/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2207);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(146);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(1510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(571);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(1506);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(1521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(1507);
/* unused harmony reexport IndexRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(1508);
/* unused harmony reexport IndexRoute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(573);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(106);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(360);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(359);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(1519);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(578);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(143);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(1512);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(1513);
/* unused harmony reexport browserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(1517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(575);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 *
 * Util模块 React Native module
 * 主要提供工具方法
 *
 */
var _require = __webpack_require__(5),
    Toast = _require.Toast;

var CryptoJS = __webpack_require__(1005);
var keySize = 128;
var initKey = '@AmcFortune2019';
var fillKey = function fillKey(key) {
  var filledKey = Buffer.alloc(keySize / 8);
  var keys = Buffer.from(key);
  if (keys.length < filledKey.length) {
    filledKey.map(function (b, i) {
      return filledKey[i] = keys[i];
    });
  }
  return filledKey;
};

module.exports = {
  encrypt: function encrypt(password) {
    var keyStr = 'chinaamc@app&web';
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var plaint = CryptoJS.enc.Utf8.parse(password);
    var encryptedData = CryptoJS.AES.encrypt(plaint, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return window.encodeURIComponent(encryptedData.toString());
  },
  aesEncrypt: function aesEncrypt(data) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initKey;

    var key2 = CryptoJS.enc.Utf8.parse(fillKey(key));
    var cipher = CryptoJS.AES.encrypt(data, key2, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
      iv: ''
    });
    // 将加密后的数据转换成 Base64
    var base64Cipher = cipher.ciphertext.toString(CryptoJS.enc.Base64);
    return base64Cipher;
  },
  hdUrl: 'http://chinaamc-charlie.izhida.cn/?content=',
  return_enterType: '华夏财富H5',
  //获取url中的参数值
  // getQueryString:function(name) {
  //   let home_url = sessionStorage.getItem('home_url');
  //   const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  //   const r =  home_url.substring((window.location.hash.search(/\?/)) + 1).match(reg);
  //   console.log(r);
  //   if (r != null) {
  //       return decodeURIComponent(r[2]);
  //   }
  // },
  getQueryString: function getQueryString(name) {
    var home_url = sessionStorage.getItem('home_url');
    console.log(home_url, "home_urlhome_url");
    var result = home_url.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    if (result == null || result.length < 1) {
      return "";
    }
    return result[1];
  },

  return_Clinet_Type: function return_Clinet_Type() {
    //第三方客户字典
    var venderType = {
      'v001': 'hxcfH5ZX', //中信联盟 优享家
      'v002': 'hxcfH5V002' //中信证券
    };
    var ua = navigator.userAgent.toLowerCase();
    var home_url = sessionStorage.getItem('home_url');
    if (ua.indexOf("amcfmapp") > -1) {
      return 'hxcfH5GJ';
    } else if (ua.includes("miniprogram")) {
      return 'hxcfMinpH5';
    } else if (ua.match(/MicroMessenger/i) == "micromessenger") {
      if (home_url && home_url.indexOf('venderType') > -1) {
        var id = this.getQueryString('venderType');
        return venderType[id];
      } else {
        return 'hxcfH5WX';
      }
    } else if (home_url && home_url.indexOf('venderType') > -1) {
      var _id = this.getQueryString('venderType');
      return venderType[_id];
    } else {
      return 'hxcfH5';
    }
  },
  ToastTime: 2,
  parsePrice: function parsePrice(s, isFloat) {
    if (s != undefined && s != "-" && s != "" && s != null && s != '--') {
      s = Math.floor(s * 100) / 100;
      var n = 2;
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
      var l = s.split(".")[0].split("").reverse(),
          r = s.split(".")[1];
      var t = "";
      if (s >= 0) {
        //正负
        for (var i = 0; i < l.length; i++) {
          t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
        }
        if (isFloat != undefined) {
          return t.split("").reverse().join("");
        } else {
          return t.split("").reverse().join("") + "." + r;
        }
      } else {
        for (var _i = 0; _i < l.length - 1; _i++) {
          t += l[_i] + ((_i + 1) % 3 == 0 && _i + 1 != l.length - 1 ? "," : "");
        }
        if (isFloat != undefined) {
          return "-" + t.split("").reverse().join("");
        } else {
          return "-" + t.split("").reverse().join("") + "." + r;
        }
      };
    } else {
      return "0.00";
    }
  },
  //千分位转number
  priceParse: function priceParse(num) {
    if (num.indexOf(",") != -1) {
      num = num.split(",").join("");
    }
    return num;
  },
  tokenTime: 1000 * 3600 * 1.5,
  regular1: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
  errorTxt: '网络异常,请检查您的网络',
  imgUrl: window.urlObj.imgUrl, //测试CMS图片地址
  url: window.urlObj.url,

  backgroundColor: 'rgba(242,245,247,1)',
  /**
   * 基于fetch的get方法
   * @method post
   * @param {string} url
   * @param {function} callback 请求成功回调
   */
  get: function get(url, params, successCallback, failCallback) {
    var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;

    if (params) {
      var paramsArray = [];
      //拼接参数
      Object.keys(params).forEach(function (key) {
        return paramsArray.push(key + '=' + params[key]);
      });
      if (url.search(/\?/) === -1) {
        url += '?' + paramsArray.join('&');
      } else {
        url += '&' + paramsArray.join('&');
      }
    }
    console.log(url, "********");
    fetch(url, {
      method: 'GET', timeout: timeout, mode: 'cors', cache: 'no-cache'
    }).then(function (response) {
      return response.text();
    }).then(function (responseText) {
      successCallback(JSON.parse(responseText));
    }).catch(function (err) {
      failCallback(err);
    });
  },
  post: function post(url, params, successCallback, failCallback) {
    var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;

    var paramsForm = new FormData();
    // for (let i in params) {
    //   console.log(params[i])
    //   paramsForm.append(i + '', params[i]);
    // }
    // paramsForm=JSON.stringify(paramsForm)
    var data = '';
    if (params) {
      var paramsArray = [];
      //拼接参数
      Object.keys(params).forEach(function (key) {
        return paramsArray.push(key + '=' + params[key]);
      });
      if (url.search(/\?/) === -1) {
        data += '' + paramsArray.join('&');
      } else {
        data += '' + paramsArray.join('&');
      }
    }
    console.log(data, paramsForm, url);
    fetch(url, {
      method: "POST",
      mode: 'cors',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (responseText) {
      successCallback(responseText);
    }).catch(function (err) {
      failCallback(err);
    });
  },
  postNew: function postNew(url, params, successCallback, failCallback) {
    var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;

    console.log(url);
    console.log(JSON.stringify(params));
    fetch(url, {
      method: "POST",
      mode: 'cors',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    }).then(function (response) {
      return response.json();
    }).then(function (responseText) {
      successCallback(responseText);
    }).catch(function (err) {
      failCallback(err);
    });
  },
  newToFixed: function newToFixed(num, count) {
    if (count == undefined) {
      count = 2;
    }
    if (num == undefined || num == "-" || num == "" || num == "--" || num == null || num == "null") {
      return '0.00';
    } else {
      var newNum = new Number(num);
      return newNum.toFixed(count);
    }
  },
  newToFixedOne: function newToFixedOne(num, count) {
    if (count == undefined) {
      count = 2;
    }
    if (num == undefined || num == "-" || num == "" || num == "--" || num == null || num == "null") {
      return '0.0';
    } else {
      var newNum = new Number(num);
      return newNum.toFixed(count);
    }
  },
  fomatFloat: function fomatFloat(num, count) {
    if (count == undefined) {
      count = 2;
    }
    if (num == undefined || num == "-" || num === "" || num == "--" || num == null || num == "null") {
      return "--";
    } else {
      var newNum = new Number(num);
      return newNum.toFixed(count);
    }
  },
  fomatFloat100: function fomatFloat100(num, count) {
    if (count == undefined) {
      count = 2;
    }
    if (num != undefined && num != "-" && num != "" && num != "--" && num != null && num != "null") {
      var newNum = new Number(num);
      if (num - 0 > 100) {
        return newNum.toFixed(0);
      } else {
        return newNum.toFixed(count);
      }
    } else {
      return "--";
    }
  },
  formatStr: function formatStr(num) {
    if (num == undefined || num == "-" || num == "" || num == "--" || num == null || num == "null" || num == '无法计算') {
      if (num == '无法计算') {
        return "0.00";
      }
      return "--";
    } else {
      return String(num);
    }
  },
  dateMD: function dateMD(date) {
    if (date == '' || date == null || date == '--' || date == '--' || date == undefined) {
      return '--';
    }
    if (isNaN(date)) {
      var k = /^(\d{4})\-([\d]+)\-([\d]+)$/;
      var reg = date.match(/^(\d{4})\-([\d]+)\-([\d]+)$/);
      if (!k.test(date) || reg[2] > 12 || reg[3] > 31) {} else {
        return date;
      }
    }
    var day, month;
    var currDate = new Date(date);
    month = currDate.getMonth() + 1;
    day = currDate.getDate();
    return month + '月' + day + '日';
  },
  TimeFormat: function TimeFormat(startDate, afterDate) {
    //格式化当前日期
    var nowYear = new Date().getFullYear();
    var nowMonth = parseInt(new Date().getMonth()) + 1;
    var nowDay = new Date().getDate();
    if (nowMonth < 10) {
      nowMonth = "0" + nowMonth;
    }
    if (nowDay < 10) {
      nowDay = "0" + nowDay;
    }
    var nowDate = String(nowYear) + String(nowMonth) + String(nowDay);

    //格式化开始日期
    if (startDate == null || startDate == undefined || startDate == "") {
      startDate = "19000101";
    } else {
      if (startDate instanceof Date) {
        var year = startDate.getFullYear();
        var month = parseInt(startDate.getMonth()) + 1;
        var day = startDate.getDate();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        startDate = String(year) + String(month) + String(day);
      } else {
        if (startDate.indexOf("-") != -1) {
          startDate = startDate.split("-")[0] + startDate.split("-")[1] + startDate.split("-")[2];
        } else if (startDate.indexOf("/") != -1) {
          startDate = startDate.split("/")[0] + startDate.split("/")[1] + startDate.split("/")[2];
        }
      }
    }

    //格式化结束日期
    if (afterDate == null || afterDate == undefined || afterDate == "") {
      afterDate = "20991231";
    } else {
      if (afterDate instanceof Date) {
        var _year = afterDate.getFullYear();
        var _month = parseInt(afterDate.getMonth()) + 1;
        var _day = afterDate.getDate();
        if (_month < 10) {
          _month = "0" + _month;
        }
        if (_day < 10) {
          _day = "0" + _day;
        }
        afterDate = String(_year) + String(_month) + String(_day);
      } else {
        if (afterDate.indexOf("-") != -1) {
          afterDate = afterDate.split("-")[0] + afterDate.split("-")[1] + afterDate.split("-")[2];
        } else if (afterDate.indexOf("/") != -1) {
          afterDate = afterDate.split("/")[0] + afterDate.split("/")[1] + afterDate.split("/")[2];
        }
      }
    }

    //返回状态
    if (nowDate < startDate) {
      return 0;
    }
    if (nowDate > afterDate) {
      return 2;
    }
    if (nowDate >= startDate && nowDate <= afterDate) {
      return 1;
    }
  },
  deepType: function deepType(obj) {
    var toString = Object.prototype.toString;
    var map = {
      '[object Boolean]': 'boolean',
      '[object Number]': 'number',
      '[object String]': 'string',
      '[object Function]': 'function',
      '[object Array]': 'array',
      '[object Date]': 'date',
      '[object RegExp]': 'regExp',
      '[object Undefined]': 'undefined',
      '[object Null]': 'null',
      '[object Object]': 'object'
    };
    return map[toString.call(obj)];
  },
  deepClone: function deepClone(data) {
    var t = this.deepType(data),
        o,
        i,
        ni;

    if (t === 'array') {
      o = [];
    } else if (t === 'object') {
      o = {};
    } else {
      return data;
    }

    if (t === 'array') {
      for (i = 0, ni = data.length; i < ni; i++) {
        o.push(this.deepClone(data[i]));
      }
      return o;
    } else if (t === 'object') {
      for (i in data) {
        o[i] = this.deepClone(data[i]);
      }
      return o;
    }
  },
  returnDate: function returnDate(date, type) {
    if (date == '' || date == null || date == '--' || date == '--' || date == undefined) {
      return '--';
    }

    if (isNaN(date)) {
      var k = /^(\d{4})\-([\d]+)\-([\d]+)$/;
      var reg = date.match(/^(\d{4})\-([\d]+)\-([\d]+)$/);
      if (!k.test(date) || reg[2] > 12 || reg[3] > 31) {} else {
        return date;
      }
    }
    var num = Number(date);
    // let a=new Date(num);
    // let b=new Date();
    // if ( a.getTimezoneOffset()!=b.getTimezoneOffset()) {
    //   num=Number(data+216000000)
    //   alert('夏令时')
    // } 
    if (type) {
      var resultDate, year, month, date, hms, resultDateTemp;
      var currDate = new Date(num);
      year = currDate.getFullYear();
      month = currDate.getMonth() + 1;
      date = currDate.getDate();
      if (currDate.getMinutes() < 10) {
        hms = currDate.getHours() + ':0' + currDate.getMinutes();
      } else {
        hms = currDate.getHours() + ':' + currDate.getMinutes();
      }
      month = month < 10 ? '0' + month : month;
      date = date < 10 ? '0' + date : date;
      resultDate = year + '-' + month + '-' + date + ' ' + hms;
      resultDateTemp = year + '-' + month;
      if (type == "M") {
        return resultDateTemp;
      } else {
        return resultDate;
      }
    } else {
      var resultDate, year, month, date, hms;
      var currDate = new Date(num);
      year = currDate.getFullYear();
      month = currDate.getMonth() + 1;
      date = currDate.getDate();
      month = month < 10 ? '0' + month : month;
      date = date < 10 ? '0' + date : date;
      resultDate = year + '-' + month + '-' + date;
      // alert(currDate) 
      return resultDate;
    }
  },
  cutReturn: function cutReturn(title, width, fontSize) {
    var x = Math.floor(width / fontSize);
    if (title.length >= x) {
      return title.substr(0, x) + '...';
    }
    return title;
  },

  /*金钱数目打千分位符*/
  thousandCount: function thousandCount(num) {
    num = String(num);
    if (Number(num) == 0 || isNaN(Number(num))) {
      num = '0.00';
      return num;
    }
    console.log(Number(num));
    num = this.formatStr(num);
    num = num.replace(/,/g, '');
    if (Number(num)) {
      num = Number(num).toFixed(2);
    }
    var parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  thousandCount4: function thousandCount4(num) {
    num = String(num);
    if (Number(num) == 0 || isNaN(Number(num))) {
      num = '0.0000';
      return num;
    }
    console.log(Number(num));
    num = this.formatStr(num);
    num = num.replace(/,/g, '');
    if (Number(num)) {
      num = Number(num).toFixed(4);
    }
    var parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },

  isIDCard: /^([1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3})|([1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x))$/,
  isMobileNo: /^1[0123456789]\d{9}$/,
  passwordPattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,8}$/,
  superFundCodeArr: ["SF1001", "SF1002", "SF1003", "SF1004", "SF1005", "SF1006", "SF1007", "SF1008", "SF1009", "SF1010", "SF1011", "SF1017", "SF1018", "SF1019", "SF1020", "SF1021", "SF1013", "SF1012", "SF1015", "SF1016", "SF1014", "SF1036", "SF1038", "SF1039", "SF1060", "SF1067", "SF1022"],
  superFundCodeArrByYl: ["SF1006", "SF1007", "SF1008", "SF1019", "SF1020", "SF1021", "SF1013"],
  superFundCodeArrByJy: ["SF1009", "SF1010", "SF1011", "SF1017", "SF1018"],
  superFundCodeArrByZl: ["SF1001", "SF1002", "SF1003", "SF1004", "SF1005", "SF1012", "SF1015", "SF1016", "SF1014", "SF1036", "SF1038", "SF1039", "SF1060", "SF1067", "SF1022"],
  superFundCodeArrByTarget: ["SF10A1", "SF10A2", "SF10A3", "SF10A4", "SF10A5", "SF10A6", "SF10A7", "SF10A8", "SF10A9", "SF10B1", "SF10B2", "SF10B3", "SF10B4", "SF10B5", "SF10B6", "SF10B7", "SF10B8", "SF10B9", "SF10C1", "SF10C2", "SF10C3", "SF10C4", "SF10C5", "SF10C6", "SF10C7", "SF10C8", "SF10C9", "SF10D1", "SF10D2", "SF10D3", "SF10D4", "SF10D5", "SF10D6", "SF10D7", "SF10D8", "SF10D9", "SF10E1", "SF10E2", "SF10E3", "SF10E4", "SF10E5", "SF10E6", "SF10E7", "SF10E8", "SF10E9"],
  superFundCodeArrByTargetName: ["小常乐目标盈008期", "小常乐目标盈009期", "小常乐目标盈010期", "小常乐目标盈011期", "小常乐目标盈012期", "小常乐目标盈013期", "小常乐目标盈014期", "小常乐目标盈015期", "小常乐目标盈016期", "小常乐目标盈017期", "小常乐目标盈018期", "小常乐目标盈019期", "小常乐目标盈020期", "小常乐目标盈021期", "小常乐目标盈022期", "小常乐目标盈023期", "小常乐目标盈024期", "小常乐目标盈025期", "小常乐目标盈026期", "小常乐目标盈027期", "小常乐目标盈028期", "小常乐目标盈029期", "小常乐目标盈030期", "小常乐目标盈031期", "小常乐目标盈030期", "小常乐目标盈031期", "小常乐目标盈", "小常乐目标盈032期", "小常乐目标盈033期", "小常乐目标盈034期", "小常乐目标盈035期", "小常乐目标盈036期", "小常乐目标盈037期", "小常乐目标盈038期", "小常乐目标盈039期", "小常乐目标盈040期", "小常乐目标盈041期", "小常乐目标盈042期", "小常乐目标盈", "小常乐目标盈043期", "小常乐目标盈044期", "小常乐目标盈045期", "小常乐目标盈046期", "小常乐目标盈047期", "小常乐目标盈048期"],
  superFundCodeArrByYlName: ["老60后智享财富组合", "老70后智赢人生组合", "老80后智领未来组合", "60后智享财富组合", "70后智赢人生组合", "80后智领未来组合", "90后智享自由组合"],
  superFundCodeArrByJyName: ["雏鹰初中生组合", "菁英高中生组合", "常青藤大学组合", "国内培优教育金组合", "常青藤教育金组合"],
  superFundCodeArrByZlName: ["", "安逸理财组合", "均衡稳健组合", "", "锐意进取组合", "货币优享组合", "固收增强组合", "权益优选组合", "指数轮动组合", "工资宝绝对收益组合", "7分小进取组合", "指数增强组合", "安心宝组合", "价值精选组合", "货币增强组合"],
  superFundCodeArrByZX: ["SF1012", "SF1013", "SF1014", "SF1015", "SF1016", "SF1017", "SF1018", "SF1019", "SF1020", "SF1021"],
  superFundNameArr: ["", "安逸理财组合", "均衡稳健组合", "", "锐意进取组合", "老60后智享财富组合", "老70后智赢人生组合", "老80后智领未来组合", "雏鹰初中生组合", "菁英高中生组合", "常青藤大学组合", "国内培优教育金组合", "常青藤教育金组合", "60后智享财富组合", "70后智赢人生组合", "80后智领未来组合", "90后智享自由组合", "货币优享组合", "固收增强组合", "权益优选组合", "指数轮动组合", "工资宝绝对收益组合", "7分小进取组合", "指数增强组合", "安心宝组合", "价值精选组合", "货币增强组合"],
  superFundTextArr: function superFundTextArr(code, component) {
    //文案暂定
    var text = "";
    if (component == "Transfer" || component == "TransferF") {
      switch (code) {
        case "SF1012":
          text = ["货币优享组合", "wjPie.png"];
          break;
        case "SF1013":
          text = ["90后", "80Pie.png"];
          break;
        case "SF1014":
          text = ["指数轮动", "wjPie.png"];
          break;
        case "SF1015":
          text = ["固收增强组合", "wjPie.png"];
          break;
        case "SF1016":
          text = ["权益优选", "wjPie.png"];
          break;
        case "SF1017":
          text = ["国内培优", "dxJyPie.png"];
          break;
        case "SF1018":
          text = ["常青藤", "dxJyPie.png"];
          break;
        case "SF1019":
          text = ["60后", "60Pie.png"];
          break;
        case "SF1020":
          text = ["70后", "70Pie.png"];
          break;
        case "SF1021":
          text = ["80后", "80Pie.png"];
          break;
        default:
          text = ["", "wjPie.png"];
      }
    }
    return text;
  },

  // toPercent:(value)=>{
  //   if(value===0) return '0.00%'
  //   if(!value) return '--'
  //   const _value=value
  //   console.log('5555555',value)
  //   const percentageArr=Math.abs(value).toFixed(4).toString().split('.')
  //   console.log('666666',percentageArr)
  //   percentageArr[0]+=percentageArr[1].slice(0,2);
  //   percentageArr[0]=parseInt(percentageArr[0])
  //   percentageArr[1]=percentageArr[1].slice(2)
  //   if(_value>0) return  `${percentageArr.join('.')}%`
  //   return `-${percentageArr.join('.')}%`
  // },

  toPercent: function toPercent(val) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    console.log('---------------', val);
    if (typeof val === "number" || typeof val === "string" && parseFloat(val) == val) {
      if (val - 0 === 0) return (val - 0).toFixed(count) + "%";
      var _value = val;
      var valueArr = Math.abs(val).toString().split(".");
      console.log('---------------', val, valueArr);
      var resultArr = null;
      if (valueArr[1] && valueArr[1].length > count + 2) {
        valueArr[1] = valueArr[1].slice(0, count + 2);
        resultArr = valueArr;
      } else resultArr = Math.abs(val).toFixed(count + 2).toString().split(".");
      console.log('---------------', val, resultArr);
      console.log('---------------', [parseInt(resultArr[0] + resultArr[1].slice(0, 2)), resultArr[1].slice(2)].join('.') + '%');
      return (_value < 0 ? '-' : '') + [parseInt(resultArr[0] + resultArr[1].slice(0, 2)), resultArr[1].slice(2)].join('.') + '%';
    }
    return "--";
  },
  processingDecimal: function processingDecimal(val) {
    var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var hasRight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (typeof val === "number" || typeof val === "string" && parseFloat(val) == val) {
      if (val - 0 === 0) return (hasRight ? "+" : "") + (val - 0).toFixed(count);
      var dot = val.toString().split(".");
      var result = void 0;
      if (dot[1] && dot[1].length > count) {
        dot[1] = dot[1].slice(0, count);
        result = dot.join(".");
      }
      result = (val - 0).toFixed(count);
      return (hasRight && val >= 0 ? "+" : "") + result;
    }
    return "--";
  },
  pieEchartsColorMap: new Map([['股票型', '#F8515C'], //股票型
  ['债券型', '#796EE0'], //债券型
  ['货币型', '#5BA3F6'], //货币型
  ['混合型', '#FF9653'], //混合型
  ['QDII基金', '#F8515C']]),
  pieEchartsFundListColorMap: new Map([['股票型', 'linear-gradient(270deg, rgba(255, 227, 227, 0) 0%, #FFE3E3 100%)'], ['债券型', 'linear-gradient(270deg, rgba(227, 225, 255, 0) 0%, #E3E0FF 100%)'], ['货币型', 'linear-gradient(270deg, rgba(224, 231, 255, 0) 0%, #E0E7FF 100%)'], ['混合型', 'linear-gradient(270deg, rgba(255, 226, 208, 0) 0%, #FFE2D0 100%)'], ['QDII基金', 'linear-gradient(270deg, rgba(255, 227, 227, 0) 0%, #FFE3E3 100%)']]),
  pieEchartsFundListBgColorMap: new Map([['股票型', '#FFFBFB'], ['债券型', '#FAFAFF'], ['货币型', '#FAFBFF'], ['混合型', '#FFFBF8'], ['QDII基金', '#FFFBFB']]),
  returnEmpty: function returnEmpty(num, val) {
    if (num === "" || num === null || num === undefined) {
      if (val === "" || val === null || val === undefined) {
        return "--";
      } else {
        if (val == "%") {
          return "--%";
        } else if (val == "fixed") {
          return "--";
        } else {
          return "--" + val;
        }
      }
    } else {
      if (val === "" || val === null || val === undefined) {
        return num;
      } else {
        if (val == "%") {
          return (num * 100).toFixed(2) + val;
        } else if (val == "fixed") {
          return Number(num).toFixed(2);
        } else {
          return num + val;
        }
      }
    }
  },
  returnEmptyAlone: function returnEmptyAlone(num) {
    if (num === null || num === "" || num === undefined) {
      return false;
    } else {
      return true;
    }
  },
  keepfomatFloat: function keepfomatFloat(num, count) {
    if (count == undefined) {
      count = 2;
    }
    if (num != undefined && num != "-" && num !== "" && num != "--" && num != null && num != "null") {
      var newNum = new Number(num);
      if (newNum > 0) {
        return "+" + newNum.toFixed(count) + "%";
      } else {
        return newNum.toFixed(count) + "%";
      }
    } else {
      return "--";
    }
  },
  Keepwodecimalplaces: function Keepwodecimalplaces(val) {
    if (val != null) {
      var A = val.toString();
      var s = A.slice(0, 1) === "-" ? Number(A.slice(1)) : Number(A);
      if (s == '0') {
        return '0.00';
      } else if (s != undefined && s != "-" && s != "" && s != null && s != '--') {
        var a = Math.floor(module.exports.percentFormatFun(s, 100));
        s = module.exports.percentFormatFunSec(a, 100);
        var n = 2;
        s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
        var k = A.slice(0, 1) === "-" ? "-" + s : s;
        return k;
      } else {
        return "0.00";
      }
    }
  },
  //保留四位小数
  Retainfourdecimalplaces: function Retainfourdecimalplaces(val) {
    if (val != null) {
      var A = val.toString();
      var s = A.slice(0, 1) === "-" ? Number(A.slice(1)) : Number(A);
      if (s == '0') {
        return '0.0000';
      } else if (s != undefined && s != "-" && s != "" && s != null && s != '--') {
        var a = Math.floor(module.exports.percentFormatFun(s, 10000));
        s = module.exports.percentFormatFunSec(a, 10000);
        var n = 4;
        s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
        var k = A.slice(0, 1) === "-" ? "-" + s : s;
        return k;
      } else {
        return "0.0000";
      }
    }
  },
  /*交易记录详情金额转换打千分位符保留两位小数*/
  TRparsePrice: function TRparsePrice(s, isFloat) {
    if (s != undefined && s != "-" && s != "" && s != null && s != '--') {
      var a = Math.floor(module.exports.percentFormatFun(s, 100));
      s = module.exports.percentFormatFunSec(a, 100);
      var n = 2;
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
      var l = s.split(".")[0].split("").reverse(),
          r = s.split(".")[1];
      var t = "";
      if (s >= 0) {
        //正负
        for (var i = 0; i < l.length; i++) {
          t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
        }
        if (isFloat != undefined) {
          return t.split("").reverse().join("");
        } else {
          return t.split("").reverse().join("") + "." + r;
        }
      } else {
        for (var _i2 = 0; _i2 < l.length - 1; _i2++) {
          t += l[_i2] + ((_i2 + 1) % 3 == 0 && _i2 + 1 != l.length - 1 ? "," : "");
        }
        if (isFloat != undefined) {
          return "-" + t.split("").reverse().join("");
        } else {
          return "-" + t.split("").reverse().join("") + "." + r;
        }
      };
    } else {
      return "0.00";
    }
  },
  //加百分比
  fomatFloatpercentage: function fomatFloatpercentage(num, count) {
    if (count == undefined) {
      count = 2;
    }
    if (num != undefined && num != "-" && num !== "" && num != "--" && num != null && num != "null") {
      var newNum = new Number(num);
      return newNum.toFixed(count) + "%";
    } else {
      return "--";
    }
  },
  //乘
  percentFormatFun: function percentFormatFun(val, per) {
    if (module.exports.returnEmptyAlone(val) === false) {
      return '--';
    }
    if (val === 0 || val === "0" || val === "0.0" || val === "0.00") {
      return "0";
    }
    var _flag = true;
    if (val < 0) {
      _flag = false;
      val = val * -1;
    }
    //原数
    var _val = val.toString();
    //10的n次幂
    var _per = per.toString();
    //几个0
    var perZero = _per.length - 1;
    //小数时
    if (_val.indexOf(".") != -1) {
      //0的位数大于等于小数点后位数
      if (perZero >= _val.split(".")[1].length) {
        //多出的位数
        var _the = perZero - _val.split(".")[1].length;
        //大于则去掉小数点后面直接追加0,等于则去掉小数点即可
        var _sec = _the > 0 ? _per.substr(1, _the) : "";
        var lastVal = _val.split(".")[0] + _val.split(".")[1] + _sec;
        //去掉前面的0
        for (var i = 0; i < lastVal.length; i++) {
          if (lastVal[i] != 0) {
            if (_flag === true) {
              return lastVal.substr(i, lastVal.length - i);
            } else {
              return "-" + lastVal.substr(i, lastVal.length - i);
            }
          }
        }
      } else {
        //小数点前的位数加上所有0就是最后小数点前的位数
        var _theSec = _val.split(".")[0].length - 0 + perZero;
        var newVal = _val.split(".")[0] + _val.split(".")[1];
        //获得小数点前最终的值
        var lastValSec = newVal.substr(0, _theSec);
        //去掉前面的0
        for (var _i3 = 0; _i3 < lastValSec.length; _i3++) {
          if (lastValSec[_i3] > 0) {
            if (_flag === true) {
              return lastValSec.substr(_i3, lastValSec.length - _i3) + "." + newVal.substr(_theSec, newVal.length - _theSec);
            } else {
              return "-" + lastValSec.substr(_i3, lastValSec.length - _i3) + "." + newVal.substr(_theSec, newVal.length - _theSec);
            }
          } else {
            if (_i3 == lastValSec.length - 1) {
              if (_flag === true) {
                return "0" + "." + newVal.substr(_theSec, newVal.length - _theSec);
              } else {
                return "-0" + "." + newVal.substr(_theSec, newVal.length - _theSec);
              }
            }
          }
        }
      }
    } else {
      //非小数 直接 追加0
      if (_flag === true) {
        return _val + _per.substr(1, perZero);
      } else {
        return "-" + _val + _per.substr(1, perZero);
      }
    }
  },
  //除
  percentFormatFunSec: function percentFormatFunSec(val, per) {
    if (module.exports.returnEmptyAlone(val) === false) {
      return '--';
    }
    if (val === 0 || val === "0" || val === "0.0" || val === "0.00") {
      return "0";
    }
    var _flag = true;
    if (val < 0) {
      _flag = false;
      val = val * -1;
    }
    //原数
    var _val = val.toString();
    //10的n次幂
    var _per = per.toString();
    //几个0
    var perZero = _per.length - 1;
    //小数时
    if (_val.indexOf(".") != -1) {
      //0的位数小于等于小数点前位数
      if (perZero <= _val.split(".")[0].length) {
        //多出的位数
        var _the = _val.split(".")[0].length - perZero;
        var firVal = _the > 0 ? _val.split(".")[0].substr(0, _the) + "." + _val.split(".")[0].substr(_the, _val.split(".")[0].length - _the) + _val.split(".")[1] : "0." + _val.split(".")[0] + _val.split(".")[1];
        if (_flag === true) {
          return firVal;
        } else {
          return "-" + firVal;
        }
      } else {
        var _the2 = perZero - _val.split(".")[0].length;
        var _firVal = "0." + _per.substr(1, _the2) + _val.split(".")[0] + _val.split(".")[1];
        if (_flag === true) {
          return _firVal;
        } else {
          return "-" + _firVal;
        }
      }
    } else {
      //非小数 
      if (perZero <= _val.length) {
        //多出的位数
        var _the3 = _val.length - perZero;
        var _firVal2 = _the3 > 0 ? _val.substr(0, _the3) + "." + _val.substr(_the3, _val.length - _the3) : "0." + _val.split(".")[0];
        if (_flag === true) {
          return _firVal2;
        } else {
          return "-" + _firVal2;
        }
      } else {
        var _the4 = perZero - _val.length;
        var _firVal3 = "0." + _per.substr(1, _the4) + _val;
        if (_flag === true) {
          return _firVal3;
        } else {
          return "-" + _firVal3;
        }
      }
    }
  },
  //管家在卖产品
  kycFundListByGJ: ["SF1022", "SF1015", "SF1016", "SF1014", "SF1017", "SF1018", "SF1019", "SF1020", "SF1021", "SF1013"],
  // 身份证上传压缩
  compressPicture: function compressPicture(files) {
    return new Promise(function (resolve, reject) {
      if (!files[0]) return false;
      var imgSIze = files[0].file.size / 1024 / 1024;
      if (imgSIze > 5) {
        return Toast.info('请上传5M以内的照片', module.exports.ToastTime);
      }
      console.log(imgSIze);
      if (imgSIze > 0.15) {
        // 压缩
        try {
          var image = new Image();
          var fileReader = new FileReader();
          fileReader.readAsDataURL(files[0].file);
          fileReader.onload = function (e) {
            image.src = e.target.result;
            // 压缩
            image.onload = function () {
              var square = 500,
                  canvas = document.createElement('canvas'),
                  context = canvas.getContext('2d');

              context.clearRect(0, 0, square, square);
              if (this.width > square || this.height > 500) {
                if (this.width >= this.height) {
                  canvas.width = square;
                  canvas.height = square * (this.height / this.width);
                  context.drawImage(this, 0, 0, square, square * (this.height / this.width));
                } else {
                  canvas.height = square;
                  canvas.width = square * (this.width / this.height);
                  context.drawImage(this, 0, 0, square * (this.width / this.height), square);
                }
              } else {
                canvas.height = this.width;
                canvas.width = this.height;
                context.drawImage(this, 0, 0, this.width, this.height);
              }

              var imgBase64 = canvas.toDataURL(files[0].file.type);

              canvas.toBlob(function (blob) {
                blob.name = files[0].file.name;
                console.log(blob, '11111111');
                resolve({ file: blob, url: imgBase64 });
              },
              // files[0].file.type
              'image/jpeg');
            };
          };
        } catch (e) {
          reject('请正确上传本人有效证件');
          // Toast.fail('请正确上传本人有效证件', Util.ToastTime);
        }
      } else {
        // 预览
        var _fileReader = new FileReader();
        _fileReader.readAsDataURL(files[0].file);
        _fileReader.onload = function (e) {};
        // 存储文件对象
        resolve(files[0]);
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(963).Buffer))

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var NavigatorMain = function (_Component) {
  _inherits(NavigatorMain, _Component);

  function NavigatorMain() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NavigatorMain);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavigatorMain.__proto__ || Object.getPrototypeOf(NavigatorMain)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      flag: navigator.userAgent.toLowerCase()
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NavigatorMain, [{
    key: "render",
    value: function render() {
      var flag = this.state.flag;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { paddingBottom: flag.indexOf("miniprogram") != -1 ? this.props.children.props.isPaddingBottom == 0 ? this.props.children.props.isPaddingBottom : 44 : 0 } },
        flag.indexOf("miniprogram") != -1 ? this.props.children : flag.indexOf("amcfmapp") != -1 || flag.indexOf("hxcfH5WX") != -1 || flag.match(/MicroMessenger/i) == "micromessenger" ? null : this.props.children
      );
    }
  }]);

  return NavigatorMain;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NavigatorMain);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(786);

Object.defineProperty(exports, 'Accordion', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index)['default'];
  }
});

var _index2 = __webpack_require__(787);

Object.defineProperty(exports, 'ActionSheet', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index2)['default'];
  }
});

var _index3 = __webpack_require__(788);

Object.defineProperty(exports, 'ActivityIndicator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index3)['default'];
  }
});

var _index4 = __webpack_require__(435);

Object.defineProperty(exports, 'Badge', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index4)['default'];
  }
});

var _index5 = __webpack_require__(199);

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index5)['default'];
  }
});

var _index6 = __webpack_require__(792);

Object.defineProperty(exports, 'Card', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index6)['default'];
  }
});

var _index7 = __webpack_require__(436);

Object.defineProperty(exports, 'Carousel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index7)['default'];
  }
});

var _index8 = __webpack_require__(437);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index8)['default'];
  }
});

var _index9 = __webpack_require__(796);

Object.defineProperty(exports, 'DatePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index9)['default'];
  }
});

var _index10 = __webpack_require__(799);

Object.defineProperty(exports, 'Drawer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index10)['default'];
  }
});

var _index11 = __webpack_require__(166);

Object.defineProperty(exports, 'Flex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index11)['default'];
  }
});

var _index12 = __webpack_require__(802);

Object.defineProperty(exports, 'Grid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index12)['default'];
  }
});

var _index13 = __webpack_require__(84);

Object.defineProperty(exports, 'Icon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index13)['default'];
  }
});

var _index14 = __webpack_require__(804);

Object.defineProperty(exports, 'ImagePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index14)['default'];
  }
});

var _index15 = __webpack_require__(808);

Object.defineProperty(exports, 'InputItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index15)['default'];
  }
});

var _index16 = __webpack_require__(130);

Object.defineProperty(exports, 'List', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index16)['default'];
  }
});

var _index17 = __webpack_require__(811);

Object.defineProperty(exports, 'ListView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index17)['default'];
  }
});

var _index18 = __webpack_require__(815);

Object.defineProperty(exports, 'Menu', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index18)['default'];
  }
});

var _index19 = __webpack_require__(818);

Object.defineProperty(exports, 'Modal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index19)['default'];
  }
});

var _index20 = __webpack_require__(821);

Object.defineProperty(exports, 'NavBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index20)['default'];
  }
});

var _index21 = __webpack_require__(823);

Object.defineProperty(exports, 'NoticeBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index21)['default'];
  }
});

var _index22 = __webpack_require__(824);

Object.defineProperty(exports, 'Pagination', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index22)['default'];
  }
});

var _index23 = __webpack_require__(828);

Object.defineProperty(exports, 'Picker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index23)['default'];
  }
});

var _index24 = __webpack_require__(826);

Object.defineProperty(exports, 'PickerView', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index24)['default'];
  }
});

var _index25 = __webpack_require__(831);

Object.defineProperty(exports, 'Popover', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index25)['default'];
  }
});

var _index26 = __webpack_require__(832);

Object.defineProperty(exports, 'Popup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index26)['default'];
  }
});

var _index27 = __webpack_require__(833);

Object.defineProperty(exports, 'Progress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index27)['default'];
  }
});

var _index28 = __webpack_require__(835);

Object.defineProperty(exports, 'Radio', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index28)['default'];
  }
});

var _index29 = __webpack_require__(837);

Object.defineProperty(exports, 'RefreshControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index29)['default'];
  }
});

var _index30 = __webpack_require__(838);

Object.defineProperty(exports, 'Result', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index30)['default'];
  }
});

var _index31 = __webpack_require__(840);

Object.defineProperty(exports, 'SearchBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index31)['default'];
  }
});

var _index32 = __webpack_require__(841);

Object.defineProperty(exports, 'SegmentedControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index32)['default'];
  }
});

var _index33 = __webpack_require__(842);

Object.defineProperty(exports, 'Slider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index33)['default'];
  }
});

var _index34 = __webpack_require__(836);

Object.defineProperty(exports, 'Range', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index34)['default'];
  }
});

var _index35 = __webpack_require__(795);

Object.defineProperty(exports, 'createTooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index35)['default'];
  }
});

var _index36 = __webpack_require__(843);

Object.defineProperty(exports, 'Stepper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index36)['default'];
  }
});

var _index37 = __webpack_require__(844);

Object.defineProperty(exports, 'Steps', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index37)['default'];
  }
});

var _index38 = __webpack_require__(845);

Object.defineProperty(exports, 'SwipeAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index38)['default'];
  }
});

var _index39 = __webpack_require__(846);

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index39)['default'];
  }
});

var _index40 = __webpack_require__(848);

Object.defineProperty(exports, 'TabBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index40)['default'];
  }
});

var _index41 = __webpack_require__(849);

Object.defineProperty(exports, 'Table', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index41)['default'];
  }
});

var _index42 = __webpack_require__(850);

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index42)['default'];
  }
});

var _index43 = __webpack_require__(851);

Object.defineProperty(exports, 'Tag', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index43)['default'];
  }
});

var _index44 = __webpack_require__(852);

Object.defineProperty(exports, 'Text', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index44)['default'];
  }
});

var _index45 = __webpack_require__(853);

Object.defineProperty(exports, 'TextareaItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index45)['default'];
  }
});

var _index46 = __webpack_require__(439);

Object.defineProperty(exports, 'Toast', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index46)['default'];
  }
});

var _index47 = __webpack_require__(440);

Object.defineProperty(exports, 'View', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index47)['default'];
  }
});

var _index48 = __webpack_require__(854);

Object.defineProperty(exports, 'WhiteSpace', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index48)['default'];
  }
});

var _index49 = __webpack_require__(441);

Object.defineProperty(exports, 'WingBlank', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index49)['default'];
  }
});

var _index50 = __webpack_require__(813);

Object.defineProperty(exports, 'LocaleProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index50)['default'];
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * @module zrender/core/util
 */
// 用于处理merge时无法遍历Date等对象的问题
var BUILTIN_OBJECT = {
  '[object Function]': 1,
  '[object RegExp]': 1,
  '[object Date]': 1,
  '[object Error]': 1,
  '[object CanvasGradient]': 1,
  '[object CanvasPattern]': 1,
  // For node-canvas
  '[object Image]': 1,
  '[object Canvas]': 1
};
var TYPED_ARRAY = {
  '[object Int8Array]': 1,
  '[object Uint8Array]': 1,
  '[object Uint8ClampedArray]': 1,
  '[object Int16Array]': 1,
  '[object Uint16Array]': 1,
  '[object Int32Array]': 1,
  '[object Uint32Array]': 1,
  '[object Float32Array]': 1,
  '[object Float64Array]': 1
};
var objToString = Object.prototype.toString;
var arrayProto = Array.prototype;
var nativeForEach = arrayProto.forEach;
var nativeFilter = arrayProto.filter;
var nativeSlice = arrayProto.slice;
var nativeMap = arrayProto.map;
var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  methods[name] = fn;
}
/**
 * Those data types can be cloned:
 *     Plain object, Array, TypedArray, number, string, null, undefined.
 * Those data types will be assgined using the orginal data:
 *     BUILTIN_OBJECT
 * Instance of user defined class will be cloned to a plain object, without
 * properties in prototype.
 * Other data types is not supported (not sure what will happen).
 *
 * Caution: do not support clone Date, for performance consideration.
 * (There might be a large number of date in `series.data`).
 * So date should not be modified in and out of echarts.
 *
 * @param {*} source
 * @return {*} new
 */


function clone(source) {
  if (source == null || typeof source != 'object') {
    return source;
  }

  var result = source;
  var typeStr = objToString.call(source);

  if (typeStr === '[object Array]') {
    result = [];

    for (var i = 0, len = source.length; i < len; i++) {
      result[i] = clone(source[i]);
    }
  } else if (TYPED_ARRAY[typeStr]) {
    var Ctor = source.constructor;

    if (source.constructor.from) {
      result = Ctor.from(source);
    } else {
      result = new Ctor(source.length);

      for (var i = 0, len = source.length; i < len; i++) {
        result[i] = clone(source[i]);
      }
    }
  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
    result = {};

    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        result[key] = clone(source[key]);
      }
    }
  }

  return result;
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overwrite=false]
 */


function merge(target, source, overwrite) {
  // We should escapse that source is string
  // and enter for ... in ...
  if (!isObject(source) || !isObject(target)) {
    return overwrite ? clone(source) : target;
  }

  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      var targetProp = target[key];
      var sourceProp = source[key];

      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
        // 如果需要递归覆盖，就递归调用merge
        merge(targetProp, sourceProp, overwrite);
      } else if (overwrite || !(key in target)) {
        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
        // NOTE，在 target[key] 不存在的时候也是直接覆盖
        target[key] = clone(source[key], true);
      }
    }
  }

  return target;
}
/**
 * @param {Array} targetAndSources The first item is target, and the rests are source.
 * @param {boolean} [overwrite=false]
 * @return {*} target
 */


function mergeAll(targetAndSources, overwrite) {
  var result = targetAndSources[0];

  for (var i = 1, len = targetAndSources.length; i < len; i++) {
    result = merge(result, targetAndSources[i], overwrite);
  }

  return result;
}
/**
 * @param {*} target
 * @param {*} source
 * @memberOf module:zrender/core/util
 */


function extend(target, source) {
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }

  return target;
}
/**
 * @param {*} target
 * @param {*} source
 * @param {boolean} [overlay=false]
 * @memberOf module:zrender/core/util
 */


function defaults(target, source, overlay) {
  for (var key in source) {
    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
      target[key] = source[key];
    }
  }

  return target;
}

var createCanvas = function () {
  return methods.createCanvas();
};

methods.createCanvas = function () {
  return document.createElement('canvas');
}; // FIXME


var _ctx;

function getContext() {
  if (!_ctx) {
    // Use util.createCanvas instead of createCanvas
    // because createCanvas may be overwritten in different environment
    _ctx = createCanvas().getContext('2d');
  }

  return _ctx;
}
/**
 * 查询数组中元素的index
 * @memberOf module:zrender/core/util
 */


function indexOf(array, value) {
  if (array) {
    if (array.indexOf) {
      return array.indexOf(value);
    }

    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === value) {
        return i;
      }
    }
  }

  return -1;
}
/**
 * 构造类继承关系
 *
 * @memberOf module:zrender/core/util
 * @param {Function} clazz 源类
 * @param {Function} baseClazz 基类
 */


function inherits(clazz, baseClazz) {
  var clazzPrototype = clazz.prototype;

  function F() {}

  F.prototype = baseClazz.prototype;
  clazz.prototype = new F();

  for (var prop in clazzPrototype) {
    clazz.prototype[prop] = clazzPrototype[prop];
  }

  clazz.prototype.constructor = clazz;
  clazz.superClass = baseClazz;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Object|Function} target
 * @param {Object|Function} sorce
 * @param {boolean} overlay
 */


function mixin(target, source, overlay) {
  target = 'prototype' in target ? target.prototype : target;
  source = 'prototype' in source ? source.prototype : source;
  defaults(target, source, overlay);
}
/**
 * Consider typed array.
 * @param {Array|TypedArray} data
 */


function isArrayLike(data) {
  if (!data) {
    return;
  }

  if (typeof data == 'string') {
    return false;
  }

  return typeof data.length == 'number';
}
/**
 * 数组或对象遍历
 * @memberOf module:zrender/core/util
 * @param {Object|Array} obj
 * @param {Function} cb
 * @param {*} [context]
 */


function each(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.forEach && obj.forEach === nativeForEach) {
    obj.forEach(cb, context);
  } else if (obj.length === +obj.length) {
    for (var i = 0, len = obj.length; i < len; i++) {
      cb.call(context, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        cb.call(context, obj[key], key, obj);
      }
    }
  }
}
/**
 * 数组映射
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function map(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.map && obj.map === nativeMap) {
    return obj.map(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      result.push(cb.call(context, obj[i], i, obj));
    }

    return result;
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {Object} [memo]
 * @param {*} [context]
 * @return {Array}
 */


function reduce(obj, cb, memo, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.reduce && obj.reduce === nativeReduce) {
    return obj.reduce(cb, memo, context);
  } else {
    for (var i = 0, len = obj.length; i < len; i++) {
      memo = cb.call(context, memo, obj[i], i, obj);
    }

    return memo;
  }
}
/**
 * 数组过滤
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {Array}
 */


function filter(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  if (obj.filter && obj.filter === nativeFilter) {
    return obj.filter(cb, context);
  } else {
    var result = [];

    for (var i = 0, len = obj.length; i < len; i++) {
      if (cb.call(context, obj[i], i, obj)) {
        result.push(obj[i]);
      }
    }

    return result;
  }
}
/**
 * 数组项查找
 * @memberOf module:zrender/core/util
 * @param {Array} obj
 * @param {Function} cb
 * @param {*} [context]
 * @return {*}
 */


function find(obj, cb, context) {
  if (!(obj && cb)) {
    return;
  }

  for (var i = 0, len = obj.length; i < len; i++) {
    if (cb.call(context, obj[i], i, obj)) {
      return obj[i];
    }
  }
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @param {*} context
 * @return {Function}
 */


function bind(func, context) {
  var args = nativeSlice.call(arguments, 2);
  return function () {
    return func.apply(context, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {Function} func
 * @return {Function}
 */


function curry(func) {
  var args = nativeSlice.call(arguments, 1);
  return function () {
    return func.apply(this, args.concat(nativeSlice.call(arguments)));
  };
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isArray(value) {
  return objToString.call(value) === '[object Array]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isFunction(value) {
  return typeof value === 'function';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isString(value) {
  return objToString.call(value) === '[object String]';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return type === 'function' || !!value && type == 'object';
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isBuiltInObject(value) {
  return !!BUILTIN_OBJECT[objToString.call(value)];
}
/**
 * @memberOf module:zrender/core/util
 * @param {*} value
 * @return {boolean}
 */


function isDom(value) {
  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
/**
 * Whether is exactly NaN. Notice isNaN('a') returns true.
 * @param {*} value
 * @return {boolean}
 */


function eqNaN(value) {
  return value !== value;
}
/**
 * If value1 is not null, then return value1, otherwise judget rest of values.
 * Low performance.
 * @memberOf module:zrender/core/util
 * @return {*} Final value
 */


function retrieve(values) {
  for (var i = 0, len = arguments.length; i < len; i++) {
    if (arguments[i] != null) {
      return arguments[i];
    }
  }
}

function retrieve2(value0, value1) {
  return value0 != null ? value0 : value1;
}

function retrieve3(value0, value1, value2) {
  return value0 != null ? value0 : value1 != null ? value1 : value2;
}
/**
 * @memberOf module:zrender/core/util
 * @param {Array} arr
 * @param {number} startIndex
 * @param {number} endIndex
 * @return {Array}
 */


function slice() {
  return Function.call.apply(nativeSlice, arguments);
}
/**
 * Normalize css liked array configuration
 * e.g.
 *  3 => [3, 3, 3, 3]
 *  [4, 2] => [4, 2, 4, 2]
 *  [4, 3, 2] => [4, 3, 2, 3]
 * @param {number|Array.<number>} val
 * @return {Array.<number>}
 */


function normalizeCssArray(val) {
  if (typeof val === 'number') {
    return [val, val, val, val];
  }

  var len = val.length;

  if (len === 2) {
    // vertical | horizontal
    return [val[0], val[1], val[0], val[1]];
  } else if (len === 3) {
    // top | horizontal | bottom
    return [val[0], val[1], val[2], val[1]];
  }

  return val;
}
/**
 * @memberOf module:zrender/core/util
 * @param {boolean} condition
 * @param {string} message
 */


function assert(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var primitiveKey = '__ec_primitive__';
/**
 * Set an object as primitive to be ignored traversing children in clone or merge
 */

function setAsPrimitive(obj) {
  obj[primitiveKey] = true;
}

function isPrimitive(obj) {
  return obj[primitiveKey];
}
/**
 * @constructor
 * @param {Object} obj Only apply `ownProperty`.
 */


function HashMap(obj) {
  obj && each(obj, function (value, key) {
    this.set(key, value);
  }, this);
} // Add prefix to avoid conflict with Object.prototype.


var HASH_MAP_PREFIX = '_ec_';
var HASH_MAP_PREFIX_LENGTH = 4;
HashMap.prototype = {
  constructor: HashMap,
  // Do not provide `has` method to avoid defining what is `has`.
  // (We usually treat `null` and `undefined` as the same, different
  // from ES6 Map).
  get: function (key) {
    return this[HASH_MAP_PREFIX + key];
  },
  set: function (key, value) {
    this[HASH_MAP_PREFIX + key] = value; // Comparing with invocation chaining, `return value` is more commonly
    // used in this case: `var someVal = map.set('a', genVal());`

    return value;
  },
  // Although util.each can be performed on this hashMap directly, user
  // should not use the exposed keys, who are prefixed.
  each: function (cb, context) {
    context !== void 0 && (cb = bind(cb, context));

    for (var prefixedKey in this) {
      this.hasOwnProperty(prefixedKey) && cb(this[prefixedKey], prefixedKey.slice(HASH_MAP_PREFIX_LENGTH));
    }
  },
  // Do not use this method if performance sensitive.
  removeKey: function (key) {
    delete this[HASH_MAP_PREFIX + key];
  }
};

function createHashMap(obj) {
  return new HashMap(obj);
}

function noop() {}

exports.$override = $override;
exports.clone = clone;
exports.merge = merge;
exports.mergeAll = mergeAll;
exports.extend = extend;
exports.defaults = defaults;
exports.createCanvas = createCanvas;
exports.getContext = getContext;
exports.indexOf = indexOf;
exports.inherits = inherits;
exports.mixin = mixin;
exports.isArrayLike = isArrayLike;
exports.each = each;
exports.map = map;
exports.reduce = reduce;
exports.filter = filter;
exports.find = find;
exports.bind = bind;
exports.curry = curry;
exports.isArray = isArray;
exports.isFunction = isFunction;
exports.isString = isString;
exports.isObject = isObject;
exports.isBuiltInObject = isBuiltInObject;
exports.isDom = isDom;
exports.eqNaN = eqNaN;
exports.retrieve = retrieve;
exports.retrieve2 = retrieve2;
exports.retrieve3 = retrieve3;
exports.slice = slice;
exports.normalizeCssArray = normalizeCssArray;
exports.assert = assert;
exports.setAsPrimitive = setAsPrimitive;
exports.isPrimitive = isPrimitive;
exports.createHashMap = createHashMap;
exports.noop = noop;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1152)();
}


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["_71"] = superFundAccAgreementState;
/* unused harmony export signingAlreadyState */
/* harmony export (immutable) */ __webpack_exports__["_86"] = setActivityId;
/* harmony export (immutable) */ __webpack_exports__["c"] = querySuperFundAccAgreement;
/* harmony export (immutable) */ __webpack_exports__["_74"] = signSuperFundAccAgreement;
/* harmony export (immutable) */ __webpack_exports__["_72"] = querySuperfundUpdateList;
/* harmony export (immutable) */ __webpack_exports__["_73"] = upgradeControl;
/* unused harmony export validateSuperFundUpdateAction */
/* harmony export (immutable) */ __webpack_exports__["_76"] = validateSuperFundUpdate;
/* unused harmony export redeemToSuperFundPreview */
/* harmony export (immutable) */ __webpack_exports__["_90"] = getredeemToSuperFundPreview;
/* harmony export (immutable) */ __webpack_exports__["_92"] = getvalidateRedeemToSuperFund;
/* harmony export (immutable) */ __webpack_exports__["_93"] = getredeemToSuperFund;
/* harmony export (immutable) */ __webpack_exports__["_94"] = AnswerSecKill;
/* harmony export (immutable) */ __webpack_exports__["_87"] = getActivityById;
/* harmony export (immutable) */ __webpack_exports__["_88"] = AnswerSubmit;
/* harmony export (immutable) */ __webpack_exports__["_66"] = getUpdateSeason;
/* harmony export (immutable) */ __webpack_exports__["_70"] = getwebLogin;
/* unused harmony export bindingMobile */
/* unused harmony export syncAccountLoginType */
/* unused harmony export syncAccountLoginNo */
/* unused harmony export syncAccountTradePw */
/* unused harmony export syncAccountLoginPw */
/* unused harmony export syncAccountMobileNo */
/* unused harmony export syncAccountRequestId */
/* unused harmony export syncAccountName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return invitationCode; });
/* unused harmony export mergeObjectEasy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return syncAccount; });
/* harmony export (immutable) */ __webpack_exports__["_43"] = validateAgeUserCertNo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return verifyPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return getCrsDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return verifyRegisterPhone; });
/* unused harmony export getVerifyCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return realUserMobileCaptcha; });
/* unused harmony export SupperFundHome */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateTransactionPassword; });
/* unused harmony export getFundIsOpen */
/* harmony export (immutable) */ __webpack_exports__["I"] = buySubmit;
/* harmony export (immutable) */ __webpack_exports__["D"] = getFundsInfo;
/* harmony export (immutable) */ __webpack_exports__["E"] = getExpectedDate;
/* harmony export (immutable) */ __webpack_exports__["G"] = getDoRedeemSuper;
/* harmony export (immutable) */ __webpack_exports__["F"] = superFundPunishmentIn7Day;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSupperFundHome;
/* harmony export (immutable) */ __webpack_exports__["n"] = getFindAssetConfig;
/* unused harmony export QueryTransitRecords */
/* harmony export (immutable) */ __webpack_exports__["p"] = getQueryTransitRecords;
/* unused harmony export TransformationFunList */
/* harmony export (immutable) */ __webpack_exports__["w"] = Xeyi;
/* harmony export (immutable) */ __webpack_exports__["m"] = getTransformationHistory;
/* unused harmony export tradeDetail */
/* harmony export (immutable) */ __webpack_exports__["v"] = getTradeDetail;
/* harmony export (immutable) */ __webpack_exports__["u"] = historyConfirmDetail;
/* harmony export (immutable) */ __webpack_exports__["_82"] = Wangqi;
/* unused harmony export userHasInvested */
/* harmony export (immutable) */ __webpack_exports__["L"] = hqtXz;
/* harmony export (immutable) */ __webpack_exports__["K"] = smSzt;
/* unused harmony export HasInvested */
/* harmony export (immutable) */ __webpack_exports__["_60"] = encyclopediaAction;
/* harmony export (immutable) */ __webpack_exports__["_61"] = getEncyclopedia;
/* harmony export (immutable) */ __webpack_exports__["_58"] = riskEvaluationPieData;
/* harmony export (immutable) */ __webpack_exports__["_59"] = getRiskEvaluationPieData;
/* unused harmony export getBuyFee */
/* unused harmony export getCondition */
/* unused harmony export getModify */
/* unused harmony export getAdjust */
/* harmony export (immutable) */ __webpack_exports__["_91"] = isInvestmentFlag;
/* unused harmony export myNeedUpdate */
/* unused harmony export checkNeedUpdate */
/* unused harmony export myNeedNotice */
/* unused harmony export checkNeedNotice */
/* harmony export (immutable) */ __webpack_exports__["_65"] = getSeasonDetail;
/* harmony export (immutable) */ __webpack_exports__["_64"] = getAdjustDetail;
/* unused harmony export mySeasonDetail */
/* unused harmony export InvestStop */
/* unused harmony export investNotCombination */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return getJiaoYis; });
/* harmony export (immutable) */ __webpack_exports__["_85"] = verifyActivityBool;
/* harmony export (immutable) */ __webpack_exports__["_75"] = verifyActivityBoolHaveCast;
/* unused harmony export QueryInCome */
/* unused harmony export QueryTradeRecords */
/* harmony export (immutable) */ __webpack_exports__["C"] = getQueryTradeRecords;
/* unused harmony export historyIncomeList */
/* harmony export (immutable) */ __webpack_exports__["e"] = getHistoryIcomeList;
/* harmony export (immutable) */ __webpack_exports__["l"] = getHistoryIcomeListSuper;
/* unused harmony export HistoryAdjustAction */
/* harmony export (immutable) */ __webpack_exports__["o"] = getHistoryAdjust;
/* harmony export (immutable) */ __webpack_exports__["J"] = getCurrentAdjustDetail;
/* unused harmony export SuperFoundDetailXCL */
/* unused harmony export getSuperFoundDetail */
/* unused harmony export historyFundCodeAndName */
/* harmony export (immutable) */ __webpack_exports__["g"] = getHistoryFundCodeAndName;
/* unused harmony export historyTradeList */
/* harmony export (immutable) */ __webpack_exports__["i"] = getHistoryTradeList;
/* unused harmony export findDividendList */
/* harmony export (immutable) */ __webpack_exports__["h"] = getHistoryFindDividend;
/* harmony export (immutable) */ __webpack_exports__["_44"] = userJob;
/* harmony export (immutable) */ __webpack_exports__["x"] = provinceCity;
/* harmony export (immutable) */ __webpack_exports__["_45"] = getUserJob;
/* harmony export (immutable) */ __webpack_exports__["z"] = getProvinceCity;
/* harmony export (immutable) */ __webpack_exports__["W"] = bankType;
/* harmony export (immutable) */ __webpack_exports__["j"] = bankList;
/* harmony export (immutable) */ __webpack_exports__["k"] = getBankList;
/* harmony export (immutable) */ __webpack_exports__["Y"] = getBankType;
/* harmony export (immutable) */ __webpack_exports__["S"] = checkNumber;
/* harmony export (immutable) */ __webpack_exports__["H"] = dianji;
/* harmony export (immutable) */ __webpack_exports__["O"] = checkSuccessData;
/* harmony export (immutable) */ __webpack_exports__["T"] = getCheckNumber;
/* harmony export (immutable) */ __webpack_exports__["P"] = getCheckSuccessData;
/* unused harmony export AllCountry */
/* harmony export (immutable) */ __webpack_exports__["y"] = getAllCountry;
/* unused harmony export certifcationSuccess */
/* harmony export (immutable) */ __webpack_exports__["A"] = getCertifcationSuccess;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return loginHXAssets; });
/* harmony export (immutable) */ __webpack_exports__["_80"] = ztcgjiaoyijilu;
/* harmony export (immutable) */ __webpack_exports__["_77"] = ztcgjiaoyijiluxiangqing;
/* harmony export (immutable) */ __webpack_exports__["_79"] = ztcgfuwufei;
/* harmony export (immutable) */ __webpack_exports__["_78"] = ztcgfuwufeimingxi;
/* harmony export (immutable) */ __webpack_exports__["_51"] = yljycbMoney;
/* harmony export (immutable) */ __webpack_exports__["_53"] = yqyljyMoney;
/* harmony export (immutable) */ __webpack_exports__["_54"] = yljyAge;
/* harmony export (immutable) */ __webpack_exports__["_57"] = ylOutAge;
/* harmony export (immutable) */ __webpack_exports__["_52"] = yqyljySliderVal;
/* harmony export (immutable) */ __webpack_exports__["_49"] = yljyPlan;
/* harmony export (immutable) */ __webpack_exports__["_48"] = yljyNum;
/* harmony export (immutable) */ __webpack_exports__["_47"] = yljyAllMoney;
/* harmony export (immutable) */ __webpack_exports__["_46"] = yljyLineData;
/* harmony export (immutable) */ __webpack_exports__["_55"] = jySchoolType;
/* harmony export (immutable) */ __webpack_exports__["_89"] = clearYlOne;
/* harmony export (immutable) */ __webpack_exports__["_56"] = clearJyOne;
/* harmony export (immutable) */ __webpack_exports__["_50"] = clearYlJyEnd;
/* harmony export (immutable) */ __webpack_exports__["_26"] = smrzCardPerson;
/* harmony export (immutable) */ __webpack_exports__["_33"] = smrzPersonNumber;
/* harmony export (immutable) */ __webpack_exports__["_34"] = smrzAddress;
/* harmony export (immutable) */ __webpack_exports__["_35"] = smrzkzrAddress;
/* harmony export (immutable) */ __webpack_exports__["_36"] = smrzsyrAddress;
/* harmony export (immutable) */ __webpack_exports__["_37"] = smrzkzrBianma;
/* harmony export (immutable) */ __webpack_exports__["_38"] = smrzsyrBianma;
/* harmony export (immutable) */ __webpack_exports__["_39"] = smrzkzrYoux;
/* harmony export (immutable) */ __webpack_exports__["_40"] = smrzsyrYoux;
/* harmony export (immutable) */ __webpack_exports__["_2"] = smrzJob;
/* harmony export (immutable) */ __webpack_exports__["_4"] = smrzkzrJob;
/* harmony export (immutable) */ __webpack_exports__["_6"] = smrzsyrJob;
/* harmony export (immutable) */ __webpack_exports__["_1"] = smrzCareerCode;
/* harmony export (immutable) */ __webpack_exports__["_3"] = smrzCareerkzrCode;
/* harmony export (immutable) */ __webpack_exports__["_5"] = smrzCareersyrCode;
/* harmony export (immutable) */ __webpack_exports__["_7"] = smrznsrcode;
/* harmony export (immutable) */ __webpack_exports__["_41"] = smrznJtsrcode;
/* harmony export (immutable) */ __webpack_exports__["_10"] = smrzCity;
/* harmony export (immutable) */ __webpack_exports__["_11"] = smrzkzrCityc;
/* harmony export (immutable) */ __webpack_exports__["_12"] = smrzsyrCityc;
/* harmony export (immutable) */ __webpack_exports__["_14"] = smrzBeneficontro;
/* harmony export (immutable) */ __webpack_exports__["_13"] = smrzBeneficiaries;
/* harmony export (immutable) */ __webpack_exports__["_28"] = smrzBeneficontroName;
/* harmony export (immutable) */ __webpack_exports__["_18"] = smrzBeneficontroZjyxq;
/* harmony export (immutable) */ __webpack_exports__["_17"] = zzhZjyxq;
/* harmony export (immutable) */ __webpack_exports__["_19"] = smrzBeneficiariesZjyxq;
/* harmony export (immutable) */ __webpack_exports__["_22"] = smrzBeneficontroZjzq;
/* harmony export (immutable) */ __webpack_exports__["_23"] = smrzBeneficiariesZjzq;
/* harmony export (immutable) */ __webpack_exports__["_8"] = smrzkzrXbcode;
/* harmony export (immutable) */ __webpack_exports__["_9"] = smrzsyrXbcode;
/* harmony export (immutable) */ __webpack_exports__["_20"] = smrzBeneficontroCsrq;
/* harmony export (immutable) */ __webpack_exports__["_21"] = smrzBeneficiariesCsrq;
/* harmony export (immutable) */ __webpack_exports__["_31"] = smrzBeneficontroKzrNo;
/* harmony export (immutable) */ __webpack_exports__["_32"] = smrzBeneficontroSyrNo;
/* harmony export (immutable) */ __webpack_exports__["_27"] = smrzBeneficiariesName;
/* harmony export (immutable) */ __webpack_exports__["_42"] = huiDiao;
/* harmony export (immutable) */ __webpack_exports__["_16"] = smrzBeneficontroType;
/* harmony export (immutable) */ __webpack_exports__["_15"] = smrzBeneficiariesType;
/* harmony export (immutable) */ __webpack_exports__["_30"] = smrzBeneficontroNo;
/* harmony export (immutable) */ __webpack_exports__["_29"] = smrzBeneficiariesNo;
/* harmony export (immutable) */ __webpack_exports__["_24"] = smrzGjzz;
/* harmony export (immutable) */ __webpack_exports__["_0"] = smrzCardNumber;
/* harmony export (immutable) */ __webpack_exports__["V"] = smrzUpdatePhoneNo;
/* harmony export (immutable) */ __webpack_exports__["X"] = smrzAgreeItemFlag;
/* harmony export (immutable) */ __webpack_exports__["R"] = smrzCheckCard;
/* unused harmony export smrzCheckCardText */
/* unused harmony export smrzCheckCardFlag */
/* harmony export (immutable) */ __webpack_exports__["M"] = smrzPassWord;
/* harmony export (immutable) */ __webpack_exports__["N"] = smrzPassWordAgain;
/* harmony export (immutable) */ __webpack_exports__["Q"] = clearSmrzPassWord;
/* harmony export (immutable) */ __webpack_exports__["U"] = clearSmrzCheckCard;
/* harmony export (immutable) */ __webpack_exports__["Z"] = clearSmrzThird;
/* harmony export (immutable) */ __webpack_exports__["b"] = clearSmrzOne;
/* harmony export (immutable) */ __webpack_exports__["_68"] = isExpiredByInvestment;
/* harmony export (immutable) */ __webpack_exports__["_83"] = getEfficientQuestionnaire;
/* harmony export (immutable) */ __webpack_exports__["_84"] = addUserAnswerByZt;
/* harmony export (immutable) */ __webpack_exports__["_25"] = ZTbool;
/* harmony export (immutable) */ __webpack_exports__["_69"] = getRcommendStrategy;
/* harmony export (immutable) */ __webpack_exports__["_67"] = getSuperFundSeriesFun;
/* harmony export (immutable) */ __webpack_exports__["t"] = superfundCancelFun;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getPay_js__ = __webpack_require__(20);


var _this2 = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import { isLoginAndRealName } from '../../CommonVar.js';







var ToastTime = __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime;
//投顾状态
function superFundAccAgreementState(text) {
  return {
    type: "SUPER_ACCA_AGREEMENT_STATE",
    text: text
  };
}
//签约状态标志 fzy
function signingAlreadyState(text) {
  return {
    type: "SIGNING_ALREADY_STATE",
    text: text
  };
}
//答题的id fzy
function setActivityId(text) {
  return {
    type: "ACTIVITY_ID",
    text: text
  };
}

/*投顾状态查询 /api/advisor/querySuperFundAccAgreement*/
function querySuperFundAccAgreement(data, successCallback, errorCallback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/advisor/querySuperFundAccAgreement", data, function (result) {
        if (result.code == '0000') {
          successCallback(result.content);
          dispatch(signingAlreadyState(result.content));
        } else {
          errorCallback(result.message);
        }
        console.log(result);
      }, function (error) {
        console.log(error);
        // errorCallback(error)
      });
    });
  };
}

// export function querySuperFundAccAgreement(data,callBack){
//   return function(dispatch, getState) {
//     getTempInfo( 'shortToken' ).then( (d)=>{
//       data.token=d;
//       Util.get(Util.url+"/api/advisor/querySuperFundAccAgreement",data,function(result){
//         if (result.code=='0000') {
//           callBack(result)
//         }else{
//           callBack(result)
//         }
//         console.log(result)
//       },function(error){

//       })
//     })
//   }
// }


/*投顾授权、签约、解约/api/advisor/signSuperFundAccAgreement 参数: token、 state(0，解约；1，签约；2，授权) 、operator(user)*/
function signSuperFundAccAgreement(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/advisor/signSuperFundAccAgreement", data, function (result) {
        if (result.code == '0000') {
          callBack(result);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
          // callBack(result)
        }
        console.log(result);
      }, function (error) {
        console.log(error, "signSuperFundAccAgreement");
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      });
    });
  };
}
/*智投组合可转换基金接口 fzy */
function querySuperfundUpdateList(callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = { token: d };
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/querySuperfundUpdateList", data, function (result) {
        if (result.code == '0000') {
          console.log(result);
          callBack(result.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
      }, function (error) {
        console.log(error);
      });
    }).catch(function (err) {
      return console.log(err);
    });
  };
}

/**智投组合升级弹窗控制标识 */
function upgradeControl(text) {
  return {
    type: "UPGRADE_CONTROL",
    text: text
  };
}

/*查询是否开放升级功能 */
function validateSuperFundUpdateAction(text) {
  return {
    type: "VALIDATE_SUPERFUND_UPDATE_ACTION",
    text: text
  };
}
function validateSuperFundUpdate(data, callBack, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/validateSuperFundUpdate", data, function (result) {
        if (result.code == '0000') {
          console.log(result.content, "查询是否开放升级功能");
          dispatch(validateSuperFundUpdateAction(result.content));
          if (callBack) {
            callBack(result.content);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}

/*智投升级预览*/
function redeemToSuperFundPreview(text) {
  return {
    type: "REDEEM_TO_SUPER_FUND_PREVIEW",
    text: text
  };
}
function getredeemToSuperFundPreview(data, callBack, _this) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/redeemToSuperFundPreview", data, function (result) {
        if (result.code == '0000') {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          var data1 = JSON.parse(JSON.stringify(result.content.previewItemFunds));
          for (var i = 0; i < data1.length; i++) {
            console.log(i);
            if (data1[i].srcRegularRate == null) {
              data1.splice(i, 1);
              i -= 1;
              continue;
            }
            console.log(i);

            for (var j = i + 1; j < data1.length; j++) {
              if (data1[i].styleTypeName == data1[j].styleTypeName) {
                if (Object.prototype.toString.call(data1[j].srcRegularRate) == "[object Number]") {
                  data1[i].srcRegularRate = data1[i].srcRegularRate + data1[j].srcRegularRate;
                }
                data1.splice(j, 1);
                j -= 1;
              }
            }
          }
          data1.sort(getVal('srcRegularRate'));
          result.content.previewItemFundsChart = data1;
          dispatch(redeemToSuperFundPreview(result.content));
          if (callBack) {
            callBack(result.content);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}

// /*预校验升级业务*/
// export function validateRedeemToSuperFund(text) {
//   return {
//     type: "VALIDATE_REDEEM_TO_SUPER_FUND",
//     text: text
//   }
// }
function getvalidateRedeemToSuperFund(data, callBack, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/validateRedeemToSuperFund", data, function (result) {
        if (result.code == '0000') {
          console.log(result.content, "预升级校验");
          if (callBack) {
            callBack(result.content);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}

/*智投升级*/
function getredeemToSuperFund(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(validateTransactionPassword(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);callback(2);;return;
        }
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/redeemToSuperFund", data, function (result) {
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
          console.log(result);
        }, function (error) {
          callback(3, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      console.log(err);
    });
  };
}

/*答题活动*/
function AnswerSecKill(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/seckill/secKillSubmit", data, function (result) {
        if (result.code == '0000') {
          callBack(result);
        } else {
          callBack(result);
        }
        console.log(result);
      }, function (error) {});
    });
  };
}
/*根据id获取答题活动-新*/
function getActivityById(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/point/getActivityById", data, function (result) {
        if (result.code == '0000') {
          callBack(result);
        } else {
          callBack(result);
        }

        console.log(result);
      }, function (error) {});
    });
  };
}
/*答题活动*/
function AnswerSubmit(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/point/savePointAnswers", data, function (result) {
        if (result.code == '0000') {
          callBack(result);
        } else {
          callBack(result);
        }
        console.log(result);
      }, function (error) {});
    });
  };
}

//调仓确认
function getUpdateSeason(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log('调仓确认:', data);
      dispatch(validateTransactionPassword(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);callback(2);return;
        }
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/updateSeason", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          callback(3, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        });
      }, function (m) {
        callback(2);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
    });
  };
}
function getwebLogin(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/login/camcWebLogin", data, function (result) {
      console.log(result, '------------------');
      if (result.code == "0000") {
        var TM = new Date();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('currentUserInfo', result.content);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-shortToken', result.content.shortToken);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-longToken', result.content.longToken);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["b" /* getUserInfoList */])());
        if (result.content.isProxySale) {
          //纯代销
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '0'); //0
          callback(result);
        } else if (result.content.hasCwimAccount) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '2');
          callback(result);
        } else if (result.content.hasCwimAccount === false) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '3');
          dispatch(syncAccountName(result.content.name));
          dispatch(syncAccountLoginType(result.content.certType));
          dispatch(syncAccountLoginNo(result.content.certNo));
          callback(result);
        }
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '0'); //1
      }
    }, function (error) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '0'); //1
    });
  };
}
//import Store from '../ReduxStore';
var bindingMobile = function bindingMobile(verifyParam, loginContent, succallback, errcallback) {
  return function () {
    var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
      var successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});

              successCallback = function successCallback(succ) {
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
                console.log(succ);
                if (succ && succ.code === '0000') {

                  succallback();
                } else {
                  console.log('后台返回数据有误！' + succ.message);
                  errcallback(succ.message);
                }
              };

              errorCallback = function errorCallback(err) {
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
                console.log(err);
                errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
              };

              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/bindingMobileNo', verifyParam, successCallback, errorCallback);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
//同步开户传入参数：证件类型
var syncAccountLoginType = function syncAccountLoginType(text) {
  return { type: 'SYNC_ACCOUNT_LOGIN_TYPE', text: text };
};

//同步开户传入参数：证件号码
var syncAccountLoginNo = function syncAccountLoginNo(text) {
  return { type: 'SYNC_ACCOUNT_LOGIN_NO', text: text };
};

//同步开户传入参数：交易密码
var syncAccountTradePw = function syncAccountTradePw(text) {
  return { type: 'SYNC_ACCOUNT_TRADE_PASSWORD', text: text };
};

//同步开户传入参数：登录密码
var syncAccountLoginPw = function syncAccountLoginPw(text) {
  return { type: 'SYNC_ACCOUNT_LOGIN_PASSWORD', text: text };
};

//同步开户传入参数：手机号
var syncAccountMobileNo = function syncAccountMobileNo(text) {
  return { type: 'SYNC_ACCOUNT_MOBILE_NO', text: text };
};

//同步开户传入参数：短信请求编码
var syncAccountRequestId = function syncAccountRequestId(text) {
  return { type: 'SYNC_ACCOUNT_REQUEST_ID', text: text };
};

//同步开户传入参数：姓名
var syncAccountName = function syncAccountName(text) {
  return { type: 'SYNC_ACCOUNT_NAME', text: text };
};

//同步开户传入参数：邀请码
var invitationCode = function invitationCode(text) {
  return { type: 'INVITATION_CODE', text: text };
};

var mergeObjectEasy = function mergeObjectEasy(oldObj, newObj) {
  return Object.assign({}, oldObj, newObj);
};
var syncAccount = function syncAccount(paramsInit, succallback, errcallback) {
  return function () {
    var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var currentUserInfo, paramsLS, params, successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["d" /* getStorage */])('currentUserInfo');

            case 2:
              currentUserInfo = _context3.sent;

              // getTempInfo( 'shortToken' ).then((data) => {
              // paramsInit.token = data;
              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
              console.log(sessionStorage);
              paramsLS = {
                // loginNo:currentUserInfo.certNo,
                // loginType:currentUserInfo.certType,
                // mobileNo:getState().mobileNo?getState().mobileNo:sessionStorage.sync.split(',')[0],
                // requestId:getState().requestId?getState().requestId:sessionStorage.sync.split(',')[1],
                // name:currentUserInfo.name,
                // invitationCode: getState().invitationCode?getState().invitationCode:sessionStorage.sync.split(',')[2],
                invitationCode: "",
                clientType: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.return_Clinet_Type()
              };
              params = mergeObjectEasy(paramsLS, paramsInit);

              successCallback = function () {
                var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(succ) {
                  var userInfo, user;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          console.log(succ);
                          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();

                          if (!(succ && succ.code === '0000')) {
                            _context2.next = 23;
                            break;
                          }

                          userInfo = {
                            userId: succ.content.userId,
                            isRealName: succ.content.tradeAccountNo ? true : false
                          };

                          if (succ.content.tradeAccountNo) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '2');
                          } else {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '1');
                          }
                          if (succ.content.name != undefined) userInfo = mergeObjectEasy(userInfo, { name: succ.content.name });
                          if (succ.content.nickName != undefined) userInfo = mergeObjectEasy(userInfo, { nickName: succ.content.nickName });
                          if (succ.content.tradeAccountNo != undefined) userInfo = mergeObjectEasy(userInfo, { tradeAccountNo: succ.content.tradeAccountNo });
                          userInfo.mobileNo = params.mobileNo;
                          console.log('同步开户后userInfo', userInfo);
                          _context2.next = 12;
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('userList-' + userInfo.userId);

                        case 12:
                          user = _context2.sent;

                          if (user != 9999) {
                            userInfo = mergeObjectEasy(user, userInfo);
                          }

                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["b" /* getUserInfoList */])());
                          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["a" /* isLogin */])(true));
                          succallback(succ.content);
                          _context2.next = 25;
                          break;

                        case 23:
                          console.log('后台返回数据有误!');
                          errcallback(succ.message);

                        case 25:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this2);
                }));

                return function successCallback(_x5) {
                  return _ref3.apply(this, arguments);
                };
              }();

              errorCallback = function errorCallback(err) {
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
                console.log(err);
                errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
              };
              // console.log(getState());
              // console.log(getState().synchAccountParam);
              // params.tradePassword = tradePassword;


              console.log(params);
              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/openCucAndCwimAccount', params, successCallback, errorCallback);
              // })
              // .catch( (err)=>{
              //   console.log(err)
              //   Toast.info(Util.errorTxt, Util.ToastTime);
              // });

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
//获取年龄情况
function validateAgeUserCertNo(params, callback, errBack) {
  return function (dispatch, getState) {
    console.log(params);
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/account/validateAgeUserCertNo", params, function (responseText) {
      console.log(responseText);
      callback(responseText);
    }, function (err) {
      // errBack();
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, 2);
    });
  };
}
//验证手机号
var verifyPhone = function verifyPhone(verifyParam, succallback, errcallback) {
  var flag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  return function () {
    var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});

              successCallback = function successCallback(succ) {
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
                console.log(succ);
                if (succ && succ.code === '0000') {
                  succallback();
                } else {
                  console.log('后台返回数据有误！' + succ.message);
                  errcallback(succ.message);
                }
              };

              errorCallback = function errorCallback(err) {
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
                console.log(err);
                errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
              };

              dispatch(syncAccountMobileNo(verifyParam.mobileNo));
              dispatch(syncAccountRequestId(verifyParam.requestId));
              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/mobileCaptcha/validateMobileCaptcha', verifyParam, successCallback, errorCallback);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
//是否有税收
var getCrsDetail = function getCrsDetail(succallback, errcallback) {
  return function () {
    var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var successCallback, errorCallback, currentUserInfo, params;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // dispatch(pageFlag(true));
              successCallback = function successCallback(succ) {
                // dispatch(pageFlag(false));
                console.log(succ);
                if (succ && succ.code === '0000') {
                  succallback(succ.content);
                } else {
                  errcallback(succ.message);
                }
              };

              errorCallback = function errorCallback(err) {
                // dispatch(pageFlag(false));

                errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
              };

              _context5.next = 4;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["d" /* getStorage */])('currentUserInfo');

            case 4:
              currentUserInfo = _context5.sent;

              console.log(currentUserInfo, 1111121);
              params = {
                certNo: currentUserInfo.certNo,
                certType: currentUserInfo.certType
              };

              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/getCrsDetail', params, successCallback, errorCallback);

            case 8:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this2);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};
//验证手机号是否已经注册
var verifyRegisterPhone = function verifyRegisterPhone(params, succallback, errcallback) {
  var revcallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  return function (dispatch, getState) {
    var successCallback = function successCallback(suc) {
      if (suc && suc.code === '0000') {
        console.log('手机号没注册过');
        succallback(params.mobileNo);
      } else {
        console.log('手机号注册过');
        if (suc.message.indexOf('手机号已注册') != -1 && revcallback) {
          revcallback(params.mobileNo);
          return;
        }
        errcallback(suc.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/validateMobileHasRegister', params, successCallback, errorCallback);
  };
};
//获取手机验证码
var getVerifyCode = function getVerifyCode(mobileNo, callback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code == '0000') {
        console.log(succ);
        callback(succ.content);
      } else {
        console.log(succ);
        console.log('后台返回数据有误!');
        callback('');
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
      callback('');
    };
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/mobileCaptcha/sendMobileCaptcha', { mobileNo: mobileNo }, successCallback, errorCallback);
  };
};
//登录后-获取手机验证码 20-3-12
var realUserMobileCaptcha = function realUserMobileCaptcha(params, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      params.token = d;
      console.log(params);
      var successCallback = function successCallback(succ) {
        if (succ && succ.code == '0000') {
          console.log(succ);
          callback(succ.content);
        } else {
          console.log(succ);
          // Toast.show(succ.message, getToastConfPoint());
          console.log('后台返回数据有误!');
          callback('');
        }
      };
      var errorCallback = function errorCallback(err) {
        console.log(err);
        callback('');
      };
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/mobileCaptcha/realUserMobileCaptcha', params, successCallback, errorCallback);
    }).catch(function (err) {
      console.log(err);
    });
  };
};
/* 智投首页*/
function SupperFundHome(text) {
  return {
    type: "SUPPER_FUND_HOME",
    text: text
  };
}
var validateTransactionPassword = function validateTransactionPassword(params, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function () {
      var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(succ) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log(succ);
                if (succ && succ.code === '0000') {
                  succallback(succ.content);
                } else {

                  console.log('后台返回数据有误！' + succ.message);
                  errcallback(succ.message);
                }

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this2);
      }));

      return function successCallback(_x12) {
        return _ref6.apply(this, arguments);
      };
    }();
    var errorCallback = function errorCallback(err) {

      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/validatePassword', params, successCallback, errorCallback);
  };
};
//当前基金是否开放
function getFundIsOpen(data, callBack) {
  return function (dispatch, getState) {
    console.log('当前基金是否开放:', data);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/buy/getBuyFee", data, function (result) {
        if (result.code == '0000') {} else {
          callBack(result.message);
        }
        console.log(result);
      }, function (error) {});
    }).catch(function (err) {
      console.log(err);
    });
  };
}
//继续投资
function buySubmit(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.return_Clinet_Type();

      console.log('购买入参:', data);
      dispatch(validateTransactionPassword(data, function (c) {
        console.log(c, "8988989889898989");
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime, function () {});callback(0, "");return;
        }
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superFund/buy", data, function (result) {
          ///superfund/buy/submit
          console.log(result, "1111111");
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            if (data.textval == "直销卡") {
              callback(result.content.requestDetail.paymentState, result);
            } else {
              callback(1, result);
            }
          } else {
            callback(0, result.message);
          }
        }, function (error) {
          callback(0, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        callback(0, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//获取三货基详情
function getFundsInfo(callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/trade/getFundsInfo", {}, function (result) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
      if (result.code == '0000') {
        if (callback) {
          callback(result);
        }
      }
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//获取智投赎回到账日
function getExpectedDate(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/redeem/getExpectedDate", data, function (result) {
      console.log(result);
      if (result.code == '0000') {
        if (callback) {
          callback(result);
        }
      }
    }, function (error) {
      console.log(error);
    });
  };
}

//赎回
function getDoRedeemSuper(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log('super redeem入参:', data);
      dispatch(validateTransactionPassword(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);callback(0);return;
        }
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/redeem/submit ", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else if (result.code == '1111') {
            __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
            callback(2, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          callback(3, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
        });
      }, function (m) {
        callback(2);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//智投组合七日惩罚性赎回判断
function superFundPunishmentIn7Day(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/trade/superFundPunishmentIn7Day", data, function (result) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        console.log(result);
        if (result.code == '0000') {
          callback(result);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        console.log(error);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
    });
  };
}

function getSupperFundHome(data, callback, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token === null || token === "" || token === undefined) {
        console.log("token为空");
      } else {
        data.token = token;
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/supperFund/homePage", data, function (data) {

          if (data.code == "0000") {
            dispatch(SupperFundHome(data.content));
            callback(data.content);
          } else {
            //let toast = Toast.show(data.message, getToastConfPoint( ) );
          }
        }, function (error) {
          console.log(error);
          //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) );
        });
        /*start*/
        // let dataTemp = homeJson;
        // if(dataTemp.code == "0000"){
        //     dispatch(SupperFundHome(dataTemp.content));
        //     callback(dataTemp.content)
        // }
        /*end*/
      }
    }).catch(function (err) {
      //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) ); 
    });
  };
}

/*组合分析（绩效归因分解）*/
function getFindAssetConfig(data, callBack, _this) {
  return function (dispatch, getState) {
    // getTempInfo( 'shortToken' ).then( (d)=>{ 
    //   let newData=data;
    //   newData.token=d;
    //   console.log('checkNeedUpdate:',newData)
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/findAssetConfig", data, function (result) {
      if (result.code == '0000') {
        callBack(result.content);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      }
    }, function (error) {
      // alert(error)
      // Toast.info(Util.errorTxt, Util.ToastTime );
    });
    // }).catch( (err)=>{ console.log(err) } )
  };
}

var homeJson = { "code": "0000", "message": null, "content": { "allIncome": "5.52", "dayIncome": "5.65", "riskType": null, "deadLine": "2017-07-31", "singleSuperFundViews": [{ "adjustFlag": false, "allIncome": "1.93", "buyFlag": null, "currentAsset": 401.25, "dayIncome": "0.93", "redeemFlag": false, "superFundCode": "SF1005", "superFundName": "锐意进取组合", "thirtyIncome": null, "deadLine": "2017-07-31" }, { "adjustFlag": false, "allIncome": "3.61", "buyFlag": null, "currentAsset": 2005.56, "dayIncome": "4.73", "redeemFlag": false, "superFundCode": "SF1011", "superFundName": "常青藤大学组合", "thirtyIncome": null, "deadLine": "2017-07-31" }], "totalAssets": 2406.81, "transitAssets": 0.0, "problemList": { "content": { "total": 4, "rows": [{ "content": "一分钟了解华夏智投", "title": "<p>华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。</p>\n<p>华夏智投组合为客户提供教育金智投、时光智投和资产增值智投三个系列，共9个组合，可以满足客户资产增值、教育、养老等多方面的投资需求，客户可以根据自身需要，选择不同的智投组合。</p>\n", "bq": [{ "tagName": "智投介绍", "cjwtId": 1493, "tagId": "WT_TAG_1492" }], "orderFlag": 1, "NUM": 1, "pageValid": "1", "key": 1493 }, { "content": "查理机器人介绍", "title": "<p>查理是汇聚华夏基金多年丰富的主动资产管理和海外资产配置经验，为您精心打造的智投机器人，查理将利用互联网技术与AI智能算法，为客户提供财务目标规划、生成资产配置解决方案、组合全周期管理的一站式智投服务，让每个客户都享受到私人银行般的服务。</p>\n", "bq": [{ "tagName": "智投介绍", "cjwtId": 1596, "tagId": "WT_TAG_1492" }], "orderFlag": 2, "NUM": 2, "pageValid": "1", "key": 1596 }, { "content": "创建智投组合的方式", "title": "<p>您只需要两步就能创建属于您的智投组合：</p>\n<p>1、华夏智投包括教育、养老和资产增值三种场景，您可以根据自身需要选择智投组合。您也可以通过智投计算器来测算一下，获得推荐组合和投资方案；</p>\n<p>2、 进入智投组合详情页后，只需要点击“一键投资”按钮，完成支付即可。购买组合一般需要两天的时间，购买后请随时关注组合调仓情况，及时跟踪调仓。</p>\n<p></p>\n", "bq": [{ "tagName": "智投介绍", "cjwtId": 1495, "tagId": "WT_TAG_1492" }], "orderFlag": 3, "NUM": 3, "pageValid": "1", "key": 1495 }, { "content": "智投计算器有什么用？", "title": "<p>智投计算器是帮助客户根据目前的所处阶段（例如客户年龄、当前养老储备金、预期每年养老金需求，或者孩子年龄、当前教育储备金等），计算客户养老金或者教育金缺口及所需投资金额。</p>\n", "bq": [{ "tagName": "智投介绍", "cjwtId": 1771, "tagId": "WT_TAG_1492" }], "orderFlag": 4, "NUM": 4, "pageValid": "1", "key": 1771 }] } } }

  /* 在途资金明细, http://10.16.0.240/hxcfapp_dev/api/superfund/queryTransitRecords */
};function QueryTransitRecords(text) {
  return {
    type: "QUERY_TRANSIT_RECORDS",
    text: text
  };
}

function getQueryTransitRecords(data, callback, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/queryTransitRecords", data, function (data) {
        if (data.code == "0000") {
          dispatch(QueryTransitRecords(data.content));

          //dispatch(pageFlag(false));
          callback(data.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
          //let toast = Toast.show(data.message, getToastConfPoint( ) );
        }
      }, function (error) {
        console.log(error, "错误信息");
        //let toast = Toast.show("网络异常，请检查您的网络", getToastConfPoint( ) );
      });
    }).catch(function (err) {
      //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) );

    });
  };
}

/*历史交易记录*/
function TransformationFunList(text) {
  return {
    type: "TRANSFORMATION_FUN_LIST",
    text: text
  };
}

// 协议初始值
function Xeyi(text) {
  return {
    type: "XEYI",
    text: text
  };
}

function getTransformationHistory(data, callbackData, _this) {
  return function (dispatch, getState) {
    //dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      // let data={
      //   token:d,
      //   fundCode:fundCode,
      //   pageSize:pageSize,
      //   pageIndex:pageIndex,
      //   businessType:businessType
      // }
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/historyTradeQuery", data, function (result) {
        if (result.content == null) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        } else {
          var newData = result.content.records.filter(function (item) {
            return item.fundName.endsWith('组合') || __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.superFundNameArr.indexOf(item.fundName) > -1 || item.businessType == "TC24";
          });
          console.log(newData, 123);
          result.content.records = newData;
          callbackData(result.content);
        }
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      });
    }).catch(function (err) {
      if (_this) {
        _this.setState({
          loadingFlag: false
        });
      }
    });
  };
}

/*交易记录详情*/
function tradeDetail(text) {
  return {
    type: "TRADE_DETAIL",
    text: text
  };
}
function getTradeDetail(data, callbackData, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/historyTradeDetail", data, function (result) {
        if (result.content == null) {} else {
          dispatch(tradeDetail(result.content));
          callbackData(result.content);
        }
      }, function (error) {
        console.log(error);
      });
    }).catch(function (err) {});
  };
}

/*历史确认详情*/
function historyConfirmDetail(data, callbackData) {
  return function (dispatch, getState) {

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/historyConfirmDetail", data, function (result) {
        if (result.content == null) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        } else {
          dispatch(tradeDetail(result.content));
          callbackData(result.content);
        }
      }, function (error) {});
    }).catch(function (err) {});
  };
}

// 往期报告
function Wangqi(data, callbackData) {
  return function (dispatch, getState) {

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/product/stopProfit/historyReport/getHistoryReportList", data);
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/product/stopProfit/historyReport/getHistoryReportList", data, function (result) {
        if (result.content == null) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        } else {
          callbackData(result.content);
        }
      }, function (error) {});
    }).catch(function (err) {});
  };
}

/*看是否用户是否持有有超级基金产品*/
function userHasInvested(text) {
  return {
    type: "QUERY_INCOME",
    text: text
  };
}
function hqtXz(text) {
  return {
    type: "HQT_XZ",
    text: text
  };
}
function smSzt(text) {
  return {
    type: "SMS_ZT",
    text: text
  };
}
function HasInvested(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/account/hasInvested", data, function (result) {
        if (result.code == "0000") {
          dispatch(userHasInvested(result.content.invested));
          callBack(result.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.code, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {});
  };
}

//智投百科
function encyclopediaAction(text) {
  return {
    type: "ENCYCLOPEDIA_ACTION",
    text: text
  };
}

//获取智投百科
function getEncyclopedia(params, callBack) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/cms/getQuestionListByCode", params, function (data) {
      dispatch(encyclopediaAction(data.content.rows));
      console.log("智投百科");
      console.log(data);
      callBack(data);
    }, function (err) {
      console.log("错误信息" + err);
    });
  };
}

//风险测评数据
function riskEvaluationPieData(text) {
  return {
    type: "RISK_EVALUATIONPIE_DATA",
    text: text
  };
}

//获取风险测评数据
function getRiskEvaluationPieData(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      params.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/account/saveRiskRank", params, function (data) {
        if (data.code == "0000") {
          dispatch(riskEvaluationPieData(data));
          console.log("风险测评数据");
          console.log(data);
          callBack();
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
          console.log(data.code);
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        console.log("错误信息" + err);
      });
    });
  };
}

//费率计算
function getBuyFee(data, callBack) {
  var callBack2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return function (dispatch, getState) {
    console.log('费率计算入参:', data);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/buy/getBuyFee", data, function (result) {
        if (result.code == '0000') {
          callBack(result.content);
        } else {
          callBack2(result.message);
          // let toast = Toast.show(result.message, getToastConfPoint( ) );
        }
        console.log(callBack2, result);
      }, function (error) {
        // let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
        console.log('费率计算入参 error');
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
function getCondition(data, callBack) {
  return function () {
    var _ref7 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(dispatch, getState) {
      var isRealName;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              isRealName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay_js__["b" /* getLoginState */])();

              if (isRealName == "1") {
                callBack(false);
              } else {
                // dispatch(setPayLoading(true))
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
                  data.token = token;
                  console.log('getCondition:', data);
                  __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/account/hasInvested", data, function (result) {
                    if (result.code == '0000') {
                      console.log(result, '是否有这个基金,true有');
                      callBack(result.content.invested);
                    } else {
                      callBack(false);
                    }
                  }, function (error) {
                    // dispatch(setPayLoading(false))
                    console.log(error);
                  });
                }).catch(function (err) {
                  // dispatch(setPayLoading(false))
                });
              };

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    return function (_x14, _x15) {
      return _ref7.apply(this, arguments);
    };
  }();
}
function getModify(data, callBack) {
  return function (dispatch, getState) {
    console.log('是否需要季度调仓,true需要');
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/checkNeedNotice", data, function (result) {
      console.log(result, '是否需要季度调仓,true需要');
      if (result.code == '0000') {
        if (result.content) {
          callBack(2);
        } else {
          dispatch(getAdjust(data, callBack));
        }
      }
    }, function (error) {});
  };
}
function getAdjust(data, callBack) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/checkNeedUpdate", data, function (result) {
      console.log(result, '是否可追加投资,true可以');
      if (result.code == "0000") {
        if (result.content.needAdjust) {
          callBack(1);
        } else {
          callBack(3);
        }
        // callBack(result.content);
      }
    }, function (error) {});
  };
}

//是否持仓
function isInvestmentFlag(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/account/hasInvested", data, function (result) {
        if (result.code == "0000") {
          if (callBack) {
            callBack(result.content.invested, result.content.riskLevel);
          }
        } else {
          // let toast = Toast.show( result.code, getToastConfPoint( ) );
        }
      }, function (error) {
        console.log(error);
      });
    }).catch(function (err) {});
  };
}
//是否需要调仓(追加投资) 
function myNeedUpdate(text) {
  return {
    type: "NEED_UPDATE",
    text: text
  };
}
function checkNeedUpdate(data) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(checkNeedNotice(data));
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/checkNeedUpdate", data, function (result) {
        if (result.code == '0000') {
          dispatch(myNeedUpdate(result.content.needAdjust));
        } else {}
        console.log('追加投资checkNeedUpdate :', result);
      }, function (error) {
        console.log('checkNeedUpdate error');
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
//是否需要调仓(季度调仓)
function myNeedNotice(text) {
  return {
    type: "NEED_NOTICE",
    text: text
  };
}
function checkNeedNotice(data) {
  return function (dispatch, getState) {
    // getTempInfo( 'shortToken' ).then( (d)=>{ 
    //   let newData=data;
    //   newData.token=d;
    //   console.log('checkNeedUpdate:',newData)
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/checkNeedNotice", data, function (result) {
      if (result.code == '0000') {
        dispatch(myNeedNotice(result.content));
      } else {}
      console.log(result, '季度调仓checkNeedNotice');
    }, function (error) {
      // let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
      console.log('checkNeedNotice error');
    });
    // }).catch( (err)=>{ console.log(err) } )
  };
}
var getVal = function getVal(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
};
function getSeasonDetail(data) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var newData = data;
      newData.token = d;
      console.log('调仓getSeasonDetail入参:', newData);
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/getSeasonDetail", newData, function (result) {
        if (result.code == '0000') {
          var data1 = JSON.parse(JSON.stringify(result.content.previewItemFunds));
          for (var i = 0; i < data1.length; i++) {
            if (data1[i].srcRegularRate == null) {
              data1.splice(i, 1);
              i -= 1;
              continue;
            }
            for (var j = i + 1; j < data1.length; j++) {
              console.log(i, j);
              if (data1[i].styleTypeName == data1[j].styleTypeName) {
                if (Object.prototype.toString.call(data1[j].srcRegularRate) == "[object Number]") {
                  data1[i].srcRegularRate = data1[i].srcRegularRate + data1[j].srcRegularRate;
                }
                data1.splice(j, 1);
                j -= 1;
              }
            }
          }
          data1.sort(getVal('srcRegularRate'));
          result.content.previewItemFundsChart = data1;
          dispatch(mySeasonDetail(result.content));
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
        console.log(result);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        //     let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
        console.log('调仓 error');
        //       dispatch(pageFlag(false));
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//调整组合（追加详情）
function getAdjustDetail(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/getAdjustDetail", data, function (result) {
        if (result.code == '0000') {
          var data1 = JSON.parse(JSON.stringify(result.content.previewItemFunds));
          for (var i = 0; i < data1.length; i++) {
            if (data1[i].srcRegularRate == null) {
              data1.splice(i, 1);
              i -= 1;
              continue;
            }
            for (var j = i + 1; j < data1.length; j++) {
              console.log(i, j);
              if (data1[i].styleTypeName == data1[j].styleTypeName) {
                if (Object.prototype.toString.call(data1[j].srcRegularRate) == "[object Number]") {
                  data1[i].srcRegularRate = data1[i].srcRegularRate + data1[j].srcRegularRate;
                }
                data1.splice(j, 1);
                j -= 1;
              }
            }
          }
          data1.sort(getVal('srcRegularRate'));
          result.content.previewItemFundsChart = data1;
          dispatch(mySeasonDetail(result.content));
        } else {
          callBack(result);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        }
        console.log(result);
      }, function (error) {
        console.log('getAdjustDetail error');
      });
    }).catch(function (err) {});
  };
}

//季度调仓
function mySeasonDetail(text) {
  return {
    type: "SEASON_DETAIL",
    text: text
  };
}
/*组合已投资详情*/
function InvestStop(text) {
  return {
    type: "INVEST_STOP",
    text: text
  };
}

/*智投组合未投详情*/
function investNotCombination(text) {
  return {
    type: "INVES_NOT_COMBINATION",
    text: text
  };
}

// 智投产品交易规则和费率
var getJiaoYis = function getJiaoYis(data, sucBack) {
  return function () {
    var _ref8 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(dispatch, getState) {
      var getFundBack, errFundBack;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              getFundBack = function () {
                var _ref9 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(succ) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          if (succ.code == "0000") {
                            sucBack(succ.content);
                          } else {
                            __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(succ.message);
                          }

                        case 1:
                        case 'end':
                          return _context8.stop();
                      }
                    }
                  }, _callee8, _this2);
                }));

                return function getFundBack(_x18) {
                  return _ref9.apply(this, arguments);
                };
              }();

              errFundBack = function errFundBack(err) {
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(err);
              };

              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/trade/rule/getSuperFundTradeRule?", { superFundCode: data }, getFundBack, errFundBack);

            case 3:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this2);
    }));

    return function (_x16, _x17) {
      return _ref8.apply(this, arguments);
    };
  }();
};

//获取止盈 非止盈 智投开放状态
function verifyActivityBool(params, sucBack) {
  return function () {
    var _ref10 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(dispatch, getState) {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken");

            case 2:
              token = _context10.sent;

              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/trade/rule/getSuperFundTradeOpenStatus?", { superFundCode: params.superFundCode, stopProfit: params.stopProfit, token: token }, function (result) {
                console.log(result);
                if (result.code == '0000') {
                  sucBack(result.content);
                }
              }, function (error) {
                console.log(error);
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
              });

            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    return function (_x19, _x20) {
      return _ref10.apply(this, arguments);
    };
  }();
}

//获取止盈 非止盈 智投开放状态（已投）
function verifyActivityBoolHaveCast(params, sucBack) {
  return function () {
    var _ref11 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(dispatch, getState) {
      var token;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken");

            case 2:
              token = _context11.sent;

              params.token = token;
              __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/trade/rule/getSuperFundTradeOpenStatus4Hold", params, function (result) {
                console.log(result);
                if (result.code == '0000') {
                  sucBack(result.content);
                }
              }, function (error) {
                console.log(error);
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
              });

            case 5:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    return function (_x21, _x22) {
      return _ref11.apply(this, arguments);
    };
  }();
}

/*组合表现折线图*/
function QueryInCome(text) {
  return {
    type: "QUERY_INCOME_Line",
    text: text
  };
}

/* 操作记录明细, http://10.16.0.240/hxcfapp_dev/api/superfund/queryTradeRecords */
function QueryTradeRecords(text) {
  return {
    type: "QUERY_TRADE_RECORDS",
    text: text
  };
}

function getQueryTradeRecords(data, callback, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/queryTradeRecords", data, function (data) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        if (data.code == "0000") {
          dispatch(QueryTradeRecords(data.content));
          callback(data.content);
          console.log(data.content, "操作记录明细");
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          //let toast = Toast.show(data.message, getToastConfPoint( ) );
        }
        // if(trJson.code === "0000"){
        //   dispatch(QueryTradeRecords(trJson.content));
        //   callback(trJson.content)
        // }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        console.log(error, "错误信息");
        //let toast = Toast.show("网络异常，请检查您的网络", getToastConfPoint( ) );
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
      //let toast = Toast.show(Util.errorTxt, getToastConfPoint( ) );
    });
  };
}

var trJson = { "code": "0000", "message": null, "content": [{ "applicationAmount": 1000.0, "businessState": "2090", "businessStateName": "成功", "businessTime": "2017-07-12 17:13:30", "businessType": "T522", "businessTypeName": "华夏智投银行卡申购", "fundCode": "SF1011", "fundName": "常青藤大学组合", "taConfirmStateName": "成功", "tradeAccountNo": "20000000629", "tradeRequestId": "4017071200146009" }, { "applicationAmount": 1000.0, "businessState": "2090", "businessStateName": "成功", "businessTime": "2017-07-12 17:12:44", "businessType": "T522", "businessTypeName": "华夏智投银行卡申购", "fundCode": "SF1011", "fundName": "常青藤大学组合", "taConfirmStateName": "成功", "tradeAccountNo": "20000000629", "tradeRequestId": "4017071200146008" }, { "applicationAmount": 998.96, "businessState": "2090", "businessStateName": "部分成功", "businessTime": "2017-07-12 15:32:17", "businessType": "T024", "businessTypeName": "赎回", "fundCode": "SF1005", "fundName": "锐意进取组合", "taConfirmStateName": "部分确认", "tradeAccountNo": "20000000629", "tradeRequestId": "4017071200145992" }, { "applicationAmount": 1000.0, "businessState": "2090", "businessStateName": "成功", "businessTime": "2017-07-10 08:45:28", "businessType": "T522", "businessTypeName": "华夏智投银行卡申购", "fundCode": "SF1005", "fundName": "锐意进取组合", "taConfirmStateName": "成功", "tradeAccountNo": "20000000629", "tradeRequestId": "4017071000143419" }, { "applicationAmount": 1000.0, "businessState": "2060", "businessStateName": "失败", "businessTime": "2017-07-06 14:57:37", "businessType": "T522", "businessTypeName": "华夏智投银行卡申购", "fundCode": "SF1006", "fundName": "60后智享财富组合", "taConfirmStateName": "失败", "tradeAccountNo": "20000000629", "tradeRequestId": "4017070600140073" }]

  /*历史收益列表*/
};var historyIncomeList = function historyIncomeList(text) {
  return {
    type: 'HISTORY_ICOME_LIST',
    text: text
  };
};
function getHistoryIcomeList(data, callback, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      var fundCode = data.fundCode;
      var url = "";
      if (__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.superFundCodeArr.indexOf(fundCode)) {
        url = __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/myAsset/superFundIncomeDetailQuery";
      } else if (fundCode === "SF1000") {
        data.fundCode = "";
        url = __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/myAsset/superFundIncomeDetailQuery";
      } else {
        url = __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/incomeDetailQuery";
      }
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(url, data, function (data) {
        if (data.code == "0000") {
          dispatch(historyIncomeList(data.content));
          console.log(true, data, "历史收益列表");
          callback(data.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, ToastTime);
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
        _this.setState({
          loadingFlag: false
        });
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
    });
  };
}

function getHistoryIcomeListSuper(data, callback, _this) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/superfund/myAsset/superFundIncomeDetailQuery", data, function (data) {

        if (data.code == "0000") {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          dispatch(historyIncomeList(data.content));
          console.log(data, "超级基金历史收益列表");
          callback(data.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, ToastTime);
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
        _this.setState({
          loadingFlag: false
        });
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
    });
  };
}

/*调仓记录*/
function HistoryAdjustAction(text) {
  return {
    type: "HISTORY_DETAIL",
    text: text
  };
}

function getHistoryAdjust(data, callBack, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/getHistoryAdjustDetail", data, function (result) {
        if (result.code == '0000') {
          dispatch(HistoryAdjustAction(result.content));
          callBack(result.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, ToastTime);
        }
      }, function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
/* 查询智投组合当前成分基金*/
function getCurrentAdjustDetail(data, callBack, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/superfund/getCurrentAdjustDetail", data, function (result) {
        if (result.code == '0000') {
          callBack(result.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}

//智投小常乐详情
function SuperFoundDetailXCL(text) {
  return {
    type: "SUPERFUND_DETAIL_XCL",
    text: text
  };
}
//小常乐详情配置详情 新
function getSuperFoundDetail(data) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/query/getSuperFoundDetail", { fundCode: data }, function (result) {
      if (result.code == '0000') {
        dispatch(SuperFoundDetailXCL(result.content.superFundDetail));
        // sucBack(result.content.superFundDetail)
      } else {}
      console.log(result, "小常乐详情接口");
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
      console.log(error);
    });
  };
}

/*获取所有交易基金的代码和名称*/
var historyFundCodeAndName = function historyFundCodeAndName(text) {
  return {
    type: 'HISTORY_FUNDCODE_NAME_LIST',
    text: text
  };
};
function getHistoryFundCodeAndName(data, _this, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/incomeFundCodeAndNameQueryRequest", data, function (data) {
        if (data.code == "0000") {
          var newData = data.content.filter(function (item) {
            return item.fundCode.startsWith('SF');
          });
          data.content = newData;
          dispatch(historyFundCodeAndName(newData));
          if (callback) {
            callback(data.content);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, ToastTime);
        }
      }, function (error) {
        if (callback) {
          callback(null);
        }
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
      });
    }).catch(function (err) {});
  };
}

/*获取历史交易确认列表*/
var historyTradeList = function historyTradeList(text) {
  return {
    type: 'HISTORY_TRADE_LIST',
    text: text
  };
};
function getHistoryTradeList(data, callback, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/tradeList", data, function (data) {
        if (data.code == "0000") {
          dispatch(historyTradeList(data.content));
          console.log(true, data, "获取历史交易确认列表");
          callback(data.content);
        } else {
          _this.setState({
            loadingFlag: false
          });
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, ToastTime);
        }
      }, function (error) {
        _this.setState({
          loadingFlag: false
        });
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
      });
    }).catch(function (err) {
      _this.setState({
        loadingFlag: false
      });
    });
  };
}

/*获取分红列表*/
var findDividendList = function findDividendList(text) {
  return {
    type: 'FIND_DIVIDEND_LIST',
    text: text
  };
};
function getHistoryFindDividend(data, callback, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/myAsset/findDividendHistory", data, function (data) {
        if (data.code == "0000") {
          dispatch(findDividendList(data.content));
          console.log(true, data, "获取分红列表");
          callback(data.content);
        } else {
          _this.setState({
            loadingFlag: false
          });
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, ToastTime);
        }
      }, function (error) {
        console.log(error);
        _this.setState({
          loadingFlag: false
        });
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, ToastTime);
      });
    }).catch(function (err) {
      _this.setState({
        loadingFlag: false
      });
    });
  };
}

//实名认证职业列表
function userJob(text) {
  return {
    type: "USER_JOB",
    text: text
  };
}
//实名认证城市列表
function provinceCity(text) {
  return {
    type: "PROVINCE_CITY",
    text: text
  };
}

//获取实名认证职业列表
function getUserJob() {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/account/getCareers", {}, function (data) {
        if (data.code == "0000") {
          dispatch(userJob(data.content));
          console.log("职业列表");
          console.log(data.content);
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
        console.log("错误信息" + err);
      });
    });
  };
}

//获取实名认证城市列表
function getProvinceCity(callback, errback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/account/getProvinceAndCity", {}, function (data) {
        if (data.code == "0000") {
          if (callback) {
            callback(data.content);
          }
          dispatch(provinceCity(data.content));
          console.log("城市列表");
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          if (errback) {
            errback();
          }
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        if (errback) {
          errback();
        }
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//银行卡类型
function bankType(text) {
  return {
    type: "BANK_TYPE",
    text: text
  };
}

//银行卡列表
function bankList(text) {
  return {
    type: "BANK_LIST",
    text: text
  };
}

//获取银行列表
function getBankList(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      var obj = {};
      obj.token = "";
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/realnameauth/getBankCardList", obj, function (data) {
        if (data.code == "0000") {
          dispatch(bankList(data));
          if (params != undefined) {
            for (var i = 0; i < data.content.length; i++) {
              if (params.content.bankCode == data.content[i].bankCode) {
                dispatch(bankType({ content: { cardName: data.content[i].paymentChannelName, bankCode: data.content[i].bankCode } }));
                break;
              } else {
                if (i == data.content.length - 1) {
                  dispatch(bankType({ content: {
                      cardName: null,
                      bankCode: null
                    } }));
                  break;
                }
              }
            }
          }
          console.log("银行列表");
          console.log(data);
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//获取卡类型
function getBankType(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      params.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/realnameauth/getBankName", params, function (data) {
        if (data.code == "0000") {
          if (data.content.bankCode == "" || data.content.bankCode == null) {
            dispatch(bankType({ content: { cardName: null, bankCode: null } }));
          } else {
            dispatch(getBankList(data));
          }
          console.log("卡类型");
          console.log(data);
        } else {
          dispatch(bankType({ content: { cardName: null, bankCode: null } }));
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//获取流水号
function checkNumber(text) {
  return {
    type: "CHECK_NUMBER",
    text: text
  };
}

function dianji(text) {
  return {
    type: "DIANJI",
    text: text
  };
}
//鉴权确认
function checkSuccessData(text) {
  return {
    type: "CHECK_SUCCESS_DATA",
    text: text
  };
}

//鉴权申请
function getCheckNumber(params, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.postNew(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/bankCard/bankCardAuthApply?token=" + token, params, function (data) {
        if (data.code == "0000") {
          dispatch(checkNumber(data));
          console.log("鉴权申请");
          console.log(data);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, 2);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          errBack();
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        errBack();
      });
    });
  };
}

//鉴权确认
function getCheckSuccessData(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      params.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/realnameauth/authConfirm", params, function (data) {
        if (data.code == "0000") {
          dispatch(checkSuccessData(data));
          console.log("鉴权确认");
          console.log(data);
          callBack();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

/*所有的国家列表*/
var AllCountry = function AllCountry(text) {
  return {
    type: 'ALL_COUNTRY',
    text: text
  };
};

function getAllCountry(callback, _this) {
  return function (dispatch, getState) {
    var data = {};
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/account/getAllCountry", data, function (data) {
      if (data.code == "0000") {
        dispatch(AllCountry(data.content));
        callback(data.content);
      } else {}
    }, function (error) {});
  };
}

//实名认证创建交易账号
function certifcationSuccess(text) {
  return {
    type: "CERTIFCATION_SUCCESS",
    text: text
  };
}
//实名认证创建交易账号
function getCertifcationSuccess(thisO, data, callBack, savePicFun) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null || token == "9999") {
        token = "";
      }
      console.log(data, "转入的参数");
      data.token = token;
      data.clientType = __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.return_Clinet_Type();
      var allParams = data;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/realnameauth/realNameAuth", data, function (data) {
        if (data.code == "0000") {
          var TM = new Date();
          if (savePicFun) {
            savePicFun(data.content.shortToken, allParams);
          }
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('currentUserInfo', data.content);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-shortToken', data.content.shortToken);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-longToken', data.content.longToken);
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '2');
          dispatch(certifcationSuccess(data));
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["b" /* getUserInfoList */])());
          console.log(data, "实名认证成功回调");
          if (callBack) {
            callBack();
          }
          console.log("实名认证创建交易账号");
          console.log(data);
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, ToastTime);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('网络异常，请检查您的网络', ToastTime);
      });
    });
  };
}

//按照证件类型登录
var loginHXAssets = function loginHXAssets(loginParam, succallback, errcallback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    var successCallback = function () {
      var _ref12 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(succ) {
        var TM, userInfo, user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
                console.log(succ);

                if (!(succ && succ.code === '0000')) {
                  _context12.next = 20;
                  break;
                }

                TM = new Date();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
                userInfo = succ.content;

                userInfo.isRealName = succ.content.tradeAccountNo ? true : false;
                if (succ.content.name != undefined) userInfo = mergeObjectEasy(userInfo, { name: succ.content.name });
                if (succ.content.nickName != undefined) userInfo = mergeObjectEasy(userInfo, { nickName: succ.content.nickName });
                if (succ.content.tradeAccountNo != undefined) userInfo = mergeObjectEasy(userInfo, { tradeAccountNo: succ.content.tradeAccountNo });
                console.log('华夏财富userInfo1', userInfo);
                _context12.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('userList-' + userInfo.userId);

              case 14:
                user = _context12.sent;

                if (user != 9999) {
                  userInfo = mergeObjectEasy(user, userInfo);
                }
                console.log('华夏财富userInfo2', userInfo);
                if (succ.content.hasCwimAccount == true) {
                  if (succ.content.tradeAccountNo) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '2');
                  } else {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '1');
                  }
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["a" /* isLogin */])(true));
                  //   // dispatch(isRealName(userInfo.isRealName));
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["b" /* getUserInfoList */])(function () {
                    succallback(succ.content);
                  }));
                } else {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginState', '3');
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                  dispatch(syncAccountName(succ.content.name));
                  dispatch(syncAccountLoginType(succ.content.certType));
                  dispatch(syncAccountLoginNo(succ.content.certNo));
                  succallback(succ.content);
                }
                _context12.next = 22;
                break;

              case 20:
                console.log('后台返回数据有误!');
                errcallback(succ.message);

              case 22:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, _this2);
      }));

      return function successCallback(_x23) {
        return _ref12.apply(this, arguments);
      };
    }();
    var errorCallback = function errorCallback(err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();

      console.log(err);
      // errcallback(Util.errorTxt);
    };

    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/certLogin', loginParam, successCallback, errorCallback);
  };
};

/*智投重构交易记录列表*/ //包含了分红详情的数据
function ztcgjiaoyijilu(data, callbackData, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/tradeRecord/getTradeRecordList", data, function (result) {
        if (result.content == null) {} else {
          callbackData(result.content);
        }
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      });
    }).catch(function (err) {
      if (_this) {
        _this.setState({
          loadingFlag: false
        });
      }
    });
  };
}

/*智投重构交易记录详情*/ //不包含分红详情的数据
function ztcgjiaoyijiluxiangqing(data, callbackData, _this) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/tradeRecord/getTradeRecordDetail", data, function (result) {
        if (result.content == null) {} else {
          if (result && result.content) {
            callbackData(result.content.superFundTradeRecordDetails, result.content.cancel);
          } else {
            callbackData([], result.content.cancel);
          }
        }
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      });
    }).catch(function (err) {
      if (_this) {
        _this.setState({
          loadingFlag: false
        });
      }
    });
  };
}

/*智投重构交易记录服务费*/
function ztcgfuwufei(data, callbackData, _this) {
  return function (dispatch, getState) {
    //dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/tradeRecord/getSuperFundUserManageFee", data, function (result) {
        if (result.content == null) {} else {
          callbackData(result.content);
        }
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      });
    }).catch(function (err) {
      if (_this) {
        _this.setState({
          loadingFlag: false
        });
      }
    });
  };
}

/*智投重构交易记录服务费明细*/
function ztcgfuwufeimingxi(data, callbackData, _this) {
  return function (dispatch, getState) {
    //dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/tradeRecord/getSuperFundUserManageFeeDetail", data, function (result) {
        if (result.content == null) {} else {
          callbackData(result.content);
        }
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      }, function (error) {
        if (_this) {
          _this.setState({
            loadingFlag: false
          });
        }
      });
    }).catch(function (err) {
      if (_this) {
        _this.setState({
          loadingFlag: false
        });
      }
    });
  };
}

//养老教育储备金
function yljycbMoney(text) {
  return {
    type: "YLJYCB_MONEY",
    text: text
  };
}
//预期养老教育金
function yqyljyMoney(text) {
  return {
    type: "YQYLJY_MONEY",
    text: text
  };
}
//养老教育年龄
function yljyAge(text) {
  return {
    type: "YLJY_AGE",
    text: text
  };
}
//养老退休年龄
function ylOutAge(text) {
  return {
    type: "YL_OUTAGE",
    text: text
  };
}
//预期养老教育金2
function yqyljySliderVal(text) {
  return {
    type: "YQYLJY_SLIDER_VAL",
    text: text
  };
}
//养老教育投资方案
function yljyPlan(text) {
  return {
    type: "YLJY_PLAN",
    text: text
  };
}
//养老教育指数
function yljyNum(text) {
  return {
    type: "YLJY_NUM",
    text: text
  };
}
//养老教育投入金额
function yljyAllMoney(text) {
  return {
    type: "YLJY_ALL_MONEY",
    text: text
  };
}
//养老教育金额图表
function yljyLineData(text) {
  return {
    type: "YLJY_LINE_DATA",
    text: text
  };
}
//教育学校类型
function jySchoolType(text) {
  return {
    type: "JY_SCHOOL_TYPE",
    text: text
  };
}
//初始化养老第一页数据
function clearYlOne() {
  return function (dispatch, getState) {
    dispatch(yljycbMoney("0"));
    dispatch(yqyljyMoney(5000));
    dispatch(yqyljySliderVal(5000));
    dispatch(yljyAge("35"));
    dispatch(ylOutAge("65"));
  };
}
//初始化教育第一页数据
function clearJyOne(school) {
  return function (dispatch, getState) {
    if (school == "初中") {
      dispatch(yljycbMoney("0"));
      // dispatch(yqyljyMoney(20000));
      // dispatch(yqyljySliderVal(20000));
      dispatch(yljyAge([5]));
    } else if (school == "高中") {
      dispatch(yljycbMoney("0"));
      // dispatch(yqyljyMoney(20000));
      // dispatch(yqyljySliderVal(20000));
      dispatch(yljyAge([6]));
    } else if (school == "大学") {
      dispatch(yljycbMoney("0"));
      // dispatch(yqyljyMoney(20000));
      // dispatch(yqyljySliderVal(20000));
      dispatch(yljyAge([8]));
    }
    dispatch(jySchoolType("国内院校"));
    dispatch(yqyljyMoney(20000));
    dispatch(yqyljySliderVal(20000));
  };
}
//初始化养老教育计划页数据
function clearYlJyEnd() {
  return function (dispatch, getState) {
    dispatch(yljyPlan("每月投资方案"));
    dispatch(yljyNum(["沪深300，年化8%"]));
    dispatch(yljyAllMoney(null));
    dispatch(yljyLineData(null));
  };
}

//实名认证持卡人
function smrzCardPerson(text) {
  return {
    type: "SMRZ_CARD_PERSON",
    text: text
  };
}
//实名认证身份证号
function smrzPersonNumber(text) {
  return {
    type: "SMRZ_PERSON_NUMBER",
    text: text
  };
}
//实名认证地址
function smrzAddress(text) {
  return {
    type: "SMRZ_ADDRESS",
    text: text
  };
}
//实名认证控制人地址
function smrzkzrAddress(text) {
  return {
    type: "SMRZ_KZRADDRESS",
    text: text
  };
}
//实名认证受益人地址
function smrzsyrAddress(text) {
  return {
    type: "SMRZ_SYRADDRESS",
    text: text
  };
}
//实名认证控制人邮政编码
function smrzkzrBianma(text) {
  return {
    type: "SMRZ_KZRBIANMA",
    text: text
  };
}
//实名认证受益人邮政编码
function smrzsyrBianma(text) {
  return {
    type: "SMRZ_SYRBIANMA",
    text: text
  };
}

//实名认证控制人电子邮箱
function smrzkzrYoux(text) {
  return {
    type: "SMRZ_KZRYOUX",
    text: text
  };
}
//实名认证受益人电子邮箱
function smrzsyrYoux(text) {
  return {
    type: "SMRZ_SYRYOUX",
    text: text
  };
}
//实名认证职业
function smrzJob(text) {
  return {
    type: "SMRZ_JOB",
    text: text
  };
}
//实名认证控制人职业
function smrzkzrJob(text) {
  return {
    type: "SMRZ_KZRJOB",
    text: text
  };
}
//实名认证受益人职业
function smrzsyrJob(text) {
  return {
    type: "SMRZ_SYRJOB",
    text: text
  };
}
//实名认证职业代码
function smrzCareerCode(text) {
  return {
    type: "SMRZ_CAREERCODE",
    text: text
  };
}
//实名认证控制人职业代码
function smrzCareerkzrCode(text) {
  return {
    type: "SMRZ_CAREERKZRCODE",
    text: text
  };
}
//实名认证受益人职业代码
function smrzCareersyrCode(text) {
  return {
    type: "SMRZ_CAREERSYRCODE",
    text: text
  };
}
//实名认证年收入
function smrznsrcode(text) {
  return {
    type: "SMRZ_NSRCODE",
    text: text
  };
}
//实名认证具体年收入
function smrznJtsrcode(text) {
  return {
    type: "SMRZ_JTNSRCODE",
    text: text
  };
}
//实名认证城市
function smrzCity(text) {
  return {
    type: "SMRZ_CITY",
    text: text
  };
}
//实名认控制人城市
function smrzkzrCityc(text) {
  return {
    type: "SMRZ_KZRCITY",
    text: text
  };
}
//实名认受益人城市
function smrzsyrCityc(text) {
  return {
    type: "SMRZ_SYRCITY",
    text: text
  };
}
//实名认证控制人
function smrzBeneficontro(text) {
  return {
    type: "SMRZ_BENEFCONTRO",
    text: text
  };
}
//实名认证受益人
function smrzBeneficiaries(text) {
  return {
    type: "SMRZ_BENEFICIARIES",
    text: text
  };
}
//实名认证控制人姓名
function smrzBeneficontroName(text) {
  return {
    type: "SMRZ_BENEFCONTRO_NAME",
    text: text
  };
}
//实名认证控制人证件有效期
function smrzBeneficontroZjyxq(text) {
  return {
    type: "SMRZ_BENEFCONTRO_ZJYXQ",
    text: text
  };
}
//实名认证主账户证件有效期
function zzhZjyxq(text) {
  return {
    type: "ZZH_ZJYXQ",
    text: text
  };
}
//实名认证受益人证件有效期
function smrzBeneficiariesZjyxq(text) {
  return {
    type: "SMRZ_BENEFICIARIES_ZJYXQ",
    text: text
  };
}
//实名认证控制人证件照片
function smrzBeneficontroZjzq(text) {
  return {
    type: "SMRZ_BENEFCONTRO_ZJZQ",
    text: text
  };
}
//实名认证受益人证件照片
function smrzBeneficiariesZjzq(text) {
  return {
    type: "SMRZ_BENEFICIARIES_ZJZQ",
    text: text
  };
}
//实名认证控制人性别
function smrzkzrXbcode(text) {
  return {
    type: "SMRZ_BENEFCONTRO_XBCODE",
    text: text
  };
}
//实名认证控受益人性别
function smrzsyrXbcode(text) {
  return {
    type: "SMRZ_BENEFICIARIES_XBCODE",
    text: text
  };
}
//实名认证控制人出生日期
function smrzBeneficontroCsrq(text) {
  return {
    type: "SMRZ_BENEFICIARIES_CSRQ",
    text: text
  };
}
//实名认证受益人出生日期
function smrzBeneficiariesCsrq(text) {
  return {
    type: "SMRZ_BENEFCONTRO_CSRQ",
    text: text
  };
}
//实名认证控制人手机号
function smrzBeneficontroKzrNo(text) {
  return {
    type: "SMRZ_BENEFCONTRO_KZRNO",
    text: text
  };
}
//实名认证受益人手机号
function smrzBeneficontroSyrNo(text) {
  return {
    type: "SMRZ_BENEFICIARIES_SYRNO",
    text: text
  };
}
//实名认证受益人姓名
function smrzBeneficiariesName(text) {
  return {
    type: "SMRZ_BENEFICIARIES_NAME",
    text: text
  };
}
//实名认证回调
function huiDiao(text) {
  return {
    type: "HUIDIAO",
    text: text
  };
}
//实名认证控制人证件类型
function smrzBeneficontroType(text) {
  return {
    type: "SMRZ_BENEFCONTRO_TYPE",
    text: text
  };
}
//实名认证受益人证件类型
function smrzBeneficiariesType(text) {
  return {
    type: "SMRZ_BENEFICIARIES_TYPE",
    text: text
  };
}
//实名认证控制人证件号
function smrzBeneficontroNo(text) {
  return {
    type: "SMRZ_BENEFCONTRO_NO",
    text: text
  };
}
//实名认证受益人证件号
function smrzBeneficiariesNo(text) {
  return {
    type: "SMRZ_BENEFICIARIES_NO",
    text: text
  };
}
//实名认证组织
function smrzGjzz(text) {
  return {
    type: "SMRZ_GJZZ",
    text: text
  };
}
//实名认证银行卡号
function smrzCardNumber(text) {
  return {
    type: "SMRZ_CARD_NUMBER",
    text: text
  };
}
//实名认证修改手机号
function smrzUpdatePhoneNo(text) {
  return {
    type: "SMRZ_UPDATE_PHONE_NO",
    text: text
  };
}
//实名认证同意项
function smrzAgreeItemFlag(text) {
  return {
    type: "SMRZ_AGREE_ITEM_FLAG",
    text: text
  };
}
//实名认证验证码
function smrzCheckCard(text) {
  return {
    type: "SMRZ_CHECK_CARD",
    text: text
  };
}
//实名认获取证验证码显示文字
function smrzCheckCardText(text) {
  return {
    type: "SMRZ_CHECK_CARD_TEXT",
    text: text
  };
}
//实名认证验证码状态
function smrzCheckCardFlag(text) {
  return {
    type: "SMRZ_CHECK_CARD_FLAG",
    text: text
  };
}
//实名认证交易密码
function smrzPassWord(text) {
  return {
    type: "SMRZ_PASS_WORD",
    text: text
  };
}
//实名认证确认交易密码
function smrzPassWordAgain(text) {
  return {
    type: "SMRZ_PASS_WORD_AGAIN",
    text: text
  };
}
//初始化实名认证交易密码
function clearSmrzPassWord() {
  return function (dispatch, getState) {
    dispatch(smrzPassWord(""));
    dispatch(smrzPassWordAgain(""));
  };
}
//初始化实名认证获取验证码页
function clearSmrzCheckCard() {
  return function (dispatch, getState) {
    dispatch(smrzCheckCard(""));
    dispatch(smrzCheckCardText("获取验证码"));
    dispatch(smrzCheckCardFlag(false));
  };
}
//初始化实名认证填卡页
function clearSmrzThird(num) {
  return function (dispatch, getState) {
    dispatch(smrzUpdatePhoneNo(num));
    dispatch(smrzAgreeItemFlag(false));
  };
}
//初始化实名认证第一页
function clearSmrzOne() {
  return function (dispatch, getState) {
    dispatch(smrzCardPerson(""));
    dispatch(smrzPersonNumber(""));
    dispatch(smrzAddress(""));
    dispatch(smrzkzrAddress(""));
    dispatch(smrzsyrAddress(""));
    dispatch(smrzkzrBianma(""));
    dispatch(smrzsyrBianma(""));
    dispatch(smrzkzrYoux(""));
    dispatch(smrzsyrYoux(""));
    dispatch(smrzJob([""]));
    dispatch(smrzkzrJob([""]));
    dispatch(smrzsyrJob([""]));
    dispatch(smrzCareerCode(""));
    dispatch(smrzCareerkzrCode(""));
    dispatch(smrzCareersyrCode(""));
    dispatch(smrznJtsrcode(""));
    dispatch(smrznsrcode(""));
    dispatch(smrzCity(["11", "1101"]));
    dispatch(smrzkzrCityc(["11", "1101"]));
    dispatch(smrzsyrCityc(["11", "1101"]));
    dispatch(smrzBeneficiaries(["本人"]));
    dispatch(smrzBeneficiariesName(""));
    dispatch(smrzBeneficiariesType([""]));
    dispatch(smrzBeneficiariesNo(""));
    dispatch(smrzBeneficontro(["本人"]));
    dispatch(smrzBeneficontroName(""));
    dispatch(smrzBeneficontroZjyxq(""));
    dispatch(zzhZjyxq(""));
    dispatch(smrzBeneficiariesZjyxq(""));
    dispatch(smrzBeneficontroZjzq(""));
    dispatch(smrzBeneficiariesZjzq(""));
    dispatch(smrzkzrXbcode(""));
    dispatch(smrzsyrXbcode(""));
    dispatch(smrzBeneficontroCsrq(""));
    dispatch(smrzBeneficiariesCsrq(""));
    dispatch(smrzBeneficontroKzrNo(""));
    dispatch(smrzBeneficontroSyrNo(""));
    dispatch(smrzBeneficontroType([""]));
    dispatch(smrzBeneficontroNo(""));
    dispatch(smrzGjzz(["否"]));
  };
}
//智投规划状态
function isExpiredByInvestment(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      params.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/kyc/isExpired", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          callBack(data);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.message);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//获取规划题目
function getEfficientQuestionnaire(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      params.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/kyc/getEfficientQuestionnaire", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          callBack(data);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.message);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//保存题目
function addUserAnswerByZt(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.postNew(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/kyc/addUserAnswer?token=" + token, params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          callBack(data);
        } else {
          console.log(data.message);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

// 证通鉴权
function ZTbool(params, _this, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/certificate/valid/ztValid", params, function (res) {
      if (res.code == "0000") {
        callback(res.content);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(res.message, 2);
      }
    }, function (error) {
      console.log(error);
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + error, 2);
    });
  };
}

//根据规划返回产品
function getRcommendStrategy(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      params.token = token;
      __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/kyc/getRcommendStrategy", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          //管家过滤部分产品&重新计算匹配
          if (navigator.userAgent.toLowerCase() && navigator.userAgent.toLowerCase().indexOf("amcfmapp") != -1) {
            if (data && data.content && data.content.allStrategyList && data.content.allStrategyList.length > 0) {
              data.content.allStrategyList = [].concat(matchFundFunByGJOther(data.content.allStrategyList));
            }
            if (data && data.content && data.content.partMateStrategyList && data.content.partMateStrategyList.length > 0) {
              data.content.partMateStrategyList = [].concat(matchFundFunByGJOther(data.content.partMateStrategyList));
            }
            if (data && data.content && data.content.allStrategyList && data.content.partMateStrategyList) {
              data.content.mateAll = matchArrByAllArrOther(data.content.allStrategyList, data.content.partMateStrategyList);
            }
          }
          callBack(data);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.message);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//不规划直接查看产品
function getSuperFundSeriesFun(params, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token === null || token === "" || token === undefined) {
        console.log("token为空");
      } else {
        params.token = token;
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/v1/superfund/superFundSeries/list", params, function (data) {
          if (data.code == "0000") {
            console.log(data);
            //管家过滤部分产品&重新计算匹配
            if (navigator.userAgent.toLowerCase() && navigator.userAgent.toLowerCase().indexOf("amcfmapp") != -1) {
              if (data && data.content && data.content.allSuperFundSeries && data.content.allSuperFundSeries.length > 0) {
                data.content.allSuperFundSeries = [].concat(matchFundFunByGJAll(data.content.allSuperFundSeries));
              }
              if (data && data.content && data.content.riskMatchSuperFundSeries && data.content.riskMatchSuperFundSeries.length > 0) {
                data.content.riskMatchSuperFundSeries = [].concat(matchFundFunByGJAll(data.content.riskMatchSuperFundSeries));
              }
              if (data && data.content && data.content.allSuperFundSeries && data.content.riskMatchSuperFundSeries) {
                data.content.mateAll = matchArrByAllArrAll(data.content.allSuperFundSeries, data.content.riskMatchSuperFundSeries);
              }
            }
            callBack(data);
            __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          } else {
            console.log(data.message);
            __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
            __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(data.message, 2);
          }
        }, function (err) {
          console.log("错误信息" + err);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
        });
      }
    });
  };
}

var matchArrByAllArrAll = function matchArrByAllArrAll(allList, otherList) {
  if (allList.length == otherList.length) {
    if (allList.length == 0) {
      return true;
    } else {
      var count = 0;
      for (var i = 0; i < allList.length; i++) {
        for (var s = 0; s < otherList.length; s++) {
          if (allList[i].seriesId === otherList[s].seriesId && allList[i].superFundList.length == otherList[s].superFundList.length) {
            count++;
          }
        }
      }
      if (count == allList.length) {
        return true;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
};

var matchArrByAllArrOther = function matchArrByAllArrOther(allList, otherList) {
  if (allList.length == otherList.length) {
    if (allList.length == 0) {
      return true;
    } else {
      var count = 0;
      for (var i = 0; i < allList.length; i++) {
        for (var s = 0; s < otherList.length; s++) {
          if (allList[i].sceneId === otherList[s].sceneId && allList[i].superFundProductViewList.length == otherList[s].superFundProductViewList.length) {
            count++;
          }
        }
      }
      if (count == allList.length) {
        return true;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
};

var matchFundFunByGJAll = function matchFundFunByGJAll(arrList) {
  var newArrList = [];
  for (var i = 0; i < arrList.length; i++) {
    var theArr = [].concat(matchFundFunByGJPub(arrList[i].superFundList));
    if (theArr.length > 0) {
      arrList[i].superFundList = [].concat(theArr);
      newArrList.push(arrList[i]);
    }
  }
  return newArrList;
};

var matchFundFunByGJOther = function matchFundFunByGJOther(arrList) {
  var newArrList = [];
  for (var i = 0; i < arrList.length; i++) {
    var theArr = [].concat(matchFundFunByGJPub(arrList[i].superFundProductViewList));
    if (theArr.length > 0) {
      arrList[i].superFundProductViewList = [].concat(theArr);
      newArrList.push(arrList[i]);
    }
  }
  return newArrList;
};

var matchFundFunByGJPub = function matchFundFunByGJPub(allList) {
  var newAllList = [];
  for (var i = 0; i < allList.length; i++) {
    if (__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.kycFundListByGJ.indexOf(allList[i].superFundCode) != -1) {
      newAllList.push(allList[i]);
    }
  }
  return newAllList;
};

//智投交易撤单
function superfundCancelFun(data, sucCallBack, errback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(validateTransactionPassword(data, function (c) {
        if (!c) {
          errback();__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + "/api/trade/doWithdraw", data, function (result) {
          console.log(result);
          if (result.code == '0000') {
            sucCallBack(1, result);
          } else {
            sucCallBack(3, result.message);
            __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
          }
        }, function (error) {
          sucCallBack(3, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
        });
      }, function (m) {
        sucCallBack(3, m);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      console.log(err);
      errback();
    });
  };
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(858);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(857);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(279);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(279);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(442);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setStorage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return goHome; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getStorage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTempInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mergeObjectEasy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return syncAddUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fundDetailFun; });
/* unused harmony export allMonetaryCode */
/* unused harmony export isAllMonetaryCode */
/* unused harmony export isRate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return superFundCodeFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return traceSaveParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getToastConfPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ClassfundFun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return onMiniProgramDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReduxStore_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_loginAction__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_guidePage__ = __webpack_require__(59);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// import Storage from './Storage';







window.tokenTimeLong = 15 * 60 * 1000;
window.tokenTimeshort = 10 * 60 * 1000;
var fetchTimeout = 30;
/*
  &改写fetch，加入超时机制
*/
var oldFetch = fetch;
window.fetch = function (input, opts) {
  var fetchPromise = oldFetch(input, opts);
  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new Error("fetch timeout"));
    }, opts && opts.timeout ? opts.timeout * 1000 : fetchTimeout * 1000);
  });
  return Promise.race([fetchPromise, timeoutPromise]);
};
var ua = navigator.userAgent.toLowerCase();

// var storage = new Storage({
//   // 最大容量，默认值1000条数据循环存储
//   size: 1000,
//   // 存储引擎：对于RN使用AsyncStorage，对于web使用window.localStorage
//   // 如果不指定则数据只会保存在内存中，重启后即丢失

//   // 数据过期时间，默认一整天（1000 * 3600 * 24 毫秒），设为null则永不过期
//   //defaultExpires: 1000 * 3600 * 24,
//   defaultExpires: null,
//   // 读写时在内存中缓存数据。默认启用。
//   enableCache: true,
//   // 如果storage中没有相应数据，或数据已过期，
//   // 则会调用相应的sync方法，无缝返回最新数据。
//   // sync方法的具体说明会在后文提到
//   // 你可以在构造函数这里就写好sync的方法
//   // 或是写到另一个文件里，这里require引入
//   // 或是在任何时候，直接对storage.sync进行赋值修改
//   sync: {}
// })

// global.storage = storage;
//i为时间 如果没有传入i则为用不过期
function setStorage(keyId, data, i) {
  // if(i == undefined){
  //   i = null
  // }
  // let key = keyId;
  // let id = undefined;
  // if(keyId.indexOf('-') != -1){
  //   let parts = keyId.split('-');
  //   key = parts[0];
  //   id = parts[1];
  // }
  // storage.save({
  //     key: key, 
  //     data: data,
  //     expires: i,
  //     id: id
  //   });
  if (Object.prototype.toString.call(data) !== "[object Null]") {
    localStorage.setItem(keyId, JSON.stringify(data));
  } else {
    localStorage.setItem(keyId, data);
  }
}

var goHome = function goHome(enterType) {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("amcfmapp") > -1) {
    if (ua.indexOf("wkwebview") > -1) {
      if (window.webkit) {
        window.webkit.messageHandlers.amcfm_utils.postMessage({ "refreshHome": "intelInvest" });
        window.webkit.messageHandlers.amcfm_utils.postMessage({ "finish": "" });
      }
    } else {
      if (window.amcfm_utils) {
        window.amcfm_utils.refreshHome('intelInvest');
        window.amcfm_utils.finish();
      }
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(1 - window.historyData.length);
    if (sessionStorage.app_index.split(',')[0] != "#/") {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].replace({
          pathname: '/' + (enterType ? '?enterType=' + enterType : '')
        });
      }, 300);
    }
  }
};
//Token会通过回调函数返回。
function getStorage(keyId, callback) {
  var key = keyId;
  var id = undefined;
  if (keyId.indexOf('-') != -1) {
    var parts = keyId.split('-');
    key = parts[0];
    id = parts[1];
  }
  if (!callback) return new Promise(function (resolev, reject) {
    var ret = localStorage.getItem(keyId);
    var a = new Date();
    //登录超时不在app生效
    if (keyId == 'loginState' && ua.indexOf("amcfmapp") == -1) {
      if (JSON.parse(localStorage.getItem('tokenTimeLong')) < a.getTime()) {
        // window.localStorage.removeItem('currentUserInfo');
        // window.localStorage.removeItem('loginInfo-longToken');
        // window.localStorage.removeItem('loginInfo-shortToken');
        // window.localStorage.removeItem('loginState');
        window.clearLocalStorage();
        __WEBPACK_IMPORTED_MODULE_4__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction__["a" /* isLogin */])(false));
        resolev('0');
        return;
      } //当前时间是否超过长token有效期，超过时间清空缓存 刷新 页面
    }
    if (keyId == 'loginInfo-shortToken') {
      //如果在管家打开 判断短token是否过期  不是管家打开判断长token是否过期
      if (ua.indexOf("amcfmapp") > -1) {
        if (JSON.parse(localStorage.getItem('tokenTimeshort')) > a.getTime()) {
          if (ret) {
            resolev(JSON.parse(ret));
            return;
          }
        }
      } else {
        if (JSON.parse(localStorage.getItem('tokenTimeshort')) > a.getTime()) {
          __WEBPACK_IMPORTED_MODULE_4__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction__["a" /* isLogin */])(true));
          if (ret) {
            resolev(JSON.parse(ret));
            return;
          }
        } else {
          if (JSON.parse(localStorage.getItem('tokenTimeLong')) != null && JSON.parse(localStorage.getItem('tokenTimeLong')) < a.getTime()) {
            // window.localStorage.clear();
            window.clearLocalStorage();
            document.location.href = 'index.html';
            reject(new Error(key + 'is expired' + ' 过期'));
          }
        }
      }
      var url = __WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/account/getShortTokenByLong";
      var longToken = JSON.parse(localStorage.getItem('loginInfo-longToken'));
      if (longToken == null) {
        reject(new Error(key + 'is expired' + ' longTOken丢失'));
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(url, { longToken: longToken }, function (dataToken) {
        console.log('换token');
        if (dataToken.code === '0000') {
          setStorage('loginInfo-shortToken', dataToken.content.token);
          setStorage('tokenTimeshort', a.getTime() + window.tokenTimeshort);
          setStorage('tokenTimeLong', a.getTime() + window.tokenTimeLong);
          resolev(dataToken.content.token);
        } else {
          reject(new Error(key + ' is expired' + ' 服务器没有返回新token'));
        }
      }, function (err) {
        reject(new Error(key + ' is expired' + ' 请检查当前网络'));
      });
      return;
    };
    if (ret) {
      resolev(JSON.parse(ret));
    } else {
      resolev(9999);
    }
    //   storage.load({
    //   key: key,
    //   id: id,
    //   // autoSync(默认为true)意味着在没有找到数据或数据过期时自动调用相应的sync方法
    //   autoSync: true,
    //   // syncInBackground(默认为true)意味着如果数据过期，
    //   // 在调用sync方法的同时先返回已经过期的数据。
    //   // 设置为false的话，则始终强制返回sync方法提供的最新数据(当然会需要更多等待时间)。
    //   syncInBackground: true,
    //   // 你还可以给sync方法传递额外的参数
    //   syncParams: {
    //     extraFetchOptions: {
    //       // 各种参数
    //     },
    //     someFlag: true,
    //   },
    //   }).then(ret => {
    //     // 如果找到数据，则在then方法中返回
    //     // 注意：这是异步返回的结果（不了解异步请自行搜索学习）
    //     // 你只能在then这个方法内继续处理ret数据
    //     // 而不能在then以外处理
    //     // 也没有办法“变成”同步返回
    //     // 你也可以使用“看似”同步的async/await语法
    //     resolev(ret);
    //     //this.setState({ user: ret });
    //   }).catch(async err => {
    //     //如果没有找到数据且没有sync方法，
    //     //或者有其他异常，则在catch中返回
    //   //console.warn(err.message,"***********");
    //   console.log(err.message,"***********");

    //   console.log(err.name);

    //   switch (err.name) {
    //       case 'NotFoundError':
    //         reject(new Error('Not found ' + key));
    //         // TODO;
    //         break;
    //       case 'ExpiredError':
    //           // TODO
    //         if(key == 'loginInfo' && id == 'shortToken'){
    //           let url = urlAllBase + "/api/account/getShortTokenByLong";
    //           let longToken=''
    //           if(longToken == ''){
    //             reject(new Error(key + 'is expired' + ' longTOken丢失'));
    //           }
    //           Util.get(url, { longToken }, (dataToken)=>{
    //             if(dataToken.code === '0000'){
    //               setStorage('loginInfo-shortToken', dataToken.content.token, tokenTime);
    //               resolev(dataToken.content.token);
    //             }else{
    //               console.log(dataToken.message);
    //               reject(new Error(key + ' is expired' + ' 服务器没有返回新token'));
    //             }
    //           }, (err)=>{
    //             console.log(err);
    //             console.log('没有取到short');
    //             reject(new Error(key + ' is expired' + ' 请检查当前网络'));
    //           });
    //           break;
    //         }
    //         reject(new Error(key + ' is expired'));

    //           // setTimeout(function(){
    //           //   storage.save({
    //           //     key: "syncFunction",  // "loginState" 注意:请不要在key中使用_下划线符号!
    //           //     rawData:"新的短Token",//{ from: 'some other site',userid: 'some userid',token: 'some token'},
    //           //     // 如果不指定过期时间，则会使用defaultExpires参数
    //           //     // 如果设为null，则永不过期
    //           //     expires: 1000*3
    //           //   });
    //           //   callback("新的短Token")
    //           // },1)
    //           break;
    //       default:
    //           reject(new Error('Not found ' + key));
    //   }
    // })
  });
  // storage.load({
  //   key: key,
  //   id: id,
  //   // autoSync(默认为true)意味着在没有找到数据或数据过期时自动调用相应的sync方法
  //   autoSync: true,
  //   // syncInBackground(默认为true)意味着如果数据过期，
  //   // 在调用sync方法的同时先返回已经过期的数据。
  //   // 设置为false的话，则始终强制返回sync方法提供的最新数据(当然会需要更多等待时间)。
  //   syncInBackground: true,
  //   // 你还可以给sync方法传递额外的参数
  //   syncParams: {
  //     extraFetchOptions: {
  //       // 各种参数
  //     },
  //     someFlag: true,
  //   },
  //   }).then(ret => {
  //     // 如果找到数据，则在then方法中返回
  //     // 注意：这是异步返回的结果（不了解异步请自行搜索学习）
  //     // 你只能在then这个方法内继续处理ret数据
  //     // 而不能在then以外处理
  //     // 也没有办法“变成”同步返回
  //     // 你也可以使用“看似”同步的async/await语法
  //     callback(ret)
  //     //this.setState({ user: ret });
  //   }).catch(async err => {
  //     //如果没有找到数据且没有sync方法，
  //     //或者有其他异常，则在catch中返回
  //   //console.warn(err.message,"***********");
  //   console.log(err.message,"***********");
  //   console.log(err.name)
  //   switch (err.name) {
  //       case 'NotFoundError':
  //         callback(null)
  //         // TODO;
  //         break;
  //       case 'ExpiredError':
  //           // TODO
  //           if(id != 'shortToken' || key != 'loginInfo'){
  //             callback(null);
  //             break;
  //           }
  //           let url = urlAllBase + "/api/account/getShortTokenByLong";
  //           let longToken = await getTempInfo('longToken');
  //           if(longToken == ''){
  //             callback(null);
  //             break;
  //           }
  //           Util.get(url, { longToken }, (dataToken)=>{
  //             if(dataToken.code === '0000'){
  //               setStorage('loginInfo-shortToken', dataToken.content.token, tokenTime);
  //               callback(dataToken.content.token);
  //             }else{
  //               console.log(dataToken.message);
  //               callback(null);
  //             }
  //           }, (err)=>{
  //             console.log(err);
  //             console.log('没有取到short');
  //             callback(null);
  //           });
  //           // setTimeout(function(){
  //           //   storage.save({
  //           //     key: "syncFunction",  // "loginState" 注意:请不要在key中使用_下划线符号!
  //           //     rawData:"新的短Token",//{ from: 'some other site',userid: 'some userid',token: 'some token'},
  //           //     // 如果不指定过期时间，则会使用defaultExpires参数
  //           //     // 如果设为null，则永不过期
  //           //     expires: 1000*3
  //           //   });
  //           //   callback("新的短Token")
  //           // },1)
  //           break;
  //       default:
  //           callback(null);
  //   }
  // })
}

var getTempInfo = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(key) {
    var result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = '';
            _context.prev = 1;

            if (key === 'shortToken' || key === 'longToken') {
              key = 'loginInfo-' + key;
            }
            _context.next = 5;
            return getStorage(key);

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);
            return _context.abrupt('return', '');

          case 11:
            return _context.abrupt('return', result);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 8]]);
  }));

  return function getTempInfo(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* 合并两个对象 */
var mergeObjectEasy = function mergeObjectEasy(oldObj, newObj) {
  return Object.assign({}, oldObj, newObj);
};

/* 同步更新当前用户信息和用户列表信息*/
var syncAddUserInfo = function () {
  var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(userInfo) {
    var currentInfo, newInfo;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getTempInfo('currentUserInfo');

          case 2:
            currentInfo = _context2.sent;

            if (currentInfo) {
              newInfo = mergeObjectEasy(currentInfo, userInfo);

              setStorage('currentUserInfo', newInfo);
              setStorage('userList-' + currentInfo.userId, newInfo);
            }

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function syncAddUserInfo(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var fundDetailFun = function fundDetailFun(type, code, route) {
  if (type == "G") {
    __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
      pathname: '/PublicOffering',
      state: {
        fundCode: code
      },
      query: {
        fundCode: code
      }
    });
  } else if (type == "S") {
    var newCallback = function newCallback() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/PrivatePlacement',
        state: {
          fundCode: code
        },
        query: {
          fundCode: code
        }
      });
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */])(newCallback, route);
  } else if (type == "S_ZX") {
    __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
      pathname: '/PrivatePlacement',
      state: {
        fundCode: code
      },
      query: {
        fundCode: code
      }
    });
  } else if (type == "J") {
    var _newCallback = function _newCallback() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/Details',
        state: {
          fundCode: code
        },
        query: {
          fundCode: code
        }
      });
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */])(_newCallback, route);
  } else if (type == "Z") {
    var _newCallback2 = function _newCallback2() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/Details',
        state: {
          fundCode: code
        },
        query: {
          fundCode: code
        }
      });
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */])(_newCallback2, route);
  }
};

var allMonetaryCode = {
  ordinary: ["SF1002"]
};

var isAllMonetaryCode = function isAllMonetaryCode(code) {
  var flag = false;
  for (var i = 0; i < allMonetaryCode.ordinary.length; i++) {
    if (code == allMonetaryCode.ordinary[i]) {
      flag = true;
      break;
    }
  }
  return flag;
};

var isRate = function isRate(money) {
  console.log(money, "moneymoney", money > 200000);
  var rateNum = "";
  if (money - 200000 < 0) {
    rateNum = 1;
  } else if (money - 1000000 <= 0) {
    rateNum = 0.8;
  } else if (money - 5000000 <= 0) {
    rateNum = 0.6;
  } else {
    rateNum = 0.4;
  }
  return rateNum;
};
//智投组合费率 11.5
var superFundCodeFee = function superFundCodeFee(code) {
  if (code == "SF1012") {
    return "0.2%";
  } else if (code == "SF1014") {
    return "0.3%";
  } else if (code == "SF1015") {
    return "0.25%";
  } else if (code == "SF1013" || code == "SF1016" || code == "SF1017" || code == "SF1019" || code == "SF1020" || code == "SF1021") {
    return "0.5%";
  } else if (code == "SF1018") {
    return "0.4%";
  } else if (code == "SF1036") {
    return "0.25%";
  }
};

var traceSaveParams = {
  traceAction: {
    MAX_RISK: 'MAX_RISK',
    READ_TIPS: 'READ_TIPS',
    TRADE_REFUSE: 'TRADE_REFUSE',
    BUY_RISK_WARN_FIRST: 'BUY_RISK_WARN_FIRST',
    BUY_WARN_AGAIN: 'BUY_WARN_AGAIN',
    REGISTER_PROTOCOL: 'REGISTER_PROTOCOL',
    SYNC_ACCOUNT_PROTOCOL: 'SYNC_ACCOUNT_PROTOCOL',
    CERTIFICATION_PROTOCOL: 'CERTIFICATION_PROTOCOL',
    SPECIAL_TIP: 'SPECIAL_TIP',
    SF_SPECIAL_TIP: 'SF_SPECIAL_TIP'
  },
  appName: 'HXCF_H5',
  appVersion: navigator.appVersion,
  deviceName: navigator.appName,
  deviceType: "",
  os: navigator.platform,
  deviceId: ""
};

var getToastConfPoint = function getToastConfPoint(funcObj) {
  return {
    duration: funcObj && funcObj.duration ? funcObj.duration : 1500,
    position: funcObj && funcObj.position ? funcObj.position : 0,
    shadow: funcObj && funcObj.shadow ? funcObj.shadow : true,
    animation: funcObj && funcObj.animation ? funcObj.animation : true,
    hideOnPress: funcObj && funcObj.hideOnPress ? funcObj.hideOnPress : true,
    delay: funcObj && funcObj.delay ? funcObj.delay : 0,
    onShow: funcObj && funcObj.onShow ? funcObj.onShow : function () {
      /* calls on toast\`s appear animation start*/
    },
    onShown: funcObj && funcObj.onShown ? funcObj.onShown : function () {
      /* calls on toast\`s appear animation end.*/
    },
    onHide: funcObj && funcObj.onHide ? funcObj.onHide : function () {
      /* calls on toast\`s hide animation start.*/
    },
    onHidden: funcObj && funcObj.onHidden ? funcObj.onHidden : function () {
      /* calls on toast\`s hide animation end.*/
    }
  };
};

var ClassfundFun = function ClassfundFun(code, stcode, nav, route, callback) {
  console.log(nav);
  nav.replace({
    pathname: '/NewPublicOffering',
    query: {
      fundCode: code
    }
  });
};

var onMiniProgramDialog = function onMiniProgramDialog(type) {
  if (navigator.userAgent.includes('miniProgram')) {
    // Guide.show(type)//弹窗图片拦截
    __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({ //页面图片拦截
      pathname: '/imgPage',
      state: {
        type: type
      }
    });
    return true;
  }

  return false;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(856);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(442);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1439);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export newFetch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return goHXJJLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLoginState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getPayAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getOpenHqt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getPayAllSuper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return goPubQuestionnaires; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return judgeQuestionnaires; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return querySuperFundAccAgreementStatus; });
/* harmony export (immutable) */ __webpack_exports__["i"] = compareDate;
/* harmony export (immutable) */ __webpack_exports__["m"] = getDateS;
/* harmony export (immutable) */ __webpack_exports__["g"] = compareTime;
/* harmony export (immutable) */ __webpack_exports__["h"] = compareTimeTwo;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDateNow;
/* harmony export (immutable) */ __webpack_exports__["k"] = getTimeNow;
/* harmony export (immutable) */ __webpack_exports__["e"] = get3MonthBefor;
/* harmony export (immutable) */ __webpack_exports__["l"] = get1yearBefor;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOneMonthBefor;
/* harmony export (immutable) */ __webpack_exports__["v"] = get3yearBefor;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSixMonthBefor;
/* harmony export (immutable) */ __webpack_exports__["w"] = get5yearBefor;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasConvertingTrade; });
/* harmony export (immutable) */ __webpack_exports__["x"] = dateDeath;
/* harmony export (immutable) */ __webpack_exports__["u"] = Fromthisyear;
/* unused harmony export computer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_questionnairesAction__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__(1);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/*!
 *
 * 判断是否进入支付页面
 *
 *
 *参数一： router 当前路由
 *参数二：  params 支付页面需要的参数
 *参数三：  navigator 
 *
 */
// import {
//   PixelRatio,
//   ActivityIndicatorIOS,
//   Platform
//   } from 'react-native';
// import Login from './login/Login';
// import Payment from "./product/Payment/Payment";
// import FixedInvestment from "./product/Payment/FixedInvestment";/**/
// import { isLoginAndRealName, getTempInfo, getToastConfPoint } from '../CommonVar';

// import goLogin, {goCertify} from './goLogin';




// import Toast from 'react-native-root-toast';

// import CertificationMainView from './myAssets/CertificationMainView';
// import QuestionnaireList from './myAssets/questionnaires/QuestionnaireList';
// import DeclareQualifiedInvestor from './myAssets/questionnaires/DeclareQualifiedInvestor';
// import HighestRiskPoint from './product/Payment/HighestRiskPoint';






var oldFetch = fetch;
var _fetch = function (oldFetch) {
  return function (url, options) {
    var abort = null;
    var abort_promise = new Promise(function (resolve, reject) {
      abort = function abort() {
        console.info('abort done.');
        reject('abort');
      };
    });
    var promise = Promise.race([fetch(url, options), abort_promise]);
    promise.abort = abort;
    return promise;
  };
}(fetch);

var newFetch = void 0;

var goLogin = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(callback) {
    var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var params = arguments[2];
    var loginState;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

          case 2:
            loginState = _context.sent;

            if (loginState == '0' || loginState == 9999) {
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
              //登录
              __WEBPACK_IMPORTED_MODULE_10_react_router__["a" /* hashHistory */].push({
                pathname: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
                state: { callback: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? callback : null, route: route, params: params }
              });
            } else if (loginState == '3') {
              //同步开户
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["a" /* mySyncBtn */])(3));
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["b" /* myPhoneNum */])(''));
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["c" /* myVerifyCode */])(''));
              __WEBPACK_IMPORTED_MODULE_10_react_router__["a" /* hashHistory */].push({
                pathname: '/BindingMobile',
                state: { callback: callback, route: route }
              });
            } else {
              callback();
            }

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function goLogin(_x2) {
    return _ref.apply(this, arguments);
  };
}();
var goHXJJLogin = function () {
  var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(callback) {
    var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var loginState;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

          case 2:
            loginState = _context2.sent;

            if (loginState == '0' || loginState == 9999) {
              //登录
              __WEBPACK_IMPORTED_MODULE_10_react_router__["a" /* hashHistory */].push({
                pathname: '/LoginHxjj',
                query: {
                  enterType: 'SubscriptionDetail'
                },
                state: { callback: callback, route: route }
              });
            } else if (loginState == '3') {
              //同步开户
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["a" /* mySyncBtn */])(3));
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["b" /* myPhoneNum */])(''));
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["c" /* myVerifyCode */])(''));
              __WEBPACK_IMPORTED_MODULE_10_react_router__["a" /* hashHistory */].push({
                pathname: '/BindingMobile',
                state: { callback: callback, route: route }
              });
            } else {
              callback();
            }

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function goHXJJLogin(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
var getLoginState = function () {
  var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getLoginState() {
    return _ref3.apply(this, arguments);
  };
}();
var getPayAll = function () {
  var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(route, params, nav) {
    var component = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var flagDigital, _currentUserInfo, hasConvertFlag, didQuestionnairs, riskCode, riskModalData, _riskModalData;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["d" /* myPaymentText */])(''));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["e" /* myFee */])('--'));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["h" /* choseBankIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["i" /* choseCurrentIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["j" /* choseBankOrCurrent */])(false));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["k" /* changeCurrentType */])(4));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["l" /* changeCurrentIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);
            if (component == 'RechargeHqt') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "HQT_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            } else if (component == 'PaymentSuperFund') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "SUPER_FUND_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            } else if (component == 'FixedInvestmentSuperFund') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "SUPER_FUND_DT_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            }
            //已登录 已实名认证
            _context4.next = 11;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

          case 11:
            flagDigital = _context4.sent;
            _context4.next = 14;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('currentUserInfo');

          case 14:
            _currentUserInfo = _context4.sent;

            if (!(flagDigital == '1')) {
              _context4.next = 22;
              break;
            }

            //实名认证
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["b" /* clearSmrzOne */])());
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            nav.push({
              pathname: '/CertificationUpload',
              state: {
                route: route,
                phoneNo: _currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
                callback: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? function () {
                  getPayAll(route, params, nav, component);
                } : null
              }
            });
            return _context4.abrupt('return');

          case 22:
            if (!(flagDigital == '3')) {
              _context4.next = 28;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            //同步开户
            nav.push({
              pathname: '/BindingMobile',
              state: { route: route, callback: function callback() {
                  getPayAll(route, params, nav, component);
                } }
            });
            return _context4.abrupt('return');

          case 28:
            if (!(flagDigital == '0')) {
              _context4.next = 32;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            nav.push({
              pathname: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
              state: { route: route, callback: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? function () {
                  getPayAll(route, params, nav, component);
                } : null }
            });
            return _context4.abrupt('return');

          case 32:
            if (!(params && params.productType == "Z")) {
              _context4.next = 49;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);
            hasConvertFlag = null;
            _context4.prev = 35;
            _context4.next = 38;
            return hasConvertingTrade({ superFundCode: params.fundCode }, function () {
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            }, function () {
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            });

          case 38:
            hasConvertFlag = _context4.sent;
            _context4.next = 45;
            break;

          case 41:
            _context4.prev = 41;
            _context4.t0 = _context4['catch'](35);

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            return _context4.abrupt('return');

          case 45:
            if (!(hasConvertFlag === true)) {
              _context4.next = 48;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].show('当前智投组合有转换在途交易，该操作暂停', __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
            return _context4.abrupt('return');

          case 48:
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);

          case 49:
            didQuestionnairs = false; //后台接口 判断是否做了问卷

            _context4.prev = 50;
            _context4.next = 53;
            return judgeQuestionnaires(params.productType);

          case 53:
            didQuestionnairs = _context4.sent;
            _context4.next = 60;
            break;

          case 56:
            _context4.prev = 56;
            _context4.t1 = _context4['catch'](50);

            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(_context4.t1.message, 2);
            return _context4.abrupt('return');

          case 60:
            if (!((params.productType == 'S' || params.productType == 'G' || params.productType == 'J' || params.productType == 'Z') && !didQuestionnairs)) {
              _context4.next = 63;
              break;
            }

            goPubQuestionnaires(nav, route, function () {
              getPayAll(route, params, nav, component);
            });
            return _context4.abrupt('return');

          case 63:
            if (false) {
              _context4.next = 125;
              break;
            }

            //调后台接口公募接口
            riskCode = '';

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);
            _context4.prev = 66;
            _context4.next = 69;
            return getRiskFlag(params.fundCode, params.productType);

          case 69:
            riskCode = _context4.sent;

            console.log('+++++++++', riskCode);
            _context4.next = 77;
            break;

          case 73:
            _context4.prev = 73;
            _context4.t2 = _context4['catch'](66);

            // store.dispatch(setPayLoading(false));
            if (_context4.t2.message != 'abort') {
              // alert(err.message);
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(_context4.t2.message, 2);
            }
            return _context4.abrupt('return');

          case 77:
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();

            if (!(riskCode.code == '')) {
              _context4.next = 82;
              break;
            }

            return _context4.abrupt('return');

          case 82:
            if (!(riskCode.code == '0000')) {
              _context4.next = 87;
              break;
            }

            // store.dispatch(setPayLoading(false));
            if (component != null) {
              nav.push({
                pathname: component,
                state: params,
                query: params
              });
            } else {
              params.callback();
            }
            return _context4.abrupt('return');

          case 87:
            if (!(/^90\d\d$/.test(riskCode.code) && riskCode.userRiskLevel == "1")) {
              _context4.next = 94;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            riskModalData = {
              title: '风险提示',
              content: '您当前的风险承受能力为最低风险等级，根据证监会发布的《关于实施<证券期货投资者适当性管理办法>的规定》，最低风险等级的客户不能购买产品风险等级高于自身风险承受能力的产品。如果您对自己的风险等级有异议，建议重新测评。',
              leftButtonTitle: '取消',
              rightButtonTitle: '重新测评',
              contentBC: params.fundName + '风险高于您的风险承受能力',
              onOK: function onOK() {
                //跳到重新测评
                // goReCheck();
                params.fundRisk = true;
                // params.fundPart = false;
                // UmengStatis.onEvent('Pay_GoReCheck');
                goPubQuestionnaires(nav, route, function () {
                  getPayAll(route, params, nav, component);
                });
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(false));
              },
              onCancel: function onCancel() {
                // UmengStatis.onEvent('Pay_ReCheckCancel');
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
              }
            };

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(riskModalData));
            // store.dispatch(traceSave({action: 'TRADE_REFUSE', message: '安全型用户购买非货币基金：' + params.fundName}));
            return _context4.abrupt('return');

          case 94:
            if (!(/^02\d\d$/.test(riskCode.code) || /^\d\d0[2,8]$/.test(riskCode.code))) {
              _context4.next = 99;
              break;
            }

            //特高产品提示页，做题
            // store.dispatch(setPayLoading(false));
            goHighestRiskPoint(nav, route, function () {
              params.fundRisk = true;
              if (component != null) {
                nav.push({
                  pathname: component,
                  state: params,
                  query: params
                });
              } else {
                params.callback();
              }
            }, params.fundName);
            return _context4.abrupt('return');

          case 99:
            if (!/^06\d\d$/.test(riskCode.code)) {
              _context4.next = 107;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            _riskModalData = {
              title: '风险提示',
              content: '本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。',
              leftButtonTitle: '取消',
              rightButtonTitle: '继续购买',
              onOK: function onOK() {
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                //购买
                params.fundRisk = true;
                if (component != null) {
                  nav.push({
                    pathname: component,
                    state: params,
                    query: params
                  });
                }
              },
              onCancel: function onCancel() {
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
              }
            };

            if (riskCode.code == '0606') {
              // riskModalData.contentBC = '组合中的成分基金：' + riskCode.confirmFundCodeList.join('、') + '，高于您的风险承受能力。';
              _riskModalData.contentBC = '';
              _riskModalData.onOK = function () {
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                //购买
                params.fundRisk = true;
                params.fundPart = riskCode.confirmFundCodeList.join('、') + '';
                if (component != null) {
                  nav.push({
                    pathname: component,
                    state: params,
                    query: params
                  });
                }
              };
            }
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(_riskModalData));
            return _context4.abrupt('return');

          case 107:
            if (!/^90\d\d$/.test(riskCode.code)) {
              _context4.next = 112;
              break;
            }

            //限制购买
            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('限制购买', 2);
            return _context4.abrupt('return');

          case 112:
            if (!/^009\d$/.test(riskCode.code)) {
              _context4.next = 117;
              break;
            }

            //限制购买
            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('子基金限制购买' + riskCode.code, 2);
            return _context4.abrupt('return');

          case 117:
            if (!/^0006$/.test(riskCode.code)) {
              _context4.next = 123;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            if (component != null) {
              nav.push({
                pathname: component,
                state: params,
                query: params
              });
            } else {
              params.callback();
            }
            return _context4.abrupt('return');

          case 123:
            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('没有对应风险码：' + riskCode.code, 2);
            return _context4.abrupt('return');

          case 125:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this, [[35, 41], [50, 56], [66, 73]]);
  }));

  return function getPayAll(_x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

var getOpenHqt = function () {
  var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(route, nav) {
    var _callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var obj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var flagDigital, _currentUserInfo, didQuestionnairs, userInfo, findHqtExist;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            _context5.next = 3;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

          case 3:
            flagDigital = _context5.sent;
            _context5.next = 6;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('currentUserInfo');

          case 6:
            _currentUserInfo = _context5.sent;

            if (!(flagDigital === '1')) {
              _context5.next = 12;
              break;
            }

            //实名认证
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["b" /* clearSmrzOne */])());
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            nav.push({
              pathname: '/CertificationUpload',
              state: {
                route: route,
                phoneNo: _currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
                callback: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? function () {
                  getOpenHqt(route, nav, _callback);
                } : null
              }
            });
            return _context5.abrupt('return');

          case 12:
            didQuestionnairs = false;
            _context5.prev = 13;
            _context5.next = 16;
            return judgeQuestionnaires("S");

          case 16:
            didQuestionnairs = _context5.sent;
            _context5.next = 24;
            break;

          case 19:
            _context5.prev = 19;
            _context5.t0 = _context5['catch'](13);

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(_context5.t0.message, 2);
            return _context5.abrupt('return');

          case 24:
            if (didQuestionnairs) {
              _context5.next = 27;
              break;
            }

            goPubQuestionnaires(nav, route, function () {
              getOpenHqt(route, nav, _callback);
            });
            return _context5.abrupt('return');

          case 27:
            userInfo = __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].getState().verifiedUserInfo;
            findHqtExist = userInfo.content;

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(false));
            if (findHqtExist.isOfficialsOrRelatives != null && findHqtExist.actualController && findHqtExist.actualControllerCertNo && findHqtExist.actualControllerCertType && findHqtExist.actualBeneficiary && findHqtExist.actualBeneficiaryCertNo && findHqtExist.actualBeneficiaryCertType) {
              if (findHqtExist.residentType != null) {
                if (obj) {
                  if (obj.bankAccountShowNo) {
                    nav.push({
                      pathname: "/HqtBindCard",
                      state: {
                        bankAccountShowNo: obj.bankAccountShowNo,
                        paymentChannelId: obj.paymentChannel,
                        bankAccountName: obj.bankName,
                        certType: obj.certType,
                        certNo: obj.certNo,
                        router: obj.router,
                        bankCode: obj.bankCode,
                        openHqt: true,
                        mobileNo: obj.mobileNo,
                        callback: obj.callback,
                        isShow: obj.isShow,
                        fundCode: obj.fundCode
                      }
                    });
                  } else {
                    nav.push({
                      pathname: "/HqtAddCard",
                      state: {
                        callback: _callback,
                        openHqt: true,
                        router: route,
                        fundCode: obj.fundCode
                      }
                    });
                  }
                } else {
                  nav.push({
                    pathname: "/HqtAddCard",
                    state: {
                      callback: _callback,
                      openHqt: true,
                      router: route
                    }
                  });
                }
              } else {
                nav.push({
                  pathname: "/ModifyTaxInfo",
                  state: {
                    route: route,
                    callback: function callback() {
                      getOpenHqt(route, nav, _callback);
                    }
                  }
                });
              }
            } else {
              nav.push({
                pathname: "/AddCertificationCard",
                state: {
                  route: route,
                  callback: function callback() {
                    getOpenHqt(route, nav, _callback);
                  }
                }
              });
            }

          case 31:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this, [[13, 19]]);
  }));

  return function getOpenHqt(_x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();

var getPayAllSuper = function () {
  var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(route, params, nav) {
    var component = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var flagDigital, _currentUserInfo, hasConvertFlag, didQuestionnairs, AccAgreementStatus, tempA, riskCode, riskModalData, _riskModalData2;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["d" /* myPaymentText */])(''));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["e" /* myFee */])('--'));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["h" /* choseBankIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["i" /* choseCurrentIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["j" /* choseBankOrCurrent */])(false));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["k" /* changeCurrentType */])(4));
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_productAction__["l" /* changeCurrentIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);
            if (component == 'RechargeHqt') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "HQT_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            } else if (component == 'PaymentSuperFund') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "SUPER_FUND_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            } else if (component == 'FixedInvestmentSuperFund') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "SUPER_FUND_DT_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            } else if (component == 'PaymentAllSuperFund') {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "SUPER_FUND_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch({
                type: "SUPER_FUND_DT_PAY_INFO",
                text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
              });
            }

            //已登录 已实名认证
            _context6.next = 11;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

          case 11:
            flagDigital = _context6.sent;
            _context6.next = 14;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('currentUserInfo');

          case 14:
            _currentUserInfo = _context6.sent;

            console.log(flagDigital, 'flagDigital11111');

            if (!(flagDigital == '1')) {
              _context6.next = 23;
              break;
            }

            //实名认证
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["b" /* clearSmrzOne */])());
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            nav.push({
              pathname: '/CertificationUpload',
              state: {
                route: route,
                phoneNo: _currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
                callback: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? function () {
                  getPayAll(route, params, nav, component);
                } : null
              }
            });
            return _context6.abrupt('return');

          case 23:
            if (!(flagDigital == '3')) {
              _context6.next = 29;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            //同步开户
            nav.push({
              pathname: '/BindingMobile',
              state: { route: route, callback: function callback() {
                  getPayAll(route, params, nav, component);
                } }
            });
            return _context6.abrupt('return');

          case 29:
            if (!(flagDigital == '0')) {
              _context6.next = 33;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            nav.push({
              pathname: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
              state: { route: route, callback: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? function () {
                  getPayAll(route, params, nav, component);
                } : null }
            });
            return _context6.abrupt('return');

          case 33:
            if (!(params && params.productType == "Z")) {
              _context6.next = 50;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);
            hasConvertFlag = null;
            _context6.prev = 36;
            _context6.next = 39;
            return hasConvertingTrade({ superFundCode: params.fundCode }, function () {
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            }, function () {
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            });

          case 39:
            hasConvertFlag = _context6.sent;
            _context6.next = 46;
            break;

          case 42:
            _context6.prev = 42;
            _context6.t0 = _context6['catch'](36);

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            return _context6.abrupt('return');

          case 46:
            if (!(hasConvertFlag === true)) {
              _context6.next = 49;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].show('当前智投组合有转换在途交易，该操作暂停', __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
            return _context6.abrupt('return');

          case 49:
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);

          case 50:
            didQuestionnairs = false; //后台接口 判断是否做了问卷

            _context6.prev = 51;
            _context6.next = 54;
            return querySuperFundAccAgreementStatus();

          case 54:
            AccAgreementStatus = _context6.sent;

            console.log(AccAgreementStatus, "AccAgreementStatusAccAgreementStatus");
            tempA = AccAgreementStatus && AccAgreementStatus.state;

            if (!(AccAgreementStatus === null || AccAgreementStatus === '' || tempA == "0")) {
              _context6.next = 61;
              break;
            }

            nav.push({
              pathname: '/SuperFundSigning',
              state: { route: route, callback: function callback() {
                  getPayAll(route, params, nav, component);
                } }
            });
            // store.dispatch(superFundAccAgreementState(true))
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            return _context6.abrupt('return');

          case 61:
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
            _context6.next = 68;
            break;

          case 64:
            _context6.prev = 64;
            _context6.t1 = _context6['catch'](51);

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(_context6.t1.message, 2);
            return _context6.abrupt('return');

          case 68:
            _context6.prev = 68;
            _context6.next = 71;
            return judgeQuestionnaires(params.productType);

          case 71:
            didQuestionnairs = _context6.sent;
            _context6.next = 78;
            break;

          case 74:
            _context6.prev = 74;
            _context6.t2 = _context6['catch'](68);

            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(_context6.t2.message, 2);
            return _context6.abrupt('return');

          case 78:
            if (!((params.productType == 'S' || params.productType == 'G' || params.productType == 'J' || params.productType == 'Z') && !didQuestionnairs)) {
              _context6.next = 81;
              break;
            }

            goPubQuestionnaires(nav, route, function () {
              getPayAll(route, params, nav, component);
            });
            return _context6.abrupt('return');

          case 81:
            if (false) {
              _context6.next = 143;
              break;
            }

            //调后台接口公募接口
            riskCode = '';

            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 0);
            _context6.prev = 84;
            _context6.next = 87;
            return getRiskFlag(params.fundCode, params.productType);

          case 87:
            riskCode = _context6.sent;

            console.log('+++++++++', riskCode);
            _context6.next = 95;
            break;

          case 91:
            _context6.prev = 91;
            _context6.t3 = _context6['catch'](84);

            // store.dispatch(setPayLoading(false));
            if (_context6.t3.message != 'abort') {
              // alert(err.message);
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(_context6.t3.message, 2);
            }
            return _context6.abrupt('return');

          case 95:
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();

            if (!(riskCode.code == '')) {
              _context6.next = 100;
              break;
            }

            return _context6.abrupt('return');

          case 100:
            if (!(riskCode.code == '0000')) {
              _context6.next = 105;
              break;
            }

            // store.dispatch(setPayLoading(false));
            if (component != null) {
              nav.push({
                pathname: component,
                state: params,
                query: params
              });
            } else {
              params.callback();
            }
            return _context6.abrupt('return');

          case 105:
            if (!(/^90\d\d$/.test(riskCode.code) && riskCode.userRiskLevel == "1")) {
              _context6.next = 112;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            riskModalData = {
              title: '风险提示',
              content: '您当前的风险承受能力为最低风险等级，根据证监会发布的《关于实施<证券期货投资者适当性管理办法>的规定》，最低风险等级的客户不能购买产品风险等级高于自身风险承受能力的产品。如果您对自己的风险等级有异议，建议重新测评。',
              leftButtonTitle: '取消',
              rightButtonTitle: '重新测评',
              contentBC: params.fundName + '风险高于您的风险承受能力',
              onOK: function onOK() {
                //跳到重新测评
                // goReCheck();
                params.fundRisk = true;
                // params.fundPart = false;
                // UmengStatis.onEvent('Pay_GoReCheck');
                goPubQuestionnaires(nav, route, function () {
                  getPayAll(route, params, nav, component);
                });
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(false));
              },
              onCancel: function onCancel() {
                // UmengStatis.onEvent('Pay_ReCheckCancel');
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
              }
            };

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(riskModalData));
            // store.dispatch(traceSave({action: 'TRADE_REFUSE', message: '安全型用户购买非货币基金：' + params.fundName}));
            return _context6.abrupt('return');

          case 112:
            if (!(/^02\d\d$/.test(riskCode.code) || /^\d\d0[2,8]$/.test(riskCode.code))) {
              _context6.next = 117;
              break;
            }

            //特高产品提示页，做题
            // store.dispatch(setPayLoading(false));
            goHighestRiskPoint(nav, route, function () {
              params.fundRisk = true;
              if (component != null) {
                nav.push({
                  pathname: component,
                  state: params,
                  query: params
                });
              } else {
                params.callback();
              }
            }, params.fundName);
            return _context6.abrupt('return');

          case 117:
            if (!/^06\d\d$/.test(riskCode.code)) {
              _context6.next = 125;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            _riskModalData2 = {
              title: '风险提示',
              content: '本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。',
              leftButtonTitle: '取消',
              rightButtonTitle: '继续购买',
              onOK: function onOK() {
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                //购买
                params.fundRisk = true;
                if (component != null) {
                  nav.push({
                    pathname: component,
                    state: params,
                    query: params
                  });
                }
              },
              onCancel: function onCancel() {
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
              }
            };

            if (riskCode.code == '0606') {
              // riskModalData.contentBC = '组合中的成分基金：' + riskCode.confirmFundCodeList.join('、') + '，高于您的风险承受能力。';
              _riskModalData2.contentBC = '';
              _riskModalData2.onOK = function () {
                __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                //购买
                params.fundRisk = true;
                params.fundPart = riskCode.confirmFundCodeList.join('、') + '';
                if (component != null) {
                  nav.push({
                    pathname: component,
                    state: params,
                    query: params
                  });
                }
              };
            }
            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(_riskModalData2));
            return _context6.abrupt('return');

          case 125:
            if (!/^90\d\d$/.test(riskCode.code)) {
              _context6.next = 130;
              break;
            }

            //限制购买
            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('限制购买', 2);
            return _context6.abrupt('return');

          case 130:
            if (!/^009\d$/.test(riskCode.code)) {
              _context6.next = 135;
              break;
            }

            //限制购买
            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('子基金限制购买' + riskCode.code, 2);
            return _context6.abrupt('return');

          case 135:
            if (!/^0006$/.test(riskCode.code)) {
              _context6.next = 141;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(true));
            if (component != null) {
              nav.push({
                pathname: component,
                state: params,
                query: params
              });
            } else {
              params.callback();
            }
            return _context6.abrupt('return');

          case 141:
            // store.dispatch(setPayLoading(false));
            __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('没有对应风险码：' + riskCode.code, 2);
            return _context6.abrupt('return');

          case 143:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this, [[36, 42], [51, 64], [68, 74], [84, 91]]);
  }));

  return function getPayAllSuper(_x14, _x15, _x16) {
    return _ref6.apply(this, arguments);
  };
}();

var goHighestRiskPoint = function goHighestRiskPoint(nav, route, callback, fundName) {
  nav.push({
    pathname: '/HighestRiskPoint',
    state: {
      route: route,
      callback: callback,
      fundName: fundName
    }
  });
};

var getRiskFlag = function () {
  var _ref7 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(fundCode, fundType) {
    var params;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

          case 2:
            _context7.t0 = _context7.sent;
            params = {
              token: _context7.t0
            };

            if (fundType == 'Z') params.superFundCode = fundCode;else params.fundCode = fundCode;
            return _context7.abrupt('return', new Promise(function (resolve, reject) {
              var successCallback = function successCallback(suc) {
                if (suc && suc.code == '0000') {
                  resolve(suc.content);
                } else {
                  reject(new Error(suc.message));
                }
              };
              var errorCallback = function errorCallback(err) {
                if (err == 'abort') reject(new Error('abort'));else reject(new Error(__WEBPACK_IMPORTED_MODULE_6__util___default.a.errorTxt));
              };
              var paramsForm = new FormData();
              for (var i in params) {
                paramsForm.append(i + '', params[i]);
              }
              var url = __WEBPACK_IMPORTED_MODULE_6__util___default.a.url + '/api/trade/getRiskFlag';
              if (paramsForm) {
                var paramsArray = [];
                //拼接参数
                Object.keys(params).forEach(function (key) {
                  return paramsArray.push(key + '=' + params[key]);
                });
                if (url.search(/\?/) == -1) {
                  url += '?' + paramsArray.join('&');
                } else {
                  url += '&' + paramsArray.join('&');
                }
              }
              newFetch = _fetch(url, {
                method: "GET",
                mode: 'cors'
              });
              newFetch.then(function (response) {
                return response.json();
              }).then(function (responseText) {
                successCallback(responseText);
              }).catch(function (err) {
                errorCallback(err);
                // store.dispatch(setPayLoading(false));
              });
              // Util.get(Util.url + '/api/trade/getRiskFlag', params, successCallback, errorCallback);
            }));

          case 6:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function getRiskFlag(_x17, _x18) {
    return _ref7.apply(this, arguments);
  };
}();

var goPriQuestionnaires = function () {
  var _ref8 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(nav, route, callback) {
    var privateFundParams, getQuestionnaireNoSuccess, getQuestionnaireNoError;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

          case 2:
            _context8.t0 = _context8.sent;
            privateFundParams = {
              token: _context8.t0,
              raiseMethod: '7'
            };

            getQuestionnaireNoSuccess = function getQuestionnaireNoSuccess(questionnaireNo, raiseMethod) {
              // store.dispatch(setPayLoading(false));
              // nav.push({
              //   component: DeclareQualifiedInvestor,
              //   params: {
              //     questionnaireType: '私募',
              //     questionnaireTypeNumber: questionnaireNo,
              //     route: route,
              //     refreshPage: ()=>{callback()}
              //   }
              // })
            };

            getQuestionnaireNoError = function getQuestionnaireNoError(msg) {
              // store.dispatch(setPayLoading(false));
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(msg, 2);
            };
            // store.dispatch(getQuestionnaireNo(privateFundParams, (questionnaireNo, raiseMethod) => getQuestionnaireNoSuccess(questionnaireNo, raiseMethod), (msg) => getQuestionnaireNoError(msg)));


          case 6:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function goPriQuestionnaires(_x19, _x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();

var goPubQuestionnaires = function () {
  var _ref9 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(nav, route, callback) {
    var publicFundParams, getQuestionnaireNoSuccess, getQuestionnaireNoError;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

          case 2:
            _context9.t0 = _context9.sent;
            publicFundParams = {
              token: _context9.t0,
              raiseMethod: '9'
            };

            getQuestionnaireNoSuccess = function getQuestionnaireNoSuccess(questionnaireNo, raiseMethod) {
              __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["a" /* setPayLoading */])(false));
              nav.push({
                pathname: '/QuestionnaireList',
                state: {
                  questionnaireType: '公募',
                  questionnaireTypeNumber: questionnaireNo,
                  route: route,
                  refreshPage: function refreshPage() {
                    callback();
                  }
                }
              });
            };

            getQuestionnaireNoError = function getQuestionnaireNoError(msg) {
              // store.dispatch(setPayLoading(false));
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(msg, 2);
            };

            __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_questionnairesAction__["a" /* getQuestionnaireNo */])(publicFundParams, function (questionnaireNo, raiseMethod) {
              return getQuestionnaireNoSuccess(questionnaireNo, raiseMethod);
            }, function (msg) {
              return getQuestionnaireNoError(msg);
            }));

          case 7:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function goPubQuestionnaires(_x22, _x23, _x24) {
    return _ref9.apply(this, arguments);
  };
}();

var uploadForPrivate = function () {
  var _ref10 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(nav, callback) {
    var successCallback, errorCallback, params;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            successCallback = function successCallback(suc) {
              callback();
              if (suc && suc.code == '0000') {
                if (suc.content == true) {
                  var riskModalData = {
                    title: '提示',
                    content: '您提交的私募合格投资者认证材料还在审核中，在此期间您还不能购买私募产品，请您耐心等待审核结果。',
                    onOK: function onOK() {
                      __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(null));
                    },
                    modalType: 'message'
                  };
                  __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_riskInPayAction__["b" /* setRiskModalData */])(riskModalData));
                } else {
                  // nav.push({
                  //   component: CertificationMainView
                  // });
                }
              } else {
                __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(suc.message, 2);
              }
            };

            errorCallback = function errorCallback(err) {
              callback();
              __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_6__util___default.a.errorTxt, 2);
            };

            _context10.next = 4;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

          case 4:
            _context10.t0 = _context10.sent;
            params = {
              token: _context10.t0
            };

            __WEBPACK_IMPORTED_MODULE_6__util___default.a.post(__WEBPACK_IMPORTED_MODULE_6__util___default.a.url + "/api/account/validateHasUploadFile", params, successCallback, errorCallback);

          case 7:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function uploadForPrivate(_x25, _x26) {
    return _ref10.apply(this, arguments);
  };
}();

var isPrivate = function isPrivate() {
  return new Promise(function () {
    var _ref11 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(resolve, reject) {
      var successCallback, errorCallback, params;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              successCallback = function successCallback(suc) {
                if (suc && suc.code == '0000') {
                  resolve(suc.content.isPrivate);
                } else {
                  reject(new Error(suc.code));
                }
              };

              errorCallback = function errorCallback(err) {
                reject(new Error(__WEBPACK_IMPORTED_MODULE_6__util___default.a.errorTxt));
              };

              _context11.next = 4;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

            case 4:
              _context11.t0 = _context11.sent;
              params = {
                token: _context11.t0
              };

              __WEBPACK_IMPORTED_MODULE_6__util___default.a.post(__WEBPACK_IMPORTED_MODULE_6__util___default.a.url + '/api/account/getRealUserInfo', params, successCallback, errorCallback);

            case 7:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this);
    }));

    return function (_x27, _x28) {
      return _ref11.apply(this, arguments);
    };
  }());
};

var judgeQuestionnaires = function () {
  var _ref12 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(productType) {
    var raiseMethod;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            raiseMethod = '9';
            return _context13.abrupt('return', new Promise(function () {
              var _ref13 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(resolve, reject) {
                var params, successCallback, errorCallback;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.next = 2;
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

                      case 2:
                        _context12.t0 = _context12.sent;
                        _context12.t1 = raiseMethod;
                        params = {
                          token: _context12.t0,
                          raiseMethod: _context12.t1
                        };

                        successCallback = function successCallback(riskType, raiseMethod) {
                          if (riskType) resolve(true);else resolve(false);
                        };

                        errorCallback = function errorCallback(msg) {
                          reject(new Error(msg));
                        };

                        __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_questionnairesAction__["b" /* getRiskType */])(params, function (riskType, raiseMethod) {
                          successCallback(riskType, raiseMethod);
                        }, function (msg) {
                          errorCallback(msg);
                        }));

                      case 8:
                      case 'end':
                        return _context12.stop();
                    }
                  }
                }, _callee12, _this);
              }));

              return function (_x30, _x31) {
                return _ref13.apply(this, arguments);
              };
            }()));

          case 2:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this);
  }));

  return function judgeQuestionnaires(_x29) {
    return _ref12.apply(this, arguments);
  };
}();

var querySuperFundAccAgreementStatus = function () {
  var _ref14 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', new Promise(function () {
              var _ref15 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(resolve, reject) {
                var params, successCallback, errorCallback;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.next = 2;
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

                      case 2:
                        _context14.t0 = _context14.sent;
                        params = {
                          token: _context14.t0
                        };

                        successCallback = function successCallback(res) {
                          resolve(res);
                        };

                        errorCallback = function errorCallback(msg) {
                          reject(new Error(msg));
                        };

                        __WEBPACK_IMPORTED_MODULE_5__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["c" /* querySuperFundAccAgreement */])(params, function (res) {
                          successCallback(res);
                        }, function (msg) {
                          errorCallback(msg);
                        }));

                      case 7:
                      case 'end':
                        return _context14.stop();
                    }
                  }
                }, _callee14, _this);
              }));

              return function (_x32, _x33) {
                return _ref15.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this);
  }));

  return function querySuperFundAccAgreementStatus() {
    return _ref14.apply(this, arguments);
  };
}();
//--------------------------------------//
// export function getPayDt(router,params,nav){
//   UmengStatis.onEvent('PublicOffering_FixedInvestment_Btn'); /*公募详情-定投按钮*/
//   // goLogin(nav,router,function(){
//   //   nav.push({
//   //     component: FixedInvestment,
//   //     params:params
//   //   });
//   // }.bind(this))
//   getPayAll(router, params, nav, FixedInvestment);
//   // isLoginAndRealName()
//   // .then((data) =>{
//   //   if(data==0){
//   //     nav.push({
//   //       component: Login,
//   //       params:{
//   //         route:router,
//   //         callback:getPayDt.bind(this,router,params,nav)
//   //       }
//   //     });
//   //   }else{
//   //     nav.push({
//   //     component: FixedInvestment,
//   //     params:params
//   //     });
//   //   }
//   // })
// }

// /*看是否登录，已经登录就走回调*/ 
// export function getToZx(router,nav,callback){
//   isLoginAndRealName()
//   .then((data) =>{
//     if(data==0){
//       nav.push({
//         component: Login,
//         params:{
//           route:router,
//           callback: callback
//         }
//       });
//     }else{
//       callback()
//     }
//   })
// }


//比较日期大小  
function compareDate(checkStartDate, checkEndDate) {
  var arys1 = new Array();
  var arys2 = new Array();
  if (checkStartDate != null && checkEndDate != null) {
    arys1 = checkStartDate.split('-');
    var sdate = new Date(arys1[0], parseInt(arys1[1] - 1), arys1[2]);
    arys2 = checkEndDate.split('-');
    var edate = new Date(arys2[0], parseInt(arys2[1] - 1), arys2[2]);
    if (sdate > edate) {
      return false;
    } else {
      return true;
    }
  }
}

/*把时间字符串转化为标准时间*/
function getDateS(strDate) {
  // console.log(strDate,"strDatestrDate")
  // var date = eval('new Date(' + strDate.replace(/\d+(?=-[^-]+$)/,function (a) { return parseInt(a, 10) - 1; }).match(/\d+/g) + ')');
  var date = new Date(strDate);
  return date;
}

//判断日期，时间大小  
function compareTime(startDate, endDate) {
  if (startDate.length > 0 && endDate.length > 0) {

    var allStartDate = getDateS(startDate);
    var allEndDate = getDateS(endDate);

    if (allStartDate.getTime() >= allEndDate.getTime()) {
      //console.log("startTime不能大于endTime，不能通过");   
      return false;
    } else {
      //console.log("startTime小于endTime，所以通过了");   
      return true;
    }
  } else {
    //console.log("时间不能为空");   
    return false;
  }
}

function compareTimeTwo(startDate, endDate) {
  if (startDate.length > 0 && endDate.length > 0) {

    var allStartDate = getDateS(startDate);
    var allEndDate = getDateS(endDate);

    if (allStartDate.getTime() > allEndDate.getTime()) {
      //console.log("startTime不能大于endTime，不能通过");   
      return false;
    } else {
      //console.log("startTime小于endTime，所以通过了");   
      return true;
    }
  } else {
    //console.log("时间不能为空");   
    return false;
  }
}

// //2012-02-02  --- 2012-02-02 19:16;；两种格式；
// function compareCalendar(startDate, endDate) {   
//   if (startDate.indexOf(" ") != -1 && endDate.indexOf(" ") != -1 ) {   
//       //包含时间，日期  
//           compareTime(startDate, endDate);               
//   } else {   
//       //不包含时间，只包含日期  
//       compareDate(startDate, endDate);   
//   }   
// }

/*获取当前时间 年-月-日*/
function getDateNow() {
  var resultDate, year, month, date, hms;
  var currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  hms = currDate.getHours() + ':' + currDate.getMinutes();
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  resultDate = year + '-' + month + '-' + date;
  return resultDate;
}

/*获取当前时间 年-月-日-时-分*/
function getTimeNow() {
  var resultDate, year, month, date, hms, hs, ms;
  var currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  hs = currDate.getHours();
  ms = currDate.getMinutes();
  hs = hs < 10 ? '0' + hs : hs;
  ms = ms < 10 ? '0' + ms : ms;
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  hms = hs + ':' + ms;
  resultDate = year + '-' + month + '-' + date + ' ' + hms;
  return resultDate;
}

/*获取三个月前的时间 年-月-日*/
function get3MonthBefor() {
  var resultDate, year, month, date, hms;
  var currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds());
  switch (month) {
    case 1:
    case 2:
    case 3:
      month += 9;
      year--;
      break;
    default:
      month -= 3;
      break;
  }
  month = month < 10 ? '0' + month : month;
  resultDate = year + '-' + month + '-' + date;
  return resultDate;
}
/*获取一年前的时间 年-月-日*/
function get1yearBefor() {
  var resultDate, year, month, date;
  var currDate = new Date();
  year = currDate.getFullYear() - 1;
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  month = month < 10 ? '0' + month : month;
  resultDate = year + '-' + month + '-' + date;
  return resultDate;
}

/*获取一个月前时间 年-月-日*/
function getOneMonthBefor() {
  var resultDate, year, month, date, hms;
  var currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds());
  switch (month) {
    case 1:
      month += 11;
      year--;
      break;
    default:
      month -= 1;
      break;
  }
  month = month < 10 ? '0' + month : month;
  resultDate = year + '-' + month + '-' + date;
  return resultDate;
}

/*获取三年前的时间 年-月-日*/
function get3yearBefor() {
  var resultDate, year, month, date;
  var currDate = new Date();
  year = currDate.getFullYear() - 3;
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  resultDate = year + '-' + month + '-' + date;
  return resultDate;
}
/*获取半年前前的 年-月-日*/
function getSixMonthBefor() {
  var resultDate, year, month, date, hms;
  var currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds());
  switch (month) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      month += 6;
      year--;
      break;
    default:
      month -= 6;
      break;
  }
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  resultDate = year + '-' + month + '-' + date;
  // console.log(resultDate,"获取半年前前的")
  return resultDate;
}
/*获取五年前的时间 年-月-日*/
function get5yearBefor() {
  var resultDate, year, month, date;
  var currDate = new Date();
  year = currDate.getFullYear() - 5;
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  resultDate = year + '-' + month + '-' + date;
  return resultDate;
}

/*当获取的字符串类型为null时*/

//智投转入、定投、转换特殊处理
var hasConvertingTrade = function () {
  var _ref16 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(data, sucCallBack, errback) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', new Promise(function (resolve, reject) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
                data.token = d;
                __WEBPACK_IMPORTED_MODULE_6__util___default.a.get(__WEBPACK_IMPORTED_MODULE_6__util___default.a.url + "/api/v1/superfund/trade/hasConvertingTrade", data, function (result) {
                  console.log(result);
                  if (result.code == '0000') {
                    sucCallBack();
                    if (result.content === true || result.content === false) {
                      resolve(result.content);
                    } else {
                      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].show(__WEBPACK_IMPORTED_MODULE_6__util___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
                      reject("error");
                    }
                  } else {
                    errback();
                    __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].show(result.message, __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
                    reject("error");
                  }
                }, function (error) {
                  errback();
                  __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].show(__WEBPACK_IMPORTED_MODULE_6__util___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
                  reject("error");
                });
              }).catch(function (err) {
                console.log(err);
                errback();
                reject("error");
              });
            }));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function hasConvertingTrade(_x34, _x35, _x36) {
    return _ref16.apply(this, arguments);
  };
}();

/* 实名认证 */

/*获取 -年又-天  没区分年直接除365*/
function dateDeath(starTime1, endTime1) {
  //转换时间
  var endTime2 = endTime1 || getDateNow();
  var startime = new Date(starTime1);
  var endtime = new Date(endTime2);
  //得到两个时间的年月日
  var start = {
    year: startime.getFullYear(),
    month: startime.getMonth() - 0 + 1,
    day: startime.getDate()
  };
  var end = {
    year: endtime.getFullYear(),
    month: endtime.getMonth() - 0 + 1,
    day: endtime.getDate()
  };
  var diff = {};
  //日期年份差值
  diff.year = end.year - start.year;
  var star = new Date(startime.getMonth() - 0 + 1 + "/" + startime.getDate() + "/01");
  var endda = new Date(endtime.getMonth() - 0 + 1 + "/" + endtime.getDate() + "/01");
  //天数差值
  diff.day = computer(starTime1) % 365;
  var year = diff.year - 1;
  var year1 = star.getTime() - 0 >= endda.getTime() - 0 ? year : diff.year;
  var sj = "";
  if (computer(starTime1) % 365 === 0) {
    sj = year + '年';
  } else {
    if (year1 === 0) {
      sj = diff.day + '天';
    } else {
      if (star.getTime() - 0 >= endda.getTime() - 0) {
        sj = year + '年又' + diff.day + '天';
      } else {
        sj = diff.year + '年又' + diff.day + '天';
      }
    }
  }
  return sj;
}
/*获取从今年起*/
function Fromthisyear() {
  var resultDate, year;
  var currDate = new Date();
  year = currDate.getFullYear();
  resultDate = year + '-' + "01" + '-' + "01";
  return resultDate;
}
/*获取距今多少天*/
function computer(date) {
  var now = new Date(); //获取当前时间戳
  var future = new Date(date); //距离的时间
  var index = (now - future) / 1000 / (60 * 60 * 24);
  var day = parseInt(index); //天
  var str = day;
  return str;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/leftArrow_header.953f6cd7.png";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1553);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(49);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrender = __webpack_require__(404);

var zrUtil = __webpack_require__(6);

var colorTool = __webpack_require__(195);

var env = __webpack_require__(64);

var timsort = __webpack_require__(397);

var Eventful = __webpack_require__(194);

var GlobalModel = __webpack_require__(1079);

var ExtensionAPI = __webpack_require__(1031);

var CoordinateSystemManager = __webpack_require__(298);

var OptionManager = __webpack_require__(1080);

var backwardCompat = __webpack_require__(1087);

var ComponentModel = __webpack_require__(102);

var SeriesModel = __webpack_require__(302);

var ComponentView = __webpack_require__(1094);

var ChartView = __webpack_require__(306);

var graphic = __webpack_require__(34);

var modelUtil = __webpack_require__(45);

var _throttle = __webpack_require__(305);

var throttle = _throttle.throttle;

var seriesColor = __webpack_require__(1096);

var loadingDefault = __webpack_require__(1078);

/*!
 * ECharts, a javascript interactive chart library.
 *
 * Copyright (c) 2015, Baidu Inc.
 * All rights reserved.
 *
 * LICENSE
 * https://github.com/ecomfe/echarts/blob/master/LICENSE.txt
 */
var each = zrUtil.each;
var parseClassType = ComponentModel.parseClassType;
var version = '3.8.5';
var dependencies = {
  zrender: '3.7.4'
};
var PRIORITY_PROCESSOR_FILTER = 1000;
var PRIORITY_PROCESSOR_STATISTIC = 5000;
var PRIORITY_VISUAL_LAYOUT = 1000;
var PRIORITY_VISUAL_GLOBAL = 2000;
var PRIORITY_VISUAL_CHART = 3000;
var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
// necessary?

var PRIORITY_VISUAL_BRUSH = 5000;
var PRIORITY = {
  PROCESSOR: {
    FILTER: PRIORITY_PROCESSOR_FILTER,
    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
  },
  VISUAL: {
    LAYOUT: PRIORITY_VISUAL_LAYOUT,
    GLOBAL: PRIORITY_VISUAL_GLOBAL,
    CHART: PRIORITY_VISUAL_CHART,
    COMPONENT: PRIORITY_VISUAL_COMPONENT,
    BRUSH: PRIORITY_VISUAL_BRUSH
  }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).

var IN_MAIN_PROCESS = '__flagInMainProcess';
var HAS_GRADIENT_OR_PATTERN_BG = '__hasGradientOrPatternBg';
var OPTION_UPDATED = '__optionUpdated';
var ACTION_REG = /^[a-zA-Z0-9_]+$/;

function createRegisterEventWithLowercaseName(method) {
  return function (eventName, handler, context) {
    // Event name is all lowercase
    eventName = eventName && eventName.toLowerCase();
    Eventful.prototype[method].call(this, eventName, handler, context);
  };
}
/**
 * @module echarts~MessageCenter
 */


function MessageCenter() {
  Eventful.call(this);
}

MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on');
MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off');
MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one');
zrUtil.mixin(MessageCenter, Eventful);
/**
 * @module echarts~ECharts
 */

function ECharts(dom, theme, opts) {
  opts = opts || {}; // Get theme by name

  if (typeof theme === 'string') {
    theme = themeStorage[theme];
  }
  /**
   * @type {string}
   */


  this.id;
  /**
   * Group id
   * @type {string}
   */

  this.group;
  /**
   * @type {HTMLElement}
   * @private
   */

  this._dom = dom;
  var defaultRenderer = 'canvas';

  /**
   * @type {module:zrender/ZRender}
   * @private
   */
  var zr = this._zr = zrender.init(dom, {
    renderer: opts.renderer || defaultRenderer,
    devicePixelRatio: opts.devicePixelRatio,
    width: opts.width,
    height: opts.height
  });
  /**
   * Expect 60 pfs.
   * @type {Function}
   * @private
   */

  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
  var theme = zrUtil.clone(theme);
  theme && backwardCompat(theme, true);
  /**
   * @type {Object}
   * @private
   */

  this._theme = theme;
  /**
   * @type {Array.<module:echarts/view/Chart>}
   * @private
   */

  this._chartsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Chart>}
   * @private
   */

  this._chartsMap = {};
  /**
   * @type {Array.<module:echarts/view/Component>}
   * @private
   */

  this._componentsViews = [];
  /**
   * @type {Object.<string, module:echarts/view/Component>}
   * @private
   */

  this._componentsMap = {};
  /**
   * @type {module:echarts/CoordinateSystem}
   * @private
   */

  this._coordSysMgr = new CoordinateSystemManager();
  /**
   * @type {module:echarts/ExtensionAPI}
   * @private
   */

  this._api = createExtensionAPI(this);
  Eventful.call(this);
  /**
   * @type {module:echarts~MessageCenter}
   * @private
   */

  this._messageCenter = new MessageCenter(); // Init mouse events

  this._initEvents(); // In case some people write `window.onresize = chart.resize`


  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure

  this._pendingActions = []; // Sort on demand

  function prioritySortFunc(a, b) {
    return a.prio - b.prio;
  }

  timsort(visualFuncs, prioritySortFunc);
  timsort(dataProcessorFuncs, prioritySortFunc);
  zr.animation.on('frame', this._onframe, this); // ECharts instance can be used as value.

  zrUtil.setAsPrimitive(this);
}

var echartsProto = ECharts.prototype;

echartsProto._onframe = function () {
  // Lazy update
  if (this[OPTION_UPDATED]) {
    var silent = this[OPTION_UPDATED].silent;
    this[IN_MAIN_PROCESS] = true;
    updateMethods.prepareAndUpdate.call(this);
    this[IN_MAIN_PROCESS] = false;
    this[OPTION_UPDATED] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  }
};
/**
 * @return {HTMLElement}
 */


echartsProto.getDom = function () {
  return this._dom;
};
/**
 * @return {module:zrender~ZRender}
 */


echartsProto.getZr = function () {
  return this._zr;
};
/**
 * Usage:
 * chart.setOption(option, notMerge, lazyUpdate);
 * chart.setOption(option, {
 *     notMerge: ...,
 *     lazyUpdate: ...,
 *     silent: ...
 * });
 *
 * @param {Object} option
 * @param {Object|boolean} [opts] opts or notMerge.
 * @param {boolean} [opts.notMerge=false]
 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
 */


echartsProto.setOption = function (option, notMerge, lazyUpdate) {
  var silent;

  if (zrUtil.isObject(notMerge)) {
    lazyUpdate = notMerge.lazyUpdate;
    silent = notMerge.silent;
    notMerge = notMerge.notMerge;
  }

  this[IN_MAIN_PROCESS] = true;

  if (!this._model || notMerge) {
    var optionManager = new OptionManager(this._api);
    var theme = this._theme;
    var ecModel = this._model = new GlobalModel(null, null, theme, optionManager);
    ecModel.init(null, null, theme, optionManager);
  }

  this._model.setOption(option, optionPreprocessorFuncs);

  if (lazyUpdate) {
    this[OPTION_UPDATED] = {
      silent: silent
    };
    this[IN_MAIN_PROCESS] = false;
  } else {
    updateMethods.prepareAndUpdate.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
    // fetched after `setOption`.

    this._zr.flush();

    this[OPTION_UPDATED] = false;
    this[IN_MAIN_PROCESS] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  }
};
/**
 * @DEPRECATED
 */


echartsProto.setTheme = function () {
  console.log('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
};
/**
 * @return {module:echarts/model/Global}
 */


echartsProto.getModel = function () {
  return this._model;
};
/**
 * @return {Object}
 */


echartsProto.getOption = function () {
  return this._model && this._model.getOption();
};
/**
 * @return {number}
 */


echartsProto.getWidth = function () {
  return this._zr.getWidth();
};
/**
 * @return {number}
 */


echartsProto.getHeight = function () {
  return this._zr.getHeight();
};
/**
 * @return {number}
 */


echartsProto.getDevicePixelRatio = function () {
  return this._zr.painter.dpr || window.devicePixelRatio || 1;
};
/**
 * Get canvas which has all thing rendered
 * @param {Object} opts
 * @param {string} [opts.backgroundColor]
 * @return {string}
 */


echartsProto.getRenderedCanvas = function (opts) {
  if (!env.canvasSupported) {
    return;
  }

  opts = opts || {};
  opts.pixelRatio = opts.pixelRatio || 1;
  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
  var zr = this._zr;
  var list = zr.storage.getDisplayList(); // Stop animations

  zrUtil.each(list, function (el) {
    el.stopAnimation(true);
  });
  return zr.painter.getRenderedCanvas(opts);
};
/**
 * Get svg data url
 * @return {string}
 */


echartsProto.getSvgDataUrl = function () {
  if (!env.svgSupported) {
    return;
  }

  var zr = this._zr;
  var list = zr.storage.getDisplayList(); // Stop animations

  zrUtil.each(list, function (el) {
    el.stopAnimation(true);
  });
  return zr.painter.pathToSvg();
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 * @param {string} [opts.excludeComponents]
 */


echartsProto.getDataURL = function (opts) {
  opts = opts || {};
  var excludeComponents = opts.excludeComponents;
  var ecModel = this._model;
  var excludesComponentViews = [];
  var self = this;
  each(excludeComponents, function (componentType) {
    ecModel.eachComponent({
      mainType: componentType
    }, function (component) {
      var view = self._componentsMap[component.__viewId];

      if (!view.group.ignore) {
        excludesComponentViews.push(view);
        view.group.ignore = true;
      }
    });
  });
  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataUrl() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
  each(excludesComponentViews, function (view) {
    view.group.ignore = false;
  });
  return url;
};
/**
 * @return {string}
 * @param {Object} opts
 * @param {string} [opts.type='png']
 * @param {string} [opts.pixelRatio=1]
 * @param {string} [opts.backgroundColor]
 */


echartsProto.getConnectedDataURL = function (opts) {
  if (!env.canvasSupported) {
    return;
  }

  var groupId = this.group;
  var mathMin = Math.min;
  var mathMax = Math.max;
  var MAX_NUMBER = Infinity;

  if (connectedGroups[groupId]) {
    var left = MAX_NUMBER;
    var top = MAX_NUMBER;
    var right = -MAX_NUMBER;
    var bottom = -MAX_NUMBER;
    var canvasList = [];
    var dpr = opts && opts.pixelRatio || 1;
    zrUtil.each(instances, function (chart, id) {
      if (chart.group === groupId) {
        var canvas = chart.getRenderedCanvas(zrUtil.clone(opts));
        var boundingRect = chart.getDom().getBoundingClientRect();
        left = mathMin(boundingRect.left, left);
        top = mathMin(boundingRect.top, top);
        right = mathMax(boundingRect.right, right);
        bottom = mathMax(boundingRect.bottom, bottom);
        canvasList.push({
          dom: canvas,
          left: boundingRect.left,
          top: boundingRect.top
        });
      }
    });
    left *= dpr;
    top *= dpr;
    right *= dpr;
    bottom *= dpr;
    var width = right - left;
    var height = bottom - top;
    var targetCanvas = zrUtil.createCanvas();
    targetCanvas.width = width;
    targetCanvas.height = height;
    var zr = zrender.init(targetCanvas);
    each(canvasList, function (item) {
      var img = new graphic.Image({
        style: {
          x: item.left * dpr - left,
          y: item.top * dpr - top,
          image: item.dom
        }
      });
      zr.add(img);
    });
    zr.refreshImmediately();
    return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
  } else {
    return this.getDataURL(opts);
  }
};
/**
 * Convert from logical coordinate system to pixel coordinate system.
 * See CoordinateSystem#convertToPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId, geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */


echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
/**
 * Convert from pixel coordinate system to logical coordinate system.
 * See CoordinateSystem#convertFromPixel.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {Array|number} result
 */

echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');

function doConvertPixel(methodName, finder, value) {
  var ecModel = this._model;

  var coordSysList = this._coordSysMgr.getCoordinateSystems();

  var result;
  finder = modelUtil.parseFinder(ecModel, finder);

  for (var i = 0; i < coordSysList.length; i++) {
    var coordSys = coordSysList[i];

    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
      return result;
    }
  }
}
/**
 * Is the specified coordinate systems or components contain the given pixel point.
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            geoIndex / geoId / geoName,
 *            bmapIndex / bmapId / bmapName,
 *            xAxisIndex / xAxisId / xAxisName,
 *            yAxisIndex / yAxisId / yAxisName,
 *            gridIndex / gridId / gridName,
 *            ... (can be extended)
 *        }
 * @param {Array|number} value
 * @return {boolean} result
 */


echartsProto.containPixel = function (finder, value) {
  var ecModel = this._model;
  var result;
  finder = modelUtil.parseFinder(ecModel, finder);
  zrUtil.each(finder, function (models, key) {
    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
      var coordSys = model.coordinateSystem;

      if (coordSys && coordSys.containPoint) {
        result |= !!coordSys.containPoint(value);
      } else if (key === 'seriesModels') {
        var view = this._chartsMap[model.__viewId];

        if (view && view.containPoint) {
          result |= view.containPoint(value, model);
        } else {}
      } else {}
    }, this);
  }, this);
  return !!result;
};
/**
 * Get visual from series or data.
 * @param {string|Object} finder
 *        If string, e.g., 'series', means {seriesIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex / seriesId / seriesName,
 *            dataIndex / dataIndexInside
 *        }
 *        If dataIndex is not specified, series visual will be fetched,
 *        but not data item visual.
 *        If all of seriesIndex, seriesId, seriesName are not specified,
 *        visual will be fetched from first series.
 * @param {string} visualType 'color', 'symbol', 'symbolSize'
 */


echartsProto.getVisual = function (finder, visualType) {
  var ecModel = this._model;
  finder = modelUtil.parseFinder(ecModel, finder, {
    defaultMainType: 'series'
  });
  var seriesModel = finder.seriesModel;
  var data = seriesModel.getData();
  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
};
/**
 * Get view of corresponding component model
 * @param  {module:echarts/model/Component} componentModel
 * @return {module:echarts/view/Component}
 */


echartsProto.getViewOfComponentModel = function (componentModel) {
  return this._componentsMap[componentModel.__viewId];
};
/**
 * Get view of corresponding series model
 * @param  {module:echarts/model/Series} seriesModel
 * @return {module:echarts/view/Chart}
 */


echartsProto.getViewOfSeriesModel = function (seriesModel) {
  return this._chartsMap[seriesModel.__viewId];
};

var updateMethods = {
  /**
   * @param {Object} payload
   * @private
   */
  update: function (payload) {
    // console.profile && console.profile('update');
    var ecModel = this._model;
    var api = this._api;
    var coordSysMgr = this._coordSysMgr;
    var zr = this._zr; // update before setOption

    if (!ecModel) {
      return;
    } // Fixme First time update ?


    ecModel.restoreData(); // TODO
    // Save total ecModel here for undo/redo (after restoring data and before processing data).
    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
    // Create new coordinate system each update
    // In LineView may save the old coordinate system and use it to get the orignal point

    coordSysMgr.create(this._model, this._api);
    processData.call(this, ecModel, api);
    stackSeriesData.call(this, ecModel);
    coordSysMgr.update(ecModel, api);
    doVisualEncoding.call(this, ecModel, payload);
    doRender.call(this, ecModel, payload); // Set background

    var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
    var painter = zr.painter; // TODO all use clearColor ?

    if (painter.isSingleCanvas && painter.isSingleCanvas()) {
      zr.configLayer(0, {
        clearColor: backgroundColor
      });
    } else {
      // In IE8
      if (!env.canvasSupported) {
        var colorArr = colorTool.parse(backgroundColor);
        backgroundColor = colorTool.stringify(colorArr, 'rgb');

        if (colorArr[3] === 0) {
          backgroundColor = 'transparent';
        }
      }

      if (backgroundColor.colorStops || backgroundColor.image) {
        // Gradient background
        // FIXME Fixed layer？
        zr.configLayer(0, {
          clearColor: backgroundColor
        });
        this[HAS_GRADIENT_OR_PATTERN_BG] = true;
        this._dom.style.background = 'transparent';
      } else {
        if (this[HAS_GRADIENT_OR_PATTERN_BG]) {
          zr.configLayer(0, {
            clearColor: null
          });
        }

        this[HAS_GRADIENT_OR_PATTERN_BG] = false;
        this._dom.style.background = backgroundColor;
      }
    }

    each(postUpdateFuncs, function (func) {
      func(ecModel, api);
    }); // console.profile && console.profileEnd('update');
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateView: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    ecModel.eachSeries(function (seriesModel) {
      seriesModel.getData().clearAllVisual();
    });
    doVisualEncoding.call(this, ecModel, payload);
    invokeUpdateMethod.call(this, 'updateView', ecModel, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateVisual: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    ecModel.eachSeries(function (seriesModel) {
      seriesModel.getData().clearAllVisual();
    });
    doVisualEncoding.call(this, ecModel, payload, true);
    invokeUpdateMethod.call(this, 'updateVisual', ecModel, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  updateLayout: function (payload) {
    var ecModel = this._model; // update before setOption

    if (!ecModel) {
      return;
    }

    doLayout.call(this, ecModel, payload);
    invokeUpdateMethod.call(this, 'updateLayout', ecModel, payload);
  },

  /**
   * @param {Object} payload
   * @private
   */
  prepareAndUpdate: function (payload) {
    var ecModel = this._model;
    prepareView.call(this, 'component', ecModel);
    prepareView.call(this, 'chart', ecModel);
    updateMethods.update.call(this, payload);
  }
};
/**
 * @private
 */

function updateDirectly(ecIns, method, payload, mainType, subType) {
  var ecModel = ecIns._model; // broadcast

  if (!mainType) {
    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
    return;
  }

  var query = {};
  query[mainType + 'Id'] = payload[mainType + 'Id'];
  query[mainType + 'Index'] = payload[mainType + 'Index'];
  query[mainType + 'Name'] = payload[mainType + 'Name'];
  var condition = {
    mainType: mainType,
    query: query
  };
  subType && (condition.subType = subType); // subType may be '' by parseClassType;
  // If dispatchAction before setOption, do nothing.

  ecModel && ecModel.eachComponent(condition, function (model, index) {
    callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
  }, ecIns);

  function callView(view) {
    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
  }
}
/**
 * Resize the chart
 * @param {Object} opts
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 * @param {boolean} [opts.silent=false]
 */


echartsProto.resize = function (opts) {
  this[IN_MAIN_PROCESS] = true;

  this._zr.resize(opts);

  var optionChanged = this._model && this._model.resetOption('media');

  var updateMethod = optionChanged ? 'prepareAndUpdate' : 'update';
  updateMethods[updateMethod].call(this); // Resize loading effect

  this._loadingFX && this._loadingFX.resize();
  this[IN_MAIN_PROCESS] = false;
  var silent = opts && opts.silent;
  flushPendingActions.call(this, silent);
  triggerUpdatedEvent.call(this, silent);
};
/**
 * Show loading effect
 * @param  {string} [name='default']
 * @param  {Object} [cfg]
 */


echartsProto.showLoading = function (name, cfg) {
  if (zrUtil.isObject(name)) {
    cfg = name;
    name = '';
  }

  name = name || 'default';
  this.hideLoading();

  if (!loadingEffects[name]) {
    return;
  }

  var el = loadingEffects[name](this._api, cfg);
  var zr = this._zr;
  this._loadingFX = el;
  zr.add(el);
};
/**
 * Hide loading effect
 */


echartsProto.hideLoading = function () {
  this._loadingFX && this._zr.remove(this._loadingFX);
  this._loadingFX = null;
};
/**
 * @param {Object} eventObj
 * @return {Object}
 */


echartsProto.makeActionFromEvent = function (eventObj) {
  var payload = zrUtil.extend({}, eventObj);
  payload.type = eventActionMap[eventObj.type];
  return payload;
};
/**
 * @pubilc
 * @param {Object} payload
 * @param {string} [payload.type] Action type
 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
 * @param {boolean} [opt.silent=false] Whether trigger events.
 * @param {boolean} [opt.flush=undefined]
 *                  true: Flush immediately, and then pixel in canvas can be fetched
 *                      immediately. Caution: it might affect performance.
 *                  false: Not not flush.
 *                  undefined: Auto decide whether perform flush.
 */


echartsProto.dispatchAction = function (payload, opt) {
  if (!zrUtil.isObject(opt)) {
    opt = {
      silent: !!opt
    };
  }

  if (!actions[payload.type]) {
    return;
  } // Avoid dispatch action before setOption. Especially in `connect`.


  if (!this._model) {
    return;
  } // May dispatchAction in rendering procedure


  if (this[IN_MAIN_PROCESS]) {
    this._pendingActions.push(payload);

    return;
  }

  doDispatchAction.call(this, payload, opt.silent);

  if (opt.flush) {
    this._zr.flush(true);
  } else if (opt.flush !== false && env.browser.weChat) {
    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
    // hang when sliding page (on touch event), which cause that zr does not
    // refresh util user interaction finished, which is not expected.
    // But `dispatchAction` may be called too frequently when pan on touch
    // screen, which impacts performance if do not throttle them.
    this._throttledZrFlush();
  }

  flushPendingActions.call(this, opt.silent);
  triggerUpdatedEvent.call(this, opt.silent);
};

function doDispatchAction(payload, silent) {
  var payloadType = payload.type;
  var escapeConnect = payload.escapeConnect;
  var actionWrap = actions[payloadType];
  var actionInfo = actionWrap.actionInfo;
  var cptType = (actionInfo.update || 'update').split(':');
  var updateMethod = cptType.pop();
  cptType = cptType[0] != null && parseClassType(cptType[0]);
  this[IN_MAIN_PROCESS] = true;
  var payloads = [payload];
  var batched = false; // Batch action

  if (payload.batch) {
    batched = true;
    payloads = zrUtil.map(payload.batch, function (item) {
      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
      item.batch = null;
      return item;
    });
  }

  var eventObjBatch = [];
  var eventObj;
  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
  each(payloads, function (batchItem) {
    // Action can specify the event by return it.
    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside

    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType

    eventObj.type = actionInfo.event || eventObj.type;
    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.

    if (isHighDown) {
      // method, payload, mainType, subType
      updateDirectly(this, updateMethod, batchItem, 'series');
    } else if (cptType) {
      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
    }
  }, this);

  if (updateMethod !== 'none' && !isHighDown && !cptType) {
    // Still dirty
    if (this[OPTION_UPDATED]) {
      // FIXME Pass payload ?
      updateMethods.prepareAndUpdate.call(this, payload);
      this[OPTION_UPDATED] = false;
    } else {
      updateMethods[updateMethod].call(this, payload);
    }
  } // Follow the rule of action batch


  if (batched) {
    eventObj = {
      type: actionInfo.event || payloadType,
      escapeConnect: escapeConnect,
      batch: eventObjBatch
    };
  } else {
    eventObj = eventObjBatch[0];
  }

  this[IN_MAIN_PROCESS] = false;
  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
}

function flushPendingActions(silent) {
  var pendingActions = this._pendingActions;

  while (pendingActions.length) {
    var payload = pendingActions.shift();
    doDispatchAction.call(this, payload, silent);
  }
}

function triggerUpdatedEvent(silent) {
  !silent && this.trigger('updated');
}
/**
 * Register event
 * @method
 */


echartsProto.on = createRegisterEventWithLowercaseName('on');
echartsProto.off = createRegisterEventWithLowercaseName('off');
echartsProto.one = createRegisterEventWithLowercaseName('one');
/**
 * @param {string} methodName
 * @private
 */

function invokeUpdateMethod(methodName, ecModel, payload) {
  var api = this._api; // Update all components

  each(this._componentsViews, function (component) {
    var componentModel = component.__model;
    component[methodName](componentModel, ecModel, api, payload);
    updateZ(componentModel, component);
  }, this); // Upate all charts

  ecModel.eachSeries(function (seriesModel, idx) {
    var chart = this._chartsMap[seriesModel.__viewId];
    chart[methodName](seriesModel, ecModel, api, payload);
    updateZ(seriesModel, chart);
    updateProgressiveAndBlend(seriesModel, chart);
  }, this); // If use hover layer

  updateHoverLayerStatus(this._zr, ecModel); // Post render

  each(postUpdateFuncs, function (func) {
    func(ecModel, api);
  });
}
/**
 * Prepare view instances of charts and components
 * @param  {module:echarts/model/Global} ecModel
 * @private
 */


function prepareView(type, ecModel) {
  var isComponent = type === 'component';
  var viewList = isComponent ? this._componentsViews : this._chartsViews;
  var viewMap = isComponent ? this._componentsMap : this._chartsMap;
  var zr = this._zr;

  for (var i = 0; i < viewList.length; i++) {
    viewList[i].__alive = false;
  }

  ecModel[isComponent ? 'eachComponent' : 'eachSeries'](function (componentType, model) {
    if (isComponent) {
      if (componentType === 'series') {
        return;
      }
    } else {
      model = componentType;
    } // Consider: id same and type changed.


    var viewId = '_ec_' + model.id + '_' + model.type;
    var view = viewMap[viewId];

    if (!view) {
      var classType = parseClassType(model.type);
      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);

      if (Clazz) {
        view = new Clazz();
        view.init(ecModel, this._api);
        viewMap[viewId] = view;
        viewList.push(view);
        zr.add(view.group);
      } else {
        // Error
        return;
      }
    }

    model.__viewId = view.__id = viewId;
    view.__alive = true;
    view.__model = model;
    view.group.__ecComponentInfo = {
      mainType: model.mainType,
      index: model.componentIndex
    };
  }, this);

  for (var i = 0; i < viewList.length;) {
    var view = viewList[i];

    if (!view.__alive) {
      zr.remove(view.group);
      view.dispose(ecModel, this._api);
      viewList.splice(i, 1);
      delete viewMap[view.__id];
      view.__id = view.group.__ecComponentInfo = null;
    } else {
      i++;
    }
  }
}
/**
 * Processor data in each series
 *
 * @param {module:echarts/model/Global} ecModel
 * @private
 */


function processData(ecModel, api) {
  each(dataProcessorFuncs, function (process) {
    process.func(ecModel, api);
  });
}
/**
 * @private
 */


function stackSeriesData(ecModel) {
  var stackedDataMap = {};
  ecModel.eachSeries(function (series) {
    var stack = series.get('stack');
    var data = series.getData();

    if (stack && data.type === 'list') {
      var previousStack = stackedDataMap[stack]; // Avoid conflict with Object.prototype

      if (stackedDataMap.hasOwnProperty(stack) && previousStack) {
        data.stackedOn = previousStack;
      }

      stackedDataMap[stack] = data;
    }
  });
}
/**
 * Layout before each chart render there series, special visual encoding stage
 *
 * @param {module:echarts/model/Global} ecModel
 * @private
 */


function doLayout(ecModel, payload) {
  var api = this._api;
  each(visualFuncs, function (visual) {
    if (visual.isLayout) {
      visual.func(ecModel, api, payload);
    }
  });
}
/**
 * Encode visual infomation from data after data processing
 *
 * @param {module:echarts/model/Global} ecModel
 * @param {object} layout
 * @param {boolean} [excludesLayout]
 * @private
 */


function doVisualEncoding(ecModel, payload, excludesLayout) {
  var api = this._api;
  ecModel.clearColorPalette();
  ecModel.eachSeries(function (seriesModel) {
    seriesModel.clearColorPalette();
  });
  each(visualFuncs, function (visual) {
    (!excludesLayout || !visual.isLayout) && visual.func(ecModel, api, payload);
  });
}
/**
 * Render each chart and component
 * @private
 */


function doRender(ecModel, payload) {
  var api = this._api; // Render all components

  each(this._componentsViews, function (componentView) {
    var componentModel = componentView.__model;
    componentView.render(componentModel, ecModel, api, payload);
    updateZ(componentModel, componentView);
  }, this);
  each(this._chartsViews, function (chart) {
    chart.__alive = false;
  }, this); // Render all charts

  ecModel.eachSeries(function (seriesModel, idx) {
    var chartView = this._chartsMap[seriesModel.__viewId];
    chartView.__alive = true;
    chartView.render(seriesModel, ecModel, api, payload);
    chartView.group.silent = !!seriesModel.get('silent');
    updateZ(seriesModel, chartView);
    updateProgressiveAndBlend(seriesModel, chartView);
  }, this); // If use hover layer

  updateHoverLayerStatus(this._zr, ecModel); // Remove groups of unrendered charts

  each(this._chartsViews, function (chart) {
    if (!chart.__alive) {
      chart.remove(ecModel, api);
    }
  }, this);
}

var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
/**
 * @private
 */

echartsProto._initEvents = function () {
  each(MOUSE_EVENT_NAMES, function (eveName) {
    this._zr.on(eveName, function (e) {
      var ecModel = this.getModel();
      var el = e.target;
      var params; // no e.target when 'globalout'.

      if (eveName === 'globalout') {
        params = {};
      } else if (el && el.dataIndex != null) {
        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType) || {};
      } // If element has custom eventData of components
      else if (el && el.eventData) {
          params = zrUtil.extend({}, el.eventData);
        }

      if (params) {
        params.event = e;
        params.type = eveName;
        this.trigger(eveName, params);
      }
    }, this);
  }, this);
  each(eventActionMap, function (actionType, eventType) {
    this._messageCenter.on(eventType, function (event) {
      this.trigger(eventType, event);
    }, this);
  }, this);
};
/**
 * @return {boolean}
 */


echartsProto.isDisposed = function () {
  return this._disposed;
};
/**
 * Clear
 */


echartsProto.clear = function () {
  this.setOption({
    series: []
  }, true);
};
/**
 * Dispose instance
 */


echartsProto.dispose = function () {
  if (this._disposed) {
    return;
  }

  this._disposed = true;
  var api = this._api;
  var ecModel = this._model;
  each(this._componentsViews, function (component) {
    component.dispose(ecModel, api);
  });
  each(this._chartsViews, function (chart) {
    chart.dispose(ecModel, api);
  }); // Dispose after all views disposed

  this._zr.dispose();

  delete instances[this.id];
};

zrUtil.mixin(ECharts, Eventful);

function updateHoverLayerStatus(zr, ecModel) {
  var storage = zr.storage;
  var elCount = 0;
  storage.traverse(function (el) {
    if (!el.isGroup) {
      elCount++;
    }
  });

  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
    storage.traverse(function (el) {
      if (!el.isGroup) {
        el.useHoverLayer = true;
      }
    });
  }
}
/**
 * Update chart progressive and blend.
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateProgressiveAndBlend(seriesModel, chartView) {
  // Progressive configuration
  var elCount = 0;
  chartView.group.traverse(function (el) {
    if (el.type !== 'group' && !el.ignore) {
      elCount++;
    }
  });
  var frameDrawNum = +seriesModel.get('progressive');
  var needProgressive = elCount > seriesModel.get('progressiveThreshold') && frameDrawNum && !env.node;

  if (needProgressive) {
    chartView.group.traverse(function (el) {
      // FIXME marker and other components
      if (!el.isGroup) {
        el.progressive = needProgressive ? Math.floor(elCount++ / frameDrawNum) : -1;

        if (needProgressive) {
          el.stopAnimation(true);
        }
      }
    });
  } // Blend configration


  var blendMode = seriesModel.get('blendMode') || null;
  chartView.group.traverse(function (el) {
    // FIXME marker and other components
    if (!el.isGroup) {
      el.setStyle('blend', blendMode);
    }
  });
}
/**
 * @param {module:echarts/model/Series|module:echarts/model/Component} model
 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
 */


function updateZ(model, view) {
  var z = model.get('z');
  var zlevel = model.get('zlevel'); // Set z and zlevel

  view.group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
    }
  });
}

function createExtensionAPI(ecInstance) {
  var coordSysMgr = ecInstance._coordSysMgr;
  return zrUtil.extend(new ExtensionAPI(ecInstance), {
    // Inject methods
    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
    getComponentByElement: function (el) {
      while (el) {
        var modelInfo = el.__ecComponentInfo;

        if (modelInfo != null) {
          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
        }

        el = el.parent;
      }
    }
  });
}
/**
 * @type {Object} key: actionType.
 * @inner
 */


var actions = {};
/**
 * Map eventType to actionType
 * @type {Object}
 */

var eventActionMap = {};
/**
 * Data processor functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */

var dataProcessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var optionPreprocessorFuncs = [];
/**
 * @type {Array.<Function>}
 * @inner
 */

var postUpdateFuncs = [];
/**
 * Visual encoding functions of each stage
 * @type {Array.<Object.<string, Function>>}
 * @inner
 */

var visualFuncs = [];
/**
 * Theme storage
 * @type {Object.<key, Object>}
 */

var themeStorage = {};
/**
 * Loading effects
 */

var loadingEffects = {};
var instances = {};
var connectedGroups = {};
var idBase = new Date() - 0;
var groupIdBase = new Date() - 0;
var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
var mapDataStores = {};

function enableConnect(chart) {
  var STATUS_PENDING = 0;
  var STATUS_UPDATING = 1;
  var STATUS_UPDATED = 2;
  var STATUS_KEY = '__connectUpdateStatus';

  function updateConnectedChartsStatus(charts, status) {
    for (var i = 0; i < charts.length; i++) {
      var otherChart = charts[i];
      otherChart[STATUS_KEY] = status;
    }
  }

  zrUtil.each(eventActionMap, function (actionType, eventType) {
    chart._messageCenter.on(eventType, function (event) {
      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
        if (event && event.escapeConnect) {
          return;
        }

        var action = chart.makeActionFromEvent(event);
        var otherCharts = [];
        zrUtil.each(instances, function (otherChart) {
          if (otherChart !== chart && otherChart.group === chart.group) {
            otherCharts.push(otherChart);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
        each(otherCharts, function (otherChart) {
          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
            otherChart.dispatchAction(action);
          }
        });
        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
      }
    });
  });
}
/**
 * @param {HTMLElement} dom
 * @param {Object} [theme]
 * @param {Object} opts
 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
 * @param {string} [opts.renderer] Currently only 'canvas' is supported.
 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
 *                              Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
 *                               Can be 'auto' (the same as null/undefined)
 */


function init(dom, theme, opts) {
  var existInstance = getInstanceByDom(dom);

  if (existInstance) {
    return existInstance;
  }

  var chart = new ECharts(dom, theme, opts);
  chart.id = 'ec_' + idBase++;
  instances[chart.id] = chart;

  if (dom.setAttribute) {
    dom.setAttribute(DOM_ATTRIBUTE_KEY, chart.id);
  } else {
    dom[DOM_ATTRIBUTE_KEY] = chart.id;
  }

  enableConnect(chart);
  return chart;
}
/**
 * @return {string|Array.<module:echarts~ECharts>} groupId
 */


function connect(groupId) {
  // Is array of charts
  if (zrUtil.isArray(groupId)) {
    var charts = groupId;
    groupId = null; // If any chart has group

    zrUtil.each(charts, function (chart) {
      if (chart.group != null) {
        groupId = chart.group;
      }
    });
    groupId = groupId || 'g_' + groupIdBase++;
    zrUtil.each(charts, function (chart) {
      chart.group = groupId;
    });
  }

  connectedGroups[groupId] = true;
  return groupId;
}
/**
 * @DEPRECATED
 * @return {string} groupId
 */


function disConnect(groupId) {
  connectedGroups[groupId] = false;
}
/**
 * @return {string} groupId
 */


var disconnect = disConnect;
/**
 * Dispose a chart instance
 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
 */

function dispose(chart) {
  if (typeof chart === 'string') {
    chart = instances[chart];
  } else if (!(chart instanceof ECharts)) {
    // Try to treat as dom
    chart = getInstanceByDom(chart);
  }

  if (chart instanceof ECharts && !chart.isDisposed()) {
    chart.dispose();
  }
}
/**
 * @param  {HTMLElement} dom
 * @return {echarts~ECharts}
 */


function getInstanceByDom(dom) {
  var key;

  if (dom.getAttribute) {
    key = dom.getAttribute(DOM_ATTRIBUTE_KEY);
  } else {
    key = dom[DOM_ATTRIBUTE_KEY];
  }

  return instances[key];
}
/**
 * @param {string} key
 * @return {echarts~ECharts}
 */


function getInstanceById(key) {
  return instances[key];
}
/**
 * Register theme
 */


function registerTheme(name, theme) {
  themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 * @param {Function} preprocessorFunc
 */


function registerPreprocessor(preprocessorFunc) {
  optionPreprocessorFuncs.push(preprocessorFunc);
}
/**
 * @param {number} [priority=1000]
 * @param {Function} processorFunc
 */


function registerProcessor(priority, processorFunc) {
  if (typeof priority === 'function') {
    processorFunc = priority;
    priority = PRIORITY_PROCESSOR_FILTER;
  }

  dataProcessorFuncs.push({
    prio: priority,
    func: processorFunc
  });
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */


function registerPostUpdate(postUpdateFunc) {
  postUpdateFuncs.push(postUpdateFunc);
}
/**
 * Usage:
 * registerAction('someAction', 'someEvent', function () { ... });
 * registerAction('someAction', function () { ... });
 * registerAction(
 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
 *     function () { ... }
 * );
 *
 * @param {(string|Object)} actionInfo
 * @param {string} actionInfo.type
 * @param {string} [actionInfo.event]
 * @param {string} [actionInfo.update]
 * @param {string} [eventName]
 * @param {Function} action
 */


function registerAction(actionInfo, eventName, action) {
  if (typeof eventName === 'function') {
    action = eventName;
    eventName = '';
  }

  var actionType = zrUtil.isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
    event: eventName
  }][0]; // Event name is all lowercase

  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
  eventName = actionInfo.event; // Validate action type and event name.

  zrUtil.assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));

  if (!actions[actionType]) {
    actions[actionType] = {
      action: action,
      actionInfo: actionInfo
    };
  }

  eventActionMap[eventName] = actionType;
}
/**
 * @param {string} type
 * @param {*} CoordinateSystem
 */


function registerCoordinateSystem(type, CoordinateSystem) {
  CoordinateSystemManager.register(type, CoordinateSystem);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */


function getCoordinateSystemDimensions(type) {
  var coordSysCreator = CoordinateSystemManager.get(type);

  if (coordSysCreator) {
    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
  }
}
/**
 * Layout is a special stage of visual encoding
 * Most visual encoding like color are common for different chart
 * But each chart has it's own layout algorithm
 *
 * @param {number} [priority=1000]
 * @param {Function} layoutFunc
 */


function registerLayout(priority, layoutFunc) {
  if (typeof priority === 'function') {
    layoutFunc = priority;
    priority = PRIORITY_VISUAL_LAYOUT;
  }

  visualFuncs.push({
    prio: priority,
    func: layoutFunc,
    isLayout: true
  });
}
/**
 * @param {number} [priority=3000]
 * @param {Function} visualFunc
 */


function registerVisual(priority, visualFunc) {
  if (typeof priority === 'function') {
    visualFunc = priority;
    priority = PRIORITY_VISUAL_CHART;
  }

  visualFuncs.push({
    prio: priority,
    func: visualFunc
  });
}
/**
 * @param {string} name
 */


function registerLoading(name, loadingFx) {
  loadingEffects[name] = loadingFx;
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentModel(opts
/*, superClass*/
) {
  // var Clazz = ComponentModel;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return ComponentModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendComponentView(opts
/*, superClass*/
) {
  // var Clazz = ComponentView;
  // if (superClass) {
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
  // }
  return ComponentView.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendSeriesModel(opts
/*, superClass*/
) {
  // var Clazz = SeriesModel;
  // if (superClass) {
  //     superClass = 'series.' + superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
  // }
  return SeriesModel.extend(opts);
}
/**
 * @param {Object} opts
 * @param {string} [superClass]
 */


function extendChartView(opts
/*, superClass*/
) {
  // var Clazz = ChartView;
  // if (superClass) {
  //     superClass = superClass.replace('series.', '');
  //     var classType = parseClassType(superClass);
  //     Clazz = ChartView.getClass(classType.main, true);
  // }
  return ChartView.extend(opts);
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 * Be careful of using it in the browser.
 *
 * @param {Function} creator
 * @example
 *     var Canvas = require('canvas');
 *     var echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */


function setCanvasCreator(creator) {
  zrUtil.$override('createCanvas', creator);
}
/**
 * @param {string} mapName
 * @param {Object|string} geoJson
 * @param {Object} [specialAreas]
 *
 * @example
 *     $.get('USA.json', function (geoJson) {
 *         echarts.registerMap('USA', geoJson);
 *         // Or
 *         echarts.registerMap('USA', {
 *             geoJson: geoJson,
 *             specialAreas: {}
 *         })
 *     });
 */


function registerMap(mapName, geoJson, specialAreas) {
  if (geoJson.geoJson && !geoJson.features) {
    specialAreas = geoJson.specialAreas;
    geoJson = geoJson.geoJson;
  }

  if (typeof geoJson === 'string') {
    geoJson = typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(geoJson) : new Function('return (' + geoJson + ');')();
  }

  mapDataStores[mapName] = {
    geoJson: geoJson,
    specialAreas: specialAreas
  };
}
/**
 * @param {string} mapName
 * @return {Object}
 */


function getMap(mapName) {
  return mapDataStores[mapName];
}

registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
registerPreprocessor(backwardCompat);
registerLoading('default', loadingDefault); // Default actions

registerAction({
  type: 'highlight',
  event: 'highlight',
  update: 'highlight'
}, zrUtil.noop);
registerAction({
  type: 'downplay',
  event: 'downplay',
  update: 'downplay'
}, zrUtil.noop); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.

var dataTool = {};
exports.version = version;
exports.dependencies = dependencies;
exports.PRIORITY = PRIORITY;
exports.init = init;
exports.connect = connect;
exports.disConnect = disConnect;
exports.disconnect = disconnect;
exports.dispose = dispose;
exports.getInstanceByDom = getInstanceByDom;
exports.getInstanceById = getInstanceById;
exports.registerTheme = registerTheme;
exports.registerPreprocessor = registerPreprocessor;
exports.registerProcessor = registerProcessor;
exports.registerPostUpdate = registerPostUpdate;
exports.registerAction = registerAction;
exports.registerCoordinateSystem = registerCoordinateSystem;
exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
exports.registerLayout = registerLayout;
exports.registerVisual = registerVisual;
exports.registerLoading = registerLoading;
exports.extendComponentModel = extendComponentModel;
exports.extendComponentView = extendComponentView;
exports.extendSeriesModel = extendSeriesModel;
exports.extendChartView = extendChartView;
exports.setCanvasCreator = setCanvasCreator;
exports.registerMap = registerMap;
exports.getMap = getMap;
exports.dataTool = dataTool;
var ___ec_export = __webpack_require__(1074);
(function () {
    for (var key in ___ec_export) {
        if (___ec_export.hasOwnProperty(key)) {
            exports[key] = ___ec_export[key];
        }
    }
})();

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fundHistoryRatePage */
/* harmony export (immutable) */ __webpack_exports__["h"] = choseBankIndex;
/* harmony export (immutable) */ __webpack_exports__["i"] = choseCurrentIndex;
/* harmony export (immutable) */ __webpack_exports__["j"] = choseBankOrCurrent;
/* harmony export (immutable) */ __webpack_exports__["l"] = changeCurrentIndex;
/* harmony export (immutable) */ __webpack_exports__["k"] = changeCurrentType;
/* harmony export (immutable) */ __webpack_exports__["J"] = choseCurrencyIndex;
/* harmony export (immutable) */ __webpack_exports__["_0"] = choseTargetIndex;
/* unused harmony export payInfo */
/* unused harmony export currentAccount */
/* unused harmony export productInfo */
/* harmony export (immutable) */ __webpack_exports__["s"] = productListType;
/* harmony export (immutable) */ __webpack_exports__["P"] = getContract;
/* harmony export (immutable) */ __webpack_exports__["Z"] = getProductInfo;
/* unused harmony export fundInfo */
/* harmony export (immutable) */ __webpack_exports__["_1"] = getCamcBankCardList;
/* harmony export (immutable) */ __webpack_exports__["_2"] = validateHqtPay;
/* unused harmony export submitHqtPay */
/* harmony export (immutable) */ __webpack_exports__["Y"] = getPayInfo;
/* harmony export (immutable) */ __webpack_exports__["I"] = getTradeInfo;
/* harmony export (immutable) */ __webpack_exports__["_3"] = getTradeInfo2;
/* unused harmony export getPayAccount */
/* harmony export (immutable) */ __webpack_exports__["_4"] = getLimitAmount;
/* harmony export (immutable) */ __webpack_exports__["W"] = getTransaction;
/* harmony export (immutable) */ __webpack_exports__["X"] = monetaryFundBuyValidate;
/* unused harmony export monetaryFundBuyRequest */
/* unused harmony export rateAndFee */
/* harmony export (immutable) */ __webpack_exports__["V"] = getMoneyChange;
/* harmony export (immutable) */ __webpack_exports__["Q"] = getDoConvert;
/* harmony export (immutable) */ __webpack_exports__["T"] = getMinLimit;
/* harmony export (immutable) */ __webpack_exports__["U"] = getDoRedeem;
/* harmony export (immutable) */ __webpack_exports__["R"] = getTransformationFunList;
/* harmony export (immutable) */ __webpack_exports__["S"] = TransformationFunList;
/* harmony export (immutable) */ __webpack_exports__["m"] = fundLabel;
/* harmony export (immutable) */ __webpack_exports__["n"] = fundListGm;
/* unused harmony export fundListGm2 */
/* harmony export (immutable) */ __webpack_exports__["o"] = fundListSm;
/* harmony export (immutable) */ __webpack_exports__["q"] = fundListJh;
/* harmony export (immutable) */ __webpack_exports__["p"] = fundListZh;
/* unused harmony export fundOperatingList */
/* harmony export (immutable) */ __webpack_exports__["t"] = searchFundList;
/* harmony export (immutable) */ __webpack_exports__["r"] = getFundLabel;
/* harmony export (immutable) */ __webpack_exports__["v"] = getFundListByPublic;
/* harmony export (immutable) */ __webpack_exports__["w"] = getFundListByPrivate;
/* harmony export (immutable) */ __webpack_exports__["y"] = getFundListByBroker;
/* harmony export (immutable) */ __webpack_exports__["x"] = getFundListByAccount;
/* harmony export (immutable) */ __webpack_exports__["u"] = getSearchFundList;
/* harmony export (immutable) */ __webpack_exports__["E"] = fundPublicDetil;
/* unused harmony export AddZx */
/* harmony export (immutable) */ __webpack_exports__["D"] = getPublicProductDetil;
/* harmony export (immutable) */ __webpack_exports__["C"] = fundPrivateDetil;
/* harmony export (immutable) */ __webpack_exports__["B"] = getPrivateProductDetil;
/* harmony export (immutable) */ __webpack_exports__["A"] = fundAggregateDetil;
/* harmony export (immutable) */ __webpack_exports__["z"] = getAggregateProductDetil;
/* harmony export (immutable) */ __webpack_exports__["F"] = reateOptional;
/* harmony export (immutable) */ __webpack_exports__["G"] = deleteOptional;
/* unused harmony export fundHistoryRate */
/* harmony export (immutable) */ __webpack_exports__["H"] = getHistoryProfileRate;
/* harmony export (immutable) */ __webpack_exports__["d"] = articleDetail;
/* harmony export (immutable) */ __webpack_exports__["f"] = getArticleDetail;
/* harmony export (immutable) */ __webpack_exports__["a"] = editLikeArticle;
/* harmony export (immutable) */ __webpack_exports__["e"] = articleMessageList;
/* harmony export (immutable) */ __webpack_exports__["c"] = getArticleMessageList;
/* harmony export (immutable) */ __webpack_exports__["b"] = writeArticleMessage;
/* harmony export (immutable) */ __webpack_exports__["g"] = editLikeMessage;
/* unused harmony export getUserQuestionnaires */
/* unused harmony export queryLastAnswerQuestionnaire */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return hasOtsRiskRearing; });
/* harmony export (immutable) */ __webpack_exports__["M"] = syncCwimToCamcNew;
/* harmony export (immutable) */ __webpack_exports__["L"] = syncCwimRiskToCamcAndStopOutOfRiskBuyPlan;
/* harmony export (immutable) */ __webpack_exports__["O"] = getSuperFundTradeLimit;
/* unused harmony export getRedeemToHqtOk */
/* harmony export (immutable) */ __webpack_exports__["K"] = getRedeemToHqtvalidate;
/* harmony export (immutable) */ __webpack_exports__["_7"] = getFundAnalysisIndicatorOfFiveYears;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getVersionInfo; });
/* harmony export (immutable) */ __webpack_exports__["_10"] = Newpublicinterfacedadian;
/* harmony export (immutable) */ __webpack_exports__["_5"] = Newpublicinterface;
/* harmony export (immutable) */ __webpack_exports__["_6"] = getPublicHistoryProfileRate;
/* harmony export (immutable) */ __webpack_exports__["_8"] = newgetPublicProductDetil;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__myAssets_userInfoAction__ = __webpack_require__(97);


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







//基金历史净值
function fundHistoryRatePage(text) {
  return {
    type: "FUND_HISTORY_RATE_PAGE",
    text: text
  };
}

//更改银行活期通位置
function choseBankIndex(text) {
  return {
    type: "SELECTED_BANK_INDEX",
    text: text
  };
}
function choseCurrentIndex(text) {
  return {
    type: "SELECTED_CURRENT_INDEX",
    text: text
  };
}
function choseBankOrCurrent(text) {
  return {
    type: "BANK_OR_CURRENT",
    text: text
  };
}
function changeCurrentIndex(text) {
  return {
    type: "CURRENT_INDEX",
    text: text
  };
}
function changeCurrentType(text) {
  return {
    type: "CURRENT_TYPE",
    text: text
  };
}
function choseCurrencyIndex(text) {
  return {
    type: "CURRENCY_INDEX",
    text: text
  };
}
function choseTargetIndex(text) {
  return {
    type: "TARGET_INDEX",
    text: text
  };
}
//支付
function payInfo(text) {
  return {
    type: "PAY_INFO",
    text: text
  };
}
function currentAccount(text) {
  return {
    type: "CURRENT_ACCOUNT",
    text: text
  };
}
function productInfo(text) {
  return {
    type: "PRODUCT_INFO",
    text: text
  };
}
//产品类型
function productListType(text) {
  return {
    type: "PRODUCT_LIST_TYPE",
    text: text
  };
}
//合同
function getContract(fundCode, callback) {
  return function (dispatch, getState) {
    // dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d,
        fundCode: fundCode
      };
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/getContract", data, function (result) {
        if (result.code == '0000') {
          callback(result);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
        console.log(result);
      }, function (error) {
        console.log('合同 error');
      });
    }).catch(function (err) {
      // dispatch(pageFlag(false))
    });
  };
}
function getProductInfo() {
  return function (dispatch, getState) {
    var homePage = window.sessionStorage.getItem('homePage');
    if (homePage) {
      dispatch(productInfo(JSON.parse(homePage)));
    } else {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d
      };
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/cms/getHomePage", data, function (result) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        if (result.code == '0000') {
          window.sessionStorage.setItem('homePage', JSON.stringify(result.content));
          dispatch(productInfo(result.content));
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}
//活期通充值
var bankList = function bankList(data) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/getCamcBankCardList", data, function (result) {
      if (result.code == '0000') {
        resolve(result);
      } else {
        reject('1111');
      }
    }, function (error) {
      reject('1111');
      // let toast = Toast.show( Util.errorTxt, getToastConfPoint( ) );
    });
  });
};
var fundInfo = function fundInfo(data) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/myAsset/getFundInfo", { fundcode: data.fundCode }, function (result) {
      resolve(result);
    }, function (error) {
      reject('1111');
    });
  });
};
var minAmount = function minAmount(data) {
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/superfund/buy/getLimitAmount", { fundCode: data.fundCode, tradeType: data.businessType, token: data.token }, function (result) {
      resolve(result);
    }, function (error) {
      reject('1111');
    });
  });
};
function getCamcBankCardList(fundCode, businessType, bankAccountShowNo, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, fundCode: fundCode, businessType: businessType, clientType: __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.return_Clinet_Type()
      };
      var p = Promise.all([bankList(data), fundInfo(data), minAmount(data)]);
      p.then(function (response) {
        console.log(response);
        var obj = { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [], currentNav: '', currentNavDate: '', fundCode: '', fundName: '', minAmount: '' } };
        obj.content.fundName = response[1].content.fund_name;
        obj.content.fundCode = response[1].content.fund_code;
        obj.content.currentNavDate = response[1].content.publish_date;
        obj.content.currentNav = response[1].content.wanfenshouyi;
        obj.content.minAmount = response[2].content;
        var num = 0;
        var arr = [];
        response[0].content.forEach(function (item, index) {
          if (bankAccountShowNo == item.bankAccountShowNo) {
            num = index;
          };
          var amountTip = parseInt(item.tradeMaxAmountTips);
          if (amountTip - 0 == amountTip) {
            if (amountTip >= 10000) {
              var str2 = '单笔' + amountTip / 10000 + '万单日' + amountTip / 10000 + '万';
            } else {
              var str2 = '单笔' + amountTip.toFixed(0) + '单日' + amountTip.toFixed(0);
            }
          } else {
            if (item.paymentChannel == "G000" && item.ywt == false) {
              var str2 = '招行卡暂不可用，请您去华夏基金管家App操作或咨询客服';
            } else {
              var str2 = '具体支付限额请咨询客服';
            }
          }
          var str = amountTip.toFixed(0) + '|' + str2;
          Object.assign(item, { disable: true, tradeMaxAmountTips: str });
          arr.push(item);
        });
        obj.content.currentAccountList = arr;
        obj.currentType = 1;
        obj.currentIndex = num;
        callback(obj);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
function validateHqtPay(data) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.return_Clinet_Type();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__investmentAction_js__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/validateHqtPay", data, function (result) {
          if (result.code == '0000') {
            dispatch(submitHqtPay(data, callback));
          } else {
            if (result.message == '未做风险问卷或风险评级已过期') {
              callback(3, '抱歉，您在华夏基金的风险调查问卷已过期，请先登录华夏基金官网或管家APP完成风险问卷，谢谢');
            } else {

              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
            }
          }
        }, function (error) {

          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        });
      }, function (m) {

        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}
//货币基金购买其他基金
function submitHqtPay(data) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/submitHqtPay", data, function (result) {
      if (result.code == '0000') {
        callback(1, result);
      } else {
        callback(3, result.message);
      }
    });
  };
}
//支付1
function getPayInfo(fundCode, businessType, productType) {
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, fundCode: fundCode, businessType: businessType, productType: productType
        // console.log(Util.url+"/api/trade/getTradeInfo",data)
        // Util.get(Util.url+"/api/trade/getTradeInfo",data,function(result){
      };console.log(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/asset/getCamcHqtPayList", data);
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/payment/getHqtAndBankCardList", data, function (result) {
        if (result.code == '0000') {
          dispatch(payInfo(result));
          if (result.content.shareList.length > 0) {
            if (!getState().bankOrCurrent) {
              dispatch(choseBankOrCurrent(false));
            }
          } else {
            dispatch(choseBankOrCurrent(true));
          }
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.code, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
        console.log(result, '接口payInfo', data);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}
function getTradeInfo(fundCode, businessType, productType, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, fundCode: fundCode, businessType: businessType, productType: productType
        // Util.get(Util.url+"/api/trade/getTradeInfo",data,function(result){
      };__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/payment/getHqtAndBankCardList", data, function (result) {
        if (result.code == '0000') {
          __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/getMonetaryFundPayList", { token: d }, function () {
            var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(data) {
              var type, num, newShareRight, newShareLeft, newShareRight2, newShareLeft2, arrlist, arrlists, newList;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      result.content.currencyFund = []; //初始化数据格式
                      type = 1; //1银行卡 2活期通 3货币基金

                      num = 0; //默认选中卫视

                      if (data.code = '0000') {

                        // let hqtList = await getCwimUserHqtCard({ token:d})
                        // console.log(hqtList);

                        // for (let i = 0; i < result.content.shareList.length; i++) {
                        //   for (let j =0; j < hqtList.length ;j++) {
                        //     if(result.content.shareList[i].paymentChannel == "888" && hqtList[j].trustChannelId == "888") {
                        //       if(result.content.shareList[i].bankCode == hqtList[j].bankCode && result.content.shareList[i].bankAccountShowNo != hqtList[j].bankAccountShowNo) {
                        //         result.content.shareList[i].bankAccountShowNo2 = hqtList[j].bankAccountShowNo;
                        //         if(result.content.shareList[i].bankCode != "007") {
                        //           result.content.shareList[i].enableCMBTrustChannel = "0";
                        //         }
                        //       }
                        //     }else {
                        //       if(hqtList[j].trustChannelId != "888") {
                        //         if(result.content.shareList[i].bankCode == hqtList[j].bankCode && result.content.shareList[i].bankAccountShowNo != hqtList[j].bankAccountShowNo) {
                        //           result.content.shareList[i].bankAccountShowNo2 = hqtList[j].bankAccountShowNo;
                        //           if(result.content.shareList[i].bankCode != "007") {
                        //             result.content.shareList[i].enableCMBTrustChannel = "0";
                        //           }
                        //         }
                        //       }
                        //     }
                        //   }  
                        // }

                        data.content.forEach(function (value, index, array) {
                          value.trustChannelShares.forEach(function (shares, index, array) {
                            var obj = Object.assign(JSON.parse(JSON.stringify(value)), JSON.parse(JSON.stringify(shares)));
                            result.content.currencyFund.push(obj);
                          });
                        }); //货币基金数据
                        result.content.currencyFund.sort(getVal('availableVolume'));
                        result.content.shareList.sort(getVal('availableVolume'));
                        //排序 G000放在最后
                        newShareRight = [];
                        newShareLeft = [];

                        result.content.shareList.forEach(function (e) {
                          if (e.paymentChannel == 'G000' && e.ywt == true) {
                            newShareLeft.push(Object.assign(e, { disable: true }));
                          } else if (e.paymentChannel == 'G000' && e.ywt == false) {
                            newShareRight.push(Object.assign(e, { disable: false }));
                          } else {
                            if (e.paymentChannel == 'G000' && !e.enableCMBTrustChannel || e.enableCMBTrustChannel == "0") {
                              newShareRight.push(Object.assign(e, { disable: false }));
                            } else {
                              newShareLeft.push(Object.assign(e, { disable: true }));
                            }
                          }
                        });

                        //屏蔽 超级基金购买、定投和普通定投
                        newShareRight2 = [];
                        newShareLeft2 = [];

                        result.content.currentAccountList.forEach(function (e) {
                          if (businessType == 'T522' || businessType == 'T039') {
                            if (e.paymentChannel != "888") {
                              if (e.tradeMaxAmountTips) {
                                if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款') == -1) {
                                  newShareLeft2.push(Object.assign(e, { disable: true }));
                                } else {
                                  newShareRight2.push(Object.assign(e, { disable: false }));
                                }
                              } else {
                                newShareLeft2.push(Object.assign(e, { disable: true }));
                              }
                            }
                          } else {
                            if (e.tradeMaxAmountTips) {
                              if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款') == -1) {
                                newShareLeft2.push(Object.assign(e, { disable: true }));
                              } else {
                                newShareRight2.push(Object.assign(e, { disable: false }));
                              }
                            } else {
                              newShareLeft2.push(Object.assign(e, { disable: true }));
                            }
                          }
                        });
                        result.content.currentAccountList = [].concat(newShareLeft2, newShareRight2);
                        result.content.shareList = [].concat(newShareLeft, newShareRight);
                        if (result.content.currencyFund.length > 0 && result.content.shareList.length > 0) {
                          if (result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == true) {
                            if (result.content.currencyFund[0].availableVolume - 0 > result.content.shareList[0].availableVolume - 0) {
                              type = 3;
                            } else {
                              type = 2;
                            }
                          } else if (result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == false) {
                            type = 3;
                          } else {
                            if (result.content.shareList.length == 1 && result.content.shareList[0].paymentChannel == "G000" && !result.content.shareList[0].enableCMBTrustChannel || result.content.shareList.length == 1 && result.content.shareList[0].enableCMBTrustChannel == "0") {
                              type = 3;
                            } else {
                              if (result.content.currencyFund[0].availableVolume - 0 > result.content.shareList[0].availableVolume - 0) {
                                type = 3;
                              } else {
                                type = 2;
                              }
                            }
                          }
                        } else if (result.content.shareList.length > 0) {
                          if (result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == true) {
                            type = 2;
                          } else if (result.content.shareList[0].paymentChannel == "G000" && result.content.shareList[0].ywt == false) {
                            type = 1;
                          } else {
                            if (result.content.shareList.length == 1 && result.content.shareList[0].paymentChannel == "G000" && !result.content.shareList[0].enableCMBTrustChannel || result.content.shareList.length == 1 && result.content.shareList[0].enableCMBTrustChannel == "0") {
                              type = 1;
                            } else {
                              type = 2;
                            }
                          }
                        } else if (result.content.currencyFund.length > 0) {
                          type = 3;
                        } else {
                          type = 1;
                        }
                        // dispatch(payInfo(result));
                        // if (getState().currentType==4){
                        //   dispatch(changeCurrentType(type))
                        //   dispatch(changeCurrentIndex(num))
                        // }
                        arrlist = [];
                        arrlists = [];
                        newList = [];

                        if (result.content.currentAccountList) {
                          arrlist = result.content.currentAccountList.map(function (item) {
                            return Object.assign({}, item, {
                              yhkBool: false
                            });
                          });
                        }
                        if (result.content.camcBankCards) {
                          arrlists = result.content.camcBankCards.map(function (item) {
                            return Object.assign({}, item, {
                              yhkBool: true,
                              disable: true
                            });
                          });
                        }
                        newList = [].concat(_toConsumableArray(arrlist), _toConsumableArray(arrlists));
                        result.content.yhkNewListList = newList; //财富银行卡和直销银行卡
                        callback(result, num, type);
                        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
                      }

                    case 4:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));

            return function (_x4) {
              return _ref.apply(this, arguments);
            };
          }(), function (error) {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          });
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}
function getTradeInfo2(fundCode, businessType, productType) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, fundCode: fundCode, businessType: businessType, productType: productType
        // Util.get(Util.url+"/api/trade/getTradeInfo",data,function(result){
      };__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/payment/getHqtAndBankCardList", data, function (result) {
        if (result.code == '0000') {
          result.content.currencyFund = [];
          var type = 1;
          var num = 0;
          result.content.shareList.sort(getVal('availableVolume'));
          var newShareRight = [];
          var newShareLeft = [];
          result.content.shareList.forEach(function (e) {
            console.log(e);
            if (e.paymentChannel == 'G000' && e.ywt == true) {
              newShareLeft.push(Object.assign(e, { disable: true }));
            } else if (e.paymentChannel == 'G000' && e.ywt == false) {
              newShareRight.push(Object.assign(e, { disable: false }));
            } else {
              if (e.paymentChannel == 'G000' && !e.enableCMBTrustChannel || e.enableCMBTrustChannel == "0") {
                newShareRight.push(Object.assign(e, { disable: false }));
              } else {
                newShareLeft.push(Object.assign(e, { disable: true }));
              }
            }
          });
          var newShareRight2 = [];
          var newShareLeft2 = [];
          result.content.currentAccountList.forEach(function (e) {
            if (businessType == 'T522' || businessType == 'T039') {
              if (e.paymentChannel != "888") {
                if (e.tradeMaxAmountTips) {
                  if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款') == -1) {
                    newShareLeft2.push(Object.assign(e, { disable: true }));
                  } else {
                    newShareRight2.push(Object.assign(e, { disable: false }));
                  }
                } else {
                  newShareLeft2.push(Object.assign(e, { disable: true }));
                }
              }
            } else {
              if (e.tradeMaxAmountTips) {
                if (e.tradeMaxAmountTips.indexOf('暂不支持该行扣款') == -1) {
                  newShareLeft2.push(Object.assign(e, { disable: true }));
                } else {
                  newShareRight2.push(Object.assign(e, { disable: false }));
                }
              } else {
                newShareLeft2.push(Object.assign(e, { disable: true }));
              }
            }
          });
          result.content.currentAccountList = [].concat(newShareLeft2, newShareRight2);
          result.content.shareList = [].concat(newShareLeft, newShareRight);
          // if (result.content.shareList.length>0) {
          //   if (result.content.shareList.length==1&&result.content.shareList[0].paymentChannel == "G000" &&!result.content.shareList[0].enableCMBTrustChannel) {
          //     type=1
          //   } else {
          //     type=2
          //   }
          // } else {
          //   type=1

          // }
          // dispatch(changeCurrentType(type))
          // dispatch(changeCurrentIndex(num))
          dispatch(payInfo(result));
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.code, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}
//排序函数
var getVal = function getVal(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
};
//支付渠道
function getPayAccount(fundCode, businessType) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, fundCode: fundCode, businessType: businessType
      };
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/getCurrentAccount", data, function (result) {
        result.content.shareList.sort(getVal('availableVolume'));
        result.content.minAmount = 0;
        result.content.currentNav = '';
        result.content.currentNavDate = '';
        result.content.fundCode = '';
        result.content.fundName = '';
        if (businessType == 'T522') {
          var oldArr = result.content.currentAccountList;
          var newArr = oldArr.filter(function (item) {
            return item.paymentChannel != "888";
          });
          result.content.currentAccountList = newArr;
        }
        dispatch(payInfo(result));
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        if (result.content.shareList.length > 0) {
          if (!getState().bankOrCurrent) {
            dispatch(choseBankOrCurrent(false));
          }
        } else {
          dispatch(choseBankOrCurrent(true));
        }
        console.log(result, 'getPayAccount', data);
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
//最低投资金额
function getLimitAmount(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/superfund/buy/getLimitAmount", data, function (result) {
        if (result.code == '0000') {
          callBack(result.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        console.log('费用计算入参 error');
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
//交易
function getTransaction(data) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.return_Clinet_Type();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__investmentAction_js__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/doBuyRequest", data, function (result) {
          if (result.code == '0000') {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
            callback(1, result);
          } else {
            callback(3);
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          }
        }, function (error) {
          callback(3);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        });
      }, function (m) {
        callback(3);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//货币基金购买其他基金校验
function monetaryFundBuyValidate(data) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.return_Clinet_Type();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__investmentAction_js__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/monetaryFundBuyValidate", data, function (result) {
          if (result.code == '0000') {
            dispatch(monetaryFundBuyRequest(data, callback));
          } else {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}
//货币基金购买其他基金
function monetaryFundBuyRequest(data) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/monetaryFundBuyRequest", data, function (result) {
      if (result.code == '0000') {
        callback(1, { content: { requestId: result.content } });
      } else {
        callback(3, result.message);
      }
    });
  };
}
//金额验证
function rateAndFee(text) {
  return {
    type: "RATE_AND_FEE",
    text: text
  };
}
function getMoneyChange(data) {
  if (data.applicationAmount.length == 0) {
    data.applicationAmount = 0;
  }
  return new Promise(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/queryRateAndFee", data, function (result) {
        console.log(result);
        if (result.code == '0000') {
          resolve(result);
        } else {
          reject(result.code);
        }
      }, function (error) {
        reject(error);
      });
    }).catch(function (error) {
      reject(error);
    });
  });
}
//转换
function getDoConvert(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    console.log('-------------');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__investmentAction_js__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/doConvert", data, function (result) {
          if (result.code == '0000') {
            callback(1, result);
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          } else {
            callback(3);
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          }
        }, function (error) {
          callback(3);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//赎回限额
function getMinLimit(data, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/getMinLimit", data, function (result) {
        if (result.code == '0000') {
          callback(result);
        }
        console.log(result, '赎回限额!!!');
      }, function (error) {});
    }).catch(function (err) {
      console.log(err);
    });
  };
}
//赎回
function getDoRedeem(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__investmentAction_js__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/doRedeem", data, function (result) {
          if (result.code == '0000') {
            callback(1, result);
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          } else {
            callback(3);
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          }
        }, function (error) {
          callback(3);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
    });
  };
}
// Transformation
function getTransformationFunList(fundCode, _this) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d,
        fundCode: fundCode
      };
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/getCanConvertFundList", data, function (result) {
        if (result.code == '0000') {

          console.log(result);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          dispatch(TransformationFunList(result));
          _this.setState({
            listArr: result
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        console.log('jiekou error');
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
    });
  };
}
function TransformationFunList(text) {
  return {
    type: "TRANSFORMATION_FUN_LIST",
    text: text
  };
}
//基金标签 - zbw
function fundLabel(text) {
  return {
    type: "FUND_LABEL",
    text: text
  };
}
//公募基金列表 - zbw
function fundListGm(text) {
  return {
    type: "FUND_LIST_GM",
    text: text
  };
}
//公募基金列表 - zbw
function fundListGm2(text) {
  return {
    type: "FUND_LIST_GM2",
    text: text
  };
}
//私募基金列表 - zbw
function fundListSm(text) {
  return {
    type: "FUND_LIST_SM",
    text: text
  };
}
//券商集合列表 - zbw
function fundListJh(text) {
  return {
    type: "FUND_LIST_JH",
    text: text
  };
}
//优选专户列表 - zbw
function fundListZh(text) {
  return {
    type: "FUND_LIST_ZH",
    text: text
  };
}
//基金筛选列表 - zbw
function fundOperatingList(text) {
  return {
    type: "FUND_OPERATING_LIST",
    text: text
  };
}
//基金搜索列表 - zbw
function searchFundList(text) {
  return {
    type: "SEARCH_FUND_LIST",
    text: text
  };
}

//获取基金标签
function getFundLabel(params, zhType) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == "" || token == undefined || token == null || token == "9999") {
        params.token = "";
      } else {
        params.token = token;
      }
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getLabelList", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          dispatch(fundLabel(data));
          if (params.fund_type == "G") {
            console.log("公募基金标签");
            dispatch(getFundListByPublic({ type: 0 }));
          } else if (params.fund_type == "S") {
            console.log("私募基金标签");
            dispatch(getFundListByPrivate({ type: 0 }));
          } else if (params.fund_type == "J") {
            if (zhType == "Z") {
              console.log("优选专户标签");
              dispatch(getFundListByAccount({ type: 0 }));
            } else {
              console.log("券商集合标签");
              dispatch(getFundListByBroker({ type: 0 }));
            }
          }
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
        console.log("错误信息" + err);
      });
    });
  };
}

//获取公募基金列表 - zbw
function getFundListByPublic(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == "" || token == undefined || token == null || token == "9999") {
        params.token = "";
      } else {
        params.token = token;
      }
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getPublicPlacementList", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          dispatch(fundListGm(data));
          dispatch(fundListGm2(data));
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
        console.log("错误信息" + err);
      });
    });
  };
}

//获取私募基金列表
function getFundListByPrivate(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == "" || token == undefined || token == null || token == "9999") {
        params.token = "";
      } else {
        params.token = token;
      }
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getPrivateProductList", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          console.log("私募基金列表");
          dispatch(fundListSm(data));
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//获取券商集合列表 - zbw
function getFundListByBroker(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == "" || token == undefined || token == null || token == "9999") {
        params.token = "";
      } else {
        params.token = token;
      }
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getAggregateProductList", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          console.log("券商集合列表");
          dispatch(fundListJh(data));
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//获取优选专户列表
function getFundListByAccount(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == "" || token == undefined || token == null || token == "9999") {
        params.token = "";
      } else {
        params.token = token;
      }
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getSpecialDepositProductList", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          console.log("优选专户列表");
          dispatch(fundListZh(data));
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

//列表搜索 - zbw
function getSearchFundList(params) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == "" || token == undefined || token == null || token == "9999") {
        params.token = "";
      } else {
        params.token = token;
      }
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getAllProductList", params, function (data) {
        if (data.code == "0000") {
          console.log(data);
          console.log("列表搜索");
          dispatch(searchFundList(data));
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        } else {
          console.log(data.code);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(data.code, 2);
        }
      }, function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("错误信息" + err, 2);
      });
    });
  };
}

/*获取基金详情*/
function fundPublicDetil(text) {
  return {
    type: "FUND_PUBLIC_DETIL",
    text: text
  };
}

/*自选状态*/
function AddZx(text) {
  return {
    type: "Add_ZX",
    text: text
  };
}

/*获取公募基金详情*/
function getPublicProductDetil(fundCode, callback, _this) {
  return function (dispatch, getState) {
    console.log('action');
    // dispatch(pageFlag(true));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      console.log('基金详情', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getPublicProductDetil?fundcode=" + fundCode + "&token=" + token);
      fetch(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getPublicProductDetil?fundcode=" + fundCode + "&token=" + token).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        _this.setState({
          loadingFlag: false
        });

        if (responseText.code == "0000") {
          console.log("基金详情,action");
          console.log(responseText);
          dispatch(fundPublicDetil(responseText.content));
          dispatch(AddZx(responseText.content.is_optional));
          // dispatch(pageFlag(false));
          callback();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }).catch(function (err) {
        console.log("错误信息" + err);;
        _this.setState({
          loadingFlag: false
        });
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}

/*私募基金详情*/
function fundPrivateDetil(text) {
  return {
    type: "FUND_PRIVATE_RATE",
    text: text
  };
}
/*获取私募详情*/
function getPrivateProductDetil(id, callback, _this) {
  return function (dispatch, getState) {
    // dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      fetch(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getPrivateProductDetil?fundcode=" + id + "&token=" + token).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        _this.setState({
          loadingFlag: false
        });
        if (responseText.code == "0000") {
          console.log("基金详情");
          console.log(responseText);
          dispatch(fundPrivateDetil(responseText.content));
          dispatch(AddZx(responseText.content.is_optional));
          // dispatch(pageFlag(false));
          callback();
        } else {

          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }).catch(function (err) {
        console.log("错误信息" + err);
        _this.setState({
          loadingFlag: false
        });
      });
    });
  };
}

/*集合理财详情*/
function fundAggregateDetil(text) {
  return {
    type: "FUND_AGGREGATE_RATE",
    text: text
  };
}
/*集合理财详情*/
function getAggregateProductDetil(id, callback, _this) {
  return function (dispatch, getState) {
    // dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      console.log(token, "ssssssss", id);
      console.log(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getAggregateProductDetil?fundcode=" + id + "&token=" + token);
      fetch(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getAggregateProductDetil?fundcode=" + id + "&token=" + token).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        _this.setState({
          loadingFlag: false
        });
        if (responseText.code == "0000") {
          console.log("集合理财详情基金详情");
          console.log(responseText);
          if (responseText.content != null) {
            dispatch(fundAggregateDetil(responseText.content));
            responseText.content.is_optional == null ? dispatch(AddZx("0")) : dispatch(AddZx(responseText.content.is_optional));
            // dispatch(pageFlag(false));
            callback(responseText.content);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }).catch(function (err) {
        console.log("错误信息" + err);
        _this.setState({
          loadingFlag: false
        });
      });
    });
  };
}

/*添加自选*/
function reateOptional(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/createOptional", data, function (data) {
        if (data.code == "0000") {
          dispatch(AddZx("1"));
          console.log("添加自选成功状态变为1");
          console.log(data.content);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("添加自选成功", __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          if (callBack) {
            callBack();
          }
        }
      }, function (error) {
        console.log(error, 333);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}
/*取消自选*/
function deleteOptional(data, callBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/deleteOptional", data, function (data) {
        if (data.code == "0000") {
          dispatch(AddZx("0"));
          console.log(data.content);

          if (callBack) {
            callBack();
          }
        }
      }, function (error) {
        console.log(error, 333);
      });
    }).catch(function (err) {});
  };
}

//基金历史净值
function fundHistoryRate(text) {
  return {
    type: "FUND_HISTORY_RATE",
    text: text
  };
}

/*私募历史净值*/
function getHistoryProfileRate(data, callback) {
  return function (dispatch, getState) {
    // dispatch(pageFlag(true))
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      data.token = token;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/getHistoryRate", data, function (data) {
        if (data.code == "0000") {
          dispatch(fundHistoryRate(data.content));
          callback(data.content);
          // dispatch(pageFlag(false))
        }
      }, function (error) {
        console.log(error, "历史净值");
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    });
  };
}

//文章详情
function articleDetail(text) {
  return {
    type: "ARTICLE_DETAIL",
    text: text
  };
}

function getArticleDetail(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/article/getArticleDetail", data, function (result) {
      if (result.code == "0000") {
        dispatch(articleDetail(result.content));
        if (callback) {
          callback(result.content);
        }
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }
    }, function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}

//点赞文章
function editLikeArticle(data) {
  return function (dispatch, getState) {
    // Toast.loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/article/editArticleLike", data, function (result) {
        if (result.code == "0000") {
          // Toast.hide();
        } else {
          // Toast.hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (err) {
        // Toast.hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}

//留言列表
function articleMessageList(text) {
  return {
    type: "ARTICLE_MESSAGE_LIST",
    text: text
  };
}

function getArticleMessageList(data, callback) {
  return function (dispatch, getState) {
    // Toast.loading('', 0);
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/article/getArticleCommentList", data, function (result) {
      if (result.code == "0000") {
        dispatch(articleMessageList(result.content));
        callback(result.content);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }
    }, function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}

//写留言
function writeArticleMessage(data, callback) {
  return function (dispatch, getState) {
    // Toast.loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/article/addUserComment", data, function (result) {
        if (result.code == "0000") {
          callback(result.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}

//点赞留言
function editLikeMessage(data) {
  return function (dispatch, getState) {
    // Toast.loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/article/editCommentLike", data, function (result) {
        if (result.code == "0000") {
          // Toast.hide();
        } else {
          // Toast.hide();
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function (err) {
        // Toast.hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
}

//获取用户风险问卷信息
var getUserQuestionnaires = function getUserQuestionnaires(data) {
  console.log(data, "dafafdf");
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/account/getUserQuestionnaires", data, function (result) {
      console.log(result, "用户当前问卷1111");
      if (result.code === '0000' && result.content) {
        resolve(result.content.questionnaireNo);
      } else {
        // let toast = Toast.show(result.code, getToastConfPoint( ) );
        resolve({});
      }
    }, function (error) {
      reject('1111');
    });
  });
};

//获取用户上次作答的问卷
var queryLastAnswerQuestionnaire = function queryLastAnswerQuestionnaire(data) {
  console.log(data, "dafafdf");
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/account/queryLastAnswerQuestionnaire", data, function (result) {
      console.log(result, "用户之前问卷1111");
      if (result.code === '0000' && result.content) {
        resolve(result.content);
      } else {
        // let toast = Toast.show(result.code, getToastConfPoint( ) );
        resolve({});
      }
    }, function (error) {
      reject('1111');
    });
  });
};

//查询直销用户是否答过问卷
var hasOtsRiskRearing = function hasOtsRiskRearing(params, callback) {
  return function (dispatch, getState) {
    var _this2 = this;

    console.log(params, "dafafdf");
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/account/hasOtsRiskRearing", params, function () {
        var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(result) {
          var wqInfoNow, wqLast;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(result.code === '0000')) {
                    _context2.next = 15;
                    break;
                  }

                  if (!result.content) {
                    _context2.next = 5;
                    break;
                  }

                  callback("1", "1", result.content);
                  _context2.next = 13;
                  break;

                case 5:
                  _context2.next = 7;
                  return getUserQuestionnaires(params);

                case 7:
                  wqInfoNow = _context2.sent;
                  _context2.next = 10;
                  return queryLastAnswerQuestionnaire(params);

                case 10:
                  wqLast = _context2.sent;

                  console.log(wqInfoNow, wqLast, result.content, "同步问卷条件");
                  callback(wqInfoNow, wqLast, result.content);

                case 13:
                  _context2.next = 16;
                  break;

                case 15:
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.code, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);

                case 16:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x8) {
          return _ref2.apply(this, arguments);
        };
      }(), function (error) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
    });
  };
};

/* 同步财富风险测评信息到直销 /api/camchqtaccount/syncCwimToCamc(新) */
function syncCwimToCamcNew(params, callback) {
  return function (dispatch, getState) {
    // dispatch(pageFlag(true))
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/camchqtaccount/syncCwimRiskToCamc", params, function (responseText) {
        if (responseText.code == "0000") {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          if (callback) {
            callback(responseText.content);
          }
          console.log(responseText);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          console.log(responseText.message);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(responseText.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          // dispatch(pageFlag(false));
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        // dispatch(pageFlag(false));
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      // dispatch(pageFlag(false));
    });
  };
}
//更新直销风险等级并同步终止直销相关计划类交易
function syncCwimRiskToCamcAndStopOutOfRiskBuyPlan(params, callback) {
  return function (dispatch, getState) {
    // dispatch(pageFlag(true))
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/camchqtaccount/syncCwimRiskToCamcAndStopOutOfRiskBuyPlan", params, function (responseText) {
        if (responseText.code == "0000") {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          if (callback) {
            callback();
          }
          console.log(responseText);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
          console.log(responseText.message);
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(responseText.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          // dispatch(pageFlag(false));
        }
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        // dispatch(pageFlag(false));
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      // dispatch(pageFlag(false));
    });
  };
}
//组合申购限额
function getSuperFundTradeLimit(params, callBack, errback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/superfund/trade/buy/getSuperFundTradeLimit", params, function (result) {
        console.log(result);
        if (result.code == '0000') {
          callBack(result);
        } else {
          // errback(result);
          // Toast.info(result.message, Util.ToastTime);;
        }
      }, function (error) {
        // errback(error);
        // Toast.info(error, Util.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);
    });
  };
}

//赎回到活期通下单
var getRedeemToHqtOk = function getRedeemToHqtOk(data, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/redeem2hqt", data, function (result) {
        if (result.code == '0000') {
          callback(1, result);
        } else {
          callback(3, result.message);
        }
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      }, function (error) {
        callback(3, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt);
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      console.log(err);__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
    });
  };
};

//赎回到活期通预校验
function getRedeemToHqtvalidate(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__investmentAction_js__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/trade/redeem2hqt/validate", data, function (result) {
          if (result.code == '0000') {
            dispatch(getRedeemToHqtOk(data, callback));
          } else {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      console.log(err);__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
    });
  };
}

//获取公募详情基金分析指标 近五年最大回撤
function getFundAnalysisIndicatorOfFiveYears(parameter, callback) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/product/publicFund/getFundAnalysisIndicatorOfFiveYears", parameter, function (res) {
      console.log(res);
      if (res.code === "0000") {
        callback(res.content);
      }
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].show(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["c" /* getToastConfPoint */])());
    });
  };
}

//获取版本信息
var getVersionInfo = function getVersionInfo(params, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(suc) {
      if (suc && suc.code === '0000') {
        console.log('获取版本信息成功');
        succallback(suc);
      } else {
        console.log('获取版本信息失败');
        errcallback(suc.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      errcallback(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + '/api/upgrade/getVersion', params, successCallback, errorCallback);
  };
};

//新版公募详情折线图打点 
function Newpublicinterfacedadian(params, callback) {
  return function (dispatch, getState) {
    var data = {
      fundCode: params.fundCode,
      fundPerformance: true,
      benchmarkPerformance: false,
      indexPerformance: false,
      type: 'sincefound'
    };
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/product/publicFund/getLineChatVo", data, function (result) {
      console.log(result);
      if (result.code == "0000") {
        callback(result.content);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message);
      }
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt);
    });
  };
}

//新版公募详情折线图
function Newpublicinterface(params, callback) {
  return function (dispatch, getState) {
    var data = {
      fundCode: params.fundCode,
      type: params.type,
      symbolCode: params.symbolCode,
      fundPerformance: true,
      benchmarkPerformance: true
    };
    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading();
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v1/product/publicFund/getLineChatVo", data, function (result) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
      if (result.code == "0000") {
        callback(result.content);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(result.message);
      }
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt);
    });
  };
}

/*公募历史净值 可以分页 拿到最新日期数据*/
function getPublicHistoryProfileRate(data, callback) {
  console.log('2----');
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/Product/publicFund/getHistoryRate", data, function (data) {
      console.log(data);
      if (data.code == "0000") {
        dispatch(fundHistoryRatePage(data.content));
        callback(data.content);
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].show(data.message);
      }
    }, function (error) {
      console.log("错误信息" + error);
    });
  };
}

/*新版公募基金申购详情*/
function newgetPublicProductDetil(fundCode, callback, _this) {
  return function () {
    var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading();
              fetch(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.url + "/api/v2/product/publicFund/getPublicProductDetail?fundCode=" + fundCode, {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then(function (response) {
                return response.json();
              }).then(function (responseText) {
                console.log('================', responseText);
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
                if (responseText.code == "0000") {
                  callback(responseText.content);
                } else {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.errorTxt);
                }
              }).catch(function (err) {
                console.log("错误信息" + err);;
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function (_x9, _x10) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bankCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return protocolCode; });
/* unused harmony export FAQCode */
//银行字典

var bankCode = {
  // 通用
  ty: {
    '002': __webpack_require__(409),
    '003': __webpack_require__(410),
    '004': __webpack_require__(411),
    '005': __webpack_require__(412),
    '006': __webpack_require__(413),
    '007': __webpack_require__(414),
    '009': __webpack_require__(415),
    '011': __webpack_require__(416),
    '012': __webpack_require__(417),
    '014': __webpack_require__(418),
    '015': __webpack_require__(419),
    '016': __webpack_require__(420),
    '017': __webpack_require__(421),
    '018': __webpack_require__(422),
    '021': __webpack_require__(423),
    '022': __webpack_require__(424),
    '903': __webpack_require__(425),
    '904': __webpack_require__(426),
    '907': __webpack_require__(427),
    '915': __webpack_require__(428)
  },
  // 银行卡管理
  yhkgl: {
    '002': __webpack_require__(626),
    '003': __webpack_require__(627),
    '004': __webpack_require__(628),
    '005': __webpack_require__(629),
    '006': __webpack_require__(630),
    '009': __webpack_require__(631),
    '011': __webpack_require__(632),
    '014': __webpack_require__(633),
    '015': __webpack_require__(634),
    '016': __webpack_require__(635),
    '018': __webpack_require__(636),
    '021': __webpack_require__(637),
    '022': __webpack_require__(638)
  }

  //协议字典

};var protocolCode = {
  '华夏财富同步信息快捷开户协议书': 'pro_001',
  '华夏财富电子交易服务协议': 'pro_002',
  '投资人权益须知': 'pro_003',
  '电子签名约定书': 'pro_004',
  '上海华夏财富投资管理有限公司快易付业务协议': 'pro_005',
  '关于我们': 'pro_006',
  '定期定额申请协议': 'pro_007',
  '上海华夏财富投资管理有限公司基金投资顾问服务协议': 'pro_008',
  '华夏查理智投投资者风险告知函': 'pro_009',
  '养老计算器规则': 'pro_010',
  '教育计算器规则': 'pro_011',
  '转出方式及额度说明': 'pro_012',
  '投资者风险告知函': 'pro_013',
  '华夏查理智投定期定额申请协议': 'pro_014',
  '投资组合策略说明书-货币': 'pro_021',
  '投资组合策略说明书-固收': 'pro_022',
  '投资组合策略说明书-权益': 'pro_023',
  '投资组合策略说明书-指数': 'pro_024',
  '投资组合策略说明书-教育': 'pro_025',
  '投资组合策略说明书-养老': 'pro_026',
  '华夏财富用户隐私政策': 'pro_027',
  '小常乐目标盈008期组合策略说明书': 'pro_029',
  '小常乐目标盈009期组合策略说明书': 'pro_030',
  '小常乐目标盈010期组合策略说明书': 'pro_031',
  '小常乐目标盈011期组合策略说明书': 'pro_032',
  '工资宝绝对收益组合策略说明书': 'pro_041',
  '7分小进取组合策略说明书': 'pro_044',
  '投资组合策略说明书-指数增强': 'pro_047',
  '投资组合策略说明书-安心宝': 'pro_057',
  '投资组合策略说明书-价值精选': 'pro_059',
  '投资组合策略说明书-货币增强': 'pro_060'

  //常见问题
};var FAQCode = {
  'wt_yhk': 'wt_yhk'

};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Sprite = __webpack_require__(1657);
var globalSprite = new Sprite();

if (document.body) {
  globalSprite.elem = globalSprite.render(document.body);
} else {
  document.addEventListener('DOMContentLoaded', function () {
    globalSprite.elem = globalSprite.render(document.body);
  }, false);
}

module.exports = globalSprite;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1001);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isLogin; });
/* unused harmony export userId */
/* unused harmony export trueName */
/* unused harmony export tradeAccountNo */
/* unused harmony export userName */
/* unused harmony export nickName */
/* unused harmony export userMobileNo */
/* unused harmony export isPrivate */
/* unused harmony export shortToken */
/* unused harmony export longToken */
/* unused harmony export verifiedUserInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cleanCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loginHXFortuneByMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loginHXFortuneByIdentity; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getUserInfoList;
/* harmony export (immutable) */ __webpack_exports__["q"] = getUserInfoListTemp;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return userBindingMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return registerAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ReservationManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCapchaCode; });
/* harmony export (immutable) */ __webpack_exports__["k"] = getTbuxy;
/* harmony export (immutable) */ __webpack_exports__["l"] = getTbuxyQis;
/* harmony export (immutable) */ __webpack_exports__["r"] = getTbuxyKh;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMobileCaptcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCapcha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return forgetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateLoginPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateTradePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






//是否有登录记录
var isLogin = function isLogin(text) {
  return { type: 'IS_LOGIN', text: text };
};

var userId = function userId(text) {
  return {
    type: 'TEMP_INFO_USER_ID',
    text: text
  };
};

var trueName = function trueName(text) {
  return {
    type: 'TEMP_INFO_TRUE_NAME',
    text: text
  };
};

var tradeAccountNo = function tradeAccountNo(text) {
  return {
    type: 'TEMP_INFO_TRADE_ACCOUNT_NO',
    text: text
  };
};

var userName = function userName(text) {
  return {
    type: 'TEMP_INFO_USER_NAME',
    text: text
  };
};

var nickName = function nickName(text) {
  return {
    type: 'TEMP_INFO_NICK_NAME',
    text: text
  };
};

var userMobileNo = function userMobileNo(text) {
  return {
    type: 'TEMP_INFO_USER_MOBILE_NO',
    text: text
  };
};

var isPrivate = function isPrivate(text) {
  return {
    type: 'TEMP_INFO_IS_PRIVATE',
    text: text
  };
};

var shortToken = function shortToken(text) {
  return {
    type: 'TEMP_INFO_SHORT_TOKEN',
    text: text
  };
};

var longToken = function longToken(text) {
  return {
    type: 'TEMP_INFO_LONG_TOKEN',
    text: text
  };
};

var verifiedUserInfo = function verifiedUserInfo(text) {
  return {
    type: 'VERIFIEDUSERINFO',
    text: text
  };
};

/*当用户退出或更换用户时清楚数据*/
var cleanCache = function cleanCache(dispatch) {
  window.localStorage.removeItem('currentUserInfo');
  window.localStorage.removeItem('loginInfo-longToken');
  window.localStorage.removeItem('loginInfo-shortToken');
  window.localStorage.removeItem('loginState');
  dispatch(isLogin(false));
  dispatch(userMobileNo(""));
  // dispatch(myInvestmentList({code:'',message:'',content:{records:[]}}));
  // dispatch(payInfo({code:'',message:'',content:{shareList:[],currentAccountList:[],currentNav:'',currentNavDate:'',fundCode:'',fundName:'',minAmount:''}}))
  // dispatch(myInvestListGm([]));
  // dispatch(myInvestListJhlc([]));
  // dispatch(myInvestListZh([]))
  // dispatch(myInvestListSm([]));
  // dispatch(myInvestListSuperFund([]));
  // dispatch(myInvestList([]));
  dispatch(verifiedUserInfo(null));
  // dispatch(unVerifiedUserInfo(null));
  // dispatch(isLogin(false));
  // dispatch(isRealName(false));
  // dispatch(SupperFundHome(null));
  // dispatch(QueryTransitRecords(null));
  // dispatch(assetInTransitList([]));
  // dispatch(bankCardNum('--'));
  // dispatch(bankCardList([]));
  // dispatch(HQTCardList([]));
  // dispatch(myInvestAccount('--'));
  // dispatch(myTrustChannelShare({fundInfo:{},trustChannelShareResponse:[],isOpenBuy:true,fundIncome:[{allIncome:0,dayIncome:'',deadLine:null}]}))
  // dispatch(tempInfo['userInfo']['mobileNo'](''));
  // dispatch(incomeDigital({customerTotalValue: '--', dayIncome: '--', allIncome: '--', endDate: '- -', transitTotalValue: '--'}));
};

//华夏财富手机号登录
var loginHXFortuneByMobile = function loginHXFortuneByMobile(loginParam, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(succ) {
        var TM, userInfo, user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(succ);

                if (!(succ && succ.code === '0000')) {
                  _context.next = 30;
                  break;
                }

                cleanCache(dispatch);
                TM = new Date();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
                userInfo = {
                  userId: succ.content.userId,
                  isRealName: succ.content.tradeAccountNo ? true : false
                };

                if (succ.content.name != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { name: succ.content.name });
                if (succ.content.nickName != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { nickName: succ.content.nickName });
                if (succ.content.tradeAccountNo != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { tradeAccountNo: succ.content.tradeAccountNo });
                userInfo.mobileNo = loginParam.mobileNo;
                console.log('华夏财富手机号登录userInfo', userInfo);
                _context.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('userList-' + userInfo.userId);

              case 14:
                user = _context.sent;

                console.log('华夏财富手机号登录userInfo', user);
                if (user != 9999) {
                  userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(user, userInfo);
                }
                console.log('华夏财富手机号登录userInfo', userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                dispatch(isLogin(true));
                dispatch(userMobileNo(loginParam.mobileNo));
                if (userInfo.isRealName) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '2');
                } else {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '1');
                }
                dispatch(getUserInfoList());
                succallback(userInfo);
                console.log(succ);
                _context.next = 32;
                break;

              case 30:
                console.log('后台返回数据有误!');
                errcallback(succ.message);

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function successCallback(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var errorCallback = function errorCallback(err) {
      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/mobileLogin', loginParam, successCallback, errorCallback);
  };
};

//华夏财富身份证登录
var loginHXFortuneByIdentity = function loginHXFortuneByIdentity(loginParam, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(succ) {
        var TM, userInfo, user, userInfoT;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(succ);

                if (!(succ && succ.code === '0000')) {
                  _context2.next = 31;
                  break;
                }

                cleanCache(dispatch);
                TM = new Date();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);

                if (!succ.content.userId) {
                  _context2.next = 24;
                  break;
                }

                userInfo = {
                  userId: succ.content.userId,
                  isRealName: succ.content.tradeAccountNo ? true : false
                };

                if (succ.content.name != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { name: succ.content.name });
                if (succ.content.nickName != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { nickName: succ.content.nickName });
                if (succ.content.tradeAccountNo != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { tradeAccountNo: succ.content.tradeAccountNo });
                console.log('华夏财富证件号登录userInfo', userInfo);
                _context2.next = 14;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('userList-' + userInfo.userId);

              case 14:
                user = _context2.sent;

                if (user != 9999) {
                  userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(user, userInfo);
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                dispatch(isLogin(true));
                console.log('21212121212华夏财富证件号登录userInfo', userInfo);
                if (userInfo.isRealName) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '2');
                } else {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '1');
                }
                dispatch(getUserInfoList());

              case 24:
                userInfoT = Object.assign({}, succ.content, {
                  userId: succ.content.userId ? succ.content.userId : null,
                  isRealName: succ.content.tradeAccountNo ? true : false,
                  shortToken: succ.content.shortToken,
                  tradeAccountNo: succ.content.tradeAccountNo

                });

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                succallback(userInfoT);
                console.log(succ);
                _context2.next = 33;
                break;

              case 31:
                console.log('后台返回数据有误!');
                errcallback(succ.message);

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function successCallback(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var errorCallback = function errorCallback(err) {
      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/certLogin', loginParam, successCallback, errorCallback);
  };
};
//获取个人信息
function getUserInfoList(callback) {
  return function (dispatch, getState) {
    var _this2 = this;

    var successCallback = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(data) {
        var flagDigital, currentUserInfo, addInfo, _currentUserInfo;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(data.code == "0000")) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('loginState');

              case 3:
                flagDigital = _context3.sent;

                if (flagDigital != '1') {
                  dispatch(verifiedUserInfo(data));
                } else {
                  dispatch(verifiedUserInfo(null));
                }
                _context3.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('currentUserInfo');

              case 7:
                currentUserInfo = _context3.sent;

                console.log(currentUserInfo);
                currentUserInfo.mobileNo = data.content.mobileNo;
                currentUserInfo.userMsg = data.content;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('currentUserInfo', currentUserInfo);
                if (callback) {
                  callback(data);
                }
                console.log(currentUserInfo);
                console.log("个人信息");
                console.log(data);
                addInfo = {};

                if (data.content.mobileNo) {
                  addInfo.mobileNo = data.content.mobileNo;
                }
                if (data.content.name) {
                  addInfo.name = data.content.name;
                }
                if (data.content.nickName) {
                  addInfo.nickName = data.content.nickName;
                }
                if (data.content.isPrivate) {
                  addInfo.isPrivate = data.content.isPrivate;
                }
                addInfo.userMsg = data.content;
                dispatch(nickName(data.content.nickName ? data.content.nickName : null));
                dispatch(trueName(data.content.name ? data.content.name : null));
                dispatch(userMobileNo(data.content.mobileNo ? data.content.mobileNo : null));
                dispatch(isPrivate(data.content.isPrivate ? data.content.isPrivate : null));
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["f" /* syncAddUserInfo */])({ addInfo: addInfo });
                _context3.next = 39;
                break;

              case 29:
                dispatch(verifiedUserInfo(null));
                _context3.next = 32;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('currentUserInfo');

              case 32:
                _currentUserInfo = _context3.sent;

                if (_currentUserInfo && _currentUserInfo.mobileNo) dispatch(userMobileNo(_currentUserInfo.mobileNo));else dispatch(userMobileNo(null));
                if (_currentUserInfo && _currentUserInfo.nickName) dispatch(nickName(_currentUserInfo.nickName));else dispatch(nickName(null));
                if (_currentUserInfo && _currentUserInfo.name) dispatch(trueName(_currentUserInfo.name));else dispatch(trueName(null));
                if (_currentUserInfo && _currentUserInfo.isPrivate) dispatch(isPrivate(_currentUserInfo.isPrivate));else dispatch(isPrivate(null));
                console.log(data.code);
                if (callback) {
                  callback();
                }

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function successCallback(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var errorCallback = function () {
      var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(err) {
        var currentUserInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch(verifiedUserInfo(null));
                _context4.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["d" /* getStorage */])('currentUserInfo');

              case 3:
                currentUserInfo = _context4.sent;

                if (currentUserInfo && currentUserInfo.mobileNo) dispatch(userMobileNo(currentUserInfo.mobileNo));else dispatch(userMobileNo(null));
                if (currentUserInfo && currentUserInfo.nickName) dispatch(nickName(currentUserInfo.nickName));else dispatch(nickName(null));
                if (currentUserInfo && currentUserInfo.name) dispatch(trueName(currentUserInfo.name));else dispatch(trueName(null));
                if (currentUserInfo && currentUserInfo.isPrivate) dispatch(isPrivate(currentUserInfo.isPrivate));else dispatch(isPrivate(null));
                console.log(err);
                if (callback) {
                  callback();
                }

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function errorCallback(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null) {
        token = "";
      }
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/account/getRealUserInfo", { token: token }, successCallback, errorCallback);
    });
  };
}

function getUserInfoListTemp(callback) {
  return function (dispatch, getState) {
    var _this3 = this;

    var successCallback = function () {
      var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (data.code == "0000") {
                  if (callback) {
                    console.log(data);
                    callback(data.content);
                  }
                } else {
                  console.log(data.code);
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }));

      return function successCallback(_x5) {
        return _ref5.apply(this, arguments);
      };
    }();
    var errorCallback = function () {
      var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log(err);

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this3);
      }));

      return function errorCallback(_x6) {
        return _ref6.apply(this, arguments);
      };
    }();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null) {
        token = "";
      }
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/account/getRealUserInfo", { token: token }, successCallback, errorCallback);
    });
  };
}

//通过验证码验证手机号,并绑定手机号
var userBindingMobile = function userBindingMobile(verifyParam, loginContent, succallback, errcallback) {
  return function () {
    var _ref7 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(dispatch, getState) {
      var successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              // dispatch(pageFlag(true));
              successCallback = function () {
                var _ref8 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(succ) {
                  var TM, userInfo, user;
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          // dispatch(pageFlag(false));
                          console.log(succ);

                          if (!(succ && succ.code === '0000')) {
                            _context7.next = 28;
                            break;
                          }

                          cleanCache(dispatch);
                          TM = new Date();

                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
                          userInfo = {
                            userId: succ.content.userId,
                            isRealName: loginContent.tradeAccountNo ? true : false
                          };

                          if (loginContent.name != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { name: loginContent.name });
                          if (loginContent.nickName != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { nickName: loginContent.nickName });
                          if (loginContent.tradeAccountNo != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { tradeAccountNo: loginContent.tradeAccountNo });
                          userInfo.mobileNo = verifyParam.mobileNo;
                          console.log('绑定手机号后userInfo', userInfo);
                          _context7.next = 14;
                          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('userList-' + userInfo.userId);

                        case 14:
                          user = _context7.sent;

                          if (user) {
                            userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(user, userInfo);
                          }
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                          dispatch(isLogin(true));
                          console.log(userInfo, loginContent, 'qw2ewqdq');
                          if (userInfo.isRealName) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '2');
                          } else {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '1');
                          }
                          dispatch(userMobileNo(verifyParam.mobileNo));
                          dispatch(getUserInfoList());
                          succallback();
                          _context7.next = 30;
                          break;

                        case 28:
                          console.log('后台返回数据有误！' + succ.message);
                          errcallback(succ.message);

                        case 30:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this);
                }));

                return function successCallback(_x9) {
                  return _ref8.apply(this, arguments);
                };
              }();

              errorCallback = function errorCallback(err) {
                // dispatch(pageFlag(false));
                console.log(err);
                errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
              };

              __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/bindingMobileNo', verifyParam, successCallback, errorCallback);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this);
    }));

    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};

//注册
var registerAccount = function registerAccount(params, succallback, errcallback) {
  return function (dispatch, getState) {
    params.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
    // dispatch(pageFlag(true));
    var successCallback = function () {
      var _ref9 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(succ) {
        var TM, userInfo, user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(succ && succ.code === '0000')) {
                  _context9.next = 26;
                  break;
                }

                cleanCache(dispatch);
                TM = new Date();

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeLong', TM.getTime() + window.tokenTimeLong);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
                userInfo = {
                  userId: succ.content.userId,
                  isRealName: succ.content.tradeAccountNo ? true : false
                };

                if (succ.content.name != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { name: succ.content.name });
                if (succ.content.nickName != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { nickName: succ.content.nickName });
                if (succ.content.tradeAccountNo != undefined) userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(userInfo, { tradeAccountNo: succ.content.tradeAccountNo });
                userInfo.mobileNo = params.mobileNo;
                console.log('注册userInfo', userInfo);
                _context9.next = 13;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('userList-' + userInfo.userId);

              case 13:
                user = _context9.sent;

                if (user != 9999) {
                  userInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["e" /* mergeObjectEasy */])(user, userInfo);
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('currentUserInfo', userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('userList-' + userInfo.userId, userInfo);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-shortToken', succ.content.shortToken);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])('loginInfo-longToken', succ.content.longToken);
                dispatch(isLogin(true));
                if (userInfo.isRealName) {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '2');
                } else {
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["a" /* setStorage */])("loginState", '1');
                }
                dispatch(userMobileNo(params.mobileNo));
                console.log(succ);
                //dispatch(getUserInfoList());
                succallback();
                _context9.next = 29;
                break;

              case 26:
                console.log(succ);
                console.log('后台返回数据有误');
                errcallback(succ.message);

              case 29:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this);
      }));

      return function successCallback(_x10) {
        return _ref9.apply(this, arguments);
      };
    }();
    var errorCallback = function errorCallback(err) {
      // dispatch(pageFlag(false));

      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/register', params, successCallback, errorCallback);
  };
};

//预约理财师
var ReservationManager = function ReservationManager(paramsInit, callback) {
  return function (dispatch, getState) {
    paramsInit.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
    var successCallback = function successCallback(succ) {
      if (succ && succ.code == '0000') {
        // Toast.info(succ.message, Util.ToastTime );
        callback(succ.content);
        console.log(succ);
      } else {
        console.log(succ);
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(succ.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        console.log('后台返回数据有误!');
      }
    };
    var errorCallback = function errorCallback(err) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("预约失败", __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      console.log(err);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/consultant/consultantSubmit', paramsInit, successCallback, errorCallback);
  };
};

//获取图片验证码
var getCapchaCode = function getCapchaCode(params, succallback, errcallback) {
  console.log('9999', params);
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code == '0000') {
        console.log(succ);
        succallback(succ.content.verifyCode, succ.content.base64Img);
      } else {
        console.log(succ);
        console.log('后台返回数据有误!');
        errcallback(succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/verifyCode', params, successCallback, errorCallback);
  };
};

//查询是否签署同步协议
function getTbuxy(params, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      console.log(params, data);
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/aml/sign/isSyncAccount", params, function (res) {
        console.log(res);
        if (res.code == "0000") {
          callback(res.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(res.message, 2);
        }
      }, function (error) {
        console.log(error);
      });
    });
  };
}

//同步协议签署
function getTbuxyQis(params, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      console.log(params, data);
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/aml/sign/syncAccountInformation", params, function (res) {
        console.log(res);
        if (res.code == "0000") {
          callback(res.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(res.message, 2);
        }
      }, function (error) {
        console.log(error);
      });
    });
  };
}

//财富开户直销
function getTbuxyKh(params, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      var randomInt = Math.floor(1 + Math.random() * 10000);
      var successCallback = function successCallback(succ) {
        if (succ && succ.code === '0000') {
          callback(succ.content);
        } else {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(succ.message, 2);
        }
      };
      var errorCallback = function errorCallback(err) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
      };
      params.token = data;
      params.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
      params.clientDeviceNo = "hxcfH5" + randomInt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.postNew(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/v1/account/syncOpenOtsAccount', params, successCallback, errorCallback);
    });
  };
}

//未登录-校验图形验证码后获取手机验证码
var getMobileCaptcha = function getMobileCaptcha(params, succallback, errcallback) {
  var fun = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  return function (dispatch, getState) {
    console.log(params);
    var successCallback = function successCallback(succ) {
      if (succ && succ.code == '0000') {
        console.log(succ);
        succallback(succ.content);
      } else {
        console.log(succ);
        if (fun) {
          errcallback(fun);
          return;
        }
        errcallback(succ);
      }
    };
    var errorCallback = function errorCallback(err) {
      // Toast.show(Util.errorTxt, getToastConfPoint());
      console.log(err);
      // callback('');
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/mobileCaptcha/getMobileCaptcha', params, successCallback, errorCallback);
  };
};
//新获取图片验证码 20/3/12
var getCapcha = function getCapcha(succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code == '0000') {
        console.log(succ);
        succallback(succ.content.token, succ.content.base64);
      } else {
        console.log(succ);
        console.log('后台返回数据有误!');
        errcallback(succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/captcha/getCaptcha', {}, successCallback, errorCallback);
  };
};

//重置登录密码
var resetPassword = function resetPassword(params, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code === '0000') {
        console.log(succ);
        succallback(succ.message);
      } else {
        console.log(succ);
        console.log('后台返回数据有误');
        errcallback(succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/resetLoginPassword', params, successCallback, errorCallback);
  };
};

//2019.12.23 修改后的重置登陆密码接口
var forgetPassword = function forgetPassword(params, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code === '0000') {
        console.log(succ);
        succallback(succ.message);
      } else {
        console.log(succ);
        console.log('后台返回数据有误');
        errcallback(succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/password/forgetPassword', params, successCallback, errorCallback);
  };
};

//修改登录密码
var updateLoginPassword = function updateLoginPassword(params, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      console.log(succ);
      if (succ && succ.code === '0000') {
        console.log('修改登录密码成功', succ);
        succallback();
      } else {
        console.log('修改登录密码失败，服务器返回错误');
        errcallback(succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log('修改登录密码请求失败！');
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/editLoginPassword', params, successCallback, errorCallback);
  };
};

//修改交易密码
var updateTradePassword = function updateTradePassword(params, succallback, errcallback) {
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code === '0000') {
        console.log('修改交易密码成功', succ);
        succallback();
      } else {
        console.log('后台返回数据有误');
        errcallback(succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log('修改交易密码请求失败！');
      errcallback(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    };
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + '/api/account/updateTradePassword', params, successCallback, errorCallback);
  };
};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var pathTool = __webpack_require__(1946);

var colorTool = __webpack_require__(195);

var matrix = __webpack_require__(127);

var vector = __webpack_require__(53);

var Path = __webpack_require__(54);

var Transformable = __webpack_require__(717);

var Image = __webpack_require__(263);

exports.Image = Image;

var Group = __webpack_require__(261);

exports.Group = Group;

var Text = __webpack_require__(264);

exports.Text = Text;

var Circle = __webpack_require__(1934);

exports.Circle = Circle;

var Sector = __webpack_require__(1940);

exports.Sector = Sector;

var Ring = __webpack_require__(1939);

exports.Ring = Ring;

var Polygon = __webpack_require__(1936);

exports.Polygon = Polygon;

var Polyline = __webpack_require__(1937);

exports.Polyline = Polyline;

var Rect = __webpack_require__(1938);

exports.Rect = Rect;

var Line = __webpack_require__(1935);

exports.Line = Line;

var BezierCurve = __webpack_require__(1933);

exports.BezierCurve = BezierCurve;

var Arc = __webpack_require__(1932);

exports.Arc = Arc;

var CompoundPath = __webpack_require__(1926);

exports.CompoundPath = CompoundPath;

var LinearGradient = __webpack_require__(1927);

exports.LinearGradient = LinearGradient;

var RadialGradient = __webpack_require__(1928);

exports.RadialGradient = RadialGradient;

var BoundingRect = __webpack_require__(63);

exports.BoundingRect = BoundingRect;
var round = Math.round;
var mathMax = Math.max;
var mathMin = Math.min;
var EMPTY_OBJ = {};
/**
 * Extend shape with parameters
 */

function extendShape(opts) {
  return Path.extend(opts);
}
/**
 * Extend path
 */


function extendPath(pathData, opts) {
  return pathTool.extendFromString(pathData, opts);
}
/**
 * Create a path element from path data string
 * @param {string} pathData
 * @param {Object} opts
 * @param {module:zrender/core/BoundingRect} rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makePath(pathData, opts, rect, layout) {
  var path = pathTool.createFromString(pathData, opts);
  var boundingRect = path.getBoundingRect();

  if (rect) {
    if (layout === 'center') {
      rect = centerGraphic(rect, boundingRect);
    }

    resizePath(path, rect);
  }

  return path;
}
/**
 * Create a image element from image url
 * @param {string} imageUrl image url
 * @param {Object} opts options
 * @param {module:zrender/core/BoundingRect} rect constrain rect
 * @param {string} [layout=cover] 'center' or 'cover'
 */


function makeImage(imageUrl, rect, layout) {
  var path = new Image({
    style: {
      image: imageUrl,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    onload: function (img) {
      if (layout === 'center') {
        var boundingRect = {
          width: img.width,
          height: img.height
        };
        path.setStyle(centerGraphic(rect, boundingRect));
      }
    }
  });
  return path;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  {Object} rect         element local bounding box
 * @param  {Object} boundingRect constraint bounding box
 * @return {Object} element position containing x, y, width, and height
 */


function centerGraphic(rect, boundingRect) {
  // Set rect to center, keep width / height ratio.
  var aspect = boundingRect.width / boundingRect.height;
  var width = rect.height * aspect;
  var height;

  if (width <= rect.width) {
    height = rect.height;
  } else {
    width = rect.width;
    height = width / aspect;
  }

  var cx = rect.x + rect.width / 2;
  var cy = rect.y + rect.height / 2;
  return {
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  };
}

var mergePath = pathTool.mergePath;
/**
 * Resize a path to fit the rect
 * @param {module:zrender/graphic/Path} path
 * @param {Object} rect
 */

function resizePath(path, rect) {
  if (!path.applyTransform) {
    return;
  }

  var pathRect = path.getBoundingRect();
  var m = pathRect.calculateTransform(rect);
  path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x1]
 * @param {number} [param.shape.y1]
 * @param {number} [param.shape.x2]
 * @param {number} [param.shape.y2]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeLine(param) {
  var shape = param.shape;
  var lineWidth = param.style.lineWidth;

  if (round(shape.x1 * 2) === round(shape.x2 * 2)) {
    shape.x1 = shape.x2 = subPixelOptimize(shape.x1, lineWidth, true);
  }

  if (round(shape.y1 * 2) === round(shape.y2 * 2)) {
    shape.y1 = shape.y2 = subPixelOptimize(shape.y1, lineWidth, true);
  }

  return param;
}
/**
 * Sub pixel optimize rect for canvas
 *
 * @param {Object} param
 * @param {Object} [param.shape]
 * @param {number} [param.shape.x]
 * @param {number} [param.shape.y]
 * @param {number} [param.shape.width]
 * @param {number} [param.shape.height]
 * @param {Object} [param.style]
 * @param {number} [param.style.lineWidth]
 * @return {Object} Modified param
 */


function subPixelOptimizeRect(param) {
  var shape = param.shape;
  var lineWidth = param.style.lineWidth;
  var originX = shape.x;
  var originY = shape.y;
  var originWidth = shape.width;
  var originHeight = shape.height;
  shape.x = subPixelOptimize(shape.x, lineWidth, true);
  shape.y = subPixelOptimize(shape.y, lineWidth, true);
  shape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - shape.x, originWidth === 0 ? 0 : 1);
  shape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - shape.y, originHeight === 0 ? 0 : 1);
  return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param {number} position Coordinate, such as x, y
 * @param {number} lineWidth Should be nonnegative integer.
 * @param {boolean=} positiveOrNegative Default false (negative).
 * @return {number} Optimized position.
 */


function subPixelOptimize(position, lineWidth, positiveOrNegative) {
  // Assure that (position + lineWidth / 2) is near integer edge,
  // otherwise line will be fuzzy in canvas.
  var doubledPosition = round(position * 2);
  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

function hasFillOrStroke(fillOrStroke) {
  return fillOrStroke != null && fillOrStroke != 'none';
}

function liftColor(color) {
  return typeof color === 'string' ? colorTool.lift(color, -0.1) : color;
}
/**
 * @private
 */


function cacheElementStl(el) {
  if (el.__hoverStlDirty) {
    var stroke = el.style.stroke;
    var fill = el.style.fill; // Create hoverStyle on mouseover

    var hoverStyle = el.__hoverStl;
    hoverStyle.fill = hoverStyle.fill || (hasFillOrStroke(fill) ? liftColor(fill) : null);
    hoverStyle.stroke = hoverStyle.stroke || (hasFillOrStroke(stroke) ? liftColor(stroke) : null);
    var normalStyle = {};

    for (var name in hoverStyle) {
      // See comment in `doSingleEnterHover`.
      if (hoverStyle[name] != null) {
        normalStyle[name] = el.style[name];
      }
    }

    el.__normalStl = normalStyle;
    el.__hoverStlDirty = false;
  }
}
/**
 * @private
 */


function doSingleEnterHover(el) {
  if (el.__isHover) {
    return;
  }

  cacheElementStl(el);

  if (el.useHoverLayer) {
    el.__zr && el.__zr.addHover(el, el.__hoverStl);
  } else {
    var style = el.style;
    var insideRollbackOpt = style.insideRollbackOpt; // Consider case: only `position: 'top'` is set on emphasis, then text
    // color should be returned to `autoColor`, rather than remain '#fff'.
    // So we should rollback then apply again after style merging.

    insideRollbackOpt && rollbackInsideStyle(style); // styles can be:
    // {
    //     label: {
    //         normal: {
    //             show: false,
    //             position: 'outside',
    //             fontSize: 18
    //         },
    //         emphasis: {
    //             show: true
    //         }
    //     }
    // },
    // where properties of `emphasis` may not appear in `normal`. We previously use
    // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
    // But consider rich text and setOption in merge mode, it is impossible to cover
    // all properties in merge. So we use merge mode when setting style here, where
    // only properties that is not `null/undefined` can be set. The disadventage:
    // null/undefined can not be used to remove style any more in `emphasis`.

    style.extendFrom(el.__hoverStl); // Do not save `insideRollback`.

    if (insideRollbackOpt) {
      applyInsideStyle(style, style.insideOriginalTextPosition, insideRollbackOpt); // textFill may be rollbacked to null.

      if (style.textFill == null) {
        style.textFill = insideRollbackOpt.autoColor;
      }
    }

    el.dirty(false);
    el.z2 += 1;
  }

  el.__isHover = true;
}
/**
 * @inner
 */


function doSingleLeaveHover(el) {
  if (!el.__isHover) {
    return;
  }

  var normalStl = el.__normalStl;

  if (el.useHoverLayer) {
    el.__zr && el.__zr.removeHover(el);
  } else {
    // Consider null/undefined value, should use
    // `setStyle` but not `extendFrom(stl, true)`.
    normalStl && el.setStyle(normalStl);
    el.z2 -= 1;
  }

  el.__isHover = false;
}
/**
 * @inner
 */


function doEnterHover(el) {
  el.type === 'group' ? el.traverse(function (child) {
    if (child.type !== 'group') {
      doSingleEnterHover(child);
    }
  }) : doSingleEnterHover(el);
}

function doLeaveHover(el) {
  el.type === 'group' ? el.traverse(function (child) {
    if (child.type !== 'group') {
      doSingleLeaveHover(child);
    }
  }) : doSingleLeaveHover(el);
}
/**
 * @inner
 */


function setElementHoverStl(el, hoverStl) {
  // If element has sepcified hoverStyle, then use it instead of given hoverStyle
  // Often used when item group has a label element and it's hoverStyle is different
  el.__hoverStl = el.hoverStyle || hoverStl || {};
  el.__hoverStlDirty = true;

  if (el.__isHover) {
    cacheElementStl(el);
  }
}
/**
 * @inner
 */


function onElementMouseOver(e) {
  if (this.__hoverSilentOnTouch && e.zrByTouch) {
    return;
  } // Only if element is not in emphasis status


  !this.__isEmphasis && doEnterHover(this);
}
/**
 * @inner
 */


function onElementMouseOut(e) {
  if (this.__hoverSilentOnTouch && e.zrByTouch) {
    return;
  } // Only if element is not in emphasis status


  !this.__isEmphasis && doLeaveHover(this);
}
/**
 * @inner
 */


function enterEmphasis() {
  this.__isEmphasis = true;
  doEnterHover(this);
}
/**
 * @inner
 */


function leaveEmphasis() {
  this.__isEmphasis = false;
  doLeaveHover(this);
}
/**
 * Set hover style of element.
 * This method can be called repeatly without side-effects.
 * @param {module:zrender/Element} el
 * @param {Object} [hoverStyle]
 * @param {Object} [opt]
 * @param {boolean} [opt.hoverSilentOnTouch=false]
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conviniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, hoverSilentOnTouch should be used to disable hover-highlight
 *        on touch device.
 */


function setHoverStyle(el, hoverStyle, opt) {
  el.__hoverSilentOnTouch = opt && opt.hoverSilentOnTouch;
  el.type === 'group' ? el.traverse(function (child) {
    if (child.type !== 'group') {
      setElementHoverStl(child, hoverStyle);
    }
  }) : setElementHoverStl(el, hoverStyle); // Duplicated function will be auto-ignored, see Eventful.js.

  el.on('mouseover', onElementMouseOver).on('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually

  el.on('emphasis', enterEmphasis).on('normal', leaveEmphasis);
}
/**
 * @param {Object|module:zrender/graphic/Style} normalStyle
 * @param {Object} emphasisStyle
 * @param {module:echarts/model/Model} normalModel
 * @param {module:echarts/model/Model} emphasisModel
 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
 * @param {Object} [opt.defaultText]
 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDataIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {module:echarts/model/Model} [opt.labelDimIndex] Fetch text by
 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex)`
 * @param {Object} [normalSpecified]
 * @param {Object} [emphasisSpecified]
 */


function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
  opt = opt || EMPTY_OBJ;
  var labelFetcher = opt.labelFetcher;
  var labelDataIndex = opt.labelDataIndex;
  var labelDimIndex = opt.labelDimIndex; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
  // is not supported util someone requests.

  var showNormal = normalModel.getShallow('show');
  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.

  var baseText = showNormal || showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex) : null, opt.defaultText) : null;
  var normalStyleText = showNormal ? baseText : null;
  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.

  if (normalStyleText != null || emphasisStyleText != null) {
    // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.
    // If we set default values on `emphasisStyle`, consider case:
    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
    // Then the 'red' will not work on emphasis.
    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
  }

  normalStyle.text = normalStyleText;
  emphasisStyle.text = emphasisStyleText;
}
/**
 * Set basic textStyle properties.
 * @param {Object|module:zrender/graphic/Style} textStyle
 * @param {module:echarts/model/Model} model
 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
 * @param {boolean} [isEmphasis]
 */


function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle);
  textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
  return textStyle;
}
/**
 * Set text option in the style.
 * @deprecated
 * @param {Object} textStyle
 * @param {module:echarts/model/Model} labelModel
 * @param {string|boolean} defaultColor Default text color.
 *        If set as false, it will be processed as a emphasis style.
 */


function setText(textStyle, labelModel, defaultColor) {
  var opt = {
    isRectText: true
  };
  var isEmphasis;

  if (defaultColor === false) {
    isEmphasis = true;
  } else {
    // Support setting color as 'auto' to get visual color.
    opt.autoColor = defaultColor;
  }

  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis);
  textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
}
/**
 * {
 *      disableBox: boolean, Whether diable drawing box of block (outer most).
 *      isRectText: boolean,
 *      autoColor: string, specify a color when color is 'auto',
 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
 *              If autoColor specified, it is used as default textFill.
 *      useInsideStyle:
 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
 *                  if `textFill` is not specified.
 *              `false`: Do not use inside style.
 *              `null/undefined`: use inside style if `isRectText` is true and
 *                  `textFill` is not specified and textPosition contains `'inside'`.
 *      forceRich: boolean
 * }
 */


function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
  // Consider there will be abnormal when merge hover style to normal style if given default value.
  opt = opt || EMPTY_OBJ;

  if (opt.isRectText) {
    var textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.

    textPosition === 'outside' && (textPosition = 'top');
    textStyle.textPosition = textPosition;
    textStyle.textOffset = textStyleModel.getShallow('offset');
    var labelRotate = textStyleModel.getShallow('rotate');
    labelRotate != null && (labelRotate *= Math.PI / 180);
    textStyle.textRotation = labelRotate;
    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
  }

  var ecModel = textStyleModel.ecModel;
  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
  // {
  //     data: [{
  //         value: 12,
  //         label: {
  //             normal: {
  //                 rich: {
  //                     // no 'a' here but using parent 'a'.
  //                 }
  //             }
  //         }
  //     }],
  //     rich: {
  //         a: { ... }
  //     }
  // }

  var richItemNames = getRichItemNames(textStyleModel);
  var richResult;

  if (richItemNames) {
    richResult = {};

    for (var name in richItemNames) {
      if (richItemNames.hasOwnProperty(name)) {
        // Cascade is supported in rich.
        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.

        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
      }
    }
  }

  textStyle.rich = richResult;
  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);

  if (opt.forceRich && !opt.textStyle) {
    opt.textStyle = {};
  }

  return textStyle;
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             normal: {
//                 rich: {
//                     // no 'a' here but using parent 'a'.
//                 }
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }


function getRichItemNames(textStyleModel) {
  // Use object to remove duplicated names.
  var richItemNameMap;

  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
    var rich = (textStyleModel.option || EMPTY_OBJ).rich;

    if (rich) {
      richItemNameMap = richItemNameMap || {};

      for (var name in rich) {
        if (rich.hasOwnProperty(name)) {
          richItemNameMap[name] = 1;
        }
      }
    }

    textStyleModel = textStyleModel.parentModel;
  }

  return richItemNameMap;
}

function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
  // In merge mode, default value should not be given.
  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);

  if (!isEmphasis) {
    if (isBlock) {
      // Always set `insideRollback`, for clearing previous.
      var originalTextPosition = textStyle.textPosition;
      textStyle.insideRollback = applyInsideStyle(textStyle, originalTextPosition, opt); // Save original textPosition, because style.textPosition will be repalced by
      // real location (like [10, 30]) in zrender.

      textStyle.insideOriginalTextPosition = originalTextPosition;
      textStyle.insideRollbackOpt = opt;
    } // Set default finally.


    if (textStyle.textFill == null) {
      textStyle.textFill = opt.autoColor;
    }
  } // Do not use `getFont` here, because merge should be supported, where
  // part of these properties may be changed in emphasis style, and the
  // others should remain their original value got from normal style.


  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
  textStyle.textAlign = textStyleModel.getShallow('align');
  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
  textStyle.textWidth = textStyleModel.getShallow('width');
  textStyle.textHeight = textStyleModel.getShallow('height');
  textStyle.textTag = textStyleModel.getShallow('tag');

  if (!isBlock || !opt.disableBox) {
    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
    textStyle.textPadding = textStyleModel.getShallow('padding');
    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
  }

  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
}

function getAutoColor(color, opt) {
  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
}

function applyInsideStyle(textStyle, textPosition, opt) {
  var useInsideStyle = opt.useInsideStyle;
  var insideRollback;

  if (textStyle.textFill == null && useInsideStyle !== false && (useInsideStyle === true || opt.isRectText && textPosition // textPosition can be [10, 30]
  && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0)) {
    insideRollback = {
      textFill: null,
      textStroke: textStyle.textStroke,
      textStrokeWidth: textStyle.textStrokeWidth
    };
    textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.

    if (textStyle.textStroke == null) {
      textStyle.textStroke = opt.autoColor;
      textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
    }
  }

  return insideRollback;
}

function rollbackInsideStyle(style) {
  var insideRollback = style.insideRollback;

  if (insideRollback) {
    style.textFill = insideRollback.textFill;
    style.textStroke = insideRollback.textStroke;
    style.textStrokeWidth = insideRollback.textStrokeWidth;
  }
}

function getFont(opt, ecModel) {
  // ecModel or default text style model.
  var gTextStyleModel = ecModel || ecModel.getModel('textStyle');
  return [// FIXME in node-canvas fontWeight is before fontStyle
  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' ');
}

function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
  if (typeof dataIndex === 'function') {
    cb = dataIndex;
    dataIndex = null;
  } // Do not check 'animation' property directly here. Consider this case:
  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
  // but its parent model (`seriesModel`) does.


  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();

  if (animationEnabled) {
    var postfix = isUpdate ? 'Update' : '';
    var duration = animatableModel.getShallow('animationDuration' + postfix);
    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);

    if (typeof animationDelay === 'function') {
      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    }

    if (typeof duration === 'function') {
      duration = duration(dataIndex);
    }

    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
  } else {
    el.stopAnimation();
    el.attr(props);
    cb && cb();
  }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So if do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} [cb]
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */


function updateProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
}
/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So if do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 *
 * @param {module:zrender/Element} el
 * @param {Object} props
 * @param {module:echarts/model/Model} [animatableModel]
 * @param {number} [dataIndex]
 * @param {Function} cb
 */


function initProps(el, props, animatableModel, dataIndex, cb) {
  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
}
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param {module:zrender/mixin/Transformable} target
 * @param {module:zrender/mixin/Transformable} [ancestor]
 */


function getTransform(target, ancestor) {
  var mat = matrix.identity([]);

  while (target && target !== ancestor) {
    matrix.mul(mat, target.getLocalTransform(), mat);
    target = target.parent;
  }

  return mat;
}
/**
 * Apply transform to an vertex.
 * @param {Array.<number>} target [x, y]
 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param {boolean=} invert Whether use invert matrix.
 * @return {Array.<number>} [x, y]
 */


function applyTransform(target, transform, invert) {
  if (transform && !zrUtil.isArrayLike(transform)) {
    transform = Transformable.getLocalTransform(transform);
  }

  if (invert) {
    transform = matrix.invert([], transform);
  }

  return vector.applyTransform([], target, transform);
}
/**
 * @param {string} direction 'left' 'right' 'top' 'bottom'
 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param {boolean=} invert Whether use invert matrix.
 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
 */


function transformDirection(direction, transform, invert) {
  // Pick a base, ensure that transform result will not be (0, 0).
  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
  vertex = applyTransform(vertex, transform, invert);
  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */


function groupTransition(g1, g2, animatableModel, cb) {
  if (!g1 || !g2) {
    return;
  }

  function getElMap(g) {
    var elMap = {};
    g.traverse(function (el) {
      if (!el.isGroup && el.anid) {
        elMap[el.anid] = el;
      }
    });
    return elMap;
  }

  function getAnimatableProps(el) {
    var obj = {
      position: vector.clone(el.position),
      rotation: el.rotation
    };

    if (el.shape) {
      obj.shape = zrUtil.extend({}, el.shape);
    }

    return obj;
  }

  var elMap1 = getElMap(g1);
  g2.traverse(function (el) {
    if (!el.isGroup && el.anid) {
      var oldEl = elMap1[el.anid];

      if (oldEl) {
        var newProp = getAnimatableProps(el);
        el.attr(getAnimatableProps(oldEl));
        updateProps(el, newProp, animatableModel, el.dataIndex);
      } // else {
      //     if (el.previousProps) {
      //         graphic.updateProps
      //     }
      // }

    }
  });
}
/**
 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
 * @param {Object} rect {x, y, width, height}
 * @return {Array.<Array.<number>>} A new clipped points.
 */


function clipPointsByRect(points, rect) {
  return zrUtil.map(points, function (point) {
    var x = point[0];
    x = mathMax(x, rect.x);
    x = mathMin(x, rect.x + rect.width);
    var y = point[1];
    y = mathMax(y, rect.y);
    y = mathMin(y, rect.y + rect.height);
    return [x, y];
  });
}
/**
 * @param {Object} targetRect {x, y, width, height}
 * @param {Object} rect {x, y, width, height}
 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
 */


function clipRectByRect(targetRect, rect) {
  var x = mathMax(targetRect.x, rect.x);
  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
  var y = mathMax(targetRect.y, rect.y);
  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height);

  if (x2 >= x && y2 >= y) {
    return {
      x: x,
      y: y,
      width: x2 - x,
      height: y2 - y
    };
  }
}
/**
 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
 * @param {Object} [rect] {x, y, width, height}
 * @return {module:zrender/Element} Icon path or image element.
 */


function createIcon(iconStr, opt, rect) {
  opt = zrUtil.extend({
    rectHover: true
  }, opt);
  var style = opt.style = {
    strokeNoScale: true
  };
  rect = rect || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  };

  if (iconStr) {
    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new Image(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
  }
}

exports.extendShape = extendShape;
exports.extendPath = extendPath;
exports.makePath = makePath;
exports.makeImage = makeImage;
exports.mergePath = mergePath;
exports.resizePath = resizePath;
exports.subPixelOptimizeLine = subPixelOptimizeLine;
exports.subPixelOptimizeRect = subPixelOptimizeRect;
exports.subPixelOptimize = subPixelOptimize;
exports.setHoverStyle = setHoverStyle;
exports.setLabelStyle = setLabelStyle;
exports.setTextStyle = setTextStyle;
exports.setText = setText;
exports.getFont = getFont;
exports.updateProps = updateProps;
exports.initProps = initProps;
exports.getTransform = getTransform;
exports.applyTransform = applyTransform;
exports.transformDirection = transformDirection;
exports.groupTransition = groupTransition;
exports.clipPointsByRect = clipPointsByRect;
exports.clipRectByRect = clipRectByRect;
exports.createIcon = createIcon;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var DOMProperty = __webpack_require__(141);
var ReactDOMComponentFlags = __webpack_require__(547);

var invariant = __webpack_require__(15);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(990);
module.exports = __webpack_require__(60).Object.assign;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(992);
var $Object = __webpack_require__(60).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bank.491d6be0.png";

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(997);
__webpack_require__(996);
__webpack_require__(998);
__webpack_require__(999);
module.exports = __webpack_require__(60).Symbol;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(460);
__webpack_require__(1000);
module.exports = __webpack_require__(295).f('iterator');

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(991);
var $Object = __webpack_require__(60).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(995);
module.exports = __webpack_require__(60).Object.setPrototypeOf;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(116));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var formatUtil = __webpack_require__(71);

var nubmerUtil = __webpack_require__(48);

var Model = __webpack_require__(70);

var each = zrUtil.each;
var isObject = zrUtil.isObject;
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */

function normalizeToArray(value) {
  return value instanceof Array ? value : value == null ? [] : [value];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *         normal: {
 *             show: false,
 *             position: 'outside',
 *             fontSize: 18
 *         },
 *         emphasis: {
 *             show: true
 *         }
 *     }
 * @param {Object} opt
 * @param {Array.<string>} subOpts
 */


function defaultEmphasis(opt, subOpts) {
  if (opt) {
    var emphasisOpt = opt.emphasis = opt.emphasis || {};
    var normalOpt = opt.normal = opt.normal || {}; // Default emphasis option from normal

    for (var i = 0, len = subOpts.length; i < len; i++) {
      var subOptName = subOpts[i];

      if (!emphasisOpt.hasOwnProperty(subOptName) && normalOpt.hasOwnProperty(subOptName)) {
        emphasisOpt[subOptName] = normalOpt[subOptName];
      }
    }
  }
}

var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);

/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retieves value from data.
 * @param {string|number|Date|Array|Object} dataItem
 * @return {number|string|Date|Array.<number|string|Date>}
 */

function getDataItemValue(dataItem) {
  // Performance sensitive.
  return dataItem && (dataItem.value == null ? dataItem : dataItem.value);
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 * @param {string|number|Date|Array|Object} dataItem
 */


function isDataItemOption(dataItem) {
  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
/**
 * This helper method convert value in data.
 * @param {string|number|Date} value
 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
 */


function converDataValue(value, dimInfo) {
  // Performance sensitive.
  var dimType = dimInfo && dimInfo.type;

  if (dimType === 'ordinal') {
    return value;
  }

  if (dimType === 'time' // spead up when using timestamp
  && typeof value !== 'number' && value != null && value !== '-') {
    value = +nubmerUtil.parseDate(value);
  } // dimType defaults 'number'.
  // If dimType is not ordinal and value is null or undefined or NaN or '-',
  // parse to NaN.


  return value == null || value === '' ? NaN : +value; // If string (like '-'), using '+' parse to NaN
}
/**
 * Create a model proxy to be used in tooltip for edge data, markLine data, markPoint data.
 * @param {module:echarts/data/List} data
 * @param {Object} opt
 * @param {string} [opt.seriesIndex]
 * @param {Object} [opt.name]
 * @param {Object} [opt.mainType]
 * @param {Object} [opt.subType]
 */


function createDataFormatModel(data, opt) {
  var model = new Model();
  zrUtil.mixin(model, dataFormatMixin);
  model.seriesIndex = opt.seriesIndex;
  model.name = opt.name || '';
  model.mainType = opt.mainType;
  model.subType = opt.subType;

  model.getData = function () {
    return data;
  };

  return model;
} // PENDING A little ugly


var dataFormatMixin = {
  /**
   * Get params for formatter
   * @param {number} dataIndex
   * @param {string} [dataType]
   * @return {Object}
   */
  getDataParams: function (dataIndex, dataType) {
    var data = this.getData(dataType);
    var rawValue = this.getRawValue(dataIndex, dataType);
    var rawDataIndex = data.getRawIndex(dataIndex);
    var name = data.getName(dataIndex, true);
    var itemOpt = data.getRawDataItem(dataIndex);
    var color = data.getItemVisual(dataIndex, 'color');
    return {
      componentType: this.mainType,
      componentSubType: this.subType,
      seriesType: this.mainType === 'series' ? this.subType : null,
      seriesIndex: this.seriesIndex,
      seriesId: this.id,
      seriesName: this.name,
      name: name,
      dataIndex: rawDataIndex,
      data: itemOpt,
      dataType: dataType,
      value: rawValue,
      color: color,
      marker: formatUtil.getTooltipMarker(color),
      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
      $vars: ['seriesName', 'name', 'value']
    };
  },

  /**
   * Format label
   * @param {number} dataIndex
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @param {string} [dataType]
   * @param {number} [dimIndex]
   * @param {string} [labelProp='label']
   * @return {string}
   */
  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
    status = status || 'normal';
    var data = this.getData(dataType);
    var itemModel = data.getItemModel(dataIndex);
    var params = this.getDataParams(dataIndex, dataType);

    if (dimIndex != null && params.value instanceof Array) {
      params.value = params.value[dimIndex];
    }

    var formatter = itemModel.get([labelProp || 'label', status, 'formatter']);

    if (typeof formatter === 'function') {
      params.status = status;
      return formatter(params);
    } else if (typeof formatter === 'string') {
      return formatUtil.formatTpl(formatter, params);
    }
  },

  /**
   * Get raw value in option
   * @param {number} idx
   * @param {string} [dataType]
   * @return {Object}
   */
  getRawValue: function (idx, dataType) {
    var data = this.getData(dataType);
    var dataItem = data.getRawDataItem(idx);

    if (dataItem != null) {
      return isObject(dataItem) && !(dataItem instanceof Array) ? dataItem.value : dataItem;
    }
  },

  /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   * @return {string} tooltip string
   */
  formatTooltip: zrUtil.noop
};
/**
 * Mapping to exists for merge.
 *
 * @public
 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
 * @param {Object|Array.<Object>} newCptOptions
 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          index of which is the same as exists.
 */

function mappingToExists(exists, newCptOptions) {
  // Mapping by the order by original option (but not order of
  // new option) in merge mode. Because we should ensure
  // some specified index (like xAxisIndex) is consistent with
  // original option, which is easy to understand, espatially in
  // media query. And in most case, merge option is used to
  // update partial option but not be expected to change order.
  newCptOptions = (newCptOptions || []).slice();
  var result = zrUtil.map(exists || [], function (obj, index) {
    return {
      exist: obj
    };
  }); // Mapping by id or name if specified.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    } // id has highest priority.


    for (var i = 0; i < result.length; i++) {
      if (!result[i].option // Consider name: two map to one.
      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }

    for (var i = 0; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Consider name: two map to one.
      // Can not match when both ids exist but different.
      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
        result[i].option = cptOption;
        newCptOptions[index] = null;
        return;
      }
    }
  }); // Otherwise mapping by index.

  each(newCptOptions, function (cptOption, index) {
    if (!isObject(cptOption)) {
      return;
    }

    var i = 0;

    for (; i < result.length; i++) {
      var exist = result[i].exist;

      if (!result[i].option // Existing model that already has id should be able to
      // mapped to (because after mapping performed model may
      // be assigned with a id, whish should not affect next
      // mapping), except those has inner id.
      && !isIdInner(exist) // Caution:
      // Do not overwrite id. But name can be overwritten,
      // because axis use name as 'show label text'.
      // 'exist' always has id and name and we dont
      // need to check it.
      && cptOption.id == null) {
        result[i].option = cptOption;
        break;
      }
    }

    if (i >= result.length) {
      result.push({
        option: cptOption
      });
    }
  });
  return result;
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 *
 * @public
 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
 *                          which order is the same as exists.
 * @return {Array.<Object>} The input.
 */


function makeIdAndName(mapResult) {
  // We use this id to hash component models and view instances
  // in echarts. id can be specified by user, or auto generated.
  // The id generation rule ensures new view instance are able
  // to mapped to old instance when setOption are called in
  // no-merge mode. So we generate model id by name and plus
  // type in view id.
  // name can be duplicated among components, which is convenient
  // to specify multi components (like series) by one name.
  // Ensure that each id is distinct.
  var idMap = zrUtil.createHashMap();
  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    existCpt && idMap.set(existCpt.id, item);
  });
  each(mapResult, function (item, index) {
    var opt = item.option;
    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
    opt && opt.id != null && idMap.set(opt.id, item);
    !item.keyInfo && (item.keyInfo = {});
  }); // Make name and id.

  each(mapResult, function (item, index) {
    var existCpt = item.exist;
    var opt = item.option;
    var keyInfo = item.keyInfo;

    if (!isObject(opt)) {
      return;
    } // name can be overwitten. Consider case: axis.name = '20km'.
    // But id generated by name will not be changed, which affect
    // only in that case: setOption with 'not merge mode' and view
    // instance will be recreated, which can be accepted.


    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name : '\0-'; // name may be displayed on screen, so use '-'.

    if (existCpt) {
      keyInfo.id = existCpt.id;
    } else if (opt.id != null) {
      keyInfo.id = opt.id + '';
    } else {
      // Consider this situatoin:
      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
      // Series with the same name between optionA and optionB
      // should be mapped.
      var idNum = 0;

      do {
        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
      } while (idMap.get(keyInfo.id));
    }

    idMap.set(keyInfo.id, item);
  });
}
/**
 * @public
 * @param {Object} cptOption
 * @return {boolean}
 */


function isIdInner(cptOption) {
  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
 */


function compressBatches(batchA, batchB) {
  var mapA = {};
  var mapB = {};
  makeMap(batchA || [], mapA);
  makeMap(batchB || [], mapB, mapA);
  return [mapToArray(mapA), mapToArray(mapB)];

  function makeMap(sourceBatch, map, otherMap) {
    for (var i = 0, len = sourceBatch.length; i < len; i++) {
      var seriesId = sourceBatch[i].seriesId;
      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
      var otherDataIndices = otherMap && otherMap[seriesId];

      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
        var dataIndex = dataIndices[j];

        if (otherDataIndices && otherDataIndices[dataIndex]) {
          otherDataIndices[dataIndex] = null;
        } else {
          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
        }
      }
    }
  }

  function mapToArray(map, isData) {
    var result = [];

    for (var i in map) {
      if (map.hasOwnProperty(i) && map[i] != null) {
        if (isData) {
          result.push(+i);
        } else {
          var dataIndices = mapToArray(map[i], true);
          dataIndices.length && result.push({
            seriesId: i,
            dataIndex: dataIndices
          });
        }
      }
    }

    return result;
  }
}
/**
 * @param {module:echarts/data/List} data
 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
 */


function queryDataIndex(data, payload) {
  if (payload.dataIndexInside != null) {
    return payload.dataIndexInside;
  } else if (payload.dataIndex != null) {
    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
      return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
  } else if (payload.name != null) {
    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
      return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
  }
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * var get = modelUitl.makeGetter();
 *
 * function some(hostObj) {
 *      get(hostObj)._someProperty = 1212;
 *      ...
 * }
 *
 * @return {Function}
 */


var makeGetter = function () {
  var index = 0;
  return function () {
    var key = '\0__ec_prop_getter_' + index++;
    return function (hostObj) {
      return hostObj[key] || (hostObj[key] = {});
    };
  };
}();
/**
 * @param {module:echarts/model/Global} ecModel
 * @param {string|Object} finder
 *        If string, e.g., 'geo', means {geoIndex: 0}.
 *        If Object, could contain some of these properties below:
 *        {
 *            seriesIndex, seriesId, seriesName,
 *            geoIndex, geoId, geoName,
 *            bmapIndex, bmapId, bmapName,
 *            xAxisIndex, xAxisId, xAxisName,
 *            yAxisIndex, yAxisId, yAxisName,
 *            gridIndex, gridId, gridName,
 *            ... (can be extended)
 *        }
 *        Each properties can be number|string|Array.<number>|Array.<string>
 *        For example, a finder could be
 *        {
 *            seriesIndex: 3,
 *            geoId: ['aa', 'cc'],
 *            gridName: ['xx', 'rr']
 *        }
 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
 *        If nothing or null/undefined specified, return nothing.
 * @param {Object} [opt]
 * @param {string} [opt.defaultMainType]
 * @param {Array.<string>} [opt.includeMainTypes]
 * @return {Object} result like:
 *        {
 *            seriesModels: [seriesModel1, seriesModel2],
 *            seriesModel: seriesModel1, // The first model
 *            geoModels: [geoModel1, geoModel2],
 *            geoModel: geoModel1, // The first model
 *            ...
 *        }
 */


function parseFinder(ecModel, finder, opt) {
  if (zrUtil.isString(finder)) {
    var obj = {};
    obj[finder + 'Index'] = 0;
    finder = obj;
  }

  var defaultMainType = opt && opt.defaultMainType;

  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
    finder[defaultMainType + 'Index'] = 0;
  }

  var result = {};
  each(finder, function (value, key) {
    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.

    if (key === 'dataIndex' || key === 'dataIndexInside') {
      result[key] = value;
      return;
    }

    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
    var mainType = parsedKey[1];
    var queryType = (parsedKey[2] || '').toLowerCase();

    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
      return;
    }

    var queryParam = {
      mainType: mainType
    };

    if (queryType !== 'index' || value !== 'all') {
      queryParam[queryType] = value;
    }

    var models = ecModel.queryComponents(queryParam);
    result[mainType + 'Models'] = models;
    result[mainType + 'Model'] = models[0];
  });
  return result;
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 * @param {module:echarts/data/List} data
 * @param {string|number} dataDim
 * @return {string}
 */


function dataDimToCoordDim(data, dataDim) {
  var dimensions = data.dimensions;
  dataDim = data.getDimension(dataDim);

  for (var i = 0; i < dimensions.length; i++) {
    var dimItem = data.getDimensionInfo(dimensions[i]);

    if (dimItem.name === dataDim) {
      return dimItem.coordDim;
    }
  }
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 * @param {module:echarts/data/List} data
 * @param {string} coordDim
 * @return {Array.<string>} data dimensions on the coordDim.
 */


function coordDimToDataDim(data, coordDim) {
  var dataDim = [];
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);

    if (dimItem.coordDim === coordDim) {
      dataDim[dimItem.coordDimIndex] = dimItem.name;
    }
  });
  return dataDim;
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 * @param {module:echarts/data/List} data
 * @param {string} otherDim Can be `otherDims`
 *                        like 'label' or 'tooltip'.
 * @return {Array.<string>} data dimensions on the otherDim.
 */


function otherDimToDataDim(data, otherDim) {
  var dataDim = [];
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);
    var otherDims = dimItem.otherDims;
    var dimIndex = otherDims[otherDim];

    if (dimIndex != null && dimIndex !== false) {
      dataDim[dimIndex] = dimItem.name;
    }
  });
  return dataDim;
}

function has(obj, prop) {
  return obj && obj.hasOwnProperty(prop);
}

exports.normalizeToArray = normalizeToArray;
exports.defaultEmphasis = defaultEmphasis;
exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
exports.getDataItemValue = getDataItemValue;
exports.isDataItemOption = isDataItemOption;
exports.converDataValue = converDataValue;
exports.createDataFormatModel = createDataFormatModel;
exports.dataFormatMixin = dataFormatMixin;
exports.mappingToExists = mappingToExists;
exports.makeIdAndName = makeIdAndName;
exports.isIdInner = isIdInner;
exports.compressBatches = compressBatches;
exports.queryDataIndex = queryDataIndex;
exports.makeGetter = makeGetter;
exports.parseFinder = parseFinder;
exports.dataDimToCoordDim = dataDimToCoordDim;
exports.coordDimToDataDim = coordDimToDataDim;
exports.otherDimToDataDim = otherDimToDataDim;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/login_input_cancel.0bfa09d3.png";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var RADIAN_EPSILON = 1e-4;

function _trim(str) {
  return str.replace(/^\s+/, '').replace(/\s+$/, '');
}
/**
 * Linear mapping a value from domain to range
 * @memberOf module:echarts/util/number
 * @param  {(number|Array.<number>)} val
 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
 * @param  {boolean} clamp
 * @return {(number|Array.<number>}
 */


function linearMap(val, domain, range, clamp) {
  var subDomain = domain[1] - domain[0];
  var subRange = range[1] - range[0];

  if (subDomain === 0) {
    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
  } // Avoid accuracy problem in edge, such as
  // 146.39 - 62.83 === 83.55999999999999.
  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
  // It is a little verbose for efficiency considering this method
  // is a hotspot.


  if (clamp) {
    if (subDomain > 0) {
      if (val <= domain[0]) {
        return range[0];
      } else if (val >= domain[1]) {
        return range[1];
      }
    } else {
      if (val >= domain[0]) {
        return range[0];
      } else if (val <= domain[1]) {
        return range[1];
      }
    }
  } else {
    if (val === domain[0]) {
      return range[0];
    }

    if (val === domain[1]) {
      return range[1];
    }
  }

  return (val - domain[0]) / subDomain * subRange + range[0];
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 * @memberOf module:echarts/util/number
 * @param {string|number} percent
 * @param {number} all
 * @return {number}
 */


function parsePercent(percent, all) {
  switch (percent) {
    case 'center':
    case 'middle':
      percent = '50%';
      break;

    case 'left':
    case 'top':
      percent = '0%';
      break;

    case 'right':
    case 'bottom':
      percent = '100%';
      break;
  }

  if (typeof percent === 'string') {
    if (_trim(percent).match(/%$/)) {
      return parseFloat(percent) / 100 * all;
    }

    return parseFloat(percent);
  }

  return percent == null ? NaN : +percent;
}
/**
 * (1) Fix rounding error of float numbers.
 * (2) Support return string to avoid scientific notation like '3.5e-7'.
 *
 * @param {number} x
 * @param {number} [precision]
 * @param {boolean} [returnStr]
 * @return {number|string}
 */


function round(x, precision, returnStr) {
  if (precision == null) {
    precision = 10;
  } // Avoid range error


  precision = Math.min(Math.max(0, precision), 20);
  x = (+x).toFixed(precision);
  return returnStr ? x : +x;
}

function asc(arr) {
  arr.sort(function (a, b) {
    return a - b;
  });
  return arr;
}
/**
 * Get precision
 * @param {number} val
 */


function getPrecision(val) {
  val = +val;

  if (isNaN(val)) {
    return 0;
  } // It is much faster than methods converting number to string as follows
  //      var tmp = val.toString();
  //      return tmp.length - 1 - tmp.indexOf('.');
  // especially when precision is low


  var e = 1;
  var count = 0;

  while (Math.round(val * e) / e !== val) {
    e *= 10;
    count++;
  }

  return count;
}
/**
 * @param {string|number} val
 * @return {number}
 */


function getPrecisionSafe(val) {
  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'

  var eIndex = str.indexOf('e');

  if (eIndex > 0) {
    var precision = +str.slice(eIndex + 1);
    return precision < 0 ? -precision : 0;
  } else {
    var dotIndex = str.indexOf('.');
    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
  }
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 *
 * @param {Array.<number>} dataExtent
 * @param {Array.<number>} pixelExtent
 * @return {number} precision
 */


function getPixelPrecision(dataExtent, pixelExtent) {
  var log = Math.log;
  var LN10 = Math.LN10;
  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.

  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
  return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainer method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param {Array.<number>} valueList a list of all data
 * @param {number} idx index of the data to be processed in valueList
 * @param {number} precision integer number showing digits of precision
 * @return {number} percent ranging from 0 to 100
 */


function getPercentWithPrecision(valueList, idx, precision) {
  if (!valueList[idx]) {
    return 0;
  }

  var sum = zrUtil.reduce(valueList, function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (sum === 0) {
    return 0;
  }

  var digits = Math.pow(10, precision);
  var votesPerQuota = zrUtil.map(valueList, function (val) {
    return (isNaN(val) ? 0 : val) / sum * digits * 100;
  });
  var targetSeats = digits * 100;
  var seats = zrUtil.map(votesPerQuota, function (votes) {
    // Assign automatic seats.
    return Math.floor(votes);
  });
  var currentSum = zrUtil.reduce(seats, function (acc, val) {
    return acc + val;
  }, 0);
  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
    return votes - seats[idx];
  }); // Has remainding votes.

  while (currentSum < targetSeats) {
    // Find next largest remainder.
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;

    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    } // Add a vote to max remainder.


    ++seats[maxId];
    remainder[maxId] = 0;
    ++currentSum;
  }

  return seats[idx] / digits;
} // Number.MAX_SAFE_INTEGER, ie do not support.


var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 * @param {number} radian
 * @return {number}
 */

function remRadian(radian) {
  var pi2 = Math.PI * 2;
  return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */


function isRadianAroundZero(val) {
  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
}

var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line

/**
 * @param {string|Date|number} value These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as loacal time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return {Date} date
 */

function parseDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (typeof value === 'string') {
    // Different browsers parse date in different way, so we parse it manually.
    // Some other issues:
    // new Date('1970-01-01') is UTC,
    // new Date('1970/01/01') and new Date('1970-1-01') is local.
    // See issue #3623
    var match = TIME_REG.exec(value);

    if (!match) {
      // return Invalid Date.
      return new Date(NaN);
    } // Use local time when no timezone offset specifed.


    if (!match[8]) {
      // match[n] can only be string or undefined.
      // But take care of '12' + 1 => '121'.
      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
    // For example, system timezone is set as "Time Zone: America/Toronto",
    // then these code will get different result:
    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
    // So we should not use `new Date`, but use `Date.UTC`.
    else {
        var hour = +match[4] || 0;

        if (match[8].toUpperCase() !== 'Z') {
          hour -= match[8].slice(0, 3);
        }

        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
      }
  } else if (value == null) {
    return new Date(NaN);
  }

  return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param  {number} val
 * @return {number}
 */


function quantity(val) {
  return Math.pow(10, quantityExponent(val));
}

function quantityExponent(val) {
  return Math.floor(Math.log(val) / Math.LN10);
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  {number} val Non-negative value.
 * @param  {boolean} round
 * @return {number}
 */


function nice(val, round) {
  var exponent = quantityExponent(val);
  var exp10 = Math.pow(10, exponent);
  var f = val / exp10; // 1 <= f < 10

  var nf;

  if (round) {
    if (f < 1.5) {
      nf = 1;
    } else if (f < 2.5) {
      nf = 2;
    } else if (f < 4) {
      nf = 3;
    } else if (f < 7) {
      nf = 5;
    } else {
      nf = 10;
    }
  } else {
    if (f < 1) {
      nf = 1;
    } else if (f < 2) {
      nf = 2;
    } else if (f < 3) {
      nf = 3;
    } else if (f < 5) {
      nf = 5;
    } else {
      nf = 10;
    }
  }

  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
  // 20 is the uppper bound of toFixed.

  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param {Array.<Object>} list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return {Array.<Object>} The origin list, which has been reformed.
 */


function reformIntervals(list) {
  list.sort(function (a, b) {
    return littleThan(a, b, 0) ? -1 : 1;
  });
  var curr = -Infinity;
  var currClose = 1;

  for (var i = 0; i < list.length;) {
    var interval = list[i].interval;
    var close = list[i].close;

    for (var lg = 0; lg < 2; lg++) {
      if (interval[lg] <= curr) {
        interval[lg] = curr;
        close[lg] = !lg ? 1 - currClose : 1;
      }

      curr = interval[lg];
      currClose = close[lg];
    }

    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }

  return list;

  function littleThan(a, b, lg) {
    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
  }
}
/**
 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
 * subtraction forces infinities to NaN
 *
 * @param {*} v
 * @return {boolean}
 */


function isNumeric(v) {
  return v - parseFloat(v) >= 0;
}

exports.linearMap = linearMap;
exports.parsePercent = parsePercent;
exports.round = round;
exports.asc = asc;
exports.getPrecision = getPrecision;
exports.getPrecisionSafe = getPrecisionSafe;
exports.getPixelPrecision = getPixelPrecision;
exports.getPercentWithPrecision = getPercentWithPrecision;
exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
exports.remRadian = remRadian;
exports.isRadianAroundZero = isRadianAroundZero;
exports.parseDate = parseDate;
exports.quantity = quantity;
exports.nice = nice;
exports.reformIntervals = reformIntervals;
exports.isNumeric = isNumeric;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square.4839b817.png";

/***/ }),
/* 52 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * 创建一个向量
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @return {Vector2}
 */

function create(x, y) {
  var out = new ArrayCtor(2);

  if (x == null) {
    x = 0;
  }

  if (y == null) {
    y = 0;
  }

  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * 复制向量数据
 * @param {Vector2} out
 * @param {Vector2} v
 * @return {Vector2}
 */


function copy(out, v) {
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 克隆一个向量
 * @param {Vector2} v
 * @return {Vector2}
 */


function clone(v) {
  var out = new ArrayCtor(2);
  out[0] = v[0];
  out[1] = v[1];
  return out;
}
/**
 * 设置向量的两个项
 * @param {Vector2} out
 * @param {number} a
 * @param {number} b
 * @return {Vector2} 结果
 */


function set(out, a, b) {
  out[0] = a;
  out[1] = b;
  return out;
}
/**
 * 向量相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function add(out, v1, v2) {
  out[0] = v1[0] + v2[0];
  out[1] = v1[1] + v2[1];
  return out;
}
/**
 * 向量缩放后相加
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} a
 */


function scaleAndAdd(out, v1, v2, a) {
  out[0] = v1[0] + v2[0] * a;
  out[1] = v1[1] + v2[1] * a;
  return out;
}
/**
 * 向量相减
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function sub(out, v1, v2) {
  out[0] = v1[0] - v2[0];
  out[1] = v1[1] - v2[1];
  return out;
}
/**
 * 向量长度
 * @param {Vector2} v
 * @return {number}
 */


function len(v) {
  return Math.sqrt(lenSquare(v));
}

var length = len; // jshint ignore:line

/**
 * 向量长度平方
 * @param {Vector2} v
 * @return {number}
 */

function lenSquare(v) {
  return v[0] * v[0] + v[1] * v[1];
}

var lengthSquare = lenSquare;
/**
 * 向量乘法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */

function mul(out, v1, v2) {
  out[0] = v1[0] * v2[0];
  out[1] = v1[1] * v2[1];
  return out;
}
/**
 * 向量除法
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 */


function div(out, v1, v2) {
  out[0] = v1[0] / v2[0];
  out[1] = v1[1] / v2[1];
  return out;
}
/**
 * 向量点乘
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function dot(v1, v2) {
  return v1[0] * v2[0] + v1[1] * v2[1];
}
/**
 * 向量缩放
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {number} s
 */


function scale(out, v, s) {
  out[0] = v[0] * s;
  out[1] = v[1] * s;
  return out;
}
/**
 * 向量归一化
 * @param {Vector2} out
 * @param {Vector2} v
 */


function normalize(out, v) {
  var d = len(v);

  if (d === 0) {
    out[0] = 0;
    out[1] = 0;
  } else {
    out[0] = v[0] / d;
    out[1] = v[1] / d;
  }

  return out;
}
/**
 * 计算向量间距离
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */


function distance(v1, v2) {
  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}

var dist = distance;
/**
 * 向量距离平方
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @return {number}
 */

function distanceSquare(v1, v2) {
  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}

var distSquare = distanceSquare;
/**
 * 求负向量
 * @param {Vector2} out
 * @param {Vector2} v
 */

function negate(out, v) {
  out[0] = -v[0];
  out[1] = -v[1];
  return out;
}
/**
 * 插值两个点
 * @param {Vector2} out
 * @param {Vector2} v1
 * @param {Vector2} v2
 * @param {number} t
 */


function lerp(out, v1, v2, t) {
  out[0] = v1[0] + t * (v2[0] - v1[0]);
  out[1] = v1[1] + t * (v2[1] - v1[1]);
  return out;
}
/**
 * 矩阵左乘向量
 * @param {Vector2} out
 * @param {Vector2} v
 * @param {Vector2} m
 */


function applyTransform(out, v, m) {
  var x = v[0];
  var y = v[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * 求两个向量最小值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function min(out, v1, v2) {
  out[0] = Math.min(v1[0], v2[0]);
  out[1] = Math.min(v1[1], v2[1]);
  return out;
}
/**
 * 求两个向量最大值
 * @param  {Vector2} out
 * @param  {Vector2} v1
 * @param  {Vector2} v2
 */


function max(out, v1, v2) {
  out[0] = Math.max(v1[0], v2[0]);
  out[1] = Math.max(v1[1], v2[1]);
  return out;
}

exports.create = create;
exports.copy = copy;
exports.clone = clone;
exports.set = set;
exports.add = add;
exports.scaleAndAdd = scaleAndAdd;
exports.sub = sub;
exports.len = len;
exports.length = length;
exports.lenSquare = lenSquare;
exports.lengthSquare = lengthSquare;
exports.mul = mul;
exports.div = div;
exports.dot = dot;
exports.scale = scale;
exports.normalize = normalize;
exports.distance = distance;
exports.dist = dist;
exports.distanceSquare = distanceSquare;
exports.distSquare = distSquare;
exports.negate = negate;
exports.lerp = lerp;
exports.applyTransform = applyTransform;
exports.min = min;
exports.max = max;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(398);

var zrUtil = __webpack_require__(6);

var PathProxy = __webpack_require__(192);

var pathContain = __webpack_require__(1920);

var Pattern = __webpack_require__(712);

var getCanvasPattern = Pattern.prototype.getCanvasPattern;
var abs = Math.abs;
var pathProxyForDraw = new PathProxy(true);
/**
 * @alias module:zrender/graphic/Path
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */

function Path(opts) {
  Displayable.call(this, opts);
  /**
   * @type {module:zrender/core/PathProxy}
   * @readOnly
   */

  this.path = null;
}

Path.prototype = {
  constructor: Path,
  type: 'path',
  __dirtyPath: true,
  strokeContainThreshold: 5,
  brush: function (ctx, prevEl) {
    var style = this.style;
    var path = this.path || pathProxyForDraw;
    var hasStroke = style.hasStroke();
    var hasFill = style.hasFill();
    var fill = style.fill;
    var stroke = style.stroke;
    var hasFillGradient = hasFill && !!fill.colorStops;
    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
    var hasFillPattern = hasFill && !!fill.image;
    var hasStrokePattern = hasStroke && !!stroke.image;
    style.bind(ctx, this, prevEl);
    this.setTransform(ctx);

    if (this.__dirty) {
      var rect; // Update gradient because bounding rect may changed

      if (hasFillGradient) {
        rect = rect || this.getBoundingRect();
        this._fillGradient = style.getGradient(ctx, fill, rect);
      }

      if (hasStrokeGradient) {
        rect = rect || this.getBoundingRect();
        this._strokeGradient = style.getGradient(ctx, stroke, rect);
      }
    } // Use the gradient or pattern


    if (hasFillGradient) {
      // PENDING If may have affect the state
      ctx.fillStyle = this._fillGradient;
    } else if (hasFillPattern) {
      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
    }

    if (hasStrokeGradient) {
      ctx.strokeStyle = this._strokeGradient;
    } else if (hasStrokePattern) {
      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
    }

    var lineDash = style.lineDash;
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy

    var scale = this.getGlobalScale();
    path.setScale(scale[0], scale[1]); // Proxy context
    // Rebuild path in following 2 cases
    // 1. Path is dirty
    // 2. Path needs javascript implemented lineDash stroking.
    //    In this case, lineDash information will not be saved in PathProxy

    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
      path.beginPath(ctx); // Setting line dash before build path

      if (lineDash && !ctxLineDash) {
        path.setLineDash(lineDash);
        path.setLineDashOffset(lineDashOffset);
      }

      this.buildPath(path, this.shape, false); // Clear path dirty flag

      if (this.path) {
        this.__dirtyPath = false;
      }
    } else {
      // Replay path building
      ctx.beginPath();
      this.path.rebuildPath(ctx);
    }

    hasFill && path.fill(ctx);

    if (lineDash && ctxLineDash) {
      ctx.setLineDash(lineDash);
      ctx.lineDashOffset = lineDashOffset;
    }

    hasStroke && path.stroke(ctx);

    if (lineDash && ctxLineDash) {
      // PENDING
      // Remove lineDash
      ctx.setLineDash([]);
    }

    this.restoreTransform(ctx); // Draw rect text

    if (style.text != null) {
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
  // Like in circle
  buildPath: function (ctx, shapeCfg, inBundle) {},
  createPathProxy: function () {
    this.path = new PathProxy();
  },
  getBoundingRect: function () {
    var rect = this._rect;
    var style = this.style;
    var needsUpdateRect = !rect;

    if (needsUpdateRect) {
      var path = this.path;

      if (!path) {
        // Create path on demand.
        path = this.path = new PathProxy();
      }

      if (this.__dirtyPath) {
        path.beginPath();
        this.buildPath(path, this.shape, false);
      }

      rect = path.getBoundingRect();
    }

    this._rect = rect;

    if (style.hasStroke()) {
      // Needs update rect with stroke lineWidth when
      // 1. Element changes scale or lineWidth
      // 2. Shape is changed
      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());

      if (this.__dirty || needsUpdateRect) {
        rectWithStroke.copy(rect); // FIXME Must after updateTransform

        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical

        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill

        if (!style.hasFill()) {
          w = Math.max(w, this.strokeContainThreshold || 4);
        } // Consider line width
        // Line scale can't be 0;


        if (lineScale > 1e-10) {
          rectWithStroke.width += w / lineScale;
          rectWithStroke.height += w / lineScale;
          rectWithStroke.x -= w / lineScale / 2;
          rectWithStroke.y -= w / lineScale / 2;
        }
      } // Return rect with stroke


      return rectWithStroke;
    }

    return rect;
  },
  contain: function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    var style = this.style;
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      var pathData = this.path.data;

      if (style.hasStroke()) {
        var lineWidth = style.lineWidth;
        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;

        if (lineScale > 1e-10) {
          // Only add extra hover lineWidth when there are no fill
          if (!style.hasFill()) {
            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
          }

          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
            return true;
          }
        }
      }

      if (style.hasFill()) {
        return pathContain.contain(pathData, x, y);
      }
    }

    return false;
  },

  /**
   * @param  {boolean} dirtyPath
   */
  dirty: function (dirtyPath) {
    if (dirtyPath == null) {
      dirtyPath = true;
    } // Only mark dirty, not mark clean


    if (dirtyPath) {
      this.__dirtyPath = dirtyPath;
      this._rect = null;
    }

    this.__dirty = true;
    this.__zr && this.__zr.refresh(); // Used as a clipping path

    if (this.__clipTarget) {
      this.__clipTarget.dirty();
    }
  },

  /**
   * Alias for animate('shape')
   * @param {boolean} loop
   */
  animateShape: function (loop) {
    return this.animate('shape', loop);
  },
  // Overwrite attrKV
  attrKV: function (key, value) {
    // FIXME
    if (key === 'shape') {
      this.setShape(value);
      this.__dirtyPath = true;
      this._rect = null;
    } else {
      Displayable.prototype.attrKV.call(this, key, value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setShape: function (key, value) {
    var shape = this.shape; // Path from string may not have shape

    if (shape) {
      if (zrUtil.isObject(key)) {
        for (var name in key) {
          if (key.hasOwnProperty(name)) {
            shape[name] = key[name];
          }
        }
      } else {
        shape[key] = value;
      }

      this.dirty(true);
    }

    return this;
  },
  getLineScale: function () {
    var m = this.transform; // Get the line scale.
    // Determinant of `m` means how much the area is enlarged by the
    // transformation. So its square root can be used as a scale factor
    // for width.

    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
  }
};
/**
 * 扩展一个 Path element, 比如星形，圆等。
 * Extend a path element
 * @param {Object} props
 * @param {string} props.type Path type
 * @param {Function} props.init Initialize
 * @param {Function} props.buildPath Overwrite buildPath method
 * @param {Object} [props.style] Extended default style config
 * @param {Object} [props.shape] Extended default shape config
 */

Path.extend = function (defaults) {
  var Sub = function (opts) {
    Path.call(this, opts);

    if (defaults.style) {
      // Extend default style
      this.style.extendFrom(defaults.style, false);
    } // Extend default shape


    var defaultShape = defaults.shape;

    if (defaultShape) {
      this.shape = this.shape || {};
      var thisShape = this.shape;

      for (var name in defaultShape) {
        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
          thisShape[name] = defaultShape[name];
        }
      }
    }

    defaults.init && defaults.init.call(this, opts);
  };

  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象

  for (var name in defaults) {
    // Extending prototype values and methods
    if (name !== 'style' && name !== 'shape') {
      Sub.prototype[name] = defaults[name];
    }
  }

  return Sub;
};

zrUtil.inherits(Path, Displayable);
var _default = Path;
module.exports = _default;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/protocol_selected.6577d8ca.png";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__(443);

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__(870);

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__(869);

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__(868);

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__(866);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(867);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// (1) The code `if (__DEV__) ...` can be removed by build tool.
// (2) If intend to use `__DEV__`, this module should be imported. Use a global
// variable `__DEV__` may cause that miss the declaration (see #6535), or the
// declaration is behind of the using position (for example in `Model.extent`,
// And tools like rollup can not analysis the dependency if not import).
var dev; // In browser

if (typeof window !== 'undefined') {
  dev = window.__DEV__;
} // In node
else if (typeof global !== 'undefined') {
    dev = global.__DEV__;
  }

if (typeof dev === 'undefined') {
  dev = true;
}

var __DEV__ = dev;
exports.__DEV__ = __DEV__;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GuidePageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GuidePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GuidePageRef; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imgs_guidePage_openAccount_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imgs_guidePage_openAccount_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__imgs_guidePage_openAccount_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imgs_guidePage_trade_png__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__imgs_guidePage_trade_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__imgs_guidePage_trade_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_icon_guidePage_png__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_icon_guidePage_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__imgs_icon_guidePage_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var GuidePageType = {
    OpenAccount: 'OPENACCOUNT', //开户
    Trade: "TRADE" //交易
};

var GuidePageRef = { current: null };

var GuidePage = function (_React$Component) {
    _inherits(GuidePage, _React$Component);

    function GuidePage(props) {
        _classCallCheck(this, GuidePage);

        var _this = _possibleConstructorReturn(this, (GuidePage.__proto__ || Object.getPrototypeOf(GuidePage)).call(this, props));

        _this.show = function (type) {
            _this.guideType = type;
            _this.setState({ active: true });
        };

        _this.onCloseView = function () {
            _this.setState({ active: false });
        };

        _this.state = {
            active: false
        };
        _this.guideType = GuidePageType.Trade;
        return _this;
    }

    _createClass(GuidePage, [{
        key: 'render',
        value: function render() {
            if (!this.state.active) return null;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'guide_page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'guide_page_top' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'guide_page_close', onClick: this.onCloseView },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'guide_page_image_icon', src: __WEBPACK_IMPORTED_MODULE_4__imgs_icon_guidePage_png___default.a })
                ),
                this.guideType === GuidePageType.OpenAccount ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'guide_page_image', src: __WEBPACK_IMPORTED_MODULE_2__imgs_guidePage_openAccount_png___default.a }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'guide_page_image', src: __WEBPACK_IMPORTED_MODULE_3__imgs_guidePage_trade_png___default.a })
            );
        }
    }]);

    return GuidePage;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Guide = {
    show: function show(type) {
        GuidePageRef.current && GuidePageRef.current.show(type);
    },
    leave: function leave() {
        GuidePageRef.current && GuidePageRef.current.onCloseView();
    }
};
/* harmony default export */ __webpack_exports__["b"] = (Guide);


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1317);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(53);

var matrix = __webpack_require__(127);

/**
 * @module echarts/core/BoundingRect
 */
var v2ApplyTransform = vec2.applyTransform;
var mathMin = Math.min;
var mathMax = Math.max;
/**
 * @alias module:echarts/core/BoundingRect
 */

function BoundingRect(x, y, width, height) {
  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }
  /**
   * @type {number}
   */


  this.x = x;
  /**
   * @type {number}
   */

  this.y = y;
  /**
   * @type {number}
   */

  this.width = width;
  /**
   * @type {number}
   */

  this.height = height;
}

BoundingRect.prototype = {
  constructor: BoundingRect,

  /**
   * @param {module:echarts/core/BoundingRect} other
   */
  union: function (other) {
    var x = mathMin(other.x, this.x);
    var y = mathMin(other.y, this.y);
    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
    this.x = x;
    this.y = y;
  },

  /**
   * @param {Array.<number>} m
   * @methods
   */
  applyTransform: function () {
    var lt = [];
    var rb = [];
    var lb = [];
    var rt = [];
    return function (m) {
      // In case usage like this
      // el.getBoundingRect().applyTransform(el.transform)
      // And element has no transform
      if (!m) {
        return;
      }

      lt[0] = lb[0] = this.x;
      lt[1] = rt[1] = this.y;
      rb[0] = rt[0] = this.x + this.width;
      rb[1] = lb[1] = this.y + this.height;
      v2ApplyTransform(lt, lt, m);
      v2ApplyTransform(rb, rb, m);
      v2ApplyTransform(lb, lb, m);
      v2ApplyTransform(rt, rt, m);
      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
      this.width = maxX - this.x;
      this.height = maxY - this.y;
    };
  }(),

  /**
   * Calculate matrix of transforming from self to target rect
   * @param  {module:zrender/core/BoundingRect} b
   * @return {Array.<number>}
   */
  calculateTransform: function (b) {
    var a = this;
    var sx = b.width / a.width;
    var sy = b.height / a.height;
    var m = matrix.create(); // 矩阵右乘

    matrix.translate(m, m, [-a.x, -a.y]);
    matrix.scale(m, m, [sx, sy]);
    matrix.translate(m, m, [b.x, b.y]);
    return m;
  },

  /**
   * @param {(module:echarts/core/BoundingRect|Object)} b
   * @return {boolean}
   */
  intersect: function (b) {
    if (!b) {
      return false;
    }

    if (!(b instanceof BoundingRect)) {
      // Normalize negative width/height.
      b = BoundingRect.create(b);
    }

    var a = this;
    var ax0 = a.x;
    var ax1 = a.x + a.width;
    var ay0 = a.y;
    var ay1 = a.y + a.height;
    var bx0 = b.x;
    var bx1 = b.x + b.width;
    var by0 = b.y;
    var by1 = b.y + b.height;
    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
  },
  contain: function (x, y) {
    var rect = this;
    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
  },

  /**
   * @return {module:echarts/core/BoundingRect}
   */
  clone: function () {
    return new BoundingRect(this.x, this.y, this.width, this.height);
  },

  /**
   * Copy from another rect
   */
  copy: function (other) {
    this.x = other.x;
    this.y = other.y;
    this.width = other.width;
    this.height = other.height;
  },
  plain: function () {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height
    };
  }
};
/**
 * @param {Object|module:zrender/core/BoundingRect} rect
 * @param {number} rect.x
 * @param {number} rect.y
 * @param {number} rect.width
 * @param {number} rect.height
 * @return {module:zrender/core/BoundingRect}
 */

BoundingRect.create = function (rect) {
  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
};

var _default = BoundingRect;
module.exports = _default;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * echarts设备环境识别
 *
 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
 * @author firede[firede@firede.us]
 * @desc thanks zepto.
 */
var env = {};

if (typeof navigator === 'undefined') {
  // In node
  env = {
    browser: {},
    os: {},
    node: true,
    // Assume canvas is supported
    canvasSupported: true,
    svgSupported: true
  };
} else {
  env = detect(navigator.userAgent);
}

var _default = env; // Zepto.js
// (c) 2010-2013 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.

function detect(ua) {
  var os = {};
  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
  // var touchpad = webos && ua.match(/TouchPad/);
  // var kindle = ua.match(/Kindle\/([\d.]+)/);
  // var silk = ua.match(/Silk\/([\d._]+)/);
  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
  // var playbook = ua.match(/PlayBook/);
  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);

  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;

  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+

  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
  // - discern (more) between multiple browsers on android
  // - decide if kindle fire in silk mode is android or not
  // - Firefox on Android doesn't specify the Android version
  // - possibly devide in os, device and browser hashes
  // if (browser.webkit = !!webkit) browser.version = webkit[1];
  // if (android) os.android = true, os.version = android[2];
  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
  // if (webos) os.webos = true, os.version = webos[2];
  // if (touchpad) os.touchpad = true;
  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
  // if (bb10) os.bb10 = true, os.version = bb10[2];
  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
  // if (playbook) browser.playbook = true;
  // if (kindle) os.kindle = true, os.version = kindle[1];
  // if (silk) browser.silk = true, browser.version = silk[1];
  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
  // if (chrome) browser.chrome = true, browser.version = chrome[1];

  if (firefox) {
    browser.firefox = true;
    browser.version = firefox[1];
  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
  // if (webview) browser.webview = true;


  if (ie) {
    browser.ie = true;
    browser.version = ie[1];
  }

  if (edge) {
    browser.edge = true;
    browser.version = edge[1];
  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
  // not be set on win phone. So we do not consider Win Phone.


  if (weChat) {
    browser.weChat = true;
  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));


  return {
    browser: browser,
    os: os,
    node: false,
    // 原生canvas支持，改极端点了
    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
    canvasSupported: !!document.createElement('canvas').getContext,
    svgSupported: typeof SVGRect !== 'undefined',
    // @see <http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript>
    // works on most browsers
    // IE10/11 does not support touch event, and MS Edge supports them but not by
    // default, so we dont check navigator.maxTouchPoints for them here.
    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
    // <http://caniuse.com/#search=pointer%20event>.
    pointerEventsSupported: 'onpointerdown' in window // Firefox supports pointer but not by default, only MS browsers are reliable on pointer
    // events currently. So we dont use that on other browsers unless tested sufficiently.
    // Although IE 10 supports pointer event, it use old style and is different from the
    // standard. So we exclude that. (IE 10 is hardly used on touch device)
    && (browser.edge || browser.ie && browser.version >= 11)
  };
}

module.exports = _default;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(1957);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalTip_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ModalSelect = function (_Component) {
  _inherits(ModalSelect, _Component);

  function ModalSelect(props) {
    _classCallCheck(this, ModalSelect);

    var _this = _possibleConstructorReturn(this, (ModalSelect.__proto__ || Object.getPrototypeOf(ModalSelect)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ModalSelect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","")
    }
  }, {
    key: 'render',
    value: function render() {
      var riskModalData = this.props.riskModalData;

      console.log(riskModalData);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.payLoading && riskModalData ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'containerModal_old' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modalView_old' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'titleText_old', style: { marginTop: this.props.titleBC ? 6 : 20 } },
              riskModalData.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentText_old' },
              riskModalData.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentTwoText_old' },
              riskModalData.contentBC
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'footView_old' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    return riskModalData.onCancel();
                  } },
                riskModalData.leftButtonTitle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    return riskModalData.onOK();
                  } },
                riskModalData.rightButtonTitle
              )
            )
          )
        ) : null
      );
    }
  }]);

  return ModalSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    riskModalData: state.riskModalData,
    payLoading: state.payLoading
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ModalSelect));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(720)["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AddCardHqtAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SuperModalTwo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalTip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ModalList = function (_Component) {
  _inherits(ModalList, _Component);

  function ModalList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalList.__proto__ || Object.getPrototypeOf(ModalList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      agreeIndex: 0
    }, _this.componentWillMount = function () {}, _this.goBacks = function () {
      if (_this.state.agreeIndex == "1") {
        _this.setState({
          agreeIndex: 0
        });
        _this.props.onFun(false);
      } else {
        _this.setState({
          agreeIndex: 1
        });
        _this.props.onFun(true);
      }
    }, _this.YueDu = function () {
      var name = '用户同步信息授权书';
      var code = __WEBPACK_IMPORTED_MODULE_4__BankCode__["a" /* protocolCode */][name];
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }, _this.render = function () {
      var _this$props = _this.props,
          flag = _this$props.flag,
          content = _this$props.content,
          title = _this$props.title,
          btnRight = _this$props.btnRight,
          btnLeft = _this$props.btnLeft,
          btnLeftFun = _this$props.btnLeftFun,
          btnRightFun = _this$props.btnRightFun,
          onFun = _this$props.onFun,
          btnLift = _this$props.btnLift,
          btnLiftFun = _this$props.btnLiftFun;

      var img_arr = [__webpack_require__(389), __webpack_require__(390)];
      var stylesFir = { display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", height: window.winHeight, width: window.winWidth };
      var stylesSec = { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", width: window.winWidth };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: _this.props.heightAll ? stylesSec : stylesFir },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { backgroundColor: "#fff", width: 271, borderRadius: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, color: "#3a3e47", textAlign: "center", paddingTop: 30 } },
              title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: "#3a3e47", textAlign: "center", paddingTop: 20, paddingBottom: 25, borderBottom: "1px solid #ebeef0" } },
              content
            ),
            onFun ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: "#3a3e47", textAlign: "center", paddingTop: 10, display: "flex", alignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: "0.4rem", height: "0.4rem" }, onClick: _this.goBacks, src: img_arr[_this.state.agreeIndex] }),
              '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u300A',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { onClick: _this.YueDu, style: { color: "red" } },
                '\u7528\u6237\u540C\u6B65\u4FE1\u606F\u6388\u6743\u4E66'
              ),
              '\u300B'
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitJustifyContent: "space-evenly", height: 40, WebkitAlignItems: "center" } },
              btnLeftFun ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: btnLeftFun, style: { fontSize: 15, color: "#fa063a", display: "-webkit-flex", height: "100%", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                btnLeft
              ) : null,
              btnLeftFun && btnRightFun ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 1, backgroundColor: "#fa063a", height: 20 } }) : null,
              btnLiftFun ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: btnLiftFun, style: { fontSize: 15, color: "#fa063a", display: "-webkit-flex", height: "100%", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                btnLift
              ) : null,
              btnRightFun ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: btnRightFun, style: { fontSize: 15, color: "#fa063a", display: "-webkit-flex", height: "100%", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                btnRight
              ) : null
            )
          )
        ) : null
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ModalList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ModalList);

var AddCardHqtAlert = function (_Component2) {
  _inherits(AddCardHqtAlert, _Component2);

  function AddCardHqtAlert(props) {
    _classCallCheck(this, AddCardHqtAlert);

    var _this2 = _possibleConstructorReturn(this, (AddCardHqtAlert.__proto__ || Object.getPrototypeOf(AddCardHqtAlert)).call(this, props));

    _this2.state = {};
    return _this2;
  }

  _createClass(AddCardHqtAlert, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'closeIcon', onClick: function onClick() {
              _this3.props.CloseAler();
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "20px", paddingRight: "20px", paddingTop: '20px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: "center", marginBottom: "20px", fontSize: 17 } },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 15, lineHeight: "20px" } },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "30px" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div', style: { marginBottom: "10px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.props.handleBtn1();
                  }, style: { border: "1px solid #FE492E", width: "100%", backgroundColor: "#FFF", height: "40px", color: "#FE492E", textAlign: "center", lineHeight: "40px" } },
                this.props.btnfirText
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.props.handleBtn2();
                  }, style: { border: "1px solid #FE492E", width: "100%", backgroundColor: "#FFF", height: "40px", color: "#FE492E", textAlign: "center", lineHeight: "40px" } },
                this.props.btnsecText
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "40px" } })
          )
        )
      );
    }
  }]);

  return AddCardHqtAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SuperModalTwo = function (_Component3) {
  _inherits(SuperModalTwo, _Component3);

  function SuperModalTwo(props) {
    _classCallCheck(this, SuperModalTwo);

    var _this4 = _possibleConstructorReturn(this, (SuperModalTwo.__proto__ || Object.getPrototypeOf(SuperModalTwo)).call(this, props));

    _this4.handleCancel = function () {
      _this4.props.handleCancel();
    };

    _this4.handleBtnOne = function () {
      _this4.props.handleBtnOne();
    };

    _this4.handleBtnTwo = function () {
      _this4.props.handleBtnTwo();
    };

    _this4.state = {};
    return _this4;
  }

  _createClass(SuperModalTwo, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          buttonText1 = _props.buttonText1,
          buttonText2 = _props.buttonText2;
      // let data = this.props.location.state.data ? this.props.location.state.data : [];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'closeIcon', onClick: function onClick() {
              _this5.handleCancel();
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "20px", paddingRight: "20px", paddingTop: '20px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: "center", marginBottom: "20px", fontSize: 17 } },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 15, lineHeight: "20px" } },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "30px" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div', style: { marginBottom: "10px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this5.handleBtnOne();
                  }, style: { border: "1px solid #FE492E", width: "100%", backgroundColor: "#FA063A", height: "40px", color: "#FFF", textAlign: "center", lineHeight: "40px" } },
                buttonText1
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this5.handleBtnTwo();
                  }, style: { border: "1px solid #FE492E", width: "100%", backgroundColor: "#FFF", height: "40px", color: "#FE492E", textAlign: "center", lineHeight: "40px" } },
                buttonText2
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "40px" } })
          )
        )
      );
    }
  }]);

  return SuperModalTwo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var env = __webpack_require__(64);

var clazzUtil = __webpack_require__(92);

var lineStyleMixin = __webpack_require__(1085);

var areaStyleMixin = __webpack_require__(1082);

var textStyleMixin = __webpack_require__(1086);

var itemStyleMixin = __webpack_require__(1084);

/**
 * @module echarts/model/Model
 */
var mixin = zrUtil.mixin;
/**
 * @alias module:echarts/model/Model
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} [parentModel]
 * @param {module:echarts/model/Global} [ecModel]
 */

function Model(option, parentModel, ecModel) {
  /**
   * @type {module:echarts/model/Model}
   * @readOnly
   */
  this.parentModel = parentModel;
  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */

  this.ecModel = ecModel;
  /**
   * @type {Object}
   * @protected
   */

  this.option = option; // Simple optimization
  // if (this.init) {
  //     if (arguments.length <= 4) {
  //         this.init(option, parentModel, ecModel, extraOpt);
  //     }
  //     else {
  //         this.init.apply(this, arguments);
  //     }
  // }
}

Model.prototype = {
  constructor: Model,

  /**
   * Model 的初始化函数
   * @param {Object} option
   */
  init: null,

  /**
   * 从新的 Option merge
   */
  mergeOption: function (option) {
    zrUtil.merge(this.option, option, true);
  },

  /**
   * @param {string|Array.<string>} path
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  get: function (path, ignoreParent) {
    if (path == null) {
      return this.option;
    }

    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
  },

  /**
   * @param {string} key
   * @param {boolean} [ignoreParent=false]
   * @return {*}
   */
  getShallow: function (key, ignoreParent) {
    var option = this.option;
    var val = option == null ? option : option[key];
    var parentModel = !ignoreParent && getParent(this, key);

    if (val == null && parentModel) {
      val = parentModel.getShallow(key);
    }

    return val;
  },

  /**
   * @param {string|Array.<string>} [path]
   * @param {module:echarts/model/Model} [parentModel]
   * @return {module:echarts/model/Model}
   */
  getModel: function (path, parentModel) {
    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
    var thisParentModel;
    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
    return new Model(obj, parentModel, this.ecModel);
  },

  /**
   * If model has option
   */
  isEmpty: function () {
    return this.option == null;
  },
  restoreData: function () {},
  // Pending
  clone: function () {
    var Ctor = this.constructor;
    return new Ctor(zrUtil.clone(this.option));
  },
  setReadOnly: function (properties) {
    clazzUtil.setReadOnly(this, properties);
  },
  // If path is null/undefined, return null/undefined.
  parsePath: function (path) {
    if (typeof path === 'string') {
      path = path.split('.');
    }

    return path;
  },

  /**
   * @param {Function} getParentMethod
   *        param {Array.<string>|string} path
   *        return {module:echarts/model/Model}
   */
  customizeGetParent: function (getParentMethod) {
    clazzUtil.set(this, 'getParent', getParentMethod);
  },
  isAnimationEnabled: function () {
    if (!env.node) {
      if (this.option.animation != null) {
        return !!this.option.animation;
      } else if (this.parentModel) {
        return this.parentModel.isAnimationEnabled();
      }
    }
  }
};

function doGet(obj, pathArr, parentModel) {
  for (var i = 0; i < pathArr.length; i++) {
    // Ignore empty
    if (!pathArr[i]) {
      continue;
    } // obj could be number/string/... (like 0)


    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;

    if (obj == null) {
      break;
    }
  }

  if (obj == null && parentModel) {
    obj = parentModel.get(pathArr);
  }

  return obj;
} // `path` can be null/undefined


function getParent(model, path) {
  var getParentMethod = clazzUtil.get(model, 'getParent');
  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
} // Enable Model.extend.


clazzUtil.enableClassExtend(Model);
mixin(Model, lineStyleMixin);
mixin(Model, areaStyleMixin);
mixin(Model, textStyleMixin);
mixin(Model, itemStyleMixin);
var _default = Model;
module.exports = _default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var textContain = __webpack_require__(112);

var numberUtil = __webpack_require__(48);

/**
 * 每三位默认加,格式化
 * @param {string|number} x
 * @return {string}
 */
function addCommas(x) {
  if (isNaN(x)) {
    return '-';
  }

  x = (x + '').split('.');
  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
}
/**
 * @param {string} str
 * @param {boolean} [upperCaseFirst=false]
 * @return {string} str
 */


function toCamelCase(str, upperCaseFirst) {
  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });

  if (upperCaseFirst && str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
}

var normalizeCssArray = zrUtil.normalizeCssArray;

function encodeHTML(source) {
  return String(source).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

var wrapVar = function (varName, seriesIdx) {
  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
/**
 * Template formatter
 * @param {string} tpl
 * @param {Array.<Object>|Object} paramsList
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTpl(tpl, paramsList, encode) {
  if (!zrUtil.isArray(paramsList)) {
    paramsList = [paramsList];
  }

  var seriesLen = paramsList.length;

  if (!seriesLen) {
    return '';
  }

  var $vars = paramsList[0].$vars || [];

  for (var i = 0; i < $vars.length; i++) {
    var alias = TPL_VAR_ALIAS[i];
    var val = wrapVar(alias, 0);
    tpl = tpl.replace(wrapVar(alias), encode ? encodeHTML(val) : val);
  }

  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
    for (var k = 0; k < $vars.length; k++) {
      var val = paramsList[seriesIdx][$vars[k]];
      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
    }
  }

  return tpl;
}
/**
 * simple Template formatter
 *
 * @param {string} tpl
 * @param {Object} param
 * @param {boolean} [encode=false]
 * @return {string}
 */


function formatTplSimple(tpl, param, encode) {
  zrUtil.each(param, function (value, key) {
    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
  });
  return tpl;
}
/**
 * @param {string} color
 * @param {string} [extraCssText]
 * @return {string}
 */


function getTooltipMarker(color, extraCssText) {
  return color ? '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:9px;height:9px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '';
}
/**
 * @param {string} str
 * @return {string}
 * @inner
 */


var s2d = function (str) {
  return str < 10 ? '0' + str : str;
};
/**
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */


function formatTime(tpl, value, isUTC) {
  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
    tpl = 'MM-dd\nyyyy';
  }

  var date = numberUtil.parseDate(value);
  var utc = isUTC ? 'UTC' : '';
  var y = date['get' + utc + 'FullYear']();
  var M = date['get' + utc + 'Month']() + 1;
  var d = date['get' + utc + 'Date']();
  var h = date['get' + utc + 'Hours']();
  var m = date['get' + utc + 'Minutes']();
  var s = date['get' + utc + 'Seconds']();
  tpl = tpl.replace('MM', s2d(M)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', s2d(d)).replace('d', d).replace('hh', s2d(h)).replace('h', h).replace('mm', s2d(m)).replace('m', m).replace('ss', s2d(s)).replace('s', s);
  return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */


function capitalFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}

var truncateText = textContain.truncateText;
var getTextRect = textContain.getBoundingRect;
exports.addCommas = addCommas;
exports.toCamelCase = toCamelCase;
exports.normalizeCssArray = normalizeCssArray;
exports.encodeHTML = encodeHTML;
exports.formatTpl = formatTpl;
exports.formatTplSimple = formatTplSimple;
exports.getTooltipMarker = getTooltipMarker;
exports.formatTime = formatTime;
exports.capitalFirst = capitalFirst;
exports.truncateText = truncateText;
exports.getTextRect = getTextRect;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1321);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1318);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(326);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(326);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/selectRound.8f53ea86.png";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

function _getPrototypeOf(t) {
  return (module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(2012);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(720)["default"];
var assertThisInitialized = __webpack_require__(77);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pageFlag */
/* unused harmony export choseKeyPasswordVal */
/* unused harmony export chosePageFlag */
/* unused harmony export chosePassWordKeyBoard */
/* unused harmony export choseLoginShowHide */
/* unused harmony export myOpenFlag */
/* harmony export (immutable) */ __webpack_exports__["f"] = myActive;
/* harmony export (immutable) */ __webpack_exports__["h"] = myAddCardText;
/* harmony export (immutable) */ __webpack_exports__["g"] = myAddPhoneText;
/* harmony export (immutable) */ __webpack_exports__["d"] = myPaymentText;
/* harmony export (immutable) */ __webpack_exports__["i"] = myPaymentTextDT;
/* unused harmony export myPaymentAgree */
/* harmony export (immutable) */ __webpack_exports__["e"] = myFee;
/* harmony export (immutable) */ __webpack_exports__["b"] = myPhoneNum;
/* harmony export (immutable) */ __webpack_exports__["c"] = myVerifyCode;
/* unused harmony export mySyncLoginPWD1 */
/* unused harmony export mySyncLoginPWD2 */
/* unused harmony export mySyncDealPWD1 */
/* unused harmony export mySyncDealPWD2 */
/* harmony export (immutable) */ __webpack_exports__["a"] = mySyncBtn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_loginAction__ = __webpack_require__(32);




function pageFlag(text) {
  return {
    type: "PAGE_FLAG",
    text: text
  };
}
function choseKeyPasswordVal(text) {
  return {
    type: "KEY_PASSWORD_VAL",
    text: text
  };
}

function chosePageFlag(data) {
  return function (dispatch, getState) {
    dispatch(pageFlag(false));
  };
}
function chosePassWordKeyBoard(text) {
  return {
    type: "PASSWORD_KEYBOARD",
    text: text
  };
}
function choseLoginShowHide(text) {
  return {
    type: "LOGIN_SHOW_HIDE",
    text: text
  };
}

//state
function myOpenFlag(text) {
  return {
    type: "OPEN_FLAG",
    text: text
  };
}
function myActive(text) {
  return {
    type: "ACTIVE",
    text: text
  };
}
function myAddCardText(text) {
  return {
    type: "ADD_CARD_TEXT",
    text: text
  };
}
function myAddPhoneText(text) {
  return {
    type: "ADD_PHONE_TEXT",
    text: text
  };
}
function myPaymentText(text) {
  return {
    type: "PAYMENT_TEXT",
    text: text
  };
}
function myPaymentTextDT(text) {
  return {
    type: "PAYMENT_TEXT_DT",
    text: text
  };
}
function myPaymentAgree(text) {
  return {
    type: "PAYMENT_AGREE",
    text: text
  };
}
function myFee(text) {
  return {
    type: "FEE",
    text: text
  };
}
function myPhoneNum(text) {
  return {
    type: "PHONE_NUM",
    text: text
  };
}
function myVerifyCode(text) {
  return {
    type: "VERIFY_CODE",
    text: text
  };
}
function mySyncLoginPWD1(text) {
  return {
    type: "SYNC_LOGIN_PWD1",
    text: text
  };
}
function mySyncLoginPWD2(text) {
  return {
    type: "SYNC_LOGIN_PWD2",
    text: text
  };
}
function mySyncDealPWD1(text) {
  return {
    type: "SYNC_DEAL_PWD1",
    text: text
  };
}
function mySyncDealPWD2(text) {
  return {
    type: "SYNC_DEAL_PWD2",
    text: text
  };
}
function mySyncBtn(text) {
  return {
    type: "SYNC_BTN",
    text: text
  };
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createForm__ = __webpack_require__(1221);
/* unused harmony reexport createForm */
// export this package's api



/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jqrIcon.a0709036.png";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var warnMsg = 'Icon props.type is invalid, have you set svg-sprite-loader correctly? see https://goo.gl/kN8oiw';

var Icon = function (_React$Component) {
    (0, _inherits3['default'])(Icon, _React$Component);

    function Icon() {
        (0, _classCallCheck3['default'])(this, Icon);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));

        _this.renderSvg = function () {
            var type = _this.props.type;

            var svg = void 0;
            try {
                svg = __webpack_require__(803)("./" + type + '.svg');
            } catch (e) {} finally {
                return svg;
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Icon, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                type = _a.type,
                className = _a.className,
                style = _a.style,
                size = _a.size,
                restProps = __rest(_a, ["type", "className", "style", "size"]);
            if (!type || typeof type !== 'string') {
                console.error(warnMsg);
                return null;
            }
            var xlinkHref = this.renderSvg();
            var outerIcon = void 0;
            if (!xlinkHref) {
                outerIcon = true;
                xlinkHref = type;
                if (!/^#/.test(type)) {
                    console.error(warnMsg);
                }
            } else {
                if (!/^#/.test(xlinkHref)) {
                    console.error(warnMsg);
                }
                xlinkHref = '#' + type;
            }
            var iconClassName = (0, _classnames2['default'])((_classNames = {
                'am-icon': true
            }, (0, _defineProperty3['default'])(_classNames, 'am-icon-' + (outerIcon ? type.substr(1) : type), true), (0, _defineProperty3['default'])(_classNames, 'am-icon-' + size, true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames));
            return _react2['default'].createElement(
                'svg',
                (0, _extends3['default'])({ className: iconClassName, style: style }, restProps),
                _react2['default'].createElement('use', { xlinkHref: xlinkHref })
            );
        }
    }]);
    return Icon;
}(_react2['default'].Component);

exports['default'] = Icon;

Icon.defaultProps = {
    size: 'md'
};
module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(291)('wks')
  , uid        = __webpack_require__(205)
  , Symbol     = __webpack_require__(99).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(535);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var CallbackQueue = __webpack_require__(545);
var PooledClass = __webpack_require__(119);
var ReactFeatureFlags = __webpack_require__(550);
var ReactReconciler = __webpack_require__(142);
var Transaction = __webpack_require__(220);

var invariant = __webpack_require__(15);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export webViewHtmlString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWebViewHtml; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_js__);


var webViewHtmlString = function webViewHtmlString(text) {
	return {
		type: 'WEB_VIEW_HTML',
		text: text
	};
};

// export const webViewUrl = (text)=>{
// 	return {
// 		type: 'WEB_VIEW_URL',
// 		text
// 	}
// }

var getWebViewHtml = function getWebViewHtml(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function successCallback(suc) {
			console.log(suc);
			if (suc.code == params.code) {
				dispatch(webViewHtmlString(suc.content));
				// succallback();
			} else {
				console.log('后台返回html数据有误！');
				// errcallback(suc.message);
				dispatch(webViewHtmlString(''));
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log('请求html字符串失败！');
			// errcallback(Util.errorTxt);
			// dispatch(webViewHtmlString(''));
		};
		__WEBPACK_IMPORTED_MODULE_0__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_0__util_js___default.a.url + '/api/cms/getProtocolByCode', params, successCallback, errorCallback);
	};
};

// export const getWebViewUrl = (params, succallback, errcallback)=>{
// 	return (dispatch, getState)=>{
// 		const successCallback = (suc)=>{
// 			if(suc.code == '0000'){
// 				dispatch(webViewUrl(suc.content));
// 				succallback();
// 			}else{
// 				console.log('后台返回URL数据有误！');
// 				errcallback(suc.message);
// 				dispatch(webViewUrl(''));
// 			}
// 		};
// 		const errorCallback = (err)=>{
// 			console.log('请求URL字符串失败！');
// 			errcallback(Util.errorTxt);
// 			dispatch(webViewUrl(''));
// 		};
// 		Util.get(Util.url + '', params, successCallback, errorCallback);
// 	}
// }

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AlerModleLcs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AlerModleQy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlerModleCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AlerModleCommonn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AlerModleUpgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ModalTips; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BankCode__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/*弹出框*/

var AlerModle = function (_Component) {
  _inherits(AlerModle, _Component);

  function AlerModle(props) {
    _classCallCheck(this, AlerModle);

    var _this = _possibleConstructorReturn(this, (AlerModle.__proto__ || Object.getPrototypeOf(AlerModle)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(AlerModle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchMove: this.touchmove.bind(this), onTouchStart: function onTouchStart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AlertIcon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'closeIcon', onClick: function onClick() {
              _this2.props.CloseAler();
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "20px", paddingRight: "20px", marginTop: "-12px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: "center", marginBottom: "20px", fontSize: 17 } },
              '\u67E5\u7406\u89E3\u5BC6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 15, lineHeight: "20px" } },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "30px" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this2.props.CloseAler();
                  }, style: { borderRadius: "20px", width: "210px", backgroundColor: "#fa063a", height: "40px", color: "#FFF", textAlign: "center", lineHeight: "40px" } },
                '\u77E5\u9053\u4E86'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "40px" } })
          )
        )
      );
    }
  }]);

  return AlerModle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlerModleLcs = function (_Component2) {
  _inherits(AlerModleLcs, _Component2);

  function AlerModleLcs(props) {
    _classCallCheck(this, AlerModleLcs);

    var _this3 = _possibleConstructorReturn(this, (AlerModleLcs.__proto__ || Object.getPrototypeOf(AlerModleLcs)).call(this, props));

    _this3.state = {};
    return _this3;
  }

  _createClass(AlerModleLcs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "10px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertContent' },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertSureBtn', onClick: function onClick() {
                  _this4.props.CloseAler();
                } },
              '\u786E\u8BA4'
            )
          )
        )
      );
    }
  }]);

  return AlerModleLcs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlerModleQy = function (_Component3) {
  _inherits(AlerModleQy, _Component3);

  function AlerModleQy(props) {
    _classCallCheck(this, AlerModleQy);

    var _this5 = _possibleConstructorReturn(this, (AlerModleQy.__proto__ || Object.getPrototypeOf(AlerModleQy)).call(this, props));

    _this5.state = {
      isSelected: false
    };
    return _this5;
  }

  _createClass(AlerModleQy, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'handleClick1',
    value: function handleClick1() {
      if (this.props.handleClick1 && this.state.isSelected) {
        this.props.handleClick1();
      }
    }
  }, {
    key: 'handleClick2',
    value: function handleClick2() {
      if (this.props.handleClick2) {
        this.props.handleClick2();
      }
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name) {
      var code = __WEBPACK_IMPORTED_MODULE_2__BankCode__["a" /* protocolCode */][name];
      console.log(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */]);
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AlertIcon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "10px", paddingRight: "10px", marginTop: "-12px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: "center", marginBottom: "20px", fontSize: 15 } },
              '\u7B7E\u7EA6\u63D0\u9192'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, lineHeight: "20px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u4F60\u597D\uFF01\u534E\u590F\u8D22\u5BCC\u83B7\u6279\u6210\u4E3A\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u9996\u6279\u8BD5\u70B9\u673A\u6784\uFF0C\u67E5\u7406\u667A\u6295\u670D\u52A1\u5347\u7EA7\u4E3A\u57FA\u91D1\u6295\u987E\u670D\u52A1\u3002\u540C\u610F\u7B7E\u7EA6\u540E\uFF0C\u60A8\u5C06\u4EAB\u53D7\u4EE5\u4E0B\u670D\u52A1\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '1\u3001\u5B9E\u65F6\u81EA\u52A8\u8C03\u4ED3\uFF0C\u907F\u514D\u4ED3\u4F4D\u504F\u79FB;'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '2\u3001\u7EC4\u5408\u5185\u6210\u5206\u57FA\u91D1\u7533\u8D2D\u8D39\u4F4E\u81F30\u6298\uFF0C\u964D\u4F4E\u4EA4\u6613\u6210\u672C;'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '3\u3001\u5168\u5E02\u573A\u57FA\u91D1\u914D\u7F6E\uFF0C\u914D\u7F6E\u7B56\u7565\u66F4\u7075\u6D3B\uFF1B'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u5C06\u6536\u53D6\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF0C\u8BF7\u60A8\u8BA4\u771F\u9605\u8BFB\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u3002\u5982\u540C\u610F\uFF0C\u8BF7\u53CA\u65F6\u7B7E\u7EA6\u5E76\u5C06\u6301\u6709\u7684\u7EC4\u5408\u8F6C\u6362\u4E3A\u6700\u65B0\u7EC4\u5408\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitJustifyContent: 'center',
                  marginTop: 15,
                  marginLeft: 0,
                  marginRight: 13,
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.setState({ isSelected: !_this6.state.isSelected });
                  } },
                this.state.isSelected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                    height: 44,
                    width: 44,
                    marginTop: -9,
                    marginLeft: -13
                  }, src: __webpack_require__(55) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                    height: 44,
                    width: 44,
                    marginTop: -9,
                    marginLeft: -13
                  }, src: __webpack_require__(51) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    marginTop: 3,
                    marginLeft: -7,
                    WebkitFlex: 1,
                    color: '#a1a7b2',
                    fontSize: 12,
                    lineHeight: "20px"
                  } },
                '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#fa063a' }, onClick: function onClick() {
                      return _this6.ProtocolPaper('上海华夏财富投资管理有限公司基金投资顾问服务协议');
                    } },
                  '\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B'
                ),
                ' '
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "20px" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.handleClick1();
                  }, style: { borderRadius: "20px", width: "210px", backgroundColor: this.state.isSelected ? "#fa063a" : "#CCC", height: "40px", color: "#FFF", textAlign: "center", lineHeight: "40px" } },
                '\u540C\u610F\u7B7E\u7EA6'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div', style: { marginTop: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.handleClick2();
                  }, style: { borderRadius: "20px", width: "210px", border: "1px solid #CCC", backgroundColor: "#FFF", height: "40px", color: "#000", textAlign: "center", lineHeight: "40px" } },
                '\u6682\u4E0D\u7B7E\u7EA6'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "20px" } })
          )
        )
      );
    }
  }]);

  return AlerModleQy;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlerModleCommon = function (_Component4) {
  _inherits(AlerModleCommon, _Component4);

  function AlerModleCommon(props) {
    _classCallCheck(this, AlerModleCommon);

    var _this7 = _possibleConstructorReturn(this, (AlerModleCommon.__proto__ || Object.getPrototypeOf(AlerModleCommon)).call(this, props));

    _this7.state = {
      isSelected: false
    };
    return _this7;
  }

  _createClass(AlerModleCommon, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      var _props = this.props,
          handleClick1 = _props.handleClick1,
          handleClick2 = _props.handleClick2,
          btnTxt1 = _props.btnTxt1,
          btnTxt2 = _props.btnTxt2,
          title = _props.title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AlertIcon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "10px", paddingRight: "10px", marginTop: "-12px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: "center", marginBottom: "20px", fontSize: 15 } },
              title
            ),
            this.props.contentArr ? this.props.contentArr.map(function (data, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index, style: { fontSize: 13, lineHeight: "20px" } },
                data
              );
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, lineHeight: "20px" } },
              this.props.content
            ),
            this.props.contentSec ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, lineHeight: "20px" } },
              this.props.contentSec
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "20px" } }),
            this.props.btnTxt1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    handleClick1();
                  }, style: { fontSize: "0.3rem", borderRadius: "20px", width: "210px", backgroundColor: "#fa063a", height: "40px", color: "#FFF", textAlign: "center", lineHeight: "40px" } },
                this.props.btnTxt1
              )
            ) : null,
            this.props.btnTxt2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div', style: { marginTop: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    handleClick2();
                  }, style: { fontSize: "0.3rem", borderRadius: "20px", border: "1px solid #CCC", width: "210px", backgroundColor: "#FFF", height: "40px", color: "#000", textAlign: "center", lineHeight: "40px" } },
                this.props.btnTxt2
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "30px" } })
          )
        )
      );
    }
  }]);

  return AlerModleCommon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlerModleCommonn = function (_Component5) {
  _inherits(AlerModleCommonn, _Component5);

  function AlerModleCommonn(props) {
    _classCallCheck(this, AlerModleCommonn);

    var _this8 = _possibleConstructorReturn(this, (AlerModleCommonn.__proto__ || Object.getPrototypeOf(AlerModleCommonn)).call(this, props));

    _this8.state = {
      isSelected: false
    };
    return _this8;
  }

  _createClass(AlerModleCommonn, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      var _props2 = this.props,
          handleClick1 = _props2.handleClick1,
          handleClick2 = _props2.handleClick2,
          btnTxt1 = _props2.btnTxt1,
          btnTxt2 = _props2.btnTxt2,
          title = _props2.title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: "15px" } },
            this.props.contentArr ? this.props.contentArr.map(function (data, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index, style: { fontSize: 13, lineHeight: "20px", paddingLeft: "20px", paddingRight: "20px" } },
                data
              );
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, lineHeight: "20px", paddingLeft: "20px", paddingRight: "20px" } },
              this.props.content
            ),
            this.props.contentSec ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, lineHeight: "20px", paddingLeft: "20px", paddingRight: "20px" } },
              this.props.contentSec
            ) : null,
            this.props.btnTxt1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    handleClick1();
                  }, style: { fontSize: "0.32rem", width: "100%", height: "40px", color: '#666666', textAlign: "center", lineHeight: "40px", borderTopColor: "#ebeef0", borderTopWidth: "1px", borderTopStyle: "solid", marginTop: "15px" } },
                this.props.btnTxt1
              )
            ) : null,
            this.props.btnTxt2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div', style: { marginTop: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    handleClick2();
                  }, style: { fontSize: "0.32rem", borderRadius: "20px", border: "1px solid #CCC", width: "210px", backgroundColor: "#FFF", height: "40px", color: "#000", textAlign: "center", lineHeight: "40px" } },
                this.props.btnTxt2
              )
            ) : null
          )
        )
      );
    }
  }]);

  return AlerModleCommonn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlerModleUpgrade = function (_Component6) {
  _inherits(AlerModleUpgrade, _Component6);

  function AlerModleUpgrade(props) {
    _classCallCheck(this, AlerModleUpgrade);

    var _this9 = _possibleConstructorReturn(this, (AlerModleUpgrade.__proto__ || Object.getPrototypeOf(AlerModleUpgrade)).call(this, props));

    _this9.state = {
      isSelected: false
    };
    return _this9;
  }

  _createClass(AlerModleUpgrade, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      var _props3 = this.props,
          handleClick1 = _props3.handleClick1,
          handleClick2 = _props3.handleClick2,
          btnTxt1 = _props3.btnTxt1,
          btnTxt2 = _props3.btnTxt2,
          title = _props3.title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "20px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'AlertIcon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "10px", paddingRight: "10px", marginTop: "-12px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: "center", marginBottom: "20px", fontSize: 15 } },
              title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, lineHeight: "20px" } },
              '\u611F\u8C22\u60A8\u7684\u4FE1\u4EFB\uFF0C\u5DF2\u4E3A\u60A8\u5F00\u7ACB\u57FA\u91D1\u6295\u987E\u8D26\u6237\u3002   \u534E\u590F\u8D22\u5BCC\u83B7\u6279\u6210\u4E3A\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u9996\u6279\u8BD5\u70B9\u673A\u6784\uFF0C\u5373\u65E5\u8D77\u67E5\u7406\u667A\u6295\u5168\u65B0\u5347\u7EA7\u3002\u60A8\u53EF\u5C06\u6301\u6709\u7684',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "red" } },
                this.props.content
              ),
              '\u8F6C\u6362\u4E3A\u4E0E\u60A8\u98CE\u9669\u627F\u53D7\u80FD\u529B\u5339\u914D\u7684\u7EC4\u5408\uFF0C\u4EAB\u53D7\u57FA\u91D1\u6295\u987E\u670D\u52A1\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "20px" } }),
            this.props.btnTxt1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    handleClick1();
                  }, style: { fontSize: "0.3rem", borderRadius: "20px", width: "210px", backgroundColor: "#fa063a", height: "40px", color: "#FFF", textAlign: "center", lineHeight: "40px" } },
                this.props.btnTxt1
              )
            ) : null,
            this.props.btnTxt2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertOk_div', style: { marginTop: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    handleClick2();
                  }, style: { fontSize: "0.3rem", borderRadius: "20px", border: "1px solid #CCC", width: "210px", backgroundColor: "#FFF", height: "40px", color: "#000", textAlign: "center", lineHeight: "40px" } },
                this.props.btnTxt2
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: "30px" } })
          )
        )
      );
    }
  }]);

  return AlerModleUpgrade;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ModalTips = function (_Component7) {
  _inherits(ModalTips, _Component7);

  function ModalTips(props) {
    _classCallCheck(this, ModalTips);

    var _this10 = _possibleConstructorReturn(this, (ModalTips.__proto__ || Object.getPrototypeOf(ModalTips)).call(this, props));

    _this10.state = {
      disabledFlag: false,
      disabledNum: 10
    };
    _this10.interval = null;
    return _this10;
  }

  _createClass(ModalTips, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // document.getElementsByTagName('html')[0].style.overflowY='hidden';
      // document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this11 = this;

      var num = this.state.disabledNum;
      this.interval = setInterval(function () {
        if (_this11.state.disabledNum - 1 == 0) {
          _this11.setState({
            disabledFlag: true,
            disabledNum: 0
          });
          clearInterval(_this11.interval);
        } else {
          _this11.setState({
            disabledNum: _this11.state.disabledNum - 1
          });
        }
      }, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.getElementsByTagName('html')[0].style.overflowY='auto';
      // document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var currentDate = new Date();
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth() + 1;
      var day = currentDate.getDate();
      var ymd = year + '年' + month + '月' + day + '日';
      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      // let {handleOk} = this.props;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#FFF", paddingTop: 60, paddingBottom: 50 }, onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { textAlign: "center", fontSize: 16, fontWeight: "bold", background: "#fff", height: 60, paddingTop: 20, position: "fixed", zIndex: 9999, top: 0, width: "100%" } },
          this.props.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { background: "#FFF", borderRadius: "20px", position: "relative", padding: 10, paddingTop: 0 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: "10px", paddingRight: "10px", position: "relative" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, lineHeight: "20px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textAlign: "center" } },
                '\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textAlign: "center" } },
                '\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textAlign: "center" } },
                '\u98CE\u9669\u63ED\u793A\u4E66'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u5C0A\u656C\u7684\u5BA2\u6237\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\uFF08\u4EE5\u4E0B\u7B80\u79F0\u57FA\u91D1\uFF09\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF08\u4EE5\u4E0B\u7B80\u79F0\u6295\u987E\u670D\u52A1\uFF09\u5B58\u5728\u98CE\u9669\u3002\u4E3A\u4E86\u4FDD\u62A4\u5BA2\u6237\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u7279\u5411\u5BA2\u6237\u544A\u77E5\u5982\u4E0B\u4FE1\u606F\u53CA\u98CE\u9669\uFF0C\u8BF7\u5BA2\u6237\u5728\u63A5\u53D7\u57FA\u91D1\u6295\u987E\u670D\u52A1\u524D\u8BA4\u771F\u9605\u8BFB\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u4E00\u3001\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u8BD5\u70B9\u673A\u6784\uFF08\u4EE5\u4E0B\u7B80\u79F0\u57FA\u91D1\u6295\u987E\u673A\u6784\uFF09\u58F0\u660E\u4E0E\u627F\u8BFA'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u57FA\u91D1\u6295\u987E\u673A\u6784\u5C06\u9075\u5FAA\u5BA2\u6237\u5229\u76CA\u4F18\u5148\u539F\u5219\uFF0C\u5C65\u884C\u8BDA\u5B9E\u5B88\u4FE1\u3001\u8C28\u614E\u52E4\u52C9\u3001\u6301\u7EED\u6CE8\u610F\u4E49\u52A1\uFF0C\u4F46\u4E0D\u5BF9\u5BA2\u6237\u6295\u8D44\u6536\u76CA\u72B6\u51B5\u6216\u672C\u91D1\u4E0D\u53D7\u635F\u5931\u4F5C\u51FA\u4EFB\u4F55\u627F\u8BFA\uFF0C\u6295\u8D44\u98CE\u9669\u7531\u5BA2\u6237\u81EA\u884C\u627F\u62C5\u3002\u57FA\u91D1\u6295\u987E\u670D\u52A1\u7684\u8FC7\u5F80\u4E1A\u7EE9\u5E76\u4E0D\u9884\u793A\u5176\u672A\u6765\u4E1A\u7EE9\u8868\u73B0\uFF0C\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u57FA\u91D1\u6295\u987E\u670D\u52A1\u4E0D\u540C\u4E8E\u57FA\u91D1\u9500\u552E\u4E1A\u52A1\uFF0C\u5176\u6536\u8D39\u6A21\u5F0F\u4E0E\u57FA\u91D1\u9500\u552E\u5B58\u5728\u8F83\u5927\u5DEE\u5F02\u3002\u57FA\u91D1\u6295\u987E\u673A\u6784\u53EF\u4EE5\u63A5\u53D7\u5BA2\u6237\u59D4\u6258\uFF0C\u6309\u7167\u57FA\u91D1\u6295\u987E\u670D\u52A1\u534F\u8BAE\u7EA6\u5B9A\u5411\u5176\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\uFF0C\u5E76\u76F4\u63A5\u6216\u8005\u95F4\u63A5\u83B7\u53D6\u7ECF\u6D4E\u5229\u76CA\u3002\u5BA2\u6237\u5E94\u5145\u5206\u4E86\u89E3\u57FA\u91D1\u6295\u987E\u670D\u52A1\u534F\u8BAE\u5173\u4E8E\u6536\u8D39\u6A21\u5F0F\u3001\u8D39\u7528\u7EC4\u6210\u3001\u8D39\u7387\u6C34\u5E73\u3001\u8BA1\u63D0\u65B9\u5F0F\u7B49\u7684\u5B89\u6392\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u4E8C\u3001\u57FA\u91D1\u6295\u987E\u670D\u52A1\u7684\u4E00\u822C\u98CE\u9669\u63ED\u793A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u4E00\uFF09\u57FA\u91D1\u6295\u987E\u673A\u6784\u63D0\u4F9B\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\u5177\u6709\u5E02\u573A\u98CE\u9669\u3001\u4FE1\u7528\u98CE\u9669\u3001\u6D41\u52A8\u6027\u98CE\u9669\u3001\u6CD5\u5F8B\u98CE\u9669\u4EE5\u53CA\u5176\u4ED6\u6295\u8D44\u98CE\u9669\u7B49\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '1.\u5E02\u573A\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u8BC1\u5238\u5E02\u573A\u4EF7\u683C\u56E0\u53D7\u5404\u79CD\u56E0\u7D20\u7684\u5F71\u54CD\u800C\u5F15\u8D77\u7684\u6CE2\u52A8\uFF0C\u5C06\u4F7F\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u9762\u4E34\u6F5C\u5728\u7684\u98CE\u9669\u3002\u5E02\u573A\u98CE\u9669\u53EF\u4EE5\u5206\u4E3A\u80A1\u7968\u6295\u8D44\u98CE\u9669\u548C\u503A\u5238\u6295\u8D44\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u80A1\u7968\u6295\u8D44\u98CE\u9669\u4E3B\u8981\u5305\u62EC\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF081\uFF09\u56FD\u5BB6\u8D27\u5E01\u653F\u7B56\u3001\u8D22\u653F\u653F\u7B56\u3001\u4EA7\u4E1A\u653F\u7B56\u7B49\u7684\u53D8\u5316\u5BF9\u8BC1\u5238\u5E02\u573A\u4EA7\u751F\u4E00\u5B9A\u7684\u5F71\u54CD\uFF0C\u5BFC\u81F4\u5E02\u573A\u4EF7\u683C\u6C34\u5E73\u6CE2\u52A8\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF082\uFF09\u5B8F\u89C2\u7ECF\u6D4E\u8FD0\u884C\u5468\u671F\u6027\u6CE2\u52A8\uFF0C\u5BF9\u80A1\u7968\u5E02\u573A\u7684\u6536\u76CA\u6C34\u5E73\u4EA7\u751F\u5F71\u54CD\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF083\uFF09\u4E0A\u5E02\u516C\u53F8\u7684\u7ECF\u8425\u72B6\u51B5\u53D7\u591A\u79CD\u56E0\u7D20\u5F71\u54CD\uFF0C\u5982\u5E02\u573A\u3001\u6280\u672F\u3001\u7ADE\u4E89\u3001\u7BA1\u7406\u3001\u8D22\u52A1\u7B49\u90FD\u4F1A\u5BFC\u81F4\u516C\u53F8\u76C8\u5229\u53D1\u751F\u53D8\u5316\uFF0C\u4ECE\u800C\u5BFC\u81F4\u80A1\u7968\u4EF7\u683C\u53D8\u52A8\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u503A\u5238\u6295\u8D44\u98CE\u9669\u4E3B\u8981\u5305\u62EC\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF081\uFF09\u5E02\u573A\u5E73\u5747\u5229\u7387\u6C34\u5E73\u53D8\u5316\u5BFC\u81F4\u503A\u5238\u4EF7\u683C\u53D8\u5316\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF082\uFF09\u503A\u5238\u5E02\u573A\u4E0D\u540C\u671F\u9650\u3001\u4E0D\u540C\u7C7B\u5C5E\u503A\u5238\u4E4B\u95F4\u7684\u5229\u5DEE\u53D8\u52A8\u5BFC\u81F4\u76F8\u5E94\u671F\u9650\u548C\u7C7B\u5C5E\u503A\u5238\u4EF7\u683C\u53D8\u5316\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF083\uFF09\u503A\u5238\u4E4B\u53D1\u884C\u4EBA\u51FA\u73B0\u8FDD\u7EA6\u3001\u62D2\u7EDD\u652F\u4ED8\u5230\u671F\u672C\u606F\uFF0C\u6216\u7531\u4E8E\u503A\u5238\u53D1\u884C\u4EBA\u4FE1\u7528\u8D28\u91CF\u964D\u4F4E\u5BFC\u81F4\u503A\u5238\u4EF7\u683C\u4E0B\u964D\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '2.\u4FE1\u7528\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u4FE1\u7528\u98CE\u9669\u662F\u6307\u91D1\u878D\u4EA7\u54C1\u53D1\u884C\u4EBA\u672A\u80FD\u591F\u5B9E\u73B0\u53D1\u884C\u65F6\u7684\u627F\u8BFA\uFF0C\u6309\u65F6\u8DB3\u989D\u8FD8\u672C\u4ED8\u606F\u7684\u98CE\u9669\uFF0C\u6216\u8005\u4EA4\u6613\u5BF9\u624B\u672A\u80FD\u6309\u65F6\u5C65\u7EA6\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '3.\u6D41\u52A8\u6027\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u5728\u5E02\u573A\u6216\u8005\u6295\u8D44\u6807\u7684\u6D41\u52A8\u6027\u4E0D\u8DB3\u7684\u60C5\u51B5\u4E0B\uFF0C\u8D44\u4EA7\u7BA1\u7406\u4EBA\u53EF\u80FD\u65E0\u6CD5\u8FC5\u901F\u3001\u4F4E\u6210\u672C\u5730\u8C03\u6574\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\uFF0C\u4ECE\u800C\u5BF9\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u6536\u76CA\u9020\u6210\u4E0D\u5229\u5F71\u54CD\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u7531\u4E8E\u5F00\u653E\u5F0F\u57FA\u91D1\u7684\u7279\u6B8A\u8981\u6C42\uFF0C\u6210\u5206\u57FA\u91D1\u5FC5\u987B\u4FDD\u6301\u4E00\u5B9A\u7684\u73B0\u91D1\u6BD4\u4F8B\u4EE5\u5E94\u5BF9\u8D4E\u56DE\u8981\u6C42\uFF0C\u5728\u7BA1\u7406\u73B0\u91D1\u5934\u5BF8\u65F6\uFF0C\u6709\u53EF\u80FD\u5B58\u5728\u73B0\u91D1\u4E0D\u8DB3\u7684\u98CE\u9669\u548C\u73B0\u91D1\u8FC7\u591A\u5E26\u6765\u7684\u6536\u76CA\u4E0B\u964D\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '4.\u6CD5\u5F8B\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u7531\u4E8E\u5404\u4E2A\u56FD\u5BB6/\u5730\u533A\u9002\u7528\u4E0D\u540C\u6CD5\u5F8B\u6CD5\u89C4\u7684\u539F\u56E0\uFF0C\u53EF\u80FD\u5BFC\u81F4\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7684\u67D0\u4E9B\u6295\u8D44\u884C\u4E3A\u5728\u90E8\u5206\u56FD\u5BB6/\u5730\u533A\u53D7\u5230\u9650\u5236\u6216\u5408\u540C\u4E0D\u80FD\u6B63\u5E38\u6267\u884C\uFF0C\u4ECE\u800C\u4F7F\u5F97\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u8D44\u4EA7\u9762\u4E34\u635F\u5931\u7684\u53EF\u80FD\u6027\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '5.\u79EF\u6781\u7BA1\u7406\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u5728\u7CBE\u9009\u6210\u5206\u57FA\u91D1\u7684\u5B9E\u9645\u64CD\u4F5C\u8FC7\u7A0B\u4E2D\uFF0C\u57FA\u91D1\u6295\u987E\u673A\u6784\u53EF\u80FD\u9650\u4E8E\u77E5\u8BC6\u3001\u6280\u672F\u3001\u7ECF\u9A8C\u7B49\u56E0\u7D20\u800C\u5F71\u54CD\u5176\u5BF9\u76F8\u5173\u4FE1\u606F\u3001\u7ECF\u6D4E\u5F62\u52BF\u548C\u8BC1\u5238\u4EF7\u683C\u8D70\u52BF\u7684\u5224\u65AD\uFF0C\u5176\u7CBE\u9009\u51FA\u7684\u6210\u5206\u57FA\u91D1\u7684\u4E1A\u7EE9\u8868\u73B0\u4E0D\u4E00\u5B9A\u6301\u7EED\u4F18\u4E8E\u5176\u4ED6\u57FA\u91D1\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '6.\u5883\u5916\u5E02\u573A\u6295\u8D44\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u6210\u5206\u57FA\u91D1\u6295\u8D44\u5883\u5916\u5E02\u573A\u8BC1\u5238\u7684\uFF0C\u9664\u4E86\u9700\u8981\u627F\u62C5\u4E0E\u5883\u5185\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u7C7B\u4F3C\u7684\u5E02\u573A\u6CE2\u52A8\u98CE\u9669\u7B49\u4E00\u822C\u6295\u8D44\u98CE\u9669\u4E4B\u5916\uFF0C\u6210\u5206\u57FA\u91D1\u8FD8\u9762\u4E34\u6C47\u7387\u98CE\u9669\u7B49\u5883\u5916\u8BC1\u5238\u5E02\u573A\u6295\u8D44\u6240\u9762\u4E34\u7684\u7279\u522B\u6295\u8D44\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '7.\u5176\u4ED6\u98CE\u9669'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u7531\u4E8E\u4E0D\u53EF\u6297\u529B\u3001\u65E0\u6CD5\u4F30\u503C\u3001\u5DE8\u989D\u8D4E\u56DE\u7B49\u60C5\u5F62\u53D1\u751F\uFF0C\u6210\u5206\u57FA\u91D1\u7684\u57FA\u91D1\u7BA1\u7406\u4EBA\u53EF\u6309\u7167\u57FA\u91D1\u5408\u540C\u3001\u62DB\u52DF\u8BF4\u660E\u4E66\u7B49\u8F7D\u660E\u7684\u89C4\u5B9A\u6682\u505C\u63A5\u53D7\u8D4E\u56DE\u7533\u8BF7\u6216\u8005\u5EF6\u7F13\u652F\u4ED8\u8D4E\u56DE\u6B3E\u9879\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u6295\u987E\u670D\u52A1\u7684\u6210\u5206\u57FA\u91D1\u9500\u552E\u670D\u52A1\u7531\u5176\u4ED6\u57FA\u91D1\u9500\u552E\u673A\u6784\u63D0\u4F9B\u7684\uFF0C\u6210\u5206\u57FA\u91D1\u9500\u552E\u673A\u6784\u5C06\u6267\u884C\u57FA\u91D1\u4EA7\u54C1\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u7533\u8BF7\uFF0C\u6210\u5206\u57FA\u91D1\u9500\u552E\u673A\u6784\u53EF\u80FD\u56E0\u8FDD\u7EA6\u6216\u5176\u4ED6\u591A\u79CD\u539F\u56E0\u5BFC\u81F4\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u4E1A\u52A1\u53D7\u5230\u9650\u5236\u3001\u6682\u505C\u6216\u7EC8\u6B62\uFF0C\u5B58\u5728\u5F71\u54CD\u6709\u6548\u6267\u884C\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u7531\u4E8E\u6218\u4E89\u3001\u81EA\u7136\u707E\u5BB3\u3001\u7F62\u5DE5\u3001\u901A\u4FE1\u6280\u672F\u6545\u969C\u6216\u5176\u4ED6\u4E0D\u53EF\u9884\u89C1\u7684\u610F\u5916\u60C5\u51B5\uFF0C\u53EF\u80FD\u5BFC\u81F4\u57FA\u91D1\u8D44\u4EA7\u635F\u5931\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u4E8C\uFF09\u57FA\u91D1\u6295\u987E\u673A\u6784\u6309\u7167\u5BA2\u6237\u7684\u98CE\u9669\u8BC6\u522B\u80FD\u529B\u3001\u98CE\u9669\u627F\u53D7\u80FD\u529B\u3001\u6295\u8D44\u76EE\u6807\u7B49\u56E0\u7D20\uFF0C\u63D0\u4F9B\u4E0D\u540C\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\uFF0C\u4E0D\u540C\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\u4F1A\u4EA7\u751F\u4E0D\u540C\u7684\u98CE\u9669\u6536\u76CA\u7279\u5F81\uFF0C\u5BA2\u6237\u5E94\u5145\u5206\u4E86\u89E3\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5BF9\u5E94\u7684\u98CE\u9669\u6536\u76CA\u7B49\u60C5\u51B5\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u57FA\u91D1\u6295\u987E\u673A\u6784\u5411\u5BA2\u6237\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5BA2\u6237\u8D2D\u4E70\u5355\u53EA\u57FA\u91D1\u4E0D\u540C\uFF0C\u53EF\u80FD\u5B58\u5728\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u6210\u5206\u57FA\u91D1\u98CE\u9669\u7B49\u7EA7\u9AD8\u4E8E\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u98CE\u9669\u7B49\u7EA7\u7684\u60C5\u51B5\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u4E09\uFF09\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u5C1A\u5904\u4E8E\u8BD5\u70B9\u9636\u6BB5\uFF0C\u5B58\u5728\u56E0\u57FA\u91D1\u6295\u987E\u673A\u6784\u7684\u8BD5\u70B9\u8D44\u683C\u88AB\u53D6\u6D88\u800C\u4E0D\u80FD\u7EE7\u7EED\u63D0\u4F9B\u670D\u52A1\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u4E09\u3001\u7BA1\u7406\u578B\u57FA\u91D1\u6295\u987E\u670D\u52A1\u7684\u7279\u6709\u98CE\u9669\u63ED\u793A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u4E00\uFF09\u8D26\u6237\u7BA1\u7406\u98CE\u9669\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '1.\u53D7\u57FA\u91D1\u8D26\u6237\u5F00\u7ACB\u5931\u8D25\u3001\u6210\u5206\u57FA\u91D1\u4EA4\u6613\u9650\u5236\u3001\u7CFB\u7EDF\u5F02\u5E38\u4EE5\u53CA\u5176\u4ED6\u7279\u6B8A\u60C5\u51B5\u7684\u5F71\u54CD\uFF0C\u6388\u6743\u8D26\u6237\u53EF\u80FD\u4F1A\u51FA\u73B0\u57FA\u91D1\u4EA4\u6613\u5931\u8D25\u7684\u60C5\u5F62\uFF1B'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '2.\u56E0\u5BA2\u6237\u7533\u8BF7\u8F6C\u5165\u8F6C\u51FA\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u65F6\u95F4\u4E0D\u540C\uFF0C\u4EE5\u53CA\u6210\u5206\u57FA\u91D1\u66FF\u4EE3\u3001\u4EA4\u6613\u89C4\u5219\u5DEE\u5F02\u6216\u9650\u5236\u3001\u5B9E\u9645\u4EA4\u6613\u8D39\u7528\uFF0C\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u518D\u5E73\u8861\u7B49\u539F\u56E0\uFF0C\u5BA2\u6237\u6301\u6709\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u4E0E\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u6240\u5BF9\u5E94\u7684\u6807\u51C6\u7EC4\u5408\u4E4B\u95F4\u53EF\u80FD\u5B58\u5728\u5DEE\u5F02\uFF0C\u5E76\u53EF\u80FD\u5BFC\u81F4\u4E1A\u7EE9\u8868\u73B0\u7B49\u65B9\u9762\u5B58\u5728\u5DEE\u5F02\uFF1B'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '3.\u5728\u6388\u6743\u8D26\u6237\u7BA1\u7406\u8FD0\u4F5C\u671F\u95F4\uFF0C\u5B58\u5728\u56E0\u5BA2\u6237\u8FDD\u53CD\u53CD\u6D17\u94B1\u3001\u53CD\u6050\u6016\u878D\u8D44\u7B49\u89C4\u5B9A\uFF0C\u6388\u6743\u8D26\u6237\u88AB\u53F8\u6CD5\u51BB\u7ED3\u6216\u5F3A\u5236\u6267\u884C\uFF0C\u5BFC\u81F4\u57FA\u91D1\u6295\u987E\u673A\u6784\u65E0\u6CD5\u6309\u7167\u534F\u8BAE\u7EA6\u5B9A\u8FDB\u884C\u8C03\u4ED3\u5E76\u6709\u6548\u5F00\u5C55\u57FA\u91D1\u6295\u8D44\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u4E8C\uFF09\u8C03\u4ED3\u98CE\u9669\uFF1A\u57FA\u91D1\u6295\u987E\u673A\u6784\u4F1A\u6839\u636E\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u53CA\u5E02\u573A\u7684\u53D8\u5316\uFF0C\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5BF9\u6BCF\u4E2A\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u6210\u5206\u57FA\u91D1\u6216\u5176\u914D\u7F6E\u6BD4\u4F8B\u8FDB\u884C\u8C03\u6574\uFF0C\u8BE5\u8C03\u6574\u53EF\u80FD\u4F1A\u4EA7\u751F\u8D39\u7528\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u4E09\uFF09\u6280\u672F\u98CE\u9669\uFF1A\u5E94\u7528\u4E92\u8054\u7F51\u6280\u672F\u63D0\u4F9B\u7BA1\u7406\u578B\u57FA\u91D1\u6295\u987E\u670D\u52A1\u65F6\uFF0C\u53EF\u80FD\u51FA\u73B0\u56E0\u91CD\u5927\u6280\u672F\u5C40\u9650\u548C\u6F0F\u6D1E\uFF0C\u5BFC\u81F4\u7CFB\u7EDF\u4E0D\u80FD\u4E3A\u5BA2\u6237\u63D0\u4F9B\u6B63\u5E38\u6301\u7EED\u670D\u52A1\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\uFF08\u56DB\uFF09\u673A\u6784\u98CE\u9669\uFF1A\u5728\u6388\u6743\u8D26\u6237\u7BA1\u7406\u8FD0\u4F5C\u671F\u95F4\uFF0C\u5B58\u5728\u56E0\u57FA\u91D1\u6295\u987E\u673A\u6784\u7ECF\u8425\u72B6\u51B5\u6076\u5316\u3001\u51FA\u73B0\u58F0\u8A89\u98CE\u9669\u7B49\u60C5\u51B5\uFF0C\u5BFC\u81F4\u5BA2\u6237\u5229\u76CA\u53D7\u5230\u5F71\u54CD\u7684\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u56DB\u3001\u5176\u4ED6\u98CE\u9669\u63ED\u793A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u672C\u98CE\u9669\u63ED\u793A\u4E66\u4EC5\u5305\u542B\u57FA\u91D1\u6295\u987E\u670D\u52A1\u53EF\u80FD\u6D89\u53CA\u7684\u90E8\u5206\u98CE\u9669\u53CA\u5E94\u77E5\u6089\u7684\u82E5\u5E72\u91CD\u5927\u4E8B\u9879\uFF0C\u672A\u7A77\u5C3D\u5217\u4E3E\u57FA\u91D1\u6295\u987E\u670D\u52A1\u7684\u6240\u6709\u98CE\u9669\u53CA\u4E0E\u5BA2\u6237\u6743\u76CA\u76F8\u5173\u7684\u4E00\u5207\u4E8B\u9879\u3002\u8BF7\u5BA2\u6237\u5728\u5B8C\u6574\u9605\u8BFB\u548C\u7406\u89E3\u57FA\u91D1\u6295\u987E\u670D\u52A1\u76F8\u5173\u534F\u8BAE\u3001\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u53CA\u672C\u98CE\u9669\u63ED\u793A\u4E66\u7684\u57FA\u7840\u4E0A\uFF0C\u6839\u636E\u81EA\u8EAB\u98CE\u9669\u627F\u53D7\u80FD\u529B\u548C\u6295\u8D44\u9700\u6C42\uFF0C\u5BA1\u614E\u51B3\u5B9A\u63A5\u53D7\u57FA\u91D1\u6295\u987E\u670D\u52A1\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u4E94\u3001\u5BA2\u6237\u58F0\u660E'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { textIndent: "2em" } },
                '\u672C\u4EBA\u5DF2\u4ED4\u7EC6\u9605\u8BFB\u57FA\u91D1\u6295\u987E\u670D\u52A1\u76F8\u5173\u7684\u534F\u8BAE\u3001\u89C4\u5219\uFF0C\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u53CA\u672C\u98CE\u9669\u63ED\u793A\u4E66\uFF0C\u5DF2\u5145\u5206\u4E86\u89E3\u5E76\u8C28\u614E\u8BC4\u4F30\u81EA\u8EAB\u98CE\u9669\u627F\u53D7\u80FD\u529B\uFF0C\u5145\u5206\u7406\u89E3\u57FA\u91D1\u6295\u987E\u670D\u52A1\u6240\u6D89\u53CA\u7684\u98CE\u9669\uFF0C\u613F\u610F\u627F\u62C5\u4E0A\u8FF0\u98CE\u9669\u63ED\u793A\u4E66\u4E2D\u63D0\u53CA\u7684\u5168\u90E8\u98CE\u9669\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textIndent: "2em", display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { style: { width: '55%' } }),
                '\u5BA2\u6237\uFF1A',
                this.props.verifiedUserInfo.name
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textIndent: "2em", display: 'flex' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { style: { width: '55%' } }),
                '\u65E5\u671F\uFF1A',
                ymd
              )
            )
          )
        ),
        this.state.disabledFlag == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: _defineProperty({ background: "#fff", height: 50, display: "flex", width: "100%", justifyContent: "center", alignItems: "center", position: "fixed", bottom: -1 }, 'background', "#fff") },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this12.goBack();
              }, style: { flex: 1, height: "50px", color: "#5c6270", textAlign: 'center', lineHeight: '50px' } },
            '\u8FD4\u56DE'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: "100%", flex: 5, backgroundColor: "#afb0b2", height: "50px", color: "#FFF", textAlign: "center", lineHeight: "50px" } },
            this.props.buttonText + ' (' + this.state.disabledNum + 's)'
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: _defineProperty({ background: "#fff", height: 50, display: "flex", width: "100%", justifyContent: "center", alignItems: "center", position: "fixed", bottom: -1 }, 'background', "#fff") },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this12.goBack();
              }, style: { flex: 1, height: "50px", color: "#5c6270", textAlign: 'center', lineHeight: '50px' } },
            '\u8FD4\u56DE'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this12.props.handleOk();
              }, style: { width: "100%", flex: 5, backgroundColor: "#fa063a", height: "50px", color: "#FFF", textAlign: "center", lineHeight: "50px" } },
            '' + this.props.buttonText
          )
        )
      );
    }
  }]);

  return ModalTips;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["e"] = (AlerModle);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = myInvestmentList;
/* unused harmony export myInvestmentListOver */
/* unused harmony export myInvestmentDetial */
/* unused harmony export myInvestmentFundList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getInvestmentList; });
/* unused harmony export getInvestmentListOver */
/* harmony export (immutable) */ __webpack_exports__["h"] = getInvestmentDetial;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInvestmentHistory;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getInvestmentFundList; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getStopBuyPlan;
/* harmony export (immutable) */ __webpack_exports__["i"] = getStopPlan;
/* harmony export (immutable) */ __webpack_exports__["k"] = moneyFundPlanStopValidate;
/* harmony export (immutable) */ __webpack_exports__["e"] = createBuyPlan;
/* harmony export (immutable) */ __webpack_exports__["n"] = createBuyPlanzxk;
/* harmony export (immutable) */ __webpack_exports__["f"] = createPlan;
/* harmony export (immutable) */ __webpack_exports__["p"] = dttByMoneyFundSubmit;
/* harmony export (immutable) */ __webpack_exports__["o"] = dttByMoneyFundValidate;
/* harmony export (immutable) */ __webpack_exports__["d"] = modifyBuyPlan;
/* harmony export (immutable) */ __webpack_exports__["c"] = modifyPlan;
/* harmony export (immutable) */ __webpack_exports__["m"] = moneyFundPlanModifyValidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__investmentAction__ = __webpack_require__(8);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





function myInvestmentList(text) {
  return {
    type: "INVESTMENT_LIST",
    text: text
  };
}
function myInvestmentListOver(text) {
  return {
    type: "INVESTMENT_LIST_OVER",
    text: text
  };
}
function myInvestmentDetial(text) {
  return {
    type: "INVESTMENT_DETIAL",
    text: text
  };
}
function myInvestmentFundList(text) {
  return {
    type: "INVESTMENT_FUN_LIST",
    text: text
  };
}
//定投计划列表
var getInvestmentList = function getInvestmentList() {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, pageSize: '9999'
      };
      console.log(d);
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/queryPlanList", data, function (result) {
        if (result.code == '0000') {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          var newDate = result.content.records.filter(function (item) {
            return item.fundCode.startsWith('SF');
          });
          result.content.records = newDate;
          dispatch(myInvestmentList(result));
        } else {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
        console.log(result, '---oooo111');
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        console.log('jiekou error');
      }, 60);
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
};
//定投计划列表
function getInvestmentListOver() {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d, pageSize: '99999'
      };
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/queryPlanList", data, function (result) {
        if (result.code == '0000') {
          dispatch(myInvestmentList(result));
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }

        console.log(result, '---oooo111');
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        console.log('jiekou error');
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//定投计划详情
function getInvestmentDetial(planId, callback) {
  return function (dispatch, getState) {
    callback();
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      var data = {
        token: d,
        planId: planId
      };
      console.log(data);
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/findSinglePlan", data, function (result) {
        if (result.code == '0000') {
          dispatch(myInvestmentDetial(result.content));
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
        console.log(result);
        callback();
      }, function (error) {
        callback();
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        console.log('jiekou error');
      });
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//定投计划历史
function getInvestmentHistory(data, successCallback) {
  return function (dispatch, getState) {

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log(data);
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/queryPayHistory", data, function (result) {
        if (result.code == '0000') {
          successCallback(result.content.records);
          console.log(result, '12213123123');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {});
  };
}
//定投基金列表
var getVal = function getVal(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
};
var getInvestmentFundList = function getInvestmentFundList(callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/queryCommonBuyPlanFundList", {}, function (result) {
      if (result.code == '0000') {
        var obj = { ZT: [], GP: [], HH: [], HB: [], ZQ: [], ZS: [], LC: [] };
        var SF1022 = [];
        var SF1067 = [];
        var SF1060 = [];
        var SF1039 = [];
        var SF1038 = [];
        var SF1036 = [];
        var SF1021 = [];
        var SF1020 = [];
        var SF1019 = [];
        var SF1018 = [];
        var SF1017 = [];
        var SF1016 = [];
        var SF1015 = [];
        var SF1014 = [];
        var SF1013 = [];
        var SF1012 = [];
        var jingzhi = [];
        var wanfenshouyi = [];
        result.content.forEach(function (item, i) {
          if (item.fundTypeName == '股票型') {
            obj.GP.push(item);
            jingzhi.push(item);
          } else if (item.fundTypeName == '混合型') {
            obj.HH.push(item);
            jingzhi.push(item);
          } else if (item.fundTypeName == '货币型') {
            obj.HB.push();
            wanfenshouyi.push(item);
          } else if (item.fundTypeName == '债券型') {
            obj.ZQ.push(item);
            jingzhi.push(item);
          } else if (item.fundTypeName == '指数型') {
            obj.ZS.push(item);
            jingzhi.push(item);
          } else if (item.fundTypeName == '理财型') {
            obj.LC.push(item);
            wanfenshouyi.push(item);
          } else if (item.fundTypeName == '超级基金型') {
            try {
              // if(Util.superFundCodeArr(item.fundCode) == -1){
              eval(item.fundCode).push(item);
              // }
            } catch (error) {}
          }
        });
        jingzhi.sort(getVal('zhangdiefu', false));
        wanfenshouyi.sort(getVal('qirinianhua', false));
        obj.ZT = [].concat(SF1022, SF1067, SF1060, SF1039, SF1038, SF1036, SF1021, SF1020, SF1019, SF1018, SF1017, SF1016, SF1015, SF1014, SF1013, SF1012);
        // let all=[...obj.ZT,...jingzhi,...wanfenshouyi];
        var all = [].concat(_toConsumableArray(obj.ZT));
        callback(all, obj.ZT, obj.GP, obj.HH, obj.HB, obj.ZQ, obj.ZS, obj.LC);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
      } else {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }
      console.log(result);
    }, function (error) {

      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      console.log('jiekou error', error);
    });
  };
};
//定投终止
function getStopBuyPlan(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log('定投终止:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/stopBuyPlan", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
function getStopPlan(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log('定投终止HQT:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/stopPlan", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
function moneyFundPlanStopValidate(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paybymoneyfund/moneyFundPlanStopValidate", data, function (result) {
          if (result.code == '0000') {
            __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paybymoneyfund/moneyFundPlanStopSubmit", data, function (result) {
              console.log(result);
              if (result.code == '0000') {
                var id = result.content;
                result.content = { planId: id };
                callback(1, result);
              } else {
                callback(3, result.message);
              }
              __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
            }, function (error) {
              callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
              __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//新建定投
function createBuyPlan(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
      console.log('定投入参:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/createBuyPlan", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(0, result.message);
          }
        }, function (error) {
          callback(0, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}

//直销卡新建定投
function createBuyPlanzxk(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
      console.log('定投入参:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/v1/plan/camcBankCardPlan/createPlan", data, function (result) {
          console.log(result, "111111");
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(0, result.message);
          }
        }, function (error) {
          callback(0, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//活期通账号新建定投
function createPlan(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
      console.log('定投入参:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/createPlan", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {});
  };
}
//智投定投
function dttByMoneyFundSubmit(data, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paybymoneyfund/dttByMoneyFundSubmit", data, function (result) {
        console.log(result);
        if (result.code == '0000') {
          var id = result.content;
          result.content = { planId: id };
          callback(1, result);
        } else {
          callback(3, result.message);
        }
      }, function (error) {
        callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
      });
    }).catch(function (err) {
      callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
    });
  };
}
function dttByMoneyFundValidate(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.return_Clinet_Type();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paybymoneyfund/dttByMoneyFundValidate", data, function (result) {
          if (result.code == '0000') {
            callback();
          } else {
            __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}
//修改定投
function modifyBuyPlan(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log('修改入参:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/modifyBuyPlan", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {});
  };
}
function modifyPlan(data, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      console.log('修改入参:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/plan/modifyPlan", data, function (result) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          if (result.code == '0000') {
            callback(1, result);
          } else {
            callback(3, result.message);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          callback(3, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt);
        });
      }, function (m) {

        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {});
  };
}
function moneyFundPlanModifyValidate(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (d) {
      data.token = d;
      data.clientType = 'hxcfApp';
      console.log('修改入参:', data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__investmentAction__["a" /* validateTransactionPassword */])(data, function (c) {
        if (!c) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('交易密码错误', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);return;
        }
        __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paybymoneyfund/moneyFundPlanModifyValidate", data, function (result) {
          console.log(result);
          if (result.code == '0000') {
            __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paybymoneyfund/moneyFundPlanModifySubmit", data, function (result) {
              if (result.code == '0000') {
                var id = result.content;
                result.content = { planId: id };
                callback(1, result);
              } else {
                __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
              }
            }, function (error) {
              __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(result.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
          }
        }, function (error) {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        });
      }, function (m) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(m, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }));
    }).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
    });
  };
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export superFundProductIncomeDelAction */
/* unused harmony export LineDataDelAction */
/* unused harmony export lineDataLastDel */
/* unused harmony export strategiesDetailsDel */
/* unused harmony export userAllIncomeHistoryDel */
/* unused harmony export allIncomeLastDel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeFundListDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSuperFundProductIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStrategiesDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStrategiesDetailsHaveCast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getStrategiesDetailsStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStrategiesDetailsStopHaveCast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getChangeFundList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHistoryIncomeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserTransactionIncomeAndProductIncome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEvaluationIndicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js__ = __webpack_require__(13);


var _this = this;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




/* 组合表现信息 */
var superFundProductIncomeAction = function superFundProductIncomeAction(data) {
  return {
    type: "SUPERFUND_PRODUCT_INCOME",
    data: data
  };
};

var superFundProductIncomeDelAction = function superFundProductIncomeDelAction(data) {
  return {
    type: "SUPERFUND_PRODUCT_INCOME_DEL",
    data: data
  };
};

/* 业绩走势及基线折线图数据 */
var LineDataAction = function LineDataAction(data) {
  return {
    type: "LINE_DATA",
    data: data
  };
};
var LineDataDelAction = function LineDataDelAction(data) {
  return {
    type: "LINE_DATA_DEL",
    data: data
  };
};

/* 最新业绩走势 */
var lineDataLast = function lineDataLast(data) {
  return {
    type: "LINE_DATA_LAST",
    data: data
  };
};

var lineDataLastDel = function lineDataLastDel(data) {
  return {
    type: "LINE_DATA_LAST_DEL",
    data: data
  };
};

/* 详情页面信息 */
var strategiesDetails = function strategiesDetails(data) {
  return {
    type: "STRATEGIES_DETAILS",
    data: data
  };
};
var strategiesDetailsDel = function strategiesDetailsDel(data) {
  return {
    type: "STRATEGIES_DETAILS_DEL",
    data: data
  };
};

/* 累计收益折线图数据 */
var userAllIncomeHistory = function userAllIncomeHistory(data) {
  return {
    type: "USER_ALL_INCOME_HISTORY",
    data: data
  };
};
var userAllIncomeHistoryDel = function userAllIncomeHistoryDel(data) {
  return {
    type: "USER_ALL_INCOME_HISTORY_DEL",
    data: data
  };
};

/* 最新累计收益 */
var allIncomeLast = function allIncomeLast(data) {
  return {
    type: "ALL_INCOME_LAST",
    data: data
  };
};

var allIncomeLastDel = function allIncomeLastDel(data) {
  return {
    type: "ALL_INCOME_LAST_DEL",
    data: data
  };
};

/* 调仓记录列表 */
var changeFundList = function changeFundList(data) {
  return {
    type: "CHANGE_FUND_LIST",
    data: data
  };
};
var changeFundListDel = function changeFundListDel(data) {
  return {
    type: "CHANGE_FUND_LIST_DEL",
    data: data
  };
};

/* 获取非止盈未投基本表现信息及业绩走势折线图数据 */
var getSuperFundProductIncome = function getSuperFundProductIncome(params, callBack) {
  //params.superFundCode = "SF00l0";

  return function () {
    var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
      var successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              successCallback = function () {
                var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(succ) {
                  var _succ$content, xData, baseData, data, xBase, xDataN, lastData, incomeIndex, lastIncome, baseIndex, lastBase;

                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (succ && succ.code === "0000") {
                            console.log("successful");
                            if (params.periodType == 1) {
                              dispatch(superFundProductIncomeAction(succ.content));
                            }
                            _succ$content = succ.content, xData = _succ$content.incomeDateList, baseData = _succ$content.incomeList4Benchmark, data = _succ$content.incomeList, xBase = _succ$content.incomeDateList4Benchmark;


                            if (!xData) {
                              xData = [];
                              data = [];
                            }
                            if (!xBase) {
                              xBase = [];
                              baseData = [];
                            }
                            xDataN = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(xData), _toConsumableArray(xBase))))).sort();

                            if (xDataN.length) {
                              lastData = xDataN[xDataN.length - 1];
                              incomeIndex = xData.indexOf(lastData);
                              lastIncome = incomeIndex != -1 ? data[incomeIndex] : "";
                              baseIndex = xData.indexOf(lastData);
                              lastBase = baseIndex != -1 ? baseData[baseIndex] : "";

                              dispatch(lineDataLast({ lastBase: lastBase, lastIncome: lastIncome }));
                            }
                            dispatch(LineDataAction(_defineProperty({}, params.periodType, {
                              incomeDateList: succ.content.incomeDateList,
                              incomeList: succ.content.incomeList,
                              incomeList4Benchmark: succ.content.incomeList4Benchmark,
                              incomeDateList4Benchmark: succ.content.incomeDateList4Benchmark
                            })));
                            callBack && callBack(succ.content);
                          } else {
                            console.log("后台返回数据有误！" + succ.message);
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function successCallback(_x3) {
                  return _ref2.apply(this, arguments);
                };
              }();

              errorCallback = function errorCallback(err) {
                console.log(err);
              };

              __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/product/income/getProductIncomeHistory", params, successCallback, errorCallback);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

/* 非止盈-未投详情页面数据 */
var getStrategiesDetails = function getStrategiesDetails(params, callback) {
  //params.superFundCode = "SF0430";
  return function (dispatch, getState) {
    // dispatch(strategiesDetailsDel())
    var successCallback = function successCallback(succ) {
      if (succ && succ.code === "0000") {
        console.log("successful");
        var seriesData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map(function (v, i) {
          return {
            value: v.totalRate,
            name: "" + v.styleTypeName.replace('基金', '') + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate)
          };
        });
        var legendData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map(function (v, i) {
          return "" + v.styleTypeName.replace('基金', '') + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate);
        });
        succ.content.superFundBasicInfo.seriesData = seriesData;
        succ.content.superFundBasicInfo.legendData = legendData;
        dispatch(strategiesDetails(succ.content));
        callback && callback(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
    };
    __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/product/nonStopProfit/getProductDetail", params, successCallback, errorCallback);
  };
};

/* 非止盈-已投详情页面数据 */
var getStrategiesDetailsHaveCast = function getStrategiesDetailsHaveCast(params, rulse) {
  //params.superFundCode = "SF0430";
  return function () {
    var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(dispatch, getState) {
      var token, successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken");

            case 2:
              token = _context3.sent;

              successCallback = function successCallback(succ) {
                if (succ && succ.code === "0000") {
                  console.log("successful");
                  var seriesData = succ.content.superFundUserShare.fundItems.map(function (v, i) {
                    return {
                      value: v.totalRate,
                      name: "" + v.styleTypeName + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate)
                    };
                  });
                  var legendData = succ.content.superFundUserShare.fundItems.map(function (v, i) {
                    return "" + v.styleTypeName + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate);
                  });
                  succ.content.superFundUserShare.seriesData = seriesData;
                  succ.content.superFundUserShare.legendData = legendData;
                  dispatch(strategiesDetails(succ.content));
                  rulse && rulse(succ.content);
                } else {
                  console.log("后台返回数据有误！" + succ.message);
                }
              };

              errorCallback = function errorCallback(err) {
                console.log(err);
              };

              params.token = token;
              __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/holdshare/nonStopProfit/getUserHoldShareDetail", params, successCallback, errorCallback);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/* 获取止盈未投详情页面数据 */
var getStrategiesDetailsStop = function getStrategiesDetailsStop(params, callback) {
  // params = {
  //   superFundCode: "SF10A1",
  // };
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code === "0000") {
        console.log("successful");
        var seriesData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map(function (v, i) {
          return {
            value: v.totalRate,
            name: "" + v.styleTypeName + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate)
          };
        });
        var legendData = succ.content.superFundBasicInfo.superFundItemFund4StyleTypeList.map(function (v, i) {
          return "" + v.styleTypeName + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate);
        });
        succ.content.superFundBasicInfo.seriesData = seriesData;
        succ.content.superFundBasicInfo.legendData = legendData;
        dispatch(strategiesDetails(succ.content));
        callback && callback(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
    };
    __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/product/stopProfit/getProductDetail", params, successCallback, errorCallback);
  };
};

/* 获取止盈已投详情页面数据 */
var getStrategiesDetailsStopHaveCast = function getStrategiesDetailsStopHaveCast(params, rulse) {
  //params.superFundCode = "SF10A1";

  return function () {
    var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
      var token, successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken");

            case 2:
              token = _context4.sent;

              successCallback = function successCallback(succ) {
                if (succ && succ.code === "0000") {
                  console.log("successful");
                  var seriesData = succ.content.superFundUserShare.fundItems.map(function (v, i) {
                    return {
                      value: v.totalRate,
                      name: "" + v.styleTypeName + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate)
                    };
                  });
                  var legendData = succ.content.superFundUserShare.fundItems.map(function (v, i) {
                    return "" + v.styleTypeName + __WEBPACK_IMPORTED_MODULE_1__util___default.a.toPercent(v.totalRate);
                  });
                  succ.content.superFundUserShare.seriesData = seriesData;
                  succ.content.superFundUserShare.legendData = legendData;
                  dispatch(strategiesDetails(succ.content));
                  rulse && rulse(succ.content);
                } else {
                  console.log("后台返回数据有误！" + succ.message);
                }
              };

              errorCallback = function errorCallback(err) {
                console.log(err);
              };

              params.token = token;
              __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/holdshare/stopProfit/getUserHoldShareDetail", params, successCallback, errorCallback);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};

/* 获取调仓记录列表数据 */
var getChangeFundList = function getChangeFundList(params) {
  //params.superFundCode = "SF0430";
  return function (dispatch, getState) {
    var successCallback = function successCallback(data) {
      if (data && data.code === "0000") {
        var result = {};
        data.content.forEach(function (v) {
          v.adjustDateStr = v.effectDateStr;
          v.adjustDate = v.effectDate;
          var key = v.adjustDateStr.split("-")[0];
          if (result[key]) return result[key].push(v);
          result[key] = [v];
        });
        dispatch(changeFundList({ adjustmentList: data.content, processedData: result }));
      } else {
        console.log("后台返回数据有误！" + data.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
    };
    __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/product/adjustment/geSuperFundAdjustmentList", params, successCallback, errorCallback);
  };
};

/* 获取累计收益折线图 */
var getHistoryIncomeList = function getHistoryIncomeList(params) {
  // params.superFundCode = "SF10A5";
  return function () {
    var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(dispatch, getState) {
      var token, successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken");

            case 2:
              token = _context5.sent;

              successCallback = function successCallback(data) {
                if (data && data.code === "0000") {
                  // if (params.periodType == 1) {
                  var lastAllIncome = data.content.incomeList[data.content.incomeList.length - 1];
                  lastAllIncome && dispatch(allIncomeLast(lastAllIncome));
                  // }
                  dispatch(userAllIncomeHistory(_defineProperty({}, params.periodType, {
                    incomeDateList: data.content.incomeDateList,
                    incomeList: data.content.incomeList
                  })));
                } else {
                  console.log("后台返回数据有误！" + data.message);
                }
              };

              errorCallback = function errorCallback(err) {
                console.log(err);
              };

              params.token = token;
              __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/holdshare/income/getUserAllIncomeHistory", params, successCallback, errorCallback);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/* 获取已投业绩走势折线图数据 */
var getUserTransactionIncomeAndProductIncome = function getUserTransactionIncomeAndProductIncome(params) {
  // params.superFundCode = "SF0430";
  return function () {
    var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(dispatch, getState) {
      var token, successCallback, errorCallback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])("shortToken");

            case 2:
              token = _context6.sent;

              successCallback = function successCallback(succ) {
                if (succ && succ.code === "0000") {
                  // if (params.periodType == 1) {
                  var _succ$content2 = succ.content,
                      xData = _succ$content2.incomeDateList,
                      baseData = _succ$content2.incomeList4Benchmark,
                      data = _succ$content2.incomeList,
                      xBase = _succ$content2.incomeDateList4Benchmark;


                  if (!xData) {
                    xData = [];
                    data = [];
                  }
                  if (!xBase) {
                    xBase = [];
                    baseData = [];
                  }
                  var xDataN = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(xData), _toConsumableArray(xBase))))).sort();
                  var lastData = xDataN[xDataN.length - 1];
                  var incomeIndex = xData.indexOf(lastData);
                  var lastIncome = incomeIndex != -1 ? data[incomeIndex] : "";
                  var baseIndex = xBase.indexOf(lastData);
                  var lastBase = baseIndex != -1 ? baseData[baseIndex] : "";
                  dispatch(lineDataLast({ lastBase: lastBase, lastIncome: lastIncome }));

                  var buyListTemp = succ.content.buyDateList && succ.content.buyDateList.map(function (v) {
                    return v.split("-").join("/");
                  });
                  var sellListTemp = succ.content.redeemDateList && succ.content.redeemDateList.map(function (v) {
                    return v.split("-").join("/");
                  });
                  dispatch(LineDataAction(_defineProperty({}, params.periodType, {
                    incomeDateList: succ.content.incomeDateList,
                    incomeList: succ.content.incomeList,
                    incomeList4Benchmark: succ.content.incomeList4Benchmark,
                    incomeDateList4Benchmark: succ.content.incomeDateList4Benchmark,
                    buyList: buyListTemp,
                    sellList: sellListTemp
                  })));
                } else {
                  console.log("后台返回数据有误！" + succ.message);
                }
              };

              errorCallback = function errorCallback(err) {
                console.log(err);
              };

              params.token = token;
              __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/holdshare/income/getProductIncomeAndUserTradeDate", params, successCallback, errorCallback);

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function (_x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/* 获取策略指标数据 */
var getEvaluationIndicator = function getEvaluationIndicator(params, sucCallback) {
  // params.superFundCode = "SF00l0";
  return function (dispatch, getState) {
    var successCallback = function successCallback(succ) {
      if (succ && succ.code === "0000") {
        sucCallback && sucCallback(succ.content);
      } else {
        console.log("后台返回数据有误！" + succ.message);
      }
    };
    var errorCallback = function errorCallback(err) {
      console.log(err);
    };
    __WEBPACK_IMPORTED_MODULE_1__util___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + "/api/v1/superfund/product/evaluation/getEvaluationIndicator", params, successCallback, errorCallback);
  };
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var TYPE_DELIMITER = '.';
var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var MEMBER_PRIFIX = '\0ec_\0';
/**
 * Hide private class member.
 * The same behavior as `host[name] = value;` (can be right-value)
 * @public
 */

function set(host, name, value) {
  return host[MEMBER_PRIFIX + name] = value;
}
/**
 * Hide private class member.
 * The same behavior as `host[name];`
 * @public
 */


function get(host, name) {
  return host[MEMBER_PRIFIX + name];
}
/**
 * For hidden private class member.
 * The same behavior as `host.hasOwnProperty(name);`
 * @public
 */


function hasOwn(host, name) {
  return host.hasOwnProperty(MEMBER_PRIFIX + name);
}
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */


function parseClassType(componentType) {
  var ret = {
    main: '',
    sub: ''
  };

  if (componentType) {
    componentType = componentType.split(TYPE_DELIMITER);
    ret.main = componentType[0] || '';
    ret.sub = componentType[1] || '';
  }

  return ret;
}
/**
 * @public
 */


function checkClassType(componentType) {
  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
/**
 * @public
 */


function enableClassExtend(RootClass, mandatoryMethods) {
  RootClass.$constructor = RootClass;

  RootClass.extend = function (proto) {
    var superClass = this;

    var ExtendedClass = function () {
      if (!proto.$constructor) {
        superClass.apply(this, arguments);
      } else {
        proto.$constructor.apply(this, arguments);
      }
    };

    zrUtil.extend(ExtendedClass.prototype, proto);
    ExtendedClass.extend = this.extend;
    ExtendedClass.superCall = superCall;
    ExtendedClass.superApply = superApply;
    zrUtil.inherits(ExtendedClass, this);
    ExtendedClass.superClass = superClass;
    return ExtendedClass;
  };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.


function superCall(context, methodName) {
  var args = zrUtil.slice(arguments, 2);
  return this.superClass.prototype[methodName].apply(context, args);
}

function superApply(context, methodName, args) {
  return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * @param {Object} entity
 * @param {Object} options
 * @param {boolean} [options.registerWhenExtend]
 * @public
 */


function enableClassManagement(entity, options) {
  options = options || {};
  /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   * @type {Object}
   */

  var storage = {};

  entity.registerClass = function (Clazz, componentType) {
    if (componentType) {
      checkClassType(componentType);
      componentType = parseClassType(componentType);

      if (!componentType.sub) {
        storage[componentType.main] = Clazz;
      } else if (componentType.sub !== IS_CONTAINER) {
        var container = makeContainer(componentType);
        container[componentType.sub] = Clazz;
      }
    }

    return Clazz;
  };

  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
    var Clazz = storage[componentMainType];

    if (Clazz && Clazz[IS_CONTAINER]) {
      Clazz = subType ? Clazz[subType] : null;
    }

    if (throwWhenNotFound && !Clazz) {
      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
    }

    return Clazz;
  };

  entity.getClassesByMainType = function (componentType) {
    componentType = parseClassType(componentType);
    var result = [];
    var obj = storage[componentType.main];

    if (obj && obj[IS_CONTAINER]) {
      zrUtil.each(obj, function (o, type) {
        type !== IS_CONTAINER && result.push(o);
      });
    } else {
      result.push(obj);
    }

    return result;
  };

  entity.hasClass = function (componentType) {
    // Just consider componentType.main.
    componentType = parseClassType(componentType);
    return !!storage[componentType.main];
  };
  /**
   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
   */


  entity.getAllClassMainTypes = function () {
    var types = [];
    zrUtil.each(storage, function (obj, type) {
      types.push(type);
    });
    return types;
  };
  /**
   * If a main type is container and has sub types
   * @param  {string}  mainType
   * @return {boolean}
   */


  entity.hasSubTypes = function (componentType) {
    componentType = parseClassType(componentType);
    var obj = storage[componentType.main];
    return obj && obj[IS_CONTAINER];
  };

  entity.parseClassType = parseClassType;

  function makeContainer(componentType) {
    var container = storage[componentType.main];

    if (!container || !container[IS_CONTAINER]) {
      container = storage[componentType.main] = {};
      container[IS_CONTAINER] = true;
    }

    return container;
  }

  if (options.registerWhenExtend) {
    var originalExtend = entity.extend;

    if (originalExtend) {
      entity.extend = function (proto) {
        var ExtendedClass = originalExtend.call(this, proto);
        return entity.registerClass(ExtendedClass, proto.type);
      };
    }
  }

  return entity;
}
/**
 * @param {string|Array.<string>} properties
 */


function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
  // if (!zrUtil.isArray(properties)) {
  //     properties = properties != null ? [properties] : [];
  // }
  // zrUtil.each(properties, function (prop) {
  //     var value = obj[prop];
  //     Object.defineProperty
  //         && Object.defineProperty(obj, prop, {
  //             value: value, writable: false
  //         });
  //     zrUtil.isArray(obj[prop])
  //         && Object.freeze
  //         && Object.freeze(obj[prop]);
  // });
}

exports.set = set;
exports.get = get;
exports.hasOwn = hasOwn;
exports.parseClassType = parseClassType;
exports.enableClassExtend = enableClassExtend;
exports.enableClassManagement = enableClassManagement;
exports.setReadOnly = setReadOnly;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var PooledClass = __webpack_require__(119);

var emptyFunction = __webpack_require__(49);
var warning = __webpack_require__(25);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close.eba0eb53.png";

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PressEvent__ = __webpack_require__(862);





// inspired by react-native



function keyMirror(obj) {
    Object.keys(obj).forEach(function (k) {
        return obj[k] = k;
    });
    return obj;
}
function copy(from, list) {
    var to = {};
    list.forEach(function (k) {
        to[k] = from[k];
    });
    return to;
}
function extractSingleTouch(_nativeEvent) {
    var nativeEvent = _nativeEvent;
    if (nativeEvent.nativeEvent) {
        nativeEvent = nativeEvent.nativeEvent;
    }
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;
    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
}
/**
 * Touchable states.
 */
var States = keyMirror({
    NOT_RESPONDER: null,
    RESPONDER_INACTIVE_PRESS_IN: null,
    RESPONDER_INACTIVE_PRESS_OUT: null,
    RESPONDER_ACTIVE_PRESS_IN: null,
    RESPONDER_ACTIVE_PRESS_OUT: null,
    RESPONDER_ACTIVE_LONG_PRESS_IN: null,
    RESPONDER_ACTIVE_LONG_PRESS_OUT: null,
    ERROR: null
});
/**
 * Quick lookup map for states that are considered to be "active"
 */
var IsActive = {
    RESPONDER_ACTIVE_PRESS_OUT: true,
    RESPONDER_ACTIVE_PRESS_IN: true
};
/**
 * Quick lookup for states that are considered to be "pressing" and are
 * therefore eligible to result in a "selection" if the press stops.
 */
var IsPressingIn = {
    RESPONDER_INACTIVE_PRESS_IN: true,
    RESPONDER_ACTIVE_PRESS_IN: true,
    RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
var IsLongPressingIn = {
    RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
/**
 * Inputs to the state machine.
 */
var Signals = keyMirror({
    DELAY: null,
    RESPONDER_GRANT: null,
    RESPONDER_RELEASE: null,
    RESPONDER_TERMINATED: null,
    ENTER_PRESS_RECT: null,
    LEAVE_PRESS_RECT: null,
    LONG_PRESS_DETECTED: null
});
/**
 * Mapping from States x Signals => States
 */
var Transitions = {
    NOT_RESPONDER: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
        RESPONDER_RELEASE: States.ERROR,
        RESPONDER_TERMINATED: States.ERROR,
        ENTER_PRESS_RECT: States.ERROR,
        LEAVE_PRESS_RECT: States.ERROR,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_INACTIVE_PRESS_IN: {
        DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_INACTIVE_PRESS_OUT: {
        DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_ACTIVE_PRESS_IN: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
    },
    RESPONDER_ACTIVE_PRESS_OUT: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_ACTIVE_LONG_PRESS_IN: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
        LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
    },
    RESPONDER_ACTIVE_LONG_PRESS_OUT: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    error: {
        DELAY: States.NOT_RESPONDER,
        RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.NOT_RESPONDER,
        LEAVE_PRESS_RECT: States.NOT_RESPONDER,
        LONG_PRESS_DETECTED: States.NOT_RESPONDER
    }
};
// ==== Typical Constants for integrating into UI components ====
// const HIT_EXPAND_PX = 20;
// const HIT_VERT_OFFSET_PX = 10;
var HIGHLIGHT_DELAY_MS = 130;
var PRESS_EXPAND_PX = 20;
var LONG_PRESS_THRESHOLD = 500;
var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
var LONG_PRESS_ALLOWED_MOVEMENT = 10;
var lastClickTime = 0;
var pressDelay = 200;
function isAllowPress() {
    // avoid click penetration
    return Date.now() - lastClickTime >= pressDelay;
}

var Touchable = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Touchable, _React$Component);

    function Touchable() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Touchable);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Touchable.__proto__ || Object.getPrototypeOf(Touchable)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.callChildEvent('onTouchStart', e);
            _this.lockMouse = true;
            if (_this.releaseLockTimer) {
                clearTimeout(_this.releaseLockTimer);
            }
            _this.touchableHandleResponderGrant(e.nativeEvent);
        };
        _this.onTouchMove = function (e) {
            _this.callChildEvent('onTouchMove', e);
            _this.touchableHandleResponderMove(e.nativeEvent);
        };
        _this.onTouchEnd = function (e) {
            _this.callChildEvent('onTouchEnd', e);
            _this.releaseLockTimer = setTimeout(function () {
                _this.lockMouse = false;
            }, 300);
            _this.touchableHandleResponderRelease(new __WEBPACK_IMPORTED_MODULE_7__PressEvent__["a" /* default */](e.nativeEvent));
        };
        _this.onTouchCancel = function (e) {
            _this.callChildEvent('onTouchCancel', e);
            _this.releaseLockTimer = setTimeout(function () {
                _this.lockMouse = false;
            }, 300);
            _this.touchableHandleResponderTerminate(e.nativeEvent);
        };
        _this.onMouseDown = function (e) {
            _this.callChildEvent('onMouseDown', e);
            if (_this.lockMouse) {
                return;
            }
            _this.touchableHandleResponderGrant(e.nativeEvent);
            document.addEventListener('mousemove', _this.touchableHandleResponderMove, false);
            document.addEventListener('mouseup', _this.onMouseUp, false);
        };
        _this.onMouseUp = function (e) {
            document.removeEventListener('mousemove', _this.touchableHandleResponderMove, false);
            document.removeEventListener('mouseup', _this.onMouseUp, false);
            _this.touchableHandleResponderRelease(new __WEBPACK_IMPORTED_MODULE_7__PressEvent__["a" /* default */](e));
        };
        _this.touchableHandleResponderMove = function (e) {
            if (!_this.touchable.startMouse) {
                return;
            }
            // Measurement may not have returned yet.
            if (!_this.touchable.dimensionsOnActivate || _this.touchable.touchState === States.NOT_RESPONDER) {
                return;
            }
            // Not enough time elapsed yet, wait for highlight -
            // this is just a perf optimization.
            if (_this.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
                return;
            }
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            if (_this.pressInLocation) {
                var movedDistance = _this._getDistanceBetweenPoints(pageX, pageY, _this.pressInLocation.pageX, _this.pressInLocation.pageY);
                if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
                    _this._cancelLongPressDelayTimeout();
                }
            }
            if (_this.checkTouchWithinActive(e)) {
                _this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
                var curState = _this.touchable.touchState;
                if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
                    _this._cancelLongPressDelayTimeout();
                }
            } else {
                _this._cancelLongPressDelayTimeout();
                _this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
            }
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Touchable, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.touchable = { touchState: undefined };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.root = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.root = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
            // disabled auto clear active state
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.releaseLockTimer) {
                clearTimeout(this.releaseLockTimer);
            }
            if (this.touchableDelayTimeout) {
                clearTimeout(this.touchableDelayTimeout);
            }
            if (this.longPressDelayTimeout) {
                clearTimeout(this.longPressDelayTimeout);
            }
            if (this.pressOutDelayTimeout) {
                clearTimeout(this.pressOutDelayTimeout);
            }
        }
    }, {
        key: 'callChildEvent',
        value: function callChildEvent(event, e) {
            var childHandle = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(this.props.children).props[event];
            if (childHandle) {
                childHandle(e);
            }
        }
    }, {
        key: '_remeasureMetricsOnInit',
        value: function _remeasureMetricsOnInit(e) {
            var root = this.root;

            var touch = extractSingleTouch(e);
            var boundingRect = root.getBoundingClientRect();
            this.touchable = {
                touchState: this.touchable.touchState,
                startMouse: {
                    pageX: touch.pageX,
                    pageY: touch.pageY
                },
                positionOnGrant: {
                    left: boundingRect.left + window.pageXOffset,
                    top: boundingRect.top + window.pageYOffset,
                    width: boundingRect.width,
                    height: boundingRect.height,
                    clientLeft: boundingRect.left,
                    clientTop: boundingRect.top
                }
            };
        }
    }, {
        key: 'touchableHandleResponderGrant',
        value: function touchableHandleResponderGrant(e) {
            var _this2 = this;

            this.touchable.touchState = States.NOT_RESPONDER;
            if (this.pressOutDelayTimeout) {
                clearTimeout(this.pressOutDelayTimeout);
                this.pressOutDelayTimeout = null;
            }
            if (this.props.fixClickPenetration && !isAllowPress()) {
                return;
            }
            this._remeasureMetricsOnInit(e);
            this._receiveSignal(Signals.RESPONDER_GRANT, e);
            var _props = this.props,
                delayMS = _props.delayPressIn,
                longDelayMS = _props.delayLongPress;

            if (delayMS) {
                this.touchableDelayTimeout = setTimeout(function () {
                    _this2._handleDelay(e);
                }, delayMS);
            } else {
                this._handleDelay(e);
            }
            var longPressEvent = new __WEBPACK_IMPORTED_MODULE_7__PressEvent__["a" /* default */](e);
            this.longPressDelayTimeout = setTimeout(function () {
                _this2._handleLongDelay(longPressEvent);
            }, longDelayMS + delayMS);
        }
    }, {
        key: 'checkScroll',
        value: function checkScroll(e) {
            var positionOnGrant = this.touchable.positionOnGrant;
            // container or window scroll
            var boundingRect = this.root.getBoundingClientRect();
            if (boundingRect.left !== positionOnGrant.clientLeft || boundingRect.top !== positionOnGrant.clientTop) {
                this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
                return false;
            }
        }
    }, {
        key: 'touchableHandleResponderRelease',
        value: function touchableHandleResponderRelease(e) {
            if (!this.touchable.startMouse) {
                return;
            }
            var touch = extractSingleTouch(e);
            if (Math.abs(touch.pageX - this.touchable.startMouse.pageX) > 30 || Math.abs(touch.pageY - this.touchable.startMouse.pageY) > 30) {
                this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
                return;
            }
            if (this.checkScroll(e) === false) {
                return;
            }
            this._receiveSignal(Signals.RESPONDER_RELEASE, e);
        }
    }, {
        key: 'touchableHandleResponderTerminate',
        value: function touchableHandleResponderTerminate(e) {
            if (!this.touchable.startMouse) {
                return;
            }
            this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
        }
    }, {
        key: 'checkTouchWithinActive',
        value: function checkTouchWithinActive(e) {
            var positionOnGrant = this.touchable.positionOnGrant;
            var _props2 = this.props,
                _props2$pressRetentio = _props2.pressRetentionOffset,
                pressRetentionOffset = _props2$pressRetentio === undefined ? {} : _props2$pressRetentio,
                hitSlop = _props2.hitSlop;

            var pressExpandLeft = pressRetentionOffset.left;
            var pressExpandTop = pressRetentionOffset.top;
            var pressExpandRight = pressRetentionOffset.right;
            var pressExpandBottom = pressRetentionOffset.bottom;
            if (hitSlop) {
                pressExpandLeft += hitSlop.left;
                pressExpandTop += hitSlop.top;
                pressExpandRight += hitSlop.right;
                pressExpandBottom += hitSlop.bottom;
            }
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            return pageX > positionOnGrant.left - pressExpandLeft && pageY > positionOnGrant.top - pressExpandTop && pageX < positionOnGrant.left + positionOnGrant.width + pressExpandRight && pageY < positionOnGrant.top + positionOnGrant.height + pressExpandBottom;
        }
    }, {
        key: 'callProp',
        value: function callProp(name, e) {
            if (this.props[name] && !this.props.disabled) {
                this.props[name](e);
            }
        }
    }, {
        key: 'touchableHandleActivePressIn',
        value: function touchableHandleActivePressIn(e) {
            this.setActive(true);
            this.callProp('onPressIn', e);
        }
    }, {
        key: 'touchableHandleActivePressOut',
        value: function touchableHandleActivePressOut(e) {
            this.setActive(false);
            this.callProp('onPressOut', e);
        }
    }, {
        key: 'touchableHandlePress',
        value: function touchableHandlePress(e) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__PressEvent__["b" /* shouldFirePress */])(e)) {
                this.callProp('onPress', e);
            }
            lastClickTime = Date.now();
        }
    }, {
        key: 'touchableHandleLongPress',
        value: function touchableHandleLongPress(e) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__PressEvent__["b" /* shouldFirePress */])(e)) {
                this.callProp('onLongPress', e);
            }
        }
    }, {
        key: 'setActive',
        value: function setActive(active) {
            if (this.props.activeClassName || this.props.activeStyle) {
                this.setState({
                    active: active
                });
            }
        }
    }, {
        key: '_remeasureMetricsOnActivation',
        value: function _remeasureMetricsOnActivation() {
            this.touchable.dimensionsOnActivate = this.touchable.positionOnGrant;
        }
    }, {
        key: '_handleDelay',
        value: function _handleDelay(e) {
            this.touchableDelayTimeout = null;
            this._receiveSignal(Signals.DELAY, e);
        }
    }, {
        key: '_handleLongDelay',
        value: function _handleLongDelay(e) {
            this.longPressDelayTimeout = null;
            var curState = this.touchable.touchState;
            if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
                console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
            } else {
                this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
            }
        }
    }, {
        key: '_receiveSignal',
        value: function _receiveSignal(signal, e) {
            var curState = this.touchable.touchState;
            var nextState = Transitions[curState] && Transitions[curState][signal];
            if (!nextState) {
                return;
            }
            if (nextState === States.ERROR) {
                return;
            }
            if (curState !== nextState) {
                this._performSideEffectsForTransition(curState, nextState, signal, e);
                this.touchable.touchState = nextState;
            }
        }
    }, {
        key: '_cancelLongPressDelayTimeout',
        value: function _cancelLongPressDelayTimeout() {
            if (this.longPressDelayTimeout) {
                clearTimeout(this.longPressDelayTimeout);
                this.longPressDelayTimeout = null;
            }
        }
    }, {
        key: '_isHighlight',
        value: function _isHighlight(state) {
            return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
        }
    }, {
        key: '_savePressInLocation',
        value: function _savePressInLocation(e) {
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            this.pressInLocation = { pageX: pageX, pageY: pageY };
        }
    }, {
        key: '_getDistanceBetweenPoints',
        value: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
            var deltaX = aX - bX;
            var deltaY = aY - bY;
            return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        }
    }, {
        key: '_performSideEffectsForTransition',
        value: function _performSideEffectsForTransition(curState, nextState, signal, e) {
            var curIsHighlight = this._isHighlight(curState);
            var newIsHighlight = this._isHighlight(nextState);
            var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;
            if (isFinalSignal) {
                this._cancelLongPressDelayTimeout();
            }
            if (!IsActive[curState] && IsActive[nextState]) {
                this._remeasureMetricsOnActivation();
            }
            if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
                this.touchableHandleLongPress(e);
            }
            if (newIsHighlight && !curIsHighlight) {
                this._startHighlight(e);
            } else if (!newIsHighlight && curIsHighlight) {
                this._endHighlight(e);
            }
            if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
                var hasLongPressHandler = !!this.props.onLongPress;
                var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && (!hasLongPressHandler || !this.props.longPressCancelsPress // or we're told to ignore it.
                );
                var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
                if (shouldInvokePress) {
                    if (!newIsHighlight && !curIsHighlight) {
                        // we never highlighted because of delay, but we should highlight now
                        this._startHighlight(e);
                        this._endHighlight(e);
                    }
                    this.touchableHandlePress(e);
                }
            }
            if (this.touchableDelayTimeout) {
                clearTimeout(this.touchableDelayTimeout);
                this.touchableDelayTimeout = null;
            }
        }
    }, {
        key: '_startHighlight',
        value: function _startHighlight(e) {
            this._savePressInLocation(e);
            this.touchableHandleActivePressIn(e);
        }
    }, {
        key: '_endHighlight',
        value: function _endHighlight(e) {
            var _this3 = this;

            if (this.props.delayPressOut) {
                this.pressOutDelayTimeout = setTimeout(function () {
                    _this3.touchableHandleActivePressOut(e);
                }, this.props.delayPressOut);
            } else {
                this.touchableHandleActivePressOut(e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                children = _props3.children,
                disabled = _props3.disabled,
                activeStyle = _props3.activeStyle,
                activeClassName = _props3.activeClassName;

            var events = disabled ? undefined : copy(this, ['onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel', 'onMouseDown']);
            var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle) {
                    style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeStyle);
                }
                if (activeClassName) {
                    if (className) {
                        className += ' ' + activeClassName;
                    } else {
                        className = activeClassName;
                    }
                }
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, events);
        }
    }]);

    return Touchable;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (Touchable);

Touchable.defaultProps = {
    fixClickPenetration: false,
    disabled: false,
    delayPressIn: HIGHLIGHT_DELAY_MS,
    delayLongPress: LONG_PRESS_DELAY_MS,
    delayPressOut: 100,
    pressRetentionOffset: {
        left: PRESS_EXPAND_PX,
        right: PRESS_EXPAND_PX,
        top: PRESS_EXPAND_PX,
        bottom: PRESS_EXPAND_PX
    },
    hitSlop: undefined,
    longPressCancelsPress: true
};

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export verifiedUserInfo */
/* unused harmony export unVerifiedUserInfo */
/* unused harmony export uploadPrivateData */
/* unused harmony export checkPrivate */
/* unused harmony export checkPrivateZg */
/* unused harmony export userIsPrivate */
/* unused harmony export userIsPrivateZg */
/* unused harmony export bankType */
/* unused harmony export checkNumber */
/* unused harmony export checkSuccessData */
/* unused harmony export certifcationSuccess */
/* unused harmony export userJob */
/* unused harmony export provinceCity */
/* unused harmony export checkPrivateData */
/* unused harmony export getUploadPrivateData */
/* unused harmony export updateUnUserInfo */
/* harmony export (immutable) */ __webpack_exports__["n"] = saveUserAccount;
/* harmony export (immutable) */ __webpack_exports__["m"] = getConversationIds;
/* harmony export (immutable) */ __webpack_exports__["l"] = uploadCertificatePic;
/* unused harmony export updateUserInfo */
/* harmony export (immutable) */ __webpack_exports__["h"] = getCardByHqt;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCardByHqtOpen;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCardListByCf;
/* harmony export (immutable) */ __webpack_exports__["e"] = addCardByHqtPost;
/* harmony export (immutable) */ __webpack_exports__["d"] = addCardByHqtOk;
/* harmony export (immutable) */ __webpack_exports__["c"] = addCardByHqtFinish;
/* unused harmony export addCardByHqtOpenFinish */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hqtExist; });
/* harmony export (immutable) */ __webpack_exports__["a"] = findCamcHqtExist;
/* unused harmony export getCwimUserHqtCard */
/* harmony export (immutable) */ __webpack_exports__["j"] = modifyUserAccount;
/* harmony export (immutable) */ __webpack_exports__["i"] = modifyTaxInfo;
/* unused harmony export shAlert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return htqAddCardNum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







//实名个人信息
function verifiedUserInfo(text) {
  return {
    type: "VERIFIEDUSERINFO",
    text: text
  };
}

//未实名个人信息
function unVerifiedUserInfo(text) {
  return {
    type: "UNVERIFIEDUSERINFO",
    text: text
  };
}

//上传私募投资资料
function uploadPrivateData(text) {
  return {
    type: "UPLOAD_PRIVATE_DATA",
    text: text
  };
}
//私募投资者资料上传情况
function checkPrivate(text) {
  return {
    type: "CHECK_PRIVATE",
    text: text
  };
}
//私募投资者资料上传情况（资管）
function checkPrivateZg(text) {
  return {
    type: "CHECK_PRIVATE_ZG",
    text: text
  };
}

//私募投资者状态
function userIsPrivate(text) {
  return {
    type: "USER_IS_PRIVATE",
    text: text
  };
}
//私募投资者状态(资管)
function userIsPrivateZg(text) {
  return {
    type: "USER_IS_PRIVATE_ZG",
    text: text
  };
}

//银行卡类型
function bankType(text) {
  return {
    type: "BANK_TYPE",
    text: text
  };
}

//获取流水号
function checkNumber(text) {
  return {
    type: "CHECK_NUMBER",
    text: text
  };
}
//鉴权确认
function checkSuccessData(text) {
  return {
    type: "CHECK_SUCCESS_DATA",
    text: text
  };
}

//实名认证创建交易账号
function certifcationSuccess(text) {
  return {
    type: "CERTIFCATION_SUCCESS",
    text: text
  };
}
//实名认证职业列表
function userJob(text) {
  return {
    type: "USER_JOB",
    text: text
  };
}

//实名认证城市列表
function provinceCity(text) {
  return {
    type: "PROVINCE_CITY",
    text: text
  };
}
//投资者资料审核情况
function checkPrivateData(type) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null) {
        token = "";
      }
      fetch(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/account/validateHasUploadFile?token=" + token + "&provedType=" + type).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        if (responseText.code == "0000") {
          if (type == "0") {
            dispatch(checkPrivate(responseText.content));
          } else {
            dispatch(checkPrivateZg(responseText.content));
          }
          console.log("投资者资料审核情况");
          console.log(responseText);
        } else {
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, 2);
        }
      }).catch(function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("网络异常，请检查您的网络", 2);
      });
    });
  };
}

//上传私募投资者资料
function getUploadPrivateData(files, callback, type) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null) {
        token = "";
      }
      fetch(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/asset/account/uploadAssetProved?token=" + token + "&provedType=" + type, {
        mode: "cors",
        method: 'POST',
        body: files
      }).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        if (responseText.code == "0000") {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
          dispatch(uploadPrivateData(responseText));
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("上传成功，请等待审核", 2);
          if (type == "0") {
            dispatch(checkPrivate(false));
            console.log("上传私募投资者资料");
          } else {
            dispatch(checkPrivateZg(false));
            console.log("上传私募资管投资者资料");
          }
          dispatch(checkPrivateData(type));
          __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
          console.log("上传私募投资者资料");
          console.log(responseText);
          if (callback) {
            callback;
          }
        } else {
          console.log(responseText.code);
          // Toast.info( responseText.code, 2);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code);
        }
      }).catch(function (err) {
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("网络异常，请检查您的网络", 1);
      });
    });
  };
}

//编辑虚拟用户个人信息
function updateUnUserInfo(thisO, nickName) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null) {
        token = "";
      }
      fetch(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/account/modifyNickName?newNickName=" + nickName + "&token=" + token).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        if (responseText.code == "0000") {
          // dispatch(provinceCity(responseText.content));
          console.log("编辑虚拟用户个人信息");
          console.log(responseText);
        } else {
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
          thisO.setState({
            flag: false
          });
        }
      }).catch(function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("网络异常,请检查您的网络", __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        thisO.getState({
          flag: false
        });
      });
    });
  };
}

//保存控制人受益人身份证信息
function saveUserAccount(params) {
  return function (dispatch, getState) {
    console.log(params);
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/modifyUserAccountInfo", params, function (res) {
      console.log(res);
      if (res.code == "0000") {} else {}
    }, function (error) {
      console.log(error);
    });
  };
}

//获取控制人受益人上传id
function getConversationIds(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      // params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/certificate/getConversationIds", params, function (responseText) {
        if (responseText.code == "0000") {
          console.log(responseText);
          callback(responseText);
        } else {
          console.log(responseText);
          errBack();
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code);
        }
      }, function (err) {
        errBack();
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
    });
  };
}

//上传身份证图片
function uploadCertificatePic(data, callback, errBack, flag, RoleVal) {
  return function (dispatch, getState) {
    data.append("accountRole", RoleVal);
    console.log(data);
    fetch(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/certificate/uploadCertificatePicAml", {
      mode: "cors",
      method: 'POST',
      body: data
    }).then(function (response) {
      return response.json();
    }).then(function (responseText) {
      console.log(responseText);
      if (flag) {
        if (responseText.code == "0000") {
          callback(responseText);
          console.log(responseText);
        } else {
          errBack();
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, 2);
          console.log(responseText.code);
        }
      } else {
        if (responseText) {
          var isjson = (typeof responseText === 'undefined' ? 'undefined' : _typeof(responseText)) == "object" && Object.prototype.toString.call(responseText).toLowerCase() == "[object object]" && !responseText.length;
          if (isjson) {
            if (responseText.code == "0000") {
              if (responseText.content && responseText.content.requestId) {
                callback(responseText);
                console.log(responseText);
              } else {
                //非法篡改requestId
                errBack();
                __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("上传身份证照片失败,请重新上传", 2);
              }
            } else {
              errBack();
              __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, 2);
              console.log(responseText.code);
            }
          } else {
            //非法篡改requestId
            errBack();
            __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("上传身份证照片失败,请重新上传", 2);
          }
        } else {
          //非法篡改requestId
          errBack();
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("上传身份证照片失败,请重新上传", 2);
        }
      }
    }).catch(function (err) {
      errBack();
      console.log(err);
    });
  };
}

//编辑实名用户个人信息
function updateUserInfo(thisO, params, data) {
  console.log("+++++");
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])("shortToken").then(function (token) {
      if (token == null) {
        token = "";
      }
      fetch(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/account/modifyAccountInfo?" + params + "=" + data + "&token=" + token).then(function (response) {
        return response.json();
      }).then(function (responseText) {
        if (responseText.code == "0000") {
          // dispatch(provinceCity(responseText.content));
          console.log("编辑实名用户个人信息");
          console.log(responseText);
        } else {
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
          thisO.setState({
            flag: false
          });
        }
      }).catch(function (err) {
        console.log("错误信息" + err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("网络异常,请检查您的网络", __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        thisO.getState({
          flag: false
        });
      });
    });
  };
}

//活期通打通
//获取用户可开通活期通的银行卡列表
function getCardByHqt(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/findOtsOpenPaymentChannelList", params, function (responseText) {
        if (responseText.code == "0000") {
          var newData = responseText.content;
          for (var i = 0; i < newData.length; i++) {
            if (newData[i].bankCode == "007" && newData[i].paymentChannelId == "G000") {
              newData.splice(i, 1);
            }
          }
          callback(newData);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

//获取用户活期通开户的银行卡列表
function getCardByHqtOpen(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/openAccountBankList", params, function (responseText) {
        if (responseText.code == "0000") {
          var newData = responseText.content;
          for (var i = 0; i < newData.length; i++) {
            if (newData[i].bankCode == "007" && newData[i].paymentChannelId == "G000") {
              newData.splice(i, 1);
            }
          }
          callback(newData);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

//获取用户在财富的银行卡列表
function getCardListByCf(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/paymentaccount/getCardList", params, function (responseText) {
        if (responseText.code == "0000") {
          callback(responseText.content.bankCard);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

//活期通加卡鉴权申请
function addCardByHqtPost(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/otsAuthApplyRequest", params, function (responseText) {
        if (responseText.code == "0000") {
          callback(responseText.content);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

//活期通加卡鉴权确认
function addCardByHqtOk(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/otsAuthConfirm", params, function (responseText) {
        if (responseText.code == "0000") {
          callback(responseText.content);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

//活期通加卡成功
function addCardByHqtFinish(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/otsAddCardRequest", params, function (responseText) {
        if (responseText.code == "0000") {
          callback(responseText.content);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

//活期通开户加卡
function addCardByHqtOpenFinish(params, callback, errBack) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/openOtsAccount", params, function (responseText) {
        if (responseText.code == "0000") {
          callback(responseText.content);
          console.log(responseText);
        } else {
          errBack();
          console.log(responseText.code);
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(responseText.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (err) {
        errBack();
        console.log(err);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    }).catch(function (err) {
      errBack();
      console.log(err);
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

/*查询华夏基金用户是否存在以及获取用户信息/api/camchqtaccount/findCamcHqtExist*/
var hqtExist = function hqtExist(text) {
  return {
    type: 'HQT_EXIST',
    text: text
  };
};

function findCamcHqtExist(data, callback) {
  return function (dispatch, getState) {
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/findCamcHqtExists", data, function (data) {
      if (data.code == "0000") {
        dispatch(hqtExist(data.content));
        console.log(data, "查询华夏基金用户是否存在以及获取用户信息");
        if (callback) {
          callback(data.content);
        }
      } else {
        // _this.setState({
        //   loadingFlag: false
        // })
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(data.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      }
    }, function (error) {
      // _this.setState({
      //     loadingFlag: false
      // })
      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
    });
  };
}

/*/获取华夏财富活期通列表的接口 api/trade/getCwimUserHqtCard*/
var getCwimUserHqtCard = function getCwimUserHqtCard(data) {
  console.log(data, "dafafdf");
  return new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/trade/getCwimUserHqtCard", data, function (result) {
      if (result.code === '0000' && result.content) {
        resolve(result.content);
      } else {
        resolve([]);
      }
    }, function (error) {
      reject('1111');
    });
  });
};

/*修改反洗钱信息 /api/camchqtaccount/modifyUserAccountInfo */
function modifyUserAccount(params, callback) {
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;
      console.log(params, '反洗钱信息');
      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/modifyUserAccountInfo", params, function (res) {
        console.log(data, 'datadatadata');
        if (res.code == "0000") {
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("添加反洗钱信息成功", __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
          if (callback) {
            callback(res);
          }
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["b" /* getUserInfoList */])());
        } else {
          // _this.setState({
          //   loadingFlag: false
          // })
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(data.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (error) {
        // _this.setState({
        //     loadingFlag: false
        // })
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    });
  };
}
/*/api/camchqtaccount/modifyTaxInfo 修改税收信息*/
function modifyTaxInfo(params, _this, callback) {
  console.log(params, '修改税收信息');
  return function (dispatch, getState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_js__["b" /* getTempInfo */])('shortToken').then(function (data) {
      params.token = data;

      __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.url + "/api/camchqtaccount/modifyTaxInfo", params, function (res) {
        console.log(data, 'datadatadata');
        if (res.code == "0000") {
          if (callback) {
            callback(res.content);
          }
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__loginAction_js__["b" /* getUserInfoList */])());
        } else {
          _this.setState({
            flag: false
          });
          __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(res.message, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function (error) {
        _this.setState({
          flag: false
        });
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.errorTxt, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      });
    });
  };
}

/*h5存数据*/
var shAlert = function shAlert(text) {
  return {
    type: 'SH_ALERT_CONTENT',
    text: text
  };
};
/*活期通加卡存卡号*/
var htqAddCardNum = function htqAddCardNum(text) {
  return {
    type: 'HQT_ADDCARD_NUM',
    text: text
  };
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(99)
  , core      = __webpack_require__(60)
  , ctx       = __webpack_require__(282)
  , hide      = __webpack_require__(134)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(132)
  , IE8_DOM_DEFINE = __webpack_require__(451)
  , toPrimitive    = __webpack_require__(293)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(114) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(452)
  , defined = __webpack_require__(283);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Model = __webpack_require__(70);

var componentUtil = __webpack_require__(304);

var clazzUtil = __webpack_require__(92);

var layout = __webpack_require__(103);

var boxLayoutMixin = __webpack_require__(1083);

/**
 * Component model
 *
 * @module echarts/model/Component
 */
var arrayPush = Array.prototype.push;
/**
 * @alias module:echarts/model/Component
 * @constructor
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {module:echarts/model/Model} ecModel
 */

var ComponentModel = Model.extend({
  type: 'component',

  /**
   * @readOnly
   * @type {string}
   */
  id: '',

  /**
   * @readOnly
   */
  name: '',

  /**
   * @readOnly
   * @type {string}
   */
  mainType: '',

  /**
   * @readOnly
   * @type {string}
   */
  subType: '',

  /**
   * @readOnly
   * @type {number}
   */
  componentIndex: 0,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * @type {module:echarts/model/Global}
   * @readOnly
   */
  ecModel: null,

  /**
   * key: componentType
   * value:  Component model list, can not be null.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @readOnly
   */
  dependentModels: [],

  /**
   * @type {string}
   * @readOnly
   */
  uid: null,

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  $constructor: function (option, parentModel, ecModel, extraOpt) {
    Model.call(this, option, parentModel, ecModel, extraOpt);
    this.uid = componentUtil.getUID('componentModel');
  },
  init: function (option, parentModel, ecModel, extraOpt) {
    this.mergeDefaultAndTheme(option, ecModel);
  },
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
    var themeModel = ecModel.getTheme();
    zrUtil.merge(option, themeModel.get(this.mainType));
    zrUtil.merge(option, this.getDefaultOption());

    if (layoutMode) {
      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (option, extraOpt) {
    zrUtil.merge(this.option, option, true);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      layout.mergeLayoutParam(this.option, option, layoutMode);
    }
  },
  // Hooker after init or mergeOption
  optionUpdated: function (newCptOption, isInit) {},
  getDefaultOption: function () {
    if (!clazzUtil.hasOwn(this, '__defaultOption')) {
      var optList = [];
      var Class = this.constructor;

      while (Class) {
        var opt = Class.prototype.defaultOption;
        opt && optList.push(opt);
        Class = Class.superClass;
      }

      var defaultOption = {};

      for (var i = optList.length - 1; i >= 0; i--) {
        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
      }

      clazzUtil.set(this, '__defaultOption', defaultOption);
    }

    return clazzUtil.get(this, '__defaultOption');
  },
  getReferringComponents: function (mainType) {
    return this.ecModel.queryComponents({
      mainType: mainType,
      index: this.get(mainType + 'Index', true),
      id: this.get(mainType + 'Id', true)
    });
  }
}); // Reset ComponentModel.extend, add preConstruct.
// clazzUtil.enableClassExtend(
//     ComponentModel,
//     function (option, parentModel, ecModel, extraOpt) {
//         // Set dependentModels, componentIndex, name, id, mainType, subType.
//         zrUtil.extend(this, extraOpt);
//         this.uid = componentUtil.getUID('componentModel');
//         // this.setReadOnly([
//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
//         //     'dependentModels', 'componentIndex'
//         // ]);
//     }
// );
// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(ComponentModel, {
  registerWhenExtend: true
});
componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.

componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);

function getDependencies(componentType) {
  var deps = [];
  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
    arrayPush.apply(deps, Clazz.prototype.dependencies || []);
  }); // Ensure main type

  return zrUtil.map(deps, function (type) {
    return clazzUtil.parseClassType(type).main;
  });
}

zrUtil.mixin(ComponentModel, boxLayoutMixin);
var _default = ComponentModel;
module.exports = _default;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var BoundingRect = __webpack_require__(63);

var _number = __webpack_require__(48);

var parsePercent = _number.parsePercent;

var formatUtil = __webpack_require__(71);

// Layout helpers for each component positioning
var each = zrUtil.each;
/**
 * @public
 */

var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
/**
 * @public
 */

var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];

function boxLayout(orient, group, gap, maxWidth, maxHeight) {
  var x = 0;
  var y = 0;

  if (maxWidth == null) {
    maxWidth = Infinity;
  }

  if (maxHeight == null) {
    maxHeight = Infinity;
  }

  var currentLineMaxSize = 0;
  group.eachChild(function (child, idx) {
    var position = child.position;
    var rect = child.getBoundingRect();
    var nextChild = group.childAt(idx + 1);
    var nextChildRect = nextChild && nextChild.getBoundingRect();
    var nextX;
    var nextY;

    if (orient === 'horizontal') {
      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
      // FIXME compare before adding gap?

      if (nextX > maxWidth || child.newline) {
        x = 0;
        nextX = moveX;
        y += currentLineMaxSize + gap;
        currentLineMaxSize = rect.height;
      } else {
        // FIXME: consider rect.y is not `0`?
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
      }
    } else {
      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group

      if (nextY > maxHeight || child.newline) {
        x += currentLineMaxSize + gap;
        y = 0;
        nextY = moveY;
        currentLineMaxSize = rect.width;
      } else {
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
      }
    }

    if (child.newline) {
      return;
    }

    position[0] = x;
    position[1] = y;
    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
  });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */


var box = boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var vbox = zrUtil.curry(boxLayout, 'vertical');
/**
 * HBox layouting
 * @param {module:zrender/container/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var hbox = zrUtil.curry(boxLayout, 'horizontal');
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.x]
 * @param {number|string} [positionInfo.y]
 * @param {number|string} [positionInfo.x2]
 * @param {number|string} [positionInfo.y2]
 * @param {Object} containerRect {width, height}
 * @param {string|number} margin
 * @return {Object} {width, height}
 */

function getAvailableSize(positionInfo, containerRect, margin) {
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var x = parsePercent(positionInfo.x, containerWidth);
  var y = parsePercent(positionInfo.y, containerHeight);
  var x2 = parsePercent(positionInfo.x2, containerWidth);
  var y2 = parsePercent(positionInfo.y2, containerHeight);
  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
  margin = formatUtil.normalizeCssArray(margin || 0);
  return {
    width: Math.max(x2 - x - margin[1] - margin[3], 0),
    height: Math.max(y2 - y - margin[0] - margin[2], 0)
  };
}
/**
 * Parse position info.
 *
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width]
 * @param {number|string} [positionInfo.height]
 * @param {number|string} [positionInfo.aspect] Aspect is width / height
 * @param {Object} containerRect
 * @param {string|number} [margin]
 *
 * @return {module:zrender/core/BoundingRect}
 */


function getLayoutRect(positionInfo, containerRect, margin) {
  margin = formatUtil.normalizeCssArray(margin || 0);
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var left = parsePercent(positionInfo.left, containerWidth);
  var top = parsePercent(positionInfo.top, containerHeight);
  var right = parsePercent(positionInfo.right, containerWidth);
  var bottom = parsePercent(positionInfo.bottom, containerHeight);
  var width = parsePercent(positionInfo.width, containerWidth);
  var height = parsePercent(positionInfo.height, containerHeight);
  var verticalMargin = margin[2] + margin[0];
  var horizontalMargin = margin[1] + margin[3];
  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right

  if (isNaN(width)) {
    width = containerWidth - right - horizontalMargin - left;
  }

  if (isNaN(height)) {
    height = containerHeight - bottom - verticalMargin - top;
  }

  if (aspect != null) {
    // If width and height are not given
    // 1. Graph should not exceeds the container
    // 2. Aspect must be keeped
    // 3. Graph should take the space as more as possible
    // FIXME
    // Margin is not considered, because there is no case that both
    // using margin and aspect so far.
    if (isNaN(width) && isNaN(height)) {
      if (aspect > containerWidth / containerHeight) {
        width = containerWidth * 0.8;
      } else {
        height = containerHeight * 0.8;
      }
    } // Calculate width or height with given aspect


    if (isNaN(width)) {
      width = aspect * height;
    }

    if (isNaN(height)) {
      height = width / aspect;
    }
  } // If left is not specified, calculate left from right and width


  if (isNaN(left)) {
    left = containerWidth - right - width - horizontalMargin;
  }

  if (isNaN(top)) {
    top = containerHeight - bottom - height - verticalMargin;
  } // Align left and top


  switch (positionInfo.left || positionInfo.right) {
    case 'center':
      left = containerWidth / 2 - width / 2 - margin[3];
      break;

    case 'right':
      left = containerWidth - width - horizontalMargin;
      break;
  }

  switch (positionInfo.top || positionInfo.bottom) {
    case 'middle':
    case 'center':
      top = containerHeight / 2 - height / 2 - margin[0];
      break;

    case 'bottom':
      top = containerHeight - height - verticalMargin;
      break;
  } // If something is wrong and left, top, width, height are calculated as NaN


  left = left || 0;
  top = top || 0;

  if (isNaN(width)) {
    // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
  }

  if (isNaN(height)) {
    // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
  }

  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
  rect.margin = margin;
  return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Traslate (with el.position by this method)
 * So this method only fixes the last step 'Traslate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatly with the same input el, the same result will be gotten.
 *
 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
 * @param {Object} positionInfo
 * @param {number|string} [positionInfo.left]
 * @param {number|string} [positionInfo.top]
 * @param {number|string} [positionInfo.right]
 * @param {number|string} [positionInfo.bottom]
 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
 * @param {Object} containerRect
 * @param {string|number} margin
 * @param {Object} [opt]
 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
 * @param {Array.<number>} [opt.boundingMode='all']
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */


function positionElement(el, positionInfo, containerRect, margin, opt) {
  var h = !opt || !opt.hv || opt.hv[0];
  var v = !opt || !opt.hv || opt.hv[1];
  var boundingMode = opt && opt.boundingMode || 'all';

  if (!h && !v) {
    return;
  }

  var rect;

  if (boundingMode === 'raw') {
    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
  } else {
    rect = el.getBoundingRect();

    if (el.needLocalTransform()) {
      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
      // which should not be modified.

      rect = rect.clone();
      rect.applyTransform(transform);
    }
  } // The real width and height can not be specified but calculated by the given el.


  positionInfo = getLayoutRect(zrUtil.defaults({
    width: rect.width,
    height: rect.height
  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
  // (see zrender/core/Transformable#getLocalTransfrom),
  // we can just only modify el.position to get final result.

  var elPos = el.position;
  var dx = h ? positionInfo.x - rect.x : 0;
  var dy = v ? positionInfo.y - rect.y : 0;
  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
}
/**
 * @param {Object} option Contains some of the properties in HV_NAMES.
 * @param {number} hvIdx 0: horizontal; 1: vertical.
 */


function sizeCalculable(option, hvIdx) {
  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
}
/**
 * Consider Case:
 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         var inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param {Object} targetOption
 * @param {Object} newOption
 * @param {Object|string} [opt]
 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
 *  that width (or height) should not be calculated by left and right (or top and bottom).
 */


function mergeLayoutParam(targetOption, newOption, opt) {
  !zrUtil.isObject(opt) && (opt = {});
  var ignoreSize = opt.ignoreSize;
  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
  var hResult = merge(HV_NAMES[0], 0);
  var vResult = merge(HV_NAMES[1], 1);
  copy(HV_NAMES[0], targetOption, hResult);
  copy(HV_NAMES[1], targetOption, vResult);

  function merge(names, hvIdx) {
    var newParams = {};
    var newValueCount = 0;
    var merged = {};
    var mergedValueCount = 0;
    var enoughParamNumber = 2;
    each(names, function (name) {
      merged[name] = targetOption[name];
    });
    each(names, function (name) {
      // Consider case: newOption.width is null, which is
      // set by user for removing width setting.
      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
      hasValue(newParams, name) && newValueCount++;
      hasValue(merged, name) && mergedValueCount++;
    });

    if (ignoreSize[hvIdx]) {
      // Only one of left/right is premitted to exist.
      if (hasValue(newOption, names[1])) {
        merged[names[2]] = null;
      } else if (hasValue(newOption, names[2])) {
        merged[names[1]] = null;
      }

      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // or targetOption: {right: ...} and newOption: {width: ...},
    // There is no conflict when merged only has params count
    // little than enoughParamNumber.


    if (mergedValueCount === enoughParamNumber || !newValueCount) {
      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // Than we can make sure user only want those two, and ignore
    // all origin params in targetOption.
    else if (newValueCount >= enoughParamNumber) {
        return newParams;
      } else {
        // Chose another param from targetOption by priority.
        for (var i = 0; i < names.length; i++) {
          var name = names[i];

          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
            newParams[name] = targetOption[name];
            break;
          }
        }

        return newParams;
      }
  }

  function hasProp(obj, name) {
    return obj.hasOwnProperty(name);
  }

  function hasValue(obj, name) {
    return obj[name] != null && obj[name] !== 'auto';
  }

  function copy(names, target, source) {
    each(names, function (name) {
      target[name] = source[name];
    });
  }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function getLayoutParams(source) {
  return copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */


function copyLayoutParams(target, source) {
  source && target && each(LOCATION_PARAMS, function (name) {
    source.hasOwnProperty(name) && (target[name] = source[name]);
  });
  return target;
}

exports.LOCATION_PARAMS = LOCATION_PARAMS;
exports.HV_NAMES = HV_NAMES;
exports.box = box;
exports.vbox = vbox;
exports.hbox = hbox;
exports.getAvailableSize = getAvailableSize;
exports.getLayoutRect = getLayoutRect;
exports.positionElement = positionElement;
exports.sizeCalculable = sizeCalculable;
exports.mergeLayoutParam = mergeLayoutParam;
exports.getLayoutParams = getLayoutParams;
exports.copyLayoutParams = copyLayoutParams;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1380);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(590);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 109 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/password_hide.10a224a6.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/password_unhide.16264817.png";

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(63);

var imageHelper = __webpack_require__(400);

var _util = __webpack_require__(6);

var getContext = _util.getContext;
var extend = _util.extend;
var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var textWidthCache = {};
var textWidthCacheCounter = 0;
var TEXT_CACHE_MAX = 5000;
var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.

var methods = {};

function $override(name, fn) {
  methods[name] = fn;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {number} width
 */


function getWidth(text, font) {
  font = font || DEFAULT_FONT;
  var key = text + ':' + font;

  if (textWidthCache[key]) {
    return textWidthCache[key];
  }

  var textLines = (text + '').split('\n');
  var width = 0;

  for (var i = 0, l = textLines.length; i < l; i++) {
    // textContain.measureText may be overrided in SVG or VML
    width = Math.max(measureText(textLines[i], font).width, width);
  }

  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
    textWidthCacheCounter = 0;
    textWidthCache = {};
  }

  textWidthCacheCounter++;
  textWidthCache[key] = width;
  return width;
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {string} [textAlign='left']
 * @param {string} [textVerticalAlign='top']
 * @param {Array.<number>} [textPadding]
 * @param {Object} [rich]
 * @param {Object} [truncate]
 * @return {Object} {x, y, width, height, lineHeight}
 */


function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) {
  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, truncate);
}

function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, truncate) {
  var contentBlock = parsePlainText(text, font, textPadding, truncate);
  var outerWidth = getWidth(text, font);

  if (textPadding) {
    outerWidth += textPadding[1] + textPadding[3];
  }

  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
  rect.lineHeight = contentBlock.lineHeight;
  return rect;
}

function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate) {
  var contentBlock = parseRichText(text, {
    rich: rich,
    truncate: truncate,
    font: font,
    textAlign: textAlign,
    textPadding: textPadding
  });
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var x = adjustTextX(0, outerWidth, textAlign);
  var y = adjustTextY(0, outerHeight, textVerticalAlign);
  return new BoundingRect(x, y, outerWidth, outerHeight);
}
/**
 * @public
 * @param {number} x
 * @param {number} width
 * @param {string} [textAlign='left']
 * @return {number} Adjusted x.
 */


function adjustTextX(x, width, textAlign) {
  // FIXME Right to left language
  if (textAlign === 'right') {
    x -= width;
  } else if (textAlign === 'center') {
    x -= width / 2;
  }

  return x;
}
/**
 * @public
 * @param {number} y
 * @param {number} height
 * @param {string} [textVerticalAlign='top']
 * @return {number} Adjusted y.
 */


function adjustTextY(y, height, textVerticalAlign) {
  if (textVerticalAlign === 'middle') {
    y -= height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y -= height;
  }

  return y;
}
/**
 * @public
 * @param {stirng} textPosition
 * @param {Object} rect {x, y, width, height}
 * @param {number} distance
 * @return {Object} {x, y, textAlign, textVerticalAlign}
 */


function adjustTextPositionOnRect(textPosition, rect, distance) {
  var x = rect.x;
  var y = rect.y;
  var height = rect.height;
  var width = rect.width;
  var halfHeight = height / 2;
  var textAlign = 'left';
  var textVerticalAlign = 'top';

  switch (textPosition) {
    case 'left':
      x -= distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'right':
      x += distance + width;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'top':
      x += width / 2;
      y -= distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'bottom':
      x += width / 2;
      y += height + distance;
      textAlign = 'center';
      break;

    case 'inside':
      x += width / 2;
      y += halfHeight;
      textAlign = 'center';
      textVerticalAlign = 'middle';
      break;

    case 'insideLeft':
      x += distance;
      y += halfHeight;
      textVerticalAlign = 'middle';
      break;

    case 'insideRight':
      x += width - distance;
      y += halfHeight;
      textAlign = 'right';
      textVerticalAlign = 'middle';
      break;

    case 'insideTop':
      x += width / 2;
      y += distance;
      textAlign = 'center';
      break;

    case 'insideBottom':
      x += width / 2;
      y += height - distance;
      textAlign = 'center';
      textVerticalAlign = 'bottom';
      break;

    case 'insideTopLeft':
      x += distance;
      y += distance;
      break;

    case 'insideTopRight':
      x += width - distance;
      y += distance;
      textAlign = 'right';
      break;

    case 'insideBottomLeft':
      x += distance;
      y += height - distance;
      textVerticalAlign = 'bottom';
      break;

    case 'insideBottomRight':
      x += width - distance;
      y += height - distance;
      textAlign = 'right';
      textVerticalAlign = 'bottom';
      break;
  }

  return {
    x: x,
    y: y,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}
/**
 * Show ellipsis if overflow.
 *
 * @public
 * @param  {string} text
 * @param  {string} containerWidth
 * @param  {string} font
 * @param  {number} [ellipsis='...']
 * @param  {Object} [options]
 * @param  {number} [options.maxIterations=3]
 * @param  {number} [options.minChar=0] If truncate result are less
 *                  then minChar, ellipsis will not show, which is
 *                  better for user hint in some cases.
 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
 * @return {string}
 */


function truncateText(text, containerWidth, font, ellipsis, options) {
  if (!containerWidth) {
    return '';
  }

  var textLines = (text + '').split('\n');
  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
  // It is not appropriate that every line has '...' when truncate multiple lines.

  for (var i = 0, len = textLines.length; i < len; i++) {
    textLines[i] = truncateSingleLine(textLines[i], options);
  }

  return textLines.join('\n');
}

function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
  options = extend({}, options);
  options.font = font;
  var ellipsis = retrieve2(ellipsis, '...');
  options.maxIterations = retrieve2(options.maxIterations, 2);
  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
  // Other languages?

  options.cnCharWidth = getWidth('国', font); // FIXME
  // Consider proportional font?

  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.

  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.

  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
    contentWidth -= ascCharWidth;
  }

  var ellipsisWidth = getWidth(ellipsis);

  if (ellipsisWidth > contentWidth) {
    ellipsis = '';
    ellipsisWidth = 0;
  }

  contentWidth = containerWidth - ellipsisWidth;
  options.ellipsis = ellipsis;
  options.ellipsisWidth = ellipsisWidth;
  options.contentWidth = contentWidth;
  options.containerWidth = containerWidth;
  return options;
}

function truncateSingleLine(textLine, options) {
  var containerWidth = options.containerWidth;
  var font = options.font;
  var contentWidth = options.contentWidth;

  if (!containerWidth) {
    return '';
  }

  var lineWidth = getWidth(textLine, font);

  if (lineWidth <= containerWidth) {
    return textLine;
  }

  for (var j = 0;; j++) {
    if (lineWidth <= contentWidth || j >= options.maxIterations) {
      textLine += options.ellipsis;
      break;
    }

    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
    textLine = textLine.substr(0, subLength);
    lineWidth = getWidth(textLine, font);
  }

  if (textLine === '') {
    textLine = options.placeholder;
  }

  return textLine;
}

function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
  var width = 0;
  var i = 0;

  for (var len = text.length; i < len && width < contentWidth; i++) {
    var charCode = text.charCodeAt(i);
    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
  }

  return i;
}
/**
 * @public
 * @param {string} font
 * @return {number} line height
 */


function getLineHeight(font) {
  // FIXME A rough approach.
  return getWidth('国', font);
}
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @return {Object} width
 */


function measureText(text, font) {
  return methods.measureText(text, font);
} // Avoid assign to an exported variable, for transforming to cjs.


methods.measureText = function (text, font) {
  var ctx = getContext();
  ctx.font = font || DEFAULT_FONT;
  return ctx.measureText(text);
};
/**
 * @public
 * @param {string} text
 * @param {string} font
 * @param {Object} [truncate]
 * @return {Object} block: {lineHeight, lines, height, outerHeight}
 *  Notice: for performance, do not calculate outerWidth util needed.
 */


function parsePlainText(text, font, padding, truncate) {
  text != null && (text += '');
  var lineHeight = getLineHeight(font);
  var lines = text ? text.split('\n') : [];
  var height = lines.length * lineHeight;
  var outerHeight = height;

  if (padding) {
    outerHeight += padding[0] + padding[2];
  }

  if (text && truncate) {
    var truncOuterHeight = truncate.outerHeight;
    var truncOuterWidth = truncate.outerWidth;

    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
      text = '';
      lines = [];
    } else if (truncOuterWidth != null) {
      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
        minChar: truncate.minChar,
        placeholder: truncate.placeholder
      }); // FIXME
      // It is not appropriate that every line has '...' when truncate multiple lines.

      for (var i = 0, len = lines.length; i < len; i++) {
        lines[i] = truncateSingleLine(lines[i], options);
      }
    }
  }

  return {
    lines: lines,
    height: height,
    outerHeight: outerHeight,
    lineHeight: lineHeight
  };
}
/**
 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
 *
 * @public
 * @param {string} text
 * @param {Object} style
 * @return {Object} block
 * {
 *      width,
 *      height,
 *      lines: [{
 *          lineHeight,
 *          width,
 *          tokens: [[{
 *              styleName,
 *              text,
 *              width,      // include textPadding
 *              height,     // include textPadding
 *              textWidth, // pure text width
 *              textHeight, // pure text height
 *              lineHeihgt,
 *              font,
 *              textAlign,
 *              textVerticalAlign
 *          }], [...], ...]
 *      }, ...]
 * }
 * If styleName is undefined, it is plain text.
 */


function parseRichText(text, style) {
  var contentBlock = {
    lines: [],
    width: 0,
    height: 0
  };
  text != null && (text += '');

  if (!text) {
    return contentBlock;
  }

  var lastIndex = STYLE_REG.lastIndex = 0;
  var result;

  while ((result = STYLE_REG.exec(text)) != null) {
    var matchedIndex = result.index;

    if (matchedIndex > lastIndex) {
      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
    }

    pushTokens(contentBlock, result[2], result[1]);
    lastIndex = STYLE_REG.lastIndex;
  }

  if (lastIndex < text.length) {
    pushTokens(contentBlock, text.substring(lastIndex, text.length));
  }

  var lines = contentBlock.lines;
  var contentHeight = 0;
  var contentWidth = 0; // For `textWidth: 100%`

  var pendingList = [];
  var stlPadding = style.textPadding;
  var truncate = style.truncate;
  var truncateWidth = truncate && truncate.outerWidth;
  var truncateHeight = truncate && truncate.outerHeight;

  if (stlPadding) {
    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
  } // Calculate layout info of tokens.


  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    var lineHeight = 0;
    var lineWidth = 0;

    for (var j = 0; j < line.tokens.length; j++) {
      var token = line.tokens[j];
      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.

      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.

      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.

      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
      // as box height of the block.
      tokenStyle.textHeight, getLineHeight(font));
      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
      token.height = tokenHeight;
      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';

      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
        return {
          lines: [],
          width: 0,
          height: 0
        };
      }

      token.textWidth = getWidth(token.text, font);
      var tokenWidth = tokenStyle.textWidth;
      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
      // line when box width is needed to be auto.

      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
        token.percentWidth = tokenWidth;
        pendingList.push(token);
        tokenWidth = 0; // Do not truncate in this case, because there is no user case
        // and it is too complicated.
      } else {
        if (tokenWidthNotSpecified) {
          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
          // `getBoundingRect()` will not get correct result.

          var textBackgroundColor = tokenStyle.textBackgroundColor;
          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
          // (1) If image is not loaded, it will be loaded at render phase and call
          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
          // image, and then the right size will be calculated here at the next tick.
          // See `graphic/helper/text.js`.
          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
          // use `imageHelper.findExistImage` to find cached image.
          // `imageHelper.findExistImage` will always be called here before
          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
          // which ensures that image will not be rendered before correct size calcualted.

          if (bgImg) {
            bgImg = imageHelper.findExistImage(bgImg);

            if (imageHelper.isImageReady(bgImg)) {
              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
            }
          }
        }

        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
        tokenWidth += paddingW;
        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;

        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
            token.text = '';
            token.textWidth = tokenWidth = 0;
          } else {
            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
              minChar: truncate.minChar
            });
            token.textWidth = getWidth(token.text, font);
            tokenWidth = token.textWidth + paddingW;
          }
        }
      }

      lineWidth += token.width = tokenWidth;
      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
    }

    line.width = lineWidth;
    line.lineHeight = lineHeight;
    contentHeight += lineHeight;
    contentWidth = Math.max(contentWidth, lineWidth);
  }

  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);

  if (stlPadding) {
    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
  }

  for (var i = 0; i < pendingList.length; i++) {
    var token = pendingList[i];
    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.

    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
  }

  return contentBlock;
}

function pushTokens(block, str, styleName) {
  var isEmptyStr = str === '';
  var strs = str.split('\n');
  var lines = block.lines;

  for (var i = 0; i < strs.length; i++) {
    var text = strs[i];
    var token = {
      styleName: styleName,
      text: text,
      isLineHolder: !text && !isEmptyStr
    }; // The first token should be appended to the last line.

    if (!i) {
      var tokens = (lines[lines.length - 1] || (lines[0] = {
        tokens: []
      })).tokens; // Consider cases:
      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
      // (which is a placeholder) should be replaced by new token.
      // (2) A image backage, where token likes {a|}.
      // (3) A redundant '' will affect textAlign in line.
      // (4) tokens with the same tplName should not be merged, because
      // they should be displayed in different box (with border and padding).

      var tokensLen = tokens.length;
      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
      (text || !tokensLen || isEmptyStr) && tokens.push(token);
    } // Other tokens always start a new line.
    else {
        // If there is '', insert it as a placeholder.
        lines.push({
          tokens: [token]
        });
      }
  }
}

function makeFont(style) {
  // FIXME in node-canvas fontWeight is before fontStyle
  // Use `fontSize` `fontFamily` to check whether font properties are defined.
  return (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
  style.fontFamily || 'sans-serif'].join(' ') || style.textFont || style.font;
}

exports.DEFAULT_FONT = DEFAULT_FONT;
exports.$override = $override;
exports.getWidth = getWidth;
exports.getBoundingRect = getBoundingRect;
exports.adjustTextX = adjustTextX;
exports.adjustTextY = adjustTextY;
exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
exports.truncateText = truncateText;
exports.getLineHeight = getLineHeight;
exports.measureText = measureText;
exports.parsePlainText = parsePlainText;
exports.parseRichText = parseRichText;
exports.makeFont = makeFont;

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ua = navigator.userAgent.toLowerCase();

var NullView = function (_Component) {
    _inherits(NullView, _Component);

    function NullView() {
        _classCallCheck(this, NullView);

        return _possibleConstructorReturn(this, (NullView.__proto__ || Object.getPrototypeOf(NullView)).apply(this, arguments));
    }

    _createClass(NullView, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (ua.indexOf("amcfmapp") > -1) {
                var have = '没有关闭方法,1秒提示消失';
                if (ua.indexOf("wkwebview") > -1) {
                    if (window.webkit) {
                        have = '有window.webkit关闭方法,1秒提示消失';
                        // Toast.info(have, 1,()=>{
                        window.webkit.messageHandlers.amcfm_utils.postMessage({ "refreshHome": "intelInvest" });
                        window.webkit.messageHandlers.amcfm_utils.postMessage({ "finish": "" });
                        // });
                    }
                } else {
                    if (window.amcfm_utils) {
                        have = '有window.amcfm_utils关闭方法,1秒提示消失';
                        // Toast.info(have, 1,()=>{
                        window.amcfm_utils.refreshHome('intelInvest');
                        window.amcfm_utils.finish();
                        // });
                    }
                }
            } else {
                // hashHistory.push({
                //     pathname: '/',
                //   });
                // let app_index=sessionStorage.getItem('app_index')-0;
                // if (app_index!=null) {
                //     console.log(app_index-window.history.length)
                //     setTimeout(function(){
                //         alert(app_index)
                //         alert(window.history.length)
                //         hashHistory.go(app_index-window.history.length);
                //     },200)
                // }
                __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(1 - window.historyData.length);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
        }
    }]);

    return NullView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NullView);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(133)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 115 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(297), __webpack_require__(296));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1369);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1367);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(531);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(531);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 120 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(187)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 122 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(186)
  , IE8_DOM_DEFINE = __webpack_require__(612)
  , toPrimitive    = __webpack_require__(378)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(121) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(613)
  , defined = __webpack_require__(368);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/circleHookG.eb28e8b9.png";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wenhao.8aac60bb.png";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * 3x2矩阵操作类
 * @exports zrender/tool/matrix
 */
var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
/**
 * 创建一个单位矩阵
 * @return {Float32Array|Array.<number>}
 */

function create() {
  var out = new ArrayCtor(6);
  identity(out);
  return out;
}
/**
 * 设置矩阵为单位矩阵
 * @param {Float32Array|Array.<number>} out
 */


function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}
/**
 * 复制矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m
 */


function copy(out, m) {
  out[0] = m[0];
  out[1] = m[1];
  out[2] = m[2];
  out[3] = m[3];
  out[4] = m[4];
  out[5] = m[5];
  return out;
}
/**
 * 矩阵相乘
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} m1
 * @param {Float32Array|Array.<number>} m2
 */


function mul(out, m1, m2) {
  // Consider matrix.mul(m, m2, m);
  // where out is the same as m2.
  // So use temp variable to escape error.
  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = out3;
  out[4] = out4;
  out[5] = out5;
  return out;
}
/**
 * 平移变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function translate(out, a, v) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4] + v[0];
  out[5] = a[5] + v[1];
  return out;
}
/**
 * 旋转变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {number} rad
 */


function rotate(out, a, rad) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var st = Math.sin(rad);
  var ct = Math.cos(rad);
  out[0] = aa * ct + ab * st;
  out[1] = -aa * st + ab * ct;
  out[2] = ac * ct + ad * st;
  out[3] = -ac * st + ct * ad;
  out[4] = ct * atx + st * aty;
  out[5] = ct * aty - st * atx;
  return out;
}
/**
 * 缩放变换
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 * @param {Float32Array|Array.<number>} v
 */


function scale(out, a, v) {
  var vx = v[0];
  var vy = v[1];
  out[0] = a[0] * vx;
  out[1] = a[1] * vy;
  out[2] = a[2] * vx;
  out[3] = a[3] * vy;
  out[4] = a[4] * vx;
  out[5] = a[5] * vy;
  return out;
}
/**
 * 求逆矩阵
 * @param {Float32Array|Array.<number>} out
 * @param {Float32Array|Array.<number>} a
 */


function invert(out, a) {
  var aa = a[0];
  var ac = a[2];
  var atx = a[4];
  var ab = a[1];
  var ad = a[3];
  var aty = a[5];
  var det = aa * ad - ab * ac;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}

exports.create = create;
exports.identity = identity;
exports.copy = copy;
exports.mul = mul;
exports.translate = translate;
exports.rotate = rotate;
exports.scale = scale;
exports.invert = invert;

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer_reducer__ = __webpack_require__(960);




var createStoreWithMiddleware = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a)(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* createStore */]);

var store = createStoreWithMiddleware(__WEBPACK_IMPORTED_MODULE_2__reducer_reducer__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ListItem = __webpack_require__(812);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var List = function (_React$Component) {
    (0, _inherits3['default'])(List, _React$Component);

    function List() {
        (0, _classCallCheck3['default'])(this, List);
        return (0, _possibleConstructorReturn3['default'])(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    (0, _createClass3['default'])(List, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                children = _a.children,
                className = _a.className,
                style = _a.style,
                renderHeader = _a.renderHeader,
                renderFooter = _a.renderFooter,
                restProps = __rest(_a, ["prefixCls", "children", "className", "style", "renderHeader", "renderFooter"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                renderHeader ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-header' },
                    typeof renderHeader === 'function' ? renderHeader() : renderHeader
                ) : null,
                children ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-body' },
                    children
                ) : null,
                renderFooter ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-footer' },
                    typeof renderFooter === 'function' ? renderFooter() : renderFooter
                ) : null
            );
        }
    }]);
    return List;
}(_react2['default'].Component);

exports['default'] = List;

List.Item = _ListItem2['default'];
List.defaultProps = {
    prefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports) {

function arrayTreeFilter(data, filterFn, options) {
  options = options || {};
  options.childrenKeyName = options.childrenKeyName || 'children';
  var children = data || [];
  var result = [];
  var level = 0;
  var foundItem;
  do {
    var foundItem = children.filter(function(item) {
      return filterFn(item, level);
    })[0];
    if (!foundItem) {
      break;
    }
    result.push(foundItem);
    children = foundItem[options.childrenKeyName] || [];
    level += 1;
  } while(children.length > 0);
  return result;
}

module.exports = arrayTreeFilter;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(167);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(100)
  , createDesc = __webpack_require__(170);
module.exports = __webpack_require__(114) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var textContain = __webpack_require__(112);

var OrdinalScale = __webpack_require__(1092);

var IntervalScale = __webpack_require__(303);

var Scale = __webpack_require__(210);

var numberUtil = __webpack_require__(48);

__webpack_require__(1093);

__webpack_require__(1091);

/**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 */
function getScaleExtent(scale, model) {
  var scaleType = scale.type;
  var min = model.getMin();
  var max = model.getMax();
  var fixMin = min != null;
  var fixMax = max != null;
  var originalExtent = scale.getExtent();
  var axisDataLen;
  var boundaryGap;
  var span;

  if (scaleType === 'ordinal') {
    axisDataLen = (model.get('data') || []).length;
  } else {
    boundaryGap = model.get('boundaryGap');

    if (!zrUtil.isArray(boundaryGap)) {
      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
    }

    if (typeof boundaryGap[0] === 'boolean') {
      boundaryGap = [0, 0];
    }

    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
  } // Notice: When min/max is not set (that is, when there are null/undefined,
  // which is the most common case), these cases should be ensured:
  // (1) For 'ordinal', show all axis.data.
  // (2) For others:
  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
  //      disabled).
  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
  //      be the result that originalExtent enlarged by boundaryGap.
  // (3) If no data, it should be ensured that `scale.setBlank` is set.
  // FIXME
  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
  // that the results processed by boundaryGap are positive/negative?


  if (min == null) {
    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
  }

  if (max == null) {
    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
  }

  if (min === 'dataMin') {
    min = originalExtent[0];
  } else if (typeof min === 'function') {
    min = min({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  if (max === 'dataMax') {
    max = originalExtent[1];
  } else if (typeof max === 'function') {
    max = max({
      min: originalExtent[0],
      max: originalExtent[1]
    });
  }

  (min == null || !isFinite(min)) && (min = NaN);
  (max == null || !isFinite(max)) && (max = NaN);
  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max)); // Evaluate if axis needs cross zero

  if (model.getNeedCrossZero()) {
    // Axis is over zero and min is not set
    if (min > 0 && max > 0 && !fixMin) {
      min = 0;
    } // Axis is under zero and max is not set


    if (min < 0 && max < 0 && !fixMax) {
      max = 0;
    }
  }

  return [min, max];
}

function niceScaleExtent(scale, model) {
  var extent = getScaleExtent(scale, model);
  var fixMin = model.getMin() != null;
  var fixMax = model.getMax() != null;
  var splitNumber = model.get('splitNumber');

  if (scale.type === 'log') {
    scale.base = model.get('logBase');
  }

  var scaleType = scale.type;
  scale.setExtent(extent[0], extent[1]);
  scale.niceExtent({
    splitNumber: splitNumber,
    fixMin: fixMin,
    fixMax: fixMax,
    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
  }); // If some one specified the min, max. And the default calculated interval
  // is not good enough. He can specify the interval. It is often appeared
  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
  // to be 60.
  // FIXME

  var interval = model.get('interval');

  if (interval != null) {
    scale.setInterval && scale.setInterval(interval);
  }
}
/**
 * @param {module:echarts/model/Model} model
 * @param {string} [axisType] Default retrieve from model.type
 * @return {module:echarts/scale/*}
 */


function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new OrdinalScale(model.getCategories(), [Infinity, -Infinity]);

      case 'value':
        return new IntervalScale();
      // Extended scale, like time and log

      default:
        return (Scale.getClass(axisType) || IntervalScale).create(model);
    }
  }
}
/**
 * Check if the axis corss 0
 */


function ifAxisCrossZero(axis) {
  var dataExtent = axis.scale.getExtent();
  var min = dataExtent[0];
  var max = dataExtent[1];
  return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param {Array.<number>} tickCoords In axis self coordinate.
 * @param {Array.<string>} labels
 * @param {string} font
 * @param {number} axisRotate 0: towards right horizontally, clock-wise is negative.
 * @param {number} [labelRotate=0] 0: towards right horizontally, clock-wise is negative.
 * @return {number}
 */


function getAxisLabelInterval(tickCoords, labels, font, axisRotate, labelRotate) {
  var textSpaceTakenRect;
  var autoLabelInterval = 0;
  var accumulatedLabelInterval = 0;
  var rotation = (axisRotate - labelRotate) / 180 * Math.PI;
  var step = 1;

  if (labels.length > 40) {
    // Simple optimization for large amount of labels
    step = Math.floor(labels.length / 40);
  }

  for (var i = 0; i < tickCoords.length; i += step) {
    var tickCoord = tickCoords[i]; // Not precise, do not consider align and vertical align
    // and each distance from axis line yet.

    var rect = textContain.getBoundingRect(labels[i], font, 'center', 'top');
    rect.x += tickCoord * Math.cos(rotation);
    rect.y += tickCoord * Math.sin(rotation); // Magic number

    rect.width *= 1.3;
    rect.height *= 1.3;

    if (!textSpaceTakenRect) {
      textSpaceTakenRect = rect.clone();
    } // There is no space for current label;
    else if (textSpaceTakenRect.intersect(rect)) {
        accumulatedLabelInterval++;
        autoLabelInterval = Math.max(autoLabelInterval, accumulatedLabelInterval);
      } else {
        textSpaceTakenRect.union(rect); // Reset

        accumulatedLabelInterval = 0;
      }
  }

  if (autoLabelInterval === 0 && step > 1) {
    return step;
  }

  return (autoLabelInterval + 1) * step - 1;
}
/**
 * @param {Object} axis
 * @param {Function} labelFormatter
 * @return {Array.<string>}
 */


function getFormattedLabels(axis, labelFormatter) {
  var scale = axis.scale;
  var labels = scale.getTicksLabels();
  var ticks = scale.getTicks();

  if (typeof labelFormatter === 'string') {
    labelFormatter = function (tpl) {
      return function (val) {
        return tpl.replace('{value}', val != null ? val : '');
      };
    }(labelFormatter); // Consider empty array


    return zrUtil.map(labels, labelFormatter);
  } else if (typeof labelFormatter === 'function') {
    return zrUtil.map(ticks, function (tick, idx) {
      return labelFormatter(getAxisRawValue(axis, tick), idx);
    }, this);
  } else {
    return labels;
  }
}

function getAxisRawValue(axis, value) {
  // In category axis with data zoom, tick is not the original
  // index of axis.data. So tick should not be exposed to user
  // in category axis.
  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
}

exports.getScaleExtent = getScaleExtent;
exports.niceScaleExtent = niceScaleExtent;
exports.createScaleByModel = createScaleByModel;
exports.ifAxisCrossZero = ifAxisCrossZero;
exports.getAxisLabelInterval = getAxisLabelInterval;
exports.getFormattedLabels = getFormattedLabels;
exports.getAxisRawValue = getAxisRawValue;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1368);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(341);
var setInnerHTML = __webpack_require__(222);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(349);
var setTextContent = __webpack_require__(563);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(1462);
var ReactInstrumentation = __webpack_require__(75);

var warning = __webpack_require__(25);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["b"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["a"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(50);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(107);

var _Actions = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var ReactBaseClasses = __webpack_require__(583);
var ReactChildren = __webpack_require__(1534);
var ReactDOMFactories = __webpack_require__(1535);
var ReactElement = __webpack_require__(147);
var ReactPropTypes = __webpack_require__(1536);
var ReactVersion = __webpack_require__(1537);

var createReactClass = __webpack_require__(1538);
var onlyChild = __webpack_require__(1542);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var ReactCurrentOwner = __webpack_require__(94);

var warning = __webpack_require__(25);
var canDefineProperty = __webpack_require__(587);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(585);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(109)
  , core      = __webpack_require__(120)
  , ctx       = __webpack_require__(610)
  , hide      = __webpack_require__(149)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(123)
  , createDesc = __webpack_require__(228);
module.exports = __webpack_require__(121) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(376)('wks')
  , uid        = __webpack_require__(229)
  , Symbol     = __webpack_require__(109).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/circleHookO.65cb4c3b.png";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_goback@2x.6b6d17ef.png";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rightArrow.7586a194.png";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(53);

var v2Create = _vector.create;
var v2DistSquare = _vector.distSquare;

/**
 * 曲线辅助模块
 * @module zrender/core/curve
 * @author pissang(https://www.github.com/pissang)
 */
var mathPow = Math.pow;
var mathSqrt = Math.sqrt;
var EPSILON = 1e-8;
var EPSILON_NUMERIC = 1e-4;
var THREE_SQRT = mathSqrt(3);
var ONE_THIRD = 1 / 3; // 临时变量

var _v0 = v2Create();

var _v1 = v2Create();

var _v2 = v2Create();

function isAroundZero(val) {
  return val > -EPSILON && val < EPSILON;
}

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * 计算三次贝塞尔值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
/**
 * 计算三次贝塞尔导数值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @return {number}
 */


function cubicDerivativeAt(p0, p1, p2, p3, t) {
  var onet = 1 - t;
  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
/**
 * 计算三次贝塞尔方程根，使用盛金公式
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} val
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function cubicRootAt(p0, p1, p2, p3, val, roots) {
  // Evaluate roots of cubic functions
  var a = p3 + 3 * (p1 - p2) - p0;
  var b = 3 * (p2 - p1 * 2 + p0);
  var c = 3 * (p1 - p0);
  var d = p0 - val;
  var A = b * b - 3 * a * c;
  var B = b * c - 9 * a * d;
  var C = c * c - 3 * b * d;
  var n = 0;

  if (isAroundZero(A) && isAroundZero(B)) {
    if (isAroundZero(b)) {
      roots[0] = 0;
    } else {
      var t1 = -c / b; //t1, t2, t3, b is not zero

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = B * B - 4 * A * C;

    if (isAroundZero(disc)) {
      var K = B / A;
      var t1 = -b / a + K; // t1, a is not zero

      var t2 = -K / 2; // t2, t3

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
      var Y2 = A * b + 1.5 * a * (-B - discSqrt);

      if (Y1 < 0) {
        Y1 = -mathPow(-Y1, ONE_THIRD);
      } else {
        Y1 = mathPow(Y1, ONE_THIRD);
      }

      if (Y2 < 0) {
        Y2 = -mathPow(-Y2, ONE_THIRD);
      } else {
        Y2 = mathPow(Y2, ONE_THIRD);
      }

      var t1 = (-b - (Y1 + Y2)) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else {
      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
      var theta = Math.acos(T) / 3;
      var ASqrt = mathSqrt(A);
      var tmp = Math.cos(theta);
      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }

      if (t3 >= 0 && t3 <= 1) {
        roots[n++] = t3;
      }
    }
  }

  return n;
}
/**
 * 计算三次贝塞尔方程极限值的位置
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {Array.<number>} extrema
 * @return {number} 有效数目
 */


function cubicExtrema(p0, p1, p2, p3, extrema) {
  var b = 6 * p2 - 12 * p1 + 6 * p0;
  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
  var c = 3 * p1 - 3 * p0;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      extrema[0] = -b / (2 * a);
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        extrema[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        extrema[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 细分三次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function cubicSubdivide(p0, p1, p2, p3, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p23 = (p3 - p2) * t + p2;
  var p012 = (p12 - p01) * t + p01;
  var p123 = (p23 - p12) * t + p12;
  var p0123 = (p123 - p012) * t + p012; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012;
  out[3] = p0123; // Seg1

  out[4] = p0123;
  out[5] = p123;
  out[6] = p23;
  out[7] = p3;
}
/**
 * 投射点到三次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} [out] 投射点
 * @return {number}
 */


function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  var prev;
  var next;
  var d1;
  var d2;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
    d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    prev = t - interval;
    next = t + interval; // t - interval

    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
    d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = cubicAt(x0, x1, x2, x3, next);
      _v2[1] = cubicAt(y0, y1, y2, y3, next);
      d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = cubicAt(x0, x1, x2, x3, t);
    out[1] = cubicAt(y0, y1, y2, y3, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}
/**
 * 计算二次方贝塞尔值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticAt(p0, p1, p2, t) {
  var onet = 1 - t;
  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
/**
 * 计算二次方贝塞尔导数值
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @return {number}
 */


function quadraticDerivativeAt(p0, p1, p2, t) {
  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
/**
 * 计算二次方贝塞尔方程根
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} roots
 * @return {number} 有效根数目
 */


function quadraticRootAt(p0, p1, p2, val, roots) {
  var a = p0 - 2 * p1 + p2;
  var b = 2 * (p1 - p0);
  var c = p0 - val;
  var n = 0;

  if (isAroundZero(a)) {
    if (isNotAroundZero(b)) {
      var t1 = -c / b;

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    }
  } else {
    var disc = b * b - 4 * a * c;

    if (isAroundZero(disc)) {
      var t1 = -b / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }
    } else if (disc > 0) {
      var discSqrt = mathSqrt(disc);
      var t1 = (-b + discSqrt) / (2 * a);
      var t2 = (-b - discSqrt) / (2 * a);

      if (t1 >= 0 && t1 <= 1) {
        roots[n++] = t1;
      }

      if (t2 >= 0 && t2 <= 1) {
        roots[n++] = t2;
      }
    }
  }

  return n;
}
/**
 * 计算二次贝塞尔方程极限值
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @return {number}
 */


function quadraticExtremum(p0, p1, p2) {
  var divider = p0 + p2 - 2 * p1;

  if (divider === 0) {
    // p1 is center of p0 and p2
    return 0.5;
  } else {
    return (p0 - p1) / divider;
  }
}
/**
 * 细分二次贝塞尔曲线
 * @memberOf module:zrender/core/curve
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} t
 * @param  {Array.<number>} out
 */


function quadraticSubdivide(p0, p1, p2, t, out) {
  var p01 = (p1 - p0) * t + p0;
  var p12 = (p2 - p1) * t + p1;
  var p012 = (p12 - p01) * t + p01; // Seg0

  out[0] = p0;
  out[1] = p01;
  out[2] = p012; // Seg1

  out[3] = p012;
  out[4] = p12;
  out[5] = p2;
}
/**
 * 投射点到二次贝塞尔曲线上，返回投射距离。
 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x
 * @param {number} y
 * @param {Array.<number>} out 投射点
 * @return {number}
 */


function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
  // http://pomax.github.io/bezierinfo/#projections
  var t;
  var interval = 0.005;
  var d = Infinity;
  _v0[0] = x;
  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
  // PENDING

  for (var _t = 0; _t < 1; _t += 0.05) {
    _v1[0] = quadraticAt(x0, x1, x2, _t);
    _v1[1] = quadraticAt(y0, y1, y2, _t);
    var d1 = v2DistSquare(_v0, _v1);

    if (d1 < d) {
      t = _t;
      d = d1;
    }
  }

  d = Infinity; // At most 32 iteration

  for (var i = 0; i < 32; i++) {
    if (interval < EPSILON_NUMERIC) {
      break;
    }

    var prev = t - interval;
    var next = t + interval; // t - interval

    _v1[0] = quadraticAt(x0, x1, x2, prev);
    _v1[1] = quadraticAt(y0, y1, y2, prev);
    var d1 = v2DistSquare(_v1, _v0);

    if (prev >= 0 && d1 < d) {
      t = prev;
      d = d1;
    } else {
      // t + interval
      _v2[0] = quadraticAt(x0, x1, x2, next);
      _v2[1] = quadraticAt(y0, y1, y2, next);
      var d2 = v2DistSquare(_v2, _v0);

      if (next <= 1 && d2 < d) {
        t = next;
        d = d2;
      } else {
        interval *= 0.5;
      }
    }
  } // t


  if (out) {
    out[0] = quadraticAt(x0, x1, x2, t);
    out[1] = quadraticAt(y0, y1, y2, t);
  } // console.log(interval, i);


  return mathSqrt(d);
}

exports.cubicAt = cubicAt;
exports.cubicDerivativeAt = cubicDerivativeAt;
exports.cubicRootAt = cubicRootAt;
exports.cubicExtrema = cubicExtrema;
exports.cubicSubdivide = cubicSubdivide;
exports.cubicProjectPoint = cubicProjectPoint;
exports.quadraticAt = quadraticAt;
exports.quadraticDerivativeAt = quadraticDerivativeAt;
exports.quadraticRootAt = quadraticRootAt;
exports.quadraticExtremum = quadraticExtremum;
exports.quadraticSubdivide = quadraticSubdivide;
exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bankCardList */
/* unused harmony export bankCardNum */
/* unused harmony export HQTCardList */
/* unused harmony export bankCardListResetPS */
/* unused harmony export addCardRequest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getBankCardType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBankList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestAuthentication; });
/* unused harmony export confirmAuthentication */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addBankCard; });
/* unused harmony export unbindBankCard */
/* unused harmony export getFAQ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBankProtocollnfoList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getPay_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_js__ = __webpack_require__(13);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var bankCardList = function bankCardList(text) {
	return {
		type: 'BANK_CARD_LIST',
		text: text
	};
};

var bankCardNum = function bankCardNum(text) {
	return {
		type: 'BANK_CARD_NUM',
		text: text
	};
};

var HQTCardList = function HQTCardList(text) {
	return {
		type: 'HQT_CARD_LIST',
		text: text
	};
};

var bankCardListResetPS = function bankCardListResetPS(text) {
	return {
		type: 'BANK_CARD_LIST_RESET',
		text: text
	};
};

//请求加卡
var addCardRequest = function addCardRequest(params, succallback, errcallback) {
	return function () {
		var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(dispatch, getState) {
			var successCallback, errorCallback;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							successCallback = function () {
								var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(succ) {
									return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
										while (1) {
											switch (_context.prev = _context.next) {
												case 0:
													console.log(succ);
													if (succ && succ.code === '0000') {
														succallback();
													} else {
														console.log('后台返回数据有误！' + succ.message);
														errcallback(succ.message);
													}

												case 2:
												case 'end':
													return _context.stop();
											}
										}
									}, _callee, _this);
								}));

								return function successCallback(_x3) {
									return _ref2.apply(this, arguments);
								};
							}();

							errorCallback = function errorCallback(err) {
								console.log(err);
								errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
							};

							_context2.next = 4;
							return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_js__["b" /* getTempInfo */])('shortToken');

						case 4:
							params.token = _context2.sent;

							__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/addCardRequest', params, successCallback, errorCallback);

						case 6:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, _this);
		}));

		return function (_x, _x2) {
			return _ref.apply(this, arguments);
		};
	}();
};

//获取卡类型
var getBankCardType = function getBankCardType(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this);
			}));

			return function successCallback(_x4) {
				return _ref3.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/realnameauth/getBankName', params, successCallback, errorCallback);
	};
};

//获取可加卡银行的列表来取得paymentChannelId
var getBankList = function getBankList(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
					while (1) {
						switch (_context4.prev = _context4.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context4.stop();
						}
					}
				}, _callee4, _this);
			}));

			return function successCallback(_x5) {
				return _ref4.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/realnameauth/getBankCardList', params, successCallback, errorCallback);
	};
};

//鉴权申请
var requestAuthentication = function requestAuthentication(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this);
			}));

			return function successCallback(_x6) {
				return _ref5.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.postNew(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/v1/account/bankCard/authApply', params, successCallback, errorCallback);
	};
};

//鉴权确认
var confirmAuthentication = function confirmAuthentication(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this);
			}));

			return function successCallback(_x7) {
				return _ref6.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/realnameauth/authConfirm', params, successCallback, errorCallback);
	};
};
//添加银行卡
var addBankCard = function addBankCard(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref7 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this);
			}));

			return function successCallback(_x8) {
				return _ref7.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.postNew(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/v2/account/bankCard/addCard', params, successCallback, errorCallback);
	};
};
//解绑银行卡
var unbindBankCard = function unbindBankCard(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref8 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this);
			}));

			return function successCallback(_x9) {
				return _ref8.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/account/closePaymentAccount', params, successCallback, errorCallback);
	};
};
//获取常见问题
var getFAQ = function getFAQ(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref9 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								console.log(succ);
								if (succ) {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.responseMsg);
									errcallback(succ.responseMsg);
								}

							case 2:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this);
			}));

			return function successCallback(_x10) {
				return _ref9.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/cms/getQuestionListByCode', params, successCallback, errorCallback);
	};
};

//银联签约协议查询,新增接口app有网关，但给予投顾H5老项目单独简单处理不走网关，后期新项目投顾替代将会都需要走网关
var getBankProtocollnfoList = function getBankProtocollnfoList(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref10 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee10, _this);
			}));

			return function successCallback(_x11) {
				return _ref10.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.postNew(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/v1/account/bankCard/getBankProtocolInfoList', params, successCallback, errorCallback);
	};
};

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var CacheHOC = function CacheHOC(ParentComponent, id) {
  return function (_ParentComponent) {
    _inherits(Cache, _ParentComponent);

    function Cache(props) {
      _classCallCheck(this, Cache);

      var _this = _possibleConstructorReturn(this, (Cache.__proto__ || Object.getPrototypeOf(Cache)).call(this, props));

      _this.getData = function () {
        return _this.globalThis.projectCache[_this.cacheId];
      };

      _this.setData = function (value) {
        if (!value) return _this.globalThis.projectCache[_this.cacheId] = null;
        var newState = Object.assign({}, _this.getData() || {}, value);
        _this.globalThis.projectCache[_this.cacheId] = newState;
      };

      _this.setScroll = function (value) {
        _this.globalThis.scrollCache[_this.cacheId] = value;
      };

      _this.getScroll = function () {
        return _this.globalThis.scrollCache[_this.cacheId];
      };

      _this.getScrollElement = function () {
        var docHeight = document.documentElement.clientHeight;
        var docume = document.documentElement.getBoundingClientRect().height > docHeight ? document.documentElement : document.body;
        return document.querySelector('#' + _this.cacheId) || docume;
      };

      _this.init = function () {
        if (!_this.globalThis.projectCache) _this.globalThis.projectCache = {};
        if (!_this.globalThis.scrollCache) _this.globalThis.scrollCache = {};
        if (!_this.globalThis.refreshCache) _this.globalThis.refreshCache = {};
        if (_this.props.location.action !== 'POP') {
          _this.setData(null);
          _this.setScroll('');
          _this.update(false);
        }
      };

      _this.update = function (value) {
        _this.globalThis.refreshCache[_this.cacheId] = value;
      };

      _this.isUpdate = function () {
        return _this.globalThis.refreshCache[_this.cacheId];
      };

      _this.globalThis = window;
      _this.cacheId = props.location.query.isRecharge === 'true' ? id + 'Recharge' : id;
      return _this;
    }

    _createClass(Cache, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        var superComponentDidMount = _get(Cache.prototype.__proto__ || Object.getPrototypeOf(Cache.prototype), 'componentDidMount', this);
        this.init();
        if (this.isUpdate()) {
          this.setState(this.getData(), function () {
            superComponentDidMount && superComponentDidMount.call(_this2);
            // this.getScrollElement()
            //   ? (this.getScrollElement().scrollTop = this.getScroll())
            //   : (document.body.scrollTop = this.getScroll());
            _this2.getScrollElement() && (_this2.getScrollElement().scrollTop = _this2.getScroll());
            _this2.update(false);
            document.body.scrollTo(0, _this2.getScroll());
          });
        } else {
          if (this.getData()) {
            this.setState(this.getData(), function () {
              _this2.getScrollElement() && (_this2.getScrollElement().scrollTo = _this2.getScroll());
              document.body.scrollTo(0, _this2.getScroll());
            });
          } else {
            superComponentDidMount && superComponentDidMount.call(this);
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.setData(this.state);
        this.setScroll(this.getScrollElement() && this.getScrollElement().scrollTop || document.documentElement.scrollTop || document.body.scrollTop);
        var superComponentWillUnmount = _get(Cache.prototype.__proto__ || Object.getPrototypeOf(Cache.prototype), 'componentWillUnmount', this);
        superComponentWillUnmount && superComponentWillUnmount.call(this);
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: this.cacheId + 'hxcf', style: { height: '100%' } },
          _get(Cache.prototype.__proto__ || Object.getPrototypeOf(Cache.prototype), 'render', this).call(this)
        );
      }
    }]);

    return Cache;
  }(ParentComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (CacheHOC);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nheader_css__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nheader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__nheader_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var NHeader = function (_Component) {
  _inherits(NHeader, _Component);

  function NHeader(props) {
    _classCallCheck(this, NHeader);

    var _this = _possibleConstructorReturn(this, (NHeader.__proto__ || Object.getPrototypeOf(NHeader)).call(this, props));

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.state = {};
    return _this;
  }

  _createClass(NHeader, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "NHeader_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "NHeader_wrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "NHeader_content" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "NHeader_goback", onClick: this.goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(152) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "NHeader_title" },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "NHeader_share" },
              this.props.rightContent
            )
          )
        )
      );
    }
  }]);

  return NHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(NHeader));

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BankCode__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PayWarmTips = function (_Component) {
  _inherits(PayWarmTips, _Component);

  function PayWarmTips() {
    _classCallCheck(this, PayWarmTips);

    return _possibleConstructorReturn(this, (PayWarmTips.__proto__ || Object.getPrototypeOf(PayWarmTips)).apply(this, arguments));
  }

  _createClass(PayWarmTips, [{
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name) {
      var code = __WEBPACK_IMPORTED_MODULE_2__BankCode__["a" /* protocolCode */][name];
      console.log(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */]);
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.props.hqt) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'footer',
          { className: 'superFooter' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { height: 30 } },
            '\u7279\u522B\u63D0\u793A :'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '1\u3001\u6D3B\u671F\u901A\u662F\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\u7684\u7406\u8D22\u4EA7\u54C1\uFF0C\u534E\u590F\u67E5\u7406\u667A\u6295\u4EC5\u53EF\u8FDB\u884C\u6D3B\u671F\u901A\u5145\u503C\uFF0C\u5982\u9700\u529E\u7406\u6D3B\u671F\u901A\u8D4E\u56DE\u3001\u4EA4\u6613\u67E5\u8BE2\u7B49\u4E1A\u52A1\u8BF7\u767B\u5F55\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6\uFF1B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '2\u300115:00\u70B9\u524D\u5B8C\u6210\u652F\u4ED8\uFF0C\u9884\u8BA1\u5728\u4E0B\u4E00\u4EA4\u6613\u65E5\u5F00\u59CB\u4EAB\u53D7\u6536\u76CA'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '3\u3001\u9884\u8BA1\u7B2C\u4E09\u4E2A\u4EA4\u6613\u65E5\u53EF\u67E5\u8BE2\u6536\u76CA\uFF1B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u4EA4\u6613\u65E515:00\u540E\u6216\u975E\u4EA4\u6613\u65E5\u63D0\u4EA4\u7533\u8BF7\uFF0C\u6309\u4E0B\u4E00\u4EA4\u6613\u65E5\u7684\u7533\u8BF7\u5904\u7406\uFF1B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u57FA\u91D1\u51C0\u503C\u4F1A\u56E0\u8BC1\u5238\u5E02\u573A\u6CE2\u52A8\u7B49\u56E0\u7D20\u6CE2\u52A8\uFF0C\u53EF\u80FD\u5BFC\u81F4\u635F\u5931\uFF1B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u7BA1\u7406\u4EBA\u6295\u8D44\u5224\u65AD\u4F1A\u6709\u5DEE\u5F02\u4ECE\u800C\u5F71\u54CD\u57FA\u91D1\u7684\u6536\u76CA\u6C34\u5E73\uFF0C\u53EF\u80FD\u53D1\u751F\u635F\u5931\uFF1B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '7\u3001\u745E\u7BA1\u7406\u4EBA\u4E1A\u52A1\u6216\u8D22\u52A1\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u53EF\u80FD\u5F71\u54CD\u6295\u8D44\u8005\u5224\u65AD\uFF0C\u4E5F\u53EF\u80FD\u5BFC\u81F4\u635F\u5931\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: '0.24rem', display: "-webkit-flex" } },
            this.props.buyType == 'SF' ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { color: '#5b6370', lineHeight: '22px' } },
              '\u5982\u9700\u4E86\u89E3\u66F4\u591A\u8BF7\u9605\u8BFB'
            ),
            this.props.buyType == 'SF' ? null
            // <p className='red-t' style={{float:'left',lineHeight:'22px'}} onClick={()=>this.ProtocolPaper('华夏查理智投投资者风险告知函')}>《华夏查理智投投资者风险告知函》</p>
            : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'red-t', style: { float: 'left', lineHeight: '22px' }, onClick: function onClick() {
                  return _this2.ProtocolPaper('投资者风险告知函');
                } },
              '\u300A\u6295\u8D44\u8005\u98CE\u9669\u544A\u77E5\u51FD\u300B'
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'footer',
          { className: 'superFooter' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { height: 30 } },
            '\u7279\u522B\u63D0\u793A :'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px', fontWeight: "bold" } },
            '1\u3001\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '2\u3001\u57FA\u91D1\u51C0\u503C\u4F1A\u56E0\u8BC1\u5238\u5E02\u573A\u6CE2\u52A8\u7B49\u56E0\u7D20\u6CE2\u52A8\uFF0C\u53EF\u80FD\u5BFC\u81F4\u635F\u5931\u3002 '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '3\u3001\u7BA1\u7406\u4EBA\u6295\u8D44\u5224\u65AD\u4F1A\u6709\u5DEE\u5F02\u4ECE\u800C\u5F71\u54CD\u57FA\u91D1\u7684\u6536\u76CA\u6C34\u5E73\uFF0C\u53EF\u80FD\u53D1\u751F\u635F\u5931\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u82E5\u7BA1\u7406\u4EBA\u4E1A\u52A1\u6216\u8D22\u52A1\u72B6\u51B5\u53D8\u5316\uFF0C\u53EF\u80FD\u5F71\u54CD\u6295\u8D44\u8005\u5224\u65AD\uFF0C\u4E5F\u53EF\u80FD\u5BFC\u81F4\u635F\u5931\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u6295\u8D44\u8005\u53EF\u4EE5\u901A\u8FC7\u5F55\u97F3\u3001\u622A\u5C4F\u7B49\u65B9\u5F0F\u7559\u5B58\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u76F8\u5173\u4FE1\u606F\u3002'
          ),
          this.props.fundLimit === '002552' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u6BCF\u534A\u5E74\u5F00\u653E\u4E00\u6B21\u7533\u8D2D\u548C\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u82E5\u9519\u8FC7\u67D0\u4E00\u5F00\u653E\u671F\u800C\u672A\u80FD\u8D4E\u56DE\uFF0C\u5176\u4EFD\u989D\u5C06\u8F6C\u5165\u4E0B\u4E00\u5C01\u95ED\u671F\uFF0C\u81F3\u4E0B\u4E00\u5F00\u653E\u671F\u65B9\u53EF\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u5728\u5F00\u653E\u671F\u7684\u6700\u540E\u4E00\u65E5\u65E5\u7EC8\uFF0C\u6EE1\u8DB3\u4E00\u5B9A\u7684\u60C5\u5F62\u65F6\uFF0C\u57FA\u91D1\u4E0E\u5176\u4ED6\u57FA\u91D1\u5408\u5E76\u6216\u7EC8\u6B62\u57FA\u91D1\u5408\u540C\uFF0C\u57FA\u91D1\u4EFD\u989D\u6301\u6709\u4EBA\u9762\u4E34\u4E00\u5B9A\u7684\u57FA\u91D1\u6E05\u7B97\u98CE\u9669'
          )] : null,
          this.props.fundLimit === '003697' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u6BCF6\u4E2A\u6708\u5F00\u653E\u4E00\u6B21\u7533\u8D2D\u548C\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u82E5\u9519\u8FC7\u67D0\u4E00\u5F00\u653E\u671F\u800C\u672A\u80FD\u8D4E\u56DE\uFF0C\u5176\u4EFD\u989D\u5C06\u8F6C\u5165\u4E0B\u4E00\u5C01\u95ED\u671F\uFF0C\u81F3\u4E0B\u4E00\u5F00\u653E\u671F\u65B9\u53EF\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u5728\u5F00\u653E\u671F\u7684\u6700\u540E\u4E00\u65E5\u65E5\u7EC8\uFF0C\u6EE1\u8DB3\u4E00\u5B9A\u7684\u60C5\u5F62\u65F6\uFF0C\u57FA\u91D1\u4E0E\u5176\u4ED6\u57FA\u91D1\u5408\u5E76\u6216\u7EC8\u6B62\u57FA\u91D1\u5408\u540C\uFF0C\u57FA\u91D1\u4EFD\u989D\u6301\u6709\u4EBA\u9762\u4E34\u4E00\u5B9A\u7684\u57FA\u91D1\u6E05\u7B97\u98CE\u9669'
          )] : null,
          this.props.fundLimit === '004063' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u6BCF1\u5E74\u5F00\u653E\u4E00\u6B21\u7533\u8D2D\u548C\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u82E5\u9519\u8FC7\u67D0\u4E00\u5F00\u653E\u671F\u800C\u672A\u80FD\u8D4E\u56DE\uFF0C\u5176\u4EFD\u989D\u5C06\u8F6C\u5165\u4E0B\u4E00\u5C01\u95ED\u671F\uFF0C\u81F3\u4E0B\u4E00\u5F00\u653E\u671F\u65B9\u53EF\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u5728\u5F00\u653E\u671F\u7684\u6700\u540E\u4E00\u65E5\u65E5\u7EC8\uFF0C\u6EE1\u8DB3\u4E00\u5B9A\u7684\u60C5\u5F62\u65F6\uFF0C\u57FA\u91D1\u53EF\u8F6C\u4E3A\u666E\u901A\u5F00\u653E\u5F0F\u57FA\u91D1'
          )] : null,
          this.props.fundLimit === '160323' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u6BCF18\u4E2A\u5F00\u653E\u4E00\u6B21\u7533\u8D2D\u548C\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u82E5\u9519\u8FC7\u67D0\u4E00\u5F00\u653E\u671F\u800C\u672A\u80FD\u8D4E\u56DE\uFF0C\u5176\u4EFD\u989D\u5C06\u8F6C\u5165\u4E0B\u4E00\u5C01\u95ED\u671F\uFF0C\u81F3\u4E0B\u4E00\u5F00\u653E\u671F\u65B9\u53EF\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u5728\u5F00\u653E\u671F\u7684\u6700\u540E\u4E00\u65E5\u65E5\u7EC8\uFF0C\u6EE1\u8DB3\u4E00\u5B9A\u7684\u60C5\u5F62\u65F6\uFF0C\u57FA\u91D1\u53EF\u8F6C\u4E3A\u666E\u901A\u5F00\u653E\u5F0F\u57FA\u91D1\uFF0C\u4E0D\u518D\u4EE5\u5B9A\u671F\u5F00\u653E\u7684\u65B9\u5F0F\u8FD0\u4F5C'
          )] : null,
          this.props.fundLimit === '160324' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u6BCF18\u4E2A\u5F00\u653E\u4E00\u6B21\u7533\u8D2D\u548C\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u82E5\u9519\u8FC7\u67D0\u4E00\u5F00\u653E\u671F\u800C\u672A\u80FD\u8D4E\u56DE\uFF0C\u5176\u4EFD\u989D\u5C06\u8F6C\u5165\u4E0B\u4E00\u5C01\u95ED\u671F\uFF0C\u81F3\u4E0B\u4E00\u5F00\u653E\u671F\u65B9\u53EF\u8D4E\u56DE'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u5728\u5F00\u653E\u671F\u7684\u6700\u540E\u4E00\u65E5\u65E5\u7EC8\uFF0C\u6EE1\u8DB3\u4E00\u5B9A\u7684\u60C5\u5F62\u65F6\uFF0C\u57FA\u91D1\u53EF\u8F6C\u4E3A\u666E\u901A\u5F00\u653E\u5F0F\u57FA\u91D1\uFF0C\u4E0D\u518D\u4EE5\u5B9A\u671F\u5F00\u653E\u7684\u65B9\u5F0F\u8FD0\u4F5C'
          )] : null,
          this.props.fundLimit === '001057' || this.props.fundLimit === '001058' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u4EA7\u54C1\u56E0\u7ECF\u8425\u7ACB\u6784\u7684\u4E1A\u52A1\u6216\u8005\u8D22\u4EA7\u72B6\u51B5\u53D8\u5316\uFF0C\u53EF\u80FD\u5BFC\u81F4\u672C\u91D1\u6216\u8005\u539F\u59CB\u672C\u91D1\u4E8F\u635F\uFF1B'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u57FA\u91D1\u4EA7\u54C1\u56E0\u7ECF\u8425\u7ACB\u6784\u7684\u4E1A\u52A1\u6216\u8005\u8D22\u4EA7\u72B6\u51B5\u53D8\u5316\uFF0C\u4F1A\u5F71\u54CD\u5BA2\u6237\u5224\u65AD\uFF1B'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u7406\u8D2230\u5929\u53EA\u80FD\u5728\u8D2D\u4E70\u4E00\u4E2A\u6708\u540E\u7684\u5BF9\u65E5\u53D1\u8D77\u8D4E\u56DE\uFF0C\u5982\u9047\u8282\u5047\u65E5\u987A\u5EF6\u3002'
          )] : null,
          this.props.fundLimit === '501186' ? [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'a', style: { color: '#5b6370', lineHeight: '22px' } },
            '4\u3001\u57FA\u91D1\u6210\u7ACB\u4E4B\u65E5\u8D773\u5E74\u5185\u5C01\u95ED\u8FD0\u4F5C\u5E76\u4E0A\u5E02\uFF0C\u5728\u6B64\u671F\u95F4\u6BCF6\u4E2A\u6708\u53D7\u9650\u5F00\u653E\u4E00\u6B21\uFF0C\u53EA\u5F00\u653E\u7533\u8D2D\uFF0C\u4E0D\u5F00\u653E\u8D4E\u56DE\uFF1B'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'b', style: { color: '#5b6370', lineHeight: '22px' } },
            '5\u3001\u672C\u57FA\u91D1\u5728\u5C01\u95ED\u8FD0\u4F5C\u671F\u7684\u53D7\u9650\u5F00\u653E\u671F\u5185\u6682\u65F6\u53EA\u63A5\u53D7\u573A\u5916\u7533\u8D2D\uFF0C\u4E0D\u63A5\u53D7\u573A\u5185\u7533\u8D2D\u3002\u5728\u6761\u4EF6\u5141\u8BB8\u7684\u60C5\u51B5\u4E0B\uFF0C\u672C\u57FA\u91D1\u5C06\u5728\u53D7\u9650\u5F00\u653E\u671F\u5185\u5F00\u653E\u573A\u5185\u7533\u8D2D\uFF1B'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'c', style: { color: '#5b6370', lineHeight: '22px' } },
            '6\u3001\u672C\u57FA\u91D1\u81EA\u6210\u7ACB6\u4E2A\u6708\u540E\u4E0A\u5E02\u4EA4\u6613\uFF0C\u5C4A\u65F6\u6295\u8D44\u8005\u53EF\u5C06\u4EFD\u989D\u8F6C\u573A\u5185\u4E0A\u5E02\u4EA4\u6613\uFF1B'
          ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { key: 'd', style: { color: '#5b6370', lineHeight: '22px' } },
            '7\u3001\u672C\u57FA\u91D1\u5C01\u95ED\u8FD0\u4F5C3\u5E74\u5C4A\u6EE1\u540E\uFF0C\u5C06\u8F6C\u578B\u4E3A\u666E\u901A\u4E0A\u5E02\u578B\u5F00\u653E\u5F0F\u57FA\u91D1\uFF08LOF\uFF09\u3002'
          )] : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: '0.24rem', display: "-webkit-flex" } },
            this.props.buyType == 'SF' ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { color: '#5b6370', lineHeight: '22px' } },
              '\u5982\u9700\u4E86\u89E3\u66F4\u591A\u8BF7\u9605\u8BFB'
            ),
            this.props.buyType == 'SF' ? null
            // <p className='red-t' style={{float:'left',lineHeight:'22px'}} onClick={()=>this.ProtocolPaper('华夏查理智投投资者风险告知函')}>《华夏查理智投投资者风险告知函》</p>
            : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'red-t', style: { float: 'left', lineHeight: '22px' }, onClick: function onClick() {
                  return _this2.ProtocolPaper('投资者风险告知函');
                } },
              '\u300A\u6295\u8D44\u8005\u98CE\u9669\u544A\u77E5\u51FD\u300B'
            )
          )
        );
      }
    }
  }]);

  return PayWarmTips;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PayWarmTips);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

__webpack_require__(1040);

__webpack_require__(1041);

var visualSymbol = __webpack_require__(1097);

var layoutPoints = __webpack_require__(1077);

var dataSample = __webpack_require__(1090);

__webpack_require__(471);

// In case developer forget to include grid component
echarts.registerVisual(zrUtil.curry(visualSymbol, 'line', 'circle', 'line'));
echarts.registerLayout(zrUtil.curry(layoutPoints, 'line')); // Down sample after filter

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, zrUtil.curry(dataSample, 'line'));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

__webpack_require__(1058);

__webpack_require__(1060);

__webpack_require__(1059);

var legendFilter = __webpack_require__(1061);

var Component = __webpack_require__(102);

// Do not contain scrollable legend, for sake of file size.
// Series Filter
echarts.registerProcessor(legendFilter);
Component.registerSubTypeDefaulter('legend', function () {
  // Default 'plain' when no type specified.
  return 'plain';
});

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var graphic = __webpack_require__(34);

var _layout = __webpack_require__(103);

var getLayoutRect = _layout.getLayoutRect;
// Model
echarts.extendComponentModel({
  type: 'title',
  layoutMode: {
    type: 'box',
    ignoreSize: true
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 6,
    show: true,
    text: '',
    // 超链接跳转
    // link: null,
    // 仅支持self | blank
    target: 'blank',
    subtext: '',
    // 超链接跳转
    // sublink: null,
    // 仅支持self | blank
    subtarget: 'blank',
    // 'center' ¦ 'left' ¦ 'right'
    // ¦ {number}（x坐标，单位px）
    left: 0,
    // 'top' ¦ 'bottom' ¦ 'center'
    // ¦ {number}（y坐标，单位px）
    top: 0,
    // 水平对齐
    // 'auto' | 'left' | 'right' | 'center'
    // 默认根据 left 的位置判断是左对齐还是右对齐
    // textAlign: null
    //
    // 垂直对齐
    // 'auto' | 'top' | 'bottom' | 'middle'
    // 默认根据 top 位置判断是上对齐还是下对齐
    // textBaseline: null
    backgroundColor: 'rgba(0,0,0,0)',
    // 标题边框颜色
    borderColor: '#ccc',
    // 标题边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 标题内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 主副标题纵向间隔，单位px，默认为10，
    itemGap: 10,
    textStyle: {
      fontSize: 18,
      fontWeight: 'bolder',
      color: '#333'
    },
    subtextStyle: {
      color: '#aaa'
    }
  }
}); // View

echarts.extendComponentView({
  type: 'title',
  render: function (titleModel, ecModel, api) {
    this.group.removeAll();

    if (!titleModel.get('show')) {
      return;
    }

    var group = this.group;
    var textStyleModel = titleModel.getModel('textStyle');
    var subtextStyleModel = titleModel.getModel('subtextStyle');
    var textAlign = titleModel.get('textAlign');
    var textBaseline = titleModel.get('textBaseline');
    var textEl = new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: titleModel.get('text'),
        textFill: textStyleModel.getTextColor()
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var textRect = textEl.getBoundingRect();
    var subText = titleModel.get('subtext');
    var subTextEl = new graphic.Text({
      style: graphic.setTextStyle({}, subtextStyleModel, {
        text: subText,
        textFill: subtextStyleModel.getTextColor(),
        y: textRect.height + titleModel.get('itemGap'),
        textVerticalAlign: 'top'
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var link = titleModel.get('link');
    var sublink = titleModel.get('sublink');
    textEl.silent = !link;
    subTextEl.silent = !sublink;

    if (link) {
      textEl.on('click', function () {
        window.open(link, '_' + titleModel.get('target'));
      });
    }

    if (sublink) {
      subTextEl.on('click', function () {
        window.open(sublink, '_' + titleModel.get('subtarget'));
      });
    }

    group.add(textEl);
    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.

    var groupRect = group.getBoundingRect();
    var layoutOption = titleModel.getBoxLayoutParams();
    layoutOption.width = groupRect.width;
    layoutOption.height = groupRect.height;
    var layoutRect = getLayoutRect(layoutOption, {
      width: api.getWidth(),
      height: api.getHeight()
    }, titleModel.get('padding')); // Adjust text align based on position

    if (!textAlign) {
      // Align left if title is on the left. center and right is same
      textAlign = titleModel.get('left') || titleModel.get('right');

      if (textAlign === 'middle') {
        textAlign = 'center';
      } // Adjust layout by text align


      if (textAlign === 'right') {
        layoutRect.x += layoutRect.width;
      } else if (textAlign === 'center') {
        layoutRect.x += layoutRect.width / 2;
      }
    }

    if (!textBaseline) {
      textBaseline = titleModel.get('top') || titleModel.get('bottom');

      if (textBaseline === 'center') {
        textBaseline = 'middle';
      }

      if (textBaseline === 'bottom') {
        layoutRect.y += layoutRect.height;
      } else if (textBaseline === 'middle') {
        layoutRect.y += layoutRect.height / 2;
      }

      textBaseline = textBaseline || 'top';
    }

    group.attr('position', [layoutRect.x, layoutRect.y]);
    var alignStyle = {
      textAlign: textAlign,
      textVerticalAlign: textBaseline
    };
    textEl.setStyle(alignStyle);
    subTextEl.setStyle(alignStyle); // Render background
    // Get groupRect again because textAlign has been changed

    groupRect = group.getBoundingRect();
    var padding = layoutRect.margin;
    var style = titleModel.getItemStyle(['color', 'opacity']);
    style.fill = titleModel.get('backgroundColor');
    var rect = new graphic.Rect({
      shape: {
        x: groupRect.x - padding[3],
        y: groupRect.y - padding[0],
        width: groupRect.width + padding[1] + padding[3],
        height: groupRect.height + padding[0] + padding[2],
        r: titleModel.get('borderRadius')
      },
      style: style,
      silent: true
    });
    graphic.subPixelOptimizeRect(rect);
    group.add(rect);
  }
});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

__webpack_require__(1050);

__webpack_require__(1063);

__webpack_require__(1064);

// FIXME Better way to pack data in graphic element

/**
 * @action
 * @property {string} type
 * @property {number} seriesIndex
 * @property {number} dataIndex
 * @property {number} [x]
 * @property {number} [y]
 */
echarts.registerAction({
  type: 'showTip',
  event: 'showTip',
  update: 'tooltip:manuallyShowTip'
}, // noop
function () {});
echarts.registerAction({
  type: 'hideTip',
  event: 'hideTip',
  update: 'tooltip:manuallyHideTip'
}, // noop
function () {});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_item_foot.7586a194.png";

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sanjiao@3x.ff62c6aa.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (props) {
    return Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
};

module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Flex = __webpack_require__(800);

var _Flex2 = _interopRequireDefault(_Flex);

var _FlexItem = __webpack_require__(801);

var _FlexItem2 = _interopRequireDefault(_FlexItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Flex2['default'].Item = _FlexItem2['default'];
exports['default'] = _Flex2['default'];
module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(456)
  , enumBugKeys = __webpack_require__(284);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(486);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(523);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(523);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1325)();
}


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1366);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.toArray = toArray;
exports.getActiveIndex = getActiveIndex;
exports.getActiveKey = getActiveKey;
exports.setTransform = setTransform;
exports.isTransformSupported = isTransformSupported;
exports.setTransition = setTransition;
exports.getTransformPropValue = getTransformPropValue;
exports.isVertical = isVertical;
exports.getTransformByIndex = getTransformByIndex;
exports.getMarginStyle = getMarginStyle;
exports.getStyle = getStyle;
exports.setPxStyle = setPxStyle;
exports.getDataAttr = getDataAttr;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  _react2['default'].Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransformSupported(style) {
  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var EventPluginRegistry = __webpack_require__(342);
var EventPluginUtils = __webpack_require__(343);
var ReactErrorUtils = __webpack_require__(347);

var accumulateInto = __webpack_require__(556);
var forEachAccumulated = __webpack_require__(557);
var invariant = __webpack_require__(15);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(178);
var EventPluginUtils = __webpack_require__(343);

var accumulateInto = __webpack_require__(556);
var forEachAccumulated = __webpack_require__(557);
var warning = __webpack_require__(25);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(93);

var getEventTarget = __webpack_require__(352);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"];
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(606);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(188);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(617)
  , enumBugKeys = __webpack_require__(369);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/junhengx.002bc97a.png";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhizhen.9fcbeb23.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(154);

var vec2 = __webpack_require__(53);

var bbox = __webpack_require__(710);

var BoundingRect = __webpack_require__(63);

var _config = __webpack_require__(260);

var dpr = _config.devicePixelRatio;

/**
 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
 * 可以用于 isInsidePath 判断以及获取boundingRect
 *
 * @module zrender/core/PathProxy
 * @author Yi Shen (http://www.github.com/pissang)
 */
// TODO getTotalLength, getPointAtLength
var CMD = {
  M: 1,
  L: 2,
  C: 3,
  Q: 4,
  A: 5,
  Z: 6,
  // Rect
  R: 7
}; // var CMD_MEM_SIZE = {
//     M: 3,
//     L: 3,
//     C: 7,
//     Q: 5,
//     A: 9,
//     R: 5,
//     Z: 1
// };

var min = [];
var max = [];
var min2 = [];
var max2 = [];
var mathMin = Math.min;
var mathMax = Math.max;
var mathCos = Math.cos;
var mathSin = Math.sin;
var mathSqrt = Math.sqrt;
var mathAbs = Math.abs;
var hasTypedArray = typeof Float32Array != 'undefined';
/**
 * @alias module:zrender/core/PathProxy
 * @constructor
 */

var PathProxy = function (notSaveData) {
  this._saveData = !(notSaveData || false);

  if (this._saveData) {
    /**
     * Path data. Stored as flat array
     * @type {Array.<Object>}
     */
    this.data = [];
  }

  this._ctx = null;
};
/**
 * 快速计算Path包围盒（并不是最小包围盒）
 * @return {Object}
 */


PathProxy.prototype = {
  constructor: PathProxy,
  _xi: 0,
  _yi: 0,
  _x0: 0,
  _y0: 0,
  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
  _ux: 0,
  _uy: 0,
  _len: 0,
  _lineDash: null,
  _dashOffset: 0,
  _dashIdx: 0,
  _dashSum: 0,

  /**
   * @readOnly
   */
  setScale: function (sx, sy) {
    this._ux = mathAbs(1 / dpr / sx) || 0;
    this._uy = mathAbs(1 / dpr / sy) || 0;
  },
  getContext: function () {
    return this._ctx;
  },

  /**
   * @param  {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  beginPath: function (ctx) {
    this._ctx = ctx;
    ctx && ctx.beginPath();
    ctx && (this.dpr = ctx.dpr); // Reset

    if (this._saveData) {
      this._len = 0;
    }

    if (this._lineDash) {
      this._lineDash = null;
      this._dashOffset = 0;
    }

    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  moveTo: function (x, y) {
    this.addData(CMD.M, x, y);
    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持

    this._x0 = x;
    this._y0 = y;
    this._xi = x;
    this._yi = y;
    return this;
  },

  /**
   * @param  {number} x
   * @param  {number} y
   * @return {module:zrender/core/PathProxy}
   */
  lineTo: function (x, y) {
    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
    || this._len < 5;
    this.addData(CMD.L, x, y);

    if (this._ctx && exceedUnit) {
      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
    }

    if (exceedUnit) {
      this._xi = x;
      this._yi = y;
    }

    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @param  {number} x3
   * @param  {number} y3
   * @return {module:zrender/core/PathProxy}
   */
  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);

    if (this._ctx) {
      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
    }

    this._xi = x3;
    this._yi = y3;
    return this;
  },

  /**
   * @param  {number} x1
   * @param  {number} y1
   * @param  {number} x2
   * @param  {number} y2
   * @return {module:zrender/core/PathProxy}
   */
  quadraticCurveTo: function (x1, y1, x2, y2) {
    this.addData(CMD.Q, x1, y1, x2, y2);

    if (this._ctx) {
      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
    }

    this._xi = x2;
    this._yi = y2;
    return this;
  },

  /**
   * @param  {number} cx
   * @param  {number} cy
   * @param  {number} r
   * @param  {number} startAngle
   * @param  {number} endAngle
   * @param  {boolean} anticlockwise
   * @return {module:zrender/core/PathProxy}
   */
  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
    this._xi = mathCos(endAngle) * r + cx;
    this._yi = mathSin(endAngle) * r + cx;
    return this;
  },
  // TODO
  arcTo: function (x1, y1, x2, y2, radius) {
    if (this._ctx) {
      this._ctx.arcTo(x1, y1, x2, y2, radius);
    }

    return this;
  },
  // TODO
  rect: function (x, y, w, h) {
    this._ctx && this._ctx.rect(x, y, w, h);
    this.addData(CMD.R, x, y, w, h);
    return this;
  },

  /**
   * @return {module:zrender/core/PathProxy}
   */
  closePath: function () {
    this.addData(CMD.Z);
    var ctx = this._ctx;
    var x0 = this._x0;
    var y0 = this._y0;

    if (ctx) {
      this._needsDash() && this._dashedLineTo(x0, y0);
      ctx.closePath();
    }

    this._xi = x0;
    this._yi = y0;
    return this;
  },

  /**
   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
   * stroke 同样
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  fill: function (ctx) {
    ctx && ctx.fill();
    this.toStatic();
  },

  /**
   * @param {CanvasRenderingContext2D} ctx
   * @return {module:zrender/core/PathProxy}
   */
  stroke: function (ctx) {
    ctx && ctx.stroke();
    this.toStatic();
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDash: function (lineDash) {
    if (lineDash instanceof Array) {
      this._lineDash = lineDash;
      this._dashIdx = 0;
      var lineDashSum = 0;

      for (var i = 0; i < lineDash.length; i++) {
        lineDashSum += lineDash[i];
      }

      this._dashSum = lineDashSum;
    }

    return this;
  },

  /**
   * 必须在其它绘制命令前调用
   * Must be invoked before all other path drawing methods
   * @return {module:zrender/core/PathProxy}
   */
  setLineDashOffset: function (offset) {
    this._dashOffset = offset;
    return this;
  },

  /**
   *
   * @return {boolean}
   */
  len: function () {
    return this._len;
  },

  /**
   * 直接设置 Path 数据
   */
  setData: function (data) {
    var len = data.length;

    if (!(this.data && this.data.length == len) && hasTypedArray) {
      this.data = new Float32Array(len);
    }

    for (var i = 0; i < len; i++) {
      this.data[i] = data[i];
    }

    this._len = len;
  },

  /**
   * 添加子路径
   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
   */
  appendPath: function (path) {
    if (!(path instanceof Array)) {
      path = [path];
    }

    var len = path.length;
    var appendSize = 0;
    var offset = this._len;

    for (var i = 0; i < len; i++) {
      appendSize += path[i].len();
    }

    if (hasTypedArray && this.data instanceof Float32Array) {
      this.data = new Float32Array(offset + appendSize);
    }

    for (var i = 0; i < len; i++) {
      var appendPathData = path[i].data;

      for (var k = 0; k < appendPathData.length; k++) {
        this.data[offset++] = appendPathData[k];
      }
    }

    this._len = offset;
  },

  /**
   * 填充 Path 数据。
   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
   */
  addData: function (cmd) {
    if (!this._saveData) {
      return;
    }

    var data = this.data;

    if (this._len + arguments.length > data.length) {
      // 因为之前的数组已经转换成静态的 Float32Array
      // 所以不够用时需要扩展一个新的动态数组
      this._expandData();

      data = this.data;
    }

    for (var i = 0; i < arguments.length; i++) {
      data[this._len++] = arguments[i];
    }

    this._prevCmd = cmd;
  },
  _expandData: function () {
    // Only if data is Float32Array
    if (!(this.data instanceof Array)) {
      var newData = [];

      for (var i = 0; i < this._len; i++) {
        newData[i] = this.data[i];
      }

      this.data = newData;
    }
  },

  /**
   * If needs js implemented dashed line
   * @return {boolean}
   * @private
   */
  _needsDash: function () {
    return this._lineDash;
  },
  _dashedLineTo: function (x1, y1) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var dx = x1 - x0;
    var dy = y1 - y0;
    var dist = mathSqrt(dx * dx + dy * dy);
    var x = x0;
    var y = y0;
    var dash;
    var nDash = lineDash.length;
    var idx;
    dx /= dist;
    dy /= dist;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum;
    x -= offset * dx;
    y -= offset * dy;

    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx == 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
      idx = this._dashIdx;
      dash = lineDash[idx];
      x += dx * dash;
      y += dy * dash;
      this._dashIdx = (idx + 1) % nDash; // Skip positive offset

      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
        continue;
      }

      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
    } // Offset for next lineTo


    dx = x - x1;
    dy = y - y1;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  // Not accurate dashed line to
  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
    var dashSum = this._dashSum;
    var offset = this._dashOffset;
    var lineDash = this._lineDash;
    var ctx = this._ctx;
    var x0 = this._xi;
    var y0 = this._yi;
    var t;
    var dx;
    var dy;
    var cubicAt = curve.cubicAt;
    var bezierLen = 0;
    var idx = this._dashIdx;
    var nDash = lineDash.length;
    var x;
    var y;
    var tmpLen = 0;

    if (offset < 0) {
      // Convert to positive offset
      offset = dashSum + offset;
    }

    offset %= dashSum; // Bezier approx length

    for (t = 0; t < 1; t += 0.1) {
      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
      bezierLen += mathSqrt(dx * dx + dy * dy);
    } // Find idx after add offset


    for (; idx < nDash; idx++) {
      tmpLen += lineDash[idx];

      if (tmpLen > offset) {
        break;
      }
    }

    t = (tmpLen - offset) / bezierLen;

    while (t <= 1) {
      x = cubicAt(x0, x1, x2, x3, t);
      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
      // Bad result if dash is long

      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      t += lineDash[idx] / bezierLen;
      idx = (idx + 1) % nDash;
    } // Finish the last segment and calculate the new offset


    idx % 2 !== 0 && ctx.lineTo(x3, y3);
    dx = x3 - x;
    dy = y3 - y;
    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
  },
  _dashedQuadraticTo: function (x1, y1, x2, y2) {
    // Convert quadratic to cubic using degree elevation
    var x3 = x2;
    var y3 = y2;
    x2 = (x2 + 2 * x1) / 3;
    y2 = (y2 + 2 * y1) / 3;
    x1 = (this._xi + 2 * x1) / 3;
    y1 = (this._yi + 2 * y1) / 3;

    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
  },

  /**
   * 转成静态的 Float32Array 减少堆内存占用
   * Convert dynamic array to static Float32Array
   */
  toStatic: function () {
    var data = this.data;

    if (data instanceof Array) {
      data.length = this._len;

      if (hasTypedArray) {
        this.data = new Float32Array(data);
      }
    }
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
    var data = this.data;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;

    for (var i = 0; i < data.length;) {
      var cmd = data[i++];

      if (i == 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = data[i];
        yi = data[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
          // 在 closePath 的时候使用
          x0 = data[i++];
          y0 = data[i++];
          xi = x0;
          yi = y0;
          min2[0] = x0;
          min2[1] = y0;
          max2[0] = x0;
          max2[1] = y0;
          break;

        case CMD.L:
          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.C:
          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.Q:
          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
          xi = data[i++];
          yi = data[i++];
          break;

        case CMD.A:
          // TODO Arc 判断的开销比较大
          var cx = data[i++];
          var cy = data[i++];
          var rx = data[i++];
          var ry = data[i++];
          var startAngle = data[i++];
          var endAngle = data[i++] + startAngle; // TODO Arc 旋转

          var psi = data[i++];
          var anticlockwise = 1 - data[i++];

          if (i == 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(startAngle) * rx + cx;
            y0 = mathSin(startAngle) * ry + cy;
          }

          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = data[i++];
          y0 = yi = data[i++];
          var width = data[i++];
          var height = data[i++]; // Use fromLine

          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
          break;

        case CMD.Z:
          xi = x0;
          yi = y0;
          break;
      } // Union


      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * Rebuild path from current data
   * Rebuild path will not consider javascript implemented line dash.
   * @param {CanvasRenderingContext2D} ctx
   */
  rebuildPath: function (ctx) {
    var d = this.data;
    var x0, y0;
    var xi, yi;
    var x, y;
    var ux = this._ux;
    var uy = this._uy;
    var len = this._len;

    for (var i = 0; i < len;) {
      var cmd = d[i++];

      if (i == 1) {
        // 如果第一个命令是 L, C, Q
        // 则 previous point 同绘制命令的第一个 point
        //
        // 第一个命令为 Arc 的情况下会在后面特殊处理
        xi = d[i];
        yi = d[i + 1];
        x0 = xi;
        y0 = yi;
      }

      switch (cmd) {
        case CMD.M:
          x0 = xi = d[i++];
          y0 = yi = d[i++];
          ctx.moveTo(xi, yi);
          break;

        case CMD.L:
          x = d[i++];
          y = d[i++]; // Not draw too small seg between

          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
            ctx.lineTo(x, y);
            xi = x;
            yi = y;
          }

          break;

        case CMD.C:
          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.Q:
          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
          xi = d[i - 2];
          yi = d[i - 1];
          break;

        case CMD.A:
          var cx = d[i++];
          var cy = d[i++];
          var rx = d[i++];
          var ry = d[i++];
          var theta = d[i++];
          var dTheta = d[i++];
          var psi = d[i++];
          var fs = d[i++];
          var r = rx > ry ? rx : ry;
          var scaleX = rx > ry ? 1 : rx / ry;
          var scaleY = rx > ry ? ry / rx : 1;
          var isEllipse = Math.abs(rx - ry) > 1e-3;
          var endAngle = theta + dTheta;

          if (isEllipse) {
            ctx.translate(cx, cy);
            ctx.rotate(psi);
            ctx.scale(scaleX, scaleY);
            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
            ctx.scale(1 / scaleX, 1 / scaleY);
            ctx.rotate(-psi);
            ctx.translate(-cx, -cy);
          } else {
            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
          }

          if (i == 1) {
            // 直接使用 arc 命令
            // 第一个命令起点还未定义
            x0 = mathCos(theta) * rx + cx;
            y0 = mathSin(theta) * ry + cy;
          }

          xi = mathCos(endAngle) * rx + cx;
          yi = mathSin(endAngle) * ry + cy;
          break;

        case CMD.R:
          x0 = xi = d[i];
          y0 = yi = d[i + 1];
          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
          break;

        case CMD.Z:
          ctx.closePath();
          xi = x0;
          yi = y0;
      }
    }
  }
};
PathProxy.CMD = CMD;
var _default = PathProxy;
module.exports = _default;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Eventful = __webpack_require__(194);

exports.Dispatcher = Eventful;

var env = __webpack_require__(64);

/**
 * 事件辅助类
 * @module zrender/core/event
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */
var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;

function getBoundingClientRect(el) {
  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect
  return el.getBoundingClientRect ? el.getBoundingClientRect() : {
    left: 0,
    top: 0
  };
} // `calculate` is optional, default false


function clientToLocal(el, e, out, calculate) {
  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
  // to the padding edge of the target element. The only browser using this convention
  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
  // not support the properties.
  // (see http://www.jacklmoore.com/notes/mouse-position/)
  // In zr painter.dom, padding edge equals to border edge.
  // FIXME
  // When mousemove event triggered on ec tooltip, target is not zr painter.dom, and
  // offsetX/Y is relative to e.target, where the calculation of zrX/Y via offsetX/Y
  // is too complex. So css-transfrom dont support in this case temporarily.

  if (calculate || !env.canvasSupported) {
    defaultGetZrXY(el, e, out);
  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
  // zoom-factor, overflow / opacity layers, transforms ...)
  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
  // <https://bugs.jquery.com/ticket/8523#comment:14>
  // BTW3, In ff, offsetX/offsetY is always 0.
  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
      out.zrX = e.layerX;
      out.zrY = e.layerY;
    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
    else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
      } // For some other device, e.g., IOS safari.
      else {
          defaultGetZrXY(el, e, out);
        }

  return out;
}

function defaultGetZrXY(el, e, out) {
  // This well-known method below does not support css transform.
  var box = getBoundingClientRect(el);
  out.zrX = e.clientX - box.left;
  out.zrY = e.clientY - box.top;
}
/**
 * 如果存在第三方嵌入的一些dom触发的事件，或touch事件，需要转换一下事件坐标.
 * `calculate` is optional, default false.
 */


function normalizeEvent(el, e, calculate) {
  e = e || window.event;

  if (e.zrX != null) {
    return e;
  }

  var eventType = e.type;
  var isTouch = eventType && eventType.indexOf('touch') >= 0;

  if (!isTouch) {
    clientToLocal(el, e, e, calculate);
    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
  } else {
    var touch = eventType != 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
    touch && clientToLocal(el, touch, e, calculate);
  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
  // If e.which has been defined, if may be readonly,
  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which


  var button = e.button;

  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
  }

  return e;
}

function addEventListener(el, name, handler) {
  if (isDomLevel2) {
    el.addEventListener(name, handler);
  } else {
    el.attachEvent('on' + name, handler);
  }
}

function removeEventListener(el, name, handler) {
  if (isDomLevel2) {
    el.removeEventListener(name, handler);
  } else {
    el.detachEvent('on' + name, handler);
  }
}
/**
 * preventDefault and stopPropagation.
 * Notice: do not do that in zrender. Upper application
 * do that if necessary.
 *
 * @memberOf module:zrender/core/event
 * @method
 * @param {Event} e : event对象
 */


var stop = isDomLevel2 ? function (e) {
  e.preventDefault();
  e.stopPropagation();
  e.cancelBubble = true;
} : function (e) {
  e.returnValue = false;
  e.cancelBubble = true;
};

function notLeftMouse(e) {
  // If e.which is undefined, considered as left mouse event.
  return e.which > 1;
} // 做向上兼容


exports.clientToLocal = clientToLocal;
exports.normalizeEvent = normalizeEvent;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;
exports.stop = stop;
exports.notLeftMouse = notLeftMouse;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

/**
 * 事件扩展
 * @module zrender/mixin/Eventful
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */
var arrySlice = Array.prototype.slice;
/**
 * 事件分发器
 * @alias module:zrender/mixin/Eventful
 * @constructor
 */

var Eventful = function () {
  this._$handlers = {};
};

Eventful.prototype = {
  constructor: Eventful,

  /**
   * 单次触发绑定，trigger后销毁
   *
   * @param {string} event 事件名
   * @param {Function} handler 响应函数
   * @param {Object} context
   */
  one: function (event, handler, context) {
    var _h = this._$handlers;

    if (!handler || !event) {
      return this;
    }

    if (!_h[event]) {
      _h[event] = [];
    }

    for (var i = 0; i < _h[event].length; i++) {
      if (_h[event][i].h === handler) {
        return this;
      }
    }

    _h[event].push({
      h: handler,
      one: true,
      ctx: context || this
    });

    return this;
  },

  /**
   * 绑定事件
   * @param {string} event 事件名
   * @param {Function} handler 事件处理函数
   * @param {Object} [context]
   */
  on: function (event, handler, context) {
    var _h = this._$handlers;

    if (!handler || !event) {
      return this;
    }

    if (!_h[event]) {
      _h[event] = [];
    }

    for (var i = 0; i < _h[event].length; i++) {
      if (_h[event][i].h === handler) {
        return this;
      }
    }

    _h[event].push({
      h: handler,
      one: false,
      ctx: context || this
    });

    return this;
  },

  /**
   * 是否绑定了事件
   * @param  {string}  event
   * @return {boolean}
   */
  isSilent: function (event) {
    var _h = this._$handlers;
    return _h[event] && _h[event].length;
  },

  /**
   * 解绑事件
   * @param {string} event 事件名
   * @param {Function} [handler] 事件处理函数
   */
  off: function (event, handler) {
    var _h = this._$handlers;

    if (!event) {
      this._$handlers = {};
      return this;
    }

    if (handler) {
      if (_h[event]) {
        var newList = [];

        for (var i = 0, l = _h[event].length; i < l; i++) {
          if (_h[event][i]['h'] != handler) {
            newList.push(_h[event][i]);
          }
        }

        _h[event] = newList;
      }

      if (_h[event] && _h[event].length === 0) {
        delete _h[event];
      }
    } else {
      delete _h[event];
    }

    return this;
  },

  /**
   * 事件分发
   *
   * @param {string} type 事件类型
   */
  trigger: function (type) {
    if (this._$handlers[type]) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 3) {
        args = arrySlice.call(args, 1);
      }

      var _h = this._$handlers[type];
      var len = _h.length;

      for (var i = 0; i < len;) {
        // Optimize advise from backbone
        switch (argLen) {
          case 1:
            _h[i]['h'].call(_h[i]['ctx']);

            break;

          case 2:
            _h[i]['h'].call(_h[i]['ctx'], args[1]);

            break;

          case 3:
            _h[i]['h'].call(_h[i]['ctx'], args[1], args[2]);

            break;

          default:
            // have more than 2 given arguments
            _h[i]['h'].apply(_h[i]['ctx'], args);

            break;
        }

        if (_h[i]['one']) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    return this;
  },

  /**
   * 带有context的事件分发, 最后一个参数是事件回调的context
   * @param {string} type 事件类型
   */
  triggerWithContext: function (type) {
    if (this._$handlers[type]) {
      var args = arguments;
      var argLen = args.length;

      if (argLen > 4) {
        args = arrySlice.call(args, 1, args.length - 1);
      }

      var ctx = args[args.length - 1];
      var _h = this._$handlers[type];
      var len = _h.length;

      for (var i = 0; i < len;) {
        // Optimize advise from backbone
        switch (argLen) {
          case 1:
            _h[i]['h'].call(ctx);

            break;

          case 2:
            _h[i]['h'].call(ctx, args[1]);

            break;

          case 3:
            _h[i]['h'].call(ctx, args[1], args[2]);

            break;

          default:
            // have more than 2 given arguments
            _h[i]['h'].apply(ctx, args);

            break;
        }

        if (_h[i]['one']) {
          _h.splice(i, 1);

          len--;
        } else {
          i++;
        }
      }
    }

    return this;
  }
}; // 对象可以通过 onxxxx 绑定事件

/**
 * @event module:zrender/mixin/Eventful#onclick
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseout
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousemove
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousewheel
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmousedown
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#onmouseup
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrag
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragstart
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragend
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragenter
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragleave
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondragover
 * @type {Function}
 * @default null
 */

/**
 * @event module:zrender/mixin/Eventful#ondrop
 * @type {Function}
 * @default null
 */

var _default = Eventful;
module.exports = _default;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(709);

var kCSSColorTable = {
  'transparent': [0, 0, 0, 0],
  'aliceblue': [240, 248, 255, 1],
  'antiquewhite': [250, 235, 215, 1],
  'aqua': [0, 255, 255, 1],
  'aquamarine': [127, 255, 212, 1],
  'azure': [240, 255, 255, 1],
  'beige': [245, 245, 220, 1],
  'bisque': [255, 228, 196, 1],
  'black': [0, 0, 0, 1],
  'blanchedalmond': [255, 235, 205, 1],
  'blue': [0, 0, 255, 1],
  'blueviolet': [138, 43, 226, 1],
  'brown': [165, 42, 42, 1],
  'burlywood': [222, 184, 135, 1],
  'cadetblue': [95, 158, 160, 1],
  'chartreuse': [127, 255, 0, 1],
  'chocolate': [210, 105, 30, 1],
  'coral': [255, 127, 80, 1],
  'cornflowerblue': [100, 149, 237, 1],
  'cornsilk': [255, 248, 220, 1],
  'crimson': [220, 20, 60, 1],
  'cyan': [0, 255, 255, 1],
  'darkblue': [0, 0, 139, 1],
  'darkcyan': [0, 139, 139, 1],
  'darkgoldenrod': [184, 134, 11, 1],
  'darkgray': [169, 169, 169, 1],
  'darkgreen': [0, 100, 0, 1],
  'darkgrey': [169, 169, 169, 1],
  'darkkhaki': [189, 183, 107, 1],
  'darkmagenta': [139, 0, 139, 1],
  'darkolivegreen': [85, 107, 47, 1],
  'darkorange': [255, 140, 0, 1],
  'darkorchid': [153, 50, 204, 1],
  'darkred': [139, 0, 0, 1],
  'darksalmon': [233, 150, 122, 1],
  'darkseagreen': [143, 188, 143, 1],
  'darkslateblue': [72, 61, 139, 1],
  'darkslategray': [47, 79, 79, 1],
  'darkslategrey': [47, 79, 79, 1],
  'darkturquoise': [0, 206, 209, 1],
  'darkviolet': [148, 0, 211, 1],
  'deeppink': [255, 20, 147, 1],
  'deepskyblue': [0, 191, 255, 1],
  'dimgray': [105, 105, 105, 1],
  'dimgrey': [105, 105, 105, 1],
  'dodgerblue': [30, 144, 255, 1],
  'firebrick': [178, 34, 34, 1],
  'floralwhite': [255, 250, 240, 1],
  'forestgreen': [34, 139, 34, 1],
  'fuchsia': [255, 0, 255, 1],
  'gainsboro': [220, 220, 220, 1],
  'ghostwhite': [248, 248, 255, 1],
  'gold': [255, 215, 0, 1],
  'goldenrod': [218, 165, 32, 1],
  'gray': [128, 128, 128, 1],
  'green': [0, 128, 0, 1],
  'greenyellow': [173, 255, 47, 1],
  'grey': [128, 128, 128, 1],
  'honeydew': [240, 255, 240, 1],
  'hotpink': [255, 105, 180, 1],
  'indianred': [205, 92, 92, 1],
  'indigo': [75, 0, 130, 1],
  'ivory': [255, 255, 240, 1],
  'khaki': [240, 230, 140, 1],
  'lavender': [230, 230, 250, 1],
  'lavenderblush': [255, 240, 245, 1],
  'lawngreen': [124, 252, 0, 1],
  'lemonchiffon': [255, 250, 205, 1],
  'lightblue': [173, 216, 230, 1],
  'lightcoral': [240, 128, 128, 1],
  'lightcyan': [224, 255, 255, 1],
  'lightgoldenrodyellow': [250, 250, 210, 1],
  'lightgray': [211, 211, 211, 1],
  'lightgreen': [144, 238, 144, 1],
  'lightgrey': [211, 211, 211, 1],
  'lightpink': [255, 182, 193, 1],
  'lightsalmon': [255, 160, 122, 1],
  'lightseagreen': [32, 178, 170, 1],
  'lightskyblue': [135, 206, 250, 1],
  'lightslategray': [119, 136, 153, 1],
  'lightslategrey': [119, 136, 153, 1],
  'lightsteelblue': [176, 196, 222, 1],
  'lightyellow': [255, 255, 224, 1],
  'lime': [0, 255, 0, 1],
  'limegreen': [50, 205, 50, 1],
  'linen': [250, 240, 230, 1],
  'magenta': [255, 0, 255, 1],
  'maroon': [128, 0, 0, 1],
  'mediumaquamarine': [102, 205, 170, 1],
  'mediumblue': [0, 0, 205, 1],
  'mediumorchid': [186, 85, 211, 1],
  'mediumpurple': [147, 112, 219, 1],
  'mediumseagreen': [60, 179, 113, 1],
  'mediumslateblue': [123, 104, 238, 1],
  'mediumspringgreen': [0, 250, 154, 1],
  'mediumturquoise': [72, 209, 204, 1],
  'mediumvioletred': [199, 21, 133, 1],
  'midnightblue': [25, 25, 112, 1],
  'mintcream': [245, 255, 250, 1],
  'mistyrose': [255, 228, 225, 1],
  'moccasin': [255, 228, 181, 1],
  'navajowhite': [255, 222, 173, 1],
  'navy': [0, 0, 128, 1],
  'oldlace': [253, 245, 230, 1],
  'olive': [128, 128, 0, 1],
  'olivedrab': [107, 142, 35, 1],
  'orange': [255, 165, 0, 1],
  'orangered': [255, 69, 0, 1],
  'orchid': [218, 112, 214, 1],
  'palegoldenrod': [238, 232, 170, 1],
  'palegreen': [152, 251, 152, 1],
  'paleturquoise': [175, 238, 238, 1],
  'palevioletred': [219, 112, 147, 1],
  'papayawhip': [255, 239, 213, 1],
  'peachpuff': [255, 218, 185, 1],
  'peru': [205, 133, 63, 1],
  'pink': [255, 192, 203, 1],
  'plum': [221, 160, 221, 1],
  'powderblue': [176, 224, 230, 1],
  'purple': [128, 0, 128, 1],
  'red': [255, 0, 0, 1],
  'rosybrown': [188, 143, 143, 1],
  'royalblue': [65, 105, 225, 1],
  'saddlebrown': [139, 69, 19, 1],
  'salmon': [250, 128, 114, 1],
  'sandybrown': [244, 164, 96, 1],
  'seagreen': [46, 139, 87, 1],
  'seashell': [255, 245, 238, 1],
  'sienna': [160, 82, 45, 1],
  'silver': [192, 192, 192, 1],
  'skyblue': [135, 206, 235, 1],
  'slateblue': [106, 90, 205, 1],
  'slategray': [112, 128, 144, 1],
  'slategrey': [112, 128, 144, 1],
  'snow': [255, 250, 250, 1],
  'springgreen': [0, 255, 127, 1],
  'steelblue': [70, 130, 180, 1],
  'tan': [210, 180, 140, 1],
  'teal': [0, 128, 128, 1],
  'thistle': [216, 191, 216, 1],
  'tomato': [255, 99, 71, 1],
  'turquoise': [64, 224, 208, 1],
  'violet': [238, 130, 238, 1],
  'wheat': [245, 222, 179, 1],
  'white': [255, 255, 255, 1],
  'whitesmoke': [245, 245, 245, 1],
  'yellow': [255, 255, 0, 1],
  'yellowgreen': [154, 205, 50, 1]
};

function clampCssByte(i) {
  // Clamp to integer 0 .. 255.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 255 ? 255 : i;
}

function clampCssAngle(i) {
  // Clamp to integer 0 .. 360.
  i = Math.round(i); // Seems to be what Chrome does (vs truncation).

  return i < 0 ? 0 : i > 360 ? 360 : i;
}

function clampCssFloat(f) {
  // Clamp to float 0.0 .. 1.0.
  return f < 0 ? 0 : f > 1 ? 1 : f;
}

function parseCssInt(str) {
  // int or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssByte(parseFloat(str) / 100 * 255);
  }

  return clampCssByte(parseInt(str, 10));
}

function parseCssFloat(str) {
  // float or percentage.
  if (str.length && str.charAt(str.length - 1) === '%') {
    return clampCssFloat(parseFloat(str) / 100);
  }

  return clampCssFloat(parseFloat(str));
}

function cssHueToRgb(m1, m2, h) {
  if (h < 0) {
    h += 1;
  } else if (h > 1) {
    h -= 1;
  }

  if (h * 6 < 1) {
    return m1 + (m2 - m1) * h * 6;
  }

  if (h * 2 < 1) {
    return m2;
  }

  if (h * 3 < 2) {
    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
  }

  return m1;
}

function lerpNumber(a, b, p) {
  return a + (b - a) * p;
}

function setRgba(out, r, g, b, a) {
  out[0] = r;
  out[1] = g;
  out[2] = b;
  out[3] = a;
  return out;
}

function copyRgba(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

var colorCache = new LRU(20);
var lastRemovedArr = null;

function putToCache(colorStr, rgbaArr) {
  // Reuse removed array
  if (lastRemovedArr) {
    copyRgba(lastRemovedArr, rgbaArr);
  }

  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
}
/**
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 * @memberOf module:zrender/util/color
 */


function parse(colorStr, rgbaArr) {
  if (!colorStr) {
    return;
  }

  rgbaArr = rgbaArr || [];
  var cached = colorCache.get(colorStr);

  if (cached) {
    return copyRgba(rgbaArr, cached);
  } // colorStr may be not string


  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.

  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.

  if (str in kCSSColorTable) {
    copyRgba(rgbaArr, kCSSColorTable[str]);
    putToCache(colorStr, rgbaArr);
    return rgbaArr;
  } // #abc and #abc123 syntax.


  if (str.charAt(0) === '#') {
    if (str.length === 4) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xfff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    } else if (str.length === 7) {
      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.

      if (!(iv >= 0 && iv <= 0xffffff)) {
        setRgba(rgbaArr, 0, 0, 0, 1);
        return; // Covers NaN.
      }

      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
      putToCache(colorStr, rgbaArr);
      return rgbaArr;
    }

    return;
  }

  var op = str.indexOf('('),
      ep = str.indexOf(')');

  if (op !== -1 && ep + 1 === str.length) {
    var fname = str.substr(0, op);
    var params = str.substr(op + 1, ep - (op + 1)).split(',');
    var alpha = 1; // To allow case fallthrough.

    switch (fname) {
      case 'rgba':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        alpha = parseCssFloat(params.pop());
      // jshint ignore:line
      // Fall through.

      case 'rgb':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsla':
        if (params.length !== 4) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        params[3] = parseCssFloat(params[3]);
        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      case 'hsl':
        if (params.length !== 3) {
          setRgba(rgbaArr, 0, 0, 0, 1);
          return;
        }

        hsla2rgba(params, rgbaArr);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;

      default:
        return;
    }
  }

  setRgba(rgbaArr, 0, 0, 0, 1);
  return;
}
/**
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */


function hsla2rgba(hsla, rgba) {
  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
  // NOTE(deanm): According to the CSS spec s/l should only be
  // percentages, but we don't bother and let float or percentage.

  var s = parseCssFloat(hsla[1]);
  var l = parseCssFloat(hsla[2]);
  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
  var m1 = l * 2 - m2;
  rgba = rgba || [];
  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);

  if (hsla.length === 4) {
    rgba[3] = hsla[3];
  }

  return rgba;
}
/**
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */


function rgba2hsla(rgba) {
  if (!rgba) {
    return;
  } // RGB from 0 to 255


  var R = rgba[0] / 255;
  var G = rgba[1] / 255;
  var B = rgba[2] / 255;
  var vMin = Math.min(R, G, B); // Min. value of RGB

  var vMax = Math.max(R, G, B); // Max. value of RGB

  var delta = vMax - vMin; // Delta RGB value

  var L = (vMax + vMin) / 2;
  var H;
  var S; // HSL results from 0 to 1

  if (delta === 0) {
    H = 0;
    S = 0;
  } else {
    if (L < 0.5) {
      S = delta / (vMax + vMin);
    } else {
      S = delta / (2 - vMax - vMin);
    }

    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;

    if (R === vMax) {
      H = deltaB - deltaG;
    } else if (G === vMax) {
      H = 1 / 3 + deltaR - deltaB;
    } else if (B === vMax) {
      H = 2 / 3 + deltaG - deltaR;
    }

    if (H < 0) {
      H += 1;
    }

    if (H > 1) {
      H -= 1;
    }
  }

  var hsla = [H * 360, S, L];

  if (rgba[3] != null) {
    hsla.push(rgba[3]);
  }

  return hsla;
}
/**
 * @param {string} color
 * @param {number} level
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function lift(color, level) {
  var colorArr = parse(color);

  if (colorArr) {
    for (var i = 0; i < 3; i++) {
      if (level < 0) {
        colorArr[i] = colorArr[i] * (1 - level) | 0;
      } else {
        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
      }
    }

    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
  }
}
/**
 * @param {string} color
 * @return {string}
 * @memberOf module:zrender/util/color
 */


function toHex(color) {
  var colorArr = parse(color);

  if (colorArr) {
    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
  }
}
/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */


function fastLerp(normalizedValue, colors, out) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  out = out || [];
  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = colors[leftIndex];
  var rightColor = colors[rightIndex];
  var dv = value - leftIndex;
  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
  return out;
}
/**
 * @deprecated
 */


var fastMapToColor = fastLerp;
/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 * @memberOf module:zrender/util/color
 */

function lerp(normalizedValue, colors, fullOutput) {
  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
    return;
  }

  var value = normalizedValue * (colors.length - 1);
  var leftIndex = Math.floor(value);
  var rightIndex = Math.ceil(value);
  var leftColor = parse(colors[leftIndex]);
  var rightColor = parse(colors[rightIndex]);
  var dv = value - leftIndex;
  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
  return fullOutput ? {
    color: color,
    leftIndex: leftIndex,
    rightIndex: rightIndex,
    value: value
  } : color;
}
/**
 * @deprecated
 */


var mapToColor = lerp;
/**
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */

function modifyHSL(color, h, s, l) {
  color = parse(color);

  if (color) {
    color = rgba2hsla(color);
    h != null && (color[0] = clampCssAngle(h));
    s != null && (color[1] = parseCssFloat(s));
    l != null && (color[2] = parseCssFloat(l));
    return stringify(hsla2rgba(color), 'rgba');
  }
}
/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 * @memberOf module:zrender/util/color
 */


function modifyAlpha(color, alpha) {
  color = parse(color);

  if (color && alpha != null) {
    color[3] = clampCssFloat(alpha);
    return stringify(color, 'rgba');
  }
}
/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */


function stringify(arrColor, type) {
  if (!arrColor || !arrColor.length) {
    return;
  }

  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];

  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
    colorStr += ',' + arrColor[3];
  }

  return type + '(' + colorStr + ')';
}

exports.parse = parse;
exports.lift = lift;
exports.toHex = toHex;
exports.fastLerp = fastLerp;
exports.fastMapToColor = fastMapToColor;
exports.lerp = lerp;
exports.mapToColor = mapToColor;
exports.modifyHSL = modifyHSL;
exports.modifyAlpha = modifyAlpha;
exports.stringify = stringify;

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRiskModalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPayLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return traceSave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var setRiskModalData = function setRiskModalData(text) {
	return {
		type: 'RISK_MODAL_DATA',
		text: text
	};
};

var setPayLoading = function setPayLoading(text) {
	return {
		type: 'SET_PAY_LOADING',
		text: text
	};
};

var traceSave = function traceSave(params) {
	return function () {
		var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
			var action;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							console.log(__WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */]);

							if (!(typeof params == 'undefined')) {
								_context.next = 3;
								break;
							}

							return _context.abrupt('return');

						case 3:
							action = params.action;
							_context.next = 6;
							return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_js__["b" /* getTempInfo */])('shortToken');

						case 6:
							params.token = _context.sent;

							params.action = __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].traceAction[action];
							params.appName = __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].appName;
							params.appVersion = __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].appVersion;
							_context.next = 12;
							return __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].deviceName;

						case 12:
							params.deviceName = _context.sent;

							params.deviceType = __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].deviceType;
							params.os = __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].os;
							params.deviceId = __WEBPACK_IMPORTED_MODULE_1__common_js__["g" /* traceSaveParams */].deviceId;
							__WEBPACK_IMPORTED_MODULE_2__util___default.a.post(__WEBPACK_IMPORTED_MODULE_2__util___default.a.url + '/api/account/traceSave', params, function (suc) {
								return console.log('留痕', params, suc);
							}, function (err) {
								return console.log('留痕失败', params, err);
							});

						case 17:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}));

		return function (_x, _x2) {
			return _ref.apply(this, arguments);
		};
	}();
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-xiaoitishi.87eace60.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.isVideoChild = isVideoChild;
exports.mergeAndSortChildren = mergeAndSortChildren;
exports.deprecatedWarning = deprecatedWarning;
exports.throttle = throttle;
exports.mediaProperties = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1956));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(782));

var _react = _interopRequireDefault(__webpack_require__(0));

// NaN is the only value in javascript which is not equal to itself.
// eslint-disable-next-line no-self-compare
var isNaN = Number.isNaN || function (value) {
  return value !== value;
};
/**
 * @file format-time.js
 *
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @private
 * @function formatTime
 */


function formatTime() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600); // handle invalid times

  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = '-';
    m = '-';
    s = '-';
  } // Check if we need to show hours


  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.

  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds

  s = s < 10 ? "0".concat(s) : s;
  return h + m + s;
} // Check if the element belongs to a video element
// only accept <source />, <track />,
// <MyComponent isVideoChild />
// elements


function isVideoChild(c) {
  if (c.props && c.props.isVideoChild) {
    return true;
  }

  return c.type === 'source' || c.type === 'track';
}

var find = function find(elements, func) {
  return elements.filter(func)[0];
}; // check if two components are the same type


var isTypeEqual = function isTypeEqual(component1, component2) {
  var type1 = component1.type;
  var type2 = component2.type;

  if (typeof type1 === 'string' || typeof type2 === 'string') {
    return type1 === type2;
  }

  if (typeof type1 === 'function' && typeof type2 === 'function') {
    return type1.displayName === type2.displayName;
  }

  return false;
}; // merge default children
// sort them by `order` property
// filter them by `disabled` property


function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var children = _react["default"].Children.toArray(_children);

  var order = _parentProps.order,
      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent

  return children.filter(function (e) {
    return !e.props.disabled;
  }) // filter the disabled components
  .concat(defaultChildren.filter(function (c) {
    return !find(children, function (component) {
      return isTypeEqual(component, c);
    });
  })).map(function (element) {
    var defaultComponent = find(defaultChildren, function (c) {
      return isTypeEqual(c, element);
    });
    var defaultProps = defaultComponent ? defaultComponent.props : {};
    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);

    var e = _react["default"].cloneElement(element, props, element.props.children);

    return e;
  }).sort(function (a, b) {
    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
  });
}
/**
 * Temporary utility for generating the warnings
 */


function deprecatedWarning(oldMethodCall, newMethodCall) {
  // eslint-disable-next-line no-console
  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
}

function throttle(callback, limit) {
  var _arguments = arguments;
  var wait = false;
  return function () {
    if (!wait) {
      // eslint-disable-next-line prefer-rest-params
      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
exports.mediaProperties = mediaProperties;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child) {
    if (isString(child.type) && isTwoCNChar(child.props.children)) {
        return _react2['default'].cloneElement(child, {}, child.props.children.split('').join(' '));
    }
    if (isString(child)) {
        if (isTwoCNChar(child)) {
            child = child.split('').join(' ');
        }
        return _react2['default'].createElement(
            'span',
            null,
            child
        );
    }
    return child;
}

var Button = function (_React$Component) {
    (0, _inherits3['default'])(Button, _React$Component);

    function Button() {
        (0, _classCallCheck3['default'])(this, Button);
        return (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Button, [{
        key: 'render',
        value: function render() {
            var _wrapCls;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                type = _a.type,
                size = _a.size,
                inline = _a.inline,
                across = _a.across,
                disabled = _a.disabled,
                icon = _a.icon,
                loading = _a.loading,
                activeStyle = _a.activeStyle,
                activeClassName = _a.activeClassName,
                onClick = _a.onClick,
                delayPressIn = _a.delayPressIn,
                delayPressOut = _a.delayPressOut,
                restProps = __rest(_a, ["children", "className", "prefixCls", "type", "size", "inline", "across", "disabled", "icon", "loading", "activeStyle", "activeClassName", "onClick", "delayPressIn", "delayPressOut"]);
            var wrapCls = (_wrapCls = {}, (0, _defineProperty3['default'])(_wrapCls, className, className), (0, _defineProperty3['default'])(_wrapCls, prefixCls, true), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-primary', type === 'primary'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-ghost', type === 'ghost'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-warning', type === 'warning'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-small', size === 'small'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-inline', inline), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-across', across), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-loading', loading), _wrapCls);
            var iconType = loading ? 'loading' : icon;
            var kids = _react2['default'].Children.map(children, insertSpace);
            if (iconType) {
                wrapCls[prefixCls + '-icon'] = true;
            }
            var delayProps = {};
            if (delayPressIn) {
                delayProps.delayPressIn = delayPressIn;
            }
            if (delayPressOut) {
                delayProps.delayPressOut = delayPressOut;
            }
            // use div, button native is buggy @yiminghe
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                (0, _extends3['default'])({ activeClassName: activeClassName || (activeStyle ? prefixCls + '-active' : undefined), disabled: disabled, activeStyle: activeStyle }, delayProps),
                _react2['default'].createElement(
                    'a',
                    (0, _extends3['default'])({ role: 'button', className: (0, _classnames2['default'])(wrapCls) }, restProps, { onClick: disabled ? undefined : onClick, 'aria-disabled': disabled }),
                    iconType ? _react2['default'].createElement(_index2['default'], { 'aria-hidden': 'true', type: iconType, size: size === 'small' ? 'xxs' : 'md' }) : null,
                    kids
                )
            );
        }
    }]);
    return Button;
}(_react2['default'].Component);

Button.defaultProps = {
    prefixCls: 'am-button',
    size: 'large',
    inline: false,
    across: false,
    disabled: false,
    loading: false,
    activeStyle: {}
};
exports['default'] = Button;
module.exports = exports['default'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcDialog = __webpack_require__(212);

var _rcDialog2 = _interopRequireDefault(_rcDialog);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

var _PropsType = __webpack_require__(816);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function checkIfAndroid(platform) {
    return platform === 'android' || platform === 'cross' && typeof window !== 'undefined' && !!navigator.userAgent.match(/Android/i);
}

var Modal = function (_ModalComponent) {
    (0, _inherits3['default'])(Modal, _ModalComponent);

    function Modal(props) {
        (0, _classCallCheck3['default'])(this, Modal);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        _this.state = {
            // in ssr, just set isAndroid false
            // since modal normally won't show at first render, componentDidMount will do double check
            isAndroid: checkIfAndroid(props.platform)
        };
        return _this;
    }

    (0, _createClass3['default'])(Modal, [{
        key: 'isInModal',
        value: function isInModal(e) {
            if (!/\biPhone\b|\biPod\b/i.test(navigator.userAgent)) {
                return;
            }
            // fix touch to scroll background page on iOS
            var prefixCls = this.props.prefixCls;
            var pNode = function (node) {
                while (node.parentNode && node.parentNode !== document.body) {
                    if (node.classList.contains(prefixCls)) {
                        return node;
                    }
                    node = node.parentNode;
                }
            }(e.target);
            if (!pNode) {
                e.preventDefault();
            }
            return true;
        }
    }, {
        key: 'renderFooterButton',
        value: function renderFooterButton(button, prefixCls, i) {
            var buttonStyle = {};
            if (button.style) {
                buttonStyle = button.style;
                if (typeof buttonStyle === 'string') {
                    var styleMap = {
                        cancel: {},
                        'default': {},
                        destructive: { color: 'red' }
                    };
                    buttonStyle = styleMap[buttonStyle] || {};
                }
            }
            var onClickFn = function onClickFn(e) {
                e.preventDefault();
                if (button.onPress) {
                    button.onPress();
                }
            };
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { activeClassName: prefixCls + '-button-active', key: i },
                _react2['default'].createElement(
                    'a',
                    { className: prefixCls + '-button', role: 'button', style: buttonStyle, onClick: onClickFn },
                    button.text || 'Button'
                )
            );
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isAndroid = checkIfAndroid(this.props.platform);
            if (isAndroid !== this.state.isAndroid) {
                this.setState({
                    isAndroid: isAndroid
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _classNames2,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                transparent = _props.transparent,
                animated = _props.animated,
                transitionName = _props.transitionName,
                maskTransitionName = _props.maskTransitionName,
                style = _props.style,
                _props$footer = _props.footer,
                footer = _props$footer === undefined ? [] : _props$footer,
                closable = _props.closable,
                operation = _props.operation;
            var isAndroid = this.state.isAndroid;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-transparent', transparent), (0, _defineProperty3['default'])(_classNames, prefixCls + '-android', isAndroid), _classNames));
            var anim = transitionName || (animated ? transparent ? 'am-fade' : 'am-slide-up' : null);
            var maskAnim = maskTransitionName || (animated ? transparent ? 'am-fade' : 'am-slide-up' : null);
            var btnGroupClass = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-button-group-' + (footer.length === 2 && !operation ? 'h' : 'v'), true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-button-group-' + (operation ? 'operation' : 'normal'), true), _classNames2));
            var footerDom = footer.length ? _react2['default'].createElement(
                'div',
                { className: btnGroupClass, role: 'group' },
                footer.map(function (button, i) {
                    return _this2.renderFooterButton(button, prefixCls, i);
                })
            ) : null;
            // transparent 模式下, 内容默认居中
            var rootStyle = transparent ? (0, _extends3['default'])({ width: '5.4rem', height: 'auto' }, style) : (0, _extends3['default'])({ width: '100%', height: '100%' }, style);
            var restProps = (0, _omit2['default'])(this.props, ['prefixCls', 'className', 'transparent', 'animated', 'transitionName', 'maskTransitionName', 'style', 'footer', 'touchFeedback', 'wrapProps']);
            var wrapProps = { onTouchStart: function onTouchStart(e) {
                    return _this2.isInModal(e);
                } };
            return _react2['default'].createElement(_rcDialog2['default'], (0, _extends3['default'])({ prefixCls: prefixCls, className: wrapCls, transitionName: anim, maskTransitionName: maskAnim, style: rootStyle, footer: footerDom, wrapProps: wrapProps, closable: closable }, restProps));
        }
    }]);
    return Modal;
}(_PropsType.ModalComponent);

exports['default'] = Modal;

Modal.defaultProps = {
    prefixCls: 'am-modal',
    // transparent change to transparent by yiminghe
    transparent: false,
    animated: true,
    style: {},
    onShow: function onShow() {},

    footer: [],
    closable: false,
    operation: false,
    platform: 'cross'
};
module.exports = exports['default'];

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// 引入柱状图
// import 'echarts/lib/chart/bar';


// 引入提示框和标题组件



var CalculatorLine = function (_Component) {
    _inherits(CalculatorLine, _Component);

    function CalculatorLine() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CalculatorLine);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CalculatorLine.__proto__ || Object.getPrototypeOf(CalculatorLine)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            dataYear: []
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CalculatorLine, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dataSource = this.props.dataSource;
            var _props = this.props,
                nowYear = _props.nowYear,
                planType = _props.planType;

            var dataYear = [];
            var fullYear = new Date().getFullYear();
            var nowMonth = parseInt(new Date().getMonth() + 1);
            if (planType == "每月投资方案") {
                for (var i = 0; i <= nowYear * 12; i++) {
                    if (nowMonth == 13) {
                        nowMonth = 1;
                        fullYear++;
                    }
                    if (nowMonth < 10) {
                        dataYear.push(fullYear + "-0" + nowMonth);
                    } else {
                        dataYear.push(fullYear + "-" + nowMonth);
                    }
                    nowMonth++;
                }
            } else if (planType == "一次投资方案") {
                for (var _i = 0; _i <= nowYear; _i++) {
                    dataYear.push(fullYear + _i);
                }
            }
            var option = {
                animation: window.isLess47,
                grid: {
                    top: 28,
                    left: 50,
                    right: 40
                },
                calculable: true,
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    position: [window.winWidth - 160, 0],
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#48b',
                            width: 1,
                            type: 'dashed'
                        },
                        crossStyle: {
                            color: '#1e90ff',
                            width: 1,
                            type: 'dashed'
                        },
                        shadowStyle: {
                            color: 'rgba(150,150,150,0.3)',
                            width: 'auto',
                            type: 'default'
                        }
                    },
                    backgroundColor: "#FFF",
                    textStyle: {
                        fontSize: 11
                    },
                    formatter: '<div style="color:rgb(161,168,179); font-size:11; width: 120px; text-align: right;" ><span >{b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}万元</span> </div>'
                },
                xAxis: [{
                    axisLine: {
                        lineStyle: {
                            width: 1,
                            color: "#CCC"
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            width: 0,
                            color: "#9BC4D8"
                        }
                    },
                    type: 'category',
                    boundaryGap: false,
                    data: dataYear
                }],
                yAxis: [{
                    type: 'value',
                    scale: true,
                    // name:'(人)',
                    axisLine: {
                        lineStyle: {
                            width: 0,
                            color: "rgb(160,167,176)"
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            width: 0,
                            color: "#9BC4D8"
                        }
                    }
                }],
                series: [{
                    name: ' ',
                    type: 'line',
                    stack: '总量',
                    smooth: true, /*线条有弧度*/
                    data: dataSource,
                    itemStyle: {
                        normal: {
                            color: '#fa063a', /*#53C6E0*/
                            lineStyle: {
                                color: '#fa063a'
                            }
                        }
                    }
                }],
                color: ['#fa063a']
            };
            var myChart = __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.init(document.getElementById('echartBox'), null, { renderer: 'svg' });
            // 绘制图表
            myChart.setOption(option);
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                        display: "-webkit-flex",
                        backgroundColor: '#fff',
                        paddingLeft: 13,
                        paddingRight: 13,
                        height: 200,
                        WebkitJustifyContent: "center",
                        WebkitAlignItems: "center",
                        paddingTop: 40
                    } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "rgb(160,167,176)", fontSize: 11, marginBottom: 10, marginLeft: 13 } },
                        '(\u4E07\u5143)'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'echartBox', style: { width: window.winWidth, height: 200 } })
                )
            );
        }
    }]);

    return CalculatorLine;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CalculatorLine);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(460);
__webpack_require__(988);
module.exports = __webpack_require__(60).Array.from;

/***/ }),
/* 203 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(283);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

__webpack_require__(1044);

__webpack_require__(1045);

var createDataSelectAction = __webpack_require__(1032);

var dataColor = __webpack_require__(1095);

var pieLayout = __webpack_require__(1047);

var dataFilter = __webpack_require__(1089);

createDataSelectAction('pie', [{
  type: 'pieToggleSelect',
  event: 'pieselectchanged',
  method: 'toggleSelected'
}, {
  type: 'pieSelect',
  event: 'pieselected',
  method: 'select'
}, {
  type: 'pieUnSelect',
  event: 'pieunselected',
  method: 'unSelect'
}]);
echarts.registerVisual(zrUtil.curry(dataColor, 'pie'));
echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
echarts.registerProcessor(zrUtil.curry(dataFilter, 'pie'));

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Model = __webpack_require__(70);

var each = zrUtil.each;
var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
// allAxesInfo should be updated when setOption performed.

function collect(ecModel, api) {
  var result = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: false,

    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.

  result.seriesInvolved && collectSeriesInfo(result, ecModel);
  return result;
}

function collectAxesInfo(result, ecModel, api) {
  var globalTooltipModel = ecModel.getComponent('tooltip');
  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.

  var linksOption = globalAxisPointerModel.get('link', true) || [];
  var linkGroups = []; // Collect axes info.

  each(api.getCoordinateSystems(), function (coordSys) {
    // Some coordinate system do not support axes, like geo.
    if (!coordSys.axisPointerEnabled) {
      return;
    }

    var coordSysKey = makeKey(coordSys.model);
    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
    // for user. So we enable seting tooltip on coordSys model.

    var coordSysModel = coordSys.model;
    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
    // Notice this case: coordSys is `grid` but not `cartesian2D` here.

    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
    // show but axisPointer will show as normal.
    && baseTooltipModel.get('show')) {
      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));

      if (triggerAxis || cross) {
        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
      }

      if (cross) {
        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
      }
    } // fromTooltip: true | false | 'cross'
    // triggerTooltip: true | false | null


    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
      var axisPointerShow = axisPointerModel.get('show');

      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
        return;
      }

      if (triggerTooltip == null) {
        triggerTooltip = axisPointerModel.get('triggerTooltip');
      }

      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
      var snap = axisPointerModel.get('snap');
      var key = makeKey(axis.model);
      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).

      var axisInfo = result.axesInfo[key] = {
        key: key,
        axis: axis,
        coordSys: coordSys,
        axisPointerModel: axisPointerModel,
        triggerTooltip: triggerTooltip,
        involveSeries: involveSeries,
        snap: snap,
        useHandle: isHandleTrigger(axisPointerModel),
        seriesModels: []
      };
      axesInfoInCoordSys[key] = axisInfo;
      result.seriesInvolved |= involveSeries;
      var groupIndex = getLinkGroupIndex(linksOption, axis);

      if (groupIndex != null) {
        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
          axesInfo: {}
        });
        linkGroup.axesInfo[key] = axisInfo;
        linkGroup.mapper = linksOption[groupIndex].mapper;
        axisInfo.linkGroup = linkGroup;
      }
    }
  });
}

function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
  var volatileOption = {};
  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
  }); // category axis do not auto snap, otherwise some tick that do not
  // has value can not be hovered. value/time/log axis default snap if
  // triggered from tooltip and trigger tooltip.

  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
  // Only these properties can be overrided from tooltip to axisPointer.

  if (tooltipAxisPointerModel.get('type') === 'cross') {
    volatileOption.type = 'line';
  }

  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.

  labelOption.show == null && (labelOption.show = false);

  if (fromTooltip === 'cross') {
    // When 'cross', both axes show labels.
    labelOption.show = true; // If triggerTooltip, this is a base axis, which should better not use cross style
    // (cross style is dashed by default)

    if (!triggerTooltip) {
      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
    }
  }

  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
}

function collectSeriesInfo(result, ecModel) {
  // Prepare data for axis trigger
  ecModel.eachSeries(function (seriesModel) {
    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
    var coordSys = seriesModel.coordinateSystem;
    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
    var seriesTooltipShow = seriesModel.get('tooltip.show', true);

    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
      return;
    }

    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
      var axis = axisInfo.axis;

      if (coordSys.getAxis(axis.dim) === axis) {
        axisInfo.seriesModels.push(seriesModel);
        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
        axisInfo.seriesDataCount += seriesModel.getData().count();
      }
    });
  }, this);
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */


function getLinkGroupIndex(linksOption, axis) {
  var axisModel = axis.model;
  var dim = axis.dim;

  for (var i = 0; i < linksOption.length; i++) {
    var linkOption = linksOption[i] || {};

    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
      return i;
    }
  }
}

function checkPropInLink(linkPropValue, axisPropValue) {
  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}

function fixValue(axisModel) {
  var axisInfo = getAxisInfo(axisModel);

  if (!axisInfo) {
    return;
  }

  var axisPointerModel = axisInfo.axisPointerModel;
  var scale = axisInfo.axis.scale;
  var option = axisPointerModel.option;
  var status = axisPointerModel.get('status');
  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.

  if (value != null) {
    value = scale.parse(value);
  }

  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
  // and status should be initialized.

  if (status == null) {
    option.status = useHandle ? 'show' : 'hide';
  }

  var extent = scale.getExtent().slice();
  extent[0] > extent[1] && extent.reverse();

  if ( // Pick a value on axis when initializing.
  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
  // where we should re-pick a value to keep `handle` displaying normally.
  || value > extent[1]) {
    // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
  }

  if (value < extent[0]) {
    value = extent[0];
  }

  option.value = value;

  if (useHandle) {
    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
  }
}

function getAxisInfo(axisModel) {
  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
}

function getAxisPointerModel(axisModel) {
  var axisInfo = getAxisInfo(axisModel);
  return axisInfo && axisInfo.axisPointerModel;
}

function isHandleTrigger(axisPointerModel) {
  return !!axisPointerModel.get('handle.show');
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */


function makeKey(model) {
  return model.type + '||' + model.id;
}

exports.collect = collect;
exports.fixValue = fixValue;
exports.getAxisInfo = getAxisInfo;
exports.getAxisPointerModel = getAxisPointerModel;
exports.makeKey = makeKey;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

// TODO Parse shadow style
// TODO Only shallow path support
function _default(properties) {
  // Normalize
  for (var i = 0; i < properties.length; i++) {
    if (!properties[i][1]) {
      properties[i][1] = properties[i][0];
    }
  }

  return function (model, excludes, includes) {
    var style = {};

    for (var i = 0; i < properties.length; i++) {
      var propName = properties[i][1];

      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
        continue;
      }

      var val = model.getShallow(propName);

      if (val != null) {
        style[properties[i][0]] = val;
      }
    }

    return style;
  };
}

module.exports = _default;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var clazzUtil = __webpack_require__(92);

/**
 * // Scale class management
 * @module echarts/scale/Scale
 */

/**
 * @param {Object} [setting]
 */
function Scale(setting) {
  this._setting = setting || {};
  /**
   * Extent
   * @type {Array.<number>}
   * @protected
   */

  this._extent = [Infinity, -Infinity];
  /**
   * Step is calculated in adjustExtent
   * @type {Array.<number>}
   * @protected
   */

  this._interval = 0;
  this.init && this.init.apply(this, arguments);
}
/**
 * Parse input val to valid inner number.
 * @param {*} val
 * @return {number}
 */


Scale.prototype.parse = function (val) {
  // Notice: This would be a trap here, If the implementation
  // of this method depends on extent, and this method is used
  // before extent set (like in dataZoom), it would be wrong.
  // Nevertheless, parse does not depend on extent generally.
  return val;
};

Scale.prototype.getSetting = function (name) {
  return this._setting[name];
};

Scale.prototype.contain = function (val) {
  var extent = this._extent;
  return val >= extent[0] && val <= extent[1];
};
/**
 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
 * @param {number} val
 * @return {number}
 */


Scale.prototype.normalize = function (val) {
  var extent = this._extent;

  if (extent[1] === extent[0]) {
    return 0.5;
  }

  return (val - extent[0]) / (extent[1] - extent[0]);
};
/**
 * Scale normalized value
 * @param {number} val
 * @return {number}
 */


Scale.prototype.scale = function (val) {
  var extent = this._extent;
  return val * (extent[1] - extent[0]) + extent[0];
};
/**
 * Set extent from data
 * @param {Array.<number>} other
 */


Scale.prototype.unionExtent = function (other) {
  var extent = this._extent;
  other[0] < extent[0] && (extent[0] = other[0]);
  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
  // this.setExtent(extent[0], extent[1]);
};
/**
 * Set extent from data
 * @param {module:echarts/data/List} data
 * @param {string} dim
 */


Scale.prototype.unionExtentFromData = function (data, dim) {
  this.unionExtent(data.getDataExtent(dim, true));
};
/**
 * Get extent
 * @return {Array.<number>}
 */


Scale.prototype.getExtent = function () {
  return this._extent.slice();
};
/**
 * Set extent
 * @param {number} start
 * @param {number} end
 */


Scale.prototype.setExtent = function (start, end) {
  var thisExtent = this._extent;

  if (!isNaN(start)) {
    thisExtent[0] = start;
  }

  if (!isNaN(end)) {
    thisExtent[1] = end;
  }
};
/**
 * @return {Array.<string>}
 */


Scale.prototype.getTicksLabels = function () {
  var labels = [];
  var ticks = this.getTicks();

  for (var i = 0; i < ticks.length; i++) {
    labels.push(this.getLabel(ticks[i]));
  }

  return labels;
};
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */


Scale.prototype.isBlank = function () {
  return this._isBlank;
},
/**
 * When axis extent depends on data and no data exists,
 * axis ticks should not be drawn, which is named 'blank'.
 */
Scale.prototype.setBlank = function (isBlank) {
  this._isBlank = isBlank;
};
clazzUtil.enableClassExtend(Scale);
clazzUtil.enableClassManagement(Scale, {
  registerWhenExtend: true
});
var _default = Scale;
module.exports = _default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

var BoundingRect = __webpack_require__(63);

// Symbol factory

/**
 * Triangle shape
 * @inner
 */
var Triangle = graphic.extendShape({
  type: 'triangle',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy + height);
    path.lineTo(cx - width, cy + height);
    path.closePath();
  }
});
/**
 * Diamond shape
 * @inner
 */

var Diamond = graphic.extendShape({
  type: 'diamond',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy);
    path.lineTo(cx, cy + height);
    path.lineTo(cx - width, cy);
    path.closePath();
  }
});
/**
 * Pin shape
 * @inner
 */

var Pin = graphic.extendShape({
  type: 'pin',
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var x = shape.x;
    var y = shape.y;
    var w = shape.width / 5 * 3; // Height must be larger than width

    var h = Math.max(w, shape.height);
    var r = w / 2; // Dist on y with tangent point and circle center

    var dy = r * r / (h - r);
    var cy = y - h + r + dy;
    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center

    var dx = Math.cos(angle) * r;
    var tanX = Math.sin(angle);
    var tanY = Math.cos(angle);
    var cpLen = r * 0.6;
    var cpLen2 = r * 0.7;
    path.moveTo(x - dx, cy + dy);
    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
    path.closePath();
  }
});
/**
 * Arrow shape
 * @inner
 */

var Arrow = graphic.extendShape({
  type: 'arrow',
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var height = shape.height;
    var width = shape.width;
    var x = shape.x;
    var y = shape.y;
    var dx = width / 3 * 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx, y + height);
    ctx.lineTo(x, y + height / 4 * 3);
    ctx.lineTo(x - dx, y + height);
    ctx.lineTo(x, y);
    ctx.closePath();
  }
});
/**
 * Map of path contructors
 * @type {Object.<string, module:zrender/graphic/Path>}
 */

var symbolCtors = {
  line: graphic.Line,
  rect: graphic.Rect,
  roundRect: graphic.Rect,
  square: graphic.Rect,
  circle: graphic.Circle,
  diamond: Diamond,
  pin: Pin,
  arrow: Arrow,
  triangle: Triangle
};
var symbolShapeMakers = {
  line: function (x, y, w, h, shape) {
    // FIXME
    shape.x1 = x;
    shape.y1 = y + h / 2;
    shape.x2 = x + w;
    shape.y2 = y + h / 2;
  },
  rect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
  },
  roundRect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
    shape.r = Math.min(w, h) / 4;
  },
  square: function (x, y, w, h, shape) {
    var size = Math.min(w, h);
    shape.x = x;
    shape.y = y;
    shape.width = size;
    shape.height = size;
  },
  circle: function (x, y, w, h, shape) {
    // Put circle in the center of square
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.r = Math.min(w, h) / 2;
  },
  diamond: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  pin: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  arrow: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  triangle: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  }
};
var symbolBuildProxies = {};
zrUtil.each(symbolCtors, function (Ctor, name) {
  symbolBuildProxies[name] = new Ctor();
});
var SymbolClz = graphic.extendShape({
  type: 'symbol',
  shape: {
    symbolType: '',
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  beforeBrush: function () {
    var style = this.style;
    var shape = this.shape; // FIXME

    if (shape.symbolType === 'pin' && style.textPosition === 'inside') {
      style.textPosition = ['50%', '40%'];
      style.textAlign = 'center';
      style.textVerticalAlign = 'middle';
    }
  },
  buildPath: function (ctx, shape, inBundle) {
    var symbolType = shape.symbolType;
    var proxySymbol = symbolBuildProxies[symbolType];

    if (shape.symbolType !== 'none') {
      if (!proxySymbol) {
        // Default rect
        symbolType = 'rect';
        proxySymbol = symbolBuildProxies[symbolType];
      }

      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
    }
  }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside

function symbolPathSetColor(color, innerColor) {
  if (this.type !== 'image') {
    var symbolStyle = this.style;
    var symbolShape = this.shape;

    if (symbolShape && symbolShape.symbolType === 'line') {
      symbolStyle.stroke = color;
    } else if (this.__isEmptyBrush) {
      symbolStyle.stroke = color;
      symbolStyle.fill = innerColor || '#fff';
    } else {
      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
      symbolStyle.fill && (symbolStyle.fill = color);
      symbolStyle.stroke && (symbolStyle.stroke = color);
    }

    this.dirty(false);
  }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 * @param {string} symbolType
 * @param {number} x
 * @param {number} y
 * @param {number} w
 * @param {number} h
 * @param {string} color
 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
 *                            for path and image only.
 */


function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
  // TODO Support image object, DynamicImage.
  var isEmpty = symbolType.indexOf('empty') === 0;

  if (isEmpty) {
    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
  }

  var symbolPath;

  if (symbolType.indexOf('image://') === 0) {
    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else if (symbolType.indexOf('path://') === 0) {
    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else {
    symbolPath = new SymbolClz({
      shape: {
        symbolType: symbolType,
        x: x,
        y: y,
        width: w,
        height: h
      }
    });
  }

  symbolPath.__isEmptyBrush = isEmpty;
  symbolPath.setColor = symbolPathSetColor;
  symbolPath.setColor(color);
  return symbolPath;
}

exports.createSymbol = createSymbol;

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dialog__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_util_es_getContainerRenderMixin__ = __webpack_require__(1420);





var DialogWrap = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'DialogWrap',
    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rc_util_es_getContainerRenderMixin__["a" /* default */])({
        isVisible: function isVisible(instance) {
            return instance.props.visible;
        },

        autoDestroy: false,
        getComponent: function getComponent(instance, extra) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, instance.props, extra, { key: "dialog" }));
        },
        getContainer: function getContainer(instance) {
            if (instance.props.getContainer) {
                return instance.props.getContainer();
            }
            var container = document.createElement('div');
            document.body.appendChild(container);
            return container;
        }
    })],
    getDefaultProps: function getDefaultProps() {
        return {
            visible: false
        };
    },
    shouldComponentUpdate: function shouldComponentUpdate(_ref) {
        var visible = _ref.visible;

        return !!(this.props.visible || visible);
    },
    componentWillUnmount: function componentWillUnmount() {
        if (this.props.visible) {
            this.renderComponent({
                afterClose: this.removeContainer,
                onClose: function onClose() {},

                visible: false
            });
        } else {
            this.removeContainer();
        }
    },
    getElement: function getElement(part) {
        return this._component.getElement(part);
    },
    render: function render() {
        return null;
    }
});
/* harmony default export */ __webpack_exports__["default"] = (DialogWrap);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(506);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1255);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(318);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1336)();
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var EventPluginRegistry = __webpack_require__(342);
var ReactEventEmitterMixin = __webpack_require__(1454);
var ViewportMetrics = __webpack_require__(555);

var getVendorPrefixedEventName = __webpack_require__(1486);
var isEventSupported = __webpack_require__(353);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(181);
var ViewportMetrics = __webpack_require__(555);

var getEventModifierState = __webpack_require__(351);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(57);
var DOMNamespaces = __webpack_require__(341);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(349);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1579);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1578);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(608);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(608);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(624);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _MultiPickerMixin = __webpack_require__(1625);

var _MultiPickerMixin2 = _interopRequireDefault(_MultiPickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MultiPicker = (0, _createReactClass2['default'])({
    mixins: [_MultiPickerMixin2['default']],
    render: function render() {
        var _this = this;

        var _props = this.props,
            prefixCls = _props.prefixCls,
            className = _props.className,
            rootNativeProps = _props.rootNativeProps,
            children = _props.children;

        var selectedValue = this.getValue();
        var colElements = _react2['default'].Children.map(children, function (col, i) {
            return _react2['default'].cloneElement(col, {
                selectedValue: selectedValue[i],
                onValueChange: function onValueChange() {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return _this.onValueChange.apply(_this, [i].concat(args));
                }
            });
        });
        return _react2['default'].createElement(
            'div',
            (0, _extends3['default'])({}, rootNativeProps, { style: this.props.style, className: (0, _classnames2['default'])(className, prefixCls) }),
            colElements
        );
    }
});
exports['default'] = MultiPicker;
module.exports = exports['default'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(623);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(624);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _zscroller = __webpack_require__(1949);

var _zscroller2 = _interopRequireDefault(_zscroller);

var _PickerMixin = __webpack_require__(1626);

var _PickerMixin2 = _interopRequireDefault(_PickerMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Picker = (0, _createReactClass2['default'])({
    mixins: [_PickerMixin2['default']],
    statics: {
        Item: function Item() {}
    },
    getDefaultProps: function getDefaultProps() {
        return {
            prefixCls: 'rmc-picker'
        };
    },
    getInitialState: function getInitialState() {
        var selectedValueState = void 0;
        var _props = this.props,
            selectedValue = _props.selectedValue,
            defaultSelectedValue = _props.defaultSelectedValue;

        if (selectedValue !== undefined) {
            selectedValueState = selectedValue;
        } else if (defaultSelectedValue !== undefined) {
            selectedValueState = defaultSelectedValue;
        } else {
            var children = _react2['default'].Children.toArray(this.props.children);
            selectedValueState = children && children[0] && children[0].props.value;
        }
        return {
            selectedValue: selectedValueState
        };
    },
    componentDidMount: function componentDidMount() {
        var _refs = this.refs,
            content = _refs.content,
            indicator = _refs.indicator,
            mask = _refs.mask,
            root = _refs.root;

        var rootHeight = root.getBoundingClientRect().height;
        // https://github.com/react-component/m-picker/issues/18
        var itemHeight = this.itemHeight = indicator.getBoundingClientRect().height;
        var num = Math.floor(rootHeight / itemHeight);
        if (num % 2 === 0) {
            num--;
        }
        num--;
        num /= 2;
        content.style.padding = itemHeight * num + 'px 0';
        indicator.style.top = itemHeight * num + 'px';
        mask.style.backgroundSize = '100% ' + itemHeight * num + 'px';
        this.zscroller = new _zscroller2['default'](content, {
            scrollingX: false,
            snapping: true,
            locking: false,
            penetrationDeceleration: .1,
            minVelocityToKeepDecelerating: 0.5,
            scrollingComplete: this.scrollingComplete
        });
        this.zscroller.setDisabled(this.props.disabled);
        this.zscroller.scroller.setSnapSize(0, itemHeight);
        this.select(this.state.selectedValue);
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if ('selectedValue' in nextProps) {
            this.setState({
                selectedValue: nextProps.selectedValue
            });
        }
        this.zscroller.setDisabled(nextProps.disabled);
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return this.state.selectedValue !== nextState.selectedValue || this.props.children !== nextProps.children;
    },
    componentDidUpdate: function componentDidUpdate() {
        this.zscroller.reflow();
        this.select(this.state.selectedValue);
    },
    componentWillUnmount: function componentWillUnmount() {
        this.zscroller.destroy();
    },
    scrollTo: function scrollTo(top) {
        this.zscroller.scroller.scrollTo(0, top);
    },
    fireValueChange: function fireValueChange(selectedValue) {
        if (selectedValue !== this.state.selectedValue) {
            if (!('selectedValue' in this.props)) {
                this.setState({
                    selectedValue: selectedValue
                });
            }
            if (this.props.onValueChange) {
                this.props.onValueChange(selectedValue);
            }
        }
    },
    scrollingComplete: function scrollingComplete() {
        var _zscroller$scroller$g = this.zscroller.scroller.getValues(),
            top = _zscroller$scroller$g.top;

        if (top >= 0) {
            this.doScrollingComplete(top);
        }
    },
    getValue: function getValue() {
        if ('selectedValue' in this.props) {
            return this.props.selectedValue;
        }
        var children = _react2['default'].Children.toArray(this.props.children);
        return children && children[0] && children[0].props.value;
    },
    render: function render() {
        var _pickerCls;

        var props = this.props;
        var prefixCls = props.prefixCls,
            itemStyle = props.itemStyle,
            indicatorStyle = props.indicatorStyle,
            _props$indicatorClass = props.indicatorClassName,
            indicatorClassName = _props$indicatorClass === undefined ? '' : _props$indicatorClass,
            children = props.children;
        var selectedValue = this.state.selectedValue;

        var itemClassName = prefixCls + '-item';
        var selectedItemClassName = itemClassName + ' ' + prefixCls + '-item-selected';
        var map = function map(item) {
            var _item$props = item.props,
                _item$props$className = _item$props.className,
                className = _item$props$className === undefined ? '' : _item$props$className,
                style = _item$props.style,
                value = _item$props.value;

            return _react2['default'].createElement(
                'div',
                { style: (0, _extends3['default'])({}, itemStyle, style), className: (selectedValue === value ? selectedItemClassName : itemClassName) + ' ' + className, key: value },
                item.children || item.props.children
            );
        };
        // compatibility for preact
        var items = _react2['default'].Children ? _react2['default'].Children.map(children, map) : [].concat(children).map(map);
        var pickerCls = (_pickerCls = {}, (0, _defineProperty3['default'])(_pickerCls, props.className, !!props.className), (0, _defineProperty3['default'])(_pickerCls, prefixCls, true), _pickerCls);
        return _react2['default'].createElement(
            'div',
            { className: (0, _classnames2['default'])(pickerCls), ref: 'root', style: this.props.style },
            _react2['default'].createElement('div', { className: prefixCls + '-mask', ref: 'mask' }),
            _react2['default'].createElement('div', { className: prefixCls + '-indicator ' + indicatorClassName, ref: 'indicator', style: indicatorStyle }),
            _react2['default'].createElement(
                'div',
                { className: prefixCls + '-content', ref: 'content' },
                items
            )
        );
    }
});
exports['default'] = Picker;
module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowBm2@4x.baa36db9.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowBm@4x.ad4323a3.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/huakuai.f4e22ef7.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading1.2efc1cd7.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading10.03d2b857.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading11.0789798b.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading12.5ee53af1.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading13.be6ff905.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading14.b50be181.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading15.52995ce1.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading16.e2836002.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading17.5376099a.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading18.77f039c9.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading19.b60dcb72.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading2.f494cd64.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading20.1ea2f408.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading21.7a0510a1.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading22.1a670288.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading23.61af33e3.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading24.e44fb100.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading25.dbe74fdf.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading3.f041ceee.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading4.0b8a77c9.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading5.88609cf5.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading6.59aec344.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading7.f54222cb.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading8.b55ee7ff.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/theLoading9.53a76bda.png";

/***/ }),
/* 260 */
/***/ (function(module, exports) {

var dpr = 1; // If in browser environment

if (typeof window !== 'undefined') {
  dpr = Math.max(window.devicePixelRatio || 1, 1);
}
/**
 * config默认配置项
 * @exports zrender/config
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 */

/**
 * debug日志选项：catchBrushException为true下有效
 * 0 : 不生成debug数据，发布用
 * 1 : 异常抛出，调试用
 * 2 : 控制台输出，调试用
 */


var debugMode = 0; // retina 屏幕优化

var devicePixelRatio = dpr;
exports.debugMode = debugMode;
exports.devicePixelRatio = devicePixelRatio;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Element = __webpack_require__(704);

var BoundingRect = __webpack_require__(63);

/**
 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
 * @module zrender/graphic/Group
 * @example
 *     var Group = require('zrender/container/Group');
 *     var Circle = require('zrender/graphic/shape/Circle');
 *     var g = new Group();
 *     g.position[0] = 100;
 *     g.position[1] = 100;
 *     g.add(new Circle({
 *         style: {
 *             x: 100,
 *             y: 100,
 *             r: 20,
 *         }
 *     }));
 *     zr.add(g);
 */

/**
 * @alias module:zrender/graphic/Group
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @extends module:zrender/mixin/Eventful
 */
var Group = function (opts) {
  opts = opts || {};
  Element.call(this, opts);

  for (var key in opts) {
    if (opts.hasOwnProperty(key)) {
      this[key] = opts[key];
    }
  }

  this._children = [];
  this.__storage = null;
  this.__dirty = true;
};

Group.prototype = {
  constructor: Group,
  isGroup: true,

  /**
   * @type {string}
   */
  type: 'group',

  /**
   * 所有子孙元素是否响应鼠标事件
   * @name module:/zrender/container/Group#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * @return {Array.<module:zrender/Element>}
   */
  children: function () {
    return this._children.slice();
  },

  /**
   * 获取指定 index 的儿子节点
   * @param  {number} idx
   * @return {module:zrender/Element}
   */
  childAt: function (idx) {
    return this._children[idx];
  },

  /**
   * 获取指定名字的儿子节点
   * @param  {string} name
   * @return {module:zrender/Element}
   */
  childOfName: function (name) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].name === name) {
        return children[i];
      }
    }
  },

  /**
   * @return {number}
   */
  childCount: function () {
    return this._children.length;
  },

  /**
   * 添加子节点到最后
   * @param {module:zrender/Element} child
   */
  add: function (child) {
    if (child && child !== this && child.parent !== this) {
      this._children.push(child);

      this._doAdd(child);
    }

    return this;
  },

  /**
   * 添加子节点在 nextSibling 之前
   * @param {module:zrender/Element} child
   * @param {module:zrender/Element} nextSibling
   */
  addBefore: function (child, nextSibling) {
    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
      var children = this._children;
      var idx = children.indexOf(nextSibling);

      if (idx >= 0) {
        children.splice(idx, 0, child);

        this._doAdd(child);
      }
    }

    return this;
  },
  _doAdd: function (child) {
    if (child.parent) {
      child.parent.remove(child);
    }

    child.parent = this;
    var storage = this.__storage;
    var zr = this.__zr;

    if (storage && storage !== child.__storage) {
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }

    zr && zr.refresh();
  },

  /**
   * 移除子节点
   * @param {module:zrender/Element} child
   */
  remove: function (child) {
    var zr = this.__zr;
    var storage = this.__storage;
    var children = this._children;
    var idx = zrUtil.indexOf(children, child);

    if (idx < 0) {
      return this;
    }

    children.splice(idx, 1);
    child.parent = null;

    if (storage) {
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }

    zr && zr.refresh();
    return this;
  },

  /**
   * 移除所有子节点
   */
  removeAll: function () {
    var children = this._children;
    var storage = this.__storage;
    var child;
    var i;

    for (i = 0; i < children.length; i++) {
      child = children[i];

      if (storage) {
        storage.delFromStorage(child);

        if (child instanceof Group) {
          child.delChildrenFromStorage(storage);
        }
      }

      child.parent = null;
    }

    children.length = 0;
    return this;
  },

  /**
   * 遍历所有子节点
   * @param  {Function} cb
   * @param  {}   context
   */
  eachChild: function (cb, context) {
    var children = this._children;

    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      cb.call(context, child, i);
    }

    return this;
  },

  /**
   * 深度优先遍历所有子孙节点
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      cb.call(context, child);

      if (child.type === 'group') {
        child.traverse(cb, context);
      }
    }

    return this;
  },
  addChildrenToStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.addToStorage(child);

      if (child instanceof Group) {
        child.addChildrenToStorage(storage);
      }
    }
  },
  delChildrenFromStorage: function (storage) {
    for (var i = 0; i < this._children.length; i++) {
      var child = this._children[i];
      storage.delFromStorage(child);

      if (child instanceof Group) {
        child.delChildrenFromStorage(storage);
      }
    }
  },
  dirty: function () {
    this.__dirty = true;
    this.__zr && this.__zr.refresh();
    return this;
  },

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function (includeChildren) {
    // TODO Caching
    var rect = null;
    var tmpRect = new BoundingRect(0, 0, 0, 0);
    var children = includeChildren || this._children;
    var tmpMat = [];

    for (var i = 0; i < children.length; i++) {
      var child = children[i];

      if (child.ignore || child.invisible) {
        continue;
      }

      var childRect = child.getBoundingRect();
      var transform = child.getLocalTransform(tmpMat); // TODO
      // The boundingRect cacluated by transforming original
      // rect may be bigger than the actual bundingRect when rotation
      // is used. (Consider a circle rotated aginst its center, where
      // the actual boundingRect should be the same as that not be
      // rotated.) But we can not find better approach to calculate
      // actual boundingRect yet, considering performance.

      if (transform) {
        tmpRect.copy(childRect);
        tmpRect.applyTransform(transform);
        rect = rect || tmpRect.clone();
        rect.union(tmpRect);
      } else {
        rect = rect || childRect.clone();
        rect.union(childRect);
      }
    }

    return rect || tmpRect;
  }
};
zrUtil.inherits(Group, Element);
var _default = Group;
module.exports = _default;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(260);

var debugMode = _config.debugMode;

var log = function () {};

if (debugMode === 1) {
  log = function () {
    for (var k in arguments) {
      throw new Error(arguments[k]);
    }
  };
} else if (debugMode > 1) {
  log = function () {
    for (var k in arguments) {
      console.log(arguments[k]);
    }
  };
}

var _default = log;
module.exports = _default;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(398);

var BoundingRect = __webpack_require__(63);

var zrUtil = __webpack_require__(6);

var imageHelper = __webpack_require__(400);

/**
 * @alias zrender/graphic/Image
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
function ZImage(opts) {
  Displayable.call(this, opts);
}

ZImage.prototype = {
  constructor: ZImage,
  type: 'image',
  brush: function (ctx, prevEl) {
    var style = this.style;
    var src = style.image; // Must bind each time

    style.bind(ctx, this, prevEl);
    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);

    if (!image || !imageHelper.isImageReady(image)) {
      return;
    } // 图片已经加载完成
    // if (image.nodeName.toUpperCase() == 'IMG') {
    //     if (!image.complete) {
    //         return;
    //     }
    // }
    // Else is canvas


    var x = style.x || 0;
    var y = style.y || 0;
    var width = style.width;
    var height = style.height;
    var aspect = image.width / image.height;

    if (width == null && height != null) {
      // Keep image/height ratio
      width = height * aspect;
    } else if (height == null && width != null) {
      height = width / aspect;
    } else if (width == null && height == null) {
      width = image.width;
      height = image.height;
    } // 设置transform


    this.setTransform(ctx);

    if (style.sWidth && style.sHeight) {
      var sx = style.sx || 0;
      var sy = style.sy || 0;
      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
      var sx = style.sx;
      var sy = style.sy;
      var sWidth = width - sx;
      var sHeight = height - sy;
      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else {
      ctx.drawImage(image, x, y, width, height);
    }

    this.restoreTransform(ctx); // Draw rect text

    if (style.text != null) {
      this.drawRectText(ctx, this.getBoundingRect());
    }
  },
  getBoundingRect: function () {
    var style = this.style;

    if (!this._rect) {
      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
    }

    return this._rect;
  }
};
zrUtil.inherits(ZImage, Displayable);
var _default = ZImage;
module.exports = _default;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Displayable = __webpack_require__(398);

var zrUtil = __webpack_require__(6);

var textContain = __webpack_require__(112);

var textHelper = __webpack_require__(401);

/**
 * @alias zrender/graphic/Text
 * @extends module:zrender/graphic/Displayable
 * @constructor
 * @param {Object} opts
 */
var Text = function (opts) {
  // jshint ignore:line
  Displayable.call(this, opts);
};

Text.prototype = {
  constructor: Text,
  type: 'text',
  brush: function (ctx, prevEl) {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.

    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
    var text = style.text; // Convert to string

    text != null && (text += ''); // Always bind style

    style.bind(ctx, this, prevEl);

    if (!textHelper.needDrawText(text, style)) {
      return;
    }

    this.setTransform(ctx);
    textHelper.renderText(this, ctx, text, style);
    this.restoreTransform(ctx);
  },
  getBoundingRect: function () {
    var style = this.style; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);

    if (!this._rect) {
      var text = style.text;
      text != null ? text += '' : text = '';
      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.rich);
      rect.x += style.x || 0;
      rect.y += style.y || 0;

      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
        var w = style.textStrokeWidth;
        rect.x -= w / 2;
        rect.y -= w / 2;
        rect.width += w;
        rect.height += w;
      }

      this._rect = rect;
    }

    return this._rect;
  }
};
zrUtil.inherits(Text, Displayable);
var _default = Text;
module.exports = _default;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(781);
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? Object(arguments[r]) : {},
      o = Object.keys(t);
    "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), o.forEach(function (r) {
      defineProperty(e, r, t[r]);
    });
  }
  return e;
}
module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_productAction_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ChannelNav = function (_Component) {
	_inherits(ChannelNav, _Component);

	function ChannelNav() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ChannelNav);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChannelNav.__proto__ || Object.getPrototypeOf(ChannelNav)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			toggleFlag: "none"
		}, _this.toggleModel = function () {
			_this.setState({
				toggleFlag: _this.state.toggleFlag != "none" ? "none" : "block"
			});
		}, _this.initProductList = function (typeNum, typeName) {
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["m" /* fundLabel */])(null));
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["n" /* fundListGm */])(null));
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["o" /* fundListSm */])(null));
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["p" /* fundListZh */])(null));
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["q" /* fundListJh */])(null));
			if (typeName == "专户计划") {
				_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["r" /* getFundLabel */])({ fund_type: typeNum }, "Z", _this));
			} else {
				_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["r" /* getFundLabel */])({ fund_type: typeNum }, "", _this));
			}
			_this.props._this.setState({
				productValue: typeName,
				labelText: "全部",
				sortValue: "按涨跌幅排序",
				sortValue2: "按万份收益排序",
				sortValue3: "日涨跌幅",
				toggle: false,
				chooseType: "不限",
				chooseType1: "不限",
				chooseType2: "不限",
				chooseType3: "不限",
				chooseType4: "不限",
				chooseTag: "",
				chooseTag1: "",
				chooseTag2: "",
				chooseTag3: "",
				chooseTag4: "",
				startMoney: "起投金额",
				dateFinish: "投资期限"
			});
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])(typeName));
		}, _this.goPublic = function () {
			_this.setState({
				toggleFlag: "none"
			});
			if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
				if (_this.props.productListType != "优选公募") {
					_this.initProductList("G", "优选公募");
				}
			} else {
				_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("优选公募"));
				__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
					pathname: '/offeringList'
				});
			}
		}, _this.goPrivate = function () {
			_this.setState({
				toggleFlag: "none"
			});
			if (_this.props.isLogin) {
				if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
					if (_this.props.productListType != "明星私募") {
						_this.initProductList("S", "明星私募");
					}
				} else {
					_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("明星私募"));
					__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
						pathname: '/offeringList'
					});
				}
			} else {
				__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
					pathname: "/Login",
					state: {
						callback: function callback() {
							if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
								if (_this.props.productListType != "明星私募") {
									_this.initProductList("S", "明星私募");
								}
							} else {
								_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("明星私募"));
								__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
									pathname: '/offeringList'
								});
							}
						},
						route: window.history.length
					}
				});
			}
		}, _this.goSpec = function () {
			_this.setState({
				toggleFlag: "none"
			});
			if (_this.props.isLogin) {
				if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
					if (_this.props.productListType != "专户计划") {
						_this.initProductList("J", "专户计划");
					}
				} else {
					_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("专户计划"));
					__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
						pathname: '/offeringList'
					});
				}
			} else {
				__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
					pathname: "/Login",
					state: {
						callback: function callback() {
							if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
								if (_this.props.productListType != "专户计划") {
									_this.initProductList("J", "专户计划");
								}
							} else {
								_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("专户计划"));
								__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
									pathname: '/offeringList'
								});
							}
						},
						route: window.history.length
					}
				});
			}
		}, _this.goBroker = function () {
			_this.setState({
				toggleFlag: "none"
			});
			if (_this.props.isLogin) {
				if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
					if (_this.props.productListType != "券商集合") {
						_this.initProductList("J", "券商集合");
					}
				} else {
					_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("券商集合"));
					__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
						pathname: '/offeringList'
					});
				}
			} else {
				__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
					pathname: "/Login",
					state: {
						callback: function callback() {
							if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname == "/offeringList") {
								if (_this.props.productListType != "券商集合") {
									_this.initProductList("J", "券商集合");
								}
							} else {
								_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["s" /* productListType */])("券商集合"));
								__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
									pathname: '/offeringList'
								});
							}
						},
						route: window.history.length
					}
				});
			}
		}, _this.goMySelf = function () {
			_this.setState({
				toggleFlag: "none"
			});
			if (_this.props.isLogin) {
				if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname != "/mySelfList") {
					__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
						pathname: "/mySelfList"
					});
				}
			} else {
				__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
					pathname: "/Login",
					state: {
						route: window.history.length,
						callback: function callback() {
							if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname != "/mySelfList") {
								__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
									pathname: "/mySelfList"
								});
							}
						}
					}
				});
			}
		}, _this.goAssets = function () {
			_this.setState({
				toggleFlag: "none"
			});
			if (_this.props.isLogin) {
				if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname != "/myAssets") {
					__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
						pathname: "/myAssets"
					});
				}
			} else {
				__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
					pathname: "/Login",
					state: {
						route: window.history.length,
						callback: function callback() {
							if (__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].getCurrentLocation().pathname != "/myAssets") {
								__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
									pathname: "/myAssets"
								});
							}
						}
					}
				});
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ChannelNav, [{
		key: 'componentWillMount',
		value: function componentWillMount() {}
	}, {
		key: 'dqlc',
		value: function dqlc() {
			__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
				pathname: '/InvestmentPlan',
				state: {}
			});
		}
	}, {
		key: 'home',
		value: function home() {
			__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
				pathname: '/nullView'
			});
		}
	}, {
		key: 'wdtz',
		value: function wdtz() {
			__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
				pathname: '/MyInvestFund',
				state: {}
			});
		}

		//初始化产品数据

	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ style: { position: "relative", width: 30, height: 30 } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { onClick: this.toggleModel, style: { width: 30, height: 30, background: "#fff", position: "absolute", left: 0, top: 0 } }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ style: { display: this.state.toggleFlag, width: window.winWidth, height: window.winHeight - 44, position: "fixed", top: 44, left: 0, background: "rgba(0, 0, 0, 0.2)", zIndex: 10 } },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { height: 330, background: "#fff", color: "#000" } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { height: 40, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", paddingLeft: 13 } },
							'\u9891\u9053\u5BFC\u822A'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { height: 60, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row" } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ onClick: this.home, style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u9996\u9875'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ onClick: this.goAssets, style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u4E2A\u4EBA\u4E2D\u5FC3'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { height: 50, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row" } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" }, onClick: this.goPublic },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u4F18\u9009\u516C\u52DF'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" }, onClick: this.goPrivate },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u660E\u661F\u79C1\u52DF'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%" }, onClick: this.goSpec },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u4E13\u6237\u8BA1\u5212'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { height: 50, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row" } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" }, onClick: this.goBroker },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u5238\u5546\u96C6\u5408'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u96F6\u94B1\u7406\u8D22'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ onClick: this.dqlc, style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u5B9A\u671F\u7406\u8D22'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { height: 50, borderBottom: "1px solid #ddd", WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row" } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ onClick: this.wdtz, style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u6211\u7684\u6295\u8D44'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%", borderRight: "0.5px solid #ddd" }, onClick: this.goMySelf },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u81EA\u9009',
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'span',
									{ style: { color: "transparent" } },
									'\u81EA\u9009'
								)
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", height: "100%" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { width: 15, height: 15, background: "#000", display: "block", marginRight: 5 } }),
								'\u4EA4\u6613\u67E5\u8BE2'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 80, WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "row" } })
					)
				)
			);
		}
	}]);

	return ChannelNav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
	return {
		fundLabel: state.fundLabel,
		fundListGm: state.fundListGm,
		fundListSm: state.fundListSm,
		fundListJh: state.fundListJh,
		fundListZh: state.fundListZh,
		isLogin: state.isLogin,
		productListType: state.productListType
	};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(ChannelNav));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Password_css__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Password_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Password_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var tipText = '密码必须是6至8位的字母或数字组合且不能完全重复';

var Password = function (_Component) {
  _inherits(Password, _Component);

  function Password(props) {
    _classCallCheck(this, Password);

    var _this2 = _possibleConstructorReturn(this, (Password.__proto__ || Object.getPrototypeOf(Password)).call(this, props));

    _this2.state = {
      isShow: true
    };
    return _this2;
  }

  _createClass(Password, [{
    key: 'onKeyup',
    value: function onKeyup(e) {
      var _this = this.props._this;
      // let pattern = Util.passwordPattern;
      if (e.keyCode != 13) {
        return;
      }
      // if(!pattern.test(_this.state.keyPasswordVal)){
      //   Toast.info(tipText, 2);
      //   return;
      // }
      e.keyCode === 13 && _this.keyOk();
    }
  }, {
    key: 'pwdIsOk',
    value: function pwdIsOk() {
      var _this = this.props._this;
      // let pattern = Util.passwordPattern;
      // if(!pattern.test(_this.state.keyPasswordVal)){
      //   Toast.info(tipText, 2);
      //   return;
      // }
      _this.keyOk();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _this = this.props._this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: this.props.ztFlag === true ? "password-sec-box" : "password-box" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '\u4EA4\u6613\u5BC6\u7801',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), onClick: function onClick() {
                _this.setState({ pwdFlag: false });
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'red-t', onClick: function onClick() {
                  _this3.pwdIsOk();
                } },
              ' \u786E\u8BA4'
            )
          ),
          this.props._type == "ZT" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'password-tip' },
            _this.props.fundRisk ? this.props.ztFlag === true ? '温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。' : '温馨提示：您购买产品的风险等级高于自身的风险承受能力，请充分了解投资风险，并确定符合您的投资目标。' : ''
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'password-tip' },
            _this.props.location.state.fundRisk ? '温馨提示：您购买产品的风险等级高于自身的风险承受能力，请充分了解投资风险，并确定符合您的投资目标。' : ''
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'password-input' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                return _this.onChangePwd(e.target.value);
              }, autofocus: 'autofocus', type: this.state.isShow ? "password" : "text", placeholder: '' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', onClick: function onClick() {
                return _this3.setState({ isShow: !_this3.state.isShow });
              }, src: this.state.isShow ? __webpack_require__(394) : __webpack_require__(393) })
          )
        )
      );
    }
  }]);

  return Password;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Password);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var nowTimeStamp = Date.now();
var now = new Date(nowTimeStamp);

var NewDate = new Date();

/*智投历史收益查询*/

var ChooseTime = function (_Component) {
  _inherits(ChooseTime, _Component);

  function ChooseTime(props) {
    _classCallCheck(this, ChooseTime);

    var _this = _possibleConstructorReturn(this, (ChooseTime.__proto__ || Object.getPrototypeOf(ChooseTime)).call(this, props));

    _this.state = {
      modalFlag: false,
      sDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()(now),
      eDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()(now)
    };
    return _this;
  }

  _createClass(ChooseTime, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      var that = this;
      var data = {
        superFundCode: "",
        pageIndex: 1,
        pageSize: 99
        //document.getElementsByTagName('title')[0].innerHTML = "交易记录";
        //dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))
      };
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      console.log(data, "************");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      //hashHistory.go(-1)
      this.props.closeBack();
    }
  }, {
    key: 'goTransactionDetail',
    value: function goTransactionDetail(item) {
      var data = {
        businessType: item.businessType,
        tradeRequestId: item.tradeRequestId
      };
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/TransactionDetail',
        state: {
          data: data
        }
      });
    }
  }, {
    key: 'onOk',
    value: function onOk(e) {
      var dispatch = this.props.dispatch;

      console.log(e.format('YYYY-MM-DD'), "eeeeee");
      // this.setState({ sValue:e })
      // let data = {
      //   superFundCode:e[0],
      //   pageIndex:1,
      //   pageSize:30,
      // }
      // if(e[0] === "0000"){
      //   data.superFundCode = ""
      // }
      //dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),this))
    }
  }, {
    key: 'onOkEndTime',
    value: function onOkEndTime(e) {
      var dispatch = this.props.dispatch;

      console.log(e.format('YYYY-MM-DD'), "eeeeee");
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch() {
      var _state = this.state,
          sDate = _state.sDate,
          eDate = _state.eDate;

      this.props.callback(sDate.format('YYYY-MM-DD'), eDate.format('YYYY-MM-DD'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref,
          _this2 = this;

      var data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
      var tempData = [{ businessTime: "0000" }];
      tempData = tempData.concat(data);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: (_ref = { position: "absolute", top: 0, left: 0, width: "100%" }, _defineProperty(_ref, 'width', "100%"), _defineProperty(_ref, 'height', "100%"), _defineProperty(_ref, 'background', "#FFF"), _ref) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1, flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, flex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u81EA\u9009\u5468\u671F'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, flex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '0.26rem' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'chooseDate', style: { borderBottom: "1px solid #ebeef0", position: 'relative', zIndex: 9 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["DatePicker"],
              {
                mode: 'date',
                title: '\u9009\u62E9\u65F6\u95F4',
                extra: 'Optional',
                value: this.state.sDate,
                onChange: function onChange(sDate) {
                  return _this2.setState({ sDate: sDate });
                },
                onOk: function onOk(e) {
                  _this2.onOk(e);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                { arrow: 'horizontal' },
                '\u8D77\u59CB\u65F6\u95F4'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'chooseDate', style: { borderBottom: "1px solid #ebeef0" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["DatePicker"],
              {
                mode: 'date',
                title: '\u9009\u62E9\u65F6\u95F4',
                extra: 'Optional',
                value: this.state.eDate,
                onChange: function onChange(eDate) {
                  return _this2.setState({ eDate: eDate });
                },
                onOk: function onOk(e) {
                  _this2.onOkEndTime(e);
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                { arrow: 'horizontal' },
                '\u7EC8\u6B62\u65F6\u95F4'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this2.handleSearch();
              }, style: { marginTop: "20px", marginLeft: "13px", marginRight: "13px", borderRadius: "20px", backgroundColor: "rgb(254, 73, 46)", height: "40px", flexDirection: "row", alignItems: "center", justifyContent: "center", display: "flex" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: "rgb(255, 255, 255)", fontSize: "15px" } },
              '\u67E5\u8BE2'
            )
          )
        )
      );
    }
  }]);

  return ChooseTime;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ChooseTime));

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductInfo_css__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ProductInfo_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ProductInfo = function (_Component) {
  _inherits(ProductInfo, _Component);

  function ProductInfo(props) {
    _classCallCheck(this, ProductInfo);

    var _this = _possibleConstructorReturn(this, (ProductInfo.__proto__ || Object.getPrototypeOf(ProductInfo)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ProductInfo, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'onClick',
    value: function onClick() {
      if (this.props.singlePoint) {
        this.props.singlePoint();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var color = ['#fa063a', '#009AA6'];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pro-info', onClick: function onClick() {
            return _this2.onClick();
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pro-info-top' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pro-info-top-text1' },
            this.props.fundName
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-info-top-text2' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pro-info-bottom' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pro-info-bottom-text1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.props.valName,
              ':',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                this.props.val
              ),
              '(' + this.props.valDate + ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pro-info-bottom-text2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.props.rateName,
              ':',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: this.props.rate == '--' || this.props.rate - 0 >= 0 ? { color: color[0] } : { color: color[1] } },
                this.props.rate,
                '%'
              )
            )
          )
        )
      );
    }
  }]);

  return ProductInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ProductInfo.defaultProps = {
  fundName: '--',
  valDate: '--',
  valName: '--',
  val: '--',
  rate: '--',
  rateName: '--'
};
/* harmony default export */ __webpack_exports__["a"] = (ProductInfo);

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_LQB.7bef0a1d.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_arrow_gray@2x.bf7198bb.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_right_arrow.e8ff6bd0.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pay_you_allow.c6d5e5a8.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(403);

var _zrender = __webpack_require__(404);

var registerPainter = _zrender.registerPainter;

var Painter = __webpack_require__(1943);

registerPainter('svg', Painter);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

exports.getComponentLocale = getComponentLocale;
exports.getLocaleCode = getLocaleCode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getComponentLocale(props, context, componentName, getDefaultLocale) {
    var locale = {};
    if (context && context.antLocale && context.antLocale[componentName]) {
        locale = context.antLocale[componentName];
    } else {
        var defaultLocale = getDefaultLocale();
        // TODO: make default lang of antd be English
        // https://github.com/ant-design/ant-design/issues/6334
        locale = defaultLocale['default'] || defaultLocale;
    }
    var result = (0, _extends3['default'])({}, locale);
    if (props.locale) {
        result = (0, _extends3['default'])({}, result, props.locale);
        if (props.locale.lang) {
            result.lang = (0, _extends3['default'])({}, locale.lang, props.locale.lang);
        }
    }
    return result;
}
function getLocaleCode(context) {
    var localeCode = context.antLocale && context.antLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if (context.antLocale && context.antLocale.exist && !localeCode) {
        return 'zh-cn';
    }
    return localeCode;
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcCheckbox = __webpack_require__(493);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Checkbox = function (_React$Component) {
    (0, _inherits3['default'])(Checkbox, _React$Component);

    function Checkbox() {
        (0, _classCallCheck3['default'])(this, Checkbox);
        return (0, _possibleConstructorReturn3['default'])(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Checkbox, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                style = _props.style,
                children = _props.children;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), _classNames));
            var mark = _react2['default'].createElement(
                'label',
                { className: wrapCls, style: style },
                _react2['default'].createElement(_rcCheckbox2['default'], (0, _omit2['default'])(this.props, ['className', 'style'])),
                children
            );
            if (this.props.wrapLabel) {
                return mark;
            }
            return _react2['default'].createElement(_rcCheckbox2['default'], this.props);
        }
    }]);
    return Checkbox;
}(_react2['default'].Component);

exports['default'] = Checkbox;

Checkbox.defaultProps = {
    prefixCls: 'am-checkbox',
    wrapLabel: true
};
module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcCheckbox = __webpack_require__(493);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Radio = function (_React$Component) {
    (0, _inherits3['default'])(Radio, _React$Component);

    function Radio() {
        (0, _classCallCheck3['default'])(this, Radio);
        return (0, _possibleConstructorReturn3['default'])(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Radio, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                style = _props.style,
                children = _props.children;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), _classNames));
            var mark = _react2['default'].createElement(
                'label',
                { className: wrapCls, style: style },
                _react2['default'].createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, (0, _omit2['default'])(this.props, ['className', 'style']), { type: 'radio' })),
                children
            );
            if (this.props.wrapLabel) {
                return mark;
            }
            return _react2['default'].createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, this.props, { type: 'radio' }));
        }
    }]);
    return Radio;
}(_react2['default'].Component);

exports['default'] = Radio;

Radio.defaultProps = {
    prefixCls: 'am-radio',
    wrapLabel: true
};
module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(860);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(859);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnswerAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlerModleTips; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AlertError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AlertResule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



/*弹出框*/
var AnswerAlert = function (_Component) {
  _inherits(AnswerAlert, _Component);

  function AnswerAlert(props) {
    _classCallCheck(this, AnswerAlert);

    var _this = _possibleConstructorReturn(this, (AnswerAlert.__proto__ || Object.getPrototypeOf(AnswerAlert)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(AnswerAlert, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'handdleClose',
    value: function handdleClose() {
      this.props.Close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var width = window.screen.width;
      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: function onTouchmove() {
            _this2.touchmove;
          }, onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: width, position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ruleImgWrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: width - 11 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: this.props.url,
                style: { width: width - 11 }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'closeRuleWrap', style: { width: width } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'closeRule', onClick: function onClick() {
                    _this2.handdleClose();
                  } })
              )
            )
          )
        )
      );
    }
  }]);

  return AnswerAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlerModleTips = function (_Component2) {
  _inherits(AlerModleTips, _Component2);

  function AlerModleTips(props) {
    _classCallCheck(this, AlerModleTips);

    var _this3 = _possibleConstructorReturn(this, (AlerModleTips.__proto__ || Object.getPrototypeOf(AlerModleTips)).call(this, props));

    _this3.state = {};
    return _this3;
  }

  _createClass(AlerModleTips, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "10px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertContent' },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertSureBtn', onClick: function onClick() {
                  _this4.props.handleSure();
                } },
              '\u786E\u8BA4'
            )
          )
        )
      );
    }
  }]);

  return AlerModleTips;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlertError = function (_Component3) {
  _inherits(AlertError, _Component3);

  function AlertError(props) {
    _classCallCheck(this, AlertError);

    var _this5 = _possibleConstructorReturn(this, (AlertError.__proto__ || Object.getPrototypeOf(AlertError)).call(this, props));

    _this5.state = {};
    return _this5;
  }

  _createClass(AlertError, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "10px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'AlertErrorContent', style: { height: 180 } },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alertSureBtn', onClick: function onClick() {
                  _this6.props.handleSure();
                } },
              '\u786E\u8BA4'
            )
          )
        )
      );
    }
  }]);

  return AlertError;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AlertResule = function (_Component4) {
  _inherits(AlertResule, _Component4);

  function AlertResule(props) {
    _classCallCheck(this, AlertResule);

    var _this7 = _possibleConstructorReturn(this, (AlertResule.__proto__ || Object.getPrototypeOf(AlertResule)).call(this, props));

    _this7.state = {};
    return _this7;
  }

  _createClass(AlertResule, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'touchmove',
    value: function touchmove(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      // let data = this.props.location.state.data ? this.props.location.state.data : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AlerModle_DIV', onClick: function onClick(event) {
            event.stopPropagation();return false;
          }, onTouchmove: this.touchmove.bind(this), onTouchstart: function onTouchstart() {
            return false;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "300px", background: "#FFF", borderRadius: "10px", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'AlertErrorContent', style: { height: 280 } },
              this.props.content
            )
          )
        )
      );
    }
  }]);

  return AlertResule;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 281 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(966);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(132)
  , dPs         = __webpack_require__(982)
  , enumBugKeys = __webpack_require__(284)
  , IE_PROTO    = __webpack_require__(290)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(450)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(972).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(203)
  , createDesc     = __webpack_require__(170)
  , toIObject      = __webpack_require__(101)
  , toPrimitive    = __webpack_require__(293)
  , has            = __webpack_require__(115)
  , IE8_DOM_DEFINE = __webpack_require__(451)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(114) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 288 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(100).f
  , has = __webpack_require__(115)
  , TAG = __webpack_require__(85)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(291)('keys')
  , uid    = __webpack_require__(205);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(99)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(167);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(99)
  , core           = __webpack_require__(60)
  , LIBRARY        = __webpack_require__(285)
  , wksExt         = __webpack_require__(295)
  , defineProperty = __webpack_require__(100).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(85);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var coordinateSystemCreators = {};

function CoordinateSystemManager() {
  this._coordinateSystems = [];
}

CoordinateSystemManager.prototype = {
  constructor: CoordinateSystemManager,
  create: function (ecModel, api) {
    var coordinateSystems = [];
    zrUtil.each(coordinateSystemCreators, function (creater, type) {
      var list = creater.create(ecModel, api);
      coordinateSystems = coordinateSystems.concat(list || []);
    });
    this._coordinateSystems = coordinateSystems;
  },
  update: function (ecModel, api) {
    zrUtil.each(this._coordinateSystems, function (coordSys) {
      // FIXME MUST have
      coordSys.update && coordSys.update(ecModel, api);
    });
  },
  getCoordinateSystems: function () {
    return this._coordinateSystems.slice();
  }
};

CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
  coordinateSystemCreators[type] = coordinateSystemCreator;
};

CoordinateSystemManager.get = function (type) {
  return coordinateSystemCreators[type];
};

var _default = CoordinateSystemManager;
module.exports = _default;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var List = __webpack_require__(300);

var completeDimensions = __webpack_require__(301);

var _model = __webpack_require__(45);

var getDataItemValue = _model.getDataItemValue;
var converDataValue = _model.converDataValue;
var isDataItemOption = _model.isDataItemOption;

var CoordinateSystem = __webpack_require__(298);

function firstDataNotNull(data) {
  var i = 0;

  while (i < data.length && data[i] == null) {
    i++;
  }

  return data[i];
}

function ifNeedCompleteOrdinalData(data) {
  var sampleItem = firstDataNotNull(data);
  return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
}
/**
 * Helper function to create a list from option data
 */


function createListFromArray(data, seriesModel, ecModel) {
  // If data is undefined
  data = data || [];
  var coordSysName = seriesModel.get('coordinateSystem');
  var creator = creators[coordSysName];
  var registeredCoordSys = CoordinateSystem.get(coordSysName);
  var completeDimOpt = {
    encodeDef: seriesModel.get('encode'),
    dimsDef: seriesModel.get('dimensions')
  }; // FIXME

  var axesInfo = creator && creator(data, seriesModel, ecModel, completeDimOpt);
  var dimensions = axesInfo && axesInfo.dimensions;

  if (!dimensions) {
    // Get dimensions from registered coordinate system
    dimensions = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
  }

  var categoryIndex = axesInfo ? axesInfo.categoryIndex : -1;
  var list = new List(dimensions, seriesModel);
  var nameList = createNameList(axesInfo, data);
  var categories = {};
  var dimValueGetter = categoryIndex >= 0 && ifNeedCompleteOrdinalData(data) ? function (itemOpt, dimName, dataIndex, dimIndex) {
    // If any dataItem is like { value: 10 }
    if (isDataItemOption(itemOpt)) {
      list.hasItemOption = true;
    } // Use dataIndex as ordinal value in categoryAxis


    return dimIndex === categoryIndex ? dataIndex : converDataValue(getDataItemValue(itemOpt), dimensions[dimIndex]);
  } : function (itemOpt, dimName, dataIndex, dimIndex) {
    var value = getDataItemValue(itemOpt);
    var val = converDataValue(value && value[dimIndex], dimensions[dimIndex]); // If any dataItem is like { value: 10 }

    if (isDataItemOption(itemOpt)) {
      list.hasItemOption = true;
    }

    var categoryAxesModels = axesInfo && axesInfo.categoryAxesModels;

    if (categoryAxesModels && categoryAxesModels[dimName]) {
      // If given value is a category string
      if (typeof val === 'string') {
        // Lazy get categories
        categories[dimName] = categories[dimName] || categoryAxesModels[dimName].getCategories();
        val = zrUtil.indexOf(categories[dimName], val);

        if (val < 0 && !isNaN(val)) {
          // In case some one write '1', '2' istead of 1, 2
          val = +val;
        }
      }
    }

    return val;
  };
  list.hasItemOption = false;
  list.initData(data, nameList, dimValueGetter);
  return list;
}

function isStackable(axisType) {
  return axisType !== 'category' && axisType !== 'time';
}

function getDimTypeByAxis(axisType) {
  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
/**
 * Creaters for each coord system.
 */


var creators = {
  cartesian2d: function (data, seriesModel, ecModel, completeDimOpt) {
    var axesModels = zrUtil.map(['xAxis', 'yAxis'], function (name) {
      return ecModel.queryComponents({
        mainType: name,
        index: seriesModel.get(name + 'Index'),
        id: seriesModel.get(name + 'Id')
      })[0];
    });
    var xAxisModel = axesModels[0];
    var yAxisModel = axesModels[1];
    var xAxisType = xAxisModel.get('type');
    var yAxisType = yAxisModel.get('type');
    var dimensions = [{
      name: 'x',
      type: getDimTypeByAxis(xAxisType),
      stackable: isStackable(xAxisType)
    }, {
      name: 'y',
      // If two category axes
      type: getDimTypeByAxis(yAxisType),
      stackable: isStackable(yAxisType)
    }];
    var isXAxisCateogry = xAxisType === 'category';
    var isYAxisCategory = yAxisType === 'category';
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
    var categoryAxesModels = {};

    if (isXAxisCateogry) {
      categoryAxesModels.x = xAxisModel;
    }

    if (isYAxisCategory) {
      categoryAxesModels.y = yAxisModel;
    }

    return {
      dimensions: dimensions,
      categoryIndex: isXAxisCateogry ? 0 : isYAxisCategory ? 1 : -1,
      categoryAxesModels: categoryAxesModels
    };
  },
  singleAxis: function (data, seriesModel, ecModel, completeDimOpt) {
    var singleAxisModel = ecModel.queryComponents({
      mainType: 'singleAxis',
      index: seriesModel.get('singleAxisIndex'),
      id: seriesModel.get('singleAxisId')
    })[0];
    var singleAxisType = singleAxisModel.get('type');
    var isCategory = singleAxisType === 'category';
    var dimensions = [{
      name: 'single',
      type: getDimTypeByAxis(singleAxisType),
      stackable: isStackable(singleAxisType)
    }];
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
    var categoryAxesModels = {};

    if (isCategory) {
      categoryAxesModels.single = singleAxisModel;
    }

    return {
      dimensions: dimensions,
      categoryIndex: isCategory ? 0 : -1,
      categoryAxesModels: categoryAxesModels
    };
  },
  polar: function (data, seriesModel, ecModel, completeDimOpt) {
    var polarModel = ecModel.queryComponents({
      mainType: 'polar',
      index: seriesModel.get('polarIndex'),
      id: seriesModel.get('polarId')
    })[0];
    var angleAxisModel = polarModel.findAxisModel('angleAxis');
    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
    var radiusAxisType = radiusAxisModel.get('type');
    var angleAxisType = angleAxisModel.get('type');
    var dimensions = [{
      name: 'radius',
      type: getDimTypeByAxis(radiusAxisType),
      stackable: isStackable(radiusAxisType)
    }, {
      name: 'angle',
      type: getDimTypeByAxis(angleAxisType),
      stackable: isStackable(angleAxisType)
    }];
    var isAngleAxisCateogry = angleAxisType === 'category';
    var isRadiusAxisCateogry = radiusAxisType === 'category';
    dimensions = completeDimensions(dimensions, data, completeDimOpt);
    var categoryAxesModels = {};

    if (isRadiusAxisCateogry) {
      categoryAxesModels.radius = radiusAxisModel;
    }

    if (isAngleAxisCateogry) {
      categoryAxesModels.angle = angleAxisModel;
    }

    return {
      dimensions: dimensions,
      categoryIndex: isAngleAxisCateogry ? 1 : isRadiusAxisCateogry ? 0 : -1,
      categoryAxesModels: categoryAxesModels
    };
  },
  geo: function (data, seriesModel, ecModel, completeDimOpt) {
    // TODO Region
    // 多个散点图系列在同一个地区的时候
    return {
      dimensions: completeDimensions([{
        name: 'lng'
      }, {
        name: 'lat'
      }], data, completeDimOpt)
    };
  }
};

function createNameList(result, data) {
  var nameList = [];
  var categoryDim = result && result.dimensions[result.categoryIndex];
  var categoryAxisModel;

  if (categoryDim) {
    categoryAxisModel = result.categoryAxesModels[categoryDim.name];
  }

  if (categoryAxisModel) {
    // FIXME Two category axis
    var categories = categoryAxisModel.getCategories();

    if (categories) {
      var dataLen = data.length; // Ordered data is given explicitly like
      // [[3, 0.2], [1, 0.3], [2, 0.15]]
      // or given scatter data,
      // pick the category

      if (zrUtil.isArray(data[0]) && data[0].length > 1) {
        nameList = [];

        for (var i = 0; i < dataLen; i++) {
          nameList[i] = categories[data[i][result.categoryIndex || 0]];
        }
      } else {
        nameList = categories.slice(0);
      }
    }
  }

  return nameList;
}

var _default = createListFromArray;
module.exports = _default;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var Model = __webpack_require__(70);

var DataDiffer = __webpack_require__(1073);

var modelUtil = __webpack_require__(45);

/**
 * List for data storage
 * @module echarts/data/List
 */
var isObject = zrUtil.isObject;
var UNDEFINED = 'undefined';
var globalObj = typeof window === UNDEFINED ? global : window;
var dataCtors = {
  'float': typeof globalObj.Float64Array === UNDEFINED ? Array : globalObj.Float64Array,
  'int': typeof globalObj.Int32Array === UNDEFINED ? Array : globalObj.Int32Array,
  // Ordinal data type can be string or int
  'ordinal': Array,
  'number': Array,
  'time': Array
};
var TRANSFERABLE_PROPERTIES = ['stackedOn', 'hasItemOption', '_nameList', '_idList', '_rawData'];

function transferProperties(a, b) {
  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(b.__wrappedMethods || []), function (propName) {
    if (b.hasOwnProperty(propName)) {
      a[propName] = b[propName];
    }
  });
  a.__wrappedMethods = b.__wrappedMethods;
}

function DefaultDataProvider(dataArray) {
  this._array = dataArray || [];
}

DefaultDataProvider.prototype.pure = false;

DefaultDataProvider.prototype.count = function () {
  return this._array.length;
};

DefaultDataProvider.prototype.getItem = function (idx) {
  return this._array[idx];
};
/**
 * @constructor
 * @alias module:echarts/data/List
 *
 * @param {Array.<string|Object>} dimensions
 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
 * @param {module:echarts/model/Model} hostModel
 */


var List = function (dimensions, hostModel) {
  dimensions = dimensions || ['x', 'y'];
  var dimensionInfos = {};
  var dimensionNames = [];

  for (var i = 0; i < dimensions.length; i++) {
    var dimensionName;
    var dimensionInfo = {};

    if (typeof dimensions[i] === 'string') {
      dimensionName = dimensions[i];
      dimensionInfo = {
        name: dimensionName,
        coordDim: dimensionName,
        coordDimIndex: 0,
        stackable: false,
        // Type can be 'float', 'int', 'number'
        // Default is number, Precision of float may not enough
        type: 'number'
      };
    } else {
      dimensionInfo = dimensions[i];
      dimensionName = dimensionInfo.name;
      dimensionInfo.type = dimensionInfo.type || 'number';

      if (!dimensionInfo.coordDim) {
        dimensionInfo.coordDim = dimensionName;
        dimensionInfo.coordDimIndex = 0;
      }
    }

    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
    dimensionNames.push(dimensionName);
    dimensionInfos[dimensionName] = dimensionInfo;
  }
  /**
   * @readOnly
   * @type {Array.<string>}
   */


  this.dimensions = dimensionNames;
  /**
   * Infomation of each data dimension, like data type.
   * @type {Object}
   */

  this._dimensionInfos = dimensionInfos;
  /**
   * @type {module:echarts/model/Model}
   */

  this.hostModel = hostModel;
  /**
   * @type {module:echarts/model/Model}
   */

  this.dataType;
  /**
   * Indices stores the indices of data subset after filtered.
   * This data subset will be used in chart.
   * @type {Array.<number>}
   * @readOnly
   */

  this.indices = [];
  /**
   * Data storage
   * @type {Object.<key, TypedArray|Array>}
   * @private
   */

  this._storage = {};
  /**
   * @type {Array.<string>}
   */

  this._nameList = [];
  /**
   * @type {Array.<string>}
   */

  this._idList = [];
  /**
   * Models of data option is stored sparse for optimizing memory cost
   * @type {Array.<module:echarts/model/Model>}
   * @private
   */

  this._optionModels = [];
  /**
   * @param {module:echarts/data/List}
   */

  this.stackedOn = null;
  /**
   * Global visual properties after visual coding
   * @type {Object}
   * @private
   */

  this._visual = {};
  /**
   * Globel layout properties.
   * @type {Object}
   * @private
   */

  this._layout = {};
  /**
   * Item visual properties after visual coding
   * @type {Array.<Object>}
   * @private
   */

  this._itemVisuals = [];
  /**
   * Item layout properties after layout
   * @type {Array.<Object>}
   * @private
   */

  this._itemLayouts = [];
  /**
   * Graphic elemnents
   * @type {Array.<module:zrender/Element>}
   * @private
   */

  this._graphicEls = [];
  /**
   * @type {Array.<Array|Object>}
   * @private
   */

  this._rawData;
  /**
   * @type {Object}
   * @private
   */

  this._extent;
};

var listProto = List.prototype;
listProto.type = 'list';
/**
 * If each data item has it's own option
 * @type {boolean}
 */

listProto.hasItemOption = true;
/**
 * Get dimension name
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 * @return {string} Concrete dim name.
 */

listProto.getDimension = function (dim) {
  if (!isNaN(dim)) {
    dim = this.dimensions[dim] || dim;
  }

  return dim;
};
/**
 * Get type and stackable info of particular dimension
 * @param {string|number} dim
 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
 */


listProto.getDimensionInfo = function (dim) {
  return zrUtil.clone(this._dimensionInfos[this.getDimension(dim)]);
};
/**
 * Initialize from data
 * @param {Array.<Object|number|Array>} data
 * @param {Array.<string>} [nameList]
 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
 */


listProto.initData = function (data, nameList, dimValueGetter) {
  data = data || [];
  var isDataArray = zrUtil.isArray(data);

  if (isDataArray) {
    data = new DefaultDataProvider(data);
  }

  this._rawData = data; // Clear

  var storage = this._storage = {};
  var indices = this.indices = [];
  var dimensions = this.dimensions;
  var dimensionInfoMap = this._dimensionInfos;
  var size = data.count();
  var idList = [];
  var nameRepeatCount = {};
  var nameDimIdx;
  nameList = nameList || []; // Init storage

  for (var i = 0; i < dimensions.length; i++) {
    var dimInfo = dimensionInfoMap[dimensions[i]];
    dimInfo.otherDims.itemName === 0 && (nameDimIdx = i);
    var DataCtor = dataCtors[dimInfo.type];
    storage[dimensions[i]] = new DataCtor(size);
  }

  var self = this;

  if (!dimValueGetter) {
    self.hasItemOption = false;
  } // Default dim value getter


  dimValueGetter = dimValueGetter || function (dataItem, dimName, dataIndex, dimIndex) {
    var value = modelUtil.getDataItemValue(dataItem); // If any dataItem is like { value: 10 }

    if (modelUtil.isDataItemOption(dataItem)) {
      self.hasItemOption = true;
    }

    return modelUtil.converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
    : value, dimensionInfoMap[dimName]);
  };

  for (var i = 0; i < size; i++) {
    // NOTICE: Try not to write things into dataItem
    var dataItem = data.getItem(i); // Each data item is value
    // [1, 2]
    // 2
    // Bar chart, line chart which uses category axis
    // only gives the 'y' value. 'x' value is the indices of cateogry
    // Use a tempValue to normalize the value to be a (x, y) value
    // Store the data by dimensions

    for (var k = 0; k < dimensions.length; k++) {
      var dim = dimensions[k];
      var dimStorage = storage[dim]; // PENDING NULL is empty or zero

      dimStorage[i] = dimValueGetter(dataItem, dim, i, k);
    }

    indices.push(i);
  } // Use the name in option and create id


  for (var i = 0; i < size; i++) {
    var dataItem = data.getItem(i);

    if (!nameList[i] && dataItem) {
      if (dataItem.name != null) {
        nameList[i] = dataItem.name;
      } else if (nameDimIdx != null) {
        nameList[i] = storage[dimensions[nameDimIdx]][i];
      }
    }

    var name = nameList[i] || ''; // Try using the id in option

    var id = dataItem && dataItem.id;

    if (!id && name) {
      // Use name as id and add counter to avoid same name
      nameRepeatCount[name] = nameRepeatCount[name] || 0;
      id = name;

      if (nameRepeatCount[name] > 0) {
        id += '__ec__' + nameRepeatCount[name];
      }

      nameRepeatCount[name]++;
    }

    id && (idList[i] = id);
  }

  this._nameList = nameList;
  this._idList = idList;
};
/**
 * @return {number}
 */


listProto.count = function () {
  return this.indices.length;
};
/**
 * Get value. Return NaN if idx is out of range.
 * @param {string} dim Dim must be concrete name.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */


listProto.get = function (dim, idx, stack) {
  var storage = this._storage;
  var dataIndex = this.indices[idx]; // If value not exists

  if (dataIndex == null || !storage[dim]) {
    return NaN;
  }

  var value = storage[dim][dataIndex]; // FIXME ordinal data type is not stackable

  if (stack) {
    var dimensionInfo = this._dimensionInfos[dim];

    if (dimensionInfo && dimensionInfo.stackable) {
      var stackedOn = this.stackedOn;

      while (stackedOn) {
        // Get no stacked data of stacked on
        var stackedValue = stackedOn.get(dim, idx); // Considering positive stack, negative stack and empty data

        if (value >= 0 && stackedValue > 0 || // Positive stack
        value <= 0 && stackedValue < 0 // Negative stack
        ) {
            value += stackedValue;
          }

        stackedOn = stackedOn.stackedOn;
      }
    }
  }

  return value;
};
/**
 * Get value for multi dimensions.
 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
 * @param {number} idx
 * @param {boolean} stack
 * @return {number}
 */


listProto.getValues = function (dimensions, idx, stack) {
  var values = [];

  if (!zrUtil.isArray(dimensions)) {
    stack = idx;
    idx = dimensions;
    dimensions = this.dimensions;
  }

  for (var i = 0, len = dimensions.length; i < len; i++) {
    values.push(this.get(dimensions[i], idx, stack));
  }

  return values;
};
/**
 * If value is NaN. Inlcuding '-'
 * @param {string} dim
 * @param {number} idx
 * @return {number}
 */


listProto.hasValue = function (idx) {
  var dimensions = this.dimensions;
  var dimensionInfos = this._dimensionInfos;

  for (var i = 0, len = dimensions.length; i < len; i++) {
    if ( // Ordinal type can be string or number
    dimensionInfos[dimensions[i]].type !== 'ordinal' && isNaN(this.get(dimensions[i], idx))) {
      return false;
    }
  }

  return true;
};
/**
 * Get extent of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 * @param {Function} filter
 */


listProto.getDataExtent = function (dim, stack, filter) {
  dim = this.getDimension(dim);
  var dimData = this._storage[dim];
  var dimInfo = this.getDimensionInfo(dim);
  stack = dimInfo && dimInfo.stackable && stack;
  var dimExtent = (this._extent || (this._extent = {}))[dim + !!stack];
  var value;

  if (dimExtent) {
    return dimExtent;
  } // var dimInfo = this._dimensionInfos[dim];


  if (dimData) {
    var min = Infinity;
    var max = -Infinity; // var isOrdinal = dimInfo.type === 'ordinal';

    for (var i = 0, len = this.count(); i < len; i++) {
      value = this.get(dim, i, stack); // FIXME
      // if (isOrdinal && typeof value === 'string') {
      //     value = zrUtil.indexOf(dimData, value);
      // }

      if (!filter || filter(value, dim, i)) {
        value < min && (min = value);
        value > max && (max = value);
      }
    }

    return this._extent[dim + !!stack] = [min, max];
  } else {
    return [Infinity, -Infinity];
  }
};
/**
 * Get sum of data in one dimension
 * @param {string} dim
 * @param {boolean} stack
 */


listProto.getSum = function (dim, stack) {
  var dimData = this._storage[dim];
  var sum = 0;

  if (dimData) {
    for (var i = 0, len = this.count(); i < len; i++) {
      var value = this.get(dim, i, stack);

      if (!isNaN(value)) {
        sum += value;
      }
    }
  }

  return sum;
};
/**
 * Retreive the index with given value
 * @param {number} idx
 * @param {number} value
 * @return {number}
 */
// FIXME Precision of float value


listProto.indexOf = function (dim, value) {
  var storage = this._storage;
  var dimData = storage[dim];
  var indices = this.indices;

  if (dimData) {
    for (var i = 0, len = indices.length; i < len; i++) {
      var rawIndex = indices[i];

      if (dimData[rawIndex] === value) {
        return i;
      }
    }
  }

  return -1;
};
/**
 * Retreive the index with given name
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfName = function (name) {
  var indices = this.indices;
  var nameList = this._nameList;

  for (var i = 0, len = indices.length; i < len; i++) {
    var rawIndex = indices[i];

    if (nameList[rawIndex] === name) {
      return i;
    }
  }

  return -1;
};
/**
 * Retreive the index with given raw data index
 * @param {number} idx
 * @param {number} name
 * @return {number}
 */


listProto.indexOfRawIndex = function (rawIndex) {
  // Indices are ascending
  var indices = this.indices; // If rawIndex === dataIndex

  var rawDataIndex = indices[rawIndex];

  if (rawDataIndex != null && rawDataIndex === rawIndex) {
    return rawIndex;
  }

  var left = 0;
  var right = indices.length - 1;

  while (left <= right) {
    var mid = (left + right) / 2 | 0;

    if (indices[mid] < rawIndex) {
      left = mid + 1;
    } else if (indices[mid] > rawIndex) {
      right = mid - 1;
    } else {
      return mid;
    }
  }

  return -1;
};
/**
 * Retreive the index of nearest value
 * @param {string} dim
 * @param {number} value
 * @param {boolean} stack If given value is after stacked
 * @param {number} [maxDistance=Infinity]
 * @return {Array.<number>} Considere multiple points has the same value.
 */


listProto.indicesOfNearest = function (dim, value, stack, maxDistance) {
  var storage = this._storage;
  var dimData = storage[dim];
  var nearestIndices = [];

  if (!dimData) {
    return nearestIndices;
  }

  if (maxDistance == null) {
    maxDistance = Infinity;
  }

  var minDist = Number.MAX_VALUE;
  var minDiff = -1;

  for (var i = 0, len = this.count(); i < len; i++) {
    var diff = value - this.get(dim, i, stack);
    var dist = Math.abs(diff);

    if (diff <= maxDistance && dist <= minDist) {
      // For the case of two data are same on xAxis, which has sequence data.
      // Show the nearest index
      // https://github.com/ecomfe/echarts/issues/2869
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        nearestIndices.length = 0;
      }

      nearestIndices.push(i);
    }
  }

  return nearestIndices;
};
/**
 * Get raw data index
 * @param {number} idx
 * @return {number}
 */


listProto.getRawIndex = function (idx) {
  var rawIdx = this.indices[idx];
  return rawIdx == null ? -1 : rawIdx;
};
/**
 * Get raw data item
 * @param {number} idx
 * @return {number}
 */


listProto.getRawDataItem = function (idx) {
  return this._rawData.getItem(this.getRawIndex(idx));
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getName = function (idx) {
  return this._nameList[this.indices[idx]] || '';
};
/**
 * @param {number} idx
 * @param {boolean} [notDefaultIdx=false]
 * @return {string}
 */


listProto.getId = function (idx) {
  return this._idList[this.indices[idx]] || this.getRawIndex(idx) + '';
};

function normalizeDimensions(dimensions) {
  if (!zrUtil.isArray(dimensions)) {
    dimensions = [dimensions];
  }

  return dimensions;
}
/**
 * Data iteration
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 *
 * @example
 *  list.each('x', function (x, idx) {});
 *  list.each(['x', 'y'], function (x, y, idx) {});
 *  list.each(function (idx) {})
 */


listProto.each = function (dims, cb, stack, context) {
  if (typeof dims === 'function') {
    context = stack;
    stack = cb;
    cb = dims;
    dims = [];
  }

  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
  var value = [];
  var dimSize = dims.length;
  var indices = this.indices;
  context = context || this;

  for (var i = 0; i < indices.length; i++) {
    // Simple optimization
    switch (dimSize) {
      case 0:
        cb.call(context, i);
        break;

      case 1:
        cb.call(context, this.get(dims[0], i, stack), i);
        break;

      case 2:
        cb.call(context, this.get(dims[0], i, stack), this.get(dims[1], i, stack), i);
        break;

      default:
        for (var k = 0; k < dimSize; k++) {
          value[k] = this.get(dims[k], i, stack);
        } // Index


        value[k] = i;
        cb.apply(context, value);
    }
  }
};
/**
 * Data filter
 * @param {string|Array.<string>}
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 */


listProto.filterSelf = function (dimensions, cb, stack, context) {
  if (typeof dimensions === 'function') {
    context = stack;
    stack = cb;
    cb = dimensions;
    dimensions = [];
  }

  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var newIndices = [];
  var value = [];
  var dimSize = dimensions.length;
  var indices = this.indices;
  context = context || this;

  for (var i = 0; i < indices.length; i++) {
    var keep; // Simple optimization

    if (!dimSize) {
      keep = cb.call(context, i);
    } else if (dimSize === 1) {
      keep = cb.call(context, this.get(dimensions[0], i, stack), i);
    } else {
      for (var k = 0; k < dimSize; k++) {
        value[k] = this.get(dimensions[k], i, stack);
      }

      value[k] = i;
      keep = cb.apply(context, value);
    }

    if (keep) {
      newIndices.push(indices[i]);
    }
  }

  this.indices = newIndices; // Reset data extent

  this._extent = {};
  return this;
};
/**
 * Data mapping to a plain array
 * @param {string|Array.<string>} [dimensions]
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.mapArray = function (dimensions, cb, stack, context) {
  if (typeof dimensions === 'function') {
    context = stack;
    stack = cb;
    cb = dimensions;
    dimensions = [];
  }

  var result = [];
  this.each(dimensions, function () {
    result.push(cb && cb.apply(this, arguments));
  }, stack, context);
  return result;
};

function cloneListForMapAndSample(original, excludeDimensions) {
  var allDimensions = original.dimensions;
  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked

  transferProperties(list, original);
  var storage = list._storage = {};
  var originalStorage = original._storage; // Init storage

  for (var i = 0; i < allDimensions.length; i++) {
    var dim = allDimensions[i];
    var dimStore = originalStorage[dim];

    if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
      storage[dim] = new dimStore.constructor(originalStorage[dim].length);
    } else {
      // Direct reference for other dimensions
      storage[dim] = originalStorage[dim];
    }
  }

  return list;
}
/**
 * Data mapping to a new List with given dimensions
 * @param {string|Array.<string>} dimensions
 * @param {Function} cb
 * @param {boolean} [stack=false]
 * @param {*} [context=this]
 * @return {Array}
 */


listProto.map = function (dimensions, cb, stack, context) {
  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
  // So we can reference to the same value

  var indices = list.indices = this.indices;
  var storage = list._storage;
  var tmpRetValue = [];
  this.each(dimensions, function () {
    var idx = arguments[arguments.length - 1];
    var retValue = cb && cb.apply(this, arguments);

    if (retValue != null) {
      // a number
      if (typeof retValue === 'number') {
        tmpRetValue[0] = retValue;
        retValue = tmpRetValue;
      }

      for (var i = 0; i < retValue.length; i++) {
        var dim = dimensions[i];
        var dimStore = storage[dim];
        var rawIdx = indices[idx];

        if (dimStore) {
          dimStore[rawIdx] = retValue[i];
        }
      }
    }
  }, stack, context);
  return list;
};
/**
 * Large data down sampling on given dimension
 * @param {string} dimension
 * @param {number} rate
 * @param {Function} sampleValue
 * @param {Function} sampleIndex Sample index for name and id
 */


listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
  var list = cloneListForMapAndSample(this, [dimension]);
  var storage = this._storage;
  var targetStorage = list._storage;
  var originalIndices = this.indices;
  var indices = list.indices = [];
  var frameValues = [];
  var frameIndices = [];
  var frameSize = Math.floor(1 / rate);
  var dimStore = targetStorage[dimension];
  var len = this.count(); // Copy data from original data

  for (var i = 0; i < storage[dimension].length; i++) {
    targetStorage[dimension][i] = storage[dimension][i];
  }

  for (var i = 0; i < len; i += frameSize) {
    // Last frame
    if (frameSize > len - i) {
      frameSize = len - i;
      frameValues.length = frameSize;
    }

    for (var k = 0; k < frameSize; k++) {
      var idx = originalIndices[i + k];
      frameValues[k] = dimStore[idx];
      frameIndices[k] = idx;
    }

    var value = sampleValue(frameValues);
    var idx = frameIndices[sampleIndex(frameValues, value) || 0]; // Only write value on the filtered data

    dimStore[idx] = value;
    indices.push(idx);
  }

  return list;
};
/**
 * Get model of one data item.
 *
 * @param {number} idx
 */
// FIXME Model proxy ?


listProto.getItemModel = function (idx) {
  var hostModel = this.hostModel;
  idx = this.indices[idx];
  return new Model(this._rawData.getItem(idx), hostModel, hostModel && hostModel.ecModel);
};
/**
 * Create a data differ
 * @param {module:echarts/data/List} otherList
 * @return {module:echarts/data/DataDiffer}
 */


listProto.diff = function (otherList) {
  var idList = this._idList;
  var otherIdList = otherList && otherList._idList;
  var val; // Use prefix to avoid index to be the same as otherIdList[idx],
  // which will cause weird udpate animation.

  var prefix = 'e\0\0';
  return new DataDiffer(otherList ? otherList.indices : [], this.indices, function (idx) {
    return (val = otherIdList[idx]) != null ? val : prefix + idx;
  }, function (idx) {
    return (val = idList[idx]) != null ? val : prefix + idx;
  });
};
/**
 * Get visual property.
 * @param {string} key
 */


listProto.getVisual = function (key) {
  var visual = this._visual;
  return visual && visual[key];
};
/**
 * Set visual property
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setVisual('color', color);
 *  setVisual({
 *      'color': color
 *  });
 */


listProto.setVisual = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setVisual(name, key[name]);
      }
    }

    return;
  }

  this._visual = this._visual || {};
  this._visual[key] = val;
};
/**
 * Set layout property.
 * @param {string|Object} key
 * @param {*} [val]
 */


listProto.setLayout = function (key, val) {
  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        this.setLayout(name, key[name]);
      }
    }

    return;
  }

  this._layout[key] = val;
};
/**
 * Get layout property.
 * @param  {string} key.
 * @return {*}
 */


listProto.getLayout = function (key) {
  return this._layout[key];
};
/**
 * Get layout of single data item
 * @param {number} idx
 */


listProto.getItemLayout = function (idx) {
  return this._itemLayouts[idx];
};
/**
 * Set layout of single data item
 * @param {number} idx
 * @param {Object} layout
 * @param {boolean=} [merge=false]
 */


listProto.setItemLayout = function (idx, layout, merge) {
  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
};
/**
 * Clear all layout of single data item
 */


listProto.clearItemLayouts = function () {
  this._itemLayouts.length = 0;
};
/**
 * Get visual property of single data item
 * @param {number} idx
 * @param {string} key
 * @param {boolean} [ignoreParent=false]
 */


listProto.getItemVisual = function (idx, key, ignoreParent) {
  var itemVisual = this._itemVisuals[idx];
  var val = itemVisual && itemVisual[key];

  if (val == null && !ignoreParent) {
    // Use global visual property
    return this.getVisual(key);
  }

  return val;
};
/**
 * Set visual property of single data item
 *
 * @param {number} idx
 * @param {string|Object} key
 * @param {*} [value]
 *
 * @example
 *  setItemVisual(0, 'color', color);
 *  setItemVisual(0, {
 *      'color': color
 *  });
 */


listProto.setItemVisual = function (idx, key, value) {
  var itemVisual = this._itemVisuals[idx] || {};
  this._itemVisuals[idx] = itemVisual;

  if (isObject(key)) {
    for (var name in key) {
      if (key.hasOwnProperty(name)) {
        itemVisual[name] = key[name];
      }
    }

    return;
  }

  itemVisual[key] = value;
};
/**
 * Clear itemVisuals and list visual.
 */


listProto.clearAllVisual = function () {
  this._visual = {};
  this._itemVisuals = [];
};

var setItemDataAndSeriesIndex = function (child) {
  child.seriesIndex = this.seriesIndex;
  child.dataIndex = this.dataIndex;
  child.dataType = this.dataType;
};
/**
 * Set graphic element relative to data. It can be set as null
 * @param {number} idx
 * @param {module:zrender/Element} [el]
 */


listProto.setItemGraphicEl = function (idx, el) {
  var hostModel = this.hostModel;

  if (el) {
    // Add data index and series index for indexing the data by element
    // Useful in tooltip
    el.dataIndex = idx;
    el.dataType = this.dataType;
    el.seriesIndex = hostModel && hostModel.seriesIndex;

    if (el.type === 'group') {
      el.traverse(setItemDataAndSeriesIndex, el);
    }
  }

  this._graphicEls[idx] = el;
};
/**
 * @param {number} idx
 * @return {module:zrender/Element}
 */


listProto.getItemGraphicEl = function (idx) {
  return this._graphicEls[idx];
};
/**
 * @param {Function} cb
 * @param {*} context
 */


listProto.eachItemGraphicEl = function (cb, context) {
  zrUtil.each(this._graphicEls, function (el, idx) {
    if (el) {
      cb && cb.call(context, el, idx);
    }
  });
};
/**
 * Shallow clone a new list except visual and layout properties, and graph elements.
 * New list only change the indices.
 */


listProto.cloneShallow = function () {
  var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
  var list = new List(dimensionInfoList, this.hostModel); // FIXME

  list._storage = this._storage;
  transferProperties(list, this); // Clone will not change the data extent and indices

  list.indices = this.indices.slice();

  if (this._extent) {
    list._extent = zrUtil.extend({}, this._extent);
  }

  return list;
};
/**
 * Wrap some method to add more feature
 * @param {string} methodName
 * @param {Function} injectFunction
 */


listProto.wrapMethod = function (methodName, injectFunction) {
  var originalMethod = this[methodName];

  if (typeof originalMethod !== 'function') {
    return;
  }

  this.__wrappedMethods = this.__wrappedMethods || [];

  this.__wrappedMethods.push(methodName);

  this[methodName] = function () {
    var res = originalMethod.apply(this, arguments);
    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
  };
}; // Methods that create a new list based on this list should be listed here.
// Notice that those method should `RETURN` the new list.


listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.

listProto.CHANGABLE_METHODS = ['filterSelf'];
var _default = List;
module.exports = _default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var _model = __webpack_require__(45);

var normalizeToArray = _model.normalizeToArray;

/**
 * Complete dimensions by data (guess dimension).
 */
var each = zrUtil.each;
var isString = zrUtil.isString;
var defaults = zrUtil.defaults;
var OTHER_DIMS = {
  tooltip: 1,
  label: 1,
  itemName: 1
};
/**
 * Complete the dimensions array, by user defined `dimension` and `encode`,
 * and guessing from the data structure.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
 *      provides not only dim template, but also default order.
 *      `name` of each item provides default coord name.
 *      [{dimsDef: []}, ...] can be specified to give names.
 * @param {Array} data Data list. [[1, 2, 3], [2, 3, 4]].
 * @param {Object} [opt]
 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
 *      For example: ['asdf', {name, type}, ...].
 * @param {Object} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
 * @param {string} [opt.extraPrefix] Prefix of name when filling the left dimensions.
 * @param {string} [opt.extraFromZero] If specified, extra dim names will be:
 *                      extraPrefix + 0, extraPrefix + extraBaseIndex + 1 ...
 *                      If not specified, extra dim names will be:
 *                      extraPrefix, extraPrefix + 0, extraPrefix + 1 ...
 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
 * @return {Array.<Object>} [{
 *      name: string mandatory,
 *      coordDim: string mandatory,
 *      coordDimIndex: number mandatory,
 *      type: string optional,
 *      tooltipName: string optional,
 *      otherDims: {
 *          tooltip: number optional,
 *          label: number optional
 *      },
 *      isExtraCoord: boolean true or undefined.
 *      other props ...
 * }]
 */

function completeDimensions(sysDims, data, opt) {
  data = data || [];
  opt = opt || {};
  sysDims = (sysDims || []).slice();
  var dimsDef = (opt.dimsDef || []).slice();
  var encodeDef = zrUtil.createHashMap(opt.encodeDef);
  var dataDimNameMap = zrUtil.createHashMap();
  var coordDimNameMap = zrUtil.createHashMap(); // var valueCandidate;

  var result = [];
  var dimCount = opt.dimCount;

  if (dimCount == null) {
    var value0 = retrieveValue(data[0]);
    dimCount = Math.max(zrUtil.isArray(value0) && value0.length || 1, sysDims.length, dimsDef.length);
    each(sysDims, function (sysDimItem) {
      var sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
    });
  } // Apply user defined dims (`name` and `type`) and init result.


  for (var i = 0; i < dimCount; i++) {
    var dimDefItem = isString(dimsDef[i]) ? {
      name: dimsDef[i]
    } : dimsDef[i] || {};
    var userDimName = dimDefItem.name;
    var resultItem = result[i] = {
      otherDims: {}
    }; // Name will be applied later for avoiding duplication.

    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
      // Only if `series.dimensions` is defined in option, tooltipName
      // will be set, and dimension will be diplayed vertically in
      // tooltip by default.
      resultItem.name = resultItem.tooltipName = userDimName;
      dataDimNameMap.set(userDimName, i);
    }

    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
  } // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.


  encodeDef.each(function (dataDims, coordDim) {
    dataDims = encodeDef.set(coordDim, normalizeToArray(dataDims).slice());
    each(dataDims, function (resultDimIdx, coordDimIndex) {
      // The input resultDimIdx can be dim name or index.
      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));

      if (resultDimIdx != null && resultDimIdx < dimCount) {
        dataDims[coordDimIndex] = resultDimIdx;
        applyDim(result[resultDimIdx], coordDim, coordDimIndex);
      }
    });
  }); // Apply templetes and default order from `sysDims`.

  var availDimIdx = 0;
  each(sysDims, function (sysDimItem, sysDimIndex) {
    var coordDim;
    var sysDimItem;
    var sysDimItemDimsDef;
    var sysDimItemOtherDims;

    if (isString(sysDimItem)) {
      coordDim = sysDimItem;
      sysDimItem = {};
    } else {
      coordDim = sysDimItem.name;
      sysDimItem = zrUtil.clone(sysDimItem); // `coordDimIndex` should not be set directly.

      sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemOtherDims = sysDimItem.otherDims;
      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
    }

    var dataDims = normalizeToArray(encodeDef.get(coordDim)); // dimensions provides default dim sequences.

    if (!dataDims.length) {
      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
          availDimIdx++;
        }

        availDimIdx < result.length && dataDims.push(availDimIdx++);
      }
    } // Apply templates.


    each(dataDims, function (resultDimIdx, coordDimIndex) {
      var resultItem = result[resultDimIdx];
      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);

      if (resultItem.name == null && sysDimItemDimsDef) {
        resultItem.name = resultItem.tooltipName = sysDimItemDimsDef[coordDimIndex];
      }

      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
    });
  }); // Make sure the first extra dim is 'value'.

  var extra = opt.extraPrefix || 'value'; // Set dim `name` and other `coordDim` and other props.

  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
    var resultItem = result[resultDimIdx] = result[resultDimIdx] || {};
    var coordDim = resultItem.coordDim;
    coordDim == null && (resultItem.coordDim = genName(extra, coordDimNameMap, opt.extraFromZero), resultItem.coordDimIndex = 0, resultItem.isExtraCoord = true);
    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
    resultItem.type == null && guessOrdinal(data, resultDimIdx) && (resultItem.type = 'ordinal');
  }

  return result;

  function applyDim(resultItem, coordDim, coordDimIndex) {
    if (OTHER_DIMS[coordDim]) {
      resultItem.otherDims[coordDim] = coordDimIndex;
    } else {
      resultItem.coordDim = coordDim;
      resultItem.coordDimIndex = coordDimIndex;
      coordDimNameMap.set(coordDim, true);
    }
  }

  function genName(name, map, fromZero) {
    if (fromZero || map.get(name) != null) {
      var i = 0;

      while (map.get(name + i) != null) {
        i++;
      }

      name += i;
    }

    map.set(name, true);
    return name;
  }
} // The rule should not be complex, otherwise user might not
// be able to known where the data is wrong.


var guessOrdinal = completeDimensions.guessOrdinal = function (data, dimIndex) {
  for (var i = 0, len = data.length; i < len; i++) {
    var value = retrieveValue(data[i]);

    if (!zrUtil.isArray(value)) {
      return false;
    }

    var value = value[dimIndex]; // Consider usage convenience, '1', '2' will be treated as "number".
    // `isFinit('')` get `true`.

    if (value != null && isFinite(value) && value !== '') {
      return false;
    } else if (isString(value) && value !== '-') {
      return true;
    }
  }

  return false;
};

function retrieveValue(o) {
  return zrUtil.isArray(o) ? o : zrUtil.isObject(o) ? o.value : o;
}

var _default = completeDimensions;
module.exports = _default;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var env = __webpack_require__(64);

var _format = __webpack_require__(71);

var formatTime = _format.formatTime;
var encodeHTML = _format.encodeHTML;
var addCommas = _format.addCommas;
var getTooltipMarker = _format.getTooltipMarker;

var _clazz = __webpack_require__(92);

var set = _clazz.set;
var get = _clazz.get;

var modelUtil = __webpack_require__(45);

var ComponentModel = __webpack_require__(102);

var colorPaletteMixin = __webpack_require__(476);

var _layout = __webpack_require__(103);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;
var SeriesModel = ComponentModel.extend({
  type: 'series.__base__',

  /**
   * @readOnly
   */
  seriesIndex: 0,
  // coodinateSystem will be injected in the echarts/CoordinateSystem
  coordinateSystem: null,

  /**
   * @type {Object}
   * @protected
   */
  defaultOption: null,

  /**
   * Data provided for legend
   * @type {Function}
   */
  // PENDING
  legendDataProvider: null,

  /**
   * Access path of color for visual
   */
  visualColorAccessPath: 'itemStyle.normal.color',

  /**
   * Support merge layout params.
   * Only support 'box' now (left/right/top/bottom/width/height).
   * @type {string|Object} Object can be {ignoreSize: true}
   * @readOnly
   */
  layoutMode: null,
  init: function (option, parentModel, ecModel, extraOpt) {
    /**
     * @type {number}
     * @readOnly
     */
    this.seriesIndex = this.componentIndex;
    this.mergeDefaultAndTheme(option, ecModel);
    var data = this.getInitialData(option, ecModel);

    /**
     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
     * @private
     */
    set(this, 'dataBeforeProcessed', data); // If we reverse the order (make data firstly, and then make
    // dataBeforeProcessed by cloneShallow), cloneShallow will
    // cause data.graph.data !== data when using
    // module:echarts/data/Graph or module:echarts/data/Tree.
    // See module:echarts/data/helper/linkList

    this.restoreData();
  },

  /**
   * Util for merge default and theme to option
   * @param  {Object} option
   * @param  {module:echarts/model/Global} ecModel
   */
  mergeDefaultAndTheme: function (option, ecModel) {
    var layoutMode = this.layoutMode;
    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
    // But if name duplicate between series subType
    // (for example: parallel) add component mainType,
    // add suffix 'Series'.

    var themeSubType = this.subType;

    if (ComponentModel.hasClass(themeSubType)) {
      themeSubType += 'Series';
    }

    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`

    modelUtil.defaultEmphasis(option.label, ['show']);
    this.fillDataTextStyle(option.data);

    if (layoutMode) {
      mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  },
  mergeOption: function (newSeriesOption, ecModel) {
    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
    this.fillDataTextStyle(newSeriesOption.data);
    var layoutMode = this.layoutMode;

    if (layoutMode) {
      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
    }

    var data = this.getInitialData(newSeriesOption, ecModel); // TODO Merge data?

    if (data) {
      set(this, 'data', data);
      set(this, 'dataBeforeProcessed', data.cloneShallow());
    }
  },
  fillDataTextStyle: function (data) {
    // Default data label emphasis `show`
    // FIXME Tree structure data ?
    // FIXME Performance ?
    if (data) {
      var props = ['show'];

      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].label) {
          modelUtil.defaultEmphasis(data[i].label, props);
        }
      }
    }
  },

  /**
   * Init a data structure from data related option in series
   * Must be overwritten
   */
  getInitialData: function () {},

  /**
   * @param {string} [dataType]
   * @return {module:echarts/data/List}
   */
  getData: function (dataType) {
    var data = get(this, 'data');
    return dataType == null ? data : data.getLinkedData(dataType);
  },

  /**
   * @param {module:echarts/data/List} data
   */
  setData: function (data) {
    set(this, 'data', data);
  },

  /**
   * Get data before processed
   * @return {module:echarts/data/List}
   */
  getRawData: function () {
    return get(this, 'dataBeforeProcessed');
  },

  /**
   * Coord dimension to data dimension.
   *
   * By default the result is the same as dimensions of series data.
   * But in some series data dimensions are different from coord dimensions (i.e.
   * candlestick and boxplot). Override this method to handle those cases.
   *
   * Coord dimension to data dimension can be one-to-many
   *
   * @param {string} coordDim
   * @return {Array.<string>} dimensions on the axis.
   */
  coordDimToDataDim: function (coordDim) {
    return modelUtil.coordDimToDataDim(this.getData(), coordDim);
  },

  /**
   * Convert data dimension to coord dimension.
   *
   * @param {string|number} dataDim
   * @return {string}
   */
  dataDimToCoordDim: function (dataDim) {
    return modelUtil.dataDimToCoordDim(this.getData(), dataDim);
  },

  /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */
  getBaseAxis: function () {
    var coordSys = this.coordinateSystem;
    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
  },
  // FIXME

  /**
   * Default tooltip formatter
   *
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {number} [dataType]
   */
  formatTooltip: function (dataIndex, multipleSeries, dataType) {
    function formatArrayValue(value) {
      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.tooltipName != null;
      }, 0);
      var result = [];
      var tooltipDims = modelUtil.otherDimToDataDim(data, 'tooltip');
      tooltipDims.length ? zrUtil.each(tooltipDims, function (dimIdx) {
        setEachItem(data.get(dimIdx, dataIndex), dimIdx);
      }) // By default, all dims is used on tooltip.
      : zrUtil.each(value, setEachItem);

      function setEachItem(val, dimIdx) {
        var dimInfo = data.getDimensionInfo(dimIdx); // If `dimInfo.tooltip` is not set, show tooltip.

        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
          return;
        }

        var dimType = dimInfo.type;
        var valStr = (vertially ? '- ' + (dimInfo.tooltipName || dimInfo.name) + ': ' : '') + (dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
        valStr && result.push(encodeHTML(valStr));
      }

      return (vertially ? '<br/>' : '') + result.join(vertially ? '<br/>' : ', ');
    }

    var data = get(this, 'data');
    var value = this.getRawValue(dataIndex);
    var formattedValue = zrUtil.isArray(value) ? formatArrayValue(value) : encodeHTML(addCommas(value));
    var name = data.getName(dataIndex);
    var color = data.getItemVisual(dataIndex, 'color');

    if (zrUtil.isObject(color) && color.colorStops) {
      color = (color.colorStops[0] || {}).color;
    }

    color = color || 'transparent';
    var colorEl = getTooltipMarker(color);
    var seriesName = this.name; // FIXME

    if (seriesName === '\0-') {
      // Not show '-'
      seriesName = '';
    }

    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? '<br/>' : ': ') : '';
    return !multipleSeries ? seriesName + colorEl + (name ? encodeHTML(name) + ': ' + formattedValue : formattedValue) : colorEl + seriesName + formattedValue;
  },

  /**
   * @return {boolean}
   */
  isAnimationEnabled: function () {
    if (env.node) {
      return false;
    }

    var animationEnabled = this.getShallow('animation');

    if (animationEnabled) {
      if (this.getData().count() > this.getShallow('animationThreshold')) {
        animationEnabled = false;
      }
    }

    return animationEnabled;
  },
  restoreData: function () {
    set(this, 'data', get(this, 'dataBeforeProcessed').cloneShallow());
  },
  getColorFromPalette: function (name, scope) {
    var ecModel = this.ecModel; // PENDING

    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope);

    if (!color) {
      color = ecModel.getColorFromPalette(name, scope);
    }

    return color;
  },

  /**
   * Get data indices for show tooltip content. See tooltip.
   * @abstract
   * @param {Array.<string>|string} dim
   * @param {Array.<number>} value
   * @param {module:echarts/coord/single/SingleAxis} baseAxis
   * @return {Object} {dataIndices, nestestValue}.
   */
  getAxisTooltipData: null,

  /**
   * See tooltip.
   * @abstract
   * @param {number} dataIndex
   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
   */
  getTooltipPosition: null
});
zrUtil.mixin(SeriesModel, modelUtil.dataFormatMixin);
zrUtil.mixin(SeriesModel, colorPaletteMixin);
var _default = SeriesModel;
module.exports = _default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var numberUtil = __webpack_require__(48);

var formatUtil = __webpack_require__(71);

var Scale = __webpack_require__(210);

var helper = __webpack_require__(477);

/**
 * Interval scale
 * @module echarts/scale/Interval
 */
var roundNumber = numberUtil.round;
/**
 * @alias module:echarts/coord/scale/Interval
 * @constructor
 */

var IntervalScale = Scale.extend({
  type: 'interval',
  _interval: 0,
  _intervalPrecision: 2,
  setExtent: function (start, end) {
    var thisExtent = this._extent; //start,end may be a Number like '25',so...

    if (!isNaN(start)) {
      thisExtent[0] = parseFloat(start);
    }

    if (!isNaN(end)) {
      thisExtent[1] = parseFloat(end);
    }
  },
  unionExtent: function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes

    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
  },

  /**
   * Get interval
   */
  getInterval: function () {
    return this._interval;
  },

  /**
   * Set interval
   */
  setInterval: function (interval) {
    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
    // We assume user wan't to set both interval, min, max to get a better result

    this._niceExtent = this._extent.slice();
    this._intervalPrecision = helper.getIntervalPrecision(interval);
  },

  /**
   * @return {Array.<number>}
   */
  getTicks: function () {
    return helper.intervalScaleGetTicks(this._interval, this._extent, this._niceExtent, this._intervalPrecision);
  },

  /**
   * @return {Array.<string>}
   */
  getTicksLabels: function () {
    var labels = [];
    var ticks = this.getTicks();

    for (var i = 0; i < ticks.length; i++) {
      labels.push(this.getLabel(ticks[i]));
    }

    return labels;
  },

  /**
   * @param {number} data
   * @param {Object} [opt]
   * @param {number|string} [opt.precision] If 'auto', use nice presision.
   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
   * @return {string}
   */
  getLabel: function (data, opt) {
    if (data == null) {
      return '';
    }

    var precision = opt && opt.precision;

    if (precision == null) {
      precision = numberUtil.getPrecisionSafe(data) || 0;
    } else if (precision === 'auto') {
      // Should be more precise then tick.
      precision = this._intervalPrecision;
    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.


    data = roundNumber(data, precision, true);
    return formatUtil.addCommas(data);
  },

  /**
   * Update interval and extent of intervals for nice ticks
   *
   * @param {number} [splitNumber = 5] Desired number of ticks
   * @param {number} [minInterval]
   * @param {number} [maxInterval]
   */
  niceTicks: function (splitNumber, minInterval, maxInterval) {
    splitNumber = splitNumber || 5;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (!isFinite(span)) {
      return;
    } // User may set axis min 0 and data are all negative
    // FIXME If it needs to reverse ?


    if (span < 0) {
      span = -span;
      extent.reverse();
    }

    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
    this._intervalPrecision = result.intervalPrecision;
    this._interval = result.interval;
    this._niceExtent = result.niceTickExtent;
  },

  /**
   * Nice extent.
   * @param {Object} opt
   * @param {number} [opt.splitNumber = 5] Given approx tick number
   * @param {boolean} [opt.fixMin=false]
   * @param {boolean} [opt.fixMax=false]
   * @param {boolean} [opt.minInterval]
   * @param {boolean} [opt.maxInterval]
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      if (extent[0] !== 0) {
        // Expand extent
        var expandSize = extent[0]; // In the fowllowing case
        //      Axis has been fixed max 100
        //      Plus data are all 100 and axis extent are [100, 100].
        // Extend to the both side will cause expanded max is larger than fixed max.
        // So only expand to the smaller side.

        if (!opt.fixMax) {
          extent[1] += expandSize / 2;
          extent[0] -= expandSize / 2;
        } else {
          extent[0] -= expandSize / 2;
        }
      } else {
        extent[1] = 1;
      }
    }

    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]

    if (!isFinite(span)) {
      extent[0] = 0;
      extent[1] = 1;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
  }
});
/**
 * @return {module:echarts/scale/Time}
 */

IntervalScale.create = function () {
  return new IntervalScale();
};

var _default = IntervalScale;
module.exports = _default;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var _clazz = __webpack_require__(92);

var parseClassType = _clazz.parseClassType;
var base = 0;
var DELIMITER = '_';
/**
 * @public
 * @param {string} type
 * @return {string}
 */

function getUID(type) {
  // Considering the case of crossing js context,
  // use Math.random to make id as unique as possible.
  return [type || '', base++, Math.random()].join(DELIMITER);
}
/**
 * @inner
 */


function enableSubTypeDefaulter(entity) {
  var subTypeDefaulters = {};

  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
    componentType = parseClassType(componentType);
    subTypeDefaulters[componentType.main] = defaulter;
  };

  entity.determineSubType = function (componentType, option) {
    var type = option.type;

    if (!type) {
      var componentTypeMain = parseClassType(componentType).main;

      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
        type = subTypeDefaulters[componentTypeMain](option);
      }
    }

    return type;
  };

  return entity;
}
/**
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 *
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 *
 * If there is circle dependencey, Error will be thrown.
 *
 */


function enableTopologicalTravel(entity, dependencyGetter) {
  /**
   * @public
   * @param {Array.<string>} targetNameList Target Component type list.
   *                                           Can be ['aa', 'bb', 'aa.xx']
   * @param {Array.<string>} fullNameList By which we can build dependency graph.
   * @param {Function} callback Params: componentType, dependencies.
   * @param {Object} context Scope of callback.
   */
  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
    if (!targetNameList.length) {
      return;
    }

    var result = makeDepndencyGraph(fullNameList);
    var graph = result.graph;
    var stack = result.noEntryList;
    var targetNameSet = {};
    zrUtil.each(targetNameList, function (name) {
      targetNameSet[name] = true;
    });

    while (stack.length) {
      var currComponentType = stack.pop();
      var currVertex = graph[currComponentType];
      var isInTargetNameSet = !!targetNameSet[currComponentType];

      if (isInTargetNameSet) {
        callback.call(context, currComponentType, currVertex.originalDeps.slice());
        delete targetNameSet[currComponentType];
      }

      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
    }

    zrUtil.each(targetNameSet, function () {
      throw new Error('Circle dependency may exists');
    });

    function removeEdge(succComponentType) {
      graph[succComponentType].entryCount--;

      if (graph[succComponentType].entryCount === 0) {
        stack.push(succComponentType);
      }
    } // Consider this case: legend depends on series, and we call
    // chart.setOption({series: [...]}), where only series is in option.
    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
    // not be called, but only sereis.mergeOption is called. Thus legend
    // have no chance to update its local record about series (like which
    // name of series is available in legend).


    function removeEdgeAndAdd(succComponentType) {
      targetNameSet[succComponentType] = true;
      removeEdge(succComponentType);
    }
  };
  /**
   * DepndencyGraph: {Object}
   * key: conponentType,
   * value: {
   *     successor: [conponentTypes...],
   *     originalDeps: [conponentTypes...],
   *     entryCount: {number}
   * }
   */


  function makeDepndencyGraph(fullNameList) {
    var graph = {};
    var noEntryList = [];
    zrUtil.each(fullNameList, function (name) {
      var thisItem = createDependencyGraphItem(graph, name);
      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
      thisItem.entryCount = availableDeps.length;

      if (thisItem.entryCount === 0) {
        noEntryList.push(name);
      }

      zrUtil.each(availableDeps, function (dependentName) {
        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
          thisItem.predecessor.push(dependentName);
        }

        var thatItem = createDependencyGraphItem(graph, dependentName);

        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
          thatItem.successor.push(name);
        }
      });
    });
    return {
      graph: graph,
      noEntryList: noEntryList
    };
  }

  function createDependencyGraphItem(graph, name) {
    if (!graph[name]) {
      graph[name] = {
        predecessor: [],
        successor: []
      };
    }

    return graph[name];
  }

  function getAvailableDependencies(originalDeps, fullNameList) {
    var availableDeps = [];
    zrUtil.each(originalDeps, function (dep) {
      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
    });
    return availableDeps;
  }
}

exports.getUID = getUID;
exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

var ORIGIN_METHOD = '\0__throttleOriginMethod';
var RATE = '\0__throttleRate';
var THROTTLE_TYPE = '\0__throttleType';
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */

function throttle(fn, delay, debounce) {
  var currCall;
  var lastCall = 0;
  var lastExec = 0;
  var timer = null;
  var diff;
  var scope;
  var args;
  var debounceNextCall;
  delay = delay || 0;

  function exec() {
    lastExec = new Date().getTime();
    timer = null;
    fn.apply(scope, args || []);
  }

  var cb = function () {
    currCall = new Date().getTime();
    scope = this;
    args = arguments;
    var thisDelay = debounceNextCall || delay;
    var thisDebounce = debounceNextCall || debounce;
    debounceNextCall = null;
    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
    clearTimeout(timer);

    if (thisDebounce) {
      timer = setTimeout(exec, thisDelay);
    } else {
      if (diff >= 0) {
        exec();
      } else {
        timer = setTimeout(exec, -diff);
      }
    }

    lastCall = currCall;
  };
  /**
   * Clear throttle.
   * @public
   */


  cb.clear = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  /**
   * Enable debounce once.
   */


  cb.debounceNextCall = function (debounceDelay) {
    debounceNextCall = debounceDelay;
  };

  return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 * @param {number} [rate]
 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
 * @return {Function} throttled function.
 */


function createOrUpdate(obj, fnAttr, rate, throttleType) {
  var fn = obj[fnAttr];

  if (!fn) {
    return;
  }

  var originFn = fn[ORIGIN_METHOD] || fn;
  var lastThrottleType = fn[THROTTLE_TYPE];
  var lastRate = fn[RATE];

  if (lastRate !== rate || lastThrottleType !== throttleType) {
    if (rate == null || !throttleType) {
      return obj[fnAttr] = originFn;
    }

    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
    fn[ORIGIN_METHOD] = originFn;
    fn[THROTTLE_TYPE] = throttleType;
    fn[RATE] = rate;
  }

  return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 *
 * @public
 * @param {Object} obj
 * @param {string} fnAttr
 */


function clear(obj, fnAttr) {
  var fn = obj[fnAttr];

  if (fn && fn[ORIGIN_METHOD]) {
    obj[fnAttr] = fn[ORIGIN_METHOD];
  }
}

exports.throttle = throttle;
exports.createOrUpdate = createOrUpdate;
exports.clear = clear;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Group = __webpack_require__(261);

var componentUtil = __webpack_require__(304);

var clazzUtil = __webpack_require__(92);

var modelUtil = __webpack_require__(45);

function Chart() {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewChart');
}

Chart.prototype = {
  type: 'chart',

  /**
   * Init the chart
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  init: function (ecModel, api) {},

  /**
   * Render the chart
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  render: function (seriesModel, ecModel, api, payload) {},

  /**
   * Highlight series or specified data item
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  highlight: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
  },

  /**
   * Downplay series or specified data item
   * @param  {module:echarts/model/Series} seriesModel
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   * @param  {Object} payload
   */
  downplay: function (seriesModel, ecModel, api, payload) {
    toggleHighlight(seriesModel.getData(), payload, 'normal');
  },

  /**
   * Remove self
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  remove: function (ecModel, api) {
    this.group.removeAll();
  },

  /**
   * Dispose self
   * @param  {module:echarts/model/Global} ecModel
   * @param  {module:echarts/ExtensionAPI} api
   */
  dispose: function () {}
  /**
   * The view contains the given point.
   * @interface
   * @param {Array.<number>} point
   * @return {boolean}
   */
  // containPoint: function () {}

};
var chartProto = Chart.prototype;

chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
  this.render(seriesModel, ecModel, api, payload);
};
/**
 * Set state of single element
 * @param  {module:zrender/Element} el
 * @param  {string} state
 */


function elSetState(el, state) {
  if (el) {
    el.trigger(state);

    if (el.type === 'group') {
      for (var i = 0; i < el.childCount(); i++) {
        elSetState(el.childAt(i), state);
      }
    }
  }
}
/**
 * @param  {module:echarts/data/List} data
 * @param  {Object} payload
 * @param  {string} state 'normal'|'emphasis'
 * @inner
 */


function toggleHighlight(data, payload, state) {
  var dataIndex = modelUtil.queryDataIndex(data, payload);

  if (dataIndex != null) {
    zrUtil.each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
      elSetState(data.getItemGraphicEl(dataIdx), state);
    });
  } else {
    data.eachItemGraphicEl(function (el) {
      elSetState(el, state);
    });
  }
} // Enable Chart.extend.


clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Chart, {
  registerWhenExtend: true
});
var _default = Chart;
module.exports = _default;

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1141);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(396)(module)))

/***/ }),
/* 311 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1197);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1209);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1208);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1223);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(319);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(315),
    getRawTag = __webpack_require__(1246),
    objectToString = __webpack_require__(1268);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(216),
    isKey = __webpack_require__(1254),
    stringToPath = __webpack_require__(1269),
    toString = __webpack_require__(1275);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1240),
    getValue = __webpack_require__(1247);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1245);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(323);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 321 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(316),
    isObjectLike = __webpack_require__(322);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hammer__ = __webpack_require__(1276);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Hammer__["a" /* default */]);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(524);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.isEventFromHandle = isEventFromHandle;
exports.isValueOutOfRange = isValueOutOfRange;
exports.isNotTouchEvent = isNotTouchEvent;
exports.getClosestPoint = getClosestPoint;
exports.getPrecision = getPrecision;
exports.getMousePosition = getMousePosition;
exports.getTouchPosition = getTouchPosition;
exports.getHandleCenterPosition = getHandleCenterPosition;
exports.ensureValueInRange = ensureValueInRange;
exports.ensureValuePrecision = ensureValuePrecision;
exports.pauseEvent = pauseEvent;

var _reactDom = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === (0, _reactDom.findDOMNode)(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1323);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1322);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__(1147);

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toArray */
/* harmony export (immutable) */ __webpack_exports__["a"] = getActiveIndex;
/* unused harmony export getActiveKey */
/* unused harmony export setTransform */
/* unused harmony export isTransformSupported */
/* unused harmony export setTransition */
/* harmony export (immutable) */ __webpack_exports__["c"] = getTransformPropValue;
/* unused harmony export isVertical */
/* harmony export (immutable) */ __webpack_exports__["d"] = getTransformByIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = getMarginStyle;
/* unused harmony export getStyle */
/* unused harmony export setPxStyle */
/* harmony export (immutable) */ __webpack_exports__["e"] = getDataAttr;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function toArray(children) {
  // allow [c,[a,b]]
  var c = [];
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(children, function (child) {
    if (child) {
      c.push(child);
    }
  });
  return c;
}

function getActiveIndex(children, activeKey) {
  var c = toArray(children);
  for (var i = 0; i < c.length; i++) {
    if (c[i].key === activeKey) {
      return i;
    }
  }
  return -1;
}

function getActiveKey(children, index) {
  var c = toArray(children);
  return c[index].key;
}

function setTransform(style, v) {
  style.transform = v;
  style.webkitTransform = v;
  style.mozTransform = v;
}

function isTransformSupported(style) {
  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
}

function setTransition(style, v) {
  style.transition = v;
  style.webkitTransition = v;
  style.MozTransition = v;
}
function getTransformPropValue(v) {
  return {
    transform: v,
    WebkitTransform: v,
    MozTransform: v
  };
}

function isVertical(tabBarPosition) {
  return tabBarPosition === 'left' || tabBarPosition === 'right';
}

function getTransformByIndex(index, tabBarPosition) {
  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
  return translate + '(' + -index * 100 + '%) translateZ(0)';
}

function getMarginStyle(index, tabBarPosition) {
  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, marginDirection, -index * 100 + '%');
}

function getStyle(el, property) {
  return +getComputedStyle(el).getPropertyValue(property).replace('px', '');
}

function setPxStyle(el, value, vertical) {
  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
  setTransform(el.style, 'translate3d(' + value + ')');
}

function getDataAttr(props) {
  return Object.keys(props).reduce(function (prev, key) {
    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
      prev[key] = props[key];
    }
    return prev;
  }, {});
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  saveRef: function saveRef(name) {
    var _this = this;

    return function (node) {
      _this[name] = node;
    };
  }
};
module.exports = exports['default'];

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(332);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(105);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(18);

var _classnames3 = _interopRequireDefault(_classnames2);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _utils = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  getDefaultProps: function getDefaultProps() {
    return {
      styles: {}
    };
  },
  onTabClick: function onTabClick(key) {
    this.props.onTabClick(key);
  },
  getTabs: function getTabs() {
    var _this = this;

    var _props = this.props,
        children = _props.panels,
        activeKey = _props.activeKey,
        prefixCls = _props.prefixCls;

    var rst = [];

    _react2['default'].Children.forEach(children, function (child) {
      if (!child) {
        return;
      }
      var key = child.key;
      var cls = activeKey === key ? prefixCls + '-tab-active' : '';
      cls += ' ' + prefixCls + '-tab';
      var events = {};
      if (child.props.disabled) {
        cls += ' ' + prefixCls + '-tab-disabled';
      } else {
        events = {
          onClick: _this.onTabClick.bind(_this, key)
        };
      }
      var ref = {};
      if (activeKey === key) {
        ref.ref = _this.saveRef('activeTab');
      }
      (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
      rst.push(_react2['default'].createElement(
        'div',
        (0, _extends3['default'])({
          role: 'tab',
          'aria-disabled': child.props.disabled ? 'true' : 'false',
          'aria-selected': activeKey === key ? 'true' : 'false'
        }, events, {
          className: cls,
          key: key
        }, ref),
        child.props.tab
      ));
    });

    return rst;
  },
  getRootNode: function getRootNode(contents) {
    var _props2 = this.props,
        prefixCls = _props2.prefixCls,
        onKeyDown = _props2.onKeyDown,
        className = _props2.className,
        extraContent = _props2.extraContent,
        style = _props2.style,
        tabBarPosition = _props2.tabBarPosition,
        restProps = (0, _objectWithoutProperties3['default'])(_props2, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition']);

    var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
    var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
    var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
    var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
    var children = contents;
    if (extraContent) {
      children = [(0, _react.cloneElement)(extraContent, {
        key: 'extra',
        style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
      }), (0, _react.cloneElement)(contents, { key: 'content' })];
      children = topOrBottom ? children : children.reverse();
    }
    return _react2['default'].createElement(
      'div',
      (0, _extends3['default'])({
        role: 'tablist',
        className: cls,
        tabIndex: '0',
        ref: this.saveRef('root'),
        onKeyDown: onKeyDown,
        style: style
      }, (0, _utils.getDataAttr)(restProps)),
      children
    );
  }
};
module.exports = exports['default'];

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(105);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(18);

var _classnames3 = _interopRequireDefault(_classnames2);

var _utils = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabContent = (0, _createReactClass2['default'])({
  displayName: 'TabContent',
  propTypes: {
    animated: _propTypes2['default'].bool,
    animatedWithMargin: _propTypes2['default'].bool,
    prefixCls: _propTypes2['default'].string,
    children: _propTypes2['default'].any,
    activeKey: _propTypes2['default'].string,
    style: _propTypes2['default'].any,
    tabBarPosition: _propTypes2['default'].string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      animated: true
    };
  },
  getTabPanes: function getTabPanes() {
    var props = this.props;
    var activeKey = props.activeKey;
    var children = props.children;
    var newChildren = [];

    _react2['default'].Children.forEach(children, function (child) {
      if (!child) {
        return;
      }
      var key = child.key;
      var active = activeKey === key;
      newChildren.push(_react2['default'].cloneElement(child, {
        active: active,
        destroyInactiveTabPane: props.destroyInactiveTabPane,
        rootPrefixCls: props.prefixCls
      }));
    });

    return newChildren;
  },
  render: function render() {
    var _classnames;

    var props = this.props;
    var prefixCls = props.prefixCls,
        children = props.children,
        activeKey = props.activeKey,
        tabBarPosition = props.tabBarPosition,
        animated = props.animated,
        animatedWithMargin = props.animatedWithMargin;
    var style = props.style;

    var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames));
    if (animated) {
      var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
      if (activeIndex !== -1) {
        var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition));
        style = (0, _extends3['default'])({}, style, animatedStyle);
      } else {
        style = (0, _extends3['default'])({}, style, {
          display: 'none'
        });
      }
    }
    return _react2['default'].createElement(
      'div',
      {
        className: classes,
        style: style
      },
      this.getTabPanes()
    );
  }
});

exports['default'] = TabContent;
module.exports = exports['default'];

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1410);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1408);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1411);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1409);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(541);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(541);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(140);
var Danger = __webpack_require__(1431);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactInstrumentation = __webpack_require__(75);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(349);
var setInnerHTML = __webpack_require__(222);
var setTextContent = __webpack_require__(563);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactErrorUtils = __webpack_require__(347);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactPropTypesSecret = __webpack_require__(1460);
var propTypesFactory = __webpack_require__(1490);

var React = __webpack_require__(146);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactCurrentOwner = __webpack_require__(94);
var ReactInstanceMap = __webpack_require__(180);
var ReactInstrumentation = __webpack_require__(75);
var ReactUpdates = __webpack_require__(87);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(57);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var emptyFunction = __webpack_require__(49);
var warning = __webpack_require__(25);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef !== 'undefined';

function ContextProvider(name) {
  var _childContextTypes, _config;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  var config = (_config = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },


    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _config[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _config);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillMount = config.componentWillMount;
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillMount;
    delete config.componentWillReceiveProps;
  }
  return config;
}

function ContextSubscriber(name) {
  var _contextTypes, _config2;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  var config = (_config2 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref2;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _config2[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _config2);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillReceiveProps;
  }
  return config;
}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRouteParams__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextUtils__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(106);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["a" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        // Handle components is object for { [name]: component } but not valid element
        // type of react, such as React.memo, React.lazy and so on.
        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_is__["isValidElementType"])(components)) {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(145);

var _DOMUtils = __webpack_require__(224);

var _DOMStateStorage = __webpack_require__(579);

var _PathUtils = __webpack_require__(107);

var _ExecutionEnvironment = __webpack_require__(362);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1522);

var _PathUtils = __webpack_require__(107);

var _runTransitionHook = __webpack_require__(364);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(223);

var _LocationUtils = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataSource", function() { return DataSource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListView__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Indexed__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RefreshControl__ = __webpack_require__(1575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexedList", function() { return __WEBPACK_IMPORTED_MODULE_1__Indexed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RefreshControl", function() { return __WEBPACK_IMPORTED_MODULE_2__RefreshControl__["a"]; });
// export this package's api



__WEBPACK_IMPORTED_MODULE_0__ListView__["a" /* default */].IndexedList = __WEBPACK_IMPORTED_MODULE_1__Indexed__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__ListView__["a" /* default */].RefreshControl = __WEBPACK_IMPORTED_MODULE_2__RefreshControl__["a" /* default */];

var DataSource = __WEBPACK_IMPORTED_MODULE_0__ListView__["a" /* default */].DataSource;

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__ListView__["a" /* default */]);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1577);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(186)
  , dPs         = __webpack_require__(1599)
  , enumBugKeys = __webpack_require__(369)
  , IE_PROTO    = __webpack_require__(375)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(611)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1592).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 373 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(123).f
  , has = __webpack_require__(122)
  , TAG = __webpack_require__(150)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(376)('keys')
  , uid    = __webpack_require__(229);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(109)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(188);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(109)
  , core           = __webpack_require__(120)
  , LIBRARY        = __webpack_require__(371)
  , wksExt         = __webpack_require__(380)
  , defineProperty = __webpack_require__(123).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(150);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clbsBg.8051ecec.jpg";

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dzoff.4b2367e6.png";

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dzon.8e3e3430.png";

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/huatiao7.9a294c1f.png";

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon11.d2c7e55d.png";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_hqt.1d6b8024.png";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_arrow_gray.52e297bd.png";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_what@2.e4ff92c9.png";

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square@3x.de43b4f4.png";

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/squareHooks@3x.9d7e1c4a.png";

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_dg.987d5ade.png";

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jiantou_icon_sec.563112bd.png";

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/show_grey@3x.122b08a9.png";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/unshow_grey@3x.d3ec63f4.png";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/youjiantougray@3x.3ffd1961.png";

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 397 */
/***/ (function(module, exports) {

// https://github.com/mziccard/node-timsort
var DEFAULT_MIN_MERGE = 32;
var DEFAULT_MIN_GALLOPING = 7;
var DEFAULT_TMP_STORAGE_LENGTH = 256;

function minRunLength(n) {
  var r = 0;

  while (n >= DEFAULT_MIN_MERGE) {
    r |= n & 1;
    n >>= 1;
  }

  return n + r;
}

function makeAscendingRun(array, lo, hi, compare) {
  var runHi = lo + 1;

  if (runHi === hi) {
    return 1;
  }

  if (compare(array[runHi++], array[lo]) < 0) {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
      runHi++;
    }

    reverseRun(array, lo, runHi);
  } else {
    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
      runHi++;
    }
  }

  return runHi - lo;
}

function reverseRun(array, lo, hi) {
  hi--;

  while (lo < hi) {
    var t = array[lo];
    array[lo++] = array[hi];
    array[hi--] = t;
  }
}

function binaryInsertionSort(array, lo, hi, start, compare) {
  if (start === lo) {
    start++;
  }

  for (; start < hi; start++) {
    var pivot = array[start];
    var left = lo;
    var right = start;
    var mid;

    while (left < right) {
      mid = left + right >>> 1;

      if (compare(pivot, array[mid]) < 0) {
        right = mid;
      } else {
        left = mid + 1;
      }
    }

    var n = start - left;

    switch (n) {
      case 3:
        array[left + 3] = array[left + 2];

      case 2:
        array[left + 2] = array[left + 1];

      case 1:
        array[left + 1] = array[left];
        break;

      default:
        while (n > 0) {
          array[left + n] = array[left + n - 1];
          n--;
        }

    }

    array[left] = pivot;
  }
}

function gallopLeft(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) > 0) {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  } else {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) > 0) {
      lastOffset = m + 1;
    } else {
      offset = m;
    }
  }

  return offset;
}

function gallopRight(value, array, start, length, hint, compare) {
  var lastOffset = 0;
  var maxOffset = 0;
  var offset = 1;

  if (compare(value, array[start + hint]) < 0) {
    maxOffset = hint + 1;

    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    var tmp = lastOffset;
    lastOffset = hint - offset;
    offset = hint - tmp;
  } else {
    maxOffset = length - hint;

    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
      lastOffset = offset;
      offset = (offset << 1) + 1;

      if (offset <= 0) {
        offset = maxOffset;
      }
    }

    if (offset > maxOffset) {
      offset = maxOffset;
    }

    lastOffset += hint;
    offset += hint;
  }

  lastOffset++;

  while (lastOffset < offset) {
    var m = lastOffset + (offset - lastOffset >>> 1);

    if (compare(value, array[start + m]) < 0) {
      offset = m;
    } else {
      lastOffset = m + 1;
    }
  }

  return offset;
}

function TimSort(array, compare) {
  var minGallop = DEFAULT_MIN_GALLOPING;
  var length = 0;
  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
  var stackLength = 0;
  var runStart;
  var runLength;
  var stackSize = 0;
  length = array.length;

  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
    tmpStorageLength = length >>> 1;
  }

  var tmp = [];
  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
  runStart = [];
  runLength = [];

  function pushRun(_runStart, _runLength) {
    runStart[stackSize] = _runStart;
    runLength[stackSize] = _runLength;
    stackSize += 1;
  }

  function mergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
        if (runLength[n - 1] < runLength[n + 1]) {
          n--;
        }
      } else if (runLength[n] > runLength[n + 1]) {
        break;
      }

      mergeAt(n);
    }
  }

  function forceMergeRuns() {
    while (stackSize > 1) {
      var n = stackSize - 2;

      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
        n--;
      }

      mergeAt(n);
    }
  }

  function mergeAt(i) {
    var start1 = runStart[i];
    var length1 = runLength[i];
    var start2 = runStart[i + 1];
    var length2 = runLength[i + 1];
    runLength[i] = length1 + length2;

    if (i === stackSize - 3) {
      runStart[i + 1] = runStart[i + 2];
      runLength[i + 1] = runLength[i + 2];
    }

    stackSize--;
    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
    start1 += k;
    length1 -= k;

    if (length1 === 0) {
      return;
    }

    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);

    if (length2 === 0) {
      return;
    }

    if (length1 <= length2) {
      mergeLow(start1, length1, start2, length2);
    } else {
      mergeHigh(start1, length1, start2, length2);
    }
  }

  function mergeLow(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length1; i++) {
      tmp[i] = array[start1 + i];
    }

    var cursor1 = 0;
    var cursor2 = start2;
    var dest = start1;
    array[dest++] = array[cursor2++];

    if (--length2 === 0) {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }

      return;
    }

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
      return;
    }

    var _minGallop = minGallop;
    var count1, count2, exit;

    while (1) {
      count1 = 0;
      count2 = 0;
      exit = false;

      do {
        if (compare(array[cursor2], tmp[cursor1]) < 0) {
          array[dest++] = array[cursor2++];
          count2++;
          count1 = 0;

          if (--length2 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest++] = tmp[cursor1++];
          count1++;
          count2 = 0;

          if (--length1 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);

        if (count1 !== 0) {
          for (i = 0; i < count1; i++) {
            array[dest + i] = tmp[cursor1 + i];
          }

          dest += count1;
          cursor1 += count1;
          length1 -= count1;

          if (length1 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest++] = array[cursor2++];

        if (--length2 === 0) {
          exit = true;
          break;
        }

        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);

        if (count2 !== 0) {
          for (i = 0; i < count2; i++) {
            array[dest + i] = array[cursor2 + i];
          }

          dest += count2;
          cursor2 += count2;
          length2 -= count2;

          if (length2 === 0) {
            exit = true;
            break;
          }
        }

        array[dest++] = tmp[cursor1++];

        if (--length1 === 1) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;
    minGallop < 1 && (minGallop = 1);

    if (length1 === 1) {
      for (i = 0; i < length2; i++) {
        array[dest + i] = array[cursor2 + i];
      }

      array[dest + length2] = tmp[cursor1];
    } else if (length1 === 0) {
      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
    } else {
      for (i = 0; i < length1; i++) {
        array[dest + i] = tmp[cursor1 + i];
      }
    }
  }

  function mergeHigh(start1, length1, start2, length2) {
    var i = 0;

    for (i = 0; i < length2; i++) {
      tmp[i] = array[start2 + i];
    }

    var cursor1 = start1 + length1 - 1;
    var cursor2 = length2 - 1;
    var dest = start2 + length2 - 1;
    var customCursor = 0;
    var customDest = 0;
    array[dest--] = array[cursor1--];

    if (--length1 === 0) {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }

      return;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
      return;
    }

    var _minGallop = minGallop;

    while (true) {
      var count1 = 0;
      var count2 = 0;
      var exit = false;

      do {
        if (compare(tmp[cursor2], array[cursor1]) < 0) {
          array[dest--] = array[cursor1--];
          count1++;
          count2 = 0;

          if (--length1 === 0) {
            exit = true;
            break;
          }
        } else {
          array[dest--] = tmp[cursor2--];
          count2++;
          count1 = 0;

          if (--length2 === 1) {
            exit = true;
            break;
          }
        }
      } while ((count1 | count2) < _minGallop);

      if (exit) {
        break;
      }

      do {
        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);

        if (count1 !== 0) {
          dest -= count1;
          cursor1 -= count1;
          length1 -= count1;
          customDest = dest + 1;
          customCursor = cursor1 + 1;

          for (i = count1 - 1; i >= 0; i--) {
            array[customDest + i] = array[customCursor + i];
          }

          if (length1 === 0) {
            exit = true;
            break;
          }
        }

        array[dest--] = tmp[cursor2--];

        if (--length2 === 1) {
          exit = true;
          break;
        }

        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);

        if (count2 !== 0) {
          dest -= count2;
          cursor2 -= count2;
          length2 -= count2;
          customDest = dest + 1;
          customCursor = cursor2 + 1;

          for (i = 0; i < count2; i++) {
            array[customDest + i] = tmp[customCursor + i];
          }

          if (length2 <= 1) {
            exit = true;
            break;
          }
        }

        array[dest--] = array[cursor1--];

        if (--length1 === 0) {
          exit = true;
          break;
        }

        _minGallop--;
      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);

      if (exit) {
        break;
      }

      if (_minGallop < 0) {
        _minGallop = 0;
      }

      _minGallop += 2;
    }

    minGallop = _minGallop;

    if (minGallop < 1) {
      minGallop = 1;
    }

    if (length2 === 1) {
      dest -= length1;
      cursor1 -= length1;
      customDest = dest + 1;
      customCursor = cursor1 + 1;

      for (i = length1 - 1; i >= 0; i--) {
        array[customDest + i] = array[customCursor + i];
      }

      array[dest] = tmp[cursor2];
    } else if (length2 === 0) {
      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
    } else {
      customCursor = dest - (length2 - 1);

      for (i = 0; i < length2; i++) {
        array[customCursor + i] = tmp[i];
      }
    }
  }

  this.mergeRuns = mergeRuns;
  this.forceMergeRuns = forceMergeRuns;
  this.pushRun = pushRun;
}

function sort(array, compare, lo, hi) {
  if (!lo) {
    lo = 0;
  }

  if (!hi) {
    hi = array.length;
  }

  var remaining = hi - lo;

  if (remaining < 2) {
    return;
  }

  var runLength = 0;

  if (remaining < DEFAULT_MIN_MERGE) {
    runLength = makeAscendingRun(array, lo, hi, compare);
    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
    return;
  }

  var ts = new TimSort(array, compare);
  var minRun = minRunLength(remaining);

  do {
    runLength = makeAscendingRun(array, lo, hi, compare);

    if (runLength < minRun) {
      var force = remaining;

      if (force > minRun) {
        force = minRun;
      }

      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
      runLength = force;
    }

    ts.pushRun(lo, runLength);
    ts.mergeRuns();
    remaining -= runLength;
    lo += runLength;
  } while (remaining !== 0);

  ts.forceMergeRuns();
}

module.exports = sort;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Style = __webpack_require__(713);

var Element = __webpack_require__(704);

var RectText = __webpack_require__(1931);

/**
 * 可绘制的图形基类
 * Base class of all displayable graphic objects
 * @module zrender/graphic/Displayable
 */

/**
 * @alias module:zrender/graphic/Displayable
 * @extends module:zrender/Element
 * @extends module:zrender/graphic/mixin/RectText
 */
function Displayable(opts) {
  opts = opts || {};
  Element.call(this, opts); // Extend properties

  for (var name in opts) {
    if (opts.hasOwnProperty(name) && name !== 'style') {
      this[name] = opts[name];
    }
  }
  /**
   * @type {module:zrender/graphic/Style}
   */


  this.style = new Style(opts.style, this);
  this._rect = null; // Shapes for cascade clipping.

  this.__clipPaths = []; // FIXME Stateful must be mixined after style is setted
  // Stateful.call(this, opts);
}

Displayable.prototype = {
  constructor: Displayable,
  type: 'displayable',

  /**
   * Displayable 是否为脏，Painter 中会根据该标记判断是否需要是否需要重新绘制
   * Dirty flag. From which painter will determine if this displayable object needs brush
   * @name module:zrender/graphic/Displayable#__dirty
   * @type {boolean}
   */
  __dirty: true,

  /**
   * 图形是否可见，为true时不绘制图形，但是仍能触发鼠标事件
   * If ignore drawing of the displayable object. Mouse event will still be triggered
   * @name module:/zrender/graphic/Displayable#invisible
   * @type {boolean}
   * @default false
   */
  invisible: false,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z: 0,

  /**
   * @name module:/zrender/graphic/Displayable#z
   * @type {number}
   * @default 0
   */
  z2: 0,

  /**
   * z层level，决定绘画在哪层canvas中
   * @name module:/zrender/graphic/Displayable#zlevel
   * @type {number}
   * @default 0
   */
  zlevel: 0,

  /**
   * 是否可拖拽
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  draggable: false,

  /**
   * 是否正在拖拽
   * @name module:/zrender/graphic/Displayable#draggable
   * @type {boolean}
   * @default false
   */
  dragging: false,

  /**
   * 是否相应鼠标事件
   * @name module:/zrender/graphic/Displayable#silent
   * @type {boolean}
   * @default false
   */
  silent: false,

  /**
   * If enable culling
   * @type {boolean}
   * @default false
   */
  culling: false,

  /**
   * Mouse cursor when hovered
   * @name module:/zrender/graphic/Displayable#cursor
   * @type {string}
   */
  cursor: 'pointer',

  /**
   * If hover area is bounding rect
   * @name module:/zrender/graphic/Displayable#rectHover
   * @type {string}
   */
  rectHover: false,

  /**
   * Render the element progressively when the value >= 0,
   * usefull for large data.
   * @type {number}
   */
  progressive: -1,
  beforeBrush: function (ctx) {},
  afterBrush: function (ctx) {},

  /**
   * 图形绘制方法
   * @param {CanvasRenderingContext2D} ctx
   */
  // Interface
  brush: function (ctx, prevEl) {},

  /**
   * 获取最小包围盒
   * @return {module:zrender/core/BoundingRect}
   */
  // Interface
  getBoundingRect: function () {},

  /**
   * 判断坐标 x, y 是否在图形上
   * If displayable element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  contain: function (x, y) {
    return this.rectContain(x, y);
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {
    cb.call(context, this);
  },

  /**
   * 判断坐标 x, y 是否在图形的包围盒上
   * If bounding rect of element contain coord x, y
   * @param  {number} x
   * @param  {number} y
   * @return {boolean}
   */
  rectContain: function (x, y) {
    var coord = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    return rect.contain(coord[0], coord[1]);
  },

  /**
   * 标记图形元素为脏，并且在下一帧重绘
   * Mark displayable element dirty and refresh next frame
   */
  dirty: function () {
    this.__dirty = true;
    this._rect = null;
    this.__zr && this.__zr.refresh();
  },

  /**
   * 图形是否会触发事件
   * If displayable object binded any event
   * @return {boolean}
   */
  // TODO, 通过 bind 绑定的事件
  // isSilent: function () {
  //     return !(
  //         this.hoverable || this.draggable
  //         || this.onmousemove || this.onmouseover || this.onmouseout
  //         || this.onmousedown || this.onmouseup || this.onclick
  //         || this.ondragenter || this.ondragover || this.ondragleave
  //         || this.ondrop
  //     );
  // },

  /**
   * Alias for animate('style')
   * @param {boolean} loop
   */
  animateStyle: function (loop) {
    return this.animate('style', loop);
  },
  attrKV: function (key, value) {
    if (key !== 'style') {
      Element.prototype.attrKV.call(this, key, value);
    } else {
      this.style.set(value);
    }
  },

  /**
   * @param {Object|string} key
   * @param {*} value
   */
  setStyle: function (key, value) {
    this.style.set(key, value);
    this.dirty(false);
    return this;
  },

  /**
   * Use given style object
   * @param  {Object} obj
   */
  useStyle: function (obj) {
    this.style = new Style(obj, this);
    this.dirty(false);
    return this;
  }
};
zrUtil.inherits(Displayable, Element);
zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);

var _default = Displayable;
module.exports = _default;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * @param {Array.<Object>} colorStops
 */
var Gradient = function (colorStops) {
  this.colorStops = colorStops || [];
};

Gradient.prototype = {
  constructor: Gradient,
  addColorStop: function (offset, color) {
    this.colorStops.push({
      offset: offset,
      color: color
    });
  }
};
var _default = Gradient;
module.exports = _default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var LRU = __webpack_require__(709);

var globalImageCache = new LRU(50);
/**
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */

function findExistImage(newImageOrSrc) {
  if (typeof newImageOrSrc === 'string') {
    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    return cachedImgObj && cachedImgObj.image;
  } else {
    return newImageOrSrc;
  }
}
/**
 * Caution: User should cache loaded images, but not just count on LRU.
 * Consider if required images more than LRU size, will dead loop occur?
 *
 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
 * @param {Function} [cb] params: (image, cbPayload)
 * @param {Object} [cbPayload] Payload on cb calling.
 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
 */


function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
  if (!newImageOrSrc) {
    return image;
  } else if (typeof newImageOrSrc === 'string') {
    // Image should not be loaded repeatly.
    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
      return image;
    } // Only when there is no existent image or existent image src
    // is different, this method is responsible for load.


    var cachedImgObj = globalImageCache.get(newImageOrSrc);
    var pendingWrap = {
      hostEl: hostEl,
      cb: cb,
      cbPayload: cbPayload
    };

    if (cachedImgObj) {
      image = cachedImgObj.image;
      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
    } else {
      !image && (image = new Image());
      image.onload = imageOnLoad;
      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
        image: image,
        pending: [pendingWrap]
      });
      image.src = image.__zrImageSrc = newImageOrSrc;
    }

    return image;
  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
  else {
      return newImageOrSrc;
    }
}

function imageOnLoad() {
  var cachedImgObj = this.__cachedImgObj;
  this.onload = this.__cachedImgObj = null;

  for (var i = 0; i < cachedImgObj.pending.length; i++) {
    var pendingWrap = cachedImgObj.pending[i];
    var cb = pendingWrap.cb;
    cb && cb(this, pendingWrap.cbPayload);
    pendingWrap.hostEl.dirty();
  }

  cachedImgObj.pending.length = 0;
}

function isImageReady(image) {
  return image && image.width && image.height;
}

exports.findExistImage = findExistImage;
exports.createOrUpdateImage = createOrUpdateImage;
exports.isImageReady = isImageReady;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(6);

var retrieve2 = _util.retrieve2;
var retrieve3 = _util.retrieve3;
var each = _util.each;
var normalizeCssArray = _util.normalizeCssArray;
var isString = _util.isString;
var isObject = _util.isObject;

var textContain = __webpack_require__(112);

var roundRectHelper = __webpack_require__(716);

var imageHelper = __webpack_require__(400);

// TODO: Have not support 'start', 'end' yet.
var VALID_TEXT_ALIGN = {
  left: 1,
  right: 1,
  center: 1
};
var VALID_TEXT_VERTICAL_ALIGN = {
  top: 1,
  bottom: 1,
  middle: 1
};
/**
 * @param {module:zrender/graphic/Style} style
 * @return {module:zrender/graphic/Style} The input style.
 */

function normalizeTextStyle(style) {
  normalizeStyle(style);
  each(style.rich, normalizeStyle);
  return style;
}

function normalizeStyle(style) {
  if (style) {
    style.font = textContain.makeFont(style);
    var textAlign = style.textAlign;
    textAlign === 'middle' && (textAlign = 'center');
    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.

    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
    var textPadding = style.textPadding;

    if (textPadding) {
      style.textPadding = normalizeCssArray(style.textPadding);
    }
  }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {string} text
 * @param {module:zrender/graphic/Style} style
 * @param {Object|boolean} [rect] {x, y, width, height}
 *                  If set false, rect text is not used.
 */


function renderText(hostEl, ctx, text, style, rect) {
  style.rich ? renderRichText(hostEl, ctx, text, style, rect) : renderPlainText(hostEl, ctx, text, style, rect);
}

function renderPlainText(hostEl, ctx, text, style, rect) {
  var font = setCtx(ctx, 'font', style.font || textContain.DEFAULT_FONT);
  var textPadding = style.textPadding;
  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirty) {
    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, font, textPadding, style.truncate);
  }

  var outerHeight = contentBlock.outerHeight;
  var textLines = contentBlock.lines;
  var lineHeight = contentBlock.lineHeight;
  var boxPos = getBoxPosition(outerHeight, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign;
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var textX = baseX;
  var textY = boxY;
  var needDrawBg = needDrawBackground(style);

  if (needDrawBg || textPadding) {
    // Consider performance, do not call getTextWidth util necessary.
    var textWidth = textContain.getWidth(text, font);
    var outerWidth = textWidth;
    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

    if (textPadding) {
      textX = getTextXForPadding(baseX, textAlign, textPadding);
      textY += textPadding[0];
    }
  }

  setCtx(ctx, 'textAlign', textAlign || 'left'); // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  setCtx(ctx, 'textBaseline', 'middle'); // Always set shadowBlur and shadowOffset to avoid leak from displayable.

  setCtx(ctx, 'shadowBlur', style.textShadowBlur || 0);
  setCtx(ctx, 'shadowColor', style.textShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', style.textShadowOffsetX || 0);
  setCtx(ctx, 'shadowOffsetY', style.textShadowOffsetY || 0); // `textBaseline` is set as 'middle'.

  textY += lineHeight / 2;
  var textStrokeWidth = style.textStrokeWidth;
  var textStroke = getStroke(style.textStroke, textStrokeWidth);
  var textFill = getFill(style.textFill);

  if (textStroke) {
    setCtx(ctx, 'lineWidth', textStrokeWidth);
    setCtx(ctx, 'strokeStyle', textStroke);
  }

  if (textFill) {
    setCtx(ctx, 'fillStyle', textFill);
  }

  for (var i = 0; i < textLines.length; i++) {
    // Fill after stroke so the outline will not cover the main part.
    textStroke && ctx.strokeText(textLines[i], textX, textY);
    textFill && ctx.fillText(textLines[i], textX, textY);
    textY += lineHeight;
  }
}

function renderRichText(hostEl, ctx, text, style, rect) {
  var contentBlock = hostEl.__textCotentBlock;

  if (!contentBlock || hostEl.__dirty) {
    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
  }

  drawRichText(hostEl, ctx, contentBlock, style, rect);
}

function drawRichText(hostEl, ctx, contentBlock, style, rect) {
  var contentWidth = contentBlock.width;
  var outerWidth = contentBlock.outerWidth;
  var outerHeight = contentBlock.outerHeight;
  var textPadding = style.textPadding;
  var boxPos = getBoxPosition(outerHeight, style, rect);
  var baseX = boxPos.baseX;
  var baseY = boxPos.baseY;
  var textAlign = boxPos.textAlign;
  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.

  applyTextRotation(ctx, style, rect, baseX, baseY);
  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
  var xLeft = boxX;
  var lineTop = boxY;

  if (textPadding) {
    xLeft += textPadding[3];
    lineTop += textPadding[0];
  }

  var xRight = xLeft + contentWidth;
  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);

  for (var i = 0; i < contentBlock.lines.length; i++) {
    var line = contentBlock.lines[i];
    var tokens = line.tokens;
    var tokenCount = tokens.length;
    var lineHeight = line.lineHeight;
    var usedWidth = line.width;
    var leftIndex = 0;
    var lineXLeft = xLeft;
    var lineXRight = xRight;
    var rightIndex = tokenCount - 1;
    var token;

    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
      usedWidth -= token.width;
      lineXLeft += token.width;
      leftIndex++;
    }

    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
      usedWidth -= token.width;
      lineXRight -= token.width;
      rightIndex--;
    } // The other tokens are placed as textAlign 'center' if there is enough space.


    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;

    while (leftIndex <= rightIndex) {
      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.

      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
      lineXLeft += token.width;
      leftIndex++;
    }

    lineTop += lineHeight;
  }
}

function applyTextRotation(ctx, style, rect, x, y) {
  // textRotation only apply in RectText.
  if (rect && style.textRotation) {
    var origin = style.textOrigin;

    if (origin === 'center') {
      x = rect.width / 2 + rect.x;
      y = rect.height / 2 + rect.y;
    } else if (origin) {
      x = origin[0] + rect.x;
      y = origin[1] + rect.y;
    }

    ctx.translate(x, y); // Positive: anticlockwise

    ctx.rotate(-style.textRotation);
    ctx.translate(-x, -y);
  }
}

function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
  var tokenStyle = style.rich[token.styleName] || {}; // 'ctx.textBaseline' is always set as 'middle', for sake of
  // the bias of "Microsoft YaHei".

  var textVerticalAlign = token.textVerticalAlign;
  var y = lineTop + lineHeight / 2;

  if (textVerticalAlign === 'top') {
    y = lineTop + token.height / 2;
  } else if (textVerticalAlign === 'bottom') {
    y = lineTop + lineHeight - token.height / 2;
  }

  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
  var textPadding = token.textPadding;

  if (textPadding) {
    x = getTextXForPadding(x, textAlign, textPadding);
    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
  }

  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
  // text will offset downward a little bit in font "Microsoft YaHei".

  setCtx(ctx, 'textBaseline', 'middle');
  setCtx(ctx, 'font', token.font || textContain.DEFAULT_FONT);
  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
  var textFill = getFill(tokenStyle.textFill || style.textFill);
  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.

  if (textStroke) {
    setCtx(ctx, 'lineWidth', textStrokeWidth);
    setCtx(ctx, 'strokeStyle', textStroke);
    ctx.strokeText(token.text, x, y);
  }

  if (textFill) {
    setCtx(ctx, 'fillStyle', textFill);
    ctx.fillText(token.text, x, y);
  }
}

function needDrawBackground(style) {
  return style.textBackgroundColor || style.textBorderWidth && style.textBorderColor;
} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius}
// shape: {x, y, width, height}


function drawBackground(hostEl, ctx, style, x, y, width, height) {
  var textBackgroundColor = style.textBackgroundColor;
  var textBorderWidth = style.textBorderWidth;
  var textBorderColor = style.textBorderColor;
  var isPlainBg = isString(textBackgroundColor);
  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);

  if (isPlainBg || textBorderWidth && textBorderColor) {
    ctx.beginPath();
    var textBorderRadius = style.textBorderRadius;

    if (!textBorderRadius) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, {
        x: x,
        y: y,
        width: width,
        height: height,
        r: textBorderRadius
      });
    }

    ctx.closePath();
  }

  if (isPlainBg) {
    setCtx(ctx, 'fillStyle', textBackgroundColor);
    ctx.fill();
  } else if (isObject(textBackgroundColor)) {
    var image = textBackgroundColor.image;
    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);

    if (image && imageHelper.isImageReady(image)) {
      ctx.drawImage(image, x, y, width, height);
    }
  }

  if (textBorderWidth && textBorderColor) {
    setCtx(ctx, 'lineWidth', textBorderWidth);
    setCtx(ctx, 'strokeStyle', textBorderColor);
    ctx.stroke();
  }
}

function onBgImageLoaded(image, textBackgroundColor) {
  // Replace image, so that `contain/text.js#parseRichText`
  // will get correct result in next tick.
  textBackgroundColor.image = image;
}

function getBoxPosition(blockHeiht, style, rect) {
  var baseX = style.x || 0;
  var baseY = style.y || 0;
  var textAlign = style.textAlign;
  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord

  if (rect) {
    var textPosition = style.textPosition;

    if (textPosition instanceof Array) {
      // Percent
      baseX = rect.x + parsePercent(textPosition[0], rect.width);
      baseY = rect.y + parsePercent(textPosition[1], rect.height);
    } else {
      var res = textContain.adjustTextPositionOnRect(textPosition, rect, style.textDistance);
      baseX = res.x;
      baseY = res.y; // Default align and baseline when has textPosition

      textAlign = textAlign || res.textAlign;
      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
    } // textOffset is only support in RectText, otherwise
    // we have to adjust boundingRect for textOffset.


    var textOffset = style.textOffset;

    if (textOffset) {
      baseX += textOffset[0];
      baseY += textOffset[1];
    }
  }

  return {
    baseX: baseX,
    baseY: baseY,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

function setCtx(ctx, prop, value) {
  // FIXME ??? performance try
  // if (ctx.__currentValues[prop] !== value) {
  // ctx[prop] = ctx.__currentValues[prop] = value;
  ctx[prop] = value; // }

  return ctx[prop];
}
/**
 * @param {string} [stroke] If specified, do not check style.textStroke.
 * @param {string} [lineWidth] If specified, do not check style.textStroke.
 * @param {number} style
 */


function getStroke(stroke, lineWidth) {
  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
  : stroke.image || stroke.colorStops ? '#000' : stroke;
}

function getFill(fill) {
  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
  : fill.image || fill.colorStops ? '#000' : fill;
}

function parsePercent(value, maxValue) {
  if (typeof value === 'string') {
    if (value.lastIndexOf('%') >= 0) {
      return parseFloat(value) / 100 * maxValue;
    }

    return parseFloat(value);
  }

  return value;
}

function getTextXForPadding(x, textAlign, textPadding) {
  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
/**
 * @param {string} text
 * @param {module:zrender/Style} style
 * @return {boolean}
 */


function needDrawText(text, style) {
  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
}

exports.normalizeTextStyle = normalizeTextStyle;
exports.renderText = renderText;
exports.getStroke = getStroke;
exports.getFill = getFill;
exports.needDrawText = needDrawText;

/***/ }),
/* 402 */
/***/ (function(module, exports) {

var svgURI = 'http://www.w3.org/2000/svg';

function createElement(name) {
  return document.createElementNS(svgURI, name);
}

exports.createElement = createElement;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(402);

var createElement = _core.createElement;

var PathProxy = __webpack_require__(192);

var BoundingRect = __webpack_require__(63);

var textContain = __webpack_require__(112);

var textHelper = __webpack_require__(401);

var Text = __webpack_require__(264);

// TODO
// 1. shadow
// 2. Image: sx, sy, sw, sh
var CMD = PathProxy.CMD;
var arrayJoin = Array.prototype.join;
var NONE = 'none';
var mathRound = Math.round;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;
var PI2 = Math.PI * 2;
var degree = 180 / PI;
var EPSILON = 1e-4;

function round4(val) {
  return mathRound(val * 1e4) / 1e4;
}

function isAroundZero(val) {
  return val < EPSILON && val > -EPSILON;
}

function pathHasFill(style, isText) {
  var fill = isText ? style.textFill : style.fill;
  return fill != null && fill !== NONE;
}

function pathHasStroke(style, isText) {
  var stroke = isText ? style.textStroke : style.stroke;
  return stroke != null && stroke !== NONE;
}

function setTransform(svgEl, m) {
  if (m) {
    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
  }
}

function attr(el, key, val) {
  if (!val || val.type !== 'linear' && val.type !== 'radial') {
    // Don't set attribute for gradient, since it need new dom nodes
    el.setAttribute(key, val);
  }
}

function attrXLink(el, key, val) {
  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
}

function bindStyle(svgEl, style, isText) {
  if (pathHasFill(style, isText)) {
    var fill = isText ? style.textFill : style.fill;
    fill = fill === 'transparent' ? NONE : fill;
    /**
     * FIXME:
     * This is a temporary fix for Chrome's clipping bug
     * that happens when a clip-path is referring another one.
     * This fix should be used before Chrome's bug is fixed.
     * For an element that has clip-path, and fill is none,
     * set it to be "rgba(0, 0, 0, 0.002)" will hide the element.
     * Otherwise, it will show black fill color.
     * 0.002 is used because this won't work for alpha values smaller
     * than 0.002.
     *
     * See
     * https://bugs.chromium.org/p/chromium/issues/detail?id=659790
     * for more information.
     */

    if (svgEl.getAttribute('clip-path') !== 'none' && fill === NONE) {
      fill = 'rgba(0, 0, 0, 0.002)';
    }

    attr(svgEl, 'fill', fill);
    attr(svgEl, 'fill-opacity', style.opacity);
  } else {
    attr(svgEl, 'fill', NONE);
  }

  if (pathHasStroke(style, isText)) {
    var stroke = isText ? style.textStroke : style.stroke;
    stroke = stroke === 'transparent' ? NONE : stroke;
    attr(svgEl, 'stroke', stroke);
    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
    var strokeScale = style.strokeNoScale ? style.host.getLineScale() : 1;
    attr(svgEl, 'stroke-width', strokeWidth / strokeScale);
    attr(svgEl, 'paint-order', 'stroke');
    attr(svgEl, 'stroke-opacity', style.opacity);
    var lineDash = style.lineDash;

    if (lineDash) {
      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
    } else {
      attr(svgEl, 'stroke-dasharray', '');
    } // PENDING


    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
  } else {
    attr(svgEl, 'stroke', NONE);
  }
}
/***************************************************
 * PATH
 **************************************************/


function pathDataToString(path) {
  var str = [];
  var data = path.data;
  var dataLength = path.len();

  for (var i = 0; i < dataLength;) {
    var cmd = data[i++];
    var cmdStr = '';
    var nData = 0;

    switch (cmd) {
      case CMD.M:
        cmdStr = 'M';
        nData = 2;
        break;

      case CMD.L:
        cmdStr = 'L';
        nData = 2;
        break;

      case CMD.Q:
        cmdStr = 'Q';
        nData = 4;
        break;

      case CMD.C:
        cmdStr = 'C';
        nData = 6;
        break;

      case CMD.A:
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++];
        var psi = data[i++];
        var clockwise = data[i++];
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = isAroundZero(dThetaPositive % PI2) && !isAroundZero(dThetaPositive);
        var large = false;

        if (dThetaPositive >= PI2) {
          large = true;
        } else if (isAroundZero(dThetaPositive)) {
          large = false;
        } else {
          large = (dTheta > -PI && dTheta < 0 || dTheta > PI) === !!clockwise;
        }

        var x0 = round4(cx + rx * mathCos(theta));
        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
        // We need to shift the end point with a small value
        // FIXME A better way to draw circle ?

        if (isCircle) {
          if (clockwise) {
            dTheta = PI2 - 1e-4;
          } else {
            dTheta = -PI2 + 1e-4;
          }

          large = true;

          if (i === 9) {
            // Move to (x0, y0) only when CMD.A comes at the
            // first position of a shape.
            // For instance, when drawing a ring, CMD.A comes
            // after CMD.M, so it's unnecessary to move to
            // (x0, y0).
            str.push('M', x0, y0);
          }
        }

        var x = round4(cx + rx * mathCos(theta + dTheta));
        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse

        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
        break;

      case CMD.Z:
        cmdStr = 'Z';
        break;

      case CMD.R:
        var x = round4(data[i++]);
        var y = round4(data[i++]);
        var w = round4(data[i++]);
        var h = round4(data[i++]);
        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
        break;
    }

    cmdStr && str.push(cmdStr);

    for (var j = 0; j < nData; j++) {
      // PENDING With scale
      str.push(round4(data[i++]));
    }
  }

  return str.join(' ');
}

var svgPath = {};

svgPath.brush = function (el) {
  var style = el.style;
  var svgEl = el.__svgEl;

  if (!svgEl) {
    svgEl = createElement('path');
    el.__svgEl = svgEl;
  }

  if (!el.path) {
    el.createPathProxy();
  }

  var path = el.path;

  if (el.__dirtyPath) {
    path.beginPath();
    el.buildPath(path, el.shape);
    el.__dirtyPath = false;
    var pathStr = pathDataToString(path);

    if (pathStr.indexOf('NaN') < 0) {
      // Ignore illegal path, which may happen such in out-of-range
      // data in Calendar series.
      attr(svgEl, 'd', pathStr);
    }
  }

  bindStyle(svgEl, style);
  setTransform(svgEl, el.transform);

  if (style.text != null) {
    svgTextDrawRectText(el, el.getBoundingRect());
  }
};
/***************************************************
 * IMAGE
 **************************************************/


var svgImage = {};

svgImage.brush = function (el) {
  var style = el.style;
  var image = style.image;

  if (image instanceof HTMLImageElement) {
    var src = image.src;
    image = src;
  }

  if (!image) {
    return;
  }

  var x = style.x || 0;
  var y = style.y || 0;
  var dw = style.width;
  var dh = style.height;
  var svgEl = el.__svgEl;

  if (!svgEl) {
    svgEl = createElement('image');
    el.__svgEl = svgEl;
  }

  if (image !== el.__imageSrc) {
    attrXLink(svgEl, 'href', image); // Caching image src

    el.__imageSrc = image;
  }

  attr(svgEl, 'width', dw);
  attr(svgEl, 'height', dh);
  attr(svgEl, 'x', x);
  attr(svgEl, 'y', y);
  setTransform(svgEl, el.transform);

  if (style.text != null) {
    svgTextDrawRectText(el, el.getBoundingRect());
  }
};
/***************************************************
 * TEXT
 **************************************************/


var svgText = {};
var tmpRect = new BoundingRect();

var svgTextDrawRectText = function (el, rect, textRect) {
  var style = el.style;
  el.__dirty && textHelper.normalizeTextStyle(style, true);
  var text = style.text; // Convert to string

  if (text == null) {
    // Draw no text only when text is set to null, but not ''
    return;
  } else {
    text += '';
  }

  var textSvgEl = el.__textSvgEl;

  if (!textSvgEl) {
    textSvgEl = createElement('text');
    el.__textSvgEl = textSvgEl;
  }

  bindStyle(textSvgEl, style, true);

  if (el instanceof Text || el.style.transformText) {
    // Transform text with element
    setTransform(textSvgEl, el.transform);
  } else {
    if (el.transform) {
      tmpRect.copy(rect);
      tmpRect.applyTransform(el.transform);
      rect = tmpRect;
    } else {
      var pos = el.transformCoordToGlobal(rect.x, rect.y);
      rect.x = pos[0];
      rect.y = pos[1];
    }
  }

  var x;
  var y;
  var textPosition = style.textPosition;
  var distance = style.textDistance;
  var align = style.textAlign || 'left';

  if (typeof style.fontSize === 'number') {
    style.fontSize += 'px';
  }

  var font = style.font || [style.fontStyle || '', style.fontWeight || '', style.fontSize || '', style.fontFamily || ''].join(' ') || textContain.DEFAULT_FONT;
  var verticalAlign = getVerticalAlignForSvg(style.textVerticalAlign);
  textRect = textContain.getBoundingRect(text, font, align, verticalAlign);
  var lineHeight = textRect.lineHeight; // Text position represented by coord

  if (textPosition instanceof Array) {
    x = rect.x + textPosition[0];
    y = rect.y + textPosition[1];
  } else {
    var newPos = textContain.adjustTextPositionOnRect(textPosition, rect, distance);
    x = newPos.x;
    y = newPos.y;
    verticalAlign = getVerticalAlignForSvg(newPos.textVerticalAlign);
    align = newPos.textAlign;
  }

  attr(textSvgEl, 'alignment-baseline', verticalAlign);

  if (font) {
    textSvgEl.style.font = font;
  }

  var textPadding = style.textPadding; // Make baseline top

  attr(textSvgEl, 'x', x);
  attr(textSvgEl, 'y', y);
  var textLines = text.split('\n');
  var nTextLines = textLines.length;
  var textAnchor = align; // PENDING

  if (textAnchor === 'left') {
    textAnchor = 'start';
    textPadding && (x += textPadding[3]);
  } else if (textAnchor === 'right') {
    textAnchor = 'end';
    textPadding && (x -= textPadding[1]);
  } else if (textAnchor === 'center') {
    textAnchor = 'middle';
    textPadding && (x += (textPadding[3] - textPadding[1]) / 2);
  }

  var dy = 0;

  if (verticalAlign === 'baseline') {
    dy = -textRect.height + lineHeight;
    textPadding && (dy -= textPadding[2]);
  } else if (verticalAlign === 'middle') {
    dy = (-textRect.height + lineHeight) / 2;
    textPadding && (y += (textPadding[0] - textPadding[2]) / 2);
  } else {
    textPadding && (dy += textPadding[0]);
  } // Font may affect position of each tspan elements


  if (el.__text !== text || el.__textFont !== font) {
    var tspanList = el.__tspanList || [];
    el.__tspanList = tspanList;

    for (var i = 0; i < nTextLines; i++) {
      // Using cached tspan elements
      var tspan = tspanList[i];

      if (!tspan) {
        tspan = tspanList[i] = createElement('tspan');
        textSvgEl.appendChild(tspan);
        attr(tspan, 'alignment-baseline', verticalAlign);
        attr(tspan, 'text-anchor', textAnchor);
      } else {
        tspan.innerHTML = '';
      }

      attr(tspan, 'x', x);
      attr(tspan, 'y', y + i * lineHeight + dy);
      tspan.appendChild(document.createTextNode(textLines[i]));
    } // Remove unsed tspan elements


    for (; i < tspanList.length; i++) {
      textSvgEl.removeChild(tspanList[i]);
    }

    tspanList.length = nTextLines;
    el.__text = text;
    el.__textFont = font;
  } else if (el.__tspanList.length) {
    // Update span x and y
    var len = el.__tspanList.length;

    for (var i = 0; i < len; ++i) {
      var tspan = el.__tspanList[i];

      if (tspan) {
        attr(tspan, 'x', x);
        attr(tspan, 'y', y + i * lineHeight + dy);
      }
    }
  }
};

function getVerticalAlignForSvg(verticalAlign) {
  if (verticalAlign === 'middle') {
    return 'middle';
  } else if (verticalAlign === 'bottom') {
    return 'baseline';
  } else {
    return 'hanging';
  }
}

svgText.drawRectText = svgTextDrawRectText;

svgText.brush = function (el) {
  var style = el.style;

  if (style.text != null) {
    // 强制设置 textPosition
    style.textPosition = [0, 0];
    svgTextDrawRectText(el, {
      x: style.x || 0,
      y: style.y || 0,
      width: 0,
      height: 0
    }, el.getBoundingRect());
  }
};

exports.path = svgPath;
exports.image = svgImage;
exports.text = svgText;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(711);

var env = __webpack_require__(64);

var zrUtil = __webpack_require__(6);

var Handler = __webpack_require__(1910);

var Storage = __webpack_require__(1913);

var Painter = __webpack_require__(1912);

var Animation = __webpack_require__(1914);

var HandlerProxy = __webpack_require__(1925);

/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var useVML = !env.canvasSupported;
var painterCtors = {
  canvas: Painter
};
var instances = {}; // ZRender实例map索引

/**
 * @type {string}
 */

var version = '3.7.4';
/**
 * Initializing a zrender instance
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
 * @return {module:zrender/ZRender}
 */

function init(dom, opts) {
  var zr = new ZRender(guid(), dom, opts);
  instances[zr.id] = zr;
  return zr;
}
/**
 * Dispose zrender instance
 * @param {module:zrender/ZRender} zr
 */


function dispose(zr) {
  if (zr) {
    zr.dispose();
  } else {
    for (var key in instances) {
      if (instances.hasOwnProperty(key)) {
        instances[key].dispose();
      }
    }

    instances = {};
  }

  return this;
}
/**
 * Get zrender instance by id
 * @param {string} id zrender instance id
 * @return {module:zrender/ZRender}
 */


function getInstance(id) {
  return instances[id];
}

function registerPainter(name, Ctor) {
  painterCtors[name] = Ctor;
}

function delInstance(id) {
  delete instances[id];
}
/**
 * @module zrender/ZRender
 */

/**
 * @constructor
 * @alias module:zrender/ZRender
 * @param {string} id
 * @param {HTMLElement} dom
 * @param {Object} opts
 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
 * @param {number} [opts.devicePixelRatio]
 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
 */


var ZRender = function (id, dom, opts) {
  opts = opts || {};
  /**
   * @type {HTMLDomElement}
   */

  this.dom = dom;
  /**
   * @type {string}
   */

  this.id = id;
  var self = this;
  var storage = new Storage();
  var rendererType = opts.renderer; // TODO WebGL

  if (useVML) {
    if (!painterCtors.vml) {
      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
    }

    rendererType = 'vml';
  } else if (!rendererType || !painterCtors[rendererType]) {
    rendererType = 'canvas';
  }

  var painter = new painterCtors[rendererType](dom, storage, opts);
  this.storage = storage;
  this.painter = painter;
  var handerProxy = !env.node ? new HandlerProxy(painter.getViewportRoot()) : null;
  this.handler = new Handler(storage, painter, handerProxy, painter.root);
  /**
   * @type {module:zrender/animation/Animation}
   */

  this.animation = new Animation({
    stage: {
      update: zrUtil.bind(this.flush, this)
    }
  });
  this.animation.start();
  /**
   * @type {boolean}
   * @private
   */

  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
  // FIXME 有点ugly

  var oldDelFromStorage = storage.delFromStorage;
  var oldAddToStorage = storage.addToStorage;

  storage.delFromStorage = function (el) {
    oldDelFromStorage.call(storage, el);
    el && el.removeSelfFromZr(self);
  };

  storage.addToStorage = function (el) {
    oldAddToStorage.call(storage, el);
    el.addSelfToZr(self);
  };
};

ZRender.prototype = {
  constructor: ZRender,

  /**
   * 获取实例唯一标识
   * @return {string}
   */
  getId: function () {
    return this.id;
  },

  /**
   * 添加元素
   * @param  {module:zrender/Element} el
   */
  add: function (el) {
    this.storage.addRoot(el);
    this._needsRefresh = true;
  },

  /**
   * 删除元素
   * @param  {module:zrender/Element} el
   */
  remove: function (el) {
    this.storage.delRoot(el);
    this._needsRefresh = true;
  },

  /**
   * Change configuration of layer
   * @param {string} zLevel
   * @param {Object} config
   * @param {string} [config.clearColor=0] Clear color
   * @param {string} [config.motionBlur=false] If enable motion blur
   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
  */
  configLayer: function (zLevel, config) {
    this.painter.configLayer(zLevel, config);
    this._needsRefresh = true;
  },

  /**
   * Repaint the canvas immediately
   */
  refreshImmediately: function () {
    // var start = new Date();
    // Clear needsRefresh ahead to avoid something wrong happens in refresh
    // Or it will cause zrender refreshes again and again.
    this._needsRefresh = false;
    this.painter.refresh();
    /**
     * Avoid trigger zr.refresh in Element#beforeUpdate hook
     */

    this._needsRefresh = false; // var end = new Date();
    // var log = document.getElementById('log');
    // if (log) {
    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
    // }
  },

  /**
   * Mark and repaint the canvas in the next frame of browser
   */
  refresh: function () {
    this._needsRefresh = true;
  },

  /**
   * Perform all refresh
   */
  flush: function () {
    if (this._needsRefresh) {
      this.refreshImmediately();
    }

    if (this._needsRefreshHover) {
      this.refreshHoverImmediately();
    }
  },

  /**
   * Add element to hover layer
   * @param  {module:zrender/Element} el
   * @param {Object} style
   */
  addHover: function (el, style) {
    if (this.painter.addHover) {
      this.painter.addHover(el, style);
      this.refreshHover();
    }
  },

  /**
   * Add element from hover layer
   * @param  {module:zrender/Element} el
   */
  removeHover: function (el) {
    if (this.painter.removeHover) {
      this.painter.removeHover(el);
      this.refreshHover();
    }
  },

  /**
   * Clear all hover elements in hover layer
   * @param  {module:zrender/Element} el
   */
  clearHover: function () {
    if (this.painter.clearHover) {
      this.painter.clearHover();
      this.refreshHover();
    }
  },

  /**
   * Refresh hover in next frame
   */
  refreshHover: function () {
    this._needsRefreshHover = true;
  },

  /**
   * Refresh hover immediately
   */
  refreshHoverImmediately: function () {
    this._needsRefreshHover = false;
    this.painter.refreshHover && this.painter.refreshHover();
  },

  /**
   * Resize the canvas.
   * Should be invoked when container size is changed
   * @param {Object} [opts]
   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
   */
  resize: function (opts) {
    opts = opts || {};
    this.painter.resize(opts.width, opts.height);
    this.handler.resize();
  },

  /**
   * Stop and clear all animation immediately
   */
  clearAnimation: function () {
    this.animation.clear();
  },

  /**
   * Get container width
   */
  getWidth: function () {
    return this.painter.getWidth();
  },

  /**
   * Get container height
   */
  getHeight: function () {
    return this.painter.getHeight();
  },

  /**
   * Export the canvas as Base64 URL
   * @param {string} type
   * @param {string} [backgroundColor='#fff']
   * @return {string} Base64 URL
   */
  // toDataURL: function(type, backgroundColor) {
  //     return this.painter.getRenderedCanvas({
  //         backgroundColor: backgroundColor
  //     }).toDataURL(type);
  // },

  /**
   * Converting a path to image.
   * It has much better performance of drawing image rather than drawing a vector path.
   * @param {module:zrender/graphic/Path} e
   * @param {number} width
   * @param {number} height
   */
  pathToImage: function (e, dpr) {
    return this.painter.pathToImage(e, dpr);
  },

  /**
   * Set default cursor
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    this.handler.setCursorStyle(cursorStyle);
  },

  /**
   * Find hovered element
   * @param {number} x
   * @param {number} y
   * @return {Object} {target, topTarget}
   */
  findHover: function (x, y) {
    return this.handler.findHover(x, y);
  },

  /**
   * Bind event
   *
   * @param {string} eventName Event name
   * @param {Function} eventHandler Handler function
   * @param {Object} [context] Context object
   */
  on: function (eventName, eventHandler, context) {
    this.handler.on(eventName, eventHandler, context);
  },

  /**
   * Unbind event
   * @param {string} eventName Event name
   * @param {Function} [eventHandler] Handler function
   */
  off: function (eventName, eventHandler) {
    this.handler.off(eventName, eventHandler);
  },

  /**
   * Trigger event manually
   *
   * @param {string} eventName Event name
   * @param {event=} event Event object
   */
  trigger: function (eventName, event) {
    this.handler.trigger(eventName, event);
  },

  /**
   * Clear all objects and the canvas.
   */
  clear: function () {
    this.storage.delRoot();
    this.painter.clear();
  },

  /**
   * Dispose self.
   */
  dispose: function () {
    this.animation.stop();
    this.clear();
    this.storage.dispose();
    this.painter.dispose();
    this.handler.dispose();
    this.animation = this.storage = this.painter = this.handler = null;
    delInstance(this.id);
  }
};
exports.version = version;
exports.init = init;
exports.dispose = dispose;
exports.getInstance = getInstance;
exports.registerPainter = registerPainter;

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bankCardList */
/* unused harmony export bankCardNum */
/* unused harmony export HQTCardList */
/* unused harmony export bankCardListResetPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hqtCardList; });
/* unused harmony export getCardListAmount */
/* unused harmony export addCardRequest */
/* unused harmony export getBankCardType */
/* unused harmony export getBankList */
/* unused harmony export requestAuthentication */
/* unused harmony export confirmAuthentication */
/* unused harmony export addBankCard */
/* unused harmony export unbindBankCard */
/* unused harmony export getFAQ */
/* unused harmony export validateTransactionPassword */
/* unused harmony export getCardListForResetTradePassword */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userInfoAction__ = __webpack_require__(97);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var bankCardList = function bankCardList(text) {
	return {
		type: 'BANK_CARD_LIST',
		text: text
	};
};

var bankCardNum = function bankCardNum(text) {
	return {
		type: 'BANK_CARD_NUM',
		text: text
	};
};

var HQTCardList = function HQTCardList(text) {
	return {
		type: 'HQT_CARD_LIST',
		text: text
	};
};

var bankCardListResetPS = function bankCardListResetPS(text) {
	return {
		type: 'BANK_CARD_LIST_RESET',
		text: text
	};
};

//获取用户银行卡列表
var getCardList = function getCardList(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(succ) {
				var opt, newData, allAbleVolume, tempArr, i, j;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									// let resHqtCard = await getCwimUserHqtCard(params)
									dispatch(bankCardList(succ.content.bankCard));
									dispatch(HQTCardList(succ.content.HqtCard));
									opt = JSON.parse(JSON.stringify(succ));
									newData = stateAbleOrNot("", opt.content.HqtCard);
									allAbleVolume = 0;
									tempArr = [];

									for (i = 0; i < newData.length; i++) {
										allAbleVolume += newData[i].availableVolume;
										if (newData[i].trustChannelDisplayName == "招商银行在线支付" && newData[i].ywt == true) {} else if (newData[i].trustChannelDisplayName == "招商银行在线支付" && newData[i].ywt == false) {
											tempArr.push(newData[i]);
											newData.splice(i, 1);
										} else {
											if (newData[i].trustChannelDisplayName == "招商银行在线支付" && !newData[i].enableCMBTrustChannel || newData[i].enableCMBTrustChannel === "0") {
												tempArr.push(newData[i]);
												newData.splice(i, 1);
											}
										}
									}
									if (tempArr.length > 0) {
										for (j = 0; j < tempArr.length; j++) {
											newData.push(tempArr[j]);
										}
									}
									dispatch(hqtCardList(newData));

									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this);
			}));

			return function successCallback(_x) {
				return _ref.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/paymentaccount/getCardList', params, successCallback, errorCallback);
	};
};

var hqtCardList = function hqtCardList(text) {
	return {
		type: 'HQT_CARD_LIST',
		text: text
	};
};
function stateAbleOrNot(argument, argumentTwo) {
	var tempData = argumentTwo;
	// for (let i = 0; i < tempData.length; i++) {
	//  for (let j =0; j < argument.length ;j++) {
	//    if(tempData[i].trustChannelId == "888" && argument[j].trustChannelId == "888") {
	//      if(tempData[i].bankCode == argument[j].bankCode && tempData[i].bankAccountShowNo != argument[j].bankAccountShowNo) {
	//        tempData[i].bankAccountShowNo2 = argument[j].bankAccountShowNo;
	//        if(tempData[i].bankCode != "007") {
	//          tempData[i].enableCMBTrustChannel = "0";
	//        }
	//      }
	//    }else {
	//      if(argument[j].trustChannelId != "888") {
	//        if(tempData[i].bankCode == argument[j].bankCode && tempData[i].bankAccountShowNo != argument[j].bankAccountShowNo) {
	//          tempData[i].bankAccountShowNo2 = argument[j].bankAccountShowNo;
	//          if(tempData[i].bankCode != "007") {
	//        	tempData[i].enableCMBTrustChannel = "0";
	//          }
	//        }
	//      }
	//    }
	//  }  
	// }
	tempData.sort(getVal('availableVolume'));
	return tempData;
}
var getVal = function getVal(property) {
	return function (a, b) {
		var value1 = a[property];
		var value2 = b[property];
		return value2 - value1;
	};
};

//获取用户银行卡数量
var getCardListAmount = function getCardListAmount(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(succ) {
				var myCardNum;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									dispatch(bankCardNum(succ.content));
									sessionStorage.setItem("myCardNum", JSON.stringify(succ.content));
									succallback();
								} else {
									console.log('后台返回数据有误！' + succ.message);
									myCardNum = sessionStorage.getItem("myCardNum");

									if (myCardNum) {
										dispatch(bankCardNum(JSON.parse(myCardNum)));
									} else {
										dispatch(bankCardNum('--'));
									}
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this);
			}));

			return function successCallback(_x2) {
				return _ref2.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			var myCardNum = sessionStorage.getItem("myCardNum");
			if (myCardNum) {
				dispatch(bankCardNum(JSON.parse(myCardNum)));
			} else {
				dispatch(bankCardNum('--'));
			}
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/paymentaccount/getCardListAmount', params, successCallback, errorCallback);
	};
};

//请求加卡
var addCardRequest = function addCardRequest(params, succallback, errcallback) {
	return function () {
		var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(dispatch, getState) {
			var successCallback, errorCallback;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							successCallback = function () {
								var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(succ) {
									return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
										while (1) {
											switch (_context3.prev = _context3.next) {
												case 0:
													console.log(succ);
													if (succ && succ.code === '0000') {
														succallback();
													} else {
														console.log('后台返回数据有误！' + succ.message);
														errcallback(succ.message);
													}

												case 2:
												case 'end':
													return _context3.stop();
											}
										}
									}, _callee3, _this);
								}));

								return function successCallback(_x5) {
									return _ref4.apply(this, arguments);
								};
							}();

							errorCallback = function errorCallback(err) {
								console.log(err);
								errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
							};

							_context4.next = 4;
							return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken');

						case 4:
							params.token = _context4.sent;

							__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/account/addCardRequest', params, successCallback, errorCallback);

						case 6:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, _this);
		}));

		return function (_x3, _x4) {
			return _ref3.apply(this, arguments);
		};
	}();
};

//获取卡类型
var getBankCardType = function getBankCardType(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
					while (1) {
						switch (_context5.prev = _context5.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context5.stop();
						}
					}
				}, _callee5, _this);
			}));

			return function successCallback(_x6) {
				return _ref5.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/realnameauth/getBankName', params, successCallback, errorCallback);
	};
};

//获取可加卡银行的列表来取得paymentChannelId
var getBankList = function getBankList(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
					while (1) {
						switch (_context6.prev = _context6.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context6.stop();
						}
					}
				}, _callee6, _this);
			}));

			return function successCallback(_x7) {
				return _ref6.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/realnameauth/getBankCardList', params, successCallback, errorCallback);
	};
};

//鉴权申请
var requestAuthentication = function requestAuthentication(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref7 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
					while (1) {
						switch (_context7.prev = _context7.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context7.stop();
						}
					}
				}, _callee7, _this);
			}));

			return function successCallback(_x8) {
				return _ref7.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/realnameauth/authApplyRequest', params, successCallback, errorCallback);
	};
};

//鉴权确认
var confirmAuthentication = function confirmAuthentication(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref8 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
					while (1) {
						switch (_context8.prev = _context8.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context8.stop();
						}
					}
				}, _callee8, _this);
			}));

			return function successCallback(_x9) {
				return _ref8.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/realnameauth/authConfirm', params, successCallback, errorCallback);
	};
};
//添加银行卡
var addBankCard = function addBankCard(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref9 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
					while (1) {
						switch (_context9.prev = _context9.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context9.stop();
						}
					}
				}, _callee9, _this);
			}));

			return function successCallback(_x10) {
				return _ref9.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/account/addCardRequest', params, successCallback, errorCallback);
	};
};
//解绑银行卡
var unbindBankCard = function unbindBankCard(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref10 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
					while (1) {
						switch (_context10.prev = _context10.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context10.stop();
						}
					}
				}, _callee10, _this);
			}));

			return function successCallback(_x11) {
				return _ref10.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/account/closePaymentAccount', params, successCallback, errorCallback);
	};
};
//获取常见问题
var getFAQ = function getFAQ(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref11 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
					while (1) {
						switch (_context11.prev = _context11.next) {
							case 0:
								console.log(succ);
								if (succ) {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.responseMsg);
									errcallback(succ.responseMsg);
								}

							case 2:
							case 'end':
								return _context11.stop();
						}
					}
				}, _callee11, _this);
			}));

			return function successCallback(_x12) {
				return _ref11.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/cms/getQuestionListByCode', params, successCallback, errorCallback);
	};
};
//验证交易密码
var validateTransactionPassword = function validateTransactionPassword(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function () {
			var _ref12 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(succ) {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
					while (1) {
						switch (_context12.prev = _context12.next) {
							case 0:
								console.log(succ);
								if (succ && succ.code === '0000') {
									succallback(succ.content);
								} else {
									console.log('后台返回数据有误！' + succ.message);
									errcallback(succ.message);
								}

							case 2:
							case 'end':
								return _context12.stop();
						}
					}
				}, _callee12, _this);
			}));

			return function successCallback(_x13) {
				return _ref12.apply(this, arguments);
			};
		}();
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/account/validatePassword', params, successCallback, errorCallback);
	};
};

//获取可以重置交易密码的银行卡
var getCardListForResetTradePassword = function getCardListForResetTradePassword(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function successCallback(succ) {
			console.log(succ);
			if (succ && succ.code === '0000') {
				dispatch(bankCardListResetPS(succ.content));
				succallback(succ.content);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_1__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_1__util___default.a.post(__WEBPACK_IMPORTED_MODULE_1__util___default.a.url + '/api/account/getResetPasswordChannels', params, successCallback, errorCallback);
	};
};

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getRiskType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQuestionnaireNo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getQuestionnaireList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saveRiskResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return previewPlanRisk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stopPlanByRiskResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);



//获取用户风险等级
var getRiskType = function getRiskType(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function successCallback(succ) {
			console.log(succ);
			if (succ && succ.code === '0000') {
				succallback(succ.content, params.raiseMethod);
				console.log(succ.content, params.raiseMethod);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_0__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_0__util___default.a.get(__WEBPACK_IMPORTED_MODULE_0__util___default.a.url + '/api/account/queryRankName', params, successCallback, errorCallback);
		// Util.get('http://127.0.0.1:3001' + '/api/account/queryRankName', params, successCallback, errorCallback);
	};
};

//获取用户风险等级问卷编号
var getQuestionnaireNo = function getQuestionnaireNo(params, succallback, errcallback) {
	return function (dispatch, getState) {
		var successCallback = function successCallback(succ) {
			console.log(succ);
			if (succ && succ.code === '0000') {
				succallback(succ.content, params.raiseMethod);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_0__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_0__util___default.a.get(__WEBPACK_IMPORTED_MODULE_0__util___default.a.url + '/api/account/getQuestionnaireNo', params, successCallback, errorCallback);
	};
};

// 获取问卷列表
var getQuestionnaireList = function getQuestionnaireList(params, succallback, errcallback) {
	return function (dispatch, getState) {
		__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
		var successCallback = function successCallback(succ) {
			console.log(succ, 'QuestionnaireListQuestionnaireList');
			if (succ && succ.code === '0000') {
				succallback(succ.content);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				// succallback(succ1.content);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_0__util___default.a.errorTxt);
		};
		console.log(params);
		__WEBPACK_IMPORTED_MODULE_0__util___default.a.get(__WEBPACK_IMPORTED_MODULE_0__util___default.a.url + '/api/account/getQuestion', params, successCallback, errorCallback);
	};
};

// 提交问卷答案
var saveRiskResult = function saveRiskResult(params, succallback, errcallback) {
	return function (dispatch, getState) {
		__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0, function () {});
		var successCallback = function successCallback(succ) {
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
			console.log(succ);
			if (succ && succ.code === '0000') {
				succallback(succ.content);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_0__util___default.a.errorTxt);
		};
		params.clientType = 'hxcfH5';
		params.answers = JSON.parse(params.answers);
		__WEBPACK_IMPORTED_MODULE_0__util___default.a.postNew(__WEBPACK_IMPORTED_MODULE_0__util___default.a.url + '/api/v1/account/saveRiskResult?token=' + params.token, params, successCallback, errorCallback);
	};
};
/*算风并评估相关定投协议风险是否匹配 */
var previewPlanRisk = function previewPlanRisk(params, succallback, errcallback) {
	return function (dispatch, getState) {
		__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0, function () {});
		var successCallback = function successCallback(succ) {
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
			console.log(succ);
			if (succ && succ.code === '0000') {
				succallback(succ.content);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_0__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_0__util___default.a.get(__WEBPACK_IMPORTED_MODULE_0__util___default.a.url + '/api/account/previewPlanRisk', params, successCallback, errorCallback);
	};
};
/* 终止风险异常定投协议 */
var stopPlanByRiskResult = function stopPlanByRiskResult(params, succallback, errcallback) {
	return function (dispatch, getState) {
		__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading('', 0, function () {});
		var successCallback = function successCallback(succ) {
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
			console.log(succ);
			if (succ && succ.code === '0000') {
				succallback(succ.content);
			} else {
				console.log('后台返回数据有误！' + succ.message);
				errcallback(succ.message);
			}
		};
		var errorCallback = function errorCallback(err) {
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
			console.log(err);
			errcallback(__WEBPACK_IMPORTED_MODULE_0__util___default.a.errorTxt);
		};
		__WEBPACK_IMPORTED_MODULE_0__util___default.a.get(__WEBPACK_IMPORTED_MODULE_0__util___default.a.url + '/api/account/stopPlanByRiskResult', params, successCallback, errorCallback);
	};
};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/002ty@4x.20953603.png";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/003ty@4x.dd9d31c2.png";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/004ty@4x.1fb316ae.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/005ty@4x.e5b7c6a6.png";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/006ty@4x.de9ca357.png";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/007ty@4x.0edc1845.png";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/009ty@4x.d1c7b4f6.png";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/011ty@4x.1cebedda.png";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/012ty@4x.ab519caa.png";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/014ty@4x.74a87f3b.png";

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/015ty@4x.4e71bf80.png";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/016ty@4x.b0518336.png";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/017ty@4x.2082cca8.png";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/018ty@4x.fd582743.png";

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/021ty@4x.ef3aa144.png";

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/022ty@4x.ae1b6c1c.png";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/903ty@4x.3b982313.png";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/904ty@4x.3172ca9c.png";

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/907ty@4x.dd040cc1.png";

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/915ty@4x.962f5d1e.png";

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hqt.ea6a7a1d.png";

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_goback.39323399.png";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/smallWh.cfeb03da.png";

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/successO.688150ed.png";

/***/ }),
/* 433 */
/***/ (function(module, exports) {

function _extends() {
  return (module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(784);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Badge = function (_React$Component) {
    (0, _inherits3['default'])(Badge, _React$Component);

    function Badge() {
        (0, _classCallCheck3['default'])(this, Badge);
        return (0, _possibleConstructorReturn3['default'])(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Badge, [{
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _a = this.props,
                className = _a.className,
                prefixCls = _a.prefixCls,
                children = _a.children,
                text = _a.text,
                size = _a.size,
                overflowCount = _a.overflowCount,
                dot = _a.dot,
                corner = _a.corner,
                hot = _a.hot,
                restProps = __rest(_a, ["className", "prefixCls", "children", "text", "size", "overflowCount", "dot", "corner", "hot"]);
            overflowCount = overflowCount;
            text = typeof text === 'number' && text > overflowCount ? overflowCount + '+' : text;
            // dot mode don't need text
            if (dot) {
                text = '';
            }
            var scrollNumberCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', dot), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-large', dot && size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-text', !dot && !corner), (0, _defineProperty3['default'])(_classNames, prefixCls + '-corner', corner), (0, _defineProperty3['default'])(_classNames, prefixCls + '-corner-large', corner && size === 'large'), _classNames));
            var badgeCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, className, !!className), (0, _defineProperty3['default'])(_classNames2, prefixCls, true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-not-a-wrapper', !children), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-corner-wrapper', corner), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-hot', !!hot), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-corner-wrapper-large', corner && size === 'large'), _classNames2));
            return _react2['default'].createElement(
                'span',
                { className: badgeCls },
                children,
                (text || dot) && _react2['default'].createElement(
                    'sup',
                    (0, _extends3['default'])({ className: scrollNumberCls }, restProps),
                    text
                )
            );
        }
    }]);
    return Badge;
}(_react2['default'].Component);

exports['default'] = Badge;

Badge.defaultProps = {
    prefixCls: 'am-badge',
    size: 'small',
    overflowCount: 99,
    dot: false,
    corner: false
};
module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rmcNukaCarousel = __webpack_require__(1621);

var _rmcNukaCarousel2 = _interopRequireDefault(_rmcNukaCarousel);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Carousel = function (_React$Component) {
    (0, _inherits3['default'])(Carousel, _React$Component);

    function Carousel(props) {
        (0, _classCallCheck3['default'])(this, Carousel);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.onChange = function (index) {
            _this.setState({
                selectedIndex: index
            }, function () {
                if (_this.props.afterChange) {
                    _this.props.afterChange(index);
                }
            });
        };
        _this.state = {
            selectedIndex: _this.props.selectedIndex
        };
        return _this;
    }

    (0, _createClass3['default'])(Carousel, [{
        key: 'render',
        value: function render() {
            var _classNames2;

            var _props = this.props,
                className = _props.className,
                prefixCls = _props.prefixCls,
                dotStyle = _props.dotStyle,
                dotActiveStyle = _props.dotActiveStyle,
                infinite = _props.infinite,
                selectedIndex = _props.selectedIndex,
                beforeChange = _props.beforeChange,
                dots = _props.dots,
                vertical = _props.vertical;

            var restProps = (0, _omit2['default'])(this.props, ['infinite', 'selectedIndex', 'beforeChange', 'afterChange', 'dots']);
            var newProps = (0, _extends3['default'])({}, restProps, { wrapAround: infinite, slideIndex: selectedIndex, beforeSlide: beforeChange });
            var Decorators = [];
            var current = this.state.selectedIndex;
            if (dots) {
                Decorators = [{
                    component: (0, _createReactClass2['default'])({
                        displayName: 'component',
                        render: function render() {
                            var _props2 = this.props,
                                slideCount = _props2.slideCount,
                                slidesToScroll = _props2.slidesToScroll;

                            var arr = [];
                            for (var i = 0; i < slideCount; i += slidesToScroll) {
                                arr.push(i);
                            }
                            var dotDom = arr.map(function (index) {
                                var _classNames;

                                var dotCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrap-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrap-dot-active', index === current), _classNames));
                                var _dotStyle = index === current ? dotActiveStyle : dotStyle;
                                return _react2['default'].createElement(
                                    'div',
                                    { className: dotCls, key: index },
                                    _react2['default'].createElement('span', { style: _dotStyle })
                                );
                            });
                            return _react2['default'].createElement(
                                'div',
                                { className: prefixCls + '-wrap' },
                                dotDom
                            );
                        }
                    }),
                    position: 'BottomCenter'
                }];
            }
            var wrapCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, className, className), (0, _defineProperty3['default'])(_classNames2, prefixCls, true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-vertical', vertical), _classNames2));
            return _react2['default'].createElement(_rmcNukaCarousel2['default'], (0, _extends3['default'])({}, newProps, { className: wrapCls, decorators: Decorators, afterSlide: this.onChange }));
        }
    }]);
    return Carousel;
}(_react2['default'].Component);

exports['default'] = Carousel;

Carousel.defaultProps = {
    prefixCls: 'am-carousel',
    dots: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    edgeEasing: 'linear',
    cellAlign: 'center',
    selectedIndex: 0,
    dotStyle: {},
    dotActiveStyle: {}
};
module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(277);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _CheckboxItem = __webpack_require__(794);

var _CheckboxItem2 = _interopRequireDefault(_CheckboxItem);

var _AgreeItem = __webpack_require__(793);

var _AgreeItem2 = _interopRequireDefault(_AgreeItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Checkbox2['default'].CheckboxItem = _CheckboxItem2['default'];
_Checkbox2['default'].AgreeItem = _AgreeItem2['default'];
exports['default'] = _Checkbox2['default'];
module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = handleProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(130);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:no-unused-variable */

/* tslint:enable:no-unused-variable */
var Item = _index2['default'].Item;
function handleProps(props, isIndexed) {
    var renderHeader = props.renderHeader,
        renderFooter = props.renderFooter,
        renderSectionHeader = props.renderSectionHeader,
        renderBodyComponent = props.renderBodyComponent,
        restProps = __rest(props, ["renderHeader", "renderFooter", "renderSectionHeader", "renderBodyComponent"]);

    var listPrefixCls = props.listPrefixCls;
    var extraProps = {
        renderHeader: null,
        renderFooter: null,
        renderSectionHeader: null,
        renderBodyComponent: renderBodyComponent || function () {
            return _react2['default'].createElement('div', { className: listPrefixCls + '-body' });
        }
    };
    if (renderHeader) {
        extraProps.renderHeader = function () {
            return _react2['default'].createElement(
                'div',
                { className: listPrefixCls + '-header' },
                renderHeader()
            );
        };
    }
    if (renderFooter) {
        extraProps.renderFooter = function () {
            return _react2['default'].createElement(
                'div',
                { className: listPrefixCls + '-footer' },
                renderFooter()
            );
        };
    }
    if (renderSectionHeader) {
        extraProps.renderSectionHeader = isIndexed ? function (sectionData, sectionID) {
            return _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    Item,
                    { prefixCls: listPrefixCls },
                    renderSectionHeader(sectionData, sectionID)
                )
            );
        } : function (sectionData, sectionID) {
            return _react2['default'].createElement(
                Item,
                { prefixCls: listPrefixCls },
                renderSectionHeader(sectionData, sectionID)
            );
        };
    }
    return { restProps: restProps, extraProps: extraProps };
}
module.exports = exports['default'];

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcNotification = __webpack_require__(1303);

var _rcNotification2 = _interopRequireDefault(_rcNotification);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

var _classnames2 = __webpack_require__(17);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var messageInstance = void 0;
var prefixCls = 'am-toast';
function getMessageInstance(mask) {
    var _classnames;

    if (messageInstance) {
        messageInstance.destroy();
        messageInstance = null;
    }
    messageInstance = _rcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        style: {},
        transitionName: 'am-fade',
        className: (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-mask', mask), (0, _defineProperty3['default'])(_classnames, prefixCls + '-nomask', !mask), _classnames))
    });
    return messageInstance;
}
function notice(content, type) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var _onClose = arguments[3];
    var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    var iconType = {
        info: '',
        success: __webpack_require__(1656),
        fail: __webpack_require__(1655),
        offline: __webpack_require__(1654),
        loading: 'loading'
    }[type];
    var instance = getMessageInstance(mask);
    instance.notice({
        duration: duration,
        style: {},
        content: !!iconType ? _react2['default'].createElement(
            'div',
            { className: prefixCls + '-text ' + prefixCls + '-text-icon', role: 'alert', 'aria-live': 'assertive' },
            _react2['default'].createElement(_index2['default'], { type: iconType, size: 'lg' }),
            _react2['default'].createElement(
                'div',
                { className: prefixCls + '-text-info' },
                content
            )
        ) : _react2['default'].createElement(
            'div',
            { className: prefixCls + '-text', role: 'alert', 'aria-live': 'assertive' },
            _react2['default'].createElement(
                'div',
                null,
                content
            )
        ),
        onClose: function onClose() {
            if (_onClose) {
                _onClose();
            }
            instance.destroy();
            instance = null;
            messageInstance = null;
        }
    });
}
exports['default'] = {
    SHORT: 3,
    LONG: 8,
    show: function show(content, duration, mask) {
        return notice(content, 'info', duration, function () {}, mask);
    },
    info: function info(content, duration, onClose, mask) {
        return notice(content, 'info', duration, onClose, mask);
    },
    success: function success(content, duration, onClose, mask) {
        return notice(content, 'success', duration, onClose, mask);
    },
    fail: function fail(content, duration, onClose, mask) {
        return notice(content, 'fail', duration, onClose, mask);
    },
    offline: function offline(content, duration, onClose, mask) {
        return notice(content, 'offline', duration, onClose, mask);
    },
    loading: function loading(content, duration, onClose, mask) {
        return notice(content, 'loading', duration, onClose, mask);
    },
    hide: function hide() {
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        }
    }
};
module.exports = exports['default'];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var View = function (_React$Component) {
    (0, _inherits3["default"])(View, _React$Component);

    function View() {
        (0, _classCallCheck3["default"])(this, View);
        return (0, _possibleConstructorReturn3["default"])(this, (View.__proto__ || Object.getPrototypeOf(View)).apply(this, arguments));
    }

    (0, _createClass3["default"])(View, [{
        key: "render",
        value: function render() {
            var props = (0, _extends3["default"])({}, this.props);
            if (Array.isArray(props.style)) {
                var style = {};
                props.style.forEach(function (s) {
                    style = (0, _extends3["default"])({}, style, s);
                });
                props.style = style;
            }
            var Component = props.Component,
                restProps = __rest(props, ["Component"]);
            return _react2["default"].createElement(Component, restProps);
        }
    }]);
    return View;
}(_react2["default"].Component);

exports["default"] = View;

View.defaultProps = {
    Component: 'div'
};
module.exports = exports["default"];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var WingBlank = function (_React$Component) {
    (0, _inherits3['default'])(WingBlank, _React$Component);

    function WingBlank() {
        (0, _classCallCheck3['default'])(this, WingBlank);
        return (0, _possibleConstructorReturn3['default'])(this, (WingBlank.__proto__ || Object.getPrototypeOf(WingBlank)).apply(this, arguments));
    }

    (0, _createClass3['default'])(WingBlank, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                className = _props.className,
                children = _props.children,
                style = _props.style;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames));
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style },
                children
            );
        }
    }]);
    return WingBlank;
}(_react2['default'].Component);

exports['default'] = WingBlank;

WingBlank.defaultProps = {
    prefixCls: 'am-wingblank',
    size: 'lg'
};
module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(36);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



var state = {
  loadingArr: [__webpack_require__(235), __webpack_require__(246), __webpack_require__(253), __webpack_require__(254), __webpack_require__(255), __webpack_require__(256), __webpack_require__(257), __webpack_require__(258), __webpack_require__(259), __webpack_require__(236), __webpack_require__(237), __webpack_require__(238), __webpack_require__(239), __webpack_require__(240), __webpack_require__(241), __webpack_require__(242), __webpack_require__(243), __webpack_require__(244), __webpack_require__(245), __webpack_require__(247), __webpack_require__(248), __webpack_require__(249), __webpack_require__(250), __webpack_require__(251), __webpack_require__(252)]
};
var count = 0;
var interVal;
var show = function show() {
  console.log('hidden');
  document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
  document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
  var isHave = document.getElementsByClassName('my-loading').length;
  if (isHave > 0) {
    return;
  }
  var div = void 0;
  div = document.createElement('div');
  div.className = 'my-loading-box';
  document.body.appendChild(div);
  __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'my-loading' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'my-loading-img', src: state.loadingArr[count] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      '\u6B63\u5728\u52A0\u8F7D...'
    )
  ), div);
  start();
};
var start = function start() {
  var div = document.getElementsByClassName('my-loading-img');
  interVal = setInterval(function () {
    count++;
    if (count > 24) {
      count = 0;
    }
    div[0].setAttribute("src", state.loadingArr[count]);
  }, 50);
};
var hide = function hide() {
  document.getElementsByTagName('html')[0].style.overflowY = 'auto';
  document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "");

  count = 0;
  var div = document.getElementsByClassName('my-loading-box');
  clearInterval(interVal);
  console.log(div);
  if (div.length > 0) {
    div[0].remove();
  }
};
var Loading = {
  show: show,
  hide: hide
};
/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 445 */,
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var PositionList = function (_React$Component) {
  _inherits(PositionList, _React$Component);

  function PositionList(props) {
    _classCallCheck(this, PositionList);

    return _possibleConstructorReturn(this, (PositionList.__proto__ || Object.getPrototypeOf(PositionList)).call(this, props));
  }

  _createClass(PositionList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          renderItem = _props.renderItem,
          dataSource = _props.dataSource,
          topDistance = _props.topDistance,
          bottomDistance = _props.bottomDistance,
          header = _props.header,
          background = _props.background;

      console.log('====dataSource===', dataSource);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { marginBottom: '.2rem' } },
        header,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { paddingTop: topDistance, paddingBottom: bottomDistance, background: background } },
          dataSource.map(function (v, i) {
            return renderItem(v);
          })
        )
      );
    }
  }]);

  return PositionList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (PositionList);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_CertificationCard_css__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_CertificationCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_CertificationCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CertificationCard = function (_Component) {
	_inherits(CertificationCard, _Component);

	function CertificationCard() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CertificationCard);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertificationCard.__proto__ || Object.getPrototypeOf(CertificationCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			cardPerson: _this.props.location.state.realName ? _this.props.location.state.realName : "",
			personNumber: _this.props.location.state.personNo ? _this.props.location.state.personNo : "",
			address: _this.props.smrzAddress,
			job: _this.props.smrzJob,
			city: _this.props.smrzCity,
			beneficiaries: _this.props.smrzBeneficiaries,
			beneficiariesName: _this.props.smrzBeneficiariesZjzq ? _this.props.smrzBeneficiariesZjzq.realName : "",
			beneficiariesType: _this.props.smrzBeneficiariesType,
			beneficiariesNo: _this.props.smrzBeneficiariesZjzq ? _this.props.smrzBeneficiariesZjzq.personNo : "",
			beneficontro: _this.props.smrzBeneficontro,
			beneficontroName: _this.props.smrzBeneficontroZjzq ? _this.props.smrzBeneficontroZjzq.realName : "",
			beneficontroType: _this.props.smrzBeneficontroType,
			beneficontroNo: _this.props.smrzBeneficontroZjzq ? _this.props.smrzBeneficontroZjzq.personNo : "",
			isImportant: _this.props.smrzGjzz,
			phoneNo: _this.props.location.state.phoneNo ? _this.props.location.state.phoneNo : "",
			enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
			careerCode: _this.props.smrzCareerCode,
			annualIncome: "",
			nsrcode: _this.props.smrznsrcode,
			annualIncomeV2: _this.props.smrznJtsrcode,
			actualControllerValidTerm: _this.props.smrzBeneficontroZjyxq ? _this.props.smrzBeneficontroZjyxq.actualControllerValidTerm : "",
			certValidTerm: _this.props.zzhZjyxq ? _this.props.zzhZjyxq.certValidTerm : "",
			certValidEver: _this.props.zzhZjyxq ? _this.props.zzhZjyxq.certValidEver : "",
			actualControllerValidEver: _this.props.smrzBeneficontroZjyxq ? _this.props.smrzBeneficontroZjyxq.actualControllerValidEver : "",
			kzrBool: _this.props.smrzBeneficontroZjzq ? _this.props.smrzBeneficontroZjzq.Boll : "",
			actualControllerSex: "",
			kzrXbcode: _this.props.smrzkzrXbcode,
			actualControllerBirthday: _this.props.smrzBeneficontroCsrq ? _this.props.smrzBeneficontroCsrq.actualControllerBirthday : "",
			actualControllerMobileNo: _this.props.smrzBeneficontroKzrNo,
			actualControllerProvince: _this.props.smrzkzrCityc,
			actualControllerAddress: _this.props.smrzkzrAddress,
			actualControllerPostcode: _this.props.smrzkzrBianma,
			kzrjob: _this.props.smrzkzrJob,
			careerkzrCode: _this.props.smrzCareerkzrCode,
			actualControllerEmail: _this.props.smrzkzrYoux,
			actualBeneficiaryValidTerm: _this.props.smrzBeneficiariesZjyxq ? _this.props.smrzBeneficiariesZjyxq.actualBeneficiaryValidTerm : "",
			actualBeneficiaryValidEver: _this.props.smrzBeneficiariesZjyxq ? _this.props.smrzBeneficiariesZjyxq.actualBeneficiaryValidEver : "",
			syrBool: _this.props.smrzBeneficiariesZjzq ? _this.props.smrzBeneficiariesZjzq.Boll : "",
			actualBeneficiarySex: "",
			syrXbcode: _this.props.smrzsyrXbcode,
			actualBeneficiaryBirthday: _this.props.smrzBeneficiariesCsrq ? _this.props.smrzBeneficiariesCsrq.actualBeneficiaryBirthday : "",
			actualBeneficiaryMobileNo: _this.props.smrzBeneficontroSyrNo,
			actualBeneficiaryProvince: _this.props.smrzsyrCityc,
			actualBeneficiaryAddress: _this.props.smrzsyrAddress,
			actualBeneficiaryPostcode: _this.props.smrzsyrBianma,
			syrjob: _this.props.smrzsyrJob,
			careersyrCode: _this.props.smrzCareersyrCode,
			actualBeneficiaryEmail: _this.props.smrzsyrYoux,
			alertFlag: false,
			userInfo: "",
			validityVal: _this.props.location.state.validity.split("-")[1]
		}, _this.changeJob = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					job: value,
					careerCode: value[0]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_1" /* smrzCareerCode */])(value[0]));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_2" /* smrzJob */])(value));
			} else {
				var _dispatch = _this.props.dispatch;

				_this.setState({
					job: [_this.props.userJob[0].careerId],
					careerCode: _this.props.userJob[0].careerId
				});
				_dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_1" /* smrzCareerCode */])(_this.props.userJob[0].careerId));
				_dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_2" /* smrzJob */])([_this.props.userJob[0].careerId]));
			}
		}, _this.changekzrJob = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					kzrjob: value,
					careerkzrCode: value[0]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_3" /* smrzCareerkzrCode */])(value[0]));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_4" /* smrzkzrJob */])(value));
			} else {
				var _dispatch2 = _this.props.dispatch;

				_this.setState({
					kzrjob: [_this.props.userJob[0].careerId],
					careerkzrCode: _this.props.userJob[0].careerId
				});
				_dispatch2(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_3" /* smrzCareerkzrCode */])(_this.props.userJob[0].careerId));
				_dispatch2(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_4" /* smrzkzrJob */])([_this.props.userJob[0].careerId]));
			}
		}, _this.changesyrJob = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					syrjob: value,
					careersyrCode: value[0]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_5" /* smrzCareersyrCode */])(value[0]));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_6" /* smrzsyrJob */])(value));
			} else {
				var _dispatch3 = _this.props.dispatch;

				_this.setState({
					syrjob: [_this.props.userJob[0].careerId],
					careersyrCode: _this.props.userJob[0].careerId
				});
				_dispatch3(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_5" /* smrzCareersyrCode */])(_this.props.userJob[0].careerId));
				_dispatch3(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_6" /* smrzsyrJob */])([_this.props.userJob[0].careerId]));
			}
		}, _this.changeNsr = function (value) {
			var dispatch = _this.props.dispatch;

			var nsr = [{ careerId: '1', careerName: '0—10万（含）' }, { careerId: '2', careerName: '10万—30万（含）' }, { careerId: '3', careerName: '30万—50万（含）' }, { careerId: '4', careerName: '50万以上' }];
			if (value[0]) {
				for (var i = 0; i < nsr.length; i++) {
					if (value[0] == nsr[i].careerId) {
						_this.setState({
							annualIncome: nsr[i].careerName,
							nsrcode: [nsr[i].careerId]
						});
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_7" /* smrznsrcode */])([nsr[i].careerId]));
					}
				}
			} else {
				_this.setState({
					annualIncome: nsr[0].careerName,
					nsrcode: [nsr[0].careerId]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_7" /* smrznsrcode */])([nsr[0].careerId]));
			}
		}, _this.changekzrXb = function (value) {
			var dispatch = _this.props.dispatch;

			var xb = [{ careerId: '1', careerName: '男' }, { careerId: '0', careerName: '女' }];
			if (value[0]) {
				for (var i = 0; i < xb.length; i++) {
					if (value[0] == xb[i].careerId) {
						_this.setState({
							actualControllerSex: xb[i].careerName,
							kzrXbcode: [xb[i].careerId]
						});
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_8" /* smrzkzrXbcode */])([xb[i].careerId]));
					}
				}
			} else {
				_this.setState({
					actualControllerSex: xb[0].careerName,
					kzrXbcode: [xb[0].careerId]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_8" /* smrzkzrXbcode */])([xb[0].careerId]));
			}
		}, _this.changesyrXb = function (value) {
			var dispatch = _this.props.dispatch;

			var xb = [{ careerId: '1', careerName: '男' }, { careerId: '0', careerName: '女' }];
			if (value[0]) {
				for (var i = 0; i < xb.length; i++) {
					if (value[0] == xb[i].careerId) {
						_this.setState({
							actualBeneficiarySex: xb[i].careerName,
							syrXbcode: [xb[i].careerId]
						});
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_9" /* smrzsyrXbcode */])([xb[i].careerId]));
					}
				}
			} else {
				_this.setState({
					actualBeneficiarySex: xb[0].careerName,
					syrXbcode: [xb[0].careerId]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_9" /* smrzsyrXbcode */])([xb[0].careerId]));
			}
		}, _this.changeCity = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				city: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_10" /* smrzCity */])(value));
		}, _this.changekzrCity = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualControllerProvince: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_11" /* smrzkzrCityc */])(value));
		}, _this.changesyrCity = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualBeneficiaryProvince: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_12" /* smrzsyrCityc */])(value));
		}, _this.changeBeneficiaries = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficiaries: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_13" /* smrzBeneficiaries */])(value));
		}, _this.changeBeneficontro = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficontro: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_14" /* smrzBeneficontro */])(value));
		}, _this.changeBeneficiariesType = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					beneficiariesType: value
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_15" /* smrzBeneficiariesType */])(value));
			} else {
				var _dispatch4 = _this.props.dispatch;

				_this.setState({
					beneficiariesType: ["身份证"]
				});
				_dispatch4(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_15" /* smrzBeneficiariesType */])(["身份证"]));
			}
		}, _this.changeBeneficontroType = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					beneficontroType: value
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_16" /* smrzBeneficontroType */])(value));
			} else {
				var _dispatch5 = _this.props.dispatch;

				_this.setState({
					beneficontroType: ["身份证"]
				});
				_dispatch5(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_16" /* smrzBeneficontroType */])(["身份证"]));
			}
		}, _this.Zhzjyxq = function (vals) {
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var dispatch = _this.props.dispatch;

			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
				pathname: "/ChangTime",
				state: {
					route: route,
					dispatch: dispatch,
					onFun: function onFun(val) {
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_17" /* zzhZjyxq */])(val));
					},
					valu: vals
				},
				query: {}
			});
		}, _this.changeBeneficontrozjyxq = function (vals) {
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var dispatch = _this.props.dispatch;

			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
				pathname: "/ChangTime",
				state: {
					route: route,
					dispatch: dispatch,
					onFun: function onFun(val) {
						console.log(val);
						if (val.str == "控制人证件有效期") {
							dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_18" /* smrzBeneficontroZjyxq */])(val));
						} else if (val.str == "受益人证件有效期") {
							dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_19" /* smrzBeneficiariesZjyxq */])(val));
						} else if (val.str == "控制人出生日期") {
							dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_20" /* smrzBeneficontroCsrq */])(val));
						} else if (val.str == "受益人出生日期") {
							dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_21" /* smrzBeneficiariesCsrq */])(val));
						}
					},
					valu: vals
				},
				query: {}
			});
		}, _this.changeBeneficontrozjzq = function () {
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var dispatch = _this.props.dispatch;

			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
				pathname: "/CertiUpload",
				state: {
					route: route,
					onFun: function onFun(val) {
						console.log(val);
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_22" /* smrzBeneficontroZjzq */])(val));
					},
					accountRole: 1,
					kzrId: _this.props.location.state.kzrId
				},
				query: {}
			});
		}, _this.changeBeneficiarieszjzq = function () {
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var dispatch = _this.props.dispatch;

			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
				pathname: "/CertiUpload",
				state: {
					route: route,
					onFun: function onFun(val) {
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_23" /* smrzBeneficiariesZjzq */])(val));
					},
					accountRole: 2,
					syrId: _this.props.location.state.syrId
				},
				query: {}
			});
		}, _this.changeIsImportant = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				isImportant: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_24" /* smrzGjzz */])(value));
		}, _this.goCertification = function () {
			var validitya = _this.props.location.state.validity.split("-")[0];
			var validityc = "";
			if (_this.props.zzhZjyxq) {
				for (var i = 0; i < _this.props.zzhZjyxq.certValidTerm.length; i++) {
					if (_this.props.zzhZjyxq.certValidTerm[i] == "-") {
						validityc += ".";
					} else {
						validityc += _this.props.zzhZjyxq.certValidTerm[i];
					}
				}
			}
			var validityb = _this.props.zzhZjyxq ? validityc : _this.props.location.state.validity.split("-")[1];
			var formData = {
				mobileNo: _this.props.location.state.phoneNo,
				certificateNo: _this.state.personNumber,
				certificateName: _this.state.cardPerson,
				isCertificateValidEver: _this.state.certValidEver == "1" ? 1 : 0,
				validity: validitya + "-" + validityb
			};

			console.log(formData);
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_25" /* ZTbool */])(formData, _this, function (result) {
				if (result.validEver) {
					if (result.ztValidate) {
						var dispatch = _this.props.dispatch;
						var _this$state = _this.state,
						    actualBeneficiaryEmail = _this$state.actualBeneficiaryEmail,
						    careersyrCode = _this$state.careersyrCode,
						    actualBeneficiaryPostcode = _this$state.actualBeneficiaryPostcode,
						    actualBeneficiaryAddress = _this$state.actualBeneficiaryAddress,
						    actualBeneficiaryMobileNo = _this$state.actualBeneficiaryMobileNo,
						    careerkzrCode = _this$state.careerkzrCode,
						    phoneNo = _this$state.phoneNo,
						    cardPerson = _this$state.cardPerson,
						    personNumber = _this$state.personNumber,
						    beneficiariesName = _this$state.beneficiariesName,
						    beneficiaries = _this$state.beneficiaries,
						    beneficontroName = _this$state.beneficontroName,
						    beneficontro = _this$state.beneficontro,
						    beneficiariesType = _this$state.beneficiariesType,
						    beneficontroType = _this$state.beneficontroType,
						    beneficiariesNo = _this$state.beneficiariesNo,
						    beneficontroNo = _this$state.beneficontroNo,
						    isImportant = _this$state.isImportant,
						    address = _this$state.address,
						    job = _this$state.job,
						    city = _this$state.city,
						    careerCode = _this$state.careerCode,
						    nsrcode = _this$state.nsrcode,
						    annualIncomeV2 = _this$state.annualIncomeV2,
						    annualIncome = _this$state.annualIncome,
						    actualControllerValidTerm = _this$state.actualControllerValidTerm,
						    actualControllerValidEver = _this$state.actualControllerValidEver,
						    kzrXbcode = _this$state.kzrXbcode,
						    actualBeneficiaryValidTerm = _this$state.actualBeneficiaryValidTerm,
						    actualBeneficiaryValidEver = _this$state.actualBeneficiaryValidEver,
						    syrXbcode = _this$state.syrXbcode,
						    actualControllerBirthday = _this$state.actualControllerBirthday,
						    actualBeneficiaryBirthday = _this$state.actualBeneficiaryBirthday,
						    actualControllerMobileNo = _this$state.actualControllerMobileNo,
						    actualControllerProvince = _this$state.actualControllerProvince,
						    actualControllerAddress = _this$state.actualControllerAddress,
						    actualControllerPostcode = _this$state.actualControllerPostcode,
						    actualControllerEmail = _this$state.actualControllerEmail,
						    actualBeneficiaryProvince = _this$state.actualBeneficiaryProvince;

						var regName = /^([\u4e00-\u9fa5]){2,7}$/;
						var regNo = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
						var regAddress = /[\u4e00-\u9fa5]+/i;
						var regSjh = /^[1][3-9][0-9]{9}$/;
						var regYzbm = /^[0-9]\d{5}(?!\d)$/;
						var regDzyx = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
						if (!regName.test(cardPerson)) {
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入正确格式的持卡人", 2);
							return;
						}
						if (!regNo.test(personNumber)) {
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入正确格式的身份证号", 2);
							return;
						}
						if (cLength(address) < 6) {
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("详细地址不能少于6个汉字", 2);
							return;
						}
						if (!careerCode) {
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请选择职业", 2);
							return;
						}
						if (nsrcode[0] == "4") {
							if (Number(annualIncomeV2) <= 50 || _this.state.annualIncomeV2.length > 12) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入12位以内的整数并且大于50（万）", 2);
								return;
							}
						}
						if (beneficontro == "他人") {
							if (!regName.test(beneficontroName)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入正确格式的控制人姓名", 2);
								return;
							}
							if (!beneficontroType) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请选择控制人证件类型", 2);
								return;
							}
							if (!beneficontroNo) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入控制人证件号", 2);
								return;
							}
							if (beneficontroType == '身份证' && !regNo.test(beneficontroNo)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的控制人身份证号', 2);
								return;
							}
							if (cLength(actualControllerAddress) < 6) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("控制人详细地址不能少于6个汉字", 2);
								return;
							}
							if (!regSjh.test(actualControllerMobileNo)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的控制人手机号', 2);
								return;
							}
							if (!regYzbm.test(actualControllerPostcode)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的控制人邮政编码', 2);
								return;
							}
							if (!regDzyx.test(actualControllerEmail)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的控制人电子邮箱', 2);
								return;
							}
						}
						if (beneficiaries == "他人") {
							if (!regName.test(beneficiariesName)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入正确格式的受益人姓名", 2);
								return;
							}
							if (!beneficiariesType) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请选择受益人证件类型", 2);
								return;
							}
							if (!beneficiariesNo) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入受益人证件号", 2);
								return;
							}
							if (beneficiariesType == '身份证' && !regNo.test(beneficiariesNo)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的受益人身份证号', 2);
								return;
							}
							if (cLength(actualBeneficiaryAddress) < 6) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("受益人详细地址不能少于6个汉字", 2);
								return;
							}
							if (!regSjh.test(actualBeneficiaryMobileNo)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的受益人手机号', 2);
								return;
							}
							if (!regYzbm.test(actualBeneficiaryPostcode)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的受益人邮政编码', 2);
								return;
							}
							if (!regDzyx.test(actualBeneficiaryEmail)) {
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的受益人电子邮箱', 2);
								return;
							}
						}
						var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
						var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
						var theNo = {
							"身份证": "0",
							"护照": "1",
							"户口本": "5",
							"警官证": "a",
							"文职证": "b",
							"港澳居民来往内地通行证(原回乡证)": "4",
							"台胞证": "A"
						};
						__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
							pathname: "/certificationCardAgain",
							state: {
								name: cardPerson,
								certNo: personNumber.toUpperCase(),
								certType: 0,
								address: address,
								careerCode: careerCode,
								cityCode: city[1],
								provinceCode: city[0],
								actualBeneficiary: beneficiaries == "本人" ? cardPerson : beneficiariesName,
								actualController: beneficontro == "本人" ? cardPerson : beneficontroName,
								actualBeneficiaryCertType: "0",
								actualBeneficiaryCertNo: beneficiaries == "本人" ? personNumber : beneficiariesNo,
								actualControllerCertType: "0",
								actualControllerCertNo: beneficontro == "本人" ? personNumber : beneficontroNo,
								officialsOrRelatives: isImportant == "是" ? true : false,
								phoneNo: phoneNo,
								callback: callback,
								route: route,
								enterType: _this.state.enterType,
								annualIncomeV2: annualIncomeV2 ? (annualIncomeV2 * 10000).toString() : "",
								annualIncome: nsrcode[0] ? nsrcode[0] : "",
								actualControllerBirthday: beneficontro == "本人" ? "" : actualControllerBirthday,
								actualControllerValidTerm: beneficontro == "本人" ? "" : actualControllerValidTerm,
								actualControllerValidEver: beneficontro == "本人" ? "" : actualControllerValidEver,
								actualControllerSex: beneficontro == "本人" ? "" : kzrXbcode[0],
								actualControllerMobileNo: beneficontro == "本人" ? "" : actualControllerMobileNo,
								actualControllerCity: beneficontro == "本人" ? "" : actualControllerProvince[1],
								actualControllerProvince: beneficontro == "本人" ? "" : actualControllerProvince[0],
								actualControllerProfession: beneficontro == "本人" ? "" : careerkzrCode,
								actualControllerAddress: beneficontro == "本人" ? "" : actualControllerAddress,
								actualControllerPostcode: beneficontro == "本人" ? "" : actualControllerPostcode,
								actualControllerEmail: beneficontro == "本人" ? "" : actualControllerEmail,
								actualBeneficiaryValidTerm: beneficiaries == "本人" ? "" : actualBeneficiaryValidTerm,
								actualBeneficiaryValidEver: beneficiaries == "本人" ? "" : actualBeneficiaryValidEver,
								actualBeneficiarySex: beneficiaries == "本人" ? "" : syrXbcode[0],
								actualBeneficiaryBirthday: beneficiaries == "本人" ? "" : actualBeneficiaryBirthday,
								actualBeneficiaryMobileNo: beneficiaries == "本人" ? "" : actualBeneficiaryMobileNo,
								actualBeneficiaryCity: beneficiaries == "本人" ? "" : actualBeneficiaryProvince[1],
								actualBeneficiaryProvince: beneficiaries == "本人" ? "" : actualBeneficiaryProvince[0],
								actualBeneficiaryAddress: beneficiaries == "本人" ? "" : actualBeneficiaryAddress,
								actualBeneficiaryPostcode: beneficiaries == "本人" ? "" : actualBeneficiaryPostcode,
								actualBeneficiaryProfession: beneficiaries == "本人" ? "" : careersyrCode,
								actualBeneficiaryEmail: beneficiaries == "本人" ? "" : actualBeneficiaryEmail,
								savePicFun: _this.props.huiDiao,
								conversationId: _this.props.location.state.conversationId ? _this.props.location.state.conversationId : "",
								certValidTerm: _this.state.certValidTerm,
								certValidEver: _this.state.certValidEver == "1" ? 1 : 0,
								certLifeTime: _this.state.certValidTerm
							},
							query: { enterType: _this.state.enterType,
								activityId: _this.props.location.query.activityId
							}
						});
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_0" /* smrzCardNumber */])(""));
						__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].hide();
					} else {
						__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("证通鉴权不通过", 2);
						return;
					}
				} else {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("证件有效期按相关规定不能选择长期有效", 2);
					return;
				}
			}));
		}, _this.changeCardPerson = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				cardPerson: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_26" /* smrzCardPerson */])(event.target.value));
		}, _this.changeBeneficiariesName = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficiariesName: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_27" /* smrzBeneficiariesName */])(event.target.value));
		}, _this.changeBeneficontroName = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficontroName: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_28" /* smrzBeneficontroName */])(event.target.value));
		}, _this.changeBeneficiariesNo = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficiariesNo: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_29" /* smrzBeneficiariesNo */])(event.target.value));
		}, _this.changeBeneficontroNo = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficontroNo: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_30" /* smrzBeneficontroNo */])(event.target.value));
		}, _this.changeBeneficontroKzrNo = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualControllerMobileNo: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_31" /* smrzBeneficontroKzrNo */])(event.target.value));
		}, _this.changeBeneficontroSyrNo = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualBeneficiaryMobileNo: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_32" /* smrzBeneficontroSyrNo */])(event.target.value));
		}, _this.changePersonNumber = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				personNumber: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_33" /* smrzPersonNumber */])(event.target.value));
		}, _this.changeAddress = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				address: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_34" /* smrzAddress */])(event.target.value));
		}, _this.changekzrAddress = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualControllerAddress: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_35" /* smrzkzrAddress */])(event.target.value));
		}, _this.changesyrAddress = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualBeneficiaryAddress: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_36" /* smrzsyrAddress */])(event.target.value));
		}, _this.changekzrBianm = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualControllerPostcode: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_37" /* smrzkzrBianma */])(event.target.value));
		}, _this.changesyrBianm = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualBeneficiaryPostcode: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_38" /* smrzsyrBianma */])(event.target.value));
		}, _this.changekzrYoux = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualControllerEmail: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_39" /* smrzkzrYoux */])(event.target.value));
		}, _this.changesyrYoux = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				actualBeneficiaryEmail: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_40" /* smrzsyrYoux */])(event.target.value));
		}, _this.changeNsrJuti = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				annualIncomeV2: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_41" /* smrznJtsrcode */])(event.target.value));
		}, _this.goBack = function () {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
		}, _this.closeMoadl = function () {
			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
			_this.setState({
				alertFlag: false
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CertificationCard, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			console.log(this.props.location);
			this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_42" /* huiDiao */])(this.props.location.state.savePicFun ? this.props.location.state.savePicFun : this.props.huiDiao));
			console.log(this.props.huiDiao);
			this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_43" /* validateAgeUserCertNo */])({ certNo: this.state.personNumber }, function (sec) {
				if (sec) {
					if (sec.eighteenBelow == true) {
						_this2.setState({
							alertFlag: true
						});
					}
				}
			}, function () {}));
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
			document.getElementsByTagName('title')[0].innerHTML = "实名认证";
			var dispatch = this.props.dispatch;

			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_44" /* userJob */])(null));
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["x" /* provinceCity */])(null));
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading("正在加载");
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["z" /* getProvinceCity */])(function (data) {
				_this2.setState({
					city: [data[0].provinceCode, data[0].cityList[0].cityCode]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_10" /* smrzCity */])([data[0].provinceCode, data[0].cityList[0].cityCode]));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_11" /* smrzkzrCityc */])([data[0].provinceCode, data[0].cityList[0].cityCode]));
			}, function () {}));
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_45" /* getUserJob */])());
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _state = this.state,
			    actualBeneficiaryEmail = _state.actualBeneficiaryEmail,
			    syrjob = _state.syrjob,
			    actualBeneficiaryPostcode = _state.actualBeneficiaryPostcode,
			    actualBeneficiaryAddress = _state.actualBeneficiaryAddress,
			    actualBeneficiaryProvince = _state.actualBeneficiaryProvince,
			    syrBool = _state.syrBool,
			    actualControllerEmail = _state.actualControllerEmail,
			    kzrjob = _state.kzrjob,
			    actualControllerPostcode = _state.actualControllerPostcode,
			    actualControllerAddress = _state.actualControllerAddress,
			    actualControllerProvince = _state.actualControllerProvince,
			    cardPerson = _state.cardPerson,
			    personNumber = _state.personNumber,
			    city = _state.city,
			    address = _state.address,
			    job = _state.job,
			    downUpListShow = _state.downUpListShow,
			    beneficiariesName = _state.beneficiariesName,
			    beneficiaries = _state.beneficiaries,
			    beneficontroName = _state.beneficontroName,
			    beneficontro = _state.beneficontro,
			    beneficiariesType = _state.beneficiariesType,
			    beneficontroType = _state.beneficontroType,
			    beneficiariesNo = _state.beneficiariesNo,
			    beneficontroNo = _state.beneficontroNo,
			    isImportant = _state.isImportant,
			    downListFlag = _state.downListFlag,
			    annualIncome = _state.annualIncome,
			    nsrcode = _state.nsrcode,
			    annualIncomeV2 = _state.annualIncomeV2,
			    actualControllerValidTerm = _state.actualControllerValidTerm,
			    kzrBool = _state.kzrBool,
			    kzrXbcode = _state.kzrXbcode,
			    actualControllerBirthday = _state.actualControllerBirthday,
			    actualControllerMobileNo = _state.actualControllerMobileNo,
			    actualBeneficiaryValidTerm = _state.actualBeneficiaryValidTerm,
			    syrXbcode = _state.syrXbcode,
			    actualBeneficiaryBirthday = _state.actualBeneficiaryBirthday,
			    actualBeneficiaryMobileNo = _state.actualBeneficiaryMobileNo;

			var nsrArr = [];
			var xbArr = [];
			var btnArr = [];
			var jobArr = [];
			var cityArr = [];
			var nsr = [{ careerId: '1', careerName: '0—10万（含）' }, { careerId: '2', careerName: '10万—30万（含）' }, { careerId: '3', careerName: '30万—50万（含）' }, { careerId: '4', careerName: '50万以上' }];
			var xb = [{ careerId: '1', careerName: '男' }, { careerId: '0', careerName: '女' }];
			for (var i = 0; i < nsr.length; i++) {
				nsrArr.push({ label: nsr[i].careerName, value: nsr[i].careerId });
			}
			for (var _i = 0; _i < xb.length; _i++) {
				xbArr.push({ label: xb[_i].careerName, value: xb[_i].careerId });
			}
			var _props = this.props,
			    provinceCity = _props.provinceCity,
			    userJob = _props.userJob;

			if (userJob != null) {
				for (var _i2 = 0; _i2 < userJob.length; _i2++) {
					jobArr.push({ label: userJob[_i2].careerName, value: userJob[_i2].careerId });
				}
			}
			if (provinceCity != null) {
				for (var _i3 = 0; _i3 < provinceCity.length; _i3++) {
					var obj = {};
					var obj2 = [];
					obj.label = provinceCity[_i3].provinceName;
					obj.value = provinceCity[_i3].provinceCode;
					for (var k = 0; k < provinceCity[_i3].cityList.length; k++) {
						obj2.push({
							label: provinceCity[_i3].cityList[k].cityName,
							value: provinceCity[_i3].cityList[k].cityCode
						});
					}
					obj.children = obj2;
					cityArr.push(obj);
				}
			}
			var beneficiariesArr = [{ value: "本人", label: "本人" }, { value: "他人", label: "他人" }];
			var beneficontroArr = [{ value: "本人", label: "本人" }, { value: "他人", label: "他人" }];
			var beneficiariesTypeArr = [{ value: "身份证", label: "身份证" }];
			var beneficontroTypeArr = [{ value: "身份证", label: "身份证" }];
			var gjzzArr = [{ value: "是", label: "是" }, { value: "否", label: "否" }];
			if (personNumber && cardPerson && job && city && address && beneficontro == "本人" && beneficiaries == "本人" && isImportant && nsrcode[0]) {
				if (nsrcode[0] != "4") {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					if (annualIncomeV2[0]) {
						btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{
								className: 'smrz-first-okbtn',
								key: 0,
								onClick: this.goCertification
							},
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								null,
								'\u4E0B\u4E00\u6B65'
							)
						));
					} else {
						btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{
								className: 'smrz-first-unokbtn',
								key: 0
							},
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								null,
								'\u4E0B\u4E00\u6B65'
							)
						));
					}
				}
			} else if (personNumber && cardPerson && job && city && address && beneficontro == "他人" && beneficiaries == "本人" && isImportant) {
				if (beneficontroName && beneficontroType && beneficontroNo && actualControllerValidTerm && kzrBool && kzrXbcode && actualControllerMobileNo && actualControllerProvince && actualControllerAddress && actualControllerPostcode && kzrjob && actualControllerEmail && actualControllerBirthday) {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-unokbtn',
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				}
			} else if (personNumber && cardPerson && job && city && address && beneficiaries == "他人" && beneficontro == "本人" && isImportant) {
				if (beneficiariesName && beneficiariesType && beneficiariesNo && actualBeneficiaryValidTerm && syrBool && syrXbcode && actualBeneficiaryMobileNo && actualBeneficiaryProvince && actualBeneficiaryAddress && actualBeneficiaryPostcode && syrjob && actualBeneficiaryEmail && actualBeneficiaryBirthday) {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-unokbtn',
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				}
			} else if (personNumber && cardPerson && job && city && address && beneficiaries == "他人" && beneficontro == "他人" && isImportant) {
				if (beneficiariesName && beneficontroName && beneficiariesType && beneficontroType && beneficiariesNo && beneficontroNo && actualControllerValidTerm && kzrBool && kzrXbcode && actualControllerMobileNo && actualControllerProvince && actualControllerAddress && actualControllerPostcode && kzrjob && actualControllerEmail && actualBeneficiaryValidTerm && syrBool && syrXbcode && actualBeneficiaryMobileNo && actualBeneficiaryProvince && actualBeneficiaryAddress && actualBeneficiaryPostcode && syrjob && actualBeneficiaryEmail && actualControllerBirthday && actualBeneficiaryBirthday) {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-unokbtn',
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				}
			} else {
				btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{
						className: 'smrz-first-unokbtn',
						key: 0
					},
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						null,
						'\u4E0B\u4E00\u6B65'
					)
				));
			}
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: "13px", color: "#5b6370" } },
							'\u6839\u636E\u8BC1\u76D1\u4F1A\u9500\u552E\u9002\u5F53\u6027\u8981\u6C42\uFF0C\u8BF7\u5982\u5B9E\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E8E\u4E3A\u60A8\u63D0\u4F9B\u66F4\u597D\u7684\u5B89\u5168\u4FDD\u969C'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u6301\u5361\u4EBA'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: cardPerson,
							onChange: this.changeCardPerson,
							placeholder: '\u8BF7\u8F93\u5165\u6301\u5361\u4EBA\u59D3\u540D'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8EAB\u4EFD\u8BC1\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							disabled: 'disabled',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right',
								backgroundColor: "#fff"
							},
							value: personNumber,
							onChange: this.changePersonNumber,
							placeholder: '\u8BF7\u8F93\u5165\u8EAB\u4EFD\u8BC1\u53F7'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: "pickerBox", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: function onClick() {
									_this3.Zhzjyxq("主账户证件有效期");
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u8BC1\u4EF6\u6709\u6548\u671F'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								this.state.certValidEver == "1" ? "长期有效" : this.state.certValidTerm
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: job[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: job, title: '\u804C\u4E1A\u5217\u8868', data: jobArr, extra: '\u8BF7\u9009\u62E9\u804C\u4E1A', onChange: this.changeJob, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u804C\u4E1A'
							)
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: city, title: '\u57CE\u5E02\u5217\u8868', data: cityArr, onChange: this.changeCity, cols: 2, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u6240\u5728\u57CE\u5E02'
							)
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BE6\u7EC6\u5730\u5740'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: address,
							onChange: this.changeAddress,
							placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: nsrcode[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: nsrcode, title: '\u5E74\u6536\u5165\u5217\u8868', data: nsrArr, extra: '\u8BF7\u9009\u62E9\u5E74\u6536\u5165', onChange: this.changeNsr, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u5E74\u6536\u5165'
							)
						)
					),
					nsrcode == "4" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u5177\u4F53\u5E74\u6536\u5165'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: annualIncomeV2,
							onChange: this.changeNsrJuti,
							placeholder: '\u8BF7\u8F93\u5165\u5177\u4F53\u5E74\u6536\u5165'
						}),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									display: "block"
								} },
							'\uFF08\u4E07\uFF09'
						)
					) : null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficontro, title: '\u8D26\u6237\u5B9E\u9645\u63A7\u5236\u4EBA', data: beneficontroArr, onChange: this.changeBeneficontro, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8D26\u6237\u5B9E\u9645\u63A7\u5236\u4EBA'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u59D3\u540D'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficontroName,
							onChange: this.changeBeneficontroName,
							placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D'
						})
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: beneficontroType[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficontroType, title: '\u8BC1\u4EF6\u7C7B\u578B', extra: '\u8BF7\u9009\u62E9\u8BC1\u4EF6\u7C7B\u578B', data: beneficontroTypeArr, onChange: this.changeBeneficontroType, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8BC1\u4EF6\u7C7B\u578B'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BC1\u4EF6\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficontroNo,
							onChange: this.changeBeneficontroNo,
							placeholder: '\u8BF7\u8F93\u5165\u8BC1\u4EF6\u53F7'
						})
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: actualControllerValidTerm ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: function onClick() {
									_this3.changeBeneficontrozjyxq("控制人证件有效期");
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u8BC1\u4EF6\u6709\u6548\u671F'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								actualControllerValidTerm ? actualControllerValidTerm : "请选择证件有效期"
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					),
					beneficontro == "本人" || !beneficontro ? null : beneficontroType[0] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: kzrBool ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: this.changeBeneficontrozjzq },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u8BC1\u4EF6\u7167\u7247'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								this.state.kzrBool ? "已上传" : "请选择证件照片"
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					) : null,
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: kzrXbcode ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: kzrXbcode, title: '\u6027\u522B\u5217\u8868', data: xbArr, extra: '\u8BF7\u9009\u62E9\u6027\u522B', onChange: this.changekzrXb, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u6027\u522B'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: actualControllerBirthday ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: function onClick() {
									_this3.changeBeneficontrozjyxq("控制人出生日期");
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u51FA\u751F\u65E5\u671F'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								actualControllerBirthday ? actualControllerBirthday : "请选择出生日期"
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u624B\u673A\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualControllerMobileNo,
							onChange: this.changeBeneficontroKzrNo,
							placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7'
						})
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: actualControllerProvince, title: '\u57CE\u5E02\u5217\u8868', data: cityArr, onChange: this.changekzrCity, cols: 2, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u6240\u5728\u57CE\u5E02'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BE6\u7EC6\u5730\u5740'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualControllerAddress,
							onChange: this.changekzrAddress,
							placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740'
						})
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u90AE\u653F\u7F16\u7801'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualControllerPostcode,
							onChange: this.changekzrBianm,
							placeholder: '\u8BF7\u8F93\u5165\u90AE\u653F\u7F16\u7801'
						})
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: kzrjob[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: kzrjob, title: '\u804C\u4E1A\u5217\u8868', data: jobArr, extra: '\u8BF7\u9009\u62E9\u804C\u4E1A', onChange: this.changekzrJob, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u804C\u4E1A'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u7535\u5B50\u90AE\u7BB1'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualControllerEmail,
							onChange: this.changekzrYoux,
							placeholder: '\u8BF7\u8F93\u5165\u7535\u5B50\u90AE\u7BB1'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficiaries, title: '\u8D26\u6237\u5B9E\u9645\u63A7\u5236\u4EBA', data: beneficiariesArr, onChange: this.changeBeneficiaries, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8D26\u6237\u5B9E\u9645\u53D7\u76CA\u4EBA'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u59D3\u540D'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficiariesName,
							onChange: this.changeBeneficiariesName,
							placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D'
						})
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: beneficiariesType[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficiariesType, title: '\u8BC1\u4EF6\u7C7B\u578B', extra: '\u8BF7\u9009\u62E9\u8BC1\u4EF6\u7C7B\u578B', data: beneficiariesTypeArr, onChange: this.changeBeneficiariesType, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8BC1\u4EF6\u7C7B\u578B'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BC1\u4EF6\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficiariesNo,
							onChange: this.changeBeneficiariesNo,
							placeholder: '\u8BF7\u8F93\u5165\u8BC1\u4EF6\u53F7'
						})
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: actualBeneficiaryValidTerm ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: function onClick() {
									_this3.changeBeneficontrozjyxq("受益人证件有效期");
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u8BC1\u4EF6\u6709\u6548\u671F'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								actualBeneficiaryValidTerm ? actualBeneficiaryValidTerm : "请选择证件有效期"
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : beneficiariesType[0] ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: syrBool ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: this.changeBeneficiarieszjzq },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u8BC1\u4EF6\u7167\u7247'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								this.state.syrBool ? "已上传" : "请选择证件照片"
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					) : null,
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: syrXbcode ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: syrXbcode, title: '\u6027\u522B\u5217\u8868', data: xbArr, extra: '\u8BF7\u9009\u62E9\u6027\u522B', onChange: this.changesyrXb, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u6027\u522B'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: actualBeneficiaryBirthday ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)",
								color: "#5b6370"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "flex", color: "#5b6370", fontSize: "13px", alignItems: "center" }, onClick: function onClick() {
									_this3.changeBeneficontrozjyxq("受益人出生日期");
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { flex: 1 } },
								'\u51FA\u751F\u65E5\u671F'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { width: 150, textAlign: "right" } },
								actualBeneficiaryBirthday ? actualBeneficiaryBirthday : "请选择出生日期"
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u624B\u673A\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualBeneficiaryMobileNo,
							onChange: this.changeBeneficontroSyrNo,
							placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7'
						})
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: actualBeneficiaryProvince, title: '\u57CE\u5E02\u5217\u8868', data: cityArr, onChange: this.changesyrCity, cols: 2, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u6240\u5728\u57CE\u5E02'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BE6\u7EC6\u5730\u5740'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualBeneficiaryAddress,
							onChange: this.changesyrAddress,
							placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740'
						})
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u90AE\u653F\u7F16\u7801'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualBeneficiaryPostcode,
							onChange: this.changesyrBianm,
							placeholder: '\u8BF7\u8F93\u5165\u90AE\u653F\u7F16\u7801'
						})
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: syrjob[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: syrjob, title: '\u804C\u4E1A\u5217\u8868', data: jobArr, extra: '\u8BF7\u9009\u62E9\u804C\u4E1A', onChange: this.changesyrJob, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u804C\u4E1A'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u7535\u5B50\u90AE\u7BB1'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: actualBeneficiaryEmail,
							onChange: this.changesyrYoux,
							placeholder: '\u8BF7\u8F93\u5165\u7535\u5B50\u90AE\u7BB1'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox pickerBoxTs', style: {
								display: "-webkit-flex",
								height: "auto",
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: isImportant, title: '\u8BF7\u9009\u62E9\u662F\u6216\u5426', data: gjzzArr, onChange: this.changeIsImportant, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u5B9E\u9645\u53D7\u76CA\u4EBA\u4E3A\u653F\u8981\u3001\u56FD\u9645\u7EC4\u7EC7\u9AD8\u7EA7\u7BA1\u7406\u4EBA\u5458\u6216\u5176\u4EB2\u5C5E\u3001\u5173\u7CFB\u5BC6\u5207\u7684\u4EBA'
							)
						)
					),
					btnArr
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modal_ModalList__["a" /* default */], { flag: this.state.alertFlag, btnRight: "确认", btnRightFun: this.closeMoadl, content: "线上交易仅支持18周岁以上的用户开户，如果未满18周岁，请联系线下网点进行开户。", title: "温馨提示" })
			);
		}
	}]);

	return CertificationCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
	return {
		userJob: state.userJob,
		provinceCity: state.provinceCity,
		smrzCardPerson: state.smrzCardPerson,
		smrzPersonNumber: state.smrzPersonNumber,
		smrzAddress: state.smrzAddress,
		smrzkzrAddress: state.smrzkzrAddress,
		smrzsyrAddress: state.smrzsyrAddress,
		smrzkzrBianma: state.smrzkzrBianma,
		smrzsyrBianma: state.smrzsyrBianma,
		smrzkzrYoux: state.smrzkzrYoux,
		smrzsyrYoux: state.smrzsyrYoux,
		smrzJob: state.smrzJob,
		smrzkzrJob: state.smrzkzrJob,
		smrzsyrJob: state.smrzsyrJob,
		smrzCareerCode: state.smrzCareerCode,
		smrzCareerkzrCode: state.smrzCareerkzrCode,
		smrzCareersyrCode: state.smrzCareersyrCode,
		smrznJtsrcode: state.smrznJtsrcode,
		smrznsrcode: state.smrznsrcode,
		smrzCity: state.smrzCity,
		smrzkzrCityc: state.smrzkzrCityc,
		smrzsyrCityc: state.smrzsyrCityc,
		smrzBeneficiaries: state.smrzBeneficiaries,
		smrzBeneficiariesName: state.smrzBeneficiariesName,
		smrzBeneficiariesType: state.smrzBeneficiariesType,
		smrzBeneficiariesNo: state.smrzBeneficiariesNo,
		smrzBeneficontro: state.smrzBeneficontro,
		smrzBeneficontroName: state.smrzBeneficontroName,
		smrzBeneficontroType: state.smrzBeneficontroType,
		smrzBeneficontroNo: state.smrzBeneficontroNo,
		smrzGjzz: state.smrzGjzz,
		userMobileNo: state.userMobileNo,
		smrzBeneficontroZjyxq: state.smrzBeneficontroZjyxq,
		zzhZjyxq: state.zzhZjyxq,
		smrzBeneficiariesZjyxq: state.smrzBeneficiariesZjyxq,
		smrzBeneficontroZjzq: state.smrzBeneficontroZjzq,
		smrzBeneficiariesZjzq: state.smrzBeneficiariesZjzq,
		smrzkzrXbcode: state.smrzkzrXbcode,
		smrzsyrXbcode: state.smrzsyrXbcode,
		smrzBeneficontroCsrq: state.smrzBeneficontroCsrq,
		smrzBeneficiariesCsrq: state.smrzBeneficiariesCsrq,
		smrzBeneficontroKzrNo: state.smrzBeneficontroKzrNo,
		smrzBeneficontroSyrNo: state.smrzBeneficontroSyrNo,
		huiDiao: state.huiDiao
	};
}

function cLength(str) {
	var reg = /[^\u4E00-\u9FA5\uf900-\ufa2d]/g;
	//匹配非中文的正则表达式
	var temp = str.replace(reg, '');
	return temp.length;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(CertificationCard));

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(449);
} catch (err) {
  var index = __webpack_require__(449);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(167)
  , document = __webpack_require__(99).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(114) && !__webpack_require__(133)(function(){
  return Object.defineProperty(__webpack_require__(450)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(281);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(285)
  , $export        = __webpack_require__(98)
  , redefine       = __webpack_require__(458)
  , hide           = __webpack_require__(134)
  , has            = __webpack_require__(115)
  , Iterators      = __webpack_require__(168)
  , $iterCreate    = __webpack_require__(976)
  , setToStringTag = __webpack_require__(289)
  , getPrototypeOf = __webpack_require__(455)
  , ITERATOR       = __webpack_require__(85)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(456)
  , hiddenKeys = __webpack_require__(284).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(115)
  , toObject    = __webpack_require__(204)
  , IE_PROTO    = __webpack_require__(290)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(115)
  , toIObject    = __webpack_require__(101)
  , arrayIndexOf = __webpack_require__(968)(false)
  , IE_PROTO     = __webpack_require__(290)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(98)
  , core    = __webpack_require__(60)
  , fails   = __webpack_require__(133);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(134);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(292)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(985)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(453)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(206));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["b"] = (cssAnimation);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var _symbol = __webpack_require__(211);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(34);

var _number = __webpack_require__(48);

var parsePercent = _number.parsePercent;

var _labelHelper = __webpack_require__(1039);

var findLabelValueDim = _labelHelper.findLabelValueDim;

/**
 * @module echarts/chart/helper/Symbol
 */
function getSymbolSize(data, idx) {
  var symbolSize = data.getItemVisual(idx, 'symbolSize');
  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
}

function getScale(symbolSize) {
  return [symbolSize[0] / 2, symbolSize[1] / 2];
}
/**
 * @constructor
 * @alias {module:echarts/chart/helper/Symbol}
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @extends {module:zrender/graphic/Group}
 */


function SymbolClz(data, idx, seriesScope) {
  graphic.Group.call(this);
  this.updateData(data, idx, seriesScope);
}

var symbolProto = SymbolClz.prototype;

function driftSymbol(dx, dy) {
  this.parent.drift(dx, dy);
}

symbolProto._createSymbol = function (symbolType, data, idx, symbolSize) {
  // Remove paths created before
  this.removeAll();
  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
  //     symbolType, -0.5, -0.5, 1, 1, color
  // );
  // If width/height are set too small (e.g., set to 1) on ios10
  // and macOS Sierra, a circle stroke become a rect, no matter what
  // the scale is set. So we set width/height as 2. See #4150.

  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color);
  symbolPath.attr({
    z2: 100,
    culling: true,
    scale: getScale(symbolSize)
  }); // Rewrite drift method

  symbolPath.drift = driftSymbol;
  this._symbolType = symbolType;
  this.add(symbolPath);
};
/**
 * Stop animation
 * @param {boolean} toLastFrame
 */


symbolProto.stopSymbolAnimation = function (toLastFrame) {
  this.childAt(0).stopAnimation(toLastFrame);
};
/**
 * FIXME:
 * Caution: This method breaks the encapsulation of this module,
 * but it indeed brings convenience. So do not use the method
 * unless you detailedly know all the implements of `Symbol`,
 * especially animation.
 *
 * Get symbol path element.
 */


symbolProto.getSymbolPath = function () {
  return this.childAt(0);
};
/**
 * Get scale(aka, current symbol size).
 * Including the change caused by animation
 */


symbolProto.getScale = function () {
  return this.childAt(0).scale;
};
/**
 * Highlight symbol
 */


symbolProto.highlight = function () {
  this.childAt(0).trigger('emphasis');
};
/**
 * Downplay symbol
 */


symbolProto.downplay = function () {
  this.childAt(0).trigger('normal');
};
/**
 * @param {number} zlevel
 * @param {number} z
 */


symbolProto.setZ = function (zlevel, z) {
  var symbolPath = this.childAt(0);
  symbolPath.zlevel = zlevel;
  symbolPath.z = z;
};

symbolProto.setDraggable = function (draggable) {
  var symbolPath = this.childAt(0);
  symbolPath.draggable = draggable;
  symbolPath.cursor = draggable ? 'move' : 'pointer';
};
/**
 * Update symbol properties
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Object} [seriesScope]
 * @param {Object} [seriesScope.itemStyle]
 * @param {Object} [seriesScope.hoverItemStyle]
 * @param {Object} [seriesScope.symbolRotate]
 * @param {Object} [seriesScope.symbolOffset]
 * @param {module:echarts/model/Model} [seriesScope.labelModel]
 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
 * @param {boolean} [seriesScope.hoverAnimation]
 * @param {Object} [seriesScope.cursorStyle]
 * @param {module:echarts/model/Model} [seriesScope.itemModel]
 * @param {string} [seriesScope.symbolInnerColor]
 * @param {Object} [seriesScope.fadeIn=false]
 */


symbolProto.updateData = function (data, idx, seriesScope) {
  this.silent = false;
  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
  var seriesModel = data.hostModel;
  var symbolSize = getSymbolSize(data, idx);
  var isInit = symbolType !== this._symbolType;

  if (isInit) {
    this._createSymbol(symbolType, data, idx, symbolSize);
  } else {
    var symbolPath = this.childAt(0);
    symbolPath.silent = false;
    graphic.updateProps(symbolPath, {
      scale: getScale(symbolSize)
    }, seriesModel, idx);
  }

  this._updateCommon(data, idx, symbolSize, seriesScope);

  if (isInit) {
    var symbolPath = this.childAt(0);
    var fadeIn = seriesScope && seriesScope.fadeIn;
    var target = {
      scale: symbolPath.scale.slice()
    };
    fadeIn && (target.style = {
      opacity: symbolPath.style.opacity
    });
    symbolPath.scale = [0, 0];
    fadeIn && (symbolPath.style.opacity = 0);
    graphic.initProps(symbolPath, target, seriesModel, idx);
  }

  this._seriesModel = seriesModel;
}; // Update common properties


var normalStyleAccessPath = ['itemStyle', 'normal'];
var emphasisStyleAccessPath = ['itemStyle', 'emphasis'];
var normalLabelAccessPath = ['label', 'normal'];
var emphasisLabelAccessPath = ['label', 'emphasis'];
/**
 * @param {module:echarts/data/List} data
 * @param {number} idx
 * @param {Array.<number>} symbolSize
 * @param {Object} [seriesScope]
 */

symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
  var symbolPath = this.childAt(0);
  var seriesModel = data.hostModel;
  var color = data.getItemVisual(idx, 'color'); // Reset style

  if (symbolPath.type !== 'image') {
    symbolPath.useStyle({
      strokeNoScale: true
    });
  }

  var itemStyle = seriesScope && seriesScope.itemStyle;
  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
  var symbolRotate = seriesScope && seriesScope.symbolRotate;
  var symbolOffset = seriesScope && seriesScope.symbolOffset;
  var labelModel = seriesScope && seriesScope.labelModel;
  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
  var cursorStyle = seriesScope && seriesScope.cursorStyle;

  if (!seriesScope || data.hasItemOption) {
    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke

    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
    symbolRotate = itemModel.getShallow('symbolRotate');
    symbolOffset = itemModel.getShallow('symbolOffset');
    labelModel = itemModel.getModel(normalLabelAccessPath);
    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
    hoverAnimation = itemModel.getShallow('hoverAnimation');
    cursorStyle = itemModel.getShallow('cursor');
  } else {
    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
  }

  var elStyle = symbolPath.style;
  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);

  if (symbolOffset) {
    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
  }

  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!

  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
  symbolPath.setStyle(itemStyle);
  var opacity = data.getItemVisual(idx, 'opacity');

  if (opacity != null) {
    elStyle.opacity = opacity;
  }

  var useNameLabel = seriesScope && seriesScope.useNameLabel;
  var valueDim = !useNameLabel && findLabelValueDim(data);

  if (useNameLabel || valueDim != null) {
    graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
      labelFetcher: seriesModel,
      labelDataIndex: idx,
      defaultText: useNameLabel ? data.getName(idx) : data.get(valueDim, idx),
      isRectText: true,
      autoColor: color
    });
  }

  symbolPath.off('mouseover').off('mouseout').off('emphasis').off('normal');
  symbolPath.hoverStyle = hoverItemStyle; // FIXME
  // Do not use symbol.trigger('emphasis'), but use symbol.highlight() instead.

  graphic.setHoverStyle(symbolPath);
  var scale = getScale(symbolSize);

  if (hoverAnimation && seriesModel.isAnimationEnabled()) {
    var onEmphasis = function () {
      var ratio = scale[1] / scale[0];
      this.animateTo({
        scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
      }, 400, 'elasticOut');
    };

    var onNormal = function () {
      this.animateTo({
        scale: scale
      }, 400, 'elasticOut');
    };

    symbolPath.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
  }
};
/**
 * @param {Function} cb
 * @param {Object} [opt]
 * @param {Object} [opt.keepLabel=true]
 */


symbolProto.fadeOut = function (cb, opt) {
  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out

  this.silent = symbolPath.silent = true; // Not show text when animating

  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
  graphic.updateProps(symbolPath, {
    style: {
      opacity: 0
    },
    scale: [0, 0]
  }, this._seriesModel, this.dataIndex, cb);
};

zrUtil.inherits(SymbolClz, graphic.Group);
var _default = SymbolClz;
module.exports = _default;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(6);

var retrieve = _util.retrieve;
var defaults = _util.defaults;
var extend = _util.extend;
var each = _util.each;

var formatUtil = __webpack_require__(71);

var graphic = __webpack_require__(34);

var Model = __webpack_require__(70);

var _number = __webpack_require__(48);

var isRadianAroundZero = _number.isRadianAroundZero;
var remRadian = _number.remRadian;

var _symbol = __webpack_require__(211);

var createSymbol = _symbol.createSymbol;

var matrixUtil = __webpack_require__(127);

var _vector = __webpack_require__(53);

var v2ApplyTransform = _vector.applyTransform;
var PI = Math.PI;

function makeAxisEventDataBase(axisModel) {
  var eventData = {
    componentType: axisModel.mainType
  };
  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
  return eventData;
}
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 *
 * @param {module:zrender/container/Group} group
 * @param {Object} axisModel
 * @param {Object} opt Standard axis parameters.
 * @param {Array.<number>} opt.position [x, y]
 * @param {number} opt.rotation by radian
 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
 * @param {number} [opt.tickDirection=1] 1 or -1
 * @param {number} [opt.labelDirection=1] 1 or -1
 * @param {number} [opt.labelOffset=0] Usefull when onZero.
 * @param {string} [opt.axisLabelShow] default get from axisModel.
 * @param {string} [opt.axisName] default get from axisModel.
 * @param {number} [opt.axisNameAvailableWidth]
 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
 * @param {number} [opt.labelInterval] Default label interval when label
 *                                     interval from model is null or 'auto'.
 * @param {number} [opt.strokeContainThreshold] Default label interval when label
 * @param {number} [opt.nameTruncateMaxWidth]
 */


var AxisBuilder = function (axisModel, opt) {
  /**
   * @readOnly
   */
  this.opt = opt;
  /**
   * @readOnly
   */

  this.axisModel = axisModel; // Default value

  defaults(opt, {
    labelOffset: 0,
    nameDirection: 1,
    tickDirection: 1,
    labelDirection: 1,
    silent: true
  });
  /**
   * @readOnly
   */

  this.group = new graphic.Group(); // FIXME Not use a seperate text group?

  var dumbGroup = new graphic.Group({
    position: opt.position.slice(),
    rotation: opt.rotation
  }); // this.group.add(dumbGroup);
  // this._dumbGroup = dumbGroup;

  dumbGroup.updateTransform();
  this._transform = dumbGroup.transform;
  this._dumbGroup = dumbGroup;
};

AxisBuilder.prototype = {
  constructor: AxisBuilder,
  hasBuilder: function (name) {
    return !!builders[name];
  },
  add: function (name) {
    builders[name].call(this);
  },
  getGroup: function () {
    return this.group;
  }
};
var builders = {
  /**
   * @private
   */
  axisLine: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;

    if (!axisModel.get('axisLine.show')) {
      return;
    }

    var extent = this.axisModel.axis.getExtent();
    var matrix = this._transform;
    var pt1 = [extent[0], 0];
    var pt2 = [extent[1], 0];

    if (matrix) {
      v2ApplyTransform(pt1, pt1, matrix);
      v2ApplyTransform(pt2, pt2, matrix);
    }

    var lineStyle = extend({
      lineCap: 'round'
    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
    this.group.add(new graphic.Line(graphic.subPixelOptimizeLine({
      // Id for animation
      anid: 'line',
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: lineStyle,
      strokeContainThreshold: opt.strokeContainThreshold || 5,
      silent: true,
      z2: 1
    })));
    var arrows = axisModel.get('axisLine.symbol');
    var arrowSize = axisModel.get('axisLine.symbolSize');

    if (arrows != null) {
      if (typeof arrows === 'string') {
        // Use the same arrow for start and end point
        arrows = [arrows, arrows];
      }

      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
        // Use the same size for width and height
        arrowSize = [arrowSize, arrowSize];
      }

      var symbolWidth = arrowSize[0];
      var symbolHeight = arrowSize[1];
      each([[opt.rotation + Math.PI / 2, pt1], [opt.rotation - Math.PI / 2, pt2]], function (item, index) {
        if (arrows[index] !== 'none' && arrows[index] != null) {
          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true);
          symbol.attr({
            rotation: item[0],
            position: item[1],
            silent: true
          });
          this.group.add(symbol);
        }
      }, this);
    }
  },

  /**
   * @private
   */
  axisTickLabel: function () {
    var axisModel = this.axisModel;
    var opt = this.opt;
    var tickEls = buildAxisTick(this, axisModel, opt);
    var labelEls = buildAxisLabel(this, axisModel, opt);
    fixMinMaxLabelShow(axisModel, labelEls, tickEls);
  },

  /**
   * @private
   */
  axisName: function () {
    var opt = this.opt;
    var axisModel = this.axisModel;
    var name = retrieve(opt.axisName, axisModel.get('name'));

    if (!name) {
      return;
    }

    var nameLocation = axisModel.get('nameLocation');
    var nameDirection = opt.nameDirection;
    var textStyleModel = axisModel.getModel('nameTextStyle');
    var gap = axisModel.get('nameGap') || 0;
    var extent = this.axisModel.axis.getExtent();
    var gapSignal = extent[0] > extent[1] ? -1 : 1;
    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
    // Reuse labelOffset.
    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
    var labelLayout;
    var nameRotation = axisModel.get('nameRotate');

    if (nameRotation != null) {
      nameRotation = nameRotation * PI / 180; // To radian.
    }

    var axisNameAvailableWidth;

    if (isNameLocationCenter(nameLocation)) {
      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
      nameDirection);
    } else {
      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
      axisNameAvailableWidth = opt.axisNameAvailableWidth;

      if (axisNameAvailableWidth != null) {
        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
      }
    }

    var textFont = textStyleModel.getFont();
    var truncateOpt = axisModel.get('nameTruncate', true) || {};
    var ellipsis = truncateOpt.ellipsis;
    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
    // truncate rich text? (consider performance)

    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
      minChar: 2,
      placeholder: truncateOpt.placeholder
    }) : name;
    var tooltipOpt = axisModel.get('tooltip', true);
    var mainType = axisModel.mainType;
    var formatterParams = {
      componentType: mainType,
      name: name,
      $vars: ['name']
    };
    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'name',
      __fullText: name,
      __truncatedText: truncatedText,
      position: pos,
      rotation: labelLayout.rotation,
      silent: isSilent(axisModel),
      z2: 1,
      tooltip: tooltipOpt && tooltipOpt.show ? extend({
        content: name,
        formatter: function () {
          return name;
        },
        formatterParams: formatterParams
      }, tooltipOpt) : null
    });
    graphic.setTextStyle(textEl.style, textStyleModel, {
      text: truncatedText,
      textFont: textFont,
      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
      textAlign: labelLayout.textAlign,
      textVerticalAlign: labelLayout.textVerticalAlign
    });

    if (axisModel.get('triggerEvent')) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisName';
      textEl.eventData.name = name;
    } // FIXME


    this._dumbGroup.add(textEl);

    textEl.updateTransform();
    this.group.add(textEl);
    textEl.decomposeTransform();
  }
};
/**
 * @public
 * @static
 * @param {Object} opt
 * @param {number} axisRotation in radian
 * @param {number} textRotation in radian
 * @param {number} direction
 * @return {Object} {
 *  rotation, // according to axis
 *  textAlign,
 *  textVerticalAlign
 * }
 */

var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
  var rotationDiff = remRadian(textRotation - axisRotation);
  var textAlign;
  var textVerticalAlign;

  if (isRadianAroundZero(rotationDiff)) {
    // Label is parallel with axis line.
    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI)) {
    // Label is inverse parallel with axis line.
    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff > 0 && rotationDiff < PI) {
      textAlign = direction > 0 ? 'right' : 'left';
    } else {
      textAlign = direction > 0 ? 'left' : 'right';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
};

function endTextLayout(opt, textPosition, textRotate, extent) {
  var rotationDiff = remRadian(textRotate - opt.rotation);
  var textAlign;
  var textVerticalAlign;
  var inverse = extent[0] > extent[1];
  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;

  if (isRadianAroundZero(rotationDiff - PI / 2)) {
    textVerticalAlign = onLeft ? 'bottom' : 'top';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
    textVerticalAlign = onLeft ? 'top' : 'bottom';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
      textAlign = onLeft ? 'left' : 'right';
    } else {
      textAlign = onLeft ? 'right' : 'left';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

function isSilent(axisModel) {
  var tooltipOpt = axisModel.get('tooltip');
  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
}

function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
  // If min or max are user set, we need to check
  // If the tick on min(max) are overlap on their neighbour tick
  // If they are overlapped, we need to hide the min(max) tick label
  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
  // Have not consider onBand yet, where tick els is more than label els.

  labelEls = labelEls || [];
  tickEls = tickEls || [];
  var firstLabel = labelEls[0];
  var nextLabel = labelEls[1];
  var lastLabel = labelEls[labelEls.length - 1];
  var prevLabel = labelEls[labelEls.length - 2];
  var firstTick = tickEls[0];
  var nextTick = tickEls[1];
  var lastTick = tickEls[tickEls.length - 1];
  var prevTick = tickEls[tickEls.length - 2];

  if (showMinLabel === false) {
    ignoreEl(firstLabel);
    ignoreEl(firstTick);
  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
    if (showMinLabel) {
      ignoreEl(nextLabel);
      ignoreEl(nextTick);
    } else {
      ignoreEl(firstLabel);
      ignoreEl(firstTick);
    }
  }

  if (showMaxLabel === false) {
    ignoreEl(lastLabel);
    ignoreEl(lastTick);
  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
    if (showMaxLabel) {
      ignoreEl(prevLabel);
      ignoreEl(prevTick);
    } else {
      ignoreEl(lastLabel);
      ignoreEl(lastTick);
    }
  }
}

function ignoreEl(el) {
  el && (el.ignore = true);
}

function isTwoLabelOverlapped(current, next, labelLayout) {
  // current and next has the same rotation.
  var firstRect = current && current.getBoundingRect().clone();
  var nextRect = next && next.getBoundingRect().clone();

  if (!firstRect || !nextRect) {
    return;
  } // When checking intersect of two rotated labels, we use mRotationBack
  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.


  var mRotationBack = matrixUtil.identity([]);
  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
  return firstRect.intersect(nextRect);
}

function isNameLocationCenter(nameLocation) {
  return nameLocation === 'middle' || nameLocation === 'center';
}
/**
 * @static
 */


var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick = function (axis, i, interval, ticksCnt, showMinLabel, showMaxLabel) {
  if (i === 0 && showMinLabel || i === ticksCnt - 1 && showMaxLabel) {
    return false;
  } // FIXME
  // Have not consider label overlap (if label is too long) yet.


  var rawTick;
  var scale = axis.scale;
  return scale.type === 'ordinal' && (typeof interval === 'function' ? (rawTick = scale.getTicks()[i], !interval(rawTick, scale.getLabel(rawTick))) : i % (interval + 1));
};
/**
 * @static
 */


var getInterval = AxisBuilder.getInterval = function (model, labelInterval) {
  var interval = model.get('interval');

  if (interval == null || interval == 'auto') {
    interval = labelInterval;
  }

  return interval;
};

function buildAxisTick(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;

  if (!axisModel.get('axisTick.show') || axis.scale.isBlank()) {
    return;
  }

  var tickModel = axisModel.getModel('axisTick');
  var lineStyleModel = tickModel.getModel('lineStyle');
  var tickLen = tickModel.get('length');
  var tickInterval = getInterval(tickModel, opt.labelInterval);
  var ticksCoords = axis.getTicksCoords(tickModel.get('alignWithLabel')); // FIXME
  // Corresponds to ticksCoords ?

  var ticks = axis.scale.getTicks();
  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
  var pt1 = [];
  var pt2 = [];
  var matrix = axisBuilder._transform;
  var tickEls = [];
  var ticksCnt = ticksCoords.length;

  for (var i = 0; i < ticksCnt; i++) {
    // Only ordinal scale support tick interval
    if (ifIgnoreOnTick(axis, i, tickInterval, ticksCnt, showMinLabel, showMaxLabel)) {
      continue;
    }

    var tickCoord = ticksCoords[i];
    pt1[0] = tickCoord;
    pt1[1] = 0;
    pt2[0] = tickCoord;
    pt2[1] = opt.tickDirection * tickLen;

    if (matrix) {
      v2ApplyTransform(pt1, pt1, matrix);
      v2ApplyTransform(pt2, pt2, matrix);
    } // Tick line, Not use group transform to have better line draw


    var tickEl = new graphic.Line(graphic.subPixelOptimizeLine({
      // Id for animation
      anid: 'tick_' + ticks[i],
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: defaults(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get('axisLine.lineStyle.color')
      }),
      z2: 2,
      silent: true
    }));
    axisBuilder.group.add(tickEl);
    tickEls.push(tickEl);
  }

  return tickEls;
}

function buildAxisLabel(axisBuilder, axisModel, opt) {
  var axis = axisModel.axis;
  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));

  if (!show || axis.scale.isBlank()) {
    return;
  }

  var labelModel = axisModel.getModel('axisLabel');
  var labelMargin = labelModel.get('margin');
  var ticks = axis.scale.getTicks();
  var labels = axisModel.getFormattedLabels(); // Special label rotate.

  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
  var categoryData = axisModel.get('data');
  var labelEls = [];
  var silent = isSilent(axisModel);
  var triggerEvent = axisModel.get('triggerEvent');
  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
  each(ticks, function (tickVal, index) {
    if (ifIgnoreOnTick(axis, index, opt.labelInterval, ticks.length, showMinLabel, showMaxLabel)) {
      return;
    }

    var itemLabelModel = labelModel;

    if (categoryData && categoryData[tickVal] && categoryData[tickVal].textStyle) {
      itemLabelModel = new Model(categoryData[tickVal].textStyle, labelModel, axisModel.ecModel);
    }

    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
    var tickCoord = axis.dataToCoord(tickVal);
    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
    var labelStr = axis.scale.getLabel(tickVal);
    var textEl = new graphic.Text({
      // Id for animation
      anid: 'label_' + tickVal,
      position: pos,
      rotation: labelLayout.rotation,
      silent: silent,
      z2: 10
    });
    graphic.setTextStyle(textEl.style, itemLabelModel, {
      text: labels[index],
      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
      // index of axis.data. So tick should not be exposed to user
      // in category axis.
      // (2) Compatible with previous version, which always returns labelStr.
      // But in interval scale labelStr is like '223,445', which maked
      // user repalce ','. So we modify it to return original val but remain
      // it as 'string' to avoid error in replacing.
      axis.type === 'category' ? labelStr : axis.type === 'value' ? tickVal + '' : tickVal, index) : textColor
    }); // Pack data for mouse event

    if (triggerEvent) {
      textEl.eventData = makeAxisEventDataBase(axisModel);
      textEl.eventData.targetType = 'axisLabel';
      textEl.eventData.value = labelStr;
    } // FIXME


    axisBuilder._dumbGroup.add(textEl);

    textEl.updateTransform();
    labelEls.push(textEl);
    axisBuilder.group.add(textEl);
    textEl.decomposeTransform();
  });
  return labelEls;
}

var _default = AxisBuilder;
module.exports = _default;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(26);

var axisPointerModelHelper = __webpack_require__(208);

/**
 * Base class of AxisView.
 */
var AxisView = echarts.extendComponentView({
  type: 'axis',

  /**
   * @private
   */
  _axisPointer: null,

  /**
   * @protected
   * @type {string}
   */
  axisPointerClass: null,

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    // FIXME
    // This process should proformed after coordinate systems updated
    // (axis scale updated), and should be performed each time update.
    // So put it here temporarily, although it is not appropriate to
    // put a model-writing procedure in `view`.
    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
    AxisView.superApply(this, 'render', arguments);
    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
  },

  /**
   * Action handler.
   * @public
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/model/Global} ecModel
   * @param {module:echarts/ExtensionAPI} api
   * @param {Object} payload
   */
  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    var axisPointer = this._axisPointer;
    axisPointer && axisPointer.remove(api);
    AxisView.superApply(this, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    disposeAxisPointer(this, api);
    AxisView.superApply(this, 'dispose', arguments);
  }
});

function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);

  if (!Clazz) {
    return;
  }

  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
}

function disposeAxisPointer(axisView, ecModel, api) {
  var axisPointer = axisView._axisPointer;
  axisPointer && axisPointer.dispose(ecModel, api);
  axisView._axisPointer = null;
}

var axisPointerClazz = [];

AxisView.registerAxisPointerClass = function (type, clazz) {
  axisPointerClazz[type] = clazz;
};

AxisView.getAxisPointerClass = function (type) {
  return type && axisPointerClazz[type];
};

var _default = AxisView;
module.exports = _default;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

/**
 * @param {Object} opt {labelInside}
 * @return {Object} {
 *  position, rotation, labelDirection, labelOffset,
 *  tickDirection, labelRotate, labelInterval, z2
 * }
 */
function layout(gridModel, axisModel, opt) {
  opt = opt || {};
  var grid = gridModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var rawAxisPosition = axis.position;
  var axisPosition = axis.onZero ? 'onZero' : rawAxisPosition;
  var axisDim = axis.dim;
  var rect = grid.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var idx = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  };
  var axisOffset = axisModel.get('offset') || 0;
  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];

  if (axis.onZero) {
    var otherAxis = grid.getAxis(axisDim === 'x' ? 'y' : 'x', axis.onZeroAxisIndex);
    var onZeroCoord = otherAxis.toGlobalCoord(otherAxis.dataToCoord(0));
    posBound[idx['onZero']] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
  } // Axis position


  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation

  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim

  var dirMap = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
  layout.labelOffset = axis.onZero ? posBound[idx[rawAxisPosition]] - posBound[idx['onZero']] : 0;

  if (axisModel.get('axisTick.inside')) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
    layout.labelDirection = -layout.labelDirection;
  } // Special label rotation


  var labelRotate = axisModel.get('axisLabel.rotate');
  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // label interval when auto mode.

  layout.labelInterval = axis.getLabelInterval(); // Over splitLine and splitArea

  layout.z2 = 1;
  return layout;
}

exports.layout = layout;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var modelUtil = __webpack_require__(45);

/**
 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param {module:echarts/model/Global} ecModel
 * @return {Object} {point: [x, y], el: ...} point Will not be null.
 */
function _default(finder, ecModel) {
  var point = [];
  var seriesIndex = finder.seriesIndex;
  var seriesModel;

  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
    return {
      point: []
    };
  }

  var data = seriesModel.getData();
  var dataIndex = modelUtil.queryDataIndex(data, finder);

  if (dataIndex == null || zrUtil.isArray(dataIndex)) {
    return {
      point: []
    };
  }

  var el = data.getItemGraphicEl(dataIndex);
  var coordSys = seriesModel.coordinateSystem;

  if (seriesModel.getTooltipPosition) {
    point = seriesModel.getTooltipPosition(dataIndex) || [];
  } else if (coordSys && coordSys.dataToPoint) {
    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
      return seriesModel.coordDimToDataDim(dim)[0];
    }), dataIndex, true)) || [];
  } else if (el) {
    // Use graphic bounding rect
    var rect = el.getBoundingRect().clone();
    rect.applyTransform(el.transform);
    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }

  return {
    point: point,
    el: el
  };
}

module.exports = _default;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var env = __webpack_require__(64);

var modelUtil = __webpack_require__(45);

var get = modelUtil.makeGetter();
var each = zrUtil.each;
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */

function register(key, api, handler) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  get(zr).records || (get(zr).records = {});
  initGlobalListeners(zr, api);
  var record = get(zr).records[key] || (get(zr).records[key] = {});
  record.handler = handler;
}

function initGlobalListeners(zr, api) {
  if (get(zr).initialized) {
    return;
  }

  get(zr).initialized = true;
  useHandler('click', zrUtil.curry(doEnter, 'click'));
  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);

  useHandler('globalout', onLeave);

  function useHandler(eventType, cb) {
    zr.on(eventType, function (e) {
      var dis = makeDispatchAction(api);
      each(get(zr).records, function (record) {
        record && cb(record, e, dis.dispatchAction);
      });
      dispatchTooltipFinally(dis.pendings, api);
    });
  }
}

function dispatchTooltipFinally(pendings, api) {
  var showLen = pendings.showTip.length;
  var hideLen = pendings.hideTip.length;
  var actuallyPayload;

  if (showLen) {
    actuallyPayload = pendings.showTip[showLen - 1];
  } else if (hideLen) {
    actuallyPayload = pendings.hideTip[hideLen - 1];
  }

  if (actuallyPayload) {
    actuallyPayload.dispatchAction = null;
    api.dispatchAction(actuallyPayload);
  }
}

function onLeave(record, e, dispatchAction) {
  record.handler('leave', null, dispatchAction);
}

function doEnter(currTrigger, record, e, dispatchAction) {
  record.handler(currTrigger, e, dispatchAction);
}

function makeDispatchAction(api) {
  var pendings = {
    showTip: [],
    hideTip: []
  }; // FIXME
  // better approach?
  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
  // So we have to add "final stage" to merge those dispatched actions.

  var dispatchAction = function (payload) {
    var pendingList = pendings[payload.type];

    if (pendingList) {
      pendingList.push(payload);
    } else {
      payload.dispatchAction = dispatchAction;
      api.dispatchAction(payload);
    }
  };

  return {
    dispatchAction: dispatchAction,
    pendings: pendings
  };
}
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 */


function unregister(key, api) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  var record = (get(zr).records || {})[key];

  if (record) {
    get(zr).records[key] = null;
  }
}

exports.register = register;
exports.unregister = unregister;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

var textContain = __webpack_require__(112);

var formatUtil = __webpack_require__(71);

var matrix = __webpack_require__(127);

var axisHelper = __webpack_require__(137);

var AxisBuilder = __webpack_require__(465);

/**
 * @param {module:echarts/model/Model} axisPointerModel
 */
function buildElStyle(axisPointerModel) {
  var axisPointerType = axisPointerModel.get('type');
  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
  var style;

  if (axisPointerType === 'line') {
    style = styleModel.getLineStyle();
    style.fill = null;
  } else if (axisPointerType === 'shadow') {
    style = styleModel.getAreaStyle();
    style.stroke = null;
  }

  return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */


function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
  var value = axisPointerModel.get('value');
  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
    precision: axisPointerModel.get('label.precision'),
    formatter: axisPointerModel.get('label.formatter')
  });
  var labelModel = axisPointerModel.getModel('label');
  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
  var font = labelModel.getFont();
  var textRect = textContain.getBoundingRect(text, font);
  var position = labelPos.position;
  var width = textRect.width + paddings[1] + paddings[3];
  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.

  var align = labelPos.align;
  align === 'right' && (position[0] -= width);
  align === 'center' && (position[0] -= width / 2);
  var verticalAlign = labelPos.verticalAlign;
  verticalAlign === 'bottom' && (position[1] -= height);
  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container

  confineInContainer(position, width, height, api);
  var bgColor = labelModel.get('backgroundColor');

  if (!bgColor || bgColor === 'auto') {
    bgColor = axisModel.get('axisLine.lineStyle.color');
  }

  elOption.label = {
    shape: {
      x: 0,
      y: 0,
      width: width,
      height: height,
      r: labelModel.get('borderRadius')
    },
    position: position.slice(),
    // TODO: rich
    style: {
      text: text,
      textFont: font,
      textFill: labelModel.getTextColor(),
      textPosition: 'inside',
      fill: bgColor,
      stroke: labelModel.get('borderColor') || 'transparent',
      lineWidth: labelModel.get('borderWidth') || 0,
      shadowBlur: labelModel.get('shadowBlur'),
      shadowColor: labelModel.get('shadowColor'),
      shadowOffsetX: labelModel.get('shadowOffsetX'),
      shadowOffsetY: labelModel.get('shadowOffsetY')
    },
    // Lable should be over axisPointer.
    z2: 10
  };
} // Do not overflow ec container


function confineInContainer(position, width, height, api) {
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  position[0] = Math.min(position[0] + width, viewWidth) - width;
  position[1] = Math.min(position[1] + height, viewHeight) - height;
  position[0] = Math.max(position[0], 0);
  position[1] = Math.max(position[1], 0);
}
/**
 * @param {number} value
 * @param {module:echarts/coord/Axis} axis
 * @param {module:echarts/model/Global} ecModel
 * @param {Object} opt
 * @param {Array.<Object>} seriesDataIndices
 * @param {number|string} opt.precision 'auto' or a number
 * @param {string|Function} opt.formatter label formatter
 */


function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
  // helps to debounce when when moving label.
  value, {
    precision: opt.precision
  });
  var formatter = opt.formatter;

  if (formatter) {
    var params = {
      value: axisHelper.getAxisRawValue(axis, value),
      seriesData: []
    };
    zrUtil.each(seriesDataIndices, function (idxItem) {
      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
      var dataIndex = idxItem.dataIndexInside;
      var dataParams = series && series.getDataParams(dataIndex);
      dataParams && params.seriesData.push(dataParams);
    });

    if (zrUtil.isString(formatter)) {
      text = formatter.replace('{value}', text);
    } else if (zrUtil.isFunction(formatter)) {
      text = formatter(params);
    }
  }

  return text;
}
/**
 * @param {module:echarts/coord/Axis} axis
 * @param {number} value
 * @param {Object} layoutInfo {
 *  rotation, position, labelOffset, labelDirection, labelMargin
 * }
 */


function getTransformedPosition(axis, value, layoutInfo) {
  var transform = matrix.create();
  matrix.rotate(transform, transform, layoutInfo.rotation);
  matrix.translate(transform, transform, layoutInfo.position);
  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
}

function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
    align: textLayout.textAlign,
    verticalAlign: textLayout.textVerticalAlign
  });
}
/**
 * @param {Array.<number>} p1
 * @param {Array.<number>} p2
 * @param {number} [xDimIndex=0] or 1
 */


function makeLineShape(p1, p2, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x1: p1[xDimIndex],
    y1: p1[1 - xDimIndex],
    x2: p2[xDimIndex],
    y2: p2[1 - xDimIndex]
  };
}
/**
 * @param {Array.<number>} xy
 * @param {Array.<number>} wh
 * @param {number} [xDimIndex=0] or 1
 */


function makeRectShape(xy, wh, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x: xy[xDimIndex],
    y: xy[1 - xDimIndex],
    width: wh[xDimIndex],
    height: wh[1 - xDimIndex]
  };
}

function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r,
    startAngle: startAngle,
    endAngle: endAngle,
    clockwise: true
  };
}

exports.buildElStyle = buildElStyle;
exports.buildLabelElOption = buildLabelElOption;
exports.getValueLabel = getValueLabel;
exports.getTransformedPosition = getTransformedPosition;
exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
exports.makeLineShape = makeLineShape;
exports.makeRectShape = makeRectShape;
exports.makeSectorShape = makeSectorShape;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

__webpack_require__(475);

__webpack_require__(1048);

// Grid view
echarts.extendComponentView({
  type: 'grid',
  render: function (gridModel, ecModel) {
    this.group.removeAll();

    if (gridModel.get('show')) {
      this.group.add(new graphic.Rect({
        shape: gridModel.coordinateSystem.getRect(),
        style: zrUtil.defaults({
          fill: gridModel.get('backgroundColor')
        }, gridModel.getItemStyle()),
        silent: true,
        z2: -1
      }));
    }
  }
});
echarts.registerPreprocessor(function (option) {
  // Only create grid when need
  if (option.xAxis && option.yAxis && !option.grid) {
    option.grid = {};
  }
});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var numberUtil = __webpack_require__(48);

var axisHelper = __webpack_require__(137);

var linearMap = numberUtil.linearMap;

function fixExtentWithBands(extent, nTick) {
  var size = extent[1] - extent[0];
  var len = nTick;
  var margin = size / len / 2;
  extent[0] += margin;
  extent[1] -= margin;
}

var normalizedExtent = [0, 1];
/**
 * @name module:echarts/coord/CartesianAxis
 * @constructor
 */

var Axis = function (dim, scale, extent) {
  /**
   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'
   * @type {string}
   */
  this.dim = dim;
  /**
   * Axis scale
   * @type {module:echarts/coord/scale/*}
   */

  this.scale = scale;
  /**
   * @type {Array.<number>}
   * @private
   */

  this._extent = extent || [0, 0];
  /**
   * @type {boolean}
   */

  this.inverse = false;
  /**
   * Usually true when axis has a ordinal scale
   * @type {boolean}
   */

  this.onBand = false;
  /**
   * @private
   * @type {number}
   */

  this._labelInterval;
};

Axis.prototype = {
  constructor: Axis,

  /**
   * If axis extent contain given coord
   * @param {number} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var extent = this._extent;
    var min = Math.min(extent[0], extent[1]);
    var max = Math.max(extent[0], extent[1]);
    return coord >= min && coord <= max;
  },

  /**
   * If axis extent contain given data
   * @param {number} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.contain(this.dataToCoord(data));
  },

  /**
   * Get coord extent.
   * @return {Array.<number>}
   */
  getExtent: function () {
    return this._extent.slice();
  },

  /**
   * Get precision used for formatting
   * @param {Array.<number>} [dataExtent]
   * @return {number}
   */
  getPixelPrecision: function (dataExtent) {
    return numberUtil.getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
  },

  /**
   * Set coord extent
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var extent = this._extent;
    extent[0] = start;
    extent[1] = end;
  },

  /**
   * Convert data to coord. Data is the rank if it has a ordinal scale
   * @param {number} data
   * @param  {boolean} clamp
   * @return {number}
   */
  dataToCoord: function (data, clamp) {
    var extent = this._extent;
    var scale = this.scale;
    data = scale.normalize(data);

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    return linearMap(data, normalizedExtent, extent, clamp);
  },

  /**
   * Convert coord to data. Data is the rank if it has a ordinal scale
   * @param {number} coord
   * @param  {boolean} clamp
   * @return {number}
   */
  coordToData: function (coord, clamp) {
    var extent = this._extent;
    var scale = this.scale;

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    var t = linearMap(coord, extent, normalizedExtent, clamp);
    return this.scale.scale(t);
  },

  /**
   * Convert pixel point to data in axis
   * @param {Array.<number>} point
   * @param  {boolean} clamp
   * @return {number} data
   */
  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
  },

  /**
   * @return {Array.<number>}
   */
  getTicksCoords: function (alignWithLabel) {
    if (this.onBand && !alignWithLabel) {
      var bands = this.getBands();
      var coords = [];

      for (var i = 0; i < bands.length; i++) {
        coords.push(bands[i][0]);
      }

      if (bands[i - 1]) {
        coords.push(bands[i - 1][1]);
      }

      return coords;
    } else {
      return zrUtil.map(this.scale.getTicks(), this.dataToCoord, this);
    }
  },

  /**
   * Coords of labels are on the ticks or on the middle of bands
   * @return {Array.<number>}
   */
  getLabelsCoords: function () {
    return zrUtil.map(this.scale.getTicks(), this.dataToCoord, this);
  },

  /**
   * Get bands.
   *
   * If axis has labels [1, 2, 3, 4]. Bands on the axis are
   * |---1---|---2---|---3---|---4---|.
   *
   * @return {Array}
   */
  // FIXME Situation when labels is on ticks
  getBands: function () {
    var extent = this.getExtent();
    var bands = [];
    var len = this.scale.count();
    var start = extent[0];
    var end = extent[1];
    var span = end - start;

    for (var i = 0; i < len; i++) {
      bands.push([span * i / len + start, span * (i + 1) / len + start]);
    }

    return bands;
  },

  /**
   * Get width of band
   * @return {number}
   */
  getBandWidth: function () {
    var axisExtent = this._extent;
    var dataExtent = this.scale.getExtent();
    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.

    len === 0 && (len = 1);
    var size = Math.abs(axisExtent[1] - axisExtent[0]);
    return Math.abs(size) / len;
  },

  /**
   * @abstract
   * @return {boolean} Is horizontal
   */
  isHorizontal: null,

  /**
   * @abstract
   * @return {number} Get axis rotate, by degree.
   */
  getRotate: null,

  /**
   * Get interval of the axis label.
   * To get precise result, at least one of `getRotate` and `isHorizontal`
   * should be implemented.
   * @return {number}
   */
  getLabelInterval: function () {
    var labelInterval = this._labelInterval;

    if (!labelInterval) {
      var axisModel = this.model;
      var labelModel = axisModel.getModel('axisLabel');
      labelInterval = labelModel.get('interval');

      if (this.type === 'category' && (labelInterval == null || labelInterval === 'auto')) {
        labelInterval = axisHelper.getAxisLabelInterval(zrUtil.map(this.scale.getTicks(), this.dataToCoord, this), axisModel.getFormattedLabels(), labelModel.getFont(), this.getRotate ? this.getRotate() : this.isHorizontal && !this.isHorizontal() ? 90 : 0, labelModel.get('rotate'));
      }

      this._labelInterval = labelInterval;
    }

    return labelInterval;
  }
};
var _default = Axis;
module.exports = _default;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var axisHelper = __webpack_require__(137);

function getName(obj) {
  if (zrUtil.isObject(obj) && obj.value != null) {
    return obj.value;
  } else {
    return obj + '';
  }
}

var _default = {
  /**
   * Format labels
   * @return {Array.<string>}
   */
  getFormattedLabels: function () {
    return axisHelper.getFormattedLabels(this.axis, this.get('axisLabel.formatter'));
  },

  /**
   * Get categories
   */
  getCategories: function () {
    return this.get('type') === 'category' && zrUtil.map(this.get('data'), getName);
  },

  /**
   * @param {boolean} origin
   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
   */
  getMin: function (origin) {
    var option = this.option;
    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;

    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
      min = this.axis.scale.parse(min);
    }

    return min;
  },

  /**
   * @param {boolean} origin
   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
   */
  getMax: function (origin) {
    var option = this.option;
    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;

    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
      max = this.axis.scale.parse(max);
    }

    return max;
  },

  /**
   * @return {boolean}
   */
  getNeedCrossZero: function () {
    var option = this.option;
    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
  },

  /**
   * Should be implemented by each axis model if necessary.
   * @return {module:echarts/model/Component} coordinate system model
   */
  getCoordSysModel: zrUtil.noop,

  /**
   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
   */
  setRange: function (rangeStart, rangeEnd) {
    this.option.rangeStart = rangeStart;
    this.option.rangeEnd = rangeEnd;
  },

  /**
   * Reset range
   */
  resetRange: function () {
    // rangeStart and rangeEnd is readonly.
    this.option.rangeStart = this.option.rangeEnd = null;
  }
};
module.exports = _default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var ComponentModel = __webpack_require__(102);

var axisModelCreator = __webpack_require__(1066);

var axisModelCommonMixin = __webpack_require__(473);

var AxisModel = ComponentModel.extend({
  type: 'cartesian2dAxis',

  /**
   * @type {module:echarts/coord/cartesian/Axis2D}
   */
  axis: null,

  /**
   * @override
   */
  init: function () {
    AxisModel.superApply(this, 'init', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  mergeOption: function () {
    AxisModel.superApply(this, 'mergeOption', arguments);
    this.resetRange();
  },

  /**
   * @override
   */
  restoreData: function () {
    AxisModel.superApply(this, 'restoreData', arguments);
    this.resetRange();
  },

  /**
   * @override
   * @return {module:echarts/model/Component}
   */
  getCoordSysModel: function () {
    return this.ecModel.queryComponents({
      mainType: 'grid',
      index: this.option.gridIndex,
      id: this.option.gridId
    })[0];
  }
});

function getAxisType(axisDim, option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
var extraOption = {
  // gridIndex: 0,
  // gridId: '',
  // Offset is for multiple axis on the same position
  offset: 0
};
axisModelCreator('x', AxisModel, getAxisType, extraOption);
axisModelCreator('y', AxisModel, getAxisType, extraOption);
var _default = AxisModel;
module.exports = _default;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var BoundingRect = __webpack_require__(63);

var _layout = __webpack_require__(103);

var getLayoutRect = _layout.getLayoutRect;

var axisHelper = __webpack_require__(137);

var Cartesian2D = __webpack_require__(1069);

var Axis2D = __webpack_require__(1067);

var CoordinateSystem = __webpack_require__(298);

__webpack_require__(1070);

/**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */
// Depends on GridModel, AxisModel, which performs preprocess.
var each = zrUtil.each;
var ifAxisCrossZero = axisHelper.ifAxisCrossZero;
var niceScaleExtent = axisHelper.niceScaleExtent;
/**
 * Check if the axis is used in the specified grid
 * @inner
 */

function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
  return axisModel.getCoordSysModel() === gridModel;
}

function rotateTextRect(textRect, rotate) {
  var rotateRadians = rotate * Math.PI / 180;
  var boundingBox = textRect.plain();
  var beforeWidth = boundingBox.width;
  var beforeHeight = boundingBox.height;
  var afterWidth = beforeWidth * Math.cos(rotateRadians) + beforeHeight * Math.sin(rotateRadians);
  var afterHeight = beforeWidth * Math.sin(rotateRadians) + beforeHeight * Math.cos(rotateRadians);
  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
  return rotatedRect;
}

function getLabelUnionRect(axis) {
  var axisModel = axis.model;
  var labels = axisModel.getFormattedLabels();
  var axisLabelModel = axisModel.getModel('axisLabel');
  var rect;
  var step = 1;
  var labelCount = labels.length;

  if (labelCount > 40) {
    // Simple optimization for large amount of labels
    step = Math.ceil(labelCount / 40);
  }

  for (var i = 0; i < labelCount; i += step) {
    if (!axis.isLabelIgnored(i)) {
      var unrotatedSingleRect = axisLabelModel.getTextRect(labels[i]);
      var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
      rect ? rect.union(singleRect) : rect = singleRect;
    }
  }

  return rect;
}

function Grid(gridModel, ecModel, api) {
  /**
   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
   * @private
   */
  this._coordsMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
   * @private
   */

  this._coordsList = [];
  /**
   * @type {Object.<string, module:echarts/coord/cartesian/Axis2D>}
   * @private
   */

  this._axesMap = {};
  /**
   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
   * @private
   */

  this._axesList = [];

  this._initCartesian(gridModel, ecModel, api);

  this.model = gridModel;
}

var gridProto = Grid.prototype;
gridProto.type = 'grid';
gridProto.axisPointerEnabled = true;

gridProto.getRect = function () {
  return this._rect;
};

gridProto.update = function (ecModel, api) {
  var axesMap = this._axesMap;

  this._updateScale(ecModel, this.model);

  each(axesMap.x, function (xAxis) {
    niceScaleExtent(xAxis.scale, xAxis.model);
  });
  each(axesMap.y, function (yAxis) {
    niceScaleExtent(yAxis.scale, yAxis.model);
  });
  each(axesMap.x, function (xAxis) {
    fixAxisOnZero(axesMap, 'y', xAxis);
  });
  each(axesMap.y, function (yAxis) {
    fixAxisOnZero(axesMap, 'x', yAxis);
  }); // Resize again if containLabel is enabled
  // FIXME It may cause getting wrong grid size in data processing stage

  this.resize(this.model, api);
};

function fixAxisOnZero(axesMap, otherAxisDim, axis) {
  // onZero can not be enabled in these two situations:
  // 1. When any other axis is a category axis.
  // 2. When no axis is cross 0 point.
  var axes = axesMap[otherAxisDim];

  if (!axis.onZero) {
    return;
  }

  var onZeroAxisIndex = axis.onZeroAxisIndex; // If target axis is specified.

  if (onZeroAxisIndex != null) {
    var otherAxis = axes[onZeroAxisIndex];

    if (otherAxis && canNotOnZeroToAxis(otherAxis)) {
      axis.onZero = false;
    }

    return;
  }

  for (var idx in axes) {
    if (axes.hasOwnProperty(idx)) {
      var otherAxis = axes[idx];

      if (otherAxis && !canNotOnZeroToAxis(otherAxis)) {
        onZeroAxisIndex = +idx;
        break;
      }
    }
  }

  if (onZeroAxisIndex == null) {
    axis.onZero = false;
  }

  axis.onZeroAxisIndex = onZeroAxisIndex;
}

function canNotOnZeroToAxis(axis) {
  return axis.type === 'category' || axis.type === 'time' || !ifAxisCrossZero(axis);
}
/**
 * Resize the grid
 * @param {module:echarts/coord/cartesian/GridModel} gridModel
 * @param {module:echarts/ExtensionAPI} api
 */


gridProto.resize = function (gridModel, api, ignoreContainLabel) {
  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
  this._rect = gridRect;
  var axesList = this._axesList;
  adjustAxes(); // Minus label size

  if (!ignoreContainLabel && gridModel.get('containLabel')) {
    each(axesList, function (axis) {
      if (!axis.model.get('axisLabel.inside')) {
        var labelUnionRect = getLabelUnionRect(axis);

        if (labelUnionRect) {
          var dim = axis.isHorizontal() ? 'height' : 'width';
          var margin = axis.model.get('axisLabel.margin');
          gridRect[dim] -= labelUnionRect[dim] + margin;

          if (axis.position === 'top') {
            gridRect.y += labelUnionRect.height + margin;
          } else if (axis.position === 'left') {
            gridRect.x += labelUnionRect.width + margin;
          }
        }
      }
    });
    adjustAxes();
  }

  function adjustAxes() {
    each(axesList, function (axis) {
      var isHorizontal = axis.isHorizontal();
      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(extent[idx], extent[1 - idx]);
      updateAxisTransfrom(axis, isHorizontal ? gridRect.x : gridRect.y);
    });
  }
};
/**
 * @param {string} axisType
 * @param {number} [axisIndex]
 */


gridProto.getAxis = function (axisType, axisIndex) {
  var axesMapOnDim = this._axesMap[axisType];

  if (axesMapOnDim != null) {
    if (axisIndex == null) {
      // Find first axis
      for (var name in axesMapOnDim) {
        if (axesMapOnDim.hasOwnProperty(name)) {
          return axesMapOnDim[name];
        }
      }
    }

    return axesMapOnDim[axisIndex];
  }
};
/**
 * @return {Array.<module:echarts/coord/Axis>}
 */


gridProto.getAxes = function () {
  return this._axesList.slice();
};
/**
 * Usage:
 *      grid.getCartesian(xAxisIndex, yAxisIndex);
 *      grid.getCartesian(xAxisIndex);
 *      grid.getCartesian(null, yAxisIndex);
 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
 *
 * @param {number|Object} [xAxisIndex]
 * @param {number} [yAxisIndex]
 */


gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
  if (xAxisIndex != null && yAxisIndex != null) {
    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
    return this._coordsMap[key];
  }

  if (zrUtil.isObject(xAxisIndex)) {
    yAxisIndex = xAxisIndex.yAxisIndex;
    xAxisIndex = xAxisIndex.xAxisIndex;
  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.


  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
      return coordList[i];
    }
  }
};

gridProto.getCartesians = function () {
  return this._coordsList.slice();
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertToPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.convertFromPixel = function (ecModel, finder, value) {
  var target = this._findConvertTarget(ecModel, finder);

  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
};
/**
 * @inner
 */


gridProto._findConvertTarget = function (ecModel, finder) {
  var seriesModel = finder.seriesModel;
  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
  var gridModel = finder.gridModel;
  var coordsList = this._coordsList;
  var cartesian;
  var axis;

  if (seriesModel) {
    cartesian = seriesModel.coordinateSystem;
    zrUtil.indexOf(coordsList, cartesian) < 0 && (cartesian = null);
  } else if (xAxisModel && yAxisModel) {
    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  } else if (xAxisModel) {
    axis = this.getAxis('x', xAxisModel.componentIndex);
  } else if (yAxisModel) {
    axis = this.getAxis('y', yAxisModel.componentIndex);
  } // Lowest priority.
  else if (gridModel) {
      var grid = gridModel.coordinateSystem;

      if (grid === this) {
        cartesian = this._coordsList[0];
      }
    }

  return {
    cartesian: cartesian,
    axis: axis
  };
};
/**
 * @implements
 * see {module:echarts/CoodinateSystem}
 */


gridProto.containPoint = function (point) {
  var coord = this._coordsList[0];

  if (coord) {
    return coord.containPoint(point);
  }
};
/**
 * Initialize cartesian coordinate systems
 * @private
 */


gridProto._initCartesian = function (gridModel, ecModel, api) {
  var axisPositionUsed = {
    left: false,
    right: false,
    top: false,
    bottom: false
  };
  var axesMap = {
    x: {},
    y: {}
  };
  var axesCount = {
    x: 0,
    y: 0
  }; /// Create axis

  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);

  if (!axesCount.x || !axesCount.y) {
    // Roll back when there no either x or y axis
    this._axesMap = {};
    this._axesList = [];
    return;
  }

  this._axesMap = axesMap; /// Create cartesian2d

  each(axesMap.x, function (xAxis, xAxisIndex) {
    each(axesMap.y, function (yAxis, yAxisIndex) {
      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
      var cartesian = new Cartesian2D(key);
      cartesian.grid = this;
      cartesian.model = gridModel;
      this._coordsMap[key] = cartesian;

      this._coordsList.push(cartesian);

      cartesian.addAxis(xAxis);
      cartesian.addAxis(yAxis);
    }, this);
  }, this);

  function createAxisCreator(axisType) {
    return function (axisModel, idx) {
      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
        return;
      }

      var axisPosition = axisModel.get('position');

      if (axisType === 'x') {
        // Fix position
        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
          // Default bottom of X
          axisPosition = 'bottom';

          if (axisPositionUsed[axisPosition]) {
            axisPosition = axisPosition === 'top' ? 'bottom' : 'top';
          }
        }
      } else {
        // Fix position
        if (axisPosition !== 'left' && axisPosition !== 'right') {
          // Default left of Y
          axisPosition = 'left';

          if (axisPositionUsed[axisPosition]) {
            axisPosition = axisPosition === 'left' ? 'right' : 'left';
          }
        }
      }

      axisPositionUsed[axisPosition] = true;
      var axis = new Axis2D(axisType, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse');
      axis.onZero = axisModel.get('axisLine.onZero');
      axis.onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex'); // Inject axis into axisModel

      axisModel.axis = axis; // Inject axisModel into axis

      axis.model = axisModel; // Inject grid info axis

      axis.grid = this; // Index of axis, can be used as key

      axis.index = idx;

      this._axesList.push(axis);

      axesMap[axisType][idx] = axis;
      axesCount[axisType]++;
    };
  }
};
/**
 * Update cartesian properties from series
 * @param  {module:echarts/model/Option} option
 * @private
 */


gridProto._updateScale = function (ecModel, gridModel) {
  // Reset scale
  zrUtil.each(this._axesList, function (axis) {
    axis.scale.setExtent(Infinity, -Infinity);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (isCartesian2D(seriesModel)) {
      var axesModels = findAxesModels(seriesModel, ecModel);
      var xAxisModel = axesModels[0];
      var yAxisModel = axesModels[1];

      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
        return;
      }

      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
      var data = seriesModel.getData();
      var xAxis = cartesian.getAxis('x');
      var yAxis = cartesian.getAxis('y');

      if (data.type === 'list') {
        unionExtent(data, xAxis, seriesModel);
        unionExtent(data, yAxis, seriesModel);
      }
    }
  }, this);

  function unionExtent(data, axis, seriesModel) {
    each(seriesModel.coordDimToDataDim(axis.dim), function (dim) {
      axis.scale.unionExtentFromData(data, dim);
    });
  }
};
/**
 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
 * @return {Object} {baseAxes: [], otherAxes: []}
 */


gridProto.getTooltipAxes = function (dim) {
  var baseAxes = [];
  var otherAxes = [];
  each(this.getCartesians(), function (cartesian) {
    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
    var otherAxis = cartesian.getOtherAxis(baseAxis);
    zrUtil.indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
    zrUtil.indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
  });
  return {
    baseAxes: baseAxes,
    otherAxes: otherAxes
  };
};
/**
 * @inner
 */


function updateAxisTransfrom(axis, coordBase) {
  var axisExtent = axis.getExtent();
  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform

  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
    return coord + coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
    return coord - coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
}

var axesTypes = ['xAxis', 'yAxis'];
/**
 * @inner
 */

function findAxesModels(seriesModel, ecModel) {
  return zrUtil.map(axesTypes, function (axisType) {
    var axisModel = seriesModel.getReferringComponents(axisType)[0];
    return axisModel;
  });
}
/**
 * @inner
 */


function isCartesian2D(seriesModel) {
  return seriesModel.get('coordinateSystem') === 'cartesian2d';
}

Grid.create = function (ecModel, api) {
  var grids = [];
  ecModel.eachComponent('grid', function (gridModel, idx) {
    var grid = new Grid(gridModel, ecModel, api);
    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
    // should be performed in create stage.

    grid.resize(gridModel, api, true);
    gridModel.coordinateSystem = grid;
    grids.push(grid);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (!isCartesian2D(seriesModel)) {
      return;
    }

    var axesModels = findAxesModels(seriesModel, ecModel);
    var xAxisModel = axesModels[0];
    var yAxisModel = axesModels[1];
    var gridModel = xAxisModel.getCoordSysModel();
    var grid = gridModel.coordinateSystem;
    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
  });
  return grids;
}; // For deciding which dimensions to use when creating list data


Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
CoordinateSystem.register('cartesian2d', Grid);
var _default = Grid;
module.exports = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var _clazz = __webpack_require__(92);

var set = _clazz.set;
var get = _clazz.get;
var _default = {
  clearColorPalette: function () {
    set(this, 'colorIdx', 0);
    set(this, 'colorNameMap', {});
  },
  getColorFromPalette: function (name, scope) {
    scope = scope || this;
    var colorIdx = get(scope, 'colorIdx') || 0;
    var colorNameMap = get(scope, 'colorNameMap') || set(scope, 'colorNameMap', {}); // Use `hasOwnProperty` to avoid conflict with Object.prototype.

    if (colorNameMap.hasOwnProperty(name)) {
      return colorNameMap[name];
    }

    var colorPalette = this.get('color', true) || [];

    if (!colorPalette.length) {
      return;
    }

    var color = colorPalette[colorIdx];

    if (name) {
      colorNameMap[name] = color;
    }

    set(scope, 'colorIdx', (colorIdx + 1) % colorPalette.length);
    return color;
  }
};
module.exports = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var numberUtil = __webpack_require__(48);

/**
 * For testable.
 */
var roundNumber = numberUtil.round;
/**
 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
 *                                Should be extent[0] < extent[1].
 * @param {number} splitNumber splitNumber should be >= 1.
 * @param {number} [minInterval]
 * @param {number} [maxInterval]
 * @return {Object} {interval, intervalPrecision, niceTickExtent}
 */

function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
  var result = {};
  var span = extent[1] - extent[0];
  var interval = result.interval = numberUtil.nice(span / splitNumber, true);

  if (minInterval != null && interval < minInterval) {
    interval = result.interval = minInterval;
  }

  if (maxInterval != null && interval > maxInterval) {
    interval = result.interval = maxInterval;
  } // Tow more digital for tick.


  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent

  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
  fixExtent(niceTickExtent, extent);
  return result;
}
/**
 * @param {number} interval
 * @return {number} interval precision
 */


function getIntervalPrecision(interval) {
  // Tow more digital for tick.
  return numberUtil.getPrecisionSafe(interval) + 2;
}

function clamp(niceTickExtent, idx, extent) {
  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.


function fixExtent(niceTickExtent, extent) {
  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
  clamp(niceTickExtent, 0, extent);
  clamp(niceTickExtent, 1, extent);

  if (niceTickExtent[0] > niceTickExtent[1]) {
    niceTickExtent[0] = niceTickExtent[1];
  }
}

function intervalScaleGetTicks(interval, extent, niceTickExtent, intervalPrecision) {
  var ticks = []; // If interval is 0, return [];

  if (!interval) {
    return ticks;
  } // Consider this case: using dataZoom toolbox, zoom and zoom.


  var safeLimit = 10000;

  if (extent[0] < niceTickExtent[0]) {
    ticks.push(extent[0]);
  }

  var tick = niceTickExtent[0];

  while (tick <= niceTickExtent[1]) {
    ticks.push(tick); // Avoid rounding error

    tick = roundNumber(tick + interval, intervalPrecision);

    if (tick === ticks[ticks.length - 1]) {
      // Consider out of safe float point, e.g.,
      // -3711126.9907707 + 2e-10 === -3711126.9907707
      break;
    }

    if (ticks.length > safeLimit) {
      return [];
    }
  } // Consider this case: the last item of ticks is smaller
  // than niceTickExtent[1] and niceTickExtent[1] === extent[1].


  if (extent[1] > (ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1])) {
    ticks.push(extent[1]);
  }

  return ticks;
}

exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
exports.getIntervalPrecision = getIntervalPrecision;
exports.fixExtent = fixExtent;
exports.intervalScaleGetTicks = intervalScaleGetTicks;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(49);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1140);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(863);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(1157);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1163);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1162);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(487);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1172);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1171);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(492);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(492);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1174);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1173);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1182);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1181);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1199);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1200);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1198);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(500);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(500);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1202);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1201);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["l"] = argumentContainer;
/* harmony export (immutable) */ __webpack_exports__["b"] = getValueFromEvent;
/* harmony export (immutable) */ __webpack_exports__["m"] = getErrorStrs;
/* harmony export (immutable) */ __webpack_exports__["i"] = isEmptyObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = flattenArray;
/* harmony export (immutable) */ __webpack_exports__["a"] = mirror;
/* harmony export (immutable) */ __webpack_exports__["d"] = hasRules;
/* unused harmony export startsWith */
/* harmony export (immutable) */ __webpack_exports__["k"] = getParams;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNameIfNested;
/* harmony export (immutable) */ __webpack_exports__["j"] = flatFieldNames;
/* harmony export (immutable) */ __webpack_exports__["h"] = clearVirtualField;
/* harmony export (immutable) */ __webpack_exports__["g"] = getVirtualPaths;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeValidateRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics__);



function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return __WEBPACK_IMPORTED_MODULE_1_hoist_non_react_statics___default()(Container, WrappedComponent);
}

function getValueFromEvent(e) {
  // support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function mirror(obj) {
  return obj;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return !!item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var callback = cb;
  var options = opt;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(ns)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    callback: callback,
    options: options
  };
}

var NAME_KEY_SEP = '.';
var NAME_INDEX_OPEN_SEP = '[';

function getNameIfNested(str) {
  var keyIndex = str.indexOf(NAME_KEY_SEP);
  var arrayIndex = str.indexOf(NAME_INDEX_OPEN_SEP);

  var index = void 0;

  if (keyIndex === -1 && arrayIndex === -1) {
    return {
      name: str
    };
  } else if (keyIndex === -1) {
    index = arrayIndex;
  } else if (arrayIndex === -1) {
    index = keyIndex;
  } else {
    index = Math.min(keyIndex, arrayIndex);
  }

  return {
    name: str.slice(0, index),
    isNested: true
  };
}

function flatFieldNames(names) {
  var ret = {};
  names.forEach(function (n) {
    ret[getNameIfNested(n).name] = 1;
  });
  return Object.keys(ret);
}

function clearVirtualField(name, fields, fieldsMeta) {
  if (fieldsMeta[name] && fieldsMeta[name].virtual) {
    /* eslint no-loop-func:0 */
    Object.keys(fields).forEach(function (ok) {
      if (getNameIfNested(ok).name === name) {
        delete fields[ok];
      }
    });
  }
}

function getVirtualPaths(fieldsMeta) {
  var virtualPaths = {};
  Object.keys(fieldsMeta).forEach(function (name) {
    var leadingName = fieldsMeta[name].leadingName;
    if (leadingName && fieldsMeta[leadingName].virtual) {
      if (leadingName in virtualPaths) {
        virtualPaths[leadingName].push(name);
      } else {
        virtualPaths[leadingName] = [name];
      }
    }
  });
  return virtualPaths;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(503);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 505 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 506 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1237);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1238),
    hasPath = __webpack_require__(1248);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(1241);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1281);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1280);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1293);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1292);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(513);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(513);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1306);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1305);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(519);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(519);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1308);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1307);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(174);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(72);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(172);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(74);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(73);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(175);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Handle = function (_React$Component) {
  (0, _inherits3['default'])(Handle, _React$Component);

  function Handle() {
    (0, _classCallCheck3['default'])(this, Handle);
    return (0, _possibleConstructorReturn3['default'])(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  (0, _createClass3['default'])(Handle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          vertical = _props.vertical,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value']);


      var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
      var elStyle = (0, _extends3['default'])({}, style, postionStyle);
      var ariaProps = {};
      if (value !== undefined) {
        ariaProps = (0, _extends3['default'])({}, ariaProps, {
          'aria-valuemin': min,
          'aria-valuemax': max,
          'aria-valuenow': value,
          'aria-disabled': !!disabled
        });
      }
      return _react2['default'].createElement('div', (0, _extends3['default'])({
        role: 'slider'
      }, ariaProps, restProps, {
        className: className,
        style: elStyle
      }));
    }
  }]);
  return Handle;
}(_react2['default'].Component);

exports['default'] = Handle;


Handle.propTypes = {
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  offset: _propTypes2['default'].number,
  style: _propTypes2['default'].object,
  disabled: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  value: _propTypes2['default'].number
};
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Track = function Track(props) {
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style;


  var positonStyle = vertical ? {
    bottom: offset + '%',
    height: length + '%'
  } : {
    left: offset + '%',
    width: length + '%'
  };

  var elStyle = (0, _extends3['default'])({
    visibility: included ? 'visible' : 'hidden'
  }, style, positonStyle);
  return _react2['default'].createElement('div', { className: className, style: elStyle });
}; /* eslint-disable react/prop-types */
exports['default'] = Track;
module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(174);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(173);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(72);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(172);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(74);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(1324);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(73);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createSlider;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(175);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(542);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _Steps = __webpack_require__(1314);

var _Steps2 = _interopRequireDefault(_Steps);

var _Marks = __webpack_require__(1313);

var _Marks2 = _interopRequireDefault(_Marks);

var _Handle = __webpack_require__(520);

var _Handle2 = _interopRequireDefault(_Handle);

var _utils = __webpack_require__(325);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3['default'])(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      (0, _classCallCheck3['default'])(this, ComponentEnhancer);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = utils.getMousePosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentMouseEvents();
        utils.pauseEvent(e);
      };

      _this.onTouchStart = function (e) {
        if (utils.isNotTouchEvent(e)) return;

        var isVertical = _this.props.vertical;
        var position = utils.getTouchPosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        utils.pauseEvent(e);
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = utils.getMousePosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = utils.getTouchPosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        (0, _warning2['default'])(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }
      _this.handlesRefs = {};
      return _this;
    }

    (0, _createClass3['default'])(ComponentEnhancer, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = (0, _addEventListener2['default'])(document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = (0, _addEventListener2['default'])(document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = (0, _addEventListener2['default'])(document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var rect = slider.getBoundingClientRect();

        return this.props.vertical ? rect.top : rect.left;
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props = this.props,
            vertical = _props.vertical,
            min = _props.min,
            max = _props.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props2 = this.props,
            min = _props2.min,
            max = _props2.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props3 = this.props,
            prefixCls = _props3.prefixCls,
            className = _props3.className,
            marks = _props3.marks,
            dots = _props3.dots,
            step = _props3.step,
            included = _props3.included,
            disabled = _props3.disabled,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max,
            children = _props3.children,
            maximumTrackStyle = _props3.maximumTrackStyle,
            style = _props3.style,
            railStyle = _props3.railStyle,
            dotStyle = _props3.dotStyle,
            activeDotStyle = _props3.activeDotStyle;

        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
        return _react2['default'].createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            style: style
          },
          _react2['default'].createElement('div', {
            className: prefixCls + '-rail',
            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          _react2['default'].createElement(_Steps2['default'], {
            prefixCls: prefixCls,
            vertical: vertical,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          _react2['default'].createElement(_Marks2['default'], {
            className: prefixCls + '-mark',
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min
          }),
          children
        );
      }
    }]);
    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
    min: _propTypes2['default'].number,
    max: _propTypes2['default'].number,
    step: _propTypes2['default'].number,
    marks: _propTypes2['default'].object,
    included: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    prefixCls: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    children: _propTypes2['default'].any,
    onBeforeChange: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onAfterChange: _propTypes2['default'].func,
    handle: _propTypes2['default'].func,
    dots: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    style: _propTypes2['default'].object,
    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    railStyle: _propTypes2['default'].object,
    dotStyle: _propTypes2['default'].object,
    activeDotStyle: _propTypes2['default'].object
  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);

      delete restProps.dragging;
      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}
module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1316);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1331)();
}


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1347);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1346);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1365);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1371);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1370);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(328);









var TabPane = __WEBPACK_IMPORTED_MODULE_5_create_react_class___default()({
  displayName: 'TabPane',
  propTypes: {
    className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    forceRender: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    placeholder: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
  },
  getDefaultProps: function getDefaultProps() {
    return { placeholder: null };
  },
  render: function render() {
    var _classnames;

    var _props = this.props,
        className = _props.className,
        destroyInactiveTabPane = _props.destroyInactiveTabPane,
        active = _props.active,
        forceRender = _props.forceRender,
        rootPrefixCls = _props.rootPrefixCls,
        style = _props.style,
        children = _props.children,
        placeholder = _props.placeholder,
        restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);

    this._isActived = this._isActived || active;
    var prefixCls = rootPrefixCls + '-tabpane';
    var cls = __WEBPACK_IMPORTED_MODULE_6_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-inactive', !active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, className), _classnames));
    var isRender = destroyInactiveTabPane ? active : this._isActived;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        style: style,
        role: 'tabpanel',
        'aria-hidden': active ? 'false' : 'true',
        className: cls
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["e" /* getDataAttr */])(restProps)),
      isRender || forceRender ? children : placeholder
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TabPane);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabPane__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabContent__ = __webpack_require__(1373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_1__TabPane__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabContent", function() { return __WEBPACK_IMPORTED_MODULE_2__TabContent__["a"]; });




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getScroll = getScroll;

var _utils = __webpack_require__(177);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(18);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isDev = "production" !== 'production';

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function offset(elem) {
  var box = void 0;
  var x = void 0;
  var y = void 0;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x = box.left;
  y = box.top;
  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  var w = doc.defaultView || doc.parentWindow;
  x += getScroll(w);
  y += getScroll(w, true);
  return {
    left: x, top: y
  };
}

function _componentDidUpdate(component, init) {
  var styles = component.props.styles;

  var wrapNode = component.nav || component.root;
  var containerOffset = offset(wrapNode);
  var inkBarNode = component.inkBar;
  var activeTab = component.activeTab;
  var inkBarNodeStyle = inkBarNode.style;
  var tabBarPosition = component.props.tabBarPosition;
  if (init) {
    // prevent mount animation
    inkBarNodeStyle.display = 'none';
  }
  if (activeTab) {
    var tabNode = activeTab;
    var tabOffset = offset(tabNode);
    var transformSupported = (0, _utils.isTransformSupported)(inkBarNodeStyle);
    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
      var left = tabOffset.left - containerOffset.left;
      var width = tabNode.offsetWidth;

      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
      // It means no css working, then ink bar should not have width until css is loaded
      // Fix https://github.com/ant-design/ant-design/issues/7564
      if (width === wrapNode.offsetWidth) {
        width = 0;
      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
        width = parseFloat(styles.inkBar.width, 10);
        if (width) {
          left = left + (tabNode.offsetWidth - width) / 2;
        }
      }
      // use 3d gpu to optimize render
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
        inkBarNodeStyle.width = width + 'px';
        inkBarNodeStyle.height = '';
      } else {
        inkBarNodeStyle.left = left + 'px';
        inkBarNodeStyle.top = '';
        inkBarNodeStyle.bottom = '';
        inkBarNodeStyle.right = wrapNode.offsetWidth - left - width + 'px';
      }
    } else {
      var top = tabOffset.top - containerOffset.top;
      var height = tabNode.offsetHeight;
      if (styles.inkBar && styles.inkBar.height !== undefined) {
        height = parseFloat(styles.inkBar.height, 10);
        if (height) {
          top = top + (tabNode.offsetHeight - height) / 2;
        }
      }
      if (transformSupported) {
        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
        inkBarNodeStyle.height = height + 'px';
        inkBarNodeStyle.width = '';
      } else {
        inkBarNodeStyle.left = '';
        inkBarNodeStyle.right = '';
        inkBarNodeStyle.top = top + 'px';
        inkBarNodeStyle.bottom = wrapNode.offsetHeight - top - height + 'px';
      }
    }
  }
  inkBarNodeStyle.display = activeTab ? 'block' : 'none';
}

exports['default'] = {
  getDefaultProps: function getDefaultProps() {
    return {
      inkBarAnimated: true
    };
  },
  componentDidUpdate: function componentDidUpdate() {
    _componentDidUpdate(this);
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    if (isDev) {
      // https://github.com/ant-design/ant-design/issues/8678
      this.timeout = setTimeout(function () {
        _componentDidUpdate(_this, true);
      }, 0);
    } else {
      _componentDidUpdate(this, true);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    clearTimeout(this.timeout);
  },
  getInkBarNode: function getInkBarNode() {
    var _classnames;

    var _props = this.props,
        prefixCls = _props.prefixCls,
        styles = _props.styles,
        inkBarAnimated = _props.inkBarAnimated;

    var className = prefixCls + '-ink-bar';
    var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
    return _react2['default'].createElement('div', {
      style: styles.inkBar,
      className: classes,
      key: 'inkBar',
      ref: this.saveRef('inkBar')
    });
  }
};

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1384);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1383);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1397);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1396);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PressEvent__ = __webpack_require__(1404);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// inspired by react-native



function keyMirror(obj) {
    Object.keys(obj).forEach(function (k) {
        return obj[k] = k;
    });
    return obj;
}
function copy(from, list) {
    var to = {};
    list.forEach(function (k) {
        to[k] = from[k];
    });
    return to;
}
function extractSingleTouch(_nativeEvent) {
    var nativeEvent = _nativeEvent;
    if (nativeEvent.nativeEvent) {
        nativeEvent = nativeEvent.nativeEvent;
    }
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;
    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
}
/**
 * Touchable states.
 */
var States = keyMirror({
    NOT_RESPONDER: null,
    RESPONDER_INACTIVE_PRESS_IN: null,
    RESPONDER_INACTIVE_PRESS_OUT: null,
    RESPONDER_ACTIVE_PRESS_IN: null,
    RESPONDER_ACTIVE_PRESS_OUT: null,
    RESPONDER_ACTIVE_LONG_PRESS_IN: null,
    RESPONDER_ACTIVE_LONG_PRESS_OUT: null,
    ERROR: null
});
/**
 * Quick lookup map for states that are considered to be "active"
 */
var IsActive = {
    RESPONDER_ACTIVE_PRESS_OUT: true,
    RESPONDER_ACTIVE_PRESS_IN: true
};
/**
 * Quick lookup for states that are considered to be "pressing" and are
 * therefore eligible to result in a "selection" if the press stops.
 */
var IsPressingIn = {
    RESPONDER_INACTIVE_PRESS_IN: true,
    RESPONDER_ACTIVE_PRESS_IN: true,
    RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
var IsLongPressingIn = {
    RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
/**
 * Inputs to the state machine.
 */
var Signals = keyMirror({
    DELAY: null,
    RESPONDER_GRANT: null,
    RESPONDER_RELEASE: null,
    RESPONDER_TERMINATED: null,
    ENTER_PRESS_RECT: null,
    LEAVE_PRESS_RECT: null,
    LONG_PRESS_DETECTED: null
});
/**
 * Mapping from States x Signals => States
 */
var Transitions = {
    NOT_RESPONDER: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
        RESPONDER_RELEASE: States.ERROR,
        RESPONDER_TERMINATED: States.ERROR,
        ENTER_PRESS_RECT: States.ERROR,
        LEAVE_PRESS_RECT: States.ERROR,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_INACTIVE_PRESS_IN: {
        DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_INACTIVE_PRESS_OUT: {
        DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_ACTIVE_PRESS_IN: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
    },
    RESPONDER_ACTIVE_PRESS_OUT: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    RESPONDER_ACTIVE_LONG_PRESS_IN: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
        LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
    },
    RESPONDER_ACTIVE_LONG_PRESS_OUT: {
        DELAY: States.ERROR,
        RESPONDER_GRANT: States.ERROR,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
        LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
        LONG_PRESS_DETECTED: States.ERROR
    },
    error: {
        DELAY: States.NOT_RESPONDER,
        RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
        RESPONDER_RELEASE: States.NOT_RESPONDER,
        RESPONDER_TERMINATED: States.NOT_RESPONDER,
        ENTER_PRESS_RECT: States.NOT_RESPONDER,
        LEAVE_PRESS_RECT: States.NOT_RESPONDER,
        LONG_PRESS_DETECTED: States.NOT_RESPONDER
    }
};
// ==== Typical Constants for integrating into UI components ====
// const HIT_EXPAND_PX = 20;
// const HIT_VERT_OFFSET_PX = 10;
var HIGHLIGHT_DELAY_MS = 130;
var PRESS_EXPAND_PX = 20;
var LONG_PRESS_THRESHOLD = 500;
var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
var LONG_PRESS_ALLOWED_MOVEMENT = 10;
var lastClickTime = 0;
var pressDelay = 200;
function isAllowPress() {
    // avoid click penetration
    return Date.now() - lastClickTime >= pressDelay;
}

var Touchable = function (_React$Component) {
    _inherits(Touchable, _React$Component);

    function Touchable() {
        _classCallCheck(this, Touchable);

        var _this = _possibleConstructorReturn(this, (Touchable.__proto__ || Object.getPrototypeOf(Touchable)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.touchable = { touchState: undefined };
        _this.onTouchStart = function (e) {
            _this.callChildEvent('onTouchStart', e);
            _this.lockMouse = true;
            if (_this.releaseLockTimer) {
                clearTimeout(_this.releaseLockTimer);
            }
            _this.touchableHandleResponderGrant(e.nativeEvent);
        };
        _this.onTouchMove = function (e) {
            _this.callChildEvent('onTouchMove', e);
            _this.touchableHandleResponderMove(e.nativeEvent);
        };
        _this.onTouchEnd = function (e) {
            _this.callChildEvent('onTouchEnd', e);
            _this.releaseLockTimer = setTimeout(function () {
                _this.lockMouse = false;
            }, 300);
            _this.touchableHandleResponderRelease(new __WEBPACK_IMPORTED_MODULE_2__PressEvent__["a" /* default */](e.nativeEvent));
        };
        _this.onTouchCancel = function (e) {
            _this.callChildEvent('onTouchCancel', e);
            _this.releaseLockTimer = setTimeout(function () {
                _this.lockMouse = false;
            }, 300);
            _this.touchableHandleResponderTerminate(e.nativeEvent);
        };
        _this.onMouseDown = function (e) {
            _this.callChildEvent('onMouseDown', e);
            if (_this.lockMouse) {
                return;
            }
            _this.touchableHandleResponderGrant(e.nativeEvent);
            document.addEventListener('mousemove', _this.touchableHandleResponderMove, false);
            document.addEventListener('mouseup', _this.onMouseUp, false);
        };
        _this.onMouseUp = function (e) {
            document.removeEventListener('mousemove', _this.touchableHandleResponderMove, false);
            document.removeEventListener('mouseup', _this.onMouseUp, false);
            _this.touchableHandleResponderRelease(new __WEBPACK_IMPORTED_MODULE_2__PressEvent__["a" /* default */](e));
        };
        _this.touchableHandleResponderMove = function (e) {
            if (!_this.touchable.startMouse) {
                return;
            }
            // Measurement may not have returned yet.
            if (!_this.touchable.dimensionsOnActivate || _this.touchable.touchState === States.NOT_RESPONDER) {
                return;
            }
            // Not enough time elapsed yet, wait for highlight -
            // this is just a perf optimization.
            if (_this.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
                return;
            }
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            if (_this.pressInLocation) {
                var movedDistance = _this._getDistanceBetweenPoints(pageX, pageY, _this.pressInLocation.pageX, _this.pressInLocation.pageY);
                if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
                    _this._cancelLongPressDelayTimeout();
                }
            }
            if (_this.checkTouchWithinActive(e)) {
                _this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
                var curState = _this.touchable.touchState;
                if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
                    _this._cancelLongPressDelayTimeout();
                }
            } else {
                _this._cancelLongPressDelayTimeout();
                _this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
            }
        };
        return _this;
    }

    _createClass(Touchable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.root = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.root = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);
            // disabled auto clear active state
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.releaseLockTimer) {
                clearTimeout(this.releaseLockTimer);
            }
            if (this.touchableDelayTimeout) {
                clearTimeout(this.touchableDelayTimeout);
            }
            if (this.longPressDelayTimeout) {
                clearTimeout(this.longPressDelayTimeout);
            }
            if (this.pressOutDelayTimeout) {
                clearTimeout(this.pressOutDelayTimeout);
            }
        }
    }, {
        key: 'callChildEvent',
        value: function callChildEvent(event, e) {
            var childHandle = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children).props[event];
            if (childHandle) {
                childHandle(e);
            }
        }
    }, {
        key: '_remeasureMetricsOnInit',
        value: function _remeasureMetricsOnInit(e) {
            var root = this.root;

            var touch = extractSingleTouch(e);
            var boundingRect = root.getBoundingClientRect();
            this.touchable = {
                touchState: this.touchable.touchState,
                startMouse: {
                    pageX: touch.pageX,
                    pageY: touch.pageY
                },
                positionOnGrant: {
                    left: boundingRect.left + window.pageXOffset,
                    top: boundingRect.top + window.pageYOffset,
                    width: boundingRect.width,
                    height: boundingRect.height,
                    clientLeft: boundingRect.left,
                    clientTop: boundingRect.top
                }
            };
        }
    }, {
        key: 'processActiveStopPropagation',
        value: function processActiveStopPropagation(e) {
            var nativeEvent = e.nativeEvent || e;
            this.shouldActive = !nativeEvent.__activeStopPropagation;
            if (this.props.activeStopPropagation) {
                nativeEvent.__activeStopPropagation = 1;
            }
        }
    }, {
        key: 'touchableHandleResponderGrant',
        value: function touchableHandleResponderGrant(e) {
            var _this2 = this;

            this.touchable.touchState = States.NOT_RESPONDER;
            if (this.pressOutDelayTimeout) {
                clearTimeout(this.pressOutDelayTimeout);
                this.pressOutDelayTimeout = null;
            }
            if (this.props.fixClickPenetration && !isAllowPress()) {
                return;
            }
            this._remeasureMetricsOnInit(e);
            this._receiveSignal(Signals.RESPONDER_GRANT, e);
            var _props = this.props,
                delayMS = _props.delayPressIn,
                longDelayMS = _props.delayLongPress;

            this.processActiveStopPropagation(e);
            if (delayMS) {
                this.touchableDelayTimeout = setTimeout(function () {
                    _this2._handleDelay(e);
                }, delayMS);
            } else {
                this._handleDelay(e);
            }
            var longPressEvent = new __WEBPACK_IMPORTED_MODULE_2__PressEvent__["a" /* default */](e);
            this.longPressDelayTimeout = setTimeout(function () {
                _this2._handleLongDelay(longPressEvent);
            }, longDelayMS + delayMS);
        }
    }, {
        key: 'checkScroll',
        value: function checkScroll(e) {
            var positionOnGrant = this.touchable.positionOnGrant;
            // container or window scroll
            var boundingRect = this.root.getBoundingClientRect();
            if (boundingRect.left !== positionOnGrant.clientLeft || boundingRect.top !== positionOnGrant.clientTop) {
                this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
                return true;
            }
            return false;
        }
    }, {
        key: 'touchableHandleResponderRelease',
        value: function touchableHandleResponderRelease(e) {
            if (!this.touchable.startMouse) {
                return;
            }
            var touch = extractSingleTouch(e);
            if (Math.abs(touch.pageX - this.touchable.startMouse.pageX) > 30 || Math.abs(touch.pageY - this.touchable.startMouse.pageY) > 30) {
                this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
                return;
            }
            if (this.checkScroll(e)) {
                return;
            }
            this._receiveSignal(Signals.RESPONDER_RELEASE, e);
        }
    }, {
        key: 'touchableHandleResponderTerminate',
        value: function touchableHandleResponderTerminate(e) {
            if (!this.touchable.startMouse) {
                return;
            }
            this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
        }
    }, {
        key: 'checkTouchWithinActive',
        value: function checkTouchWithinActive(e) {
            var positionOnGrant = this.touchable.positionOnGrant;
            var _props2 = this.props,
                _props2$pressRetentio = _props2.pressRetentionOffset,
                pressRetentionOffset = _props2$pressRetentio === undefined ? {} : _props2$pressRetentio,
                hitSlop = _props2.hitSlop;

            var pressExpandLeft = pressRetentionOffset.left;
            var pressExpandTop = pressRetentionOffset.top;
            var pressExpandRight = pressRetentionOffset.right;
            var pressExpandBottom = pressRetentionOffset.bottom;
            if (hitSlop) {
                pressExpandLeft += hitSlop.left;
                pressExpandTop += hitSlop.top;
                pressExpandRight += hitSlop.right;
                pressExpandBottom += hitSlop.bottom;
            }
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            return pageX > positionOnGrant.left - pressExpandLeft && pageY > positionOnGrant.top - pressExpandTop && pageX < positionOnGrant.left + positionOnGrant.width + pressExpandRight && pageY < positionOnGrant.top + positionOnGrant.height + pressExpandBottom;
        }
    }, {
        key: 'callProp',
        value: function callProp(name, e) {
            if (this.props[name] && !this.props.disabled) {
                this.props[name](e);
            }
        }
    }, {
        key: 'touchableHandleActivePressIn',
        value: function touchableHandleActivePressIn(e) {
            if (this.shouldActive) {
                this.setActive(true);
            }
            this.callProp('onPressIn', e);
        }
    }, {
        key: 'touchableHandleActivePressOut',
        value: function touchableHandleActivePressOut(e) {
            this.setActive(false);
            this.callProp('onPressOut', e);
        }
    }, {
        key: 'touchableHandlePress',
        value: function touchableHandlePress(e) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PressEvent__["b" /* shouldFirePress */])(e)) {
                this.callProp('onPress', e);
            }
            lastClickTime = Date.now();
        }
    }, {
        key: 'touchableHandleLongPress',
        value: function touchableHandleLongPress(e) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PressEvent__["b" /* shouldFirePress */])(e)) {
                this.callProp('onLongPress', e);
            }
        }
    }, {
        key: 'setActive',
        value: function setActive(active) {
            if (this.state.active !== active && (this.props.activeClassName || this.props.activeStyle)) {
                this.setState({
                    active: active
                });
            }
        }
    }, {
        key: '_remeasureMetricsOnActivation',
        value: function _remeasureMetricsOnActivation() {
            this.touchable.dimensionsOnActivate = this.touchable.positionOnGrant;
        }
    }, {
        key: '_handleDelay',
        value: function _handleDelay(e) {
            this.touchableDelayTimeout = null;
            this._receiveSignal(Signals.DELAY, e);
        }
    }, {
        key: '_handleLongDelay',
        value: function _handleLongDelay(e) {
            this.longPressDelayTimeout = null;
            var curState = this.touchable.touchState;
            if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
                console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
            } else {
                this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
            }
        }
    }, {
        key: '_receiveSignal',
        value: function _receiveSignal(signal, e) {
            var curState = this.touchable.touchState;
            var nextState = Transitions[curState] && Transitions[curState][signal];
            if (!nextState) {
                return;
            }
            if (nextState === States.ERROR) {
                return;
            }
            if (curState !== nextState) {
                this._performSideEffectsForTransition(curState, nextState, signal, e);
                this.touchable.touchState = nextState;
            }
        }
    }, {
        key: '_cancelLongPressDelayTimeout',
        value: function _cancelLongPressDelayTimeout() {
            if (this.longPressDelayTimeout) {
                clearTimeout(this.longPressDelayTimeout);
                this.longPressDelayTimeout = null;
            }
        }
    }, {
        key: '_isHighlight',
        value: function _isHighlight(state) {
            return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
        }
    }, {
        key: '_savePressInLocation',
        value: function _savePressInLocation(e) {
            var touch = extractSingleTouch(e);
            var pageX = touch && touch.pageX;
            var pageY = touch && touch.pageY;
            this.pressInLocation = { pageX: pageX, pageY: pageY };
        }
    }, {
        key: '_getDistanceBetweenPoints',
        value: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
            var deltaX = aX - bX;
            var deltaY = aY - bY;
            return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        }
    }, {
        key: '_performSideEffectsForTransition',
        value: function _performSideEffectsForTransition(curState, nextState, signal, e) {
            var curIsHighlight = this._isHighlight(curState);
            var newIsHighlight = this._isHighlight(nextState);
            var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;
            if (isFinalSignal) {
                this._cancelLongPressDelayTimeout();
            }
            if (!IsActive[curState] && IsActive[nextState]) {
                this._remeasureMetricsOnActivation();
            }
            if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
                this.touchableHandleLongPress(e);
            }
            if (newIsHighlight && !curIsHighlight) {
                this._startHighlight(e);
            } else if (!newIsHighlight && curIsHighlight) {
                this._endHighlight(e);
            }
            if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
                var hasLongPressHandler = !!this.props.onLongPress;
                var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && ( // We *are* long pressing..
                !hasLongPressHandler || // But either has no long handler
                !this.props.longPressCancelsPress // or we're told to ignore it.
                );
                var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
                if (shouldInvokePress) {
                    if (!newIsHighlight && !curIsHighlight) {
                        // we never highlighted because of delay, but we should highlight now
                        this._startHighlight(e);
                        this._endHighlight(e);
                    }
                    this.touchableHandlePress(e);
                }
            }
            if (this.touchableDelayTimeout) {
                clearTimeout(this.touchableDelayTimeout);
                this.touchableDelayTimeout = null;
            }
        }
    }, {
        key: '_startHighlight',
        value: function _startHighlight(e) {
            this._savePressInLocation(e);
            this.touchableHandleActivePressIn(e);
        }
    }, {
        key: '_endHighlight',
        value: function _endHighlight(e) {
            var _this3 = this;

            if (this.props.delayPressOut) {
                this.pressOutDelayTimeout = setTimeout(function () {
                    _this3.touchableHandleActivePressOut(e);
                }, this.props.delayPressOut);
            } else {
                this.touchableHandleActivePressOut(e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                children = _props3.children,
                disabled = _props3.disabled,
                activeStyle = _props3.activeStyle,
                activeClassName = _props3.activeClassName;

            var events = disabled ? undefined : copy(this, ['onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel', 'onMouseDown']);
            var child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle) {
                    style = _extends({}, style, activeStyle);
                }
                if (activeClassName) {
                    if (className) {
                        className += ' ' + activeClassName;
                    } else {
                        className = activeClassName;
                    }
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, events);
        }
    }]);

    return Touchable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (Touchable);

Touchable.defaultProps = {
    fixClickPenetration: false,
    disabled: false,
    delayPressIn: HIGHLIGHT_DELAY_MS,
    delayLongPress: LONG_PRESS_DELAY_MS,
    delayPressOut: 100,
    pressRetentionOffset: {
        left: PRESS_EXPAND_PX,
        right: PRESS_EXPAND_PX,
        top: PRESS_EXPAND_PX,
        bottom: PRESS_EXPAND_PX
    },
    hitSlop: undefined,
    longPressCancelsPress: true
};

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LazyRenderBox, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.hiddenClassName || nextProps.visible;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hiddenClassName = _props.hiddenClassName,
          visible = _props.visible,
          props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

      if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(props.children) > 1) {
        if (!visible && hiddenClassName) {
          props.className += ' ' + hiddenClassName;
        }
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', props);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(props.children);
    }
  }]);

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPopupClassNameFromAlign;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1413);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1412);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;

var _addDomEventListener = _interopRequireDefault(__webpack_require__(434));

var _reactDom = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener.default)(target, eventType, callback, option);
}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1424)();
}


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(119);

var invariant = __webpack_require__(15);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(141);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactInstrumentation = __webpack_require__(75);

var quoteAttributeValueForBrowser = __webpack_require__(1487);
var warning = __webpack_require__(25);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var LinkedValueUtils = __webpack_require__(345);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactUpdates = __webpack_require__(87);

var warning = __webpack_require__(25);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(1447);

var containsNode = __webpack_require__(1117);
var focusNode = __webpack_require__(479);
var getActiveElement = __webpack_require__(480);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var DOMLazyTree = __webpack_require__(140);
var DOMProperty = __webpack_require__(141);
var React = __webpack_require__(146);
var ReactBrowserEventEmitter = __webpack_require__(218);
var ReactCurrentOwner = __webpack_require__(94);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactDOMContainerInfo = __webpack_require__(1441);
var ReactDOMFeatureFlags = __webpack_require__(1443);
var ReactFeatureFlags = __webpack_require__(550);
var ReactInstanceMap = __webpack_require__(180);
var ReactInstrumentation = __webpack_require__(75);
var ReactMarkupChecksum = __webpack_require__(1457);
var ReactReconciler = __webpack_require__(142);
var ReactUpdateQueue = __webpack_require__(348);
var ReactUpdates = __webpack_require__(87);

var emptyObject = __webpack_require__(138);
var instantiateReactComponent = __webpack_require__(561);
var invariant = __webpack_require__(15);
var setInnerHTML = __webpack_require__(222);
var shouldUpdateReactComponent = __webpack_require__(354);
var warning = __webpack_require__(25);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var React = __webpack_require__(146);

var invariant = __webpack_require__(15);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(554);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(57);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(35);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var ReactCompositeComponent = __webpack_require__(1438);
var ReactEmptyComponent = __webpack_require__(549);
var ReactHostComponent = __webpack_require__(551);

var getNextDebugID = __webpack_require__(1540);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(57);
var escapeTextContentForBrowser = __webpack_require__(221);
var setInnerHTML = __webpack_require__(222);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactCurrentOwner = __webpack_require__(94);
var REACT_ELEMENT_TYPE = __webpack_require__(1453);

var getIteratorFn = __webpack_require__(1484);
var invariant = __webpack_require__(15);
var KeyEscapeUtils = __webpack_require__(344);
var warning = __webpack_require__(25);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1493);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(568);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(569);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(356);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1504)();
}


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(358);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    innerRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["shape"])({ current: __WEBPACK_IMPORTED_MODULE_2_prop_types__["elementType"] })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { ref: innerRef }));
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(182);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(578);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(1520);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(364);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(1154);

var _runTransitionHook = __webpack_require__(364);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(145);

var _PathUtils = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Channel = function Channel(data) {
  _classCallCheck(this, Channel);

  var listeners = [];
  data = data || {};

  this.subscribe = function (fn) {
    listeners.push(fn);
  };

  this.unsubscribe = function (fn) {
    var idx = listeners.indexOf(fn);
    if (idx !== -1) listeners.splice(idx, 1);
  };

  this.update = function (fn) {
    if (fn) fn(data);
    listeners.forEach(function (l) {
      return l(data);
    });
  };
};

exports.default = Channel;
module.exports = exports['default'];

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(183),
    _assign = __webpack_require__(24);

var ReactNoopUpdateQueue = __webpack_require__(586);

var canDefineProperty = __webpack_require__(587);
var emptyObject = __webpack_require__(138);
var invariant = __webpack_require__(15);
var lowPriorityWarning = __webpack_require__(1541);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(183);

var ReactCurrentOwner = __webpack_require__(94);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(25);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(594);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(592);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(593);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(596);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(595);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _arrayTreeFilter = __webpack_require__(131);

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

var _MultiPicker = __webpack_require__(230);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(231);

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Cascader = function (_React$Component) {
    (0, _inherits3['default'])(Cascader, _React$Component);

    function Cascader() {
        (0, _classCallCheck3['default'])(this, Cascader);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).apply(this, arguments));

        _this.state = {
            value: _this.getValue(_this.props.data, _this.props.defaultValue || _this.props.value)
        };
        _this.onValueChange = function (value, index) {
            var children = (0, _arrayTreeFilter2['default'])(_this.props.data, function (c, level) {
                return level <= index && c.value === value[level];
            });
            var data = children[index];
            var i = void 0;
            for (i = index + 1; data && data.children && data.children.length && i < _this.props.cols; i++) {
                data = data.children[0];
                value[i] = data.value;
            }
            value.length = i;
            if (!('value' in _this.props)) {
                _this.setState({
                    value: value
                });
            }
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Cascader, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: this.getValue(nextProps.data, nextProps.value)
                });
            }
        }
    }, {
        key: 'getValue',
        value: function getValue(d, val) {
            var data = d || this.props.data;
            var value = val || this.props.value || this.props.defaultValue;
            if (!value || !value.length) {
                value = [];
                for (var i = 0; i < this.props.cols; i++) {
                    if (data && data.length) {
                        value[i] = data[0].value;
                        data = data[0].children;
                    }
                }
            }
            return value;
        }
    }, {
        key: 'getCols',
        value: function getCols() {
            var _props = this.props,
                data = _props.data,
                cols = _props.cols,
                pickerPrefixCls = _props.pickerPrefixCls,
                disabled = _props.disabled,
                pickerItemStyle = _props.pickerItemStyle,
                indicatorStyle = _props.indicatorStyle;

            var value = this.state.value;
            var childrenTree = (0, _arrayTreeFilter2['default'])(data, function (c, level) {
                return c.value === value[level];
            }).map(function (c) {
                return c.children;
            });
            // in case the users data is async get when select change
            var needPad = cols - childrenTree.length;
            if (needPad > 0) {
                for (var i = 0; i < needPad; i++) {
                    childrenTree.push([]);
                }
            }
            childrenTree.length = cols - 1;
            childrenTree.unshift(data);
            return childrenTree.map(function () {
                var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var level = arguments[1];
                return _react2['default'].createElement(_Picker2['default'], { key: level, prefixCls: pickerPrefixCls, style: { flex: 1 }, disabled: disabled, indicatorStyle: indicatorStyle, pickerItemStyle: pickerItemStyle }, children.map(function (item) {
                    return _react2['default'].createElement(_Picker2['default'].Item, { value: item.value, key: item.value }, item.label);
                }));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var prefixCls = props.prefixCls,
                className = props.className,
                rootNativeProps = props.rootNativeProps,
                style = props.style;

            var cols = this.getCols();
            var multiStyle = (0, _extends3['default'])({ flexDirection: 'row', alignItems: 'center' }, style);
            return _react2['default'].createElement(_MultiPicker2['default'], { style: multiStyle, prefixCls: prefixCls, className: className, selectedValue: this.state.value, rootNativeProps: rootNativeProps, onValueChange: this.onValueChange }, cols);
        }
    }]);
    return Cascader;
}(_react2['default'].Component);

Cascader.defaultProps = {
    cols: 3,
    prefixCls: 'rmc-cascader',
    pickerPrefixCls: 'rmc-picker',
    data: [],
    disabled: false
};
exports['default'] = Cascader;
module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1558);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1556);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1559);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1557);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(597);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(597);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1561);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1560);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1568);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1566);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1569);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1567);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(603);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(603);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1571);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1570);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ListViewDataSource__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollView__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_sticky__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_sticky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_sticky__);






/* eslint no-unused-vars: 0, react/no-multi-comp: 0
react/prop-types: 0, react/sort-comp: 0, no-unused-expressions: 0 */







var DEFAULT_PAGE_SIZE = 1;
var DEFAULT_INITIAL_ROWS = 10;
var DEFAULT_SCROLL_RENDER_AHEAD = 1000;
var DEFAULT_END_REACHED_THRESHOLD = 1000;
var DEFAULT_SCROLL_CALLBACK_THROTTLE = 50;
var SCROLLVIEW_REF = 'listviewscroll';

var StaticRenderer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(StaticRenderer, _React$Component);

  function StaticRenderer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StaticRenderer);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StaticRenderer.__proto__ || Object.getPrototypeOf(StaticRenderer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(StaticRenderer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.shouldUpdate;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.render();
    }
  }]);

  return StaticRenderer;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
// https://github.com/facebook/react-native/blob/0.26-stable/Libraries/CustomComponents/ListView/ListView.js


var ListView = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListView, _React$Component2);

  function ListView() {
    var _ref;

    var _temp, _this2, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ListView.__proto__ || Object.getPrototypeOf(ListView)).call.apply(_ref, [this].concat(args))), _this2), _initialiseProps.call(_this2), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret);
  }

  /**
   * Exports some data, e.g. for perf investigations or analytics.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ListView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // this data should never trigger a render pass, so don't put in state
      this.scrollProperties = {
        visibleLength: null,
        contentLength: null,
        offset: 0
      };
      this._childFrames = [];
      this._visibleRows = {};
      this._prevRenderedRowsCount = 0;
      this._sentEndForContentLength = null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (this.props.dataSource !== nextProps.dataSource || this.props.initialListSize !== nextProps.initialListSize) {
        this.setState(function (state, props) {
          _this3._prevRenderedRowsCount = 0;
          return {
            curRenderedRowsCount: Math.min(Math.max(state.curRenderedRowsCount, nextProps.initialListSize // for preact
            ), nextProps.dataSource.getRowCount() // for preact
            )
          };
        }, function () {
          return _this3._renderMoreRowsIfNeeded();
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var bodyComponents = [];

      var dataSource = this.props.dataSource;
      var allRowIDs = dataSource.rowIdentities;
      var rowCount = 0;
      var sectionHeaderIndices = [];

      var header = this.props.renderHeader && this.props.renderHeader();
      var footer = this.props.renderFooter && this.props.renderFooter();
      var totalIndex = header ? 1 : 0;

      var _loop = function _loop(sectionIdx) {
        var sectionID = dataSource.sectionIdentities[sectionIdx];
        var rowIDs = allRowIDs[sectionIdx];
        if (rowIDs.length === 0) {
          return 'continue';
        }

        if (_this4.props.renderSectionHeader) {
          var shouldUpdateHeader = rowCount >= _this4._prevRenderedRowsCount && dataSource.sectionHeaderShouldUpdate(sectionIdx);

          var renderSectionHeader = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StaticRenderer, {
            key: 's_' + sectionID,
            shouldUpdate: !!shouldUpdateHeader,
            render: _this4.props.renderSectionHeader.bind(null, dataSource.getSectionHeaderData(sectionIdx), sectionID)
          });
          if (_this4.props.stickyHeader) {
            renderSectionHeader = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11_react_sticky__["Sticky"],
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this4.props.stickyProps, { key: 's_' + sectionID,
                ref: function ref(c) {
                  _this4.stickyRefs[sectionID] = c;
                }
              }),
              renderSectionHeader
            );
          }
          bodyComponents.push(renderSectionHeader);
          sectionHeaderIndices.push(totalIndex++);
        }

        var sectionBody = [];
        for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
          var rowID = rowIDs[rowIdx];
          var comboID = sectionID + '_' + rowID;
          var shouldUpdateRow = rowCount >= _this4._prevRenderedRowsCount && dataSource.rowShouldUpdate(sectionIdx, rowIdx);
          var row = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(StaticRenderer, {
            key: 'r_' + comboID,
            shouldUpdate: !!shouldUpdateRow,
            render: _this4.props.renderRow.bind(null, dataSource.getRowData(sectionIdx, rowIdx), sectionID, rowID, _this4.onRowHighlighted)
          });
          // bodyComponents.push(row);
          sectionBody.push(row);
          totalIndex++;

          if (_this4.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
            var adjacentRowHighlighted = _this4.state.highlightedRow.sectionID === sectionID && (_this4.state.highlightedRow.rowID === rowID || _this4.state.highlightedRow.rowID === rowIDs[rowIdx + 1]);
            var separator = _this4.props.renderSeparator(sectionID, rowID, adjacentRowHighlighted);
            if (separator) {
              // bodyComponents.push(separator);
              sectionBody.push(separator);
              totalIndex++;
            }
          }
          if (++rowCount === _this4.state.curRenderedRowsCount) {
            break;
          }
        }
        bodyComponents.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(_this4.props.renderSectionBodyWrapper(sectionID), {
          className: _this4.props.sectionBodyClassName
        }, sectionBody));
        if (rowCount >= _this4.state.curRenderedRowsCount) {
          return 'break';
        }
      };

      _loop2: for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
        var _ret2 = _loop(sectionIdx);

        switch (_ret2) {
          case 'continue':
            continue;

          case 'break':
            break _loop2;}
      }

      var _props = this.props,
          renderScrollComponent = _props.renderScrollComponent,
          props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['renderScrollComponent']);

      bodyComponents = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(props.renderBodyComponent(), {}, bodyComponents);
      if (props.stickyHeader) {
        bodyComponents = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_react_sticky__["StickyContainer"],
          props.stickyContainerProps,
          bodyComponents
        );
      }

      this._sc = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(renderScrollComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { onScroll: this._onScroll })), {
        ref: SCROLLVIEW_REF,
        onContentSizeChange: this._onContentSizeChange,
        onLayout: this._onLayout
      }, header, bodyComponents, footer, props.children);
      return this._sc;
    }
  }, {
    key: 'componentDidMount',


    /**
     The following code was originally intended to implement the pull-up-refresh feature,
     but not need to do it.
      Coincidentally, it solves a problem, if the content is not high enough,
     the `onScroll` and `onEndReached` event will not be fired.
     However, there should be a better solution for this issue.
     */
    value: function componentDidMount() {
      this.bindEvt();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unBindEvt();
    }
  }]);

  return ListView;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListView.DataSource = __WEBPACK_IMPORTED_MODULE_9__ListViewDataSource__["a" /* default */];
ListView.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__ScrollView__["a" /* default */].propTypes, {
  dataSource: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.instanceOf(__WEBPACK_IMPORTED_MODULE_9__ListViewDataSource__["a" /* default */]).isRequired,
  renderSeparator: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  renderRow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  initialListSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onEndReached: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEndReachedThreshold: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  pageSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  renderFooter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  renderHeader: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  renderSectionHeader: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  renderScrollComponent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  scrollRenderAheadDistance: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onChangeVisibleRows: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  scrollEventThrottle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  // another added
  renderBodyComponent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  renderSectionBodyWrapper: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  sectionBodyClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  useZscroller: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, // for web
  useBodyScroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, // for web
  stickyHeader: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, // for web
  stickyProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, // https://github.com/captivationsoftware/react-sticky/blob/master/README.md#sticky--props
  stickyContainerProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
});
ListView.defaultProps = {
  initialListSize: DEFAULT_INITIAL_ROWS,
  pageSize: DEFAULT_PAGE_SIZE,
  renderScrollComponent: function renderScrollComponent(props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ScrollView__["a" /* default */], props);
  },
  renderBodyComponent: function renderBodyComponent() {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', null);
  },
  renderSectionBodyWrapper: function renderSectionBodyWrapper(sectionID) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { key: sectionID });
  },
  sectionBodyClassName: 'list-view-section-body',
  scrollRenderAheadDistance: DEFAULT_SCROLL_RENDER_AHEAD,
  onEndReachedThreshold: DEFAULT_END_REACHED_THRESHOLD,
  scrollEventThrottle: DEFAULT_SCROLL_CALLBACK_THROTTLE,
  stickyProps: {},
  stickyContainerProps: {},
  scrollerOptions: {}
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.state = {
    curRenderedRowsCount: this.props.initialListSize,
    highlightedRow: {} };

  this.getMetrics = function () {
    return {
      contentLength: _this5.scrollProperties.contentLength,
      totalRows: _this5.props.dataSource.getRowCount(),
      renderedRows: _this5.state.curRenderedRowsCount,
      visibleRows: Object.keys(_this5._visibleRows).length
    };
  };

  this.scrollTo = function () {
    var _refs$SCROLLVIEW_REF;

    _this5.refs[SCROLLVIEW_REF] && _this5.refs[SCROLLVIEW_REF].scrollTo && (_refs$SCROLLVIEW_REF = _this5.refs[SCROLLVIEW_REF]).scrollTo.apply(_refs$SCROLLVIEW_REF, arguments);
  };

  this.getInnerViewNode = function () {
    // console.log(this.refs[SCROLLVIEW_REF]);
    return _this5.refs[SCROLLVIEW_REF].getInnerViewNode();
  };

  this.onRowHighlighted = function (sectionID, rowID) {
    _this5.setState({ highlightedRow: { sectionID: sectionID, rowID: rowID } });
  };

  this.stickyRefs = {};

  this._onContentSizeChange = function (width, height) {
    var contentLength = !_this5.props.horizontal ? height : width;
    if (contentLength !== _this5.scrollProperties.contentLength) {
      _this5.scrollProperties.contentLength = contentLength;
      _this5._renderMoreRowsIfNeeded();
    }
    _this5.props.onContentSizeChange && _this5.props.onContentSizeChange(width, height);
  };

  this._onLayout = function (event) {
    var _event$nativeEvent$la = event.nativeEvent.layout,
        width = _event$nativeEvent$la.width,
        height = _event$nativeEvent$la.height;

    var visibleLength = !_this5.props.horizontal ? height : width;
    if (visibleLength !== _this5.scrollProperties.visibleLength) {
      _this5.scrollProperties.visibleLength = visibleLength;
      _this5._renderMoreRowsIfNeeded();
    }
    _this5.props.onLayout && _this5.props.onLayout(event);
  };

  this._maybeCallOnEndReached = function (event) {
    // console.log(this.scrollProperties, this._getDistanceFromEnd(this.scrollProperties));
    if (_this5.props.onEndReached && _this5.scrollProperties.contentLength !== _this5._sentEndForContentLength && _this5._getDistanceFromEnd(_this5.scrollProperties) < _this5.props.onEndReachedThreshold && _this5.state.curRenderedRowsCount === _this5.props.dataSource.getRowCount()) {
      _this5._sentEndForContentLength = _this5.scrollProperties.contentLength;
      _this5.props.onEndReached(event);
      return true;
    }
    return false;
  };

  this._renderMoreRowsIfNeeded = function () {
    if (_this5.scrollProperties.contentLength === null || _this5.scrollProperties.visibleLength === null || _this5.state.curRenderedRowsCount === _this5.props.dataSource.getRowCount()) {
      _this5._maybeCallOnEndReached();
      return;
    }

    var distanceFromEnd = _this5._getDistanceFromEnd(_this5.scrollProperties);
    // console.log(distanceFromEnd, this.props.scrollRenderAheadDistance);
    if (distanceFromEnd < _this5.props.scrollRenderAheadDistance) {
      _this5._pageInNewRows();
    }
  };

  this._pageInNewRows = function () {
    _this5.setState(function (state, props) {
      var rowsToRender = Math.min(state.curRenderedRowsCount + props.pageSize, props.dataSource.getRowCount());
      _this5._prevRenderedRowsCount = state.curRenderedRowsCount;
      return {
        curRenderedRowsCount: rowsToRender
      };
    }, function () {
      _this5._prevRenderedRowsCount = _this5.state.curRenderedRowsCount;
    });
  };

  this._getDistanceFromEnd = function (scrollProperties) {
    return scrollProperties.contentLength - scrollProperties.visibleLength - scrollProperties.offset;
  };

  this._onScroll = function (e) {
    var isVertical = !_this5.props.horizontal;
    var ev = e;
    // when the ListView is destroyed,
    // but also will trigger scroll event after `scrollEventThrottle`
    if (!_this5.refs[SCROLLVIEW_REF]) {
      return;
    }
    var target = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(_this5.refs[SCROLLVIEW_REF]);
    if (_this5.props.stickyHeader || _this5.props.useBodyScroll) {
      _this5.scrollProperties.visibleLength = window[isVertical ? 'innerHeight' : 'innerWidth'];
      _this5.scrollProperties.contentLength = target[isVertical ? 'scrollHeight' : 'scrollWidth'];
      // In chrome61 `document.body.scrollTop` is invalid,
      // and add new `document.scrollingElement`(chrome61, iOS support).
      // In old-android-browser and iOS `document.documentElement.scrollTop` is invalid.
      var scrollNode = document.scrollingElement ? document.scrollingElement : document.body;
      _this5.scrollProperties.offset = scrollNode[isVertical ? 'scrollTop' : 'scrollLeft'];
    } else if (_this5.props.useZscroller) {
      var domScroller = _this5.refs[SCROLLVIEW_REF].domScroller;
      ev = domScroller;
      _this5.scrollProperties.visibleLength = domScroller.container[isVertical ? 'clientHeight' : 'clientWidth'];
      _this5.scrollProperties.contentLength = domScroller.content[isVertical ? 'offsetHeight' : 'offsetWidth'];
      _this5.scrollProperties.offset = domScroller.scroller.getValues()[isVertical ? 'top' : 'left'];
      // console.log(this.scrollProperties, domScroller.scroller.getScrollMax())
    } else {
      _this5.scrollProperties.visibleLength = target[isVertical ? 'offsetHeight' : 'offsetWidth'];
      _this5.scrollProperties.contentLength = target[isVertical ? 'scrollHeight' : 'scrollWidth'];
      _this5.scrollProperties.offset = target[isVertical ? 'scrollTop' : 'scrollLeft'];
    }

    if (!_this5._maybeCallOnEndReached(ev)) {
      _this5._renderMoreRowsIfNeeded();
    }

    if (_this5.props.onEndReached && _this5._getDistanceFromEnd(_this5.scrollProperties) > _this5.props.onEndReachedThreshold) {
      // Scrolled out of the end zone, so it should be able to trigger again.
      _this5._sentEndForContentLength = null;
    }

    _this5.props.onScroll && _this5.props.onScroll(ev);
  };

  this.bindEvt = function () {
    var ele = _this5.getEle();
    ele.addEventListener('touchstart', _this5.onPullUpStart);
    ele.addEventListener('touchmove', _this5.onPullUpMove);
    ele.addEventListener('touchend', _this5.onPullUpEnd);
    ele.addEventListener('touchcancel', _this5.onPullUpEnd);
  };

  this.unBindEvt = function () {
    var ele = _this5.getEle();
    ele.removeEventListener('touchstart', _this5.onPullUpStart);
    ele.removeEventListener('touchmove', _this5.onPullUpMove);
    ele.removeEventListener('touchend', _this5.onPullUpEnd);
    ele.removeEventListener('touchcancel', _this5.onPullUpEnd);
  };

  this.getEle = function () {
    var _props2 = _this5.props,
        stickyHeader = _props2.stickyHeader,
        useBodyScroll = _props2.useBodyScroll;

    var ele = void 0;
    if (stickyHeader || useBodyScroll) {
      ele = document.body;
    } else {
      ele = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(_this5.refs.listviewscroll.refs.ScrollView);
    }
    return ele;
  };

  this.onPullUpStart = function (e) {
    _this5._pullUpStartPageY = e.touches[0].screenY;
    _this5._isPullUp = false;
    _this5._pullUpEle = _this5.getEle();
  };

  this.onPullUpMove = function (e) {
    // 使用 pageY 对比有问题
    if (e.touches[0].screenY < _this5._pullUpStartPageY && _this5._reachBottom()) {
      // console.log('滚动条到了底部，pull up');
      _this5._isPullUp = true;
    }
  };

  this.onPullUpEnd = function (e) {
    if (_this5._isPullUp && _this5.props.onEndReached) {
      // this.props.onEndReached(e);
      // https://github.com/react-component/m-list-view/pull/15/files
      // need update `this.scrollProperties` in order to render correctly
      _this5._onScroll(e);
    }
    _this5._isPullUp = false;
  };

  this._reachBottom = function () {
    var element = _this5._pullUpEle;
    if (element === document.body) {
      return element.scrollHeight - element.scrollTop === window.innerHeight;
    }
    return element.scrollHeight - element.scrollTop === element.clientHeight;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ListView);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetTop;
/* harmony export (immutable) */ __webpack_exports__["b"] = _event;
/* harmony export (immutable) */ __webpack_exports__["c"] = throttle;
function getOffsetTop(elem) {
  var offsetTop = 0;
  /* eslint no-cond-assign: 0 */
  do {
    if (!isNaN(elem.offsetTop)) {
      offsetTop += elem.offsetTop;
    }
  } while (elem = elem.offsetParent);
  return offsetTop;
}

function _event(e) {
  if (e.touches && e.touches.length) {
    return e.touches[0];
  }
  if (e.changedTouches && e.changedTouches.length) {
    return e.changedTouches[0];
  }
  return e;
}

function throttle(fn, delay) {
  var delayFlag = true;
  var firstInvoke = true;
  // console.log('exec once');
  return function _throttle(e) {
    if (delayFlag) {
      delayFlag = false;
      setTimeout(function () {
        delayFlag = true;
        // console.log('exec delay time');
        fn(e);
      }, delay);
      if (firstInvoke) {
        // console.log('first invoke');
        fn(e);
        firstInvoke = false;
      }
    }
  };
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1584), __esModule: true };

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(606);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1581);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1580);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 609 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1588);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(188)
  , document = __webpack_require__(109).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(121) && !__webpack_require__(187)(function(){
  return Object.defineProperty(__webpack_require__(611)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(609);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(371)
  , $export        = __webpack_require__(148)
  , redefine       = __webpack_require__(618)
  , hide           = __webpack_require__(149)
  , has            = __webpack_require__(122)
  , Iterators      = __webpack_require__(370)
  , $iterCreate    = __webpack_require__(1594)
  , setToStringTag = __webpack_require__(374)
  , getPrototypeOf = __webpack_require__(1601)
  , ITERATOR       = __webpack_require__(150)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(227)
  , createDesc     = __webpack_require__(228)
  , toIObject      = __webpack_require__(124)
  , toPrimitive    = __webpack_require__(378)
  , has            = __webpack_require__(122)
  , IE8_DOM_DEFINE = __webpack_require__(612)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(121) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(617)
  , hiddenKeys = __webpack_require__(369).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(122)
  , toIObject    = __webpack_require__(124)
  , arrayIndexOf = __webpack_require__(1590)(false)
  , IE_PROTO     = __webpack_require__(375)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(149);

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(368);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1624);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcDialog = __webpack_require__(212);

var _rcDialog2 = _interopRequireDefault(_rcDialog);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _PopupMixin = __webpack_require__(1627);

var _PopupMixin2 = _interopRequireDefault(_PopupMixin);

var _rcTouchable = __webpack_require__(538);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupPicker = (0, _createReactClass2['default'])({
  mixins: [_PopupMixin2['default']],
  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rmc-picker-popup',
      triggerType: 'onClick',
      WrapComponent: 'span'
    };
  },
  getModal: function getModal() {
    var props = this.props;
    if (!this.state.visible) {
      return null;
    }
    var prefixCls = props.prefixCls;

    return _react2['default'].createElement(
      _rcDialog2['default'],
      { prefixCls: '' + prefixCls, className: props.className || '', visible: true, closable: false, transitionName: props.transitionName || props.popupTransitionName, maskTransitionName: props.maskTransitionName, onClose: this.hide, style: props.style },
      _react2['default'].createElement(
        'div',
        null,
        _react2['default'].createElement(
          'div',
          { className: prefixCls + '-header' },
          _react2['default'].createElement(
            _rcTouchable2['default'],
            { activeClassName: prefixCls + '-item-active' },
            _react2['default'].createElement(
              'div',
              { className: prefixCls + '-item ' + prefixCls + '-header-left', onClick: this.onDismiss },
              props.dismissText
            )
          ),
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-item ' + prefixCls + '-title' },
            props.title
          ),
          _react2['default'].createElement(
            _rcTouchable2['default'],
            { activeClassName: prefixCls + '-item-active' },
            _react2['default'].createElement(
              'div',
              { className: prefixCls + '-item ' + prefixCls + '-header-right', onClick: this.onOk },
              props.okText
            )
          )
        ),
        this.getContent()
      )
    );
  },
  render: function render() {
    return this.getRender();
  }
});
exports['default'] = PopupPicker;
module.exports = exports['default'];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1629);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1628);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 625 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/002yhkgl.c70251ae.jpg";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/003yhkgl.62c4b100.jpg";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/004yhkgl.b9a628f2.jpg";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/005yhkgl.9146fe61.jpg";

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/006yhkgl.97a3c3d1.jpg";

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/009yhkgl.0c9463fb.jpg";

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/011yhkgl.25c25557.jpg";

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/014yhkgl.3314d70a.jpg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/015yhkgl.faafc5ca.jpg";

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/016yhkgl.a4b17f76.jpg";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/018yhkgl.92eceb51.jpg";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/021yhkgl.6184e880.jpg";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/022yhkgl.342a5029.jpg";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/60s.5df59456.png";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/70s.854ab0d6.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/80s.001dd58e.png";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/904hqtxq.177f8435.png";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ID Card back_.441bda98.png";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ID Card front_.2589e76f.png";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowBm.d81ae67a.png";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/blhylIcon.411931d4.png";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/camera_.5e75afa4.png";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clbs_head.7c856f75.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clostR.3fdd3f5b.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cqt.9543d8b9.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/daxueIcon.1008ba28.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/daxuejy.5b889db6.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/errorO.c8e58f08.png";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gaozhongIcon.8fd46e43.png";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hf.6a0fdc77.png";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_operating.6850d919.png";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jh.831e8d56.png";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jhPie.a30e94dd.png";

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jjPie.778b96b2.png";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jjzhIcon.0b7a9f86.png";

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jq.a284844f.png";

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo1.3b01fe9d.png";

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/money1.0bb9454b.png";

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/money2.d3535760.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/money3.2c63727b.png";

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/money4.eeab5c47.png";

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_investing.cf304489.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_dynameic@2x.0c4f4841.png";

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_header_bg@2x.951c1c26.png";

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_jiaoyimingxi.a2571de5.png";

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_kefu.dcfb42ed.png";

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_position_arrow@2x.0d31825e.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_shouyimingxi.247d9bf8.png";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_shuoming.c6c83bb4.png";

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_what .fb440538.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/open.729b52bc.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/qlhylIcon.302b3414.png";

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/qpxIcon.d0c2c5c7.png";

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rchx.186a737d.png";

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/round_bs.7bf7f5e4.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search_header.14cd9aaa.png";

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slxx.0b3783d8.png";

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/smRound.6445fd32.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/squareHookNew.9d7e1c4a.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/squareNew.de43b4f4.png";

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tzzj.d9eae2d9.png";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wenhao3.329449db.png";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wj.07127b86.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wjPie.5e28d9fa.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xfzj.a00a40b6.png";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xiaoxueIcon.ba86f468.png";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xqgz.17e5eaa8.png";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xuanzhong.f879f116.png";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhongxuejy.77fc6676.png";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhuanpan.d64c6752.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eq_clcsk_icon.c08b06a2.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eq_lcgh_icon.044ae781.png";

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eq_mdzt_icon.30352535.png";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eq_zhdt_icon.fc8e1578.png";

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/home_ZT_card.bf505c8e.png";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/home_ZT_card_icon.aafeaf78.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_arraw_right_gray.52e297bd.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jiantou_icon.fdd22a96.png";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var guid = __webpack_require__(711);

var Eventful = __webpack_require__(194);

var Transformable = __webpack_require__(717);

var Animatable = __webpack_require__(1941);

var zrUtil = __webpack_require__(6);

/**
 * @alias module:zrender/Element
 * @constructor
 * @extends {module:zrender/mixin/Animatable}
 * @extends {module:zrender/mixin/Transformable}
 * @extends {module:zrender/mixin/Eventful}
 */
var Element = function (opts) {
  // jshint ignore:line
  Transformable.call(this, opts);
  Eventful.call(this, opts);
  Animatable.call(this, opts);
  /**
   * 画布元素ID
   * @type {string}
   */

  this.id = opts.id || guid();
};

Element.prototype = {
  /**
   * 元素类型
   * Element type
   * @type {string}
   */
  type: 'element',

  /**
   * 元素名字
   * Element name
   * @type {string}
   */
  name: '',

  /**
   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
   * ZRender instance will be assigned when element is associated with zrender
   * @name module:/zrender/Element#__zr
   * @type {module:zrender/ZRender}
   */
  __zr: null,

  /**
   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
   * If ignore drawing and events of the element object
   * @name module:/zrender/Element#ignore
   * @type {boolean}
   * @default false
   */
  ignore: false,

  /**
   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
   * 该路径会继承被裁减对象的变换
   * @type {module:zrender/graphic/Path}
   * @see http://www.w3.org/TR/2dcontext/#clipping-region
   * @readOnly
   */
  clipPath: null,

  /**
   * Drift element
   * @param  {number} dx dx on the global space
   * @param  {number} dy dy on the global space
   */
  drift: function (dx, dy) {
    switch (this.draggable) {
      case 'horizontal':
        dy = 0;
        break;

      case 'vertical':
        dx = 0;
        break;
    }

    var m = this.transform;

    if (!m) {
      m = this.transform = [1, 0, 0, 1, 0, 0];
    }

    m[4] += dx;
    m[5] += dy;
    this.decomposeTransform();
    this.dirty(false);
  },

  /**
   * Hook before update
   */
  beforeUpdate: function () {},

  /**
   * Hook after update
   */
  afterUpdate: function () {},

  /**
   * Update each frame
   */
  update: function () {
    this.updateTransform();
  },

  /**
   * @param  {Function} cb
   * @param  {}   context
   */
  traverse: function (cb, context) {},

  /**
   * @protected
   */
  attrKV: function (key, value) {
    if (key === 'position' || key === 'scale' || key === 'origin') {
      // Copy the array
      if (value) {
        var target = this[key];

        if (!target) {
          target = this[key] = [];
        }

        target[0] = value[0];
        target[1] = value[1];
      }
    } else {
      this[key] = value;
    }
  },

  /**
   * Hide the element
   */
  hide: function () {
    this.ignore = true;
    this.__zr && this.__zr.refresh();
  },

  /**
   * Show the element
   */
  show: function () {
    this.ignore = false;
    this.__zr && this.__zr.refresh();
  },

  /**
   * @param {string|Object} key
   * @param {*} value
   */
  attr: function (key, value) {
    if (typeof key === 'string') {
      this.attrKV(key, value);
    } else if (zrUtil.isObject(key)) {
      for (var name in key) {
        if (key.hasOwnProperty(name)) {
          this.attrKV(name, key[name]);
        }
      }
    }

    this.dirty(false);
    return this;
  },

  /**
   * @param {module:zrender/graphic/Path} clipPath
   */
  setClipPath: function (clipPath) {
    var zr = this.__zr;

    if (zr) {
      clipPath.addSelfToZr(zr);
    } // Remove previous clip path


    if (this.clipPath && this.clipPath !== clipPath) {
      this.removeClipPath();
    }

    this.clipPath = clipPath;
    clipPath.__zr = zr;
    clipPath.__clipTarget = this;
    this.dirty(false);
  },

  /**
   */
  removeClipPath: function () {
    var clipPath = this.clipPath;

    if (clipPath) {
      if (clipPath.__zr) {
        clipPath.removeSelfFromZr(clipPath.__zr);
      }

      clipPath.__zr = null;
      clipPath.__clipTarget = null;
      this.clipPath = null;
      this.dirty(false);
    }
  },

  /**
   * Add self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  addSelfToZr: function (zr) {
    this.__zr = zr; // 添加动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.addAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.addSelfToZr(zr);
    }
  },

  /**
   * Remove self from zrender instance.
   * Not recursively because it will be invoked when element added to storage.
   * @param {module:zrender/ZRender} zr
   */
  removeSelfFromZr: function (zr) {
    this.__zr = null; // 移除动画

    var animators = this.animators;

    if (animators) {
      for (var i = 0; i < animators.length; i++) {
        zr.animation.removeAnimator(animators[i]);
      }
    }

    if (this.clipPath) {
      this.clipPath.removeSelfFromZr(zr);
    }
  }
};
zrUtil.mixin(Element, Animatable);
zrUtil.mixin(Element, Transformable);
zrUtil.mixin(Element, Eventful);
var _default = Element;
module.exports = _default;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var Clip = __webpack_require__(1915);

var color = __webpack_require__(195);

var _util = __webpack_require__(6);

var isArrayLike = _util.isArrayLike;

/**
 * @module echarts/animation/Animator
 */
var arraySlice = Array.prototype.slice;

function defaultGetter(target, key) {
  return target[key];
}

function defaultSetter(target, key, value) {
  target[key] = value;
}
/**
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} percent
 * @return {number}
 */


function interpolateNumber(p0, p1, percent) {
  return (p1 - p0) * percent + p0;
}
/**
 * @param  {string} p0
 * @param  {string} p1
 * @param  {number} percent
 * @return {string}
 */


function interpolateString(p0, p1, percent) {
  return percent > 0.5 ? p1 : p0;
}
/**
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {number} percent
 * @param  {Array} out
 * @param  {number} arrDim
 */


function interpolateArray(p0, p1, percent, out, arrDim) {
  var len = p0.length;

  if (arrDim == 1) {
    for (var i = 0; i < len; i++) {
      out[i] = interpolateNumber(p0[i], p1[i], percent);
    }
  } else {
    var len2 = len && p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
      }
    }
  }
} // arr0 is source array, arr1 is target array.
// Do some preprocess to avoid error happened when interpolating from arr0 to arr1


function fillArr(arr0, arr1, arrDim) {
  var arr0Len = arr0.length;
  var arr1Len = arr1.length;

  if (arr0Len !== arr1Len) {
    // FIXME Not work for TypedArray
    var isPreviousLarger = arr0Len > arr1Len;

    if (isPreviousLarger) {
      // Cut the previous
      arr0.length = arr1Len;
    } else {
      // Fill the previous
      for (var i = arr0Len; i < arr1Len; i++) {
        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
      }
    }
  } // Handling NaN value


  var len2 = arr0[0] && arr0[0].length;

  for (var i = 0; i < arr0.length; i++) {
    if (arrDim === 1) {
      if (isNaN(arr0[i])) {
        arr0[i] = arr1[i];
      }
    } else {
      for (var j = 0; j < len2; j++) {
        if (isNaN(arr0[i][j])) {
          arr0[i][j] = arr1[i][j];
        }
      }
    }
  }
}
/**
 * @param  {Array} arr0
 * @param  {Array} arr1
 * @param  {number} arrDim
 * @return {boolean}
 */


function isArraySame(arr0, arr1, arrDim) {
  if (arr0 === arr1) {
    return true;
  }

  var len = arr0.length;

  if (len !== arr1.length) {
    return false;
  }

  if (arrDim === 1) {
    for (var i = 0; i < len; i++) {
      if (arr0[i] !== arr1[i]) {
        return false;
      }
    }
  } else {
    var len2 = arr0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        if (arr0[i][j] !== arr1[i][j]) {
          return false;
        }
      }
    }
  }

  return true;
}
/**
 * Catmull Rom interpolate array
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @param  {Array} out
 * @param  {number} arrDim
 */


function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
  var len = p0.length;

  if (arrDim == 1) {
    for (var i = 0; i < len; i++) {
      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
    }
  } else {
    var len2 = p0[0].length;

    for (var i = 0; i < len; i++) {
      for (var j = 0; j < len2; j++) {
        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
      }
    }
  }
}
/**
 * Catmull Rom interpolate number
 * @param  {number} p0
 * @param  {number} p1
 * @param  {number} p2
 * @param  {number} p3
 * @param  {number} t
 * @param  {number} t2
 * @param  {number} t3
 * @return {number}
 */


function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}

function cloneValue(value) {
  if (isArrayLike(value)) {
    var len = value.length;

    if (isArrayLike(value[0])) {
      var ret = [];

      for (var i = 0; i < len; i++) {
        ret.push(arraySlice.call(value[i]));
      }

      return ret;
    }

    return arraySlice.call(value);
  }

  return value;
}

function rgba2String(rgba) {
  rgba[0] = Math.floor(rgba[0]);
  rgba[1] = Math.floor(rgba[1]);
  rgba[2] = Math.floor(rgba[2]);
  return 'rgba(' + rgba.join(',') + ')';
}

function getArrayDim(keyframes) {
  var lastValue = keyframes[keyframes.length - 1].value;
  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
}

function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
  var getter = animator._getter;
  var setter = animator._setter;
  var useSpline = easing === 'spline';
  var trackLen = keyframes.length;

  if (!trackLen) {
    return;
  } // Guess data type


  var firstVal = keyframes[0].value;
  var isValueArray = isArrayLike(firstVal);
  var isValueColor = false;
  var isValueString = false; // For vertices morphing

  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
  var trackMaxTime; // Sort keyframe as ascending

  keyframes.sort(function (a, b) {
    return a.time - b.time;
  });
  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe

  var kfPercents = []; // Value of each keyframe

  var kfValues = [];
  var prevValue = keyframes[0].value;
  var isAllValueEqual = true;

  for (var i = 0; i < trackLen; i++) {
    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string

    var value = keyframes[i].value; // Check if value is equal, deep check if value is array

    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
      isAllValueEqual = false;
    }

    prevValue = value; // Try converting a string to a color array

    if (typeof value == 'string') {
      var colorArray = color.parse(value);

      if (colorArray) {
        value = colorArray;
        isValueColor = true;
      } else {
        isValueString = true;
      }
    }

    kfValues.push(value);
  }

  if (!forceAnimate && isAllValueEqual) {
    return;
  }

  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value

  for (var i = 0; i < trackLen - 1; i++) {
    if (isValueArray) {
      fillArr(kfValues[i], lastValue, arrDim);
    } else {
      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
        kfValues[i] = lastValue;
      }
    }
  }

  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
  // animation playback is sequency

  var lastFrame = 0;
  var lastFramePercent = 0;
  var start;
  var w;
  var p0;
  var p1;
  var p2;
  var p3;

  if (isValueColor) {
    var rgba = [0, 0, 0, 0];
  }

  var onframe = function (target, percent) {
    // Find the range keyframes
    // kf1-----kf2---------current--------kf3
    // find kf2 and kf3 and do interpolation
    var frame; // In the easing function like elasticOut, percent may less than 0

    if (percent < 0) {
      frame = 0;
    } else if (percent < lastFramePercent) {
      // Start from next key
      // PENDING start from lastFrame ?
      start = Math.min(lastFrame + 1, trackLen - 1);

      for (frame = start; frame >= 0; frame--) {
        if (kfPercents[frame] <= percent) {
          break;
        }
      } // PENDING really need to do this ?


      frame = Math.min(frame, trackLen - 2);
    } else {
      for (frame = lastFrame; frame < trackLen; frame++) {
        if (kfPercents[frame] > percent) {
          break;
        }
      }

      frame = Math.min(frame - 1, trackLen - 2);
    }

    lastFrame = frame;
    lastFramePercent = percent;
    var range = kfPercents[frame + 1] - kfPercents[frame];

    if (range === 0) {
      return;
    } else {
      w = (percent - kfPercents[frame]) / range;
    }

    if (useSpline) {
      p1 = kfValues[frame];
      p0 = kfValues[frame === 0 ? frame : frame - 1];
      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];

      if (isValueArray) {
        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(p1, p2, w);
        } else {
          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
        }

        setter(target, propName, value);
      }
    } else {
      if (isValueArray) {
        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
      } else {
        var value;

        if (isValueColor) {
          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
          value = rgba2String(rgba);
        } else if (isValueString) {
          // String is step(0.5)
          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
        } else {
          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
        }

        setter(target, propName, value);
      }
    }
  };

  var clip = new Clip({
    target: animator._target,
    life: trackMaxTime,
    loop: animator._loop,
    delay: animator._delay,
    onframe: onframe,
    ondestroy: oneTrackDone
  });

  if (easing && easing !== 'spline') {
    clip.easing = easing;
  }

  return clip;
}
/**
 * @alias module:zrender/animation/Animator
 * @constructor
 * @param {Object} target
 * @param {boolean} loop
 * @param {Function} getter
 * @param {Function} setter
 */


var Animator = function (target, loop, getter, setter) {
  this._tracks = {};
  this._target = target;
  this._loop = loop || false;
  this._getter = getter || defaultGetter;
  this._setter = setter || defaultSetter;
  this._clipCount = 0;
  this._delay = 0;
  this._doneList = [];
  this._onframeList = [];
  this._clipList = [];
};

Animator.prototype = {
  /**
   * 设置动画关键帧
   * @param  {number} time 关键帧时间，单位是ms
   * @param  {Object} props 关键帧的属性值，key-value表示
   * @return {module:zrender/animation/Animator}
   */
  when: function (time
  /* ms */
  , props) {
    var tracks = this._tracks;

    for (var propName in props) {
      if (!props.hasOwnProperty(propName)) {
        continue;
      }

      if (!tracks[propName]) {
        tracks[propName] = []; // Invalid value

        var value = this._getter(this._target, propName);

        if (value == null) {
          // zrLog('Invalid property ' + propName);
          continue;
        } // If time is 0
        //  Then props is given initialize value
        // Else
        //  Initialize value from current prop value


        if (time !== 0) {
          tracks[propName].push({
            time: 0,
            value: cloneValue(value)
          });
        }
      }

      tracks[propName].push({
        time: time,
        value: props[propName]
      });
    }

    return this;
  },

  /**
   * 添加动画每一帧的回调函数
   * @param  {Function} callback
   * @return {module:zrender/animation/Animator}
   */
  during: function (callback) {
    this._onframeList.push(callback);

    return this;
  },
  pause: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].pause();
    }

    this._paused = true;
  },
  resume: function () {
    for (var i = 0; i < this._clipList.length; i++) {
      this._clipList[i].resume();
    }

    this._paused = false;
  },
  isPaused: function () {
    return !!this._paused;
  },
  _doneCallback: function () {
    // Clear all tracks
    this._tracks = {}; // Clear all clips

    this._clipList.length = 0;
    var doneList = this._doneList;
    var len = doneList.length;

    for (var i = 0; i < len; i++) {
      doneList[i].call(this);
    }
  },

  /**
   * 开始执行动画
   * @param  {string|Function} [easing]
   *         动画缓动函数，详见{@link module:zrender/animation/easing}
   * @param  {boolean} forceAnimate
   * @return {module:zrender/animation/Animator}
   */
  start: function (easing, forceAnimate) {
    var self = this;
    var clipCount = 0;

    var oneTrackDone = function () {
      clipCount--;

      if (!clipCount) {
        self._doneCallback();
      }
    };

    var lastClip;

    for (var propName in this._tracks) {
      if (!this._tracks.hasOwnProperty(propName)) {
        continue;
      }

      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);

      if (clip) {
        this._clipList.push(clip);

        clipCount++; // If start after added to animation

        if (this.animation) {
          this.animation.addClip(clip);
        }

        lastClip = clip;
      }
    } // Add during callback on the last clip


    if (lastClip) {
      var oldOnFrame = lastClip.onframe;

      lastClip.onframe = function (target, percent) {
        oldOnFrame(target, percent);

        for (var i = 0; i < self._onframeList.length; i++) {
          self._onframeList[i](target, percent);
        }
      };
    } // This optimization will help the case that in the upper application
    // the view may be refreshed frequently, where animation will be
    // called repeatly but nothing changed.


    if (!clipCount) {
      this._doneCallback();
    }

    return this;
  },

  /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stop: function (forwardToLast) {
    var clipList = this._clipList;
    var animation = this.animation;

    for (var i = 0; i < clipList.length; i++) {
      var clip = clipList[i];

      if (forwardToLast) {
        // Move to last frame before stop
        clip.onframe(this._target, 1);
      }

      animation && animation.removeClip(clip);
    }

    clipList.length = 0;
  },

  /**
   * 设置动画延迟开始的时间
   * @param  {number} time 单位ms
   * @return {module:zrender/animation/Animator}
   */
  delay: function (time) {
    this._delay = time;
    return this;
  },

  /**
   * 添加动画结束的回调
   * @param  {Function} cb
   * @return {module:zrender/animation/Animator}
   */
  done: function (cb) {
    if (cb) {
      this._doneList.push(cb);
    }

    return this;
  },

  /**
   * @return {Array.<module:zrender/animation/Clip>}
   */
  getClips: function () {
    return this._clipList;
  }
};
var _default = Animator;
module.exports = _default;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
  setTimeout(func, 16);
};

module.exports = _default;

/***/ }),
/* 707 */
/***/ (function(module, exports) {

var PI2 = Math.PI * 2;

function normalizeRadian(angle) {
  angle %= PI2;

  if (angle < 0) {
    angle += PI2;
  }

  return angle;
}

exports.normalizeRadian = normalizeRadian;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

function windingLine(x0, y0, x1, y1, x, y) {
  if (y > y0 && y > y1 || y < y0 && y < y1) {
    return 0;
  } // Ignore horizontal line


  if (y1 === y0) {
    return 0;
  }

  var dir = y1 < y0 ? 1 : -1;
  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon

  if (t === 1 || t === 0) {
    dir = y1 < y0 ? 0.5 : -0.5;
  }

  var x_ = t * (x1 - x0) + x0;
  return x_ > x ? dir : 0;
}

module.exports = windingLine;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// Simple LRU cache use doubly linked list
// @module zrender/core/LRU

/**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 */
var LinkedList = function () {
  /**
   * @type {module:zrender/core/LRU~Entry}
   */
  this.head = null;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.tail = null;
  this._len = 0;
};

var linkedListProto = LinkedList.prototype;
/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {module:zrender/core/LRU~Entry}
 */

linkedListProto.insert = function (val) {
  var entry = new Entry(val);
  this.insertEntry(entry);
  return entry;
};
/**
 * Insert an entry at the tail
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.insertEntry = function (entry) {
  if (!this.head) {
    this.head = this.tail = entry;
  } else {
    this.tail.next = entry;
    entry.prev = this.tail;
    entry.next = null;
    this.tail = entry;
  }

  this._len++;
};
/**
 * Remove entry.
 * @param  {module:zrender/core/LRU~Entry} entry
 */


linkedListProto.remove = function (entry) {
  var prev = entry.prev;
  var next = entry.next;

  if (prev) {
    prev.next = next;
  } else {
    // Is head
    this.head = next;
  }

  if (next) {
    next.prev = prev;
  } else {
    // Is tail
    this.tail = prev;
  }

  entry.next = entry.prev = null;
  this._len--;
};
/**
 * @return {number}
 */


linkedListProto.len = function () {
  return this._len;
};
/**
 * Clear list
 */


linkedListProto.clear = function () {
  this.head = this.tail = null;
  this._len = 0;
};
/**
 * @constructor
 * @param {} val
 */


var Entry = function (val) {
  /**
   * @type {}
   */
  this.value = val;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.next;
  /**
   * @type {module:zrender/core/LRU~Entry}
   */

  this.prev;
};
/**
 * LRU Cache
 * @constructor
 * @alias module:zrender/core/LRU
 */


var LRU = function (maxSize) {
  this._list = new LinkedList();
  this._map = {};
  this._maxSize = maxSize || 10;
  this._lastRemovedEntry = null;
};

var LRUProto = LRU.prototype;
/**
 * @param  {string} key
 * @param  {} value
 * @return {} Removed value
 */

LRUProto.put = function (key, value) {
  var list = this._list;
  var map = this._map;
  var removed = null;

  if (map[key] == null) {
    var len = list.len(); // Reuse last removed entry

    var entry = this._lastRemovedEntry;

    if (len >= this._maxSize && len > 0) {
      // Remove the least recently used
      var leastUsedEntry = list.head;
      list.remove(leastUsedEntry);
      delete map[leastUsedEntry.key];
      removed = leastUsedEntry.value;
      this._lastRemovedEntry = leastUsedEntry;
    }

    if (entry) {
      entry.value = value;
    } else {
      entry = new Entry(value);
    }

    entry.key = key;
    list.insertEntry(entry);
    map[key] = entry;
  }

  return removed;
};
/**
 * @param  {string} key
 * @return {}
 */


LRUProto.get = function (key) {
  var entry = this._map[key];
  var list = this._list;

  if (entry != null) {
    // Put the latest used entry in the tail
    if (entry !== list.tail) {
      list.remove(entry);
      list.insertEntry(entry);
    }

    return entry.value;
  }
};
/**
 * Clear the cache
 */


LRUProto.clear = function () {
  this._list.clear();

  this._map = {};
};

var _default = LRU;
module.exports = _default;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var vec2 = __webpack_require__(53);

var curve = __webpack_require__(154);

/**
 * @author Yi Shen(https://github.com/pissang)
 */
var mathMin = Math.min;
var mathMax = Math.max;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI2 = Math.PI * 2;
var start = vec2.create();
var end = vec2.create();
var extremity = vec2.create();
/**
 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
 * @module zrender/core/bbox
 * @param {Array<Object>} points 顶点数组
 * @param {number} min
 * @param {number} max
 */

function fromPoints(points, min, max) {
  if (points.length === 0) {
    return;
  }

  var p = points[0];
  var left = p[0];
  var right = p[0];
  var top = p[1];
  var bottom = p[1];
  var i;

  for (i = 1; i < points.length; i++) {
    p = points[i];
    left = mathMin(left, p[0]);
    right = mathMax(right, p[0]);
    top = mathMin(top, p[1]);
    bottom = mathMax(bottom, p[1]);
  }

  min[0] = left;
  min[1] = top;
  max[0] = right;
  max[1] = bottom;
}
/**
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromLine(x0, y0, x1, y1, min, max) {
  min[0] = mathMin(x0, x1);
  min[1] = mathMin(y0, y1);
  max[0] = mathMax(x0, x1);
  max[1] = mathMax(y0, y1);
}

var xDim = [];
var yDim = [];
/**
 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {number} x3
 * @param {number} y3
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */

function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
  var cubicExtrema = curve.cubicExtrema;
  var cubicAt = curve.cubicAt;
  var i;
  var n = cubicExtrema(x0, x1, x2, x3, xDim);
  min[0] = Infinity;
  min[1] = Infinity;
  max[0] = -Infinity;
  max[1] = -Infinity;

  for (i = 0; i < n; i++) {
    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
    min[0] = mathMin(x, min[0]);
    max[0] = mathMax(x, max[0]);
  }

  n = cubicExtrema(y0, y1, y2, y3, yDim);

  for (i = 0; i < n; i++) {
    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
    min[1] = mathMin(y, min[1]);
    max[1] = mathMax(y, max[1]);
  }

  min[0] = mathMin(x0, min[0]);
  max[0] = mathMax(x0, max[0]);
  min[0] = mathMin(x3, min[0]);
  max[0] = mathMax(x3, max[0]);
  min[1] = mathMin(y0, min[1]);
  max[1] = mathMax(y0, max[1]);
  min[1] = mathMin(y3, min[1]);
  max[1] = mathMax(y3, max[1]);
}
/**
 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
 * @memberOf module:zrender/core/bbox
 * @param {number} x0
 * @param {number} y0
 * @param {number} x1
 * @param {number} y1
 * @param {number} x2
 * @param {number} y2
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
  var quadraticExtremum = curve.quadraticExtremum;
  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero

  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
  var x = quadraticAt(x0, x1, x2, tx);
  var y = quadraticAt(y0, y1, y2, ty);
  min[0] = mathMin(x0, x2, x);
  min[1] = mathMin(y0, y2, y);
  max[0] = mathMax(x0, x2, x);
  max[1] = mathMax(y0, y2, y);
}
/**
 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
 * @method
 * @memberOf module:zrender/core/bbox
 * @param {number} x
 * @param {number} y
 * @param {number} rx
 * @param {number} ry
 * @param {number} startAngle
 * @param {number} endAngle
 * @param {number} anticlockwise
 * @param {Array.<number>} min
 * @param {Array.<number>} max
 */


function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
  var vec2Min = vec2.min;
  var vec2Max = vec2.max;
  var diff = Math.abs(startAngle - endAngle);

  if (diff % PI2 < 1e-4 && diff > 1e-4) {
    // Is a circle
    min[0] = x - rx;
    min[1] = y - ry;
    max[0] = x + rx;
    max[1] = y + ry;
    return;
  }

  start[0] = mathCos(startAngle) * rx + x;
  start[1] = mathSin(startAngle) * ry + y;
  end[0] = mathCos(endAngle) * rx + x;
  end[1] = mathSin(endAngle) * ry + y;
  vec2Min(min, start, end);
  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]

  startAngle = startAngle % PI2;

  if (startAngle < 0) {
    startAngle = startAngle + PI2;
  }

  endAngle = endAngle % PI2;

  if (endAngle < 0) {
    endAngle = endAngle + PI2;
  }

  if (startAngle > endAngle && !anticlockwise) {
    endAngle += PI2;
  } else if (startAngle < endAngle && anticlockwise) {
    startAngle += PI2;
  }

  if (anticlockwise) {
    var tmp = endAngle;
    endAngle = startAngle;
    startAngle = tmp;
  } // var number = 0;
  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;


  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
    if (angle > startAngle) {
      extremity[0] = mathCos(angle) * rx + x;
      extremity[1] = mathSin(angle) * ry + y;
      vec2Min(min, extremity, min);
      vec2Max(max, extremity, max);
    }
  }
}

exports.fromPoints = fromPoints;
exports.fromLine = fromLine;
exports.fromCubic = fromCubic;
exports.fromQuadratic = fromQuadratic;
exports.fromArc = fromArc;

/***/ }),
/* 711 */
/***/ (function(module, exports) {

/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */
var idStart = 0x0907;

function _default() {
  return idStart++;
}

module.exports = _default;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

var Pattern = function (image, repeat) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {image: ...}`, where this constructor will not be called.
  this.image = image;
  this.repeat = repeat; // Can be cloned

  this.type = 'pattern';
};

Pattern.prototype.getCanvasPattern = function (ctx) {
  return ctx.createPattern(this.image, this.repeat || 'repeat');
};

var _default = Pattern;
module.exports = _default;

/***/ }),
/* 713 */
/***/ (function(module, exports) {

var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);

var Style = function (opts, host) {
  this.extendFrom(opts, false);
  this.host = host;
};

function createLinearGradient(ctx, obj, rect) {
  var x = obj.x == null ? 0 : obj.x;
  var x2 = obj.x2 == null ? 1 : obj.x2;
  var y = obj.y == null ? 0 : obj.y;
  var y2 = obj.y2 == null ? 0 : obj.y2;

  if (!obj.global) {
    x = x * rect.width + rect.x;
    x2 = x2 * rect.width + rect.x;
    y = y * rect.height + rect.y;
    y2 = y2 * rect.height + rect.y;
  }

  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
  return canvasGradient;
}

function createRadialGradient(ctx, obj, rect) {
  var width = rect.width;
  var height = rect.height;
  var min = Math.min(width, height);
  var x = obj.x == null ? 0.5 : obj.x;
  var y = obj.y == null ? 0.5 : obj.y;
  var r = obj.r == null ? 0.5 : obj.r;

  if (!obj.global) {
    x = x * width + rect.x;
    y = y * height + rect.y;
    r = r * min;
  }

  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
  return canvasGradient;
}

Style.prototype = {
  constructor: Style,

  /**
   * @type {module:zrender/graphic/Displayable}
   */
  host: null,

  /**
   * @type {string}
   */
  fill: '#000',

  /**
   * @type {string}
   */
  stroke: null,

  /**
   * @type {number}
   */
  opacity: 1,

  /**
   * @type {Array.<number>}
   */
  lineDash: null,

  /**
   * @type {number}
   */
  lineDashOffset: 0,

  /**
   * @type {number}
   */
  shadowBlur: 0,

  /**
   * @type {number}
   */
  shadowOffsetX: 0,

  /**
   * @type {number}
   */
  shadowOffsetY: 0,

  /**
   * @type {number}
   */
  lineWidth: 1,

  /**
   * If stroke ignore scale
   * @type {Boolean}
   */
  strokeNoScale: false,
  // Bounding rect text configuration
  // Not affected by element transform

  /**
   * @type {string}
   */
  text: null,

  /**
   * If `fontSize` or `fontFamily` exists, `font` will be reset by
   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
   * So do not visit it directly in upper application (like echarts),
   * but use `contain/text#makeFont` instead.
   * @type {string}
   */
  font: null,

  /**
   * The same as font. Use font please.
   * @deprecated
   * @type {string}
   */
  textFont: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontStyle: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontWeight: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * Should be 12 but not '12px'.
   * @type {number}
   */
  fontSize: null,

  /**
   * It helps merging respectively, rather than parsing an entire font string.
   * @type {string}
   */
  fontFamily: null,

  /**
   * Reserved for special functinality, like 'hr'.
   * @type {string}
   */
  textTag: null,

  /**
   * @type {string}
   */
  textFill: '#000',

  /**
   * @type {string}
   */
  textStroke: null,

  /**
   * @type {number}
   */
  textWidth: null,

  /**
   * Only for textBackground.
   * @type {number}
   */
  textHeight: null,

  /**
   * textStroke may be set as some color as a default
   * value in upper applicaion, where the default value
   * of textStrokeWidth should be 0 to make sure that
   * user can choose to do not use text stroke.
   * @type {number}
   */
  textStrokeWidth: 0,

  /**
   * @type {number}
   */
  textLineHeight: null,

  /**
   * 'inside', 'left', 'right', 'top', 'bottom'
   * [x, y]
   * Based on x, y of rect.
   * @type {string|Array.<number>}
   * @default 'inside'
   */
  textPosition: 'inside',

  /**
   * If not specified, use the boundingRect of a `displayable`.
   * @type {Object}
   */
  textRect: null,

  /**
   * [x, y]
   * @type {Array.<number>}
   */
  textOffset: null,

  /**
   * @type {string}
   */
  textAlign: null,

  /**
   * @type {string}
   */
  textVerticalAlign: null,

  /**
   * @type {number}
   */
  textDistance: 5,

  /**
   * @type {string}
   */
  textShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textShadowBlur: 0,

  /**
   * @type {number}
   */
  textShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textShadowOffsetY: 0,

  /**
   * @type {string}
   */
  textBoxShadowColor: 'transparent',

  /**
   * @type {number}
   */
  textBoxShadowBlur: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetX: 0,

  /**
   * @type {number}
   */
  textBoxShadowOffsetY: 0,

  /**
   * Whether transform text.
   * Only useful in Path and Image element
   * @type {boolean}
   */
  transformText: false,

  /**
   * Text rotate around position of Path or Image
   * Only useful in Path and Image element and transformText is false.
   */
  textRotation: 0,

  /**
   * Text origin of text rotation, like [10, 40].
   * Based on x, y of rect.
   * Useful in label rotation of circular symbol.
   * By default, this origin is textPosition.
   * Can be 'center'.
   * @type {string|Array.<number>}
   */
  textOrigin: null,

  /**
   * @type {string}
   */
  textBackgroundColor: null,

  /**
   * @type {string}
   */
  textBorderColor: null,

  /**
   * @type {number}
   */
  textBorderWidth: 0,

  /**
   * @type {number}
   */
  textBorderRadius: 0,

  /**
   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
   * @type {number|Array.<number>}
   */
  textPadding: null,

  /**
   * Text styles for rich text.
   * @type {Object}
   */
  rich: null,

  /**
   * {outerWidth, outerHeight, ellipsis, placeholder}
   * @type {Object}
   */
  truncate: null,

  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
   * @type {string}
   */
  blend: null,

  /**
   * @param {CanvasRenderingContext2D} ctx
   */
  bind: function (ctx, el, prevEl) {
    var style = this;
    var prevStyle = prevEl && prevEl.style;
    var firstDraw = !prevStyle;

    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
      var prop = STYLE_COMMON_PROPS[i];
      var styleName = prop[0];

      if (firstDraw || style[styleName] !== prevStyle[styleName]) {
        // FIXME Invalid property value will cause style leak from previous element.
        ctx[styleName] = style[styleName] || prop[1];
      }
    }

    if (firstDraw || style.fill !== prevStyle.fill) {
      ctx.fillStyle = style.fill;
    }

    if (firstDraw || style.stroke !== prevStyle.stroke) {
      ctx.strokeStyle = style.stroke;
    }

    if (firstDraw || style.opacity !== prevStyle.opacity) {
      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }

    if (firstDraw || style.blend !== prevStyle.blend) {
      ctx.globalCompositeOperation = style.blend || 'source-over';
    }

    if (this.hasStroke()) {
      var lineWidth = style.lineWidth;
      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
    }
  },
  hasFill: function () {
    var fill = this.fill;
    return fill != null && fill !== 'none';
  },
  hasStroke: function () {
    var stroke = this.stroke;
    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
  },

  /**
   * Extend from other style
   * @param {zrender/graphic/Style} otherStyle
   * @param {boolean} overwrite true: overwrirte any way.
   *                            false: overwrite only when !target.hasOwnProperty
   *                            others: overwrite when property is not null/undefined.
   */
  extendFrom: function (otherStyle, overwrite) {
    if (otherStyle) {
      for (var name in otherStyle) {
        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
          this[name] = otherStyle[name];
        }
      }
    }
  },

  /**
   * Batch setting style with a given object
   * @param {Object|string} obj
   * @param {*} [obj]
   */
  set: function (obj, value) {
    if (typeof obj === 'string') {
      this[obj] = value;
    } else {
      this.extendFrom(obj, true);
    }
  },

  /**
   * Clone
   * @return {zrender/graphic/Style} [description]
   */
  clone: function () {
    var newStyle = new this.constructor();
    newStyle.extendFrom(this, true);
    return newStyle;
  },
  getGradient: function (ctx, obj, rect) {
    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
    var canvasGradient = method(ctx, obj, rect);
    var colorStops = obj.colorStops;

    for (var i = 0; i < colorStops.length; i++) {
      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    }

    return canvasGradient;
  }
};
var styleProto = Style.prototype;

for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
  var prop = STYLE_COMMON_PROPS[i];

  if (!(prop[0] in styleProto)) {
    styleProto[prop[0]] = prop[1];
  }
} // Provide for others


Style.getGradient = styleProto.getGradient;
var _default = Style;
module.exports = _default;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var env = __webpack_require__(64);

// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
// where exception "unexpected call to method or property access"
// might be thrown when calling ctx.fill or ctx.stroke after a path
// whose area size is zero is drawn and ctx.clip() is called and
// shadowBlur is set. See #4572, #3112, #5777.
// (e.g.,
//  ctx.moveTo(10, 10);
//  ctx.lineTo(20, 10);
//  ctx.closePath();
//  ctx.clip();
//  ctx.shadowBlur = 10;
//  ...
//  ctx.fill();
// )
var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];

function _default(orignalBrush) {
  // version string can be: '11.0'
  return env.browser.ie && env.browser.version >= 11 ? function () {
    var clipPaths = this.__clipPaths;
    var style = this.style;
    var modified;

    if (clipPaths) {
      for (var i = 0; i < clipPaths.length; i++) {
        var clipPath = clipPaths[i];
        var shape = clipPath && clipPath.shape;
        var type = clipPath && clipPath.type;

        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
          for (var j = 0; j < shadowTemp.length; j++) {
            // It is save to put shadowTemp static, because shadowTemp
            // will be all modified each item brush called.
            shadowTemp[j][2] = style[shadowTemp[j][0]];
            style[shadowTemp[j][0]] = shadowTemp[j][1];
          }

          modified = true;
          break;
        }
      }
    }

    orignalBrush.apply(this, arguments);

    if (modified) {
      for (var j = 0; j < shadowTemp.length; j++) {
        style[shadowTemp[j][0]] = shadowTemp[j][2];
      }
    }
  } : orignalBrush;
}

module.exports = _default;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var smoothSpline = __webpack_require__(1930);

var smoothBezier = __webpack_require__(1929);

function buildPath(ctx, shape, closePath) {
  var points = shape.points;
  var smooth = shape.smooth;

  if (points && points.length >= 2) {
    if (smooth && smooth !== 'spline') {
      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
      ctx.moveTo(points[0][0], points[0][1]);
      var len = points.length;

      for (var i = 0; i < (closePath ? len : len - 1); i++) {
        var cp1 = controlPoints[i * 2];
        var cp2 = controlPoints[i * 2 + 1];
        var p = points[(i + 1) % len];
        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
      }
    } else {
      if (smooth === 'spline') {
        points = smoothSpline(points, closePath);
      }

      ctx.moveTo(points[0][0], points[0][1]);

      for (var i = 1, l = points.length; i < l; i++) {
        ctx.lineTo(points[i][0], points[i][1]);
      }
    }

    closePath && ctx.closePath();
  }
}

exports.buildPath = buildPath;

/***/ }),
/* 716 */
/***/ (function(module, exports) {

function buildPath(ctx, shape) {
  var x = shape.x;
  var y = shape.y;
  var width = shape.width;
  var height = shape.height;
  var r = shape.r;
  var r1;
  var r2;
  var r3;
  var r4; // Convert width and height to positive for better borderRadius

  if (width < 0) {
    x = x + width;
    width = -width;
  }

  if (height < 0) {
    y = y + height;
    height = -height;
  }

  if (typeof r === 'number') {
    r1 = r2 = r3 = r4 = r;
  } else if (r instanceof Array) {
    if (r.length === 1) {
      r1 = r2 = r3 = r4 = r[0];
    } else if (r.length === 2) {
      r1 = r3 = r[0];
      r2 = r4 = r[1];
    } else if (r.length === 3) {
      r1 = r[0];
      r2 = r4 = r[1];
      r3 = r[2];
    } else {
      r1 = r[0];
      r2 = r[1];
      r3 = r[2];
      r4 = r[3];
    }
  } else {
    r1 = r2 = r3 = r4 = 0;
  }

  var total;

  if (r1 + r2 > width) {
    total = r1 + r2;
    r1 *= width / total;
    r2 *= width / total;
  }

  if (r3 + r4 > width) {
    total = r3 + r4;
    r3 *= width / total;
    r4 *= width / total;
  }

  if (r2 + r3 > height) {
    total = r2 + r3;
    r2 *= height / total;
    r3 *= height / total;
  }

  if (r1 + r4 > height) {
    total = r1 + r4;
    r1 *= height / total;
    r4 *= height / total;
  }

  ctx.moveTo(x + r1, y);
  ctx.lineTo(x + width - r2, y);
  r2 !== 0 && ctx.quadraticCurveTo(x + width, y, x + width, y + r2);
  ctx.lineTo(x + width, y + height - r3);
  r3 !== 0 && ctx.quadraticCurveTo(x + width, y + height, x + width - r3, y + height);
  ctx.lineTo(x + r4, y + height);
  r4 !== 0 && ctx.quadraticCurveTo(x, y + height, x, y + height - r4);
  ctx.lineTo(x, y + r1);
  r1 !== 0 && ctx.quadraticCurveTo(x, y, x + r1, y);
}

exports.buildPath = buildPath;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var matrix = __webpack_require__(127);

var vector = __webpack_require__(53);

/**
 * 提供变换扩展
 * @module zrender/mixin/Transformable
 * @author pissang (https://www.github.com/pissang)
 */
var mIdentity = matrix.identity;
var EPSILON = 5e-5;

function isNotAroundZero(val) {
  return val > EPSILON || val < -EPSILON;
}
/**
 * @alias module:zrender/mixin/Transformable
 * @constructor
 */


var Transformable = function (opts) {
  opts = opts || {}; // If there are no given position, rotation, scale

  if (!opts.position) {
    /**
     * 平移
     * @type {Array.<number>}
     * @default [0, 0]
     */
    this.position = [0, 0];
  }

  if (opts.rotation == null) {
    /**
     * 旋转
     * @type {Array.<number>}
     * @default 0
     */
    this.rotation = 0;
  }

  if (!opts.scale) {
    /**
     * 缩放
     * @type {Array.<number>}
     * @default [1, 1]
     */
    this.scale = [1, 1];
  }
  /**
   * 旋转和缩放的原点
   * @type {Array.<number>}
   * @default null
   */


  this.origin = this.origin || null;
};

var transformableProto = Transformable.prototype;
transformableProto.transform = null;
/**
 * 判断是否需要有坐标变换
 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
 */

transformableProto.needLocalTransform = function () {
  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
};

transformableProto.updateTransform = function () {
  var parent = this.parent;
  var parentHasTransform = parent && parent.transform;
  var needLocalTransform = this.needLocalTransform();
  var m = this.transform;

  if (!(needLocalTransform || parentHasTransform)) {
    m && mIdentity(m);
    return;
  }

  m = m || matrix.create();

  if (needLocalTransform) {
    this.getLocalTransform(m);
  } else {
    mIdentity(m);
  } // 应用父节点变换


  if (parentHasTransform) {
    if (needLocalTransform) {
      matrix.mul(m, parent.transform, m);
    } else {
      matrix.copy(m, parent.transform);
    }
  } // 保存这个变换矩阵


  this.transform = m;
  this.invTransform = this.invTransform || matrix.create();
  matrix.invert(this.invTransform, m);
};

transformableProto.getLocalTransform = function (m) {
  return Transformable.getLocalTransform(this, m);
};
/**
 * 将自己的transform应用到context上
 * @param {CanvasRenderingContext2D} ctx
 */


transformableProto.setTransform = function (ctx) {
  var m = this.transform;
  var dpr = ctx.dpr || 1;

  if (m) {
    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
  } else {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
};

transformableProto.restoreTransform = function (ctx) {
  var dpr = ctx.dpr || 1;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};

var tmpTransform = [];
/**
 * 分解`transform`矩阵到`position`, `rotation`, `scale`
 */

transformableProto.decomposeTransform = function () {
  if (!this.transform) {
    return;
  }

  var parent = this.parent;
  var m = this.transform;

  if (parent && parent.transform) {
    // Get local transform and decompose them to position, scale, rotation
    matrix.mul(tmpTransform, parent.invTransform, m);
    m = tmpTransform;
  }

  var sx = m[0] * m[0] + m[1] * m[1];
  var sy = m[2] * m[2] + m[3] * m[3];
  var position = this.position;
  var scale = this.scale;

  if (isNotAroundZero(sx - 1)) {
    sx = Math.sqrt(sx);
  }

  if (isNotAroundZero(sy - 1)) {
    sy = Math.sqrt(sy);
  }

  if (m[0] < 0) {
    sx = -sx;
  }

  if (m[3] < 0) {
    sy = -sy;
  }

  position[0] = m[4];
  position[1] = m[5];
  scale[0] = sx;
  scale[1] = sy;
  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
};
/**
 * Get global scale
 * @return {Array.<number>}
 */


transformableProto.getGlobalScale = function () {
  var m = this.transform;

  if (!m) {
    return [1, 1];
  }

  var sx = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
  var sy = Math.sqrt(m[2] * m[2] + m[3] * m[3]);

  if (m[0] < 0) {
    sx = -sx;
  }

  if (m[3] < 0) {
    sy = -sy;
  }

  return [sx, sy];
};
/**
 * 变换坐标位置到 shape 的局部坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToLocal = function (x, y) {
  var v2 = [x, y];
  var invTransform = this.invTransform;

  if (invTransform) {
    vector.applyTransform(v2, v2, invTransform);
  }

  return v2;
};
/**
 * 变换局部坐标位置到全局坐标空间
 * @method
 * @param {number} x
 * @param {number} y
 * @return {Array.<number>}
 */


transformableProto.transformCoordToGlobal = function (x, y) {
  var v2 = [x, y];
  var transform = this.transform;

  if (transform) {
    vector.applyTransform(v2, v2, transform);
  }

  return v2;
};
/**
 * @static
 * @param {Object} target
 * @param {Array.<number>} target.origin
 * @param {number} target.rotation
 * @param {Array.<number>} target.position
 * @param {Array.<number>} [m]
 */


Transformable.getLocalTransform = function (target, m) {
  m = m || [];
  mIdentity(m);
  var origin = target.origin;
  var scale = target.scale || [1, 1];
  var rotation = target.rotation || 0;
  var position = target.position || [0, 0];

  if (origin) {
    // Translate to origin
    m[4] -= origin[0];
    m[5] -= origin[1];
  }

  matrix.scale(m, m, scale);

  if (rotation) {
    matrix.rotate(m, m, rotation);
  }

  if (origin) {
    // Translate back from origin
    m[4] += origin[0];
    m[5] += origin[1];
  }

  m[4] += position[0];
  m[5] += position[1];
  return m;
};

var _default = Transformable;
module.exports = _default;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(402);

var createElement = _core.createElement;

var zrUtil = __webpack_require__(6);

var Path = __webpack_require__(54);

var ZImage = __webpack_require__(263);

var ZText = __webpack_require__(264);

var _graphic = __webpack_require__(403);

var svgPath = _graphic.path;
var svgImage = _graphic.image;
var svgText = _graphic.text;

/**
 * @file Manages elements that can be defined in <defs> in SVG,
 *       e.g., gradients, clip path, etc.
 * @author Zhang Wenli
 */
var MARK_UNUSED = '0';
var MARK_USED = '1';
/**
 * Manages elements that can be defined in <defs> in SVG,
 * e.g., gradients, clip path, etc.
 *
 * @class
 * @param {SVGElement}      svgRoot   root of SVG document
 * @param {string|string[]} tagNames  possible tag names
 * @param {string}          markLabel label name to make if the element
 *                                    is used
 */

function Definable(svgRoot, tagNames, markLabel) {
  this._svgRoot = svgRoot;
  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
  this._markLabel = markLabel;
  this.nextId = 0;
}

Definable.prototype.createElement = createElement;
/**
 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
 *
 * @param {boolean} isForceCreating if need to create when not exists
 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
 * exist and isForceCreating is false
 */

Definable.prototype.getDefs = function (isForceCreating) {
  var svgRoot = this._svgRoot;

  var defs = this._svgRoot.getElementsByTagName('defs');

  if (defs.length === 0) {
    // Not exist
    if (isForceCreating) {
      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
      svgRoot.firstChild // Insert in the front of svg
      );

      if (!defs.contains) {
        // IE doesn't support contains method
        defs.contains = function (el) {
          var children = defs.children;

          if (!children) {
            return false;
          }

          for (var i = children.length - 1; i >= 0; --i) {
            if (children[i] === el) {
              return true;
            }
          }

          return false;
        };
      }

      return defs;
    } else {
      return null;
    }
  } else {
    return defs[0];
  }
};
/**
 * Update DOM element if necessary.
 *
 * @param {Object|string} element style element. e.g., for gradient,
 *                                it may be '#ccc' or {type: 'linear', ...}
 * @param {Function|undefined} onUpdate update callback
 */


Definable.prototype.update = function (element, onUpdate) {
  if (!element) {
    return;
  }

  var defs = this.getDefs(false);

  if (element._dom && defs.contains(element._dom)) {
    // Update DOM
    if (typeof onUpdate === 'function') {
      onUpdate();
    }
  } else {
    // No previous dom, create new
    var dom = this.add(element);

    if (dom) {
      element._dom = dom;
    }
  }
};
/**
 * Add gradient dom to defs
 *
 * @param {SVGElement} dom DOM to be added to <defs>
 */


Definable.prototype.addDom = function (dom) {
  var defs = this.getDefs(true);
  defs.appendChild(dom);
};
/**
 * Remove DOM of a given element.
 *
 * @param {SVGElement} element element to remove dom
 */


Definable.prototype.removeDom = function (element) {
  var defs = this.getDefs(false);
  defs.removeChild(element._dom);
};
/**
 * Get DOMs of this element.
 *
 * @return {HTMLDomElement} doms of this defineable elements in <defs>
 */


Definable.prototype.getDoms = function () {
  var defs = this.getDefs(false);

  if (!defs) {
    // No dom when defs is not defined
    return [];
  }

  var doms = [];
  zrUtil.each(this._tagNames, function (tagName) {
    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
    // rather than real array.
    // So `doms.concat(tags)` add tags as one object.

    doms = doms.concat([].slice.call(tags));
  });
  return doms;
};
/**
 * Mark DOMs to be unused before painting, and clear unused ones at the end
 * of the painting.
 */


Definable.prototype.markAllUnused = function () {
  var doms = this.getDoms();
  var that = this;
  zrUtil.each(doms, function (dom) {
    dom[that._markLabel] = MARK_UNUSED;
  });
};
/**
 * Mark a single DOM to be used.
 *
 * @param {SVGElement} dom DOM to mark
 */


Definable.prototype.markUsed = function (dom) {
  if (dom) {
    dom[this._markLabel] = MARK_USED;
  }
};
/**
 * Remove unused DOMs defined in <defs>
 */


Definable.prototype.removeUnused = function () {
  var defs = this.getDefs(false);

  if (!defs) {
    // Nothing to remove
    return;
  }

  var doms = this.getDoms();
  var that = this;
  zrUtil.each(doms, function (dom) {
    if (dom[that._markLabel] !== MARK_USED) {
      // Remove gradient
      defs.removeChild(dom);
    }
  });
};
/**
 * Get SVG proxy.
 *
 * @param {Displayable} displayable displayable element
 * @return {Path|Image|Text} svg proxy of given element
 */


Definable.prototype.getSvgProxy = function (displayable) {
  if (displayable instanceof Path) {
    return svgPath;
  } else if (displayable instanceof ZImage) {
    return svgImage;
  } else if (displayable instanceof ZText) {
    return svgText;
  } else {
    return svgPath;
  }
};
/**
 * Get text SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element of text
 */


Definable.prototype.getTextSvgElement = function (displayable) {
  return displayable.__textSvgEl;
};
/**
 * Get SVG element.
 *
 * @param {Displayable} displayable displayable element
 * @return {SVGElement} SVG element
 */


Definable.prototype.getSvgElement = function (displayable) {
  return displayable.__svgEl;
};

var _default = Definable;
module.exports = _default;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1151).enable();
  window.Promise = __webpack_require__(1150);
}

// fetch() polyfill for making API calls.
__webpack_require__(1909);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(24);


/***/ }),
/* 720 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalSelect_css__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalSelect_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ModalSelectTip = function (_Component) {
  _inherits(ModalSelectTip, _Component);

  function ModalSelectTip(props) {
    _classCallCheck(this, ModalSelectTip);

    var _this = _possibleConstructorReturn(this, (ModalSelectTip.__proto__ || Object.getPrototypeOf(ModalSelectTip)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ModalSelectTip, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","")
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'containerModal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modalView' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'titleText', style: { marginTop: this.props.titleBC ? 6 : 20 } },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentText' },
              this.props.content ? this.props.content : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u672C\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u53CA\u57FA\u91D1\u9500\u552E\u670D\u52A1\u7531\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u534E\u590F\u8D22\u5BCC\uFF09\u63D0\u4F9B\u3002'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u534E\u590F\u8D22\u5BCC\u4E3A\u534E\u590F\u57FA\u91D1\u5168\u8D44\u5B50\u516C\u53F8\uFF0C\u62E5\u6709\u8BC1\u76D1\u4F1A\u9881\u53D1\u7684\u57FA\u91D1\u9500\u552E\u8D44\u683C\uFF0C2019\u5E7410\u6708\u9996\u6279\u83B7\u5F97\u8BC1\u76D1\u4F1A\u6279\u51C6\u8BD5\u70B9\u5F00\u5C55\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u3002'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E3A\u534E\u590F\u8D22\u5BCC\u63A5\u53D7\u6295\u8D44\u8005\u59D4\u6258\uFF0C\u6309\u7167\u7EA6\u5B9A\u5411\u6295\u8D44\u8005\u63D0\u4F9B\u7684\u6839\u636E\u6295\u8D44\u8005\u4E2A\u4EBA\u60C5\u51B5\uFF0C\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u6784\u5EFA\u6295\u8D44\u7EC4\u5408\u53CA\u6295\u8D44\u4EA4\u6613\u7684\u6295\u8D44\u987E\u95EE\u670D\u52A1\u5DE5\u5177\uFF0C\u5176\u5B9E\u8D28\u4E3A\u6295\u8D44\u7279\u5B9A\u6295\u8D44\u7EC4\u5408\u6240\u5305\u542B\u7684\u516C\u52DF\u57FA\u91D1\u4EA7\u54C1\u6216\u7ECF\u4E2D\u56FD\u8BC1\u76D1\u4F1A\u8BA4\u53EF\u7684\u540C\u7C7B\u4EA7\u54C1\u3002'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u6709\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4EE5\u4E0B\u7279\u70B9\uFF1A'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '1\u3001 \u5728\u7B26\u5408\u76F8\u5173\u4E1A\u52A1\u89C4\u8303\u53CA\u5408\u89C4\u64CD\u4F5C\u7684\u524D\u63D0\u4E0B\uFF0C\u7EC4\u5408\u7531\u4E13\u4E1A\u8D44\u4EA7\u914D\u7F6E\u56E2\u961F\uFF0C',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: '#fa063a' } },
                    '\u6839\u636E\u5E02\u573A\u884C\u60C5\u4E0E\u7EC4\u5408\u8868\u73B0\u60C5\u51B5\u8FDB\u884C\u81EA\u52A8\u8C03\u4ED3'
                  ),
                  '\uFF0C\u6295\u8D44\u8005\u53EF\u5728\u6709\u5173\u4FE1\u606F\u62AB\u9732\u4E2D\u67E5\u8BE2\u3002'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '2\u3001 \u4F9D\u636E\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u300A\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u7B49\u6587\u4EF6\u7684\u89C4\u5B9A\uFF0C\u6839\u636E\u6295\u8D44\u8005\u59D4\u6258\u5411\u5176\u63D0\u4F9B\u7BA1\u7406\u578B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: '#fa063a' } },
                    '\u6709\u6743\u5411\u6295\u8D44\u8005\u6536\u53D6\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39'
                  ),
                  '\u3002'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u8BF7\u6295\u8D44\u8005\u52A1\u5FC5\u4E8E\u7533\u8BF7\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u4E4B\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u300A\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u3001\u534E\u590F\u8D22\u5BCC\u4EA4\u6613\u5E73\u53F0\u76F8\u5173\u7684\u4E1A\u52A1\u89C4\u5219\u53CA\u98CE\u9669\u63ED\u793A\u4E66\uFF0C\u5145\u5206\u4E86\u89E3\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u89C4\u5219\u3001\u6536\u8D39\u65B9\u5F0F\u3001\u514D\u8D23\u60C5\u5F62\u3001\u4E00\u822C\u53CA\u7279\u6709\u98CE\u9669\u7B49\u5185\u5BB9\u3002'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentTwoText' },
              this.props.contentBC ? this.props.contentBC : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u98CE\u9669\u63D0\u793A\uFF1A\u672C\u516C\u53F8\u627F\u8BFA\u4EE5\u8BDA\u5B9E\u4FE1\u7528\u3001\u52E4\u52C9\u5C3D\u8D23\u7684\u539F\u5219\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u4E3A\u6295\u8D44\u8005\u8C03\u4ED3\uFF0C\u4F46\u4E0D\u4FDD\u8BC1\u6295\u987E\u8D26\u6237\u4E00\u5B9A\u76C8\u5229\uFF0C\u6295\u8D44\u8005\u9700\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\uFF0C\u7EC4\u5408\u8FC7\u5F80\u4E1A\u7EE9\u4E0D\u4EE3\u8868\u672A\u6765\u8868\u73B0\uFF0C\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'footView', style: { bottom: document.documentElement.clientHeight / 2 - 550 / 2 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    return _this2.props.onOK();
                  } },
                this.props.rightButtonTitle
              )
            )
          )
        ) : null
      );
    }
  }]);

  return ModalSelectTip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ModalSelectTip.defaultProps = {
  leftButtonTitle: '取消',
  rightButtonTitle: '确认',
  content: '',
  contentBC: '',
  onCancel: function onCancel() {},
  onOK: function onOK() {},
  titleBC: '',
  title: '',
  flag: false
};


/* harmony default export */ __webpack_exports__["a"] = (ModalSelectTip);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__myAssets_payment_PayWarmTips__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__myAssets_payment_PayCardSuperFund__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_loginAction__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_myAssets_userInfoAction__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getPay__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { Link } from 'react-router-dom';















var PaymentSuperFund = function (_Component) {
  _inherits(PaymentSuperFund, _Component);

  function PaymentSuperFund(props) {
    _classCallCheck(this, PaymentSuperFund);

    var _this2 = _possibleConstructorReturn(this, (PaymentSuperFund.__proto__ || Object.getPrototypeOf(PaymentSuperFund)).call(this, props));

    _this2.keyOk = function () {
      var _this2$props = _this2.props,
          navigator = _this2$props.navigator,
          payInfoData = _this2$props.payInfoData,
          businessType = _this2$props.businessType,
          dispatch = _this2$props.dispatch;
      var _this2$props2 = _this2.props,
          fundName = _this2$props2.fundName,
          fundCode = _this2$props2.fundCode; //navigator 传入

      var _this = _this2;
      var amount = _this2.state.amount;
      var paymentText = _this2.props.paymentText;

      var pushResult = function pushResult(i, result) {
        if (i == 1) {
          console.log("020202002020202022");
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '支付完成',
              content: '支付成功',
              dataSouse: [['申请编号', result.content.requestId], ['产品名称', _this2.props.fundName + '(' + _this2.props.fundCode + ')'], ['投资金额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(paymentText) + '元']],
              souseVal: ['查看交易信息', '返回我的智投'],
              businessType: payInfoData.currentType == 1 ? "T522" : payInfoData.currentType == 2 ? "T422" : payInfoData.currentType == 3 ? "T822" : "",
              superFundConfirmAndIncomeDate: result.content.confirmAndIncomeDate,
              fundCode: fundCode,
              superTypeValue: _this2.props.superTypeValue

            }
          });
        } else if (i == 0) {
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '支付完成',
              content: '很抱歉，您的这笔交易支付失败',
              content2: result.content ? result.content.requestDetail.paymentMessage : result,
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        } else if (i == 2) {
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '支付完成',
              content: '处理中（银行返回处理中)',
              content2: '申请处理中',
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        } else if (i == 3 || i == 5) {
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '支付完成',
              content: '结果未知',
              content2: '申请结果未知，请等待日终状态后联系客服',
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '支付完成',
              content: '结果未知',
              content2: '申请结果未知，请等待日终状态后联系客服',
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        }
      };

      if (payInfoData.currentType == 1) {
        var item = payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        console.log('银行卡交易' + payInfoData.currentIndex, item);
        if (item.yhkBool) {
          var data = { //直销卡交易
            amount: Number(paymentText),
            businessType: "TH22",
            superFundCode: fundCode,
            payByHqt: false,
            bankCode: item.bankCode,
            password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(_this2.props.keyPasswordVal),
            paymentChannel: item.paymentChannelId,
            payByOtsCards: true,
            clientType: "",
            clientDeviceNo: "",
            textval: "直销卡"
          };
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["I" /* buySubmit */])(data, pushResult));
        } else {
          var _data = {
            "amount": paymentText,
            "businessType": "T522",
            "clientIp": "127.0.0.1",
            "currentAccountId": item.currentAccountId,
            "paymentChannel": item.paymentChannel,
            "superFundCode": fundCode,
            "payByHqt": false,
            "riskControlFlag": "0",
            password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(_this2.props.keyPasswordVal),
            textval: "财富卡"
          };
          console.log(_this2.props.keyPasswordVal, "898989898");
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["I" /* buySubmit */])(_data, pushResult));
        }
      } else if (payInfoData.currentType == 2) {
        var _item = payInfoData.content.shareList[payInfoData.currentIndex];
        console.log('活期通' + payInfoData.currentIndex, _item);
        var _data2 = {
          "amount": paymentText,
          "businessType": "T422",
          "clientIp": "127.0.0.1",
          "currentAccountId": _item.currentAccountId,
          "paymentChannel": _item.paymentChannel,
          "superFundCode": fundCode,
          "payByHqt": true,
          "riskControlFlag": "0",
          password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(_this2.props.keyPasswordVal),
          bankCode: _item.bankCode,
          textval: "活期通"
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["I" /* buySubmit */])(_data2, pushResult));
      } else if (payInfoData.currentType == 3) {
        var _item2 = payInfoData.content.currencyFund[payInfoData.currentIndex];
        var _data3 = {
          "amount": paymentText,
          "businessType": "T822",
          "clientIp": "127.0.0.1",
          "currentAccountId": _item2.trustChannelId,
          "paymentChannel": _item2.trustChannelId,
          "superFundCode": fundCode,
          "payByHqt": false,
          "riskControlFlag": "0",
          password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(_this2.props.keyPasswordVal),
          bankCode: _item2.bankCode,
          bankAccountShowNo: _item2.bankAccountShowNo,
          payByMoneyFund: true,
          moneyFundCode: _item2.fundCode,
          textval: "零钱宝"
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["I" /* buySubmit */])(_data3, pushResult));
      }
    };

    _this2.popoverCountFun = function (text) {
      if (text >= 10000 && text < 100000) {
        _this2.setState({
          popoverCountFlag: true,
          popoverCount: '万'
        });
      } else if (text >= 100000 && text < 1000000) {
        _this2.setState({
          popoverCountFlag: true,
          popoverCount: '十万'
        });
      } else if (text >= 1000000 && text < 10000000) {
        _this2.setState({
          popoverCountFlag: true,
          popoverCount: '百万'
        });
      } else if (text >= 10000000 && text < 100000000) {
        _this2.setState({
          popoverCountFlag: true,
          popoverCount: '千万'
        });
      } else if (text >= 100000000 && text < 1000000000) {
        _this2.setState({
          popoverCountFlag: true,
          popoverCount: '亿'
        });
      } else if (text >= 1000000000 && text < 10000000000) {
        _this2.setState({
          popoverCountFlag: true,
          popoverCount: '十亿'
        });
      } else {
        _this2.setState({
          popoverCountFlag: false,
          popoverCount: ''
        });
      }
    };

    _this2.maxTipFun = function (text, i, type, amount, amountMax) {
      _this2.setState({
        tipByMax: ""
      });
      if (text === null || text === "" || text === undefined) {
        return;
      }
      var yhkList = _this2.props.payInfoData.content.yhkNewListList;
      var hqtList = _this2.props.payInfoData.content.shareList;
      var lqbList = _this2.props.payInfoData.content.currencyFund;
      var _amount = amount === null || amount === "" || amount === undefined ? null : Number(amount);
      var _amountMax = amountMax === null || amountMax === "" || amountMax === undefined ? null : Number(amountMax);
      var _index = i;
      var _type = type;
      if (text === 0 || text === "0") {
        _this2.setState({
          tipByMax: "转入金额不能为0"
        });
        return;
      }
      if (_amount !== null && _amount !== "" && _amount !== undefined) {
        if (text < _amount) {
          _this2.setState({
            tipByMax: "转入金额低于最低限额"
          });
          return;
        }
      }
      if (_amountMax !== null && _amountMax !== "" && _amountMax !== undefined) {
        if (text > _amountMax) {
          _this2.setState({
            tipByMax: "转入金额超过最高限额"
          });
          return;
        }
      }
      if (_type == "1") {
        if (yhkList && yhkList.length > 0) {
          if (yhkList[_index].tradeMaxAmountTips.indexOf("|") != -1) {
            var _num = yhkList[_index].tradeMaxAmountTips.split("|")[0];
            _num = _num >= 0 ? Number(_num) : _num;
            if (_num !== null && _num !== "" && _num !== undefined) {
              if (text > _num) {
                _this2.setState({
                  tipByMax: "转入金额超过银行卡限额"
                });
              }
            }
          }
        }
      } else if (_type == "2") {
        if (hqtList && hqtList.length > 0) {
          if (hqtList[_index].availableVolume !== null && hqtList[_index].availableVolume !== "" && hqtList[_index].availableVolume !== undefined) {
            if (text > hqtList[_index].availableVolume) {
              _this2.setState({
                tipByMax: "转入金额超过可用余额"
              });
            }
          }
        }
      } else if (_type == "3") {
        if (lqbList && lqbList.length > 0) {
          if (lqbList[_index].availableVolume !== null && lqbList[_index].availableVolume !== "" && lqbList[_index].availableVolume !== undefined) {
            if (text > lqbList[_index].availableVolume) {
              _this2.setState({
                tipByMax: "转入金额超过可用余额"
              });
            }
          }
        }
      }
    };

    _this2.resetRiskFun = function () {
      _this2.setState({
        showRiskModal: false
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */], window.history.length, function () {
        _this2.next("1");
      });
      return;
    };

    _this2.sameDataFun = function () {
      _this2.setState({
        showRiskModal: false
      });
      _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["L" /* syncCwimRiskToCamcAndStopOutOfRiskBuyPlan */])({}, function () {
        _this2.next("2");
      }));
      return;
    };

    _this2.riskShowFun = function () {
      _this2.setState({
        showRiskModal: true
      });
    };

    _this2.paymentMethod = function () {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: '/PayCardList',
        state: {
          type: 'superFund',
          actionType: 'SUPER_FUND',
          fundCode: _this2.props.fundCode
        }
      });
    };

    _this2.state = {
      fundLimit: '',
      isOk: false,
      agreeIndex: 0,
      btnFlag: false,
      amount: '',
      fee: '--',
      fundIsOpen: '',
      tipByMax: "",
      amountMax: '0',
      popoverCount: '', //气泡金额数位文本
      popoverCountFlag: false, //数位显示标志
      showRiskModal: false,
      unionPayTransformBool: false
    };
    return _this2;
  }

  _createClass(PaymentSuperFund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      document.title = "在线支付";
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_loginAction__["b" /* getUserInfoList */])(function (result) {
        var inParamsData = {
          certNo: result.content.certNo,
          certType: result.content.certType,
          name: result.content.name
        };
        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_myAssets_userInfoAction__["a" /* findCamcHqtExist */])(inParamsData));
      }));
    }
  }, {
    key: 'next',
    value: function next(res) {
      var _this4 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          payInfoData = _props.payInfoData;
      var _state = this.state,
          amount = _state.amount,
          fundIsOpen = _state.fundIsOpen;
      var paymentText = this.props.paymentText;

      if (!__WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(paymentText)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确格式的金额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
        return;
      }
      if (this.state.tipByMax) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(this.state.tipByMax, __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
        return;
      }
      if (amount > paymentText) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('投资金额不可低于' + amount + '元', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
        return;
      }
      try {
        if (payInfoData.currentType == 1) {
          var item = payInfoData.content.yhkNewListList[payInfoData.currentIndex];
          if (!item) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return;
          }
          if (!item.disable) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return;
          }
          if (paymentText > 5000 && !payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool) {
            this.setState({ unionPayTransformBool: true });
            return;
          }
          if (item.tradeMaxAmountTips.split('|')[0] - 0 < paymentText) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(item.yhkBool ? item.tradeMaxAmountTips.split('|')[2] : item.tradeMaxAmountTips.split('|')[1], __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return false;
          }
        } else if (payInfoData.currentType == 2) {
          var _item3 = payInfoData.content.shareList[payInfoData.currentIndex];
          if (!_item3) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return;
          }
          if (!_item3.disable) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return;
          }
          if (_item3.availableVolume < paymentText) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('金额不可超过活期通余额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return false;
          }
        } else if (payInfoData.currentType == 3) {
          var _item4 = payInfoData.content.currencyFund[payInfoData.currentIndex];
          if (!_item4) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return;
          }
          if (_item4.availableVolume < paymentText) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('金额不可超过' + _item4.fundName + '余额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
            return false;
          }
        }
      } catch (e) {
        console.log('金额异常');
      }
      if (fundIsOpen !== '') {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(fundIsOpen, __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
        return;
      }
      if (payInfoData.currentType == 1 && payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool) {
        console.log("44444444444", payInfoData);
        var findHqtExist = this.props.findHqtExist;
        var params = {
          otsTradeAccountNo: findHqtExist.tradeAccountNo,
          raiseMethod: "9"
        };
        if (res == "1") {
          try {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
              if (_flag) {
                //组合成分基金中包含华夏基金产品，需弹窗提示
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this4.props.fundCode }, function (result) {
                  var data = result[result.length - 1].itemAdjustList;
                  var fundsArr = [];
                  console.log(data);
                  if (_this4.props.prompt && _this4.props.prompt.replace(/(^s*)|(s*$)/g, "").length !== 0) {
                    _this4.props.parThis.setState({
                      data: _this4.props.prompt,
                      isShowModal2: true
                    });
                  } else {
                    for (var i = 0; i < data.length; i++) {
                      if (data[i].fundName.indexOf('华夏') != -1) {
                        fundsArr.push(data[i].fundName);
                      }
                    }
                    if (fundsArr.length == 0) {
                      console.log(1);
                      _this4.props.parThis.setState({
                        pwdFlag: true
                      });
                    } else {
                      console.log(2);
                      _this4.props.parThis.setState({
                        data: fundsArr.join('、'),
                        isShowModal2: true
                      });
                    }
                  }
                }));
              } else {
                _this4.riskShowFun();
              }
            }));
          } catch (err) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].hide();
          }
        } else if (res == "2") {
          try {
            //组合成分基金中包含华夏基金产品，需弹窗提示
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: this.props.fundCode }, function (result) {
              var data = result[result.length - 1].itemAdjustList;
              var fundsArr = [];
              console.log(data);
              if (_this4.props.prompt && _this4.props.prompt.replace(/(^s*)|(s*$)/g, "").length !== 0) {
                _this4.props.parThis.setState({
                  data: _this4.props.prompt,
                  isShowModal2: true
                });
              } else {
                for (var i = 0; i < data.length; i++) {
                  if (data[i].fundName.indexOf('华夏') != -1) {
                    fundsArr.push(data[i].fundName);
                  }
                }
                if (fundsArr.length == 0) {
                  console.log(1);
                  _this4.props.parThis.setState({
                    pwdFlag: true
                  });
                } else {
                  console.log(2);
                  _this4.props.parThis.setState({
                    data: fundsArr.join('、'),
                    isShowModal2: true
                  });
                }
              }
            }));
          } catch (err) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].hide();
          }
        } else {
          try {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["N" /* hasOtsRiskRearing */])(params, function (c1, c2, z1) {
              console.log(c1, c2, z1, "是否同步问卷");
              if (z1) {
                console.log("4444444", c1, c2, z1, "是否同步问卷");
                //组合成分基金中包含华夏基金产品，需弹窗提示
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this4.props.fundCode }, function (result) {
                  var data = result[result.length - 1].itemAdjustList;
                  var fundsArr = [];
                  console.log(data);
                  if (_this4.props.prompt && _this4.props.prompt.replace(/(^s*)|(s*$)/g, "").length !== 0) {
                    _this4.props.parThis.setState({
                      data: _this4.props.prompt,
                      isShowModal2: true
                    });
                  } else {
                    for (var i = 0; i < data.length; i++) {
                      if (data[i].fundName.indexOf('华夏') != -1) {
                        fundsArr.push(data[i].fundName);
                      }
                    }
                    if (fundsArr.length == 0) {
                      console.log(1);
                      _this4.props.parThis.setState({
                        pwdFlag: true
                      });
                    } else {
                      console.log(2);
                      _this4.props.parThis.setState({
                        data: fundsArr.join('、'),
                        isShowModal2: true
                      });
                    }
                  }
                }));
              } else {
                if (c1 === c2) {
                  console.log(c1, c2, z1, "c1 === c2同步问卷");
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
                    console.log(_flag, "44444444445555555555");
                    if (_flag) {
                      //组合成分基金中包含华夏基金产品，需弹窗提示
                      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this4.props.fundCode }, function (result) {
                        var data = result[result.length - 1].itemAdjustList;
                        var fundsArr = [];
                        console.log(data);
                        if (_this4.props.prompt && _this4.props.prompt.replace(/(^s*)|(s*$)/g, "").length !== 0) {
                          _this4.props.parThis.setState({
                            data: _this4.props.prompt,
                            isShowModal2: true
                          });
                        } else {
                          for (var i = 0; i < data.length; i++) {
                            if (data[i].fundName.indexOf('华夏') != -1) {
                              fundsArr.push(data[i].fundName);
                            }
                          }
                          if (fundsArr.length == 0) {
                            console.log(1);
                            _this4.props.parThis.setState({
                              pwdFlag: true
                            });
                          } else {
                            console.log(2);
                            _this4.props.parThis.setState({
                              data: fundsArr.join('、'),
                              isShowModal2: true
                            });
                          }
                        }
                      }));
                    } else {
                      _this4.riskShowFun();
                    }
                  }));
                } else {
                  console.log(c1, c2, z1, "c1 === c2同步问卷");
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */], window.history.length, function () {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
                      console.log(_flag, "44444444444666666666666");
                      if (_flag) {
                        //组合成分基金中包含华夏基金产品，需弹窗提示
                        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this4.props.fundCode }, function (result) {
                          var data = result[result.length - 1].itemAdjustList;
                          var fundsArr = [];
                          console.log(data);
                          if (_this4.props.prompt && _this4.props.prompt.replace(/(^s*)|(s*$)/g, "").length !== 0) {
                            _this4.props.parThis.setState({
                              data: _this4.props.prompt,
                              isShowModal2: true
                            });
                          } else {
                            for (var i = 0; i < data.length; i++) {
                              if (data[i].fundName.indexOf('华夏') != -1) {
                                fundsArr.push(data[i].fundName);
                              }
                            }
                            if (fundsArr.length == 0) {
                              console.log(1);
                              _this4.props.parThis.setState({
                                pwdFlag: true
                              });
                            } else {
                              console.log(2);
                              _this4.props.parThis.setState({
                                data: fundsArr.join('、'),
                                isShowModal2: true
                              });
                            }
                          }
                        }));
                      } else {
                        _this4.riskShowFun();
                      }
                    }));
                  });
                }
              }
            }));
          } catch (err) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].hide();
            console.log(err, '同步问卷失败');
          }
        }
      } else {
        console.log("444444444888");
        //组合成分基金中包含华夏基金产品，需弹窗提示
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: this.props.fundCode }, function (result) {
          var data = result[result.length - 1].itemAdjustList;
          var fundsArr = [];
          console.log(data);
          if (_this4.props.prompt && _this4.props.prompt.replace(/(^s*)|(s*$)/g, "").length !== 0) {
            _this4.props.parThis.setState({
              data: _this4.props.prompt,
              isShowModal2: true
            });
          } else {
            for (var i = 0; i < data.length; i++) {
              if (data[i].fundName.indexOf('华夏') != -1) {
                fundsArr.push(data[i].fundName);
              }
            }
            if (fundsArr.length == 0) {
              console.log(1);
              _this4.props.parThis.setState({
                pwdFlag: true
              });
            } else {
              console.log(2);
              _this4.props.parThis.setState({
                data: fundsArr.join('、'),
                isShowModal2: true
              });
            }
          }
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetch();
      this.props.parThis.getChildThis(this);
      this.popoverCountFun(this.props.paymentText);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this5 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          payInfoData = _props2.payInfoData;

      var dataAmount = {
        businessType: 'T022',
        superFundCode: this.props.fundCode
      };
      if (payInfoData.currentType == 4) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["I" /* getTradeInfo */])(this.props.fundCode, 'T522', this.props.productType, function (result, i, type) {
          _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["O" /* getSuperFundTradeLimit */])(dataAmount, function (val) {
            _this5.setState({ amount: val.content.minLimit, amountMax: val.content.maxLimit });
            _this5.maxTipFun(_this5.props.paymentText, i, type, val.content.minLimit, val.content.maxLimit);
          }));
          Object.assign(result, { currentType: type }, { currentIndex: i });
          dispatch({
            type: "SUPER_FUND_PAY_INFO",
            text: result
          });
        }));
      } else {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["O" /* getSuperFundTradeLimit */])(dataAmount, function (val) {
          _this5.setState({ amount: val.content.minLimit, amountMax: val.content.maxLimit });
          _this5.maxTipFun(_this5.props.paymentText, _this5.props.payInfoData.currentIndex, _this5.props.payInfoData.currentType, val.content.minLimit, val.content.maxLimit);
        }));
      }
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var agreeIndex = this.state.agreeIndex;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["K" /* smSzt */])(1));
      } else {
        this.setState({
          agreeIndex: 0
        });
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["K" /* smSzt */])(0));
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name) {
      var code = __WEBPACK_IMPORTED_MODULE_2__BankCode__["a" /* protocolCode */][name];
      console.log(__WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */]);
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }
  }, {
    key: 'choseBank',
    value: function choseBank() {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: '/paymentBankList',
        state: {
          fundCode: this.props.fundCode
        }
      });
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(text) {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          payInfoData = _props3.payInfoData,
          fundCode = _props3.fundCode,
          businessType = _props3.businessType,
          productType = _props3.productType;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_publicAction__["d" /* myPaymentText */])(text));
      if (payInfoData.currentType == 1) {
        var item = payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        var data = {
          paymentChannelId: item.paymentChannel,
          businessType: 'T522',
          fundCode: this.props.fundCode,
          applicationAmount: text,
          payBuyHqt: true
        };
        var data0 = {
          paymentChannelId: item.paymentChannel,
          businessType: 'T522',
          fundCode: this.props.fundCode,
          applicationAmount: 0,
          payBuyHqt: true
          // if (text.length==0) 
          //   dispatch(getBuyFee(data0,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
          // else
          //   dispatch(getBuyFee(data,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
        };console.log('银行卡');
      } else if (payInfoData.currentType == 2) {
        var _item5 = payInfoData.content.shareList[payInfoData.currentIndex];
        var _data4 = {
          paymentChannelId: _item5.currentAccountId,
          businessType: 'T422',
          fundCode: this.props.fundCode,
          applicationAmount: text,
          payBuyHqt: true
        };
        var data2 = {
          paymentChannellId: _item5.currentAccountId,
          businessType: 'T422',
          fundCode: this.props.fundCode,
          applicationAmount: 0,
          payBuyHqt: true
          // if (text.length==0) 
          //   dispatch(getBuyFee(data2,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
          // else
          //   dispatch(getBuyFee(data,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
        };
      } else if (payInfoData.currentType == 3) {
        var _item6 = payInfoData.content.currencyFund[payInfoData.currentIndex];
        var _data5 = {
          paymentChannelId: _item6.trustChannelId,
          businessType: 'T822',
          fundCode: this.props.fundCode,
          applicationAmount: text,
          payBuyHqt: true
        };
        var _data6 = {
          paymentChannellId: _item6.trustChannelId,
          businessType: 'T822',
          fundCode: this.props.fundCode,
          applicationAmount: 0,
          payBuyHqt: true
          // if (text.length==0) 
          //   dispatch(getBuyFee(data2,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
          // else
          //   dispatch(getBuyFee(data,(val)=>{this.props.dispatch(myFee(val))},(val)=>{this.setState({fundIsOpen:val})}))
        };
      }
      this.popoverCountFun(text);
      this.maxTipFun(text, this.props.payInfoData.currentIndex, this.props.payInfoData.currentType, this.state.amount, this.state.amountMax);
    }
    //各种限额提示

  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props4 = this.props,
          businessType = _props4.businessType,
          productType = _props4.productType,
          payInfoData = _props4.payInfoData,
          rateAndFeeDate = _props4.rateAndFeeDate,
          paymentText = _props4.paymentText;

      var _this = this;
      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginTop: -10 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: window.winWidth, backgroundColor: "#fff", paddingBottom: 15, paddingTop: 20, paddingLeft: 20, paddingRight: 20, borderTopLeftRadius: 10, borderTopRightRadius: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, color: '#333' } },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(this.props.fundName) + '(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(this.props.fundCode) + ')'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 12, color: '#999' } },
                '\u8F6C\u5165'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: 25, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
              this.props.paymentText == '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 40 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999', fontSize: 12 } },
                  '|'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#F8515C', fontSize: 12, marginTop: 1, marginLeft: 2 } })
              ) : null,
              this.state.popoverCountFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 40 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999', fontSize: 12 } },
                  '|'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999', fontSize: 12, marginTop: 1, marginLeft: 2 } },
                  this.state.popoverCount
                )
              ) : null,
              this.state.tipByMax ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: this.state.popoverCountFlag ? 5 : 40 } },
                this.state.popoverCountFlag ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999', fontSize: 12 } },
                  '|'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#F8515C', fontSize: 12, marginTop: 1, marginLeft: 2 } },
                  this.state.tipByMax
                )
              ) : null
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between", paddingBottom: 9.5, borderBottomColor: "#EBEBEB", borderBottomWidth: 0.5, borderBottomStyle: "solid" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 24, fontWeight: "500", color: "#333" } },
                  '\xA5'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'price_placeholder_style', style: { fontSize: 24, color: "#333", fontWeight: "400", marginLeft: 10, width: 240 }, autocomplete: 'off', onChange: function onChange(e) {
                    return _this6.onChangeText(e.target.value);
                  }, type: 'text', value: this.props.paymentText, placeholder: __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(this.state.amount) + '\u5143\u8D77\u8D2D' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.onChangeText("");
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: __webpack_require__(1893),
                  style: { height: 16, width: 16 }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 14.5, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#999", fontSize: 12 } },
                '\u4E70\u5165\u8D39\u7387\uFF1A'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 12, color: '#B69271', fontWeight: "500" } },
                '0-1\u6298'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff", marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__myAssets_payment_PayCardSuperFund__["a" /* default */], { type: 'superFund', superFundCode: this.props.fundCode, actionType: 'SUPER_FUND' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: "auto", paddingTop: 10, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" }, className: 'pay-agree' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: img_arr[this.props.smSzt], style: { width: 32, height: 32 }, onClick: function onClick() {
                  return _this6.isAgreeClick();
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { display: 'block' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999999', fontSize: 12 } },
                  '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F'
                ),
                this.props.fundCode == 'SF1012' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-货币');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1015' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-固收');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1016' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-权益');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1014' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-指数');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1017' || this.props.fundCode == 'SF1018' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-教育');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1019' || this.props.fundCode == 'SF1020' || this.props.fundCode == 'SF1021' || this.props.fundCode == 'SF1013' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-养老');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.policy && this.props.policyTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper(_this6.props.policyTitle ? _this6.props.policyTitle : "");
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1036' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-工资宝');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1038' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-7分小进取');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1039' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-指数增强');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1060' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-安心宝');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1067' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-价值精选');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1022' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this6.ProtocolPaper('投资组合策略说明书-货币增强');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999999', fontSize: 12 } },
                  '\u53CA\u7279\u522B\u63D0\u793A\u5185\u5BB9'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: window.winWidth, paddingLeft: 20, paddingRight: 20, marginTop: 20 } },
              this.props.smSzt == 1 && __WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(this.props.paymentText) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this6.next();
                  }, style: { width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#fa063a", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 16, color: "#fff" } },
                  '\u786E\u5B9A\u4E70\u5165'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#D3D4D6", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 16, color: "#fff" } },
                  '\u786E\u5B9A\u4E70\u5165'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginTop: 20, paddingLeft: 7, paddingRight: 7 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__myAssets_payment_PayWarmTips__["a" /* default */], { buyType: 'SF', fundLimit: this.props.fundLimit })
            )
          )
        ),
        this.state.showRiskModal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u6E29\u99A8\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u6D3B\u671F\u901A\u3001\u95EA\u8D2D\u76F8\u5173\u670D\u52A1\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\uFF0C\u6839\u636E\u534E\u590F\u57FA\u91D1\u7684\u8BC4\u5206\u6807\u51C6\uFF0C\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E3A\uFF1AC1\u4FDD\u5B88\u578B\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u6839\u636E\u300A\u8BC1\u5238\u671F\u8D27\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u529E\u6CD5\u300B\u7684\u89C4\u5B9A\uFF0C\u60A8\u9002\u5408\u4EA4\u6613\u98CE\u9669\u7B49\u7EA7\u4E3AR1\u7684\u4EA7\u54C1\u3002',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 15, color: "#333", lineHeight: "20px", fontWeight: "bold" } },
                  '\u60A8\u5982\u679C\u786E\u5B9A\u8BA4\u540C\u6B64\u98CE\u9669\u7B49\u7EA7\u8BC4\u5B9A\uFF0C\u4E3A\u4E86\u964D\u4F4E\u60A8\u7684\u98CE\u9669\uFF0C\u6211\u4EEC\u5C06\u7EC8\u6B62\u60A8\u5728\u534E\u590F\u57FA\u91D1\u5DF2\u7ECF\u7B7E\u7EA6\u7684R1\u4EA7\u54C1\u4EE5\u5916\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\uFF0C\u5305\u62EC\u5B9A\u6295\u3001\u667A\u80FD\u8BA4\u8D2D\u3001\u5B9A\u671F\u8F6C\u6362\u7B49\u3002'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.resetRiskFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u91CD\u65B0\u6D4B\u8BC4'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.sameDataFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u786E\u8BA4'
                )
              )
            )
          )
        ) : null,
        this.state.unionPayTransformBool ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u6E29\u99A8\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u8D22\u5BCC\u5361\u652F\u4ED8\u65B9\u5F0F\u91D1\u989D\u4E0D\u5F97\u8D85\u8FC75000\u5143\uFF0C\u8BF7\u60A8\u9009\u62E9\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u6216\u4E0B\u8F7D\u534E\u590F\u8D22\u5BCCapp\u64CD\u4F5C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.paymentMethod, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u4FEE\u6539\u652F\u4ED8\u65B9\u5F0F'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.setState({ unionPayTransformBool: false });
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u786E\u8BA4'
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return PaymentSuperFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    payInfoData: state.superFundPayInfo,
    paymentText: state.paymentText,
    fee: state.fee,
    findHqtExist: state.findHqtExist,
    smSzt: state.smSzt
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PaymentSuperFund));

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_svg_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_bar__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// 引入柱状图




// 引入提示框和标题组件




var SuperPie = function (_Component) {
  _inherits(SuperPie, _Component);

  function SuperPie() {
    _classCallCheck(this, SuperPie);

    return _possibleConstructorReturn(this, (SuperPie.__proto__ || Object.getPrototypeOf(SuperPie)).apply(this, arguments));
  }

  _createClass(SuperPie, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          _props$legendData = _props.legendData,
          legendData = _props$legendData === undefined ? [] : _props$legendData,
          _props$seriesData = _props.seriesData,
          seriesData = _props$seriesData === undefined ? [] : _props$seriesData;

      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperPie"));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperPie"), null, { renderer: "svg" });
      }
      myChart.clear();
      myChart.resize();
      // 绘制图表
      myChart.setOption(SuperPieOption(seriesData, legendData));
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
        if (window.isLess47) {
          var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperPie"));
        } else {
          var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperPie"), null, { renderer: "svg" });
        }

        // 绘制图表
        myChart.clear();
        myChart.resize();
        myChart.setOption(SuperPieOption(nextProps.seriesData, nextProps.legendData));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperPie"));
      myChart.clear();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var thisProps = this.props || {},
          thisState = this.state || {};
      for (var key in nextProps) {
        if (thisProps[key] !== nextProps[key]) {
          return true;
        }
      }
      for (var _key in nextState) {
        if (thisState[_key] !== nextState[_key]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "SuperPie", style: { width: "100%", height: this.props.height } });
    }
  }]);

  return SuperPie;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SuperPie);
/*饼图Option*/
function SuperPieOption(seriesData, legendData) {
  var color = [];
  legendData.forEach(function (v) {
    var cor = __WEBPACK_IMPORTED_MODULE_9__util___default.a.pieEchartsColorMap.get(v.replace(/[0-9\.]+%$/, '')) || '#796EE0';

    color.push(cor);
  });
  return {
    color: color, //: //["#F8515C", "#FF9653", "#796EE0", "#5BA3F6"],
    animation: window.isLess47,

    calculable: true,
    legend: {
      //  width:300,
      // left:20,
      right: 0,
      top: "center",
      orient: "vertical",
      data: legendData, //["货币基金15.0%", "                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    20.0%", "进取股票25.0%", "稳健型债券40.0%"],
      itemGap: 6,
      itemWidth: 5,
      selectedMode: false,

      icon: "circle",
      formatter: function formatter(name) {
        var percentageIndex = name.search(/[0-9\.]+%$/);
        var namaArr = [name.slice(0, percentageIndex), name.slice(percentageIndex)];
        return "{a|" + namaArr[0] + "}{b|" + namaArr[1] + "}";
      },
      textStyle: {
        color: "#333",
        fontSize: "12px",
        width: 180,
        rich: {
          a: {
            align: "left",
            width: 100
          },
          b: { align: "right", width: 80 }
        }
      }
    },
    series: [{
      minAngle: 20,
      type: "pie",
      hoverAnimation: false,
      radius: [34, 47],
      center: ["18%", "50%"],
      roseType: false,
      data: seriesData,
      label: {
        normal: {
          show: false
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      },
      itemStyle: {
        normal: {
          borderColor: "#fff",
          borderWidth: 2
        }
      },
      silent: true
    }]
  };
}

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReduxStore_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_myAssets_myCardAction__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_js__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// import { findCamcHqtExist } from '../../../action/myAssets/userInfoAction'



var PayCard = function (_Component) {
  _inherits(PayCard, _Component);

  function PayCard(props) {
    var _this2 = this;

    _classCallCheck(this, PayCard);

    var _this = _possibleConstructorReturn(this, (PayCard.__proto__ || Object.getPrototypeOf(PayCard)).call(this, props));

    _this.toGetCardList = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__common_js__["b" /* getTempInfo */])('shortToken');

            case 2:
              _context.t0 = _context.sent;
              params = {
                token: _context.t0
              };

              __WEBPACK_IMPORTED_MODULE_8__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_myCardAction__["a" /* getCardList */])(params, function (content) {
                console.log(content);
              }, function (msg) {
                console.log(msg);
              }));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = {};
    return _this;
  }

  _createClass(PayCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // let data = store.getState().verifiedUserInfo.content;
      // console.log(data)
      // let inParamsData = {
      //   certNo: data.certNo,
      //   certType: data.certType,
      //   name: data.name
      // }
      // store.dispatch(findCamcHqtExist(inParamsData))
      this.toGetCardList();
    }
  }, {
    key: 'choseBank',
    value: function choseBank() {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/PayCardList',
        state: {
          type: this.props.type,
          actionType: this.props.actionType,
          fundCode: this.props.superFundCode
        }
      });
    }
  }, {
    key: 'renderRecharge',
    value: function renderRecharge() {
      var _this3 = this;

      var payInfoData = this.props.payInfoData;

      if (payInfoData.currentType == 2) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { height: 46.5, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", borderTopColor: "#EBEBEB", borderTopWidth: 0.5, borderTopStyle: "solid" } },
        payInfoData.currentType == 2 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" }, onClick: function onClick() {
              return _this3.goHQT(payInfoData.content.shareList[payInfoData.currentIndex]);
            } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { fontSize: 12, color: '#999' } },
            '\u53EF\u7528\u4F59\u989D\u4E0D\u8DB3\uFF1F'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { fontSize: 12, color: '#B69271', fontWeight: "500" } },
            '\u7ACB\u5373\u5145\u503C'
          )
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: "flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" }, onClick: function onClick() {
              return _this3.goLQB(payInfoData.content.currencyFund[payInfoData.currentIndex]);
            } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { fontSize: 12, color: '#999' } },
            '\u53EF\u7528\u4F59\u989D\u4E0D\u8DB3\uFF1F'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { fontSize: 12, color: '#B69271', fontWeight: "500" } },
            '\u7ACB\u5373\u5145\u503C'
          )
        )
      );else return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null);
    }
  }, {
    key: 'goHQT',
    value: function goHQT(parmas) {
      var _props = this.props,
          navigator = _props.navigator,
          dispatch = _props.dispatch,
          fundCode = _props.fundCode;

      var data = {
        fundCode: '003003',
        businessType: 'T022',
        productType: 'G',
        type: this.props.type,
        bankAccountShowNo: parmas.bankAccountShowNo,
        currentIndex: this.props.payInfoData.currentIndex
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_investmentAction__["L" /* hqtXz */])(parmas.bankCode));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__getPay__["j" /* getPayAll */])(window.history.length, data, __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */], 'RechargeHqt');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var payInfoData = this.props.payInfoData;

      console.log(payInfoData, "66666666666");
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        payInfoData.currentType == 1 && payInfoData.content.yhkNewListList.length > 0 ? payInfoData.content.yhkNewListList.map(function (item, i) {
          if (i == payInfoData.currentIndex) {
            if (item.disable) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'yhkNewListList' + i, onClick: function onClick() {
                    return _this4.choseBank();
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { paddingTop: 15, paddingBottom: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { width: 100 } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                      '\u652F\u4ED8\u65B9\u5F0F'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "flex-end" } },
                      item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 14, width: 14 }, src: __webpack_require__(39) }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#333', fontSize: 14, marginLeft: 3 } },
                          '\u7406\u8D22\u4E2D\u5FC3'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 14, width: 14 }, src: __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39) }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#333', fontSize: 14, marginLeft: 3 } },
                          (item.yhkBool ? "直销银行卡-" : "财富银行卡-") + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankName) + '(尾号' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                        )
                      ),
                      item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#999', fontSize: 12, marginLeft: 3 } },
                          '\u7406\u8D22\u4E2D\u5FC3POS\u673A\u5237\u5361'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#999', fontSize: 12, marginLeft: 3 } },
                          item.yhkBool ? window.funSplit(item.tradeMaxAmountTips)[0] >= 999999999999 ? '单笔无限额，单日无限额' : item.paymentChannelId == 'G000' && item.bankCode == '007' ? '单笔限额20万，单日限额20万' : item.dayMonthLimit && window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额" + window.funSplit(item.tradeMaxAmountTips)[0] / 10000 + "万" + item.dayMonthLimit : window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额" + window.funSplit(item.tradeMaxAmountTips)[0] / 10000 + "万" : '' : window.funSplit(item.tradeMaxAmountTips)[1]
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 10, width: 10 }, src: __webpack_require__(274) })
                  )
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'yhkNewListList' + i, onClick: function onClick() {
                    return _this4.choseBank();
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { paddingTop: 15, paddingBottom: 15, WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", display: "-webkit-flex" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                    '\u652F\u4ED8\u65B9\u5F0F'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                    '\u65E0\u652F\u4ED8\u65B9\u5F0F'
                  )
                )
              );
            }
          }
        }) : payInfoData.currentType == 2 && payInfoData.content.shareList.length > 0 ? payInfoData.content.shareList.map(function (item, i) {
          if (i == payInfoData.currentIndex) {
            if (item.disable) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'shareList' + i, onClick: function onClick() {
                    return _this4.choseBank();
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { paddingTop: 15, paddingBottom: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                      '\u652F\u4ED8\u65B9\u5F0F'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "flex-end" } },
                      item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 14, width: 14 }, src: __webpack_require__(39) }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#333', fontSize: 14, marginLeft: 3 } },
                          '\u6D3B\u671F\u901A',
                          '(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.trustChannelName) + '尾号' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 14, width: 14 }, src: __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39) }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#333', fontSize: 14, marginLeft: 3 } },
                          '' + (typeof item.trustChannelName == 'string' ? item.trustChannelName.indexOf('-') > -1 ? item.trustChannelName.split('-')[0] : '--' : '--'),
                          '(' + (typeof item.trustChannelName == 'string' ? item.trustChannelName.indexOf('-') > -1 ? item.trustChannelName.split('-')[1] : '--' : '--') + '\u5C3E\u53F7' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                        )
                      ),
                      item.paymentChannel == "G000" && item.ywt == false ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3, width: 200, WebkitFlexWrap: "wrap" } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#999', fontSize: 12, marginLeft: 3 } },
                          '\u62DB\u884C\u5361\u6682\u4E0D\u53EF\u7528\uFF0C\u8BF7\u60A8\u53BB\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6App\u64CD\u4F5C\u6216\u54A8\u8BE2\u5BA2\u670D'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#999', fontSize: 12, marginLeft: 3 } },
                          '\u53EF\u7528\u4F59\u989D\uFF1A'
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: '#B69271', fontSize: 12, fontWeight: "500" } },
                          __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.availableVolume),
                          '\u5143'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 10, width: 10 }, src: __webpack_require__(274) })
                  )
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'shareList' + i, onClick: function onClick() {
                    return _this4.choseBank();
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { paddingTop: 15, paddingBottom: 15, WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", display: "-webkit-flex" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                    '\u652F\u4ED8\u65B9\u5F0F'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                    '\u65E0\u652F\u4ED8\u65B9\u5F0F'
                  )
                )
              );
            }
          }
        }) : payInfoData.currentType == 3 && payInfoData.content.currencyFund.length > 0 ? payInfoData.content.currencyFund.map(function (item, i) {
          if (i == payInfoData.currentIndex) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: 'currencyFund' + i, onClick: function onClick() {
                  return _this4.choseBank();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { paddingTop: 15, paddingBottom: 15, WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", display: "-webkit-flex" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
                    '\u652F\u4ED8\u65B9\u5F0F'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "flex-end" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: 14, height: 14 }, src: __webpack_require__(271) }),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { style: { color: '#333', fontSize: 14, marginLeft: 3 } },
                        item.fundName
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginTop: 3 } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { style: { color: '#333', fontSize: 14, marginLeft: 3 } },
                        '(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.trustChannelName) + '尾号' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex", marginTop: 3 } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { style: { color: '#999', fontSize: 12, marginLeft: 3 } },
                        '\u53EF\u7528\u4F59\u989D\uFF1A'
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { style: { color: '#B69271', fontSize: 12, fontWeight: "500" } },
                        __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.availableVolume),
                        '\u5143'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 10, width: 10 }, src: __webpack_require__(274) })
                )
              )
            );
          }
        }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: 'currencyFund$ff', onClick: function onClick() {
              return _this4.choseBank();
            } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 15, paddingBottom: 15, WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
              '\u652F\u4ED8\u65B9\u5F0F'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#333', fontSize: 16, fontWeight: "500" } },
              '\u65E0\u652F\u4ED8\u65B9\u5F0F'
            )
          )
        ),
        this.renderRecharge()
      );
    }
  }]);

  return PayCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(state, ownProps);
  return {
    payInfoData: state[ownProps.type + 'PayInfo']

  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(PayCard));

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var H5page = function (_Component) {
  _inherits(H5page, _Component);

  function H5page(props) {
    _classCallCheck(this, H5page);

    var _this = _possibleConstructorReturn(this, (H5page.__proto__ || Object.getPrototypeOf(H5page)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(H5page, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.getElementById("viewDiv").innerHTML = '<object type="text/html" data="' + this.props.location.state.urlString + '" width="100%" height="100%"></object>';
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.props.location.state.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content', id: 'viewDiv' })
      );
    }
  }]);

  return H5page;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(H5page));

/***/ }),
/* 726 */,
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var barLayoutGrid = __webpack_require__(1076);

__webpack_require__(475);

__webpack_require__(1033);

__webpack_require__(1034);

__webpack_require__(471);

// In case developer forget to include grid component
echarts.registerLayout(zrUtil.curry(barLayoutGrid, 'bar')); // Visual coding for legend

echarts.registerVisual(function (ecModel) {
  ecModel.eachSeriesByType('bar', function (seriesModel) {
    var data = seriesModel.getData();
    data.setVisual('legendSymbol', 'roundRect');
  });
});

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CLicon04.a4b1948c.png";

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MyAsset.9bb341d8.png";

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC15.1030222d.png";

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPage6.cd88c24b.png";

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerTop.afc9864f.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowGrayRightOne.c91556ea.png";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/broker.257dd02a.png";

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close_header.5edee8df.png";

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hqt_bg.90c45537.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hqt_bg_bot.66a6e2b8.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon12.872e1e59.png";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon13.371a34ac.png";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon34.46fa3ee6.png";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.604c9371.png";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_bank_card.b173d417.png";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_cycle_plan.c3b3fe64.png";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_header.2e6ee899.png";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_pricateIcon.17847037.png";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_questionnaire.11843856.png";

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_search_server.5c59f5b8.png";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_setting.8a8361a8.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_stable_no.2824ba98.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/my_assets_user_select.4725a6eb.png";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nullty@4x.50de9799.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/private.699f272c.png";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/public.7a465937.png";

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/radio_big_bg.71a473fc.jpg";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/redStar.0e474cec.png";

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/redText.a9f2a7f9.png";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slices1@2x.aaec06d9.png";

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slices2@2x.ca47e429.png";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slices3@2x.777016d2.png";

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slices4@2x.e3b4be84.png";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/slices5@2x.2c3c13aa.png";

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/special.fbcb9132.png";

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/squareHook.dfc8fa9d.png";

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/submitBtn.8afe7f7a.png";

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/subscribe.f5b4a64e.png";

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/changjianwentiQ@3x.3b2a44ec.png";

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/changjianxiangqingA@3x.20ee6803.png";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/guidePage_openAccount.b12e8d7d.png";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/guidePage_trade.ea2971b4.png";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_guidePage.6471ba61.png";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_xiajiant.18f9f9eb.png";

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconkongkongruye.3876313d.png";

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_shangjiantou_1414_999999.95097fd2.png";

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xiaoicon_shuoming.06e8159a.png";

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFullscreenChange = handleFullscreenChange;
exports.activate = activate;
exports.userActivate = userActivate;
exports.play = play;
exports.pause = pause;
exports.togglePlay = togglePlay;
exports.seek = seek;
exports.forward = forward;
exports.replay = replay;
exports.changeRate = changeRate;
exports.changeVolume = changeVolume;
exports.mute = mute;
exports.toggleFullscreen = toggleFullscreen;
exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;

var _fullscreen = _interopRequireDefault(__webpack_require__(2001));

var OPERATE = 'video-react/OPERATE';
exports.OPERATE = OPERATE;
var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
exports.USER_ACTIVATE = USER_ACTIVATE;

function handleFullscreenChange(isFullscreen) {
  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: isFullscreen
  };
}

function activate(activity) {
  return {
    type: PLAYER_ACTIVATE,
    activity: activity
  };
}

function userActivate(activity) {
  return {
    type: USER_ACTIVATE,
    activity: activity
  };
}

function play() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'play',
    source: ''
  };
  this.video.play();
  return {
    type: OPERATE,
    operation: operation
  };
}

function pause() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'pause',
    source: ''
  };
  this.video.pause();
  return {
    type: OPERATE,
    operation: operation
  };
}

function togglePlay() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'toggle-play',
    source: ''
  };
  this.video.togglePlay();
  return {
    type: OPERATE,
    operation: operation
  };
} // seek video by time


function seek(time) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'seek',
    source: ''
  };
  this.video.seek(time);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump forward x seconds


function forward(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "forward-".concat(seconds),
    source: ''
  };
  this.video.forward(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump back x seconds


function replay(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "replay-".concat(seconds),
    source: ''
  };
  this.video.replay(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeRate(rate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-rate',
    source: ''
  };
  this.video.playbackRate = rate;
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeVolume(volume) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-volume',
    source: ''
  };
  var v = volume;

  if (volume < 0) {
    v = 0;
  }

  if (volume > 1) {
    v = 1;
  }

  this.video.volume = v;
  return {
    type: OPERATE,
    operation: operation
  };
}

function mute(muted) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: muted ? 'muted' : 'unmuted',
    source: ''
  };
  this.video.muted = muted;
  return {
    type: OPERATE,
    operation: operation
  };
}

function toggleFullscreen(player) {
  if (_fullscreen["default"].enabled) {
    if (_fullscreen["default"].isFullscreen) {
      _fullscreen["default"].exit();
    } else {
      _fullscreen["default"].request(this.rootElement);
    }

    return {
      type: OPERATE,
      operation: {
        action: 'toggle-fullscreen',
        source: ''
      }
    };
  }

  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: !player.isFullscreen
  };
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findElPosition = findElPosition;
exports.getPointerPosition = getPointerPosition;
exports.blurNode = blurNode;
exports.focusNode = focusNode;
exports.hasClass = hasClass;

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {ReactNodeRef} el React Node ref from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var _document = document,
      body = _document.body,
      docEl = _document.documentElement;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round

  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}
/**
 * Get pointer position in a React Node ref
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
 */


function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;
  var evtPageY = event.pageY;
  var evtPageX = event.pageX;

  if (event.changedTouches) {
    evtPageX = event.changedTouches[0].pageX;
    evtPageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
  return position;
} // blur an element


function blurNode(reactNode) {
  if (reactNode && reactNode.blur) {
    reactNode.blur();
  }
} // focus an element


function focusNode(reactNode) {
  if (reactNode && reactNode.focus) {
    reactNode.focus();
  }
} // check if an element has a class name


function hasClass(elm, cls) {
  var classes = elm.className.split(' ');

  for (var i = 0; i < classes.length; i++) {
    if (classes[i].toLowerCase() === cls.toLowerCase()) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./002ty@4x.png": 409,
	"./002yhkgl.jpg": 626,
	"./003ty@4x.png": 410,
	"./003yhkgl.jpg": 627,
	"./004ty@4x.png": 411,
	"./004yhkgl.jpg": 628,
	"./005ty@4x.png": 412,
	"./005yhkgl.jpg": 629,
	"./006ty@4x.png": 413,
	"./006yhkgl.jpg": 630,
	"./007ty@4x.png": 414,
	"./009ty@4x.png": 415,
	"./009yhkgl.jpg": 631,
	"./011ty@4x.png": 416,
	"./011yhkgl.jpg": 632,
	"./012ty@4x.png": 417,
	"./014ty@2x.png": 1661,
	"./014ty@3x.png": 1662,
	"./014ty@4x.png": 418,
	"./014yhkgl.jpg": 633,
	"./015ty@2x.png": 1663,
	"./015ty@3x.png": 1664,
	"./015ty@4x.png": 419,
	"./015yhkgl.jpg": 634,
	"./016ty@2x.png": 1665,
	"./016ty@3x.png": 1666,
	"./016ty@4x.png": 420,
	"./016yhkgl.jpg": 635,
	"./017ty@2x.png": 1667,
	"./017ty@3x.png": 1668,
	"./017ty@4x.png": 421,
	"./018ty@2x.png": 1669,
	"./018ty@3x.png": 1670,
	"./018ty@4x.png": 422,
	"./018yhkgl.jpg": 636,
	"./021ty@2x.png": 1671,
	"./021ty@3x.png": 1672,
	"./021ty@4x.png": 423,
	"./021yhkgl.jpg": 637,
	"./022ty@2x.png": 1673,
	"./022ty@3x.png": 1674,
	"./022ty@4x.png": 424,
	"./022yhkgl.jpg": 638,
	"./14-3.png": 1675,
	"./3.jpg": 1676,
	"./601Hou.png": 1677,
	"./601Hou@4x.png": 1678,
	"./60Hou.png": 1679,
	"./60Hou@4x.png": 1680,
	"./60Pie.png": 1681,
	"./60s.png": 639,
	"./701Hou.png": 1682,
	"./701Hou@4x.png": 1683,
	"./70Hou.png": 1684,
	"./70Hou@4x.png": 1685,
	"./70Pie.png": 1686,
	"./70s.png": 640,
	"./8-1.png": 1687,
	"./8-2.png": 1688,
	"./8-3.png": 1689,
	"./801Hou.png": 1690,
	"./801Hou@4x.png": 1691,
	"./80Hou.png": 1692,
	"./80Hou@4x.png": 1693,
	"./80Pie.png": 1694,
	"./80s.png": 641,
	"./903ty@2x.png": 1695,
	"./903ty@3x.png": 1696,
	"./903ty@4x.png": 425,
	"./904hqtxq.png": 642,
	"./904ty@2x.png": 1697,
	"./904ty@3x.png": 1698,
	"./904ty@4x.png": 426,
	"./907ty@2x.png": 1699,
	"./907ty@3x.png": 1700,
	"./907ty@4x.png": 427,
	"./915ty@2x.png": 1701,
	"./915ty@3x.png": 1702,
	"./915ty@4x.png": 428,
	"./All_yincang@2x.png": 1703,
	"./CLicon01.png": 1704,
	"./CLicon02.png": 1705,
	"./CLicon03.png": 1706,
	"./CLicon04.png": 731,
	"./Education.png": 1707,
	"./ID Card back_.png": 643,
	"./ID Card front_.png": 644,
	"./IMG_5881.PNG": 1127,
	"./IMG_5882.PNG": 1128,
	"./LcsBg.png": 1708,
	"./LcsTop-bg001.png": 1709,
	"./MyAsset.png": 732,
	"./RiskBanner.png": 1710,
	"./aixin.png": 1711,
	"./aixin2.png": 1712,
	"./anquan.png": 1713,
	"./answerChoose.png": 1714,
	"./answerChoose1.png": 1715,
	"./answerChoose2.png": 1716,
	"./answerPIC1.png": 1717,
	"./answerPIC11.png": 1718,
	"./answerPIC12.png": 1719,
	"./answerPIC13.png": 1720,
	"./answerPIC14.png": 1721,
	"./answerPIC15.png": 733,
	"./answerPIC2.png": 1722,
	"./answerPage.png": 1723,
	"./answerPage2.png": 1724,
	"./answerPage3.png": 1725,
	"./answerPage4.png": 1726,
	"./answerPage5.png": 1727,
	"./answerPage6.png": 734,
	"./answerTop.png": 735,
	"./answerTop@2x.png": 1728,
	"./arrowBm.png": 645,
	"./arrowBm2@4x.png": 232,
	"./arrowBm@4x.png": 233,
	"./arrowGrayRightOne.png": 736,
	"./arrowGrayTwo.png": 1729,
	"./arrowGrayTwoSS.png": 1730,
	"./arrowLeftTwo.png": 1731,
	"./arrow_02.png": 1732,
	"./bank.png": 39,
	"./bg.png": 1733,
	"./blhylIcon.png": 646,
	"./bottoms2.png": 1734,
	"./briefOne.jpg": 1735,
	"./briefOne.png": 1736,
	"./briefTwo.jpg": 1737,
	"./briefTwo.png": 1738,
	"./brief_logo.jpg": 1739,
	"./broker.png": 737,
	"./bt_bg1_30.png": 1740,
	"./bt_bg_14.png": 1741,
	"./btn_bg_03.png": 1742,
	"./call.png": 1743,
	"./camera_.png": 647,
	"./card_bg.png": 1744,
	"./circleHookG.png": 125,
	"./circleHookO.png": 151,
	"./clbsBg.jpg": 381,
	"./clbs_head.png": 648,
	"./close.png": 95,
	"./close_header.png": 738,
	"./clostR.png": 649,
	"./cqt.png": 650,
	"./daxueIcon.png": 651,
	"./daxuejy.png": 652,
	"./desktop.ini": 1129,
	"./downArrow_operating.png": 1745,
	"./dtan.png": 1746,
	"./dtan@2x.png": 1747,
	"./dtgl.png": 1748,
	"./dxJy.png": 1749,
	"./dxJy@4x.png": 1750,
	"./dxJyPie.png": 1751,
	"./dzoff.png": 382,
	"./dzon.png": 383,
	"./errorO.png": 653,
	"./fanhui@3x.png": 1752,
	"./feiyong.png": 1753,
	"./feiyong@4x..png": 1754,
	"./fenxsIcon.jpg": 1755,
	"./fenxsIcon.png": 1756,
	"./fenxsWrap.png": 1757,
	"./gaozhongIcon.png": 654,
	"./handerR.png": 1758,
	"./hdgz.png": 1759,
	"./hdgz@2x.png": 1760,
	"./hdgz@3x.png": 1761,
	"./headerMyAssetsBg.png": 1762,
	"./hf.png": 655,
	"./hqt.png": 429,
	"./hqt_bg.png": 739,
	"./hqt_bg_bot.png": 740,
	"./huakuai.png": 234,
	"./huatiao.png": 1763,
	"./huatiao7.png": 384,
	"./icon11.png": 385,
	"./icon12.png": 741,
	"./icon13.png": 742,
	"./icon14@4x.png": 1764,
	"./icon34.png": 743,
	"./icon35.png": 1765,
	"./icon4.png": 1766,
	"./iconDingTou.png": 1767,
	"./icon_LQB.png": 271,
	"./icon_RMB.png": 1768,
	"./icon_circle.png": 1769,
	"./icon_circleHook.png": 1770,
	"./icon_close@3x.png": 1771,
	"./icon_confirm.png": 1772,
	"./icon_error.png": 1773,
	"./icon_hqt.png": 386,
	"./icon_operating.png": 656,
	"./icon_success.png": 1774,
	"./iconhxcf_icon_youjiantou_10_gray.png": 1775,
	"./icon／icon_changjianwenti.png": 1776,
	"./icon／icon_jiaoyixiangqing_shibai.png": 1777,
	"./icon／icon_jiaoyixiangqing_yiwancheng.png": 1778,
	"./icon／icon_jiaoyixiangqing_yiwancheng@3x.png": 1779,
	"./icon／icon_shangjiantou_1414_999999@3x.png": 1780,
	"./icon／icon_xiajiantou_1414_999999.png": 1781,
	"./img3@2x.jpg": 1782,
	"./img3@3x.jpg": 1783,
	"./index.html": 1953,
	"./ing.png": 1784,
	"./investBtn1.png": 1785,
	"./investBtn2.png": 1786,
	"./investBtnBg.png": 1787,
	"./jh.png": 657,
	"./jhPie.png": 658,
	"./jjPie.png": 659,
	"./jjzhIcon.png": 660,
	"./jq.png": 661,
	"./jq1.png": 1788,
	"./jqrIcon.png": 83,
	"./jsqA@4x.png": 1789,
	"./jsqWrap.png": 1790,
	"./jsqi.png": 1791,
	"./junhengx.png": 190,
	"./kefu.png": 1792,
	"./lcs_logo.png": 1793,
	"./lcs_newbg.jpg": 1794,
	"./lcs_txt.png": 1795,
	"./lcs_txt@2x.png": 1796,
	"./lcs_xj.png": 1797,
	"./leftArrow_header.png": 21,
	"./login_input_cancel.png": 47,
	"./logo.png": 744,
	"./logo1.png": 662,
	"./mingxing_bg_09.png": 1798,
	"./money1.png": 663,
	"./money2.png": 664,
	"./money3.png": 665,
	"./money4.png": 666,
	"./my_assets_bank_card.png": 745,
	"./my_assets_cycle_plan.png": 746,
	"./my_assets_header.png": 747,
	"./my_assets_investing.png": 667,
	"./my_assets_item_foot.png": 163,
	"./my_assets_pricateIcon.png": 748,
	"./my_assets_questionnaire.png": 749,
	"./my_assets_search_server.png": 750,
	"./my_assets_setting.png": 751,
	"./my_assets_stable_no.png": 752,
	"./my_assets_user_select.png": 753,
	"./n_hava_cast_bg.png": 1799,
	"./n_hava_cast_bg@2x.png": 1800,
	"./n_hava_cast_header_bg.png": 1801,
	"./n_hava_cast_header_bg@2x.png": 1802,
	"./n_icon_arrow_gray.png": 387,
	"./n_icon_arrow_gray@2x.png": 272,
	"./n_icon_dynameic.png": 1803,
	"./n_icon_dynameic@2x.png": 668,
	"./n_icon_goback.png": 430,
	"./n_icon_goback@2x.png": 152,
	"./n_icon_header_bg.png": 1804,
	"./n_icon_header_bg@2x.png": 669,
	"./n_icon_highlight.png": 1805,
	"./n_icon_highlight@2x.png": 1806,
	"./n_icon_jiaoyimingxi.png": 670,
	"./n_icon_jiaoyimingxi@2x.png": 1807,
	"./n_icon_kefu.png": 671,
	"./n_icon_kefu@2x.png": 1808,
	"./n_icon_position_arrow.png": 1809,
	"./n_icon_position_arrow@2x.png": 672,
	"./n_icon_right_arrow.png": 273,
	"./n_icon_right_arrow@2x.png": 1810,
	"./n_icon_shouyimingxi.png": 673,
	"./n_icon_shouyimingxi@2x.png": 1811,
	"./n_icon_shuoming.png": 674,
	"./n_icon_shuoming@2x.png": 1812,
	"./n_icon_strategy.png": 1813,
	"./n_icon_strategy@2x.png": 1814,
	"./n_icon_tab.png": 1815,
	"./n_icon_tab@2x.png": 1816,
	"./n_icon_tab_left.png": 1817,
	"./n_icon_tab_left@2x.png": 1818,
	"./n_icon_video.png": 1819,
	"./n_icon_video@2x.png": 1820,
	"./n_icon_what .png": 675,
	"./n_icon_what@2.png": 388,
	"./n_service-report-bg.png": 1821,
	"./n_service-report-bg@2x.png": 1822,
	"./n_service-report-tag.png": 1823,
	"./n_service-report-tag@2x.png": 1824,
	"./name_03.png": 1825,
	"./nextBg.png": 1826,
	"./nullty@4x.png": 754,
	"./open.png": 676,
	"./orgBg.jpg": 1827,
	"./page_02.jpg": 1828,
	"./page_03.jpg": 1829,
	"./page_04.jpg": 1830,
	"./password_hide.png": 110,
	"./password_unhide.png": 111,
	"./payErr_bg.png": 1831,
	"./paySucc_bg.png": 1832,
	"./phone_03.png": 1833,
	"./pic_1_14.jpg": 1834,
	"./pic_2_17.jpg": 1835,
	"./pic_3_20.jpg": 1836,
	"./pic_4_22.jpg": 1837,
	"./pic_5_24.jpg": 1838,
	"./pic_6_26.jpg": 1839,
	"./pic_7_28.jpg": 1840,
	"./pic_8_30.jpg": 1841,
	"./pic_jl.jpg": 1842,
	"./pic_xj.jpg": 1843,
	"./popover_Bankquota.png": 1844,
	"./popover_count.png": 1845,
	"./popover_input.png": 1846,
	"./popover_read.png": 1847,
	"./private.png": 755,
	"./protocol_select.png": 1848,
	"./protocol_selected.png": 55,
	"./public.png": 756,
	"./qlhylIcon.png": 677,
	"./qpxIcon.png": 678,
	"./radio_big_bg.jpg": 757,
	"./rchx.png": 679,
	"./redStar.png": 758,
	"./redText.png": 759,
	"./registerBg2.jpeg": 1849,
	"./registerHook.png": 1850,
	"./rightArrow.png": 153,
	"./round_bs.png": 680,
	"./ruleImg.png": 1851,
	"./ruleImg1.png": 1852,
	"./ruleImg2.png": 1853,
	"./ruleImg3.png": 1854,
	"./ruleImg4.png": 1855,
	"./search_header.png": 681,
	"./search_header_back.png": 1856,
	"./selectRound.png": 76,
	"./simu_bg_07.png": 1857,
	"./slices1@2x.png": 760,
	"./slices2@2x.png": 761,
	"./slices3@2x.png": 762,
	"./slices4@2x.png": 763,
	"./slices5@2x.png": 764,
	"./slxx.png": 682,
	"./smRound.png": 683,
	"./smallWh.png": 431,
	"./special.png": 765,
	"./square.png": 51,
	"./square1.png": 1858,
	"./square@3x.png": 389,
	"./squareHook.png": 766,
	"./squareHookNew.png": 684,
	"./squareHooks@3x.png": 390,
	"./squareNew.png": 685,
	"./submitBtn.png": 767,
	"./submitBtn@2x.png": 1859,
	"./subscribe.png": 768,
	"./successO.png": 432,
	"./superBg@4x.png": 1860,
	"./tdfBanner@4x.png": 1861,
	"./theLoading1.png": 235,
	"./theLoading10.png": 236,
	"./theLoading11.png": 237,
	"./theLoading12.png": 238,
	"./theLoading13.png": 239,
	"./theLoading14.png": 240,
	"./theLoading15.png": 241,
	"./theLoading16.png": 242,
	"./theLoading17.png": 243,
	"./theLoading18.png": 244,
	"./theLoading19.png": 245,
	"./theLoading2.png": 246,
	"./theLoading20.png": 247,
	"./theLoading21.png": 248,
	"./theLoading22.png": 249,
	"./theLoading23.png": 250,
	"./theLoading24.png": 251,
	"./theLoading25.png": 252,
	"./theLoading3.png": 253,
	"./theLoading4.png": 254,
	"./theLoading5.png": 255,
	"./theLoading6.png": 256,
	"./theLoading7.png": 257,
	"./theLoading8.png": 258,
	"./theLoading9.png": 259,
	"./toBottom.png": 1862,
	"./toTop.png": 1863,
	"./top_bg_01.jpg": 1864,
	"./tops2.png": 1865,
	"./touxiang.png": 1866,
	"./tzzj.png": 686,
	"./upArrow_operating.png": 1867,
	"./wenhao.png": 126,
	"./wenhao2.png": 1868,
	"./wenhao3.png": 687,
	"./wenjianx.png": 1869,
	"./wj.png": 688,
	"./wjPie.png": 689,
	"./wlzs.jpg": 1870,
	"./wlzs.png": 1871,
	"./xfzj.png": 690,
	"./xiaoxueIcon.png": 691,
	"./xqgz.png": 692,
	"./xuanzhong.png": 693,
	"./xuanzhong@2x.png": 1872,
	"./xxGray.png": 1873,
	"./xxJy.png": 1874,
	"./xxJy@4x.png": 1875,
	"./xxJyPie.png": 1876,
	"./xxYellow.png": 1877,
	"./yzm_bg_03.png": 1878,
	"./zcdt_Down.png": 1879,
	"./zcdt_Fhjl.png": 1880,
	"./zcdt_Jyjl.png": 1881,
	"./zcdt_Mytg.png": 1882,
	"./zcdt_Right@2x.png": 1883,
	"./zcdt_Symx.png": 1884,
	"./zcdt_Up.png": 1885,
	"./zcdt_Xi@2x.png": 1886,
	"./zcdt_xianshi@2x.png": 1887,
	"./zhizhen.png": 191,
	"./zhongxuejy.png": 694,
	"./zhuanpan.png": 695,
	"./znyx.png": 1888,
	"./zxJy.png": 1889,
	"./zxJy@4x.png": 1890,
	"./zxJyPie.png": 1891
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 780;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(1957);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(2011);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(783);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(24);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
function hasClass(node, className) {
    if (node.classList) {
        return node.classList.contains(className);
    }
    var originClass = node.className;
    return (' ' + originClass + ' ').indexOf(' ' + className + ' ') > -1;
}
function addClass(node, className) {
    if (node.classList) {
        node.classList.add(className);
    } else {
        if (!hasClass(node, className)) {
            node.className = node.className + ' ' + className;
        }
    }
}
function removeClass(node, className) {
    if (node.classList) {
        node.classList.remove(className);
    } else {
        if (hasClass(node, className)) {
            var originClass = node.className;
            node.className = (' ' + originClass + ' ').replace(' ' + className + ' ', '');
        }
    }
}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcCollapse = __webpack_require__(1193);

var _rcCollapse2 = _interopRequireDefault(_rcCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Accordion = function (_React$Component) {
    (0, _inherits3['default'])(Accordion, _React$Component);

    function Accordion() {
        (0, _classCallCheck3['default'])(this, Accordion);
        return (0, _possibleConstructorReturn3['default'])(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Accordion, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_rcCollapse2['default'], this.props);
        }
    }]);
    return Accordion;
}(_react2['default'].Component);

exports['default'] = Accordion;

Accordion.Panel = _rcCollapse.Panel;
Accordion.defaultProps = {
    prefixCls: 'am-accordion'
};
module.exports = exports['default'];

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _rcDialog = __webpack_require__(212);

var _rcDialog2 = _interopRequireDefault(_rcDialog);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

var _getDataAttr = __webpack_require__(165);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var NORMAL = 'NORMAL'; /* tslint:disable:jsx-no-multiline-js */

var SHARE = 'SHARE';
function noop() {}
var queue = [];
function createActionSheet(flag, config, callback) {
    var _classNames;

    var props = (0, _extends3['default'])({ prefixCls: 'am-action-sheet', cancelButtonText: '取消' }, config);
    var prefixCls = props.prefixCls,
        className = props.className,
        transitionName = props.transitionName,
        maskTransitionName = props.maskTransitionName,
        _props$maskClosable = props.maskClosable,
        maskClosable = _props$maskClosable === undefined ? true : _props$maskClosable;

    var div = document.createElement('div');
    document.body.appendChild(div);
    queue.push(close);
    function close() {
        if (div) {
            _reactDom2['default'].unmountComponentAtNode(div);
            div.parentNode.removeChild(div);
            div = null;
            var index = queue.indexOf(close);
            if (index !== -1) {
                queue.splice(index, 1);
            }
        }
    }
    function cb(index) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        var res = callback(index, rowIndex);
        if (res && res.then) {
            res.then(function () {
                close();
            });
        } else {
            close();
        }
    }
    var title = props.title,
        message = props.message,
        options = props.options,
        destructiveButtonIndex = props.destructiveButtonIndex,
        cancelButtonIndex = props.cancelButtonIndex,
        cancelButtonText = props.cancelButtonText;

    var titleMsg = [title ? _react2['default'].createElement(
        'h3',
        { key: '0', className: prefixCls + '-title' },
        title
    ) : null, message ? _react2['default'].createElement(
        'div',
        { key: '1', className: prefixCls + '-message' },
        message
    ) : null];
    var children = null;
    var mode = 'normal';
    switch (flag) {
        case NORMAL:
            mode = 'normal';
            children = _react2['default'].createElement(
                'div',
                (0, _getDataAttr2['default'])(props),
                titleMsg,
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-button-list', role: 'group' },
                    options.map(function (item, index) {
                        var _cls;

                        var cls = (_cls = {}, (0, _defineProperty3['default'])(_cls, prefixCls + '-button-list-item', true), (0, _defineProperty3['default'])(_cls, prefixCls + '-destructive-button', destructiveButtonIndex === index), (0, _defineProperty3['default'])(_cls, prefixCls + '-cancel-button', cancelButtonIndex === index), _cls);
                        var itemProps = {
                            className: (0, _classnames2['default'])(cls),
                            onClick: function onClick() {
                                return cb(index);
                            },
                            role: 'button'
                        };
                        var bItem = _react2['default'].createElement(
                            _rcTouchable2['default'],
                            { key: index, activeClassName: prefixCls + '-button-list-item-active' },
                            _react2['default'].createElement(
                                'div',
                                itemProps,
                                item
                            )
                        );
                        if (cancelButtonIndex === index || destructiveButtonIndex === index) {
                            bItem = _react2['default'].createElement(
                                _rcTouchable2['default'],
                                { key: index, activeClassName: prefixCls + '-button-list-item-active' },
                                _react2['default'].createElement(
                                    'div',
                                    itemProps,
                                    item,
                                    cancelButtonIndex === index ? _react2['default'].createElement('span', { className: prefixCls + '-cancel-button-mask' }) : null
                                )
                            );
                        }
                        return bItem;
                    })
                )
            );
            break;
        case SHARE:
            mode = 'share';
            var multipleLine = options.length && Array.isArray(options[0]) || false;
            var createList = function createList(item, index) {
                var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                return _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-share-list-item', role: 'button', key: index, onClick: function onClick() {
                            return cb(index, rowIndex);
                        } },
                    _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-share-list-item-icon' },
                        item.iconName ? _react2['default'].createElement(_index2['default'], { type: item.iconName }) : item.icon
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-share-list-item-title' },
                        item.title
                    )
                );
            };
            children = _react2['default'].createElement(
                'div',
                (0, _getDataAttr2['default'])(props),
                titleMsg,
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-share' },
                    multipleLine ? options.map(function (item, index) {
                        return _react2['default'].createElement(
                            'div',
                            { key: index, className: prefixCls + '-share-list' },
                            item.map(function (ii, ind) {
                                return createList(ii, ind, index);
                            })
                        );
                    }) : _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-share-list' },
                        options.map(function (item, index) {
                            return createList(item, index);
                        })
                    ),
                    _react2['default'].createElement(
                        _rcTouchable2['default'],
                        { activeClassName: prefixCls + '-share-cancel-button-active' },
                        _react2['default'].createElement(
                            'div',
                            { className: prefixCls + '-share-cancel-button', role: 'button', onClick: function onClick() {
                                    return cb(-1);
                                } },
                            cancelButtonText
                        )
                    )
                )
            );
            break;
        default:
            break;
    }
    var rootCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + mode, true), _classNames));
    _reactDom2['default'].render(_react2['default'].createElement(
        _rcDialog2['default'],
        { visible: true, title: '', footer: '', prefixCls: prefixCls, className: rootCls, transitionName: transitionName || 'am-slide-up', maskTransitionName: maskTransitionName || 'am-fade', onClose: function onClose() {
                return cb(cancelButtonIndex || -1);
            }, maskClosable: maskClosable, wrapProps: props.wrapProps || {} },
        children
    ), div);
    return {
        close: close
    };
}
exports['default'] = {
    showActionSheetWithOptions: function showActionSheetWithOptions(config) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        createActionSheet(NORMAL, config, callback);
    },
    showShareActionSheetWithOptions: function showShareActionSheetWithOptions(config) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        createActionSheet(SHARE, config, callback);
    },
    close: function close() {
        queue.forEach(function (q) {
            return q();
        });
    }
};
module.exports = exports['default'];

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
var ActivityIndicator = function (_React$Component) {
    (0, _inherits3['default'])(ActivityIndicator, _React$Component);

    function ActivityIndicator() {
        (0, _classCallCheck3['default'])(this, ActivityIndicator);
        return (0, _possibleConstructorReturn3['default'])(this, (ActivityIndicator.__proto__ || Object.getPrototypeOf(ActivityIndicator)).apply(this, arguments));
    }

    (0, _createClass3['default'])(ActivityIndicator, [{
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                animating = _props.animating,
                toast = _props.toast,
                size = _props.size,
                text = _props.text;

            var wrapClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-toast', !!toast), _classNames));
            var spinnerClass = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-spinner', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-spinner-lg', !!toast || size === 'large'), _classNames2));
            if (animating) {
                if (toast) {
                    return _react2['default'].createElement(
                        'div',
                        { className: wrapClass },
                        text ? _react2['default'].createElement(
                            'div',
                            { className: prefixCls + '-content' },
                            _react2['default'].createElement('span', { className: spinnerClass, 'aria-hidden': 'true' }),
                            _react2['default'].createElement(
                                'span',
                                { className: prefixCls + '-toast' },
                                text
                            )
                        ) : _react2['default'].createElement(
                            'div',
                            { className: prefixCls + '-content' },
                            _react2['default'].createElement('span', { className: spinnerClass, 'aria-label': 'Loading' })
                        )
                    );
                } else {
                    return text ? _react2['default'].createElement(
                        'div',
                        { className: wrapClass },
                        _react2['default'].createElement('span', { className: spinnerClass, 'aria-hidden': 'true' }),
                        _react2['default'].createElement(
                            'span',
                            { className: prefixCls + '-tip' },
                            text
                        )
                    ) : _react2['default'].createElement(
                        'div',
                        { className: wrapClass },
                        _react2['default'].createElement('span', { className: spinnerClass, 'aria-label': 'loading' })
                    );
                }
            } else {
                return null;
            }
        }
    }]);
    return ActivityIndicator;
}(_react2['default'].Component);

exports['default'] = ActivityIndicator;

ActivityIndicator.defaultProps = {
    prefixCls: 'am-activity-indicator',
    animating: true,
    size: 'small',
    panelColor: 'rgba(34,34,34,0.6)',
    toast: false
};
module.exports = exports['default'];

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var CardBody = function (_React$Component) {
    (0, _inherits3['default'])(CardBody, _React$Component);

    function CardBody() {
        (0, _classCallCheck3['default'])(this, CardBody);
        return (0, _possibleConstructorReturn3['default'])(this, (CardBody.__proto__ || Object.getPrototypeOf(CardBody)).apply(this, arguments));
    }

    (0, _createClass3['default'])(CardBody, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                restProps = __rest(_a, ["prefixCls", "className"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-body', true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement('div', (0, _extends3['default'])({ className: wrapCls }, restProps));
        }
    }]);
    return CardBody;
}(_react2['default'].Component);

exports['default'] = CardBody;

CardBody.defaultProps = {
    prefixCls: 'am-card'
};
module.exports = exports['default'];

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var CardFooter = function (_React$Component) {
    (0, _inherits3['default'])(CardFooter, _React$Component);

    function CardFooter() {
        (0, _classCallCheck3['default'])(this, CardFooter);
        return (0, _possibleConstructorReturn3['default'])(this, (CardFooter.__proto__ || Object.getPrototypeOf(CardFooter)).apply(this, arguments));
    }

    (0, _createClass3['default'])(CardFooter, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                content = _a.content,
                className = _a.className,
                extra = _a.extra,
                restProps = __rest(_a, ["prefixCls", "content", "className", "extra"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-footer', true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls }, restProps),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-footer-content' },
                    content
                ),
                extra && _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-footer-extra' },
                    extra
                )
            );
        }
    }]);
    return CardFooter;
}(_react2['default'].Component);

exports['default'] = CardFooter;

CardFooter.defaultProps = {
    prefixCls: 'am-card'
};
module.exports = exports['default'];

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var CardHeader = function (_React$Component) {
    (0, _inherits3['default'])(CardHeader, _React$Component);

    function CardHeader() {
        (0, _classCallCheck3['default'])(this, CardHeader);
        return (0, _possibleConstructorReturn3['default'])(this, (CardHeader.__proto__ || Object.getPrototypeOf(CardHeader)).apply(this, arguments));
    }

    (0, _createClass3['default'])(CardHeader, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                title = _a.title,
                thumb = _a.thumb,
                thumbStyle = _a.thumbStyle,
                extra = _a.extra,
                restProps = __rest(_a, ["prefixCls", "className", "title", "thumb", "thumbStyle", "extra"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-header', true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls }, restProps),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-header-content' },
                    typeof thumb === 'string' ? _react2['default'].createElement('img', { style: thumbStyle, src: thumb }) : thumb,
                    title
                ),
                extra ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-header-extra' },
                    extra
                ) : null
            );
        }
    }]);
    return CardHeader;
}(_react2['default'].Component);

exports['default'] = CardHeader;

CardHeader.defaultProps = {
    prefixCls: 'am-card',
    thumbStyle: {}
};
module.exports = exports['default'];

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _CardHeader = __webpack_require__(791);

var _CardHeader2 = _interopRequireDefault(_CardHeader);

var _CardBody = __webpack_require__(789);

var _CardBody2 = _interopRequireDefault(_CardBody);

var _CardFooter = __webpack_require__(790);

var _CardFooter2 = _interopRequireDefault(_CardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Card = function (_React$Component) {
    (0, _inherits3['default'])(Card, _React$Component);

    function Card() {
        (0, _classCallCheck3['default'])(this, Card);
        return (0, _possibleConstructorReturn3['default'])(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Card, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                full = _a.full,
                className = _a.className,
                resetProps = __rest(_a, ["prefixCls", "full", "className"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-full', full), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement('div', (0, _extends3['default'])({ className: wrapCls }, resetProps));
        }
    }]);
    return Card;
}(_react2['default'].Component);

exports['default'] = Card;

Card.defaultProps = {
    prefixCls: 'am-card',
    full: false
};
Card.Header = _CardHeader2['default'];
Card.Body = _CardBody2['default'];
Card.Footer = _CardFooter2['default'];
module.exports = exports['default'];

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _Checkbox = __webpack_require__(277);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _getDataAttr = __webpack_require__(165);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AgreeItem = function (_React$Component) {
    (0, _inherits3['default'])(AgreeItem, _React$Component);

    function AgreeItem() {
        (0, _classCallCheck3['default'])(this, AgreeItem);
        return (0, _possibleConstructorReturn3['default'])(this, (AgreeItem.__proto__ || Object.getPrototypeOf(AgreeItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(AgreeItem, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                style = _props.style,
                className = _props.className;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-agree', true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, (0, _getDataAttr2['default'])(this.props), { className: wrapCls, style: style }),
                _react2['default'].createElement(_Checkbox2['default'], (0, _extends3['default'])({}, (0, _omit2['default'])(this.props, ['style']), { className: prefixCls + '-agree-label' }))
            );
        }
    }]);
    return AgreeItem;
}(_react2['default'].Component);

exports['default'] = AgreeItem;

AgreeItem.defaultProps = {
    prefixCls: 'am-checkbox'
};
module.exports = exports['default'];

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(130);

var _index2 = _interopRequireDefault(_index);

var _Checkbox = __webpack_require__(277);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ListItem = _index2['default'].Item;
function noop() {}

var CheckboxItem = function (_React$Component) {
    (0, _inherits3['default'])(CheckboxItem, _React$Component);

    function CheckboxItem() {
        (0, _classCallCheck3['default'])(this, CheckboxItem);
        return (0, _possibleConstructorReturn3['default'])(this, (CheckboxItem.__proto__ || Object.getPrototypeOf(CheckboxItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(CheckboxItem, [{
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                listPrefixCls = _props.listPrefixCls,
                className = _props.className,
                children = _props.children,
                disabled = _props.disabled,
                _props$checkboxProps = _props.checkboxProps,
                checkboxProps = _props$checkboxProps === undefined ? {} : _props$checkboxProps;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-disabled', disabled === true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            // Note: if not omit `onChange`, it will trigger twice on check listitem
            var otherProps = (0, _omit2['default'])(this.props, ['listPrefixCls', 'onChange', 'disabled', 'checkboxProps']);
            if (disabled) {
                delete otherProps.onClick;
            } else {
                otherProps.onClick = otherProps.onClick || noop;
            }
            var extraProps = {};
            ['name', 'defaultChecked', 'checked', 'onChange', 'disabled'].forEach(function (i) {
                if (i in _this2.props) {
                    extraProps[i] = _this2.props[i];
                }
            });
            return _react2['default'].createElement(
                ListItem,
                (0, _extends3['default'])({}, otherProps, { prefixCls: listPrefixCls, className: wrapCls, thumb: _react2['default'].createElement(_Checkbox2['default'], (0, _extends3['default'])({}, checkboxProps, extraProps)) }),
                children
            );
        }
    }]);
    return CheckboxItem;
}(_react2['default'].Component);

exports['default'] = CheckboxItem;

CheckboxItem.defaultProps = {
    prefixCls: 'am-checkbox',
    listPrefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createSliderWithTooltip = __webpack_require__(1315);

var _createSliderWithTooltip2 = _interopRequireDefault(_createSliderWithTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _createSliderWithTooltip2['default'];
module.exports = exports['default'];

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popup = __webpack_require__(1563);

var _Popup2 = _interopRequireDefault(_Popup);

var _DatePicker = __webpack_require__(1562);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _utils = __webpack_require__(798);

var _getLocale = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDefaultProps() {
    return (0, _extends3['default'])({ prefixCls: 'am-picker', pickerPrefixCls: 'am-picker-col', popupPrefixCls: 'am-picker-popup', minuteStep: 1 }, (0, _utils.getProps)());
}

var DatePicker = function (_React$Component) {
    (0, _inherits3['default'])(DatePicker, _React$Component);

    function DatePicker() {
        (0, _classCallCheck3['default'])(this, DatePicker);
        return (0, _possibleConstructorReturn3['default'])(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
    }

    (0, _createClass3['default'])(DatePicker, [{
        key: 'render',
        value: function render() {
            var props = this.props,
                context = this.context;
            var children = props.children,
                value = props.value,
                defaultDate = props.defaultDate,
                extra = props.extra,
                popupPrefixCls = props.popupPrefixCls;

            var locale = (0, _getLocale.getComponentLocale)(props, context, 'DatePicker', function () {
                return __webpack_require__(797);
            });
            var localeCode = (0, _getLocale.getLocaleCode)(context);
            var okText = locale.okText,
                dismissText = locale.dismissText,
                DatePickerLocale = locale.DatePickerLocale;

            if (localeCode) {
                if (value) {
                    value.locale(localeCode);
                }
                if (defaultDate) {
                    defaultDate.locale(localeCode);
                }
            }
            var dataPicker = _react2['default'].createElement(_DatePicker2['default'], { minuteStep: props.minuteStep, locale: DatePickerLocale, minDate: props.minDate, maxDate: props.maxDate, mode: props.mode, pickerPrefixCls: props.pickerPrefixCls, prefixCls: props.prefixCls, defaultDate: value || (0, _utils.getDefaultDate)(this.props) });
            return _react2['default'].createElement(
                _Popup2['default'],
                (0, _extends3['default'])({ datePicker: dataPicker, WrapComponent: 'div', transitionName: 'am-slide-up', maskTransitionName: 'am-fade' }, props, { prefixCls: popupPrefixCls, date: value || (0, _utils.getDefaultDate)(this.props), dismissText: dismissText, okText: okText }),
                children && _react2['default'].cloneElement(children, { extra: value ? (0, _utils.formatFn)(this, value) : extra })
            );
        }
    }]);
    return DatePicker;
}(_react2['default'].Component);

exports['default'] = DatePicker;

DatePicker.defaultProps = getDefaultProps();
DatePicker.contextTypes = {
    antLocale: _propTypes2['default'].object
};
module.exports = exports['default'];

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _zh_CN = __webpack_require__(1565);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    okText: '确定',
    dismissText: '取消',
    DatePickerLocale: _zh_CN2['default']
};
module.exports = exports['default'];

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(279);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.formatFn = formatFn;
exports.getProps = getProps;
exports.getDefaultDate = getDefaultDate;

var _moment = __webpack_require__(310);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getFormatter(type) {
    var formatter = void 0;
    if (type === 'time') {
        formatter = 'HH:mm';
    } else if (type === 'datetime') {
        formatter = 'YYYY-MM-DD HH:mm';
    } else {
        formatter = 'YYYY-MM-DD';
    }
    return formatter;
}
function formatFn(instance, value) {
    var format = instance.props.format;

    var type = typeof format === 'undefined' ? 'undefined' : (0, _typeof3['default'])(format);
    if (type === 'string') {
        return value.format(type);
    }
    if (type === 'function') {
        return format(value);
    }
    return value.format(getFormatter(instance.props.mode));
}
function getProps() {
    return {
        mode: 'datetime',
        extra: '请选择',
        onChange: function onChange() {},

        title: ''
    };
}
function getDefaultDate(props) {
    var defaultDate = props.defaultDate,
        minDate = props.minDate,
        maxDate = props.maxDate;

    if (defaultDate) {
        return defaultDate;
    }
    var now = (0, _moment2['default'])();
    if (minDate && now.isBefore(minDate)) {
        return minDate;
    }
    if (maxDate && maxDate.isBefore(now)) {
        return minDate;
    }
    return now;
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcDrawer = __webpack_require__(1204);

var _rcDrawer2 = _interopRequireDefault(_rcDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Drawer = function (_React$Component) {
    (0, _inherits3['default'])(Drawer, _React$Component);

    function Drawer() {
        (0, _classCallCheck3['default'])(this, Drawer);
        return (0, _possibleConstructorReturn3['default'])(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Drawer, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_rcDrawer2['default'], this.props);
        }
    }]);
    return Drawer;
}(_react2['default'].Component);

exports['default'] = Drawer;

Drawer.defaultProps = {
    prefixCls: 'am-drawer',
    enableDragHandle: false
};
module.exports = exports['default'];

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Flex = function (_React$Component) {
    (0, _inherits3['default'])(Flex, _React$Component);

    function Flex() {
        (0, _classCallCheck3['default'])(this, Flex);
        return (0, _possibleConstructorReturn3['default'])(this, (Flex.__proto__ || Object.getPrototypeOf(Flex)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Flex, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                direction = _a.direction,
                wrap = _a.wrap,
                justify = _a.justify,
                align = _a.align,
                alignContent = _a.alignContent,
                className = _a.className,
                children = _a.children,
                prefixCls = _a.prefixCls,
                style = _a.style,
                restProps = __rest(_a, ["direction", "wrap", "justify", "align", "alignContent", "className", "children", "prefixCls", "style"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dir-row', direction === 'row'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dir-row-reverse', direction === 'row-reverse'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dir-column', direction === 'column'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dir-column-reverse', direction === 'column-reverse'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-nowrap', wrap === 'nowrap'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrap', wrap === 'wrap'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrap-reverse', wrap === 'wrap-reverse'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-justify-start', justify === 'start'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-justify-end', justify === 'end'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-justify-center', justify === 'center'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-justify-between', justify === 'between'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-justify-around', justify === 'around'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-top', align === 'top' || align === 'start'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-middle', align === 'middle' || align === 'center'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-bottom', align === 'bottom' || align === 'end'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-baseline', align === 'baseline'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-stretch', align === 'stretch'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-content-start', alignContent === 'start'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-content-end', alignContent === 'end'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-content-center', alignContent === 'center'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-content-between', alignContent === 'between'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-content-around', alignContent === 'around'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-align-content-stretch', alignContent === 'stretch'), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                children
            );
        }
    }]);
    return Flex;
}(_react2['default'].Component);

exports['default'] = Flex;

Flex.defaultProps = {
    prefixCls: 'am-flexbox',
    align: 'center'
};
module.exports = exports['default'];

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var FlexItem = function (_React$Component) {
    (0, _inherits3['default'])(FlexItem, _React$Component);

    function FlexItem() {
        (0, _classCallCheck3['default'])(this, FlexItem);
        return (0, _possibleConstructorReturn3['default'])(this, (FlexItem.__proto__ || Object.getPrototypeOf(FlexItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(FlexItem, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                style = _a.style,
                restProps = __rest(_a, ["children", "className", "prefixCls", "style"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                children
            );
        }
    }]);
    return FlexItem;
}(_react2['default'].Component);

exports['default'] = FlexItem;

FlexItem.defaultProps = {
    prefixCls: 'am-flexbox'
};
module.exports = exports['default'];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(166);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(436);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var Grid = function (_React$Component) {
    (0, _inherits3['default'])(Grid, _React$Component);

    function Grid() {
        (0, _classCallCheck3['default'])(this, Grid);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).apply(this, arguments));

        _this.state = {
            initialSlideWidth: 0
        };
        _this.renderCarousel = function (rowsArr, pageCount, rowCount) {
            var prefixCls = _this.props.prefixCls;

            var carouselMaxRow = _this.props.carouselMaxRow;
            var pagesArr = [];
            for (var pageIndex = 0; pageIndex < pageCount; pageIndex++) {
                var pageRows = [];
                for (var ii = 0; ii < carouselMaxRow; ii++) {
                    var rowIndex = pageIndex * carouselMaxRow + ii;
                    if (rowIndex < rowCount) {
                        pageRows.push(rowsArr[rowIndex]);
                    } else {
                        // 空节点为了确保末尾页的最后未到底的行有底线(样式中last-child会没线)
                        pageRows.push(_react2['default'].createElement('div', { key: 'gridline-' + rowIndex }));
                    }
                }
                pagesArr.push(_react2['default'].createElement(
                    'div',
                    { key: 'pageitem-' + pageIndex, className: prefixCls + '-carousel-page' },
                    pageRows
                ));
            }
            return pagesArr;
        };
        _this.renderItem = function (dataItem, index, columnNum, renderItem) {
            var prefixCls = _this.props.prefixCls;

            var itemEl = null;
            if (renderItem) {
                itemEl = renderItem(dataItem, index);
            } else {
                if (dataItem) {
                    var icon = dataItem.icon,
                        text = dataItem.text;

                    itemEl = _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-item-inner-content column-num-' + columnNum },
                        _react2['default'].isValidElement(icon) ? icon : _react2['default'].createElement('img', { className: prefixCls + '-icon', src: icon }),
                        _react2['default'].createElement(
                            'div',
                            { className: prefixCls + '-text' },
                            text
                        )
                    );
                }
            }
            return _react2['default'].createElement(
                'div',
                { className: prefixCls + '-item-content' },
                itemEl
            );
        };
        _this.getRows = function (rowCount, dataLength) {
            var _this$props = _this.props,
                columnNum = _this$props.columnNum,
                data = _this$props.data,
                renderItem = _this$props.renderItem,
                prefixCls = _this$props.prefixCls,
                _onClick = _this$props.onClick;

            var rowsArr = [];
            columnNum = columnNum;
            var rowWidth = 100 / columnNum + '%';
            var colStyle = {
                width: rowWidth
            };
            for (var i = 0; i < rowCount; i++) {
                var rowArr = [];

                var _loop = function _loop(j) {
                    var dataIndex = i * columnNum + j;
                    var itemEl = void 0;
                    if (dataIndex < dataLength) {
                        var el = data && data[dataIndex];
                        itemEl = _react2['default'].createElement(
                            _index2['default'].Item,
                            { key: 'griditem-' + dataIndex, className: prefixCls + '-item', onClick: function onClick() {
                                    return _onClick && _onClick(el, dataIndex);
                                }, style: colStyle },
                            _this.renderItem(el, dataIndex, columnNum, renderItem)
                        );
                    } else {
                        itemEl = _react2['default'].createElement(
                            _index2['default'].Item,
                            { key: 'griditem-' + dataIndex, className: prefixCls + '-item ' + prefixCls + '-null-item', style: colStyle },
                            _react2['default'].createElement(
                                'div',
                                { className: prefixCls + '-item-content' },
                                _react2['default'].createElement('div', { className: prefixCls + '-item-inner-content' })
                            )
                        );
                    }
                    rowArr.push(itemEl);
                };

                for (var j = 0; j < columnNum; j++) {
                    _loop(j);
                }
                rowsArr.push(_react2['default'].createElement(
                    _index2['default'],
                    { justify: 'center', align: 'stretch', key: 'gridline-' + i },
                    rowArr
                ));
            }
            return rowsArr;
        };
        return _this;
    }

    (0, _createClass3['default'])(Grid, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                initialSlideWidth: document.documentElement.clientWidth
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                data = _a.data,
                hasLine = _a.hasLine,
                isCarousel = _a.isCarousel,
                restProps = __rest(_a, ["prefixCls", "className", "data", "hasLine", "isCarousel"]);
            var columnNum = restProps.columnNum,
                carouselMaxRow = restProps.carouselMaxRow,
                onClick = restProps.onClick,
                renderItem = restProps.renderItem,
                restPropsForCarousel = __rest(restProps, ["columnNum", "carouselMaxRow", "onClick", "renderItem"]);

            var initialSlideWidth = this.state.initialSlideWidth;

            columnNum = columnNum;
            carouselMaxRow = carouselMaxRow;
            var dataLength = data && data.length || 0;
            var rowCount = void 0;
            var pageCount = 1;
            var rowsArr = void 0;
            var renderEl = void 0;
            if (isCarousel && initialSlideWidth > 0) {
                // carousel mode && not server render. because carousel dependes on document
                pageCount = Math.ceil(dataLength / (columnNum * carouselMaxRow));
                rowCount = pageCount * carouselMaxRow;
                rowsArr = this.getRows(rowCount, dataLength);
                var carouselProps = {};
                if (pageCount <= 1) {
                    carouselProps = {
                        dots: false,
                        dragging: false,
                        swiping: false
                    };
                }
                renderEl = _react2['default'].createElement(
                    _index4['default'],
                    (0, _extends3['default'])({ initialSlideWidth: initialSlideWidth }, restPropsForCarousel, carouselProps),
                    this.renderCarousel(rowsArr, pageCount, rowCount)
                );
            } else {
                rowCount = Math.ceil(dataLength / columnNum);
                rowsArr = this.getRows(rowCount, dataLength);
                renderEl = rowsArr;
            }
            return _react2['default'].createElement(
                'div',
                { className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-line', hasLine), (0, _defineProperty3['default'])(_classNames, className, className), _classNames)) },
                renderEl
            );
        }
    }]);
    return Grid;
}(_react2['default'].Component);

exports['default'] = Grid;

Grid.defaultProps = {
    data: [],
    hasLine: true,
    isCarousel: false,
    columnNum: 4,
    carouselMaxRow: 2,
    prefixCls: 'am-grid'
};
module.exports = exports['default'];

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./check-circle-o.svg": 1632,
	"./check-circle.svg": 1633,
	"./check.svg": 1634,
	"./cross-circle-o.svg": 1635,
	"./cross-circle.svg": 1636,
	"./cross.svg": 1637,
	"./down.svg": 1638,
	"./ellipsis-circle.svg": 1639,
	"./ellipsis.svg": 1640,
	"./exclamation-circle.svg": 1641,
	"./info-circle.svg": 1642,
	"./koubei-o.svg": 1643,
	"./koubei.svg": 1644,
	"./left.svg": 1645,
	"./loading.svg": 1646,
	"./question-circle.svg": 1647,
	"./right.svg": 1648,
	"./search.svg": 1649,
	"./up.svg": 1650
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 803;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(441);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(166);

var _index4 = _interopRequireDefault(_index3);

var _index5 = __webpack_require__(439);

var _index6 = _interopRequireDefault(_index5);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:no-bitwise */
var Item = _index4['default'].Item;
function noop() {}

var ImagePicker = function (_React$Component) {
    (0, _inherits3['default'])(ImagePicker, _React$Component);

    function ImagePicker() {
        (0, _classCallCheck3['default'])(this, ImagePicker);

        // http://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side
        var _this = (0, _possibleConstructorReturn3['default'])(this, (ImagePicker.__proto__ || Object.getPrototypeOf(ImagePicker)).apply(this, arguments));

        _this.getOrientation = function (file, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var view = new DataView(e.target.result);
                if (view.getUint16(0, false) !== 0xFFD8) {
                    return callback(-2);
                }
                var length = view.byteLength;
                var offset = 2;
                while (offset < length) {
                    var marker = view.getUint16(offset, false);
                    offset += 2;
                    if (marker === 0xFFE1) {
                        var tmp = view.getUint32(offset += 2, false);
                        if (tmp !== 0x45786966) {
                            return callback(-1);
                        }
                        var little = view.getUint16(offset += 6, false) === 0x4949;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;
                        for (var i = 0; i < tags; i++) {
                            if (view.getUint16(offset + i * 12, little) === 0x0112) {
                                return callback(view.getUint16(offset + i * 12 + 8, little));
                            }
                        }
                    } else if ((marker & 0xFF00) !== 0xFF00) {
                        break;
                    } else {
                        offset += view.getUint16(offset, false);
                    }
                }
                return callback(-1);
            };
            reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
        };
        _this.getRotation = function () {
            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var imgRotation = 0;
            switch (orientation) {
                case 3:
                    imgRotation = 180;
                    break;
                case 6:
                    imgRotation = 90;
                    break;
                case 8:
                    imgRotation = 270;
                    break;
                default:
            }
            return imgRotation;
        };
        _this.removeImage = function (index) {
            var newImages = [];
            var _this$props$files = _this.props.files,
                files = _this$props$files === undefined ? [] : _this$props$files;

            files.forEach(function (image, idx) {
                if (index !== idx) {
                    newImages.push(image);
                }
            });
            if (_this.props.onChange) {
                _this.props.onChange(newImages, 'remove', index);
            }
        };
        _this.addImage = function (imgItem) {
            var _this$props$files2 = _this.props.files,
                files = _this$props$files2 === undefined ? [] : _this$props$files2;

            var newImages = files.concat(imgItem);
            if (_this.props.onChange) {
                _this.props.onChange(newImages, 'add');
            }
        };
        _this.onImageClick = function (index) {
            if (_this.props.onImageClick) {
                _this.props.onImageClick(index, _this.props.files);
            }
        };
        _this.onFileChange = function () {
            var fileSelectorEl = _this.refs.fileSelectorInput;
            if (fileSelectorEl.files && fileSelectorEl.files.length) {
                var file = fileSelectorEl.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                    var dataURL = e.target.result;
                    if (!dataURL) {
                        _index6['default'].fail('图片获取失败');
                        return;
                    }
                    var orientation = 1;
                    _this.getOrientation(file, function (res) {
                        // -2: not jpeg , -1: not defined
                        if (res > 0) {
                            orientation = res;
                        }
                        _this.addImage({
                            url: dataURL,
                            orientation: orientation,
                            file: file
                        });
                        fileSelectorEl.value = '';
                    });
                };
                reader.readAsDataURL(file);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(ImagePicker, [{
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                style = _props.style,
                className = _props.className,
                _props$files = _props.files,
                files = _props$files === undefined ? [] : _props$files,
                selectable = _props.selectable,
                onAddImageClick = _props.onAddImageClick;

            var imgItemList = [];
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            files.forEach(function (image, index) {
                var imgStyle = {
                    backgroundImage: 'url(' + image.url + ')',
                    transform: 'rotate(' + _this2.getRotation(image.orientation) + 'deg)'
                };
                imgItemList.push(_react2['default'].createElement(
                    Item,
                    { key: 'item-' + index },
                    _react2['default'].createElement(
                        'div',
                        { key: index, className: prefixCls + '-item' },
                        _react2['default'].createElement('div', { className: prefixCls + '-item-remove', role: 'button', 'aria-label': 'Click and Remove this image', onClick: function onClick() {
                                _this2.removeImage(index);
                            } }),
                        _react2['default'].createElement('div', { className: prefixCls + '-item-content', role: 'button', 'aria-label': 'Image can be clicked', onClick: function onClick() {
                                _this2.onImageClick(index);
                            }, style: imgStyle })
                    )
                ));
            });
            var selectEl = _react2['default'].createElement(
                _rcTouchable2['default'],
                { activeClassName: prefixCls + '-upload-btn-active', key: 'select' },
                _react2['default'].createElement(
                    Item,
                    null,
                    _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-item ' + prefixCls + '-upload-btn', onClick: onAddImageClick, role: 'button', 'aria-label': 'Choose and add image' },
                        _react2['default'].createElement('input', { ref: 'fileSelectorInput', type: 'file', accept: 'image/jpg,image/jpeg,image/png,image/gif', onChange: function onChange() {
                                _this2.onFileChange();
                            } })
                    )
                )
            );
            var allEl = selectable ? imgItemList.concat([selectEl]) : imgItemList;
            var length = allEl.length;
            if (length !== 0 && length % 4 !== 0) {
                var blankCount = 4 - length % 4;
                var fillBlankEl = [];
                for (var i = 0; i < blankCount; i++) {
                    fillBlankEl.push(_react2['default'].createElement(Item, { key: 'blank-' + i }));
                }
                allEl = allEl.concat(fillBlankEl);
            }
            var flexEl = [];
            for (var _i = 0; _i < allEl.length / 4; _i++) {
                var rowEl = allEl.slice(_i * 4, _i * 4 + 4);
                flexEl.push(rowEl);
            }
            var renderEl = flexEl.map(function (item, index) {
                return _react2['default'].createElement(
                    _index4['default'],
                    { key: 'flex-' + index },
                    item
                );
            });
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-list', role: 'group' },
                    _react2['default'].createElement(
                        _index2['default'],
                        { size: 'md' },
                        renderEl
                    )
                )
            );
        }
    }]);
    return ImagePicker;
}(_react2['default'].Component);

exports['default'] = ImagePicker;

ImagePicker.defaultProps = {
    prefixCls: 'am-image-picker',
    files: [],
    onChange: noop,
    onImageClick: noop,
    onAddImageClick: noop,
    selectable: true
};
module.exports = exports['default'];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _CustomKeyboard = __webpack_require__(806);

var _CustomKeyboard2 = _interopRequireDefault(_CustomKeyboard);

var _class = __webpack_require__(785);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var NumberInput = function (_React$Component) {
    (0, _inherits3['default'])(NumberInput, _React$Component);

    function NumberInput(props) {
        (0, _classCallCheck3['default'])(this, NumberInput);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call(this, props));

        _this.getComponent = function () {
            var _this$props = _this.props,
                keyboardPrefixCls = _this$props.keyboardPrefixCls,
                confirmLabel = _this$props.confirmLabel;

            return _react2['default'].createElement(_CustomKeyboard2['default'], { onClick: _this.onKeyboardClick, preixCls: keyboardPrefixCls, confirmLabel: confirmLabel });
        };
        _this.renderCustomKeyboard = function () {
            var container = document.querySelector('#' + _this.props.keyboardPrefixCls + '-container');
            if (!container) {
                container = document.createElement('div');
                container.setAttribute('id', _this.props.keyboardPrefixCls + '-container');
                document.body.appendChild(container);
                window.antmCustomKeyboard = _reactDom2['default'].unstable_renderSubtreeIntoContainer(_this, _this.getComponent(), container);
            }
        };
        _this._blurEventListener = function (ev) {
            var value = _this.props.value;

            if (ev.target !== _this.refs['input-container']) {
                _this.onInputBlur(value);
            }
        };
        _this.unLinkInput = function () {
            var antmCustomKeyboard = window.antmCustomKeyboard;
            if (antmCustomKeyboard.linkedInput === _this) {
                antmCustomKeyboard.linkedInput = null;
                (0, _class.addClass)(antmCustomKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
            }
        };
        _this.onInputBlur = function (value) {
            var focused = _this.state.focused;

            if (focused) {
                _this.setState({
                    focused: false
                });
                _this.props.onBlur(value);
                setTimeout(function () {
                    _this.unLinkInput();
                }, 50);
            }
        };
        _this.onInputFocus = function (value) {
            _this.props.onFocus(value);
            _this.setState({
                focused: true
            }, function () {
                var antmCustomKeyboard = window.antmCustomKeyboard;
                antmCustomKeyboard.linkedInput = _this;
                (0, _class.removeClass)(antmCustomKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
                antmCustomKeyboard.confirmDisabled = value === '';
                if (value === '') {
                    (0, _class.addClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                } else {
                    (0, _class.removeClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                }
            });
        };
        _this.onKeyboardClick = function (KeyboardItemValue) {
            var _this$props2 = _this.props,
                value = _this$props2.value,
                onChange = _this$props2.onChange,
                maxLength = _this$props2.maxLength;

            var valueAfterChange = void 0;
            // 删除键
            if (KeyboardItemValue === 'delete') {
                valueAfterChange = value.substring(0, value.length - 1);
                onChange({ target: { value: valueAfterChange } });
                // 确认键
            } else if (KeyboardItemValue === 'confirm') {
                valueAfterChange = value;
                onChange({ target: { value: valueAfterChange } });
                _this.onInputBlur(value);
                // 收起键
            } else if (KeyboardItemValue === 'hide') {
                valueAfterChange = value;
                _this.onInputBlur(valueAfterChange);
            } else {
                if (maxLength !== undefined && +maxLength >= 0 && (value + KeyboardItemValue).length > maxLength) {
                    valueAfterChange = (value + KeyboardItemValue).substr(0, maxLength);
                    onChange({ target: { value: valueAfterChange } });
                } else {
                    valueAfterChange = value + KeyboardItemValue;
                    onChange({ target: { value: valueAfterChange } });
                }
            }
            var antmCustomKeyboard = window.antmCustomKeyboard;
            antmCustomKeyboard.confirmDisabled = valueAfterChange === '';
            if (valueAfterChange === '') {
                (0, _class.addClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
            } else {
                (0, _class.removeClass)(antmCustomKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
            }
        };
        _this.onFakeInputClick = function () {
            var value = _this.props.value;
            var focused = _this.state.focused;

            if (!focused) {
                _this.onInputFocus(value);
            }
        };
        _this.focus = function () {
            document.removeEventListener('click', _this._blurEventListener, false);
            _this.onFakeInputClick();
            setTimeout(function () {
                document.addEventListener('click', _this._blurEventListener, false);
            }, 50);
        };
        _this.state = {
            focused: props.focused || false
        };
        return _this;
    }

    (0, _createClass3['default'])(NumberInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if ('focused' in nextProps && nextProps.focused !== this.state.focused) {
                this.debounceFocusTimeout = setTimeout(function () {
                    var _props = _this2.props,
                        disabled = _props.disabled,
                        editable = _props.editable;

                    if (nextProps.focused && !disabled && editable) {
                        _this2.onInputFocus(_this2.props.value);
                    }
                }, 10);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!window.antmCustomKeyboard) {
                this.renderCustomKeyboard();
            }
            var _props2 = this.props,
                autoFocus = _props2.autoFocus,
                focused = _props2.focused,
                value = _props2.value,
                disabled = _props2.disabled,
                editable = _props2.editable;

            if ((autoFocus || focused) && !disabled && editable) {
                this.onInputFocus(value);
            }
            document.addEventListener('click', this._blurEventListener, false);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this._blurEventListener, false);
            if (this.debounceFocusTimeout) {
                clearTimeout(this.debounceFocusTimeout);
                this.debounceFocusTimeout = null;
            }
            this.unLinkInput();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props3 = this.props,
                placeholder = _props3.placeholder,
                value = _props3.value,
                disabled = _props3.disabled,
                editable = _props3.editable;
            var focused = this.state.focused;

            var preventKeyboard = disabled || !editable;
            var fakeInputCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, 'fake-input', true), (0, _defineProperty3['default'])(_classNames, 'focus', focused), (0, _defineProperty3['default'])(_classNames, 'fake-input-disabled', disabled), _classNames));
            return _react2['default'].createElement(
                'div',
                { className: 'fake-input-container' },
                value === '' && _react2['default'].createElement(
                    'div',
                    { className: 'fake-input-placeholder' },
                    placeholder
                ),
                _react2['default'].createElement(
                    'div',
                    { className: fakeInputCls, ref: 'input-container', onClick: preventKeyboard ? function () {} : this.onFakeInputClick },
                    value
                )
            );
        }
    }]);
    return NumberInput;
}(_react2['default'].Component); /* tslint:disable:jsx-no-multiline-js */


NumberInput.defaultProps = {
    onChange: function onChange() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    placeholder: '',
    value: '',
    disabled: false,
    editable: true,
    prefixCls: 'am-input',
    keyboardPrefixCls: 'am-number-keyboard'
};
exports['default'] = NumberInput;
module.exports = exports['default'];

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeyboardItem = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var KeyboardItem = exports.KeyboardItem = function (_React$Component) {
    (0, _inherits3['default'])(KeyboardItem, _React$Component);

    function KeyboardItem() {
        (0, _classCallCheck3['default'])(this, KeyboardItem);
        return (0, _possibleConstructorReturn3['default'])(this, (KeyboardItem.__proto__ || Object.getPrototypeOf(KeyboardItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(KeyboardItem, [{
        key: 'render',
        value: function render() {
            var _wrapCls;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                _onClick = _a.onClick,
                className = _a.className,
                disabled = _a.disabled,
                children = _a.children,
                tdRef = _a.tdRef,
                restProps = __rest(_a, ["prefixCls", "onClick", "className", "disabled", "children", "tdRef"]);
            var value = children;
            if (className === 'keyboard-delete') {
                value = 'delete';
            } else if (className === 'keyboard-hide') {
                value = 'hide';
            } else if (className === 'keyboard-confirm') {
                value = 'confirm';
            }
            var wrapCls = (_wrapCls = {}, (0, _defineProperty3['default'])(_wrapCls, className, className), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item', true), _wrapCls);
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { activeClassName: prefixCls + '-item-active' },
                _react2['default'].createElement(
                    'td',
                    (0, _extends3['default'])({ ref: tdRef, onClick: function onClick(e) {
                            _onClick(e, value);
                        }, className: (0, _classnames2['default'])(wrapCls) }, restProps),
                    children
                )
            );
        }
    }]);
    return KeyboardItem;
}(_react2['default'].Component);

KeyboardItem.defaultProps = {
    prefixCls: 'am-number-keyboard',
    onClick: function onClick() {},
    disabled: false
};

var CustomKeyboard = function (_React$Component2) {
    (0, _inherits3['default'])(CustomKeyboard, _React$Component2);

    function CustomKeyboard() {
        (0, _classCallCheck3['default'])(this, CustomKeyboard);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (CustomKeyboard.__proto__ || Object.getPrototypeOf(CustomKeyboard)).apply(this, arguments));

        _this2.onKeyboardClick = function (e, value) {
            e.nativeEvent.stopImmediatePropagation();
            if (value === 'confirm' && _this2.confirmDisabled) {
                return null;
            } else {
                if (_this2.linkedInput) {
                    _this2.linkedInput.onKeyboardClick(value);
                }
            }
        };
        _this2.renderKeyboardItem = function (item, index) {
            return _react2['default'].createElement(
                KeyboardItem,
                { onClick: _this2.onKeyboardClick, key: 'item-' + item + '-' + index },
                item
            );
        };
        return _this2;
    }

    (0, _createClass3['default'])(CustomKeyboard, [{
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                confirmLabel = _props.confirmLabel;

            var wrapperCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-hide', true), _classNames));
            return _react2['default'].createElement(
                'div',
                { className: wrapperCls, ref: function ref(el) {
                        return _this3.antmKeyboard = el;
                    } },
                _react2['default'].createElement(
                    'table',
                    null,
                    _react2['default'].createElement(
                        'tbody',
                        null,
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['1', '2', '3'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            }),
                            _react2['default'].createElement(KeyboardItem, { className: 'keyboard-delete', rowSpan: 2, onClick: this.onKeyboardClick })
                        ),
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['4', '5', '6'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            })
                        ),
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['7', '8', '9'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            }),
                            _react2['default'].createElement(
                                KeyboardItem,
                                { className: 'keyboard-confirm', rowSpan: 2, onClick: this.onKeyboardClick, tdRef: function tdRef(el) {
                                        return _this3.confirmKeyboardItem = el;
                                    } },
                                confirmLabel
                            )
                        ),
                        _react2['default'].createElement(
                            'tr',
                            null,
                            ['.', '0'].map(function (item, index) {
                                return _this3.renderKeyboardItem(item, index);
                            }),
                            _react2['default'].createElement(KeyboardItem, { className: 'keyboard-hide', onClick: this.onKeyboardClick })
                        )
                    )
                )
            );
        }
    }]);
    return CustomKeyboard;
}(_react2['default'].Component);

CustomKeyboard.defaultProps = {
    prefixCls: 'am-number-keyboard'
};
exports['default'] = CustomKeyboard;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Input = function (_React$Component) {
    (0, _inherits3['default'])(Input, _React$Component);

    function Input(props) {
        (0, _classCallCheck3['default'])(this, Input);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

        _this.onInputBlur = function (e) {
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: false
                });
            }
            var value = e.target.value;
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onInputFocus = function (e) {
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: true
                });
            }
            var value = e.target.value;
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.focus = function () {
            _this.refs.input.focus();
        };
        _this.state = {
            focused: props.focused || false
        };
        return _this;
    }

    (0, _createClass3['default'])(Input, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('focused' in nextProps) {
                this.setState({
                    focused: nextProps.focused
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if ((this.props.autoFocus || this.state.focused) && navigator.userAgent.indexOf('AlipayClient') > 0) {
                this.refs.input.focus();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.focused) {
                this.refs.input.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var otherProps = (0, _omit2['default'])(this.props, ['onBlur', 'onFocus', 'focused', 'autoFocus']);
            return _react2['default'].createElement('input', (0, _extends3['default'])({ ref: 'input', onBlur: this.onInputBlur, onFocus: this.onInputFocus }, otherProps));
        }
    }]);
    return Input;
}(_react2['default'].Component);

exports['default'] = Input;
module.exports = exports['default'];

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

var _Input = __webpack_require__(807);

var _Input2 = _interopRequireDefault(_Input);

var _CustomInput = __webpack_require__(805);

var _CustomInput2 = _interopRequireDefault(_CustomInput);

var _getLocale = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {} /* tslint:disable:jsx-no-multiline-js */

function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}

var InputItem = function (_React$Component) {
    (0, _inherits3['default'])(InputItem, _React$Component);

    function InputItem(props) {
        (0, _classCallCheck3['default'])(this, InputItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (InputItem.__proto__ || Object.getPrototypeOf(InputItem)).call(this, props));

        _this.onInputChange = function (e) {
            var value = e.target.value;
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                type = _this$props.type;

            switch (type) {
                case 'text':
                    break;
                case 'bankCard':
                    value = value.replace(/\D/g, '').replace(/(....)(?=.)/g, '$1 ');
                    break;
                case 'phone':
                    value = value.replace(/\D/g, '').substring(0, 11);
                    var valueLen = value.length;
                    if (valueLen > 3 && valueLen < 8) {
                        value = value.substr(0, 3) + ' ' + value.substr(3);
                    } else if (valueLen >= 8) {
                        value = value.substr(0, 3) + ' ' + value.substr(3, 4) + ' ' + value.substr(7);
                    }
                    break;
                case 'number':
                    value = value.replace(/\D/g, '');
                    break;
                case 'password':
                    break;
                default:
                    break;
            }
            if (onChange) {
                onChange(value);
            }
        };
        _this.onInputFocus = function (value) {
            if (_this.debounceTimeout) {
                clearTimeout(_this.debounceTimeout);
                _this.debounceTimeout = null;
            }
            _this.setState({
                focus: true
            });
            if (document.activeElement.tagName.toLowerCase() === 'input') {
                _this.scrollIntoViewTimeout = setTimeout(function () {
                    try {
                        document.activeElement.scrollIntoViewIfNeeded();
                    } catch (e) {}
                }, 100);
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.onInputBlur = function (value) {
            _this.debounceTimeout = setTimeout(function () {
                if (document.activeElement !== _this.refs.input.refs.input) {
                    _this.setState({
                        focus: false
                    });
                }
            }, 200);
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onExtraClick = function (e) {
            if (_this.props.onExtraClick) {
                _this.props.onExtraClick(e);
            }
        };
        _this.onErrorClick = function (e) {
            if (_this.props.onErrorClick) {
                _this.props.onErrorClick(e);
            }
        };
        _this.clearInput = function () {
            if (_this.props.type !== 'password' && _this.props.updatePlaceholder) {
                _this.setState({
                    placeholder: _this.props.value
                });
            }
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            _this.focus();
        };
        _this.focus = function () {
            _this.refs.input.focus();
        };
        _this.state = {
            placeholder: props.placeholder
        };
        return _this;
    }

    (0, _createClass3['default'])(InputItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('placeholder' in nextProps && !nextProps.updatePlaceholder) {
                this.setState({
                    placeholder: nextProps.placeholder
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            if (this.scrollIntoViewTimeout) {
                clearTimeout(this.scrollIntoViewTimeout);
                this.scrollIntoViewTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                prefixListCls = _props.prefixListCls,
                type = _props.type,
                value = _props.value,
                defaultValue = _props.defaultValue,
                name = _props.name,
                editable = _props.editable,
                disabled = _props.disabled,
                style = _props.style,
                clear = _props.clear,
                children = _props.children,
                error = _props.error,
                className = _props.className,
                extra = _props.extra,
                labelNumber = _props.labelNumber,
                maxLength = _props.maxLength;
            // note: remove `placeholderTextColor` prop for rn TextInput supports placeholderTextColor

            var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'prefixListCls', 'editable', 'style', 'clear', 'children', 'error', 'className', 'extra', 'labelNumber', 'onExtraClick', 'onErrorClick', 'updatePlaceholder', 'placeholderTextColor', 'type', 'locale']);
            var locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'InputItem', function () {
                return __webpack_require__(809);
            });
            var confirmLabel = locale.confirmLabel;
            var _state = this.state,
                placeholder = _state.placeholder,
                focus = _state.focus;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixListCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-error', error), (0, _defineProperty3['default'])(_classNames, prefixCls + '-focus', focus), (0, _defineProperty3['default'])(_classNames, prefixCls + '-android', focus), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            var labelCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-2', labelNumber === 2), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-3', labelNumber === 3), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-4', labelNumber === 4), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-5', labelNumber === 5), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-6', labelNumber === 6), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-7', labelNumber === 7), _classNames2));
            var controlCls = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-control', true));
            var inputType = 'text';
            if (type === 'bankCard' || type === 'phone') {
                inputType = 'tel';
            } else if (type === 'password') {
                inputType = 'password';
            } else if (type === 'digit') {
                inputType = 'number';
            } else if (type !== 'text' && type !== 'number') {
                inputType = type;
            }
            var valueProps = void 0;
            if ('value' in this.props) {
                valueProps = {
                    value: fixControlledValue(value)
                };
            } else {
                valueProps = {
                    defaultValue: defaultValue
                };
            }
            var patternProps = void 0;
            if (type === 'number') {
                patternProps = {
                    pattern: '[0-9]*'
                };
            }
            var classNameProps = void 0;
            if (type === 'digit') {
                classNameProps = {
                    className: 'h5numInput'
                };
            }
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style },
                children ? _react2['default'].createElement(
                    'div',
                    { className: labelCls },
                    children
                ) : null,
                _react2['default'].createElement(
                    'div',
                    { className: controlCls },
                    type === 'money' ? _react2['default'].createElement(_CustomInput2['default'], (0, _extends3['default'])({ type: type, ref: 'input', maxLength: maxLength, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, disabled: disabled, editable: editable, value: fixControlledValue(value) }, this.props.focused !== undefined ? { focused: this.props.focused } : {}, this.props.autoFocus !== undefined ? { autoFocus: this.props.autoFocus } : {}, { prefixCls: prefixCls, confirmLabel: confirmLabel })) : _react2['default'].createElement(_Input2['default'], (0, _extends3['default'])({}, patternProps, otherProps, valueProps, classNameProps, { ref: 'input', type: inputType, maxLength: maxLength, name: name, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, readOnly: !editable, disabled: disabled }))
                ),
                clear && editable && !disabled && value && value.length > 0 ? _react2['default'].createElement('div', { className: prefixCls + '-clear', onClick: this.clearInput }) : null,
                error ? _react2['default'].createElement('div', { className: prefixCls + '-error-extra', onClick: this.onErrorClick }) : null,
                extra !== '' ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-extra', onClick: this.onExtraClick },
                    extra
                ) : null
            );
        }
    }]);
    return InputItem;
}(_react2['default'].Component);

InputItem.defaultProps = {
    prefixCls: 'am-input',
    prefixListCls: 'am-list',
    type: 'text',
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    extra: '',
    onExtraClick: noop,
    error: false,
    onErrorClick: noop,
    labelNumber: 5,
    updatePlaceholder: false
};
InputItem.contextTypes = {
    antLocale: _propTypes2['default'].object
};
exports['default'] = InputItem;
module.exports = exports['default'];

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    confirmLabel: '确定'
};
module.exports = exports['default'];

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rmcListView = __webpack_require__(365);

var _rmcListView2 = _interopRequireDefault(_rmcListView);

var _handleProps2 = __webpack_require__(438);

var _handleProps3 = _interopRequireDefault(_handleProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var IndexedList = _rmcListView2['default'].IndexedList;

var MIndexedList = function (_React$Component) {
    (0, _inherits3['default'])(MIndexedList, _React$Component);

    function MIndexedList() {
        (0, _classCallCheck3['default'])(this, MIndexedList);
        return (0, _possibleConstructorReturn3['default'])(this, (MIndexedList.__proto__ || Object.getPrototypeOf(MIndexedList)).apply(this, arguments));
    }

    (0, _createClass3['default'])(MIndexedList, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                listPrefixCls = _props.listPrefixCls;

            var _handleProps = (0, _handleProps3['default'])(this.props, true),
                restProps = _handleProps.restProps,
                extraProps = _handleProps.extraProps;

            return _react2['default'].createElement(
                IndexedList,
                (0, _extends3['default'])({ ref: 'indexedList', sectionHeaderClassName: prefixCls + '-section-header ' + listPrefixCls + '-body', sectionBodyClassName: prefixCls + '-section-body ' + listPrefixCls + '-body' }, restProps, extraProps),
                this.props.children
            );
        }
    }]);
    return MIndexedList;
}(_react2['default'].Component);

exports['default'] = MIndexedList;

MIndexedList.defaultProps = {
    prefixCls: 'am-indexed-list',
    listPrefixCls: 'am-list',
    listViewPrefixCls: 'am-list-view'
};
module.exports = exports['default'];

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rmcListView = __webpack_require__(365);

var _rmcListView2 = _interopRequireDefault(_rmcListView);

var _handleProps2 = __webpack_require__(438);

var _handleProps3 = _interopRequireDefault(_handleProps2);

var _Indexed = __webpack_require__(810);

var _Indexed2 = _interopRequireDefault(_Indexed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ListView = function (_React$Component) {
    (0, _inherits3['default'])(ListView, _React$Component);

    function ListView() {
        (0, _classCallCheck3['default'])(this, ListView);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (ListView.__proto__ || Object.getPrototypeOf(ListView)).apply(this, arguments));

        _this.scrollTo = function () {
            var _this$refs$listview;

            return (_this$refs$listview = _this.refs.listview).scrollTo.apply(_this$refs$listview, arguments);
        };
        _this.getInnerViewNode = function () {
            return _this.refs.listview.getInnerViewNode();
        };
        return _this;
    }

    (0, _createClass3['default'])(ListView, [{
        key: 'render',
        value: function render() {
            var _handleProps = (0, _handleProps3['default'])(this.props, false),
                restProps = _handleProps.restProps,
                extraProps = _handleProps.extraProps;

            var _props = this.props,
                useZscroller = _props.useZscroller,
                refreshControl = _props.refreshControl;

            if (refreshControl) {
                useZscroller = true;
            }
            return _react2['default'].createElement(_rmcListView2['default'], (0, _extends3['default'])({ ref: 'listview' }, restProps, extraProps, { useZscroller: useZscroller }));
        }
    }]);
    return ListView;
}(_react2['default'].Component);

exports['default'] = ListView;

ListView.defaultProps = {
    prefixCls: 'am-list-view',
    listPrefixCls: 'am-list'
};
ListView.DataSource = _rmcListView2['default'].DataSource;
ListView.IndexedList = _Indexed2['default'];
module.exports = exports['default'];

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Brief = undefined;

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var Brief = exports.Brief = function (_React$Component) {
    (0, _inherits3['default'])(Brief, _React$Component);

    function Brief() {
        (0, _classCallCheck3['default'])(this, Brief);
        return (0, _possibleConstructorReturn3['default'])(this, (Brief.__proto__ || Object.getPrototypeOf(Brief)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Brief, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'am-list-brief', style: this.props.style },
                this.props.children
            );
        }
    }]);
    return Brief;
}(_react2['default'].Component);

var ListItem = function (_React$Component2) {
    (0, _inherits3['default'])(ListItem, _React$Component2);

    function ListItem(props) {
        (0, _classCallCheck3['default'])(this, ListItem);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

        _this2.onClick = function (ev) {
            var _this2$props = _this2.props,
                onClick = _this2$props.onClick,
                platform = _this2$props.platform;

            var isAndroid = platform === 'android' || platform === 'cross' && !!navigator.userAgent.match(/Android/i);
            if (!!onClick && isAndroid) {
                if (_this2.debounceTimeout) {
                    clearTimeout(_this2.debounceTimeout);
                    _this2.debounceTimeout = null;
                }
                var Item = ev.currentTarget;
                var RippleWidth = Math.max(Item.offsetHeight, Item.offsetWidth);
                var ClientRect = ev.currentTarget.getBoundingClientRect();
                var pointX = ev.clientX - ClientRect.left - Item.offsetWidth / 2;
                var pointY = ev.clientY - ClientRect.top - Item.offsetWidth / 2;
                var coverRippleStyle = {
                    width: RippleWidth + 'px',
                    height: RippleWidth + 'px',
                    left: pointX + 'px',
                    top: pointY + 'px'
                };
                _this2.setState({
                    coverRippleStyle: coverRippleStyle,
                    RippleClicked: true
                }, function () {
                    _this2.debounceTimeout = setTimeout(function () {
                        _this2.setState({
                            coverRippleStyle: { display: 'none' },
                            RippleClicked: false
                        });
                    }, 1000);
                });
            }
            if (onClick) {
                onClick(ev);
            }
        };
        _this2.state = {
            coverRippleStyle: { display: 'none' },
            RippleClicked: false
        };
        return _this2;
    }

    (0, _createClass3['default'])(ListItem, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _wrapCls,
                _classNames,
                _classNames2,
                _classNames3,
                _this3 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                activeStyle = _a.activeStyle,
                error = _a.error,
                align = _a.align,
                wrap = _a.wrap,
                disabled = _a.disabled,
                children = _a.children,
                multipleLine = _a.multipleLine,
                thumb = _a.thumb,
                extra = _a.extra,
                arrow = _a.arrow,
                onClick = _a.onClick,
                onLongPress = _a.onLongPress,
                restProps = __rest(_a, ["prefixCls", "className", "activeStyle", "error", "align", "wrap", "disabled", "children", "multipleLine", "thumb", "extra", "arrow", "onClick", "onLongPress"]);var _state = this.state,
                coverRippleStyle = _state.coverRippleStyle,
                RippleClicked = _state.RippleClicked;

            var wrapCls = (_wrapCls = {}, (0, _defineProperty3['default'])(_wrapCls, className, className), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item', true), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-disabled', disabled), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-error', error), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-top', align === 'top'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-middle', align === 'middle'), (0, _defineProperty3['default'])(_wrapCls, prefixCls + '-item-bottom', align === 'bottom'), _wrapCls);
            var rippleCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-ripple', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-ripple-animate', RippleClicked), _classNames));
            var lineCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-line', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-line-multiple', multipleLine), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-line-wrap', wrap), _classNames2));
            var arrowCls = (0, _classnames2['default'])((_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow', true), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow-horizontal', arrow === 'horizontal'), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow-vertical', arrow === 'down' || arrow === 'up'), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-arrow-vertical-up', arrow === 'up'), _classNames3));
            var content = _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, (0, _omit2['default'])(restProps, ['platform']), { onClick: function onClick(ev) {
                        _this3.onClick(ev);
                    }, className: (0, _classnames2['default'])(wrapCls) }),
                thumb ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-thumb' },
                    typeof thumb === 'string' ? _react2['default'].createElement('img', { src: thumb }) : thumb
                ) : null,
                _react2['default'].createElement(
                    'div',
                    { className: lineCls },
                    children !== undefined && _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-content' },
                        children
                    ),
                    extra !== undefined && _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-extra' },
                        extra
                    ),
                    arrow && _react2['default'].createElement('div', { className: arrowCls, 'aria-hidden': 'true' })
                ),
                _react2['default'].createElement('div', { style: coverRippleStyle, className: rippleCls })
            );
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { disabled: disabled || !onClick && !onLongPress, activeStyle: activeStyle, activeClassName: prefixCls + '-item-active', onLongPress: onLongPress },
                content
            );
        }
    }]);
    return ListItem;
}(_react2['default'].Component);

ListItem.defaultProps = {
    prefixCls: 'am-list',
    align: 'middle',
    error: false,
    multipleLine: false,
    wrap: false,
    platform: 'cross'
};
ListItem.Brief = Brief;
exports['default'] = ListItem;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LocaleProvider = function (_React$Component) {
    (0, _inherits3['default'])(LocaleProvider, _React$Component);

    function LocaleProvider() {
        (0, _classCallCheck3['default'])(this, LocaleProvider);
        return (0, _possibleConstructorReturn3['default'])(this, (LocaleProvider.__proto__ || Object.getPrototypeOf(LocaleProvider)).apply(this, arguments));
    }

    (0, _createClass3['default'])(LocaleProvider, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                antLocale: (0, _extends3['default'])({}, this.props.locale, { exist: true })
            };
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2['default'].Children.only(this.props.children);
        }
    }]);
    return LocaleProvider;
}(_react2['default'].Component);

exports['default'] = LocaleProvider;

LocaleProvider.propTypes = {
    locale: _propTypes2['default'].object
};
LocaleProvider.childContextTypes = {
    antLocale: _propTypes2['default'].object
};
module.exports = exports['default'];

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports['default'] = SubMenu;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(130);

var _index2 = _interopRequireDefault(_index);

var _Radio = __webpack_require__(278);

var _Radio2 = _interopRequireDefault(_Radio);

var _index3 = __webpack_require__(437);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function SubMenu(props) {
    var onClick = function onClick(dataItem) {
        if (props.onSel) {
            props.onSel(dataItem);
        }
    };
    var subMenuPrefixCls = props.subMenuPrefixCls,
        radioPrefixCls = props.radioPrefixCls,
        subMenuData = props.subMenuData,
        showSelect = props.showSelect,
        selItem = props.selItem,
        multiSelect = props.multiSelect;

    var selected = function selected(dataItem) {
        return showSelect && selItem.length > 0 && selItem.indexOf(dataItem.value) !== -1;
    };
    return _react2['default'].createElement(
        _index2['default'],
        { style: { paddingTop: 0 }, className: subMenuPrefixCls },
        subMenuData.map(function (dataItem, idx) {
            var _classNames;

            return _react2['default'].createElement(
                _index2['default'].Item,
                { className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, radioPrefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, subMenuPrefixCls + '-item-selected', selected(dataItem)), (0, _defineProperty3['default'])(_classNames, subMenuPrefixCls + '-item-disabled', dataItem.disabled), _classNames)), key: idx, extra: !multiSelect ? _react2['default'].createElement(_Radio2['default'], { checked: selected(dataItem), disabled: dataItem.disabled, onChange: function onChange() {
                            return onClick(dataItem);
                        } }) : _react2['default'].createElement(_index4['default'], { checked: selected(dataItem), disabled: dataItem.disabled, onChange: function onChange() {
                            return onClick(dataItem);
                        } }) },
                dataItem.label
            );
        })
    );
} /* tslint:disable:jsx-no-multiline-js */
module.exports = exports['default'];

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(861);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(130);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(166);

var _index4 = _interopRequireDefault(_index3);

var _SubMenu = __webpack_require__(814);

var _SubMenu2 = _interopRequireDefault(_SubMenu);

var _index5 = __webpack_require__(199);

var _index6 = _interopRequireDefault(_index5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
var Menu = function (_React$Component) {
    (0, _inherits3['default'])(Menu, _React$Component);

    function Menu(props) {
        (0, _classCallCheck3['default'])(this, Menu);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));

        _this.onMenuOk = function () {
            var onOk = _this.props.onOk;

            if (onOk) {
                onOk(_this.state.value);
            }
        };
        _this.onMenuCancel = function () {
            var onCancel = _this.props.onCancel;

            if (onCancel) {
                onCancel();
            }
        };
        _this.onClickFirstLevelItem = function (dataItem) {
            var onChange = _this.props.onChange;

            _this.setState({
                firstLevelSelectValue: dataItem.value
            });
            if (dataItem.isLeaf && onChange) {
                onChange([dataItem.value]);
            }
        };
        _this.getSelectValue = function (dataItem) {
            var _this$props = _this.props,
                level = _this$props.level,
                multiSelect = _this$props.multiSelect;

            if (multiSelect) {
                var _this$state = _this.state,
                    value = _this$state.value,
                    firstLevelSelectValue = _this$state.firstLevelSelectValue;

                if (value && value.length > 0) {
                    if (level === 2 && value[0] !== firstLevelSelectValue) {
                        /* if level is 2, when first level is reselect, reset submenu array */
                        return [firstLevelSelectValue, [dataItem.value]];
                    } else {
                        /* if level is 1, or first level isn't changed when level is 2, just do add or delete for submenu array  */
                        var chosenValues = level === 2 ? value[1] : value;
                        var existIndex = chosenValues.indexOf(dataItem.value);
                        if (existIndex === -1) {
                            chosenValues.push(dataItem.value);
                        } else {
                            chosenValues.splice(existIndex, 1);
                        }
                        return value;
                    }
                } else {
                    /* if value is not exist before, init value */
                    return level === 2 ? [firstLevelSelectValue, [dataItem.value]] : [dataItem.value];
                }
            }
            return level === 2 ? [_this.state.firstLevelSelectValue, dataItem.value] : [dataItem.value];
        };
        _this.onClickSubMenuItem = function (dataItem) {
            var onChange = _this.props.onChange;

            var value = _this.getSelectValue(dataItem);
            _this.setState({ value: value });
            setTimeout(function () {
                // if onChange will close the menu, set a little time to show its selection state.
                if (onChange) {
                    onChange(value);
                }
            }, 300);
        };
        _this.state = {
            firstLevelSelectValue: _this.getNewFsv(props),
            value: props.value
        };
        return _this;
    }

    (0, _createClass3['default'])(Menu, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) {
                this.setState({
                    firstLevelSelectValue: this.getNewFsv(nextProps),
                    value: nextProps.value
                });
            }
        }
    }, {
        key: 'getNewFsv',
        value: function getNewFsv(props) {
            var value = props.value,
                data = props.data;

            var firstValue = '';
            if (value && value.length) {
                firstValue = value[0];
            } else if (!data[0].isLeaf) {
                firstValue = data[0].value;
            }
            return firstValue;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                className = _props.className,
                height = _props.height,
                _props$data = _props.data,
                data = _props$data === undefined ? [] : _props$data,
                prefixCls = _props.prefixCls,
                level = _props.level,
                multiSelect = _props.multiSelect,
                multiSelectMenuBtnsCls = _props.multiSelectMenuBtnsCls,
                MenuSelectContanerPrefixCls = _props.MenuSelectContanerPrefixCls;
            var _state = this.state,
                firstLevelSelectValue = _state.firstLevelSelectValue,
                value = _state.value;

            var subMenuData = data; // menu only has one level as init
            if (level === 2) {
                var parent = data;
                if (firstLevelSelectValue && firstLevelSelectValue !== '') {
                    parent = data.filter(function (dataItem) {
                        return dataItem.value === firstLevelSelectValue;
                    });
                }
                if (parent[0] && parent[0].children && parent[0].isLeaf !== true) {
                    subMenuData = parent[0].children;
                } else {
                    subMenuData = [];
                }
            }
            var subValue = value && value.length > 0 && [].concat((0, _toConsumableArray3['default'])(value)) || [];
            if (level === 2 && subValue.length > 1) {
                subValue.shift();
                if (multiSelect) {
                    /* example: [[1,2,3]] -> [1,2,3] */
                    subValue = subValue[0];
                }
            }
            var parentValue = value && value.length > 1 && level === 2 ? value[0] : null;
            var subSelInitItem = subMenuData.filter(function (dataItem) {
                return subValue.indexOf(dataItem.value) !== -1;
            }).map(function (item) {
                return item.value;
            });
            var showSelect = true;
            if (level === 2 && parentValue !== firstLevelSelectValue) {
                showSelect = false;
            }
            var menuHeight = Math.round(height || document.documentElement.clientHeight / 2);
            return _react2['default'].createElement(
                _index4['default'],
                { className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames)), style: {
                        height: menuHeight + 'px'
                    }, direction: 'column', align: 'stretch' },
                _react2['default'].createElement(
                    _index4['default'],
                    { align: 'top', className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, MenuSelectContanerPrefixCls, true)) },
                    level === 2 && _react2['default'].createElement(
                        _index4['default'].Item,
                        null,
                        _react2['default'].createElement(
                            _index2['default'],
                            { role: 'tablist' },
                            data.map(function (dataItem, index) {
                                return _react2['default'].createElement(
                                    _index2['default'].Item,
                                    { className: dataItem.value === firstLevelSelectValue ? prefixCls + '-selected' : '', onClick: function onClick() {
                                            return _this2.onClickFirstLevelItem(dataItem);
                                        }, key: 'listitem-1-' + index, role: 'tab', 'aria-selected': dataItem.value === firstLevelSelectValue },
                                    dataItem.label
                                );
                            })
                        )
                    ),
                    _react2['default'].createElement(
                        _index4['default'].Item,
                        { role: 'tabpanel', 'aria-hidden': 'false', className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, MenuSelectContanerPrefixCls + '-submenu', true)) },
                        _react2['default'].createElement(_SubMenu2['default'], { subMenuPrefixCls: this.props.subMenuPrefixCls, radioPrefixCls: this.props.radioPrefixCls, subMenuData: subMenuData, selItem: subSelInitItem, onSel: this.onClickSubMenuItem, showSelect: showSelect, multiSelect: multiSelect })
                    )
                ),
                multiSelect && _react2['default'].createElement(
                    'div',
                    { className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, multiSelectMenuBtnsCls, true)) },
                    _react2['default'].createElement(
                        _index6['default'],
                        { inline: true, className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, multiSelectMenuBtnsCls + '-btn', true)), onClick: this.onMenuCancel },
                        '\u53D6\u6D88'
                    ),
                    _react2['default'].createElement(
                        _index6['default'],
                        { inline: true, type: 'primary', className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, multiSelectMenuBtnsCls + '-btn', true)), onClick: this.onMenuOk },
                        '\u786E\u5B9A'
                    )
                )
            );
        }
    }]);
    return Menu;
}(_react2['default'].Component);

exports['default'] = Menu;

Menu.defaultProps = {
    prefixCls: 'am-menu',
    subMenuPrefixCls: 'am-sub-menu',
    radioPrefixCls: 'am-radio',
    multiSelectMenuBtnsCls: 'am-multi-select-btns',
    MenuSelectContanerPrefixCls: 'am-menu-select-container',
    data: [],
    level: 2,
    onChange: function onChange() {},
    onOk: function onOk() {},
    onCancel: function onCancel() {},
    multiSelect: false
};
module.exports = exports['default'];

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalComponent = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ModalComponent = exports.ModalComponent = function (_React$Component) {
  (0, _inherits3['default'])(ModalComponent, _React$Component);

  function ModalComponent() {
    (0, _classCallCheck3['default'])(this, ModalComponent);
    return (0, _possibleConstructorReturn3['default'])(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).apply(this, arguments));
  }

  return ModalComponent;
}(_react2['default'].Component);

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = a;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Modal = __webpack_require__(200);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function a() {
    var title = arguments.length <= 0 ? undefined : arguments[0];
    var content = arguments.length <= 1 ? undefined : arguments[1];
    var actions = (arguments.length <= 2 ? undefined : arguments[2]) || [{ text: '确定' }];
    if (!title && !content) {
        // console.log('Must specify either an alert title, or message, or both');
        return {
            close: function close() {}
        };
    }
    var prefixCls = 'am-modal';
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        _reactDom2['default'].unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    close();
                });
            } else {
                close();
            }
        };
        return button;
    });
    _reactDom2['default'].render(_react2['default'].createElement(
        _Modal2['default'],
        { visible: true, transparent: true, prefixCls: prefixCls, title: title, transitionName: 'am-zoom', closable: false, maskClosable: false, footer: footer, maskTransitionName: 'am-fade' },
        _react2['default'].createElement(
            'div',
            { style: { zoom: 1, overflow: 'hidden' } },
            content
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(200);

var _Modal2 = _interopRequireDefault(_Modal);

var _alert = __webpack_require__(817);

var _alert2 = _interopRequireDefault(_alert);

var _prompt = __webpack_require__(820);

var _prompt2 = _interopRequireDefault(_prompt);

var _operation = __webpack_require__(819);

var _operation2 = _interopRequireDefault(_operation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Modal2['default'].alert = _alert2['default'];
_Modal2['default'].prompt = _prompt2['default'];
_Modal2['default'].operation = _operation2['default'];
exports['default'] = _Modal2['default'];
module.exports = exports['default'];

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = a;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Modal = __webpack_require__(200);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:enable:no-unused-variable */
function a() {
    var actions = (arguments.length <= 0 ? undefined : arguments[0]) || [{ text: '确定' }];
    var prefixCls = 'am-modal';
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        _reactDom2['default'].unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    close();
                });
            } else {
                close();
            }
        };
        return button;
    });
    _reactDom2['default'].render(_react2['default'].createElement(_Modal2['default'], { visible: true, operation: true, transparent: true, prefixCls: prefixCls, transitionName: 'am-zoom', closable: false, maskClosable: true, onClose: close, footer: footer, maskTransitionName: 'am-fade', className: 'am-modal-operation' }), div);
    return {
        close: close
    };
} /* tslint:disable:no-unused-variable */
module.exports = exports['default'];

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = prompt;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Modal = __webpack_require__(200);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function prompt(title, message, callbackOrActions) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var placeholders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ['', ''];

    if (!callbackOrActions) {
        // console.log('Must specify callbackOrActions');
        return {
            close: function close() {}
        };
    }
    var prefixCls = 'am-modal';
    var data = {};
    function onChange(e) {
        var target = e.target;
        var inputType = target.getAttribute('type');
        data[inputType] = target.value;
    }
    var inputDom = void 0;
    var focusFn = function focusFn(input) {
        setTimeout(function () {
            if (input) {
                input.focus();
            }
        }, 500);
    };
    switch (type) {
        case 'login-password':
            inputDom = _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'text', defaultValue: defaultValue, ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'password', defaultValue: '', onChange: onChange, placeholder: placeholders[1] })
                    )
                )
            );
            break;
        case 'secure-text':
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input' },
                _react2['default'].createElement(
                    'label',
                    null,
                    _react2['default'].createElement('input', { type: 'password', defaultValue: '', ref: function ref(input) {
                            return focusFn(input);
                        }, onChange: onChange, placeholder: placeholders[0] })
                )
            );
            break;
        case 'plain-text':
        case 'default':
        default:
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input' },
                _react2['default'].createElement(
                    'label',
                    null,
                    _react2['default'].createElement('input', { type: 'text', defaultValue: defaultValue, ref: function ref(input) {
                            return focusFn(input);
                        }, onChange: onChange, placeholder: placeholders[0] })
                )
            );
            break;
    }
    var content = _react2['default'].createElement(
        'div',
        null,
        message,
        inputDom
    );
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        _reactDom2['default'].unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    function getArgs(func) {
        var text = data.text || '';
        var password = data.password || '';
        if (type === 'login-password') {
            return func(text, password);
        } else if (type === 'secure-text') {
            return func(password);
        }
        return func(text);
    }
    var actions = void 0;
    if (typeof callbackOrActions === 'function') {
        actions = [{ text: '取消' }, { text: '确定', onPress: function onPress() {
                getArgs(callbackOrActions);
            } }];
    } else {
        actions = callbackOrActions.map(function (item) {
            return {
                text: item.text,
                onPress: function onPress() {
                    if (item.onPress) {
                        return getArgs(item.onPress);
                    }
                }
            };
        });
    }
    var footer = actions.map(function (button) {
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    close();
                });
            } else {
                close();
            }
        };
        return button;
    });
    _reactDom2['default'].render(_react2['default'].createElement(
        _Modal2['default'],
        { visible: true, transparent: true, prefixCls: prefixCls, title: title, closable: false, maskClosable: false, transitionName: 'am-zoom', footer: footer, maskTransitionName: 'am-fade' },
        _react2['default'].createElement(
            'div',
            { style: { zoom: 1, overflow: 'hidden' } },
            content
        )
    ), div);
    return {
        close: close
    };
} /* tslint:disable:no-switch-case-fall-through */
module.exports = exports['default'];

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var NavBar = function (_React$Component) {
    (0, _inherits3['default'])(NavBar, _React$Component);

    function NavBar() {
        (0, _classCallCheck3['default'])(this, NavBar);
        return (0, _possibleConstructorReturn3['default'])(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).apply(this, arguments));
    }

    (0, _createClass3['default'])(NavBar, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                mode = _a.mode,
                iconName = _a.iconName,
                leftContent = _a.leftContent,
                rightContent = _a.rightContent,
                onLeftClick = _a.onLeftClick,
                restProps = __rest(_a, ["prefixCls", "className", "children", "mode", "iconName", "leftContent", "rightContent", "onLeftClick"]);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, className), (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + mode, true), _classNames));
            return _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, restProps, { className: wrapCls }),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-left', role: 'button', onClick: onLeftClick },
                    iconName && _react2['default'].createElement(
                        'span',
                        { className: prefixCls + '-left-icon', 'aria-hidden': 'true' },
                        _react2['default'].createElement(_index2['default'], { type: iconName })
                    ),
                    _react2['default'].createElement(
                        'span',
                        { className: prefixCls + '-left-content' },
                        leftContent
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-title' },
                    children
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-right' },
                    rightContent
                )
            );
        }
    }]);
    return NavBar;
}(_react2['default'].Component);

exports['default'] = NavBar;

NavBar.defaultProps = {
    prefixCls: 'am-navbar',
    mode: 'dark',
    iconName: 'left',
    onLeftClick: function onLeftClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Marquee = (0, _createReactClass2['default'])({
    displayName: 'Marquee',
    getDefaultProps: function getDefaultProps() {
        return {
            text: '',
            loop: false,
            leading: 500,
            trailing: 800,
            fps: 40,
            className: ''
        };
    },
    getInitialState: function getInitialState() {
        return {
            animatedWidth: 0,
            overflowWidth: 0
        };
    },
    componentDidMount: function componentDidMount() {
        this._measureText();
        this._startAnimation();
    },
    componentDidUpdate: function componentDidUpdate() {
        this._measureText();
        if (!this._marqueeTimer) {
            this._startAnimation();
        }
    },
    componentWillUnmount: function componentWillUnmount() {
        clearTimeout(this._marqueeTimer);
    },
    render: function render() {
        var _props = this.props,
            prefixCls = _props.prefixCls,
            className = _props.className,
            text = _props.text;

        var style = (0, _extends3['default'])({ position: 'relative', right: this.state.animatedWidth, whiteSpace: 'nowrap', display: 'inline-block' }, this.props.style);
        return _react2['default'].createElement(
            'div',
            { className: prefixCls + '-marquee-wrap ' + className, style: { overflow: 'hidden' }, role: 'marquee' },
            _react2['default'].createElement(
                'div',
                { ref: 'text', className: prefixCls + '-marquee', style: style },
                text,
                ' '
            )
        );
    },
    _startAnimation: function _startAnimation() {
        var _this = this;

        clearTimeout(this._marqueeTimer);
        var TIMEOUT = 1 / this.props.fps * 1000;
        var isLeading = this.state.animatedWidth === 0;
        var timeout = isLeading ? this.props.leading : TIMEOUT;
        var animate = function animate() {
            var overflowWidth = _this.state.overflowWidth;

            var animatedWidth = _this.state.animatedWidth + 1;
            var isRoundOver = animatedWidth > overflowWidth;
            if (isRoundOver) {
                if (_this.props.loop) {
                    animatedWidth = 0;
                } else {
                    return;
                }
            }
            if (isRoundOver && _this.props.trailing) {
                _this._marqueeTimer = setTimeout(function () {
                    _this.setState({
                        animatedWidth: animatedWidth
                    });
                    _this._marqueeTimer = setTimeout(animate, TIMEOUT);
                }, _this.props.trailing);
            } else {
                _this.setState({
                    animatedWidth: animatedWidth
                });
                _this._marqueeTimer = setTimeout(animate, TIMEOUT);
            }
        };
        if (this.state.overflowWidth !== 0) {
            this._marqueeTimer = setTimeout(animate, timeout);
        }
    },
    _measureText: function _measureText() {
        var container = _reactDom2['default'].findDOMNode(this);
        var node = _reactDom2['default'].findDOMNode(this.refs.text);
        if (container && node) {
            var containerWidth = container.offsetWidth;
            var textWidth = node.offsetWidth;
            var overflowWidth = textWidth - containerWidth;
            if (overflowWidth !== this.state.overflowWidth) {
                this.setState({
                    overflowWidth: overflowWidth
                });
            }
        }
    }
}); /*
     * https://github.com/jasonslyvia/react-marquee
     * remove PC
     * support React Element for text prop
    */
exports['default'] = Marquee;
module.exports = exports['default'];

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

var _Marquee = __webpack_require__(822);

var _Marquee2 = _interopRequireDefault(_Marquee);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var NoticeBar = function (_React$Component) {
    (0, _inherits3['default'])(NoticeBar, _React$Component);

    function NoticeBar(props) {
        (0, _classCallCheck3['default'])(this, NoticeBar);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (NoticeBar.__proto__ || Object.getPrototypeOf(NoticeBar)).call(this, props));

        _this.onClick = function () {
            var _this$props = _this.props,
                mode = _this$props.mode,
                onClick = _this$props.onClick;

            if (onClick) {
                onClick();
            }
            if (mode === 'closable') {
                _this.setState({
                    show: false
                });
            }
        };
        _this.state = {
            show: true
        };
        return _this;
    }

    (0, _createClass3['default'])(NoticeBar, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                mode = _a.mode,
                icon = _a.icon,
                onClick = _a.onClick,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                marqueeProps = _a.marqueeProps,
                restProps = __rest(_a, ["mode", "icon", "onClick", "children", "className", "prefixCls", "marqueeProps"]);
            var extraProps = {};
            var operationDom = null;
            if (mode === 'closable') {
                operationDom = _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-operation', onClick: this.onClick, role: 'button', 'aria-label': 'close' },
                    _react2['default'].createElement(_index2['default'], { type: 'cross', size: 'md' })
                );
            } else {
                if (mode === 'link') {
                    operationDom = _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-operation', role: 'button', 'aria-label': 'go to detail' },
                        _react2['default'].createElement(_index2['default'], { type: 'right', size: 'md' })
                    );
                }
                extraProps.onClick = onClick;
            }
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames));
            var marquee = (0, _extends3['default'])({ loop: false, leading: 500, trailing: 800, fps: 40, style: {} }, marqueeProps);
            return this.state.show ? _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls }, restProps, extraProps, { role: 'alert' }),
                icon ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-icon', 'aria-hidden': 'true' },
                    ' ',
                    icon,
                    ' '
                ) : null,
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-content' },
                    _react2['default'].createElement(_Marquee2['default'], (0, _extends3['default'])({ prefixCls: prefixCls, text: children }, marquee))
                ),
                operationDom
            ) : null;
        }
    }]);
    return NoticeBar;
}(_react2['default'].Component);

exports['default'] = NoticeBar;

NoticeBar.defaultProps = {
    prefixCls: 'am-notice-bar',
    mode: '',
    icon: _react2['default'].createElement(_index2['default'], { type: __webpack_require__(1651), size: 'xxs' }),
    onClick: function onClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(199);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(166);

var _index4 = _interopRequireDefault(_index3);

var _getLocale = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
var Pagination = function (_React$Component) {
    (0, _inherits3['default'])(Pagination, _React$Component);

    function Pagination(props) {
        (0, _classCallCheck3['default'])(this, Pagination);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));

        _this.state = {
            current: props.current
        };
        return _this;
    }

    (0, _createClass3['default'])(Pagination, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                current: nextProps.current
            });
        }
    }, {
        key: 'onChange',
        value: function onChange(p) {
            this.setState({
                current: p
            });
            if (this.props.onChange) {
                this.props.onChange(p);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this,
                _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                style = _props.style,
                mode = _props.mode,
                total = _props.total,
                simple = _props.simple;

            var current = this.state.current;
            var locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'Pagination', function () {
                return __webpack_require__(825);
            });
            var prevText = locale.prevText,
                nextText = locale.nextText;

            var markup = _react2['default'].createElement(
                _index4['default'],
                null,
                _react2['default'].createElement(
                    _index4['default'].Item,
                    { className: prefixCls + '-wrap-btn ' + prefixCls + '-wrap-btn-prev' },
                    _react2['default'].createElement(
                        _index2['default'],
                        { inline: true, disabled: current <= 0, onClick: function onClick() {
                                return _this2.onChange(current - 1);
                            } },
                        prevText
                    )
                ),
                this.props.children ? _react2['default'].createElement(
                    _index4['default'].Item,
                    null,
                    this.props.children
                ) : !simple && _react2['default'].createElement(
                    _index4['default'].Item,
                    { className: prefixCls + '-wrap', 'aria-live': 'assertive' },
                    _react2['default'].createElement(
                        'span',
                        { className: 'active' },
                        current + 1
                    ),
                    '/',
                    _react2['default'].createElement(
                        'span',
                        null,
                        total
                    )
                ),
                _react2['default'].createElement(
                    _index4['default'].Item,
                    { className: prefixCls + '-wrap-btn ' + prefixCls + '-wrap-btn-next' },
                    _react2['default'].createElement(
                        _index2['default'],
                        { inline: true, disabled: current >= total - 1, onClick: function onClick() {
                                return _this2.onChange(_this2.state.current + 1);
                            } },
                        nextText
                    )
                )
            );
            if (mode === 'number') {
                markup = _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-wrap' },
                    _react2['default'].createElement(
                        'span',
                        { className: 'active' },
                        current + 1
                    ),
                    '/',
                    _react2['default'].createElement(
                        'span',
                        null,
                        total
                    )
                );
            } else if (mode === 'pointer') {
                var arr = [];
                for (var i = 0; i < total; i++) {
                    var _classNames;

                    arr.push(_react2['default'].createElement(
                        'div',
                        { key: 'dot-' + i, className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrap-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrap-dot-active', i === current), _classNames)) },
                        _react2['default'].createElement('span', null)
                    ));
                }
                markup = _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-wrap' },
                    arr
                );
            }
            var cls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls, true), (0, _defineProperty3['default'])(_classNames2, className, !!className), _classNames2));
            return _react2['default'].createElement(
                'div',
                { className: cls, style: style },
                markup
            );
        }
    }]);
    return Pagination;
}(_react2['default'].Component);

exports['default'] = Pagination;

Pagination.defaultProps = {
    prefixCls: 'am-pagination',
    mode: 'button',
    current: 0,
    simple: false,
    onChange: function onChange() {}
};
Pagination.contextTypes = {
    antLocale: _propTypes2['default'].object
};
module.exports = exports['default'];

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    prevText: '上一页',
    nextText: '下一页'
};
module.exports = exports['default'];

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cascader = __webpack_require__(591);

var _Cascader2 = _interopRequireDefault(_Cascader);

var _MultiPicker = __webpack_require__(230);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(231);

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
function getDefaultProps() {
    return {
        prefixCls: 'am-picker',
        pickerPrefixCls: 'am-picker-col',
        cols: 3,
        cascade: true,
        value: [],
        onChange: function onChange() {}
    };
}

var PickerView = function (_React$Component) {
    (0, _inherits3['default'])(PickerView, _React$Component);

    function PickerView() {
        (0, _classCallCheck3['default'])(this, PickerView);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PickerView.__proto__ || Object.getPrototypeOf(PickerView)).apply(this, arguments));

        _this.getCol = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                pickerPrefixCls = _this$props.pickerPrefixCls,
                indicatorStyle = _this$props.indicatorStyle,
                itemStyle = _this$props.itemStyle;

            return data.map(function (col, index) {
                return _react2['default'].createElement(
                    _Picker2['default'],
                    { key: index, prefixCls: pickerPrefixCls, style: { flex: 1 }, indicatorStyle: indicatorStyle, itemStyle: itemStyle },
                    col.map(function (item) {
                        return _react2['default'].createElement(
                            _Picker2['default'].Item,
                            { key: item.value, value: item.value },
                            item.label
                        );
                    })
                );
            });
        };
        return _this;
    }

    (0, _createClass3['default'])(PickerView, [{
        key: 'render',
        value: function render() {
            var props = this.props;

            var picker = void 0;
            if (props.cascade) {
                picker = _react2['default'].createElement(_Cascader2['default'], { prefixCls: props.prefixCls, pickerPrefixCls: props.pickerPrefixCls, data: props.data, value: props.value, onChange: props.onChange, cols: props.cols, indicatorStyle: props.indicatorStyle, pickerItemStyle: props.itemStyle });
            } else {
                picker = _react2['default'].createElement(
                    _MultiPicker2['default'],
                    { prefixCls: props.prefixCls, selectedValue: props.value, onValueChange: props.onChange, pickerPrefixCls: props.pickerPrefixCls, indicatorStyle: props.indicatorStyle, style: { flexDirection: 'row' } },
                    this.getCol()
                );
            }
            return picker;
        }
    }]);
    return PickerView;
}(_react2['default'].Component);

exports['default'] = PickerView;

PickerView.defaultProps = getDefaultProps();
module.exports = exports['default'];

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getDefaultProps = getDefaultProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__(1555);

var _Popup2 = _interopRequireDefault(_Popup);

var _Cascader = __webpack_require__(591);

var _Cascader2 = _interopRequireDefault(_Cascader);

var _MultiPicker = __webpack_require__(230);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(231);

var _Picker2 = _interopRequireDefault(_Picker);

var _arrayTreeFilter = __webpack_require__(131);

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */
function getDefaultProps() {
    var defaultFormat = function defaultFormat(values) {
        return values.join(',');
    };
    return {
        triggerType: 'onClick',
        prefixCls: 'am-picker',
        pickerPrefixCls: 'am-picker-col',
        popupPrefixCls: 'am-picker-popup',
        format: defaultFormat,
        cols: 3,
        cascade: true,
        extra: '请选择',
        okText: '确定',
        dismissText: '取消',
        title: ''
    };
}

var AbstractPicker = function (_React$Component) {
    (0, _inherits3['default'])(AbstractPicker, _React$Component);

    function AbstractPicker() {
        (0, _classCallCheck3['default'])(this, AbstractPicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (AbstractPicker.__proto__ || Object.getPrototypeOf(AbstractPicker)).apply(this, arguments));

        _this.getSel = function () {
            var value = _this.props.value || [];
            var treeChildren = void 0;
            if (_this.props.cascade) {
                treeChildren = (0, _arrayTreeFilter2['default'])(_this.props.data, function (c, level) {
                    return c.value === value[level];
                });
            } else {
                treeChildren = value.map(function (v, i) {
                    return _this.props.data[i].filter(function (d) {
                        return d.value === v;
                    })[0];
                });
            }
            return _this.props.format && _this.props.format(treeChildren.map(function (v) {
                return v.label;
            }));
        };
        _this.getPickerCol = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                pickerPrefixCls = _this$props.pickerPrefixCls,
                itemStyle = _this$props.itemStyle,
                indicatorStyle = _this$props.indicatorStyle;

            return data.map(function (col, index) {
                return _react2['default'].createElement(
                    _Picker2['default'],
                    { key: index, prefixCls: pickerPrefixCls, style: { flex: 1 }, itemStyle: itemStyle, indicatorStyle: indicatorStyle },
                    col.map(function (item) {
                        return _react2['default'].createElement(
                            _Picker2['default'].Item,
                            { key: item.value, value: item.value },
                            item.label
                        );
                    })
                );
            });
        };
        return _this;
    }

    (0, _createClass3['default'])(AbstractPicker, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                children = _a.children,
                _a$value = _a.value,
                value = _a$value === undefined ? [] : _a$value,
                extra = _a.extra,
                okText = _a.okText,
                dismissText = _a.dismissText,
                popupPrefixCls = _a.popupPrefixCls,
                itemStyle = _a.itemStyle,
                indicatorStyle = _a.indicatorStyle,
                cascade = _a.cascade,
                prefixCls = _a.prefixCls,
                pickerPrefixCls = _a.pickerPrefixCls,
                data = _a.data,
                cols = _a.cols,
                onPickerChange = _a.onPickerChange,
                restProps = __rest(_a, ["children", "value", "extra", "okText", "dismissText", "popupPrefixCls", "itemStyle", "indicatorStyle", "cascade", "prefixCls", "pickerPrefixCls", "data", "cols", "onPickerChange"]);
            var cascader = void 0;
            var popupMoreProps = {};
            if (cascade) {
                cascader = _react2['default'].createElement(_Cascader2['default'], { prefixCls: prefixCls, pickerPrefixCls: pickerPrefixCls, data: data, cols: cols, onChange: onPickerChange, pickerItemStyle: itemStyle, indicatorStyle: indicatorStyle });
            } else {
                cascader = _react2['default'].createElement(
                    _MultiPicker2['default'],
                    { style: { flexDirection: 'row', alignItems: 'center' }, prefixCls: prefixCls, pickerItemStyle: itemStyle },
                    this.getPickerCol()
                );
                popupMoreProps = {
                    pickerValueProp: 'selectedValue',
                    pickerValueChangeProp: 'onValueChange'
                };
            }
            return _react2['default'].createElement(
                _Popup2['default'],
                (0, _extends3['default'])({ cascader: cascader }, this.popupProps, restProps, { prefixCls: popupPrefixCls, value: value, dismissText: dismissText, okText: okText }, popupMoreProps),
                children && _react2['default'].cloneElement(children, { extra: this.getSel() || extra })
            );
        }
    }]);
    return AbstractPicker;
}(_react2['default'].Component);

exports['default'] = AbstractPicker;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AbstractPicker2 = __webpack_require__(827);

var _AbstractPicker3 = _interopRequireDefault(_AbstractPicker2);

var _popupProps = __webpack_require__(829);

var _popupProps2 = _interopRequireDefault(_popupProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Picker = function (_AbstractPicker) {
    (0, _inherits3['default'])(Picker, _AbstractPicker);

    function Picker() {
        (0, _classCallCheck3['default'])(this, Picker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).apply(this, arguments));

        _this.popupProps = _popupProps2['default'];
        return _this;
    }

    return Picker;
}(_AbstractPicker3['default']);

exports['default'] = Picker;

Picker.defaultProps = (0, _AbstractPicker2.getDefaultProps)();
module.exports = exports['default'];

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    WrapComponent: 'div',
    transitionName: 'am-slide-up',
    maskTransitionName: 'am-fade'
};
module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Item = function (_React$Component) {
    (0, _inherits3['default'])(Item, _React$Component);

    function Item() {
        (0, _classCallCheck3['default'])(this, Item);
        return (0, _possibleConstructorReturn3['default'])(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Item, [{
        key: 'render',
        value: function render() {
            var _cls;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                icon = _a.icon,
                disabled = _a.disabled,
                firstItem = _a.firstItem,
                activeStyle = _a.activeStyle,
                restProps = __rest(_a, ["children", "className", "prefixCls", "icon", "disabled", "firstItem", "activeStyle"]);
            var cls = (_cls = {}, (0, _defineProperty3['default'])(_cls, className, !!className), (0, _defineProperty3['default'])(_cls, prefixCls + '-item', true), (0, _defineProperty3['default'])(_cls, prefixCls + '-item-disabled', disabled), _cls);
            var activeClass = prefixCls + '-item-active ';
            if (firstItem) {
                activeClass += prefixCls + '-item-fix-active-arrow';
            }
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { disabled: disabled, activeClassName: activeClass, activeStyle: activeStyle },
                _react2['default'].createElement(
                    'div',
                    (0, _extends3['default'])({ className: (0, _classnames2['default'])(cls) }, restProps),
                    _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-item-container' },
                        icon ? _react2['default'].createElement(
                            'span',
                            { className: prefixCls + '-item-icon', 'aria-hidden': 'true' },
                            icon
                        ) : null,
                        _react2['default'].createElement(
                            'span',
                            { className: prefixCls + '-item-content' },
                            children
                        )
                    )
                )
            );
        }
    }]);
    return Item;
}(_react2['default'].Component);

exports['default'] = Item;

Item.defaultProps = {
    prefixCls: 'am-popover',
    disabled: false
};
Item.myName = 'PopoverItem';
module.exports = exports['default'];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcTooltip = __webpack_require__(1390);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Item = __webpack_require__(830);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

function recursiveCloneChildren(children) {
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (ch, _i) {
        return ch;
    };

    return _react2['default'].Children.map(children, function (child, index) {
        var newChild = cb(child, index);
        if (newChild && newChild.props && newChild.props.children) {
            return _react2['default'].cloneElement(newChild, {}, recursiveCloneChildren(newChild.props.children, cb));
        }
        return newChild;
    });
}

var Popover = function (_React$Component) {
    (0, _inherits3['default'])(Popover, _React$Component);

    function Popover() {
        (0, _classCallCheck3['default'])(this, Popover);
        return (0, _possibleConstructorReturn3['default'])(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Popover, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                overlay = _a.overlay,
                _a$onSelect = _a.onSelect,
                onSelect = _a$onSelect === undefined ? function () {} : _a$onSelect,
                restProps = __rest(_a, ["overlay", "onSelect"]);
            var overlayNode = recursiveCloneChildren(overlay, function (child, index) {
                var extraProps = { firstItem: false };
                if (child && child.type && child.type.myName === 'PopoverItem' && !child.props.disabled) {
                    extraProps.onClick = function () {
                        return onSelect(child, index);
                    };
                    extraProps.firstItem = index === 0;
                    return _react2['default'].cloneElement(child, extraProps);
                }
                return child;
            });
            var wrapperNode = _react2['default'].createElement(
                'div',
                { className: this.props.prefixCls + '-inner-wrapper' },
                overlayNode
            );
            return _react2['default'].createElement(_rcTooltip2['default'], (0, _extends3['default'])({}, restProps, { overlay: wrapperNode }));
        }
    }]);
    return Popover;
}(_react2['default'].Component);

exports['default'] = Popover;

Popover.defaultProps = {
    prefixCls: 'am-popover',
    placement: 'bottomRight',
    align: { overflow: { adjustY: 0, adjustX: 0 } },
    trigger: ['click']
};
Popover.Item = _Item2['default'];
module.exports = exports['default'];

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _rcDialog = __webpack_require__(212);

var _rcDialog2 = _interopRequireDefault(_rcDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function create(_instanceId, config, content) {
    var afterClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (_x) {};

    var props = (0, _extends3['default'])({ prefixCls: 'am-popup', animationType: 'slide-down' }, config);
    var prefixCls = props.prefixCls,
        transitionName = props.transitionName,
        animationType = props.animationType,
        maskTransitionName = props.maskTransitionName,
        _props$maskClosable = props.maskClosable,
        maskClosable = _props$maskClosable === undefined ? true : _props$maskClosable,
        onMaskClose = props.onMaskClose,
        className = props.className;

    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        if (div) {
            _reactDom2['default'].unmountComponentAtNode(div);
            div.parentNode.removeChild(div);
            div = null;
        }
        afterClose(_instanceId);
    }
    var transName = 'am-slide-down';
    if (animationType === 'slide-up') {
        transName = 'am-slide-up';
    }
    // 在 iPhone 上拖动 mask 蒙层、会触发最顶部或最底部的、页面回弹后的留白，解决办法是，禁掉 mask 蒙层的 onTouchStart 事件。
    // 但由于以下原因：
    // Popup 组件底层依赖 [rc-dialog](https://github.com/react-component/dialog)
    // 而 rc-dialog 点击 mask 蒙层关闭弹出框的事件是绑定在 classname 为 rc-dialog-wrap 的 dom 节点上，
    // 此节点是弹出层中主要内容的“父节点”，而非正常的“兄弟节点”。相关 issue https://github.com/react-component/dialog/issues/40
    // 所以、相对于 antd-mobile@0.9.8 以及之前的版本的变化是：
    // 去掉 am-popup-wrap 设置的 `position: fixed; top: 0; bottom: 0; ...` 样式，并给 am-popup 设置 z-index .
    // 另外不使用 rc-dialog 提供的 maskClosable 功能，而改为在这里实现
    var maskProps = {
        onClick: function onClick(e) {
            e.preventDefault();
            if (maskClosable) {
                if (onMaskClose && typeof onMaskClose === 'function') {
                    var res = onMaskClose();
                    if (res && res.then) {
                        res.then(function () {
                            close();
                        });
                    } else {
                        close();
                    }
                } else {
                    close();
                }
            }
        }
    };
    var cls = className ? prefixCls + '-' + animationType + ' ' + className : prefixCls + '-' + animationType;
    _reactDom2['default'].render(_react2['default'].createElement(
        _rcDialog2['default'],
        (0, _extends3['default'])({}, props, { className: cls, visible: true, title: '', footer: '', transitionName: transitionName || transName, maskTransitionName: maskTransitionName || 'am-fade', maskProps: (0, _extends3['default'])({}, props.maskProps, maskProps) }),
        content
    ), div);
    return {
        instanceId: instanceId,
        close: close
    };
} /* tslint:disable:jsx-no-multiline-js */

var ins = {
    defaultInstance: null,
    instances: []
};
var instanceId = 1;

var Popup = function Popup() {
    (0, _classCallCheck3['default'])(this, Popup);
};

exports['default'] = Popup;

Popup.newInstance = function () {
    var j = void 0;
    return {
        show: function show(content, config) {
            j = create(instanceId++, config, content, function (iId) {
                for (var i = 0; i < ins.instances.length; i++) {
                    if (ins.instances[i].instanceId === iId) {
                        ins.instances.splice(i, 1);
                        return;
                    }
                }
            });
            ins.instances.push(j);
        },
        hide: function hide() {
            j.close();
        }
    };
};
Popup.show = function (content, config) {
    Popup.hide();
    ins.defaultInstance = create('0', config, content, function (iId) {
        if (iId === '0') {
            ins.defaultInstance = null;
        }
    });
};
Popup.hide = function () {
    if (ins.defaultInstance) {
        ins.defaultInstance.close();
    }
};
module.exports = exports['default'];

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Progress = function (_React$Component) {
    (0, _inherits3['default'])(Progress, _React$Component);

    function Progress() {
        (0, _classCallCheck3['default'])(this, Progress);
        return (0, _possibleConstructorReturn3['default'])(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Progress, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.noAppearTransition = true;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.appearTransition) {
                setTimeout(function () {
                    _this2.refs.bar.style.width = _this2.props.percent + '%';
                }, 10);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                prefixCls = _props.prefixCls,
                position = _props.position,
                unfilled = _props.unfilled,
                _props$style = _props.style,
                style = _props$style === undefined ? {} : _props$style,
                _props$wrapStyle = _props.wrapStyle,
                wrapStyle = _props$wrapStyle === undefined ? {} : _props$wrapStyle;

            var percentStyle = {
                width: this.noAppearTransition || !this.props.appearTransition ? this.props.percent + '%' : 0,
                height: 0
            };
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-outer', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-fixed-outer', position === 'fixed'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-hide-outer', unfilled === 'hide'), _classNames));
            // TODO 2.0 整理 style， api 变更 style, barStyle, remove wrapStyle(不添入文档， for tiny)
            return _react2['default'].createElement(
                'div',
                { style: wrapStyle, className: wrapCls, role: 'progressbar', 'aria-valuenow': this.props.percent, 'aria-valuemin': '0', 'aria-valuemax': '100' },
                _react2['default'].createElement('div', { ref: 'bar', className: prefixCls + '-bar', style: (0, _extends3['default'])({}, style, percentStyle) })
            );
        }
    }]);
    return Progress;
}(_react2['default'].Component);

exports['default'] = Progress;

Progress.defaultProps = {
    prefixCls: 'am-progress',
    percent: 0,
    position: 'fixed',
    unfilled: 'show',
    appearTransition: false
};
module.exports = exports['default'];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(130);

var _index2 = _interopRequireDefault(_index);

var _Radio = __webpack_require__(278);

var _Radio2 = _interopRequireDefault(_Radio);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ListItem = _index2['default'].Item;
function noop() {}

var RadioItem = function (_React$Component) {
    (0, _inherits3['default'])(RadioItem, _React$Component);

    function RadioItem() {
        (0, _classCallCheck3['default'])(this, RadioItem);
        return (0, _possibleConstructorReturn3['default'])(this, (RadioItem.__proto__ || Object.getPrototypeOf(RadioItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(RadioItem, [{
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                listPrefixCls = _props.listPrefixCls,
                className = _props.className,
                children = _props.children,
                disabled = _props.disabled,
                _props$radioProps = _props.radioProps,
                radioProps = _props$radioProps === undefined ? {} : _props$radioProps;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-disabled', disabled === true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            // Note: if not omit `onChange`, it will trigger twice on check listitem
            var otherProps = (0, _omit2['default'])(this.props, ['listPrefixCls', 'onChange', 'disabled', 'radioProps']);
            if (disabled) {
                delete otherProps.onClick;
            } else {
                otherProps.onClick = otherProps.onClick || noop;
            }
            var extraProps = {};
            ['name', 'defaultChecked', 'checked', 'onChange', 'disabled'].forEach(function (i) {
                if (i in _this2.props) {
                    extraProps[i] = _this2.props[i];
                }
            });
            return _react2['default'].createElement(
                ListItem,
                (0, _extends3['default'])({}, otherProps, { prefixCls: listPrefixCls, className: wrapCls, extra: _react2['default'].createElement(_Radio2['default'], (0, _extends3['default'])({}, radioProps, extraProps)) }),
                children
            );
        }
    }]);
    return RadioItem;
}(_react2['default'].Component);

exports['default'] = RadioItem;

RadioItem.defaultProps = {
    prefixCls: 'am-radio',
    listPrefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__(278);

var _Radio2 = _interopRequireDefault(_Radio);

var _RadioItem = __webpack_require__(834);

var _RadioItem2 = _interopRequireDefault(_RadioItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Radio2['default'].RadioItem = _RadioItem2['default'];
exports['default'] = _Radio2['default'];
module.exports = exports['default'];

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Range = __webpack_require__(1311);

var _Range2 = _interopRequireDefault(_Range);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Range = function (_React$Component) {
    (0, _inherits3['default'])(Range, _React$Component);

    function Range() {
        (0, _classCallCheck3['default'])(this, Range);
        return (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Range, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: this.props.prefixCls + '-wrapper' },
                _react2['default'].createElement(_Range2['default'], this.props)
            );
        }
    }]);
    return Range;
}(_react2['default'].Component);

exports['default'] = Range;

Range.defaultProps = {
    prefixCls: 'am-slider'
};
module.exports = exports['default'];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rmcListView = __webpack_require__(365);

var _rmcListView2 = _interopRequireDefault(_rmcListView);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var dpr = typeof window !== 'undefined' && window.devicePixelRatio || 2;
_rmcListView2['default'].RefreshControl.defaultProps = (0, _extends3['default'])({}, _rmcListView2['default'].RefreshControl.defaultProps, { prefixCls: 'am-refresh-control', icon: [_react2['default'].createElement(
        'div',
        { key: '0', className: 'am-refresh-control-pull' },
        _react2['default'].createElement(
            'span',
            null,
            '\u4E0B\u62C9\u53EF\u4EE5\u5237\u65B0'
        )
    ), _react2['default'].createElement(
        'div',
        { key: '1', className: 'am-refresh-control-release' },
        _react2['default'].createElement(
            'span',
            null,
            '\u677E\u5F00\u7ACB\u5373\u5237\u65B0'
        )
    )], loading: _react2['default'].createElement(_index2['default'], { type: 'loading' }), refreshing: false, distanceToRefresh: 50 / 2 * dpr });
exports['default'] = _rmcListView2['default'].RefreshControl;
module.exports = exports['default'];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(199);

var _index2 = _interopRequireDefault(_index);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Result = function (_React$Component) {
    (0, _inherits3['default'])(Result, _React$Component);

    function Result() {
        (0, _classCallCheck3['default'])(this, Result);
        return (0, _possibleConstructorReturn3['default'])(this, (Result.__proto__ || Object.getPrototypeOf(Result)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Result, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                img = _props.img,
                imgUrl = _props.imgUrl,
                title = _props.title,
                message = _props.message,
                buttonText = _props.buttonText,
                buttonClick = _props.buttonClick,
                buttonType = _props.buttonType,
                style = _props.style;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            var imgContent = null;
            if (img) {
                imgContent = _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-pic' },
                    img
                );
            } else if (imgUrl) {
                imgContent = _react2['default'].createElement('div', { className: prefixCls + '-pic', style: { backgroundImage: 'url(' + imgUrl + ')' } });
            }
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style, role: 'alert' },
                imgContent,
                title ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-title' },
                    title
                ) : null,
                message ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-message' },
                    message
                ) : null,
                buttonText ? _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-button' },
                    _react2['default'].createElement(
                        _index2['default'],
                        { type: buttonType, onClick: buttonClick },
                        buttonText
                    )
                ) : null
            );
        }
    }]);
    return Result;
}(_react2['default'].Component); /* tslint:disable:jsx-no-multiline-js */


exports['default'] = Result;

Result.defaultProps = {
    prefixCls: 'am-result',
    buttonType: '',
    buttonClick: function buttonClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function noop() {}
var defaultProps = exports.defaultProps = {
    prefixCls: 'am-search',
    placeholder: '',
    onSubmit: noop,
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onClear: noop,
    showCancelButton: false,
    cancelText: '取消',
    disabled: false
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _PropsType = __webpack_require__(839);

var _getDataAttr = __webpack_require__(165);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SearchBar = function (_React$Component) {
    (0, _inherits3['default'])(SearchBar, _React$Component);

    function SearchBar(props) {
        (0, _classCallCheck3['default'])(this, SearchBar);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

        _this.onSubmit = function (e) {
            e.preventDefault();
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state.value);
            }
            _this.refs.searchInput.blur();
        };
        _this.onChange = function (e) {
            if (!_this.state.focus) {
                _this.setState({
                    focus: true
                });
            }
            var value = e.target.value;
            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            }
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        _this.onFocus = function () {
            _this.setState({
                focus: true
            });
            _this.firstFocus = true;
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: true
                });
            }
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
            if (document.activeElement.tagName.toLowerCase() === 'input') {
                _this.scrollIntoViewTimeout = setTimeout(function () {
                    try {
                        document.activeElement.scrollIntoViewIfNeeded();
                    } catch (e) {}
                }, 100);
            }
        };
        _this.onBlur = function () {
            _this.onBlurTimeout = setTimeout(function () {
                if (!_this.blurFromOnClear) {
                    if (document.activeElement !== _this.refs.search) {
                        _this.setState({
                            focus: false
                        });
                    }
                }
                _this.blurFromOnClear = false;
            }, 50);
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: false
                });
            }
            if (_this.props.onBlur) {
                _this.props.onBlur();
            }
        };
        _this.onClear = function () {
            _this.doClear();
        };
        _this.doClear = function () {
            var blurFromOnClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            _this.blurFromOnClear = blurFromOnClear;
            if (!('value' in _this.props)) {
                _this.setState({ value: '' });
            }
            if (_this.props.onClear) {
                _this.props.onClear('');
            }
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            if (blurFromOnClear) {
                _this.refs.searchInput.focus();
            }
        };
        _this.onCancel = function () {
            if (_this.props.onCancel) {
                _this.props.onCancel(_this.state.value);
            } else {
                _this.doClear(false);
            }
        };
        var value = void 0;
        if ('value' in props) {
            value = props.value || '';
        } else if ('defaultValue' in props) {
            value = props.defaultValue;
        } else {
            value = '';
        }
        _this.state = {
            value: value,
            focus: false,
            focused: props.focused || false
        };
        return _this;
    }

    (0, _createClass3['default'])(SearchBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var initBtn = window.getComputedStyle(this.refs.rightBtn);
            this.rightBtnInitMarginleft = initBtn['margin-left'];
            if ((this.props.autoFocus || this.state.focused) && navigator.userAgent.indexOf('AlipayClient') > 0) {
                this.refs.searchInput.focus();
            }
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            // 检测是否包含名为 ${this.props.prefixCls}-start 样式，生成动画
            // offsetWidth 某些时候是向上取整，某些时候是向下取整，不能用
            var realWidth = this.refs.syntheticPhContainer.getBoundingClientRect().width; // 包含小数
            if (this.refs.searchInputContainer.className.indexOf(this.props.prefixCls + '-start') > -1) {
                this.refs.syntheticPh.style.width = Math.ceil(realWidth) + 'px';
                if (!this.props.showCancelButton) {
                    this.refs.rightBtn.style.marginRight = 0;
                }
            } else {
                this.refs.syntheticPh.style.width = '100%';
                if (!this.props.showCancelButton) {
                    this.refs.rightBtn.style.marginRight = '-' + (this.refs.rightBtn.offsetWidth + parseInt(this.rightBtnInitMarginleft, 10)) + 'px';
                }
            }
            if (this.state.focused) {
                this.refs.searchInput.focus();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            }
            if ('focused' in nextProps) {
                this.setState({
                    focused: nextProps.focused
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.scrollIntoViewTimeout) {
                clearTimeout(this.scrollIntoViewTimeout);
                this.scrollIntoViewTimeout = null;
            }
            if (this.onBlurTimeout) {
                clearTimeout(this.onBlurTimeout);
                this.onBlurTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2, _classNames3;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                showCancelButton = _props.showCancelButton,
                disabled = _props.disabled,
                placeholder = _props.placeholder,
                cancelText = _props.cancelText,
                className = _props.className,
                style = _props.style,
                maxLength = _props.maxLength;
            var _state = this.state,
                value = _state.value,
                focus = _state.focus;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-start', focus || value && value.length > 0), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            var clearCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-clear', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-clear-show', focus && value && value.length > 0), _classNames2));
            var cancelCls = (0, _classnames2['default'])((_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, prefixCls + '-cancel', true), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-cancel-show', showCancelButton || focus || value && value.length > 0), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-cancel-anim', this.firstFocus), _classNames3));
            return _react2['default'].createElement(
                'form',
                { onSubmit: this.onSubmit, className: wrapCls, style: style, ref: 'searchInputContainer', action: '#' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'div',
                        { className: prefixCls + '-synthetic-ph', ref: 'syntheticPh' },
                        _react2['default'].createElement(
                            'span',
                            { className: prefixCls + '-synthetic-ph-container', ref: 'syntheticPhContainer' },
                            _react2['default'].createElement('i', { className: prefixCls + '-synthetic-ph-icon' }),
                            _react2['default'].createElement(
                                'span',
                                { className: prefixCls + '-synthetic-ph-placeholder', style: { visibility: placeholder && !value ? 'visible' : 'hidden' } },
                                placeholder
                            )
                        )
                    ),
                    _react2['default'].createElement('input', (0, _extends3['default'])({ type: 'search', className: prefixCls + '-value', value: value, disabled: disabled, placeholder: placeholder, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, ref: 'searchInput', maxLength: maxLength }, (0, _getDataAttr2['default'])(this.props))),
                    _react2['default'].createElement('a', { onClick: this.onClear, className: clearCls })
                ),
                _react2['default'].createElement(
                    'div',
                    { className: cancelCls, onClick: this.onCancel, ref: 'rightBtn' },
                    cancelText
                )
            );
        }
    }]);
    return SearchBar;
}(_react2['default'].Component);

exports['default'] = SearchBar;

SearchBar.defaultProps = _PropsType.defaultProps;
module.exports = exports['default'];

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcTouchable = __webpack_require__(96);

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SegmentedControl = function (_React$Component) {
    (0, _inherits3['default'])(SegmentedControl, _React$Component);

    function SegmentedControl(props) {
        (0, _classCallCheck3['default'])(this, SegmentedControl);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (SegmentedControl.__proto__ || Object.getPrototypeOf(SegmentedControl)).call(this, props));

        _this.state = {
            selectedIndex: props.selectedIndex
        };
        return _this;
    }

    (0, _createClass3['default'])(SegmentedControl, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.selectedIndex !== this.state.selectedIndex) {
                this.setState({
                    selectedIndex: nextProps.selectedIndex
                });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick(e, index, value) {
            var _props = this.props,
                disabled = _props.disabled,
                onChange = _props.onChange,
                onValueChange = _props.onValueChange;

            if (!disabled && this.state.selectedIndex !== index) {
                // just do a mock so that the api to be the same as react-native
                e.nativeEvent = e.nativeEvent ? e.nativeEvent : {};
                e.nativeEvent.selectedSegmentIndex = index;
                e.nativeEvent.value = value;
                if (onChange) {
                    onChange(e);
                }
                if (onValueChange) {
                    onValueChange(value);
                }
                this.setState({
                    selectedIndex: index
                });
            }
        }
    }, {
        key: 'renderSegmentItem',
        value: function renderSegmentItem(idx, value, selected) {
            var _classNames,
                _this2 = this;

            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                disabled = _props2.disabled,
                tintColor = _props2.tintColor;

            var itemCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-selected', selected), _classNames));
            var itemStyle = {
                color: selected ? '#fff' : tintColor,
                backgroundColor: selected ? tintColor : '#fff',
                borderColor: tintColor
            };
            var activeInnerStyle = tintColor ? {
                backgroundColor: tintColor
            } : {};
            return _react2['default'].createElement(
                _rcTouchable2['default'],
                { key: idx, disabled: disabled, activeClassName: prefixCls + '-item-active' },
                _react2['default'].createElement(
                    'div',
                    { className: itemCls, style: itemStyle, role: 'tab', 'aria-selected': selected && !disabled, 'aria-disabled': disabled, onClick: disabled ? undefined : function (e) {
                            return _this2.onClick(e, idx, value);
                        } },
                    _react2['default'].createElement('div', { className: prefixCls + '-item-inner', style: activeInnerStyle }),
                    value
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames2,
                _this3 = this;

            var _props3 = this.props,
                className = _props3.className,
                prefixCls = _props3.prefixCls,
                style = _props3.style,
                disabled = _props3.disabled,
                _props3$values = _props3.values,
                values = _props3$values === undefined ? [] : _props3$values;

            var wrapCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, className, !!className), (0, _defineProperty3['default'])(_classNames2, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-disabled', disabled), _classNames2));
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style, role: 'tablist' },
                values.map(function (value, idx) {
                    return _this3.renderSegmentItem(idx, value, idx === _this3.state.selectedIndex);
                })
            );
        }
    }]);
    return SegmentedControl;
}(_react2['default'].Component);

exports['default'] = SegmentedControl;

SegmentedControl.defaultProps = {
    prefixCls: 'am-segment',
    selectedIndex: 0,
    disabled: false,
    values: [],
    onChange: function onChange() {},
    onValueChange: function onValueChange() {},

    style: {},
    tintColor: ''
};
module.exports = exports['default'];

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Slider = __webpack_require__(1312);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Slider = function (_React$Component) {
    (0, _inherits3['default'])(Slider, _React$Component);

    function Slider() {
        (0, _classCallCheck3['default'])(this, Slider);
        return (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Slider, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: this.props.prefixCls + '-wrapper' },
                _react2['default'].createElement(_Slider2['default'], this.props)
            );
        }
    }]);
    return Slider;
}(_react2['default'].Component);

exports['default'] = Slider;

Slider.defaultProps = {
    prefixCls: 'am-slider'
};
module.exports = exports['default'];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcInputNumber = __webpack_require__(1287);

var _rcInputNumber2 = _interopRequireDefault(_rcInputNumber);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Stepper = function (_React$Component) {
    (0, _inherits3['default'])(Stepper, _React$Component);

    function Stepper() {
        (0, _classCallCheck3['default'])(this, Stepper);
        return (0, _possibleConstructorReturn3['default'])(this, (Stepper.__proto__ || Object.getPrototypeOf(Stepper)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Stepper, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _a = this.props,
                className = _a.className,
                showNumber = _a.showNumber,
                restProps = __rest(_a, ["className", "showNumber"]);
            var stepperClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, 'showNumber', !!showNumber), _classNames));
            return _react2['default'].createElement(_rcInputNumber2['default'], (0, _extends3['default'])({ upHandler: _react2['default'].createElement(_index2['default'], { type: __webpack_require__(1653), size: 'xxs' }), downHandler: _react2['default'].createElement(_index2['default'], { type: __webpack_require__(1652), size: 'xxs' }) }, restProps, { ref: 'inputNumber', className: stepperClass }));
        }
    }]);
    return Stepper;
}(_react2['default'].Component);

exports['default'] = Stepper;

Stepper.defaultProps = {
    prefixCls: 'am-stepper',
    step: 1,
    readOnly: false,
    showNumber: false,
    focusOnUpDown: false,
    useTouch: true
};
module.exports = exports['default'];

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcSteps = __webpack_require__(1340);

var _rcSteps2 = _interopRequireDefault(_rcSteps);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Steps = function (_React$Component) {
    (0, _inherits3['default'])(Steps, _React$Component);

    function Steps() {
        (0, _classCallCheck3['default'])(this, Steps);
        return (0, _possibleConstructorReturn3['default'])(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Steps, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.direction !== 'horizontal') {
                return;
            }
            // set tail's left position based on main's width for each step dynamically.
            this.stepRefs.forEach(function (s) {
                if (s.refs.tail) {
                    s.refs.tail.style.left = s.refs.main.offsetWidth / 2 + 'px';
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.stepRefs = [];
            var _props = this.props,
                children = _props.children,
                status = _props.status;

            var current = this.props.current;
            // flattern the array at first https://github.com/ant-design/ant-design-mobile/issues/934
            var newChildren = _react2['default'].Children.map(children, function (item) {
                return item;
            });
            newChildren = _react2['default'].Children.map(newChildren, function (item, index) {
                var className = item.props.className;
                if (index < newChildren.length - 1 && newChildren[index + 1].props.status === 'error') {
                    className = className ? className + ' error-tail' : 'error-tail';
                }
                var icon = item.props.icon;
                if (!icon) {
                    if (index < current) {
                        // 对应 state: finish
                        icon = 'check-circle-o';
                    } else if (index > current) {
                        // 对应 state: wait
                        icon = 'ellipsis';
                        className = className ? className + ' ellipsis-item' : 'ellipsis-item';
                    }
                    if (status === 'error' && index === current || item.props.status === 'error') {
                        icon = 'cross-circle-o';
                    }
                }
                icon = typeof icon === 'string' ? _react2['default'].createElement(_index2['default'], { type: icon }) : icon;
                return _react2['default'].cloneElement(item, { icon: icon, className: className, ref: function ref(c) {
                        return _this2.stepRefs[index] = c;
                    } });
            });
            return _react2['default'].createElement(
                _rcSteps2['default'],
                (0, _extends3['default'])({ ref: 'rcSteps' }, this.props),
                newChildren
            );
        }
    }]);
    return Steps;
}(_react2['default'].Component);

exports['default'] = Steps;

Steps.Step = _rcSteps2['default'].Step;
Steps.defaultProps = {
    prefixCls: 'am-steps',
    iconPrefix: 'ant',
    labelPlacement: 'vertical',
    direction: 'vertical',
    current: 0
};
module.exports = exports['default'];

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcSwipeout = __webpack_require__(1342);

var _rcSwipeout2 = _interopRequireDefault(_rcSwipeout);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SwipeAction = function (_React$Component) {
    (0, _inherits3['default'])(SwipeAction, _React$Component);

    function SwipeAction() {
        (0, _classCallCheck3['default'])(this, SwipeAction);
        return (0, _possibleConstructorReturn3['default'])(this, (SwipeAction.__proto__ || Object.getPrototypeOf(SwipeAction)).apply(this, arguments));
    }

    (0, _createClass3['default'])(SwipeAction, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                className = _props.className,
                style = _props.style,
                prefixCls = _props.prefixCls,
                _props$left = _props.left,
                left = _props$left === undefined ? [] : _props$left,
                _props$right = _props.right,
                right = _props$right === undefined ? [] : _props$right,
                autoClose = _props.autoClose,
                disabled = _props.disabled,
                onOpen = _props.onOpen,
                onClose = _props.onClose,
                children = _props.children;

            var wrapClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, 1), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames));
            return left.length || right.length ? _react2['default'].createElement(
                'div',
                { style: style, className: className },
                _react2['default'].createElement(
                    _rcSwipeout2['default'],
                    { prefixCls: prefixCls, left: left, right: right, autoClose: autoClose, disabled: disabled, onOpen: onOpen, onClose: onClose },
                    children
                )
            ) : _react2['default'].createElement(
                'div',
                { style: style, className: wrapClass },
                children
            );
        }
    }]);
    return SwipeAction;
}(_react2['default'].Component);

SwipeAction.defaultProps = {
    prefixCls: 'am-swipe',
    title: '请确认操作',
    autoClose: false,
    disabled: false,
    left: [],
    right: [],
    onOpen: function onOpen() {},
    onClose: function onClose() {}
};
exports['default'] = SwipeAction;
module.exports = exports['default'];

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Switch = function (_React$Component) {
    (0, _inherits3['default'])(Switch, _React$Component);

    function Switch() {
        (0, _classCallCheck3['default'])(this, Switch);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));

        _this.onChange = function (e) {
            var checked = e.target.checked;
            if (_this.props.onChange) {
                _this.props.onChange(checked);
            }
        };
        _this.onClick = function (e) {
            if (_this.props.onClick) {
                var val = void 0;
                if (e && e.target && e.target.checked !== undefined) {
                    val = e.target.checked;
                } else {
                    val = _this.props.checked;
                }
                _this.props.onClick(val);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Switch, [{
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                style = _a.style,
                name = _a.name,
                checked = _a.checked,
                disabled = _a.disabled,
                className = _a.className,
                platform = _a.platform,
                restProps = __rest(_a, ["prefixCls", "style", "name", "checked", "disabled", "className", "platform"]);
            var isAndroid = platform === 'android' || platform === 'cross' && typeof navigator !== 'undefined' && !!navigator.userAgent.match(/Android/i);
            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, className, className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-android', isAndroid), _classNames));
            var fackInputCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, 'checkbox', true), (0, _defineProperty3['default'])(_classNames2, 'checkbox-disabled', disabled), _classNames2));
            var globalProps = Object.keys(restProps).reduce(function (prev, key) {
                if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
                    prev[key] = restProps[key];
                }
                return prev;
            }, {});
            return _react2['default'].createElement(
                'label',
                { className: wrapCls, style: style },
                _react2['default'].createElement('input', (0, _extends3['default'])({ type: 'checkbox', name: name, className: prefixCls + '-checkbox', disabled: disabled, checked: checked, onChange: this.onChange, value: checked ? 'on' : 'off' }, !disabled ? { onClick: this.onClick } : {}, globalProps)),
                _react2['default'].createElement('div', (0, _extends3['default'])({ className: fackInputCls }, disabled ? { onClick: this.onClick } : {}))
            );
        }
    }]);
    return Switch;
}(_react2['default'].Component);

exports['default'] = Switch;

Switch.defaultProps = {
    prefixCls: 'am-switch',
    name: '',
    checked: false,
    disabled: false,
    onChange: function onChange() {},

    platform: 'cross',
    onClick: function onClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(435);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tab = function (_React$Component) {
    (0, _inherits3['default'])(Tab, _React$Component);

    function Tab() {
        (0, _classCallCheck3['default'])(this, Tab);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));

        _this.renderIcon = function () {
            var _this$props = _this.props,
                dot = _this$props.dot,
                badge = _this$props.badge,
                selected = _this$props.selected,
                selectedIcon = _this$props.selectedIcon,
                icon = _this$props.icon,
                title = _this$props.title,
                prefixCls = _this$props.prefixCls;

            var iconRes = selected ? selectedIcon : icon;
            var iconDom = _react2['default'].isValidElement(iconRes) ? iconRes : _react2['default'].createElement('img', { className: prefixCls + '-image', src: iconRes.uri || iconRes, alt: title });
            if (badge) {
                return _react2['default'].createElement(
                    _index2['default'],
                    { text: badge, className: prefixCls + '-badge tab-badge' },
                    ' ',
                    iconDom,
                    ' '
                );
            }
            if (dot) {
                return _react2['default'].createElement(
                    _index2['default'],
                    { dot: true, className: prefixCls + '-badge tab-dot' },
                    iconDom
                );
            }
            return iconDom;
        };
        return _this;
    }

    (0, _createClass3['default'])(Tab, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                prefixCls = _props.prefixCls,
                selected = _props.selected,
                unselectedTintColor = _props.unselectedTintColor,
                tintColor = _props.tintColor;

            var iconColor = selected ? tintColor : unselectedTintColor;
            return _react2['default'].createElement(
                'div',
                this.props.dataAttrs,
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-icon', style: { color: iconColor } },
                    this.renderIcon()
                ),
                _react2['default'].createElement(
                    'p',
                    { className: prefixCls + '-title', style: { color: selected ? tintColor : unselectedTintColor } },
                    title
                )
            );
        }
    }]);
    return Tab;
}(_react2['default'].Component);

exports['default'] = Tab;
module.exports = exports['default'];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Item = undefined;

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcTabs = __webpack_require__(533);

var _rcTabs2 = _interopRequireDefault(_rcTabs);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _Tab = __webpack_require__(847);

var _Tab2 = _interopRequireDefault(_Tab);

var _TabContent = __webpack_require__(331);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _TabBar = __webpack_require__(1379);

var _TabBar2 = _interopRequireDefault(_TabBar);

var _getDataAttr = __webpack_require__(165);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Item = exports.Item = function (_React$Component) {
    (0, _inherits3['default'])(Item, _React$Component);

    function Item() {
        (0, _classCallCheck3['default'])(this, Item);
        return (0, _possibleConstructorReturn3['default'])(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Item, [{
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return Item;
}(_react2['default'].Component);

var AntTabBar = function (_React$Component2) {
    (0, _inherits3['default'])(AntTabBar, _React$Component2);

    function AntTabBar() {
        (0, _classCallCheck3['default'])(this, AntTabBar);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (AntTabBar.__proto__ || Object.getPrototypeOf(AntTabBar)).apply(this, arguments));

        _this2.onChange = function (key) {
            _react2['default'].Children.forEach(_this2.props.children, function (c) {
                if (c.key === key && c.props.onPress) {
                    c.props.onPress();
                }
            });
        };
        _this2.renderTabBar = function () {
            var _this2$props = _this2.props,
                barTintColor = _this2$props.barTintColor,
                hidden = _this2$props.hidden,
                prefixCls = _this2$props.prefixCls;

            var barCls = hidden ? prefixCls + '-bar-hidden' : '';
            return _react2['default'].createElement(_TabBar2['default'], { className: barCls, style: { backgroundColor: barTintColor } });
        };
        _this2.renderTabContent = function () {
            return _react2['default'].createElement(_TabContent2['default'], { animated: false });
        };
        return _this2;
    }

    (0, _createClass3['default'])(AntTabBar, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var activeKey = void 0;
            var children = [];
            var _allKeys = [];
            _react2['default'].Children.forEach(this.props.children, function (c) {
                var hasKey = !!c.key;
                var isUnique = _allKeys.indexOf(c.key) === -1;
                (0, _warning2['default'])(hasKey && isUnique, 'TabBar.Item must have a unique key!');
                _allKeys.push(c.key);
                if (c.props.selected) {
                    activeKey = c.key;
                }
                children.push(c);
            });
            var _props = this.props,
                tintColor = _props.tintColor,
                unselectedTintColor = _props.unselectedTintColor;

            var panels = children.map(function (c) {
                var cProps = c.props;
                var tab = _react2['default'].createElement(_Tab2['default'], { prefixCls: _this3.props.prefixCls + '-tab', badge: cProps.badge, dot: cProps.dot, selected: cProps.selected, icon: cProps.icon, selectedIcon: cProps.selectedIcon, title: cProps.title, tintColor: tintColor, unselectedTintColor: unselectedTintColor, dataAttrs: (0, _getDataAttr2['default'])(cProps) });
                return _react2['default'].createElement(
                    _rcTabs.TabPane,
                    { placeholder: _this3.props.placeholder, tab: tab, key: c.key },
                    cProps.children
                );
            });
            return _react2['default'].createElement(
                _rcTabs2['default'],
                { renderTabBar: this.renderTabBar, renderTabContent: this.renderTabContent, tabBarPosition: 'bottom', prefixCls: this.props.prefixCls, activeKey: activeKey, onChange: this.onChange },
                panels
            );
        }
    }]);
    return AntTabBar;
}(_react2['default'].Component);

AntTabBar.defaultProps = {
    prefixCls: 'am-tab-bar',
    barTintColor: 'white',
    tintColor: '#108ee9',
    hidden: false,
    unselectedTintColor: '#888',
    placeholder: '正在加载'
};
AntTabBar.Item = Item;
exports['default'] = AntTabBar;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcTable = __webpack_require__(1363);

var _rcTable2 = _interopRequireDefault(_rcTable);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Table = function (_React$Component) {
    (0, _inherits3['default'])(Table, _React$Component);

    function Table() {
        (0, _classCallCheck3['default'])(this, Table);
        return (0, _possibleConstructorReturn3['default'])(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Table, [{
        key: 'render',
        value: function render() {
            (0, _warning2['default'])(false, 'Table is going to be deprecated at antd-mobile@2.0. see https://goo.gl/xb0YEX');
            var _props = this.props,
                prefixCls = _props.prefixCls,
                columns = _props.columns,
                dataSource = _props.dataSource,
                direction = _props.direction,
                scrollX = _props.scrollX,
                titleFixed = _props.titleFixed;

            var newProps = (0, _extends3['default'])({}, this.props, { data: dataSource });
            var table = void 0;
            // 默认纵向
            if (!direction || direction === 'vertical') {
                if (titleFixed) {
                    table = _react2['default'].createElement(_rcTable2['default'], (0, _extends3['default'])({}, newProps, { columns: columns, scroll: { x: true }, showHeader: false }));
                } else {
                    table = _react2['default'].createElement(_rcTable2['default'], (0, _extends3['default'])({}, newProps, { columns: columns, scroll: { x: scrollX } }));
                }
                // 横向
            } else if (direction === 'horizon') {
                columns[0].className = prefixCls + '-horizonTitle';
                table = _react2['default'].createElement(_rcTable2['default'], (0, _extends3['default'])({}, newProps, { columns: columns, showHeader: false, scroll: { x: scrollX } }));
                // 混合
            } else if (direction === 'mix') {
                columns[0].className = prefixCls + '-horizonTitle';
                table = _react2['default'].createElement(_rcTable2['default'], (0, _extends3['default'])({}, newProps, { columns: columns, scroll: { x: scrollX } }));
            }
            return table;
        }
    }]);
    return Table;
}(_react2['default'].Component);

exports['default'] = Table;

Table.defaultProps = {
    dataSource: [],
    prefixCls: 'am-table'
};
module.exports = exports['default'];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rcTabs = __webpack_require__(533);

var _rcTabs2 = _interopRequireDefault(_rcTabs);

var _SwipeableTabContent = __webpack_require__(1378);

var _SwipeableTabContent2 = _interopRequireDefault(_SwipeableTabContent);

var _TabContent = __webpack_require__(331);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _InkTabBar = __webpack_require__(1375);

var _InkTabBar2 = _interopRequireDefault(_InkTabBar);

var _SwipeableInkTabBar = __webpack_require__(1376);

var _SwipeableInkTabBar2 = _interopRequireDefault(_SwipeableInkTabBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tabs = function (_React$Component) {
    (0, _inherits3['default'])(Tabs, _React$Component);

    function Tabs() {
        (0, _classCallCheck3['default'])(this, Tabs);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));

        _this.renderTabBar = function () {
            var _this$props = _this.props,
                children = _this$props.children,
                animated = _this$props.animated,
                speed = _this$props.speed,
                pageSize = _this$props.pageSize,
                tabBarhammerOptions = _this$props.tabBarhammerOptions,
                onTabClick = _this$props.onTabClick;

            if (children.length > pageSize) {
                return _react2['default'].createElement(_SwipeableInkTabBar2['default'], { onTabClick: onTabClick, speed: speed, pageSize: pageSize, hammerOptions: tabBarhammerOptions });
            }
            return _react2['default'].createElement(_InkTabBar2['default'], { inkBarAnimated: animated, onTabClick: onTabClick });
        };
        _this.renderTabContent = function () {
            var _this$props2 = _this.props,
                animated = _this$props2.animated,
                swipeable = _this$props2.swipeable,
                hammerOptions = _this$props2.hammerOptions;

            return swipeable ? _react2['default'].createElement(_SwipeableTabContent2['default'], { animated: animated, hammerOptions: hammerOptions }) : _react2['default'].createElement(_TabContent2['default'], { animated: animated });
        };
        return _this;
    }

    (0, _createClass3['default'])(Tabs, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_rcTabs2['default'], (0, _extends3['default'])({ renderTabBar: this.renderTabBar, renderTabContent: this.renderTabContent }, this.props));
        }
    }]);
    return Tabs;
}(_react2['default'].Component);

exports['default'] = Tabs;

Tabs.TabPane = _rcTabs.TabPane;
Tabs.defaultProps = {
    prefixCls: 'am-tabs',
    animated: true,
    swipeable: true,
    tabBarPosition: 'top',
    hammerOptions: {},
    tabBarhammerOptions: {},
    pageSize: 5,
    speed: 10,
    onChange: function onChange() {},
    onTabClick: function onTabClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _index = __webpack_require__(84);

var _index2 = _interopRequireDefault(_index);

var _getDataAttr = __webpack_require__(165);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tag = function (_React$Component) {
    (0, _inherits3['default'])(Tag, _React$Component);

    function Tag(props) {
        (0, _classCallCheck3['default'])(this, Tag);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).call(this, props));

        _this.onClick = function () {
            var _this$props = _this.props,
                disabled = _this$props.disabled,
                onChange = _this$props.onChange;

            if (disabled) {
                return;
            }
            var isSelect = _this.state.selected;
            _this.setState({
                selected: !isSelect
            }, function () {
                if (onChange) {
                    onChange(!isSelect);
                }
            });
        };
        _this.onTagClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
            _this.setState({
                closed: true
            }, _this.props.afterClose);
        };
        _this.state = {
            selected: props.selected,
            closed: false
        };
        return _this;
    }

    (0, _createClass3['default'])(Tag, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.selected !== nextProps.selected) {
                this.setState({
                    selected: nextProps.selected
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                prefixCls = _props.prefixCls,
                disabled = _props.disabled,
                closable = _props.closable,
                small = _props.small,
                style = _props.style;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-normal', !disabled && (!this.state.selected || small || closable)), (0, _defineProperty3['default'])(_classNames, prefixCls + '-small', small), (0, _defineProperty3['default'])(_classNames, prefixCls + '-active', this.state.selected && !disabled && !small && !closable), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-closable', closable), _classNames));
            var closableDom = closable && !disabled && !small ? _react2['default'].createElement(
                'div',
                { className: prefixCls + '-close', role: 'button', onClick: this.onTagClose, 'aria-label': 'remove tag' },
                _react2['default'].createElement(_index2['default'], { type: 'cross-circle', size: 'xs', 'aria-hidden': 'true' })
            ) : null;
            return !this.state.closed ? _react2['default'].createElement(
                'div',
                (0, _extends3['default'])({}, (0, _getDataAttr2['default'])(this.props), { className: wrapCls, onClick: this.onClick, style: style }),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-text' },
                    children
                ),
                closableDom
            ) : null;
        }
    }]);
    return Tag;
}(_react2['default'].Component);

exports['default'] = Tag;

Tag.defaultProps = {
    prefixCls: 'am-tag',
    disabled: false,
    selected: false,
    closable: false,
    small: false,
    onChange: function onChange() {},
    onClose: function onClose() {},
    afterClose: function afterClose() {}
};
module.exports = exports['default'];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(440);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Text = function (_React$Component) {
    (0, _inherits3['default'])(Text, _React$Component);

    function Text() {
        (0, _classCallCheck3['default'])(this, Text);
        return (0, _possibleConstructorReturn3['default'])(this, (Text.__proto__ || Object.getPrototypeOf(Text)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Text, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_index2['default'], this.props);
        }
    }]);
    return Text;
}(_react2['default'].Component);

exports['default'] = Text;

Text.defaultProps = {
    Component: 'span'
};
module.exports = exports['default'];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = __webpack_require__(61);

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {} /* tslint:disable:jsx-no-multiline-js */

function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}
var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\n/g;
function countSymbols() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return text.replace(regexAstralSymbols, '_').length;
}

var TextareaItem = function (_React$Component) {
    (0, _inherits3['default'])(TextareaItem, _React$Component);

    function TextareaItem(props) {
        (0, _classCallCheck3['default'])(this, TextareaItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (TextareaItem.__proto__ || Object.getPrototypeOf(TextareaItem)).call(this, props));

        _this.onChange = function (e) {
            var value = e.target.value;
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange(value);
            }
            // 设置 defaultValue 时，用户输入不会触发 componentDidUpdate ，此处手工调用
            _this.componentDidUpdate();
        };
        _this.onBlur = function (e) {
            _this.debounceTimeout = setTimeout(function () {
                if (document.activeElement !== _this.refs.textarea) {
                    _this.setState({
                        focus: false
                    });
                }
            }, 100);
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: false
                });
            }
            var value = e.target.value;
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onFocus = function (e) {
            if (_this.debounceTimeout) {
                clearTimeout(_this.debounceTimeout);
                _this.debounceTimeout = null;
            }
            if (!('focused' in _this.props)) {
                _this.setState({
                    focused: true
                });
            }
            _this.setState({
                focus: true
            });
            var value = e.target.value;
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
            if (document.activeElement.tagName.toLowerCase() === 'textarea') {
                _this.scrollIntoViewTimeout = setTimeout(function () {
                    try {
                        document.activeElement.scrollIntoViewIfNeeded();
                    } catch (e) {}
                }, 100);
            }
        };
        _this.onErrorClick = function () {
            if (_this.props.onErrorClick) {
                _this.props.onErrorClick();
            }
        };
        _this.clearInput = function () {
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
        };
        _this.state = {
            focus: false,
            focused: props.focused || false
        };
        return _this;
    }

    (0, _createClass3['default'])(TextareaItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate();
            if ((this.props.autoFocus || this.state.focused) && navigator.userAgent.indexOf('AlipayClient') > 0) {
                this.refs.textarea.focus();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.autoHeight && (this.state.focus || this.state.focused)) {
                var textareaDom = this.refs.textarea;
                textareaDom.style.height = ''; // 字数减少时能自动减小高度
                textareaDom.style.height = textareaDom.scrollHeight + 'px';
            }
            if (this.state.focused) {
                this.refs.textarea.focus();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('focused' in nextProps) {
                this.setState({
                    focused: nextProps.focused
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
            if (this.scrollIntoViewTimeout) {
                clearTimeout(this.scrollIntoViewTimeout);
                this.scrollIntoViewTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                prefixListCls = _props.prefixListCls,
                style = _props.style,
                title = _props.title,
                value = _props.value,
                defaultValue = _props.defaultValue,
                clear = _props.clear,
                editable = _props.editable,
                disabled = _props.disabled,
                error = _props.error,
                className = _props.className,
                labelNumber = _props.labelNumber,
                autoHeight = _props.autoHeight;

            var count = this.props.count;
            var rows = this.props.rows;
            // note: remove `placeholderTextColor` prop for rn TextInput supports placeholderTextColor
            var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'prefixListCls', 'editable', 'style', 'clear', 'children', 'error', 'className', 'count', 'labelNumber', 'title', 'onErrorClick', 'autoHeight', 'autoFocus', 'focused', 'placeholderTextColor']);
            var valueProps = void 0;
            if ('value' in this.props) {
                valueProps = {
                    value: fixControlledValue(value)
                };
            } else {
                valueProps = {
                    defaultValue: defaultValue
                };
            }
            var focus = this.state.focus;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixListCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-single-line', rows === 1 && !autoHeight), (0, _defineProperty3['default'])(_classNames, prefixCls + '-error', error), (0, _defineProperty3['default'])(_classNames, prefixCls + '-focus', focus), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
            var labelCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-2', labelNumber === 2), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-3', labelNumber === 3), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-4', labelNumber === 4), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-5', labelNumber === 5), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-6', labelNumber === 6), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-label-7', labelNumber === 7), _classNames2));
            var characterLength = countSymbols(value);
            var lengthCtrlProps = {};
            if (count > 0) {
                lengthCtrlProps.maxLength = count - characterLength + (value ? value.length : 0);
            }
            return _react2['default'].createElement(
                'div',
                { className: wrapCls, style: style },
                title && _react2['default'].createElement(
                    'div',
                    { className: labelCls },
                    title
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-control' },
                    _react2['default'].createElement('textarea', (0, _extends3['default'])({ ref: 'textarea' }, lengthCtrlProps, otherProps, valueProps, { onChange: this.onChange, onBlur: this.onBlur, onFocus: this.onFocus, readOnly: !editable }))
                ),
                clear && editable && value && characterLength > 0 && _react2['default'].createElement('div', { className: prefixCls + '-clear', onClick: this.clearInput, onTouchStart: this.clearInput }),
                error && _react2['default'].createElement('div', { className: prefixCls + '-error-extra', onClick: this.onErrorClick }),
                count > 0 && rows > 1 && _react2['default'].createElement(
                    'span',
                    { className: prefixCls + '-count' },
                    _react2['default'].createElement(
                        'span',
                        null,
                        value ? characterLength : 0
                    ),
                    '/',
                    count
                )
            );
        }
    }]);
    return TextareaItem;
}(_react2['default'].Component);

exports['default'] = TextareaItem;

TextareaItem.defaultProps = {
    prefixCls: 'am-textarea',
    prefixListCls: 'am-list',
    autoHeight: false,
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    rows: 1,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onErrorClick: noop,
    error: false,
    labelNumber: 5
};
module.exports = exports['default'];

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(16);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(9);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(12);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(10);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(17);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var WhiteSpace = function (_React$Component) {
    (0, _inherits3['default'])(WhiteSpace, _React$Component);

    function WhiteSpace() {
        (0, _classCallCheck3['default'])(this, WhiteSpace);
        return (0, _possibleConstructorReturn3['default'])(this, (WhiteSpace.__proto__ || Object.getPrototypeOf(WhiteSpace)).apply(this, arguments));
    }

    (0, _createClass3['default'])(WhiteSpace, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                className = _props.className,
                style = _props.style,
                onClick = _props.onClick;

            var wrapCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, '' + prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames));
            return _react2['default'].createElement('div', { className: wrapCls, style: style, onClick: onClick });
        }
    }]);
    return WhiteSpace;
}(_react2['default'].Component);

exports['default'] = WhiteSpace;

WhiteSpace.defaultProps = {
    prefixCls: 'am-whitespace',
    size: 'md'
};
module.exports = exports['default'];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(855);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldFirePress;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function PressEvent(nativeEvent) {
    var _this = this;

    this.nativeEvent = nativeEvent;
    ['type', 'currentTarget', 'target', 'touches', 'changedTouches'].forEach(function (m) {
        _this[m] = nativeEvent[m];
    });
    if (!nativeEvent.$pressSeq) {
        nativeEvent.$pressSeq = 1;
    } else {
        nativeEvent.$pressSeq += 1;
    }
    this.$pressSeq = nativeEvent.$pressSeq;
}
PressEvent.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, PressEvent.prototype, {
    preventDefault: function preventDefault() {
        this.nativeEvent.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        var nativeEvent = this.nativeEvent,
            $pressSeq = this.$pressSeq;

        if (nativeEvent.$stopPressSeq) {
            return;
        }
        nativeEvent.$stopPressSeq = $pressSeq;
    }
});
function shouldFirePress(e) {
    var nativeEvent = e.nativeEvent,
        $pressSeq = e.$pressSeq;

    if (!nativeEvent.$stopPressSeq) {
        return true;
    }
    return nativeEvent.$stopPressSeq >= $pressSeq;
}
/* harmony default export */ __webpack_exports__["a"] = (PressEvent);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(36);

var _validator = __webpack_require__(876);

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__(865);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(36);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(36);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(36);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(36);

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__(443);

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(36);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(36);

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__(884);

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__(878);

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__(879);

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__(872);

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__(882);

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__(877);

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__(875);

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__(871);

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__(880);

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__(874);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(881);

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__(873);

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__(883);

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__(885);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(56);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_AddCard_css__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_AddCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_AddCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_myCardsAction_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router__ = __webpack_require__(1);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var AddCard = function (_Component) {
  _inherits(AddCard, _Component);

  function AddCard(props) {
    _classCallCheck(this, AddCard);

    var _this = _possibleConstructorReturn(this, (AddCard.__proto__ || Object.getPrototypeOf(AddCard)).call(this, props));

    _this.state = {
      name: '',
      btnFlag: false
    };
    return _this;
  }

  _createClass(AddCard, [{
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.title = "添加银行卡";
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_js__["d" /* getStorage */])('currentUserInfo');

              case 3:
                userInfo = _context.sent;

                this.setState({
                  name: userInfo.userMsg.name,
                  mobileNo: userInfo.mobileNo
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'onChangeText',
    value: function onChangeText(e) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_publicAction__["h" /* myAddCardText */])(e.target.value));
    }
  }, {
    key: 'handleGetBankCardType',
    value: function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].loading('', 2);
                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_js__["b" /* getTempInfo */])('shortToken');

              case 3:
                _context2.t0 = _context2.sent;
                _context2.t1 = this.props.addCardText;
                params = {
                  token: _context2.t0,
                  bankCardNo: _context2.t1
                };

                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myCardsAction_js__["e" /* getBankCardType */])(params, function (content) {
                  return _this2.getBankCardTypeSuccess(content);
                }, function (msg) {
                  return _this2.getBankCardTypeError(msg);
                }));

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleGetBankCardType() {
        return _ref2.apply(this, arguments);
      }

      return handleGetBankCardType;
    }()
  }, {
    key: 'getBankCardTypeSuccess',
    value: function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(content) {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_js__["d" /* getStorage */])("currentUserInfo");

              case 2:
                data = _context3.sent;

                __WEBPACK_IMPORTED_MODULE_12_react_router__["a" /* hashHistory */].push({
                  pathname: '/AddPhone',
                  state: {
                    length: window.history.length,
                    content: content,
                    bankAccountName: data.userMsg.name,
                    certType: data.userMsg.certType,
                    certNo: data.userMsg.certNo,
                    bankAccountShowNo: this.props.addCardText,
                    cardName: content.cardName,
                    bankCode: content.bankCode,
                    fundCode: this.props.location.state.fundCode,
                    mobileNo: data.userMsg.mobileNo
                  }
                });

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getBankCardTypeSuccess(_x) {
        return _ref3.apply(this, arguments);
      }

      return getBankCardTypeSuccess;
    }()
  }, {
    key: 'getBankCardTypeError',
    value: function getBankCardTypeError(msg) {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var flag = __WEBPACK_IMPORTED_MODULE_8__util___default.a.regular1.test(this.props.addCardText);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_12_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u6DFB\u52A0\u94F6\u884C\u5361'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'share' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'shareTitle' },
              '\u8BF7\u7ED1\u5B9A\u60A8\u672C\u4EBA\u7684\u94F6\u884C\u5361'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'contentHeader', style: { borderBottom: '1px solid #eaeaea' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u6301\u5361\u4EBA'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              this.state.name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'contentHeader' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5361\u53F7'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1, textAlign: 'right' }, onChange: function onChange(e) {
                return _this3.onChangeText(e);
              }, type: 'text', value: this.props.addCardText, placeholder: '请输入卡号' })
          ),
          flag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this3.handleGetBankCardType();
              }, className: 'btn' },
            '\u4E0B\u4E00\u6B65'
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray' },
            '\u4E0B\u4E00\u6B65'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'addCard-tipBox' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6E29\u99A8\u63D0\u793A :'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5982\u679C\u60A8\u7684\u94F6\u884C\u5361\u662F\u7531\u4EA4\u901A\u94F6\u884C\u3001\u6D66\u53D1\u94F6\u884C\u3001\u5E73\u5B89\u94F6\u884C\u6216\u90AE\u50A8\u94F6\u884C\u53D1\u884C\u7684\u3002\u60A8\u9700\u8981\u5148\u901A\u8FC7\u7535\u8111\u8BBF\u95EE\u94F6\u8054\u5B98\u7F51\u5F00\u901A\u8BE5\u5361\u7684\u94F6\u8054\u5728\u7EBF\u652F\u4ED8\uFF0C\u7F51\u5740\uFF1Ahttps://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay\u3002\u5F00\u901A\u6210\u529F\u540E\uFF0C\u518D\u901A\u8FC7APP\u7ED1\u5B9A\u8BE5\u7C7B\u94F6\u884C\u5361\u5373\u53EF\u3002\u4E3A\u6B64\u9020\u6210\u7684\u4E0D\u4FBF\uFF0C\u656C\u8BF7\u8C05\u89E3\u3002'
            )
          )
        )
      );
    }
  }]);

  return AddCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    addCardText: state.addCardText
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(AddCard));

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_myCardsAction_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_publicAction__ = __webpack_require__(81);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var wrapProps = void 0;

var AddPhone = function (_Component) {
  _inherits(AddPhone, _Component);

  function AddPhone(props) {
    _classCallCheck(this, AddPhone);

    var _this = _possibleConstructorReturn(this, (AddPhone.__proto__ || Object.getPrototypeOf(AddPhone)).call(this, props));

    _this.showActionSheet = function () {
      var arr = _this.state.bankListName;
      var BUTTONS = arr;
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["ActionSheet"].showActionSheetWithOptions({
        options: BUTTONS,
        cancelButtonIndex: BUTTONS.length - 1,
        // title: '标题',
        message: '银行卡列表',
        maskClosable: true,
        'data-seed': 'logId',
        wrapProps: wrapProps
      }, function (buttonIndex) {
        if (buttonIndex == -1 || buttonIndex == arr.length - 1) {
          return;
        }
        _this.setState({ bankName: BUTTONS[buttonIndex] });
        _this.setState({
          paymentChannelId: _this.state.bankList[buttonIndex].paymentChannelId,
          paymentChannelName: _this.state.bankList[buttonIndex].paymentChannelName
        });
      });
    };

    _this.sure = function () {
      var _this$state = _this.state,
          text = _this$state.text,
          paymentChannelId = _this$state.paymentChannelId;
      var addPhoneText = _this.props.addPhoneText;
      var _this$props$location$ = _this.props.location.state,
          bankAccountName = _this$props$location$.bankAccountName,
          bankAccountShowNo = _this$props$location$.bankAccountShowNo,
          certNo = _this$props$location$.certNo;

      var regPhone = /^1[0123456789]\d{9}$/;
      if (!regPhone.test(addPhoneText)) {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("手机号有误，请重新输入", __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading('', 2);
      // if(!paymentChannelId) {
      //  Toast.info( "未自动获取到所属银行，请手动选择",Util.ToastTime );
      //  return ;
      // }
      // this.props.location.state.navigator.push({
      //   component: VerifyDynamicCode,
      //   params: {
      //     mobileNo: mobileNo,
      //     bankAccountName: bankAccountName,
      //     certType: this.props.certType,
      //     certNo: this.props.certNo,
      //     bankAccountShowNo: bankAccountShowNo,
      //     bankCode: this.props.bankCode,
      //     bankName: this.state.bankName,
      //     trustChannelId: this.state.paymentChannelId,
      //     route: this.props.route,
      //     refreshPage: this.props.refreshPage,
      //   }
      // })
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: '/Verification',
        state: {
          length: _this.props.location.state.length,
          content: _this.props.location.state.content,
          mobileNo: _this.props.addPhoneText,
          bankAccountName: _this.props.location.state.bankAccountName,
          certType: _this.props.location.state.certType,
          certNo: _this.props.location.state.certNo,
          bankAccountShowNo: _this.props.location.state.bankAccountShowNo,
          cardName: _this.props.location.state.cardName,
          bankCode: _this.props.location.state.bankCode,
          trustChannelId: _this.state.paymentChannelId,
          fundCode: _this.props.location.state.fundCode,
          bankProtocolVersion: _this.state.agreementValue.bankProtocolVersion,
          upProtocolVersion: _this.state.agreementValue.upProtocolVersion
        }
      });
      _this.setState({ agreeIndex: 0 });
    };

    _this.state = {
      agreeIndex: 0,
      btnFlag: false,
      text: '',
      paymentChannelId: '',
      bankList: '',
      bankListName: [],
      paymentChannelName: '',
      bankName: '',
      showSelectBankArrow: false,
      clicked: '',
      verificationCodeBool: false,
      agreementValue: ''
    };
    return _this;
  }

  _createClass(AddPhone, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "添加银行卡";
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_publicAction__["g" /* myAddPhoneText */])(this.props.location.state.mobileNo));
      this.toGetBankList();
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["ActionSheet"].close();
    }
  }, {
    key: 'toGetBankList',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_js__["b" /* getTempInfo */])('shortToken');

              case 2:
                _context.t0 = _context.sent;
                params = {
                  token: _context.t0
                };

                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_myCardsAction_js__["d" /* getBankList */])(params, function (content) {
                  return _this2.getBankListSuccess(content);
                }, function (msg) {
                  return _this2.getBankListError(msg);
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toGetBankList() {
        return _ref.apply(this, arguments);
      }

      return toGetBankList;
    }()
  }, {
    key: 'getBankListSuccess',
    value: function getBankListSuccess(content) {
      this.setState({ loadingFlag: false });
      var bankListName = [];
      for (var i = 0; i < content.length; i++) {
        bankListName.push(content[i].paymentChannelName);
      }
      bankListName.push('取消');
      this.setState({
        bankList: content,
        bankListName: bankListName
      });
      this.toGetPaymentChannelId();
    }
  }, {
    key: 'getBankListError',
    value: function getBankListError(msg) {
      this.setState({ loadingFlag: false });
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
    }
  }, {
    key: 'toGetPaymentChannelId',
    value: function toGetPaymentChannelId() {
      var bankList = this.state.bankList;

      for (var i = 0; i < bankList.length; i++) {
        if (bankList[i].bankCode == this.props.location.state.bankCode) {
          this.setState({
            paymentChannelId: bankList[i].paymentChannelId,
            paymentChannelName: bankList[i].paymentChannelName,
            bankName: bankList[i].paymentChannelName
          });
          return;
        }
      }
      // Toast.show('未自动获取到所属银行，请手动选择', getToastConfPoint());
      // this.setState({downUpListShow: true});
      this.setState({ showSelectBankArrow: true });
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ verificationCodeBool: true });
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(e) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_publicAction__["g" /* myAddPhoneText */])(e.target.value));
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var _state = this.state,
          agreeIndex = _state.agreeIndex,
          text = _state.text;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
      } else {
        this.setState({
          agreeIndex: 0
        });
      }
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name, value) {
      var code = __WEBPACK_IMPORTED_MODULE_5__BankCode__["a" /* protocolCode */][name];
      if (code) {
        __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
          pathname: '/WebView',
          state: { name: name, code: code },
          query: { code: code }
        });
      } else {
        var newName = name.substring(1, name.length - 1);
        __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
          pathname: '/WebView',
          state: { name: newName, webViewHtml: value == 'bankProtocolName' ? this.state.agreementValue.bankProtocolUrl : this.state.agreementValue.upProtocolUrl },
          query: { code: code }
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_js__["b" /* getTempInfo */])("shortToken");

              case 2:
                _context2.t0 = _context2.sent;
                _context2.t1 = this.props.location.state.bankAccountShowNo;
                params = {
                  token: _context2.t0,
                  bankAccountNo: _context2.t1
                };

                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_myCardsAction_js__["a" /* getBankProtocollnfoList */])(params, function (value) {
                  _this3.setState({ agreementValue: value });
                }, function (message) {
                  __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(message, __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
                }));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      var flag = __WEBPACK_IMPORTED_MODULE_6__util___default.a.regular1.test(this.props.addPhoneText);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u6DFB\u52A0\u94F6\u884C\u5361'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { WebkitFlex: 1, overflow: "auto" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'share' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'shareTitle' },
                '\u8BF7\u7ED1\u5B9A\u60A8\u672C\u4EBA\u7684\u94F6\u884C\u5361'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: this.showActionSheet, className: 'contentHeader', style: { borderBottom: '1px solid #eaeaea' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { width: '1.5rem' } },
                '\u5361\u7C7B\u578B'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { WebkitFlex: 1 } },
                this.state.bankName || !this.state.bankName == '取消' ? this.state.bankName : '请选择所属银行',
                ' '
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'contentHeader' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { width: '1.5rem' } },
                '\u624B\u673A\u53F7'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1 }, onChange: function onChange(e) {
                  return _this4.onChangeText(e);
                }, type: 'text', value: this.props.addPhoneText, placeholder: '请输入银行预留手机号' })
            ),
            flag && this.state.paymentChannelId && this.state.agreementValue ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this4.next();
                }, className: 'btn' },
              '\u4E0B\u4E00\u6B65'
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'btn btn-gray' },
              '\u4E0B\u4E00\u6B65'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'addCard-tipBox' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                '\u6E29\u99A8\u63D0\u793A :'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                '\u5982\u679C\u60A8\u7684\u94F6\u884C\u5361\u662F\u7531\u4EA4\u901A\u94F6\u884C\u3001\u6D66\u53D1\u94F6\u884C\u3001\u5E73\u5B89\u94F6\u884C\u6216\u90AE\u50A8\u94F6\u884C\u53D1\u884C\u7684\u3002\u60A8\u9700\u8981\u5148\u901A\u8FC7\u7535\u8111\u8BBF\u95EE\u94F6\u8054\u5B98\u7F51\u5F00\u901A\u8BE5\u5361\u7684\u94F6\u8054\u5728\u7EBF\u652F\u4ED8\uFF0C\u7F51\u5740\uFF1Ahttps://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay\u3002\u5F00\u901A\u6210\u529F\u540E\uFF0C\u518D\u901A\u8FC7APP\u7ED1\u5B9A\u8BE5\u7C7B\u94F6\u884C\u5361\u5373\u53EF\u3002\u4E3A\u6B64\u9020\u6210\u7684\u4E0D\u4FBF\uFF0C\u656C\u8BF7\u8C05\u89E3\u3002'
              )
            )
          )
        ),
        this.state.verificationCodeBool ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u6E29\u99A8\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20, fontSize: '0.28rem' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: img_arr[this.state.agreeIndex], className: 'imgBtn', style: { marginTop: '-0.35rem' }, onClick: function onClick() {
                  return _this4.isAgreeClick();
                } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { lineHeight: '0.35rem' } },
                '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { color: "#fa063a" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('上海华夏财富投资管理有限公司快易付业务协议', '');
                    } },
                  '\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u5FEB\u6613\u4ED8\u4E1A\u52A1\u534F\u8BAE\u300B'
                ),
                '\u3001',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { color: "#fa063a" }, onClick: function onClick() {
                      return _this4.ProtocolPaper(_this4.state.agreementValue.bankProtocolName, 'bankProtocolName');
                    } },
                  this.state.agreementValue.bankProtocolName
                ),
                '\u3001',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { color: "#fa063a" }, onClick: function onClick() {
                      return _this4.ProtocolPaper(_this4.state.agreementValue.upProtocolName, 'upProtocolName');
                    } },
                  this.state.agreementValue.upProtocolName
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this4.setState({ verificationCodeBool: false, agreeIndex: 0 });
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u53D6\u6D88'
                )
              ),
              this.state.agreeIndex == 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.sure, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u540C\u610F\u5E76\u7EE7\u7EED'
                )
              ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("请先阅读并确认协议", __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#ccc", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u540C\u610F\u5E76\u7EE7\u7EED'
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return AddPhone;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    addPhoneText: state.addPhoneText
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(AddPhone));

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NullView = function (_Component) {
	_inherits(NullView, _Component);

	function NullView() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, NullView);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NullView.__proto__ || Object.getPrototypeOf(NullView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			moveX: 0,
			moveY: 0,
			startX: 0,
			startY: 0,
			endX: 0,
			endY: 0
		}, _this.touchStart = function (event) {
			_this.setState({
				startX: event.changedTouches[0].pageX,
				startY: event.changedTouches[0].pageY
			});
		}, _this.touchMove = function (event) {
			var moveX = event.changedTouches[0].pageX - _this.state.startX + _this.state.endX;
			var moveY = event.changedTouches[0].pageY - _this.state.startY + _this.state.endY;
			if (moveX >= 0 && moveX <= window.winWidth - 50) {
				_this.setState({
					moveX: moveX
				});
			}
			if (moveY >= 0 && moveY <= window.winHeight - 50) {
				_this.setState({
					moveY: moveY
				});
			}
		}, _this.touchEnd = function (event) {
			_this.setState({
				endX: _this.state.moveX,
				endY: _this.state.moveY
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(NullView, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			document.addEventListener("touchmove", function (event) {
				event.preventDefault();
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    moveX = _state.moveX,
			    moveY = _state.moveY;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ style: { width: "100%", height: "100%", background: "#fff", position: "relative", overflow: "hidden" } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onTouchEnd: this.touchEnd, onTouchStart: this.touchStart, onTouchMove: this.touchMove, style: { width: 50, height: 50, background: "red", position: "absolute", left: moveX, top: moveY } })
			);
		}
	}]);

	return NullView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NullView);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(13);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var wrapProps = void 0;

var ErrorPage = function (_Component) {
  _inherits(ErrorPage, _Component);

  function ErrorPage(props) {
    _classCallCheck(this, ErrorPage);

    var _this2 = _possibleConstructorReturn(this, (ErrorPage.__proto__ || Object.getPrototypeOf(ErrorPage)).call(this, props));

    _this2.showActionSheet = function () {
      var BUTTONS = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { style: { color: '#111111' }, href: 'tel:4008175666' },
        '\u547C\u53EB400-817-5666'
      ), '取消'];
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["ActionSheet"].showActionSheetWithOptions({
        options: BUTTONS,
        cancelButtonIndex: BUTTONS.length - 1,
        destructiveButtonIndex: BUTTONS.length - 2,
        // title: '标题',
        message: '周一至周五08：30-17：00',
        maskClosable: true,
        'data-seed': 'logId',
        wrapProps: wrapProps
      }, function (buttonIndex) {
        _this2.setState({ clicked: BUTTONS[buttonIndex] });
      });
    };

    _this2.state = {
      clicked: 'none'
    };
    return _this2;
  }

  _createClass(ErrorPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = this.props.location.state.title;
    }
  }, {
    key: 'next',
    value: function next(name) {
      if (name === '查看我的智投' || name === '返回智投首页') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name === '返回华夏智投') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name === '联系客服') {
        this.showActionSheet();
      } else if (name === '完成') {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].replace({
          pathname: '/SubscriptionDetail?enterType=SubscriptionDetail'
        });
        // hashHistory.push({
        //   pathname: '/nullView',
        // });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.props.location.state.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'success-box' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(653), style: { width: '1.24rem', height: '1.24rem' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { marginTop: '0.2rem' } },
              this.props.location.state.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { marginTop: '0.2rem', fontSize: 13, color: '#5b6370', lineHeihgt: 18 } },
              this.props.location.state.content2
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: '100%', marginTop: 30 } },
              this.props.location.state.dataSouse.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: 'cq' + i, className: 'success-bar' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    item[0]
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    item[1]
                  )
                );
              })
            )
          ),
          this.props.location.state.souseVal.map(function (item, i) {
            if (i == 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'bt' + i, onClick: function onClick() {
                    return _this3.next(item);
                  }, className: 'btn' },
                item
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'bt' + i, onClick: function onClick() {
                    return _this3.next(item);
                  }, className: 'btn btn-white' },
                item
              );
            }
          })
        )
      );
    }
  }]);

  return ErrorPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ErrorPage));

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infoTable_css__ = __webpack_require__(2143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__infoTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__infoTable_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var InfoTable = function (_Component) {
  _inherits(InfoTable, _Component);

  function InfoTable(props) {
    _classCallCheck(this, InfoTable);

    var _this = _possibleConstructorReturn(this, (InfoTable.__proto__ || Object.getPrototypeOf(InfoTable)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(InfoTable, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$dataSouse = _props.dataSouse,
          dataSouse = _props$dataSouse === undefined ? [] : _props$dataSouse,
          _props$cols = _props.cols,
          cols = _props$cols === undefined ? 3 : _props$cols,
          className = _props.className,
          itemClassName = _props.itemClassName,
          _props$valueStyle = _props.valueStyle,
          valueStyle = _props$valueStyle === undefined ? {} : _props$valueStyle;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "InfoTable_container " + className },
        dataSouse.map(function (item, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoRow, { key: index, className: "Row_distance", cols: cols, dataRow: item, itemClassName: itemClassName, valueStyle: valueStyle });
        })
      );
    }
  }]);

  return InfoTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InfoTable));

var InfoRow = function (_Component2) {
  _inherits(InfoRow, _Component2);

  function InfoRow(props) {
    _classCallCheck(this, InfoRow);

    var _this2 = _possibleConstructorReturn(this, (InfoRow.__proto__ || Object.getPrototypeOf(InfoRow)).call(this, props));

    _this2.getColor = function (value, key) {
      var noColor = ["运行周期", "运作起始日期"];
      var green = ['近一年最大回撤', '组合最大回撤'];
      if (noColor.includes(key) || value === '--') return "#333";
      if (green.includes(key)) return '#1DA96B';
      if (value.replace("%", "") >= 0) return "#F8515C";
      return "#1DA96B";
    };

    _this2.state = {};
    return _this2;
  }

  _createClass(InfoRow, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          cols = _props2.cols,
          _props2$dataRow = _props2.dataRow,
          dataRow = _props2$dataRow === undefined ? [] : _props2$dataRow,
          className = _props2.className,
          itemClassName = _props2.itemClassName,
          valueStyle = _props2.valueStyle;

      console.log('valueStyle', valueStyle);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "InfoRow_container  " + className },
        dataRow.map(function (item, index) {
          var value = item[0] || '--';
          var key = item[1];
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { key: index, className: "InfoRow_item" + cols + " " + itemClassName, style: { width: "calc(100% / " + cols + ")" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "InfoRow_value", style: Object.assign({ color: _this3.getColor(value, key) }, valueStyle) },
              value
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "InfoRow_tip" },
              key
            )
          );
        })
      );
    }
  }]);

  return InfoRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal_ModalSelectTip__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_riskInPayAction_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var width = window.screen.width;

var ua = navigator.userAgent.toLowerCase();

function getQueryUrlFun(variable) {
  var _url = window.location.href;
  if (_url && _url.split("#/").length == 2 && _url.split("#/")[1] === "") {
    _url = _url.split("#/")[0];
  }
  if (_url.indexOf("?") != -1) {
    var query = _url.split("?")[1];
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return 9999;
  } else {
    return 9999;
  }
}
window.setCookie = function (name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
};

var Investment = function (_Component) {
  _inherits(Investment, _Component);

  function Investment(props) {
    var _this2 = this;

    _classCallCheck(this, Investment);

    var _this = _possibleConstructorReturn(this, (Investment.__proto__ || Object.getPrototypeOf(Investment)).call(this, props));

    _this.chooseDataFun = function (arr) {
      var _count = false;
      if (arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
            _count = true;
            break;
          }
          if (arr[i].superFundList && arr[i].superFundList.length > 0) {
            _count = true;
            break;
          }
        }
      }
      return _count;
    };

    _this.chooseDataSecFun = function (arr) {
      if (arr && arr.length === 0 || !arr) {
        return true;
      } else {
        var _count = true;
        if (arr && arr.length > 0) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
              _count = false;
              break;
            }
            if (arr[i].superFundList && arr[i].superFundList.length > 0) {
              _count = false;
              break;
            }
          }
        }
        return _count;
      }
    };

    _this.sessionKyc = function () {
      var loadSourceBySup = sessionStorage.getItem('loadSourceBySup');
      var loadSourceByZt = sessionStorage.getItem('loadSourceByZt');
      if ((loadSourceBySup == "全部" || loadSourceBySup == "部分") && loadSourceByZt !== "true") {
        // Toast.loading();
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_67" /* getSuperFundSeriesFun */])({}, function (suc) {
          console.log(suc);
          if (suc && suc.content) {
            // Toast.hide();
            if (loadSourceBySup == "全部") {
              if (_this.chooseDataFun(suc.content.allSuperFundSeries)) {
                _this.setState({
                  seriesId: suc.content.allSuperFundSeries && suc.content.allSuperFundSeries.length > 0 ? suc.content.allSuperFundSeries[0].seriesId : "",
                  seriesName: suc.content.allSuperFundSeries && suc.content.allSuperFundSeries.length > 0 ? suc.content.allSuperFundSeries[0].seriesName : "",
                  mateFundList: suc.content.allSuperFundSeries ? suc.content.allSuperFundSeries : []
                }, function () {
                  _this.setState({
                    showHidePlanFlag: false,
                    showFundFlag: true
                  });
                });
              }
            } else {
              if (_this.chooseDataFun(suc.content.riskMatchSuperFundSeries)) {
                _this.setState({
                  mateFundList: suc.content.riskMatchSuperFundSeries ? suc.content.riskMatchSuperFundSeries : [],
                  seriesId: suc.content.riskMatchSuperFundSeries && suc.content.riskMatchSuperFundSeries.length > 0 ? suc.content.riskMatchSuperFundSeries[0].seriesId : "",
                  seriesName: suc.content.riskMatchSuperFundSeries && suc.content.riskMatchSuperFundSeries.length > 0 ? suc.content.riskMatchSuperFundSeries[0].seriesName : ""
                }, function () {
                  _this.setState({
                    showHidePlanFlag: false,
                    showFundFlag: true
                  });
                });
              }
            }
          } else {
            // Toast.hide();
          }
        }));
      } else {
        if (loadSourceByZt === "true") {
          _this.goResultFun(false);
          sessionStorage.setItem('loadSourceByZt', "false");
        }
      }
    };

    _this.showHidePlan = function () {
      _this.setState({
        showHidePlanFlag: !_this.state.showHidePlanFlag
      });
    };

    _this.showRiskMakeFunFir = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_riskInPayAction_js__["c" /* traceSave */])({ action: 'SF_SPECIAL_TIP', message: '用户查看部分智投产品时间: ' + new Date().toLocaleString() }));
      if (_this.chooseDataSecFun(_this.state.partMateStrategyList)) {
        _this.setState({
          riskModalFir: false,
          riskMakeSecFlag: true
        });
      } else {
        _this.showAllFundListFir(true, _this.state.partMateStrategyList, "部分");
      }
    };

    _this.resetRiskFun = function () {
      _this.setState({
        riskMakeFlag: false
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */], window.history.length, function () {});
    };

    _this.showAllFundListFir = function (flag, data, name) {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_riskInPayAction_js__["c" /* traceSave */])({ action: 'SF_SPECIAL_TIP', message: '用户查看全部智投产品时间: ' + new Date().toLocaleString() }));
      if (flag === true) {
        _this.setState({
          riskModalFir: false
        });
      }
      if (_this.chooseDataFun(data)) {
        var tabListArr = [];
        for (var i = 0; i < _this.state.sceneVoList.length; i++) {
          var _count = 0;
          var _countSec = 0;
          for (var s = 0; s < data.length; s++) {
            if (data[s].superFundProductViewList && data[s].superFundProductViewList.length > 0) {
              _countSec = _countSec - 0 + 1;
              if (_this.state.sceneVoList[i].sceneId != data[s].sceneId) {
                _count = _count - 0 + 1;
              }
            }
          }
          if (_count == _countSec && _count > 0) {
            tabListArr.push(_this.state.sceneVoList[i].sceneName);
          }
        }
        console.log(tabListArr);
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: '/MakePlanResult',
          state: {
            fundListArr: data,
            tabListArr: tabListArr,
            lookFlag: name,
            rootPath: "Investment"
          }
        });
      }
    };

    _this.goToMakePlan = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var flagDigital, _currentUserInfo, isMiniProgram, didQuestionnairs, currentUserInfo;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].loading();
              _context.next = 3;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('loginState');

            case 3:
              flagDigital = _context.sent;
              _context.next = 6;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('currentUserInfo');

            case 6:
              _currentUserInfo = _context.sent;

              console.log(flagDigital, _currentUserInfo);

              if (!(flagDigital != '0' && !_currentUserInfo.isRealName)) {
                _context.next = 12;
                break;
              }

              isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_14__guidePage_index_js__["a" /* GuidePageType */].OpenAccount);

              if (!isMiniProgram) {
                _context.next = 12;
                break;
              }

              return _context.abrupt('return');

            case 12:
              if (!(flagDigital == '1')) {
                _context.next = 19;
                break;
              }

              //实名认证
              _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["b" /* clearSmrzOne */])());
              __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
              __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                pathname: '/CertificationUpload',
                state: {
                  route: window.history.length,
                  phoneNo: _currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
                  callback: ua.indexOf("amcfmapp") > -1 ? function () {
                    _this.goToMakePlan();
                  } : null
                }
              });
              return _context.abrupt('return');

            case 19:
              if (!(flagDigital == '3')) {
                _context.next = 25;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
              //同步开户
              __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                pathname: '/BindingMobile',
                state: { route: window.history.length, callback: function callback() {
                    _this.goToMakePlan();
                  } }
              });
              return _context.abrupt('return');

            case 25:
              if (!(flagDigital == '0')) {
                _context.next = 31;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
              __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                pathname: ua.indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
                state: { route: window.history.length, callback: ua.indexOf("amcfmapp") > -1 ? function () {
                    _this.goToMakePlan();
                  } : null }
              });
              return _context.abrupt('return');

            case 31:
              __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
              didQuestionnairs = false;
              _context.prev = 33;
              _context.next = 36;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["o" /* judgeQuestionnaires */])();

            case 36:
              didQuestionnairs = _context.sent;
              _context.next = 42;
              break;

            case 39:
              _context.prev = 39;
              _context.t0 = _context['catch'](33);
              return _context.abrupt('return');

            case 42:
              if (didQuestionnairs) {
                _context.next = 45;
                break;
              }

              _this.setState({
                questionModal: true
              });
              return _context.abrupt('return');

            case 45:
              _context.next = 47;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('currentUserInfo');

            case 47:
              currentUserInfo = _context.sent;

              console.log(currentUserInfo);
              if (currentUserInfo && currentUserInfo.userMsg) {
                __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                  pathname: '/MakePlanDetail',
                  state: {
                    certNo: currentUserInfo.userMsg.certType === "0" && currentUserInfo.userMsg.certNo ? currentUserInfo.userMsg.certNo : ""
                  }
                });
              }

            case 50:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[33, 39]]);
    }));
    _this.isExpiredByInvestmentFun = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _func, flagDigital;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _func = function _func() {
                _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_68" /* isExpiredByInvestment */])({}, function (res) {
                  console.log(res);
                  _this.setState({
                    ifMakePlan: res.content.planed,
                    isAnswerState: res.content.expried,
                    userAnswerList: []
                  });
                  if (res.content.questionnaire && res.content.questionnaire.questionList && res.content.questionnaire.questionList.length > 0) {
                    var dataSource = [].concat(res.content.questionnaire.questionList);
                    var newDataSource = [].concat(_this.state.userAnswerList);
                    for (var i = 0; i < dataSource.length; i++) {
                      var _title = dataSource[i].content;
                      var _order = dataSource[i].order;
                      var _content = "";
                      if (dataSource[i].order == "1") {
                        _content = dataSource[i].userOption ? new Date().getFullYear() - dataSource[i].userOption : "";
                      }
                      if (dataSource[i].order == "2") {
                        var newData = [];
                        for (var s = 0; s < dataSource[i].optionList.length; s++) {
                          if (dataSource[i].userOption.indexOf(dataSource[i].optionList[s].order) != -1) {
                            newData.push({
                              flag: true,
                              content: dataSource[i].optionList[s].content
                            });
                          } else {
                            newData.push({
                              flag: false,
                              content: dataSource[i].optionList[s].content
                            });
                          }
                        }
                        _content = newData;
                      }
                      // if(dataSource[i].order == "3") {
                      //   for(let s = 0; s < dataSource[i].optionList.length; s++) {
                      //     if(dataSource[i].userOption == dataSource[i].optionList[s].order) {
                      //       _content = dataSource[i].optionList[s].content == "是" ? true : false;
                      //     }
                      //   }
                      // }
                      // newDataSource.push({
                      //   order: _order,
                      //   title: _title,
                      //   content: _content
                      // });
                      if (dataSource[i].order != "3") {
                        newDataSource.push({
                          order: _order,
                          title: _title,
                          content: _content
                        });
                      }
                    }
                    console.log(newDataSource);
                    _this.setState({
                      userAnswerList: newDataSource
                    });
                  }
                }));
              };

              if (!(ua.indexOf("amcfmapp") > -1)) {
                _context2.next = 5;
                break;
              }

              _func();
              _context2.next = 9;
              break;

            case 5:
              _context2.next = 7;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('loginState');

            case 7:
              flagDigital = _context2.sent;

              if (flagDigital == '0') {} else {
                _func();
              }

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.goResultFun = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(val) {
        var flagDigital, _currentUserInfo, isMiniProgram, didQuestionnairs;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].loading();
                _context3.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('loginState');

              case 3:
                flagDigital = _context3.sent;
                _context3.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('currentUserInfo');

              case 6:
                _currentUserInfo = _context3.sent;

                console.log(flagDigital, _currentUserInfo);

                if (!(flagDigital != '0' && !_currentUserInfo.isRealName)) {
                  _context3.next = 12;
                  break;
                }

                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_14__guidePage_index_js__["a" /* GuidePageType */].OpenAccount);

                if (!isMiniProgram) {
                  _context3.next = 12;
                  break;
                }

                return _context3.abrupt('return');

              case 12:
                if (!(flagDigital == '1')) {
                  _context3.next = 19;
                  break;
                }

                //实名认证
                _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["b" /* clearSmrzOne */])());
                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                  pathname: '/CertificationUpload',
                  state: {
                    route: window.history.length,
                    phoneNo: _currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
                    callback: ua.indexOf("amcfmapp") > -1 ? function () {
                      _this.goResultFun(val);
                    } : null
                  }
                });
                return _context3.abrupt('return');

              case 19:
                if (!(flagDigital == '3')) {
                  _context3.next = 25;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                //同步开户
                __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                  pathname: '/BindingMobile',
                  state: { route: window.history.length, callback: function callback() {
                      _this.goResultFun(val);
                    } }
                });
                return _context3.abrupt('return');

              case 25:
                if (!(flagDigital == '0')) {
                  _context3.next = 31;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
                  pathname: ua.indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
                  state: { route: window.history.length, callback: ua.indexOf("amcfmapp") > -1 ? function () {
                      _this.goResultFun(val);
                    } : null }
                });
                return _context3.abrupt('return');

              case 31:
                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                didQuestionnairs = false;
                _context3.prev = 33;
                _context3.next = 36;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["o" /* judgeQuestionnaires */])();

              case 36:
                didQuestionnairs = _context3.sent;
                _context3.next = 42;
                break;

              case 39:
                _context3.prev = 39;
                _context3.t0 = _context3['catch'](33);
                return _context3.abrupt('return');

              case 42:
                if (didQuestionnairs) {
                  _context3.next = 45;
                  break;
                }

                _this.setState({
                  questionModal: true
                });
                return _context3.abrupt('return');

              case 45:
                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].loading();
                if (val === true) {
                  _this.setState({
                    allStrategyList: [],
                    partMateStrategyList: [],
                    sceneVoList: []
                  });
                  _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_69" /* getRcommendStrategy */])({}, function (suc) {
                    console.log(suc);
                    if (suc && suc.content) {
                      __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                      _this.setState({
                        sceneVoList: suc.content.sceneVoList
                      }, function () {
                        if (suc.content.mateAll === true) {
                          if (_this.chooseDataSecFun(suc.content.allStrategyList)) {
                            _this.setState({
                              nothingFlagFir: true
                            });
                          } else {
                            //匹配直接跳转
                            _this.showAllFundListFir(false, suc.content.allStrategyList ? suc.content.allStrategyList : [], "全部");
                          }
                        } else {
                          //不匹配 一个也没有
                          if (_this.chooseDataSecFun(suc.content.allStrategyList)) {
                            _this.setState({
                              nothingFlagFir: true
                            });
                          } else {
                            _this.setState({
                              riskModalFir: true,
                              allStrategyList: suc.content.allStrategyList ? suc.content.allStrategyList : [],
                              partMateStrategyList: suc.content.partMateStrategyList ? suc.content.partMateStrategyList : []
                            });
                          }
                        }
                      });
                    } else {
                      __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                    }
                  }));
                } else {
                  _this.setState({
                    allSuperFundSeries: [],
                    riskMatchSuperFundSeries: []
                  });
                  _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_67" /* getSuperFundSeriesFun */])({}, function (suc) {
                    console.log(suc);
                    if (suc && suc.content) {
                      __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                      if (suc.content.mateAll === true) {
                        if (_this.chooseDataSecFun(suc.content.allSuperFundSeries)) {
                          _this.setState({
                            nothingFlagSec: true
                          });
                        } else {
                          //匹配直接跳转
                          _this.showAllFundListSec(suc.content.allSuperFundSeries ? suc.content.allSuperFundSeries : []);
                        }
                      } else {
                        //不匹配 一个也没有
                        if (_this.chooseDataSecFun(suc.content.allSuperFundSeries)) {
                          _this.setState({
                            nothingFlagSec: true
                          });
                        } else {
                          _this.setState({
                            riskModalSec: true,
                            allSuperFundSeries: suc.content.allSuperFundSeries ? suc.content.allSuperFundSeries : [],
                            riskMatchSuperFundSeries: suc.content.riskMatchSuperFundSeries ? suc.content.riskMatchSuperFundSeries : []
                          });
                        }
                      }
                    } else {
                      __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                    }
                  }));
                }

              case 47:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[33, 39]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.showRiskMakeFunSec = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_riskInPayAction_js__["c" /* traceSave */])({ action: 'SF_SPECIAL_TIP', message: '用户查看部分智投产品时间: ' + new Date().toLocaleString() }));
      if (_this.chooseDataSecFun(_this.state.riskMatchSuperFundSeries)) {
        _this.setState({
          riskModalSec: false,
          riskMakeFlag: true
        });
      } else {
        _this.setState({
          mateFundList: _this.state.riskMatchSuperFundSeries,
          seriesId: _this.state.riskMatchSuperFundSeries.length > 0 ? _this.state.riskMatchSuperFundSeries[0].seriesId : "",
          seriesName: _this.state.riskMatchSuperFundSeries.length > 0 ? _this.state.riskMatchSuperFundSeries[0].seriesName : ""
        }, function () {
          if (_this.chooseDataFun(_this.state.riskMatchSuperFundSeries)) {
            _this.setState({
              riskModalSec: false,
              showHidePlanFlag: false,
              showFundFlag: true
            });
            sessionStorage.setItem('loadSourceBySup', "部分");
          }
        });
      }
    };

    _this.showAllFundListSec = function (data) {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_riskInPayAction_js__["c" /* traceSave */])({ action: 'SF_SPECIAL_TIP', message: '用户查看全部智投产品时间: ' + new Date().toLocaleString() }));
      _this.setState({
        allSuperFundSeries: data ? data : _this.state.allSuperFundSeries,
        mateFundList: data ? data : _this.state.allSuperFundSeries,
        seriesId: data && data.length > 0 ? data[0].seriesId : _this.state.allSuperFundSeries.length > 0 ? _this.state.allSuperFundSeries[0].seriesId : "",
        seriesName: data && data.length > 0 ? data[0].seriesName : _this.state.allSuperFundSeries.length > 0 ? _this.state.allSuperFundSeries[0].seriesName : "",
        riskModalSec: false
      }, function () {
        if (data) {
          if (_this.chooseDataFun(data)) {
            _this.setState({
              riskModalSec: false,
              showHidePlanFlag: false,
              showFundFlag: true
            });
            sessionStorage.setItem('loadSourceBySup', "全部");
          }
        } else {
          if (_this.chooseDataFun(_this.state.allSuperFundSeries)) {
            _this.setState({
              riskModalSec: false,
              showHidePlanFlag: false,
              showFundFlag: true
            });
            sessionStorage.setItem('loadSourceBySup', "全部");
          }
        }
      });
    };

    _this.ckTab = function (id, name) {
      _this.setState({
        seriesId: id,
        seriesName: name
      });
    };

    _this.investNotDetil = function (data) {
      if (ua.indexOf("amcfmapp") > -1) {
        // window.location.href = "http://mtest.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode;//测试
        if (data.superFundCode == 'SF1022') {
          window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/touguDetailPage/index.html?fundCode=" + data.superFundCode; //生产
        } else {
          window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode; //生产
        }
        return;
      }
      var pathName = "/SuperFundDetail";
      if (data.fundType === "1") {
        pathName = '/TargetProfitDetail';
      } else {
        pathName = '/SuperFundDetail';
      }

      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
        pathname: pathName,
        state: { superFundName: data.superFundName, superFundCode: data.superFundCode },
        query: { superFundName: data.superFundName, superFundCode: data.superFundCode }
      });
    };

    _this.showModalXiaoai = function () {
      _this.setState({
        modalXai: true
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
    };

    _this.closeModalXai = function () {
      _this.setState({
        modalXai: false
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", _this.touchMove, false);
    };

    _this.hideQuestionModal = function () {
      _this.setState({
        questionModal: false
      });
    };

    _this.quertionModalFun = function () {
      _this.setState({
        questionModal: false
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */], window.history.length, function () {});
    };

    _this.hideRiskMakeFlagFun = function () {
      _this.setState({
        riskMakeFlag: false
      });
    };

    _this.state = {
      arr: [],
      localStorage: '没有登录',
      oldlocalStorage: JSON.stringify(window.localStorage),
      dataSouse: '接口',
      hideFlag: false,
      upgradeFlag: true,
      disupgradeFlag: false,
      disAgreeAlertFlag: false,
      sqAlerFlag: true,
      upgradeList: [],
      upgradeListAll: [],
      firstFlag: false,
      ifMakePlan: false, //是否做了规划
      isAnswerState: false, //题目、答案是否变更
      showHidePlanFlag: true, //默认展开
      riskModalFir: false, //风险提示
      riskModalSec: false, //风险提示
      riskMakeFlag: false, // 重新测评
      showFundFlag: false, //显示基金列表
      userAnswerList: [], //用户规划答案
      allStrategyList: [],
      partMateStrategyList: [],
      riskMatchSuperFundSeries: [],
      allSuperFundSeries: [],
      mateFundList: [],
      nothingFlagFir: false,
      nothingFlagSec: false,
      sceneVoList: [],
      seriesId: "",
      seriesName: "",
      modalXai: false,
      riskMakeSecFlag: false,
      questionModal: false,
      // thisText: "",
      flag: navigator.userAgent.toLowerCase()
    };
    return _this;
  }

  _createClass(Investment, [{
    key: 'componentWillMount',
    value: function () {
      var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this3 = this;

        var dispatch, isFirst, amcuid, amcuid2, stoken, localStorage_token;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // let a = Util.return_Clinet_Type();
                // console.log(a);
                sessionStorage.setItem('home_url', window.location.hash);
                window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "进入查理智投"]);
                dispatch = this.props.dispatch;

                document.title = "华夏查理智投";

                if (!(ua.indexOf("amcfmapp") > -1)) {
                  _context4.next = 23;
                  break;
                }

                isFirst = window.sessionStorage.getItem('no-first'); //重启打开app第一次进入智投，第一次进入清空localStorage缓存，并更改sessStorage进入状态

                if (isFirst) {} else {
                  window.clearLocalStorage();
                  // Toast.info('第一次进入,清空缓存');
                  window.sessionStorage.setItem('no-first', true);
                }
                amcuid = getQueryUrlFun("data");
                _context4.next = 10;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])("amcuid2");

              case 10:
                amcuid2 = _context4.sent;
                stoken = getQueryUrlFun("appId");
                // setTimeout(() => {
                //   this.setState({
                //     thisText: "URL: " +  window.location.href + "data: " + amcuid + ", appId: " + stoken + ", cookie: " + document.cookie + ", uaNav: " + ua
                //   });
                // }, 2000)

                if (!(amcuid == amcuid2)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 15;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["d" /* getStorage */])('loginInfo-longToken');

              case 15:
                localStorage_token = _context4.sent;

                if (localStorage_token != 9999) {
                  // alert('同一个账户有长token');
                  // this.setState({
                  //   localStorage:JSON.stringify(window.localStorage),
                  // })
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {
                    _this3.haveFund(data);
                    _this3.isExpiredByInvestmentFun();
                  }, this));
                } else {
                  if (amcuid != 9999) {
                    // alert('同一个账户没有长token，且外部登录')
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_70" /* getwebLogin */])({
                      data: amcuid,
                      appId: stoken
                    }, function (result) {
                      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* setStorage */])('amcuid2', amcuid);
                      // this.setState({
                      //   dataSouse:JSON.stringify(result),
                      //   localStorage:JSON.stringify(window.localStorage),
                      // })
                      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {
                        _this3.haveFund(data);
                      }, _this3));
                      _this3.isExpiredByInvestmentFun();
                    }));
                  }
                }
                _context4.next = 21;
                break;

              case 19:
                //不是同一个账户，有amcuid获取接口，没有代表未登录
                window.clearLocalStorage();
                if (amcuid != 9999) {
                  // alert('不是同一个账户，外部登录')
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_70" /* getwebLogin */])({
                    data: amcuid,
                    appId: stoken
                  }, function (result) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common__["a" /* setStorage */])('amcuid2', amcuid);
                    // this.setState({
                    //     dataSouse:JSON.stringify(result),
                    //     localStorage:JSON.stringify(window.localStorage),
                    //   })
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {
                      _this3.haveFund(data);
                    }, _this3));
                    _this3.isExpiredByInvestmentFun();
                  }));
                }

              case 21:
                _context4.next = 24;
                break;

              case 23:
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {
                  _this3.haveFund(data);
                  _this3.isExpiredByInvestmentFun();
                }, this));

              case 24:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentWillMount() {
        return _ref4.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'haveFund',
    value: function () {
      var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(SupperFundHome) {
        var _this4 = this;

        var arr, getTimeFlag, d, AccAgreementStatus, nextDay, _nextDay, _AccAgreementStatus;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // this.setState({
                //   dataSouse:JSON.stringify(SupperFundHome)
                // })
                arr = [];

                if (!SupperFundHome) {
                  _context5.next = 32;
                  break;
                }

                if (!SupperFundHome.singleSuperFundViews) {
                  _context5.next = 32;
                  break;
                }

                SupperFundHome.singleSuperFundViews.map(function (item, key) {
                  arr.push(item.superFundCode);
                });
                _context5.prev = 4;
                getTimeFlag = window.localStorage.getItem("TimeTagQy");

                if (!getTimeFlag) {
                  _context5.next = 18;
                  break;
                }

                d = new Date();

                if (!(d.getTime() > getTimeFlag)) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 11;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["p" /* querySuperFundAccAgreementStatus */])();

              case 11:
                AccAgreementStatus = _context5.sent;

                console.log(AccAgreementStatus, "AccAgreementStatusAccAgreementStatus");
                if (AccAgreementStatus === null || AccAgreementStatus === '') {
                  this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_71" /* superFundAccAgreementState */])(true));
                }
                nextDay = new Date(new Date().setHours(0, 0, 0, 0)) / 1000 + 86400;

                window.localStorage.setItem("TimeTagQy", nextDay * 1000);

              case 16:
                _context5.next = 25;
                break;

              case 18:

                // 记录次日0点时间戳
                _nextDay = new Date(new Date().setHours(0, 0, 0, 0)) / 1000 + 86400;

                window.localStorage.setItem("TimeTagQy", _nextDay * 1000);
                _context5.next = 22;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["p" /* querySuperFundAccAgreementStatus */])();

              case 22:
                _AccAgreementStatus = _context5.sent;

                console.log(_AccAgreementStatus, "AccAgreementStatusAccAgreementStatus");
                if (_AccAgreementStatus === null || _AccAgreementStatus.state === '0') {
                  this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_71" /* superFundAccAgreementState */])(true));
                }

              case 25:
                __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
                _context5.next = 31;
                break;

              case 28:
                _context5.prev = 28;
                _context5.t0 = _context5['catch'](4);

                console.log(_context5.t0);

              case 31:
                //获取智投组合可转换
                try {
                  this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["c" /* querySuperFundAccAgreement */])({}, function (res) {
                    console.log(res);
                  }));
                  this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_72" /* querySuperfundUpdateList */])(function (res) {
                    var arr = [];
                    for (var i = 0; i < res.length; i++) {
                      arr.push(res[i].superFundName);
                    }
                    _this4.setState({
                      upgradeList: arr,
                      upgradeListAll: res
                    });
                    console.log(res);
                    if (res.length > 0) {
                      console.log('弹升级窗');
                      var upgradeTime = window.localStorage.getItem("UpgradeTime");
                      if (upgradeTime) {
                        console.log('已存过时间');
                        var _d = new Date();
                        if (_d.getTime() > upgradeTime) {
                          _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_73" /* upgradeControl */])(true));
                        } else {
                          _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_73" /* upgradeControl */])(false));
                        }
                      } else {
                        console.log('没存时间，首次弹');
                        _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_73" /* upgradeControl */])(true));
                      }
                    } else {
                      _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_73" /* upgradeControl */])(false));
                      console.log('不弹升级');
                    }
                  }));
                } catch (err) {
                  console.log(err);
                }

              case 32:
                this.setState({
                  arr: arr
                });

              case 33:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 28]]);
      }));

      function haveFund(_x2) {
        return _ref5.apply(this, arguments);
      }

      return haveFund;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref6 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data, zhongXin;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.props.location.query.inviteCode) {
                  window.localStorage.setItem("inviteCode", this.props.location.query.inviteCode);
                }
                data = {
                  superFundCode: "SF1015"
                };
                zhongXin = sessionStorage.getItem('home_url');

                if (sessionStorage.getItem('first_enter') == null && zhongXin && zhongXin.indexOf('venderType') > -1) {
                  this.setState({
                    firstFlag: true
                  });
                }
                //kyc缓存基金列表
                this.sessionKyc();
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["K" /* smSzt */])(0));

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function componentDidMount() {
        return _ref6.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "离开查理智投"]);
    }
  }, {
    key: 'goSuperFundList',
    value: function goSuperFundList() {
      if (ua.indexOf("amcfmapp") > -1) {
        return;
      }
      window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "点击智投总金额"]);
      var data = this.props.SupperFundHome.singleSuperFundViews;
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
        pathname: '/SuperFundList',
        state: { name: '调整组合', type: 1, data: data },
        query: { code: '' }
      });
    }
    // goTransitRecords(){
    //   window._czc.push(["_trackEvent", "华夏财富H5", "查理智投", "点击再涂资金"]);
    //   hashHistory.push({
    //     pathname: "/TransitRecords"
    //   })
    // }

  }, {
    key: 'handleDisagree',
    value: function handleDisagree() {
      // Toast.hide();
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_71" /* superFundAccAgreementState */])(false));
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction__["a" /* myInvestmentList */])({ code: '', message: '', content: { records: [] } }));
      this.setState({
        disAgreeAlertFlag: true
        // sqAlerFlag:false
      });
    }
  }, {
    key: 'handleArgee',
    value: function handleArgee() {
      var _this5 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_71" /* superFundAccAgreementState */])(false));
      // this.props.dispatch(myInvestmentList({code:'',message:'',content:{records:[]}} ))
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_74" /* signSuperFundAccAgreement */])({ state: 1, operator: "user" }, function (res) {
        console.log(res, "签约回调");
        _this5.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["c" /* querySuperFundAccAgreement */])());
        // this.setState({
        //   agreeAlertFlag:true
        // })
      }));
    }
    //   //知道了
    //  closeAgreeAlert(){
    //     this.setState({
    //       agreeAlertFlag:false
    //     })
    // }
    //二级不同意签约

  }, {
    key: 'closeDisAgreeAlert',
    value: function closeDisAgreeAlert() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_71" /* superFundAccAgreementState */])(false));
      this.setState({
        disAgreeAlertFlag: false
      });
    }
  }, {
    key: 'callBackQy',
    value: function callBackQy() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_71" /* superFundAccAgreementState */])(true));
      this.setState({ sqAlerFlag: true, disAgreeAlertFlag: false });
    }
    /*立即升级 */

  }, {
    key: 'pushUpdate',
    value: function pushUpdate() {
      var upgradeListAll = this.state.upgradeListAll;

      var superFundCode = upgradeListAll[0].superFundCode;
      var targetFundList = upgradeListAll[0].targetFundList;
      var amount = upgradeListAll[0].totalAmount;
      console.log(targetFundList, "targetFundList", amount);

      var fun = function fun() {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].loading();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["q" /* hasConvertingTrade */])({
          superFundCode: superFundCode
        }, function () {
          __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
        }, function () {
          __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
        }).then(function (suc) {
          if (suc === true) {
            __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].show('当前智投组合有转换在途交易，该操作暂停', __WEBPACK_IMPORTED_MODULE_3__util___default.a.ToastTime);
            return;
          }

          __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
            pathname: '/TransferF',
            state: {
              type: 1, //调整组合,
              targetFundList: targetFundList,
              amount: amount,
              superFundCode: superFundCode
            },
            query: {
              targetFundList: targetFundList,
              amount: amount,
              superFundCode: superFundCode
            }
          });
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
          return;
        });
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["a" /* goLogin */])(fun, window.history.length);
    }
    /* 暂不升级*/

  }, {
    key: 'handleCancleUpgrade',
    value: function handleCancleUpgrade() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_73" /* upgradeControl */])(false));
      this.setState({
        disupgradeFlag: true
        // upgradeFlag:false
      });
    }
    /*返回升级页面 */

  }, {
    key: 'handleBackUpgrade',
    value: function handleBackUpgrade() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_73" /* upgradeControl */])(true));
      this.setState({
        disupgradeFlag: false
      });
    }
    /** 挽留不同意 */

  }, {
    key: 'handleNoUpgrade',
    value: function handleNoUpgrade() {
      // 记录次日0点时间戳
      var nextDay = new Date(new Date().setHours(0, 0, 0, 0)) / 1000 + 86400;
      window.localStorage.setItem("UpgradeTime", nextDay * 1000);
      this.setState({
        disupgradeFlag: false
      });
    }
  }, {
    key: 'RiskTest',
    value: function RiskTest() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
        pathname: '/ChooseGh'
      });
    }
  }, {
    key: 'pushInvestmentPlan',
    value: function pushInvestmentPlan() {
      window.location.href = "https://www.amcfortune.com/minipage/zdt/app/index.html";
    }
  }, {
    key: 'pushZTJS',
    value: function pushZTJS() {
      // window.location.href = "https://app.amcfortune.com/wAppStatic/h5/video.html";
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
        pathname: '/Understand'
      });
    }
  }, {
    key: 'pushWz',
    value: function pushWz() {
      // hashHistory.push({
      //   pathname:'/iframeWeb',
      //   query:{
      //     url:'https://wx.xinmeikuang.com/start/huaxia/h5/20190531/index'
      //   }
      // })
      window.location.href = "https://wx.xinmeikuang.com/start/huaxia/h5/20190531/index";
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props = this.props,
          SupperFundHome = _props.SupperFundHome,
          superFundAccAgreementState = _props.superFundAccAgreementState,
          inInvestmentList = _props.inInvestmentList;
      var _state = this.state,
          hideFlag = _state.hideFlag,
          upgradeList = _state.upgradeList,
          upgradeListAll = _state.upgradeListAll;


      console.log(this.props.inInvestmentList, '***inInvestmentListinInvestmentListinInvestmentList');
      // SupperFundHome = tempData.content;
      var dataViews = SupperFundHome ? SupperFundHome : [];
      var SuperList = SupperFundHome ? SupperFundHome.singleSuperFundViews ? SupperFundHome.singleSuperFundViews : [] : [];
      var haveSF = SupperFundHome ? SupperFundHome.singleSuperFundViews != null ? true : false : false;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { id: 'InvestmentIndex', style: { display: 'flex', flex: 1, overflowY: 'scroll', flexDirection: 'column', alignItems: 'center' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { backgroundImage: 'url(' + __webpack_require__(1899) + ')', backgroundSize: "cover", width: window.winWidth, paddingRight: 20, paddingLeft: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: this.state.flag.indexOf("miniprogram") != -1 ? 33 : 66, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "flex-end" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 24, color: "#333", fontWeight: 500 } },
                '\u534E\u590F\u67E5\u7406\u667A\u6295'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 12, color: "#333" } },
                '\u61C2\u6295\u8D44'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { style: { width: 2, height: 2, background: "#F92C3D", marginLeft: 6, marginRight: 6 } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 12, color: "#333" } },
                '\u66F4\u61C2\u4F60'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.showModalXiaoai, src: __webpack_require__(1903), style: { width: 18, height: 18, marginLeft: 4 } })
            )
          ),
          haveSF ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { marginTop: 10, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", width: window.winWidth - 40, paddingTop: 15, paddingBottom: 15, paddingRight: 15, paddingLeft: 15, backgroundColor: "#fff", borderRadius: 4 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#999" } },
                  '\u667A\u6295\u603B\u8D44\u4EA7\uFF08\u5143\uFF09'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.goSuperFundList();
                  },
                  style: { marginTop: 8, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "flex-end" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 20, color: "#333", fontWeight: 400 } },
                  SupperFundHome && SupperFundHome.totalAssets ? __WEBPACK_IMPORTED_MODULE_3__util___default.a.parsePrice(SupperFundHome.totalAssets.toString().split(".")[0], true) : "--"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#333", fontWeight: 400 } },
                  SupperFundHome && SupperFundHome.totalAssets ? SupperFundHome.totalAssets.toString().split(".").length == 2 ? "." + SupperFundHome.totalAssets.toFixed(2).toString().split(".")[1] : ".00" : ""
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginTop: 12, backgroundColor: "#F5F5F5", width: window.winWidth - 70, borderRadius: 2, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, paddingRight: 15, display: "-webkit-flex", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlex: 4, WebkitFlexDirection: "column" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "#999", fontSize: 12 } },
                    '\u6700\u65B0\u6536\u76CA (',
                    SupperFundHome.deadLine ? SupperFundHome.deadLine : "--",
                    ')'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: SupperFundHome && SupperFundHome.dayIncome ? SupperFundHome.dayIncome > 0 ? "#F92C3D" : "#1EB872" : "#F92C3D", fontSize: 14, fontWeight: 400, marginTop: 5 } },
                    SupperFundHome && SupperFundHome.dayIncome ? SupperFundHome.dayIncome > 0 ? "+" + __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(SupperFundHome.dayIncome) : __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(SupperFundHome.dayIncome) : "--"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlex: 3, WebkitFlexDirection: "column" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "#999", fontSize: 12 } },
                    '\u7D2F\u8BA1\u6536\u76CA (\u5143)'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: SupperFundHome && SupperFundHome.allIncome ? SupperFundHome.allIncome > 0 ? "#F92C3D" : "#1EB872" : "#F92C3D", fontSize: 14, fontWeight: 400, marginTop: 5 } },
                    SupperFundHome && SupperFundHome.allIncome ? SupperFundHome.allIncome > 0 ? "+" + __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(SupperFundHome.allIncome) : __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(SupperFundHome.allIncome) : "--"
                  )
                )
              )
            ),
            ua.indexOf("amcfmapp") > -1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 40 } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "transparent", width: window.winWidth - 40, marginTop: 25, borderRadius: 4, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.pushZTJS();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(698), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u79D2\u61C2\u667A\u6295'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.pushInvestmentPlan();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(699), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u667A\u6167\u5B9A\u6295'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.RiskTest();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(697), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u8D22\u52A1\u89C4\u5212'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.pushWz();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(696), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u67E5\u7406\u8D22\u5546\u8BFE'
                )
              )
            )
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingTop: 10 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(391), style: { width: 12.8, height: 13 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#666", marginLeft: 4 } },
                  '\u667A\u80FD\u914D\u7F6E'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginLeft: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(391), style: { width: 12.8, height: 13 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#666", marginLeft: 4 } },
                  '\u7701\u5FC3\u6295\u8D44'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginLeft: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(391), style: { width: 12.8, height: 13 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#666", marginLeft: 4 } },
                  '\u7A33\u5065\u7406\u8D22'
                )
              )
            ),
            ua.indexOf("amcfmapp") > -1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 115 } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#fff", height: 86, width: window.winWidth - 40, marginTop: 20, borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20, marginBottom: 10 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.pushZTJS();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(698), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u79D2\u61C2\u667A\u6295'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.pushInvestmentPlan();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(699), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u667A\u6167\u5B9A\u6295'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.RiskTest();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(697), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u8D22\u52A1\u89C4\u5212'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                {
                  href: "javascript:void(0)",
                  onClick: function onClick() {
                    _this6.pushWz();
                  },
                  style: { display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(696), style: { width: 32, height: 32 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#333", marginTop: 5 } },
                  '\u67E5\u7406\u8D22\u5546\u8BFE'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: "-webkit-flex", marginTop: ua.indexOf("amcfmapp") > -1 && haveSF ? 0 : ua.indexOf("amcfmapp") > -1 && !haveSF ? -80 : 20, height: 40, alignSelf: 'flex-start', marginLeft: 20, alignItems: 'center' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { style: { fontSize: 18, color: "#27282F", fontWeight: 500 } },
            '\u5F00\u59CB\u4F60\u7684\u89C4\u5212'
          )
        ),
        this.state.ifMakePlan && !this.state.isAnswerState ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { backgroundImage: 'url(' + __webpack_require__(700) + ')', backgroundSize: "cover", width: window.winWidth - 40, minHeight: 200, paddingRight: 15, paddingLeft: 15, paddingTop: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 16, color: "#2C3245", fontWeight: 500 } },
              '\u4E0D\u540C\u4EBA\u751F\u9636\u6BB5\u7684\u53EF\u80FD\u6295\u8D44\u9700\u6C42'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(701), style: { width: 28, height: 28 } })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 12, color: "#868DA0", lineHeight: "17px" } },
              '\u6211\u4EEC\u5C06\u57FA\u4E8E\u751F\u547D\u5468\u671F\u7406\u8BBA\uFF0C\u6839\u636E\u60A8\u586B\u5199\u7684\u9700\u6C42\uFF0C\u7ED3\u5408\u60A8\u6240\u5904\u7684\u4EBA\u751F\u9636\u6BB5\uFF0C\u4E3A\u60A8\u89C4\u5212\u5408\u9002\u7684\u6295\u8D44\u65B9\u6848'
            )
          ),
          this.state.userAnswerList.length > 0 && this.state.showHidePlanFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginTop: 15, width: window.winWidth - 70, backgroundColor: "#fff", paddingTop: 10, paddingBottom: 15, paddingLeft: 15, paddingRight: 15, borderRadius: 2 } },
            this.state.userAnswerList.map(function (data, index) {
              if (data.order == "1") {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: index + "_" + data.order, style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 12, color: "#666" } },
                    '\u60A8\u5F53\u524D\u7684\u6295\u8D44\u9700\u6C42'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 12, color: "#666" } },
                    '\u5E74\u9F84\uFF1A',
                    data.content,
                    '\u5C81'
                  )
                );
              }
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { backgroundColor: "#EFF0F4", height: 1, width: window.winWidth - 100, marginTop: 15 } }),
            this.state.userAnswerList.map(function (data, index) {
              if (data.order == "2") {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: index + "_" + data.order },
                  data.content.map(function (dataSec, indexSec) {
                    if (dataSec.flag) {
                      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: index + "_" + data.order + "_" + indexSec, style: { marginTop: indexSec === 0 ? 10 : 14 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", width: "max-content", backgroundColor: "rgba(255, 214, 217, 0.3)", height: 15, borderTopRightRadius: 100, borderTopLeftRadius: 100, borderBottomLeftRadius: 100 } },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1892), style: { width: 12, height: 12 } }),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { style: { fontSize: 10, color: "#F92C3D", fontWeight: 500, marginLeft: 3 } },
                            dataSec.content.split("：")[0],
                            '\uFF1A'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { style: { fontSize: 12, color: "#333", lineHeight: "17px", marginTop: 2 } },
                            dataSec.content.split("：")[1]
                          )
                        )
                      );
                    } else {
                      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { key: index + "_" + data.order + "_" + indexSec, style: { marginTop: indexSec === 0 ? 10 : 14 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", width: "max-content", backgroundColor: "rgba(230, 230, 230, 0.3)", height: 15, borderTopRightRadius: 100, borderTopLeftRadius: 100, borderBottomLeftRadius: 100 } },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { width: 12, height: 12, backgroundColor: "#EEEEEE", borderRadius: 100 } }),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'span',
                            { style: { fontSize: 10, color: "#999", fontWeight: 500, marginLeft: 3 } },
                            dataSec.content.split("：")[0],
                            '\uFF1A'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          null,
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { style: { fontSize: 12, color: "#999", lineHeight: "17px", marginTop: 2 } },
                            dataSec.content.split("：")[1]
                          )
                        )
                      );
                    }
                  })
                );
              }
            })
          ) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingTop: 20, WebkitFlexDirection: "row", paddingBottom: 15 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: this.goToMakePlan, style: { width: 122, height: 32, backgroundColor: "transparent", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#F92C3D" } },
                '\u91CD\u65B0\u89C4\u5212'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  _this6.goResultFun(true);
                }, style: { marginLeft: 20, width: 122, height: 32, backgroundColor: "#F92C3D", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#fff" } },
                '\u67E5\u770B\u7ED3\u679C'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginBottom: 20, width: window.winWidth - 70, textAlign: "center" }, onClick: this.showHidePlan },
            this.state.showHidePlanFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(703), style: { width: 14, height: 14 } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(392), style: { width: 14, height: 14 } })
          )
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { backgroundImage: 'url(' + __webpack_require__(700) + ')', backgroundSize: "cover", width: window.winWidth - 40, minHeight: 200, paddingRight: 15, paddingLeft: 15, paddingTop: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between", WebkitAlignItems: "center" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 16, color: "#2C3245", fontWeight: 500 } },
              '\u4E0D\u540C\u4EBA\u751F\u9636\u6BB5\u7684\u53EF\u80FD\u6295\u8D44\u9700\u6C42'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(701), style: { width: 28, height: 28 } })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 12, color: "#868DA0", lineHeight: "17px" } },
              '\u6211\u4EEC\u5C06\u57FA\u4E8E\u751F\u547D\u5468\u671F\u7406\u8BBA\uFF0C\u6839\u636E\u60A8\u586B\u5199\u7684\u9700\u6C42\uFF0C\u7ED3\u5408\u60A8\u6240\u5904\u7684\u4EBA\u751F\u9636\u6BB5\uFF0C\u4E3A\u60A8\u89C4\u5212\u5408\u9002\u7684\u6295\u8D44\u65B9\u6848'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            this.state.showHidePlanFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitFlexWrap: "wrap", WebkitJustifyContent: 'space-between', marginTop: 15 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { borderRadius: 2, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15 } },
                  '\u8D22\u5BCC\u6210\u957F'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1895), style: { width: 44, height: 44 } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { borderRadius: 2, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15 } },
                  '\u8D44\u4EA7\u4FDD\u503C'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1896), style: { width: 44, height: 44 } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { borderRadius: 2, marginTop: 10, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15 } },
                  '\u517B\u8001\u50A8\u84C4'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1897), style: { width: 44, height: 44 } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { borderRadius: 2, marginTop: 10, backgroundColor: "#fff", WebkitAlignItems: "flex-start", width: (window.winWidth - 80) / 2, height: 64, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#333", marginLeft: 15, marginTop: 15 } },
                  '\u5B50\u5973\u6559\u80B2'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1898), style: { width: 44, height: 44 } })
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingTop: 26, WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.goToMakePlan, style: { width: 122, height: 32, backgroundColor: "#F92C3D", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u5F00\u542F\u89C4\u5212'
                )
              ),
              this.state.isAnswerState ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginTop: 15 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 12, color: "#7F8BA3" } },
                  '\u4E3A\u63D0\u4F9B\u66F4\u4F18\u8D28\u670D\u52A1\uFF0C\u6295\u987E\u5347\u7EA7\uFF0C\u8BF7\u91CD\u65B0\u89C4\u5212'
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginTop: 15, marginBottom: 20, width: window.winWidth - 70, textAlign: "center" }, onClick: this.showHidePlan },
                this.state.showHidePlanFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(703), style: { width: 14, height: 14 } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(392), style: { width: 14, height: 14 } })
              )
            )
          )
        ),
        this.state.showFundFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth - 40, marginTop: 30, backgroundColor: "#FFF6F6", paddingLeft: 8, paddingRight: 15, paddingTop: 8, paddingBottom: 8, borderRadius: 4, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "flex-start" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1900), style: { width: 17, height: 18 } }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { style: { fontSize: 12, color: "#333", lineHeight: "20px", marginLeft: 2 } },
            '\u60A8\u5BF9\u672C\u6B21\u6295\u8D44\u6709\u8F83\u4E3A\u660E\u786E\u7684\u76EE\u6807\uFF0C\u534E\u590F\u8D22\u5BCC\u4E3A\u60A8\u63D0\u4F9B\u5982\u4E0B\u57FA\u91D1\u6295\u987E\u7EC4\u5408\uFF0C\u60A8\u53EF\u81EA\u4E3B\u9009\u62E9\u3002'
          )
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { paddingBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this6.goResultFun(false);
              }, style: { boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", width: window.winWidth - 40, height: 50, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#fff", WebkitFlexDirection: "row", borderRadius: 4, marginTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 14, color: "#2C3245" } },
              '\u6211\u6709\u660E\u786E\u6295\u8D44\u76EE\u6807\uFF0C\u5E0C\u671B\u76F4\u63A5\u6311\u9009\u7EC4\u5408'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(777), style: { width: 16, height: 16, marginLeft: 5 } })
          )
        ),
        this.state.showFundFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { paddingLeft: 20, paddingRight: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: window.winWidth - 40, overflowX: "auto" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingTop: 15 } },
              this.state.mateFundList.map(function (data, index) {
                if (data.superFundList && data.superFundList.length > 0) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        _this6.ckTab(data.seriesId, data.seriesName);
                      }, key: index, style: { height: 30, backgroundColor: _this6.state.seriesId == data.seriesId ? "#FFE9EB" : "#F3F3F3", paddingLeft: 10, paddingRight: 10, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderRadius: 15, whiteSpace: "pre", marginLeft: index === 0 ? 0 : 10 } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      { style: { fontSize: 14, color: _this6.state.seriesId == data.seriesId ? "#F92C3D" : "#666" } },
                      data.seriesName
                    )
                  );
                }
              })
            )
          ),
          this.state.mateFundList.map(function (data, index) {
            if (data.superFundList && data.superFundList.length > 0 && data.seriesId == _this6.state.seriesId) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: index, style: { paddingTop: 20, display: "-webkit-flex", width: window.winWidth - 40, WebkitJustifyContent: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { position: "relative", backgroundColor: "#fff", borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", paddingTop: 15, paddingBottom: 15, paddingLeft: 15, paddingRight: 15, width: window.winWidth - 40, minHeight: 178.78 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      { style: { fontSize: 16, color: "#2C3245", fontWeight: 500 } },
                      data.seriesName
                    )
                  ),
                  data.superFundList.map(function (dataSec, indexSec) {
                    var colorSyl = "#F92C3D";
                    if (dataSec.fullOneYear) {
                      if (__WEBPACK_IMPORTED_MODULE_3__util___default.a.returnEmpty(dataSec.rate, "%") == "--%") {
                        colorSyl = "#333";
                      } else {
                        if (dataSec.rate < 0) {
                          colorSyl = "rgba(54, 169, 99, 1)";
                        } else {
                          colorSyl = "#F92C3D";
                        }
                      }
                    } else {
                      colorSyl = "#333";
                    }
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { onClick: function onClick() {
                          _this6.investNotDetil(dataSec);
                        }, key: indexSec + "_" + data.seriesId },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { paddingTop: 20 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          { style: { fontSize: 14, color: "#333" } },
                          dataSec.superFundName
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { marginTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row" } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column" } },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { style: { fontSize: 18, color: colorSyl, fontWeight: 400, lineHeight: '20px' } },
                            dataSec.fullOneYear ? __WEBPACK_IMPORTED_MODULE_3__util___default.a.returnEmpty(dataSec.rate, "%") : "--%"
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { style: { fontSize: 11, color: "#666", marginTop: 5 } },
                            ua.indexOf("amcfmapp") > -1 ? "成立以来年化涨跌幅" : dataSec.rateTypeName
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column" } },
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { style: { fontSize: 18, color: "#333", fontWeight: 400, lineHeight: '20px' } },
                            dataSec.holdTime
                          ),
                          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { style: { fontSize: 11, color: "#666", marginTop: 5 } },
                            dataSec.hold
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { marginTop: 10, backgroundColor: "#F5F5F5", paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10, borderRadius: 2 } },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'p',
                          { style: { fontSize: 11, color: "#666" } },
                          '\u7279\u70B9\uFF1A',
                          dataSec.feature
                        )
                      ),
                      data.superFundList.length - 1 === indexSec ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { marginTop: 20, backgroundColor: "#EFF0F4", height: 1, width: window.winWidth - 40 } })
                    );
                  })
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index });
            }
          })
        ) : null,
        this.state.showFundFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, paddingLeft: 20, paddingRight: 20, paddingTop: 20, paddingBottom: 40, backgroundColor: "#F8F8F8", marginTop: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { style: { fontSize: 12, color: "#999", lineHeight: "17px" } },
            '\u4EE5\u4E0A\u5185\u5BB9\u4EC5\u7528\u4F5C\u4E86\u89E3\u60A8\u7684\u6295\u8D44\u76EE\u6807\uFF0C\u4E0D\u5BF9\u6295\u987E\u7B56\u7565\u7684\u6536\u76CA\u53CA\u56DE\u64A4\u63A7\u5236\u6709\u4EFB\u4F55\u4FDD\u8BC1\u3002\u6210\u7ACB\u4EE5\u6765\u5E74\u5316\u6536\u76CA\u7B49\u5386\u53F2\u4E1A\u7EE9\u4EC5\u4F5C\u4E3A\u53C2\u8003\uFF0C\u4E0D\u9884\u793A\u7EC4\u5408\u672A\u6765\u8868\u73B0\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\uFF1B\u6295\u8D44\u8005\u81EA\u4E3B\u9009\u62E9\u6295\u987E\u7EC4\u5408\uFF0C\u627F\u62C5\u5E02\u573A\u6CE2\u52A8\u5E26\u6765\u7684\u635F\u5931\uFF1B\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002'
          )
        ) : null,
        this.state.riskModalFir ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u4E3A\u60A8\u89C4\u5212\u7684\u65B9\u6848\u4E2D\u90E8\u5206\u4EA7\u54C1\u7684\u98CE\u9669\u7B49\u7EA7\u4E0E\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E0D\u7B26\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u5168\u90E8\u67E5\u770B'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.showRiskMakeFunFir, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u90E8\u5206\u67E5\u770B'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.showAllFundListFir(true, _this6.state.allStrategyList, "全部");
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u5168\u90E8\u67E5\u770B'
                )
              )
            )
          )
        ) : null,
        this.state.riskModalSec ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u90E8\u5206\u4EA7\u54C1\u7684\u98CE\u9669\u7B49\u7EA7\u4E0E\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E0D\u7B26\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u5168\u90E8\u67E5\u770B'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.showRiskMakeFunSec, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u90E8\u5206\u67E5\u770B'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this6.showAllFundListSec("");
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u5168\u90E8\u67E5\u770B'
                )
              )
            )
          )
        ) : null,
        this.state.riskMakeFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5C0A\u656C\u7684\u7528\u6237\uFF0C\u60A8\u9009\u62E9\u4E86\u90E8\u5206\u67E5\u770B\uFF0C\u5DF2\u4E3A\u60A8\u5C4F\u853D\u6389\u98CE\u9669\u4E0D\u5339\u914D\u7684\u7EC4\u5408\u7B56\u7565\uFF0C\u5C4F\u853D\u540E\uFF0C\u6682\u65E0\u5339\u914D\u60A8\u9700\u6C42\u7684\u6295\u987E\u7EC4\u5408\u3002\u5982\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u91CD\u65B0\u8FDB\u884C\u98CE\u9669\u6D4B\u8BC4\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.hideRiskMakeFlagFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u53D6\u6D88'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.resetRiskFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u91CD\u65B0\u6D4B\u8BC4'
                )
              )
            )
          )
        ) : null,
        this.state.nothingFlagFir ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5C0A\u656C\u7684\u7528\u6237\uFF0C\u57FA\u4E8E\u60A8\u7684\u9700\u6C42\uFF0C\u6682\u672A\u80FD\u4E3A\u60A8\u5339\u914D\u51FA\u6295\u987E\u7EC4\u5408\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.goToMakePlan, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u91CD\u65B0\u89C4\u5212'
                )
              )
            )
          )
        ) : null,
        this.state.riskMakeSecFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5C0A\u656C\u7684\u7528\u6237\uFF0C\u60A8\u9009\u62E9\u4E86\u90E8\u5206\u67E5\u770B\uFF0C\u5DF2\u4E3A\u60A8\u5C4F\u853D\u6389\u98CE\u9669\u4E0D\u5339\u914D\u7684\u7EC4\u5408\u7B56\u7565\uFF0C\u5C4F\u853D\u540E\uFF0C\u6682\u65E0\u5339\u914D\u60A8\u9700\u6C42\u7684\u6295\u987E\u7EC4\u5408\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.goToMakePlan, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u91CD\u65B0\u89C4\u5212'
                )
              )
            )
          )
        ) : null,
        this.state.nothingFlagSec ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5C0A\u656C\u7684\u7528\u6237\uFF0C\u57FA\u4E8E\u60A8\u7684\u9700\u6C42\uFF0C\u6682\u672A\u80FD\u4E3A\u60A8\u5339\u914D\u51FA\u6295\u987E\u7EC4\u5408\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.resetRiskFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u91CD\u65B0\u6D4B\u8BC4'
                )
              )
            )
          )
        ) : null,
        this.state.questionModal ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5F53\u524D\u60A8\u8FD8\u672A\u8FDB\u884C\u98CE\u9669\u6D4B\u8BC4\u6216\u98CE\u9669\u6D4B\u8BC4\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u60A8\u5B8C\u6210\u6D4B\u8BC4\u540E\u518D\u7EE7\u7EED\u64CD\u4F5C\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.hideQuestionModal, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u6682\u4E0D\u6D4B\u8BC4'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.quertionModalFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u98CE\u9669\u6D4B\u8BC4'
                )
              )
            )
          )
        ) : null,
        this.state.modalXai ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20, fontWeight: "500" } },
                "华夏查理智投依托于华夏财富多年的投顾服务经验，基于您在不同人生阶段的财富目标，通过智能化的算法模型为您匹配定制化财富管理方案，一站式满足您的资产保值、财富成长、品质养老、子女教育等场景需求。"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20, fontWeight: "500" } },
                "我们希望通过专业化、场景化的基金投顾服务，帮助您降低筛选基金的门槛，并通过全程暖心陪伴服务，帮助您坚定地长期持有，将优选基金的业绩转化为您的实际回报，让您在投资过程中更省心、更安心。"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.closeModalXai, style: { width: "100%", height: "40px", textAlign: "center", lineHeight: "40px", borderTopColor: "#ebeef0", borderTopWidth: "1px", borderTopStyle: "solid", marginTop: "15px" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 17, color: '#666666' } },
                    '\u77E5\u9053\u4E86'
                  )
                )
              )
            )
          )
        ) : null,
        superFundAccAgreementState || inInvestmentList.content.records.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__["c" /* AlerModleQy */], { handleClick1: this.handleArgee.bind(this), handleClick2: this.handleDisagree.bind(this) }) : null,
        this.state.disAgreeAlertFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__["a" /* AlerModleCommon */], { btnTxt1: '\u8FD4\u56DE\u7B7E\u7EA6\u9875\u9762',
          btnTxt2: '\u77E5\u9053\u4E86\uFF0C\u6682\u4E0D\u7B7E\u7EA6',
          content: "根据监管要求，只能对签约的客户提供基金投顾服务。如未及时签约，华夏财富将无法再为您提供自动调仓等服务，您可选择继续持有当前份额或赎回。",
          title: '\u7B7E\u7EA6\u63D0\u9192',
          handleClick1: this.callBackQy.bind(this),
          handleClick2: this.closeDisAgreeAlert.bind(this)
        }) : null,
        this.props.signingAlreadyState != null && this.props.signingAlreadyState.state == "1" && this.props.upgradeControl ?
        // this.state.upgradeFlag?
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__["d" /* AlerModleUpgrade */], { btnTxt1: '\u7ACB\u5373\u5347\u7EA7',
          btnTxt2: '\u6682\u4E0D\u5347\u7EA7',
          content: '' + upgradeList.join('、'),
          title: '\u7EC4\u5408\u5347\u7EA7',
          handleClick1: this.pushUpdate.bind(this),
          handleClick2: this.handleCancleUpgrade.bind(this)
        }) : null,
        this.state.disupgradeFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__["a" /* AlerModleCommon */], { btnTxt1: '\u8FD4\u56DE\u5347\u7EA7\u9875\u9762',
          btnTxt2: '\u77E5\u9053\u4E86\uFF0C\u6682\u4E0D\u5347\u7EA7',
          content: "组合升级后您可享受基金投顾服务，建议您及时进行组合升级。另外，您也可以在组合持仓页面进行组合升级。",
          title: '\u7EC4\u5408\u5347\u7EA7',
          handleClick1: this.handleBackUpgrade.bind(this),
          handleClick2: this.handleNoUpgrade.bind(this)
        }) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Modal_ModalSelectTip__["a" /* default */], { onOK: function onOK() {
            sessionStorage.setItem('first_enter', true);_this6.setState({ firstFlag: false });
          }, flag: this.state.firstFlag, height: 240, title: '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u63D0\u793A', rightButtonTitle: '\u6211\u5DF2\u77E5\u6653' })
      );
    }
  }]);

  return Investment;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTransitRecords: state.QueryTransitRecords,
    SupperFundHome: state.SupperFundHome,
    superFundAccAgreementState: state.superFundAccAgreementState,
    inInvestmentList: state.InvestPlanReducer.inInvestmentList,
    signingAlreadyState: state.signingAlreadyState,
    upgradeControl: state.upgradeControl
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__HOC_StateCache_js__["a" /* default */])(Investment, 'InvestmentIndex')));

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_css__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_ModalList__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import { getWebViewHtml } from '../action/webViewContentAction.js';


// import { setStorage, goHome } from '../common';



var ToastTime = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.ToastTime;
var encrypt = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.encrypt;
var ua = navigator.userAgent.toLowerCase();
function getvl(name) {
  var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
  if (reg.test(window.location.href)) return window.unescape(RegExp.$2.replace(/\+/g, " "));
  return undefined;
};
var seasons = [{
  label: '身份证',
  value: '0',
  key: 0
}, {
  label: '护照',
  value: '1',
  key: 1
}, {
  label: '军官证',
  value: '2',
  key: 2
}, {
  label: '士兵证',
  value: '3',
  key: 3
}, {
  label: '港澳居民来往内地通行证(原回乡证)',
  value: '4',
  key: 4
}, {
  label: '户口本',
  value: '5',
  key: 7
}, {
  label: '外国护照',
  value: '6',
  key: 8
}, {
  label: '其他',
  value: '7',
  key: 9
}, {
  label: '警官证',
  value: 'a',
  key: 10
}, {
  label: '文职证',
  value: 'b',
  key: 11
}, {
  label: '台胞证',
  value: 'A',
  key: 12
}, {
  label: '基金账号',
  value: 'TAACCOUNTNO',
  key: 13
}];

var Login = function (_Component) {
  _inherits(Login, _Component);

  function Login(props) {
    _classCallCheck(this, Login);

    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.closeMoadl = function () {
      if (_this.state.Bools) {
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_loginAction_js__["l" /* getTbuxyQis */])({ clientType: "APP", token: "" }, function () {
          _this.setState({
            tanCar: false
          });
          _this.loginSuccess(_this.state.contentVal);
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info("请先阅读并确认用户同步信息授权书", 2);
        return;
      }
    };

    _this.state = {
      sValue: ['0'],
      identityNumber: '',
      VerificationCode: '',
      passWord: '',
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
      invitationCode: _this.props.location.query.inviteCode ? _this.props.location.query.inviteCode : window.localStorage.getItem("inviteCode"),
      isShow: true,
      tanCar: false,
      Bools: false,
      contentVal: ""
    };
    _this.goCallback = false;
    _this.hasCwimAccount = false;
    return _this;
  }

  _createClass(Login, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "华夏基金账号登录";
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(e) {
      this.setState({
        identityNumber: e.target.value
      });
    }
  }, {
    key: 'onChangePassWord',
    value: function onChangePassWord(e) {
      this.setState({
        passWord: e.target.value
      });
    }
  }, {
    key: 'Verification',
    value: function Verification(e) {
      this.setState({
        VerificationCode: e.target.value
      });
    }
  }, {
    key: 'onNext',
    value: function onNext() {
      var _this2 = this;

      var _state = this.state,
          identityNumber = _state.identityNumber,
          passWord = _state.passWord;

      if (identityNumber === "") {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info("请输入证件号码", ToastTime);
      } else if (passWord === "") {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info("请输入交易密码", ToastTime);
      }
      var isIDCard15 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      var isIDCard18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
      if (this.state.sValue[0] === '0' && identityNumber.length == 15) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('只支持18位身份证登录，请在华夏基金进行身份证升位。', ToastTime);
        return;
      }
      if (this.state.sValue[0] === '0' && !(isIDCard15.test(identityNumber) || isIDCard18.test(identityNumber))) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('身份证号码不符合规则，请填写正确的号码', ToastTime);
        return;
      }

      var loginParam = {
        accountType: '1', //华夏基金1 华夏财富0
        certificateType: this.state.sValue[0],
        certificateNo: identityNumber.toUpperCase(),
        // password: CryptoJS.AES.encrypt('111aaa', 'chinaamc@app&web').toString()
        password: encrypt(passWord)
      };
      console.log(loginParam, "loginParamloginParamloginParam");
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__["s" /* loginHXAssets */])(loginParam, function (content) {
        _this2.loginSuccess(content), _this2.setState({ contentVal: content });
      }, function (msg) {
        return _this2.loginError(msg);
      }));
    }
  }, {
    key: 'loginSuccess',
    value: function loginSuccess(content) {
      var _this3 = this;

      console.log(content);
      if (ua.indexOf("amcfmapp") > -1) {
        if (ua.indexOf("wkwebview") > -1) {
          if (window.webkit) {
            // Toast.info( '刷新', 3 );
            window.webkit.messageHandlers.amcfm_utils.postMessage({ "refreshHome": "intelInvest" });
          }
        } else {
          if (window.amcfm_utils) {
            // Toast.info( '刷新', 3 );
            window.amcfm_utils.refreshHome('intelInvest');
          }
        }
      }
      if (content.hasCwimAccount) {
        console.log(content);
        if (content.userId) {
          if (content.certType == 0) {
            this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
              console.log(val, "3939393939");
              if (val) {
                _this3.goCallback = true;
                if (_this3.state.enterType === "InviteRegister") {
                  // goHome("Investment");
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].replace({
                    pathname: '/?enterType=Investment'
                  });
                } else if (_this3.state.enterType === "Answer") {
                  console.log("进入答题");
                  __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
                    pathname: '/AnswerActivityDatillPage',
                    state: {},
                    query: { enterType: "Answer",
                      activityId: _this3.props.location.query.activityId
                    }
                  });
                } else if (_this3.state.enterType == "activity") {
                  var resInfo = content;
                  var userId_a = resInfo.userId ? resInfo.userId : "";
                  var tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
                  var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                  console.log(paramsStr);
                  var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_4__util_js___default.a.aesEncrypt(paramsStr));
                  window.location.href = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.hdUrl + paramsData;
                } else {
                  _this3.isAppGo();
                }
              } else {
                _this3.setState({
                  tanCar: true
                });
              }
            }));
          } else {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('华夏财富仅支持身份证开户，详情请咨询客服', 2);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: "/HxjjBindingMobile",
            query: {
              enterType: this.state.enterType
            },
            state: {
              content: content,
              route: this.props.location.state.route,
              callback: this.props.location.state.callback,
              activityId: this.props.location.query.activityId
            }
          });
        }
      } else {
        if (content.certType == 0) {
          if (content.mobileNo == "" || content.mobileNo == null || content.mobileNo == undefined) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('未能获取到您的手机号，请重试', 2);
            return;
          }
          this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: content.mobileNo }, function () {
            __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
              pathname: '/Loginkah',
              query: {},
              state: {
                name: content.name,
                loginType: content.certType,
                loginNo: content.certNo,
                mobileNo: content.mobileNo,
                callback: _this3.props.location.state.callback,
                route: _this3.props.location.state.route,
                _this: _this3.props,
                onFun: function onFun() {
                  _this3.loginSuccess(content);
                }
              }
            });
          }, function (msg) {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);return;
          }, function () {
            __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info("该手机号已被占用，如非本人操作，请联系我们", 2);return;
          }));
        } else {
          __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('华夏财富仅支持身份证开户，详情请咨询客服', 2);
          return;
        }
        // this.goCallback=true;
        // this.hasCwimAccount=true;//需要同步开户
        // this.isAppGo();
      }
    }
  }, {
    key: 'isAppGo',
    value: function isAppGo() {
      if (ua.indexOf("amcfmapp") > -1) {
        var enterType = getvl("enterType");
        if (enterType == 'TransactionRecordProduct' || enterType == 'InvestmentPlan') {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].replace({
            pathname: enterType
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-1);
        }
      } else {
        if (this.state.enterType) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-1);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-2);
        }
      }
    }
  }, {
    key: 'loginError',
    value: function loginError(msg) {
      console.log(msg, "登录失败");
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, ToastTime);
      // this.props.navigator.push({component: BindingMobile });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      console.log(this.goCallback);
      if (this.goCallback) {
        if (this.hasCwimAccount) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/BindingMobile',
            query: {
              enterType: this.state.enterType,
              invitationCode: this.state.invitationCode,
              activityId: this.props.location.query.activityId
            },
            state: { callback: this.props.location.state.callback, route: this.props.location.state.route }
          });
        } else {
          this.props.location.state.callback ? this.props.location.state.callback() : null;
        }
      }
    }
  }, {
    key: 'onKeyup',
    value: function onKeyup(e) {
      var _state2 = this.state,
          identityNumber = _state2.identityNumber,
          passWord = _state2.passWord;

      if (identityNumber !== "" && passWord !== "") {
        e.keyCode === 13 && this.onNext();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          identityNumber = _state3.identityNumber,
          passWord = _state3.passWord;

      console.log(this.props.location.state);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this4.goBack();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u534E\u590F\u57FA\u91D1\u8D26\u53F7\u767B\u5F55'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 25, paddingBottom: 12 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: "13px", color: "#5b6370" } },
              '\u8BF7\u8F93\u5165\u60A8\u5728\u534E\u590F\u57FA\u91D1\u7684\u8D26\u53F7\u548C\u4EA4\u6613\u5BC6\u7801\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pickerBox pickerBox_login', style: {
                display: "-webkit-flex",
                height: 45,
                backgroundColor: "#fff",
                paddingLeft: 13,
                paddingRight: 13,
                WebkitAlignItems: "center",
                WebkitFlexDirection: "row",
                borderBottom: "1px solid rgb(235, 238, 240)"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Picker"],
              { value: this.state.sValue, onPickerChange: function onPickerChange(e) {
                  return console.log('onPickerChange', e);
                }, onOk: function onOk(e) {
                  return _this4.setState({ sValue: e });
                }, title: '\u9009\u62E9\u8BC1\u4EF6\u7C7B\u578B', data: seasons, cols: 1, className: 'forss' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["List"].Item,
                { arrow: 'horizontal' },
                '\u8BC1\u4EF6\u7C7B\u578B'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8BC1\u4EF6\u53F7\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
              id: 'u2',
              value: this.state.identityNumber,
              onChange: function onChange(e) {
                return _this4.onChangeText(e);
              },
              placeholder: '\u8BF7\u8F93\u5165\u8BC1\u4EF6\u53F7\u7801'

            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                return _this4.setState({ identityNumber: '' });
              }, src: __webpack_require__(47), className: 'imgBtn' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u4EA4\u6613\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
              id: 'p2',
              type: this.state.isShow ? "password" : "text",
              value: this.state.passWord,
              onChange: function onChange(e) {
                return _this4.onChangePassWord(e);
              },
              placeholder: '\u8BF7\u8F93\u5165\u4EA4\u6613\u5BC6\u7801'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', onClick: function onClick() {
                return _this4.setState({ isShow: !_this4.state.isShow });
              }, style: { height: 30, width: 30 }, src: this.state.isShow ? __webpack_require__(394) : __webpack_require__(393) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                return _this4.setState({ passWord: '' });
              }, src: __webpack_require__(47), className: 'imgBtn' })
          ),
          identityNumber !== "" && passWord !== "" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: 0,
              onClick: function onClick() {
                return _this4.onNext();
              }, className: 'btn' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u767B\u5F55'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray',
              key: 0
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u767B\u5F55'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modal_ModalList__["a" /* default */], { onFun: function onFun(Bools) {
            _this4.setState({ Bools: Bools });
          }, flag: this.state.tanCar, btnRight: "确认", btnRightFun: this.closeMoadl, content: "为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》", title: "" })
      );
    }
  }]);

  return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Login));

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AnswerAlert__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_ModalList__ = __webpack_require__(69);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var LoginHxcf = function (_Component) {
  _inherits(LoginHxcf, _Component);

  function LoginHxcf(props) {
    _classCallCheck(this, LoginHxcf);

    var _this = _possibleConstructorReturn(this, (LoginHxcf.__proto__ || Object.getPrototypeOf(LoginHxcf)).call(this, props));

    _this.handleLogin = function () {
      if (_this.state.loginTypeNumber == '1') {
        if (!_this.state.userName) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("请填写手机号码", 2);
          return;
        }

        var pattern = /^1[0123456789]\d{9}$/;
        if (!pattern.test(_this.state.userName)) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("请输入正确的手机号码", 2);
          return;
        }

        if (!_this.state.passWord) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("请填写登录密码", 2);
          return;
        }

        var loginParamForMobile = {
          mobileNo: _this.state.userName,
          password: __WEBPACK_IMPORTED_MODULE_3__util___default.a.encrypt(_this.state.passWord)
        };
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading("正在加载");
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["i" /* loginHXFortuneByMobile */])(loginParamForMobile, function (content) {
          _this.loginSuccess(content), _this.setState({ contentVal: content });
        }, function (msg) {
          return _this.loginError(msg);
        }));
      }

      if (_this.state.loginTypeNumber == '0') {
        if (!_this.state.userName) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("请填写证件号码", 2);
          return;
        }
        if (!_this.state.passWord) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("请填写登录密码", 2);
          return;
        }

        var isIDCard15 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
        var isIDCard18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
        if (!(isIDCard15.test(_this.state.userName) || isIDCard18.test(_this.state.userName))) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("身份证号码不符合规则，请填写正确的号码", 2);
          return;
        }

        var loginParamForIdentity = {
          accountType: '0',
          certificateType: '0',
          certificateNo: _this.state.userName.toUpperCase(),
          password: __WEBPACK_IMPORTED_MODULE_3__util___default.a.encrypt(_this.state.passWord)
        };
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading("正在加载");
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["j" /* loginHXFortuneByIdentity */])(loginParamForIdentity, function (content) {
          _this.loginSuccess(content, "2"), _this.setState({ contentVal: content });
        }, function (msg) {
          return _this.loginError(msg);
        }));
      }
    };

    _this.loginSuccess = function (content, flag) {
      sessionStorage.setItem('loadSourceBySup', "");
      sessionStorage.setItem('loadSourceByZt', "");
      var queryEnterType = _this.props.location.query ? _this.props.location.query.enterType : "no";

      console.log(content, "userBindingMobil登录成功", _this.props.location.query.enterType);
      if (window.navigator.userAgent.indexOf("amcfmapp") > -1) {
        if (window.navigator.userAgent.indexOf("wkwebview") > -1) {
          if (window.webkit) {
            window.webkit.messageHandlers.amcfm_utils.postMessage({ "refreshHome": "intelInvest" });
          }
        } else {
          if (window.amcfm_utils) {
            window.amcfm_utils.refreshHome('intelInvest');
          }
        }
      }
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      if (flag) {
        console.log(content, "030303003");
        if (content.userId == null && _this.state.loginTypeNumber == '0') {
          console.log(content, 'qw2ewqdq');

          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: "/userBindingMobile",
            state: {
              content: content,
              route: route,
              callback: callback
            }
          });
        } else {
          if (queryEnterType === "Answer" || queryEnterType === "activity") {
            if (content.isRealName) {
              /*已实名*/
              _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
                if (val) {
                  if (queryEnterType === "Answer") {
                    __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                      pathname: '/AnswerActivityDatillPage',
                      state: {},
                      query: { enterType: "Answer",
                        activityId: _this.props.location.query.activityId }
                    });
                  } else {
                    var userId_a = content.userId ? content.userId : "";
                    var tradeAccountNo_a = content.tradeAccountNo ? content.tradeAccountNo : "";
                    var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                    console.log(paramsStr);
                    var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3__util___default.a.aesEncrypt(paramsStr));
                    window.location.href = __WEBPACK_IMPORTED_MODULE_3__util___default.a.hdUrl + paramsData;
                  }
                } else {
                  _this.setState({
                    tanCar: true
                  });
                }
              }));
            } else {
              _this.setState({
                TipsFlag: true
              });
            }
          } else {
            if (content.isRealName) {
              /*已实名*/
              _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
                if (val) {
                  _this.goCallback = true;
                  // hashHistory.go(route - window.history.length);
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
                } else {
                  _this.setState({
                    tanCar: true
                  });
                }
              }));
            } else {
              _this.goCallback = true;
              // hashHistory.go(route - window.history.length);
              __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
            }
          }
        }
      } else {
        console.log(content, "030303003");
        if (queryEnterType === "Answer" || queryEnterType === "activity") {
          if (content.isRealName) {
            /*已实名*/
            _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
              console.log(val);
              if (val) {
                if (queryEnterType === "Answer") {
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                    pathname: '/AnswerActivityDatillPage',
                    state: {},
                    query: { enterType: "Answer", activityId: _this.props.location.query.activityId }
                  });
                } else {
                  var userId_a = content.userId ? content.userId : "";
                  var tradeAccountNo_a = content.tradeAccountNo ? content.tradeAccountNo : "";
                  var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                  console.log(paramsStr);
                  var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_3__util___default.a.aesEncrypt(paramsStr));
                  window.location.href = __WEBPACK_IMPORTED_MODULE_3__util___default.a.hdUrl + paramsData;
                }
              } else {
                _this.setState({
                  tanCar: true
                });
              }
            }));
          } else {
            _this.setState({
              TipsFlag: true
            });
          }
        } else {
          if (content.isRealName) {
            /*已实名*/
            _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
              if (val) {
                _this.goCallback = true;
                // hashHistory.go(route - window.history.length);
                __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
              } else {
                _this.setState({
                  tanCar: true
                });
              }
            }));
          } else {
            _this.goCallback = true;
            // hashHistory.go(route - window.history.length);
            __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
          }
        }
      }
    };

    _this.loginError = function (msg) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, 2);
    };

    _this.goBack = function () {
      var back = _this.props.location.state && _this.props.location.state.back ? _this.props.location.state.back : null;
      if (back) {
        back();
      } else {
        __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
      }
    };

    _this.changeLoginType = function (value) {
      if (value[0] == "0") {
        _this.setState({
          loginTypeName: "证件号码"
        });
      } else if (value[0] == "1") {
        _this.setState({
          loginTypeName: "手机号码"
        });
      }
      _this.setState({
        loginTypeNumber: value[0],
        userName: "",
        passWord: ""
      });
    };

    _this.changeUserName = function (event) {
      _this.setState({
        userName: event.target.value
      });
    };

    _this.changePassWord = function (event) {
      _this.setState({
        passWord: event.target.value
      });
    };

    _this.clearUserName = function () {
      _this.setState({
        userName: ""
      });
    };

    _this.clearPassWord = function () {
      _this.setState({
        passWord: ""
      });
    };

    _this.goRegister = function () {
      var registerParams = '';
      if (_this.props.location.state.params && _this.props.location.state.params.isInvestmentAdvisory) {
        var EnterPage = _this.props.location.state.params.enterType == 'TargetProfitDetail' ? 'TP' : 'SP';
        registerParams = '&superFundCode=' + _this.props.location.state.params.fundCode + '&superFundName=' + _this.props.location.state.params.fundName + '&inst_id=SFH5&enterType=hxcfH5&EnterPage=' + EnterPage;
      }
      window.location.href = 'https://wh5.amcfortune.com/wh5-trade/#/register?clientType=hxcfH5' + registerParams;
    };

    _this.forgetPassWord = function () {
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      sessionStorage.setItem("verifyDynamicCodeSec_mobileNumber", "");
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: "/verifyDynamicCodeSec",
        state: {
          route: route,
          callback: callback
        },
        query: {
          enterType: _this.state.enterType,
          activityId: _this.props.location.query.activityId
        }
      });
    };

    _this.closeMoadl = function () {
      if (_this.state.Bools) {
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["l" /* getTbuxyQis */])({ clientType: "APP", token: "" }, function () {
          _this.setState({
            tanCar: false
          });
          if (_this.state.loginTypeNumber == "1") {
            _this.loginSuccess(_this.state.contentVal, "");
          } else {
            _this.loginSuccess(_this.state.contentVal, "2");
          }
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info("请先阅读并确认用户同步信息授权书", 2);
        return;
      }
    };

    _this.goJjLogin = function () {
      console.log(_this.state.enterType);
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: "/LoginHxjj",
        state: {
          route: route,
          callback: callback
        }, query: {
          enterType: _this.state.enterType,
          activityId: _this.props.location.query.activityId
        }
      });
    };

    _this.state = {
      //手机号登录对应loginTypeNumber为1，身份证对应为0
      loginTypeName: '手机号码',
      loginTypeNumber: '1',
      userName: "",
      passWord: '',
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
      TipsFlag: false,
      isShow: true,
      tanCar: false,
      contentVal: "",
      Bools: false
    };
    _this.goCallback = false;
    return _this;
  }

  _createClass(LoginHxcf, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "华夏财富账号登录";
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
      if (this.goCallback) {
        if (callback) {
          callback();
        }
      }
    }

    //注册


    //忘记密码

  }, {
    key: 'handleSure',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  TipsFlag: false
                });
                __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                  pathname: '/CertificationUpload',
                  state: {
                    phoneNo: this.state.contentVal ? this.state.contentVal.mobileNo : ""
                  },
                  query: { enterType: this.state.enterType,
                    activityId: this.props.location.query.activityId

                  }
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSure() {
        return _ref.apply(this, arguments);
      }

      return handleSure;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _ref2,
          _ref3,
          _ref4;

      var loginTypeArr = [{
        value: "0",
        label: "身份证"
      }, {
        value: "1",
        label: "手机号"
      }];
      var _state = this.state,
          loginTypeName = _state.loginTypeName,
          loginTypeNumber = _state.loginTypeNumber,
          userName = _state.userName,
          passWord = _state.passWord,
          TipsFlag = _state.TipsFlag;

      console.log(this.state.contentVal, "93939393993");
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u534E\u590F\u8D22\u5BCC\u8D26\u53F7\u767B\u5F55'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex",
                overflow: "hidden"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100 } },
              '\u767B\u5F55\u65B9\u5F0F'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'pickerBox pickerBox2', style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Picker"],
                { value: [loginTypeNumber], title: '\u767B\u5F55\u65B9\u5F0F', data: loginTypeArr, onChange: this.changeLoginType, cols: 1, className: 'forss' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["List"].Item, { arrow: 'horizontal' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100 } },
              loginTypeName
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { id: 'u1', autocomplete: 'off', style: { WebkitFlex: 1, fontSize: 14 }, onChange: this.changeUserName, value: userName, type: 'text', placeholder: "请输入" + loginTypeName }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.clearUserName, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100 } },
              '\u767B\u5F55\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { id: 'p1', autocomplete: 'off', style: { width: "100%", fontSize: 14 }, onChange: this.changePassWord, value: passWord, type: this.state.isShow ? "password" : "text", placeholder: '\u8BF7\u8F93\u5165\u767B\u5F55\u5BC6\u7801' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: '', onClick: function onClick() {
                  return _this2.setState({ isShow: !_this2.state.isShow });
                }, style: { height: 40, width: 40 }, src: this.state.isShow ? __webpack_require__(394) : __webpack_require__(393) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.clearPassWord, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                display: "-webkit-flex",
                paddingTop: 10,
                paddingBottom: 14,
                paddingRight: 13,
                paddingLeft: 13,
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                WebkitJustifyContent: 'center',
                marginLeft: window.winWidth - 76,
                width: 76
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#5b6370', fontSize: 11 }, onClick: this.forgetPassWord },
              '\u5FD8\u8BB0\u5BC6\u7801'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: this.handleLogin, style: (_ref2 = {
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20,
                backgroundColor: "#fa063a",
                height: 40
              }, _defineProperty(_ref2, 'borderRadius', 20), _defineProperty(_ref2, 'WebkitFlexDirection', 'row'), _defineProperty(_ref2, 'WebkitAlignItems', 'center'), _defineProperty(_ref2, 'WebkitJustifyContent', 'center'), _defineProperty(_ref2, 'display', "-webkit-flex"), _ref2) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#ffffff', fontSize: 15 } },
              '\u767B\u5F55'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: this.goJjLogin, style: (_ref3 = {
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20,
                backgroundColor: "#fff",
                height: 40
              }, _defineProperty(_ref3, 'borderRadius', 20), _defineProperty(_ref3, 'WebkitFlexDirection', 'row'), _defineProperty(_ref3, 'WebkitAlignItems', 'center'), _defineProperty(_ref3, 'WebkitJustifyContent', 'center'), _defineProperty(_ref3, 'display', "-webkit-flex"), _defineProperty(_ref3, 'marginTop', 7), _defineProperty(_ref3, 'border', "1px solid #fa063a"), _ref3) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#fa063a', fontSize: 15 } },
              '\u534E\u590F\u57FA\u91D1\u8D26\u53F7\u767B\u5F55'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: this.goRegister, style: (_ref4 = {
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20,
                backgroundColor: "#fff",
                height: 40
              }, _defineProperty(_ref4, 'borderRadius', 20), _defineProperty(_ref4, 'WebkitFlexDirection', 'row'), _defineProperty(_ref4, 'WebkitAlignItems', 'center'), _defineProperty(_ref4, 'WebkitJustifyContent', 'center'), _defineProperty(_ref4, 'display', "-webkit-flex"), _defineProperty(_ref4, 'marginTop', 20), _defineProperty(_ref4, 'border', "1px solid #fa063a"), _ref4) },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#fa063a', fontSize: 15 } },
              '\u8FD8\u6CA1\u6709\u8D26\u53F7\uFF1F\u7ACB\u5373\u6CE8\u518C'
            )
          )
        ),
        TipsFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AnswerAlert__["a" /* AlerModleTips */], { content: '\u60A8\u8FD8\u672A\u5B9E\u540D\u8BA4\u8BC1\u9700\u8981\u5B9E\u540D\u8BA4\u8BC1', handleSure: this.handleSure.bind(this) }) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modal_ModalList__["a" /* default */], { onFun: function onFun(Bools) {
            _this2.setState({ Bools: Bools });
          }, flag: this.state.tanCar, btnRight: "确认", btnRightFun: this.closeMoadl, content: "为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》", title: "" })
      );
    }
  }]);

  return LoginHxcf;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(LoginHxcf));

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalDetail_css__ = __webpack_require__(2134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalDetail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ModalDetail_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ModalDetail = function (_Component) {
  _inherits(ModalDetail, _Component);

  function ModalDetail(props) {
    _classCallCheck(this, ModalDetail);

    var _this = _possibleConstructorReturn(this, (ModalDetail.__proto__ || Object.getPrototypeOf(ModalDetail)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ModalDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","")
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'modal_container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modal_view' },
            this.props.title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'modal_title' },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'modal_content' },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'modal_footer' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    return _this2.props.onOK();
                  } },
                this.props.rightButtonTitle
              )
            )
          )
        ) : null
      );
    }
  }]);

  return ModalDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ModalDetail.defaultProps = {
  // leftButtonTitle:　'取消',
  rightButtonTitle: '确认',
  content: '',
  // contentBC:'',
  onCancel: function onCancel() {},
  onOK: function onOK() {},
  // titleBC:'',
  title: '',
  flag: false
};


/* harmony default export */ __webpack_exports__["a"] = (ModalDetail);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalTip_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ModalPaySup = function (_Component) {
  _inherits(ModalPaySup, _Component);

  function ModalPaySup(props) {
    _classCallCheck(this, ModalPaySup);

    var _this = _possibleConstructorReturn(this, (ModalPaySup.__proto__ || Object.getPrototypeOf(ModalPaySup)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ModalPaySup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","")
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'containerModal_old' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modalView_old' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'titleText_old', style: { marginTop: this.props.titleBC ? 6 : 20 } },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentText_old' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u60A8\u5373\u5C06\u6295\u8D44\u7684',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontWeight: "bold" } },
                  this.props.fundName
                ),
                '\u5305\u542B\u5173\u8054\u65B9\uFF08\u534E\u590F\u57FA\u91D1\uFF09\u7BA1\u7406\u7684\u4EA7\u54C1\uFF0C\u5177\u4F53\u4E3A',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontWeight: "bold" } },
                  this.props.data
                ),
                ' \uFF0C\u8BF7\u60A8\u77E5\u6089\u3002\u5F53\u51FA\u73B0\u5229\u76CA\u51B2\u7A81\u65F6\uFF0C\u534E\u590F\u8D22\u5BCC\u4E0D\u4F1A\u4E3A\u81EA\u8EAB\u53CA\u5176\u5173\u8054\u65B9\u7684\u5229\u76CA\u635F\u5BB3\u6295\u8D44\u8005\u5229\u76CA\uFF0C\u4E0D\u4F1A\u4E3A\u6295\u8D44\u987E\u95EE\u4EBA\u5458\u53CA\u5176\u5229\u76CA\u76F8\u5173\u8005\u7684\u5229\u76CA\u635F\u5BB3\u60A8\u7684\u5229\u76CA\uFF0C\u4E0D\u4F1A\u4E3A\u7279\u5B9A\u5BA2\u6237\u5229\u76CA\u635F\u5BB3\u5176\u4ED6\u5BA2\u6237\u5229\u76CA\uFF0C\u4E0D\u4F1A\u76F4\u63A5\u6216\u95F4\u63A5\u53C2\u4E0E\u5185\u5E55\u4EA4\u6613\u3001\u64CD\u7EB5\u8BC1\u5238\u4EA4\u6613\u4EF7\u683C\u6216\u901A\u8FC7\u6295\u8D44\u7EC4\u5408\u8FDB\u884C\u975E\u6CD5\u5229\u76CA\u8F93\u9001\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentTwoText_old' },
              this.props.contentBC
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'footView_old' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    _this2.props.onOK();
                  } },
                this.props.rightButtonTitle
              )
            )
          )
        ),
        ':null'
      );
    }
  }]);

  return ModalPaySup;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    riskModalData: state.riskModalData,
    payLoading: state.payLoading
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ModalPaySup));

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModalTip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModalTip_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ModalTip = function (_Component) {
  _inherits(ModalTip, _Component);

  function ModalTip(props) {
    _classCallCheck(this, ModalTip);

    var _this = _possibleConstructorReturn(this, (ModalTip.__proto__ || Object.getPrototypeOf(ModalTip)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ModalTip, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // document.getElementsByTagName('body')[0].setAttribute("style","")
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'containerModal_old' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'modalView_old' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'titleText_old', style: { marginTop: this.props.titleBC ? 6 : 20 } },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentText_old' },
              this.props.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'contentTwoText_old' },
              this.props.contentBC
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'footView_old' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    return _this2.props.onOK();
                  } },
                this.props.rightButtonTitle
              )
            )
          )
        ) : null
      );
    }
  }]);

  return ModalTip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ModalTip.defaultProps = {
  leftButtonTitle: '取消',
  rightButtonTitle: '确认',
  content: '',
  contentBC: '',
  onCancel: function onCancel() {},
  onOK: function onOK() {},
  titleBC: '',
  title: '',
  flag: false
};


/* harmony default export */ __webpack_exports__["a"] = (ModalTip);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModelEvaluationcopy_css__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ModelEvaluationcopy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ModelEvaluationcopy_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ModelEvaluation = function (_Component) {
	_inherits(ModelEvaluation, _Component);

	function ModelEvaluation(props) {
		_classCallCheck(this, ModelEvaluation);

		var _this = _possibleConstructorReturn(this, (ModelEvaluation.__proto__ || Object.getPrototypeOf(ModelEvaluation)).call(this, props));

		_this.state = {
			agreeIndex: 0,
			StateChange: true
		};
		return _this;
	}

	_createClass(ModelEvaluation, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setState({
				StateChange: true
			});
		}
	}, {
		key: 'handleOk',
		value: function handleOk() {
			this.setState({
				StateChange: false
			});
		}
	}, {
		key: 'isAgreeClick',
		value: function isAgreeClick() {
			var agreeIndex = this.state.agreeIndex;

			if (agreeIndex == 0) {
				this.setState({
					agreeIndex: 1
				});
			} else {
				this.setState({
					agreeIndex: 0
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return this.state.StateChange ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'containerQue' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ style: { justifyContent: 'center', display: "flex", flex: 1 } },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'modalViewQue' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ className: 'titleTextQue' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ className: 'Less' },
								'\u2003\u2003\u4E3A\u843D\u5B9E\u300A\u8BC1\u5238\u671F\u8D27\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u529E\u6CD5\u300B\uFF0C\u5C06\u9002\u5F53\u7684\u4EA7\u54C1\u6216\u670D\u52A1\u9500\u552E\u6216\u63D0\u4F9B\u7ED9\u9002\u5F53\u7684\u6295\u8D44\u4EBA\uFF0C\u7EF4\u62A4\u6295\u8D44\u8005\u5408\u6CD5\u6743\u76CA\uFF0C\u73B0\u9700\u5BF9\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u8FDB\u884C\u6D4B\u8BD5\uFF0C\u7279\u63D0\u793A\u5982\u4E0B\uFF1A'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ className: 'Less' },
								'\u2003\u20031\u3001\u5F53\u60A8\u7684\u57FA\u672C\u4FE1\u606F\u548C\u98CE\u9669\u6D4B\u8BC4\u95EE\u5377\u4E2D\u7684\u4FE1\u606F\u53D1\u751F\u91CD\u8981\u53D8\u5316\u3001\u53EF\u80FD\u5F71\u54CD\u5206\u7C7B\u65F6\uFF0C\u60A8\u5E94\u53CA\u65F6\u4FEE\u6539\u57FA\u672C\u4FE1\u606F\u6216\u66F4\u65B0\u95EE\u5377\u3002'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ className: 'Less' },
								'\u2003\u20032\u3001\u672C\u516C\u53F8\u6839\u636E\u60A8\u63D0\u4F9B\u7684\u4FE1\u606F\u5BF9\u60A8\u8FDB\u884C\u98CE\u9669\u627F\u53D7\u80FD\u529B\u8BC4\u4F30\uFF0C\u5F00\u5C55\u9002\u5F53\u6027\u5DE5\u4F5C\u3002\u60A8\u5E94\u5F53\u5982\u5B9E\u63D0\u4F9B\u76F8\u5173\u4FE1\u606F\u53CA\u8BC1\u660E\u6750\u6599\uFF0C\u5E76\u5BF9\u6240\u63D0\u4F9B\u7684\u4FE1\u606F\u548C\u8BC1\u660E\u6750\u6599\u7684\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\u3001\u5B8C\u6574\u6027\u8D1F\u8D23\u3002\u5F53\u60A8\u7684\u5404\u9879\u72B6\u51B5\u53D1\u751F\u91CD\u5927\u53D8\u5316\u65F6\uFF0C\u60A8\u9700\u5BF9\u6240\u6295\u8D44\u7684\u91D1\u878D\u4EA7\u54C1\u53CA\u65F6\u8FDB\u884C\u91CD\u65B0\u5BA1\u89C6\uFF0C\u4EE5\u786E\u4FDD\u60A8\u7684\u6295\u8D44\u51B3\u5B9A\u4E0E\u60A8\u53EF\u627F\u53D7\u7684\u6295\u8D44\u98CE\u9669\u7A0B\u5EA6\u4EE5\u53CA\u6295\u8D44\u76EE\u6807\u7B49\u5B9E\u9645\u60C5\u51B5\u4E00\u81F4\u3002'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ className: 'Less' },
								'\u2003\u20033\u3001\u6295\u8D44\u98CE\u9669\u627F\u53D7\u80FD\u529B\u6D4B\u8BD5\u5185\u5BB9\u53CA\u7ED3\u679C\u4EC5\u4F9B\u53C2\u8003\uFF0C\u5B9E\u9645\u6295\u8D44\u8BF7\u614E\u91CD\u3002\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E\u3002'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ className: 'footViewQue' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ className: 'onPressRightView2', onClick: function onClick() {
										_this2.handleOk();
									} },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'p',
									{ className: 'footTextR' },
									'\u6211\u5DF2\u77E5\u6653\u5E76\u540C\u610F'
								)
							)
						)
					)
				)
			) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
		}
	}]);

	return ModelEvaluation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ModelEvaluation);
;

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_portfolioAction_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nheaderjiaoyijilu_css__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nheaderjiaoyijilu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__nheaderjiaoyijilu_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var NHeader = function (_Component) {
  _inherits(NHeader, _Component);

  function NHeader(props) {
    _classCallCheck(this, NHeader);

    var _this = _possibleConstructorReturn(this, (NHeader.__proto__ || Object.getPrototypeOf(NHeader)).call(this, props));

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.state = {};
    return _this;
  }

  _createClass(NHeader, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "NHeader_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "NHeader_wrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "NHeader_content" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "NHeader_goback", onClick: this.goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(152) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "NHeader_title" },
              this.props.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "NHeader_share" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { onClick: function onClick() {} },
                this.props.title1
              )
            )
          )
        )
      );
    }
  }]);

  return NHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(NHeader));

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BankCode__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var RedeemSuperFund = function (_Component) {
  _inherits(RedeemSuperFund, _Component);

  function RedeemSuperFund(props) {
    _classCallCheck(this, RedeemSuperFund);

    var _this = _possibleConstructorReturn(this, (RedeemSuperFund.__proto__ || Object.getPrototypeOf(RedeemSuperFund)).call(this, props));

    _this.state = {
      fundLimit: '',
      isOk: false,
      active: 1 //1活期通 2银行
    };
    return _this;
  }

  _createClass(RedeemSuperFund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "选择赎回渠道";
    }
  }, {
    key: 'choseCurrent',
    value: function choseCurrent(i) {
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction__["i" /* choseCurrentIndex */])(i));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction__["j" /* choseBankOrCurrent */])(false));
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          selectCurrentIndex = _props.selectCurrentIndex,
          selectBankIndex = _props.selectBankIndex;
      var active = this.state.active;

      var icon = [__webpack_require__(125), __webpack_require__(151)];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u9009\u62E9\u8D4E\u56DE\u6E20\u9053'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          this.props.location.state.dataSouse.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'bankList', onClick: function onClick() {
                  return _this2.choseCurrent(i);
                }, key: i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), className: 'img' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListTip' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  item.trustChannelName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u53EF\u8D4E\u56DE\u91D1\u989D:',
                  __WEBPACK_IMPORTED_MODULE_3__util___default.a.parsePrice(item.canRedeemAmount),
                  '\u5143'
                ),
                !item.allAmountCanUse ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { color: 'rgb(104,113,126)', fontSize: 10, paddingTop: 2 } },
                  "部分成分基金暂停赎回/转换",
                  ' '
                ) : null
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListRightOK' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: selectCurrentIndex === i ? icon[1] : icon[0], className: 'img' })
              )
            );
          })
        )
      );
    }
  }]);

  return RedeemSuperFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    selectBankIndex: state.selectBankIndex,
    selectCurrentIndex: state.selectCurrentIndex,
    verifiedUserInfo: state.verifiedUserInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(RedeemSuperFund));

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__myAssets_payment_Password__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fundDetail_AlerModle__ = __webpack_require__(89);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var RedeemSuperFund = function (_Component) {
  _inherits(RedeemSuperFund, _Component);

  function RedeemSuperFund(props) {
    _classCallCheck(this, RedeemSuperFund);

    var _this2 = _possibleConstructorReturn(this, (RedeemSuperFund.__proto__ || Object.getPrototypeOf(RedeemSuperFund)).call(this, props));

    _this2.agreeFunSec = function () {
      _this2.setState({
        setModalShow: false,
        pwdFlag: true
      });
    };

    _this2.onFun = function (val) {
      var cardList = _this2.props.location.state.cardList;

      var zdnum = __WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(cardList[_this2.props.selectCurrentIndex].canRedeemAmount);
      if (_this2.state.numVal !== "0") {
        _this2.setState({
          text: val * zdnum,
          btnFlag: true,
          BoolVlue: false,
          Colr: val,
          baiFen: val * 100 + "%",
          BoolVlues: false
        });
      } else {
        _this2.setState({
          btnFlag: false,
          BoolVlue: false,
          BoolVlues: false,
          baiFen: val * 100 + "%",
          Colr: val
        });
      }
    };

    _this2.backFunHqt = function (cerArr) {
      if (_this2.props.location.state && _this2.props.location.state.cardList && _this2.props.location.state.cardList.length > 0 && cerArr.length > 0) {
        var dataList = cerArr;
        var newData = [];
        if (_this2.props.location.state.cardList[_this2.props.selectCurrentIndex].capitalChannelId != "y") {
          for (var i = 0; i < dataList.length; i++) {
            if (dataList[i].fundname != "活期通") {
              newData.push(dataList[i]);
            }
          }
          if (dataList[_this2.props.currencyIndex] && dataList[_this2.props.currencyIndex].fundname == "活期通" || _this2.props.currencyIndex - 0 > dataList.length - 1) {
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["J" /* choseCurrencyIndex */])(0));
            _this2.setState({
              currencyArr: newData
            });
          } else {
            for (var _i = 0; _i < newData.length; _i++) {
              if (newData[_i].fundname == dataList[_this2.props.currencyIndex].fundname) {
                _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["J" /* choseCurrencyIndex */])(_this2.props.currencyIndex));
                _this2.setState({
                  currencyArr: newData
                });
                break;
              }
            }
          }
        } else {
          var Flag = false;
          for (var _i2 = 0; _i2 < dataList.length; _i2++) {
            newData.push(dataList[_i2]);
            if (dataList[_i2].fundname == "活期通") {
              Flag = true;
            }
          }
          if (!Flag) {
            newData.push({
              fundname: "活期通",
              fundtext: "赎回资金将默认转入当前活期通账户中七日年化收益率最高的产品"
            });
          }
          for (var _i3 = 0; _i3 < newData.length; _i3++) {
            if (newData[_i3].fundname == dataList[_this2.props.currencyIndex].fundname) {
              _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["J" /* choseCurrencyIndex */])(_this2.props.currencyIndex));
              _this2.setState({
                currencyArr: newData
              });
              break;
            }
          }
        }
      }
    };

    _this2.state = {
      text: '',
      btnFlag: false,
      pwdFlag: false,
      keyPasswordVal: '',
      active: 1,
      currencyArr: [],
      currencyArrIndex: 0,
      currencyFlag: false,
      setModalShow: false,
      expectedDateArr: {
        moneyFundExpectedDate: '--',
        bankCardExpectedDate: '--'
      },
      limitFlag: false,
      sevenDayFlag: false,
      partialRedeem: false,
      numVal: "",
      BoolVlue: false,
      Bool: false,
      Tiac: false,
      Colr: "",
      baiFen: "",
      BoolVlues: false,
      Num: ""
    };
    return _this2;
  }

  _createClass(RedeemSuperFund, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'componentWillMount',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this3 = this;

        var _props$location$state, fundCode, cardList, selectCurrentIndex, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props$location$state = this.props.location.state, fundCode = _props$location$state.fundCode, cardList = _props$location$state.cardList;
                selectCurrentIndex = this.props.selectCurrentIndex;


                console.log(cardList, selectCurrentIndex);
                document.title = "赎回";
                if (__WEBPACK_IMPORTED_MODULE_5__util___default.a.superFundCodeArrByTarget.indexOf(fundCode) != -1) {
                  this.allConver();
                }
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["D" /* getFundsInfo */])(function (result) {
                  _this3.getFundsInfo(result);
                }));
                _context.t0 = fundCode;
                _context.next = 9;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__common__["b" /* getTempInfo */])('shortToken');

              case 9:
                _context.t1 = _context.sent;
                _context.t2 = cardList[selectCurrentIndex].trustChannelId;
                data = {
                  superFundCode: _context.t0,
                  token: _context.t1,
                  trustChannelId: _context.t2
                };

                console.log(data, '获取到款时间');
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["E" /* getExpectedDate */])(data, function (result) {
                  _this3.getExpectedDate(result);
                }));

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: 'getExpectedDate',
    value: function getExpectedDate(result) {
      this.setState({
        expectedDateArr: result.content
      });
    }
  }, {
    key: 'getFundsInfo',
    value: function getFundsInfo(result) {
      console.log(result);
      var newData = [];
      if (result.content) {
        newData = [].concat(result.content);
        if (this.props.location.state && this.props.location.state.cardList && this.props.location.state.cardList.length > 0 && this.props.location.state.cardList[this.props.selectCurrentIndex].capitalChannelId != "y") {} else {
          newData.push({
            fundname: "活期通",
            fundtext: "赎回资金将默认转入当前活期通账户中七日年化收益率最高的产品"
          });
        }
      }
      this.setState({
        currencyArr: newData
      });
      this.backFunHqt(newData);
    }
  }, {
    key: 'next',
    value: function next() {
      var _this4 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          selectCurrentIndex = _props.selectCurrentIndex;
      var _props$location$state2 = this.props.location.state,
          cardList = _props$location$state2.cardList,
          fundCode = _props$location$state2.fundCode;

      var baiFenVal = "";
      if (this.state.baiFen.indexOf("%") != -1) {
        baiFenVal = this.state.baiFen.substring(0, this.state.baiFen.length - 1);
      } else {
        baiFenVal = this.state.baiFen;
      }
      if (!cardList) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请选择赎回渠道', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
        return;
      }
      if (!Number.isInteger(Number(baiFenVal))) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入整数可转出比例', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
        return;
      }
      if (cardList[selectCurrentIndex].canRedeemAmount - 0 <= 0) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('可赎回份额为0，不能赎回', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
        return;
      }
      // if (cardList[selectCurrentIndex].status=='adjust') {
      //   Toast.info( '调仓中不允许赎回', Util.ToastTime );
      //   return;
      // }
      // if(cardList[selectCurrentIndex].canRedeemAmount-0 >= 500){
      //   if(this.state.text-0 < 500){
      //     let toast = Toast.info( '赎回金额不可低于500元', Util.ToastTime );
      //     return;
      //   }
      // }
      // if (cardList[selectCurrentIndex].canRedeemAmount-0<this.state.text-0) {
      //   Toast.info( '赎回金额不可超过可赎回金额', Util.ToastTime );
      //   return;
      // }
      // if(this.state.text-0!=cardList[selectCurrentIndex].canRedeemAmount-0){
      //   if(this.state.text-0 > (cardList[selectCurrentIndex].canRedeemAmount-0)*0.8 || (cardList[selectCurrentIndex].canRedeemAmount-0)-(this.state.text-0)< 500){
      //     this.setState({
      //       limitFlag: true
      //     })
      //     return;
      //   }
      // }
      // if (this.state.amount-0>=cardList[selectCurrentIndex].totalAmount-0) {
      //   if (this.state.text-0!=cardList[selectCurrentIndex].totalAmount-0) {
      //     let toast = Toast.info( '赎回额低于交易最低限额，请全部赎回', Util.ToastTime );
      //     return;
      //   }
      // } else{
      //   if (cardList[selectCurrentIndex].totalAmount-0<this.state.text-0) {
      //     Toast.info( '赎回金额不可超过可赎回金额', Util.ToastTime );
      //     return;
      //   }
      // }
      var params = {
        fundCode: fundCode,
        businessType: 'T024',
        trustChannelId: cardList[selectCurrentIndex].trustChannelId
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["F" /* superFundPunishmentIn7Day */])(params, function (result) {
        console.log(result);
        if (result.content) {
          _this4.setState({
            sevenDayFlag: true
          });
        } else {
          if (_this4.state.active == 1) {
            if (_this4.state.currencyArr[_this4.props.currencyIndex].fundname == "活期通") {
              _this4.setState({
                pwdFlag: true
              });
            } else {
              _this4.setState({
                setModalShow: true
              });
            }
          } else {
            _this4.setState({
              pwdFlag: true
            });
          }
        }
      }));
    }
    //七日赎回确认

  }, {
    key: 'onNext',
    value: function onNext() {
      var _this5 = this;

      this.setState({
        sevenDayFlag: false
      }, function () {
        if (_this5.state.active == 1) {
          if (_this5.state.currencyArr[_this5.props.currencyIndex].fundname == "活期通") {
            _this5.setState({
              pwdFlag: true
            });
          } else {
            _this5.setState({
              setModalShow: true
            });
          }
        } else {
          _this5.setState({
            pwdFlag: true
          });
        }
      });
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(e) {
      var cardList = this.props.location.state.cardList;

      var zdnum = __WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount);
      var minRedeemRatestr = cardList[this.props.selectCurrentIndex].minRedeemRate;
      var maxRedeemRatestr = cardList[this.props.selectCurrentIndex].maxRedeemRate;
      // if(minRedeemRatestr<=e.target.value*1 && maxRedeemRatestr>=e.target.value){
      if (e.target.value == "10") {
        this.setState({ Colr: 0.1 });
      } else if (e.target.value == "20") {
        this.setState({ Colr: 0.2 });
      } else if (e.target.value == "30") {
        this.setState({ Colr: 0.3 });
      } else if (e.target.value == "50") {
        this.setState({ Colr: 0.5 });
      } else if (e.target.value == "80") {
        this.setState({ Colr: 0.8 });
      } else if (e.target.value == "100") {
        this.setState({ Colr: 1 });
      } else {
        this.setState({ Colr: "" });
      }
      // }else{
      //   this.setState({Colr:""})
      // }
      var maxmin = "";
      if (minRedeemRatestr > e.target.value * 1 || maxRedeemRatestr < e.target.value * 1) {
        if (e.target.value * 1 == 100 && zdnum > 0) {
          this.setState({
            BoolVlue: false
          });
          maxmin = false;
        } else {
          this.setState({
            BoolVlue: true
          });
          maxmin = true;
        }
      } else {
        this.setState({
          BoolVlue: false
        });
        maxmin = false;
      }
      if (e.target.value === "") {
        this.setState({
          BoolVlue: false,
          BoolVlues: false
        });
        maxmin = false;
      } else {
        this.setState({
          BoolVlues: true
        });
      }
      this.setState({
        text: e.target.value * 1 / 100 * zdnum,
        baiFen: e.target.value
      });
      var flag = __WEBPACK_IMPORTED_MODULE_5__util___default.a.regular1.test(e.target.value);
      if (flag && e.target.value !== '' && !maxmin) {
        this.setState({
          btnFlag: true
        });
      } else {
        this.setState({
          btnFlag: false
        });
      }
    }
  }, {
    key: 'choseBank',
    value: function choseBank() {
      var _this6 = this;

      var cardList = this.props.location.state.cardList;

      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/RedeemBankList',
        state: {
          dataSouse: cardList,
          Fun: function Fun(i) {
            _this6.setState({ Num: i });
          }
        }
      });
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        keyPasswordVal: val
      });
    }
  }, {
    key: 'btnCallBack1',
    value: function btnCallBack1() {}
  }, {
    key: 'btnCallBack2',
    value: function btnCallBack2() {}
  }, {
    key: 'keyOk',
    value: function keyOk() {
      var _props2 = this.props,
          navigator = _props2.navigator,
          businessType = _props2.businessType,
          dispatch = _props2.dispatch,
          bankOrCurrent = _props2.bankOrCurrent,
          selectCurrentIndex = _props2.selectCurrentIndex,
          keyPasswordVal = _props2.keyPasswordVal,
          trustChannelShare = _props2.trustChannelShare;
      var _props$location$state3 = this.props.location.state,
          cardList = _props$location$state3.cardList,
          fundCode = _props$location$state3.fundCode,
          fundName = _props$location$state3.fundName;

      if (!cardList) {
        return;
      }
      var baiFen = this.state.baiFen;

      var _this = this;
      var pushResult = function pushResult(i, result) {
        console.log(i, result);
        if (i == 1) {
          __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '赎回完成',
              content: '您的赎回申请已被受理',
              dataSouse: [['申请编号', result.content], ['产品名称', fundName], ['赎回比例', baiFen.replace(/[^0-9]/ig, "") + "%"]],
              souseVal: ['查看我的智投']
            }
          });
        } else if (i == 3) {
          __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '赎回完成',
              content: '很抱歉,赎回申请失败。',
              content2: result,
              dataSouse: [],
              souseVal: ['查看我的智投']
            }
          });
        }
      };
      if (this.state.currencyArr[this.props.currencyIndex].fundname == "活期通" && this.state.active == 1) {
        var data = {
          fundCode: fundCode,
          largeRedemptionFlag: '1',
          trustChannelId: cardList[selectCurrentIndex].trustChannelId,
          redeemAmount: this.state.text,
          password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(this.state.keyPasswordVal),
          redeemRate: Number(this.state.baiFen.replace(/[^0-9]/ig, "")) //赎回比例
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["K" /* getRedeemToHqtvalidate */])(data, pushResult));
      } else {
        if (this.state.active == 1) {
          var _data = {
            superFundCode: fundCode,
            monetaryFund: this.state.currencyArr[this.props.currencyIndex].fundcode,
            trustChannelId: cardList[selectCurrentIndex].trustChannelId,
            password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(this.state.keyPasswordVal),
            redeemToCard: false,
            redeemRate: Number(this.state.baiFen.replace(/[^0-9]/ig, "")) //赎回比例
          };
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["G" /* getDoRedeemSuper */])(_data, pushResult));
        } else {
          var _data2 = {
            superFundCode: fundCode,
            trustChannelId: cardList[selectCurrentIndex].trustChannelId,
            password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(this.state.keyPasswordVal),
            redeemToCard: true,
            redeemRate: Number(this.state.baiFen.replace(/[^0-9]/ig, "")) //赎回比例
          };
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["G" /* getDoRedeemSuper */])(_data2, pushResult));
        }
      }
    }
  }, {
    key: 'allConver',
    value: function allConver() {
      var _props$location$state4 = this.props.location.state,
          totalAmount = _props$location$state4.totalAmount,
          cardList = _props$location$state4.cardList;
      var _props3 = this.props,
          trustChannelShare = _props3.trustChannelShare,
          selectCurrentIndex = _props3.selectCurrentIndex;

      if (!cardList) {
        return;
      }
      this.setState({
        text: __WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(cardList[selectCurrentIndex].canRedeemAmount, 2).toString()
      });
      if (cardList[selectCurrentIndex].canRedeemAmount !== 0) {
        this.setState({
          btnFlag: true
        });
      }
    }
  }, {
    key: 'choseTab',
    value: function choseTab(i) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["H" /* dianji */])(i));
      this.setState({
        active: i
      });
    }
  }, {
    key: 'ChoseCurrency',
    value: function ChoseCurrency() {
      this.setState({
        Bool: true
      });
      // hashHistory.push({
      //   pathname: "/RedeemCurrencyList",
      //   query:{
      //     dataSouse:this.state.currencyArr
      //   },
      //   state: {
      //     dataSouse:this.state.currencyArr

      //   }
      // });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this7 = this;

      var cardList = this.props.location.state.cardList;

      var zdnum = __WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount);
      if (zdnum == 0) {
        this.setState({ numVal: "0" });
      }
      this.setState({ active: this.props.dianji ? this.props.dianji : 1 });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["D" /* getFundsInfo */])(function (result) {
        _this7.getFundsInfo(result);
      }));
      if (cardList[this.props.selectCurrentIndex].maxRedeemRate == 100 && cardList[this.props.selectCurrentIndex].minRedeemRate == 100) {
        this.setState({
          Colr: 1,
          text: zdnum,
          baiFen: "100%"
        });
        if (__WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(cardList[this.props.selectCurrentIndex].canRedeemAmount) > 0) {
          this.setState({ btnFlag: true });
        } else {
          this.setState({ btnFlag: false });
        }
      }
    }
  }, {
    key: 'changeIndex',
    value: function changeIndex(item, i) {
      this.setState({
        Bool: false
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["J" /* choseCurrencyIndex */])(i));
    }
  }, {
    key: 'fanhui',
    value: function fanhui() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction__["H" /* dianji */])(1));
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      console.log(Number(this.state.baiFen.replace(/[^0-9]/ig, "")));
      var _props$location$state5 = this.props.location.state,
          fundName = _props$location$state5.fundName,
          fundCode = _props$location$state5.fundCode,
          totalAmount = _props$location$state5.totalAmount,
          cardList = _props$location$state5.cardList; //nav 传入

      var jinVal = cardList[this.props.selectCurrentIndex].minRedeemRate + "%-" + cardList[this.props.selectCurrentIndex].maxRedeemRate + "%" + "或100%";
      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      var icon = [__webpack_require__(125), __webpack_require__(693)];
      console.log(cardList, this.state.text);
      var _this = this;
      var selectCurrentIndex = this.props.selectCurrentIndex;
      var Colr = this.state.Colr;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'headerblacks' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  _this8.fanhui();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.36rem" } },
              '\u8D4E\u56DE'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { width: "44px" } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content' },
          this.state.Bool ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this8.setState({ Bool: false });
              }, style: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 100 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { position: "fixed", bottom: 0, left: 0, width: "100%", height: "50%", background: "#fff", overflow: "auto", borderTopLeftRadius: "0.2rem", borderTopRightRadius: "0.2rem", paddingTop: ".4rem" } },
              this.state.currencyArr.map(function (item, i) {
                if (item.fundname == "活期通") {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { key: i, className: 'currencyList', onClick: function onClick() {
                        return _this8.changeIndex(item, i);
                      } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        item.fundname
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { color: '#666666', fontSize: 14 } },
                        item.fundtext
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: 'bankListRightOK' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: _this8.props.currencyIndex === i ? icon[1] : icon[0], className: _this8.props.currencyIndex === i ? 'xuanzhongimg' : "img" })
                    )
                  );
                } else {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { key: i, className: 'currencyList', onClick: function onClick() {
                        return _this8.changeIndex(item, i);
                      } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16, fontWeight: "500" } },
                        item.fundname,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'span',
                          { style: { color: "#cccccc", fontSize: "0.3rem", marginBottom: "0.04rem", flex: 1, marginLeft: ".08rem" } },
                          ">"
                        ),
                        i == 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'znyx' }) : null
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { color: '#F8515C', fontSize: ".32rem", fontWeight: "500" } },
                        item.wanfenshouyi,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { style: { color: '#F8515C', fontSize: ".32rem", fontWeight: "500", width: "2rem", marginLeft: "2rem", paddingLeft: "0.05rem" } },
                          item.qirinianhua,
                          '%'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { style: { color: '#666666' } },
                        '\u4E07\u5206\u6536\u76CA',
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                          'div',
                          { style: { width: "2rem", marginLeft: "2rem" } },
                          '7\u65E5\u5E74\u5316\u6536\u76CA'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'div',
                      { className: 'bankListRightOK' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: _this8.props.currencyIndex === i ? icon[1] : icon[0], className: _this8.props.currencyIndex === i ? 'xuanzhongimg' : "img" })
                    )
                  );
                }
              })
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'headerActive' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingTop: "3px" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this8.choseTab(1);
                  }, style: { fontSize: "0.32rem", fontWeight: "bold", color: this.state.active == 1 ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)' } },
                '\u8F6C\u51FA\u81F3\u8D27\u5E01\u57FA\u91D1'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this8.choseTab(2);
                  }, style: { fontSize: "0.32rem", fontWeight: "bold", color: this.state.active == 2 ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)' } },
                '\u8F6C\u51FA\u81F3\u94F6\u884C\u5361'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "flex", paddingTop: "0.1rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { flex: 1, textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: this.props.dianji == 1 ? 'active' : this.state.active == 1 ? "active" : null })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { flex: 1, textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: this.props.dianji == 2 ? 'active' : this.state.active == 2 ? "active" : null })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'contentHeader' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: "0.32rem", fontWeight: "500", color: '#333333' } },
              this.props.location.state.fundName + '(' + this.props.location.state.fundCode + ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginTop: "10px", backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingLeft: "0.26rem", paddingRight: "0.26rem", paddingTop: "0.2rem", paddingBottom: "0.4rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: "0.32rem", marginRight: "0.8rem", fontWeight: "500", color: '#333333' } },
                '\u8F6C\u51FA\u6BD4\u4F8B'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: "#999999" } },
                this.state.BoolVlue ? "｜" : ""
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: "red", fontSize: "0.24rem" } },
                this.state.BoolVlue ? "转出比例超限" : ""
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'input' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: "0.48rem", fontWeight: "500", color: '#333333' } },
                '\xA5'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                disabled: __WEBPACK_IMPORTED_MODULE_5__util___default.a.superFundCodeArrByTarget.indexOf(fundCode) != -1 ? true : false
                //  disabled={false} 
                , autocomplete: 'off', placeholder: '\u53EF\u8F6C\u51FA\u6BD4\u4F8B' + jinVal, onChange: function onChange(e) {
                  return _this8.onChangeText(e);
                }, type: 'text', value: this.state.baiFen, style: { backgroundColor: "#fff", fontSize: "0.38rem", fontWeight: "500", color: '#333333', marginLeft: "-20px" } }),
              this.state.BoolVlues ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { fontSize: "0.38rem", fontWeight: "500", color: '#333333', paddingTop: "0.1rem" } },
                '%'
              ) : null
            ),
            cardList && cardList.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "flex", paddingBottom: "30px", paddingTop: "20px", paddingLeft: "13px" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: cardList[this.props.selectCurrentIndex].maxRedeemRate >= 10 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 10 ? function () {
                    _this8.onFun(0.1);
                  } : function () {}, className: [cardList[this.props.selectCurrentIndex].maxRedeemRate >= 10 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 10 ? Colr == 0.1 ? "biliss" : "bili" : "bilis"] },
                '10%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: cardList[this.props.selectCurrentIndex].maxRedeemRate >= 20 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 20 ? function () {
                    _this8.onFun(0.2);
                  } : function () {}, className: [cardList[this.props.selectCurrentIndex].maxRedeemRate >= 20 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 20 ? Colr == 0.2 ? "biliss" : "bili" : "bilis"] },
                '20%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: cardList[this.props.selectCurrentIndex].maxRedeemRate >= 30 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 30 ? function () {
                    _this8.onFun(0.3);
                  } : function () {}, className: [cardList[this.props.selectCurrentIndex].maxRedeemRate >= 30 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 30 ? Colr == 0.3 ? "biliss" : "bili" : "bilis"] },
                '30%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: cardList[this.props.selectCurrentIndex].maxRedeemRate >= 50 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 50 ? function () {
                    _this8.onFun(0.5);
                  } : function () {}, className: [cardList[this.props.selectCurrentIndex].maxRedeemRate >= 50 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 50 ? Colr == 0.5 ? "biliss" : "bili" : "bilis"] },
                '50%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: cardList[this.props.selectCurrentIndex].maxRedeemRate >= 80 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 80 ? function () {
                    _this8.onFun(0.8);
                  } : function () {}, className: [cardList[this.props.selectCurrentIndex].maxRedeemRate >= 80 && cardList[this.props.selectCurrentIndex].minRedeemRate <= 80 ? Colr == 0.8 ? "biliss" : "bili" : "bilis"] },
                '80%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this8.onFun(1);
                  }, className: [Colr == 1 ? "biliss" : "bili"] },
                '100%'
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "flex", paddingBottom: "30px", paddingTop: "20px", paddingLeft: "13px" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {}, className: ["bilis"] },
                '10%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {}, className: ["bilis"] },
                '20%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {}, className: ["bilis"] },
                '30%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {}, className: ["bilis"] },
                '50%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {}, className: ["bilis"] },
                '80%'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this8.onFun(1);
                  }, className: [Colr == 1 ? "biliss" : "bili"] },
                '100%'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'shares' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "flex", flex: 1, fontSize: "0.32rem", fontWeight: "500", color: '#333333' } },
              '\u8F6C\u51FA\u8D44\u91D1\u6765\u6E90'
            ),
            cardList ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this.choseBank();
                }, className: 'bankList' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_3__BankCode__["b" /* bankCode */]['ty'][cardList[selectCurrentIndex].bankCode] ? __WEBPACK_IMPORTED_MODULE_3__BankCode__["b" /* bankCode */]['ty'][cardList[selectCurrentIndex].bankCode] : __webpack_require__(39), style: { width: ".3rem", height: ".3rem", marginTop: ".4rem", marginRight: "5px" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'bankListTip' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  cardList[selectCurrentIndex].trustChannelName
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  '\u53EF\u8D4E\u56DE\u91D1\u989D:',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: "#B69271" } },
                    __WEBPACK_IMPORTED_MODULE_5__util___default.a.parsePrice(cardList[selectCurrentIndex].canRedeemAmount),
                    '\u5143'
                  )
                ),
                !cardList[selectCurrentIndex].allAmountCanUse ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { color: 'rgb(104,113,126)', fontSize: 10, paddingTop: 2 } },
                  "部分成分基金暂停赎回/转换",
                  ' '
                ) : null
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'bankListRight' })
            ) : null
          ),
          this.state.active == 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'redeemCurrency', onClick: function onClick() {
                return _this8.ChoseCurrency();
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: "0.32rem", fontWeight: "500", color: '#333333' } },
              '\u8F6C\u51FA\u81F3'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontWeight: "400", color: '#333333' } },
              this.state.currencyArr.length > 0 && this.state.currencyArr[this.props.currencyIndex] ? this.state.currencyArr[this.props.currencyIndex].fundname : '--',
              this.props.currencyIndex == 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'znyx' }) : null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'rightImg' })
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                paddingLeft: "13px",
                flexDirection: "row",
                display: 'flex',
                height: "20px",
                marginTop: "10px",
                fontSize: "0.24rem",
                alignItems: 'center'
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { color: "#B69271" } },
              '\u9884\u8BA1'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'red-ts' },
              this.props.dianji ? this.props.dianji == 1 ? this.state.expectedDateArr.moneyFundExpectedDate : this.state.expectedDateArr.bankCardExpectedDate : this.state.expectedDateArr.moneyFundExpectedDate
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { color: '#999999' } },
              '\u5230\u8D26\uFF0C\u8BF7\u4EE5\u5B9E\u9645\u5230\u8D26\u65F6\u95F4\u4E3A\u51C6'
            )
          ),
          this.state.btnFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                cardList[selectCurrentIndex].allAmountCanUse ? cardList[selectCurrentIndex].status == 'adjust' ? _this8.setState({ Tiac: true }) : _this8.next() : _this8.setState({ Tiac: true });
              }, className: 'btn' },
            '\u63D0\u4EA4'
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray' },
            '\u63D0\u4EA4'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginTop: 30 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'footer',
              { className: 'superFooter' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { height: 30, fontSize: "12px", color: "#999999", fontWeight: "bold" } },
                '\u7279\u522B\u63D0\u793A :'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { color: '#999999', fontSize: "12px", lineHeight: '22px', fontWeight: "bold" } },
                '1\u3001\u672C\u4E1A\u52A1\u6682\u4E0D\u652F\u6301\u64A4\u5355\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { color: '#999999', fontSize: "12px", lineHeight: '22px', fontWeight: "bold" } },
                '2\u3001\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { color: '#999999', fontSize: "12px", lineHeight: '22px', fontWeight: "bold" } },
                '3\u3001\u57FA\u91D1\u51C0\u503C\u4F1A\u56E0\u8BC1\u5238\u5E02\u573A\u6CE2\u52A8\u7B49\u56E0\u7D20\u6CE2\u52A8\uFF0C\u53EF\u80FD\u5BFC\u81F4\u635F\u5931\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { color: '#999999', fontSize: "12px", lineHeight: '22px', fontWeight: "bold" } },
                '4\u3001\u7BA1\u7406\u4EBA\u6295\u8D44\u5224\u65AD\u4F1A\u6709\u5DEE\u5F02\u4ECE\u800C\u5F71\u54CD\u57FA\u91D1\u7684\u6536\u76CA\u6C34\u5E73\uFF0C\u53EF\u80FD\u53D1\u751F\u635F\u5931\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { color: '#999999', fontSize: "12px", lineHeight: '22px', fontWeight: "bold" } },
                '5\u3001\u82E5\u7BA1\u7406\u4EBA\u4E1A\u52A1\u6216\u8D22\u52A1\u72B6\u51B5\u53D8\u5316\uFF0C\u53EF\u80FD\u5F71\u54CD\u6295\u8D44\u8005\u5224\u65AD\uFF0C\u4E5F\u53EF\u80FD\u5BFC\u81F4\u635F\u5931\u3002'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { color: '#999999', fontSize: "12px", lineHeight: '22px', fontWeight: "bold" } },
                '6\u3001\u6295\u8D44\u8005\u53EF\u4EE5\u901A\u8FC7\u5F55\u97F3\u3001\u622A\u5C4F\u7B49\u65B9\u5F0F\u7559\u5B58\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u76F8\u5173\u4FE1\u606F\u3002'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Modal_ModalList__["a" /* default */], { flag: this.state.setModalShow, title: '\u6E29\u99A8\u63D0\u793A', content: '\u60A8\u7684\u8D4E\u56DE\u8D44\u91D1\u5C06\u81EA\u52A8\u7533\u8D2D\u4E3A\u534E\u590F\u8D22\u5BCC\u96F6\u94B1\u5B9D\u8D27\u5E01\u4EFD\u989D\uFF0C\u5728\u7EC4\u5408\u8D4E\u56DE\u6210\u529F\u540E\uFF0C\u60A8\u53EF\u4EE5\u5728\u534E\u590F\u8D22\u5BCCAPP\u6216\u5B98\u7F51\u67E5\u8BE2\u96F6\u94B1\u5B9D\u4EFD\u989D\u3002', btnRight: '\u6211\u77E5\u9053\u4E86', btnRightFun: this.agreeFunSec }),
        this.state.partialRedeem ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Modal_ModalList__["b" /* SuperModalTwo */], { title: '\u6E29\u99A8\u63D0\u793A', content: '\u7531\u4E8E\u90E8\u5206\u6210\u5206\u57FA\u91D1\u6682\u505C\u8D4E\u56DE/\u8F6C\u6362\uFF0C\u73B0\u5728\u8D4E\u56DE\u53EF\u80FD\u4F1A\u5F71\u54CD\u60A8\u540E\u7EED\u6295\u8D44\u65B9\u6848\uFF0C\u662F\u5426\u7EE7\u7EED\uFF1F',
          buttonText1: "继续赎回", buttonText2: '\u6211\u518D\u60F3\u60F3',
          handleBtnOne: function handleBtnOne() {
            _this8.next();_this8.setState({ partialRedeem: false });
          },
          handleBtnTwo: function handleBtnTwo() {
            _this8.setState({ partialRedeem: false });
          },
          handleCancel: function handleCancel() {
            _this8.setState({ partialRedeem: false });
          }
        }) : null,
        this.state.Tiac ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Modal_ModalList__["b" /* SuperModalTwo */], { title: '', content: '\u60A8\u6301\u6709\u7EC4\u5408\u6B63\u5728\u8C03\u4ED3\uFF0C\u73B0\u5728\u8D4E\u56DE\u4F1A\u5BFC\u81F4\u6301\u4ED3\u504F\u79FB\uFF0C\u786E\u5B9A\u8981\u8F6C\u51FA\u5417\uFF1F',
          buttonText1: "确认转出", buttonText2: '\u6211\u518D\u60F3\u60F3',
          handleBtnOne: function handleBtnOne() {
            _this8.next();_this8.setState({ Tiac: false });
          },
          handleBtnTwo: function handleBtnTwo() {
            _this8.setState({ Tiac: false });
          },
          handleCancel: function handleCancel() {
            _this8.setState({ Tiac: false });
          }
        }) : null,
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__myAssets_payment_Password__["a" /* default */], { _this: this }) : null,
        this.state.sevenDayFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__fundDetail_AlerModle__["a" /* AlerModleCommon */], {
          btnTxt1: '\u786E\u8BA4',
          btnTxt2: '\u53D6\u6D88',
          content: "自交易日2018年3月30日起，若投资者赎回除货币及交易型开放式指数基金以外的开放式基金时持续持有期少于7日（自然日），将被收取不低于1.5%的赎回费。具体赎回费率请参见产品说明。",
          title: '\u7279\u522B\u63D0\u793A',
          handleClick1: function handleClick1() {
            _this8.onNext();
          },
          handleClick2: function handleClick2() {
            _this8.setState({ sevenDayFlag: false });
          }
        }) : null
      );
    }
  }]);

  return RedeemSuperFund;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    selectCurrentIndex: state.selectCurrentIndex,
    currencyIndex: state.currencyIndex,
    dianji: state.dianji
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(RedeemSuperFund));

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__success_css__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__success_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__success_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var WebView = function (_Component) {
  _inherits(WebView, _Component);

  function WebView(props) {
    _classCallCheck(this, WebView);

    var _this = _possibleConstructorReturn(this, (WebView.__proto__ || Object.getPrototypeOf(WebView)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(WebView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = this.props.location.state.title;
    }
  }, {
    key: 'next',
    value: function next(name) {
      var _this2 = this;

      if (name === '返回我的智投' || name == '返回智投首页') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name === '返回华夏智投') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name === '查看银行卡') {
        // this.props.dispatch({
        //   type:"SUPER_FUND_PAY_INFO",
        //   text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
        // });
        // this.props.dispatch({
        //   type:"SUPER_FUND_DT_PAY_INFO",
        //   text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
        // });
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-4);
        setTimeout(function () {
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_productAction__["I" /* getTradeInfo */])(_this2.props.location.state.fundCode, 'T522', _this2.props.location.state.productType, function (result, i, type) {
            Object.assign(result, { currentType: type }, { currentIndex: i });
            _this2.props.dispatch({
              type: "SUPER_FUND_PAY_INFO",
              text: result
            });
          }));
        });
      } else if (name === '查看定投计划') {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
          pathname: '/InvestmentPlan'
        });
      } else if (name === '返回我的资产') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name === '查看我的投资') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name === '返回产品首页') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
      } else if (name == '查看交易详情') {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
          pathname: '/TransactionDetail',
          state: {
            data: { tradeRequestId: this.props.location.state.dataSouse[0][1] },
            flag: 'JL'
          }
        });
      } else if (name == '完成') {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].replace({
          pathname: '/SubscriptionDetail?enterType=SubscriptionDetail'
        });
      } else if (name == '返回') {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-1);
        this.props.dispatch({
          type: "SUPER_FUND_PAY_INFO",
          text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
        });
        this.props.dispatch({
          type: "SUPER_FUND_DT_PAY_INFO",
          text: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [] }, currentType: 4, currentIndex: 0 }
        });
      }
    }
  }, {
    key: 'goDetail',
    value: function goDetail(name) {
      if (name === '返回我的智投' || name == '返回智投首页' || name === '返回华夏智投' || name === '查看我的智投') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["h" /* goHome */])();
        return;
      }
      var SupperFundHome = this.props.SupperFundHome;
      var fundCode = this.props.location.state.fundCode;

      console.log(SupperFundHome, fundCode);
      var pathName = "";
      if (this.props.location.state.superTypeValue === "1") {
        pathName = '/TargetProfitHaveCast';
      } else {
        pathName = '/SuperFundDetailHaveCast';
      }
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: pathName,
        state: {
          superFundCode: fundCode
        },
        query: {
          superFundCode: fundCode
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$location$state = this.props.location.state,
          superFundConfirmAndIncomeDate = _props$location$state.superFundConfirmAndIncomeDate,
          businessType = _props$location$state.businessType;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.props.location.state.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'success-box' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(1902), style: { width: '1.24rem', height: '1.24rem' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { marginTop: '0.3rem', height: '0.9rem', color: '#333333', fontSize: '.36rem' } },
              this.props.location.state.content
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: '100%', marginTop: '.5rem' } },
              this.props.location.state.dataSouse.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: 'cq' + i, className: 'success-bar' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    item[0]
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { color: _this3.props.location.state.dataSouse.length - 1 == i ? "#B69271" : "#333333" } },
                    item[1]
                  )
                );
              })
            )
          ),
          businessType && (businessType == 'T522' || businessType == 'T422' || businessType == 'T822') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'success\u2014step' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'row', height: '.6rem', alignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'step-circle-ed' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { color: '#333333', fontSize: '.28rem', lineHeight: '.4rem' } },
                '\u7533\u8BF7\u5DF2\u53D7\u7406'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '1px', height: '.8rem', backgroundColor: '#BF9B79', marginLeft: '4.5px', marginTop: '-.2rem' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'row', height: '.6rem', alignItems: 'center', marginTop: '-.2rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'step-circle-ing' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { color: '#333333', fontSize: '.28rem', lineHeight: '.4rem' } },
                superFundConfirmAndIncomeDate.buyConfirmDate && superFundConfirmAndIncomeDate.buyConfirmWeek ? '\u9884\u8BA1' + superFundConfirmAndIncomeDate.buyConfirmDate + ' ' + superFundConfirmAndIncomeDate.buyConfirmWeek + ' 15:00\u524D\u786E\u8BA4\u4EFD\u989D' : '\u9884\u8BA1 -- \u524D\u786E\u8BA4\u4EFD\u989D'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '1px', height: '.8rem', backgroundColor: '#D9D9D9', marginLeft: '4.5px', marginTop: '-.2rem' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'row', height: '.6rem', alignItems: 'center', marginTop: '-.2rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'step-circle-ing' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { color: '#333333', fontSize: '.28rem', lineHeight: '.4rem' } },
                superFundConfirmAndIncomeDate.buyIncomeDate && superFundConfirmAndIncomeDate.buyIncomeWeek ? '\u9884\u8BA1' + superFundConfirmAndIncomeDate.buyIncomeDate + ' ' + superFundConfirmAndIncomeDate.buyIncomeWeek + ' \u5F00\u59CB\u67E5\u770B\u6536\u76CA' : '\u9884\u8BA1 -- \u5F00\u59CB\u67E5\u770B\u6536\u76CA'
              )
            )
          ) : null,
          this.props.location.state.souseVal.map(function (item, i) {
            if (i == 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'bt' + i, onClick: function onClick() {
                    return _this3.goDetail(item);
                  }, className: 'btn-yellow' },
                item
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'bt' + i, onClick: function onClick() {
                    return _this3.next(item);
                  }, className: 'btn btn-white' },
                item
              );
            }
          })
        )
      );
    }
  }]);

  return WebView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(WebView));

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var width = window.screen.width;

var Transfer = function (_Component) {
  _inherits(Transfer, _Component);

  function Transfer(props) {
    _classCallCheck(this, Transfer);

    var _this2 = _possibleConstructorReturn(this, (Transfer.__proto__ || Object.getPrototypeOf(Transfer)).call(this, props));

    _this2.state = {
      pwdFlag: false,
      transferVal: '',
      transferFlag: false,
      text: ''

    };
    _this2.userMsg = { nickName: null, mobileNo: null, name: null };
    return _this2;
  }

  _createClass(Transfer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var dispatch = this.props.dispatch;

      this.getUserMsg();
      if (this.props.location.state.type === 1) {
        document.title = "调整组合";
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_64" /* getAdjustDetail */])({ superFundCode: this.props.location.state.superFundCode }, function (result) {
          return _this3.transferFlag(result);
        }));
      } else {
        document.title = "季度调仓";
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_65" /* getSeasonDetail */])({ superFundCode: this.props.location.state.superFundCode }));
      }
    }
  }, {
    key: 'getUserMsg',
    value: function getUserMsg() {
      this.userMsg = JSON.parse(localStorage.currentUserInfo).userMsg;
      console.log(this.userMsg);
    }
  }, {
    key: 'transferFlag',
    value: function transferFlag(result) {
      this.setState({
        transferVal: result.code,
        transferFlag: true
      });
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'showKeyboard',
    value: function showKeyboard() {
      var dispatch = this.props.dispatch;

      if (this.state.transferVal == '') {
        this.setState({
          pwdFlag: true
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__["Toast"].info(this.state.transferVal, 2);
      }
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        text: val
      });
    }
  }, {
    key: 'transfer',
    value: function transfer(type) {
      var _this = this;
      var pushResult = function pushResult(i, result) {
        if (i == 1) {
          __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '调仓申请结果',
              content: '您的调仓申请已被受理！',
              dataSouse: [['申请编号', result.content.tradeRequestIds], ['下单时间', __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(result.content.businessTime, true)], ['所属交易日', __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(result.content.requestWorkday)]],
              souseVal: ['返回华夏智投']
            }
          });
        } else if (i == 3) {
          __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '调仓申请结果',
              content: '很抱歉，您的组合调仓申请失败！',
              content2: result,
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        }
      };
      var date = { flag: 1, superFundCode: this.props.location.state.superFundCode, password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(this.state.text) };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_66" /* getUpdateSeason */])(date, pushResult));
    }
  }, {
    key: 'btnCallBack1',
    value: function btnCallBack1() {}
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      console.log(this.props.location.state);
      var _props$location$state = this.props.location.state,
          type = _props$location$state.type,
          superFundCode = _props$location$state.superFundCode,
          isZJ = _props$location$state.isZJ;
      var inSeasonDetail = this.props.inSeasonDetail;

      console.log(inSeasonDetail.previewItemFundsChart, '------');
      var pieImg = "";
      var name = '';
      var _img = __WEBPACK_IMPORTED_MODULE_4__util___default.a.superFundTextArr(superFundCode, "Transfer")[1];
      pieImg = __webpack_require__(780)("./" + _img);
      name = __WEBPACK_IMPORTED_MODULE_4__util___default.a.superFundTextArr(superFundCode, "Transfer")[0];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
              type === 1 ? '调整组合' : '季度调仓'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { WebkitFlex: 1, overflow: "auto" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'content', style: { paddingBottom: '50px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'topBackground' },
              isZJ == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                (this.userMsg.name ? this.userMsg.name : this.userMsg.mobileNo) + ' \u60A8\u597D\uFF0C\u6B22\u8FCE\u60A8\u7EE7\u7EED\u8D2D\u4E70' + inSeasonDetail.superFund.fundName + '\u3002\u7531\u4E8E\u60A8\u5F53\u524D\u6301\u6709\u7684\u7EC4\u5408\u4E0E\u6807\u51C6\u7EC4\u5408\u5B58\u5728\u504F\u5DEE\uFF0C\u5728\u8D2D\u4E70\u524D\u9700\u8981\u5BF9\u60A8\u5F53\u524D\u6301\u6709\u7684\u7EC4\u5408\u8FDB\u884C\u8C03\u6574\uFF0C\u8C03\u6574\u60C5\u51B5\u5982\u4E0B\uFF1A'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                (this.userMsg.name ? this.userMsg.name : this.userMsg.mobileNo) + '  \u60A8\u597D\uFF0C\u6839\u636E\u5E02\u573A\u73AF\u5883\u5206\u6790\uFF0C\u67E5\u7406\u5BF9' + inSeasonDetail.superFund.fundName + '\u8FDB\u884C\u4E86\u8C03\u6574\uFF0C\u4E3A\u4FDD\u8BC1\u667A\u6295\u7EC4\u5408\u7684\u6301\u7EED\u7A33\u5B9A\u6536\u76CA\uFF0C\u5E76\u4FDD\u8BC1\u6700\u4F73\u7684\u98CE\u9669\u6536\u76CA\u6BD4\uFF0C\u5EFA\u8BAE\u60A8\u540C\u6B65\u8FDB\u884C\u66F4\u65B0\u3002\u8C03\u6574\u60C5\u51B5\u5982\u4E0B\uFF1A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", marginTop: '0.12rem', padding: '0 13px', height: '40px', WebkitAlignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: '12px', color: "#000", WebkitFlex: 1 } },
                type == 1 ? '调仓明细' : '最新组合配置'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'gary12' },
                inSeasonDetail.superFund.nextAdjustDate.substring(0, 10) + '更新'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { background: '#fff', position: 'relative' } },
              inSeasonDetail.previewItemFunds.length == 0 ? null : [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pieImg, style: { position: 'absolute', top: 300 / 2 - 32, left: width * 0.3 - 32, width: '64px', height: '64px' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransferPie, { inSeasonDetail: inSeasonDetail })]
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: {} },
                '\u8C03\u4ED3\u660E\u7EC6'
              )
            ),
            inSeasonDetail.previewItemFunds.map(function (item, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'list' + i, style: { display: "-webkit-flex", background: '#fff', height: '0.9rem', padding: '0 13px', borderBottom: '0.005rem solid rgb(224,227,279)' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12', style: { WebkitFlex: 1, lineHeight: '0.9rem' } },
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { lineHeight: '0.9rem' } },
                  __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.holdRate * 100) + '%→' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.targetRegularRate * 100) + '%'
                )
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 6 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: '0.9rem', marginLeft: '13px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u9884\u4F30\u6210\u672C'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", background: '#fff', height: '0.9rem', padding: '0 13px', borderBottom: '0.005rem solid rgb(224,227,279)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'gary12', style: { fontSize: '12px', WebkitFlex: 1, lineHeight: '0.9rem' } },
                '\u9884\u8BA1\u53D1\u751F\u8D39\u7528'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { lineHeight: '0.9rem' } },
                inSeasonDetail.fee != null ? __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(inSeasonDetail.fee) + "元" : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", background: '#fff', height: '0.9rem', padding: '0 13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'gary12', style: { fontSize: '12px', WebkitFlex: 1, lineHeight: '0.9rem' } },
                '\u9884\u8BA1\u5B8C\u6210\u65F6\u95F4'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { lineHeight: '0.9rem' } },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(inSeasonDetail.needDays) + '日'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", marginTop: '0.4rem', background: '#fff', height: '0.9rem', padding: '0 13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'gary12', style: { lineHeight: '0.9rem' } },
                '\u6E29\u99A8\u63D0\u793A\uFF1A\u9884\u8BA1\u6210\u672C\u4EC5\u4F9B\u53C2\u8003\uFF0C\u8BF7\u4EE5\u5B9E\u9645\u53D1\u751F\u8D39\u7528\u4E3A\u51C6\u3002'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'fixed', bottom: 0, width: '100%', borderTop: '1px solid rgb(224,227,229)' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: '#5b6370', display: "-webkit-flex", WebkitAlignItems: 'center', overflow: 'hidden', border: '1px solid rgb(224,227,279)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack, style: { background: 'rgba(242,245,247,1)', textAlign: 'center', height: '40px', WebkitFlex: 1, display: "-webkit-flex",
                    WebkitFlexDirection: 'column',
                    WebkitJustifyContent: 'center',
                    WebkitAlignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(385), style: { width: 18, height: 18 } }),
                '\u6682\u4E0D\u8C03\u4ED3'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { onClick: function onClick() {
                    return _this4.showKeyboard(type);
                  }, style: { color: '#fff', backgroundColor: '#fa063a', textAlign: 'center', height: '40px', lineHeight: '40px', WebkitFlex: 3 } },
                '\u786E\u8BA4\u8C03\u4ED3'
              )
            )
          ),
          this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'fixed', top: 0, width: '100%', height: '100%', background: 'rgba(52,52,52,0.4)' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'fixed', bottom: 0, width: '100%', height: '70%', background: '#fff' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { position: 'relative', height: '0.9rem', lineHeight: '0.9rem', textAlign: 'center', borderBottom: '0.005rem solid rgb(224,227,279)' } },
                '\u4EA4\u6613\u5BC6\u7801',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), style: { position: 'absolute', left: 0, width: '0.88rem', height: '0.88rem' }, onClick: function onClick() {
                    _this4.setState({ pwdFlag: false });
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { position: 'absolute', top: 0, right: 0, width: '0.9rem' }, onClick: function onClick() {
                      _this4.transfer(type);
                    } },
                  ' \u786E\u8BA4'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: '0.9rem', padding: '13px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                    return _this4.onChangePwd(e.target.value);
                  }, autofocus: 'autofocus', style: { height: '0.9rem', width: '100%', fontSize: '0.3rem', border: '1px solid #afafaf', borderRadius: '0.1rem' }, type: 'password', placeholder: '' })
              )
            )
          ) : null
        )
      );
    }
  }]);

  return Transfer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function compare(prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 > val2) {
      return -1;
    } else if (val1 < val2) {
      return 1;
    } else {
      return 0;
    }
  };
}

var TransferPie = function (_Component2) {
  _inherits(TransferPie, _Component2);

  function TransferPie() {
    _classCallCheck(this, TransferPie);

    return _possibleConstructorReturn(this, (TransferPie.__proto__ || Object.getPrototypeOf(TransferPie)).apply(this, arguments));
  }

  _createClass(TransferPie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inSeasonDetail = this.props.inSeasonDetail;

      var dataSouse = [];
      var dataSouseName = [];
      inSeasonDetail.previewItemFundsChart.sort(compare("srcRegularRate"));
      for (var i = 0; i < inSeasonDetail.previewItemFundsChart.length; i++) {
        var item = inSeasonDetail.previewItemFundsChart[i];

        var name = item.styleTypeName + __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.srcRegularRate * 100) + '%';
        dataSouse.push({ value: __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.srcRegularRate * 100), name: name });
        dataSouseName.push(name);
      }
      var corArr = ['#e85040', '#ff7242', '#28b7f6', '#7290fd', '#9bcd65', '#ab47bc'];
      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_6_echarts_lib_echarts___default.a.init(document.getElementById('TransferPie'));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_6_echarts_lib_echarts___default.a.init(document.getElementById('TransferPie'), null, { renderer: 'svg' });
      }
      // 绘制图表
      myChart.setOption(SuperPieOption(dataSouse, dataSouseName));
    }
  }, {
    key: 'render',
    value: function render() {

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'TransferPie', style: { width: "100%", height: 300 } });
    }
  }]);

  return TransferPie;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*饼图Option*/


function SuperPieOption(data, dataName) {
  var colorArr = [];
  if (dataName) {
    dataName.map(function (item, key) {
      if (item.indexOf("跨境权益") != -1) {
        colorArr.push("#4729c5");
      } else if (item.indexOf("国内权益") != -1) {
        colorArr.push("#e22424");
      } else if (item.indexOf("跨境债券") != -1) {
        colorArr.push("#f25a0f");
      } else if (item.indexOf("另类") != -1) {
        colorArr.push("#f0d331");
      } else if (item.indexOf("货币") != -1) {
        colorArr.push("#23c7e2");
      } else if (item.indexOf("国内债券") != -1) {
        colorArr.push("#034ab2");
      }
    });
  }
  var hg = 60;
  if (dataName.length <= 2) {
    hg = 20;
  } else if (dataName.length <= 4) {
    hg = 60;
  } else if (dataName.length <= 6) {
    hg = 80;
  } else if (dataName.length <= 8) {
    hg = 100;
  }

  var SuperPieOption = {
    animation: window.isLess47,
    calculable: true,
    legend: {
      y: 'center',
      x: 'left',
      left: width / 2 + 40,
      orient: 'vertical',
      data: dataName,
      //height:hg,
      itemWidth: 14,
      selectedMode: false,
      textStyle: { color: "auto" }
    },
    series: [{
      minAngle: 20,
      type: 'pie',
      hoverAnimation: false,
      radius: [44, 75],
      center: ['30%', '50%'],
      roseType: 'radius',
      data: data,
      label: {
        normal: {
          show: false
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }

    }],
    color: colorArr
  };
  return SuperPieOption;
}
function mapStateToProps(state, ownProps) {
  return {
    inSeasonDetail: state.inSeasonDetail
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Transfer));

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_Verification_css__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_Verification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_Verification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_myCardsAction_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var count = 120;

var Verification = function (_Component) {
  _inherits(Verification, _Component);

  function Verification(props) {
    _classCallCheck(this, Verification);

    var _this = _possibleConstructorReturn(this, (Verification.__proto__ || Object.getPrototypeOf(Verification)).call(this, props));

    _this.getRandomInt = function (min, max) {
      return Math.floor(min + Math.random() * max);
    };

    _this.state = {
      btnFlag: false,
      text: '',
      yzm: 0,
      cardVal: "获取验证码",
      checkFlag: false,
      dynamicCode: '',
      authRequestNo: ''
    };
    return _this;
  }

  _createClass(Verification, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      var params = this.props.location.query;
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'btnCallBack1',
    value: function btnCallBack1(x) {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].go(1 - x);
    }
  }, {
    key: 'next',
    value: function next(content, i) {
      __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__["Toast"].hide();
      var text = this.state.text;

      if (i == 1) {
        __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
          pathname: '/Success',
          state: {
            title: '添加银行卡',
            content: '您的银行卡已绑定成功',
            dataSouse: [],
            souseVal: ['查看银行卡'],
            fundCode: this.props.location.state.fundCode
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__["Toast"].info(content, __WEBPACK_IMPORTED_MODULE_7__util___default.a.ToastTime);
      }
    }
  }, {
    key: 'toAddBankCard',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var randomInt, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                randomInt = this.getRandomInt(1, 100000);

                this.setState({ loadingFlag: true });
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["b" /* getTempInfo */])('shortToken');

              case 4:
                _context.t0 = _context.sent;
                _context.t1 = this.props.location.state.mobileNo;
                _context.t2 = this.props.location.state.bankCode;
                _context.t3 = this.props.location.state.bankAccountShowNo;
                _context.t4 = this.state.text;
                _context.t5 = this.state.authRequestNo;
                _context.t6 = this.props.location.state.bankProtocolVersion;
                _context.t7 = this.props.location.state.upProtocolVersion;
                _context.t8 = __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type();
                _context.t9 = "hxcfH5" + randomInt;
                _context.t10 = this.props.location.state.trustChannelId;
                params = {
                  token: _context.t0,
                  mobileNo: _context.t1,
                  bankCode: _context.t2,
                  bankAccountShowNo: _context.t3,
                  captcha: _context.t4,
                  authRequestSNo: _context.t5,
                  bankProtocolVersion: _context.t6,
                  upProtocolVersion: _context.t7,
                  clientType: _context.t8,
                  clientDeviceNo: _context.t9,
                  paymentChannelId: _context.t10
                };

                __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__["Toast"].loading('', 0, function () {});
                console.log(params);
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myCardsAction_js__["b" /* addBankCard */])(params, function (content) {
                  return _this2.next(content, 1);
                }, function (msg) {
                  return _this2.next(msg, 2);
                }));

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toAddBankCard() {
        return _ref.apply(this, arguments);
      }

      return toAddBankCard;
    }()
  }, {
    key: 'onChangeText',
    value: function onChangeText(e) {
      this.setState({
        text: e.target.value
      });
      // let flag=Util.regular1.test(e.target.value)
      // if (flag&&e.target.value.length!==6) {
      //   this.setState({
      //       btnFlag:false
      //   })
      // }else{
      //   this.setState({
      //       btnFlag:true
      //   })
      // }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(window.timer);
    }
  }, {
    key: 'requestAuthenticationSuccess',
    value: function requestAuthenticationSuccess(content) {
      this.setState({ loadingFlag: false });
      this.setState({ authRequestNo: content.requestNo });
    }
  }, {
    key: 'requestAuthenticationError',
    value: function requestAuthenticationError(msg) {
      // this.setState({loadingFlag: false});
      __WEBPACK_IMPORTED_MODULE_9_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_7__util___default.a.ToastTime);
    }
  }, {
    key: 'getYZM',
    value: function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;

        var randomInt, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                randomInt = this.getRandomInt(1, 100000);
                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["b" /* getTempInfo */])('shortToken');

              case 3:
                _context2.t0 = _context2.sent;
                _context2.t1 = this.props.location.state.trustChannelId;
                _context2.t2 = this.props.location.state.bankAccountShowNo;
                _context2.t3 = this.props.location.state.mobileNo;
                _context2.t4 = __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type();
                _context2.t5 = "hxcfH5" + randomInt;
                params = {
                  token: _context2.t0,
                  paymentChannelId: _context2.t1,
                  bankAccountShowNo: _context2.t2,
                  mobileNo: _context2.t3,
                  businessType: 'AddCard',
                  clientType: _context2.t4,
                  clientDeviceNo: _context2.t5
                };

                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myCardsAction_js__["c" /* requestAuthentication */])(params, function (content) {
                  return _this3.requestAuthenticationSuccess(content);
                }, function (msg) {
                  return _this3.requestAuthenticationError(msg);
                }));

                this.setState({
                  yzm: 120
                });
                count = 120;

                window.timer = setInterval(function () {
                  if (count > 0) {
                    count -= 1;
                    this.setState({
                      yzm: count
                    });
                  } else {
                    clearInterval(window.timer);
                    count = 120;
                  }
                }.bind(this), 1000);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getYZM() {
        return _ref2.apply(this, arguments);
      }

      return getYZM;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      console.log(this.props.location.state);
      var flag = __WEBPACK_IMPORTED_MODULE_7__util___default.a.regular1.test(this.state.text);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'BindingMobile-header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u6DFB\u52A0\u94F6\u884C\u5361'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'share' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'shareTitle' },
              '\u8BF7\u8F93\u5165\u60A8\u6536\u5230\u7684\u77ED\u4FE1\u9A8C\u8BC1\u7801'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'Verification-input-box' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                return _this4.onChangeText(e);
              }, type: 'text', value: this.state.text, placeholder: '' }),
            this.state.yzm !== 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'Verification-input-yzm1 Verification-input-yzm2' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                this.state.yzm,
                '\u79D2\u540E\u91CD\u53D1'
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this4.getYZM();
                }, className: 'Verification-input-yzm1' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u83B7\u53D6\u9A8C\u8BC1\u7801'
              )
            )
          ),
          flag && this.state.authRequestNo ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this4.toAddBankCard();
              }, className: 'btn' },
            '\u4E0B\u4E00\u6B65'
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray' },
            '\u4E0B\u4E00\u6B65'
          )
        )
      );
    }
  }]);

  return Verification;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Verification));

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var WebView = function (_Component) {
  _inherits(WebView, _Component);

  function WebView(props) {
    _classCallCheck(this, WebView);

    var _this = _possibleConstructorReturn(this, (WebView.__proto__ || Object.getPrototypeOf(WebView)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(WebView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var dispatch = this.props.dispatch;

      var params = this.props.location.state;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_webViewContentAction_js__["a" /* getWebViewHtml */])(params, function () {
        _this2.succallback();
      }, function (msg) {
        _this2.errcallback(msg);
      }));
      document.title = this.props.location.state.name;
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.props.location.state.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          this.props.location.state.webViewHtml ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { ref: 'iframe', id: 'postMessage', src: this.props.location.state.webViewHtml, frameborder: '0', width: '100%', height: window.screen.height - 44, style: { border: 0 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { fontSize: '0.36rem', padding: 13 }, dangerouslySetInnerHTML: { __html: this.props.location.state.webViewHtml ? this.props.location.state.webViewHtml : this.props.webViewHtml
            } })
        )
      );
    }
  }]);

  return WebView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    webViewHtml: state.webViewHtml
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(WebView));

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SuperPie */
/* unused harmony export FundList */
/* unused harmony export FundListHave */
/* unused harmony export TabComponent */
/* unused harmony export PieCharNew */
/* unused harmony export PieCharHaveNew */
/* unused harmony export TabComponentHave */
/* unused harmony export LineComponent */
/* unused harmony export FxBarComponent */
/* unused harmony export AdjustRecord */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdjustRecordContent; });
/* unused harmony export ProblemList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_svg_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zrender_lib_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_zrender_lib_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_bar__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_investmentAction__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// 引入柱状图
// import 'echarts/lib/chart/bar';




// 引入提示框和标题组件






// let problemList = { 
//   content:{
//     "total":4,
//     "rows":[
//       {
//         "content":"一分钟了解华夏智投",
//         "title":"<p>华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。</p>\n<p>华夏智投组合为客户提供教育金智投、时光智投和资产增值智投三个系列，共9个组合，可以满足客户资产增值、教育、养老等多方面的投资需求，客户可以根据自身需要，选择不同的智投组合。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1493,"tagId":"WT_TAG_1492"}],"orderFlag":1,"NUM":1,"pageValid":"1","key":1493
//       },
//       {
//         "content":"查理机器人介绍",
//         "title":"<p>查理是汇聚华夏基金多年丰富的主动资产管理和海外资产配置经验，为您精心打造的智投机器人，查理将利用互联网技术与AI智能算法，为客户提供财务目标规划、生成资产配置解决方案、组合全周期管理的一站式智投服务，让每个客户都享受到私人银行般的服务。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1596,"tagId":"WT_TAG_1492"}],"orderFlag":2,"NUM":2,"pageValid":"1","key":1596
//       },
//       {
//         "content":"创建智投组合的方式",
//         "title":"<p>您只需要两步就能创建属于您的智投组合：</p>\n<p>1、华夏智投包括教育、养老和资产增值三种场景，您可以根据自身需要选择智投组合。您也可以通过智投计算器来测算一下，获得推荐组合和投资方案；</p>\n<p>2、 进入智投组合详情页后，只需要点击“一键投资”按钮，完成支付即可。购买组合一般需要两天的时间，购买后请随时关注组合调仓情况，及时跟踪调仓。</p>\n<p></p>\n","bq":[{"tagName":"智投介绍","cjwtId":1495,"tagId":"WT_TAG_1492"}],"orderFlag":3,"NUM":3,"pageValid":"1","key":1495
//       },
//       {
//         "content":"智投计算器有什么用？",
//         "title":"<p>智投计算器是帮助客户根据目前的所处阶段（例如客户年龄、当前养老储备金、预期每年养老金需求，或者孩子年龄、当前教育储备金等），计算客户养老金或者教育金缺口及所需投资金额。</p>\n","bq":[{"tagName":"智投介绍","cjwtId":1771,"tagId":"WT_TAG_1492"}],"orderFlag":4,"NUM":4,"pageValid":"1","key":1771
//       }
//     ]
//   }
// }


var allData = [{
  fundCode: "002229",
  fundName: "华夏经济转型股票11111",
  fundType: "0",
  regularRate: "0.0998",
  styleType: "1",
  styleTypeName: "国内权益基金"
}, {
  fundCode: "002891",
  fundName: "华夏移动互联混合（QDII）",
  fundType: "8",
  regularRate: "0.1044",
  styleType: "1",
  styleTypeName: "国内权益基金"
}, {
  fundCode: "002460",
  fundName: "华夏鼎利债券C",
  fundType: "1",
  regularRate: "0.0998",
  styleType: "1",
  styleTypeName: "国内债券基金"
}, {
  fundCode: "003003",
  fundName: "华夏现金增利货币A",
  fundType: "2",
  regularRate: "0.1011",
  styleType: "5",
  styleTypeName: "货币基金"
}, {
  fundCode: "160314",
  fundName: "华夏行业混合",
  fundType: "0",
  regularRate: "0.2002",
  styleType: "1",
  styleTypeName: "国内权益基金"
}, {
  fundCode: "001928",
  fundName: "华夏消费升级混合C",
  fundType: "0",
  regularRate: "0.1481",
  styleType: "1",
  styleTypeName: "国内权益基金"
}, {
  fundCode: "002230",
  fundName: "华夏大中华混合(QDII)",
  fundType: "8",
  regularRate: "0.1446",
  styleType: "2",
  styleTypeName: "跨境权益基金"
}, {
  fundCode: "001033",
  fundName: "华夏安康债券C",
  fundType: "1",
  regularRate: "0.102",
  styleType: "3",
  styleTypeName: "国内债券基金"
}];

var width = window.screen.width;

var SuperPie = function (_Component) {
  _inherits(SuperPie, _Component);

  function SuperPie() {
    _classCallCheck(this, SuperPie);

    return _possibleConstructorReturn(this, (SuperPie.__proto__ || Object.getPrototypeOf(SuperPie)).apply(this, arguments));
  }

  _createClass(SuperPie, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var thisProps = this.props || {},
          thisState = this.state || {};
      for (var key in nextProps) {
        if (thisProps[key] !== nextProps[key]) {
          return true;
        }
      }

      for (var _key in nextState) {
        if (thisState[_key] !== nextState[_key]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          dataName = _props.dataName;

      console.log(data, dataName);
      // 基于准备好的dom，初始化echarts实例

      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperPie'));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperPie'), null, { renderer: 'svg' });
      }
      myChart.clear();
      // 绘制图表
      myChart.setOption(SuperPieOption(data, dataName));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
        if (window.isLess47) {
          var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperPie'));
        } else {
          var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperPie'), null, { renderer: 'svg' });
        }

        // 绘制图表
        myChart.clear();
        myChart.setOption(SuperPieOption(nextProps.data, nextProps.dataName));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperPie'));
      myChart.clear();
    }
  }, {
    key: 'render',
    value: function render() {
      var pieImg = this.props.pieImg;

      console.log(pieImg, "pieImgpieImgpieImgpieImgpieImg");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#FFF", position: 'relative', width: "100%", height: 240 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperPie', style: { width: "100%", height: 240 } })
      );
    }
  }]);

  return SuperPie;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var FundList = function (_Component2) {
  _inherits(FundList, _Component2);

  function FundList(props) {
    _classCallCheck(this, FundList);

    var _this2 = _possibleConstructorReturn(this, (FundList.__proto__ || Object.getPrototypeOf(FundList)).call(this, props));

    _this2.state = {};
    return _this2;
  }

  _createClass(FundList, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var colorArr = [];
      data.map(function (item, key) {
        if (item.styleTypeName && item.styleTypeName.indexOf("跨境权益") != -1) {
          colorArr.push("#ef5002");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("国内权益") != -1) {
          colorArr.push("#e22424");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("跨境债券") != -1) {
          colorArr.push("#f25a0f");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("另类") != -1) {
          colorArr.push("#f0d331");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("货币") != -1) {
          colorArr.push("#23c7e2");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("国内债券") != -1) {
          colorArr.push("#034ab2");
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        data.map(function (itme, i) {
          if (i % 2 === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pzList_div', key: i, style: { backgroundColor: '#FFF' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pzList_name' },
                itme.fundName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pz_rateDiv' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { width: "1.1rem" } },
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate * 100, 2) + "%"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, flex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, background: colorArr[i], height: '0.28rem', borderRadius: '4px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, flex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, height: '0.4rem' } })
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pzList_div', style: { backgroundColor: '#FFF' }, key: i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pzList_name' },
                itme.fundName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pz_rateDiv' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { width: "1.1rem" } },
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate * 100, 2) + "%"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, flex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, background: colorArr[i], height: '0.28rem', borderRadius: '4px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, flex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.regularRate) * 10, height: '0.4rem' } })
              )
            );
          }
        })
      );
    }
  }]);

  return FundList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var FundListHave = function (_Component3) {
  _inherits(FundListHave, _Component3);

  function FundListHave(props) {
    _classCallCheck(this, FundListHave);

    var _this3 = _possibleConstructorReturn(this, (FundListHave.__proto__ || Object.getPrototypeOf(FundListHave)).call(this, props));

    _this3.state = {};
    return _this3;
  }

  _createClass(FundListHave, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var colorArr = [];
      data.map(function (item, key) {
        if (item.styleTypeName && item.styleTypeName.indexOf("跨境权益") != -1) {
          colorArr.push("#ef5002");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("国内权益") != -1) {
          colorArr.push("#e22424");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("跨境债券") != -1) {
          colorArr.push("#f25a0f");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("另类") != -1) {
          colorArr.push("#f0d331");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("货币") != -1) {
          colorArr.push("#23c7e2");
        } else if (item.styleTypeName && item.styleTypeName.indexOf("国内债券") != -1) {
          colorArr.push("#034ab2");
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        data.map(function (itme, i) {
          if (i % 2 === 0) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pzList_div', key: i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pzList_name' },
                itme.fundName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pz_rateDiv' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { width: "0.8rem" } },
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup * 10, 1) * 10 + "%"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, flex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, background: colorArr[i], height: '0.28rem', borderRadius: '4px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, flex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, height: '0.4rem' } })
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pzList_div', style: { backgroundColor: '#FFF' }, key: i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pzList_name' },
                itme.fundName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pz_rateDiv' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { width: "0.8rem" } },
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup * 10, 1) * 10 + "%"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, flex: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, background: colorArr[i], height: '0.28rem', borderRadius: '4px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, flex: 10 - __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(itme.rateInGroup) * 10, height: '0.4rem' } })
              )
            );
          }
        })
      );
    }
  }]);

  return FundListHave;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var TabComponent = function (_Component4) {
  _inherits(TabComponent, _Component4);

  function TabComponent(props) {
    _classCallCheck(this, TabComponent);

    var _this4 = _possibleConstructorReturn(this, (TabComponent.__proto__ || Object.getPrototypeOf(TabComponent)).call(this, props));

    _this4.agreeFunSec = function () {
      _this4.setState({
        setModalShow: false
      });
    };

    _this4.state = {
      tabName: '配置概况',
      setModalShow: false
    };
    return _this4;
  }

  _createClass(TabComponent, [{
    key: 'tabClick',
    value: function tabClick(data) {
      if (data === "配置详情") {
        window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "点击配置详情"]);
      }
      this.setState({
        tabName: data
      });
    }
  }, {
    key: 'setModal',
    value: function setModal() {
      console.log(11111);
      this.setState({
        setModalShow: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var tabName = this.state.tabName;
      var pieImg = this.props.pieImg;

      //let data = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];

      var dataTwo = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];
      var data = this.props.data ? this.props.data.pieTableQuery.itemFunds : [];
      var seasonPublishDate = this.props.data ? this.props.data.productQueryResponse.seasonPublishDate : "--";
      data.sort(compare('regularRate'));
      dataTwo.sort(compare('regularRate'));

      var arrObj = [];
      var arrName = [];

      var opt = JSON.parse(JSON.stringify(data));
      for (var i = 0; i < opt.length; i++) {
        for (var j = i + 1; j < opt.length; j++) {
          if (opt[i].styleTypeName == opt[j].styleTypeName) {
            opt[i].regularRate = Number(opt[i].regularRate) + Number(opt[j].regularRate);
            opt.splice(j, 1);
            j--;
          }
        }
      }
      opt.sort(compare('regularRate'));
      for (var _i = 0; _i < opt.length; _i++) {
        if (opt[_i].styleTypeName == "货币基金") {
          continue;
        }
        arrObj.push({
          value: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i].regularRate * 100, 0),
          name: opt[_i].styleTypeName ? opt[_i].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i].regularRate * 100, 0) + "%" : "--" + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i].regularRate * 100, 0) + "%"
        });
        if (opt[_i].styleTypeName) {
          arrName.push(opt[_i].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i].regularRate * 100, 0) + "%");
        } else {
          arrName.push(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i].regularRate * 100, 0) + "%");
        }
      }
      if (opt.length > 0) {
        var allVal = 100;
        for (var s = 0; s < arrObj.length; s++) {
          allVal = allVal - arrObj[s].value;
        }
        arrObj.push({
          value: allVal,
          name: "货币" + allVal + "%"
        });
        arrName.push("货币" + allVal + "%");
      }
      console.log(414, arrObj);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { backgroundColor: "#FFF", paddingLeft: 15, paddingRight: 15 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", marginTop: 10, WebkitFlexDirection: "row", WebkitJustifyContent: "flex-start", WebkitAlignItems: "center", height: 45, lineHeight: "45px", borderColor: '#ebedf0', borderWidth: 0, borderBottomWidth: 1, width: "100%", borderStyle: "solid" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: "#505558", fontSize: "0.32rem" } },
              '\u914D\u7F6E\u6982\u51B5'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              onClick: this.props.handleAlert,
              style: {
                height: "0.32rem",
                width: "0.32rem",
                color: "#FA063A",
                marginLeft: 6
              }, src: __webpack_require__(431) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          tabName === "配置概况" ? data.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SuperPie, { data: arrObj, dataName: arrName, pieImg: pieImg }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperPie', style: { width: "100%", height: 360 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FundList, { data: dataTwo })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Modal_ModalList__["a" /* default */], { flag: this.state.setModalShow, title: '\u67E5\u7406\u89E3\u5BC6', content: '该图展示基金投资组合策略目标配置情况。', btnRight: '\u6211\u77E5\u9053\u4E86', btnRightFun: this.agreeFunSec })
      );
    }
  }]);

  return TabComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var PieCharNew = function (_Component5) {
  _inherits(PieCharNew, _Component5);

  function PieCharNew(props) {
    _classCallCheck(this, PieCharNew);

    var _this5 = _possibleConstructorReturn(this, (PieCharNew.__proto__ || Object.getPrototypeOf(PieCharNew)).call(this, props));

    _this5.state = {};
    return _this5;
  }

  _createClass(PieCharNew, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          pieImg = _props2.pieImg,
          flag = _props2.flag;

      var corArr = [];
      var data = this.props.data ? this.props.data.pieTableQueryResponse.itemFunds : [];
      // let optTwo = [];
      // optTwo = data.slice(0);
      // optTwo.sort(compare('regularRate'))
      var opt = [];
      opt = JSON.parse(JSON.stringify(data));
      for (var i = 0; i < opt.length; i++) {
        for (var j = i + 1; j < opt.length; j++) {
          if (opt[i].styleTypeName == opt[j].styleTypeName) {
            opt[i].regularRate = Number(opt[i].regularRate) + Number(opt[j].regularRate);
            opt.splice(j, 1);
            j--;
          }
        }
      }

      // optTwo.map((item,key)=>{
      //   if(item.styleTypeName.indexOf("跨境权益") != -1){
      //     corArr.push("#4729c5")
      //   }else if(item.styleTypeName.indexOf("国内权益") != -1){
      //     corArr.push("#e22424")
      //   }else if(item.styleTypeName.indexOf("跨境债券") != -1){
      //     corArr.push("#f25a0f")
      //   }else if(item.styleTypeName.indexOf("另类") != -1){
      //     corArr.push("#f0d331")
      //   }else if(item.styleTypeName.indexOf("货币") != -1){
      //     corArr.push("#23c7e2")
      //   }else if(item.styleTypeName.indexOf("国内债券") != -1){
      //     corArr.push("#034ab2")
      //   }
      // })

      var arrObj = [];
      var arrName = [];
      opt.sort(compare('regularRate'));
      for (var _i2 = 0; _i2 < opt.length; _i2++) {
        if (opt[_i2].styleTypeName == "货币基金") {
          continue;
        }
        arrObj.push({
          value: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i2].regularRate * 100, 0),
          name: opt[_i2].styleTypeName ? opt[_i2].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i2].regularRate * 100, 0) + "%" : "--" + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i2].regularRate * 100, 0) + "%"
        });
        if (opt[_i2].styleTypeName) {
          arrName.push(opt[_i2].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i2].regularRate * 100, 0) + "%");
        } else {
          arrName.push(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i2].regularRate * 100, 0) + "%");
        }
      }
      if (opt.length > 0) {
        var allVal = 100;
        for (var s = 0; s < arrObj.length; s++) {
          allVal = allVal - arrObj[s].value;
        }
        arrObj.push({
          value: allVal,
          name: "货币" + allVal + "%"
        });
        arrName.push("货币" + allVal + "%");
      }
      // console.log(optTwo,"optTwooptTwooptTwooptTwo")

      if (flag) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          data.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SuperPie, { data: arrObj, dataName: arrName, pieImg: pieImg }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperPie', style: { width: "100%", height: 360 } })
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { paddingLeft: 10, paddingRight: 10, background: "#FFF", paddingBottom: 10 } });
      }
    }
  }]);

  return PieCharNew;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var PieCharHaveNew = function (_Component6) {
  _inherits(PieCharHaveNew, _Component6);

  function PieCharHaveNew(props) {
    _classCallCheck(this, PieCharHaveNew);

    var _this6 = _possibleConstructorReturn(this, (PieCharHaveNew.__proto__ || Object.getPrototypeOf(PieCharHaveNew)).call(this, props));

    _this6.agreeFunSec = function () {
      _this6.setState({
        setModalShow: false
      });
    };

    _this6.state = {
      setModalShow: false
    };
    return _this6;
  }

  _createClass(PieCharHaveNew, [{
    key: 'setModal',
    value: function setModal() {
      console.log(11111);
      this.setState({
        setModalShow: true
      });
    }
  }, {
    key: 'judgmentMonthlyReport',
    value: function judgmentMonthlyReport(code) {
      console.log(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.superFundCodeArrByZX.some(function (item) {
        item === code;
      }), code);
      return __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.superFundCodeArrByZX.some(function (item) {
        return item === code;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          pieImg = _props3.pieImg,
          flag = _props3.flag;
      //let data = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];

      var corArr = [];
      var dataTwo = this.props.data ? this.props.data.shareQueryResponse.fundItems ? this.props.data.shareQueryResponse.fundItems : [] : [];
      var data = this.props.data ? this.props.data.pieTableQueryResponse.itemFunds ? this.props.data.pieTableQueryResponse.itemFunds : [] : [];
      var seasonPublishDate = this.props.data ? this.props.data.productQueryResponse.seasonPublishDate ? this.props.data.productQueryResponse.seasonPublishDate : "--" : "--";
      data.sort(compare('regularRate'));
      dataTwo.sort(compare('rateInGroup'));

      // let optTwo = [];
      // optTwo = data.slice(0);
      // optTwo.sort(compare('rateInGroup'))
      // for(let k=0; k<optTwo.length; k++){
      //   if(optTwo[k].rateInGroup <= 0.01){
      //     optTwo.splice(k,1)
      //   }
      // }
      var opt = [];
      opt = JSON.parse(JSON.stringify(data));
      for (var k = 0; k < opt.length; k++) {
        if (opt[k].regularRate <= 0.01) {
          opt.splice(k, 1);
        }
      }
      for (var i = 0; i < opt.length; i++) {
        for (var j = i + 1; j < opt.length; j++) {
          if (opt[i].styleTypeName == opt[j].styleTypeName) {
            opt[i].regularRate = Number(opt[i].regularRate) + Number(opt[j].regularRate);
            opt.splice(j, 1);
            j--;
          }
        }
      }

      // optTwo.map((item,key)=>{
      //   if(item.styleTypeName.indexOf("跨境权益") != -1){
      //     corArr.push("#4729c5")
      //   }else if(item.styleTypeName.indexOf("国内权益") != -1){
      //     corArr.push("#e22424")
      //   }else if(item.styleTypeName.indexOf("跨境债券") != -1){
      //     corArr.push("#f25a0f")
      //   }else if(item.styleTypeName.indexOf("另类") != -1){
      //     corArr.push("#f0d331")
      //   }else if(item.styleTypeName.indexOf("货币") != -1){
      //     corArr.push("#23c7e2")
      //   }else if(item.styleTypeName.indexOf("国内债券") != -1){
      //     corArr.push("#034ab2")
      //   }
      // })

      console.log(data);
      var arrObj = [];
      var arrName = [];
      opt.sort(compare('regularRate'));
      for (var _i3 = 0; _i3 < opt.length; _i3++) {
        if (opt[_i3].styleTypeName == "货币基金") {
          continue;
        }
        arrObj.push({
          value: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i3].regularRate * 100, 0),
          name: opt[_i3].styleTypeName ? opt[_i3].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i3].regularRate * 100, 0) + "%" : "--" + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i3].regularRate * 100, 0) + "%"
        });
        if (opt[_i3].styleTypeName) {
          arrName.push(opt[_i3].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i3].regularRate * 100, 0) + "%");
        } else {
          arrName.push(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i3].regularRate * 100, 0) + "%");
        }
      }
      if (opt.length > 0) {
        var allVal = 100;
        for (var s = 0; s < arrObj.length; s++) {
          allVal = allVal - arrObj[s].value;
        }
        arrObj.push({
          value: allVal,
          name: "货币" + allVal + "%"
        });
        arrName.push("货币" + allVal + "%");
      }

      if (flag) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          data.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SuperPie, { data: arrObj, dataName: arrName, pieImg: pieImg }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperPie', style: { width: "100%", height: 360 } })
        );
      } else {
        if (true) {
          return null;
        } else {
          return React.createElement(
            'div',
            { style: { paddingLeft: 10, paddingRight: 10, background: "#FFF", paddingBottom: 10 } },
            React.createElement(
              'div',
              { style: { borderRadius: 10, background: "#F6F9FC", minHeight: 50, height: 'auto', overflow: 'hidden', fontSize: "0.24rem" } },
              dataTwo.map(function (itme, i) {
                if (i < i - 1) {
                  return React.createElement(
                    'div',
                    { className: 'pzList_div', key: i, style: { borderBottom: '1px solid #ebedf0' } },
                    React.createElement(
                      'div',
                      { className: 'pzList_name', style: { fontSize: '0.24rem' } },
                      itme.fundName
                    ),
                    React.createElement(
                      'div',
                      { className: 'pz_rateDiv' },
                      React.createElement(
                        'div',
                        { style: { WebkitFlex: 1, flex: 1, WebkitAlignItems: "center", WebkitJustifyContent: "center", display: "-webkit-flex" } },
                        Util.newToFixed(itme.rateInGroup * 100, 2) + "%"
                      )
                    )
                  );
                } else {
                  return React.createElement(
                    'div',
                    { className: 'pzList_div', key: i },
                    React.createElement(
                      'div',
                      { className: 'pzList_name', style: { fontSize: '0.24rem' } },
                      itme.fundName
                    ),
                    React.createElement(
                      'div',
                      { className: 'pz_rateDiv' },
                      React.createElement(
                        'div',
                        { style: { WebkitFlex: 1, flex: 1, WebkitAlignItems: "center", WebkitJustifyContent: "center", display: "-webkit-flex" } },
                        Util.newToFixed(itme.rateInGroup * 100, 2) + "%"
                      )
                    )
                  );
                }
              }),
              React.createElement(
                'div',
                { className: 'pzList_div' },
                console.log(this.props.superFundCode),
                this.judgmentMonthlyReport(this.props.superFundCode) ? React.createElement(
                  'div',
                  { style: { textAlign: "right", width: "100%", lineHeight: "0.8rem", paddingRight: 15 }, onClick: this.props.handleAlert },
                  '\u66F4\u65B0\u65F6\u95F4: ',
                  seasonPublishDate.substring(0, 10),
                  React.createElement('img', { style: {
                      height: "0.32rem",
                      width: "0.32rem",
                      color: "#FA063A",
                      lineHeight: "0.42rem",
                      marginBottom: "-0.09rem",
                      marginLeft: 3
                    }, src: require("../../img/smallWh.png") })
                ) : React.createElement(
                  'div',
                  { style: { height: "0.8rem", fontSize: "0.22rem", lineHeight: "0.8rem", backgroundColor: "#fff", width: '100%', textAlign: "right", paddingRight: 15 } },
                  '\u66F4\u65B0\u65F6\u95F4: ',
                  seasonPublishDate.substring(0, 10)
                )
              )
            ),
            React.createElement(ModalList, { flag: this.state.setModalShow, title: '\u67E5\u7406\u89E3\u5BC6', content: '该图展示基金投资组合策略目标配置情况。', btnRight: '\u6211\u77E5\u9053\u4E86', btnRightFun: this.agreeFunSec })
          );
        }
      }
    }
  }]);

  return PieCharHaveNew;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var TabComponentHave = function (_Component7) {
  _inherits(TabComponentHave, _Component7);

  function TabComponentHave(props) {
    _classCallCheck(this, TabComponentHave);

    var _this7 = _possibleConstructorReturn(this, (TabComponentHave.__proto__ || Object.getPrototypeOf(TabComponentHave)).call(this, props));

    _this7.state = {
      tabName: '配置概况'
    };
    return _this7;
  }

  _createClass(TabComponentHave, [{
    key: 'tabClick',
    value: function tabClick(data) {
      this.setState({
        tabName: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var tabName = this.state.tabName;
      var pieImg = this.props.pieImg;

      //let data = this.props.data ? this.props.data.productQueryResponse.itemFunds : [];

      var corArr = [];
      var data = this.props.data ? this.props.data.shareQueryResponse.fundItems ? this.props.data.shareQueryResponse.fundItems : [] : [];
      data.sort(compare('rateInGroup'));

      // let optTwo = [];
      // optTwo = data.slice(0);
      // optTwo.sort(compare('rateInGroup'))
      // for(let k=0; k<optTwo.length; k++){
      //   if(optTwo[k].rateInGroup <= 0.01){
      //     optTwo.splice(k,1)
      //   }
      // }
      var opt = [];
      opt = JSON.parse(JSON.stringify(data));
      for (var k = 0; k < opt.length; k++) {
        if (opt[k].rateInGroup <= 0.01) {
          opt.splice(k, 1);
        }
      }
      for (var i = 0; i < opt.length; i++) {
        for (var j = i + 1; j < opt.length; j++) {
          if (opt[i].styleTypeName == opt[j].styleTypeName) {
            opt[i].rateInGroup = Number(opt[i].rateInGroup) + Number(opt[j].rateInGroup);
            opt.splice(j, 1);
            j--;
          }
        }
      }

      // optTwo.map((item,key)=>{
      //   if(item.styleTypeName.indexOf("跨境权益") != -1){
      //     corArr.push("#4729c5")
      //   }else if(item.styleTypeName.indexOf("国内权益") != -1){
      //     corArr.push("#e22424")
      //   }else if(item.styleTypeName.indexOf("跨境债券") != -1){
      //     corArr.push("#f25a0f")
      //   }else if(item.styleTypeName.indexOf("另类") != -1){
      //     corArr.push("#f0d331")
      //   }else if(item.styleTypeName.indexOf("货币") != -1){
      //     corArr.push("#23c7e2")
      //   }else if(item.styleTypeName.indexOf("国内债券") != -1){
      //     corArr.push("#034ab2")
      //   }
      // })

      console.log(data);
      var arrObj = [];
      var arrName = [];
      opt.sort(compare('rateInGroup'));
      for (var _i4 = 0; _i4 < opt.length; _i4++) {
        arrObj.push({
          value: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i4].rateInGroup * 100),
          name: opt[_i4].styleTypeName ? opt[_i4].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i4].rateInGroup * 100) + "%" : "--" + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i4].rateInGroup * 100) + "%"
        });
        if (opt[_i4].styleTypeName) {
          arrName.push(opt[_i4].styleTypeName.replace(/基金/g, "") + __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i4].rateInGroup * 100, 0) + "%");
        } else {
          arrName.push(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(opt[_i4].rateInGroup * 100, 0) + "%");
        }
      }
      console.log(414, arrObj);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: '0.9rem', borderBottom: '1px solid #ebedf0', background: "#FFF", display: "-webkit-flex", padding: '0 0.1rem 0 0.1rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: tabName === "配置概况" ? "tabClick" : "tabDefault", onClick: function onClick() {
                return _this8.tabClick("配置概况");
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u914D\u7F6E\u6982\u51B5'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: tabName === "配置详情" ? "tabClick" : "tabDefault", onClick: function onClick() {
                _this8.tabClick("配置详情");
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u914D\u7F6E\u8BE6\u60C5'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          tabName === "配置概况" ? data.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SuperPie, { data: arrObj, dataName: arrName, pieImg: pieImg }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperPie', style: { width: "100%", height: 360 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FundListHave, { data: data })
        )
      );
    }
  }]);

  return TabComponentHave;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var LineComponent = function (_Component8) {
  _inherits(LineComponent, _Component8);

  function LineComponent(props) {
    _classCallCheck(this, LineComponent);

    var _this9 = _possibleConstructorReturn(this, (LineComponent.__proto__ || Object.getPrototypeOf(LineComponent)).call(this, props));

    _this9.state = {};
    return _this9;
  }

  _createClass(LineComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // var myChart = echarts.init(document.getElementById('SuperLine'));
      //  // 绘制图表
      //  let dataArr = [];
      //  this.props.data2 ? this.props.data2.map(function(item){
      //    dataArr.push(Util.newToFixed(item*100))
      //  }): null
      //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var thisProps = this.props || {},
          thisState = this.state || {};
      for (var key in nextProps) {
        if (thisProps[key] !== nextProps[key]) {
          return true;
        }
      }

      for (var _key2 in nextState) {
        if (thisState[_key2] !== nextState[_key2]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperLine'));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperLine'), null, { renderer: 'svg' });
      }
      var dataArr = [];
      myChart.clear();
      myChart.setOption(returnLineOption(this.props.data1, this.props.data2, this.props.data3));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('SuperLine'));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperLine', style: { width: "100%", height: 360, overflow: "hidden" } });
    }
  }]);

  return LineComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var FxBarComponent = function (_Component9) {
  _inherits(FxBarComponent, _Component9);

  function FxBarComponent(props) {
    _classCallCheck(this, FxBarComponent);

    var _this10 = _possibleConstructorReturn(this, (FxBarComponent.__proto__ || Object.getPrototypeOf(FxBarComponent)).call(this, props));

    _this10.state = {
      dataX: ["资产配置收益", "基金选择收益", "业绩基准收益"],
      dataY: [0.09, 0.38, 0.18],
      sumX: 0.00,
      date: "2017-01-01",
      flag: true
    };
    return _this10;
  }

  _createClass(FxBarComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // var myChart = echarts.init(document.getElementById('FxBar'));
      //  // 绘制图表
      //  let dataArr = [];
      //  this.props.data2 ? this.props.data2.map(function(item){
      //    dataArr.push(Util.newToFixed(item*100))
      //  }): null
      //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
      var _props4 = this.props,
          dispatch = _props4.dispatch,
          superFundCode = _props4.superFundCode;

      var inData = {
        fundCode: superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_investmentAction__["n" /* getFindAssetConfig */])(inData, this.handleCallBack.bind(this), this));
    }
  }, {
    key: 'handleCallBack',
    value: function handleCallBack(data) {
      console.log(data, "组合分析 绩效分解组合分析 绩效分解组合分析 绩效分解");
      var dataX = [];
      var dataY = [];
      var sumX = 0;
      var flag = true;
      for (var i = data.length - 1; i >= 0; i--) {
        if (data[i].configValue === null) {
          flag = false;
          break;
        }
        dataX.push(data[i].configName);
        dataY.push(data[i].configValue.replace(/%/, ""));
        sumX += Number(data[i].configValue.replace(/%/, ""));
      }
      this.setState({
        dataX: dataX, dataY: dataY, sumX: sumX, flag: flag,
        date: data[0].analyDate
      });
      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('FxBar'));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_4_echarts_lib_echarts___default.a.init(document.getElementById('FxBar'), null, { renderer: 'svg' });
      }

      // 绘制图表
      var dataArr = [];
      this.props.data2 ? this.props.data2.map(function (item) {
        dataArr.push(__WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(item * 100));
      }) : null;
      myChart.clear();
      var optionBar = {
        title: {
          text: '',
          subtext: '',
          sublink: ''
        },
        animation: window.isLess47,
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: false
          },
          axisTick: {
            lineStyle: {
              width: 0,
              color: "#9BC4D8"
            }

          },
          axisLabel: {
            textStyle: { /*x轴文字颜色*/
              color: '#CCC',
              fontSize: '12'
            }
          },
          // axisLabel: {
          //     show:true,
          //     color: function(data, index) {
          //         console.log(data, index)
          //         var corArr = ["red", "blue", "yellow", "blue", "green", "orange"];
          //         return corArr[index]
          //     }
          // },
          data: dataX
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: "rgb(240,241,242)"
            }
          },
          // axisLabel: {
          //     color: function(data, index) {
          //         console.log(data, index)
          //         var corArr = ["red", "blue", "yellow", "blue", "green", "orange"];
          //         return corArr[index]
          //     }
          // },
          axisLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value} %',
            textStyle: { /*y轴文字颜色*/
              color: '#CCC'
            }
          }
        },
        series: [{
          name: '组合分析',
          type: 'bar',
          clickable: false,
          hoverAnimation: false,
          stack: '总量',
          label: {
            normal: {
              show: false,
              position: 'top',
              color: "auto"
            }
          },
          barWidth: 30, //柱图宽度
          data: dataY
        }],
        color: ["#23c7e2", "#d4d9b0", "#265573"]
      };
      myChart.setOption(optionBar);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {}
  }, {
    key: 'render',
    value: function render() {
      var _this11 = this;

      var _state = this.state,
          date = _state.date,
          sumX = _state.sumX,
          flag = _state.flag;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#FFF" } },
        flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'zhFx_div' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: "14px" } },
              '\u7EC4\u5408\u5206\u6790'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: "11px" } },
              '(\u7EE9\u6548\u5F52\u56E0\u5206\u89E3)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'wenHao', onClick: function onClick() {
                _this11.props.handleAlert();
              } })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { textAlign: "center", position: "relative", bottom: -10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: "13px" } },
              '\u7EC4\u5408\u6536\u76CA\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: sumX >= 0 ? "#fb615b" : "#7fdd81", fontSize: "14px" } },
              __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixed(sumX) + "%"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'FxBar', style: { width: "100%", height: 360, paddingLeft: '8px', background: "#FFF" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: 12, color: "#CCC", textAlign: "right", paddingRight: "13px", position: "relative", top: -10 } },
            '\u57FA\u4E8E\u8BE5\u7EC4\u5408',
            date.substr(0, 4),
            '\u5E74',
            date.substr(5, 2),
            '\u6708\u6570\u636E\u5206\u6790 '
          )
        ) : null
      );
    }
  }]);

  return FxBarComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*调仓记录*/
var AdjustRecord = function (_Component10) {
  _inherits(AdjustRecord, _Component10);

  function AdjustRecord(props) {
    _classCallCheck(this, AdjustRecord);

    var _this12 = _possibleConstructorReturn(this, (AdjustRecord.__proto__ || Object.getPrototypeOf(AdjustRecord)).call(this, props));

    _this12.state = {
      data: null
    };
    _this12.dataSouce = [];
    return _this12;
  }

  _createClass(AdjustRecord, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var inData = {
        superFundCode: this.props.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_investmentAction__["o" /* getHistoryAdjust */])(inData, this.handleCallBack.bind(this), this));
    }
  }, {
    key: 'handleCallBack',
    value: function handleCallBack(data) {
      this.dataSouce = data;
      this.setState({
        data: data[data.length - 1]
      });
    }
  }, {
    key: 'pushHistoryRate',
    value: function pushHistoryRate() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: '/TransitHistory',
        state: { data: this.dataSouce }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: "0 15px 0 15px", background: "#FFF", marginTop: 10 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'comonTitle', style: { borderBottom: '1px solid #ebedf0', background: "#FFF" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginLeft: 0 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#505558', fontSize: '0.32rem' } },
                '\u8C03\u4ED3\u8BB0\u5F55'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginRight: 0 } },
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#828C96', fontSize: '0.26rem' } },
                data ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.returnDate(data.adjustDate) : ''
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdjustRecordContent, { data: data }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: this.pushHistoryRate.bind(this), className: 'more_AdjustRecord', style: { height: "48px", background: "#FFF", borderTop: '1px solid #ebedf0', color: '#828892', fontSize: '0.26rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u67E5\u770B\u5386\u53F2\u8C03\u4ED3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(1894), style: { width: 44, height: 44, marginLeft: -12 } })
        )
      );
    }
  }]);

  return AdjustRecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AdjustRecordContent = function (_Component11) {
  _inherits(AdjustRecordContent, _Component11);

  function AdjustRecordContent() {
    _classCallCheck(this, AdjustRecordContent);

    return _possibleConstructorReturn(this, (AdjustRecordContent.__proto__ || Object.getPrototypeOf(AdjustRecordContent)).apply(this, arguments));
  }

  _createClass(AdjustRecordContent, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      console.log(data, "调仓调仓");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#FFF" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'adjust_title_wrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: 58, borderBottom: "1px #ebeef0 solid", paddingTop: 16, paddingLeft: 13, paddingRight: 13, color: "#3a3e47", fontSize: 12 } },
            '\u6839\u636E\u6700\u8FD1\u7684\u5E02\u573A\u60C5\u51B5,  \u67E5\u7406\u5BF9\u7EC4\u5408\u8FDB\u884C\u4E86\u8D44\u4EA7\u914D\u7F6E\u6BD4\u4F8B\u8C03\u6574:'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'tabAdjust_list' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 12, color: "#a1a7b2" } },
              '\u57FA\u91D1\u540D\u79F0'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 12, color: "#a1a7b2" } },
              '\u8C03\u6574\u524D\u6BD4\u4F8B'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 12, color: "#a1a7b2" } },
              '\u8C03\u6574\u540E\u6BD4\u4F8B'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          data ? data.itemAdjustList.map(function (item, index) {
            if (index % 2 === 0) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Adjust_list', key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixedOne(item.beforeRate * 100, 1) + "%"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixedOne(item.afterRate * 100, 1) + "%"
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'Adjust_list2', key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixedOne(item.beforeRate * 100, 1) + "%"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.newToFixedOne(item.afterRate * 100, 1) + "%"
                )
              );
            }
          }) : null
        )
      );
    }
  }]);

  return AdjustRecordContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ProblemList = function (_Component12) {
  _inherits(ProblemList, _Component12);

  function ProblemList(props) {
    _classCallCheck(this, ProblemList);

    var _this14 = _possibleConstructorReturn(this, (ProblemList.__proto__ || Object.getPrototypeOf(ProblemList)).call(this, props));

    _this14.goDetail = function (content, key) {
      if (key == 0) {
        window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "智投百科列表问题一进入按钮"]);
      } else if (key == 1) {
        window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "智投百科列表问题二进入按钮"]);
      } else if (key == 2) {
        window._czc.push(["_trackEvent", "华夏财富H5", "智投详情", "智投百科列表问题三进入按钮"]);
      }

      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: "/encyclopediaDetail",
        state: {
          content: content
        }
      });
    };

    _this14.state = {};
    return _this14;
  }

  _createClass(ProblemList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this15 = this;

      var data = this.props.data ? this.props.data.problemList.content.rows : [];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'problemList' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'eq_ztDetail_title' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '\u667A\u6295\u767E\u79D1'
          )
        ),
        data.map(function (item, i) {
          if (i < 3) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'problemItem', key: i, onClick: function onClick() {
                  return _this15.goDetail(item.title, i);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1 } },
                item.content
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            );
          }
        })
      );
    }
  }]);

  return ProblemList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*饼图Option*/
function SuperPieOption(data, dataName) {
  var colorArr = [];
  if (dataName) {
    dataName.map(function (item, key) {
      if (item && item.indexOf("跨境权益") != -1) {
        colorArr.push("#ef5002");
      } else if (item && item.indexOf("国内权益") != -1) {
        colorArr.push("#e22424");
      } else if (item && item.indexOf("跨境债券") != -1) {
        colorArr.push("#f25a0f");
      } else if (item && item.indexOf("另类") != -1) {
        colorArr.push("#f0d331");
      } else if (item && item.indexOf("货币") != -1) {
        colorArr.push("#23c7e2");
      } else if (item && item.indexOf("国内债券") != -1) {
        colorArr.push("#034ab2");
      }
    });
  }
  var hg = 60;
  if (dataName.length <= 2) {
    hg = 20;
  } else if (dataName.length <= 4) {
    hg = 60;
  } else if (dataName.length <= 6) {
    hg = 80;
  } else if (dataName.length <= 8) {
    hg = 100;
  }

  var SuperPieOption = {
    animation: window.isLess47,

    calculable: true,
    legend: {
      // y : 'bottom',
      // x: 'center',
      // data:dataName,
      // textStyle:{color:"auto"}
      y: 'bottom',
      x: 'center',
      orient: 'vertical',
      data: dataName,
      height: 80,
      itemWidth: 14,
      selectedMode: false,
      textStyle: { color: "auto" }
    },
    series: [{
      type: 'pie',
      hoverAnimation: false,
      radius: [44, 100],
      center: ['50%', '40%'],
      // roseType : 'radius',
      roseType: false,
      data: data,
      // [
      //     {value:15, name:'货币基金15.0%'},
      //     {value:20, name:'均衡股票20.0%'},
      //     {value:25, name:'进取股票25.0%'},
      //     {value:40, name:'稳健型债券40.0%'},
      // ],
      label: {
        normal: {
          show: false
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }

    }],
    color: colorArr
  };

  SuperPieOption = {
    animation: window.isLess47,

    calculable: true,
    legend: {
      // y : 'bottom',
      // x: 'center',
      // data:dataName,
      // textStyle:{color:"auto"}

      // y : 'center',
      // x: 'left',
      // left:width/2 + 40,
      // orient:'vertical',


      y: 'center',
      x: 'left',
      // left:width/2 + 40,
      left: 20,
      orient: 'vertical',
      data: dataName,
      //height:hg,
      itemWidth: 14,
      selectedMode: false,
      textStyle: { color: "auto" }
    },
    series: [{
      minAngle: 20,
      type: 'pie',
      hoverAnimation: false,
      radius: [44, 75],
      // center : ['30%', '50%'],
      center: ['70%', '50%'],
      // roseType : 'radius',
      roseType: false,
      data: data,
      // [
      //     {value:15, name:'货币基金15.0%'},
      //     {value:20, name:'均衡股票20.0%'},
      //     {value:25, name:'进取股票25.0%'},
      //     {value:40, name:'稳健型债券40.0%'},
      // ],
      label: {
        normal: {
          show: false
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }

    }],
    color: colorArr
    //color: ['#db6a3d','#427bc7','#2ca1bd','#f5ad3c']
    //color: ['#4729c5','#e22424','#f25a0f','#f0d331','23c7e2','034ab2']
  };

  return SuperPieOption;
}

/*折线图Option*/
function returnLineOption(data1, data2, data3) {
  console.log(width, "widthwidthwidthwidthwidthwidth");
  var pValue = 0;
  if (width < 350) {
    pValue = 0;
  } else if (width < 400) {
    pValue = 13;
  } else {
    pValue = 23;
  }

  var option = void 0;
  if (data1) {
    option = {
      // tooltip : {
      //     trigger: 'axis'
      // },
      animation: window.isLess47,
      grid: {
        left: 47
      },
      // legend: {
      //     data:['2030TDF','沪深300指数','2030TDF比较基准','目标日期-2030'],
      //     y : 'bottom',
      //     x: 'center',
      //     textStyle:{color:"a1a7b2"}
      // },
      tooltip: {
        show: true,
        trigger: 'axis',
        alwaysShowContent: true,
        position: [width / 2, 0],
        padding: [16, 300, 0, pValue],
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#48b',
            width: 1,
            type: 'dashed'
          },
          crossStyle: {
            color: '#1e90ff',
            width: 1,
            type: 'dashed'
          },
          shadowStyle: {
            color: 'rgba(150,150,150,0.3)',
            width: 'auto',
            type: 'default'
          }
        },
        backgroundColor: "#FFF",
        textStyle: {
          fontSize: 11,
          paddingLeft: 5,
          paddingRight: 5
        },
        formatter: '<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}%</span> </div>'
        //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
        // function(params,ticket,callBack) {
        //     var result = '';
        //     // params.forEach(function (item) {
        //     //     result =  item.name + ":" + item.data;
        //     // });
        //     result = params[0].name + params[0].data
        //     return result;
        // }
      },
      calculable: true,
      xAxis: [{
        axisLine: {
          lineStyle: {
            width: 1,
            color: "#CCC"
          }
        },
        axisTick: {
          lineStyle: {
            width: 0,
            color: "#9BC4D8"
          }
        },
        type: 'category',
        boundaryGap: false,
        data: data1
      }],
      yAxis: [{
        type: 'value',
        scale: true,
        // name:'(人)',
        axisLine: {
          lineStyle: {
            width: 0,
            color: "rgb(160,167,176)"
          }
        },
        axisTick: {
          lineStyle: {
            width: 0,
            color: "#9BC4D8"
          }
        },
        axisLabel: {
          formatter: '{value} %'
        }
      }],
      series: [{
        name: '累计收益',
        type: 'line',
        stack: '总量',
        smooth: true, /*线条有弧度*/
        data: data2,
        itemStyle: {
          normal: {
            color: '#fa063a', /*#53C6E0*/
            lineStyle: {
              color: '#fa063a'
            }
          }
        }
      }, {
        name: '业绩基准',
        type: 'line',
        stack: '业绩',
        smooth: true, /*线条有弧度*/
        data: data3,
        itemStyle: {
          normal: {
            color: '#23c7e2', /*#53C6E0*/
            lineStyle: {
              color: '#23c7e2'
            }
          }
        }
        // symbolSize:6
      }],
      color: ['#fa063a']
    };
  } else {
    option = {
      // tooltip : {
      //     trigger: 'axis'
      // },
      animation: window.isLess47,

      grid: {
        y: '5%'
      },
      // legend: {
      //     data:['2030TDF','沪深300指数','2030TDF比较基准','目标日期-2030'],
      //     y : 'bottom',
      //     x: 'center',
      //     textStyle:{color:"a1a7b2"}
      // },
      calculable: true,
      xAxis: [{
        axisLine: {
          lineStyle: {
            width: 1,
            color: "#CCC"
          }
        },
        axisTick: {
          lineStyle: {
            width: 0,
            color: "#9BC4D8"
          }
        },
        type: 'category',
        boundaryGap: false,
        data: ['2016/7/19', '2016/8/19', '2016/9/19', '2016/10/19', '2016/11/19', '2016/12/19', '2017/1/19']
      }],
      yAxis: [{
        type: 'value',
        scale: true,
        // name:'(人)',
        axisLine: {
          lineStyle: {
            width: 0,
            color: "rgb(160,167,176)"
          }
        },
        axisTick: {
          lineStyle: {
            width: 0,
            color: "#9BC4D8"
          }
        },
        axisLabel: {
          formatter: '{value} %'
        }
      }],
      series: [{
        name: '2030TDF',
        type: 'line',
        stack: '总量',
        smooth: true, /*线条有弧度*/
        data: [120, 132, 101, 134, 90, 230, 210],
        itemStyle: {
          normal: {
            color: '#fa063a', /*#53C6E0*/
            lineStyle: {
              color: '#fa063a'
            }
          }
        }
      }],
      color: ['#fa063a']
    };
  }
  return option;
}

function compare(prop) {
  // return function(a,b){
  //     var allStartDate = getDateS(a[property]);   
  //     var allEndDate = getDateS(b[property]);
  //     var value1 = allStartDate.getTime()
  //     var value2 = allEndDate.getTime()
  //     return value2 - value1;
  // }
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 > val2) {
      return -1;
    } else if (val1 < val2) {
      return 1;
    } else {
      return 0;
    }
  };
}

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/*配置详情*/

var Configuration = function (_Component) {
  _inherits(Configuration, _Component);

  function Configuration(props) {
    _classCallCheck(this, Configuration);

    var _this = _possibleConstructorReturn(this, (Configuration.__proto__ || Object.getPrototypeOf(Configuration)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Configuration, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "配置明细";
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
      // this.props.history.push({
      //     pathname:'/',
      // })
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.location.state.data ? this.props.location.state.data : [];
      // data = data.sort(compare('rateInGroup'))
      // for(let k=0; k<data.length; k++){
      //   if(data[k].rateInGroup <= 0.01){
      //     data.splice(k,1)
      //   }
      // }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u914D\u7F6E\u660E\u7EC6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          data.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'superListJ superConfiguration', key: i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { borderBottom: '1px solid #f2f4f7' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#fa063a' } },
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#fa063a' } },
                  item.rateInGroup != null ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.fomatFloat(item.rateInGroup * 100) + "%" : "--"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  "资产金额:" + (item.balance != null ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.fomatFloat(item.balance) + "元" : "--")
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  "可用份额:" + (item.availableVolume != null ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.fomatFloat(item.availableVolume) + "份" : "--")
                )
              )
            );
          })
        )
      );
    }
  }]);

  return Configuration;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function compare(prop) {
  // return function(a,b){
  //     var allStartDate = getDateS(a[property]);   
  //     var allEndDate = getDateS(b[property]);
  //     var value1 = allStartDate.getTime()
  //     var value2 = allEndDate.getTime()
  //     return value2 - value1;
  // }
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 > val2) {
      return -1;
    } else if (val1 < val2) {
      return 1;
    } else {
      return 0;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Configuration);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/*操作记录*/

var OperationRecord = function (_Component) {
  _inherits(OperationRecord, _Component);

  function OperationRecord(props) {
    _classCallCheck(this, OperationRecord);

    var _this = _possibleConstructorReturn(this, (OperationRecord.__proto__ || Object.getPrototypeOf(OperationRecord)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(OperationRecord, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "操作记录";
      var superFundCode = this.props.location.state.superFundCode;
      var dispatch = this.props.dispatch;

      var data = {
        superFundCode: superFundCode,
        pageIndex: 1,
        pageSize: 999
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["C" /* getQueryTradeRecords */])(data, this.callBack.bind(this), this));
    }
  }, {
    key: 'callBack',
    value: function callBack(data) {
      console.log(data);
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var superFundCode = this.props.location.state.superFundCode;
      var data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u64CD\u4F5C\u8BB0\u5F55'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          data.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'superListJ superOperation', key: i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { borderBottom: '1px solid #f2f4f7' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#fa063a' } },
                  item.businessTypeName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.fomatFloat(item.applicationAmount) + "元"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  item.businessStateName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.formatStr(item.businessTime)
                )
              )
            );
          })
        )
      );
    }
  }]);

  return OperationRecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(OperationRecord));

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export lineOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var width = window.screen.width;

var historyD = {
      "code": "0000",
      "message": null,
      "content": {
            "HistoryRate": [{
                  "fund_type": "1",
                  "fund_name": "华夏移动互联混合（QDII）",
                  "code": "002891"
            }]
      }

      /*智投持仓列表*/
};
var SuperFundList = function (_Component) {
      _inherits(SuperFundList, _Component);

      function SuperFundList(props) {
            _classCallCheck(this, SuperFundList);

            var _this = _possibleConstructorReturn(this, (SuperFundList.__proto__ || Object.getPrototypeOf(SuperFundList)).call(this, props));

            _this.state = {
                  modalFlag: false,
                  tabName: "持有组合",

                  tipFlag: false

            };
            return _this;
      }

      _createClass(SuperFundList, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                  document.title = '我的智投账户';
                  var dispatch = this.props.dispatch;

                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {}, this));
            }
      }, {
            key: 'ProtocolPaper',
            value: function ProtocolPaper() {
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                        pathname: '/Transfer',
                        state: {
                              name: '调整组合',
                              type: 1
                        },
                        query: {
                              code: ''
                        }
                  });
            }
      }, {
            key: 'goBack',
            value: function goBack() {
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                        pathname: '/'
                  });
            }
      }, {
            key: 'goInvesting',
            value: function goInvesting() {
                  this.setState({
                        modalFlag: true
                  });
            }
      }, {
            key: 'goTransactionRecord',
            value: function goTransactionRecord() {
                  window._czc.push(["_trackEvent", "华夏财富H5", "我的智投账户", "交易记录按钮"]);
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                        pathname: '/TransactionRecord',
                        state: {
                              pathName: "/SuperFundList"
                        }
                  });
            }
      }, {
            key: 'goDetail',
            value: function goDetail(superFundCode, superFundType) {
                  var SupperFundHome = this.props.SupperFundHome;
                  var pathName = "";
                  if (superFundType === "1") {
                        pathName = '/TargetProfitHaveCast';
                  } else {
                        pathName = '/SuperFundDetailHaveCast';
                  }

                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                        pathname: pathName,
                        state: {
                              superFundCode: superFundCode
                        },
                        query: {
                              superFundCode: superFundCode
                        }
                  });
            }
      }, {
            key: 'tabClick',
            value: function tabClick(data) {
                  this.setState({
                        tabName: data
                  });
            }
      }, {
            key: 'goHistoryProfit',
            value: function goHistoryProfit() {
                  var SupperFundHome = this.props.SupperFundHome;
                  var data = SupperFundHome ? this.props.SupperFundHome.singleSuperFundViews ? this.props.SupperFundHome.singleSuperFundViews : [] : [];
                  __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                        pathname: '/HistoryProfit',
                        state: {
                              SuperList: data
                        },
                        query: {
                              SuperList: ""
                        }
                  });
            }
      }, {
            key: 'render',
            value: function render() {
                  var _this2 = this;

                  //let  = this.props.location.state.data;

                  var SupperFundHome = this.props.SupperFundHome;
                  var data = SupperFundHome ? this.props.SupperFundHome.singleSuperFundViews ? this.props.SupperFundHome.singleSuperFundViews : [] : [];
                  console.log(data, "智投持仓列表智投持仓列表智投持仓列表");
                  var tabName = this.state.tabName;

                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'container' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__["a" /* default */],
                              null,
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'header' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          null,
                                          ' ',
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                                                      return _this2.goBack();
                                                } })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { className: 'MyZh_div' },
                                          '\u6211\u7684\u667A\u6295\u8D26\u6237'
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { className: 'MyJy_div', onClick: function onClick() {
                                                      _this2.goTransactionRecord();
                                                } },
                                          '\u4EA4\u6613\u8BB0\u5F55'
                                    )
                              )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'content' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'headerShow' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { style: { marginTop: '0.24rem' } },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { style: { fontSize: "0.24rem", color: "#aebad7" } },
                                                '\u667A\u6295\u603B\u91D1\u989D(\u5143)'
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { style: { fontSize: "0.56rem" } },
                                                SupperFundHome ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(SupperFundHome.totalAssets) : null
                                          )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'transitAssetsShow' }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { className: 'headerShowTwo' },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'classCenter', onClick: function onClick() {
                                                            return _this2.goHistoryProfit();
                                                      } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'div',
                                                      null,
                                                      SupperFundHome ? "最新收益(" + (SupperFundHome.deadLine != null ? SupperFundHome.deadLine : "--") + ")" : "",
                                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'a',
                                                            { onClick: function onClick(event) {
                                                                        event.stopPropagation(), _this2.setState({ tipFlag: true });
                                                                  } },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                                                                        height: "0.32rem",
                                                                        width: "0.32rem",
                                                                        color: "#FA063A",
                                                                        lineHeight: "0.42rem",
                                                                        marginBottom: "-0.09rem",
                                                                        marginLeft: 2
                                                                  }, src: __webpack_require__(687) })
                                                      )
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'div',
                                                      null,
                                                      SupperFundHome ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.fomatFloat(SupperFundHome.dayIncome) : null
                                                )
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "1px", backgroundColor: 'rgba(255,255,255,0.35)', height: "1.4rem" } }),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'classCenter', onClick: function onClick() {
                                                            return _this2.goHistoryProfit();
                                                      } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'div',
                                                      null,
                                                      '\u7D2F\u8BA1\u6536\u76CA'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'div',
                                                      null,
                                                      SupperFundHome ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.fomatFloat(SupperFundHome.allIncome) : null
                                                )
                                          )
                                    )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: '' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { className: 'cyzh_div' },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: tabName === "持有组合" ? "tabClickList" : "tabDefaultList", onClick: function onClick() {
                                                            return _this2.tabClick("持有组合");
                                                      } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'span',
                                                      null,
                                                      '\u6301\u6709\u7EC4\u5408'
                                                )
                                          ),
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: tabName === "收益表现" ? "tabClickList" : "tabDefaultList", onClick: function onClick() {
                                                            _this2.tabClick("收益表现");
                                                      } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'span',
                                                      null,
                                                      '\u6536\u76CA\u8868\u73B0'
                                                )
                                          )
                                    )
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { display: this.state.tabName === "持有组合" ? "block" : "none" } },
                                    data.map(function (item, index) {
                                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'superListZh', onClick: function onClick() {
                                                            _this2.goDetail(item.superFundCode, item.superFundType);
                                                      } },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'div',
                                                      null,
                                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'span',
                                                            { style: { color: "#3a3e47" } },
                                                            item.superFundName
                                                      ),
                                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                      'div',
                                                      null,
                                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'div',
                                                            { className: 'flexPadding' },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                  'div',
                                                                  { style: { fontSize: 14, color: "#000" } },
                                                                  item.adjustFlag || item.buyFlag ? null : null,
                                                                  !item.adjustFlag && !item.buyFlag ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.newToFixed(item.currentAsset) + "元" : null,
                                                                  item.adjustFlag ? "调仓中" : null,
                                                                  item.buyFlag ? "申购中" : null
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                  'div',
                                                                  { style: { fontSize: 12, color: "#AEA7B2" } },
                                                                  '\u5F53\u524D\u8D44\u4EA7'
                                                            )
                                                      ),
                                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 1, height: 30, backgroundColor: "#f2f4f7" } }),
                                                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'div',
                                                            { className: 'flexPadding' },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                  'div',
                                                                  { style: { color: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.newToFixed(item.dayIncome) >= 0 ? "#fa063a" : "#7fdd81", fontSize: 14 } },
                                                                  __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.newToFixed(item.dayIncome) > 0 ? "+" + __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.newToFixed(item.dayIncome) + "元" : __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.newToFixed(item.dayIncome) + "元"
                                                            ),
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                                  'div',
                                                                  { style: { fontSize: 12, color: "#AEA7B2" } },
                                                                  '\u6700\u65B0\u6536\u76CA(\u5143)'
                                                            )
                                                      )
                                                )
                                          );
                                    })
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { display: this.state.tabName === "持有组合" ? "none" : "block", background: "#FFF" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabLineComponent, { dispatch: this.props.dispatch }),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                          'div',
                                          { className: 'pushMore_div' },
                                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { onClick: function onClick() {
                                                            return _this2.goHistoryProfit();
                                                      }, style: { height: "30px", width: 100, backgroundColor: "#fa063a", borderRadius: 200, color: "#FFF", textAlign: 'center', lineHeight: "30px" } },
                                                '\u67E5\u770B\u66F4\u591A'
                                          )
                                    )
                              )
                        ),
                        this.state.tipFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AlerModle__["b" /* AlerModleCommonn */], {
                              btnTxt1: '\u77E5\u9053\u4E86',
                              content: "投顾组合由于其底层基金净值更新时间不同，组合资产及收益分两次更新。一般为交易日当晚更新组合中华夏基金公募产品数据，次日15点后更新组合中非华夏基金公募产品数据。",
                              contentSec: "遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。",
                              title: '\u67E5\u7406\u89E3\u5BC6',
                              handleClick1: function handleClick1() {
                                    _this2.setState({ tipFlag: false });
                              }
                        }) : null
                  );
            }
      }]);

      return SuperFundList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var TabLineComponent = function (_Component2) {
      _inherits(TabLineComponent, _Component2);

      function TabLineComponent(props) {
            _classCallCheck(this, TabLineComponent);

            var _this3 = _possibleConstructorReturn(this, (TabLineComponent.__proto__ || Object.getPrototypeOf(TabLineComponent)).call(this, props));

            _this3.state = {
                  tabName: '三个月',
                  data1: [],
                  data2: [],
                  historyData: {
                        HistoryRate: []
                  },
                  threeMonthDate: [],
                  threeMonthNav: [],
                  oneYearDate: [],
                  oneYearNav: [],
                  totalDate: [],
                  totalNav: [],
                  dataX: null,
                  dataY: null
            };
            return _this3;
      }

      _createClass(TabLineComponent, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                  var _props = this.props,
                      dispatch = _props.dispatch,
                      superFundCode = _props.superFundCode;

                  var that = this;
                  //this.callBackIncome(historyD.content)

                  var beginDate = GetDateStr(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])());
                  var endDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])();
                  var data = {};
                  data.fundCode = "";
                  data.beginDate = beginDate;
                  data.endDate = endDate;
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction__["l" /* getHistoryIcomeListSuper */])(data, this.handleCallback.bind(this), this));
            }
      }, {
            key: 'handleCallback',
            value: function handleCallback(data) {
                  var dataX = [];
                  var dataY = [];
                  for (var i = data.length - 1; i >= 0; i--) {
                        if (data[i].dayIncome != "--") {
                              dataY.push(data[i].dayIncome);
                              dataX.push(data[i].deadLine);
                        }
                  }
                  this.setState({
                        dataX: dataX, dataY: dataY
                  });
                  // this.props._this.setState({
                  //  loadingFlag:false
                  // })

                  console.log(data, "ffff", dataX, dataY);
            }
      }, {
            key: 'callBackIncome',
            value: function callBackIncome(data) {
                  console.log(data);
                  var tempDate = ["2017/7/21", "2017/7/22", "2017/7/23", "2017/7/24", "2017/7/25", "2017/7/26", "2017/7/27", "2017/7/28", "2017/7/29", "2017/7/30", "2017/7/31", "2017/8/1", "2017/8/2", "2017/8/3", "2017/8/4", "2017/8/5", "2017/8/6", "2017/8/7", "2017/8/8", "2017/8/9", "2017/8/10", "2017/8/11", "2017/8/12", "2017/8/13", "2017/8/14", "2017/8/15", "2017/8/16", "2017/8/17", "2017/8/18", "2017/8/19", "2017/8/20", "2017/8/21", "2017/8/22", "2017/8/23", "2017/8/24", "2017/8/25", "2017/8/26", "2017/8/27", "2017/8/28", "2017/8/29", "2017/8/30", "2017/8/31", "2017/9/1", "2017/9/2", "2017/9/3", "2017/9/4", "2017/9/5", "2017/9/6", "2017/9/7", "2017/9/8", "2017/9/9", "2017/9/10", "2017/9/11", "2017/9/12", "2017/9/13", "2017/9/14", "2017/9/15", "2017/9/16", "2017/9/17", "2017/9/18", "2017/9/19", "2017/9/20", "2017/9/21"];

                  var tempNav = [24.3, 0.2, 0.1, 34.6, -21.9, -38.7, 24, 10.8, 0.2, 0.1, 8.9, 3.6, 3, -21.3, -1, 0.1, 0.2, 43.1, 22.8, -8, -39.2, -20.8, 0.2, 0.1, 84.2, 6.1, 30.5, -10.5, -13.9, 0.2, 0.1, 28.4, 7.1, 0.4, -46.6, 26.5, 0.2, 0.1, -6.9, -15.7, 45.5, 13, 47.7, 0.2, 0.1, -8.5, 35.9, -2.3, 1.8, -17.4, 0.1, 0.2, 48.7, 33.6, -7.2, 3.7, -8.7, 0, 0, 23.6, -2.7, 25.7, 8];

                  var dateLength = tempDate.length;
                  var threeMonthDate = tempDate.slice(dateLength - 7);
                  var threeMonthNav = tempNav.slice(dateLength - 7);
                  var oneYearDate = tempDate.slice(dateLength - 30);
                  var oneYearNav = tempNav.slice(dateLength - 30);

                  this.setState({
                        data1: threeMonthDate,
                        data2: threeMonthNav,
                        threeMonthDate: threeMonthDate,
                        threeMonthNav: threeMonthNav,
                        oneYearDate: oneYearDate,
                        oneYearNav: oneYearNav,
                        totalNav: tempNav,
                        totalDate: tempDate
                  });
            }
      }, {
            key: 'handleTab',
            value: function handleTab(a) {
                  var _props2 = this.props,
                      dispatch = _props2.dispatch,
                      superFundCode = _props2.superFundCode;

                  console.log(superFundCode);

                  var that = this;

                  if (a == "三个月") {
                        //BtnYear(superFundCode,a)
                        var inData = {
                              superFundCode: superFundCode,
                              periodType: 3
                        };
                        that.setState({
                              tabName: "三个月",
                              data1: this.state.threeMonthDate,
                              data2: this.state.threeMonthNav
                        });
                  } else if (a == "近一年") {
                        //BtnYear(superFundCode,a)
                        var _inData = {
                              superFundCode: superFundCode,
                              periodType: 12
                        };
                        that.setState({
                              tabName: "近一年",
                              data1: this.state.oneYearDate,
                              data2: this.state.oneYearNav
                        });
                  } else if (a == "成立以来") {
                        //BtnYear(superFundCode,a)
                        that.setState({
                              tabName: "成立以来",
                              data1: this.state.totalDate,
                              data2: this.state.totalNav
                        });
                  }
            }
      }, {
            key: 'render',
            value: function render() {
                  var _state = this.state,
                      tabName = _state.tabName,
                      data1 = _state.data1,
                      data2 = _state.data2,
                      dataX = _state.dataX,
                      dataY = _state.dataY;

                  console.log(data1, data2);
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { background: "#FFF" } },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineComponent, { data1: dataX, data2: dataY })
                        )
                  );
            }
      }]);

      return TabLineComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var LineComponent = function (_Component3) {
      _inherits(LineComponent, _Component3);

      function LineComponent(props) {
            _classCallCheck(this, LineComponent);

            var _this4 = _possibleConstructorReturn(this, (LineComponent.__proto__ || Object.getPrototypeOf(LineComponent)).call(this, props));

            _this4.state = {};
            return _this4;
      }

      _createClass(LineComponent, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                  // var myChart = echarts.init(document.getElementById('SuperLine'));
                  //  // 绘制图表
                  //  let dataArr = [];
                  //  this.props.data2 ? this.props.data2.map(function(item){
                  //    dataArr.push(Util.newToFixed(item*100))
                  //  }): null
                  //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
            }
      }, {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps, nextState) {}
      }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                  if (window.isLess47) {
                        var myChart = __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default.a.init(document.getElementById('SuperLine'));
                  } else {
                        var myChart = __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default.a.init(document.getElementById('SuperLine'), null, { renderer: 'svg' });
                  }
                  // 绘制图表
                  var dataArr = [];
                  // this.props.data2 ? this.props.data2.map(function(item) {
                  //       dataArr.push(Util.newToFixed(item * 100))
                  // }) : null
                  myChart.clear();
                  myChart.setOption(lineOption(this.props.data1, this.props.data2));
            }
      }, {
            key: 'render',
            value: function render() {
                  var width = window.screen.width;
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'SuperLine', style: { width: width, height: 360, paddingLeft: '8px' } });
            }
      }]);

      return LineComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*折线图option*/


function lineOption(dataName, dataSouce) {
      var pValue = 0;
      if (width < 350) {
            pValue = 0;
      } else if (width < 400) {
            pValue = 13;
      } else {
            pValue = 23;
      }
      var option = {
            title: {
                  text: ''
            },
            animation: window.isLess47,
            grid: {
                  y: '13%',
                  left: 37
            },
            // tooltip: {},
            // legend: {
            //     data:[]
            // },
            tooltip: {
                  show: true,
                  trigger: 'axis',
                  alwaysShowContent: true,
                  position: [width / 2, 0],
                  padding: [16, 300, 0, pValue],
                  axisPointer: {
                        type: 'line',
                        lineStyle: {
                              color: '#48b',
                              width: 1,
                              type: 'dashed'
                        },
                        crossStyle: {
                              color: '#1e90ff',
                              width: 1,
                              type: 'dashed'
                        },
                        shadowStyle: {
                              color: 'rgba(150,150,150,0.3)',
                              width: 'auto',
                              type: 'default'
                        }
                  },
                  backgroundColor: "#FFF",
                  textStyle: {
                        fontSize: 11,
                        paddingLeft: 5,
                        paddingRight: 5
                  },
                  formatter: '<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}%</span> </div>'

            },
            xAxis: [{
                  type: 'category',
                  boundaryGap: false,
                  data: dataName,
                  // name:'(年份)',
                  axisLine: {
                        lineStyle: {
                              width: 1,
                              color: "#CCC"
                        }
                  },
                  axisTick: {
                        lineStyle: {
                              width: 0,
                              color: "#9BC4D8"
                        }
                  }
            }],
            axis: [{
                  axisLline: {
                        show: true,
                        lineStyle: {
                              color: '#99C4D7',
                              width: 2,
                              type: 'dashed'
                        }
                  },
                  splitArea: {
                        areaStyle: {
                              color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
                        }
                  }
            }],
            yAxis: [{
                  type: 'value',
                  scale: true,
                  // name:'(人)',
                  axisLine: {
                        lineStyle: {
                              width: 0,
                              color: "rgb(160,167,176)"
                        }
                  },
                  axisTick: {
                        lineStyle: {
                              width: 0,
                              color: "#9BC4D8"
                        }
                  },
                  axisLabel: {
                        rotate: 0,
                        formatter: '{value}'
                  }
            }],
            series: [{
                  name: '日收益',
                  type: 'line',
                  smooth: true,
                  hoverAnimation: false,
                  data: dataSouce,
                  itemStyle: {
                        normal: {
                              color: '#fa063a',
                              /*#53C6E0*/
                              lineStyle: {
                                    color: '#fa063a'
                              }
                        }
                  }
            }]
      };
      return option;
}

function mapStateToProps(state, ownProps) {
      return {
            SupperFundHome: state.SupperFundHome
      };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(SuperFundList));

function GetDateStr(beginDate) {
      var AddDayCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -15;

      var dd = new Date(beginDate.replace(/\-/g, '/'));
      dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期  
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0  
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0  
      return y + "-" + m + "-" + d;
}

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_ModalList__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ToastTime = 2;

var seasons = [{
  label: '全部产品',
  value: '2013',
  key: 0
}, {
  label: '锐意进取型',
  value: '2013',
  key: 1
}, {
  label: '稳健型',
  value: '2014',
  key: 2
}];

var TaxInfo = function (_Component) {
  _inherits(TaxInfo, _Component);

  function TaxInfo(props) {
    _classCallCheck(this, TaxInfo);

    var _this2 = _possibleConstructorReturn(this, (TaxInfo.__proto__ || Object.getPrototypeOf(TaxInfo)).call(this, props));

    _this2.closeMoadl = function () {
      if (_this2.state.Bools) {
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["l" /* getTbuxyQis */])({ clientType: "APP", token: "" }, function () {
          _this2.setState({
            tanCar: false
          });
          __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-7);
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["w" /* Xeyi */])(false));
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请先阅读并确认用户同步信息授权书", 2);
        return;
      }
    };

    _this2.state = {
      yesFlag: false,
      noFlag: true,
      onlyChinese: true,
      noOnlyChinese: false,

      allCountry: [],
      allCountryCode: "",
      allCountryZhCode: "",
      allCountryUsCode: "",
      allCountryUs: [],
      chineseName: "", /*姓名*/
      familyName: "", /*姓*/
      englishName: "", /*名*/
      countryUs: "", /*现居国英文*/
      countryZh: "", /*现居国中文*/
      countryCode: "",
      countryUsCode: "",
      provinceUs: "", /*现居省英文*/
      provinceZh: "", /*现居省中文*/
      cityUs: "", /*现居市英文*/
      cityZh: "", /*现居市中文*/
      birthCityUs: "", /*出生市英文*/
      birthCityZh: "", /*出生市中文*/
      birthCountryUs: "", /*出生国家英文*/
      birthCountryZh: "", /*出生国家中文*/
      birthCountryCode: "",
      birthCountryUsCode: "",
      addressUs: "", /*现居地址英文或拼音*/
      addressZh: "", /*现居地址中文*/
      birthAddressUs: "", /*出生地英文或拼音*/
      birthAddressZh: "", /*出生地址中文*/
      provinceCity: "", /*所在城市(选中国)*/
      provinceCode: "",
      cityCode: "",
      isShow: true,

      TaxCountryCode: "",
      onTaxNumber: "有", /*是否有纳税人识别号*/
      TaxNumber: "", /*纳税人识别号*/
      NoTaxNumber: "A", /*无纳税人识别号原因*/
      NoNumberReasion: "", /*具体原因*/

      arrInfo: [],
      i: 0,

      agreeIcon: true,
      enterType: _this2.props.location.query.enterType ? _this2.props.location.query.enterType : null,

      tanCar: false,
      Bools: false
    };
    _this2.goCallback = false;
    return _this2;
  }

  _createClass(TaxInfo, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.goCallback) {
        this.props.location.state.callback ? this.props.location.state.callback() : null;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      console.log(this.props.Xeyi);
      if (this.props.Xeyi == true) {
        this.setState({
          tanCar: true
        });
      } else {
        this.setState({
          tanCar: false
        });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var dispatch = this.props.dispatch;

      document.getElementsByTagName('title')[0].innerHTML = "税收居民身份";

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["x" /* provinceCity */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["y" /* getAllCountry */])(this.detailCallBack.bind(this), this));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["z" /* getProvinceCity */])(function (data) {
        _this3.setState({
          provinceCity: [data[0].provinceName, data[0].cityList[0].cityName],
          provinceCode: data[0].provinceCode,
          cityCode: data[0].cityList[0].cityCode
        });
      }, function () {
        _this3.setState({
          provinceCity: ["", ""]
        });
      }));
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'detailCallBack',
    value: function detailCallBack(data) {
      var newDataUS = [].concat(data);
      var newDataZh = [].concat(data);
      var usCode = [];
      var code = [];
      var usAll = [];
      var zhAll = [];
      newDataUS.sort(function (a, b) {
        return a.countryNameUs.localeCompare(b.countryNameUs, 'zh-Hans-CN', { sensitivity: 'accent' });
      });
      newDataZh.sort(function (a, b) {
        return a.countryNameZh.localeCompare(b.countryNameZh, 'zh-Hans-CN', { sensitivity: 'accent' });
      });
      for (var i = 0; i < newDataUS.length; i++) {
        usCode.push(newDataUS[i].countryCode);
        usAll.push(newDataUS[i].countryNameUs);
      }
      for (var _i = 0; _i < newDataZh.length; _i++) {
        code.push(newDataZh[_i].countryCode);
        zhAll.push(newDataZh[_i].countryNameZh);
      }
      this.setState({
        allCountryUs: newDataUS,
        allCountry: newDataZh,
        allCountryCode: code,
        allCountryZhCode: code,
        allCountryUsCode: usCode,
        countryUs: usAll[0],
        countryZh: zhAll[code.indexOf(newDataUS[0].countryCode)],
        countryUsCode: usCode[0],
        countryCode: usCode[0],
        birthCountryUs: usAll[0],
        birthCountryZh: zhAll[code.indexOf(newDataUS[0].countryCode)],
        birthCountryUsCode: usCode[0],
        birthCountryCode: usCode[0],
        TaxCountryCode: code[0]
      });
    }
  }, {
    key: 'addTaxCountry',
    value: function addTaxCountry() {
      var _this = this;
      var arr = [];
      arr = arr.concat(this.state.arrInfo);
      var vueKey = this.state.i;
      var ii = void 0;
      for (var i = 0; i < this.state.i; i++) {
        if (arr[i] == undefined) {
          var refOne = "taxName" + String(i);
          arr[i] = refOne;
          ii = 0;
          break;
        }
      }
      if (this.state.i < 19) {
        if (ii != 0) {
          var refTwo = "taxName" + String(vueKey);
          arr[vueKey] = refTwo;
          ii = 1;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('最多只能有20个纳税国家', ToastTime);
        return;
      }
      this.setState({
        i: this.state.i + ii,
        arrInfo: arr
      });
    }
  }, {
    key: 'deleteTaxCountry',
    value: function deleteTaxCountry(vue) {
      var arrTemp = [];
      arrTemp = arrTemp.concat(this.state.arrInfo);
      arrTemp[vue] = undefined;
      this.setState({
        arrInfo: arrTemp
      });
    }
  }, {
    key: 'successCallBack',
    value: function successCallBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: '/TaxSuccess',
        state: {
          callback: this.props.location.state.callback, route: this.props.location.state.route, name: false
        }
      });
    }
  }, {
    key: 'sureBtn',
    value: function sureBtn() {
      var _this4 = this;

      var that = this;
      var dispatch = this.props.dispatch;
      var _props$location$state = this.props.location.state,
          passWord = _props$location$state.passWord,
          name = _props$location$state.name,
          authRequestNo = _props$location$state.authRequestNo,
          bankAccountName = _props$location$state.bankAccountName,
          bankAccountShowNo = _props$location$state.bankAccountShowNo,
          bankCode = _props$location$state.bankCode,
          businessType = _props$location$state.businessType,
          certNo = _props$location$state.certNo,
          certType = _props$location$state.certType,
          mobileNo = _props$location$state.mobileNo,
          paymentChannelId = _props$location$state.paymentChannelId,
          actualBeneficiary = _props$location$state.actualBeneficiary,
          actualController = _props$location$state.actualController,
          actualBeneficiaryCertType = _props$location$state.actualBeneficiaryCertType,
          actualBeneficiaryCertNo = _props$location$state.actualBeneficiaryCertNo,
          actualControllerCertType = _props$location$state.actualControllerCertType,
          actualControllerCertNo = _props$location$state.actualControllerCertNo,
          officialsOrRelatives = _props$location$state.officialsOrRelatives,
          address = _props$location$state.address,
          careerCode = _props$location$state.careerCode,
          cityCode = _props$location$state.cityCode,
          provinceCode = _props$location$state.provinceCode,
          annualIncomeV2 = _props$location$state.annualIncomeV2,
          annualIncome = _props$location$state.annualIncome,
          actualControllerBirthday = _props$location$state.actualControllerBirthday,
          actualControllerValidTerm = _props$location$state.actualControllerValidTerm,
          actualControllerValidEver = _props$location$state.actualControllerValidEver,
          actualControllerSex = _props$location$state.actualControllerSex,
          actualControllerMobileNo = _props$location$state.actualControllerMobileNo,
          actualControllerProvince = _props$location$state.actualControllerProvince,
          actualControllerProfession = _props$location$state.actualControllerProfession,
          actualControllerAddress = _props$location$state.actualControllerAddress,
          actualControllerPostcode = _props$location$state.actualControllerPostcode,
          actualControllerEmail = _props$location$state.actualControllerEmail,
          actualBeneficiaryValidTerm = _props$location$state.actualBeneficiaryValidTerm,
          actualBeneficiaryValidEver = _props$location$state.actualBeneficiaryValidEver,
          actualBeneficiarySex = _props$location$state.actualBeneficiarySex,
          actualBeneficiaryBirthday = _props$location$state.actualBeneficiaryBirthday,
          actualBeneficiaryMobileNo = _props$location$state.actualBeneficiaryMobileNo,
          actualBeneficiaryProvince = _props$location$state.actualBeneficiaryProvince,
          actualBeneficiaryAddress = _props$location$state.actualBeneficiaryAddress,
          actualBeneficiaryPostcode = _props$location$state.actualBeneficiaryPostcode,
          actualBeneficiaryProfession = _props$location$state.actualBeneficiaryProfession,
          actualBeneficiaryEmail = _props$location$state.actualBeneficiaryEmail,
          conversationId = _props$location$state.conversationId,
          certLifeTime = _props$location$state.certLifeTime,
          certValidEver = _props$location$state.certValidEver,
          certValidTerm = _props$location$state.certValidTerm,
          actualBeneficiaryCity = _props$location$state.actualBeneficiaryCity,
          actualControllerCity = _props$location$state.actualControllerCity,
          savePicFun = _props$location$state.savePicFun;

      var password = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.encrypt(passWord);
      var _state = this.state,
          agreeIcon = _state.agreeIcon,
          yesFlag = _state.yesFlag,
          noFlag = _state.noFlag,
          onlyChinese = _state.onlyChinese,
          noOnlyChinese = _state.noOnlyChinese,
          onTaxNumber = _state.onTaxNumber,
          TaxCountryCode = _state.TaxCountryCode,
          TaxNumber = _state.TaxNumber,
          NoTaxNumber = _state.NoTaxNumber,
          NoNumberReasion = _state.NoNumberReasion,
          chineseName = _state.chineseName,
          countryZh = _state.countryZh,
          countryUs = _state.countryUs,
          familyName = _state.familyName,
          englishName = _state.englishName,
          birthCountryZh = _state.birthCountryZh,
          birthCountryUs = _state.birthCountryUs,
          addressZh = _state.addressZh,
          addressUs = _state.addressUs,
          birthAddressZh = _state.birthAddressZh,
          birthAddressUs = _state.birthAddressUs,
          provinceUs = _state.provinceUs,
          provinceZh = _state.provinceZh,
          cityUs = _state.cityUs,
          cityZh = _state.cityZh,
          birthCityUs = _state.birthCityUs,
          birthCityZh = _state.birthCityZh,
          countryCode = _state.countryCode,
          countryUsCode = _state.countryUsCode,
          birthCountryCode = _state.birthCountryCode,
          birthCountryUsCode = _state.birthCountryUsCode,
          provinceCity = _state.provinceCity;

      var isAbroad = yesFlag ? true : false;
      var residentType = onlyChinese ? "0" : "2";
      var crsTaxCountry = [];
      var crsTaxIdentifier = [];
      var noIdentifierReason = [];
      var specificReason = [];
      if (!agreeIcon) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请勾选本人承诺', ToastTime);
        return;
      }
      var cNReg = /^[\u4e00-\u9fa5]+$/; //全中文
      var eNReg = /^[^\u4e00-\u9fa5]+$/; //全英文
      if (noOnlyChinese) {
        if (countryUs == "China") {
          if (chineseName == "" || familyName == "" || englishName == "" || countryZh == "" || countryUs == "" || cityUs == "" || provinceCity == "" || birthCountryUs == "" || birthCountryZh == "" || TaxCountryCode == "") {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请完整填写身份资料', ToastTime);
            return;
          } else {
            if (!cNReg.test(chineseName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓名不能包含英文", ToastTime);
              return;
            }
            if (!eNReg.test(familyName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓不能包含中文", ToastTime);
              return;
            }
            if (!eNReg.test(englishName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("名不能包含中文", ToastTime);
              return;
            }
            if (onTaxNumber === "有") {
              if (TaxNumber == "") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写纳税人识别号', ToastTime);
                return;
              }
            } else if (onTaxNumber === "无") {
              if (NoTaxNumber === "请选择") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请选择无纳税人识别号原因', ToastTime);
                return;
              } else if (NoTaxNumber === "B") {
                if (NoNumberReasion === "") {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写未取得纳税人识别号具体原因', ToastTime);
                  return;
                }
              }
            }
          }
        } else {
          if (chineseName == "" || familyName == "" || englishName == "" || countryZh == "" || countryUs == "" || cityUs == "" || birthCountryUs == "" || birthCountryZh == "" || TaxCountryCode == "") {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请完整填写身份资料', ToastTime);
            return;
          } else {
            if (!cNReg.test(chineseName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓名不能包含英文", ToastTime);
              return;
            }
            if (!eNReg.test(familyName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓不能包含中文", ToastTime);
              return;
            }
            if (!eNReg.test(englishName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("名不能包含中文", ToastTime);
              return;
            }
            if (onTaxNumber === "有") {
              if (TaxNumber == "") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写纳税人识别号', ToastTime);
                return;
              }
            } else if (onTaxNumber === "无") {
              if (NoTaxNumber === "请选择") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请选择无纳税人识别号原因', ToastTime);
                return;
              } else if (NoTaxNumber === "B") {
                if (NoNumberReasion === "") {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写未取得纳税人识别号具体原因', ToastTime);
                  return;
                }
              }
            }
          }
        }
        if (NoTaxNumber === "请选择") {
          noIdentifierReason.push("");
        } else {
          noIdentifierReason = [NoTaxNumber];
        }
        crsTaxCountry = [TaxCountryCode];
        crsTaxIdentifier.push(TaxNumber);

        specificReason.push(NoNumberReasion);
        var disFlag = false;

        this.state.arrInfo.map(function (item, key) {
          if (item != undefined) {
            if (that.refs[item].state.TaxCountryCode == "") {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("纳税居民国" + String(key + 2) + "不能为空", ToastTime);
              disFlag = true;
              return false;
            } else if (that.refs[item].state.onTaxNumber == "有") {
              if (that.refs[item].state.TaxNumber === "") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请填写纳税居民国" + String(key + 2) + "纳税人识别号", ToastTime);
                disFlag = true;
                return false;
              }
            } else if (that.refs[item].state.onTaxNumber === "无") {
              if (that.refs[item].state.NoTaxNumber === "请选择") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择纳税居民国" + String(key + 2) + "无纳税人识别号原因", ToastTime);
                disFlag = true;
                return false;
              } else if (that.refs[item].state.NoTaxNumber === "B") {
                if (that.refs[item].state.NoNumberReasion === "") {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请填写纳税居民国" + String(key + 2) + "未取得纳税人识别号原因", ToastTime);
                  disFlag = true;
                  return false;
                }
              }
            }
            if (that.refs[item].state.NoTaxNumber === "请选择") {
              noIdentifierReason.push("");
            } else {
              noIdentifierReason.push(that.refs[item].state.NoTaxNumber);
            }
            crsTaxCountry.push(that.refs[item].state.TaxCountryCode);
            crsTaxIdentifier.push(that.refs[item].state.TaxNumber);
            specificReason.push(that.refs[item].state.NoNumberReasion);
          }
        });
        if (disFlag) {
          return false;
        }
        crsTaxCountry = crsTaxCountry.join();
        crsTaxIdentifier = crsTaxIdentifier.join();
        noIdentifierReason = noIdentifierReason.join();
        specificReason = specificReason.join();
        var allInObj = {
          isAbroad: isAbroad, residentType: residentType,
          chineseName: chineseName,
          familyName: familyName,
          englishName: englishName,
          countryZh: countryCode,
          countryUs: countryUsCode,
          provinceUs: provinceUs,
          provinceZh: countryUs == "China" ? this.state.provinceCode : provinceZh,
          cityUs: cityUs,
          cityZh: countryUs == "China" ? this.state.cityCode : cityZh,
          birthCityUs: birthCityUs,
          birthCityZh: birthCityZh,
          postCode: "",
          email: "",
          addressZh: addressZh,
          addressUs: addressUs,
          birthCountryZh: birthCountryCode,
          birthCountryUs: birthCountryUsCode,
          birthAddressZh: birthAddressZh,
          birthAddressUs: birthAddressUs,

          crsTaxCountry: crsTaxCountry,
          crsTaxIdentifier: crsTaxIdentifier,
          noIdentifierReason: noIdentifierReason,
          specificReason: specificReason,

          password: password, name: name, authRequestNo: authRequestNo,
          bankAccountName: bankAccountName, bankAccountShowNo: bankAccountShowNo,
          bankCode: bankCode, businessType: businessType, certNo: certNo, certType: certType,
          mobileNo: mobileNo, paymentChannelId: paymentChannelId,
          actualBeneficiary: actualBeneficiary, actualController: actualController, actualBeneficiaryCertType: actualBeneficiaryCertType, actualBeneficiaryCertNo: actualBeneficiaryCertNo, actualControllerCertType: actualControllerCertType, actualControllerCertNo: actualControllerCertNo, officialsOrRelatives: officialsOrRelatives, address: address, careerCode: careerCode, cityCode: cityCode, provinceCode: provinceCode,
          annualIncomeV2: annualIncomeV2, annualIncome: annualIncome, actualControllerBirthday: actualControllerBirthday, actualControllerValidTerm: actualControllerValidTerm, actualControllerValidEver: actualControllerValidEver, actualControllerSex: actualControllerSex, actualControllerMobileNo: actualControllerMobileNo, actualControllerProvince: actualControllerProvince, actualControllerProfession: actualControllerProfession,
          actualControllerAddress: actualControllerAddress, actualControllerPostcode: actualControllerPostcode, actualControllerEmail: actualControllerEmail, actualBeneficiaryValidTerm: actualBeneficiaryValidTerm, actualBeneficiaryValidEver: actualBeneficiaryValidEver, actualBeneficiarySex: actualBeneficiarySex, actualBeneficiaryBirthday: actualBeneficiaryBirthday, actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
          actualBeneficiaryProvince: actualBeneficiaryProvince, actualBeneficiaryAddress: actualBeneficiaryAddress, actualBeneficiaryPostcode: actualBeneficiaryPostcode, actualBeneficiaryProfession: actualBeneficiaryProfession, actualBeneficiaryEmail: actualBeneficiaryEmail, conversationId: conversationId, certLifeTime: certLifeTime, certValidEver: certValidEver, certValidTerm: certValidTerm, actualBeneficiaryCity: actualBeneficiaryCity, actualControllerCity: actualControllerCity

        };
        console.log(allInObj);
        var route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
        var callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
        if (name) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["A" /* getCertifcationSuccess */])(that, allInObj, function () {
            var route = _this4.props.location.state && _this4.props.location.state.route ? _this4.props.location.state.route : null;
            if (_this4.state.enterType == "Answer") {
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
                pathname: '/AnswerActivityDatillPage',
                state: {},
                query: { enterType: "Answer", activityId: _this4.props.location.query.activityId }
              });
            } else if (_this4.state.enterType == "activity") {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["q" /* getUserInfoListTemp */])(function (resInfo) {
                var userId_a = resInfo.userId ? resInfo.userId : "";
                var tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
                var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                console.log(paramsStr);
                var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_4__util_js___default.a.aesEncrypt(paramsStr));
                window.location.href = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.hdUrl + paramsData;
              }));
            }
            if (route) {
              _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
                if (val) {
                  __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-7);
                } else {
                  _this4.setState({
                    tanCar: true
                  });
                  _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["w" /* Xeyi */])(true));
                }
              }));
            }
          }, this.props.huiDiao));
        } else {
          var _allInObj = {
            isAbroad: isAbroad, residentType: residentType,
            chineseName: chineseName,
            familyName: familyName,
            englishName: englishName,
            countryZh: countryCode,
            countryUs: countryUsCode,
            provinceUs: provinceUs,
            provinceZh: countryUs == "China" ? this.state.provinceCode : provinceZh,
            cityUs: cityUs,
            cityZh: countryUs == "China" ? this.state.cityCode : cityZh,
            birthCityUs: birthCityUs,
            birthCityZh: birthCityZh,
            postCode: "",
            email: "",
            addressZh: addressZh,
            addressUs: addressUs,
            birthCountryZh: birthCountryCode,
            birthCountryUs: birthCountryUsCode,
            birthAddressZh: birthAddressZh,
            birthAddressUs: birthAddressUs,
            crsTaxCountry: crsTaxCountry,
            crsTaxIdentifier: crsTaxIdentifier,
            noIdentifierReason: noIdentifierReason,
            specificReason: specificReason
          };
          console.log(_allInObj);
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["B" /* syncAccount */])(_allInObj, function (resInfo) {
            var route = _this4.props.location.state && _this4.props.location.state.route ? _this4.props.location.state.route : null;
            if (_this4.props.location.query.enterType == "InviteRegister") {
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
                pathname: '/?enterType=Investment'
              });
            } else if (_this4.state.enterType == "Answer") {
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
                pathname: '/AnswerActivityDatillPage',
                state: {},
                query: { enterType: "Answer", activityId: _this4.props.location.query.activityId }
              });
            } else if (_this4.state.enterType == "activity") {
              var userId_a = resInfo.userId ? resInfo.userId : "";
              var tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
              var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
              console.log(paramsStr);
              var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_4__util_js___default.a.aesEncrypt(paramsStr));
              window.location.href = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.hdUrl + paramsData;
            }
            if (route) {
              _this4.goCallback = true;
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-2);
            }
          }, function (msg) {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.ToastTime);
          }));
        }
      } else {
        if (!yesFlag && !noFlag) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择是否有向向其他国家纳税的活动", ToastTime);
          return;
        } else if (!onlyChinese && !noOnlyChinese) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择本人申明", ToastTime);
          return;
        }
        var _allInObj2 = {
          isAbroad: isAbroad, residentType: residentType,
          password: password, name: name, authRequestNo: authRequestNo,
          bankAccountName: bankAccountName, bankAccountShowNo: bankAccountShowNo,
          bankCode: bankCode, businessType: businessType, certNo: certNo, certType: certType,
          mobileNo: mobileNo, paymentChannelId: paymentChannelId,
          actualBeneficiary: actualBeneficiary, actualController: actualController, actualBeneficiaryCertType: actualBeneficiaryCertType, actualBeneficiaryCertNo: actualBeneficiaryCertNo, actualControllerCertType: actualControllerCertType, actualControllerCertNo: actualControllerCertNo, officialsOrRelatives: officialsOrRelatives, address: address, careerCode: careerCode, cityCode: cityCode, provinceCode: provinceCode,
          annualIncomeV2: annualIncomeV2, annualIncome: annualIncome, actualControllerBirthday: actualControllerBirthday, actualControllerValidTerm: actualControllerValidTerm, actualControllerValidEver: actualControllerValidEver, actualControllerSex: actualControllerSex, actualControllerMobileNo: actualControllerMobileNo, actualControllerProvince: actualControllerProvince, actualControllerProfession: actualControllerProfession,
          actualControllerAddress: actualControllerAddress, actualControllerPostcode: actualControllerPostcode, actualControllerEmail: actualControllerEmail, actualBeneficiaryValidTerm: actualBeneficiaryValidTerm, actualBeneficiaryValidEver: actualBeneficiaryValidEver, actualBeneficiarySex: actualBeneficiarySex, actualBeneficiaryBirthday: actualBeneficiaryBirthday, actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
          actualBeneficiaryProvince: actualBeneficiaryProvince, actualBeneficiaryAddress: actualBeneficiaryAddress, actualBeneficiaryPostcode: actualBeneficiaryPostcode, actualBeneficiaryProfession: actualBeneficiaryProfession, actualBeneficiaryEmail: actualBeneficiaryEmail, conversationId: conversationId, certLifeTime: certLifeTime, certValidEver: certValidEver, certValidTerm: certValidTerm, actualBeneficiaryCity: actualBeneficiaryCity, actualControllerCity: actualControllerCity
        };
        if (name) {
          var _route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["A" /* getCertifcationSuccess */])(that, _allInObj2, function () {
            var route = _this4.props.location.state && _this4.props.location.state.route ? _this4.props.location.state.route : null;
            if (_this4.state.enterType == "Answer") {
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
                pathname: '/AnswerActivityDatillPage',
                state: {},
                query: { enterType: "Answer", activityId: _this4.props.location.query.activityId }
              });
            } else if (_this4.state.enterType == "activity") {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["q" /* getUserInfoListTemp */])(function (resInfo) {
                var userId_a = resInfo.userId ? resInfo.userId : "";
                var tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
                var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                console.log(paramsStr);
                var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_4__util_js___default.a.aesEncrypt(paramsStr));
                window.location.href = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.hdUrl + paramsData;
              }));
            }
            if (route) {
              _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["k" /* getTbuxy */])({ clientType: "APP", token: "" }, function (val) {
                if (val) {
                  __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-7);
                } else {
                  _this4.setState({
                    tanCar: true
                  });
                  _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["w" /* Xeyi */])(true));
                }
              }));
            }
          }, this.props.huiDiao));
        } else {
          var obj = {
            isAbroad: isAbroad,
            residentType: residentType
          };
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["B" /* syncAccount */])(obj, function (resInfo) {
            var route = _this4.props.location.state && _this4.props.location.state.route ? _this4.props.location.state.route : null;
            if (_this4.props.location.query.enterType == "InviteRegister") {
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
                pathname: '/?enterType=Investment'
              });
            } else if (_this4.state.enterType == "Answer") {
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
                pathname: '/AnswerActivityDatillPage',
                state: {},
                query: { enterType: "Answer", activityId: _this4.props.location.query.activityId }
              });
            } else if (_this4.state.enterType == "activity") {
              var userId_a = resInfo.userId ? resInfo.userId : "";
              var tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
              var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
              console.log(paramsStr);
              var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_4__util_js___default.a.aesEncrypt(paramsStr));
              window.location.href = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.hdUrl + paramsData;
            }
            if (route) {
              _this4.goCallback = true;
              __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-2);
            }
          }, function (msg) {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(msg, ToastTime);
          }));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      console.log(this.props.location.state);
      var arrUs = [];
      var arrZh = [];
      var usAll = [];
      var zhAll = [];
      var arrProc = [];
      if (this.state.allCountry.length > 0 && this.state.allCountryUs.length > 0) {
        for (var i = 0; i < this.state.allCountry.length; i++) {
          arrUs.push({
            label: this.state.allCountryUs[i].countryNameUs,
            value: this.state.allCountryUs[i].countryCode
          });
          arrZh.push({
            label: this.state.allCountry[i].countryNameZh,
            value: this.state.allCountry[i].countryCode
          });
          usAll.push(this.state.allCountryUs[i].countryNameUs);
          zhAll.push(this.state.allCountry[i].countryNameZh);
        }
      }
      if (this.props.provinceCity != null) {
        for (var _i2 = 0; _i2 < this.props.provinceCity.length; _i2++) {
          var obj = {};
          var obj2 = [];
          obj.label = this.props.provinceCity[_i2].provinceName;
          obj.value = this.props.provinceCity[_i2].provinceCode;
          for (var k = 0; k < this.props.provinceCity[_i2].cityList.length; k++) {
            obj2.push({
              label: this.props.provinceCity[_i2].cityList[k].cityName,
              value: this.props.provinceCity[_i2].cityList[k].cityCode
            });
          }
          obj.children = obj2;
          arrProc.push(obj);
        }
      }

      var _state2 = this.state,
          yesFlag = _state2.yesFlag,
          noFlag = _state2.noFlag,
          onlyChinese = _state2.onlyChinese,
          noOnlyChinese = _state2.noOnlyChinese,
          onTaxNumber = _state2.onTaxNumber,
          NoTaxNumber = _state2.NoTaxNumber,
          chineseName = _state2.chineseName,
          countryZh = _state2.countryZh,
          countryUs = _state2.countryUs,
          familyName = _state2.familyName,
          englishName = _state2.englishName,
          birthCountryZh = _state2.birthCountryZh,
          birthCountryUs = _state2.birthCountryUs,
          addressZh = _state2.addressZh,
          addressUs = _state2.addressUs,
          birthAddressZh = _state2.birthAddressZh,
          birthAddressUs = _state2.birthAddressUs,
          provinceUs = _state2.provinceUs,
          provinceZh = _state2.provinceZh,
          cityUs = _state2.cityUs,
          cityZh = _state2.cityZh,
          birthCityUs = _state2.birthCityUs,
          birthCityZh = _state2.birthCityZh,
          countryCode = _state2.countryCode,
          countryUsCode = _state2.countryUsCode,
          birthCountryCode = _state2.birthCountryCode,
          birthCountryUsCode = _state2.birthCountryUsCode,
          TaxCountryCode = _state2.TaxCountryCode,
          provinceCity = _state2.provinceCity,
          agreeIcon = _state2.agreeIcon;

      console.log(this.props.location.state, this.props.huiDiao);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this5.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u7A0E\u6536\u5C45\u6C11\u8EAB\u4EFD'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content', style: { paddingBottom: "40px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'TaxBgMain' },
            '\u6839\u636E\u300A\u975E\u5C45\u6C11\u91D1\u878D\u8D26\u6237\u6D89\u7A0E\u4FE1\u606F\u5C3D\u804C\u8C03\u67E5\u7BA1\u7406\u529E\u6CD5\u300B\u89C4\u5B9A\uFF0C\u8BF7\u60A8\u8865\u5145\u4EE5\u4E0B\u8D44\u6599\uFF0C\u9605\u8BFB\u5E76\u52FE\u9009\u627F\u8BFA\u5185\u5BB9:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
            '\u672C\u4EBA\u7533\u660E\u4E3A'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: onlyChinese ? "chooseYes" : "chooseNO", onClick: function onClick() {
                _this5.setState({ onlyChinese: true, noOnlyChinese: false, resultShow: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u4EC5\u4E3A\u4E2D\u56FD\u7A0E\u6536\u5C45\u6C11'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: noOnlyChinese ? "chooseYes" : "chooseNO", onClick: function onClick() {
                //  this.setState({ noOnlyChinese:true, onlyChinese:false, resultShow:true, }) 
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("线上交易仅支持中国税收人开户，如您在其他国家同时存在纳税，请联系线下网点进行开户", ToastTime);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5373\u662F\u4E2D\u56FD\u7A0E\u6536\u5C45\u6C11\u53C8\u662F\u5176\u4ED6\u56FD\u5BB6\uFF08\u5730\u533A\uFF09\u7A0E\u6536\u5C45\u6C11'
            )
          ),
          noOnlyChinese ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'crsAdd' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u8865\u5145\u8EAB\u4EFD\u8D44\u6599'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u59D3\u540D\uFF08\u4E2D\u6587\uFF09'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D', value: chineseName, onChange: function onChange(e) {
                  _this5.setState({ chineseName: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u59D3 (\u82F1\u6587\u6216\u62FC\u97F3)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u59D3', value: familyName, onChange: function onChange(e) {
                  _this5.setState({ familyName: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u540D (\u82F1\u6587\u6216\u62FC\u97F3)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u540D', value: englishName, onChange: function onChange(e) {
                  _this5.setState({ englishName: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u73B0\u5C45\u5730\u5740 (\u82F1\u6587\u6216\u62FC\u97F3)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrUs, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [countryUsCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ countryUsCode: e[0], countryCode: e[0], countryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], countryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7701 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u7701', value: provinceUs, onChange: function onChange(e) {
                  _this5.setState({ provinceUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: cityUs, onChange: function onChange(e) {
                  _this5.setState({ cityUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: addressUs, onChange: function onChange(e) {
                  _this5.setState({ addressUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: countryUs == "China" ? "" : "ifChina", style: { height: '0.9rem', paddingLeft: '13px', paddingRight: '13px', lineHeight: '1rem', fontSize: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u73B0\u5C45\u5730\u5740 (\u4E2D\u6587)'
              ),
              countryUs == "China" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u6B64\u9879\u9009\u586B'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrZh, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [countryCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ countryCode: e[0], countryUsCode: e[0], countryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], countryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            countryUs == "China" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrProc, cols: 2, className: 'forss', title: '\u9009\u62E9\u57CE\u5E02', value: [this.state.provinceCode, this.state.cityCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ provinceCode: e[0], cityCode: e[1] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u6240\u5728\u57CE\u5E02'
                )
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7701'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u7701', value: provinceZh, onChange: function onChange(e) {
                  _this5.setState({ provinceZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            countryUs == "China" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: cityZh, onChange: function onChange(e) {
                  _this5.setState({ cityZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              countryUs == "China" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: addressZh, onChange: function onChange(e) {
                  _this5.setState({ addressZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u51FA\u751F\u5730 (\u82F1\u6587\u6216\u62FC\u97F3)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrUs, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [birthCountryUsCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ birthCountryUsCode: e[0], birthCountryCode: e[0], birthCountryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], birthCountryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: birthCityUs, onChange: function onChange(e) {
                  _this5.setState({ birthCityUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: birthAddressUs, onChange: function onChange(e) {
                  _this5.setState({ birthAddressUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u51FA\u751F\u5730 (\u4E2D\u6587)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrZh, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [birthCountryCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ birthCountryCode: e[0], birthCountryUsCode: e[0], birthCountryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], birthCountryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: birthCityZh, onChange: function onChange(e) {
                  _this5.setState({ birthCityZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: birthAddressZh, onChange: function onChange(e) {
                  _this5.setState({ birthAddressZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { hegiht: "0.18rem" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'taxCountryTitle' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  '\u7EB3\u7A0E\u5C45\u6C11\u56FD1'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'PickerWrap' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                  { data: arrZh, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [TaxCountryCode], onPickerChange: function onPickerChange(e) {
                      return console.log('onPickerChange', e);
                    }, onOk: function onOk(e) {
                      return _this5.setState({ TaxCountryCode: e[0] });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                    { arrow: 'horizontal' },
                    '\u7A0E\u6536\u5C45\u6C11\u56FD(\u5730\u533A)'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'PickerWrap' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                  { data: HoverNoTaxNumber, cols: 1, className: 'forss', title: '\u8BF7\u9009\u62E9', value: [this.state.onTaxNumber], onPickerChange: function onPickerChange(e) {
                      return console.log('onPickerChange', e);
                    }, onOk: function onOk(e) {
                      return _this5.setState({ onTaxNumber: e[0] });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                    { arrow: 'horizontal' },
                    '\u662F\u5426\u6709\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
                  )
                )
              ),
              onTaxNumber === "有" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'taxInputClass' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                    _this5.setState({ isShow: false });
                  }, onBlur: function onBlur() {
                    _this5.setState({ isShow: true });
                  }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BC6\u522B\u53F7', value: this.state.TaxNumber, onChange: function onChange(e) {
                    _this5.setState({ TaxNumber: e.target.value });
                  }, style: { WebkitFlex: 1, textAlign: 'right' } })
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PickerWrap' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                    { data: NoTaxNumberArr, cols: 1, className: 'forss', title: '\u9009\u62E9\u539F\u56E0', value: [this.state.NoTaxNumber], onPickerChange: function onPickerChange(e) {
                        return console.log('onPickerChange', e);
                      }, onOk: function onOk(e) {
                        return _this5.setState({ NoTaxNumber: e[0] });
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                      { arrow: 'horizontal' },
                      '\u65E0\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7\u539F\u56E0'
                    )
                  )
                ),
                NoTaxNumber === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'taxInputClass' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    '\u5177\u4F53\u539F\u56E0'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                      _this5.setState({ isShow: false });
                    }, onBlur: function onBlur() {
                      _this5.setState({ isShow: true });
                    }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5177\u4F53\u539F\u56E0', value: this.state.NoNumberReasion, onChange: function onChange(e) {
                      _this5.setState({ NoNumberReasion: e.target.value });
                    }, style: { WebkitFlex: 1, textAlign: 'right' } })
                ) : null
              )
            ),
            this.state.arrInfo.map(function (item, i) {
              var index = i;

              if (item != undefined) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TaxCountry, { key: "item" + i, allCountry: arrZh, ref: item, 'this': _this5, index: index });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: "0 13px 0 0.26em", marginTop: '0.3rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this5.addTaxCountry();
                  }, style: { height: '0.8rem', display: "-webkit-flex", borderRadius: 40, border: "1px solid #ff9536", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#ff9536' } },
                  '+\u6DFB\u52A0\u5176\u4ED6\u7EB3\u7A0E\u5C45\u6C11\u56FD'
                )
              )
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'toSureAll' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: agreeIcon ? "yesSure" : "noSure" },
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { onClick: function onClick() {
                  _this5.setState({ agreeIcon: !_this5.state.agreeIcon });
                } }),
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'sureContent' },
              '"\u672C\u4EBA\u786E\u8BA4\u4E0A\u8FF0\u6240\u63D0\u4F9B\u7684\u4FE1\u606F\u771F\u5B9E\u3001\u51C6\u786E\u3001\u5B8C\u6574\u3001\u5408\u6CD5\u3001\u6709\u6548\uFF0C\u5982\u6709\u4F2A\u9020 \u3001\u6B3A\u8BC8\uFF0C\u63D0\u4F9B\u865A\u5047\u4FE1\u606F\u7B49\u884C\u4E3A\uFF0C\u672C\u4EBA\u81EA\u613F\u627F\u62C5\u6CD5\u5F8B\u8D23\u4EFB\u3002\u5F53\u6709\u5173\u8D44\u6599\u4FE1\u5FC3\u53D1\u751F\u53D8\u66F4\u65F6\uFF0C\u672C\u4EBA\u5C06\u5728 30\u65E5\u5185\u4E66\u9762\u901A\u77E5\u534E\u590F\u57FA\u91D1\u529E\u7406\u4FE1\u606F\u66F4\u6539\u624B\u7EED\uFF0C\u672C\u4EBA\u81EA\u613F\u627F\u62C5\u56E0\u672A\u5C65\u884C\u4E0A\u8FF0\u4E49\u52A1\u7167\u6210\u7684\u98CE\u9669\u548C\u635F\u5931\uFF0C\u534E\u590F\u57FA\u91D1\u5BF9\u672C\u4EBA\u906D\u53D7\u7684\u635F\u5931\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002"'
            )
          )
        ),
        this.state.isShow ? !this.state.tanCar ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FixedBottomHave', style: { WebkitJustifyContent: "center" }, onClick: function onClick() {
              return _this5.sureBtn();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F'
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FixedBottomHave', style: { WebkitJustifyContent: "center" }, onClick: function onClick() {} },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F'
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modal_ModalList__["a" /* default */], { heightAll: true, onFun: function onFun(Bools) {
            _this5.setState({ Bools: Bools });
          }, flag: this.state.tanCar, btnRight: "确认", btnRightFun: this.closeMoadl, content: "为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》", title: "" })
      );
    }
  }]);

  return TaxInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var HoverNoTaxNumber = [{
  label: '有',
  value: '有',
  key: 0
}, {
  label: '无',
  value: '无',
  key: 1
}];

var NoTaxNumberArr = [{
  label: '居民国不发放识别号',
  value: 'A',
  key: 0
}, {
  label: '未取得纳税人识别号',
  value: 'B',
  key: 1
}];

var TaxCountry = function (_Component2) {
  _inherits(TaxCountry, _Component2);

  function TaxCountry(props) {
    _classCallCheck(this, TaxCountry);

    var _this6 = _possibleConstructorReturn(this, (TaxCountry.__proto__ || Object.getPrototypeOf(TaxCountry)).call(this, props));

    _this6.state = {
      TaxCountryCode: _this6.props.this.state.allCountryCode[0],
      onTaxNumber: "有", /*是否有纳税人识别号*/
      TaxNumber: "", /*纳税人识别号*/
      NoTaxNumber: "A", /*无纳税人识别号原因*/
      NoNumberReasion: "" /*具体原因*/
    };
    return _this6;
  }

  _createClass(TaxCountry, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _state3 = this.state,
          onTaxNumber = _state3.onTaxNumber,
          NoTaxNumber = _state3.NoTaxNumber;
      var allCountry = this.props.allCountry;

      var thisPro = this.props.this;
      var index = this.props.index + 2;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'taxCountryTitle' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            "纳税居民国" + index
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: function onClick() {
                thisPro.deleteTaxCountry(_this7.props.index);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              null,
              '\u5220\u9664'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerWrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
            { data: allCountry, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [this.state.TaxCountryCode], onPickerChange: function onPickerChange(e) {
                return console.log('onPickerChange', e);
              }, onOk: function onOk(e) {
                return _this7.setState({ TaxCountryCode: e[0] });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
              { arrow: 'horizontal' },
              '\u7A0E\u6536\u5C45\u6C11\u56FD(\u5730\u533A)'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerWrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
            { data: HoverNoTaxNumber, cols: 1, className: 'forss', title: '\u8BF7\u9009\u62E9', value: [this.state.onTaxNumber], onPickerChange: function onPickerChange(e) {
                return console.log('onPickerChange', e);
              }, onOk: function onOk(e) {
                return _this7.setState({ onTaxNumber: e[0] });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
              { arrow: 'horizontal' },
              '\u662F\u5426\u6709\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
            )
          )
        ),
        onTaxNumber === "有" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'taxInputClass' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BC6\u522B\u53F7', value: this.state.TaxNumber, onChange: function onChange(e) {
              _this7.setState({ TaxNumber: e.target.value });
            }, style: { WebkitFlex: 1, textAlign: 'right' } })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PickerWrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
              { data: NoTaxNumberArr, cols: 1, className: 'forss', title: '\u9009\u62E9\u539F\u56E0', value: [this.state.NoTaxNumber], onPickerChange: function onPickerChange(e) {
                  return console.log('onPickerChange', e);
                }, onOk: function onOk(e) {
                  return _this7.setState({ NoTaxNumber: e[0] });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                { arrow: 'horizontal' },
                '\u65E0\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7\u539F\u56E0'
              )
            )
          ),
          NoTaxNumber === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'taxInputClass' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5177\u4F53\u539F\u56E0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5177\u4F53\u539F\u56E0', value: this.state.NoNumberReasion, onChange: function onChange(e) {
                _this7.setState({ NoNumberReasion: e.target.value });
              }, style: { WebkitFlex: 1, textAlign: 'right' } })
          ) : null
        )
      );
    }
  }]);

  return TaxCountry;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    provinceCity: state.provinceCity,
    Xeyi: state.Xeyi,
    huiDiao: state.huiDiao
    // userHasInvested:state.userHasInvested,
    // inNeedUpdate:state.inNeedUpdate,
    // payLoading:state.riskInPay.payLoading,
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(TaxInfo));

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import Util from '../util.js';




var TaxSuccess = function (_Component) {
  _inherits(TaxSuccess, _Component);

  function TaxSuccess(props) {
    _classCallCheck(this, TaxSuccess);

    var _this = _possibleConstructorReturn(this, (TaxSuccess.__proto__ || Object.getPrototypeOf(TaxSuccess)).call(this, props));

    _this.state = {
      title: ''
    };
    _this.flag = false;
    return _this;
  }

  _createClass(TaxSuccess, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "实名认证";
      this.setState({
        title: '实名认证'
      });
    }
  }, {
    key: 'next',
    value: function next() {
      //登录成功回调
      var route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
      if (route) {
        // hashHistory.go(route - window.history.length);
        __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-7);
      }
      this.flag = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.flag) {
        this.flag = false;
        var callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
        if (callback) {
          callback();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      console.log(this.props.location);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.state.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitAlignItems: "center", fontSize: '0.30rem', flexFlow: 'column', background: '#fff', padding: '1rem 13px 1rem 13px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { textAlign: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(432), style: { width: '1.24rem', height: '1.24rem' } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { marginTop: '0.2rem' } },
                this.state.title + '\u6210\u529F!'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                display: "-webkit-flex",
                marginTop: 15,
                height: 40,
                backgroundColor: "#fa063a",
                WebkitJustifyContent: "center",
                WebkitAlignItems: "center",
                borderRadius: 30,
                marginLeft: 13,
                marginRight: 13,
                marginBottom: 15
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: "#fff", fontSize: "0.3rem" }, onClick: function onClick() {
                  return _this2.next();
                } },
              '\u8FD4\u56DE\u6211\u7684\u8D44\u4EA7'
            )
          )
        )
      );
    }
  }]);

  return TaxSuccess;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TaxSuccess);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__myAssets_payment_Password__ = __webpack_require__(267);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var getDateYM = __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.returnDate;

/*智投交易记录详情*/

var TransactionDetail = function (_Component) {
  _inherits(TransactionDetail, _Component);

  function TransactionDetail(props) {
    _classCallCheck(this, TransactionDetail);

    var _this = _possibleConstructorReturn(this, (TransactionDetail.__proto__ || Object.getPrototypeOf(TransactionDetail)).call(this, props));

    _this.keyOk = function () {
      var pushResult = function pushResult(i, result) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].hide();
        if (i === 1) {
          _this.setState({
            pwdFlag: false
          });
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '撤回结果',
              content: '申请已受理',
              dataSouse: [['申请编号', _this.state.dataSouse.businessType == "E231" ? _this.props.location.state.data.tradeRequestId : result.content], ['产品名称', _this.state.dataSouse.businessType === "T522" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(_this.state.dataSouse.targetFundName) : _this.state.dataSouse.fundName], ['所属交易日', getDateYM(_this.state.dataSouse.requestWorkday)]],
              souseVal: ['返回我的智投']

            }
          });
        } else if (i === 3) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '撤回',
              content: '撤回失败',
              content2: result,
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        }
      };
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].loading();
      var data = _this.props.location.state.data;
      data.password = __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.encrypt(_this.state.keyPasswordVal);
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["t" /* superfundCancelFun */])(data, pushResult, function () {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].hide();
      }));
    };

    _this.onChangePwd = function (val) {
      _this.setState({
        keyPasswordVal: val
      });
    };

    _this.state = {
      dataSouse: [],
      list: _defineProperty({
        list_item1: {
          key: []
        }
      }, 'list_item1', {
        key: []
      }),
      pwdFlag: false,
      keyPasswordVal: ""
    };
    return _this;
  }

  _createClass(TransactionDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "交易详情";
      var dispatch = this.props.dispatch;

      var data = this.props.location.state.data;
      var flag = this.props.location.state.flag ? this.props.location.state.flag : null;
      if (flag === "QR") {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["u" /* historyConfirmDetail */])(data, this.detailCallBack.bind(this), this));
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["v" /* getTradeDetail */])(data, this.detailCallBack.bind(this), this));
      }
    }
  }, {
    key: 'detailCallBack',
    value: function detailCallBack(data) {
      var list = {};
      if (data.businessType === "T020" || data.businessType === "T022") {
        /*认购 申购 超级基金申购*/
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13'],
            name1: ['产品名称', data.fundName],
            name2: ['资金渠道', data.trustChannelName],
            name3: ['支付渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName)],
            name4: ['申请编号', data.tradeRequestId],
            name5: ['收费方式', data.fundShareClassName],
            name6: ['下单日期', getDateYM(data.businessTime)],
            name7: ['下单时间', getDateHS(data.businessTime)],
            name8: ['所属交易日', getDateYM(data.requestWorkday)],
            name9: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + "元"],
            name10: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name11: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name12: ['交易状态', data.businessStateName],
            name13: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name13 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name14 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name14");
        }
      } else if (data.businessType === "T220") {
        /*赎回转认购*/
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13', 'name14'],
            name1: ['产品名称', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundName)],
            name2: ['资金渠道', data.trustChannelName],
            name3: ['支付渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName)],
            name4: ['申请编号', data.tradeRequestId],
            name5: ['收费方式', data.targetFundShareClassName],
            name6: ['下单日期', getDateYM(data.businessTime)],
            name7: ['下单时间', getDateHS(data.businessTime)],
            name8: ['所属交易日', getDateYM(data.requestWorkday)],
            name9: ['支付方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundName)],
            name10: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + "元"],
            name11: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name12: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name13: ['交易状态', data.businessStateName],
            name14: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name14 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name15 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name15");
        }
      } else if (data.businessType === "T522") {
        /*超级基金申购*/
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', /*'name5',*/'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13'],
            name1: ['产品名称', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundName)],
            name2: ['资金渠道', data.trustChannelName],
            name3: ['支付渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName)],
            name4: ['申请编号', data.tradeRequestId],
            /*name5:['支付方式',""],*/
            name6: ['下单日期', getDateYM(data.businessTime)],
            name7: ['下单时间', getDateHS(data.businessTime)],
            name8: ['所属交易日', getDateYM(data.requestWorkday)],
            name9: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + "元"],
            name10: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name11: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name12: ['交易状态', data.businessStateName],
            name13: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name13 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name14 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name14");
        }
      } else if (data.businessType === "T822") {
        /*超级基金申购*/
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13', 'name14', 'name15'],
            name1: ['客户名称', data.tradeAccountName],
            name2: ['业务类别', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessTypeName)],
            name3: ['产品名称', data.targetFundName],
            name4: ['资金渠道', data.trustChannelName],
            name5: ['申请编号', data.tradeRequestId],
            name6: ['收费方式', data.targetFundShareClassName],
            name7: ['下单日期', getDateYM(data.businessTime)],
            name8: ['下单时间', getDateHS(data.businessTime)],
            name9: ['所属交易日', getDateYM(data.requestWorkday)],
            name10: ['支付方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundName)],
            name11: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + "元"],
            name12: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name13: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name14: ['交易状态', data.businessStateName],
            name15: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name15 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name16 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name16");
        }
      } else if (data.businessType === 'E224' || data.businessType === 'E225' || data.businessType === 'E226' || data.businessType === 'E205' || data.businessType === 'E204' || data.businessType === 'E206') {
        /*定投通  */
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name12', 'name13', 'name14',, 'name15', 'name16'],
            name1: ['产品名称', data.targetFundName],
            name2: ['资金渠道', data.trustChannelName],
            name3: ['支付渠道', data.trustChannelName],
            name4: ['基金账号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taAccountNo)],
            name5: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name6: ['协议号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradePlanId)],
            name7: ['收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName)],
            name8: ['下单日期', getDateYM(data.businessTime)],
            name9: ['下单时间', getDateHS(data.businessTime)],
            name10: ['所属交易日', getDateYM(data.requestWorkday)],
            /*name11:['支付时间',Util.formatStr(data.paymentTime)],*/
            name12: ['申请金额', data.applicationAmount != null ? data.applicationAmount + "元" : "--"],
            name13: ['结算币种', "人民币"],
            name14: ['风险标志', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.riskRearingControlFlagName)],
            name15: ['交易状态', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)],
            name16: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name16 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name17 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name17");
        }
        /**************确认详情*******/
      } else if (data.businessType === "T024") {
        /*赎回 */
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13', 'name14'],
            name1: ['产品名称', data.fundName],
            name2: ['托管渠道', data.trustChannelName],
            name3: ['收款账户', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName)],
            name4: ['申请编号', data.tradeRequestId],
            name5: ['收费方式', data.fundShareClassName],
            name6: ['下单日期', getDateYM(data.businessTime)],
            name7: ['下单时间', getDateHS(data.businessTime)],
            name8: ['所属交易日', getDateYM(data.requestWorkday)],
            name9: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + '元'],
            name10: ['申请份额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.applicationVolume) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.applicationVolume) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.applicationVolume) + "份"],
            name11: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name12: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name13: ['巨额赎回处理', data.largeRedemptionName],
            name14: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name14 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name15 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)];
          list.list_item1.key.push("name15");
        }
      } else if (data.businessType === "T422" || data.businessType === "T420") {
        /*外部赎回转申购/认购 */
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2',, /*'name3'*/'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13', 'name14'],
            name1: ['产品名称', data.targetFundName],
            name2: ['托管渠道', data.trustChannelName],
            /*name3:['收款账户',Util.formatStr(data.bankName) !="--" ? Util.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4 ) : Util.formatStr(data.bankName) ],*/
            name4: ['申请编号', data.tradeRequestId],
            name5: ['收费方式', data.targetFundShareClassName],
            name6: ['下单日期', getDateYM(data.businessTime)],
            name7: ['下单时间', getDateHS(data.businessTime)],
            name8: ['所属交易日', getDateYM(data.requestWorkday)],
            name9: ['支付方式', "活期通"],
            name10: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + "元"],
            /*name11:['申请份额',Util.formatStr(data.applicationVolume) == "--" ? Util.formatStr(data.applicationVolume) : Util.formatStr(data.applicationVolume) + "份"],*/
            name11: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name12: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name13: ['交易状态', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)],
            name14: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name14 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name15 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name15");
        }
      } else if (data.businessType === "T036") {
        /*转换*/
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13'],
            name1: ['转出基金名称', data.fundName],
            name2: ['转出基金收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName)],
            name3: ['托管渠道', data.trustChannelName],
            name4: ['转入基金名称', data.targetFundName],
            name5: ['转入基金收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName)],
            name6: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name7: ['下单日期', getDateYM(data.businessTime)],
            name8: ['下单时间', getDateHS(data.businessTime)],
            name9: ['所属交易日', getDateYM(data.requestWorkday)],
            name10: ['申请份额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.applicationVolume) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.applicationVolume) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.applicationVolume) + "份"],
            name11: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name12: ['交易状态', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)],
            name13: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name13 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name14 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name14");
        }
      } else if (data.businessType === "T999") {
        /*调仓 */
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12'],
            name1: ['产品名称', data.fundName],
            name2: ['托管渠道', data.trustChannelName],
            name3: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name4: ['下单日期', getDateYM(data.businessTime)],
            name5: ['下单时间', getDateHS(data.businessTime)],
            name6: ['所属交易日', getDateYM(data.requestWorkday)],
            name7: ['申请份额', "--"],
            name8: ['申请金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.applicationAmount) + "元"],
            name9: ['确认金额', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) === "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.confirmAmount) + "元"],
            name10: ['结算币种', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.currencyName)],
            name11: ['交易状态', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)],
            name12: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name12 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name13 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name13");
        }
      } else if (data.businessType === "T029") {
        /*修改分红方式 */
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6'],
            name1: ['产品名称', data.fundName],
            name2: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name3: ['下单日期', getDateYM(data.businessTime)],
            name4: ['下单时间', getDateHS(data.businessTime)],
            name5: ['所属交易日', getDateYM(data.requestWorkday)],
            name6: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name6 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name7 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name7");
        }
      } else if (data.businessType === "T039" || data.businessType === "E201" || data.businessType === "E202" || data.businessType === "E203" || data.businessType === "E227" || data.businessType === "E228" || data.businessType === "E229") {
        /*定投通  */
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name12', 'name13', 'name14',, 'name15', 'name16'],
            name1: ['产品名称', data.fundName],
            name2: ['资金渠道', data.trustChannelName],
            name3: ['支付渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName) + " ****" + data.bankAccountShowNo.substr(data.bankAccountShowNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.bankName)],
            name4: ['基金账号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taAccountNo)],
            name5: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name6: ['协议号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradePlanId)],
            name7: ['收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName)],
            name8: ['下单日期', getDateYM(data.businessTime)],
            name9: ['下单时间', getDateHS(data.businessTime)],
            name10: ['所属交易日', getDateYM(data.requestWorkday)],
            /*name11:['支付时间',Util.formatStr(data.paymentTime)],*/
            name12: ['申请金额', data.applicationAmount != null ? data.applicationAmount + "元" : "--"],
            name13: ['结算币种', "人民币"],
            name14: ['风险标志', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.riskRearingControlFlagName)],
            name15: ['交易状态', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)],
            name16: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name16 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name17 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name17");
        }
        /**************确认详情*******/
      } else if (data.businessType === "T130" || data.businessType === "T122" || data.businessType === "T192" || data.businessType === "T139") {
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12'],
            name1: ['产品名称', data.fundName],
            name2: ['成交净值', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.newToFixed(data.confirmNav, 4)],
            name3: ['支付渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName) + " ****" + data.currentAccountNo.substr(data.currentAccountNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName)],
            name4: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name5: ['确认编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeConfirmNo)],
            name6: ['收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName)],
            name7: ['申请日期', getDateYM(data.requestWorkday)],
            name8: ['确认日期', getDateYM(data.confirmWorkday)],
            name9: ['交易确定金额', data.confirmAmount != null ? data.confirmAmount + "元" : "--"],
            name10: ['交易确定份额', data.confirmVolume != null ? data.confirmVolume + "份" : "--"],
            name11: ['交易费用', data.commision != null ? data.commision + "元" : "--"],
            name12: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
      } else if (data.businessType === "T124" || data.businessType === "T194 " || data.businessType === "T142") {
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13'],
            name1: ['产品名称', data.fundName],
            name2: ['成交净值', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.newToFixed(data.confirmNav, 4)],
            name3: ['托管渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName)],
            name4: ['收款账户', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.returnBankName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.returnBankName) + " ****" + data.returnBankAccountShowNo.substr(data.returnBankAccountShowNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.returnBankName)],
            name5: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name6: ['确认编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeConfirmNo)],
            name7: ['收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName)],
            name8: ['申请日期', getDateYM(data.requestWorkday)],
            name9: ['确认日期', getDateYM(data.confirmWorkday)],
            name10: ['交易确定金额', data.confirmAmount != null ? data.confirmAmount + "元" : "--"],
            name11: ['交易确定份额', data.confirmVolume != null ? data.confirmVolume + "份" : "--"],
            name12: ['交易费用', data.commision != null ? data.commision + "元" : "--"],
            name13: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
      } else if (data.businessType === "T120") {
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10'],
            name1: ['产品名称', data.fundName],
            name2: ['成交净值', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.newToFixed(data.confirmNav, 4)],
            name3: ['支付渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName) != "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName) + " ****" + data.currentAccountNo.substr(data.currentAccountNo.length - 4) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName)],
            name4: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name5: ['确认编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeConfirmNo)],
            name6: ['收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName)],
            name7: ['申请日期', getDateYM(data.requestWorkday)],
            name8: ['确认日期', getDateYM(data.confirmWorkday)],
            name9: ['交易确定金额', data.confirmAmount != null ? data.confirmAmount + "元" : "--"],
            name10: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name10 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name11 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name11");
        }
      } else if (data.businessType === "T136") {
        var flag = this.props.location.state.flag ? this.props.location.state.flag : null;
        if (flag == "QR") {
          list = {
            list_item1: {
              title: data.businessTypeName,
              key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12', 'name13', 'name14'],
              name1: ['转出基金名称', data.fundName],
              name2: ['转出基金收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName)],
              name3: ['托管渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName)],
              name4: ['转入基金名称', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundName)],
              name5: ['转入基金收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName)],
              name6: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
              name7: ['确认编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeConfirmNo)],
              name8: ['申请日期', getDateYM(data.requestWorkday)],
              name9: ['确认日期', getDateYM(data.confirmWorkday)],
              name10: ['交易确定份额', data.confirmVolume != null ? data.confirmVolume + "份" : "--"],
              name11: ['转入基金净值', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.newToFixed(data.targetFundNav, 4)],
              name12: ['转出基金净值', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.newToFixed(data.confirmNav, 4)],
              name13: ['交易费用', data.commision != null ? data.commision + "元" : "--"],
              name14: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
            },
            list_item2: {
              key: []
            }
          };
        } else {
          list = {
            list_item1: {
              title: data.businessTypeName,
              key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12'],
              name1: ['转出基金名称', data.fundName],
              name2: ['转出基金收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName)],
              name3: ['托管渠道', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.capitalChannelName)],
              name4: ['转入基金名称', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundName)],
              name5: ['转入基金收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName)],
              name6: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
              name7: ['确认编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeConfirmNo)],
              name8: ['申请日期', getDateYM(data.requestWorkday)],
              name9: ['确认日期', getDateYM(data.confirmWorkday)],
              name10: ['交易确定份额', data.confirmVolume != null ? data.confirmVolume + "份" : "--"],
              name11: ['交易费用', data.commision != null ? data.commision + "元" : "--"],
              name12: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
            },
            list_item2: {
              key: []
            }
          };
        }
      } else if (data.businessType === "T129") {
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5'],
            name1: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name2: ['确认编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeConfirmNo)],
            name3: ['申请日期', getDateYM(data.requestWorkday)],
            name4: ['确认日期', getDateYM(data.confirmWorkday)],
            name5: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name5 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name6 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name6");
        }
      } else {
        list = {
          list_item1: {
            title: data.businessTypeName,
            key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name12', 'name13', 'name14',, 'name15', 'name16'],
            name1: ['产品名称', data.targetFundName],
            name2: ['资金渠道', data.trustChannelName],
            name3: ['支付渠道', data.trustChannelName],
            name4: ['基金账号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taAccountNo)],
            name5: ['申请编号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradeRequestId)],
            name6: ['协议号', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.tradePlanId)],
            name7: ['收费方式', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName) == "--" ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.fundShareClassName) : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.targetFundShareClassName)],
            name8: ['下单日期', getDateYM(data.businessTime)],
            name9: ['下单时间', getDateHS(data.businessTime)],
            name10: ['所属交易日', getDateYM(data.requestWorkday)],
            /*name11:['支付时间',Util.formatStr(data.paymentTime)],*/
            name12: ['申请金额', data.applicationAmount != null ? data.applicationAmount + "元" : "--"],
            name13: ['结算币种', "人民币"],
            name14: ['风险标志', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.riskRearingControlFlagName)],
            name15: ['交易状态', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.businessStateName)],
            name16: ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)]
          },
          list_item2: {
            key: []
          }
        };
        if (data.hasOwnProperty("commission")) {
          list.list_item1.name16 = ['交易费用', this.props.location.state && this.props.location.state.commission != null ? this.props.location.state.commission + "元" : "--"];
          list.list_item1.name17 = ['确认结果', __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.formatStr(data.taConfirmStateName)];
          list.list_item1.key.push("name17");
        }
      }

      this.setState({
        list: list,
        dataSouse: data
      });
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/Transfer',
        state: { name: '调整组合', type: 1 },
        query: { code: '' }
      });
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      // hashHistory.push({
      //     pathname:'/TransactionRecord',
      // })
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-1);
    }
  }, {
    key: 'chechan',
    value: function chechan() {
      this.setState({
        pwdFlag: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.getTradeDetail;

      var list_item1Temp = {
        title: "华夏智投银行申购",
        key: ['name1', 'name2', 'name3', 'name4', 'name5', 'name6', 'name7', 'name8', 'name9', 'name10', 'name11', 'name12'],
        name1: ['转出基金名称', "常青大学计划"],
        name2: ['转出基金收费方式', "收费方式"],
        name3: ['托管渠道', "托管渠道"],
        name4: ['转入基金名称', "转入基金名称"],
        name5: ['转入基金收费方式', "转入基金收费方式"],
        name6: ['申请编号', "申请编号"],
        name7: ['确认编号', "确认编号"],
        name8: ['申请日期', "2017-07-28"],
        name9: ['确认日期', "2017-07-28"],
        name10: ['交易确定份额', "100份"],
        name11: ['交易费用', "0.00"],
        name12: ['确认结果', "成功"]
      };
      var list = this.state.list;
      var list_item1 = list.list_item1;
      var dataSouse = this.state.dataSouse;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u4EA4\u6613\u8BE6\u60C5'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: ' content' },
          list_item1.key.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: "100%" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '0.44rem 13px 0.24rem 13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#fa063a' } },
                list_item1.title
              )
            ),
            list_item1.key.map(function (item, i) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'TransactionDetailList', key: i },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  list_item1[item][0]
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  list_item1[item][1]
                )
              );
            })
          ) : null
        ),
        this.state.dataSouse.isCancel &&
        // dataSouse.businessType != "T020" && 
        dataSouse.businessType != "T420" &&
        // dataSouse.businessType != "T422" && 
        dataSouse.businessType != "T999" && dataSouse.businessType != "TH20" && dataSouse.businessType != "E233" && dataSouse.businessType != "E234" && dataSouse.businessType != "E235" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'isCancel_botton', onClick: function onClick() {
              return _this2.chechan();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'isCancel_img' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { fontSize: 12, color: "#5b6370" } },
            '\u64A4\u5355'
          )
        ) : null,
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__myAssets_payment_Password__["a" /* default */], { _this: this, ztFlag: true, _type: 'ZT' }) : null
      );
    }
  }]);

  return TransactionDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    getTradeDetail: state.getTradeDetail
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransactionDetail));

function getDateHS(vue) {
  var num = Number(vue);
  var resultDate, year, month, date, hms;
  var currDate = new Date(num);
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  var hs = currDate.getHours();
  var ms = currDate.getMinutes();
  var ss = currDate.getSeconds();
  hs = hs < 10 ? '0' + hs : hs;
  ms = ms < 10 ? '0' + ms : ms;
  ss = ss < 10 ? '0' + ss : ss;
  month = month < 10 ? '0' + month : month;
  date = date < 10 ? '0' + date : date;
  hms = hs + ':' + ms + ":" + ss;
  resultDate = hms;
  return resultDate;
}

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











function MyBody(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'am-list-body my-body' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: { display: 'none' } },
      'you can custom body wrap element'
    ),
    props.children
  );
}

var objArr;
var ua = navigator.userAgent.toLowerCase();

/*智投交易记录*/

var TransactionRecord = function (_Component) {
  _inherits(TransactionRecord, _Component);

  function TransactionRecord(props) {
    _classCallCheck(this, TransactionRecord);

    var _this = _possibleConstructorReturn(this, (TransactionRecord.__proto__ || Object.getPrototypeOf(TransactionRecord)).call(this, props));

    _this.onEndReached = function (event) {
      var that = _this;
      // load new data
      // hasMore: from backend data, indicates whether it is the last page, here is false
      if (_this.state.isLoading && !_this.state.hasMore) {
        return;
      }
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      console.log('reach end', event);

      _this.setState({ isLoading: true });

      var dispatch = _this.props.dispatch;

      var dataArr = [];
      var totalDataArr = [];

      // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
      var data = {
        pageIndex: _this.state.pageIndex,
        pageSize: _this.state.pageSize,
        superFundCode: _this.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["C" /* getQueryTradeRecords */])(data, _this.callbackData.bind(_this), that));
    };

    var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
        return r1 !== r2;
      } });
    _this.state = {
      isLoading: true,
      dataSource: ds.cloneWithRows([]),
      modalFlag: false,
      sValue: ["0000"],
      pageIndex: 1,
      pageSize: 30,
      totalDataArr: [],
      superFundCode: "",
      height: window.winHeight - 88,
      seasons: []
    };
    return _this;
  }

  _createClass(TransactionRecord, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      var that = this;
      var dispatch = this.props.dispatch;
      // const hei = window.winHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
      var hei = window.winHeight - 88;
      // simulate initial Ajax
      // setTimeout(() => {
      //   this.setState({
      //     dataSource: ds.cloneWithRows([]),
      //     //dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
      //     isLoading: false,
      //     height: hei,
      //   });
      // }, 600);
      var data = {
        pageIndex: this.state.pageIndex,
        pageSize: this.state.pageSize,
        superFundCode: this.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["C" /* getQueryTradeRecords */])(data, this.callbackData.bind(this), that));
      var _seasons = [].concat(this.state.seasons);
      _seasons.push({
        label: '全部产品',
        value: '0000',
        key: 0
      });
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundCodeArr.length; i++) {
        _seasons.push({
          label: __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundNameArr[i],
          value: __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundCodeArr[i],
          key: i - 0 + 1
        });
      }
      this.setState({
        seasons: _seasons
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      var that = this;
      var data = {
        superFundCode: "",
        pageIndex: 1,
        pageSize: 99
      };
      document.getElementsByTagName('title')[0].innerHTML = "交易记录";
      //dispatch(getSupperFundHome({}, (data) => {}, this))
      //dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),that))
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      var totalDataArr = this.state.totalDataArr.concat(data);
      this.state.loadingFlag ? this.setState({ loadingFlag: false }) : null;
      if (data.length !== 0) {
        var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
            return r1 !== r2;
          } });
        if (data.length < this.state.pageSize) {
          this.setState({
            isLoading: 0,
            dataSource: ds.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            pageIndex: this.state.pageIndex + 1,
            handleFlag: false
          });
        } else {
          this.setState({
            isLoading: false,
            pageIndex: this.state.pageIndex + 1,
            dataSource: ds.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            handleFlag: false
          });
        }
      } else {
        this.setState({
          isLoading: 0
        });
      }

      console.log(data, "************");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      // let pathName = this.props.location.state.pathName? this.props.location.state.pathName :'/';
      // let data = this.props.location.state.data ? this.props.location.state.data : null;
      // hashHistory.push({
      //     pathname:pathName,
      //     state:{

      //     }
      // })
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].go(-1);
    }
  }, {
    key: 'goTransactionDetail',
    value: function goTransactionDetail(item) {
      var data = {
        businessType: item.businessType,
        tradeRequestId: item.tradeRequestId
      };
      if (item.businessType == "TC24") {
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: '/Servicechargerecord',
          state: {
            businessType: item.businessType,
            tradeRequestId: item.tradeRequestId
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: '/TransactionDetail',
          state: {
            data: data,
            flag: "JL",
            commission: item.commission
          }
        });
      }
    }
  }, {
    key: 'onOk',
    value: function onOk(e) {
      var fundCode = e[0];
      var that = this;
      var dispatch = this.props.dispatch;

      var flag = void 0;
      if (this.state.totalDataArr.length !== 0) {
        flag = true;
      } else {
        flag = false;
      }
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      this.setState({
        productAll: false,
        superFundCode: fundCode,
        sValue: e,
        pageIndex: 1,
        pageSize: 30,
        dataSource: ds.cloneWithRows([]),
        totalDataArr: [],
        loadingFlag: flag,
        handleFlag: true
      });
      var data = {
        pageIndex: 1,
        pageSize: 30,
        superFundCode: fundCode
      };

      console.log(data);

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["C" /* getQueryTradeRecords */])(data, this.callbackData.bind(this), that));

      // this.setState({ sValue:e })
      // let data = {
      //   superFundCode:e[0],
      //   pageIndex:1,
      //   pageSize:30,
      // }
      // if(e[0] === "0000"){
      //   data.superFundCode = ""
      // }
      // dispatch(getQueryTradeRecords(data,this.callbackData.bind(this),this))
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      console.log("有无加载", this.state.isLoading);
      if (this.state.isLoading === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u6B63\u5728\u52A0\u8F7D...'
        );
      } else if (this.state.isLoading === false) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u52A0\u8F7D\u5B8C\u6210'
        );
      } else if (this.state.isLoading === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u6CA1\u6709\u66F4\u591A\u6570\u636E\u4E86'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
      // let { SupperFundHome } = this.props;

      // let SuperList = SupperFundHome&&SupperFundHome.singleSuperFundViews ? SupperFundHome.singleSuperFundViews : [];

      // let seasons = [
      //   {
      //     label: '全部产品',
      //     value: '0000',
      //     key:0
      //   },
      // ];
      // SuperList.map((item,i)=>{
      //   seasons.push({
      //     label:item.superFundName,
      //     value:item.superFundCode,
      //     key:i+1
      //   })
      // })

      var tempData = [{ businessTime: "0000" }];
      tempData = tempData.concat(data);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u4EA4\u6613\u8BB0\u5F55'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem" } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: ua.indexOf("amcfmapp") > -1 ? "chooseSelect_Wrap chooseSelect_Wrap2" : "chooseSelect_Wrap", style: { position: 'fixed', background: "#000", top: 44, left: 0 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
            { data: this.state.seasons, cols: 1, className: 'forss', title: '\u9009\u62E9\u4EA7\u54C1', value: this.state.sValue, onPickerChange: function onPickerChange(e) {
                return console.log('onPickerChange', e);
              }, onOk: function onOk(e) {
                _this2.onOk(e);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item, null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rightBottomArrow', style: { position: 'absolute', right: '0.36rem', top: "50%", zIndex: 2 } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content', style: { paddingTop: 88 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"], {
            ref: function ref(el) {
              return _this2.lv = el;
            },
            dataSource: this.state.dataSource,
            renderFooter: function renderFooter() {
              return _this2.renderFooter();
            },
            renderBodyComponent: function renderBodyComponent() {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyBody, null);
            },
            renderRow: function renderRow(rowData, sectionID, rowID) {
              objArr = [{ createDate: "" }].concat(_this2.state.totalDataArr);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: rowID },
                returnDateStr(rowData.businessTime) === returnDateStr(objArr[rowID].businessTime) ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 22, paddingBottom: 12, fontSize: "20px", background: "rgba(242,245,247,1)" } },
                  rowData.businessTime.substr(0, 7)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'superListJ', onClick: function onClick() {
                      return _this2.goTransactionDetail(rowData);
                    }, style: { marginBottom: 0 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { borderBottom: '1px solid #f2f4f7' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { color: '#fa063a' } },
                      rowData.businessTypeName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      rowData.fundName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      getNum(rowData.applicationAmount, rowData.applicationVolume)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      rowData.businessStateName
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.formatStr(rowData.businessTime)
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: "rgba(242,245,247,1)" } })
              );
            },

            style: {
              height: this.state.height,
              overflow: 'auto'
            },
            pageSize: 4,
            onScroll: function onScroll() {
              console.log('scroll');
            },
            scrollRenderAheadDistance: 500,
            onEndReached: this.onEndReached,
            onEndReachedThreshold: 15
          })
        )
      );
    }
  }]);

  return TransactionRecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords,
    SupperFundHome: state.SupperFundHome
  };
}

function returnDateStr(str) {
  if (str) {
    return str.substr(0, 7);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransactionRecord));

function getNum(num1, num2) {
  if ((num1 === "" || num1 === null || num1 === undefined) && (num2 === "" || num2 === null || num2 === undefined)) {
    return "--";
  }
  if (num1 === "" || num1 === null || num1 === undefined) {
    return num2 + '份';
  }
  if (num2 === "" || num2 === null || num2 === undefined) {
    return num1 + '元';
  }
  if (num1 === 0) {
    return num2 + '份';
  }
  if (num2 === 0) {
    return num1 + '元';
  }
  if (num1 === num2) {
    return num1 + '元';
  }
}

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/*智投交易记录*/

var TransitHistory = function (_Component) {
  _inherits(TransitHistory, _Component);

  function TransitHistory() {
    _classCallCheck(this, TransitHistory);

    return _possibleConstructorReturn(this, (TransitHistory.__proto__ || Object.getPrototypeOf(TransitHistory)).apply(this, arguments));
  }

  _createClass(TransitHistory, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = '历史调仓记录';
    }
  }, {
    key: 'push',
    value: function push(item) {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/TransitHistoryDetial',
        state: { data: item }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.deepClone(this.props.location.state.data);
      console.log(this.props.location.state.data);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.goBack();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5386\u53F2\u8C03\u4ED3\u8BB0\u5F55'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content TransitHistory-content' },
          data.reverse().map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'TransitHistory-item', key: 'TH' + i, onClick: function onClick() {
                  return _this2.push(item);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.returnDate(item.adjustDate) + '\u8C03\u4ED3\u8BB0\u5F55'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  '\u6839\u636E\u6700\u8FD1\u7684\u5E02\u573A\u60C5\u51B5\uFF0C\u67E5\u7406\u5BF9\u7EC4\u5408\u8FDB\u884C\u4E86\u8D44\u4EA7\u914D\u7F6E\u8C03\u6574\uFF1A'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(153), style: { marginRight: '0px' }, className: 'img' })
            );
          })
        )
      );
    }
  }]);

  return TransitHistory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransitHistory));

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommonComponents_js__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/*智投交易记录*/

var TransitHistoryDetail = function (_Component) {
  _inherits(TransitHistoryDetail, _Component);

  function TransitHistoryDetail() {
    _classCallCheck(this, TransitHistoryDetail);

    return _possibleConstructorReturn(this, (TransitHistoryDetail.__proto__ || Object.getPrototypeOf(TransitHistoryDetail)).apply(this, arguments));
  }

  _createClass(TransitHistoryDetail, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.title = '历史调仓详情';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5386\u53F2\u8C03\u4ED3\u8BE6\u60C5'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content TransitHistory-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CommonComponents_js__["a" /* AdjustRecordContent */], { data: this.props.location.state.data })
        )
      );
    }
  }]);

  return TransitHistoryDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords,
    SupperFundHome: state.SupperFundHome
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransitHistoryDetail));

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/*在途资金交易明细*/



var TransitRecords = function (_Component) {
  _inherits(TransitRecords, _Component);

  function TransitRecords(props) {
    _classCallCheck(this, TransitRecords);

    var _this = _possibleConstructorReturn(this, (TransitRecords.__proto__ || Object.getPrototypeOf(TransitRecords)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(TransitRecords, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction__["p" /* getQueryTransitRecords */])({}, function () {}, this));
      document.title = "在途资金交易明细";
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      // hashHistory.push({
      //     pathname:'/',
      // })
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].go(-1);
    }
  }, {
    key: 'goTransactionDetail',
    value: function goTransactionDetail(item) {
      var data = {
        businessType: item.businessType,
        tradeRequestId: item.tradeRequestId
      };
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/TransactionDetail',
        state: {
          data: data
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      //let data = this.props.QueryTransitRecords ? this.props.QueryTransitRecords : [];

      var data = void 0;
      if (this.props.QueryTransitRecords) {
        data = this.props.QueryTransitRecords;
        data.sort(compare('businessTime'));
      } else {
        data = [];
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1, flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, flex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u5728\u9014\u8D44\u91D1\u4EA4\u6613\u660E\u7EC6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, flex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '13px' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          data.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'superListJ', key: i, onClick: function onClick() {
                  return _this2.goTransactionDetail(item);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { borderBottom: '1px solid #f2f4f7' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#fa063a' } },
                  item.businessTypeName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  item.superFundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.fomatFloat(item.transitAmount) + "元"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  item.businessStateName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.formatStr(item.businessTime)
                )
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 20, marginBottom: 30, paddingLeft: 13, paddingRight: 13 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: 30, fontSize: 12 } },
              '\u6E29\u99A8\u63D0\u793A :'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: 'rgba(130,138,138,1)', fontSize: 12, lineHeight: "22px" } },
              '1\u3001\u5F53\u6295\u987E\u7EC4\u5408\u6709\u7533\u8D2D\u5728\u9014\u4EA4\u6613\u65F6\uFF0C\u7533\u8D2D\u7684\u5E95\u5C42\u8D27\u5E01\u4EFD\u989D\u5C06\u5B9E\u65F6\u786E\u8BA4\u5E76\u663E\u793A\u5728\u7EC4\u5408\u8D44\u4EA7\u4E2D\uFF0C\u5176\u4ED6\u6210\u5206\u57FA\u91D1\u9700\u7533\u8D2D\u786E\u8BA4\u540E\uFF0C\u65B9\u53EF\u663E\u793A\u5728\u7EC4\u5408\u8D44\u4EA7\u4E2D\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: 'rgba(130,138,138,1)', fontSize: 12, lineHeight: "22px" } },
              '2\u3001\u5F53\u6295\u987E\u7EC4\u5408\u6709\u90E8\u5206\u8D4E\u56DE\u5728\u9014\u4EA4\u6613\u65F6\uFF0C\u7EC4\u5408\u5E95\u5C42\u8D27\u5E01\u4EFD\u989D\u5C06\u5168\u90E8\u51BB\u7ED3\uFF0C\u4E0D\u5728\u5269\u4F59\u7EC4\u5408\u8D44\u4EA7\u4E2D\u663E\u793A\u3002\u5F85\u7EC4\u5408\u8D4E\u56DE\u4EA4\u6613\u786E\u8BA4\u540E\uFF0C\u5269\u4F59\u5E95\u5C42\u8D27\u5E01\u4EFD\u989D\u65B9\u53EF\u663E\u793A\u5728\u7EC4\u5408\u8D44\u4EA7\u4E2D\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: 'rgba(130,138,138,1)', fontSize: 12, lineHeight: "22px" } },
              '3\u3001\u5F53\u6295\u987E\u7EC4\u5408\u6709\u8C03\u4ED3\u5728\u9014\u4EA4\u6613\u65F6\uFF0C\u7EC4\u5408\u8D44\u4EA7\u5C06\u6682\u505C\u5C55\u793A\uFF0C\u5F85\u8C03\u4ED3\u4EA4\u6613\u786E\u8BA4\u540E\uFF0C\u65B9\u53EF\u67E5\u770B\u7EC4\u5408\u8D44\u4EA7\u3002'
            )
          )
        )
      );
    }
  }]);

  return TransitRecords;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTransitRecords: state.QueryTransitRecords
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransitRecords));

function compare(property) {
  return function (a, b) {
    var allStartDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getPay__["m" /* getDateS */])(a[property]);
    var allEndDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getPay__["m" /* getDateS */])(b[property]);
    var value1 = allStartDate.getTime();
    var value2 = allEndDate.getTime();
    return value2 - value1;
  };
}

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ForgetPassword = function (_Component) {
  _inherits(ForgetPassword, _Component);

  function ForgetPassword() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ForgetPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ForgetPassword.__proto__ || Object.getPrototypeOf(ForgetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mobileNumber: '',
      CapchaCode: '',
      animating: false,
      serverCapchaCode: '',
      imageBase64: '',
      getCapchaSuccess: false,
      flag: false
    }, _this.getCapchaCodeAgain = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__["o" /* getCapchaCode */])({ scale: window.devicePixelRatio }, function (code, imageBase64) {
        _this.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this.getCapchaCodeError(msg);
      }));
    }, _this.handleVerify = function () {
      if (!_this.state.mobileNumber) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入手机号码', 2);
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!_this.state.CapchaCode) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入右侧验证码', 2);
        return;
      }
      if (_this.state.CapchaCode.toUpperCase() != _this.state.serverCapchaCode) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('验证码错误', 2);
        _this.getCapchaCodeAgain();
        return;
      }
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: _this.state.mobileNumber }, function () {
        _this.verifyRegisterPhoneErr('该手机号码为未注册号码，请确认输入正确手机号码');
      }, function (msg) {
        _this.verifyRegisterPhoneErr(msg);
      }, function (phoneNum) {
        _this.verifyRegisterPhoneSuc(phoneNum);
      }));
    }, _this.verifyRegisterPhoneSuc = function (phoneNum) {
      _this.setState({
        flag: false
      });
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      sessionStorage.setItem("ForgetPassword_mobileNumber", phoneNum);
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: "/verifyDynamicCode",
        state: {
          mobileNumber: phoneNum,
          route: route,
          callback: callback
        }
      });
    }, _this.verifyRegisterPhoneErr = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
    }, _this.getCapchaCodeSuccess = function (code, imageBase64) {
      _this.setState({
        serverCapchaCode: code,
        imageBase64: imageBase64
      });
      _this.setState({ getCapchaSuccess: true });
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }, _this.changeMobileNo = function (event) {
      _this.setState({
        mobileNumber: event.target.value
      });
    }, _this.changeCatpCode = function (event) {
      _this.setState({
        CapchaCode: event.target.value
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ForgetPassword, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "找回登录密码";
      var mobileNumber = sessionStorage.getItem("ForgetPassword_mobileNumber");
      if (mobileNumber) {
        this.setState({
          mobileNumber: mobileNumber
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__["o" /* getCapchaCode */])({ scale: window.devicePixelRatio }, function (code, imageBase64) {
        _this2.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this2.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'getCapchaCodeError',
    value: function getCapchaCodeError(msg) {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
      this.setState({ getCapchaSuccess: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u627E\u56DE\u767B\u5F55\u5BC6\u7801'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex",
                position: "relative"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  paddingLeft: 13,
                  fontSize: 14,
                  width: 90
                } },
              '\u624B\u673A\u53F7'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  display: "-webkit-flex",
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: {
                  WebkitFlex: 1,
                  fontSize: 14,
                  color: '#3a3e47'
                }, placeholder: '\u8BF7\u8F93\u5165\u6CE8\u518C\u624B\u673A\u53F7', value: this.state.mobileNumber, onChange: this.changeMobileNo }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.setState({ mobileNumber: '' });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                    marginRight: -2,
                    width: 44,
                    height: 44
                  }, src: __webpack_require__(47) })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottomColor: 'rgba(242,245,247,1)',
                borderBottomWidth: 1,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex",
                position: "relative"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  paddingLeft: 13,
                  fontSize: 14,
                  width: 90
                } },
              '\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  display: "-webkit-flex",
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', style: {
                    width: "100%",
                    fontSize: 14,
                    color: '#3a3e47'
                  }, placeholder: '\u8BF7\u8F93\u5165\u53F3\u4FA7\u9A8C\u8BC1\u7801', value: this.state.CapchaCode, onChange: this.changeCatpCode })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.getCapchaCodeAgain, style: { paddingRight: 13 } },
                this.state.getCapchaSuccess ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { width: 63 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 63,
                      height: 27
                    }, src: 'data:image/png;base64,' + this.state.imageBase64 })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: {
                      WebkitFlexDirection: 'row',
                      WebkitJustifyContent: 'center',
                      WebkitAlignItems: 'center',
                      width: 63,
                      height: 27,
                      backgroundColor: '#afb0b2',
                      display: "-webkit-flex"
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: {
                        fontSize: 10,
                        color: '#3a3e47'
                      } },
                    '\u52A0\u8F7D\u4E2D...'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.CapchaCode && this.state.mobileNumber ? this.handleVerify : null },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  marginTop: 14,
                  marginLeft: 13,
                  marginRight: 13,
                  padding: 10,
                  backgroundColor: this.state.CapchaCode && this.state.mobileNumber ? '#fa063a' : '#afb0b2',
                  borderRadius: 22,
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u4E0B\u4E00\u6B65'
              )
            )
          )
        )
      );
    }
  }]);

  return ForgetPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ForgetPassword));

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__imgs_registerBg2_png__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__imgs_registerBg2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__imgs_registerBg2_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var intervalId = null;
var requestId = '';

/*
register?enterType=Investment/InviteRegister&inviteCode=手机号
*/

var InviteRegister = function (_Component) {
  _inherits(InviteRegister, _Component);

  function InviteRegister() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InviteRegister);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InviteRegister.__proto__ || Object.getPrototypeOf(InviteRegister)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mobileNumber: '',
      password: '',
      mobileDynamicCode: '',
      isRequestingVerifyCode: false,
      countdown: 120,
      isSelected: false,
      flag: false,
      invitationCode: _this.props.location.query.inviteCode ? /^1[0123456789]\d{9}$/.test(_this.props.location.query.inviteCode) ? _this.props.location.query.inviteCode : "" : window.localStorage.getItem("inviteCode"),
      invitationCodeFlag: true,
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
      serverCapchaCode: '',
      imageBase64: '',
      captchaCode: ''
    }, _this.handleVerify = function () {
      if (!_this.state.mobileDynamicCode || !_this.state.mobileNumber) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入完整信息', 2);
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!_this.state.password) {
        var toast = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入密码', 2);
        return;
      }
      if (!_this.state.captchaCode) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入图形验证码', __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        return;
      }
      if (requestId === '' || !requestId) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请先申请手机验证码', 2);
        return;
      }
      if (!_this.state.isSelected) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('同意协议后才能注册', 2);
        return;
      }
      if (_this.state.invitationCode && !/^1[0123456789]\d{9}$/.test(_this.state.invitationCode)) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('用户邀请码不合规', 2);
        return;
      }
      // if(this.state.invitationCode == this.state.mobileNumber){
      //   Toast.info('用户邀请码不能与注册的手机号一致', 2);
      //   return ;
      // }
      var verifyParam = {
        requestId: requestId,
        mobileNo: _this.state.mobileNumber,
        captchaText: _this.state.mobileDynamicCode,
        password: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.encrypt(_this.state.password),
        invitationCode: _this.state.invitationCode ? _this.state.invitationCode : ""
      };
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["c" /* registerAccount */])(verifyParam, function () {
        _this.verifySuccess();
      }, function (msg) {
        return _this.verifyError(msg);
      }));
    }, _this.verifySuccess = function () {
      _this.setState({
        flag: false
      });
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      // if(route) {
      //   hashHistory.go(route - window.history.length);
      // }else {
      //   hashHistory.goBack();
      // }
      // setTimeout(() => {
      //   if(callback) {
      //     callback();
      //   }
      // }, 100);
      if (_this.state.enterType == "InviteRegister") {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_js__["h" /* goHome */])("Investment");
        // hashHistory.push({
        //   pathname: "/",
        //   state: {
        //     route: route,
        //     callback: callback
        //   },
        //   query:{
        //     enterType:"Investment"
        //   }
        // })
      } else {
        __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].go(-2);
      }
    }, _this.verifyError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info(msg, 2);
    }, _this.verifyRegisterPhoneSuc = function (mobileNumber) {
      var params = {
        mobileNo: mobileNumber,
        token: _this.state.serverCapchaCode,
        captchaCode: _this.state.captchaCode.toUpperCase()
      };
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["d" /* getMobileCaptcha */])(params, function (suc) {
        requestId = suc;
        _this.makeInterval();
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info(err.code, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        requestId = "";
        _this.setState({
          captchaCode: ""
        });
        _this.getCapchaCodeAgain();
      }));

      // this.props.dispatch(getVerifyCode(mobileNumber, (requestid)=>{requestId = requestid; }));
      // let params = { mobileNo: mobileNumber }
      // this.props.dispatch(realUserMobileCaptcha(params, (requestid)=>{requestId = requestid; }));
    }, _this.verifyRegisterPhoneErr = function (msg) {
      __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info(msg, 2);
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
      _this.setState({
        isRequestingVerifyCode: false
      });
    }, _this.handleWaitingForVerifyDynamicCode = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!_this.state.password) {
        var toast = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入密码', 2);
        return;
      }
      if (!_this.state.captchaCode) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入图形验证码', 2);
        return;
      }
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: _this.state.mobileNumber }, function (mobileNumber) {
        _this.verifyRegisterPhoneSuc(mobileNumber);
      }, function (msg) {
        _this.verifyRegisterPhoneErr(msg);
      }));
    }, _this.makeInterval = function () {
      var countNum = 119;
      _this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            cancelTimeOut();
            _this.setState({
              isRequestingVerifyCode: false
            });
          }
          _this.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (intervalId) clearInterval(intervalId);
          intervalId = null;
        };
      });
    }, _this.handleJumpToProtocol = function (title) {
      var code = __WEBPACK_IMPORTED_MODULE_6__BankCode__["a" /* protocolCode */][title];
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: title, code: code },
        query: { code: code }
      });
    }, _this.changePhoneNo = function (event) {
      _this.setState({
        mobileNumber: event.target.value
      });
      window.localStorage.setItem("register_phoneNo", event.target.value);
    }, _this.clearPhoneNo = function () {
      _this.setState({
        mobileNumber: ""
      });
      window.localStorage.setItem("register_phoneNo", "");
    }, _this.changePassWord = function (event) {
      _this.setState({
        password: event.target.value
      });
      window.localStorage.setItem("register_password", event.target.value);
    }, _this.clearPassWord = function () {
      _this.setState({
        password: ""
      });
      window.localStorage.setItem("register_password", "");
    }, _this.changeCkCard = function (event) {
      _this.setState({
        mobileDynamicCode: event.target.value
      });
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }, _this.toggleInvitation = function () {
      _this.setState({
        invitationCodeFlag: !_this.state.invitationCodeFlag
      });
    }, _this.goInvestment = function () {
      window.location.href = "http://a.app.qq.com/o/simple.jsp?pkgname=com.huaxiafortune";
      // goHome("Investment");
      // hashHistory.push({
      //     pathname:'/',
      //     state:{},
      //     query: {}
      // })
    }, _this.goJjLogin = function () {
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      var enterType = _this.props.location.query.enterType ? _this.props.location.query.enterType : null;
      var invitationCode = _this.state.invitationCode;
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: "/LoginHxjj",
        query: {
          enterType: enterType,
          invitationCode: invitationCode
        },
        state: {
          route: route,
          callback: callback
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InviteRegister, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // window.localStorage.setItem("inviteCode", '18679933878');
      console.log(window.localStorage.getItem("inviteCode"));
      document.title = "注册";
      if (this.props.location.query.enterType === "InviteRegister") {} else {
        this.setState({
          mobileNumber: window.localStorage.getItem("register_phoneNo"),
          password: window.localStorage.getItem("register_password")
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["e" /* getCapcha */])(function (code, imageBase64) {
        console.log('1&&&&&&&&&&');_this2.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this2.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'getCapchaCodeSuccess',
    value: function getCapchaCodeSuccess(code, imageBase64) {
      console.log('verifySuccess');
      this.setState({
        serverCapchaCode: code,
        imageBase64: imageBase64,
        getCapchaSuccess: true

      });
    }
  }, {
    key: 'getCapchaCodeAgain',
    value: function getCapchaCodeAgain() {
      var _this3 = this;

      this.setState({
        captchaCode: ''
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_loginAction_js__["e" /* getCapcha */])(function (code, imageBase64) {
        _this3.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this3.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'getCapchaCodeError',
    value: function getCapchaCodeError(msg) {
      __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
      this.setState({ getCapchaSuccess: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      requestId = '';
      this.setState({
        flag: false
      });
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          mobileNumber = _state.mobileNumber,
          password = _state.password,
          mobileDynamicCode = _state.mobileDynamicCode;

      console.log(this.props.location.query, "locationlocationlocation");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'RegisterboxContent', style: { width: window.winWidth, height: window.winWidth * (1285 / 640) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_10__imgs_registerBg2_png___default.a, alt: '', style: { width: "100%", height: "100%" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'RegisterboxContentInput' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: window.winWidth * (270 / 640) } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: window.winWidth * (80 / 640) }, className: 'regiserTitle' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'registertxt' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { height: 1 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'registertxtCenter' },
                  '\u7ACB\u5373\u6CE8\u518C'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { height: 1 } })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: window.winWidth * (70 / 640),
                  marginLeft: 30,
                  marginRight: 30,
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  borderRadius: 10,
                  border: "1px solid rgb(72,73,176)",
                  position: "relative",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90 } },
                '\u624B\u673A\u53F7\u7801'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    display: "-webkit-flex",
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1, fontSize: '0.26rem' }, onChange: this.changePhoneNo, value: mobileNumber, type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.clearPhoneNo, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: window.winWidth * (70 / 640),
                  marginTop: 7,
                  marginLeft: 30,
                  marginRight: 30,
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  borderRadius: 10,
                  border: "1px solid rgb(72,73,176)",
                  position: "relative",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90 } },
                '\u767B\u5F55\u5BC6\u7801'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    display: "-webkit-flex",
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1, fontSize: '0.26rem' }, onChange: this.changePassWord, value: password, type: 'password', placeholder: '\u8BF7\u8F93\u51656-8\u4F4D\u767B\u5F55\u5BC6\u7801' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.clearPassWord, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: window.winWidth * (70 / 640),
                  marginTop: 7,
                  marginLeft: 30,
                  marginRight: 30,
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  borderRadius: 10,
                  border: "1px solid rgb(72,73,176)",
                  position: "relative",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90 } },
                '\u56FE\u5F62\u9A8C\u8BC1\u7801'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    display: "-webkit-flex",
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', style: { width: "100%", fontSize: '0.26rem' }, value: this.state.captchaCode, onChange: function onChange(e) {
                    _this4.setState({ captchaCode: e.target.value });
                  }, type: 'text', placeholder: '\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 75, marginRight: 3 }, onClick: function onClick() {
                      _this4.getCapchaCodeAgain();
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 63,
                      height: 27
                    }, src: 'data:image/png;base64,' + this.state.imageBase64 })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: window.winWidth * (70 / 640),
                  marginTop: 7,
                  marginLeft: 30,
                  marginRight: 30,
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  borderRadius: 10,
                  border: "1px solid rgb(72,73,176)",
                  position: "relative",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { paddingLeft: 13, color: "#3a3e47", fontSize: '0.26rem', width: 90 } },
                '\u624B\u673A\u52A8\u6001\u7801'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    display: "-webkit-flex",
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { WebkitFlex: 1, paddingRight: 10 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', style: { fontSize: '0.26rem', width: "100%" }, onChange: this.changeCkCard, value: mobileDynamicCode, type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u52A8\u6001\u7801' })
                ),
                this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: {
                      backgroundColor: '#d8dbdd',
                      height: 27,
                      borderRadius: 13,
                      paddingLeft: 10,
                      paddingRight: 10,
                      WebkitAlignItems: 'center',
                      WebkitJustifyContent: 'center',
                      display: "-webkit-flex",
                      marginRight: 10,
                      width: 100
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: "#5b6370", fontSize: '0.22rem' } },
                    this.state.countDown,
                    '\u79D2\u540E\u91CD\u53D1'
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { "whiteSpace": "nowrap", width: 100, textAlign: "right", paddingRight: 13 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { onClick: this.handleWaitingForVerifyDynamicCode, style: {
                        color: 'rgb(125,131,186)',
                        fontSize: '0.22rem'
                      } },
                    '\u83B7\u53D6\u9A8C\u8BC1\u7801'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: 35, paddingRight: 26, paddingLeft: 26 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", height: "100%" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { color: '#3a3e47', fontSize: 13, display: "-webkit-flex", WebkitAlignItems: "center", paddingLeft: 5 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { width: 120, paddingTop: 2 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "flex-end" }, onClick: this.toggleInvitation },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { color: '#3a3e47', marginLeft: 13, fontSize: 13 } },
                      '\u6211\u6709\u9080\u8BF7\u7801'
                    ),
                    this.state.invitationCodeFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 30, height: 30 }, src: __webpack_require__(232) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 30, height: 30 }, src: __webpack_require__(233) })
                  )
                )
              )
            ),
            this.state.invitationCodeFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: window.winWidth * (70 / 640),
                  marginLeft: 30,
                  marginRight: 30,
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  borderRadius: 10,
                  border: "1px solid rgb(72,73,176)",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#3a3e47', marginLeft: 13, fontSize: 14, width: 60 } },
                '\u9080\u8BF7\u7801'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1,
                    display: "-webkit-flex"
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { WebkitFlex: 1, fontSize: 13, display: "-webkit-flex" }, placeholder: '(非必填) 请输入推荐人手机号码', value: this.state.invitationCode, onChange: function onChange(event) {
                    return _this4.setState({ invitationCode: event.target.value });
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this4.setState({ invitationCode: '' });
                    }, style: { height: window.winWidth * (70 / 640) }, className: 'inviteCodeDiv' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { marginRight: -2, width: 40, height: 40 }, src: __webpack_require__(47) })
                )
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitJustifyContent: 'center',
                  marginTop: 0,
                  marginLeft: 30,
                  marginRight: 30,
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this4.setState({ isSelected: !_this4.state.isSelected });
                  } },
                this.state.isSelected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                    height: 44,
                    width: 44,
                    marginRight: 5,
                    marginLeft: -13
                  }, src: __webpack_require__(684) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                    height: 44,
                    width: 44,
                    marginRight: 5,
                    marginLeft: -13
                  }, src: __webpack_require__(685) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    marginTop: 3,
                    marginLeft: -7,
                    WebkitFlex: 1,
                    color: '#a1a7b2',
                    fontSize: 12,
                    lineHeight: "20px"
                  } },
                '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: 'rgb(73,80,160)' }, onClick: function onClick() {
                      _this4.handleJumpToProtocol('华夏财富电子交易服务协议');
                    } },
                  '\u300A\u534E\u590F\u8D22\u5BCC\u7535\u5B50\u4EA4\u6613\u670D\u52A1\u534F\u8BAE\u300B'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: 'rgb(73,80,160)' }, onClick: function onClick() {
                      _this4.handleJumpToProtocol('投资人权益须知');
                    } },
                  '\u300A\u6295\u8D44\u4EBA\u6743\u76CA\u987B\u77E5\u300B'
                ),
                '\u548C',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: 'rgb(73,80,160)' }, onClick: function onClick() {
                      _this4.handleJumpToProtocol('电子签名约定书');
                    } },
                  '\u300A\u7535\u5B50\u7B7E\u540D\u7EA6\u5B9A\u4E66\u300B'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.handleVerify,
                className: 'registerButton_new', style: { marginTop: 8, marginLeft: 30, marginRight: 30, width: 'auto', height: window.winWidth * (70 / 640) }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u6CE8'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { marginLeft: 10 } },
                '\u518C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'hxjzLoginBtn', onClick: this.goJjLogin, style: { marginTop: 9, marginLeft: 30, marginRight: 30, width: 'auto', height: window.winWidth * (70 / 640) } },
              '\u534E\u590F\u57FA\u91D1\u8D26\u53F7\u767B\u5F55'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'registerPageTwo', style: { width: window.winWidth, height: window.winWidth * (664 / 640) } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'registerPageThree', style: { width: window.winWidth, height: window.winWidth * (500 / 640) } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'registerPageFour', style: { width: window.winWidth, height: window.winWidth * (795 / 640) } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'registerPageFive', style: { width: window.winWidth, height: window.winWidth * (532 / 640) } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'registerPageSix', style: { width: window.winWidth, height: window.winWidth * (303 / 640) } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'registerPageSeven', style: { width: window.winWidth, height: window.winWidth * (148 / 640) } })
      );
    }
  }]);

  return InviteRegister;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InviteRegister));

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_js__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var intervalId = null;
var requestId = '';

/*
register?enterType=Investment/Register&inviteCode=手机号
*/

var Register = function (_Component) {
  _inherits(Register, _Component);

  function Register() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, Register);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Register.__proto__ || Object.getPrototypeOf(Register)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mobileNumber: '',
      password: '',
      mobileDynamicCode: '',
      isRequestingVerifyCode: false,
      countdown: 120,
      isSelected: false,
      flag: false,
      invitationCode: _this.props.location.query.inviteCode ? /^1[34578]\d{9}$/.test(_this.props.location.query.inviteCode) ? _this.props.location.query.inviteCode : "" : window.localStorage.getItem("inviteCode"),
      invitationCodeFlag: true,
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
      captchaCode: "",
      serverCapchaCode: "",
      imageBase64: ""
    }, _this.handleVerify = function () {
      if (!_this.state.mobileDynamicCode || !_this.state.mobileNumber) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入信息', 2);
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!_this.state.password) {
        var toast = __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入密码', 2);
        return;
      }
      if (!/\S/.test(_this.state.captchaCode)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入图形验证码', 2);
        return;
      }
      if (requestId === '' || !requestId) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请先申请手机验证码', 2);
        return;
      }
      if (!_this.state.isSelected) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('同意协议后才能注册', 2);
        return;
      }
      if (_this.state.invitationCode && !/^1[0123456789]\d{9}$/.test(_this.state.invitationCode)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('用户邀请码不合规', 2);
        return;
      }
      // if(this.state.invitationCode == this.state.mobileNumber){
      //   Toast.info('用户邀请码不能与注册的手机号一致', 2);
      //   return ;
      // }
      var verifyParam = {
        requestId: requestId,
        mobileNo: _this.state.mobileNumber,
        captchaText: _this.state.mobileDynamicCode,
        password: __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.encrypt(_this.state.password),
        invitationCode: _this.state.invitationCode ? _this.state.invitationCode : ""
      };
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["c" /* registerAccount */])(verifyParam, function () {
        _this.verifySuccess();
      }, function (msg) {
        return _this.verifyError(msg);
      }));
    }, _this.verifySuccess = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var route, callback;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                flag: false
              });
              route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
              callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
              // if(route) {
              //   hashHistory.go(route - window.history.length);
              // }else {
              //   hashHistory.goBack();
              // }
              // setTimeout(() => {
              //   if(callback) {
              //     callback();
              //   }
              // }, 100);

              if (_this.state.enterType == "Register") {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_js__["h" /* goHome */])("Investment");
                // hashHistory.push({
                //   pathname: "/",
                //   state: {
                //     route: route,
                //     callback: callback
                //   },
                //   query:{
                //     enterType:"Investment"
                //   }
                // })
              } else if (_this.state.enterType == "Answer" || _this.state.enterType == "activity") {
                __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                  pathname: '/CertificationUpload',
                  state: {
                    phoneNo: _this.state.mobileNumber
                  },
                  query: { enterType: _this.state.enterType,
                    activityId: _this.props.location.query.activityId
                  }
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].go(-2);
              }

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.verifyError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, 2);
    }, _this.verifyRegisterPhoneSuc = function (mobileNumber) {
      var params = {
        mobileNo: _this.state.mobileNumber,
        token: _this.state.serverCapchaCode,
        captchaCode: _this.state.captchaCode.toUpperCase()
      };
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["d" /* getMobileCaptcha */])(params, function (suc) {
        requestId = suc;
        _this.makeInterval();
      }, function (err) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(err.code, __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        requestId = "";
        _this.setState({
          captchaCode: ""
        });
        _this.getPicCaptchaFun();
      }));
    }, _this.verifyRegisterPhoneErr = function (msg) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, 2);
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
      _this.setState({
        isRequestingVerifyCode: false
      });
    }, _this.handleWaitingForVerifyDynamicCode = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!/\S/.test(_this.state.captchaCode)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入图形验证码', 2);
        return;
      }
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: _this.state.mobileNumber }, function (mobileNumber) {
        _this.verifyRegisterPhoneSuc(mobileNumber);
      }, function (msg) {
        _this.verifyRegisterPhoneErr(msg);
      }));
    }, _this.makeInterval = function () {
      var countNum = 119;
      _this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            cancelTimeOut();
            _this.setState({
              isRequestingVerifyCode: false
            });
          }
          _this.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (intervalId) clearInterval(intervalId);
          intervalId = null;
        };
      });
    }, _this.handleJumpToProtocol = function (title) {
      var code = __WEBPACK_IMPORTED_MODULE_7__BankCode__["a" /* protocolCode */][title];
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: title, code: code },
        query: { code: code }
      });
    }, _this.changePhoneNo = function (event) {
      _this.setState({
        mobileNumber: event.target.value
      });
      window.localStorage.setItem("register_phoneNo", event.target.value);
    }, _this.clearPhoneNo = function () {
      _this.setState({
        mobileNumber: ""
      });
      window.localStorage.setItem("register_phoneNo", "");
    }, _this.changePassWord = function (event) {
      _this.setState({
        password: event.target.value
      });
      window.localStorage.setItem("register_password", event.target.value);
    }, _this.changeTxCode = function (event) {
      _this.setState({
        captchaCode: event.target.value
      });
    }, _this.clearPassWord = function () {
      _this.setState({
        password: ""
      });
      window.localStorage.setItem("register_password", "");
    }, _this.clearTxCode = function () {
      _this.setState({
        captchaCode: ""
      });
    }, _this.changeCkCard = function (event) {
      _this.setState({
        mobileDynamicCode: event.target.value
      });
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
    }, _this.toggleInvitation = function () {
      _this.setState({
        invitationCodeFlag: !_this.state.invitationCodeFlag
      });
    }, _this.getPicCaptchaFun = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["e" /* getCapcha */])(function (token, base64) {
        _this.setState({
          imageBase64: base64,
          serverCapchaCode: token
        });
      }, function () {}));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Register, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // window.localStorage.setItem("inviteCode", '18679933878');
      console.log(window.localStorage.getItem("inviteCode"));
      document.title = "注册";
      if (this.props.location.query.enterType === "Register") {} else {
        this.setState({
          mobileNumber: window.localStorage.getItem("register_phoneNo"),
          password: window.localStorage.getItem("register_password")
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getPicCaptchaFun();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      requestId = '';
      this.setState({
        flag: false
      });
      if (intervalId) {
        clearInterval(intervalId);
      }
    }

    //获取图形验证码

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          mobileNumber = _state.mobileNumber,
          password = _state.password,
          mobileDynamicCode = _state.mobileDynamicCode,
          captchaCode = _state.captchaCode,
          imageBase64 = _state.imageBase64;

      console.log(this.props.location.query, "locationlocationlocation");
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              this.state.enterType === "Register" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u6CE8\u518C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 25,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90 } },
              '\u624B\u673A\u53F7\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1, fontSize: 14 }, onChange: this.changePhoneNo, value: mobileNumber, type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.clearPhoneNo, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90 } },
              '\u767B\u5F55\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1, fontSize: 14 }, onChange: this.changePassWord, value: password, type: 'password', placeholder: '\u8BF7\u8F93\u51656-8\u4F4D\u767B\u5F55\u5BC6\u7801' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.clearPassWord, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90 } },
              '\u56FE\u5F62\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', style: { WebkitFlex: 1, fontSize: 14 }, onChange: this.changeTxCode, value: captchaCode, placeholder: '\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.getPicCaptchaFun, style: { position: "absolute", right: 40, background: "rgba(255, 255, 255, 1)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", color: "rgba(177, 46, 44, 1)" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { alt: '\u56FE\u7247\u9A8C\u8BC1\u7801', style: { width: 63, height: 27 }, src: 'data:image/png;base64,' + imageBase64 })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.clearTxCode, alt: '', style: { height: 40, width: 40, marginRight: 0 }, src: __webpack_require__(47) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 90 } },
              '\u624B\u673A\u52A8\u6001\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', style: { fontSize: 14, width: "100%" }, onChange: this.changeCkCard, value: mobileDynamicCode, type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u52A8\u6001\u7801' })
              ),
              this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: {
                    backgroundColor: '#d8dbdd',
                    height: 27,
                    borderRadius: 13,
                    paddingLeft: 10,
                    paddingRight: 10,
                    WebkitAlignItems: 'center',
                    WebkitJustifyContent: 'center',
                    display: "-webkit-flex",
                    marginRight: 10,
                    width: 110
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { color: "#5b6370", fontSize: 13 } },
                  this.state.countDown,
                  '\u79D2\u540E\u91CD\u53D1'
                )
              ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { "whiteSpace": "nowrap", width: 110, textAlign: "right", paddingRight: 13 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { onClick: this.handleWaitingForVerifyDynamicCode, style: {
                      color: '#fa063a',
                      fontSize: 13
                    } },
                  '\u83B7\u53D6\u9A8C\u8BC1\u7801'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { height: 45, paddingRight: 13, paddingLeft: 13 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitJustifyContent: "flex-end", WebkitFlexDirection: "row", height: "100%" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { width: 120 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "flex-end" }, onClick: this.toggleInvitation },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#3a3e47', marginLeft: 13, fontSize: 13 } },
                    '\u6211\u6709\u9080\u8BF7\u7801'
                  ),
                  this.state.invitationCodeFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: 30, height: 30 }, src: __webpack_require__(232) }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: 30, height: 30 }, src: __webpack_require__(233) })
                )
              )
            )
          ),
          this.state.invitationCodeFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#3a3e47', marginLeft: 13, fontSize: 14, width: 80 } },
              '\u9080\u8BF7\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1,
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { WebkitFlex: 1, fontSize: 13, display: "-webkit-flex" }, placeholder: '(非必填) 请输入推荐人手机号码', value: this.state.invitationCode, onChange: function onChange(event) {
                  return _this3.setState({ invitationCode: event.target.value });
                } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.setState({ invitationCode: '' });
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { marginRight: -2, width: 44, height: 44 }, src: __webpack_require__(47) })
              )
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                WebkitFlexDirection: 'row',
                WebkitJustifyContent: 'center',
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  _this3.setState({ isSelected: !_this3.state.isSelected });
                } },
              this.state.isSelected ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: {
                  height: 28,
                  width: 28,
                  marginTop: -2,
                  marginLeft: -7,
                  marginRight: 5
                }, src: __webpack_require__(55) }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: {
                  height: 28,
                  width: 28,
                  marginTop: -2,
                  marginLeft: -7,
                  marginRight: 5
                }, src: __webpack_require__(51) })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: {
                  marginTop: 3,
                  marginLeft: -7,
                  WebkitFlex: 1,
                  color: '#a1a7b2',
                  fontSize: 12,
                  lineHeight: "20px"
                } },
              '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: '#fa063a' }, onClick: function onClick() {
                    _this3.handleJumpToProtocol('华夏财富电子交易服务协议');
                  } },
                '\u300A\u534E\u590F\u8D22\u5BCC\u7535\u5B50\u4EA4\u6613\u670D\u52A1\u534F\u8BAE\u300B'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: '#fa063a' }, onClick: function onClick() {
                    _this3.handleJumpToProtocol('投资人权益须知');
                  } },
                '\u300A\u6295\u8D44\u4EBA\u6743\u76CA\u987B\u77E5\u300B'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: '#fa063a' }, onClick: function onClick() {
                    _this3.handleJumpToProtocol('华夏财富用户隐私政策');
                  } },
                '\u300A\u534E\u590F\u8D22\u5BCC\u7528\u6237\u9690\u79C1\u653F\u7B56\u300B'
              ),
              '\u548C',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: '#fa063a' }, onClick: function onClick() {
                    _this3.handleJumpToProtocol('电子签名约定书');
                  } },
                '\u300A\u7535\u5B50\u7B7E\u540D\u7EA6\u5B9A\u4E66\u300B'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.mobileDynamicCode && this.state.mobileNumber && this.state.password && this.state.isSelected ? this.handleVerify : null },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: this.state.mobileDynamicCode && this.state.mobileNumber && this.state.password && this.state.isSelected ? '#fa063a' : '#afb0b2', WebkitAlignItems: 'center', WebkitJustifyContent: 'center', height: 40, borderRadius: 20, WebkitFlexDirection: 'row', display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u6CE8\u518C'
              )
            )
          )
        )
      );
    }
  }]);

  return Register;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Register));

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SetNewPassword = function (_Component) {
  _inherits(SetNewPassword, _Component);

  function SetNewPassword() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SetNewPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SetNewPassword.__proto__ || Object.getPrototypeOf(SetNewPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mobileNumber: _this.props.location.state ? _this.props.location.state.mobileNumber : "",
      newPassword: '',
      checkPassword: '',
      secureTextEntryForNewPassword: true,
      secureTextEntryForCheckPassword: true,
      flag: false,
      passType: "password",
      passTypeAgin: "password"
    }, _this.handleSetNewPassword = function () {
      var encryptedPassword = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.encrypt(_this.state.newPassword);

      var pattern = /^[\d,\w]{6,8}$/;
      if (!pattern.test(_this.state.newPassword)) {
        var toast = __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info('密码格式不正确', 2);
        return;
      }

      if (_this.state.newPassword != _this.state.checkPassword) {
        __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info('密码不一致', 2);
        return;
      }

      var setNewPasswordParam = {
        mobileNo: _this.state.mobileNumber,
        newPassword: encryptedPassword
      };
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_loginAction_js__["m" /* resetPassword */])(setNewPasswordParam, function (msg) {
        _this.syncSuccess(msg);
      }, function (msg) {
        _this.syncError(msg);
      }));
    }, _this.syncError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info(msg, 2);
    }, _this.syncSuccess = function () {
      _this.setState({
        flag: false
      });
      //跳转到登录前的页面。
      // Toast.info(msg, 2);
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].go(-3);
    }, _this.changePassword = function (event) {
      _this.setState({
        newPassword: event.target.value
      });
    }, _this.changeCkPassword = function (event) {
      _this.setState({
        checkPassword: event.target.value
      });
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SetNewPassword, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "设置登录密码";
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          passType = _state.passType,
          passTypeAgin = _state.passTypeAgin;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BBE\u7F6E\u767B\u5F55\u5BC6\u7801'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100 } },
              '\u767B\u5F55\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: this.changePassword, value: this.state.newPassword, type: passType, style: { WebkitFlex: 1, fontSize: 14, color: "#3a3e47", height: 40 }, placeholder: '\u8BF7\u8F93\u51656-8\u4F4D\u767B\u5F55\u5BC6\u7801' }),
              this.state.secureTextEntryForNewPassword ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                  return _this2.setState({ secureTextEntryForNewPassword: !_this2.state.secureTextEntryForNewPassword, passType: "text" });
                }, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(111) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                  return _this2.setState({ secureTextEntryForNewPassword: !_this2.state.secureTextEntryForNewPassword, passType: "password" });
                }, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(110) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                marginTop: 7,
                marginLeft: 13,
                marginRight: 13,
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                borderRadius: 22,
                border: "1px solid #eaeded",
                position: "relative",
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100 } },
              '\u786E\u8BA4\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: this.changeCkPassword, value: this.state.checkPassword, type: passTypeAgin, style: { WebkitFlex: 1, fontSize: 14, color: "#3a3e47", height: 40 }, placeholder: '\u8BF7\u8F93\u5165\u786E\u8BA4\u5BC6\u7801' }),
              this.state.secureTextEntryForCheckPassword ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                  return _this2.setState({ secureTextEntryForCheckPassword: !_this2.state.secureTextEntryForCheckPassword, passTypeAgin: "text" });
                }, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(111) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                  return _this2.setState({ secureTextEntryForCheckPassword: !_this2.state.secureTextEntryForCheckPassword, passTypeAgin: "password" });
                }, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(110) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.newPassword && this.state.checkPassword ? this.handleSetNewPassword : null },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: this.state.newPassword && this.state.checkPassword ? '#fa063a' : '#afb0b2', WebkitAlignItems: 'center', WebkitJustifyContent: 'center', height: 40, borderRadius: 20, WebkitFlexDirection: 'row', display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u5B8C\u6210'
              )
            )
          )
        )
      );
    }
  }]);

  return SetNewPassword;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SetNewPassword));

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var intervalId = null;
var requestId = '';

var UserBindingMobile = function (_Component) {
  _inherits(UserBindingMobile, _Component);

  function UserBindingMobile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserBindingMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserBindingMobile.__proto__ || Object.getPrototypeOf(UserBindingMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      verifyCode: '',
      phoneNum: '',
      isRequestingVerifyCode: false,
      countDown: 120,
      flag: false
    }, _this.handleVerify = function () {
      if (!_this.state.verifyCode || !_this.state.phoneNum) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入信息', 2);
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(_this.state.phoneNum)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (requestId === '' || !requestId) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请先申请手机验证码', 2);
        return;
      }
      var verifyParam = {
        requestId: requestId,
        mobileNo: _this.state.phoneNum,
        mobileCaptchaText: _this.state.verifyCode,
        token: _this.props.location.state.content.shortToken
      };
      _this.setState({
        flag: true
      });
      console.log(_this.props.location.state.content, 'this.props.location.state.content,');
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__["p" /* userBindingMobile */])(verifyParam, _this.props.location.state.content, function () {
        _this.verifySuccess();
      }, function (msg) {
        return _this.verifyError(msg);
      }));
    }, _this.verifySuccess = function () {
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      // if(route) {
      //   hashHistory.go(route - window.history.length);
      // }else {
      //   hashHistory.goBack();
      // }
      // setTimeout(() => {
      //   if(callback) {
      //     callback();
      //   }
      // }, 100);
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].go(-2);
    }, _this.verifyError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
    }, _this.verifyRegisterPhoneSuc = function (phoneNum) {
      var params = { mobileNo: phoneNum };
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["r" /* realUserMobileCaptcha */])(params, function (requestid) {
        requestId = requestid;
      }));
    }, _this.verifyRegisterPhoneErr = function (msg) {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
      _this.setState({
        isRequestingVerifyCode: false
      });
    }, _this.handleWaitingForVC = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.phoneNum)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: _this.state.phoneNum }, function (phoneNum) {
        _this.verifyRegisterPhoneSuc(phoneNum);
      }, function (msg) {
        _this.verifyRegisterPhoneErr(msg);
      }));
      var countNum = 119;
      _this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            cancelTimeOut();
            _this.setState({
              isRequestingVerifyCode: false
            });
          }
          _this.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (intervalId) clearInterval(intervalId);
          intervalId = null;
        };
      });
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }, _this.changePhoneNo = function (event) {
      _this.setState({
        phoneNum: event.target.value
      });
    }, _this.changeVerifyCode = function (event) {
      _this.setState({
        verifyCode: event.target.value
      });
    }, _this.clearPhoneNum = function () {
      _this.setState({
        phoneNum: ""
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserBindingMobile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      requestId = '';
      this.setState({
        flag: false
      });
      if (intervalId) {
        clearInterval(intervalId);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "绑定手机号";
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7ED1\u5B9A\u624B\u673A\u53F7'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: window.winWidth,
                height: "auto"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#5b6370',
                  marginTop: 25,
                  marginBottom: 12,
                  fontSize: 13,
                  marginLeft: 13,
                  marginRight: 13,
                  display: 'block',
                  lineHeight: "18px"
                } },
              '\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u4F60\u8FD8\u6CA1\u6709\u7ED1\u5B9A\u624B\u673A\u53F7\uFF01\u4E3A\u4E86\u786E\u4FDD\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u7ED1\u5B9A\u60A8\u7684\u624B\u673A\u53F7\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: window.winWidth,
                height: "auto"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: 45,
                  borderBottom: "1px solid  rgba(242,245,247,1)",
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  display: "-webkit-flex",
                  position: "relative"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: '#3a3e47',
                    paddingLeft: 13,
                    fontSize: 13,
                    width: 90
                  } },
                '\u624B\u673A\u53F7'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    display: "-webkit-flex",
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, WebkitFlex: 1 }, placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.phoneNum, onChange: this.changePhoneNo }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.clearPhoneNum, src: __webpack_require__(47), style: { marginRight: -2, width: 44, height: 44 } })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  paddingLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u624B\u673A\u52A8\u6001\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801', value: this.state.verifyCode, onChange: this.changeVerifyCode })
              ),
              this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    backgroundColor: '#d8dbdd',
                    height: 27,
                    borderRadius: 13,
                    paddingLeft: 10,
                    paddingRight: 10,
                    WebkitAlignItems: 'center',
                    WebkitJustifyContent: 'center',
                    display: "-webkit-flex",
                    marginRight: 10,
                    width: 110
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5b6370", fontSize: 13 } },
                  this.state.countDown,
                  '\u79D2\u540E\u91CD\u53D1'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { "white-space": "nowrap", width: 110, textAlign: "right", paddingRight: 13 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.handleWaitingForVC, style: {
                      color: '#fa063a',
                      fontSize: 13
                    } },
                  '\u83B7\u53D6\u9A8C\u8BC1\u7801'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.verifyCode && this.state.phoneNum ? this.handleVerify : null },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: this.state.verifyCode && this.state.phoneNum ? '#fa063a' : '#afb0b2', WebkitAlignItems: 'center', WebkitJustifyContent: 'center', height: 40, borderRadius: 20, WebkitFlexDirection: 'row', display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u7ED1\u5B9A'
              )
            )
          )
        )
      );
    }
  }]);

  return UserBindingMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(UserBindingMobile));

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var intervalId = null;
var requestId = "";

var VerifyDynamicCode = function (_Component) {
  _inherits(VerifyDynamicCode, _Component);

  function VerifyDynamicCode() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VerifyDynamicCode);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VerifyDynamicCode.__proto__ || Object.getPrototypeOf(VerifyDynamicCode)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mobileNumber: _this.props.location.state ? _this.props.location.state.mobileNumber : "",
      mobileDynamicCode: '',
      isRequestingVerifyCode: false,
      countdown: 120,
      flag: false
    }, _this.handleVerify = function () {
      if (requestId === '' || !requestId) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请先申请手机验证码', 2);
        return;
      }
      var verifyParam = {
        requestId: requestId,
        mobileNo: _this.state.mobileNumber,
        captcha: _this.state.mobileDynamicCode
      };
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["q" /* verifyPhone */])(verifyParam, function () {
        _this.verifySuccess();
      }, function (msg) {
        return _this.verifyError(msg);
      }));
    }, _this.verifySuccess = function () {
      _this.setState({
        flag: false
      });
      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: "/setNewPassword",
        state: {
          mobileNumber: _this.state.mobileNumber,
          callback: callback,
          route: route
        }
      });
    }, _this.verifyError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
      // this.props.navigator.push({component: SetLoginPassword});  
    }, _this.handleWaitingForVerifyDynamicCode = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      var params = { mobileNo: _this.state.mobileNumber };
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["r" /* realUserMobileCaptcha */])(params, function (requestid) {
        requestId = requestid;
      }));
      var countNum = 119;
      _this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            cancelTimeOut();
            _this.setState({
              isRequestingVerifyCode: false
            });
          }
          _this.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (intervalId) clearInterval(intervalId);
          intervalId = null;
        };
      });
    }, _this.splitMobileNumber = function (mobileNumber) {
      if (_this.props.isFromFast) return mobileNumber.substring(0, 3) + ' ' + '****' + ' ' + mobileNumber.substring(7);else return mobileNumber.substring(0, 3) + ' ' + mobileNumber.substring(3, 7) + ' ' + mobileNumber.substring(7);
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }, _this.changeMobileDynamicCode = function (event) {
      _this.setState({
        mobileDynamicCode: event.target.value
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VerifyDynamicCode, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      requestId = '';
      this.setState({
        flag: false
      });
      if (intervalId) clearInterval(intervalId);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "找回登录密码";
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u627E\u56DE\u767B\u5F55\u5BC6\u7801'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: window.winWidth,
                height: 'auto'
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    marginTop: 50,
                    fontSize: 22,
                    color: '#3a3e47'
                  } },
                this.splitMobileNumber(this.state.mobileNumber)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    marginTop: 9,
                    marginBottom: 10,
                    color: '#5b6370',
                    fontSize: 13
                  } },
                '\uFF08\u624B\u673A\u53F7\uFF09'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  marginLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u624B\u673A\u52A8\u6001\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801', value: this.state.mobileDynamicCode, onChange: this.changeMobileDynamicCode })
              ),
              this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    backgroundColor: '#d8dbdd',
                    height: 27,
                    borderRadius: 13,
                    paddingLeft: 10,
                    paddingRight: 10,
                    WebkitAlignItems: 'center',
                    WebkitJustifyContent: 'center',
                    display: "-webkit-flex",
                    marginRight: 10,
                    width: 110
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5b6370", fontSize: 13 } },
                  this.state.countDown,
                  '\u79D2\u540E\u91CD\u53D1'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { whiteSpace: "nowrap", width: 110, textAlign: "right", paddingRight: 13 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.handleWaitingForVerifyDynamicCode, style: {
                      color: '#fa063a',
                      fontSize: 13
                    } },
                  '\u83B7\u53D6\u9A8C\u8BC1\u7801'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.mobileDynamicCode && this.state.mobileNumber ? this.handleVerify : null },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: this.state.mobileDynamicCode && this.state.mobileNumber ? '#fa063a' : '#afb0b2', WebkitAlignItems: 'center', WebkitJustifyContent: 'center', height: 40, borderRadius: 20, WebkitFlexDirection: 'row', display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u4E0B\u4E00\u6B65'
              )
            )
          )
        )
      );
    }
  }]);

  return VerifyDynamicCode;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(VerifyDynamicCode));

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var intervalId = null;
var requestId = "";

var VerifyDynamicCodeSec = function (_Component) {
  _inherits(VerifyDynamicCodeSec, _Component);

  function VerifyDynamicCodeSec() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VerifyDynamicCodeSec);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VerifyDynamicCodeSec.__proto__ || Object.getPrototypeOf(VerifyDynamicCodeSec)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mobileNumber: "",
      mobileDynamicCode: '',
      isRequestingVerifyCode: false,
      countdown: 120,
      flag: false,
      captchaCode: "",
      serverCapchaCode: "",
      imageBase64: "",
      passWord: "",
      passWordSec: "",
      showHideFlag: true,
      showHideFlagSec: true
    }, _this.handleVerify = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!/\S/.test(_this.state.captchaCode)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入图形验证码', 2);
        return;
      }
      if (requestId === '' || !requestId) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请先申请手机验证码', 2);
        return;
      }
      var encryptedPassword = __WEBPACK_IMPORTED_MODULE_5__util_js___default.a.encrypt(_this.state.passWord);

      var pattern = /^[\d,\w]{6,8}$/;
      if (!pattern.test(_this.state.passWord)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('密码格式不正确', 2);
        return;
      }
      if (_this.state.passWord != _this.state.passWordSec) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('密码不一致', 2);
        return;
      }
      var verifyParam = {
        requestId: requestId,
        mobileNo: _this.state.mobileNumber,
        captcha: _this.state.mobileDynamicCode,
        newPassword: encryptedPassword
      };
      console.log(verifyParam);
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__["n" /* forgetPassword */])(verifyParam, function (msg) {
        _this.syncSuccess(msg);
      }, function (msg) {
        _this.syncError(msg);
      }));
    }, _this.syncError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
    }, _this.syncSuccess = function () {
      _this.setState({
        flag: false
      });
      //跳转到登录前的页面。
      // Toast.info(msg, 2);
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].go(-1);
    }, _this.handleWaitingForVerifyDynamicCodeSec = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.mobileNumber)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (!/\S/.test(_this.state.captchaCode)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入图形验证码', 2);
        return;
      }
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: _this.state.mobileNumber }, function () {
        _this.verifyRegisterPhoneSuc();
      }, function (msg) {
        _this.verifyRegisterPhoneErr(msg);
      }));
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }, _this.getPicCaptchaFun = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__["e" /* getCapcha */])(function (token, base64) {
        _this.setState({
          imageBase64: base64,
          serverCapchaCode: token
        });
      }, function () {}));
    }, _this.showHidePass = function () {
      _this.setState({
        showHideFlag: !_this.state.showHideFlag
      });
    }, _this.showHidePassSec = function () {
      _this.setState({
        showHideFlagSec: !_this.state.showHideFlagSec
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VerifyDynamicCodeSec, [{
    key: 'verifyRegisterPhoneSuc',
    value: function verifyRegisterPhoneSuc() {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info("该手机号码为未注册号码，请确认输入正确手机号码", 2);
    }
  }, {
    key: 'verifyRegisterPhoneErr',
    value: function verifyRegisterPhoneErr(msg) {
      var _this2 = this;

      if (msg.indexOf('手机号已注册') != -1) {
        var params = {
          mobileNo: this.state.mobileNumber,
          token: this.state.serverCapchaCode,
          captchaCode: this.state.captchaCode.toUpperCase()
        };
        console.log(params);
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_loginAction_js__["d" /* getMobileCaptcha */])(params, function (requestId) {
          _this2.getMobileCaptchaSucc(requestId);
        }, function (content) {
          _this2.getMobileCaptchaErr(content);
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);
      }
    }

    //图形验证码验证成功并获取短信验证码

  }, {
    key: 'getMobileCaptchaSucc',
    value: function getMobileCaptchaSucc(_requestId) {
      var _this3 = this;

      console.log(_requestId);
      requestId = _requestId;
      var countNum = 119;
      this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            cancelTimeOut();
            _this3.setState({
              isRequestingVerifyCode: false
            });
          }
          _this3.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (intervalId) clearInterval(intervalId);
          intervalId = null;
        };
      });
    }

    //图形验证码验证失败

  }, {
    key: 'getMobileCaptchaErr',
    value: function getMobileCaptchaErr(err) {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(err.message, 2);
      requestId = "";
      this.setState({
        captchaCode: ""
      });
      this.getPicCaptchaFun();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      requestId = '';
      this.setState({
        flag: false
      });
      if (intervalId) clearInterval(intervalId);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "找回登录密码";
      this.getPicCaptchaFun();
    }

    //获取图形验证码

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u627E\u56DE\u767B\u5F55\u5BC6\u7801'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  marginLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u624B\u673A\u53F7'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u5165\u6CE8\u518C\u624B\u673A\u53F7', value: this.state.mobileNumber, onChange: function onChange(event) {
                    _this4.setState({ mobileNumber: event.target.value });
                  } })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  marginLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u56FE\u5F62\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 13, display: "-webkit-flex", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801', value: this.state.captchaCode, onChange: function onChange(event) {
                    _this4.setState({ captchaCode: event.target.value });
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: this.getPicCaptchaFun },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 63,
                      height: 27
                    }, src: 'data:image/png;base64,' + this.state.imageBase64 })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  marginLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u624B\u673A\u52A8\u6001\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801', value: this.state.mobileDynamicCode, onChange: function onChange(event) {
                    _this4.setState({ mobileDynamicCode: event.target.value });
                  } })
              ),
              this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: {
                    backgroundColor: '#d8dbdd',
                    height: 27,
                    borderRadius: 13,
                    paddingLeft: 10,
                    paddingRight: 10,
                    WebkitAlignItems: 'center',
                    WebkitJustifyContent: 'center',
                    display: "-webkit-flex",
                    marginRight: 10,
                    width: 110
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5b6370", fontSize: 13 } },
                  this.state.countDown,
                  '\u79D2\u540E\u91CD\u53D1'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { whiteSpace: "nowrap", width: 110, textAlign: "right", paddingRight: 13 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.handleWaitingForVerifyDynamicCodeSec, style: {
                      color: '#fa063a',
                      fontSize: 13
                    } },
                  '\u83B7\u53D6\u9A8C\u8BC1\u7801'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  marginLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u65B0\u767B\u5F55\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 13, display: "-webkit-flex", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: this.state.showHideFlag ? "password" : "text", style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u51656-8\u4F4D\u767B\u5F55\u5BC6\u7801', value: this.state.passWord, onChange: function onChange(event) {
                    _this4.setState({ passWord: event.target.value });
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: this.showHidePass },
                  this.state.showHideFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }, src: __webpack_require__(110) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }, src: __webpack_require__(111) })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  marginLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u786E\u8BA4\u5BC6\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 13, display: "-webkit-flex", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: this.state.showHideFlagSec ? "password" : "text", style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u91CD\u65B0\u8F93\u5165\u5BC6\u7801', value: this.state.passWordSec, onChange: function onChange(event) {
                    _this4.setState({ passWordSec: event.target.value });
                  } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: this.showHidePassSec },
                  this.state.showHideFlagSec ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }, src: __webpack_require__(110) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                      width: 55,
                      height: 55,
                      marginRight: -16
                    }, src: __webpack_require__(111) })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.mobileDynamicCode && this.state.mobileNumber && this.state.passWord && this.state.passWordSec && this.state.captchaCode ? this.handleVerify : null },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: this.state.mobileDynamicCode && this.state.mobileNumber && this.state.passWord && this.state.passWordSec && this.state.captchaCode ? '#fa063a' : '#afb0b2', WebkitAlignItems: 'center', WebkitJustifyContent: 'center', height: 40, borderRadius: 20, WebkitFlexDirection: 'row', display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u4E0B\u4E00\u6B65'
              )
            )
          )
        )
      );
    }
  }]);

  return VerifyDynamicCodeSec;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(VerifyDynamicCodeSec));

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var InvestmentDetail = function (_Component) {
  _inherits(InvestmentDetail, _Component);

  function InvestmentDetail(props) {
    _classCallCheck(this, InvestmentDetail);

    var _this = _possibleConstructorReturn(this, (InvestmentDetail.__proto__ || Object.getPrototypeOf(InvestmentDetail)).call(this, props));

    _this.state = {
      pwdFlag: false,
      keyPasswordVal: '',
      ThreeIncome: '',
      dayIncomeDate: ''
    };
    return _this;
  }

  _createClass(InvestmentDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      document.title = '定投计划详情';
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myAssets_InvestPlanAction_js__["h" /* getInvestmentDetial */])(this.props.location.state.planId, this.changeFlag.bind(this)));
      console.log(this.props.inInvestmentDetial);
      if (this.props.location.state.planItem.fundCode.startsWith('SF')) {
        var inData = {
          superFundCode: this.props.location.state.planItem.fundCode,
          periodType: 12
        };
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_portfolioAction__["a" /* getSuperFundProductIncome */])(inData, function (data) {
          var leng = data.incomeDateList.length - 1;
          var IncomeDate = data.incomeDateList[leng]; /*最新收益率时间*/
          var ThreeIncome = data.incomeList[leng];
          _this2.setState({
            dayIncomeDate: IncomeDate.replace(/\//g, "-"),
            ThreeIncome: __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(ThreeIncome * 100) /*近一年收益*/
          });
        }, this));
      }
    }
  }, {
    key: 'changeFlag',
    value: function changeFlag() {}
  }, {
    key: 'change',
    value: function change() {
      var _this3 = this;

      var _props = this.props,
          inInvestmentDetial = _props.inInvestmentDetial,
          dispatch = _props.dispatch;

      var currentNavDate = new Date(inInvestmentDetial.publishDate).getTime();
      if (this.props.location.state.planItem.fundCode.startsWith('SF')) {
        var obj = {
          name: inInvestmentDetial.fundName,
          fundCode: inInvestmentDetial.fundCode,
          currentNav: inInvestmentDetial.fundValue,
          currentNavDate: currentNavDate
        };
        var params = {
          fundName: inInvestmentDetial.fundName,
          fundCode: inInvestmentDetial.fundCode,
          businessType: 'T022',
          productType: 'G',
          titleHeader: '定投计划修改',
          planId: inInvestmentDetial.planId,
          trustChannelId: inInvestmentDetial.trustChannelId,
          item: obj,
          wanfenshouyi: inInvestmentDetial.wanfenshouyi,
          fundType: inInvestmentDetial.fundType,
          planItem: this.props.location.state.planItem,
          callback: function callback() {}
        };
        setTimeout(function () {
          _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["d" /* myPaymentText */])(_this3.props.location.state.planItem.tradeAmount.toString()));
        }, 1000);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], 'FixedInvestmentSuperFundChange');
      } else {
        var _obj = {
          name: inInvestmentDetial.fundName,
          fundCode: inInvestmentDetial.fundCode,
          currentNav: inInvestmentDetial.fundValue,
          currentNavDate: currentNavDate
        };
        var _params = {
          fundName: inInvestmentDetial.fundName,
          fundCode: inInvestmentDetial.fundCode,
          businessType: 'T022',
          productType: 'G',
          titleHeader: '定投计划修改',
          planId: inInvestmentDetial.planId,
          item: _obj,
          wanfenshouyi: inInvestmentDetial.wanfenshouyi,
          fundType: inInvestmentDetial.fundType,
          planItem: this.props.location.state.planItem,
          callback: function callback() {}
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, _params, __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], 'FixedInvestmentChange');
      }
    }
  }, {
    key: 'goFunDetial',
    value: function goFunDetial() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          inInvestmentDetial = _props2.inInvestmentDetial;
      var planItem = this.props.location.state.planItem;

      var superFundCode = planItem.fundCode;
      if (superFundCode.startsWith('SF')) {
        var component = void 0;
        component = '/SuperFundDetail';
        __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
          pathname: component,
          state: { superFundCode: planItem.fundCode },
          query: { superFundCode: planItem.fundCode }
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_js__["j" /* fundDetailFun */])('G', inInvestmentDetial.fundCode, window.history.length);
      }
    }
  }, {
    key: 'funRight',
    value: function funRight() {
      var inInvestmentDetial = this.props.inInvestmentDetial;

      console.log(inInvestmentDetial);
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/InvestmentRecord',
        state: { planId: inInvestmentDetial.planId }
      });
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        keyPasswordVal: val
      });
    }
  }, {
    key: 'keyOk',
    value: function keyOk() {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          inInvestmentDetial = _props3.inInvestmentDetial;
      var planItem = this.props.location.state.planItem;
      var keyPasswordVal = this.state.keyPasswordVal;

      var data = {
        planId: inInvestmentDetial.planId,
        password: __WEBPACK_IMPORTED_MODULE_3__util___default.a.encrypt(keyPasswordVal)
      };
      console.log(inInvestmentDetial);
      var pushResult = function pushResult(i, result) {
        if (i == 1) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].replace({
            pathname: '/Success',
            state: {
              title: '定投计划',
              content: '您终止的定投计划已被受理',
              dataSouse: [['终止编号', result.content.planId]],
              souseVal: ['查看我的投资', '返回智投首页']
            }
          });
        } else if (i == 3) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].replace({
            pathname: '/ErrorResult',
            state: {
              title: '定投计划',
              content: '您终止的定投计划失败',
              content2: result,
              dataSouse: [],
              souseVal: ['返回智投首页', '联系客服']
            }
          });
        }
      };
      if (planItem.type == '12') {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myAssets_InvestPlanAction_js__["i" /* getStopPlan */])(data, pushResult));
      } else if (planItem.type == '0') {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myAssets_InvestPlanAction_js__["j" /* getStopBuyPlan */])(data, pushResult));
      } else if (planItem.type == '11' || planItem.type == '2') {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_myAssets_InvestPlanAction_js__["k" /* moneyFundPlanStopValidate */])(data, pushResult));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props$location$state = this.props.location.state,
          name = _props$location$state.name,
          code = _props$location$state.code,
          planItem = _props$location$state.planItem;
      var inInvestmentDetial = this.props.inInvestmentDetial;

      console.log('定投详情', inInvestmentDetial);
      var arr = ['', '', '一', '二', '三', '四', '五'];
      var str = '';
      if (inInvestmentDetial.periodType == '0') {
        str = '每月' + inInvestmentDetial.tradeDates[0] + '日';
      } else if (inInvestmentDetial.periodType == '1') {
        str = '每周周' + arr[inInvestmentDetial.tradeDates[0]];
      } else if (inInvestmentDetial.periodType == '3') {
        str = '每双周周' + arr[inInvestmentDetial.tradeDates[0]];
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5B9A\u6295\u8BA1\u5212\u8BE6\u60C5'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginRight: 13 }, onClick: function onClick() {
                  return _this4.funRight();
                } },
              '\u5B9A\u6295\u8BB0\u5F55'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content paddB40' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-detial-header', onClick: function onClick() {
                return _this4.goFunDetial();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-header-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(662) }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-header-center' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-detial-header-center-top' },
                name + '(' + code + ')'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-detial-header-center-bottom' },
                this.props.location.state.planItem.fundCode.startsWith('SF') ? '\u8FD1\u4E00\u5E74\u6536\u76CA:' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(__WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(this.state.ThreeIncome), 2) + '%(' + this.state.dayIncomeDate + ')' : inInvestmentDetial.fundType == '理财型' || inInvestmentDetial.fundType == '货币型' ? '\u4E07\u4EFD\u6536\u76CA:' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(__WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(inInvestmentDetial.wanfenshouyi), 4) + '(' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(inInvestmentDetial.publishDate) + ')' : '\u6700\u65B0\u51C0\u503C:' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(__WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(inInvestmentDetial.fundValue), 3) + '(' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(inInvestmentDetial.publishDate) + ')'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-header-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(153), className: 'plan-detial-header-right' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-detial-info' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-info-box' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                inInvestmentDetial.tradeAmount,
                '\u5143'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5B9A\u6295\u91D1\u989D'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-info-box' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                str.length == 0 ? '--' : str
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5B9A\u6295\u5468\u671F'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-info-box' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                planItem.trustChannelName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u652F\u4ED8\u6E20\u9053'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-detial-info-time' },
            '\u4E0B\u4E00\u6263\u6B3E\u65E5:',
            __WEBPACK_IMPORTED_MODULE_3__util___default.a.returnDate(inInvestmentDetial.nextTradeDate)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-detial-barbox' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-barbox-bar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7D2F\u8BA1\u6295\u8D44'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                inInvestmentDetial.amount
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-detial-barbox-bar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5B9A\u6295\u6B21\u6570'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                inInvestmentDetial.count
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'plan-detial-bottom' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this4.change();
              } },
            '\u4FEE\u6539'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this4.setState({ pwdFlag: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(385) }),
            '\u7EC8\u6B62'
          )
        ),
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', top: 0, width: '100%', height: '100%', background: 'rgba(52,52,52,0.4)' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'fixed', bottom: 0, width: '100%', height: '70%', background: '#fff' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'relative', height: '45px', lineHeight: '45px', textAlign: 'center', borderBottom: '0.005rem solid rgb(224,227,279)', fontSize: '0.3rem' } },
              '\u4EA4\u6613\u5BC6\u7801',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), style: { position: 'absolute', left: 0, width: '0.88rem', height: '0.88rem' }, onClick: function onClick() {
                  _this4.setState({ pwdFlag: false });
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { position: 'absolute', top: 0, right: 0, width: '45px', fontSize: '13px' }, className: 'red-t', onClick: function onClick() {
                    _this4.keyOk();
                  } },
                ' \u786E\u8BA4'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '0.3rem 0.3rem 0rem 0.3rem', fontSize: '13px' } },
              this.props.location.state.fundRisk ? '温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。' : ''
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '45px', padding: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                  return _this4.onChangePwd(e.target.value);
                }, autofocus: 'autofocus', style: { height: '45px', width: '100%', fontSize: '0.3rem', border: '1px solid #afafaf', borderRadius: '0.1rem' }, type: 'password', placeholder: '' })
            )
          )
        ) : null
      );
    }
  }]);

  return InvestmentDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    inInvestmentDetial: state.InvestPlanReducer.inInvestmentDetial
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InvestmentDetail));

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_myAssets_InvestPlanAction__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChannelNav__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var TabPane = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Tabs"].TabPane;
function callback(key) {
  console.log(key);
}

var InvestmentFund = function (_Component) {
  _inherits(InvestmentFund, _Component);

  function InvestmentFund(props) {
    var _arguments = arguments;

    _classCallCheck(this, InvestmentFund);

    var _this2 = _possibleConstructorReturn(this, (InvestmentFund.__proto__ || Object.getPrototypeOf(InvestmentFund)).call(this, props));

    _this2.dataNode = [];

    _this2.selectFund = function (item) {
      var productType = void 0;
      if (item.fundTypeName == "超级基金型") {
        productType = 'Z';
      } else if (item.raiseMethod == '9') {
        productType = 'G';
      } else if (item.raiseMethod == '7') {
        productType = 'S';
      } else if (item.raiseMethod == '5') {
        productType = 'J';
      }

      if (item.fundTypeName == "超级基金型") {
        var inData = {
          superFundCode: item.fundCode,
          periodType: 12
        };
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_portfolioAction__["a" /* getSuperFundProductIncome */])(inData, function (data) {
          var leng = data.incomeDateList.length - 1;
          var IncomeDate = data.incomeDateList[leng]; /*最新收益率时间*/
          var ThreeIncome = data.incomeList[leng];
          var params = {
            fundName: item.name,
            fundCode: item.fundCode,
            ThreeIncome: ThreeIncome ? __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(ThreeIncome * 100) : '',
            dayIncomeDate: IncomeDate ? IncomeDate.replace(/\//g, "-") : '',
            productType: "Z",
            pageText: "新建定投计划",
            superTypeValue: __WEBPACK_IMPORTED_MODULE_4__util___default.a.superFundCodeArrByTarget.indexOf(item.fundCode) != -1 ? "1" : "0"
          };
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["r" /* getPayAllSuper */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
        }, _this2));
      } else {
        var params = {
          fundName: item.name,
          fundCode: item.fundCode,
          businessType: 'T039',
          productType: productType,
          titleHeader: '新建定投计划',
          wanfenshouyi: item.wanfenshouyi ? item.wanfenshouyi : "",
          fundType: item.fundTypeName,
          currentNav: item.currentNav,
          currentNavDate: item.currentNavDate,
          item: item
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], "FixedInvestment");
      }
    };

    _this2.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this2.focusText = function () {
      document.onkeydown = function (event) {
        var e = event || window.event || _arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {
          _this2.getSearchList();
        }
      };
    };

    _this2.changeVale = function (event) {
      _this2.setState({
        headerValue: event.target.value
      });
    };

    _this2.blurText = function () {
      document.onkeydown = function (event) {
        var e = event || window.event || _arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {}
      };
    };

    _this2.state = {
      headerValue: '',
      source0: [],
      source1: [],
      source2: [],
      source3: [],
      source4: [],
      source5: [],
      source6: [],
      source7: [],
      source8: [],
      source9: [],
      searchSouse: [],
      firstOpen: true,
      searchFlag: false
    };
    return _this2;
  }

  _createClass(InvestmentFund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      document.title = "选择定投基金";
      var _props = this.props,
          dispatch = _props.dispatch,
          TransformationFunList = _props.TransformationFunList;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_myAssets_InvestPlanAction__["g" /* getInvestmentFundList */])(function () {
        return _this3.dataSouse.apply(_this3, arguments);
      }));
    }
  }, {
    key: 'dataSouse',
    value: function dataSouse() {
      for (var _len = arguments.length, arr = Array(_len), _key = 0; _key < _len; _key++) {
        arr[_key] = arguments[_key];
      }

      console.log(arr);
      this.setState({
        source0: arr[0],
        source1: arr[1],
        // source2:arr[2],
        // source3:arr[3],
        // source4:arr[4],
        // source5:arr[5],
        // source6:arr[6],
        // source7:arr[7],
        // source8:arr[8],
        // source9:arr[9],
        firstOpen: false
      });
      this.dataNode = arr;
    }
  }, {
    key: 'serchChange',
    value: function serchChange(e) {
      this.setState({
        serchVal: e.target.value
      });
    }
  }, {
    key: 'getSearchList',
    value: function getSearchList() {
      var _state = this.state,
          source0 = _state.source0,
          headerValue = _state.headerValue;

      if (headerValue == '') {
        this.setState({
          searchFlag: false,
          searchSouse: []
        });
      } else {
        var newArr = source0.filter(function (item) {
          if (item.fundCode.toUpperCase().indexOf(headerValue.toUpperCase()) > -1 || item.name.toUpperCase().indexOf(headerValue.toUpperCase()) > -1) {
            return item;
          }
        });
        this.setState({
          searchFlag: true,
          searchSouse: newArr
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var fundLength = this.props.inInvestmentFundList.content.length;
      var _state2 = this.state,
          source0 = _state2.source0,
          source1 = _state2.source1,
          source2 = _state2.source2,
          source3 = _state2.source3,
          source4 = _state2.source4,
          source5 = _state2.source5,
          source6 = _state2.source6,
          source7 = _state2.source7,
          searchFlag = _state2.searchFlag,
          searchSouse = _state2.searchSouse,
          firstOpen = _state2.firstOpen,
          headerValue = _state2.headerValue;

      var _this = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container plan-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader SearchList-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autoComplete: 'off', onBlur: this.blurText, onFocus: this.focusText, onChange: this.changeVale, value: this.state.searchValue, placeholder: '\u8BF7\u8F93\u5165\u57FA\u91D1\u540D\u79F0\u6216\u4EE3\u7801', type: 'text' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { onClick: this.goBack },
              '\u53D6\u6D88'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          searchFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { overflow: "auto", overflowX: "hidden" } },
            searchSouse.map(function (item, i) {
              if (item.fundTypeName == '超级基金型') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                    _this.selectFund(item);
                  },
                  fundName: item.name,
                  valName: '近一年收益'
                  // val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                  , val: item.fundCode != 'SF1038' && item.fundCode != 'SF1060' && item.fundCode != 'SF1067' ? __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.yearsIncome[item.yearsIncome.length - 1] * 100, 2) + '%' : '--',
                  valDate: __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(item.currentNavDate).substr(-5),
                  rateName: '日涨跌幅',
                  rate: item.fundCode != 'SF1038' && item.fundCode != 'SF1060' && item.fundCode != 'SF1067' ? '' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(((item.yearsIncome[item.yearsIncome.length - 1] + 1) / (item.yearsIncome[item.yearsIncome.length - 1 - 1] + 1) - 1) * 100, 2) : '--'
                  // rate='--'
                });
              } else if (item.fundTypeName == '货币型' || item.fundTypeName == '理财型') {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                    _this.selectFund(item);
                  },
                  fundName: item.name,
                  valName: '万份收益',
                  val: __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.wanfenshouyi, 4),
                  valDate: __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(item.currentNavDate).substr(-5),
                  rateName: '七日年化',
                  rate: '' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.qirinianhua, 3)
                });
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                    _this.selectFund(item);
                  },
                  fundName: item.name,
                  valName: '最新净值',
                  val: __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.currentNav, 3),
                  valDate: __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(item.currentNavDate).substr(-5),
                  rateName: '日涨跌幅',
                  rate: '' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.zhangdiefu, 2)
                });
              }
            })
          ) : firstOpen ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Tabs"],
            { defaultActiveKey: '1', type: 'card', animated: false, onChange: callback },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              TabPane,
              { tab: ' ', key: '1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-content-box' },
                source0.map(function (item, i) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'planfund-info', key: 'invest' + i },
                    item.fundTypeName == '超级基金型' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                        _this.selectFund(item);
                      },
                      fundName: item.name,
                      valName: '近一年收益'
                      // val={Util.fomatFloat(item.yearsIncome[item.yearsIncome.length-1]*100,2)+'%'}
                      , val: item.fundCode != 'SF1038' && item.fundCode != 'SF1060' && item.fundCode != 'SF1067' ? __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.yearsIncome[item.yearsIncome.length - 1] * 100, 2) + '%' : '--',
                      valDate: __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(item.currentNavDate).substr(-5),
                      rateName: '日涨跌幅'
                      // rate={`${Util.fomatFloat((((item.yearsIncome[item.yearsIncome.length-1] + 1)/(item.yearsIncome[item.yearsIncome.length-1-1] + 1)) - 1)*100,2)}`}
                      , rate: item.fundCode != 'SF1038' && item.fundCode != 'SF1060' && item.fundCode != 'SF1067' ? '' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(((item.yearsIncome[item.yearsIncome.length - 1] + 1) / (item.yearsIncome[item.yearsIncome.length - 1 - 1] + 1) - 1) * 100, 2) : '--'
                    }) : item.fundTypeName == '货币型' || item.fundTypeName == '理财型' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                        _this.selectFund(item);
                      },
                      fundName: item.name,
                      valName: '万份收益',
                      val: __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.wanfenshouyi, 4),
                      valDate: __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(item.currentNavDate).substr(-5),
                      rateName: '七日年化',
                      rate: '' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.qirinianhua, 3)
                    }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                        _this.selectFund(item);
                      },
                      fundName: item.name,
                      valName: '最新净值',
                      val: __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.currentNav, 3),
                      valDate: __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(item.currentNavDate).substr(-5),
                      rateName: '日涨跌幅',
                      rate: '' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(item.zhangdiefu, 2)
                    })
                  );
                }),
                source0.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'plan-tip' },
                  '\u6CA1\u6709\u7B26\u5408\u6761\u4EF6\u7684\u4EA7\u54C1'
                ) : null
              )
            )
          )
        )
      );
    }
  }]);

  return InvestmentFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    inInvestmentFundList: state.InvestPlanReducer.inInvestmentFundList,
    fundPublicProductDetil: state.fundPublicProductDetil
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InvestmentFund));

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InvestmentPlan_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InvestmentPlan_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InvestmentPlan_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BankCode__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var InvestmentPlan = function (_Component) {
  _inherits(InvestmentPlan, _Component);

  function InvestmentPlan(props) {
    _classCallCheck(this, InvestmentPlan);

    var _this = _possibleConstructorReturn(this, (InvestmentPlan.__proto__ || Object.getPrototypeOf(InvestmentPlan)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(InvestmentPlan, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_myAssets_InvestPlanAction_js__["l" /* getInvestmentList */])());
      document.title = "定投计划";
      console.log(this.props.inInvestmentList);
    }
  }, {
    key: 'selectFund',
    value: function selectFund() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/InvestmentFund',
        state: {}
      });
    }
  }, {
    key: 'push',
    value: function push(item) {
      console.log(item);
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/InvestmentDetail',
        state: {
          planId: item.planId,
          name: item.fundName,
          code: item.fundCode,
          planItem: item
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      console.log(this.props.inInvestmentList);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5B9A\u6295\u8BA1\u5212'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content paddB40' },
          this.props.inInvestmentList.content.records.map(function (item, i) {
            var arr = ['', '', '一', '二', '三', '四', '五'];
            var str = '';
            if (item.periodType == '0') {
              str = '每月' + item.tradeDates[0] + '日';
            } else if (item.periodType == '1') {
              str = '每周周' + arr[item.tradeDates[0]];
            } else if (item.periodType == '3') {
              str = '每双周周' + arr[item.tradeDates[0]];
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-info', key: 'plan-info' + i, onClick: function onClick() {
                  return _this2.push(item);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-info-header' },
                item.type == '11' || item.type == '2' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'plan-info-header-left' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(429), style: { width: 24, height: 31, marginRight: 5, marginLeft: 5 } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    item.convertOutFundName,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { fontSize: 12, color: '#5b6370' } },
                      '(' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.trustChannelName) + ')'
                    )
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'plan-info-header-left' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39) }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    item.trustChannelName
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'plan-info-header-center' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'plan-info-header-center-top' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      null,
                      str
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'plan-info-header-center-bottom' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      null,
                      item.tradeAmount,
                      '\u5143'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'plan-info-header-right' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    item.fundName
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-info-footer' },
                '\u4E0B\u4E00\u6263\u6B3E\u65E5:',
                __WEBPACK_IMPORTED_MODULE_3__util___default.a.returnDate(item.nextTradeDate)
              )
            );
          }),
          this.props.inInvestmentList.content.records.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-tip' },
            '\u60A8\u8FD8\u6CA1\u6709\u521B\u5EFA\u8FC7\u5B9A\u6295\u8BA1\u5212\uFF0C\u70B9\u51FB\u5E95\u90E8\u6309\u94AE\u7ACB\u5373\u521B\u5EFA'
          ) : null
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn2', onClick: function onClick() {
              return _this2.selectFund();
            } },
          '\u65B0\u5EFA\u5B9A\u6295\u8BA1\u5212'
        )
      );
    }
  }]);

  return InvestmentPlan;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    inInvestmentList: state.InvestPlanReducer.inInvestmentList
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InvestmentPlan));

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvestmentPlan_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InvestmentPlan_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__InvestmentPlan_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var InvestmentRecord = function (_Component) {
  _inherits(InvestmentRecord, _Component);

  function InvestmentRecord(props) {
    _classCallCheck(this, InvestmentRecord);

    var _this = _possibleConstructorReturn(this, (InvestmentRecord.__proto__ || Object.getPrototypeOf(InvestmentRecord)).call(this, props));

    _this.state = {
      deals: []
    };
    return _this;
  }

  _createClass(InvestmentRecord, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "定投记录";
      var _props = this.props,
          dispatch = _props.dispatch,
          planId = _props.planId;

      var data = {
        planId: this.props.location.state.planId,
        pageIndex: 1,
        pageSize: 10000
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_myAssets_InvestPlanAction_js__["b" /* getInvestmentHistory */])(data, this.successCallback1.bind(this)));
    }
  }, {
    key: 'successCallback1',
    value: function successCallback1(result) {
      this.setState({
        deals: result
      });
    }
  }, {
    key: 'render',
    value: function render() {

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5B9A\u6295\u8BB0\u5F55'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content ' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-record-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-record-item' },
              '\u6263\u6B3E\u65E5\u671F'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-record-item' },
              '\u6263\u6B3E\u91D1\u989D ( \u5143 ) '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'plan-record-item' },
              '\u5F53\u65E5\u51C0\u503C ( \u5143 ) '
            )
          ),
          this.state.deals.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: i % 2 == 0 ? 'plan-record-wrad1' : 'plan-record-wrad2', key: 'k' + i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-record-item' },
                __WEBPACK_IMPORTED_MODULE_3__util___default.a.returnDate(item.tradeDate)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-record-item' },
                __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.tradeAmount) + '(' + item.capitalState + ')',
                '  '
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'plan-record-item' },
                __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.nav),
                ' '
              )
            );
          })
        )
      );
    }
  }]);

  return InvestmentRecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InvestmentRecord));

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReduxStore_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_myAssets_myCardAction__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_js__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import { findCamcHqtExist } from '../../../action/myAssets/userInfoAction'



var PayCard = function (_Component) {
  _inherits(PayCard, _Component);

  function PayCard(props) {
    var _this2 = this;

    _classCallCheck(this, PayCard);

    var _this = _possibleConstructorReturn(this, (PayCard.__proto__ || Object.getPrototypeOf(PayCard)).call(this, props));

    _this.toGetCardList = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_js__["b" /* getTempInfo */])('shortToken');

            case 2:
              _context.t0 = _context.sent;
              params = {
                token: _context.t0
              };

              __WEBPACK_IMPORTED_MODULE_8__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_myAssets_myCardAction__["a" /* getCardList */])(params, function (content) {
                console.log(content);
              }, function (msg) {
                console.log(msg);
              }));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = {};
    return _this;
  }

  _createClass(PayCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // let data = store.getState().verifiedUserInfo.content;
      // console.log(data)
      // let inParamsData = {
      //   certNo: data.certNo,
      //   certType: data.certType,
      //   name: data.name
      // }
      // store.dispatch(findCamcHqtExist(inParamsData))
      this.toGetCardList();
    }
  }, {
    key: 'choseBank',
    value: function choseBank() {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/PayCardList',
        state: {
          type: this.props.type,
          actionType: this.props.actionType,
          fundCode: this.props.superFundCode
        }
      });
    }
  }, {
    key: 'renderRecharge',
    value: function renderRecharge() {
      var _this3 = this;

      var payInfoData = this.props.payInfoData;

      if (payInfoData.currentType == 2)
        // if (false)
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'render_recharge' },
          payInfoData.currentType == 2 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this3.goHQT(payInfoData.content.shareList[payInfoData.currentIndex]);
              } },
            '\u5B58\u5165\u6D3B\u671F\u901A >'
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this3.goLQB(payInfoData.content.currencyFund[payInfoData.currentIndex]);
              } },
            '\u5B58\u5165\u96F6\u94B1\u5B9D >'
          )
        );else return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 10 } });
    }
  }, {
    key: 'goHQT',
    value: function goHQT(parmas) {
      var _props = this.props,
          navigator = _props.navigator,
          dispatch = _props.dispatch,
          fundCode = _props.fundCode;

      var data = {
        fundCode: '003003',
        businessType: 'T022',
        productType: 'G',
        type: this.props.type,
        bankAccountShowNo: parmas.bankAccountShowNo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getPay__["j" /* getPayAll */])(window.history.length, data, __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */], 'RechargeHqt');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var payInfoData = this.props.payInfoData;

      console.log(payInfoData);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        payInfoData.currentType == 1 && payInfoData.content.currentAccountList.length > 0 ? payInfoData.content.currentAccountList.map(function (item, i) {
          if (i == payInfoData.currentIndex) {
            if (item.disable) {
              if (item.paymentChannel == '888') {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: 'currentAccountList' + i, onClick: function onClick() {
                      return _this4.choseBank();
                    }, className: 'bankList' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(39), className: 'img' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'bankListTip' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      null,
                      '\u7406\u8D22\u4E2D\u5FC3'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      null,
                      '\u7406\u8D22\u4E2D\u5FC3POS\u673A\u5237\u5361'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'bankListRight' })
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { key: 'currentAccountList' + i, onClick: function onClick() {
                      return _this4.choseBank();
                    }, className: 'bankList' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), className: 'img' }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'bankListTip' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      null,
                      __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankName) + '(*' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'p',
                      null,
                      window.funSplit(item.tradeMaxAmountTips)[1]
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'bankListRight' })
                );
              }
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this4.choseBank();
                  }, style: { fontSize: 15, height: '1.7rem', backgroundColor: '#fefefe', textAlign: 'center', lineHeight: '1.7rem' } },
                '\u65E0\u652F\u4ED8\u65B9\u5F0F'
              );
            }
          }
        }) : payInfoData.currentType == 2 && payInfoData.content.shareList.length > 0 ? payInfoData.content.shareList.map(function (item, i) {
          if (i == payInfoData.currentIndex) {
            if (item.disable) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'shareList' + i, onClick: function onClick() {
                    return _this4.choseBank();
                  }, className: 'bankList' },
                item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(39), className: 'img' }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_7__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), className: 'img' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'bankListTip' },
                  item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(386), style: { width: 28, height: 20 } }),
                    '\u6D3B\u671F\u901A'
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(386), style: { width: 28, height: 20 } }),
                    __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.trustChannelName) + '(*' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                  ),
                  item.paymentChannel == "G000" && item.ywt == false ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    null,
                    '\u62DB\u884C\u5361\u6682\u4E0D\u53EF\u7528\uFF0C\u8BF7\u60A8\u53BB\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6App\u64CD\u4F5C\u6216\u54A8\u8BE2\u5BA2\u670D'
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    null,
                    '可用余额:' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(item.availableVolume),
                    '\u5143'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'bankListRight' })
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this4.choseBank();
                  }, style: { fontSize: 15, height: '1.7rem', backgroundColor: '#fefefe', textAlign: 'center', lineHeight: '1.7rem' } },
                '\u65E0\u652F\u4ED8\u65B9\u5F0F'
              );
            }
          }
        }) : payInfoData.currentType == 3 && payInfoData.content.currencyFund.length > 0 ? payInfoData.content.currencyFund.map(function (item, i) {
          if (i == payInfoData.currentIndex) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: 'currencyFund' + i, className: 'bankList', onClick: function onClick() {
                  return _this4.choseBank();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(271), style: { width: 36, height: 40 }, className: 'img' }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'bankListTip' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  item.fundName,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 12 } },
                    '(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.trustChannelName) + '*' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  null,
                  '可用余额:' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(item.availableVolume),
                  '\u5143'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'bankListRight' })
            );
          }
        }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              return _this4.choseBank();
            }, style: { fontSize: 15, height: '1.7rem', backgroundColor: '#fefefe', textAlign: 'center', lineHeight: '1.7rem' } },
          '\u65E0\u652F\u4ED8\u65B9\u5F0F'
        ),
        this.renderRecharge()
      );
    }
  }]);

  return PayCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(state, ownProps);
  return {
    payInfoData: state[ownProps.type + 'PayInfo']

  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(PayCard));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_array_tree_filter__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_array_tree_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_array_tree_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PayWarmTips__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pay_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Pay_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PayCard__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_publicAction__ = __webpack_require__(81);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { Picker,List} from 'antd-mobile/lib';












var Payment = function (_Component) {
  _inherits(Payment, _Component);

  function Payment(props) {
    _classCallCheck(this, Payment);

    var _this2 = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));

    _this2.state = {
      text: '',
      btnFlag: false,
      pwdFlag: false,
      keyPasswordVal: '',
      agreeIndex: 0
    };
    return _this2;
  }

  _createClass(Payment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      console.log(this.props.location.state);
      this.fetch();
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(text) {
      var _props = this.props,
          dispatch = _props.dispatch,
          payInfoData = _props.payInfoData,
          currentType = _props.currentType,
          currentIndex = _props.currentIndex;
      var _props$location$state = this.props.location.state,
          fundCode = _props$location$state.fundCode,
          productType = _props$location$state.productType,
          businessType = _props$location$state.businessType;

      var flag = __WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(text);
      this.setState({ text: text });
      if (!flag) {
        return;
      }
      if (payInfoData.content.currentAccountList.length == 0 && payInfoData.content.shareList.length == 0 && payInfoData.content.currencyFund.length == 0) {
        // let toast = Toast.show( '请选择支付方式', getToastConfPoint( ) );
        return false;
      }
      if (currentType == 1) {
        var _item = payInfoData.content.currentAccountList[currentIndex];
        var data = {
          trustChannelId: _item.paymentChannel,
          businessType: businessType,
          fundCode: fundCode,
          applicationAmount: text,
          payBuyHqt: false
        };
        var data2 = {
          trustChannelId: _item.paymentChannel,
          businessType: businessType,
          fundCode: fundCode,
          applicationAmount: 0,
          payBuyHqt: false
        };
        if (text.length == 0) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["V" /* getMoneyChange */])(data2));
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["V" /* getMoneyChange */])(data));
        }
      } else {
        if (currentType == 2) {
          if (payInfoData.content.shareList.length == 0) {
            return;
          }
          var item = payInfoData.content.shareList[currentIndex];
        } else {
          if (payInfoData.content.currencyFund.length == 0) {
            return;
          }
          var item = payInfoData.content.currencyFund[currentIndex];
        }
        var _data = {
          currentAccountId: item.currentAccountId,
          businessType: businessType,
          fundCode: fundCode,
          applicationAmount: text,
          payBuyHqt: true
        };
        var _data2 = {
          trustChannelId: item.currentAccountId,
          businessType: businessType,
          fundCode: fundCode,
          applicationAmount: 0,
          payBuyHqt: true
        };
        console.log(item, _data);
        if (text.length == 0) {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["V" /* getMoneyChange */])(_data2));
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["V" /* getMoneyChange */])(_data));
        }
      }
    }
  }, {
    key: 'next',
    value: function next() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          payInfoData = _props2.payInfoData,
          currentType = _props2.currentType,
          currentIndex = _props2.currentIndex;
      var text = this.state.text;

      if (!__WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(this.state.text)) {
        __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].info('请输入正确格式的金额', 2);
        return;
      }
      if (payInfoData.content.minAmount > this.state.text) {
        __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].info('投资金额不可低于' + payInfoData.content.minAmount + '元', 2);
        return;
      }
      if (currentType == 1) {
        var item = payInfoData.content.currentAccountList[currentIndex];
        if (item.tradeMaxAmountTips.split('|')[0] - 0 < text) {
          __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].info(item.tradeMaxAmountTips.split('|')[1], 2);
          return false;
        }
      } else if (currentType == 2) {
        var _item2 = payInfoData.content.shareList[currentIndex];
        if (_item2.availableVolume < text) {
          __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].info('金额不可超过活期通余额', 2);
          return false;
        }
      }
      this.setState({
        pwdFlag: true
      });
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _props$location$state2 = this.props.location.state,
          fundCode = _props$location$state2.fundCode,
          businessType = _props$location$state2.businessType,
          productType = _props$location$state2.productType;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["I" /* getTradeInfo */])(fundCode, businessType, productType));
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        keyPasswordVal: val
      });
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var agreeIndex = this.state.agreeIndex;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
      } else {
        this.setState({
          agreeIndex: 0
        });
      }
    }
  }, {
    key: 'keyOk',
    value: function keyOk() {
      var _props3 = this.props,
          navigator = _props3.navigator,
          payInfoData = _props3.payInfoData,
          dispatch = _props3.dispatch,
          currentType = _props3.currentType,
          currentIndex = _props3.currentIndex;
      var _props$location$state3 = this.props.location.state,
          fundCode = _props$location$state3.fundCode,
          businessType = _props$location$state3.businessType,
          fundName = _props$location$state3.fundName;

      var _this = this;
      var _state = this.state,
          text = _state.text,
          keyPasswordVal = _state.keyPasswordVal;

      console.log(keyPasswordVal, '1111111111111111');
      var pushResult = function pushResult(i, result) {
        if (i == 1) {
          var content = result.content.isCounterChannel ? '申请已提交，请您到理财中心POS或转账完成交易。' : '支付成功';
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].replace({
            pathname: '/Success',
            state: {
              title: '支付完成',
              content: content,
              dataSouse: result.content.isCounterChannel ? [['申请编号', result.content.requestId], ['产品名称', fundName], ['投资金额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(text) + '元'], ['账户户名', '上海华夏财富投资管理有限公司'], ['账户账号', '605005576'], ['开户行全称', '中国民生银行北京木樨地支行'], ['大额行号', '305100001016']] : [['申请编号', result.content.requestId], ['产品名称', fundName], ['投资金额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(text) + '元']],
              souseVal: ['完成']
            }
          });
        } else if (i == 3) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].replace({
            pathname: '/ErrorResult',
            state: {
              title: '支付完成',
              content: '很抱歉，您的这笔交易支付失败',
              dataSouse: [],
              souseVal: ['完成', '联系客服']
            }
          });
        }
      };
      if (currentType == 1) {
        var item = payInfoData.content.currentAccountList[currentIndex];
        console.log('银行卡交易' + currentIndex, item);
        var data = {
          applicationAmount: text - 0,
          businessType: businessType,
          fundCode: fundCode,
          payByHqt: false,
          bankAccountShowNo: item.bankAccountShowNo,
          password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(keyPasswordVal),
          paymentAccountId: item.paymentAccountId

        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["W" /* getTransaction */])(data, pushResult));
      } else if (currentType == 2) {
        var _item3 = payInfoData.content.shareList[currentIndex];
        console.log('活期通' + currentIndex, _item3);
        var _data3 = {
          applicationAmount: text - 0,
          businessType: businessType,
          fundCode: fundCode,
          payByHqt: true,
          paymentChannelId: _item3.paymentChannel,
          password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(keyPasswordVal),
          bankCode: _item3.bankCode
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["W" /* getTransaction */])(_data3, pushResult));
      } else if (currentType == 3) {
        var _item4 = payInfoData.content.currencyFund[currentIndex];
        var _data4 = {
          amount: text - 0,
          clientIp: '127.0.0.1',
          largeRedemptionFlag: '1',
          sourceFundCode: _item4.fundCode,
          targetFundCode: fundCode,
          trustChannelId: _item4.trustChannelId,
          password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(keyPasswordVal),
          bankAccountShowNo: _item4.bankAccountShowNo
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["X" /* monetaryFundBuyValidate */])(_data4, pushResult));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      var _props$location$state4 = this.props.location.state,
          fundName = _props$location$state4.fundName,
          fundCode = _props$location$state4.fundCode,
          fundType = _props$location$state4.fundType,
          wanfenshouyi = _props$location$state4.wanfenshouyi,
          currentNavDate = _props$location$state4.currentNavDate,
          currentNav = _props$location$state4.currentNav,
          businessType = _props$location$state4.businessType;
      var _props4 = this.props,
          payInfoData = _props4.payInfoData,
          rateAndFeeDate = _props4.rateAndFeeDate;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5728\u7EBF\u652F\u4ED8'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fixed-invest-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fixed-invest-header-top' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'fixed-invest-header-top-name' },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(fundName) + '(' + fundCode + ')'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'fixed-invest-header-top-type' },
                businessType == 'T022' ? '申购' : businessType == 'T020' ? '认购' : ''
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fixed-invest-header-bottom' },
              businessType == 'T020' ? '\u6700\u65B0\u51C0\u503C \uFF1A1.000\u5143' : fundType == '理财型' || fundType == '货币型' ? '\u4E07\u4EFD\u6536\u76CA \uFF1A' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(__WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(wanfenshouyi), 4) + '(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(payInfoData.content.currentNavDate) + ')' : '\u6700\u65B0\u51C0\u503C \uFF1A' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(__WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(payInfoData.content.currentNav), 3) + '(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(payInfoData.content.currentNavDate) + ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'share' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'shareTitle' },
              '\u8BF7\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PayCard__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'input' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u6295\u8D44\u91D1\u989D'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                return _this3.onChangeText(e.target.value);
              }, type: 'text', placeholder: '最低投资金额' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(payInfoData.content.minAmount) + '元' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pay-agree' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: img_arr[this.state.agreeIndex], className: 'imgBtn', onClick: function onClick() {
                return _this3.isAgreeClick();
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u5DF2\u9605\u8BFB\u7279\u522B\u63D0\u793A\u5185\u5BB9'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pay-fee' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u8D39\u7387\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'red-t' },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate) == '0.00' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate) == '0.00%' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate) == '0%' ? '0%' : __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u9884\u8BA1\u8D39\u7528\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'red-t' },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee) == '0.00' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee) == '0.00%' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee) == '0%' ? '0元' : __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(this.state.text) && this.state.agreeIndex == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this3.next();
              }, className: 'btn' },
            '\u786E\u8BA4\u4E70\u5165'
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray' },
            '\u786E\u8BA4\u4E70\u5165'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 40 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PayWarmTips__["a" /* default */], { fundLimit: this.props.location.state.fundCode })
          )
        ),
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', top: 0, width: '100%', height: '100%', background: 'rgba(52,52,52,0.4)' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'fixed', bottom: 0, width: '100%', height: '70%', background: '#fff' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'relative', height: '45px', lineHeight: '45px', textAlign: 'center', borderBottom: '0.005rem solid rgb(224,227,279)', fontSize: '0.3rem' } },
              '\u4EA4\u6613\u5BC6\u7801',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), style: { position: 'absolute', left: 0, width: '0.88rem', height: '0.88rem' }, onClick: function onClick() {
                  _this3.setState({ pwdFlag: false });
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { position: 'absolute', top: 0, right: 0, width: '45px', fontSize: '13px' }, className: 'red-t', onClick: function onClick() {
                    _this3.keyOk();
                  } },
                ' \u786E\u8BA4'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '0.3rem 0.3rem 0rem 0.3rem', fontSize: '13px' } },
              this.props.location.state.fundRisk ? '温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。' : ''
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '45px', padding: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                  return _this3.onChangePwd(e.target.value);
                }, autofocus: 'autofocus', style: { height: '45px', width: '100%', fontSize: '0.3rem', border: '1px solid #afafaf', borderRadius: '0.1rem' }, type: 'password', placeholder: '' })
            )
          )
        ) : null
      );
    }
  }]);

  return Payment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    payInfoData: state.payInfo,
    rateAndFeeDate: state.rateAndFee,
    currentType: state.currentType,
    currentIndex: state.currentIndex
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Payment));

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












function MyBody(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'am-list-body my-body' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: { display: 'none' } },
      'you can custom body wrap element'
    ),
    props.children
  );
}

var productType = [{
  label: '全部类型',
  value: '',
  key: 1
}, {
  label: '赎回转申购',
  value: 'T822',
  key: 2
}, {
  label: '申购',
  value: 'T022',
  key: 3
}, {
  label: '赎回',
  value: 'T024',
  key: 4
}, {
  label: '设置分红方式',
  value: 'T029',
  key: 5
}, {
  label: '基金转换',
  value: 'T036',
  key: 6
}, {
  label: '定期定额申购',
  value: 'T039',
  key: 7
}, {
  label: '定期定额申购协议',
  value: 'E201',
  key: 8
}, {
  label: '定期定额申购修改',
  value: 'E202',
  key: 9
}, {
  label: '定期定额申购取消',
  value: 'E203',
  key: 10
}, {
  label: '定期定额基金转换协议',
  value: 'E204',
  key: 11
}, {
  label: '定期定额基金转换修改',
  value: 'E205',
  key: 12
}, {
  label: '定期定额基金转换取消',
  value: 'E206',
  key: 13
}, {
  label: '预约赎回协议',
  value: 'E207',
  key: 14
}, {
  label: '预约赎回取消',
  value: 'E208',
  key: 15
}, {
  label: '赎回转认购',
  value: 'T220',
  key: 26
}, {
  label: '定期赎回转申购协议',
  value: 'E224',
  key: 16
}, {
  label: '定期赎回转申购修改',
  value: 'E225',
  key: 17
}, {
  label: '定期赎回转申购取消',
  value: 'E226',
  key: 18
}, {
  label: '活期通认购',
  value: 'T420',
  key: 19
}, {
  label: '活期通申购',
  value: 'T422',
  key: 20
}, {
  label: '超级基金调仓',
  value: 'T999',
  key: 21
}, {
  label: '超级基金银行卡申购',
  value: 'T522',
  key: 22
}, {
  label: '定期外部赎回转申购协议',
  value: 'E227',
  key: 23
}, {
  label: '定期外部赎回转申购修改',
  value: 'E228',
  key: 24
}, {
  label: '定期外部赎回转申购取消',
  value: 'E229',
  key: 25
}, {
  label: '智投管理费扣除',
  value: 'TC24',
  key: 26
}];
var ua = navigator.userAgent.toLowerCase();

var objArr;

/*产品交易记录*/

var TransactionRecordProduct = function (_Component) {
  _inherits(TransactionRecordProduct, _Component);

  function TransactionRecordProduct(props) {
    _classCallCheck(this, TransactionRecordProduct);

    var _this2 = _possibleConstructorReturn(this, (TransactionRecordProduct.__proto__ || Object.getPrototypeOf(TransactionRecordProduct)).call(this, props));

    _this2.onEndReached = function (event) {
      var _this = _this2;
      // load new data
      // hasMore: from backend data, indicates whether it is the last page, here is false
      if (_this2.state.isLoading && !_this2.state.hasMore) {
        return;
      }
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      console.log('reach end', event);

      _this2.setState({ isLoading: true });

      var dispatch = _this2.props.dispatch;

      var dataArr = [];
      var totalDataArr = [];

      // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
      var data = {
        pageIndex: _this2.state.pageIndex,
        pageSize: _this2.state.pageSize,
        businessType: _this2.state.businessType,
        fundCode: _this2.state.fundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["m" /* getTransformationHistory */])(data, _this2.callbackData.bind(_this2), _this));
    };

    var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
        return r1 !== r2;
      } });
    _this2.state = {
      isLoading: true,
      dataSource: ds.cloneWithRows([]),
      height: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? window.winHeight : window.winHeight - 88,
      businessType: "",
      fundCode: "",
      modalFlag: false,
      sValue: [""],
      productType: [""],
      superHome: null,
      allFundList: null,
      HomeFlag: false,
      FundListFlag: false,
      pageIndex: 1,
      pageSize: 30,
      totalDataArr: []
    };
    return _this2;
  }

  _createClass(TransactionRecordProduct, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      var dispatch = this.props.dispatch;
      // const hei = window.winHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
      var hei = window.winHeight - 88;
      // simulate initial Ajax
      // setTimeout(() => {
      //   this.setState({
      //     dataSource: ds.cloneWithRows([]),
      //     //dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
      //     isLoading: false,
      //     height: hei,
      //   });
      // }, 600);
      var data = {
        pageIndex: this.state.pageIndex,
        pageSize: this.state.pageSize,
        businessType: this.state.businessType,
        fundCode: this.state.fundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["m" /* getTransformationHistory */])(data, this.callbackData.bind(this), this));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      objArr = [];

      var dispatch = this.props.dispatch;

      var that = this;
      var data = {
        superFundCode: "",
        pageIndex: 1,
        pageSize: 99
      };
      document.getElementsByTagName('title')[0].innerHTML = "交易记录";
      //dispatch(getTransformationHistory(data,this.callbackData.bind(this),that))
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {
        console.log(data.singleSuperFundViews, "datadatadata", data);
        //let superHome = data ? ( data.singleSuperFundViews ? data.singleSuperFundViews : []) : null
        _this3.setState({
          superHome: data,
          HomeFlag: true
        });
      }, this));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["g" /* getHistoryFundCodeAndName */])({}, this, function (data) {
        _this3.setState({
          allFundList: data,
          FundListFlag: true
        });
      }));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      var totalDataArr = this.state.totalDataArr.concat(data.records);
      this.state.loadingFlag ? this.setState({ loadingFlag: false }) : null;
      if (data.records.length !== 0) {
        var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
            return r1 !== r2;
          } });
        if (data.records.length < this.state.pageSize) {
          this.setState({
            isLoading: 0,
            dataSource: ds.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            pageIndex: this.state.pageIndex + 1,
            handleFlag: false
          });
        } else {
          this.setState({
            isLoading: false,
            pageIndex: this.state.pageIndex + 1,
            dataSource: ds.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            handleFlag: false
          });
        }
      } else {
        this.setState({
          isLoading: 0
        });
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].go(-1);
    }
  }, {
    key: 'goTransactionDetail',
    value: function goTransactionDetail(item) {
      var data = {
        businessType: item.businessType,
        tradeRequestId: item.tradeRequestId
      };
      if (item.businessType == "TC24") {
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: '/Servicechargerecord',
          state: {
            businessType: item.businessType,
            tradeRequestId: item.tradeRequestId
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: '/TransactionDetail',
          state: {
            data: data
          }
        });
      }
    }
  }, {
    key: 'productTypeCallback',
    value: function productTypeCallback(e) {
      var fundCode = e[0];
      var _this = this;
      var dispatch = this.props.dispatch;

      var flag = void 0;
      if (this.state.totalDataArr.length !== 0) {
        flag = true;
      } else {
        flag = false;
      }
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      this.setState({
        productAll: false,
        fundCode: fundCode,
        sValue: e,
        pageIndex: 1,
        pageSize: 30,
        dataSource: ds.cloneWithRows([]),
        totalDataArr: [],
        loadingFlag: flag,
        handleFlag: true
      });
      var data = {};
      if (fundCode == "" && this.state.businessType == "") {
        data = {
          pageIndex: 1,
          pageSize: 30
        };
      } else if (fundCode == "") {
        data = {
          pageIndex: 1,
          pageSize: 30,
          businessType: this.state.businessType
        };
      } else if (this.state.businessType == "") {
        data = {
          pageIndex: 1,
          pageSize: 30,
          fundCode: fundCode
        };
      } else {
        data = {
          pageIndex: 1,
          pageSize: 30,
          businessType: this.state.businessType,
          fundCode: fundCode
        };
      }
      console.log(data);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["m" /* getTransformationHistory */])(data, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'confirmTypeCallback',
    value: function confirmTypeCallback(e) {
      var businessType = e[0];
      var _this = this;
      var flag = void 0;
      if (this.state.totalDataArr.length !== 0) {
        flag = true;
      } else {
        flag = false;
      }

      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      var dispatch = this.props.dispatch;

      this.setState({
        transactionAll: false,
        businessType: businessType,
        productType: e,
        pageIndex: 1,
        pageSize: 30,
        dataSource: ds.cloneWithRows([]),
        totalDataArr: [],
        loadingFlag: flag,
        handleFlag: true
      });

      var data = {};
      if (businessType === "" && this.state.fundCode === "") {
        data = {
          pageIndex: 1,
          pageSize: 30
        };
      } else if (businessType === "") {
        data = {
          pageIndex: 1,
          pageSize: 30,
          fundCode: this.state.fundCode
        };
      } else if (this.state.fundCode === "") {
        data = {
          pageIndex: 1,
          pageSize: 30,
          businessType: businessType
        };
      } else {
        data = {
          pageIndex: 1,
          pageSize: 30,
          fundCode: this.state.fundCode,
          businessType: businessType
        };
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["m" /* getTransformationHistory */])(data, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'onOk',
    value: function onOk(e) {
      var dispatch = this.props.dispatch;

      this.setState({ sValue: e });
      var data = {
        superFundCode: e[0],
        pageIndex: 1,
        pageSize: 30
      };
      if (e[0] === "0000") {
        data.superFundCode = "";
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["m" /* getTransformationHistory */])(data, this.callbackData.bind(this), this));
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      console.log("有无加载", this.state.isLoading);
      if (this.state.isLoading === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u6B63\u5728\u52A0\u8F7D...'
        );
      } else if (this.state.isLoading === false) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u52A0\u8F7D\u5B8C\u6210'
        );
      } else if (this.state.isLoading === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u6CA1\u6709\u66F4\u591A\u6570\u636E\u4E86'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          superHome = _state.superHome,
          allFundList = _state.allFundList;

      var data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
      var tempData = [{ businessTime: "0000" }];
      tempData = tempData.concat(data);
      var seasons = [{
        label: '全部产品',
        value: '',
        key: 0
      }];
      superHome && allFundList ? superHome.singleSuperFundViews ? superHome.singleSuperFundViews.map(function (itme, i) {
        seasons.push({
          label: itme.superFundName,
          value: itme.superFundCode,
          key: i + 1
        });
      }) : null : null;

      superHome && allFundList ? allFundList.map(function (itme, i) {
        seasons.push({
          label: itme.fundName,
          value: itme.fundCode,
          key: i + 1
        });
      }) : null;

      var separator = function separator(sectionID, rowID) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          key: sectionID + '-' + rowID,
          style: {
            backgroundColor: '#F5F5F9',
            height: 8
          }
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this4.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u4EA4\u6613\u8BB0\u5F55'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '0.26rem' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'chooseSelects_Wrap', style: { display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: ua.indexOf("amcfmapp") > -1 ? "chooseSelect_Wrap chooseSelect_Wrap2" : "chooseSelect_Wrap", style: { position: 'relative', background: "#000", WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: productType, cols: 1, className: 'forss', title: '\u4EA4\u6613', value: this.state.productType, onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    _this4.confirmTypeCallback(e);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item, null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rightBottomArrow', style: { position: 'absolute', right: '0.36rem', top: "50%", zIndex: 2 } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: ua.indexOf("amcfmapp") > -1 ? "chooseSelect_Wrap chooseSelect_Wrap2" : "chooseSelect_Wrap", style: { position: 'relative', background: "#000", WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: seasons, cols: 1, className: 'forss', title: '\u4EA7\u54C1', value: this.state.sValue, onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    _this4.productTypeCallback(e);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item, null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rightBottomArrow', style: { position: 'absolute', right: '0.36rem', top: "50%", zIndex: 2 } })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ListViewWrap ListHistory_Con' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"], {
              ref: function ref(el) {
                return _this4.lv = el;
              },
              dataSource: this.state.dataSource,
              renderFooter: function renderFooter() {
                return _this4.renderFooter();
              },
              renderBodyComponent: function renderBodyComponent() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyBody, null);
              },
              renderRow: function renderRow(rowData, sectionID, rowID) {
                objArr = [{ createDate: "" }].concat(_this4.state.totalDataArr);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.returnDate(rowData.businessTime, "M") == __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.returnDate(objArr[rowID].businessTime, "M") ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 22, paddingBottom: 12, fontSize: "20px" } },
                    __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.returnDate(rowData.businessTime, "M")
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'superListJ', onClick: function onClick() {
                        return _this4.goTransactionDetail(rowData);
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { borderBottom: '1px solid #f2f4f7' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { color: '#fa063a' } },
                        rowData.businessTypeName
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        rowData.fundName
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        ' ',
                        getNum(rowData.applicationAmount, rowData.applicationVolume),
                        ' '
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        rowData.businessStateName
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        ' ',
                        __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.returnDate(rowData.businessTime)
                      )
                    )
                  )
                );
              },

              style: {
                height: this.state.height,
                overflow: 'auto'
              },
              pageSize: 4,
              onScroll: function onScroll() {
                console.log('scroll');
              },
              scrollRenderAheadDistance: 500,
              onEndReached: this.onEndReached,
              onEndReachedThreshold: 15
            })
          )
        )
      );
    }
  }]);

  return TransactionRecordProduct;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransactionRecordProduct));

function getNum(num1, num2) {
  if ((num1 === "" || num1 === null || num1 === undefined) && (num2 === "" || num2 === null || num2 === undefined)) {
    return "--";
  }
  if (num1 === "" || num1 === null || num1 === undefined) {
    return num2 + '份';
  }
  if (num2 === "" || num2 === null || num2 === undefined) {
    return num1 + '元';
  }
  if (num1 === 0) {
    return num2 + '份';
  }
  if (num2 === 0) {
    return num1 + '元';
  }
  if (num1 === num2) {
    return num1 + '元';
  }
}

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsultationDetails; });
/* unused harmony export ContainBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_productAction_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js__ = __webpack_require__(13);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ConsultationDetails = function (_PureComponent) {
	_inherits(ConsultationDetails, _PureComponent);

	function ConsultationDetails() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ConsultationDetails);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConsultationDetails.__proto__ || Object.getPrototypeOf(ConsultationDetails)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			isLogin: false,
			articleLike: false,
			message: "",
			likeCount: 0,
			pageNum: 1,
			pageSize: 50,
			isMoreMessage: false,
			allSource: []
		}, _this.GetQueryString = function (name) {
			var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			if (window.location.href.indexOf("?") != -1) {
				var _r = "?" + window.location.href.split("?")[window.location.href.split("?").length - 1];
				var r = _r.substr(1).match(reg);
				if (r != null) return unescape(r[2]);return "";
			} else {
				return "";
			}
		}, _this.ckArticle = function () {
			var dispatch = _this.props.dispatch;

			_this.setState({
				articleLike: !_this.state.articleLike,
				likeCount: !_this.state.articleLike ? _this.state.likeCount - 0 + 1 : _this.state.likeCount - 1
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["a" /* editLikeArticle */])({ articleId: _this.GetQueryString("articleId") }));
		}, _this.theTrim = function (str) {
			return str.replace(/(^\s*)|(\s*$)/g, "");
		}, _this.subArticleMessage = function () {
			var dispatch = _this.props.dispatch;
			var message = _this.state.message;

			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["b" /* writeArticleMessage */])({ articleId: _this.GetQueryString("articleId"), token: _this.GetQueryString("token"), content: message }, function (data) {
				_this.setState({
					message: ""
				});
				__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info("提交成功,请耐心等待审核", 2);
			}));
		}, _this.writeMessage = function (event) {
			_this.setState({
				message: event.target.value
			});
		}, _this.showMore = function () {
			var dispatch = _this.props.dispatch;
			var _this$state = _this.state,
			    pageNum = _this$state.pageNum,
			    pageSize = _this$state.pageSize,
			    allSource = _this$state.allSource;

			__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].loading();
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["c" /* getArticleMessageList */])({ articleId: _this.GetQueryString("articleId"), token: _this.GetQueryString("token"), pageNum: pageNum - 0 + 1, pageSize: pageSize }, function (data) {
				if (data.articleCommentResponses.length > 0) {
					_this.setState({
						allSource: allSource.concat(data.articleCommentResponses),
						pageNum: pageNum - 0 + 1,
						pageSize: pageSize,
						isMoreMessage: true
					});
					__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
				} else {
					__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
					__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info("留言已全部加载", 2);
					_this.setState({
						isMoreMessage: false
					});
				}
			}));
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ConsultationDetails, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var dispatch = this.props.dispatch;
			var _state = this.state,
			    pageNum = _state.pageNum,
			    pageSize = _state.pageSize;

			if (this.GetQueryString("articleId")) {
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["d" /* articleDetail */])(null));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["e" /* articleMessageList */])([]));
				if (this.GetQueryString("token")) {
					var TM = new Date();
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["a" /* setStorage */])('tokenTimeshort', TM.getTime() + window.tokenTimeshort);
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["a" /* setStorage */])('loginInfo-shortToken', this.GetQueryString("token"));
					this.setState({
						isLogin: true
					});
				} else {
					this.setState({
						isLogin: false
					});
				}
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["f" /* getArticleDetail */])({ articleId: this.GetQueryString("articleId"), token: this.GetQueryString("token") }, function (data) {
					_this2.setState({
						articleLike: data.hasLikeArticle,
						likeCount: data.likeCount ? data.likeCount : 0
					});
				}));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["c" /* getArticleMessageList */])({ articleId: this.GetQueryString("articleId"), token: this.GetQueryString("token"), pageNum: pageNum, pageSize: pageSize }, function (data) {
					if (data.commentCount > pageSize) {
						_this2.setState({
							isMoreMessage: true
						});
					}
					_this2.setState({
						allSource: [].concat(data.articleCommentResponses)
					});
				}));
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var articleDetail = this.props.articleDetail;
			var _state2 = this.state,
			    isLogin = _state2.isLogin,
			    articleLike = _state2.articleLike,
			    message = _state2.message,
			    likeCount = _state2.likeCount,
			    isMoreMessage = _state2.isMoreMessage,
			    allSource = _state2.allSource;

			var title = void 0,
			    source = void 0,
			    createTime = void 0,
			    content = void 0,
			    pageView = void 0,
			    tagName = void 0;
			if (articleDetail) {
				title = articleDetail.title ? articleDetail.title : "--";
				source = articleDetail.source ? articleDetail.source : "--";
				if (articleDetail.createTime) {
					if (((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600).toFixed(0) > 24) {
						createTime = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.returnDate(articleDetail.createTime);
					} else {
						if ((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600 < 1) {
							createTime = ((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600 * 60).toFixed(0) + "分钟前";
						} else {
							createTime = ((new Date().getTime() - new Date(articleDetail.createTime).getTime()) / 1000 / 3600).toFixed(0) + "小时前";
						}
					}
				} else {
					createTime = "--";
				}
				content = articleDetail.content ? articleDetail.content : "";
				pageView = articleDetail.pageView ? articleDetail.pageView - 0 + 1 : 0;
				tagName = articleDetail.tagName ? articleDetail.tagName : "--";
				content = content.replace(/xmwebp/g, "xmorient");
			}
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ style: { overflow: "hidden", width: document.documentElement.clientWidth, minHeight: document.documentElement.clientHeight } },
				articleDetail ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { WebkitFlex: 1, paddingBottom: isLogin ? 63 : 13 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { background: "#fff", padding: 13 } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { fontSize: 20, fontWeight: "bold", color: "#3a3e47" } },
								title
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", fontSize: 12, paddingTop: 15, color: "#5b6370" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									null,
									tagName,
									' | ',
									createTime
								),
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									null,
									'\u6765\u6E90: ',
									source
								)
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { paddingTop: 15 }, dangerouslySetInnerHTML: { __html: content } }),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", fontSize: 12, paddingTop: 15, color: "#5b6370" } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									null,
									'\u6D4F\u89C8',
									pageView
								),
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									{ onClick: isLogin ? this.ckArticle : null },
									articleLike ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(383), style: { width: 13, height: 13, marginRight: 2 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(382), style: { width: 13, height: 13, marginRight: 2 } }),
									likeCount
								)
							)
						),
						allSource.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { background: "#fff", marginTop: 15, padding: 13 } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { paddingBottom: 10, color: "#3a3e47" } },
								'\u7CBE\u9009\u7559\u8A00'
							),
							allSource.map(function (data, index) {
								return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainBox, { mobileNo: _this3.GetQueryString("mobileNo"), articleId: _this3.GetQueryString("articleId"), isLogin: isLogin, dataSource: data, key: index });
							}),
							isMoreMessage ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ onClick: this.showMore, style: { height: 30, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", marginTop: 10 } },
								'\u52A0\u8F7D\u66F4\u591A'
							) : null
						) : null
					),
					isLogin ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { height: 50, background: "#f5f5f9", padding: 8, position: "fixed", bottom: 0, width: "100%", display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: { WebkitFlex: 1, height: "100%", paddingLeft: 15 }, value: message, onChange: this.writeMessage, placeholder: '\u7559\u8A00\u5C06\u7531\u5E73\u53F0\u7B5B\u9009\u540E\u663E\u793A' }),
						message && this.theTrim(message) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ onClick: this.subArticleMessage, style: { width: 60, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", background: "#fff", height: "100%" } },
							'\u63D0\u4EA4'
						) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ onClick: function onClick() {}, style: { width: 60, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", background: "#fff", height: "100%", color: "gray" } },
							'\u63D0\u4EA4'
						)
					) : null
				) : null
			);
		}
	}]);

	return ConsultationDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ConsultationDetails = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ConsultationDetails);

var ContainBox = function (_PureComponent2) {
	_inherits(ContainBox, _PureComponent2);

	function ContainBox() {
		var _ref2;

		var _temp2, _this4, _ret2;

		_classCallCheck(this, ContainBox);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, (_ref2 = ContainBox.__proto__ || Object.getPrototypeOf(ContainBox)).call.apply(_ref2, [this].concat(args))), _this4), _this4.state = {
			messageLike: _this4.props.dataSource.hasLikeComment,
			likeCount: _this4.props.dataSource.likeCount ? _this4.props.dataSource.likeCount : 0
		}, _this4.ckArticle = function () {
			var _this4$props = _this4.props,
			    dispatch = _this4$props.dispatch,
			    dataSource = _this4$props.dataSource;

			_this4.setState({
				messageLike: !_this4.state.messageLike,
				likeCount: !_this4.state.messageLike ? _this4.state.likeCount - 0 + 1 : _this4.state.likeCount - 1
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_productAction_js__["g" /* editLikeMessage */])({ commentId: dataSource.commentId }));
		}, _temp2), _possibleConstructorReturn(_this4, _ret2);
	}

	_createClass(ContainBox, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    isLogin = _props.isLogin,
			    dataSource = _props.dataSource,
			    mobileNo = _props.mobileNo;
			var _state3 = this.state,
			    messageLike = _state3.messageLike,
			    likeCount = _state3.likeCount;

			var content = dataSource.content ? dataSource.content : "";
			var newPhone = "";
			if (mobileNo) {
				for (var i = 0; i < mobileNo.length - 7; i++) {
					newPhone += "*";
				}
				newPhone = mobileNo.substr(0, 3) + "" + newPhone + "" + mobileNo.substr(3 + newPhone.length, mobileNo.length - 3 - newPhone.length);
			} else {
				newPhone = "注册用户";
			}
			var userName = dataSource.userName ? dataSource.userName : newPhone;
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "flex-start", marginTop: 10 } },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ style: { width: 40 } },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { width: 25, height: 25, overflow: "hidden", borderRadius: 25 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(642), style: { width: "100%", height: "100%" } })
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ style: { borderBottom: "1px solid #f5f5f9", WebkitFlex: 1, paddingBottom: 10 } },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", fontSize: 13 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: 13, color: "#3a3e47", fontWeight: "bold" } },
							userName
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ onClick: isLogin ? this.ckArticle : null },
							messageLike ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(383), style: { width: 13, height: 13, marginRight: 2 } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(382), style: { width: 13, height: 13, marginRight: 2 } }),
							likeCount
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingTop: 5, wordBreak: "break-all", color: "#5b6370", fontSize: 15 } },
						content
					)
				)
			);
		}
	}]);

	return ContainBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ContainBox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ContainBox);

function mapStateToProps(state, ownProps) {
	return {
		articleDetail: state.articleDetail
	};
}

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export lineOption */
/* unused harmony export lineOptionL */
/* unused harmony export lineOptionW */
/* unused harmony export lineOptionQ */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_ModalSelect__ = __webpack_require__(67);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';

var historyD = { "code": "0000", "message": null, "content": { "HistoryRate": [{ "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "164347", "fund_id": "3924", "publish_date": "2016-12-16", "value_134": "1.002", "value_124": "316568403.07", "value_134_2": "1.002", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": null, "id": "0", "value_zdfpct": null }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "164936", "fund_id": "3924", "publish_date": "2016-12-23", "value_134": "1.001", "value_124": "316260560.09", "value_134_2": "1.001", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "165703", "fund_id": "3924", "publish_date": "2016-12-30", "value_134": "0.999", "value_124": "315733128.13", "value_134_2": "0.999", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "165612", "fund_id": "3924", "publish_date": "2016-12-31", "value_134": "0.999", "value_124": "315726376.30", "value_134_2": "0.999", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "166151", "fund_id": "3924", "publish_date": "2017-01-06", "value_134": "0.993", "value_124": "313690601.59", "value_134_2": "0.993", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.60", "id": "0", "value_zdfpct": "-0.60" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "166905", "fund_id": "3924", "publish_date": "2017-01-13", "value_134": "0.993", "value_124": "313748727.77", "value_134_2": "0.993", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "167659", "fund_id": "3924", "publish_date": "2017-01-20", "value_134": "0.992", "value_124": "313503582.31", "value_134_2": "0.992", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "167902", "fund_id": "3924", "publish_date": "2017-01-24", "value_134": "0.990", "value_124": null, "value_134_2": "0.990", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "167965", "fund_id": "3924", "publish_date": "2017-01-25", "value_134": "0.992", "value_124": null, "value_134_2": "0.992", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "168173", "fund_id": "3924", "publish_date": "2017-01-26", "value_134": "0.993", "value_124": null, "value_134_2": "0.993", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.10", "id": "0", "value_zdfpct": "0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "168325", "fund_id": "3924", "publish_date": "2017-02-03", "value_134": "0.993", "value_124": null, "value_134_2": "0.993", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "168560", "fund_id": "3924", "publish_date": "2017-02-06", "value_134": "0.995", "value_124": null, "value_134_2": "0.995", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "168679", "fund_id": "3924", "publish_date": "2017-02-07", "value_134": "0.996", "value_124": null, "value_134_2": "0.996", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.10", "id": "0", "value_zdfpct": "0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "168751", "fund_id": "3924", "publish_date": "2017-02-08", "value_134": "1.000", "value_124": null, "value_134_2": "1.000", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.40", "id": "0", "value_zdfpct": "0.40" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "168870", "fund_id": "3924", "publish_date": "2017-02-09", "value_134": "1.000", "value_124": null, "value_134_2": "1.000", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "169023", "fund_id": "3924", "publish_date": "2017-02-10", "value_134": "0.999", "value_124": null, "value_134_2": "0.999", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "169150", "fund_id": "3924", "publish_date": "2017-02-13", "value_134": "1.001", "value_124": null, "value_134_2": "1.001", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "169333", "fund_id": "3924", "publish_date": "2017-02-14", "value_134": "1.001", "value_124": null, "value_134_2": "1.001", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "169528", "fund_id": "3924", "publish_date": "2017-02-15", "value_134": "0.999", "value_124": null, "value_134_2": "0.999", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "169681", "fund_id": "3924", "publish_date": "2017-02-16", "value_134": "1.001", "value_124": null, "value_134_2": "1.001", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "169864", "fund_id": "3924", "publish_date": "2017-02-17", "value_134": "0.997", "value_124": null, "value_134_2": "0.997", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.40", "id": "0", "value_zdfpct": "-0.40" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "170119", "fund_id": "3924", "publish_date": "2017-02-21", "value_134": "1.004", "value_124": null, "value_134_2": "1.004", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.70", "id": "0", "value_zdfpct": "0.70" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "170266", "fund_id": "3924", "publish_date": "2017-02-22", "value_134": "1.006", "value_124": null, "value_134_2": "1.006", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "170387", "fund_id": "3924", "publish_date": "2017-02-23", "value_134": "1.001", "value_124": null, "value_134_2": "1.001", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.50", "id": "0", "value_zdfpct": "-0.50" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "170540", "fund_id": "3924", "publish_date": "2017-02-24", "value_134": "0.999", "value_124": null, "value_134_2": "0.999", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "170733", "fund_id": "3924", "publish_date": "2017-02-27", "value_134": "1.001", "value_124": null, "value_134_2": "1.001", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "170841", "fund_id": "3924", "publish_date": "2017-02-28", "value_134": "1.000", "value_124": null, "value_134_2": "1.000", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171000", "fund_id": "3924", "publish_date": "2017-03-01", "value_134": "1.002", "value_124": null, "value_134_2": "1.002", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171105", "fund_id": "3924", "publish_date": "2017-03-02", "value_134": "1.002", "value_124": null, "value_134_2": "1.002", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171330", "fund_id": "3924", "publish_date": "2017-03-03", "value_134": "1.003", "value_124": null, "value_134_2": "1.003", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.10", "id": "0", "value_zdfpct": "0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171451", "fund_id": "3924", "publish_date": "2017-03-06", "value_134": "1.004", "value_124": null, "value_134_2": "1.004", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.10", "id": "0", "value_zdfpct": "0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171652", "fund_id": "3924", "publish_date": "2017-03-07", "value_134": "1.009", "value_124": null, "value_134_2": "1.009", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.50", "id": "0", "value_zdfpct": "0.50" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171753", "fund_id": "3924", "publish_date": "2017-03-08", "value_134": "1.010", "value_124": null, "value_134_2": "1.010", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.10", "id": "0", "value_zdfpct": "0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "171997", "fund_id": "3924", "publish_date": "2017-03-09", "value_134": "1.005", "value_124": null, "value_134_2": "1.005", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.50", "id": "0", "value_zdfpct": "-0.50" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "172091", "fund_id": "3924", "publish_date": "2017-03-10", "value_134": "1.014", "value_124": null, "value_134_2": "1.014", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.90", "id": "0", "value_zdfpct": "0.90" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "172215", "fund_id": "3924", "publish_date": "2017-03-13", "value_134": "1.023", "value_124": null, "value_134_2": "1.023", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.89", "id": "0", "value_zdfpct": "0.89" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "172412", "fund_id": "3924", "publish_date": "2017-03-14", "value_134": "1.021", "value_124": null, "value_134_2": "1.021", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "172602", "fund_id": "3924", "publish_date": "2017-03-15", "value_134": "1.023", "value_124": null, "value_134_2": "1.023", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.20", "id": "0", "value_zdfpct": "0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "172679", "fund_id": "3924", "publish_date": "2017-03-16", "value_134": "1.030", "value_124": null, "value_134_2": "1.030", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.68", "id": "0", "value_zdfpct": "0.68" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "172955", "fund_id": "3924", "publish_date": "2017-03-17", "value_134": "1.022", "value_124": null, "value_134_2": "1.022", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.78", "id": "0", "value_zdfpct": "-0.78" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "173000", "fund_id": "3924", "publish_date": "2017-03-20", "value_134": "1.027", "value_124": null, "value_134_2": "1.027", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.49", "id": "0", "value_zdfpct": "0.49" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "173275", "fund_id": "3924", "publish_date": "2017-03-21", "value_134": "1.033", "value_124": null, "value_134_2": "1.033", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.58", "id": "0", "value_zdfpct": "0.58" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "173328", "fund_id": "3924", "publish_date": "2017-03-22", "value_134": "1.030", "value_124": null, "value_134_2": "1.030", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.29", "id": "0", "value_zdfpct": "-0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "173510", "fund_id": "3924", "publish_date": "2017-03-23", "value_134": "1.034", "value_124": null, "value_134_2": "1.034", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.39", "id": "0", "value_zdfpct": "0.39" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "173735", "fund_id": "3924", "publish_date": "2017-03-24", "value_134": "1.046", "value_124": null, "value_134_2": "1.046", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.16", "id": "0", "value_zdfpct": "1.16" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "173928", "fund_id": "3924", "publish_date": "2017-03-27", "value_134": "1.035", "value_124": null, "value_134_2": "1.035", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.05", "id": "0", "value_zdfpct": "-1.05" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174006", "fund_id": "3924", "publish_date": "2017-03-28", "value_134": "1.031", "value_124": null, "value_134_2": "1.031", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.39", "id": "0", "value_zdfpct": "-0.39" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174162", "fund_id": "3924", "publish_date": "2017-03-29", "value_134": "1.036", "value_124": null, "value_134_2": "1.036", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.48", "id": "0", "value_zdfpct": "0.48" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174311", "fund_id": "3924", "publish_date": "2017-03-30", "value_134": "1.026", "value_124": null, "value_134_2": "1.026", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.97", "id": "0", "value_zdfpct": "-0.97" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174571", "fund_id": "3924", "publish_date": "2017-03-31", "value_134": "1.034", "value_124": null, "value_134_2": "1.034", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.78", "id": "0", "value_zdfpct": "0.78" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174719", "fund_id": "3924", "publish_date": "2017-04-05", "value_134": "1.037", "value_124": null, "value_134_2": "1.037", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.29", "id": "0", "value_zdfpct": "0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174937", "fund_id": "3924", "publish_date": "2017-04-06", "value_134": "1.034", "value_124": null, "value_134_2": "1.034", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.29", "id": "0", "value_zdfpct": "-0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "174992", "fund_id": "3924", "publish_date": "2017-04-07", "value_134": "1.037", "value_124": null, "value_134_2": "1.037", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.29", "id": "0", "value_zdfpct": "0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "175191", "fund_id": "3924", "publish_date": "2017-04-10", "value_134": "1.028", "value_124": null, "value_134_2": "1.028", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.87", "id": "0", "value_zdfpct": "-0.87" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "175355", "fund_id": "3924", "publish_date": "2017-04-11", "value_134": "1.023", "value_124": null, "value_134_2": "1.023", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.49", "id": "0", "value_zdfpct": "-0.49" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "175581", "fund_id": "3924", "publish_date": "2017-04-12", "value_134": "1.019", "value_124": null, "value_134_2": "1.019", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.39", "id": "0", "value_zdfpct": "-0.39" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "175615", "fund_id": "3924", "publish_date": "2017-04-13", "value_134": "1.017", "value_124": null, "value_134_2": "1.017", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.20", "id": "0", "value_zdfpct": "-0.20" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "176115", "fund_id": "3924", "publish_date": "2017-04-18", "value_134": "1.006", "value_124": null, "value_134_2": "1.006", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.08", "id": "0", "value_zdfpct": "-1.08" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "176317", "fund_id": "3924", "publish_date": "2017-04-19", "value_134": "1.006", "value_124": null, "value_134_2": "1.006", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "176520", "fund_id": "3924", "publish_date": "2017-04-20", "value_134": "1.022", "value_124": null, "value_134_2": "1.022", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.59", "id": "0", "value_zdfpct": "1.59" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "176668", "fund_id": "3924", "publish_date": "2017-04-21", "value_134": "1.019", "value_124": null, "value_134_2": "1.019", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.29", "id": "0", "value_zdfpct": "-0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "176777", "fund_id": "3924", "publish_date": "2017-04-24", "value_134": "1.012", "value_124": null, "value_134_2": "1.012", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.69", "id": "0", "value_zdfpct": "-0.69" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "177009", "fund_id": "3924", "publish_date": "2017-04-25", "value_134": "1.022", "value_124": null, "value_134_2": "1.022", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.99", "id": "0", "value_zdfpct": "0.99" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "177151", "fund_id": "3924", "publish_date": "2017-04-26", "value_134": "1.025", "value_124": null, "value_134_2": "1.025", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.29", "id": "0", "value_zdfpct": "0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "177360", "fund_id": "3924", "publish_date": "2017-04-27", "value_134": "1.031", "value_124": null, "value_134_2": "1.031", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.59", "id": "0", "value_zdfpct": "0.59" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "177590", "fund_id": "3924", "publish_date": "2017-04-28", "value_134": "1.031", "value_124": null, "value_134_2": "1.031", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "177674", "fund_id": "3924", "publish_date": "2017-05-02", "value_134": "1.033", "value_124": null, "value_134_2": "1.033", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.19", "id": "0", "value_zdfpct": "0.19" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "177991", "fund_id": "3924", "publish_date": "2017-05-04", "value_134": "1.022", "value_124": null, "value_134_2": "1.022", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.06", "id": "0", "value_zdfpct": "-1.06" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "178259", "fund_id": "3924", "publish_date": "2017-05-05", "value_134": "1.019", "value_124": null, "value_134_2": "1.019", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.29", "id": "0", "value_zdfpct": "-0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "178351", "fund_id": "3924", "publish_date": "2017-05-08", "value_134": "1.016", "value_124": null, "value_134_2": "1.016", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.29", "id": "0", "value_zdfpct": "-0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "178572", "fund_id": "3924", "publish_date": "2017-05-09", "value_134": "1.030", "value_124": null, "value_134_2": "1.030", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.38", "id": "0", "value_zdfpct": "1.38" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "178602", "fund_id": "3924", "publish_date": "2017-05-10", "value_134": "1.037", "value_124": null, "value_134_2": "1.037", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.68", "id": "0", "value_zdfpct": "0.68" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "178843", "fund_id": "3924", "publish_date": "2017-05-11", "value_134": "1.041", "value_124": null, "value_134_2": "1.041", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.39", "id": "0", "value_zdfpct": "0.39" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "179050", "fund_id": "3924", "publish_date": "2017-05-12", "value_134": "1.036", "value_124": null, "value_134_2": "1.036", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.48", "id": "0", "value_zdfpct": "-0.48" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "179253", "fund_id": "3924", "publish_date": "2017-05-15", "value_134": "1.045", "value_124": null, "value_134_2": "1.045", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.87", "id": "0", "value_zdfpct": "0.87" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "179385", "fund_id": "3924", "publish_date": "2017-05-16", "value_134": "1.070", "value_124": null, "value_134_2": "1.070", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "2.39", "id": "0", "value_zdfpct": "2.39" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "179490", "fund_id": "3924", "publish_date": "2017-05-17", "value_134": "1.056", "value_124": null, "value_134_2": "1.056", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.31", "id": "0", "value_zdfpct": "-1.31" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "179643", "fund_id": "3924", "publish_date": "2017-05-18", "value_134": "1.048", "value_124": null, "value_134_2": "1.048", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.76", "id": "0", "value_zdfpct": "-0.76" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "179936", "fund_id": "3924", "publish_date": "2017-05-19", "value_134": "1.047", "value_124": null, "value_134_2": "1.047", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "180087", "fund_id": "3924", "publish_date": "2017-05-22", "value_134": "1.050", "value_124": null, "value_134_2": "1.050", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.29", "id": "0", "value_zdfpct": "0.29" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "180143", "fund_id": "3924", "publish_date": "2017-05-23", "value_134": "1.043", "value_124": null, "value_134_2": "1.043", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.67", "id": "0", "value_zdfpct": "-0.67" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "180406", "fund_id": "3924", "publish_date": "2017-05-24", "value_134": "1.041", "value_124": null, "value_134_2": "1.041", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.19", "id": "0", "value_zdfpct": "-0.19" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "180456", "fund_id": "3924", "publish_date": "2017-05-25", "value_134": "1.037", "value_124": null, "value_134_2": "1.037", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.38", "id": "0", "value_zdfpct": "-0.38" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "180711", "fund_id": "3924", "publish_date": "2017-05-26", "value_134": "1.036", "value_124": null, "value_134_2": "1.036", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "180833", "fund_id": "3924", "publish_date": "2017-05-31", "value_134": "1.031", "value_124": null, "value_134_2": "1.031", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.48", "id": "0", "value_zdfpct": "-0.48" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "181012", "fund_id": "3924", "publish_date": "2017-06-01", "value_134": "1.027", "value_124": null, "value_134_2": "1.027", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.39", "id": "0", "value_zdfpct": "-0.39" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "181263", "fund_id": "3924", "publish_date": "2017-06-02", "value_134": "1.033", "value_124": null, "value_134_2": "1.033", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.58", "id": "0", "value_zdfpct": "0.58" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "181404", "fund_id": "3924", "publish_date": "2017-06-05", "value_134": "1.039", "value_124": null, "value_134_2": "1.039", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.58", "id": "0", "value_zdfpct": "0.58" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "181566", "fund_id": "3924", "publish_date": "2017-06-06", "value_134": "1.043", "value_124": null, "value_134_2": "1.043", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.38", "id": "0", "value_zdfpct": "0.38" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "181730", "fund_id": "3924", "publish_date": "2017-06-07", "value_134": "1.058", "value_124": null, "value_134_2": "1.058", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.44", "id": "0", "value_zdfpct": "1.44" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "181862", "fund_id": "3924", "publish_date": "2017-06-08", "value_134": "1.070", "value_124": null, "value_134_2": "1.070", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.13", "id": "0", "value_zdfpct": "1.13" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "182125", "fund_id": "3924", "publish_date": "2017-06-09", "value_134": "1.069", "value_124": null, "value_134_2": "1.069", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.09", "id": "0", "value_zdfpct": "-0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "182214", "fund_id": "3924", "publish_date": "2017-06-12", "value_134": "1.043", "value_124": null, "value_134_2": "1.043", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-2.43", "id": "0", "value_zdfpct": "-2.43" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "182478", "fund_id": "3924", "publish_date": "2017-06-13", "value_134": "1.051", "value_124": null, "value_134_2": "1.051", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.77", "id": "0", "value_zdfpct": "0.77" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "182558", "fund_id": "3924", "publish_date": "2017-06-14", "value_134": "1.045", "value_124": null, "value_134_2": "1.045", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.57", "id": "0", "value_zdfpct": "-0.57" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "182737", "fund_id": "3924", "publish_date": "2017-06-15", "value_134": "1.044", "value_124": null, "value_134_2": "1.044", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.10", "id": "0", "value_zdfpct": "-0.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "182878", "fund_id": "3924", "publish_date": "2017-06-16", "value_134": "1.051", "value_124": null, "value_134_2": "1.051", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.67", "id": "0", "value_zdfpct": "0.67" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "183088", "fund_id": "3924", "publish_date": "2017-06-19", "value_134": "1.061", "value_124": null, "value_134_2": "1.061", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.95", "id": "0", "value_zdfpct": "0.95" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "183262", "fund_id": "3924", "publish_date": "2017-06-20", "value_134": "1.063", "value_124": null, "value_134_2": "1.063", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.19", "id": "0", "value_zdfpct": "0.19" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "183462", "fund_id": "3924", "publish_date": "2017-06-21", "value_134": "1.080", "value_124": null, "value_134_2": "1.080", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.60", "id": "0", "value_zdfpct": "1.60" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "183623", "fund_id": "3924", "publish_date": "2017-06-22", "value_134": "1.070", "value_124": null, "value_134_2": "1.070", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.93", "id": "0", "value_zdfpct": "-0.93" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "183768", "fund_id": "3924", "publish_date": "2017-06-23", "value_134": "1.081", "value_124": null, "value_134_2": "1.081", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.03", "id": "0", "value_zdfpct": "1.03" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "183978", "fund_id": "3924", "publish_date": "2017-06-26", "value_134": "1.087", "value_124": null, "value_134_2": "1.087", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.56", "id": "0", "value_zdfpct": "0.56" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "184135", "fund_id": "3924", "publish_date": "2017-06-27", "value_134": "1.081", "value_124": null, "value_134_2": "1.081", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.55", "id": "0", "value_zdfpct": "-0.55" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "184223", "fund_id": "3924", "publish_date": "2017-06-28", "value_134": "1.063", "value_124": null, "value_134_2": "1.063", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.67", "id": "0", "value_zdfpct": "-1.67" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "184422", "fund_id": "3924", "publish_date": "2017-06-29", "value_134": "1.066", "value_124": null, "value_134_2": "1.066", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.28", "id": "0", "value_zdfpct": "0.28" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "184576", "fund_id": "3924", "publish_date": "2017-06-30", "value_134": "1.063", "value_124": "197508511.31", "value_134_2": "1.063", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.28", "id": "0", "value_zdfpct": "-0.28" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "184839", "fund_id": "3924", "publish_date": "2017-07-03", "value_134": "1.058", "value_124": null, "value_134_2": "1.058", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.47", "id": "0", "value_zdfpct": "-0.47" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "185024", "fund_id": "3924", "publish_date": "2017-07-05", "value_134": "1.071", "value_124": null, "value_134_2": "1.071", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.23", "id": "0", "value_zdfpct": "1.23" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "185226", "fund_id": "3924", "publish_date": "2017-07-06", "value_134": "1.075", "value_124": null, "value_134_2": "1.075", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.37", "id": "0", "value_zdfpct": "0.37" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "185504", "fund_id": "3924", "publish_date": "2017-07-07", "value_134": "1.075", "value_124": null, "value_134_2": "1.075", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "185585", "fund_id": "3924", "publish_date": "2017-07-10", "value_134": "1.076", "value_124": null, "value_134_2": "1.076", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.09", "id": "0", "value_zdfpct": "0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "185751", "fund_id": "3924", "publish_date": "2017-07-11", "value_134": "1.082", "value_124": null, "value_134_2": "1.082", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.56", "id": "0", "value_zdfpct": "0.56" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "185950", "fund_id": "3924", "publish_date": "2017-07-12", "value_134": "1.092", "value_124": null, "value_134_2": "1.092", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.92", "id": "0", "value_zdfpct": "0.92" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "186099", "fund_id": "3924", "publish_date": "2017-07-13", "value_134": "1.096", "value_124": null, "value_134_2": "1.096", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.37", "id": "0", "value_zdfpct": "0.37" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "186391", "fund_id": "3924", "publish_date": "2017-07-14", "value_134": "1.095", "value_124": null, "value_134_2": "1.095", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.09", "id": "0", "value_zdfpct": "-0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "186445", "fund_id": "3924", "publish_date": "2017-07-17", "value_134": "1.090", "value_124": null, "value_134_2": "1.090", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.46", "id": "0", "value_zdfpct": "-0.46" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "186668", "fund_id": "3924", "publish_date": "2017-07-18", "value_134": "1.098", "value_124": null, "value_134_2": "1.098", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.73", "id": "0", "value_zdfpct": "0.73" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "186801", "fund_id": "3924", "publish_date": "2017-07-19", "value_134": "1.119", "value_124": null, "value_134_2": "1.119", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.91", "id": "0", "value_zdfpct": "1.91" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "186919", "fund_id": "3924", "publish_date": "2017-07-20", "value_134": "1.124", "value_124": null, "value_134_2": "1.124", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.45", "id": "0", "value_zdfpct": "0.45" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "187243", "fund_id": "3924", "publish_date": "2017-07-21", "value_134": "1.125", "value_124": null, "value_134_2": "1.125", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.09", "id": "0", "value_zdfpct": "0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "187432", "fund_id": "3924", "publish_date": "2017-07-24", "value_134": "1.140", "value_124": null, "value_134_2": "1.140", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.33", "id": "0", "value_zdfpct": "1.33" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "187531", "fund_id": "3924", "publish_date": "2017-07-25", "value_134": "1.132", "value_124": null, "value_134_2": "1.132", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.70", "id": "0", "value_zdfpct": "-0.70" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "187630", "fund_id": "3924", "publish_date": "2017-07-26", "value_134": "1.117", "value_124": null, "value_134_2": "1.117", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.33", "id": "0", "value_zdfpct": "-1.33" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "187829", "fund_id": "3924", "publish_date": "2017-07-27", "value_134": "1.119", "value_124": null, "value_134_2": "1.119", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.18", "id": "0", "value_zdfpct": "0.18" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "188059", "fund_id": "3924", "publish_date": "2017-07-28", "value_134": "1.118", "value_124": null, "value_134_2": "1.118", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.09", "id": "0", "value_zdfpct": "-0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "188284", "fund_id": "3924", "publish_date": "2017-07-31", "value_134": "1.118", "value_124": null, "value_134_2": "1.118", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "188462", "fund_id": "3924", "publish_date": "2017-08-01", "value_134": "1.111", "value_124": null, "value_134_2": "1.111", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.63", "id": "0", "value_zdfpct": "-0.63" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "188568", "fund_id": "3924", "publish_date": "2017-08-02", "value_134": "1.109", "value_124": null, "value_134_2": "1.109", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.18", "id": "0", "value_zdfpct": "-0.18" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "188786", "fund_id": "3924", "publish_date": "2017-08-03", "value_134": "1.096", "value_124": null, "value_134_2": "1.096", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.17", "id": "0", "value_zdfpct": "-1.17" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "189006", "fund_id": "3924", "publish_date": "2017-08-04", "value_134": "1.095", "value_124": null, "value_134_2": "1.095", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.09", "id": "0", "value_zdfpct": "-0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "189191", "fund_id": "3924", "publish_date": "2017-08-07", "value_134": "1.106", "value_124": null, "value_134_2": "1.106", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.00", "id": "0", "value_zdfpct": "1.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "189344", "fund_id": "3924", "publish_date": "2017-08-08", "value_134": "1.118", "value_124": null, "value_134_2": "1.118", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.08", "id": "0", "value_zdfpct": "1.08" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "189389", "fund_id": "3924", "publish_date": "2017-08-09", "value_134": "1.115", "value_124": null, "value_134_2": "1.115", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.27", "id": "0", "value_zdfpct": "-0.27" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "189589", "fund_id": "3924", "publish_date": "2017-08-10", "value_134": "1.098", "value_124": null, "value_134_2": "1.098", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.52", "id": "0", "value_zdfpct": "-1.52" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "189808", "fund_id": "3924", "publish_date": "2017-08-11", "value_134": "1.081", "value_124": null, "value_134_2": "1.081", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.55", "id": "0", "value_zdfpct": "-1.55" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "190046", "fund_id": "3924", "publish_date": "2017-08-14", "value_134": "1.104", "value_124": null, "value_134_2": "1.104", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "2.13", "id": "0", "value_zdfpct": "2.13" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "190186", "fund_id": "3924", "publish_date": "2017-08-15", "value_134": "1.102", "value_124": null, "value_134_2": "1.102", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.18", "id": "0", "value_zdfpct": "-0.18" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "190340", "fund_id": "3924", "publish_date": "2017-08-16", "value_134": "1.122", "value_124": null, "value_134_2": "1.122", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.81", "id": "0", "value_zdfpct": "1.81" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "190408", "fund_id": "3924", "publish_date": "2017-08-17", "value_134": "1.109", "value_124": null, "value_134_2": "1.109", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.16", "id": "0", "value_zdfpct": "-1.16" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "190708", "fund_id": "3924", "publish_date": "2017-08-18", "value_134": "1.107", "value_124": null, "value_134_2": "1.107", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.18", "id": "0", "value_zdfpct": "-0.18" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "190809", "fund_id": "3924", "publish_date": "2017-08-21", "value_134": "1.115", "value_124": null, "value_134_2": "1.115", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.72", "id": "0", "value_zdfpct": "0.72" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191020", "fund_id": "3924", "publish_date": "2017-08-22", "value_134": "1.090", "value_124": null, "value_134_2": "1.090", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-2.24", "id": "0", "value_zdfpct": "-2.24" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191129", "fund_id": "3924", "publish_date": "2017-08-23", "value_134": "1.098", "value_124": null, "value_134_2": "1.098", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.73", "id": "0", "value_zdfpct": "0.73" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191287", "fund_id": "3924", "publish_date": "2017-08-24", "value_134": "1.101", "value_124": null, "value_134_2": "1.101", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.27", "id": "0", "value_zdfpct": "0.27" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191649", "fund_id": "3924", "publish_date": "2017-08-25", "value_134": "1.089", "value_124": null, "value_134_2": "1.089", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.09", "id": "0", "value_zdfpct": "-1.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191794", "fund_id": "3924", "publish_date": "2017-08-28", "value_134": "1.077", "value_124": null, "value_134_2": "1.077", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-1.10", "id": "0", "value_zdfpct": "-1.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191915", "fund_id": "3924", "publish_date": "2017-08-29", "value_134": "1.077", "value_124": null, "value_134_2": "1.077", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "191998", "fund_id": "3924", "publish_date": "2017-08-30", "value_134": "1.085", "value_124": null, "value_134_2": "1.085", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.74", "id": "0", "value_zdfpct": "0.74" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "192218", "fund_id": "3924", "publish_date": "2017-08-31", "value_134": "1.092", "value_124": null, "value_134_2": "1.092", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.65", "id": "0", "value_zdfpct": "0.65" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "192376", "fund_id": "3924", "publish_date": "2017-09-01", "value_134": "1.104", "value_124": null, "value_134_2": "1.104", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.10", "id": "0", "value_zdfpct": "1.10" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "192718", "fund_id": "3924", "publish_date": "2017-09-05", "value_134": "1.104", "value_124": null, "value_134_2": "1.104", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.00", "id": "0", "value_zdfpct": "0.00" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "192920", "fund_id": "3924", "publish_date": "2017-09-06", "value_134": "1.105", "value_124": null, "value_134_2": "1.105", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.09", "id": "0", "value_zdfpct": "0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "193134", "fund_id": "3924", "publish_date": "2017-09-07", "value_134": "1.120", "value_124": null, "value_134_2": "1.120", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.36", "id": "0", "value_zdfpct": "1.36" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "193272", "fund_id": "3924", "publish_date": "2017-09-08", "value_134": "1.114", "value_124": null, "value_134_2": "1.114", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.54", "id": "0", "value_zdfpct": "-0.54" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "193469", "fund_id": "3924", "publish_date": "2017-09-11", "value_134": "1.128", "value_124": null, "value_134_2": "1.128", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.26", "id": "0", "value_zdfpct": "1.26" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "193585", "fund_id": "3924", "publish_date": "2017-09-12", "value_134": "1.146", "value_124": null, "value_134_2": "1.146", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.60", "id": "0", "value_zdfpct": "1.60" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "193784", "fund_id": "3924", "publish_date": "2017-09-13", "value_134": "1.159", "value_124": null, "value_134_2": "1.159", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.13", "id": "0", "value_zdfpct": "1.13" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "193915", "fund_id": "3924", "publish_date": "2017-09-14", "value_134": "1.152", "value_124": null, "value_134_2": "1.152", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "-0.60", "id": "0", "value_zdfpct": "-0.60" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "194123", "fund_id": "3924", "publish_date": "2017-09-15", "value_134": "1.153", "value_124": null, "value_134_2": "1.153", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "0.09", "id": "0", "value_zdfpct": "0.09" }, { "fund_type": "1", "fund_name": "华夏移动互联混合（QDII）", "code": "002891", "administrater": null, "fund_value_id": "194307", "fund_id": "3924", "publish_date": "2017-09-18", "value_134": "1.175", "value_124": null, "value_134_2": "1.175", "value_2_1": null, "value_2_2": null, "value_2_3": null, "value_2_4": null, "value_2_5": null, "value_3_1": null, "value_4_1": null, "value_u_d": null, "holiday_flag": null, "value_zdf": "1.91", "id": "0", "value_zdfpct": "1.91" }], "totalElements": 161 } };

var width = window.screen.width;

/*公募详情*/

var PublicOffering = function (_Component) {
  _inherits(PublicOffering, _Component);

  function PublicOffering(props) {
    _classCallCheck(this, PublicOffering);

    var _this = _possibleConstructorReturn(this, (PublicOffering.__proto__ || Object.getPrototypeOf(PublicOffering)).call(this, props));

    _this.state = {
      loadingFlag: true
    };
    return _this;
  }

  _createClass(PublicOffering, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      var funcodeVue = this.props.location.state.fundCode ? this.props.location.state.fundCode : "000021";
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["D" /* getPublicProductDetil */])(funcodeVue, this.handleCallback.bind(this), this));
    }
  }, {
    key: 'handleCallback',
    value: function handleCallback(data) {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var data = {
        PublicDetilAllocation: [],
        PublicDetilAsset: [],
        PublicDetilBaseInfo: [{
          managers: ""
        }],
        PublicDetilBond: [],
        PublicDetilInfo: [_defineProperty({ discount_rate: "", dtstatus: "",
          fundcode: "", fundenddate: null,
          fundfullname: "", fundmessage: "",
          fundname: "", fundstartdate: "",
          fundtype: "", fundvalue: "",
          isshow: null, leijijingzhi: "", numcolor: "",
          publish_date: "", qirinianhua: null,
          qrnhcolor: "", rate: "", sgstatus: "",
          show_discount_rate: "",
          tradedt: "", tradesg: "", wanfenshouyi: null,
          year3grade: "", year5grade: "", zhangdiefu: ""
        }, 'tradedt', "")],
        PublicDetilManager: [],
        PublicDetilProfit: [{
          fundcode: "", fundname: "", fundtype: "",
          m1: "", m3: "", m6: "", sumdate: "",
          totalnavchgrate: null, w1: "", y1: "", y2: null, y3: "", y4: null,
          y5: "", yearnavchgrate: null
        }],
        PublicDetilRate: [],
        PublicDetilStock: []
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["E" /* fundPublicDetil */])(data));
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          fundPublicProductDetil = _props.fundPublicProductDetil,
          fundHistoty = _props.fundHistoty,
          AddZxFlag = _props.AddZxFlag,
          payLoading = _props.payLoading;

      console.log(fundPublicProductDetil, "------------");
      var dataInfo = fundPublicProductDetil.PublicDetilInfo[0];
      var title = dataInfo.fundname.length > 1 ? dataInfo.fundname + "(" + dataInfo.fundcode + ")" : "";
      document.getElementsByTagName('title')[0].innerHTML = title;
      console.log(title, "fundcodefundcodefundcode");
      var fundtype = dataInfo.fundtype;
      var touzFx = getFx(fundtype);
      var funcodeVue = this.props.location.state.fundCode;
      console.log(funcodeVue, "funcodeVuefuncodeVuefuncodeVuefuncodeVue");

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              ' ',
              title,
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopMain, { data: dataInfo }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, height: 10 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IncomeShowTab, { touzFx: touzFx, dispatch: this.props.dispatch, funcodeVue: funcodeVue }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, height: 10 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListNumber, { data: fundPublicProductDetil.PublicDetilProfit[0] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, height: 10 } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FundInfoList, { data: fundPublicProductDetil, touzFx: touzFx }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, height: 10 } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 44 } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BottomPart, { fundPublicProductDetil: fundPublicProductDetil, optional: AddZxFlag, dispatch: this.props.dispatch, dataInfo: dataInfo })
      );
    }
  }]);

  return PublicOffering;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    fundPublicProductDetil: state.fundPublicProductDetil,
    fundHistoty: state.fundHistoty,
    AddZxFlag: state.AddZxFlag
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PublicOffering));

var TopMain = function (_Component2) {
  _inherits(TopMain, _Component2);

  function TopMain(props) {
    _classCallCheck(this, TopMain);

    var _this3 = _possibleConstructorReturn(this, (TopMain.__proto__ || Object.getPrototypeOf(TopMain)).call(this, props));

    _this3.state = {};
    return _this3;
  }

  _createClass(TopMain, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var fundtype = data.fundtype;
      var touzFx = getFx(fundtype);
      var year3grade = data.year3grade;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        touzFx !== "低" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 84, WebkitFlexDirection: 'row', display: "-webkit-flex", paddingTop: 20, backgroundColor: '#FFF' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.44rem', color: "#fb615b", height: 21 } },
              data.fundvalue
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.24rem', color: "#5b6370", marginTop: 2 } },
              '\u6700\u65B0\u51C0\u503C(\u5143)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.2rem', color: "rgb(152,160,172)", marginTop: 2 } },
              data.publish_date
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.44rem', color: data.zhangdiefu >= 0 ? "#fb615b" : "#7fdd81", height: 21 } },
              data.zhangdiefu != null && data.zhangdiefu !== "" ? data.zhangdiefu + "%" : "--"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.24rem', color: "#5b6370", marginTop: 2 } },
              '\u65E5\u6DA8\u8DCC\u5E45'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.44rem', color: '#fb615b', height: 21 } },
              touzFx
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.24rem', color: "#5b6370", marginTop: 2 } },
              '\u6295\u8D44\u98CE\u9669'
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 84, WebkitFlexDirection: 'row', display: "-webkit-flex", paddingTop: 20, backgroundColor: '#FFF' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.44rem', color: "#fb615b", height: 21 } },
              data.wanfenshouyi
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.24rem', color: "#5b6370", marginTop: 2 } },
              '\u4E07\u5206\u6536\u76CA(\u5143)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.2rem', color: "rgb(152,160,172)", marginTop: 2 } },
              data.publish_date
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.44rem', color: "#7fdd81", height: 21 } },
              data.qirinianhua
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.24rem', color: "#5b6370", marginTop: 2 } },
              '\u4E03\u65E5\u5E74\u5316'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.44rem', color: '#fb615b', height: 21 } },
              touzFx
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.24rem', color: "#5b6370", marginTop: 2 } },
              '\u6295\u8D44\u98CE\u9669'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 43, display: "-webkit-flex", WebkitFlexDirection: 'row', backgroundColor: '#FFF', borderTop: "solid #ebeef0 1px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, display: "-webkit-flex", WebkitAlignItems: 'center', paddingLeft: 25, fontSize: '0.28rem' } },
            data.fundtype
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, display: "-webkit-flex", WebkitAlignItems: 'center', WebkitJustifyContent: 'flex-end', paddingRight: 13 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: '0.28rem', marginRight: 6 } },
              '\u94F6\u6CB3\u8BC4\u7EA7'
            ),
            returnStar(year3grade)
          )
        )
      );
    }
  }]);

  return TopMain;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function returnStar(year3grade) {
  var stars = [];
  var endStar = 5 - year3grade;
  if (endStar === 5) {
    stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: { fontSize: '0.28rem', color: '#5b6370' } },
      '\u6682\u65E0'
    ));
  } else {
    for (var i = 0; i < year3grade; i++) {
      stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'stars2', key: i + 11 }));
    }
    for (var _i = 0; _i < endStar; _i++) {
      stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'stars1', key: _i + 12 }));
    }
  }
  return stars;
}

var BottomPart = function (_Component3) {
  _inherits(BottomPart, _Component3);

  function BottomPart(props) {
    _classCallCheck(this, BottomPart);

    var _this4 = _possibleConstructorReturn(this, (BottomPart.__proto__ || Object.getPrototypeOf(BottomPart)).call(this, props));

    _this4.state = {};
    return _this4;
  }

  _createClass(BottomPart, [{
    key: 'handleOptional',
    value: function handleOptional() {
      console.log(this.props.dataInfo.fundcode);
      var data = {
        fundcode: this.props.dataInfo.fundcode
      };
      var callBack = this.props.callBack;
      console.log(this.props.optional);
      if (this.props.optional == "0") {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["F" /* reateOptional */])(data));
      } else {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["G" /* deleteOptional */])(data));
      }
    }
  }, {
    key: 'goInvestPlan',
    value: function goInvestPlan() {
      var dataInfo = this.props.dataInfo;
      var paramss = {
        fundCode: dataInfo.fundcode,
        businessType: this.props.fundPublicProductDetil.businessType,
        productType: 'G',
        titleHeader: '新建定投计划',
        currentNav: dataInfo.fundvalue,
        currentNavDate: dataInfo.publish_date,
        item: {
          shareClassName: this.props.fundPublicProductDetil.fundShareClassName
        },
        fundType: dataInfo.fundtype,
        wanfenshouyi: dataInfo.wanfenshouyi ? dataInfo.wanfenshouyi : "",
        fundName: dataInfo.fundname
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, paramss, __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */], 'FixedInvestment');
    }
  }, {
    key: 'goPay',
    value: function goPay() {
      var dataInfo = this.props.dataInfo;
      var paramss = {
        fundName: dataInfo.fundname,
        fundCode: dataInfo.fundcode,
        businessType: this.props.fundPublicProductDetil.businessType,
        productType: 'G',
        fundType: dataInfo.fundtype,
        wanfenshouyi: dataInfo.wanfenshouyi
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, paramss, __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */], 'Payment');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var state = true;
      var zxFlag = this.props.optional;
      console.log(this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: "fixed", bottom: 0, width: "100%", height: 40 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 40, display: "-webkit-flex", WebkitFlexDirection: 'row' } },
          state ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this5.goInvestPlan();
              }, style: { WebkitFlex: 2, borderTop: '#e1e3e6 solid 1px', borderRight: '#e1e3e6 solid 1px', display: "-webkit-flex", WebkitAlignItems: 'center', WebkitFlexDirection: 'column', background: "#FFF" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 24, WebkitAlignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'dtIcon' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: 'rgb(90,99,112)' } },
              '\u5B9A\u6295'
            )
          ) : null,
          zxFlag == "0" || zxFlag == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 2, borderTop: '#e1e3e6 solid 1px', display: "-webkit-flex", WebkitAlignItems: 'center', WebkitFlexDirection: 'column', background: "#FFF" }, onClick: __WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */].bind(this, this.handleOptional.bind(this), window.history.length) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 24, WebkitAlignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'zxIcon' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: 'rgb(90,99,112)' } },
              '\u52A0\u81EA\u9009'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 2, borderTop: '#e1e3e6 solid 1px', display: "-webkit-flex", WebkitAlignItems: 'center', WebkitFlexDirection: 'column', background: "#FFF" }, onClick: __WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */].bind(this, this.handleOptional.bind(this), window.history.length) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 24, WebkitAlignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'zxIcon2' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: 'rgb(90,99,112)' } },
              '\u53D6\u6D88\u81EA\u9009'
            )
          ),
          this.props.fundPublicProductDetil.businessType === "T022" || this.props.fundPublicProductDetil.businessType === "T020" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this5.goPay();
              }, style: { WebkitFlex: state ? 6 : 8, backgroundColor: "#fa063a", color: '#FFF', fontSize: '0.3rem', display: "-webkit-flex", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u7533\u8D2D'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: state ? 6 : 8, backgroundColor: "#afb0b3", color: '#FFF', fontSize: '0.3rem', display: "-webkit-flex", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u7533\u8D2D'
            )
          )
        )
      );
    }
  }]);

  return BottomPart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var IncomeShowTab = function (_Component4) {
  _inherits(IncomeShowTab, _Component4);

  function IncomeShowTab(props) {
    _classCallCheck(this, IncomeShowTab);

    var _this6 = _possibleConstructorReturn(this, (IncomeShowTab.__proto__ || Object.getPrototypeOf(IncomeShowTab)).call(this, props));

    _this6.state = {
      txt: "单位净值"
    };
    return _this6;
  }

  _createClass(IncomeShowTab, [{
    key: 'handerClick',
    value: function handerClick(txt) {
      this.setState({
        txt: txt
      });
    }
  }, {
    key: 'goHistoryRate',
    value: function goHistoryRate() {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/HistoryRate',
        state: {}
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var state = true;
      var txt = this.state.txt;
      var _props2 = this.props,
          touzFx = _props2.touzFx,
          funcodeVue = _props2.funcodeVue;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { height: 424, background: '#FFF' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 48, border: "1px solid #ebeef0", paddingLeft: 45, paddingRight: 45, WebkitFlex: 1 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlexDirection: 'row', display: "-webkit-flex", height: 48 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: txt === "单位净值" ? "TabClick2" : "TabClick1", onClick: function onClick() {
                  _this7.handerClick("单位净值");
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5355\u4F4D\u51C0\u503C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: txt === "累计净值" ? "TabClick2" : "TabClick1", onClick: function onClick() {
                  _this7.handerClick("累计净值");
                } },
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7D2F\u8BA1\u51C0\u503C'
              )
            )
          )
        ),
        touzFx !== "低" ? txt === "单位净值" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabLineComponent, { dispatch: this.props.dispatch, fundvalue: funcodeVue }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabLineComponentTwo, { dispatch: this.props.dispatch, fundvalue: funcodeVue }) : txt === "累计净值" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabLineComponentH, { dispatch: this.props.dispatch, fundvalue: funcodeVue }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabLineComponentHTwo, { dispatch: this.props.dispatch, fundvalue: funcodeVue }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 44, display: "-webkit-flex", border: "1px solid #ebeef0", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' }, onClick: function onClick() {
              _this7.goHistoryRate(funcodeVue);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: '0.28rem', color: '#3A3E47' } },
            '\u67E5\u770B\u5386\u53F2\u51C0\u503C'
          )
        )
      );
    }
  }]);

  return IncomeShowTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ListNumber = function (_Component5) {
  _inherits(ListNumber, _Component5);

  function ListNumber(props) {
    _classCallCheck(this, ListNumber);

    var _this8 = _possibleConstructorReturn(this, (ListNumber.__proto__ || Object.getPrototypeOf(ListNumber)).call(this, props));

    _this8.state = {};
    return _this8;
  }

  _createClass(ListNumber, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var state = true;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { height: 205, background: '#FFF', paddingTop: 12 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'numberList' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListTitle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u65F6\u95F4\u533A\u95F4'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListTitle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u6DA8\u8DCC\u5E45'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'numberList2' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8FD1\u4E00\u4E2A\u6708'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              data.m1 != null ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.m1) + "%" : "-"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'numberList' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8FD1\u4E09\u4E2A\u6708'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              data.m3 != null ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.m3) + "%" : "-"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'numberList2' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8FD1\u4E00\u5E74'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              ' ',
              data.y1 != null ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.y1) + "%" : "-",
              ' '
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'numberList' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u6210\u7ACB\u4EE5\u6765'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'numberListLi' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              ' ',
              data.totalnavchgrate != null ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.fomatFloat(data.totalnavchgrate) + "%" : "-",
              ' '
            )
          )
        )
      );
    }
  }]);

  return ListNumber;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var FundInfoList = function (_Component6) {
  _inherits(FundInfoList, _Component6);

  function FundInfoList(props) {
    _classCallCheck(this, FundInfoList);

    var _this9 = _possibleConstructorReturn(this, (FundInfoList.__proto__ || Object.getPrototypeOf(FundInfoList)).call(this, props));

    _this9.state = {};
    return _this9;
  }

  _createClass(FundInfoList, [{
    key: 'pushPublicDetilBaseInfo',
    value: function pushPublicDetilBaseInfo() {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/FundGk',
        state: { data: this.props.data.PublicDetilBaseInfo[0], minAmount: this.props.data.minAmount },
        query: { code: '' }
      });
    }
  }, {
    key: 'pushManagersList',
    value: function pushManagersList() {
      var managers = this.props.data.PublicDetilManager;
      if (managers.length > 1) {
        __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
          pathname: '/ManagersList',
          state: { data: managers, touzFx: this.props.touzFx },
          query: { code: '' }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
          pathname: '/ManagersDetail',
          state: { data: managers[0], touzFx: this.props.touzFx },
          query: { code: '' }
        });
      }
    }
  }, {
    key: 'pushRate',
    value: function pushRate() {
      var data = this.props.data;
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/Rate',
        state: { data: data.PublicDetilRate, touzFx: this.props.touzFx }
      });
    }
  }, {
    key: 'pushPositionSituation',
    value: function pushPositionSituation() {
      var data = this.props.data;
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/PositionSituation',
        state: { data: data, touzFx: this.props.touzFx }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      var data = this.props.data;

      var dataShow = data.PublicDetilInfo[0];
      var rateShow = "";
      var man = "";
      if (dataShow.show_discount_rate == "Y") {
        rateShow = "最低" + dataShow.discount_rate;
      }
      for (var i = 0; i < data.PublicDetilManager.length; i++) {
        man += " " + data.PublicDetilManager[i].name;
      }

      var state = true;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: '#FFF' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'listStyle', onClick: function onClick() {
              _this10.pushPublicDetilBaseInfo();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u57FA\u91D1\u6982\u51B5'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              ' ',
              dataShow.sgstatus,
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'arrowRight' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'listStyle', onClick: function onClick() {
              _this10.pushManagersList();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u57FA\u91D1\u7ECF\u7406'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              ' ',
              man,
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'arrowRight' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'listStyle', onClick: function onClick() {
              _this10.pushRate();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8D39\u7387\u4ECB\u7ECD'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u6700\u4F4E0.6%'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'arrowRight' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'listStyle', onClick: function onClick() {
              _this10.pushPositionSituation();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u6301\u4ED3\u60C5\u51B5'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'arrowRight' })
          )
        )
      );
    }
  }]);

  return FundInfoList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var LineComponent = function (_Component7) {
  _inherits(LineComponent, _Component7);

  function LineComponent(props) {
    _classCallCheck(this, LineComponent);

    var _this11 = _possibleConstructorReturn(this, (LineComponent.__proto__ || Object.getPrototypeOf(LineComponent)).call(this, props));

    _this11.state = {};
    return _this11;
  }

  _createClass(LineComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // var myChart = echarts.init(document.getElementById('SuperLine'));
      //  // 绘制图表
      //  let dataArr = [];
      //  this.props.data2 ? this.props.data2.map(function(item){
      //    dataArr.push(Util.newToFixed(item*100))
      //  }): null
      //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var myChart = __WEBPACK_IMPORTED_MODULE_5_echarts_lib_echarts___default.a.init(document.getElementById('PublicOfferLine'));
      // 绘制图表
      myChart.clear();
      myChart.setOption(lineOption(this.props.data1, this.props.data2));
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'PublicOfferLine', style: { width: "100%", height: 300, paddingLeft: '8px' } });
    }
  }]);

  return LineComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*收益表现下的折线图*/
/*单位净值*/


var TabLineComponent = function (_Component8) {
  _inherits(TabLineComponent, _Component8);

  function TabLineComponent(props) {
    _classCallCheck(this, TabLineComponent);

    var _this12 = _possibleConstructorReturn(this, (TabLineComponent.__proto__ || Object.getPrototypeOf(TabLineComponent)).call(this, props));

    _this12.state = {
      option: {},
      txt: "三个月",
      historyData: { HistoryRate: [] },
      threeMonthDate: [],
      threeMonthNav: [],
      oneYearDate: [],
      oneYearNav: [],
      totalDate: [],
      totalNav: [],
      data1: [],
      data2: [],
      newDate: null,
      newNav: null
    };
    return _this12;
  }

  _createClass(TabLineComponent, [{
    key: 'historyCallback',
    value: function historyCallback(data) {
      console.log(data, "历史净值");

      var that = this;
      this.handleData(data);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var historyJoin = {
        type: 1,
        fundcode: this.props.fundvalue
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["H" /* getHistoryProfileRate */])(historyJoin, this.historyCallback.bind(this)));
    }
  }, {
    key: 'handleData',
    value: function handleData(data) {
      var fundtype = this.props.dataInfo;
      /* let touzFx = getFx(fundtype);*/
      var touzFx = "";
      var Datacontnet = data.HistoryRate;

      var threeMonthDate = this.state.threeMonthDate;
      var threeMonthNav = this.state.threeMonthNav;
      var oneYearDate = this.state.oneYearDate;
      var oneYearNav = this.state.oneYearNav;
      var totalDate = this.state.totalDate;
      var totalNav = this.state.totalNav;

      if (totalNav.length == 0) {
        threeMonthDate = [];
        threeMonthNav = [];
        oneYearDate = [];
        oneYearNav = [];
        totalDate = [];
        totalNav = [];
        var oneYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["l" /* get1yearBefor */])();
        var threeMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["e" /* get3MonthBefor */])();
        for (var i = Datacontnet.length - 1; i >= 0; i--) {
          totalDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_134);
          // }else{
          //   totalNav.push(Datacontnet[i].value_2_1)
          // }
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(oneYear, Datacontnet[i].publish_date)) {
            oneYearDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_134);
            // }else{
            //   oneYearNav.push(Datacontnet[i].value_2_1)
            // }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(threeMonth, Datacontnet[i].publish_date)) {
              threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
              // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_134);
              // }else{
              //   threeMonthNav.push(Datacontnet[i].value_2_1)
              // }
            }
          }
        }

        threeMonthDate = threeMonthDate.reverse(), threeMonthNav = threeMonthNav.reverse(), oneYearDate = oneYearDate.reverse(), oneYearNav = oneYearNav.reverse(), totalNav = totalNav.reverse(), totalDate = totalDate.reverse();
        this.setState({
          threeMonthDate: threeMonthDate,
          threeMonthNav: threeMonthNav,
          oneYearDate: oneYearDate,
          oneYearNav: oneYearNav,
          totalNav: totalNav,
          totalDate: totalDate,
          option: lineOption(threeMonthDate, threeMonthNav),
          data1: threeMonthDate,
          data2: threeMonthNav,
          newDate: threeMonthDate[threeMonthDate.length - 1],
          newNav: threeMonthNav[threeMonthNav.length - 1]
        });
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(a) {
      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
      // myChart.clear();
      //document.getElementById('PublicOfferLine').innerHTML = "";
      //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

      var that = this;
      if (a == "三个月") {
        // UmengStatis.onEvent('PublicOffering_ThreeMonth_Btn'); /*公募详情-三个月按钮*/
        var threeMonthDate = this.state.threeMonthDate;
        var threeMonthNav = this.state.threeMonthNav;
        that.setState({
          txt: "三个月",
          data1: this.state.threeMonthDate,
          data2: this.state.threeMonthNav,
          newDate: threeMonthDate[threeMonthDate.length - 1],
          newNav: threeMonthNav[threeMonthNav.length - 1]
        });
      } else if (a === "近一年") {
        // UmengStatis.onEvent('PublicOffering_OneYears_Btn'); /*公募详情-近一年按钮*/
        var _state = this.state,
            oneYearDate = _state.oneYearDate,
            oneYearNav = _state.oneYearNav;

        that.setState({
          txt: "近一年",
          data1: this.state.oneYearDate,
          data2: this.state.oneYearNav,
          newDate: oneYearDate[oneYearDate.length - 1],
          newNav: oneYearNav[oneYearNav.length - 1]
        });
        // 绘制图表
        //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));
      } else if (a === "成立以来") {
        // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
        var _state2 = this.state,
            totalDate = _state2.totalDate,
            totalNav = _state2.totalNav;

        that.setState({
          txt: "成立以来",
          data1: this.state.totalDate,
          data2: this.state.totalNav,
          newDate: totalDate[totalDate.length - 1],
          newNav: totalNav[totalNav.length - 1]
        });
        //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this13 = this;

      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      var data = this.props.data;
      var _state3 = this.state,
          data1 = _state3.data1,
          data2 = _state3.data2,
          txt = _state3.txt,
          newDate = _state3.newDate,
          newNav = _state3.newNav;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { background: "#FFF", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tabLinTitle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "三个月" ? "clickTab" : "", onClick: function onClick() {
                  _this13.handleTab("三个月");
                } },
              '\u4E09\u4E2A\u6708'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "近一年" ? "clickTab" : "", onClick: function onClick() {
                  _this13.handleTab("近一年");
                } },
              '\u8FD1\u4E00\u5E74'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "成立以来" ? "clickTab" : "", onClick: function onClick() {
                  _this13.handleTab("成立以来");
                } },
              '\u6210\u7ACB\u4EE5\u6765'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: "absolute", right: 0, top: "40px", backgroundColor: 'rgba(255,255,255,0)', width: width } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'linePositionTop', style: { width: width } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "rgb(161,168,179)", fontSize: 11 } },
                  ""
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "rgb(249,98,94)", fontSize: 11 } },
                  ""
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 11, color: 'rgba(161,168,179,1)' } },
                  ' ',
                  newDate != null ? newDate + "单位净值：" : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 11, color: "rgb(249,98,94)" } },
                  newNav != null && newNav != "--" ? newNav + "%" : null
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineComponent, { data1: data1, data2: data2 })
        )
      );
    }
  }]);

  return TabLineComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*累计净值*/


var TabLineComponentTwo = function (_Component9) {
  _inherits(TabLineComponentTwo, _Component9);

  function TabLineComponentTwo(props) {
    _classCallCheck(this, TabLineComponentTwo);

    var _this14 = _possibleConstructorReturn(this, (TabLineComponentTwo.__proto__ || Object.getPrototypeOf(TabLineComponentTwo)).call(this, props));

    _this14.state = {
      option: {},
      txt: "三个月",
      historyData: { HistoryRate: [] },
      threeMonthDate: [],
      threeMonthNav: [],
      oneYearDate: [],
      oneYearNav: [],
      totalDate: [],
      totalNav: [],
      data1: [],
      data2: []
    };
    return _this14;
  }

  _createClass(TabLineComponentTwo, [{
    key: 'historyCallback',
    value: function historyCallback(data) {
      console.log(data, "历史净值");

      var that = this;
      this.handleData(data);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      console.log(this.props.fundvalue, "historyCallbackhistoryCallbackhistoryCallback");
      // InteractionManager.runAfterInteractions(() => {
      //   dispatch(getHistoryProfileRate(history,this.historyCallback.bind(this)));
      // });
      var historyJoin = {
        type: 1,
        fundcode: this.props.fundvalue
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["H" /* getHistoryProfileRate */])(historyJoin, this.historyCallback.bind(this)));
    }
  }, {
    key: 'handleData',
    value: function handleData(data) {
      var fundtype = this.props.dataInfo;
      /* let touzFx = getFx(fundtype);*/
      var touzFx = "";
      var Datacontnet = data.HistoryRate;

      var threeMonthDate = this.state.threeMonthDate;
      var threeMonthNav = this.state.threeMonthNav;
      var oneYearDate = this.state.oneYearDate;
      var oneYearNav = this.state.oneYearNav;
      var totalDate = this.state.totalDate;
      var totalNav = this.state.totalNav;

      if (totalNav.length == 0) {
        threeMonthDate = [];
        threeMonthNav = [];
        oneYearDate = [];
        oneYearNav = [];
        totalDate = [];
        totalNav = [];
        var oneYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["l" /* get1yearBefor */])();
        var threeMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["e" /* get3MonthBefor */])();
        for (var i = Datacontnet.length - 1; i >= 0; i--) {
          totalDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_134_2);
          // }else{
          //   totalNav.push(Datacontnet[i].value_2_1)
          // }
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(oneYear, Datacontnet[i].publish_date)) {
            oneYearDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_134_2);
            // }else{
            //   oneYearNav.push(Datacontnet[i].value_2_1)
            // }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(threeMonth, Datacontnet[i].publish_date)) {
              threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
              // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_134_2);
              // }else{
              //   threeMonthNav.push(Datacontnet[i].value_2_1)
              // }
            }
          }
        }

        threeMonthDate = threeMonthDate.reverse(), threeMonthNav = threeMonthNav.reverse(), oneYearDate = oneYearDate.reverse(), oneYearNav = oneYearNav.reverse(), totalNav = totalNav.reverse(), totalDate = totalDate.reverse();
        this.setState({
          threeMonthDate: threeMonthDate,
          threeMonthNav: threeMonthNav,
          oneYearDate: oneYearDate,
          oneYearNav: oneYearNav,
          totalNav: totalNav,
          totalDate: totalDate,
          option: lineOption(threeMonthDate, threeMonthNav),
          data1: threeMonthDate,
          data2: threeMonthNav
        });
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(a) {
      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
      // myChart.clear();
      //document.getElementById('PublicOfferLine').innerHTML = "";
      //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

      var that = this;
      if (a == "三个月") {
        // UmengStatis.onEvent('PublicOffering_ThreeMonth_Btn'); /*公募详情-三个月按钮*/
        that.setState({
          txt: "三个月",
          data1: this.state.threeMonthDate,
          data2: this.state.threeMonthNav
        });
      } else if (a === "近一年") {
        // UmengStatis.onEvent('PublicOffering_OneYears_Btn'); /*公募详情-近一年按钮*/
        that.setState({
          txt: "近一年",
          data1: this.state.oneYearDate,
          data2: this.state.oneYearNav
        });
        // 绘制图表
        //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));
      } else if (a === "成立以来") {
        // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
        that.setState({
          txt: "成立以来",
          data1: this.state.totalDate,
          data2: this.state.totalNav
        });
        //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this15 = this;

      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      var data = this.props.data;
      var _state4 = this.state,
          data1 = _state4.data1,
          data2 = _state4.data2,
          txt = _state4.txt;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { background: "#FFF" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tabLinTitle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "三个月" ? "clickTab" : "", onClick: function onClick() {
                  _this15.handleTab("三个月");
                } },
              '\u4E09\u4E2A\u6708'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "近一年" ? "clickTab" : "", onClick: function onClick() {
                  _this15.handleTab("近一年");
                } },
              '\u8FD1\u4E00\u5E74'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "成立以来" ? "clickTab" : "", onClick: function onClick() {
                  _this15.handleTab("成立以来");
                } },
              '\u6210\u7ACB\u4EE5\u6765'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineComponent, { data1: data1, data2: data2 })
        )
      );
    }
  }]);

  return TabLineComponentTwo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*货币*/


var TabLineComponentH = function (_Component10) {
  _inherits(TabLineComponentH, _Component10);

  function TabLineComponentH(props) {
    _classCallCheck(this, TabLineComponentH);

    var _this16 = _possibleConstructorReturn(this, (TabLineComponentH.__proto__ || Object.getPrototypeOf(TabLineComponentH)).call(this, props));

    _this16.state = {
      option: {},
      txt: "三个月",
      historyData: { HistoryRate: [] },
      threeMonthDate: [],
      threeMonthNav: [],
      oneYearDate: [],
      oneYearNav: [],
      totalDate: [],
      totalNav: [],
      data1: [],
      data2: []
    };
    return _this16;
  }

  _createClass(TabLineComponentH, [{
    key: 'historyCallback',
    value: function historyCallback(data) {
      console.log(data, "历史净值");

      var that = this;
      this.handleData(data);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var historyJoin = {
        type: 1,
        fundcode: this.props.fundvalue
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["H" /* getHistoryProfileRate */])(historyJoin, this.historyCallback.bind(this)));
    }
  }, {
    key: 'handleData',
    value: function handleData(data) {
      var fundtype = this.props.dataInfo;
      /* let touzFx = getFx(fundtype);*/
      var touzFx = "";
      var Datacontnet = data.HistoryRate;

      var threeMonthDate = this.state.threeMonthDate;
      var threeMonthNav = this.state.threeMonthNav;
      var oneYearDate = this.state.oneYearDate;
      var oneYearNav = this.state.oneYearNav;
      var totalDate = this.state.totalDate;
      var totalNav = this.state.totalNav;

      if (totalNav.length == 0) {
        threeMonthDate = [];
        threeMonthNav = [];
        oneYearDate = [];
        oneYearNav = [];
        totalDate = [];
        totalNav = [];
        var oneYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["l" /* get1yearBefor */])();
        var threeMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["e" /* get3MonthBefor */])();
        for (var i = Datacontnet.length - 1; i >= 0; i--) {
          totalDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_2_1);
          // }else{
          //   totalNav.push(Datacontnet[i].value_2_1)
          // }
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(oneYear, Datacontnet[i].publish_date)) {
            oneYearDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_2_1);
            // }else{
            //   oneYearNav.push(Datacontnet[i].value_2_1)
            // }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(threeMonth, Datacontnet[i].publish_date)) {
              threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
              // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_2_1);
              // }else{
              //   threeMonthNav.push(Datacontnet[i].value_2_1)
              // }
            }
          }
        }

        threeMonthDate = threeMonthDate.reverse(), threeMonthNav = threeMonthNav.reverse(), oneYearDate = oneYearDate.reverse(), oneYearNav = oneYearNav.reverse(), totalNav = totalNav.reverse(), totalDate = totalDate.reverse();
        this.setState({
          threeMonthDate: threeMonthDate,
          threeMonthNav: threeMonthNav,
          oneYearDate: oneYearDate,
          oneYearNav: oneYearNav,
          totalNav: totalNav,
          totalDate: totalDate,
          option: lineOption(threeMonthDate, threeMonthNav),
          data1: threeMonthDate,
          data2: threeMonthNav
        });
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(a) {
      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
      // myChart.clear();
      //document.getElementById('PublicOfferLine').innerHTML = "";
      //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

      var that = this;
      if (a == "三个月") {

        that.setState({
          txt: "三个月",
          data1: this.state.threeMonthDate,
          data2: this.state.threeMonthNav
        });
      } else if (a === "近一年") {

        that.setState({
          txt: "近一年",
          data1: this.state.oneYearDate,
          data2: this.state.oneYearNav
        });
        // 绘制图表
        //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));
      } else if (a === "成立以来") {
        // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
        that.setState({
          txt: "成立以来",
          data1: this.state.totalDate,
          data2: this.state.totalNav
        });
        //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this17 = this;

      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      var data = this.props.data;
      var _state5 = this.state,
          data1 = _state5.data1,
          data2 = _state5.data2,
          txt = _state5.txt;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { background: "#FFF" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tabLinTitle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "三个月" ? "clickTab" : "", onClick: function onClick() {
                  _this17.handleTab("三个月");
                } },
              '\u4E09\u4E2A\u6708'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "近一年" ? "clickTab" : "", onClick: function onClick() {
                  _this17.handleTab("近一年");
                } },
              '\u8FD1\u4E00\u5E74'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "成立以来" ? "clickTab" : "", onClick: function onClick() {
                  _this17.handleTab("成立以来");
                } },
              '\u6210\u7ACB\u4EE5\u6765'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineComponent, { data1: data1, data2: data2 })
        )
      );
    }
  }]);

  return TabLineComponentH;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*货币*/


var TabLineComponentHTwo = function (_Component11) {
  _inherits(TabLineComponentHTwo, _Component11);

  function TabLineComponentHTwo(props) {
    _classCallCheck(this, TabLineComponentHTwo);

    var _this18 = _possibleConstructorReturn(this, (TabLineComponentHTwo.__proto__ || Object.getPrototypeOf(TabLineComponentHTwo)).call(this, props));

    _this18.state = {
      option: {},
      txt: "三个月",
      historyData: { HistoryRate: [] },
      threeMonthDate: [],
      threeMonthNav: [],
      oneYearDate: [],
      oneYearNav: [],
      totalDate: [],
      totalNav: [],
      data1: [],
      data2: []
    };
    return _this18;
  }

  _createClass(TabLineComponentHTwo, [{
    key: 'historyCallback',
    value: function historyCallback(data) {
      console.log(data, "历史净值");

      var that = this;
      this.handleData(data);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var historyJoin = {
        type: 1,
        fundcode: this.props.fundvalue
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_productAction__["H" /* getHistoryProfileRate */])(historyJoin, this.historyCallback.bind(this)));
    }
  }, {
    key: 'handleData',
    value: function handleData(data) {
      var fundtype = this.props.dataInfo;
      /* let touzFx = getFx(fundtype);*/
      var touzFx = "";
      var Datacontnet = data.HistoryRate;

      var threeMonthDate = this.state.threeMonthDate;
      var threeMonthNav = this.state.threeMonthNav;
      var oneYearDate = this.state.oneYearDate;
      var oneYearNav = this.state.oneYearNav;
      var totalDate = this.state.totalDate;
      var totalNav = this.state.totalNav;

      if (totalNav.length == 0) {
        threeMonthDate = [];
        threeMonthNav = [];
        oneYearDate = [];
        oneYearNav = [];
        totalDate = [];
        totalNav = [];
        var oneYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["l" /* get1yearBefor */])();
        var threeMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["e" /* get3MonthBefor */])();
        for (var i = Datacontnet.length - 1; i >= 0; i--) {
          totalDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_2_2);
          // }else{
          //   totalNav.push(Datacontnet[i].value_2_1)
          // }
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(oneYear, Datacontnet[i].publish_date)) {
            oneYearDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_2_2);
            // }else{
            //   oneYearNav.push(Datacontnet[i].value_2_1)
            // }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["g" /* compareTime */])(threeMonth, Datacontnet[i].publish_date)) {
              threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
              // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_2_2);
              // }else{
              //   threeMonthNav.push(Datacontnet[i].value_2_1)
              // }
            }
          }
        }

        threeMonthDate = threeMonthDate.reverse(), threeMonthNav = threeMonthNav.reverse(), oneYearDate = oneYearDate.reverse(), oneYearNav = oneYearNav.reverse(), totalNav = totalNav.reverse(), totalDate = totalDate.reverse();
        this.setState({
          threeMonthDate: threeMonthDate,
          threeMonthNav: threeMonthNav,
          oneYearDate: oneYearDate,
          oneYearNav: oneYearNav,
          totalNav: totalNav,
          totalDate: totalDate,
          option: lineOption(threeMonthDate, threeMonthNav),
          data1: threeMonthDate,
          data2: threeMonthNav
        });
      }
    }
  }, {
    key: 'handleTab',
    value: function handleTab(a) {
      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
      // myChart.clear();
      //document.getElementById('PublicOfferLine').innerHTML = "";
      //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

      var that = this;
      if (a == "三个月") {
        // UmengStatis.onEvent('PublicOffering_ThreeMonth_Btn'); /*公募详情-三个月按钮*/
        that.setState({
          txt: "三个月",
          data1: this.state.threeMonthDate,
          data2: this.state.threeMonthNav
        });
      } else if (a === "近一年") {
        // UmengStatis.onEvent('PublicOffering_OneYears_Btn'); /*公募详情-近一年按钮*/
        that.setState({
          txt: "近一年",
          data1: this.state.oneYearDate,
          data2: this.state.oneYearNav
        });
        // 绘制图表
        //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));
      } else if (a === "成立以来") {
        // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
        that.setState({
          txt: "成立以来",
          data1: this.state.totalDate,
          data2: this.state.totalNav
        });
        //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this19 = this;

      var fundtype = this.props.dataInfo;
      var touzFx = getFx(fundtype);
      var data = this.props.data;
      var _state6 = this.state,
          data1 = _state6.data1,
          data2 = _state6.data2,
          txt = _state6.txt;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { background: "#FFF" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'tabLinTitle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "三个月" ? "clickTab" : "", onClick: function onClick() {
                  _this19.handleTab("三个月");
                } },
              '\u4E09\u4E2A\u6708'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "近一年" ? "clickTab" : "", onClick: function onClick() {
                  _this19.handleTab("近一年");
                } },
              '\u8FD1\u4E00\u5E74'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: txt === "成立以来" ? "clickTab" : "", onClick: function onClick() {
                  _this19.handleTab("成立以来");
                } },
              '\u6210\u7ACB\u4EE5\u6765'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineComponent, { data1: data1, data2: data2 })
        )
      );
    }
  }]);

  return TabLineComponentHTwo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*折线图option*/


function lineOption(dataName, dataSouce) {
  var option = {
    title: {
      text: ''
    },
    grid: {
      y: '13%',
      left: 37
    },
    // tooltip: {},
    // legend: {
    //     data:[]
    // },
    tooltip: {
      show: true,
      trigger: 'axis',
      alwaysShowContent: true,
      position: [width / 2, 0],
      padding: [16, 300, 0, 23],
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#48b',
          width: 1,
          type: 'dashed'
        },
        crossStyle: {
          color: '#1e90ff',
          width: 1,
          type: 'dashed'
        },
        shadowStyle: {
          color: 'rgba(150,150,150,0.3)',
          width: 'auto',
          type: 'default'
        }
      },
      backgroundColor: "#FFF",
      textStyle: {
        fontSize: 11,
        paddingLeft: 5,
        paddingRight: 5
      },
      formatter: '<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}%</span> </div>'
      //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
      // function(params,ticket,callBack) {
      //     var result = '';
      //     // params.forEach(function (item) {
      //     //     result =  item.name + ":" + item.data;
      //     // });
      //     result = params[0].name + params[0].data
      //     return result;
      // }
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      data: dataName,
      // name:'(年份)',
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#CCC"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      }
    }],
    axis: [{
      axisLline: {
        show: true,
        lineStyle: {
          color: '#99C4D7',
          width: 2,
          type: 'dashed'
        }
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        }
      }
    }],
    yAxis: [{
      type: 'value',
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0,
          color: "rgb(160,167,176)"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      },
      axisLabel: {
        rotate: 0,
        formatter: '{value}'
      }
    }],
    series: [{
      name: '单位净值',
      type: 'line',
      smooth: true,
      hoverAnimation: false,
      data: dataSouce,
      itemStyle: {
        normal: {
          color: '#fa063a', /*#53C6E0*/
          lineStyle: {
            color: '#fa063a'
          }
        }
      }
    }]
  };
  return option;
}

/*折线图option*/
function lineOptionL(dataName, dataSouce) {
  var option = {
    title: {
      text: ''
    },
    grid: {
      y: '13%',
      left: 37
    },
    // tooltip: {},
    // legend: {
    //     data:[]
    // },
    tooltip: {
      show: true,
      trigger: 'axis',
      alwaysShowContent: true,
      position: [width / 2, 0],
      padding: [16, 300, 0, 23],
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#48b',
          width: 1,
          type: 'dashed'
        },
        crossStyle: {
          color: '#1e90ff',
          width: 1,
          type: 'dashed'
        },
        shadowStyle: {
          color: 'rgba(150,150,150,0.3)',
          width: 'auto',
          type: 'default'
        }
      },
      backgroundColor: "#FFF",
      textStyle: {
        fontSize: 11,
        paddingLeft: 5,
        paddingRight: 5
      },
      formatter: '<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}%</span> </div>'
      //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
      // function(params,ticket,callBack) {
      //     var result = '';
      //     // params.forEach(function (item) {
      //     //     result =  item.name + ":" + item.data;
      //     // });
      //     result = params[0].name + params[0].data
      //     return result;
      // }
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      data: dataName,
      // name:'(年份)',
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#CCC"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      }
    }],
    axis: [{
      axisLline: {
        show: true,
        lineStyle: {
          color: '#99C4D7',
          width: 2,
          type: 'dashed'
        }
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        }
      }
    }],
    yAxis: [{
      type: 'value',
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0,
          color: "rgb(160,167,176)"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      },
      axisLabel: {
        rotate: 0,
        formatter: '{value}'
      }
    }],
    series: [{
      name: '累计净值',
      type: 'line',
      smooth: true,
      hoverAnimation: false,
      data: dataSouce,
      itemStyle: {
        normal: {
          color: '#fa063a', /*#53C6E0*/
          lineStyle: {
            color: '#fa063a'
          }
        }
      }
    }]
  };
  return option;
}

/*折线图option 万份收益*/
function lineOptionW(dataName, dataSouce) {
  var option = {
    title: {
      text: ''
    },
    grid: {
      y: '13%',
      left: 37
    },
    // tooltip: {},
    // legend: {
    //     data:[]
    // },
    tooltip: {
      show: true,
      trigger: 'axis',
      alwaysShowContent: true,
      position: [width / 2, 0],
      padding: [16, 300, 0, 23],
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#48b',
          width: 1,
          type: 'dashed'
        },
        crossStyle: {
          color: '#1e90ff',
          width: 1,
          type: 'dashed'
        },
        shadowStyle: {
          color: 'rgba(150,150,150,0.3)',
          width: 'auto',
          type: 'default'
        }
      },
      backgroundColor: "#FFF",
      textStyle: {
        fontSize: 11,
        paddingLeft: 5,
        paddingRight: 5
      },
      formatter: '<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}%</span> </div>'
      //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
      // function(params,ticket,callBack) {
      //     var result = '';
      //     // params.forEach(function (item) {
      //     //     result =  item.name + ":" + item.data;
      //     // });
      //     result = params[0].name + params[0].data
      //     return result;
      // }
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      data: dataName,
      // name:'(年份)',
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#CCC"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      }
    }],
    axis: [{
      axisLline: {
        show: true,
        lineStyle: {
          color: '#99C4D7',
          width: 2,
          type: 'dashed'
        }
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        }
      }
    }],
    yAxis: [{
      type: 'value',
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0,
          color: "rgb(160,167,176)"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      },
      axisLabel: {
        rotate: 0,
        formatter: '{value}'
      }
    }],
    series: [{
      name: '万份收益',
      type: 'line',
      smooth: true,
      hoverAnimation: false,
      data: dataSouce,
      itemStyle: {
        normal: {
          color: '#fa063a', /*#53C6E0*/
          lineStyle: {
            color: '#fa063a'
          }
        }
      }
    }]
  };
  return option;
}

/*折线图option 七日年化*/
function lineOptionQ(dataName, dataSouce) {
  var option = {
    title: {
      text: ''
    },
    grid: {
      y: '13%',
      left: 37
    },
    // tooltip: {},
    // legend: {
    //     data:[]
    // },
    tooltip: {
      show: true,
      trigger: 'axis',
      alwaysShowContent: true,
      position: [width / 2, 0],
      padding: [16, 300, 0, 23],
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: '#48b',
          width: 1,
          type: 'dashed'
        },
        crossStyle: {
          color: '#1e90ff',
          width: 1,
          type: 'dashed'
        },
        shadowStyle: {
          color: 'rgba(150,150,150,0.3)',
          width: 'auto',
          type: 'default'
        }
      },
      backgroundColor: "#FFF",
      textStyle: {
        fontSize: 11,
        paddingLeft: 5,
        paddingRight: 5
      },
      formatter: '<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:' + ('' + (true ? 'rgb(249,98,94)' : '#f0f')) + '>{c0}%</span> </div>'
      //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
      // function(params,ticket,callBack) {
      //     var result = '';
      //     // params.forEach(function (item) {
      //     //     result =  item.name + ":" + item.data;
      //     // });
      //     result = params[0].name + params[0].data
      //     return result;
      // }
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      data: dataName,
      // name:'(年份)',
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#CCC"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      }
    }],
    axis: [{
      axisLline: {
        show: true,
        lineStyle: {
          color: '#99C4D7',
          width: 2,
          type: 'dashed'
        }
      },
      splitArea: {
        areaStyle: {
          color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        }
      }
    }],
    yAxis: [{
      type: 'value',
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0,
          color: "rgb(160,167,176)"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0,
          color: "#9BC4D8"
        }
      },
      axisLabel: {
        rotate: 0,
        formatter: '{value}'
      }
    }],
    series: [{
      name: '七日年化',
      type: 'line',
      smooth: true,
      hoverAnimation: false,
      data: dataSouce,
      itemStyle: {
        normal: {
          color: '#fa063a', /*#53C6E0*/
          lineStyle: {
            color: '#fa063a'
          }
        }
      }
    }]
  };
  return option;
}

function getFx(fundtype) {
  var touzFx = "";
  if (fundtype == "股票型" || fundtype == "指数型") {
    touzFx = "高";
  } else if (fundtype == "混合型" || fundtype == "债券型") {
    touzFx = "中";
  } else if (fundtype == "货币型" || fundtype == "理财型") {
    touzFx = "低";
  }
  return touzFx;
}

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChooseTime__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















function MyBody(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'am-list-body my-body' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { style: { display: 'none' } },
      'you can custom body wrap element'
    ),
    props.children
  );
}

var data = [{
  img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
  title: 'Meet hotel',
  des: '不是所有的兼职汪都需要风吹日晒'
}, {
  img: 'https://zos.alipayobjects.com/rmsportal/XmwCzSeJiqpkuMB.png',
  title: 'McDonald\'s invites you',
  des: '不是所有的兼职汪都需要风吹日晒'
}, {
  img: 'https://zos.alipayobjects.com/rmsportal/hfVtzEhPzTUewPm.png',
  title: 'Eat the week',
  des: '不是所有的兼职汪都需要风吹日晒'
}];

var content = [{ "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-16", "allIncomeNext": "-19475.84", "serialNo": 1 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-15", "allIncomeNext": "-19475.84", "serialNo": 2 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-14", "allIncomeNext": "-19475.84", "serialNo": 3 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-13", "allIncomeNext": "-19475.84", "serialNo": 4 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-12", "allIncomeNext": "-19475.84", "serialNo": 5 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-11", "allIncomeNext": "-19475.84", "serialNo": 6 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-10", "allIncomeNext": "-19475.84", "serialNo": 7 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-09", "allIncomeNext": "-19475.84", "serialNo": 8 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-08", "allIncomeNext": "-19475.84", "serialNo": 9 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-07", "allIncomeNext": "-19475.84", "serialNo": 10 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-06", "allIncomeNext": "-19475.84", "serialNo": 11 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-05", "allIncomeNext": "-19475.84", "serialNo": 12 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-04", "allIncomeNext": "-19475.84", "serialNo": 13 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-03", "allIncomeNext": "-19475.84", "serialNo": 14 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-02", "allIncomeNext": "-19475.84", "serialNo": 15 }, { "dayIncome": "--", "allIncome": "-19475.84", "deadLine": "2017-11-01", "allIncomeNext": "-19475.84", "serialNo": 16 }];

var NUM_SECTIONS = 5;
var NUM_ROWS_PER_SECTION = 5;
var pageIndex = 0;

var seasonsTime = [{
  label: '全部时间',
  value: '0',
  key: 0
}, {
  label: '近一个月',
  value: '1',
  key: 1
}, {
  label: '近三个月',
  value: '3',
  key: 2
}, {
  label: '近半年',
  value: '6',
  key: 3
}, {
  label: '自选周期',
  value: 'zx',
  key: 4
}];

/*智投历史收益查询*/

var HistoryProfit = function (_Component) {
  _inherits(HistoryProfit, _Component);

  function HistoryProfit(props) {
    _classCallCheck(this, HistoryProfit);

    var _this2 = _possibleConstructorReturn(this, (HistoryProfit.__proto__ || Object.getPrototypeOf(HistoryProfit)).call(this, props));

    _this2.onEndReached = function (event) {
      var _this = _this2;
      // load new data
      // hasMore: from backend data, indicates whether it is the last page, here is false
      if (_this2.state.isLoading && !_this2.state.hasMore) {
        return;
      }

      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      console.log('reach end', event);
      var da = _this2.state.content.concat(content);
      console.log(da, "dadaadadadada");
      _this2.setState({ isLoading: true });

      // genData(++pageIndex);
      // setTimeout(() => {
      //   console.log("timetiem")
      //   this.setState({
      //     content:da,
      //     dataSource: ds.cloneWithRows(da),
      //     //dataSource:this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
      //     isLoading: false,
      //   });
      // })

      // this.setState({
      //   nomore:true
      // })
      var dataArr = [];
      var totalDataArr = [];
      // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)
      var dispatch = _this2.props.dispatch;

      // console.log(this.state.dataSource._cachedRowCount,"********", dataProps.length)

      var data = {
        beginDate: _this2.state.beginDate,
        fundCode: _this2.state.fundCode,
        endDate: _this2.state.endDate
        // this.setState({nomore:true}, ()=> {
        //   dispatch(getHistoryIcomeListSuper(data,this.handleCallback.bind(this),_this))
        // });
      };console.log(_this2.state.chooseBeginDate, _this2.state.beginDate, "时间时间", _this2.state.handleFlag);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["h" /* compareTimeTwo */])(_this2.state.chooseBeginDate, _this2.state.beginDate) && !_this2.state.handleFlag) {
        // Toast.loading('', 0, () => {});
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["l" /* getHistoryIcomeListSuper */])(data, _this2.handleCallback.bind(_this), _this));
      } else {

        _this2.setState({

          isLoading: 0
        });
      }
    };

    var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
        return r1 !== r2;
      } });
    var ua = navigator.userAgent.toLowerCase();
    _this2.state = {
      modalFlag: false,
      sValue: [""],
      timeValue: ["0"],
      seasons: [],
      allIncomes: 0,
      fundCode: "",
      beginDate: GetDateStr(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])()),
      endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])(),
      chooseBeginDate: "1990-01-01",
      chooseEndDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])(),
      totalDataArr: [],
      dataSource: ds.cloneWithRows([]),
      handleFlag: true,
      //dataSource,
      isLoading: true,
      content: [],
      height: ua.indexOf("hxcfH5WX") != -1 || ua.match(/MicroMessenger/i) == "micromessenger" ? window.winHeight - 86 : window.winHeight - 88 - 44,
      zxFlag: false
    };

    return _this2;
  }

  _createClass(HistoryProfit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var ua = navigator.userAgent.toLowerCase();
      console.log(ua.indexOf("hxcfH5WX"), "ua.indexOf");

      document.title = '历史收益查询';
      var dispatch = this.props.dispatch;

      var that = this;
      var data = {
        superFundCode: "",
        pageIndex: 1,
        pageSize: 99
      };
      document.getElementsByTagName('title')[0].innerHTML = "历史收益查询";
      // dispatch(getHistoryIcomeListSuper(data,this.callbackData.bind(this),that))
      // dispatch(getSupperFundHome({},(data)=>{},this))
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["f" /* getSupperFundHome */])({}, function (data) {
        console.log(data.singleSuperFundViews, "datadatadata", data);
        //let superHome = data ? ( data.singleSuperFundViews ? data.singleSuperFundViews : []) : null
        _this3.setState({
          superHome: data
        });
      }, this));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      var data = {
        beginDate: this.state.beginDate,
        fundCode: this.state.fundCode,
        endDate: this.state.endDate
      };

      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0, function () {});
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["l" /* getHistoryIcomeListSuper */])(data, this.handleCallback.bind(this), this));

      // const hei = window.winHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
      var hei = window.winHeight - 88 - 45;
      // simulate initial Ajax
      // setTimeout(() => {

      //   this.setState({
      //     dataSource: ds.cloneWithRows([]),
      //     //dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
      //     // isLoading: false,
      //     height: hei,
      //   });
      // }, 600);
    }
  }, {
    key: 'handleCallback',
    value: function handleCallback(data) {

      console.log(data, "datada******tadata");
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      var allIncomes = 0;
      var totalDataArr = this.state.totalDataArr.concat(data);
      if (data.length === 0) {
        this.setState({

          isLoading: 0
        });
      } else if (data.length < 15) {
        this.setState({

          dataSource: ds.cloneWithRows(totalDataArr),
          totalDataArr: totalDataArr,
          isLoading: 0,
          allIncomes: totalDataArr[0].allIncome,
          endDate: GetDateStr(this.state.beginDate, -1),
          beginDate: GetDateStr(this.state.beginDate)
        });
      } else {
        this.setState({
          dataSource: ds.cloneWithRows(totalDataArr),
          totalDataArr: totalDataArr,
          allIncomes: totalDataArr[0].allIncome,

          handleFlag: false,
          endDate: GetDateStr(this.state.beginDate, -1),
          beginDate: GetDateStr(this.state.beginDate),
          isLoading: false
        });
      }
      // Toast.hide()
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      console.log(data, "************");
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].go(-1);
      // let pathName = this.props.location.state.pathName ? this.props.location.state.pathName :'/';
      // let data = this.props.location.state.data ? this.props.location.state.data : null;
      // hashHistory.push({
      //     pathname:pathName,
      //     state:{

      //     }
      // })
    }
  }, {
    key: 'goTransactionDetail',
    value: function goTransactionDetail(item) {
      var data = {
        businessType: item.businessType,
        tradeRequestId: item.tradeRequestId
      };
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/TransactionDetail',
        state: {
          data: data
        }
      });
    }
  }, {
    key: 'handleProduct',
    value: function handleProduct(e) {
      var dispatch = this.props.dispatch;

      console.log(e, "eeeeee");
      //this.setState({ sValue:e })
      // let data = {
      //   superFundCode:e[0],
      //   pageIndex:1,
      //   pageSize:30,
      // }
      var tempbeginDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["h" /* compareTimeTwo */])(GetDateStr(this.state.chooseEndDate), this.state.chooseBeginDate) ? this.state.chooseBeginDate : GetDateStr(this.state.chooseEndDate);
      var data = {
        beginDate: tempbeginDate,
        fundCode: e[0],
        endDate: this.state.chooseEndDate
      };

      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });
      this.setState({
        isLoading: true,
        productAll: false,
        sValue: e,
        fundCode: e[0],
        beginDate: tempbeginDate,
        endDate: this.state.chooseEndDate,
        dataSource: ds.cloneWithRows([]),
        totalDataArr: [],
        allIncomes: 0,
        handleFlag: true
      });

      console.log(data, "allInData**78787878", GetDateStr(this.state.chooseEndDate), this.state.chooseEndDate);
      if (e[0] === "0000") {
        data.superFundCode = "";
      }
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["l" /* getHistoryIcomeListSuper */])(data, this.handleCallback.bind(this), this));
    }
  }, {
    key: 'handleTime',
    value: function handleTime(e) {
      var dispatch = this.props.dispatch;

      console.log(e, "eeeeee");
      var dateNow = null;
      if (e[0] == "1") {
        dateNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["d" /* getOneMonthBefor */])();
      } else if (e[0] == "3") {
        dateNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["e" /* get3MonthBefor */])();
      } else if (e[0] == "6") {
        dateNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["f" /* getSixMonthBefor */])();
      } else {
        dateNow = "1990-09-09";
      }
      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });

      console.log(dateNow, "dateNowdateNowdateNowdateNow");

      this.setState({

        isLoading: true,
        timeAll: false,
        timeValue: e,
        chooseBeginDate: dateNow,
        chooseEndDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])(),
        allIncomes: 0,
        beginDate: GetDateStr(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])()),
        endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])(),
        totalDataArr: [],
        dataSource: ds.cloneWithRows([]),
        handleFlag: true
      });
      var data = {
        beginDate: GetDateStr(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])()),
        fundCode: this.state.fundCode,
        endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["c" /* getDateNow */])()
      };
      if (e[0] === "0000") {
        data.superFundCode = "";
      }
      if (e[0] === "zx") {
        // hashHistory.push({
        //     pathname:'/ChooseTime',
        //     state:{
        //       data
        //     }
        // })
        this.setState({
          zxFlag: true
        });
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["l" /* getHistoryIcomeListSuper */])(data, this.handleCallback.bind(this), this));
      }
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      console.log("有无加载", this.state.isLoading);
      if (this.state.isLoading === true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u6B63\u5728\u52A0\u8F7D...'
        );
      } else if (this.state.isLoading === false) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u52A0\u8F7D\u5B8C\u6210'
        );
      } else if (this.state.isLoading === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 0, textAlign: 'center' } },
          '\u6CA1\u6709\u66F4\u591A\u6570\u636E\u4E86'
        );
      }
    }
  }, {
    key: 'ChooseTimeCallback2',
    value: function ChooseTimeCallback2(sDate, eDate) {

      console.log("开始和结束时间", sDate, eDate);
      this.setState({
        zxFlag: false
      });
    }
  }, {
    key: 'ChooseTimeCallback',
    value: function ChooseTimeCallback(sTime, eTime) {
      var _this = this;
      var dispatch = _this.props.dispatch;

      var ds = new __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["i" /* compareDate */])(sTime, eTime)) {
        this.setState({
          isLoading: true,
          zxFlag: false,
          productAll: false,
          dataSource: ds.cloneWithRows([]),
          totalDataArr: [],
          handleFlag: true,
          allIncomes: 0,
          chooseBeginDate: sTime,
          chooseEndDate: eTime,
          beginDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["h" /* compareTimeTwo */])(GetDateStr(eTime), sTime) ? sTime : GetDateStr(eTime),
          endDate: eTime
        });
        var _data = {
          beginDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["h" /* compareTimeTwo */])(GetDateStr(eTime), sTime) ? sTime : GetDateStr(eTime),
          endDate: eTime,
          fundCode: this.state.fundCode
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["l" /* getHistoryIcomeListSuper */])(_data, this.handleCallback.bind(this), this));
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("起始时间不能大于终止时间", __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.ToastTime);
      }
    }
  }, {
    key: 'closeChoose',
    value: function closeChoose() {
      this.setState({
        zxFlag: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var data = this.props.QueryTradeRecords ? this.props.QueryTradeRecords : [];
      var tempData = [{ businessTime: "0000" }];
      tempData = tempData.concat(data);
      var _state = this.state,
          allIncomes = _state.allIncomes,
          zxFlag = _state.zxFlag,
          superHome = _state.superHome;

      var seasons = [{
        label: '全部产品',
        value: '',
        key: 0
      }];
      superHome ? superHome.singleSuperFundViews ? superHome.singleSuperFundViews.map(function (itme, i) {
        seasons.push({
          label: itme.superFundName,
          value: itme.superFundCode,
          key: i + 2
        });
      }) : null : null;

      var heihgt = window.winHeight;
      var hei = window.winHeight - 86;

      var separator = function separator(sectionID, rowID) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          key: sectionID + '-' + rowID,
          style: {
            backgroundColor: '#F5F5F9',
            height: 8,
            borderTop: '1px solid #ECECED',
            borderBottom: '1px solid #ECECED'
          }
        });
      };
      var row = function row(rowData, sectionID, rowID) {
        // if (index < 0) {

        //   index = content.length - 1;
        // }
        // const obj = content[index--];
        console.log(rowID, "rowID");
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { background: "#FFF" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "flex", height: "45px", justifyContent: "space-between", flexDirection: "row", alignItems: "center", paddingLeft: "13px", paddingRight: "13px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: "13px", color: "#5b6370" } },
              rowData.deadLine
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: "13px", color: rowData.dayIncome >= 0 || rowData.dayIncome == "--" ? "#fb615b" : "#7fdd81" } },
              rowData.dayIncome
            )
          )
        );
        // return (
        //   <div key={rowID} style={{ padding: '0 15px' }}>
        //     <div
        //       style={{
        //         lineHeight: '50px',
        //         color: '#888',
        //         fontSize: 18,
        //         borderBottom: '1px solid #F6F6F6',
        //       }}
        //     >{obj.title}</div>
        //     <div style={{ display: '-webkit-box', display: 'flex', padding: '15px 0' }}>
        //       <img style={{ height: '64px', marginRight: '15px' }} src={obj.img} alt="" />
        //       <div style={{ lineHeight: 1 }}>
        //         <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>{obj.des}</div>
        //         <div><span style={{ fontSize: '30px', color: '#FF6E27' }}>35</span>¥ {rowID}</div>
        //       </div>
        //     </div>
        //   </div>
        // );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1, flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this4.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, flex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u5386\u53F2\u6536\u76CA\u67E5\u8BE2'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, flex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '0.26rem' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'chooseSelects_Wrap', style: _defineProperty({ display: "-webkit-flex" }, 'display', "flex") },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'chooseSelect_Wrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: seasons, cols: 1, className: 'forss', title: '\u4EA7\u54C1', value: this.state.sValue, onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    _this4.handleProduct(e);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item, null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rightBottomArrow', style: { position: 'absolute', right: '0.36rem', top: "50%", zIndex: 2 } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'chooseSelect_Wrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: seasonsTime, cols: 1, className: 'forss', title: '\u65F6\u95F4', value: this.state.timeValue, onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    _this4.handleTime(e);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item, null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rightBottomArrow', style: { position: 'absolute', right: '0.36rem', top: "50%", zIndex: 2 } })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'Adjust_listHeaderInconme' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: "13px", color: "#5b6370" } },
              '\u7D2F\u8BA1\u76C8\u4E8F(\u5143)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: allIncomes >= 0 ? "#fb615b" : "#7fdd81" } },
              allIncomes
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ListViewWrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ListView"], {
              ref: function ref(el) {
                return _this4.lv = el;
              },
              dataSource: this.state.dataSource,
              renderFooter: function renderFooter() {
                return _this4.renderFooter();
              },
              renderBodyComponent: function renderBodyComponent() {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MyBody, null);
              },
              renderRow: function renderRow(rowData, sectionID, rowID) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { background: "#FFF", overflow: "auto" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'HistoryProfitList' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: "13px", color: "#5b6370" } },
                        rowData.deadLine
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: "13px", color: rowData.dayIncome >= 0 || rowData.dayIncome == "--" ? "#fb615b" : "#7fdd81" } },
                        rowData.dayIncome
                      )
                    )
                  )
                );
              },

              renderSeparator: separator,
              style: {
                height: this.state.height,
                overflow: 'auto'
              },
              pageSize: 4,
              onScroll: function onScroll() {
                console.log('scroll');
              },
              scrollRenderAheadDistance: 500,
              onEndReached: this.onEndReached,
              onEndReachedThreshold: 15,
              initialListSize: 15
            })
          )
        ),
        zxFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ChooseTime__["a" /* default */], { callback: this.ChooseTimeCallback.bind(this), closeBack: this.closeChoose.bind(this) }) : null
      );
    }
  }]);

  return HistoryProfit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords,
    SupperFundHome: state.SupperFundHome
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HistoryProfit));

function GetDateStr(beginDate) {
  var AddDayCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -15;

  var dd = new Date(beginDate.replace(/\-/g, '/'));
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期  
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0  
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0  
  return y + "-" + m + "-" + d;
}

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var WebView = function (_Component) {
  _inherits(WebView, _Component);

  function WebView(props) {
    _classCallCheck(this, WebView);

    var _this2 = _possibleConstructorReturn(this, (WebView.__proto__ || Object.getPrototypeOf(WebView)).call(this, props));

    _this2.state = {};
    return _this2;
  }

  _createClass(WebView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = this.props.location.state.title;
    }
  }, {
    key: 'next',
    value: function next() {
      var _this3 = this;

      console.log(this.props.location.state.route, window.history.length);
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-1);
      setTimeout(function () {
        _this3.props.location.state.refreshPage ? _this3.props.location.state.refreshPage() : null;
      }, 100);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _this = this;
      console.log(this.props.location);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.props.location.state.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'share' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'shareTitle', style: { color: '#5b6370', fontSize: '.26rem' } },
              this.props.location.state.content
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'question_suc_box' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: '100%' } },
              this.props.location.state.dataSouse.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: 'cq' + i, className: 'question_suc_item' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: "0.32rem", WebkitFlex: 1, color: '#3a3e47' } },
                    item[0]
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { color: 'rgba(130,138,138,1)', WebkitFlex: 1, textAlign: 'right' } },
                    item[1]
                  )
                );
              })
            )
          ),
          this.props.location.state.tipVal != '' || this.props.location.state.tipVal != undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'question_suc_tip' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { color: '#5b6370' } },
              '\u98CE\u9669\u63D0\u793A\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: '.24rem', color: '#a1a7b2' } },
              this.props.location.state.tipVal
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this4.next();
              }, className: 'btn' },
            '\u6211\u5DF2\u77E5\u6653'
          )
        )
      );
    }
  }]);

  return WebView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(WebView));

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var questionsArr = [{
  title: '此基金产品是高风险产品，您是否确定已经了解其风险？',
  selections: ['是', '否']
}, {
  title: '此基金产品是高风险产品，可能因市场波动导致本金损失，您是否已充分考虑该投资风险？',
  selections: ['是', '否']
}];

var HighestRiskPoint = function (_Component) {
  _inherits(HighestRiskPoint, _Component);

  function HighestRiskPoint(props) {
    _classCallCheck(this, HighestRiskPoint);

    var _this2 = _possibleConstructorReturn(this, (HighestRiskPoint.__proto__ || Object.getPrototypeOf(HighestRiskPoint)).call(this, props));

    _this2.state = {};
    _this2.answers = [];
    _this2.goCallback = false;
    return _this2;
  }

  _createClass(HighestRiskPoint, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = '特高风险提示';
    }
  }, {
    key: 'makeAnswers',
    value: function makeAnswers(key, answer) {
      this.answers[key] = answer;
    }
  }, {
    key: 'addQuestions',
    value: function addQuestions(queArr) {
      var _this3 = this;

      return queArr.map(function (item, index, array) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Question, { key: index, index: index, makeAnswers: function makeAnswers(key, answer) {
            _this3.makeAnswers(key, answer);
          }, question: item });
      });
    }
  }, {
    key: 'goOn',
    value: function goOn() {
      var length = 0;
      this.answers.forEach(function (item, index, array) {
        length++;
      });
      if (length != questionsArr.length) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请回答上述全部问题！', __WEBPACK_IMPORTED_MODULE_5__util_js___default.a.ToastTime);
        return;
      }
      if (this.answers.some(function (item, index, array) {
        return item;
      })) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请充分了解和考虑该产品的投资风险之后，再进行购买！', __WEBPACK_IMPORTED_MODULE_5__util_js___default.a.ToastTime);
        return;
      }
      this.goCallback = true;
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].go(-1);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.goCallback) {
        this.props.location.state.callback ? this.props.location.state.callback() : null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _this = this;
      console.log(this.props.location);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u7279\u9AD8\u98CE\u9669\u63D0\u793A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content paddB40' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'HighestRisk_header' },
            '\u8BE5\u4EA7\u54C1\u5C5E\u4E8E\u9AD8\u98CE\u9669\u4EA7\u54C1\uFF0C\u79C1\u52DF\u80A1\u6743\u6295\u8D44\u57FA\u91D1\u5177\u6709\u6BD4\u8F83\u9AD8\u7684\u98CE\u9669\uFF0C\u5176\u4FE1\u606F\u62AB\u9732\u7684\u9891\u7387\u8F83\u4F4E\uFF0C\u6CE2\u52A8\u7387\u9AD8\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'riskQuestionTitleView' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u6309\u7167\u300A\u8BC1\u5238\u671F\u8D27\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u529E\u6CD5\u300B\u89C4\u5B9A\uFF0C\u6295\u8D44\u7279\u9AD8\u98CE\u9669\u4EA7\u54C1\u9700\u8981\u56DE\u7B54\u5982\u4E0B\u95EE\u9898\uFF1A'
            )
          ),
          this.addQuestions(questionsArr)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'bottomView' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bottomLeftTouchView', onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'bottomLeftView' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u53D6\u6D88'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bottomRightTouchView', onClick: function onClick() {
                _this4.goOn();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'bottomRightView' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '\u786E\u5B9A\u5E76\u8FDB\u5165\u4E0B\u4E00\u6B65'
              )
            )
          )
        )
      );
    }
  }]);

  return HighestRiskPoint;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Question = function (_Component2) {
  _inherits(Question, _Component2);

  function Question(props) {
    _classCallCheck(this, Question);

    var _this5 = _possibleConstructorReturn(this, (Question.__proto__ || Object.getPrototypeOf(Question)).call(this, props));

    _this5.state = {
      // yesOrNo : null
    };
    _this5.selectionsArray = [];
    return _this5;
  }

  _createClass(Question, [{
    key: 'selectionAction',
    value: function selectionAction(key) {
      this.selectionsArray.forEach(function (item, index, array) {
        if (key == index) {
          item.setState({
            isSelected: true
          });
        } else {
          item.setState({
            isSelected: false
          });
        }
      });
      this.props.makeAnswers(this.props.index, key);
    }
  }, {
    key: 'addSelection',
    value: function addSelection(selections) {
      var _this6 = this;

      return selections.map(function (item, index, array) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Selection, { option: item, callback: function callback(key) {
            _this6.selectionAction(key);
          }, ref: function ref(selection) {
            _this6.selectionsArray[index] = selection;
          }, key: index, index: index });
      });
    }
  }, {
    key: 'render',
    value: function render() {

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'questionView' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          Number(this.props.index) + 1 + '、' + this.props.question.title
        ),
        this.addSelection(this.props.question.selections)
      );
    }
  }]);

  return Question;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Selection = function (_Component3) {
  _inherits(Selection, _Component3);

  function Selection(props) {
    _classCallCheck(this, Selection);

    var _this7 = _possibleConstructorReturn(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).call(this, props));

    _this7.state = {
      isSelected: false
    };
    return _this7;
  }

  _createClass(Selection, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'questionnaireContent', onClick: function onClick() {
            _this8.props.callback(_this8.props.index);
          } },
        this.state.isSelected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(151) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(125) }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.props.option
        )
      );
    }
  }]);

  return Selection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HighestRiskPoint));

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_ModelEvaluationcopy__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_riskInPayAction__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Question_css__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Question_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Question_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var QuestionnaireList = function (_Component) {
  _inherits(QuestionnaireList, _Component);

  function QuestionnaireList(props) {
    _classCallCheck(this, QuestionnaireList);

    var _this = _possibleConstructorReturn(this, (QuestionnaireList.__proto__ || Object.getPrototypeOf(QuestionnaireList)).call(this, props));

    _this.state = {
      questionnaireType: '公募',
      questionnaireTypeNumber: 3,
      questionnaireNumber: 1,
      questionnaireTotalNumber: 1,
      questionnaireArray: [{ content: '', options: [] }],
      loadingFlag: false,
      disableSelectItem: false,
      alertFlag: false,
      stopType: '',
      yyrgArr: [],
      dtjhArr: [],
      alertContent: '根据最新的评测结果，超出风险承受能力的计划类交易将被终止。如果您对自己的风险等级有异议，建议重新测评。'
    };
    _this.answers = [];
    _this.questionnaireSelectedOption = [];
    return _this;
  }

  _createClass(QuestionnaireList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "公募答题问卷";
      this.toGetQuestionnaireList();
    }
  }, {
    key: 'toGetQuestionnaireList',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* getTempInfo */])('shortToken');

              case 2:
                _context.t0 = _context.sent;
                _context.t1 = this.state.questionnaireTypeNumber;
                params = {
                  token: _context.t0,
                  questionnaireNo: _context.t1
                };

                console.log(params);
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["c" /* getQuestionnaireList */])(params, function (questionnaireList) {
                  _this2.getQuestionnaireSuccess(questionnaireList);
                }, function (msg) {
                  _this2.getQuestionnaireError(msg);
                }));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function toGetQuestionnaireList() {
        return _ref.apply(this, arguments);
      }

      return toGetQuestionnaireList;
    }()
  }, {
    key: 'getQuestionnaireSuccess',
    value: function getQuestionnaireSuccess(questionnaireList) {
      this.setState({
        questionnaireArray: questionnaireList,
        questionnaireTotalNumber: questionnaireList.length
      });
      console.log(questionnaireList, questionnaireList.length);
    }
  }, {
    key: 'getQuestionnaireError',
    value: function getQuestionnaireError(msg) {}
  }, {
    key: 'handleSelectedOption',
    value: function handleSelectedOption(key) {
      this.setState({ disableSelectItem: false });
      this.answers.push({ answerNo: '' + this.state.questionnaireNumber, optionNo: key });
      this.setState({
        questionnaireNumber: this.state.questionnaireNumber + 1
      });
      // console.log(this.answers,'*******',this.state.questionnaireNumber);
    }
  }, {
    key: 'clickItem',
    value: function clickItem(i) {
      var _this3 = this;

      if (this.state.disableSelectItem) {
        return;
      }
      this.questionnaireSelectedOption = this.questionnaireSelectedOption.slice(0, this.state.questionnaireNumber - 1);
      this.questionnaireSelectedOption.push(this.state.questionnaireArray[this.state.questionnaireNumber - 1].options[i].optionId);
      this.setState({
        disableSelectItem: true
      });
      setTimeout(function () {
        return _this3.handleSelectedOption(_this3.state.questionnaireArray[_this3.state.questionnaireNumber - 1].options[i].optionId);
      }, 40);
    }
  }, {
    key: 'handleSaveRiskResult',
    value: function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(key) {
        var _this4 = this;

        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({ loadingFlag: true });
                if (this.answers.length < this.state.questionnaireTotalNumber) {
                  this.answers.push({ answerNo: '' + this.state.questionnaireNumber, optionNo: key });
                }
                _context2.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* getTempInfo */])('shortToken');

              case 4:
                _context2.t0 = _context2.sent;
                _context2.t1 = this.state.questionnaireTypeNumber;
                _context2.t2 = JSON.stringify(this.answers);
                params = {
                  token: _context2.t0,
                  raiseMethod: '9',
                  questionnaireNo: _context2.t1,
                  answers: _context2.t2
                };

                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["d" /* previewPlanRisk */])(params, function (result) {
                  var xzRiskArr = [];
                  var riskMismatch = [];
                  var yyrgArr = [];
                  var dtjhArr = [];
                  if (result && result.length > 0) {
                    if (result[0].riskRearRank == "1") {
                      /* 答了 R1 */
                      for (var ii = 0; ii < result.length; ii++) {
                        if (result[ii].planType == "10" && Number(result[ii].riskLevel) > Number(result[ii].riskRearRank)) {
                          yyrgArr.push(result[ii].fundName);
                        } else if (result[ii].planType != "10" && Number(result[ii].riskLevel) > Number(result[ii].riskRearRank)) {
                          dtjhArr.push(result[ii].fundName);
                        }
                      }
                      if (yyrgArr.length > 0 || dtjhArr.length > 0) {
                        var showContent = dtjhArr.length > 0 && yyrgArr.length > 0 ? '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5177\u4F53\u5305\u62EC\uFF1A' + dtjhArr + ',' + yyrgArr + '\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002' : dtjhArr.length > 0 && yyrgArr.length == 0 ? '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5177\u4F53\u5305\u62EC\uFF1A' + dtjhArr + '\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002' : dtjhArr.length == 0 && yyrgArr.length > 0 ? '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5177\u4F53\u5305\u62EC\uFF1A' + yyrgArr + '\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002' : '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002';
                        _this4.setState({
                          alertFlag: true,
                          alertContent: showContent,
                          stopType: ""
                        });
                      } else {
                        _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["e" /* saveRiskResult */])(params, function (content) {
                          _this4.saveRiskResultSuccess(content);
                        }, function (msg) {
                          _this4.saveRiskResultError(msg);
                        }));
                      }
                    } else {
                      for (var i = 0; i < result.length; i++) {
                        if (Number(result[i].riskLevel) > Number(result[i].riskRearRank)) {
                          if (result[i].raiseMethod == "6" || result[i].raiseMethod == "8") {
                            /*资管类、且产品风险等级大于答问券风险等级*/
                            xzRiskArr.push(result[i]);
                          } else {
                            riskMismatch.push(result[i]);
                          }
                        }
                      }
                      if (xzRiskArr.length > 0) {
                        for (var j = 0; j < xzRiskArr.length; j++) {
                          if (xzRiskArr[j].planType == "10") {
                            yyrgArr.push(xzRiskArr[j].fundName);
                          } else {
                            dtjhArr.push(xzRiskArr[j].fundName);
                          }
                        }
                        var yyrgArr2 = [];
                        var dtjhArr2 = [];
                        for (var kk = 0; kk < riskMismatch.length; kk++) {
                          if (riskMismatch[kk].planType == "10") {
                            yyrgArr2.push(riskMismatch[kk].fundName);
                          } else {
                            dtjhArr2.push(riskMismatch[kk].fundName);
                          }
                        }
                        var _showContent = dtjhArr.length > 0 && yyrgArr.length > 0 ? '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5177\u4F53\u5305\u62EC\uFF1A' + dtjhArr + ',' + yyrgArr + '\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002' : dtjhArr.length > 0 && yyrgArr.length == 0 ? '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5177\u4F53\u5305\u62EC\uFF1A' + dtjhArr + '\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002' : dtjhArr.length == 0 && yyrgArr.length > 0 ? '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5177\u4F53\u5305\u62EC\uFF1A' + yyrgArr + '\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002' : '\u6839\u636E\u6700\u65B0\u7684\u8BC4\u6D4B\u7ED3\u679C\uFF0C\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\u5C06\u88AB\u7EC8\u6B62\u3002\u5982\u679C\u60A8\u5BF9\u81EA\u5DF1\u7684\u98CE\u9669\u7B49\u7EA7\u6709\u5F02\u8BAE\uFF0C\u5EFA\u8BAE\u91CD\u65B0\u8BC4\u6D4B\u3002';
                        _this4.setState({
                          alertFlag: true,
                          stopType: "1",
                          alertContent: _showContent,
                          yyrgArr: yyrgArr2,
                          dtjhArr: dtjhArr2
                        });
                      } else {
                        for (var k = 0; k < riskMismatch.length; k++) {
                          if (riskMismatch[k].planType == "10") {
                            yyrgArr.push(riskMismatch[k].fundName);
                          } else {
                            dtjhArr.push(riskMismatch[k].fundName);
                          }
                        }
                        _this4.setState({
                          yyrgArr: yyrgArr,
                          dtjhArr: dtjhArr
                        }, function () {
                          console.log("没有限制只有不匹配，提交答案走结果页");
                          _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["e" /* saveRiskResult */])(params, function (content) {
                            _this4.saveRiskResultSuccess(content);
                          }, function (msg) {
                            _this4.saveRiskResultError(msg);
                          }));
                        });
                      }
                    }
                  } else {
                    console.log("[], 提交答案走结果页");
                    _this4.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["e" /* saveRiskResult */])(params, function (content) {
                      _this4.saveRiskResultSuccess(content);
                    }, function (msg) {
                      _this4.saveRiskResultError(msg);
                    }));
                  }
                  console.log(result, "是否匹配返回");
                }, function (msg) {
                  _this4.setState({
                    loadingFlag: false,
                    disableSelectItem: false
                  });
                  __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.ToastTime);
                  _this4.answers.pop();
                  console.log(msg, "msg");
                }));
                // this.props.dispatch(saveRiskResult(params, (content)=>{this.saveRiskResultSuccess(content)}, (msg)=>{this.saveRiskResultError(msg)}));
                // this.props.navigator.popToRoute(this.props.route);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSaveRiskResult(_x) {
        return _ref2.apply(this, arguments);
      }

      return handleSaveRiskResult;
    }()
  }, {
    key: 'saveRiskResultSuccess',
    value: function saveRiskResultSuccess(content) {
      this.setState({ loadingFlag: false });
      this.setState({ disableSelectItem: false });
      console.log(this.props.location);
      var _state = this.state,
          dtjhArr = _state.dtjhArr,
          yyrgArr = _state.yyrgArr;

      var tipVal = '';
      var showContent = dtjhArr.length > 0 && yyrgArr.length > 0 ? '\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\uFF1A' + dtjhArr + ',' + yyrgArr + '\u3002' : dtjhArr.length > 0 && yyrgArr.length == 0 ? '\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\uFF1A' + dtjhArr + '\u3002' : dtjhArr.length == 0 && yyrgArr.length > 0 ? '\u8D85\u51FA\u98CE\u9669\u627F\u53D7\u80FD\u529B\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\uFF1A' + yyrgArr + '\u3002' : "";
      // if(this.props.location.state.raiseMethod=='9'){
      var fundList = '';
      for (var i = 0; i < content.fundList.length; i++) {
        fundList += content.fundList[i].fundName;
        i < content.fundList.length - 1 ? fundList += '、' : fundList += '。';
      }
      console.log(content.fundList, 'xxxxx');
      if (content.hasDiffFunds) {
        tipVal = '\u60A8\u6700\u65B0\u7684\u98CE\u9669\u7B49\u7EA7\u4E3A' + content.rank + '\uFF0C\u4E0A\u4E00\u6B21\u6D4B\u8BC4\u7ED3\u679C\u4E3A' + (content.lastRankName ? content.lastRankName : '空') + '\u3002' + (content.fundList.length != 0 ? '\u60A8\u6301\u6709\u4E2D\u7684\u90E8\u5206\u4EA7\u54C1\u4E0E\u60A8\u7684\u98CE\u9669\u7B49\u7EA7\u4E0D\u5339\u914D\uFF0C\u8BF7\u6CE8\u610F\u6301\u4ED3\u98CE\u9669\uFF1A' + fundList + ' ' + showContent : '' + showContent);
      } else {
        tipVal = '\u60A8\u6700\u65B0\u7684\u98CE\u9669\u7B49\u7EA7\u4E3A' + content.rank + '\uFF0C\u4E0A\u4E00\u6B21\u6D4B\u8BC4\u7ED3\u679C\u4E3A' + (content.lastRankName ? content.lastRankName : '空') + '\u3002' + (content.fundList.length != 0 ? '\u60A8\u6301\u6709\u4E2D\u7684\u4EA7\u54C1\u4E0E\u60A8\u7684\u98CE\u9669\u7B49\u7EA7\u5B8C\u5168\u5339\u914D\u3002' : '' + showContent);
      }

      // }
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].replace({
        pathname: '/FinishQuestionnaireSuccess',
        state: {
          title: '调查问卷',
          content: '恭喜您完成了风险测评问卷，您的风险测评结果为：',
          dataSouse: [['投资人姓名：', content.name], ['问卷编号：', content.questionnaireNo], ['问卷得分：', content.score], ['风险承受能力：', content.rank]],
          tipVal: tipVal,
          route: this.props.location.state.route,
          refreshPage: this.props.location.state.refreshPage
        }
      });

      // hashHistory.replace({
      //   pathname:'/FinishQuestionnaireSuccess',
      //   state: {
      //     title:'调查问卷',
      //     content:'恭喜您完成了风险测评问卷，您的风险测评结果为：',
      //     dataSouse:[['投资人姓名：',content.name],['问卷编号：',content.questionnaireNo],['问卷得分：',content.score]
      //     ,['风险承受能力：',content.rank]],
      //     tipVal:tipVal,
      //     refreshPage:this.props.location.state.refreshPage,route:this.props.location.state.route
      //   },
      // })
    }
  }, {
    key: 'saveRiskResultError',
    value: function saveRiskResultError(msg) {
      this.setState({ loadingFlag: false });
      this.setState({ disableSelectItem: false });
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.ToastTime);
      this.answers.pop();
    }
  }, {
    key: 'handleGo',
    value: function handleGo() {
      this.setState({
        loadingFlag: false,
        disableSelectItem: false,
        alertFlag: false,
        questionnaireNumber: 1
      });
      this.answers = [];
    }
  }, {
    key: 'closeMoadl',
    value: function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(key) {
        var _this5 = this;

        var dispatch, params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch = this.props.dispatch;

                if (this.answers.length < this.state.questionnaireTotalNumber) {
                  this.answers.push({ answerNo: '' + this.state.questionnaireNumber, optionNo: key });
                }
                console.log(this.state.questionnaireTypeNumber, "questionnaireNoquestionnaireNoquestionnaireNo");
                _context3.next = 5;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["b" /* getTempInfo */])('shortToken');

              case 5:
                _context3.t0 = _context3.sent;
                _context3.t1 = this.state.questionnaireTypeNumber;
                _context3.t2 = JSON.stringify(this.answers);
                _context3.t3 = this.state.stopType;
                params = {
                  token: _context3.t0,
                  questionnaireNo: _context3.t1,
                  answers: _context3.t2,
                  stopType: _context3.t3
                };


                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["f" /* stopPlanByRiskResult */])(params, function (res) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info("终止成功", __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.ToastTime);
                  console.log(res, "终止");
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_riskInPayAction__["c" /* traceSave */])({ action: 'BUY_RISK_WARN_FIRST', message: '重新测评后，用户确认终止风险不匹配的计划类交易' })); /*终止留痕*/
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_questionnairesAction__["e" /* saveRiskResult */])(Object.assign(params, { raiseMethod: _this5.props.location.state.raiseMethod }), function (content) {
                    _this5.saveRiskResultSuccess(content);
                  }, function (msg) {
                    _this5.saveRiskResultError(msg);
                  }));
                }, function (err) {
                  __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info(err, __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.ToastTime);
                  console.log(err, "终止err");
                }));
                this.setState({
                  alertFlag: false,
                  loadingFlag: false
                });

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function closeMoadl(_x2) {
        return _ref3.apply(this, arguments);
      }

      return closeMoadl;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var navigator = this.props.navigator;

      var optionsArray = [];
      console.log(this.props.location);
      // 1~(n-1)页问题列表
      if (this.state.questionnaireNumber <= this.state.questionnaireTotalNumber - 1) {
        optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'share', style: { color: '#5b6370', height: 'auto', paddingBottom: '10px' }, key: '1' },
          this.state.questionnaireNumber + '\u3001' + this.state.questionnaireArray[this.state.questionnaireNumber - 1].content
        ));

        var _loop = function _loop(i) {
          console.log('\u6570\u7EC4\uFF1A' + _this6.answers.length + '\uFF0C\u4E0B\u6807' + (_this6.state.questionnaireNumber - 1) + ',\u4EC0\u4E48\u4E1C\u897F' + _this6.answers[_this6.state.questionnaireNumber - 1]);
          console.log(_this6.questionnaireSelectedOption, _this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].optionId);
          optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this6.clickItem(i);
              }, disabled: _this6.state.disableSelectItem },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitAlignItems: 'center', background: '#fff', borderBottom: '1px solid rgba(242,245,247,1)', height: '62px' } },
              _this6.questionnaireSelectedOption[_this6.state.questionnaireNumber - 1] == _this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].optionId ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: '0.88rem', height: '0.88rem' }, src: __webpack_require__(55) }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: '0.88rem', height: '0.88rem' }, src: __webpack_require__(51) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { WebkitFlex: 1 } },
                _this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].content
              )
            )
          ));
        };

        for (var i = 0; i < this.state.questionnaireArray[this.state.questionnaireNumber - 1].options.length; i++) {
          _loop(i);
        }
        // 第一页不显示上一题按钮
        this.state.questionnaireNumber == 1 ? optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: '2' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitJustifyContent: 'flex-end', marginTop: '0.3rem' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              this.state.questionnaireNumber
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '/' + this.state.questionnaireTotalNumber
            )
          )
        )) : optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: "-webkit-flex", WebkitJustifyContent: 'space-between', marginTop: '0.31rem' }, key: '2' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this6.setState({ questionnaireNumber: _this6.state.questionnaireNumber - 1, disableSelectItem: false });_this6.answers.pop();
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E0A\u4E00\u9898'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitJustifyContent: 'flex-end' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              this.state.questionnaireNumber
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '/' + this.state.questionnaireTotalNumber
            )
          )
        ));
      }

      // 最后一页问题列表
      if (this.state.questionnaireNumber == this.state.questionnaireTotalNumber) {
        optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'share', style: { color: '#5b6370', height: 'auto' }, key: '1' },
          this.state.questionnaireNumber + '\u3001' + this.state.questionnaireArray[this.state.questionnaireNumber - 1].content
        ));

        var _loop2 = function _loop2(i) {
          optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this6.setState({ questionnaireSelectedOption: _this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].optionId, disableSelectItem: true });_this6.handleSaveRiskResult(_this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].optionId);
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitAlignItems: 'center', background: '#fff', borderBottom: '1px solid rgba(242,245,247,1)', height: '62px' } },
              _this6.state.questionnaireSelectedOption == _this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].optionId ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: '0.88rem', height: '0.88rem' }, src: __webpack_require__(55) }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: '0.88rem', height: '0.88rem' }, src: __webpack_require__(51) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                _this6.state.questionnaireArray[_this6.state.questionnaireNumber - 1].options[i].content
              )
            )
          ));
        };

        for (var i = 0; i < this.state.questionnaireArray[this.state.questionnaireNumber - 1].options.length; i++) {
          _loop2(i);
        }
        optionsArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { display: "-webkit-flex", WebkitJustifyContent: 'space-between', marginTop: '0.31rem' }, key: '2' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this6.setState({ questionnaireNumber: _this6.state.questionnaireNumber - 1, disableSelectItem: false });_this6.answers.pop();
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E0A\u4E00\u9898'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitJustifyContent: 'flex-end' } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              this.state.questionnaireNumber
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '/' + this.state.questionnaireTotalNumber
            )
          )
        ));
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u516C\u52DF\u7B54\u9898\u95EE\u5377'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content', style: { fontSize: '13px' } },
          optionsArray
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modal_ModelEvaluationcopy__["a" /* default */], null),
        this.state.alertFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__fundDetail_AlerModle__["a" /* AlerModleCommon */], {
          btnTxt1: '\u786E\u8BA4\u7EC8\u6B62',
          btnTxt2: '\u91CD\u65B0\u6D4B\u8BC4',
          content: this.state.alertContent,
          title: '\u98CE\u9669\u63D0\u793A',
          handleClick1: this.closeMoadl.bind(this),
          handleClick2: this.handleGo.bind(this)
        }) : null
      );
    }
  }]);

  return QuestionnaireList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(QuestionnaireList));

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CertificationCardAgain = function (_Component) {
	_inherits(CertificationCardAgain, _Component);

	function CertificationCardAgain() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CertificationCardAgain);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertificationCardAgain.__proto__ || Object.getPrototypeOf(CertificationCardAgain)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			cardNumber: _this.props.smrzCardNumber,
			enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null
		}, _this.goCertification = function () {
			var _this$props$location$ = _this.props.location.state,
			    savePicFun = _this$props$location$.savePicFun,
			    name = _this$props$location$.name,
			    certNo = _this$props$location$.certNo,
			    address = _this$props$location$.address,
			    careerCode = _this$props$location$.careerCode,
			    cityCode = _this$props$location$.cityCode,
			    provinceCode = _this$props$location$.provinceCode,
			    actualBeneficiary = _this$props$location$.actualBeneficiary,
			    actualController = _this$props$location$.actualController,
			    actualBeneficiaryCertType = _this$props$location$.actualBeneficiaryCertType,
			    actualBeneficiaryCertNo = _this$props$location$.actualBeneficiaryCertNo,
			    actualControllerCertType = _this$props$location$.actualControllerCertType,
			    actualControllerCertNo = _this$props$location$.actualControllerCertNo,
			    officialsOrRelatives = _this$props$location$.officialsOrRelatives,
			    phoneNo = _this$props$location$.phoneNo,
			    annualIncomeV2 = _this$props$location$.annualIncomeV2,
			    annualIncome = _this$props$location$.annualIncome,
			    actualControllerBirthday = _this$props$location$.actualControllerBirthday,
			    actualControllerValidTerm = _this$props$location$.actualControllerValidTerm,
			    actualControllerValidEver = _this$props$location$.actualControllerValidEver,
			    actualControllerSex = _this$props$location$.actualControllerSex,
			    actualControllerMobileNo = _this$props$location$.actualControllerMobileNo,
			    actualControllerProvince = _this$props$location$.actualControllerProvince,
			    actualControllerProfession = _this$props$location$.actualControllerProfession,
			    actualControllerAddress = _this$props$location$.actualControllerAddress,
			    actualControllerPostcode = _this$props$location$.actualControllerPostcode,
			    actualControllerEmail = _this$props$location$.actualControllerEmail,
			    actualBeneficiaryValidTerm = _this$props$location$.actualBeneficiaryValidTerm,
			    actualBeneficiaryValidEver = _this$props$location$.actualBeneficiaryValidEver,
			    actualBeneficiarySex = _this$props$location$.actualBeneficiarySex,
			    actualBeneficiaryBirthday = _this$props$location$.actualBeneficiaryBirthday,
			    actualBeneficiaryMobileNo = _this$props$location$.actualBeneficiaryMobileNo,
			    actualBeneficiaryProvince = _this$props$location$.actualBeneficiaryProvince,
			    actualBeneficiaryAddress = _this$props$location$.actualBeneficiaryAddress,
			    actualBeneficiaryPostcode = _this$props$location$.actualBeneficiaryPostcode,
			    actualBeneficiaryProfession = _this$props$location$.actualBeneficiaryProfession,
			    actualBeneficiaryEmail = _this$props$location$.actualBeneficiaryEmail,
			    conversationId = _this$props$location$.conversationId,
			    actualBeneficiaryCity = _this$props$location$.actualBeneficiaryCity,
			    actualControllerCity = _this$props$location$.actualControllerCity,
			    certLifeTime = _this$props$location$.certLifeTime,
			    certValidEver = _this$props$location$.certValidEver,
			    certValidTerm = _this$props$location$.certValidTerm;
			var cardNumber = _this.state.cardNumber;
			var dispatch = _this.props.dispatch;

			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__action_investmentAction_js__["W" /* bankType */])(null));
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__action_investmentAction_js__["Y" /* getBankType */])({
				bankCardNo: cardNumber
			}));
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
				pathname: "/certificationSetPhone",
				state: {
					phoneNo: phoneNo,
					name: name,
					certNo: certNo,
					certType: 0,
					bankAccountShowNo: cardNumber,
					address: address,
					careerCode: careerCode,
					cityCode: cityCode,
					provinceCode: provinceCode,
					actualBeneficiary: actualBeneficiary,
					actualController: actualController,
					actualBeneficiaryCertType: actualBeneficiaryCertType,
					actualBeneficiaryCertNo: actualBeneficiaryCertNo,
					actualControllerCertType: actualControllerCertType,
					actualControllerCertNo: actualControllerCertNo,
					officialsOrRelatives: officialsOrRelatives,
					callback: callback,
					route: route,
					enterType: _this.state.enterType,
					annualIncomeV2: annualIncomeV2,
					annualIncome: annualIncome,
					actualControllerBirthday: actualControllerBirthday,
					actualControllerValidTerm: actualControllerValidTerm,
					actualControllerValidEver: actualControllerValidEver,
					actualControllerSex: actualControllerSex,
					actualControllerMobileNo: actualControllerMobileNo,
					actualControllerProvince: actualControllerProvince,
					actualControllerProfession: actualControllerProfession,
					actualControllerAddress: actualControllerAddress,
					actualControllerPostcode: actualControllerPostcode,
					actualControllerEmail: actualControllerEmail,
					actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
					actualBeneficiaryValidEver: actualBeneficiaryValidEver,
					actualBeneficiarySex: actualBeneficiarySex,
					actualBeneficiaryBirthday: actualBeneficiaryBirthday,
					actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
					actualBeneficiaryProvince: actualBeneficiaryProvince,
					actualBeneficiaryAddress: actualBeneficiaryAddress,
					actualBeneficiaryPostcode: actualBeneficiaryPostcode,
					actualBeneficiaryProfession: actualBeneficiaryProfession,
					actualBeneficiaryEmail: actualBeneficiaryEmail,
					actualBeneficiaryCity: actualBeneficiaryCity,
					actualControllerCity: actualControllerCity,
					savePicFun: savePicFun,
					conversationId: conversationId,
					certLifeTime: certLifeTime,
					certValidEver: certValidEver,
					certValidTerm: certValidTerm
				},
				query: { enterType: _this.state.enterType,

					activityId: _this.props.location.query.activityId }
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__action_investmentAction_js__["Z" /* clearSmrzThird */])(phoneNo));
		}, _this.changeCardNumber = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				cardNumber: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__action_investmentAction_js__["_0" /* smrzCardNumber */])(event.target.value));
		}, _this.goBack = function () {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
			__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CertificationCardAgain, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
			document.getElementsByTagName('title')[0].innerHTML = "实名认证";
			console.log("控制人:", this.props.location.state.actualController, "受益人:", this.props.location.state.actualBeneficiary, "控制人证件类型:", this.props.location.state.actualControllerCertType, "受益人证件类型:", this.props.location.state.actualBeneficiaryCertType, "控制人证件号:", this.props.location.state.actualControllerCertNo, "受益人证件号:", this.props.location.state.actualBeneficiaryCertNo, "组织:", this.props.location.state.officialsOrRelatives);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
		}
	}, {
		key: 'render',
		value: function render() {
			var cardNumber = this.state.cardNumber;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_3__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: "13px", color: "#5b6370" } },
							'\u8BF7\u901A\u8FC7\u7ED1\u5B9A\u94F6\u884C\u5361\u5B8C\u6210\u5B9E\u540D\u8BA4\u8BC1'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u6301\u5361\u4EBA'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{
								style: {
									width: "60%",
									fontSize: "13px",
									color: "#3a3e47",
									textAlign: 'right'
								} },
							this.props.location.state.name
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u5361\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: cardNumber,
							onChange: this.changeCardNumber,
							placeholder: '\u8BF7\u8F93\u5165\u5361\u53F7'
						})
					),
					cardNumber != "" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								marginTop: 15,
								height: 40,
								backgroundColor: "#fa063a",
								WebkitJustifyContent: "center",
								WebkitAlignItems: "center",
								borderRadius: 30,
								marginLeft: 13,
								marginRight: 13,
								marginBottom: 15
							},
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0B\u4E00\u6B65'
						)
					) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								marginTop: 15,
								height: 40,
								backgroundColor: "#afb0b2",
								WebkitJustifyContent: "center",
								WebkitAlignItems: "center",
								borderRadius: 30,
								marginLeft: 13,
								marginRight: 13,
								marginBottom: 15
							},
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0B\u4E00\u6B65'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'addCard-tipBox' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'p',
							null,
							'\u6E29\u99A8\u63D0\u793A :'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'p',
							null,
							'\u5982\u679C\u60A8\u7684\u94F6\u884C\u5361\u662F\u7531\u4EA4\u901A\u94F6\u884C\u3001\u6D66\u53D1\u94F6\u884C\u3001\u5E73\u5B89\u94F6\u884C\u6216\u90AE\u50A8\u94F6\u884C\u53D1\u884C\u7684\u3002\u60A8\u9700\u8981\u5148\u901A\u8FC7\u7535\u8111\u8BBF\u95EE\u94F6\u8054\u5B98\u7F51\u5F00\u901A\u8BE5\u5361\u7684\u94F6\u8054\u5728\u7EBF\u652F\u4ED8\uFF0C\u7F51\u5740\uFF1Ahttps://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay\u3002\u5F00\u901A\u6210\u529F\u540E\uFF0C\u518D\u901A\u8FC7APP\u7ED1\u5B9A\u8BE5\u7C7B\u94F6\u884C\u5361\u5373\u53EF\u3002\u4E3A\u6B64\u9020\u6210\u7684\u4E0D\u4FBF\uFF0C\u656C\u8BF7\u8C05\u89E3\u3002'
						)
					)
				)
			);
		}
	}]);

	return CertificationCardAgain;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
	return {
		smrzCardNumber: state.smrzCardNumber
	};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CertificationCardAgain));

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var time = void 0;

var CertificationCheckPhone = function (_Component) {
  _inherits(CertificationCheckPhone, _Component);

  function CertificationCheckPhone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CertificationCheckPhone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertificationCheckPhone.__proto__ || Object.getPrototypeOf(CertificationCheckPhone)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      checkCard: _this.props.smrzCheckCard,
      cardVal: _this.props.smrzCheckCardText,
      checkFlag: _this.props.smrzCheckCardFlag,
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null
    }, _this.getRandomInt = function (min, max) {
      return Math.floor(min + Math.random() * max);
    }, _this.goCertification = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          checkNumber = _this$props.checkNumber;
      var checkCard = _this.state.checkCard;
      var _this$props$location$ = _this.props.location.state,
          savePicFun = _this$props$location$.savePicFun,
          actualControllerCity = _this$props$location$.actualControllerCity,
          actualBeneficiaryCity = _this$props$location$.actualBeneficiaryCity,
          mobileNo = _this$props$location$.mobileNo,
          name = _this$props$location$.name,
          certNo = _this$props$location$.certNo,
          certType = _this$props$location$.certType,
          bankAccountShowNo = _this$props$location$.bankAccountShowNo,
          trustChannelId = _this$props$location$.trustChannelId,
          bankCode = _this$props$location$.bankCode,
          address = _this$props$location$.address,
          careerCode = _this$props$location$.careerCode,
          cityCode = _this$props$location$.cityCode,
          provinceCode = _this$props$location$.provinceCode,
          actualBeneficiary = _this$props$location$.actualBeneficiary,
          actualController = _this$props$location$.actualController,
          actualBeneficiaryCertType = _this$props$location$.actualBeneficiaryCertType,
          actualBeneficiaryCertNo = _this$props$location$.actualBeneficiaryCertNo,
          actualControllerCertType = _this$props$location$.actualControllerCertType,
          actualControllerCertNo = _this$props$location$.actualControllerCertNo,
          officialsOrRelatives = _this$props$location$.officialsOrRelatives,
          annualIncomeV2 = _this$props$location$.annualIncomeV2,
          annualIncome = _this$props$location$.annualIncome,
          actualControllerBirthday = _this$props$location$.actualControllerBirthday,
          actualControllerValidTerm = _this$props$location$.actualControllerValidTerm,
          actualControllerValidEver = _this$props$location$.actualControllerValidEver,
          actualControllerSex = _this$props$location$.actualControllerSex,
          actualControllerMobileNo = _this$props$location$.actualControllerMobileNo,
          actualControllerProvince = _this$props$location$.actualControllerProvince,
          actualControllerProfession = _this$props$location$.actualControllerProfession,
          actualControllerAddress = _this$props$location$.actualControllerAddress,
          actualControllerPostcode = _this$props$location$.actualControllerPostcode,
          actualControllerEmail = _this$props$location$.actualControllerEmail,
          actualBeneficiaryValidTerm = _this$props$location$.actualBeneficiaryValidTerm,
          actualBeneficiaryValidEver = _this$props$location$.actualBeneficiaryValidEver,
          actualBeneficiarySex = _this$props$location$.actualBeneficiarySex,
          actualBeneficiaryBirthday = _this$props$location$.actualBeneficiaryBirthday,
          actualBeneficiaryMobileNo = _this$props$location$.actualBeneficiaryMobileNo,
          actualBeneficiaryProvince = _this$props$location$.actualBeneficiaryProvince,
          actualBeneficiaryAddress = _this$props$location$.actualBeneficiaryAddress,
          actualBeneficiaryPostcode = _this$props$location$.actualBeneficiaryPostcode,
          actualBeneficiaryProfession = _this$props$location$.actualBeneficiaryProfession,
          actualBeneficiaryEmail = _this$props$location$.actualBeneficiaryEmail,
          conversationId = _this$props$location$.conversationId,
          certLifeTime = _this$props$location$.certLifeTime,
          certValidEver = _this$props$location$.certValidEver,
          certValidTerm = _this$props$location$.certValidTerm;

      var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
      var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
      if (checkNumber == null) {
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请先获取验证码", 2);
      } else {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["O" /* checkSuccessData */])(null));
        __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading("正在加载", 2);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["P" /* getCheckSuccessData */])({
          captcha: checkCard,
          authRequestNo: checkNumber.content.requestNo,
          bankProtocolVersion: _this.props.location.state.bankProtocolVersion,
          upProtocolVersion: _this.props.location.state.upProtocolVersion
        }, function () {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["Q" /* clearSmrzPassWord */])());
          __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
            pathname: "/certificationSetPassWord",
            state: {
              mobileNo: mobileNo,
              name: name,
              certNo: certNo,
              certType: certType,
              bankAccountShowNo: bankAccountShowNo,
              paymentChannelId: trustChannelId,
              bankCode: bankCode,
              authRequestNo: checkNumber.content.requestNo,
              businessType: "AddCard",
              bankAccountName: name,
              address: address,
              careerCode: careerCode,
              cityCode: cityCode,
              provinceCode: provinceCode,
              actualBeneficiary: actualBeneficiary,
              actualController: actualController,
              actualBeneficiaryCertType: actualBeneficiaryCertType,
              actualBeneficiaryCertNo: actualBeneficiaryCertNo,
              actualControllerCertType: actualControllerCertType,
              actualControllerCertNo: actualControllerCertNo,
              officialsOrRelatives: officialsOrRelatives,
              callback: callback,
              route: route,
              enterType: _this.state.enterType,
              annualIncomeV2: annualIncomeV2,
              annualIncome: annualIncome,
              actualControllerBirthday: actualControllerBirthday,
              actualControllerValidTerm: actualControllerValidTerm,
              actualControllerValidEver: actualControllerValidEver,
              actualControllerSex: actualControllerSex,
              actualControllerMobileNo: actualControllerMobileNo,
              actualControllerProvince: actualControllerProvince,
              actualControllerProfession: actualControllerProfession,
              actualControllerAddress: actualControllerAddress,
              actualControllerPostcode: actualControllerPostcode,
              actualControllerEmail: actualControllerEmail,
              actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
              actualBeneficiaryValidEver: actualBeneficiaryValidEver,
              actualBeneficiarySex: actualBeneficiarySex,
              actualBeneficiaryBirthday: actualBeneficiaryBirthday,
              actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
              actualBeneficiaryProvince: actualBeneficiaryProvince,
              actualBeneficiaryAddress: actualBeneficiaryAddress,
              actualBeneficiaryPostcode: actualBeneficiaryPostcode,
              actualBeneficiaryProfession: actualBeneficiaryProfession,
              actualBeneficiaryEmail: actualBeneficiaryEmail,
              actualBeneficiaryCity: actualBeneficiaryCity,
              actualControllerCity: actualControllerCity,
              savePicFun: savePicFun,
              conversationId: conversationId,
              certLifeTime: certLifeTime,
              certValidEver: certValidEver,
              certValidTerm: certValidTerm
            },
            query: { enterType: _this.state.enterType,
              activityId: _this.props.location.query.activityId }
          });
        }));
      }
    }, _this.changeCheckCard = function (event) {
      var dispatch = _this.props.dispatch;

      _this.setState({
        checkCard: event.target.value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["R" /* smrzCheckCard */])(event.target.value));
    }, _this.goBack = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }, _this.getCheckCard = function () {
      var count = 119;
      var thisO = _this;
      var dispatch = _this.props.dispatch;
      var _this$props$location$2 = _this.props.location.state,
          name = _this$props$location$2.name,
          mobileNo = _this$props$location$2.mobileNo,
          bankAccountShowNo = _this$props$location$2.bankAccountShowNo,
          certNo = _this$props$location$2.certNo,
          certType = _this$props$location$2.certType,
          trustChannelId = _this$props$location$2.trustChannelId;

      __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["S" /* checkNumber */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["T" /* getCheckNumber */])({
        name: name,
        certNo: certNo,
        mobileNo: mobileNo,
        paymentChannelId: trustChannelId,
        bankAccountShowNo: bankAccountShowNo,
        clientType: __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.return_Clinet_Type()
      }, function () {
        if (time) {
          clearInterval(time);
        }
        thisO.setState({
          cardVal: "获取验证码",
          checkFlag: false
        });
      }));
      thisO.setState({
        cardVal: count + "秒后重发",
        checkFlag: true
      });
      // dispatch(smrzCheckCardText(count + "秒后重发"));
      // dispatch(smrzCheckCardFlag(true));
      time = setInterval(function () {
        count--;
        thisO.setState({
          cardVal: count + "秒后重发",
          checkFlag: true
        });
        // dispatch(smrzCheckCardText(count + "秒后重发"));
        // dispatch(smrzCheckCardFlag(true));
        if (count == 0) {
          clearInterval(time);
          thisO.setState({
            cardVal: "获取验证码",
            checkFlag: false
          });
          // dispatch(smrzCheckCardText(count + "秒后重发"));
          // dispatch(smrzCheckCardFlag(false));
        }
      }, 1000);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CertificationCheckPhone, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
      document.getElementsByTagName('title')[0].innerHTML = "实名认证";
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
      clearInterval(time);
    }
  }, {
    key: 'render',
    value: function render() {
      var checkNumber = this.props.checkNumber;
      var _state = this.state,
          checkCard = _state.checkCard,
          checkFlag = _state.checkFlag,
          cardVal = _state.cardVal;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5B9E\u540D\u8BA4\u8BC1'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: "13px", color: "#5b6370" } },
              '\u8BF7\u8F93\u5165\u60A8\u6536\u5230\u7684\u77ED\u4FE1\u9A8C\u8BC1\u7801'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                height: 45,
                backgroundColor: "#fff",
                paddingLeft: 13,
                paddingRight: 13,
                overflow: "hidden",
                borderBottomWidth: 1,
                borderBottomColor: 'rgb(235, 238, 240)'
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: "#5b6370",
                  fontSize: "13px"
                } },
              '\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
              style: {
                height: 45,
                width: 150,
                fontSize: "13px",
                marginLeft: 10,
                color: "#3a3e47",
                verticalAlign: "middle"
              },
              value: checkCard,
              onChange: this.changeCheckCard,
              placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801'
            }),
            checkFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  backgroundColor: "#afb0b2",
                  height: 30,
                  width: 90,
                  WebkitJustifyContent: "center",
                  WebkitAlignItems: "center",
                  marginTop: 7.5,
                  borderRadius: 30,
                  float: "right"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#5b6370",
                    fontSize: "13px"
                  } },
                cardVal
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  backgroundColor: "#fa063a",
                  height: 30,
                  width: 90,
                  marginTop: 7.5,
                  WebkitJustifyContent: "center",
                  WebkitAlignItems: "center",
                  borderRadius: 30,
                  float: "right"
                }, onClick: this.getCheckCard },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#fff",
                    fontSize: "13px"
                  } },
                '\u83B7\u53D6\u9A8C\u8BC1\u7801'
              )
            )
          ),
          checkCard != "" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                display: "-webkit-flex",
                marginTop: 15,
                height: 40,
                backgroundColor: "#fa063a",
                WebkitJustifyContent: "center",
                WebkitAlignItems: "center",
                borderRadius: 30,
                marginLeft: 13,
                marginRight: 13,
                marginBottom: 15
              },
              key: 0,
              onClick: this.goCertification
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: "#fff", fontSize: 15 } },
              '\u4E0B\u4E00\u6B65'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                display: "-webkit-flex",
                marginTop: 15,
                height: 40,
                backgroundColor: "#afb0b2",
                WebkitJustifyContent: "center",
                WebkitAlignItems: "center",
                borderRadius: 30,
                marginLeft: 13,
                marginRight: 13,
                marginBottom: 15
              },
              key: 0
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: "#fff", fontSize: 15 } },
              '\u4E0B\u4E00\u6B65'
            )
          )
        )
      );
    }
  }]);

  return CertificationCheckPhone;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    checkNumber: state.checkNumber,
    checkSuccessData: state.checkSuccessData,
    smrzCheckCard: state.smrzCheckCard,
    smrzCheckCardText: state.smrzCheckCardText,
    smrzCheckCardFlag: state.smrzCheckCardFlag
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(CertificationCheckPhone));

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var CertificationSetPassWord = function (_Component) {
	_inherits(CertificationSetPassWord, _Component);

	function CertificationSetPassWord() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CertificationSetPassWord);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertificationSetPassWord.__proto__ || Object.getPrototypeOf(CertificationSetPassWord)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			passWord: _this.props.smrzPassWord,
			passWordAgain: _this.props.smrzPassWordAgain,
			enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null
		}, _this.goCertification = function () {
			var _this$state = _this.state,
			    passWord = _this$state.passWord,
			    passWordAgain = _this$state.passWordAgain;
			var _this$props$location$ = _this.props.location.state,
			    savePicFun = _this$props$location$.savePicFun,
			    actualBeneficiaryCity = _this$props$location$.actualBeneficiaryCity,
			    actualControllerCity = _this$props$location$.actualControllerCity,
			    name = _this$props$location$.name,
			    authRequestNo = _this$props$location$.authRequestNo,
			    bankAccountName = _this$props$location$.bankAccountName,
			    bankAccountShowNo = _this$props$location$.bankAccountShowNo,
			    bankCode = _this$props$location$.bankCode,
			    businessType = _this$props$location$.businessType,
			    certNo = _this$props$location$.certNo,
			    certType = _this$props$location$.certType,
			    paymentChannelId = _this$props$location$.paymentChannelId,
			    actualBeneficiary = _this$props$location$.actualBeneficiary,
			    actualController = _this$props$location$.actualController,
			    actualBeneficiaryCertType = _this$props$location$.actualBeneficiaryCertType,
			    actualBeneficiaryCertNo = _this$props$location$.actualBeneficiaryCertNo,
			    actualControllerCertType = _this$props$location$.actualControllerCertType,
			    actualControllerCertNo = _this$props$location$.actualControllerCertNo,
			    officialsOrRelatives = _this$props$location$.officialsOrRelatives,
			    address = _this$props$location$.address,
			    careerCode = _this$props$location$.careerCode,
			    provinceCode = _this$props$location$.provinceCode,
			    cityCode = _this$props$location$.cityCode,
			    mobileNo = _this$props$location$.mobileNo,
			    annualIncomeV2 = _this$props$location$.annualIncomeV2,
			    annualIncome = _this$props$location$.annualIncome,
			    actualControllerBirthday = _this$props$location$.actualControllerBirthday,
			    actualControllerValidTerm = _this$props$location$.actualControllerValidTerm,
			    actualControllerValidEver = _this$props$location$.actualControllerValidEver,
			    actualControllerSex = _this$props$location$.actualControllerSex,
			    actualControllerMobileNo = _this$props$location$.actualControllerMobileNo,
			    actualControllerProvince = _this$props$location$.actualControllerProvince,
			    actualControllerProfession = _this$props$location$.actualControllerProfession,
			    actualControllerAddress = _this$props$location$.actualControllerAddress,
			    actualControllerPostcode = _this$props$location$.actualControllerPostcode,
			    actualControllerEmail = _this$props$location$.actualControllerEmail,
			    actualBeneficiaryValidTerm = _this$props$location$.actualBeneficiaryValidTerm,
			    actualBeneficiaryValidEver = _this$props$location$.actualBeneficiaryValidEver,
			    actualBeneficiarySex = _this$props$location$.actualBeneficiarySex,
			    actualBeneficiaryBirthday = _this$props$location$.actualBeneficiaryBirthday,
			    actualBeneficiaryMobileNo = _this$props$location$.actualBeneficiaryMobileNo,
			    actualBeneficiaryProvince = _this$props$location$.actualBeneficiaryProvince,
			    actualBeneficiaryAddress = _this$props$location$.actualBeneficiaryAddress,
			    actualBeneficiaryPostcode = _this$props$location$.actualBeneficiaryPostcode,
			    actualBeneficiaryProfession = _this$props$location$.actualBeneficiaryProfession,
			    actualBeneficiaryEmail = _this$props$location$.actualBeneficiaryEmail,
			    conversationId = _this$props$location$.conversationId,
			    certLifeTime = _this$props$location$.certLifeTime,
			    certValidEver = _this$props$location$.certValidEver,
			    certValidTerm = _this$props$location$.certValidTerm;
			var userMobileNo = _this.props.userMobileNo;

			var pattern = __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.passwordPattern;
			if (!pattern.test(passWord)) {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("密码必须是6至8位的字母或数字组合且不能完全重复", 2);
				return;
			}
			if (passWordAgain != passWord) {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("密码不一致，请重新输入", 2);
				return;
			}
			if (passWordAgain.length < 6) {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("确认密码至少6位数", 2);
				return;
			}
			if (passWord.length < 6) {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("密码至少6位数", 2);
				return;
			}
			if (passWordAgain.length > 8) {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("确认密码至多8位数", 2);
				return;
			}
			if (passWord.length > 8) {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("密码至多8位数", 2);
				return;
			}
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
				pathname: "/TaxInfo",
				state: {
					passWord: passWord,
					name: name,
					authRequestNo: authRequestNo,
					bankAccountName: bankAccountName,
					bankAccountShowNo: bankAccountShowNo,
					bankCode: bankCode,
					businessType: businessType,
					certNo: certNo,
					certType: certType,
					mobileNo: mobileNo ? mobileNo : userMobileNo,
					paymentChannelId: paymentChannelId,
					actualBeneficiary: actualBeneficiary,
					actualController: actualController,
					actualBeneficiaryCertType: actualBeneficiaryCertType,
					actualBeneficiaryCertNo: actualBeneficiaryCertNo,
					actualControllerCertType: actualControllerCertType,
					actualControllerCertNo: actualControllerCertNo,
					officialsOrRelatives: officialsOrRelatives,
					address: address,
					careerCode: careerCode,
					cityCode: cityCode,
					provinceCode: provinceCode,
					callback: callback,
					route: route,
					enterType: _this.state.enterType,
					annualIncomeV2: annualIncomeV2,
					annualIncome: annualIncome,
					actualControllerBirthday: actualControllerBirthday,
					actualControllerValidTerm: actualControllerValidTerm,
					actualControllerValidEver: actualControllerValidEver,
					actualControllerSex: actualControllerSex,
					actualControllerMobileNo: actualControllerMobileNo,
					actualControllerProvince: actualControllerProvince,
					actualControllerProfession: actualControllerProfession,
					actualControllerAddress: actualControllerAddress,
					actualControllerPostcode: actualControllerPostcode,
					actualControllerEmail: actualControllerEmail,
					actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
					actualBeneficiaryValidEver: actualBeneficiaryValidEver,
					actualBeneficiarySex: actualBeneficiarySex,
					actualBeneficiaryBirthday: actualBeneficiaryBirthday,
					actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
					actualBeneficiaryProvince: actualBeneficiaryProvince,
					actualBeneficiaryAddress: actualBeneficiaryAddress,
					actualBeneficiaryPostcode: actualBeneficiaryPostcode,
					actualBeneficiaryProfession: actualBeneficiaryProfession,
					actualBeneficiaryEmail: actualBeneficiaryEmail,
					actualBeneficiaryCity: actualBeneficiaryCity,
					actualControllerCity: actualControllerCity,
					savePicFun: savePicFun,
					conversationId: conversationId,
					certLifeTime: certLifeTime,
					certValidEver: certValidEver,
					certValidTerm: certValidTerm
				},
				query: { enterType: _this.state.enterType,
					activityId: _this.props.location.query.activityId }
			});
		}, _this.changePassWord = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				passWord: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__["M" /* smrzPassWord */])(event.target.value));
		}, _this.changePassWordAgain = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				passWordAgain: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__["N" /* smrzPassWordAgain */])(event.target.value));
		}, _this.goBack = function () {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
			__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CertificationSetPassWord, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
			document.getElementsByTagName('title')[0].innerHTML = "实名认证";
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    passWord = _state.passWord,
			    passWordAgain = _state.passWordAgain;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_2__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: "13px", color: "#5b6370" } },
							'\u8BF7\u8BBE\u7F6E\u4EA4\u6613\u5BC6\u7801\uFF0C\u5728\u8FDB\u884C\u4EA4\u6613\u65F6\u4F7F\u7528\uFF0C\u8BF7\u59A5\u5584\u4FDD\u7BA1'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u4EA4\u6613\u5BC6\u7801'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							type: 'password',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: passWord,
							onChange: this.changePassWord,
							placeholder: '\u8BF7\u8F93\u51656-8\u4F4D\u5BC6\u7801'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u786E\u8BA4\u5BC6\u7801'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							type: 'password',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: passWordAgain,
							onChange: this.changePassWordAgain,
							placeholder: '\u8BF7\u518D\u6B21\u8F93\u5165\u5BC6\u7801'
						})
					),
					passWordAgain != "" && passWord != "" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								marginTop: 15,
								height: 40,
								backgroundColor: "#fa063a",
								WebkitJustifyContent: "center",
								WebkitAlignItems: "center",
								borderRadius: 30,
								marginLeft: 13,
								marginRight: 13,
								marginBottom: 15
							},
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0B\u4E00\u6B65'
						)
					) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								marginTop: 15,
								height: 40,
								backgroundColor: "#afb0b2",
								WebkitJustifyContent: "center",
								WebkitAlignItems: "center",
								borderRadius: 30,
								marginLeft: 13,
								marginRight: 13,
								marginBottom: 15
							},
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0B\u4E00\u6B65'
						)
					)
				)
			);
		}
	}]);

	return CertificationSetPassWord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
	return {
		smrzPassWord: state.smrzPassWord,
		smrzPassWordAgain: state.smrzPassWordAgain,
		userMobileNo: state.userMobileNo
	};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(CertificationSetPassWord));

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_myCardsAction_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CertificationSetPhone = function (_Component) {
	_inherits(CertificationSetPhone, _Component);

	function CertificationSetPhone() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CertificationSetPhone);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertificationSetPhone.__proto__ || Object.getPrototypeOf(CertificationSetPhone)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			phoneNumber: _this.props.smrzUpdatePhoneNo ? _this.props.smrzUpdatePhoneNo : _this.props.location.state.phoneNo,
			agreeIcon: _this.props.smrzAgreeItemFlag,
			enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
			verificationCodeBool: false,
			iSstateBool: false,
			agreementValue: ''
		}, _this.sure = function () {
			var regPhone = /^1[0123456789]\d{9}$/;
			var _this$props = _this.props,
			    bankList = _this$props.bankList,
			    bankType = _this$props.bankType,
			    dispatch = _this$props.dispatch;
			var _this$props$location$ = _this.props.location.state,
			    savePicFun = _this$props$location$.savePicFun,
			    actualControllerCity = _this$props$location$.actualControllerCity,
			    actualBeneficiaryCity = _this$props$location$.actualBeneficiaryCity,
			    phoneNo = _this$props$location$.phoneNo,
			    name = _this$props$location$.name,
			    certNo = _this$props$location$.certNo,
			    bankAccountShowNo = _this$props$location$.bankAccountShowNo,
			    address = _this$props$location$.address,
			    careerCode = _this$props$location$.careerCode,
			    cityCode = _this$props$location$.cityCode,
			    provinceCode = _this$props$location$.provinceCode,
			    actualBeneficiary = _this$props$location$.actualBeneficiary,
			    actualController = _this$props$location$.actualController,
			    actualBeneficiaryCertType = _this$props$location$.actualBeneficiaryCertType,
			    actualBeneficiaryCertNo = _this$props$location$.actualBeneficiaryCertNo,
			    actualControllerCertType = _this$props$location$.actualControllerCertType,
			    actualControllerCertNo = _this$props$location$.actualControllerCertNo,
			    officialsOrRelatives = _this$props$location$.officialsOrRelatives,
			    annualIncomeV2 = _this$props$location$.annualIncomeV2,
			    annualIncome = _this$props$location$.annualIncome,
			    actualControllerBirthday = _this$props$location$.actualControllerBirthday,
			    actualControllerValidTerm = _this$props$location$.actualControllerValidTerm,
			    actualControllerValidEver = _this$props$location$.actualControllerValidEver,
			    actualControllerSex = _this$props$location$.actualControllerSex,
			    actualControllerMobileNo = _this$props$location$.actualControllerMobileNo,
			    actualControllerProvince = _this$props$location$.actualControllerProvince,
			    actualControllerProfession = _this$props$location$.actualControllerProfession,
			    actualControllerAddress = _this$props$location$.actualControllerAddress,
			    actualControllerPostcode = _this$props$location$.actualControllerPostcode,
			    actualControllerEmail = _this$props$location$.actualControllerEmail,
			    actualBeneficiaryValidTerm = _this$props$location$.actualBeneficiaryValidTerm,
			    actualBeneficiaryValidEver = _this$props$location$.actualBeneficiaryValidEver,
			    actualBeneficiarySex = _this$props$location$.actualBeneficiarySex,
			    actualBeneficiaryBirthday = _this$props$location$.actualBeneficiaryBirthday,
			    actualBeneficiaryMobileNo = _this$props$location$.actualBeneficiaryMobileNo,
			    actualBeneficiaryProvince = _this$props$location$.actualBeneficiaryProvince,
			    actualBeneficiaryAddress = _this$props$location$.actualBeneficiaryAddress,
			    actualBeneficiaryPostcode = _this$props$location$.actualBeneficiaryPostcode,
			    actualBeneficiaryProfession = _this$props$location$.actualBeneficiaryProfession,
			    actualBeneficiaryEmail = _this$props$location$.actualBeneficiaryEmail,
			    conversationId = _this$props$location$.conversationId,
			    certLifeTime = _this$props$location$.certLifeTime,
			    certValidEver = _this$props$location$.certValidEver,
			    certValidTerm = _this$props$location$.certValidTerm;

			if (_this.state.bank == "") {
				__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择银行卡类型", 2);
				return;
			}
			if (!regPhone.test(_this.state.phoneNumber)) {
				__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("手机号有误，请重新输入", 2);
				return;
			}
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			for (var i = 0; i < bankList.content.length; i++) {
				if (bankList.content[i].bankCode == bankType.content.bankCode) {
					var _state;

					__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
						pathname: "/certificationCheckPhone",
						state: (_state = {
							mobileNo: phoneNo,
							name: name,
							certNo: certNo,
							certType: 0,
							bankAccountShowNo: bankAccountShowNo,
							trustChannelId: bankList.content[i].paymentChannelId,
							bankCode: bankList.content[i].bankCode,
							bankAccountName: bankList.content[i].paymentChannelName,
							route: _this.props.route ? _this.props.route : null,
							callback: _this.props.callback ? _this.props.callback : null,
							address: address,
							careerCode: careerCode,
							cityCode: cityCode,
							provinceCode: provinceCode,
							actualBeneficiary: actualBeneficiary,
							actualController: actualController,
							actualBeneficiaryCertType: actualBeneficiaryCertType,
							actualBeneficiaryCertNo: actualBeneficiaryCertNo,
							actualControllerCertType: actualControllerCertType,
							actualControllerCertNo: actualControllerCertNo,
							officialsOrRelatives: officialsOrRelatives
						}, _defineProperty(_state, 'callback', callback), _defineProperty(_state, 'route', route), _defineProperty(_state, 'annualIncomeV2', annualIncomeV2), _defineProperty(_state, 'annualIncome', annualIncome), _defineProperty(_state, 'actualControllerBirthday', actualControllerBirthday), _defineProperty(_state, 'actualControllerValidTerm', actualControllerValidTerm), _defineProperty(_state, 'actualControllerValidEver', actualControllerValidEver), _defineProperty(_state, 'actualControllerSex', actualControllerSex), _defineProperty(_state, 'actualControllerMobileNo', actualControllerMobileNo), _defineProperty(_state, 'actualControllerProvince', actualControllerProvince), _defineProperty(_state, 'actualControllerProfession', actualControllerProfession), _defineProperty(_state, 'actualControllerAddress', actualControllerAddress), _defineProperty(_state, 'actualControllerPostcode', actualControllerPostcode), _defineProperty(_state, 'actualControllerEmail', actualControllerEmail), _defineProperty(_state, 'actualBeneficiaryValidTerm', actualBeneficiaryValidTerm), _defineProperty(_state, 'actualBeneficiaryValidEver', actualBeneficiaryValidEver), _defineProperty(_state, 'actualBeneficiarySex', actualBeneficiarySex), _defineProperty(_state, 'actualBeneficiaryBirthday', actualBeneficiaryBirthday), _defineProperty(_state, 'actualBeneficiaryMobileNo', actualBeneficiaryMobileNo), _defineProperty(_state, 'actualBeneficiaryProvince', actualBeneficiaryProvince), _defineProperty(_state, 'actualBeneficiaryAddress', actualBeneficiaryAddress), _defineProperty(_state, 'actualBeneficiaryPostcode', actualBeneficiaryPostcode), _defineProperty(_state, 'actualBeneficiaryProfession', actualBeneficiaryProfession), _defineProperty(_state, 'actualBeneficiaryEmail', actualBeneficiaryEmail), _defineProperty(_state, 'actualBeneficiaryCity', actualBeneficiaryCity), _defineProperty(_state, 'actualControllerCity', actualControllerCity), _defineProperty(_state, 'savePicFun', savePicFun), _defineProperty(_state, 'conversationId', conversationId), _defineProperty(_state, 'certLifeTime', certLifeTime), _defineProperty(_state, 'certValidEver', certValidEver), _defineProperty(_state, 'certValidTerm', certValidTerm), _defineProperty(_state, 'bankProtocolVersion', _this.state.agreementValue.bankProtocolVersion), _defineProperty(_state, 'upProtocolVersion', _this.state.agreementValue.upProtocolVersion), _state),
						query: { enterType: _this.state.enterType,
							activityId: _this.props.location.query.activityId }
					});
					dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["U" /* clearSmrzCheckCard */])());
					_this.setState({ agreeIcon: false });
				}
			}
		}, _this.goCertification = function () {
			_this.setState({ verificationCodeBool: true });
		}, _this.changePhoneNumber = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				phoneNumber: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["V" /* smrzUpdatePhoneNo */])(event.target.value));
		}, _this.changeBank = function (value) {
			_this.setState({ iSstateBool: true });
			var _this$props2 = _this.props,
			    dispatch = _this$props2.dispatch,
			    bankList = _this$props2.bankList;

			if (value[0]) {
				for (var i = 0; i < bankList.content.length; i++) {
					if (value[0] == bankList.content[i].bankCode) {
						dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["W" /* bankType */])({ content: {
								cardName: bankList.content[i].paymentChannelName,
								bankCode: value[0]
							} }));
					}
				}
			} else {
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["W" /* bankType */])({ content: {
						cardName: bankList.content[0].paymentChannelName,
						bankCode: "002"
					} }));
			}
		}, _this.changeAgree = function () {
			var dispatch = _this.props.dispatch;

			_this.setState({
				agreeIcon: _this.state.agreeIcon ? false : true
			});
			var flag = _this.state.agreeIcon ? false : true;
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["X" /* smrzAgreeItemFlag */])(flag));
		}, _this.goBack = function () {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
			__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CertificationSetPhone, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
			document.getElementsByTagName('title')[0].innerHTML = "实名认证";
		}
	}, {
		key: 'componentDidMount',
		value: function () {
			var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var _this2 = this;

				var params;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["k" /* getBankList */])());
								_context.next = 3;
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_js__["b" /* getTempInfo */])("shortToken");

							case 3:
								_context.t0 = _context.sent;
								_context.t1 = this.props.location.state.bankAccountShowNo;
								params = {
									token: _context.t0,
									bankAccountNo: _context.t1
								};

								this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myCardsAction_js__["a" /* getBankProtocollnfoList */])(params, function (value) {
									_this2.setState({ agreementValue: value });
								}, function (message) {
									__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(message, 2);
								}));

							case 7:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function componentDidMount() {
				return _ref2.apply(this, arguments);
			}

			return componentDidMount;
		}()
	}, {
		key: 'ProtocolPaper',
		value: function ProtocolPaper(name, value) {
			var code = __WEBPACK_IMPORTED_MODULE_5__BankCode__["a" /* protocolCode */][name];
			if (code) {
				__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
					pathname: '/WebView',
					state: { name: name, code: code },
					query: { code: code }
				});
			} else {
				var newName = name.substring(1, name.length - 1);
				__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
					pathname: '/WebView',
					state: { name: newName, webViewHtml: value == 'bankProtocolName' ? this.state.agreementValue.bankProtocolUrl : this.state.agreementValue.upProtocolUrl },
					query: { code: code }
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var img_arr = [__webpack_require__(51), __webpack_require__(55)];
			var _state2 = this.state,
			    agreeIcon = _state2.agreeIcon,
			    phoneNumber = _state2.phoneNumber,
			    bank = _state2.bank;
			var _props = this.props,
			    bankList = _props.bankList,
			    bankType = _props.bankType;

			console.log(bankType, bankList);
			var bankArr = [];
			if (bankList != null) {
				for (var i = 0; i < bankList.content.length; i++) {
					bankArr.push({
						label: bankList.content[i].paymentChannelName,
						value: bankList.content[i].bankCode
					});
				}
			}
			return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_6__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						null,
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'div',
								{ style: { fontSize: "13px", color: "#5b6370" } },
								'\u9700\u8981\u5BF9\u60A8\u5728\u8BE5\u94F6\u884C\u9884\u7559\u7684\u624B\u673A\u53F7\u8FDB\u884C\u6821\u9A8C'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ className: 'pickerBox', style: {
									display: "-webkit-flex",
									height: 45,
									backgroundColor: "#fff",
									paddingLeft: 13,
									paddingRight: 13,
									WebkitAlignItems: "center",
									WebkitFlexDirection: "row",
									borderBottom: "1px solid rgb(235, 238, 240)"
								} },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
								{ value: bankType != null ? [bankType.content.bankCode] : "", extra: bankType != null ? bankType.content.cardName : "", title: '\u94F6\u884C\u5361\u5217\u8868', data: bankArr, onChange: this.changeBank, cols: 1, className: 'forss' },
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
									{ arrow: 'horizontal' },
									'\u5361\u7C7B\u578B'
								)
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: {
									display: "-webkit-flex",
									height: 45,
									backgroundColor: "#fff",
									paddingLeft: 13,
									paddingRight: 13,
									WebkitAlignItems: "center",
									WebkitFlexDirection: "row",
									borderBottom: "1px solid rgb(235, 238, 240)"
								} },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								{ style: {
										color: "#5b6370",
										fontSize: "13px",
										width: "40%",
										display: "block"
									} },
								'\u624B\u673A\u53F7'
							),
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off',
								style: {
									width: "60%",
									fontSize: "13px",
									color: "#3a3e47",
									textAlign: 'right'
								},
								value: this.state.phoneNumber,
								onChange: this.changePhoneNumber,
								placeholder: '\u8BF7\u8F93\u5165\u94F6\u884C\u9884\u7559\u624B\u673A\u53F7'
							})
						)
					),
					phoneNumber != "" && bankType && bankType.content.bankCode != null && this.state.agreementValue ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								marginTop: 15,
								height: 40,
								backgroundColor: "#fa063a",
								WebkitJustifyContent: "center",
								WebkitAlignItems: "center",
								borderRadius: 30,
								marginLeft: 13,
								marginRight: 13,
								marginBottom: 15
							},
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0B\u4E00\u6B65'
						)
					) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								marginTop: 15,
								height: 40,
								backgroundColor: "#afb0b2",
								WebkitJustifyContent: "center",
								WebkitAlignItems: "center",
								borderRadius: 30,
								marginLeft: 13,
								marginRight: 13,
								marginBottom: 15
							},
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0B\u4E00\u6B65'
						)
					),
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ className: 'addCard-tipBox' },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'p',
							null,
							'\u6E29\u99A8\u63D0\u793A :'
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'p',
							null,
							'\u5982\u679C\u60A8\u7684\u94F6\u884C\u5361\u662F\u7531\u4EA4\u901A\u94F6\u884C\u3001\u6D66\u53D1\u94F6\u884C\u3001\u5E73\u5B89\u94F6\u884C\u6216\u90AE\u50A8\u94F6\u884C\u53D1\u884C\u7684\u3002\u60A8\u9700\u8981\u5148\u901A\u8FC7\u7535\u8111\u8BBF\u95EE\u94F6\u8054\u5B98\u7F51\u5F00\u901A\u8BE5\u5361\u7684\u94F6\u8054\u5728\u7EBF\u652F\u4ED8\uFF0C\u7F51\u5740\uFF1Ahttps://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay\u3002\u5F00\u901A\u6210\u529F\u540E\uFF0C\u518D\u901A\u8FC7APP\u7ED1\u5B9A\u8BE5\u7C7B\u94F6\u884C\u5361\u5373\u53EF\u3002\u4E3A\u6B64\u9020\u6210\u7684\u4E0D\u4FBF\uFF0C\u656C\u8BF7\u8C05\u89E3\u3002'
						)
					)
				),
				this.state.verificationCodeBool ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					'div',
					{ style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'p',
								{ style: { fontSize: 18, color: "#333", fontWeight: 500 } },
								'\u6E29\u99A8\u63D0\u793A'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20, fontSize: '0.28rem' } },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: img_arr[agreeIcon ? 1 : 0], className: 'imgBtn', style: { marginTop: '-0.35rem' }, onClick: function onClick() {
									return _this3.changeAgree();
								} }),
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'p',
								{ style: { lineHeight: '0.35rem' } },
								'\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'span',
									{ style: { color: "#fa063a" }, onClick: function onClick() {
											return _this3.ProtocolPaper('上海华夏财富投资管理有限公司快易付业务协议');
										} },
									'\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u5FEB\u6613\u4ED8\u4E1A\u52A1\u534F\u8BAE\u300B'
								),
								'\u3001',
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'span',
									{ style: { color: "#fa063a" }, onClick: function onClick() {
											return _this3.ProtocolPaper(_this3.state.agreementValue.bankProtocolName, 'bankProtocolName');
										} },
									this.state.agreementValue.bankProtocolName
								),
								'\u3001',
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'span',
									{ style: { color: "#fa063a" }, onClick: function onClick() {
											return _this3.ProtocolPaper(_this3.state.agreementValue.upProtocolName, 'upProtocolName');
										} },
									this.state.agreementValue.upProtocolName
								)
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'div',
								{ onClick: function onClick() {
										_this3.setState({ verificationCodeBool: false, agreeIcon: false });
									}, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'p',
									{ style: { fontSize: 14, color: "#F92C3D" } },
									'\u53D6\u6D88'
								)
							),
							this.state.agreeIcon ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'div',
								{ onClick: this.sure, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'p',
									{ style: { fontSize: 14, color: "#fff" } },
									'\u540C\u610F\u5E76\u7EE7\u7EED'
								)
							) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'div',
								{ onClick: function onClick() {
										__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请先阅读并确认协议", 2);
									}, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#ccc", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'p',
									{ style: { fontSize: 14, color: "#fff" } },
									'\u540C\u610F\u5E76\u7EE7\u7EED'
								)
							)
						)
					)
				) : null
			);
		}
	}]);

	return CertificationSetPhone;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
	return {
		bankList: state.bankList,
		bankType: state.bankType,
		smrzUpdatePhoneNo: state.smrzUpdatePhoneNo,
		smrzAgreeItemFlag: state.smrzAgreeItemFlag
	};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(CertificationSetPhone));

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var interVal = null;

var EducationCalculator = function (_Component) {
  _inherits(EducationCalculator, _Component);

  function EducationCalculator() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, EducationCalculator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = EducationCalculator.__proto__ || Object.getPrototypeOf(EducationCalculator)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      theMoney: _this2.props.yljycbMoney,
      theOutMoney: _this2.props.yqyljyMoney,
      childAge: _this2.props.yljyAge,
      sliderVal: _this2.props.yqyljySliderVal,
      thunkIcon: false,
      loadingArr: [__webpack_require__(235), __webpack_require__(246), __webpack_require__(253), __webpack_require__(254), __webpack_require__(255), __webpack_require__(256), __webpack_require__(257), __webpack_require__(258), __webpack_require__(259), __webpack_require__(236), __webpack_require__(237), __webpack_require__(238), __webpack_require__(239), __webpack_require__(240), __webpack_require__(241), __webpack_require__(242), __webpack_require__(243), __webpack_require__(244), __webpack_require__(245), __webpack_require__(247), __webpack_require__(248), __webpack_require__(249), __webpack_require__(250), __webpack_require__(251), __webpack_require__(252)],
      loadingIcon: "",
      schoolType: _this2.props.jySchoolType
    }, _this2.touchMove = function (event) {
      event.preventDefault();
    }, _this2.changeTheMoney = function (event) {
      var dispatch = _this2.props.dispatch;

      _this2.setState({
        theMoney: event.target.value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_51" /* yljycbMoney */])(event.target.value));
    }, _this2.changeTheOutMoney = function (value) {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "输入教育金"]);
      var dispatch = _this2.props.dispatch;
      var schoolType = _this2.state.schoolType;

      if (schoolType == "国内院校") {
        if (value > 30000 && value <= 40000) {
          var a = (50000 - 30000) / (10000 / 1000);
          var b = (value - 30000) / 1000;
          _this2.setState({
            sliderVal: a * b + 30000
          });
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(a * b + 30000));
        } else if (value > 40000 && value <= 50000) {
          var _a = (100000 - 50000) / (10000 / 1000);
          var _b = (value - 40000) / 1000;
          _this2.setState({
            sliderVal: _a * _b + 50000
          });
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(_a * _b + 50000));
        } else if (value > 50000 && value <= 60000) {
          var _a2 = (200000 - 100000) / (10000 / 1000);
          var _b2 = (value - 50000) / 1000;
          _this2.setState({
            sliderVal: _a2 * _b2 + 100000
          });
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(_a2 * _b2 + 100000));
        } else {
          _this2.setState({
            sliderVal: value
          });
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(value));
        }
      } else if (schoolType == "国外院校") {
        _this2.setState({
          sliderVal: value
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(value));
      }
      _this2.setState({
        theOutMoney: value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_53" /* yqyljyMoney */])(value));
    }, _this2.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "回退"]);
    }, _this2.changeAge = function (value) {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "选择年龄"]);
      var dispatch = _this2.props.dispatch;

      _this2.setState({
        childAge: value[0]
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_54" /* yljyAge */])(value[0]));
    }, _this2.goResult = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "计算结果"]);
      var _this2$state = _this2.state,
          childAge = _this2$state.childAge,
          theMoney = _this2$state.theMoney,
          sliderVal = _this2$state.sliderVal;
      var school = _this2.props.location.state.school;

      var regMoney = /^(([1-9]\d{0,9})|0)(\.\d{1,2})?$/;
      var dlValue = void 0;
      var pValue = void 0;
      var studyMoney = sliderVal;
      if (!regMoney.test(theMoney)) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请输入有效金额", 2);
        return;
      }
      if (school == "初中") {
        dlValue = 12;
        pValue = 3;
      } else if (school == "高中") {
        dlValue = 15;
        pValue = 3;
      } else if (school == "大学") {
        dlValue = 18;
        pValue = 4;
      }
      _this2.getYearGap(childAge, studyMoney, theMoney, dlValue, pValue);
    }, _this2.getYearGap = function (A, N, S, DL, P) {
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this2.touchMove, false);
      var school = _this2.props.location.state.school;

      _this2.setState({
        thunkIcon: true,
        loadingIcon: _this2.state.loadingArr[0]
      });
      var r = 0.03;
      var r2 = 1 / (1 + r);
      var ST = S * Math.pow(r + 1, DL - A);
      var N1 = ST / ((1 - Math.pow(r2, P)) / (1 - r2));
      var count = 0;
      interVal = setInterval(function () {
        if (count == 49) {
          clearInterval(interVal);
          _this2.setState({
            thunkIcon: false
          });
          var _obj = document.getElementsByTagName("html")[0];
          _obj.style.overflowY = "auto";
          _obj.style.overflowY = "auto";
          _obj.removeEventListener("touchmove", _this2.touchMove, false);
          __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
            pathname: "/educationCalculatorResult",
            state: {
              theParams: {
                actual: N1.toFixed(2),
                gap: (N - N1).toFixed(2),
                theMoney: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(N, false),
                theAge: A,
                school: school,
                schoolType: _this2.state.schoolType,
                theOutMoney: _this2.state.sliderVal
              }
            }
          });
        } else {
          count++;
          if (count > 24) {
            _this2.setState({
              loadingIcon: _this2.state.loadingArr[count - 25]
            });
          } else {
            _this2.setState({
              loadingIcon: _this2.state.loadingArr[count]
            });
          }
        }
      }, 100);
    }, _this2.goRule = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "计算规则"]);
      var code = __WEBPACK_IMPORTED_MODULE_3__BankCode__["a" /* protocolCode */]["教育计算器规则"];
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: {
          name: "教育计算器规则",
          code: code
        },
        query: {
          code: code
        }
      });
    }, _this2.focusTheMoney = function () {
      var dispatch = _this2.props.dispatch;

      if (_this2.state.theMoney == "0") {
        _this2.setState({
          theMoney: ""
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_51" /* yljycbMoney */])(""));
      }
    }, _this2.blurTheMoney = function () {
      var dispatch = _this2.props.dispatch;

      if (_this2.state.theMoney == "") {
        _this2.setState({
          theMoney: "0"
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_51" /* yljycbMoney */])("0"));
      }
    }, _this2.changeMoney = function (event) {
      var reg = /^[0-9]*$/;
      var dispatch = _this2.props.dispatch;

      if (event.target.value.length <= 7 && reg.test(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.priceParse(event.target.value))) {
        _this2.setState({
          sliderVal: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.priceParse(event.target.value)
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.priceParse(event.target.value)));
      }
    }, _this2.changeSchoolType = function (school) {
      var _this = _this2;
      var dispatch = _this2.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_55" /* jySchoolType */])(null));
      _this.setState({
        schoolType: null
      });
      setTimeout(function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_55" /* jySchoolType */])(school));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_53" /* yqyljyMoney */])(school == "国内院校" ? 20000 : 100000));
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["_52" /* yqyljySliderVal */])(school == "国内院校" ? 20000 : 100000));
        _this.setState({
          schoolType: school,
          sliderVal: school == "国内院校" ? 20000 : 100000,
          theOutMoney: school == "国内院校" ? 20000 : 100000
        });
      });
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(EducationCalculator, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "教育智能规划";
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "进入"]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(interVal);
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", this.touchMove, false);
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "退出"]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
          _ref2,
          _ref3;

      var school = this.props.location.state.school;
      var _state = this.state,
          theMoney = _state.theMoney,
          childAge = _state.childAge,
          theOutMoney = _state.theOutMoney,
          sliderVal = _state.sliderVal,
          schoolType = _state.schoolType;

      var arrList = [""];
      var pickerData = void 0;
      if (school == "初中") {
        pickerData = [{ value: -1, label: -1 }, { value: 0, label: 0 }, { value: 1, label: 1 }, { value: 2, label: 2 }, { value: 3, label: 3 }, { value: 4, label: 4 }, { value: 5, label: 5 }, { value: 6, label: 6 }, { value: 7, label: 7 }, { value: 8, label: 8 }, { value: 9, label: 9 }, { value: 10, label: 10 }, { value: 11, label: 11 }];
      } else if (school == "高中") {
        pickerData = [{ value: -1, label: -1 }, { value: 0, label: 0 }, { value: 1, label: 1 }, { value: 2, label: 2 }, { value: 3, label: 3 }, { value: 4, label: 4 }, { value: 5, label: 5 }, { value: 6, label: 6 }, { value: 7, label: 7 }, { value: 8, label: 8 }, { value: 9, label: 9 }, { value: 10, label: 10 }, { value: 11, label: 11 }, { value: 12, label: 12 }, { value: 13, label: 13 }, { value: 14, label: 14 }];
      } else if (school == "大学") {
        pickerData = [{ value: -1, label: -1 }, { value: 0, label: 0 }, { value: 1, label: 1 }, { value: 2, label: 2 }, { value: 3, label: 3 }, { value: 4, label: 4 }, { value: 5, label: 5 }, { value: 6, label: 6 }, { value: 7, label: 7 }, { value: 8, label: 8 }, { value: 9, label: 9 }, { value: 10, label: 10 }, { value: 11, label: 11 }, { value: 12, label: 12 }, { value: 13, label: 13 }, { value: 14, label: 14 }, { value: 15, label: 15 }, { value: 16, label: 16 }, { value: 17, label: 17 }];
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader bgChange' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u6559\u80B2\u667A\u80FD\u89C4\u5212'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { onClick: this.goRule },
                '\u8BA1\u7B97\u89C4\u5219'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent', style: { paddingBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  '\u8F93\u5165\u5B50\u5973\u5E74\u9F84\u3001\u6559\u80B2\u9636\u6BB5\u548C\u5F53\u524D\u6559\u80B2\u91D1\u50A8\u5907\uFF0C\u7B97\u7B97\u60A8\u7684\u6559\u80B2\u91D1\u7F3A\u53E3\uFF1A'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pickerBox3', style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(235, 238, 240)",
                  position: "relative"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { value: [childAge], title: '\u9009\u62E9\u5E74\u9F84', extra: childAge, data: pickerData, onChange: this.changeAge, cols: 1, className: 'forss' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u5B69\u5B50\u5E74\u9F84'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 13, color: "#000", position: "absolute", right: 45, top: 15 } },
                '\u5C81'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(235, 238, 240)"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#000",
                    fontSize: "13px",
                    width: "50%"
                  } },
                '\u5F53\u524D\u6559\u80B2\u50A8\u5907\u91D1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 32, display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
                  style: {
                    height: 40,
                    width: "100%",
                    fontSize: 13,
                    color: "#3a3e47",
                    textAlign: 'right'
                  },
                  value: theMoney,
                  onChange: this.changeTheMoney,
                  placeholder: '\u8BF7\u8F93\u5165\u91D1\u989D',
                  onFocus: this.focusTheMoney,
                  onBlur: this.blurTheMoney
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 13, color: "#000", paddingLeft: 5 } },
                  '\u5143'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20, paddingBottom: 20, paddingLeft: 13, paddingRight: 13, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitJustifyContent: "center", paddingBottom: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.changeSchoolType("国内院校");
                  }, style: { borderStyle: "solid", borderWidth: 1, borderColor: schoolType == "国内院校" ? "#fe4920" : "#dcdcdc", borderRadius: 50, width: 100, height: 25, marginRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { height: "100%", display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: schoolType == "国内院校" ? "#fe4920" : "#3a3e47", fontSize: 12 } },
                    '\u56FD\u5185\u9662\u6821'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.changeSchoolType("国外院校");
                  }, style: { borderStyle: "solid", borderWidth: 1, borderColor: schoolType == "国外院校" ? "#fe4920" : "#dcdcdc", borderRadius: 50, width: 100, height: 25, marginRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { height: "100%", display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: schoolType == "国外院校" ? "#fe4920" : "#3a3e47", fontSize: 12 } },
                    '\u56FD\u5916\u9662\u6821'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlexDirection: 'row', WebkitAlignItems: "center", height: 50, display: "-webkit-flex", WebkitJustifyContent: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#3a3e47", fontSize: 12 } },
                '\u9884\u8BA1\u6BCF\u5E74\u6559\u80B2\u652F\u51FA'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: -15, borderBottom: "1px solid #fa063a" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', onChange: this.changeMoney, style: { color: "#fa063a", fontSize: 22, width: 90, padding: 0, textAlign: "center" }, value: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(sliderVal, false) == 0.00 ? "0" : __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(sliderVal, false) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#3a3e47", fontSize: 12 } },
                '\u5143'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 10, textAlign: "center" } },
              schoolType == "国内院校" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Slider"], { trackStyle: { backgroundColor: "transparent", width: window.winWidth - 34 }, railStyle: { backgroundColor: "transparent" }, handleStyle: (_ref2 = { backgroundColor: "transparent", border: 0, "boxShadow": "none", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: 30, width: 25 }, _defineProperty(_ref2, 'border', 0), _defineProperty(_ref2, 'backgroundImage', 'url(' + __webpack_require__(234) + ')'), _ref2), step: 1000, defaultValue: theOutMoney, min: 0, max: 60000, onChange: this.changeTheOutMoney }) : schoolType == "国外院校" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Slider"], { trackStyle: { backgroundColor: "transparent", width: window.winWidth - 34 }, railStyle: { backgroundColor: "transparent" }, handleStyle: (_ref3 = { backgroundColor: "transparent", border: 0, "boxShadow": "none", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: 30, width: 25 }, _defineProperty(_ref3, 'border', 0), _defineProperty(_ref3, 'backgroundImage', 'url(' + __webpack_require__(234) + ')'), _ref3), step: 1000, defaultValue: theOutMoney, min: 0, max: 600000, onChange: this.changeTheOutMoney }) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: __webpack_require__(384),
                style: { width: window.winWidth - 49, marginTop: 25 }
              }),
              arrList.map(function (data, key) {
                if (school == "初中") {
                  if (schoolType == "国内院校") {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: 0, style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '0w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '1w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '2w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '3w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '5w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '10w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '20w'
                      )
                    );
                  } else if (schoolType == "国外院校") {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: 0, style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '0w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '10w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '20w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '30w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '40w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '50w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '60w'
                      )
                    );
                  } else {
                    return null;
                  }
                } else if (school == "高中") {
                  if (schoolType == "国内院校") {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: 0, style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '0w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '1w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '2w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '3w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '5w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '10w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '20w'
                      )
                    );
                  } else if (schoolType == "国外院校") {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: 0, style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '0w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '10w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '20w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '30w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '40w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '50w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '60w'
                      )
                    );
                  } else {
                    return null;
                  }
                } else if (school == "大学") {
                  if (schoolType == "国内院校") {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: 0, style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '0w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '1w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '2w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '3w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '5w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '10w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '20w'
                      )
                    );
                  } else if (schoolType == "国外院校") {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { key: 0, style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '0w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '10w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '20w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '30w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '40w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '50w'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                        '60w'
                      )
                    );
                  } else {
                    return null;
                  }
                }
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: { display: "-webkit-flex", backgroundColor: "#fff", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13, marginTop: 10, paddingTop: 20, paddingBottom: 20 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: "#5b6270",
                  lineHeight: 1.5,
                  display: "block",
                  fontSize: "13px"
                } },
              '\u6E29\u99A8\u63D0\u793A : \u6559\u80B2\u50A8\u5907\u91D1\u662F\u6307\u60A8\u5F53\u524D\u8BA1\u5212\u7528\u4E8E\u5B50\u5973\u6559\u80B2\u7684\u50A8\u5907\u91D1\uFF0C\u4E00\u822C\u662F\u6307\u94F6\u884C\u5B58\u6B3E\u3001\u8865\u5145\u5546\u4E1A\u4FDD\u9669\u7B49\u3002\u5B69\u5B50\u6559\u80B2\u652F\u51FA\u4E00\u822C\u5305\u62EC\u5B66\u6742\u8D39\u3001\u5174\u8DA3\u73ED\u3001\u751F\u6D3B\u8D39\u7B49\u3002\u8BD5\u7B97\u5E74\u5316\u6536\u76CA\u7387\u4EC5\u7528\u4E8E\u65B9\u6848\u8BD5\u7B97\uFF0C\u4E0D\u4EE3\u8868\u67D0\u4E2A\u667A\u6295\u7EC4\u5408\u7684\u6536\u76CA\u8868\u73B0\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitJustifyContent: "center", WebkitAlignItems: "center", marginTop: 10, display: "-webkit-flex" } },
            theMoney != "" && theMoney != null && theMoney != undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.goResult, style: { backgroundColor: "#fa063a", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#fff", fontSize: 14 } },
                '\u8BCA\u65AD\u6559\u80B2\u6295\u8D44\u72B6\u51B5'
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#afb0b2", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#fff", fontSize: 14 } },
                '\u8BCA\u65AD\u6559\u80B2\u6295\u8D44\u72B6\u51B5'
              )
            )
          )
        ),
        !this.state.thunkIcon ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', left: 0, bottom: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.7)", WebkitJustifyContent: "center", WebkitAlignItems: "center", top: window.navigator.userAgent.indexOf("amcfmapp") > -1 || window.navigator.userAgent.indexOf("hxcfH5WX") > -1 || window.navigator.userAgent.match(/MicroMessenger/i) == "micromessenger" ? 0 : 44, display: "-webkit-flex", WebkitFlexDirection: "column" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: this.state.loadingIcon,
            style: { width: 250, height: 250, marginTop: -80 }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { marginTop: 25, fontSize: 18, color: "#fff" } },
            '\u8FD0\u7B97\u4E2D...'
          )
        )
      );
    }
  }]);

  return EducationCalculator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    yljycbMoney: state.yljycbMoney,
    yqyljyMoney: state.yqyljyMoney,
    yljyAge: state.yljyAge,
    yqyljySliderVal: state.yqyljySliderVal,
    jySchoolType: state.jySchoolType
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(EducationCalculator));

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalculatorLine_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NullView_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var EducationCalculatorPlan = function (_Component) {
  _inherits(EducationCalculatorPlan, _Component);

  function EducationCalculatorPlan() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EducationCalculatorPlan);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EducationCalculatorPlan.__proto__ || Object.getPrototypeOf(EducationCalculatorPlan)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      planType: _this.props.yljyPlan,
      startNum: _this.props.yljyNum,
      nowMoney: _this.props.yljyAllMoney,
      nowYear: _this.props.location.state.ageMax - _this.props.location.state.theParams.theAge,
      lineArray: _this.props.yljyLineData
      // addflag: false
    }, _this.getMoney = function (yearGap, N, planType, startNum) {
      var dispatch = _this.props.dispatch;

      _this.setState({
        lineArray: null
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_46" /* yljyLineData */])(null));
      var thisO = _this;
      setTimeout(function () {
        var nowYear = _this.state.nowYear;

        var r = 0.03;
        var r2 = 1 / (1 + r);
        var totalGap = yearGap * ((1 - Math.pow(r2, N)) / (1 - r2));
        var rate = void 0;
        if (planType == "每月投资方案") {
          if (startNum[0] == "沪深300，年化8%") {
            rate = Math.pow(0.08 + 1, 1 / 12) - 1;
          } else if (startNum[0] == "中债综合财富指数，年化4.2%") {
            rate = Math.pow(0.042 + 1, 1 / 12) - 1;
          } else if (startNum[0] == "标普500，年化7%") {
            rate = Math.pow(0.07 + 1, 1 / 12) - 1;
          }
          _this.PMT(rate, nowYear * 12, 0, totalGap);
        } else if (planType == "一次投资方案") {
          if (startNum[0] == "沪深300，年化8%") {
            rate = 0.08;
          } else if (startNum[0] == "中债综合财富指数，年化4.2%") {
            rate = 0.042;
          } else if (startNum[0] == "标普500，年化7%") {
            rate = 0.07;
          }
          _this.PV(rate, nowYear, totalGap);
        }
      });
    }, _this.PMT = function (ir, np, pv, fv) {
      var dispatch = _this.props.dispatch;

      var pmt = ir * (pv * Math.pow(ir + 1, np) + fv) / ((ir + 1) * (Math.pow(ir + 1, np) - 1));
      _this.setState({
        nowMoney: pmt.toFixed(2)
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_47" /* yljyAllMoney */])(pmt.toFixed(2)));
      _this.getProfitCurve4PMT(pmt, np, ir);
    }, _this.PV = function (ir, np, fv) {
      var dispatch = _this.props.dispatch;

      var pv = fv / Math.pow(1 + ir, np);
      _this.setState({
        nowMoney: pv.toFixed(2)
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_47" /* yljyAllMoney */])(pv.toFixed(2)));
      _this.getProfitCurve4PV(pv, np, ir);
    }, _this.getProfitCurve4PV = function (pv, n, r) {
      var dispatch = _this.props.dispatch;

      var c = [];
      for (var i = 0; i <= n; i++) {
        c[i] = (pv * Math.pow(1 + r, i) * 0.0001).toFixed(2);
      }
      _this.setState({
        lineArray: c
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_46" /* yljyLineData */])(c));
    }, _this.getProfitCurve4PMT = function (pmt, n, r) {
      var dispatch = _this.props.dispatch;

      var c = [];
      for (var i = 0; i <= n; i++) {
        if (i === 0) {
          c[i] = (pmt * 0.0001).toFixed(2);
        } else {
          c[i] = (c[i - 1] * (1 + r) + pmt * 0.0001).toFixed(2);
        }
      }
      _this.setState({
        lineArray: c
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_46" /* yljyLineData */])(c));
    }, _this.changeStartNum = function (value) {
      var dispatch = _this.props.dispatch;
      var theParams = _this.props.location.state.theParams;
      var planType = _this.state.planType;

      _this.setState({
        startNum: value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_48" /* yljyNum */])(value));
      var theValue = void 0;
      if (theParams.school == "小学") {
        theValue = 6;
      } else if (theParams.school == "中学") {
        theValue = 6;
      } else if (theParams.school == "大学") {
        theValue = 4;
      }
      if (theParams.gap < 0) {
        _this.getMoney(theParams.theOutMoney, theValue, planType, value);
      } else {
        _this.getMoney(theParams.gap, theValue, planType, value);
      }
    }, _this.changePlan = function (value) {
      var dispatch = _this.props.dispatch;
      var theParams = _this.props.location.state.theParams;

      _this.setState({
        planType: value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_49" /* yljyPlan */])(value));
      var theValue = void 0;
      if (theParams.school == "小学") {
        theValue = 6;
      } else if (theParams.school == "中学") {
        theValue = 6;
      } else if (theParams.school == "大学") {
        theValue = 4;
      }
      if (theParams.gap < 0) {
        _this.getMoney(theParams.theOutMoney, theValue, value, _this.state.startNum);
      } else {
        _this.getMoney(theParams.gap, theValue, value, _this.state.startNum);
      }
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }, _this.goInvestMain = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/nullView"
      });
    }, _this.goDetail = function () {
      var _this$props = _this.props,
          userHasInvested = _this$props.userHasInvested,
          inNeedUpdate = _this$props.inNeedUpdate,
          dispatch = _this$props.dispatch;
      var theParams = _this.props.location.state.theParams;

      var code = void 0;
      if (theParams.school == "小学") {
        code = 'SF1009';
      } else if (theParams.school == "中学") {
        code = 'SF1010';
      } else if (theParams.school == "大学") {
        code = 'SF1011';
      }
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: {
          superFundCode: code
        }
      });
    }, _this.goPayDetail = function (event) {
      event.stopPropagation();
      var dispatch = _this.props.dispatch;

      var route = window.history.length;
      var theParams = _this.props.location.state.theParams;

      var code = void 0,
          name = void 0;
      if (theParams.school == "小学") {
        code = 'SF1009';
        name = '金色起跑线';
      } else if (theParams.school == "中学") {
        code = 'SF1010';
        name = '菁英中学生';
      } else if (theParams.school == "大学") {
        code = 'SF1011';
        name = '常青藤大学';
      }
      var data = { superFundCode: code };
      var fun = function fun() {
        var params = {
          fundCode: code,
          fundName: name,
          productType: "Z",
          pageText: "申购",
          superTypeValue: "0"
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(route, params, __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */])(fun, window.history.length);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EducationCalculatorPlan, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "投资方案";
      var theParams = this.props.location.state.theParams;
      var planType = this.state.planType;

      var theValue = void 0;
      var dispatch = this.props.dispatch;

      var code = void 0;
      if (theParams.school == "小学") {
        code = 'SF1009';
        theValue = 6;
      } else if (theParams.school == "中学") {
        code = 'SF1010';
        theValue = 6;
      } else if (theParams.school == "大学") {
        code = 'SF1011';
        theValue = 4;
      }
      var data1 = { superFundCode: code };
      if (theParams.gap < 0) {
        this.getMoney(theParams.theOutMoney, theValue, planType, this.state.startNum);
      } else {
        this.getMoney(theParams.gap, theValue, planType, this.state.startNum);
      }
    }
  }, {
    key: 'ok',
    value: function ok() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/paymentSuperFund'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _ref2,
          _ref3;

      var theParams = this.props.location.state.theParams;
      var _state = this.state,
          planType = _state.planType,
          downUpListShow = _state.downUpListShow,
          startNum = _state.startNum,
          nowYear = _state.nowYear,
          nowMoney = _state.nowMoney,
          lineArray = _state.lineArray;

      var startNumArray = [{ value: "沪深300，年化8%", label: "沪深300，年化8%" }, { value: "中债综合财富指数，年化4.2%", label: "中债综合财富指数，年化4.2%" }, { value: "标普500，年化7%", label: "标普500，年化7%" }];
      var imgIcon = [];
      var textList2 = [];
      var textList3 = [];
      if (theParams.school == "小学") {
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          style: { width: 121, height: 85 },
          src: __webpack_require__(678)
        }));
        textList3.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 15, color: "#ff9536" } },
          '\u91D1\u8272\u8D77\u8DD1\u7EBF'
        ));
        textList2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 12, color: "#5b6470", marginTop: 8 } },
          '\u653B\u5B88\u517C\u5907 \u7D27\u8DDF\u5E02\u573A\u884C\u60C5'
        ));
      } else if (theParams.school == "中学") {
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          style: { width: 121, height: 85 },
          src: __webpack_require__(694)
        }));
        textList3.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 15, color: "#ff9536" } },
          '\u83C1\u82F1\u4E2D\u5B66\u751F'
        ));
        textList2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 12, color: "#5b6470", marginTop: 8 } },
          '\u5747\u8861\u914D\u7F6E \u7A33\u5065\u5347\u503C'
        ));
      } else if (theParams.school == "大学") {
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          style: { width: 121, height: 85 },
          src: __webpack_require__(652)
        }));
        textList3.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 15, color: "#ff9536" } },
          '\u5E38\u9752\u85E4\u5927\u5B66'
        ));
        textList2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 12, color: "#5b6470", marginTop: 8 } },
          '\u6295\u8D44\u672A\u6765 \u8D22\u5BCC\u542F\u822A'
        ));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: {
            backgroundColor: 'rgba(242,245,247,1)',
            display: "-webkit-flex",
            WebkitFlexDirection: "column",
            height: "100%"
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__["a" /* default */], { go: function go() {
            return _this2.ok();
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange', style: { backgroundSize: "cover", width: window.winWidth, height: 44 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: 100 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(21) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center" } },
                '\u6295\u8D44\u65B9\u6848'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.goInvestMain },
                  '\u8DF3\u8FC7'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { overflow: "auto", overflowX: "hidden", WebkitFlex: 1 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  '\u6839\u636E\u60A8\u7684\u60C5\u51B5\uFF0C\u4E3A\u60A8\u63A8\u8350\u4EE5\u4E0B\u4E24\u79CD\u6295\u8D44\u65B9\u6848\uFF0C\u4F9B\u53C2\u8003\uFF1A'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 10, paddingBottom: 10, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { display: "block", fontSize: "13px", color: "#5b6370", marginTop: 5, lineHeight: 1.5 } },
              '\u6E29\u99A8\u63D0\u793A : \u6295\u8D44\u65B9\u6848\u4E3A\u7ED3\u5408\u5E02\u573A\u4E2D\u4EE3\u8868\u6027\u6307\u6570\u8FC7\u53BB5\u5E74\u4E1A\u7EE9\u8FDB\u884C\u8BA1\u7B97\u7684\uFF0C\u8BD5\u7B97\u7ED3\u679C\u5E76\u4E0D\u4EE3\u8868\u60A8\u5B9E\u9645\u6295\u8D44\u80FD\u591F\u5F97\u5230\u7684\u6536\u76CA\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", height: 45, width: window.winWidth, WebkitFlexDirection: "row", border: "1px solid #ebedf0", backgroundColor: "#fff", marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.changePlan("每月投资方案");
                }, style: planType == "每月投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: planType == "每月投资方案" ? (_ref2 = { color: "#3a3e47" }, _defineProperty(_ref2, 'color', "#5b6370"), _defineProperty(_ref2, 'fontSize', 12), _ref2) : { color: "#5b6370", fontSize: 12 } },
                '\u6BCF\u6708\u6295\u8D44\u65B9\u6848'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.changePlan("一次投资方案");
                }, style: planType == "一次投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: planType == "一次投资方案" ? (_ref3 = { color: "#3a3e47" }, _defineProperty(_ref3, 'color', "#5b6370"), _defineProperty(_ref3, 'fontSize', 12), _ref3) : { color: "#5b6370", fontSize: 12 } },
                '\u4E00\u6B21\u6295\u8D44\u65B9\u6848'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: "13px" } },
                  planType == "每月投资方案" ? "每月投入" : "一次性投入"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 20, color: "#ff935f", marginTop: 5 } },
                  nowMoney != null ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(nowMoney, false) : null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#5b6370" } },
                    ' ',
                    nowMoney != null ? "元" : null
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: "13px" } },
                  '\u6301\u7EED\u6295\u8D44'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 20, color: "#3a3e47", marginTop: 5 } },
                  nowYear,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#5b6370" } },
                    ' \u5E74'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: "13px" } },
                  '\u9884\u671F\u53EF\u65B0\u589E\u6559\u80B2\u91D1'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 20, color: "#3a3e47", marginTop: 5 } },
                  theParams.gap < 0 ? theParams.school == "小学" ? 15 / 2 * 10000 : theParams.school == "中学" ? 30 / 2 * 10000 : 40 / 2 * 10000 : __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(Number(theParams.gap).toFixed(2), false),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#5b6370" } },
                    ' \u5143\uFF0F\u5E74'
                  )
                )
              )
            ),
            lineArray != null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CalculatorLine_js__["a" /* default */], { dataSource: lineArray, planType: planType, nowYear: nowYear }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pickerBox', style: {
                  display: "-webkit-flex",
                  height: 45,
                  borderTop: "1px solid rgb(235, 238, 240)",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  paddingLeft: 13,
                  paddingRight: 5,
                  backgroundColor: "#fff"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Picker"],
                { value: startNum, title: '\u8BA1\u7B97\u53C2\u8003\u6307\u6570', extra: startNum[0], data: startNumArray, onChange: this.changeStartNum, cols: 1, className: 'forss' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u9009\u62E9\u53C2\u8003\u6307\u6570'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: this.goDetail, style: { display: "-webkit-flex", height: 117, backgroundColor: "#fff", marginTop: 10, paddingTop: 20, paddingBottom: 20, WebkitFlexDirection: "row" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: "60%", paddingLeft: 13 } },
              textList3,
              textList2,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.goPayDetail, style: { display: "-webkit-flex", textAlign: "center", height: 25, width: 89, border: "1px solid #ff9536", marginTop: 15, borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#ff9536" } },
                  '\u4E00\u952E\u6295\u8D44'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", width: "40%", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              imgIcon
            )
          )
        )
      );
    }
  }]);

  return EducationCalculatorPlan;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    yljyPlan: state.yljyPlan,
    yljyNum: state.yljyNum,
    yljyAllMoney: state.yljyAllMoney,
    yljyLineData: state.yljyLineData
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(EducationCalculatorPlan));

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NullView_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CalculatorLine_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__guidePage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var EducationCalculatorResult = function (_Component) {
  _inherits(EducationCalculatorResult, _Component);

  function EducationCalculatorResult() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, EducationCalculatorResult);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EducationCalculatorResult.__proto__ || Object.getPrototypeOf(EducationCalculatorResult)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addflag: false,
      planType: "每月投资方案",
      startNum: "沪深300，年化8%",
      nowMoney: null,
      nowYear: _this.props.location.state.theParams.school == "初中" ? 12 - _this.props.location.state.theParams.theAge : _this.props.location.state.theParams.school == "高中" ? 15 - _this.props.location.state.theParams.theAge : 18 - _this.props.location.state.theParams.theAge,
      lineArray: null,
      resultShow: false,
      modalFlag: false,
      jmTitle: "",
      jmContent: "",
      superFundName: ''
    }, _this.goPlan = function () {
      var dispatch = _this.props.dispatch;

      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/EducationCalculatorPlan",
        state: {
          theParams: _this.props.location.state.theParams,
          ageMax: _this.props.location.state.theParams.school == "初中" ? 12 : _this.props.location.state.theParams.school == "高中" ? 15 : 18
        }
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_investmentAction_js__["_50" /* clearYlJyEnd */])());
    }, _this.goBack = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育测算结果", "回退"]);
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }, _this.goInvestMain = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/nullView"
      });
    }, _this.goDetail = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育测算结果", "组合详情"]);
      var _this$props = _this.props,
          userHasInvested = _this$props.userHasInvested,
          inNeedUpdate = _this$props.inNeedUpdate,
          dispatch = _this$props.dispatch;
      var theParams = _this.props.location.state.theParams;

      var code = void 0;
      if (theParams.school == "大学") {
        if (theParams.schoolType == "国内院校") {
          code = "SF1017";
        } else {
          code = "SF1018";
        }
      }
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: {
          superFundCode: code
        },
        query: {
          superFundCode: code
        }
      });
    }, _this.goPayDetail = function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event) {
        var flagDigital, _currentUserInfo, isMiniProgram, dispatch, route, theParams, code, name, data, fun;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.stopPropagation();
                window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "一键投资"]);
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('loginState');

              case 4:
                flagDigital = _context.sent;
                _context.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('currentUserInfo');

              case 7:
                _currentUserInfo = _context.sent;
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["i" /* onMiniProgramDialog */])(flagDigital != '0' && !_currentUserInfo.isRealName ? __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].OpenAccount : __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return');

              case 11:
                dispatch = _this.props.dispatch;
                route = window.history.length;
                theParams = _this.props.location.state.theParams;
                code = void 0, name = void 0;

                if (theParams.school == "大学") {
                  if (theParams.schoolType == "国内院校") {
                    code = "SF1017";
                    name = "国内培优教育金组合";
                  } else {
                    code = "SF1018";
                    name = "常青藤教育金组合";
                  }
                }
                data = { superFundCode: code };

                fun = function fun() {
                  var params = {
                    fundCode: code,
                    fundName: name,
                    productType: "Z",
                    pageText: "申购",
                    superTypeValue: "0"
                  };
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["j" /* getPayAll */])(route, params, __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["a" /* goLogin */])(fun, window.history.length);

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.getMoney = function (yearGap, N, planType, startNum) {
      _this.setState({
        lineArray: null
      });
      var thisO = _this;
      setTimeout(function () {
        var nowYear = thisO.state.nowYear;

        var r = 0.03;
        var r2 = 1 / (1 + r);
        var totalGap = yearGap * ((1 - Math.pow(r2, N)) / (1 - r2));
        var rate = void 0;
        if (planType == "每月投资方案") {
          if (startNum == "沪深300，年化8%") {
            rate = Math.pow(0.08 + 1, 1 / 12) - 1;
          } else if (startNum == "中债综合财富指数，年化4.2%") {
            rate = Math.pow(0.042 + 1, 1 / 12) - 1;
          } else if (startNum == "标普500，年化7%") {
            rate = Math.pow(0.07 + 1, 1 / 12) - 1;
          }
          thisO.PMT(rate, nowYear * 12, 0, totalGap);
        } else if (planType == "一次投资方案") {
          if (startNum == "沪深300，年化8%") {
            rate = 0.08;
          } else if (startNum == "中债综合财富指数，年化4.2%") {
            rate = 0.042;
          } else if (startNum == "标普500，年化7%") {
            rate = 0.07;
          }
          thisO.PV(rate, nowYear, totalGap);
        }
      });
    }, _this.PMT = function (ir, np, pv, fv) {
      var pmt = ir * (pv * Math.pow(ir + 1, np) + fv) / ((ir + 1) * (Math.pow(ir + 1, np) - 1));
      _this.setState({
        nowMoney: pmt.toFixed(2)
      });
      _this.getProfitCurve4PMT(pmt, np, ir);
    }, _this.PV = function (ir, np, fv) {
      var pv = fv / Math.pow(1 + ir, np);
      _this.setState({
        nowMoney: pv.toFixed(2)
      });
      _this.getProfitCurve4PV(pv, np, ir);
    }, _this.getProfitCurve4PV = function (pv, n, r) {
      var c = [];
      for (var i = 0; i <= n; i++) {
        c[i] = (pv * Math.pow(1 + r, i) * 0.0001).toFixed(2);
      }
      _this.setState({
        lineArray: c
      });
    }, _this.getProfitCurve4PMT = function (pmt, n, r) {
      var c = [];
      for (var i = 0; i <= n; i++) {
        if (i === 0) {
          c[i] = (pmt * 0.0001).toFixed(2);
        } else {
          c[i] = (c[i - 1] * (1 + r) + pmt * 0.0001).toFixed(2);
        }
      }
      _this.setState({
        lineArray: c
      });
    }, _this.changeStartNum = function (value) {
      var theParams = _this.props.location.state.theParams;
      var planType = _this.state.planType;

      _this.setState({
        startNum: value[0]
      });
      var theValue = void 0;
      if (theParams.school == "初中") {
        theValue = 3;
      } else if (theParams.school == "高中") {
        theValue = 3;
      } else if (theParams.school == "大学") {
        theValue = 4;
      }
      if (theParams.gap < 0) {
        _this.getMoney(theParams.theOutMoney, theValue, planType, value);
      } else {
        _this.getMoney(theParams.gap, theValue, planType, value);
      }
    }, _this.changePlan = function (value) {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育测算结果", "选择方案"]);
      var theParams = _this.props.location.state.theParams;

      _this.setState({
        planType: value
      });
      var theValue = void 0;
      if (theParams.school == "初中") {
        theValue = 3;
      } else if (theParams.school == "高中") {
        theValue = 3;
      } else if (theParams.school == "大学") {
        theValue = 4;
      }
      if (theParams.gap < 0) {
        _this.getMoney(theParams.theOutMoney, theValue, value, _this.state.startNum);
      } else {
        _this.getMoney(theParams.gap, theValue, value, _this.state.startNum);
      }
    }, _this.closeModal = function () {
      _this.setState({
        modalFlag: false
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", _this.touchMove, false);
    }, _this.showModal = function (value) {
      if (value == "0") {
        _this.setState({
          modalFlag: true,
          jmTitle: "查理解密",
          jmContent: "可支取的教育金是根据您当前实际的子女年龄、教育阶段和当前教育储备金，计算出您孩子达到适学年龄时，每年可支取的教育金。"
        });
      } else if (value == "1") {
        _this.setState({
          modalFlag: true,
          jmTitle: "查理解密",
          jmContent: "查理智投暂时还不支持组合定投业务，您需要通过每月主动投资来完成该投资方案。"
        });
      } else if (value == "2") {
        _this.setState({
          modalFlag: true,
          jmTitle: "查理解密",
          jmContent: "参考指数的年化收益是根据2002年至2017年期间的指数表现，取5年滚动收益序列求平均值，然后进行年化处理所得。"
        });
      }
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
    }, _this.touchMove = function (event) {
      event.preventDefault();
    }, _this.goDT = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event) {
        var flagDigital, _currentUserInfo, isMiniProgram, theParams, code, name, params;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.stopPropagation();
                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('loginState');

              case 3:
                flagDigital = _context2.sent;
                _context2.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('currentUserInfo');

              case 6:
                _currentUserInfo = _context2.sent;
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["i" /* onMiniProgramDialog */])(flagDigital != '0' && !_currentUserInfo.isRealName ? __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].OpenAccount : __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                theParams = _this.props.location.state.theParams;
                code = void 0, name = void 0;

                if (theParams.school == "大学") {
                  if (theParams.schoolType == "国内院校") {
                    code = "SF1017";
                    name = "国内培优教育金组合";
                  } else {
                    code = "SF1018";
                    name = "常青藤教育金组合";
                  }
                }
                params = {
                  fundCode: code,
                  fundName: name,
                  productType: "Z",
                  pageText: "新建定投计划",
                  superTypeValue: "0",
                  text: _this.state.nowMoney != null ? _this.state.nowMoney : ''
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EducationCalculatorResult, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育测算结果", "退出"]);
      __WEBPACK_IMPORTED_MODULE_14__guidePage__["b" /* default */].leave();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育测算结果", "进入"]);
      document.getElementsByTagName('title')[0].innerHTML = "教育测算结果";
      var theParams = this.props.location.state.theParams;
      var _state = this.state,
          planType = _state.planType,
          startNum = _state.startNum;
      var dispatch = this.props.dispatch;

      var theValue = void 0;
      var code = void 0;
      if (theParams.school == "大学") {
        theValue = 4;
        if (theParams.schoolType == "国内院校") {
          code = "SF1017";
        } else {
          code = "SF1018";
        }
      }
      if (theParams.gap < 0) {
        this.getMoney(theParams.theOutMoney, theValue, planType, startNum);
      } else {
        this.getMoney(theParams.gap, theValue, planType, startNum);
      }
    }
  }, {
    key: 'ok',
    value: function ok() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/paymentSuperFund'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var theParams = this.props.location.state.theParams;
      var _state2 = this.state,
          planType = _state2.planType,
          downUpListShow = _state2.downUpListShow,
          startNum = _state2.startNum,
          nowYear = _state2.nowYear,
          nowMoney = _state2.nowMoney,
          lineArray = _state2.lineArray,
          jmContent = _state2.jmContent,
          jmTitle = _state2.jmTitle;

      var startNumArray = [{ value: "沪深300，年化8%", label: "沪深300，年化8%" }, { value: "中债综合财富指数，年化4.2%", label: "中债综合财富指数，年化4.2%" }, { value: "标普500，年化7%", label: "标普500，年化7%" }];
      var textList3 = [];
      if (theParams.school == "大学") {
        if (theParams.schoolType == "国内院校") {
          textList3.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { key: 0, style: { fontSize: 18, color: "#fa063a" } },
            "国内培优教育金组合"
          ));
        } else {
          textList3.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { key: 0, style: { fontSize: 18, color: "#fa063a" } },
            "常青藤教育金组合"
          ));
        }
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__["a" /* default */], { go: function go() {
            return _this3.ok();
          } }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'boxHeader bgChange', style: { zIndex: 99999990 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u6559\u80B2\u6D4B\u7B97\u7ED3\u679C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { onClick: this.goInvestMain },
                '\u8DF3\u8FC7'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'boxContent', id: 'EducationCalculatorResultIndex', style: { paddingBottom: 74, display: 'flex', flex: 1, overflowY: 'scroll', flexDirection: 'column' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  theParams.gap <= 0 ? "根据测算，您目前的教育储备已可以满足您的需求。为了给您的孩子更好的教育保障，为您推荐教育智投组合投资方案：" : "根据测算，您目前的教育储蓄和教育费用预算还存在较大差距，建议您提早投资，增加教育金储备。为您推荐教育智投组合投资方案："
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, position: "relative" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { color: "#5b6370", fontSize: 13 } },
                    '\u53EF\u652F\u53D6\u6559\u80B2\u91D1'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        _this3.showModal("0");
                      }, style: { position: "absolute", width: 35, height: 35, right: -40, top: -10, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(126), style: { width: 15, height: 15 } })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#3a3e47", marginTop: 5 } },
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(theParams.actual, false),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5143\uFF0F\u5E74'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: "#5b6370", fontSize: 13 } },
                    '\u6559\u80B2\u91D1\u7F3A\u53E3'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#fa063a", marginTop: 5 } },
                  theParams.gap < 0 ? 0 : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(theParams.gap, false),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5143\uFF0F\u5E74'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(255, 238, 240)"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: {
                    color: "#5b6370",
                    fontSize: "13px",
                    width: "50%"
                  } },
                '\u9884\u8BA1\u6BCF\u5E74\u6559\u80B2\u652F\u51FA'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: {
                    color: "#5b6370",
                    fontSize: "13px",
                    width: "50%",
                    textAlign: "right"
                  } },
                theParams.theOutMoney,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { fontSize: "13px", color: "#5b6370" } },
                  '\u5143\uFF0F\u5E74'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", height: 45, width: window.winWidth, WebkitFlexDirection: "row", border: "1px solid #ebedf0", backgroundColor: "#fff", marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this3.changePlan("每月投资方案");
                }, style: planType == "每月投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: planType == "每月投资方案" ? { color: "#3a3e47", fontSize: 13 } : { color: "#5b6370", fontSize: 13 } },
                '\u6BCF\u6708\u6295\u8D44\u65B9\u6848'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this3.changePlan("一次投资方案");
                }, style: planType == "一次投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: planType == "一次投资方案" ? { color: "#3a3e47", fontSize: 13 } : { color: "#5b6370", fontSize: 13 } },
                '\u4E00\u6B21\u6295\u8D44\u65B9\u6848'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: 13, position: "relative" } },
                  planType == "每月投资方案" ? "每月投入" : "一次性投入",
                  planType == "每月投资方案" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        _this3.showModal("1");
                      }, style: { position: "absolute", width: 35, height: 35, right: -30, top: -10, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(126), style: { width: 15, height: 15 } })
                  ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#3a3e47", marginTop: 5 } },
                  nowMoney != null ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(nowMoney, false) : null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' ',
                    nowMoney != null ? "元" : null
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { divAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: 13 } },
                  '\u6301\u7EED\u6295\u8D44'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#3a3e47", marginTop: 5 } },
                  nowYear,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5E74'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: 13 } },
                  '\u53EF\u65B0\u589E\u6559\u80B2\u91D1'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#fa063a", marginTop: 5 } },
                  theParams.gap < 0 ? theParams.school == "初中" ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(15 / 2 * 10000, false) : theParams.school == "高中" ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(30 / 2 * 10000, false) : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(40 / 2 * 10000, false) : lineArray != null ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(Math.round(Number(lineArray[lineArray.length - 1])) * 10000, false) : null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5143'
                  )
                )
              )
            ),
            lineArray != null ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CalculatorLine_js__["a" /* default */], { dataSource: lineArray, planType: planType, nowYear: nowYear }) : null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'pickerBox', style: {
                  display: "-webkit-flex",
                  height: 45,
                  borderTop: "1px solid rgb(235, 238, 240)",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  paddingLeft: 13,
                  paddingRight: 5,
                  backgroundColor: "#fff",
                  position: "relative"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Picker"],
                { value: [startNum], title: '\u8BA1\u7B97\u53C2\u8003\u6307\u6570', extra: startNum, data: startNumArray, onChange: this.changeStartNum, cols: 1, className: 'forss' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u9009\u62E9\u53C2\u8003\u6307\u6570'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.showModal("2");
                  }, style: { position: "absolute", width: 35, height: 35, left: 90, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(126), style: { width: 15, height: 15 } })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 10, paddingBottom: 10, backgroundColor: "#fff", marginTop: 10, marginBottom: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { fontSize: 13, color: "#5b6370", marginTop: 5, lineHeight: "20px", fontWeight: "bold" } },
              '\u6E29\u99A8\u63D0\u793A : ',
              '\u4E0A\u8FF0\u6A21\u62DF\u4F7F\u7528\u5E02\u573A\u4E2D\u4EE3\u8868\u6027\u6307\u6570\u8FC7\u53BB5\u5E74\u7684\u5E74\u5316\u5E73\u5747\u6536\u76CA\u7387\u8BA1\u7B97\uFF0C\u672A\u6765\u7531\u4E8E\u5E02\u573A\u73AF\u5883\u4E0D\u540C\u3001\u5B9E\u9645\u6295\u8D44\u8FD0\u4F5C\u7B49\u4E0D\u53EF\u80FD\u5B8C\u5168\u590D\u5236\u8BE5\u6A21\u62DF\u7ED3\u679C\u3002\u8BE5\u6A21\u62DF\u4E0D\u80FD\u4F5C\u4E3A\u6295\u8D44\u9884\u6D4B\uFF0C\u4E5F\u4E0D\u4EE3\u8868\u60A8\u5B9E\u9645\u6295\u8D44\u6240\u5F97\u6536\u76CA\uFF0C\u6295\u8D44\u4E5F\u53EF\u80FD\u906D\u9047\u4E8F\u635F\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { onClick: this.goDetail, style: { position: "fixed", bottom: 0, width: "100%", zIndex: 99999990, height: 74, backgroundColor: "#fff", paddingTop: 10, paddingBottom: 10, WebkitFlexDirection: "row", borderTop: "1px solid #e1e3e6", display: "-webkit-flex", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 0.6, paddingLeft: 13, WebkitJustifyContent: "flex-start", display: "-webkit-flex", WebkitFlexDirection: "column" } },
            textList3,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, color: "#000", marginTop: 5 } },
              '\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 0.4, WebkitJustifyContent: "flex-end", WebkitAlignItems: "flex-end", paddingRight: 13, display: "-webkit-flex" } },
            planType == "每月投资方案" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: this.goDT, style: { backgroundColor: "#fa063a", height: 35, width: 130, border: "1px solid #fa063a", borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 18, color: "#fff" } },
                '\u4E00\u952E\u5B9A\u6295'
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: this.goPayDetail, style: { backgroundColor: "#fa063a", height: 35, width: 130, border: "1px solid #fa063a", borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 18, color: "#fff" } },
                '\u4E00\u952E\u6295\u8D44'
              )
            )
          )
        ),
        this.state.modalFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#333333", fontWeight: "500", paddingLeft: 20, paddingRight: 20 } },
                jmContent
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.closeModal, style: { width: "100%", height: "40px", textAlign: "center", lineHeight: "40px", borderTopColor: "#ebeef0", borderTopWidth: "1px", borderTopStyle: "solid", marginTop: "15px" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 17, color: '#666666' } },
                    '\u77E5\u9053\u4E86'
                  )
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return EducationCalculatorResult;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__HOC_StateCache_js__["a" /* default */])(EducationCalculatorResult, 'EducationCalculatorResultIndex')));

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var EducationCalculatorSelectSchool = function (_Component) {
  _inherits(EducationCalculatorSelectSchool, _Component);

  function EducationCalculatorSelectSchool() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EducationCalculatorSelectSchool);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EducationCalculatorSelectSchool.__proto__ || Object.getPrototypeOf(EducationCalculatorSelectSchool)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      theMoney: "",
      childAge: 0
    }, _this.goBack = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "回退"]);
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }, _this.goEducationCalculator = function (school) {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "选择学校"]);
      var dispatch = _this.props.dispatch;

      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/educationCalculator",
        state: {
          school: school
        }
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_56" /* clearJyOne */])(school));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EducationCalculatorSelectSchool, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "进入"]);
      document.getElementsByTagName('title')[0].innerHTML = "教育智能规划";
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "退出"]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          theMoney = _state.theMoney,
          childAge = _state.childAge;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader bgChange' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u6559\u80B2\u667A\u80FD\u89C4\u5212'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  '\u6295\u8D44\u6559\u80B2\u7684\u65B9\u5F0F\u4E0D\u662F\u53EA\u6709\u5B66\u533A\u623F\uFF0C\u4E0E\u5176\u4E70\u4E00\u595780\u5E74\u4EE3\u7684\u5929\u4EF7\u5B66\u533A\u623F\uFF0C\u8FD8\u4E0D\u5982\u8BA9\u67E5\u7406\u4E3A\u60A8\u91CF\u8EAB\u5B9A\u5236\u4E00\u4EFD\u6559\u80B2\u7406\u8D22\u89C4\u5212\u65B9\u6848\uFF0C\u4E3A\u5B69\u5B50\u4E0A\u5B66\u63D0\u524D\u50A8\u5907\u6559\u80B2\u91D1\u3002'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 25, paddingLeft: 13, paddingRight: 13, paddingBottom: 12.5 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: "#5b6270", fontSize: "13px" } },
              '\u8BF7\u9009\u62E9\u60A8\u7684\u6559\u80B2\u50A8\u5907\u91D1\u4F7F\u7528\u9636\u6BB5:'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: 240, backgroundColor: "#fff", paddingLeft: 13, paddingRight: 13 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 80, borderBottom: "1px solid rgb(235, 238, 240)", WebkitFlexDirection: "row" }, onClick: function onClick() {
                  return _this2.goEducationCalculator("大学");
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginRight: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: __webpack_require__(651),
                  style: { height: 48, width: 48 }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 7.5 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#3a3e47", display: "block" } },
                    '\u5E38\u9752\u85E4\u5927\u5B66\u7EC4\u5408'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 10, color: "#a1a7b2", display: "block" } },
                    '\u4E3A\u5927\u5B66\u9636\u6BB5\u50A8\u5907\u6559\u80B2\u91D1'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 80, borderBottom: "1px solid rgb(235, 238, 240)", WebkitFlexDirection: "row" }, onClick: function onClick() {
                  return _this2.goEducationCalculator("高中");
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginRight: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: __webpack_require__(654),
                  style: { height: 48, width: 48 }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 7.5 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#3a3e47", display: "block" } },
                    '\u83C1\u82F1\u9AD8\u4E2D\u751F\u7EC4\u5408'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 10, color: "#a1a7b2", display: "block" } },
                    '\u4E3A\u9AD8\u4E2D\u9636\u6BB5\u50A8\u5907\u6559\u80B2\u91D1'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 80, WebkitFlexDirection: "row" }, onClick: function onClick() {
                  return _this2.goEducationCalculator("初中");
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", marginRight: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                  src: __webpack_require__(691),
                  style: { height: 48, width: 48 }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 7.5 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#3a3e47", display: "block" } },
                    '\u96CF\u9E70\u521D\u4E2D\u751F\u7EC4\u5408'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 10, color: "#a1a7b2", display: "block" } },
                    '\u4E3A\u521D\u4E2D\u9636\u6BB5\u50A8\u5907\u6559\u80B2\u91D1'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EducationCalculatorSelectSchool;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(EducationCalculatorSelectSchool));

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Encyclopedia = function (_Component) {
  _inherits(Encyclopedia, _Component);

  function Encyclopedia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Encyclopedia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Encyclopedia.__proto__ || Object.getPrototypeOf(Encyclopedia)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      listSource: null
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }, _this.goDetail = function (content) {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
        pathname: "/encyclopediaDetail",
        state: {
          content: content
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Encyclopedia, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      document.getElementsByTagName('title')[0].innerHTML = "智投百科";
      var dispatch = this.props.dispatch;

      this.setState({
        listSource: null
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_60" /* encyclopediaAction */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_61" /* getEncyclopedia */])({
        code: "wt_zt2"
      }, function (data) {
        _this2.setState({
          listSource: [].concat(data.content.rows)
        });
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var listSource = this.state.listSource;
      var encyclopediaAction = this.props.encyclopediaAction;

      var contentArray = [];
      if (listSource != null) {
        for (var i = 0; i < listSource.length; i++) {
          for (var k = i + 1; k < listSource.length; k++) {
            if (listSource[i].bq[0].tagId == listSource[k].bq[0].tagId) {
              listSource.splice(k, 1);
            }
          }
        }
        if (encyclopediaAction != null) {
          for (var s = 0; s < listSource.length; s++) {
            contentArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: s, style: {
                  height: 50,
                  paddingTop: 25,
                  paddingLeft: 13,
                  paddingRight: 13
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#3a3e47",
                    fontSize: "13px"
                  } },
                listSource[s].bq[0].tagName
              )
            ));

            var _loop = function _loop(h) {
              if (listSource[s].bq[0].tagId == encyclopediaAction[h].bq[0].tagId) {
                contentArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: encyclopediaAction[h].bq[0].cjwtId },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this3.goDetail(encyclopediaAction[h].title);
                      }, style: {
                        display: "-webkit-flex",
                        height: 45,
                        paddingLeft: 13,
                        paddingRight: 6.5,
                        backgroundColor: "#fff",
                        borderBottom: "1px solid rgb(235, 238, 240)",
                        WebkitJustifyContent: "space-between",
                        WebkitAlignItems: "center",
                        WebkitFlexDirection: "row",
                        WebkitFlexWrap: "wrap"
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { dangerouslySetInnerHTML: { __html: encyclopediaAction[h].title }, style: {
                        color: "#3a3e47",
                        fontSize: 12
                      } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                      src: __webpack_require__(163),
                      style: {
                        width: 22,
                        height: 44
                      }
                    })
                  )
                ));
              }
            };

            for (var h = 0; h < encyclopediaAction.length; h++) {
              _loop(h);
            }
          }
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#fff", display: "-webkit-flex", WebkitFlexDirection: "column", height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { background: "rgb(38, 42, 48)", display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center" } },
              '\u667A\u6295\u767E\u79D1'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right" } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { WebkitFlex: 1, overflow: "auto", background: "rgba(242,245,247,1)" } },
          encyclopediaAction != null ? contentArray : null
        )
      );
    }
  }]);

  return Encyclopedia;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    encyclopediaAction: state.encyclopediaAction
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Encyclopedia));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EncyclopediaDetail = function (_Component) {
  _inherits(EncyclopediaDetail, _Component);

  function EncyclopediaDetail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EncyclopediaDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EncyclopediaDetail.__proto__ || Object.getPrototypeOf(EncyclopediaDetail)).call.apply(_ref, [this].concat(args))), _this), _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EncyclopediaDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "百科详情";
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u767E\u79D1\u8BE6\u60C5'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.props.location.state.content }, style: { WebkitFlex: 1, fontSize: 18, paddingLeft: 13, paddingRight: 13, paddingTop: 13, paddingBottom: 13 } })
        )
      );
    }
  }]);

  return EncyclopediaDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EncyclopediaDetail);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KnowMore = function (_Component) {
  _inherits(KnowMore, _Component);

  function KnowMore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, KnowMore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KnowMore.__proto__ || Object.getPrototypeOf(KnowMore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rotateNum: 0
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(KnowMore, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "华夏智投组合介绍";
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#fff", display: "-webkit-flex", WebkitFlexDirection: "column", height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { background: "rgb(38, 42, 48)", display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center" } },
              '\u534E\u590F\u667A\u6295\u7EC4\u5408\u4ECB\u7ECD'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right" } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { fontSize: 18, paddingLeft: 13, paddingRight: 13, paddingTop: 13, WebkitFlex: 1, paddingBottom: 13 } },
          this.props.location.state.content
        )
      );
    }
  }]);

  return KnowMore;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (KnowMore);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var interVal = null;

var PensionCalculator = function (_Component) {
  _inherits(PensionCalculator, _Component);

  function PensionCalculator() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PensionCalculator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PensionCalculator.__proto__ || Object.getPrototypeOf(PensionCalculator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      theMoney: _this.props.location.query.theMoney ? _this.props.location.query.theMoney : _this.props.yljycbMoney,
      sliderGetMoneyValue: _this.props.location.query.sliderGetMoneyValue ? _this.props.location.query.sliderGetMoneyValue : _this.props.yqyljyMoney,
      sliderVal: _this.props.location.query.sliderVal ? _this.props.location.query.sliderVal : _this.props.yqyljySliderVal,
      theAge: _this.props.location.query.theAge ? _this.props.location.query.theAge : _this.props.yljyAge,
      thunkIcon: false,
      theOutAge: _this.props.location.query.theOutAge ? _this.props.location.query.theOutAge : _this.props.ylOutAge,
      loadingArr: [__webpack_require__(235), __webpack_require__(246), __webpack_require__(253), __webpack_require__(254), __webpack_require__(255), __webpack_require__(256), __webpack_require__(257), __webpack_require__(258), __webpack_require__(259), __webpack_require__(236), __webpack_require__(237), __webpack_require__(238), __webpack_require__(239), __webpack_require__(240), __webpack_require__(241), __webpack_require__(242), __webpack_require__(243), __webpack_require__(244), __webpack_require__(245), __webpack_require__(247), __webpack_require__(248), __webpack_require__(249), __webpack_require__(250), __webpack_require__(251), __webpack_require__(252)],
      loadingIcon: ""
    }, _this.goBack = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "回退"]);
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }, _this.changeTheMoney = function (event) {
      var dispatch = _this.props.dispatch;

      _this.setState({
        theMoney: event.target.value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_51" /* yljycbMoney */])(event.target.value));
    }, _this.changeTheAge = function (event) {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "输入年龄"]);
      var dispatch = _this.props.dispatch;

      _this.setState({
        theAge: event.target.value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_54" /* yljyAge */])(event.target.value));
    }, _this.changeTheOutAge = function (event) {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "输入退休年龄"]);
      var dispatch = _this.props.dispatch;

      _this.setState({
        theOutAge: event.target.value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_57" /* ylOutAge */])(event.target.value));
    }, _this.changeGetMoney = function (value) {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "输入养老金"]);
      var dispatch = _this.props.dispatch;

      if (value > 10000) {
        var a = (50000 - 10000) / (2000 / 500);
        var b = (value - 10000) / 500;
        _this.setState({
          sliderVal: a * b + 10000
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_52" /* yqyljySliderVal */])(a * b + 10000));
      } else {
        _this.setState({
          sliderVal: value
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_52" /* yqyljySliderVal */])(value));
      }
      _this.setState({
        sliderGetMoneyValue: value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_53" /* yqyljyMoney */])(value));
    }, _this.goResult = function () {
      var _this$state = _this.state,
          theAge = _this$state.theAge,
          theMoney = _this$state.theMoney,
          sliderVal = _this$state.sliderVal,
          theOutAge = _this$state.theOutAge;

      var regAge = /^[0-9]*$/;
      var regMoney = /^(([1-9]\d{0,9})|0)(\.\d{1,2})?$/;
      if (!regAge.test(theAge)) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请输入有效年龄", 2);
        return;
      }
      if (!regAge.test(theOutAge)) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请输入有效的退休年龄", 2);
        return;
      } else {
        if (Number(theOutAge) < 30 || Number(theOutAge) > 85) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请输入有效的退休年龄", 2);
          return;
        }
      }
      if (Number(theAge) >= Number(theOutAge)) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("退休年龄需大于您的实际年龄", 2);
        return;
      }
      if (!regMoney.test(theMoney)) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请输入有效金额", 2);
        return;
      }
      if (sliderVal == 0) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("预期养老金不能为0", 2);
        return;
      }
      _this.getYearGap(theAge, sliderVal * 12, theMoney, theOutAge, 90 - theOutAge);
    }, _this.getYearGap = function (A, N, S, DL, P) {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "计算结果"]);
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
      _this.setState({
        thunkIcon: true,
        loadingIcon: _this.state.loadingArr[0]
      });
      var r = 0.03;
      var r2 = 1 / (1 + r);
      var ST = S * Math.pow(r + 1, DL - A);
      var N1 = ST / ((1 - Math.pow(r2, P)) / (1 - r2));
      var count = 0;
      interVal = setInterval(function () {
        if (count == 49) {
          clearInterval(interVal);
          _this.setState({
            thunkIcon: false
          });
          var _obj = document.getElementsByTagName("html")[0];
          _obj.style.overflowY = "auto";
          _obj.style.overflowY = "auto";
          _obj.removeEventListener("touchmove", _this.touchMove, false);
          __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
            pathname: "/pensionCalculatorResult",
            state: {
              theParams: {
                actual: N1.toFixed(2),
                gap: (N - N1).toFixed(2),
                theMoney: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(N / 12, false),
                theAge: A,
                yqylj: _this.state.sliderVal,
                theOutAge: DL
              }
            }
          });
        } else {
          count++;
          if (count > 24) {
            _this.setState({
              loadingIcon: _this.state.loadingArr[count - 25]
            });
          } else {
            _this.setState({
              loadingIcon: _this.state.loadingArr[count]
            });
          }
        }
      }, 100);
    }, _this.goRule = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "计算规则"]);
      var code = __WEBPACK_IMPORTED_MODULE_3__BankCode__["a" /* protocolCode */]["养老计算器规则"];
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: {
          name: "养老计算器规则",
          code: code
        },
        query: {
          code: code
        }
      });
    }, _this.focusTheAge = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.theAge == "35") {
        _this.setState({
          theAge: ""
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_54" /* yljyAge */])(""));
      }
    }, _this.blurTheAge = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.theAge == "") {
        _this.setState({
          theAge: "35"
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_54" /* yljyAge */])("35"));
      }
    }, _this.focusTheOutAge = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.theOutAge == "65") {
        _this.setState({
          theOutAge: ""
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_57" /* ylOutAge */])(""));
      }
    }, _this.blurTheOutAge = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.theOutAge == "") {
        _this.setState({
          theOutAge: "65"
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_57" /* ylOutAge */])("65"));
      }
    }, _this.focusTheMoney = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.theMoney == "0") {
        _this.setState({
          theMoney: ""
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_51" /* yljycbMoney */])(""));
      }
    }, _this.blurTheMoney = function () {
      var dispatch = _this.props.dispatch;

      if (_this.state.theMoney == "") {
        _this.setState({
          theMoney: "0"
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_51" /* yljycbMoney */])("0"));
      }
    }, _this.changeMoney = function (event) {
      var reg = /^[0-9]*$/;
      var dispatch = _this.props.dispatch;

      if (event.target.value.length <= 7 && reg.test(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.priceParse(event.target.value))) {
        _this.setState({
          sliderVal: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.priceParse(event.target.value)
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_investmentAction_js__["_52" /* yqyljySliderVal */])(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.priceParse(event.target.value)));
      }
    }, _this.touchMove = function (event) {
      event.preventDefault();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PensionCalculator, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "进入"]);
      var _props = this.props,
          dispatch = _props.dispatch,
          isLogin = _props.isLogin;
      // getStorage("openFlagYl")
      // .then((data) => {
      //   if(data) {
      //     this.setState({
      //       theMoney: "0",
      //       sliderGetMoneyValue: 5000,
      //       sliderVal: 5000,
      //       theAge: "35",
      //     });
      //     dispatch(yljycbMoney("0"));
      //     dispatch(yqyljyMoney(5000));
      //     dispatch(yqyljySliderVal(5000));
      //     dispatch(yljyAge("35"));
      //     setStorage("openFlagYl", false);
      //   }
      // });

      document.getElementsByTagName('title')[0].innerHTML = "养老智能规划";
      //Toast.loading("正在加载", 0);
      if (isLogin) {
        // dispatch(getUserInfoList(this, (flag, data) => {
        //   if(flag) {
        //     let birthday = returnDate(data.content.birthday+3600000);
        //     let age = returnAge(birthday)
        //     this.setState({
        //       theAge: String(age)
        //     });
        //     dispatch(yljyAge(String(age)));
        //   }else {
        //     this.setState({
        //       theAge: "35"
        //     });
        //     dispatch(yljyAge("35"));
        //   }
        //   Toast.hide();
        // }));
      } else {}
    }

    //此处计算器按照每年金额计算，N为预期每年支出的养老金

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智能规划", "退出"]);
      clearInterval(interVal);
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", this.touchMove, false);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref2;

      var _state = this.state,
          theMoney = _state.theMoney,
          sliderGetMoneyValue = _state.sliderGetMoneyValue,
          theAge = _state.theAge,
          sliderVal = _state.sliderVal,
          theOutAge = _state.theOutAge;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader bgChange' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u517B\u8001\u667A\u80FD\u89C4\u5212'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { onClick: this.goRule },
                '\u8BA1\u7B97\u89C4\u5219'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent', style: { paddingBottom: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  '\u8F93\u5165\u60A8\u9000\u4F11\u540E\u671F\u671B\u6BCF\u5E74\u83B7\u5F97\u7684\u517B\u8001\u91D1\u6536\u5165\u548C\u76EE\u524D\u7684\u50A8\u5907\u91D1\u72B6\u51B5\uFF0C\u7B97\u7B97\u60A8\u7684\u517B\u8001\u91D1\u7F3A\u53E3\uFF1A'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(235, 238, 240)"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#000",
                    fontSize: "13px",
                    width: "50%"
                  } },
                '\u60A8\u7684\u5E74\u9F84'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
                  style: {
                    height: 40,
                    width: "100%",
                    fontSize: 13,
                    color: "#3a3e47",
                    textAlign: 'right'
                  },
                  value: theAge,
                  onFocus: this.focusTheAge,
                  onBlur: this.blurTheAge,
                  onChange: this.changeTheAge,
                  placeholder: '\u8BF7\u8F93\u5165\u5E74\u9F84'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 13, color: "#000", paddingLeft: 5 } },
                  '\u5C81'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(235, 238, 240)"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#000",
                    fontSize: "13px",
                    width: "50%"
                  } },
                '\u9000\u4F11\u5E74\u9F84'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
                  style: {
                    height: 40,
                    width: "100%",
                    fontSize: 13,
                    color: "#3a3e47",
                    textAlign: 'right'
                  },
                  value: theOutAge,
                  onFocus: this.focusTheOutAge,
                  onBlur: this.blurTheOutAge,
                  onChange: this.changeTheOutAge,
                  placeholder: '\u8BF7\u8F93\u5165\u9000\u4F11\u5E74\u9F84'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 13, color: "#000", paddingLeft: 5 } },
                  '\u5C81'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(235, 238, 240)"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#000",
                    fontSize: "13px",
                    width: "50%"
                  } },
                '\u5F53\u524D\u517B\u8001\u50A8\u5907\u91D1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
                  style: {
                    height: 40,
                    width: "100%",
                    fontSize: 13,
                    color: "#3a3e47",
                    textAlign: 'right'
                  },
                  value: theMoney,
                  onFocus: this.focusTheMoney,
                  onBlur: this.blurTheMoney,
                  onChange: this.changeTheMoney,
                  placeholder: '\u8BF7\u8F93\u5165\u91D1\u989D'
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 13, color: "#000", paddingLeft: 5 } },
                  '\u5143'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: { display: "-webkit-flex", backgroundColor: "rgb(235, 238, 240)", height: 80, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: "#5b6270",
                  lineHeight: 1.5,
                  display: "block",
                  fontSize: "13px"
                } },
              '\u517B\u8001\u50A8\u5907\u91D1\u662F\u6307\u60A8\u5F53\u524D\u8BA1\u5212\u7528\u4E8E\u517B\u8001\u7684\u50A8\u5907\u91D1\uFF0C\u4E00\u822C\u662F\u6307\u94F6\u884C\u5B58\u6B3E\u3001\u4F01\u4E1A\u5E74\u91D1\u3001\u793E\u4FDD\u53CA\u517B\u8001\u8865\u5145\u5546\u4E1A\u4FDD\u9669\u7B49\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20, paddingBottom: 20, paddingLeft: 13, paddingRight: 13, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlexDirection: 'row', WebkitAlignItems: "center", height: 50, display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#3a3e47", fontSize: 12 } },
                '\u60A8\u9884\u671F\u517B\u8001\u91D1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: -15, borderBottom: "1px solid #fa063a" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', onChange: this.changeMoney, style: { color: "#fa063a", fontSize: 22, width: 90, padding: 0, textAlign: "center" }, value: __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(sliderVal, false) == 0.00 ? "0" : __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(sliderVal, false) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#3a3e47", fontSize: 12 } },
                '\u5143\uFF0F\u6708'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, textAlign: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Slider"], { trackStyle: { backgroundColor: "transparent", width: window.winWidth - 34 }, railStyle: { backgroundColor: "transparent" }, handleStyle: (_ref2 = { backgroundColor: "transparent", border: 0, "boxShadow": "none", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: 30, width: 25 }, _defineProperty(_ref2, 'border', 0), _defineProperty(_ref2, 'backgroundImage', 'url(' + __webpack_require__(234) + ')'), _ref2), step: 500, defaultValue: sliderGetMoneyValue, min: 0, max: 12000, onChange: this.changeGetMoney }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                src: __webpack_require__(384),
                style: { width: window.winWidth - 49, marginTop: 25 }
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '0k'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '2k'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '4k'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '6k'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '8k'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '1w'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#5b6370", width: 30, textAlign: "center" } },
                  '5w'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: { display: "-webkit-flex", backgroundColor: "#fff", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13, marginTop: 10, paddingTop: 20, paddingBottom: 20 }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: {
                  color: "#5b6270",
                  lineHeight: 1.5,
                  display: "block",
                  fontSize: "13px"
                } },
              '\u6E29\u99A8\u63D0\u793A : \u8BD5\u7B97\u5E74\u5316\u6536\u76CA\u7387\u4EC5\u7528\u4E8E\u667A\u6295\u7EC4\u5408\u65B9\u6848\u6D4B\u7B97\uFF0C\u5E76\u4E0D\u4EE3\u8868\u67D0\u4E2A\u667A\u6295\u7EC4\u5408\u7684\u6536\u76CA\u8868\u73B0\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitJustifyContent: "center", WebkitAlignItems: "center", marginTop: 10, display: "-webkit-flex" } },
            theAge != "" && theAge != null && theAge != undefined && theMoney != "" && theMoney != null && theMoney != undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.goResult, style: { backgroundColor: "#fa063a", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#fff", fontSize: 14 } },
                '\u8BCA\u65AD\u517B\u8001\u6295\u8D44\u72B6\u51B5'
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#afb0b2", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: "#fff", fontSize: 14 } },
                '\u8BCA\u65AD\u517B\u8001\u6295\u8D44\u72B6\u51B5'
              )
            )
          )
        ),
        !this.state.thunkIcon ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', left: 0, bottom: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.7)", WebkitJustifyContent: "center", WebkitAlignItems: "center", top: window.navigator.userAgent.indexOf("amcfmapp") > -1 || window.navigator.userAgent.indexOf("hxcfH5WX") > -1 || window.navigator.userAgent.match(/MicroMessenger/i) == "micromessenger" ? 0 : 44, display: "-webkit-flex", WebkitFlexDirection: "column" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: this.state.loadingIcon,
            style: { width: 250, height: 250, marginTop: -80 }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { marginTop: 25, fontSize: 18, color: "#fff" } },
            '\u8FD0\u7B97\u4E2D...'
          )
        )
      );
    }
  }]);

  return PensionCalculator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    yljycbMoney: state.yljycbMoney,
    yqyljyMoney: state.yqyljyMoney,
    yljyAge: state.yljyAge,
    ylOutAge: state.ylOutAge,
    yqyljySliderVal: state.yqyljySliderVal,
    isLogin: state.isLogin
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(PensionCalculator));

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CalculatorLine_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NullView_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PensionCalculatorPlan = function (_Component) {
  _inherits(PensionCalculatorPlan, _Component);

  function PensionCalculatorPlan() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PensionCalculatorPlan);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PensionCalculatorPlan.__proto__ || Object.getPrototypeOf(PensionCalculatorPlan)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      planType: _this.props.yljyPlan,
      startNum: _this.props.yljyNum,
      nowMoney: _this.props.yljyAllMoney,
      nowYear: 65 - _this.props.location.state.theParams.theAge,
      lineArray: _this.props.yljyLineData,
      addflag: false
    }, _this.getMoney = function (yearGap, N, planType, startNum) {
      var dispatch = _this.props.dispatch;

      _this.setState({
        lineArray: null
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_46" /* yljyLineData */])(null));
      var thisO = _this;
      setTimeout(function () {
        var nowYear = thisO.state.nowYear;

        var r = 0.03;
        var r2 = 1 / (1 + r);
        var totalGap = yearGap * ((1 - Math.pow(r2, N)) / (1 - r2));
        var rate = void 0;
        if (planType == "每月投资方案") {
          if (startNum[0] == "沪深300，年化8%") {
            rate = Math.pow(0.08 + 1, 1 / 12) - 1;
          } else if (startNum[0] == "中债综合财富指数，年化4.2%") {
            rate = Math.pow(0.042 + 1, 1 / 12) - 1;
          } else if (startNum[0] == "标普500，年化7%") {
            rate = Math.pow(0.07 + 1, 1 / 12) - 1;
          }
          thisO.PMT(rate, nowYear * 12, 0, totalGap);
        } else if (planType == "一次投资方案") {
          if (startNum[0] == "沪深300，年化8%") {
            rate = 0.08;
          } else if (startNum[0] == "中债综合财富指数，年化4.2%") {
            rate = 0.042;
          } else if (startNum[0] == "标普500，年化7%") {
            rate = 0.07;
          }
          thisO.PV(rate, nowYear, totalGap);
        }
      });
    }, _this.PMT = function (ir, np, pv, fv) {
      var dispatch = _this.props.dispatch;

      var pmt = ir * (pv * Math.pow(ir + 1, np) + fv) / ((ir + 1) * (Math.pow(ir + 1, np) - 1));
      _this.setState({
        nowMoney: pmt.toFixed(2)
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_47" /* yljyAllMoney */])(pmt.toFixed(2)));
      _this.getProfitCurve4PMT(pmt, np, ir);
    }, _this.PV = function (ir, np, fv) {
      var dispatch = _this.props.dispatch;

      var pv = fv / Math.pow(1 + ir, np);
      _this.setState({
        nowMoney: pv.toFixed(2)
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_47" /* yljyAllMoney */])(pv.toFixed(2)));
      _this.getProfitCurve4PV(pv, np, ir);
    }, _this.getProfitCurve4PV = function (pv, n, r) {
      var dispatch = _this.props.dispatch;

      var c = [];
      for (var i = 0; i <= n; i++) {
        c[i] = (pv * Math.pow(1 + r, i) * 0.0001).toFixed(2);
      }
      _this.setState({
        lineArray: c
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_46" /* yljyLineData */])(c));
    }, _this.getProfitCurve4PMT = function (pmt, n, r) {
      var dispatch = _this.props.dispatch;

      var c = [];
      for (var i = 0; i <= n; i++) {
        if (i === 0) {
          c[i] = (pmt * 0.0001).toFixed(2);
        } else {
          c[i] = (c[i - 1] * (1 + r) + pmt * 0.0001).toFixed(2);
        }
      }
      _this.setState({
        lineArray: c
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_46" /* yljyLineData */])(c));
    }, _this.changeStartNum = function (value) {
      var dispatch = _this.props.dispatch;
      var theParams = _this.props.location.state.theParams;
      var planType = _this.state.planType;

      _this.setState({
        startNum: value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_48" /* yljyNum */])(value));
      if (theParams.gap < 0) {
        _this.getMoney(theParams.yqylj / 2, 25, planType, value);
      } else {
        _this.getMoney(theParams.gap, 25, planType, value);
      }
    }, _this.changePlan = function (value) {
      var dispatch = _this.props.dispatch;
      var theParams = _this.props.location.state.theParams;

      _this.setState({
        planType: value
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_investmentAction_js__["_49" /* yljyPlan */])(value));
      if (theParams.gap < 0) {
        _this.getMoney(theParams.yqylj / 2, 25, value, _this.state.startNum);
      } else {
        _this.getMoney(theParams.gap, 25, value, _this.state.startNum);
      }
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }, _this.goInvestMain = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/nullView"
      });
    }, _this.goDetail = function () {
      var _this$props = _this.props,
          userHasInvested = _this$props.userHasInvested,
          inNeedUpdate = _this$props.inNeedUpdate,
          dispatch = _this$props.dispatch;
      var theParams = _this.props.location.state.theParams;

      var code = void 0;
      if (theParams.theAge <= 37) {
        code = 'SF1008';
      } else if (theParams.theAge >= 38 && theParams.theAge < 47) {
        code = 'SF1007';
      } else if (theParams.theAge >= 48 && theParams.theAge < 65) {
        code = 'SF1006';
      }
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: {
          superFundCode: code
        }
      });
    }, _this.goPayDetail = function (event) {
      event.stopPropagation();
      var dispatch = _this.props.dispatch;

      var route = window.history.length;
      var theParams = _this.props.location.state.theParams;

      var code = void 0,
          name = void 0;
      if (theParams.theAge <= 37) {
        code = 'SF1008';
        name = '80后智领未来';
      } else if (theParams.theAge >= 38 && theParams.theAge < 47) {
        code = 'SF1007';
        name = '70后智赢人生';
      } else if (theParams.theAge >= 48 && theParams.theAge < 65) {
        code = 'SF1006';
        name = '60后智享财富';
      }
      var data = { superFundCode: code };
      var fun = function fun() {
        var params = {
          fundCode: code,
          fundName: name,
          productType: "Z",
          pageText: "申购",
          superTypeValue: "0"
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(route, params, __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["a" /* goLogin */])(fun, window.history.length);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PensionCalculatorPlan, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "投资方案";
      var theParams = this.props.location.state.theParams;
      var planType = this.state.planType;
      var dispatch = this.props.dispatch;

      var code = void 0;
      if (theParams.theAge <= 37) {
        code = 'SF1008';
      } else if (theParams.theAge >= 38 && theParams.theAge < 47) {
        code = 'SF1007';
      } else if (theParams.theAge >= 48 && theParams.theAge < 65) {
        code = 'SF1006';
      }
      var data1 = { superFundCode: code };
      if (theParams.gap < 0) {
        this.getMoney(theParams.yqylj / 2, 25, planType, this.state.startNum);
      } else {
        this.getMoney(theParams.gap, 25, planType, this.state.startNum);
      }
    }
  }, {
    key: 'ok',
    value: function ok() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/paymentSuperFund'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _ref2,
          _ref3;

      var theParams = this.props.location.state.theParams;
      var _state = this.state,
          planType = _state.planType,
          startNum = _state.startNum,
          nowYear = _state.nowYear,
          nowMoney = _state.nowMoney,
          lineArray = _state.lineArray;

      var startNumArray = [{ value: "沪深300，年化8%", label: "沪深300，年化8%" }, { value: "中债综合财富指数，年化4.2%", label: "中债综合财富指数，年化4.2%" }, { value: "标普500，年化7%", label: "标普500，年化7%" }];
      var textList = [];
      var imgIcon = [];
      var textList2 = [];
      if (theParams.theAge <= 37) {
        textList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 15, color: "#ff9536" } },
          '80\u540E\u667A\u9886\u672A\u6765'
        ));
        textList2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 12, color: "#5b6470", marginTop: 8 } },
          '\u6295\u8D44\u672A\u6765 \u8D22\u5BCC\u542F\u822A'
        ));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          style: { width: 121, height: 85 },
          src: __webpack_require__(646)
        }));
      } else if (theParams.theAge >= 38 && theParams.theAge < 47) {
        textList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 15, color: "#ff9536" } },
          '70\u540E\u667A\u8D62\u4EBA\u751F'
        ));
        textList2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 12, color: "#5b6470", marginTop: 8 } },
          '\u5747\u8861\u914D\u7F6E \u7A33\u5065\u5347\u503C'
        ));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          style: { width: 121, height: 85 },
          src: __webpack_require__(677)
        }));
      } else if (theParams.theAge >= 48 && theParams.theAge < 65) {
        textList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 15, color: "#ff9536" } },
          '60\u540E\u667A\u4EAB\u8D22\u5BCC'
        ));
        textList2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 12, color: "#5b6470", marginTop: 8 } },
          '\u8FFD\u6C42\u957F\u671F \u7A33\u5B9A\u6536\u76CA'
        ));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          style: { width: 121, height: 85 },
          src: __webpack_require__(660)
        }));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: {
            backgroundColor: 'rgba(242,245,247,1)',
            display: "-webkit-flex",
            WebkitFlexDirection: "column",
            height: "100%"
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__["a" /* default */], { go: function go() {
            return _this2.ok();
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange', style: { backgroundSize: "cover", width: window.winWidth, height: 44 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: 100 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(21) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center" } },
                '\u6295\u8D44\u65B9\u6848'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { onClick: this.goInvestMain },
                  '\u8DF3\u8FC7'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { overflow: "auto", overflowX: "hidden", WebkitFlex: 1 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  '\u6839\u636E\u60A8\u7684\u60C5\u51B5\uFF0C\u4E3A\u60A8\u63A8\u8350\u4EE5\u4E0B\u4E24\u79CD\u6295\u8D44\u65B9\u6848\uFF0C\u4F9B\u53C2\u8003\u3002'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 10, paddingBottom: 10, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { display: "block", fontSize: "13px", color: "#5b6370", marginTop: 5, lineHeight: 1.5 } },
              '\u6E29\u99A8\u63D0\u793A : \u6295\u8D44\u65B9\u6848\u4E3A\u7ED3\u5408\u5E02\u573A\u4E2D\u4EE3\u8868\u6027\u6307\u6570\u8FC7\u53BB5\u5E74\u4E1A\u7EE9\u8FDB\u884C\u8BA1\u7B97\u7684\uFF0C\u8BD5\u7B97\u7ED3\u679C\u5E76\u4E0D\u4EE3\u8868\u60A8\u5B9E\u9645\u6295\u8D44\u80FD\u591F\u5F97\u5230\u7684\u6536\u76CA\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", height: 45, width: window.winWidth, WebkitFlexDirection: "row", border: "1px solid #ebedf0", backgroundColor: "#fff", marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.changePlan("每月投资方案");
                }, style: planType == "每月投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: planType == "每月投资方案" ? (_ref2 = { color: "#3a3e47" }, _defineProperty(_ref2, 'color', "#5b6370"), _defineProperty(_ref2, 'fontSize', 12), _ref2) : { color: "#5b6370", fontSize: 12 } },
                '\u6BCF\u6708\u6295\u8D44\u65B9\u6848'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this2.changePlan("一次投资方案");
                }, style: planType == "一次投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: planType == "一次投资方案" ? (_ref3 = { color: "#3a3e47" }, _defineProperty(_ref3, 'color', "#5b6370"), _defineProperty(_ref3, 'fontSize', 12), _ref3) : { color: "#5b6370", fontSize: 12 } },
                '\u4E00\u6B21\u6295\u8D44\u65B9\u6848'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: "13px" } },
                  planType == "每月投资方案" ? "每月投入" : "一次性投入"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 20, color: "#ff935f", marginTop: 5 } },
                  nowMoney != null ? __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice(nowMoney, false) : null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#5b6370" } },
                    ' ',
                    nowMoney != null ? "元" : null
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: "13px" } },
                  '\u6301\u7EED\u6295\u8D44'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 20, color: "#3a3e47", marginTop: 5 } },
                  nowYear,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#5b6370" } },
                    ' \u5E74'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: "13px" } },
                  '\u9884\u671F\u53EF\u65B0\u589E\u517B\u8001\u91D1'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 20, color: "#3a3e47", marginTop: 5 } },
                  theParams.gap < 0 ? (theParams.yqylj / 2 / 12).toFixed(2) : __WEBPACK_IMPORTED_MODULE_1__util_js___default.a.parsePrice((theParams.gap / 12).toFixed(2), false),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: "13px", color: "#5b6370" } },
                    ' \u5143\uFF0F\u6708'
                  )
                )
              )
            ),
            lineArray != null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CalculatorLine_js__["a" /* default */], { dataSource: lineArray, planType: planType, nowYear: nowYear }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pickerBox', style: {
                  display: "-webkit-flex",
                  height: 45,
                  borderTop: "1px solid rgb(235, 238, 240)",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  paddingLeft: 13,
                  paddingRight: 5,
                  backgroundColor: "#fff"
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Picker"],
                { value: startNum, title: '\u8BA1\u7B97\u53C2\u8003\u6307\u6570', extra: startNum[0], data: startNumArray, onChange: this.changeStartNum, cols: 1, className: 'forss' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u9009\u62E9\u53C2\u8003\u6307\u6570'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: this.goDetail, style: { display: "-webkit-flex", height: 117, backgroundColor: "#fff", marginTop: 10, paddingTop: 20, paddingBottom: 20, WebkitFlexDirection: "row" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: "60%", paddingLeft: 13 } },
              textList,
              textList2,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.goPayDetail, style: { display: "-webkit-flex", textAlign: "center", height: 25, width: 89, border: "1px solid #ff9536", marginTop: 15, borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 12, color: "#ff9536" } },
                  '\u4E00\u952E\u6295\u8D44'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", width: "40%", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              imgIcon
            )
          )
        )
      );
    }
  }]);

  return PensionCalculatorPlan;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    yljyPlan: state.yljyPlan,
    yljyNum: state.yljyNum,
    yljyAllMoney: state.yljyAllMoney,
    yljyLineData: state.yljyLineData
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(PensionCalculatorPlan));

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NullView_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CalculatorLine_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__guidePage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var PensionCalculatorResult = function (_Component) {
  _inherits(PensionCalculatorResult, _Component);

  function PensionCalculatorResult() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, PensionCalculatorResult);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PensionCalculatorResult.__proto__ || Object.getPrototypeOf(PensionCalculatorResult)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      addflag: false,
      planType: "每月投资方案",
      startNum: "沪深300，年化8%",
      nowMoney: null,
      nowYear: _this.props.location.state ? _this.props.location.state.theParams.theOutAge - _this.props.location.state.theParams.theAge : null,
      lineArray: null,
      resultShow: false,
      modalFlag: false,
      jmContent: "",
      jmTitle: "",
      superFundName: ''
    }, _this.goBack = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "回退"]);
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
    }, _this.goInvestMain = function () {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: "/nullView"
      });
    }, _this.goDetail = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "组合详情"]);
      var _this$props = _this.props,
          userHasInvested = _this$props.userHasInvested,
          inNeedUpdate = _this$props.inNeedUpdate,
          dispatch = _this$props.dispatch;
      var theParams = _this.props.location.state.theParams;

      var code = void 0;
      var _year = new Date().getFullYear();
      if (_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
        code = "SF1019";
      } else if (_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
        code = "SF1020";
      } else if (_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
        code = "SF1021";
      } else if (_year - theParams.theAge >= 1990) {
        code = "SF1013";
      }
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: {
          superFundCode: code
        },
        query: {
          superFundCode: code
        }
      });
    }, _this.goPayDetail = function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event) {
        var flagDigital, _currentUserInfo, isMiniProgram, dispatch, route, theParams, code, name, _year, data, fun;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "一键投资"]);
                event.stopPropagation();
                _context.next = 4;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('loginState');

              case 4:
                flagDigital = _context.sent;
                _context.next = 7;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('currentUserInfo');

              case 7:
                _currentUserInfo = _context.sent;
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["i" /* onMiniProgramDialog */])(flagDigital != '0' && !_currentUserInfo.isRealName ? __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].OpenAccount : __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt('return');

              case 11:
                dispatch = _this.props.dispatch;
                route = window.history.length;
                theParams = _this.props.location.state.theParams;
                code = void 0, name = void 0;
                _year = new Date().getFullYear();

                if (_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
                  code = "SF1019";
                  name = "60后智享财富组合";
                } else if (_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
                  code = "SF1020";
                  name = "70后智赢人生组合";
                } else if (_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
                  code = "SF1021";
                  name = "80后智领未来组合";
                } else if (_year - theParams.theAge >= 1990) {
                  code = "SF1013";
                  name = "90后智享自由组合";
                }
                data = { superFundCode: code };

                fun = function fun() {
                  var params = {
                    fundCode: code,
                    fundName: name,
                    productType: "Z",
                    pageText: "申购",
                    superTypeValue: "0"
                  };
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["j" /* getPayAll */])(route, params, __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["a" /* goLogin */])(fun, window.history.length);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.getMoney = function (yearGap, N, planType, startNum) {
      _this.setState({
        lineArray: null
      });
      var thisO = _this;
      setTimeout(function () {
        var nowYear = thisO.state.nowYear;

        var r = 0.03;
        var r2 = 1 / (1 + r);
        var totalGap = yearGap * ((1 - Math.pow(r2, N)) / (1 - r2));
        var rate = void 0;
        if (planType == "每月投资方案") {
          if (startNum == "沪深300，年化8%") {
            rate = Math.pow(0.08 + 1, 1 / 12) - 1;
          } else if (startNum == "中债综合财富指数，年化4.2%") {
            rate = Math.pow(0.042 + 1, 1 / 12) - 1;
          } else if (startNum == "标普500，年化7%") {
            rate = Math.pow(0.07 + 1, 1 / 12) - 1;
          }
          thisO.PMT(rate, nowYear * 12, 0, totalGap);
        } else if (planType == "一次投资方案") {
          if (startNum == "沪深300，年化8%") {
            rate = 0.08;
          } else if (startNum == "中债综合财富指数，年化4.2%") {
            rate = 0.042;
          } else if (startNum == "标普500，年化7%") {
            rate = 0.07;
          }
          thisO.PV(rate, nowYear, totalGap);
        }
      });
    }, _this.PMT = function (ir, np, pv, fv) {
      var pmt = ir * (pv * Math.pow(ir + 1, np) + fv) / ((ir + 1) * (Math.pow(ir + 1, np) - 1));
      _this.setState({
        nowMoney: pmt.toFixed(2)
      });
      _this.getProfitCurve4PMT(pmt, np, ir);
    }, _this.PV = function (ir, np, fv) {
      var pv = fv / Math.pow(1 + ir, np);
      _this.setState({
        nowMoney: pv.toFixed(2)
      });
      _this.getProfitCurve4PV(pv, np, ir);
    }, _this.getProfitCurve4PV = function (pv, n, r) {
      var c = [];
      for (var i = 0; i <= n; i++) {
        c[i] = (pv * Math.pow(1 + r, i) * 0.0001).toFixed(2);
      }
      _this.setState({
        lineArray: c
      });
    }, _this.getProfitCurve4PMT = function (pmt, n, r) {
      var c = [];
      for (var i = 0; i <= n; i++) {
        if (i === 0) {
          c[i] = (pmt * 0.0001).toFixed(2);
        } else {
          c[i] = (c[i - 1] * (1 + r) + pmt * 0.0001).toFixed(2);
        }
      }
      _this.setState({
        lineArray: c
      });
    }, _this.changeStartNum = function (value) {
      var theParams = _this.props.location.state.theParams;
      var planType = _this.state.planType;

      _this.setState({
        startNum: value[0]
      });
      if (theParams.gap < 0) {
        _this.getMoney(theParams.yqylj / 2, 25, planType, value);
      } else {
        _this.getMoney(theParams.gap, 25, planType, value);
      }
    }, _this.changePlan = function (value) {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "选择方案"]);
      var theParams = _this.props.location.state.theParams;

      _this.setState({
        planType: value
      });
      if (theParams.gap < 0) {
        _this.getMoney(theParams.yqylj / 2, 25, value, _this.state.startNum);
      } else {
        _this.getMoney(theParams.gap, 25, value, _this.state.startNum);
      }
    }, _this.closeModal = function () {
      _this.setState({
        modalFlag: false
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", _this.touchMove, false);
    }, _this.showModal = function (value) {
      var theParams = _this.props.location.state.theParams;

      if (value == "0") {
        _this.setState({
          modalFlag: true,
          jmTitle: "查理解密",
          jmContent: "可支取的养老金是根据您当前实际的养老储备金和年龄，计算出当您达到" + theParams.theOutAge + "岁退休年龄时，每月可支取的养老金。"
        });
      } else if (value == "1") {
        _this.setState({
          modalFlag: true,
          jmTitle: "查理解密",
          jmContent: "查理智投暂时还不支持组合定投业务，您需要通过每月主动投资来完成该投资方案。"
        });
      } else if (value == "2") {
        _this.setState({
          modalFlag: true,
          jmTitle: "查理解密",
          jmContent: "参考指数的年化收益是根据2002年至2017年期间的指数表现，取5年滚动收益序列求平均值，然后进行年化处理所得。"
        });
      }
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
    }, _this.touchMove = function (event) {
      event.preventDefault();
    }, _this.goDT = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event) {
        var flagDigital, _currentUserInfo, isMiniProgram, theParams, code, name, _year, params;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.stopPropagation();
                _context2.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('loginState');

              case 3:
                flagDigital = _context2.sent;
                _context2.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["d" /* getStorage */])('currentUserInfo');

              case 6:
                _currentUserInfo = _context2.sent;
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common__["i" /* onMiniProgramDialog */])(flagDigital != '0' && !_currentUserInfo.isRealName ? __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].OpenAccount : __WEBPACK_IMPORTED_MODULE_13__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                theParams = _this.props.location.state.theParams;
                code = void 0, name = void 0;
                _year = new Date().getFullYear();

                if (_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
                  code = "SF1019";
                  name = "60后智享财富组合";
                } else if (_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
                  code = "SF1020";
                  name = "70后智赢人生组合";
                } else if (_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
                  code = "SF1021";
                  name = "80后智领未来组合";
                } else if (_year - theParams.theAge >= 1990) {
                  code = "SF1013";
                  name = "90后智享自由组合";
                }
                params = {
                  fundCode: code,
                  fundName: name,
                  productType: "Z",
                  pageText: "新建定投计划",
                  superTypeValue: "0",
                  text: _this.state.nowMoney != null ? _this.state.nowMoney : ''
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PensionCalculatorResult, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "进入"]);
      document.getElementsByTagName('title')[0].innerHTML = "养老测算结果";
      var theParams = this.props.location.state.theParams;
      var planType = this.state.planType;

      var code = void 0;
      var _year = new Date().getFullYear();
      if (_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
        code = "SF1019";
      } else if (_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
        code = "SF1020";
      } else if (_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
        code = "SF1021";
      } else if (_year - theParams.theAge >= 1990) {
        code = "SF1013";
      }
      if (theParams.gap < 0) {
        this.getMoney(theParams.yqylj / 2, 25, planType, this.state.startNum);
      } else {
        this.getMoney(theParams.gap, 25, planType, this.state.startNum);
      }
    }
  }, {
    key: 'ok',
    value: function ok() {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: '/paymentSuperFund'
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "退出"]);
      __WEBPACK_IMPORTED_MODULE_14__guidePage__["b" /* default */].leave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var theParams = this.props.location.state.theParams;
      var _state = this.state,
          planType = _state.planType,
          startNum = _state.startNum,
          nowYear = _state.nowYear,
          nowMoney = _state.nowMoney,
          lineArray = _state.lineArray,
          jmContent = _state.jmContent,
          jmTitle = _state.jmTitle;

      var startNumArray = [{ value: "沪深300，年化8%", label: "沪深300，年化8%" }, { value: "中债综合财富指数，年化4.2%", label: "中债综合财富指数，年化4.2%" }, { value: "标普500，年化7%", label: "标普500，年化7%" }];
      var textList = [];
      var _year = new Date().getFullYear();
      if (_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
        textList.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 18, color: "#fa063a" } },
          "60后智享财富组合"
        ));
      } else if (_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
        textList.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 18, color: "#fa063a" } },
          "70后智赢人生组合"
        ));
      } else if (_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
        textList.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 18, color: "#fa063a" } },
          "80后智领未来组合"
        ));
      } else if (_year - theParams.theAge >= 1990) {
        textList.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: 0, style: { fontSize: 18, color: "#fa063a" } },
          "90后智享自由组合"
        ));
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modal_ModalSelect__["a" /* default */], { go: function go() {
            return _this3.ok();
          } }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'boxHeader bgChange' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u517B\u8001\u6D4B\u7B97\u7ED3\u679C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { onClick: this.goInvestMain },
                '\u8DF3\u8FC7'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'boxContent', id: 'PensionCalculatorResultIndex', style: { paddingBottom: 74, display: 'flex', flex: 1, overflowY: 'scroll', flexDirection: 'column' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'bgChange2', style: { backgroundSize: "cover", width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
                style: { width: 63, height: 63 },
                src: __webpack_require__(83)
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  theParams.gap <= 0 ? "根据测算，您目前的养老储蓄已可以满足您的需求。为了给您将来的生活提供更好的保障，为您专属定制了养老智投组合投资方案：" : "根据测算，您目前的养老储蓄和您期望的美好生活还存在较大差距，建议您提早投资，增加养老金储备。为您专属定制了养老智投组合投资方案："
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, position: "relative" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { color: "#5b6370", fontSize: 13 } },
                    '\u53EF\u652F\u53D6\u7684\u517B\u8001\u91D1'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        _this3.showModal("0");
                      }, style: { position: "absolute", width: 35, height: 35, right: -40, top: -10, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(126), style: { width: 15, height: 15 } })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#3a3e47", marginTop: 5 } },
                  __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(theParams.actual / 12, false),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5143\uFF0F\u6708'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "column" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: "#5b6370", fontSize: 13 } },
                    '\u517B\u8001\u91D1\u7F3A\u53E3'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#fa063a", marginTop: 5 } },
                  theParams.gap < 0 ? 0 : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(theParams.gap / 12, false),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5143\uFF0F\u6708'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  height: 45,
                  backgroundColor: "#fff",
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  borderBottom: "1px solid rgb(255, 238, 240)"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: {
                    color: "#5b6370",
                    fontSize: "13px",
                    width: "50%"
                  } },
                '\u671F\u671B\u83B7\u5F97\u7684\u517B\u8001\u91D1'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: {
                    color: "#5b6370",
                    fontSize: "13px",
                    width: "50%",
                    textAlign: "right"
                  } },
                theParams.theMoney,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { fontSize: "13px", color: "#5b6370" } },
                  '\u5143\uFF0F\u6708'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", height: 45, width: window.winWidth, WebkitFlexDirection: "row", border: "1px solid #ebedf0", backgroundColor: "#fff", marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this3.changePlan("每月投资方案");
                }, style: planType == "每月投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: planType == "每月投资方案" ? { color: "#3a3e47", fontSize: 13 } : { color: "#5b6370", fontSize: 13 } },
                '\u6BCF\u6708\u6295\u8D44\u65B9\u6848'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this3.changePlan("一次投资方案");
                }, style: planType == "一次投资方案" ? { borderBottom: "1px solid #ff9a96", width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } : { width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: planType == "一次投资方案" ? { color: "#3a3e47", fontSize: 13 } : { color: "#5b6370", fontSize: 13 } },
                '\u4E00\u6B21\u6295\u8D44\u65B9\u6848'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: 13, position: "relative" } },
                  planType == "每月投资方案" ? "每月投入" : "一次性投入",
                  planType == "每月投资方案" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        _this3.showModal("1");
                      }, style: { position: "absolute", width: 35, height: 35, right: -30, top: -10, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(126), style: { width: 15, height: 15 } })
                  ) : null
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#3a3e47", marginTop: 5 } },
                  nowMoney != null ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(nowMoney, false) : null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' ',
                    nowMoney != null ? "元" : null
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { divAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: 13 } },
                  '\u6301\u7EED\u6295\u8D44'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#3a3e47", marginTop: 5 } },
                  nowYear,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5E74'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5, color: "#5b6370", fontSize: 13 } },
                  '\u53EF\u65B0\u589E\u517B\u8001\u91D1'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 22, color: "#fa063a", marginTop: 5 } },
                  theParams.gap < 0 ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(Math.round(Number(theParams.yqylj / 2 / 12)) * 10000, false) : lineArray != null ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.parsePrice(Math.round(Number(lineArray[lineArray.length - 1])) * 10000, false) : null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    ' \u5143'
                  )
                )
              )
            ),
            lineArray != null ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CalculatorLine_js__["a" /* default */], { dataSource: lineArray, planType: planType, nowYear: nowYear }) : null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'pickerBox', style: {
                  display: "-webkit-flex",
                  height: 45,
                  borderTop: "1px solid rgb(235, 238, 240)",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  WebkitFlexDirection: "row",
                  paddingLeft: 13,
                  paddingRight: 5,
                  backgroundColor: "#fff",
                  position: 'relative'
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Picker"],
                { value: [startNum], title: '\u8BA1\u7B97\u53C2\u8003\u6307\u6570', extra: startNum, data: startNumArray, onChange: this.changeStartNum, cols: 1, className: 'forss' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u9009\u62E9\u53C2\u8003\u6307\u6570'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this3.showModal("2");
                  }, style: { position: "absolute", width: 35, height: 35, left: 90, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(126), style: { width: 15, height: 15 } })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 10, paddingBottom: 10, backgroundColor: "#fff", marginTop: 10, marginBottom: 10 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { fontSize: 13, color: "#5b6370", marginTop: 5, lineHeight: "20px", fontWeight: "bold" } },
              '\u6E29\u99A8\u63D0\u793A : ',
              '\u4E0A\u8FF0\u6A21\u62DF\u4F7F\u7528\u5E02\u573A\u4E2D\u4EE3\u8868\u6027\u6307\u6570\u8FC7\u53BB5\u5E74\u7684\u5E74\u5316\u5E73\u5747\u6536\u76CA\u7387\u8BA1\u7B97\uFF0C\u672A\u6765\u7531\u4E8E\u5E02\u573A\u73AF\u5883\u4E0D\u540C\u3001\u5B9E\u9645\u6295\u8D44\u8FD0\u4F5C\u7B49\u4E0D\u53EF\u80FD\u5B8C\u5168\u590D\u5236\u8BE5\u6A21\u62DF\u7ED3\u679C\u3002\u8BE5\u6A21\u62DF\u4E0D\u80FD\u4F5C\u4E3A\u6295\u8D44\u9884\u6D4B\uFF0C\u4E5F\u4E0D\u4EE3\u8868\u60A8\u5B9E\u9645\u6295\u8D44\u6240\u5F97\u6536\u76CA\uFF0C\u6295\u8D44\u4E5F\u53EF\u80FD\u906D\u9047\u4E8F\u635F\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { onClick: this.goDetail, style: { position: "fixed", bottom: 0, width: "100%", zIndex: 99999990, height: 74, backgroundColor: "#fff", paddingTop: 10, paddingBottom: 10, WebkitFlexDirection: "row", borderTop: "1px solid #e1e3e6", display: "-webkit-flex", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 0.6, paddingLeft: 13, WebkitJustifyContent: "flex-start", display: "-webkit-flex", WebkitFlexDirection: "column" } },
            textList,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, color: "#000", marginTop: 5 } },
              '\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 0.4, WebkitJustifyContent: "flex-end", WebkitAlignItems: "flex-end", paddingRight: 13, display: "-webkit-flex" } },
            planType == "每月投资方案" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: this.goDT, style: { backgroundColor: "#fa063a", height: 35, width: 130, border: "1px solid #fa063a", borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 18, color: "#fff" } },
                '\u4E00\u952E\u5B9A\u6295'
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: this.goPayDetail, style: { backgroundColor: "#fa063a", height: 35, width: 130, border: "1px solid #fa063a", borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 18, color: "#fff" } },
                '\u4E00\u952E\u6295\u8D44'
              )
            )
          )
        ),
        this.state.modalFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#333333", fontWeight: "500", paddingLeft: 20, paddingRight: 20 } },
                jmContent
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.closeModal, style: { width: "100%", height: "40px", textAlign: "center", lineHeight: "40px", borderTopColor: "#ebeef0", borderTopWidth: "1px", borderTopStyle: "solid", marginTop: "15px" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 17, color: '#666666' } },
                    '\u77E5\u9053\u4E86'
                  )
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return PensionCalculatorResult;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__HOC_StateCache_js__["a" /* default */])(PensionCalculatorResult, 'PensionCalculatorResultIndex')));

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RiskEvaluationPie_js__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NullView_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var RecoQuestionDoing = function (_Component) {
  _inherits(RecoQuestionDoing, _Component);

  function RecoQuestionDoing() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RecoQuestionDoing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecoQuestionDoing.__proto__ || Object.getPrototypeOf(RecoQuestionDoing)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      count: 1,
      fadeAnim2: window.winWidth,
      fadeAnim3: window.winWidth,
      fadeAnim4: window.winWidth,
      fadeAnim5: window.winWidth,
      fadeAnim6: window.winWidth,
      multieArray: [],
      answers: []
    }, _this.loseLocation = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题页跳过"]);
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].replace({
        pathname: "/"
      });
    }, _this.goBack = function () {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题页回退"]);
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }, _this.passThis = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: "/nullView"
      });
    }, _this.answerFun = function (question, answer, count) {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题"]);
      var interVal = void 0;
      var dispatch = _this.props.dispatch;

      _this.setState({
        count: count
      });
      var answersArr = [].concat(_this.state.answers);
      answersArr.push({
        answerNo: question,
        optionNo: answer
      });
      var thisO = _this;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_58" /* riskEvaluationPieData */])(null));
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading("正在加载");
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_59" /* getRiskEvaluationPieData */])({ answers: JSON.stringify(answersArr) }, function () {
        _this.setState({
          answers: answersArr
        });
        if (count == 7) {
          window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "答题结束"]);
          __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
            pathname: "/recoQuestionFinish",
            state: {
              riskEvaluationPieData: _this.props.riskEvaluationPieData
            }
          });
        }
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
      }));
      if (count != 7) {
        if (count == 2) {
          interVal = setInterval(function () {
            if (_this.state.fadeAnim2 - 30 <= 0) {
              clearInterval(interVal);
              thisO.setState({
                fadeAnim2: 0
              });
            } else {
              thisO.setState({
                fadeAnim2: _this.state.fadeAnim2 - 30
              });
            }
          }, 1);
        } else if (count == 3) {
          interVal = setInterval(function () {
            if (_this.state.fadeAnim3 - 30 <= 0) {
              clearInterval(interVal);
              thisO.setState({
                fadeAnim3: 0
              });
            } else {
              thisO.setState({
                fadeAnim3: _this.state.fadeAnim3 - 30
              });
            }
          }, 1);
        } else if (count == 4) {
          interVal = setInterval(function () {
            if (_this.state.fadeAnim4 - 30 <= 0) {
              clearInterval(interVal);
              thisO.setState({
                fadeAnim4: 0
              });
            } else {
              thisO.setState({
                fadeAnim4: _this.state.fadeAnim4 - 30
              });
            }
          }, 1);
        } else if (count == 5) {
          interVal = setInterval(function () {
            if (_this.state.fadeAnim5 - 30 <= 0) {
              clearInterval(interVal);
              thisO.setState({
                fadeAnim5: 0
              });
            } else {
              thisO.setState({
                fadeAnim5: _this.state.fadeAnim5 - 30
              });
            }
          }, 1);
        } else if (count == 6) {
          interVal = setInterval(function () {
            if (_this.state.fadeAnim6 - 30 <= 0) {
              clearInterval(interVal);
              thisO.setState({
                fadeAnim6: 0
              });
            } else {
              thisO.setState({
                fadeAnim6: _this.state.fadeAnim6 - 30
              });
            }
          }, 1);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RecoQuestionDoing, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "进入"]);
      document.getElementsByTagName('title')[0].innerHTML = "风险偏好测评";
      var dispatch = this.props.dispatch;

      var array = [{
        answerNo: "9001",
        optionNo: "90005"
      }, {
        answerNo: "9002",
        optionNo: "90013"
      }, {
        answerNo: "9003",
        optionNo: "90023"
      }, {
        answerNo: "9004",
        optionNo: "90041"
      }, {
        answerNo: "9005",
        optionNo: "90055"
      }, {
        answerNo: "9006",
        optionNo: "90065"
      }];
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading("正在加载");
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_59" /* getRiskEvaluationPieData */])({ answers: JSON.stringify(array) }, function () {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.scrollTo(0, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评", "退出"]);
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_58" /* riskEvaluationPieData */])(null));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          count = _state.count,
          fadeAnim2 = _state.fadeAnim2,
          fadeAnim3 = _state.fadeAnim3,
          fadeAnim4 = _state.fadeAnim4,
          fadeAnim5 = _state.fadeAnim5,
          fadeAnim6 = _state.fadeAnim6;
      var riskEvaluationPieData = this.props.riskEvaluationPieData;

      var roundView = [];
      for (var i = 1; i <= 6; i++) {
        if (count == 7) {
          if (i == 6) {
            roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: i, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#ff9536" } })
            ));
          } else {
            roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: i, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#ff9536" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { backgroundColor: "#ff9536", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9 } })
            ));
          }
        } else {
          if (i == 6) {
            if (i == count) {
              roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 6, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", border: "1px solid #ff9536", width: window.winWidth == 320 ? 10 : 15, height: window.winWidth == 320 ? 10 : 15, borderRadius: 15, backgroundColor: "transparent", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 4 : 7, height: window.winWidth == 320 ? 4 : 7, backgroundColor: "#ff9536", borderRadius: 7 } })
                )
              ));
            } else if (i > count) {
              roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 6, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#eef2f8" } })
              ));
            }
          } else {
            if (i == count) {
              roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: i, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", border: "1px solid #ff9536", width: window.winWidth == 320 ? 10 : 15, height: window.winWidth == 320 ? 10 : 15, borderRadius: 15, backgroundColor: "transparent", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 4 : 7, height: window.winWidth == 320 ? 4 : 7, backgroundColor: "#ff9536", borderRadius: 7 } })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { backgroundColor: "#eef2f8", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9 } })
              ));
            } else if (i > count) {
              roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: i, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#eef2f8" } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { backgroundColor: "#eef2f8", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9 } })
              ));
            } else if (i < count) {
              roundView.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: i, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.winWidth == 320 ? 6 : 11, height: window.winWidth == 320 ? 6 : 11, borderRadius: 11, backgroundColor: "#ff9536" } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { backgroundColor: "#ff9536", height: 1, width: window.winWidth == 320 ? 30 : 38, marginLeft: 9, marginRight: 9 } })
              ));
            }
          }
        }
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u98CE\u9669\u504F\u597D\u6D4B\u8BC4'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { onClick: this.passThis },
                '\u8DF3\u8FC7'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: 320 } },
            riskEvaluationPieData != null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RiskEvaluationPie_js__["a" /* default */], { dataSource: riskEvaluationPieData }) : null
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { backgroundColor: "#fff", height: 305 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", height: 55, WebkitFlexDirection: "row", paddingLeft: 13, paddingRight: 13, border: "1px solid rgba(242,245,247,1)", WebkitAlignItems: "center", WebkitJustifyContent: "center", WebkitFlex: 1 } },
              roundView
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, position: "relative", height: 250 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { backgroundColor: "#fff", position: "absolute", width: window.winWidth, height: 250, left: 0, top: 0, paddingTop: 20 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: "#fa063a" } },
                    '\u6211\u4ECA\u5E74'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9001", "90001", 2);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(253, 242, 231)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#fea662" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u4E0D\u523025\u5C81'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9001", "90002", 2);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(254, 224, 224)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#ff6562" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '26-45\u5C81'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9001", "90003", 2);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(228, 239, 253)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#6b9ef4" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '46-64\u5C81'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9001", "90004", 2);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(220, 245, 252)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#4ac9f5" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '65\u5C81\u4EE5\u4E0A'
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  style: { backgroundColor: "#fff", position: "absolute", width: window.winWidth, height: 250, left: this.state.fadeAnim2, top: 0, paddingTop: 20 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: "#fa063a" } },
                    '\u6211\u73B0\u5728'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9002", "90011", 3);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(692),
                        style: { width: 93, height: 93 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '\u8F9B\u52E4\u5DE5\u4F5C'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9002", "90012", 3);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(690),
                        style: { width: 93, height: 93 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '\u95F2\u8D4B\u5728\u5BB6'
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  style: { backgroundColor: "#fff", position: "absolute", width: window.winWidth, height: 250, left: this.state.fadeAnim3, top: 0, paddingTop: 20 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: "#fa063a" } },
                    '\u6211\u7684\u8D22\u52A1\u72B6\u51B5'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9003", "90021", 4);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(679),
                        style: { width: 93, height: 93 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '\u5DE5\u8D44\u8DB3\u4EE5\u652F\u4ED8\u65E5\u5E38\u82B1\u9500'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9003", "90022", 4);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(686),
                        style: { width: 93, height: 93 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '\u6709\u65F6\u9700\u8981\u4F7F\u7528\u6295\u8D44\u8D44\u91D1'
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  style: { backgroundColor: "#fff", position: "absolute", width: window.winWidth, height: 250, left: this.state.fadeAnim4, top: 0, paddingTop: 20 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: "#fa063a" } },
                    '\u6211\u6295\u8D44\u662F\u4E3A\u4E86'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 20, WebkitFlexWrap: "wrap" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90031", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(254, 242, 231)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("资本保值") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#fea662" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u8D44\u672C\u4FDD\u503C'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#fea662" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u8D44\u672C\u4FDD\u503C'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90032", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(254, 222, 219)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("累积财富") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#ff6562" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u7D2F\u79EF\u8D22\u5BCC'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#ff6562" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u7D2F\u79EF\u8D22\u5BCC'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90033", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(227, 236, 250)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("日常收入") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#6b9ef4" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u65E5\u5E38\u6536\u5165'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#6b9ef4" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u65E5\u5E38\u6536\u5165'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90034", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(220, 245, 252)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("投机") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#4ac9f5" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u6295\u673A'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#4ac9f5" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u6295\u673A'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90035", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(253, 242, 231)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("战胜通胀") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#fea662" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u6218\u80DC\u901A\u80C0'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#fea662" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u6218\u80DC\u901A\u80C0'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90036", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(225, 248, 227)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("对冲") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#68dd6e" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u5BF9\u51B2'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#68dd6e" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u5BF9\u51B2'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90037", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(219, 248, 251)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("主营业务") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#4ed7f0" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u4E3B\u8425\u4E1A\u52A1'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#4ed7f0" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u4E3B\u8425\u4E1A\u52A1'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90038", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(235, 235, 250)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("继承遗产") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#9f95e6" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u7EE7\u627F\u9057\u4EA7'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#9f95e6" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u7EE7\u627F\u9057\u4EA7'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90039", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(253, 222, 220)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("退休养老") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#ff5c50" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u9000\u4F11\u517B\u8001'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#ff5c50" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u9000\u4F11\u517B\u8001'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9004", "90040", 5);
                      },
                      style: { display: "-webkit-flex", marginBottom: 10, WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 58 : 72, height: window.winWidth == 320 ? 58 : 72, borderRadius: 72, backgroundColor: "rgb(248, 230, 245)" } },
                    this.state.multieArray && this.state.multieArray.indexOf("子女教育") != -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'img',
                      {
                        alt: '',
                        style: { display: "-webkit-flex", width: 72, height: 72, WebkitJustifyContent: "center", WebkitAlignItems: "center" },
                        src: __webpack_require__(76)
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#f580a0" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#fff", fontSize: 12 } },
                          '\u5B50\u5973\u6559\u80B2'
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: window.winWidth == 320 ? 52 : 62, height: window.winWidth == 320 ? 52 : 62, borderRadius: 62, backgroundColor: "#f580a0" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '\u5B50\u5973\u6559\u80B2'
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  style: { backgroundColor: "#fff", position: "absolute", width: window.winWidth, height: 250, left: this.state.fadeAnim5, top: 0, paddingTop: 20 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: "#fa063a" } },
                    '\u6211\u53EF\u4EE5\u627F\u53D7\u7684\u635F\u5931'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9005", "90051", 6);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(663),
                        style: { width: 70, height: 70 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      "<15%"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '(\u7CBE\u6253\u7EC6\u7B97)'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9005", "90052", 6);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(664),
                        style: { width: 70, height: 70 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      "15-25%"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '(\u8FFD\u6C42\u7A33\u5065)'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9005", "90053", 6);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(665),
                        style: { width: 70, height: 70 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      "25-50%"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '(\u8D22\u5927\u6C14\u7C97)'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this2.answerFun("9005", "90054", 6);
                      }, style: { display: "-webkit-flex", WebkitAlignItems: "center", width: 130, WebkitFlexDirection: "column", height: 150 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
                        alt: '',
                        src: __webpack_require__(666),
                        style: { width: 70, height: 70 }
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      ">50%"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: "#5b6370", fontSize: 12, marginTop: 10 } },
                      '(\u6709\u94B1\u4EFB\u6027)'
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  style: { backgroundColor: "#fff", position: "absolute", width: window.winWidth, height: 250, left: this.state.fadeAnim6, top: 0, paddingTop: 20 }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13, WebkitJustifyContent: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: "#fa063a" } },
                    '\u5982\u679C\u4EE550%\u6536\u76CA\u4E3A\u6295\u8D44\u76EE\u6807\uFF0C\u60A8\u8BA4\u4E3A\u591A\u4E45\u80FD\u5B9E\u73B0\u76EE\u6807\uFF1F'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitJustifyContent: "space-around", marginTop: 40 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9006", "90061", 7);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(253, 242, 231)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#fea662" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '10\u5E74\u4EE5\u4E0A'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9006", "90062", 7);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(254, 224, 224)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#ff6562" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '6-10\u5E74'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9006", "90063", 7);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(228, 239, 253)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#6b9ef4" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '1-5\u5E74'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.answerFun("9006", "90064", 7);
                      },
                      style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 72, height: 72, borderRadius: 72, backgroundColor: "rgb(220, 245, 252)" } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: 62, height: 62, borderRadius: 62, backgroundColor: "#4ac9f5" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#fff", fontSize: 12 } },
                        '1\u5E74\u4EE5\u5185'
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RecoQuestionDoing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    riskEvaluationPieData: state.riskEvaluationPieData
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(RecoQuestionDoing));

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__guidePage__ = __webpack_require__(59);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var RceoQuestionFinish = function (_Component) {
  _inherits(RceoQuestionFinish, _Component);

  function RceoQuestionFinish() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RceoQuestionFinish);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RceoQuestionFinish.__proto__ || Object.getPrototypeOf(RceoQuestionFinish)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      flag: false
    }, _this.goDetail = function (result) {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评结果页", "组合详情"]);
      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_6__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          isLogin = _this$props.isLogin;

      var superFundCode = result.superFundCode;

      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: {
          superFundCode: superFundCode,
          isTop: true
        },
        query: {
          superFundCode: superFundCode,
          isTop: true
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RceoQuestionFinish, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评结果页", "进入"]);
      document.getElementsByTagName('title')[0].innerHTML = "风险偏好测评";
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "风险偏好测评结果页", "退出"]);
      __WEBPACK_IMPORTED_MODULE_8__guidePage__["b" /* default */].leave();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var riskEvaluationPieData = this.props.location.state.riskEvaluationPieData;

      var imgIcon = [];
      var imgIcon2 = [];
      if (riskEvaluationPieData.content.superFundCode == "SF1012") {
        imgIcon2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(190),
          style: { width: 25, height: 25, marginTop: 40 }
        }));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(191),
          style: { width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(-120deg)" }
        }));
      } else if (riskEvaluationPieData.content.superFundCode == "SF1015") {
        imgIcon2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(190),
          style: { width: 25, height: 25, marginTop: 40 }
        }));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(191),
          style: { width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(0deg)" }
        }));
      } else if (riskEvaluationPieData.content.superFundCode == "SF1016") {
        imgIcon2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(190),
          style: { width: 25, height: 25, marginTop: 40 }
        }));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(191),
          style: { width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(60deg)" }
        }));
      } else if (riskEvaluationPieData.content.superFundCode == "SF1014") {
        imgIcon2.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(190),
          style: { width: 25, height: 25, marginTop: 40 }
        }));
        imgIcon.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          key: 0,
          src: __webpack_require__(191),
          style: { width: window.winWidth === 320 ? 140 : 169, height: window.winWidth === 320 ? 140 : 169, position: "absolute", left: 0, top: 0, WebkitTransform: "rotate(120deg)" }
        }));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { position: "relative", width: window.winWidth, backgroundSize: "cover", backgroundImage: 'url(' + __webpack_require__(381) + ')', display: "-webkit-flex", WebkitFlexDirection: "column", minHeight: window.winHeight }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'boxHeader', style: { backgroundColor: "transparent" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  '\u98CE\u9669\u504F\u597D\u6D4B\u8BC4'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxContent' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: {
                  width: window.winWidth,
                  paddingLeft: 13,
                  paddingRight: 13,
                  WebkitFlexDirection: "row",
                  WebkitJustifyContent: "space-between",
                  WebkitAlignItems: "center",
                  display: "-webkit-flex",
                  paddingTop: 20
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { width: 63, height: 63 }, src: __webpack_require__(83) }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: {
                      color: "#fff",
                      lineHeight: "16px",
                      fontSize: 13
                    } },
                  '\u7ECF\u6D4B\u8BC4\uFF0C\u60A8\u7684\u98CE\u9669\u504F\u597D\u4E3A',
                  riskEvaluationPieData.content.superFundCode == "SF1012" ? "低" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "中" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "中高" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "高" : "",
                  '\u98CE\u9669\u504F\u597D\uFF0C\u4E3A\u60A8\u63A8\u8350\u201C',
                  riskEvaluationPieData.content.superFundCode == "SF1012" ? "货币优享组合" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "固收增强组合" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "权益优选组合" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "指数轮动组合" : "",
                  '\u201D'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: "relative", height: 200, width: window.winWidth, paddingLeft: 13, paddingRight: 13, marginTop: 25 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { backgroundColor: "rgba(0, 0, 0, 0.2)", borderRadius: 10, paddingLeft: 13, paddingRight: 13, WebkitJustifyContent: "center", WebkitFlexDirection: "row", display: "-webkit-flex", height: 200 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { position: "relative", WebkitAlignItems: "flex-start", display: "-webkit-flex", WebkitFlexDirection: "column", WebkitFlex: 0.4 } },
                  imgIcon2,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: 9, fontSize: 15, color: "#fff" } },
                    riskEvaluationPieData.content.superFundCode == "SF1012" ? "货币优享组合" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "固收增强组合" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "权益优选组合" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "指数轮动组合" : ""
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: 10, fontSize: "13px", color: "#fff" } },
                    riskEvaluationPieData.content.superFundCode == "SF1012" ? "流动性强" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "稳健理财" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "灵活配置" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "紧跟市场" : ""
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: 5, fontSize: "13px", color: "#fff" } },
                    riskEvaluationPieData.content.superFundCode == "SF1012" ? "国民理财升级" : riskEvaluationPieData.content.superFundCode == "SF1015" ? "追求资产增值" : riskEvaluationPieData.content.superFundCode == "SF1016" ? "掘金超额收益" : riskEvaluationPieData.content.superFundCode == "SF1014" ? "做聪明投资者" : ""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", position: "relative", WebkitFlex: 0.6, WebkitJustifyContent: "flex-end" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      style: { position: "relative", backgroundImage: 'url(' + __webpack_require__(695) + ')', backgroundSize: "cover", width: window.winWidth == 320 ? 140 : 169, height: window.winWidth == 320 ? 140 : 169, marginTop: 30 }
                    },
                    imgIcon
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: "absolute", bottom: 60, width: "100%" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { margin: "0 auto", display: "-webkit-flex", width: 209, height: 40, backgroundColor: "transparent", border: "1px solid #fff", borderRadius: 25, WebkitJustifyContent: "center", WebkitAlignItems: "center" }, onClick: function onClick() {
                    return _this2.goDetail(riskEvaluationPieData.content);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 15, color: "#fff" } },
                  '\u67E5\u770B\u8BE6\u60C5'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RceoQuestionFinish;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    isLogin: state.isLogin
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(RceoQuestionFinish));

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NullView_js__ = __webpack_require__(113);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var rotateInterval = void 0;

var Recommend = function (_Component) {
  _inherits(Recommend, _Component);

  function Recommend() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Recommend);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Recommend.__proto__ || Object.getPrototypeOf(Recommend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rotateNum: 0
    }, _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }, _this.knowMore = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: "/knowMore",
        state: {
          content: "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。"
        }
      });
    }, _this.goEncyclopedia = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: "/encyclopedia"
      });
    }, _this.goMain = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: "/nullView"
      });
    }, _this.goFundDetail = function (code, type) {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: {
          superFundCode: code
        },
        query: {
          superFundCode: code
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Recommend, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementsByTagName('title')[0].innerHTML = "查理推荐";
      var thisO = this;
      rotateInterval = setInterval(function () {
        thisO.setState({
          rotateNum: thisO.state.rotateNum + 1
        });
      }, 10);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(rotateInterval);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var knowMoreText = "";
      var titleText = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
      var titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
      if (window.winWidth > 375 && window.winWidth <= 414) {
        titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
      } else if (window.winWidth <= 375 && window.winWidth > 320) {
        titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
      } else if (window.winWidth == 320) {
        titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段...";
        knowMoreText = "了解更多 >>";
      } else if (window.winWidth > 414 && window.winWidth <= 480) {
        titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
      } else if (window.winWidth > 480 && window.winWidth <= 540) {
        titleTextStr = "华夏智投组合是在华夏基金19年资产管理经验的基础上，融入AI智能算法倾力打造的智能投资组合。基于客户不同阶段的财富目标，提供一键式、智能化的资产配置整体解决方案。";
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { backgroundSize: "cover", backgroundImage: 'url(' + __webpack_require__(381) + ')', display: "-webkit-flex", WebkitFlexDirection: "column", height: "100%" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain_js__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: 100 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center" } },
              '\u67E5\u7406\u63A8\u8350'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.goEncyclopedia, style: { fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right" } },
              '\u667A\u6295\u767E\u79D1'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { WebkitFlex: 1, overflow: "auto", overflowX: "hidden" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                width: window.winWidth,
                paddingLeft: 13,
                paddingRight: 13,
                WebkitFlexDirection: "row",
                WebkitJustifyContent: "space-between",
                WebkitAlignItems: "center",
                display: "-webkit-flex",
                paddingTop: 20,
                paddingBottom: 20
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 63, width: 63 }, src: __webpack_require__(83) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: "relative", paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth - 96, borderRadius: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: {
                    color: "#fff",
                    lineHeight: "16px",
                    fontSize: 13
                  } },
                titleTextStr
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.knowMore(titleText);
                  }, style: { position: "absolute", right: 10, bottom: 8 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#fa063a", fontSize: 14 } },
                  knowMoreText
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: "relative", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", margin: "0 auto", backgroundSize: "cover", height: window.winWidth === 320 ? window.winWidth - 46 : window.winWidth - 76, width: window.winWidth === 320 ? window.winWidth - 46 : window.winWidth - 76, backgroundImage: 'url(' + __webpack_require__(680) + ')' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 70, width: 70, margin: "0" }, src: __webpack_require__(648) }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { transform: "rotate(" + this.state.rotateNum + "deg)", position: "absolute", height: window.winWidth === 320 ? window.winWidth - 46 : window.winWidth - 76, width: window.winWidth === 320 ? window.winWidth - 46 : window.winWidth - 76, left: 0, top: 0 }, src: __webpack_require__(683) }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1009", "教育");
                  }, style: { textAlign: "center", position: "absolute", top: 0, left: window.winWidth === 320 ? (window.winWidth - 46) / 2 - 50 : (window.winWidth - 76) / 2 - 50 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 35, width: 35 }, src: __webpack_require__(682) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '\u91D1\u8272\u8D77\u8DD1\u7EBF'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1006", "养老");
                  }, style: { textAlign: "center", position: "absolute", top: 20, left: window.winWidth === 320 ? (window.winWidth - 46) / 2 : (window.winWidth - 76) / 2 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 35, width: 35 }, src: __webpack_require__(639) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '60\u540E\u667A\u4EAB\u8D22\u5BCC'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1005", "风险");
                  }, style: { textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth - 46) / 2 - 80 : (window.winWidth - 76) / 2 - 80, left: window.winWidth === 320 ? (window.winWidth - 46) / 2 - 100 : (window.winWidth - 76) / 2 - 100 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(661) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '\u9510\u610F\u8FDB\u53D6'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1008", "养老");
                  }, style: { textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth - 46) / 2 - 100 : (window.winWidth - 76) / 2 - 100, right: -10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 50, width: 50 }, src: __webpack_require__(641) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '80\u540E\u667A\u9886\u672A\u6765'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1010", "教育");
                  }, style: { textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth - 46) / 2 : (window.winWidth - 76) / 2, left: -10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(650) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '\u83C1\u82F1\u4E2D\u5B66\u751F'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1007", "养老");
                  }, style: { textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth - 46) / 2 + 40 : (window.winWidth - 76) / 2 + 40, left: window.winWidth === 320 ? (window.winWidth - 46) / 2 - 80 : (window.winWidth - 76) / 2 - 80 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(640) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '70\u540E\u667A\u8D62\u4EBA\u751F'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1011", "教育");
                  }, style: { textAlign: "center", position: "absolute", bottom: -20, left: window.winWidth === 320 ? (window.winWidth - 46) / 2 : (window.winWidth - 76) / 2 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 50, width: 50 }, src: __webpack_require__(655) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '\u5E38\u9752\u85E4\u5927\u5B66'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1003", "风险");
                  }, style: { textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth - 46) / 2 - 20 : (window.winWidth - 76) / 2 - 20, right: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 35, width: 35 }, src: __webpack_require__(657) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '\u5747\u8861\u7A33\u5065'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.goFundDetail("SF1002", "风险");
                  }, style: { textAlign: "center", position: "absolute", top: window.winWidth === 320 ? (window.winWidth - 46) / 2 + 60 : (window.winWidth - 76) / 2 + 60, right: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { height: 40, width: 40 }, src: __webpack_require__(688) }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: "#fff", textAlign: "center" } },
                  '\u5B89\u9038\u7406\u8D22'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingBottom: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.goMain, style: { margin: "0 auto", marginBottom: 40, marginTop: 50, height: 40, borderRadius: 25, border: "1px solid #fff", fontSize: 14, width: 209, background: "transparent", color: "#fff", WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u67E5\u770B\u66F4\u591A'
              )
            )
          )
        )
      );
    }
  }]);

  return Recommend;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Recommend));

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// 引入柱状图
// import 'echarts/lib/chart/bar';


// 引入提示框和标题组件



function compare(prop) {
  // return function(a,b){
  //     var allStartDate = getDateS(a[property]);   
  //     var allEndDate = getDateS(b[property]);
  //     var value1 = allStartDate.getTime()
  //     var value2 = allEndDate.getTime()
  //     return value2 - value1;
  // }
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 > val2) {
      return -1;
    } else if (val1 < val2) {
      return 1;
    } else {
      return 0;
    }
  };
}

var RiskEvaluationPie = function (_Component) {
  _inherits(RiskEvaluationPie, _Component);

  function RiskEvaluationPie() {
    _classCallCheck(this, RiskEvaluationPie);

    return _possibleConstructorReturn(this, (RiskEvaluationPie.__proto__ || Object.getPrototypeOf(RiskEvaluationPie)).apply(this, arguments));
  }

  _createClass(RiskEvaluationPie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dataSource = this.props.dataSource;

      var newArray = [];
      var option = void 0;
      var colorArr = [];
      var newDataSource = __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.deepClone(dataSource.content.superFundItemViews);

      for (var i = 0; i < newDataSource.length; i++) {
        for (var k = i + 1; k < newDataSource.length; k++) {
          if (newDataSource[i].typeName == newDataSource[k].typeName) {
            newDataSource[i].rate = Number(newDataSource[i].rate) + Number(newDataSource[k].rate);
            newDataSource.splice(k, 1);
            k--;
          }
        }
      }
      newDataSource.sort(compare("rate"));
      for (var _i = 0; _i < newDataSource.length; _i++) {
        newArray.push({ value: (newDataSource[_i].rate * 100).toFixed(2), name: newDataSource[_i].typeName + (newDataSource[_i].rate * 100).toFixed(2) + "%" });
        if (newDataSource[_i].fundType && newDataSource[_i].fundType.indexOf("跨境权益") != -1) {
          colorArr.push("#4729c5");
        } else if (newDataSource[_i].fundType && newDataSource[_i].fundType.indexOf("国内权益") != -1) {
          colorArr.push("#e22424");
        } else if (newDataSource[_i].fundType && newDataSource[_i].fundType.indexOf("跨境债券") != -1) {
          colorArr.push("#f25a0f");
        } else if (newDataSource[_i].fundType && newDataSource[_i].fundType.indexOf("另类") != -1) {
          colorArr.push("#f0d331");
        } else if (newDataSource[_i].fundType && newDataSource[_i].fundType.indexOf("货币") != -1) {
          colorArr.push("#23c7e2");
        } else if (newDataSource[_i].fundType && newDataSource[_i].fundType.indexOf("国内债券") != -1) {
          colorArr.push("#034ab2");
        }
        if (_i == newDataSource.length - 1) {
          option = {
            animation: window.isLess47,
            calculable: true,
            legend: {
              bottom: 15,
              x: 'center',
              orient: 'horizontal',
              data: newArray,
              height: 20,
              width: window.winWidth - 26,
              itemWidth: 14,
              selectedMode: false,
              textStyle: {}
            },
            series: [{
              type: 'pie',
              hoverAnimation: false,
              radius: [45, 90],
              center: [(window.winWidth - 26) / 2, 120],
              roseType: 'radius',
              data: newArray,
              label: {
                normal: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              }

            }],
            color: colorArr
          };
          var myChart = __WEBPACK_IMPORTED_MODULE_1_echarts_lib_echarts___default.a.init(document.getElementById('echartBox'), null, { renderer: 'svg' });
          // 绘制图表
          myChart.setOption(option);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var dataSource = this.props.dataSource;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { backgroundColor: "rgba(242,245,247,1)", paddingLeft: 13, paddingRight: 13, height: "100%", width: "100%" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: "100%", height: "100%", position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { backgroundColor: "transparent", position: 'absolute', top: 100, width: window.winWidth - 26, textAlign: "center" } },
            dataSource.content.riskRankName == "积极型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 48, height: 48 }, src: __webpack_require__(659) }) : dataSource.content.riskRankName == "稳健型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 48, height: 48 }, src: __webpack_require__(689) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 48, height: 48 }, src: __webpack_require__(658) })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'echartBox', style: { width: window.winWidth - 26, height: 320 } })
        )
      );
    }
  }]);

  return RiskEvaluationPie;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RiskEvaluationPie);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__css_BindingMobile_css__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__css_BindingMobile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__css_BindingMobile_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Loading_js__ = __webpack_require__(444);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var BindingMobile = function (_Component) {
  _inherits(BindingMobile, _Component);

  function BindingMobile(props) {
    _classCallCheck(this, BindingMobile);

    var _this = _possibleConstructorReturn(this, (BindingMobile.__proto__ || Object.getPrototypeOf(BindingMobile)).call(this, props));

    _this.toggleInvitation = function () {
      _this.setState({
        invitationCodeFlag: !_this.state.invitationCodeFlag
      });
    };

    _this.changeIncode = function (event) {
      _this.setState({
        invitationCode: event.target.value
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_62" /* invitationCode */])(event.target.value));
    };

    _this.state = {
      isRequestingVerifyCode: false,
      countDown: 120,
      loading: false,
      setModalShow: false,
      agreeIndex: 0,
      invitationCode: _this.props.location.query.invitationCode ? _this.props.location.query.invitationCode : "",
      invitationCodeFlag: false,
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
      serverCapchaCode: '',
      imageBase64: '',
      VerificationCode: ''
    };
    _this.intervalId = null;
    _this.requestId = '';
    _this.PopDid = false;
    _this.goCallback = false;
    return _this;
  }

  _createClass(BindingMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_13__Loading_js__["a" /* default */].hide();
      document.title = "一键开户";
      this.setState({
        phoneNum: this.props.mobileNo
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["e" /* getCapcha */])(function (code, imageBase64) {
        console.log('1&&&&&&&&&&');_this2.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this2.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'getCapchaCodeSuccess',
    value: function getCapchaCodeSuccess(code, imageBase64) {
      console.log('verifySuccess');
      this.setState({
        serverCapchaCode: code,
        imageBase64: imageBase64,
        getCapchaSuccess: true

      });
    }
  }, {
    key: 'getCapchaCodeAgain',
    value: function getCapchaCodeAgain() {
      var _this3 = this;

      this.setState({
        VerificationCode: ''
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["e" /* getCapcha */])(function (code, imageBase64) {
        _this3.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this3.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'getCapchaCodeError',
    value: function getCapchaCodeError(msg) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
      this.setState({ getCapchaSuccess: false });
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(e) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_publicAction__["b" /* myPhoneNum */])(e.target.value));
      // this.setState({
      //   phoneNum:e.target.value
      // })
    }
  }, {
    key: 'handleWaitingForVC',
    value: function handleWaitingForVC() {
      var _this4 = this;

      if (!/^1[0123456789]\d{9}$/.test(this.props.phoneNum)) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
        return;
      }
      // this.requestId = '';
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["d" /* verifyRegisterPhone */])({ mobileNo: this.props.phoneNum }, function (phoneNum) {
        _this4.verifyRegisterPhoneSuc(phoneNum);
      }, function (msg) {
        _this4.verifyRegisterPhoneErr(msg);
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
      if (this.goCallback) {
        this.props.location.state.callback ? this.props.location.state.callback() : null;
      }
    }
  }, {
    key: 'verifyRegisterPhoneSuc',
    value: function verifyRegisterPhoneSuc(phoneNum) {
      var _this5 = this;

      var _state = this.state,
          serverCapchaCode = _state.serverCapchaCode,
          VerificationCode = _state.VerificationCode;

      if (VerificationCode) {
        var params = { mobileNo: phoneNum,
          token: serverCapchaCode,
          captchaCode: VerificationCode.toUpperCase()
        };
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_loginAction_js__["d" /* getMobileCaptcha */])(params, function (requestId) {
          _this5.getMobileCaptchaSucc(requestId);
        }, function (succ) {
          _this5.getMobileCaptchaErr(succ);
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入图形验证码', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
      }

      // this.props.dispatch(realUserMobileCaptcha(params, (requestId)=>{this.requestId = requestId; console.log(requestId)}));
    }
  }, {
    key: 'verifyRegisterPhoneErr',
    value: function verifyRegisterPhoneErr(msg) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
      if (this.intervalId) clearInterval(this.intervalId);
      this.intervalId = null;
      this.setState({
        isRequestingVerifyCode: false
      });
    }
  }, {
    key: 'getMobileCaptchaSucc',
    value: function getMobileCaptchaSucc(requestId) {
      var _this6 = this;

      this.requestId = requestId;
      console.log(requestId);
      var countNum = 119;
      this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        _this6.intervalId = setInterval(function () {
          countNum--;
          // console.log(countNum);
          if (countNum < 0) {
            _this6.getCapchaCodeAgain();
            cancelTimeOut();
            _this6.setState({
              isRequestingVerifyCode: false
            });
          }
          _this6.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (_this6.intervalId) clearInterval(_this6.intervalId);
          _this6.intervalId = null;
        };
      });
    }
  }, {
    key: 'getMobileCaptchaErr',
    value: function getMobileCaptchaErr(succ) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].show(succ.message, __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
      this.getCapchaCodeAgain();
    }
  }, {
    key: 'Verification',
    value: function Verification(e) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_publicAction__["c" /* myVerifyCode */])(e.target.value));
      // this.setState({
      //   verifyCode:e.target.value
      // })
    }
  }, {
    key: 'handleVerify',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this7 = this;

        var verifyParam;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.props.verifyCode || !this.props.phoneNum)) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入信息', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 3:
                if (/^1[0123456789]\d{9}$/.test(this.props.phoneNum)) {
                  _context.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 6:
                if (this.state.VerificationCode) {
                  _context.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请输入图形验证码', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 9:
                if (!(this.requestId === '' || !this.requestId)) {
                  _context.next = 12;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('请先申请手机验证码', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 12:
                if (!(this.state.invitationCode && !/^1[0123456789]\d{9}$/.test(this.state.invitationCode))) {
                  _context.next = 15;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info('用户邀请码不合规', __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 15:
                _context.t0 = this.requestId;
                _context.t1 = this.props.phoneNum;
                _context.t2 = this.props.verifyCode;
                _context.next = 20;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_js__["b" /* getTempInfo */])('shortToken');

              case 20:
                _context.t3 = _context.sent;
                verifyParam = {
                  requestId: _context.t0,
                  mobileNo: _context.t1,
                  captcha: _context.t2,
                  token: _context.t3
                };

                console.log(verifyParam);
                console.log('verify');
                this.setState({
                  loading: true
                });
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["q" /* verifyPhone */])(verifyParam, function () {
                  sessionStorage.setItem('sync', _this7.props.phoneNum + ',' + _this7.requestId + ',' + (_this7.state.invitationCode ? _this7.state.invitationCode : ""));_this7.verifySuccess();
                }, function (msg) {
                  return _this7.verifyError(msg);
                }));

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleVerify() {
        return _ref.apply(this, arguments);
      }

      return handleVerify;
    }()
  }, {
    key: 'verifySuccess',
    value: function verifySuccess() {
      var _this8 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_63" /* getCrsDetail */])(function (content) {
        _this8.crsSuc(content);
      }, function (msg) {
        _this8.crsErr(msg);
      }));
    }
  }, {
    key: 'crsSuc',
    value: function crsSuc(content) {
      var _this9 = this;

      // var content={"tradeAccountNo":"40000401984","name":"张广文","certType":"0","certNo":"120110198102083022","email":"zhgw@buaa.edu.cn","sex":"0","address":"北京市海淀区学院路37号北航公共管理学院","birthday":350409600000,"isExpert":false,"residentType":0,"crsAccountInfo":{}}
      if (content.residentType != null && content.isAbroad != null) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["B" /* syncAccount */])({ isAbroad: content.isAbroad, residentType: content.residentType, provinceUs: content.crsAccountInfo.provinceUs, cityUs: content.crsAccountInfo.cityUs, postCode: content.crsAccountInfo.postCode, email: content.crsAccountInfo.email, provinceZh: content.crsAccountInfo.provinceZh, cityZh: content.crsAccountInfo.cityZh, birthCityUs: content.crsAccountInfo.birthCityUs, birthCityZh: content.crsAccountInfo.birthCityZh }, function (resInfo) {
          if (_this9.props.location.state.route) {
            if (_this9.state.enterType) {
              if (_this9.state.enterType == 'SubscriptionDetail') {
                _this9.goCallback = true;
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-1);
              } else if (_this9.state.enterType === "Answer") {
                console.log("进入答题");
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                  pathname: '/AnswerActivityDatillPage',
                  state: {},
                  query: { enterType: "Answer", activityId: _this9.props.location.query.activityId }
                });
              } else if (_this9.state.enterType == "activity") {
                var userId_a = resInfo.userId ? resInfo.userId : "";
                var tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
                var paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                console.log(paramsStr);
                var paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_7__util_js___default.a.aesEncrypt(paramsStr));
                window.location.href = __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.hdUrl + paramsData;
              } else {
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].replace({
                  pathname: '/?enterType="Investment'
                });
              }
            } else {
              _this9.goCallback = true;
              __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-1);
            }
          } else {
            if (_this9.state.enterType) {
              if (_this9.state.enterType == 'SubscriptionDetail') {
                _this9.goCallback = true;
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-1);
              } else if (_this9.state.enterType === "Answer") {
                console.log("进入答题");
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                  pathname: '/AnswerActivityDatillPage',
                  state: {},
                  query: { enterType: "Answer", activityId: _this9.props.location.query.activityId }
                });
              } else if (_this9.state.enterType == "activity") {
                var _userId_a = resInfo.userId ? resInfo.userId : "";
                var _tradeAccountNo_a = resInfo.tradeAccountNo ? resInfo.tradeAccountNo : "";
                var _paramsStr = "userId=" + _userId_a + "&tradeAccountNo=" + _tradeAccountNo_a;
                console.log(_paramsStr);
                var _paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_7__util_js___default.a.aesEncrypt(_paramsStr));
                window.location.href = __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.hdUrl + _paramsData;
              } else {
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].replace({
                  pathname: '/?enterType="Investment'
                });
              }
            }
          }
        }, function (msg) {
          __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
        }));
      } else {
        console.log('4');
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
          pathname: '/TaxInfo',
          query: {
            enterType: this.state.enterType,
            activityId: this.props.location.query.activityId
          },
          state: { callback: this.props.location.state.callback, route: this.props.location.state.route }
        });
      }
    }
  }, {
    key: 'crsErr',
    value: function crsErr(msg) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
    }
  }, {
    key: 'verifyError',
    value: function verifyError(msg) {
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_7__util_js___default.a.ToastTime);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_publicAction__["b" /* myPhoneNum */])(''));
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_publicAction__["b" /* myPhoneNum */])(''));
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_publicAction__["c" /* myVerifyCode */])(''));
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name) {
      var code = __WEBPACK_IMPORTED_MODULE_11__BankCode__["a" /* protocolCode */][name];
      console.log(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */]);
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var agreeIndex = this.state.agreeIndex;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
      } else {
        this.setState({
          agreeIndex: 0
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      console.log(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].location);
      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'BindingMobile-header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this10.goBack();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u4E00\u952E\u5F00\u6237'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'sync-header' },
            '\u534E\u590F\u67E5\u7406\u667A\u6295\u662F\u7531\u534E\u590F\u57FA\u91D1\u5168\u8D44\u5B50\u516C\u53F8\u534E\u590F\u8D22\u5BCC\u4E3A\u60A8\u63D0\u4F9B\u7684\uFF0C\u60A8\u9700\u8981\u540C\u6B65\u8D26\u6237\u4FE1\u606F\u5E76\u5F00\u901A\u534E\u590F\u8D22\u5BCC\u8D26\u6237\u3002\u4E3A\u4E86\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u7ED1\u5B9A\u5E38\u7528\u624B\u673A\u53F7\uFF1A'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'BindingMobile-input-box' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u624B\u673A\u53F7'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                return _this10.onChangeText(e);
              }, type: 'text', value: this.props.phoneNum, placeholder: '请输入手机号' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: function onClick() {
                return _this10.clear();
              }, src: __webpack_require__(47), className: 'imgBtn' })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'BindingMobile-input-box' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u56FE\u5F62\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', value: this.state.VerificationCode, onChange: function onChange(e) {
                _this10.setState({ VerificationCode: e.target.value });
              }, placeholder: '请输入图形验证码' }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { display: "-webkit-flex", WebkitAlignItems: "center" }, onClick: function onClick() {
                  _this10.getCapchaCodeAgain();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: {
                  width: 63,
                  height: 27
                }, src: 'data:image/png;base64,' + this.state.imageBase64 })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'BindingMobile-input-box' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u624B\u673A\u52A8\u6001\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                return _this10.Verification(e);
              }, type: 'text', value: this.props.verifyCode, placeholder: '请输入短信验证码' }),
            this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'BindingMobile-input-yzm' },
              this.state.countDown,
              '\u79D2\u540E\u91CD\u53D1'
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'BindingMobile-input-yzm', onClick: function onClick() {
                  return _this10.handleWaitingForVC();
                } },
              '\u83B7\u53D6\u9A8C\u8BC1\u7801'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { height: 45, paddingRight: 13, paddingLeft: 13 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitJustifyContent: "flex-end", WebkitFlexDirection: "row", height: "100%" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { width: 120 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "flex-end" }, onClick: this.toggleInvitation },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: '#3a3e47', marginLeft: 13, fontSize: 13 } },
                    '\u6211\u6709\u9080\u8BF7\u7801'
                  ),
                  this.state.invitationCodeFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: 30, height: 30 }, src: __webpack_require__(232) }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: 30, height: 30 }, src: __webpack_require__(233) })
                )
              )
            )
          ),
          this.state.invitationCodeFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: '1px solid rgba(242,245,247,1)',
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: '#3a3e47', marginLeft: 13, fontSize: 13, width: 80 } },
              '\u9080\u8BF7\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1,
                  display: "-webkit-flex"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { WebkitFlex: 1, fontSize: 13, display: "-webkit-flex" }, placeholder: '输入推荐人手机号码', value: this.state.invitationCode, onChange: this.changeIncode }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this10.setState({ invitationCode: '' });_this10.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_62" /* invitationCode */])(""));
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { marginRight: -2, width: 44, height: 44 }, src: __webpack_require__(47) })
              )
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'BindingMobile-xy-box' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: img_arr[this.state.agreeIndex], className: 'imgBtn', onClick: function onClick() {
                return _this10.isAgreeClick();
              } }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'red-t', onClick: function onClick() {
                    return _this10.ProtocolPaper('华夏财富同步信息快捷开户协议书');
                  } },
                '\u300A\u534E\u590F\u8D22\u5BCC\u540C\u6B65\u4FE1\u606F\u5FEB\u6377\u5F00\u6237\u534F\u8BAE\u4E66\u300B'
              ),
              '\u548C',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'red-t', onClick: function onClick() {
                    return _this10.ProtocolPaper('华夏财富电子交易服务协议');
                  } },
                '\u300A\u534E\u590F\u8D22\u5BCC\u7535\u5B50\u4EA4\u6613\u670D\u52A1\u534F\u8BAE\u300B'
              )
            )
          ),
          this.props.phoneNum && this.props.verifyCode && this.state.agreeIndex == 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this10.handleVerify();
              }, className: 'yjkh-btn yjkh-btn2' },
            '\u4E00\u952E\u5F00\u6237'
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'yjkh-btn' },
            '\u4E00\u952E\u5F00\u6237'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'yjkh-tip' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u7279\u522B\u63D0\u9192 :'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5F00\u901A\u534E\u590F\u8D22\u5BCC\u8D26\u6237\u540E\uFF0C\u767B\u5F55\u5BC6\u7801\u548C\u4EA4\u6613\u5BC6\u7801\u4E0E\u534E\u590F\u57FA\u91D1\u5F53\u524D\u7684\u4EA4\u6613\u5BC6\u7801\u4E00\u81F4\u3002\u5982\u6709\u9700\u8981\uFF0C\u60A8\u53EF\u4EE5\u767B\u5F55\u534E\u590F\u8D22\u5BCCAPP\u6216\u5B98\u7F51\uFF0C\u4FEE\u6539\u767B\u5F55\u548C\u4EA4\u6613\u5BC6\u7801\u3002'
            )
          )
        )
      );
    }
  }]);

  return BindingMobile;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    mobileNo: state.mobileNo,
    phoneNum: state.phoneNum,
    verifyCode: state.verifyCode
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(BindingMobile));

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);


//转换基金 参数
var pwdFlag = function pwdFlag() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'TRANSFORMATION_PWD':
      return action.text;
    default:
      return state;
  }
};
var shareClass = function shareClass() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case 'TRANSFORMATION_SHARECLASS':
      return action.text;
    default:
      return state;
  }
};
var selectVal = function selectVal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请选择转入基金';
  var action = arguments[1];

  switch (action.type) {
    case 'TRANSFORMATION_SELECTVAL':
      return action.text;
    default:
      return state;
  }
};
var selectCode = function selectCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case 'TRANSFORMATION_SELECTCODE':
      return action.text;
    default:
      return state;
  }
};
var selectType = function selectType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case 'TRANSFORMATION_SELECTTYPE':
      return action.text;
    default:
      return state;
  }
};
var text = function text() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case 'TRANSFORMATION_TEXT':
      return action.text;
    default:
      return state;
  }
};
var TransformationReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  pwdFlag: pwdFlag,
  shareClass: shareClass,
  selectVal: selectVal,
  text: text,
  selectCode: selectCode,
  selectType: selectType
});

/* harmony default export */ __webpack_exports__["a"] = (TransformationReducer);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);


//定投列表
var inInvestmentList = function inInvestmentList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: { records: [] } };
  var action = arguments[1];

  switch (action.type) {
    case "INVESTMENT_LIST":
      return action.text;
    default:
      return state;
  }
};
//定投详情
var inInvestmentDetial = function inInvestmentDetial() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: { records: [], tradeDates: [0] } };
  var action = arguments[1];

  switch (action.type) {
    case "INVESTMENT_DETIAL":
      return action.text;
    default:
      return state;
  }
};
var inInvestmentFundList = function inInvestmentFundList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: [] };
  var action = arguments[1];

  switch (action.type) {
    case "INVESTMENT_FUN_LIST":
      return action.text;
    default:
      return state;
  }
};
var productReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  inInvestmentList: inInvestmentList,
  inInvestmentFundList: inInvestmentFundList,
  inInvestmentDetial: inInvestmentDetial
});

/* harmony default export */ __webpack_exports__["a"] = (productReducer);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);


var inVestList = function inVestList() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'MY_INVEST_LIST':
			return action.text;
		default:
			return state;
	}
};
var inVestListGm = function inVestListGm() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'MY_INVEST_LIST_GM':
			return action.text;
		default:
			return state;
	}
};
var inVestListSm = function inVestListSm() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'MY_INVEST_LIST_SM':
			return action.text;
		default:
			return state;
	}
};
var inVestListSF = function inVestListSF() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'MY_INVEST_LIST_SF':
			return action.text;
		default:
			return state;
	}
};
var inVestListJhlc = function inVestListJhlc() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'MY_INVEST_LIST_JHLC':
			return action.text;
		default:
			return state;
	}
};
var inVestListZh = function inVestListZh() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'MY_INVEST_LIST_ZH':
			return action.text;
		default:
			return state;
	}
};
var inDividendMethod = function inDividendMethod() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
	var action = arguments[1];

	switch (action.type) {
		case 'DIVIDEND_METHOD':
			return action.text;
		default:
			return state;
	}
};
var inFundType = function inFundType() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var action = arguments[1];

	switch (action.type) {
		case 'FUND_TYPE':
			return action.text;
		default:
			return state;
	}
};
var trustChannelShare = function trustChannelShare() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fundInfo: {}, trustChannelShareResponse: [], isOpenBuy: true, fundIncome: [{ allIncome: 0, dayIncome: '', deadLine: null }] };
	var action = arguments[1];

	switch (action.type) {
		case 'TRUST_CHANNE_SHARE':
			return action.text;
		default:
			return state;
	}
};

//在途资金交易明细列表
var assetInTransitList = function assetInTransitList() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var action = arguments[1];

	switch (action.type) {
		case 'ASSET_IN_TRANSIT_LIST':
			return action.text;
		default:
			return state;
	}
};

var myInvest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
	inVestList: inVestList,
	inVestListJhlc: inVestListJhlc,
	inVestListZh: inVestListZh,
	inVestListSm: inVestListSm,
	inVestListSF: inVestListSF,
	inVestListGm: inVestListGm,
	inDividendMethod: inDividendMethod,
	inFundType: inFundType,
	trustChannelShare: trustChannelShare,
	assetInTransitList: assetInTransitList
});

/* harmony default export */ __webpack_exports__["a"] = (myInvest);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);


//产品首页
function productInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { advPic1: { "name": "", "code": "", "type": "", "createDate": "", "picList": [{ pictureUrl: "" }], key: '' },
    advPic2: { "name": "", "code": "", "type": "", "createDate": "", "picList": [{ pictureUrl: "" }], key: '' },
    bannerPic: { "name": "", "code": "", "type": "", "createDate": "", "picList": [{ pictureUrl: "" }, { pictureUrl: "" }, { pictureUrl: "" }, { pictureUrl: "" }, { pictureUrl: "" }], key: '' },
    featureGroupList: [], fundCommendList: [] };
  var action = arguments[1];

  switch (action.type) {
    case "PRODUCT_INFO":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

var productReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  productInfo: productInfo
});

/* harmony default export */ __webpack_exports__["a"] = (productReducer);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return investNot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return superFundProductIncomes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return lineData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stopProfitDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return strategiesDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeFundList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return userAllIncomeHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return lineDataLast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return allIncomeLast; });
var investNot = function investNot() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "INVEST_NOT":
      return action.data;
    case "INVEST_NOT_DEL":
      return {};
    default:
      return state;
  }
};

var superFundProductIncomes = function superFundProductIncomes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "SUPERFUND_PRODUCT_INCOME":
      return action.data;
    case "SUPERFUND_PRODUCT_INCOME_DEL":
      return {};
    default:
      return state;
  }
};
var lineData = function lineData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "LINE_DATA":
      return Object.assign({}, state, action.data);
    case "LINE_DATA_DEL":
      return {};
    default:
      return state;
  }
};

var stopProfitDetail = function stopProfitDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "STOP_PROFIT_DETAIL":
      return Object.assign({}, state, action.data);
    case "STOP_PROFIT_DETAIL_DEL":
      return {};
    default:
      return state;
  }
};

var strategiesDetails = function strategiesDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "STRATEGIES_DETAILS":
      return action.data;
    case "STRATEGIES_DETAILS_DEL":
      return {};
    default:
      return state;
  }
};

var changeFundList = function changeFundList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "CHANGE_FUND_LIST":
      return action.data;
    case "CHANGE_FUND_LIST_DEL":
      return {};
    default:
      return state;
  }
};

var userAllIncomeHistory = function userAllIncomeHistory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "USER_ALL_INCOME_HISTORY":
      return Object.assign({}, state, action.data);
    case "USER_ALL_INCOME_HISTORY_DEL":
      return {};
    default:
      return state;
  }
};

var lineDataLast = function lineDataLast() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case "LINE_DATA_LAST":
      return action.data;
    case "LINE_DATA_LAST_DEL":
      return {};
    default:
      return state;
  }
};

var allIncomeLast = function allIncomeLast() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "ALL_INCOME_LAST":
      return action.data;
    case "ALL_INCOME_LAST_DEL":
      return null;
    default:
      return state;
  }
};

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productReducer__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__myAssets_InvestPlanReducer__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__myAssets_myInvestReducer__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransformationReducer__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__serviceReportReducer__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__ = __webpack_require__(959);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var isLogin = function isLogin() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "IS_LOGIN":
      return action.text;
    default:
      return state;
  }
};
////同步开户传入参数：证件类型
var loginType = function loginType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_LOGIN_TYPE":
      return action.text;
    default:
      return state;
  }
};

/*基金历史收益/净值*/
function fundHistoryRatePage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { HistoryRate: [], totalElements: 0 };
  var action = arguments[1];

  if (action.type === "FUND_HISTORY_RATE_PAGE") {
    return action.text;
  } else {
    return state;
  }
}

////同步开户传入参数：证件号码
var loginNo = function loginNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_LOGIN_NO":
      return action.text;
    default:
      return state;
  }
};

////同步开户传入参数：交易密码
var tradePassword = function tradePassword() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_TRADE_PASSWORD":
      return action.text;
    default:
      return state;
  }
};

////同步开户传入参数：登录密码
var loginPassword = function loginPassword() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_LOGIN_PASSWORD":
      return action.text;
    default:
      return state;
  }
};

////同步开户传入参数：手机号
var mobileNo = function mobileNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_MOBILE_NO":
      return action.text;
    default:
      return state;
  }
};

////同步开户传入参数：短信请求编码
var requestId = function requestId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_REQUEST_ID":
      return action.text;
    default:
      return state;
  }
};

////同步开户传入参数：短信请求编码
var name = function name() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_ACCOUNT_NAME":
      return action.text;
    default:
      return state;
  }
};
////同步开户传入参数：邀请码
var invitationCode = function invitationCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "INVITATION_CODE":
      return action.text;
    default:
      return state;
  }
};
/*智投首页*/
function SupperFundHome() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SUPPER_FUND_HOME":
      return action.text;
    default:
      return state;
  }
}
var riskModalData = function riskModalData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'RISK_MODAL_DATA':
      return action.text;
    default:
      return state;
  }
};
var payLoading = function payLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'SET_PAY_LOADING':
      return action.text;
    default:
      return state;
  }
};
//银行 活期通选中位置
function selectBankIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "SELECTED_BANK_INDEX":
      return action.text;
    default:
      return state;
  }
}
function selectCurrentIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "SELECTED_CURRENT_INDEX":
      return action.text;
    default:
      return state;
  }
}

function currentType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case "CURRENT_TYPE":
      return action.text;
    default:
      return state;
  }
}
function currentIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "CURRENT_INDEX":
      return action.text;
    default:
      return state;
  }
}
function currencyIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "CURRENCY_INDEX":
      return action.text;
    default:
      return state;
  }
}
function targetIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "TARGET_INDEX":
      return action.text;
    default:
      return state;
  }
}
//当前选中卡券类型 true选中银行
function bankOrCurrent() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "BANK_OR_CURRENT":
      return action.text;
    default:
      return state;
  }
}
//支付
function payInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [], currentNav: '', currentNavDate: '', fundCode: '', fundName: '', minAmount: '' } };
  var action = arguments[1];

  switch (action.type) {
    case "PAY_INFO":
      return action.text;
    default:
      return state;
  }
}
function generateReducer(prefix, state) {
  console.log(prefix, state, 22002222);
  var PAY_INFO = prefix + '_PAY_INFO';
  var initialState = { code: '', message: '', content: Object.assign({ currencyFund: [], shareList: [], currentAccountList: [] }, state), currentType: 4, currentIndex: 0 };
  return function payInfoReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case PAY_INFO:
        return action.text;
        break;
      default:
        return state;
        break;
    }
  };
}
function currentAccount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: { shareList: [], currentAccountList: [] } };
  var action = arguments[1];

  switch (action.type) {
    case "CURRENT_ACCOUNT":
      return action.text;
    default:
      return state;
  }
}
//说明书选择状态
function smSzt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "SMS_ZT":
      return action.text;
    default:
      return state;
  }
}
//活期通选中状态
function hqtXz() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "HQT_XZ":
      return action.text;
    default:
      return state;
  }
}
//费率
function rateAndFee() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: { fee: '--', feeBefore: '--', rate: '--', rate4: '--', rateBefore: '--' } };
  var action = arguments[1];

  switch (action.type) {
    case "RATE_AND_FEE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//季度调仓
function inSeasonDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fee: '', needDays: '', previewItemFunds: [], previewItemFundsChart: [], superFund: { createDate: '', riskTypeName: '', fundName: '', nextAdjustDate: '' }, targetSuperFund: {} };
  var action = arguments[1];

  switch (action.type) {
    case "SEASON_DETAIL":
      return action.text;
    default:
      return state;
  }
}
//是否需要调仓

function userHasInvested() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "QUERY_INCOME":
      return action.text;
    default:
      return state;
  }
}
function inNeedUpdate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "NEED_UPDATE":
      return action.text;
    default:
      return state;
  }
}
function inNeedNotice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "NEED_NOTICE":
      return action.text;
    default:
      return state;
  }
}

//智投百科
function encyclopediaAction() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "ENCYCLOPEDIA_ACTION":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//风险测评数据
function riskEvaluationPieData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "RISK_EVALUATIONPIE_DATA":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function webViewHtml() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "WEB_VIEW_HTML":
      return action.text;
    default:
      return state;
  }
}
//转换基金列表
function TransformationFunList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { code: '', message: '', content: [] };
  var action = arguments[1];

  switch (action.type) {
    case "TRANSFORMATION_FUN_LIST":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//ydx end

/*智投组合未投 详情*/
function InvestNotCombinationDetil() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "INVES_NOT_COMBINATION":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/*组合已投资详情*/
function InvestStopDetil() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "INVEST_STOP":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//职业列表
function userJob() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "USER_JOB":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//城市列表
function provinceCity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "PROVINCE_CITY":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*操作记录*/
function QueryTradeRecords() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "QUERY_TRADE_RECORDS":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

//银行卡列表
function bankList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "BANK_LIST":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//银行卡类型
function bankType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "BANK_TYPE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//鉴权返回流水号
function checkNumber() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "CHECK_NUMBER":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function dianji() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "DIANJI":
      return action.text ? action.text : 1;
      break;
    default:
      return state;
      break;
  }
}
//鉴权确认
function checkSuccessData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "CHECK_SUCCESS_DATA":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*在途资金明细*/
function QueryTransitRecords() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "QUERY_TRANSIT_RECORDS":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*交易记录详情*/
function getTradeDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "TRADE_DETAIL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/*state 状态*/
function openFlag() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "OPEN_FLAG":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function active() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case "ACTIVE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function addCardText() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "ADD_CARD_TEXT":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function addPhoneText() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "ADD_PHONE_TEXT":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function paymentText() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "PAYMENT_TEXT":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function paymentTextDT() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "PAYMENT_TEXT_DT":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function paymentAgree() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];

  switch (action.type) {
    case "PAYMENT_AGREE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function fee() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '--';
  var action = arguments[1];

  switch (action.type) {
    case "FEE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function phoneNum() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "PHONE_NUM":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function verifyCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "VERIFY_CODE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function syncLoginPWD1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_LOGIN_PWD1":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function syncLoginPWD2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_LOGIN_PWD2":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function syncDealPWD1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_DEAL_PWD1":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function syncDealPWD2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_DEAL_PWD2":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
function syncBtn() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { agreeIndex1: 0, agreeIndex2: 0, btnFlag: false };
  var action = arguments[1];

  switch (action.type) {
    case "SYNC_BTN":
      if (action.text == 1) {
        if (state.agreeIndex1 == 0 && state.agreeIndex2 == 1) return { agreeIndex1: state.agreeIndex1 == 0 ? 1 : 0, agreeIndex2: state.agreeIndex2, btnFlag: true };else return { agreeIndex1: state.agreeIndex1 == 0 ? 1 : 0, agreeIndex2: state.agreeIndex2, btnFlag: false };
      } else if (action.text == 2) {
        if (state.agreeIndex1 == 1 && state.agreeIndex2 == 0) return { agreeIndex1: state.agreeIndex1, agreeIndex2: state.agreeIndex2 == 0 ? 1 : 0, btnFlag: true };else return { agreeIndex1: state.agreeIndex1, agreeIndex2: state.agreeIndex2 == 0 ? 1 : 0, btnFlag: false };
      } else {
        return { agreeIndex1: 0, agreeIndex2: 0, btnFlag: false };
      }
      break;
    default:
      return state;
      break;
  }
}

//养老教育储备金
function yljycbMoney() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YLJYCB_MONEY":
      return action.text;
    default:
      return state;
  }
}
//预期养老教育金
function yqyljyMoney() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YQYLJY_MONEY":
      return action.text;
    default:
      return state;
  }
}
//预期养老教育金2
function yqyljySliderVal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YQYLJY_SLIDER_VAL":
      return action.text;
    default:
      return state;
  }
}
//养老教育年龄
function yljyAge() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YLJY_AGE":
      return action.text;
    default:
      return state;
  }
}
//养老退休年龄
function ylOutAge() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YL_OUTAGE":
      return action.text;
    default:
      return state;
  }
}
//养老教育投资方案
function yljyPlan() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YLJY_PLAN":
      return action.text;
    default:
      return state;
  }
}

//养老教育指数
function yljyNum() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YLJY_NUM":
      return action.text;
    default:
      return state;
  }
}
//养老教育投入金额
function yljyAllMoney() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YLJY_ALL_MONEY":
      return action.text;
    default:
      return state;
  }
}
//养老教育金额图表
function yljyLineData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "YLJY_LINE_DATA":
      return action.text;
    default:
      return state;
  }
}
//教育学校类型
function jySchoolType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "JY_SCHOOL_TYPE":
      return action.text;
    default:
      return state;
  }
}
//实名认证持卡人
function smrzCardPerson() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CARD_PERSON":
      return action.text;
    default:
      return state;
  }
}
//实名认证身份证号
function smrzPersonNumber() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_PERSON_NUMBER":
      return action.text;
    default:
      return state;
  }
}
//实名认证地址
function smrzAddress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_ADDRESS":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人地址
function smrzkzrAddress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_KZRADDRESS":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人地址
function smrzsyrAddress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_SYRADDRESS":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人邮政编码
function smrzkzrBianma() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_KZRBIANMA":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人邮政编码
function smrzsyrBianma() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_SYRBIANMA":
      return action.text;
    default:
      return state;
  }
}

//实名认证控制人电子邮箱
function smrzkzrYoux() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_KZRYOUX":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人电子邮箱
function smrzsyrYoux() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_SYRYOUX":
      return action.text;
    default:
      return state;
  }
}
//实名认证职业
function smrzJob() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_JOB":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人职业
function smrzkzrJob() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_KZRJOB":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人职业
function smrzsyrJob() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_SYRJOB":
      return action.text;
    default:
      return state;
  }
}
//实名认证职业代码
function smrzCareerCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CAREERCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人职业代码
function smrzCareerkzrCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CAREERKZRCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人职业代码
function smrzCareersyrCode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CAREERSYRCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证年收入
function smrznsrcode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_NSRCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证具体年收入
function smrznJtsrcode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_JTNSRCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证城市
function smrzCity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["", ""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CITY":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人城市
function smrzkzrCityc() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["", ""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_KZRCITY":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人城市
function smrzsyrCityc() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["", ""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_SYRCITY":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人类型
function smrzBeneficontro() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["本人"];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人
function smrzBeneficontroName() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_NAME":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人证件有效期
function smrzBeneficontroZjyxq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_ZJYXQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证主账户证件有效期
function zzhZjyxq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "ZZH_ZJYXQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人证件有效期
function smrzBeneficiariesZjyxq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_ZJYXQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人证件照片
function smrzBeneficontroZjzq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_ZJZQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人证件照片
function smrzBeneficiariesZjzq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_ZJZQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人性别
function smrzkzrXbcode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_XBCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人性别
function smrzsyrXbcode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_XBCODE":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人出生日期
function smrzBeneficontroCsrq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_CSRQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人出生日期
function smrzBeneficiariesCsrq() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_CSRQ":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人手机号
function smrzBeneficontroKzrNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_KZRNO":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人手机号
function smrzBeneficontroSyrNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_SYRNO":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人类型
function smrzBeneficiaries() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["本人"];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人
function smrzBeneficiariesName() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_NAME":
      return action.text;
    default:
      return state;
  }
}
function huiDiao() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "HUIDIAO":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人证件类型
function smrzBeneficiariesType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_TYPE":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人证件类型
function smrzBeneficontroType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [""];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_TYPE":
      return action.text;
    default:
      return state;
  }
}
//实名认证受益人证件号
function smrzBeneficiariesNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFICIARIES_NO":
      return action.text;
    default:
      return state;
  }
}
//实名认证控制人证件号
function smrzBeneficontroNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_BENEFCONTRO_NO":
      return action.text;
    default:
      return state;
  }
}
//实名认证组织
function smrzGjzz() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["否"];
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_GJZZ":
      return action.text;
    default:
      return state;
  }
}
//实名认证银行卡号
function smrzCardNumber() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CARD_NUMBER":
      return action.text;
    default:
      return state;
  }
}
//实名认证修改手机号
function smrzUpdatePhoneNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_UPDATE_PHONE_NO":
      return action.text;
    default:
      return state;
  }
}
//实名认证同意项
function smrzAgreeItemFlag() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_AGREE_ITEM_FLAG":
      return action.text;
    default:
      return state;
  }
}
//实名认证验证码
function smrzCheckCard() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CHECK_CARD":
      return action.text;
    default:
      return state;
  }
}
//实名认获取证验证码显示文字
function smrzCheckCardText() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CHECK_CARD_TEXT":
      return action.text;
    default:
      return state;
  }
}
//实名认证验证码状态
function smrzCheckCardFlag() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_CHECK_CARD_FLAG":
      return action.text;
    default:
      return state;
  }
}
//实名认证交易密码
function smrzPassWord() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_PASS_WORD":
      return action.text;
    default:
      return state;
  }
}
//实名认证确认交易密码
function smrzPassWordAgain() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var action = arguments[1];

  switch (action.type) {
    case "SMRZ_PASS_WORD_AGAIN":
      return action.text;
    default:
      return state;
  }
}

//基金标签 - zbw
function fundLabel() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "FUND_LABEL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//公募基金列表 - zbw
function fundListGm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "FUND_LIST_GM":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//公募基金列表 - zbw
function fundListGm2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "FUND_LIST_GM2":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//私募基金列表 - zbw
function fundListSm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "FUND_LIST_SM":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//券商集合列表 - zbw
function fundListJh() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "FUND_LIST_JH":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//优选专户列表 - zbw
function fundListZh() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "FUND_LIST_ZH":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//基金搜索列表 - zbw
function searchFundList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SEARCH_FUND_LIST":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

var userId = function userId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  // console.log('reducer userId', action && action.text ? action.text : state);
  switch (action.type) {
    case "TEMP_INFO_USER_ID":
      return action.text;
    default:
      return state;
  }
};

var shortToken = function shortToken() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { shortToken: '', timeLine: '' };
  var action = arguments[1];

  // console.log('reducer shortToken',action && action.text ? action.text : state);
  switch (action.type) {
    case "TEMP_INFO_SHORT_TOKEN":
      return action.text;
    default:
      return state;
  }
};

var longToken = function longToken() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  // console.log('reducer longtoken',action && action.text ? action.text : state);
  switch (action.type) {
    case "TEMP_INFO_LONG_TOKEN":
      return action.text;
    default:
      return state;
  }
};

var tradeAccountNo = function tradeAccountNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case 'TEMP_INFO_TRADE_ACCOUNT_NO':
      return action.text;
    default:
      return state;
  }
};

var nickName = function nickName() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'TEMP_INFO_NICK_NAME':
      return action.text;
    default:
      return state;
  }
};

var userName = function userName() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'TEMP_INFO_USER_NAME':
      return action.text;
    default:
      return state;
  }
};

var trueName = function trueName() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'TEMP_INFO_TRUE_NAME':
      return action.text;
    default:
      return state;
  }
};

var userMobileNo = function userMobileNo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'TEMP_INFO_USER_MOBILE_NO':
      return action.text;
    default:
      return state;
  }
};

var isPrivate = function isPrivate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'TEMP_INFO_IS_PRIVATE':
      return action.text;
    default:
      return state;
  }
};

var bankCardListResetPS = function bankCardListResetPS() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case 'BANK_CARD_LIST_RESET':
      return action.text;
    default:
      return state;
  }
};

//产品类型
var productListType = function productListType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'PRODUCT_LIST_TYPE':
      return action.text;
    default:
      return state;
  }
};

//资产集合
var incomeDigital = function incomeDigital() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { customerTotalValue: '--', dayIncome: '--', allIncome: '--', endDate: '- -', transitTotalValue: '--' };
  var action = arguments[1];

  switch (action.type) {
    case 'MY_ASSETS_INCOME_DIGITAL':
      return action.text;
    default:
      return state;
  }
};

//实名个人信息
function verifiedUserInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "VERIFIEDUSERINFO":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*夏基金用户是否存在以及获取用户信息*/
function findHqtExist() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "HQT_EXIST":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function hqtCardList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case "HQT_CARD_LIST":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function Xeyi() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case "XEYI":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*公募基金详情*/
function fundPublicProductDetil() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    PublicDetilAllocation: [],
    PublicDetilAsset: [],
    PublicDetilBaseInfo: [{
      managers: ""
    }],
    PublicDetilBond: [],
    PublicDetilInfo: [_defineProperty({ discount_rate: "", dtstatus: "",
      fundcode: "", fundenddate: null,
      fundfullname: "", fundmessage: "",
      fundname: "", fundstartdate: "",
      fundtype: "", fundvalue: "",
      isshow: null, leijijingzhi: "", numcolor: "",
      publish_date: "", qirinianhua: null,
      qrnhcolor: "", rate: "", sgstatus: "",
      show_discount_rate: "",
      tradedt: "", tradesg: "", wanfenshouyi: null,
      year3grade: "", year5grade: "", zhangdiefu: ""
    }, 'tradedt', "")],
    PublicDetilManager: [],
    PublicDetilProfit: [{
      fundcode: "", fundname: "", fundtype: "",
      m1: "", m3: "", m6: "", sumdate: "",
      totalnavchgrate: null, w1: "", y1: "", y2: null, y3: "", y4: null,
      y5: "", yearnavchgrate: null
    }],
    PublicDetilRate: [],
    PublicDetilStock: []
  };
  var action = arguments[1];

  switch (action.type) {
    case "FUND_PUBLIC_DETIL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/*私募基金详情*/
function fundPrivateProductDetil() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    announcement: null, asset: null, asset_date: "", buy_rare: "1", chg: null,
    create_date: "", cxq: "", fund_code: "",
    fund_introduce: "null", fund_level: null, fund_management: "null",
    fund_name: "", fund_operator: "", fund_style: "", fund_t: null, fund_type: "私募基金",
    id: "2552", invest_extent: "", nvest_manager: "",
    invest_manager_introduce: null, invest_strategy: "", investment_term: "null",
    is_optional: "0", join_rare: "", kfq: "", manager: "",
    minAmount: null, nav_actual_date: "2016-02-01",
    open_date_end: "2017-01-20",
    open_date_start: "2017-01-04",
    operator: null,
    proformance_wage: "",
    publish_date: "2017-01-23",
    risk_type: null,
    short_name: "",
    start_money: "",
    start_point: null,
    state: "1",
    trusteeship: "",
    y1: null,
    y1_name: "",
    y1_order: null
  };
  var action = arguments[1];

  switch (action.type) {
    case "FUND_PRIVATE_RATE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*集合理财详情*/
function fundAggregateProductDetil() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    announcement: null, asset: null, asset_date: "", buy_rare: "1", chg: null,
    create_date: "", cxq: "不定期", fund_code: "",
    fund_introduce: "null", fund_level: null, fund_management: "null",
    fund_name: " ", fund_operator: "", fund_style: "", fund_t: null, fund_type: "私募基金",
    id: "2552", invest_extent: "", nvest_manager: "",
    invest_manager_introduce: null, invest_strategy: "", investment_term: "null",
    is_optional: "0", join_rare: "", kfq: "", manager: "",
    minAmount: null, nav_actual_date: "2016-02-01",
    open_date_end: "2017-01-20",
    open_date_start: "2017-01-04",
    operator: null,
    proformance_wage: "",
    publish_date: "2017-01-23",
    risk_type: null,
    short_name: " ",
    start_money: "",
    start_point: null,
    state: "1",
    trusteeship: "",
    y1: null,
    y1_name: "",
    y1_order: null
  };
  var action = arguments[1];

  switch (action.type) {
    case "FUND_AGGREGATE_RATE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*基金历史净值*/
function fundHistoty() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { HistoryRate: [], totalElements: 0 };
  var action = arguments[1];

  switch (action.type) {
    case "FUND_HISTORY_RATE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/*自选标示*/
function AddZxFlag() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "Add_ZX":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

function getHistoryAdjust() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "HISTORY_DETAIL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

//文章详情
function articleDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case "ARTICLE_DETAIL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

//评论列表
function articleMessageList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case "ARTICLE_MESSAGE_LIST":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*智投产品 查询是否开放升级功能 */
function validateSuperFundUpdate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "VALIDATE_SUPERFUND_UPDATE_ACTION":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*智投升级预览*/
function redeemToSuperFundPreview() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fee: "",
    needDays: "",
    previewItemFunds: [],
    superFund: {
      createDate: "",
      fundName: "",
      fundType: "",
      itemList: [],
      nextAdjustDate: "",
      riskType: "",
      riskTypeName: "",
      superFundCode: ""
    },
    targetSuperFund: {
      createDate: "",
      fundName: "",
      fundType: "",
      itemList: [],
      nextAdjustDate: "",
      riskType: "",
      riskTypeName: "",
      superFundCode: ""
    },
    previewItemFundsChart: []
  };
  var action = arguments[1];

  switch (action.type) {
    case "REDEEM_TO_SUPER_FUND_PREVIEW":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}

/*投顾状态*/
function superFundAccAgreementState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "SUPER_ACCA_AGREEMENT_STATE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/*签约状态*/
function signingAlreadyState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tradeAccountNo: "", state: "", createTime: 0, lastUpdateTime: 0 };
  var action = arguments[1];

  switch (action.type) {
    case "SIGNING_ALREADY_STATE":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
/**智投升级控制标识 */
function upgradeControl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case "UPGRADE_CONTROL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//答题ID
function setActivityId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { activityId: "" };
  var action = arguments[1];

  switch (action.type) {
    case "ACTIVITY_ID":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
//智投组合小常乐详情
function SuperFoundDetailXCL() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case "SUPERFUND_DETAIL_XCL":
      return action.text;
      break;
    default:
      return state;
      break;
  }
}
var reducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  SuperFoundDetailXCL: SuperFoundDetailXCL,
  hqtCardList: hqtCardList,
  Xeyi: Xeyi,
  findHqtExist: findHqtExist,
  upgradeControl: upgradeControl,
  signingAlreadyState: signingAlreadyState,
  superFundAccAgreementState: superFundAccAgreementState,
  validateSuperFundUpdate: validateSuperFundUpdate,
  redeemToSuperFundPreview: redeemToSuperFundPreview,
  /*历史调仓*/
  getHistoryAdjust: getHistoryAdjust,
  /*state 状态*/
  isLogin: isLogin,
  syncBtn: syncBtn,
  syncLoginPWD1: syncLoginPWD1,
  syncLoginPWD2: syncLoginPWD2,
  syncDealPWD1: syncDealPWD1,
  syncDealPWD2: syncDealPWD2,
  paymentAgree: paymentAgree,
  fee: fee,
  paymentText: paymentText,
  paymentTextDT: paymentTextDT,
  active: active,
  openFlag: openFlag,
  addCardText: addCardText,
  addPhoneText: addPhoneText,
  phoneNum: phoneNum,
  verifyCode: verifyCode,
  TransformationFunList: TransformationFunList,
  /*智投首页*/
  riskModalData: riskModalData,
  payLoading: payLoading,
  InvestNotCombinationDetil: InvestNotCombinationDetil, /*智投未投 详情*/
  InvestStopDetil: InvestStopDetil, /*智投已投资详情*/
  QueryTradeRecords: QueryTradeRecords, /*操作记录*/
  getTradeDetail: getTradeDetail, /*交易记录详情*/
  QueryTransitRecords: QueryTransitRecords, /*在途资金明细*/
  SupperFundHome: SupperFundHome, /*智投首页*/
  fundPublicProductDetil: fundPublicProductDetil, /*公募详情*/
  fundPrivateProductDetil: fundPrivateProductDetil, /*私募详情*/
  fundAggregateProductDetil: fundAggregateProductDetil, /*集合理财*/
  fundHistoty: fundHistoty, /*历史净值*/
  AddZxFlag: AddZxFlag, /*自选标示*/
  selectBankIndex: selectBankIndex, //卡位置
  selectCurrentIndex: selectCurrentIndex, //活期通位置
  bankOrCurrent: bankOrCurrent, //卡类型
  currentIndex: currentIndex,
  currencyIndex: currencyIndex,
  currentType: currentType,
  payInfo: payInfo, //支付渠道
  smSzt: smSzt,
  hqtXz: hqtXz,
  buyFundPayInfo: generateReducer('BUY_FUND'),
  bugDTPayInfo: generateReducer('BUY_DT'),
  superFundPayInfo: generateReducer('SUPER_FUND'),
  superFundDTPayInfo: generateReducer('SUPER_FUND_DT'),
  hqtPayInfo: generateReducer('HQT'),
  currentAccount: currentAccount,
  rateAndFee: rateAndFee, //申购费率
  inSeasonDetail: inSeasonDetail, //调仓info
  userHasInvested: userHasInvested,
  inNeedUpdate: inNeedUpdate,
  inNeedNotice: inNeedNotice,
  loginType: loginType,
  loginNo: loginNo,
  verifiedUserInfo: verifiedUserInfo,
  tradePassword: tradePassword,
  loginPassword: loginPassword,
  mobileNo: mobileNo,
  requestId: requestId,
  name: name,
  //智投百科
  encyclopediaAction: encyclopediaAction,
  //风险偏好测评
  riskEvaluationPieData: riskEvaluationPieData,
  //职业列表
  userJob: userJob,
  //城市列表
  provinceCity: provinceCity,
  //银行卡列表
  bankList: bankList,
  //银行卡类型
  bankType: bankType,
  //鉴权流水号
  checkNumber: checkNumber,
  dianji: dianji,
  //鉴权确认
  checkSuccessData: checkSuccessData,
  webViewHtml: webViewHtml,
  //养老教育储备金
  yljycbMoney: yljycbMoney,
  //预期养老教育金
  yqyljyMoney: yqyljyMoney,
  //预期养老教育金2
  yqyljySliderVal: yqyljySliderVal,
  //养老教育年龄
  yljyAge: yljyAge,
  //养老退休年龄
  ylOutAge: ylOutAge,
  //养老教育投资方案
  yljyPlan: yljyPlan,
  //养老教育指数
  yljyNum: yljyNum,
  //养老教育投入金额
  yljyAllMoney: yljyAllMoney,
  //养老教育金额图表
  yljyLineData: yljyLineData,
  //教育学校类型
  jySchoolType: jySchoolType,
  //实名认证持卡人
  smrzCardPerson: smrzCardPerson,
  //实名认证身份证号
  smrzPersonNumber: smrzPersonNumber,
  //实名认证地址
  smrzAddress: smrzAddress,
  //实名认证控制人地址
  smrzkzrAddress: smrzkzrAddress,
  //实名认证受益人地址
  smrzsyrAddress: smrzsyrAddress,
  //实名认证控制人邮政编码
  smrzkzrBianma: smrzkzrBianma,
  //实名认证受益人邮政编码
  smrzsyrBianma: smrzsyrBianma,
  //实名认证控制人电子邮箱
  smrzkzrYoux: smrzkzrYoux,
  //实名认证受益人电子邮箱
  smrzsyrYoux: smrzsyrYoux,
  //实名认证职业
  smrzJob: smrzJob,
  //实名认证控制人职业
  smrzkzrJob: smrzkzrJob,
  //实名认证受益人职业
  smrzsyrJob: smrzsyrJob,
  //实名认证职业代码
  smrzCareerCode: smrzCareerCode,
  //实名认证控制人职业代码
  smrzCareerkzrCode: smrzCareerkzrCode,
  //实名认证受益人职业代码
  smrzCareersyrCode: smrzCareersyrCode,
  //实名认证具体年收入
  smrznJtsrcode: smrznJtsrcode,
  //实名认证年收入
  smrznsrcode: smrznsrcode,
  //实名认证城市
  smrzCity: smrzCity,
  //实名认证控制人城市
  smrzkzrCityc: smrzkzrCityc,
  //实名认证受益人城市
  smrzsyrCityc: smrzsyrCityc,
  //实名认证受益人类型
  smrzBeneficiaries: smrzBeneficiaries,
  //实名认证受益人
  smrzBeneficiariesName: smrzBeneficiariesName,
  huiDiao: huiDiao,
  //实名认证控制人类型
  smrzBeneficontro: smrzBeneficontro,
  //实名认证控制人
  smrzBeneficontroName: smrzBeneficontroName,
  //实名认证控制人证件有效期
  smrzBeneficontroZjyxq: smrzBeneficontroZjyxq,
  // 实名认证主账户证件有效期
  zzhZjyxq: zzhZjyxq,
  //实名认证受益人证件有效期
  smrzBeneficiariesZjyxq: smrzBeneficiariesZjyxq,
  //实名认证控制人证件照片
  smrzBeneficontroZjzq: smrzBeneficontroZjzq,
  //实名认证受益人证件照片
  smrzBeneficiariesZjzq: smrzBeneficiariesZjzq,
  //实名认证控制人性别
  smrzkzrXbcode: smrzkzrXbcode,
  //实名认证受益人性别
  smrzsyrXbcode: smrzsyrXbcode,
  //实名认证控制人出生日期
  smrzBeneficontroCsrq: smrzBeneficontroCsrq,
  //实名认证受益人出生日期
  smrzBeneficiariesCsrq: smrzBeneficiariesCsrq,
  //实名认证控制人手机号
  smrzBeneficontroKzrNo: smrzBeneficontroKzrNo,
  //实名认证受益人手机号
  smrzBeneficontroSyrNo: smrzBeneficontroSyrNo,
  //实名认证受益人证件类型
  smrzBeneficiariesType: smrzBeneficiariesType,
  //实名认证控制人证件类型
  smrzBeneficontroType: smrzBeneficontroType,
  //实名认证受益人证件号
  smrzBeneficiariesNo: smrzBeneficiariesNo,
  //实名认证控制人证件号
  smrzBeneficontroNo: smrzBeneficontroNo,
  //实名认证组织
  smrzGjzz: smrzGjzz,
  //实名认证银行卡号
  smrzCardNumber: smrzCardNumber,
  //实名认证修改手机号
  smrzUpdatePhoneNo: smrzUpdatePhoneNo,
  //实名认证同意项
  smrzAgreeItemFlag: smrzAgreeItemFlag,
  //实名认证验证码
  smrzCheckCard: smrzCheckCard,
  //实名认获取证验证码显示文字
  smrzCheckCardText: smrzCheckCardText,
  //实名认证验证码状态
  smrzCheckCardFlag: smrzCheckCardFlag,
  //实名认证交易密码
  smrzPassWord: smrzPassWord,
  //实名认证确认交易密码
  smrzPassWordAgain: smrzPassWordAgain,
  productReducer: __WEBPACK_IMPORTED_MODULE_1__productReducer__["a" /* default */], //产品reducer
  //产品列表start
  fundLabel: fundLabel,
  fundListGm: fundListGm,
  fundListGm2: fundListGm2,
  fundListSm: fundListSm,
  fundListJh: fundListJh,
  fundListZh: fundListZh,
  searchFundList: searchFundList,
  //产品列表end
  InvestPlanReducer: __WEBPACK_IMPORTED_MODULE_2__myAssets_InvestPlanReducer__["a" /* default */], //定投reducer
  myInvestReducer: __WEBPACK_IMPORTED_MODULE_3__myAssets_myInvestReducer__["a" /* default */], // 我的投资reduce
  TransformationReducer: __WEBPACK_IMPORTED_MODULE_4__TransformationReducer__["a" /* default */], //转换交易 记录信息
  userId: userId,
  tradeAccountNo: tradeAccountNo,
  nickName: nickName,
  userName: userName,
  userMobileNo: userMobileNo,
  isPrivate: isPrivate,
  shortToken: shortToken,
  longToken: longToken,
  trueName: trueName,
  //产品类型
  productListType: productListType,
  //资产集合
  incomeDigital: incomeDigital,
  bankCardListResetPS: bankCardListResetPS,
  //同步开户邀请码
  invitationCode: invitationCode,
  //文章详情
  articleDetail: articleDetail,
  //评论列表
  articleMessageList: articleMessageList,
  targetIndex: targetIndex,
  setActivityId: setActivityId,
  serviceReportReducer: __WEBPACK_IMPORTED_MODULE_5__serviceReportReducer__["a" /* default */],
  investNot: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["a" /* investNot */], stopProfitDetail: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["b" /* stopProfitDetail */], superFundProductIncomes: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["c" /* superFundProductIncomes */],
  lineData: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["d" /* lineData */], strategiesDetails: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["e" /* strategiesDetails */], changeFundList: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["f" /* changeFundList */], userAllIncomeHistory: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["g" /* userAllIncomeHistory */], lineDataLast: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["h" /* lineDataLast */], allIncomeLast: __WEBPACK_IMPORTED_MODULE_6__protfolioReducer__["i" /* allIncomeLast */],
  fundHistoryRatePage: fundHistoryRatePage
});

/* harmony default export */ __webpack_exports__["a"] = (reducers);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


var serviceReportList = function serviceReportList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: [], processData: {} };
  var action = arguments[1];

  switch (action.type) {
    case "SERVICE_REPORTLIST":
      var curKeys = Object.keys(state.processData);
      var lastKeys = curKeys[curKeys.length - 1];
      var newKeys = Object.keys(action.data.processData);
      var newFiratKeys = newKeys[0];
      if (lastKeys == newFiratKeys) {
        var _action$data$processD;

        console.log('lastKeys == newFiratKeys');
        (_action$data$processD = action.data.processData[newFiratKeys]).unshift.apply(_action$data$processD, _toConsumableArray(state.processData[lastKeys]));
      }
      console.log('11111111', action.data.processData);
      return Object.assign({}, action.data, {
        data: [].concat(_toConsumableArray(state.data), _toConsumableArray(action.data.data)),
        processData: Object.assign({}, state.processData, action.data.processData)
      });

    case "LIST_DEL":
      return { data: [], processData: {} };
    default:
      return state;
  }
};
var serviceReporDetail = function serviceReporDetail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "SERVICE_REPORTDETAIL":
      return action.data;
    case "DEL":
      return {};
    default:
      return state;
  }
};
var serviceReportReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  serviceReportList: serviceReportList,
  serviceReporDetail: serviceReporDetail
});

/* harmony default export */ __webpack_exports__["a"] = (serviceReportReducer);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(962)
var ieee754 = __webpack_require__(1131)
var isArray = __webpack_require__(1132)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(993);
var $Object = __webpack_require__(60).Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(994);
module.exports = __webpack_require__(60).Object.getPrototypeOf;

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(101)
  , toLength  = __webpack_require__(459)
  , toIndex   = __webpack_require__(986);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(281)
  , TAG = __webpack_require__(85)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(100)
  , createDesc      = __webpack_require__(170);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(169)
  , gOPS    = __webpack_require__(288)
  , pIE     = __webpack_require__(203);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(99).document && document.documentElement;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(168)
  , ITERATOR   = __webpack_require__(85)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(281);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(132);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(286)
  , descriptor     = __webpack_require__(170)
  , setToStringTag = __webpack_require__(289)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(134)(IteratorPrototype, __webpack_require__(85)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(85)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(169)
  , toIObject = __webpack_require__(101);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(205)('meta')
  , isObject = __webpack_require__(167)
  , has      = __webpack_require__(115)
  , setDesc  = __webpack_require__(100).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(133)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(169)
  , gOPS     = __webpack_require__(288)
  , pIE      = __webpack_require__(203)
  , toObject = __webpack_require__(204)
  , IObject  = __webpack_require__(452)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(133)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(100)
  , anObject = __webpack_require__(132)
  , getKeys  = __webpack_require__(169);

module.exports = __webpack_require__(114) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(101)
  , gOPN      = __webpack_require__(454).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(167)
  , anObject = __webpack_require__(132);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(282)(Function.call, __webpack_require__(287).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(292)
  , defined   = __webpack_require__(283);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(292)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(969)
  , ITERATOR  = __webpack_require__(85)('iterator')
  , Iterators = __webpack_require__(168);
module.exports = __webpack_require__(60).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(282)
  , $export        = __webpack_require__(98)
  , toObject       = __webpack_require__(204)
  , call           = __webpack_require__(975)
  , isArrayIter    = __webpack_require__(973)
  , toLength       = __webpack_require__(459)
  , createProperty = __webpack_require__(970)
  , getIterFn      = __webpack_require__(987);

$export($export.S + $export.F * !__webpack_require__(977)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(967)
  , step             = __webpack_require__(978)
  , Iterators        = __webpack_require__(168)
  , toIObject        = __webpack_require__(101);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(453)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(98);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(981)});

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(98)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(286)});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(98);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(114), 'Object', {defineProperty: __webpack_require__(100).f});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(101)
  , $getOwnPropertyDescriptor = __webpack_require__(287).f;

__webpack_require__(457)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(204)
  , $getPrototypeOf = __webpack_require__(455);

__webpack_require__(457)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(98);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(984).set});

/***/ }),
/* 996 */
/***/ (function(module, exports) {



/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(99)
  , has            = __webpack_require__(115)
  , DESCRIPTORS    = __webpack_require__(114)
  , $export        = __webpack_require__(98)
  , redefine       = __webpack_require__(458)
  , META           = __webpack_require__(980).KEY
  , $fails         = __webpack_require__(133)
  , shared         = __webpack_require__(291)
  , setToStringTag = __webpack_require__(289)
  , uid            = __webpack_require__(205)
  , wks            = __webpack_require__(85)
  , wksExt         = __webpack_require__(295)
  , wksDefine      = __webpack_require__(294)
  , keyOf          = __webpack_require__(979)
  , enumKeys       = __webpack_require__(971)
  , isArray        = __webpack_require__(974)
  , anObject       = __webpack_require__(132)
  , toIObject      = __webpack_require__(101)
  , toPrimitive    = __webpack_require__(293)
  , createDesc     = __webpack_require__(170)
  , _create        = __webpack_require__(286)
  , gOPNExt        = __webpack_require__(983)
  , $GOPD          = __webpack_require__(287)
  , $DP            = __webpack_require__(100)
  , $keys          = __webpack_require__(169)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(454).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(203).f  = $propertyIsEnumerable;
  __webpack_require__(288).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(285)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(134)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294)('asyncIterator');

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294)('observable');

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(989);
var global        = __webpack_require__(99)
  , hide          = __webpack_require__(134)
  , Iterators     = __webpack_require__(168)
  , TO_STRING_TAG = __webpack_require__(85)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(135), __webpack_require__(136), __webpack_require__(116), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(206), __webpack_require__(1006), __webpack_require__(1003), __webpack_require__(135), __webpack_require__(136), __webpack_require__(297), __webpack_require__(461), __webpack_require__(1022), __webpack_require__(462), __webpack_require__(1024), __webpack_require__(1023), __webpack_require__(1021), __webpack_require__(296), __webpack_require__(1017), __webpack_require__(116), __webpack_require__(44), __webpack_require__(1007), __webpack_require__(1009), __webpack_require__(1008), __webpack_require__(1011), __webpack_require__(1010), __webpack_require__(1012), __webpack_require__(1013), __webpack_require__(1014), __webpack_require__(1016), __webpack_require__(1015), __webpack_require__(1004), __webpack_require__(1002), __webpack_require__(1025), __webpack_require__(1020), __webpack_require__(1019), __webpack_require__(1018));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(297), __webpack_require__(296));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(135), __webpack_require__(136), __webpack_require__(116), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(135), __webpack_require__(136), __webpack_require__(116), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(135), __webpack_require__(136), __webpack_require__(116), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(461));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(206));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(206), __webpack_require__(462));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(23), __webpack_require__(135), __webpack_require__(136), __webpack_require__(116), __webpack_require__(44));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1028);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1027);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js

function ExtensionAPI(chartInstance) {
  zrUtil.each(echartsAPIList, function (name) {
    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
  }, this);
}

var _default = ExtensionAPI;
module.exports = _default;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

function _default(seriesType, actionInfos) {
  zrUtil.each(actionInfos, function (actionInfo) {
    actionInfo.update = 'updateView';
    /**
     * @payload
     * @property {string} seriesName
     * @property {string} name
     */

    echarts.registerAction(actionInfo, function (payload, ecModel) {
      var selected = {};
      ecModel.eachComponent({
        mainType: 'series',
        subType: seriesType,
        query: payload
      }, function (seriesModel) {
        if (seriesModel[actionInfo.method]) {
          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
        }

        var data = seriesModel.getData(); // Create selected map

        data.each(function (idx) {
          var name = data.getName(idx);
          selected[name] = seriesModel.isSelected(name) || false;
        });
      });
      return {
        name: payload.name,
        selected: selected
      };
    });
  });
}

module.exports = _default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var BaseBarSeries = __webpack_require__(1035);

var _default = BaseBarSeries.extend({
  type: 'series.bar',
  dependencies: ['grid', 'polar'],
  brushSelector: 'rect'
});

module.exports = _default;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

var _helper = __webpack_require__(1037);

var setLabel = _helper.setLabel;

var Model = __webpack_require__(70);

var barItemStyle = __webpack_require__(1036);

var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'normal', 'barBorderWidth']; // FIXME
// Just for compatible with ec2.

zrUtil.extend(Model.prototype, barItemStyle);

var _default = echarts.extendChartView({
  type: 'bar',
  render: function (seriesModel, ecModel, api) {
    var coordinateSystemType = seriesModel.get('coordinateSystem');

    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
      this._render(seriesModel, ecModel, api);
    } else {}

    return this.group;
  },
  dispose: zrUtil.noop,
  _render: function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coord = seriesModel.coordinateSystem;
    var baseAxis = coord.getBaseAxis();
    var isHorizontalOrRadial;

    if (coord.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
    } else if (coord.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
    }

    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
    data.diff(oldData).add(function (dataIndex) {
      if (!data.hasValue(dataIndex)) {
        return;
      }

      var itemModel = data.getItemModel(dataIndex);
      var layout = getLayout[coord.type](data, dataIndex, itemModel);
      var el = elementCreator[coord.type](data, dataIndex, itemModel, layout, isHorizontalOrRadial, animationModel);
      data.setItemGraphicEl(dataIndex, el);
      group.add(el);
      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
    }).update(function (newIndex, oldIndex) {
      var el = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(el);
        return;
      }

      var itemModel = data.getItemModel(newIndex);
      var layout = getLayout[coord.type](data, newIndex, itemModel);

      if (el) {
        graphic.updateProps(el, {
          shape: layout
        }, animationModel, newIndex);
      } else {
        el = elementCreator[coord.type](data, newIndex, itemModel, layout, isHorizontalOrRadial, animationModel, true);
      }

      data.setItemGraphicEl(newIndex, el); // Add back

      group.add(el);
      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
    }).remove(function (dataIndex) {
      var el = oldData.getItemGraphicEl(dataIndex);

      if (coord.type === 'cartesian2d') {
        el && removeRect(dataIndex, animationModel, el);
      } else {
        el && removeSector(dataIndex, animationModel, el);
      }
    }).execute();
    this._data = data;
  },
  remove: function (ecModel, api) {
    var group = this.group;
    var data = this._data;

    if (ecModel.get('animation')) {
      if (data) {
        data.eachItemGraphicEl(function (el) {
          if (el.type === 'sector') {
            removeSector(el.dataIndex, ecModel, el);
          } else {
            removeRect(el.dataIndex, ecModel, el);
          }
        });
      }
    } else {
      group.removeAll();
    }
  }
});

var elementCreator = {
  cartesian2d: function (data, dataIndex, itemModel, layout, isHorizontal, animationModel, isUpdate) {
    var rect = new graphic.Rect({
      shape: zrUtil.extend({}, layout)
    }); // Animation

    if (animationModel) {
      var rectShape = rect.shape;
      var animateProperty = isHorizontal ? 'height' : 'width';
      var animateTarget = {};
      rectShape[animateProperty] = 0;
      animateTarget[animateProperty] = layout[animateProperty];
      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
        shape: animateTarget
      }, animationModel, dataIndex);
    }

    return rect;
  },
  polar: function (data, dataIndex, itemModel, layout, isRadial, animationModel, isUpdate) {
    var sector = new graphic.Sector({
      shape: zrUtil.extend({}, layout)
    }); // Animation

    if (animationModel) {
      var sectorShape = sector.shape;
      var animateProperty = isRadial ? 'r' : 'endAngle';
      var animateTarget = {};
      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
      animateTarget[animateProperty] = layout[animateProperty];
      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
        shape: animateTarget
      }, animationModel, dataIndex);
    }

    return sector;
  }
};

function removeRect(dataIndex, animationModel, el) {
  // Not show text when animating
  el.style.text = null;
  graphic.updateProps(el, {
    shape: {
      width: 0
    }
  }, animationModel, dataIndex, function () {
    el.parent && el.parent.remove(el);
  });
}

function removeSector(dataIndex, animationModel, el) {
  // Not show text when animating
  el.style.text = null;
  graphic.updateProps(el, {
    shape: {
      r: el.shape.r0
    }
  }, animationModel, dataIndex, function () {
    el.parent && el.parent.remove(el);
  });
}

var getLayout = {
  cartesian2d: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    var fixedLineWidth = getLineWidth(itemModel, layout); // fix layout with lineWidth

    var signX = layout.width > 0 ? 1 : -1;
    var signY = layout.height > 0 ? 1 : -1;
    return {
      x: layout.x + signX * fixedLineWidth / 2,
      y: layout.y + signY * fixedLineWidth / 2,
      width: layout.width - signX * fixedLineWidth,
      height: layout.height - signY * fixedLineWidth
    };
  },
  polar: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    return {
      cx: layout.cx,
      cy: layout.cy,
      r0: layout.r0,
      r: layout.r,
      startAngle: layout.startAngle,
      endAngle: layout.endAngle
    };
  }
};

function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
  var color = data.getItemVisual(dataIndex, 'color');
  var opacity = data.getItemVisual(dataIndex, 'opacity');
  var itemStyleModel = itemModel.getModel('itemStyle.normal');
  var hoverStyle = itemModel.getModel('itemStyle.emphasis').getBarItemStyle();

  if (!isPolar) {
    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
  }

  el.useStyle(zrUtil.defaults({
    fill: color,
    opacity: opacity
  }, itemStyleModel.getBarItemStyle()));
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && el.attr('cursor', cursorStyle);
  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';

  if (!isPolar) {
    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
  }

  graphic.setHoverStyle(el, hoverStyle);
} // In case width or height are too small.


function getLineWidth(itemModel, rawLayout) {
  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
  return Math.min(lineWidth, Math.abs(rawLayout.width), Math.abs(rawLayout.height));
}

module.exports = _default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var SeriesModel = __webpack_require__(302);

var createListFromArray = __webpack_require__(299);

var _default = SeriesModel.extend({
  type: 'series.__base_bar__',
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  },
  getMarkerPosition: function (value) {
    var coordSys = this.coordinateSystem;

    if (coordSys) {
      // PENDING if clamp ?
      var pt = coordSys.dataToPoint(value, true);
      var data = this.getData();
      var offset = data.getLayout('offset');
      var size = data.getLayout('size');
      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
      pt[offsetIndex] += offset + size / 2;
      return pt;
    }

    return [NaN, NaN];
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // stack: null
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // 最小高度改为0
    barMinHeight: 0,
    // 最小角度为0，仅对极坐标系下的柱状图有效
    barMinAngle: 0,
    // cursor: null,
    // barMaxWidth: null,
    // 默认自适应
    // barWidth: null,
    // 柱间距离，默认为柱形宽度的30%，可设固定值
    // barGap: '30%',
    // 类目间柱形距离，默认为类目间距的20%，可设固定值
    // barCategoryGap: '20%',
    // label: {
    //     normal: {
    //         show: false
    //     }
    // },
    itemStyle: {// normal: {
      // color: '各异'
      // },
      // emphasis: {}
    }
  }
});

module.exports = _default;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(209);

var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getBarItemStyle: function (excludes) {
    var style = getBarItemStyle(this, excludes);

    if (this.getBorderLineDash) {
      var lineDash = this.getBorderLineDash();
      lineDash && (style.lineDash = lineDash);
    }

    return style;
  }
};
module.exports = _default;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(34);

function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
  var labelModel = itemModel.getModel('label.normal');
  var hoverLabelModel = itemModel.getModel('label.emphasis');
  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
    labelFetcher: seriesModel,
    labelDataIndex: dataIndex,
    defaultText: seriesModel.getRawValue(dataIndex),
    isRectText: true,
    autoColor: color
  });
  fixPosition(normalStyle);
  fixPosition(hoverStyle);
}

function fixPosition(style, labelPositionOutside) {
  if (style.textPosition === 'outside') {
    style.textPosition = labelPositionOutside;
  }
}

exports.setLabel = setLabel;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(34);

var SymbolClz = __webpack_require__(464);

/**
 * @module echarts/chart/helper/SymbolDraw
 */

/**
 * @constructor
 * @alias module:echarts/chart/helper/SymbolDraw
 * @param {module:zrender/graphic/Group} [symbolCtor]
 */
function SymbolDraw(symbolCtor) {
  this.group = new graphic.Group();
  this._symbolCtor = symbolCtor || SymbolClz;
}

var symbolDrawProto = SymbolDraw.prototype;

function symbolNeedsDraw(data, idx, isIgnore) {
  var point = data.getItemLayout(idx); // Is an object
  // if (point && point.hasOwnProperty('point')) {
  //     point = point.point;
  // }

  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(isIgnore && isIgnore(idx)) && data.getItemVisual(idx, 'symbol') !== 'none';
}
/**
 * Update symbols draw by new data
 * @param {module:echarts/data/List} data
 * @param {Array.<boolean>} [isIgnore]
 */


symbolDrawProto.updateData = function (data, isIgnore) {
  var group = this.group;
  var seriesModel = data.hostModel;
  var oldData = this._data;
  var SymbolCtor = this._symbolCtor;
  var seriesScope = {
    itemStyle: seriesModel.getModel('itemStyle.normal').getItemStyle(['color']),
    hoverItemStyle: seriesModel.getModel('itemStyle.emphasis').getItemStyle(),
    symbolRotate: seriesModel.get('symbolRotate'),
    symbolOffset: seriesModel.get('symbolOffset'),
    hoverAnimation: seriesModel.get('hoverAnimation'),
    labelModel: seriesModel.getModel('label.normal'),
    hoverLabelModel: seriesModel.getModel('label.emphasis'),
    cursorStyle: seriesModel.get('cursor')
  };
  data.diff(oldData).add(function (newIdx) {
    var point = data.getItemLayout(newIdx);

    if (symbolNeedsDraw(data, newIdx, isIgnore)) {
      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
      symbolEl.attr('position', point);
      data.setItemGraphicEl(newIdx, symbolEl);
      group.add(symbolEl);
    }
  }).update(function (newIdx, oldIdx) {
    var symbolEl = oldData.getItemGraphicEl(oldIdx);
    var point = data.getItemLayout(newIdx);

    if (!symbolNeedsDraw(data, newIdx, isIgnore)) {
      group.remove(symbolEl);
      return;
    }

    if (!symbolEl) {
      symbolEl = new SymbolCtor(data, newIdx);
      symbolEl.attr('position', point);
    } else {
      symbolEl.updateData(data, newIdx, seriesScope);
      graphic.updateProps(symbolEl, {
        position: point
      }, seriesModel);
    } // Add back


    group.add(symbolEl);
    data.setItemGraphicEl(newIdx, symbolEl);
  }).remove(function (oldIdx) {
    var el = oldData.getItemGraphicEl(oldIdx);
    el && el.fadeOut(function () {
      group.remove(el);
    });
  }).execute();
  this._data = data;
};

symbolDrawProto.updateLayout = function () {
  var data = this._data;

  if (data) {
    // Not use animation
    data.eachItemGraphicEl(function (el, idx) {
      var point = data.getItemLayout(idx);
      el.attr('position', point);
    });
  }
};

symbolDrawProto.remove = function (enableAnimation) {
  var group = this.group;
  var data = this._data;

  if (data) {
    if (enableAnimation) {
      data.eachItemGraphicEl(function (el) {
        el.fadeOut(function () {
          group.remove(el);
        });
      });
    } else {
      group.removeAll();
    }
  }
};

var _default = SymbolDraw;
module.exports = _default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var _model = __webpack_require__(45);

var otherDimToDataDim = _model.otherDimToDataDim;

/**
 * @module echarts/chart/helper/Symbol
 */
function findLabelValueDim(data) {
  var valueDim;
  var labelDims = otherDimToDataDim(data, 'label');

  if (labelDims.length) {
    valueDim = labelDims[0];
  } else {
    // Get last value dim
    var dimensions = data.dimensions.slice();
    var dataType;

    while (dimensions.length && (valueDim = dimensions.pop(), dataType = data.getDimensionInfo(valueDim).type, dataType === 'ordinal' || dataType === 'time')) {} // jshint ignore:line

  }

  return valueDim;
}

exports.findLabelValueDim = findLabelValueDim;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var createListFromArray = __webpack_require__(299);

var SeriesModel = __webpack_require__(302);

var _default = SeriesModel.extend({
  type: 'series.line',
  dependencies: ['grid', 'polar'],
  getInitialData: function (option, ecModel) {
    return createListFromArray(option.data, this, ecModel);
  },
  defaultOption: {
    zlevel: 0,
    // 一级层叠
    z: 2,
    // 二级层叠
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    hoverAnimation: true,
    // stack: null
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // If clip the overflow value
    clipOverflow: true,
    // cursor: null,
    label: {
      normal: {
        position: 'top'
      }
    },
    // itemStyle: {
    //     normal: {},
    //     emphasis: {}
    // },
    lineStyle: {
      normal: {
        width: 2,
        type: 'solid'
      }
    },
    // areaStyle: {},
    // false, 'start', 'end', 'middle'
    step: false,
    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    // 拐点图形类型
    symbol: 'emptyCircle',
    // 拐点图形大小
    symbolSize: 4,
    // 拐点图形旋转控制
    symbolRotate: null,
    // 是否显示 symbol, 只有在 tooltip hover 的时候显示
    showSymbol: true,
    // 标志图形默认只有主轴显示（随主轴标签间隔隐藏策略）
    showAllSymbol: false,
    // 是否连接断点
    connectNulls: false,
    // 数据过滤，'average', 'max', 'min', 'sum'
    sampling: 'none',
    animationEasing: 'linear',
    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity
  }
});

module.exports = _default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var SymbolDraw = __webpack_require__(1038);

var SymbolClz = __webpack_require__(464);

var lineAnimationDiff = __webpack_require__(1042);

var graphic = __webpack_require__(34);

var modelUtil = __webpack_require__(45);

var _poly = __webpack_require__(1043);

var Polyline = _poly.Polyline;
var Polygon = _poly.Polygon;

var ChartView = __webpack_require__(306);

// FIXME step not support polar
function isPointsSame(points1, points2) {
  if (points1.length !== points2.length) {
    return;
  }

  for (var i = 0; i < points1.length; i++) {
    var p1 = points1[i];
    var p2 = points2[i];

    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
      return;
    }
  }

  return true;
}

function getSmooth(smooth) {
  return typeof smooth === 'number' ? smooth : smooth ? 0.3 : 0;
}

function getAxisExtentWithGap(axis) {
  var extent = axis.getGlobalExtent();

  if (axis.onBand) {
    // Remove extra 1px to avoid line miter in clipped edge
    var halfBandWidth = axis.getBandWidth() / 2 - 1;
    var dir = extent[1] > extent[0] ? 1 : -1;
    extent[0] += dir * halfBandWidth;
    extent[1] -= dir * halfBandWidth;
  }

  return extent;
}

function sign(val) {
  return val >= 0 ? 1 : -1;
}
/**
 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
 * @param {module:echarts/data/List} data
 * @param {Array.<Array.<number>>} points
 * @private
 */


function getStackedOnPoints(coordSys, data) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = 0;

  if (!baseAxis.onZero) {
    var extent = valueAxis.scale.getExtent();

    if (extent[0] > 0) {
      // Both positive
      valueStart = extent[0];
    } else if (extent[1] < 0) {
      // Both negative
      valueStart = extent[1];
    } // If is one positive, and one negative, onZero shall be true

  }

  var valueDim = valueAxis.dim;
  var baseDataOffset = valueDim === 'x' || valueDim === 'radius' ? 1 : 0;
  return data.mapArray([valueDim], function (val, idx) {
    var stackedOnSameSign;
    var stackedOn = data.stackedOn; // Find first stacked value with same sign

    while (stackedOn && sign(stackedOn.get(valueDim, idx)) === sign(val)) {
      stackedOnSameSign = stackedOn;
      break;
    }

    var stackedData = [];
    stackedData[baseDataOffset] = data.get(baseAxis.dim, idx);
    stackedData[1 - baseDataOffset] = stackedOnSameSign ? stackedOnSameSign.get(valueDim, idx, true) : valueStart;
    return coordSys.dataToPoint(stackedData);
  }, true);
}

function createGridClipShape(cartesian, hasAnimation, seriesModel) {
  var xExtent = getAxisExtentWithGap(cartesian.getAxis('x'));
  var yExtent = getAxisExtentWithGap(cartesian.getAxis('y'));
  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
  var x = Math.min(xExtent[0], xExtent[1]);
  var y = Math.min(yExtent[0], yExtent[1]);
  var width = Math.max(xExtent[0], xExtent[1]) - x;
  var height = Math.max(yExtent[0], yExtent[1]) - y;
  var lineWidth = seriesModel.get('lineStyle.normal.width') || 2; // Expand clip shape to avoid clipping when line value exceeds axis

  var expandSize = seriesModel.get('clipOverflow') ? lineWidth / 2 : Math.max(width, height);

  if (isHorizontal) {
    y -= expandSize;
    height += expandSize * 2;
  } else {
    x -= expandSize;
    width += expandSize * 2;
  }

  var clipPath = new graphic.Rect({
    shape: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  });

  if (hasAnimation) {
    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
    graphic.initProps(clipPath, {
      shape: {
        width: width,
        height: height
      }
    }, seriesModel);
  }

  return clipPath;
}

function createPolarClipShape(polar, hasAnimation, seriesModel) {
  var angleAxis = polar.getAngleAxis();
  var radiusAxis = polar.getRadiusAxis();
  var radiusExtent = radiusAxis.getExtent();
  var angleExtent = angleAxis.getExtent();
  var RADIAN = Math.PI / 180;
  var clipPath = new graphic.Sector({
    shape: {
      cx: polar.cx,
      cy: polar.cy,
      r0: radiusExtent[0],
      r: radiusExtent[1],
      startAngle: -angleExtent[0] * RADIAN,
      endAngle: -angleExtent[1] * RADIAN,
      clockwise: angleAxis.inverse
    }
  });

  if (hasAnimation) {
    clipPath.shape.endAngle = -angleExtent[0] * RADIAN;
    graphic.initProps(clipPath, {
      shape: {
        endAngle: -angleExtent[1] * RADIAN
      }
    }, seriesModel);
  }

  return clipPath;
}

function createClipShape(coordSys, hasAnimation, seriesModel) {
  return coordSys.type === 'polar' ? createPolarClipShape(coordSys, hasAnimation, seriesModel) : createGridClipShape(coordSys, hasAnimation, seriesModel);
}

function turnPointsIntoStep(points, coordSys, stepTurnAt) {
  var baseAxis = coordSys.getBaseAxis();
  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
  var stepPoints = [];

  for (var i = 0; i < points.length - 1; i++) {
    var nextPt = points[i + 1];
    var pt = points[i];
    stepPoints.push(pt);
    var stepPt = [];

    switch (stepTurnAt) {
      case 'end':
        stepPt[baseIndex] = nextPt[baseIndex];
        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
        break;

      case 'middle':
        // default is start
        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
        var stepPt2 = [];
        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt);
        stepPoints.push(stepPt2);
        break;

      default:
        stepPt[baseIndex] = pt[baseIndex];
        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start

        stepPoints.push(stepPt);
    }
  } // Last points


  points[i] && stepPoints.push(points[i]);
  return stepPoints;
}

function getVisualGradient(data, coordSys) {
  var visualMetaList = data.getVisual('visualMeta');

  if (!visualMetaList || !visualMetaList.length || !data.count()) {
    // When data.count() is 0, gradient range can not be calculated.
    return;
  }

  var visualMeta;

  for (var i = visualMetaList.length - 1; i >= 0; i--) {
    // Can only be x or y
    if (visualMetaList[i].dimension < 2) {
      visualMeta = visualMetaList[i];
      break;
    }
  }

  if (!visualMeta || coordSys.type !== 'cartesian2d') {
    return;
  } // If the area to be rendered is bigger than area defined by LinearGradient,
  // the canvas spec prescribes that the color of the first stop and the last
  // stop should be used. But if two stops are added at offset 0, in effect
  // browsers use the color of the second stop to render area outside
  // LinearGradient. So we can only infinitesimally extend area defined in
  // LinearGradient to render `outerColors`.


  var dimension = visualMeta.dimension;
  var dimName = data.dimensions[dimension];
  var axis = coordSys.getAxis(dimName); // dataToCoor mapping may not be linear, but must be monotonic.

  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
    return {
      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
      color: stop.color
    };
  });
  var stopLen = colorStops.length;
  var outerColors = visualMeta.outerColors.slice();

  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
    colorStops.reverse();
    outerColors.reverse();
  }

  var tinyExtent = 10; // Arbitrary value: 10px

  var minCoord = colorStops[0].coord - tinyExtent;
  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
  var coordSpan = maxCoord - minCoord;

  if (coordSpan < 1e-3) {
    return 'transparent';
  }

  zrUtil.each(colorStops, function (stop) {
    stop.offset = (stop.coord - minCoord) / coordSpan;
  });
  colorStops.push({
    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
    color: outerColors[1] || 'transparent'
  });
  colorStops.unshift({
    // notice colorStops.length have been changed.
    offset: stopLen ? colorStops[0].offset : 0.5,
    color: outerColors[0] || 'transparent'
  }); // zrUtil.each(colorStops, function (colorStop) {
  //     // Make sure each offset has rounded px to avoid not sharp edge
  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
  // });

  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
  gradient[dimName] = minCoord;
  gradient[dimName + '2'] = maxCoord;
  return gradient;
}

var _default = ChartView.extend({
  type: 'line',
  init: function () {
    var lineGroup = new graphic.Group();
    var symbolDraw = new SymbolDraw();
    this.group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineGroup = lineGroup;
  },
  render: function (seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var lineStyleModel = seriesModel.getModel('lineStyle.normal');
    var areaStyleModel = seriesModel.getModel('areaStyle.normal');
    var points = data.mapArray(data.getItemLayout, true);
    var isCoordSysPolar = coordSys.type === 'polar';
    var prevCoordSys = this._coordSys;
    var symbolDraw = this._symbolDraw;
    var polyline = this._polyline;
    var polygon = this._polygon;
    var lineGroup = this._lineGroup;
    var hasAnimation = seriesModel.get('animation');
    var isAreaChart = !areaStyleModel.isEmpty();
    var stackedOnPoints = getStackedOnPoints(coordSys, data);
    var showSymbol = seriesModel.get('showSymbol');

    var isSymbolIgnore = showSymbol && !isCoordSysPolar && !seriesModel.get('showAllSymbol') && this._getSymbolIgnoreFunc(data, coordSys); // Remove temporary symbols


    var oldData = this._data;
    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    }); // Remove previous created symbols if showSymbol changed to false

    if (!showSymbol) {
      symbolDraw.remove();
    }

    group.add(lineGroup); // FIXME step not support polar

    var step = !isCoordSysPolar && seriesModel.get('step'); // Initialization animation or coordinate system changed

    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
      showSymbol && symbolDraw.updateData(data, isSymbolIgnore);

      if (step) {
        // TODO If stacked series is not step
        points = turnPointsIntoStep(points, coordSys, step);
        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
      }

      polyline = this._newPolyline(points, coordSys, hasAnimation);

      if (isAreaChart) {
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      }

      lineGroup.setClipPath(createClipShape(coordSys, true, seriesModel));
    } else {
      if (isAreaChart && !polygon) {
        // If areaStyle is added
        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
      } else if (polygon && !isAreaChart) {
        // If areaStyle is removed
        lineGroup.remove(polygon);
        polygon = this._polygon = null;
      } // Update clipPath


      lineGroup.setClipPath(createClipShape(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
      // because points are not changed

      showSymbol && symbolDraw.updateData(data, isSymbolIgnore); // Stop symbol animation and sync with line points
      // FIXME performance?

      data.eachItemGraphicEl(function (el) {
        el.stopAnimation(true);
      }); // In the case data zoom triggerred refreshing frequently
      // Data may not change if line has a category axis. So it should animate nothing

      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
        if (hasAnimation) {
          this._updateAnimation(data, stackedOnPoints, coordSys, api, step);
        } else {
          // Not do it in update with animation
          if (step) {
            // TODO If stacked series is not step
            points = turnPointsIntoStep(points, coordSys, step);
            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
          }

          polyline.setShape({
            points: points
          });
          polygon && polygon.setShape({
            points: points,
            stackedOnPoints: stackedOnPoints
          });
        }
      }
    }

    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
    lineStyleModel.getLineStyle(), {
      fill: 'none',
      stroke: visualColor,
      lineJoin: 'bevel'
    }));
    var smooth = seriesModel.get('smooth');
    smooth = getSmooth(seriesModel.get('smooth'));
    polyline.setShape({
      smooth: smooth,
      smoothMonotone: seriesModel.get('smoothMonotone'),
      connectNulls: seriesModel.get('connectNulls')
    });

    if (polygon) {
      var stackedOn = data.stackedOn;
      var stackedOnSmooth = 0;
      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
        fill: visualColor,
        opacity: 0.7,
        lineJoin: 'bevel'
      }));

      if (stackedOn) {
        var stackedOnSeries = stackedOn.hostModel;
        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
      }

      polygon.setShape({
        smooth: smooth,
        stackedOnSmooth: stackedOnSmooth,
        smoothMonotone: seriesModel.get('smoothMonotone'),
        connectNulls: seriesModel.get('connectNulls')
      });
    }

    this._data = data; // Save the coordinate system for transition animation when data changed

    this._coordSys = coordSys;
    this._stackedOnPoints = stackedOnPoints;
    this._points = points;
    this._step = step;
  },
  dispose: function () {},
  highlight: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (!symbol) {
        // Create a temporary symbol if it is not exists
        var pt = data.getItemLayout(dataIndex);

        if (!pt) {
          // Null data
          return;
        }

        symbol = new SymbolClz(data, dataIndex);
        symbol.position = pt;
        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
        symbol.__temp = true;
        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation

        symbol.stopSymbolAnimation(true);
        this.group.add(symbol);
      }

      symbol.highlight();
    } else {
      // Highlight whole series
      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    }
  },
  downplay: function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = modelUtil.queryDataIndex(data, payload);

    if (dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (symbol) {
        if (symbol.__temp) {
          data.setItemGraphicEl(dataIndex, null);
          this.group.remove(symbol);
        } else {
          symbol.downplay();
        }
      }
    } else {
      // FIXME
      // can not downplay completely.
      // Downplay whole series
      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    }
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolyline: function (points) {
    var polyline = this._polyline; // Remove previous created polyline

    if (polyline) {
      this._lineGroup.remove(polyline);
    }

    polyline = new Polyline({
      shape: {
        points: points
      },
      silent: true,
      z2: 10
    });

    this._lineGroup.add(polyline);

    this._polyline = polyline;
    return polyline;
  },

  /**
   * @param {module:zrender/container/Group} group
   * @param {Array.<Array.<number>>} stackedOnPoints
   * @param {Array.<Array.<number>>} points
   * @private
   */
  _newPolygon: function (points, stackedOnPoints) {
    var polygon = this._polygon; // Remove previous created polygon

    if (polygon) {
      this._lineGroup.remove(polygon);
    }

    polygon = new Polygon({
      shape: {
        points: points,
        stackedOnPoints: stackedOnPoints
      },
      silent: true
    });

    this._lineGroup.add(polygon);

    this._polygon = polygon;
    return polygon;
  },

  /**
   * @private
   */
  _getSymbolIgnoreFunc: function (data, coordSys) {
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0]; // `getLabelInterval` is provided by echarts/component/axis

    if (categoryAxis && categoryAxis.isLabelIgnored) {
      return zrUtil.bind(categoryAxis.isLabelIgnored, categoryAxis);
    }
  },

  /**
   * @private
   */
  // FIXME Two value axis
  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step) {
    var polyline = this._polyline;
    var polygon = this._polygon;
    var seriesModel = data.hostModel;
    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys);
    var current = diff.current;
    var stackedOnCurrent = diff.stackedOnCurrent;
    var next = diff.next;
    var stackedOnNext = diff.stackedOnNext;

    if (step) {
      // TODO If stacked series is not step
      current = turnPointsIntoStep(diff.current, coordSys, step);
      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
      next = turnPointsIntoStep(diff.next, coordSys, step);
      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
    } // `diff.current` is subset of `current` (which should be ensured by
    // turnPointsIntoStep), so points in `__points` can be updated when
    // points in `current` are update during animation.


    polyline.shape.__points = diff.current;
    polyline.shape.points = current;
    graphic.updateProps(polyline, {
      shape: {
        points: next
      }
    }, seriesModel);

    if (polygon) {
      polygon.setShape({
        points: current,
        stackedOnPoints: stackedOnCurrent
      });
      graphic.updateProps(polygon, {
        shape: {
          points: next,
          stackedOnPoints: stackedOnNext
        }
      }, seriesModel);
    }

    var updatedDataInfo = [];
    var diffStatus = diff.status;

    for (var i = 0; i < diffStatus.length; i++) {
      var cmd = diffStatus[i].cmd;

      if (cmd === '=') {
        var el = data.getItemGraphicEl(diffStatus[i].idx1);

        if (el) {
          updatedDataInfo.push({
            el: el,
            ptIdx: i // Index of points

          });
        }
      }
    }

    if (polyline.animators && polyline.animators.length) {
      polyline.animators[0].during(function () {
        for (var i = 0; i < updatedDataInfo.length; i++) {
          var el = updatedDataInfo[i].el;
          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
        }
      });
    }
  },
  remove: function (ecModel) {
    var group = this.group;
    var oldData = this._data;

    this._lineGroup.removeAll();

    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting


    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    });
    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
  }
});

module.exports = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// var arrayDiff = require('zrender/src/core/arrayDiff');
// 'zrender/src/core/arrayDiff' has been used before, but it did
// not do well in performance when roam with fixed dataZoom window.
function sign(val) {
  return val >= 0 ? 1 : -1;
}

function getStackedOnPoint(coordSys, data, idx) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = baseAxis.onZero ? 0 : valueAxis.scale.getExtent()[0];
  var valueDim = valueAxis.dim;
  var baseDataOffset = valueDim === 'x' || valueDim === 'radius' ? 1 : 0;
  var stackedOnSameSign;
  var stackedOn = data.stackedOn;
  var val = data.get(valueDim, idx); // Find first stacked value with same sign

  while (stackedOn && sign(stackedOn.get(valueDim, idx)) === sign(val)) {
    stackedOnSameSign = stackedOn;
    break;
  }

  var stackedData = [];
  stackedData[baseDataOffset] = data.get(baseAxis.dim, idx);
  stackedData[1 - baseDataOffset] = stackedOnSameSign ? stackedOnSameSign.get(valueDim, idx, true) : valueStart;
  return coordSys.dataToPoint(stackedData);
} // function convertToIntId(newIdList, oldIdList) {
//     // Generate int id instead of string id.
//     // Compare string maybe slow in score function of arrDiff
//     // Assume id in idList are all unique
//     var idIndicesMap = {};
//     var idx = 0;
//     for (var i = 0; i < newIdList.length; i++) {
//         idIndicesMap[newIdList[i]] = idx;
//         newIdList[i] = idx++;
//     }
//     for (var i = 0; i < oldIdList.length; i++) {
//         var oldId = oldIdList[i];
//         // Same with newIdList
//         if (idIndicesMap[oldId]) {
//             oldIdList[i] = idIndicesMap[oldId];
//         }
//         else {
//             oldIdList[i] = idx++;
//         }
//     }
// }


function diffData(oldData, newData) {
  var diffResult = [];
  newData.diff(oldData).add(function (idx) {
    diffResult.push({
      cmd: '+',
      idx: idx
    });
  }).update(function (newIdx, oldIdx) {
    diffResult.push({
      cmd: '=',
      idx: oldIdx,
      idx1: newIdx
    });
  }).remove(function (idx) {
    diffResult.push({
      cmd: '-',
      idx: idx
    });
  }).execute();
  return diffResult;
}

function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys) {
  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
  // var oldIdList = oldData.mapArray(oldData.getId);
  // convertToIntId(newIdList, oldIdList);
  // // FIXME One data ?
  // diff = arrayDiff(oldIdList, newIdList);

  var currPoints = [];
  var nextPoints = []; // Points for stacking base line

  var currStackedPoints = [];
  var nextStackedPoints = [];
  var status = [];
  var sortedIndices = [];
  var rawIndices = [];
  var dims = newCoordSys.dimensions;

  for (var i = 0; i < diff.length; i++) {
    var diffItem = diff[i];
    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
    // Which is in case remvoing or add more than one data in the tail or head

    switch (diffItem.cmd) {
      case '=':
        var currentPt = oldData.getItemLayout(diffItem.idx);
        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly

        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
          currentPt = nextPt.slice();
        }

        currPoints.push(currentPt);
        nextPoints.push(nextPt);
        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
        rawIndices.push(newData.getRawIndex(diffItem.idx1));
        break;

      case '+':
        var idx = diffItem.idx;
        currPoints.push(oldCoordSys.dataToPoint([newData.get(dims[0], idx, true), newData.get(dims[1], idx, true)]));
        nextPoints.push(newData.getItemLayout(idx).slice());
        currStackedPoints.push(getStackedOnPoint(oldCoordSys, newData, idx));
        nextStackedPoints.push(newStackedOnPoints[idx]);
        rawIndices.push(newData.getRawIndex(idx));
        break;

      case '-':
        var idx = diffItem.idx;
        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
        // FIXME FIXME FIXME

        if (rawIndex !== idx) {
          currPoints.push(oldData.getItemLayout(idx));
          nextPoints.push(newCoordSys.dataToPoint([oldData.get(dims[0], idx, true), oldData.get(dims[1], idx, true)]));
          currStackedPoints.push(oldStackedOnPoints[idx]);
          nextStackedPoints.push(getStackedOnPoint(newCoordSys, oldData, idx));
          rawIndices.push(rawIndex);
        } else {
          pointAdded = false;
        }

    } // Original indices


    if (pointAdded) {
      status.push(diffItem);
      sortedIndices.push(sortedIndices.length);
    }
  } // Diff result may be crossed if all items are changed
  // Sort by data index


  sortedIndices.sort(function (a, b) {
    return rawIndices[a] - rawIndices[b];
  });
  var sortedCurrPoints = [];
  var sortedNextPoints = [];
  var sortedCurrStackedPoints = [];
  var sortedNextStackedPoints = [];
  var sortedStatus = [];

  for (var i = 0; i < sortedIndices.length; i++) {
    var idx = sortedIndices[i];
    sortedCurrPoints[i] = currPoints[idx];
    sortedNextPoints[i] = nextPoints[idx];
    sortedCurrStackedPoints[i] = currStackedPoints[idx];
    sortedNextStackedPoints[i] = nextStackedPoints[idx];
    sortedStatus[i] = status[idx];
  }

  return {
    current: sortedCurrPoints,
    next: sortedNextPoints,
    stackedOnCurrent: sortedCurrStackedPoints,
    stackedOnNext: sortedNextStackedPoints,
    status: sortedStatus
  };
}

module.exports = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var vec2 = __webpack_require__(53);

var fixClipWithShadow = __webpack_require__(714);

// Poly path support NaN point
var vec2Min = vec2.min;
var vec2Max = vec2.max;
var scaleAndAdd = vec2.scaleAndAdd;
var v2Copy = vec2.copy; // Temporary variable

var v = [];
var cp0 = [];
var cp1 = [];

function isPointNull(p) {
  return isNaN(p[0]) || isNaN(p[1]);
}

function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
  var prevIdx = 0;
  var idx = start;

  for (var k = 0; k < segLen; k++) {
    var p = points[idx];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(p)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
      v2Copy(cp0, p);
    } else {
      if (smooth > 0) {
        var nextIdx = idx + dir;
        var nextP = points[nextIdx];

        if (connectNulls) {
          // Find next point not null
          while (nextP && isPointNull(points[nextIdx])) {
            nextIdx += dir;
            nextP = points[nextIdx];
          }
        }

        var ratioNextSeg = 0.5;
        var prevP = points[prevIdx];
        var nextP = points[nextIdx]; // Last point

        if (!nextP || isPointNull(nextP)) {
          v2Copy(cp1, p);
        } else {
          // If next data is null in not connect case
          if (isPointNull(nextP) && !connectNulls) {
            nextP = p;
          }

          vec2.sub(v, nextP, prevP);
          var lenPrevSeg;
          var lenNextSeg;

          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
            var dim = smoothMonotone === 'x' ? 0 : 1;
            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
          } else {
            lenPrevSeg = vec2.dist(p, prevP);
            lenNextSeg = vec2.dist(p, nextP);
          } // Use ratio of seg length


          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
        } // Smooth constraint


        vec2Min(cp0, cp0, smoothMax);
        vec2Max(cp0, cp0, smoothMin);
        vec2Min(cp1, cp1, smoothMax);
        vec2Max(cp1, cp1, smoothMin);
        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment

        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
      } else {
        ctx.lineTo(p[0], p[1]);
      }
    }

    prevIdx = idx;
    idx += dir;
  }

  return k;
}

function getBoundingBox(points, smoothConstraint) {
  var ptMin = [Infinity, Infinity];
  var ptMax = [-Infinity, -Infinity];

  if (smoothConstraint) {
    for (var i = 0; i < points.length; i++) {
      var pt = points[i];

      if (pt[0] < ptMin[0]) {
        ptMin[0] = pt[0];
      }

      if (pt[1] < ptMin[1]) {
        ptMin[1] = pt[1];
      }

      if (pt[0] > ptMax[0]) {
        ptMax[0] = pt[0];
      }

      if (pt[1] > ptMax[1]) {
        ptMax[1] = pt[1];
      }
    }
  }

  return {
    min: smoothConstraint ? ptMin : ptMax,
    max: smoothConstraint ? ptMax : ptMin
  };
}

var Polyline = Path.extend({
  type: 'ec-polyline',
  shape: {
    points: [],
    smooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  style: {
    fill: null,
    stroke: '#000'
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var i = 0;
    var len = points.length;
    var result = getBoundingBox(points, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
  }
});
var Polygon = Path.extend({
  type: 'ec-polygon',
  shape: {
    points: [],
    // Offset between stacked base points and points
    stackedOnPoints: [],
    smooth: 0,
    stackedOnSmooth: 0,
    smoothConstraint: true,
    smoothMonotone: null,
    connectNulls: false
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var points = shape.points;
    var stackedOnPoints = shape.stackedOnPoints;
    var i = 0;
    var len = points.length;
    var smoothMonotone = shape.smoothMonotone;
    var bbox = getBoundingBox(points, shape.smoothConstraint);
    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i])) {
          break;
        }
      }
    }

    while (i < len) {
      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
      i += k + 1;
      ctx.closePath();
    }
  }
});
exports.Polyline = Polyline;
exports.Polygon = Polygon;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var List = __webpack_require__(300);

var zrUtil = __webpack_require__(6);

var modelUtil = __webpack_require__(45);

var _number = __webpack_require__(48);

var getPercentWithPrecision = _number.getPercentWithPrecision;

var completeDimensions = __webpack_require__(301);

var dataSelectableMixin = __webpack_require__(1057);

var PieSeries = echarts.extendSeriesModel({
  type: 'series.pie',
  // Overwrite
  init: function (option) {
    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed

    this.legendDataProvider = function () {
      return this.getRawData();
    };

    this.updateSelectedMap(option.data);

    this._defaultLabelLine(option);
  },
  // Overwrite
  mergeOption: function (newOption) {
    PieSeries.superCall(this, 'mergeOption', newOption);
    this.updateSelectedMap(this.option.data);
  },
  getInitialData: function (option, ecModel) {
    var dimensions = completeDimensions(['value'], option.data);
    var list = new List(dimensions, this);
    list.initData(option.data);
    return list;
  },
  // Overwrite
  getDataParams: function (dataIndex) {
    var data = this.getData();
    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?

    var valueList = [];
    data.each('value', function (value) {
      valueList.push(value);
    });
    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
    params.$vars.push('percent');
    return params;
  },
  _defaultLabelLine: function (option) {
    // Extend labelLine emphasis
    modelUtil.defaultEmphasis(option.labelLine, ['show']);
    var labelLineNormalOpt = option.labelLine.normal;
    var labelLineEmphasisOpt = option.labelLine.emphasis; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.normal.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.label.emphasis.show;
  },
  defaultOption: {
    zlevel: 0,
    z: 2,
    legendHoverLink: true,
    hoverAnimation: true,
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // 选中时扇区偏移量
    selectedOffset: 10,
    // 高亮扇区偏移量
    hoverOffset: 10,
    // If use strategy to avoid label overlapping
    avoidLabelOverlap: true,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
    // roseType: null,
    percentPrecision: 2,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // cursor: null,
    label: {
      normal: {
        // If rotate around circle
        rotate: false,
        show: true,
        // 'outer', 'inside', 'center'
        position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
        // 默认使用全局文本样式，详见TEXTSTYLE
        // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数

      },
      emphasis: {}
    },
    // Enabled when label.normal.position is 'outer'
    labelLine: {
      normal: {
        show: true,
        // 引导线两段中的第一段长度
        length: 15,
        // 引导线两段中的第二段长度
        length2: 15,
        smooth: false,
        lineStyle: {
          // color: 各异,
          width: 1,
          type: 'solid'
        }
      }
    },
    itemStyle: {
      normal: {
        borderWidth: 1
      },
      emphasis: {}
    },
    // Animation type canbe expansion, scale
    animationType: 'expansion',
    animationEasing: 'cubicOut',
    data: []
  }
});
zrUtil.mixin(PieSeries, dataSelectableMixin);
var _default = PieSeries;
module.exports = _default;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

var ChartView = __webpack_require__(306);

/**
 * @param {module:echarts/model/Series} seriesModel
 * @param {boolean} hasAnimation
 * @inner
 */
function updateDataSelected(uid, seriesModel, hasAnimation, api) {
  var data = seriesModel.getData();
  var dataIndex = this.dataIndex;
  var name = data.getName(dataIndex);
  var selectedOffset = seriesModel.get('selectedOffset');
  api.dispatchAction({
    type: 'pieToggleSelect',
    from: uid,
    name: name,
    seriesId: seriesModel.id
  });
  data.each(function (idx) {
    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
  });
}
/**
 * @param {module:zrender/graphic/Sector} el
 * @param {Object} layout
 * @param {boolean} isSelected
 * @param {number} selectedOffset
 * @param {boolean} hasAnimation
 * @inner
 */


function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
  var midAngle = (layout.startAngle + layout.endAngle) / 2;
  var dx = Math.cos(midAngle);
  var dy = Math.sin(midAngle);
  var offset = isSelected ? selectedOffset : 0;
  var position = [dx * offset, dy * offset];
  hasAnimation // animateTo will stop revious animation like update transition
  ? el.animate().when(200, {
    position: position
  }).start('bounceOut') : el.attr('position', position);
}
/**
 * Piece of pie including Sector, Label, LabelLine
 * @constructor
 * @extends {module:zrender/graphic/Group}
 */


function PiePiece(data, idx) {
  graphic.Group.call(this);
  var sector = new graphic.Sector({
    z2: 2
  });
  var polyline = new graphic.Polyline();
  var text = new graphic.Text();
  this.add(sector);
  this.add(polyline);
  this.add(text);
  this.updateData(data, idx, true); // Hover to change label and labelLine

  function onEmphasis() {
    polyline.ignore = polyline.hoverIgnore;
    text.ignore = text.hoverIgnore;
  }

  function onNormal() {
    polyline.ignore = polyline.normalIgnore;
    text.ignore = text.normalIgnore;
  }

  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
}

var piePieceProto = PiePiece.prototype;

piePieceProto.updateData = function (data, idx, firstCreate) {
  var sector = this.childAt(0);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var sectorShape = zrUtil.extend({}, layout);
  sectorShape.label = null;

  if (firstCreate) {
    sector.setShape(sectorShape);
    var animationType = seriesModel.getShallow('animationType');

    if (animationType === 'scale') {
      sector.shape.r = layout.r0;
      graphic.initProps(sector, {
        shape: {
          r: layout.r
        }
      }, seriesModel, idx);
    } // Expansion
    else {
        sector.shape.endAngle = layout.startAngle;
        graphic.updateProps(sector, {
          shape: {
            endAngle: layout.endAngle
          }
        }, seriesModel, idx);
      }
  } else {
    graphic.updateProps(sector, {
      shape: sectorShape
    }, seriesModel, idx);
  } // Update common style


  var itemStyleModel = itemModel.getModel('itemStyle');
  var visualColor = data.getItemVisual(idx, 'color');
  sector.useStyle(zrUtil.defaults({
    lineJoin: 'bevel',
    fill: visualColor
  }, itemStyleModel.getModel('normal').getItemStyle()));
  sector.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected

  toggleItemSelected(this, data.getItemLayout(idx), itemModel.get('selected'), seriesModel.get('selectedOffset'), seriesModel.get('animation'));

  function onEmphasis() {
    // Sector may has animation of updating data. Force to move to the last frame
    // Or it may stopped on the wrong shape
    sector.stopAnimation(true);
    sector.animateTo({
      shape: {
        r: layout.r + seriesModel.get('hoverOffset')
      }
    }, 300, 'elasticOut');
  }

  function onNormal() {
    sector.stopAnimation(true);
    sector.animateTo({
      shape: {
        r: layout.r
      }
    }, 300, 'elasticOut');
  }

  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');

  if (itemModel.get('hoverAnimation') && seriesModel.isAnimationEnabled()) {
    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
  }

  this._updateLabel(data, idx);

  graphic.setHoverStyle(this);
};

piePieceProto._updateLabel = function (data, idx) {
  var labelLine = this.childAt(1);
  var labelText = this.childAt(2);
  var seriesModel = data.hostModel;
  var itemModel = data.getItemModel(idx);
  var layout = data.getItemLayout(idx);
  var labelLayout = layout.label;
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.updateProps(labelLine, {
    shape: {
      points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
    }
  }, seriesModel, idx);
  graphic.updateProps(labelText, {
    style: {
      x: labelLayout.x,
      y: labelLayout.y
    }
  }, seriesModel, idx);
  labelText.attr({
    rotation: labelLayout.rotation,
    origin: [labelLayout.x, labelLayout.y],
    z2: 10
  });
  var labelModel = itemModel.getModel('label.normal');
  var labelHoverModel = itemModel.getModel('label.emphasis');
  var labelLineModel = itemModel.getModel('labelLine.normal');
  var labelLineHoverModel = itemModel.getModel('labelLine.emphasis');
  var visualColor = data.getItemVisual(idx, 'color');
  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
    labelFetcher: data.hostModel,
    labelDataIndex: idx,
    defaultText: data.getName(idx),
    autoColor: visualColor,
    useInsideStyle: !!labelLayout.inside
  }, {
    textAlign: labelLayout.textAlign,
    textVerticalAlign: labelLayout.verticalAlign,
    opacity: data.getItemVisual(idx, 'opacity')
  });
  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
  labelText.hoverIgnore = !labelHoverModel.get('show');
  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color

  labelLine.setStyle({
    stroke: visualColor,
    opacity: data.getItemVisual(idx, 'opacity')
  });
  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
  var smooth = labelLineModel.get('smooth');

  if (smooth && smooth === true) {
    smooth = 0.4;
  }

  labelLine.setShape({
    smooth: smooth
  });
};

zrUtil.inherits(PiePiece, graphic.Group); // Pie view

var PieView = ChartView.extend({
  type: 'pie',
  init: function () {
    var sectorGroup = new graphic.Group();
    this._sectorGroup = sectorGroup;
  },
  render: function (seriesModel, ecModel, api, payload) {
    if (payload && payload.from === this.uid) {
      return;
    }

    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var hasAnimation = ecModel.get('animation');
    var isFirstRender = !oldData;
    var animationType = seriesModel.get('animationType');
    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
    var selectedMode = seriesModel.get('selectedMode');
    data.diff(oldData).add(function (idx) {
      var piePiece = new PiePiece(data, idx); // Default expansion animation

      if (isFirstRender && animationType !== 'scale') {
        piePiece.eachChild(function (child) {
          child.stopAnimation(true);
        });
      }

      selectedMode && piePiece.on('click', onSectorClick);
      data.setItemGraphicEl(idx, piePiece);
      group.add(piePiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);
      piePiece.updateData(data, newIdx);
      piePiece.off('click');
      selectedMode && piePiece.on('click', onSectorClick);
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      group.remove(piePiece);
    }).execute();

    if (hasAnimation && isFirstRender && data.count() > 0 // Default expansion animation
    && animationType !== 'scale') {
      var shape = data.getItemLayout(0);
      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel));
    }

    this._data = data;
  },
  dispose: function () {},
  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel) {
    var clipPath = new graphic.Sector({
      shape: {
        cx: cx,
        cy: cy,
        r0: 0,
        r: r,
        startAngle: startAngle,
        endAngle: startAngle,
        clockwise: clockwise
      }
    });
    graphic.initProps(clipPath, {
      shape: {
        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
      }
    }, seriesModel, cb);
    return clipPath;
  },

  /**
   * @implement
   */
  containPoint: function (point, seriesModel) {
    var data = seriesModel.getData();
    var itemLayout = data.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  }
});
var _default = PieView;
module.exports = _default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var textContain = __webpack_require__(112);

// FIXME emphasis label position is not same with normal label position
function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight) {
  list.sort(function (a, b) {
    return a.y - b.y;
  }); // 压

  function shiftDown(start, end, delta, dir) {
    for (var j = start; j < end; j++) {
      list[j].y += delta;

      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
        shiftUp(j, delta / 2);
        return;
      }
    }

    shiftUp(end - 1, delta / 2);
  } // 弹


  function shiftUp(end, delta) {
    for (var j = end; j >= 0; j--) {
      list[j].y -= delta;

      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
        break;
      }
    }
  }

  function changeX(list, isDownList, cx, cy, r, dir) {
    var lastDeltaX = dir > 0 ? isDownList // 右侧
    ? Number.MAX_VALUE // 下
    : 0 // 上
    : isDownList // 左侧
    ? Number.MAX_VALUE // 下
    : 0; // 上

    for (var i = 0, l = list.length; i < l; i++) {
      // Not change x for center label
      if (list[i].position === 'center') {
        continue;
      }

      var deltaY = Math.abs(list[i].y - cy);
      var length = list[i].len;
      var length2 = list[i].len2;
      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);

      if (isDownList && deltaX >= lastDeltaX) {
        // 右下，左下
        deltaX = lastDeltaX - 10;
      }

      if (!isDownList && deltaX <= lastDeltaX) {
        // 右上，左上
        deltaX = lastDeltaX + 10;
      }

      list[i].x = cx + deltaX * dir;
      lastDeltaX = deltaX;
    }
  }

  var lastY = 0;
  var delta;
  var len = list.length;
  var upList = [];
  var downList = [];

  for (var i = 0; i < len; i++) {
    delta = list[i].y - lastY;

    if (delta < 0) {
      shiftDown(i, len, -delta, dir);
    }

    lastY = list[i].y + list[i].height;
  }

  if (viewHeight - lastY < 0) {
    shiftUp(len - 1, lastY - viewHeight);
  }

  for (var i = 0; i < len; i++) {
    if (list[i].y >= cy) {
      downList.push(list[i]);
    } else {
      upList.push(list[i]);
    }
  }

  changeX(upList, false, cx, cy, r, dir);
  changeX(downList, true, cx, cy, r, dir);
}

function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight) {
  var leftList = [];
  var rightList = [];

  for (var i = 0; i < labelLayoutList.length; i++) {
    if (labelLayoutList[i].x < cx) {
      leftList.push(labelLayoutList[i]);
    } else {
      rightList.push(labelLayoutList[i]);
    }
  }

  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight);
  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight);

  for (var i = 0; i < labelLayoutList.length; i++) {
    var linePoints = labelLayoutList[i].linePoints;

    if (linePoints) {
      var dist = linePoints[1][0] - linePoints[2][0];

      if (labelLayoutList[i].x < cx) {
        linePoints[2][0] = labelLayoutList[i].x + 3;
      } else {
        linePoints[2][0] = labelLayoutList[i].x - 3;
      }

      linePoints[1][1] = linePoints[2][1] = labelLayoutList[i].y;
      linePoints[1][0] = linePoints[2][0] + dist;
    }
  }
}

function _default(seriesModel, r, viewWidth, viewHeight) {
  var data = seriesModel.getData();
  var labelLayoutList = [];
  var cx;
  var cy;
  var hasLabelRotate = false;
  data.each(function (idx) {
    var layout = data.getItemLayout(idx);
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label.normal'); // Use position in normal or emphasis

    var labelPosition = labelModel.get('position') || itemModel.get('label.emphasis.position');
    var labelLineModel = itemModel.getModel('labelLine.normal');
    var labelLineLen = labelLineModel.get('length');
    var labelLineLen2 = labelLineModel.get('length2');
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var textX;
    var textY;
    var linePoints;
    var textAlign;
    cx = layout.cx;
    cy = layout.cy;
    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';

    if (labelPosition === 'center') {
      textX = layout.cx;
      textY = layout.cy;
      textAlign = 'center';
    } else {
      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
      textX = x1 + dx * 3;
      textY = y1 + dy * 3;

      if (!isLabelInside) {
        // For roseType
        var x2 = x1 + dx * (labelLineLen + r - layout.r);
        var y2 = y1 + dy * (labelLineLen + r - layout.r);
        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
        var y3 = y2;
        textX = x3 + (dx < 0 ? -5 : 5);
        textY = y3;
        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
      }

      textAlign = isLabelInside ? 'center' : dx > 0 ? 'left' : 'right';
    }

    var font = labelModel.getFont();
    var labelRotate = labelModel.get('rotate') ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
    hasLabelRotate = !!labelRotate;
    layout.label = {
      x: textX,
      y: textY,
      position: labelPosition,
      height: textRect.height,
      len: labelLineLen,
      len2: labelLineLen2,
      linePoints: linePoints,
      textAlign: textAlign,
      verticalAlign: 'middle',
      rotation: labelRotate,
      inside: isLabelInside
    }; // Not layout the inside label

    if (!isLabelInside) {
      labelLayoutList.push(layout.label);
    }
  });

  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight);
  }
}

module.exports = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var _number = __webpack_require__(48);

var parsePercent = _number.parsePercent;
var linearMap = _number.linearMap;

var labelLayout = __webpack_require__(1046);

var zrUtil = __webpack_require__(6);

var PI2 = Math.PI * 2;
var RADIAN = Math.PI / 180;

function _default(seriesType, ecModel, api, payload) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');

    if (!zrUtil.isArray(radius)) {
      radius = [0, radius];
    }

    if (!zrUtil.isArray(center)) {
      center = [center, center];
    }

    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = parsePercent(center[0], width);
    var cy = parsePercent(center[1], height);
    var r0 = parsePercent(radius[0], size / 2);
    var r = parsePercent(radius[1], size / 2);
    var data = seriesModel.getData();
    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var validDataCount = 0;
    data.each('value', function (value) {
      !isNaN(value) && validDataCount++;
    });
    var sum = data.getSum('value'); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var clockwise = seriesModel.get('clockwise');
    var roseType = seriesModel.get('roseType');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]

    var extent = data.getDataExtent('value');
    extent[0] = 0; // In the case some sector angle is smaller than minAngle

    var restAngle = PI2;
    var valueSumLargerThanMinAngle = 0;
    var currentAngle = startAngle;
    var dir = clockwise ? 1 : -1;
    data.each('value', function (value, idx) {
      var angle;

      if (isNaN(value)) {
        data.setItemLayout(idx, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: r0,
          r: roseType ? NaN : r
        });
        return;
      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？


      if (roseType !== 'area') {
        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
      } else {
        angle = PI2 / validDataCount;
      }

      if (angle < minAngle) {
        angle = minAngle;
        restAngle -= minAngle;
      } else {
        valueSumLargerThanMinAngle += value;
      }

      var endAngle = currentAngle + dir * angle;
      data.setItemLayout(idx, {
        angle: angle,
        startAngle: currentAngle,
        endAngle: endAngle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: r0,
        r: roseType ? linearMap(value, extent, [r0, r]) : r
      });
      currentAngle = endAngle;
    }, true); // Some sector is constrained by minAngle
    // Rest sectors needs recalculate angle

    if (restAngle < PI2 && validDataCount) {
      // Average the angle if rest angle is not enough after all angles is
      // Constrained by minAngle
      if (restAngle <= 1e-3) {
        var angle = PI2 / validDataCount;
        data.each('value', function (value, idx) {
          if (!isNaN(value)) {
            var layout = data.getItemLayout(idx);
            layout.angle = angle;
            layout.startAngle = startAngle + dir * idx * angle;
            layout.endAngle = startAngle + dir * (idx + 1) * angle;
          }
        });
      } else {
        unitRadian = restAngle / valueSumLargerThanMinAngle;
        currentAngle = startAngle;
        data.each('value', function (value, idx) {
          if (!isNaN(value)) {
            var layout = data.getItemLayout(idx);
            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
            layout.startAngle = currentAngle;
            layout.endAngle = currentAngle + dir * angle;
            currentAngle += dir * angle;
          }
        });
      }
    }

    labelLayout(seriesModel, r, width, height);
  });
}

module.exports = _default;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(474);

__webpack_require__(1049);

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

var AxisBuilder = __webpack_require__(465);

var AxisView = __webpack_require__(466);

var cartesianAxisHelper = __webpack_require__(467);

var ifIgnoreOnTick = AxisBuilder.ifIgnoreOnTick;
var getInterval = AxisBuilder.getInterval;
var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine']; // function getAlignWithLabel(model, axisModel) {
//     var alignWithLabel = model.get('alignWithLabel');
//     if (alignWithLabel === 'auto') {
//         alignWithLabel = axisModel.get('axisTick.alignWithLabel');
//     }
//     return alignWithLabel;
// }

var CartesianAxisView = AxisView.extend({
  type: 'cartesianAxis',
  axisPointerClass: 'CartesianAxisPointer',

  /**
   * @override
   */
  render: function (axisModel, ecModel, api, payload) {
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new graphic.Group();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var gridModel = axisModel.getCoordSysModel();
    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    zrUtil.each(selfBuilderAttrs, function (name) {
      if (axisModel.get(name + '.show')) {
        this['_' + name](axisModel, gridModel, layout.labelInterval);
      }
    }, this);
    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @param {number|Function} labelInterval
   * @private
   */
  _splitLine: function (axisModel, gridModel, labelInterval) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineInterval = getInterval(splitLineModel, labelInterval);
    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords();
    var ticks = axis.scale.getTicks();
    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');
    var p1 = [];
    var p2 = []; // Simple optimization
    // Batching the lines if color are the same

    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < ticksCoords.length; i++) {
      if (ifIgnoreOnTick(axis, i, lineInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
        continue;
      }

      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;

      this._axisGroup.add(new graphic.Line(graphic.subPixelOptimizeLine({
        anid: 'line_' + ticks[i],
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: zrUtil.defaults({
          stroke: lineColors[colorIndex]
        }, lineStyle),
        silent: true
      })));
    }
  },

  /**
   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
   * @param {module:echarts/coord/cartesian/GridModel} gridModel
   * @param {number|Function} labelInterval
   * @private
   */
  _splitArea: function (axisModel, gridModel, labelInterval) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords();
    var ticks = axis.scale.getTicks();
    var prevX = axis.toGlobalCoord(ticksCoords[0]);
    var prevY = axis.toGlobalCoord(ticksCoords[0]);
    var count = 0;
    var areaInterval = getInterval(splitAreaModel, labelInterval);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
    var showMinLabel = axisModel.get('axisLabel.showMinLabel');
    var showMaxLabel = axisModel.get('axisLabel.showMaxLabel');

    for (var i = 1; i < ticksCoords.length; i++) {
      if (ifIgnoreOnTick(axis, i, areaInterval, ticksCoords.length, showMinLabel, showMaxLabel)) {
        continue;
      }

      var tickCoord = axis.toGlobalCoord(ticksCoords[i]);
      var x;
      var y;
      var width;
      var height;

      if (axis.isHorizontal()) {
        x = prevX;
        y = gridRect.y;
        width = tickCoord - x;
        height = gridRect.height;
      } else {
        x = gridRect.x;
        y = prevY;
        width = gridRect.width;
        height = tickCoord - y;
      }

      var colorIndex = count++ % areaColors.length;

      this._axisGroup.add(new graphic.Rect({
        anid: 'area_' + ticks[i],
        shape: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        style: zrUtil.defaults({
          fill: areaColors[colorIndex]
        }, areaStyle),
        silent: true
      }));

      prevX = x + width;
      prevY = y + height;
    }
  }
});
CartesianAxisView.extend({
  type: 'xAxis'
});
CartesianAxisView.extend({
  type: 'yAxis'
});

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var axisPointerModelHelper = __webpack_require__(208);

var axisTrigger = __webpack_require__(1055);

__webpack_require__(1051);

__webpack_require__(1052);

__webpack_require__(1054);

// CartesianAxisPointer is not supposed to be required here. But consider
// echarts.simple.js and online build tooltip, which only require gridSimple,
// CartesianAxisPointer should be able to required somewhere.
echarts.registerPreprocessor(function (option) {
  // Always has a global axisPointerModel for default setting.
  if (option) {
    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
    // is not set, remain null/undefined, otherwise it will
    // override existent link setting.

    if (link && !zrUtil.isArray(link)) {
      option.axisPointer.link = [link];
    }
  }
}); // This process should proformed after coordinate systems created
// and series data processed. So put it on statistic processing stage.

echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
  // allAxesInfo should be updated when setOption performed.
  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
}); // Broadcast to all views.

echarts.registerAction({
  type: 'updateAxisPointer',
  event: 'updateAxisPointer',
  update: ':updateAxisPointer'
}, axisTrigger);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var AxisPointerModel = echarts.extendComponentModel({
  type: 'axisPointer',
  coordSysAxesInfo: null,
  defaultOption: {
    // 'auto' means that show when triggered by tooltip or handle.
    show: 'auto',
    // 'click' | 'mousemove' | 'none'
    triggerOn: null,
    // set default in AxisPonterView.js
    zlevel: 0,
    z: 50,
    type: 'line',
    // axispointer triggered by tootip determine snap automatically,
    // see `modelHelper`.
    snap: false,
    triggerTooltip: true,
    value: null,
    status: null,
    // Init value depends on whether handle is used.
    // [group0, group1, ...]
    // Each group can be: {
    //      mapper: function () {},
    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
    //      xAxisId: ...,
    //      yAxisName: ...,
    //      angleAxisIndex: ...
    // }
    // mapper: can be ignored.
    //      input: {axisInfo, value}
    //      output: {axisInfo, value}
    link: [],
    // Do not set 'auto' here, otherwise global animation: false
    // will not effect at this axispointer.
    animation: null,
    animationDurationUpdate: 200,
    lineStyle: {
      color: '#aaa',
      width: 1,
      type: 'solid'
    },
    shadowStyle: {
      color: 'rgba(150,150,150,0.3)'
    },
    label: {
      show: true,
      formatter: null,
      // string | Function
      precision: 'auto',
      // Or a number like 0, 1, 2 ...
      margin: 3,
      color: '#fff',
      padding: [5, 7, 5, 7],
      backgroundColor: 'auto',
      // default: axis line color
      borderColor: null,
      borderWidth: 0,
      shadowBlur: 3,
      shadowColor: '#aaa' // Considering applicability, common style should
      // better not have shadowOffset.
      // shadowOffsetX: 0,
      // shadowOffsetY: 2

    },
    handle: {
      show: false,
      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
      // jshint ignore:line
      size: 45,
      // handle margin is from symbol center to axis, which is stable when circular move.
      margin: 50,
      // color: '#1b8bbd'
      // color: '#2f4554'
      color: '#333',
      shadowBlur: 3,
      shadowColor: '#aaa',
      shadowOffsetX: 0,
      shadowOffsetY: 2,
      // For mobile performance
      throttle: 40
    }
  }
});
var _default = AxisPointerModel;
module.exports = _default;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var globalListener = __webpack_require__(469);

var AxisPointerView = echarts.extendComponentView({
  type: 'axisPointer',
  render: function (globalAxisPointerModel, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
    // AxisPointerView to be independent to Tooltip.

    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
        dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: currTrigger,
          x: e && e.offsetX,
          y: e && e.offsetY
        });
      }
    });
  },

  /**
   * @override
   */
  remove: function (ecModel, api) {
    globalListener.unregister(api.getZr(), 'axisPointer');
    AxisPointerView.superApply(this._model, 'remove', arguments);
  },

  /**
   * @override
   */
  dispose: function (ecModel, api) {
    globalListener.unregister('axisPointer', api);
    AxisPointerView.superApply(this._model, 'dispose', arguments);
  }
});
var _default = AxisPointerView;
module.exports = _default;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var clazzUtil = __webpack_require__(92);

var graphic = __webpack_require__(34);

var axisPointerModelHelper = __webpack_require__(208);

var eventTool = __webpack_require__(193);

var throttleUtil = __webpack_require__(305);

var modelUtil = __webpack_require__(45);

var get = modelUtil.makeGetter();
var clone = zrUtil.clone;
var bind = zrUtil.bind;
/**
 * Base axis pointer class in 2D.
 * Implemenents {module:echarts/component/axis/IAxisPointer}.
 */

function BaseAxisPointer() {}

BaseAxisPointer.prototype = {
  /**
   * @private
   */
  _group: null,

  /**
   * @private
   */
  _lastGraphicKey: null,

  /**
   * @private
   */
  _handle: null,

  /**
   * @private
   */
  _dragging: false,

  /**
   * @private
   */
  _lastValue: null,

  /**
   * @private
   */
  _lastStatus: null,

  /**
   * @private
   */
  _payloadInfo: null,

  /**
   * In px, arbitrary value. Do not set too small,
   * no animation is ok for most cases.
   * @protected
   */
  animationThreshold: 15,

  /**
   * @implement
   */
  render: function (axisModel, axisPointerModel, api, forceRender) {
    var value = axisPointerModel.get('value');
    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
    // be replaced when user calling setOption in not merge mode.

    this._axisModel = axisModel;
    this._axisPointerModel = axisPointerModel;
    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
    // So it is power consuming if performing `render` each time,
    // especially on mobile device.

    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
      return;
    }

    this._lastValue = value;
    this._lastStatus = status;
    var group = this._group;
    var handle = this._handle;

    if (!status || status === 'hide') {
      // Do not clear here, for animation better.
      group && group.hide();
      handle && handle.hide();
      return;
    }

    group && group.show();
    handle && handle.show(); // Otherwise status is 'show'

    var elOption = {};
    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.

    var graphicKey = elOption.graphicKey;

    if (graphicKey !== this._lastGraphicKey) {
      this.clear(api);
    }

    this._lastGraphicKey = graphicKey;
    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);

    if (!group) {
      group = this._group = new graphic.Group();
      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
      api.getZr().add(group);
    } else {
      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
    }

    updateMandatoryProps(group, axisPointerModel, true);

    this._renderHandle(value);
  },

  /**
   * @implement
   */
  remove: function (api) {
    this.clear(api);
  },

  /**
   * @implement
   */
  dispose: function (api) {
    this.clear(api);
  },

  /**
   * @protected
   */
  determineAnimation: function (axisModel, axisPointerModel) {
    var animation = axisPointerModel.get('animation');
    var axis = axisModel.axis;
    var isCategoryAxis = axis.type === 'category';
    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.

    if (!useSnap && !isCategoryAxis) {
      return false;
    }

    if (animation === 'auto' || animation == null) {
      var animationThreshold = this.animationThreshold;

      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
        return true;
      } // It is important to auto animation when snap used. Consider if there is
      // a dataZoom, animation will be disabled when too many points exist, while
      // it will be enabled for better visual effect when little points exist.


      if (useSnap) {
        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
        var axisExtent = axis.getExtent(); // Approximate band width

        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
      }

      return false;
    }

    return animation === true;
  },

  /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
  },

  /**
   * @protected
   */
  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
    var pointerOption = elOption.pointer;

    if (pointerOption) {
      var pointerEl = get(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
      group.add(pointerEl);
    }
  },

  /**
   * @protected
   */
  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
    if (elOption.label) {
      var labelEl = get(group).labelEl = new graphic.Rect(clone(elOption.label));
      group.add(labelEl);
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @protected
   */
  updatePointerEl: function (group, elOption, updateProps) {
    var pointerEl = get(group).pointerEl;

    if (pointerEl) {
      pointerEl.setStyle(elOption.pointer.style);
      updateProps(pointerEl, {
        shape: elOption.pointer.shape
      });
    }
  },

  /**
   * @protected
   */
  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
    var labelEl = get(group).labelEl;

    if (labelEl) {
      labelEl.setStyle(elOption.label.style);
      updateProps(labelEl, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        shape: elOption.label.shape,
        position: elOption.label.position
      });
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  },

  /**
   * @private
   */
  _renderHandle: function (value) {
    if (this._dragging || !this.updateHandleTransform) {
      return;
    }

    var axisPointerModel = this._axisPointerModel;

    var zr = this._api.getZr();

    var handle = this._handle;
    var handleModel = axisPointerModel.getModel('handle');
    var status = axisPointerModel.get('status');

    if (!handleModel.get('show') || !status || status === 'hide') {
      handle && zr.remove(handle);
      this._handle = null;
      return;
    }

    var isInit;

    if (!this._handle) {
      isInit = true;
      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
        cursor: 'move',
        draggable: true,
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          eventTool.stop(e.event);
        },
        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
        drift: bind(this._onHandleDragMove, this),
        ondragend: bind(this._onHandleDragEnd, this)
      });
      zr.add(handle);
    }

    updateMandatoryProps(handle, axisPointerModel, false); // update style

    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position

    var handleSize = handleModel.get('size');

    if (!zrUtil.isArray(handleSize)) {
      handleSize = [handleSize, handleSize];
    }

    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');

    this._moveHandleToValue(value, isInit);
  },

  /**
   * @private
   */
  _moveHandleToValue: function (value, isInit) {
    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
  },

  /**
   * @private
   */
  _onHandleDragMove: function (dx, dy) {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    this._dragging = true; // Persistent for throttle.

    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
    this._payloadInfo = trans;
    handle.stopAnimation();
    handle.attr(getHandleTransProps(trans));
    get(handle).lastProp = null;

    this._doDispatchAxisPointer();
  },

  /**
   * Throttled method.
   * @private
   */
  _doDispatchAxisPointer: function () {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var payloadInfo = this._payloadInfo;
    var axisModel = this._axisModel;

    this._api.dispatchAction({
      type: 'updateAxisPointer',
      x: payloadInfo.cursorPoint[0],
      y: payloadInfo.cursorPoint[1],
      tooltipOption: payloadInfo.tooltipOption,
      axesInfo: [{
        axisDim: axisModel.axis.dim,
        axisIndex: axisModel.componentIndex
      }]
    });
  },

  /**
   * @private
   */
  _onHandleDragEnd: function (moveAnimation) {
    this._dragging = false;
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
    // axisPointer. So move handle to align the exact value position when
    // drag ended.


    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
    // button, and will be hidden after finger left handle button.


    this._api.dispatchAction({
      type: 'hideTip'
    });
  },

  /**
   * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {number} value
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0}
   */
  getHandleTransform: null,

  /**
   * * Should be implemenented by sub-class if support `handle`.
   * @protected
   * @param {Object} transform {position, rotation}
   * @param {Array.<number>} delta [dx, dy]
   * @param {module:echarts/model/Model} axisModel
   * @param {module:echarts/model/Model} axisPointerModel
   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
   */
  updateHandleTransform: null,

  /**
   * @private
   */
  clear: function (api) {
    this._lastValue = null;
    this._lastStatus = null;
    var zr = api.getZr();
    var group = this._group;
    var handle = this._handle;

    if (zr && group) {
      this._lastGraphicKey = null;
      group && zr.remove(group);
      handle && zr.remove(handle);
      this._group = null;
      this._handle = null;
      this._payloadInfo = null;
    }
  },

  /**
   * @protected
   */
  doClear: function () {// Implemented by sub-class if necessary.
  },

  /**
   * @protected
   * @param {Array.<number>} xy
   * @param {Array.<number>} wh
   * @param {number} [xDimIndex=0] or 1
   */
  buildLabel: function (xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
      x: xy[xDimIndex],
      y: xy[1 - xDimIndex],
      width: wh[xDimIndex],
      height: wh[1 - xDimIndex]
    };
  }
};
BaseAxisPointer.prototype.constructor = BaseAxisPointer;

function updateProps(animationModel, moveAnimation, el, props) {
  // Animation optimize.
  if (!propsEqual(get(el).lastProp, props)) {
    get(el).lastProp = props;
    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
  }
}

function propsEqual(lastProps, newProps) {
  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
    var equals = true;
    zrUtil.each(newProps, function (item, key) {
      equals = equals && propsEqual(lastProps[key], item);
    });
    return !!equals;
  } else {
    return lastProps === newProps;
  }
}

function updateLabelShowHide(labelEl, axisPointerModel) {
  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
}

function getHandleTransProps(trans) {
  return {
    position: trans.position.slice(),
    rotation: trans.rotation || 0
  };
}

function updateMandatoryProps(group, axisPointerModel, silent) {
  var z = axisPointerModel.get('z');
  var zlevel = axisPointerModel.get('zlevel');
  group && group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
      el.silent = silent;
    }
  });
}

clazzUtil.enableClassExtend(BaseAxisPointer);
var _default = BaseAxisPointer;
module.exports = _default;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var graphic = __webpack_require__(34);

var BaseAxisPointer = __webpack_require__(1053);

var viewHelper = __webpack_require__(470);

var cartesianAxisHelper = __webpack_require__(467);

var AxisView = __webpack_require__(466);

var CartesianAxisPointer = BaseAxisPointer.extend({
  /**
   * @override
   */
  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisPointerType = axisPointerModel.get('type');
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = viewHelper.buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent, elStyle);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  },

  /**
   * @override
   */
  getHandleTransform: function (value, axisModel, axisPointerModel) {
    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
      labelInside: false
    });
    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
    return {
      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  },

  /**
   * @override
   */
  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisExtent = axis.getGlobalExtent(true);
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var dimIndex = axis.dim === 'x' ? 0 : 1;
    var currPosition = transform.position;
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.

    var tooltipOptions = [{
      verticalAlign: 'middle'
    }, {
      align: 'center'
    }];
    return {
      position: currPosition,
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: tooltipOptions[dimIndex]
    };
  }
});

function getCartesian(grid, axis) {
  var opt = {};
  opt[axis.dim + 'AxisIndex'] = axis.index;
  return grid.getCartesian(opt);
}

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent, elStyle) {
    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
    graphic.subPixelOptimizeLine({
      shape: targetShape,
      style: elStyle
    });
    return {
      type: 'Line',
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent, elStyle) {
    var bandWidth = axis.getBandWidth();
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
    };
  }
};

function getAxisDimIndex(axis) {
  return axis.dim === 'x' ? 0 : 1;
}

AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
var _default = CartesianAxisPointer;
module.exports = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var modelUtil = __webpack_require__(45);

var modelHelper = __webpack_require__(208);

var findPointFromSeries = __webpack_require__(468);

var each = zrUtil.each;
var curry = zrUtil.curry;
var get = modelUtil.makeGetter();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @param {Object} coordSysAxesInfo
 * @param {Object} payload
 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
 *              trigger axisPointer and tooltip.
 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
 * @param {Object} [payload.dataIndex] finder, restrict target axes.
 * @param {Object} [payload.axesInfo] finder, restrict target axes.
 *        [{
 *          axisDim: 'x'|'y'|'angle'|...,
 *          axisIndex: ...,
 *          value: ...
 *        }, ...]
 * @param {Function} [payload.dispatchAction]
 * @param {Object} [payload.tooltipOption]
 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
 *        which can be specified in dispatchAction
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 * @return {Object} content of event obj for echarts.connect.
 */

function _default(payload, ecModel, api) {
  var currTrigger = payload.currTrigger;
  var point = [payload.x, payload.y];
  var finder = payload;
  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
  // See #6121. But we are not able to reproduce it yet.

  if (!coordSysAxesInfo) {
    return;
  }

  if (illegalPoint(point)) {
    // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = findPointFromSeries({
      seriesIndex: finder.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: finder.dataIndex
    }, ecModel).point;
  }

  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
  // and dataIndex.

  var inputAxesInfo = finder.axesInfo;
  var axesInfo = coordSysAxesInfo.axesInfo;
  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
  var outputFinder = {};
  var showValueMap = {};
  var dataByCoordSys = {
    list: [],
    map: {}
  };
  var updaters = {
    showPointer: curry(showPointer, showValueMap),
    showTooltip: curry(showTooltip, dataByCoordSys)
  }; // Process for triggered axes.

  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
    // If a point given, it must be contained by the coordinate system.
    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
      var axis = axisInfo.axis;
      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.

      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
        var val = inputAxisInfo && inputAxisInfo.value;

        if (val == null && !isIllegalPoint) {
          val = axis.pointToData(point);
        }

        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
      }
    });
  }); // Process for linked axes.

  var linkTriggers = {};
  each(axesInfo, function (tarAxisInfo, tarKey) {
    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.

    if (linkGroup && !showValueMap[tarKey]) {
      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.

        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
          var val = srcValItem.value;
          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
          linkTriggers[tarAxisInfo.key] = val;
        }
      });
    }
  });
  each(linkTriggers, function (val, tarKey) {
    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
  });
  updateModelActually(showValueMap, axesInfo, outputFinder);
  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
  dispatchHighDownActually(axesInfo, dispatchAction, api);
  return outputFinder;
}

function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
  var axis = axisInfo.axis;

  if (axis.scale.isBlank() || !axis.containData(newValue)) {
    return;
  }

  if (!axisInfo.involveSeries) {
    updaters.showPointer(axisInfo, newValue);
    return;
  } // Heavy calculation. So put it after axis.containData checking.


  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
  var payloadBatch = payloadInfo.payloadBatch;
  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
  // By defualt use the first involved series data as a sample to connect.

  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
    zrUtil.extend(outputFinder, payloadBatch[0]);
  } // If no linkSource input, this process is for collecting link
  // target, where snap should not be accepted.


  if (!dontSnap && axisInfo.snap) {
    if (axis.containData(snapToValue) && snapToValue != null) {
      newValue = snapToValue;
    }
  }

  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
  // incorrect "axis value ~ series value" mapping displayed in tooltip.

  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}

function buildPayloadsBySeries(value, axisInfo) {
  var axis = axisInfo.axis;
  var dim = axis.dim;
  var snapToValue = value;
  var payloadBatch = [];
  var minDist = Number.MAX_VALUE;
  var minDiff = -1;
  each(axisInfo.seriesModels, function (series, idx) {
    var dataDim = series.coordDimToDataDim(dim);
    var seriesNestestValue;
    var dataIndices;

    if (series.getAxisTooltipData) {
      var result = series.getAxisTooltipData(dataDim, value, axis);
      dataIndices = result.dataIndices;
      seriesNestestValue = result.nestestValue;
    } else {
      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
      // when data length is not same.
      false, axis.type === 'category' ? 0.5 : null);

      if (!dataIndices.length) {
        return;
      }

      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
    }

    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
      return;
    }

    var diff = value - seriesNestestValue;
    var dist = Math.abs(diff); // Consider category case

    if (dist <= minDist) {
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        snapToValue = seriesNestestValue;
        payloadBatch.length = 0;
      }

      each(dataIndices, function (dataIndex) {
        payloadBatch.push({
          seriesIndex: series.seriesIndex,
          dataIndexInside: dataIndex,
          dataIndex: series.getData().getRawIndex(dataIndex)
        });
      });
    }
  });
  return {
    payloadBatch: payloadBatch,
    snapToValue: snapToValue
  };
}

function showPointer(showValueMap, axisInfo, value, payloadBatch) {
  showValueMap[axisInfo.key] = {
    value: value,
    payloadBatch: payloadBatch
  };
}

function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
  var payloadBatch = payloadInfo.payloadBatch;
  var axis = axisInfo.axis;
  var axisModel = axis.model;
  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
  // whose length will be used to judge whether dispatch action.

  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
    return;
  }

  var coordSysModel = axisInfo.coordSys.model;
  var coordSysKey = modelHelper.makeKey(coordSysModel);
  var coordSysItem = dataByCoordSys.map[coordSysKey];

  if (!coordSysItem) {
    coordSysItem = dataByCoordSys.map[coordSysKey] = {
      coordSysId: coordSysModel.id,
      coordSysIndex: coordSysModel.componentIndex,
      coordSysType: coordSysModel.type,
      coordSysMainType: coordSysModel.mainType,
      dataByAxis: []
    };
    dataByCoordSys.list.push(coordSysItem);
  }

  coordSysItem.dataByAxis.push({
    axisDim: axis.dim,
    axisIndex: axisModel.componentIndex,
    axisType: axisModel.type,
    axisId: axisModel.id,
    value: value,
    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
    // depends that all models have been updated. So it should not be performed
    // here. Considering axisPointerModel used here is volatile, which is hard
    // to be retrieve in TooltipView, we prepare parameters here.
    valueLabelOpt: {
      precision: axisPointerModel.get('label.precision'),
      formatter: axisPointerModel.get('label.formatter')
    },
    seriesDataIndices: payloadBatch.slice()
  });
}

function updateModelActually(showValueMap, axesInfo, outputFinder) {
  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    var valItem = showValueMap[key];

    if (valItem) {
      !axisInfo.useHandle && (option.status = 'show');
      option.value = valItem.value; // For label formatter param and highlight.

      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
    } // When always show (e.g., handle used), remain
    // original value and status.
    else {
        // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
      } // If status is 'hide', should be no info in payload.


    option.status === 'show' && outputAxesInfo.push({
      axisDim: axisInfo.axis.dim,
      axisIndex: axisInfo.axis.model.componentIndex,
      value: option.value
    });
  });
}

function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
  // Basic logic: If no showTip required, hideTip will be dispatched.
  if (illegalPoint(point) || !dataByCoordSys.list.length) {
    dispatchAction({
      type: 'hideTip'
    });
    return;
  } // In most case only one axis (or event one series is used). It is
  // convinient to fetch payload.seriesIndex and payload.dataIndex
  // dirtectly. So put the first seriesIndex and dataIndex of the first
  // axis on the payload.


  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  dispatchAction({
    type: 'showTip',
    escapeConnect: true,
    x: point[0],
    y: point[1],
    tooltipOption: payload.tooltipOption,
    position: payload.position,
    dataIndexInside: sampleItem.dataIndexInside,
    dataIndex: sampleItem.dataIndex,
    seriesIndex: sampleItem.seriesIndex,
    dataByCoordSys: dataByCoordSys.list
  });
}

function dispatchHighDownActually(axesInfo, dispatchAction, api) {
  // FIXME
  // highlight status modification shoule be a stage of main process?
  // (Consider confilct (e.g., legend and axisPointer) and setOption)
  var zr = api.getZr();
  var highDownKey = 'axisPointerLastHighlights';
  var lastHighlights = get(zr)[highDownKey] || {};
  var newHighlights = get(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
  // Build hash map and remove duplicate incidentally.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
      newHighlights[key] = batchItem;
    });
  }); // Diff.

  var toHighlight = [];
  var toDownplay = [];
  zrUtil.each(lastHighlights, function (batchItem, key) {
    !newHighlights[key] && toDownplay.push(batchItem);
  });
  zrUtil.each(newHighlights, function (batchItem, key) {
    !lastHighlights[key] && toHighlight.push(batchItem);
  });
  toDownplay.length && api.dispatchAction({
    type: 'downplay',
    escapeConnect: true,
    batch: toDownplay
  });
  toHighlight.length && api.dispatchAction({
    type: 'highlight',
    escapeConnect: true,
    batch: toHighlight
  });
}

function findInputAxisInfo(inputAxesInfo, axisInfo) {
  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
    var inputAxisInfo = inputAxesInfo[i];

    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
      return inputAxisInfo;
    }
  }
}

function makeMapperParam(axisInfo) {
  var axisModel = axisInfo.axis.model;
  var item = {};
  var dim = item.axisDim = axisInfo.axis.dim;
  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
  item.axisName = item[dim + 'AxisName'] = axisModel.name;
  item.axisId = item[dim + 'AxisId'] = axisModel.id;
  return item;
}

function illegalPoint(point) {
  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

module.exports = _default;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

var _layout = __webpack_require__(103);

var getLayoutRect = _layout.getLayoutRect;
var layoutBox = _layout.box;
var positionElement = _layout.positionElement;

var formatUtil = __webpack_require__(71);

var graphic = __webpack_require__(34);

/**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */
function layout(group, componentModel, api) {
  var boxLayoutParams = componentModel.getBoxLayoutParams();
  var padding = componentModel.get('padding');
  var viewportSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
  positionElement(group, boxLayoutParams, viewportSize, padding);
}

function makeBackground(rect, componentModel) {
  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
  var style = componentModel.getItemStyle(['color', 'opacity']);
  style.fill = componentModel.get('backgroundColor');
  var rect = new graphic.Rect({
    shape: {
      x: rect.x - padding[3],
      y: rect.y - padding[0],
      width: rect.width + padding[1] + padding[3],
      height: rect.height + padding[0] + padding[2],
      r: componentModel.get('borderRadius')
    },
    style: style,
    silent: true,
    z2: -1
  }); // FIXME
  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
  // and background rect when setting like `left: 0`, `top: 0`.
  // graphic.subPixelOptimizeRect(rect);

  return rect;
}

exports.layout = layout;
exports.makeBackground = makeBackground;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

/**
 * Data selectable mixin for chart series.
 * To eanble data select, option of series must have `selectedMode`.
 * And each data item will use `selected` to toggle itself selected status
 */
var _default = {
  updateSelectedMap: function (targetList) {
    this._targetList = targetList.slice();
    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
      targetMap.set(target.name, target);
      return targetMap;
    }, zrUtil.createHashMap());
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  // PENGING If selectedMode is null ?
  select: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      this._selectTargetMap.each(function (target) {
        target.selected = false;
      });
    }

    target && (target.selected = true);
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  unSelect: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
    // selectedMode !== 'single' && target && (target.selected = false);

    target && (target.selected = false);
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  toggleSelected: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);

    if (target != null) {
      this[target.selected ? 'unSelect' : 'select'](name, id);
      return target.selected;
    }
  },

  /**
   * Either name or id should be passed as input here.
   * If both of them are defined, id is used.
   *
   * @param {string|undefined} name name of data
   * @param {number|undefined} id dataIndex of data
   */
  isSelected: function (name, id) {
    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
    return target && target.selected;
  }
};
module.exports = _default;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var Model = __webpack_require__(70);

var LegendModel = echarts.extendComponentModel({
  type: 'legend.plain',
  dependencies: ['series'],
  layoutMode: {
    type: 'box',
    // legend.width/height are maxWidth/maxHeight actually,
    // whereas realy width/height is calculated by its content.
    // (Setting {left: 10, right: 10} does not make sense).
    // So consider the case:
    // `setOption({legend: {left: 10});`
    // then `setOption({legend: {right: 10});`
    // The previous `left` should be cleared by setting `ignoreSize`.
    ignoreSize: true
  },
  init: function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
    option.selected = option.selected || {};
  },
  mergeOption: function (option) {
    LegendModel.superCall(this, 'mergeOption', option);
  },
  optionUpdated: function () {
    this._updateData(this.ecModel);

    var legendData = this._data; // If selectedMode is single, try to select one

    if (legendData[0] && this.get('selectedMode') === 'single') {
      var hasSelected = false; // If has any selected in option.selected

      for (var i = 0; i < legendData.length; i++) {
        var name = legendData[i].get('name');

        if (this.isSelected(name)) {
          // Force to unselect others
          this.select(name);
          hasSelected = true;
          break;
        }
      } // Try select the first if selectedMode is single


      !hasSelected && this.select(legendData[0].get('name'));
    }
  },
  _updateData: function (ecModel) {
    var legendData = zrUtil.map(this.get('data') || [], function (dataItem) {
      // Can be string or number
      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
        dataItem = {
          name: dataItem
        };
      }

      return new Model(dataItem, this, this.ecModel);
    }, this);
    this._data = legendData;
    var availableNames = zrUtil.map(ecModel.getSeries(), function (series) {
      return series.name;
    });
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.legendDataProvider) {
        var data = seriesModel.legendDataProvider();
        availableNames = availableNames.concat(data.mapArray(data.getName));
      }
    });
    /**
     * @type {Array.<string>}
     * @private
     */

    this._availableNames = availableNames;
  },

  /**
   * @return {Array.<module:echarts/model/Model>}
   */
  getData: function () {
    return this._data;
  },

  /**
   * @param {string} name
   */
  select: function (name) {
    var selected = this.option.selected;
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      var data = this._data;
      zrUtil.each(data, function (dataItem) {
        selected[dataItem.get('name')] = false;
      });
    }

    selected[name] = true;
  },

  /**
   * @param {string} name
   */
  unSelect: function (name) {
    if (this.get('selectedMode') !== 'single') {
      this.option.selected[name] = false;
    }
  },

  /**
   * @param {string} name
   */
  toggleSelected: function (name) {
    var selected = this.option.selected; // Default is true

    if (!selected.hasOwnProperty(name)) {
      selected[name] = true;
    }

    this[selected[name] ? 'unSelect' : 'select'](name);
  },

  /**
   * @param {string} name
   */
  isSelected: function (name) {
    var selected = this.option.selected;
    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
  },
  defaultOption: {
    // 一级层叠
    zlevel: 0,
    // 二级层叠
    z: 4,
    show: true,
    // 布局方式，默认为水平布局，可选为：
    // 'horizontal' | 'vertical'
    orient: 'horizontal',
    left: 'center',
    // right: 'center',
    top: 0,
    // bottom: null,
    // 水平对齐
    // 'auto' | 'left' | 'right'
    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
    align: 'auto',
    backgroundColor: 'rgba(0,0,0,0)',
    // 图例边框颜色
    borderColor: '#ccc',
    borderRadius: 0,
    // 图例边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 图例内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // 各个item之间的间隔，单位px，默认为10，
    // 横向布局时为水平间隔，纵向布局时为纵向间隔
    itemGap: 10,
    // 图例图形宽度
    itemWidth: 25,
    // 图例图形高度
    itemHeight: 14,
    // 图例关闭时候的颜色
    inactiveColor: '#ccc',
    textStyle: {
      // 图例文字颜色
      color: '#333'
    },
    // formatter: '',
    // 选择模式，默认开启图例开关
    selectedMode: true,
    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
    // selected: null,
    // 图例内容（详见legend.data，数组中每一项代表一个item
    // data: [],
    // Tooltip 相关配置
    tooltip: {
      show: false
    }
  }
});
var _default = LegendModel;
module.exports = _default;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var _symbol = __webpack_require__(211);

var createSymbol = _symbol.createSymbol;

var graphic = __webpack_require__(34);

var _listComponent = __webpack_require__(1056);

var makeBackground = _listComponent.makeBackground;

var layoutUtil = __webpack_require__(103);

var curry = zrUtil.curry;
var each = zrUtil.each;
var Group = graphic.Group;

var _default = echarts.extendComponentView({
  type: 'legend.plain',
  newlineDisabled: false,

  /**
   * @override
   */
  init: function () {
    /**
     * @private
     * @type {module:zrender/container/Group}
     */
    this.group.add(this._contentGroup = new Group());
    /**
     * @private
     * @type {module:zrender/Element}
     */

    this._backgroundEl;
  },

  /**
   * @protected
   */
  getContentGroup: function () {
    return this._contentGroup;
  },

  /**
   * @override
   */
  render: function (legendModel, ecModel, api) {
    this.resetInner();

    if (!legendModel.get('show', true)) {
      return;
    }

    var itemAlign = legendModel.get('align');

    if (!itemAlign || itemAlign === 'auto') {
      itemAlign = legendModel.get('left') === 'right' && legendModel.get('orient') === 'vertical' ? 'right' : 'left';
    }

    this.renderInner(itemAlign, legendModel, ecModel, api); // Perform layout.

    var positionInfo = legendModel.getBoxLayoutParams();
    var viewportSize = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var padding = legendModel.get('padding');
    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize); // Place mainGroup, based on the calculated `mainRect`.

    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
      width: mainRect.width,
      height: mainRect.height
    }, positionInfo), viewportSize, padding);
    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.

    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
  },

  /**
   * @protected
   */
  resetInner: function () {
    this.getContentGroup().removeAll();
    this._backgroundEl && this.group.remove(this._backgroundEl);
  },

  /**
   * @protected
   */
  renderInner: function (itemAlign, legendModel, ecModel, api) {
    var contentGroup = this.getContentGroup();
    var legendDrawnMap = zrUtil.createHashMap();
    var selectMode = legendModel.get('selectedMode');
    each(legendModel.getData(), function (itemModel, dataIndex) {
      var name = itemModel.get('name'); // Use empty string or \n as a newline string

      if (!this.newlineDisabled && (name === '' || name === '\n')) {
        contentGroup.add(new Group({
          newline: true
        }));
        return;
      }

      var seriesModel = ecModel.getSeriesByName(name)[0];

      if (legendDrawnMap.get(name)) {
        // Have been drawed
        return;
      } // Series legend


      if (seriesModel) {
        var data = seriesModel.getData();
        var color = data.getVisual('color'); // If color is a callback function

        if (typeof color === 'function') {
          // Use the first data
          color = color(seriesModel.getDataParams(0));
        } // Using rect symbol defaultly


        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
        var symbolType = data.getVisual('symbol');

        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode);

        itemGroup.on('click', curry(dispatchSelectAction, name, api)).on('mouseover', curry(dispatchHighlightAction, seriesModel, null, api)).on('mouseout', curry(dispatchDownplayAction, seriesModel, null, api));
        legendDrawnMap.set(name, true);
      } else {
        // Data legend of pie, funnel
        ecModel.eachRawSeries(function (seriesModel) {
          // In case multiple series has same data name
          if (legendDrawnMap.get(name)) {
            return;
          }

          if (seriesModel.legendDataProvider) {
            var data = seriesModel.legendDataProvider();
            var idx = data.indexOfName(name);

            if (idx < 0) {
              return;
            }

            var color = data.getItemVisual(idx, 'color');
            var legendSymbolType = 'roundRect';

            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, selectMode);

            itemGroup.on('click', curry(dispatchSelectAction, name, api)) // FIXME Should not specify the series name
            .on('mouseover', curry(dispatchHighlightAction, seriesModel, name, api)).on('mouseout', curry(dispatchDownplayAction, seriesModel, name, api));
            legendDrawnMap.set(name, true);
          }
        }, this);
      }
    }, this);
  },
  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, selectMode) {
    var itemWidth = legendModel.get('itemWidth');
    var itemHeight = legendModel.get('itemHeight');
    var inactiveColor = legendModel.get('inactiveColor');
    var isSelected = legendModel.isSelected(name);
    var itemGroup = new Group();
    var textStyleModel = itemModel.getModel('textStyle');
    var itemIcon = itemModel.get('icon');
    var tooltipModel = itemModel.getModel('tooltip');
    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first

    legendSymbolType = itemIcon || legendSymbolType;
    itemGroup.add(createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, true)); // Compose symbols
    // PENDING

    if (!itemIcon && symbolType // At least show one symbol, can't be all none
    && (symbolType !== legendSymbolType || symbolType == 'none')) {
      var size = itemHeight * 0.8;

      if (symbolType === 'none') {
        symbolType = 'circle';
      } // Put symbol in the center


      itemGroup.add(createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor));
    }

    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
    var textAlign = itemAlign;
    var formatter = legendModel.get('formatter');
    var content = name;

    if (typeof formatter === 'string' && formatter) {
      content = formatter.replace('{name}', name != null ? name : '');
    } else if (typeof formatter === 'function') {
      content = formatter(name);
    }

    itemGroup.add(new graphic.Text({
      style: graphic.setTextStyle({}, textStyleModel, {
        text: content,
        x: textX,
        y: itemHeight / 2,
        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
        textAlign: textAlign,
        textVerticalAlign: 'middle'
      })
    })); // Add a invisible rect to increase the area of mouse hover

    var hitRect = new graphic.Rect({
      shape: itemGroup.getBoundingRect(),
      invisible: true,
      tooltip: tooltipModel.get('show') ? zrUtil.extend({
        content: name,
        // Defaul formatter
        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
          return name;
        },
        formatterParams: {
          componentType: 'legend',
          legendIndex: legendModel.componentIndex,
          name: name,
          $vars: ['name']
        }
      }, tooltipModel.option) : null
    });
    itemGroup.add(hitRect);
    itemGroup.eachChild(function (child) {
      child.silent = true;
    });
    hitRect.silent = !selectMode;
    this.getContentGroup().add(itemGroup);
    graphic.setHoverStyle(itemGroup);
    itemGroup.__legendDataIndex = dataIndex;
    return itemGroup;
  },

  /**
   * @protected
   */
  layoutInner: function (legendModel, itemAlign, maxSize) {
    var contentGroup = this.getContentGroup(); // Place items in contentGroup.

    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
    var contentRect = contentGroup.getBoundingRect();
    contentGroup.attr('position', [-contentRect.x, -contentRect.y]);
    return this.group.getBoundingRect();
  }
});

function dispatchSelectAction(name, api) {
  api.dispatchAction({
    type: 'legendToggleSelect',
    name: name
  });
}

function dispatchHighlightAction(seriesModel, dataName, api) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    seriesModel.get('legendHoverLink') && api.dispatchAction({
      type: 'highlight',
      seriesName: seriesModel.name,
      name: dataName
    });
  }
}

function dispatchDownplayAction(seriesModel, dataName, api) {
  // If element hover will move to a hoverLayer.
  var el = api.getZr().storage.getDisplayList()[0];

  if (!(el && el.useHoverLayer)) {
    seriesModel.get('legendHoverLink') && api.dispatchAction({
      type: 'downplay',
      seriesName: seriesModel.name,
      name: dataName
    });
  }
}

module.exports = _default;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

function legendSelectActionHandler(methodName, payload, ecModel) {
  var selectedMap = {};
  var isToggleSelect = methodName === 'toggleSelected';
  var isSelected; // Update all legend components

  ecModel.eachComponent('legend', function (legendModel) {
    if (isToggleSelect && isSelected != null) {
      // Force other legend has same selected status
      // Or the first is toggled to true and other are toggled to false
      // In the case one legend has some item unSelected in option. And if other legend
      // doesn't has the item, they will assume it is selected.
      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
    } else {
      legendModel[methodName](payload.name);
      isSelected = legendModel.isSelected(payload.name);
    }

    var legendData = legendModel.getData();
    zrUtil.each(legendData, function (model) {
      var name = model.get('name'); // Wrap element

      if (name === '\n' || name === '') {
        return;
      }

      var isItemSelected = legendModel.isSelected(name);

      if (selectedMap.hasOwnProperty(name)) {
        // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
      } else {
        selectedMap[name] = isItemSelected;
      }
    });
  }); // Return the event explicitly

  return {
    name: payload.name,
    selected: selectedMap
  };
}
/**
 * @event legendToggleSelect
 * @type {Object}
 * @property {string} type 'legendToggleSelect'
 * @property {string} [from]
 * @property {string} name Series name or data item name
 */


echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
/**
 * @event legendSelect
 * @type {Object}
 * @property {string} type 'legendSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
/**
 * @event legendUnSelect
 * @type {Object}
 * @property {string} type 'legendUnSelect'
 * @property {string} name Series name or data item name
 */

echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

function _default(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (legendModels && legendModels.length) {
    ecModel.filterSeries(function (series) {
      // If in any legend component the status is not selected.
      // Because in legend series is assumed selected when it is not in the legend data.
      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(series.name)) {
          return false;
        }
      }

      return true;
    });
  }
}

module.exports = _default;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var zrColor = __webpack_require__(195);

var eventUtil = __webpack_require__(193);

var env = __webpack_require__(64);

var formatUtil = __webpack_require__(71);

var each = zrUtil.each;
var toCamelCase = formatUtil.toCamelCase;
var vendors = ['', '-webkit-', '-moz-', '-o-'];
var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
/**
 * @param {number} duration
 * @return {string}
 * @inner
 */

function assembleTransition(duration) {
  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
  return zrUtil.map(vendors, function (vendorPrefix) {
    return vendorPrefix + 'transition:' + transitionText;
  }).join(';');
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */


function assembleFont(textStyleModel) {
  var cssText = [];
  var fontSize = textStyleModel.get('fontSize');
  var color = textStyleModel.getTextColor();
  color && cssText.push('color:' + color);
  cssText.push('font:' + textStyleModel.getFont());
  fontSize && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
  each(['decoration', 'align'], function (name) {
    var val = textStyleModel.get(name);
    val && cssText.push('text-' + name + ':' + val);
  });
  return cssText.join(';');
}
/**
 * @param {Object} tooltipModel
 * @return {string}
 * @inner
 */


function assembleCssText(tooltipModel) {
  var cssText = [];
  var transitionDuration = tooltipModel.get('transitionDuration');
  var backgroundColor = tooltipModel.get('backgroundColor');
  var textStyleModel = tooltipModel.getModel('textStyle');
  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.

  transitionDuration && cssText.push(assembleTransition(transitionDuration));

  if (backgroundColor) {
    if (env.canvasSupported) {
      cssText.push('background-Color:' + backgroundColor);
    } else {
      // for ie
      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
      cssText.push('filter:alpha(opacity=70)');
    }
  } // Border style


  each(['width', 'color', 'radius'], function (name) {
    var borderName = 'border-' + name;
    var camelCase = toCamelCase(borderName);
    var val = tooltipModel.get(camelCase);
    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
  }); // Text style

  cssText.push(assembleFont(textStyleModel)); // Padding

  if (padding != null) {
    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
  }

  return cssText.join(';') + ';';
}
/**
 * @alias module:echarts/component/tooltip/TooltipContent
 * @constructor
 */


function TooltipContent(container, api) {
  var el = document.createElement('div');
  var zr = this._zr = api.getZr();
  this.el = el;
  this._x = api.getWidth() / 2;
  this._y = api.getHeight() / 2;
  container.appendChild(el);
  this._container = container;
  this._show = false;
  /**
   * @private
   */

  this._hideTimeout;
  var self = this;

  el.onmouseenter = function () {
    // clear the timeout in hideLater and keep showing tooltip
    if (self._enterable) {
      clearTimeout(self._hideTimeout);
      self._show = true;
    }

    self._inContent = true;
  };

  el.onmousemove = function (e) {
    e = e || window.event;

    if (!self._enterable) {
      // Try trigger zrender event to avoid mouse
      // in and out shape too frequently
      var handler = zr.handler;
      eventUtil.normalizeEvent(container, e, true);
      handler.dispatch('mousemove', e);
    }
  };

  el.onmouseleave = function () {
    if (self._enterable) {
      if (self._show) {
        self.hideLater(self._hideDelay);
      }
    }

    self._inContent = false;
  };
}

TooltipContent.prototype = {
  constructor: TooltipContent,

  /**
   * @private
   * @type {boolean}
   */
  _enterable: true,

  /**
   * Update when tooltip is rendered
   */
  update: function () {
    // FIXME
    // Move this logic to ec main?
    var container = this._container;
    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
    var domStyle = container.style;

    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
      domStyle.position = 'relative';
    } // Hide the tooltip
    // PENDING
    // this.hide();

  },
  show: function (tooltipModel) {
    clearTimeout(this._hideTimeout);
    var el = this.el;
    el.style.cssText = gCssText + assembleCssText(tooltipModel) // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
    + ';left:' + this._x + 'px;top:' + this._y + 'px;' + (tooltipModel.get('extraCssText') || '');
    el.style.display = el.innerHTML ? 'block' : 'none';
    this._show = true;
  },
  setContent: function (content) {
    this.el.innerHTML = content == null ? '' : content;
  },
  setEnterable: function (enterable) {
    this._enterable = enterable;
  },
  getSize: function () {
    var el = this.el;
    return [el.clientWidth, el.clientHeight];
  },
  moveTo: function (x, y) {
    // xy should be based on canvas root. But tooltipContent is
    // the sibling of canvas root. So padding of ec container
    // should be considered here.
    var zr = this._zr;
    var viewportRootOffset;

    if (zr && zr.painter && (viewportRootOffset = zr.painter.getViewportRootOffset())) {
      x += viewportRootOffset.offsetLeft;
      y += viewportRootOffset.offsetTop;
    }

    var style = this.el.style;
    style.left = x + 'px';
    style.top = y + 'px';
    this._x = x;
    this._y = y;
  },
  hide: function () {
    this.el.style.display = 'none';
    this._show = false;
  },
  hideLater: function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater mutiple times

        this._show = false;
        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  },
  isShow: function () {
    return this._show;
  }
};
var _default = TooltipContent;
module.exports = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var _default = echarts.extendComponentModel({
  type: 'tooltip',
  dependencies: ['axisPointer'],
  defaultOption: {
    zlevel: 0,
    z: 8,
    show: true,
    // tooltip主体内容
    showContent: true,
    // 'trigger' only works on coordinate system.
    // 'item' | 'axis' | 'none'
    trigger: 'item',
    // 'click' | 'mousemove' | 'none'
    triggerOn: 'mousemove|click',
    alwaysShowContent: false,
    displayMode: 'single',
    // 'single' | 'multipleByCoordSys'
    // 位置 {Array} | {Function}
    // position: null
    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
    // align: null,
    // verticalAlign: null,
    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
    confine: false,
    // 内容格式器：{string}（Template） ¦ {Function}
    // formatter: null
    showDelay: 0,
    // 隐藏延迟，单位ms
    hideDelay: 100,
    // 动画变换时间，单位s
    transitionDuration: 0.4,
    enterable: false,
    // 提示背景颜色，默认为透明度为0.7的黑色
    backgroundColor: 'rgba(50,50,50,0.7)',
    // 提示边框颜色
    borderColor: '#333',
    // 提示边框圆角，单位px，默认为4
    borderRadius: 4,
    // 提示边框线宽，单位px，默认为0（无边框）
    borderWidth: 0,
    // 提示内边距，单位px，默认各方向内边距为5，
    // 接受数组分别设定上右下左边距，同css
    padding: 5,
    // Extra css text
    extraCssText: '',
    // 坐标轴指示器，坐标轴触发有效
    axisPointer: {
      // 默认为直线
      // 可选为：'line' | 'shadow' | 'cross'
      type: 'line',
      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
      // 默认 'auto'，会选择类型为 cateogry 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
      // 极坐标系会默认选择 angle 轴
      axis: 'auto',
      animation: 'auto',
      animationDurationUpdate: 200,
      animationEasingUpdate: 'exponentialOut',
      crossStyle: {
        color: '#999',
        width: 1,
        type: 'dashed',
        // TODO formatter
        textStyle: {} // lineStyle and shadowStyle should not be specified here,
        // otherwise it will always override those styles on option.axisPointer.

      }
    },
    textStyle: {
      color: '#fff',
      fontSize: 14
    }
  }
});

module.exports = _default;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var echarts = __webpack_require__(26);

var zrUtil = __webpack_require__(6);

var env = __webpack_require__(64);

var TooltipContent = __webpack_require__(1062);

var formatUtil = __webpack_require__(71);

var numberUtil = __webpack_require__(48);

var graphic = __webpack_require__(34);

var findPointFromSeries = __webpack_require__(468);

var layoutUtil = __webpack_require__(103);

var Model = __webpack_require__(70);

var globalListener = __webpack_require__(469);

var axisHelper = __webpack_require__(137);

var axisPointerViewHelper = __webpack_require__(470);

var bind = zrUtil.bind;
var each = zrUtil.each;
var parsePercent = numberUtil.parsePercent;
var proxyRect = new graphic.Rect({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
});

var _default = echarts.extendComponentView({
  type: 'tooltip',
  init: function (ecModel, api) {
    if (env.node) {
      return;
    }

    var tooltipContent = new TooltipContent(api.getDom(), api);
    this._tooltipContent = tooltipContent;
  },
  render: function (tooltipModel, ecModel, api) {
    if (env.node) {
      return;
    } // Reset


    this.group.removeAll();
    /**
     * @private
     * @type {module:echarts/component/tooltip/TooltipModel}
     */

    this._tooltipModel = tooltipModel;
    /**
     * @private
     * @type {module:echarts/model/Global}
     */

    this._ecModel = ecModel;
    /**
     * @private
     * @type {module:echarts/ExtensionAPI}
     */

    this._api = api;
    /**
     * Should be cleaned when render.
     * @private
     * @type {Array.<Array.<Object>>}
     */

    this._lastDataByCoordSys = null;
    /**
     * @private
     * @type {boolean}
     */

    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
    var tooltipContent = this._tooltipContent;
    tooltipContent.update();
    tooltipContent.setEnterable(tooltipModel.get('enterable'));

    this._initGlobalListener();

    this._keepShow();
  },
  _initGlobalListener: function () {
    var tooltipModel = this._tooltipModel;
    var triggerOn = tooltipModel.get('triggerOn');
    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none') {
        if (triggerOn.indexOf(currTrigger) >= 0) {
          this._tryShow(e, dispatchAction);
        } else if (currTrigger === 'leave') {
          this._hide(dispatchAction);
        }
      }
    }, this));
  },
  _keepShow: function () {
    var tooltipModel = this._tooltipModel;
    var ecModel = this._ecModel;
    var api = this._api; // Try to keep the tooltip show when refreshing

    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
    // self.manuallyShowTip({x, y}) might cause tooltip hide,
    // which is not expected.
    && tooltipModel.get('triggerOn') !== 'none') {
      var self = this;
      clearTimeout(this._refreshUpdateTimeout);
      this._refreshUpdateTimeout = setTimeout(function () {
        // Show tip next tick after other charts are rendered
        // In case highlight action has wrong result
        // FIXME
        self.manuallyShowTip(tooltipModel, ecModel, api, {
          x: self._lastX,
          y: self._lastY
        });
      });
    }
  },

  /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */
  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
    if (payload.from === this.uid || env.node) {
      return;
    }

    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket

    this._ticket = ''; // When triggered from axisPointer.

    var dataByCoordSys = payload.dataByCoordSys;

    if (payload.tooltip && payload.x != null && payload.y != null) {
      var el = proxyRect;
      el.position = [payload.x, payload.y];
      el.update();
      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        target: el
      }, dispatchAction);
    } else if (dataByCoordSys) {
      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        event: {},
        dataByCoordSys: payload.dataByCoordSys,
        tooltipOption: payload.tooltipOption
      }, dispatchAction);
    } else if (payload.seriesIndex != null) {
      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
        return;
      }

      var pointInfo = findPointFromSeries(payload, ecModel);
      var cx = pointInfo.point[0];
      var cy = pointInfo.point[1];

      if (cx != null && cy != null) {
        this._tryShow({
          offsetX: cx,
          offsetY: cy,
          position: payload.position,
          target: pointInfo.el,
          event: {}
        }, dispatchAction);
      }
    } else if (payload.x != null && payload.y != null) {
      // FIXME
      // should wrap dispatchAction like `axisPointer/globalListener` ?
      api.dispatchAction({
        type: 'updateAxisPointer',
        x: payload.x,
        y: payload.y
      });

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        target: api.getZr().findHover(payload.x, payload.y).target,
        event: {}
      }, dispatchAction);
    }
  },
  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
    var tooltipContent = this._tooltipContent;

    if (!this._alwaysShowContent) {
      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
    }

    this._lastX = this._lastY = null;

    if (payload.from !== this.uid) {
      this._hide(makeDispatchAction(payload, api));
    }
  },
  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
  // and tooltip.
  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
    var seriesIndex = payload.seriesIndex;
    var dataIndex = payload.dataIndex;
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;

    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
      return;
    }

    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (!seriesModel) {
      return;
    }

    var data = seriesModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);

    if (tooltipModel.get('trigger') !== 'axis') {
      return;
    }

    api.dispatchAction({
      type: 'updateAxisPointer',
      seriesIndex: seriesIndex,
      dataIndex: dataIndex,
      position: payload.position
    });
    return true;
  },
  _tryShow: function (e, dispatchAction) {
    var el = e.target;
    var tooltipModel = this._tooltipModel;

    if (!tooltipModel) {
      return;
    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed


    this._lastX = e.offsetX;
    this._lastY = e.offsetY;
    var dataByCoordSys = e.dataByCoordSys;

    if (dataByCoordSys && dataByCoordSys.length) {
      this._showAxisTooltip(dataByCoordSys, e);
    } // Always show item tooltip if mouse is on the element with dataIndex
    else if (el && el.dataIndex != null) {
        this._lastDataByCoordSys = null;

        this._showSeriesItemTooltip(e, el, dispatchAction);
      } // Tooltip provided directly. Like legend.
      else if (el && el.tooltip) {
          this._lastDataByCoordSys = null;

          this._showComponentItemTooltip(e, el, dispatchAction);
        } else {
          this._lastDataByCoordSys = null;

          this._hide(dispatchAction);
        }
  },
  _showOrMove: function (tooltipModel, cb) {
    // showDelay is used in this case: tooltip.enterable is set
    // as true. User intent to move mouse into tooltip and click
    // something. `showDelay` makes it easyer to enter the content
    // but tooltip do not move immediately.
    var delay = tooltipModel.get('showDelay');
    cb = zrUtil.bind(cb, this);
    clearTimeout(this._showTimout);
    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
  },
  _showAxisTooltip: function (dataByCoordSys, e) {
    var ecModel = this._ecModel;
    var globalTooltipModel = this._tooltipModel;
    var point = [e.offsetX, e.offsetY];
    var singleDefaultHTML = [];
    var singleParamsList = [];
    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
    each(dataByCoordSys, function (itemCoordSys) {
      // var coordParamList = [];
      // var coordDefaultHTML = [];
      // var coordTooltipModel = buildTooltipModel([
      //     e.tooltipOption,
      //     itemCoordSys.tooltipOption,
      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
      //     globalTooltipModel
      // ]);
      // var displayMode = coordTooltipModel.get('displayMode');
      // var paramsList = displayMode === 'single' ? singleParamsList : [];
      each(itemCoordSys.dataByAxis, function (item) {
        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
        var axisValue = item.value;
        var seriesDefaultHTML = [];

        if (!axisModel || axisValue == null) {
          return;
        }

        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
        zrUtil.each(item.seriesDataIndices, function (idxItem) {
          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
          var dataIndex = idxItem.dataIndexInside;
          var dataParams = series && series.getDataParams(dataIndex);
          dataParams.axisDim = item.axisDim;
          dataParams.axisIndex = item.axisIndex;
          dataParams.axisType = item.axisType;
          dataParams.axisId = item.axisId;
          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
          dataParams.axisValueLabel = valueLabel;

          if (dataParams) {
            singleParamsList.push(dataParams);
            seriesDefaultHTML.push(series.formatTooltip(dataIndex, true));
          }
        }); // Default tooltip content
        // FIXME
        // (1) shold be the first data which has name?
        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.

        var firstLine = valueLabel;
        singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + '<br />' : '') + seriesDefaultHTML.join('<br />'));
      });
    }, this); // In most case, the second axis is shown upper than the first one.

    singleDefaultHTML.reverse();
    singleDefaultHTML = singleDefaultHTML.join('<br /><br />');
    var positionExpr = e.position;

    this._showOrMove(singleTooltipModel, function () {
      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
      } else {
        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr);
      }
    }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.

  },
  _showSeriesItemTooltip: function (e, el, dispatchAction) {
    var ecModel = this._ecModel; // Use dataModel in element if possible
    // Used when mouseover on a element like markPoint or edge
    // In which case, the data is not main data in series.

    var seriesIndex = el.seriesIndex;
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.

    var dataModel = el.dataModel || seriesModel;
    var dataIndex = el.dataIndex;
    var dataType = el.dataType;
    var data = dataModel.getData();
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
    var tooltipTrigger = tooltipModel.get('trigger');

    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
      return;
    }

    var params = dataModel.getDataParams(dataIndex, dataType);
    var defaultHtml = dataModel.formatTooltip(dataIndex, false, dataType);
    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;

    this._showOrMove(tooltipModel, function () {
      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target);
    }); // FIXME
    // duplicated showtip if manuallyShowTip is called from dispatchAction.


    dispatchAction({
      type: 'showTip',
      dataIndexInside: dataIndex,
      dataIndex: data.getRawIndex(dataIndex),
      seriesIndex: seriesIndex,
      from: this.uid
    });
  },
  _showComponentItemTooltip: function (e, el, dispatchAction) {
    var tooltipOpt = el.tooltip;

    if (typeof tooltipOpt === 'string') {
      var content = tooltipOpt;
      tooltipOpt = {
        content: content,
        // Fixed formatter
        formatter: content
      };
    }

    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
    var defaultHtml = subTooltipModel.get('content');
    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
    // only works on cooridinate system. In fact, we have not found case
    // that requires setting `trigger` nothing on component yet.

    this._showOrMove(subTooltipModel, function () {
      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
    }); // If not dispatch showTip, tip may be hide triggered by axis.


    dispatchAction({
      type: 'showTip',
      from: this.uid
    });
  },
  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el) {
    // Reset ticket
    this._ticket = '';

    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
      return;
    }

    var tooltipContent = this._tooltipContent;
    var formatter = tooltipModel.get('formatter');
    positionExpr = positionExpr || tooltipModel.get('position');
    var html = defaultHtml;

    if (formatter && typeof formatter === 'string') {
      html = formatUtil.formatTpl(formatter, params, true);
    } else if (typeof formatter === 'function') {
      var callback = bind(function (cbTicket, html) {
        if (cbTicket === this._ticket) {
          tooltipContent.setContent(html);

          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
        }
      }, this);
      this._ticket = asyncTicket;
      html = formatter(params, asyncTicket, callback);
    }

    tooltipContent.setContent(html);
    tooltipContent.show(tooltipModel);

    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
  },

  /**
   * @param  {string|Function|Array.<number>|Object} positionExpr
   * @param  {number} x Mouse x
   * @param  {number} y Mouse y
   * @param  {boolean} confine Whether confine tooltip content in view rect.
   * @param  {Object|<Array.<Object>} params
   * @param  {module:zrender/Element} el target element
   * @param  {module:echarts/ExtensionAPI} api
   * @return {Array.<number>}
   */
  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
    var viewWidth = this._api.getWidth();

    var viewHeight = this._api.getHeight();

    positionExpr = positionExpr || tooltipModel.get('position');
    var contentSize = content.getSize();
    var align = tooltipModel.get('align');
    var vAlign = tooltipModel.get('verticalAlign');
    var rect = el && el.getBoundingRect().clone();
    el && rect.applyTransform(el.transform);

    if (typeof positionExpr === 'function') {
      // Callback of position can be an array or a string specify the position
      positionExpr = positionExpr([x, y], params, content.el, rect, {
        viewSize: [viewWidth, viewHeight],
        contentSize: contentSize.slice()
      });
    }

    if (zrUtil.isArray(positionExpr)) {
      x = parsePercent(positionExpr[0], viewWidth);
      y = parsePercent(positionExpr[1], viewHeight);
    } else if (zrUtil.isObject(positionExpr)) {
      positionExpr.width = contentSize[0];
      positionExpr.height = contentSize[1];
      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
        width: viewWidth,
        height: viewHeight
      });
      x = layoutRect.x;
      y = layoutRect.y;
      align = null; // When positionExpr is left/top/right/bottom,
      // align and verticalAlign will not work.

      vAlign = null;
    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
    else if (typeof positionExpr === 'string' && el) {
        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
        x = pos[0];
        y = pos[1];
      } else {
        var pos = refixTooltipPosition(x, y, content.el, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
        x = pos[0];
        y = pos[1];
      }

    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);

    if (tooltipModel.get('confine')) {
      var pos = confineTooltipPosition(x, y, content.el, viewWidth, viewHeight);
      x = pos[0];
      y = pos[1];
    }

    content.moveTo(x, y);
  },
  // FIXME
  // Should we remove this but leave this to user?
  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
    var lastCoordSys = this._lastDataByCoordSys;
    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
        var thisItem = thisDataByAxis[indexAxis] || {};
        var lastIndices = lastItem.seriesDataIndices || [];
        var newIndices = thisItem.seriesDataIndices || [];
        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
          var newIdxItem = newIndices[j];
          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
        });
      });
    });
    this._lastDataByCoordSys = dataByCoordSys;
    return !!contentNotChanged;
  },
  _hide: function (dispatchAction) {
    // Do not directly hideLater here, because this behavior may be prevented
    // in dispatchAction when showTip is dispatched.
    // FIXME
    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
    this._lastDataByCoordSys = null;
    dispatchAction({
      type: 'hideTip',
      from: this.uid
    });
  },
  dispose: function (ecModel, api) {
    if (env.node) {
      return;
    }

    this._tooltipContent.hide();

    globalListener.unregister('itemTooltip', api);
  }
});
/**
 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
 * From top to bottom. (the last one should be globalTooltipModel);
 */


function buildTooltipModel(modelCascade) {
  var resultModel = modelCascade.pop();

  while (modelCascade.length) {
    var tooltipOpt = modelCascade.pop();

    if (tooltipOpt) {
      if (tooltipOpt instanceof Model) {
        tooltipOpt = tooltipOpt.get('tooltip', true);
      } // In each data item tooltip can be simply write:
      // {
      //  value: 10,
      //  tooltip: 'Something you need to know'
      // }


      if (typeof tooltipOpt === 'string') {
        tooltipOpt = {
          formatter: tooltipOpt
        };
      }

      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
    }
  }

  return resultModel;
}

function makeDispatchAction(payload, api) {
  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
}

function refixTooltipPosition(x, y, el, viewWidth, viewHeight, gapH, gapV) {
  var size = getOuterSize(el);
  var width = size.width;
  var height = size.height;

  if (gapH != null) {
    if (x + width + gapH > viewWidth) {
      x -= width + gapH;
    } else {
      x += gapH;
    }
  }

  if (gapV != null) {
    if (y + height + gapV > viewHeight) {
      y -= height + gapV;
    } else {
      y += gapV;
    }
  }

  return [x, y];
}

function confineTooltipPosition(x, y, el, viewWidth, viewHeight) {
  var size = getOuterSize(el);
  var width = size.width;
  var height = size.height;
  x = Math.min(x + width, viewWidth) - width;
  y = Math.min(y + height, viewHeight) - height;
  x = Math.max(x, 0);
  y = Math.max(y, 0);
  return [x, y];
}

function getOuterSize(el) {
  var width = el.clientWidth;
  var height = el.clientHeight; // Consider browser compatibility.
  // IE8 does not support getComputedStyle.

  if (document.defaultView && document.defaultView.getComputedStyle) {
    var stl = document.defaultView.getComputedStyle(el);

    if (stl) {
      width += parseInt(stl.paddingLeft, 10) + parseInt(stl.paddingRight, 10) + parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
      height += parseInt(stl.paddingTop, 10) + parseInt(stl.paddingBottom, 10) + parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
    }
  }

  return {
    width: width,
    height: height
  };
}

function calcTooltipPosition(position, rect, contentSize) {
  var domWidth = contentSize[0];
  var domHeight = contentSize[1];
  var gap = 5;
  var x = 0;
  var y = 0;
  var rectWidth = rect.width;
  var rectHeight = rect.height;

  switch (position) {
    case 'inside':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'top':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y - domHeight - gap;
      break;

    case 'bottom':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight + gap;
      break;

    case 'left':
      x = rect.x - domWidth - gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'right':
      x = rect.x + rectWidth + gap;
      y = rect.y + rectHeight / 2 - domHeight / 2;
  }

  return [x, y];
}

function isCenterAlign(align) {
  return align === 'center' || align === 'middle';
}

module.exports = _default;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var defaultOption = {
  show: true,
  zlevel: 0,
  // 一级层叠
  z: 0,
  // 二级层叠
  // 反向坐标轴
  inverse: false,
  // 坐标轴名字，默认为空
  name: '',
  // 坐标轴名字位置，支持'start' | 'middle' | 'end'
  nameLocation: 'end',
  // 坐标轴名字旋转，degree。
  nameRotate: null,
  // Adapt to axis rotate, when nameLocation is 'middle'.
  nameTruncate: {
    maxWidth: null,
    ellipsis: '...',
    placeholder: '.'
  },
  // 坐标轴文字样式，默认取全局样式
  nameTextStyle: {},
  // 文字与轴线距离
  nameGap: 15,
  silent: false,
  // Default false to support tooltip.
  triggerEvent: false,
  // Default false to avoid legacy user event listener fail.
  tooltip: {
    show: false
  },
  axisPointer: {},
  // 坐标轴线
  axisLine: {
    // 默认显示，属性show控制显示与否
    show: true,
    onZero: true,
    onZeroAxisIndex: null,
    // 属性lineStyle控制线条样式
    lineStyle: {
      color: '#333',
      width: 1,
      type: 'solid'
    },
    // 坐标轴两端的箭头
    symbol: ['none', 'none'],
    symbolSize: [10, 15]
  },
  // 坐标轴小标记
  axisTick: {
    // 属性show控制显示与否，默认显示
    show: true,
    // 控制小标记是否在grid里
    inside: false,
    // 属性length控制线长
    length: 5,
    // 属性lineStyle控制线条样式
    lineStyle: {
      width: 1
    }
  },
  // 坐标轴文本标签，详见axis.axisLabel
  axisLabel: {
    show: true,
    // 控制文本标签是否在grid里
    inside: false,
    rotate: 0,
    showMinLabel: null,
    // true | false | null (auto)
    showMaxLabel: null,
    // true | false | null (auto)
    margin: 8,
    // formatter: null,
    // 其余属性默认使用全局文本样式，详见TEXTSTYLE
    fontSize: 12
  },
  // 分隔线
  splitLine: {
    // 默认显示，属性show控制显示与否
    show: true,
    // 属性lineStyle（详见lineStyle）控制线条样式
    lineStyle: {
      color: ['#ccc'],
      width: 1,
      type: 'solid'
    }
  },
  // 分隔区域
  splitArea: {
    // 默认不显示，属性show控制显示与否
    show: false,
    // 属性areaStyle（详见areaStyle）控制区域样式
    areaStyle: {
      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  }
};
var axisDefault = {};
axisDefault.categoryAxis = zrUtil.merge({
  // 类目起始和结束两端空白策略
  boundaryGap: true,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: false
  },
  // 坐标轴小标记
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: false,
    interval: 'auto'
  },
  // 坐标轴文本标签，详见axis.axisLabel
  axisLabel: {
    interval: 'auto'
  }
}, defaultOption);
axisDefault.valueAxis = zrUtil.merge({
  // 数值起始和结束两端空白策略
  boundaryGap: [0, 0],
  // 最小值, 设置成 'dataMin' 则从数据中计算最小值
  // min: null,
  // 最大值，设置成 'dataMax' 则从数据中计算最大值
  // max: null,
  // Readonly prop, specifies start value of the range when using data zoom.
  // rangeStart: null
  // Readonly prop, specifies end value of the range when using data zoom.
  // rangeEnd: null
  // 脱离0值比例，放大聚焦到最终_min，_max区间
  // scale: false,
  // 分割段数，默认为5
  splitNumber: 5 // Minimum interval
  // minInterval: null
  // maxInterval: null

}, defaultOption); // FIXME

axisDefault.timeAxis = zrUtil.defaults({
  scale: true,
  min: 'dataMin',
  max: 'dataMax'
}, axisDefault.valueAxis);
axisDefault.logAxis = zrUtil.defaults({
  scale: true,
  logBase: 10
}, axisDefault.valueAxis);
var _default = axisDefault;
module.exports = _default;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var axisDefault = __webpack_require__(1065);

var ComponentModel = __webpack_require__(102);

var _layout = __webpack_require__(103);

var getLayoutParams = _layout.getLayoutParams;
var mergeLayoutParam = _layout.mergeLayoutParam;
// FIXME axisType is fixed ?
var AXIS_TYPES = ['value', 'category', 'time', 'log'];
/**
 * Generate sub axis model class
 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
 * @param {module:echarts/model/Component} BaseAxisModelClass
 * @param {Function} axisTypeDefaulter
 * @param {Object} [extraDefaultOption]
 */

function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
  zrUtil.each(AXIS_TYPES, function (axisType) {
    BaseAxisModelClass.extend({
      type: axisName + 'Axis.' + axisType,
      mergeDefaultAndTheme: function (option, ecModel) {
        var layoutMode = this.layoutMode;
        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
        zrUtil.merge(option, this.getDefaultOption());
        option.type = axisTypeDefaulter(axisName, option);

        if (layoutMode) {
          mergeLayoutParam(option, inputPositionParams, layoutMode);
        }
      },
      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
    });
  });
  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
}

module.exports = _default;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Axis = __webpack_require__(472);

/**
 * Extend axis 2d
 * @constructor module:echarts/coord/cartesian/Axis2D
 * @extends {module:echarts/coord/cartesian/Axis}
 * @param {string} dim
 * @param {*} scale
 * @param {Array.<number>} coordExtent
 * @param {string} axisType
 * @param {string} position
 */
var Axis2D = function (dim, scale, coordExtent, axisType, position) {
  Axis.call(this, dim, scale, coordExtent);
  /**
   * Axis type
   *  - 'category'
   *  - 'value'
   *  - 'time'
   *  - 'log'
   * @type {string}
   */

  this.type = axisType || 'value';
  /**
   * Axis position
   *  - 'top'
   *  - 'bottom'
   *  - 'left'
   *  - 'right'
   */

  this.position = position || 'bottom';
};

Axis2D.prototype = {
  constructor: Axis2D,

  /**
   * Index of axis, can be used as key
   */
  index: 0,

  /**
   * If axis is on the zero position of the other axis
   * @type {boolean}
   */
  onZero: false,

  /**
   * Axis model
   * @param {module:echarts/coord/cartesian/AxisModel}
   */
  model: null,
  isHorizontal: function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  },

  /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */
  getGlobalExtent: function (asc) {
    var ret = this.getExtent();
    ret[0] = this.toGlobalCoord(ret[0]);
    ret[1] = this.toGlobalCoord(ret[1]);
    asc && ret[0] > ret[1] && ret.reverse();
    return ret;
  },
  getOtherAxis: function () {
    this.grid.getOtherAxis();
  },

  /**
   * If label is ignored.
   * Automatically used when axis is category and label can not be all shown
   * @param  {number}  idx
   * @return {boolean}
   */
  isLabelIgnored: function (idx) {
    if (this.type === 'category') {
      var labelInterval = this.getLabelInterval();
      return typeof labelInterval === 'function' && !labelInterval(idx, this.scale.getLabel(idx)) || idx % (labelInterval + 1);
    }
  },

  /**
   * @override
   */
  pointToData: function (point, clamp) {
    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
  },

  /**
   * Transform global coord to local coord,
   * i.e. var localCoord = axis.toLocalCoord(80);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toLocalCoord: null,

  /**
   * Transform global coord to local coord,
   * i.e. var globalCoord = axis.toLocalCoord(40);
   * designate by module:echarts/coord/cartesian/Grid.
   * @type {Function}
   */
  toGlobalCoord: null
};
zrUtil.inherits(Axis2D, Axis);
var _default = Axis2D;
module.exports = _default;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

/**
 * Cartesian coordinate system
 * @module  echarts/coord/Cartesian
 *
 */
function dimAxisMapper(dim) {
  return this._axes[dim];
}
/**
 * @alias module:echarts/coord/Cartesian
 * @constructor
 */


var Cartesian = function (name) {
  this._axes = {};
  this._dimList = [];
  /**
   * @type {string}
   */

  this.name = name || '';
};

Cartesian.prototype = {
  constructor: Cartesian,
  type: 'cartesian',

  /**
   * Get axis
   * @param  {number|string} dim
   * @return {module:echarts/coord/Cartesian~Axis}
   */
  getAxis: function (dim) {
    return this._axes[dim];
  },

  /**
   * Get axes list
   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
   */
  getAxes: function () {
    return zrUtil.map(this._dimList, dimAxisMapper, this);
  },

  /**
   * Get axes list by given scale type
   */
  getAxesByScale: function (scaleType) {
    scaleType = scaleType.toLowerCase();
    return zrUtil.filter(this.getAxes(), function (axis) {
      return axis.scale.type === scaleType;
    });
  },

  /**
   * Add axis
   * @param {module:echarts/coord/Cartesian.Axis}
   */
  addAxis: function (axis) {
    var dim = axis.dim;
    this._axes[dim] = axis;

    this._dimList.push(dim);
  },

  /**
   * Convert data to coord in nd space
   * @param {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  dataToCoord: function (val) {
    return this._dataCoordConvert(val, 'dataToCoord');
  },

  /**
   * Convert coord in nd space to data
   * @param  {Array.<number>|Object.<string, number>} val
   * @return {Array.<number>|Object.<string, number>}
   */
  coordToData: function (val) {
    return this._dataCoordConvert(val, 'coordToData');
  },
  _dataCoordConvert: function (input, method) {
    var dimList = this._dimList;
    var output = input instanceof Array ? [] : {};

    for (var i = 0; i < dimList.length; i++) {
      var dim = dimList[i];
      var axis = this._axes[dim];
      output[dim] = axis[method](input[dim]);
    }

    return output;
  }
};
var _default = Cartesian;
module.exports = _default;

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Cartesian = __webpack_require__(1068);

function Cartesian2D(name) {
  Cartesian.call(this, name);
}

Cartesian2D.prototype = {
  constructor: Cartesian2D,
  type: 'cartesian2d',

  /**
   * @type {Array.<string>}
   * @readOnly
   */
  dimensions: ['x', 'y'],

  /**
   * Base axis will be used on stacking.
   *
   * @return {module:echarts/coord/cartesian/Axis2D}
   */
  getBaseAxis: function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
  },

  /**
   * If contain point
   * @param {Array.<number>} point
   * @return {boolean}
   */
  containPoint: function (point) {
    var axisX = this.getAxis('x');
    var axisY = this.getAxis('y');
    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
  },

  /**
   * If contain data
   * @param {Array.<number>} data
   * @return {boolean}
   */
  containData: function (data) {
    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
  },

  /**
   * @param {Array.<number>} data
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  dataToPoint: function (data, clamp) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    return [xAxis.toGlobalCoord(xAxis.dataToCoord(data[0], clamp)), yAxis.toGlobalCoord(yAxis.dataToCoord(data[1], clamp))];
  },

  /**
   * @param {Array.<number>} point
   * @param {boolean} [clamp=false]
   * @return {Array.<number>}
   */
  pointToData: function (point, clamp) {
    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    return [xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp), yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp)];
  },

  /**
   * Get other axis
   * @param {module:echarts/coord/cartesian/Axis2D} axis
   */
  getOtherAxis: function (axis) {
    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
  }
};
zrUtil.inherits(Cartesian2D, Cartesian);
var _default = Cartesian2D;
module.exports = _default;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(474);

var ComponentModel = __webpack_require__(102);

// Grid 是在有直角坐标系的时候必须要存在的
// 所以这里也要被 Cartesian2D 依赖
var _default = ComponentModel.extend({
  type: 'grid',
  dependencies: ['xAxis', 'yAxis'],
  layoutMode: 'box',

  /**
   * @type {module:echarts/coord/cartesian/Grid}
   */
  coordinateSystem: null,
  defaultOption: {
    show: false,
    zlevel: 0,
    z: 0,
    left: '10%',
    top: 60,
    right: '10%',
    bottom: 60,
    // If grid size contain label
    containLabel: false,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    backgroundColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderColor: '#ccc'
  }
});

module.exports = _default;

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var BoundingRect = __webpack_require__(63);

var bbox = __webpack_require__(710);

var vec2 = __webpack_require__(53);

var polygonContain = __webpack_require__(1921);

/**
 * @module echarts/coord/geo/Region
 */

/**
 * @param {string} name
 * @param {Array} geometries
 * @param {Array.<number>} cp
 */
function Region(name, geometries, cp) {
  /**
   * @type {string}
   * @readOnly
   */
  this.name = name;
  /**
   * @type {Array.<Array>}
   * @readOnly
   */

  this.geometries = geometries;

  if (!cp) {
    var rect = this.getBoundingRect();
    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  } else {
    cp = [cp[0], cp[1]];
  }
  /**
   * @type {Array.<number>}
   */


  this.center = cp;
}

Region.prototype = {
  constructor: Region,
  properties: null,

  /**
   * @return {module:zrender/core/BoundingRect}
   */
  getBoundingRect: function () {
    var rect = this._rect;

    if (rect) {
      return rect;
    }

    var MAX_NUMBER = Number.MAX_VALUE;
    var min = [MAX_NUMBER, MAX_NUMBER];
    var max = [-MAX_NUMBER, -MAX_NUMBER];
    var min2 = [];
    var max2 = [];
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon
      if (geometries[i].type !== 'polygon') {
        continue;
      } // Doesn't consider hole


      var exterior = geometries[i].exterior;
      bbox.fromPoints(exterior, min2, max2);
      vec2.min(min, min, min2);
      vec2.max(max, max, max2);
    } // No data


    if (i === 0) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
  },

  /**
   * @param {<Array.<number>} coord
   * @return {boolean}
   */
  contain: function (coord) {
    var rect = this.getBoundingRect();
    var geometries = this.geometries;

    if (!rect.contain(coord[0], coord[1])) {
      return false;
    }

    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      if (polygonContain.contain(exterior, coord[0], coord[1])) {
        // Not in the region if point is in the hole.
        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
          if (polygonContain.contain(interiors[k])) {
            continue loopGeo;
          }
        }

        return true;
      }
    }

    return false;
  },
  transformTo: function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var aspect = rect.width / rect.height;

    if (!width) {
      width = aspect * height;
    } else if (!height) {
      height = width / aspect;
    }

    var target = new BoundingRect(x, y, width, height);
    var transform = rect.calculateTransform(target);
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      // Only support polygon.
      if (geometries[i].type !== 'polygon') {
        continue;
      }

      var exterior = geometries[i].exterior;
      var interiors = geometries[i].interiors;

      for (var p = 0; p < exterior.length; p++) {
        vec2.applyTransform(exterior[p], exterior[p], transform);
      }

      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
        for (var p = 0; p < interiors[h].length; p++) {
          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
      }
    }

    rect = this._rect;
    rect.copy(target); // Update center

    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }
};
var _default = Region;
module.exports = _default;

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Region = __webpack_require__(1071);

/**
 * Parse and decode geo json
 * @module echarts/coord/geo/parseGeoJson
 */
function decode(json) {
  if (!json.UTF8Encoding) {
    return json;
  }

  var encodeScale = json.UTF8Scale;

  if (encodeScale == null) {
    encodeScale = 1024;
  }

  var features = json.features;

  for (var f = 0; f < features.length; f++) {
    var feature = features[f];
    var geometry = feature.geometry;
    var coordinates = geometry.coordinates;
    var encodeOffsets = geometry.encodeOffsets;

    for (var c = 0; c < coordinates.length; c++) {
      var coordinate = coordinates[c];

      if (geometry.type === 'Polygon') {
        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
      } else if (geometry.type === 'MultiPolygon') {
        for (var c2 = 0; c2 < coordinate.length; c2++) {
          var polygon = coordinate[c2];
          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
        }
      }
    }
  } // Has been decoded


  json.UTF8Encoding = false;
  return json;
}

function decodePolygon(coordinate, encodeOffsets, encodeScale) {
  var result = [];
  var prevX = encodeOffsets[0];
  var prevY = encodeOffsets[1];

  for (var i = 0; i < coordinate.length; i += 2) {
    var x = coordinate.charCodeAt(i) - 64;
    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding

    x = x >> 1 ^ -(x & 1);
    y = y >> 1 ^ -(y & 1); // Delta deocding

    x += prevX;
    y += prevY;
    prevX = x;
    prevY = y; // Dequantize

    result.push([x / encodeScale, y / encodeScale]);
  }

  return result;
}
/**
 * @alias module:echarts/coord/geo/parseGeoJson
 * @param {Object} geoJson
 * @return {module:zrender/container/Group}
 */


function _default(geoJson) {
  decode(geoJson);
  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
    // Output of mapshaper may have geometry null
    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
  }), function (featureObj) {
    var properties = featureObj.properties;
    var geo = featureObj.geometry;
    var coordinates = geo.coordinates;
    var geometries = [];

    if (geo.type === 'Polygon') {
      geometries.push({
        type: 'polygon',
        // According to the GeoJSON specification.
        // First must be exterior, and the rest are all interior(holes).
        exterior: coordinates[0],
        interiors: coordinates.slice(1)
      });
    }

    if (geo.type === 'MultiPolygon') {
      zrUtil.each(coordinates, function (item) {
        if (item[0]) {
          geometries.push({
            type: 'polygon',
            exterior: item[0],
            interiors: item.slice(1)
          });
        }
      });
    }

    var region = new Region(properties.name, geometries, properties.cp);
    region.properties = properties;
    return region;
  });
}

module.exports = _default;

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

function defaultKeyGetter(item) {
  return item;
}
/**
 * @param {Array} oldArr
 * @param {Array} newArr
 * @param {Function} oldKeyGetter
 * @param {Function} newKeyGetter
 * @param {Object} [context] Can be visited by this.context in callback.
 */


function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
  this._old = oldArr;
  this._new = newArr;
  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
  this.context = context;
}

DataDiffer.prototype = {
  constructor: DataDiffer,

  /**
   * Callback function when add a data
   */
  add: function (func) {
    this._add = func;
    return this;
  },

  /**
   * Callback function when update a data
   */
  update: function (func) {
    this._update = func;
    return this;
  },

  /**
   * Callback function when remove a data
   */
  remove: function (func) {
    this._remove = func;
    return this;
  },
  execute: function () {
    var oldArr = this._old;
    var newArr = this._new;
    var oldDataIndexMap = {};
    var newDataIndexMap = {};
    var oldDataKeyArr = [];
    var newDataKeyArr = [];
    var i;
    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this); // Travel by inverted order to make sure order consistency
    // when duplicate keys exists (consider newDataIndex.pop() below).
    // For performance consideration, these code below do not look neat.

    for (i = 0; i < oldArr.length; i++) {
      var key = oldDataKeyArr[i];
      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.

      if (idx != null) {
        // Consider there is duplicate key (for example, use dataItem.name as key).
        // We should make sure every item in newArr and oldArr can be visited.
        var len = idx.length;

        if (len) {
          len === 1 && (newDataIndexMap[key] = null);
          idx = idx.unshift();
        } else {
          newDataIndexMap[key] = null;
        }

        this._update && this._update(idx, i);
      } else {
        this._remove && this._remove(i);
      }
    }

    for (var i = 0; i < newDataKeyArr.length; i++) {
      var key = newDataKeyArr[i];

      if (newDataIndexMap.hasOwnProperty(key)) {
        var idx = newDataIndexMap[key];

        if (idx == null) {
          continue;
        } // idx can never be empty array here. see 'set null' logic above.


        if (!idx.length) {
          this._add && this._add(idx);
        } else {
          for (var j = 0, len = idx.length; j < len; j++) {
            this._add && this._add(idx[j]);
          }
        }
      }
    }
  }
};

function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
  for (var i = 0; i < arr.length; i++) {
    // Add prefix to avoid conflict with Object.prototype.
    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
    var existence = map[key];

    if (existence == null) {
      keyArr.push(key);
      map[key] = i;
    } else {
      if (!existence.length) {
        map[key] = existence = [existence];
      }

      existence.push(i);
    }
  }
}

var _default = DataDiffer;
module.exports = _default;

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var zrender = __webpack_require__(404);

exports.zrender = zrender;

var matrix = __webpack_require__(127);

exports.matrix = matrix;

var vector = __webpack_require__(53);

exports.vector = vector;

var zrUtil = __webpack_require__(6);

var colorTool = __webpack_require__(195);

exports.color = colorTool;

var graphic = __webpack_require__(34);

exports.graphic = graphic;

var numberUtil = __webpack_require__(48);

exports.number = numberUtil;

var formatUtil = __webpack_require__(71);

exports.format = formatUtil;

var _throttle = __webpack_require__(305);

var throttle = _throttle.throttle;
exports.throttle = _throttle.throttle;

var ecHelper = __webpack_require__(1075);

exports.helper = ecHelper;

var _List = __webpack_require__(300);

exports.List = _List;

var _Model = __webpack_require__(70);

exports.Model = _Model;

var _Axis = __webpack_require__(472);

exports.Axis = _Axis;

var _env = __webpack_require__(64);

exports.env = _env;

var _parseGeoJson = __webpack_require__(1072);

exports.parseGeoJson = _parseGeoJson;

/**
 * Do not mount those modules on 'src/echarts' for better tree shaking.
 */
var ecUtil = {};
zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
  ecUtil[name] = zrUtil[name];
});
exports.util = ecUtil;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var createListFromArray = __webpack_require__(299);

var axisHelper = __webpack_require__(137);

var axisModelCommonMixin = __webpack_require__(473);

var Model = __webpack_require__(70);

var _completeDimensions = __webpack_require__(301);

exports.completeDimensions = _completeDimensions;

var _symbol = __webpack_require__(211);

exports.createSymbol = _symbol.createSymbol;

/**
 * Create a muti dimension List structure from seriesModel.
 * @param  {module:echarts/model/Model} seriesModel
 * @return {module:echarts/data/List} list
 */
function createList(seriesModel) {
  var data = seriesModel.get('data');
  return createListFromArray(data, seriesModel, seriesModel.ecModel);
}
/**
 * @see {module:echarts/data/helper/completeDimensions}
 */


/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option
 */
function createScale(dataExtent, option) {
  var axisModel = option;

  if (!(option instanceof Model)) {
    axisModel = new Model(option);
    zrUtil.mixin(axisModel, axisModelCommonMixin);
  }

  var scale = axisHelper.createScaleByModel(axisModel);
  scale.setExtent(dataExtent[0], dataExtent[1]);
  axisHelper.niceScaleExtent(scale, axisModel);
  return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Inlcude methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 * `setRange(start: number, end: number)`
 * `resetRange()`
 */


function mixinAxisModelCommonMethods(Model) {
  zrUtil.mixin(Model, axisModelCommonMixin);
}

exports.createList = createList;
exports.createScale = createScale;
exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var _number = __webpack_require__(48);

var parsePercent = _number.parsePercent;
var STACK_PREFIX = '__ec_stack_';

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim + axis.index;
}
/**
 * @param {Object} opt
 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
 * @param {number} opt.count Positive interger.
 * @param {number} [opt.barWidth]
 * @param {number} [opt.barMaxWidth]
 * @param {number} [opt.barGap]
 * @param {number} [opt.barCategoryGap]
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */


function getLayoutOnAxis(opt, api) {
  var params = [];
  var baseAxis = opt.axis;
  var axisKey = 'axis0';

  if (baseAxis.type !== 'category') {
    return;
  }

  var bandWidth = baseAxis.getBandWidth();

  for (var i = 0; i < opt.count || 0; i++) {
    params.push(zrUtil.defaults({
      bandWidth: bandWidth,
      axisKey: axisKey,
      stackId: STACK_PREFIX + i
    }, opt));
  }

  var widthAndOffsets = doCalBarWidthAndOffset(params, api);
  var result = [];

  for (var i = 0; i < opt.count; i++) {
    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
    item.offsetCenter = item.offset + item.width / 2;
    result.push(item);
  }

  return result;
}

function calBarWidthAndOffset(barSeries, api) {
  var seriesInfoList = zrUtil.map(barSeries, function (seriesModel) {
    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');
    return {
      bandWidth: bandWidth,
      barWidth: barWidth,
      barMaxWidth: barMaxWidth,
      barGap: barGap,
      barCategoryGap: barCategoryGap,
      axisKey: getAxisKey(baseAxis),
      stackId: getSeriesStackId(seriesModel)
    };
  });
  return doCalBarWidthAndOffset(seriesInfoList, api);
}

function doCalBarWidthAndOffset(seriesInfoList, api) {
  // Columns info on each category axis. Key is cartesian name
  var columnsMap = {};
  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
    var axisKey = seriesInfo.axisKey;
    var bandWidth = seriesInfo.bandWidth;
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = seriesInfo.stackId;

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    }; // Caution: In a single coordinate system, these barGrid attributes
    // will be shared by series. Consider that they have default values,
    // only the attributes set on the last series will work.
    // Do not change this fact unless there will be a break change.
    // TODO

    var barWidth = seriesInfo.barWidth;

    if (barWidth && !stacks[stackId].width) {
      // See #6312, do not restrict width.
      stacks[stackId].width = barWidth;
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      columnsOnAxis.remainedWidth -= barWidth;
    }

    var barMaxWidth = seriesInfo.barMaxWidth;
    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    var barGap = seriesInfo.barGap;
    barGap != null && (columnsOnAxis.gap = barGap);
    var barCategoryGap = seriesInfo.barCategoryGap;
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    zrUtil.each(stacks, function (column, stack) {
      var maxWidth = column.maxWidth;

      if (maxWidth && maxWidth < autoWidth) {
        maxWidth = Math.min(maxWidth, remainedWidth);

        if (column.width) {
          maxWidth = Math.min(maxWidth, column.width);
        }

        remainedWidth -= maxWidth;
        column.width = maxWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    zrUtil.each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    zrUtil.each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}
/**
 * @param {string} seriesType
 * @param {module:echarts/model/Global} ecModel
 * @param {module:echarts/ExtensionAPI} api
 */


function barLayoutGrid(seriesType, ecModel, api) {
  var barWidthAndOffset = calBarWidthAndOffset(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
  }));
  var lastStackCoords = {};
  var lastStackCoordsOrigin = {};
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for cartesian2d only
    if (seriesModel.coordinateSystem.type !== 'cartesian2d') {
      return;
    }

    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = cartesian.getOtherAxis(baseAxis);
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    var valueAxisStart = baseAxis.onZero ? valueAxis.toGlobalCoord(valueAxis.dataToCoord(0)) : valueAxis.getGlobalExtent()[0];
    var coordDims = [seriesModel.coordDimToDataDim('x')[0], seriesModel.coordDimToDataDim('y')[0]];
    var coords = data.mapArray(coordDims, function (x, y) {
      return cartesian.dataToPoint([x, y]);
    }, true);
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243

    data.setLayout({
      offset: columnOffset,
      size: columnWidth
    });
    data.each(seriesModel.coordDimToDataDim(valueAxis.dim)[0], function (value, idx) {
      if (isNaN(value)) {
        return;
      }

      if (!lastStackCoords[stackId][idx]) {
        lastStackCoords[stackId][idx] = {
          p: valueAxisStart,
          // Positive stack
          n: valueAxisStart // Negative stack

        };
        lastStackCoordsOrigin[stackId][idx] = {
          p: valueAxisStart,
          // Positive stack
          n: valueAxisStart // Negative stack

        };
      }

      var sign = value >= 0 ? 'p' : 'n';
      var coord = coords[idx];
      var lastCoord = lastStackCoords[stackId][idx][sign];
      var lastCoordOrigin = lastStackCoordsOrigin[stackId][idx][sign];
      var x;
      var y;
      var width;
      var height;

      if (valueAxis.isHorizontal()) {
        x = lastCoord;
        y = coord[1] + columnOffset;
        width = coord[0] - lastCoordOrigin;
        height = columnWidth;
        lastStackCoordsOrigin[stackId][idx][sign] += width;

        if (Math.abs(width) < barMinHeight) {
          width = (width < 0 ? -1 : 1) * barMinHeight;
        }

        lastStackCoords[stackId][idx][sign] += width;
      } else {
        x = coord[0] + columnOffset;
        y = lastCoord;
        width = columnWidth;
        height = coord[1] - lastCoordOrigin;
        lastStackCoordsOrigin[stackId][idx][sign] += height;

        if (Math.abs(height) < barMinHeight) {
          // Include zero to has a positive bar
          height = (height <= 0 ? -1 : 1) * barMinHeight;
        }

        lastStackCoords[stackId][idx][sign] += height;
      }

      data.setItemLayout(idx, {
        x: x,
        y: y,
        width: width,
        height: height
      });
    }, true);
  }, this);
}

barLayoutGrid.getLayoutOnAxis = getLayoutOnAxis;
var _default = barLayoutGrid;
module.exports = _default;

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

function _default(seriesType, ecModel) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      return;
    }

    var dims = [];
    var coordDims = coordSys.dimensions;

    for (var i = 0; i < coordDims.length; i++) {
      dims.push(seriesModel.coordDimToDataDim(coordSys.dimensions[i])[0]);
    }

    if (dims.length === 1) {
      data.each(dims[0], function (x, idx) {
        // Also {Array.<number>}, not undefined to avoid if...else... statement
        data.setItemLayout(idx, isNaN(x) ? [NaN, NaN] : coordSys.dataToPoint(x));
      });
    } else if (dims.length === 2) {
      data.each(dims, function (x, y, idx) {
        // Also {Array.<number>}, not undefined to avoid if...else... statement
        data.setItemLayout(idx, isNaN(x) || isNaN(y) ? [NaN, NaN] : coordSys.dataToPoint([x, y]));
      }, true);
    }
  });
}

module.exports = _default;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var graphic = __webpack_require__(34);

var PI = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */

function _default(api, opts) {
  opts = opts || {};
  zrUtil.defaults(opts, {
    text: 'loading',
    color: '#c23531',
    textColor: '#000',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    zlevel: 0
  });
  var mask = new graphic.Rect({
    style: {
      fill: opts.maskColor
    },
    zlevel: opts.zlevel,
    z: 10000
  });
  var arc = new graphic.Arc({
    shape: {
      startAngle: -PI / 2,
      endAngle: -PI / 2 + 0.1,
      r: 10
    },
    style: {
      stroke: opts.color,
      lineCap: 'round',
      lineWidth: 5
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  var labelRect = new graphic.Rect({
    style: {
      fill: 'none',
      text: opts.text,
      textPosition: 'right',
      textDistance: 10,
      textFill: opts.textColor
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  arc.animateShape(true).when(1000, {
    endAngle: PI * 3 / 2
  }).start('circularInOut');
  arc.animateShape(true).when(1000, {
    startAngle: PI * 3 / 2
  }).delay(300).start('circularInOut');
  var group = new graphic.Group();
  group.add(arc);
  group.add(labelRect);
  group.add(mask); // Inject resize

  group.resize = function () {
    var cx = api.getWidth() / 2;
    var cy = api.getHeight() / 2;
    arc.setShape({
      cx: cx,
      cy: cy
    });
    var r = arc.shape.r;
    labelRect.setShape({
      x: cx - r,
      y: cy - r,
      width: r * 2,
      height: r * 2
    });
    mask.setShape({
      x: 0,
      y: 0,
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  group.resize();
  return group;
}

module.exports = _default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(58);

var __DEV__ = _config.__DEV__;

var zrUtil = __webpack_require__(6);

var modelUtil = __webpack_require__(45);

var Model = __webpack_require__(70);

var ComponentModel = __webpack_require__(102);

var globalDefault = __webpack_require__(1081);

var colorPaletteMinin = __webpack_require__(476);

/**
 * ECharts global model
 *
 * @module {echarts/model/Global}
 */

/**
 * Caution: If the mechanism should be changed some day, these cases
 * should be considered:
 *
 * (1) In `merge option` mode, if using the same option to call `setOption`
 * many times, the result should be the same (try our best to ensure that).
 * (2) In `merge option` mode, if a component has no id/name specified, it
 * will be merged by index, and the result sequence of the components is
 * consistent to the original sequence.
 * (3) `reset` feature (in toolbox). Find detailed info in comments about
 * `mergeOption` in module:echarts/model/OptionManager.
 */
var each = zrUtil.each;
var filter = zrUtil.filter;
var map = zrUtil.map;
var isArray = zrUtil.isArray;
var indexOf = zrUtil.indexOf;
var isObject = zrUtil.isObject;
var OPTION_INNER_KEY = '\0_ec_inner';
/**
 * @alias module:echarts/model/Global
 *
 * @param {Object} option
 * @param {module:echarts/model/Model} parentModel
 * @param {Object} theme
 */

var GlobalModel = Model.extend({
  constructor: GlobalModel,
  init: function (option, parentModel, theme, optionManager) {
    theme = theme || {};
    this.option = null; // Mark as not initialized.

    /**
     * @type {module:echarts/model/Model}
     * @private
     */

    this._theme = new Model(theme);
    /**
     * @type {module:echarts/model/OptionManager}
     */

    this._optionManager = optionManager;
  },
  setOption: function (option, optionPreprocessorFuncs) {
    zrUtil.assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');

    this._optionManager.setOption(option, optionPreprocessorFuncs);

    this.resetOption(null);
  },

  /**
   * @param {string} type null/undefined: reset all.
   *                      'recreate': force recreate all.
   *                      'timeline': only reset timeline option
   *                      'media': only reset media query option
   * @return {boolean} Whether option changed.
   */
  resetOption: function (type) {
    var optionChanged = false;
    var optionManager = this._optionManager;

    if (!type || type === 'recreate') {
      var baseOption = optionManager.mountOption(type === 'recreate');

      if (!this.option || type === 'recreate') {
        initBase.call(this, baseOption);
      } else {
        this.restoreData();
        this.mergeOption(baseOption);
      }

      optionChanged = true;
    }

    if (type === 'timeline' || type === 'media') {
      this.restoreData();
    }

    if (!type || type === 'recreate' || type === 'timeline') {
      var timelineOption = optionManager.getTimelineOption(this);
      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
    }

    if (!type || type === 'recreate' || type === 'media') {
      var mediaOptions = optionManager.getMediaOption(this, this._api);

      if (mediaOptions.length) {
        each(mediaOptions, function (mediaOption) {
          this.mergeOption(mediaOption, optionChanged = true);
        }, this);
      }
    }

    return optionChanged;
  },

  /**
   * @protected
   */
  mergeOption: function (newOption) {
    var option = this.option;
    var componentsMap = this._componentsMap;
    var newCptTypes = []; // 如果不存在对应的 component model 则直接 merge

    each(newOption, function (componentOption, mainType) {
      if (componentOption == null) {
        return;
      }

      if (!ComponentModel.hasClass(mainType)) {
        option[mainType] = option[mainType] == null ? zrUtil.clone(componentOption) : zrUtil.merge(option[mainType], componentOption, true);
      } else {
        newCptTypes.push(mainType);
      }
    }); // FIXME OPTION 同步是否要改回原来的

    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
    this._seriesIndices = this._seriesIndices || [];

    function visitComponent(mainType, dependencies) {
      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.

      each(mapResult, function (item, index) {
        var opt = item.option;

        if (isObject(opt)) {
          item.keyInfo.mainType = mainType;
          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
        }
      });
      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
      option[mainType] = [];
      componentsMap.set(mainType, []);
      each(mapResult, function (resultItem, index) {
        var componentModel = resultItem.exist;
        var newCptOption = resultItem.option;
        zrUtil.assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
        // see removeEdgeAndAdd in topologicalTravel and
        // ComponentModel.getAllClassMainTypes.

        if (!newCptOption) {
          componentModel.mergeOption({}, this);
          componentModel.optionUpdated({}, false);
        } else {
          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);

          if (componentModel && componentModel instanceof ComponentModelClass) {
            componentModel.name = resultItem.keyInfo.name;
            componentModel.mergeOption(newCptOption, this);
            componentModel.optionUpdated(newCptOption, false);
          } else {
            // PENDING Global as parent ?
            var extraOpt = zrUtil.extend({
              dependentModels: dependentModels,
              componentIndex: index
            }, resultItem.keyInfo);
            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
            zrUtil.extend(componentModel, extraOpt);
            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
            // newCptOption has been used as componentModel.option
            // and may be merged with theme and default, so pass null
            // to avoid confusion.

            componentModel.optionUpdated(null, true);
          }
        }

        componentsMap.get(mainType)[index] = componentModel;
        option[mainType][index] = componentModel.option;
      }, this); // Backup series for filtering.

      if (mainType === 'series') {
        this._seriesIndices = createSeriesIndices(componentsMap.get('series'));
      }
    }
  },

  /**
   * Get option for output (cloned option and inner info removed)
   * @public
   * @return {Object}
   */
  getOption: function () {
    var option = zrUtil.clone(this.option);
    each(option, function (opts, mainType) {
      if (ComponentModel.hasClass(mainType)) {
        var opts = modelUtil.normalizeToArray(opts);

        for (var i = opts.length - 1; i >= 0; i--) {
          // Remove options with inner id.
          if (modelUtil.isIdInner(opts[i])) {
            opts.splice(i, 1);
          }
        }

        option[mainType] = opts;
      }
    });
    delete option[OPTION_INNER_KEY];
    return option;
  },

  /**
   * @return {module:echarts/model/Model}
   */
  getTheme: function () {
    return this._theme;
  },

  /**
   * @param {string} mainType
   * @param {number} [idx=0]
   * @return {module:echarts/model/Component}
   */
  getComponent: function (mainType, idx) {
    var list = this._componentsMap.get(mainType);

    if (list) {
      return list[idx || 0];
    }
  },

  /**
   * If none of index and id and name used, return all components with mainType.
   * @param {Object} condition
   * @param {string} condition.mainType
   * @param {string} [condition.subType] If ignore, only query by mainType
   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
   * @return {Array.<module:echarts/model/Component>}
   */
  queryComponents: function (condition) {
    var mainType = condition.mainType;

    if (!mainType) {
      return [];
    }

    var index = condition.index;
    var id = condition.id;
    var name = condition.name;

    var cpts = this._componentsMap.get(mainType);

    if (!cpts || !cpts.length) {
      return [];
    }

    var result;

    if (index != null) {
      if (!isArray(index)) {
        index = [index];
      }

      result = filter(map(index, function (idx) {
        return cpts[idx];
      }), function (val) {
        return !!val;
      });
    } else if (id != null) {
      var isIdArray = isArray(id);
      result = filter(cpts, function (cpt) {
        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
      });
    } else if (name != null) {
      var isNameArray = isArray(name);
      result = filter(cpts, function (cpt) {
        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
      });
    } else {
      // Return all components with mainType
      result = cpts.slice();
    }

    return filterBySubType(result, condition);
  },

  /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * var result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * var result = findComponents(
   *     {mainType: 'series'},
   *     function (model, index) {...}
   * );
   * // result like [component0, componnet1, ...]
   *
   * @param {Object} condition
   * @param {string} condition.mainType Mandatory.
   * @param {string} [condition.subType] Optional.
   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
   *        where xxx is mainType.
   *        If query attribute is null/undefined or has no index/id/name,
   *        do not filtering by query conditions, which is convenient for
   *        no-payload situations or when target of action is global.
   * @param {Function} [condition.filter] parameter: component, return boolean.
   * @return {Array.<module:echarts/model/Component>}
   */
  findComponents: function (condition) {
    var query = condition.query;
    var mainType = condition.mainType;
    var queryCond = getQueryCond(query);
    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
    return doFilter(filterBySubType(result, condition));

    function getQueryCond(q) {
      var indexAttr = mainType + 'Index';
      var idAttr = mainType + 'Id';
      var nameAttr = mainType + 'Name';
      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
        mainType: mainType,
        // subType will be filtered finally.
        index: q[indexAttr],
        id: q[idAttr],
        name: q[nameAttr]
      } : null;
    }

    function doFilter(res) {
      return condition.filter ? filter(res, condition.filter) : res;
    }
  },

  /**
   * @usage
   * eachComponent('legend', function (legendModel, index) {
   *     ...
   * });
   * eachComponent(function (componentType, model, index) {
   *     // componentType does not include subType
   *     // (componentType is 'xxx' but not 'xxx.aa')
   * });
   * eachComponent(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
   *     function (model, index) {...}
   * );
   * eachComponent(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
   *     function (model, index) {...}
   * );
   *
   * @param {string|Object=} mainType When mainType is object, the definition
   *                                  is the same as the method 'findComponents'.
   * @param {Function} cb
   * @param {*} context
   */
  eachComponent: function (mainType, cb, context) {
    var componentsMap = this._componentsMap;

    if (typeof mainType === 'function') {
      context = cb;
      cb = mainType;
      componentsMap.each(function (components, componentType) {
        each(components, function (component, index) {
          cb.call(context, componentType, component, index);
        });
      });
    } else if (zrUtil.isString(mainType)) {
      each(componentsMap.get(mainType), cb, context);
    } else if (isObject(mainType)) {
      var queryResult = this.findComponents(mainType);
      each(queryResult, cb, context);
    }
  },

  /**
   * @param {string} name
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByName: function (name) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.name === name;
    });
  },

  /**
   * @param {number} seriesIndex
   * @return {module:echarts/model/Series}
   */
  getSeriesByIndex: function (seriesIndex) {
    return this._componentsMap.get('series')[seriesIndex];
  },

  /**
   * @param {string} subType
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeriesByType: function (subType) {
    var series = this._componentsMap.get('series');

    return filter(series, function (oneSeries) {
      return oneSeries.subType === subType;
    });
  },

  /**
   * @return {Array.<module:echarts/model/Series>}
   */
  getSeries: function () {
    return this._componentsMap.get('series').slice();
  },

  /**
   * After filtering, series may be different
   * frome raw series.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachSeries: function (cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      cb.call(context, series, rawSeriesIndex);
    }, this);
  },

  /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeries: function (cb, context) {
    each(this._componentsMap.get('series'), cb, context);
  },

  /**
   * After filtering, series may be different.
   * frome raw series.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */
  eachSeriesByType: function (subType, cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      if (series.subType === subType) {
        cb.call(context, series, rawSeriesIndex);
      }
    }, this);
  },

  /**
   * Iterate raw series before filtered of given type.
   *
   * @parma {string} subType
   * @param {Function} cb
   * @param {*} context
   */
  eachRawSeriesByType: function (subType, cb, context) {
    return each(this.getSeriesByType(subType), cb, context);
  },

  /**
   * @param {module:echarts/model/Series} seriesModel
   */
  isSeriesFiltered: function (seriesModel) {
    assertSeriesInitialized(this);
    return zrUtil.indexOf(this._seriesIndices, seriesModel.componentIndex) < 0;
  },

  /**
   * @return {Array.<number>}
   */
  getCurrentSeriesIndices: function () {
    return (this._seriesIndices || []).slice();
  },

  /**
   * @param {Function} cb
   * @param {*} context
   */
  filterSeries: function (cb, context) {
    assertSeriesInitialized(this);
    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
    this._seriesIndices = createSeriesIndices(filteredSeries);
  },
  restoreData: function () {
    var componentsMap = this._componentsMap;
    this._seriesIndices = createSeriesIndices(componentsMap.get('series'));
    var componentTypes = [];
    componentsMap.each(function (components, componentType) {
      componentTypes.push(componentType);
    });
    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
      each(componentsMap.get(componentType), function (component) {
        component.restoreData();
      });
    });
  }
});
/**
 * @inner
 */

function mergeTheme(option, theme) {
  zrUtil.each(theme, function (themeItem, name) {
    // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
    if (!ComponentModel.hasClass(name)) {
      if (typeof themeItem === 'object') {
        option[name] = !option[name] ? zrUtil.clone(themeItem) : zrUtil.merge(option[name], themeItem, false);
      } else {
        if (option[name] == null) {
          option[name] = themeItem;
        }
      }
    }
  });
}

function initBase(baseOption) {
  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.

  this.option = {};
  this.option[OPTION_INNER_KEY] = 1;
  /**
   * Init with series: [], in case of calling findSeries method
   * before series initialized.
   * @type {Object.<string, Array.<module:echarts/model/Model>>}
   * @private
   */

  this._componentsMap = zrUtil.createHashMap({
    series: []
  });
  /**
   * Mapping between filtered series list and raw series list.
   * key: filtered series indices, value: raw series indices.
   * @type {Array.<nubmer>}
   * @private
   */

  this._seriesIndices = null;
  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property

  zrUtil.merge(baseOption, globalDefault, false);
  this.mergeOption(baseOption);
}
/**
 * @inner
 * @param {Array.<string>|string} types model types
 * @return {Object} key: {string} type, value: {Array.<Object>} models
 */


function getComponentsByTypes(componentsMap, types) {
  if (!zrUtil.isArray(types)) {
    types = types ? [types] : [];
  }

  var ret = {};
  each(types, function (type) {
    ret[type] = (componentsMap.get(type) || []).slice();
  });
  return ret;
}
/**
 * @inner
 */


function determineSubType(mainType, newCptOption, existComponent) {
  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType

  return subType;
}
/**
 * @inner
 */


function createSeriesIndices(seriesModels) {
  return map(seriesModels, function (series) {
    return series.componentIndex;
  }) || [];
}
/**
 * @inner
 */


function filterBySubType(components, condition) {
  // Using hasOwnProperty for restrict. Consider
  // subType is undefined in user payload.
  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
    return cpt.subType === condition.subType;
  }) : components;
}
/**
 * @inner
 */


function assertSeriesInitialized(ecModel) {}

zrUtil.mixin(GlobalModel, colorPaletteMinin);
var _default = GlobalModel;
module.exports = _default;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var modelUtil = __webpack_require__(45);

var ComponentModel = __webpack_require__(102);

/**
 * ECharts option manager
 *
 * @module {echarts/model/OptionManager}
 */
var each = zrUtil.each;
var clone = zrUtil.clone;
var map = zrUtil.map;
var merge = zrUtil.merge;
var QUERY_REG = /^(min|max)?(.+)$/;
/**
 * TERM EXPLANATIONS:
 *
 * [option]:
 *
 *     An object that contains definitions of components. For example:
 *     var option = {
 *         title: {...},
 *         legend: {...},
 *         visualMap: {...},
 *         series: [
 *             {data: [...]},
 *             {data: [...]},
 *             ...
 *         ]
 *     };
 *
 * [rawOption]:
 *
 *     An object input to echarts.setOption. 'rawOption' may be an
 *     'option', or may be an object contains multi-options. For example:
 *     var option = {
 *         baseOption: {
 *             title: {...},
 *             legend: {...},
 *             series: [
 *                 {data: [...]},
 *                 {data: [...]},
 *                 ...
 *             ]
 *         },
 *         timeline: {...},
 *         options: [
 *             {title: {...}, series: {data: [...]}},
 *             {title: {...}, series: {data: [...]}},
 *             ...
 *         ],
 *         media: [
 *             {
 *                 query: {maxWidth: 320},
 *                 option: {series: {x: 20}, visualMap: {show: false}}
 *             },
 *             {
 *                 query: {minWidth: 320, maxWidth: 720},
 *                 option: {series: {x: 500}, visualMap: {show: true}}
 *             },
 *             {
 *                 option: {series: {x: 1200}, visualMap: {show: true}}
 *             }
 *         ]
 *     };
 *
 * @alias module:echarts/model/OptionManager
 * @param {module:echarts/ExtensionAPI} api
 */

function OptionManager(api) {
  /**
   * @private
   * @type {module:echarts/ExtensionAPI}
   */
  this._api = api;
  /**
   * @private
   * @type {Array.<number>}
   */

  this._timelineOptions = [];
  /**
   * @private
   * @type {Array.<Object>}
   */

  this._mediaList = [];
  /**
   * @private
   * @type {Object}
   */

  this._mediaDefault;
  /**
   * -1, means default.
   * empty means no media.
   * @private
   * @type {Array.<number>}
   */

  this._currentMediaIndices = [];
  /**
   * @private
   * @type {Object}
   */

  this._optionBackup;
  /**
   * @private
   * @type {Object}
   */

  this._newBaseOption;
} // timeline.notMerge is not supported in ec3. Firstly there is rearly
// case that notMerge is needed. Secondly supporting 'notMerge' requires
// rawOption cloned and backuped when timeline changed, which does no
// good to performance. What's more, that both timeline and setOption
// method supply 'notMerge' brings complex and some problems.
// Consider this case:
// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);


OptionManager.prototype = {
  constructor: OptionManager,

  /**
   * @public
   * @param {Object} rawOption Raw option.
   * @param {module:echarts/model/Global} ecModel
   * @param {Array.<Function>} optionPreprocessorFuncs
   * @return {Object} Init option
   */
  setOption: function (rawOption, optionPreprocessorFuncs) {
    rawOption = clone(rawOption, true); // FIXME
    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。

    var oldOptionBackup = this._optionBackup;
    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);

    if (oldOptionBackup) {
      // Only baseOption can be merged.
      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
      // that is, if you `setOption` twice and both has timeline options, the latter
      // timeline opitons will not be merged to the formers, but just substitude them.

      if (newParsedOption.timelineOptions.length) {
        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
      }

      if (newParsedOption.mediaList.length) {
        oldOptionBackup.mediaList = newParsedOption.mediaList;
      }

      if (newParsedOption.mediaDefault) {
        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
      }
    } else {
      this._optionBackup = newParsedOption;
    }
  },

  /**
   * @param {boolean} isRecreate
   * @return {Object}
   */
  mountOption: function (isRecreate) {
    var optionBackup = this._optionBackup; // TODO
    // 如果没有reset功能则不clone。

    this._timelineOptions = map(optionBackup.timelineOptions, clone);
    this._mediaList = map(optionBackup.mediaList, clone);
    this._mediaDefault = clone(optionBackup.mediaDefault);
    this._currentMediaIndices = [];
    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
    // called, and is merged into every new option by inner method `mergeOption`
    // each time `setOption` called, can be only used in `isRecreate`, because
    // its reliability is under suspicion. In other cases option merge is
    // performed by `model.mergeOption`.
    ? optionBackup.baseOption : this._newBaseOption);
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Object}
   */
  getTimelineOption: function (ecModel) {
    var option;
    var timelineOptions = this._timelineOptions;

    if (timelineOptions.length) {
      // getTimelineOption can only be called after ecModel inited,
      // so we can get currentIndex from timelineModel.
      var timelineModel = ecModel.getComponent('timeline');

      if (timelineModel) {
        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
      }
    }

    return option;
  },

  /**
   * @param {module:echarts/model/Global} ecModel
   * @return {Array.<Object>}
   */
  getMediaOption: function (ecModel) {
    var ecWidth = this._api.getWidth();

    var ecHeight = this._api.getHeight();

    var mediaList = this._mediaList;
    var mediaDefault = this._mediaDefault;
    var indices = [];
    var result = []; // No media defined.

    if (!mediaList.length && !mediaDefault) {
      return result;
    } // Multi media may be applied, the latter defined media has higher priority.


    for (var i = 0, len = mediaList.length; i < len; i++) {
      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
        indices.push(i);
      }
    } // FIXME
    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。


    if (!indices.length && mediaDefault) {
      indices = [-1];
    }

    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
      result = map(indices, function (index) {
        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
      });
    } // Otherwise return nothing.


    this._currentMediaIndices = indices;
    return result;
  }
};

function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
  var timelineOptions = [];
  var mediaList = [];
  var mediaDefault;
  var baseOption; // Compatible with ec2.

  var timelineOpt = rawOption.timeline;

  if (rawOption.baseOption) {
    baseOption = rawOption.baseOption;
  } // For timeline


  if (timelineOpt || rawOption.options) {
    baseOption = baseOption || {};
    timelineOptions = (rawOption.options || []).slice();
  } // For media query


  if (rawOption.media) {
    baseOption = baseOption || {};
    var media = rawOption.media;
    each(media, function (singleMedia) {
      if (singleMedia && singleMedia.option) {
        if (singleMedia.query) {
          mediaList.push(singleMedia);
        } else if (!mediaDefault) {
          // Use the first media default.
          mediaDefault = singleMedia;
        }
      }
    });
  } // For normal option


  if (!baseOption) {
    baseOption = rawOption;
  } // Set timelineOpt to baseOption in ec3,
  // which is convenient for merge option.


  if (!baseOption.timeline) {
    baseOption.timeline = timelineOpt;
  } // Preprocess.


  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
    return media.option;
  })), function (option) {
    each(optionPreprocessorFuncs, function (preProcess) {
      preProcess(option, isNew);
    });
  });
  return {
    baseOption: baseOption,
    timelineOptions: timelineOptions,
    mediaDefault: mediaDefault,
    mediaList: mediaList
  };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */


function applyMediaQuery(query, ecWidth, ecHeight) {
  var realMap = {
    width: ecWidth,
    height: ecHeight,
    aspectratio: ecWidth / ecHeight // lowser case for convenientce.

  };
  var applicatable = true;
  zrUtil.each(query, function (value, attr) {
    var matched = attr.match(QUERY_REG);

    if (!matched || !matched[1] || !matched[2]) {
      return;
    }

    var operator = matched[1];
    var realAttr = matched[2].toLowerCase();

    if (!compare(realMap[realAttr], value, operator)) {
      applicatable = false;
    }
  });
  return applicatable;
}

function compare(real, expect, operator) {
  if (operator === 'min') {
    return real >= expect;
  } else if (operator === 'max') {
    return real <= expect;
  } else {
    // Equals
    return real === expect;
  }
}

function indicesEquals(indices1, indices2) {
  // indices is always order by asc and has only finite number.
  return indices1.join(',') === indices2.join(',');
}
/**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 */


function mergeOption(oldOption, newOption) {
  newOption = newOption || {};
  each(newOption, function (newCptOpt, mainType) {
    if (newCptOpt == null) {
      return;
    }

    var oldCptOpt = oldOption[mainType];

    if (!ComponentModel.hasClass(mainType)) {
      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
    } else {
      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
      oldOption[mainType] = map(mapResult, function (item) {
        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
      });
    }
  });
}

var _default = OptionManager;
module.exports = _default;

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

var platform = ''; // Navigator not exists in node

if (typeof navigator !== 'undefined') {
  platform = navigator.platform || '';
}

var _default = {
  // 全图默认背景
  // backgroundColor: 'rgba(0,0,0,0)',
  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
  // 浅色
  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
  // 深色
  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
  // 默认需要 Grid 配置项
  // grid: {},
  // 主题，主题
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  animation: 'auto',
  animationDuration: 1000,
  animationDurationUpdate: 300,
  animationEasing: 'exponentialOut',
  animationEasingUpdate: 'cubicOut',
  animationThreshold: 2000,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3000,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3000,
  // See: module:echarts/scale/Time
  useUTC: false
};
module.exports = _default;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(209);

var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
var _default = {
  getAreaStyle: function (excludes, includes) {
    return getAreaStyle(this, excludes, includes);
  }
};
module.exports = _default;

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

var _default = {
  getBoxLayoutParams: function () {
    return {
      left: this.get('left'),
      top: this.get('top'),
      right: this.get('right'),
      bottom: this.get('bottom'),
      width: this.get('width'),
      height: this.get('height')
    };
  }
};
module.exports = _default;

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(209);

var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
var _default = {
  getItemStyle: function (excludes, includes) {
    var style = getItemStyle(this, excludes, includes);
    var lineDash = this.getBorderLineDash();
    lineDash && (style.lineDash = lineDash);
    return style;
  },
  getBorderLineDash: function () {
    var lineType = this.get('borderType');
    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
  }
};
module.exports = _default;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var makeStyleMapper = __webpack_require__(209);

var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
var _default = {
  getLineStyle: function (excludes) {
    var style = getLineStyle(this, excludes);
    var lineDash = this.getLineDash(style.lineWidth);
    lineDash && (style.lineDash = lineDash);
    return style;
  },
  getLineDash: function (lineWidth) {
    if (lineWidth == null) {
      lineWidth = 1;
    }

    var lineType = this.get('type');
    var dotSize = Math.max(lineWidth, 2);
    var dashSize = lineWidth * 4;
    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
  }
};
module.exports = _default;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var textContain = __webpack_require__(112);

var graphicUtil = __webpack_require__(34);

var PATH_COLOR = ['textStyle', 'color'];
var _default = {
  /**
   * Get color property or get color from option.textStyle.color
   * @param {boolean} [isEmphasis]
   * @return {string}
   */
  getTextColor: function (isEmphasis) {
    var ecModel = this.ecModel;
    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
  },

  /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */
  getFont: function () {
    return graphicUtil.getFont({
      fontStyle: this.getShallow('fontStyle'),
      fontWeight: this.getShallow('fontWeight'),
      fontSize: this.getShallow('fontSize'),
      fontFamily: this.getShallow('fontFamily')
    }, this.ecModel);
  },
  getTextRect: function (text) {
    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('rich'), this.getShallow('truncateText'));
  }
};
module.exports = _default;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(6);

var each = _util.each;
var isArray = _util.isArray;
var isObject = _util.isObject;

var compatStyle = __webpack_require__(1088);

var _model = __webpack_require__(45);

var normalizeToArray = _model.normalizeToArray;

// Compatitable with 2.0
function get(opt, path) {
  path = path.split(',');
  var obj = opt;

  for (var i = 0; i < path.length; i++) {
    obj = obj && obj[path[i]];

    if (obj == null) {
      break;
    }
  }

  return obj;
}

function set(opt, path, val, overwrite) {
  path = path.split(',');
  var obj = opt;
  var key;

  for (var i = 0; i < path.length - 1; i++) {
    key = path[i];

    if (obj[key] == null) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (overwrite || obj[path[i]] == null) {
    obj[path[i]] = val;
  }
}

function compatLayoutProperties(option) {
  each(LAYOUT_PROPERTIES, function (prop) {
    if (prop[0] in option && !(prop[1] in option)) {
      option[prop[1]] = option[prop[0]];
    }
  });
}

var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
var COMPATITABLE_SERIES = ['bar', 'boxplot', 'candlestick', 'chord', 'effectScatter', 'funnel', 'gauge', 'lines', 'graph', 'heatmap', 'line', 'map', 'parallel', 'pie', 'radar', 'sankey', 'scatter', 'treemap'];

function _default(option, isTheme) {
  compatStyle(option, isTheme); // Make sure series array for model initialization.

  option.series = normalizeToArray(option.series);
  each(option.series, function (seriesOpt) {
    if (!isObject(seriesOpt)) {
      return;
    }

    var seriesType = seriesOpt.type;

    if (seriesType === 'pie' || seriesType === 'gauge') {
      if (seriesOpt.clockWise != null) {
        seriesOpt.clockwise = seriesOpt.clockWise;
      }
    }

    if (seriesType === 'gauge') {
      var pointerColor = get(seriesOpt, 'pointer.color');
      pointerColor != null && set(seriesOpt, 'itemStyle.normal.color', pointerColor);
    }

    for (var i = 0; i < COMPATITABLE_SERIES.length; i++) {
      if (COMPATITABLE_SERIES[i] === seriesOpt.type) {
        compatLayoutProperties(seriesOpt);
        break;
      }
    }
  }); // dataRange has changed to visualMap

  if (option.dataRange) {
    option.visualMap = option.dataRange;
  }

  each(COMPATITABLE_COMPONENTS, function (componentName) {
    var options = option[componentName];

    if (options) {
      if (!isArray(options)) {
        options = [options];
      }

      each(options, function (option) {
        compatLayoutProperties(option);
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var modelUtil = __webpack_require__(45);

var each = zrUtil.each;
var isObject = zrUtil.isObject;
var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];

function compatItemStyle(opt) {
  var itemStyleOpt = opt && opt.itemStyle;

  if (!itemStyleOpt) {
    return;
  }

  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
    var styleName = POSSIBLE_STYLES[i];
    var normalItemStyleOpt = itemStyleOpt.normal;
    var emphasisItemStyleOpt = itemStyleOpt.emphasis;

    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].normal) {
        opt[styleName].normal = normalItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
      }

      normalItemStyleOpt[styleName] = null;
    }

    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].emphasis) {
        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
      } else {
        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
      }

      emphasisItemStyleOpt[styleName] = null;
    }
  }
}

function compatTextStyle(opt, propName) {
  var labelOptSingle = isObject(opt) && opt[propName];
  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;

  if (textStyle) {
    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];

      if (textStyle.hasOwnProperty(propName)) {
        labelOptSingle[propName] = textStyle[propName];
      }
    }
  }
}

function compatLabelTextStyle(labelOpt) {
  if (isObject(labelOpt)) {
    compatTextStyle(labelOpt, 'normal');
    compatTextStyle(labelOpt, 'emphasis');
  }
}

function processSeries(seriesOpt) {
  if (!isObject(seriesOpt)) {
    return;
  }

  compatItemStyle(seriesOpt);
  compatLabelTextStyle(seriesOpt.label); // treemap

  compatLabelTextStyle(seriesOpt.upperLabel); // graph

  compatLabelTextStyle(seriesOpt.edgeLabel);
  var markPoint = seriesOpt.markPoint;
  compatItemStyle(markPoint);
  compatLabelTextStyle(markPoint && markPoint.label);
  var markLine = seriesOpt.markLine;
  compatItemStyle(seriesOpt.markLine);
  compatLabelTextStyle(markLine && markLine.label);
  var markArea = seriesOpt.markArea;
  compatLabelTextStyle(markArea && markArea.label); // For gauge

  compatTextStyle(seriesOpt, 'axisLabel');
  compatTextStyle(seriesOpt, 'title');
  compatTextStyle(seriesOpt, 'detail');
  var data = seriesOpt.data;

  if (data) {
    for (var i = 0; i < data.length; i++) {
      compatItemStyle(data[i]);
      compatLabelTextStyle(data[i] && data[i].label);
    }
  } // mark point data


  var markPoint = seriesOpt.markPoint;

  if (markPoint && markPoint.data) {
    var mpData = markPoint.data;

    for (var i = 0; i < mpData.length; i++) {
      compatItemStyle(mpData[i]);
      compatLabelTextStyle(mpData[i] && mpData[i].label);
    }
  } // mark line data


  var markLine = seriesOpt.markLine;

  if (markLine && markLine.data) {
    var mlData = markLine.data;

    for (var i = 0; i < mlData.length; i++) {
      if (zrUtil.isArray(mlData[i])) {
        compatItemStyle(mlData[i][0]);
        compatLabelTextStyle(mlData[i][0] && mlData[i][0].label);
        compatItemStyle(mlData[i][1]);
        compatLabelTextStyle(mlData[i][1] && mlData[i][1].label);
      } else {
        compatItemStyle(mlData[i]);
        compatLabelTextStyle(mlData[i] && mlData[i].label);
      }
    }
  }
}

function toArr(o) {
  return zrUtil.isArray(o) ? o : o ? [o] : [];
}

function toObj(o) {
  return (zrUtil.isArray(o) ? o[0] : o) || {};
}

function _default(option, isTheme) {
  each(toArr(option.series), function (seriesOpt) {
    isObject(seriesOpt) && processSeries(seriesOpt);
  });
  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
  each(axes, function (axisName) {
    each(toArr(option[axisName]), function (axisOpt) {
      if (axisOpt) {
        compatTextStyle(axisOpt, 'axisLabel');
        compatTextStyle(axisOpt.axisPointer, 'label');
      }
    });
  });
  each(toArr(option.parallel), function (parallelOpt) {
    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
    compatTextStyle(parallelAxisDefault, 'axisLabel');
    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
  });
  each(toArr(option.calendar), function (calendarOpt) {
    compatTextStyle(calendarOpt, 'dayLabel');
    compatTextStyle(calendarOpt, 'monthLabel');
    compatTextStyle(calendarOpt, 'yearLabel');
  }); // radar.name.textStyle

  each(toArr(option.radar), function (radarOpt) {
    compatTextStyle(radarOpt, 'name');
  });
  each(toArr(option.geo), function (geoOpt) {
    if (isObject(geoOpt)) {
      compatLabelTextStyle(geoOpt.label);
      each(toArr(geoOpt.regions), function (regionObj) {
        compatLabelTextStyle(regionObj.label);
      });
    }
  });
  compatLabelTextStyle(toObj(option.timeline).label);
  compatTextStyle(toObj(option.axisPointer), 'label');
  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
}

module.exports = _default;

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

function _default(seriesType, ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (!legendModels || !legendModels.length) {
    return;
  }

  ecModel.eachSeriesByType(seriesType, function (series) {
    var data = series.getData();
    data.filterSelf(function (idx) {
      var name = data.getName(idx); // If in any legend component the status is not selected.

      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(name)) {
          return false;
        }
      }

      return true;
    }, this);
  }, this);
}

module.exports = _default;

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

var samplers = {
  average: function (frame) {
    var sum = 0;
    var count = 0;

    for (var i = 0; i < frame.length; i++) {
      if (!isNaN(frame[i])) {
        sum += frame[i];
        count++;
      }
    } // Return NaN if count is 0


    return count === 0 ? NaN : sum / count;
  },
  sum: function (frame) {
    var sum = 0;

    for (var i = 0; i < frame.length; i++) {
      // Ignore NaN
      sum += frame[i] || 0;
    }

    return sum;
  },
  max: function (frame) {
    var max = -Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] > max && (max = frame[i]);
    }

    return max;
  },
  min: function (frame) {
    var min = Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] < min && (min = frame[i]);
    }

    return min;
  },
  // TODO
  // Median
  nearest: function (frame) {
    return frame[0];
  }
};

var indexSampler = function (frame, value) {
  return Math.round(frame.length / 2);
};

function _default(seriesType, ecModel, api) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var sampling = seriesModel.get('sampling');
    var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling

    if (coordSys.type === 'cartesian2d' && sampling) {
      var baseAxis = coordSys.getBaseAxis();
      var valueAxis = coordSys.getOtherAxis(baseAxis);
      var extent = baseAxis.getExtent(); // Coordinste system has been resized

      var size = extent[1] - extent[0];
      var rate = Math.round(data.count() / size);

      if (rate > 1) {
        var sampler;

        if (typeof sampling === 'string') {
          sampler = samplers[sampling];
        } else if (typeof sampling === 'function') {
          sampler = sampling;
        }

        if (sampler) {
          data = data.downSample(valueAxis.dim, 1 / rate, sampler, indexSampler);
          seriesModel.setData(data);
        }
      }
    }
  }, this);
}

module.exports = _default;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Scale = __webpack_require__(210);

var numberUtil = __webpack_require__(48);

var IntervalScale = __webpack_require__(303);

/**
 * Log scale
 * @module echarts/scale/Log
 */
// Use some method of IntervalScale
var scaleProto = Scale.prototype;
var intervalScaleProto = IntervalScale.prototype;
var getPrecisionSafe = numberUtil.getPrecisionSafe;
var roundingErrorFix = numberUtil.round;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathPow = Math.pow;
var mathLog = Math.log;
var LogScale = Scale.extend({
  type: 'log',
  base: 10,
  $constructor: function () {
    Scale.apply(this, arguments);
    this._originalScale = new IntervalScale();
  },

  /**
   * @return {Array.<number>}
   */
  getTicks: function () {
    var originalScale = this._originalScale;
    var extent = this._extent;
    var originalExtent = originalScale.getExtent();
    return zrUtil.map(intervalScaleProto.getTicks.call(this), function (val) {
      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158

      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
      return powVal;
    }, this);
  },

  /**
   * @param {number} val
   * @return {string}
   */
  getLabel: intervalScaleProto.getLabel,

  /**
   * @param  {number} val
   * @return {number}
   */
  scale: function (val) {
    val = scaleProto.scale.call(this, val);
    return mathPow(this.base, val);
  },

  /**
   * @param {number} start
   * @param {number} end
   */
  setExtent: function (start, end) {
    var base = this.base;
    start = mathLog(start) / mathLog(base);
    end = mathLog(end) / mathLog(base);
    intervalScaleProto.setExtent.call(this, start, end);
  },

  /**
   * @return {number} end
   */
  getExtent: function () {
    var base = this.base;
    var extent = scaleProto.getExtent.call(this);
    extent[0] = mathPow(base, extent[0]);
    extent[1] = mathPow(base, extent[1]); // Fix #4158

    var originalScale = this._originalScale;
    var originalExtent = originalScale.getExtent();
    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
    return extent;
  },

  /**
   * @param  {Array.<number>} extent
   */
  unionExtent: function (extent) {
    this._originalScale.unionExtent(extent);

    var base = this.base;
    extent[0] = mathLog(extent[0]) / mathLog(base);
    extent[1] = mathLog(extent[1]) / mathLog(base);
    scaleProto.unionExtent.call(this, extent);
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    this.unionExtent(data.getDataExtent(dim, true, function (val) {
      return val > 0;
    }));
  },

  /**
   * Update interval and extent of intervals for nice ticks
   * @param  {number} [approxTickNum = 10] Given approx tick number
   */
  niceTicks: function (approxTickNum) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (span === Infinity || span <= 0) {
      return;
    }

    var interval = numberUtil.quantity(span);
    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.

    if (err <= 0.5) {
      interval *= 10;
    } // Interval should be integer


    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
      interval *= 10;
    }

    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
    this._interval = interval;
    this._niceExtent = niceExtent;
  },

  /**
   * Nice extent.
   * @override
   */
  niceExtent: function (opt) {
    intervalScaleProto.niceExtent.call(this, opt);
    var originalScale = this._originalScale;
    originalScale.__fixMin = opt.fixMin;
    originalScale.__fixMax = opt.fixMax;
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  LogScale.prototype[methodName] = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return scaleProto[methodName].call(this, val);
  };
});

LogScale.create = function () {
  return new LogScale();
};

function fixRoundingError(val, originalVal) {
  return roundingErrorFix(val, getPrecisionSafe(originalVal));
}

var _default = LogScale;
module.exports = _default;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Scale = __webpack_require__(210);

/**
 * Linear continuous scale
 * @module echarts/coord/scale/Ordinal
 *
 * http://en.wikipedia.org/wiki/Level_of_measurement
 */
// FIXME only one data
var scaleProto = Scale.prototype;
var OrdinalScale = Scale.extend({
  type: 'ordinal',
  init: function (data, extent) {
    this._data = data;
    this._extent = extent || [0, data.length - 1];
  },
  parse: function (val) {
    return typeof val === 'string' ? zrUtil.indexOf(this._data, val) // val might be float.
    : Math.round(val);
  },
  contain: function (rank) {
    rank = this.parse(rank);
    return scaleProto.contain.call(this, rank) && this._data[rank] != null;
  },

  /**
   * Normalize given rank or name to linear [0, 1]
   * @param {number|string} [val]
   * @return {number}
   */
  normalize: function (val) {
    return scaleProto.normalize.call(this, this.parse(val));
  },
  scale: function (val) {
    return Math.round(scaleProto.scale.call(this, val));
  },

  /**
   * @return {Array}
   */
  getTicks: function () {
    var ticks = [];
    var extent = this._extent;
    var rank = extent[0];

    while (rank <= extent[1]) {
      ticks.push(rank);
      rank++;
    }

    return ticks;
  },

  /**
   * Get item on rank n
   * @param {number} n
   * @return {string}
   */
  getLabel: function (n) {
    return this._data[n];
  },

  /**
   * @return {number}
   */
  count: function () {
    return this._extent[1] - this._extent[0] + 1;
  },

  /**
   * @override
   */
  unionExtentFromData: function (data, dim) {
    this.unionExtent(data.getDataExtent(dim, false));
  },
  niceTicks: zrUtil.noop,
  niceExtent: zrUtil.noop
});
/**
 * @return {module:echarts/scale/Time}
 */

OrdinalScale.create = function () {
  return new OrdinalScale();
};

var _default = OrdinalScale;
module.exports = _default;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var numberUtil = __webpack_require__(48);

var formatUtil = __webpack_require__(71);

var scaleHelper = __webpack_require__(477);

var IntervalScale = __webpack_require__(303);

// [About UTC and local time zone]:
// In most cases, `number.parseDate` will treat input data string as local time
// (except time zone is specified in time string). And `format.formateTime` returns
// local time by default. option.useUTC is false by default. This design have
// concidered these common case:
// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
// in local time by default.
// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
// as its original time, without any time difference.
var intervalScaleProto = IntervalScale.prototype;
var mathCeil = Math.ceil;
var mathFloor = Math.floor;
var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？

var bisect = function (a, x, lo, hi) {
  while (lo < hi) {
    var mid = lo + hi >>> 1;

    if (a[mid][1] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};
/**
 * @alias module:echarts/coord/scale/Time
 * @constructor
 */


var TimeScale = IntervalScale.extend({
  type: 'time',

  /**
   * @override
   */
  getLabel: function (val) {
    var stepLvl = this._stepLvl;
    var date = new Date(val);
    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
  },

  /**
   * @override
   */
  niceExtent: function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      // Expand extent
      extent[0] -= ONE_DAY;
      extent[1] += ONE_DAY;
    } // If there are no data and extent are [Infinity, -Infinity]


    if (extent[1] === -Infinity && extent[0] === Infinity) {
      var d = new Date();
      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
      extent[0] = extent[1] - ONE_DAY;
    }

    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
    }
  },

  /**
   * @override
   */
  niceTicks: function (approxTickNum, minInterval, maxInterval) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];
    var approxInterval = span / approxTickNum;

    if (minInterval != null && approxInterval < minInterval) {
      approxInterval = minInterval;
    }

    if (maxInterval != null && approxInterval > maxInterval) {
      approxInterval = maxInterval;
    }

    var scaleLevelsLen = scaleLevels.length;
    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
    var interval = level[1]; // Same with interval scale if span is much larger than 1 year

    if (level[0] === 'year') {
      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
      // var niceYearSpan = numberUtil.nice(yearSpan, false);

      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
      interval *= yearStep;
    }

    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
    scaleHelper.fixExtent(niceExtent, extent);
    this._stepLvl = level; // Interval will be used in getTicks

    this._interval = interval;
    this._niceExtent = niceExtent;
  },
  parse: function (val) {
    // val might be float.
    return +numberUtil.parseDate(val);
  }
});
zrUtil.each(['contain', 'normalize'], function (methodName) {
  TimeScale.prototype[methodName] = function (val) {
    return intervalScaleProto[methodName].call(this, this.parse(val));
  };
}); // Steps from d3

var scaleLevels = [// Format              interval
['hh:mm:ss', ONE_SECOND], // 1s
['hh:mm:ss', ONE_SECOND * 5], // 5s
['hh:mm:ss', ONE_SECOND * 10], // 10s
['hh:mm:ss', ONE_SECOND * 15], // 15s
['hh:mm:ss', ONE_SECOND * 30], // 30s
['hh:mm\nMM-dd', ONE_MINUTE], // 1m
['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
['hh:mm\nMM-dd', ONE_HOUR], // 1h
['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
['MM-dd\nyyyy', ONE_DAY], // 1d
['MM-dd\nyyyy', ONE_DAY * 2], // 2d
['MM-dd\nyyyy', ONE_DAY * 3], // 3d
['MM-dd\nyyyy', ONE_DAY * 4], // 4d
['MM-dd\nyyyy', ONE_DAY * 5], // 5d
['MM-dd\nyyyy', ONE_DAY * 6], // 6d
['week', ONE_DAY * 7], // 7d
['MM-dd\nyyyy', ONE_DAY * 10], // 10d
['week', ONE_DAY * 14], // 2w
['week', ONE_DAY * 21], // 3w
['month', ONE_DAY * 31], // 1M
['week', ONE_DAY * 42], // 6w
['month', ONE_DAY * 62], // 2M
['week', ONE_DAY * 42], // 10w
['quarter', ONE_DAY * 380 / 4], // 3M
['month', ONE_DAY * 31 * 4], // 4M
['month', ONE_DAY * 31 * 5], // 5M
['half-year', ONE_DAY * 380 / 2], // 6M
['month', ONE_DAY * 31 * 8], // 8M
['month', ONE_DAY * 31 * 10], // 10M
['year', ONE_DAY * 380] // 1Y
];
/**
 * @param {module:echarts/model/Model}
 * @return {module:echarts/scale/Time}
 */

TimeScale.create = function (model) {
  return new TimeScale({
    useUTC: model.ecModel.get('useUTC')
  });
};

var _default = TimeScale;
module.exports = _default;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var Group = __webpack_require__(261);

var componentUtil = __webpack_require__(304);

var clazzUtil = __webpack_require__(92);

var Component = function () {
  /**
   * @type {module:zrender/container/Group}
   * @readOnly
   */
  this.group = new Group();
  /**
   * @type {string}
   * @readOnly
   */

  this.uid = componentUtil.getUID('viewComponent');
};

Component.prototype = {
  constructor: Component,
  init: function (ecModel, api) {},
  render: function (componentModel, ecModel, api, payload) {},
  dispose: function () {}
};
var componentProto = Component.prototype;

componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
}; // Enable Component.extend.


clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.

clazzUtil.enableClassManagement(Component, {
  registerWhenExtend: true
});
var _default = Component;
module.exports = _default;

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

// Pick color from palette for each data item.
// Applicable for charts that require applying color palette
// in data level (like pie, funnel, chord).
function _default(seriesType, ecModel) {
  // Pie and funnel may use diferrent scope
  var paletteScope = {};
  ecModel.eachRawSeriesByType(seriesType, function (seriesModel) {
    var dataAll = seriesModel.getRawData();
    var idxMap = {};

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      var data = seriesModel.getData();
      data.each(function (idx) {
        var rawIdx = data.getRawIndex(idx);
        idxMap[rawIdx] = idx;
      });
      dataAll.each(function (rawIdx) {
        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded

        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);

        if (!singleDataColor) {
          // FIXME Performance
          var itemModel = dataAll.getItemModel(rawIdx);
          var color = itemModel.get('itemStyle.normal.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx), paletteScope); // Legend may use the visual info in data before processed

          dataAll.setItemVisual(rawIdx, 'color', color); // Data is not filtered

          if (filteredIdx != null) {
            data.setItemVisual(filteredIdx, 'color', color);
          }
        } else {
          // Set data all color for legend
          dataAll.setItemVisual(rawIdx, 'color', singleDataColor);
        }
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var Gradient = __webpack_require__(399);

function _default(ecModel) {
  function encodeColor(seriesModel) {
    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.normal.color').split('.');
    var data = seriesModel.getData();
    var color = seriesModel.get(colorAccessPath) // Set in itemStyle
    || seriesModel.getColorFromPalette(seriesModel.get('name')); // Default color
    // FIXME Set color function or use the platte color

    data.setVisual('color', color); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      if (typeof color === 'function' && !(color instanceof Gradient)) {
        data.each(function (idx) {
          data.setItemVisual(idx, 'color', color(seriesModel.getDataParams(idx)));
        });
      } // itemStyle in each data item


      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var color = itemModel.get(colorAccessPath, true);

        if (color != null) {
          data.setItemVisual(idx, 'color', color);
        }
      });
    }
  }

  ecModel.eachRawSeries(encodeColor);
}

module.exports = _default;

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

function _default(seriesType, defaultSymbolType, legendSymbol, ecModel, api) {
  // Encoding visual for all series include which is filtered for legend drawing
  ecModel.eachRawSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var symbolType = seriesModel.get('symbol') || defaultSymbolType;
    var symbolSize = seriesModel.get('symbolSize');
    data.setVisual({
      legendSymbol: legendSymbol || symbolType,
      symbol: symbolType,
      symbolSize: symbolSize
    }); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel)) {
      if (typeof symbolSize === 'function') {
        data.each(function (idx) {
          var rawValue = seriesModel.getRawValue(idx); // FIXME

          var params = seriesModel.getDataParams(idx);
          data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
        });
      }

      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var itemSymbolType = itemModel.getShallow('symbol', true);
        var itemSymbolSize = itemModel.getShallow('symbolSize', true); // If has item symbol

        if (itemSymbolType != null) {
          data.setItemVisual(idx, 'symbol', itemSymbolType);
        }

        if (itemSymbolSize != null) {
          // PENDING Transform symbolSize ?
          data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
        }
      });
    }
  });
}

module.exports = _default;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var camelize = __webpack_require__(1115);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

var isTextNode = __webpack_require__(1125);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var invariant = __webpack_require__(15);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(57);

var createArrayFromMixed = __webpack_require__(1118);
var getMarkupWrap = __webpack_require__(1120);
var invariant = __webpack_require__(15);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(57);

var invariant = __webpack_require__(15);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1122);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1124);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/IMG_5881.983d4c7f.PNG";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/IMG_5882.b1fe294f.PNG";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/desktop.3830763b.ini";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 1131 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tweenState"] = factory();
	else
		root["tweenState"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/*!*****************!*\
  !*** multi lib ***!
  \*****************/
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(/*! ./index.js */169);


/***/ },

/***/ 5:
/*!******************************!*\
  !*** ./~/process/browser.js ***!
  \******************************/
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },

/***/ 169:
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tweenFunctions = __webpack_require__(/*! tween-functions */ 170);
	
	var _tweenFunctions2 = _interopRequireDefault(_tweenFunctions);
	
	var _raf = __webpack_require__(/*! raf */ 171);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	// additive is the new iOS 8 default. In most cases it simulates a physics-
	// looking overshoot behavior (especially with easeInOut. You can test that in
	// the example
	var DEFAULT_STACK_BEHAVIOR = 'ADDITIVE';
	var DEFAULT_EASING = _tweenFunctions.easeInOutQuad;
	var DEFAULT_DURATION = 300;
	var DEFAULT_DELAY = 0;
	
	var stackBehavior = {
	  ADDITIVE: 'ADDITIVE',
	  DESTRUCTIVE: 'DESTRUCTIVE'
	};
	
	var Mixin = {
	  _rafID: null,
	
	  getInitialState: function getInitialState() {
	    return {
	      tweenQueue: []
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    _raf2['default'].cancel(this._rafID);
	    this._rafID = -1;
	  },
	
	  tweenState: function tweenState(path, _ref) {
	    var _this = this;
	
	    var easing = _ref.easing;
	    var duration = _ref.duration;
	    var delay = _ref.delay;
	    var beginValue = _ref.beginValue;
	    var endValue = _ref.endValue;
	    var onEnd = _ref.onEnd;
	    var configSB = _ref.stackBehavior;
	
	    this.setState(function (state) {
	      var cursor = state;
	      var stateName = undefined;
	      // see comment below on pash hash
	      var pathHash = undefined;
	      if (typeof path === 'string') {
	        stateName = path;
	        pathHash = path;
	      } else {
	        for (var i = 0; i < path.length - 1; i++) {
	          cursor = cursor[path[i]];
	        }
	        stateName = path[path.length - 1];
	        pathHash = path.join('|');
	      }
	      // see the reasoning for these defaults at the top of file
	      var newConfig = {
	        easing: easing || DEFAULT_EASING,
	        duration: duration == null ? DEFAULT_DURATION : duration,
	        delay: delay == null ? DEFAULT_DELAY : delay,
	        beginValue: beginValue == null ? cursor[stateName] : beginValue,
	        endValue: endValue,
	        onEnd: onEnd,
	        stackBehavior: configSB || DEFAULT_STACK_BEHAVIOR
	      };
	
	      var newTweenQueue = state.tweenQueue;
	      if (newConfig.stackBehavior === stackBehavior.DESTRUCTIVE) {
	        newTweenQueue = state.tweenQueue.filter(function (item) {
	          return item.pathHash !== pathHash;
	        });
	      }
	
	      // we store path hash, so that during value retrieval we can use hash
	      // comparison to find the path. See the kind of shitty thing you have to
	      // do when you don't have value comparison for collections?
	      newTweenQueue.push({
	        pathHash: pathHash,
	        config: newConfig,
	        initTime: Date.now() + newConfig.delay
	      });
	
	      // sorry for mutating. For perf reasons we don't want to deep clone.
	      // guys, can we please all start using persistent collections so that
	      // we can stop worrying about nonesense like this
	      cursor[stateName] = newConfig.endValue;
	      if (newTweenQueue.length === 1) {
	        _this._rafID = (0, _raf2['default'])(_this._rafCb);
	      }
	
	      // this will also include the above mutated update
	      return { tweenQueue: newTweenQueue };
	    });
	  },
	
	  getTweeningValue: function getTweeningValue(path) {
	    var state = this.state;
	
	    var tweeningValue = undefined;
	    var pathHash = undefined;
	    if (typeof path === 'string') {
	      tweeningValue = state[path];
	      pathHash = path;
	    } else {
	      tweeningValue = state;
	      for (var i = 0; i < path.length; i++) {
	        tweeningValue = tweeningValue[path[i]];
	      }
	      pathHash = path.join('|');
	    }
	    var now = Date.now();
	
	    for (var i = 0; i < state.tweenQueue.length; i++) {
	      var _state$tweenQueue$i = state.tweenQueue[i];
	      var itemPathHash = _state$tweenQueue$i.pathHash;
	      var initTime = _state$tweenQueue$i.initTime;
	      var config = _state$tweenQueue$i.config;
	
	      if (itemPathHash !== pathHash) {
	        continue;
	      }
	
	      var progressTime = now - initTime > config.duration ? config.duration : Math.max(0, now - initTime);
	      // `now - initTime` can be negative if initTime is scheduled in the
	      // future by a delay. In this case we take 0
	
	      // if duration is 0, consider that as jumping to endValue directly. This
	      // is needed because the easing functino might have undefined behavior for
	      // duration = 0
	      var easeValue = config.duration === 0 ? config.endValue : config.easing(progressTime, config.beginValue, config.endValue, config.duration);
	
	      // TODO: some funcs accept a 5th param
	      var contrib = easeValue - config.endValue;
	      tweeningValue += contrib;
	    }
	
	    return tweeningValue;
	  },
	
	  _rafCb: function _rafCb() {
	    var state = this.state;
	    if (state.tweenQueue.length === 0) {
	      return;
	    }
	
	    var now = Date.now();
	    var newTweenQueue = [];
	
	    for (var i = 0; i < state.tweenQueue.length; i++) {
	      var item = state.tweenQueue[i];
	      var initTime = item.initTime;
	      var config = item.config;
	
	      if (now - initTime < config.duration) {
	        newTweenQueue.push(item);
	      } else {
	        config.onEnd && config.onEnd();
	      }
	    }
	
	    // onEnd might trigger a parent callback that removes this component
	    // -1 means we've canceled it in componentWillUnmount
	    if (this._rafID === -1) {
	      return;
	    }
	
	    this.setState({
	      tweenQueue: newTweenQueue
	    });
	
	    this._rafID = (0, _raf2['default'])(this._rafCb);
	  }
	};
	
	exports['default'] = {
	  Mixin: Mixin,
	  easingTypes: _tweenFunctions2['default'],
	  stackBehavior: stackBehavior
	};
	module.exports = exports['default'];

/***/ },

/***/ 170:
/*!************************************!*\
  !*** ./~/tween-functions/index.js ***!
  \************************************/
/***/ function(module, exports) {

	'use strict';
	
	// t: current time, b: beginning value, _c: final value, d: total duration
	var tweenFunctions = {
	  linear: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * t / d + b;
	  },
	  easeInQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t + b;
	  },
	  easeOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (t /= d) * (t - 2) + b;
	  },
	  easeInOutQuad: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t + b;
	    } else {
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    }
	  },
	  easeInCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t + b;
	  },
	  easeOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  },
	  easeInOutCubic: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	  },
	  easeInQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t + b;
	  },
	  easeOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  },
	  easeInOutQuart: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t + b;
	    } else {
	      return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	    }
	  },
	  easeInQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * (t /= d) * t * t * t * t + b;
	  },
	  easeOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  },
	  easeInOutQuint: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	    }
	  },
	  easeInSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  },
	  easeOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  },
	  easeInOutSine: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  },
	  easeInExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	  },
	  easeOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	  },
	  easeInOutExpo: function(t, b, _c, d) {
	    var c = _c - b;
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    } else {
	      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	    }
	  },
	  easeInCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  },
	  easeOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  },
	  easeInOutCirc: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d / 2) < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    } else {
	      return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	    }
	  },
	  easeInElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	  },
	  easeOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d) === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	  },
	  easeInOutElastic: function(t, b, _c, d) {
	    var c = _c - b;
	    var a, p, s;
	    s = 1.70158;
	    p = 0;
	    a = c;
	    if (t === 0) {
	      return b;
	    } else if ((t /= d / 2) === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    } else {
	      s = p / (2 * Math.PI) * Math.asin(c / a);
	    }
	    if (t < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	    } else {
	      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
	    }
	  },
	  easeInBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  },
	  easeOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  },
	  easeInOutBack: function(t, b, _c, d, s) {
	    var c = _c - b;
	    if (s === void 0) {
	      s = 1.70158;
	    }
	    if ((t /= d / 2) < 1) {
	      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
	    } else {
	      return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	    }
	  },
	  easeInBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    v = tweenFunctions.easeOutBounce(d - t, 0, c, d);
	    return c - v + b;
	  },
	  easeOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    if ((t /= d) < 1 / 2.75) {
	      return c * (7.5625 * t * t) + b;
	    } else if (t < 2 / 2.75) {
	      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
	    } else if (t < 2.5 / 2.75) {
	      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
	    } else {
	      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
	    }
	  },
	  easeInOutBounce: function(t, b, _c, d) {
	    var c = _c - b;
	    var v;
	    if (t < d / 2) {
	      v = tweenFunctions.easeInBounce(t * 2, 0, c, d);
	      return v * 0.5 + b;
	    } else {
	      v = tweenFunctions.easeOutBounce(t * 2 - d, 0, c, d);
	      return v * 0.5 + c * 0.5 + b;
	    }
	  }
	};
	
	module.exports = tweenFunctions;


/***/ },

/***/ 171:
/*!************************!*\
  !*** ./~/raf/index.js ***!
  \************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(/*! performance-now */ 172)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function() {
	  root.requestAnimationFrame = raf
	  root.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 172:
/*!**************************************************!*\
  !*** ./~/performance-now/lib/performance-now.js ***!
  \**************************************************/
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./~/process/browser.js */ 5)))

/***/ }

/******/ })
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1138);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1139);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(482);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1135);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1142 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 1146 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(1142),
    isArguments = __webpack_require__(1145),
    isArray = __webpack_require__(1146);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keys;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1148);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(483);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(483);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1153);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1631);
var objectAssign = __webpack_require__(24);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1156)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(311)))

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(1158);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isWindow */])(lastElement) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isSimilarValue */])(preRect.width, sourceRect.width) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["b"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(339);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1160);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1161);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1159);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(485);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(485);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(486);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["b"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["d"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["e"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(487);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1170);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_PureRenderMixin__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_PureRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_PureRenderMixin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);












var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Checkbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return __WEBPACK_IMPORTED_MODULE_9_rc_util_es_PureRenderMixin___default.a.shouldComponentUpdate.apply(this, args);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          style = _props.style,
          name = _props.name,
          type = _props.type,
          disabled = _props.disabled,
          readOnly = _props.readOnly,
          tabIndex = _props.tabIndex,
          onClick = _props.onClick,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          others = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'className', 'style', 'name', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur']);

      var globalProps = Object.keys(others).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
          prev[key] = others[key];
        }
        return prev;
      }, {});

      var checked = this.state.checked;

      var classString = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, className, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-checked', checked), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), _classNames));

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: classString, style: style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          name: name,
          type: type,
          readOnly: readOnly,
          disabled: disabled,
          tabIndex: tabIndex,
          className: prefixCls + '-input',
          checked: !!checked,
          onClick: onClick,
          onFocus: onFocus,
          onBlur: onBlur,
          onChange: this.handleChange
        }, globalProps)),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('span', { className: prefixCls + '-inner' })
      );
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Checkbox.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  defaultChecked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  checked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onFocus: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  readOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      }
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(494);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(494);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1178);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1180);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1179);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(495);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(495);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Panel__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function toArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }
  return currentActiveKey;
}

var Collapse = function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    var _this$props = _this.props,
        activeKey = _this$props.activeKey,
        defaultActiveKey = _this$props.defaultActiveKey;

    var currentActiveKey = defaultActiveKey;
    if ('activeKey' in _this.props) {
      currentActiveKey = activeKey;
    }

    _this.state = {
      openAnimation: _this.props.openAnimation || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__["a" /* default */])(_this.props.prefixCls),
      activeKey: toArray(currentActiveKey)
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: toArray(nextProps.activeKey)
        });
      }
      if ('openAnimation' in nextProps) {
        this.setState({
          openAnimation: nextProps.openAnimation
        });
      }
    }
  }, {
    key: 'onClickItem',
    value: function onClickItem(key) {
      var activeKey = this.state.activeKey;
      if (this.props.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = [].concat(_toConsumableArray(activeKey));
        var index = activeKey.indexOf(key);
        var isActive = index > -1;
        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }
      this.setActiveKey(activeKey);
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var activeKey = this.state.activeKey;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          accordion = _props.accordion,
          destroyInactivePanel = _props.destroyInactivePanel;

      var newChildren = [];

      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(this.props.children, function (child, index) {
        if (!child) return;
        // If there is no key provide, use the panel order as default key
        var key = child.key || String(index);
        var _child$props = child.props,
            header = _child$props.header,
            headerClass = _child$props.headerClass,
            disabled = _child$props.disabled;

        var isActive = false;
        if (accordion) {
          isActive = activeKey[0] === key;
        } else {
          isActive = activeKey.indexOf(key) > -1;
        }

        var props = {
          key: key,
          header: header,
          headerClass: headerClass,
          isActive: isActive,
          prefixCls: prefixCls,
          destroyInactivePanel: destroyInactivePanel,
          openAnimation: _this2.state.openAnimation,
          children: child.props.children,
          onItemClick: disabled ? null : function () {
            return _this2.onClickItem(key);
          }
        };

        newChildren.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, props));
      });

      return newChildren;
    }
  }, {
    key: 'setActiveKey',
    value: function setActiveKey(activeKey) {
      if (!('activeKey' in this.props)) {
        this.setState({ activeKey: activeKey });
      }
      this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          className = _props2.className,
          style = _props2.style;

      var collapseClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: collapseClassName, style: style },
        this.getItems()
      );
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  accordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

Collapse.defaultProps = {
  prefixCls: 'rc-collapse',
  onChange: function onChange() {},

  accordion: false,
  destroyInactivePanel: false
};

Collapse.Panel = __WEBPACK_IMPORTED_MODULE_2__Panel__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContent__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_animate__ = __webpack_require__(171);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CollapsePanel = function (_Component) {
  _inherits(CollapsePanel, _Component);

  function CollapsePanel() {
    _classCallCheck(this, CollapsePanel);

    return _possibleConstructorReturn(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
  }

  _createClass(CollapsePanel, [{
    key: 'handleItemClick',
    value: function handleItemClick() {
      if (this.props.onItemClick) {
        this.props.onItemClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          style = _props.style,
          prefixCls = _props.prefixCls,
          header = _props.header,
          headerClass = _props.headerClass,
          children = _props.children,
          isActive = _props.isActive,
          showArrow = _props.showArrow,
          destroyInactivePanel = _props.destroyInactivePanel,
          disabled = _props.disabled;

      var headerCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
      var itemCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: itemCls, style: style, id: id, role: 'tablist' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: headerCls,
            onClick: this.handleItemClick.bind(this),
            role: 'tab',
            'aria-expanded': isActive
          },
          showArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'arrow' }),
          header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_rc_animate__["a" /* default */],
          {
            showProp: 'isActive',
            exclusive: true,
            component: '',
            animation: this.props.openAnimation
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__PanelContent__["a" /* default */],
            {
              prefixCls: prefixCls,
              isActive: isActive,
              destroyInactivePanel: destroyInactivePanel
            },
            children
          )
        )
      );
    }
  }]);

  return CollapsePanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CollapsePanel.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  headerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

CollapsePanel.defaultProps = {
  showArrow: true,
  isActive: false,
  destroyInactivePanel: false,
  onItemClick: function onItemClick() {},

  headerClass: ''
};

/* harmony default export */ __webpack_exports__["a"] = (CollapsePanel);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelContent = function (_Component) {
  _inherits(PanelContent, _Component);

  function PanelContent() {
    _classCallCheck(this, PanelContent);

    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
  }

  _createClass(PanelContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.isActive || nextProps.isActive;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      this._isActived = this._isActived || this.props.isActive;
      if (!this._isActived) {
        return null;
      }
      var _props = this.props,
          prefixCls = _props.prefixCls,
          isActive = _props.isActive,
          children = _props.children,
          destroyInactivePanel = _props.destroyInactivePanel;

      var contentCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
      var child = !isActive && destroyInactivePanel ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-content-box' },
        children
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: contentCls,
          role: 'tabpanel'
        },
        child
      );
    }
  }]);

  return PanelContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PanelContent.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (PanelContent);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Panel", function() { return Panel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__(1190);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */]);
var Panel = __WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */].Panel;

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_animation__ = __webpack_require__(463);


function animate(node, show, transitionName, done) {
  var height = void 0;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_css_animation__["b" /* default */])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = node.offsetHeight + 'px';
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = (show ? height : 0) + 'px';
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, prefixCls + '-anim', done);
    },
    leave: function leave(node, done) {
      return animate(node, false, prefixCls + '-anim', done);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (animation);

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_lib_getScrollBarSize__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_lib_getScrollBarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rc_util_lib_getScrollBarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_object_assign__);












var uuid = 0;
var openCount = 0;

function noop() {}
function getScroll(w, top) {
    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
    var method = 'scroll' + (top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') {
            ret = d.body[method];
        }
    }
    return ret;
}
function setTransformOrigin(node, value) {
    var style = node.style;
    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
        style[prefix + 'TransformOrigin'] = value;
    });
    style['transformOrigin'] = value;
}
function offset(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));

        _this.onAnimateLeave = function () {
                                    if (_this.refs.wrap) {
                _this.refs.wrap.style.display = 'none';
            }
            _this.inTransition = false;
            _this.removeScrollingEffect();
            _this.props.afterClose();
        };
        _this.onMaskClick = function (e) {
                        if (Date.now() - _this.openTime < 300) {
                return;
            }
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        _this.onKeyDown = function (e) {
            var props = _this.props;
            if (props.keyboard && e.keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].ESC) {
                _this.close(e);
            }
                        if (props.visible) {
                if (e.keyCode === __WEBPACK_IMPORTED_MODULE_7_rc_util_es_KeyCode__["a" /* default */].TAB) {
                    var activeElement = document.activeElement;
                    var dialogRoot = _this.refs.wrap;
                    var sentinel = _this.refs.sentinel;
                    if (e.shiftKey) {
                        if (activeElement === dialogRoot) {
                            sentinel.focus();
                        }
                    } else if (activeElement === _this.refs.sentinel) {
                        dialogRoot.focus();
                    }
                }
            }
        };
        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var dest = {};
            if (props.width !== undefined) {
                dest.width = props.width;
            }
            if (props.height !== undefined) {
                dest.height = props.height;
            }
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-footer', ref: "footer" }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-header', ref: "header" }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: prefixCls + '-close-x' }));
            }
            var style = __WEBPACK_IMPORTED_MODULE_11_object_assign___default()({}, props.style, dest);
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: "dialog", style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-body', style: props.bodyStyle, ref: "body" }, props.bodyProps), props.children), footer), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { tabIndex: 0, ref: "sentinel", style: { width: 0, height: 0, overflow: 'hidden' } }, "sentinel"));
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, dialogElement);
        };
        _this.getZIndexStyle = function () {
            var style = {};
            var props = _this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        };
        _this.getWrapStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_11_object_assign___default()({}, _this.getZIndexStyle(), _this.props.wrapStyle);
        };
        _this.getMaskStyle = function () {
            return __WEBPACK_IMPORTED_MODULE_11_object_assign___default()({}, _this.getZIndexStyle(), _this.props.maskStyle);
        };
        _this.getMaskElement = function () {
            var props = _this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = _this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        };
        _this.getMaskTransitionName = function () {
            var props = _this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getTransitionName = function () {
            var props = _this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        };
        _this.getElement = function (part) {
            return _this.refs[part];
        };
        _this.setScrollbar = function () {
            if (_this.bodyIsOverflowing && _this.scrollbarWidth !== undefined) {
                document.body.style.paddingRight = _this.scrollbarWidth + 'px';
            }
        };
        _this.addScrollingEffect = function () {
            openCount++;
            if (openCount !== 1) {
                return;
            }
            _this.checkScrollbar();
            _this.setScrollbar();
            document.body.style.overflow = 'hidden';
                    };
        _this.removeScrollingEffect = function () {
            openCount--;
            if (openCount !== 0) {
                return;
            }
            document.body.style.overflow = '';
            _this.resetScrollbar();
                    };
        _this.close = function (e) {
            _this.props.onClose(e);
        };
        _this.checkScrollbar = function () {
            var fullWindowWidth = window.innerWidth;
            if (!fullWindowWidth) {
                var documentElementRect = document.documentElement.getBoundingClientRect();
                fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
            }
            _this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
            if (_this.bodyIsOverflowing) {
                _this.scrollbarWidth = __WEBPACK_IMPORTED_MODULE_10_rc_util_lib_getScrollBarSize___default()();
            }
        };
        _this.resetScrollbar = function () {
            document.body.style.paddingRight = '';
        };
        _this.adjustDialog = function () {
            if (_this.refs.wrap && _this.scrollbarWidth !== undefined) {
                var modalIsOverflowing = _this.refs.wrap.scrollHeight > document.documentElement.clientHeight;
                _this.refs.wrap.style.paddingLeft = (!_this.bodyIsOverflowing && modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
                _this.refs.wrap.style.paddingRight = (_this.bodyIsOverflowing && !modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
            }
        };
        _this.resetAdjustments = function () {
            if (_this.refs.wrap) {
                _this.refs.wrap.style.paddingLeft = _this.refs.wrap.style.paddingLeft = '';
            }
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Dialog, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.inTransition = false;
            this.titleId = 'rcDialogTitle' + uuid++;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.componentDidUpdate({});
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var props = this.props;
            var mousePosition = this.props.mousePosition;
            if (props.visible) {
                                if (!prevProps.visible) {
                    this.openTime = Date.now();
                    this.lastOutSideFocusNode = document.activeElement;
                    this.addScrollingEffect();
                    this.refs.wrap.focus();
                    var dialogNode = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.refs.dialog);
                    if (mousePosition) {
                        var elOffset = offset(dialogNode);
                        setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
                    } else {
                        setTransformOrigin(dialogNode, '');
                    }
                }
            } else if (prevProps.visible) {
                this.inTransition = true;
                if (props.mask && this.lastOutSideFocusNode) {
                    try {
                        this.lastOutSideFocusNode.focus();
                    } catch (e) {
                        this.lastOutSideFocusNode = null;
                    }
                    this.lastOutSideFocusNode = null;
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.visible || this.inTransition) {
                this.removeScrollingEffect();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var prefixCls = props.prefixCls,
                maskClosable = props.maskClosable;

            var style = this.getWrapStyle();
                                    if (props.visible) {
                style.display = null;
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", null, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: "wrap", onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
        }
    }]);

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    afterClose: noop,
    className: '',
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    prefixCls: 'rc-dialog',
    onClose: noop
};

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_object_assign__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_object_assign__);








var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LazyRenderBox, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return !!nextProps.hiddenClassName || !!nextProps.visible;
        }
    }, {
        key: 'render',
        value: function render() {
            var className = this.props.className;
            if (!!this.props.hiddenClassName && !this.props.visible) {
                className += ' ' + this.props.hiddenClassName;
            }
            var props = __WEBPACK_IMPORTED_MODULE_6_object_assign___default()({}, this.props);
            delete props.hiddenClassName;
            delete props.visible;
            props.className = className;
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props));
        }
    }]);

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);












function getOffset(ele) {
  var el = ele;
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

var CANCEL_DISTANCE_ON_SCROLL = 20;

var Drawer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Drawer, _React$Component);

  function Drawer(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Drawer);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

    _this.onOverlayClicked = function () {
      if (_this.props.open) {
        // see https://github.com/react-component/drawer/issues/9
        setTimeout(function () {
          _this.props.onOpenChange(false, { overlayClicked: true });
        }, 0);
      }
    };

    _this.onTouchStart = function (ev) {
      // filter out if a user starts swiping with a second finger
      if (!_this.isTouching()) {
        var touch = ev.targetTouches[0];
        _this.setState({
          touchIdentifier: !_this.notTouch ? touch.identifier : null,
          touchStartX: touch.clientX,
          touchStartY: touch.clientY,
          touchCurrentX: touch.clientX,
          touchCurrentY: touch.clientY
        });
      }
    };

    _this.onTouchMove = function (ev) {
      // ev.preventDefault(); // cannot touchmove with FastClick
      if (_this.isTouching()) {
        for (var ind = 0; ind < ev.targetTouches.length; ind++) {
          // we only care about the finger that we are tracking
          if (ev.targetTouches[ind].identifier === _this.state.touchIdentifier) {
            _this.setState({
              touchCurrentX: ev.targetTouches[ind].clientX,
              touchCurrentY: ev.targetTouches[ind].clientY
            });
            break;
          }
        }
      }
    };

    _this.onTouchEnd = function () {
      _this.notTouch = false;
      if (_this.isTouching()) {
        // trigger a change to open if sidebar has been dragged beyond dragToggleDistance
        var touchWidth = _this.touchSidebarWidth();

        if (_this.props.open && touchWidth < _this.state.sidebarWidth - _this.props.dragToggleDistance || !_this.props.open && touchWidth > _this.props.dragToggleDistance) {
          _this.props.onOpenChange(!_this.props.open);
        }

        var touchHeight = _this.touchSidebarHeight();

        if (_this.props.open && touchHeight < _this.state.sidebarHeight - _this.props.dragToggleDistance || !_this.props.open && touchHeight > _this.props.dragToggleDistance) {
          _this.props.onOpenChange(!_this.props.open);
        }

        _this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    };

    _this.onScroll = function () {
      if (_this.isTouching() && _this.inCancelDistanceOnScroll()) {
        _this.setState({
          touchIdentifier: null,
          touchStartX: null,
          touchStartY: null,
          touchCurrentX: null,
          touchCurrentY: null
        });
      }
    };

    _this.inCancelDistanceOnScroll = function () {
      var cancelDistanceOnScroll = void 0;
      switch (_this.props.position) {
        case 'right':
          cancelDistanceOnScroll = Math.abs(_this.state.touchCurrentX - _this.state.touchStartX) < CANCEL_DISTANCE_ON_SCROLL;
          break;
        case 'bottom':
          cancelDistanceOnScroll = Math.abs(_this.state.touchCurrentY - _this.state.touchStartY) < CANCEL_DISTANCE_ON_SCROLL;
          break;
        case 'top':
          cancelDistanceOnScroll = Math.abs(_this.state.touchStartY - _this.state.touchCurrentY) < CANCEL_DISTANCE_ON_SCROLL;
          break;
        case 'left':
        default:
          cancelDistanceOnScroll = Math.abs(_this.state.touchStartX - _this.state.touchCurrentX) < CANCEL_DISTANCE_ON_SCROLL;
      }
      return cancelDistanceOnScroll;
    };

    _this.isTouching = function () {
      return _this.state.touchIdentifier !== null;
    };

    _this.saveSidebarSize = function () {
      var sidebar = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this.refs.sidebar);
      var width = sidebar.offsetWidth;
      var height = sidebar.offsetHeight;
      var sidebarTop = getOffset(__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this.refs.sidebar)).top;
      var dragHandleTop = getOffset(__WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this.refs.dragHandle)).top;

      if (width !== _this.state.sidebarWidth) {
        _this.setState({ sidebarWidth: width });
      }
      if (height !== _this.state.sidebarHeight) {
        _this.setState({ sidebarHeight: height });
      }
      if (sidebarTop !== _this.state.sidebarTop) {
        _this.setState({ sidebarTop: sidebarTop });
      }
      if (dragHandleTop !== _this.state.dragHandleTop) {
        _this.setState({ dragHandleTop: dragHandleTop });
      }
    };

    _this.touchSidebarWidth = function () {
      // if the sidebar is open and start point of drag is inside the sidebar
      // we will only drag the distance they moved their finger
      // otherwise we will move the sidebar to be below the finger.
      if (_this.props.position === 'right') {
        if (_this.props.open && window.innerWidth - _this.state.touchStartX < _this.state.sidebarWidth) {
          if (_this.state.touchCurrentX > _this.state.touchStartX) {
            return _this.state.sidebarWidth + _this.state.touchStartX - _this.state.touchCurrentX;
          }
          return _this.state.sidebarWidth;
        }
        return Math.min(window.innerWidth - _this.state.touchCurrentX, _this.state.sidebarWidth);
      }

      if (_this.props.position === 'left') {
        if (_this.props.open && _this.state.touchStartX < _this.state.sidebarWidth) {
          if (_this.state.touchCurrentX > _this.state.touchStartX) {
            return _this.state.sidebarWidth;
          }
          return _this.state.sidebarWidth - _this.state.touchStartX + _this.state.touchCurrentX;
        }
        return Math.min(_this.state.touchCurrentX, _this.state.sidebarWidth);
      }
    };

    _this.touchSidebarHeight = function () {
      // if the sidebar is open and start point of drag is inside the sidebar
      // we will only drag the distance they moved their finger
      // otherwise we will move the sidebar to be below the finger.
      if (_this.props.position === 'bottom') {
        if (_this.props.open && window.innerHeight - _this.state.touchStartY < _this.state.sidebarHeight) {
          if (_this.state.touchCurrentY > _this.state.touchStartY) {
            return _this.state.sidebarHeight + _this.state.touchStartY - _this.state.touchCurrentY;
          }
          return _this.state.sidebarHeight;
        }
        return Math.min(window.innerHeight - _this.state.touchCurrentY, _this.state.sidebarHeight);
      }

      if (_this.props.position === 'top') {
        var touchStartOffsetY = _this.state.touchStartY - _this.state.sidebarTop;
        if (_this.props.open && touchStartOffsetY < _this.state.sidebarHeight) {
          if (_this.state.touchCurrentY > _this.state.touchStartY) {
            return _this.state.sidebarHeight;
          }
          return _this.state.sidebarHeight - _this.state.touchStartY + _this.state.touchCurrentY;
        }
        return Math.min(_this.state.touchCurrentY - _this.state.dragHandleTop, _this.state.sidebarHeight);
      }
    };

    _this.renderStyle = function (_ref) {
      var sidebarStyle = _ref.sidebarStyle,
          isTouching = _ref.isTouching,
          overlayStyle = _ref.overlayStyle,
          contentStyle = _ref.contentStyle;

      if (_this.props.position === 'right' || _this.props.position === 'left') {
        sidebarStyle.transform = 'translateX(0%)';
        sidebarStyle.WebkitTransform = 'translateX(0%)';
        if (isTouching) {
          var percentage = _this.touchSidebarWidth() / _this.state.sidebarWidth;
          // slide open to what we dragged
          if (_this.props.position === 'right') {
            sidebarStyle.transform = 'translateX(' + (1 - percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateX(' + (1 - percentage) * 100 + '%)';
          }
          if (_this.props.position === 'left') {
            sidebarStyle.transform = 'translateX(-' + (1 - percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateX(-' + (1 - percentage) * 100 + '%)';
          }
          // fade overlay to match distance of drag
          overlayStyle.opacity = percentage;
          overlayStyle.visibility = 'visible';
        }
        if (contentStyle) {
          contentStyle[_this.props.position] = _this.state.sidebarWidth + 'px';
        }
      }
      if (_this.props.position === 'top' || _this.props.position === 'bottom') {
        sidebarStyle.transform = 'translateY(0%)';
        sidebarStyle.WebkitTransform = 'translateY(0%)';
        if (isTouching) {
          var _percentage = _this.touchSidebarHeight() / _this.state.sidebarHeight;
          // slide open to what we dragged
          if (_this.props.position === 'bottom') {
            sidebarStyle.transform = 'translateY(' + (1 - _percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateY(' + (1 - _percentage) * 100 + '%)';
          }
          if (_this.props.position === 'top') {
            sidebarStyle.transform = 'translateY(-' + (1 - _percentage) * 100 + '%)';
            sidebarStyle.WebkitTransform = 'translateY(-' + (1 - _percentage) * 100 + '%)';
          }
          // fade overlay to match distance of drag
          overlayStyle.opacity = _percentage;
          overlayStyle.visibility = 'visible';
        }
        if (contentStyle) {
          contentStyle[_this.props.position] = _this.state.sidebarHeight + 'px';
        }
      }
    };

    _this.state = {
      // the detected width of the sidebar in pixels
      sidebarWidth: 0,
      sidebarHeight: 0,
      sidebarTop: 0,
      dragHandleTop: 0,

      // keep track of touching params
      touchIdentifier: null,
      touchStartX: null,
      touchStartY: null,
      touchCurrentX: null,
      touchCurrentY: null,

      // if touch is supported by the browser
      touchSupported: (typeof window === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(window)) === 'object' && 'ontouchstart' in window
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Drawer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.saveSidebarSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // filter out the updates when we're touching
      if (!this.isTouching()) {
        this.saveSidebarSize();
      }
    }

    // This logic helps us prevents the user from sliding the sidebar horizontally
    // while scrolling the sidebar vertically. When a scroll event comes in, we're
    // cancelling the ongoing gesture if it did not move horizontally much.


    // True if the on going gesture X distance is less than the cancel distance


    // calculate the sidebarWidth based on current touch info

    // calculate the sidebarHeight based on current touch info

  }, {
    key: 'render',
    value: function render() {
      var _rootCls,
          _this2 = this;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          prefixCls = _props.prefixCls,
          position = _props.position,
          transitions = _props.transitions,
          touch = _props.touch,
          enableDragHandle = _props.enableDragHandle,
          sidebar = _props.sidebar,
          children = _props.children,
          docked = _props.docked,
          open = _props.open;


      var sidebarStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props.sidebarStyle);
      var contentStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props.contentStyle);
      var overlayStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props.overlayStyle);

      var rootCls = (_rootCls = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_rootCls, className, !!className), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_rootCls, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_rootCls, prefixCls + '-' + position, true), _rootCls);

      var rootProps = { style: style };
      var isTouching = this.isTouching();

      if (isTouching) {
        this.renderStyle({ sidebarStyle: sidebarStyle, isTouching: true, overlayStyle: overlayStyle });
      } else if (docked) {
        if (this.state.sidebarWidth !== 0) {
          rootCls[prefixCls + '-docked'] = true;
          this.renderStyle({ sidebarStyle: sidebarStyle, contentStyle: contentStyle });
        }
      } else if (open) {
        rootCls[prefixCls + '-open'] = true;
        this.renderStyle({ sidebarStyle: sidebarStyle });
        overlayStyle.opacity = 1;
        overlayStyle.visibility = 'visible';
      }

      if (isTouching || !transitions) {
        sidebarStyle.transition = 'none';
        sidebarStyle.WebkitTransition = 'none';
        contentStyle.transition = 'none';
        overlayStyle.transition = 'none';
      }

      var dragHandle = null;

      if (this.state.touchSupported && touch) {
        if (open) {
          rootProps.onTouchStart = function (ev) {
            _this2.notTouch = true;
            _this2.onTouchStart(ev);
          };
          rootProps.onTouchMove = this.onTouchMove;
          rootProps.onTouchEnd = this.onTouchEnd;
          rootProps.onTouchCancel = this.onTouchEnd;
          rootProps.onScroll = this.onScroll;
        } else if (enableDragHandle) {
          dragHandle = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: prefixCls + '-draghandle', style: this.props.dragHandleStyle,
            onTouchStart: this.onTouchStart, onTouchMove: this.onTouchMove,
            onTouchEnd: this.onTouchEnd, onTouchCancel: this.onTouchEnd,
            ref: 'dragHandle'
          });
        }
      }

      // const evt = {};
      // // FastClick use touchstart instead of click
      // if (this.state.touchSupported) {
      //   evt.onTouchStart = () => {
      //     this.notTouch = true;
      //     this.onOverlayClicked();
      //   };
      //   evt.onTouchEnd = () => {
      //     this.notTouch = false;
      //     this.setState({
      //       touchIdentifier: null,
      //     });
      //   };
      // } else {
      //   evt.onClick = this.onOverlayClicked;
      // }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(rootCls) }, rootProps),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: prefixCls + '-sidebar', style: sidebarStyle,
            ref: 'sidebar'
          },
          sidebar
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: prefixCls + '-overlay',
          style: overlayStyle,
          role: 'presentation',
          ref: 'overlay',
          onClick: this.onOverlayClicked
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: prefixCls + '-content', style: contentStyle,
            ref: 'content'
          },
          dragHandle,
          children
        )
      );
    }
  }]);

  return Drawer;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Drawer.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  // main content to render
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node.isRequired,

  // styles
  // styles: PropTypes.shape({
  //   dragHandle: PropTypes.object,
  // }),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  sidebarStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  contentStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  dragHandleStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,

  // sidebar content to render
  sidebar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node.isRequired,

  // boolean if sidebar should be docked
  docked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // boolean if sidebar should slide open
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // boolean if transitions should be disabled
  transitions: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // boolean if touch gestures are enabled
  touch: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  enableDragHandle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  // where to place the sidebar
  position: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['left', 'right', 'top', 'bottom']),

  // distance we have to drag the sidebar to toggle open state
  dragToggleDistance: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  // callback called when the overlay is clicked
  onOpenChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};
Drawer.defaultProps = {
  prefixCls: 'rc-drawer',
  sidebarStyle: {},
  contentStyle: {},
  overlayStyle: {},
  dragHandleStyle: {},
  docked: false,
  open: false,
  transitions: true,
  touch: true,
  enableDragHandle: true,
  position: 'left',
  dragToggleDistance: 30,
  onOpenChange: function onOpenChange() {}
};
/* harmony default export */ __webpack_exports__["a"] = (Drawer);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(1203);
// export this package's api

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Drawer__["a" /* default */]);

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(501);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(501);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1205);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1207);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1206);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(313);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(313);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);
var ReactPropTypesSecret = __webpack_require__(1218);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1216)();
}


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_async_validator__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_async_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_async_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_has__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_set__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__createFieldsStore__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(502);














var DEFAULT_TRIGGER = 'onChange';

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* mirror */] : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      withRef = option.withRef;


  function decorate(WrappedComponent) {
    var Form = __WEBPACK_IMPORTED_MODULE_5_create_react_class___default()({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__createFieldsStore__["a" /* default */])(fields || {});

        this.instances = {};
        this.cachedBind = {};
        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          return _this[key] = function () {
            var _fieldsStore;

            __WEBPACK_IMPORTED_MODULE_7_warning___default()(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      onCollectCommon: function onCollectCommon(name_, action, args) {
        var name = name_;
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args)) : __WEBPACK_IMPORTED_MODULE_12__utils__["b" /* getValueFromEvent */].apply(undefined, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          onValuesChange(this.props, __WEBPACK_IMPORTED_MODULE_10_lodash_set___default()({}, name, value));
        }
        var nameKeyObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* getNameIfNested */])(name);
        if (this.fieldsStore.getFieldMeta(nameKeyObj.name).exclusive) {
          name = nameKeyObj.name;
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;

        var fieldContent = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, field, {
          dirty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* hasRules */])(validate)
        });
        this.setFields(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, name, fieldContent));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var fieldContent = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, field, {
          dirty: true
        });
        this.validateFieldsInternal([fieldContent], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        var cache = this.cachedBind[name] = this.cachedBind[name] || {};
        if (!cache[action]) {
          cache[action] = fn.bind(this, name, action);
        }
        return cache[action];
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            warning(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            warning(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(fieldElem, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }

        var nameIfNested = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* getNameIfNested */])(name);
        var leadingName = nameIfNested.name;
        var fieldOption = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          valuePropName: 'value',
          validate: [],
          trigger: DEFAULT_TRIGGER,
          leadingName: leadingName,
          name: name
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            exclusive = fieldOption.exclusive,
            validate = fieldOption.validate;


        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var leadingFieldMeta = this.fieldsStore.getFieldMeta(leadingName);
        if (nameIfNested.isNested) {
          leadingFieldMeta.virtual = !exclusive;
          // exclusive allow getFieldProps('x', {initialValue})
          // non-exclusive does not allow getFieldProps('x', {initialValue})
          leadingFieldMeta.hidden = !exclusive;
          leadingFieldMeta.exclusive = exclusive;
        }

        var inputProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = name;
        }

        var validateRules = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["e" /* normalizeValidateRules */])(validate, rules, validateTrigger);
        var validateTriggers = validateRules.filter(function (item) {
          return !!item.rules && item.rules.length;
        }).map(function (item) {
          return item.trigger;
        }).reduce(function (pre, curr) {
          return pre.concat(curr);
        }, []);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["f" /* flattenArray */])(actionRules);
      },
      setFields: function setFields(fields) {
        var _this4 = this;

        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = {};
          Object.keys(fields).forEach(function (f) {
            changedFields[f] = _this4.fieldsStore.getField(f);
          });
          onFieldsChange(this.props, changedFields);
        }
        this.forceUpdate();
      },
      resetFields: function resetFields(ns) {
        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
      },
      setFieldsValue: function setFieldsValue(fieldsValue) {
        if (onValuesChange) {
          onValuesChange(this.props, fieldsValue);
        }
        var newFields = {};
        var _fieldsStore2 = this.fieldsStore,
            fieldsMeta = _fieldsStore2.fieldsMeta,
            fields = _fieldsStore2.fields;

        var virtualPaths = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["g" /* getVirtualPaths */])(fieldsMeta);
        Object.keys(fieldsValue).forEach(function (name) {
          var value = fieldsValue[name];
          if (fieldsMeta[name] && fieldsMeta[name].virtual) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["h" /* clearVirtualField */])(name, fields, fieldsMeta);
            for (var i = 0, len = virtualPaths[name].length; i < len; i++) {
              var path = virtualPaths[name][i];
              if (__WEBPACK_IMPORTED_MODULE_9_lodash_has___default()(fieldsValue, path)) {
                newFields[path] = {
                  name: path,
                  value: __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(fieldsValue, path)
                };
              }
            }
          } else if (fieldsMeta[name]) {
            newFields[name] = {
              name: name,
              value: value
            };
          } else {
            __WEBPACK_IMPORTED_MODULE_7_warning___default()(false, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
        });
        this.setFields(newFields);
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          // after destroy, delete data
          this.fieldsStore.clearField(name);
          delete this.instances[name];
          delete this.cachedBind[name];
          return;
        }
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            }
            ref(component);
          }
        }
        this.instances[name] = component;
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this5 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              __WEBPACK_IMPORTED_MODULE_10_lodash_set___default()(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this5.fieldsStore.getFieldMeta(name);
          var newField = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this5.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this5.fieldsStore.getFieldValue(f);
        });
        if (callback && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* isEmptyObject */])(allFields)) {
          callback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* isEmptyObject */])(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["j" /* flatFieldNames */])(fieldNames)));
          return;
        }
        var validator = new __WEBPACK_IMPORTED_MODULE_6_async_validator___default.a(allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var fieldName = e.field;
              if (!__WEBPACK_IMPORTED_MODULE_9_lodash_has___default()(errorsGroup, fieldName)) {
                __WEBPACK_IMPORTED_MODULE_10_lodash_set___default()(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(errorsGroup, name);
            var nowField = _this5.fieldsStore.getField(name);
            // avoid concurrency problems
            if (nowField.value !== allValues[name]) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this5.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref2) {
                var name = _ref2.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                __WEBPACK_IMPORTED_MODULE_10_lodash_set___default()(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["i" /* isEmptyObject */])(errorsGroup) ? null : errorsGroup, _this5.fieldsStore.getFieldsValue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["j" /* flatFieldNames */])(fieldNames)));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this6 = this;

        var _getParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["k" /* getParams */])(ns, opt, cb),
            names = _getParams.names,
            callback = _getParams.callback,
            options = _getParams.options;

        var fieldNames = names || this.fieldsStore.getValidFieldsName();
        var fields = fieldNames.filter(function (name) {
          var fieldMeta = _this6.fieldsStore.getFieldMeta(name);
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* hasRules */])(fieldMeta.validate);
        }).map(function (name) {
          var field = _this6.fieldsStore.getField(name);
          field.value = _this6.fieldsStore.getFieldValue(name);
          return field;
        });
        if (!fields.length) {
          if (callback) {
            callback(null, this.fieldsStore.getFieldsValue(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["j" /* flatFieldNames */])(fieldNames)));
          }
          return;
        }
        if (!('firstFields' in options)) {
          options.firstFields = fieldNames.filter(function (name) {
            var fieldMeta = _this6.fieldsStore.getFieldMeta(name);
            return !!fieldMeta.validateFirst;
          });
        }
        this.validateFieldsInternal(fields, {
          fieldNames: fieldNames,
          options: options
        }, callback);
      },
      isSubmitting: function isSubmitting() {
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this7 = this;

        var fn = function fn() {
          _this7.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['wrappedComponentRef']);

        var formProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, formPropName, this.getForm());
        if (withRef) {
          __WEBPACK_IMPORTED_MODULE_7_warning___default()(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, formProps, restProps));
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, props);
      }
    });

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["l" /* argumentContainer */])(Form, WrappedComponent);
  }

  return decorate;
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseForm);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFieldsStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_has__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_set__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(502);









var atom = {};

var FieldsStore = function () {
  function FieldsStore(fields) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FieldsStore);

    _initialiseProps.call(this);

    this.fields = fields;
    this.fieldsMeta = {};
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()(this.fields, fields);
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        var _getNameIfNested = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* getNameIfNested */])(f),
            name = _getNameIfNested.name,
            isNested = _getNameIfNested.isNested;

        if (isNested && fieldsMeta[name].exclusive) {
          return;
        }
        nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = fieldsMeta[f];
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var newFields = {};
      var fields = this.fields;

      var names = ns || Object.keys(fields);
      names.forEach(function (name) {
        var field = fields[name];
        if (field && 'value' in field) {
          newFields[name] = {};
        }
      });
      return newFields;
    }
  }, {
    key: 'getValueFromFieldsInternal',
    value: function getValueFromFieldsInternal(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.fieldsMeta[name];
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var _this2 = this;

      var fieldsMeta = this.fieldsMeta;

      if (fieldsMeta[name] && fieldsMeta[name].virtual) {
        var ret = {};
        Object.keys(fieldsMeta).forEach(function (fieldKey) {
          var nameIfNested = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* getNameIfNested */])(fieldKey);
          if (nameIfNested.name === name && nameIfNested.isNested) {
            __WEBPACK_IMPORTED_MODULE_6_lodash_set___default()(ret, fieldKey, _this2.getValueFromFieldsInternal(fieldKey, fields));
          }
        });
        return ret[name];
      }
      return this.getValueFromFieldsInternal(name, fields);
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var fieldsMeta = this.fieldsMeta;
      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !fieldsMeta[name].hidden;
      }) : [];
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var exclusive = fieldMeta.exclusive,
          leadingName = fieldMeta.leadingName,
          name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;
      var fieldsMeta = this.fieldsMeta;

      var field = exclusive ? this.getField(leadingName) : this.getField(name);
      var fieldValue = atom;
      if (field && 'value' in field) {
        fieldValue = field.value;
      }
      if (fieldValue === atom) {
        fieldValue = exclusive ? fieldsMeta[leadingName].initialValue : fieldMeta.initialValue;
      }
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      if (!this.fieldsMeta[name]) {
        this.fieldsMeta[name] = {};
      }
      return this.fieldsMeta[name];
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);

  return FieldsStore;
}();

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getFieldsValue = function (names) {
    var fields = names || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["j" /* flatFieldNames */])(_this3.getValidFieldsName());
    var allValues = {};
    fields.forEach(function (f) {
      __WEBPACK_IMPORTED_MODULE_6_lodash_set___default()(allValues, f, _this3.getFieldValue(f));
    });
    return allValues;
  };

  this.getFieldValue = function (name) {
    var fields = _this3.fields;

    return _this3.getValueFromFields(name, fields);
  };

  this.getFieldsError = function (names) {
    var fields = names || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["j" /* flatFieldNames */])(_this3.getValidFieldsName());
    var allErrors = {};
    fields.forEach(function (f) {
      __WEBPACK_IMPORTED_MODULE_6_lodash_set___default()(allErrors, f, _this3.getFieldError(f));
    });
    return allErrors;
  };

  this.getFieldError = function (name) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["m" /* getErrorStrs */])(_this3.getFieldMember(name, 'errors'));
  };

  this.setFieldsInitialValue = function (initialValues) {
    var fieldsMeta = _this3.fieldsMeta;
    var virtualPaths = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["g" /* getVirtualPaths */])(fieldsMeta);
    Object.keys(initialValues).forEach(function (name) {
      if (fieldsMeta[name] && fieldsMeta[name].virtual) {
        for (var i = 0, len = virtualPaths[name].length; i < len; i++) {
          var path = virtualPaths[name][i];
          if (__WEBPACK_IMPORTED_MODULE_5_lodash_has___default()(initialValues, path)) {
            fieldsMeta[path] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, fieldsMeta[path], {
              initialValue: __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(initialValues, path)
            });
          }
        }
      } else if (fieldsMeta[name]) {
        fieldsMeta[name] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, fieldsMeta[name], {
          initialValue: initialValues[name]
        });
      }
    });
  };

  this.isFieldValidating = function (name) {
    return _this3.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this3.getValidFieldsName();
    return names.some(function (n) {
      return _this3.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this3.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this3.getValidFieldsName();
    return names.some(function (n) {
      return _this3.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new FieldsStore(fields);
}

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseForm__ = __webpack_require__(1219);


var mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createBaseForm__["a" /* default */])(options, [mixin]);
}

/* unused harmony default export */ var _unused_webpack_default_export = (createForm);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(503);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1222);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(24);

var emptyObject = __webpack_require__(138);
var _invariant = __webpack_require__(15);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1228);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1249),
    hashDelete = __webpack_require__(1250),
    hashGet = __webpack_require__(1251),
    hashHas = __webpack_require__(1252),
    hashSet = __webpack_require__(1253);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1257),
    listCacheDelete = __webpack_require__(1258),
    listCacheGet = __webpack_require__(1259),
    listCacheHas = __webpack_require__(1260),
    listCacheSet = __webpack_require__(1261);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(318),
    root = __webpack_require__(319);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1262),
    mapCacheDelete = __webpack_require__(1263),
    mapCacheGet = __webpack_require__(1264),
    mapCacheHas = __webpack_require__(1265),
    mapCacheSet = __webpack_require__(1266);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1236),
    eq = __webpack_require__(506);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1244);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(317),
    toKey = __webpack_require__(320);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(316),
    isObjectLike = __webpack_require__(322);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1272),
    isMasked = __webpack_require__(1256),
    isObject = __webpack_require__(321),
    toSource = __webpack_require__(1270);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1235),
    castPath = __webpack_require__(317),
    isIndex = __webpack_require__(505),
    isObject = __webpack_require__(321),
    toKey = __webpack_require__(320);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(315),
    arrayMap = __webpack_require__(1234),
    isArray = __webpack_require__(216),
    isSymbol = __webpack_require__(323);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(319);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(318);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(315);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(317),
    isArguments = __webpack_require__(1271),
    isArray = __webpack_require__(216),
    isIndex = __webpack_require__(505),
    isLength = __webpack_require__(1273),
    toKey = __webpack_require__(320);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(215);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(215);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(215);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(215);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(216),
    isSymbol = __webpack_require__(323);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1243);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(213);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(213);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(213);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(213);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1230),
    ListCache = __webpack_require__(1231),
    Map = __webpack_require__(1232);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(214);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1274);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1267);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1239),
    isObjectLike = __webpack_require__(322);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(316),
    isObject = __webpack_require__(321);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 1273 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1233);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1242);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);








// https://github.com/hammerjs/hammer.js/issues/930
// https://github.com/JedWatson/react-hammerjs/issues/14
// require('hammerjs') when in a browser. This is safe because Hammer is only
// invoked in componentDidMount, which is not executed on the server.
var Hammer = typeof window !== 'undefined' ? __webpack_require__(1130) : undefined;

var privateProps = {
	children: true,
	direction: true,
	options: true,
	recognizeWith: true,
	vertical: true
};

/**
 * Hammer Component
 * ================
 */

var handlerToEvent = {
	action: 'tap press',
	onDoubleTap: 'doubletap',
	onPan: 'pan',
	onPanCancel: 'pancancel',
	onPanEnd: 'panend',
	onPanStart: 'panstart',
	onPinch: 'pinch',
	onPinchCancel: 'pinchcancel',
	onPinchEnd: 'pinchend',
	onPinchIn: 'pinchin',
	onPinchOut: 'pinchout',
	onPinchStart: 'pinchstart',
	onPress: 'press',
	onPressUp: 'pressup',
	onRotate: 'rotate',
	onRotateCancel: 'rotatecancel',
	onRotateEnd: 'rotateend',
	onRotateMove: 'rotatemove',
	onRotateStart: 'rotatestart',
	onSwipe: 'swipe',
	onSwipeRight: 'swiperight',
	onSwipeLeft: 'swipeleft',
	onSwipeUp: 'swipeup',
	onSwipeDown: 'swipedown',
	onTap: 'tap'
};

Object.keys(handlerToEvent).forEach(function (i) {
	privateProps[i] = true;
});

function updateHammer(hammer, props) {
	var _this = this;

	if (props.hasOwnProperty('vertical')) {
		console.warn('vertical is deprecated, please use `direction` instead');
	}

	var directionProp = props.direction;
	if (directionProp || props.hasOwnProperty('vertical')) {
		var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
		hammer.get('pan').set({ direction: Hammer[direction] });
		hammer.get('swipe').set({ direction: Hammer[direction] });
	}

	if (props.options) {
		Object.keys(props.options).forEach(function (option) {
			if (option === 'recognizers') {
				Object.keys(props.options.recognizers).forEach(function (gesture) {
					var recognizer = hammer.get(gesture);
					recognizer.set(props.options.recognizers[gesture]);
					if (props.options.recognizers[gesture].requireFailure) {
						recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
					}
				}, _this);
			} else {
				var key = option;
				var optionObj = {};
				optionObj[key] = props.options[option];
				hammer.set(optionObj);
			}
		}, this);
	}

	if (props.recognizeWith) {
		Object.keys(props.recognizeWith).forEach(function (gesture) {
			var recognizer = hammer.get(gesture);
			recognizer.recognizeWith(props.recognizeWith[gesture]);
		}, this);
	}

	Object.keys(props).forEach(function (p) {
		var e = handlerToEvent[p];
		if (e) {
			hammer.off(e);
			hammer.on(e, props[p]);
		}
	});
}

var HammerComponent = function (_React$Component) {
	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(HammerComponent, _React$Component);

	function HammerComponent() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, HammerComponent);

		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(HammerComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.hammer = new Hammer(__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this));
			updateHammer(this.hammer, this.props);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.hammer) {
				updateHammer(this.hammer, this.props);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.hammer) {
				this.hammer.stop();
				this.hammer.destroy();
			}
			this.hammer = null;
		}
	}, {
		key: 'render',
		value: function render() {
			var props = {};

			Object.keys(this.props).forEach(function (i) {
				if (!privateProps[i]) {
					props[i] = this.props[i];
				}
			}, this);

			// Reuse the child provided
			// This makes it flexible to use whatever element is wanted (div, ul, etc)
			return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(this.props.children), props);
		}
	}]);

	return HammerComponent;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

HammerComponent.displayName = 'Hammer';
HammerComponent.propTypes = {
	className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (HammerComponent);

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1278);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1279);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1277);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(510);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(510);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_touchable__ = __webpack_require__(538);









var InputHandler = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputHandler, _Component);

  function InputHandler() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InputHandler);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InputHandler.__proto__ || Object.getPrototypeOf(InputHandler)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InputHandler, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          disabled = _props.disabled,
          otherProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'disabled']);

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_touchable__["default"],
        { disabled: disabled, activeClassName: prefixCls + '-handler-active' },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', otherProps)
      );
    }
  }]);

  return InputHandler;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

InputHandler.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (InputHandler);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixin__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputHandler__ = __webpack_require__(1286);









function noop() {}

function preventDefault(e) {
  e.preventDefault();
}

var InputNumber = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'InputNumber',

  propTypes: {
    focusOnUpDown: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onKeyDown: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onKeyUp: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    tabIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    onFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    readOnly: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
    upHandler: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
    downHandler: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
    useTouch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    parser: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onMouseOver: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    onMouseOut: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    precision: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixin__["a" /* default */]],

  getDefaultProps: function getDefaultProps() {
    return {
      focusOnUpDown: true,
      useTouch: false,
      prefixCls: 'rc-input-number'
    };
  },
  componentDidMount: function componentDidMount() {
    this.componentDidUpdate();
  },
  componentWillUpdate: function componentWillUpdate() {
    try {
      this.start = this.refs.input.selectionStart;
      this.end = this.refs.input.selectionEnd;
    } catch (e) {
      // Fix error in Chrome:
      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
      // http://stackoverflow.com/q/21177489/3040605
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.props.focusOnUpDown && this.state.focused) {
      var selectionRange = this.refs.input.setSelectionRange;
      if (selectionRange && typeof selectionRange === 'function' && this.start !== undefined && this.end !== undefined && this.start !== this.end) {
        this.refs.input.setSelectionRange(this.start, this.end);
      } else {
        this.focus();
      }
    }
  },
  onKeyDown: function onKeyDown(e) {
    if (e.keyCode === 38) {
      var ratio = this.getRatio(e);
      this.up(e, ratio);
      this.stop();
    } else if (e.keyCode === 40) {
      var _ratio = this.getRatio(e);
      this.down(e, _ratio);
      this.stop();
    }
    var onKeyDown = this.props.onKeyDown;

    if (onKeyDown) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      onKeyDown.apply(undefined, [e].concat(args));
    }
  },
  onKeyUp: function onKeyUp(e) {
    this.stop();
    var onKeyUp = this.props.onKeyUp;

    if (onKeyUp) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      onKeyUp.apply(undefined, [e].concat(args));
    }
  },
  getRatio: function getRatio(e) {
    var ratio = 1;
    if (e.metaKey || e.ctrlKey) {
      ratio = 0.1;
    } else if (e.shiftKey) {
      ratio = 10;
    }
    return ratio;
  },
  getValueFromEvent: function getValueFromEvent(e) {
    return e.target.value;
  },
  focus: function focus() {
    this.refs.input.focus();
  },
  formatWrapper: function formatWrapper(num) {
    if (this.props.formatter) {
      return this.props.formatter(num);
    }
    return num;
  },
  render: function render() {
    var _classNames;

    var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props);
    var prefixCls = props.prefixCls,
        disabled = props.disabled,
        readOnly = props.readOnly,
        useTouch = props.useTouch;

    var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, props.className, !!props.className), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-focused', this.state.focused), _classNames));
    var upDisabledClass = '';
    var downDisabledClass = '';
    var value = this.state.value;

    if (value) {
      if (!isNaN(value)) {
        var val = Number(value);
        if (val >= props.max) {
          upDisabledClass = prefixCls + '-handler-up-disabled';
        }
        if (val <= props.min) {
          downDisabledClass = prefixCls + '-handler-down-disabled';
        }
      } else {
        upDisabledClass = prefixCls + '-handler-up-disabled';
        downDisabledClass = prefixCls + '-handler-down-disabled';
      }
    }

    var editable = !props.readOnly && !props.disabled;

    // focus state, show input value
    // unfocus state, show valid value
    var inputDisplayValue = void 0;
    if (this.state.focused) {
      inputDisplayValue = this.state.inputValue;
    } else {
      inputDisplayValue = this.toPrecisionAsStep(this.state.value);
    }

    if (inputDisplayValue === undefined || inputDisplayValue === null) {
      inputDisplayValue = '';
    }

    var upEvents = void 0;
    var downEvents = void 0;
    if (useTouch) {
      upEvents = {
        onTouchStart: editable && !upDisabledClass ? this.up : noop,
        onTouchEnd: this.stop
      };
      downEvents = {
        onTouchStart: editable && !downDisabledClass ? this.down : noop,
        onTouchEnd: this.stop
      };
    } else {
      upEvents = {
        onMouseDown: editable && !upDisabledClass ? this.up : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
      downEvents = {
        onMouseDown: editable && !downDisabledClass ? this.down : noop,
        onMouseUp: this.stop,
        onMouseLeave: this.stop
      };
    }
    var inputDisplayValueFormat = this.formatWrapper(inputDisplayValue);
    var isUpDisabled = !!upDisabledClass || disabled || readOnly;
    var isDownDisabled = !!downDisabledClass || disabled || readOnly;
    // ref for test
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      {
        className: classes,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseOver: props.onMouseOver,
        onMouseOut: props.onMouseOut
      },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: prefixCls + '-handler-wrap' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: 'up',
            disabled: isUpDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, upEvents, {
            role: 'button',
            'aria-label': 'Increase Value',
            'aria-disabled': !!isUpDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
          }),
          this.props.upHandler || __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-up-inner',
            onClick: preventDefault
          })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__InputHandler__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            ref: 'down',
            disabled: isDownDisabled,
            prefixCls: prefixCls,
            unselectable: 'unselectable'
          }, downEvents, {
            role: 'button',
            'aria-label': 'Decrease Value',
            'aria-disabled': !!isDownDisabled,
            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
          }),
          this.props.downHandler || __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', {
            unselectable: 'unselectable',
            className: prefixCls + '-handler-down-inner',
            onClick: preventDefault
          })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: prefixCls + '-input-wrap',
          role: 'spinbutton',
          'aria-valuemin': props.min,
          'aria-valuemax': props.max,
          'aria-valuenow': value
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input', {
          type: props.type,
          placeholder: props.placeholder,
          onClick: props.onClick,
          className: prefixCls + '-input',
          tabIndex: props.tabIndex,
          autoComplete: 'off',
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onKeyDown: editable ? this.onKeyDown : noop,
          onKeyUp: editable ? this.onKeyUp : noop,
          autoFocus: props.autoFocus,
          maxLength: props.maxLength,
          readOnly: props.readOnly,
          disabled: props.disabled,
          max: props.max,
          min: props.min,
          step: props.step,
          name: props.name,
          id: props.id,
          onChange: this.onChange,
          ref: 'input',
          value: inputDisplayValueFormat
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["default"] = (InputNumber);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function noop() {}

function defaultParser(input) {
  return input.replace(/[^\w\.-]+/g, '');
}

/**
 * When click and hold on a button - the speed of auto changin the value.
 */
var SPEED = 200;

/**
 * When click and hold on a button - the delay before auto changin the value.
 */
var DELAY = 600;

/**
 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
 */
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

/* harmony default export */ __webpack_exports__["a"] = ({
  getDefaultProps: function getDefaultProps() {
    return {
      max: MAX_SAFE_INTEGER,
      min: -MAX_SAFE_INTEGER,
      step: 1,
      style: {},
      onChange: noop,
      onKeyDown: noop,
      onFocus: noop,
      onBlur: noop,
      parser: defaultParser
    };
  },
  getInitialState: function getInitialState() {
    var value = void 0;
    var props = this.props;
    if ('value' in props) {
      value = props.value;
    } else {
      value = props.defaultValue;
    }
    value = this.toNumber(value);
    return {
      inputValue: this.toPrecisionAsStep(value),
      value: value,
      focused: props.autoFocus
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      var value = this.state.focused ? nextProps.value : this.getValidValue(nextProps.value);
      this.setState({
        value: value,
        inputValue: this.inputting ? value : this.toPrecisionAsStep(value)
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.stop();
  },
  onChange: function onChange(e) {
    if (this.state.focused) {
      this.inputting = true;
    }
    var input = this.props.parser(this.getValueFromEvent(e).trim());
    this.setState({ inputValue: input });
    this.props.onChange(this.toNumberWhenUserInput(input)); // valid number or invalid string
  },
  onFocus: function onFocus() {
    var _props;

    this.setState({
      focused: true
    });
    (_props = this.props).onFocus.apply(_props, arguments);
  },
  onBlur: function onBlur(e) {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this.inputting = false;
    this.setState({
      focused: false
    });
    var value = this.getCurrentValidValue(this.state.inputValue);
    e.persist(); // fix https://github.com/react-component/input-number/issues/51
    this.setValue(value, function () {
      var _props2;

      (_props2 = _this.props).onBlur.apply(_props2, [e].concat(args));
    });
  },
  getCurrentValidValue: function getCurrentValidValue(value) {
    var val = value;
    if (val === '') {
      val = '';
    } else if (!this.isNotCompleteNumber(val)) {
      val = this.getValidValue(val);
    } else {
      val = this.state.value;
    }
    return this.toNumber(val);
  },
  getValidValue: function getValidValue(value) {
    var val = parseFloat(value, 10);
    // https://github.com/ant-design/ant-design/issues/7358
    if (isNaN(val)) {
      return value;
    }
    if (val < this.props.min) {
      val = this.props.min;
    }
    if (val > this.props.max) {
      val = this.props.max;
    }
    return val;
  },
  setValue: function setValue(v, callback) {
    // trigger onChange
    var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? undefined : parseFloat(v, 10);
    var changed = newValue !== this.state.value || '' + newValue !== '' + this.state.inputValue; // https://github.com/ant-design/ant-design/issues/7363
    if (!('value' in this.props)) {
      this.setState({
        value: newValue,
        inputValue: this.toPrecisionAsStep(v)
      }, callback);
    } else {
      // always set input value same as value
      this.setState({
        inputValue: this.toPrecisionAsStep(this.state.value)
      }, callback);
    }
    if (changed) {
      this.props.onChange(newValue);
    }
  },
  getPrecision: function getPrecision(value) {
    if ('precision' in this.props) {
      return this.props.precision;
    }
    var valueString = value.toString();
    if (valueString.indexOf('e-') >= 0) {
      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
    }
    var precision = 0;
    if (valueString.indexOf('.') >= 0) {
      precision = valueString.length - valueString.indexOf('.') - 1;
    }
    return precision;
  },


  // step={1.0} value={1.51}
  // press +
  // then value should be 2.51, rather than 2.5
  // if this.props.precision is undefined
  // https://github.com/react-component/input-number/issues/39
  getMaxPrecision: function getMaxPrecision(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    if ('precision' in this.props) {
      return this.props.precision;
    }
    var step = this.props.step;

    var ratioPrecision = this.getPrecision(ratio);
    var stepPrecision = this.getPrecision(step);
    var currentValuePrecision = this.getPrecision(currentValue);
    if (!currentValue) {
      return ratioPrecision + stepPrecision;
    }
    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
  },
  getPrecisionFactor: function getPrecisionFactor(currentValue) {
    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var precision = this.getMaxPrecision(currentValue, ratio);
    return Math.pow(10, precision);
  },
  toPrecisionAsStep: function toPrecisionAsStep(num) {
    if (this.isNotCompleteNumber(num) || num === '') {
      return num;
    }
    var precision = Math.abs(this.getMaxPrecision(num));
    if (precision === 0) {
      return num.toString();
    }
    if (!isNaN(precision)) {
      return Number(num).toFixed(precision);
    }
    return num.toString();
  },


  // '1.' '1x' 'xx' '' => are not complete numbers
  isNotCompleteNumber: function isNotCompleteNumber(num) {
    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
  },
  toNumber: function toNumber(num) {
    if (this.isNotCompleteNumber(num)) {
      return num;
    }
    if ('precision' in this.props) {
      return Number(Number(num).toFixed(this.props.precision));
    }
    return Number(num);
  },


  // '1.0' '1.00'  => may be a inputing number
  toNumberWhenUserInput: function toNumberWhenUserInput(num) {
    // num.length > 16 => prevent input large number will became Infinity
    if ((/\.\d*0$/.test(num) || num.length > 16) && this.state.focused) {
      return num;
    }
    return this.toNumber(num);
  },
  upStep: function upStep(val, rat) {
    var _props3 = this.props,
        step = _props3.step,
        min = _props3.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? step : min;
    }
    return this.toNumber(result);
  },
  downStep: function downStep(val, rat) {
    var _props4 = this.props,
        step = _props4.step,
        min = _props4.min;

    var precisionFactor = this.getPrecisionFactor(val, rat);
    var precision = Math.abs(this.getMaxPrecision(val, rat));
    var result = void 0;
    if (typeof val === 'number') {
      result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
    } else {
      result = min === -Infinity ? -step : min;
    }
    return this.toNumber(result);
  },
  step: function step(type, e) {
    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    if (e) {
      e.preventDefault();
    }
    var props = this.props;
    if (props.disabled) {
      return;
    }
    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
    if (this.isNotCompleteNumber(value)) {
      return;
    }
    var val = this[type + 'Step'](value, ratio);
    if (val > props.max) {
      val = props.max;
    } else if (val < props.min) {
      val = props.min;
    }
    this.setValue(val);
    this.setState({
      focused: true
    });
  },
  stop: function stop() {
    if (this.autoStepTimer) {
      clearTimeout(this.autoStepTimer);
    }
  },
  down: function down(e, ratio, recursive) {
    var _this2 = this;

    if (e.persist) {
      e.persist();
    }
    this.stop();
    this.step('down', e, ratio);
    this.autoStepTimer = setTimeout(function () {
      _this2.down(e, ratio, true);
    }, recursive ? SPEED : DELAY);
  },
  up: function up(e, ratio, recursive) {
    var _this3 = this;

    if (e.persist) {
      e.persist();
    }
    this.stop();
    this.step('up', e, ratio);
    this.autoStepTimer = setTimeout(function () {
      _this3.up(e, ratio, true);
    }, recursive ? SPEED : DELAY);
  }
});

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(511);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(511);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1289);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1291);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1290);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(512);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(512);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className), style: props.style, onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(1301);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      _this.setState(function (previousState) {
        var notices = previousState.notices;
        if (!notices.filter(function (v) {
          return v.key === key;
        }).length) {
          return {
            notices: notices.concat(notice)
          };
        }
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var noticeNodes = this.state.notices.map(function (notice) {
        var onClose = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            onClose: onClose
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["a" /* default */],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
};
Notification.defaultProps = {
  prefixCls: 'rc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = void 0;
  if (getContainer) {
    div = getContainer();
  } else {
    div = document.createElement('div');
    document.body.appendChild(div);
  }
  var notification = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, props), div);
  return {
    notice: function notice(noticeProps) {
      notification.add(noticeProps);
    },
    removeNotice: function removeNotice(key) {
      notification.remove(key);
    },

    component: notification,
    destroy: function destroy() {
      __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
      if (!getContainer) {
        document.body.removeChild(div);
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(1302);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1304);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(173);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(524);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(72);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(172);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(74);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(73);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(175);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _shallowequal = __webpack_require__(625);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _Track = __webpack_require__(521);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(522);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(325);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Range = function (_React$Component) {
  (0, _inherits3['default'])(Range, _React$Component);

  function Range(props) {
    (0, _classCallCheck3['default'])(this, Range);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ handle: null });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(null, Array(count + 1)).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v) {
      return _this.trimAlignValue(v);
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  (0, _createClass3['default'])(Range, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
      if (this.props.min === nextProps.min && this.props.max === nextProps.max && (0, _shallowequal2['default'])(this.props.value, nextProps.value)) {
        return;
      }
      var bounds = this.state.bounds;

      var value = nextProps.value || bounds;
      var nextBounds = value.map(function (v) {
        return _this2.trimAlignValue(v, nextProps);
      });
      if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
        return v === bounds[i];
      })) return;

      this.setState({ bounds: nextBounds });
      if (bounds.some(function (v) {
        return utils.isValueOutOfRange(v, nextProps);
      })) {
        this.props.onChange(nextBounds);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else if (state.handle !== undefined) {
        this.setState({ handle: state.handle });
      }

      var data = (0, _extends3['default'])({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: boundNeedMoving,
        recent: boundNeedMoving
      });

      var prevValue = bounds[boundNeedMoving];
      if (value === prevValue) return;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      nextBounds[boundNeedMoving] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var props = this.props;
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
      nextBounds[state.handle] = value;
      var nextHandle = state.handle;
      if (props.pushable !== false) {
        var originalValue = state.bounds[nextHandle];
        this.pushSurroundingHandles(nextBounds, nextHandle, originalValue);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        handle: nextHandle,
        bounds: nextBounds
      });
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value > bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound = closestBound + 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
      if (isAtTheSamePoint) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props = this.props,
          marks = _props.marks,
          step = _props.step,
          min = _props.min,
          max = _props.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = (0, _extends3['default'])({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle, originalValue) {
      var threshold = this.props.pushable;

      var value = bounds[handle];

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = originalValue;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var valInRange = utils.ensureValueInRange(v, mergedProps);
      var valNotConflict = this.ensureValueNotConflict(valInRange, mergedProps);
      return utils.ensureValuePrecision(valNotConflict, mergedProps);
    }
  }, {
    key: 'ensureValueNotConflict',
    value: function ensureValueNotConflict(val, _ref) {
      var allowCross = _ref.allowCross;

      var state = this.state || {};
      var handle = state.handle,
          bounds = state.bounds;
      /* eslint-disable eqeqeq */

      if (!allowCross && handle != null) {
        if (handle > 0 && val <= bounds[handle - 1]) {
          return bounds[handle - 1];
        }
        if (handle < bounds.length - 1 && val >= bounds[handle + 1]) {
          return bounds[handle + 1];
        }
      }
      /* eslint-enable eqeqeq */
      return val;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          vertical = _props2.vertical,
          included = _props2.included,
          disabled = _props2.disabled,
          min = _props2.min,
          max = _props2.max,
          handleGenerator = _props2.handle,
          trackStyle = _props2.trackStyle,
          handleStyle = _props2.handleStyle;


      var offsets = bounds.map(function (v) {
        return _this3.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        return handleGenerator({
          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          min: min,
          max: max,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this3.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return _react2['default'].createElement(_Track2['default'], {
          className: trackClassName,
          vertical: vertical,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }]);
  return Range;
}(_react2['default'].Component); /* eslint-disable react/prop-types */


Range.displayName = 'Range';
Range.propTypes = {
  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
  count: _propTypes2['default'].number,
  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
  allowCross: _propTypes2['default'].bool,
  disabled: _propTypes2['default'].bool
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false
};
exports['default'] = (0, _createSlider2['default'])(Range);
module.exports = exports['default'];

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(72);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(172);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(74);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(73);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(175);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _Track = __webpack_require__(521);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(522);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(325);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prop-types */
var Slider = function (_React$Component) {
  (0, _inherits3['default'])(Slider, _React$Component);

  function Slider(props) {
    (0, _classCallCheck3['default'])(this, Slider);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    if (false) {
      (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
      (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
    }
    return _this;
  }

  (0, _createClass3['default'])(Slider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

      var prevValue = this.state.value;
      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
      var nextValue = this.trimAlignValue(value, nextProps);
      if (nextValue === prevValue) return;

      this.setState({ value: nextValue });
      if (utils.isValueOutOfRange(value, nextProps)) {
        this.props.onChange(nextValue);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      }

      var changedValue = state.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var state = this.state;
      var value = this.calcValueByPos(position);
      var oldValue = state.value;
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var val = utils.ensureValueInRange(v, mergedProps);
      return utils.ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          included = _props.included,
          disabled = _props.disabled,
          minimumTrackStyle = _props.minimumTrackStyle,
          trackStyle = _props.trackStyle,
          handleStyle = _props.handleStyle,
          min = _props.min,
          max = _props.max,
          handleGenerator = _props.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = _react2['default'].createElement(_Track2['default'], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        length: offset,
        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);
  return Slider;
}(_react2['default'].Component);

Slider.propTypes = {
  defaultValue: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  disabled: _propTypes2['default'].bool
};
exports['default'] = (0, _createSlider2['default'])(Slider);
module.exports = exports['default'];

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(326);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(173);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;

    var markPoint = marks[point];
    var markPointIsObject = (typeof markPoint === 'undefined' ? 'undefined' : (0, _typeof3['default'])(markPoint)) === 'object' && !_react2['default'].isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
    return _react2['default'].createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point
      },
      markLabel
    );
  });

  return _react2['default'].createElement(
    'div',
    { className: className },
    elements
  );
};

exports['default'] = Marks;
module.exports = exports['default'];

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(173);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i = i + step) {
      if (points.indexOf(i) >= 0) continue;
      points.push(i);
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? (0, _extends3['default'])({ bottom: offset }, dotStyle) : (0, _extends3['default'])({ left: offset }, dotStyle);
    if (isActived) {
      style = (0, _extends3['default'])({}, style, activeDotStyle);
    }

    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), _classNames));

    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
  });

  return _react2['default'].createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

exports['default'] = Steps;
module.exports = exports['default'];

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(174);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(173);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(62);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(72);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(172);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(74);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(73);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createSliderWithTooltip;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(175);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTooltip = __webpack_require__(1329);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

var _Handle = __webpack_require__(520);

var _Handle2 = _interopRequireDefault(_Handle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function createSliderWithTooltip(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    (0, _inherits3['default'])(ComponentWrapper, _React$Component);

    function ComponentWrapper(props) {
      (0, _classCallCheck3['default'])(this, ComponentWrapper);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call(this, props));

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: (0, _extends4['default'])({}, prevState.visibles, (0, _defineProperty3['default'])({}, index, visible))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = (0, _objectWithoutProperties3['default'])(_ref, ['value', 'dragging', 'index', 'disabled']);
        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;
        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            restTooltipProps = (0, _objectWithoutProperties3['default'])(tipProps, ['prefixCls', 'overlay', 'placement']);


        return _react2['default'].createElement(
          _rcTooltip2['default'],
          (0, _extends4['default'])({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging),
            key: index
          }),
          _react2['default'].createElement(_Handle2['default'], (0, _extends4['default'])({}, restProps, {
            style: (0, _extends4['default'])({}, handleStyle[0]),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      };

      _this.state = { visibles: {} };
      return _this;
    }

    (0, _createClass3['default'])(ComponentWrapper, [{
      key: 'render',
      value: function render() {
        return _react2['default'].createElement(Component, (0, _extends4['default'])({}, this.props, { handle: this.handleWithTooltip }));
      }
    }]);
    return ComponentWrapper;
  }(_react2['default'].Component), _class.propTypes = {
    tipFormatter: _propTypes2['default'].func,
    handleStyle: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
    tipProps: _propTypes2['default'].object
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {}
  }, _temp;
}
module.exports = exports['default'];

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(964), __esModule: true };

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(965), __esModule: true };

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(1320);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(1319);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);
var ReactPropTypesSecret = __webpack_require__(1326);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(1327);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1328);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1332);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(527);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(526);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(1333);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["a" /* polyfill */])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1337);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function isString(str) {
  return typeof str === 'string';
}

var Step = function (_React$Component) {
  _inherits(Step, _React$Component);

  function Step() {
    _classCallCheck(this, Step);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Step.prototype.render = function render() {
    var _classNames, _classNames2;

    var _props = this.props,
        className = _props.className,
        prefixCls = _props.prefixCls,
        style = _props.style,
        itemWidth = _props.itemWidth,
        _props$status = _props.status,
        status = _props$status === undefined ? 'wait' : _props$status,
        iconPrefix = _props.iconPrefix,
        icon = _props.icon,
        wrapperStyle = _props.wrapperStyle,
        adjustMarginRight = _props.adjustMarginRight,
        stepNumber = _props.stepNumber,
        description = _props.description,
        title = _props.title,
        progressDot = _props.progressDot,
        restProps = _objectWithoutProperties(_props, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'progressDot']);

    var iconClassName = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls + '-icon', true), _defineProperty(_classNames, iconPrefix + 'icon', true), _defineProperty(_classNames, iconPrefix + 'icon-' + icon, icon && isString(icon)), _defineProperty(_classNames, iconPrefix + 'icon-check', !icon && status === 'finish'), _defineProperty(_classNames, iconPrefix + 'icon-cross', !icon && status === 'error'), _classNames));

    var iconNode = void 0;
    var iconDot = _react2["default"].createElement('span', { className: prefixCls + '-icon-dot' });
    // `progressDot` enjoy the highest priority
    if (!!progressDot) {
      if (typeof progressDot === 'function') {
        iconNode = _react2["default"].createElement(
          'span',
          { className: prefixCls + '-icon' },
          progressDot(iconDot, { index: stepNumber - 1, status: status, title: title, description: description })
        );
      } else {
        iconNode = _react2["default"].createElement(
          'span',
          { className: prefixCls + '-icon' },
          iconDot
        );
      }
    } else if (icon && !isString(icon)) {
      iconNode = _react2["default"].createElement(
        'span',
        { className: prefixCls + '-icon' },
        icon
      );
    } else if (icon || status === 'finish' || status === 'error') {
      iconNode = _react2["default"].createElement('span', { className: iconClassName });
    } else {
      iconNode = _react2["default"].createElement(
        'span',
        { className: prefixCls + '-icon' },
        stepNumber
      );
    }
    var classString = (0, _classnames2["default"])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-status-' + status, true), _defineProperty(_classNames2, prefixCls + '-custom', icon), _defineProperty(_classNames2, className, !!className), _classNames2));
    return _react2["default"].createElement(
      'div',
      _extends({}, restProps, {
        className: classString,
        style: _extends({ width: itemWidth, marginRight: adjustMarginRight }, style)
      }),
      _react2["default"].createElement(
        'div',
        {
          ref: 'tail',
          className: prefixCls + '-tail',
          style: { paddingRight: -adjustMarginRight }
        },
        _react2["default"].createElement('i', null)
      ),
      _react2["default"].createElement(
        'div',
        { className: prefixCls + '-step' },
        _react2["default"].createElement(
          'div',
          {
            className: prefixCls + '-head',
            style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
          },
          _react2["default"].createElement(
            'div',
            { className: prefixCls + '-head-inner' },
            iconNode
          )
        ),
        _react2["default"].createElement(
          'div',
          { ref: 'main', className: prefixCls + '-main' },
          _react2["default"].createElement(
            'div',
            {
              className: prefixCls + '-title',
              style: { background: wrapperStyle.background || wrapperStyle.backgroundColor }
            },
            title
          ),
          description ? _react2["default"].createElement(
            'div',
            { className: prefixCls + '-description' },
            description
          ) : ''
        )
      )
    );
  };

  return Step;
}(_react2["default"].Component);

exports["default"] = Step;


Step.propTypes = {
  className: _propTypes2["default"].string,
  prefixCls: _propTypes2["default"].string,
  style: _propTypes2["default"].object,
  wrapperStyle: _propTypes2["default"].object,
  itemWidth: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  status: _propTypes2["default"].string,
  iconPrefix: _propTypes2["default"].string,
  icon: _propTypes2["default"].node,
  adjustMarginRight: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
  stepNumber: _propTypes2["default"].string,
  description: _propTypes2["default"].any,
  title: _propTypes2["default"].any,
  progressDot: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].func])
};
module.exports = exports['default'];

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(1143);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Steps = function (_React$Component) {
  _inherits(Steps, _React$Component);

  function Steps(props) {
    _classCallCheck(this, Steps);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.calcStepOffsetWidth = function () {
      var domNode = _reactDom2["default"].findDOMNode(_this);
      if (domNode.children.length > 0) {
        if (_this.calcTimeout) {
          clearTimeout(_this.calcTimeout);
        }
        _this.calcTimeout = setTimeout(function () {
          // +1 for fit edge bug of digit width, like 35.4px
          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
          // Reduce shake bug
          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
            return;
          }
          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
        });
      }
    };

    _this.state = {
      lastStepOffsetWidth: 0
    };
    _this.calcStepOffsetWidth = (0, _lodash2["default"])(_this.calcStepOffsetWidth, 150);
    return _this;
  }

  Steps.prototype.componentDidMount = function componentDidMount() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
    this.calcStepOffsetWidth();
  };

  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.calcTimeout) {
      clearTimeout(this.calcTimeout);
    }
    if (this.calcStepOffsetWidth.cancel) {
      this.calcStepOffsetWidth.cancel();
    }
  };

  Steps.prototype.render = function render() {
    var _classNames,
        _this2 = this;

    var props = this.props;

    var prefixCls = props.prefixCls,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        className = props.className,
        children = props.children,
        direction = props.direction,
        labelPlacement = props.labelPlacement,
        iconPrefix = props.iconPrefix,
        status = props.status,
        size = props.size,
        current = props.current,
        progressDot = props.progressDot,
        restProps = _objectWithoutProperties(props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot']);

    var filteredChildren = _react2["default"].Children.toArray(children).filter(function (c) {
      return !!c;
    });
    var lastIndex = filteredChildren.length - 1;
    var reLayouted = this.state.lastStepOffsetWidth > 0;
    var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
    var classString = (0, _classnames2["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, prefixCls + '-' + size, size), _defineProperty(_classNames, prefixCls + '-' + direction, true), _defineProperty(_classNames, prefixCls + '-label-' + adjustedlabelPlacement, direction === 'horizontal'), _defineProperty(_classNames, prefixCls + '-hidden', !reLayouted), _defineProperty(_classNames, prefixCls + '-dot', !!progressDot), _defineProperty(_classNames, className, className), _classNames));

    return _react2["default"].createElement(
      'div',
      _extends({ className: classString, style: style }, restProps),
      _react2["default"].Children.map(filteredChildren, function (ele, idx) {
        if (!ele) {
          return null;
        }
        var itemWidth = direction === 'vertical' || idx === lastIndex || !reLayouted ? null : 100 / lastIndex + '%';
        var adjustMarginRight = direction === 'vertical' || idx === lastIndex ? null : -Math.round(_this2.state.lastStepOffsetWidth / lastIndex + 1);
        var np = {
          stepNumber: (idx + 1).toString(),
          itemWidth: itemWidth,
          adjustMarginRight: adjustMarginRight,
          prefixCls: prefixCls,
          iconPrefix: iconPrefix,
          wrapperStyle: style,
          progressDot: progressDot
        };

        // fix tail color
        if (status === 'error' && idx === current - 1) {
          np.className = props.prefixCls + '-next-error';
        }

        if (!ele.props.status) {
          if (idx === current) {
            np.status = status;
          } else if (idx < current) {
            np.status = 'finish';
          } else {
            np.status = 'wait';
          }
        }
        return _react2["default"].cloneElement(ele, np);
      }, this)
    );
  };

  return Steps;
}(_react2["default"].Component);

exports["default"] = Steps;


Steps.propTypes = {
  prefixCls: _propTypes2["default"].string,
  iconPrefix: _propTypes2["default"].string,
  direction: _propTypes2["default"].string,
  labelPlacement: _propTypes2["default"].string,
  children: _propTypes2["default"].any,
  status: _propTypes2["default"].string,
  size: _propTypes2["default"].string,
  progressDot: _propTypes2["default"].oneOfType([_propTypes2["default"].bool, _propTypes2["default"].func])
};

Steps.defaultProps = {
  prefixCls: 'rc-steps',
  iconPrefix: 'rc',
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  current: 0,
  status: 'process',
  size: '',
  progressDot: false
};
module.exports = exports['default'];

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Steps = __webpack_require__(1339);

var _Steps2 = _interopRequireDefault(_Steps);

var _Step = __webpack_require__(1338);

var _Step2 = _interopRequireDefault(_Step);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Steps2["default"].Step = _Step2["default"];
exports["default"] = _Steps2["default"];
module.exports = exports['default'];

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_hammerjs__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_omit_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);






var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};






var Swipeout = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Swipeout, _React$Component);

    function Swipeout(props) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Swipeout);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Swipeout.__proto__ || Object.getPrototypeOf(Swipeout)).call(this, props));

        _this.onCloseSwipe = function (ev) {
            if (_this.openedLeft || _this.openedRight) {
                var pNode = function (node) {
                    while (node.parentNode && node.parentNode !== document.body) {
                        if (node.className.indexOf(_this.props.prefixCls + '-actions') > -1) {
                            return node;
                        }
                        node = node.parentNode;
                    }
                }(ev.target);
                if (!pNode) {
                    ev.preventDefault();
                    _this.close();
                }
            }
        };
        _this.onPanStart = function (e) {
            var direction = e.offsetDirection;
            // http://hammerjs.github.io/api/#directions
            var isLeft = direction === 2;
            var isRight = direction === 4;
            if (!isLeft && !isRight) {
                return;
            }
            var _this$props = _this.props,
                left = _this$props.left,
                right = _this$props.right;

            _this.needShowRight = isLeft && right.length > 0;
            _this.needShowLeft = isRight && left.length > 0;
            if (_this.left) {
                _this.left.style.visibility = _this.needShowRight ? 'hidden' : 'visible';
            }
            if (_this.right) {
                _this.right.style.visibility = _this.needShowLeft ? 'hidden' : 'visible';
            }
            if (_this.needShowLeft || _this.needShowRight) {
                _this.swiping = true;
                _this.setState({
                    swiping: _this.swiping
                });
            }
        };
        _this.onPan = function (e) {
            var deltaX = e.deltaX;

            if (!_this.swiping) {
                return;
            }
            _this._setStyle(deltaX);
        };
        _this.onPanEnd = function (e) {
            if (!_this.swiping) {
                return;
            }
            var btnsLeftWidth = _this.btnsLeftWidth;
            var btnsRightWidth = _this.btnsRightWidth;
            var deltaX = e.deltaX;

            var needOpenRight = _this.needShowRight && Math.abs(deltaX) > btnsRightWidth / 2;
            var needOpenLeft = _this.needShowLeft && Math.abs(deltaX) > btnsRightWidth / 2;
            if (needOpenRight) {
                _this.open(-btnsRightWidth, false, true);
            } else if (needOpenLeft) {
                _this.open(btnsLeftWidth, true, false);
            } else {
                _this.close();
            }
            _this.swiping = false;
            _this.setState({
                swiping: _this.swiping
            });
            _this.needShowLeft = false;
            _this.needShowRight = false;
        };
        // set content & actions style
        _this._setStyle = function (value) {
            var limit = value > 0 ? _this.btnsLeftWidth : -_this.btnsRightWidth;
            var contentLeft = _this._getContentEasing(value, limit);
            _this.content.style.left = contentLeft + 'px';
            if (_this.cover) {
                _this.cover.style.display = Math.abs(value) > 0 ? 'block' : 'none';
                _this.cover.style.left = contentLeft + 'px';
            }
        };
        _this.open = function (value, openedLeft, openedRight) {
            if (!_this.openedLeft && !_this.openedRight && _this.props.onOpen) {
                _this.props.onOpen();
            }
            _this.openedLeft = openedLeft;
            _this.openedRight = openedRight;
            _this._setStyle(value);
        };
        _this.close = function () {
            if ((_this.openedLeft || _this.openedRight) && _this.props.onClose) {
                _this.props.onClose();
            }
            _this._setStyle(0);
            _this.openedLeft = false;
            _this.openedRight = false;
        };
        _this.state = {
            swiping: false
        };
        _this.openedLeft = false;
        _this.openedRight = false;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Swipeout, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.btnsLeftWidth = this.left ? this.left.offsetWidth : 0;
            this.btnsRightWidth = this.right ? this.right.offsetWidth : 0;
            document.body.addEventListener('touchstart', this.onCloseSwipe, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('touchstart', this.onCloseSwipe, true);
        }
        // left & right button click

    }, {
        key: 'onBtnClick',
        value: function onBtnClick(ev, btn) {
            var onPress = btn.onPress;
            if (onPress) {
                onPress(ev);
            }
            if (this.props.autoClose) {
                this.close();
            }
        }
    }, {
        key: '_getContentEasing',
        value: function _getContentEasing(value, limit) {
            // limit content style left when value > actions width
            var delta = Math.abs(value) - Math.abs(limit);
            var isOverflow = delta > 0;
            var factor = limit > 0 ? 1 : -1;
            if (isOverflow) {
                value = limit + Math.pow(delta, 0.85) * factor;
                return Math.abs(value) > Math.abs(limit) ? limit : value;
            }
            return value;
        }
    }, {
        key: 'renderButtons',
        value: function renderButtons(buttons, _ref) {
            var _this2 = this;

            var prefixCls = this.props.prefixCls;
            return buttons && buttons.length ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                { className: prefixCls + '-actions ' + prefixCls + '-actions-' + _ref, ref: function ref(el) {
                        return _this2[_ref] = el;
                    } },
                buttons.map(function (btn, i) {
                    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { key: i, className: prefixCls + '-btn ' + (btn.hasOwnProperty('className') ? btn.className : ''), style: btn.style, role: 'button', onClick: function onClick(e) {
                                return _this2.onBtnClick(e, btn);
                            } },
                        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                            'div',
                            { className: prefixCls + '-btn-text' },
                            btn.text || 'Click'
                        )
                    );
                })
            ) : null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                left = _a.left,
                right = _a.right,
                disabled = _a.disabled,
                children = _a.children,
                restProps = __rest(_a, ["prefixCls", "left", "right", "disabled", "children"]);
            var divProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_omit_js__["default"])(restProps, ['autoClose', 'onOpen', 'onClose']);
            var refProps = {
                ref: function ref(el) {
                    return _this3.content = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(el);
                }
            };
            var cls = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-swiping', this.state.swiping));
            return (left.length || right.length) && !disabled ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: cls }, divProps),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: prefixCls + '-cover', ref: function ref(el) {
                        return _this3.cover = el;
                    } }),
                this.renderButtons(left, 'left'),
                this.renderButtons(right, 'right'),
                __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_8_rc_hammerjs__["default"],
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ direction: 'DIRECTION_HORIZONTAL', onPanStart: this.onPanStart, onPan: this.onPan, onPanEnd: this.onPanEnd }, refProps),
                    __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                        'div',
                        { className: prefixCls + '-content' },
                        children
                    )
                )
            ) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
                'div',
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, refProps, divProps),
                children
            );
        }
    }]);

    return Swipeout;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Swipeout);

Swipeout.defaultProps = {
    prefixCls: 'rc-swipeout',
    autoClose: false,
    disabled: false,
    left: [],
    right: [],
    onOpen: function onOpen() {},
    onClose: function onClose() {}
};

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipeout__ = __webpack_require__(1341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Swipeout__["a"]; });


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(528);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(528);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1343);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1345);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1344);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(529);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(529);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Column = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Column, _Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Column.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  colSpan: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node,
  dataIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  fixed: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf([true, 'left', 'right']),
  render: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onCellClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (Column);

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var ColumnGroup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ColumnGroup, _Component);

  function ColumnGroup() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ColumnGroup);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
  }

  return ColumnGroup;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ColumnGroup.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
};
ColumnGroup.isTableColumnGroup = true;
/* harmony default export */ __webpack_exports__["a"] = (ColumnGroup);

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var ColumnManager = function () {
  function ColumnManager(columns, elements) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ColumnManager);

    this._cached = {};

    this.columns = columns || this.normalize(elements);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ColumnManager, [{
    key: 'isAnyColumnsFixed',
    value: function isAnyColumnsFixed() {
      var _this = this;

      return this._cache('isAnyColumnsFixed', function () {
        return _this.columns.some(function (column) {
          return !!column.fixed;
        });
      });
    }
  }, {
    key: 'isAnyColumnsLeftFixed',
    value: function isAnyColumnsLeftFixed() {
      var _this2 = this;

      return this._cache('isAnyColumnsLeftFixed', function () {
        return _this2.columns.some(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: 'isAnyColumnsRightFixed',
    value: function isAnyColumnsRightFixed() {
      var _this3 = this;

      return this._cache('isAnyColumnsRightFixed', function () {
        return _this3.columns.some(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: 'leftColumns',
    value: function leftColumns() {
      var _this4 = this;

      return this._cache('leftColumns', function () {
        return _this4.groupedColumns().filter(function (column) {
          return column.fixed === 'left' || column.fixed === true;
        });
      });
    }
  }, {
    key: 'rightColumns',
    value: function rightColumns() {
      var _this5 = this;

      return this._cache('rightColumns', function () {
        return _this5.groupedColumns().filter(function (column) {
          return column.fixed === 'right';
        });
      });
    }
  }, {
    key: 'leafColumns',
    value: function leafColumns() {
      var _this6 = this;

      return this._cache('leafColumns', function () {
        return _this6._leafColumns(_this6.columns);
      });
    }
  }, {
    key: 'leftLeafColumns',
    value: function leftLeafColumns() {
      var _this7 = this;

      return this._cache('leftLeafColumns', function () {
        return _this7._leafColumns(_this7.leftColumns());
      });
    }
  }, {
    key: 'rightLeafColumns',
    value: function rightLeafColumns() {
      var _this8 = this;

      return this._cache('rightLeafColumns', function () {
        return _this8._leafColumns(_this8.rightColumns());
      });
    }

    // add appropriate rowspan and colspan to column

  }, {
    key: 'groupedColumns',
    value: function groupedColumns() {
      var _this9 = this;

      return this._cache('groupedColumns', function () {
        var _groupColumns = function _groupColumns(columns) {
          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

          // track how many rows we got
          rows[currentRow] = rows[currentRow] || [];
          var grouped = [];
          var setRowSpan = function setRowSpan(column) {
            var rowSpan = rows.length - currentRow;
            if (column && !column.children && // parent columns are supposed to be one row
            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
              column.rowSpan = rowSpan;
            }
          };
          columns.forEach(function (column, index) {
            var newColumn = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, column);
            rows[currentRow].push(newColumn);
            parentColumn.colSpan = parentColumn.colSpan || 0;
            if (newColumn.children && newColumn.children.length > 0) {
              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
              parentColumn.colSpan = parentColumn.colSpan + newColumn.colSpan;
            } else {
              parentColumn.colSpan++;
            }
            // update rowspan to all same row columns
            for (var i = 0; i < rows[currentRow].length - 1; ++i) {
              setRowSpan(rows[currentRow][i]);
            }
            // last column, update rowspan immediately
            if (index + 1 === columns.length) {
              setRowSpan(newColumn);
            }
            grouped.push(newColumn);
          });
          return grouped;
        };
        return _groupColumns(_this9.columns);
      });
    }
  }, {
    key: 'normalize',
    value: function normalize(elements) {
      var _this10 = this;

      var columns = [];
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(elements, function (element) {
        if (!__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(element)) {
          return;
        }
        var column = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, element.props);
        if (element.key) {
          column.key = element.key;
        }
        if (element.type.isTableColumnGroup) {
          column.children = _this10.normalize(column.children);
        }
        columns.push(column);
      });
      return columns;
    }
  }, {
    key: 'reset',
    value: function reset(columns, elements) {
      this.columns = columns || this.normalize(elements);
      this._cached = {};
    }
  }, {
    key: '_cache',
    value: function _cache(name, fn) {
      if (name in this._cached) {
        return this._cached[name];
      }
      this._cached[name] = fn();
      return this._cached[name];
    }
  }, {
    key: '_leafColumns',
    value: function _leafColumns(columns) {
      var _this11 = this;

      var leafColumns = [];
      columns.forEach(function (column) {
        if (!column.children) {
          leafColumns.push(column);
        } else {
          leafColumns.push.apply(leafColumns, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this11._leafColumns(column.children)));
        }
      });
      return leafColumns;
    }
  }]);

  return ColumnManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ColumnManager);

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shallowequal__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shallowequal__);








var ExpandIcon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExpandIcon, _React$Component);

  function ExpandIcon() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ExpandIcon);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExpandIcon.__proto__ || Object.getPrototypeOf(ExpandIcon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ExpandIcon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_6_shallowequal___default()(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          expandable = _props.expandable,
          prefixCls = _props.prefixCls,
          onExpand = _props.onExpand,
          needIndentSpaced = _props.needIndentSpaced,
          expanded = _props.expanded,
          record = _props.record;

      if (expandable) {
        var expandClassName = expanded ? 'expanded' : 'collapsed';
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', {
          className: prefixCls + '-expand-icon ' + prefixCls + '-' + expandClassName,
          onClick: function onClick(e) {
            return onExpand(!expanded, record, e);
          }
        });
      } else if (needIndentSpaced) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: prefixCls + '-expand-icon ' + prefixCls + '-spaced' });
      }
      return null;
    }
  }]);

  return ExpandIcon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ExpandIcon.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  expandable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  needIndentSpaced: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onExpand: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (ExpandIcon);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableRow__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableHeader__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ColumnManager__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__createStore__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_component_classes__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_component_classes__);

















var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.onExpanded = function (expanded, record, e, index) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      var info = _this.findExpandedRow(record);
      if (typeof info !== 'undefined' && !expanded) {
        _this.onRowDestroy(record, index);
      } else if (!info && expanded) {
        var expandedRows = _this.getExpandedRows().concat();
        expandedRows.push(_this.getRowKey(record, index));
        _this.onExpandedRowsChange(expandedRows);
      }
      _this.props.onExpand(expanded, record);
    };

    _this.onRowDestroy = function (record, rowIndex) {
      var expandedRows = _this.getExpandedRows().concat();
      var rowKey = _this.getRowKey(record, rowIndex);
      var index = -1;
      expandedRows.forEach(function (r, i) {
        if (r === rowKey) {
          index = i;
        }
      });
      if (index !== -1) {
        expandedRows.splice(index, 1);
      }
      _this.onExpandedRowsChange(expandedRows);
    };

    _this.handleWindowResize = function () {
      _this.syncFixedTableRowHeight();
      _this.setScrollPositionClassName();
    };

    _this.syncFixedTableRowHeight = function () {
      var tableRect = _this.tableNode.getBoundingClientRect();
                  if (tableRect.height !== undefined && tableRect.height <= 0) {
        return;
      }
      var prefixCls = _this.props.prefixCls;

      var headRows = _this.refs.headTable ? _this.refs.headTable.querySelectorAll('thead') : _this.refs.bodyTable.querySelectorAll('thead');
      var bodyRows = _this.refs.bodyTable.querySelectorAll('.' + prefixCls + '-row') || [];
      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
        return row.getBoundingClientRect().height || 'auto';
      });
      var fixedColumnsBodyRowsHeight = [].map.call(bodyRows, function (row) {
        return row.getBoundingClientRect().height || 'auto';
      });
      if (__WEBPACK_IMPORTED_MODULE_11_shallowequal___default()(_this.state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && __WEBPACK_IMPORTED_MODULE_11_shallowequal___default()(_this.state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
        return;
      }
      _this.setState({
        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
      });
    };

    _this.handleBodyScrollLeft = function (e) {
      var target = e.target;
      var _this$props$scroll = _this.props.scroll,
          scroll = _this$props$scroll === undefined ? {} : _this$props$scroll;
      var _this$refs = _this.refs,
          headTable = _this$refs.headTable,
          bodyTable = _this$refs.bodyTable;

      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
        if (target === bodyTable && headTable) {
          headTable.scrollLeft = target.scrollLeft;
        } else if (target === headTable && bodyTable) {
          bodyTable.scrollLeft = target.scrollLeft;
        }
        _this.setScrollPositionClassName(target);
      }
            _this.lastScrollLeft = target.scrollLeft;
    };

    _this.handleBodyScrollTop = function (e) {
      var target = e.target;
      var _this$props$scroll2 = _this.props.scroll,
          scroll = _this$props$scroll2 === undefined ? {} : _this$props$scroll2;
      var _this$refs2 = _this.refs,
          headTable = _this$refs2.headTable,
          bodyTable = _this$refs2.bodyTable,
          fixedColumnsBodyLeft = _this$refs2.fixedColumnsBodyLeft,
          fixedColumnsBodyRight = _this$refs2.fixedColumnsBodyRight;

      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
        var scrollTop = target.scrollTop;
        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
          fixedColumnsBodyLeft.scrollTop = scrollTop;
        }
        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
          fixedColumnsBodyRight.scrollTop = scrollTop;
        }
        if (bodyTable && target !== bodyTable) {
          bodyTable.scrollTop = scrollTop;
        }
      }
            _this.lastScrollTop = target.scrollTop;
    };

    _this.handleBodyScroll = function (e) {
      _this.handleBodyScrollLeft(e);
      _this.handleBodyScrollTop(e);
    };

    _this.handleRowHover = function (isHover, key) {
      _this.store.setState({
        currentHoverKey: isHover ? key : null
      });
    };

    var expandedRowKeys = [];
    var rows = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(props.data));
    _this.columnManager = new __WEBPACK_IMPORTED_MODULE_13__ColumnManager__["a" /* default */](props.columns, props.children);
    _this.store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__createStore__["a" /* default */])({
      currentHoverKey: null,
      expandedRowsHeight: {}
    });
    _this.setScrollPosition('left');

    if (props.defaultExpandAllRows) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        expandedRowKeys.push(_this.getRowKey(row, i));
        rows = rows.concat(row[props.childrenColumnName] || []);
      }
    } else {
      expandedRowKeys = props.expandedRowKeys || props.defaultExpandedRowKeys;
    }
    _this.state = {
      expandedRowKeys: expandedRowKeys,
      currentHoverKey: null,
      fixedColumnsHeadRowsHeight: [],
      fixedColumnsBodyRowsHeight: []
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
        this.debouncedWindowResize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* debounce */])(this.handleWindowResize, 150);
        this.resizeEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.debouncedWindowResize);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('expandedRowKeys' in nextProps) {
        this.setState({
          expandedRowKeys: nextProps.expandedRowKeys
        });
      }
      if (nextProps.columns && nextProps.columns !== this.props.columns) {
        this.columnManager.reset(nextProps.columns);
      } else if (nextProps.children !== this.props.children) {
        this.columnManager.reset(null, nextProps.children);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.columnManager.isAnyColumnsFixed()) {
        this.handleWindowResize();
      }
            if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
        this.resetScrollX();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.resizeEvent) {
        this.resizeEvent.remove();
      }
      if (this.debouncedWindowResize) {
        this.debouncedWindowResize.cancel();
      }
    }
  }, {
    key: 'onExpandedRowsChange',
    value: function onExpandedRowsChange(expandedRowKeys) {
      if (!this.props.expandedRowKeys) {
        this.setState({ expandedRowKeys: expandedRowKeys });
      }
      this.props.onExpandedRowsChange(expandedRowKeys);
    }
  }, {
    key: 'getRowKey',
    value: function getRowKey(record, index) {
      var rowKey = this.props.rowKey;
      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* warningOnce */])(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
      return key === undefined ? index : key;
    }
  }, {
    key: 'getExpandedRows',
    value: function getExpandedRows() {
      return this.props.expandedRowKeys || this.state.expandedRowKeys;
    }
  }, {
    key: 'getHeader',
    value: function getHeader(columns, fixed) {
      var _props = this.props,
          showHeader = _props.showHeader,
          expandIconAsCell = _props.expandIconAsCell,
          prefixCls = _props.prefixCls;

      var rows = this.getHeaderRows(columns);

      if (expandIconAsCell && fixed !== 'right') {
        rows[0].unshift({
          key: 'rc-table-expandIconAsCell',
          className: prefixCls + '-expand-icon-th',
          title: '',
          rowSpan: rows.length
        });
      }

      var trStyle = fixed ? this.getHeaderRowStyle(columns, rows) : null;

      return showHeader ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableHeader__["a" /* default */], {
        prefixCls: prefixCls,
        rows: rows,
        rowStyle: trStyle
      }) : null;
    }
  }, {
    key: 'getHeaderRows',
    value: function getHeaderRows(columns) {
      var _this2 = this;

      var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var rows = arguments[2];

      rows = rows || [];
      rows[currentRow] = rows[currentRow] || [];

      columns.forEach(function (column) {
        if (column.rowSpan && rows.length < column.rowSpan) {
          while (rows.length < column.rowSpan) {
            rows.push([]);
          }
        }
        var cell = {
          key: column.key,
          className: column.className || '',
          children: column.title
        };
        if (column.children) {
          _this2.getHeaderRows(column.children, currentRow + 1, rows);
        }
        if ('colSpan' in column) {
          cell.colSpan = column.colSpan;
        }
        if ('rowSpan' in column) {
          cell.rowSpan = column.rowSpan;
        }
        if (cell.colSpan !== 0) {
          rows[currentRow].push(cell);
        }
      });
      return rows.filter(function (row) {
        return row.length > 0;
      });
    }
  }, {
    key: 'getExpandedRow',
    value: function getExpandedRow(key, content, visible, className, fixed) {
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          expandIconAsCell = _props2.expandIconAsCell;

      var colCount = void 0;
      if (fixed === 'left') {
        colCount = this.columnManager.leftLeafColumns().length;
      } else if (fixed === 'right') {
        colCount = this.columnManager.rightLeafColumns().length;
      } else {
        colCount = this.columnManager.leafColumns().length;
      }
      var columns = [{
        key: 'extra-row',
        render: function render() {
          return {
            props: {
              colSpan: colCount
            },
            children: fixed !== 'right' ? content : '&nbsp;'
          };
        }
      }];
      if (expandIconAsCell && fixed !== 'right') {
        columns.unshift({
          key: 'expand-icon-placeholder',
          render: function render() {
            return null;
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TableRow__["a" /* default */], {
        columns: columns,
        visible: visible,
        className: className,
        key: key + '-extra-row',
        rowKey: key + '-extra-row',
        prefixCls: prefixCls + '-expanded-row',
        indent: 1,
        expandable: false,
        store: this.store,
        expandedRow: true,
        fixed: !!fixed
      });
    }
  }, {
    key: 'getRowsByData',
    value: function getRowsByData(data, visible, indent, columns, fixed) {
      var props = this.props;
      var childrenColumnName = props.childrenColumnName,
          expandedRowRender = props.expandedRowRender,
          expandRowByClick = props.expandRowByClick,
          rowClassName = props.rowClassName,
          rowRef = props.rowRef,
          expandedRowClassName = props.expandedRowClassName,
          onRowClick = props.onRowClick,
          onRowDoubleClick = props.onRowDoubleClick,
          onRowMouseEnter = props.onRowMouseEnter,
          onRowMouseLeave = props.onRowMouseLeave;
      var fixedColumnsBodyRowsHeight = this.state.fixedColumnsBodyRowsHeight;

      var rst = [];
      var needIndentSpaced = props.data.some(function (record) {
        return record[childrenColumnName];
      });

      var expandIconAsCell = fixed !== 'right' ? props.expandIconAsCell : false;
      var expandIconColumnIndex = fixed !== 'right' ? props.expandIconColumnIndex : -1;

      for (var i = 0; i < data.length; i++) {
        var record = data[i];
        var key = this.getRowKey(record, i);
        var childrenColumn = record[childrenColumnName];
        var isRowExpanded = this.isRowExpanded(record, i);
        var expandedRowContent = void 0;
        if (expandedRowRender && isRowExpanded) {
          expandedRowContent = expandedRowRender(record, i, indent);
        }
        var className = rowClassName(record, i, indent);

        var onHoverProps = {};
        if (this.columnManager.isAnyColumnsFixed()) {
          onHoverProps.onHover = this.handleRowHover;
        }

        var height = fixed && fixedColumnsBodyRowsHeight[i] ? fixedColumnsBodyRowsHeight[i] : null;

        var leafColumns = void 0;
        if (fixed === 'left') {
          leafColumns = this.columnManager.leftLeafColumns();
        } else if (fixed === 'right') {
          leafColumns = this.columnManager.rightLeafColumns();
        } else {
          leafColumns = this.columnManager.leafColumns();
        }

        rst.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TableRow__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          indent: indent,
          indentSize: props.indentSize,
          needIndentSpaced: needIndentSpaced,
          className: className,
          record: record,
          expandIconAsCell: expandIconAsCell,
          onDestroy: this.onRowDestroy,
          index: i,
          visible: visible,
          expandRowByClick: expandRowByClick,
          onExpand: this.onExpanded,
          expandable: childrenColumn || expandedRowRender,
          expanded: isRowExpanded,
          prefixCls: props.prefixCls + '-row',
          childrenColumnName: childrenColumnName,
          columns: leafColumns,
          expandIconColumnIndex: expandIconColumnIndex,
          onRowClick: onRowClick,
          onRowDoubleClick: onRowDoubleClick,
          onRowMouseEnter: onRowMouseEnter,
          onRowMouseLeave: onRowMouseLeave,
          height: height
        }, onHoverProps, {
          key: key,
          hoverKey: key,
          ref: rowRef(record, i, indent),
          store: this.store
        })));

        var subVisible = visible && isRowExpanded;

        if (expandedRowContent && isRowExpanded) {
          rst.push(this.getExpandedRow(key, expandedRowContent, subVisible, expandedRowClassName(record, i, indent), fixed));
        }
        if (childrenColumn) {
          rst = rst.concat(this.getRowsByData(childrenColumn, subVisible, indent + 1, columns, fixed));
        }
      }
      return rst;
    }
  }, {
    key: 'getRows',
    value: function getRows(columns, fixed) {
      return this.getRowsByData(this.props.data, true, 0, columns, fixed);
    }
  }, {
    key: 'getColGroup',
    value: function getColGroup(columns, fixed) {
      var cols = [];
      if (this.props.expandIconAsCell && fixed !== 'right') {
        cols.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('col', {
          className: this.props.prefixCls + '-expand-icon-col',
          key: 'rc-table-expand-icon-col'
        }));
      }
      var leafColumns = void 0;
      if (fixed === 'left') {
        leafColumns = this.columnManager.leftLeafColumns();
      } else if (fixed === 'right') {
        leafColumns = this.columnManager.rightLeafColumns();
      } else {
        leafColumns = this.columnManager.leafColumns();
      }
      cols = cols.concat(leafColumns.map(function (c) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('col', { key: c.key, style: { width: c.width, minWidth: c.width } });
      }));
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'colgroup',
        null,
        cols
      );
    }
  }, {
    key: 'getLeftFixedTable',
    value: function getLeftFixedTable() {
      return this.getTable({
        columns: this.columnManager.leftColumns(),
        fixed: 'left'
      });
    }
  }, {
    key: 'getRightFixedTable',
    value: function getRightFixedTable() {
      return this.getTable({
        columns: this.columnManager.rightColumns(),
        fixed: 'right'
      });
    }
  }, {
    key: 'getTable',
    value: function getTable() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var columns = options.columns,
          fixed = options.fixed;
      var _props3 = this.props,
          prefixCls = _props3.prefixCls,
          _props3$scroll = _props3.scroll,
          scroll = _props3$scroll === undefined ? {} : _props3$scroll,
          getBodyWrapper = _props3.getBodyWrapper,
          showHeader = _props3.showHeader;
      var useFixedHeader = this.props.useFixedHeader;

      var bodyStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props.bodyStyle);
      var headStyle = {};

      var tableClassName = '';
      if (scroll.x || fixed) {
        tableClassName = prefixCls + '-fixed';
        bodyStyle.overflowX = bodyStyle.overflowX || 'auto';
      }

      var innerBodyStyle = {};
      if (scroll.y) {
                        if (fixed) {
          innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
          innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
        } else {
          bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
        }
        bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
        useFixedHeader = true;

                var scrollbarWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["c" /* measureScrollbar */])();
        if (scrollbarWidth > 0) {
          (fixed ? bodyStyle : headStyle).marginBottom = '-' + scrollbarWidth + 'px';
          (fixed ? bodyStyle : headStyle).paddingBottom = '0px';
        }
      }

      var renderTable = function renderTable() {
        var hasHead = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var hasBody = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var tableStyle = {};
        if (!fixed && scroll.x) {
                    if (scroll.x === true) {
            tableStyle.tableLayout = 'fixed';
          } else {
            tableStyle.width = scroll.x;
          }
        }
        var tableBody = hasBody ? getBodyWrapper(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'tbody',
          { className: prefixCls + '-tbody' },
          _this3.getRows(columns, fixed)
        )) : null;
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'table',
          { className: tableClassName, style: tableStyle, key: 'table' },
          _this3.getColGroup(columns, fixed),
          hasHead ? _this3.getHeader(columns, fixed) : null,
          tableBody
        );
      };

      var headTable = void 0;

      if (useFixedHeader && showHeader) {
        headTable = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            key: 'headTable',
            className: prefixCls + '-header',
            ref: fixed ? null : 'headTable',
            style: headStyle,
            onScroll: this.handleBodyScrollLeft
          },
          renderTable(true, false)
        );
      }

      var bodyTable = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          key: 'bodyTable',
          className: prefixCls + '-body',
          style: bodyStyle,
          ref: 'bodyTable',
          onScroll: this.handleBodyScroll
        },
        renderTable(!useFixedHeader)
      );

      if (fixed && columns.length) {
        var refName = void 0;
        if (columns[0].fixed === 'left' || columns[0].fixed === true) {
          refName = 'fixedColumnsBodyLeft';
        } else if (columns[0].fixed === 'right') {
          refName = 'fixedColumnsBodyRight';
        }
        delete bodyStyle.overflowX;
        delete bodyStyle.overflowY;
        bodyTable = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            key: 'bodyTable',
            className: prefixCls + '-body-outer',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, bodyStyle)
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            {
              className: prefixCls + '-body-inner',
              style: innerBodyStyle,
              ref: refName,
              onScroll: this.handleBodyScroll
            },
            renderTable(!useFixedHeader)
          )
        );
      }
      return [headTable, bodyTable];
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var _props4 = this.props,
          title = _props4.title,
          prefixCls = _props4.prefixCls;

      return title ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: prefixCls + '-title', key: 'title' },
        title(this.props.data)
      ) : null;
    }
  }, {
    key: 'getFooter',
    value: function getFooter() {
      var _props5 = this.props,
          footer = _props5.footer,
          prefixCls = _props5.prefixCls;

      return footer ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: prefixCls + '-footer', key: 'footer' },
        footer(this.props.data)
      ) : null;
    }
  }, {
    key: 'getEmptyText',
    value: function getEmptyText() {
      var _props6 = this.props,
          emptyText = _props6.emptyText,
          prefixCls = _props6.prefixCls,
          data = _props6.data;

      return !data.length ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: prefixCls + '-placeholder', key: 'emptyText' },
        typeof emptyText === 'function' ? emptyText() : emptyText
      ) : null;
    }
  }, {
    key: 'getHeaderRowStyle',
    value: function getHeaderRowStyle(columns, rows) {
      var fixedColumnsHeadRowsHeight = this.state.fixedColumnsHeadRowsHeight;

      var headerHeight = fixedColumnsHeadRowsHeight[0];
      if (headerHeight && columns) {
        if (headerHeight === 'auto') {
          return { height: 'auto' };
        }
        return { height: headerHeight / rows.length };
      }
      return null;
    }
  }, {
    key: 'setScrollPosition',
    value: function setScrollPosition(position) {
      this.scrollPosition = position;
      if (this.tableNode) {
        var prefixCls = this.props.prefixCls;

        if (position === 'both') {
          __WEBPACK_IMPORTED_MODULE_15_component_classes___default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-left').add(prefixCls + '-scroll-position-right');
        } else {
          __WEBPACK_IMPORTED_MODULE_15_component_classes___default()(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-' + position);
        }
      }
    }
  }, {
    key: 'setScrollPositionClassName',
    value: function setScrollPositionClassName(target) {
      var node = target || this.refs.bodyTable;
      var scrollToLeft = node.scrollLeft === 0;
      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;
      if (scrollToLeft && scrollToRight) {
        this.setScrollPosition('both');
      } else if (scrollToLeft) {
        this.setScrollPosition('left');
      } else if (scrollToRight) {
        this.setScrollPosition('right');
      } else if (this.scrollPosition !== 'middle') {
        this.setScrollPosition('middle');
      }
    }
  }, {
    key: 'resetScrollX',
    value: function resetScrollX() {
      if (this.refs.headTable) {
        this.refs.headTable.scrollLeft = 0;
      }
      if (this.refs.bodyTable) {
        this.refs.bodyTable.scrollLeft = 0;
      }
    }
  }, {
    key: 'findExpandedRow',
    value: function findExpandedRow(record, index) {
      var _this4 = this;

      var rows = this.getExpandedRows().filter(function (i) {
        return i === _this4.getRowKey(record, index);
      });
      return rows[0];
    }
  }, {
    key: 'isRowExpanded',
    value: function isRowExpanded(record, index) {
      return typeof this.findExpandedRow(record, index) !== 'undefined';
    }
  }, {
    key: 'hasScrollX',
    value: function hasScrollX() {
      var _props$scroll = this.props.scroll,
          scroll = _props$scroll === undefined ? {} : _props$scroll;

      return 'x' in scroll;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var props = this.props;
      var prefixCls = props.prefixCls;

      var className = props.prefixCls;
      if (props.className) {
        className += ' ' + props.className;
      }
      if (props.useFixedHeader || props.scroll && props.scroll.y) {
        className += ' ' + prefixCls + '-fixed-header';
      }
      if (this.scrollPosition === 'both') {
        className += ' ' + prefixCls + '-scroll-position-left ' + prefixCls + '-scroll-position-right';
      } else {
        className += ' ' + prefixCls + '-scroll-position-' + this.scrollPosition;
      }

      var isTableScroll = this.columnManager.isAnyColumnsFixed() || props.scroll.x || props.scroll.y;

      var content = [this.getTable({ columns: this.columnManager.groupedColumns() }), this.getEmptyText(), this.getFooter()];

      var scrollTable = isTableScroll ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: prefixCls + '-scroll' },
        content
      ) : content;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { ref: function ref(node) {
            return _this5.tableNode = node;
          }, className: className, style: props.style },
        this.getTitle(),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: prefixCls + '-content' },
          scrollTable,
          this.columnManager.isAnyColumnsLeftFixed() && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            { className: prefixCls + '-fixed-left' },
            this.getLeftFixedTable()
          ),
          this.columnManager.isAnyColumnsRightFixed() && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            { className: prefixCls + '-fixed-right' },
            this.getRightFixedTable()
          )
        )
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = {
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  expandIconAsCell: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  defaultExpandAllRows: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  expandedRowKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  defaultExpandedRowKeys: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  useFixedHeader: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  columns: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  bodyStyle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  rowKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  rowClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  expandedRowClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  childrenColumnName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onExpand: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onExpandedRowsChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  indentSize: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onRowClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onRowDoubleClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  expandIconColumnIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  showHeader: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  footer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  emptyText: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  scroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  rowRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  getBodyWrapper: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Table.defaultProps = {
  data: [],
  useFixedHeader: false,
  expandIconAsCell: false,
  defaultExpandAllRows: false,
  defaultExpandedRowKeys: [],
  rowKey: 'key',
  rowClassName: function rowClassName() {
    return '';
  },
  expandedRowClassName: function expandedRowClassName() {
    return '';
  },
  onExpand: function onExpand() {},
  onExpandedRowsChange: function onExpandedRowsChange() {},
  onRowClick: function onRowClick() {},
  onRowDoubleClick: function onRowDoubleClick() {},
  onRowMouseEnter: function onRowMouseEnter() {},
  onRowMouseLeave: function onRowMouseLeave() {},

  prefixCls: 'rc-table',
  bodyStyle: {},
  style: {},
  childrenColumnName: 'children',
  indentSize: 15,
  expandIconColumnIndex: 0,
  showHeader: true,
  scroll: {},
  rowRef: function rowRef() {
    return null;
  },
  getBodyWrapper: function getBodyWrapper(body) {
    return body;
  },
  emptyText: function emptyText() {
    return 'No Data';
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);









var TableCell = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableCell, _React$Component);

  function TableCell() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableCell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          record = _this$props.record,
          onCellClick = _this$props.column.onCellClick;

      if (onCellClick) {
        onCellClick(record, e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableCell, [{
    key: 'isInvalidRenderCellText',
    value: function isInvalidRenderCellText(text) {
      return text && !__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          record = _props.record,
          indentSize = _props.indentSize,
          prefixCls = _props.prefixCls,
          indent = _props.indent,
          index = _props.index,
          expandIcon = _props.expandIcon,
          column = _props.column;
      var dataIndex = column.dataIndex,
          render = column.render,
          _column$className = column.className,
          className = _column$className === undefined ? '' : _column$className;

      // We should return undefined if no dataIndex is specified, but in order to
      // be compatible with object-path's behavior, we return the record object instead.

      var text = void 0;
      if (typeof dataIndex === 'number') {
        text = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(record, dataIndex);
      } else if (!dataIndex || dataIndex.length === 0) {
        text = record;
      } else {
        text = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(record, dataIndex);
      }
      var tdProps = void 0;
      var colSpan = void 0;
      var rowSpan = void 0;

      if (render) {
        text = render(text, record, index);
        if (this.isInvalidRenderCellText(text)) {
          tdProps = text.props || {};
          colSpan = tdProps.colSpan;
          rowSpan = tdProps.rowSpan;
          text = text.children;
        }
      }

      // Fix https://github.com/ant-design/ant-design/issues/1202
      if (this.isInvalidRenderCellText(text)) {
        text = null;
      }

      var indentText = expandIcon ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', {
        style: { paddingLeft: indentSize * indent + 'px' },
        className: prefixCls + '-indent indent-level-' + indent
      }) : null;

      if (rowSpan === 0 || colSpan === 0) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'td',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          className: className
        }, tdProps, {
          onClick: this.handleClick
        }),
        indentText,
        expandIcon,
        text
      );
    }
  }]);

  return TableCell;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TableCell.propTypes = {
  record: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  indent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  indentSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  column: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  expandIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
};
/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shallowequal__);









var TableHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TableHeader, _React$Component);

  function TableHeader() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TableHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TableHeader, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_7_shallowequal___default()(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          rowStyle = _props.rowStyle,
          rows = _props.rows;

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'thead',
        { className: prefixCls + '-thead' },
        rows.map(function (row, index) {
          return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            'tr',
            { key: index, style: rowStyle },
            row.map(function (cellProps, i) {
              return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('th', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cellProps, { key: i }));
            })
          );
        })
      );
    }
  }]);

  return TableHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TableHeader.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  rowStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  rows: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array
};
/* harmony default export */ __webpack_exports__["a"] = (TableHeader);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableCell__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExpandIcon__ = __webpack_require__(1357);









var TableRow = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TableRow, _React$Component);

  function TableRow() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      height: null
    }, _this.onRowClick = function (event) {
      var _this$props = _this.props,
          record = _this$props.record,
          index = _this$props.index,
          onRowClick = _this$props.onRowClick,
          expandable = _this$props.expandable,
          expandRowByClick = _this$props.expandRowByClick,
          expanded = _this$props.expanded,
          onExpand = _this$props.onExpand;

      if (expandable && expandRowByClick) {
        onExpand(!expanded, record, event, index);
      }
      onRowClick(record, index, event);
    }, _this.onRowDoubleClick = function (event) {
      var _this$props2 = _this.props,
          record = _this$props2.record,
          index = _this$props2.index,
          onRowDoubleClick = _this$props2.onRowDoubleClick;

      onRowDoubleClick(record, index, event);
    }, _this.onMouseEnter = function (event) {
      var _this$props3 = _this.props,
          record = _this$props3.record,
          index = _this$props3.index,
          onRowMouseEnter = _this$props3.onRowMouseEnter,
          onHover = _this$props3.onHover,
          hoverKey = _this$props3.hoverKey;

      onHover(true, hoverKey);
      onRowMouseEnter(record, index, event);
    }, _this.onMouseLeave = function (event) {
      var _this$props4 = _this.props,
          record = _this$props4.record,
          index = _this$props4.index,
          onRowMouseLeave = _this$props4.onRowMouseLeave,
          onHover = _this$props4.onHover,
          hoverKey = _this$props4.hoverKey;

      onHover(false, hoverKey);
      onRowMouseLeave(record, index, event);
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TableRow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var store = this.props.store;

      this.pushHeight();
      this.pullHeight();
      this.unsubscribe = store.subscribe(function () {
        _this2.setHover();
        _this2.pullHeight();
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props = this.props,
          record = _props.record,
          onDestroy = _props.onDestroy,
          index = _props.index;

      onDestroy(record, index);
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
  }, {
    key: 'setHover',
    value: function setHover() {
      var _props2 = this.props,
          store = _props2.store,
          hoverKey = _props2.hoverKey;

      var _store$getState = store.getState(),
          currentHoverKey = _store$getState.currentHoverKey;

      if (currentHoverKey === hoverKey) {
        this.setState({ hovered: true });
      } else if (this.state.hovered === true) {
        this.setState({ hovered: false });
      }
    }
  }, {
    key: 'pullHeight',
    value: function pullHeight() {
      var _props3 = this.props,
          store = _props3.store,
          expandedRow = _props3.expandedRow,
          fixed = _props3.fixed,
          rowKey = _props3.rowKey;

      var _store$getState2 = store.getState(),
          expandedRowsHeight = _store$getState2.expandedRowsHeight;

      if (expandedRow && fixed && expandedRowsHeight[rowKey]) {
        this.setState({ height: expandedRowsHeight[rowKey] });
      }
    }
  }, {
    key: 'pushHeight',
    value: function pushHeight() {
      var _props4 = this.props,
          store = _props4.store,
          expandedRow = _props4.expandedRow,
          fixed = _props4.fixed,
          rowKey = _props4.rowKey;

      if (expandedRow && !fixed) {
        var _store$getState3 = store.getState(),
            expandedRowsHeight = _store$getState3.expandedRowsHeight;

        var height = this.trRef.getBoundingClientRect().height;
        expandedRowsHeight[rowKey] = height;
        store.setState({ expandedRowsHeight: expandedRowsHeight });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          prefixCls = _props5.prefixCls,
          columns = _props5.columns,
          record = _props5.record,
          visible = _props5.visible,
          index = _props5.index,
          expandIconColumnIndex = _props5.expandIconColumnIndex,
          expandIconAsCell = _props5.expandIconAsCell,
          expanded = _props5.expanded,
          expandRowByClick = _props5.expandRowByClick,
          expandable = _props5.expandable,
          onExpand = _props5.onExpand,
          needIndentSpaced = _props5.needIndentSpaced,
          indent = _props5.indent,
          indentSize = _props5.indentSize;
      var className = this.props.className;


      if (this.state.hovered) {
        className += ' ' + prefixCls + '-hover';
      }

      var cells = [];

      var expandIcon = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ExpandIcon__["a" /* default */], {
        expandable: expandable,
        prefixCls: prefixCls,
        onExpand: onExpand,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        record: record
      });

      for (var i = 0; i < columns.length; i++) {
        if (expandIconAsCell && i === 0) {
          cells.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'td',
            {
              className: prefixCls + '-expand-icon-cell',
              key: 'rc-table-expand-icon-cell'
            },
            expandIcon
          ));
        }
        var isColumnHaveExpandIcon = expandIconAsCell || expandRowByClick ? false : i === expandIconColumnIndex;
        cells.push(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TableCell__["a" /* default */], {
          prefixCls: prefixCls,
          record: record,
          indentSize: indentSize,
          indent: indent,
          index: index,
          column: columns[i],
          key: columns[i].key,
          expandIcon: isColumnHaveExpandIcon ? expandIcon : null
        }));
      }
      var height = this.props.height || this.state.height;
      var style = { height: height };
      if (!visible) {
        style.display = 'none';
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'tr',
        {
          ref: function ref(node) {
            return _this3.trRef = node;
          },
          onClick: this.onRowClick,
          onDoubleClick: this.onRowDoubleClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          className: prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent,
          style: style
        },
        cells
      );
    }
  }]);

  return TableRow;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TableRow.propTypes = {
  onDestroy: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onRowClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onRowDoubleClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onRowMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onRowMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  record: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  expandIconColumnIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  onHover: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  columns: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  hoverKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  expandable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onExpand: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  needIndentSpaced: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  indent: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  indentSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  expandIconAsCell: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  expandRowByClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  store: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  expandedRow: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  fixed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  rowKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
TableRow.defaultProps = {
  onRowClick: function onRowClick() {},
  onRowDoubleClick: function onRowDoubleClick() {},
  onRowMouseEnter: function onRowMouseEnter() {},
  onRowMouseLeave: function onRowMouseLeave() {},
  onDestroy: function onDestroy() {},

  expandIconColumnIndex: 0,
  expandRowByClick: false,
  onHover: function onHover() {}
};
/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function createStore(initialState) {
  var state = initialState;
  var listeners = [];

  function setState(partial) {
    state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, partial);
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }
  }

  function getState() {
    return state;
  }

  function subscribe(listener) {
    listeners.push(listener);

    return function unsubscribe() {
      var index = listeners.indexOf(listener);
      listeners.splice(index, 1);
    };
  }

  return {
    setState: setState,
    getState: getState,
    subscribe: subscribe
  };
}

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Column__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__ = __webpack_require__(1355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_1__Column__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnGroup", function() { return __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__["a"]; });




__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */].Column = __WEBPACK_IMPORTED_MODULE_1__Column__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */].ColumnGroup = __WEBPACK_IMPORTED_MODULE_2__ColumnGroup__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Table__["a" /* default */]);


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = measureScrollbar;
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["b"] = warningOnce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var scrollbarWidth = void 0;

// Measure scrollbar width for padding body during modal show/hide
var scrollbarMeasure = {
  position: 'absolute',
  top: '-9999px',
  width: '50px',
  height: '50px',
  overflow: 'scroll'
};

function measureScrollbar() {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return 0;
  }
  if (scrollbarWidth) {
    return scrollbarWidth;
  }
  var scrollDiv = document.createElement('div');
  for (var scrollProp in scrollbarMeasure) {
    if (scrollbarMeasure.hasOwnProperty(scrollProp)) {
      scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
    }
  }
  document.body.appendChild(scrollDiv);
  var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  scrollbarWidth = width;
  return scrollbarWidth;
}

function debounce(func, wait, immediate) {
  var timeout = void 0;
  function debounceFunc() {
    var context = this;
    var args = arguments;
    // https://fb.me/react-event-pooling
    if (args[0] && args[0].persist) {
      args[0].persist();
    }
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  }
  debounceFunc.cancel = function cancel() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounceFunc;
}

var warned = {};
function warningOnce(condition, format, args) {
  if (!warned[format]) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(condition, format, args);
    warned[format] = !condition;
  }
}

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(202), __esModule: true };

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * LEFT
   */
  LEFT: 37, // also NUM_WEST
  /**
   * UP
   */
  UP: 38, // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39, // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40 // also NUM_SOUTH
});

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(328);








var TabContent = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'TabContent',
  propTypes: {
    animated: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    animatedWithMargin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    style: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    tabBarPosition: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      animated: true
    };
  },
  getTabPanes: function getTabPanes() {
    var props = this.props;
    var activeKey = props.activeKey;
    var children = props.children;
    var newChildren = [];

    __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(children, function (child) {
      if (!child) {
        return;
      }
      var key = child.key;
      var active = activeKey === key;
      newChildren.push(__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
        active: active,
        destroyInactiveTabPane: props.destroyInactiveTabPane,
        rootPrefixCls: props.prefixCls
      }));
    });

    return newChildren;
  },
  render: function render() {
    var _classnames;

    var props = this.props;
    var prefixCls = props.prefixCls,
        children = props.children,
        activeKey = props.activeKey,
        tabBarPosition = props.tabBarPosition,
        animated = props.animated,
        animatedWithMargin = props.animatedWithMargin;
    var style = props.style;

    var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-content', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames));
    if (animated) {
      var activeIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* getActiveIndex */])(children, activeKey);
      if (activeIndex !== -1) {
        var animatedStyle = animatedWithMargin ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* getMarginStyle */])(activeIndex, tabBarPosition) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["c" /* getTransformPropValue */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["d" /* getTransformByIndex */])(activeIndex, tabBarPosition));
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, animatedStyle);
      } else {
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, {
          display: 'none'
        });
      }
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      {
        className: classes,
        style: style
      },
      this.getTabPanes()
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TabContent);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KeyCode__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabPane__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(328);














function noop() {}

function getDefaultActiveKey(props) {
  var activeKey = void 0;
  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(props.children, function (child) {
    if (child && !activeKey && !child.props.disabled) {
      activeKey = child.key;
    }
  });
  return activeKey;
}

function activeKeyIsValid(props, key) {
  var keys = __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.map(props.children, function (child) {
    return child && child.key;
  });
  return keys.indexOf(key) >= 0;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _initialiseProps.call(_this);

    var activeKey = void 0;
    if ('activeKey' in props) {
      activeKey = props.activeKey;
    } else if ('defaultActiveKey' in props) {
      activeKey = props.defaultActiveKey;
    } else {
      activeKey = getDefaultActiveKey(props);
    }

    _this.state = {
      activeKey: activeKey
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: nextProps.activeKey
        });
      } else if (!activeKeyIsValid(nextProps, this.state.activeKey)) {
        // https://github.com/ant-design/ant-design/issues/7093
        this.setState({
          activeKey: getDefaultActiveKey(nextProps)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var props = this.props;

      var prefixCls = props.prefixCls,
          tabBarPosition = props.tabBarPosition,
          className = props.className,
          renderTabContent = props.renderTabContent,
          renderTabBar = props.renderTabBar,
          destroyInactiveTabPane = props.destroyInactiveTabPane,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['prefixCls', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);

      var cls = __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, prefixCls + '-' + tabBarPosition, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, className, !!className), _classnames));

      this.tabBar = renderTabBar();
      var contents = [__WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(this.tabBar, {
        prefixCls: prefixCls,
        key: 'tabBar',
        onKeyDown: this.onNavKeyDown,
        tabBarPosition: tabBarPosition,
        onTabClick: this.onTabClick,
        panels: props.children,
        activeKey: this.state.activeKey
      }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(renderTabContent(), {
        prefixCls: prefixCls,
        tabBarPosition: tabBarPosition,
        activeKey: this.state.activeKey,
        destroyInactiveTabPane: destroyInactiveTabPane,
        children: props.children,
        onChange: this.setActiveKey,
        key: 'tabContent'
      })];
      if (tabBarPosition === 'bottom') {
        contents.reverse();
      }
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          className: cls,
          style: props.style
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils__["e" /* getDataAttr */])(restProps)),
        contents
      );
    }
  }]);

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onTabClick = function (activeKey) {
    if (_this2.tabBar.props.onTabClick) {
      _this2.tabBar.props.onTabClick(activeKey);
    }
    _this2.setActiveKey(activeKey);
  };

  this.onNavKeyDown = function (e) {
    var eventKeyCode = e.keyCode;
    if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].RIGHT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].DOWN) {
      e.preventDefault();
      var nextKey = _this2.getNextActiveKey(true);
      _this2.onTabClick(nextKey);
    } else if (eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].LEFT || eventKeyCode === __WEBPACK_IMPORTED_MODULE_9__KeyCode__["a" /* default */].UP) {
      e.preventDefault();
      var previousKey = _this2.getNextActiveKey(false);
      _this2.onTabClick(previousKey);
    }
  };

  this.setActiveKey = function (activeKey) {
    if (_this2.state.activeKey !== activeKey) {
      if (!('activeKey' in _this2.props)) {
        _this2.setState({
          activeKey: activeKey
        });
      }
      _this2.props.onChange(activeKey);
    }
  };

  this.getNextActiveKey = function (next) {
    var activeKey = _this2.state.activeKey;
    var children = [];
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(_this2.props.children, function (c) {
      if (c && !c.props.disabled) {
        if (next) {
          children.push(c);
        } else {
          children.unshift(c);
        }
      }
    });
    var length = children.length;
    var ret = length && children[0].key;
    children.forEach(function (child, i) {
      if (child.key === activeKey) {
        if (i === length - 1) {
          ret = children[0].key;
        } else {
          ret = children[i + 1].key;
        }
      }
    });
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Tabs);


Tabs.propTypes = {
  destroyInactiveTabPane: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  renderTabBar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  renderTabContent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  tabBarPosition: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

Tabs.defaultProps = {
  prefixCls: 'rc-tabs',
  destroyInactiveTabPane: false,
  onChange: noop,
  tabBarPosition: 'top',
  style: {}
};

Tabs.TabPane = __WEBPACK_IMPORTED_MODULE_10__TabPane__["a" /* default */];

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _InkTabBarMixin = __webpack_require__(534);

var _InkTabBarMixin2 = _interopRequireDefault(_InkTabBarMixin);

var _TabBarMixin = __webpack_require__(330);

var _TabBarMixin2 = _interopRequireDefault(_TabBarMixin);

var _RefMixin = __webpack_require__(329);

var _RefMixin2 = _interopRequireDefault(_RefMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var InkTabBar = (0, _createReactClass2['default'])({
  displayName: 'InkTabBar',
  mixins: [_RefMixin2['default'], _TabBarMixin2['default'], _InkTabBarMixin2['default']],
  render: function render() {
    var inkBarNode = this.getInkBarNode();
    var tabs = this.getTabs();
    return this.getRootNode([inkBarNode, tabs]);
  }
});

exports['default'] = InkTabBar;
module.exports = exports['default'];

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(105);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames2 = __webpack_require__(18);

var _classnames3 = _interopRequireDefault(_classnames2);

var _InkTabBarMixin = __webpack_require__(534);

var _InkTabBarMixin2 = _interopRequireDefault(_InkTabBarMixin);

var _SwipeableTabBarMixin = __webpack_require__(1377);

var _SwipeableTabBarMixin2 = _interopRequireDefault(_SwipeableTabBarMixin);

var _TabBarMixin = __webpack_require__(330);

var _TabBarMixin2 = _interopRequireDefault(_TabBarMixin);

var _RefMixin = __webpack_require__(329);

var _RefMixin2 = _interopRequireDefault(_RefMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SwipeableInkTabBar = (0, _createReactClass2['default'])({
  displayName: 'SwipeableInkTabBar',

  mixins: [_RefMixin2['default'], _TabBarMixin2['default'], _InkTabBarMixin2['default'], _SwipeableTabBarMixin2['default']],

  getSwipeableTabs: function getSwipeableTabs() {
    var _this = this;

    var props = this.props;
    var children = props.panels;
    var activeKey = props.activeKey;
    var rst = [];
    var prefixCls = props.prefixCls;

    var _flexWidth = 1 / props.pageSize * 100 + '%';
    var tabStyle = {
      WebkitFlexBasis: _flexWidth,
      flexBasis: _flexWidth
    };

    _react2['default'].Children.forEach(children, function (child) {
      var _classnames;

      if (!child) {
        return;
      }
      var key = child.key;
      var cls = (0, _classnames3['default'])(prefixCls + '-tab', (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-active', activeKey === key), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-disabled', child.props.disabled), _classnames));
      var events = {};
      if (!child.props.disabled) {
        events = {
          onClick: _this.onTabClick.bind(_this, key)
        };
      }
      var refProps = {};
      if (activeKey === key) {
        refProps.ref = _this.saveRef('activeTab');
      }
      rst.push(_react2['default'].createElement(
        'div',
        (0, _extends3['default'])({
          role: 'tab',
          style: tabStyle,
          'aria-disabled': child.props.disabled ? 'true' : 'false',
          'aria-selected': activeKey === key ? 'true' : 'false'
        }, events, {
          className: cls,
          key: key
        }, refProps),
        child.props.tab
      ));
    });

    return rst;
  },
  render: function render() {
    var inkBarNode = this.getInkBarNode();
    var tabs = this.getSwipeableTabs();
    var scrollbarNode = this.getSwipeBarNode([inkBarNode, tabs]);
    return this.getRootNode(scrollbarNode);
  }
});

exports['default'] = SwipeableInkTabBar;
module.exports = exports['default'];

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(105);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(86);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames3 = __webpack_require__(18);

var _classnames4 = _interopRequireDefault(_classnames3);

var _rcHammerjs = __webpack_require__(324);

var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  getInitialState: function getInitialState() {
    var _checkPaginationByKey = this.checkPaginationByKey(this.props.activeKey),
        hasPrevPage = _checkPaginationByKey.hasPrevPage,
        hasNextPage = _checkPaginationByKey.hasNextPage;

    return {
      hasPrevPage: hasPrevPage,
      hasNextPage: hasNextPage
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      hammerOptions: {},
      pageSize: 5, // per page show how many tabs
      speed: 7 // swipe speed, 1 to 10, more bigger more faster
    };
  },
  checkPaginationByKey: function checkPaginationByKey(activeKey) {
    var _props = this.props,
        panels = _props.panels,
        pageSize = _props.pageSize;

    var index = this.getIndexByKey(activeKey);
    var centerTabCount = Math.floor(pageSize / 2);
    // the basic rule is to make activeTab be shown in the center of TabBar viewport
    return {
      hasPrevPage: index - centerTabCount > 0,
      hasNextPage: index + centerTabCount < panels.length
    };
  },

  /**
   * used for props.activeKey setting, not for swipe callback
   */
  getDeltaByKey: function getDeltaByKey(activeKey) {
    var pageSize = this.props.pageSize;

    var index = this.getIndexByKey(activeKey);
    var centerTabCount = Math.floor(pageSize / 2);
    var tabWidth = this.cache.tabWidth;

    var delta = (index - centerTabCount) * tabWidth * -1;
    return delta;
  },
  getIndexByKey: function getIndexByKey(activeKey) {
    var panels = this.props.panels;

    var length = panels.length;
    for (var i = 0; i < length; i++) {
      if (panels[i].key === activeKey) {
        return i;
      }
    }
    return -1;
  },
  checkPaginationByDelta: function checkPaginationByDelta(delta) {
    var totalAvaliableDelta = this.cache.totalAvaliableDelta;

    return {
      hasPrevPage: delta < 0,
      hasNextPage: -delta < totalAvaliableDelta
    };
  },
  setSwipePositionByKey: function setSwipePositionByKey(activeKey) {
    var _checkPaginationByKey2 = this.checkPaginationByKey(activeKey),
        hasPrevPage = _checkPaginationByKey2.hasPrevPage,
        hasNextPage = _checkPaginationByKey2.hasNextPage;

    var totalAvaliableDelta = this.cache.totalAvaliableDelta;

    this.setState({
      hasPrevPage: hasPrevPage,
      hasNextPage: hasNextPage
    });
    var delta = void 0;
    if (!hasPrevPage) {
      // the first page
      delta = 0;
    } else if (!hasNextPage) {
      // the last page
      delta = -totalAvaliableDelta;
    } else if (hasNextPage) {
      // the middle page
      delta = this.getDeltaByKey(activeKey);
    }
    this.cache.totalDelta = delta;
    this.setSwipePosition();
  },
  setSwipePosition: function setSwipePosition() {
    var _cache = this.cache,
        totalDelta = _cache.totalDelta,
        vertical = _cache.vertical;

    (0, _utils.setPxStyle)(this.swipeNode, totalDelta, vertical);
  },
  componentDidMount: function componentDidMount() {
    var swipe = this.swipe,
        nav = this.nav;
    var _props2 = this.props,
        tabBarPosition = _props2.tabBarPosition,
        pageSize = _props2.pageSize,
        panels = _props2.panels,
        activeKey = _props2.activeKey;

    this.swipeNode = _reactDom2['default'].findDOMNode(swipe); // dom which scroll (9999px)
    this.realNode = _reactDom2['default'].findDOMNode(nav); // dom which visiable in screen (viewport)
    var _isVertical = (0, _utils.isVertical)(tabBarPosition);
    var _viewSize = (0, _utils.getStyle)(this.realNode, _isVertical ? 'height' : 'width');
    var _tabWidth = _viewSize / pageSize;
    this.cache = {
      vertical: _isVertical,
      totalAvaliableDelta: _tabWidth * panels.length - _viewSize,
      tabWidth: _tabWidth
    };
    this.setSwipePositionByKey(activeKey);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.activeKey && nextProps.activeKey !== this.props.activeKey) {
      this.setSwipePositionByKey(nextProps.activeKey);
    }
  },
  onPan: function onPan(e) {
    var _cache2 = this.cache,
        vertical = _cache2.vertical,
        totalAvaliableDelta = _cache2.totalAvaliableDelta,
        totalDelta = _cache2.totalDelta;
    var speed = this.props.speed;
    // calculate touch distance

    var nowDelta = vertical ? e.deltaY : e.deltaX;
    nowDelta = nowDelta * (speed / 10);

    // calculate distance dom need transform
    var _nextDelta = nowDelta + totalDelta;
    if (_nextDelta >= 0) {
      _nextDelta = 0;
    } else if (_nextDelta <= -totalAvaliableDelta) {
      _nextDelta = -totalAvaliableDelta;
    }

    this.cache.totalDelta = _nextDelta;
    this.setSwipePosition();

    // calculate pagination display

    var _checkPaginationByDel = this.checkPaginationByDelta(this.cache.totalDelta),
        hasPrevPage = _checkPaginationByDel.hasPrevPage,
        hasNextPage = _checkPaginationByDel.hasNextPage;

    if (hasPrevPage !== this.state.hasPrevPage || hasNextPage !== this.state.hasNextPage) {
      this.setState({
        hasPrevPage: hasPrevPage,
        hasNextPage: hasNextPage
      });
    }
  },
  getSwipeBarNode: function getSwipeBarNode(tabs) {
    var _classnames2;

    var _props3 = this.props,
        prefixCls = _props3.prefixCls,
        hammerOptions = _props3.hammerOptions,
        tabBarPosition = _props3.tabBarPosition;
    var _state = this.state,
        hasPrevPage = _state.hasPrevPage,
        hasNextPage = _state.hasNextPage;

    var navClassName = prefixCls + '-nav';
    var navClasses = (0, _classnames4['default'])((0, _defineProperty3['default'])({}, navClassName, true));
    var events = {
      onPan: this.onPan
    };
    return _react2['default'].createElement(
      'div',
      {
        className: (0, _classnames4['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nav-swipe-container', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-prevpage', hasPrevPage), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nextpage', hasNextPage), _classnames2)),
        key: 'container',
        ref: this.saveRef('container')
      },
      _react2['default'].createElement(
        'div',
        { className: prefixCls + '-nav-wrap', ref: this.saveRef('navWrap') },
        _react2['default'].createElement(
          _rcHammerjs2['default'],
          (0, _extends3['default'])({}, events, {
            direction: (0, _utils.isVertical)(tabBarPosition) ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL',
            options: hammerOptions
          }),
          _react2['default'].createElement(
            'div',
            { className: prefixCls + '-nav-swipe', ref: this.saveRef('swipe') },
            _react2['default'].createElement(
              'div',
              { className: navClasses, ref: this.saveRef('nav') },
              tabs
            )
          )
        )
      )
    );
  }
};
module.exports = exports['default'];

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(105);

var _extends3 = _interopRequireDefault(_extends2);

var _TabContent = __webpack_require__(331);

var _TabContent2 = _interopRequireDefault(_TabContent);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _rcHammerjs = __webpack_require__(324);

var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(177);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RESISTANCE_COEF = 0.6;

function computeIndex(_ref) {
  var maxIndex = _ref.maxIndex,
      startIndex = _ref.startIndex,
      delta = _ref.delta,
      viewSize = _ref.viewSize;

  var index = startIndex + -delta / viewSize;
  if (index < 0) {
    index = Math.exp(index * RESISTANCE_COEF) - 1;
  } else if (index > maxIndex) {
    index = maxIndex + 1 - Math.exp((maxIndex - index) * RESISTANCE_COEF);
  }
  return index;
}

function getIndexByDelta(e) {
  var delta = (0, _utils.isVertical)(this.props.tabBarPosition) ? e.deltaY : e.deltaX;
  var otherDelta = (0, _utils.isVertical)(this.props.tabBarPosition) ? e.deltaX : e.deltaY;
  if (Math.abs(delta) < Math.abs(otherDelta)) {
    return undefined;
  }
  var currentIndex = computeIndex({
    maxIndex: this.maxIndex,
    viewSize: this.viewSize,
    startIndex: this.startIndex,
    delta: delta
  });
  var showIndex = delta < 0 ? Math.floor(currentIndex + 1) : Math.floor(currentIndex);
  if (showIndex < 0) {
    showIndex = 0;
  } else if (showIndex > this.maxIndex) {
    showIndex = this.maxIndex;
  }
  if (this.children[showIndex].props.disabled) {
    return undefined;
  }
  return currentIndex;
}

var SwipeableTabContent = (0, _createReactClass2['default'])({
  displayName: 'SwipeableTabContent',

  propTypes: {
    tabBarPosition: _propTypes2['default'].string,
    onChange: _propTypes2['default'].func,
    children: _propTypes2['default'].any,
    hammerOptions: _propTypes2['default'].any,
    animated: _propTypes2['default'].bool,
    activeKey: _propTypes2['default'].string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      animated: true
    };
  },
  componentDidMount: function componentDidMount() {
    this.rootNode = _reactDom2['default'].findDOMNode(this);
  },
  onPanStart: function onPanStart() {
    var _props = this.props,
        tabBarPosition = _props.tabBarPosition,
        children = _props.children,
        activeKey = _props.activeKey,
        animated = _props.animated;

    var startIndex = this.startIndex = (0, _utils.getActiveIndex)(children, activeKey);
    if (startIndex === -1) {
      return;
    }
    if (animated) {
      (0, _utils.setTransition)(this.rootNode.style, 'none');
    }
    this.startDrag = true;
    this.children = (0, _utils.toArray)(children);
    this.maxIndex = this.children.length - 1;
    this.viewSize = (0, _utils.isVertical)(tabBarPosition) ? this.rootNode.offsetHeight : this.rootNode.offsetWidth;
  },
  onPan: function onPan(e) {
    if (!this.startDrag) {
      return;
    }
    var tabBarPosition = this.props.tabBarPosition;

    var currentIndex = getIndexByDelta.call(this, e);
    if (currentIndex !== undefined) {
      (0, _utils.setTransform)(this.rootNode.style, (0, _utils.getTransformByIndex)(currentIndex, tabBarPosition));
    }
  },
  onPanEnd: function onPanEnd(e) {
    if (!this.startDrag) {
      return;
    }
    this.end(e);
  },
  onSwipe: function onSwipe(e) {
    this.end(e, true);
  },
  end: function end(e, swipe) {
    var _props2 = this.props,
        tabBarPosition = _props2.tabBarPosition,
        animated = _props2.animated;

    this.startDrag = false;
    if (animated) {
      (0, _utils.setTransition)(this.rootNode.style, '');
    }
    var currentIndex = getIndexByDelta.call(this, e);
    var finalIndex = this.startIndex;
    if (currentIndex !== undefined) {
      if (currentIndex < 0) {
        finalIndex = 0;
      } else if (currentIndex > this.maxIndex) {
        finalIndex = this.maxIndex;
      } else if (swipe) {
        var delta = (0, _utils.isVertical)(tabBarPosition) ? e.deltaY : e.deltaX;
        finalIndex = delta < 0 ? Math.ceil(currentIndex) : Math.floor(currentIndex);
      } else {
        var floorIndex = Math.floor(currentIndex);
        if (currentIndex - floorIndex > 0.6) {
          finalIndex = floorIndex + 1;
        } else {
          finalIndex = floorIndex;
        }
      }
    }
    if (this.children[finalIndex].props.disabled) {
      return;
    }
    if (this.startIndex === finalIndex) {
      if (animated) {
        (0, _utils.setTransform)(this.rootNode.style, (0, _utils.getTransformByIndex)(finalIndex, this.props.tabBarPosition));
      }
    } else {
      this.props.onChange((0, _utils.getActiveKey)(this.props.children, finalIndex));
    }
  },
  render: function render() {
    var _props3 = this.props,
        tabBarPosition = _props3.tabBarPosition,
        hammerOptions = _props3.hammerOptions,
        animated = _props3.animated;

    var events = {
      onSwipe: this.onSwipe,
      onPanStart: this.onPanStart
    };
    if (animated !== false) {
      events = (0, _extends3['default'])({}, events, {
        onPan: this.onPan,
        onPanEnd: this.onPanEnd
      });
    }
    return _react2['default'].createElement(
      _rcHammerjs2['default'],
      (0, _extends3['default'])({}, events, {
        direction: (0, _utils.isVertical)(tabBarPosition) ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL',
        options: hammerOptions
      }),
      _react2['default'].createElement(_TabContent2['default'], this.props)
    );
  }
});

exports['default'] = SwipeableTabContent;
module.exports = exports['default'];

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReactClass = __webpack_require__(31);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _TabBarMixin = __webpack_require__(330);

var _TabBarMixin2 = _interopRequireDefault(_TabBarMixin);

var _RefMixin = __webpack_require__(329);

var _RefMixin2 = _interopRequireDefault(_RefMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TabBar = (0, _createReactClass2['default'])({
  displayName: 'TabBar',
  mixins: [_RefMixin2['default'], _TabBarMixin2['default']],
  render: function render() {
    var tabs = this.getTabs();
    return this.getRootNode(tabs);
  }
});

exports['default'] = TabBar;
module.exports = exports['default'];

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(535);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1382);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1381);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(536);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(536);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_trigger__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__placements__ = __webpack_require__(1391);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls;

      return [__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: prefixCls + '-inner', key: 'content' },
        typeof overlay === 'function' ? overlay() : overlay
      )];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Tooltip, [{
    key: 'getPopupDomNode',
    value: function getPopupDomNode() {
      return this.trigger.getPopupDomNode();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          overlayClassName = _props.overlayClassName,
          trigger = _props.trigger,
          mouseEnterDelay = _props.mouseEnterDelay,
          mouseLeaveDelay = _props.mouseLeaveDelay,
          overlayStyle = _props.overlayStyle,
          prefixCls = _props.prefixCls,
          children = _props.children,
          onVisibleChange = _props.onVisibleChange,
          afterVisibleChange = _props.afterVisibleChange,
          transitionName = _props.transitionName,
          animation = _props.animation,
          placement = _props.placement,
          align = _props.align,
          destroyTooltipOnHide = _props.destroyTooltipOnHide,
          defaultVisible = _props.defaultVisible,
          getTooltipContainer = _props.getTooltipContainer,
          restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

      var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
      if ('visible' in this.props) {
        extraProps.popupVisible = this.props.visible;
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_trigger__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          popupClassName: overlayClassName,
          ref: this.saveTrigger,
          prefixCls: prefixCls,
          popup: this.getPopupElement,
          action: trigger,
          builtinPlacements: __WEBPACK_IMPORTED_MODULE_9__placements__["a" /* placements */],
          popupPlacement: placement,
          popupAlign: align,
          getPopupContainer: getTooltipContainer,
          onPopupVisibleChange: onVisibleChange,
          afterPopupVisibleChange: afterVisibleChange,
          popupTransitionName: transitionName,
          popupAnimation: animation,
          defaultPopupVisible: defaultVisible,
          destroyPopupOnHide: destroyTooltipOnHide,
          mouseLeaveDelay: mouseLeaveDelay,
          popupStyle: overlayStyle,
          mouseEnterDelay: mouseEnterDelay
        }, extraProps),
        children
      );
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1389);


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1394);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1392);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1395);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1393);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(537);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(537);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = shouldFirePress;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function PressEvent(nativeEvent) {
    var _this = this;

    this.nativeEvent = nativeEvent;
    ['type', 'currentTarget', 'target', 'touches', 'changedTouches'].forEach(function (m) {
        _this[m] = nativeEvent[m];
    });
    if (!nativeEvent.$pressSeq) {
        nativeEvent.$pressSeq = 1;
    } else {
        nativeEvent.$pressSeq += 1;
    }
    this.$pressSeq = nativeEvent.$pressSeq;
}
PressEvent.prototype = _extends({}, PressEvent.prototype, {
    preventDefault: function preventDefault() {
        this.nativeEvent.preventDefault();
    },
    stopPropagation: function stopPropagation() {
        var nativeEvent = this.nativeEvent,
            $pressSeq = this.$pressSeq;

        if (nativeEvent.$stopPressSeq) {
            return;
        }
        nativeEvent.$stopPressSeq = $pressSeq;
    }
});
// because of setTimeout, can not depend on fire order
function shouldFirePress(e) {
    var nativeEvent = e.nativeEvent,
        $pressSeq = e.$pressSeq;

    if (!nativeEvent.$stopPressSeq) {
        return true;
    }
    return nativeEvent.$stopPressSeq >= $pressSeq;
}
/* harmony default export */ __webpack_exports__["a"] = (PressEvent);

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_align__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_animate__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PopupInner__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LazyRenderBox__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(540);














var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Popup.__proto__ || Object.getPrototypeOf(Popup)).call(this, props));

    _initialiseProps.call(_this);

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_12__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_12__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Popup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.rootNode = this.getPopupDomNode();
    }
  }, {
    key: 'getPopupDomNode',
    value: function getPopupDomNode() {
      return __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this.popupInstance);
    }
  }, {
    key: 'getMaskTransitionName',
    value: function getMaskTransitionName() {
      var props = this.props;
      var transitionName = props.maskTransitionName;
      var animation = props.maskAnimation;
      if (!transitionName && animation) {
        transitionName = props.prefixCls + '-' + animation;
      }
      return transitionName;
    }
  }, {
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'getClassName',
    value: function getClassName(currentAlignClassName) {
      return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
    }
  }, {
    key: 'getPopupElement',
    value: function getPopupElement() {
      var savePopupRef = this.savePopupRef,
          props = this.props;
      var align = props.align,
          style = props.style,
          visible = props.visible,
          prefixCls = props.prefixCls,
          destroyPopupOnHide = props.destroyPopupOnHide;

      var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
      var hiddenClassName = prefixCls + '-hidden';
      if (!visible) {
        this.currentAlignClassName = null;
      }
      var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, this.getZIndexStyle());
      var popupInnerProps = {
        className: className,
        prefixCls: prefixCls,
        ref: savePopupRef,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        style: newStyle
      };
      if (destroyPopupOnHide) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
          {
            component: '',
            exclusive: true,
            transitionAppear: true,
            transitionName: this.getTransitionName()
          },
          visible ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */],
            {
              target: this.getTarget,
              key: 'popup',
              ref: this.saveAlignRef,
              monitorWindowResize: true,
              align: align,
              onAlign: this.onAlign
            },
            __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10__PopupInner__["a" /* default */],
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
                visible: true
              }, popupInnerProps),
              props.children
            )
          ) : null
        );
      }
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName(),
          showProp: 'xVisible'
        },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_align__["a" /* default */],
          {
            target: this.getTarget,
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            xVisible: visible,
            childrenProps: { visible: 'xVisible' },
            disabled: !visible,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              hiddenClassName: hiddenClassName
            }, popupInnerProps),
            props.children
          )
        )
      );
    }
  }, {
    key: 'getZIndexStyle',
    value: function getZIndexStyle() {
      var style = {};
      var props = this.props;
      if (props.zIndex !== undefined) {
        style.zIndex = props.zIndex;
      }
      return style;
    }
  }, {
    key: 'getMaskElement',
    value: function getMaskElement() {
      var props = this.props;
      var maskElement = void 0;
      if (props.mask) {
        var maskTransition = this.getMaskTransitionName();
        maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__LazyRenderBox__["a" /* default */], {
          style: this.getZIndexStyle(),
          key: 'mask',
          className: props.prefixCls + '-mask',
          hiddenClassName: props.prefixCls + '-mask-hidden',
          visible: props.visible
        });
        if (maskTransition) {
          maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_rc_animate__["a" /* default */],
            {
              key: 'mask',
              showProp: 'visible',
              transitionAppear: true,
              component: '',
              transitionName: maskTransition
            },
            maskElement
          );
        }
      }
      return maskElement;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        this.getMaskElement(),
        this.getPopupElement()
      );
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this2.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this2.currentAlignClassName !== currentAlignClassName) {
      _this2.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this2.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.getTarget = function () {
    return _this2.props.getRootDomNode();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LazyRenderBox__ = __webpack_require__(539);








var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PopupInner.__proto__ || Object.getPrototypeOf(PopupInner)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PopupInner, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var className = props.className;
      if (!props.visible) {
        className += ' ' + props.hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        {
          className: className,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          style: props.style
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__LazyRenderBox__["a" /* default */],
          { className: props.prefixCls + '-content', visible: props.visible },
          props.children
        )
      );
    }
  }]);

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin__);











function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var isMobile = typeof navigator !== 'undefined' && !!navigator.userAgent.match(/(Android|iPhone|iPad|iPod|iOS|UCWEB)/i);

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur'];

var Trigger = __WEBPACK_IMPORTED_MODULE_4_create_react_class___default()({
  displayName: 'Trigger',
  propTypes: {
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    action: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)]),
    showAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    hideAction: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    popup: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired,
    popupStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    prefixCls: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    popupClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    popupPlacement: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    builtinPlacements: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    popupTransitionName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
    popupAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    zIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    focusDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    blurDelay: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    getPopupContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    getDocument: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    mask: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    maskClosable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    onPopupAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    popupAlign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    popupVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    maskTransitionName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
    maskAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_9_rc_util_lib_getContainerRenderMixin___default()({
    autoMount: false,

    isVisible: function isVisible(instance) {
      return instance.state.popupVisible;
    },
    getContainer: function getContainer(instance) {
      var props = instance.props;

      var popupContainer = document.createElement('div');
                  popupContainer.style.position = 'absolute';
      popupContainer.style.top = '0';
      popupContainer.style.left = '0';
      popupContainer.style.width = '100%';
      var mountNode = props.getPopupContainer ? props.getPopupContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(instance)) : props.getDocument().body;
      mountNode.appendChild(popupContainer);
      return popupContainer;
    }
  })],

  getDefaultProps: function getDefaultProps() {
    return {
      prefixCls: 'rc-trigger-popup',
      getPopupClassNameFromAlign: returnEmptyString,
      getDocument: returnDocument,
      onPopupVisibleChange: noop,
      afterPopupVisibleChange: noop,
      onPopupAlign: noop,
      popupClassName: '',
      mouseEnterDelay: 0,
      mouseLeaveDelay: 0.1,
      focusDelay: 0,
      blurDelay: 0.15,
      popupStyle: {},
      destroyPopupOnHide: false,
      popupAlign: {},
      defaultPopupVisible: false,
      mask: false,
      maskClosable: true,
      action: [],
      showAction: [],
      hideAction: []
    };
  },
  getInitialState: function getInitialState() {
    var props = this.props;
    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }
    return {
      popupVisible: popupVisible
    };
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
  },
  componentDidMount: function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var popupVisible = _ref.popupVisible;

    if (popupVisible !== undefined) {
      this.setState({
        popupVisible: popupVisible
      });
    }
  },
  componentDidUpdate: function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    this.renderComponent(null, function () {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    });

                    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && this.isClickToHide()) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default()(currentDocument, 'mousedown', this.onDocumentClick);
      }
                              if (!this.touchOutsideHandler && isMobile) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = __WEBPACK_IMPORTED_MODULE_6_rc_util_lib_Dom_addEventListener___default()(currentDocument, 'click', this.onDocumentClick);
      }
      return;
    }

    this.clearOutsideHandler();
  },
  componentWillUnmount: function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
  },
  onMouseEnter: function onMouseEnter(e) {
    this.fireEvents('onMouseEnter', e);
    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
  },
  onMouseLeave: function onMouseLeave(e) {
    this.fireEvents('onMouseLeave', e);
    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
  },
  onPopupMouseEnter: function onPopupMouseEnter() {
    this.clearDelayTimer();
  },
  onPopupMouseLeave: function onPopupMouseLeave(e) {
            if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(this._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
  },
  onFocus: function onFocus(e) {
    this.fireEvents('onFocus', e);
        this.clearDelayTimer();
    if (this.isFocusToShow()) {
      this.focusTime = Date.now();
      this.delaySetPopupVisible(true, this.props.focusDelay);
    }
  },
  onMouseDown: function onMouseDown(e) {
    this.fireEvents('onMouseDown', e);
    this.preClickTime = Date.now();
  },
  onTouchStart: function onTouchStart(e) {
    this.fireEvents('onTouchStart', e);
    this.preTouchTime = Date.now();
  },
  onBlur: function onBlur(e) {
    this.fireEvents('onBlur', e);
    this.clearDelayTimer();
    if (this.isBlurToHide()) {
      this.delaySetPopupVisible(false, this.props.blurDelay);
    }
  },
  onClick: function onClick(event) {
    this.fireEvents('onClick', event);
        if (this.focusTime) {
      var preTime = void 0;
      if (this.preClickTime && this.preTouchTime) {
        preTime = Math.min(this.preClickTime, this.preTouchTime);
      } else if (this.preClickTime) {
        preTime = this.preClickTime;
      } else if (this.preTouchTime) {
        preTime = this.preTouchTime;
      }
      if (Math.abs(preTime - this.focusTime) < 20) {
        return;
      }
      this.focusTime = 0;
    }
    this.preClickTime = 0;
    this.preTouchTime = 0;
    event.preventDefault();
    var nextVisible = !this.state.popupVisible;
    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
      this.setPopupVisible(!this.state.popupVisible);
    }
  },
  onDocumentClick: function onDocumentClick(event) {
    if (this.props.mask && !this.props.maskClosable) {
      return;
    }
    var target = event.target;
    var root = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);
    var popupNode = this.getPopupDomNode();
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rc_util_es_Dom_contains__["a" /* default */])(popupNode, target)) {
      this.close();
    }
  },
  getPopupDomNode: function getPopupDomNode() {
        if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  },
  getRootDomNode: function getRootDomNode() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this);
  },
  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
    var className = [];
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        builtinPlacements = props.builtinPlacements,
        prefixCls = props.prefixCls;

    if (popupPlacement && builtinPlacements) {
      className.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* getPopupClassNameFromAlign */])(builtinPlacements, prefixCls, align));
    }
    if (props.getPopupClassNameFromAlign) {
      className.push(props.getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  },
  getPopupAlign: function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  },
  getComponent: function getComponent() {
    var props = this.props,
        state = this.state;

    var mouseProps = {};
    if (this.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = this.onPopupMouseEnter;
    }
    if (this.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = this.onPopupMouseLeave;
    }
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: props.prefixCls,
        destroyPopupOnHide: props.destroyPopupOnHide,
        visible: state.popupVisible,
        className: props.popupClassName,
        action: props.action,
        align: this.getPopupAlign(),
        onAlign: props.onPopupAlign,
        animation: props.popupAnimation,
        getClassNameFromAlign: this.getPopupClassNameFromAlign
      }, mouseProps, {
        getRootDomNode: this.getRootDomNode,
        style: props.popupStyle,
        mask: props.mask,
        zIndex: props.zIndex,
        transitionName: props.popupTransitionName,
        maskAnimation: props.maskAnimation,
        maskTransitionName: props.maskTransitionName
      }),
      typeof props.popup === 'function' ? props.popup() : props.popup
    );
  },
  setPopupVisible: function setPopupVisible(popupVisible) {
    this.clearDelayTimer();
    if (this.state.popupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({
          popupVisible: popupVisible
        });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }
  },
  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible);
    }
  },
  clearDelayTimer: function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  },
  clearOutsideHandler: function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  },
  createTwoChains: function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  },
  isClickToShow: function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  },
  isClickToHide: function isClickToHide() {
    var _props2 = this.props,
        action = _props2.action,
        hideAction = _props2.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  },
  isMouseEnterToShow: function isMouseEnterToShow() {
    var _props3 = this.props,
        action = _props3.action,
        showAction = _props3.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  },
  isMouseLeaveToHide: function isMouseLeaveToHide() {
    var _props4 = this.props,
        action = _props4.action,
        hideAction = _props4.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  },
  isFocusToShow: function isFocusToShow() {
    var _props5 = this.props,
        action = _props5.action,
        showAction = _props5.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  },
  isBlurToHide: function isBlurToHide() {
    var _props6 = this.props,
        action = _props6.action,
        hideAction = _props6.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  },
  forcePopupAlign: function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  },
  fireEvents: function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  },
  close: function close() {
    this.setPopupVisible(false);
  },
  render: function render() {
    var props = this.props;
    var children = props.children;
    var child = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children);
    var newChildProps = {};
    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(child, newChildProps);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__(625);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContainerRenderMixin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function defaultGetContainer() {
  var container = document.createElement('div');
  document.body.appendChild(container);
  return container;
}

function getContainerRenderMixin(config) {
  var _config$autoMount = config.autoMount,
      autoMount = _config$autoMount === void 0 ? true : _config$autoMount,
      _config$autoDestroy = config.autoDestroy,
      autoDestroy = _config$autoDestroy === void 0 ? true : _config$autoDestroy,
      isVisible = config.isVisible,
      isForceRender = config.isForceRender,
      getComponent = config.getComponent,
      _config$getContainer = config.getContainer,
      getContainer = _config$getContainer === void 0 ? defaultGetContainer : _config$getContainer;
  var mixin;

  function _renderComponent(instance, componentArg, ready) {
    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
      if (!instance._container) {
        instance._container = getContainer(instance);
      }

      var component;

      if (instance.getComponent) {
        component = instance.getComponent(componentArg);
      } else {
        component = getComponent(instance, componentArg);
      }

      __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
        instance._component = this;

        if (ready) {
          ready.call(this);
        }
      });
    }
  }

  if (autoMount) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentDidMount: function componentDidMount() {
        _renderComponent(this);
      },
      componentDidUpdate: function componentDidUpdate() {
        _renderComponent(this);
      }
    });
  }

  if (!autoMount || !autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      renderComponent: function renderComponent(componentArg, ready) {
        _renderComponent(this, componentArg, ready);
      }
    });
  }

  function _removeContainer(instance) {
    if (instance._container) {
      var container = instance._container;
      __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.unmountComponentAtNode(container);
      container.parentNode.removeChild(container);
      instance._container = null;
    }
  }

  if (autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentWillUnmount: function componentWillUnmount() {
        _removeContainer(this);
      }
    });
  } else {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      removeContainer: function removeContainer() {
        _removeContainer(this);
      }
    });
  }

  return mixin;
}

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContainerRenderMixin;

var _reactDom = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function defaultGetContainer() {
  var container = document.createElement('div');
  document.body.appendChild(container);
  return container;
}

function getContainerRenderMixin(config) {
  var _config$autoMount = config.autoMount,
      autoMount = _config$autoMount === void 0 ? true : _config$autoMount,
      _config$autoDestroy = config.autoDestroy,
      autoDestroy = _config$autoDestroy === void 0 ? true : _config$autoDestroy,
      isVisible = config.isVisible,
      isForceRender = config.isForceRender,
      getComponent = config.getComponent,
      _config$getContainer = config.getContainer,
      getContainer = _config$getContainer === void 0 ? defaultGetContainer : _config$getContainer;
  var mixin;

  function _renderComponent(instance, componentArg, ready) {
    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
      if (!instance._container) {
        instance._container = getContainer(instance);
      }

      var component;

      if (instance.getComponent) {
        component = instance.getComponent(componentArg);
      } else {
        component = getComponent(instance, componentArg);
      }

      _reactDom.default.unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
        instance._component = this;

        if (ready) {
          ready.call(this);
        }
      });
    }
  }

  if (autoMount) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentDidMount: function componentDidMount() {
        _renderComponent(this);
      },
      componentDidUpdate: function componentDidUpdate() {
        _renderComponent(this);
      }
    });
  }

  if (!autoMount || !autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      renderComponent: function renderComponent(componentArg, ready) {
        _renderComponent(this, componentArg, ready);
      }
    });
  }

  function _removeContainer(instance) {
    if (instance._container) {
      var container = instance._container;

      _reactDom.default.unmountComponentAtNode(container);

      container.parentNode.removeChild(container);
      instance._container = null;
    }
  }

  if (autoDestroy) {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      componentWillUnmount: function componentWillUnmount() {
        _removeContainer(this);
      }
    });
  } else {
    mixin = _objectSpread(_objectSpread({}, mixin), {}, {
      removeContainer: function removeContainer() {
        _removeContainer(this);
      }
    });
  }

  return mixin;
}

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollBarSize;
var cached;

function getScrollBarSize(fresh) {
  if (typeof document === 'undefined') {
    return 0;
  }

  if (fresh || cached === undefined) {
    var inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';
    var outer = document.createElement('div');
    var outerStyle = outer.style;
    outerStyle.position = 'absolute';
    outerStyle.top = 0;
    outerStyle.left = 0;
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }

  return cached;
}

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);
var ReactPropTypesSecret = __webpack_require__(1425);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(35);

var focusNode = __webpack_require__(479);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(179);
var ExecutionEnvironment = __webpack_require__(57);
var FallbackCompositionState = __webpack_require__(1434);
var SyntheticCompositionEvent = __webpack_require__(1471);
var SyntheticInputEvent = __webpack_require__(1474);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(544);
var ExecutionEnvironment = __webpack_require__(57);
var ReactInstrumentation = __webpack_require__(75);

var camelizeStyleName = __webpack_require__(1116);
var dangerousStyleValue = __webpack_require__(1480);
var hyphenateStyleName = __webpack_require__(1123);
var memoizeStringOnly = __webpack_require__(1126);
var warning = __webpack_require__(25);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(178);
var EventPropagators = __webpack_require__(179);
var ExecutionEnvironment = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactUpdates = __webpack_require__(87);
var SyntheticEvent = __webpack_require__(93);

var inputValueTracking = __webpack_require__(560);
var getEventTarget = __webpack_require__(352);
var isEventSupported = __webpack_require__(353);
var isTextInputElement = __webpack_require__(562);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var DOMLazyTree = __webpack_require__(140);
var ExecutionEnvironment = __webpack_require__(57);

var createNodesFromMarkup = __webpack_require__(1119);
var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(179);
var ReactDOMComponentTree = __webpack_require__(35);
var SyntheticMouseEvent = __webpack_require__(219);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var PooledClass = __webpack_require__(119);

var getTextContentAccessor = __webpack_require__(559);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(141);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(142);

var instantiateReactComponent = __webpack_require__(561);
var KeyEscapeUtils = __webpack_require__(344);
var shouldUpdateReactComponent = __webpack_require__(354);
var traverseAllChildren = __webpack_require__(564);
var warning = __webpack_require__(25);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"."}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(584);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(311)))

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(340);
var ReactDOMIDOperations = __webpack_require__(1444);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var React = __webpack_require__(146);
var ReactComponentEnvironment = __webpack_require__(346);
var ReactCurrentOwner = __webpack_require__(94);
var ReactErrorUtils = __webpack_require__(347);
var ReactInstanceMap = __webpack_require__(180);
var ReactInstrumentation = __webpack_require__(75);
var ReactNodeTypes = __webpack_require__(554);
var ReactReconciler = __webpack_require__(142);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(138);
var invariant = __webpack_require__(15);
var shallowEqual = __webpack_require__(308);
var shouldUpdateReactComponent = __webpack_require__(354);
var warning = __webpack_require__(25);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(35);
var ReactDefaultInjection = __webpack_require__(1452);
var ReactMount = __webpack_require__(553);
var ReactReconciler = __webpack_require__(142);
var ReactUpdates = __webpack_require__(87);
var ReactVersion = __webpack_require__(1465);

var findDOMNode = __webpack_require__(1481);
var getHostComponentFromComposite = __webpack_require__(558);
var renderSubtreeIntoContainer = __webpack_require__(1488);
var warning = __webpack_require__(25);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var AutoFocusUtils = __webpack_require__(1427);
var CSSPropertyOperations = __webpack_require__(1429);
var DOMLazyTree = __webpack_require__(140);
var DOMNamespaces = __webpack_require__(341);
var DOMProperty = __webpack_require__(141);
var DOMPropertyOperations = __webpack_require__(546);
var EventPluginHub = __webpack_require__(178);
var EventPluginRegistry = __webpack_require__(342);
var ReactBrowserEventEmitter = __webpack_require__(218);
var ReactDOMComponentFlags = __webpack_require__(547);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactDOMInput = __webpack_require__(1445);
var ReactDOMOption = __webpack_require__(1446);
var ReactDOMSelect = __webpack_require__(548);
var ReactDOMTextarea = __webpack_require__(1449);
var ReactInstrumentation = __webpack_require__(75);
var ReactMultiChild = __webpack_require__(1458);
var ReactServerRenderingTransaction = __webpack_require__(1463);

var emptyFunction = __webpack_require__(49);
var escapeTextContentForBrowser = __webpack_require__(221);
var invariant = __webpack_require__(15);
var isEventSupported = __webpack_require__(353);
var shallowEqual = __webpack_require__(308);
var inputValueTracking = __webpack_require__(560);
var validateDOMNesting = __webpack_require__(355);
var warning = __webpack_require__(25);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(355);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var DOMLazyTree = __webpack_require__(140);
var ReactDOMComponentTree = __webpack_require__(35);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(340);
var ReactDOMComponentTree = __webpack_require__(35);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var DOMPropertyOperations = __webpack_require__(546);
var LinkedValueUtils = __webpack_require__(345);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactUpdates = __webpack_require__(87);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var React = __webpack_require__(146);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactDOMSelect = __webpack_require__(548);

var warning = __webpack_require__(25);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(57);

var getNodeForCharacterOffset = __webpack_require__(1485);
var getTextContentAccessor = __webpack_require__(559);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var DOMChildrenOperations = __webpack_require__(340);
var DOMLazyTree = __webpack_require__(140);
var ReactDOMComponentTree = __webpack_require__(35);

var escapeTextContentForBrowser = __webpack_require__(221);
var invariant = __webpack_require__(15);
var validateDOMNesting = __webpack_require__(355);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27),
    _assign = __webpack_require__(24);

var LinkedValueUtils = __webpack_require__(345);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactUpdates = __webpack_require__(87);

var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var ReactUpdates = __webpack_require__(87);
var Transaction = __webpack_require__(220);

var emptyFunction = __webpack_require__(49);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(1426);
var BeforeInputEventPlugin = __webpack_require__(1428);
var ChangeEventPlugin = __webpack_require__(1430);
var DefaultEventPluginOrder = __webpack_require__(1432);
var EnterLeaveEventPlugin = __webpack_require__(1433);
var HTMLDOMPropertyConfig = __webpack_require__(1435);
var ReactComponentBrowserEnvironment = __webpack_require__(1437);
var ReactDOMComponent = __webpack_require__(1440);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactDOMEmptyComponent = __webpack_require__(1442);
var ReactDOMTreeTraversal = __webpack_require__(1450);
var ReactDOMTextComponent = __webpack_require__(1448);
var ReactDefaultBatchingStrategy = __webpack_require__(1451);
var ReactEventListener = __webpack_require__(1455);
var ReactInjection = __webpack_require__(1456);
var ReactReconcileTransaction = __webpack_require__(1461);
var SVGDOMPropertyConfig = __webpack_require__(1466);
var SelectEventPlugin = __webpack_require__(1467);
var SimpleEventPlugin = __webpack_require__(1468);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(178);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var EventListener = __webpack_require__(478);
var ExecutionEnvironment = __webpack_require__(57);
var PooledClass = __webpack_require__(119);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactUpdates = __webpack_require__(87);

var getEventTarget = __webpack_require__(352);
var getUnboundedScrollPosition = __webpack_require__(1121);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(141);
var EventPluginHub = __webpack_require__(178);
var EventPluginUtils = __webpack_require__(343);
var ReactComponentEnvironment = __webpack_require__(346);
var ReactEmptyComponent = __webpack_require__(549);
var ReactBrowserEventEmitter = __webpack_require__(218);
var ReactHostComponent = __webpack_require__(551);
var ReactUpdates = __webpack_require__(87);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(1479);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactComponentEnvironment = __webpack_require__(346);
var ReactInstanceMap = __webpack_require__(180);
var ReactInstrumentation = __webpack_require__(75);

var ReactCurrentOwner = __webpack_require__(94);
var ReactReconciler = __webpack_require__(142);
var ReactChildReconciler = __webpack_require__(1436);

var emptyFunction = __webpack_require__(49);
var flattenChildren = __webpack_require__(1482);
var invariant = __webpack_require__(15);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var invariant = __webpack_require__(15);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var CallbackQueue = __webpack_require__(545);
var PooledClass = __webpack_require__(119);
var ReactBrowserEventEmitter = __webpack_require__(218);
var ReactInputSelection = __webpack_require__(552);
var ReactInstrumentation = __webpack_require__(75);
var Transaction = __webpack_require__(220);
var ReactUpdateQueue = __webpack_require__(348);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(1459);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(24);

var PooledClass = __webpack_require__(119);
var Transaction = __webpack_require__(220);
var ReactInstrumentation = __webpack_require__(75);
var ReactServerUpdateQueue = __webpack_require__(1464);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(348);

var warning = __webpack_require__(25);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(179);
var ExecutionEnvironment = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactInputSelection = __webpack_require__(552);
var SyntheticEvent = __webpack_require__(93);

var getActiveElement = __webpack_require__(480);
var isTextInputElement = __webpack_require__(562);
var shallowEqual = __webpack_require__(308);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(27);

var EventListener = __webpack_require__(478);
var EventPropagators = __webpack_require__(179);
var ReactDOMComponentTree = __webpack_require__(35);
var SyntheticAnimationEvent = __webpack_require__(1469);
var SyntheticClipboardEvent = __webpack_require__(1470);
var SyntheticEvent = __webpack_require__(93);
var SyntheticFocusEvent = __webpack_require__(1473);
var SyntheticKeyboardEvent = __webpack_require__(1475);
var SyntheticMouseEvent = __webpack_require__(219);
var SyntheticDragEvent = __webpack_require__(1472);
var SyntheticTouchEvent = __webpack_require__(1476);
var SyntheticTransitionEvent = __webpack_require__(1477);
var SyntheticUIEvent = __webpack_require__(181);
var SyntheticWheelEvent = __webpack_require__(1478);

var emptyFunction = __webpack_require__(49);
var getEventCharCode = __webpack_require__(350);
var invariant = __webpack_require__(15);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(93);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(93);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(93);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(219);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(181);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(93);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(181);

var getEventCharCode = __webpack_require__(350);
var getEventKey = __webpack_require__(1483);
var getEventModifierState = __webpack_require__(351);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(181);

var getEventModifierState = __webpack_require__(351);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(93);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(219);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(544);
var warning = __webpack_require__(25);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(27);

var ReactCurrentOwner = __webpack_require__(94);
var ReactDOMComponentTree = __webpack_require__(35);
var ReactInstanceMap = __webpack_require__(180);

var getHostComponentFromComposite = __webpack_require__(558);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(344);
var traverseAllChildren = __webpack_require__(564);
var warning = __webpack_require__(25);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"."}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(584);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(311)))

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(350);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(57);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(221);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(553);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1491);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

var ReactPropTypesSecret = __webpack_require__(1492);
var checkPropTypes = __webpack_require__(1489);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(356);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1500);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(567);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(567);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(569);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1501);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(356);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);
var ReactPropTypesSecret = __webpack_require__(1505);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(571);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(182);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRedirect);

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(182);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexRoute);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(182);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(144);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== 'undefined';

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },


  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

if (prefixUnsafeLifecycleMethods) {
  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
  delete Router.prototype.componentWillReceiveProps;
  delete Router.prototype.componentWillMount;
}

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(357);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(144);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(576);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(143);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(572);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(143);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(576);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(143);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(574);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(106);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(359);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(361);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(145);

var _DOMUtils = __webpack_require__(224);

var _DOMStateStorage = __webpack_require__(579);

var _PathUtils = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(361);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(145);

var _PathUtils = __webpack_require__(107);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(50);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(362);

var _BrowserProtocol = __webpack_require__(361);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1524);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(224);

var _createHistory = __webpack_require__(363);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(50);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(362);

var _DOMUtils = __webpack_require__(224);

var _HashProtocol = __webpack_require__(1523);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(363);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(46);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(50);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(145);

var _PathUtils = __webpack_require__(107);

var _createHistory = __webpack_require__(363);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(565);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _channel = __webpack_require__(582);

var _channel2 = _interopRequireDefault(_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_React$Component) {
  _inherits(Container, _React$Component);

  function Container(props) {
    _classCallCheck(this, Container);

    var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this, props));

    _this.updateOffset = function (_ref) {
      var inherited = _ref.inherited,
          offset = _ref.offset;

      _this.channel.update(function (data) {
        data.inherited = inherited + offset;
      });
    };

    _this.channel = new _channel2.default({ inherited: 0, offset: 0, node: null });
    return _this;
  }

  _createClass(Container, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { 'sticky-channel': this.channel };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var parentChannel = this.context['sticky-channel'];
      if (parentChannel) parentChannel.subscribe(this.updateOffset);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var node = _reactDom2.default.findDOMNode(this);
      this.channel.update(function (data) {
        data.node = node;
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.channel.update(function (data) {
        data.node = null;
      });

      var parentChannel = this.context['sticky-channel'];
      if (parentChannel) parentChannel.unsubscribe(this.updateOffset);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        this.props,
        this.props.children
      );
    }
  }]);

  return Container;
}(_react2.default.Component);

Container.contextTypes = {
  'sticky-channel': _propTypes2.default.any
};
Container.childContextTypes = {
  'sticky-channel': _propTypes2.default.any
};
exports.default = Container;
module.exports = exports['default'];

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Channel = exports.StickyContainer = exports.Sticky = undefined;

var _sticky = __webpack_require__(1531);

var _sticky2 = _interopRequireDefault(_sticky);

var _container = __webpack_require__(1529);

var _container2 = _interopRequireDefault(_container);

var _channel = __webpack_require__(582);

var _channel2 = _interopRequireDefault(_channel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Sticky = _sticky2.default;
exports.StickyContainer = _container2.default;
exports.Channel = _channel2.default;
exports.default = _sticky2.default;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sticky = function (_React$Component) {
  _inherits(Sticky, _React$Component);

  function Sticky(props) {
    _classCallCheck(this, Sticky);

    var _this = _possibleConstructorReturn(this, (Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call(this, props));

    _this.updateContext = function (_ref) {
      var inherited = _ref.inherited,
          node = _ref.node;

      _this.containerNode = node;
      _this.setState({
        containerOffset: inherited,
        distanceFromBottom: _this.getDistanceFromBottom()
      });
    };

    _this.recomputeState = function () {
      var isSticky = _this.isSticky();
      var height = _this.getHeight();
      var width = _this.getWidth();
      var xOffset = _this.getXOffset();
      var distanceFromBottom = _this.getDistanceFromBottom();
      var hasChanged = _this.state.isSticky !== isSticky;

      _this.setState({ isSticky: isSticky, height: height, width: width, xOffset: xOffset, distanceFromBottom: distanceFromBottom });

      if (hasChanged) {
        if (_this.channel) {
          _this.channel.update(function (data) {
            data.offset = isSticky ? _this.state.height : 0;
          });
        }

        _this.props.onStickyStateChange(isSticky);
      }
    };

    _this.state = {};
    return _this;
  }

  _createClass(Sticky, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.channel = this.context['sticky-channel'];
      this.channel.subscribe(this.updateContext);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.on(['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], this.recomputeState);
      this.recomputeState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.recomputeState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.off(['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'], this.recomputeState);
      this.channel.unsubscribe(this.updateContext);
    }
  }, {
    key: 'getXOffset',
    value: function getXOffset() {
      return this.refs.placeholder.getBoundingClientRect().left;
    }
  }, {
    key: 'getWidth',
    value: function getWidth() {
      return this.refs.placeholder.getBoundingClientRect().width;
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      return _reactDom2.default.findDOMNode(this.refs.children).getBoundingClientRect().height;
    }
  }, {
    key: 'getDistanceFromTop',
    value: function getDistanceFromTop() {
      return this.refs.placeholder.getBoundingClientRect().top;
    }
  }, {
    key: 'getDistanceFromBottom',
    value: function getDistanceFromBottom() {
      if (!this.containerNode) return 0;
      return this.containerNode.getBoundingClientRect().bottom;
    }
  }, {
    key: 'isSticky',
    value: function isSticky() {
      if (!this.props.isActive) return false;

      var fromTop = this.getDistanceFromTop();
      var fromBottom = this.getDistanceFromBottom();

      var topBreakpoint = this.state.containerOffset - this.props.topOffset;
      var bottomBreakpoint = this.state.containerOffset + this.props.bottomOffset;

      return fromTop <= topBreakpoint && fromBottom >= bottomBreakpoint;
    }
  }, {
    key: 'on',
    value: function on(events, callback) {
      events.forEach(function (evt) {
        window.addEventListener(evt, callback);
      });
    }
  }, {
    key: 'off',
    value: function off(events, callback) {
      events.forEach(function (evt) {
        window.removeEventListener(evt, callback);
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(newProps, newState) {
      var _this2 = this;

      // Have we changed the number of props?
      var propNames = Object.keys(this.props);
      if (Object.keys(newProps).length != propNames.length) return true;

      // Have we changed any prop values?
      var valuesMatch = propNames.every(function (key) {
        return newProps.hasOwnProperty(key) && newProps[key] === _this2.props[key];
      });
      if (!valuesMatch) return true;

      // Have we changed any state that will always impact rendering?
      var state = this.state;
      if (newState.isSticky !== state.isSticky) return true;

      // If we are sticky, have we changed any state that will impact rendering?
      if (state.isSticky) {
        if (newState.height !== state.height) return true;
        if (newState.width !== state.width) return true;
        if (newState.xOffset !== state.xOffset) return true;
        if (newState.containerOffset !== state.containerOffset) return true;
        if (newState.distanceFromBottom !== state.distanceFromBottom) return true;
      }

      return false;
    }

    /*
     * The special sauce.
     */

  }, {
    key: 'render',
    value: function render() {
      var placeholderStyle = { paddingBottom: 0 };
      var className = this.props.className;

      // To ensure that this component becomes sticky immediately on mobile devices instead
      // of disappearing until the scroll event completes, we add `transform: translateZ(0)`
      // to 'kick' rendering of this element to the GPU
      // @see http://stackoverflow.com/questions/32875046
      var style = _extends({}, { transform: 'translateZ(0)' }, this.props.style);

      if (this.state.isSticky) {
        var _stickyStyle = {
          position: 'fixed',
          top: this.state.containerOffset,
          left: this.state.xOffset,
          width: this.state.width
        };

        var bottomLimit = this.state.distanceFromBottom - this.state.height - this.props.bottomOffset;
        if (this.state.containerOffset > bottomLimit) {
          _stickyStyle.top = bottomLimit;
        }

        placeholderStyle.paddingBottom = this.state.height;

        className += ' ' + this.props.stickyClassName;
        style = _extends({}, style, _stickyStyle, this.props.stickyStyle);
      }

      var _props = this.props,
          topOffset = _props.topOffset,
          isActive = _props.isActive,
          stickyClassName = _props.stickyClassName,
          stickyStyle = _props.stickyStyle,
          bottomOffset = _props.bottomOffset,
          onStickyStateChange = _props.onStickyStateChange,
          props = _objectWithoutProperties(_props, ['topOffset', 'isActive', 'stickyClassName', 'stickyStyle', 'bottomOffset', 'onStickyStateChange']);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { ref: 'placeholder', style: placeholderStyle }),
        _react2.default.createElement(
          'div',
          _extends({}, props, { ref: 'children', className: className, style: style }),
          this.props.children
        )
      );
    }
  }]);

  return Sticky;
}(_react2.default.Component);

Sticky.propTypes = {
  isActive: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  stickyClassName: _propTypes2.default.string,
  stickyStyle: _propTypes2.default.object,
  topOffset: _propTypes2.default.number,
  bottomOffset: _propTypes2.default.number,
  onStickyStateChange: _propTypes2.default.func
};
Sticky.defaultProps = {
  isActive: true,
  className: '',
  style: {},
  stickyClassName: 'sticky',
  stickyStyle: {},
  topOffset: 0,
  bottomOffset: 0,
  onStickyStateChange: function onStickyStateChange() {}
};
Sticky.contextTypes = {
  'sticky-channel': _propTypes2.default.any
};
exports.default = Sticky;
module.exports = exports['default'];

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(183);

var invariant = __webpack_require__(15);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1533);
var ReactElement = __webpack_require__(147);

var emptyFunction = __webpack_require__(49);
var traverseAllChildren = __webpack_require__(1543);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(147);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(147),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(1546);

module.exports = factory(isValidElement);

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(583),
    Component = _require.Component;

var _require2 = __webpack_require__(147),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(586);
var factory = __webpack_require__(1544);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(183);

var ReactElement = __webpack_require__(147);

var invariant = __webpack_require__(15);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(183);

var ReactCurrentOwner = __webpack_require__(94);
var REACT_ELEMENT_TYPE = __webpack_require__(585);

var getIteratorFn = __webpack_require__(1539);
var invariant = __webpack_require__(15);
var KeyEscapeUtils = __webpack_require__(1532);
var warning = __webpack_require__(25);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(24);

var emptyObject = __webpack_require__(138);
var _invariant = __webpack_require__(15);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1547);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(15);
var warning = __webpack_require__(25);

var ReactPropTypesSecret = __webpack_require__(1548);
var checkPropTypes = __webpack_require__(1545);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(588);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(590);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1554);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(594);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(592);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(593);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(596);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(595);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__(622);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupCascader = function (_React$Component) {
    (0, _inherits3['default'])(PopupCascader, _React$Component);

    function PopupCascader() {
        (0, _classCallCheck3['default'])(this, PopupCascader);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PopupCascader.__proto__ || Object.getPrototypeOf(PopupCascader)).apply(this, arguments));

        _this.onOk = function (v) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                onOk = _this$props.onOk;

            if (onChange) {
                onChange(v);
            }
            if (onOk) {
                onOk(v);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(PopupCascader, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_Popup2['default'], (0, _extends3['default'])({ picker: this.props.cascader }, this.props, { onOk: this.onOk }));
        }
    }]);
    return PopupCascader;
}(_react2['default'].Component);

PopupCascader.defaultProps = {
    pickerValueProp: 'value',
    pickerValueChangeProp: 'onChange'
};
exports['default'] = PopupCascader;
module.exports = exports['default'];

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(600);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(598);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(599);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(602);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(601);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MultiPicker = __webpack_require__(230);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(231);

var _Picker2 = _interopRequireDefault(_Picker);

var _moment = __webpack_require__(1572);

var _moment2 = _interopRequireDefault(_moment);

var _en_US = __webpack_require__(1564);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDaysInMonth(now) {
    return now.clone().endOf('month').date();
}
function pad(n) {
    return n < 10 ? '0' + n : n + '';
}
var smallPickerItem = {
    fontSize: 20
};
var DATETIME = 'datetime';
var DATE = 'date';
var TIME = 'time';
var MONTH = 'month';
var YEAR = 'year';

var DatePicker = function (_React$Component) {
    (0, _inherits3['default'])(DatePicker, _React$Component);

    function DatePicker() {
        (0, _classCallCheck3['default'])(this, DatePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));

        _this.state = {
            date: _this.props.date || _this.props.defaultDate
        };
        _this.onValueChange = function (values, index) {
            var value = parseInt(values[index], 10);
            var props = _this.props;
            var mode = props.mode;

            var newValue = _this.getDate().clone();
            if (mode === DATETIME || mode === DATE || mode === YEAR || mode === MONTH) {
                switch (index) {
                    case 0:
                        newValue.year(value);
                        break;
                    case 1:
                        newValue.month(value);
                        break;
                    case 2:
                        newValue.date(value);
                        break;
                    case 3:
                        newValue.hour(value);
                        break;
                    case 4:
                        newValue.minute(value);
                        break;
                    default:
                        break;
                }
            } else {
                switch (index) {
                    case 0:
                        newValue.hour(value);
                        break;
                    case 1:
                        newValue.minute(value);
                        break;
                    default:
                        break;
                }
            }
            newValue = _this.clipDate(newValue);
            if (!('date' in props)) {
                _this.setState({
                    date: newValue
                });
            }
            if (props.onDateChange) {
                props.onDateChange(newValue);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(DatePicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('date' in nextProps) {
                this.setState({
                    date: nextProps.date || nextProps.defaultDate
                });
            }
        }
    }, {
        key: 'getDefaultMinDate',
        value: function getDefaultMinDate() {
            if (!this.defaultMinDate) {
                this.defaultMinDate = this.getGregorianCalendar([2000, 1, 1, 0, 0, 0]);
            }
            return this.defaultMinDate;
        }
    }, {
        key: 'getDefaultMaxDate',
        value: function getDefaultMaxDate() {
            if (!this.defaultMaxDate) {
                this.defaultMaxDate = this.getGregorianCalendar([2030, 1, 1, 23, 59, 59]);
            }
            return this.defaultMaxDate;
        }
    }, {
        key: 'getDate',
        value: function getDate() {
            return this.state.date || this.getDefaultMinDate();
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return this.getDate();
        }
    }, {
        key: 'getMinYear',
        value: function getMinYear() {
            return this.getMinDate().year();
        }
    }, {
        key: 'getMaxYear',
        value: function getMaxYear() {
            return this.getMaxDate().year();
        }
    }, {
        key: 'getMinMonth',
        value: function getMinMonth() {
            return this.getMinDate().month();
        }
    }, {
        key: 'getMaxMonth',
        value: function getMaxMonth() {
            return this.getMaxDate().month();
        }
    }, {
        key: 'getMinDay',
        value: function getMinDay() {
            return this.getMinDate().date();
        }
    }, {
        key: 'getMaxDay',
        value: function getMaxDay() {
            return this.getMaxDate().date();
        }
    }, {
        key: 'getMinHour',
        value: function getMinHour() {
            return this.getMinDate().hour();
        }
    }, {
        key: 'getMaxHour',
        value: function getMaxHour() {
            return this.getMaxDate().hour();
        }
    }, {
        key: 'getMinMinute',
        value: function getMinMinute() {
            return this.getMinDate().minute();
        }
    }, {
        key: 'getMaxMinute',
        value: function getMaxMinute() {
            return this.getMaxDate().minute();
        }
    }, {
        key: 'getMinDate',
        value: function getMinDate() {
            return this.props.minDate || this.getDefaultMinDate();
        }
    }, {
        key: 'getMaxDate',
        value: function getMaxDate() {
            return this.props.maxDate || this.getDefaultMaxDate();
        }
    }, {
        key: 'getDateData',
        value: function getDateData() {
            var _props = this.props,
                locale = _props.locale,
                formatMonth = _props.formatMonth,
                formatDay = _props.formatDay,
                mode = _props.mode;

            var date = this.getDate();
            var selYear = date.year();
            var selMonth = date.month();
            var minDateYear = this.getMinYear();
            var maxDateYear = this.getMaxYear();
            var minDateMonth = this.getMinMonth();
            var maxDateMonth = this.getMaxMonth();
            var minDateDay = this.getMinDay();
            var maxDateDay = this.getMaxDay();
            var years = [];
            for (var i = minDateYear; i <= maxDateYear; i++) {
                years.push({
                    value: i + '',
                    label: i + locale.year + ''
                });
            }
            var yearCol = { key: 'year', props: { children: years } };
            if (mode === YEAR) {
                return [yearCol];
            }
            var months = [];
            var minMonth = 0;
            var maxMonth = 11;
            if (minDateYear === selYear) {
                minMonth = minDateMonth;
            }
            if (maxDateYear === selYear) {
                maxMonth = maxDateMonth;
            }
            for (var _i = minMonth; _i <= maxMonth; _i++) {
                var label = formatMonth ? formatMonth(_i, date) : _i + 1 + locale.month + '';
                months.push({
                    value: _i + '',
                    label: label
                });
            }
            var monthCol = { key: 'month', props: { children: months } };
            if (mode === MONTH) {
                return [yearCol, monthCol];
            }
            var days = [];
            var minDay = 1;
            var maxDay = getDaysInMonth(date);
            if (minDateYear === selYear && minDateMonth === selMonth) {
                minDay = minDateDay;
            }
            if (maxDateYear === selYear && maxDateMonth === selMonth) {
                maxDay = maxDateDay;
            }
            for (var _i2 = minDay; _i2 <= maxDay; _i2++) {
                var _label = formatDay ? formatDay(_i2, date) : _i2 + locale.day + '';
                days.push({
                    value: _i2 + '',
                    label: _label
                });
            }
            return [yearCol, monthCol, { key: 'day', props: { children: days } }];
        }
    }, {
        key: 'getTimeData',
        value: function getTimeData() {
            var minHour = 0;
            var maxHour = 23;
            var minMinute = 0;
            var maxMinute = 59;
            var _props2 = this.props,
                mode = _props2.mode,
                locale = _props2.locale,
                minuteStep = _props2.minuteStep;

            var date = this.getDate();
            var minDateMinute = this.getMinMinute();
            var maxDateMinute = this.getMaxMinute();
            var minDateHour = this.getMinHour();
            var maxDateHour = this.getMaxHour();
            var hour = date.hour();
            if (mode === DATETIME) {
                var year = date.year();
                var month = date.month();
                var day = date.date();
                var minDateYear = this.getMinYear();
                var maxDateYear = this.getMaxYear();
                var minDateMonth = this.getMinMonth();
                var maxDateMonth = this.getMaxMonth();
                var minDateDay = this.getMinDay();
                var maxDateDay = this.getMaxDay();
                if (minDateYear === year && minDateMonth === month && minDateDay === day) {
                    minHour = minDateHour;
                    if (minDateHour === hour) {
                        minMinute = minDateMinute;
                    }
                }
                if (maxDateYear === year && maxDateMonth === month && maxDateDay === day) {
                    maxHour = maxDateHour;
                    if (maxDateHour === hour) {
                        maxMinute = maxDateMinute;
                    }
                }
            } else {
                minHour = minDateHour;
                if (minDateHour === hour) {
                    minMinute = minDateMinute;
                }
                maxHour = maxDateHour;
                if (maxDateHour === hour) {
                    maxMinute = maxDateMinute;
                }
            }
            var hours = [];
            for (var i = minHour; i <= maxHour; i++) {
                hours.push({
                    value: i + '',
                    label: locale.hour ? i + locale.hour + '' : pad(i)
                });
            }
            var minutes = [];
            for (var _i3 = minMinute; _i3 <= maxMinute; _i3 += minuteStep) {
                minutes.push({
                    value: _i3 + '',
                    label: locale.minute ? _i3 + locale.minute + '' : pad(_i3)
                });
            }
            return [{ key: 'hours', props: { children: hours } }, { key: 'minutes', props: { children: minutes } }];
        }
    }, {
        key: 'getGregorianCalendar',
        value: function getGregorianCalendar(arg) {
            return (0, _moment2['default'])(arg);
        }
    }, {
        key: 'clipDate',
        value: function clipDate(date) {
            var mode = this.props.mode;

            var minDate = this.getMinDate();
            var maxDate = this.getMaxDate();
            if (mode === DATETIME) {
                if (date.isBefore(minDate)) {
                    return minDate.clone();
                }
                if (date.isAfter(maxDate)) {
                    return maxDate.clone();
                }
            } else if (mode === DATE) {
                if (date.isBefore(minDate, 'day')) {
                    return minDate.clone();
                }
                if (date.isAfter(maxDate, 'day')) {
                    return maxDate.clone();
                }
            } else {
                var maxHour = maxDate.hour();
                var maxMinutes = maxDate.minute();
                var minHour = minDate.hour();
                var minMinutes = minDate.minute();
                var hour = date.hour();
                var minutes = date.minute();
                if (hour < minHour || hour === minHour && minutes < minMinutes) {
                    return minDate.clone();
                }
                if (hour > maxHour || hour === maxHour && minutes > maxMinutes) {
                    return maxDate.clone();
                }
            }
            return date;
        }
    }, {
        key: 'getValueCols',
        value: function getValueCols() {
            var mode = this.props.mode;

            var date = this.getDate();
            var cols = [];
            var value = [];
            if (mode === YEAR) {
                return {
                    cols: this.getDateData(),
                    value: [date.year() + '']
                };
            }
            if (mode === MONTH) {
                return {
                    cols: this.getDateData(),
                    value: [date.year() + '', date.month() + '']
                };
            }
            if (mode === DATETIME || mode === DATE) {
                cols = this.getDateData();
                value = [date.year() + '', date.month() + '', date.date() + ''];
            }
            if (mode === DATETIME || mode === TIME) {
                cols = cols.concat(this.getTimeData());
                value = value.concat([date.hour() + '', date.minute() + '']);
            }
            return {
                value: value,
                cols: cols
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _getValueCols = this.getValueCols(),
                value = _getValueCols.value,
                cols = _getValueCols.cols;

            var _props3 = this.props,
                mode = _props3.mode,
                prefixCls = _props3.prefixCls,
                pickerPrefixCls = _props3.pickerPrefixCls,
                rootNativeProps = _props3.rootNativeProps,
                className = _props3.className,
                disabled = _props3.disabled,
                style = _props3.style;

            var multiStyle = (0, _extends3['default'])({ flexDirection: 'row', alignItems: 'center' }, style);
            return _react2['default'].createElement(_MultiPicker2['default'], { style: multiStyle, rootNativeProps: rootNativeProps, className: className, prefixCls: prefixCls, selectedValue: value, onValueChange: this.onValueChange }, cols.map(function (p) {
                return _react2['default'].createElement(_Picker2['default'], { style: { flex: 1 }, key: p.key, disabled: disabled, prefixCls: pickerPrefixCls, itemStyle: typeof window === 'undefined' && mode === 'datetime' ? smallPickerItem : undefined }, p.props.children.map(function (item) {
                    return _react2['default'].createElement(_Picker2['default'].Item, { key: item.value, value: item.value }, item.label);
                }));
            }));
        }
    }]);
    return DatePicker;
}(_react2['default'].Component);

DatePicker.defaultProps = {
    prefixCls: 'rmc-date-picker',
    pickerPrefixCls: 'rmc-picker',
    locale: _en_US2['default'],
    mode: DATE,
    minuteStep: 1,
    onDateChange: function onDateChange() {}
};
exports['default'] = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(600);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(598);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(599);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(602);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(601);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__(622);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupDatePicker = function (_React$Component) {
    (0, _inherits3['default'])(PopupDatePicker, _React$Component);

    function PopupDatePicker() {
        (0, _classCallCheck3['default'])(this, PopupDatePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PopupDatePicker.__proto__ || Object.getPrototypeOf(PopupDatePicker)).apply(this, arguments));

        _this.onOk = function (v) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                onOk = _this$props.onOk;

            if (onChange) {
                onChange(v);
            }
            if (onOk) {
                onOk(v);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(PopupDatePicker, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_Popup2['default'], (0, _extends3['default'])({ picker: this.props.datePicker, value: this.props.date }, this.props, { onOk: this.onOk }));
        }
    }]);
    return PopupDatePicker;
}(_react2['default'].Component);

PopupDatePicker.defaultProps = {
    pickerValueProp: 'date',
    pickerValueChangeProp: 'onDateChange'
};
exports['default'] = PopupDatePicker;
module.exports = exports['default'];

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: ''
};
module.exports = exports['default'];

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    year: '年',
    month: '月',
    day: '日',
    hour: '时',
    minute: '分'
};
module.exports = exports['default'];

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(42), __esModule: true };

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(43), __esModule: true };

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(41), __esModule: true };

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(396)(module)))

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ListView__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util__ = __webpack_require__(605);














function setDocumentScrollTop(val) {
  window.document.body.scrollTop = val; // chrome61 is invalid
  window.document.documentElement.scrollTop = val;
}

/* eslint react/prop-types: 0 */

var IndexedList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(IndexedList, _React$Component);

  function IndexedList(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, IndexedList);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IndexedList.__proto__ || Object.getPrototypeOf(IndexedList)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      pageSize: props.pageSize,
      _delay: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(IndexedList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.dataChange(this.props);
      // handle quickSearchBar
      this.getQsInfo();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.dataSource !== nextProps.dataSource) {
        this.dataChange(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.getQsInfo();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._timer) {
        clearTimeout(this._timer);
      }
      this._hCache = null;
    }
  }, {
    key: 'renderQuickSearchBar',
    value: function renderQuickSearchBar(quickSearchBarTop, quickSearchBarStyle) {
      var _this2 = this;

      var _props = this.props,
          dataSource = _props.dataSource,
          prefixCls = _props.prefixCls;

      var sectionKvs = dataSource.sectionIdentities.map(function (i) {
        return {
          value: i,
          label: dataSource._getSectionHeaderData(dataSource._dataBlob, i)
        };
      });
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'ul',
        { ref: 'quickSearchBar',
          className: prefixCls + '-quick-search-bar', style: quickSearchBarStyle,
          onTouchStart: this.onTouchStart,
          onTouchMove: this.onTouchMove,
          onTouchEnd: this.onTouchEnd,
          onTouchCancel: this.onTouchEnd
        },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'li',
          { 'data-qf-target': quickSearchBarTop.value,
            onClick: function onClick() {
              return _this2.onQuickSearchTop(undefined, quickSearchBarTop.value);
            }
          },
          quickSearchBarTop.label
        ),
        sectionKvs.map(function (i) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'li',
            { key: i.value, 'data-qf-target': i.value,
              onClick: function onClick() {
                return _this2.onQuickSearch(i.value);
              }
            },
            i.label
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
          _classNames;

      var _state = this.state,
          _delay = _state._delay,
          pageSize = _state.pageSize;

      var _props2 = this.props,
          className = _props2.className,
          prefixCls = _props2.prefixCls,
          children = _props2.children,
          quickSearchBarTop = _props2.quickSearchBarTop,
          quickSearchBarStyle = _props2.quickSearchBarStyle,
          _props2$initialListSi = _props2.initialListSize,
          initialListSize = _props2$initialListSi === undefined ? Math.min(20, this.props.dataSource.getRowCount()) : _props2$initialListSi,
          showQuickSearchIndicator = _props2.showQuickSearchIndicator,
          _renderSectionHeader = _props2.renderSectionHeader,
          sectionHeaderClassName = _props2.sectionHeaderClassName,
          other = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['className', 'prefixCls', 'children', 'quickSearchBarTop', 'quickSearchBarStyle', 'initialListSize', 'showQuickSearchIndicator', 'renderSectionHeader', 'sectionHeaderClassName']);

      // initialListSize={this.props.dataSource.getRowCount()}


      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: prefixCls + '-container' },
        _delay && this.props.delayActivityIndicator,
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__ListView__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, other, {
            ref: 'indexedListView',
            className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(prefixCls, className),
            initialListSize: initialListSize,
            pageSize: pageSize,
            renderSectionHeader: function renderSectionHeader(sectionData, sectionID) {
              return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(_renderSectionHeader(sectionData, sectionID), {
                ref: function ref(c) {
                  return _this3.sectionComponents[sectionID] = c;
                },
                className: sectionHeaderClassName || prefixCls + '-section-header'
              });
            }
          }),
          children
        ),
        this.renderQuickSearchBar(quickSearchBarTop, quickSearchBarStyle),
        showQuickSearchIndicator ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-qsindicator', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-qsindicator-hide', !showQuickSearchIndicator || !this.state.showQuickSearchIndicator), _classNames)), ref: 'qsIndicator'
        }) : null
      );
    }
  }]);

  return IndexedList;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

IndexedList.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__ListView__["a" /* default */].propTypes, {
  children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  sectionHeaderClassName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  quickSearchBarTop: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  quickSearchBarStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  onQuickSearch: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  showQuickSearchIndicator: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
});
IndexedList.defaultProps = {
  prefixCls: 'rmc-indexed-list',
  quickSearchBarTop: { value: '#', label: '#' },
  onQuickSearch: function onQuickSearch() {},
  showQuickSearchIndicator: false,
  delayTime: 100,
  // delayActivityIndicator: <div style={{padding: 5, textAlign: 'center'}}>rendering more</div>,
  delayActivityIndicator: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onQuickSearchTop = function (sectionID, topId) {
    if (_this4.props.stickyHeader) {
      setDocumentScrollTop(0);
    } else {
      __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this4.refs.indexedListView.refs.listviewscroll).scrollTop = 0;
    }
    _this4.props.onQuickSearch(sectionID, topId);
  };

  this.onQuickSearch = function (sectionID) {
    var lv = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this4.refs.indexedListView.refs.listviewscroll);
    var sec = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(_this4.sectionComponents[sectionID]);
    if (_this4.props.stickyHeader) {
      // react-sticky 会把 header 设置为 fixed ，但提供了 placeholder 记忆原来位置
      var stickyComponent = _this4.refs.indexedListView.stickyRefs[sectionID];
      if (stickyComponent && stickyComponent.refs.placeholder) {
        sec = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(stickyComponent.refs.placeholder);
      }
      setDocumentScrollTop(sec.getBoundingClientRect().top - lv.getBoundingClientRect().top + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["a" /* getOffsetTop */])(lv));
    } else {
      lv.scrollTop += sec.getBoundingClientRect().top - lv.getBoundingClientRect().top;
    }
    _this4.props.onQuickSearch(sectionID);
  };

  this.onTouchStart = function (e) {
    _this4._target = e.target;
    _this4._basePos = _this4.refs.quickSearchBar.getBoundingClientRect();
    document.addEventListener('touchmove', _this4._disableParent, false);
    document.body.className = document.body.className + ' ' + _this4.props.prefixCls + '-qsb-moving';
    _this4.updateIndicator(_this4._target);
  };

  this.onTouchMove = function (e) {
    e.preventDefault();
    if (_this4._target) {
      var ex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util__["b" /* _event */])(e);
      var basePos = _this4._basePos;
      var _pos = void 0;
      if (ex.clientY >= basePos.top && ex.clientY <= basePos.top + _this4._qsHeight) {
        _pos = Math.floor((ex.clientY - basePos.top) / _this4._avgH);
        var target = void 0;
        if (_pos in _this4._hCache) {
          target = _this4._hCache[_pos][0];
        }
        if (target) {
          var overValue = target.getAttribute('data-qf-target');
          if (_this4._target !== target) {
            if (_this4.props.quickSearchBarTop.value === overValue) {
              _this4.onQuickSearchTop(undefined, overValue);
            } else {
              _this4.onQuickSearch(overValue);
            }
            _this4.updateIndicator(target);
          }
          _this4._target = target;
        }
      }
    }
  };

  this.onTouchEnd = function () {
    if (!_this4._target) {
      return;
    }
    document.removeEventListener('touchmove', _this4._disableParent, false);
    document.body.className = document.body.className.replace(new RegExp('\\s*' + _this4.props.prefixCls + '-qsb-moving', 'g'), '');
    _this4.updateIndicator(_this4._target, true);
    _this4._target = null;
  };

  this.getQsInfo = function () {
    var quickSearchBar = _this4.refs.quickSearchBar;
    var height = quickSearchBar.offsetHeight;
    var hCache = [];
    [].slice.call(quickSearchBar.querySelectorAll('[data-qf-target]')).forEach(function (d) {
      hCache.push([d]);
    });
    var _avgH = height / hCache.length;
    var _top = 0;
    for (var i = 0, len = hCache.length; i < len; i++) {
      _top = i * _avgH;
      hCache[i][1] = [_top, _top + _avgH];
    }
    _this4._qsHeight = height;
    _this4._avgH = _avgH;
    _this4._hCache = hCache;
  };

  this.sectionComponents = {};

  this.dataChange = function (props) {
    // delay render more
    var rowCount = props.dataSource.getRowCount();
    if (!rowCount) {
      return;
    }
    _this4.setState({
      _delay: true
    });
    if (_this4._timer) {
      clearTimeout(_this4._timer);
    }
    _this4._timer = setTimeout(function () {
      _this4.setState({
        pageSize: rowCount,
        _delay: false
      }, function () {
        return _this4.refs.indexedListView._pageInNewRows();
      });
    }, props.delayTime);
  };

  this.updateIndicator = function (ele, end) {
    var el = ele;
    if (!el.getAttribute('data-qf-target')) {
      el = el.parentNode;
    }
    if (_this4.props.showQuickSearchIndicator) {
      _this4.refs.qsIndicator.innerText = el.innerText.trim();
      _this4.setState({
        showQuickSearchIndicator: true
      });
      if (_this4._indicatorTimer) {
        clearTimeout(_this4._indicatorTimer);
      }
      _this4._indicatorTimer = setTimeout(function () {
        _this4.setState({
          showQuickSearchIndicator: false
        });
      }, 1000);
    }

    var cls = _this4.props.prefixCls + '-quick-search-bar-over';
    // can not use setState to change className, it has a big performance issue!
    _this4._hCache.forEach(function (d) {
      d[0].className = d[0].className.replace(cls, '');
    });
    if (!end) {
      el.className = el.className + ' ' + cls;
    }
  };

  this._disableParent = function (e) {
    e.preventDefault();
    e.stopPropagation();
  };
};

/* harmony default export */ __webpack_exports__["a"] = (IndexedList);

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_isEmpty__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fbjs_lib_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);






function defaultGetRowData(dataBlob, sectionID, rowID) {
  return dataBlob[sectionID][rowID];
}

function defaultGetSectionHeaderData(dataBlob, sectionID) {
  return dataBlob[sectionID];
}

// type differType = (data1, data2) => bool;
//
// type ParamType = {
//   rowHasChanged: differType;
//   getRowData: ?typeof defaultGetRowData;
//   sectionHeaderHasChanged: ?differType;
//   getSectionHeaderData: ?typeof defaultGetSectionHeaderData;
// }

/**
 * Provides efficient data processing and access to the
 * `ListView` component.  A `ListViewDataSource` is created with functions for
 * extracting data from the input blob, and comparing elements (with default
 * implementations for convenience).  The input blob can be as simple as an
 * array of strings, or an object with rows nested inside section objects.
 *
 * To update the data in the datasource, use `cloneWithRows` (or
 * `cloneWithRowsAndSections` if you care about sections).  The data in the
 * data source is immutable, so you can't modify it directly.  The clone methods
 * suck in the new data and compute a diff for each row so ListView knows
 * whether to re-render it or not.
 *
 * In this example, a component receives data in chunks, handled by
 * `_onDataArrived`, which concats the new data onto the old data and updates the
 * data source.  We use `concat` to create a new array - mutating `this._data`,
 * e.g. with `this._data.push(newRowData)`, would be an error. `_rowHasChanged`
 * understands the shape of the row data and knows how to efficiently compare
 * it.
 *
 * ```
 * getInitialState: function() {
 *   var ds = new ListViewDataSource({rowHasChanged: this._rowHasChanged});
 *   return {ds};
 * },
 * _onDataArrived(newData) {
 *   this._data = this._data.concat(newData);
 *   this.setState({
 *     ds: this.state.ds.cloneWithRows(this._data)
 *   });
 * }
 * ```
 */

var ListViewDataSource = function () {

  /**
   * You can provide custom extraction and `hasChanged` functions for section
   * headers and rows.  If absent, data will be extracted with the
   * `defaultGetRowData` and `defaultGetSectionHeaderData` functions.
   *
   * The default extractor expects data of one of the following forms:
   *
   *      { sectionID_1: { rowID_1: <rowData1>, ... }, ... }
   *
   *    or
   *
   *      { sectionID_1: [ <rowData1>, <rowData2>, ... ], ... }
   *
   *    or
   *
   *      [ [ <rowData1>, <rowData2>, ... ], ... ]
   *
   * The constructor takes in a params argument that can contain any of the
   * following:
   *
   * - getRowData(dataBlob, sectionID, rowID);
   * - getSectionHeaderData(dataBlob, sectionID);
   * - rowHasChanged(prevRowData, nextRowData);
   * - sectionHeaderHasChanged(prevSectionData, nextSectionData);
   */
  function ListViewDataSource(params) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ListViewDataSource);

    __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(params && typeof params.rowHasChanged === 'function', 'Must provide a rowHasChanged function.');
    this._rowHasChanged = params.rowHasChanged;
    this._getRowData = params.getRowData || defaultGetRowData;
    this._sectionHeaderHasChanged = params.sectionHeaderHasChanged;
    this._getSectionHeaderData = params.getSectionHeaderData || defaultGetSectionHeaderData;

    this._dataBlob = null;
    this._dirtyRows = [];
    this._dirtySections = [];
    this._cachedRowCount = 0;

    // These two private variables are accessed by outsiders because ListView
    // uses them to iterate over the data in this class.
    this.rowIdentities = [];
    this.sectionIdentities = [];
  }

  /**
   * Clones this `ListViewDataSource` with the specified `dataBlob` and
   * `rowIdentities`. The `dataBlob` is just an arbitrary blob of data. At
   * construction an extractor to get the interesting information was defined
   * (or the default was used).
   *
   * The `rowIdentities` is is a 2D array of identifiers for rows.
   * ie. [['a1', 'a2'], ['b1', 'b2', 'b3'], ...].  If not provided, it's
   * assumed that the keys of the section data are the row identities.
   *
   * Note: This function does NOT clone the data in this data source. It simply
   * passes the functions defined at construction to a new data source with
   * the data specified. If you wish to maintain the existing data you must
   * handle merging of old and new data separately and then pass that into
   * this function as the `dataBlob`.
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ListViewDataSource, [{
    key: 'cloneWithRows',
    value: function cloneWithRows(dataBlob, rowIdentities) {
      var rowIds = rowIdentities ? [rowIdentities] : null;
      if (!this._sectionHeaderHasChanged) {
        this._sectionHeaderHasChanged = function () {
          return false;
        };
      }
      return this.cloneWithRowsAndSections({ s1: dataBlob }, ['s1'], rowIds);
    }

    /**
     * This performs the same function as the `cloneWithRows` function but here
     * you also specify what your `sectionIdentities` are. If you don't care
     * about sections you should safely be able to use `cloneWithRows`.
     *
     * `sectionIdentities` is an array of identifiers for  sections.
     * ie. ['s1', 's2', ...].  If not provided, it's assumed that the
     * keys of dataBlob are the section identities.
     *
     * Note: this returns a new object!
     */

  }, {
    key: 'cloneWithRowsAndSections',
    value: function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(typeof this._sectionHeaderHasChanged === 'function', 'Must provide a sectionHeaderHasChanged function with section data.');
      __WEBPACK_IMPORTED_MODULE_2_fbjs_lib_invariant___default()(!sectionIdentities || !rowIdentities || sectionIdentities.length === rowIdentities.length, 'row and section ids lengths must be the same');

      var newSource = new ListViewDataSource({
        getRowData: this._getRowData,
        getSectionHeaderData: this._getSectionHeaderData,
        rowHasChanged: this._rowHasChanged,
        sectionHeaderHasChanged: this._sectionHeaderHasChanged
      });
      newSource._dataBlob = dataBlob;
      if (sectionIdentities) {
        newSource.sectionIdentities = sectionIdentities;
      } else {
        newSource.sectionIdentities = Object.keys(dataBlob);
      }
      if (rowIdentities) {
        newSource.rowIdentities = rowIdentities;
      } else {
        newSource.rowIdentities = [];
        newSource.sectionIdentities.forEach(function (sectionID) {
          newSource.rowIdentities.push(Object.keys(dataBlob[sectionID]));
        });
      }
      newSource._cachedRowCount = countRows(newSource.rowIdentities);

      newSource._calculateDirtyArrays(this._dataBlob, this.sectionIdentities, this.rowIdentities);

      return newSource;
    }
  }, {
    key: 'getRowCount',
    value: function getRowCount() {
      return this._cachedRowCount;
    }
  }, {
    key: 'getRowAndSectionCount',
    value: function getRowAndSectionCount() {
      return this._cachedRowCount + this.sectionIdentities.length;
    }

    /**
     * Returns if the row is dirtied and needs to be rerendered
     */

  }, {
    key: 'rowShouldUpdate',
    value: function rowShouldUpdate(sectionIndex, rowIndex) {
      var needsUpdate = this._dirtyRows[sectionIndex][rowIndex];
      __WEBPACK_IMPORTED_MODULE_4_warning___default()(needsUpdate !== undefined, 'missing dirtyBit for section, row: ' + sectionIndex + ', ' + rowIndex);
      return needsUpdate;
    }

    /**
     * Gets the data required to render the row.
     */

  }, {
    key: 'getRowData',
    value: function getRowData(sectionIndex, rowIndex) {
      var sectionID = this.sectionIdentities[sectionIndex];
      var rowID = this.rowIdentities[sectionIndex][rowIndex];
      __WEBPACK_IMPORTED_MODULE_4_warning___default()(sectionID !== undefined && rowID !== undefined, 'rendering invalid section, row: ' + sectionIndex + ', ' + rowIndex);
      return this._getRowData(this._dataBlob, sectionID, rowID);
    }

    /**
     * Gets the rowID at index provided if the dataSource arrays were flattened,
     * or null of out of range indexes.
     */

  }, {
    key: 'getRowIDForFlatIndex',
    value: function getRowIDForFlatIndex(index) {
      var accessIndex = index;
      for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
        if (accessIndex >= this.rowIdentities[ii].length) {
          accessIndex -= this.rowIdentities[ii].length;
        } else {
          return this.rowIdentities[ii][accessIndex];
        }
      }
      return null;
    }

    /**
     * Gets the sectionID at index provided if the dataSource arrays were flattened,
     * or null for out of range indexes.
     */

  }, {
    key: 'getSectionIDForFlatIndex',
    value: function getSectionIDForFlatIndex(index) {
      var accessIndex = index;
      for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
        if (accessIndex >= this.rowIdentities[ii].length) {
          accessIndex -= this.rowIdentities[ii].length;
        } else {
          return this.sectionIdentities[ii];
        }
      }
      return null;
    }

    /**
     * Returns an array containing the number of rows in each section
     */

  }, {
    key: 'getSectionLengths',
    value: function getSectionLengths() {
      var results = [];
      for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
        results.push(this.rowIdentities[ii].length);
      }
      return results;
    }

    /**
     * Returns if the section header is dirtied and needs to be rerendered
     */

  }, {
    key: 'sectionHeaderShouldUpdate',
    value: function sectionHeaderShouldUpdate(sectionIndex) {
      var needsUpdate = this._dirtySections[sectionIndex];
      __WEBPACK_IMPORTED_MODULE_4_warning___default()(needsUpdate !== undefined, 'missing dirtyBit for section: ' + sectionIndex);
      return needsUpdate;
    }

    /**
     * Gets the data required to render the section header
     */

  }, {
    key: 'getSectionHeaderData',
    value: function getSectionHeaderData(sectionIndex) {
      if (!this._getSectionHeaderData) {
        return null;
      }
      var sectionID = this.sectionIdentities[sectionIndex];
      __WEBPACK_IMPORTED_MODULE_4_warning___default()(sectionID !== undefined, 'renderSection called on invalid section: ' + sectionIndex);
      return this._getSectionHeaderData(this._dataBlob, sectionID);
    }

    /**
     * Private members and methods.
     */

    // These two 'protected' variables are accessed by ListView to iterate over
    // the data in this class.

  }, {
    key: '_calculateDirtyArrays',
    value: function _calculateDirtyArrays(prevDataBlob, prevSectionIDs, prevRowIDs) {
      // construct a hashmap of the existing (old) id arrays
      var prevSectionsHash = keyedDictionaryFromArray(prevSectionIDs);
      var prevRowsHash = {};
      for (var ii = 0; ii < prevRowIDs.length; ii++) {
        var sectionID = prevSectionIDs[ii];
        __WEBPACK_IMPORTED_MODULE_4_warning___default()(!prevRowsHash[sectionID], 'SectionID appears more than once: ' + sectionID);
        prevRowsHash[sectionID] = keyedDictionaryFromArray(prevRowIDs[ii]);
      }

      // compare the 2 identity array and get the dirtied rows
      this._dirtySections = [];
      this._dirtyRows = [];

      var dirty;
      for (var sIndex = 0; sIndex < this.sectionIdentities.length; sIndex++) {
        var sectionID = this.sectionIdentities[sIndex];
        // dirty if the sectionHeader is new or _sectionHasChanged is true
        dirty = !prevSectionsHash[sectionID];
        var sectionHeaderHasChanged = this._sectionHeaderHasChanged;
        if (!dirty && sectionHeaderHasChanged) {
          dirty = sectionHeaderHasChanged(this._getSectionHeaderData(prevDataBlob, sectionID), this._getSectionHeaderData(this._dataBlob, sectionID));
        }
        this._dirtySections.push(!!dirty);

        this._dirtyRows[sIndex] = [];
        for (var rIndex = 0; rIndex < this.rowIdentities[sIndex].length; rIndex++) {
          var rowID = this.rowIdentities[sIndex][rIndex];
          // dirty if the section is new, row is new or _rowHasChanged is true
          dirty = !prevSectionsHash[sectionID] || !prevRowsHash[sectionID][rowID] || this._rowHasChanged(this._getRowData(prevDataBlob, sectionID, rowID), this._getRowData(this._dataBlob, sectionID, rowID));
          this._dirtyRows[sIndex].push(!!dirty);
        }
      }
    }
  }]);

  return ListViewDataSource;
}();

function countRows(allRowIDs) {
  var totalRows = 0;
  for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
    var rowIDs = allRowIDs[sectionIdx];
    totalRows += rowIDs.length;
  }
  return totalRows;
}

function keyedDictionaryFromArray(arr) {
  if (__WEBPACK_IMPORTED_MODULE_3_fbjs_lib_isEmpty___default()(arr)) {
    return {};
  }
  var result = {};
  for (var ii = 0; ii < arr.length; ii++) {
    var key = arr[ii];
    __WEBPACK_IMPORTED_MODULE_4_warning___default()(!result[key], 'Value appears more than once in array: ' + key);
    result[key] = true;
  }
  return result;
}

// module.exports = ListViewDataSource;
/* harmony default export */ __webpack_exports__["a"] = (ListViewDataSource);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);









var propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  icon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  loading: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  distanceToRefresh: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  refreshing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onRefresh: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
};

var RefreshControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RefreshControl, _React$Component);

  function RefreshControl(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RefreshControl);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RefreshControl.__proto__ || Object.getPrototypeOf(RefreshControl)).call(this, props));

    _this.state = {
      active: false,
      deactive: false,
      loadingState: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RefreshControl, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          style = _props.style,
          icon = _props.icon,
          loading = _props.loading,
          refreshing = _props.refreshing;
      var _state = this.state,
          active = _state.active,
          deactive = _state.deactive,
          loadingState = _state.loadingState;

      var wrapCls = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-ptr', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-active', active), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-deactive', deactive), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-loading', loadingState || refreshing), _classNames));
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { ref: 'ptr', className: wrapCls, style: style },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: prefixCls + '-ptr-icon' },
          icon
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: prefixCls + '-ptr-loading' },
          loading
        )
      );
    }
  }]);

  return RefreshControl;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

RefreshControl.propTypes = propTypes;
RefreshControl.defaultProps = {
  prefixCls: 'list-view-refresh-control',
  distanceToRefresh: 50,
  refreshing: false,
  icon: [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { key: '0', className: 'list-view-refresh-control-pull' },
    '\u2193 \u4E0B\u62C9'
  ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    { key: '1', className: 'list-view-refresh-control-release' },
    '\u2191 \u91CA\u653E'
  )],
  loading: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    'div',
    null,
    'loading...'
  )
};
/* harmony default export */ __webpack_exports__["a"] = (RefreshControl);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_zscroller__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(605);













var SCROLLVIEW = 'ScrollView';
var INNERVIEW = 'InnerScrollView';

// https://github.com/facebook/react-native/blob/0.26-stable/Libraries/Components/ScrollView/ScrollView.js

/* eslint react/prop-types: 0, react/sort-comp: 0, no-unused-expressions: 0 */

var propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  listPrefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  listViewPrefixCls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  contentContainerStyle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  onScroll: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  scrollEventThrottle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  refreshControl: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element
};
var styles = {
  base: {
    position: 'relative',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    flex: 1
  },
  zScroller: {
    position: 'relative',
    overflow: 'hidden',
    flex: 1
  }
};

var ScrollView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ScrollView, _React$Component);

  function ScrollView() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ScrollView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ScrollView.__proto__ || Object.getPrototypeOf(ScrollView)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ScrollView, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      // https://github.com/ant-design/ant-design-mobile/issues/1480
      // https://stackoverflow.com/questions/1386696/make-scrollleft-scrolltop-changes-not-trigger-scroll-event
      // 问题情景：用户滚动内容后，改变 dataSource 触发 ListView componentWillReceiveProps
      // 内容变化后 scrollTop 如果改变、会自动触发 scroll 事件，而此事件应该避免被执行
      if ((this.props.dataSource !== nextProps.dataSource || this.props.initialListSize !== nextProps.initialListSize) && this.tsExec) {
        // console.log('componentWillUpdate');
        if (this.props.stickyHeader || this.props.useBodyScroll) {
          window.removeEventListener('scroll', this.tsExec);
        } else if (!this.props.useZscroller) {
          // not handle useZscroller now. todo
          __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs[SCROLLVIEW]).removeEventListener('scroll', this.tsExec);
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      // console.log('componentDidUpdate');
      if (prevProps.refreshControl && this.props.refreshControl) {
        var preRefreshing = prevProps.refreshControl.props.refreshing;
        var nowRefreshing = this.props.refreshControl.props.refreshing;
        if (preRefreshing && !nowRefreshing && this.refreshControlRefresh) {
          this.refreshControlRefresh();
        } else if (!this.manuallyRefresh && !preRefreshing && nowRefreshing) {
          this.domScroller.scroller.triggerPullToRefresh();
        }
      }
      // handle componentWillUpdate accordingly
      if ((this.props.dataSource !== prevProps.dataSource || this.props.initialListSize !== prevProps.initialListSize) && this.tsExec) {
        // console.log('componentDidUpdate');
        setTimeout(function () {
          if (_this2.props.stickyHeader || _this2.props.useBodyScroll) {
            window.addEventListener('scroll', _this2.tsExec);
          } else if (!_this2.props.useZscroller) {
            // not handle useZscroller now. todo
            __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(_this2.refs[SCROLLVIEW]).addEventListener('scroll', _this2.tsExec);
          }
        }, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.tsExec = this.throttleScroll();
      // IE supports onresize on all HTML elements.
      // In all other Browsers the onresize is only available at the window object
      this.onLayout = function () {
        return _this3.props.onLayout({
          nativeEvent: { layout: { width: window.innerWidth, height: window.innerHeight } }
        });
      };
      var ele = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs[SCROLLVIEW]);

      if (this.props.stickyHeader || this.props.useBodyScroll) {
        window.addEventListener('scroll', this.tsExec);
        window.addEventListener('resize', this.onLayout);
        // todo
        // ele.addEventListener('resize', this.onContentSizeChange);
      } else {
        // todo
        // ele.addEventListener('resize', this.onLayout);
        // ReactDOM.findDOMNode(this.refs[INNERVIEW])
        // .addEventListener('resize', this.onContentSizeChange);
        if (this.props.useZscroller) {
          this.renderZscroller();
        } else {
          ele.addEventListener('scroll', this.tsExec);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.stickyHeader || this.props.useBodyScroll) {
        window.removeEventListener('scroll', this.tsExec);
        window.removeEventListener('resize', this.onLayout);
      } else if (this.props.useZscroller) {
        this.domScroller.destroy();
      } else {
        __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this.refs[SCROLLVIEW]).removeEventListener('scroll', this.tsExec);
      }
    }
  }, {
    key: 'renderZscroller',
    value: function renderZscroller() {
      var _this4 = this;

      var _props = this.props,
          scrollerOptions = _props.scrollerOptions,
          refreshControl = _props.refreshControl;

      var _scrollingComplete = scrollerOptions.scrollingComplete,
          _onScroll = scrollerOptions.onScroll,
          restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(scrollerOptions, ['scrollingComplete', 'onScroll']);
      // console.log(scrollingComplete, onScroll, restProps);
      // console.log('onRefresh will not change', refreshControl.props.onRefresh.toString());


      this.domScroller = new __WEBPACK_IMPORTED_MODULE_9_zscroller__["a" /* default */](this.getInnerViewNode(), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        scrollingX: false,
        onScroll: function onScroll() {
          _this4.tsExec();
          if (_onScroll) {
            _onScroll();
          }
        },
        scrollingComplete: function scrollingComplete() {
          _this4.scrollingComplete();
          if (_scrollingComplete) {
            _scrollingComplete();
          }
        }
      }, restProps));
      if (refreshControl) {
        var scroller = this.domScroller.scroller;
        var _refreshControl$props = refreshControl.props,
            distanceToRefresh = _refreshControl$props.distanceToRefresh,
            onRefresh = _refreshControl$props.onRefresh;

        scroller.activatePullToRefresh(distanceToRefresh, function () {
          // console.log('first reach the distance');
          _this4.manuallyRefresh = true;
          _this4.overDistanceThenRelease = false;
          _this4.refs.refreshControl && _this4.refs.refreshControl.setState({ active: true });
        }, function () {
          // console.log('back to the distance', this.overDistanceThenRelease);
          _this4.manuallyRefresh = false;
          _this4.refs.refreshControl && _this4.refs.refreshControl.setState({
            deactive: _this4.overDistanceThenRelease,
            active: false,
            loadingState: false
          });
        }, function () {
          // console.log('Over distance and release to loading');
          _this4.overDistanceThenRelease = true;
          _this4.refs.refreshControl && _this4.refs.refreshControl.setState({
            deactive: false,
            loadingState: true
          });
          var finishPullToRefresh = function finishPullToRefresh() {
            scroller.finishPullToRefresh();
            _this4.refreshControlRefresh = null;
          };
          Promise.all([new Promise(function (resolve) {
            onRefresh();
            _this4.refreshControlRefresh = resolve;
          }),
          // at lease 1s for ux
          new Promise(function (resolve) {
            return setTimeout(resolve, 1000);
          })]).then(finishPullToRefresh, finishPullToRefresh);
        });
        if (refreshControl.props.refreshing) {
          scroller.triggerPullToRefresh();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          _props2$prefixCls = _props2.prefixCls,
          prefixCls = _props2$prefixCls === undefined ? '' : _props2$prefixCls,
          _props2$listPrefixCls = _props2.listPrefixCls,
          listPrefixCls = _props2$listPrefixCls === undefined ? '' : _props2$listPrefixCls,
          _props2$listViewPrefi = _props2.listViewPrefixCls,
          listViewPrefixCls = _props2$listViewPrefi === undefined ? 'rmc-list-view' : _props2$listViewPrefi,
          _props2$style = _props2.style,
          style = _props2$style === undefined ? {} : _props2$style,
          _props2$contentContai = _props2.contentContainerStyle,
          contentContainerStyle = _props2$contentContai === undefined ? {} : _props2$contentContai,
          useZscroller = _props2.useZscroller,
          refreshControl = _props2.refreshControl,
          stickyHeader = _props2.stickyHeader,
          useBodyScroll = _props2.useBodyScroll;


      var styleBase = styles.base;
      if (stickyHeader || useBodyScroll) {
        styleBase = {};
      } else if (useZscroller) {
        styleBase = styles.zScroller;
      }

      var preCls = prefixCls || listViewPrefixCls || '';

      var containerProps = {
        ref: SCROLLVIEW,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, styleBase, style),
        className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(className, preCls + '-scrollview')
      };
      var contentContainerProps = {
        ref: INNERVIEW,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ position: 'absolute', minWidth: '100%' }, contentContainerStyle),
        className: __WEBPACK_IMPORTED_MODULE_10_classnames___default()(preCls + '-scrollview-content', listPrefixCls)
      };

      if (refreshControl) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          containerProps,
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'div',
            contentContainerProps,
            __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(refreshControl, { ref: 'refreshControl' }),
            children
          )
        );
      }

      if (stickyHeader || useBodyScroll) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          containerProps,
          children
        );
      }
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        containerProps,
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          contentContainerProps,
          children
        )
      );
    }
  }]);

  return ScrollView;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ScrollView.propTypes = propTypes;

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getInnerViewNode = function () {
    return __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(_this5.refs[INNERVIEW]);
  };

  this.scrollTo = function () {
    if (_this5.props.stickyHeader || _this5.props.useBodyScroll) {
      var _window;

      (_window = window).scrollTo.apply(_window, arguments);
    } else if (_this5.props.useZscroller) {
      var _domScroller$scroller;

      // it will change zScroller's dimensions on data loaded, so it needs fire reflow.
      _this5.domScroller.reflow();
      (_domScroller$scroller = _this5.domScroller.scroller).scrollTo.apply(_domScroller$scroller, arguments);
    } else {
      var ele = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(_this5.refs[SCROLLVIEW]);
      ele.scrollLeft = arguments.length <= 0 ? undefined : arguments[0];
      ele.scrollTop = arguments.length <= 1 ? undefined : arguments[1];
    }
  };

  this.throttleScroll = function () {
    var handleScroll = function handleScroll() {};
    if (_this5.props.scrollEventThrottle && _this5.props.onScroll) {
      handleScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util__["c" /* throttle */])(function (e) {
        _this5.props.onScroll && _this5.props.onScroll(e);
      }, _this5.props.scrollEventThrottle);
    }
    return handleScroll;
  };

  this.scrollingComplete = function () {
    // console.log('scrolling complete');
    if (_this5.props.refreshControl && _this5.refs.refreshControl && _this5.refs.refreshControl.state.deactive) {
      _this5.refs.refreshControl.setState({ deactive: false });
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ScrollView);

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1582), __esModule: true };

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1583), __esModule: true };

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1585), __esModule: true };

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1586), __esModule: true };

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1587), __esModule: true };

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1607);
module.exports = __webpack_require__(120).Object.assign;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1608);
var $Object = __webpack_require__(120).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1609);
var $Object = __webpack_require__(120).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1610);
module.exports = __webpack_require__(120).Object.setPrototypeOf;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1613);
__webpack_require__(1611);
__webpack_require__(1614);
__webpack_require__(1615);
module.exports = __webpack_require__(120).Symbol;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1612);
__webpack_require__(1616);
module.exports = __webpack_require__(380).f('iterator');

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(124)
  , toLength  = __webpack_require__(1605)
  , toIndex   = __webpack_require__(1604);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(189)
  , gOPS    = __webpack_require__(373)
  , pIE     = __webpack_require__(227);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(109).document && document.documentElement;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(609);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(372)
  , descriptor     = __webpack_require__(228)
  , setToStringTag = __webpack_require__(374)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(149)(IteratorPrototype, __webpack_require__(150)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(189)
  , toIObject = __webpack_require__(124);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(229)('meta')
  , isObject = __webpack_require__(188)
  , has      = __webpack_require__(122)
  , setDesc  = __webpack_require__(123).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(187)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(189)
  , gOPS     = __webpack_require__(373)
  , pIE      = __webpack_require__(227)
  , toObject = __webpack_require__(619)
  , IObject  = __webpack_require__(613)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(187)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(123)
  , anObject = __webpack_require__(186)
  , getKeys  = __webpack_require__(189);

module.exports = __webpack_require__(121) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(124)
  , gOPN      = __webpack_require__(616).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(122)
  , toObject    = __webpack_require__(619)
  , IE_PROTO    = __webpack_require__(375)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(188)
  , anObject = __webpack_require__(186);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(610)(Function.call, __webpack_require__(615).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(377)
  , defined   = __webpack_require__(368);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(377)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(377)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1589)
  , step             = __webpack_require__(1595)
  , Iterators        = __webpack_require__(370)
  , toIObject        = __webpack_require__(124);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(614)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(148);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(1598)});

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(148)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(372)});

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(148);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(121), 'Object', {defineProperty: __webpack_require__(123).f});

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(148);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1602).set});

/***/ }),
/* 1611 */
/***/ (function(module, exports) {



/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(1603)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(614)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(109)
  , has            = __webpack_require__(122)
  , DESCRIPTORS    = __webpack_require__(121)
  , $export        = __webpack_require__(148)
  , redefine       = __webpack_require__(618)
  , META           = __webpack_require__(1597).KEY
  , $fails         = __webpack_require__(187)
  , shared         = __webpack_require__(376)
  , setToStringTag = __webpack_require__(374)
  , uid            = __webpack_require__(229)
  , wks            = __webpack_require__(150)
  , wksExt         = __webpack_require__(380)
  , wksDefine      = __webpack_require__(379)
  , keyOf          = __webpack_require__(1596)
  , enumKeys       = __webpack_require__(1591)
  , isArray        = __webpack_require__(1593)
  , anObject       = __webpack_require__(186)
  , toIObject      = __webpack_require__(124)
  , toPrimitive    = __webpack_require__(378)
  , createDesc     = __webpack_require__(228)
  , _create        = __webpack_require__(372)
  , gOPNExt        = __webpack_require__(1600)
  , $GOPD          = __webpack_require__(615)
  , $DP            = __webpack_require__(123)
  , $keys          = __webpack_require__(189)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(616).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(227).f  = $propertyIsEnumerable;
  __webpack_require__(373).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(371)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(149)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(379)('asyncIterator');

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(379)('observable');

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1606);
var global        = __webpack_require__(109)
  , hide          = __webpack_require__(149)
  , Iterators     = __webpack_require__(370)
  , TO_STRING_TAG = __webpack_require__(150)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* eslint-disable fb-www/typeof-undefined */
/* eslint-disable no-unused-vars */

var invariant = __webpack_require__(620);

/**
 * Checks if a value is empty.
 */
function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === 'object') {
    if (value) {
      !(!isIterable(value) || value.size === undefined) ?  false ? invariant(false, 'isEmpty() does not support iterable collections.') : invariant(false) : void 0;
      for (var _ in value) {
        return false;
      }
    }
    return true;
  } else {
    return !value;
  }
}

function isIterable(value) {
  if (typeof Symbol === 'undefined') {
    return false;
  }
  return value[Symbol.iterator];
}

module.exports = isEmpty;

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*
 * Scroller
 * http://github.com/zynga/scroller
 *
 * Copyright 2011, Zynga Inc.
 * Licensed under the MIT License.
 * https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
 *
 * Based on the work of: Unify Project (unify-project.org)
 * http://unify-project.org
 * Copyright 2011, Deutsche Telekom AG
 * License: MIT + Apache (V2)
 */

/**
 * Generic animation class with support for dropped frames both optional easing and duration.
 *
 * Optional duration is useful when the lifetime is defined by another condition than time
 * e.g. speed of an animating object, etc.
 *
 * Dropped frame logic allows to keep using the same updater logic independent from the actual
 * rendering. This eases a lot of cases where it might be pretty complex to break down a state
 * based on the pure time difference.
 */
var desiredFrames = 60;
var millisecondsPerSecond = 1000;
var running = {};
var counter = 1;
var win = typeof window !== 'undefined' ? window : undefined;

if (!win) {
  win = typeof global !== 'undefined' ? global : {};
}

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller
// fixes from Paul Irish and Tino Zijdel
(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !win.requestAnimationFrame; ++x) {
    win.requestAnimationFrame = win[vendors[x] + 'RequestAnimationFrame'];
    win.cancelAnimationFrame = win[vendors[x] + 'CancelAnimationFrame'] || win[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!win.requestAnimationFrame) {
    win.requestAnimationFrame = function (callback) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = win.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!win.cancelAnimationFrame) {
    win.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
})();

var Animate = {
  /**
   * Stops the given animation.
   *
   * @param id {Integer} Unique animation ID
   * @return {Boolean} Whether the animation was stopped (aka, was running before)
   */
  stop: function stop(id) {
    var cleared = running[id] != null;
    if (cleared) {
      running[id] = null;
    }

    return cleared;
  },

  /**
   * Whether the given animation is still running.
   *
   * @param id {Integer} Unique animation ID
   * @return {Boolean} Whether the animation is still running
   */
  isRunning: function isRunning(id) {
    return running[id] != null;
  },

  /**
   * Start the animation.
   *
   * @param stepCallback {Function} Pointer to function which is executed on every step.
   *   Signature of the method should be `function(percent, now, virtual) { return continueWithAnimation; }`
   * @param verifyCallback {Function} Executed before every animation step.
   *   Signature of the method should be `function() { return continueWithAnimation; }`
   * @param completedCallback {Function}
   *   Signature of the method should be `function(droppedFrames, finishedAnimation) {}`
   * @param duration {Integer} Milliseconds to run the animation
   * @param easingMethod {Function} Pointer to easing function
   *   Signature of the method should be `function(percent) { return modifiedValue; }`
   * @return {Integer} Identifier of animation. Can be used to stop it any time.
   */
  start: function start(stepCallback, verifyCallback, completedCallback, duration, easingMethod) {
    var start = +new Date();
    var lastFrame = start;
    var percent = 0;
    var dropCounter = 0;
    var id = counter++;

    // Compacting running db automatically every few new animations
    if (id % 20 === 0) {
      var newRunning = {};
      for (var usedId in running) {
        newRunning[usedId] = true;
      }
      running = newRunning;
    }

    // This is the internal step method which is called every few milliseconds
    var step = function step(virtual) {
      // Normalize virtual value
      var render = virtual !== true;

      // Get current time
      var now = +new Date();

      // Verification is executed before next animation step
      if (!running[id] || verifyCallback && !verifyCallback(id)) {

        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, false);
        return;
      }

      // For the current rendering to apply let's update omitted steps in memory.
      // This is important to bring internal state variables up-to-date with progress in time.
      if (render) {

        var droppedFrames = Math.round((now - lastFrame) / (millisecondsPerSecond / desiredFrames)) - 1;
        for (var j = 0; j < Math.min(droppedFrames, 4); j++) {
          step(true);
          dropCounter++;
        }
      }

      // Compute percent value
      if (duration) {
        percent = (now - start) / duration;
        if (percent > 1) {
          percent = 1;
        }
      }

      // Execute step callback, then...
      var value = easingMethod ? easingMethod(percent) : percent;
      if ((stepCallback(value, now, render) === false || percent === 1) && render) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, percent === 1 || duration == null);
      } else if (render) {
        lastFrame = now;
        win.requestAnimationFrame(step);
      }
    };

    // Mark as running
    running[id] = true;

    // Init first step
    win.requestAnimationFrame(step);

    // Return unique animation ID
    return id;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scroller__ = __webpack_require__(1620);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var MIN_INDICATOR_SIZE = 8;
var win = typeof window !== 'undefined' ? window : undefined;

if (!win) {
  win = typeof global !== 'undefined' ? global : {};
}

function setTransform(nodeStyle, value) {
  nodeStyle.transform = value;
  nodeStyle.webkitTransform = value;
  nodeStyle.MozTransform = value;
}

function setTransformOrigin(nodeStyle, value) {
  nodeStyle.transformOrigin = value;
  nodeStyle.webkitTransformOrigin = value;
  nodeStyle.MozTransformOrigin = value;
}

var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });
  win.addEventListener('test', null, opts);
} catch (e) {
  // empty
}

var isWebView = typeof navigator !== 'undefined' && /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);

function iOSWebViewFix(e, touchendFn) {
  // https://github.com/ant-design/ant-design-mobile/issues/573#issuecomment-339560829
  // iOS UIWebView issue, It seems no problem in WKWebView
  if (isWebView && e.changedTouches[0].clientY < 0) {
    touchendFn(new Event('touchend') || e);
  }
}

var willPreventDefault = supportsPassive ? { passive: false } : false;
var willNotPreventDefault = supportsPassive ? { passive: true } : false;

function addEventListener(target, type, fn, options) {
  target.addEventListener(type, fn, options);
  return function () {
    target.removeEventListener(type, fn, options);
  };
}

function DOMScroller(content) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var scrollbars = void 0;
  var indicators = void 0;
  var indicatorsSize = void 0;
  var scrollbarsSize = void 0;
  var indicatorsPos = void 0;
  var scrollbarsOpacity = void 0;
  var contentSize = void 0;
  var clientSize = void 0;

  this.content = content;
  var container = this.container = content.parentNode;
  this.options = _extends({}, options, {
    scrollingComplete: function scrollingComplete() {
      _this.clearScrollbarTimer();
      _this.timer = setTimeout(function () {
        if (_this._destroyed) {
          return;
        }
        if (options.scrollingComplete) {
          options.scrollingComplete();
        }
        if (scrollbars) {
          ['x', 'y'].forEach(function (k) {
            if (scrollbars[k]) {
              _this.setScrollbarOpacity(k, 0);
            }
          });
        }
      }, 0);
    }
  });

  if (this.options.scrollbars) {
    scrollbars = this.scrollbars = {};
    indicators = this.indicators = {};
    indicatorsSize = this.indicatorsSize = {};
    scrollbarsSize = this.scrollbarsSize = {};
    indicatorsPos = this.indicatorsPos = {};
    scrollbarsOpacity = this.scrollbarsOpacity = {};
    contentSize = this.contentSize = {};
    clientSize = this.clientSize = {};

    ['x', 'y'].forEach(function (k) {
      var optionName = k === 'x' ? 'scrollingX' : 'scrollingY';
      if (_this.options[optionName] !== false) {
        scrollbars[k] = document.createElement('div');
        scrollbars[k].className = 'zscroller-scrollbar-' + k;
        indicators[k] = document.createElement('div');
        indicators[k].className = 'zscroller-indicator-' + k;
        scrollbars[k].appendChild(indicators[k]);
        indicatorsSize[k] = -1;
        scrollbarsOpacity[k] = 0;
        indicatorsPos[k] = 0;
        container.appendChild(scrollbars[k]);
      }
    });
  }

  var init = true;
  var contentStyle = content.style;

  // create Scroller instance
  this.scroller = new __WEBPACK_IMPORTED_MODULE_0__Scroller__["a" /* default */](function (left, top, zoom) {
    if (!init && options.onScroll) {
      options.onScroll();
    }
    setTransform(contentStyle, 'translate3d(' + -left + 'px,' + -top + 'px,0) scale(' + zoom + ')');
    if (scrollbars) {
      ['x', 'y'].forEach(function (k) {
        if (scrollbars[k]) {
          var pos = k === 'x' ? left : top;
          if (clientSize[k] >= contentSize[k]) {
            _this.setScrollbarOpacity(k, 0);
          } else {
            if (!init) {
              _this.setScrollbarOpacity(k, 1);
            }
            var normalIndicatorSize = clientSize[k] / contentSize[k] * scrollbarsSize[k];
            var size = normalIndicatorSize;
            var indicatorPos = void 0;
            if (pos < 0) {
              size = Math.max(normalIndicatorSize + pos, MIN_INDICATOR_SIZE);
              indicatorPos = 0;
            } else if (pos > contentSize[k] - clientSize[k]) {
              size = Math.max(normalIndicatorSize + contentSize[k] - clientSize[k] - pos, MIN_INDICATOR_SIZE);
              indicatorPos = scrollbarsSize[k] - size;
            } else {
              indicatorPos = pos / contentSize[k] * scrollbarsSize[k];
            }
            _this.setIndicatorSize(k, size);
            _this.setIndicatorPos(k, indicatorPos);
          }
        }
      });
    }
    init = false;
  }, this.options);

  // bind events
  this.bindEvents();

  // the content element needs a correct transform origin for zooming
  setTransformOrigin(content.style, 'left top');

  // reflow for the first time
  this.reflow();
}

DOMScroller.prototype = {
  constructor: DOMScroller,
  setDisabled: function setDisabled(disabled) {
    this.disabled = disabled;
  },
  clearScrollbarTimer: function clearScrollbarTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  setScrollbarOpacity: function setScrollbarOpacity(axis, opacity) {
    if (this.scrollbarsOpacity[axis] !== opacity) {
      this.scrollbars[axis].style.opacity = opacity;
      this.scrollbarsOpacity[axis] = opacity;
    }
  },
  setIndicatorPos: function setIndicatorPos(axis, value) {
    var indicatorsPos = this.indicatorsPos,
        indicators = this.indicators;

    if (indicatorsPos[axis] !== value) {
      if (axis === 'x') {
        setTransform(indicators[axis].style, 'translate3d(' + value + 'px,0,0)');
      } else {
        setTransform(indicators[axis].style, 'translate3d(0, ' + value + 'px,0)');
      }
      indicatorsPos[axis] = value;
    }
  },
  setIndicatorSize: function setIndicatorSize(axis, value) {
    var indicatorsSize = this.indicatorsSize,
        indicators = this.indicators;

    if (indicatorsSize[axis] !== value) {
      indicators[axis].style[axis === 'x' ? 'width' : 'height'] = value + 'px';
      indicatorsSize[axis] = value;
    }
  },
  reflow: function reflow() {
    var container = this.container,
        content = this.content,
        scrollbarsSize = this.scrollbarsSize,
        contentSize = this.contentSize,
        scrollbars = this.scrollbars,
        clientSize = this.clientSize,
        scroller = this.scroller;

    if (scrollbars) {
      contentSize.x = content.offsetWidth;
      contentSize.y = content.offsetHeight;
      clientSize.x = container.clientWidth;
      clientSize.y = container.clientHeight;
      if (scrollbars.x) {
        scrollbarsSize.x = scrollbars.x.offsetWidth;
      }
      if (scrollbars.y) {
        scrollbarsSize.y = scrollbars.y.offsetHeight;
      }
    }
    // set the right scroller dimensions
    scroller.setDimensions(container.clientWidth, container.clientHeight, content.offsetWidth, content.offsetHeight);

    // refresh the position for zooming purposes
    var rect = container.getBoundingClientRect();
    scroller.setPosition(rect.x + container.clientLeft, rect.y + container.clientTop);
  },
  destroy: function destroy() {
    this._destroyed = true;
    this.unbindEvent();
  },
  unbindEvent: function unbindEvent(type) {
    var eventHandlers = this.eventHandlers;

    if (type) {
      if (eventHandlers[type]) {
        eventHandlers[type]();
        delete eventHandlers[type];
      }
    } else {
      Object.keys(eventHandlers).forEach(function (t) {
        eventHandlers[t]();
        delete eventHandlers[t];
      });
    }
  },
  bindEvent: function bindEvent(target, type, fn, options) {
    var eventHandlers = this.eventHandlers;

    if (eventHandlers[type]) {
      eventHandlers[type]();
    }
    eventHandlers[type] = addEventListener(target, type, fn, options);
  },
  bindEvents: function bindEvents() {
    var _this2 = this;

    // reflow handling
    this.eventHandlers = {};

    this.bindEvent(win, 'resize', function () {
      _this2.reflow();
    }, false);

    var lockMouse = false;
    var releaseLockTimer = void 0;

    var container = this.container,
        scroller = this.scroller;


    this.bindEvent(container, 'touchstart', function (e) {
      lockMouse = true;
      if (releaseLockTimer) {
        clearTimeout(releaseLockTimer);
        releaseLockTimer = null;
      }
      // Don't react if initial down happens on a form element
      if (e.touches[0] && e.touches[0].target && e.touches[0].target.tagName.match(/input|textarea|select/i) || _this2.disabled) {
        return;
      }
      _this2.clearScrollbarTimer();
      // reflow since the container may have changed
      _this2.reflow();
      scroller.doTouchStart(e.touches, e.timeStamp);
    }, willNotPreventDefault);

    var _options = this.options,
        preventDefaultOnTouchMove = _options.preventDefaultOnTouchMove,
        zooming = _options.zooming;

    var onTouchEnd = function onTouchEnd(e) {
      scroller.doTouchEnd(e.timeStamp);
      releaseLockTimer = setTimeout(function () {
        lockMouse = false;
      }, 300);
    };

    if (preventDefaultOnTouchMove !== false) {
      this.bindEvent(container, 'touchmove', function (e) {
        e.preventDefault();
        scroller.doTouchMove(e.touches, e.timeStamp, e.scale);
        iOSWebViewFix(e, onTouchEnd);
      }, willPreventDefault);
    } else {
      this.bindEvent(container, 'touchmove', function (e) {
        scroller.doTouchMove(e.touches, e.timeStamp, e.scale);
        iOSWebViewFix(e, onTouchEnd);
      }, willNotPreventDefault);
    }

    this.bindEvent(container, 'touchend', onTouchEnd, willNotPreventDefault);
    this.bindEvent(container, 'touchcancel', onTouchEnd, willNotPreventDefault);

    var onMouseUp = function onMouseUp(e) {
      scroller.doTouchEnd(e.timeStamp);
      _this2.unbindEvent('mousemove');
      _this2.unbindEvent('mouseup');
    };

    var onMouseMove = function onMouseMove(e) {
      scroller.doTouchMove([{
        pageX: e.pageX,
        pageY: e.pageY
      }], e.timeStamp);
    };

    this.bindEvent(container, 'mousedown', function (e) {
      if (lockMouse || e.target.tagName.match(/input|textarea|select/i) || _this2.disabled) {
        return;
      }
      _this2.clearScrollbarTimer();
      scroller.doTouchStart([{
        pageX: e.pageX,
        pageY: e.pageY
      }], e.timeStamp);
      // reflow since the container may have changed
      _this2.reflow();
      e.preventDefault();
      _this2.bindEvent(document, 'mousemove', onMouseMove, willNotPreventDefault);
      _this2.bindEvent(document, 'mouseup', onMouseUp, willNotPreventDefault);
    }, willPreventDefault);

    if (zooming) {
      this.bindEvent(container, 'mousewheel', function (e) {
        scroller.doMouseZoom(e.wheelDelta, e.timeStamp, e.pageX, e.pageY);
        e.preventDefault();
      }, willPreventDefault);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (DOMScroller);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animate__ = __webpack_require__(1618);
/*
 * Scroller
 * http://github.com/zynga/scroller
 *
 * Copyright 2011, Zynga Inc.
 * Licensed under the MIT License.
 * https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
 *
 * Based on the work of: Unify Project (unify-project.org)
 * http://unify-project.org
 * Copyright 2011, Deutsche Telekom AG
 * License: MIT + Apache (V2)
 */



var Scroller;

var NOOP = function NOOP() {};

/**
 * A pure logic 'component' for 'virtual' scrolling/zooming.
 */
Scroller = function Scroller(callback, options) {

  this.__callback = callback;

  this.options = {

    /** Enable scrolling on x-axis */
    scrollingX: true,

    /** Enable scrolling on y-axis */
    scrollingY: true,

    /** Enable animations for deceleration, snap back, zooming and scrolling */
    animating: true,

    /** duration for animations triggered by scrollTo/zoomTo */
    animationDuration: 250,

    /** Enable bouncing (content can be slowly moved outside and jumps back after releasing) */
    bouncing: true,

    /** Enable locking to the main axis if user moves only slightly on one of them at start */
    locking: true,

    /** Enable pagination mode (switching between full page content panes) */
    paging: false,

    /** Enable snapping of content to a configured pixel grid */
    snapping: false,

    /** Enable zooming of content via API, fingers and mouse wheel */
    zooming: false,

    /** Minimum zoom level */
    minZoom: 0.5,

    /** Maximum zoom level */
    maxZoom: 3,

    /** Multiply or decrease scrolling speed **/
    speedMultiplier: 1,

    /** Callback that is fired on the later of touch end or deceleration end,
     provided that another scrolling action has not begun. Used to know
     when to fade out a scrollbar. */
    scrollingComplete: NOOP,

    /** This configures the amount of change applied to deceleration when reaching boundaries  **/
    penetrationDeceleration: 0.03,

    /** This configures the amount of change applied to acceleration when reaching boundaries  **/
    penetrationAcceleration: 0.08

  };

  for (var key in options) {
    this.options[key] = options[key];
  }
};

// Easing Equations (c) 2003 Robert Penner, all rights reserved.
// Open source under the BSD License.

/**
 * @param pos {Number} position between 0 (start of effect) and 1 (end of effect)
 **/
var easeOutCubic = function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
};

/**
 * @param pos {Number} position between 0 (start of effect) and 1 (end of effect)
 **/
var easeInOutCubic = function easeInOutCubic(pos) {
  if ((pos /= 0.5) < 1) {
    return 0.5 * Math.pow(pos, 3);
  }

  return 0.5 * (Math.pow(pos - 2, 3) + 2);
};

var members = {

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: STATUS
   ---------------------------------------------------------------------------
   */

  /** {Boolean} Whether only a single finger is used in touch handling */
  __isSingleTouch: false,

  /** {Boolean} Whether a touch event sequence is in progress */
  __isTracking: false,

  /** {Boolean} Whether a deceleration animation went to completion. */
  __didDecelerationComplete: false,

  /**
   * {Boolean} Whether a gesture zoom/rotate event is in progress. Activates when
   * a gesturestart event happens. This has higher priority than dragging.
   */
  __isGesturing: false,

  /**
   * {Boolean} Whether the user has moved by such a distance that we have enabled
   * dragging mode. Hint: It's only enabled after some pixels of movement to
   * not interrupt with clicks etc.
   */
  __isDragging: false,

  /**
   * {Boolean} Not touching and dragging anymore, and smoothly animating the
   * touch sequence using deceleration.
   */
  __isDecelerating: false,

  /**
   * {Boolean} Smoothly animating the currently configured change
   */
  __isAnimating: false,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: DIMENSIONS
   ---------------------------------------------------------------------------
   */

  /** {Integer} Available outer left position (from document perspective) */
  __clientLeft: 0,

  /** {Integer} Available outer top position (from document perspective) */
  __clientTop: 0,

  /** {Integer} Available outer width */
  __clientWidth: 0,

  /** {Integer} Available outer height */
  __clientHeight: 0,

  /** {Integer} Outer width of content */
  __contentWidth: 0,

  /** {Integer} Outer height of content */
  __contentHeight: 0,

  /** {Integer} Snapping width for content */
  __snapWidth: 100,

  /** {Integer} Snapping height for content */
  __snapHeight: 100,

  /** {Integer} Height to assign to refresh area */
  __refreshHeight: null,

  /** {Boolean} Whether the refresh process is enabled when the event is released now */
  __refreshActive: false,

  /** {Function} Callback to execute on activation. This is for signalling the user about a refresh is about to happen when he release */
  __refreshActivate: null,

  /** {Function} Callback to execute on deactivation. This is for signalling the user about the refresh being cancelled */
  __refreshDeactivate: null,

  /** {Function} Callback to execute to start the actual refresh. Call {@link #refreshFinish} when done */
  __refreshStart: null,

  /** {Number} Zoom level */
  __zoomLevel: 1,

  /** {Number} Scroll position on x-axis */
  __scrollLeft: 0,

  /** {Number} Scroll position on y-axis */
  __scrollTop: 0,

  /** {Integer} Maximum allowed scroll position on x-axis */
  __maxScrollLeft: 0,

  /** {Integer} Maximum allowed scroll position on y-axis */
  __maxScrollTop: 0,

  /* {Number} Scheduled left position (final position when animating) */
  __scheduledLeft: 0,

  /* {Number} Scheduled top position (final position when animating) */
  __scheduledTop: 0,

  /* {Number} Scheduled zoom level (final scale when animating) */
  __scheduledZoom: 0,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: LAST POSITIONS
   ---------------------------------------------------------------------------
   */

  /** {Number} Left position of finger at start */
  __lastTouchLeft: null,

  /** {Number} Top position of finger at start */
  __lastTouchTop: null,

  /** {Date} Timestamp of last move of finger. Used to limit tracking range for deceleration speed. */
  __lastTouchMove: null,

  /** {Array} List of positions, uses three indexes for each state: left, top, timestamp */
  __positions: null,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: DECELERATION SUPPORT
   ---------------------------------------------------------------------------
   */

  /** {Integer} Minimum left scroll position during deceleration */
  __minDecelerationScrollLeft: null,

  /** {Integer} Minimum top scroll position during deceleration */
  __minDecelerationScrollTop: null,

  /** {Integer} Maximum left scroll position during deceleration */
  __maxDecelerationScrollLeft: null,

  /** {Integer} Maximum top scroll position during deceleration */
  __maxDecelerationScrollTop: null,

  /** {Number} Current factor to modify horizontal scroll position with on every step */
  __decelerationVelocityX: null,

  /** {Number} Current factor to modify vertical scroll position with on every step */
  __decelerationVelocityY: null,

  /*
   ---------------------------------------------------------------------------
   PUBLIC API
   ---------------------------------------------------------------------------
   */

  /**
   * Configures the dimensions of the client (outer) and content (inner) elements.
   * Requires the available space for the outer element and the outer size of the inner element.
   * All values which are falsy (null or zero etc.) are ignored and the old value is kept.
   *
   * @param clientWidth {Integer ? null} Inner width of outer element
   * @param clientHeight {Integer ? null} Inner height of outer element
   * @param contentWidth {Integer ? null} Outer width of inner element
   * @param contentHeight {Integer ? null} Outer height of inner element
   */
  setDimensions: function setDimensions(clientWidth, clientHeight, contentWidth, contentHeight) {

    var self = this;

    // Only update values which are defined
    if (clientWidth === +clientWidth) {
      self.__clientWidth = clientWidth;
    }

    if (clientHeight === +clientHeight) {
      self.__clientHeight = clientHeight;
    }

    if (contentWidth === +contentWidth) {
      self.__contentWidth = contentWidth;
    }

    if (contentHeight === +contentHeight) {
      self.__contentHeight = contentHeight;
    }

    // Refresh maximums
    self.__computeScrollMax();

    // Refresh scroll position
    self.scrollTo(self.__scrollLeft, self.__scrollTop, true);
  },

  /**
   * Sets the client coordinates in relation to the document.
   *
   * @param left {Integer ? 0} Left position of outer element
   * @param top {Integer ? 0} Top position of outer element
   */
  setPosition: function setPosition(left, top) {

    var self = this;

    self.__clientLeft = left || 0;
    self.__clientTop = top || 0;
  },

  /**
   * Configures the snapping (when snapping is active)
   *
   * @param width {Integer} Snapping width
   * @param height {Integer} Snapping height
   */
  setSnapSize: function setSnapSize(width, height) {

    var self = this;

    self.__snapWidth = width;
    self.__snapHeight = height;
  },

  /**
   * Activates pull-to-refresh. A special zone on the top of the list to start a list refresh whenever
   * the user event is released during visibility of this zone. This was introduced by some apps on iOS like
   * the official Twitter client.
   *
   * @param height {Integer} Height of pull-to-refresh zone on top of rendered list
   * @param activateCallback {Function} Callback to execute on activation. This is for signalling the user about a refresh is about to happen when he release.
   * @param deactivateCallback {Function} Callback to execute on deactivation. This is for signalling the user about the refresh being cancelled.
   * @param startCallback {Function} Callback to execute to start the real async refresh action. Call {@link #finishPullToRefresh} after finish of refresh.
   */
  activatePullToRefresh: function activatePullToRefresh(height, activateCallback, deactivateCallback, startCallback) {

    var self = this;

    self.__refreshHeight = height;
    self.__refreshActivate = activateCallback;
    self.__refreshDeactivate = deactivateCallback;
    self.__refreshStart = startCallback;
  },

  /**
   * Starts pull-to-refresh manually.
   */
  triggerPullToRefresh: function triggerPullToRefresh() {
    // Use publish instead of scrollTo to allow scrolling to out of boundary position
    // We don't need to normalize scrollLeft, zoomLevel, etc. here because we only y-scrolling when pull-to-refresh is enabled
    this.__publish(this.__scrollLeft, -this.__refreshHeight, this.__zoomLevel, true);

    if (this.__refreshStart) {
      this.__refreshStart();
    }
  },

  /**
   * Signalizes that pull-to-refresh is finished.
   */
  finishPullToRefresh: function finishPullToRefresh() {

    var self = this;

    self.__refreshActive = false;
    if (self.__refreshDeactivate) {
      self.__refreshDeactivate();
    }

    self.scrollTo(self.__scrollLeft, self.__scrollTop, true);
  },

  /**
   * Returns the scroll position and zooming values
   *
   * @return {Map} `left` and `top` scroll position and `zoom` level
   */
  getValues: function getValues() {

    var self = this;

    return {
      left: self.__scrollLeft,
      top: self.__scrollTop,
      zoom: self.__zoomLevel
    };
  },

  /**
   * Returns the maximum scroll values
   *
   * @return {Map} `left` and `top` maximum scroll values
   */
  getScrollMax: function getScrollMax() {

    var self = this;

    return {
      left: self.__maxScrollLeft,
      top: self.__maxScrollTop
    };
  },

  /**
   * Zooms to the given level. Supports optional animation. Zooms
   * the center when no coordinates are given.
   *
   * @param level {Number} Level to zoom to
   * @param animate {Boolean ? false} Whether to use animation
   * @param originLeft {Number ? null} Zoom in at given left coordinate
   * @param originTop {Number ? null} Zoom in at given top coordinate
   * @param callback {Function ? null} A callback that gets fired when the zoom is complete.
   */
  zoomTo: function zoomTo(level, animate, originLeft, originTop, callback) {

    var self = this;

    if (!self.options.zooming) {
      throw new Error("Zooming is not enabled!");
    }

    // Add callback if exists
    if (callback) {
      self.__zoomComplete = callback;
    }

    // Stop deceleration
    if (self.__isDecelerating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    var oldLevel = self.__zoomLevel;

    // Normalize input origin to center of viewport if not defined
    if (originLeft == null) {
      originLeft = self.__clientWidth / 2;
    }

    if (originTop == null) {
      originTop = self.__clientHeight / 2;
    }

    // Limit level according to configuration
    level = Math.max(Math.min(level, self.options.maxZoom), self.options.minZoom);

    // Recompute maximum values while temporary tweaking maximum scroll ranges
    self.__computeScrollMax(level);

    // Recompute left and top coordinates based on new zoom level
    var left = (originLeft + self.__scrollLeft) * level / oldLevel - originLeft;
    var top = (originTop + self.__scrollTop) * level / oldLevel - originTop;

    // Limit x-axis
    if (left > self.__maxScrollLeft) {
      left = self.__maxScrollLeft;
    } else if (left < 0) {
      left = 0;
    }

    // Limit y-axis
    if (top > self.__maxScrollTop) {
      top = self.__maxScrollTop;
    } else if (top < 0) {
      top = 0;
    }

    // Push values out
    self.__publish(left, top, level, animate);
  },

  /**
   * Zooms the content by the given factor.
   *
   * @param factor {Number} Zoom by given factor
   * @param animate {Boolean ? false} Whether to use animation
   * @param originLeft {Number ? 0} Zoom in at given left coordinate
   * @param originTop {Number ? 0} Zoom in at given top coordinate
   * @param callback {Function ? null} A callback that gets fired when the zoom is complete.
   */
  zoomBy: function zoomBy(factor, animate, originLeft, originTop, callback) {

    var self = this;

    self.zoomTo(self.__zoomLevel * factor, animate, originLeft, originTop, callback);
  },

  /**
   * Scrolls to the given position. Respect limitations and snapping automatically.
   *
   * @param left {Number?null} Horizontal scroll position, keeps current if value is <code>null</code>
   * @param top {Number?null} Vertical scroll position, keeps current if value is <code>null</code>
   * @param animate {Boolean?false} Whether the scrolling should happen using an animation
   * @param zoom {Number?null} Zoom level to go to
   */
  scrollTo: function scrollTo(left, top, animate, zoom, callback) {

    var self = this;

    // Stop deceleration
    if (self.__isDecelerating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    // Correct coordinates based on new zoom level
    if (zoom != null && zoom !== self.__zoomLevel) {

      if (!self.options.zooming) {
        throw new Error("Zooming is not enabled!");
      }

      left *= zoom;
      top *= zoom;

      // Recompute maximum values while temporary tweaking maximum scroll ranges
      self.__computeScrollMax(zoom);
    } else {

      // Keep zoom when not defined
      zoom = self.__zoomLevel;
    }

    if (!self.options.scrollingX) {

      left = self.__scrollLeft;
    } else {

      if (self.options.paging) {
        left = Math.round(left / self.__clientWidth) * self.__clientWidth;
      } else if (self.options.snapping) {
        left = Math.round(left / self.__snapWidth) * self.__snapWidth;
      }
    }

    if (!self.options.scrollingY) {

      top = self.__scrollTop;
    } else {

      if (self.options.paging) {
        top = Math.round(top / self.__clientHeight) * self.__clientHeight;
      } else if (self.options.snapping) {
        top = Math.round(top / self.__snapHeight) * self.__snapHeight;
      }
    }

    // Limit for allowed ranges
    left = Math.max(Math.min(self.__maxScrollLeft, left), 0);
    top = Math.max(Math.min(self.__maxScrollTop, top), 0);

    // Don't animate when no change detected, still call publish to make sure
    // that rendered position is really in-sync with internal data
    if (left === self.__scrollLeft && top === self.__scrollTop) {
      animate = false;
      if (callback) {
        callback();
      }
    }

    // Publish new values
    if (!self.__isTracking) {
      self.__publish(left, top, zoom, animate);
    }
  },

  /**
   * Scroll by the given offset
   *
   * @param left {Number ? 0} Scroll x-axis by given offset
   * @param top {Number ? 0} Scroll x-axis by given offset
   * @param animate {Boolean ? false} Whether to animate the given change
   */
  scrollBy: function scrollBy(left, top, animate) {

    var self = this;

    var startLeft = self.__isAnimating ? self.__scheduledLeft : self.__scrollLeft;
    var startTop = self.__isAnimating ? self.__scheduledTop : self.__scrollTop;

    self.scrollTo(startLeft + (left || 0), startTop + (top || 0), animate);
  },

  /*
   ---------------------------------------------------------------------------
   EVENT CALLBACKS
   ---------------------------------------------------------------------------
   */

  /**
   * Mouse wheel handler for zooming support
   */
  doMouseZoom: function doMouseZoom(wheelDelta, timeStamp, pageX, pageY) {

    var self = this;
    var change = wheelDelta > 0 ? 0.97 : 1.03;

    return self.zoomTo(self.__zoomLevel * change, false, pageX - self.__clientLeft, pageY - self.__clientTop);
  },

  /**
   * Touch start handler for scrolling support
   */
  doTouchStart: function doTouchStart(touches, timeStamp) {

    // Array-like check is enough here
    if (touches.length == null) {
      throw new Error("Invalid touch list: " + touches);
    }

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Reset interruptedAnimation flag
    self.__interruptedAnimation = true;

    // Stop deceleration
    if (self.__isDecelerating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
      self.__interruptedAnimation = true;
    }

    // Stop animation
    if (self.__isAnimating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isAnimating);
      self.__isAnimating = false;
      self.__interruptedAnimation = true;
    }

    // Use center point when dealing with two fingers
    var currentTouchLeft, currentTouchTop;
    var isSingleTouch = touches.length === 1;
    if (isSingleTouch) {
      currentTouchLeft = touches[0].pageX;
      currentTouchTop = touches[0].pageY;
    } else {
      currentTouchLeft = Math.abs(touches[0].pageX + touches[1].pageX) / 2;
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    }

    // Store initial positions
    self.__initialTouchLeft = currentTouchLeft;
    self.__initialTouchTop = currentTouchTop;

    // Store current zoom level
    self.__zoomLevelStart = self.__zoomLevel;

    // Store initial touch positions
    self.__lastTouchLeft = currentTouchLeft;
    self.__lastTouchTop = currentTouchTop;

    // Store initial move time stamp
    self.__lastTouchMove = timeStamp;

    // Reset initial scale
    self.__lastScale = 1;

    // Reset locking flags
    self.__enableScrollX = !isSingleTouch && self.options.scrollingX;
    self.__enableScrollY = !isSingleTouch && self.options.scrollingY;

    // Reset tracking flag
    self.__isTracking = true;

    // Reset deceleration complete flag
    self.__didDecelerationComplete = false;

    // Dragging starts directly with two fingers, otherwise lazy with an offset
    self.__isDragging = !isSingleTouch;

    // Some features are disabled in multi touch scenarios
    self.__isSingleTouch = isSingleTouch;

    // Clearing data structure
    self.__positions = [];
  },

  /**
   * Touch move handler for scrolling support
   */
  doTouchMove: function doTouchMove(touches, timeStamp, scale) {

    // Array-like check is enough here
    if (touches.length == null) {
      throw new Error("Invalid touch list: " + touches);
    }

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Ignore event when tracking is not enabled (event might be outside of element)
    if (!self.__isTracking) {
      return;
    }

    var currentTouchLeft, currentTouchTop;

    // Compute move based around of center of fingers
    if (touches.length === 2) {
      currentTouchLeft = Math.abs(touches[0].pageX + touches[1].pageX) / 2;
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    } else {
      currentTouchLeft = touches[0].pageX;
      currentTouchTop = touches[0].pageY;
    }

    var positions = self.__positions;

    // Are we already is dragging mode?
    if (self.__isDragging) {

      // Compute move distance
      var moveX = currentTouchLeft - self.__lastTouchLeft;
      var moveY = currentTouchTop - self.__lastTouchTop;

      // Read previous scroll position and zooming
      var scrollLeft = self.__scrollLeft;
      var scrollTop = self.__scrollTop;
      var level = self.__zoomLevel;

      // Work with scaling
      if (scale != null && self.options.zooming) {

        var oldLevel = level;

        // Recompute level based on previous scale and new scale
        level = level / self.__lastScale * scale;

        // Limit level according to configuration
        level = Math.max(Math.min(level, self.options.maxZoom), self.options.minZoom);

        // Only do further compution when change happened
        if (oldLevel !== level) {

          // Compute relative event position to container
          var currentTouchLeftRel = currentTouchLeft - self.__clientLeft;
          var currentTouchTopRel = currentTouchTop - self.__clientTop;

          // Recompute left and top coordinates based on new zoom level
          scrollLeft = (currentTouchLeftRel + scrollLeft) * level / oldLevel - currentTouchLeftRel;
          scrollTop = (currentTouchTopRel + scrollTop) * level / oldLevel - currentTouchTopRel;

          // Recompute max scroll values
          self.__computeScrollMax(level);
        }
      }

      if (self.__enableScrollX) {

        scrollLeft -= moveX * this.options.speedMultiplier;
        var maxScrollLeft = self.__maxScrollLeft;

        if (scrollLeft > maxScrollLeft || scrollLeft < 0) {

          // Slow down on the edges
          if (self.options.bouncing) {

            scrollLeft += moveX / 2 * this.options.speedMultiplier;
          } else if (scrollLeft > maxScrollLeft) {

            scrollLeft = maxScrollLeft;
          } else {

            scrollLeft = 0;
          }
        }
      }

      // Compute new vertical scroll position
      if (self.__enableScrollY) {

        scrollTop -= moveY * this.options.speedMultiplier;
        var maxScrollTop = self.__maxScrollTop;

        if (scrollTop > maxScrollTop || scrollTop < 0) {

          // Slow down on the edges
          if (self.options.bouncing) {

            scrollTop += moveY / 2 * this.options.speedMultiplier;

            // Support pull-to-refresh (only when only y is scrollable)
            if (!self.__enableScrollX && self.__refreshHeight != null) {

              if (!self.__refreshActive && scrollTop <= -self.__refreshHeight) {

                self.__refreshActive = true;
                if (self.__refreshActivate) {
                  self.__refreshActivate();
                }
              } else if (self.__refreshActive && scrollTop > -self.__refreshHeight) {

                self.__refreshActive = false;
                if (self.__refreshDeactivate) {
                  self.__refreshDeactivate();
                }
              }
            }
          } else if (scrollTop > maxScrollTop) {

            scrollTop = maxScrollTop;
          } else {

            scrollTop = 0;
          }
        }
      }

      // Keep list from growing infinitely (holding min 10, max 20 measure points)
      if (positions.length > 60) {
        positions.splice(0, 30);
      }

      // Track scroll movement for decleration
      positions.push(scrollLeft, scrollTop, timeStamp);

      // Sync scroll position
      self.__publish(scrollLeft, scrollTop, level);

      // Otherwise figure out whether we are switching into dragging mode now.
    } else {

      var minimumTrackingForScroll = 3;
      var minimumTrackingForDrag = 5;

      var distanceX = Math.abs(currentTouchLeft - self.__initialTouchLeft);
      var distanceY = Math.abs(currentTouchTop - self.__initialTouchTop);

      self.__enableScrollX = self.options.scrollingX && distanceX >= minimumTrackingForScroll;
      self.__enableScrollY = self.options.scrollingY && distanceY >= minimumTrackingForScroll;

      var radian = void 0;

      if (self.options.locking && self.__enableScrollY) {
        radian = radian || Math.atan2(distanceY, distanceX);
        if (radian < Math.PI / 4) {
          self.__enableScrollY = false;
        }
      }

      if (self.options.locking && self.__enableScrollX) {
        radian = radian || Math.atan2(distanceY, distanceX);
        if (radian > Math.PI / 4) {
          self.__enableScrollX = false;
        }
      }

      positions.push(self.__scrollLeft, self.__scrollTop, timeStamp);

      self.__isDragging = (self.__enableScrollX || self.__enableScrollY) && (distanceX >= minimumTrackingForDrag || distanceY >= minimumTrackingForDrag);
      if (self.__isDragging) {
        self.__interruptedAnimation = false;
      }
    }

    // Update last touch positions and time stamp for next event
    self.__lastTouchLeft = currentTouchLeft;
    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = scale;
  },

  /**
   * Touch end handler for scrolling support
   */
  doTouchEnd: function doTouchEnd(timeStamp) {

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Ignore event when tracking is not enabled (no touchstart event on element)
    // This is required as this listener ('touchmove') sits on the document and not on the element itself.
    if (!self.__isTracking) {
      return;
    }

    // Not touching anymore (when two finger hit the screen there are two touch end events)
    self.__isTracking = false;

    // Be sure to reset the dragging flag now. Here we also detect whether
    // the finger has moved fast enough to switch into a deceleration animation.
    if (self.__isDragging) {

      // Reset dragging flag
      self.__isDragging = false;

      // Start deceleration
      // Verify that the last move detected was in some relevant time frame
      if (self.__isSingleTouch && self.options.animating && timeStamp - self.__lastTouchMove <= 100) {

        // Then figure out what the scroll position was about 100ms ago
        var positions = self.__positions;
        var endPos = positions.length - 1;
        var startPos = endPos;

        // Move pointer to position measured 100ms ago
        for (var i = endPos; i > 0 && positions[i] > self.__lastTouchMove - 100; i -= 3) {
          startPos = i;
        }

        // If start and stop position is identical in a 100ms timeframe,
        // we cannot compute any useful deceleration.
        if (startPos !== endPos) {

          // Compute relative movement between these two points
          var timeOffset = positions[endPos] - positions[startPos];
          var movedLeft = self.__scrollLeft - positions[startPos - 2];
          var movedTop = self.__scrollTop - positions[startPos - 1];

          // Based on 50ms compute the movement to apply for each render step
          self.__decelerationVelocityX = movedLeft / timeOffset * (1000 / 60);
          self.__decelerationVelocityY = movedTop / timeOffset * (1000 / 60);

          // How much velocity is required to start the deceleration
          var minVelocityToStartDeceleration = self.options.paging || self.options.snapping ? 4 : 1;

          // Verify that we have enough velocity to start deceleration
          if (Math.abs(self.__decelerationVelocityX) > minVelocityToStartDeceleration || Math.abs(self.__decelerationVelocityY) > minVelocityToStartDeceleration) {

            // Deactivate pull-to-refresh when decelerating
            if (!self.__refreshActive) {
              self.__startDeceleration(timeStamp);
            }
          } else {
            self.options.scrollingComplete();
          }
        } else {
          self.options.scrollingComplete();
        }
      } else if (timeStamp - self.__lastTouchMove > 100) {
        self.options.scrollingComplete();
      }
    }

    // If this was a slower move it is per default non decelerated, but this
    // still means that we want snap back to the bounds which is done here.
    // This is placed outside the condition above to improve edge case stability
    // e.g. touchend fired without enabled dragging. This should normally do not
    // have modified the scroll positions or even showed the scrollbars though.
    if (!self.__isDecelerating) {

      if (self.__refreshActive && self.__refreshStart) {

        // Use publish instead of scrollTo to allow scrolling to out of boundary position
        // We don't need to normalize scrollLeft, zoomLevel, etc. here because we only y-scrolling when pull-to-refresh is enabled
        self.__publish(self.__scrollLeft, -self.__refreshHeight, self.__zoomLevel, true);

        if (self.__refreshStart) {
          self.__refreshStart();
        }
      } else {

        if (self.__interruptedAnimation || self.__isDragging) {
          self.options.scrollingComplete();
        }
        self.scrollTo(self.__scrollLeft, self.__scrollTop, true, self.__zoomLevel);

        // Directly signalize deactivation (nothing todo on refresh?)
        if (self.__refreshActive) {

          self.__refreshActive = false;
          if (self.__refreshDeactivate) {
            self.__refreshDeactivate();
          }
        }
      }
    }

    // Fully cleanup list
    self.__positions.length = 0;
  },

  /*
   ---------------------------------------------------------------------------
   PRIVATE API
   ---------------------------------------------------------------------------
   */

  /**
   * Applies the scroll position to the content element
   *
   * @param left {Number} Left scroll position
   * @param top {Number} Top scroll position
   * @param animate {Boolean?false} Whether animation should be used to move to the new coordinates
   */
  __publish: function __publish(left, top, zoom, animate) {

    var self = this;

    // Remember whether we had an animation, then we try to continue based on the current "drive" of the animation
    var wasAnimating = self.__isAnimating;
    if (wasAnimating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(wasAnimating);
      self.__isAnimating = false;
    }

    if (animate && self.options.animating) {

      // Keep scheduled positions for scrollBy/zoomBy functionality
      self.__scheduledLeft = left;
      self.__scheduledTop = top;
      self.__scheduledZoom = zoom;

      var oldLeft = self.__scrollLeft;
      var oldTop = self.__scrollTop;
      var oldZoom = self.__zoomLevel;

      var diffLeft = left - oldLeft;
      var diffTop = top - oldTop;
      var diffZoom = zoom - oldZoom;

      var step = function step(percent, now, render) {

        if (render) {

          self.__scrollLeft = oldLeft + diffLeft * percent;
          self.__scrollTop = oldTop + diffTop * percent;
          self.__zoomLevel = oldZoom + diffZoom * percent;

          // Push values out
          if (self.__callback) {
            self.__callback(self.__scrollLeft, self.__scrollTop, self.__zoomLevel);
          }
        }
      };

      var verify = function verify(id) {
        return self.__isAnimating === id;
      };

      var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
        if (animationId === self.__isAnimating) {
          self.__isAnimating = false;
        }

        if (self.__didDecelerationComplete || wasFinished) {
          self.options.scrollingComplete();
        }

        if (self.options.zooming) {
          self.__computeScrollMax();
          if (self.__zoomComplete) {
            self.__zoomComplete();
            self.__zoomComplete = null;
          }
        }
      };

      // When continuing based on previous animation we choose an ease-out animation instead of ease-in-out
      self.__isAnimating = __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].start(step, verify, completed, self.options.animationDuration, wasAnimating ? easeOutCubic : easeInOutCubic);
    } else {

      self.__scheduledLeft = self.__scrollLeft = left;
      self.__scheduledTop = self.__scrollTop = top;
      self.__scheduledZoom = self.__zoomLevel = zoom;

      // Push values out
      if (self.__callback) {
        self.__callback(left, top, zoom);
      }

      // Fix max scroll ranges
      if (self.options.zooming) {
        self.__computeScrollMax();
        if (self.__zoomComplete) {
          self.__zoomComplete();
          self.__zoomComplete = null;
        }
      }
    }
  },

  /**
   * Recomputes scroll minimum values based on client dimensions and content dimensions.
   */
  __computeScrollMax: function __computeScrollMax(zoomLevel) {

    var self = this;

    if (zoomLevel == null) {
      zoomLevel = self.__zoomLevel;
    }

    self.__maxScrollLeft = Math.max(self.__contentWidth * zoomLevel - self.__clientWidth, 0);
    self.__maxScrollTop = Math.max(self.__contentHeight * zoomLevel - self.__clientHeight, 0);
  },

  /*
   ---------------------------------------------------------------------------
   ANIMATION (DECELERATION) SUPPORT
   ---------------------------------------------------------------------------
   */

  /**
   * Called when a touch sequence end and the speed of the finger was high enough
   * to switch into deceleration mode.
   */
  __startDeceleration: function __startDeceleration(timeStamp) {

    var self = this;

    if (self.options.paging) {

      var scrollLeft = Math.max(Math.min(self.__scrollLeft, self.__maxScrollLeft), 0);
      var scrollTop = Math.max(Math.min(self.__scrollTop, self.__maxScrollTop), 0);
      var clientWidth = self.__clientWidth;
      var clientHeight = self.__clientHeight;

      // We limit deceleration not to the min/max values of the allowed range, but to the size of the visible client area.
      // Each page should have exactly the size of the client area.
      self.__minDecelerationScrollLeft = Math.floor(scrollLeft / clientWidth) * clientWidth;
      self.__minDecelerationScrollTop = Math.floor(scrollTop / clientHeight) * clientHeight;
      self.__maxDecelerationScrollLeft = Math.ceil(scrollLeft / clientWidth) * clientWidth;
      self.__maxDecelerationScrollTop = Math.ceil(scrollTop / clientHeight) * clientHeight;
    } else {

      self.__minDecelerationScrollLeft = 0;
      self.__minDecelerationScrollTop = 0;
      self.__maxDecelerationScrollLeft = self.__maxScrollLeft;
      self.__maxDecelerationScrollTop = self.__maxScrollTop;
    }

    // Wrap class method
    var step = function step(percent, now, render) {
      self.__stepThroughDeceleration(render);
    };

    // How much velocity is required to keep the deceleration running
    // added by yiminghe
    var minVelocityToKeepDecelerating = self.options.minVelocityToKeepDecelerating;

    if (!minVelocityToKeepDecelerating) {
      minVelocityToKeepDecelerating = self.options.snapping ? 4 : 0.001;
    }

    // Detect whether it's still worth to continue animating steps
    // If we are already slow enough to not being user perceivable anymore, we stop the whole process here.
    var verify = function verify() {
      var shouldContinue = Math.abs(self.__decelerationVelocityX) >= minVelocityToKeepDecelerating || Math.abs(self.__decelerationVelocityY) >= minVelocityToKeepDecelerating;
      if (!shouldContinue) {
        self.__didDecelerationComplete = true;
      }
      return shouldContinue;
    };

    var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
      self.__isDecelerating = false;
      // Animate to grid when snapping is active, otherwise just fix out-of-boundary positions
      // fixed by yiminghe, in case call scrollingComplete twice
      self.scrollTo(self.__scrollLeft, self.__scrollTop, self.options.snapping, null, self.__didDecelerationComplete && self.options.scrollingComplete);
    };

    // Start animation and switch on flag
    self.__isDecelerating = __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].start(step, verify, completed);
  },

  /**
   * Called on every step of the animation
   *
   * @param inMemory {Boolean?false} Whether to not render the current step, but keep it in memory only. Used internally only!
   */
  __stepThroughDeceleration: function __stepThroughDeceleration(render) {

    var self = this;

    //
    // COMPUTE NEXT SCROLL POSITION
    //

    // Add deceleration to scroll position
    var scrollLeft = self.__scrollLeft + self.__decelerationVelocityX;
    var scrollTop = self.__scrollTop + self.__decelerationVelocityY;

    //
    // HARD LIMIT SCROLL POSITION FOR NON BOUNCING MODE
    //

    if (!self.options.bouncing) {

      var scrollLeftFixed = Math.max(Math.min(self.__maxDecelerationScrollLeft, scrollLeft), self.__minDecelerationScrollLeft);
      if (scrollLeftFixed !== scrollLeft) {
        scrollLeft = scrollLeftFixed;
        self.__decelerationVelocityX = 0;
      }

      var scrollTopFixed = Math.max(Math.min(self.__maxDecelerationScrollTop, scrollTop), self.__minDecelerationScrollTop);
      if (scrollTopFixed !== scrollTop) {
        scrollTop = scrollTopFixed;
        self.__decelerationVelocityY = 0;
      }
    }

    //
    // UPDATE SCROLL POSITION
    //

    if (render) {

      self.__publish(scrollLeft, scrollTop, self.__zoomLevel);
    } else {

      self.__scrollLeft = scrollLeft;
      self.__scrollTop = scrollTop;
    }

    //
    // SLOW DOWN
    //

    // Slow down velocity on every iteration
    if (!self.options.paging) {

      // This is the factor applied to every iteration of the animation
      // to slow down the process. This should emulate natural behavior where
      // objects slow down when the initiator of the movement is removed
      var frictionFactor = 0.95;

      self.__decelerationVelocityX *= frictionFactor;
      self.__decelerationVelocityY *= frictionFactor;
    }

    //
    // BOUNCING SUPPORT
    //

    if (self.options.bouncing) {

      var scrollOutsideX = 0;
      var scrollOutsideY = 0;

      // This configures the amount of change applied to deceleration/acceleration when reaching boundaries
      var penetrationDeceleration = self.options.penetrationDeceleration;
      var penetrationAcceleration = self.options.penetrationAcceleration;

      // Check limits
      if (scrollLeft < self.__minDecelerationScrollLeft) {
        scrollOutsideX = self.__minDecelerationScrollLeft - scrollLeft;
      } else if (scrollLeft > self.__maxDecelerationScrollLeft) {
        scrollOutsideX = self.__maxDecelerationScrollLeft - scrollLeft;
      }

      if (scrollTop < self.__minDecelerationScrollTop) {
        scrollOutsideY = self.__minDecelerationScrollTop - scrollTop;
      } else if (scrollTop > self.__maxDecelerationScrollTop) {
        scrollOutsideY = self.__maxDecelerationScrollTop - scrollTop;
      }

      // Slow down until slow enough, then flip back to snap position
      if (scrollOutsideX !== 0) {
        if (scrollOutsideX * self.__decelerationVelocityX <= 0) {
          self.__decelerationVelocityX += scrollOutsideX * penetrationDeceleration;
        } else {
          self.__decelerationVelocityX = scrollOutsideX * penetrationAcceleration;
        }
      }

      if (scrollOutsideY !== 0) {
        if (scrollOutsideY * self.__decelerationVelocityY <= 0) {
          self.__decelerationVelocityY += scrollOutsideY * penetrationDeceleration;
        } else {
          self.__decelerationVelocityY = scrollOutsideY * penetrationAcceleration;
        }
      }
    }
  }
};

// Copy over members to prototype
for (var key in members) {
  Scroller.prototype[key] = members[key];
}

/* harmony default export */ __webpack_exports__["a"] = (Scroller);

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Carousel = __webpack_require__(1622);

module.exports = Carousel;


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _createReactClass = __webpack_require__(621);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _kwReactTweenState = __webpack_require__(1133);

var _kwReactTweenState2 = _interopRequireDefault(_kwReactTweenState);

var _decorators = __webpack_require__(1623);

var _decorators2 = _interopRequireDefault(_decorators);

var _objectAssign = __webpack_require__(24);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _exenv = __webpack_require__(1098);

var _exenv2 = _interopRequireDefault(_exenv);

var addEvent = function addEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent('on' + type, eventHandle);
  } else {
    elem['on' + type] = eventHandle;
  }
};

var removeEvent = function removeEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }
  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent('on' + type, eventHandle);
  } else {
    elem['on' + type] = null;
  }
};

var Carousel = (0, _createReactClass2['default'])({
  displayName: 'Carousel',

  mixins: [_kwReactTweenState2['default'].Mixin],

  propTypes: {
    afterSlide: _propTypes2['default'].func,
    autoplay: _propTypes2['default'].bool,
    resetAutoplay: _propTypes2['default'].bool, // by warmhug
    swipeSpeed: _propTypes2['default'].number, // by warmhug
    autoplayInterval: _propTypes2['default'].number,
    beforeSlide: _propTypes2['default'].func,
    cellAlign: _propTypes2['default'].oneOf(['left', 'center', 'right']),
    cellSpacing: _propTypes2['default'].number,
    data: _propTypes2['default'].func,
    decorators: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
      component: _propTypes2['default'].func,
      position: _propTypes2['default'].oneOf(['TopLeft', 'TopCenter', 'TopRight', 'CenterLeft', 'CenterCenter', 'CenterRight', 'BottomLeft', 'BottomCenter', 'BottomRight']),
      style: _propTypes2['default'].object
    })),
    dragging: _propTypes2['default'].bool,
    easing: _propTypes2['default'].string,
    edgeEasing: _propTypes2['default'].string,
    framePadding: _propTypes2['default'].string,
    frameOverflow: _propTypes2['default'].string,
    initialSlideHeight: _propTypes2['default'].number,
    initialSlideWidth: _propTypes2['default'].number,
    slideIndex: _propTypes2['default'].number,
    slidesToShow: _propTypes2['default'].number,
    slidesToScroll: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].oneOf(['auto'])]),
    slideWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
    speed: _propTypes2['default'].number,
    swiping: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    width: _propTypes2['default'].string,
    wrapAround: _propTypes2['default'].bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      afterSlide: function afterSlide() {},
      autoplay: false,
      resetAutoplay: true,
      swipeSpeed: 5,
      autoplayInterval: 3000,
      beforeSlide: function beforeSlide() {},
      cellAlign: 'left',
      cellSpacing: 0,
      data: function data() {},
      decorators: _decorators2['default'],
      dragging: true,
      easing: 'easeOutCirc',
      edgeEasing: 'easeOutElastic',
      framePadding: '0px',
      frameOverflow: 'hidden',
      slideIndex: 0,
      slidesToScroll: 1,
      slidesToShow: 1,
      slideWidth: 1,
      speed: 500,
      swiping: true,
      vertical: false,
      width: '100%',
      wrapAround: false
    };
  },

  getInitialState: function getInitialState() {
    return {
      currentSlide: this.props.slideIndex,
      dragging: false,
      frameWidth: 0,
      left: 0,
      slideCount: 0,
      slidesToScroll: this.props.slidesToScroll,
      slideWidth: 0,
      top: 0
    };
  },

  componentWillMount: function componentWillMount() {
    this.setInitialDimensions();
  },

  componentDidMount: function componentDidMount() {
    this.setDimensions();
    this.bindEvents();
    this.setExternalData();
    if (this.props.autoplay) {
      this.startAutoplay();
    }
  },

  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.setState({
      slideCount: nextProps.children.length
    });
    this.setDimensions(nextProps);
    if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
      this.goToSlide(nextProps.slideIndex);
    }
    if (this.props.autoplay !== nextProps.autoplay) {
      if (nextProps.autoplay) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    }
  },

  componentWillUnmount: function componentWillUnmount() {
    this.unbindEvents();
    this.stopAutoplay();
  },

  render: function render() {
    var self = this;
    var children = _react2['default'].Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;
    return _react2['default'].createElement(
      'div',
      { className: ['slider', this.props.className || ''].join(' '), ref: 'slider', style: (0, _objectAssign2['default'])(this.getSliderStyles(), this.props.style || {}) },
      _react2['default'].createElement(
        'div',
        _extends({ className: 'slider-frame',
          ref: 'frame',
          style: this.getFrameStyles()
        }, this.getTouchEvents(), this.getMouseEvents(), {
          onClick: this.handleClick }),
        _react2['default'].createElement(
          'ul',
          { className: 'slider-list', ref: 'list', style: this.getListStyles() },
          children
        )
      ),
      this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
        return _react2['default'].createElement(
          'div',
          {
            style: (0, _objectAssign2['default'])(self.getDecoratorStyles(Decorator.position), Decorator.style || {}),
            className: 'slider-decorator-' + index,
            key: index },
          _react2['default'].createElement(Decorator.component, {
            currentSlide: self.state.currentSlide,
            slideCount: self.state.slideCount,
            frameWidth: self.state.frameWidth,
            slideWidth: self.state.slideWidth,
            slidesToScroll: self.state.slidesToScroll,
            cellSpacing: self.props.cellSpacing,
            slidesToShow: self.props.slidesToShow,
            wrapAround: self.props.wrapAround,
            nextSlide: self.nextSlide,
            previousSlide: self.previousSlide,
            goToSlide: self.goToSlide })
        );
      }) : null,
      _react2['default'].createElement('style', { type: 'text/css', dangerouslySetInnerHTML: { __html: self.getStyleTagStyles() } })
    );
  },

  // Touch Events

  touchObject: {},

  getTouchEvents: function getTouchEvents() {
    var self = this;

    if (self.props.swiping === false) {
      return null;
    }

    return {
      onTouchStart: function onTouchStart(e) {
        self.touchObject = {
          startX: e.touches[0].pageX,
          startY: e.touches[0].pageY
        };
        self.handleMouseOver();
      },
      onTouchMove: function onTouchMove(e) {
        var direction = self.swipeDirection(self.touchObject.startX, e.touches[0].pageX, self.touchObject.startY, e.touches[0].pageY);

        if (direction !== 0) {
          e.preventDefault();
        }

        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.touches[0].pageX,
          endY: e.touches[0].pageY,
          length: length,
          direction: direction
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
        });
      },
      onTouchEnd: function onTouchEnd(e) {
        self.handleSwipe(e);
        self.handleMouseOut();
      },
      onTouchCancel: function onTouchCancel(e) {
        self.handleSwipe(e);
      }
    };
  },

  clickSafe: true,

  getMouseEvents: function getMouseEvents() {
    var self = this;

    if (this.props.dragging === false) {
      return null;
    }

    return {
      onMouseOver: function onMouseOver() {
        self.handleMouseOver();
      },
      onMouseOut: function onMouseOut() {
        self.handleMouseOut();
      },
      onMouseDown: function onMouseDown(e) {
        self.touchObject = {
          startX: e.clientX,
          startY: e.clientY
        };

        self.setState({
          dragging: true
        });
      },
      onMouseMove: function onMouseMove(e) {
        if (!self.state.dragging) {
          return;
        }

        var direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);

        if (direction !== 0) {
          e.preventDefault();
        }

        var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));

        self.touchObject = {
          startX: self.touchObject.startX,
          startY: self.touchObject.startY,
          endX: e.clientX,
          endY: e.clientY,
          length: length,
          direction: direction
        };

        self.setState({
          left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
          top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
        });
      },
      onMouseUp: function onMouseUp(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      },
      onMouseLeave: function onMouseLeave(e) {
        if (!self.state.dragging) {
          return;
        }

        self.handleSwipe(e);
      }
    };
  },

  handleMouseOver: function handleMouseOver() {
    if (this.props.autoplay) {
      this.autoplayPaused = true;
      this.stopAutoplay();
    }
  },

  handleMouseOut: function handleMouseOut() {
    if (this.props.autoplay && this.autoplayPaused) {
      this.startAutoplay();
      this.autoplayPaused = null;
    }
  },

  handleClick: function handleClick(e) {
    if (this.clickSafe === true) {
      e.preventDefault();
      e.stopPropagation();

      if (e.nativeEvent) {
        e.nativeEvent.stopPropagation();
      }
    }
  },

  handleSwipe: function handleSwipe(e) {
    if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
      this.clickSafe = true;
    } else {
      this.clickSafe = false;
    }

    var slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }

    if (this.touchObject.length > this.state.slideWidth / slidesToShow / this.props.swipeSpeed) {
      if (this.touchObject.direction === 1) {
        if (this.state.currentSlide >= _react2['default'].Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
          this.animateSlide(_kwReactTweenState2['default'].easingTypes[this.props.edgeEasing]);
        } else {
          this.nextSlide();
        }
      } else if (this.touchObject.direction === -1) {
        if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
          this.animateSlide(_kwReactTweenState2['default'].easingTypes[this.props.edgeEasing]);
        } else {
          this.previousSlide();
        }
      }
    } else {
      this.goToSlide(this.state.currentSlide);
    }

    this.touchObject = {};

    this.setState({
      dragging: false
    });
  },

  swipeDirection: function swipeDirection(x1, x2, y1, y2) {

    var xDist, yDist, r, swipeAngle;

    xDist = x1 - x2;
    yDist = y1 - y2;
    r = Math.atan2(yDist, xDist);

    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return 1;
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return 1;
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return -1;
    }
    if (this.props.vertical === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 1;
      } else {
        return -1;
      }
    }
    return 0;
  },

  autoplayIterator: function autoplayIterator() {
    if (this.props.wrapAround) {
      return this.nextSlide();
    }
    if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
      this.nextSlide();
    } else {
      this.stopAutoplay();
    }
  },

  startAutoplay: function startAutoplay() {
    this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
  },

  resetAutoplay: function resetAutoplay() {
    if (this.props.resetAutoplay && this.props.autoplay && !this.autoplayPaused) {
      // by warmhug
      this.stopAutoplay();
      this.startAutoplay();
    }
  },

  stopAutoplay: function stopAutoplay() {
    this.autoplayID && clearInterval(this.autoplayID);
  },

  // Action Methods

  goToSlide: function goToSlide(index) {
    var self = this;
    if (index >= _react2['default'].Children.count(this.props.children) || index < 0) {
      if (!this.props.wrapAround) {
        return;
      };
      if (index >= _react2['default'].Children.count(this.props.children)) {
        this.props.beforeSlide(this.state.currentSlide, 0);
        return this.setState({
          currentSlide: 0
        }, function () {
          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(0);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      } else {
        var endSlide = _react2['default'].Children.count(this.props.children) - this.state.slidesToScroll;
        this.props.beforeSlide(this.state.currentSlide, endSlide);
        return this.setState({
          currentSlide: endSlide
        }, function () {
          self.animateSlide(null, null, self.getTargetLeft(null, index), function () {
            self.animateSlide(null, 0.01);
            self.props.afterSlide(endSlide);
            self.resetAutoplay();
            self.setExternalData();
          });
        });
      }
    }

    this.props.beforeSlide(this.state.currentSlide, index);

    this.setState({
      currentSlide: index
    }, function () {
      self.animateSlide();
      this.props.afterSlide(index);
      self.resetAutoplay();
      self.setExternalData();
    });
  },

  nextSlide: function nextSlide() {
    var childrenCount = _react2['default'].Children.count(this.props.children);
    var slidesToShow = this.props.slidesToShow;
    if (this.props.slidesToScroll === 'auto') {
      slidesToShow = this.state.slidesToScroll;
    }
    if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
    } else {
      if (this.props.slideWidth !== 1) {
        return this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
      }
      this.goToSlide(Math.min(this.state.currentSlide + this.state.slidesToScroll, childrenCount - slidesToShow));
    }
  },

  previousSlide: function previousSlide() {
    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
      return;
    }

    if (this.props.wrapAround) {
      this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
    } else {
      this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
    }
  },

  // Animation

  animateSlide: function animateSlide(easing, duration, endValue, callback) {
    this.tweenState(this.props.vertical ? 'top' : 'left', {
      easing: easing || _kwReactTweenState2['default'].easingTypes[this.props.easing],
      duration: duration || this.props.speed,
      endValue: endValue || this.getTargetLeft(),
      onEnd: callback || null
    });
  },

  getTargetLeft: function getTargetLeft(touchOffset, slide) {
    var offset;
    var target = slide || this.state.currentSlide;
    switch (this.props.cellAlign) {
      case 'left':
        {
          offset = 0;
          offset -= this.props.cellSpacing * target;
          break;
        }
      case 'center':
        {
          offset = (this.state.frameWidth - this.state.slideWidth) / 2;
          offset -= this.props.cellSpacing * target;
          break;
        }
      case 'right':
        {
          offset = this.state.frameWidth - this.state.slideWidth;
          offset -= this.props.cellSpacing * target;
          break;
        }
    }

    var left = this.state.slideWidth * target;

    var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

    if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
      left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
      offset = 0;
      offset -= this.props.cellSpacing * (this.state.slideCount - 1);
    }

    offset -= touchOffset || 0;

    return (left - offset) * -1;
  },

  // Bootstrapping

  bindEvents: function bindEvents() {
    var self = this;
    if (_exenv2['default'].canUseDOM) {
      addEvent(window, 'resize', self.onResize);
      addEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  onResize: function onResize() {
    this.setDimensions();
  },

  onReadyStateChange: function onReadyStateChange() {
    this.setDimensions();
  },

  unbindEvents: function unbindEvents() {
    var self = this;
    if (_exenv2['default'].canUseDOM) {
      removeEvent(window, 'resize', self.onResize);
      removeEvent(document, 'readystatechange', self.onReadyStateChange);
    }
  },

  formatChildren: function formatChildren(children) {
    var self = this;
    var positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
    return _react2['default'].Children.map(children, function (child, index) {
      return _react2['default'].createElement(
        'li',
        { className: 'slider-slide', style: self.getSlideStyles(index, positionValue), key: index },
        child
      );
    });
  },

  setInitialDimensions: function setInitialDimensions() {
    var self = this,
        slideWidth,
        frameHeight,
        slideHeight;

    slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
    slideHeight = this.props.initialSlideHeight ? this.props.initialSlideHeight * this.props.slidesToShow : 0;

    frameHeight = slideHeight + this.props.cellSpacing * (this.props.slidesToShow - 1);

    this.setState({
      slideHeight: slideHeight,
      frameWidth: this.props.vertical ? frameHeight : '100%',
      slideCount: _react2['default'].Children.count(this.props.children),
      slideWidth: slideWidth
    }, function () {
      self.setLeft();
      self.setExternalData();
    });
  },

  setDimensions: function setDimensions(props) {
    props = props || this.props;

    var self = this,
        slideWidth,
        slidesToScroll,
        firstSlide,
        frame,
        frameWidth,
        frameHeight,
        slideHeight;

    slidesToScroll = props.slidesToScroll;
    frame = this.refs.frame;
    firstSlide = frame.childNodes[0].childNodes[0];
    if (firstSlide) {
      firstSlide.style.height = 'auto';
      slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
    } else {
      slideHeight = 100;
    }

    if (typeof props.slideWidth !== 'number') {
      slideWidth = parseInt(props.slideWidth);
    } else {
      if (props.vertical) {
        slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
      } else {
        slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
      }
    }

    if (!props.vertical) {
      slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
    }

    frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
    frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

    if (props.slidesToScroll === 'auto') {
      slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
    }

    this.setState({
      slideHeight: slideHeight,
      frameWidth: frameWidth,
      slideWidth: slideWidth,
      slidesToScroll: slidesToScroll,
      left: props.vertical ? 0 : this.getTargetLeft(),
      top: props.vertical ? this.getTargetLeft() : 0
    }, function () {
      self.setLeft();
    });
  },

  setLeft: function setLeft() {
    this.setState({
      left: this.props.vertical ? 0 : this.getTargetLeft(),
      top: this.props.vertical ? this.getTargetLeft() : 0
    });
  },

  // Data

  setExternalData: function setExternalData() {
    if (this.props.data) {
      this.props.data();
    }
  },

  // Styles

  getListStyles: function getListStyles() {
    var listWidth = this.state.slideWidth * _react2['default'].Children.count(this.props.children);
    var spacingOffset = this.props.cellSpacing * _react2['default'].Children.count(this.props.children);
    var transform = 'translate3d(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px, 0)';
    return {
      transform: transform,
      WebkitTransform: transform,
      msTransform: 'translate(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px)',
      position: 'relative',
      display: 'block',
      margin: this.props.vertical ? this.props.cellSpacing / 2 * -1 + 'px 0px' : '0px ' + this.props.cellSpacing / 2 * -1 + 'px',
      padding: 0,
      height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
      width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
      cursor: this.state.dragging === true ? 'pointer' : 'inherit',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box'
    };
  },

  getFrameStyles: function getFrameStyles() {
    return {
      position: 'relative',
      display: 'block',
      overflow: this.props.frameOverflow,
      height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
      margin: this.props.framePadding,
      padding: 0,
      transform: 'translate3d(0, 0, 0)',
      WebkitTransform: 'translate3d(0, 0, 0)',
      msTransform: 'translate(0, 0)',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box'
    };
  },

  getSlideStyles: function getSlideStyles(index, positionValue) {
    var targetPosition = this.getSlideTargetPosition(index, positionValue);
    return {
      position: 'absolute',
      left: this.props.vertical ? 0 : targetPosition,
      top: this.props.vertical ? targetPosition : 0,
      display: this.props.vertical ? 'block' : 'inline-block',
      listStyleType: 'none',
      verticalAlign: 'top',
      width: this.props.vertical ? '100%' : this.state.slideWidth,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
      marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
      marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
    };
  },

  getSlideTargetPosition: function getSlideTargetPosition(index, positionValue) {
    var slidesToShow = this.state.frameWidth / this.state.slideWidth;
    var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
    var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;

    if (this.props.wrapAround) {
      var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
      if (this.state.slideCount - slidesBefore <= index) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
      }

      var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);

      if (this.state.slideWidth !== 1) {
        slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
      }

      if (index <= slidesAfter - 1) {
        return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
      }
    }

    return targetPosition;
  },

  getSliderStyles: function getSliderStyles() {
    return {
      position: 'relative',
      display: 'block',
      width: this.props.width,
      height: 'auto',
      boxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      visibility: this.state.slideWidth ? 'visible' : 'hidden'
    };
  },

  getStyleTagStyles: function getStyleTagStyles() {
    return '.slider-slide > img {width: 100%; display: block;}';
  },

  getDecoratorStyles: function getDecoratorStyles(position) {
    switch (position) {
      case 'TopLeft':
        {
          return {
            position: 'absolute',
            top: 0,
            left: 0
          };
        }
      case 'TopCenter':
        {
          return {
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            WebkitTransform: 'translateX(-50%)',
            msTransform: 'translateX(-50%)'
          };
        }
      case 'TopRight':
        {
          return {
            position: 'absolute',
            top: 0,
            right: 0
          };
        }
      case 'CenterLeft':
        {
          return {
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            WebkitTransform: 'translateY(-50%)',
            msTransform: 'translateY(-50%)'
          };
        }
      case 'CenterCenter':
        {
          return {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            WebkitTransform: 'translate(-50%, -50%)',
            msTransform: 'translate(-50%, -50%)'
          };
        }
      case 'CenterRight':
        {
          return {
            position: 'absolute',
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)',
            WebkitTransform: 'translateY(-50%)',
            msTransform: 'translateY(-50%)'
          };
        }
      case 'BottomLeft':
        {
          return {
            position: 'absolute',
            bottom: 0,
            left: 0
          };
        }
      case 'BottomCenter':
        {
          return {
            position: 'absolute',
            bottom: 0,
            width: '100%',
            textAlign: 'center'
          };
        }
      case 'BottomRight':
        {
          return {
            position: 'absolute',
            bottom: 0,
            right: 0
          };
        }
      default:
        {
          return {
            position: 'absolute',
            top: 0,
            left: 0
          };
        }
    }
  }

});

Carousel.ControllerMixin = {
  getInitialState: function getInitialState() {
    return {
      carousels: {}
    };
  },
  setCarouselData: function setCarouselData(carousel) {
    var data = this.state.carousels;
    data[carousel] = this.refs[carousel];
    this.setState({
      carousels: data
    });
  }
};

exports['default'] = Carousel;
module.exports = exports['default'];

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(621);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var DefaultDecorators = [{
  component: (0, _createReactClass2['default'])({
    render: function render() {
      return _react2['default'].createElement(
        'button',
        {
          style: this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround),
          onClick: this.handleClick },
        'PREV'
      );
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      this.props.previousSlide();
    },
    getButtonStyles: function getButtonStyles(disabled) {
      return {
        border: 0,
        background: 'rgba(0,0,0,0.4)',
        color: 'white',
        padding: 10,
        outline: 0,
        opacity: disabled ? 0.3 : 1,
        cursor: 'pointer'
      };
    }
  }),
  position: 'CenterLeft'
}, {
  component: (0, _createReactClass2['default'])({
    render: function render() {
      return _react2['default'].createElement(
        'button',
        {
          style: this.getButtonStyles(this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround),
          onClick: this.handleClick },
        'NEXT'
      );
    },
    handleClick: function handleClick(e) {
      e.preventDefault();
      this.props.nextSlide();
    },
    getButtonStyles: function getButtonStyles(disabled) {
      return {
        border: 0,
        background: 'rgba(0,0,0,0.4)',
        color: 'white',
        padding: 10,
        outline: 0,
        opacity: disabled ? 0.3 : 1,
        cursor: 'pointer'
      };
    }
  }),
  position: 'CenterRight'
}, {
  component: (0, _createReactClass2['default'])({
    render: function render() {
      var self = this;
      var indexes = this.getIndexes(self.props.slideCount, self.props.slidesToScroll);
      return _react2['default'].createElement(
        'ul',
        { style: self.getListStyles() },
        indexes.map(function (index) {
          return _react2['default'].createElement(
            'li',
            { style: self.getListItemStyles(), key: index },
            _react2['default'].createElement(
              'button',
              {
                style: self.getButtonStyles(self.props.currentSlide === index),
                onClick: self.props.goToSlide.bind(null, index) },
              '•'
            )
          );
        })
      );
    },
    getIndexes: function getIndexes(count, inc) {
      var arr = [];
      for (var i = 0; i < count; i += inc) {
        arr.push(i);
      }
      return arr;
    },
    getListStyles: function getListStyles() {
      return {
        position: 'relative',
        margin: 0,
        top: -10,
        padding: 0
      };
    },
    getListItemStyles: function getListItemStyles() {
      return {
        listStyleType: 'none',
        display: 'inline-block'
      };
    },
    getButtonStyles: function getButtonStyles(active) {
      return {
        border: 0,
        background: 'transparent',
        color: 'black',
        cursor: 'pointer',
        padding: 10,
        outline: 0,
        fontSize: 24,
        opacity: active ? 1 : 0.5
      };
    }
  }),
  position: 'BottomCenter'
}];

exports['default'] = DefaultDecorators;
module.exports = exports['default'];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(24);

var emptyObject = __webpack_require__(138);
var _invariant = __webpack_require__(15);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    getDefaultProps: function getDefaultProps() {
        return {
            prefixCls: 'rmc-multi-picker',
            onValueChange: function onValueChange() {}
        };
    },
    getValue: function getValue() {
        var _props = this.props,
            children = _props.children,
            selectedValue = _props.selectedValue;

        if (selectedValue && selectedValue.length) {
            return selectedValue;
        } else {
            if (!children) {
                return [];
            }
            return _react2['default'].Children.map(children, function (c) {
                var cc = _react2['default'].Children.toArray(c.props.children);
                return cc && cc[0] && cc[0].props.value;
            });
        }
    },
    onValueChange: function onValueChange(i, v) {
        var value = this.getValue().concat();
        value[i] = v;
        this.props.onValueChange(value, i);
    }
};
module.exports = exports['default'];

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    select: function select(value) {
        var children = _react2['default'].Children.toArray(this.props.children);
        for (var i = 0, len = children.length; i < len; i++) {
            if (children[i].props.value === value) {
                this.selectByIndex(i);
                return;
            }
        }
        this.selectByIndex(0);
    },
    selectByIndex: function selectByIndex(index) {
        if (index < 0 || index >= _react2['default'].Children.count(this.props.children) || !this.itemHeight) {
            return;
        }
        this.scrollTo(index * this.itemHeight);
    },
    doScrollingComplete: function doScrollingComplete(top) {
        var index = top / this.itemHeight;
        var floor = Math.floor(index);
        if (index - floor > 0.5) {
            index = floor + 1;
        } else {
            index = floor;
        }
        var children = _react2['default'].Children.toArray(this.props.children);
        index = Math.min(index, children.length - 1);
        var child = children[index];
        if (child) {
            this.fireValueChange(child.props.value);
        } else if (console.warn) {
            console.warn('child not found', children, index);
        }
    }
}; /* tslint:disable:no-console */

module.exports = exports['default'];

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(623);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}
exports['default'] = {
    getDefaultProps: function getDefaultProps() {
        return {
            onVisibleChange: noop,
            okText: 'Ok',
            pickerValueProp: 'selectedValue',
            pickerValueChangeProp: 'onValueChange',
            dismissText: 'Dismiss',
            title: '',
            onOk: noop,
            onDismiss: noop
        };
    },
    getInitialState: function getInitialState() {
        return {
            pickerValue: 'value' in this.props ? this.props.value : null,
            visible: this.props.visible || false
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if ('value' in nextProps) {
            this.setState({
                pickerValue: nextProps.value
            });
        }
        if ('visible' in nextProps) {
            this.setVisibleState(nextProps.visible);
        }
    },
    onPickerChange: function onPickerChange(pickerValue) {
        if (this.state.pickerValue !== pickerValue) {
            this.setState({
                pickerValue: pickerValue
            });
            var _props = this.props,
                picker = _props.picker,
                pickerValueChangeProp = _props.pickerValueChangeProp;

            if (picker && picker.props[pickerValueChangeProp]) {
                picker.props[pickerValueChangeProp](pickerValue);
            }
        }
    },
    saveRef: function saveRef(picker) {
        this.picker = picker;
    },
    setVisibleState: function setVisibleState(visible) {
        this.setState({
            visible: visible
        });
        if (!visible) {
            this.setState({
                pickerValue: null
            });
        }
    },
    fireVisibleChange: function fireVisibleChange(visible) {
        if (this.state.visible !== visible) {
            if (!('visible' in this.props)) {
                this.setVisibleState(visible);
            }
            this.props.onVisibleChange(visible);
        }
    },
    getRender: function getRender() {
        var props = this.props;
        var children = props.children;
        if (!children) {
            return this.getModal();
        }
        var _props2 = this.props,
            WrapComponent = _props2.WrapComponent,
            disabled = _props2.disabled;

        var child = children;
        var newChildProps = {};
        if (!disabled) {
            newChildProps[props.triggerType] = this.onTriggerClick;
        }
        return _react2['default'].createElement(
            WrapComponent,
            { style: props.wrapStyle },
            _react2['default'].cloneElement(child, newChildProps),
            this.getModal()
        );
    },
    onTriggerClick: function onTriggerClick(e) {
        var child = this.props.children;
        var childProps = child.props || {};
        if (childProps[this.props.triggerType]) {
            childProps[this.props.triggerType](e);
        }
        this.fireVisibleChange(!this.state.visible);
    },
    onOk: function onOk() {
        this.props.onOk(this.picker && this.picker.getValue());
        this.fireVisibleChange(false);
    },
    getContent: function getContent() {
        if (this.props.picker) {
            var _React$cloneElement;

            var pickerValue = this.state.pickerValue;

            if (pickerValue === null) {
                pickerValue = this.props.value;
            }
            return _react2['default'].cloneElement(this.props.picker, (_React$cloneElement = {}, (0, _defineProperty3['default'])(_React$cloneElement, this.props.pickerValueProp, pickerValue), (0, _defineProperty3['default'])(_React$cloneElement, this.props.pickerValueChangeProp, this.onPickerChange), (0, _defineProperty3['default'])(_React$cloneElement, 'ref', this.saveRef), _React$cloneElement));
        } else {
            return this.props.content;
        }
    },
    onDismiss: function onDismiss() {
        this.props.onDismiss();
        this.fireVisibleChange(false);
    },
    hide: function hide() {
        this.fireVisibleChange(false);
    }
};
module.exports = exports['default'];

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(38), __esModule: true };

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

(function(host) {

  var properties = {
    browser: [
      [/msie ([\.\_\d]+)/, "ie"],
      [/trident\/.*?rv:([\.\_\d]+)/, "ie"],
      [/firefox\/([\.\_\d]+)/, "firefox"],
      [/chrome\/([\.\_\d]+)/, "chrome"],
      [/version\/([\.\_\d]+).*?safari/, "safari"],
      [/mobile safari ([\.\_\d]+)/, "safari"],
      [/android.*?version\/([\.\_\d]+).*?safari/, "com.android.browser"],
      [/crios\/([\.\_\d]+).*?safari/, "chrome"],
      [/opera/, "opera"],
      [/opera\/([\.\_\d]+)/, "opera"],
      [/opera ([\.\_\d]+)/, "opera"],
      [/opera mini.*?version\/([\.\_\d]+)/, "opera.mini"],
      [/opios\/([a-z\.\_\d]+)/, "opera"],
      [/blackberry/, "blackberry"],
      [/blackberry.*?version\/([\.\_\d]+)/, "blackberry"],
      [/bb\d+.*?version\/([\.\_\d]+)/, "blackberry"],
      [/rim.*?version\/([\.\_\d]+)/, "blackberry"],
      [/iceweasel\/([\.\_\d]+)/, "iceweasel"],
      [/edge\/([\.\d]+)/, "edge"]
    ],
    os: [
      [/linux ()([a-z\.\_\d]+)/, "linux"],
      [/mac os x/, "macos"],
      [/mac os x.*?([\.\_\d]+)/, "macos"],
      [/os ([\.\_\d]+) like mac os/, "ios"],
      [/openbsd ()([a-z\.\_\d]+)/, "openbsd"],
      [/android/, "android"],
      [/android ([a-z\.\_\d]+);/, "android"],
      [/mozilla\/[a-z\.\_\d]+ \((?:mobile)|(?:tablet)/, "firefoxos"],
      [/windows\s*(?:nt)?\s*([\.\_\d]+)/, "windows"],
      [/windows phone.*?([\.\_\d]+)/, "windows.phone"],
      [/windows mobile/, "windows.mobile"],
      [/blackberry/, "blackberryos"],
      [/bb\d+/, "blackberryos"],
      [/rim.*?os\s*([\.\_\d]+)/, "blackberryos"]
    ],
    device: [
      [/ipad/, "ipad"],
      [/iphone/, "iphone"],
      [/lumia/, "lumia"],
      [/htc/, "htc"],
      [/nexus/, "nexus"],
      [/galaxy nexus/, "galaxy.nexus"],
      [/nokia/, "nokia"],
      [/ gt\-/, "galaxy"],
      [/ sm\-/, "galaxy"],
      [/xbox/, "xbox"],
      [/(?:bb\d+)|(?:blackberry)|(?: rim )/, "blackberry"]
    ]
  };

  var UNKNOWN = "Unknown";

  var propertyNames = Object.keys(properties);

  function Sniffr() {
    var self = this;

    propertyNames.forEach(function(propertyName) {
      self[propertyName] = {
        name: UNKNOWN,
        version: [],
        versionString: UNKNOWN
      };
    });
  }

  function determineProperty(self, propertyName, userAgent) {
    properties[propertyName].forEach(function(propertyMatcher) {
      var propertyRegex = propertyMatcher[0];
      var propertyValue = propertyMatcher[1];

      var match = userAgent.match(propertyRegex);

      if (match) {
        self[propertyName].name = propertyValue;

        if (match[2]) {
          self[propertyName].versionString = match[2];
          self[propertyName].version = [];
        } else if (match[1]) {
          self[propertyName].versionString = match[1].replace(/_/g, ".");
          self[propertyName].version = parseVersion(match[1]);
        } else {
          self[propertyName].versionString = UNKNOWN;
          self[propertyName].version = [];
        }
      }
    });
  }

  function parseVersion(versionString) {
    return versionString.split(/[\._]/).map(function(versionPart) {
      return parseInt(versionPart);
    });
  }

  Sniffr.prototype.sniff = function(userAgentString) {
    var self = this;
    var userAgent = (userAgentString || navigator.userAgent || "").toLowerCase();

    propertyNames.forEach(function(propertyName) {
      determineProperty(self, propertyName, userAgent);
    });
  };


  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Sniffr;
  } else {
    host.Sniffr = new Sniffr();
    host.Sniffr.sniff(navigator.userAgent);
  }
})(this);


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 48 48\" id=\"check-circle-o\" ><g fill-rule=\"evenodd\"><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z\"/><path d=\"M12.2 23.2L10 25.3l10 9.9L37.2 15 35 13 19.8 30.8z\"/></g></symbol>";
module.exports = sprite.add(image, "check-circle-o");

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 48 48\" id=\"check-circle\" ><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zM13.1 23.2l-2.2 2.1 10 9.9L38.1 15l-2.2-2-15.2 17.8-7.6-7.6z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "check-circle");

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"check\" ><title>Operation Icons Copy 6</title><path d=\"M34.538 8L38 11.518 17.808 32 8 22.033l3.462-3.518 6.346 6.45z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "check");

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 48 48\" id=\"cross-circle-o\" ><title>step-48-&#x9519;&#x8BEF;-&#x5B9E;&#x5FC3;</title><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.799-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.721 7.723c-.726.728-.558 1.646-.065 2.177.494.532 1.554.683 2.312-.174l7.587-7.584 7.644 7.623c.796.799 1.608.725 2.211.146.604-.579.72-1.442-.075-2.24l-7.657-7.669 7.544-7.521c.811-.697.9-1.76.297-2.34-.92-.885-1.849-.338-2.264.078l-7.685 7.667z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "cross-circle-o");

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 48 48\" id=\"cross-circle\" ><g fill-rule=\"evenodd\"><path d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z\"/><path d=\"M24.34 22.219l-7.775-7.774a1.499 1.499 0 1 0-2.121 2.121l7.774 7.774-7.774 7.775a1.499 1.499 0 1 0 2.12 2.12l7.775-7.773 7.775 7.774a1.499 1.499 0 1 0 2.121-2.121L26.46 24.34l7.774-7.774a1.499 1.499 0 1 0-2.121-2.121l-7.775 7.774z\"/></g></symbol>";
module.exports = sprite.add(image, "cross-circle");

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"cross\" ><path d=\"M24.008 21.852l8.969-8.968L31.093 11l-8.969 8.968L13.156 11l-1.884 1.884 8.968 8.968-9.24 9.24 1.884 1.885 9.24-9.24 9.24 9.24 1.885-1.884-9.24-9.24z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "cross");

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"down\" ><title>Operation Icons Copy 4</title><path d=\"M22.355 28.237l-11.483-10.9c-.607-.576-1.714-.396-2.48.41l.674-.71c-.763.802-.73 2.071-.282 2.496l11.37 10.793-.04.039 2.088 2.196 1.098-1.043 12.308-11.682c.447-.425.48-1.694-.282-2.496l.674.71c-.766-.806-1.873-.986-2.48-.41L22.355 28.237z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "down");

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis-circle\" ><title>ellipsis-circle-cp</title><g fill-rule=\"evenodd\"><path d=\"M22.13.109C10.049.109.255 9.903.255 21.984s9.794 21.875 21.875 21.875 21.875-9.794 21.875-21.875S34.211.109 22.13.109zm0 40.7c-10.396 0-18.825-8.429-18.825-18.825 0-10.396 8.429-18.825 18.825-18.825 10.396 0 18.825 8.429 18.825 18.825 0 10.396-8.429 18.825-18.825 18.825z\"/><circle cx=\"21.888\" cy=\"22.701\" r=\"2.445\"/><circle cx=\"12.23\" cy=\"22.701\" r=\"2.445\"/><circle cx=\"31.546\" cy=\"22.701\" r=\"2.445\"/></g></symbol>";
module.exports = sprite.add(image, "ellipsis-circle");

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis\" ><circle cx=\"21.888\" cy=\"22\" r=\"4.045\"/><circle cx=\"5.913\" cy=\"22\" r=\"4.045\"/><circle cx=\"37.863\" cy=\"22\" r=\"4.045\"/></symbol>";
module.exports = sprite.add(image, "ellipsis");

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 64 64\" id=\"exclamation-circle\" ><title>Share Icons Copy 3</title><path d=\"M59.58 40.889L41.193 9.11C39.135 5.382 35.723 3 31.387 3c-3.11 0-6.521 2.382-8.58 6.111L4.42 40.89c-2.788 4.635-3.126 8.81-1.225 12.22C5.015 56.208 7.572 58 13 58h36.773c5.428 0 9.21-1.792 11.031-4.889 1.9-3.41 1.564-7.584-1.225-12.222zm-2.452 11c-.635 1.695-3.802 2.444-7.354 2.444H13c-3.591 0-5.493-.75-6.129-2.444-1.712-2.41-1.375-5.262 0-8.556l18.386-31.777c2.116-3.168 4.394-4.89 6.13-4.89 2.96 0 5.238 1.722 7.354 4.89l18.386 31.777c1.374 3.294 1.713 6.146 0 8.556zm-25.74-33c-.405 0-1.227.836-1.227 2.444v15.89c0 1.608.822 2.444 1.226 2.444 1.628 0 2.452-.836 2.452-2.445V21.333c0-1.608-.824-2.444-2.452-2.444zm0 23.222c-.405 0-1.227.788-1.227 1.222v2.445c0 .434.822 1.222 1.226 1.222 1.628 0 2.452-.788 2.452-1.222v-2.445c0-.434-.824-1.222-2.452-1.222z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "exclamation-circle");

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"info-circle\" ><circle cx=\"13.828\" cy=\"19.63\" r=\"1.938\"/><circle cx=\"21.767\" cy=\"19.63\" r=\"1.938\"/><circle cx=\"29.767\" cy=\"19.63\" r=\"1.938\"/><path d=\"M22.102 4.161c-9.918 0-17.958 7.146-17.958 15.961 0 4.935 2.522 9.345 6.481 12.273v5.667l.038.012a2.627 2.627 0 1 0 4.501 1.455l.002.001 5.026-3.539c.628.059 1.265.093 1.911.093 9.918 0 17.958-7.146 17.958-15.961-.001-8.816-8.041-15.962-17.959-15.962zm-.04 29.901c-.902 0-1.781-.081-2.642-.207l-5.882 4.234c-.024.025-.055.04-.083.06l-.008.006a.511.511 0 0 1-.284.095.525.525 0 0 1-.525-.525l.005-6.375c-3.91-2.516-6.456-6.544-6.456-11.1 0-7.628 7.107-13.812 15.875-13.812s15.875 6.184 15.875 13.812-7.107 13.812-15.875 13.812z\"/></symbol>";
module.exports = sprite.add(image, "info-circle");

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 43 38\" id=\"koubei-o\" ><path d=\"M37.75.227H5.25C2.125.227.66 2.652.66 4.542v8.03c0 9.346 5.751 17.213 13.64 20.35a.732.732 0 0 1 .325.246c.145.207.128.409.128.409l.001 2.033s.241.743.667 1.167c.254.254.899.545 1.201.577.929.099 2.059.226 4.716-.125a25.097 25.097 0 0 0 13.111-5.918c6.157-5.345 8.549-12.549 8.549-18.738V4.625c0-1.89-1.206-4.398-5.248-4.398zm3.287 13.045c0 5.58-2.277 11.784-7.87 16.603-3.366 2.896-7.511 4.831-11.917 5.417-2.413.317-3.347.186-4.191.096-.275-.029-.496-.076-.392-1.013.104-1.958-.194-2.156-.325-2.342-.076-.1-.261-.287-.378-.332C8.797 28.874 2.577 21.698 2.577 13.272V5.203c0-1.703.335-3.06 3.173-3.06h31.292c3.671 0 3.995 1.174 3.995 2.878v8.251z\"/><path d=\"M32.531 19.444c-.336 0-.62.171-.809.42l-.01-.007-.002-.001a11.61 11.61 0 0 1-9.682 5.196c-6.419 0-11.623-5.204-11.623-11.623h-.038a1.027 1.027 0 0 0-1.023-.995c-.556 0-1.003.443-1.023.995h-.007l.001.029-.001.007.002.012c.026 7.552 6.154 13.667 13.713 13.667 4.757 0 8.945-2.423 11.406-6.101 0 0 .127-.368.127-.57a1.031 1.031 0 0 0-1.031-1.029z\"/><ellipse cx=\"35.456\" cy=\"12.506\" rx=\"1.95\" ry=\"1.918\"/></symbol>";
module.exports = sprite.add(image, "koubei-o");

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 43 38\" id=\"koubei\" ><title>&#x53E3;&#x7891;</title><g fill-rule=\"evenodd\"><path d=\"M4.921 1.227c-1.814 0-3.284 1.452-3.284 3.243v8.459c0 8.86 6.073 16.517 13.589 19.49a.701.701 0 0 1 .31.233c.138.196.122.388.122.388v2.148s-.012.463.393.865c.242.241.506.338.794.368.885.094 1.962.214 4.493-.119a23.972 23.972 0 0 0 12.492-5.61c5.866-5.067 8.145-11.896 8.145-17.763V4.563c0-1.792-1.47-3.336-3.285-3.336H4.92z\"/><path d=\"M33.506 12.506c0-1.06.873-1.918 1.95-1.918 1.078 0 1.95.858 1.95 1.918 0 1.059-.872 1.918-1.95 1.918-1.077 0-1.95-.86-1.95-1.918z\" fill=\"#FFF\"/><path d=\"M9.127 13.465c0 6.087 5.564 12.847 12.626 12.784 3.336-.03 8.006-1.522 10.778-5.784\" stroke=\"#FFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></g></symbol>";
module.exports = sprite.add(image, "koubei");

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"left\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><defs><path id=\"left_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"left_b\"><use xlink:href=\"#left_a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#left_b)\"><defs><path id=\"left_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"left_d\"><use xlink:href=\"#left_c\" overflow=\"visible\"/></clipPath></g><path d=\"M16.247 21.399L28.48 9.166l2.121 2.121-10.118 10.119 10.118 10.118-2.121 2.121-12.233-12.233.007-.006z\"/></symbol>";
module.exports = sprite.add(image, "left");

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 -2 59.75 60.25\" id=\"loading\" ><path fill=\"#ccc\" d=\"M29.691-.527c-15.648 0-28.333 12.685-28.333 28.333s12.685 28.333 28.333 28.333c15.648 0 28.333-12.685 28.333-28.333S45.339-.527 29.691-.527zm.184 53.75c-14.037 0-25.417-11.379-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.379 25.417 25.417-11.38 25.416-25.417 25.416z\"/><path fill=\"none\" stroke=\"#108ee9\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" d=\"M56.587 29.766c.369-7.438-1.658-14.699-6.393-19.552\"/></symbol>";
module.exports = sprite.add(image, "loading");

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"question-circle\" ><title>Operation Icons Copy 12</title><g fill-rule=\"evenodd\"><path d=\"M21.186 3C10.333 3 1.827 11.506 1.827 22.358 1.827 32.494 10.333 41 21.186 41c10.133 0 18.641-8.506 18.641-18.642C39.827 11.506 31.32 3 21.186 3m15.641 19c0 8.823-7.179 16-16 16-8.823 0-16-7.177-16-16s7.177-16 16-16c8.821 0 16 7.177 16 16z\"/><path d=\"M22.827 31.5a1.5 1.5 0 1 1-2.999.001 1.5 1.5 0 0 1 3-.001M26.827 16.02c0 .957-.203 1.822-.61 2.593-.427.792-1.117 1.612-2.073 2.457-.867.734-1.453 1.435-1.754 2.096-.302.7-.453 1.693-.453 2.979a.828.828 0 0 1-.823.855.828.828 0 0 1-.584-.22.877.877 0 0 1-.24-.635c0-1.305.168-2.38.506-3.227.336-.883.93-1.682 1.779-2.4 1.01-.883 1.71-1.692 2.1-2.428.337-.645.504-1.38.504-2.209-.018-.936-.3-1.7-.85-2.289-.654-.717-1.62-1.075-2.896-1.075-1.506 0-2.596.535-3.269 1.6-.46.754-.689 1.645-.689 2.677a.92.92 0 0 1-.266.66.747.747 0 0 1-.558.25.73.73 0 0 1-.585-.194c-.16-.164-.239-.393-.239-.69 0-1.819.584-3.272 1.754-4.357C18.644 11.486 19.927 11 21.433 11h.293c1.452 0 2.638.414 3.561 1.241 1.027.902 1.54 2.162 1.54 3.78z\"/></g></symbol>";
module.exports = sprite.add(image, "question-circle");

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"right\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><defs><path id=\"right_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"right_b\"><use xlink:href=\"#right_a\" overflow=\"visible\"/></clipPath><g clip-path=\"url(#right_b)\"><defs><path id=\"right_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"right_d\"><use xlink:href=\"#right_c\" overflow=\"visible\"/></clipPath></g><path d=\"M30.601 21.399L18.368 9.166l-2.121 2.121 10.118 10.119-10.118 10.118 2.121 2.121 12.233-12.233-.006-.006z\"/></symbol>";
module.exports = sprite.add(image, "right");

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"search\" ><title>System Icons Copy 8</title><path d=\"M32.981 29.255l8.914 8.293L39.603 40l-8.859-8.242a15.952 15.952 0 0 1-10.754 4.147C11.16 35.905 4 28.763 4 19.952 4 11.142 11.16 4 19.99 4s15.99 7.142 15.99 15.952c0 3.472-1.112 6.685-2.999 9.303zm.05-9.21c0 7.123-5.701 12.918-12.88 12.918-7.177 0-13.016-5.795-13.016-12.918 0-7.12 5.839-12.917 13.017-12.917 7.178 0 12.879 5.797 12.879 12.917z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "search");

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 44 44\" id=\"up\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Operation Icons Copy 4</title><title>background</title><path fill=\"none\" d=\"M-1-1h46v46H-1z\"/><g><title>Layer 1</title><defs><path id=\"up_a\" d=\"M-129-845h24v24h-24z\"/></defs><clipPath id=\"up_b\"><use xlink:href=\"#up_a\"/></clipPath><g clip-path=\"url(#up_b)\"><defs><path id=\"up_c\" d=\"M-903-949H947V996H-903z\"/></defs><clipPath id=\"up_d\"><use xlink:href=\"#up_c\"/></clipPath></g><path d=\"M23.417 14.229L11.184 26.462l2.121 2.12 10.12-10.117 10.117 10.118 2.121-2.121L23.43 14.229l-.006.006z\"/></g></symbol>";
module.exports = sprite.add(image, "up");

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 38 33\" id=\"trips\" ><title>trips</title><g fill-rule=\"evenodd\"><path d=\"M17.838 28.8c-.564-.468-1.192-.983-1.836-1.496-4.244-3.385-5.294-3.67-6.006-3.67-.014 0-.027.005-.04.005-.015 0-.028-.005-.042-.005H3.562c-.734 0-.903-.203-.903-.928V10.085c0-.49.058-.8.66-.8h5.782c.693 0 1.758-.28 6.4-3.628.828-.597 1.637-1.197 2.336-1.723V28.8zM19.682.19c-.463-.22-1.014-.158-1.417.157-.02.016-1.983 1.552-4.152 3.125C10.34 6.21 9.243 6.664 9.02 6.737H3.676c-.027 0-.053.003-.08.004H1.183c-.608 0-1.1.486-1.1 1.085V25.14c0 .598.492 1.084 1.1 1.084h8.71c.22.08 1.257.55 4.605 3.24 1.947 1.562 3.694 3.088 3.712 3.103.25.22.568.333.89.333.186 0 .373-.038.55-.116.48-.213.79-.684.79-1.204V1.38c0-.506-.294-.968-.758-1.19z\" mask=\"url(#mask-2)\"/><path d=\"M31.42 16.475c0-3.363-1.854-6.297-4.606-7.876-.125-.066-.42-.192-.625-.192-.612 0-1.108.488-1.108 1.09 0 .404.22.764.55.952 2.128 1.19 3.565 3.442 3.565 6.025 0 2.627-1.486 4.913-3.677 6.087-.318.19-.53.54-.53.934 0 .602.496 1.09 1.107 1.09.26.002.568-.15.568-.15 2.835-1.556 4.754-4.538 4.754-7.96\" mask=\"url(#mask-4)\"/><g><path d=\"M30.14 3.057c-.205-.122-.41-.22-.658-.22-.608 0-1.1.485-1.1 1.084 0 .433.26.78.627.977 4.043 2.323 6.762 6.636 6.762 11.578 0 4.938-2.716 9.248-6.755 11.572-.354.19-.66.55-.66.993 0 .6.494 1.084 1.102 1.084.243 0 .438-.092.65-.213 4.692-2.695 7.848-7.7 7.848-13.435 0-5.723-3.142-10.718-7.817-13.418\" mask=\"url(#mask-6)\"/></g></g></symbol>";
module.exports = sprite.add(image, "trips");

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 30 2\" id=\"minus\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <defs/> <g id=\"minus_Page-1\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <rect id=\"minus_Rectangle\" fill-rule=\"evenodd\" x=\"0\" y=\"0\" width=\"30\" height=\"2\"/> </g> </symbol>";
module.exports = sprite.add(image, "minus");

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 30 30\" id=\"plus\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <defs/> <g id=\"plus_Page-1\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\"> <path fill-rule=\"evenodd\" d=\"M14,14 L0,14 L0,16 L14,16 L14,30 L16,30 L16,16 L30,16 L30,14 L16,14 L16,-1.77635684e-15 L14,-2.14375088e-15 L14,14 Z\" id=\"plus_Combined-Shape\"/> </g> </symbol>";
module.exports = sprite.add(image, "plus");

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 72 72\" id=\"dislike\" ><title>&#x54ED;&#x8138;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path fill=\"#FFF\" d=\"M47 22h2v6h-2zM23 22h2v6h-2z\"/><path d=\"M21 51s4.6-7 15-7 15 7 15 7\" stroke=\"#FFF\" stroke-width=\"2\"/></g></symbol>";
module.exports = sprite.add(image, "dislike");

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 72 72\" id=\"fail\" ><title>&#x5931;&#x8D25;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path d=\"M22 22l28.304 28.304M22 50.304L50.304 22\" stroke=\"#FFF\" stroke-width=\"2\"/></g></symbol>";
module.exports = sprite.add(image, "fail");

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {


var sprite = __webpack_require__(30);
var image = "<symbol viewBox=\"0 0 72 72\" id=\"success\" ><title>&#x6210;&#x529F;</title><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z\" fill=\"#FFF\"/><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M19 34.54l11.545 11.923L52.815 24\"/></g></symbol>";
module.exports = sprite.add(image, "success");

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

var Sniffr = __webpack_require__(1630);

/**
 * List of SVG attributes to fix url target in them
 * @type {string[]}
 */
var fixAttributes = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke'
];

/**
 * Query to find'em
 * @type {string}
 */
var fixAttributesQuery = '[' + fixAttributes.join('],[') + ']';
/**
 * @type {RegExp}
 */
var URI_FUNC_REGEX = /^url\((.*)\)$/;

/**
 * Convert array-like to array
 * @param {Object} arrayLike
 * @returns {Array.<*>}
 */
function arrayFrom(arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
}

/**
 * Handles forbidden symbols which cannot be directly used inside attributes with url(...) content.
 * Adds leading slash for the brackets
 * @param {string} url
 * @return {string} encoded url
 */
function encodeUrlForEmbedding(url) {
  return url.replace(/\(|\)/g, "\\$&");
}

/**
 * Replaces prefix in `url()` functions
 * @param {Element} svg
 * @param {string} currentUrlPrefix
 * @param {string} newUrlPrefix
 */
function baseUrlWorkAround(svg, currentUrlPrefix, newUrlPrefix) {
  var nodes = svg.querySelectorAll(fixAttributesQuery);

  if (!nodes) {
    return;
  }

  arrayFrom(nodes).forEach(function (node) {
    if (!node.attributes) {
      return;
    }

    arrayFrom(node.attributes).forEach(function (attribute) {
      var attributeName = attribute.localName.toLowerCase();

      if (fixAttributes.indexOf(attributeName) !== -1) {
        var match = URI_FUNC_REGEX.exec(node.getAttribute(attributeName));

        // Do not touch urls with unexpected prefix
        if (match && match[1].indexOf(currentUrlPrefix) === 0) {
          var referenceUrl = encodeUrlForEmbedding(newUrlPrefix + match[1].split(currentUrlPrefix)[1]);
          node.setAttribute(attributeName, 'url(' + referenceUrl + ')');
        }
      }
    });
  });
}

/**
 * Because of Firefox bug #353575 gradients and patterns don't work if they are within a symbol.
 * To workaround this we move the gradient definition outside the symbol element
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
 * @param {Element} svg
 */
var FirefoxSymbolBugWorkaround = function (svg) {
  var defs = svg.querySelector('defs');

  var moveToDefsElems = svg.querySelectorAll('symbol linearGradient, symbol radialGradient, symbol pattern');
  for (var i = 0, len = moveToDefsElems.length; i < len; i++) {
    defs.appendChild(moveToDefsElems[i]);
  }
};

/**
 * Fix for browser (IE, maybe other too) which are throwing 'WrongDocumentError'
 * if you insert an element which is not part of the document
 * @see http://stackoverflow.com/questions/7981100/how-do-i-dynamically-insert-an-svg-image-into-html#7986519
 * @param {Element} svg
 */
function importSvg(svg) {
  try {
    if (document.importNode) {
      return document.importNode(svg, true);
    }
  } catch(e) {}

  return svg;
}

/**
 * @type {string}
 */
var DEFAULT_URI_PREFIX = '#';

/**
 * @type {string}
 */
var xLinkHref = 'xlink:href';
/**
 * @type {string}
 */
var xLinkNS = 'http://www.w3.org/1999/xlink';
/**
 * @type {string}
 */
var svgOpening = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="' + xLinkNS + '"';
/**
 * @type {string}
 */
var svgClosing = '</svg>';
/**
 * @type {string}
 */
var contentPlaceHolder = '{content}';

/**
 * Representation of SVG sprite
 * @constructor
 */
function Sprite() {
  var baseElement = document.getElementsByTagName('base')[0];
  var currentUrl = window.location.href.split('#')[0];
  var baseUrl = baseElement && baseElement.href;
  this.urlPrefix = baseUrl && baseUrl !== currentUrl ? currentUrl + DEFAULT_URI_PREFIX : DEFAULT_URI_PREFIX;

  var sniffr = new Sniffr();
  sniffr.sniff();
  this.browser = sniffr.browser;
  this.content = [];

  if (this.browser.name !== 'ie' && baseUrl) {
    window.addEventListener('spriteLoaderLocationUpdated', function (e) {
      var currentPrefix = this.urlPrefix;
      var newUrlPrefix = e.detail.newUrl.split(DEFAULT_URI_PREFIX)[0] + DEFAULT_URI_PREFIX;
      baseUrlWorkAround(this.svg, currentPrefix, newUrlPrefix);
      this.urlPrefix = newUrlPrefix;

      // Don't update <use>s only for Chrome lower than 49
      if (this.browser.name !== 'chrome' || this.browser.version[0] >= 49) {
        var nodes = arrayFrom(document.querySelectorAll('use[*|href]'));
        nodes.forEach(function (node) {
          var href = node.getAttribute(xLinkHref);
          if (href && href.indexOf(currentPrefix) === 0) {
            node.setAttributeNS(xLinkNS, xLinkHref, newUrlPrefix + href.split(DEFAULT_URI_PREFIX)[1]);
          }
        });
      }
    }.bind(this));
  }
}

Sprite.styles = ['position:absolute', 'width:0', 'height:0'];

Sprite.spriteTemplate = function(){ return svgOpening + ' style="'+ Sprite.styles.join(';') +'"><defs>' + contentPlaceHolder + '</defs>' + svgClosing; }
Sprite.symbolTemplate = function() { return svgOpening + '>' + contentPlaceHolder + svgClosing; }

/**
 * @type {Array<String>}
 */
Sprite.prototype.content = null;

/**
 * @param {String} content
 * @param {String} id
 */
Sprite.prototype.add = function (content, id) {
  if (this.svg) {
    this.appendSymbol(content);
  }

  this.content.push(content);

  return DEFAULT_URI_PREFIX + id;
};

/**
 *
 * @param content
 * @param template
 * @returns {Element}
 */
Sprite.prototype.wrapSVG = function (content, template) {
  var svgString = template.replace(contentPlaceHolder, content);

  var svg = new DOMParser().parseFromString(svgString, 'image/svg+xml').documentElement;
  var importedSvg = importSvg(svg);

  if (this.browser.name !== 'ie' && this.urlPrefix) {
    baseUrlWorkAround(importedSvg, DEFAULT_URI_PREFIX, this.urlPrefix);
  }

  return importedSvg;
};

Sprite.prototype.appendSymbol = function (content) {
  var symbol = this.wrapSVG(content, Sprite.symbolTemplate()).childNodes[0];

  this.svg.querySelector('defs').appendChild(symbol);
  if (this.browser.name === 'firefox') {
    FirefoxSymbolBugWorkaround(this.svg);
  }
};

/**
 * @returns {String}
 */
Sprite.prototype.toString = function () {
  var wrapper = document.createElement('div');
  wrapper.appendChild(this.render());
  return wrapper.innerHTML;
};

/**
 * @param {HTMLElement} [target]
 * @param {Boolean} [prepend=true]
 * @returns {HTMLElement} Rendered sprite node
 */
Sprite.prototype.render = function (target, prepend) {
  target = target || null;
  prepend = typeof prepend === 'boolean' ? prepend : true;

  var svg = this.wrapSVG(this.content.join(''), Sprite.spriteTemplate());

  if (this.browser.name === 'firefox') {
    FirefoxSymbolBugWorkaround(svg);
  }

  if (target) {
    if (prepend && target.childNodes[0]) {
      target.insertBefore(svg, target.childNodes[0]);
    } else {
      target.appendChild(svg);
    }
  }

  this.svg = svg;

  return svg;
};

module.exports = Sprite;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1659);


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1660);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52), __webpack_require__(396)(module)))

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/014ty@2x.6c590dcc.png";

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/014ty@3x.74a87f3b.png";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/015ty@2x.edc41885.png";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/015ty@3x.4e71bf80.png";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/016ty@2x.8fd090e3.png";

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/016ty@3x.b0518336.png";

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/017ty@2x.06f3efd3.png";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/017ty@3x.2082cca8.png";

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/018ty@2x.c7af2cae.png";

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/018ty@3x.fd582743.png";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/021ty@2x.1c3945e4.png";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/021ty@3x.ef3aa144.png";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/022ty@2x.f1b9e71f.png";

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/022ty@3x.ae1b6c1c.png";

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/14-3.6291307e.png";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.bacba50d.jpg";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/601Hou.3d1e97b9.png";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/601Hou@4x.18e7f9a1.png";

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/60Hou.d7d3a72f.png";

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/60Hou@4x.00ff060b.png";

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/60Pie.e7b6252f.png";

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/701Hou.c6977c0c.png";

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/701Hou@4x.0d1d076c.png";

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/70Hou.fe094340.png";

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/70Hou@4x.4bda02ea.png";

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/70Pie.e7b33101.png";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8-1.96e702a2.png";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8-2.2d05c35e.png";

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8-3.570ac61d.png";

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/801Hou.9dc32e6b.png";

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/801Hou@4x.570a15f8.png";

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/80Hou.1a99b0cb.png";

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/80Hou@4x.1cc4d302.png";

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/80Pie.ca567843.png";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/903ty@2x.ee0cf0fe.png";

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/903ty@3x.3b982313.png";

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/904ty@2x.3d11e513.png";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/904ty@3x.3172ca9c.png";

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/907ty@2x.b168a383.png";

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/907ty@3x.dd040cc1.png";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/915ty@2x.d00a35f6.png";

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/915ty@3x.962f5d1e.png";

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/All_yincang@2x.290da1cc.png";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CLicon01.a5207618.png";

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CLicon02.8d09eb3b.png";

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/CLicon03.e6fb6fe9.png";

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Education.ce010af0.png";

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LcsBg.d5490176.png";

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LcsTop-bg001.66360c7c.png";

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/RiskBanner.8a5e9b16.png";

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aixin.49a72f97.png";

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aixin2.46311656.png";

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/anquan.5dd57650.png";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerChoose.54994c30.png";

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerChoose1.271be97b.png";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerChoose2.54994c30.png";

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC1.4e2ccd6a.png";

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC11.7991d3fd.png";

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC12.a3f8f252.png";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC13.7991d3fd.png";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC14.1030222d.png";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPIC2.6a87a639.png";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPage.4db84df3.png";

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPage2.f041312b.png";

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPage3.9d6ee67e.png";

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPage4.f041312b.png";

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerPage5.74a18714.png";

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/answerTop@2x.e17c3d1e.png";

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowGrayTwo.6ed2e405.png";

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowGrayTwoSS.b459b134.png";

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowLeftTwo.4990ee13.png";

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow_02.c85ed9f9.png";

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg.74b77897.png";

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bottoms2.d865073d.png";

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/briefOne.bef7bf8a.jpg";

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/briefOne.c14eacd1.png";

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/briefTwo.7ad6e5e5.jpg";

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/briefTwo.9be2052a.png";

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/brief_logo.0ab5c6ab.jpg";

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bt_bg1_30.01ea68c3.png";

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bt_bg_14.e42c055d.png";

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/btn_bg_03.7dc5829a.png";

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/call.096f5f7d.png";

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/card_bg.dfe189db.png";

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/downArrow_operating.c8df1e31.png";

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dtan.087b7886.png";

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dtan@2x.27b0e144.png";

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dtgl.30c67495.png";

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dxJy.0c939c5c.png";

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dxJy@4x.e84dc2b7.png";

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dxJyPie.3ef29671.png";

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fanhui@3x.fed74961.png";

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/feiyong.fe392153.png";

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/feiyong@4x..fe392153.png";

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fenxsIcon.aa8eb7f7.jpg";

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fenxsIcon.775a0906.png";

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fenxsWrap.8f53ea86.png";

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/handerR.eea43384.png";

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hdgz.c63a485b.png";

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hdgz@2x.7b081888.png";

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hdgz@3x.2fc6f57d.png";

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/headerMyAssetsBg.b9454656.png";

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/huatiao.5351c090.png";

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon14@4x.d5498a47.png";

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon35.b8086fee.png";

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon4.79d7a315.png";

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconDingTou.9e1fc681.png";

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_RMB.dc8a051b.png";

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_circle.c15a4cf4.png";

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_circleHook.ab17aa0d.png";

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_close@3x.1bb477a3.png";

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_confirm.53c04dc9.png";

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_error.172781f4.png";

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_success.a73aae66.png";

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconhxcf_icon_youjiantou_10_gray.52e297bd.png";

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_changjianwenti.a7cd1eb4.png";

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_jiaoyixiangqing_shibai.919bdaa8.png";

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_jiaoyixiangqing_yiwancheng.99a4d341.png";

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_jiaoyixiangqing_yiwancheng@3x.40a21d1a.png";

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_shangjiantou_1414_999999@3x.dded03ba.png";

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon／icon_xiajiantou_1414_999999.8eb88ec3.png";

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img3@2x.cb61168e.jpg";

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/img3@3x.014e2ac8.jpg";

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ing.38c02b02.png";

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/investBtn1.ae8902d2.png";

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/investBtn2.e990053e.png";

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/investBtnBg.65e6fd40.png";

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jq1.e631c7e0.png";

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jsqA@4x.aee1c0fa.png";

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jsqWrap.73078f9f.png";

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jsqi.e2569aab.png";

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kefu.33581c93.png";

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lcs_logo.2306a2b9.png";

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lcs_newbg.f3ca0f5a.jpg";

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lcs_txt.40ac4131.png";

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lcs_txt@2x.61be5d8c.png";

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lcs_xj.3471b99a.png";

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mingxing_bg_09.33eca04b.png";

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_hava_cast_bg.8a0a235e.png";

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_hava_cast_bg@2x.a01ef93a.png";

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_hava_cast_header_bg.70de5e9f.png";

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_hava_cast_header_bg@2x.d8a5f695.png";

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_dynameic.63b9b7fb.png";

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_header_bg.e43fd4ee.png";

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_highlight.dcf63d89.png";

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_highlight@2x.a9deb010.png";

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_jiaoyimingxi@2x.2113e4c3.png";

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_kefu@2x.50100d83.png";

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_position_arrow.89542927.png";

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_right_arrow@2x.ffc82591.png";

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_shouyimingxi@2x.fea9af81.png";

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_shuoming@2x.faa125fe.png";

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_strategy.432042bd.png";

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_strategy@2x.01954881.png";

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_tab.85c15921.png";

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_tab@2x.a4c14aa5.png";

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_tab_left.18508370.png";

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_tab_left@2x.68f9ed3f.png";

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_video.73fdbe75.png";

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_icon_video@2x.e86e7f67.png";

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_service-report-bg.40a73b14.png";

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_service-report-bg@2x.7896adec.png";

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_service-report-tag.637c5b5e.png";

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/n_service-report-tag@2x.715a09c3.png";

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/name_03.61c969d8.png";

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nextBg.39196820.png";

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/orgBg.bca9a962.jpg";

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/page_02.856121fc.jpg";

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/page_03.bfc7d753.jpg";

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/page_04.310db8ee.jpg";

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/payErr_bg.044dec5d.png";

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paySucc_bg.a85c52a1.png";

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/phone_03.6f482225.png";

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_1_14.175526e1.jpg";

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_2_17.761f02a1.jpg";

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_3_20.f0ec1e0b.jpg";

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_4_22.3cc497e3.jpg";

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_5_24.6daabf42.jpg";

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_6_26.c5467ae5.jpg";

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_7_28.8b4f948f.jpg";

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_8_30.1c3802ff.jpg";

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_jl.2142d152.jpg";

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_xj.699cf137.jpg";

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/popover_Bankquota.e9ae06b6.png";

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/popover_count.8a37926f.png";

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/popover_input.f94a5669.png";

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/popover_read.3ee00658.png";

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/protocol_select.e4f9c8a9.png";

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/registerBg2.5d4fe5af.jpeg";

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/registerHook.3d55b8e9.png";

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ruleImg.0e7797f6.png";

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ruleImg1.3f8f2744.png";

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ruleImg2.5e5e1a4c.png";

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ruleImg3.d796bc2c.png";

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ruleImg4.d796bc2c.png";

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search_header_back.fb77f215.png";

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/simu_bg_07.0b44f7e9.png";

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/square1.e4f9c8a9.png";

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/submitBtn@2x.07129371.png";

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/superBg@4x.e08e6861.png";

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tdfBanner@4x.e8f716fb.png";

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/toBottom.b4bad6ec.png";

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/toTop.b6a5fc64.png";

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/top_bg_01.ef8bae17.jpg";

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tops2.968dd78b.png";

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/touxiang.a9d6e546.png";

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/upArrow_operating.eeced0de.png";

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wenhao2.f8fbe3ba.png";

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wenjianx.47c87465.png";

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wlzs.56f8857f.jpg";

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wlzs.8f69f65e.png";

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xuanzhong@2x.f879f116.png";

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xxGray.1464ea7b.png";

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xxJy.7926fb61.png";

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xxJy@4x.8672c734.png";

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xxJyPie.3e9f798e.png";

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xxYellow.0f066e1b.png";

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yzm_bg_03.53334481.png";

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Down.e8e73a6e.png";

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Fhjl.50263f67.png";

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Jyjl.724f8a1c.png";

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Mytg.5374d5f8.png";

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Right@2x.498ea671.png";

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Symx.8337f42a.png";

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Up.4ddcce8e.png";

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_Xi@2x.c271ec1a.png";

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_xianshi@2x.5b10bff6.png";

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/znyx.538fd329.png";

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zxJy.8884723b.png";

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zxJy@4x.da5654b8.png";

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zxJyPie.192d7a62.png";

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ZT_checked.946e7d99.png";

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/allClear_pay.e5258bb4.jpg";

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eq_arrowRight@3x.1bf1f1a3.png";

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_1.32202483.png";

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_2.ff9a6675.png";

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_3.d89869de.png";

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_4.13ab4fd9.png";

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/investment_head_bg.06b86a92.png";

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kyc_zt_mqmb_icon.63eafe8a.png";

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/registerBg2.7d505608.png";

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/success_new.017195a9.png";

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xiaoshuoming.df154025.png";

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhuanhuan.a3604208.png";

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLoadStart = handleLoadStart;
exports.handleCanPlay = handleCanPlay;
exports.handleWaiting = handleWaiting;
exports.handleCanPlayThrough = handleCanPlayThrough;
exports.handlePlaying = handlePlaying;
exports.handlePlay = handlePlay;
exports.handlePause = handlePause;
exports.handleEnd = handleEnd;
exports.handleSeeking = handleSeeking;
exports.handleSeeked = handleSeeked;
exports.handleDurationChange = handleDurationChange;
exports.handleTimeUpdate = handleTimeUpdate;
exports.handleVolumeChange = handleVolumeChange;
exports.handleProgressChange = handleProgressChange;
exports.handleRateChange = handleRateChange;
exports.handleSuspend = handleSuspend;
exports.handleAbort = handleAbort;
exports.handleEmptied = handleEmptied;
exports.handleStalled = handleStalled;
exports.handleLoadedMetaData = handleLoadedMetaData;
exports.handleLoadedData = handleLoadedData;
exports.handleResize = handleResize;
exports.handleError = handleError;
exports.handleSeekingTime = handleSeekingTime;
exports.handleEndSeeking = handleEndSeeking;
exports.activateTextTrack = activateTextTrack;
exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
var LOAD_START = 'video-react/LOAD_START';
exports.LOAD_START = LOAD_START;
var CAN_PLAY = 'video-react/CAN_PLAY';
exports.CAN_PLAY = CAN_PLAY;
var WAITING = 'video-react/WAITING';
exports.WAITING = WAITING;
var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
var PLAYING = 'video-react/PLAYING';
exports.PLAYING = PLAYING;
var PLAY = 'video-react/PLAY';
exports.PLAY = PLAY;
var PAUSE = 'video-react/PAUSE';
exports.PAUSE = PAUSE;
var END = 'video-react/END';
exports.END = END;
var SEEKING = 'video-react/SEEKING';
exports.SEEKING = SEEKING;
var SEEKED = 'video-react/SEEKED';
exports.SEEKED = SEEKED;
var SEEKING_TIME = 'video-react/SEEKING_TIME';
exports.SEEKING_TIME = SEEKING_TIME;
var END_SEEKING = 'video-react/END_SEEKING';
exports.END_SEEKING = END_SEEKING;
var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
exports.DURATION_CHANGE = DURATION_CHANGE;
var TIME_UPDATE = 'video-react/TIME_UPDATE';
exports.TIME_UPDATE = TIME_UPDATE;
var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
exports.VOLUME_CHANGE = VOLUME_CHANGE;
var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
var RATE_CHANGE = 'video-react/RATE_CHANGE';
exports.RATE_CHANGE = RATE_CHANGE;
var SUSPEND = 'video-react/SUSPEND';
exports.SUSPEND = SUSPEND;
var ABORT = 'video-react/ABORT';
exports.ABORT = ABORT;
var EMPTIED = 'video-react/EMPTIED';
exports.EMPTIED = EMPTIED;
var STALLED = 'video-react/STALLED';
exports.STALLED = STALLED;
var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
exports.LOADED_META_DATA = LOADED_META_DATA;
var LOADED_DATA = 'video-react/LOADED_DATA';
exports.LOADED_DATA = LOADED_DATA;
var RESIZE = 'video-react/RESIZE';
exports.RESIZE = RESIZE;
var ERROR = 'video-react/ERROR';
exports.ERROR = ERROR;
var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;

function handleLoadStart(videoProps) {
  return {
    type: LOAD_START,
    videoProps: videoProps
  };
}

function handleCanPlay(videoProps) {
  return {
    type: CAN_PLAY,
    videoProps: videoProps
  };
}

function handleWaiting(videoProps) {
  return {
    type: WAITING,
    videoProps: videoProps
  };
}

function handleCanPlayThrough(videoProps) {
  return {
    type: CAN_PLAY_THROUGH,
    videoProps: videoProps
  };
}

function handlePlaying(videoProps) {
  return {
    type: PLAYING,
    videoProps: videoProps
  };
}

function handlePlay(videoProps) {
  return {
    type: PLAY,
    videoProps: videoProps
  };
}

function handlePause(videoProps) {
  return {
    type: PAUSE,
    videoProps: videoProps
  };
}

function handleEnd(videoProps) {
  return {
    type: END,
    videoProps: videoProps
  };
}

function handleSeeking(videoProps) {
  return {
    type: SEEKING,
    videoProps: videoProps
  };
}

function handleSeeked(videoProps) {
  return {
    type: SEEKED,
    videoProps: videoProps
  };
}

function handleDurationChange(videoProps) {
  return {
    type: DURATION_CHANGE,
    videoProps: videoProps
  };
}

function handleTimeUpdate(videoProps) {
  return {
    type: TIME_UPDATE,
    videoProps: videoProps
  };
}

function handleVolumeChange(videoProps) {
  return {
    type: VOLUME_CHANGE,
    videoProps: videoProps
  };
}

function handleProgressChange(videoProps) {
  return {
    type: PROGRESS_CHANGE,
    videoProps: videoProps
  };
}

function handleRateChange(videoProps) {
  return {
    type: RATE_CHANGE,
    videoProps: videoProps
  };
}

function handleSuspend(videoProps) {
  return {
    type: SUSPEND,
    videoProps: videoProps
  };
}

function handleAbort(videoProps) {
  return {
    type: ABORT,
    videoProps: videoProps
  };
}

function handleEmptied(videoProps) {
  return {
    type: EMPTIED,
    videoProps: videoProps
  };
}

function handleStalled(videoProps) {
  return {
    type: STALLED,
    videoProps: videoProps
  };
}

function handleLoadedMetaData(videoProps) {
  return {
    type: LOADED_META_DATA,
    videoProps: videoProps
  };
}

function handleLoadedData(videoProps) {
  return {
    type: LOADED_DATA,
    videoProps: videoProps
  };
}

function handleResize(videoProps) {
  return {
    type: RESIZE,
    videoProps: videoProps
  };
}

function handleError(videoProps) {
  return {
    type: ERROR,
    videoProps: videoProps
  };
}

function handleSeekingTime(time) {
  return {
    type: SEEKING_TIME,
    time: time
  };
}

function handleEndSeeking(time) {
  return {
    type: END_SEEKING,
    time: time
  };
}

function activateTextTrack(textTrack) {
  return {
    type: ACTIVATE_TEXT_TRACK,
    textTrack: textTrack
  };
}

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var Dom = _interopRequireWildcard(__webpack_require__(779));

var propTypes = {
  className: _propTypes["default"].string,
  onMouseDown: _propTypes["default"].func,
  onMouseMove: _propTypes["default"].func,
  stepForward: _propTypes["default"].func,
  stepBack: _propTypes["default"].func,
  sliderActive: _propTypes["default"].func,
  sliderInactive: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  getPercent: _propTypes["default"].func,
  vertical: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  label: _propTypes["default"].string,
  valuenow: _propTypes["default"].string,
  valuetext: _propTypes["default"].string
};

var Slider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Slider, _Component);

  function Slider(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      document.removeEventListener('keydown', this.handleKeyPress, true);
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      var getPercent = this.props.getPercent;

      if (!getPercent) {
        return 0;
      }

      var progress = getPercent(); // Protect against no duration and other division issues

      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
        progress = 0;
      }

      return progress;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
      // event.stopPropagation();

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: true
      });

      if (this.props.sliderActive) {
        this.props.sliderActive(event);
      }

      this.handleMouseMove(event);

      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var onMouseMove = this.props.onMouseMove;

      if (onMouseMove) {
        onMouseMove(event);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      // On iOS safari, a subsequent mouseup event will be fired after touchend.
      // Its weird event positions make the player seek a wrong time.
      // calling preventDefault (at touchend phase) will prevent the mouseup event
      event.preventDefault();
      var onMouseUp = this.props.onMouseUp;
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: false
      });

      if (this.props.sliderInactive) {
        this.props.sliderInactive(event);
      }

      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.which === 37 || event.which === 40) {
        // Left and Down Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepBack();
      } else if (event.which === 38 || event.which === 39) {
        // Up and Right Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepForward();
      }
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      if (this.props.stepForward) {
        this.props.stepForward();
      }
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      if (this.props.stepBack) {
        this.props.stepBack();
      }
    }
  }, {
    key: "calculateDistance",
    value: function calculateDistance(event) {
      var node = this.slider;
      var position = Dom.getPointerPosition(node, event);

      if (this.props.vertical) {
        return position.y;
      }

      return position.x;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var progress = this.getProgress();
      var percentage = "".concat((progress * 100).toFixed(2), "%");
      return _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          progress: progress,
          percentage: percentage
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          vertical = _this$props.vertical,
          label = _this$props.label,
          valuenow = _this$props.valuenow,
          valuetext = _this$props.valuetext;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, {
          'video-react-slider-vertical': vertical,
          'video-react-slider-horizontal': !vertical,
          'video-react-sliding': this.state.active
        }, 'video-react-slider'),
        ref: function ref(c) {
          _this2.slider = c;
        },
        tabIndex: "0",
        role: "slider",
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleMouseDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        "aria-label": label || '',
        "aria-valuenow": valuenow || '',
        "aria-valuetext": valuetext || '',
        "aria-valuemin": 0,
        "aria-valuemax": 100
      }, this.renderChildren());
    }
  }]);
  return Slider;
}(_react.Component);

exports["default"] = Slider;
Slider.propTypes = propTypes;
Slider.displayName = 'Slider';

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _MenuButton = _interopRequireDefault(__webpack_require__(1908));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  rates: _propTypes["default"].array,
  className: _propTypes["default"].string
};
var defaultProps = {
  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
};

var PlaybackRateMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);

  function PlaybackRateMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props = this.props,
          rates = _this$props.rates,
          actions = _this$props.actions;

      if (index >= 0 && index < rates.length) {
        actions.changeRate(rates[index]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rates = _this$props2.rates,
          player = _this$props2.player;
      var items = rates.map(function (rate) {
        return {
          label: "".concat(rate, "x"),
          value: rate
        };
      });
      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Playback Rate"), _react["default"].createElement("div", {
        className: "video-react-playback-rate-value"
      }, "".concat(player.playbackRate.toFixed(2), "x")));
    }
  }]);
  return PlaybackRateMenuButton;
}(_react.Component);

PlaybackRateMenuButton.propTypes = propTypes;
PlaybackRateMenuButton.defaultProps = defaultProps;
PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
var _default = PlaybackRateMenuButton;
exports["default"] = _default;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _Menu = _interopRequireDefault(__webpack_require__(2194));

var _MenuItem = _interopRequireDefault(__webpack_require__(2195));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(1979));

var propTypes = {
  inline: _propTypes["default"].bool,
  items: _propTypes["default"].array,
  className: _propTypes["default"].string,
  onSelectItem: _propTypes["default"].func,
  children: _propTypes["default"].any,
  selectedIndex: _propTypes["default"].number
};

var MenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuButton, _Component);

  function MenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
    _this.state = {
      active: false,
      activateIndex: props.selectedIndex || 0
    };
    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.activateMenuItem(this.props.selectedIndex);
      }
    }
  }, {
    key: "commitSelection",
    value: function commitSelection(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "activateMenuItem",
    value: function activateMenuItem(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "handleIndexChange",
    value: function handleIndexChange(index) {
      var onSelectItem = this.props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleUpArrow",
    value: function handleUpArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex - 1;

        if (newIndex < 0) {
          newIndex = items.length ? items.length - 1 : 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleDownArrow",
    value: function handleDownArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex + 1;

        if (newIndex >= items.length) {
          newIndex = 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (this.state.active) {
        e.preventDefault();
        this.commitSelection(this.state.activateIndex);
      }
    }
  }, {
    key: "handleReturn",
    value: function handleReturn(e) {
      e.preventDefault();

      if (this.state.active) {
        this.commitSelection(this.state.activateIndex);
      } else {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "handleEscape",
    value: function handleEscape() {
      this.setState({
        active: false,
        activateIndex: 0
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      // Escape (27) key
      if (event.which === 27) {
        this.handleEscape(event);
      } else if (event.which === 9) {
        // Tab (9) key
        this.handleTab(event);
      } else if (event.which === 13) {
        // Enter (13) key
        this.handleReturn(event);
      } else if (event.which === 38) {
        // Up (38) key
        this.handleUpArrow(event);
      } else if (event.which === 40) {
        // Down (40) key press
        this.handleDownArrow(event);
      }
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(i) {
      this.commitSelection(i);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      var items = this.props.items;
      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
        return _react["default"].createElement(_MenuItem["default"], {
          item: item,
          index: i,
          onSelectItem: _this2.handleSelectItem,
          activateIndex: _this2.state.activateIndex,
          key: "item-".concat(i++)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className;
      return _react["default"].createElement(_ClickableComponent["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-menu-button-inline': !!inline,
          'video-react-menu-button-popup': !inline,
          'video-react-menu-button-active': this.state.active
        }, 'video-react-control video-react-button video-react-menu-button'),
        role: "button",
        tabIndex: "0",
        ref: function ref(c) {
          _this3.menuButton = c;
        },
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props.children, this.renderMenu());
    }
  }]);
  return MenuButton;
}(_react.Component);

exports["default"] = MenuButton;
MenuButton.propTypes = propTypes;
MenuButton.displayName = 'MenuButton';

/***/ }),
/* 1909 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(6);

var vec2 = __webpack_require__(53);

var Draggable = __webpack_require__(1942);

var Eventful = __webpack_require__(194);

/**
 * Handler
 * @module zrender/Handler
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 *         pissang (shenyi.914@gmail.com)
 */
var SILENT = 'silent';

function makeEventPacket(eveType, targetInfo, event) {
  return {
    type: eveType,
    event: event,
    // target can only be an element that is not silent.
    target: targetInfo.target,
    // topTarget can be a silent element.
    topTarget: targetInfo.topTarget,
    cancelBubble: false,
    offsetX: event.zrX,
    offsetY: event.zrY,
    gestureEvent: event.gestureEvent,
    pinchX: event.pinchX,
    pinchY: event.pinchY,
    pinchScale: event.pinchScale,
    wheelDelta: event.zrDelta,
    zrByTouch: event.zrByTouch,
    which: event.which
  };
}

function EmptyProxy() {}

EmptyProxy.prototype.dispose = function () {};

var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
/**
 * @alias module:zrender/Handler
 * @constructor
 * @extends module:zrender/mixin/Eventful
 * @param {module:zrender/Storage} storage Storage instance.
 * @param {module:zrender/Painter} painter Painter instance.
 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
 */

var Handler = function (storage, painter, proxy, painterRoot) {
  Eventful.call(this);
  this.storage = storage;
  this.painter = painter;
  this.painterRoot = painterRoot;
  proxy = proxy || new EmptyProxy();
  /**
   * Proxy of event. can be Dom, WebGLSurface, etc.
   */

  this.proxy = proxy; // Attach handler

  proxy.handler = this;
  /**
   * {target, topTarget, x, y}
   * @private
   * @type {Object}
   */

  this._hovered = {};
  /**
   * @private
   * @type {Date}
   */

  this._lastTouchMoment;
  /**
   * @private
   * @type {number}
   */

  this._lastX;
  /**
   * @private
   * @type {number}
   */

  this._lastY;
  Draggable.call(this);
  util.each(handlerNames, function (name) {
    proxy.on && proxy.on(name, this[name], this);
  }, this);
};

Handler.prototype = {
  constructor: Handler,
  mousemove: function (event) {
    var x = event.zrX;
    var y = event.zrY;
    var lastHovered = this._hovered;
    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
    // See #6198.

    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
      lastHoveredTarget = lastHovered.target;
    }

    var hovered = this._hovered = this.findHover(x, y);
    var hoveredTarget = hovered.target;
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element

    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(lastHovered, 'mouseout', event);
    } // Mouse moving on one element


    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element

    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
      this.dispatchToElement(hovered, 'mouseover', event);
    }
  },
  mouseout: function (event) {
    this.dispatchToElement(this._hovered, 'mouseout', event); // There might be some doms created by upper layer application
    // at the same level of painter.getViewportRoot() (e.g., tooltip
    // dom created by echarts), where 'globalout' event should not
    // be triggered when mouse enters these doms. (But 'mouseout'
    // should be triggered at the original hovered element as usual).

    var element = event.toElement || event.relatedTarget;
    var innerDom;

    do {
      element = element && element.parentNode;
    } while (element && element.nodeType != 9 && !(innerDom = element === this.painterRoot));

    !innerDom && this.trigger('globalout', {
      event: event
    });
  },

  /**
   * Resize
   */
  resize: function (event) {
    this._hovered = {};
  },

  /**
   * Dispatch event
   * @param {string} eventName
   * @param {event=} eventArgs
   */
  dispatch: function (eventName, eventArgs) {
    var handler = this[eventName];
    handler && handler.call(this, eventArgs);
  },

  /**
   * Dispose
   */
  dispose: function () {
    this.proxy.dispose();
    this.storage = this.proxy = this.painter = null;
  },

  /**
   * 设置默认的cursor style
   * @param {string} [cursorStyle='default'] 例如 crosshair
   */
  setCursorStyle: function (cursorStyle) {
    var proxy = this.proxy;
    proxy.setCursor && proxy.setCursor(cursorStyle);
  },

  /**
   * 事件分发代理
   *
   * @private
   * @param {Object} targetInfo {target, topTarget} 目标图形元素
   * @param {string} eventName 事件名称
   * @param {Object} event 事件对象
   */
  dispatchToElement: function (targetInfo, eventName, event) {
    targetInfo = targetInfo || {};
    var el = targetInfo.target;

    if (el && el.silent) {
      return;
    }

    var eventHandler = 'on' + eventName;
    var eventPacket = makeEventPacket(eventName, targetInfo, event);

    while (el) {
      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
      el.trigger(eventName, eventPacket);
      el = el.parent;

      if (eventPacket.cancelBubble) {
        break;
      }
    }

    if (!eventPacket.cancelBubble) {
      // 冒泡到顶级 zrender 对象
      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在

      this.painter && this.painter.eachOtherLayer(function (layer) {
        if (typeof layer[eventHandler] == 'function') {
          layer[eventHandler].call(layer, eventPacket);
        }

        if (layer.trigger) {
          layer.trigger(eventName, eventPacket);
        }
      });
    }
  },

  /**
   * @private
   * @param {number} x
   * @param {number} y
   * @param {module:zrender/graphic/Displayable} exclude
   * @return {model:zrender/Element}
   * @method
   */
  findHover: function (x, y, exclude) {
    var list = this.storage.getDisplayList();
    var out = {
      x: x,
      y: y
    };

    for (var i = list.length - 1; i >= 0; i--) {
      var hoverCheckResult;

      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
        !out.topTarget && (out.topTarget = list[i]);

        if (hoverCheckResult !== SILENT) {
          out.target = list[i];
          break;
        }
      }
    }

    return out;
  }
}; // Common handlers

util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  Handler.prototype[name] = function (event) {
    // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
    var hovered = this.findHover(event.zrX, event.zrY);
    var hoveredTarget = hovered.target;

    if (name === 'mousedown') {
      this._downEl = hoveredTarget;
      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup

      this._upEl = hoveredTarget;
    } else if (name === 'mosueup') {
      this._upEl = hoveredTarget;
    } else if (name === 'click') {
      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
      // including the case that `mousedown` - `mousemove` - `mouseup`,
      // which should be filtered, otherwise it will bring trouble to
      // pan and zoom.
      || !this._downPoint // Arbitrary value
      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
        return;
      }

      this._downPoint = null;
    }

    this.dispatchToElement(hovered, name, event);
  };
});

function isHover(displayable, x, y) {
  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
    var el = displayable;
    var isSilent;

    while (el) {
      // If clipped by ancestor.
      // FIXME: If clipPath has neither stroke nor fill,
      // el.clipPath.contain(x, y) will always return false.
      if (el.clipPath && !el.clipPath.contain(x, y)) {
        return false;
      }

      if (el.silent) {
        isSilent = true;
      }

      el = el.parent;
    }

    return isSilent ? SILENT : true;
  }

  return false;
}

util.mixin(Handler, Eventful);
util.mixin(Handler, Draggable);
var _default = Handler;
module.exports = _default;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(6);

var _config = __webpack_require__(260);

var devicePixelRatio = _config.devicePixelRatio;

var Style = __webpack_require__(713);

var Pattern = __webpack_require__(712);

/**
 * @module zrender/Layer
 * @author pissang(https://www.github.com/pissang)
 */
function returnFalse() {
  return false;
}
/**
 * 创建dom
 *
 * @inner
 * @param {string} id dom id 待用
 * @param {Painter} painter painter instance
 * @param {number} number
 */


function createDom(id, painter, dpr) {
  var newDom = util.createCanvas();
  var width = painter.getWidth();
  var height = painter.getHeight();
  var newDomStyle = newDom.style; // 没append呢，请原谅我这样写，清晰~

  newDomStyle.position = 'absolute';
  newDomStyle.left = 0;
  newDomStyle.top = 0;
  newDomStyle.width = width + 'px';
  newDomStyle.height = height + 'px';
  newDom.width = width * dpr;
  newDom.height = height * dpr; // id不作为索引用，避免可能造成的重名，定义为私有属性

  newDom.setAttribute('data-zr-dom-id', id);
  return newDom;
}
/**
 * @alias module:zrender/Layer
 * @constructor
 * @extends module:zrender/mixin/Transformable
 * @param {string} id
 * @param {module:zrender/Painter} painter
 * @param {number} [dpr]
 */


var Layer = function (id, painter, dpr) {
  var dom;
  dpr = dpr || devicePixelRatio;

  if (typeof id === 'string') {
    dom = createDom(id, painter, dpr);
  } // Not using isDom because in node it will return false
  else if (util.isObject(id)) {
      dom = id;
      id = dom.id;
    }

  this.id = id;
  this.dom = dom;
  var domStyle = dom.style;

  if (domStyle) {
    // Not in node
    dom.onselectstart = returnFalse; // 避免页面选中的尴尬

    domStyle['-webkit-user-select'] = 'none';
    domStyle['user-select'] = 'none';
    domStyle['-webkit-touch-callout'] = 'none';
    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
    domStyle['padding'] = 0;
    domStyle['margin'] = 0;
    domStyle['border-width'] = 0;
  }

  this.domBack = null;
  this.ctxBack = null;
  this.painter = painter;
  this.config = null; // Configs

  /**
   * 每次清空画布的颜色
   * @type {string}
   * @default 0
   */

  this.clearColor = 0;
  /**
   * 是否开启动态模糊
   * @type {boolean}
   * @default false
   */

  this.motionBlur = false;
  /**
   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   * @type {number}
   * @default 0.7
   */

  this.lastFrameAlpha = 0.7;
  /**
   * Layer dpr
   * @type {number}
   */

  this.dpr = dpr;
};

Layer.prototype = {
  constructor: Layer,
  elCount: 0,
  __dirty: true,
  initContext: function () {
    this.ctx = this.dom.getContext('2d');
    this.ctx.__currentValues = {};
    this.ctx.dpr = this.dpr;
  },
  createBackBuffer: function () {
    var dpr = this.dpr;
    this.domBack = createDom('back-' + this.id, this.painter, dpr);
    this.ctxBack = this.domBack.getContext('2d');
    this.ctxBack.__currentValues = {};

    if (dpr != 1) {
      this.ctxBack.scale(dpr, dpr);
    }
  },

  /**
   * @param  {number} width
   * @param  {number} height
   */
  resize: function (width, height) {
    var dpr = this.dpr;
    var dom = this.dom;
    var domStyle = dom.style;
    var domBack = this.domBack;
    domStyle.width = width + 'px';
    domStyle.height = height + 'px';
    dom.width = width * dpr;
    dom.height = height * dpr;

    if (domBack) {
      domBack.width = width * dpr;
      domBack.height = height * dpr;

      if (dpr != 1) {
        this.ctxBack.scale(dpr, dpr);
      }
    }
  },

  /**
   * 清空该层画布
   * @param {boolean} clearAll Clear all with out motion blur
   */
  clear: function (clearAll) {
    var dom = this.dom;
    var ctx = this.ctx;
    var width = dom.width;
    var height = dom.height;
    var clearColor = this.clearColor;
    var haveMotionBLur = this.motionBlur && !clearAll;
    var lastFrameAlpha = this.lastFrameAlpha;
    var dpr = this.dpr;

    if (haveMotionBLur) {
      if (!this.domBack) {
        this.createBackBuffer();
      }

      this.ctxBack.globalCompositeOperation = 'copy';
      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
    }

    ctx.clearRect(0, 0, width, height);

    if (clearColor) {
      var clearColorGradientOrPattern; // Gradient

      if (clearColor.colorStops) {
        // Cache canvas gradient
        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
          x: 0,
          y: 0,
          width: width,
          height: height
        });
        clearColor.__canvasGradient = clearColorGradientOrPattern;
      } // Pattern
      else if (clearColor.image) {
          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
        }

      ctx.save();
      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
      ctx.fillRect(0, 0, width, height);
      ctx.restore();
    }

    if (haveMotionBLur) {
      var domBack = this.domBack;
      ctx.save();
      ctx.globalAlpha = lastFrameAlpha;
      ctx.drawImage(domBack, 0, 0, width, height);
      ctx.restore();
    }
  }
};
var _default = Layer;
module.exports = _default;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

var _config = __webpack_require__(260);

var devicePixelRatio = _config.devicePixelRatio;

var util = __webpack_require__(6);

var log = __webpack_require__(262);

var BoundingRect = __webpack_require__(63);

var timsort = __webpack_require__(397);

var Layer = __webpack_require__(1911);

var requestAnimationFrame = __webpack_require__(706);

var Image = __webpack_require__(263);

/**
 * Default canvas painter
 * @module zrender/Painter
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 *         pissang (https://www.github.com/pissang)
 */
// PENDIGN
// Layer exceeds MAX_PROGRESSIVE_LAYER_NUMBER may have some problem when flush directly second time.
//
// Maximum progressive layer. When exceeding this number. All elements will be drawed in the last layer.
var MAX_PROGRESSIVE_LAYER_NUMBER = 5;

function parseInt10(val) {
  return parseInt(val, 10);
}

function isLayerValid(layer) {
  if (!layer) {
    return false;
  }

  if (layer.__builtin__) {
    return true;
  }

  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
    return false;
  }

  return true;
}

function preProcessLayer(layer) {
  layer.__unusedCount++;
}

function postProcessLayer(layer) {
  if (layer.__unusedCount == 1) {
    layer.clear();
  }
}

var tmpRect = new BoundingRect(0, 0, 0, 0);
var viewRect = new BoundingRect(0, 0, 0, 0);

function isDisplayableCulled(el, width, height) {
  tmpRect.copy(el.getBoundingRect());

  if (el.transform) {
    tmpRect.applyTransform(el.transform);
  }

  viewRect.width = width;
  viewRect.height = height;
  return !tmpRect.intersect(viewRect);
}

function isClipPathChanged(clipPaths, prevClipPaths) {
  if (clipPaths == prevClipPaths) {
    // Can both be null or undefined
    return false;
  }

  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
    return true;
  }

  for (var i = 0; i < clipPaths.length; i++) {
    if (clipPaths[i] !== prevClipPaths[i]) {
      return true;
    }
  }
}

function doClip(clipPaths, ctx) {
  for (var i = 0; i < clipPaths.length; i++) {
    var clipPath = clipPaths[i];
    clipPath.setTransform(ctx);
    ctx.beginPath();
    clipPath.buildPath(ctx, clipPath.shape);
    ctx.clip(); // Transform back

    clipPath.restoreTransform(ctx);
  }
}

function createRoot(width, height) {
  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // 避免页面选中的尴尬

  domRoot.style.cssText = ['position:relative', 'overflow:hidden', 'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
  return domRoot;
}
/**
 * @alias module:zrender/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var Painter = function (root, storage, opts) {
  this.type = 'canvas'; // In node environment using node-canvas

  var singleCanvas = !root.nodeName // In node ?
  || root.nodeName.toUpperCase() === 'CANVAS';
  this._opts = opts = util.extend({}, opts || {});
  /**
   * @type {number}
   */

  this.dpr = opts.devicePixelRatio || devicePixelRatio;
  /**
   * @type {boolean}
   * @private
   */

  this._singleCanvas = singleCanvas;
  /**
   * 绘图容器
   * @type {HTMLElement}
   */

  this.root = root;
  var rootStyle = root.style;

  if (rootStyle) {
    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
    root.innerHTML = '';
  }
  /**
   * @type {module:zrender/Storage}
   */


  this.storage = storage;
  /**
   * @type {Array.<number>}
   * @private
   */

  var zlevelList = this._zlevelList = [];
  /**
   * @type {Object.<string, module:zrender/Layer>}
   * @private
   */

  var layers = this._layers = {};
  /**
   * @type {Object.<string, Object>}
   * @type {private}
   */

  this._layerConfig = {};

  if (!singleCanvas) {
    this._width = this._getSize(0);
    this._height = this._getSize(1);
    var domRoot = this._domRoot = createRoot(this._width, this._height);
    root.appendChild(domRoot);
  } else {
    if (opts.width != null) {
      root.width = opts.width;
    }

    if (opts.height != null) {
      root.height = opts.height;
    } // Use canvas width and height directly


    var width = root.width;
    var height = root.height;
    this._width = width;
    this._height = height; // Create layer if only one given canvas
    // Device pixel ratio is fixed to 1 because given canvas has its specified width and height

    var mainLayer = new Layer(root, this, 1);
    mainLayer.initContext(); // FIXME Use canvas width and height
    // mainLayer.resize(width, height);

    layers[0] = mainLayer;
    zlevelList.push(0);
    this._domRoot = root;
  } // Layers for progressive rendering


  this._progressiveLayers = [];
  /**
   * @type {module:zrender/Layer}
   * @private
   */

  this._hoverlayer;
  this._hoverElements = [];
};

Painter.prototype = {
  constructor: Painter,
  getType: function () {
    return 'canvas';
  },

  /**
   * If painter use a single canvas
   * @return {boolean}
   */
  isSingleCanvas: function () {
    return this._singleCanvas;
  },

  /**
   * @return {HTMLDivElement}
   */
  getViewportRoot: function () {
    return this._domRoot;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },

  /**
   * 刷新
   * @param {boolean} [paintAll=false] 强制绘制所有displayable
   */
  refresh: function (paintAll) {
    var list = this.storage.getDisplayList(true);
    var zlevelList = this._zlevelList;

    this._paintList(list, paintAll); // Paint custum layers


    for (var i = 0; i < zlevelList.length; i++) {
      var z = zlevelList[i];
      var layer = this._layers[z];

      if (!layer.__builtin__ && layer.refresh) {
        layer.refresh();
      }
    }

    this.refreshHover();

    if (this._progressiveLayers.length) {
      this._startProgessive();
    }

    return this;
  },
  addHover: function (el, hoverStyle) {
    if (el.__hoverMir) {
      return;
    }

    var elMirror = new el.constructor({
      style: el.style,
      shape: el.shape
    });
    elMirror.__from = el;
    el.__hoverMir = elMirror;
    elMirror.setStyle(hoverStyle);

    this._hoverElements.push(elMirror);
  },
  removeHover: function (el) {
    var elMirror = el.__hoverMir;
    var hoverElements = this._hoverElements;
    var idx = util.indexOf(hoverElements, elMirror);

    if (idx >= 0) {
      hoverElements.splice(idx, 1);
    }

    el.__hoverMir = null;
  },
  clearHover: function (el) {
    var hoverElements = this._hoverElements;

    for (var i = 0; i < hoverElements.length; i++) {
      var from = hoverElements[i].__from;

      if (from) {
        from.__hoverMir = null;
      }
    }

    hoverElements.length = 0;
  },
  refreshHover: function () {
    var hoverElements = this._hoverElements;
    var len = hoverElements.length;
    var hoverLayer = this._hoverlayer;
    hoverLayer && hoverLayer.clear();

    if (!len) {
      return;
    }

    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
    // FIXME?

    if (!hoverLayer) {
      hoverLayer = this._hoverlayer = this.getLayer(1e5);
    }

    var scope = {};
    hoverLayer.ctx.save();

    for (var i = 0; i < len;) {
      var el = hoverElements[i];
      var originalEl = el.__from; // Original el is removed
      // PENDING

      if (!(originalEl && originalEl.__zr)) {
        hoverElements.splice(i, 1);
        originalEl.__hoverMir = null;
        len--;
        continue;
      }

      i++; // Use transform
      // FIXME style and shape ?

      if (!originalEl.invisible) {
        el.transform = originalEl.transform;
        el.invTransform = originalEl.invTransform;
        el.__clipPaths = originalEl.__clipPaths; // el.

        this._doPaintEl(el, hoverLayer, true, scope);
      }
    }

    hoverLayer.ctx.restore();
  },
  _startProgessive: function () {
    var self = this;

    if (!self._furtherProgressive) {
      return;
    } // Use a token to stop progress steps triggered by
    // previous zr.refresh calling.


    var token = self._progressiveToken = +new Date();
    self._progress++;
    requestAnimationFrame(step);

    function step() {
      // In case refreshed or disposed
      if (token === self._progressiveToken && self.storage) {
        self._doPaintList(self.storage.getDisplayList());

        if (self._furtherProgressive) {
          self._progress++;
          requestAnimationFrame(step);
        } else {
          self._progressiveToken = -1;
        }
      }
    }
  },
  _clearProgressive: function () {
    this._progressiveToken = -1;
    this._progress = 0;
    util.each(this._progressiveLayers, function (layer) {
      layer.__dirty && layer.clear();
    });
  },
  _paintList: function (list, paintAll) {
    if (paintAll == null) {
      paintAll = false;
    }

    this._updateLayerStatus(list);

    this._clearProgressive();

    this.eachBuiltinLayer(preProcessLayer);

    this._doPaintList(list, paintAll);

    this.eachBuiltinLayer(postProcessLayer);
  },
  _doPaintList: function (list, paintAll) {
    var currentLayer;
    var currentZLevel;
    var ctx; // var invTransform = [];

    var scope;
    var progressiveLayerIdx = 0;
    var currentProgressiveLayer;
    var width = this._width;
    var height = this._height;
    var layerProgress;
    var frame = this._progress;

    function flushProgressiveLayer(layer) {
      var dpr = ctx.dpr || 1;
      ctx.save();
      ctx.globalAlpha = 1;
      ctx.shadowBlur = 0; // Avoid layer don't clear in next progressive frame

      currentLayer.__dirty = true;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(layer.dom, 0, 0, width * dpr, height * dpr);
      ctx.restore();
    }

    for (var i = 0, l = list.length; i < l; i++) {
      var el = list[i];
      var elZLevel = this._singleCanvas ? 0 : el.zlevel;
      var elFrame = el.__frame; // Flush at current context
      // PENDING

      if (elFrame < 0 && currentProgressiveLayer) {
        flushProgressiveLayer(currentProgressiveLayer);
        currentProgressiveLayer = null;
      } // Change draw layer


      if (currentZLevel !== elZLevel) {
        if (ctx) {
          ctx.restore();
        } // Reset scope


        scope = {}; // Only 0 zlevel if only has one canvas

        currentZLevel = elZLevel;
        currentLayer = this.getLayer(currentZLevel);

        if (!currentLayer.__builtin__) {
          log('ZLevel ' + currentZLevel + ' has been used by unkown layer ' + currentLayer.id);
        }

        ctx = currentLayer.ctx;
        ctx.save(); // Reset the count

        currentLayer.__unusedCount = 0;

        if (currentLayer.__dirty || paintAll) {
          currentLayer.clear();
        }
      }

      if (!(currentLayer.__dirty || paintAll)) {
        continue;
      }

      if (elFrame >= 0) {
        // Progressive layer changed
        if (!currentProgressiveLayer) {
          currentProgressiveLayer = this._progressiveLayers[Math.min(progressiveLayerIdx++, MAX_PROGRESSIVE_LAYER_NUMBER - 1)];
          currentProgressiveLayer.ctx.save();
          currentProgressiveLayer.renderScope = {};

          if (currentProgressiveLayer && currentProgressiveLayer.__progress > currentProgressiveLayer.__maxProgress) {
            // flushProgressiveLayer(currentProgressiveLayer);
            // Quick jump all progressive elements
            // All progressive element are not dirty, jump over and flush directly
            i = currentProgressiveLayer.__nextIdxNotProg - 1; // currentProgressiveLayer = null;

            continue;
          }

          layerProgress = currentProgressiveLayer.__progress;

          if (!currentProgressiveLayer.__dirty) {
            // Keep rendering
            frame = layerProgress;
          }

          currentProgressiveLayer.__progress = frame + 1;
        }

        if (elFrame === frame) {
          this._doPaintEl(el, currentProgressiveLayer, true, currentProgressiveLayer.renderScope);
        }
      } else {
        this._doPaintEl(el, currentLayer, paintAll, scope);
      }

      el.__dirty = false;
    }

    if (currentProgressiveLayer) {
      flushProgressiveLayer(currentProgressiveLayer);
    } // Restore the lastLayer ctx


    ctx && ctx.restore(); // If still has clipping state
    // if (scope.prevElClipPaths) {
    //     ctx.restore();
    // }

    this._furtherProgressive = false;
    util.each(this._progressiveLayers, function (layer) {
      if (layer.__maxProgress >= layer.__progress) {
        this._furtherProgressive = true;
      }
    }, this);
  },
  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
    var ctx = currentLayer.ctx;
    var m = el.transform;

    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
    !el.invisible // Ignore transparent element
    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
    // Draw a scale 0 element can cause all following draw wrong
    // And setTransform with scale 0 will cause set back transform failed.
    && !(m && !m[0] && !m[3]) // Ignore culled element
    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
      var clipPaths = el.__clipPaths; // Optimize when clipping on group with several elements

      if (scope.prevClipLayer !== currentLayer || isClipPathChanged(clipPaths, scope.prevElClipPaths)) {
        // If has previous clipping state, restore from it
        if (scope.prevElClipPaths) {
          scope.prevClipLayer.ctx.restore();
          scope.prevClipLayer = scope.prevElClipPaths = null; // Reset prevEl since context has been restored

          scope.prevEl = null;
        } // New clipping state


        if (clipPaths) {
          ctx.save();
          doClip(clipPaths, ctx);
          scope.prevClipLayer = currentLayer;
          scope.prevElClipPaths = clipPaths;
        }
      }

      el.beforeBrush && el.beforeBrush(ctx);
      el.brush(ctx, scope.prevEl || null);
      scope.prevEl = el;
      el.afterBrush && el.afterBrush(ctx);
    }
  },

  /**
   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
   * @param {number} zlevel
   * @return {module:zrender/Layer}
   */
  getLayer: function (zlevel) {
    if (this._singleCanvas) {
      return this._layers[0];
    }

    var layer = this._layers[zlevel];

    if (!layer) {
      // Create a new layer
      layer = new Layer('zr_' + zlevel, this, this.dpr);
      layer.__builtin__ = true;

      if (this._layerConfig[zlevel]) {
        util.merge(layer, this._layerConfig[zlevel], true);
      }

      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
      // Or excanvas will get 0px clientWidth and clientHeight

      layer.initContext();
    }

    return layer;
  },
  insertLayer: function (zlevel, layer) {
    var layersMap = this._layers;
    var zlevelList = this._zlevelList;
    var len = zlevelList.length;
    var prevLayer = null;
    var i = -1;
    var domRoot = this._domRoot;

    if (layersMap[zlevel]) {
      log('ZLevel ' + zlevel + ' has been used already');
      return;
    } // Check if is a valid layer


    if (!isLayerValid(layer)) {
      log('Layer of zlevel ' + zlevel + ' is not valid');
      return;
    }

    if (len > 0 && zlevel > zlevelList[0]) {
      for (i = 0; i < len - 1; i++) {
        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
          break;
        }
      }

      prevLayer = layersMap[zlevelList[i]];
    }

    zlevelList.splice(i + 1, 0, zlevel);
    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
    // (It can be a WebGL layer and assigned to a ZImage element)
    // But it still under management of zrender.

    if (!layer.virtual) {
      if (prevLayer) {
        var prevDom = prevLayer.dom;

        if (prevDom.nextSibling) {
          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
        } else {
          domRoot.appendChild(layer.dom);
        }
      } else {
        if (domRoot.firstChild) {
          domRoot.insertBefore(layer.dom, domRoot.firstChild);
        } else {
          domRoot.appendChild(layer.dom);
        }
      }
    }
  },
  // Iterate each layer
  eachLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      cb.call(context, this._layers[z], z);
    }
  },
  // Iterate each buildin layer
  eachBuiltinLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },
  // Iterate each other layer except buildin layer
  eachOtherLayer: function (cb, context) {
    var zlevelList = this._zlevelList;
    var layer;
    var z;
    var i;

    for (i = 0; i < zlevelList.length; i++) {
      z = zlevelList[i];
      layer = this._layers[z];

      if (!layer.__builtin__) {
        cb.call(context, layer, z);
      }
    }
  },

  /**
   * 获取所有已创建的层
   * @param {Array.<module:zrender/Layer>} [prevLayer]
   */
  getLayers: function () {
    return this._layers;
  },
  _updateLayerStatus: function (list) {
    var layers = this._layers;
    var progressiveLayers = this._progressiveLayers;
    var elCountsLastFrame = {};
    var progressiveElCountsLastFrame = {};
    this.eachBuiltinLayer(function (layer, z) {
      elCountsLastFrame[z] = layer.elCount;
      layer.elCount = 0;
      layer.__dirty = false;
    });
    util.each(progressiveLayers, function (layer, idx) {
      progressiveElCountsLastFrame[idx] = layer.elCount;
      layer.elCount = 0;
      layer.__dirty = false;
    });
    var progressiveLayerCount = 0;
    var currentProgressiveLayer;
    var lastProgressiveKey;
    var frameCount = 0;

    for (var i = 0, l = list.length; i < l; i++) {
      var el = list[i];
      var zlevel = this._singleCanvas ? 0 : el.zlevel;
      var layer = layers[zlevel];
      var elProgress = el.progressive;

      if (layer) {
        layer.elCount++;
        layer.__dirty = layer.__dirty || el.__dirty;
      } /////// Update progressive


      if (elProgress >= 0) {
        // Fix wrong progressive sequence problem.
        if (lastProgressiveKey !== elProgress) {
          lastProgressiveKey = elProgress;
          frameCount++;
        }

        var elFrame = el.__frame = frameCount - 1;

        if (!currentProgressiveLayer) {
          var idx = Math.min(progressiveLayerCount, MAX_PROGRESSIVE_LAYER_NUMBER - 1);
          currentProgressiveLayer = progressiveLayers[idx];

          if (!currentProgressiveLayer) {
            currentProgressiveLayer = progressiveLayers[idx] = new Layer('progressive', this, this.dpr);
            currentProgressiveLayer.initContext();
          }

          currentProgressiveLayer.__maxProgress = 0;
        }

        currentProgressiveLayer.__dirty = currentProgressiveLayer.__dirty || el.__dirty;
        currentProgressiveLayer.elCount++;
        currentProgressiveLayer.__maxProgress = Math.max(currentProgressiveLayer.__maxProgress, elFrame);

        if (currentProgressiveLayer.__maxProgress >= currentProgressiveLayer.__progress) {
          // Should keep rendering this  layer because progressive rendering is not finished yet
          layer.__dirty = true;
        }
      } else {
        el.__frame = -1;

        if (currentProgressiveLayer) {
          currentProgressiveLayer.__nextIdxNotProg = i;
          progressiveLayerCount++;
          currentProgressiveLayer = null;
        }
      }
    }

    if (currentProgressiveLayer) {
      progressiveLayerCount++;
      currentProgressiveLayer.__nextIdxNotProg = i;
    } // 层中的元素数量有发生变化


    this.eachBuiltinLayer(function (layer, z) {
      if (elCountsLastFrame[z] !== layer.elCount) {
        layer.__dirty = true;
      }
    });
    progressiveLayers.length = Math.min(progressiveLayerCount, MAX_PROGRESSIVE_LAYER_NUMBER);
    util.each(progressiveLayers, function (layer, idx) {
      if (progressiveElCountsLastFrame[idx] !== layer.elCount) {
        el.__dirty = true;
      }

      if (layer.__dirty) {
        layer.__progress = 0;
      }
    });
  },

  /**
   * 清除hover层外所有内容
   */
  clear: function () {
    this.eachBuiltinLayer(this._clearLayer);
    return this;
  },
  _clearLayer: function (layer) {
    layer.clear();
  },

  /**
   * 修改指定zlevel的绘制参数
   *
   * @param {string} zlevel
   * @param {Object} config 配置对象
   * @param {string} [config.clearColor=0] 每次清空画布的颜色
   * @param {string} [config.motionBlur=false] 是否开启动态模糊
   * @param {number} [config.lastFrameAlpha=0.7]
   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
   */
  configLayer: function (zlevel, config) {
    if (config) {
      var layerConfig = this._layerConfig;

      if (!layerConfig[zlevel]) {
        layerConfig[zlevel] = config;
      } else {
        util.merge(layerConfig[zlevel], config, true);
      }

      var layer = this._layers[zlevel];

      if (layer) {
        util.merge(layer, layerConfig[zlevel], true);
      }
    }
  },

  /**
   * 删除指定层
   * @param {number} zlevel 层所在的zlevel
   */
  delLayer: function (zlevel) {
    var layers = this._layers;
    var zlevelList = this._zlevelList;
    var layer = layers[zlevel];

    if (!layer) {
      return;
    }

    layer.dom.parentNode.removeChild(layer.dom);
    delete layers[zlevel];
    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
  },

  /**
   * 区域大小变化后重绘
   */
  resize: function (width, height) {
    var domRoot = this._domRoot; // FIXME Why ?

    domRoot.style.display = 'none'; // Save input w/h

    var opts = this._opts;
    width != null && (opts.width = width);
    height != null && (opts.height = height);
    width = this._getSize(0);
    height = this._getSize(1);
    domRoot.style.display = ''; // 优化没有实际改变的resize

    if (this._width != width || height != this._height) {
      domRoot.style.width = width + 'px';
      domRoot.style.height = height + 'px';

      for (var id in this._layers) {
        if (this._layers.hasOwnProperty(id)) {
          this._layers[id].resize(width, height);
        }
      }

      util.each(this._progressiveLayers, function (layer) {
        layer.resize(width, height);
      });
      this.refresh(true);
    }

    this._width = width;
    this._height = height;
    return this;
  },

  /**
   * 清除单独的一个层
   * @param {number} zlevel
   */
  clearLayer: function (zlevel) {
    var layer = this._layers[zlevel];

    if (layer) {
      layer.clear();
    }
  },

  /**
   * 释放
   */
  dispose: function () {
    this.root.innerHTML = '';
    this.root = this.storage = this._domRoot = this._layers = null;
  },

  /**
   * Get canvas which has all thing rendered
   * @param {Object} opts
   * @param {string} [opts.backgroundColor]
   * @param {number} [opts.pixelRatio]
   */
  getRenderedCanvas: function (opts) {
    opts = opts || {};

    if (this._singleCanvas) {
      return this._layers[0].dom;
    }

    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
    imageLayer.initContext();
    imageLayer.clearColor = opts.backgroundColor;
    imageLayer.clear();
    var displayList = this.storage.getDisplayList(true);
    var scope = {};
    var zlevel;
    var self = this;

    function findAndDrawOtherLayer(smaller, larger) {
      var zlevelList = self._zlevelList;

      if (smaller == null) {
        smaller = -Infinity;
      }

      var intermediateLayer;

      for (var i = 0; i < zlevelList.length; i++) {
        var z = zlevelList[i];
        var layer = self._layers[z];

        if (!layer.__builtin__ && z > smaller && z < larger) {
          intermediateLayer = layer;
          break;
        }
      }

      if (intermediateLayer && intermediateLayer.renderToCanvas) {
        imageLayer.ctx.save();
        intermediateLayer.renderToCanvas(imageLayer.ctx);
        imageLayer.ctx.restore();
      }
    }

    for (var i = 0; i < displayList.length; i++) {
      var el = displayList[i];

      if (el.zlevel !== zlevel) {
        findAndDrawOtherLayer(zlevel, el.zlevel);
        zlevel = el.zlevel;
      }

      this._doPaintEl(el, imageLayer, true, scope);
    }

    findAndDrawOtherLayer(zlevel, Infinity);
    return imageLayer.dom;
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  pathToImage: function (path, dpr) {
    dpr = dpr || this.dpr;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var rect = path.getBoundingRect();
    var style = path.style;
    var shadowBlurSize = style.shadowBlur;
    var shadowOffsetX = style.shadowOffsetX;
    var shadowOffsetY = style.shadowOffsetY;
    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
    var width = rect.width + leftMargin + rightMargin;
    var height = rect.height + topMargin + bottomMargin;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, width, height);
    ctx.dpr = dpr;
    var pathTransform = {
      position: path.position,
      rotation: path.rotation,
      scale: path.scale
    };
    path.position = [leftMargin - rect.x, topMargin - rect.y];
    path.rotation = 0;
    path.scale = [1, 1];
    path.updateTransform();

    if (path) {
      path.brush(ctx);
    }

    var ImageShape = Image;
    var imgShape = new ImageShape({
      style: {
        x: 0,
        y: 0,
        image: canvas
      }
    });

    if (pathTransform.position != null) {
      imgShape.position = path.position = pathTransform.position;
    }

    if (pathTransform.rotation != null) {
      imgShape.rotation = path.rotation = pathTransform.rotation;
    }

    if (pathTransform.scale != null) {
      imgShape.scale = path.scale = pathTransform.scale;
    }

    return imgShape;
  }
};
var _default = Painter;
module.exports = _default;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(6);

var env = __webpack_require__(64);

var Group = __webpack_require__(261);

var timsort = __webpack_require__(397);

/**
 * Storage内容仓库模块
 * @module zrender/Storage
 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
 * @author errorrik (errorrik@gmail.com)
 * @author pissang (https://github.com/pissang/)
 */
// Use timsort because in most case elements are partially sorted
// https://jsfiddle.net/pissang/jr4x7mdm/8/
function shapeCompareFunc(a, b) {
  if (a.zlevel === b.zlevel) {
    if (a.z === b.z) {
      // if (a.z2 === b.z2) {
      //     // FIXME Slow has renderidx compare
      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
      //     return a.__renderidx - b.__renderidx;
      // }
      return a.z2 - b.z2;
    }

    return a.z - b.z;
  }

  return a.zlevel - b.zlevel;
}
/**
 * 内容仓库 (M)
 * @alias module:zrender/Storage
 * @constructor
 */


var Storage = function () {
  // jshint ignore:line
  this._roots = [];
  this._displayList = [];
  this._displayListLen = 0;
};

Storage.prototype = {
  constructor: Storage,

  /**
   * @param  {Function} cb
   *
   */
  traverse: function (cb, context) {
    for (var i = 0; i < this._roots.length; i++) {
      this._roots[i].traverse(cb, context);
    }
  },

  /**
   * 返回所有图形的绘制队列
   * @param {boolean} [update=false] 是否在返回前更新该数组
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
   *
   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
   * @return {Array.<module:zrender/graphic/Displayable>}
   */
  getDisplayList: function (update, includeIgnore) {
    includeIgnore = includeIgnore || false;

    if (update) {
      this.updateDisplayList(includeIgnore);
    }

    return this._displayList;
  },

  /**
   * 更新图形的绘制队列。
   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
   */
  updateDisplayList: function (includeIgnore) {
    this._displayListLen = 0;
    var roots = this._roots;
    var displayList = this._displayList;

    for (var i = 0, len = roots.length; i < len; i++) {
      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
    }

    displayList.length = this._displayListLen; // for (var i = 0, len = displayList.length; i < len; i++) {
    //     displayList[i].__renderidx = i;
    // }
    // displayList.sort(shapeCompareFunc);

    env.canvasSupported && timsort(displayList, shapeCompareFunc);
  },
  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
    if (el.ignore && !includeIgnore) {
      return;
    }

    el.beforeUpdate();

    if (el.__dirty) {
      el.update();
    }

    el.afterUpdate();
    var userSetClipPath = el.clipPath;

    if (userSetClipPath) {
      // FIXME 效率影响
      if (clipPaths) {
        clipPaths = clipPaths.slice();
      } else {
        clipPaths = [];
      }

      var currentClipPath = userSetClipPath;
      var parentClipPath = el; // Recursively add clip path

      while (currentClipPath) {
        // clipPath 的变换是基于使用这个 clipPath 的元素
        currentClipPath.parent = parentClipPath;
        currentClipPath.updateTransform();
        clipPaths.push(currentClipPath);
        parentClipPath = currentClipPath;
        currentClipPath = currentClipPath.clipPath;
      }
    }

    if (el.isGroup) {
      var children = el._children;

      for (var i = 0; i < children.length; i++) {
        var child = children[i]; // Force to mark as dirty if group is dirty
        // FIXME __dirtyPath ?

        if (el.__dirty) {
          child.__dirty = true;
        }

        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
      } // Mark group clean here


      el.__dirty = false;
    } else {
      el.__clipPaths = clipPaths;
      this._displayList[this._displayListLen++] = el;
    }
  },

  /**
   * 添加图形(Shape)或者组(Group)到根节点
   * @param {module:zrender/Element} el
   */
  addRoot: function (el) {
    if (el.__storage === this) {
      return;
    }

    if (el instanceof Group) {
      el.addChildrenToStorage(this);
    }

    this.addToStorage(el);

    this._roots.push(el);
  },

  /**
   * 删除指定的图形(Shape)或者组(Group)
   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
   */
  delRoot: function (el) {
    if (el == null) {
      // 不指定el清空
      for (var i = 0; i < this._roots.length; i++) {
        var root = this._roots[i];

        if (root instanceof Group) {
          root.delChildrenFromStorage(this);
        }
      }

      this._roots = [];
      this._displayList = [];
      this._displayListLen = 0;
      return;
    }

    if (el instanceof Array) {
      for (var i = 0, l = el.length; i < l; i++) {
        this.delRoot(el[i]);
      }

      return;
    }

    var idx = util.indexOf(this._roots, el);

    if (idx >= 0) {
      this.delFromStorage(el);

      this._roots.splice(idx, 1);

      if (el instanceof Group) {
        el.delChildrenFromStorage(this);
      }
    }
  },
  addToStorage: function (el) {
    el.__storage = this;
    el.dirty(false);
    return this;
  },
  delFromStorage: function (el) {
    if (el) {
      el.__storage = null;
    }

    return this;
  },

  /**
   * 清空并且释放Storage
   */
  dispose: function () {
    this._renderList = this._roots = null;
  },
  displayableSortFunc: shapeCompareFunc
};
var _default = Storage;
module.exports = _default;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(6);

var _event = __webpack_require__(193);

var Dispatcher = _event.Dispatcher;

var requestAnimationFrame = __webpack_require__(706);

var Animator = __webpack_require__(705);

/**
 * 动画主类, 调度和管理所有动画控制器
 *
 * @module zrender/animation/Animation
 * @author pissang(https://github.com/pissang)
 */
// TODO Additive animation
// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
// https://developer.apple.com/videos/wwdc2014/#236

/**
 * @typedef {Object} IZRenderStage
 * @property {Function} update
 */

/**
 * @alias module:zrender/animation/Animation
 * @constructor
 * @param {Object} [options]
 * @param {Function} [options.onframe]
 * @param {IZRenderStage} [options.stage]
 * @example
 *     var animation = new Animation();
 *     var obj = {
 *         x: 100,
 *         y: 100
 *     };
 *     animation.animate(node.position)
 *         .when(1000, {
 *             x: 500,
 *             y: 500
 *         })
 *         .when(2000, {
 *             x: 100,
 *             y: 100
 *         })
 *         .start('spline');
 */
var Animation = function (options) {
  options = options || {};
  this.stage = options.stage || {};

  this.onframe = options.onframe || function () {}; // private properties


  this._clips = [];
  this._running = false;
  this._time;
  this._pausedTime;
  this._pauseStart;
  this._paused = false;
  Dispatcher.call(this);
};

Animation.prototype = {
  constructor: Animation,

  /**
   * 添加 clip
   * @param {module:zrender/animation/Clip} clip
   */
  addClip: function (clip) {
    this._clips.push(clip);
  },

  /**
   * 添加 animator
   * @param {module:zrender/animation/Animator} animator
   */
  addAnimator: function (animator) {
    animator.animation = this;
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.addClip(clips[i]);
    }
  },

  /**
   * 删除动画片段
   * @param {module:zrender/animation/Clip} clip
   */
  removeClip: function (clip) {
    var idx = util.indexOf(this._clips, clip);

    if (idx >= 0) {
      this._clips.splice(idx, 1);
    }
  },

  /**
   * 删除动画片段
   * @param {module:zrender/animation/Animator} animator
   */
  removeAnimator: function (animator) {
    var clips = animator.getClips();

    for (var i = 0; i < clips.length; i++) {
      this.removeClip(clips[i]);
    }

    animator.animation = null;
  },
  _update: function () {
    var time = new Date().getTime() - this._pausedTime;

    var delta = time - this._time;
    var clips = this._clips;
    var len = clips.length;
    var deferredEvents = [];
    var deferredClips = [];

    for (var i = 0; i < len; i++) {
      var clip = clips[i];
      var e = clip.step(time, delta); // Throw out the events need to be called after
      // stage.update, like destroy

      if (e) {
        deferredEvents.push(e);
        deferredClips.push(clip);
      }
    } // Remove the finished clip


    for (var i = 0; i < len;) {
      if (clips[i]._needsRemove) {
        clips[i] = clips[len - 1];
        clips.pop();
        len--;
      } else {
        i++;
      }
    }

    len = deferredEvents.length;

    for (var i = 0; i < len; i++) {
      deferredClips[i].fire(deferredEvents[i]);
    }

    this._time = time;
    this.onframe(delta);
    this.trigger('frame', delta);

    if (this.stage.update) {
      this.stage.update();
    }
  },
  _startLoop: function () {
    var self = this;
    this._running = true;

    function step() {
      if (self._running) {
        requestAnimationFrame(step);
        !self._paused && self._update();
      }
    }

    requestAnimationFrame(step);
  },

  /**
   * 开始运行动画
   */
  start: function () {
    this._time = new Date().getTime();
    this._pausedTime = 0;

    this._startLoop();
  },

  /**
   * 停止运行动画
   */
  stop: function () {
    this._running = false;
  },

  /**
   * Pause
   */
  pause: function () {
    if (!this._paused) {
      this._pauseStart = new Date().getTime();
      this._paused = true;
    }
  },

  /**
   * Resume
   */
  resume: function () {
    if (this._paused) {
      this._pausedTime += new Date().getTime() - this._pauseStart;
      this._paused = false;
    }
  },

  /**
   * 清除所有动画片段
   */
  clear: function () {
    this._clips = [];
  },

  /**
   * 对一个目标创建一个animator对象，可以指定目标中的属性使用动画
   * @param  {Object} target
   * @param  {Object} options
   * @param  {boolean} [options.loop=false] 是否循环播放动画
   * @param  {Function} [options.getter=null]
   *         如果指定getter函数，会通过getter函数取属性值
   * @param  {Function} [options.setter=null]
   *         如果指定setter函数，会通过setter函数设置属性值
   * @return {module:zrender/animation/Animation~Animator}
   */
  // TODO Gap
  animate: function (target, options) {
    options = options || {};
    var animator = new Animator(target, options.loop, options.getter, options.setter);
    this.addAnimator(animator);
    return animator;
  }
};
util.mixin(Animation, Dispatcher);
var _default = Animation;
module.exports = _default;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

var easingFuncs = __webpack_require__(1916);

/**
 * 动画主控制器
 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
 * @config life(1000) 动画时长
 * @config delay(0) 动画延迟时间
 * @config loop(true)
 * @config gap(0) 循环的间隔时间
 * @config onframe
 * @config easing(optional)
 * @config ondestroy(optional)
 * @config onrestart(optional)
 *
 * TODO pause
 */
function Clip(options) {
  this._target = options.target; // 生命周期

  this._life = options.life || 1000; // 延时

  this._delay = options.delay || 0; // 开始时间
  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒

  this._initialized = false; // 是否循环

  this.loop = options.loop == null ? false : options.loop;
  this.gap = options.gap || 0;
  this.easing = options.easing || 'Linear';
  this.onframe = options.onframe;
  this.ondestroy = options.ondestroy;
  this.onrestart = options.onrestart;
  this._pausedTime = 0;
  this._paused = false;
}

Clip.prototype = {
  constructor: Clip,
  step: function (globalTime, deltaTime) {
    // Set startTime on first step, or _startTime may has milleseconds different between clips
    // PENDING
    if (!this._initialized) {
      this._startTime = globalTime + this._delay;
      this._initialized = true;
    }

    if (this._paused) {
      this._pausedTime += deltaTime;
      return;
    }

    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始

    if (percent < 0) {
      return;
    }

    percent = Math.min(percent, 1);
    var easing = this.easing;
    var easingFunc = typeof easing == 'string' ? easingFuncs[easing] : easing;
    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
    this.fire('frame', schedule); // 结束

    if (percent == 1) {
      if (this.loop) {
        this.restart(globalTime); // 重新开始周期
        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件

        return 'restart';
      } // 动画完成将这个控制器标识为待删除
      // 在Animation.update中进行批量删除


      this._needsRemove = true;
      return 'destroy';
    }

    return null;
  },
  restart: function (globalTime) {
    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
    this._startTime = globalTime - remainder + this.gap;
    this._pausedTime = 0;
    this._needsRemove = false;
  },
  fire: function (eventType, arg) {
    eventType = 'on' + eventType;

    if (this[eventType]) {
      this[eventType](this._target, arg);
    }
  },
  pause: function () {
    this._paused = true;
  },
  resume: function () {
    this._paused = false;
  }
};
var _default = Clip;
module.exports = _default;

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

/**
 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
 * @see http://sole.github.io/tween.js/examples/03_graphs.html
 * @exports zrender/animation/easing
 */
var easing = {
  /**
  * @param {number} k
  * @return {number}
  */
  linear: function (k) {
    return k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticIn: function (k) {
    return k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticOut: function (k) {
    return k * (2 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quadraticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k;
    }

    return -0.5 * (--k * (k - 2) - 1);
  },
  // 三次方的缓动（t^3）

  /**
  * @param {number} k
  * @return {number}
  */
  cubicIn: function (k) {
    return k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicOut: function (k) {
    return --k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  cubicInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k + 2);
  },
  // 四次方的缓动（t^4）

  /**
  * @param {number} k
  * @return {number}
  */
  quarticIn: function (k) {
    return k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticOut: function (k) {
    return 1 - --k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quarticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k;
    }

    return -0.5 * ((k -= 2) * k * k * k - 2);
  },
  // 五次方的缓动（t^5）

  /**
  * @param {number} k
  * @return {number}
  */
  quinticIn: function (k) {
    return k * k * k * k * k;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticOut: function (k) {
    return --k * k * k * k * k + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  quinticInOut: function (k) {
    if ((k *= 2) < 1) {
      return 0.5 * k * k * k * k * k;
    }

    return 0.5 * ((k -= 2) * k * k * k * k + 2);
  },
  // 正弦曲线的缓动（sin(t)）

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalIn: function (k) {
    return 1 - Math.cos(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalOut: function (k) {
    return Math.sin(k * Math.PI / 2);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  sinusoidalInOut: function (k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  },
  // 指数曲线的缓动（2^t）

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialIn: function (k) {
    return k === 0 ? 0 : Math.pow(1024, k - 1);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialOut: function (k) {
    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  exponentialInOut: function (k) {
    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if ((k *= 2) < 1) {
      return 0.5 * Math.pow(1024, k - 1);
    }

    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  },
  // 圆形曲线的缓动（sqrt(1-t^2)）

  /**
  * @param {number} k
  * @return {number}
  */
  circularIn: function (k) {
    return 1 - Math.sqrt(1 - k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularOut: function (k) {
    return Math.sqrt(1 - --k * k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  circularInOut: function (k) {
    if ((k *= 2) < 1) {
      return -0.5 * (Math.sqrt(1 - k * k) - 1);
    }

    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  },
  // 创建类似于弹簧在停止前来回振荡的动画

  /**
  * @param {number} k
  * @return {number}
  */
  elasticIn: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  elasticInOut: function (k) {
    var s;
    var a = 0.1;
    var p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = p * Math.asin(1 / a) / (2 * Math.PI);
    }

    if ((k *= 2) < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    }

    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
  },
  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动

  /**
  * @param {number} k
  * @return {number}
  */
  backIn: function (k) {
    var s = 1.70158;
    return k * k * ((s + 1) * k - s);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backOut: function (k) {
    var s = 1.70158;
    return --k * k * ((s + 1) * k + s) + 1;
  },

  /**
  * @param {number} k
  * @return {number}
  */
  backInOut: function (k) {
    var s = 1.70158 * 1.525;

    if ((k *= 2) < 1) {
      return 0.5 * (k * k * ((s + 1) * k - s));
    }

    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  },
  // 创建弹跳效果

  /**
  * @param {number} k
  * @return {number}
  */
  bounceIn: function (k) {
    return 1 - easing.bounceOut(1 - k);
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceOut: function (k) {
    if (k < 1 / 2.75) {
      return 7.5625 * k * k;
    } else if (k < 2 / 2.75) {
      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
    } else if (k < 2.5 / 2.75) {
      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
    } else {
      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    }
  },

  /**
  * @param {number} k
  * @return {number}
  */
  bounceInOut: function (k) {
    if (k < 0.5) {
      return easing.bounceIn(k * 2) * 0.5;
    }

    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
  }
};
var _default = easing;
module.exports = _default;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

var _util = __webpack_require__(707);

var normalizeRadian = _util.normalizeRadian;
var PI2 = Math.PI * 2;
/**
 * 圆弧描边包含判断
 * @param  {number}  cx
 * @param  {number}  cy
 * @param  {number}  r
 * @param  {number}  startAngle
 * @param  {number}  endAngle
 * @param  {boolean}  anticlockwise
 * @param  {number} lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {Boolean}
 */

function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  x -= cx;
  y -= cy;
  var d = Math.sqrt(x * x + y * y);

  if (d - _l > r || d + _l < r) {
    return false;
  }

  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
    // Is a circle
    return true;
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += PI2;
  }

  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
}

exports.containStroke = containStroke;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

var curve = __webpack_require__(154);

/**
 * 三次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  x3
 * @param  {number}  y3
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
    return false;
  }

  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

/**
 * 线段包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth;
  var _a = 0;
  var _b = x0; // Quick reject

  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
    return false;
  }

  if (x0 !== x1) {
    _a = (y0 - y1) / (x0 - x1);
    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
  } else {
    return Math.abs(x - x0) <= _l / 2;
  }

  var tmp = _a * x - y + _b;

  var _s = tmp * tmp / (_a * _a + 1);

  return _s <= _l / 2 * _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(192);

var line = __webpack_require__(1919);

var cubic = __webpack_require__(1918);

var quadratic = __webpack_require__(1922);

var arc = __webpack_require__(1917);

var _util = __webpack_require__(707);

var normalizeRadian = _util.normalizeRadian;

var curve = __webpack_require__(154);

var windingLine = __webpack_require__(708);

var CMD = PathProxy.CMD;
var PI2 = Math.PI * 2;
var EPSILON = 1e-4;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
} // 临时数组


var roots = [-1, -1, -1];
var extrema = [-1, -1];

function swapExtrema() {
  var tmp = extrema[0];
  extrema[0] = extrema[1];
  extrema[1] = tmp;
}

function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
    return 0;
  }

  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var w = 0;
    var nExtrema = -1;
    var y0_, y1_;

    for (var i = 0; i < nRoots; i++) {
      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon

      var unit = t === 0 || t === 1 ? 0.5 : 1;
      var x_ = curve.cubicAt(x0, x1, x2, x3, t);

      if (x_ < x) {
        // Quick reject
        continue;
      }

      if (nExtrema < 0) {
        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);

        if (extrema[1] < extrema[0] && nExtrema > 1) {
          swapExtrema();
        }

        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);

        if (nExtrema > 1) {
          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
        }
      }

      if (nExtrema == 2) {
        // 分成三段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else if (t < extrema[1]) {
          w += y1_ < y0_ ? unit : -unit;
        } else {
          w += y3 < y1_ ? unit : -unit;
        }
      } else {
        // 分成两段单调函数
        if (t < extrema[0]) {
          w += y0_ < y0 ? unit : -unit;
        } else {
          w += y3 < y0_ ? unit : -unit;
        }
      }
    }

    return w;
  }
}

function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
  // Quick reject
  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
    return 0;
  }

  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);

  if (nRoots === 0) {
    return 0;
  } else {
    var t = curve.quadraticExtremum(y0, y1, y2);

    if (t >= 0 && t <= 1) {
      var w = 0;
      var y_ = curve.quadraticAt(y0, y1, y2, t);

      for (var i = 0; i < nRoots; i++) {
        // Remove one endpoint.
        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);

        if (x_ < x) {
          // Quick reject
          continue;
        }

        if (roots[i] < t) {
          w += y_ < y0 ? unit : -unit;
        } else {
          w += y2 < y_ ? unit : -unit;
        }
      }

      return w;
    } else {
      // Remove one endpoint.
      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);

      if (x_ < x) {
        // Quick reject
        return 0;
      }

      return y2 < y0 ? unit : -unit;
    }
  }
} // TODO
// Arc 旋转


function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
  y -= cy;

  if (y > r || y < -r) {
    return 0;
  }

  var tmp = Math.sqrt(r * r - y * y);
  roots[0] = -tmp;
  roots[1] = tmp;
  var diff = Math.abs(startAngle - endAngle);

  if (diff < 1e-4) {
    return 0;
  }

  if (diff % PI2 < 1e-4) {
    // Is a circle
    startAngle = 0;
    endAngle = PI2;
    var dir = anticlockwise ? 1 : -1;

    if (x >= roots[0] + cx && x <= roots[1] + cx) {
      return dir;
    } else {
      return 0;
    }
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2;
  }

  var w = 0;

  for (var i = 0; i < 2; i++) {
    var x_ = roots[i];

    if (x_ + cx > x) {
      var angle = Math.atan2(y, x_);
      var dir = anticlockwise ? 1 : -1;

      if (angle < 0) {
        angle = PI2 + angle;
      }

      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
          dir = -dir;
        }

        w += dir;
      }
    }
  }

  return w;
}

function containPath(data, lineWidth, isStroke, x, y) {
  var w = 0;
  var xi = 0;
  var yi = 0;
  var x0 = 0;
  var y0 = 0;

  for (var i = 0; i < data.length;) {
    var cmd = data[i++]; // Begin a new subpath

    if (cmd === CMD.M && i > 1) {
      // Close previous subpath
      if (!isStroke) {
        w += windingLine(xi, yi, x0, y0, x, y);
      } // 如果被任何一个 subpath 包含
      // if (w !== 0) {
      //     return true;
      // }

    }

    if (i == 1) {
      // 如果第一个命令是 L, C, Q
      // 则 previous point 同绘制命令的第一个 point
      //
      // 第一个命令为 Arc 的情况下会在后面特殊处理
      xi = data[i];
      yi = data[i + 1];
      x0 = xi;
      y0 = yi;
    }

    switch (cmd) {
      case CMD.M:
        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
        // 在 closePath 的时候使用
        x0 = data[i++];
        y0 = data[i++];
        xi = x0;
        yi = y0;
        break;

      case CMD.L:
        if (isStroke) {
          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.C:
        if (isStroke) {
          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.Q:
        if (isStroke) {
          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
            return true;
          }
        } else {
          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
        }

        xi = data[i++];
        yi = data[i++];
        break;

      case CMD.A:
        // TODO Arc 判断的开销比较大
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++]; // TODO Arc 旋转

        var psi = data[i++];
        var anticlockwise = 1 - data[i++];
        var x1 = Math.cos(theta) * rx + cx;
        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令

        if (i > 1) {
          w += windingLine(xi, yi, x1, y1, x, y);
        } else {
          // 第一个命令起点还未定义
          x0 = x1;
          y0 = y1;
        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放


        var _x = (x - cx) * ry / rx + cx;

        if (isStroke) {
          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
            return true;
          }
        } else {
          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
        }

        xi = Math.cos(theta + dTheta) * rx + cx;
        yi = Math.sin(theta + dTheta) * ry + cy;
        break;

      case CMD.R:
        x0 = xi = data[i++];
        y0 = yi = data[i++];
        var width = data[i++];
        var height = data[i++];
        var x1 = x0 + width;
        var y1 = y0 + height;

        if (isStroke) {
          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // FIXME Clockwise ?
          w += windingLine(x1, y0, x1, y1, x, y);
          w += windingLine(x0, y1, x0, y0, x, y);
        }

        break;

      case CMD.Z:
        if (isStroke) {
          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
            return true;
          }
        } else {
          // Close a subpath
          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
          // FIXME subpaths may overlap
          // if (w !== 0) {
          //     return true;
          // }
        }

        xi = x0;
        yi = y0;
        break;
    }
  }

  if (!isStroke && !isAroundEqual(yi, y0)) {
    w += windingLine(xi, yi, x0, y0, x, y) || 0;
  }

  return w !== 0;
}

function contain(pathData, x, y) {
  return containPath(pathData, 0, false, x, y);
}

function containStroke(pathData, lineWidth, x, y) {
  return containPath(pathData, lineWidth, true, x, y);
}

exports.contain = contain;
exports.containStroke = containStroke;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

var windingLine = __webpack_require__(708);

var EPSILON = 1e-8;

function isAroundEqual(a, b) {
  return Math.abs(a - b) < EPSILON;
}

function contain(points, x, y) {
  var w = 0;
  var p = points[0];

  if (!p) {
    return false;
  }

  for (var i = 1; i < points.length; i++) {
    var p2 = points[i];
    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
    p = p2;
  } // Close polygon


  var p0 = points[0];

  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
  }

  return w !== 0;
}

exports.contain = contain;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

var _curve = __webpack_require__(154);

var quadraticProjectPoint = _curve.quadraticProjectPoint;

/**
 * 二次贝塞尔曲线描边包含判断
 * @param  {number}  x0
 * @param  {number}  y0
 * @param  {number}  x1
 * @param  {number}  y1
 * @param  {number}  x2
 * @param  {number}  y2
 * @param  {number}  lineWidth
 * @param  {number}  x
 * @param  {number}  y
 * @return {boolean}
 */
function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
  if (lineWidth === 0) {
    return false;
  }

  var _l = lineWidth; // Quick reject

  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
    return false;
  }

  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
  return d <= _l / 2;
}

exports.containStroke = containStroke;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

var eventUtil = __webpack_require__(193);

/**
 * Only implements needed gestures for mobile.
 */
var GestureMgr = function () {
  /**
   * @private
   * @type {Array.<Object>}
   */
  this._track = [];
};

GestureMgr.prototype = {
  constructor: GestureMgr,
  recognize: function (event, target, root) {
    this._doTrack(event, target, root);

    return this._recognize(event);
  },
  clear: function () {
    this._track.length = 0;
    return this;
  },
  _doTrack: function (event, target, root) {
    var touches = event.touches;

    if (!touches) {
      return;
    }

    var trackItem = {
      points: [],
      touches: [],
      target: target,
      event: event
    };

    for (var i = 0, len = touches.length; i < len; i++) {
      var touch = touches[i];
      var pos = eventUtil.clientToLocal(root, touch, {});
      trackItem.points.push([pos.zrX, pos.zrY]);
      trackItem.touches.push(touch);
    }

    this._track.push(trackItem);
  },
  _recognize: function (event) {
    for (var eventName in recognizers) {
      if (recognizers.hasOwnProperty(eventName)) {
        var gestureInfo = recognizers[eventName](this._track, event);

        if (gestureInfo) {
          return gestureInfo;
        }
      }
    }
  }
};

function dist(pointPair) {
  var dx = pointPair[1][0] - pointPair[0][0];
  var dy = pointPair[1][1] - pointPair[0][1];
  return Math.sqrt(dx * dx + dy * dy);
}

function center(pointPair) {
  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
}

var recognizers = {
  pinch: function (track, event) {
    var trackLen = track.length;

    if (!trackLen) {
      return;
    }

    var pinchEnd = (track[trackLen - 1] || {}).points;
    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;

    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
      var pinchScale = dist(pinchEnd) / dist(pinchPre);
      !isFinite(pinchScale) && (pinchScale = 1);
      event.pinchScale = pinchScale;
      var pinchCenter = center(pinchEnd);
      event.pinchX = pinchCenter[0];
      event.pinchY = pinchCenter[1];
      return {
        type: 'pinch',
        target: track[0].target,
        event: event
      };
    }
  } // Only pinch currently.

};
var _default = GestureMgr;
module.exports = _default;

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

// Myers' Diff Algorithm
// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
function Diff() {}

Diff.prototype = {
  diff: function (oldArr, newArr, equals) {
    if (!equals) {
      equals = function (a, b) {
        return a === b;
      };
    }

    this.equals = equals;
    var self = this;
    oldArr = oldArr.slice();
    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running

    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var editLength = 1;
    var maxEditLength = newLen + oldLen;
    var bestPath = [{
      newPos: -1,
      components: []
    }]; // Seed editLength = 0, i.e. the content starts with the same values

    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);

    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
      var indices = [];

      for (var i = 0; i < newArr.length; i++) {
        indices.push(i);
      } // Identity per the equality and tokenizer


      return [{
        indices: indices,
        count: newArr.length
      }];
    } // Main worker method. checks all permutations of a given edit length for acceptance.


    function execEditLength() {
      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
        var basePath;
        var addPath = bestPath[diagonalPath - 1];
        var removePath = bestPath[diagonalPath + 1];
        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;

        if (addPath) {
          // No one else is going to attempt to use this value, clear it
          bestPath[diagonalPath - 1] = undefined;
        }

        var canAdd = addPath && addPath.newPos + 1 < newLen;
        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;

        if (!canAdd && !canRemove) {
          // If this path is a terminal then prune
          bestPath[diagonalPath] = undefined;
          continue;
        } // Select the diagonal that we want to branch from. We select the prior
        // path whose position in the new string is the farthest from the origin
        // and does not pass the bounds of the diff graph


        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
          basePath = clonePath(removePath);
          self.pushComponent(basePath.components, undefined, true);
        } else {
          basePath = addPath; // No need to clone, we've pulled it from the list

          basePath.newPos++;
          self.pushComponent(basePath.components, true, undefined);
        }

        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done

        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
          return buildValues(self, basePath.components, newArr, oldArr);
        } else {
          // Otherwise track this path as a potential candidate and continue.
          bestPath[diagonalPath] = basePath;
        }
      }

      editLength++;
    }

    while (editLength <= maxEditLength) {
      var ret = execEditLength();

      if (ret) {
        return ret;
      }
    }
  },
  pushComponent: function (components, added, removed) {
    var last = components[components.length - 1];

    if (last && last.added === added && last.removed === removed) {
      // We need to clone here as the component clone operation is just
      // as shallow array clone
      components[components.length - 1] = {
        count: last.count + 1,
        added: added,
        removed: removed
      };
    } else {
      components.push({
        count: 1,
        added: added,
        removed: removed
      });
    }
  },
  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
    var newLen = newArr.length;
    var oldLen = oldArr.length;
    var newPos = basePath.newPos;
    var oldPos = newPos - diagonalPath;
    var commonCount = 0;

    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
      newPos++;
      oldPos++;
      commonCount++;
    }

    if (commonCount) {
      basePath.components.push({
        count: commonCount
      });
    }

    basePath.newPos = newPos;
    return oldPos;
  },
  tokenize: function (value) {
    return value.slice();
  },
  join: function (value) {
    return value.slice();
  }
};

function buildValues(diff, components, newArr, oldArr) {
  var componentPos = 0;
  var componentLen = components.length;
  var newPos = 0;
  var oldPos = 0;

  for (; componentPos < componentLen; componentPos++) {
    var component = components[componentPos];

    if (!component.removed) {
      var indices = [];

      for (var i = newPos; i < newPos + component.count; i++) {
        indices.push(i);
      }

      component.indices = indices;
      newPos += component.count; // Common case

      if (!component.added) {
        oldPos += component.count;
      }
    } else {
      var indices = [];

      for (var i = oldPos; i < oldPos + component.count; i++) {
        indices.push(i);
      }

      component.indices = indices;
      oldPos += component.count;
    }
  }

  return components;
}

function clonePath(path) {
  return {
    newPos: path.newPos,
    components: path.components.slice(0)
  };
}

var arrayDiff = new Diff();

function _default(oldArr, newArr, callback) {
  return arrayDiff.diff(oldArr, newArr, callback);
}

module.exports = _default;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

var _event = __webpack_require__(193);

var addEventListener = _event.addEventListener;
var removeEventListener = _event.removeEventListener;
var normalizeEvent = _event.normalizeEvent;

var zrUtil = __webpack_require__(6);

var Eventful = __webpack_require__(194);

var env = __webpack_require__(64);

var GestureMgr = __webpack_require__(1923);

var TOUCH_CLICK_DELAY = 300;
var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
var pointerEventNames = {
  pointerdown: 1,
  pointerup: 1,
  pointermove: 1,
  pointerout: 1
};
var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
  var nm = name.replace('mouse', 'pointer');
  return pointerEventNames[nm] ? nm : name;
});

function eventNameFix(name) {
  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
}

function processGesture(proxy, event, stage) {
  var gestureMgr = proxy._gestureMgr;
  stage === 'start' && gestureMgr.clear();
  var gestureInfo = gestureMgr.recognize(event, proxy.handler.findHover(event.zrX, event.zrY, null).target, proxy.dom);
  stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.

  if (gestureInfo) {
    var type = gestureInfo.type;
    event.gestureEvent = type;
    proxy.handler.dispatchToElement({
      target: gestureInfo.target
    }, type, gestureInfo.event);
  }
} // function onMSGestureChange(proxy, event) {
//     if (event.translationX || event.translationY) {
//         // mousemove is carried by MSGesture to reduce the sensitivity.
//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
//     }
//     if (event.scale !== 1) {
//         event.pinchX = event.offsetX;
//         event.pinchY = event.offsetY;
//         event.pinchScale = event.scale;
//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
//     }
// }

/**
 * Prevent mouse event from being dispatched after Touch Events action
 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
 * Result: Blocking Mouse Events for 700ms.
 */


function setTouchTimer(instance) {
  instance._touching = true;
  clearTimeout(instance._touchTimer);
  instance._touchTimer = setTimeout(function () {
    instance._touching = false;
  }, 700);
}

var domHandlers = {
  /**
   * Mouse move handler
   * @inner
   * @param {Event} event
   */
  mousemove: function (event) {
    event = normalizeEvent(this.dom, event);
    this.trigger('mousemove', event);
  },

  /**
   * Mouse out handler
   * @inner
   * @param {Event} event
   */
  mouseout: function (event) {
    event = normalizeEvent(this.dom, event);
    var element = event.toElement || event.relatedTarget;

    if (element != this.dom) {
      while (element && element.nodeType != 9) {
        // 忽略包含在root中的dom引起的mouseOut
        if (element === this.dom) {
          return;
        }

        element = element.parentNode;
      }
    }

    this.trigger('mouseout', event);
  },

  /**
   * Touch开始响应函数
   * @inner
   * @param {Event} event
   */
  touchstart: function (event) {
    // Default mouse behaviour should not be disabled here.
    // For example, page may needs to be slided.
    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
    // mouse event in upper applicatoin.

    event.zrByTouch = true;
    this._lastTouchMoment = new Date();
    processGesture(this, event, 'start'); // In touch device, trigger `mousemove`(`mouseover`) should
    // be triggered, and must before `mousedown` triggered.

    domHandlers.mousemove.call(this, event);
    domHandlers.mousedown.call(this, event);
    setTouchTimer(this);
  },

  /**
   * Touch移动响应函数
   * @inner
   * @param {Event} event
   */
  touchmove: function (event) {
    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
    // mouse event in upper applicatoin.

    event.zrByTouch = true;
    processGesture(this, event, 'change'); // Mouse move should always be triggered no matter whether
    // there is gestrue event, because mouse move and pinch may
    // be used at the same time.

    domHandlers.mousemove.call(this, event);
    setTouchTimer(this);
  },

  /**
   * Touch结束响应函数
   * @inner
   * @param {Event} event
   */
  touchend: function (event) {
    event = normalizeEvent(this.dom, event); // Mark touch, which is useful in distinguish touch and
    // mouse event in upper applicatoin.

    event.zrByTouch = true;
    processGesture(this, event, 'end');
    domHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
    // we can conveniently implement "hover style" in both PC and touch device just
    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
    // to remove "hover style" on an element, without any additional code for
    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
    // style" will remain for user view)
    // click event should always be triggered no matter whether
    // there is gestrue event. System click can not be prevented.

    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
      domHandlers.click.call(this, event);
    }

    setTouchTimer(this);
  },
  pointerdown: function (event) {
    domHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
    //     this._msGesture.addPointer(event.pointerId);
    // }
  },
  pointermove: function (event) {
    // FIXME
    // pointermove is so sensitive that it always triggered when
    // tap(click) on touch screen, which affect some judgement in
    // upper application. So, we dont support mousemove on MS touch
    // device yet.
    if (!isPointerFromTouch(event)) {
      domHandlers.mousemove.call(this, event);
    }
  },
  pointerup: function (event) {
    domHandlers.mouseup.call(this, event);
  },
  pointerout: function (event) {
    // pointerout will be triggered when tap on touch screen
    // (IE11+/Edge on MS Surface) after click event triggered,
    // which is inconsistent with the mousout behavior we defined
    // in touchend. So we unify them.
    // (check domHandlers.touchend for detailed explanation)
    if (!isPointerFromTouch(event)) {
      domHandlers.mouseout.call(this, event);
    }
  }
};

function isPointerFromTouch(event) {
  var pointerType = event.pointerType;
  return pointerType === 'pen' || pointerType === 'touch';
} // function useMSGuesture(handlerProxy, event) {
//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
// }
// Common handlers


zrUtil.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
  domHandlers[name] = function (event) {
    event = normalizeEvent(this.dom, event);
    this.trigger(name, event);
  };
});
/**
 * 为控制类实例初始化dom 事件处理函数
 *
 * @inner
 * @param {module:zrender/Handler} instance 控制类实例
 */

function initDomHandler(instance) {
  zrUtil.each(touchHandlerNames, function (name) {
    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
  });
  zrUtil.each(pointerHandlerNames, function (name) {
    instance._handlers[name] = zrUtil.bind(domHandlers[name], instance);
  });
  zrUtil.each(mouseHandlerNames, function (name) {
    instance._handlers[name] = makeMouseHandler(domHandlers[name], instance);
  });

  function makeMouseHandler(fn, instance) {
    return function () {
      if (instance._touching) {
        return;
      }

      return fn.apply(instance, arguments);
    };
  }
}

function HandlerDomProxy(dom) {
  Eventful.call(this);
  this.dom = dom;
  /**
   * @private
   * @type {boolean}
   */

  this._touching = false;
  /**
   * @private
   * @type {number}
   */

  this._touchTimer;
  /**
   * @private
   * @type {module:zrender/core/GestureMgr}
   */

  this._gestureMgr = new GestureMgr();
  this._handlers = {};
  initDomHandler(this);

  if (env.pointerEventsSupported) {
    // Only IE11+/Edge
    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
    // at the same time.
    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
    // screen, which do not occurs in pointer event.
    // So we use pointer event to both detect touch gesture and mouse behavior.
    mountHandlers(pointerHandlerNames, this); // FIXME
    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
    // which does not prevent defuault behavior occasionally (which may cause view port
    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
    // touch screen. And we only support click behavior on MS touch screen now.
    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
    // We dont support touch on IE on win7.
    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
    // if (typeof MSGesture === 'function') {
    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
    // }
  } else {
    if (env.touchEventsSupported) {
      mountHandlers(touchHandlerNames, this); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
      // addEventListener(root, 'mouseout', this._mouseoutHandler);
    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
    // mouse event can not be handle in those devices.
    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
    // mouseevent after touch event triggered, see `setTouchTimer`.


    mountHandlers(mouseHandlerNames, this);
  }

  function mountHandlers(handlerNames, instance) {
    zrUtil.each(handlerNames, function (name) {
      addEventListener(dom, eventNameFix(name), instance._handlers[name]);
    }, instance);
  }
}

var handlerDomProxyProto = HandlerDomProxy.prototype;

handlerDomProxyProto.dispose = function () {
  var handlerNames = mouseHandlerNames.concat(touchHandlerNames);

  for (var i = 0; i < handlerNames.length; i++) {
    var name = handlerNames[i];
    removeEventListener(this.dom, eventNameFix(name), this._handlers[name]);
  }
};

handlerDomProxyProto.setCursor = function (cursorStyle) {
  this.dom.style.cursor = cursorStyle || 'default';
};

zrUtil.mixin(HandlerDomProxy, Eventful);
var _default = HandlerDomProxy;
module.exports = _default;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

// CompoundPath to improve performance
var _default = Path.extend({
  type: 'compound',
  shape: {
    paths: null
  },
  _updatePathDirty: function () {
    var dirtyPath = this.__dirtyPath;
    var paths = this.shape.paths;

    for (var i = 0; i < paths.length; i++) {
      // Mark as dirty if any subpath is dirty
      dirtyPath = dirtyPath || paths[i].__dirtyPath;
    }

    this.__dirtyPath = dirtyPath;
    this.__dirty = this.__dirty || dirtyPath;
  },
  beforeBrush: function () {
    this._updatePathDirty();

    var paths = this.shape.paths || [];
    var scale = this.getGlobalScale(); // Update path scale

    for (var i = 0; i < paths.length; i++) {
      if (!paths[i].path) {
        paths[i].createPathProxy();
      }

      paths[i].path.setScale(scale[0], scale[1]);
    }
  },
  buildPath: function (ctx, shape) {
    var paths = shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].buildPath(ctx, paths[i].shape, true);
    }
  },
  afterBrush: function () {
    var paths = this.shape.paths || [];

    for (var i = 0; i < paths.length; i++) {
      paths[i].__dirtyPath = false;
    }
  },
  getBoundingRect: function () {
    this._updatePathDirty();

    return Path.prototype.getBoundingRect.call(this);
  }
});

module.exports = _default;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Gradient = __webpack_require__(399);

/**
 * x, y, x2, y2 are all percent from 0 to 1
 * @param {number} [x=0]
 * @param {number} [y=0]
 * @param {number} [x2=1]
 * @param {number} [y2=0]
 * @param {Array.<Object>} colorStops
 * @param {boolean} [globalCoord=false]
 */
var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'linear', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0 : x;
  this.y = y == null ? 0 : y;
  this.x2 = x2 == null ? 1 : x2;
  this.y2 = y2 == null ? 0 : y2; // Can be cloned

  this.type = 'linear'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

LinearGradient.prototype = {
  constructor: LinearGradient
};
zrUtil.inherits(LinearGradient, Gradient);
var _default = LinearGradient;
module.exports = _default;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

var zrUtil = __webpack_require__(6);

var Gradient = __webpack_require__(399);

/**
 * x, y, r are all percent from 0 to 1
 * @param {number} [x=0.5]
 * @param {number} [y=0.5]
 * @param {number} [r=0.5]
 * @param {Array.<Object>} [colorStops]
 * @param {boolean} [globalCoord=false]
 */
var RadialGradient = function (x, y, r, colorStops, globalCoord) {
  // Should do nothing more in this constructor. Because gradient can be
  // declard by `color: {type: 'radial', colorStops: ...}`, where
  // this constructor will not be called.
  this.x = x == null ? 0.5 : x;
  this.y = y == null ? 0.5 : y;
  this.r = r == null ? 0.5 : r; // Can be cloned

  this.type = 'radial'; // If use global coord

  this.global = globalCoord || false;
  Gradient.call(this, colorStops);
};

RadialGradient.prototype = {
  constructor: RadialGradient
};
zrUtil.inherits(RadialGradient, Gradient);
var _default = RadialGradient;
module.exports = _default;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(53);

var v2Min = _vector.min;
var v2Max = _vector.max;
var v2Scale = _vector.scale;
var v2Distance = _vector.distance;
var v2Add = _vector.add;
var v2Clone = _vector.clone;
var v2Sub = _vector.sub;

/**
 * 贝塞尔平滑曲线
 * @module zrender/shape/util/smoothBezier
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * 贝塞尔平滑曲线
 * @alias module:zrender/shape/util/smoothBezier
 * @param {Array} points 线段顶点数组
 * @param {number} smooth 平滑等级, 0-1
 * @param {boolean} isLoop
 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
 *                           整个折线的包围盒做一个并集用来约束控制点。
 * @param {Array} 计算出来的控制点数组
 */
function _default(points, smooth, isLoop, constraint) {
  var cps = [];
  var v = [];
  var v1 = [];
  var v2 = [];
  var prevPoint;
  var nextPoint;
  var min, max;

  if (constraint) {
    min = [Infinity, Infinity];
    max = [-Infinity, -Infinity];

    for (var i = 0, len = points.length; i < len; i++) {
      v2Min(min, min, points[i]);
      v2Max(max, max, points[i]);
    } // 与指定的包围盒做并集


    v2Min(min, min, constraint[0]);
    v2Max(max, max, constraint[1]);
  }

  for (var i = 0, len = points.length; i < len; i++) {
    var point = points[i];

    if (isLoop) {
      prevPoint = points[i ? i - 1 : len - 1];
      nextPoint = points[(i + 1) % len];
    } else {
      if (i === 0 || i === len - 1) {
        cps.push(v2Clone(points[i]));
        continue;
      } else {
        prevPoint = points[i - 1];
        nextPoint = points[i + 1];
      }
    }

    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length

    v2Scale(v, v, smooth);
    var d0 = v2Distance(point, prevPoint);
    var d1 = v2Distance(point, nextPoint);
    var sum = d0 + d1;

    if (sum !== 0) {
      d0 /= sum;
      d1 /= sum;
    }

    v2Scale(v1, v, -d0);
    v2Scale(v2, v, d1);
    var cp0 = v2Add([], point, v1);
    var cp1 = v2Add([], point, v2);

    if (constraint) {
      v2Max(cp0, cp0, min);
      v2Min(cp0, cp0, max);
      v2Max(cp1, cp1, min);
      v2Min(cp1, cp1, max);
    }

    cps.push(cp0);
    cps.push(cp1);
  }

  if (isLoop) {
    cps.push(cps.shift());
  }

  return cps;
}

module.exports = _default;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

var _vector = __webpack_require__(53);

var v2Distance = _vector.distance;

/**
 * Catmull-Rom spline 插值折线
 * @module zrender/shape/util/smoothSpline
 * @author pissang (https://www.github.com/pissang)
 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
 *         errorrik (errorrik@gmail.com)
 */

/**
 * @inner
 */
function interpolate(p0, p1, p2, p3, t, t2, t3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
/**
 * @alias module:zrender/shape/util/smoothSpline
 * @param {Array} points 线段顶点数组
 * @param {boolean} isLoop
 * @return {Array}
 */


function _default(points, isLoop) {
  var len = points.length;
  var ret = [];
  var distance = 0;

  for (var i = 1; i < len; i++) {
    distance += v2Distance(points[i - 1], points[i]);
  }

  var segs = distance / 2;
  segs = segs < len ? len : segs;

  for (var i = 0; i < segs; i++) {
    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
    var idx = Math.floor(pos);
    var w = pos - idx;
    var p0;
    var p1 = points[idx % len];
    var p2;
    var p3;

    if (!isLoop) {
      p0 = points[idx === 0 ? idx : idx - 1];
      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
    } else {
      p0 = points[(idx - 1 + len) % len];
      p2 = points[(idx + 1) % len];
      p3 = points[(idx + 2) % len];
    }

    var w2 = w * w;
    var w3 = w * w2;
    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
  }

  return ret;
}

module.exports = _default;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

var textHelper = __webpack_require__(401);

var BoundingRect = __webpack_require__(63);

/**
 * Mixin for drawing text in a element bounding rect
 * @module zrender/mixin/RectText
 */
var tmpRect = new BoundingRect();

var RectText = function () {};

RectText.prototype = {
  constructor: RectText,

  /**
   * Draw text in a rect with specified position.
   * @param  {CanvasRenderingContext2D} ctx
   * @param  {Object} rect Displayable rect
   */
  drawRectText: function (ctx, rect) {
    var style = this.style;
    rect = style.textRect || rect; // Optimize, avoid normalize every time.

    this.__dirty && textHelper.normalizeTextStyle(style, true);
    var text = style.text; // Convert to string

    text != null && (text += '');

    if (!textHelper.needDrawText(text, style)) {
      return;
    } // FIXME


    ctx.save(); // Transform rect to view space

    var transform = this.transform;

    if (!style.transformText) {
      if (transform) {
        tmpRect.copy(rect);
        tmpRect.applyTransform(transform);
        rect = tmpRect;
      }
    } else {
      this.setTransform(ctx);
    } // transformText and textRotation can not be used at the same time.


    textHelper.renderText(this, ctx, text, style, rect);
    ctx.restore();
  }
};
var _default = RectText;
module.exports = _default;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

/**
 * 圆弧
 * @module zrender/graphic/shape/Arc
 */
var _default = Path.extend({
  type: 'arc',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
  }
});

module.exports = _default;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var vec2 = __webpack_require__(53);

var _curve = __webpack_require__(154);

var quadraticSubdivide = _curve.quadraticSubdivide;
var cubicSubdivide = _curve.cubicSubdivide;
var quadraticAt = _curve.quadraticAt;
var cubicAt = _curve.cubicAt;
var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
var cubicDerivativeAt = _curve.cubicDerivativeAt;

/**
 * 贝塞尔曲线
 * @module zrender/shape/BezierCurve
 */
var out = [];

function someVectorAt(shape, t, isTangent) {
  var cpx2 = shape.cpx2;
  var cpy2 = shape.cpy2;

  if (cpx2 === null || cpy2 === null) {
    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
  } else {
    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
  }
}

var _default = Path.extend({
  type: 'bezier-curve',
  shape: {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cpx1: 0,
    cpy1: 0,
    // cpx2: 0,
    // cpy2: 0
    // Curve show percent, for animating
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1 = shape.x1;
    var y1 = shape.y1;
    var x2 = shape.x2;
    var y2 = shape.y2;
    var cpx1 = shape.cpx1;
    var cpy1 = shape.cpy1;
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (cpx2 == null || cpy2 == null) {
      if (percent < 1) {
        quadraticSubdivide(x1, cpx1, x2, percent, out);
        cpx1 = out[1];
        x2 = out[2];
        quadraticSubdivide(y1, cpy1, y2, percent, out);
        cpy1 = out[1];
        y2 = out[2];
      }

      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
    } else {
      if (percent < 1) {
        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
        cpx1 = out[1];
        cpx2 = out[2];
        x2 = out[3];
        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
        cpy1 = out[1];
        cpy2 = out[2];
        y2 = out[3];
      }

      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
    }
  },

  /**
   * Get point at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  pointAt: function (t) {
    return someVectorAt(this.shape, t, false);
  },

  /**
   * Get tangent at percent
   * @param  {number} t
   * @return {Array.<number>}
   */
  tangentAt: function (t) {
    var p = someVectorAt(this.shape, t, true);
    return vec2.normalize(p, p);
  }
});

module.exports = _default;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

/**
 * 圆形
 * @module zrender/shape/Circle
 */
var _default = Path.extend({
  type: 'circle',
  shape: {
    cx: 0,
    cy: 0,
    r: 0
  },
  buildPath: function (ctx, shape, inBundle) {
    // Better stroking in ShapeBundle
    // Always do it may have performence issue ( fill may be 2x more cost)
    if (inBundle) {
      ctx.moveTo(shape.cx + shape.r, shape.cy);
    } // else {
    //     if (ctx.allocate && !ctx.data.length) {
    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
    //     }
    // }
    // Better stroking in ShapeBundle
    // ctx.moveTo(shape.cx + shape.r, shape.cy);


    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
  }
});

module.exports = _default;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

/**
 * 直线
 * @module zrender/graphic/shape/Line
 */
var _default = Path.extend({
  type: 'line',
  shape: {
    // Start point
    x1: 0,
    y1: 0,
    // End point
    x2: 0,
    y2: 0,
    percent: 1
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    var x1 = shape.x1;
    var y1 = shape.y1;
    var x2 = shape.x2;
    var y2 = shape.y2;
    var percent = shape.percent;

    if (percent === 0) {
      return;
    }

    ctx.moveTo(x1, y1);

    if (percent < 1) {
      x2 = x1 * (1 - percent) + x2 * percent;
      y2 = y1 * (1 - percent) + y2 * percent;
    }

    ctx.lineTo(x2, y2);
  },

  /**
   * Get point at percent
   * @param  {number} percent
   * @return {Array.<number>}
   */
  pointAt: function (p) {
    var shape = this.shape;
    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
  }
});

module.exports = _default;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var polyHelper = __webpack_require__(715);

/**
 * 多边形
 * @module zrender/shape/Polygon
 */
var _default = Path.extend({
  type: 'polygon',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, true);
  }
});

module.exports = _default;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var polyHelper = __webpack_require__(715);

/**
 * @module zrender/graphic/shape/Polyline
 */
var _default = Path.extend({
  type: 'polyline',
  shape: {
    points: null,
    smooth: false,
    smoothConstraint: null
  },
  style: {
    stroke: '#000',
    fill: null
  },
  buildPath: function (ctx, shape) {
    polyHelper.buildPath(ctx, shape, false);
  }
});

module.exports = _default;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var roundRectHelper = __webpack_require__(716);

/**
 * 矩形
 * @module zrender/graphic/shape/Rect
 */
var _default = Path.extend({
  type: 'rect',
  shape: {
    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
    // r缩写为1         相当于 [1, 1, 1, 1]
    // r缩写为[1]       相当于 [1, 1, 1, 1]
    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
    r: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;

    if (!shape.r) {
      ctx.rect(x, y, width, height);
    } else {
      roundRectHelper.buildPath(ctx, shape);
    }

    ctx.closePath();
    return;
  }
});

module.exports = _default;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

/**
 * 圆环
 * @module zrender/graphic/shape/Ring
 */
var _default = Path.extend({
  type: 'ring',
  shape: {
    cx: 0,
    cy: 0,
    r: 0,
    r0: 0
  },
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var PI2 = Math.PI * 2;
    ctx.moveTo(x + shape.r, y);
    ctx.arc(x, y, shape.r, 0, PI2, false);
    ctx.moveTo(x + shape.r0, y);
    ctx.arc(x, y, shape.r0, 0, PI2, true);
  }
});

module.exports = _default;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var fixClipWithShadow = __webpack_require__(714);

/**
 * 扇形
 * @module zrender/graphic/shape/Sector
 */
var _default = Path.extend({
  type: 'sector',
  shape: {
    cx: 0,
    cy: 0,
    r0: 0,
    r: 0,
    startAngle: 0,
    endAngle: Math.PI * 2,
    clockwise: true
  },
  brush: fixClipWithShadow(Path.prototype.brush),
  buildPath: function (ctx, shape) {
    var x = shape.cx;
    var y = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var unitX = Math.cos(startAngle);
    var unitY = Math.sin(startAngle);
    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
    ctx.lineTo(unitX * r + x, unitY * r + y);
    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);

    if (r0 !== 0) {
      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
    }

    ctx.closePath();
  }
});

module.exports = _default;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

var Animator = __webpack_require__(705);

var log = __webpack_require__(262);

var _util = __webpack_require__(6);

var isString = _util.isString;
var isFunction = _util.isFunction;
var isObject = _util.isObject;
var isArrayLike = _util.isArrayLike;
var indexOf = _util.indexOf;

/**
 * @alias modue:zrender/mixin/Animatable
 * @constructor
 */
var Animatable = function () {
  /**
   * @type {Array.<module:zrender/animation/Animator>}
   * @readOnly
   */
  this.animators = [];
};

Animatable.prototype = {
  constructor: Animatable,

  /**
   * 动画
   *
   * @param {string} path The path to fetch value from object, like 'a.b.c'.
   * @param {boolean} [loop] Whether to loop animation.
   * @return {module:zrender/animation/Animator}
   * @example:
   *     el.animate('style', false)
   *         .when(1000, {x: 10} )
   *         .done(function(){ // Animation done })
   *         .start()
   */
  animate: function (path, loop) {
    var target;
    var animatingShape = false;
    var el = this;
    var zr = this.__zr;

    if (path) {
      var pathSplitted = path.split('.');
      var prop = el; // If animating shape

      animatingShape = pathSplitted[0] === 'shape';

      for (var i = 0, l = pathSplitted.length; i < l; i++) {
        if (!prop) {
          continue;
        }

        prop = prop[pathSplitted[i]];
      }

      if (prop) {
        target = prop;
      }
    } else {
      target = el;
    }

    if (!target) {
      log('Property "' + path + '" is not existed in element ' + el.id);
      return;
    }

    var animators = el.animators;
    var animator = new Animator(target, loop);
    animator.during(function (target) {
      el.dirty(animatingShape);
    }).done(function () {
      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
      animators.splice(indexOf(animators, animator), 1);
    });
    animators.push(animator); // If animate after added to the zrender

    if (zr) {
      zr.animation.addAnimator(animator);
    }

    return animator;
  },

  /**
   * 停止动画
   * @param {boolean} forwardToLast If move to last frame before stop
   */
  stopAnimation: function (forwardToLast) {
    var animators = this.animators;
    var len = animators.length;

    for (var i = 0; i < len; i++) {
      animators[i].stop(forwardToLast);
    }

    animators.length = 0;
    return this;
  },

  /**
   * Caution: this method will stop previous animation.
   * So do not use this method to one element twice before
   * animation starts, unless you know what you are doing.
   * @param {Object} target
   * @param {number} [time=500] Time in ms
   * @param {string} [easing='linear']
   * @param {number} [delay=0]
   * @param {Function} [callback]
   * @param {Function} [forceAnimate] Prevent stop animation and callback
   *        immediently when target values are the same as current values.
   *
   * @example
   *  // Animate position
   *  el.animateTo({
   *      position: [10, 10]
   *  }, function () { // done })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
   *  el.animateTo({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100, 'cubicOut', function () { // done })
   */
  // TODO Return animation key
  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
    // animateTo(target, time, easing, callback);
    if (isString(delay)) {
      callback = easing;
      easing = delay;
      delay = 0;
    } // animateTo(target, time, delay, callback);
    else if (isFunction(easing)) {
        callback = easing;
        easing = 'linear';
        delay = 0;
      } // animateTo(target, time, callback);
      else if (isFunction(delay)) {
          callback = delay;
          delay = 0;
        } // animateTo(target, callback)
        else if (isFunction(time)) {
            callback = time;
            time = 500;
          } // animateTo(target)
          else if (!time) {
              time = 500;
            } // Stop all previous animations


    this.stopAnimation();

    this._animateToShallow('', this, target, time, delay); // Animators may be removed immediately after start
    // if there is nothing to animate


    var animators = this.animators.slice();
    var count = animators.length;

    function done() {
      count--;

      if (!count) {
        callback && callback();
      }
    } // No animators. This should be checked before animators[i].start(),
    // because 'done' may be executed immediately if no need to animate.


    if (!count) {
      callback && callback();
    } // Start after all animators created
    // Incase any animator is done immediately when all animation properties are not changed


    for (var i = 0; i < animators.length; i++) {
      animators[i].done(done).start(easing, forceAnimate);
    }
  },

  /**
   * @private
   * @param {string} path=''
   * @param {Object} source=this
   * @param {Object} target
   * @param {number} [time=500]
   * @param {number} [delay=0]
   *
   * @example
   *  // Animate position
   *  el._animateToShallow({
   *      position: [10, 10]
   *  })
   *
   *  // Animate shape, style and position in 100ms, delayed 100ms
   *  el._animateToShallow({
   *      shape: {
   *          width: 500
   *      },
   *      style: {
   *          fill: 'red'
   *      }
   *      position: [10, 10]
   *  }, 100, 100)
   */
  _animateToShallow: function (path, source, target, time, delay) {
    var objShallow = {};
    var propertyCount = 0;

    for (var name in target) {
      if (!target.hasOwnProperty(name)) {
        continue;
      }

      if (source[name] != null) {
        if (isObject(target[name]) && !isArrayLike(target[name])) {
          this._animateToShallow(path ? path + '.' + name : name, source[name], target[name], time, delay);
        } else {
          objShallow[name] = target[name];
          propertyCount++;
        }
      } else if (target[name] != null) {
        // Attr directly if not has property
        // FIXME, if some property not needed for element ?
        if (!path) {
          this.attr(name, target[name]);
        } else {
          // Shape or style
          var props = {};
          props[path] = {};
          props[path][name] = target[name];
          this.attr(props);
        }
      }
    }

    if (propertyCount > 0) {
      this.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
    }

    return this;
  }
};
var _default = Animatable;
module.exports = _default;

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

// TODO Draggable for group
// FIXME Draggable on element which has parent rotation or scale
function Draggable() {
  this.on('mousedown', this._dragStart, this);
  this.on('mousemove', this._drag, this);
  this.on('mouseup', this._dragEnd, this);
  this.on('globalout', this._dragEnd, this); // this._dropTarget = null;
  // this._draggingTarget = null;
  // this._x = 0;
  // this._y = 0;
}

Draggable.prototype = {
  constructor: Draggable,
  _dragStart: function (e) {
    var draggingTarget = e.target;

    if (draggingTarget && draggingTarget.draggable) {
      this._draggingTarget = draggingTarget;
      draggingTarget.dragging = true;
      this._x = e.offsetX;
      this._y = e.offsetY;
      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
    }
  },
  _drag: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      var x = e.offsetX;
      var y = e.offsetY;
      var dx = x - this._x;
      var dy = y - this._y;
      this._x = x;
      this._y = y;
      draggingTarget.drift(dx, dy, e);
      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
      var dropTarget = this.findHover(x, y, draggingTarget).target;
      var lastDropTarget = this._dropTarget;
      this._dropTarget = dropTarget;

      if (draggingTarget !== dropTarget) {
        if (lastDropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
        }

        if (dropTarget && dropTarget !== lastDropTarget) {
          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
        }
      }
    }
  },
  _dragEnd: function (e) {
    var draggingTarget = this._draggingTarget;

    if (draggingTarget) {
      draggingTarget.dragging = false;
    }

    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);

    if (this._dropTarget) {
      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
    }

    this._draggingTarget = null;
    this._dropTarget = null;
  }
};

function param(target, e) {
  return {
    target: target,
    topTarget: e && e.topTarget
  };
}

var _default = Draggable;
module.exports = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

var _core = __webpack_require__(402);

var createElement = _core.createElement;

var util = __webpack_require__(6);

var each = util.each;

var zrLog = __webpack_require__(262);

var Path = __webpack_require__(54);

var ZImage = __webpack_require__(263);

var ZText = __webpack_require__(264);

var arrayDiff = __webpack_require__(1924);

var GradientManager = __webpack_require__(1945);

var ClippathManager = __webpack_require__(1944);

var _graphic = __webpack_require__(403);

var svgPath = _graphic.path;
var svgImage = _graphic.image;
var svgText = _graphic.text;

/**
 * SVG Painter
 * @module zrender/svg/Painter
 */
function parseInt10(val) {
  return parseInt(val, 10);
}

function getSvgProxy(el) {
  if (el instanceof Path) {
    return svgPath;
  } else if (el instanceof ZImage) {
    return svgImage;
  } else if (el instanceof ZText) {
    return svgText;
  } else {
    return svgPath;
  }
}

function checkParentAvailable(parent, child) {
  return child && parent && child.parentNode !== parent;
}

function insertAfter(parent, child, prevSibling) {
  if (checkParentAvailable(parent, child) && prevSibling) {
    var nextSibling = prevSibling.nextSibling;
    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
  }
}

function prepend(parent, child) {
  if (checkParentAvailable(parent, child)) {
    var firstChild = parent.firstChild;
    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
  }
}

function append(parent, child) {
  if (checkParentAvailable(parent, child)) {
    parent.appendChild(child);
  }
}

function remove(parent, child) {
  if (child && parent && child.parentNode === parent) {
    parent.removeChild(child);
  }
}

function getTextSvgElement(displayable) {
  return displayable.__textSvgEl;
}

function getSvgElement(displayable) {
  return displayable.__svgEl;
}
/**
 * @alias module:zrender/svg/Painter
 * @constructor
 * @param {HTMLElement} root 绘图容器
 * @param {module:zrender/Storage} storage
 * @param {Object} opts
 */


var SVGPainter = function (root, storage, opts) {
  this.root = root;
  this.storage = storage;
  this._opts = opts = util.extend({}, opts || {});
  var svgRoot = createElement('svg');
  svgRoot.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svgRoot.setAttribute('version', '1.1');
  svgRoot.setAttribute('baseProfile', 'full');
  svgRoot.style['user-select'] = 'none';
  svgRoot.style.cssText = 'position:absolute;left:0;top:0;';
  this.gradientManager = new GradientManager(svgRoot);
  this.clipPathManager = new ClippathManager(svgRoot);
  var viewport = document.createElement('div');
  viewport.style.cssText = 'overflow:hidden;position:relative';
  this._svgRoot = svgRoot;
  this._viewport = viewport;
  root.appendChild(viewport);
  viewport.appendChild(svgRoot);
  this.resize(opts.width, opts.height);
  this._visibleList = [];
};

SVGPainter.prototype = {
  constructor: SVGPainter,
  getType: function () {
    return 'svg';
  },
  getViewportRoot: function () {
    return this._viewport;
  },
  getViewportRootOffset: function () {
    var viewportRoot = this.getViewportRoot();

    if (viewportRoot) {
      return {
        offsetLeft: viewportRoot.offsetLeft || 0,
        offsetTop: viewportRoot.offsetTop || 0
      };
    }
  },
  refresh: function () {
    var list = this.storage.getDisplayList(true);

    this._paintList(list);
  },
  _paintList: function (list) {
    this.gradientManager.markAllUnused();
    this.clipPathManager.markAllUnused();
    var svgRoot = this._svgRoot;
    var visibleList = this._visibleList;
    var listLen = list.length;
    var newVisibleList = [];
    var i;

    for (i = 0; i < listLen; i++) {
      var displayable = list[i];
      var svgProxy = getSvgProxy(displayable);

      if (!displayable.invisible) {
        if (displayable.__dirty) {
          svgProxy && svgProxy.brush(displayable); // Update clipPath

          this.clipPathManager.update(displayable); // Update gradient

          if (displayable.style) {
            this.gradientManager.update(displayable.style.fill);
            this.gradientManager.update(displayable.style.stroke);
          }

          displayable.__dirty = false;
        }

        newVisibleList.push(displayable);
      }
    }

    var diff = arrayDiff(visibleList, newVisibleList);
    var prevSvgElement; // First do remove, in case element moved to the head and do remove
    // after add

    for (i = 0; i < diff.length; i++) {
      var item = diff[i];

      if (item.removed) {
        for (var k = 0; k < item.count; k++) {
          var displayable = visibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          remove(svgRoot, svgElement);
          remove(svgRoot, textSvgElement);
        }
      }
    }

    for (i = 0; i < diff.length; i++) {
      var item = diff[i];

      if (item.added) {
        for (var k = 0; k < item.count; k++) {
          var displayable = newVisibleList[item.indices[k]];
          var svgElement = getSvgElement(displayable);
          var textSvgElement = getTextSvgElement(displayable);
          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);

          if (svgElement) {
            insertAfter(svgRoot, textSvgElement, svgElement);
          } else if (prevSvgElement) {
            insertAfter(svgRoot, textSvgElement, prevSvgElement);
          } else {
            prepend(svgRoot, textSvgElement);
          } // Insert text


          insertAfter(svgRoot, textSvgElement, svgElement);
          prevSvgElement = textSvgElement || svgElement || prevSvgElement;
          this.gradientManager.addWithoutUpdate(svgElement, displayable);
          this.clipPathManager.markUsed(displayable);
        }
      } else if (!item.removed) {
        for (var k = 0; k < item.count; k++) {
          var displayable = newVisibleList[item.indices[k]];
          prevSvgElement = svgElement = getTextSvgElement(displayable) || getSvgElement(displayable) || prevSvgElement;
          this.gradientManager.markUsed(displayable);
          this.gradientManager.addWithoutUpdate(svgElement, displayable);
          this.clipPathManager.markUsed(displayable);
        }
      }
    }

    this.gradientManager.removeUnused();
    this.clipPathManager.removeUnused();
    this._visibleList = newVisibleList;
  },
  _getDefs: function (isForceCreating) {
    var svgRoot = this._svgRoot;

    var defs = this._svgRoot.getElementsByTagName('defs');

    if (defs.length === 0) {
      // Not exist
      if (isForceCreating) {
        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
        svgRoot.firstChild // Insert in the front of svg
        );

        if (!defs.contains) {
          // IE doesn't support contains method
          defs.contains = function (el) {
            var children = defs.children;

            if (!children) {
              return false;
            }

            for (var i = children.length - 1; i >= 0; --i) {
              if (children[i] === el) {
                return true;
              }
            }

            return false;
          };
        }

        return defs;
      } else {
        return null;
      }
    } else {
      return defs[0];
    }
  },
  resize: function (width, height) {
    var viewport = this._viewport; // FIXME Why ?

    viewport.style.display = 'none'; // Save input w/h

    var opts = this._opts;
    width != null && (opts.width = width);
    height != null && (opts.height = height);
    width = this._getSize(0);
    height = this._getSize(1);
    viewport.style.display = '';

    if (this._width !== width && this._height !== height) {
      this._width = width;
      this._height = height;
      var viewportStyle = viewport.style;
      viewportStyle.width = width + 'px';
      viewportStyle.height = height + 'px';
      var svgRoot = this._svgRoot; // Set width by 'svgRoot.width = width' is invalid

      svgRoot.setAttribute('width', width);
      svgRoot.setAttribute('height', height);
    }
  },

  /**
   * 获取绘图区域宽度
   */
  getWidth: function () {
    return this._width;
  },

  /**
   * 获取绘图区域高度
   */
  getHeight: function () {
    return this._height;
  },
  _getSize: function (whIdx) {
    var opts = this._opts;
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];

    if (opts[wh] != null && opts[wh] !== 'auto') {
      return parseFloat(opts[wh]);
    }

    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.

    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
  },
  dispose: function () {
    this.root.innerHTML = '';
    this._svgRoot = this._viewport = this.storage = null;
  },
  clear: function () {
    if (this._viewport) {
      this.root.removeChild(this._viewport);
    }
  },
  pathToSvg: function () {
    this.refresh();
    var html = this._svgRoot.outerHTML;
    return 'data:img/svg+xml;utf-8,' + unescape(html);
  }
}; // Not supported methods

function createMethodNotSupport(method) {
  return function () {
    zrLog('In SVG mode painter not support method "' + method + '"');
  };
} // Unsuppoted methods


each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
  SVGPainter.prototype[name] = createMethodNotSupport(name);
});
var _default = SVGPainter;
module.exports = _default;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(718);

var zrUtil = __webpack_require__(6);

var matrix = __webpack_require__(127);

/**
 * @file Manages SVG clipPath elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG clipPath elements.
 *
 * @class
 * @extends Definable
 * @param   {SVGElement} svgRoot root of SVG document
 */
function ClippathManager(svgRoot) {
  Definable.call(this, svgRoot, 'clipPath', '__clippath_in_use__');
}

zrUtil.inherits(ClippathManager, Definable);
/**
 * Update clipPath.
 *
 * @param {Displayable} displayable displayable element
 */

ClippathManager.prototype.update = function (displayable) {
  var svgEl = this.getSvgElement(displayable);

  if (svgEl) {
    this.updateDom(svgEl, displayable.__clipPaths, false);
  }

  var textEl = this.getTextSvgElement(displayable);

  if (textEl) {
    // Make another clipPath for text, since it's transform
    // matrix is not the same with svgElement
    this.updateDom(textEl, displayable.__clipPaths, true);
  }

  this.markUsed(displayable);
};
/**
 * Create an SVGElement of displayable and create a <clipPath> of its
 * clipPath
 *
 * @param {Displayable} parentEl  parent element
 * @param {ClipPath[]}  clipPaths clipPaths of parent element
 * @param {boolean}     isText    if parent element is Text
 */


ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
  if (clipPaths && clipPaths.length > 0) {
    // Has clipPath, create <clipPath> with the first clipPath
    var defs = this.getDefs(true);
    var clipPath = clipPaths[0];
    var clipPathEl;
    var id;
    var dom = isText ? '_textDom' : '_dom';

    if (clipPath[dom]) {
      // Use a dom that is already in <defs>
      id = clipPath[dom].getAttribute('id');
      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>

      if (!defs.contains(clipPathEl)) {
        // This happens when set old clipPath that has
        // been previously removed
        defs.appendChild(clipPathEl);
      }
    } else {
      // New <clipPath>
      id = 'zr-clip-' + this.nextId;
      ++this.nextId;
      clipPathEl = this.createElement('clipPath');
      clipPathEl.setAttribute('id', id);
      defs.appendChild(clipPathEl);
      clipPath[dom] = clipPathEl;
    } // Build path and add to <clipPath>


    var svgProxy = this.getSvgProxy(clipPath);

    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
      /**
       * If a clipPath has a parent with transform, the transform
       * of parent should not be considered when setting transform
       * of clipPath. So we need to transform back from parent's
       * transform, which is done by multiplying parent's inverse
       * transform.
       */
      // Store old transform
      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path

      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
      svgProxy.brush(clipPath); // Set back transform of clipPath

      clipPath.transform = transform;
    } else {
      svgProxy.brush(clipPath);
    }

    var pathEl = this.getSvgElement(clipPath);
    /**
     * Use `cloneNode()` here to appendChild to multiple parents,
     * which may happend when Text and other shapes are using the same
     * clipPath. Since Text will create an extra clipPath DOM due to
     * different transform rules.
     */

    clipPathEl.appendChild(pathEl.cloneNode());
    parentEl.setAttribute('clip-path', 'url(#' + id + ')');

    if (clipPaths.length > 1) {
      // Make the other clipPaths recursively
      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
    }
  } else {
    // No clipPath
    if (parentEl) {
      parentEl.setAttribute('clip-path', 'none');
    }
  }
};
/**
 * Mark a single clipPath to be used
 *
 * @param {Displayable} displayable displayable element
 */


ClippathManager.prototype.markUsed = function (displayable) {
  var that = this;

  if (displayable.__clipPaths && displayable.__clipPaths.length > 0) {
    zrUtil.each(displayable.__clipPaths, function (clipPath) {
      if (clipPath._dom) {
        Definable.prototype.markUsed.call(that, clipPath._dom);
      }

      if (clipPath._textDom) {
        Definable.prototype.markUsed.call(that, clipPath._textDom);
      }
    });
  }
};

var _default = ClippathManager;
module.exports = _default;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

var Definable = __webpack_require__(718);

var zrUtil = __webpack_require__(6);

var zrLog = __webpack_require__(262);

/**
 * @file Manages SVG gradient elements.
 * @author Zhang Wenli
 */

/**
 * Manages SVG gradient elements.
 *
 * @class
 * @extends Definable
 * @param   {SVGElement} svgRoot root of SVG document
 */
function GradientManager(svgRoot) {
  Definable.call(this, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
}

zrUtil.inherits(GradientManager, Definable);
/**
 * Create new gradient DOM for fill or stroke if not exist,
 * but will not update gradient if exists.
 *
 * @param {SvgElement}  svgElement   SVG element to paint
 * @param {Displayable} displayable  zrender displayable element
 */

GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
  if (displayable && displayable.style) {
    var that = this;
    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
        var gradient = displayable.style[fillOrStroke];
        var defs = that.getDefs(true); // Create dom in <defs> if not exists

        var dom;

        if (gradient._dom) {
          // Gradient exists
          dom = gradient._dom;

          if (!defs.contains(gradient._dom)) {
            // _dom is no longer in defs, recreate
            that.addDom(dom);
          }
        } else {
          // New dom
          dom = that.add(gradient);
        }

        that.markUsed(displayable);
        var id = dom.getAttribute('id');
        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
      }
    });
  }
};
/**
 * Add a new gradient tag in <defs>
 *
 * @param   {Gradient} gradient zr gradient instance
 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
 *                            created DOM
 */


GradientManager.prototype.add = function (gradient) {
  var dom;

  if (gradient.type === 'linear') {
    dom = this.createElement('linearGradient');
  } else if (gradient.type === 'radial') {
    dom = this.createElement('radialGradient');
  } else {
    zrLog('Illegal gradient type.');
    return null;
  } // Set dom id with gradient id, since each gradient instance
  // will have no more than one dom element.
  // id may exists before for those dirty elements, in which case
  // id should remain the same, and other attributes should be
  // updated.


  gradient.id = gradient.id || this.nextId++;
  dom.setAttribute('id', 'zr-gradient-' + gradient.id);
  this.updateDom(gradient, dom);
  this.addDom(dom);
  return dom;
};
/**
 * Update gradient.
 *
 * @param {Gradient} gradient zr gradient instance
 */


GradientManager.prototype.update = function (gradient) {
  var that = this;
  Definable.prototype.update.call(this, gradient, function () {
    var type = gradient.type;
    var tagName = gradient._dom.tagName;

    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
      // Gradient type is not changed, update gradient
      that.updateDom(gradient, gradient._dom);
    } else {
      // Remove and re-create if type is changed
      that.removeDom(gradient);
      that.add(gradient);
    }
  });
};
/**
 * Update gradient dom
 *
 * @param {Gradient} gradient zr gradient instance
 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
 *                            DOM to update
 */


GradientManager.prototype.updateDom = function (gradient, dom) {
  if (gradient.type === 'linear') {
    dom.setAttribute('x1', gradient.x);
    dom.setAttribute('y1', gradient.y);
    dom.setAttribute('x2', gradient.x2);
    dom.setAttribute('y2', gradient.y2);
  } else if (gradient.type === 'radial') {
    dom.setAttribute('cx', gradient.x);
    dom.setAttribute('cy', gradient.y);
    dom.setAttribute('r', gradient.r);
  } else {
    zrLog('Illegal gradient type.');
    return;
  }

  if (gradient.global) {
    // x1, x2, y1, y2 in range of 0 to canvas width or height
    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
  } else {
    // x1, x2, y1, y2 in range of 0 to 1
    dom.setAttribute('gradientUnits', 'objectBoundingBox');
  } // Remove color stops if exists


  dom.innerHTML = ''; // Add color stops

  var colors = gradient.colorStops;

  for (var i = 0, len = colors.length; i < len; ++i) {
    var stop = this.createElement('stop');
    stop.setAttribute('offset', colors[i].offset * 100 + '%');
    stop.setAttribute('stop-color', colors[i].color);
    dom.appendChild(stop);
  } // Store dom element in gradient, to avoid creating multiple
  // dom instances for the same gradient element


  gradient._dom = dom;
};
/**
 * Mark a single gradient to be used
 *
 * @param {Displayable} displayable displayable element
 */


GradientManager.prototype.markUsed = function (displayable) {
  if (displayable.style) {
    var gradient = displayable.style.fill;

    if (gradient && gradient._dom) {
      Definable.prototype.markUsed.call(this, gradient._dom);
    }

    gradient = displayable.style.stroke;

    if (gradient && gradient._dom) {
      Definable.prototype.markUsed.call(this, gradient._dom);
    }
  }
};

var _default = GradientManager;
module.exports = _default;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

var Path = __webpack_require__(54);

var PathProxy = __webpack_require__(192);

var transformPath = __webpack_require__(1947);

// command chars
var cc = ['m', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z', 'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'];
var mathSqrt = Math.sqrt;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI = Math.PI;

var vMag = function (v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};

var vRatio = function (u, v) {
  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
};

var vAngle = function (u, v) {
  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
};

function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
  var psi = psiDeg * (PI / 180.0);
  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);

  if (lambda > 1) {
    rx *= mathSqrt(lambda);
    ry *= mathSqrt(lambda);
  }

  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
  var cxp = f * rx * yp / ry;
  var cyp = f * -ry * xp / rx;
  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
  var dTheta = vAngle(u, v);

  if (vRatio(u, v) <= -1) {
    dTheta = PI;
  }

  if (vRatio(u, v) >= 1) {
    dTheta = 0;
  }

  if (fs === 0 && dTheta > 0) {
    dTheta = dTheta - 2 * PI;
  }

  if (fs === 1 && dTheta < 0) {
    dTheta = dTheta + 2 * PI;
  }

  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}

function createPathProxyFromString(data) {
  if (!data) {
    return [];
  } // command string


  var cs = data.replace(/-/g, ' -').replace(/  /g, ' ').replace(/ /g, ',').replace(/,,/g, ',');
  var n; // create pipes so that we can split the data

  for (n = 0; n < cc.length; n++) {
    cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
  } // create array


  var arr = cs.split('|'); // init context point

  var cpx = 0;
  var cpy = 0;
  var path = new PathProxy();
  var CMD = PathProxy.CMD;
  var prevCmd;

  for (n = 1; n < arr.length; n++) {
    var str = arr[n];
    var c = str.charAt(0);
    var off = 0;
    var p = str.slice(1).replace(/e,-/g, 'e-').split(',');
    var cmd;

    if (p.length > 0 && p[0] === '') {
      p.shift();
    }

    for (var i = 0; i < p.length; i++) {
      p[i] = parseFloat(p[i]);
    }

    while (off < p.length && !isNaN(p[off])) {
      if (isNaN(p[0])) {
        break;
      }

      var ctlPtx;
      var ctlPty;
      var rx;
      var ry;
      var psi;
      var fa;
      var fs;
      var x1 = cpx;
      var y1 = cpy; // convert l, H, h, V, and v to L

      switch (c) {
        case 'l':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'L':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'm':
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          c = 'l';
          break;

        case 'M':
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.M;
          path.addData(cmd, cpx, cpy);
          c = 'L';
          break;

        case 'h':
          cpx += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'H':
          cpx = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'v':
          cpy += p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'V':
          cpy = p[off++];
          cmd = CMD.L;
          path.addData(cmd, cpx, cpy);
          break;

        case 'C':
          cmd = CMD.C;
          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
          cpx = p[off - 2];
          cpy = p[off - 1];
          break;

        case 'c':
          cmd = CMD.C;
          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
          cpx += p[off - 2];
          cpy += p[off - 1];
          break;

        case 'S':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 's':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.C) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cmd = CMD.C;
          x1 = cpx + p[off++];
          y1 = cpy + p[off++];
          cpx += p[off++];
          cpy += p[off++];
          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
          break;

        case 'Q':
          x1 = p[off++];
          y1 = p[off++];
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'q':
          x1 = p[off++] + cpx;
          y1 = p[off++] + cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, x1, y1, cpx, cpy);
          break;

        case 'T':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 't':
          ctlPtx = cpx;
          ctlPty = cpy;
          var len = path.len();
          var pathData = path.data;

          if (prevCmd === CMD.Q) {
            ctlPtx += cpx - pathData[len - 4];
            ctlPty += cpy - pathData[len - 3];
          }

          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.Q;
          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
          break;

        case 'A':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx = p[off++];
          cpy = p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;

        case 'a':
          rx = p[off++];
          ry = p[off++];
          psi = p[off++];
          fa = p[off++];
          fs = p[off++];
          x1 = cpx, y1 = cpy;
          cpx += p[off++];
          cpy += p[off++];
          cmd = CMD.A;
          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
          break;
      }
    }

    if (c === 'z' || c === 'Z') {
      cmd = CMD.Z;
      path.addData(cmd);
    }

    prevCmd = cmd;
  }

  path.toStatic();
  return path;
} // TODO Optimize double memory cost problem


function createPathOptions(str, opts) {
  var pathProxy = createPathProxyFromString(str);
  opts = opts || {};

  opts.buildPath = function (path) {
    if (path.setData) {
      path.setData(pathProxy.data); // Svg and vml renderer don't have context

      var ctx = path.getContext();

      if (ctx) {
        path.rebuildPath(ctx);
      }
    } else {
      var ctx = path;
      pathProxy.rebuildPath(ctx);
    }
  };

  opts.applyTransform = function (m) {
    transformPath(pathProxy, m);
    this.dirty(true);
  };

  return opts;
}
/**
 * Create a Path object from path string data
 * http://www.w3.org/TR/SVG/paths.html#PathData
 * @param  {Object} opts Other options
 */


function createFromString(str, opts) {
  return new Path(createPathOptions(str, opts));
}
/**
 * Create a Path class from path string data
 * @param  {string} str
 * @param  {Object} opts Other options
 */


function extendFromString(str, opts) {
  return Path.extend(createPathOptions(str, opts));
}
/**
 * Merge multiple paths
 */
// TODO Apply transform
// TODO stroke dash
// TODO Optimize double memory cost problem


function mergePath(pathEls, opts) {
  var pathList = [];
  var len = pathEls.length;

  for (var i = 0; i < len; i++) {
    var pathEl = pathEls[i];

    if (!pathEl.path) {
      pathEl.createPathProxy();
    }

    if (pathEl.__dirtyPath) {
      pathEl.buildPath(pathEl.path, pathEl.shape, true);
    }

    pathList.push(pathEl.path);
  }

  var pathBundle = new Path(opts); // Need path proxy.

  pathBundle.createPathProxy();

  pathBundle.buildPath = function (path) {
    path.appendPath(pathList); // Svg and vml renderer don't have context

    var ctx = path.getContext();

    if (ctx) {
      path.rebuildPath(ctx);
    }
  };

  return pathBundle;
}

exports.createFromString = createFromString;
exports.extendFromString = extendFromString;
exports.mergePath = mergePath;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

var PathProxy = __webpack_require__(192);

var _vector = __webpack_require__(53);

var v2ApplyTransform = _vector.applyTransform;
var CMD = PathProxy.CMD;
var points = [[], [], []];
var mathSqrt = Math.sqrt;
var mathAtan2 = Math.atan2;

function _default(path, m) {
  var data = path.data;
  var cmd;
  var nPoint;
  var i;
  var j;
  var k;
  var p;
  var M = CMD.M;
  var C = CMD.C;
  var L = CMD.L;
  var R = CMD.R;
  var A = CMD.A;
  var Q = CMD.Q;

  for (i = 0, j = 0; i < data.length;) {
    cmd = data[i++];
    j = i;
    nPoint = 0;

    switch (cmd) {
      case M:
        nPoint = 1;
        break;

      case L:
        nPoint = 1;
        break;

      case C:
        nPoint = 3;
        break;

      case Q:
        nPoint = 2;
        break;

      case A:
        var x = m[4];
        var y = m[5];
        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx

        data[i] *= sx;
        data[i++] += x; // cy

        data[i] *= sy;
        data[i++] += y; // Scale rx and ry
        // FIXME Assume psi is 0 here

        data[i++] *= sx;
        data[i++] *= sy; // Start angle

        data[i++] += angle; // end angle

        data[i++] += angle; // FIXME psi

        i += 2;
        j = i;
        break;

      case R:
        // x0, y0
        p[0] = data[i++];
        p[1] = data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1]; // x1, y1

        p[0] += data[i++];
        p[1] += data[i++];
        v2ApplyTransform(p, p, m);
        data[j++] = p[0];
        data[j++] = p[1];
    }

    for (k = 0; k < nPoint; k++) {
      var p = points[k];
      p[0] = data[i++];
      p[1] = data[i++];
      v2ApplyTransform(p, p, m); // Write back

      data[j++] = p[0];
      data[j++] = p[1];
    }
  }
}

module.exports = _default;

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf__);
/*
 * Scroller
 * http://github.com/zynga/scroller
 *
 * Copyright 2011, Zynga Inc.
 * Licensed under the MIT License.
 * https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
 *
 * Based on the work of: Unify Project (unify-project.org)
 * http://unify-project.org
 * Copyright 2011, Deutsche Telekom AG
 * License: MIT + Apache (V2)
 */

/**
 * Generic animation class with support for dropped frames both optional easing and duration.
 *
 * Optional duration is useful when the lifetime is defined by another condition than time
 * e.g. speed of an animating object, etc.
 *
 * Dropped frame logic allows to keep using the same updater logic independent from the actual
 * rendering. This eases a lot of cases where it might be pretty complex to break down a state
 * based on the pure time difference.
 */


var desiredFrames = 60;
var millisecondsPerSecond = 1000;
var running = {};
var counter = 1;
var win = typeof window !== 'undefined' ? window : undefined;

if (!win) {
  win = typeof global !== 'undefined' ? global : {};
}

var Animate = {
  /**
   * Stops the given animation.
   *
   * @param id {Integer} Unique animation ID
   * @return {Boolean} Whether the animation was stopped (aka, was running before)
   */
  stop: function stop(id) {
    var cleared = running[id] != null;
    if (cleared) {
      running[id] = null;
    }

    return cleared;
  },

  /**
   * Whether the given animation is still running.
   *
   * @param id {Integer} Unique animation ID
   * @return {Boolean} Whether the animation is still running
   */
  isRunning: function isRunning(id) {
    return running[id] != null;
  },

  /**
   * Start the animation.
   *
   * @param stepCallback {Function} Pointer to function which is executed on every step.
   *   Signature of the method should be `function(percent, now, virtual) { return continueWithAnimation; }`
   * @param verifyCallback {Function} Executed before every animation step.
   *   Signature of the method should be `function() { return continueWithAnimation; }`
   * @param completedCallback {Function}
   *   Signature of the method should be `function(droppedFrames, finishedAnimation) {}`
   * @param duration {Integer} Milliseconds to run the animation
   * @param easingMethod {Function} Pointer to easing function
   *   Signature of the method should be `function(percent) { return modifiedValue; }`
   * @return {Integer} Identifier of animation. Can be used to stop it any time.
   */
  start: function start(stepCallback, verifyCallback, completedCallback, duration, easingMethod) {
    var start = +new Date();
    var lastFrame = start;
    var percent = 0;
    var dropCounter = 0;
    var id = counter++;

    // Compacting running db automatically every few new animations
    if (id % 20 === 0) {
      var newRunning = {};
      for (var usedId in running) {
        newRunning[usedId] = true;
      }
      running = newRunning;
    }

    // This is the internal step method which is called every few milliseconds
    var step = function step(virtual) {
      // Normalize virtual value
      var render = virtual !== true;

      // Get current time
      var now = +new Date();

      // Verification is executed before next animation step
      if (!running[id] || verifyCallback && !verifyCallback(id)) {

        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, false);
        return;
      }

      // For the current rendering to apply let's update omitted steps in memory.
      // This is important to bring internal state variables up-to-date with progress in time.
      if (render) {

        var droppedFrames = Math.round((now - lastFrame) / (millisecondsPerSecond / desiredFrames)) - 1;
        for (var j = 0; j < Math.min(droppedFrames, 4); j++) {
          step(true);
          dropCounter++;
        }
      }

      // Compute percent value
      if (duration) {
        percent = (now - start) / duration;
        if (percent > 1) {
          percent = 1;
        }
      }

      // Execute step callback, then...
      var value = easingMethod ? easingMethod(percent) : percent;
      if ((stepCallback(value, now, render) === false || percent === 1) && render) {
        running[id] = null;
        completedCallback && completedCallback(desiredFrames - dropCounter / ((now - start) / millisecondsPerSecond), id, percent === 1 || duration == null);
      } else if (render) {
        lastFrame = now;
        __WEBPACK_IMPORTED_MODULE_0_raf___default()(step);
      }
    };

    // Mark as running
    running[id] = true;

    // Init first step
    __WEBPACK_IMPORTED_MODULE_0_raf___default()(step);

    // Return unique animation ID
    return id;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scroller__ = __webpack_require__(1950);



var MIN_INDICATOR_SIZE = 8;

function setTransform(nodeStyle, value) {
  nodeStyle.transform = value;
  nodeStyle.webkitTransform = value;
  nodeStyle.MozTransform = value;
}

function setTransformOrigin(nodeStyle, value) {
  nodeStyle.transformOrigin = value;
  nodeStyle.webkitTransformOrigin = value;
  nodeStyle.MozTransformOrigin = value;
}

function DOMScroller(content) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var scrollbars = void 0;
  var indicators = void 0;
  var indicatorsSize = void 0;
  var scrollbarsSize = void 0;
  var indicatorsPos = void 0;
  var scrollbarsOpacity = void 0;
  var contentSize = void 0;
  var clientSize = void 0;

  this.content = content;
  this.container = content.parentNode;
  this.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
    scrollingComplete: function scrollingComplete() {
      _this.clearScrollbarTimer();
      _this.timer = setTimeout(function () {
        if (_this._destroyed) {
          return;
        }
        if (options.scrollingComplete) {
          options.scrollingComplete();
        }
        if (scrollbars) {
          ['x', 'y'].forEach(function (k) {
            if (scrollbars[k]) {
              _this.setScrollbarOpacity(k, 0);
            }
          });
        }
      }, 0);
    }
  });

  if (this.options.scrollbars) {
    scrollbars = this.scrollbars = {};
    indicators = this.indicators = {};
    indicatorsSize = this.indicatorsSize = {};
    scrollbarsSize = this.scrollbarsSize = {};
    indicatorsPos = this.indicatorsPos = {};
    scrollbarsOpacity = this.scrollbarsOpacity = {};
    contentSize = this.contentSize = {};
    clientSize = this.clientSize = {};

    ['x', 'y'].forEach(function (k) {
      var optionName = k === 'x' ? 'scrollingX' : 'scrollingY';
      if (_this.options[optionName] !== false) {
        scrollbars[k] = document.createElement('div');
        scrollbars[k].className = 'zscroller-scrollbar-' + k;
        indicators[k] = document.createElement('div');
        indicators[k].className = 'zscroller-indicator-' + k;
        scrollbars[k].appendChild(indicators[k]);
        indicatorsSize[k] = -1;
        scrollbarsOpacity[k] = 0;
        indicatorsPos[k] = 0;
        _this.container.appendChild(scrollbars[k]);
      }
    });
  }

  var init = true;
  var contentStyle = content.style;

  // create Scroller instance
  this.scroller = new __WEBPACK_IMPORTED_MODULE_1__Scroller__["a" /* default */](function (left, top, zoom) {
    if (!init && options.onScroll) {
      options.onScroll();
    }
    setTransform(contentStyle, 'translate3d(' + -left + 'px,' + -top + 'px,0) scale(' + zoom + ')');
    if (scrollbars) {
      ['x', 'y'].forEach(function (k) {
        if (scrollbars[k]) {
          var pos = k === 'x' ? left : top;
          if (clientSize[k] >= contentSize[k]) {
            _this.setScrollbarOpacity(k, 0);
          } else {
            if (!init) {
              _this.setScrollbarOpacity(k, 1);
            }
            var normalIndicatorSize = clientSize[k] / contentSize[k] * scrollbarsSize[k];
            var size = normalIndicatorSize;
            var indicatorPos = void 0;
            if (pos < 0) {
              size = Math.max(normalIndicatorSize + pos, MIN_INDICATOR_SIZE);
              indicatorPos = 0;
            } else if (pos > contentSize[k] - clientSize[k]) {
              size = Math.max(normalIndicatorSize + contentSize[k] - clientSize[k] - pos, MIN_INDICATOR_SIZE);
              indicatorPos = scrollbarsSize[k] - size;
            } else {
              indicatorPos = pos / contentSize[k] * scrollbarsSize[k];
            }
            _this.setIndicatorSize(k, size);
            _this.setIndicatorPos(k, indicatorPos);
          }
        }
      });
    }
    init = false;
  }, this.options);

  // bind events
  this.bindEvents();

  // the content element needs a correct transform origin for zooming
  setTransformOrigin(content.style, 'left top');

  // reflow for the first time
  this.reflow();
}

DOMScroller.prototype.setDisabled = function setDisabled(disabled) {
  this.disabled = disabled;
};

DOMScroller.prototype.clearScrollbarTimer = function clearScrollbarTimer() {
  if (this.timer) {
    clearTimeout(this.timer);
    this.timer = null;
  }
};

DOMScroller.prototype.setScrollbarOpacity = function setScrollbarOpacity(axis, opacity) {
  if (this.scrollbarsOpacity[axis] !== opacity) {
    this.scrollbars[axis].style.opacity = opacity;
    this.scrollbarsOpacity[axis] = opacity;
  }
};

DOMScroller.prototype.setIndicatorPos = function setIndicatorPos(axis, value) {
  if (this.indicatorsPos[axis] !== value) {
    if (axis === 'x') {
      setTransform(this.indicators[axis].style, 'translate3d(' + value + 'px,0,0)');
    } else {
      setTransform(this.indicators[axis].style, 'translate3d(0, ' + value + 'px,0)');
    }
    this.indicatorsPos[axis] = value;
  }
};

DOMScroller.prototype.setIndicatorSize = function setIndicatorSize(axis, value) {
  if (this.indicatorsSize[axis] !== value) {
    this.indicators[axis].style[axis === 'x' ? 'width' : 'height'] = value + 'px';
    this.indicatorsSize[axis] = value;
  }
};

DOMScroller.prototype.reflow = function reflow() {
  if (this.scrollbars) {
    this.contentSize.x = this.content.offsetWidth;
    this.contentSize.y = this.content.offsetHeight;
    this.clientSize.x = this.container.clientWidth;
    this.clientSize.y = this.container.clientHeight;
    if (this.scrollbars.x) {
      this.scrollbarsSize.x = this.scrollbars.x.offsetWidth;
    }
    if (this.scrollbars.y) {
      this.scrollbarsSize.y = this.scrollbars.y.offsetHeight;
    }
  }
  // set the right scroller dimensions
  this.scroller.setDimensions(this.container.clientWidth, this.container.clientHeight, this.content.offsetWidth, this.content.offsetHeight);

  // refresh the position for zooming purposes
  var rect = this.container.getBoundingClientRect();
  this.scroller.setPosition(rect.x + this.container.clientLeft, rect.y + this.container.clientTop);
};

DOMScroller.prototype.destroy = function destroy() {
  this._destroyed = true;
  window.removeEventListener('resize', this.onResize, false);
  this.container.removeEventListener('touchstart', this.onTouchStart, false);
  this.container.removeEventListener('touchmove', this.onTouchMove, false);
  this.container.removeEventListener('touchend', this.onTouchEnd, false);
  this.container.removeEventListener('touchcancel', this.onTouchCancel, false);
  this.container.removeEventListener('mousedown', this.onMouseDown, false);
  document.removeEventListener('mousemove', this.onMouseMove, false);
  document.removeEventListener('mouseup', this.onMouseUp, false);
  this.container.removeEventListener('mousewheel', this.onMouseWheel, false);
};

DOMScroller.prototype.bindEvents = function bindEvents() {
  var _this2 = this;

  var that = this;

  // reflow handling
  window.addEventListener('resize', this.onResize = function () {
    that.reflow();
  }, false);

  var lockMouse = false;
  var releaseLockTimer = void 0;

  this.container.addEventListener('touchstart', this.onTouchStart = function (e) {
    lockMouse = true;
    if (releaseLockTimer) {
      clearTimeout(releaseLockTimer);
      releaseLockTimer = null;
    }
    // Don't react if initial down happens on a form element
    if (e.touches[0] && e.touches[0].target && e.touches[0].target.tagName.match(/input|textarea|select/i) || _this2.disabled) {
      return;
    }
    _this2.clearScrollbarTimer();
    // reflow since the container may have changed
    that.reflow();
    that.scroller.doTouchStart(e.touches, e.timeStamp);
  }, false);

  this.container.addEventListener('touchmove', this.onTouchMove = function (e) {
    if (_this2.options.preventDefaultOnTouchMove !== false) {
      e.preventDefault();
    }
    that.scroller.doTouchMove(e.touches, e.timeStamp, e.scale);
  }, false);

  this.container.addEventListener('touchend', this.onTouchEnd = function (e) {
    that.scroller.doTouchEnd(e.timeStamp);
    releaseLockTimer = setTimeout(function () {
      lockMouse = false;
    }, 300);
  }, false);

  this.container.addEventListener('touchcancel', this.onTouchCancel = function (e) {
    that.scroller.doTouchEnd(e.timeStamp);
    releaseLockTimer = setTimeout(function () {
      lockMouse = false;
    }, 300);
  }, false);

  this.onMouseUp = function (e) {
    that.scroller.doTouchEnd(e.timeStamp);
    document.removeEventListener('mousemove', _this2.onMouseMove, false);
    document.removeEventListener('mouseup', _this2.onMouseUp, false);
  };

  this.onMouseMove = function (e) {
    that.scroller.doTouchMove([{
      pageX: e.pageX,
      pageY: e.pageY
    }], e.timeStamp);
  };

  this.container.addEventListener('mousedown', this.onMouseDown = function (e) {
    if (lockMouse || e.target.tagName.match(/input|textarea|select/i) || _this2.disabled) {
      return;
    }
    _this2.clearScrollbarTimer();
    that.scroller.doTouchStart([{
      pageX: e.pageX,
      pageY: e.pageY
    }], e.timeStamp);
    // reflow since the container may have changed
    that.reflow();
    e.preventDefault();
    document.addEventListener('mousemove', _this2.onMouseMove, false);
    document.addEventListener('mouseup', _this2.onMouseUp, false);
  }, false);

  this.container.addEventListener('mousewheel', this.onMouseWheel = function (e) {
    if (that.options.zooming) {
      that.scroller.doMouseZoom(e.wheelDelta, e.timeStamp, e.pageX, e.pageY);
      e.preventDefault();
    }
  }, false);
};

/* harmony default export */ __webpack_exports__["default"] = (DOMScroller);

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animate__ = __webpack_require__(1948);
/*
 * Scroller
 * http://github.com/zynga/scroller
 *
 * Copyright 2011, Zynga Inc.
 * Licensed under the MIT License.
 * https://raw.github.com/zynga/scroller/master/MIT-LICENSE.txt
 *
 * Based on the work of: Unify Project (unify-project.org)
 * http://unify-project.org
 * Copyright 2011, Deutsche Telekom AG
 * License: MIT + Apache (V2)
 */



var Scroller;

var NOOP = function NOOP() {};

/**
 * A pure logic 'component' for 'virtual' scrolling/zooming.
 */
Scroller = function Scroller(callback, options) {

  this.__callback = callback;

  this.options = {

    /** Enable scrolling on x-axis */
    scrollingX: true,

    /** Enable scrolling on y-axis */
    scrollingY: true,

    /** Enable animations for deceleration, snap back, zooming and scrolling */
    animating: true,

    /** duration for animations triggered by scrollTo/zoomTo */
    animationDuration: 250,

    /** Enable bouncing (content can be slowly moved outside and jumps back after releasing) */
    bouncing: true,

    /** Enable locking to the main axis if user moves only slightly on one of them at start */
    locking: true,

    /** Enable pagination mode (switching between full page content panes) */
    paging: false,

    /** Enable snapping of content to a configured pixel grid */
    snapping: false,

    /** Enable zooming of content via API, fingers and mouse wheel */
    zooming: false,

    /** Minimum zoom level */
    minZoom: 0.5,

    /** Maximum zoom level */
    maxZoom: 3,

    /** Multiply or decrease scrolling speed **/
    speedMultiplier: 1,

    /** Callback that is fired on the later of touch end or deceleration end,
     provided that another scrolling action has not begun. Used to know
     when to fade out a scrollbar. */
    scrollingComplete: NOOP,

    /** This configures the amount of change applied to deceleration when reaching boundaries  **/
    penetrationDeceleration: 0.03,

    /** This configures the amount of change applied to acceleration when reaching boundaries  **/
    penetrationAcceleration: 0.08

  };

  for (var key in options) {
    this.options[key] = options[key];
  }
};

// Easing Equations (c) 2003 Robert Penner, all rights reserved.
// Open source under the BSD License.

/**
 * @param pos {Number} position between 0 (start of effect) and 1 (end of effect)
 **/
var easeOutCubic = function easeOutCubic(pos) {
  return Math.pow(pos - 1, 3) + 1;
};

/**
 * @param pos {Number} position between 0 (start of effect) and 1 (end of effect)
 **/
var easeInOutCubic = function easeInOutCubic(pos) {
  if ((pos /= 0.5) < 1) {
    return 0.5 * Math.pow(pos, 3);
  }

  return 0.5 * (Math.pow(pos - 2, 3) + 2);
};

var members = {

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: STATUS
   ---------------------------------------------------------------------------
   */

  /** {Boolean} Whether only a single finger is used in touch handling */
  __isSingleTouch: false,

  /** {Boolean} Whether a touch event sequence is in progress */
  __isTracking: false,

  /** {Boolean} Whether a deceleration animation went to completion. */
  __didDecelerationComplete: false,

  /**
   * {Boolean} Whether a gesture zoom/rotate event is in progress. Activates when
   * a gesturestart event happens. This has higher priority than dragging.
   */
  __isGesturing: false,

  /**
   * {Boolean} Whether the user has moved by such a distance that we have enabled
   * dragging mode. Hint: It's only enabled after some pixels of movement to
   * not interrupt with clicks etc.
   */
  __isDragging: false,

  /**
   * {Boolean} Not touching and dragging anymore, and smoothly animating the
   * touch sequence using deceleration.
   */
  __isDecelerating: false,

  /**
   * {Boolean} Smoothly animating the currently configured change
   */
  __isAnimating: false,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: DIMENSIONS
   ---------------------------------------------------------------------------
   */

  /** {Integer} Available outer left position (from document perspective) */
  __clientLeft: 0,

  /** {Integer} Available outer top position (from document perspective) */
  __clientTop: 0,

  /** {Integer} Available outer width */
  __clientWidth: 0,

  /** {Integer} Available outer height */
  __clientHeight: 0,

  /** {Integer} Outer width of content */
  __contentWidth: 0,

  /** {Integer} Outer height of content */
  __contentHeight: 0,

  /** {Integer} Snapping width for content */
  __snapWidth: 100,

  /** {Integer} Snapping height for content */
  __snapHeight: 100,

  /** {Integer} Height to assign to refresh area */
  __refreshHeight: null,

  /** {Boolean} Whether the refresh process is enabled when the event is released now */
  __refreshActive: false,

  /** {Function} Callback to execute on activation. This is for signalling the user about a refresh is about to happen when he release */
  __refreshActivate: null,

  /** {Function} Callback to execute on deactivation. This is for signalling the user about the refresh being cancelled */
  __refreshDeactivate: null,

  /** {Function} Callback to execute to start the actual refresh. Call {@link #refreshFinish} when done */
  __refreshStart: null,

  /** {Number} Zoom level */
  __zoomLevel: 1,

  /** {Number} Scroll position on x-axis */
  __scrollLeft: 0,

  /** {Number} Scroll position on y-axis */
  __scrollTop: 0,

  /** {Integer} Maximum allowed scroll position on x-axis */
  __maxScrollLeft: 0,

  /** {Integer} Maximum allowed scroll position on y-axis */
  __maxScrollTop: 0,

  /* {Number} Scheduled left position (final position when animating) */
  __scheduledLeft: 0,

  /* {Number} Scheduled top position (final position when animating) */
  __scheduledTop: 0,

  /* {Number} Scheduled zoom level (final scale when animating) */
  __scheduledZoom: 0,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: LAST POSITIONS
   ---------------------------------------------------------------------------
   */

  /** {Number} Left position of finger at start */
  __lastTouchLeft: null,

  /** {Number} Top position of finger at start */
  __lastTouchTop: null,

  /** {Date} Timestamp of last move of finger. Used to limit tracking range for deceleration speed. */
  __lastTouchMove: null,

  /** {Array} List of positions, uses three indexes for each state: left, top, timestamp */
  __positions: null,

  /*
   ---------------------------------------------------------------------------
   INTERNAL FIELDS :: DECELERATION SUPPORT
   ---------------------------------------------------------------------------
   */

  /** {Integer} Minimum left scroll position during deceleration */
  __minDecelerationScrollLeft: null,

  /** {Integer} Minimum top scroll position during deceleration */
  __minDecelerationScrollTop: null,

  /** {Integer} Maximum left scroll position during deceleration */
  __maxDecelerationScrollLeft: null,

  /** {Integer} Maximum top scroll position during deceleration */
  __maxDecelerationScrollTop: null,

  /** {Number} Current factor to modify horizontal scroll position with on every step */
  __decelerationVelocityX: null,

  /** {Number} Current factor to modify vertical scroll position with on every step */
  __decelerationVelocityY: null,

  /*
   ---------------------------------------------------------------------------
   PUBLIC API
   ---------------------------------------------------------------------------
   */

  /**
   * Configures the dimensions of the client (outer) and content (inner) elements.
   * Requires the available space for the outer element and the outer size of the inner element.
   * All values which are falsy (null or zero etc.) are ignored and the old value is kept.
   *
   * @param clientWidth {Integer ? null} Inner width of outer element
   * @param clientHeight {Integer ? null} Inner height of outer element
   * @param contentWidth {Integer ? null} Outer width of inner element
   * @param contentHeight {Integer ? null} Outer height of inner element
   */
  setDimensions: function setDimensions(clientWidth, clientHeight, contentWidth, contentHeight) {

    var self = this;

    // Only update values which are defined
    if (clientWidth === +clientWidth) {
      self.__clientWidth = clientWidth;
    }

    if (clientHeight === +clientHeight) {
      self.__clientHeight = clientHeight;
    }

    if (contentWidth === +contentWidth) {
      self.__contentWidth = contentWidth;
    }

    if (contentHeight === +contentHeight) {
      self.__contentHeight = contentHeight;
    }

    // Refresh maximums
    self.__computeScrollMax();

    // Refresh scroll position
    self.scrollTo(self.__scrollLeft, self.__scrollTop, true);
  },

  /**
   * Sets the client coordinates in relation to the document.
   *
   * @param left {Integer ? 0} Left position of outer element
   * @param top {Integer ? 0} Top position of outer element
   */
  setPosition: function setPosition(left, top) {

    var self = this;

    self.__clientLeft = left || 0;
    self.__clientTop = top || 0;
  },

  /**
   * Configures the snapping (when snapping is active)
   *
   * @param width {Integer} Snapping width
   * @param height {Integer} Snapping height
   */
  setSnapSize: function setSnapSize(width, height) {

    var self = this;

    self.__snapWidth = width;
    self.__snapHeight = height;
  },

  /**
   * Activates pull-to-refresh. A special zone on the top of the list to start a list refresh whenever
   * the user event is released during visibility of this zone. This was introduced by some apps on iOS like
   * the official Twitter client.
   *
   * @param height {Integer} Height of pull-to-refresh zone on top of rendered list
   * @param activateCallback {Function} Callback to execute on activation. This is for signalling the user about a refresh is about to happen when he release.
   * @param deactivateCallback {Function} Callback to execute on deactivation. This is for signalling the user about the refresh being cancelled.
   * @param startCallback {Function} Callback to execute to start the real async refresh action. Call {@link #finishPullToRefresh} after finish of refresh.
   */
  activatePullToRefresh: function activatePullToRefresh(height, activateCallback, deactivateCallback, startCallback) {

    var self = this;

    self.__refreshHeight = height;
    self.__refreshActivate = activateCallback;
    self.__refreshDeactivate = deactivateCallback;
    self.__refreshStart = startCallback;
  },

  /**
   * Starts pull-to-refresh manually.
   */
  triggerPullToRefresh: function triggerPullToRefresh() {
    // Use publish instead of scrollTo to allow scrolling to out of boundary position
    // We don't need to normalize scrollLeft, zoomLevel, etc. here because we only y-scrolling when pull-to-refresh is enabled
    this.__publish(this.__scrollLeft, -this.__refreshHeight, this.__zoomLevel, true);

    if (this.__refreshStart) {
      this.__refreshStart();
    }
  },

  /**
   * Signalizes that pull-to-refresh is finished.
   */
  finishPullToRefresh: function finishPullToRefresh() {

    var self = this;

    self.__refreshActive = false;
    if (self.__refreshDeactivate) {
      self.__refreshDeactivate();
    }

    self.scrollTo(self.__scrollLeft, self.__scrollTop, true);
  },

  /**
   * Returns the scroll position and zooming values
   *
   * @return {Map} `left` and `top` scroll position and `zoom` level
   */
  getValues: function getValues() {

    var self = this;

    return {
      left: self.__scrollLeft,
      top: self.__scrollTop,
      zoom: self.__zoomLevel
    };
  },

  /**
   * Returns the maximum scroll values
   *
   * @return {Map} `left` and `top` maximum scroll values
   */
  getScrollMax: function getScrollMax() {

    var self = this;

    return {
      left: self.__maxScrollLeft,
      top: self.__maxScrollTop
    };
  },

  /**
   * Zooms to the given level. Supports optional animation. Zooms
   * the center when no coordinates are given.
   *
   * @param level {Number} Level to zoom to
   * @param animate {Boolean ? false} Whether to use animation
   * @param originLeft {Number ? null} Zoom in at given left coordinate
   * @param originTop {Number ? null} Zoom in at given top coordinate
   * @param callback {Function ? null} A callback that gets fired when the zoom is complete.
   */
  zoomTo: function zoomTo(level, animate, originLeft, originTop, callback) {

    var self = this;

    if (!self.options.zooming) {
      throw new Error("Zooming is not enabled!");
    }

    // Add callback if exists
    if (callback) {
      self.__zoomComplete = callback;
    }

    // Stop deceleration
    if (self.__isDecelerating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    var oldLevel = self.__zoomLevel;

    // Normalize input origin to center of viewport if not defined
    if (originLeft == null) {
      originLeft = self.__clientWidth / 2;
    }

    if (originTop == null) {
      originTop = self.__clientHeight / 2;
    }

    // Limit level according to configuration
    level = Math.max(Math.min(level, self.options.maxZoom), self.options.minZoom);

    // Recompute maximum values while temporary tweaking maximum scroll ranges
    self.__computeScrollMax(level);

    // Recompute left and top coordinates based on new zoom level
    var left = (originLeft + self.__scrollLeft) * level / oldLevel - originLeft;
    var top = (originTop + self.__scrollTop) * level / oldLevel - originTop;

    // Limit x-axis
    if (left > self.__maxScrollLeft) {
      left = self.__maxScrollLeft;
    } else if (left < 0) {
      left = 0;
    }

    // Limit y-axis
    if (top > self.__maxScrollTop) {
      top = self.__maxScrollTop;
    } else if (top < 0) {
      top = 0;
    }

    // Push values out
    self.__publish(left, top, level, animate);
  },

  /**
   * Zooms the content by the given factor.
   *
   * @param factor {Number} Zoom by given factor
   * @param animate {Boolean ? false} Whether to use animation
   * @param originLeft {Number ? 0} Zoom in at given left coordinate
   * @param originTop {Number ? 0} Zoom in at given top coordinate
   * @param callback {Function ? null} A callback that gets fired when the zoom is complete.
   */
  zoomBy: function zoomBy(factor, animate, originLeft, originTop, callback) {

    var self = this;

    self.zoomTo(self.__zoomLevel * factor, animate, originLeft, originTop, callback);
  },

  /**
   * Scrolls to the given position. Respect limitations and snapping automatically.
   *
   * @param left {Number?null} Horizontal scroll position, keeps current if value is <code>null</code>
   * @param top {Number?null} Vertical scroll position, keeps current if value is <code>null</code>
   * @param animate {Boolean?false} Whether the scrolling should happen using an animation
   * @param zoom {Number?null} Zoom level to go to
   */
  scrollTo: function scrollTo(left, top, animate, zoom, callback) {

    var self = this;

    // Stop deceleration
    if (self.__isDecelerating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
    }

    // Correct coordinates based on new zoom level
    if (zoom != null && zoom !== self.__zoomLevel) {

      if (!self.options.zooming) {
        throw new Error("Zooming is not enabled!");
      }

      left *= zoom;
      top *= zoom;

      // Recompute maximum values while temporary tweaking maximum scroll ranges
      self.__computeScrollMax(zoom);
    } else {

      // Keep zoom when not defined
      zoom = self.__zoomLevel;
    }

    if (!self.options.scrollingX) {

      left = self.__scrollLeft;
    } else {

      if (self.options.paging) {
        left = Math.round(left / self.__clientWidth) * self.__clientWidth;
      } else if (self.options.snapping) {
        left = Math.round(left / self.__snapWidth) * self.__snapWidth;
      }
    }

    if (!self.options.scrollingY) {

      top = self.__scrollTop;
    } else {

      if (self.options.paging) {
        top = Math.round(top / self.__clientHeight) * self.__clientHeight;
      } else if (self.options.snapping) {
        top = Math.round(top / self.__snapHeight) * self.__snapHeight;
      }
    }

    // Limit for allowed ranges
    left = Math.max(Math.min(self.__maxScrollLeft, left), 0);
    top = Math.max(Math.min(self.__maxScrollTop, top), 0);

    // Don't animate when no change detected, still call publish to make sure
    // that rendered position is really in-sync with internal data
    if (left === self.__scrollLeft && top === self.__scrollTop) {
      animate = false;
      if (callback) {
        callback();
      }
    }

    // Publish new values
    if (!self.__isTracking) {
      self.__publish(left, top, zoom, animate);
    }
  },

  /**
   * Scroll by the given offset
   *
   * @param left {Number ? 0} Scroll x-axis by given offset
   * @param top {Number ? 0} Scroll x-axis by given offset
   * @param animate {Boolean ? false} Whether to animate the given change
   */
  scrollBy: function scrollBy(left, top, animate) {

    var self = this;

    var startLeft = self.__isAnimating ? self.__scheduledLeft : self.__scrollLeft;
    var startTop = self.__isAnimating ? self.__scheduledTop : self.__scrollTop;

    self.scrollTo(startLeft + (left || 0), startTop + (top || 0), animate);
  },

  /*
   ---------------------------------------------------------------------------
   EVENT CALLBACKS
   ---------------------------------------------------------------------------
   */

  /**
   * Mouse wheel handler for zooming support
   */
  doMouseZoom: function doMouseZoom(wheelDelta, timeStamp, pageX, pageY) {

    var self = this;
    var change = wheelDelta > 0 ? 0.97 : 1.03;

    return self.zoomTo(self.__zoomLevel * change, false, pageX - self.__clientLeft, pageY - self.__clientTop);
  },

  /**
   * Touch start handler for scrolling support
   */
  doTouchStart: function doTouchStart(touches, timeStamp) {

    // Array-like check is enough here
    if (touches.length == null) {
      throw new Error("Invalid touch list: " + touches);
    }

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Reset interruptedAnimation flag
    self.__interruptedAnimation = true;

    // Stop deceleration
    if (self.__isDecelerating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isDecelerating);
      self.__isDecelerating = false;
      self.__interruptedAnimation = true;
    }

    // Stop animation
    if (self.__isAnimating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(self.__isAnimating);
      self.__isAnimating = false;
      self.__interruptedAnimation = true;
    }

    // Use center point when dealing with two fingers
    var currentTouchLeft, currentTouchTop;
    var isSingleTouch = touches.length === 1;
    if (isSingleTouch) {
      currentTouchLeft = touches[0].pageX;
      currentTouchTop = touches[0].pageY;
    } else {
      currentTouchLeft = Math.abs(touches[0].pageX + touches[1].pageX) / 2;
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    }

    // Store initial positions
    self.__initialTouchLeft = currentTouchLeft;
    self.__initialTouchTop = currentTouchTop;

    // Store current zoom level
    self.__zoomLevelStart = self.__zoomLevel;

    // Store initial touch positions
    self.__lastTouchLeft = currentTouchLeft;
    self.__lastTouchTop = currentTouchTop;

    // Store initial move time stamp
    self.__lastTouchMove = timeStamp;

    // Reset initial scale
    self.__lastScale = 1;

    // Reset locking flags
    self.__enableScrollX = !isSingleTouch && self.options.scrollingX;
    self.__enableScrollY = !isSingleTouch && self.options.scrollingY;

    // Reset tracking flag
    self.__isTracking = true;

    // Reset deceleration complete flag
    self.__didDecelerationComplete = false;

    // Dragging starts directly with two fingers, otherwise lazy with an offset
    self.__isDragging = !isSingleTouch;

    // Some features are disabled in multi touch scenarios
    self.__isSingleTouch = isSingleTouch;

    // Clearing data structure
    self.__positions = [];
  },

  /**
   * Touch move handler for scrolling support
   */
  doTouchMove: function doTouchMove(touches, timeStamp, scale) {

    // Array-like check is enough here
    if (touches.length == null) {
      throw new Error("Invalid touch list: " + touches);
    }

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Ignore event when tracking is not enabled (event might be outside of element)
    if (!self.__isTracking) {
      return;
    }

    var currentTouchLeft, currentTouchTop;

    // Compute move based around of center of fingers
    if (touches.length === 2) {
      currentTouchLeft = Math.abs(touches[0].pageX + touches[1].pageX) / 2;
      currentTouchTop = Math.abs(touches[0].pageY + touches[1].pageY) / 2;
    } else {
      currentTouchLeft = touches[0].pageX;
      currentTouchTop = touches[0].pageY;
    }

    var positions = self.__positions;

    // Are we already is dragging mode?
    if (self.__isDragging) {

      // Compute move distance
      var moveX = currentTouchLeft - self.__lastTouchLeft;
      var moveY = currentTouchTop - self.__lastTouchTop;

      // Read previous scroll position and zooming
      var scrollLeft = self.__scrollLeft;
      var scrollTop = self.__scrollTop;
      var level = self.__zoomLevel;

      // Work with scaling
      if (scale != null && self.options.zooming) {

        var oldLevel = level;

        // Recompute level based on previous scale and new scale
        level = level / self.__lastScale * scale;

        // Limit level according to configuration
        level = Math.max(Math.min(level, self.options.maxZoom), self.options.minZoom);

        // Only do further compution when change happened
        if (oldLevel !== level) {

          // Compute relative event position to container
          var currentTouchLeftRel = currentTouchLeft - self.__clientLeft;
          var currentTouchTopRel = currentTouchTop - self.__clientTop;

          // Recompute left and top coordinates based on new zoom level
          scrollLeft = (currentTouchLeftRel + scrollLeft) * level / oldLevel - currentTouchLeftRel;
          scrollTop = (currentTouchTopRel + scrollTop) * level / oldLevel - currentTouchTopRel;

          // Recompute max scroll values
          self.__computeScrollMax(level);
        }
      }

      if (self.__enableScrollX) {

        scrollLeft -= moveX * this.options.speedMultiplier;
        var maxScrollLeft = self.__maxScrollLeft;

        if (scrollLeft > maxScrollLeft || scrollLeft < 0) {

          // Slow down on the edges
          if (self.options.bouncing) {

            scrollLeft += moveX / 2 * this.options.speedMultiplier;
          } else if (scrollLeft > maxScrollLeft) {

            scrollLeft = maxScrollLeft;
          } else {

            scrollLeft = 0;
          }
        }
      }

      // Compute new vertical scroll position
      if (self.__enableScrollY) {

        scrollTop -= moveY * this.options.speedMultiplier;
        var maxScrollTop = self.__maxScrollTop;

        if (scrollTop > maxScrollTop || scrollTop < 0) {

          // Slow down on the edges
          if (self.options.bouncing) {

            scrollTop += moveY / 2 * this.options.speedMultiplier;

            // Support pull-to-refresh (only when only y is scrollable)
            if (!self.__enableScrollX && self.__refreshHeight != null) {

              if (!self.__refreshActive && scrollTop <= -self.__refreshHeight) {

                self.__refreshActive = true;
                if (self.__refreshActivate) {
                  self.__refreshActivate();
                }
              } else if (self.__refreshActive && scrollTop > -self.__refreshHeight) {

                self.__refreshActive = false;
                if (self.__refreshDeactivate) {
                  self.__refreshDeactivate();
                }
              }
            }
          } else if (scrollTop > maxScrollTop) {

            scrollTop = maxScrollTop;
          } else {

            scrollTop = 0;
          }
        }
      }

      // Keep list from growing infinitely (holding min 10, max 20 measure points)
      if (positions.length > 60) {
        positions.splice(0, 30);
      }

      // Track scroll movement for decleration
      positions.push(scrollLeft, scrollTop, timeStamp);

      // Sync scroll position
      self.__publish(scrollLeft, scrollTop, level);

      // Otherwise figure out whether we are switching into dragging mode now.
    } else {

      var minimumTrackingForScroll = 3;
      var minimumTrackingForDrag = 5;

      var distanceX = Math.abs(currentTouchLeft - self.__initialTouchLeft);
      var distanceY = Math.abs(currentTouchTop - self.__initialTouchTop);

      self.__enableScrollX = self.options.scrollingX && distanceX >= minimumTrackingForScroll;
      self.__enableScrollY = self.options.scrollingY && distanceY >= minimumTrackingForScroll;

      var radian = void 0;

      if (self.options.locking && self.__enableScrollY) {
        radian = radian || Math.atan2(distanceY, distanceX);
        if (radian < Math.PI / 4) {
          self.__enableScrollY = false;
        }
      }

      if (self.options.locking && self.__enableScrollX) {
        radian = radian || Math.atan2(distanceY, distanceX);
        if (radian > Math.PI / 4) {
          self.__enableScrollX = false;
        }
      }

      positions.push(self.__scrollLeft, self.__scrollTop, timeStamp);

      self.__isDragging = (self.__enableScrollX || self.__enableScrollY) && (distanceX >= minimumTrackingForDrag || distanceY >= minimumTrackingForDrag);
      if (self.__isDragging) {
        self.__interruptedAnimation = false;
      }
    }

    // Update last touch positions and time stamp for next event
    self.__lastTouchLeft = currentTouchLeft;
    self.__lastTouchTop = currentTouchTop;
    self.__lastTouchMove = timeStamp;
    self.__lastScale = scale;
  },

  /**
   * Touch end handler for scrolling support
   */
  doTouchEnd: function doTouchEnd(timeStamp) {

    if (timeStamp instanceof Date) {
      timeStamp = timeStamp.valueOf();
    }
    if (typeof timeStamp !== "number") {
      throw new Error("Invalid timestamp value: " + timeStamp);
    }

    var self = this;

    // Ignore event when tracking is not enabled (no touchstart event on element)
    // This is required as this listener ('touchmove') sits on the document and not on the element itself.
    if (!self.__isTracking) {
      return;
    }

    // Not touching anymore (when two finger hit the screen there are two touch end events)
    self.__isTracking = false;

    // Be sure to reset the dragging flag now. Here we also detect whether
    // the finger has moved fast enough to switch into a deceleration animation.
    if (self.__isDragging) {

      // Reset dragging flag
      self.__isDragging = false;

      // Start deceleration
      // Verify that the last move detected was in some relevant time frame
      if (self.__isSingleTouch && self.options.animating && timeStamp - self.__lastTouchMove <= 100) {

        // Then figure out what the scroll position was about 100ms ago
        var positions = self.__positions;
        var endPos = positions.length - 1;
        var startPos = endPos;

        // Move pointer to position measured 100ms ago
        for (var i = endPos; i > 0 && positions[i] > self.__lastTouchMove - 100; i -= 3) {
          startPos = i;
        }

        // If start and stop position is identical in a 100ms timeframe,
        // we cannot compute any useful deceleration.
        if (startPos !== endPos) {

          // Compute relative movement between these two points
          var timeOffset = positions[endPos] - positions[startPos];
          var movedLeft = self.__scrollLeft - positions[startPos - 2];
          var movedTop = self.__scrollTop - positions[startPos - 1];

          // Based on 50ms compute the movement to apply for each render step
          self.__decelerationVelocityX = movedLeft / timeOffset * (1000 / 60);
          self.__decelerationVelocityY = movedTop / timeOffset * (1000 / 60);

          // How much velocity is required to start the deceleration
          var minVelocityToStartDeceleration = self.options.paging || self.options.snapping ? 4 : 1;

          // Verify that we have enough velocity to start deceleration
          if (Math.abs(self.__decelerationVelocityX) > minVelocityToStartDeceleration || Math.abs(self.__decelerationVelocityY) > minVelocityToStartDeceleration) {

            // Deactivate pull-to-refresh when decelerating
            if (!self.__refreshActive) {
              self.__startDeceleration(timeStamp);
            }
          } else {
            self.options.scrollingComplete();
          }
        } else {
          self.options.scrollingComplete();
        }
      } else if (timeStamp - self.__lastTouchMove > 100) {
        self.options.scrollingComplete();
      }
    }

    // If this was a slower move it is per default non decelerated, but this
    // still means that we want snap back to the bounds which is done here.
    // This is placed outside the condition above to improve edge case stability
    // e.g. touchend fired without enabled dragging. This should normally do not
    // have modified the scroll positions or even showed the scrollbars though.
    if (!self.__isDecelerating) {

      if (self.__refreshActive && self.__refreshStart) {

        // Use publish instead of scrollTo to allow scrolling to out of boundary position
        // We don't need to normalize scrollLeft, zoomLevel, etc. here because we only y-scrolling when pull-to-refresh is enabled
        self.__publish(self.__scrollLeft, -self.__refreshHeight, self.__zoomLevel, true);

        if (self.__refreshStart) {
          self.__refreshStart();
        }
      } else {

        if (self.__interruptedAnimation || self.__isDragging) {
          self.options.scrollingComplete();
        }
        self.scrollTo(self.__scrollLeft, self.__scrollTop, true, self.__zoomLevel);

        // Directly signalize deactivation (nothing todo on refresh?)
        if (self.__refreshActive) {

          self.__refreshActive = false;
          if (self.__refreshDeactivate) {
            self.__refreshDeactivate();
          }
        }
      }
    }

    // Fully cleanup list
    self.__positions.length = 0;
  },

  /*
   ---------------------------------------------------------------------------
   PRIVATE API
   ---------------------------------------------------------------------------
   */

  /**
   * Applies the scroll position to the content element
   *
   * @param left {Number} Left scroll position
   * @param top {Number} Top scroll position
   * @param animate {Boolean?false} Whether animation should be used to move to the new coordinates
   */
  __publish: function __publish(left, top, zoom, animate) {

    var self = this;

    // Remember whether we had an animation, then we try to continue based on the current "drive" of the animation
    var wasAnimating = self.__isAnimating;
    if (wasAnimating) {
      __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].stop(wasAnimating);
      self.__isAnimating = false;
    }

    if (animate && self.options.animating) {

      // Keep scheduled positions for scrollBy/zoomBy functionality
      self.__scheduledLeft = left;
      self.__scheduledTop = top;
      self.__scheduledZoom = zoom;

      var oldLeft = self.__scrollLeft;
      var oldTop = self.__scrollTop;
      var oldZoom = self.__zoomLevel;

      var diffLeft = left - oldLeft;
      var diffTop = top - oldTop;
      var diffZoom = zoom - oldZoom;

      var step = function step(percent, now, render) {

        if (render) {

          self.__scrollLeft = oldLeft + diffLeft * percent;
          self.__scrollTop = oldTop + diffTop * percent;
          self.__zoomLevel = oldZoom + diffZoom * percent;

          // Push values out
          if (self.__callback) {
            self.__callback(self.__scrollLeft, self.__scrollTop, self.__zoomLevel);
          }
        }
      };

      var verify = function verify(id) {
        return self.__isAnimating === id;
      };

      var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
        if (animationId === self.__isAnimating) {
          self.__isAnimating = false;
        }

        if (self.__didDecelerationComplete || wasFinished) {
          self.options.scrollingComplete();
        }

        if (self.options.zooming) {
          self.__computeScrollMax();
          if (self.__zoomComplete) {
            self.__zoomComplete();
            self.__zoomComplete = null;
          }
        }
      };

      // When continuing based on previous animation we choose an ease-out animation instead of ease-in-out
      self.__isAnimating = __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].start(step, verify, completed, self.options.animationDuration, wasAnimating ? easeOutCubic : easeInOutCubic);
    } else {

      self.__scheduledLeft = self.__scrollLeft = left;
      self.__scheduledTop = self.__scrollTop = top;
      self.__scheduledZoom = self.__zoomLevel = zoom;

      // Push values out
      if (self.__callback) {
        self.__callback(left, top, zoom);
      }

      // Fix max scroll ranges
      if (self.options.zooming) {
        self.__computeScrollMax();
        if (self.__zoomComplete) {
          self.__zoomComplete();
          self.__zoomComplete = null;
        }
      }
    }
  },

  /**
   * Recomputes scroll minimum values based on client dimensions and content dimensions.
   */
  __computeScrollMax: function __computeScrollMax(zoomLevel) {

    var self = this;

    if (zoomLevel == null) {
      zoomLevel = self.__zoomLevel;
    }

    self.__maxScrollLeft = Math.max(self.__contentWidth * zoomLevel - self.__clientWidth, 0);
    self.__maxScrollTop = Math.max(self.__contentHeight * zoomLevel - self.__clientHeight, 0);
  },

  /*
   ---------------------------------------------------------------------------
   ANIMATION (DECELERATION) SUPPORT
   ---------------------------------------------------------------------------
   */

  /**
   * Called when a touch sequence end and the speed of the finger was high enough
   * to switch into deceleration mode.
   */
  __startDeceleration: function __startDeceleration(timeStamp) {

    var self = this;

    if (self.options.paging) {

      var scrollLeft = Math.max(Math.min(self.__scrollLeft, self.__maxScrollLeft), 0);
      var scrollTop = Math.max(Math.min(self.__scrollTop, self.__maxScrollTop), 0);
      var clientWidth = self.__clientWidth;
      var clientHeight = self.__clientHeight;

      // We limit deceleration not to the min/max values of the allowed range, but to the size of the visible client area.
      // Each page should have exactly the size of the client area.
      self.__minDecelerationScrollLeft = Math.floor(scrollLeft / clientWidth) * clientWidth;
      self.__minDecelerationScrollTop = Math.floor(scrollTop / clientHeight) * clientHeight;
      self.__maxDecelerationScrollLeft = Math.ceil(scrollLeft / clientWidth) * clientWidth;
      self.__maxDecelerationScrollTop = Math.ceil(scrollTop / clientHeight) * clientHeight;
    } else {

      self.__minDecelerationScrollLeft = 0;
      self.__minDecelerationScrollTop = 0;
      self.__maxDecelerationScrollLeft = self.__maxScrollLeft;
      self.__maxDecelerationScrollTop = self.__maxScrollTop;
    }

    // Wrap class method
    var step = function step(percent, now, render) {
      self.__stepThroughDeceleration(render);
    };

    // How much velocity is required to keep the deceleration running
    // added by yiminghe
    var minVelocityToKeepDecelerating = self.options.minVelocityToKeepDecelerating;

    if (!minVelocityToKeepDecelerating) {
      minVelocityToKeepDecelerating = self.options.snapping ? 4 : 0.001;
    }

    // Detect whether it's still worth to continue animating steps
    // If we are already slow enough to not being user perceivable anymore, we stop the whole process here.
    var verify = function verify() {
      var shouldContinue = Math.abs(self.__decelerationVelocityX) >= minVelocityToKeepDecelerating || Math.abs(self.__decelerationVelocityY) >= minVelocityToKeepDecelerating;
      if (!shouldContinue) {
        self.__didDecelerationComplete = true;
      }
      return shouldContinue;
    };

    var completed = function completed(renderedFramesPerSecond, animationId, wasFinished) {
      self.__isDecelerating = false;
      // Animate to grid when snapping is active, otherwise just fix out-of-boundary positions
      // fixed by yiminghe, in case call scrollingComplete twice
      self.scrollTo(self.__scrollLeft, self.__scrollTop, self.options.snapping, null, self.__didDecelerationComplete && self.options.scrollingComplete);
    };

    // Start animation and switch on flag
    self.__isDecelerating = __WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */].start(step, verify, completed);
  },

  /**
   * Called on every step of the animation
   *
   * @param inMemory {Boolean?false} Whether to not render the current step, but keep it in memory only. Used internally only!
   */
  __stepThroughDeceleration: function __stepThroughDeceleration(render) {

    var self = this;

    //
    // COMPUTE NEXT SCROLL POSITION
    //

    // Add deceleration to scroll position
    var scrollLeft = self.__scrollLeft + self.__decelerationVelocityX;
    var scrollTop = self.__scrollTop + self.__decelerationVelocityY;

    //
    // HARD LIMIT SCROLL POSITION FOR NON BOUNCING MODE
    //

    if (!self.options.bouncing) {

      var scrollLeftFixed = Math.max(Math.min(self.__maxDecelerationScrollLeft, scrollLeft), self.__minDecelerationScrollLeft);
      if (scrollLeftFixed !== scrollLeft) {
        scrollLeft = scrollLeftFixed;
        self.__decelerationVelocityX = 0;
      }

      var scrollTopFixed = Math.max(Math.min(self.__maxDecelerationScrollTop, scrollTop), self.__minDecelerationScrollTop);
      if (scrollTopFixed !== scrollTop) {
        scrollTop = scrollTopFixed;
        self.__decelerationVelocityY = 0;
      }
    }

    //
    // UPDATE SCROLL POSITION
    //

    if (render) {

      self.__publish(scrollLeft, scrollTop, self.__zoomLevel);
    } else {

      self.__scrollLeft = scrollLeft;
      self.__scrollTop = scrollTop;
    }

    //
    // SLOW DOWN
    //

    // Slow down velocity on every iteration
    if (!self.options.paging) {

      // This is the factor applied to every iteration of the animation
      // to slow down the process. This should emulate natural behavior where
      // objects slow down when the initiator of the movement is removed
      var frictionFactor = 0.95;

      self.__decelerationVelocityX *= frictionFactor;
      self.__decelerationVelocityY *= frictionFactor;
    }

    //
    // BOUNCING SUPPORT
    //

    if (self.options.bouncing) {

      var scrollOutsideX = 0;
      var scrollOutsideY = 0;

      // This configures the amount of change applied to deceleration/acceleration when reaching boundaries
      var penetrationDeceleration = self.options.penetrationDeceleration;
      var penetrationAcceleration = self.options.penetrationAcceleration;

      // Check limits
      if (scrollLeft < self.__minDecelerationScrollLeft) {
        scrollOutsideX = self.__minDecelerationScrollLeft - scrollLeft;
      } else if (scrollLeft > self.__maxDecelerationScrollLeft) {
        scrollOutsideX = self.__maxDecelerationScrollLeft - scrollLeft;
      }

      if (scrollTop < self.__minDecelerationScrollTop) {
        scrollOutsideY = self.__minDecelerationScrollTop - scrollTop;
      } else if (scrollTop > self.__maxDecelerationScrollTop) {
        scrollOutsideY = self.__maxDecelerationScrollTop - scrollTop;
      }

      // Slow down until slow enough, then flip back to snap position
      if (scrollOutsideX !== 0) {
        if (scrollOutsideX * self.__decelerationVelocityX <= 0) {
          self.__decelerationVelocityX += scrollOutsideX * penetrationDeceleration;
        } else {
          self.__decelerationVelocityX = scrollOutsideX * penetrationAcceleration;
        }
      }

      if (scrollOutsideY !== 0) {
        if (scrollOutsideY * self.__decelerationVelocityY <= 0) {
          self.__decelerationVelocityY += scrollOutsideY * penetrationDeceleration;
        } else {
          self.__decelerationVelocityY = scrollOutsideY * penetrationAcceleration;
        }
      }
    }
  }
};

// Copy over members to prototype
for (var key in members) {
  Scroller.prototype[key] = members[key];
}

/* harmony default export */ __webpack_exports__["a"] = (Scroller);

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(37), __esModule: true };

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1951);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 1953 */
/***/ (function(module, exports) {



/***/ }),
/* 1954 */
/***/ (function(module, exports) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(2004);
var iterableToArray = __webpack_require__(2009);
var unsupportedIterableToArray = __webpack_require__(2014);
var nonIterableSpread = __webpack_require__(2010);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(720)["default"];
var toPrimitive = __webpack_require__(2013);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return serviceReporListDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serviceReporDetailDel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getServiceReportList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getServiceReportListHasQuarterly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getServiceReportDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_js__ = __webpack_require__(13);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var serviceReportList = function serviceReportList(data) {
	return {
		type: 'SERVICE_REPORTLIST',
		data: data
	};
};

var serviceReporDetail = function serviceReporDetail(data) {
	return {
		type: 'SERVICE_REPORTDETAIL',
		data: data
	};
};

var serviceReporListDel = function serviceReporListDel(data) {
	return {
		type: 'LIST_DEL',
		data: data
	};
};

var serviceReporDetailDel = function serviceReporDetailDel(data) {
	return {
		type: 'DEL',
		data: data
	};
};
var getServiceReportList = function getServiceReportList(params) {
	// params.superFundCode='SF1009'
	return function (dispatch, getState) {
		var successCallback = function successCallback(suc) {
			console.log('=======', suc);
			if (suc.code == '0000') {
				var result = {};
				suc.content.data.forEach(function (item, index) {
					if (item.monthReportToPortal) item.type = 2;else item.type = item.detailType;
					if (result[item.newsTime]) {
						result[item.newsTime].push(item);
					} else {
						result[item.newsTime] = [item];
					}
				});
				console.log('----result----', result);
				//Object.entries(result).map((item)=>{console.log('----',item)})
				suc.content.processData = result;
				console.log('---suc.content.data ---', suc.content);
				dispatch(serviceReportList(suc.content));
			} else {
				console.log('非正确数据！');
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log('请求失败', err);
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/v1/superFund/SuperFundReport/getRecentNewsReportList', params, successCallback, errorCallback);
	};
};

var getServiceReportListHasQuarterly = function getServiceReportListHasQuarterly(params) {

	return function () {
		var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch, getState) {
			var successCallback, errorCallback, token;
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							successCallback = function successCallback(suc) {
								console.log('=======', suc);
								if (suc.code == '0000') {
									var result = {};
									suc.content.data.forEach(function (item, index) {

										if (item.monthReportToPortal) item.type = 2;else item.type = item.detailType;
										if (result[item.newsTime]) {
											result[item.newsTime].push(item);
										} else {
											result[item.newsTime] = [item];
										}
									});
									console.log('----result----', result);
									//Object.entries(result).map((item)=>{console.log('----',item)})
									suc.content.processData = result;
									console.log('---suc.content.data ---', suc.content);
									dispatch(serviceReportList(suc.content));
								} else {
									console.log('非正确数据！');
								}
							};

							errorCallback = function errorCallback(err) {
								console.log('请求失败', err);
								// errcallback(Util.errorTxt);
								// dispatch(webViewHtmlString(''));
							};

							_context.next = 4;
							return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_js__["b" /* getTempInfo */])('shortToken');

						case 4:
							token = _context.sent;

							params.token = token;
							//params.token='eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NTA2MTEyMTUsInN1YiI6IjIwMDAwMDc3MDM3IiwidXNlcklkIjoiMTY3NzAiLCJjZXJUeXBlIjoiMCIsImNlck5vIjoiMTEwMTAxMTk4NjA4MDgxMDM0IiwibmFtZSI6IuixhuixhjTlj7ciLCJ0aW1lc3RhcCI6MTY1MDYxMTIxNTg2N30.U4vX2UYD7QHVwRZEPVLx7d3bRagLiLUYd-qC8nXM6Qo'

							if (params.token) {
								_context.next = 8;
								break;
							}

							return _context.abrupt('return', alert('请先登陆！'));

						case 8:
							__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/v1/superFund/SuperFundReport/getSuperFundReportList', params, successCallback, errorCallback);

						case 9:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this);
		}));

		return function (_x, _x2) {
			return _ref.apply(this, arguments);
		};
	}();
};

var getServiceReportDetail = function getServiceReportDetail(params) {
	return function (dispatch, getState) {
		var successCallback = function successCallback(suc) {
			console.log('=======', suc);
			if (suc.code == '0000') {
				if (suc.content.monthReportToPortal) suc.content.type = 2;
				suc.content.type = suc.content.detailType;
				dispatch(serviceReporDetail(suc.content));
			} else {
				console.log('非正确数据！');
			}
		};
		var errorCallback = function errorCallback(err) {
			console.log('请求失败', err);
			// errcallback(Util.errorTxt);
			// dispatch(webViewHtmlString(''));
		};
		__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_js___default.a.url + '/api/v1/superFund/SuperFundReport/getRecentNewsReportDetail', params, successCallback, errorCallback);
	};
};

/***/ }),
/* 1959 */,
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__changefundlistentry_css__ = __webpack_require__(2135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__changefundlistentry_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__changefundlistentry_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ChangeFundListEntry = function (_React$PureComponent) {
  _inherits(ChangeFundListEntry, _React$PureComponent);

  function ChangeFundListEntry(props) {
    _classCallCheck(this, ChangeFundListEntry);

    var _this = _possibleConstructorReturn(this, (ChangeFundListEntry.__proto__ || Object.getPrototypeOf(ChangeFundListEntry)).call(this, props));

    _this.toChangeFundList = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: "/ChangeFundList",
        query: { superFundCode: _this.props.superFundCode },
        state: { superFundCode: _this.props.superFundCode }
      });
    };

    _this.state = {};
    return _this;
  }

  _createClass(ChangeFundListEntry, [{
    key: "render",
    value: function render() {
      var effectDateStr = this.props.effectDateStr;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "Entry_container", onClick: this.toChangeFundList },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "Entry_title" },
          "\u8C03\u4ED3\u8BB0\u5F55"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Entry_btn" },
          __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.returnEmptyAlone(effectDateStr) === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "Entry_data" },
            "\u6682\u65E0\u8C03\u4ED3\u8BB0\u5F55"
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "Entry_data" },
            "\u622A\u6B62",
            effectDateStr || "--"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(272) })
        )
      );
    }
  }]);

  return ChangeFundListEntry;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails.superFundAdjustmentVersion,
      superFundAdjustmentVersion = _state$strategiesDeta === undefined ? {} : _state$strategiesDeta;

  return {
    effectDateStr: superFundAdjustmentVersion && superFundAdjustmentVersion.effectDateStr
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(ChangeFundListEntry)));

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineEchart__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lineEchartPerformanceTrends_css__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lineEchartPerformanceTrends_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lineEchartPerformanceTrends_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_portfolioAction__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var LineEchartPerformanceTrends = function (_Component) {
  _inherits(LineEchartPerformanceTrends, _Component);

  function LineEchartPerformanceTrends(props) {
    _classCallCheck(this, LineEchartPerformanceTrends);

    var _this = _possibleConstructorReturn(this, (LineEchartPerformanceTrends.__proto__ || Object.getPrototypeOf(LineEchartPerformanceTrends)).call(this, props));

    _this.formatter = function (params) {
      console.log('params', params);
      var getColor = function getColor(value) {
        if (!value && value != 0) return;
        if (value === "--") return "#333";
        if (value >= 0) return "#F8515C";
        return "#1DA96B";
      };
      if (params && params.length === 1 && params[0] && params[0].seriesName === '业绩基准') {
        params[1] = params[0];params[0] = null;
      }
      return "<div class=\"PT_describe\">\n              <div class=\"PT_data\">\u672C\u7B56\u7565 <span class='PT_describe_colon'>:</span> <span style='color:" + getColor(params[0] && params[0].value[1]) + "'>" + __WEBPACK_IMPORTED_MODULE_6__util___default.a.toPercent(params[0] && params[0].value[1]) + "</span></div>\n              <div class=\"PT_base_data\">\u4E1A\u7EE9\u57FA\u51C6 <span class='PT_describe_colon'>:</span> <span style='color:" + getColor(params[1] && params[1].value[1]) + "'>" + __WEBPACK_IMPORTED_MODULE_6__util___default.a.toPercent(params[1] && params[1].value[1]) + "</span></div>\n              <img style=' width: .24rem; margin-left: .1rem ' src='" + __webpack_require__(388) + "' />\n            </div>";
    };

    _this.changeTab = function (index) {
      var periodType = [1, 3, 6, 12, 36];
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          location = _this$props.location,
          lineData = _this$props.lineData;

      var key = periodType[index];
      var echartsDOM = document.querySelector("#tip");
      if (echartsDOM) echartsDOM.style.display = "flex";
      if (index == _this.state.tab) return;
      // document.querySelector('#tip').style.display='flex'
      _this.setState({ tab: index });
      if (periodType[index] in lineData) return;
      var params = {
        superFundCode: location.query.superFundCode,
        periodType: periodType[index]
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_portfolioAction__["a" /* getSuperFundProductIncome */])(params));
    };

    _this.state = {
      tab: 0
    };
    return _this;
  }

  _createClass(LineEchartPerformanceTrends, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      console.log('props', this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var btn = ["近1月", "近3月", "近6月", "近1年", "近3年"];
      var periodType = [1, 3, 6, 12, 36];
      var linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
      var xData = linelist.incomeDateList,
          baseData = linelist.incomeList4Benchmark,
          data = linelist.incomeList,
          xBase = linelist.incomeDateList4Benchmark;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "PT_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LineEchart__["a" /* default */], { lineDataLast: this.props.lineDataLast, formatter: this.formatter, xData: xData, baseData: baseData, data: data, xBase: xBase }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "PT_btn_group" },
          btn.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { onClick: function onClick() {
                  return _this2.changeTab(index);
                }, key: index, className: _this2.state.tab == index && "Tab_Selected" },
              item
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "PT_tip" },
          "\u4E1A\u7EE9\u8D70\u52BF\u4E3A\u6839\u636E\u7B56\u7565\u7EC4\u5408\u6301\u4ED3\u57FA\u91D1\u51C0\u503C\u6CE2\u52A8\u8BA1\u7B97\u7ED3\u679C\uFF0C\u672A\u8003\u8651\u6210\u5206\u57FA\u91D1\u4EA4\u6613\u8D39\u7528\uFF0C\u4E0E\u7528\u6237\u5B9E\u9645\u6536\u76CA\u53EF\u80FD\u7565\u6709\u5DEE\u5F02\u3002"
        )
      );
    }
  }]);

  return LineEchartPerformanceTrends;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    lineData: state.lineData,
    lineDataLast: state.lineDataLast
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(LineEchartPerformanceTrends)));

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_svg_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__targetProfitHaveCast_css__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__targetProfitHaveCast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__targetProfitHaveCast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var LineEchart = function (_Component) {
  _inherits(LineEchart, _Component);

  function LineEchart(props) {
    _classCallCheck(this, LineEchart);

    var _this = _possibleConstructorReturn(this, (LineEchart.__proto__ || Object.getPrototypeOf(LineEchart)).call(this, props));

    _this.setEchart = function () {
      var incomeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var incomeDateList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
      }
      var dataArr = [];
      myChart.clear();
      myChart.resize();
      myChart.setOption(setLineOption(incomeList, incomeDateList, _this.formatter));
      // 默认选中最右一项弹出tooltip
      var timer = setTimeout(function () {
        if (incomeDateList && incomeDateList.length) myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: incomeDateList.length - 1
        });
        clearTimeout(timer);
      }, 900);
    };

    _this.getColor = function (value) {
      if (!value && value !== 0) return '#333';
      if (value === "--") return "#333";
      if (value >= 0) return "#F8515C";
      return "#1DA96B";
    };

    _this.formatter = function (params) {
      return "<div class=\"line_echarts_tooltip style_sm_font\">\u7D2F\u8BA1\u6536\u76CA <span style='margin:0 .1rem'>:</span> <span style='color:" + _this.getColor(params[0] && params[0].value) + "'>" + __WEBPACK_IMPORTED_MODULE_8__util___default.a.processingDecimal(params[0] && params[0].value, 2, true) + "</span></div>";
    };

    _this.state = {
      tab: 0
    };
    return _this;
  }

  _createClass(LineEchart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var periodType = [1, 3, 6, 12, 36];
      var userAllIncomeHistory = this.props.userAllIncomeHistory[periodType[this.state.tab]] ? this.props.userAllIncomeHistory[periodType[this.state.tab]] : {};
      this.setEchart(userAllIncomeHistory.incomeList, userAllIncomeHistory.incomeDateList);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var thisProps = this.props || {},
          thisState = this.state || {};
      for (var key in nextProps) {
        if (thisProps[key] !== nextProps[key]) {
          return true;
        }
      }
      for (var _key in nextState) {
        if (thisState[_key] !== nextState[_key]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var periodType = [1, 3, 6, 12, 36];
      var userAllIncomeHistory = this.props.userAllIncomeHistory[periodType[this.state.tab]] ? this.props.userAllIncomeHistory[periodType[this.state.tab]] : {};
      this.setEchart(userAllIncomeHistory.incomeList, userAllIncomeHistory.incomeDateList);
    }
  }, {
    key: "render",
    value: function render() {
      var allIncomeLast = this.props.allIncomeLast;

      var btn = ["近1月", "近3月", "近6月", "近1年", "近3年"];
      var periodType = [1, 3, 6, 12, 36];
      var dataSource = this.props.userAllIncomeHistory[periodType[this.state.tab]] ? this.props.userAllIncomeHistory[periodType[this.state.tab]] : {};
      var _dataSource$incomeDat = dataSource.incomeDateList,
          incomeDateList = _dataSource$incomeDat === undefined ? [] : _dataSource$incomeDat;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        incomeDateList.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "flex", alignItems: "center", position: "absolute", marginBottom: "0.36rem", color: "#3C3C3C", fontSize: ".24rem", lineHeight: ".34rem" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "center" /* , width: "2.5rem"  */ } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { boxSizing: "content-box", width: ".12rem", height: ".12rem", borderRadius: "50%", border: "2px solid #ffffff", background: "#BF9B79", marginRight: ".1rem" } }),
              "\u7D2F\u8BA1\u6536\u76CA ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { margin: "0 .1rem" } },
                ":"
              ),
              /* (!allIncomeLast && allIncomeLast !== 0) ? <span style={{color:'#333'}}>--</span> :  */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { color: this.getColor(allIncomeLast) } },
                __WEBPACK_IMPORTED_MODULE_8__util___default.a.processingDecimal(allIncomeLast, 2, true)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "SuperLine", style: { width: "100%", height: 360, overflow: "hidden" } })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".2rem" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "SuperLine" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: "4.17rem", height: "2.52rem" }, src: __webpack_require__(775) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            { style: { fontSize: ".28rem", lineHeight: ".4rem" } },
            "\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E"
          )
        )
      );
    }
  }]);

  return LineEchart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    userAllIncomeHistory: state.userAllIncomeHistory,
    allIncomeLast: state.allIncomeLast
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(mapStateToProps)(LineEchart)));

function setLineOption() {
  var incomeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var incomeDateList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _formatter = arguments[2];

  var getColor = function getColor(value) {
    if (!value && value != 0) return;
    if (value === "--") return "#333";
    if (value >= 0) return "#F8515C";
    return "#1DA96B";
  };

  var option = {
    color: ["#BF9B79"],
    grid: {
      left: "0%",
      right: "3%",
      bottom: "3%",
      //top:'3%',
      containLabel: true
    },
    xAxis: [{
      type: "category",
      boundaryGap: false,
      color: "#878787",
      fontSize: 9,
      fontWeight: 600,
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#DFDFDF"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0
        }
      },
      axisLabel: {
        color: "#878787",
        align: "center",
        interval: function interval(index, value) {
          if (index == 0 || index == incomeDateList.length - 1 || index == incomeDateList.length / 2 - 1 || index == (incomeDateList.length - 1) / 2) {
            return value;
          }
          return false;
        },

        formatter: function formatter(value, index) {
          if (index == 0) return "{start|" + value.split("/").join("-") + "}";
          if (index == incomeDateList.length - 1) return "{end|" + value.split("/").join("-") + "}";
          if (index == incomeDateList.length / 2 - 1 || index == (incomeDateList.length - 1) / 2) return "{middle|" + value.split("/").join("-") + "}";
        },

        rich: {
          start: {
            width: "200%",
            align: "left"
          },
          end: {
            width: "0%",
            align: "right"
          },
          middle: {
            align: "center"
          }
        }
      },
      data: incomeDateList
    }],
    yAxis: [{
      type: "value",
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0
        }
      },
      axisTick: {
        lineStyle: {
          width: 0
        }
      },
      axisLabel: {
        formatter: function formatter(value, index) {
          return __WEBPACK_IMPORTED_MODULE_8__util___default.a.processingDecimal(value);
        }
      },
      splitLine: {
        lineStyle: {
          color: "#DFDFDF",
          width: 1,
          type: "dotted"
        }
      }
    }],
    animation: window.isLess47,

    tooltip: {
      show: true,
      trigger: "axis",
      alwaysShowContent: true,
      position: [0, 0],
      padding: [0, 0, 0, 0],
      transitionDuration: 0,
      triggerOn: 'mousemove|click',
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#48b",
          width: 1,
          type: "dashed",
          opacity: 1
        }
      },
      backgroundColor: "#FFF",
      extraCssText: 'width:100%;',
      formatter: function formatter(params) {
        return _formatter(params);
      }
    },
    calculable: true,

    series: [{
      name: "累计收益",
      type: "line",
      smooth: true,
      data: incomeList,
      showSymbol: false,
      areaStyle: {
        normal: {
          color: new __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: "rgba(191, 155, 121, 0.15)"
          }, {
            offset: 1,
            color: "rgba(191, 155, 121, 0)"
          }]),
          origin: 'start'
        },
        origin: 'start'
      }
    }]
  };

  return option;
}

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_svg_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zrender_lib_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_zrender_lib_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var LineEchart = function (_Component) {
  _inherits(LineEchart, _Component);

  function LineEchart(props) {
    _classCallCheck(this, LineEchart);

    var _this = _possibleConstructorReturn(this, (LineEchart.__proto__ || Object.getPrototypeOf(LineEchart)).call(this, props));

    _this.setEchart = function () {
      var xData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var xBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var baseData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var formatter = arguments[4];
      var buyList = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var sellList = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
      }
      var dataArr = [];
      myChart.clear();
      myChart.resize();
      myChart.setOption(setLineOption(xData, data, xBase, baseData, formatter, buyList, sellList));
      //默认选中最右一项弹出tooltip
      var timer = setTimeout(function () {
        clearTimeout(timer);
        if (!xBase.length && !xData.length) return;
        if (!xBase.length && xData.length || xData[xData.length - 1] >= xBase[xBase.length - 1]) {
          myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0, // 系列的 index
            dataIndex: data.length - 1 // 数据的 index
          });
        }
        if (xBase.length && !xData.length || xData[xData.length - 1] < xBase[xBase.length - 1]) {
          myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 1, // 系列的 index
            dataIndex: baseData.length - 1 // 数据的 index
          });
        }
        // document.querySelector('#tip').style.display='none'
      }, 900);
    };

    _this.getColor = function (value) {
      if (!value && value !== 0) return;
      if (value === "--") return "#333";
      if (value >= 0) return "#F8515C";
      return "#1DA96B";
    };

    _this.formatter = function (params) {
      if (params && params.length === 1 && params[0] && params[0].seriesName === '业绩基准') {
        params[1] = params[0];params[0] = null;
      }
      return "<div class=\"PT_describe\">\n              <div class=\"PT_data\">\u672C\u7B56\u7565 <span class='PT_describe_colon'>:</span> <span style='color:" + _this.getColor(params[0] && params[0].value) + "'>" + __WEBPACK_IMPORTED_MODULE_8__util___default.a.toPercent(params[0] && params[0].value) + "</span></div>\n              <div class=\"PT_base_data\">\u4E1A\u7EE9\u57FA\u51C6 <span class='PT_describe_colon'>:</span> <span style='color:" + _this.getColor(params[1] && params[1].value[1]) + "'>" + __WEBPACK_IMPORTED_MODULE_8__util___default.a.toPercent(params[1] && params[1].value[1]) + "</span></div>\n              <img style=' width: .24rem; margin-left: .1rem ' src='" + __webpack_require__(388) + "' />\n            </div>";
    };

    _this.changeTab = function (index) {
      var periodType = [1, 3, 6, 12, 36];
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          location = _this$props.location,
          lineData = _this$props.lineData;

      if (index == _this.state.tab) return;
      _this.setState({ tab: index });
      if (periodType[index] in lineData) return;
      var params = {
        superFundCode: location.state.superFundCode,
        periodType: periodType[index]
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_portfolioAction__["b" /* getUserTransactionIncomeAndProductIncome */])(params));
    };

    _this.state = {
      tab: 0
    };
    return _this;
  }

  _createClass(LineEchart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var periodType = [1, 3, 6, 12, 36];
      var linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
      var xData = linelist.incomeDateList,
          baseData = linelist.incomeList4Benchmark,
          data = linelist.incomeList,
          xBase = linelist.incomeDateList4Benchmark,
          _linelist$buyList = linelist.buyList,
          buyList = _linelist$buyList === undefined ? [] : _linelist$buyList,
          _linelist$sellList = linelist.sellList,
          sellList = _linelist$sellList === undefined ? [] : _linelist$sellList;


      if (!xData) {
        xData = [];
        data = [];
      }
      if (!xBase) {
        xBase = [];
        baseData = [];
      }
      this.setEchart(xData, data, xBase, baseData, this.formatter, buyList, sellList);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var thisProps = this.props || {},
          thisState = this.state || {};
      for (var key in nextProps) {
        if (thisProps[key] !== nextProps[key]) {
          return true;
        }
      }
      for (var _key in nextState) {
        if (thisState[_key] !== nextState[_key]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var periodType = [1, 3, 6, 12, 36];
      var linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
      var xData = linelist.incomeDateList,
          baseData = linelist.incomeList4Benchmark,
          data = linelist.incomeList,
          xBase = linelist.incomeDateList4Benchmark,
          _linelist$buyList2 = linelist.buyList,
          buyList = _linelist$buyList2 === undefined ? [] : _linelist$buyList2,
          _linelist$sellList2 = linelist.sellList,
          sellList = _linelist$sellList2 === undefined ? [] : _linelist$sellList2;

      if (!xData) {
        xData = [];
        data = [];
      }
      if (!xBase) {
        xBase = [];
        baseData = [];
      }
      this.setEchart(xData, data, xBase, baseData, this.formatter, buyList, sellList);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var btn = ["近1月", "近3月", "近6月", "近1年", "近3年"];
      var periodType = [1, 3, 6, 12, 36];
      var linelist = this.props.lineData[periodType[this.state.tab]] ? this.props.lineData[periodType[this.state.tab]] : {};
      var xData = linelist.incomeDateList,
          baseData = linelist.incomeList4Benchmark,
          data = linelist.incomeList,
          xBase = linelist.incomeDateList4Benchmark;


      if (!xData) {
        xData = [];
        data = [];
      }
      if (!xBase) {
        xBase = [];
        baseData = [];
      }
      var _props$lineDataLast = this.props.lineDataLast,
          lastIncome = _props$lineDataLast.lastIncome,
          lastBase = _props$lineDataLast.lastBase;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        xData && xData.length || xBase && xBase.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { position: "relative" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { id: "tip", style: { display: "flex", alignItems: "center", position: "absolute", marginBottom: "0.36rem", color: "#3C3C3C", fontSize: ".24rem", lineHeight: ".34rem" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "center", width: "2.5rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { boxSizing: "content-box", width: ".12rem", height: ".12rem", borderRadius: "50%", border: "2px solid #ffffff", background: "#BF9B79", marginRight: ".1rem" } }),
              "\u672C\u7B56\u7565 ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { margin: "0 .1rem" } },
                ":"
              ),
              !lastIncome && lastIncome !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { color: "#333" } },
                "--"
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { color: this.getColor(lastIncome) } },
                __WEBPACK_IMPORTED_MODULE_8__util___default.a.toPercent(lastIncome)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { display: "flex", alignItems: "center", minWidth: '2.2rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { style: { boxSizing: "content-box", width: ".12rem", height: ".12rem", borderRadius: "50%", border: "2px solid #ffffff", background: "#CAD6E8", marginRight: ".1rem" } }),
              "\u4E1A\u7EE9\u57FA\u51C6 ",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { margin: "0 .1rem" } },
                ":"
              ),
              !lastBase && lastBase !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { color: "#333" } },
                "--"
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: { color: this.getColor(lastBase) } },
                __WEBPACK_IMPORTED_MODULE_8__util___default.a.toPercent(lastBase)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".24rem", marginLeft: ".1rem" }, src: __webpack_require__(388) })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "SuperLine", style: { width: "100%", height: 360, overflow: "hidden" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "style_flex_row_center style_flex_average style_sm_font  target_btn" },
            btn.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { onClick: function onClick() {
                    return _this2.changeTab(index);
                  }, key: index, className: _this2.state.tab == index && "Tab_Selected" },
                item
              );
            })
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".2rem" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "SuperLine" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: "4.17rem", height: "2.52rem" }, src: __webpack_require__(775) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "text",
            { style: { fontSize: ".28rem", lineHeight: ".4rem" } },
            "\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E"
          )
        )
      );
    }
  }]);

  return LineEchart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    lineData: state.lineData,
    lineDataLast: state.lineDataLast
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps)(LineEchart)));

function setLineOption() {
  var xData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var xBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var baseData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var _formatter = arguments[4];
  var buyList = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
  var sellList = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

  var xDataN = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(xData), _toConsumableArray(xBase))))).sort();
  // xDataN=['2022-07-01','2022-07-03','2022-07-04','2022-07-05','2022-07-06','2022-07-07','2022-07-08','2022-07-09','2022-07-28','2022-07-29','2022-08-01','2022-08-02']
  // buyList=['2022-07-28','2022-07-29'];
  // sellList=['2022-07-28','2022-08-01'];
  var symbol = function symbol(v) {
    return buyList && buyList.includes(v) || sellList && sellList.includes(v) ? 'circle' : 'none';
  };
  var symbolColor = function symbolColor(v) {
    if (buyList && buyList.includes(v) && sellList && sellList.includes(v)) {
      return 'red';
    }
    if (buyList && buyList.includes(v)) {
      return "red";
    }
    if (sellList && sellList.includes(v)) {
      return "blue";
    }
  };
  var dayIncomeSeries = xDataN.map(function (v, i) {
    var index = xData.indexOf(v);
    if (index === -1) {
      return {
        name: v,
        value: '--',
        symbol: 'none'
      };
    }
    return {
      name: v,
      value: data[index],
      symbol: symbol(v),
      itemStyle: {
        normal: {
          color: symbolColor(v)
        },
        emphasis: {
          scale: false
        }
      }
    };
  });
  var baseSeries = xBase.map(function (v, i) {
    return [v, baseData[i]];
  });
  // dayIncomeSeries = [
  //   {
  //     name: '2022-07-01',
  //     value: 0.0067,
  //     symbol: symbol('2022-07-01'),
  //     symbolSize:10,
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-01')
  //       },

  //     }
  //   },
  //   {
  //     name: '2022-07-03',
  //     value: '--',
  //     symbol: 'none',
  //     symbolSize:10,
  //     // itemStyle: {
  //     //   normal: {
  //     //     color: symbolColor('2022-07-03')
  //     //   },
  //     // }
  //   },
  //   {
  //     name: '2022-07-04',
  //     value: 0.0067,
  //     symbol: symbol('2022-07-04'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-04')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-05',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-05'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-05')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-06',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-06'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-06')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-07',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-07'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-07')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-08',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-08'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-08')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-09',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-09'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-09')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-28',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-28'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-28')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-07-29',
  //     value: '0.0067',
  //     symbol: symbol('2022-07-29'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-07-29')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-08-01',
  //     value: '0.0067',
  //     symbol: symbol('2022-08-01'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-08-01')
  //       },
  //     }
  //   },
  //   {
  //     name: '2022-08-02',
  //     value: '0.0067',
  //     symbol: symbol('2022-08-02'),
  //     itemStyle: {
  //       normal: {
  //         color: symbolColor('2022-08-02')
  //       },
  //     }
  //   },];
  // baseSeries=[['2022-07-01',0.1067],['2022-07-03',0.1067],['2022-07-05',0.0167],['2022-07-06',0.0167],['2022-07-07',0.0167],['2022-07-08',0.0167],['2022-07-09',0.0167],['2022-07-28',0.0167],['2022-07-29',0.0167],['2022-08-01',0.0167],['2022-08-02',0.0167]]
  var option = void 0;
  option = {
    color: ["#BF9B79", "#CAD6E8"],
    grid: {
      left: "0%",
      right: "3%",
      bottom: "3%",
      //top:'3%',
      containLabel: true
    },
    xAxis: [{
      type: "category",
      boundaryGap: false,
      // color: "#878787",
      fontSize: 0,
      fontWeight: 600,
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#DFDFDF"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0
        }
      },
      axisLabel: {
        color: "#878787",
        align: "center",
        // interval: (index, value) => {
        //   if (index == 0 || index == xDataN.length - 1 || index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) {
        //     return value;
        //   }
        //   return false;
        // },
        interval: 0,
        formatter: function formatter(value, index) {
          if (index == 0) return "{start|" + value.split("/").join("-") + "}";
          if (index == xDataN.length - 1) return "{end|" + value.split("/").join("-") + "}";
          if (index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) return "{middle|" + value.split("/").join("-") + "}";
          return "{h|" + value.split("/").join("-") + "}";
        },
        rich: {
          start: {
            width: "200%",
            align: "left",
            fontSize: 9,
            color: '#333'
          },
          end: {
            width: "0%",
            align: "right",
            fontSize: 9
          },
          middle: {
            align: "center",
            fontSize: 9
          },
          h: {
            fontSize: 0,
            color: 'rgba(0,0,0,0)',
            width: 0,
            height: 0
            // display:'none'
          }
        }
      },
      data: xDataN
    }],
    yAxis: [{
      type: "value",
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0
        }
      },
      axisTick: {
        lineStyle: {
          width: 0
        }
      },
      axisLabel: {
        formatter: function formatter(value, index) {
          return __WEBPACK_IMPORTED_MODULE_8__util___default.a.toPercent(value);
        }
      },
      splitLine: {
        lineStyle: {
          color: "#DFDFDF",
          width: 1,
          type: "dotted"
        }
      }
    }],
    animation: window.isLess47,

    tooltip: {
      show: true,
      trigger: "axis",
      alwaysShowContent: true,
      position: [0, 0],
      padding: [0, 0, 0, 0],
      transitionDuration: 0,
      triggerOn: 'mousemove|click',
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#48b",
          width: 1,
          type: "dashed",
          opacity: 1
        }
      },
      backgroundColor: "#FFF",
      extraCssText: "width:100%;",
      formatter: function formatter(params) {
        return _formatter(params);
      }
    },
    calculable: true,

    series: [{
      name: "本策略",
      type: "line",
      smooth: true /*线条有弧度*/
      , data: dayIncomeSeries,
      connectNulls: true,
      symbolSize: 6,
      // showSymbol:false,
      itemStyle: {
        normal: {}
      },
      areaStyle: {
        normal: {
          color: new __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: "rgba(191, 155, 121, 0.15)"
          }, {
            offset: 1,
            color: "rgba(191, 155, 121, 0)"
          }]),
          origin: 'start'
        }
      },
      label: {
        //打点显示提示框
        // offset: [10, 10],
        // emphasis: {
        //   show: true,
        //   formatter: (params) => {
        //     if ((buyList&&buyList.includes(params.data.name/* params.data[0] */)) && (sellList&&sellList.includes(params.data.name/* params.data[0] */))) return "{buy|转入}{n|\n\n}{sell|转出}";
        //     if (buyList&&buyList.includes(params.data.name/* params.data[0] */)) return "{buy|转入}";
        //     if (sellList&&sellList.includes(params.data.name/* params.data[0] */)) return "{sell|转出}";

        //     return "";
        //   },
        //   rich: {
        //     buy: {
        //       backgroundColor: "#F8515C",
        //       fontSize: 12,
        //       padding: 5,
        //       color: "#333",
        //       borderRadius: 5,
        //     },
        //     sell: {
        //       backgroundColor: "#1DA96B",
        //       fontSize: 12,
        //       padding: 5,
        //       color: "#333",
        //       borderRadius: 5,
        //     },
        //     n: {
        //       lineHeight:5
        //     },
        //   },
        // },
      }
    }, {
      name: "业绩基准",
      type: "line",
      smooth: true,
      data: baseSeries,
      // showSymbol:false,
      connectNulls: true,
      symbol: 'none',
      areaStyle: {
        normal: {
          color: new __WEBPACK_IMPORTED_MODULE_3_echarts_lib_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: "rgba(189, 200, 212, 0.15)"
          }, {
            offset: 1,
            color: "rgba(189, 200, 212, 0)"
          }])
        }
      }
    }]
  };

  return option;
}

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_tree_filter__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_tree_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_tree_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__investPlan_InvestmentPlan_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__investPlan_InvestmentPlan_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__investPlan_InvestmentPlan_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pay_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Pay_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PayWarmTips__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PayCardSuperFund__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Modal_ModalPaySup__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__action_loginAction__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__action_myAssets_userInfoAction__ = __webpack_require__(97);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var CustomChildren = function CustomChildren(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      onClick: props.onClick,
      className: 'text-bar',
      style: { height: 52 }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { style: { paddingLeft: 20, fontSize: 16, color: "#333", fontWeight: "500" } },
      props.children
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { style: { color: "#999", fontSize: 14 } },
        props.extra
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { height: 10, width: 10 }, src: __webpack_require__(274) })
    )
  );
};
var accountTip;
var account;

var FixedInvestmentSuperFund = function (_Component) {
  _inherits(FixedInvestmentSuperFund, _Component);

  function FixedInvestmentSuperFund(props) {
    _classCallCheck(this, FixedInvestmentSuperFund);

    var _this = _possibleConstructorReturn(this, (FixedInvestmentSuperFund.__proto__ || Object.getPrototypeOf(FixedInvestmentSuperFund)).call(this, props));

    _this.popoverCountFun = function (text) {
      if (text >= 10000 && text < 100000) {
        _this.setState({
          popoverCountFlag: true,
          popoverCount: '万'
        });
      } else if (text >= 100000 && text < 1000000) {
        _this.setState({
          popoverCountFlag: true,
          popoverCount: '十万'
        });
      } else if (text >= 1000000 && text < 10000000) {
        _this.setState({
          popoverCountFlag: true,
          popoverCount: '百万'
        });
      } else if (text >= 10000000 && text < 100000000) {
        _this.setState({
          popoverCountFlag: true,
          popoverCount: '千万'
        });
      } else if (text >= 100000000 && text < 1000000000) {
        _this.setState({
          popoverCountFlag: true,
          popoverCount: '亿'
        });
      } else if (text >= 1000000000 && text < 10000000000) {
        _this.setState({
          popoverCountFlag: true,
          popoverCount: '十亿'
        });
      } else {
        _this.setState({
          popoverCountFlag: false,
          popoverCount: ''
        });
      }
    };

    _this.keyOk = function () {
      var _this$props = _this.props,
          payInfoData = _this$props.payInfoData,
          dispatch = _this$props.dispatch;
      var _this$props2 = _this.props,
          planItem = _this$props2.planItem,
          fundCode = _this$props2.fundCode,
          fundName = _this$props2.fundName;

      var pushResult = function pushResult(i, result) {
        if (i === 1) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '定投计划',
              content: '定投签约完成',
              dataSouse: [['申请编号', result.content.planId], ['产品名称', fundName], ['投资金额', _this.props.paymentText + '元']],
              souseVal: ['返回智投首页']
            }
          });
        } else if (i === 0) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '定投计划',
              content: '定投签约失败',
              content2: result,
              dataSouse: [],
              souseVal: ['返回智投首页', '联系客服']
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '定投计划',
              content: '结果未知',
              content2: '申请结果未知，请等待日终状态后联系客服',
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        }
      };

      if (payInfoData.currentType == 1) {
        var itemCard = payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        if (itemCard.yhkBool) {
          var data = {
            password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(_this.props.keyPasswordVal),
            fundCode: fundCode,
            paymentChannelId: itemCard.paymentChannelId,
            periodTradeType: 0,
            periodType: _this.state.pickerValue[0],
            tradeDays: _this.state.pickerValue[1],
            tradeAmount: _this.props.paymentText,
            bankAccountShowNo: itemCard.bankAccountShowNo,
            bankCode: itemCard.bankCode
          };
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction_js__["n" /* createBuyPlanzxk */])(data, pushResult));
        } else {
          var _data = {
            password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(_this.props.keyPasswordVal),
            fundCode: fundCode,
            paymentAccountId: itemCard.paymentAccountId,
            periodType: _this.state.pickerValue[0],
            tradeDays: _this.state.pickerValue[1],
            tradeAmount: _this.props.paymentText
          };
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction_js__["e" /* createBuyPlan */])(_data, pushResult));
        }
      } else if (payInfoData.currentType == 2) {
        var _itemCard = payInfoData.content.shareList[payInfoData.currentIndex];
        var _data2 = {
          password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(_this.props.keyPasswordVal),
          fundCode: fundCode,
          paymentChannelId: _itemCard.paymentChannel,
          periodTradeType: 0,
          periodType: _this.state.pickerValue[0],
          tradeDays: _this.state.pickerValue[1],
          tradeAmount: _this.props.paymentText,
          bankCode: _itemCard.bankCode
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction_js__["f" /* createPlan */])(_data2, pushResult));
      } else if (payInfoData.currentType == 3) {
        var _itemCard2 = payInfoData.content.currencyFund[payInfoData.currentIndex];
        var _data3 = {
          password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(_this.props.keyPasswordVal),
          fundCode: _itemCard2.fundCode,
          targetFundCode: fundCode,
          trustChannelId: _itemCard2.trustChannelId,
          periodType: _this.state.pickerValue[0],
          tradeDates: _this.state.pickerValue[1],
          tradeAmount: _this.props.paymentText,
          bankCode: _itemCard2.bankCode,
          bankAccountShowNo: _itemCard2.bankAccountShowNo
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction_js__["o" /* dttByMoneyFundValidate */])(_data3, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_myAssets_InvestPlanAction_js__["p" /* dttByMoneyFundSubmit */])(_data3, pushResult)));
      }
    };

    _this.maxTipFun = function (text, i, type, amount, amountMax) {
      _this.setState({
        tipByMax: ""
      });
      if (text === null || text === "" || text === undefined) {
        return;
      }
      var yhkList = _this.props.payInfoData.content.currentAccountList;
      var hqtList = _this.props.payInfoData.content.shareList;
      var lqbList = _this.props.payInfoData.content.currencyFund;
      var _amount = amount === null || amount === "" || amount === undefined ? null : Number(amount);
      var _amountMax = amountMax === null || amountMax === "" || amountMax === undefined ? null : Number(amountMax);
      var _index = i;
      var _type = type;
      if (text === 0 || text === "0") {
        _this.setState({
          tipByMax: "申购金额不能为0"
        });
        return;
      }
      if (_amount !== null && _amount !== "" && _amount !== undefined) {
        if (text < _amount) {
          _this.setState({
            tipByMax: "申购金额低于最低限额"
          });
          return;
        }
      }
      if (_amountMax !== null && _amountMax !== "" && _amountMax !== undefined) {
        if (text > _amountMax) {
          _this.setState({
            tipByMax: "申购金额超过最高限额"
          });
          return;
        }
      }
      if (_type == "1") {
        if (yhkList && yhkList.length > 0) {
          if (yhkList[_index].tradeMaxAmountTips.indexOf("|") != -1) {
            var _num = yhkList[_index].tradeMaxAmountTips.split("|")[0];
            _num = _num >= 0 ? Number(_num) : _num;
            if (_num !== null && _num !== "" && _num !== undefined) {
              if (text > _num) {
                _this.setState({
                  tipByMax: "申购金额超过银行卡限额"
                });
              }
            }
          }
        }
      } else if (_type == "2") {
        if (hqtList && hqtList.length > 0) {
          if (hqtList[_index].availableVolume !== null && hqtList[_index].availableVolume !== "" && hqtList[_index].availableVolume !== undefined) {
            if (text > hqtList[_index].availableVolume) {
              _this.setState({
                tipByMax: "申购金额超过可用余额"
              });
            }
          }
        }
      } else if (_type == "3") {
        if (lqbList && lqbList.length > 0) {
          if (lqbList[_index].availableVolume !== null && lqbList[_index].availableVolume !== "" && lqbList[_index].availableVolume !== undefined) {
            if (text > lqbList[_index].availableVolume) {
              _this.setState({
                tipByMax: "申购金额超过可用余额"
              });
            }
          }
        }
      }
    };

    _this.resetRiskFun = function () {
      _this.setState({
        showRiskModal: false
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], window.history.length, function () {
        _this.next("1");
      });
      return;
    };

    _this.sameDataFun = function () {
      _this.setState({
        showRiskModal: false
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["L" /* syncCwimRiskToCamcAndStopOutOfRiskBuyPlan */])({}, function () {
        _this.next("2");
      }));
      return;
    };

    _this.riskShowFun = function () {
      _this.setState({
        showRiskModal: true
      });
    };

    _this.paymentMethod = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/PayCardList',
        state: {
          type: 'superFundDT',
          actionType: 'SUPER_FUND_DT',
          fundCode: _this.props.fundCode
        }
      });
    };

    _this.state = {
      pickerValue: [0, 1],
      agreeIndex: 0,
      amount: '',
      dayIncomeDate: '',
      ThreeIncome: '',
      dataSouse: [{
        label: '每月',
        value: 0,
        key: 0,
        children: [{ label: '1日', value: 1, key: 0 }, { label: '2日', value: 2, key: 1 }, { label: '3日', value: 3, key: 2 }, { label: '4日', value: 4, key: 3 }, { label: '5日', value: 5, key: 4 }, { label: '6日', value: 6, key: 5 }, { label: '7日', value: 7, key: 6 }, { label: '8日', value: 8, key: 7 }, { label: '9日', value: 9, key: 8 }, { label: '10日', value: 10, key: 9 }, { label: '11日', value: 11, key: 10 }, { label: '12日', value: 12, key: 11 }, { label: '13日', value: 13, key: 12 }, { label: '14日', value: 14, key: 13 }, { label: '15日', value: 15, key: 14 }, { label: '16日', value: 16, key: 15 }, { label: '17日', value: 17, key: 16 }, { label: '18日', value: 18, key: 17 }, { label: '19日', value: 19, key: 18 }, { label: '20日', value: 20, key: 19 }, { label: '21日', value: 21, key: 20 }, { label: '22日', value: 22, key: 21 }, { label: '23日', value: 23, key: 22 }, { label: '24日', value: 24, key: 23 }, { label: '25日', value: 25, key: 24 }, { label: '26日', value: 26, key: 25 }, { label: '27日', value: 27, key: 26 }, { label: '28日', value: 28, key: 27 }]
      }],
      tipByMax: "",
      amountMax: '0',
      popoverCount: '', //气泡金额数位文本
      popoverCountFlag: false, //数位显示标志
      showRiskModal: false,
      unionPayTransformBool: false
    };
    return _this;
  }

  _createClass(FixedInvestmentSuperFund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      document.title = "新建定投计划";
      var _props = this.props,
          payInfoData = _props.payInfoData,
          dispatch = _props.dispatch;
      var _props2 = this.props,
          fundCode = _props2.fundCode,
          productType = _props2.productType;

      var dataAmount = {
        businessType: 'T022',
        superFundCode: fundCode
      };
      if (this.props.text) this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_publicAction__["i" /* myPaymentTextDT */])(this.props.text - 0 > 500 ? this.props.text : '500'));
      if (payInfoData.currentType == 4) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["I" /* getTradeInfo */])(fundCode, 'T522', productType, function (result, i, type) {
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["O" /* getSuperFundTradeLimit */])(dataAmount, function (val) {
            _this2.setState({ amount: val.content.minLimit, amountMax: val.content.maxLimit });
            _this2.maxTipFun(_this2.props.paymentText, i, type, val.content.minLimit, val.content.maxLimit);
          }));
          Object.assign(result, { currentType: type }, { currentIndex: i });
          dispatch({
            type: "SUPER_FUND_DT_PAY_INFO",
            text: result
          });
        }));
      } else {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["O" /* getSuperFundTradeLimit */])(dataAmount, function (val) {
          _this2.setState({ amount: val.content.minLimit, amountMax: val.content.maxLimit });
          _this2.maxTipFun(_this2.props.paymentText, _this2.props.payInfoData.currentIndex, _this2.props.payInfoData.currentType, val.content.minLimit, val.content.maxLimit);
        }));
      }
      var inData = {
        superFundCode: fundCode,
        periodType: 0
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__action_loginAction__["b" /* getUserInfoList */])(function (result) {
        var inParamsData = {
          certNo: result.content.certNo,
          certType: result.content.certType,
          name: result.content.name
        };
        _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__action_myAssets_userInfoAction__["a" /* findCamcHqtExist */])(inParamsData));
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.parThis.getChildThis(this);
      this.popoverCountFun(this.props.paymentText);
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(text) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_publicAction__["i" /* myPaymentTextDT */])(text));
      this.popoverCountFun(text);
      this.maxTipFun(text, this.props.payInfoData.currentIndex, this.props.payInfoData.currentType, this.state.amount, this.state.amountMax);
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name) {
      var code = __WEBPACK_IMPORTED_MODULE_8__BankCode__["a" /* protocolCode */][name];
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var agreeIndex = this.state.agreeIndex;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["K" /* smSzt */])(1));
      } else {
        this.setState({
          agreeIndex: 0
        });
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["K" /* smSzt */])(0));
      }
    }
  }, {
    key: 'next',
    value: function next(res) {
      var _this3 = this;

      var _props3 = this.props,
          payInfoData = _props3.payInfoData,
          paymentText = _props3.paymentText,
          dispatch = _props3.dispatch;
      var amount = this.state.amount;

      if (this.state.tipByMax) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info(this.state.tipByMax, __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
        return;
      }
      if (amount > paymentText) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('投资金额不可低于' + amount + '元', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
        return;
      }
      if (payInfoData.currentType == 1) {
        var item = payInfoData.content.yhkNewListList[payInfoData.currentIndex];
        if (!item) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
          return;
        }
        if (!item.disable) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
          return;
        }
        if (paymentText > 5000 && !payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool) {
          this.setState({ unionPayTransformBool: true });
          return;
        }
        if (item.tradeMaxAmountTips.split('|')[0] - 0 < paymentText) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info(item.tradeMaxAmountTips.split('|')[1], __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
          return false;
        }
      } else if (payInfoData.currentType == 2) {
        var _item = payInfoData.content.shareList[payInfoData.currentIndex];
        if (!_item) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
          return;
        }
        if (!_item.disable) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
          return;
        }
      } else if (payInfoData.currentType == 3) {
        var _item2 = payInfoData.content.currencyFund[payInfoData.currentIndex];
        if (!_item2) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请选择支付方式', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
          return;
        }
      }

      if (payInfoData.currentType == 1 && payInfoData.content.yhkNewListList[payInfoData.currentIndex].yhkBool) {
        var findHqtExist = this.props.findHqtExist;
        var params = {
          otsTradeAccountNo: findHqtExist.tradeAccountNo,
          raiseMethod: "9"
        };
        if (res == "1") {
          try {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
              if (_flag) {
                console.log('bbb');
                //组合成分基金中包含华夏基金产品，需弹窗提示
                _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this3.props.fundCode }, function (result) {

                  var data = result[result.length - 1].itemAdjustList;
                  var fundsArr = [];
                  console.log(data);
                  for (var i = 0; i < data.length; i++) {
                    if (data[i].fundName.indexOf('华夏') != -1) {
                      fundsArr.push(data[i].fundName);
                    }
                  }
                  if (fundsArr.length == 0) {
                    console.log(1);
                    _this3.props.parThis.setState({
                      pwdFlag: true
                    });
                  } else {
                    console.log(2);
                    _this3.props.parThis.setState({
                      data: fundsArr.join('、'),
                      isShowModal2: true
                    });
                  }
                }));
              } else {
                _this3.riskShowFun();
              }
            }));
          } catch (err) {
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
          }
        } else if (res == "2") {
          try {
            console.log('bbb');
            //组合成分基金中包含华夏基金产品，需弹窗提示
            this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: this.props.fundCode }, function (result) {

              var data = result[result.length - 1].itemAdjustList;
              var fundsArr = [];
              console.log(data);
              for (var i = 0; i < data.length; i++) {
                if (data[i].fundName.indexOf('华夏') != -1) {
                  fundsArr.push(data[i].fundName);
                }
              }
              if (fundsArr.length == 0) {
                console.log(1);
                _this3.props.parThis.setState({
                  pwdFlag: true
                });
              } else {
                console.log(2);
                _this3.props.parThis.setState({
                  data: fundsArr.join('、'),
                  isShowModal2: true
                });
              }
            }));
          } catch (err) {
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
          }
        } else {
          try {
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["N" /* hasOtsRiskRearing */])(params, function (c1, c2, z1) {
              console.log(c1, c2, z1, "是否同步问卷");
              if (z1) {
                console.log('bbb');
                //组合成分基金中包含华夏基金产品，需弹窗提示
                _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this3.props.fundCode }, function (result) {

                  var data = result[result.length - 1].itemAdjustList;
                  var fundsArr = [];
                  console.log(data);
                  for (var i = 0; i < data.length; i++) {
                    if (data[i].fundName.indexOf('华夏') != -1) {
                      fundsArr.push(data[i].fundName);
                    }
                  }
                  if (fundsArr.length == 0) {
                    console.log(1);
                    _this3.props.parThis.setState({
                      pwdFlag: true
                    });
                  } else {
                    console.log(2);
                    _this3.props.parThis.setState({
                      data: fundsArr.join('、'),
                      isShowModal2: true
                    });
                  }
                }));
              } else {
                if (c1 === c2) {
                  console.log(c1, c2, z1, "c1 === c2同步问卷");
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
                    if (_flag) {
                      console.log('bbb');
                      //组合成分基金中包含华夏基金产品，需弹窗提示
                      _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this3.props.fundCode }, function (result) {

                        var data = result[result.length - 1].itemAdjustList;
                        var fundsArr = [];
                        console.log(data);
                        for (var i = 0; i < data.length; i++) {
                          if (data[i].fundName.indexOf('华夏') != -1) {
                            fundsArr.push(data[i].fundName);
                          }
                        }
                        if (fundsArr.length == 0) {
                          console.log(1);
                          _this3.props.parThis.setState({
                            pwdFlag: true
                          });
                        } else {
                          console.log(2);
                          _this3.props.parThis.setState({
                            data: fundsArr.join('、'),
                            isShowModal2: true
                          });
                        }
                      }));
                    } else {
                      _this3.riskShowFun();
                    }
                  }));
                } else {
                  console.log(c1, c2, z1, "c1 === c2同步问卷");
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], window.history.length, function () {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
                      if (_flag) {
                        console.log('bbb');
                        //组合成分基金中包含华夏基金产品，需弹窗提示
                        _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: _this3.props.fundCode }, function (result) {

                          var data = result[result.length - 1].itemAdjustList;
                          var fundsArr = [];
                          console.log(data);
                          for (var i = 0; i < data.length; i++) {
                            if (data[i].fundName.indexOf('华夏') != -1) {
                              fundsArr.push(data[i].fundName);
                            }
                          }
                          if (fundsArr.length == 0) {
                            console.log(1);
                            _this3.props.parThis.setState({
                              pwdFlag: true
                            });
                          } else {
                            console.log(2);
                            _this3.props.parThis.setState({
                              data: fundsArr.join('、'),
                              isShowModal2: true
                            });
                          }
                        }));
                      } else {
                        _this3.riskShowFun();
                      }
                    }));
                  });
                }
              }
            }));
          } catch (err) {
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
            console.log(err, '同步问卷失败');
          }
        }
      } else {
        //组合成分基金中包含华夏基金产品，需弹窗提示
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["J" /* getCurrentAdjustDetail */])({ superFundCode: this.props.fundCode }, function (result) {

          var data = result[result.length - 1].itemAdjustList;
          var fundsArr = [];
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            if (data[i].fundName.indexOf('华夏') != -1) {
              fundsArr.push(data[i].fundName);
            }
          }
          if (fundsArr.length == 0) {
            console.log(1);
            _this3.props.parThis.setState({
              pwdFlag: true
            });
          } else {
            console.log(2);
            _this3.props.parThis.setState({
              data: fundsArr.join('、'),
              isShowModal2: true
            });
          }
        }));
      }
    }
    //各种限额提示

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      console.log(this.props.payInfoData, "94949949494");
      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      var payInfoData = this.props.payInfoData;
      var _props4 = this.props,
          titleHeader = _props4.titleHeader,
          fundName = _props4.fundName,
          fundCode = _props4.fundCode;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginTop: -10 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20, paddingBottom: 20, paddingLeft: 20, paddingRight: 20, width: window.winWidth, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", height: 62, backgroundColor: "#fff", borderTopLeftRadius: 10, borderTopRightRadius: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 16, color: '#333', fontWeight: "500" } },
              this.props.fundName + '(' + this.props.fundCode + ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 10, paddingTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 20, backgroundColor: "#fff", paddingRight: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 16, color: '#333', fontWeight: "500" } },
              '\u6BCF\u671F\u5B9A\u6295\u91D1\u989D'
            ),
            this.props.paymentText == '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 15 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#999', fontSize: 12 } },
                '|'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#F8515C', fontSize: 12, marginTop: 1, marginLeft: 2 } },
                "请输入申购金额"
              )
            ) : null,
            this.state.tipByMax ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", marginLeft: 15 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#999', fontSize: 12 } },
                '|'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { color: '#F8515C', fontSize: 12, marginTop: 1, marginLeft: 2 } },
                this.state.tipByMax
              )
            ) : null
          ),
          this.state.popoverCountFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { backgroundColor: "#fff", display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 60, height: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: '#999', fontSize: 12 } },
              '|'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: '#999', fontSize: 12, marginTop: 1, marginLeft: 2 } },
              this.state.popoverCount
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 20, backgroundColor: "#fff" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", paddingBottom: 9.5, borderBottomColor: "#EBEBEB", borderBottomWidth: 0.5, borderBottomStyle: "solid", width: window.winWidth - 40 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 24, fontWeight: "500", color: "#333" } },
                '\xA5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'price_placeholder_style', style: { fontSize: 24, color: "#333", fontWeight: "400", marginLeft: 10, width: 240 }, autoComplete: 'off', value: this.props.paymentText, placeholder: __WEBPACK_IMPORTED_MODULE_5__util___default.a.parsePrice(this.state.amount) + '\u5143\u8D77\u8D2D', onChange: function onChange(e) {
                  return _this4.onChangeText(e.target.value);
                }, type: 'text' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 14.5, paddingBottom: 14.5, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", backgroundColor: "#fff", paddingLeft: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: "#999", fontSize: 12 } },
              '\u57FA\u91D1\u7533\u8D2D\u8D39\u7387\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 12, color: '#B69271', fontWeight: "500" } },
              '0-1\u6298'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Picker"],
              {
                title: '\u9009\u62E9\u5B9A\u6295\u5468\u671F',
                extra: this.state.pickerValue,
                cols: 2,
                data: this.state.dataSouse,
                value: this.state.pickerValue,
                onChange: function onChange(v) {
                  console.log(v);_this4.setState({ pickerValue: v });
                }
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                CustomChildren,
                { style: { fontSize: 13, color: "#3a3f47" } },
                '\u5B9A\u6295\u65F6\u95F4'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: window.winWidth, paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 0.5, backgroundColor: "#EBEBEB", width: window.winWidth - 40 } })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 20, paddingRight: 20, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PayCardSuperFund__["a" /* default */], { type: 'superFundDT', superFundCode: this.props.fundCode, actionType: 'SUPER_FUND_DT' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: "auto", paddingTop: 10, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" }, className: 'pay-agree' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: img_arr[this.props.smSzt], style: { width: 32, height: 32 }, onClick: function onClick() {
                  return _this4.isAgreeClick();
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { display: 'block' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999999', fontSize: 12 } },
                  '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('华夏查理智投定期定额申请协议');
                    } },
                  '\u300A\u534E\u590F\u67E5\u7406\u667A\u6295\u5B9A\u671F\u5B9A\u989D\u7533\u8BF7\u534F\u8BAE\u300B'
                ),
                this.props.fundCode == 'SF1012' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-货币');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1015' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-固收');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1016' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-权益');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1014' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-指数');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1017' || this.props.fundCode == 'SF1018' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-教育');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1019' || this.props.fundCode == 'SF1020' || this.props.fundCode == 'SF1021' || this.props.fundCode == 'SF1013' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-养老');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.policy && this.props.policyTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper(_this4.props.policyTitle ? _this4.props.policyTitle : "");
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1036' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-工资宝');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1038' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-7分小进取');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1039' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-指数增强');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1060' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-安心宝');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1067' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-价值精选');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : this.props.fundCode == 'SF1022' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: "#5270A3" }, onClick: function onClick() {
                      return _this4.ProtocolPaper('投资组合策略说明书-货币增强');
                    } },
                  '\u300A\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B'
                ) : null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#999999', fontSize: 12 } },
                  '\u53CA\u7279\u522B\u63D0\u793A\u5185\u5BB9'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { width: window.winWidth, paddingLeft: 20, paddingRight: 20, marginTop: 20 } },
              this.props.smSzt == 1 && __WEBPACK_IMPORTED_MODULE_5__util___default.a.regular1.test(this.props.paymentText) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this4.next();
                  }, style: { width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#fa063a", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 16, color: "#fff" } },
                  '\u4E0B\u4E00\u6B65'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: window.winWidth - 40, height: 44, borderRadius: 44, backgroundColor: "#D3D4D6", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 16, color: "#fff" } },
                  '\u4E0B\u4E00\u6B65'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginTop: 20, paddingLeft: 7, paddingRight: 7 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PayWarmTips__["a" /* default */], { buyType: 'SF', fundLimit: this.props.fundLimit })
            )
          )
        ),
        this.state.showRiskModal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u6E29\u99A8\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u6D3B\u671F\u901A\u3001\u95EA\u8D2D\u76F8\u5173\u670D\u52A1\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\uFF0C\u6839\u636E\u534E\u590F\u57FA\u91D1\u7684\u8BC4\u5206\u6807\u51C6\uFF0C\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E3A\uFF1AC1\u4FDD\u5B88\u578B\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u6839\u636E\u300A\u8BC1\u5238\u671F\u8D27\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u529E\u6CD5\u300B\u7684\u89C4\u5B9A\uFF0C\u60A8\u9002\u5408\u4EA4\u6613\u98CE\u9669\u7B49\u7EA7\u4E3AR1\u7684\u4EA7\u54C1\u3002',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 15, color: "#333", lineHeight: "20px", fontWeight: "bold" } },
                  '\u60A8\u5982\u679C\u786E\u5B9A\u8BA4\u540C\u6B64\u98CE\u9669\u7B49\u7EA7\u8BC4\u5B9A\uFF0C\u4E3A\u4E86\u964D\u4F4E\u60A8\u7684\u98CE\u9669\uFF0C\u6211\u4EEC\u5C06\u7EC8\u6B62\u60A8\u5728\u534E\u590F\u57FA\u91D1\u5DF2\u7ECF\u7B7E\u7EA6\u7684R1\u4EA7\u54C1\u4EE5\u5916\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\uFF0C\u5305\u62EC\u5B9A\u6295\u3001\u667A\u80FD\u8BA4\u8D2D\u3001\u5B9A\u671F\u8F6C\u6362\u7B49\u3002'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.resetRiskFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u91CD\u65B0\u6D4B\u8BC4'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.sameDataFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u786E\u8BA4'
                )
              )
            )
          )
        ) : null,
        this.state.unionPayTransformBool ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u6E29\u99A8\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u8D22\u5BCC\u5361\u652F\u4ED8\u65B9\u5F0F\u91D1\u989D\u4E0D\u5F97\u8D85\u8FC75000\u5143\uFF0C\u8BF7\u60A8\u9009\u62E9\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u6216\u4E0B\u8F7D\u534E\u590F\u8D22\u5BCCapp\u64CD\u4F5C'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.paymentMethod, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u4FEE\u6539\u652F\u4ED8\u65B9\u5F0F'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this4.setState({ unionPayTransformBool: false });
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u786E\u8BA4'
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return FixedInvestmentSuperFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    payInfoData: state.superFundDTPayInfo,
    paymentText: state.paymentTextDT,
    findHqtExist: state.findHqtExist,
    smSzt: state.smSzt
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(FixedInvestmentSuperFund));

/***/ }),
/* 1965 */,
/* 1966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FinancialPlanning_bg.d0ffbb47.png";

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c_hxcf_icon_youjiantou_10_grayss.ac39c8b9.png";

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eq_leftArrow1.0c06b575.png";

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/headerImg.767ae443.png";

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_gth.a92b32d9.png";

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconiantoushangsheng.a7ecb0bf.png";

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconjiantouxiajiang.b4becc27.png";

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  manager: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var Bezel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Bezel, _Component);

  function Bezel(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bezel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
    _this.timer = null;
    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      hidden: true,
      operation: {}
    };
    return _this;
  }

  (0, _createClass2["default"])(Bezel, [{
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      var _this2 = this;

      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
        if (this.timer) {
          // previous animation is not finished
          clearTimeout(this.timer); // cancel it

          this.timer = null;
        } // show it
        // update operation


        this.setState({
          hidden: false,
          count: state.count,
          operation: state.operation
        }); // hide it after 0.5s

        this.timer = setTimeout(function () {
          _this2.setState({
            hidden: true
          });

          _this2.timer = null;
        }, 500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // only displays for shortcut so far
      if (this.state.operation.source !== 'shortcut') {
        return null;
      }

      var style = this.state.hidden ? {
        display: 'none'
      } : null;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-bezel': true,
          'video-react-bezel-animation': this.state.count % 2 === 0,
          'video-react-bezel-animation-alt': this.state.count % 2 === 1
        }, this.props.className),
        style: style,
        role: "status",
        "aria-label": this.state.operation.action
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
      }));
    }
  }]);
  return Bezel;
}(_react.Component);

exports["default"] = Bezel;
Bezel.propTypes = propTypes;
Bezel.displayName = 'Bezel';

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  position: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  position: 'left'
};

var BigPlayButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(BigPlayButton, _Component);

  function BigPlayButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, BigPlayButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BigPlayButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "handleClick",
    value: function handleClick() {
      var actions = this.props.actions;
      actions.play();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          player = _this$props.player,
          position = _this$props.position;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])('video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
          'big-play-button-hide': player.hasStarted || !player.currentSrc
        }),
        type: "button",
        "aria-live": "polite",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Play Video"));
    }
  }]);
  return BigPlayButton;
}(_react.Component);

exports["default"] = BigPlayButton;
BigPlayButton.propTypes = propTypes;
BigPlayButton.defaultProps = defaultProps;
BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(433));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  tagName: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  tagName: 'div'
};

var ClickableComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClickableComponent, _Component);

  function ClickableComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClickableComponent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ClickableComponent, [{
    key: "handleKeypress",
    value: function handleKeypress(event) {
      // Support Space (32) or Enter (13) key operation to fire a click event
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var onClick = this.props.onClick;
      onClick(event);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeypress);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeypress);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Tag = this.props.tagName;
      var props = (0, _objectSpread2["default"])({}, this.props);
      delete props.tagName;
      delete props.className;
      return _react["default"].createElement(Tag, (0, _extends2["default"])({
        className: (0, _classnames["default"])(this.props.className),
        role: "button",
        tabIndex: "0",
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, props));
    }
  }]);
  return ClickableComponent;
}(_react.Component);

exports["default"] = ClickableComponent;
ClickableComponent.propTypes = propTypes;
ClickableComponent.defaultProps = defaultProps;
ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadingSpinner;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function LoadingSpinner(_ref) {
  var player = _ref.player,
      className = _ref.className;

  if (player.error) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-loading-spinner', className)
  });
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  poster: _propTypes["default"].string,
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function PosterImage(_ref) {
  var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;

  if (!poster || player.hasStarted) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-poster', className),
    style: {
      backgroundImage: "url(\"".concat(poster, "\")")
    },
    onClick: function onClick() {
      if (player.paused) {
        actions.play();
      }
    }
  });
}

PosterImage.propTypes = propTypes;
PosterImage.displayName = 'PosterImage';
var _default = PosterImage;
exports["default"] = _default;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(781));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1956));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _react = __webpack_require__(0);

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _dom = __webpack_require__(779);

var propTypes = {
  clickable: _propTypes["default"].bool,
  dblclickable: _propTypes["default"].bool,
  manager: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  shortcuts: _propTypes["default"].array
};
var defaultProps = {
  clickable: true,
  dblclickable: true
};

var Shortcut =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Shortcut, _Component);

  function Shortcut(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Shortcut);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
    _this.defaultShortcuts = [{
      keyCode: 32,
      // spacebar
      handle: _this.togglePlay
    }, {
      keyCode: 75,
      // k
      handle: _this.togglePlay
    }, {
      keyCode: 70,
      // f
      handle: _this.toggleFullscreen
    }, {
      keyCode: 37,
      // Left arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(5, {
          action: 'replay-5',
          source: 'shortcut'
        }); // Go back 5 seconds
      }
    }, {
      keyCode: 74,
      // j
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(10, {
          action: 'replay-10',
          source: 'shortcut'
        }); // Go back 10 seconds
      }
    }, {
      keyCode: 39,
      // Right arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(5, {
          action: 'forward-5',
          source: 'shortcut'
        }); // Go forward 5 seconds
      }
    }, {
      keyCode: 76,
      // l
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(10, {
          action: 'forward-10',
          source: 'shortcut'
        }); // Go forward 10 seconds
      }
    }, {
      keyCode: 36,
      // Home
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.seek(0); // Go to beginning of video
      }
    }, {
      keyCode: 35,
      // End
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        } // Go to end of video


        actions.seek(player.duration);
      }
    }, {
      keyCode: 38,
      // Up arrow
      handle: function handle(player, actions) {
        // Increase volume 5%
        var v = player.volume + 0.05;

        if (v > 1) {
          v = 1;
        }

        actions.changeVolume(v, {
          action: 'volume-up',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 40,
      // Down arrow
      handle: function handle(player, actions) {
        // Decrease volume 5%
        var v = player.volume - 0.05;

        if (v < 0) {
          v = 0;
        }

        var action = v > 0 ? 'volume-down' : 'volume-off';
        actions.changeVolume(v, {
          action: action,
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 190,
      // Shift + >
      shift: true,
      handle: function handle(player, actions) {
        // Increase speed
        var playbackRate = player.playbackRate;

        if (playbackRate >= 1.5) {
          playbackRate = 2;
        } else if (playbackRate >= 1.25) {
          playbackRate = 1.5;
        } else if (playbackRate >= 1.0) {
          playbackRate = 1.25;
        } else if (playbackRate >= 0.5) {
          playbackRate = 1.0;
        } else if (playbackRate >= 0.25) {
          playbackRate = 0.5;
        } else if (playbackRate >= 0) {
          playbackRate = 0.25;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-forward',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 188,
      // Shift + <
      shift: true,
      handle: function handle(player, actions) {
        // Decrease speed
        var playbackRate = player.playbackRate;

        if (playbackRate <= 0.5) {
          playbackRate = 0.25;
        } else if (playbackRate <= 1.0) {
          playbackRate = 0.5;
        } else if (playbackRate <= 1.25) {
          playbackRate = 1.0;
        } else if (playbackRate <= 1.5) {
          playbackRate = 1.25;
        } else if (playbackRate <= 2) {
          playbackRate = 1.5;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-rewind',
          source: 'shortcut'
        });
      }
    }];
    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Shortcut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mergeShortcuts();
      document.addEventListener('keydown', this.handleKeyPress);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('dblclick', this.handleDoubleClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.shortcuts !== this.props.shortcuts) {
        this.mergeShortcuts();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('dblclick', this.handleDoubleClick);
    } // merge the shortcuts from props

  }, {
    key: "mergeShortcuts",
    value: function mergeShortcuts() {
      var getShortcutKey = function getShortcutKey(_ref) {
        var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === void 0 ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? false : _ref$alt;
        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
      };

      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
      }, {});
      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
        var keyCode = shortcut.keyCode,
            handle = shortcut.handle;

        if (keyCode && typeof handle === 'function') {
          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
        }

        return shortcuts;
      }, defaultShortcuts);

      var gradeShortcut = function gradeShortcut(s) {
        var score = 0;
        var ps = ['ctrl', 'shift', 'alt'];
        ps.forEach(function (key) {
          if (s[key]) {
            score++;
          }
        });
        return score;
      };

      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
        return mergedShortcuts[key];
      }).sort(function (a, b) {
        return gradeShortcut(b) - gradeShortcut(a);
      });
    }
  }, {
    key: "togglePlay",
    value: function togglePlay(player, actions) {
      if (player.paused) {
        actions.play({
          action: 'play',
          source: 'shortcut'
        });
      } else {
        actions.pause({
          action: 'pause',
          source: 'shortcut'
        });
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(player, actions) {
      actions.toggleFullscreen(player);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (!player.isActive) {
        return;
      }

      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
        return;
      }

      var keyCode = e.keyCode || e.which;
      var ctrl = e.ctrlKey || e.metaKey;
      var shift = e.shiftKey;
      var alt = e.altKey;
      var shortcut = this.shortcuts.filter(function (s) {
        if (!s.keyCode || s.keyCode - keyCode !== 0) {
          return false;
        }

        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
          return false;
        }

        return true;
      })[0];

      if (shortcut) {
        shortcut.handle(player, actions);
        e.preventDefault();
      }
    } // only if player is active and player is ready

  }, {
    key: "canBeClicked",
    value: function canBeClicked(player, e) {
      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
        return false;
      }

      return true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          clickable = _this$props2.clickable;

      if (!this.canBeClicked(player, e) || !clickable) {
        return;
      }

      this.togglePlay(player, actions); // e.preventDefault();
    }
  }, {
    key: "handleDoubleClick",
    value: function handleDoubleClick(e) {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions,
          dblclickable = _this$props3.dblclickable;

      if (!this.canBeClicked(player, e) || !dblclickable) {
        return;
      }

      this.toggleFullscreen(player, actions); // e.preventDefault();
    } // this component dose not render anything
    // it's just for the key down event

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Shortcut;
}(_react.Component);

exports["default"] = Shortcut;
Shortcut.propTypes = propTypes;
Shortcut.defaultProps = defaultProps;
Shortcut.displayName = 'Shortcut';

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(198);

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  children: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  className: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  crossOrigin: _propTypes["default"].string,
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  onResize: _propTypes["default"].func
};

var Video =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Video, _Component);

  function Video(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Video);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
    _this.video = null; // the html5 video

    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate(); // make sure the children can get the video property

      if (this.video && this.video.textTracks) {
        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
      }
    } // get all video properties

  }, {
    key: "getProperties",
    value: function getProperties() {
      var _this2 = this;

      if (!this.video) {
        return null;
      }

      return _utils.mediaProperties.reduce(function (properties, key) {
        properties[key] = _this2.video[key];
        return properties;
      }, {});
    } // get playback rate

  }, {
    key: "handleTextTrackChange",
    value: function handleTextTrackChange() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (this.video && this.video.textTracks) {
        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
          return textTrack.mode === 'showing';
        });

        if (activeTextTrack !== player.activeTextTrack) {
          actions.activateTextTrack(activeTextTrack);
        }
      }
    } // play the video

  }, {
    key: "play",
    value: function play() {
      var promise = this.video.play();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      var promise = this.video.pause();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // toggle play

  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      try {
        this.video.currentTime = time;
      } catch (e) {// console.log(e, 'Video is not ready.')
      }
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.seek(this.video.currentTime + seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.forward(-seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      actions.toggleFullscreen(player);
    } // Fired when the user agent
    // begins looking for media data

  }, {
    key: "handleLoadStart",
    value: function handleLoadStart() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          onLoadStart = _this$props3.onLoadStart;
      actions.handleLoadStart(this.getProperties());

      if (onLoadStart) {
        onLoadStart.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlay",
    value: function handleCanPlay() {
      var _this$props4 = this.props,
          actions = _this$props4.actions,
          onCanPlay = _this$props4.onCanPlay;
      actions.handleCanPlay(this.getProperties());

      if (onCanPlay) {
        onCanPlay.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlayThrough",
    value: function handleCanPlayThrough() {
      var _this$props5 = this.props,
          actions = _this$props5.actions,
          onCanPlayThrough = _this$props5.onCanPlayThrough;
      actions.handleCanPlayThrough(this.getProperties());

      if (onCanPlayThrough) {
        onCanPlayThrough.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handlePlaying",
    value: function handlePlaying() {
      var _this$props6 = this.props,
          actions = _this$props6.actions,
          onPlaying = _this$props6.onPlaying;
      actions.handlePlaying(this.getProperties());

      if (onPlaying) {
        onPlaying.apply(void 0, arguments);
      }
    } // Fired whenever the media has been started

  }, {
    key: "handlePlay",
    value: function handlePlay() {
      var _this$props7 = this.props,
          actions = _this$props7.actions,
          onPlay = _this$props7.onPlay;
      actions.handlePlay(this.getProperties());

      if (onPlay) {
        onPlay.apply(void 0, arguments);
      }
    } // Fired whenever the media has been paused

  }, {
    key: "handlePause",
    value: function handlePause() {
      var _this$props8 = this.props,
          actions = _this$props8.actions,
          onPause = _this$props8.onPause;
      actions.handlePause(this.getProperties());

      if (onPause) {
        onPause.apply(void 0, arguments);
      }
    } // Fired when the duration of
    // the media resource is first known or changed

  }, {
    key: "handleDurationChange",
    value: function handleDurationChange() {
      var _this$props9 = this.props,
          actions = _this$props9.actions,
          onDurationChange = _this$props9.onDurationChange;
      actions.handleDurationChange(this.getProperties());

      if (onDurationChange) {
        onDurationChange.apply(void 0, arguments);
      }
    } // Fired while the user agent
    // is downloading media data

  }, {
    key: "handleProgress",
    value: function handleProgress() {
      var _this$props10 = this.props,
          actions = _this$props10.actions,
          onProgress = _this$props10.onProgress;

      if (this.video) {
        actions.handleProgressChange(this.getProperties());
      }

      if (onProgress) {
        onProgress.apply(void 0, arguments);
      }
    } // Fired when the end of the media resource
    // is reached (currentTime == duration)

  }, {
    key: "handleEnded",
    value: function handleEnded() {
      var _this$props11 = this.props,
          loop = _this$props11.loop,
          player = _this$props11.player,
          actions = _this$props11.actions,
          onEnded = _this$props11.onEnded;

      if (loop) {
        this.seek(0);
        this.play();
      } else if (!player.paused) {
        this.pause();
      }

      actions.handleEnd(this.getProperties());

      if (onEnded) {
        onEnded.apply(void 0, arguments);
      }
    } // Fired whenever the media begins waiting

  }, {
    key: "handleWaiting",
    value: function handleWaiting() {
      var _this$props12 = this.props,
          actions = _this$props12.actions,
          onWaiting = _this$props12.onWaiting;
      actions.handleWaiting(this.getProperties());

      if (onWaiting) {
        onWaiting.apply(void 0, arguments);
      }
    } // Fired whenever the player
    // is jumping to a new time

  }, {
    key: "handleSeeking",
    value: function handleSeeking() {
      var _this$props13 = this.props,
          actions = _this$props13.actions,
          onSeeking = _this$props13.onSeeking;
      actions.handleSeeking(this.getProperties());

      if (onSeeking) {
        onSeeking.apply(void 0, arguments);
      }
    } // Fired when the player has
    // finished jumping to a new time

  }, {
    key: "handleSeeked",
    value: function handleSeeked() {
      var _this$props14 = this.props,
          actions = _this$props14.actions,
          onSeeked = _this$props14.onSeeked;
      actions.handleSeeked(this.getProperties());

      if (onSeeked) {
        onSeeked.apply(void 0, arguments);
      }
    } // Handle Fullscreen Change

  }, {
    key: "handleFullscreenChange",
    value: function handleFullscreenChange() {} // Fires when the browser is
    // intentionally not getting media data

  }, {
    key: "handleSuspend",
    value: function handleSuspend() {
      var _this$props15 = this.props,
          actions = _this$props15.actions,
          onSuspend = _this$props15.onSuspend;
      actions.handleSuspend(this.getProperties());

      if (onSuspend) {
        onSuspend.apply(void 0, arguments);
      }
    } // Fires when the loading of an audio/video is aborted

  }, {
    key: "handleAbort",
    value: function handleAbort() {
      var _this$props16 = this.props,
          actions = _this$props16.actions,
          onAbort = _this$props16.onAbort;
      actions.handleAbort(this.getProperties());

      if (onAbort) {
        onAbort.apply(void 0, arguments);
      }
    } // Fires when the current playlist is empty

  }, {
    key: "handleEmptied",
    value: function handleEmptied() {
      var _this$props17 = this.props,
          actions = _this$props17.actions,
          onEmptied = _this$props17.onEmptied;
      actions.handleEmptied(this.getProperties());

      if (onEmptied) {
        onEmptied.apply(void 0, arguments);
      }
    } // Fires when the browser is trying to
    // get media data, but data is not available

  }, {
    key: "handleStalled",
    value: function handleStalled() {
      var _this$props18 = this.props,
          actions = _this$props18.actions,
          onStalled = _this$props18.onStalled;
      actions.handleStalled(this.getProperties());

      if (onStalled) {
        onStalled.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // meta data for the audio/video

  }, {
    key: "handleLoadedMetaData",
    value: function handleLoadedMetaData() {
      var _this$props19 = this.props,
          actions = _this$props19.actions,
          onLoadedMetadata = _this$props19.onLoadedMetadata,
          startTime = _this$props19.startTime;

      if (startTime && startTime > 0) {
        this.video.currentTime = startTime;
      }

      actions.handleLoadedMetaData(this.getProperties());

      if (onLoadedMetadata) {
        onLoadedMetadata.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // the current frame of the audio/video

  }, {
    key: "handleLoadedData",
    value: function handleLoadedData() {
      var _this$props20 = this.props,
          actions = _this$props20.actions,
          onLoadedData = _this$props20.onLoadedData;
      actions.handleLoadedData(this.getProperties());

      if (onLoadedData) {
        onLoadedData.apply(void 0, arguments);
      }
    } // Fires when the current
    // playback position has changed

  }, {
    key: "handleTimeUpdate",
    value: function handleTimeUpdate() {
      var _this$props21 = this.props,
          actions = _this$props21.actions,
          onTimeUpdate = _this$props21.onTimeUpdate;
      actions.handleTimeUpdate(this.getProperties());

      if (onTimeUpdate) {
        onTimeUpdate.apply(void 0, arguments);
      }
    }
    /**
     * Fires when the playing speed of the audio/video is changed
     */

  }, {
    key: "handleRateChange",
    value: function handleRateChange() {
      var _this$props22 = this.props,
          actions = _this$props22.actions,
          onRateChange = _this$props22.onRateChange;
      actions.handleRateChange(this.getProperties());

      if (onRateChange) {
        onRateChange.apply(void 0, arguments);
      }
    } // Fires when the volume has been changed

  }, {
    key: "handleVolumeChange",
    value: function handleVolumeChange() {
      var _this$props23 = this.props,
          actions = _this$props23.actions,
          onVolumeChange = _this$props23.onVolumeChange;
      actions.handleVolumeChange(this.getProperties());

      if (onVolumeChange) {
        onVolumeChange.apply(void 0, arguments);
      }
    } // Fires when an error occurred
    // during the loading of an audio/video

  }, {
    key: "handleError",
    value: function handleError() {
      var _this$props24 = this.props,
          actions = _this$props24.actions,
          onError = _this$props24.onError;
      actions.handleError(this.getProperties());

      if (onError) {
        onError.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$props25 = this.props,
          actions = _this$props25.actions,
          onResize = _this$props25.onResize;
      actions.handleResize(this.getProperties());

      if (onResize) {
        onResize.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleKeypress",
    value: function handleKeypress() {}
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;

      var props = (0, _objectSpread2["default"])({}, this.props, {
        video: this.video
      }); // to make sure the children can get video property

      if (!this.video) {
        return null;
      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements


      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
        var cprops;

        if (typeof c.type === 'string') {
          // add onError to <source />
          if (c.type === 'source') {
            cprops = (0, _objectSpread2["default"])({}, c.props);
            var preOnError = cprops.onError;

            cprops.onError = function () {
              if (preOnError) {
                preOnError.apply(void 0, arguments);
              }

              _this3.handleError.apply(_this3, arguments);
            };
          }
        } else {
          cprops = props;
        }

        return _react["default"].cloneElement(c, cprops);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props26 = this.props,
          loop = _this$props26.loop,
          poster = _this$props26.poster,
          preload = _this$props26.preload,
          src = _this$props26.src,
          autoPlay = _this$props26.autoPlay,
          playsInline = _this$props26.playsInline,
          muted = _this$props26.muted,
          crossOrigin = _this$props26.crossOrigin,
          videoId = _this$props26.videoId;
      return _react["default"].createElement("video", {
        className: (0, _classnames["default"])('video-react-video', this.props.className),
        id: videoId,
        crossOrigin: crossOrigin,
        ref: function ref(c) {
          _this4.video = c;
        },
        muted: muted,
        preload: preload,
        loop: loop,
        playsInline: playsInline,
        autoPlay: autoPlay,
        poster: poster,
        src: src,
        onLoadStart: this.handleLoadStart,
        onWaiting: this.handleWaiting,
        onCanPlay: this.handleCanPlay,
        onCanPlayThrough: this.handleCanPlayThrough,
        onPlaying: this.handlePlaying,
        onEnded: this.handleEnded,
        onSeeking: this.handleSeeking,
        onSeeked: this.handleSeeked,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onProgress: this.handleProgress,
        onDurationChange: this.handleDurationChange,
        onError: this.handleError,
        onSuspend: this.handleSuspend,
        onAbort: this.handleAbort,
        onEmptied: this.handleEmptied,
        onStalled: this.handleStalled,
        onLoadedMetadata: this.handleLoadedMetaData,
        onLoadedData: this.handleLoadedData,
        onTimeUpdate: this.handleTimeUpdate,
        onRateChange: this.handleRateChange,
        onVolumeChange: this.handleVolumeChange,
        tabIndex: "-1"
      }, this.renderChildren());
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      if (val > 1) {
        val = 1;
      }

      if (val < 0) {
        val = 0;
      }

      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Video;
}(_react.Component);

exports["default"] = Video;
Video.propTypes = propTypes;
Video.displayName = 'Video';

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(782));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _ProgressControl = _interopRequireDefault(__webpack_require__(1992));

var _PlayToggle = _interopRequireDefault(__webpack_require__(1991));

var _ForwardControl = _interopRequireDefault(__webpack_require__(1985));

var _ReplayControl = _interopRequireDefault(__webpack_require__(1993));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(1987));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(1998));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(1996));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(1997));

var _TimeDivider = _interopRequireDefault(__webpack_require__(1999));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(1995));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(1907));

var _utils = __webpack_require__(198);

var propTypes = {
  children: _propTypes["default"].any,
  autoHide: _propTypes["default"].bool,
  autoHideTime: _propTypes["default"].number,
  // used in Player
  disableDefaultControls: _propTypes["default"].bool,
  disableCompletely: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  autoHide: true,
  disableCompletely: false
};

var ControlBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ControlBar, _Component);

  function ControlBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ControlBar, [{
    key: "getDefaultChildren",
    value: function getDefaultChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5.1
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 5.2
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 5.3
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 6
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 8
      })];
    }
  }, {
    key: "getFullChildren",
    value: function getFullChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_ReplayControl["default"], {
        key: "replay-control",
        order: 2
      }), _react["default"].createElement(_ForwardControl["default"], {
        key: "forward-control",
        order: 3
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 6
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 7
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 8
      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
        key: "remaining-time-display",
        order: 9
      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
        rates: [1, 1.25, 1.5, 2],
        key: "playback-rate",
        order: 10
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 11
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = _react["default"].Children.toArray(this.props.children);

      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
      var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className

      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoHide = _this$props2.autoHide,
          className = _this$props2.className,
          disableCompletely = _this$props2.disableCompletely;
      var children = this.getChildren();
      return disableCompletely ? null : _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-control-bar', {
          'video-react-control-bar-auto-hide': autoHide
        }, className)
      }, children);
    }
  }]);
  return ControlBar;
}(_react.Component);

exports["default"] = ControlBar;
ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(1986));

// Pass mode into parent function
var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
ForwardControl.displayName = 'ForwardControl';
var _default = ForwardControl;
exports["default"] = _default;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  seconds: _propTypes["default"].oneOf([5, 10, 30])
};
var defaultProps = {
  seconds: 10
};

var _default = function _default(mode) {
  var ForwardReplayControl =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(ForwardReplayControl, _Component);

    function ForwardReplayControl(props, context) {
      var _this;

      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    (0, _createClass2["default"])(ForwardReplayControl, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
            actions = _this$props.actions,
            seconds = _this$props.seconds; // Depends mode to implement different actions

        if (mode === 'forward') {
          actions.forward(seconds);
        } else {
          actions.replay(seconds);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            seconds = _this$props2.seconds,
            className = _this$props2.className;
        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));

        if (className) {
          classNames.push(className);
        }

        return _react["default"].createElement("button", {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: classNames.join(' '),
          type: "button",
          onClick: this.handleClick
        }, _react["default"].createElement("span", {
          className: "video-react-control-text"
        }, "".concat(mode, " ").concat(seconds, " seconds")));
      }
    }]);
    return ForwardReplayControl;
  }(_react.Component);

  ForwardReplayControl.propTypes = propTypes;
  ForwardReplayControl.defaultProps = defaultProps;
  return ForwardReplayControl;
};

exports["default"] = _default;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var FullscreenToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FullscreenToggle, _Component);

  function FullscreenToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, FullscreenToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(FullscreenToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.toggleFullscreen(player);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])(className, {
          'video-react-icon-fullscreen-exit': player.isFullscreen,
          'video-react-icon-fullscreen': !player.isFullscreen
        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
        ref: function ref(c) {
          _this2.button = c;
        },
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Non-Fullscreen"));
    }
  }]);
  return FullscreenToggle;
}(_react.Component);

exports["default"] = FullscreenToggle;
FullscreenToggle.propTypes = propTypes;
FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  duration: _propTypes["default"].number,
  buffered: _propTypes["default"].object,
  className: _propTypes["default"].string
}; // Shows load progress

function LoadProgressBar(_ref) {
  var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;

  if (!buffered || !buffered.length) {
    return null;
  }

  var bufferedEnd = buffered.end(buffered.length - 1);
  var style = {};

  if (bufferedEnd > duration) {
    bufferedEnd = duration;
  } // get the percent width of a time compared to the total end


  function percentify(time, end) {
    var percent = time / end || 0; // no NaN

    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
  } // the width of the progress bar


  style.width = percentify(bufferedEnd, duration);
  var parts = []; // add child elements to represent the individual buffered time ranges

  for (var i = 0; i < buffered.length; i++) {
    var start = buffered.start(i);
    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)

    var part = _react["default"].createElement("div", {
      style: {
        left: percentify(start, bufferedEnd),
        width: percentify(end - start, bufferedEnd)
      },
      key: "part-".concat(i)
    });

    parts.push(part);
  }

  if (parts.length === 0) {
    parts = null;
  }

  return _react["default"].createElement("div", {
    style: style,
    className: (0, _classnames["default"])('video-react-load-progress', className)
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Loaded: 0%"), parts);
}

LoadProgressBar.propTypes = propTypes;
LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(198);

function MouseTimeDisplay(_ref) {
  var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;

  if (!mouseTime.time) {
    return null;
  }

  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-mouse-display', className),
    style: {
      left: "".concat(mouseTime.position, "px")
    },
    "data-current-time": time
  });
}

MouseTimeDisplay.propTypes = {
  duration: _propTypes["default"].number,
  mouseTime: _propTypes["default"].object,
  className: _propTypes["default"].string
};
MouseTimeDisplay.displayName = 'MouseTimeDisplay';
var _default = MouseTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PlayProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(198);

var propTypes = {
  currentTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  percentage: _propTypes["default"].string,
  className: _propTypes["default"].string
}; // Shows play progress

function PlayProgressBar(_ref) {
  var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;
  return _react["default"].createElement("div", {
    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
    style: {
      width: percentage
    }
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Progress: ".concat(percentage)));
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var PlayToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlayToggle, _Component);

  function PlayToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlayToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlayToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (player.paused) {
        actions.play();
      } else {
        actions.pause();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      var controlText = player.paused ? 'Play' : 'Pause';
      return _react["default"].createElement("button", {
        ref: function ref(c) {
          _this2.button = c;
        },
        className: (0, _classnames["default"])(className, {
          'video-react-play-control': true,
          'video-react-control': true,
          'video-react-button': true,
          'video-react-paused': player.paused,
          'video-react-playing': !player.paused
        }),
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, controlText));
    }
  }]);
  return PlayToggle;
}(_react.Component);

exports["default"] = PlayToggle;
PlayToggle.propTypes = propTypes;
PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(433));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var Dom = _interopRequireWildcard(__webpack_require__(779));

var _SeekBar = _interopRequireDefault(__webpack_require__(1994));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var ProgressControl =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ProgressControl, _Component);

  function ProgressControl(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ProgressControl);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
    _this.state = {
      mouseTime: {
        time: null,
        position: 0
      }
    };
    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ProgressControl, [{
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (!event.pageX) {
        return;
      }

      var duration = this.props.player.duration;
      var node = this.seekBar;
      var newTime = Dom.getPointerPosition(node, event).x * duration;
      var position = event.pageX - Dom.findElPosition(node).left;
      this.setState({
        mouseTime: {
          time: newTime,
          position: position
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      return _react["default"].createElement("div", {
        onMouseMove: this.handleMouseMoveThrottle,
        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
        mouseTime: this.state.mouseTime,
        ref: function ref(c) {
          _this2.seekBar = c;
        }
      }, this.props)));
    }
  }]);
  return ProgressControl;
}(_react.Component);

exports["default"] = ProgressControl;
ProgressControl.propTypes = propTypes;
ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(1986));

// Pass mode into parent function
var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
ReplayControl.displayName = 'ReplayControl';
var _default = ReplayControl;
exports["default"] = _default;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _Slider = _interopRequireDefault(__webpack_require__(1906));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(1990));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(1988));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(1989));

var _utils = __webpack_require__(198);

var propTypes = {
  player: _propTypes["default"].object,
  mouseTime: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var SeekBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SeekBar, _Component);

  function SeekBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, SeekBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SeekBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
    /**
     * Get percentage of video played
     *
     * @return {Number} Percentage played
     * @method getPercent
     */

  }, {
    key: "getPercent",
    value: function getPercent() {
      var _this$props$player = this.props.player,
          currentTime = _this$props$player.currentTime,
          seekingTime = _this$props$player.seekingTime,
          duration = _this$props$player.duration;
      var time = seekingTime || currentTime;
      var percent = time / duration;
      return percent >= 1 ? 1 : percent;
    }
  }, {
    key: "getNewTime",
    value: function getNewTime(event) {
      var duration = this.props.player.duration;
      var distance = this.slider.calculateDistance(event);
      var newTime = distance * duration; // Don't let video end while scrubbing.

      return newTime === duration ? newTime - 0.1 : newTime;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {}
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)

      actions.seek(newTime);
      actions.handleEndSeeking(newTime);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event);
      actions.handleSeekingTime(newTime);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var actions = this.props.actions;
      actions.forward(5);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var actions = this.props.actions;
      actions.replay(5);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$player2 = _this$props.player,
          currentTime = _this$props$player2.currentTime,
          seekingTime = _this$props$player2.seekingTime,
          duration = _this$props$player2.duration,
          buffered = _this$props$player2.buffered,
          mouseTime = _this$props.mouseTime;
      var time = seekingTime || currentTime;
      return _react["default"].createElement(_Slider["default"], {
        ref: function ref(input) {
          _this2.slider = input;
        },
        label: "video progress bar",
        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
        valuenow: (this.getPercent() * 100).toFixed(2),
        valuetext: (0, _utils.formatTime)(time, duration),
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        getPercent: this.getPercent,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, _react["default"].createElement(_LoadProgressBar["default"], {
        buffered: buffered,
        currentTime: time,
        duration: duration
      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
        duration: duration,
        mouseTime: mouseTime
      }), _react["default"].createElement(_PlayProgressBar["default"], {
        currentTime: time,
        duration: duration
      }));
    }
  }]);
  return SeekBar;
}(_react.Component);

exports["default"] = SeekBar;
SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(433));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _PopupButton = _interopRequireDefault(__webpack_require__(2197));

var _VolumeBar = _interopRequireDefault(__webpack_require__(2198));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  alwaysShowVolume: _propTypes["default"].bool
};
var defaultProps = {
  vertical: false
};

var VolumeMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeMenuButton, _Component);

  function VolumeMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
    _this.state = {
      active: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeMenuButton, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.mute(!player.muted);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        active: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          player = _this$props2.player,
          className = _this$props2.className;
      var inline = !vertical;
      var level = this.volumeLevel;
      return _react["default"].createElement(_PopupButton["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-volume-menu-button-vertical': vertical,
          'video-react-volume-menu-button-horizontal': !vertical,
          'video-react-vol-muted': player.muted,
          'video-react-vol-0': level === 0 && !player.muted,
          'video-react-vol-1': level === 1,
          'video-react-vol-2': level === 2,
          'video-react-vol-3': level === 3,
          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
        }, 'video-react-volume-menu-button'),
        onClick: this.handleClick,
        inline: inline
      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props)));
    }
  }, {
    key: "volumeLevel",
    get: function get() {
      var _this$props$player = this.props.player,
          volume = _this$props$player.volume,
          muted = _this$props$player.muted;
      var level = 3;

      if (volume === 0 || muted) {
        level = 0;
      } else if (volume < 0.33) {
        level = 1;
      } else if (volume < 0.67) {
        level = 2;
      }

      return level;
    }
  }]);
  return VolumeMenuButton;
}(_react.Component);

VolumeMenuButton.propTypes = propTypes;
VolumeMenuButton.defaultProps = defaultProps;
VolumeMenuButton.displayName = 'VolumeMenuButton';
var _default = VolumeMenuButton;
exports["default"] = _default;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(198);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function CurrentTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-current-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Current Time "), formattedTime));
}

CurrentTimeDisplay.propTypes = propTypes;
CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
var _default = CurrentTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(198);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function DurationDisplay(_ref) {
  var duration = _ref.player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
  }, _react["default"].createElement("div", {
    className: "video-react-duration-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Duration Time "), formattedTime));
}

DurationDisplay.propTypes = propTypes;
DurationDisplay.displayName = 'DurationDisplay';
var _default = DurationDisplay;
exports["default"] = _default;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _utils = __webpack_require__(198);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function RemainingTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var remainingTime = duration - currentTime;
  var formattedTime = (0, _utils.formatTime)(remainingTime);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-remaining-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Remaining Time "), "-".concat(formattedTime)));
}

RemainingTimeDisplay.propTypes = propTypes;
RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
var _default = RemainingTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TimeDivider;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  separator: _propTypes["default"].string,
  className: _propTypes["default"].string
};

function TimeDivider(_ref) {
  var separator = _ref.separator,
      className = _ref.className;
  var separatorText = separator || '/';
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
    dir: "ltr"
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
}

TimeDivider.propTypes = propTypes;
TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.operationReducer = exports.playerReducer = void 0;

var _player = _interopRequireDefault(__webpack_require__(2202));

var _operation = _interopRequireDefault(__webpack_require__(2201));

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    player: (0, _player["default"])(state.player, action),
    operation: (0, _operation["default"])(state.operation, action)
  };
}

var playerReducer = _player["default"];
exports.playerReducer = playerReducer;
var operationReducer = _operation["default"];
exports.operationReducer = operationReducer;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var Fullscreen =
/*#__PURE__*/
function () {
  function Fullscreen() {
    (0, _classCallCheck2["default"])(this, Fullscreen);
  }

  (0, _createClass2["default"])(Fullscreen, [{
    key: "request",
    value: function request(elm) {
      if (elm.requestFullscreen) {
        elm.requestFullscreen();
      } else if (elm.webkitRequestFullscreen) {
        elm.webkitRequestFullscreen();
      } else if (elm.mozRequestFullScreen) {
        elm.mozRequestFullScreen();
      } else if (elm.msRequestFullscreen) {
        elm.msRequestFullscreen();
      }
    }
  }, {
    key: "exit",
    value: function exit() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(handler) {
      document.addEventListener('fullscreenchange', handler);
      document.addEventListener('webkitfullscreenchange', handler);
      document.addEventListener('mozfullscreenchange', handler);
      document.addEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(handler) {
      document.removeEventListener('fullscreenchange', handler);
      document.removeEventListener('webkitfullscreenchange', handler);
      document.removeEventListener('mozfullscreenchange', handler);
      document.removeEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "isFullscreen",
    get: function get() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }
  }, {
    key: "enabled",
    get: function get() {
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }
  }]);
  return Fullscreen;
}();

var _default = new Fullscreen();

exports["default"] = _default;

/***/ }),
/* 2002 */,
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_css__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_dist_antd_mobile_css__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_dist_antd_mobile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_dist_antd_mobile_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_video_react_dist_video_react_css__ = __webpack_require__(2132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_video_react_dist_video_react_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_video_react_dist_video_react_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppGJ__ = __webpack_require__(2016);







if (navigator.userAgent.indexOf("amcfmapp") > -1) {
  window.isLess47 = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || navigator.userAgent.indexOf('Chrome') == -1 ? true : navigator.userAgent.match(/Chrome\/([\d.]+)/)[1] >= '47';
} else {
  window.isLess47 = true;
}
window.winWidth = document.documentElement.clientWidth;
window.winHeight = document.documentElement.clientHeight;
// window.navigator.userAgent = navigator.userAgent.toLowerCase();
window.funSplit = function (str) {
  if (str) {
    if (str.includes("暂不支持该行扣款")) {
      var _str = str.replace(/暂不支持该行扣款/, "该银行暂不支持扣款，建议使用活期通支付");
      return _str.split("|");
    }
    return str.split("|");
  } else {
    return ['', ''];
  }
};
window.clearLocalStorage = function () {
  window.localStorage.removeItem('currentUserInfo');
  window.localStorage.removeItem('loginInfo-longToken');
  window.localStorage.removeItem('loginInfo-shortToken');
  window.localStorage.removeItem('loginState');
  window.localStorage.removeItem('tokenTimeLong');
  window.localStorage.removeItem('tokenTimeshort');
  window.localStorage.removeItem('amcuid2');
};
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AppGJ__["a" /* default */], null), document.getElementById('root'));

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(1954);
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(2008);

function _defineProperty(e, r, t) {
  return (r = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(2005);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPrimitive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(1955);

function toPrimitive(t, r) {
  if ("object" != __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPropertyKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(2007);


function toPropertyKey(t) {
  var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : i + "";
}


/***/ }),
/* 2009 */
/***/ (function(module, exports) {

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

function _setPrototypeOf(t, e) {
  return (module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(720)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(1954);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2015 */,
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading_css__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Investment_css__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Investment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Investment_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loading_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ReduxStore_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Investment__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Transfer__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sync_BindingMobile__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pubQuestion_QuestionnaireList__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pubQuestion_FinishQuestionnaireSuccess__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pubQuestion_HighestRiskPoint__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AddCard__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_AddPhone__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Verification__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_recommend_Recommend_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_recommend_KnowMore_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_recommend_Encyclopedia_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_recommend_EncyclopediaDetail_js__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_recommend_RecoQuestionDoing_js__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_recommend_RecoQuestionFinish_js__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_recommend_PensionCalculator_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_recommend_PensionCalculatorResult_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_recommend_PensionCalculatorPlan_js__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_recommend_EducationCalculatorSelectSchool_js__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_recommend_EducationCalculator_js__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_recommend_EducationCalculatorResult_js__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_recommend_EducationCalculatorPlan_js__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_recommend_CertificationCard_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_recommend_CertificationUpload_js__ = __webpack_require__(2130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_recommend_CertiUpload_js__ = __webpack_require__(2129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_recommend_ChangTime_js__ = __webpack_require__(2131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_recommend_CertificationCardAgain_js__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_recommend_CertificationSetPhone_js__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_recommend_CertificationCheckPhone_js__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_recommend_CertificationSetPassWord_js__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_PaymentSuperFund__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_PaymentAllSuperFund__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_myAssets_payment_FixedInvestmentSuperFund_js__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_myAssets_payment_FixedInvestmentSuperFundChange_js__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_RedeemSuperFund__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_RedeemCurrencyList__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_RedeemBankList__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Success__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Error__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_myAssets_payment_PayCardList__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_myAssets_payment_HqtCardList__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_WebView__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_fundDetail_SuperFundList__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_fundDetail_TransactionRecord__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_fundDetail_OperationRecord__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_fundDetail_Configuration__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_fundDetail_TaxInfo__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_fundDetail_TransactionDetail__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Login__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Loginkah__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_LoginHxcf__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_login_UserBindingMobile__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_login_HxjjBindingMobile__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_login_Register__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_login_ForgetPassword__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_login_VerifyDynamicCode__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_login_VerifyDynamicCodeSec__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_login_SetNewPassword__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_fundDetail_TransitRecords__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_fundDetail_TransitHistory__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_fundDetail_TransitHistoryDetial__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_fundDetail_TaxSuccess__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_NullView_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_AnimationView_js__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_product_HistoryProfit__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_product_ChooseTime__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__action_riskInPayAction__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_login_InviteRegister__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_myAssets_investPlan_InvestmentPlan_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_myAssets_investPlan_InvestmentDetail_js__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_myAssets_investPlan_InvestmentFund_js__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_myAssets_investPlan_InvestmentRecord_js__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_myAssets_investPlan_SerchInvestment_js__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_myAssets_queryServices_TransactionRecordProduct__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_myAssets_payment_Payment_js__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_myAssets_payment_RechargeHqt_js__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_SubscriptionDetail__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_SubscriptionDetailTwo__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_ReservationsManager__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Answer__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_AnswerPage__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_AnswerActivityPage__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_AnswerActivityDatillPage__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_PrivacyAgreement__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_product_ConsultationDetails_js__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_SuperFundSigning__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_TransferF__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_fundDetail_SuperRate__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_fundDetail_ChooseGh__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Modal_ModalProtocol__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Understand__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_iframeWeb__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_fundDetail_Transactionrecordztgz__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_fundDetail_Fuwuqimingxi__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_fundDetail_Feiyongxiangqing__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_fundDetail_Transferrecord__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_fundDetail_Transferinrecord__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_fundDetail_Dividendreinvestedincash__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_fundDetail_Servicechargerecord__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_fundDetail_Detailsofwarehouseadjustment__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_myAssets_myCard_CurrentDemand__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_recommend_AddCertificationCard_js__ = __webpack_require__(2128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_fundDetail_ModifyTaxInfo__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_myAssets_myCard_HqtAddCard__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_myAssets_myCard_HqtBindCard__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_myAssets_myCard_HqtCheckCard__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_myAssets_myCard_HqtSuccess__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_TargetFundsList__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_fundDetail_TargetProfitDetail__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_fundDetail_TargetProfitHaveCast__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_fundDetail_HistoryPerformance__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_fundDetail_SuperFundDetail__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_fundDetail_PortfolioPerformance__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_fundDetail_BaoGao__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_fundDetail_JaoYi__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_fundDetail_FeiL__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_fundDetail_PositionDetails__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_fundDetail_ChangeFundList__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_fundDetail_ChangeFundDetail__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_fundDetail_ServiceReport__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_fundDetail_ServiceReportDetail__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_fundDetail_PositionDetailsHaveCast__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_product_Details_PublicOffering_js__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_fundDetail_SuperFundDetailHaveCast__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_fundDetail_MakePlanDetail__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_fundDetail_MakePlanResult__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_product_Details_NewPublicOffering_js__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_guidePage_imgPage_js__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_guidePage__ = __webpack_require__(59);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











































































 /*智投历史收益查询*/
 /*自选周期*/


//个人资产文件夹





 /*产品交易记录*/






















//智投重构交易记录


















//止盈组合详情
















//公募详情


//规划答题

//规划结果页

//新公募详情




window.historyData = [];
var uMeng = function uMeng(nextState, action) {
  var enterType = __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.return_enterType;
  var title = "";
  try {
    switch (nextState.location.pathname) {
      case "/PaymentSuperFund":
        title = "超级基金（在线支付）";
        break;
      case "/RedeemSuperFund":
        title = "超级基金赎回";
        break;
      case "/LoginHxjj":
        title = "华夏基金账号登录";
        break;
      case "/RedeemBankList":
        title = "选择赎回渠道";
        break;
      case "/WebView":
        title = nextState.location.state.name;
        break;
      case "/AddCard":
        title = "添加银行卡输入银行卡号页面";
        break;
      case "/AddPhone":
        title = "添加银行卡输入手机号页面";
        break;
      case "/Verification":
        title = "添加银行卡短信验证码页";
        break;
      case "/PayCardList":
        title = "选择支付方式";
        break;
      case "/Success":
        title = nextState.location.state.title;
        break;
      case "/ErrorResult":
        title = nextState.location.state.title;
        break;
      case "/QuestionnaireList":
        title = "问卷题目列表页";
        break;
      case "/FinishQuestionnaireSuccess":
        title = "问卷成功页面";
        break;
      case "/Transfer":
        title = "调仓页面";
        break;
      case "/TaxInfo":
        title = "税收页面";
        break;
      case "/HighestRiskPoint":
        title = "特高风险页";
        break;
      case "/FixedInvestmentSuperFund":
        title = "超级基金(定投)";
        break;
    }
    window._czc.push(["_trackEvent", enterType, title, action]);
  } catch (e) {}
};
var outFun = function outFun(nextState, replaceState) {
  uMeng(nextState, "离开");
  console.log(nextState);
  if (window.historyData.indexOf(window.location.hash) >= 0) {
    window.historyData.splice(window.historyData.indexOf(window.location.hash));
    sessionStorage.setItem("app_index", window.historyData); //没存储过 存储APP首页的位置
  }
  __WEBPACK_IMPORTED_MODULE_7__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_76__action_riskInPayAction__["a" /* setPayLoading */])(false));
  __WEBPACK_IMPORTED_MODULE_5__Loading_js__["a" /* default */].hide();
};
var enterFun = function enterFun(nextState, replaceState) {
  if ((nextState.location.pathname == "PaymentAllSuperFund" || nextState.location.pathname == "/PaymentAllSuperFund") && nextState.location.action == "PUSH") {
    var sess = sessionStorage.getItem("modalShowByTip");
    if (sess) {
      var arr = sess.split(",");
      if (arr.indexOf("zxzf_zt") != -1) {
        arr.splice(arr.indexOf("zxzf_zt"), 1);
        sessionStorage.setItem("modalShowByTip", arr.join());
      }
    }
    sessionStorage.setItem("activeByPaymentAllSuperFund", "");
  }
  if ((nextState.location.pathname == "TransferF" || nextState.location.pathname == "/TransferF") && nextState.location.action == "PUSH") {
    var _sess = sessionStorage.getItem("modalShowByTip");
    if (_sess) {
      var _arr = _sess.split(",");
      if (_arr.indexOf("zh_zt") != -1) {
        _arr.splice(_arr.indexOf("zh_zt"), 1);
        sessionStorage.setItem("modalShowByTip", _arr.join());
      }
    }
  }
  if (nextState.location.pathname == "/") {
    sessionStorage.setItem("home_url", window.location.hash);
  }
  var ua = navigator.userAgent.toLowerCase();
  uMeng(nextState, "进入");
  window.scrollTo(1, 0);
  if (ua.indexOf("amcfmapp") == -1) {
    //判断是否不是App进入
    if (sessionStorage.getItem("app_index") == null) {
      //判断是否是第一次进入页面，没存储代表第一次进入
      window.clearLocalStorage(); //清楚缓存
      if (window.location.hash != "#/" && window.location.hash.indexOf("enterType") == -1 && window.location.hash.indexOf("venderType") == -1) {
        //回到首页
        window.historyData = ["#/"]; //路由初始化
        __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].replace({
          pathname: "/"
        });
      } else {
        window.historyData.push(window.location.hash);
      }
      sessionStorage.setItem("app_index", window.historyData);
    } else {
      var old = sessionStorage.getItem("app_index").split(",");
      if (old[old.length - 1] == window.location.hash) {
        //刷新浏览器判断 同一个url代表刷新
        window.historyData = old; //存入缓存
      } else {
        if (window.historyData.indexOf(window.location.hash) < 0) {
          window.historyData.push(window.location.hash);
          sessionStorage.setItem("app_index", window.historyData);
        }
      }
    }
  }
};

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var ua = navigator.userAgent.toLowerCase();
      if (!localStorage.boardFlag && ua.indexOf("amcfmapp") > -1) {
        var div = document.createElement("div");
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var establishmentYears = currentYear - 1998; //1998华夏基金成立时间
        div.className = "board";
        document.body.appendChild(div);
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(760) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(761) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(762) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(763) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(764) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                _this2.close();
              },
              style: { top: window.screen.width / 750 * 846 + "px" },
              className: "btn1"
            },
            "\u7ACB\u5373\u4F53\u9A8C"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "textCont", style: { top: window.screen.width / 750 * 946 + "px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "text",
              null,
              "\u534E\u590F\u57FA\u91D1",
              establishmentYears,
              "\u5E74\u8D44\u4EA7\u7BA1\u7406\u7ECF\u9A8C"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "text",
              null,
              "\u57FA\u4E8EMVP\u6A21\u578B\u7684\u667A\u80FD\u6295\u8D44\u7EC4\u5408"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "text",
              null,
              "\u9488\u5BF9\u4E0D\u540C\u9636\u6BB5\u7684\u8D22\u5BCC\u76EE\u6807"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "text",
              null,
              "\u63D0\u4F9B\u4E00\u952E\u5F0F\u667A\u80FD\u5316\u8D44\u4EA7\u914D\u7F6E\u6574\u4F53\u89E3\u51B3\u65B9\u6848"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                _this2.close();
              },
              style: { bottom: window.screen.width / 750 * 60 + "px" },
              className: "btn2"
            },
            "\u7ACB\u5373\u4F53\u9A8C"
          )
        ), div);
      }
    }
  }, {
    key: "close",
    value: function close() {
      localStorage.setItem("boardFlag", true);
      document.getElementsByClassName("board")[0].remove();
    }
  }, {
    key: "render",
    value: function render() {
      var ua = navigator.userAgent.toLowerCase();
      var style = document.createElement("style");
      style.type = "text/css";
      if (ua.indexOf("amcfmapp") > -1) {
        style.innerHTML = ".header-red{background:#CC3040;height:68px;padding-top:22px}#superContent{padding-top: 68px}.header-red2{background:#f03456}.boxContent{width:100%;height:100%;}#root{min-height:" + window.winHeight + "px}";
      } else if (ua.indexOf("hxcfH5WX") != -1 || ua.match(/MicroMessenger/i) == "micromessenger") {
        style.innerHTML = ".boxContent{width:100%;height:100%;}#root{min-height:" + window.winHeight + "px}";
      } else {
        style.innerHTML = ".content{padding-top: 44px;min-height:" + window.winHeight + "px}.boxContent{padding-top:44px;width:100%;height:100%;}#root{min-height:" + window.winHeight + "px}";
      }
      document.getElementsByTagName("HEAD").item(0).appendChild(style);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* Provider */],
          { store: __WEBPACK_IMPORTED_MODULE_7__ReduxStore_js__["a" /* default */] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_react_router__["b" /* Router */],
            { history: __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */] },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, exact: true, path: "/", component: __WEBPACK_IMPORTED_MODULE_10__components_Investment__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/animationView", component: __WEBPACK_IMPORTED_MODULE_73__components_AnimationView_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/NewPublicOffering", component: __WEBPACK_IMPORTED_MODULE_136__components_product_Details_NewPublicOffering_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/nullView", component: __WEBPACK_IMPORTED_MODULE_72__components_NullView_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/FinishQuestionnaireSuccess", component: __WEBPACK_IMPORTED_MODULE_14__components_pubQuestion_FinishQuestionnaireSuccess__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HighestRiskPoint", component: __WEBPACK_IMPORTED_MODULE_15__components_pubQuestion_HighestRiskPoint__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/recommend", component: __WEBPACK_IMPORTED_MODULE_19__components_recommend_Recommend_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Transfer", component: __WEBPACK_IMPORTED_MODULE_11__components_Transfer__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/BindingMobile", component: __WEBPACK_IMPORTED_MODULE_12__components_sync_BindingMobile__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/RedeemBankList", component: __WEBPACK_IMPORTED_MODULE_46__components_RedeemBankList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/AddCard", component: __WEBPACK_IMPORTED_MODULE_16__components_AddCard__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/AddPhone", component: __WEBPACK_IMPORTED_MODULE_17__components_AddPhone__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Verification", component: __WEBPACK_IMPORTED_MODULE_18__components_Verification__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/knowMore", component: __WEBPACK_IMPORTED_MODULE_20__components_recommend_KnowMore_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/encyclopedia", component: __WEBPACK_IMPORTED_MODULE_21__components_recommend_Encyclopedia_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/encyclopediaDetail", component: __WEBPACK_IMPORTED_MODULE_22__components_recommend_EncyclopediaDetail_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/recoQuestionDoing", component: __WEBPACK_IMPORTED_MODULE_23__components_recommend_RecoQuestionDoing_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/recoQuestionFinish", component: __WEBPACK_IMPORTED_MODULE_24__components_recommend_RecoQuestionFinish_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/pensionCalculator", component: __WEBPACK_IMPORTED_MODULE_25__components_recommend_PensionCalculator_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/pensionCalculatorResult", component: __WEBPACK_IMPORTED_MODULE_26__components_recommend_PensionCalculatorResult_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/pensionCalculatorPlan", component: __WEBPACK_IMPORTED_MODULE_27__components_recommend_PensionCalculatorPlan_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/educationCalculatorSelectSchool", component: __WEBPACK_IMPORTED_MODULE_28__components_recommend_EducationCalculatorSelectSchool_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/educationCalculator", component: __WEBPACK_IMPORTED_MODULE_29__components_recommend_EducationCalculator_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/educationCalculatorResult", component: __WEBPACK_IMPORTED_MODULE_30__components_recommend_EducationCalculatorResult_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/educationCalculatorPlan", component: __WEBPACK_IMPORTED_MODULE_31__components_recommend_EducationCalculatorPlan_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/certificationCard", component: __WEBPACK_IMPORTED_MODULE_32__components_recommend_CertificationCard_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ChangTime", component: __WEBPACK_IMPORTED_MODULE_35__components_recommend_ChangTime_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/CertificationUpload", component: __WEBPACK_IMPORTED_MODULE_33__components_recommend_CertificationUpload_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/CertiUpload", component: __WEBPACK_IMPORTED_MODULE_34__components_recommend_CertiUpload_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/certificationCardAgain", component: __WEBPACK_IMPORTED_MODULE_36__components_recommend_CertificationCardAgain_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/certificationSetPhone", component: __WEBPACK_IMPORTED_MODULE_37__components_recommend_CertificationSetPhone_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/certificationCheckPhone", component: __WEBPACK_IMPORTED_MODULE_38__components_recommend_CertificationCheckPhone_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/certificationSetPassWord", component: __WEBPACK_IMPORTED_MODULE_39__components_recommend_CertificationSetPassWord_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PaymentSuperFund", component: __WEBPACK_IMPORTED_MODULE_40__components_PaymentSuperFund__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PaymentAllSuperFund", component: __WEBPACK_IMPORTED_MODULE_41__components_PaymentAllSuperFund__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/FixedInvestmentSuperFund", component: __WEBPACK_IMPORTED_MODULE_42__components_myAssets_payment_FixedInvestmentSuperFund_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/FixedInvestmentSuperFundChange", component: __WEBPACK_IMPORTED_MODULE_43__components_myAssets_payment_FixedInvestmentSuperFundChange_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Payment", component: __WEBPACK_IMPORTED_MODULE_84__components_myAssets_payment_Payment_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/RechargeHqt", component: __WEBPACK_IMPORTED_MODULE_85__components_myAssets_payment_RechargeHqt_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/RedeemCurrencyList", component: __WEBPACK_IMPORTED_MODULE_45__components_RedeemCurrencyList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/RedeemSuperFund", component: __WEBPACK_IMPORTED_MODULE_44__components_RedeemSuperFund__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Success", component: __WEBPACK_IMPORTED_MODULE_47__components_Success__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ErrorResult", component: __WEBPACK_IMPORTED_MODULE_48__components_Error__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/WebView", component: __WEBPACK_IMPORTED_MODULE_51__components_WebView__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PayCardList", component: __WEBPACK_IMPORTED_MODULE_49__components_myAssets_payment_PayCardList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HqtCardList", component: __WEBPACK_IMPORTED_MODULE_50__components_myAssets_payment_HqtCardList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SuperFundDetail", component: __WEBPACK_IMPORTED_MODULE_121__components_fundDetail_SuperFundDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SuperFundList", component: __WEBPACK_IMPORTED_MODULE_52__components_fundDetail_SuperFundList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransactionRecord", component: __WEBPACK_IMPORTED_MODULE_53__components_fundDetail_TransactionRecord__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/OperationRecord", component: __WEBPACK_IMPORTED_MODULE_54__components_fundDetail_OperationRecord__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Configuration", component: __WEBPACK_IMPORTED_MODULE_55__components_fundDetail_Configuration__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TaxInfo", component: __WEBPACK_IMPORTED_MODULE_56__components_fundDetail_TaxInfo__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransactionDetail", component: __WEBPACK_IMPORTED_MODULE_57__components_fundDetail_TransactionDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/LoginHxjj", component: __WEBPACK_IMPORTED_MODULE_58__components_Login__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Loginkah", component: __WEBPACK_IMPORTED_MODULE_59__components_Loginkah__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Login", component: __WEBPACK_IMPORTED_MODULE_60__components_LoginHxcf__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/userBindingMobile", component: __WEBPACK_IMPORTED_MODULE_61__components_login_UserBindingMobile__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HxjjBindingMobile", component: __WEBPACK_IMPORTED_MODULE_62__components_login_HxjjBindingMobile__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/register", component: __WEBPACK_IMPORTED_MODULE_63__components_login_Register__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/forgetPassword", component: __WEBPACK_IMPORTED_MODULE_64__components_login_ForgetPassword__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/verifyDynamicCode", component: __WEBPACK_IMPORTED_MODULE_65__components_login_VerifyDynamicCode__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/verifyDynamicCodeSec", component: __WEBPACK_IMPORTED_MODULE_66__components_login_VerifyDynamicCodeSec__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/setNewPassword", component: __WEBPACK_IMPORTED_MODULE_67__components_login_SetNewPassword__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/QuestionnaireList", component: __WEBPACK_IMPORTED_MODULE_13__components_pubQuestion_QuestionnaireList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransitRecords", component: __WEBPACK_IMPORTED_MODULE_68__components_fundDetail_TransitRecords__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransitHistory", component: __WEBPACK_IMPORTED_MODULE_69__components_fundDetail_TransitHistory__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransitHistoryDetial", component: __WEBPACK_IMPORTED_MODULE_70__components_fundDetail_TransitHistoryDetial__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TaxSuccess", component: __WEBPACK_IMPORTED_MODULE_71__components_fundDetail_TaxSuccess__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HistoryProfit", component: __WEBPACK_IMPORTED_MODULE_74__components_product_HistoryProfit__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ChooseTime", component: __WEBPACK_IMPORTED_MODULE_75__components_product_ChooseTime__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/InviteRegister", component: __WEBPACK_IMPORTED_MODULE_77__components_login_InviteRegister__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/InvestmentFund", component: __WEBPACK_IMPORTED_MODULE_80__components_myAssets_investPlan_InvestmentFund_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/InvestmentRecord", component: __WEBPACK_IMPORTED_MODULE_81__components_myAssets_investPlan_InvestmentRecord_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/InvestmentPlan", component: __WEBPACK_IMPORTED_MODULE_78__components_myAssets_investPlan_InvestmentPlan_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/InvestmentDetail", component: __WEBPACK_IMPORTED_MODULE_79__components_myAssets_investPlan_InvestmentDetail_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SerchInvestment", component: __WEBPACK_IMPORTED_MODULE_82__components_myAssets_investPlan_SerchInvestment_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransactionRecordProduct", component: __WEBPACK_IMPORTED_MODULE_83__components_myAssets_queryServices_TransactionRecordProduct__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SubscriptionDetail", component: __WEBPACK_IMPORTED_MODULE_86__components_SubscriptionDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SubscriptionDetailTwo", component: __WEBPACK_IMPORTED_MODULE_87__components_SubscriptionDetailTwo__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ReservationsManager", component: __WEBPACK_IMPORTED_MODULE_88__components_ReservationsManager__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Answer", component: __WEBPACK_IMPORTED_MODULE_89__components_Answer__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/AnswePage", component: __WEBPACK_IMPORTED_MODULE_90__components_AnswerPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["b" /* Router */], { onLeave: outFun, onEnter: enterFun, path: "/PrivacyAgreement", component: __WEBPACK_IMPORTED_MODULE_93__components_PrivacyAgreement__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ConsultationDetails", component: __WEBPACK_IMPORTED_MODULE_94__components_product_ConsultationDetails_js__["a" /* ConsultationDetails */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SuperFundSigning", component: __WEBPACK_IMPORTED_MODULE_95__components_SuperFundSigning__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TransferF", component: __WEBPACK_IMPORTED_MODULE_96__components_TransferF__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SuperRate", component: __WEBPACK_IMPORTED_MODULE_97__components_fundDetail_SuperRate__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ChooseGh", component: __WEBPACK_IMPORTED_MODULE_98__components_fundDetail_ChooseGh__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ModalProtocol", component: __WEBPACK_IMPORTED_MODULE_99__components_Modal_ModalProtocol__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Understand", component: __WEBPACK_IMPORTED_MODULE_100__components_Understand__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/iframeWeb", component: __WEBPACK_IMPORTED_MODULE_101__components_iframeWeb__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/CurrentDemand", component: __WEBPACK_IMPORTED_MODULE_110__components_myAssets_myCard_CurrentDemand__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/AddCertificationCard", component: __WEBPACK_IMPORTED_MODULE_111__components_recommend_AddCertificationCard_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ModifyTaxInfo", component: __WEBPACK_IMPORTED_MODULE_112__components_fundDetail_ModifyTaxInfo__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HqtAddCard", component: __WEBPACK_IMPORTED_MODULE_113__components_myAssets_myCard_HqtAddCard__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HqtBindCard", component: __WEBPACK_IMPORTED_MODULE_114__components_myAssets_myCard_HqtBindCard__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HqtCheckCard", component: __WEBPACK_IMPORTED_MODULE_115__components_myAssets_myCard_HqtCheckCard__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HqtSuccess", component: __WEBPACK_IMPORTED_MODULE_116__components_myAssets_myCard_HqtSuccess__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/AnswerActivityDatillPage", component: __WEBPACK_IMPORTED_MODULE_92__components_AnswerActivityDatillPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/AnswerActivityPage", component: __WEBPACK_IMPORTED_MODULE_91__components_AnswerActivityPage__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TargetFundsList", component: __WEBPACK_IMPORTED_MODULE_117__components_TargetFundsList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TargetProfitDetail", component: __WEBPACK_IMPORTED_MODULE_118__components_fundDetail_TargetProfitDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/TargetProfitHaveCast", component: __WEBPACK_IMPORTED_MODULE_119__components_fundDetail_TargetProfitHaveCast__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/HistoryPerformance", component: __WEBPACK_IMPORTED_MODULE_120__components_fundDetail_HistoryPerformance__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/MakePlanDetail", component: __WEBPACK_IMPORTED_MODULE_134__components_fundDetail_MakePlanDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/MakePlanResult", component: __WEBPACK_IMPORTED_MODULE_135__components_fundDetail_MakePlanResult__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PortfolioPerformance", component: __WEBPACK_IMPORTED_MODULE_122__components_fundDetail_PortfolioPerformance__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/BaoGao", component: __WEBPACK_IMPORTED_MODULE_123__components_fundDetail_BaoGao__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/JaoYi", component: __WEBPACK_IMPORTED_MODULE_124__components_fundDetail_JaoYi__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/FeiL", component: __WEBPACK_IMPORTED_MODULE_125__components_fundDetail_FeiL__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PositionDetails", component: __WEBPACK_IMPORTED_MODULE_126__components_fundDetail_PositionDetails__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ChangeFundList", component: __WEBPACK_IMPORTED_MODULE_127__components_fundDetail_ChangeFundList__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ChangeFundDetail", component: __WEBPACK_IMPORTED_MODULE_128__components_fundDetail_ChangeFundDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ServiceReport", component: __WEBPACK_IMPORTED_MODULE_129__components_fundDetail_ServiceReport__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/ServiceReportDetail", component: __WEBPACK_IMPORTED_MODULE_130__components_fundDetail_ServiceReportDetail__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PublicOffering", component: __WEBPACK_IMPORTED_MODULE_132__components_product_Details_PublicOffering_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Transactionrecordztgz", component: __WEBPACK_IMPORTED_MODULE_102__components_fundDetail_Transactionrecordztgz__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Fuwufei", component: __WEBPACK_IMPORTED_MODULE_103__components_fundDetail_Fuwuqimingxi__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Feiyongxiangqing", component: __WEBPACK_IMPORTED_MODULE_104__components_fundDetail_Feiyongxiangqing__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Transferrecord", component: __WEBPACK_IMPORTED_MODULE_105__components_fundDetail_Transferrecord__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Transferinrecord", component: __WEBPACK_IMPORTED_MODULE_106__components_fundDetail_Transferinrecord__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Dividendreinvestedincash", component: __WEBPACK_IMPORTED_MODULE_107__components_fundDetail_Dividendreinvestedincash__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Servicechargerecord", component: __WEBPACK_IMPORTED_MODULE_108__components_fundDetail_Servicechargerecord__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/Detailsofwarehouseadjustment", component: __WEBPACK_IMPORTED_MODULE_109__components_fundDetail_Detailsofwarehouseadjustment__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/PositionDetailsHavaCast", component: __WEBPACK_IMPORTED_MODULE_131__components_fundDetail_PositionDetailsHaveCast__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/imgPage", component: __WEBPACK_IMPORTED_MODULE_137__components_guidePage_imgPage_js__["a" /* default */] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_router__["c" /* Route */], { onLeave: outFun, onEnter: enterFun, path: "/SuperFundDetailHaveCast", component: __WEBPACK_IMPORTED_MODULE_133__components_fundDetail_SuperFundDetailHaveCast__["a" /* default */] })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_138__components_guidePage__["c" /* GuidePage */], { ref: function ref(_ref) {
            return __WEBPACK_IMPORTED_MODULE_138__components_guidePage__["d" /* GuidePageRef */].current = _ref;
          } })
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AnswerAlert__ = __webpack_require__(280);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

var Answer = function (_Component) {
  _inherits(Answer, _Component);

  function Answer(props) {
    _classCallCheck(this, Answer);

    var _this = _possibleConstructorReturn(this, (Answer.__proto__ || Object.getPrototypeOf(Answer)).call(this, props));

    _this.state = {
      alertFlag: false
    };

    return _this;
  }

  _createClass(Answer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'beginAnswer',
    value: function beginAnswer() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/Login',
        // pathname:'/AnswePage', 

        state: {},
        query: { enterType: "Answer" }
      });
    }
  }, {
    key: 'pushDetail',
    value: function pushDetail() {
      //  window.location.href = "https://www.amcfortune.com/minipage/zdz/app/index.html";
      //  window.location.href = "https://www.amcfortune.com/minipage/hxcy/app/index.html";
      window.location.href = " https://www.amcfortune.com/minipage/xywap/index.html";
    }
  }, {
    key: 'alertRule',
    value: function alertRule() {
      this.setState({
        alertFlag: true
      });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({
        alertFlag: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _window$screen = window.screen,
          width = _window$screen.width,
          height = _window$screen.height;
      var alertFlag = this.state.alertFlag;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AnswerContent', style: { height: height } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { width: '100%', position: "relative" }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: __webpack_require__(733),
            alt: '',
            style: { width: width, verticalAlign: 'top' }

          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
              _this2.alertRule();
            }, style: { width: 150, height: 50, position: "absolute", top: 10, right: 0, zIndex: 9, background: "rgba(0,0,0,0)" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jionAnswer', style: { width: width, bottom: width / (750 / 180), height: width / (750 / 75), zIndex: 9 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
                _this2.beginAnswer();
              }, style: { height: width / (750 / 75) } })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jionMore', style: { width: width, bottom: width / (750 / 76), height: width / (750 / 75), zIndex: 9 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
                _this2.pushDetail();
              }, style: { height: width / (750 / 75) } })
          )
        ),
        alertFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AnswerAlert__["b" /* AnswerAlert */], { Close: this.handleClose.bind(this) }) : null
      );
      // return (
      //     <div>
      //         <div className="Answer" style={{width:width,height:width*(2871/750)}}>
      //           <div style={{width:150,height:50,position:"absolute",top:10,right:0,background:"rgba(0,0,0,0)"}}></div>
      //         </div>
      //     </div>
      // );
    }
  }]);

  return Answer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Answer));

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnswerAlert__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

var AnswerActivityDatillPage = function (_Component) {
  _inherits(AnswerActivityDatillPage, _Component);

  function AnswerActivityDatillPage(props) {
    _classCallCheck(this, AnswerActivityDatillPage);

    var _this = _possibleConstructorReturn(this, (AnswerActivityDatillPage.__proto__ || Object.getPrototypeOf(AnswerActivityDatillPage)).call(this, props));

    _this.state = {
      chooseFlag: "C",
      alertFlag: false,
      content: "",
      AlertErrorFlag: false,
      chooseFlag2: "C",
      chooseFlag3: "C",
      activityQuestionList: [],
      count: 0
    };

    return _this;
  }

  _createClass(AnswerActivityDatillPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
      var _props = this.props,
          dispatch = _props.dispatch,
          setActivityId = _props.setActivityId;

      var data = {
        //  activityId:'10000000000000002701'
        activityId: setActivityId.activityId == "" ? this.props.location.query.activityId : setActivityId.activityId
        // activityId:this.props.location.query.activityId
      };
      var callback = function callback(data) {
        console.log('返回值', data);
        var newQuestion = data.content.activityQuestionResponse.map(function (item, index) {
          item['queMask'] = '';
          item.options.map(function (itemobj, index) {
            itemobj['optMask'] = '';
            return itemobj;
          });
          return item;
        });
        console.log(newQuestion);
        _this2.setState({
          activityQuestionList: newQuestion
        });
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_87" /* getActivityById */])(data, callback));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'checkopt',
    value: function checkopt(Qid, Oid) {
      var _state = this.state,
          activityQuestionList = _state.activityQuestionList,
          count = _state.count;

      var newQuestion = activityQuestionList.map(function (item, index) {
        if (item.questionId == Qid) {
          item['queMask'] = '1';
          item.options.map(function (itemobj, index) {
            if (itemobj.optionId == Oid) {
              itemobj['optMask'] = '1';
            } else {
              itemobj['optMask'] = '';
            }
            return itemobj;
          });
        }
        return item;
      });
      this.setState({
        activityQuestionList: newQuestion
      });
    }
  }, {
    key: 'handleChoose',
    value: function handleChoose(code, num) {
      if (num == 1) {
        this.setState({
          chooseFlag: code
        });
      } else if (num == 2) {
        this.setState({
          chooseFlag2: code
        });
      } else if (num == 3) {
        this.setState({
          chooseFlag3: code
        });
      }
    }
  }, {
    key: 'submitChoose',
    value: function submitChoose() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          setActivityId = _props2.setActivityId;
      var activityQuestionList = this.state.activityQuestionList;

      console.log(activityQuestionList);
      var count = 0;
      var condition = activityQuestionList.some(function (item) {
        return item.queMask == '1';
      });
      console.log(condition);
      if (!condition) {
        this.setState({
          AlertErrorFlag: true,
          content: "请先进行答题，再进行提交"
        });
        return;
      }
      var condition1 = activityQuestionList.some(function (item) {
        return item.queMask == '';
      });
      if (condition1) {
        this.setState({
          AlertErrorFlag: true,
          content: "您还有未回答的题目"
        });
        return;
      }
      //获取答对题数
      var newQuestion = activityQuestionList.map(function (item, index) {
        item.options.map(function (itemobj, index) {
          if (itemobj.optMask == 1 && itemobj.rightAnswer) {
            count++;
          }
        });
      });

      this.setState({ count: count }, function () {
        console.log('count1111', count);
      });
      var newAnswerSheet = activityQuestionList.map(function (item) {
        var ary = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = item.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var itemObj = _step.value;

            if (itemObj.optMask === "1") {
              ary.push({ optionId: itemObj.optionId });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return { answerOptions: ary, questionId: item.questionId };
      });

      console.log(newAnswerSheet);

      var inData = {
        activityId: setActivityId.activityId == "" ? this.props.location.query.activityId : setActivityId.activityId,
        clientType: 'hxcfH5',
        answerSheet: JSON.stringify(newAnswerSheet)
      };
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].loading("正在加载");
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_88" /* AnswerSubmit */])(inData, this.callback.bind(this)));
    }
  }, {
    key: 'callback',
    value: function callback(e) {
      var count = this.state.count;

      console.log(e);
      if (e.code === "0000") {
        if (count == 0) {
          this.setState({
            alertFlag: true,
            content: "答题完成，您共回答对0道问题，很遗憾不能获得奖励"
          });
        } else {
          this.setState({
            alertFlag: true,
            content: "答题完成，您共回答对" + count + "道问题，共获得" + e.content.point + "智豆，请到APP查看并使用智豆"
          });
        }
      } else {
        this.setState({
          alertFlag: true,
          content: e.message
        });
      }
    }
  }, {
    key: 'handleSure',
    value: function handleSure() {
      this.setState({
        AlertErrorFlag: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var width = window.screen.width;
      var _state2 = this.state,
          chooseFlag = _state2.chooseFlag,
          content = _state2.content,
          alertFlag = _state2.alertFlag,
          AlertErrorFlag = _state2.AlertErrorFlag,
          activityQuestionList = _state2.activityQuestionList,
          chooseFlag2 = _state2.chooseFlag2,
          chooseFlag3 = _state2.chooseFlag3;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { width: width } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: width } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: __webpack_require__(735),
            style: { width: width }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: width, height: width / (750 / 90), fontSize: 22, textAlign: "center", background: "#fff" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { color: '#D8342B', padding: 10, fontWeight: 'bold' } },
            '\u9898\u76EE'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: width, paddingLeft: 20, paddingRight: 20, background: "#fff", paddingBottom: 40 } },
          activityQuestionList.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: 10, marginBottom: 20 }, key: index },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: width / (750 / 650), borderBottomWidth: 10, borderColor: '#1B81FF' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 16, color: '#001871', lineHeight: 1.8 } },
                  item.order,
                  '\u3001',
                  item.content
                ),
                item.options.map(function (itemObj, indexObj) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: indexObj, onClick: function onClick() {
                        _this3.checkopt(item.questionId, itemObj.optionId);
                      }, style: { fontSize: 14, padding: 10, background: itemObj.optMask == '1' ? '#FFFAF3' : '#EEF6FF', marginTop: 12, display: 'flex', flexDirection: 'row' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { fontSize: 16, width: width / (750 / 40), color: 'red', lineHeight: 1.4 } },
                      itemObj.order,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      { style: { width: width / (750 / 560), lineHeight: 1.8 } },
                      itemObj.content,
                      ' '
                    )
                  );
                })
              )
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: width, background: "#fff" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this3.submitChoose();
              }, style: { display: 'flex', justifyContent: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
              src: __webpack_require__(767),
              style: { width: width * 0.837, height: width * 0.16, verticalAlign: 'center' }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20, paddingBottom: 20, fontSize: 12, color: '#001871', textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5E02\u573A\u6709\u98CE\u9669 \u6295\u8D44\u9700\u8C28\u614E'
            )
          )
        ),
        AlertErrorFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AnswerAlert__["d" /* AlertError */], { content: content, handleSure: this.handleSure.bind(this) }) : null,
        alertFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AnswerAlert__["c" /* AlertResule */], { content: content }) : null
      );
    }
  }]);

  return AnswerActivityDatillPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(state, state.setActivityId, '1212121');
  return {
    setActivityId: state.setActivityId
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AnswerActivityDatillPage));

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AnswerAlert__ = __webpack_require__(280);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

var AnswerActivityPage = function (_Component) {
  _inherits(AnswerActivityPage, _Component);

  function AnswerActivityPage(props) {
    _classCallCheck(this, AnswerActivityPage);

    var _this = _possibleConstructorReturn(this, (AnswerActivityPage.__proto__ || Object.getPrototypeOf(AnswerActivityPage)).call(this, props));

    _this.state = {
      alertFlag: false,
      alerterrFlag: false,
      content: '',
      activityurl: '',
      ruleurl: ''
    };

    return _this;
  }

  _createClass(AnswerActivityPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
      var dispatch = this.props.dispatch;

      console.log('id', this.props.location.query.activityId);

      var data = {
        activityId: this.props.location.query.activityId
        //存储ID
      };dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction_js__["_86" /* setActivityId */])(data));
      var callback = function callback(data) {
        console.log('返回值', data);

        if (!data.content || !data.content.activityPic) {
          _this2.setState({
            alerterrFlag: true,
            content: data.message ? data.message : '答题活动获取失败'
          });
          return;
        }
        _this2.setState({
          activityurl: '' + (__WEBPACK_IMPORTED_MODULE_7__util___default.a.imgUrl + data.content.activityPic),
          ruleurl: '' + (__WEBPACK_IMPORTED_MODULE_7__util___default.a.imgUrl + data.content.rulePic)
        });
      };

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction_js__["_87" /* getActivityById */])(data, callback));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'beginAnswer',
    value: function beginAnswer() {

      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/Login',

        state: {},
        query: { enterType: "Answer",
          activityId: this.props.location.query.activityId }
      });
    }
  }, {
    key: 'pushDetail',
    value: function pushDetail() {
      //  window.location.href = "https://www.amcfortune.com/minipage/zdz/app/index.html";
      //  window.location.href = "https://www.amcfortune.com/minipage/hxcy/app/index.html";
      window.location.href = " https://www.amcfortune.com/minipage/xywap/index.html";
    }
  }, {
    key: 'alertRule',
    value: function alertRule() {
      this.setState({
        alertFlag: true
      });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.setState({
        alertFlag: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _window$screen = window.screen,
          width = _window$screen.width,
          height = _window$screen.height;
      var _state = this.state,
          alertFlag = _state.alertFlag,
          content = _state.content,
          alerterrFlag = _state.alerterrFlag,
          activityurl = _state.activityurl,
          ruleurl = _state.ruleurl;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'AnswerContent', style: { height: height } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            style: { height: '100%', width: '100%', position: "relative", background: '#fff' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
            src: activityurl,
            alt: '',
            style: { width: width, height: height, verticalAlign: 'top' }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
              _this3.alertRule();
            },
            style: { width: 150, height: 50, position: "absolute", top: 10, right: 0, zIndex: 9 }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jionAnswer', style: { width: width, bottom: width / (750 / 180), height: width / (750 / 75), zIndex: 9, textAlign: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
                _this3.beginAnswer();
              }, style: { width: width, textAlign: 'center' } })
          )
        ),
        alertFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AnswerAlert__["b" /* AnswerAlert */], { url: ruleurl, Close: this.handleClose.bind(this) }) : null,
        alerterrFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AnswerAlert__["c" /* AlertResule */], { content: content }) : null
      );
    }
  }]);

  return AnswerActivityPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AnswerActivityPage));

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AnswerAlert__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

var AnswerPage = function (_Component) {
  _inherits(AnswerPage, _Component);

  function AnswerPage(props) {
    _classCallCheck(this, AnswerPage);

    var _this = _possibleConstructorReturn(this, (AnswerPage.__proto__ || Object.getPrototypeOf(AnswerPage)).call(this, props));

    _this.state = {
      chooseFlag: "C",
      alertFlag: false,
      content: "",
      AlertErrorFlag: false,
      chooseFlag2: "C",
      chooseFlag3: "C",

      count: 0
    };

    return _this;
  }

  _createClass(AnswerPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "进入答题"]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "答题", "离开答题"]);
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'handleChoose',
    value: function handleChoose(code, num) {
      if (num == 1) {
        this.setState({
          chooseFlag: code
        });
      } else if (num == 2) {
        this.setState({
          chooseFlag2: code
        });
      } else if (num == 3) {
        this.setState({
          chooseFlag3: code
        });
      }
    }
  }, {
    key: 'submitChoose',
    value: function submitChoose() {
      var _state = this.state,
          chooseFlag = _state.chooseFlag,
          chooseFlag2 = _state.chooseFlag2,
          chooseFlag3 = _state.chooseFlag3;
      var dispatch = this.props.dispatch;

      var yesNum = 0;
      if (chooseFlag === "C" && chooseFlag2 === "C" && chooseFlag3 === "C") {
        this.setState({
          AlertErrorFlag: true,
          content: "请先进行答题，再进行提交"
        });
        return;
      } else {
        if (chooseFlag != "C") {
          yesNum += 1;
        }
        if (chooseFlag2 != "C") {
          yesNum += 1;
        }
        if (chooseFlag3 != "C") {
          yesNum += 1;
        }
      }
      if (yesNum != 0) {
        var inData = {
          count: yesNum
        };
        this.setState({
          count: yesNum
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_94" /* AnswerSecKill */])(inData, this.callback.bind(this)));
      } else {
        this.setState({
          AlertErrorFlag: true,
          content: "答题完成，您共回答0道问题，很遗憾不能获得奖励"
        });
      }
    }
  }, {
    key: 'callback',
    value: function callback(e) {
      var count = this.state.count;

      console.log(e);
      if (e.code === "0000") {
        this.setState({
          alertFlag: true,
          content: "答题完成，您共回答" + count + "道问题，请等待后续货币基金份额发放"
        });
      } else {
        this.setState({
          alertFlag: true,
          content: e.message
        });
      }
    }
  }, {
    key: 'handleSure',
    value: function handleSure() {
      this.setState({
        AlertErrorFlag: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var width = window.screen.width;
      var _state2 = this.state,
          chooseFlag = _state2.chooseFlag,
          content = _state2.content,
          alertFlag = _state2.alertFlag,
          AlertErrorFlag = _state2.AlertErrorFlag,
          chooseFlag2 = _state2.chooseFlag2,
          chooseFlag3 = _state2.chooseFlag3;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { background: "#0b0c44", position: 'relative', width: width } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
          src: __webpack_require__(734),
          alt: '',
          style: { width: width, verticalAlign: 'top' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'questionOne', onClick: function onClick() {
              _this2.handleChoose("A", 1);
            }, style: { width: width, bottom: width / (750 / 1260) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: width * 0.248, height: width * 0.637 / (590 / 128), background: "rgba(0,0,0,0)" } },
            chooseFlag === "A" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'answerChooseFlag' }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'questionTwo', onClick: function onClick() {
              _this2.handleChoose("B", 1);
            }, style: { width: width, bottom: width / (750 / 1158) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: width * 0.248, height: width * 0.637 / (590 / 128), background: "rgba(0,0,0,0)" } },
            chooseFlag === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'answerChooseFlag' }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'questionOne', onClick: function onClick() {
              _this2.handleChoose("A", 2);
            }, style: { width: width, bottom: width / (750 / 942) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: width * 0.248, height: width * 0.637 / (590 / 128), background: "rgba(0,0,0,0)" } },
            chooseFlag2 === "A" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'answerChooseFlag' }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'questionTwo', onClick: function onClick() {
              _this2.handleChoose("B", 2);
            }, style: { width: width, bottom: width / (750 / 855) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: width * 0.248, height: width * 0.637 / (590 / 128), background: "rgba(0,0,0,0)" } },
            chooseFlag2 === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'answerChooseFlag' }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'questionOne', onClick: function onClick() {
              _this2.handleChoose("A", 3);
            }, style: { width: width, bottom: width / (750 / 532) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: width * 0.248, height: width * 0.637 / (590 / 128), background: "rgba(0,0,0,0)" } },
            chooseFlag3 === "A" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'answerChooseFlag' }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'questionTwo', onClick: function onClick() {
              _this2.handleChoose("B", 3);
            }, style: { width: width, bottom: width / (750 / 448) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: width * 0.248, height: width * 0.637 / (590 / 128), background: "rgba(0,0,0,0)" } },
            chooseFlag3 === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'answerChooseFlag' }) : null
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'sureAnswerBtn', style: { width: width, bottom: width / (750 / 265) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
              _this2.submitChoose();
            }, style: { width: width * 0.837, height: width * 0.637 / (478 / 101), background: "rgba(0,0,0,0)" } })
        ),
        AlertErrorFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AnswerAlert__["d" /* AlertError */], { content: content, handleSure: this.handleSure.bind(this) }) : null,
        alertFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AnswerAlert__["c" /* AlertResule */], { content: content }) : null
      );
    }
  }]);

  return AnswerPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*
<div className="AnswerPage" style={{width:width, height:width/(750/1334) }}>
  <div className="questionOne" style={{width:width, bottom:(width)/(750/586)}}>
    <div onClick={()=>{ this.handleChoose("A") }} style={{width:width*0.786, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}> 
        { chooseFlag === "A" ? 
          <div className="answerChooseFlag"></div> : null
        }
    </div>
  </div>
  <div className="questionTwo" style={{width:width, bottom:(width)/(750/416)}}>
    <div onClick={()=>{ this.handleChoose("B") }} style={{width:width*0.786, height:(width*0.637)/(590/128), background:"rgba(0,0,0,0)"}}>
      {chooseFlag === "B" ?
       <div className="answerChooseFlag"></div> : null
      }
    </div>
  </div>
  <div className="sureAnswerBtn" style={{width:width, bottom:(width)/(750/162)}}>
    <div onClick={ ()=>{ this.submitChoose() }} style={{width:width*0.637, height:(width*0.637)/(478/101), background:"rgba(0,0,0,0)"}}>

    </div>
  </div>
</div>

*/

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AnswerPage));

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detailInformation_css__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detailInformation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__detailInformation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InfoTable_js__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_H5page__ = __webpack_require__(725);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var BaseInformationGeneral = function (_Component) {
  _inherits(BaseInformationGeneral, _Component);

  function BaseInformationGeneral(props) {
    _classCallCheck(this, BaseInformationGeneral);

    var _this = _possibleConstructorReturn(this, (BaseInformationGeneral.__proto__ || Object.getPrototypeOf(BaseInformationGeneral)).call(this, props));

    _this.goVideo = function (url) {
      window.location.href = encodeURI(url /* "https://live.vhall.com/v3/lives/subscribe/981938248" */);
    };

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.getMore = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/PortfolioPerformance",
        state: { superFundCode: _this.props.superFundCode },
        query: { superFundCode: _this.props.superFundCode }
      });
    };

    _this.getInfo = function () {
      var incomeRateList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return [[[__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(incomeRateList.hisAnnualizedGains), "成立以来年化"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(incomeRateList.maxRetreat), "近一年最大回撤"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(incomeRateList.dayGains), "日涨跌幅"]]];
    };

    _this.getAll = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/ServiceReport",
        state: { superFundCode: _this.props.superFundCode },
        query: { superFundCode: _this.props.superFundCode }
      });
    };

    _this.toRecentNewsDetail = function (id) {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/ServiceReportDetail",
        state: { id: id },
        query: { id: id }
      });
    };

    _this.state = {};
    return _this;
  }

  _createClass(BaseInformationGeneral, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var fundName = this.props.superFundName;
      var _props = this.props,
          baseInfo = _props.baseInfo,
          strategy = _props.strategy,
          recentNewsList = _props.recentNewsList,
          _props$operationDay = _props.operationDay,
          operationDay = _props$operationDay === undefined ? '--' : _props$operationDay,
          _props$riskLevelName = _props.riskLevelName,
          riskLevelName = _props$riskLevelName === undefined ? '--' : _props$riskLevelName,
          hasOneYear = _props.hasOneYear,
          introVideoUrl = _props.introVideoUrl;

      var infoTable = this.getInfo(baseInfo);
      var recentNewsLists = recentNewsList ? recentNewsList.slice(0, 3) : [];
      var strategyFlag = strategy && strategy.strategy && strategy.strategy.trim();
      var lightPointFlag = strategy && strategy.lightPoint && strategy.lightPoint.trim();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "DeInfo_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "DeInfo_strategy_wrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "DeInfo" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "DeInfo_fundName" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                fundName
              ),
              introVideoUrl && hasOneYear && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { onClick: function onClick() {
                    return _this2.goVideo(introVideoUrl);
                  } },
                "\u89C6\u9891\u4ECB\u7ECD"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "DeInfo_runtime" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                riskLevelName
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                "\u5DF2\u8FD0\u884C" + operationDay + "\u5929"
              )
            )
          ),
          hasOneYear && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__InfoTable_js__["a" /* default */], { cols: 3, dataSouse: infoTable, className: "InfoTable" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "get_more", onClick: this.getMore },
              "\u67E5\u770B\u66F4\u591A\u6570\u636E",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(273) })
            )
          ),
          (strategyFlag || lightPointFlag) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "strategy" },
            strategyFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "strategy_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { className: "strategy_item_text" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "\u6295\u8D44\u7B56\u7565"
                ),
                " | ",
                strategy.strategy.trim()
              )
            ),
            lightPointFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "strategy_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { className: "strategy_item_text" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "\u7B56\u7565\u4EAE\u70B9"
                ),
                " | ",
                strategy.lightPoint.trim()
              )
            )
          )
        ),
        introVideoUrl && hasOneYear != undefined && !hasOneYear && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { onClick: function onClick() {
              return _this2.goVideo(introVideoUrl);
            }, style: { height: "2.8rem", marginTop: ".1rem", borderRadius: ".2rem" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: "100%" }, src: __webpack_require__(757) })
        ),
        !!recentNewsLists.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "DeInfo_dynameic" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dynameic", onClick: this.getAll },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(668) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "query_more" },
              "\u67E5\u770B\u5168\u90E8",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(273) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dynameic_list" },
            recentNewsLists.map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                {
                  key: item.id,
                  className: "dynameic_item",
                  onClick: function onClick() {
                    return _this2.toRecentNewsDetail(item.id);
                  }
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  "\xB7 ",
                  item.title
                )
              );
            })
          )
        )
      );
    }
  }]);

  return BaseInformationGeneral;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails,
      _state$strategiesDeta2 = _state$strategiesDeta.superFund,
      superFund = _state$strategiesDeta2 === undefined ? {} : _state$strategiesDeta2,
      strategy = _state$strategiesDeta.strategy,
      recentNewsList = _state$strategiesDeta.recentNewsList,
      _state$strategiesDeta3 = _state$strategiesDeta.superFundBasicInfo,
      superFundBasicInfo = _state$strategiesDeta3 === undefined ? {} : _state$strategiesDeta3;

  return {
    baseInfo: state.superFundProductIncomes,
    strategy: strategy,
    recentNewsList: recentNewsList,
    operationDay: superFundBasicInfo.operationDay,
    riskLevelName: superFundBasicInfo.riskLevelName,
    fullOneYear: superFundBasicInfo.fullOneYear,
    hasOneYear: state.superFundProductIncomes.hasOneYear,
    introVideoUrl: superFund.introVideoUrl
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(BaseInformationGeneral)));

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detailInformation_css__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__detailInformation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__detailInformation_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfoTable_js__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_portfolioAction__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product_H5page__ = __webpack_require__(725);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









//import H5Page from './product/H5Page.js';

//export const TypeContext = React.createContext({isStop:false});

var BaseInformationStop = function (_Component) {
  _inherits(BaseInformationStop, _Component);

  function BaseInformationStop(props) {
    _classCallCheck(this, BaseInformationStop);

    var _this = _possibleConstructorReturn(this, (BaseInformationStop.__proto__ || Object.getPrototypeOf(BaseInformationStop)).call(this, props));

    _this.goVideo = function (url) {
      window.location.href = encodeURI(url /* "https://live.vhall.com/v3/lives/subscribe/981938248" */);
    };

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.getInfo = function (baseInfo) {
      // const start = new Date(baseInfo.startDate) != "Invalid Date" ? Util.returnDate(baseInfo.startDate) : "--"; //incomeRateList.startDate
      return [[[baseInfo && __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(baseInfo.profitRate), "止盈目标年化收益率"], [baseInfo && baseInfo.runPeriod != undefined && baseInfo.runPeriod, "运行周期"], [baseInfo && baseInfo.investDateStr, "运作起始日期"]]];
    };

    _this.getAll = function () {

      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/ServiceReport",
        state: { superFundCode: _this.props.superFundCode },
        query: { superFundCode: _this.props.superFundCode }
      });
    };

    _this.toRecentNewsDetail = function (id) {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/ServiceReportDetail",
        state: { id: id },
        query: { id: id }
      });
    };

    _this.state = {};
    return _this;
  }

  _createClass(BaseInformationStop, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var fundName = this.props.superFundName;
      var _props = this.props,
          strategy = _props.strategy,
          recentNewsList = _props.recentNewsList,
          _props$baseInfo = _props.baseInfo,
          baseInfo = _props$baseInfo === undefined ? {} : _props$baseInfo,
          _props$riskLevelName = _props.riskLevelName,
          riskLevelName = _props$riskLevelName === undefined ? '--' : _props$riskLevelName,
          introVideoUrl = _props.introVideoUrl;


      var infoTable = this.getInfo(baseInfo);

      var recentNewsLists = recentNewsList ? recentNewsList.slice(0, 3) : [];
      var strategyFlag = strategy && strategy.strategy && strategy.strategy.trim();
      var lightPointFlag = strategy && strategy.lightPoint && strategy.lightPoint.trim();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "DeInfo_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "DeInfo_strategy_wrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "DeInfo" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "DeInfo_fundName" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                null,
                fundName
              ),
              introVideoUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { onClick: function onClick() {
                    return _this2.goVideo(introVideoUrl);
                  } },
                "\u89C6\u9891\u4ECB\u7ECD"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "DeInfo_runtime" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                riskLevelName
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InfoTable_js__["a" /* default */], { cols: 3, dataSouse: infoTable, className: "InfoTable", itemClassName: "item_table_sec" }),
          (strategyFlag || lightPointFlag) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "strategy" },
            strategyFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "strategy_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { className: "strategy_item_text" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "\u6295\u8D44\u7B56\u7565"
                ),
                " | ",
                strategy.strategy.trim()
              )
            ),
            lightPointFlag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "strategy_item" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                { className: "strategy_item_text" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "\u7B56\u7565\u4EAE\u70B9"
                ),
                " | ",
                strategy.lightPoint.trim()
              )
            )
          )
        ),
        !!recentNewsLists.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "DeInfo_dynameic" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dynameic", onClick: this.getAll },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(668) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "query_more" },
              "\u67E5\u770B\u5168\u90E8",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(273) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "dynameic_list" },
            recentNewsLists.map(function (item) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { key: item.id, className: "dynameic_item", onClick: function onClick() {
                    return _this2.toRecentNewsDetail(item.id);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  null,
                  "\xB7 ",
                  item.title
                )
              );
            })
          )
        )
      );
    }
  }]);

  return BaseInformationStop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails,
      _state$strategiesDeta2 = _state$strategiesDeta.superFund,
      superFund = _state$strategiesDeta2 === undefined ? {} : _state$strategiesDeta2,
      strategy = _state$strategiesDeta.strategy,
      recentNewsList = _state$strategiesDeta.recentNewsList,
      _state$strategiesDeta3 = _state$strategiesDeta.superFundBasicInfo,
      superFundBasicInfo = _state$strategiesDeta3 === undefined ? {} : _state$strategiesDeta3,
      stopProfitOperationInfo = _state$strategiesDeta.stopProfitOperationInfo;

  return {
    baseInfo: stopProfitOperationInfo,
    strategy: strategy,
    recentNewsList: recentNewsList,
    riskLevelName: superFundBasicInfo.riskLevelName,
    introVideoUrl: superFund.introVideoUrl
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(BaseInformationStop)));

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_svg_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zrender_lib_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_zrender_lib_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lineEchartPerformanceTrends_css__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lineEchartPerformanceTrends_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__lineEchartPerformanceTrends_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var LineEchart = function (_Component) {
  _inherits(LineEchart, _Component);

  function LineEchart(props) {
    _classCallCheck(this, LineEchart);

    var _this = _possibleConstructorReturn(this, (LineEchart.__proto__ || Object.getPrototypeOf(LineEchart)).call(this, props));

    _this.createSingEcharts = function () {
      var myChart = null;
      return function () {
        if (myChart) {
          return myChart;
        }
        if (window.isLess47) {
          return myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"));
        } else {
          return myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
        }
      };
    }();

    _this.setEchart = function () {
      var xData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var xBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var baseData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var formatter = arguments[4];

      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
      }
      myChart.clear();
      myChart.resize();
      myChart.setOption(setLineOption(xData, data, xBase, baseData, formatter));
      // 默认选中最右一项弹出tooltip

      var timer = setTimeout(function () {
        clearTimeout(timer);

        if (!xBase.length && !xData.length) return;
        if (!xBase.length && xData.length || xData[xData.length - 1] >= xBase[xBase.length - 1]) {
          myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0, // 系列的 index
            dataIndex: data.length - 1 // 数据的 index
          });
        }
        if (xBase.length && !xData.length || xData[xData.length - 1] < xBase[xBase.length - 1]) {
          myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 1, // 系列的 index
            dataIndex: baseData.length - 1 // 数据的 index
          });
        }
        var echartsDOM = document.querySelector("#tip");
        if (echartsDOM) echartsDOM.style.display = "none";
      }, 900);
    };

    _this.getColor = function (value) {
      if (!value && value != 0) return;
      if (value === "--") return "#333";
      if (value >= 0) return "#F8515C";
      return "#1DA96B";
    };

    _this.state = {};
    return _this;
  }

  _createClass(LineEchart, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var thisProps = this.props || {},
          thisState = this.state || {};
      for (var key in nextProps) {
        if (thisProps[key] !== nextProps[key]) {
          return true;
        }
      }
      for (var _key in nextState) {
        if (thisState[_key] !== nextState[_key]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          xData = _props.xData,
          baseData = _props.baseData,
          xBase = _props.xBase,
          data = _props.data,
          formatter = _props.formatter;

      if (!xData) {
        xData = [];
        data = [];
      }
      if (!xBase) {
        xBase = [];
        baseData = [];
      }
      console.log(xData, baseData, data, formatter);
      this.setEchart(xData, data, xBase, baseData, formatter);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _props2 = this.props,
          xData = _props2.xData,
          baseData = _props2.baseData,
          data = _props2.data,
          xBase = _props2.xBase,
          formatter = _props2.formatter;

      if (!xData) {
        xData = [];
        data = [];
      }
      if (!xBase) {
        xBase = [];
        baseData = [];
      }
      this.setEchart(xData, data, xBase, baseData, formatter);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var myChart = __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.init(document.getElementById("SuperLine"));
    }
  }, {
    key: "render",
    value: function render() {
      var _props$lineDataLast = this.props.lineDataLast,
          lastIncome = _props$lineDataLast.lastIncome,
          lastBase = _props$lineDataLast.lastBase;
      var _props3 = this.props,
          xData = _props3.xData,
          xBase = _props3.xBase;

      if (!xData) {
        xData = [];
      }
      if (!xBase) {
        xBase = [];
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { position: "relative" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { id: "tip", className: "PT_describe", style: { position: "absolute" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "PT_data" },
            "\u672C\u7B56\u7565 ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "PT_describe_colon" },
              ":"
            ),
            !lastIncome && lastIncome != 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: "#333" } },
              "--"
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: this.getColor(lastIncome) } },
              __WEBPACK_IMPORTED_MODULE_7__util___default.a.toPercent(lastIncome)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "PT_base_data" },
            "\u4E1A\u7EE9\u57FA\u51C6 ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "PT_describe_colon" },
              ":"
            ),
            !lastBase && lastBase != 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: "#333" } },
              "--"
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: this.getColor(lastBase) } },
              __WEBPACK_IMPORTED_MODULE_7__util___default.a.toPercent(lastBase)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".24rem", marginLeft: ".1rem" }, src: __webpack_require__(388) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: "SuperLine", style: { width: "100%", height: 360, overflow: "hidden" } })
      );
    }
  }]);

  return LineEchart;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LineEchart);

function setLineOption() {
  var xData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var xBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var baseData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var _formatter = arguments[4];

  // xBase=['2022-07-4','2022-07-5','2022-07-6'];
  // baseData=[1.5,1.6,1.098];
  var xDataN = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(xData), _toConsumableArray(xBase))))).sort();

  var dayIncomeSeries = xData.map(function (v, i) {
    return [v, data[i]];
  });
  var baseSeries = xBase.map(function (v, i) {
    return [v, baseData[i]];
  });
  var option = void 0;
  option = {
    color: ["#BF9B79", "#CAD6E8"],
    grid: {
      left: "0%",
      right: "3%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: [{
      type: "category",
      boundaryGap: false,
      color: "#878787",
      fontSize: 9,
      fontWeight: 600,
      axisLine: {
        lineStyle: {
          width: 1,
          color: "#DFDFDF"
        }
      },
      axisTick: {
        lineStyle: {
          width: 0
        }
      },
      axisLabel: {
        color: "#878787",
        align: "center",
        interval: function interval(index, value) {
          if (index == 0 || index == xDataN.length - 1 || index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) {
            return value;
          }
          return false;
        },
        formatter: function formatter(value, index) {
          if (index == 0) return "{start|" + value.split("/").join("-") + "}";
          if (index == xDataN.length - 1) return "{end|" + value.split("/").join("-") + "}";
          if (index == xDataN.length / 2 - 1 || index == (xDataN.length - 1) / 2) return "{middle|" + value.split("/").join("-") + "}";
        },
        rich: {
          start: {
            width: "200%",
            align: "left"
          },
          end: {
            width: "0%",
            align: "right"
          },
          middle: {
            align: "center"
          }
        }
      },
      data: xDataN
    }],
    yAxis: [{
      type: "value",
      scale: true,
      // name:'(人)',
      axisLine: {
        lineStyle: {
          width: 0
        }
      },
      axisTick: {
        lineStyle: {
          width: 0
        }
      },
      axisLabel: {
        formatter: function formatter(value, index) {
          return __WEBPACK_IMPORTED_MODULE_7__util___default.a.toPercent(value);
        }
      },
      splitLine: {
        lineStyle: {
          color: "#DFDFDF",
          width: 1,
          type: "dotted"
        }
      }
    }],
    animation: window.isLess47,

    tooltip: {
      show: true,
      trigger: "axis",
      alwaysShowContent: true,
      position: [0, 0],
      padding: [0, 0, 0, 0],
      transitionDuration: 0,
      triggerOn: 'mousemove|click',
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#48b",
          width: 1,
          type: "dashed",
          opacity: 1
        }
      },
      backgroundColor: "#FFF",
      extraCssText: "width:100%;",
      formatter: function formatter(params) {
        return _formatter(params);
      }
    },
    calculable: true,

    series: [{
      name: "本策略",
      type: "line",
      smooth: true /*线条有弧度*/
      , data: dayIncomeSeries,
      //animation: false,
      showSymbol: false,
      itemStyle: {
        normal: {}
      },
      areaStyle: {
        normal: {
          color: new __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: "rgba(191, 155, 121, 0.15)"
          }, {
            offset: 1,
            color: "rgba(191, 155, 121, 0)"
          }])
        }
      }
    }, {
      name: "业绩基准",
      type: "line",
      smooth: true,
      data: baseSeries,
      showSymbol: false,
      areaStyle: {
        normal: {
          color: new __WEBPACK_IMPORTED_MODULE_2_echarts_lib_echarts___default.a.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: "rgba(189, 200, 212, 0.15)"
          }, {
            offset: 1,
            color: "rgba(189, 200, 212, 0)"
          }])
        }
      }
    }]
  };

  return option;
}

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Loginkah = function (_Component) {
  _inherits(Loginkah, _Component);

  function Loginkah() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, Loginkah);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Loginkah.__proto__ || Object.getPrototypeOf(Loginkah)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      agreeIndex: 0,
      identityNumber: ""
    }, _this2.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }, _this2.goBacks = function () {
      if (_this2.state.agreeIndex == "1") {
        _this2.setState({
          agreeIndex: 0
        });
      } else {
        _this2.setState({
          agreeIndex: 1
        });
      }
    }, _this2.closeMoadl = function () {
      var _this2$props$location = _this2.props.location.state,
          name = _this2$props$location.name,
          mobileNo = _this2$props$location.mobileNo,
          loginType = _this2$props$location.loginType,
          loginNo = _this2$props$location.loginNo,
          _this = _this2$props$location._this,
          onFun = _this2$props$location.onFun;

      var pattern = /^1[0123456789]\d{9}$/;
      console.log(_this2.props.location.state);
      if (_this2.state.identityNumber.length > 0) {
        if (!pattern.test(_this2.state.identityNumber)) {
          __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确格式邀请码', 2);
          return;
        }
      }
      if (_this2.state.agreeIndex == "1") {
        _this.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["B" /* syncAccount */])({ name: name, loginType: loginType, loginNo: loginNo, mobileNo: mobileNo, invitationCode: _this2.state.identityNumber }, function () {
          _this.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__["l" /* getTbuxyQis */])({ clientType: "APP", token: "" }, function (val) {
            if (val) {
              __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].go(-3);
            }
          }));
        }, function (msg) {
          __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, 2);return;
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info("请先阅读并确认用户同步信息授权书", 2);
        return;
      }
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(Loginkah, [{
    key: 'onChangeText',
    value: function onChangeText(e) {
      this.setState({
        identityNumber: e.target.value
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      console.log(window.localStorage.getItem("inviteCode"));
      if (window.localStorage.getItem("inviteCode")) {
        this.setState({
          identityNumber: window.localStorage.getItem("inviteCode")
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var img_arr = [__webpack_require__(389), __webpack_require__(390)];
      var _props$location$state = this.props.location.state,
          name = _props$location$state.name,
          mobileNo = _props$location$state.mobileNo,
          loginType = _props$location$state.loginType,
          loginNo = _props$location$state.loginNo;

      console.log(this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this3.goBack();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u540C\u6B65\u5F00\u6237'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bars' },
            '\u7CFB\u7EDF\u5373\u5C06\u4E3A\u60A8\u5F00\u901A\u534E\u590F\u8D22\u5BCC\u8D26\u6237'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u59D3\u540D\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8BC1\u4EF6\u7C7B\u578B\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8EAB\u4EFD\u8BC1'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u8BC1\u4EF6\u53F7\u7801\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              loginNo
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u624B\u673A\u53F7\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              mobileNo
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'login-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u9080\u8BF7\u7801\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
                style: { width: "100%" },
                value: this.state.identityNumber,
                onChange: function onChange(e) {
                  return _this3.onChangeText(e);
                },
                placeholder: '\uFF08\u975E\u5FC5\u586B\uFF09\u8BF7\u8F93\u5165\u63A8\u8350\u4EBA\u624B\u673A\u53F7\u7801'

              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: 12, color: "#3a3e47", textAlign: "center", paddingTop: 10, display: "flex", alignItems: "center" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: "0.4rem", height: "0.4rem" }, onClick: this.goBacks, src: img_arr[this.state.agreeIndex] }),
            '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F\u300A\u7528\u6237\u540C\u6B65\u4FE1\u606F\u6388\u6743\u4E66\u300B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: this.closeMoadl, style: { width: "90%", height: "0.7rem", border: "1px solid #000", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px", marginTop: "20px", marginLeft: "5%", borderRadius: "5px" } },
            '\u786E\u8BA4\u5F00\u6237'
          )
        )
      );
    }
  }]);

  return Loginkah;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Loginkah);

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BankCode__ = __webpack_require__(29);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { setSignPrivacyAgreement } from "../../action/publicAction";






var ua = navigator.userAgent.toLowerCase();

var ModalProtocol = function (_Component) {
	_inherits(ModalProtocol, _Component);

	function ModalProtocol(props) {
		var _this2 = this;

		_classCallCheck(this, ModalProtocol);

		var _this = _possibleConstructorReturn(this, (ModalProtocol.__proto__ || Object.getPrototypeOf(ModalProtocol)).call(this, props));

		_this.unAgreeFun = function () {
			_this.setState({
				setModalShow: true
			});
		};

		_this.agreeFun = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, _this2);
		}));

		_this.agreeFunSec = function () {
			_this.setState({
				setModalShow: false
			});
		};

		_this.unAgreeFunSec = function () {
			if (ua.indexOf("amcfmapp") > -1) {
				var have = '没有关闭方法,1秒提示消失';
				if (ua.indexOf("wkwebview") > -1) {
					if (window.webkit) {
						have = '有window.webkit关闭方法,1秒提示消失';
						// Toast.info(have, 1,()=>{
						window.webkit.messageHandlers.amcfm_utils.postMessage({ "refreshHome": "intelInvest" });
						window.webkit.messageHandlers.amcfm_utils.postMessage({ "finish": "" });
						// });
					}
				} else {
					if (window.amcfm_utils) {
						have = '有window.amcfm_utils关闭方法,1秒提示消失';
						// Toast.info(have, 1,()=>{
						window.amcfm_utils.refreshHome('intelInvest');
						window.amcfm_utils.finish();
						// });
					}
				}
			} else {
				// hashHistory.push({
				//     pathname: '/',
				//   });
				// let app_index=sessionStorage.getItem('app_index')-0;
				// if (app_index!=null) {
				//     console.log(app_index-window.history.length)
				//     setTimeout(function(){
				//         alert(app_index)
				//         alert(window.history.length)
				//         hashHistory.go(app_index-window.history.length);
				//     },200)
				// }
				__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].go(1 - window.historyData.length);
				setTimeout(function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_loginAction_js__["h" /* cleanCache */])(_this.props.dispatch);
				});
			}
		};

		_this.ProtocolPaper = function (name) {
			var code = __WEBPACK_IMPORTED_MODULE_8__BankCode__["a" /* protocolCode */][name];
			console.log(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */]);
			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
				pathname: '/WebView',
				state: { name: name, code: code },
				query: { code: code }
			});
		};

		_this.state = {
			setModalShow: false
		};
		return _this;
	}

	_createClass(ModalProtocol, [{
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
				'div',
				{ style: { flex: 1, backgroundColor: "#fff" } },
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								null,
								'\u6E29\u99A8\u63D0\u793A'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					'div',
					{ style: { position: "absolute", top: ua.indexOf("amcfmapp") > -1 ? 0 : 44, bottom: 40, width: "100%", overflow: "auto" } },
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 15 } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								{ style: { fontSize: 12, color: "#3a3e47" } },
								'\u611F\u8C22\u60A8\u4F7F\u7528\u534E\u590F\u8D22\u5BCCAPP\uFF01'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { paddingTop: 10 } },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								{ style: { fontSize: 12, color: "#3a3e47", lineHeight: "20px" } },
								'\u6211\u4EEC\u975E\u5E38\u91CD\u89C6\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u548C\u9690\u79C1\u4FDD\u62A4\u3002\u4E3A\u4E86\u66F4\u597D\u5730\u4FDD\u969C\u60A8\u7684\u4E2A\u4EBA\u6743\u76CA\uFF0C\u5728\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u524D\uFF0C\u8BF7\u60A8\u52A1\u5FC5\u5BA1\u614E\u9605\u8BFB\u3001\u5145\u5206\u7406\u89E3',
								__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'span',
									{ className: 'red-t', onClick: function onClick() {
											_this3.ProtocolPaper('华夏财富用户隐私政策');
										} },
									'\u300A\u534E\u590F\u8D22\u5BCC\u7528\u6237\u9690\u79C1\u653F\u7B56\u300B'
								),
								'\u5404\u6761\u6B3E\uFF0C\u6211\u4EEC\u4F1A\u6309\u7167\u4E0A\u8FF0\u653F\u7B56\u6536\u96C6\u3001\u4F7F\u7528\u548C\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { paddingTop: 10 } },
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								{ style: { fontSize: 12, color: "#3a3e47" } },
								'\u5982\u60A8\u540C\u610F\uFF0C\u8BF7\u70B9\u51FB\u201C\u540C\u610F\u201D\u5F00\u59CB\u63A5\u53D7\u6211\u4EEC\u7684\u670D\u52A1\u3002'
							)
						)
					)
				),
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					'div',
					{ style: { display: "-webkit-flex", height: 40, WebkitFlexDirection: "row", position: "absolute", bottom: 0, width: "100%" } },
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ onClick: this.unAgreeFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1, backgroundColor: "#afb0b2" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'span',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u4E0D\u540C\u610F'
						)
					),
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ onClick: this.agreeFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1, backgroundColor: "#FA063A" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'span',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u540C\u610F'
						)
					)
				),
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ModalList__["a" /* default */], { flag: this.state.setModalShow, title: '\u6E29\u99A8\u63D0\u793A', content: '\u534E\u590F\u8D22\u5BCC\u5C06\u4E25\u683C\u6309\u7167\u4E0A\u8FF0\u653F\u7B56\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\uFF0C\u5982\u60A8\u4E0D\u540C\u610F\u6211\u4EEC\u7684\u653F\u7B56\uFF0C\u5219\u65E0\u6CD5\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u3002', btnLeft: '\u7EE7\u7EED\u9000\u51FA', btnRight: '\u6211\u77E5\u9053\u4E86', btnRightFun: this.agreeFunSec, btnLeftFun: this.unAgreeFunSec })
			);
		}
	}]);

	return ModalProtocol;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

;

var mapStateToProps = function mapStateToProps(state, ownProps) {
	return {};
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(ModalProtocol));

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentSuperFund__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__myAssets_payment_FixedInvestmentSuperFund_js__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Modal_ModalPaySup__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__myAssets_payment_Password__ = __webpack_require__(267);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PaymentAllSuperFund = function (_Component) {
  _inherits(PaymentAllSuperFund, _Component);

  function PaymentAllSuperFund(props) {
    _classCallCheck(this, PaymentAllSuperFund);

    var _this2 = _possibleConstructorReturn(this, (PaymentAllSuperFund.__proto__ || Object.getPrototypeOf(PaymentAllSuperFund)).call(this, props));

    _this2.initActive = function () {
      var sess = sessionStorage.getItem("activeByPaymentAllSuperFund");
      if (sess == "1" || sess == "2") {
        _this2.setState({
          active: sess
        });
      }
    };

    _this2.returnLevelFun = function (val) {
      if (val == "2") {
        return "R2";
      }
      if (val == "3") {
        return "R3";
      }
      if (val == "4") {
        return "R4";
      }
      return "";
    };

    _this2.keyOk = function () {
      if (_this2.childThis) {
        _this2.childThis.keyOk();
      }
    };

    _this2.getChildThis = function (_this) {
      _this2.childThis = _this;
    };

    _this2.close = function (event) {
      event.stopPropagation();
      _this2.state.setState({ pwdFlag: false });
    };

    _this2.onChangePwd = function (val) {
      _this2.setState({
        keyPasswordVal: val
      });
    };

    _this2.state = {
      isShowModal: false,
      hideContent: false,
      isShowModal2: false,
      pwdFlag: false,
      data: [],
      keyPasswordVal: "",
      active: _this2.props.location.state.pageText == "申购" ? 1 : _this2.props.location.state.pageText == "新建定投计划" ? 2 : 1,
      supRiskVal: ""
    };
    _this2.childThis = null;
    return _this2;
  }

  _createClass(PaymentAllSuperFund, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.childThis = null;
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initActive();
      this.hasInvested();
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'handleOk',
    value: function handleOk() {
      this.setState({
        isShowModal: false,
        hideContent: false
      });
      var sess = sessionStorage.getItem("modalShowByTip");
      if (sess) {
        var arr = sess.split(",");
        if (arr.indexOf("zxzf_zt") < 0) {
          arr.push("zxzf_zt");
          sessionStorage.setItem("modalShowByTip", arr.join());
        }
      } else {
        sessionStorage.setItem("modalShowByTip", "zxzf_zt");
      }
    }
  }, {
    key: 'hasInvested',
    value: function hasInvested() {
      var _this3 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_91" /* isInvestmentFlag */])({ superFundCode: this.props.location.state.fundCode }, function (result, riskLevel) {
        if (!result) {
          var sess = sessionStorage.getItem("modalShowByTip");
          if (sess) {
            var arr = sess.split(",");
            if (arr.indexOf("zxzf_zt") < 0) {
              _this3.setState({
                isShowModal: true,
                hideContent: true,
                supRiskVal: _this3.returnLevelFun(riskLevel)
              });
            }
          } else {
            _this3.setState({
              isShowModal: true,
              hideContent: true,
              supRiskVal: _this3.returnLevelFun(riskLevel)
            });
          }
        }
      }));
    }
  }, {
    key: 'choseTab',
    value: function choseTab(i) {
      this.setState({
        active: i,
        isShowModal: false,
        hideContent: false,
        isShowModal2: false,
        pwdFlag: false,
        data: [],
        keyPasswordVal: ""
      });
      sessionStorage.setItem('activeByPaymentAllSuperFund', i);
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["K" /* smSzt */])(0));
    }
  }, {
    key: 'onOk',
    value: function onOk() {
      this.setState({
        isShowModal2: false,
        pwdFlag: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var active = this.state.active;

      var _props = this.props.location.state;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: this.state.hideContent ? "none" : "block" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'headerblacks' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold" } },
                '\u5728\u7EBF\u652F\u4ED8'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "44px" } })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: _props.pageText == "申购" || _props.pageText == "新建定投计划" || _props.pageText == "无定投" ? 'content' : "" },
            _props.pageText == "申购" || _props.pageText == "新建定投计划" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'headerActive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingTop: "5px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      return _this4.choseTab(1);
                    }, style: { fontSize: "20px", fontWeight: "bold" } },
                  '\u8F6C\u5165'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      return _this4.choseTab(2);
                    }, style: { fontSize: "20px", fontWeight: "bold" } },
                  '\u5B9A\u6295'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "flex", paddingTop: "5px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.state.active == 1 ? 'active' : null })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.state.active == 2 ? 'active' : null })
                )
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1 } },
              active == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PaymentSuperFund__["a" /* default */], Object.assign({ parThis: this, keyPasswordVal: this.state.keyPasswordVal }, _props)) : null,
              active == 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__myAssets_payment_FixedInvestmentSuperFund_js__["a" /* default */], Object.assign({ parThis: this, keyPasswordVal: this.state.keyPasswordVal }, _props)) : null
            )
          )
        ),
        this.state.isShowModal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_fundDetail_AlerModle__["f" /* ModalTips */], { title: '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u6295\u8D44\u8005\u98CE\u9669\u63ED\u793A\u4E66', buttonText: '\u6211\u5DF2\u77E5\u6653\u98CE\u9669\uFF0C\u786E\u8BA4\u8D2D\u4E70', handleOk: function handleOk() {
            _this4.handleOk();
          }, verifiedUserInfo: this.props.verifiedUserInfo.content }) : null,
        this.state.isShowModal2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Modal_ModalPaySup__["a" /* default */], { title: '\u5229\u76CA\u5173\u8054\u65B9\u51B2\u7A81\u63D0\u793A', onOK: function onOK() {
            _this4.onOk();
          }, rightButtonTitle: '\u6211\u5DF2\u77E5\u6653', fundName: _props.fundName, data: this.state.data }) : null,
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__myAssets_payment_Password__["a" /* default */], { _this: this, ztFlag: true, _type: 'ZT' }) : null
      );
    }
  }]);

  return PaymentAllSuperFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    verifiedUserInfo: state.verifiedUserInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PaymentAllSuperFund));

/***/ }),
/* 2027 */,
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detailInformation_css__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__detailInformation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__detailInformation_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Performance = function (_Component) {
  _inherits(Performance, _Component);

  function Performance(props) {
    _classCallCheck(this, Performance);

    var _this = _possibleConstructorReturn(this, (Performance.__proto__ || Object.getPrototypeOf(Performance)).call(this, props));

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.state = {};
    return _this;
  }

  _createClass(Performance, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          renderDOM = _props.renderDOM,
          _props$background = _props.background,
          background = _props$background === undefined ? false : _props$background,
          title = _props.title,
          style = _props.style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "" + (background ? "per_container" : 'no_ackground'), style: { backgroundColor: 'transparent' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Performance_content", style: style },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "Performance_title" },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "table_info" },
            renderDOM
          )
        )
      );
    }
  }]);

  return Performance;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Performance));

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PieEcarts__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PositionList__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__position_css__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__position_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__position_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Position = function (_React$PureComponent) {
  _inherits(Position, _React$PureComponent);

  function Position(props) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props));

    _this.toSelectionPool = function () {
      window.open('https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf');
      // window.location.href='https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf'
    };

    _this.toPositionDetails = function () {
      var _this$props = _this.props,
          _this$props$superFund = _this$props.superFundItemFund4StyleTypeList,
          superFundItemFund4StyleTypeList = _this$props$superFund === undefined ? [] : _this$props$superFund,
          _this$props$updateTim = _this$props.updateTimeStr,
          updateTimeStr = _this$props$updateTim === undefined ? "" : _this$props$updateTim;

      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/PositionDetails",
        query: {
          superFundItemFund4StyleTypeList: superFundItemFund4StyleTypeList,
          updateTimeStr: updateTimeStr
        },
        state: {
          superFundItemFund4StyleTypeList: superFundItemFund4StyleTypeList,
          updateTimeStr: updateTimeStr
        }
      });
    };

    _this.toPublicOffering = function (item) {
      if (item.camcOrNonCamcWhiteListFundFlag === "0") return __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("该产品暂不支持交易", __WEBPACK_IMPORTED_MODULE_2__util__["ToastTime"]);
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({ pathname: "/PublicOffering", query: { fundCode: item.fundCode }, state: { fundCode: item.fundCode } });
    };

    _this.renderItem = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "PositionPie_Item_container",
          key: item.fundCode,
          onClick: function onClick() {
            _this.toPublicOffering(item);
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          item.fundName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          item.fundCode
        )
      );
    };

    _this.header = function (v) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "PositionPie_header_container", style: { background: __WEBPACK_IMPORTED_MODULE_2__util___default.a.pieEchartsFundListColorMap.get(v.styleTypeName) } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "PositionPie_title" },
          v.styleTypeName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "Position_totleValue" },
          __WEBPACK_IMPORTED_MODULE_2__util___default.a.toPercent(v.totalRate)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "more_btn", onClick: _this.toPositionDetails },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "\u5171",
            v.subSuperFundItemList.length,
            "\u53EA\uFF0C\u67E5\u770B\u5168\u90E8"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(272) })
        )
      );
    };

    _this.state = {};
    return _this;
  }

  _createClass(Position, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$superFundItemF = _props.superFundItemFund4StyleTypeList,
          superFundItemFund4StyleTypeList = _props$superFundItemF === undefined ? [] : _props$superFundItemF,
          _props$legendData = _props.legendData,
          legendData = _props$legendData === undefined ? [] : _props$legendData,
          _props$seriesData = _props.seriesData,
          seriesData = _props$seriesData === undefined ? [] : _props$seriesData,
          updateTimeStr = _props.updateTimeStr;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "Position_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Position_header" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "Position_title" },
            "\u7B56\u7565\u6301\u4ED3"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "\u66F4\u65B0\u65F6\u95F4\uFF1A",
            updateTimeStr
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "SelectPool_btn", onClick: this.toSelectionPool },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "\u4EA7\u54C1\u5907\u9009\u6C60"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(272) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PieEcarts__["a" /* default */], { height: "140px", legendData: legendData, seriesData: seriesData }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          superFundItemFund4StyleTypeList.map(function (v, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PositionList__["a" /* default */], { key: v.styleType, background: __WEBPACK_IMPORTED_MODULE_2__util___default.a.pieEchartsFundListBgColorMap.get(v.styleTypeName), header: _this2.header(v), renderItem: _this2.renderItem, dataSource: v.subSuperFundItemList.slice(0, 3), topDistance: ".22rem", bottomDistance: ".22rem" });
          })
        )
      );
    }
  }]);

  return Position;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails.superFundBasicInfo,
      superFundBasicInfo = _state$strategiesDeta === undefined ? {} : _state$strategiesDeta;

  return {
    seriesData: superFundBasicInfo.seriesData,
    legendData: superFundBasicInfo.legendData,
    superFundItemFund4StyleTypeList: superFundBasicInfo.superFundItemFund4StyleTypeList,
    updateTimeStr: superFundBasicInfo.updateTimeStr
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(Position)));

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PrivacyAgreement = function (_Component) {
  _inherits(PrivacyAgreement, _Component);

  function PrivacyAgreement(props) {
    _classCallCheck(this, PrivacyAgreement);

    var _this = _possibleConstructorReturn(this, (PrivacyAgreement.__proto__ || Object.getPrototypeOf(PrivacyAgreement)).call(this, props));

    _this.state = {
      title: "华夏财富用户隐私政策"
    };
    return _this;
  }

  _createClass(PrivacyAgreement, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      document.title = this.state.title;
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_webViewContentAction_js__["a" /* getWebViewHtml */])({ name: '华夏财富用户隐私政策', code: 'pro_027' }, function () {
        _this2.succallback();
      }, function (msg) {
        _this2.errcallback(msg);
      }));
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this.state.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { fontSize: '0.36rem', padding: 13 }, dangerouslySetInnerHTML: { __html: this.props.webViewHtml
            } })
        )
      );
    }
  }]);

  return PrivacyAgreement;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    webViewHtml: state.webViewHtml
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PrivacyAgreement));

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_productAction__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RedeemCurrencyList = function (_Component) {
  _inherits(RedeemCurrencyList, _Component);

  function RedeemCurrencyList(props) {
    _classCallCheck(this, RedeemCurrencyList);

    var _this = _possibleConstructorReturn(this, (RedeemCurrencyList.__proto__ || Object.getPrototypeOf(RedeemCurrencyList)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(RedeemCurrencyList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "选择赎回至";
    }
  }, {
    key: 'changeIndex',
    value: function changeIndex(item, i) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_productAction__["J" /* choseCurrencyIndex */])(i));
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dataSouse = this.props.location.state.dataSouse; //nav 传入

      var icon = [__webpack_require__(125), __webpack_require__(151)];
      var currencyIndex = this.props.currencyIndex;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u9009\u62E9\u8D4E\u56DE\u81F3'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          dataSouse.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'currencyList', onClick: function onClick() {
                  return _this2.changeIndex(item, i);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { color: '#3a3f47', fontSize: 16 } },
                  item.fundname,
                  i == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'znyx' }) : null
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { color: '#5c6470' } },
                  item.wanfenshouyi,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: '#e64743' } },
                    item.qirinianhua
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { color: '#a1a7b2' } },
                  '\u4E07\u5206\u6536\u76CA',
                  item.publish_date.substr(-5),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    '7\u65E5\u5E74\u5316\u6536\u76CA'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListRightOK' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: currencyIndex === i ? icon[1] : icon[0], className: 'img' })
              )
            );
          })
        )
      );
    }
  }]);

  return RedeemCurrencyList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    currencyIndex: state.currencyIndex
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(RedeemCurrencyList));

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











function closest(el, selector) {
  var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

var ReservationsManager = function (_Component) {
  _inherits(ReservationsManager, _Component);

  function ReservationsManager(props) {
    _classCallCheck(this, ReservationsManager);

    var _this = _possibleConstructorReturn(this, (ReservationsManager.__proto__ || Object.getPrototypeOf(ReservationsManager)).call(this, props));

    _this.showModal = function (key) {
      return function (e) {
        e.preventDefault(); // 修复 Android 上点击穿透
        _this.setState(_defineProperty({}, key, true));
      };
    };

    _this.onClose = function (key) {
      return function () {
        _this.setState(_defineProperty({}, key, false));
      };
    };

    _this.onWrapTouchStart = function (e) {
      // fix touch to scroll background page on iOS
      if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
        return;
      }
      var pNode = closest(e.target, '.am-modal-content');
      if (!pNode) {
        e.preventDefault();
      }
    };

    _this.state = {
      name: '',
      mobileNum: '',
      VerificationCode: '',
      serverCapchaCode: '',
      imageBase64: '',
      phoneCode: '',
      txt: "获取验证码",
      num: 30,
      isRequestingVerifyCode: false,
      imgCode: true,
      sex: '1',
      modal1: false
    };
    _this.PopDid = false;
    _this.requestId = '';
    _this.intervalId = null;
    return _this;
  }

  _createClass(ReservationsManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // this.props.dispatch(getCapchaCode({scale: 2},(code, imageBase64)=>{console.log('1&&&&&&&&&&'); this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__["e" /* getCapcha */])(function (code, imageBase64) {
        console.log('1&&&&&&&&&&');_this2.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this2.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "理财师", "进入理财师"]);
      document.title = "预约理财师";
      var dispatch = this.props.dispatch;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "理财师", "离开理财师"]);
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'getCapchaCodeSuccess',
    value: function getCapchaCodeSuccess(code, imageBase64) {
      console.log('verifySuccess');
      this.setState({
        serverCapchaCode: code,
        imageBase64: imageBase64,
        getCapchaSuccess: true
      });
    }
  }, {
    key: 'getCapchaCodeAgain',
    value: function getCapchaCodeAgain() {
      var _this3 = this;

      this.setState({
        VerificationCode: ''
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__["e" /* getCapcha */])(function (code, imageBase64) {
        _this3.getCapchaCodeSuccess(code, imageBase64);
      }, function (msg) {
        _this3.getCapchaCodeError(msg);
      }));
    }
  }, {
    key: 'getCapchaCodeError',
    value: function getCapchaCodeError(msg) {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
      this.setState({ getCapchaSuccess: false });
    }
  }, {
    key: 'getVerificationCode',
    value: function getVerificationCode() {
      var _this4 = this;

      var _state = this.state,
          mobileNum = _state.mobileNum,
          serverCapchaCode = _state.serverCapchaCode,
          VerificationCode = _state.VerificationCode;

      var params = {
        mobileNo: mobileNum,
        token: serverCapchaCode,
        captchaCode: VerificationCode.toUpperCase()
      };
      if (!/^1[0123456789]\d{9}$/.test(this.state.mobileNum)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
        return;
      }

      if (this.state.VerificationCode) {
        this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__["d" /* getMobileCaptcha */])(params, function (requestId) {
          _this4.getMobileCaptchaSucc(requestId);
        }, function (succ) {
          _this4.getMobileCaptchaErr(succ);
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入图形验证码', __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
      }

      // this.props.dispatch(getVerifyCode(mobileNum, (requestId)=>{this.requestId = requestId; console.log(requestId)}));
    }
  }, {
    key: 'getMobileCaptchaSucc',
    value: function getMobileCaptchaSucc(requestId) {
      var _this5 = this;

      this.requestId = requestId;
      console.log(requestId);
      var countNum = 119;
      this.setState({ isRequestingVerifyCode: true, num: countNum }, function () {
        _this5.intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            _this5.getCapchaCodeAgain();
            cancelTimeOut();
            _this5.setState({
              isRequestingVerifyCode: false
            });
          }
          _this5.setState({
            num: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (_this5.intervalId) clearInterval(_this5.intervalId);
          _this5.intervalId = null;
        };
      });
    }
  }, {
    key: 'getMobileCaptchaErr',
    value: function getMobileCaptchaErr(succ) {
      __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].show(succ.message, __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
      this.getCapchaCodeAgain();
    }
  }, {
    key: 'handleVerify',
    value: function handleVerify() {
      var _this6 = this;

      if (!/^1[0123456789]\d{9}$/.test(this.state.mobileNum)) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
        return;
      }

      var imgCodeFlag = true;
      if (!this.state.VerificationCode) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入图形验证码', __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
        imgCodeFlag = false;
      }
      if (!imgCodeFlag) {
        return false;
      }

      if (this.requestId === '' || !this.requestId) {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请先申请手机验证码', __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
        return;
      }
      if (this.state.name === "") {
        __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__["Toast"].info('请输入姓名', __WEBPACK_IMPORTED_MODULE_8__util___default.a.ToastTime);
        return;
      }

      var verifyParam = {
        requestId: this.requestId,
        userName: this.state.name,
        mobileNo: this.state.mobileNum,
        captchaCode: this.state.phoneCode,
        sex: this.state.sex
      };
      console.log(verifyParam);
      this.setState({
        loading: true
      });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__["s" /* ReservationManager */])(verifyParam, function (d) {
        _this6.verifySuccess(d);
      }, function (msg) {
        return _this6.verifyError(msg);
      }));
    }
  }, {
    key: 'verifySuccess',
    value: function verifySuccess(data) {
      window._czc.push(["_trackEvent", "华夏财富H5", "理财师", "立即预约btn"]);
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
      document.getElementsByTagName('body')[0].setAttribute('ontouchmove', "event.preventDefault()");
      console.log(data);
      if (data === true) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        this.setState({
          modal1: true,
          name: "",
          mobileNum: "",
          phoneCode: "",
          VerificationCode: "",
          isRequestingVerifyCode: false
        });
      }
    }
  }, {
    key: 'verifyError',
    value: function verifyError(msg) {}
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this,
          _ref;

      var width = window.screen.width;
      var height = window.screen.height;
      var _state2 = this.state,
          imgCode = _state2.imgCode,
          mobileNum = _state2.mobileNum,
          name = _state2.name,
          VerificationCode = _state2.VerificationCode;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBg_manager' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'header_bg', style: { width: "100%", height: width * (2080 / 1125) } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: width * (2080 / 1125) * (600 / 2080) } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conBotton' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'inputContent', style: { paddingLeft: width * (65 / 1125), paddingRight: width * (65 / 1125) } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingLeft: 13, paddingRight: 13, background: "#FFF", height: "auto", borderRadius: 10, paddingBottom: 20 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'inputName' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'labal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      '\u59D3'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      '\u540D'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lineCut', style: { marginLeft: 12 } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'inputWrap' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'textInput', placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u59D3\u540D', value: name, onChange: function onChange(e) {
                        _this7.setState({ name: e.target.value });
                      } })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'inputName' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'labal' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      '\u624B'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      '\u673A'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      '\u53F7'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lineCut', style: { marginLeft: 12 } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'inputWrap' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'textInput', placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u624B\u673A\u53F7', value: mobileNum, onChange: function onChange(e) {
                        _this7.setState({ mobileNum: e.target.value });
                      } })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'inputName' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'labalTwo' },
                    '\u56FE\u5F62\u9A8C\u8BC1\u7801'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lineCut' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'inputWrap' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'textInput', placeholder: '\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801', value: this.state.VerificationCode, onChange: function onChange(e) {
                        _this7.setState({ VerificationCode: e.target.value });
                      } })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        _this7.getCapchaCodeAgain();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: {
                        width: 63,
                        height: 27
                      }, src: 'data:image/png;base64,' + this.state.imageBase64 })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'inputName' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'labalTwo' },
                    '\u77ED\u4FE1\u9A8C\u8BC1\u7801'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lineCut' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'inputWrap' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'textInput', placeholder: '\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801', value: this.state.phoneCode, onChange: function onChange(e) {
                        _this7.setState({ phoneCode: e.target.value });
                      } })
                  ),
                  !this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { onClick: function onClick() {
                        return _this7.getVerificationCode();
                      }, className: 'getCodeBg' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { color: "#FFF", fontSize: 12, backgroundColor: "rgba(0,0,0,0)" } },
                      this.state.txt
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'getCodeBg' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { color: "#FFF", fontSize: 12, backgroundColor: "rgba(0,0,0,0)" } },
                      this.state.num + "S"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      return _this7.handleVerify();
                    }, style: (_ref = {
                      borderRadius: 20,
                      backgroundColor: "#fa063a",
                      height: 42
                    }, _defineProperty(_ref, 'borderRadius', 20), _defineProperty(_ref, 'WebkitFlexDirection', 'row'), _defineProperty(_ref, 'WebkitAlignItems', 'center'), _defineProperty(_ref, 'WebkitJustifyContent', 'center'), _defineProperty(_ref, 'display', "-webkit-flex"), _defineProperty(_ref, 'marginTop', 15), _ref) },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: '#ffffff', fontSize: 17 } },
                    '\u7ACB\u5373\u9884\u7EA6'
                  )
                )
              )
            )
          )
        ),
        this.state.modal1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__fundDetail_AlerModle__["g" /* AlerModleLcs */], { content: '\u9884\u7EA6\u6210\u529F\uFF0C\u7406\u8D22\u5E08\u5C06\u5728\u4E09\u4E2A\u5DE5\u4F5C\u65E5\u5185\u4E0E\u60A8\u8054\u7CFB\uFF0C\u8BF7\u4FDD\u6301\u7535\u8BDD\u7545\u901A\u3002', CloseAler: function CloseAler() {
            _this7.setState({ modal1: false });
          } }) : null
      );
    }
  }]);

  return ReservationsManager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ReservationsManager));

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PieEcarts__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__position_css__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__position_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__position_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Position = function (_React$PureComponent) {
  _inherits(Position, _React$PureComponent);

  function Position(props) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, (Position.__proto__ || Object.getPrototypeOf(Position)).call(this, props));

    _this.toSelectionPool = function () {
      window.open('https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf');
      // window.location.href='https://app.amcfortune.com/wAppStatic/AlternativeFund.pdf'
    };

    _this.state = {};
    return _this;
  }

  _createClass(Position, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          _props$legendData = _props.legendData,
          legendData = _props$legendData === undefined ? [] : _props$legendData,
          _props$seriesData = _props.seriesData,
          seriesData = _props$seriesData === undefined ? [] : _props$seriesData,
          updateTimeStr = _props.updateTimeStr;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "Position_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Position_header" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "Position_title" },
            "\u7B56\u7565\u6301\u4ED3"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            "\u66F4\u65B0\u65F6\u95F4\uFF1A",
            updateTimeStr
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "SelectPool_btn", onClick: this.toSelectionPool },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "\u4EA7\u54C1\u5907\u9009\u6C60"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(272) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PieEcarts__["a" /* default */], { height: "140px", legendData: legendData, seriesData: seriesData })
      );
    }
  }]);

  return Position;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails.superFundBasicInfo,
      superFundBasicInfo = _state$strategiesDeta === undefined ? {} : _state$strategiesDeta;

  return {
    seriesData: superFundBasicInfo.seriesData,
    legendData: superFundBasicInfo.legendData,
    updateTimeStr: superFundBasicInfo.updateTimeStr
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(Position)));

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









//http://localhost:3000/#/SubscriptionDetail?enterType=SubscriptionDetail

var SubscriptionDetail = function (_Component) {
  _inherits(SubscriptionDetail, _Component);

  function SubscriptionDetail(props) {
    _classCallCheck(this, SubscriptionDetail);

    var _this = _possibleConstructorReturn(this, (SubscriptionDetail.__proto__ || Object.getPrototypeOf(SubscriptionDetail)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(SubscriptionDetail, [{
    key: 'callBack',
    value: function callBack() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["f" /* getSupperFundHome */])({}, this.callBack, this));
    }
  }, {
    key: 'goPay',
    value: function goPay() {
      var params = {
        fundName: "华夏3年封闭运作战略配售",
        fundCode: '501186',
        businessType: 'T020',
        productType: 'G',
        fundType: '股票型',
        enterType: 'SubscriptionDetail'
      };
      var fun = function fun() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */], 'Payment');
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["t" /* goHXJJLogin */])(fun, window.history.length);
    }
  }, {
    key: 'Process',
    value: function Process() {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({
        pathname: '/SubscriptionDetailTwo',
        state: {
          pathname: '/SubscriptionDetailTwo'
        },
        query: {
          enterType: 'SubscriptionDetail'
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var SupperFundHome = this.props.SupperFundHome;

      console.log(SupperFundHome);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { flex: 1 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.screen.width, height: window.screen.width * (7449 / 645) }, className: 'SubscriptionDetailBanner' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 40, width: "100%" } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { height: 40, display: "-webkit-flex", WebkitFlexDirection: 'row', position: "fixed", bottom: 0, width: "100%" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this2.Process();
              }, style: { WebkitFlex: 2, borderTop: '#e1e3e6 solid 1px', display: "-webkit-flex", WebkitJustifyContent: 'center', WebkitAlignItems: 'center', background: "#FFF" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: '0.3rem', color: 'rgb(90,99,112)' } },
              '\u4E86\u89E3\u6295\u8D44\u6D41\u7A0B'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this2.goPay();
              }, style: { WebkitFlex: 2, height: 40, backgroundColor: "#fa063a", color: '#FFF', fontSize: '0.3rem', display: "-webkit-flex", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u7ACB\u5373\u8BA4\u8D2D'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal_ModalSelect__["a" /* default */], null)
      );
    }
  }]);

  return SubscriptionDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SubscriptionDetail));

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SubscriptionDetailTwo = function (_Component) {
  _inherits(SubscriptionDetailTwo, _Component);

  function SubscriptionDetailTwo(props) {
    _classCallCheck(this, SubscriptionDetailTwo);

    var _this = _possibleConstructorReturn(this, (SubscriptionDetailTwo.__proto__ || Object.getPrototypeOf(SubscriptionDetailTwo)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(SubscriptionDetailTwo, [{
    key: 'callBack',
    value: function callBack() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["f" /* getSupperFundHome */])({}, this.callBack, this));
    }
  }, {
    key: 'goPay',
    value: function goPay() {
      var params = {
        fundName: "华夏3年封闭运作战略配售",
        fundCode: '501186',
        businessType: 'T020',
        productType: 'G',
        fundType: '股票型',
        enterType: 'SubscriptionDetail'
      };
      var fun = function fun() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */], 'Payment');
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["t" /* goHXJJLogin */])(fun, window.history.length);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var SupperFundHome = this.props.SupperFundHome;

      console.log(SupperFundHome);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { flex: 1 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: window.screen.width, height: window.screen.width * (3312 / 640) }, className: 'SubscriptionDetailTwoBanner' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 40, width: "100%" } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              return _this2.goPay();
            }, style: { position: "fixed", bottom: 0, width: "100%", height: 40, backgroundColor: "#fa063a", color: '#FFF', fontSize: '0.3rem', display: "-webkit-flex", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u7ACB\u5373\u8BA4\u8D2D'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Modal_ModalSelect__["a" /* default */], null)
      );
    }
  }]);

  return SubscriptionDetailTwo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SubscriptionDetailTwo));

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__superFundDetailTab_css__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__superFundDetailTab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__superFundDetailTab_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LineEchartPerformanceTrends_js__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_ModalDetail__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SuperFundDetailTab = function (_Component) {
  _inherits(SuperFundDetailTab, _Component);

  function SuperFundDetailTab(props) {
    _classCallCheck(this, SuperFundDetailTab);

    var _this = _possibleConstructorReturn(this, (SuperFundDetailTab.__proto__ || Object.getPrototypeOf(SuperFundDetailTab)).call(this, props));

    _this.showWenHaoView = function (event, val) {
      event.stopPropagation();
      if (val == "盈利客户占比") {
        _this.setState({
          tipFlag: true,
          tsText: ["该策略累计收益为正的用户数/该策略累计服务用户数"]
        });
      } else if (val == "客户委托管理平均时长") {
        _this.setState({
          tipFlag: true,
          tsText: ["该策略累计服务用户数持仓天数之和/该策略累计服务用户数"]
        });
      }
    };

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.changeTab = function (value) {
      if (value === 1) _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_portfolioAction__["j" /* getEvaluationIndicator */])({ superFundCode: _this.props.superFundCode }, function (data) {
        _this.setState({
          evaluationIndicator: data
        });
      }));
      _this.setState({ tab: value });
    };

    _this.state = {
      tab: 0,
      resultShow: false,
      tsText: [],
      tipFlag: false,
      evaluationIndicator: {}
    };
    return _this;
  }

  _createClass(SuperFundDetailTab, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var evaluationIndicator = this.state.evaluationIndicator;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "Line_Tab_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Line_Tab" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                _this2.changeTab(0);
              },
              className: this.state.tab === 0 ? "tab_active  first_tab" : "first_tab"
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "\u7B56\u7565\u4E1A\u7EE9\u8868\u73B0"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              onClick: function onClick() {
                _this2.changeTab(1);
              },
              className: this.state.tab === 1 ? "tab_active" : ""
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "\u7B56\u7565\u8BC4\u4EF7\u6307\u6807"
            )
          )
        ),
        this.state.tab == 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Tab_content" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "Line_tip" },
            "\u4E1A\u7EE9\u8D70\u52BF"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LineEchartPerformanceTrends_js__["a" /* default */], null)
        ),
        this.state.tab == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "Tab_second" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "Tab_second_infos" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "Tab_second_infos_item" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "Tab_infos_value" },
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.toPercent(evaluationIndicator.profitCustRatio)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "Tab_infos_tip" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "\u76C8\u5229\u5BA2\u6237\u5360\u6BD4"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                    onClick: function onClick(event) {
                      _this2.showWenHaoView(event, "盈利客户占比");
                    }
                    /* onClick={this.handleAlert} */, style: { width: ".24rem", marginLeft: ".1rem" },
                    src: __webpack_require__(675)
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "Tab_second_infos_item" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "Tab_infos_value" },
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.processingDecimal(evaluationIndicator.custTrustManageAvgTime, 1),
                  "\u5929"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "Tab_infos_tip" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    "span",
                    null,
                    "\u5BA2\u6237\u59D4\u6258\u7BA1\u7406\u5E73\u5747\u65F6\u957F"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
                    onClick: function onClick(event) {
                      _this2.showWenHaoView(event, "客户委托管理平均时长");
                    },
                    style: { width: ".24rem", marginLeft: ".1rem" },
                    src: __webpack_require__(675)
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "Tab_second_infos_updata_time" },
              "\u66F4\u65B0\u65F6\u95F4\uFF1A",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { style: {} },
                evaluationIndicator.updateTime || '--'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modal_ModalDetail__["a" /* default */], {
          flag: this.state.tipFlag,
          rightButtonTitle: "\u77E5\u9053\u4E86",
          titleBC: true,
          content: this.state.tsText,
          onOK: function onOK() {
            _this2.setState({ tipFlag: false });
          }
        })
      );
    }
  }]);

  return SuperFundDetailTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SuperFundDetailTab));

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_webViewContentAction_js__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_js__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SuperFundSigning = function (_Component) {
  _inherits(SuperFundSigning, _Component);

  function SuperFundSigning(props) {
    _classCallCheck(this, SuperFundSigning);

    var _this = _possibleConstructorReturn(this, (SuperFundSigning.__proto__ || Object.getPrototypeOf(SuperFundSigning)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(SuperFundSigning, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      var params = this.props.location.state;
      // dispatch(getWebViewHtml(params, ()=>{this.succallback()}, (msg)=>{this.errcallback(msg)}));
      // document.title =this.props.location.state.name
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'signSuperAccAgreement',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var userInfo, userMsg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__common_js__["d" /* getStorage */])('currentUserInfo');

              case 2:
                userInfo = _context.sent;
                userMsg = userInfo.userMsg;

                if (!(userMsg && userMsg.certType != "0")) {
                  _context.next = 7;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('为了保障您的交易体验，投顾服务暂不支持非身份证用户签约/投资。', __WEBPACK_IMPORTED_MODULE_8__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 7:
                if (!(userMsg && new Date().getTime() - userMsg.birthday < 568080000000)) {
                  _context.next = 10;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('为了保障您的交易体验，投顾服务暂不对18周岁以下用户开放。', __WEBPACK_IMPORTED_MODULE_8__util_js___default.a.ToastTime);
                return _context.abrupt('return');

              case 10:
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_investmentAction__["_74" /* signSuperFundAccAgreement */])({ state: 1, operator: "user" }, function (e) {
                  __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
                  console.log(e, "签约成功///////");
                  __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("签约成功", __WEBPACK_IMPORTED_MODULE_8__util_js___default.a.ToastTime);
                  setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
                  }, 2000);
                  setTimeout(function () {
                    _this2.props.location.state.callback();
                  }, 2200);
                  console.log(_this2.props.location, "this.props.locationthis.props.location");
                }));

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signSuperAccAgreement() {
        return _ref.apply(this, arguments);
      }

      return signSuperAccAgreement;
    }()
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              "签约"
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content ', style: { background: "#FFF", paddingBottom: 45 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'qy_read_title' },
            '\u8BF7\u60A8\u9605\u8BFB\u5E76\u540C\u610F\u4EE5\u4E0B\u5185\u5BB9\uFF1A'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { padding: 13 }, className: 'qy_read_content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\uFF1A\u6295\u8D44\u8005'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\uFF1A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6839\u636E\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6CD5\u300B\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u300A\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6CD5\u300B\u201D\uFF09\u3001\u300A\u5173\u4E8E\u505A\u597D\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u8BD5\u70B9\u5DE5\u4F5C\u7684\u901A\u77E5\u300B\uFF08\u4E2D\u56FD\u8BC1\u5238\u76D1\u7763\u7BA1\u7406\u59D4\u5458\u4F1A\u673A\u6784\u90E8\u51FD[2019]2515\u53F7\uFF09\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u300A\u901A\u77E5\u300B\u201D\uFF09\u7B49\u6709\u5173\u6CD5\u5F8B\u6CD5\u89C4\u548C\u89C4\u8303\u6027\u6587\u4EF6\u7684\u89C4\u5B9A\uFF0C\u7532\u65B9\u81EA\u613F\u7533\u8BF7\u4F7F\u7528\u4E59\u65B9\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u4E3A\u660E\u786E\u53CC\u65B9\u7684\u6743\u5229\u548C\u4E49\u52A1\uFF0C\u7ECF\u53CC\u65B9\u53CB\u597D\u534F\u5546\uFF0C\u7B7E\u8BA2\u672C\u534F\u8BAE\u3002\u672C\u534F\u8BAE\u901A\u8FC7\u4E59\u65B9\u5E73\u53F0\u6216\u5176\u6307\u5B9A\u7684\u57FA\u91D1\u9500\u552E\u673A\u6784\u5E73\u53F0\u4EE5\u7535\u5B50\u65B9\u5F0F\u7B7E\u7F72\uFF0C\u7532\u65B9\u53EF\u901A\u8FC7\u201C\u52FE\u9009\u201D\u3001\u70B9\u51FB\u201C\u540C\u610F\u7B7E\u7EA6\u201D\u6216\u4E2A\u4EBA\u7535\u5B50\u7B7E\u540D\u7B49\u65B9\u5F0F\u4E0E\u4E59\u65B9\u4E66\u9762\u7B7E\u7F72\u672C\u534F\u8BAE\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E00\u7AE0 \u98CE\u9669\u63ED\u793A\u53CA\u514D\u8D23'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E00\u6761 \u98CE\u9669\u63ED\u793A'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E3A\u4E59\u65B9\u63A5\u53D7\u7532\u65B9\u59D4\u6258\uFF0C\u6309\u7167\u7EA6\u5B9A\u5411\u6295\u8D44\u8005\u63D0\u4F9B\u7684\u6839\u636E\u6295\u8D44\u8005\u4E2A\u4EBA\u60C5\u51B5\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u6784\u5EFA\u6295\u8D44\u7EC4\u5408\u53CA\u6295\u8D44\u4EA4\u6613\u7684\u6295\u8D44\u987E\u95EE\u670D\u52A1\u5DE5\u5177\uFF0C\u5176\u5B9E\u8D28\u4E3A\u8D2D\u4E70\u7279\u5B9A\u6295\u8D44\u7EC4\u5408\u6240\u5305\u542B\u7684\u516C\u52DF\u57FA\u91D1\u4EA7\u54C1\u6216\u4E2D\u56FD\u8BC1\u76D1\u4F1A\u8BA4\u53EF\u7684\u5176\u4ED6\u4EA7\u54C1\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u6210\u4EFD\u57FA\u91D1\u201D\uFF09\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u8BF7\u7532\u65B9\u52A1\u5FC5\u4E8E\u7533\u8BF7\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u4E4B\u524D\uFF0C\u8BA4\u771F\u3001\u5168\u9762\u3001\u7EC6\u81F4\u5730\u9605\u8BFB\u672C\u534F\u8BAE\u3001\u4E59\u65B9\u53CA\u57FA\u91D1\u6295\u987E\u7EC4\u5408\u4E2D\u6210\u4EFD\u57FA\u91D1\u7684\u9500\u552E\u673A\u6784\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u201D\uFF09\uFF08\u5982\u6709\uFF09\u7684\u4E1A\u52A1\u89C4\u5219\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4E0E\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u4E1A\u52A1\u89C4\u5219\u3001\u8D44\u91D1\u4EA4\u6536\u89C4\u5219\u7B49\uFF09\u53CA\u57FA\u91D1\u6295\u987E\u7EC4\u5408\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u3001\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\uFF0C\u5145\u5206\u4E86\u89E3\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u89C4\u5219\u3001\u6536\u8D39\u65B9\u5F0F\u3001\u514D\u8D23\u60C5\u5F62\u7B49\u5185\u5BB9\u3002\u82E5\u7532\u65B9\u4E0D\u63A5\u53D7\u672C\u534F\u8BAE\u5F53\u4E2D\u4EFB\u4F55\u6761\u6B3E\u3001\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u4E1A\u52A1\u89C4\u5219\u53CA\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u3001\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u4E2D\u7684\u4EFB\u4F55\u5185\u5BB9\uFF0C\u8BF7\u52FF\u8FDB\u884C\u201C\u52FE\u9009\u201D\u3001\u70B9\u51FB\u201C\u540C\u610F\u7B7E\u7EA6\u201D\u6216\u5176\u4ED6\u65B9\u5F0F\u7535\u5B50\u7B7E\u7F72\u672C\u534F\u8BAE\uFF0C\u4EA6\u4E0D\u5F97\u4F7F\u7528\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u3002\u7532\u65B9\u4E0D\u5F97\u4EE5\u672A\u4ED4\u7EC6\u9605\u8BFB\u672C\u534F\u8BAE\u3001\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u4E1A\u52A1\u89C4\u5219\u53CA\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u3001\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u7684\u5168\u90E8\u6216\u90E8\u5206\u7EA6\u5B9A\u4E3A\u7531\u63D0\u51FA\u76F8\u5173\u7684\u6743\u5229\u4E3B\u5F20\u6216\u6297\u8FA9\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u7532\u65B9\u5E94\u5F53\u7ED3\u5408\u81EA\u8EAB\u7684\u6295\u8D44\u7ECF\u5386\u3001\u98CE\u9669\u627F\u53D7\u80FD\u529B\u3001\u8D44\u4EA7\u914D\u7F6E\u9700\u8981\u3001\u6D41\u52A8\u6027\u9700\u6C42\u7B49\u7279\u5F81\uFF0C\u81EA\u4E3B\u51B3\u7B56\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u5E76\u72EC\u7ACB\u627F\u62C5\u6295\u8D44\u98CE\u9669\u3002 \u4E59\u65B9\u4ECE\u4E8B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\uFF0C\u5E94\u5F53\u9075\u5B88\u6CD5\u5F8B\u6CD5\u89C4\u548C\u4E2D\u56FD\u8BC1\u76D1\u4F1A\u7684\u76F8\u5173\u89C4\u5B9A\uFF0C\u9075\u5FAA\u8BDA\u5B9E\u4FE1\u7528\u539F\u5219\uFF0C\u9632\u8303\u5229\u76CA\u51B2\u7A81\uFF0C\u5207\u5B9E\u7EF4\u62A4\u7532\u65B9\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u52E4\u52C9\u3001\u5BA1\u614E\u5730\u4E3A\u7532\u65B9\u63D0\u4F9B\u670D\u52A1\u3002\u867D\u7136\u4E59\u65B9\u5DF2\u7ECF\u5728\u4E2D\u56FD\u8BC1\u5238\u76D1\u7763\u7BA1\u7406\u59D4\u5458\u4F1A\u5907\u6848\uFF0C\u5177\u6709\u4ECE\u4E8B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u8BD5\u70B9\u8D44\u683C\uFF0C\u4F46\u8BE5\u5907\u6848\u4E0D\u6784\u6210\u5BF9\u6295\u8D44\u987E\u95EE\u673A\u6784\u6295\u8D44\u80FD\u529B\u3001\u6301\u7EED\u5408\u89C4\u60C5\u51B5\u7684\u8BA4\u53EF\uFF0C\u4E0D\u4F5C\u4E3A\u5BF9\u57FA\u91D1\u8D22\u4EA7\u5B89\u5168\u7684\u4FDD\u8BC1\u3002\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u5C1A\u5904\u4E8E\u8BD5\u70B9\u9636\u6BB5\uFF0C\u5B58\u5728\u56E0\u4E59\u65B9\u8BD5\u70B9\u8D44\u683C\u88AB\u53D6\u6D88\u4E0D\u80FD\u7EE7\u7EED\u63D0\u4F9B\u670D\u52A1\u7684\u98CE\u9669\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u7532\u65B9\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u5C06\u89C6\u4E3A\u7532\u65B9\u6388\u6743\u4E59\u65B9\u884C\u4F7F\u7EA6\u5B9A\u6743\u9650\u7684\u8D26\u6237\u7BA1\u7406\u6743\uFF0C\u6388\u6743\u4E59\u65B9\u81EA\u884C\u5411\u6210\u4EFD\u57FA\u91D1\u7BA1\u7406\u4EBA\u51FA\u5177\u6210\u4EFD\u57FA\u91D1\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u6307\u4EE4\u4EE5\u53CA\u6295\u987E\u670D\u52A1\u8D39\u5212\u6B3E\uFF08\u6216\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\uFF09\uFF0C\u4EE3\u7532\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u51FA\u5177\u6210\u4EFD\u57FA\u91D1\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u6307\u4EE4\u4EE5\u53CA\u6295\u987E\u670D\u52A1\u8D39\u5212\u6B3E\uFF08\u6216\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\uFF09\u6307\u4EE4\uFF0C\u4E59\u65B9\u5C06\u6839\u636E\u65E2\u5B9A\u7684\u6295\u8D44\u7B56\u7565\u548C\u7EC4\u5408\u6784\u5EFA\u7A0B\u5E8F\u63D0\u51FA\u6295\u8D44\u987E\u95EE\u5EFA\u8BAE\uFF0C\u6388\u6743\u4E59\u65B9\u6309\u7167\u76F8\u5173\u6D41\u7A0B\u548C\u89C4\u8303\u5E2E\u52A9\u7532\u65B9\u6784\u5EFA\u6295\u8D44\u7EC4\u5408\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u3001\u8C03\u4ED3\u7B49\uFF09\u3002\u7532\u65B9\u4F7F\u7528\u4E59\u65B9\u63D0\u4F9B\u7684\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u5E94\u7F34\u7EB3\u4E00\u5B9A\u6BD4\u4F8B\u7684\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u3002\u7532\u65B9\u8BA4\u53EF\u4E59\u65B9\u5236\u5B9A\u7684\u8BA1\u8D39\u6807\u51C6\u53CA\u6536\u8D39\u89C4\u5219\uFF0C\u540C\u610F\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u8BA1\u7B97\u5E94\u5411\u7532\u65B9\u6536\u53D6\u7684\u57FA\u91D1\u6295\u987E\u670D\u52A1\u8D39\uFF0C\u901A\u8FC7\u6295\u987E\u670D\u52A1\u8D39\u5212\u6B3E\uFF08\u6216\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\uFF09\u7B49\u76D1\u7BA1\u8BA4\u53EF\u7684\u65B9\u5F0F\u5B9E\u73B0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u7684\u6536\u53D6\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E09\uFF09\u7532\u65B9\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u8D26\u6237\u4E0B\u7684\u6295\u8D44\u7EC4\u5408\uFF0C\u5B9E\u8D28\u662F\u6309\u7167\u6295\u8D44\u5EFA\u8BAE\u7684\u8D44\u4EA7\u5206\u914D\u6BD4\u4F8B\uFF0C\u4E00\u6B21\u6027\u8BA4/\u7533\u8D2D\u8BE5\u6295\u8D44\u7EC4\u5408\u5185\u7684\u6240\u6709\u6210\u4EFD\u57FA\u91D1\u3002\u7532\u65B9\u5728\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u524D\uFF0C\u5E94\u5F53\u77E5\u6089\u6295\u8D44\u7EC4\u5408\u7684\u98CE\u9669\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u7B7E\u7F72\u98CE\u9669\u63ED\u793A\u4E66\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u56DB\uFF09\u6295\u8D44\u7EC4\u5408\u5185\u6210\u4EFD\u57FA\u91D1\u7684\u98CE\u9669\u4E00\u822C\u5305\u62EC\u56E0\u6574\u4F53\u653F\u6CBB\u3001\u7ECF\u6D4E\u3001\u793E\u4F1A\u7B49\u73AF\u5883\u56E0\u7D20\u5BF9\u8BC1\u5238\u4EF7\u683C\u4EA7\u751F\u5F71\u54CD\u800C\u5F62\u6210\u7684\u7CFB\u7EDF\u6027\u98CE\u9669\uFF0C\u4E2A\u522B\u8BC1\u5238\u7279\u6709\u7684\u975E\u7CFB\u7EDF\u6027\u98CE\u9669\uFF0C\u7531\u4E8E\u57FA\u91D1\u6295\u8D44\u8005\u8FDE\u7EED\u5927\u91CF\u8D4E\u56DE\u57FA\u91D1\u4EA7\u751F\u7684\u6D41\u52A8\u6027\u98CE\u9669\uFF0C\u57FA\u91D1\u7BA1\u7406\u4EBA\u5728\u57FA\u91D1\u7BA1\u7406\u5B9E\u65BD\u8FC7\u7A0B\u4E2D\u4EA7\u751F\u7684\u57FA\u91D1\u7BA1\u7406\u98CE\u9669\uFF0C\u6210\u4EFD\u57FA\u91D1\u7684\u7279\u5B9A\u98CE\u9669\u7B49\u7B49\u3002\u6295\u8D44\u7EC4\u5408\u5185\u5404\u6210\u4EFD\u57FA\u91D1\u7684\u5177\u4F53\u60C5\u51B5\u53EF\u53C2\u89C1\u300A\u57FA\u91D1\u5408\u540C\u300B\u3001\u300A\u62DB\u52DF\u8BF4\u660E\u4E66\u300B\u3001\u300A\u53D1\u552E\u516C\u544A\u300B\u7B49\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E94\uFF09\u4E3A\u4E86\u65B9\u4FBF\u7532\u65B9\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u4E59\u65B9\u5C06\u5BF9\u6295\u987E\u8D26\u6237\u7684\u7B7E\u7EA6\u4E0E\u89E3\u7EA6\u4EE5\u53CA\u6295\u8D44\u7EC4\u5408\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8C03\u4ED3\u3001\u5206\u7EA2\u7B49\u4E1A\u52A1\u8BBE\u5B9A\u7279\u5B9A\u7684\u4E1A\u52A1\u89C4\u5219\uFF0C\u7532\u65B9\u5E94\u8BE5\u5145\u5206\u4E86\u89E3\u5E76\u63A5\u53D7\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u4E1A\u52A1\u89C4\u5219\uFF0C\u5426\u5219\u7532\u65B9\u4E0D\u5F97\u901A\u8FC7\u4E59\u65B9\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u3002\u4E59\u65B9\u6709\u6743\u6839\u636E\u4E1A\u52A1\u5F00\u5C55\u60C5\u51B5\uFF0C\u5BF9\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8FDB\u884C\u5347\u7EA7\u3001\u6539\u8FDB\uFF0C\u751A\u81F3\u6682\u505C\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u76F8\u5173\u53D8\u5316\u5E94\u53CA\u65F6\u5411\u7532\u65B9\u5C65\u884C\u62AB\u9732\u4E49\u52A1\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u516D\uFF09\u4E3A\u5E2E\u52A9\u7532\u65B9\u5236\u5B9A\u6295\u8D44\u51B3\u7B56\uFF0C\u4E59\u65B9\u8BBE\u8BA1\u4E86\u6559\u80B2\u3001\u517B\u8001\u7B49\u60C5\u666F\u4E0B\u7684\u6295\u8D44\u89C4\u5212\u6A21\u62DF\u5E76\u51FA\u5177\u6295\u8D44\u65B9\u6848\u5EFA\u8BAE\uFF0C\u8BE5\u6A21\u62DF\u662F\u4F7F\u7528\u5E02\u573A\u4E2D\u5177\u6709\u4EE3\u8868\u6027\u7684\u6307\u6570\u4E2D\u957F\u671F\u7684\u5386\u53F2\u5E74\u5316\u5E73\u5747\u6536\u76CA\u7387\u8BA1\u7B97\uFF0C\u672A\u6765\u7531\u4E8E\u5E02\u573A\u73AF\u5883\u4E0D\u540C\u3001\u5B9E\u9645\u6295\u8D44\u8FD0\u4F5C\u7B49\u4E0D\u53EF\u80FD\u5B8C\u5168\u590D\u5236\u5176\u6A21\u62DF\u7ED3\u679C\u3002\u8BE5\u6A21\u62DF\u4E0D\u4F5C\u4E3A\u6295\u8D44\u9884\u6D4B\uFF0C\u4E5F\u4E0D\u4EE3\u8868\u6295\u8D44\u8005\u5B9E\u9645\u6295\u8D44\u6240\u5F97\u6536\u76CA\uFF0C\u6295\u8D44\u4E5F\u53EF\u80FD\u906D\u9047\u4E8F\u635F\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E8C\u6761 \u514D\u8D23\u6761\u6B3E'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7531\u4E59\u65B9\u6839\u636E\u4E00\u5B9A\u7684\u6295\u8D44\u7B56\u7565\u6216\u6295\u8D44\u76EE\u6807\u63D0\u4F9B\uFF0C\u4E59\u65B9\u4E0D\u5BF9\u5EFA\u8BAE\u914D\u7F6E\u7684\u6295\u8D44\u7EC4\u5408\u8FDB\u884C\u4EFB\u4F55\u5B9E\u8D28\u7684\u5224\u65AD\uFF0C\u4E0D\u4FDD\u8BC1\u6295\u8D44\u7EC4\u5408\u4E00\u5B9A\u76C8\u5229\u3002\u8D44\u672C\u5E02\u573A\u7684\u53D1\u5C55\u65E0\u6CD5\u9884\u6D4B\uFF0C\u7EC4\u5408\u8FC7\u5F80\u4E1A\u7EE9\u5E76\u4E0D\u9884\u793A\u5176\u672A\u6765\u8868\u73B0\u3002\u4E59\u65B9\u4E0D\u5BF9\u57FA\u91D1\u6536\u76CA\u72B6\u51B5\u6216\u672C\u91D1\u4E0D\u53D7\u635F\u5931\u4F5C\u51FA\u4EFB\u4F55\u627F\u8BFA\uFF0C\u7532\u65B9\u901A\u8FC7\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8FDB\u884C\u7684\u57FA\u91D1\u6295\u8D44\u4ECD\u7136\u5B58\u5728\u6295\u8D44\u4E8F\u635F\u7684\u98CE\u9669\uFF0C\u6295\u8D44\u8005\u9700\u81EA\u884C\u627F\u62C5\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u4EFB\u4F55\u6295\u8D44\u90FD\u53EF\u80FD\u4EA7\u751F\u635F\u5931\uFF0C\u4E59\u65B9\u9009\u62E9\u7684\u7279\u5B9A\u6210\u4EFD\u57FA\u91D1\u53EF\u80FD\u5728\u4E00\u6BB5\u65F6\u95F4\u5185\u7684\u6536\u76CA\u7387\u60C5\u51B5\u8F83\u5DEE\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E09\uFF09\u4E59\u65B9\u53D7\u7406\u7532\u65B9\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7533\u8BF7\uFF0C\u4E0D\u4EE3\u8868\u7532\u65B9\u53D1\u8D77\u7684\u4E00\u7CFB\u5217\u5177\u4F53\u4EA4\u6613\uFF08\u6295\u8D44\u7EC4\u5408\u6784\u5EFA\u3001\u8C03\u4ED3\u7B49\uFF09\u4E00\u5B9A\u6210\u529F\uFF0C\u5404\u9879\u4E1A\u52A1\u53EF\u80FD\u53D7\u57FA\u91D1\u6CE8\u518C\u767B\u8BB0\u673A\u6784\u4E1A\u52A1\u89C4\u5219\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E1A\u52A1\u89C4\u5219\u5F71\u54CD\u800C\u5168\u90E8\u5931\u8D25\u6216\u8005\u90E8\u5206\u5931\u8D25\uFF0C\u5177\u4F53\u60C5\u5F62\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6682\u505C\u7533\u8D2D\u3001\u6682\u505C\u8D4E\u56DE\u3001\u7533\u8D2D\u9650\u989D\u3001\u8D4E\u56DE\u9650\u989D\u3001\u5DE8\u989D\u8D4E\u56DE\u3001\u6682\u505C\u5B9A\u671F\u5B9A\u989D\u6295\u8D44\u7B49\uFF0C\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u65E0\u9700\u5BF9\u4E1A\u52A1\u5931\u8D25\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u56DB\uFF09\u4E3A\u4E86\u4FBF\u4E8E\u7532\u65B9\u4E86\u89E3\u6295\u8D44\u7EC4\u5408\u7684\u6574\u4F53\u6295\u8D44\u8868\u73B0\uFF0C\u4E59\u65B9\u5C06\u6A21\u62DF\u8BA1\u7B97\u6295\u8D44\u7EC4\u5408\u7684\u51C0\u503C\u3001\u635F\u76CA\u7B49\u6570\u636E\uFF0C\u8BE5\u7B49\u6570\u636E\u4EC5\u4F9B\u7532\u65B9\u53C2\u8003\uFF0C\u4E0D\u6784\u6210\u7532\u65B9\u5B9E\u9645\u6295\u8D44\u6536\u76CA\u8BC1\u660E\u6216\u4F5C\u4E3A\u4EFB\u4F55\u5F62\u5F0F\u7684\u8BC1\u636E\u4F7F\u7528\uFF0C\u7532\u65B9\u5B9E\u9645\u6295\u8D44\u635F\u76CA\u4EE5\u6295\u8D44\u7EC4\u5408\u6210\u4EFD\u57FA\u91D1\u7684\u57FA\u91D1\u7BA1\u7406\u4EBA\u62AB\u9732\u6570\u636E\u4E3A\u51C6\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E94\uFF09\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5C06\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u901A\u8FC7\u77ED\u4FE1\u3001\u90AE\u4EF6\u3001\u4E59\u65B9\u81EA\u6709\u7EBF\u4E0A\u5E73\u53F0\u5185\u90E8\u4FE1\u606F\u63A8\u9001\u65B9\u5F0F\u4E2D\u7684\u81F3\u5C11\u4E00\u79CD\u65B9\u5F0F\u5411\u7532\u65B9\u63A8\u9001\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u8FD0\u4F5C\u4FE1\u606F\uFF0C\u4F46\u4E0D\u4FDD\u8BC1\u4E00\u5B9A\u9001\u8FBE\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u516D\uFF09\u5982\u9047\u81EA\u7136\u707E\u5BB3\u7B49\u4E0D\u53EF\u6297\u529B\u4E8B\u4EF6\uFF0C\u6216\u5176\u4ED6\u4E0D\u53EF\u9884\u89C1\u7684\u975E\u5E38\u60C5\u51B5\uFF0C\u6216\u7F51\u7EDC\u3001\u901A\u8BAF\u6545\u969C\u53D1\u751F\u7B49\uFF0C\u5BFC\u81F4\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u65E0\u6CD5\u5C65\u884C\u534F\u8BAE\u7684\uFF0C\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E8C\u7AE0 \u534F\u8BAE\u6761\u6B3E'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E00\u6761 \u5B9A\u4E49'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\uFF1A\u6307\u4E59\u65B9\u63A5\u53D7\u7532\u65B9\u59D4\u6258\uFF0C\u6309\u7167\u672C\u534F\u8BAE\u7EA6\u5B9A\u5411\u7532\u65B9\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u5EFA\u8BAE\uFF0C\u4EE3\u7532\u65B9\u505A\u51FA\u5177\u4F53\u57FA\u91D1\u6295\u8D44\u54C1\u79CD\u3001\u6570\u91CF\u548C\u4E70\u5356\u65F6\u673A\u7684\u51B3\u7B56\uFF0C\u7531\u4E59\u65B9\u6216\u4E59\u65B9\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4EE3\u7532\u65B9\u6267\u884C\u6210\u4EFD\u57FA\u91D1\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u7533\u8BF7\uFF08\u542B\u901A\u8FC7\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6307\u5B9A\u7684\u8D27\u5E01\u5E02\u573A\u57FA\u91D1\u8FDB\u884C\u64CD\u4F5C\uFF09\uFF0C\u5E76\u76F4\u63A5\u6216\u95F4\u63A5\u83B7\u53D6\u7ECF\u6D4E\u5229\u76CA\uFF08\u5982\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF09\u7684\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\uFF1A\u6307\u4E0E\u4E59\u65B9\u7B7E\u7F72\u5408\u4F5C\u534F\u8BAE\u5E76\u6309\u7167\u8BE5\u534F\u8BAE\u7EA6\u5B9A\u53CA\u6709\u5173\u4E1A\u52A1\u89C4\u5219\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4E59\u65B9\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u81EA\u8EAB\u7684\u4E1A\u52A1\u89C4\u5219\u53CA\u4E59\u65B9\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5408\u4F5C\u4E1A\u52A1\u89C4\u5219\uFF09\uFF0C\u4E3A\u7532\u65B9\u5F00\u7ACB\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\uFF0C\u63A5\u53D7\u4E59\u65B9\u64CD\u4F5C\u6307\u4EE4\uFF0C\u4EE3\u7532\u65B9\u6267\u884C\u6210\u4EFD\u57FA\u91D1\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u7533\u8BF7\uFF08\u542B\u901A\u8FC7\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6307\u5B9A\u7684\u8D27\u5E01\u5E02\u573A\u57FA\u91D1\u8FDB\u884C\u64CD\u4F5C\uFF09\uFF0C\u5411\u7532\u65B9\u63D0\u4F9B\u76F8\u5173\u670D\u52A1\u7684\u57FA\u91D1\u9500\u552E\u673A\u6784\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6295\u987E\u8D26\u6237\u5F00\u7ACB\uFF1A\u6307\u7532\u65B9\u4E0E\u4E59\u65B9\u7B7E\u7F72\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\uFF0C\u6388\u6743\u4E59\u65B9\u4E3A\u7532\u65B9\u5F00\u7ACB\u8FDB\u884C\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\uFF0C\u5E76\u884C\u4F7F\u7EA6\u5B9A\u6743\u9650\u7684\u8D26\u6237\u7BA1\u7406\u6743\uFF1B\u6216\u6388\u6743\u4E0E\u4E59\u65B9\u5408\u4F5C\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E3A\u7532\u65B9\u5F00\u7ACB\u7684\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\uFF08\u5982\u9700\uFF09\uFF0C\u6388\u6743\u4E59\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u53D1\u9001\u5BF9\u5E94\u64CD\u4F5C\u6307\u4EE4\uFF0C\u7531\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6309\u7167\u4E0E\u4E59\u65B9\u7B7E\u7F72\u7684\u5408\u4F5C\u534F\u8BAE\u7684\u7EA6\u5B9A\u53CA\u6709\u5173\u4E1A\u52A1\u89C4\u5219\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4E59\u65B9\u81EA\u8EAB\u4E1A\u52A1\u89C4\u5219\u3001\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u81EA\u8EAB\u4E1A\u52A1\u89C4\u5219\u53CA\u4E59\u65B9\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5408\u4F5C\u4E1A\u52A1\u89C4\u5219\uFF09\u5BF9\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u8FDB\u884C\u64CD\u4F5C\u3002\u7532\u65B9\u6309\u57FA\u91D1\u9500\u552E\u6709\u5173\u89C4\u5B9A\u5F00\u7ACB\u7684\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u4F5C\u4E3A\u5176\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u6388\u6743\u8D26\u6237\u3002\u4E59\u65B9\u6839\u636E\u7532\u65B9\u7684\u6388\u6743\u5728\u4E59\u65B9\u6216\u4E59\u65B9\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7CFB\u7EDF\u6807\u8BC6\u7532\u65B9\u6295\u8D44\u7EC4\u5408\u5BF9\u5E94\u7684\u6295\u987E\u8D26\u6237\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6295\u8D44\u7EC4\u5408\uFF1A\u6307\u7531\u4E59\u65B9\u6839\u636E\u4E00\u5B9A\u7684\u6295\u8D44\u7B56\u7565\u6216\u6295\u8D44\u76EE\u6807\u6784\u5EFA\u7684\uFF0C\u7531\u82E5\u5E72\u53EA\u516C\u52DF\u57FA\u91D1\u4EA7\u54C1\u6216\u4E2D\u56FD\u8BC1\u76D1\u4F1A\u8BA4\u53EF\u7684\u5176\u4ED6\u4EA7\u54C1\u6784\u6210\u7684\u8D44\u4EA7\u7EC4\u5408\uFF0C\u5305\u62EC\u6295\u8D44\u8303\u56F4\u3001\u6295\u8D44\u9650\u5236\u3001\u6295\u8D44\u7B56\u7565\u3001\u4E1A\u7EE9\u6BD4\u8F83\u57FA\u51C6\u3001\u6295\u987E\u670D\u52A1\u8D39\u7387\u7B49\u3002\u6295\u8D44\u8005\u5728\u9009\u62E9\u5177\u4F53\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u524D\uFF0C\u5E94\u4ED4\u7EC6\u9605\u8BFB\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\uFF0C\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u5C5E\u4E8E\u672C\u534F\u8BAE\u7684\u7EC4\u6210\u90E8\u5206\u3002\u6295\u8D44\u7EC4\u5408\u672C\u8EAB\u5E76\u975E\u4EFB\u4F55\u5F62\u5F0F\u7684\u4EA7\u54C1\u6216\u96C6\u5408\u6295\u8D44\u8BA1\u5212\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6210\u4EFD\u57FA\u91D1\uFF1A\u6307\u6295\u8D44\u7EC4\u5408\u6240\u5305\u542B\u7684\u6240\u6709\u516C\u52DF\u57FA\u91D1\u4EA7\u54C1\u6216\u4E2D\u56FD\u8BC1\u76D1\u4F1A\u8BA4\u53EF\u7684\u5176\u4ED6\u4EA7\u54C1\uFF0C\u6839\u636E\u7279\u5B9A\u7684\u6295\u8D44\u7B56\u7565\u6216\u8005\u6295\u8D44\u76EE\u6807\uFF0C\u4E59\u65B9\u53EF\u80FD\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5BF9\u6295\u8D44\u7EC4\u5408\u7684\u6210\u4EFD\u57FA\u91D1\u6216\u8005\u6210\u4EFD\u57FA\u91D1\u7684\u8D44\u4EA7\u914D\u7F6E\u6BD4\u4F8B\u505A\u51FA\u8C03\u6574\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7EC4\u5408\u8D2D\u4E70\uFF1A\u6307\u7532\u65B9\u901A\u8FC7\u4E59\u65B9\u81EA\u6709\u5E73\u53F0\u6216\u4E59\u65B9\u5408\u4F5C\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5E73\u53F0\u8D2D\u4E70\u6295\u8D44\u7EC4\u5408\uFF0C\u5B9E\u8D28\u662F\u6388\u6743\u4E59\u65B9\u6309\u7167\u7532\u65B9\u9009\u62E9\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\uFF0C\u4EE3\u7532\u65B9\u505A\u51FA\u5177\u4F53\u57FA\u91D1\u6295\u8D44\u54C1\u79CD\u3001\u6570\u91CF\u548C\u8D2D\u4E70\u65F6\u673A\u4EA4\u6613\u51B3\u7B56\uFF0C\u6309\u7167\u6295\u8D44\u7EC4\u5408\u9884\u8BBE\u7684\u8D44\u4EA7\u914D\u7F6E\u6BD4\u4F8B\uFF0C\u901A\u8FC7\u4E59\u65B9\u6216\u4EE3\u7532\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u51FA\u5177\u57FA\u91D1\u4EA7\u54C1\u8BA4/\u7533\u8D2D\u6307\u4EE4\u4E00\u6B21\u6027\u8BA4/\u7533\u8D2D\u6295\u8D44\u7EC4\u5408\u5185\u6240\u6709\u7684\u6210\u4EFD\u57FA\u91D1\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7EC4\u5408\u8D4E\u56DE\uFF1A\u6307\u7532\u65B9\u901A\u8FC7\u4E59\u65B9\u81EA\u6709\u5E73\u53F0\u6216\u4E59\u65B9\u5408\u4F5C\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u901A\u8FC7\u4E59\u65B9\u6216\u4EE3\u7532\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u51FA\u5177\u6210\u4EFD\u57FA\u91D1\u8D4E\u56DE\u6307\u4EE4\uFF0C\u5BF9\u5DF2\u6301\u6709\u6295\u8D44\u7EC4\u5408\u5185\u7684\u6210\u4EFD\u57FA\u91D1\u8FDB\u884C\u5168\u90E8\u6216\u8005\u6309\u6BD4\u4F8B\u8D4E\u56DE\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7EC4\u5408\u8C03\u4ED3\uFF1A\u6307\u7532\u65B9\u6388\u6743\u4E59\u65B9\u5BF9\u7532\u65B9\u5DF2\u6301\u6709\u6295\u8D44\u7EC4\u5408\u5411\u76EE\u6807\u6295\u8D44\u7EC4\u5408\u8FDB\u884C\u8C03\u6574\u7684\u884C\u4E3A\uFF0C\u5B9E\u8D28\u662F\u9488\u5BF9\u7EC4\u5408\u4E2D\u7684\u4E00\u7CFB\u5217\u6210\u4EFD\u57FA\u91D1\u8FDB\u884C\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u6216\u8F6C\u6362\uFF0C\u4E59\u65B9\u53EF\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u53D1\u51FA\u76F8\u5173\u6307\u4EE4\u5B9E\u73B0\u76F8\u5173\u884C\u4E3A\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u51C0\u6295\u8D44\u989D\uFF1A\u6307\u7532\u65B9\u521D\u59CB\u6295\u8D44\u989D\u52A0\u4E0A\u5386\u6B21\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u8F67\u5DEE\u91D1\u989D\u540E\u7684\u4EF7\u503C\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5DE5\u4F5C\u65E5\uFF1A\u6307\u4E0A\u6D77\u8BC1\u5238\u4EA4\u6613\u6240\u3001\u6DF1\u5733\u8BC1\u5238\u4EA4\u6613\u6240\u7684\u6B63\u5E38\u4EA4\u6613\u65E5\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF1A\u662F\u6307\u4E59\u65B9\u6839\u636E\u6240\u63D0\u4F9B\u7684\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u6536\u53D6\u7684\u4E00\u5B9A\u8D39\u7528\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u670D\u52A1\u8FD0\u4F5C\u671F\uFF1A\u6307\u4E59\u65B9\u63A5\u53D7\u7532\u65B9\u59D4\u6258\uFF0C\u5411\u7532\u65B9\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u671F\u9650\uFF08\u5982\u6709\uFF09\u3002\u5177\u4F53\u65F6\u95F4\u89C1\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E8C\u6761 \u5F53\u4E8B\u4EBA\u7684\u6743\u5229\u4E49\u52A1'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u7532\u65B9\u7684\u6743\u5229\u4E49\u52A1'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u7532\u65B9\u7684\u6743\u5229'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF081\uFF09\u7532\u65B9\u6709\u6743\u8981\u6C42\u4E59\u65B9\u6839\u636E\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF0C\u529E\u7406\u6295\u987E\u8D26\u6237\u5F00\u7ACB\u3001\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u5F00\u7ACB\u3001\u7EC4\u5408\u8D2D\u4E70\u3001\u7EC4\u5408\u8C03\u4ED3\u3001\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u3001\u5206\u7EA2\u7B49\u6709\u5173\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\uFF0C\u4E59\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u53D1\u51FA\u76F8\u5173\u6307\u4EE4\u4EE5\u5B8C\u6210\u4E0A\u8FF0\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u76F8\u5173\u884C\u4E3A\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF082\uFF09\u5176\u4ED6\u6CD5\u5F8B\u6CD5\u89C4\u3001\u89C4\u8303\u6027\u6587\u4EF6\u89C4\u5B9A\u53CA\u672C\u534F\u8BAE\u7EA6\u5B9A\u7532\u65B9\u5E94\u4EAB\u6709\u7684\u4E49\u52A1\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u7532\u65B9\u7684\u4E49\u52A1'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF081\uFF09\u8BA4\u771F\u9605\u8BFB\u5E76\u9075\u5B88\u672C\u534F\u8BAE\u3001\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u4E1A\u52A1\u89C4\u5219\u53CA\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u3001\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\uFF0C\u660E\u786E\u77E5\u6089\u5E76\u627F\u62C5\u57FA\u91D1\u7EC4\u5408\u6295\u8D44\u7684\u98CE\u9669\uFF1B'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF082\uFF09\u8BA4\u771F\u9605\u8BFB\u5E76\u7B7E\u7F72\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\uFF1B'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF083\uFF09\u5145\u5206\u5168\u9762\u4E86\u89E3\u672C\u534F\u8BAE\u53CA\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u7EA6\u5B9A\u7684\u57FA\u91D1\u7EC4\u5408\u7B56\u7565\uFF0C\u5982\u5B9E\u586B\u5199\u98CE\u9669\u8BC6\u522B\u548C\u627F\u62C5\u80FD\u529B\u8C03\u67E5\u95EE\u5377\uFF0C\u544A\u77E5\u76F8\u5173\u4FE1\u606F\uFF0C\u5E76\u5BF9\u5176\u771F\u5B9E\u6027\u3001\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u8D1F\u8D23\uFF0C\u524D\u8FF0\u4FE1\u606F\u5982\u53D1\u751F\u5B9E\u8D28\u6027\u53D8\u66F4\uFF0C\u5E94\u53CA\u65F6\u544A\u77E5\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u5176\u4ED6\u57FA\u91D1\u9500\u552E\u673A\u6784\uFF1B'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF084\uFF09\u4EE5\u771F\u5B9E\u8EAB\u4EFD\u548C\u81EA\u6709\u8D44\u91D1\u53C2\u4E0E\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u4FDD\u8BC1\u8D44\u91D1\u6765\u6E90\u7B26\u5408\u56FD\u5BB6\u6709\u5173\u89C4\u5B9A\uFF1B'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF085\uFF09\u6309\u7167\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF08\u6536\u8D39\u9879\u76EE\u3001\u6536\u8D39\u6807\u51C6\u548C\u652F\u4ED8\u65B9\u5F0F\u7B49\uFF09\uFF0C\u7F34\u7EB3\u53C2\u4E0E\u6B3E\u9879\uFF0C\u5E76\u652F\u4ED8\u76F8\u5173\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF08\u5982\u6709\uFF09\u53CA\u6210\u4EFD\u57FA\u91D1\u6536\u53D6\u7684\u6709\u5173\u4EA4\u6613\u8D39\u7528\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF086\uFF09\u7532\u65B9\u5E94\u660E\u786E\u77E5\u6089\u5176\u662F\u4E0E\u6295\u8D44\u987E\u95EE\u670D\u52A1\u9879\u4E0B\u57FA\u91D1\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7B49\u7EA7\u8FDB\u884C\u9002\u5F53\u6027\u5339\u914D\uFF0C\u57FA\u91D1\u7EC4\u5408\u7B56\u7565\u4E2D\u53EF\u80FD\u4F1A\u6709\u4E2A\u522B\u57FA\u91D1\u4E0E\u7532\u65B9\u7684\u6295\u8D44\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E0D\u5339\u914D\uFF0C\u7532\u65B9\u5728\u6B64\u4E0D\u53EF\u64A4\u9500\u5730\u627F\u8BA4\u5E76\u540C\u610F\u4E59\u65B9\u53EF\u6839\u636E\u5176\u8D44\u4EA7\u914D\u7F6E\u7B56\u7565\u4E3A\u5BA2\u6237\u914D\u7F6E\u8BE5\u7B49\u57FA\u91D1\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF087\uFF09\u7532\u65B9\u786E\u8BA4\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D26\u6237\u9879\u4E0B\u57FA\u91D1\u7EC4\u5408\u4E2D\u7684\u4EFB\u4E00\u57FA\u91D1\u53EC\u5F00\u57FA\u91D1\u4EFD\u989D\u6301\u6709\u4EBA\u5927\u4F1A\uFF0C\u5373\u6784\u6210\u7532\u65B9\u5DF2\u6309\u7167\u672C\u534F\u8BAE\u7EA6\u5B9A\u4E0D\u53EF\u64A4\u9500\u5730\u6388\u6743\u4E59\u65B9\u51FA\u5E2D\u76F8\u5E94\u7684\u57FA\u91D1\u4EFD\u989D\u6301\u6709\u4EBA\u5927\u4F1A\u5E76\u4EE3\u7532\u65B9\u884C\u4F7F\u8868\u51B3\u6743\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF088\uFF09\u7532\u65B9\u5E94\u6839\u636E\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\u53CA\u4E59\u65B9\u548C\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E1A\u52A1\u89C4\u5219\uFF0C\u5168\u6743\u6388\u6743\u4E59\u65B9\u548C\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u529E\u7406\u6295\u987E\u8D26\u6237\u5F00\u7ACB\u3001\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u5F00\u7ACB\u3001\u7EC4\u5408\u8D2D\u4E70\uFF08\u542B\u5931\u8D25\u4E1A\u52A1\u5904\u7406\uFF09\u3001\u7EC4\u5408\u8C03\u4ED3\uFF08\u542B\u5931\u8D25\u4E1A\u52A1\u5904\u7406\uFF09\u3001\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u3001\u5206\u7EA2\u3001\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u6536\u53D6\uFF08\u542B\u901A\u8FC7\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6307\u5B9A\u7684\u8D27\u5E01\u5E02\u573A\u57FA\u91D1\u8FDB\u884C\u64CD\u4F5C\uFF09\u7B49\u6709\u5173\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\uFF0C\u4E0D\u5E72\u6D89\u4E14\u4E0D\u64A4\u9500\u6295\u8D44\u987E\u95EE\u505A\u51FA\u7684\u8C03\u4ED3\u6307\u4EE4\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF089\uFF09\u5176\u4ED6\u6CD5\u5F8B\u6CD5\u89C4\u3001\u89C4\u8303\u6027\u6587\u4EF6\u53CA\u672C\u534F\u8BAE\u7EA6\u5B9A\u7532\u65B9\u5E94\u5C3D\u7684\u4E49\u52A1\u3002'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u4E59\u65B9\u7684\u6743\u5229\u4E49\u52A1'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u4E59\u65B9\u7684\u6743\u5229'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF081\uFF09\u4E59\u65B9\u6709\u6743\u6839\u636E\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\u53CA\u81EA\u8EAB\u4E1A\u52A1\u89C4\u5219\uFF0C\u4E3A\u6295\u8D44\u8005\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u5EFA\u8BAE\uFF0C\u4EE3\u7532\u65B9\u529E\u7406\u6295\u987E\u8D26\u6237\u5F00\u7ACB\u3001\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u5F00\u7ACB\uFF0C\u7EC4\u5408\u8D2D\u4E70\uFF08\u542B\u5931\u8D25\u4E1A\u52A1\u5904\u7406\uFF09\u3001\u7EC4\u5408\u8C03\u4ED3\uFF08\u542B\u5931\u8D25\u4E1A\u52A1\u5904\u7406\uFF09\u3001\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u3001\u5206\u7EA2\u3001\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u6536\u53D6\u7B49\u6709\u5173\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u6D89\u53CA\u7684\u4EA4\u6613\u7533\u8BF7\uFF08\u542B\u901A\u8FC7\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6307\u5B9A\u7684\u8D27\u5E01\u5E02\u573A\u57FA\u91D1\u8FDB\u884C\u64CD\u4F5C\uFF09\uFF0C\u901A\u8FC7\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6267\u884C\u524D\u8FF0\u4EA4\u6613\u6307\u4EE4\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF082\uFF09\u4E59\u65B9\u6709\u6743\u6839\u636E\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF0C\u6309\u7167\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7B7E\u7F72\u7684\u5408\u4F5C\u534F\u8BAE\u7684\u7EA6\u5B9A\u53CA\u6709\u5173\u4E1A\u52A1\u89C4\u5219\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4E59\u65B9\u81EA\u8EAB\u4E1A\u52A1\u89C4\u5219\u3001\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u81EA\u8EAB\u4E1A\u52A1\u89C4\u5219\u53CA\u4E59\u65B9\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5408\u4F5C\u4E1A\u52A1\u89C4\u5219\uFF09\uFF0C\u4EE3\u7532\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u51FA\u5177\u6210\u4EFD\u57FA\u91D1\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\u6307\u4EE4\u4EE5\u53CA\u6295\u987E\u670D\u52A1\u8D39\u5212\u6B3E\uFF08\u6216\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\uFF09\u6307\u4EE4\uFF0C\u76F8\u5173\u4EA4\u6613\u6307\u4EE4\u6216\u5212\u6B3E\uFF08\u6216\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\uFF09\u6307\u4EE4\u7684\u6267\u884C\u7ED3\u679C\u7531\u6295\u8D44\u8005\u81EA\u884C\u627F\u62C5\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF083\uFF09\u4E59\u65B9\u6709\u6743\u6839\u636E\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u6536\u8D39\u9879\u76EE\u3001\u6536\u8D39\u6807\u51C6\u548C\u652F\u4ED8\u65B9\u5F0F\uFF0C\u5411\u7532\u65B9\u6536\u53D6\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF08\u5982\u6709\uFF09\u53CA\u6210\u4EFD\u57FA\u91D1\u6536\u53D6\u7684\u6709\u5173\u4EA4\u6613\u8D39\u7528\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF084\uFF09\u5176\u4ED6\u6CD5\u5F8B\u6CD5\u89C4\u3001\u89C4\u8303\u6027\u6587\u4EF6\u53CA\u672C\u534F\u8BAE\u7EA6\u5B9A\u4E59\u65B9\u5E94\u4EAB\u6709\u7684\u6743\u5229\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u4E59\u65B9\u7684\u4E49\u52A1'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u4ECE\u4E8B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u5E94\u5F53\u606A\u5C3D\u804C\u5B88\uFF0C\u5C65\u884C\u8BDA\u5B9E\u4FE1\u7528\u3001\u8C28\u614E\u52E4\u52C9\u7684\u4E49\u52A1\u3002\u7EF4\u62A4\u6295\u8D44\u884C\u4E1A\u7684\u5B8C\u6574\u6027\uFF0C\u4F18\u5148\u7EF4\u62A4\u6295\u8D44\u8005\u7684\u5229\u76CA\u3002\u9075\u5B88\u81EA\u613F\u3001\u516C\u5E73\u3001\u8BDA\u5B9E\u4FE1\u7528\u7684\u57FA\u672C\u539F\u5219\uFF0C\u4E0D\u5F97\u5229\u7528\u81EA\u8EAB\u4F18\u52BF\u5730\u4F4D\u635F\u5BB3\u6295\u8D44\u8005\u5229\u76CA\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u5E94\u6839\u636E\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\u53CA\u81EA\u8EAB\u4E1A\u52A1\u89C4\u5219\uFF0C\u6216\u6839\u636E\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7B7E\u7F72\u7684\u5408\u4F5C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF0C\u4EE3\u7532\u65B9\u529E\u7406\u6295\u987E\u8D26\u6237\u5F00\u7ACB\u3001\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u5F00\u7ACB\u3001\u7EC4\u5408\u8D2D\u4E70\u3001\u7EC4\u5408\u8C03\u4ED3\u3001\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u3001\u5206\u7EA2\u7B49\u6709\u5173\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\uFF0C\u6216\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4EE3\u7532\u65B9\u529E\u7406\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u5F00\u7ACB\u3001\u7EC4\u5408\u8D2D\u4E70\u3001\u7EC4\u5408\u8C03\u4ED3\u3001\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u3001\u5206\u7EA2\u7B49\u6709\u5173\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5728\u4E59\u65B9\u9996\u6B21\u63A5\u89E6\u666E\u901A\u6295\u8D44\u8005\u5E76\u5411\u5176\u63D0\u4F9B\u670D\u52A1\u524D\uFF0C\u4E59\u65B9\u5E94\u5F53\u63D0\u793A\u7532\u65B9\u53EF\u4EE5\u901A\u8FC7\u5F55\u97F3\u3001\u622A\u5C4F\u7B49\u65B9\u5F0F\u7559\u5B58\u76F8\u5173\u4FE1\u606F\u3002\u901A\u8FC7\u4E92\u8054\u7F51\u5728\u7EBF\u65B9\u5F0F\u63D0\u4F9B\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\uFF0C\u5E94\u5F53\u5411\u7532\u65B9\u63D0\u4F9B\u8BB0\u5F55\u3001\u4FDD\u5B58\u3001\u4E0B\u8F7D\u7B49\u7559\u75D5\u529F\u80FD\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u63D0\u793A\u7532\u65B9\u6CE8\u610F\u4EFB\u4F55\u5B9E\u9645\u6216\u6F5C\u5728\u7684\u5229\u76CA\u51B2\u7A81\u3002\u4E59\u65B9\u5E94\u5C3D\u5408\u7406\u7684\u6CE8\u610F\u4E49\u52A1\u548C\u72EC\u7ACB\u7684\u4E13\u4E1A\u5224\u65AD\u8FDB\u884C\u6295\u8D44\u5206\u6790\uFF0C\u51FA\u5177\u6295\u8D44\u5EFA\u8BAE\uFF0C\u91C7\u53D6\u6295\u8D44\u884C\u4E3A\u548C\u4ECE\u4E8B\u5176\u4ED6\u4E13\u4E1A\u6D3B\u52A8\u3002\u7EF4\u62A4\u8D44\u672C\u5E02\u573A\u76F8\u5173\u89C4\u5219\uFF0C\u9075\u5B88\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u7EF4\u62A4\u5E76\u63D0\u9AD8\u81EA\u8EAB\u4E13\u4E1A\u80FD\u529B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u4FDD\u8BC1\u7532\u65B9\u5408\u6CD5\u6743\u76CA\uFF0C\u4E59\u65B9\u5E94\u5F53\u5EFA\u7ACB\u5065\u5168\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7BA1\u7406\u5236\u5EA6\u3001\u5408\u89C4\u7BA1\u7406\u548C\u98CE\u9669\u63A7\u5236\u673A\u5236\uFF0C\u4E86\u89E3\u7532\u65B9\u7684\u8EAB\u4EFD\u3001\u8D22\u4EA7\u4E0E\u6536\u5165\u72B6\u51B5\u3001\u8BC1\u5238\u6295\u8D44\u7ECF\u9A8C\u3001\u6295\u8D44\u9700\u6C42\u4E0E\u98CE\u9669\u504F\u597D\uFF0C\u8BC4\u4F30\u7532\u65B9\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\uFF0C\u4E59\u65B9\u5E94\u5F53\u4E86\u89E3\u7532\u65B9\u7684\u60C5\u51B5\uFF0C\u5728\u8BC4\u4F30\u98CE\u9669\u627F\u53D7\u80FD\u529B\u548C\u670D\u52A1\u9700\u6C42\u7684\u57FA\u7840\u4E0A\uFF0C\u5411\u7532\u65B9\u63D0\u4F9B\u9002\u5F53\u7684\u6295\u8D44\u5EFA\u8BAE\u670D\u52A1\u3002\u4E59\u65B9\u5E94\u5F53\u901A\u8FC7\u81EA\u8EAB\u5E73\u53F0\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5E73\u53F0\u5411\u7532\u65B9\u8FDB\u884C\u98CE\u9669\u63ED\u793A\uFF0C\u8FDB\u884C\u4E1A\u52A1\u63A8\u5E7F\u65F6\u4E0D\u5F97\u5BF9\u5176\u670D\u52A1\u80FD\u529B\u548C\u8FC7\u5F80\u4E1A\u7EE9\u8FDB\u884C\u865A\u5047\u3001\u4E0D\u5B9E\u3001\u8BEF\u5BFC\u6027\u7684\u8425\u9500\u5BA3\u4F20\uFF0C\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u5411\u7532\u65B9\u627F\u8BFA\u6216\u8005\u4FDD\u8BC1\u6536\u76CA\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u7684\u5176\u4ED6\u4E49\u52A1\u5305\u62EC\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF081\uFF09\u4EE5\u8BDA\u5B9E\u4FE1\u7528\u3001\u8C28\u614E\u52E4\u52C9\u7684\u539F\u5219\u7BA1\u7406\u7EC4\u5408\u8D22\u4EA7\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF082\uFF09\u914D\u5907\u8DB3\u591F\u7684\u5177\u6709\u4E13\u4E1A\u8D44\u683C\u7684\u4EBA\u5458\u8FDB\u884C\u57FA\u91D1\u6295\u8D44\u5206\u6790\u3001\u51B3\u7B56\uFF0C\u4EE5\u4E13\u4E1A\u5316\u7684\u7ECF\u8425\u65B9\u5F0F\u7BA1\u7406\u6295\u987E\u8D26\u6237\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF083\uFF09\u5EFA\u7ACB\u5065\u5168\u5185\u90E8\u98CE\u9669\u63A7\u5236\u3001\u76D1\u5BDF\u4E0E\u7A3D\u6838\u3001\u8D22\u52A1\u7BA1\u7406\u53CA\u4EBA\u4E8B\u7BA1\u7406\u7B49\u5236\u5EA6\uFF0C\u4FDD\u8BC1\u6240\u7BA1\u7406\u7684\u7EC4\u5408\u8D22\u4EA7\u548C\u4E59\u65B9\u7684\u8D22\u4EA7\u76F8\u4E92\u72EC\u7ACB\uFF0C\u5355\u72EC\u5BF9\u6295\u987E\u4E1A\u52A1\u4E0B\u7684\u6295\u8D44\u7EC4\u5408\u8FDB\u884C\u767B\u8BB0\u548C\u7BA1\u7406\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF084\uFF09\u9664\u6CD5\u5F8B\u6CD5\u89C4\u3001\u672C\u534F\u8BAE\u53CA\u5176\u4ED6\u6709\u5173\u89C4\u5B9A\u5916\uFF0C\u4E0D\u5F97\u5229\u7528\u7EC4\u5408\u8D22\u4EA7\u4E3A\u81EA\u5DF1\u53CA\u4EFB\u4F55\u7B2C\u4E09\u4EBA\u8C0B\u53D6\u5229\u76CA\uFF0C\u4E0D\u5F97\u59D4\u6258\u7B2C\u4E09\u4EBA\u8FDB\u884C\u8D26\u6237\u7BA1\u7406\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF085\uFF09\u4E25\u683C\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u5176\u4ED6\u6709\u5173\u89C4\u5B9A\uFF0C\u5C65\u884C\u4FE1\u606F\u62AB\u9732\u4E49\u52A1\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF086\uFF09\u4FDD\u5B88\u57FA\u91D1\u5546\u4E1A\u79D8\u5BC6\uFF0C\u4E0D\u6CC4\u9732\u6295\u8D44\u8005\u7684\u6295\u8D44\u8BA1\u5212\u3001\u6295\u8D44\u610F\u5411\u7B49\u3002\u9664\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u5176\u4ED6\u6709\u5173\u89C4\u5B9A\u53E6\u6709\u89C4\u5B9A\u5916\uFF0C\u5728\u7EC4\u5408\u4FE1\u606F\u516C\u5F00\u62AB\u9732\u524D\u5E94\u4E88\u4FDD\u5BC6\uFF0C\u4E0D\u5411\u4ED6\u4EBA\u6CC4\u9732\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E09\u6761 \u670D\u52A1\u5185\u5BB9\u4E0E\u65B9\u5F0F'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u4E1A\u52A1\u89C4\u5219'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u901A\u8FC7\u4E59\u65B9\u5E73\u53F0\u6216\u4E59\u65B9\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u540C\u610F\u6309\u4E0B\u5217\u89C4\u5219\u529E\u7406\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u6388\u6743\u59D4\u6258\uFF1A\u7532\u65B9\u540C\u610F\u6309\u7167\u672C\u534F\u8BAE\u53CA\u5176\u9644\u4EF6\uFF08\u5982\u6709\uFF09\uFF0C\u63A5\u53D7\u4E59\u65B9\u63D0\u4F9B\u7684\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u59D4\u6258\u5E76\u6388\u6743\u4E59\u65B9\u8FD0\u7528\u7532\u65B9\u4EA4\u7EB3\u7684\u7EA6\u5B9A\u53C2\u4E0E\u6B3E\u4EE3\u7532\u65B9\u4F5C\u51FA\u6295\u8D44\u51B3\u7B56\u3001\u53D1\u5E03\u8C03\u4ED3\u6307\u4EE4\u5E76\u901A\u8FC7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u8D26\u6237\u6267\u884C\u76F8\u5173\u6307\u4EE4\u6765\u8FDB\u884C\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6295\u8D44\u3002\u7532\u65B9\u540C\u610F\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u8D26\u6237\u9879\u4E0B\u5404\u57FA\u91D1\u7684\u7EA2\u5229\u5206\u914D\u65B9\u5F0F\u4E3A\u7EA2\u5229\u518D\u6295\u8D44\u65B9\u5F0F\uFF08\u201C\u5C0F\u5E38\u4E50\u76EE\u6807\u76C8\u201D\u6B62\u76C8\u667A\u6295\u7CFB\u5217\u6295\u8D44\u7EC4\u5408\u5404\u6210\u4EFD\u57FA\u91D1\u7684\u7EA2\u5229\u5206\u914D\u65B9\u5F0F\u4EE5\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u7EA6\u5B9A\u4E3A\u51C6\uFF09\u3002\u4E59\u65B9\u540C\u610F\u63A5\u53D7\u7532\u65B9\u7684\u59D4\u6258\u548C\u6388\u6743\uFF0C\u6309\u7167\u672C\u534F\u8BAE\u53CA\u5176\u9644\u4EF6\uFF08\u5982\u6709\uFF09\u7684\u7EA6\u5B9A\uFF0C\u5411\u7532\u65B9\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u5C06\u7532\u65B9\u4EA4\u7EB3\u7684\u7EA6\u5B9A\u53C2\u4E0E\u6B3E\u6295\u8D44\u4E8E\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9500\u552E\u7684\u516C\u52DF\u57FA\u91D1\u53CA\u76D1\u7BA1\u673A\u6784\u5141\u8BB8\u7684\u5176\u4ED6\u4EA7\u54C1\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u9002\u7528\u8303\u56F4\uFF1A\u672C\u670D\u52A1\u4E00\u822C\u53EF\u9002\u7528\u4E8E\u6CD5\u5F8B\u6CD5\u89C4\u6216\u76D1\u7BA1\u89C4\u5B9A\u5141\u8BB8\u4E59\u65B9\u63D0\u4F9B\u57FA\u91D1\u6295\u987E\u670D\u52A1\u7684\u5404\u7C7B\u4EA7\u54C1\uFF0C\u4F46\u5177\u4F53\u9002\u7528\u7684\u4EA7\u54C1\u8303\u56F4\u4EE5\u4E59\u65B9\u9875\u9762\u53CA\u4E59\u65B9\u8BA4\u53EF\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9875\u9762\u5C55\u793A\u4E3A\u51C6\uFF0C\u4E59\u65B9\u6709\u6743\u6839\u636E\u4E1A\u52A1\u9700\u8981\u53D8\u66F4\u672C\u670D\u52A1\u9002\u7528\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u6240\u6295\u8D44\u7684\u516C\u52DF\u57FA\u91D1\u4EA7\u54C1\u6216\u4E2D\u56FD\u8BC1\u76D1\u4F1A\u8BA4\u53EF\u7684\u5176\u4ED6\u4EA7\u54C1\u7684\u8303\u56F4\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '3\u3001\u670D\u52A1\u7533\u8BF7\uFF1A\u7532\u65B9\u53C2\u4E0E\u548C\u9000\u51FA\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u4E1A\u52A1\u7533\u8BF7\u53EF\u901A\u8FC7\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u529E\u7406\u3002\u7532\u65B9\u5E94\u5728\u5DE5\u4F5C\u65E515:00\u524D\u5411\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u57FA\u91D1\u9500\u552E\u673A\u6784\u63D0\u51FA\u4E0A\u8FF0\u4E1A\u52A1\u7533\u8BF7\uFF0C\u7532\u65B9\u5728\u5DE5\u4F5C\u65E515:00\u4EE5\u540E\u6216\u975E\u5DE5\u4F5C\u65E5\u63D0\u51FA\u7684\u7533\u8BF7\uFF0C\u5C06\u88AB\u89C6\u4E3A\u4E0B\u4E00\u4E2A\u5DE5\u4F5C\u65E5\u63D0\u51FA\u7684\u7533\u8BF7\u3002\u7532\u65B9\u53C2\u4E0E\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u65F6\uFF0C\u9700\u5728\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5F00\u7ACB\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u8D26\u6237\u3002\u6295\u8D44\u7EC4\u5408\u4E2D\u4EFB\u4E00\u6210\u4EFD\u57FA\u91D1\u5904\u4E8E\u6682\u505C\u7533\u8D2D\u72B6\u6001\u65F6\uFF0C\u4E59\u65B9\u6709\u6743\u81EA\u884C\u6216\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9488\u5BF9\u8BE5\u7EC4\u5408\u4E0D\u63A5\u53D7\u7EC4\u5408\u8D2D\u4E70\u670D\u52A1\u7533\u8BF7\uFF1B\u6295\u8D44\u7EC4\u5408\u4E2D\u4EFB\u4E00\u6210\u4EFD\u57FA\u91D1\u5904\u4E8E\u6682\u505C\u8D4E\u56DE\u72B6\u6001\u65F6\uFF0C\u4E59\u65B9\u6709\u6743\u81EA\u884C\u6216\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9488\u5BF9\u8BE5\u7EC4\u5408\u4E0D\u63A5\u53D7\u7EC4\u5408\u5168\u90E8\u6216\u90E8\u5206\u6210\u4EFD\u57FA\u91D1\u8D4E\u56DE\u670D\u52A1\u7533\u8BF7\uFF0C\u5982\u4E0D\u63A5\u53D7\u90E8\u5206\u6210\u4EFD\u57FA\u91D1\u8D4E\u56DE\u670D\u52A1\u7533\u8BF7\u7684\uFF0C\u5219\u8BE5\u90E8\u5206\u6210\u4EFD\u57FA\u91D1\u5BF9\u5E94\u8D44\u4EA7\u51BB\u7ED3\uFF0C\u5F53\u65E5\u7532\u65B9\u53EF\u8D4E\u56DE\u603B\u8D44\u4EA7\u4E3A\u5B9E\u9645\u8D44\u4EA7\u51CF\u53BB\u6B64\u90E8\u5206\u51BB\u7ED3\u8D44\u4EA7\uFF0C\u5177\u4F53\u8BE6\u60C5\u4EE5\u4E59\u65B9\u9875\u9762\u53CA\u4E59\u65B9\u8BA4\u53EF\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9875\u9762\u5C55\u793A\u4E3A\u51C6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '4\u3001\u7EC4\u5408\u7B56\u7565\uFF1A\u7531\u4E59\u65B9\u8D1F\u8D23\u63D0\u4F9B\u7EC4\u5408\u7684\u8D44\u4EA7\u914D\u7F6E\u65B9\u6848\uFF0C\u5E76\u6839\u636E\u5E02\u573A\u548C\u7EC4\u5408\u8FD0\u884C\u60C5\u51B5\uFF0C\u5B9E\u65F6\u8FDB\u884C\u8C03\u6574\u3002\u4E59\u65B9\u5C06\u6839\u636E\u7532\u65B9\u7684\u7279\u5F81\u4FE1\u606F\uFF0C\u4F8B\u5982\u5E74\u9F84\u3001\u6027\u522B\u3001\u6536\u5165\u3001\u8D44\u4EA7\u72B6\u51B5\u3001\u6295\u8D44\u76EE\u6807\u7B49\uFF0C\u5728\u6EE1\u8DB3\u6295\u8D44\u54C1\u79CD\u548C\u6D41\u52A8\u6027\u8981\u6C42\u7B49\u6295\u8D44\u9650\u5236\u7684\u524D\u63D0\u4E0B\uFF0C\u534F\u52A9\u7532\u65B9\u8BBE\u5B9A\u7B26\u5408\u7532\u65B9\u9700\u6C42\u7684\u6295\u8D44\u76EE\u6807\u3002\u4E59\u65B9\u5C06\u7814\u53D1\u8D44\u4EA7\u914D\u7F6E\u6A21\u578B\uFF0C\u901A\u8FC7\u5BF9\u5BA2\u6237\u98CE\u9669\u504F\u597D\u3001\u6295\u8D44\u76EE\u6807\u7684\u91CF\u5316\uFF0C\u5BF9\u5404\u7C7B\u8D44\u4EA7\u7ED9\u4E88\u4E0D\u540C\u7684\u6743\u91CD\uFF0C\u529B\u4E89\u4F7F\u7EC4\u5408\u957F\u671F\u6536\u76CA\u7B26\u5408\u5BA2\u6237\u9884\u671F\u3002\u7532\u65B9\u53EF\u4EE5\u9009\u53D6\u7684\u5177\u4F53\u7EC4\u5408\u7B56\u7565\u53CA\u76F8\u5E94\u98CE\u9669\u63A7\u5236\u63AA\u65BD\u5185\u5BB9\u8BF7\u53C2\u8003\u4E59\u65B9\u7EDF\u4E00\u5236\u5B9A\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '5\u3001\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D44\u91D1\u8D26\u6237\u3001\u7F34\u6B3E\u65B9\u5F0F\uFF1A \u9664\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u3001\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7535\u5B50\u4EA4\u6613\u5B9A\u671F\u5B9A\u989D\u7533\u8D2D\u4E1A\u52A1\u534F\u8BAE\u300B\u53CA\u4E59\u65B9\u6307\u5B9A\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u76F8\u5173\u4E1A\u52A1\u89C4\u5219\u53E6\u6709\u7EA6\u5B9A\u5916\uFF0C\u7532\u65B9\u652F\u4ED8\u7EA6\u5B9A\u53C2\u4E0E\u6B3E\u3001\u7533\u8BF7\u9000\u51FA\u540E\u83B7\u5F97\u9000\u51FA\u6B3E\u7B49\u5747\u901A\u8FC7\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7ED3\u7B97\u8D26\u6237\u4E0E\u7532\u65B9\u672C\u4EBA\u94F6\u884C\u7ED3\u7B97\u8D26\u6237\u4E4B\u95F4\u5C01\u95ED\u5212\u8F6C\uFF0C\u7532\u65B9\u5F00\u7ACB\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u8D26\u6237\u65F6\u7ED1\u5B9A\u7684\u4E2A\u4EBA\u94F6\u884C\u7ED3\u7B97\u8D26\u6237\u662F\u7532\u65B9\u63A5\u53D7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u800C\u4EA4\u7EB3\u53C2\u4E0E\u8D44\u91D1\u3001\u6295\u8D44\u987E\u95EE\u8D26\u6237\u9879\u4E0B\u57FA\u91D1\u4EA4\u6613\u6240\u6D89\u8D44\u91D1\u6536\u4ED8\u53CA\u6536\u53D6\u9000\u51FA\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u65F6\u7684\u8D44\u91D1\u7684\u552F\u4E00\u8D44\u91D1\u8D26\u6237\u3002\u53C2\u4E0E\u6B3E\u4EA4\u6B3E\u65B9\u5F0F\u5206\u4E3A\u7075\u6D3B\u4EA4\u6B3E\u65B9\u5F0F\u548C\u5B9A\u671F\u5B9A\u989D\u4EA4\u6B3E\u65B9\u5F0F\uFF0C\u5177\u4F53\u4EE5\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u3001\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7535\u5B50\u4EA4\u6613\u5B9A\u671F\u5B9A\u989D\u7533\u8D2D\u4E1A\u52A1\u534F\u8BAE\u300B\u53CA\u4E59\u65B9\u6307\u5B9A\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6709\u5173\u4E1A\u52A1\u89C4\u5219\u7684\u7EA6\u5B9A\u4E3A\u51C6\uFF0C\u9664\u672C\u534F\u8BAE\u53E6\u6709\u7EA6\u5B9A\u5916\uFF0C\u7532\u65B9\u5728\u63D0\u4EA4\u53C2\u4E0E\u6216\u8FFD\u52A0\u7533\u8BF7\u65F6\uFF0C\u5E94\u5168\u989D\u4EA4\u4ED8\u7EA6\u5B9A\u53C2\u4E0E\u6B3E\u3002\u7532\u65B9\u5411\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u63D0\u4EA4\u7533\u8BF7\u5E76\u5168\u989D\u4EA4\u4ED8\u6B3E\u9879\u7684\uFF0C\u7533\u8BF7\u65B9\u4E3A\u6709\u6548\u3002\u7EA6\u5B9A\u53C2\u4E0E\u6B3E\u7684\u652F\u4ED8\u65F6\u95F4\u3001\u65B9\u5F0F\u4EE5\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u4E1A\u52A1\u89C4\u5219\u89C4\u5B9A\u4E3A\u51C6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '6\u3001\u7EC4\u5408\u8C03\u4ED3\uFF1A\u4E3A\u9002\u5E94\u5E02\u573A\u53D8\u5316\u548C\u6295\u8D44\u76EE\u6807\u9700\u8981\uFF0C\u4E59\u65B9\u5C06\u5BF9\u7532\u65B9\u7684\u6388\u6743\u8D26\u6237\u8FDB\u884C\u7EC4\u5408\u8C03\u4ED3\uFF0C\u9664\u4E59\u65B9\u53CA\u4E59\u65B9\u5408\u4F5C\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E1A\u52A1\u89C4\u5219\u53E6\u6709\u7EA6\u5B9A\uFF0C\u4E59\u65B9\u53CA\u4E59\u65B9\u5408\u4F5C\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5C06\u6839\u636E\u4E1A\u52A1\u89C4\u5219\u5B9E\u9645\u6267\u884C\u6210\u4EFD\u57FA\u91D1\u6709\u5173\u4EA4\u6613\u6307\u4EE4\uFF0C\u65E0\u9700\u5728\u6BCF\u6B21\u8C03\u4ED3\u524D\u83B7\u5F97\u7532\u65B9\u540C\u610F\u3002\u7532\u65B9\u7406\u89E3\u5E76\u540C\u610F\uFF0C\u56E0\u4E59\u65B9\u7684\u6295\u8D44\u5224\u65AD\u6216\u8DDF\u968F\u76EE\u6807\u7EC4\u5408\u64CD\u4F5C\u7684\u65F6\u95F4\u5DEE\u7B49\u539F\u56E0\uFF0C\u4F1A\u5BFC\u81F4\u8DDF\u968F\u6295\u8D44\u4E1A\u7EE9\u7684\u5DEE\u5F02\u751A\u81F3\u662F\u53CD\u5DEE\uFF0C\u7532\u65B9\u5E94\u81EA\u884C\u627F\u62C5\u98CE\u9669\u548C\u8D23\u4EFB\u3002 \u7EC4\u5408\u8C03\u4ED3\u89C6\u4E3A\u540C\u610F\u6388\u6743\u4E59\u65B9\u7CFB\u7EDF\u6839\u636E\u7532\u65B9\u5DF2\u6301\u6709\u8D44\u4EA7\u60C5\u51B5\u5411\u76EE\u6807\u6210\u4EFD\u8C03\u6574\u800C\u751F\u6210\u7684\u4E00\u7CFB\u5217\u8C03\u4ED3\u6307\u4EE4\uFF08\u57FA\u91D1\u8D4E\u56DE\u3001\u8BA4/\u7533\u8D2D\u3001\u8F6C\u6362\u3001\u8BBE\u7F6E\u57FA\u91D1\u5206\u7EA2\u65B9\u5F0F\u7B49\uFF09\u5E76\u81EA\u52A8\u6267\u884C\uFF0C\u4E59\u65B9\u4EA6\u53EF\u5411\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u53D1\u51FA\u6709\u5173\u4EA4\u6613\u6307\u4EE4\u5B9E\u73B0\u8C03\u4ED3\u884C\u4E3A\uFF0C\u8FD9\u4E9B\u6307\u4EE4\u4ECE\u4E59\u65B9\u53D1\u8D77\u5230\u786E\u8BA4\u5B8C\u6210\u6839\u636E\u4E0D\u540C\u7684\u6210\u4EFD\u57FA\u91D1\u4E0E\u6307\u4EE4\u7C7B\u578B\u9700\u8981\u82E5\u5E72\u4E2A\u4EA4\u6613\u65E5\u3002\u82E5\u4E59\u65B9\u5BF9\u7532\u65B9\u7684\u6388\u6743\u8D26\u6237\u8FDB\u884C\u7EC4\u5408\u8C03\u4ED3\u65F6\uFF0C\u4E3A\u8FBE\u6210\u7532\u65B9\u8C03\u6574\u8F83\u4F18\u914D\u7F6E\u6BD4\u4F8B\u7684\u76EE\u6807\uFF0C\u7532\u65B9\u6301\u6709\u6295\u8D44\u7EC4\u5408\u4E2D\u7684\u67D0\u9879\u6216\u67D0\u51E0\u9879\u6210\u4EFD\u57FA\u91D1\u8D4E\u56DE\u91D1\u989D\u8D85\u51FA\u8BE5\u6210\u4EFD\u57FA\u91D1\u7BA1\u7406\u4EBA\u89C4\u5B9A\u7684\u9650\u989D\uFF0C\u4E59\u65B9\u53EF\u4EE5\u901A\u8FC7\u4E59\u65B9\u7CFB\u7EDF\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9500\u552E\u7CFB\u7EDF\u6839\u636E\u4E59\u65B9\u4E1A\u52A1\u89C4\u5219\u4E3A\u7532\u65B9\u5C06\u4E0A\u8FF0\u8C03\u4ED3\u5206\u62C6\u6210\u591A\u7B14\u4EA4\u6613\uFF1B\u56E0\u8BA4/\u7533\u8D2D\u91D1\u989D\u8D85\u51FA\u8BE5\u6210\u4EFD\u57FA\u91D1\u7BA1\u7406\u4EBA\u89C4\u5B9A\u7684\u9650\u989D\u7684\uFF0C\u4E59\u65B9\u53EF\u4EE5\u901A\u8FC7\u4E59\u65B9\u7CFB\u7EDF\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9500\u552E\u7CFB\u7EDF\u6839\u636E\u4E59\u65B9\u4E1A\u52A1\u89C4\u5219\u4E3A\u7532\u65B9\u5C06\u4E0A\u8FF0\u8C03\u4ED3\u5206\u62C6\u6210\u591A\u7B14\u4EA4\u6613\uFF0C\u6216\u8BA4/\u7533\u8D2D\u7B26\u5408\u8BE5\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u5907\u9009\u57FA\u91D1\u3002\u82E5\u91C7\u7528\u5206\u62C6\u591A\u7B14\u4EA4\u6613\u65B9\u5F0F\uFF0C\u8BE5\u591A\u7B14\u4EA4\u6613\u53EF\u80FD\u9700\u8981\u82E5\u5E72\u4E2A\u4EA4\u6613\u65E5\u3002\u7531\u4E8E\u57FA\u91D1\u7533\u8D2D\u3001\u8D4E\u56DE\u7B49\u64CD\u4F5C\u57FA\u4E8E\u672A\u77E5\u4EF7\u539F\u5219\uFF0C\u4E14\u53EF\u80FD\u5B58\u5728\u7533\u8D2D\u5907\u9009\u57FA\u91D1\u7684\u60C5\u5F62\uFF0C\u7EC4\u5408\u8C03\u4ED3\u5373\u4F7F\u6307\u4EE4\u5168\u90E8\u6267\u884C\u6210\u529F\u4E5F\u53EF\u80FD\u51FA\u73B0\u4E0E\u76EE\u6807\u7EC4\u5408\u6210\u4EFD\u6BD4\u4F8B\u6709\u4E00\u5B9A\u504F\u79BB\u7684\u60C5\u51B5\u3002\u7532\u65B9\u540C\u610F\u4E0A\u8FF0\u60C5\u5F62\u5E76\u81EA\u884C\u627F\u62C5\u98CE\u9669\u548C\u8D23\u4EFB\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '7\u3001\u5206\u7EA2\u65B9\u5F0F\uFF1A\u4E3A\u4FBF\u4E8E\u6295\u8D44\u7EC4\u5408\u7BA1\u7406\uFF0C\u9664\u201C\u5C0F\u5E38\u4E50\u76EE\u6807\u76C8\u201D\u6B62\u76C8\u667A\u6295\u7CFB\u5217\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u53E6\u6709\u7EA6\u5B9A\u4E4B\u5916\uFF0C\u6295\u8D44\u7EC4\u5408\u5185\u6210\u4EFD\u57FA\u91D1\u5206\u7EA2\u65B9\u5F0F\u5C06\u7EDF\u4E00\u8BBE\u5B9A\u4E3A\u7EA2\u5229\u518D\u6295\u8D44\uFF0C\u4E14\u4E0D\u53EF\u4EE5\u8FDB\u884C\u4FEE\u6539\u3002\u7532\u65B9\u7B7E\u7F72\u672C\u534F\u8BAE\u5373\u8868\u660E\u7532\u65B9\u77E5\u6653\u8BE5\u4E1A\u52A1\u89C4\u5219\uFF0C\u5E76\u6388\u6743\u4E59\u65B9\u5C06\u7EC4\u5408\u4E2D\u5404\u6210\u4EFD\u57FA\u91D1\u7684\u5206\u7EA2\u5206\u914D\u65B9\u5F0F\u7EDF\u4E00\u8BBE\u7F6E\u4E3A\u7EA2\u5229\u518D\u6295\u8D44\u65B9\u5F0F\uFF08\u201C\u5C0F\u5E38\u4E50\u76EE\u6807\u76C8\u201D\u6B62\u76C8\u667A\u6295\u7CFB\u5217\u6295\u8D44\u7EC4\u5408\u5404\u6210\u4EFD\u57FA\u91D1\u7684\u5206\u7EA2\u5206\u914D\u65B9\u5F0F\u4EE5\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u7EA6\u5B9A\u4E3A\u51C6\uFF09\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '8\u3001\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u9000\u51FA\u65B9\u5F0F\uFF08\u7EC4\u5408\u8D4E\u56DE\uFF09\uFF1A\u6307\u901A\u8FC7\u6388\u6743\u4E59\u65B9\u6216\u4E59\u65B9\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5BF9\u5DF2\u6301\u6709\u7EC4\u5408\u5185\u7684\u6240\u6709\u6210\u4EFD\u57FA\u91D1\u8FDB\u884C\u5168\u90E8\u6216\u8005\u6309\u6BD4\u4F8B\u8D4E\u56DE\u3002\u7532\u65B9\u540C\u610F\u5E76\u63A5\u53D7\uFF0C\u7EC4\u5408\u90E8\u5206\u8D4E\u56DE\u65F6\uFF0C\u53EF\u80FD\u4F1A\u56E0\u4E3A\u5404\u79CD\u60C5\u5F62\u9020\u6210\u7EC4\u5408\u5269\u4F59\u6301\u4ED3\u7684\u6210\u4EFD\u6BD4\u4F8B\u51FA\u73B0\u4E00\u5B9A\u504F\u79BB\u7684\u60C5\u51B5\u3002\u7532\u65B9\u540C\u610F\u4E0A\u8FF0\u60C5\u5F62\u5E76\u81EA\u884C\u627F\u62C5\u98CE\u9669\u548C\u8D23\u4EFB\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '9\u3001\u5DE8\u989D\u8D4E\u56DE\uFF1A\u5F53\u8FDB\u884C\u7EC4\u5408\u8D4E\u56DE\u6216\u7EC4\u5408\u8C03\u4ED3\u65F6\uFF0C\u82E5\u53D1\u751F\u6210\u4EFD\u57FA\u91D1\u5DE8\u989D\u8D4E\u56DE\u4E14\u6210\u4EFD\u57FA\u91D1\u7BA1\u7406\u4EBA\u51B3\u5B9A\u90E8\u5206\u5EF6\u671F\u8D4E\u56DE\u7684\u60C5\u5F62\uFF0C\u7532\u65B9\u540C\u610F\uFF0C\u5BF9\u4E8E\u5EF6\u671F\u529E\u7406\u7684\u8D4E\u56DE\u7533\u8BF7\u90E8\u5206\uFF0C\u6388\u6743\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4EE3\u7532\u65B9\u9009\u62E9\u4EE5\u8FDE\u7EED\u8D4E\u56DE\u65B9\u5F0F\u8FDB\u884C\u8D4E\u56DE\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '10\u3001\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF1A\u4E59\u65B9\u5C06\u6309\u6295\u987E\u8D26\u6237\u4E2D\u7684\u5404\u7C7B\u7EC4\u5408\u7684\u8D44\u4EA7\u51C0\u503C\u7684\u4E00\u5B9A\u6BD4\u4F8B\u52A0\u603B\u6536\u53D6\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF0C\u9002\u7528\u6BD4\u4F8B\u4E59\u65B9\u5C06\u5728\u9875\u9762\u8FDB\u884C\u5C55\u793A\u3002\u4E59\u65B9\u53EF\u4EE5\u5BF9\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u5B9E\u65BD\u8D39\u7387\u4F18\u60E0\uFF0C\u5177\u4F53\u4F18\u60E0\u8D39\u7387\u4EE5\u4E59\u65B9\u9875\u9762\u53CA\u4E59\u65B9\u8BA4\u53EF\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u9875\u9762\u5C55\u793A\u4E3A\u51C6\u3002\u5728\u4E59\u65B9\u4F5C\u4E3A\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u65F6\uFF0C\u7533\u8D2D\u3001\u8D4E\u56DE\u7EC4\u5408\u4E2D\u7684\u6210\u4EFD\u57FA\u91D1\u65F6\uFF0C\u4E59\u65B9\u5C06\u5728\u57FA\u91D1\u9500\u552E\u4E1A\u52A1\u89C4\u5219\u5141\u8BB8\u7684\u60C5\u51B5\u4E0B\uFF0C\u51CF\u514D\u7532\u65B9\u8BA1\u5165\u57FA\u91D1\u8D44\u4EA7\u5916\u7684\u7533\u8D2D\u3001\u8D4E\u56DE\u8D39\u7528\uFF08\u7BA1\u7406\u4EBA\u6536\u53D6\u7684\u7533\u8D2D\u3001\u8D4E\u56DE\u8D39\u7528\u90E8\u5206\u4E0D\u514D\u9664\uFF09\u3002\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u6309\u65E5\u8BA1\u63D0\uFF0C\u4EE5\u672C\u534F\u8BAE\u7B2C\u516D\u6761\u7EA6\u5B9A\u7684\u65B9\u5F0F\u6536\u53D6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '11\u3001\u5982\u7532\u65B9\u5728\u4F7F\u7528\u4E59\u65B9\u63D0\u4F9B\u7684\u9500\u552E\u670D\u52A1\u4E2D\u5BF9\u4E59\u65B9\u8D1F\u6709\u5230\u671F\u503A\u52A1\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u56E0\u5411\u7532\u65B9\u91CD\u590D\u51FA\u6B3E\u3001\u7532\u65B9\u91CD\u590D\u8D4E\u56DE\u4EFD\u989D\u7B49\u5BFC\u81F4\u7684\u7532\u65B9\u4E0D\u5F53\u5F97\u5229\u6216\u5176\u4ED6\u4E59\u65B9\u5BF9\u7532\u65B9\u4EAB\u6709\u503A\u6743\u7684\u60C5\u5F62\uFF09\uFF0C\u5728\u4E0D\u5F71\u54CD\u7532\u65B9\u6743\u76CA\u7684\u60C5\u51B5\u4E0B\uFF0C\u7ECF\u901A\u77E5\u7532\u65B9\u540E\uFF0C\u4E59\u65B9\u6709\u6743\u91C7\u53D6\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u51BB\u7ED3\u7532\u65B9\u4EA4\u6613\u8D26\u6237\u3001\u4ECE\u7532\u65B9\u94F6\u884C\u8D26\u6237\u6263\u6B3E\u3001\u6309\u7167\u5E02\u573A\u4EF7\u683C\u8D4E\u56DE\u6216\u8FC7\u6237\u7532\u65B9\u57FA\u91D1\u4EFD\u989D\u7B49\u65B9\u5F0F\u6765\u5B9E\u73B0\u503A\u6743\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '12\u3001\u7533\u8D2D\u8D39\u3001\u8D4E\u56DE\u8D39\u3001\u8F6C\u6362\u8D39\u53CA\u57FA\u91D1\u9500\u552E\u8D39\u7528\uFF1A\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u9879\u4E0B\u57FA\u91D1\u7684\u7533\u8D2D\u8D39\u3001\u8D4E\u56DE\u8D39\u3001\u8F6C\u6362\u8D39\u53CA\u57FA\u91D1\u9500\u552E\u7B49\u8D39\u7528\uFF0C\u5C06\u7531\u7532\u65B9\u627F\u62C5\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '13\u3001\u7532\u65B9\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u8D26\u6237\u9879\u4E0B\u7684\u57FA\u91D1\u56E0\u53F8\u6CD5\u6267\u884C\u3001\u884C\u653F\u5F3A\u5236\u63AA\u65BD\u3001\u6CD5\u9662\u5224\u51B3\u3001\u79BB\u5A5A\u7B49\u60C5\u5F62\uFF0C\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u53EF\u6839\u636E\u76F8\u5173\u57FA\u91D1\u7684\u57FA\u91D1\u5408\u540C\u53CA\u57FA\u91D1\u6CE8\u518C\u767B\u8BB0\u673A\u6784\u975E\u4EA4\u6613\u8FC7\u6237\u7684\u76F8\u5173\u89C4\u5219\u534F\u52A9\u529E\u7406\u51BB\u7ED3\u3001\u975E\u4EA4\u6613\u8FC7\u6237\u7B49\u624B\u7EED\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '14\u3001\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7535\u5B50\u4EA4\u6613\u5B9A\u671F\u5B9A\u989D\u7533\u8D2D\u4E1A\u52A1\uFF1A\u82E5\u7532\u65B9\u9009\u62E9\u91C7\u7528\u5B9A\u671F\u5B9A\u989D\u4EA4\u6B3E\u65B9\u5F0F\u7684\u7F34\u6B3E\u53C2\u4E0E\u6B3E\uFF0C\u8FD8\u5E94\u7B7E\u7F72\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7535\u5B50\u4EA4\u6613\u5B9A\u671F\u5B9A\u989D\u7533\u8D2D\u4E1A\u52A1\u534F\u8BAE\u300B\u6216\u4E59\u65B9\u6307\u5B9A\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u76F8\u5173\u670D\u52A1\u534F\u8BAE\u5E76\u9075\u5B88\u76F8\u5173\u7EA6\u5B9A\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '15\u3001\u5176\u4ED6\u672C\u534F\u8BAE\u672A\u5C3D\u7684\u4E59\u65B9\u4E1A\u52A1\u89C4\u5219\uFF0C\u4EE5\u4E59\u65B9\u7F51\u7AD9\u516C\u793A\uFF08\u5305\u62EC\u4E59\u65B9\u7F51\u7AD9\u53CA\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u5404\u7C7B\u4EA4\u6613\u63D0\u793A\u3001\u95EE\u7B54\u7B49\u5404\u79CD\u5F62\u5F0F\u7684\u4E1A\u52A1\u89C4\u5219\uFF09\u4E3A\u51C6\u3002\u5176\u4ED6\u672C\u534F\u8BAE\u672A\u5C3D\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E1A\u52A1\u89C4\u5219\u4EE5\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u4E3A\u51C6\u3002\u7532\u65B9\u5E94\u5F53\u4ED4\u7EC6\u9605\u8BFB\u5E76\u4E86\u89E3\u76F8\u5173\u4E1A\u52A1\u89C4\u5219\uFF0C\u7532\u65B9\u7533\u8BF7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u5373\u8868\u793A\u7532\u65B9\u5DF2\u7ECF\u5B8C\u5168\u6E05\u695A\u3001\u4E86\u89E3\u5E76\u540C\u610F\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u6700\u65B0\u4E1A\u52A1\u89C4\u5219\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u6295\u8D44\u5EFA\u8BAE\u51B3\u7B56\u6D41\u7A0B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u6295\u8D44\u76EE\u6807\u8BBE\u5B9A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u6216\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u6536\u96C6\u6295\u8D44\u8005\u7279\u5F81\u4FE1\u606F\uFF0C\u4F8B\u5982\u5E74\u9F84\u3001\u6027\u522B\u3001\u6536\u5165\u3001\u8D44\u4EA7\u72B6\u51B5\u3001\u6295\u8D44\u76EE\u6807\u7B49\uFF0C\u5728\u6EE1\u8DB3\u6295\u8D44\u54C1\u79CD\u548C\u6D41\u52A8\u6027\u8981\u6C42\u7B49\u6295\u8D44\u9650\u5236\u7684\u524D\u63D0\u4E0B\uFF0C\u534F\u52A9\u6295\u8D44\u8005\u8BBE\u5B9A\u7B26\u5408\u9700\u6C42\u7684\u6295\u8D44\u76EE\u6807\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u8D44\u4EA7\u914D\u7F6E\u7814\u7A76'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u5C06\u5927\u7C7B\u8D44\u4EA7\u914D\u7F6E\u5206\u4E3A\u6218\u7565\u8D44\u4EA7\u914D\u7F6E\u548C\u6218\u672F\u8D44\u4EA7\u914D\u7F6E\u4E24\u4E2A\u5C42\u9762\u3002\u6218\u7565\u8D44\u4EA7\u914D\u7F6E\u7684\u76EE\u6807\u662F\u6295\u8D44\u7EC4\u5408\u7684\u957F\u671F\u6536\u76CA\u8FBE\u5230\u5BA2\u6237\u7684\u9884\u671F\u3002\u4E59\u65B9\u5728\u786E\u7ACB\u6218\u7565\u8D44\u4EA7\u914D\u7F6E\u6BD4\u4F8B\u65F6\uFF0C\u7ACB\u8DB3\u957F\u5468\u671F\uFF0C\u6838\u5FC3\u805A\u7126\u5728\u5BF9\u5927\u7C7B\u8D44\u4EA7\u6536\u76CA\u548C\u98CE\u9669\u7684\u957F\u671F\u9884\u6D4B\u4EE5\u53CA\u5BF9\u5BA2\u6237\u7684\u98CE\u9669\u504F\u597D\u3001\u6295\u8D44\u76EE\u6807\u7684\u91CF\u5316\u3002\u901A\u8FC7\u5BF9\u7ECF\u6D4E\u589E\u901F\u3001\u8D27\u5E01\u589E\u901F\u7B49\u7ECF\u6D4E\u3001\u91D1\u878D\u6307\u6807\u5224\u65AD\uFF0C\u5B9E\u73B0\u5BF9\u5927\u7C7B\u8D44\u4EA7\u7684\u957F\u671F\u6536\u76CA\u548C\u98CE\u9669\u9884\u6D4B\u3002\u901A\u8FC7\u5BF9\u5BA2\u6237\u98CE\u9669\u504F\u597D\u3001\u6295\u8D44\u76EE\u6807\u7684\u91CF\u5316\uFF0C\u5BF9\u5404\u7C7B\u8D44\u4EA7\u7ED9\u4E88\u4E0D\u540C\u7684\u6743\u91CD\uFF0C\u529B\u4E89\u4F7F\u7EC4\u5408\u957F\u671F\u6536\u76CA\u7B26\u5408\u5BA2\u6237\u9884\u671F\u3002 \u6218\u672F\u8D44\u4EA7\u914D\u7F6E\u5C06\u7ECF\u6D4E\u5468\u671F\u5BF9\u8D44\u4EA7\u7684\u5F71\u54CD\u7EB3\u5165\u8D44\u4EA7\u914D\u7F6E\u6846\u67B6\uFF0C\u901A\u8FC7\u5728\u6218\u7565\u8D44\u4EA7\u914D\u7F6E\u6BD4\u4F8B\u4E0A\u7684\u504F\u79FB\uFF0C\u83B7\u5F97\u8D85\u989D\u6536\u76CA\u3002\u5728\u5B9E\u8DF5\u5E94\u7528\u4E2D\uFF0C\u4F20\u7EDF\u6295\u8D44\u65F6\u949F\u5FFD\u89C6\u4E86\u9006\u5468\u671F\u7684\u653F\u7B56\u4E0E\u8D44\u4EA7\u4F30\u503C\u5BF9\u8D44\u4EA7\u914D\u7F6E\u7684\u5F71\u54CD\u3002\u4ECE\u5386\u53F2\u7ECF\u9A8C\u770B\uFF0C\u653F\u7B56\u5468\u671F\u5BF9\u7ECF\u6D4E\u5468\u671F\u548C\u5BF9\u5E02\u573A\u6CE2\u52A8\u5F71\u54CD\u5DE8\u5927\u3002\u57FA\u4E8E\u6B64\uFF0C\u6BCD\u516C\u53F8\u534E\u590F\u57FA\u91D1\u7BA1\u7406\u6709\u9650\u516C\u53F8\uFF08\u201C\u534E\u590F\u57FA\u91D1\u201D\uFF09\u5C06\u6295\u8D44\u65F6\u949F\u7684\u5206\u6790\u6846\u67B6\u8FDB\u884C\u5B8C\u5584\uFF0C\u5F62\u6210\u57FA\u4E8E\u5B8F\u89C2\uFF08Macro-economy\uFF09\u3001\u4F30\u503C\uFF08Value\uFF09\u3001\u653F\u7B56\uFF08Policy\uFF09\u7684MVP\u5206\u6790\u6A21\u578B\u3002\u4E59\u65B9\u57FA\u4E8EMVP\u6A21\u578B\uFF0C\u7D27\u5BC6\u8DDF\u8E2A\u5B8F\u89C2\u6570\u636E\u3001\u4F30\u503C\u6570\u636E\u4EE5\u53CA\u653F\u7B56\u7684\u53D8\u5316\uFF0C\u5B9A\u671F\u4E0E\u534E\u590F\u57FA\u91D1\u5C31\u5927\u7C7B\u8D44\u4EA7\u89C2\u70B9\u8FDB\u884C\u6C9F\u901A\u4EA4\u6D41\uFF0C\u8FDB\u884C\u6218\u672F\u8D44\u4EA7\u914D\u7F6E\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '3\u3001\u57FA\u91D1\u9009\u62E9\u8BC4\u4EF7 \u5728\u5EFA\u7ACB\u57FA\u91D1\u5907\u9009\u5E93\u8FC7\u7A0B\u4E2D\uFF0C\u4E59\u65B9\u9996\u5148\u4F1A\u5BF9\u5168\u5E02\u573A\u57FA\u91D1\u7BA1\u7406\u4EBA\u7684\u5408\u89C4\u6027\u3001\u57FA\u91D1\u7684\u6301\u6709\u4EBA\u7ED3\u6784\u7B49\u6761\u4EF6\u8FDB\u884C\u7B5B\u9009\uFF0C\u5F97\u5230\u57FA\u91D1\u5907\u9009\u57FA\u7840\u6C60\uFF08\u57FA\u7840\u6C60\uFF09\u3002\u5728\u57FA\u7840\u6C60\u7684\u57FA\u7840\u4E4B\u4E0A\uFF0C\u5BF9\u6C60\u4E2D\u57FA\u91D1\u7684\u7B56\u7565\u548C\u7BA1\u7406\u98CE\u683C\u8FDB\u884C\u5212\u5206\uFF0C\u901A\u8FC7\u57FA\u91D1\u7ECF\u7406\u8BBF\u8C08\u548C\u5B9A\u91CF\u5206\u6790\uFF0C\u91CD\u70B9\u5173\u6CE8\u57FA\u91D1\u7684\u57FA\u91D1\u89C4\u6A21\u3001\u6295\u8D44\u7ECF\u7406\u5386\u53F2\u4E1A\u7EE9\u3001\u6295\u8D44\u98CE\u683C\u7A33\u5B9A\u6027\u3001\u8D85\u989D\u6536\u76CA\u80FD\u529B\u3001\u98CE\u9669\u63A7\u5236\u80FD\u529B\u7B49\u8981\u70B9\uFF0C\u9009\u51FA\u5176\u4E2D\u98CE\u683C\u660E\u6670\u3001\u8868\u73B0\u6301\u7EED\u7A33\u5065\u7684\u57FA\u91D1\uFF0C\u5E76\u8054\u5408\u4E59\u65B9\u6BCD\u516C\u53F8\u534E\u590F\u57FA\u91D1\u7684\u6295\u7814\u56E2\u961F\u8FDB\u884C\u8C03\u7814\uFF0C\u53CD\u590D\u8BBA\u8BC1\uFF0C\u4EA4\u53C9\u9A8C\u8BC1\uFF0C\u5C06\u8BC4\u5206\u9760\u524D\u7684\u57FA\u91D1\u79FB\u5165\u57FA\u91D1\u5907\u9009\u6838\u5FC3\u6C60\uFF08\u6838\u5FC3\u6C60\uFF09\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '4\u3001\u7EC4\u5408\u6784\u5EFA \u5728\u5E95\u5C42\u57FA\u91D1\u8D44\u4EA7\u7684\u57FA\u7840\u4E0A\uFF0C\u4E59\u65B9\u6839\u636E\u4E0D\u540C\u7684\u6295\u8D44\u76EE\u6807\u63D0\u4F9B\u591A\u6837\u5316\u7684\u7EC4\u5408\u3002\u5728\u7EC4\u5408\u7684\u5206\u7C7B\u4E0A\uFF0C\u4E3B\u8981\u57FA\u4E8E\u6295\u8D44\u671F\u9650\u548C\u6536\u76CA\u76EE\u6807\u8FD9\u4E24\u4E2A\u7EF4\u5EA6\u6784\u5EFA\u7EC4\u5408\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E09\uFF09\u8C03\u4ED3\u7BA1\u7406'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u540C\u610F\u6309\u7167\u672C\u534F\u8BAE\u7EA6\u5B9A\uFF0C\u63A5\u53D7\u4E59\u65B9\u63D0\u4F9B\u7684\u6388\u6743\u7BA1\u7406\u8D26\u6237\u670D\u52A1\uFF0C\u59D4\u6258\u5E76\u6388\u6743\u4E59\u65B9\u8FD0\u7528\u7532\u65B9\u4EA4\u7EB3\u7684\u8D44\u91D1\u4EE5\u7532\u65B9\u540D\u4E49\u8FDB\u884C\u7EC4\u5408\u6295\u8D44\uFF0C\u5E76\u6388\u6743\u4E59\u65B9\u505A\u51FA\u51B3\u5B9A\u3002\u7532\u4E59\u53CC\u65B9\u786E\u8BA4\uFF0C\u4E59\u65B9\u53CA\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u57FA\u4E8E\u672C\u534F\u8BAE\u7EA6\u5B9A\u529E\u7406\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u3001\u8F6C\u6362\u7B49\u4EA4\u6613\uFF0C\u5E94\u7B26\u5408\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u76F8\u5E94\u4EA7\u54C1\u5408\u540C\u3001\u62DB\u52DF\u8BF4\u660E\u4E66\u3001\u4E34\u65F6\u516C\u544A\u7B49\u6587\u4EF6\u7684\u89C4\u5B9A\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6839\u636E\u5E02\u573A\u72B6\u51B5\uFF0C\u7532\u65B9\u7684\u6295\u8D44\u7EC4\u5408\u5728\u6709\u5FC5\u8981\u65F6\uFF0C\u7531\u4E59\u65B9\u8D1F\u8D23\u505A\u51FA\u8C03\u4ED3\u5EFA\u8BAE\uFF0C\u5E76\u7EC4\u7EC7\u5B9E\u65BD\u8C03\u4ED3\u6D41\u7A0B\uFF0C\u5177\u4F53\u5B9E\u65BD\u548C\u590D\u6838\u76D1\u63A7\u3002\u4E59\u65B9\u5E94\u5F53\u5BA1\u614E\u8BC4\u4F30\u8C03\u4ED3\u884C\u4E3A\u5BF9\u6D41\u52A8\u6027\u7684\u5F71\u54CD\u3002\u4E3A\u4FDD\u62A4\u6295\u8D44\u8005\u5229\u76CA\uFF0C\u4E59\u65B9\u9075\u5FAA\u5E95\u5C42\u8D44\u4EA7\u957F\u671F\u914D\u7F6E\u539F\u5219\uFF0C\u4E0D\u8FDB\u884C\u9891\u7E41\u8C03\u4ED3\u3002\u4E59\u65B9\u63D0\u4F9B\u7684\u6240\u6709\u7EC4\u5408\u7B56\u7565\u7684\u5E74\u5EA6\u6700\u9AD8\u5468\u8F6C\u7387\u4E0D\u5F97\u8D85\u8FC7200%\uFF0C\u8FBE\u5230180%\u65F6\u89E6\u53D1\u9884\u8B66\u62A5\u544A\u673A\u5236\uFF0C\u82E5\u4E59\u65B9\u62DF\u4E0A\u8C03\u6700\u9AD8\u5468\u8F6C\u7387\uFF0C\u5E94\u5F53\u4E8B\u524D\u62A5\u544A\u6709\u5173\u76D1\u7BA1\u90E8\u95E8\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u786E\u4FDD\u7EC4\u5408\u8C03\u4ED3\u89C4\u8303\u51C6\u786E\u5B9E\u65BD\uFF0C\u4E59\u65B9\u5236\u5B9A\u4E86\u7EC4\u5408\u8C03\u4ED3\u5185\u90E8\u6D41\u7A0B\uFF0C\u5E76\u901A\u8FC7\u589E\u52A0\u590D\u6838\u3001\u8FD0\u8425\u76D1\u63A7\u907F\u514D\u64CD\u4F5C\u98CE\u9669\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u56DB\u6761 \u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u6267\u884C\u60C5\u51B5'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u89C4\u8303\u516C\u53F8\u9500\u552E\u884C\u4E3A\uFF0C\u786E\u4FDD\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u5236\u5EA6\u7684\u6709\u6548\u843D\u5B9E\uFF0C\u4FDD\u62A4\u6295\u8D44\u8005\u5408\u6CD5\u6743\u76CA\uFF0C\u4E59\u65B9\u6839\u636E\u300A\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6CD5\u300B\u3001\u300A\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u9500\u552E\u673A\u6784\u76D1\u7763\u7BA1\u7406\u529E\u6CD5\u300B\u3001\u300A\u8BC1\u5238\u671F\u8D27\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u529E\u6CD5\u300B\u3001\u300A\u57FA\u91D1\u52DF\u96C6\u673A\u6784\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u5B9E\u65BD\u6307\u5F15\uFF08\u8BD5\u884C\uFF09\u300B\u7B49\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u3001\u81EA\u5F8B\u89C4\u5219\uFF0C\u5236\u5B9A\u4E86\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u6682\u884C\u529E\u6CD5\u300B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u5E94\u5F53\u9075\u5B88\u6CD5\u5F8B\u3001\u884C\u653F\u6CD5\u89C4\u3001\u516C\u53F8\u7BA1\u7406\u5236\u5EA6\u53CA\u5176\u4ED6\u6709\u5173\u89C4\u5B9A\uFF0C\u5728\u9500\u552E\u4EA7\u54C1\u6216\u8005\u63D0\u4F9B\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u52E4\u52C9\u5C3D\u8D23\uFF0C\u5BA1\u614E\u5C65\u804C\uFF0C\u5168\u9762\u4E86\u89E3\u6295\u8D44\u8005\u60C5\u51B5\uFF0C\u6DF1\u5165\u8C03\u67E5\u5206\u6790\u4EA7\u54C1\u6216\u8005\u670D\u52A1\u4FE1\u606F\uFF0C\u79D1\u5B66\u6709\u6548\u8BC4\u4F30\uFF0C\u5145\u5206\u63ED\u793A\u98CE\u9669\uFF0C\u57FA\u4E8E\u6295\u8D44\u8005\u7684\u4E0D\u540C\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4EE5\u53CA\u4EA7\u54C1\u6216\u8005\u670D\u52A1\u7684\u4E0D\u540C\u98CE\u9669\u7B49\u7EA7\u7B49\u56E0\u7D20\uFF0C\u63D0\u51FA\u660E\u786E\u7684\u9002\u5F53\u6027\u5339\u914D\u610F\u89C1\uFF0C\u5C06\u5408\u9002\u7684\u4EA7\u54C1\u6216\u8005\u670D\u52A1\u63A8\u4ECB\u7ED9\u5408\u9002\u7684\u6295\u8D44\u8005\u3002\u4F46\u8BE5\u9002\u5F53\u6027\u5339\u914D\u610F\u89C1\u5E76\u4E0D\u8868\u660E\u4E59\u65B9\u5BF9\u6295\u987E\u670D\u52A1\u7684\u98CE\u9669\u548C\u6536\u76CA\u505A\u51FA\u5B9E\u8D28\u6027\u5224\u65AD\u6216\u4FDD\u8BC1\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u4E86\u89E3\u5E76\u8BA4\u8BC6\u5230\uFF0C\u4E59\u65B9\u6839\u636E\u81EA\u8EAB\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u63D0\u4F9B\u7684\u7532\u65B9\u7684\u98CE\u9669\u6D4B\u8BC4\u7ED3\u679C\uFF0C\u5411\u7532\u65B9\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u5EFA\u8BAE\u548C\u57FA\u91D1\u4EA7\u54C1\u7684\u6295\u8D44\u51B3\u7B56\u3002\u4E3A\u6B64\uFF0C\u7532\u65B9\u5E94\u5BA1\u614E\u5B8C\u6210\u98CE\u9669\u6D4B\u8BC4\u5E76\u5411\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u63D0\u4F9B\u771F\u5B9E\u3001\u51C6\u786E\u3001\u5B8C\u6574\u7684\u4FE1\u606F\uFF0C\u5E76\u5728\u8BE5\u7B49\u4FE1\u606F\u6D89\u53CA\u91CD\u5927\u53D8\u5316\u65F6\u53CA\u65F6\u901A\u77E5\u8BE5\u57FA\u91D1\u9500\u552E\u673A\u6784\u3002\u7532\u65B9\u5728\u6B64\u786E\u8BA4\uFF0C\u7532\u65B9\u5E94\u81EA\u884C\u627F\u62C5\u56E0\u672A\u5C65\u884C\u4E0A\u8FF0\u4E49\u52A1\u800C\u4EA7\u751F\u7684\u4EFB\u4F55\u635F\u5931\u6216\u4E0D\u5229\u540E\u679C\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E94\u6761 \u6295\u8D44\u987E\u95EE\u7684\u804C\u8D23\u548C\u7981\u6B62\u884C\u4E3A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u6295\u8D44\u987E\u95EE\u7684\u804C\u8D23'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u5E94\u6309\u7167\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u4E1A\u52A1\u89C4\u5219\u3001\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u3001\u6295\u8D44\u5EFA\u8BAE\u6D41\u7A0B\u3001\u8C03\u4ED3\u7BA1\u7406\u3001\u5229\u76CA\u51B2\u7A81\u3001\u98CE\u9669\u63A7\u5236\u63AA\u65BD\u3001\u4FE1\u606F\u62AB\u9732\u7B49\u5185\u5BB9\uFF0C\u4EE3\u7532\u65B9\u529E\u7406\u6295\u987E\u8D26\u6237\u5F00\u7ACB\u3001\u81EA\u884C\u6216\u901A\u8FC7\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u5F00\u7ACB\u3001\u7EC4\u5408\u8D2D\u4E70\u3001\u7EC4\u5408\u8C03\u4ED3\u3001\u6210\u4EFD\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u6216\u8F6C\u6362\u7B49\u6709\u5173\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u6295\u8D44\u987E\u95EE\u7684\u7981\u6B62\u884C\u4E3A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u53CA\u6295\u8D44\u987E\u95EE\u4EBA\u5458\u4E0D\u5F97\u6709\u4E0B\u5217\u884C\u4E3A\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u5229\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u4ECE\u4E8B\u8FDD\u6CD5\u3001\u8FDD\u89C4\u884C\u4E3A\uFF0C\u6216\u63D0\u4F9B\u4FBF\u5229\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u6CC4\u9732\u5BA2\u6237\u8D44\u6599\u3001\u6295\u8D44\u8BA1\u5212\u548C\u4EA4\u6613\u60C5\u51B5\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '3\u3001\u4ECE\u4E8B\u975E\u516C\u5E73\u4EA4\u6613\u3001\u5229\u76CA\u8F93\u9001\u7B49\u635F\u5BB3\u7532\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u884C\u4E3A\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '4\u3001\u5411\u7532\u65B9\u627F\u8BFA\u6536\u76CA\uFF0C\u627F\u8BFA\u672C\u91D1\u4E0D\u53D7\u635F\u5931\u6216\u8005\u9650\u5B9A\u635F\u5931\u91D1\u989D\u6216\u6BD4\u4F8B\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '5\u3001\u5176\u4ED6\u635F\u5BB3\u7532\u65B9\u5408\u6CD5\u6743\u76CA\u7684\u884C\u4E3A\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '6\u3001\u5176\u4ED6\u6CD5\u5F8B\u6CD5\u89C4\u3001\u89C4\u8303\u6027\u6587\u4EF6\u89C4\u5B9A\u53CA\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u7981\u6B62\u884C\u4E3A\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u516D\u6761 \u6536\u8D39\u9879\u76EE\u3001\u6807\u51C6\u548C\u652F\u4ED8\u65B9\u5F0F'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u6309\u6295\u987E\u8D26\u6237\u5404\u7C7B\u7EC4\u5408\u7684\u8D44\u4EA7\u51C0\u503C\u7684\u4E00\u5B9A\u6BD4\u4F8B\u52A0\u603B\u6536\u53D6\uFF0C\u5177\u4F53\u8D39\u7387\u6807\u51C6\u8BE6\u89C1\u672C\u534F\u8BAE\u6240\u9644\u5404\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7684\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6309\u8D44\u4EA7\u51C0\u503C\u7684\u4E00\u5B9A\u6BD4\u4F8B\u6536\u53D6\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u7684\u8BA1\u7B97\u65B9\u6CD5\u5982\u4E0B\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'H\uFF1DE\xD7R\xF7\u5F53\u5E74\u5929\u6570'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'H\u4E3A\u6BCF\u65E5\u5E94\u8BA1\u63D0\u7684\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'E\u4E3A\u524D\u4E00\u65E5\u6295\u987E\u8D26\u6237\u8D44\u4EA7\u51C0\u503C'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'R\u4E3A\u5404\u7C7B\u7EC4\u5408\u9002\u7528\u7684\u5E74\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u7387'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6BCF\u4E00\u7EC4\u5408\u7684\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u52A0\u603B\u540E\u4E3A\u6295\u987E\u8D26\u6237\u4E2D\u5404\u7C7B\u7EC4\u5408\u7684\u5168\u90E8\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u3002\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u6BCF\u65E5\u8BA1\u63D0\uFF0C\u6309\u6708\u652F\u4ED8\u6216\u5168\u90E8\u53CA\u90E8\u5206\u8D4E\u56DE\u65F6\u652F\u4ED8\uFF0C\u6309\u6708\u652F\u4ED8\u7684\uFF0C\u6BCF\u6708\u7ED3\u675F\u540E\u4E94\u4E2A\u5DE5\u4F5C\u65E5\u5185\u6536\u53D6\uFF0C\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u53E6\u6709\u7EA6\u5B9A\u7684\u9664\u5916\u3002\u7532\u65B9\u540C\u610F\u4E59\u65B9\u53EF\u91C7\u7528\u8D44\u91D1\u5212\u8F6C\u6216\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\u7B49\u76D1\u7BA1\u90E8\u95E8\u8BA4\u53EF\u7684\u5F62\u5F0F\u5B9E\u73B0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u7684\u6536\u53D6\u3002\u82E5\u91C7\u7528\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\u5F62\u5F0F\u7684\uFF0C\u7532\u65B9\u540C\u610F\u5E76\u6388\u6743\u4E59\u65B9\u6216\u5176\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u8D4E\u56DE\u7532\u65B9\u5E94\u652F\u4ED8\u7684\u57FA\u91D1\u6295\u987E\u670D\u52A1\u8D39\u7B49\u989D\u7684\u8D27\u5E01\u57FA\u91D1\u4EFD\u989D\uFF0C\u5E76\u5C06\u4E0A\u8FF0\u8D27\u5E01\u57FA\u91D1\u4EFD\u989D\u8FC7\u6237\u81F3\u4E59\u65B9\u8D26\u6237\uFF0C\u4E59\u65B9\u53EF\u8D4E\u56DE\u4E0A\u8FF0\u8D27\u5E01\u57FA\u91D1\u4EFD\u989D\uFF0C\u4E0A\u8FF0\u8D27\u5E01\u57FA\u91D1\u4EFD\u989D\u8D4E\u56DE\u7684\u8D44\u91D1\u4F5C\u4E3A\u5E94\u652F\u4ED8\u7684\u57FA\u91D1\u6295\u987E\u670D\u52A1\u8D39\u5BF9\u5E94\u7684\u91D1\u989D\u3002\u4EE5\u4E0A\u76F8\u5173\u6307\u4EE4\u6267\u884C\u7ED3\u679C\u7531\u7532\u65B9\u627F\u62C5\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u6709\u6743\u6839\u636E\u76D1\u7BA1\u89C4\u5B9A\u548C\u5E02\u573A\u60C5\u51B5\uFF0C\u5BF9\u4E0A\u8FF0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u5B9E\u65BD\u8D39\u7387\u4F18\u60E0\u6216\u8C03\u6574\uFF0C\u5177\u4F53\u4EE5\u4E59\u65B9\u901A\u8FC7\u4E59\u65B9\u6216\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7F51\u7AD9\u3001\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u516C\u544A\u7B49\u65B9\u5F0F\u901A\u77E5\u7532\u65B9\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u7533\u8D2D\u8D39\u3001\u8D4E\u56DE\u8D39\u3001\u8F6C\u6362\u8D39\u53CA\u57FA\u91D1\u9500\u552E\u8D39\u7528'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7EC4\u5408\u4E2D\u6210\u4EFD\u57FA\u91D1\u7684\u7533\u8D2D\u8D39\u3001\u8D4E\u56DE\u8D39\u3001\u8F6C\u6362\u8D39\u53CA\u57FA\u91D1\u9500\u552E\u8D39\u7528\u7531\u7532\u65B9\u627F\u62C5\uFF0C\u6536\u8D39\u6807\u51C6\u548C\u6536\u53D6\u65B9\u5F0F\u4EE5\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7CFB\u7EDF\u8BBE\u7F6E\u4E3A\u51C6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E03\u6761 \u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                ' '
              ),
              '\u8BE6\u89C1\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u516B\u6761 \u5229\u76CA\u51B2\u7A81'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u9632\u8303\u5229\u76CA\u51B2\u7A81\uFF0C\u5728\u6295\u8D44\u5EFA\u8BAE\u673A\u5236\u4E0A\uFF0C\u4E59\u65B9\u8BBE\u7ACB\u6295\u8D44\u51B3\u7B56\u59D4\u5458\u4F1A\uFF0C\u4E0E\u6BCD\u516C\u53F8\u534E\u590F\u57FA\u91D1\u6295\u8D44\u90E8\u95E8\u3001\u4E59\u65B9\u5176\u4ED6\u90E8\u95E8\u76F8\u4E92\u9694\u79BB\u3002\u6295\u8D44\u51B3\u7B56\u59D4\u5458\u4F1A\u72EC\u7ACB\u5BA1\u8BAE\u57FA\u91D1\u5907\u9009\u5E93\u5165\u5E93\u540D\u5355\uFF0C\u5BA1\u8BAE\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u4EA7\u751F\u548C\u8C03\u6574\u5E76\u8BC4\u4F30\u5F62\u6210\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\uFF0C\u5BA1\u8BAE\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u5177\u4F53\u4EA7\u54C1\u54C1\u79CD\u3001\u6570\u91CF\u7684\u786E\u5B9A\u53CA\u8C03\u6574\uFF1B\u5728\u76D1\u63A7\u673A\u5236\u4E0A\uFF0C\u901A\u8FC7\u98CE\u9669\u7BA1\u7406\u90E8\u95E8\u8FDB\u884C\u6295\u8D44\u7A0B\u5E8F\u548C\u6295\u8D44\u9650\u5236\u7684\u76D1\u63A7\uFF0C\u5E76\u96C6\u4E2D\u5BF9\u57FA\u91D1\u5907\u9009\u5E93\u8FDB\u884C\u7BA1\u7406\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u5728\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u5EFA\u8BAE\u8FC7\u7A0B\u4E2D\uFF0C\u5E94\u5BA2\u89C2\u3001\u72EC\u7ACB\u5F62\u6210\u5EFA\u8BAE\u65B9\u6848\uFF0C\u8BA4\u771F\u6267\u884C\u516C\u5E73\u4EA4\u6613\u5236\u5EA6\uFF0C\u6309\u7167\u89C4\u5B9A\u5BF9\u7279\u6B8A\u4EA4\u6613\u5C65\u884C\u5BA1\u6279\u6216\u5907\u6848\u624B\u7EED\u3002\u4E59\u65B9\u5E94\u5BF9\u5404\u6295\u8D44\u7EC4\u5408\u7684\u6295\u8D44\u7BA1\u7406\u8FDB\u884C\u5B9A\u671F\u68C0\u67E5\u548C\u8BC4\u4F30\uFF0C\u5206\u6790\u662F\u5426\u5B58\u5728\u8FDD\u80CC\u516C\u5E73\u4EA4\u6613\u539F\u5219\u7684\u5F02\u5E38\u60C5\u51B5\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u901A\u8FC7\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u5EFA\u8BAE\u7532\u65B9\u6295\u8D44\u4E8E\u4E59\u65B9\u6216\u5173\u8054\u65B9\u7BA1\u7406\u7684\u4EA7\u54C1\u7684\uFF0C\u5E94\u4E8B\u5148\u544A\u77E5\u7532\u65B9\uFF0C\u5E76\u5411\u7532\u65B9\u5145\u5206\u62AB\u9732\u6F5C\u5728\u5229\u76CA\u51B2\u7A81\uFF1B\u5728\u5907\u9009\u5E93\u6D41\u7A0B\u4E0A\uFF0C\u5BF9\u5173\u8054\u65B9\u548C\u5176\u4ED6\u57FA\u91D1\u7BA1\u7406\u4EBA\u7BA1\u7406\u7684\u6210\u4EFD\u57FA\u91D1\u91C7\u7528\u540C\u4E00\u6807\u51C6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u540C\u65F6\u4F5C\u4E3A\u7EC4\u5408\u6210\u4EFD\u57FA\u91D1\u7684\u9500\u552E\u673A\u6784\uFF0C\u53EF\u80FD\u4E0E\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u6784\u6210\u5229\u76CA\u51B2\u7A81\u3002\u4E3A\u9632\u8303\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u4E0E\u57FA\u91D1\u9500\u552E\u4E1A\u52A1\u90E8\u95E8\u7B49\u53EF\u80FD\u5B58\u5728\u7684\u5229\u76CA\u51B2\u7A81\uFF0C\u4E59\u65B9\u5C06\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u4FDD\u969C\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u72EC\u7ACB\u4E0E\u9694\u79BB\uFF0C\u9632\u8303\u56E0\u5176\u4ED6\u4E1A\u52A1\u5F71\u54CD\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u7A33\u5065\u8FD0\u884C\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u58F0\u660E\u3001\u4FDD\u8BC1\u548C\u627F\u8BFA\uFF0C\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u5E94\u4EE5\u6295\u8D44\u8005\u5229\u76CA\u81F3\u4E0A\uFF0C\u516C\u5E73\u5BF9\u5F85\u5BA2\u6237\u3002\u5F53\u51FA\u73B0\u5229\u76CA\u51B2\u7A81\u65F6\uFF0C\u4E59\u65B9\u4E0D\u5F97\u4E3A\u516C\u53F8\u53CA\u5176\u5173\u8054\u65B9\u7684\u5229\u76CA\u635F\u5BB3\u6295\u8D44\u8005\u5229\u76CA\uFF0C\u4E0D\u5F97\u4E3A\u4E59\u65B9\u6295\u8D44\u987E\u95EE\u4EBA\u5458\u53CA\u5176\u5229\u76CA\u76F8\u5173\u8005\u7684\u5229\u76CA\u635F\u5BB3\u7532\u65B9\u5229\u76CA\uFF0C\u4E0D\u5F97\u4E3A\u7279\u5B9A\u5BA2\u6237\u5229\u76CA\u635F\u5BB3\u5176\u4ED6\u5BA2\u6237\u5229\u76CA\u3002\u4E59\u65B9\u4FDD\u8BC1\u5176\u4E0D\u4F1A\u76F4\u63A5\u6216\u95F4\u63A5\u53C2\u4E0E\u5185\u5E55\u4EA4\u6613\u3001\u64CD\u7EB5\u8BC1\u5238\u4EA4\u6613\u4EF7\u683C\u6216\u901A\u8FC7\u6295\u8D44\u7EC4\u5408\u8FDB\u884C\u975E\u6CD5\u5229\u76CA\u8F93\u9001\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u53EF\u4EE5\u59D4\u6258\u5176\u6BCD\u516C\u53F8\u534E\u590F\u57FA\u91D1\u53C2\u4E0E\u57FA\u91D1\u914D\u7F6E\u5EFA\u8BAE\u7684\u6295\u8D44\u51B3\u7B56\uFF0C\u4E3A\u4E59\u65B9\u7684\u57FA\u91D1\u6295\u987E\u670D\u52A1\u63D0\u4F9B\u6295\u8D44\u7814\u7A76\u652F\u6301\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u4E5D\u6761 \u98CE\u9669\u63A7\u5236\u63AA\u65BD'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6839\u636E\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u7279\u70B9\uFF0C\u4E59\u65B9\u5EFA\u7ACB\u4E86\u5408\u89C4\u98CE\u9669\u9632\u63A7\u4F53\u7CFB\uFF0C\u7EF4\u62A4\u4E1A\u52A1\u7A33\u5B9A\u8FD0\u884C\u3002\u5177\u4F53\u98CE\u9669\u63A7\u5236\u63AA\u65BD\u5982\u4E0B\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u64CD\u4F5C\u98CE\u9669'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u8D44\u91D1\u76D1\u7BA1'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7EC4\u5408\u8D44\u91D1\u4EA4\u6536\u5168\u8FC7\u7A0B\u5728\u57FA\u91D1\u9500\u552E\u7ED3\u7B97\u8D44\u91D1\u76D1\u7BA1\u884C\u7684\u76D1\u7763\u4E0B\u8FDB\u884C\uFF0C\u786E\u4FDD\u7532\u65B9\u8D44\u91D1\u540C\u5361\u8FDB\u51FA\uFF0C\u901A\u8FC7\u95ED\u73AF\u64CD\u4F5C\u4FDD\u969C\u7532\u65B9\u8D44\u91D1\u5B89\u5168\uFF0C\u9632\u8303\u8D44\u91D1\u4EA4\u6536\u548C\u6D17\u94B1\u98CE\u9669\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u8D26\u6237\u6388\u6743\u7BA1\u7406'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u6309\u57FA\u91D1\u9500\u552E\u6709\u5173\u89C4\u5B9A\u5F00\u7ACB\u7684\u57FA\u91D1\u4EA4\u6613\u8D26\u6237\u4F5C\u4E3A\u5176\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u6388\u6743\u8D26\u6237\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '3\u3001\u8C03\u4ED3\u7BA1\u7406'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7EC4\u5408\u8C03\u4ED3\u65B9\u6848\u7531\u4E59\u65B9\u51FA\u5177\u5E76\u7EC4\u7EC7\u5B9E\u65BD\uFF0C\u901A\u8FC7\u72EC\u7ACB\u7684\u90E8\u95E8\u3001\u4EBA\u5458\u3001\u7CFB\u7EDF\u9694\u79BB\u9632\u8303\u5229\u76CA\u51B2\u7A81\uFF0C\u5E76\u901A\u8FC7\u5185\u90E8\u6D41\u7A0B\u548C\u7CFB\u7EDF\u63A7\u5236\u964D\u4F4E\u64CD\u4F5C\u98CE\u9669\u3002 \u7EC4\u5408\u8C03\u4ED3\u671F\u95F4\u4E59\u65B9\u8D1F\u8D23\u5BF9\u4EA4\u6613\u7533\u8BF7\u3001\u786E\u8BA4\u3001\u6E05\u7B97\u3001\u8D44\u91D1\u5212\u8F6C\u7B49\u4E1A\u52A1\u6D41\u7A0B\u7684\u8FD0\u884C\u72B6\u6001\u8FDB\u884C\u76D1\u63A7\uFF1B\u4E59\u65B9\u8D1F\u8D23\u5BF9\u7CFB\u7EDF\u72B6\u51B5\u3001\u670D\u52A1\u5668\u8D1F\u8F7D\u60C5\u51B5\u7B49\u8FDB\u884C\u5B9E\u65F6\u76D1\u63A7\uFF0C\u53CA\u65F6\u53D1\u73B0\u5E76\u5904\u7406\u5F02\u5E38\u60C5\u51B5\uFF0C\u786E\u4FDD\u7CFB\u7EDF\u6B63\u5E38\u8FD0\u8F6C\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '4\u3001\u5E94\u6025\u9884\u6848'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u89C4\u907F\u5F02\u5E38\u60C5\u51B5\u5BFC\u81F4\u7684\u4E1A\u52A1\u98CE\u9669\uFF0C\u9488\u5BF9\u5E95\u5C42\u57FA\u91D1\u6682\u505C\u3001\u7533\u8D2D\u5931\u8D25\u3001\u8D44\u91D1\u4EA4\u6536\u5931\u8D25\u3001\u7CFB\u7EDF\u6545\u969C\u7B49\u60C5\u5F62\uFF0C\u4E59\u65B9\u5236\u5B9A\u6709\u76F8\u5E94\u7684\u5E94\u6025\u5904\u7406\u9884\u6848\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u7EC4\u5408\u5E02\u573A\u98CE\u9669\u7BA1\u7406'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u7EC4\u5408\u6295\u8D44\u9650\u5236'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6295\u8D44\u7EC4\u5408\u5728\u6295\u8D44\u65B9\u9762\u9700\u8981\u7B26\u5408\u4EE5\u4E0B\u8981\u6C42\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF081\uFF09\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u7684\u5355\u4E2A\u5BA2\u6237\u6301\u6709\u5355\u53EA\u57FA\u91D1\u7684\u5E02\u503C\uFF0C\u4E0D\u5F97\u9AD8\u4E8E\u5BA2\u6237\u8D26\u6237\u8D44\u4EA7\u51C0\u503C\u768420%\uFF0C\u8D27\u5E01\u5E02\u573A\u57FA\u91D1\u3001\u6307\u6570\u57FA\u91D1\u4E0D\u53D7\u6B64\u9650\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF082\uFF09\u5355\u4E00\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u4E0B\u6240\u6709\u5BA2\u6237\u6301\u6709\u5355\u53EA\u57FA\u91D1\u7684\u4EFD\u989D\u7EFC\u5408\u4E0D\u5F97\u8D85\u8FC7\u8BE5\u57FA\u91D1\u603B\u4EFD\u989D\u768420%\uFF0C\u6301\u6709\u6307\u6570\u57FA\u91D1\u7684\u4EFD\u989D\u603B\u548C\u4E0D\u5F97\u8D85\u8FC7\u8BE5\u57FA\u91D1\u603B\u4EFD\u989D\u768430%\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF083\uFF09\u5355\u4E00\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u4E0B\u6240\u6709\u5BA2\u6237\u5355\u65E5\u8D4E\u56DE\u5355\u53EA\u57FA\u91D1\u7684\u4EFD\u989D\u603B\u548C\u539F\u5219\u4E0A\u4E0D\u8D85\u8FC7\u8BE5\u57FA\u91D1\u603B\u4EFD\u989D\u76845%\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF084\uFF09\u4E0D\u5F97\u5411\u6295\u8D44\u8005\u5EFA\u8BAE\u7ED3\u6784\u7684\u57FA\u91D1\uFF0C\u5305\u62EC\u5206\u7EA7\u57FA\u91D1\u573A\u5185\u4EFD\u989D\u548C\u76D1\u7BA1\u90E8\u95E8\u8BA4\u5B9A\u7684\u5176\u4ED6\u57FA\u91D1\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF085\uFF09\u5EFA\u8BAE\u6295\u8D44\u8005\u6295\u8D44\u4E8E\u5C01\u95ED\u8FD0\u4F5C\u57FA\u91D1\u3001\u5B9A\u671F\u5F00\u653E\u57FA\u91D1\u7B49\u6D41\u901A\u53D7\u9650\u57FA\u91D1\u7684\uFF0C\u5E94\u5F53\u5236\u5B9A\u4E13\u95E8\u7684\u98CE\u9669\u7BA1\u7406\u5236\u5EA6\uFF0C\u5411\u6295\u8D44\u8005\u7279\u522B\u63D0\u793A\u98CE\u9669\u3002\u5411\u666E\u901A\u6295\u8D44\u8005\u5EFA\u8BAE\u6295\u8D44\u6D41\u901A\u53D7\u9650\u57FA\u91D1\u7684\uFF0C\u5E94\u5F53\u4E8B\u5148\u53D6\u5F97\u6295\u8D44\u8005\u540C\u610F\uFF0C\u4E14\u786E\u8BA4\u6D41\u901A\u53D7\u9650\u57FA\u91D1\u7684\u6295\u8D44\u671F\u9650\u4E0E\u6295\u8D44\u8005\u7684\u76EE\u6807\u6295\u8D44\u671F\u9650\u4E0D\u5B58\u5728\u51B2\u7A81\u3002 \u56E0\u8BC1\u5238\u5E02\u573A\u6CE2\u52A8\u3001\u57FA\u91D1\u89C4\u6A21\u53D8\u52A8\u7B49\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u4E4B\u5916\u7684\u56E0\u7D20\u5BFC\u81F4\u4E0D\u7B26\u5408\u4E0A\u8FF0\u8981\u6C42\uFF0C\u5E94\u5F53\u57283\u4E2A\u6708\u5185\u8C03\u6574\uFF0C\u7ECF\u76D1\u7BA1\u90E8\u95E8\u8BA4\u53EF\u7684\u60C5\u5F62\u9664\u5916\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u5E02\u573A\u98CE\u9669\u76D1\u63A7'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u6BCF\u65E5\u5BF9\u5404\u7EC4\u5408\u7684\u76C8\u4E8F\u60C5\u51B5\u3001\u6CE2\u52A8\u7387\u3001\u56DE\u64A4\u3001\u5E95\u5C42\u57FA\u91D1\u7684\u76F8\u5173\u6027\u3001\u5E95\u5C42\u57FA\u91D1\u76C8\u4E8F\u60C5\u51B5\u3001\u5E95\u5C42\u57FA\u91D1\u7684\u98CE\u9669\u5360\u6BD4\u8FDB\u884C\u76D1\u63A7\u3002\u6BCF\u5B63\u5EA6\u5BF9\u7EC4\u5408\u548C\u5E02\u573A\u60C5\u51B5\u8FDB\u884C\u56DE\u987E\u548C\u8C03\u6574\uFF0C\u786E\u4FDD\u5404\u7EC4\u5408\u59CB\u7EC8\u7B26\u5408\u65E2\u5B9A\u6295\u8D44\u76EE\u6807\u3002\u4E59\u65B9\u5728\u5FC5\u8981\u65F6\u65B9\u8FDB\u884C\u8C03\u4ED3\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '3\u3001\u6A21\u578B\u98CE\u9669\u63A7\u5236'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5728\u8D44\u4EA7\u914D\u7F6E\u548C\u57FA\u91D1\u9009\u62E9\u8FC7\u7A0B\u4E2D\uFF0C\u4E59\u65B9\u91C7\u7528\u5B9A\u6027\u4E3A\u4E3B\u3001\u91CF\u5316\u5DE5\u5177\u8F85\u52A9\u7684\u7B56\u7565\u3002\u7EC4\u5408\u8D44\u4EA7\u914D\u7F6E\u548C\u8C03\u4ED3\u5EFA\u8BAE\u4E3B\u8981\u4F9D\u8D56\u4E8E\u4E59\u65B9\u5BF9\u5B8F\u89C2\u7ECF\u6D4E\u3001\u4F30\u503C\u3001\u653F\u7B56\u7684\u5224\u65AD\u4EE5\u53CA\u6295\u7814\u4EBA\u5458\u7684\u8C03\u7814\u5F97\u5230\uFF0C\u5E76\u4E0D\u5B8C\u5168\u4F9D\u8D56\u4E8E\u7B97\u6CD5\u7A0B\u5E8F\uFF0C\u6A21\u578B\u98CE\u9669\u53EF\u63A7\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '4\u3001\u6D41\u52A8\u6027\u98CE\u9669\u7BA1\u7406'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u6301\u7EED\u76D1\u63A7\u5404\u7EC4\u5408\u53CA\u5BF9\u5E94\u5E95\u5C42\u57FA\u91D1\u7684\u8BA4/\u7533\u8D2D\u3001\u8D4E\u56DE\u60C5\u51B5\uFF0C\u5305\u62EC\u7EC4\u5408\u8C03\u4ED3\u671F\u95F4\u5BF9\u5E95\u5C42\u57FA\u91D1\u89C4\u6A21\u53D8\u5316\u7684\u5F71\u54CD\uFF0C\u53CA\u65F6\u8BC4\u4F30\u548C\u76D1\u6D4B\u5404\u5E95\u5C42\u57FA\u91D1\u7684\u6D41\u52A8\u6027\u98CE\u9669\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '5\u3001\u7EC4\u5408\u4E1A\u7EE9\u5206\u6790\u548C\u7EE9\u6548\u5F52\u56E0'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u6BCF\u6708\u5BF9\u7EC4\u5408\u8FDB\u884C\u4E1A\u7EE9\u5206\u6790\uFF0C\u8BA1\u7B97\u7EC4\u5408\u98CE\u9669\u8C03\u6574\u7684\u6536\u76CA\u6307\u6807\uFF0C\u5982\u590F\u666E\u6BD4\u7387\u3001\u56DE\u64A4\u3001\u6CE2\u52A8\u7387\u7B49\uFF1B\u901A\u8FC7\u6536\u76CA\u5F52\u56E0\u6A21\u578B\u6708\u5EA6\u5BF9\u7EC4\u5408\u7684\u4E1A\u7EE9\u8FDB\u884C\u5F52\u56E0\u5206\u6790\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E09\uFF09\u5229\u76CA\u51B2\u7A81\u98CE\u9669\u9632\u8303'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u9632\u8303\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u4E0E\u57FA\u91D1\u9500\u552E\u4E1A\u52A1\u90E8\u95E8\u7B49\u53EF\u80FD\u5B58\u5728\u7684\u5229\u76CA\u51B2\u7A81\uFF0C\u4E59\u65B9\u5C06\u91C7\u53D6\u76F8\u5E94\u63AA\u65BD\u4FDD\u969C\u6295\u987E\u4E1A\u52A1\u7684\u72EC\u7ACB\u4E0E\u9694\u79BB\uFF0C\u9632\u8303\u56E0\u5176\u4ED6\u4E1A\u52A1\u5F71\u54CD\u6295\u987E\u4E1A\u52A1\u7684\u7A33\u5065\u8FD0\u884C\u3002\u5728\u6295\u8D44\u5EFA\u8BAE\u673A\u5236\u4E0A\uFF0C\u4E59\u65B9\u72EC\u7ACB\u8BBE\u7ACB\u4EA7\u54C1\u90E8\u95E8\uFF0C\u4E0E\u6BCD\u516C\u53F8\u534E\u590F\u57FA\u91D1\u6295\u8D44\u90E8\u95E8\u3001\u4E59\u65B9\u5176\u4ED6\u90E8\u95E8\u76F8\u4E92\u9694\u79BB\uFF0C\u72EC\u7ACB\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u5EFA\u8BAE\u3002\u5728\u76D1\u63A7\u673A\u5236\u4E0A\uFF0C\u901A\u8FC7\u98CE\u9669\u7BA1\u7406\u90E8\u95E8\u8FDB\u884C\u6295\u8D44\u7A0B\u5E8F\u548C\u6295\u8D44\u9650\u5236\u7684\u76D1\u63A7\uFF0C\u5E76\u96C6\u4E2D\u5BF9\u57FA\u91D1\u5907\u9009\u5E93\u8FDB\u884C\u7BA1\u7406\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u9632\u8303\u5229\u76CA\u51B2\u7A81\uFF0C\u4E59\u65B9\u5728\u63D0\u4F9B\u57FA\u91D1\u914D\u7F6E\u5EFA\u8BAE\u8FC7\u7A0B\u4E2D\uFF0C\u5BA2\u89C2\u3001\u72EC\u7ACB\u5F62\u6210\u5EFA\u8BAE\u65B9\u6848\uFF0C\u8BA4\u771F\u6267\u884C\u516C\u5E73\u4EA4\u6613\u5236\u5EA6\uFF0C\u6309\u7167\u89C4\u5B9A\u5BF9\u7279\u6B8A\u4EA4\u6613\u5C65\u884C\u5BA1\u6279\u6216\u5907\u6848\u624B\u7EED\u3002\u4E59\u65B9\u5E94\u5BF9\u5404\u6295\u8D44\u7EC4\u5408\u7684\u6295\u8D44\u7BA1\u7406\u8FDB\u884C\u5B9A\u671F\u68C0\u67E5\u548C\u8BC4\u4F30\uFF0C\u5206\u6790\u662F\u5426\u5B58\u5728\u8FDD\u80CC\u516C\u5E73\u4EA4\u6613\u539F\u5219\u7684\u5F02\u5E38\u60C5\u51B5\u3002\u4E59\u65B9\u5C06\u6309\u7167\u4E59\u65B9\u4EA7\u54C1\u90E8\u7684\u7EC4\u5408\u5EFA\u8BAE\u65B9\u6848\u4E3A\u7532\u65B9\u4E0B\u5355\u7533\u8D2D\u3001\u8D4E\u56DE\u7EC4\u5408\u6210\u4EFD\u57FA\u91D1\uFF0C\u6216\u4EE3\u7532\u65B9\u5411\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u51FA\u5177\u7533\u8D2D\u3001\u8D4E\u56DE\u7EC4\u5408\u6210\u4EFD\u57FA\u91D1\u6307\u4EE4\uFF0C\u4E3A\u907F\u514D\u91CD\u590D\u6536\u8D39\uFF0C\u4FDD\u62A4\u7532\u65B9\u5229\u76CA\uFF0C\u5728\u7533\u8D2D\u3001\u8D4E\u56DE\u7EC4\u5408\u4E2D\u7684\u6210\u4EFD\u57FA\u91D1\u65F6\uFF0C\u5C06\u4E0D\u6536\u53D6\u6210\u4EFD\u57FA\u91D1\u8BA1\u5165\u57FA\u91D1\u8D44\u4EA7\u5916\u7684\u7533\u8D2D\u3001\u8D4E\u56DE\u8D39\u7528\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5C3D\u7BA1\u672C\u534F\u8BAE\u53E6\u6709\u89C4\u5B9A\uFF0C\u6BCD\u516C\u53F8\u534E\u590F\u57FA\u91D1\u6709\u6743\u53C2\u4E0E\u57FA\u91D1\u914D\u7F6E\u5EFA\u8BAE\u7684\u6295\u8D44\u51B3\u7B56\uFF0C\u4E3A\u4E59\u65B9\u7684\u57FA\u91D1\u6295\u987E\u670D\u52A1\u63D0\u4F9B\u6295\u8D44\u7814\u7A76\u652F\u6301\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u6761 \u4FE1\u606F\u62AB\u9732'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E3A\u786E\u4FDD\u7532\u65B9\u5145\u5206\u77E5\u6089\u6240\u529E\u7406\u7684\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u60C5\u51B5\uFF0C\u4E59\u65B9\u5C06\u5728\u7F51\u7AD9\u548C\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u62AB\u9732\u6295\u8D44\u7EC4\u5408\u7684\u6295\u8D44\u76EE\u6807\u3001\u6295\u8D44\u7B56\u7565\u3001\u57FA\u91D1\u5907\u9009\u5E93\u660E\u7EC6\u3001\u4E1A\u7EE9\u6BD4\u8F83\u57FA\u51C6\u3001\u8D39\u7387\u7ED3\u6784\u3001\u98CE\u9669\u6536\u76CA\u7279\u5F81\u3001\u98CE\u9669\u63ED\u793A\u7B49\u4FE1\u606F\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5728\u65E5\u5E38\u8FD0\u4F5C\u4FE1\u606F\u65B9\u9762\uFF0C\u5C06\u6BCF\u65E5\u62AB\u9732\u4E0A\u4E00\u4EA4\u6613\u65E5\u7EC4\u5408\u6536\u76CA\u7387\u3001\u8D26\u6237\u6536\u76CA\u7387\u3001\u8D26\u6237\u8D44\u4EA7\u51C0\u503C\u60C5\u51B5\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5728\u5B9A\u671F\u62A5\u544A\u65B9\u9762\uFF0C\u6BCF\u5B63\u5EA6\u62AB\u9732\u5E74\u5316\u6536\u76CA\u7387\u548C\u5B63\u5EA6\u6536\u76CA\u7387\u3001\u7EC4\u5408\u8FD0\u4F5C\u5206\u6790\u3001\u8D44\u4EA7\u7EC4\u5408\u60C5\u51B5\u3001\u6210\u4EFD\u57FA\u91D1\u6784\u6210\u53CA\u5360\u6BD4\u3001\u672C\u671F\u8C03\u51FA\u8C03\u5165\u6210\u4EFD\u57FA\u91D1\u8BB0\u5F55\u4EE5\u53CA\u5F53\u671F\u4EA4\u6613\u53CA\u6301\u6709\u57FA\u91D1\u4EA7\u751F\u7684\u8D39\u7528\uFF0C\u5E76\u6309\u6BCF\u5B63\u7684\u9891\u7387\u5411\u5BA2\u6237\u53D1\u9001\u8D26\u6237\u6301\u4ED3\u3001\u4EA4\u6613\u8BB0\u5F55\u7B49\u4FE1\u606F\uFF0C\u5E76\u5C31\u662F\u5426\u5168\u9762\u6839\u636E\u534F\u8BAE\u76F8\u5173\u7EA6\u5B9A\u8FDB\u884C\u4EA4\u6613\u64CD\u4F5C\u3001\u662F\u5426\u5B58\u5728\u6267\u884C\u504F\u5DEE\u3001\u4EA4\u6613\u7B56\u7565\u8C03\u6574\u7B49\u8FDB\u884C\u4E13\u9879\u8BF4\u660E\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u5728\u4E34\u65F6\u4FE1\u606F\u62AB\u9732\u65B9\u9762\uFF0C\u82E5\u53D1\u751F\u5F71\u54CD\u7532\u65B9\u5229\u76CA\u7684\u91CD\u5927\u4E8B\u4EF6\uFF0C\u5C06\u53CA\u65F6\u901A\u8FC7\u7F51\u7AD9\u548C\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u4E0A\u62AB\u9732\u4E34\u65F6\u516C\u544A\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u6839\u636E\u672C\u534F\u8BAE\u5728\u7F51\u7AD9\u548C\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u4E0A\uFF0C\u62AB\u9732\u8D26\u6237\u6536\u76CA\u3001\u6301\u4ED3\u3001\u4EA4\u6613\u8BB0\u5F55\u7B49\u4FE1\u606F\uFF0C\u62AB\u9732\u9891\u7387\u5982\u4E0B\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF081\uFF09\u8D26\u6237\u6536\u76CA\uFF1AT+1\u65E5\u5411\u7532\u65B9\u62AB\u9732\u5176\u8D26\u6237\u6536\u76CA\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF082\uFF09\u6301\u4ED3\uFF1A\u6BCF\u5B63\u5EA6\u5411\u7532\u65B9\u62AB\u9732\u5176\u6301\u4ED3\u4FE1\u606F\uFF1B'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF083\uFF09\u4EA4\u6613\u8BB0\u5F55\uFF1A\u5B9E\u65F6\u62AB\u9732\u7532\u65B9\u4EA4\u6613\u8BB0\u5F55\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u53EF\u901A\u8FC7\u62E8\u6253\u4E59\u65B9\u5BA2\u670D\u7535\u8BDD\u65B9\u5F0F\u83B7\u53D6\u6301\u4ED3\u60C5\u51B5\u548C\u4EA4\u6613\u660E\u7EC6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u4FDD\u8BC1\u7532\u65B9\u80FD\u591F\u6309\u7167\u6CD5\u89C4\u89C4\u5B9A\u53CA\u672C\u534F\u8BAE\u4E0A\u8FF0\u7EA6\u5B9A\u7684\u65F6\u95F4\u548C\u65B9\u5F0F\u67E5\u8BE2\u8D26\u6237\u4FE1\u606F\u3002\u53D1\u751F\u53EF\u80FD\u5F71\u54CD\u5BA2\u6237\u6743\u76CA\u7684\u91CD\u5927\u4E8B\u9879\u65F6\uFF0C\u5E94\u5F53\u81EA\u91CD\u5927\u4E8B\u9879\u53D1\u751F\u4E4B\u65E5\u8D772\u65E5\u5185\uFF0C\u6309\u7167\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u65B9\u5F0F\uFF0C\u5411\u7532\u65B9\u8FDB\u884C\u62AB\u9732\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u53EF\u5BF9\u4E59\u65B9\u5C65\u884C\u4E0A\u8FF0\u4FE1\u606F\u62AB\u9732\u60C5\u51B5\u5B9E\u65BD\u76D1\u7763\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u4E00\u6761 \u8FDD\u7EA6\u8D23\u4EFB'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u534F\u8BAE\u4EFB\u4F55\u4E00\u65B9\u56E0\u6545\u610F\u6216\u8FC7\u5931\u8FDD\u53CD\u672C\u534F\u8BAE\u7684\u7EA6\u5B9A\uFF0C\u7ED9\u53E6\u4E00\u65B9\u9020\u6210\u635F\u5931\u7684\uFF0C\u5E94\u627F\u62C5\u76F8\u5E94\u7684\u8FDD\u7EA6\u8D23\u4EFB\u3002\u5982\u5C5E\u53CC\u65B9\u8FDD\u7EA6\uFF0C\u7531\u53CC\u65B9\u5206\u522B\u627F\u62C5\u5404\u81EA\u5E94\u8D1F\u7684\u8D23\u4EFB\u3002\u4E59\u65B9\u4E0E\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5206\u522B\u5BF9\u5404\u81EA\u7684\u884C\u4E3A\u4F9D\u6CD5\u627F\u62C5\u8D23\u4EFB\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u4E8C\u6761 \u6CD5\u5F8B\u9002\u7528'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u672C\u534F\u8BAE\u7684\u6210\u7ACB\u3001\u751F\u6548\u3001\u5C65\u884C\u548C\u89E3\u91CA\uFF0C\u5747\u9002\u7528\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6CD5\u5F8B\uFF1B\u6CD5\u5F8B\u65E0\u660E\u6587\u89C4\u5B9A\u7684\uFF0C\u53EF\u9002\u7528\u901A\u884C\u7684\u884C\u4E1A\u60EF\u4F8B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u5982\u679C\u672C\u534F\u8BAE\u7684\u90E8\u5206\u89C4\u5B9A\u4E0E\u6709\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\u6216\u91D1\u878D\u89C4\u7AE0\u76F8\u62B5\u89E6\uFF0C\u53CC\u65B9\u5E94\u6309\u6709\u5173\u7684\u6CD5\u5F8B\u6CD5\u89C4\u6216\u91D1\u878D\u89C4\u7AE0\u7684\u89C4\u5B9A\u5C65\u884C\u81EA\u5DF1\u7684\u6743\u5229\u4E49\u52A1\uFF0C\u534F\u8BAE\u7684\u5176\u4ED6\u90E8\u5206\u7684\u6548\u529B\u4E0D\u53D7\u5F71\u54CD\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E09\uFF09\u5173\u4E8E\u672C\u534F\u8BAE\u7684\u672A\u5C3D\u4E8B\u5B9C\uFF0C\u53CC\u65B9\u540C\u610F\u6309\u7167\u4E59\u65B9\u53CA\u4E59\u65B9\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u6709\u5173\u89C4\u5B9A\u548C\u91D1\u878D\u76D1\u7BA1\u89C4\u7AE0\u7684\u89C4\u5B9A\u529E\u7406\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u4E09\u6761 \u4E89\u8BAE\u7684\u89E3\u51B3'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u534F\u8BAE\u5C65\u884C\u5730\u4E3A\u5317\u4EAC\u5E02\uFF0C\u7532\u3001\u4E59\u53CC\u65B9\u5728\u5C65\u884C\u672C\u534F\u8BAE\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u5982\u53D1\u751F\u4E89\u8BAE\uFF0C\u5E94\u534F\u5546\u89E3\u51B3\u3002\u534F\u5546\u4E0D\u6210\u7684\uFF0C\u4EFB\u4F55\u4E00\u65B9\u5747\u53EF\u5411\u5317\u4EAC\u4EF2\u88C1\u59D4\u5458\u4F1A\u63D0\u8D77\u4EF2\u88C1\u3002\u4EF2\u88C1\u88C1\u51B3\u662F\u7EC8\u5C40\u7684\uFF0C\u5BF9\u53CC\u65B9\u5747\u5177\u6709\u7EA6\u675F\u529B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2B\u5341\u56DB\u6761 \u534F\u8BAE\u9002\u7528'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u534F\u8BAE\u672A\u4F5C\u7EA6\u5B9A\u7684\uFF0C\u4EE5\u4E59\u65B9\u53CA\u4E59\u65B9\u6307\u5B9A\u7684\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u5236\u5B9A\u5E76\u4E0D\u65F6\u66F4\u65B0\u7684\u4E1A\u52A1\u89C4\u5219\u4E3A\u51C6\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u4E94\u6761 \u534F\u8BAE\u7B7E\u7F72\u3001\u53D8\u66F4\u4E0E\u89E3\u9664'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u7B7E\u7F72\u672C\u534F\u8BAE\u5373\u8868\u660E\u7532\u65B9\u5DF2\u7ECF\u4ED4\u7EC6\u9605\u8BFB\u672C\u670D\u52A1\u534F\u8BAE\u5404\u9879\u5185\u5BB9\uFF0C\u6E05\u695A\u53CC\u65B9\u7684\u6743\u5229\u4E49\u52A1\uFF0C\u613F\u610F\u901A\u8FC7\u7535\u5B50\u4FE1\u606F\u7F51\u7EDC\u4EE5\u7535\u5B50\u5F62\u5F0F\u7B7E\u7F72\u76F8\u5173\u6587\u4EF6\u5E76\u627F\u62C5\u76F8\u5173\u7B7E\u7EA6\u540E\u679C\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u534F\u8BAE\u81EA\u7532\u65B9\u7B7E\u7F72\u534F\u8BAE\u65F6\u751F\u6548\u3002\u7532\u65B9\u4E8E\u7F51\u7AD9\u3001\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u4E0A\u786E\u8BA4\u672C\u534F\u8BAE\u5185\u5BB9\u3001\u8F93\u5165\u4E13\u6709\u7684\u8D26\u6237\u5BC6\u7801\u5373\u4E3A\u534F\u8BAE\u7B7E\u7F72\uFF0C\u4E0E\u7532\u65B9\u7EB8\u8D28\u6587\u4EF6\u4E0A\u7B7E\u540D\u5177\u6709\u540C\u7B49\u6548\u529B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u53EF\u4EE5\u6839\u636E\u76D1\u7BA1\u90E8\u95E8\u6709\u5173\u8981\u6C42\u3001\u884C\u4E1A\u534F\u4F1A\u6709\u5173\u6307\u5F15\u3001\u5B9E\u9645\u60C5\u51B5\u548C\u4E1A\u52A1\u9700\u8981\u53D8\u66F4\u672C\u534F\u8BAE\u5177\u4F53\u5185\u5BB9\uFF0C\u53D1\u751F\u53D8\u66F4\u7684\uFF0C\u4E59\u65B9\u5C06\u5728\u7F51\u7AD9\u3001\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u6216\u8425\u4E1A\u573A\u6240\u516C\u544A\u6216\u4EE5\u5176\u4ED6\u9002\u5F53\u65B9\u5F0F\u901A\u77E5\uFF0C\u800C\u65E0\u9700\u53E6\u884C\u5355\u72EC\u901A\u77E5\u6295\u8D44\u8005\uFF1B\u6295\u8D44\u8005\u5728\u516C\u544A\u540E\u7EE7\u7EED\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\uFF0C\u89C6\u4E3A\u63A5\u53D7\u8BE5\u53D8\u66F4\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u534F\u8BAE\u5E94\u6301\u7EED\u6709\u6548\uFF0C\u9664\u975E\u4EFB\u4F55\u4E00\u65B9\u5728\u4EE5\u4E0B\u60C5\u5F62\u63D0\u524D\u89E3\u9664\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u82E5\u4EFB\u4F55\u4E00\u65B9\u51FA\u73B0\u4EE5\u4E0B\u60C5\u5F62\uFF0C\u4EFB\u4F55\u4E00\u65B9\u6709\u6743\u5728\u63D0\u524D\u901A\u77E5\u7684\u524D\u63D0\u4E0B\u968F\u65F6\u7ACB\u5373\u7EC8\u6B62\u672C\u534F\u8BAE\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u8FDD\u53CD\u672C\u534F\u8BAE\u89C4\u5B9A\u7684\u4E49\u52A1\u4E14\u672A\u80FD\u53CA\u65F6\u8865\u6551\uFF1B\u6216'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u7834\u4EA7\uFF08\u4E3A\u91CD\u7EC4\u6216\u5408\u5E76\u76EE\u7684\u8FDB\u884C\u7684\u81EA\u613F\u6E05\u7B97\u9664\u5916\uFF09\u6216\u5176\u53D1\u751F\u8D22\u4EA7\u63A5\u7BA1\u7684\uFF1B\u6216'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '3\u3001\u4E59\u65B9\u5F00\u5C55\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u8D44\u683C\u88AB\u6682\u505C\u6216\u64A4\u9500\uFF1B\u6216'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '4\u3001\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u3001\u76D1\u7BA1\u8981\u6C42\u89E3\u9664\u7684\uFF1B\u53CA'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u7532\u65B9\u6709\u6743\u6839\u636E\u4E59\u65B9\u9875\u9762\u63D0\u793A\u7684\u64CD\u4F5C\u6B65\u9AA4\u968F\u65F6\u7EC8\u6B62\u672C\u534F\u8BAE\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u534F\u8BAE\u89E3\u9664\u6216\u7EC8\u6B62\u540E\uFF0C\u4E59\u65B9\u4E0D\u518D\u4E3A\u7532\u65B9\u7684\u6295\u8D44\u7EC4\u5408\u63D0\u4F9B\u6388\u6743\u7BA1\u7406\u670D\u52A1\uFF0C\u7532\u65B9\u5E94\u81EA\u884C\u51B3\u5B9A\u6295\u8D44\u7EC4\u5408\u5185\u7684\u6210\u4EFD\u57FA\u91D1\u662F\u5426\u8D4E\u56DE\u6216\u8FDB\u884C\u5176\u4ED6\u8C03\u4ED3\u64CD\u4F5C\u3002\u672C\u534F\u8BAE\u89E3\u9664\u6216\u7EC8\u6B62\u524D\u4E59\u65B9\u5DF2\u7ECF\u6536\u53D6\u7684\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u4E0D\u4E88\u9000\u8FD8\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2B\u5341\u516D\u6761 \u9001\u8FBE'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u540C\u610F\uFF0C\u5C31\u4EFB\u4F55\u5173\u4E8E\u6295\u8D44\u3001\u8D44\u91D1\u652F\u4ED8\u6216\u6536\u53D6\u3001\u6743\u5229\u4E49\u52A1\u8F6C\u8BA9\u3001\u7B7E\u7EA6\u3001\u534F\u8BAE\u6761\u6B3E\u66F4\u65B0\u7B49\u5185\u5BB9\u7684\u901A\u77E5\uFF0C\u4EFB\u4F55\u5173\u4E8E\u4EBA\u6C11\u6CD5\u9662\u8BC9\u8BBC\u6587\u4EF6\u3001\u6267\u884C\u6587\u4EF6\u7684\u9001\u8FBE\uFF0C\u4E59\u65B9\u53EF\u9009\u62E9\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u8FDB\u884C\u544A\u77E5\u6216\u9001\u8FBE:'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E00\uFF09\u901A\u8FC7\u4E59\u65B9\u516C\u544A\u3001\u7AD9\u5185\u4FE1\u7B49\u65B9\u5F0F\u516C\u793A\uFF0C\u81EA\u4E59\u65B9\u516C\u793A\u5185\u5BB9\u53D1\u5E03\u4E4B\u65E5\u8D77\u6EE11\u4E2A\u5DE5\u4F5C\u65E5\uFF0C\u89C6\u4E3A\u9001\u8FBE\u6210\u529F;'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E8C\uFF09\u901A\u8FC7\u7532\u65B9\u9884\u7559\u7684\u7535\u5B50\u90AE\u4EF6\u3001\u624B\u673A\u77ED\u4FE1\u65B9\u5F0F\u4F20\u9001\uFF0C\u81EA\u9001\u8FBE\u5185\u5BB9\u7531\u4E59\u65B9\u90AE\u7BB1\u7CFB\u7EDF\u6216\u77ED\u4FE1\u7CFB\u7EDF\u53D1\u51FA\u4E4B\u65F6\uFF0C\u89C6\u4E3A\u9001\u8FBE\u6210\u529F;'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\uFF08\u4E09\uFF09\u4EE5\u5E38\u89C4\u7684\u4FE1\u4EF6\u65B9\u5F0F\u90AE\u5BC4\uFF0C\u81EA\u4FE1\u4EF6\u90AE\u6233\u65E5\u671F\u8D77\u6EE1\u56DB\u4E2A\u5DE5\u4F5C\u65E5\u89C6\u4E3A\u9001\u8FBE\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u82E5\u56E0\u7532\u65B9\u5730\u5740\u3001\u540D\u79F0\u7B49\u8054\u7CFB\u65B9\u5F0F\u6709\u8BEF\u6216\u6709\u53D8\u66F4\u800C\u672A\u4E66\u9762\u901A\u77E5\u4E59\u65B9\uFF0C\u6216\u4FE1\u606F\u7CFB\u4F20\u8F93\u6545\u969C\u7B49\u539F\u56E0\u5BFC\u81F4\u7532\u65B9\u672A\u6536\u5230\u8BE5\u7B49\u901A\u77E5\u7684\uFF0C\u4E59\u65B9\u4E0D\u627F\u62C5\u8D23\u4EFB\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u4E03\u6761 \u7279\u522B\u63D0\u793A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u4F5C\u4E3A\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u8BD5\u70B9\u673A\u6784\uFF0C\u6839\u636E\u300A\u901A\u77E5\u300B\u7684\u8981\u6C42\uFF0C\u7279\u522B\u63D0\u793A\u7532\u65B9\u5982\u4E0B\u4FE1\u606F\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u4E59\u65B9\u4E1A\u52A1\u63A8\u5E7F\u3001\u5BA2\u6237\u62DB\u63FD\u3001\u4E86\u89E3\u5BA2\u6237\u7B49\u4E1A\u52A1\u73AF\u8282\u7684\u4EBA\u5458\u4E0D\u5F97\u5411\u5BA2\u6237\u63D0\u4F9B\u672A\u7ECF\u6295\u8D44\u51B3\u7B56\u59D4\u5458\u4F1A\u5BA1\u8BAE\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u6216\u64C5\u81EA\u53D8\u66F4\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u7532\u65B9\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\uFF1A\u672C\u534F\u8BAE\u4E0D\u514D\u9664\u4E59\u65B9\u8BDA\u5B9E\u5B88\u4FE1\u3001\u8C28\u614E\u52E4\u52C9\u4E49\u52A1\u7684\u6761\u6B3E\uFF0C\u7532\u65B9\u4EAB\u6709\u968F\u65F6\u7EC8\u6B62\u670D\u52A1\u7684\u6743\u5229\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7532\u65B9\u540C\u610F\u7B7E\u7F72\u672C\u534F\u8BAE\u89C6\u4E3A\u540C\u610F\u5E76\u7B7E\u5B57\u786E\u8BA4\u9644\u4EF6\u300A\u7279\u522B\u63D0\u793A\u786E\u8BA4\u300B\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7B2C\u5341\u516B\u6761 \u5176\u4ED6'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E59\u65B9\u5BF9\u672C\u534F\u8BAE\u62E5\u6709\u4FEE\u6539\u6743\uFF0C\u4FEE\u6539\u672C\u534F\u8BAE\u6216\u672C\u534F\u8BAE\u6761\u6B3E\u7684\u901A\u77E5\u5C06\u901A\u8FC7\u4E59\u65B9\u6216\u4E59\u65B9\u6307\u5B9A\u6210\u4EFD\u57FA\u91D1\u9500\u552E\u673A\u6784\u7684\u7F51\u7AD9\u548C\u79FB\u52A8\u7EC8\u7AEF\uFF08APP\uFF09\u6216\u5176\u4ED6\u65B9\u5F0F\u544A\u77E5\u7532\u65B9\u3002\u7532\u65B9\u7533\u8BF7\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u524D\u5747\u9700\u7B7E\u7F72\u672C\u534F\u8BAE\u5185\u5BB9\uFF0C\u82E5\u7532\u65B9\u4E0D\u8BA4\u53EF\u672C\u534F\u8BAE\u5185\u5BB9\u53CA\u5176\u540E\u7EED\u4FEE\u6539\u90E8\u5206\uFF0C\u5219\u7532\u65B9\u5E94\u5F53\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\uFF0C\u5426\u5219\u5373\u8868\u793A\u7532\u65B9\u8BA4\u53EF\u76F8\u5173\u534F\u8BAE\u5185\u5BB9\uFF0C\u5E76\u63A5\u53D7\u534F\u8BAE\u6761\u6B3E\u7EA6\u675F\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u9644\u4EF6\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u7279\u522B\u63D0\u793A\u786E\u8BA4'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u534E\u590F\u8D22\u5BCC\u201D\uFF09\u4F5C\u4E3A\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u7684\u8BD5\u70B9\u673A\u6784\uFF0C\u6839\u636E\u300A\u5173\u4E8E\u505A\u597D\u516C\u5F00\u52DF\u96C6\u8BC1\u5238\u6295\u8D44\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u8BD5\u70B9\u5DE5\u4F5C\u7684\u901A\u77E5\u300B\uFF08\u4E2D\u56FD\u8BC1\u5238\u76D1\u7763\u7BA1\u7406\u59D4\u5458\u4F1A\u673A\u6784\u90E8\u51FD[2019]2515\u53F7\uFF09\u7684\u6709\u5173\u8981\u6C42\uFF0C\u7279\u522B\u63D0\u793A\u6295\u8D44\u8005\u5982\u4E0B\u4FE1\u606F\uFF1A'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '1\u3001\u534E\u590F\u8D22\u5BCC\u4E1A\u52A1\u63A8\u5E7F\u3001\u5BA2\u6237\u62DB\u63FD\u3001\u4E86\u89E3\u5BA2\u6237\u7B49\u4E1A\u52A1\u73AF\u8282\u7684\u4EBA\u5458\u4E0D\u5F97\u5411\u5BA2\u6237\u63D0\u4F9B\u672A\u7ECF\u6295\u8D44\u51B3\u7B56\u59D4\u5458\u4F1A\u5BA1\u8BAE\u7684\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u6216\u64C5\u81EA\u53D8\u66F4\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '2\u3001\u6295\u8D44\u8005\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\uFF1A\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u4E0D\u514D\u9664\u534E\u590F\u8D22\u5BCC\u8BDA\u5B9E\u5B88\u4FE1\u3001\u8C28\u614E\u52E4\u52C9\u4E49\u52A1\u7684\u6761\u6B3E\uFF0C\u6295\u8D44\u8005\u4EAB\u6709\u968F\u65F6\u7EC8\u6B62\u670D\u52A1\u7684\u6743\u5229\u3002'
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u672C\u4EBA\u4F5C\u4E3A\u6295\u8D44\u8005\uFF0C\u786E\u8BA4\u5DF2\u77E5\u6089\u4E0A\u8FF0\u7279\u522B\u63D0\u793A\u7684\u6709\u5173\u5185\u5BB9\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'qy_FixedBottomNot' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this3.handleCancel();
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { color: "#5c6270", fontSize: '10px' } },
              '\u53D6\u6D88'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this3.signSuperAccAgreement();
              } },
            ' \u540C\u610F\u7B7E\u7EA6 '
          )
        )
      );
    }
  }]);

  return SuperFundSigning;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    webViewHtml: state.webViewHtml
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(SuperFundSigning));

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_productAction__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TargetFundsList = function (_Component) {
  _inherits(TargetFundsList, _Component);

  function TargetFundsList(props) {
    _classCallCheck(this, TargetFundsList);

    var _this = _possibleConstructorReturn(this, (TargetFundsList.__proto__ || Object.getPrototypeOf(TargetFundsList)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(TargetFundsList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "转入组合";
    }
  }, {
    key: 'changeIndex',
    value: function changeIndex(item, i) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_productAction__["_0" /* choseTargetIndex */])(i));
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dataSouse = this.props.location.state.dataSouse; //nav 传入

      var icon = [__webpack_require__(125), __webpack_require__(151)];
      var targetIndex = this.props.targetIndex;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u8F6C\u5165\u7EC4\u5408'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          dataSouse.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: i, className: 'currencyList', onClick: function onClick() {
                  return _this2.changeIndex(item, i);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { color: '#3a3f47', fontSize: 16 } },
                  item.superFundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { color: '#5c6470', fontSize: 14 } },
                  item.superFundCode
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListRightOK' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: targetIndex === i ? icon[1] : icon[0], className: 'img' })
              )
            );
          })
        )
      );
    }
  }]);

  return TargetFundsList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    targetIndex: state.targetIndex
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TargetFundsList));

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PaymentSuperFund_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_fundDetail_AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Modal_ModalPaySup__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var width = window.screen.width;

var TransferF = function (_Component) {
  _inherits(TransferF, _Component);

  function TransferF(props) {
    _classCallCheck(this, TransferF);

    var _this2 = _possibleConstructorReturn(this, (TransferF.__proto__ || Object.getPrototypeOf(TransferF)).call(this, props));

    _this2.returnLevelFun = function (val) {
      if (val == "2") {
        return "R2";
      }
      if (val == "3") {
        return "R3";
      }
      if (val == "4") {
        return "R4";
      }
      return "";
    };

    _this2.state = {
      pwdFlag: false,
      transferVal: '',
      transferFlag: false,
      text: '',
      isShowModal: false,
      data: [],
      isShowModal2: false,
      hideContent: false,
      sevenDayFlag: false,
      supRiskVal: ""

    };
    _this2.userMsg = { nickName: null, mobileNo: null, name: null };
    return _this2;
  }

  _createClass(TransferF, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var dispatch = this.props.dispatch;

      this.getUserMsg();
      // if (this.props.location.state.type===1) {
      //   document.title = "调整组合"
      //   dispatch(getAdjustDetail({superFundCode:this.props.location.state.superFundCode},(result)=>this.transferFlag(result)));
      // }else{
      //   document.title = "季度调仓"
      //   dispatch(getSeasonDetail({superFundCode:this.props.location.state.superFundCode}));
      // }
      var _props$location$state = this.props.location.state,
          superFundCode = _props$location$state.superFundCode,
          amount = _props$location$state.amount,
          targetFundList = _props$location$state.targetFundList;

      console.log(superFundCode, amount, targetFundList);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_90" /* getredeemToSuperFundPreview */])({
        superFundCode: superFundCode,
        amount: amount,
        targetSuperFundCode: targetFundList[this.props.targetIndex].superFundCode
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var superFundCode = this.props.location.state.superFundCode;

      this.hasInvested();
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_portfolioAction__["c" /* getStrategiesDetailsHaveCast */])({
        superFundCode: superFundCode
      }, function () {}));
    }
  }, {
    key: 'hasInvested',
    value: function hasInvested() {
      var _this3 = this;

      console.log(111);
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_91" /* isInvestmentFlag */])({ superFundCode: this.props.location.state.fundCode }, function (result, riskLevel) {
        if (!result) {
          var sess = sessionStorage.getItem("modalShowByTip");
          if (sess) {
            var arr = sess.split(",");
            if (arr.indexOf("zh_zt") < 0) {
              _this3.setState({
                isShowModal: true,
                hideContent: true,
                supRiskVal: _this3.returnLevelFun(riskLevel)
              });
            }
          } else {
            _this3.setState({
              isShowModal: true,
              hideContent: true,
              supRiskVal: _this3.returnLevelFun(riskLevel)
            });
          }
        }
      }));
    }
  }, {
    key: 'getUserMsg',
    value: function getUserMsg() {
      this.userMsg = JSON.parse(localStorage.currentUserInfo).userMsg;
      console.log(this.userMsg);
    }
  }, {
    key: 'transferFlag',
    value: function transferFlag(result) {
      this.setState({
        transferVal: result.code,
        transferFlag: true
      });
    }
  }, {
    key: 'succallback',
    value: function succallback() {
      // alert()
    }
  }, {
    key: 'errcallback',
    value: function errcallback(msg) {
      // alert(msg)
    }
  }, {
    key: 'showKeyboard',
    value: function showKeyboard() {
      var _this4 = this;

      var _props = this.props,
          dispatch = _props.dispatch,
          strategiesDetails = _props.strategiesDetails;
      var _props$location$state2 = this.props.location.state,
          superFundCode = _props$location$state2.superFundCode,
          amount = _props$location$state2.amount,
          targetFundList = _props$location$state2.targetFundList;

      var data = { amount: amount, targetSuperFundCode: targetFundList[this.props.targetIndex].superFundCode, superFundCode: superFundCode
        //判断七日惩罚性赎回
      };var params = {
        fundCode: superFundCode,
        businessType: 'T036',
        trustChannelId: targetFundList[this.props.targetIndex].trustChannelId
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["F" /* superFundPunishmentIn7Day */])(params, function (result) {
        console.log(result);
        if (result.content) {
          _this4.setState({
            sevenDayFlag: true
          });
        } else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_92" /* getvalidateRedeemToSuperFund */])(data, function (res) {
            if (_this4.state.transferVal == '') {
              //组合成分基金中包含华夏基金产品，需弹窗提示
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["o" /* getHistoryAdjust */])({ superFundCode: targetFundList[_this4.props.targetIndex].superFundCode }, function (result) {
                var data = result[result.length - 1].itemAdjustList;
                var fundsArr = [];
                console.log(data);
                for (var i = 0; i < data.length; i++) {
                  if (data[i].fundName.indexOf('华夏') != -1) {
                    fundsArr.push(data[i].fundName);
                  }
                }
                if (fundsArr.length == 0) {
                  console.log(1);
                  _this4.setState({
                    pwdFlag: true
                  });
                } else {
                  console.log(2);
                  _this4.setState({
                    data: fundsArr.join('、'),
                    isShowModal2: true
                  });
                }
              }));
              // this.setState({
              //   pwdFlag:true
              // })
            } else {
              __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].info(_this4.state.transferVal, 2);
            }
          }));
        }
      }));
    }
    //七日赎回确认

  }, {
    key: 'onNext',
    value: function onNext() {
      var _this5 = this;

      var dispatch = this.props.dispatch;
      var _props$location$state3 = this.props.location.state,
          superFundCode = _props$location$state3.superFundCode,
          amount = _props$location$state3.amount,
          targetFundList = _props$location$state3.targetFundList;

      var data = { amount: amount, targetSuperFundCode: targetFundList[this.props.targetIndex].superFundCode, superFundCode: superFundCode };
      this.setState({
        sevenDayFlag: false
      }, function () {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_92" /* getvalidateRedeemToSuperFund */])(data, function (res) {
          if (_this5.state.transferVal == '') {
            //组合成分基金中包含华夏基金产品，需弹窗提示
            dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["o" /* getHistoryAdjust */])({ superFundCode: targetFundList[_this5.props.targetIndex].superFundCode }, function (result) {
              var data = result[result.length - 1].itemAdjustList;
              var fundsArr = [];
              console.log(data);
              for (var i = 0; i < data.length; i++) {
                if (data[i].fundName.indexOf('华夏') != -1) {
                  fundsArr.push(data[i].fundName);
                }
              }
              if (fundsArr.length == 0) {
                console.log(1);
                _this5.setState({
                  pwdFlag: true
                });
              } else {
                console.log(2);
                _this5.setState({
                  data: fundsArr.join('、'),
                  isShowModal2: true
                });
              }
            }));
            // this.setState({
            //   pwdFlag:true
            // })
          } else {
            __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].info(_this5.state.transferVal, 2);
          }
        }));
      });
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        text: val
      });
    }
  }, {
    key: 'transfer',
    value: function transfer(type) {
      var _this = this;
      var pushResult = function pushResult(i, result) {
        if (i == 1) {
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '调仓申请结果',
              content: '您的组合转换已被受理！',
              dataSouse: [['申请编号', result.content.tradeRequestIds], ['下单时间', __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(result.content.businessTime, true)], ['所属交易日', __WEBPACK_IMPORTED_MODULE_4__util___default.a.returnDate(result.content.requestWorkday)]],
              souseVal: ['返回华夏智投']
            }
          });
        } else if (i == 3) {
          __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '调仓申请结果',
              content: '很抱歉，您的组合转换申请失败！',
              content2: result,
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        }
      };
      var _props$location$state4 = this.props.location.state,
          superFundCode = _props$location$state4.superFundCode,
          amount = _props$location$state4.amount,
          targetFundList = _props$location$state4.targetFundList;

      var data = {
        amount: amount,
        targetSuperFundCode: targetFundList[this.props.targetIndex].superFundCode,
        flag: 1, superFundCode: superFundCode, password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(this.state.text)
        // this.props.dispatch(getUpdateSeason(date,pushResult))
      };this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["_93" /* getredeemToSuperFund */])(data, pushResult));
    }
  }, {
    key: 'btnCallBack1',
    value: function btnCallBack1() {}
  }, {
    key: 'handleOk',
    value: function handleOk() {
      this.setState({
        isShowModal: false,
        hideContent: false
      });
      var sess = sessionStorage.getItem("modalShowByTip");
      if (sess) {
        var arr = sess.split(",");
        if (arr.indexOf("zh_zt") < 0) {
          arr.push("zh_zt");
          sessionStorage.setItem("modalShowByTip", arr.join());
        }
      } else {
        sessionStorage.setItem("modalShowByTip", "zh_zt");
      }
    }
  }, {
    key: 'onOk',
    value: function onOk() {
      this.setState({
        isShowModal2: false,
        pwdFlag: true
      });
    }
  }, {
    key: 'chooseIndex',
    value: function chooseIndex() {
      var targetFundList = this.props.location.state.targetFundList;

      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
        pathname: "/TargetFundsList",
        query: {
          dataSouse: targetFundList
        },
        state: {
          dataSouse: targetFundList

        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      console.log(this.props.location.state);
      var _props$location$state5 = this.props.location.state,
          type = _props$location$state5.type,
          superFundCode = _props$location$state5.superFundCode,
          isZJ = _props$location$state5.isZJ;
      var _props2 = this.props,
          inSeasonDetail = _props2.inSeasonDetail,
          redeemToSuperFundPreview = _props2.redeemToSuperFundPreview;

      console.log(inSeasonDetail.previewItemFundsChart, '------', redeemToSuperFundPreview);
      var pieImg = "";
      var name = '';
      var _img = __WEBPACK_IMPORTED_MODULE_4__util___default.a.superFundTextArr(superFundCode, "TransferF")[1];
      pieImg = __webpack_require__(780)("./" + _img);
      name = __WEBPACK_IMPORTED_MODULE_4__util___default.a.superFundTextArr(superFundCode, "TransferF")[0];
      var targetFundList = this.props.location.state.targetFundList;
      // console.log(targetFundList);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: this.state.hideContent ? "none" : "block" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__NavigatorMain__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'header' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
                "转换详情"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlex: 1, overflow: "auto" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'content', style: { paddingBottom: '50px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'listStyle', onClick: function onClick() {
                    return _this6.chooseIndex();
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { height: 44 }, className: 'jus_center' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 13, color: "#5b6370" } },
                    '\u8F6C\u5165\u7EC4\u5408'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { height: 44, flexDirection: "row", alignItems: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    targetFundList[this.props.targetIndex].superFundName
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(736), style: { width: 30, height: 44 } })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", marginTop: '0.12rem', padding: '0 13px', height: '40px', WebkitAlignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: '12px', color: "#000", WebkitFlex: 1 } },
                  '最新组合配置'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12' },
                  redeemToSuperFundPreview.superFund.nextAdjustDate ? redeemToSuperFundPreview.superFund.nextAdjustDate.substring(0, 10) + '更新' : '--更新'
                )
              ),
              redeemToSuperFundPreview.previewItemFunds.length == 0 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { background: '#fff', position: 'relative', display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pieImg, style: { position: 'absolute', left: width * 0.3 - 32, width: '64px', height: '64px' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransferPie, { inSeasonDetail: redeemToSuperFundPreview })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { padding: '13px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: {} },
                  '\u8C03\u4ED3\u660E\u7EC6'
                )
              ),
              redeemToSuperFundPreview.previewItemFunds.map(function (item, i) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: 'list' + i, style: { display: "-webkit-flex", background: '#fff', height: '0.9rem', padding: '0 13px', borderBottom: '0.005rem solid rgb(224,227,279)' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'gary12', style: { WebkitFlex: 1, lineHeight: '0.9rem' } },
                    item.fundName
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { lineHeight: '0.9rem' } },
                    __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.holdRate * 100) + '%→' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.targetRegularRate * 100) + '%'
                  )
                );
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingTop: 6 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { height: '0.9rem', marginLeft: '13px' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    '\u9884\u4F30\u6210\u672C'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", background: '#fff', height: '0.9rem', padding: '0 13px', borderBottom: '0.005rem solid rgb(224,227,279)' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12', style: { fontSize: '12px', WebkitFlex: 1, lineHeight: '0.9rem' } },
                  '\u9884\u8BA1\u53D1\u751F\u8D39\u7528'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { lineHeight: '0.9rem' } },
                  redeemToSuperFundPreview.fee != null ? __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(redeemToSuperFundPreview.fee) + "元" : "--"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", background: '#fff', height: '0.9rem', padding: '0 13px' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12', style: { fontSize: '12px', WebkitFlex: 1, lineHeight: '0.9rem' } },
                  '\u9884\u8BA1\u5B8C\u6210\u65F6\u95F4'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { lineHeight: '0.9rem' } },
                  __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(redeemToSuperFundPreview.needDays) + '日'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", marginTop: '0.4rem', background: '#fff', padding: '0 13px', WebkitFlexDirection: "column", paddingBottom: 10 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12', style: { marginTop: 10 } },
                  '\u6E29\u99A8\u63D0\u793A\uFF1A'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12', style: { marginTop: 5, fontWeight: "bold" } },
                  '1\u3001\u672C\u4E1A\u52A1\u6682\u4E0D\u652F\u6301\u64A4\u5355\u3002'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { className: 'gary12', style: { marginTop: 5 } },
                  '2\u3001\u9884\u8BA1\u6210\u672C\u4EC5\u4F9B\u53C2\u8003\uFF0C\u8BF7\u4EE5\u5B9E\u9645\u53D1\u751F\u8D39\u7528\u4E3A\u51C6\u3002'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'fixed', bottom: 0, width: '100%', borderTop: '1px solid rgb(224,227,229)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { color: '#5b6370', display: "-webkit-flex", WebkitAlignItems: 'center', overflow: 'hidden', border: '1px solid rgb(224,227,279)' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { onClick: function onClick() {
                      return _this6.showKeyboard(type);
                    }, style: { color: '#fff', backgroundColor: '#fa063a', textAlign: 'center', height: '40px', lineHeight: '40px', WebkitFlex: 3 } },
                  '\u786E\u8BA4\u8F6C\u6362'
                )
              )
            ),
            this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'fixed', top: 0, width: '100%', height: '100%', background: 'rgba(52,52,52,0.4)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { position: 'fixed', bottom: 0, width: '100%', height: '70%', background: '#fff' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { position: 'relative', height: '0.9rem', lineHeight: '0.9rem', textAlign: 'center', borderBottom: '0.005rem solid rgb(224,227,279)' } },
                  '\u4EA4\u6613\u5BC6\u7801',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), style: { position: 'absolute', left: 0, width: '0.88rem', height: '0.88rem' }, onClick: function onClick() {
                      _this6.setState({ pwdFlag: false });
                    } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { position: 'absolute', top: 0, right: 0, width: '0.9rem' }, onClick: function onClick() {
                        _this6.transfer(type);
                      } },
                    ' \u786E\u8BA4'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { height: '0.9rem', padding: '13px' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                      return _this6.onChangePwd(e.target.value);
                    }, autofocus: 'autofocus', style: { height: '0.9rem', width: '100%', fontSize: '0.3rem', border: '1px solid #afafaf', borderRadius: '0.1rem' }, type: 'password', placeholder: '' })
                )
              )
            ) : null,
            this.state.isShowModal2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Modal_ModalPaySup__["a" /* default */], { title: '\u5229\u76CA\u5173\u8054\u65B9\u51B2\u7A81\u63D0\u793A', onOK: function onOK() {
                _this6.onOk();
              }, rightButtonTitle: '\u6211\u5DF2\u77E5\u6653', fundName: targetFundList[this.props.targetIndex].superFundName, data: this.state.data }) : null
          )
        ),
        this.state.isShowModal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_fundDetail_AlerModle__["f" /* ModalTips */], { title: '\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u4E1A\u52A1\u6295\u8D44\u8005\u98CE\u9669\u63ED\u793A\u4E66', buttonText: '\u6211\u5DF2\u77E5\u6653\u98CE\u9669\uFF0C\u786E\u8BA4\u8D2D\u4E70', handleOk: function handleOk() {
            _this6.handleOk();
          }, verifiedUserInfo: this.props.verifiedUserInfo.content }) : null,
        this.state.sevenDayFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_fundDetail_AlerModle__["a" /* AlerModleCommon */], {
          btnTxt1: '\u786E\u8BA4',
          btnTxt2: '\u53D6\u6D88',
          content: "自交易日2018年3月30日起，若投资者赎回除货币及交易型开放式指数基金以外的开放式基金时持续持有期少于7日（自然日），将被收取不低于1.5%的赎回费。具体赎回费率请参见产品说明。",
          title: '\u7279\u522B\u63D0\u793A',
          handleClick1: function handleClick1() {
            _this6.onNext();
          },
          handleClick2: function handleClick2() {
            _this6.setState({ sevenDayFlag: false });
          }
        }) : null
      );
    }
  }]);

  return TransferF;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function compare(prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 > val2) {
      return -1;
    } else if (val1 < val2) {
      return 1;
    } else {
      return 0;
    }
  };
}

var TransferPie = function (_Component2) {
  _inherits(TransferPie, _Component2);

  function TransferPie() {
    _classCallCheck(this, TransferPie);

    return _possibleConstructorReturn(this, (TransferPie.__proto__ || Object.getPrototypeOf(TransferPie)).apply(this, arguments));
  }

  _createClass(TransferPie, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var inSeasonDetail = this.props.inSeasonDetail;

      var dataSouse = [];
      var dataSouseName = [];
      inSeasonDetail.previewItemFundsChart.sort(compare("srcRegularRate"));
      for (var i = 0; i < inSeasonDetail.previewItemFundsChart.length; i++) {
        var item = inSeasonDetail.previewItemFundsChart[i];

        var name = item.styleTypeName + __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.srcRegularRate * 100) + '%';
        dataSouse.push({ value: __WEBPACK_IMPORTED_MODULE_4__util___default.a.newToFixed(item.srcRegularRate * 100), name: name });
        dataSouseName.push(name);
      }
      var corArr = ['#e85040', '#ff7242', '#28b7f6', '#7290fd', '#9bcd65', '#ab47bc'];
      if (window.isLess47) {
        var myChart = __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts___default.a.init(document.getElementById('TransferPie'));
      } else {
        var myChart = __WEBPACK_IMPORTED_MODULE_7_echarts_lib_echarts___default.a.init(document.getElementById('TransferPie'), null, { renderer: 'svg' });
      }
      // 绘制图表
      myChart.setOption(SuperPieOption(dataSouse, dataSouseName));
    }
  }, {
    key: 'render',
    value: function render() {

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'TransferPie', style: { width: "100%", height: 300 } });
    }
  }]);

  return TransferPie;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/*饼图Option*/


function SuperPieOption(data, dataName) {
  var colorArr = [];
  if (dataName) {
    dataName.map(function (item, key) {
      if (item.indexOf("跨境权益") != -1) {
        colorArr.push("#4729c5");
      } else if (item.indexOf("国内权益") != -1) {
        colorArr.push("#e22424");
      } else if (item.indexOf("跨境债券") != -1) {
        colorArr.push("#f25a0f");
      } else if (item.indexOf("另类") != -1) {
        colorArr.push("#f0d331");
      } else if (item.indexOf("货币") != -1) {
        colorArr.push("#23c7e2");
      } else if (item.indexOf("国内债券") != -1) {
        colorArr.push("#034ab2");
      }
    });
  }
  var hg = 60;
  if (dataName.length <= 2) {
    hg = 20;
  } else if (dataName.length <= 4) {
    hg = 60;
  } else if (dataName.length <= 6) {
    hg = 80;
  } else if (dataName.length <= 8) {
    hg = 100;
  }

  var SuperPieOption = {
    animation: window.isLess47,
    calculable: true,
    legend: {
      y: 'center',
      x: 'left',
      left: width / 2 + 40,
      orient: 'vertical',
      data: dataName,
      //height:hg,
      itemWidth: 14,
      selectedMode: false,
      textStyle: { color: "auto" }
    },
    series: [{
      minAngle: 20,
      type: 'pie',
      hoverAnimation: false,
      radius: [44, 75],
      center: ['30%', '50%'],
      roseType: 'radius',
      data: data,
      label: {
        normal: {
          show: false
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      }

    }],
    color: colorArr
  };
  return SuperPieOption;
}
function mapStateToProps(state, ownProps) {
  return {
    inSeasonDetail: state.inSeasonDetail,
    redeemToSuperFundPreview: state.redeemToSuperFundPreview,
    targetIndex: state.targetIndex,
    strategiesDetails: state.strategiesDetails,
    verifiedUserInfo: state.verifiedUserInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TransferF));

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_video_react__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_video_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var width = window.screen.width;
var ua = navigator.userAgent.toLowerCase();

var Understand = function (_Component) {
  _inherits(Understand, _Component);

  function Understand(props) {
    _classCallCheck(this, Understand);

    return _possibleConstructorReturn(this, (Understand.__proto__ || Object.getPrototypeOf(Understand)).call(this, props));
  }

  _createClass(Understand, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'goBack',
    value: function goBack() {
      if (ua.indexOf("amcfmapp") > -1) {
        if (ua.indexOf("wkwebview") > -1) {
          if (window.webkit) {
            window.webkit.messageHandlers.amcfm_utils.postMessage({ "refreshHome": "intelInvest" });
            window.webkit.messageHandlers.amcfm_utils.postMessage({ "finish": "" });
          }
        } else {
          if (window.amcfm_utils) {
            window.amcfm_utils.refreshHome('intelInvest');
            window.amcfm_utils.finish();
          }
        }
      } else {
        // hashHistory.goBack();
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(1 - window.historyData.length);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header', style: { backgroundColor: 'rgba(211,211,211,0)' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u4E00\u5206\u949F\u4E86\u89E3\u534E\u590F\u67E5\u7406\u667A\u6295'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '13px' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content', style: { paddingBottom: 40 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'understand-bg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 63, height: 63 }, src: __webpack_require__(83) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: 10, width: width - 110, justifyContent: 'center', color: '#fff', fontSize: 14, lineHeight: '23px', padding: 7 } },
              '\u534E\u590F\u67E5\u7406\u667A\u6295\u7EC4\u5408\u662F\u5728\u534E\u590F\u57FA\u91D121\u5E74\u8D44\u4EA7\u7BA1\u7406\u7ECF\u9A8C\u7684\u57FA\u7840\u4E0A\uFF0C\u878D\u5165\u667A\u80FD\u7B97\u6CD5\u503E\u529B\u6253\u9020\u7684\u667A\u80FD\u6295\u8D44\u7EC4\u5408\u3002\u57FA\u4E8E\u5BA2\u6237\u4E0D\u540C\u9636\u6BB5\u7684\u8D22\u5BCC\u76EE\u6807\uFF0C\u63D0\u4F9B\u4E00\u952E\u5F0F\u3001\u667A\u80FD\u5316\u7684\u8D44\u4EA7\u914D\u7F6E\u6574\u4F53\u89E3\u51B3\u65B9\u6848\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { padding: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_video_react__["Player"],
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', { src: 'https://www.amcfortune.com/minipage/mdzt/mdzt.mp4' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: width }, src: __webpack_require__(743) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              return _this2.goBack();
            }, style: { height: 40, backgroundColor: '#fa063a', width: width, position: 'fixed', bottom: 0, textAlign: 'center', color: '#fff', lineHeight: '40px' } },
          '\u7ACB\u5373\u4F53\u9A8C'
        )
      );
    }
  }]);

  return Understand;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Understand));

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NHeader_js__ = __webpack_require__(157);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var BaoGao = function (_Component) {
  _inherits(BaoGao, _Component);

  function BaoGao(props) {
    _classCallCheck(this, BaoGao);

    var _this = _possibleConstructorReturn(this, (BaoGao.__proto__ || Object.getPrototypeOf(BaoGao)).call(this, props));

    _this.state = {
      dataVals: null,
      tipFlag: false,
      texts: [],
      arrObjList: ""
    };
    return _this;
  }

  _createClass(BaoGao, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var dispatch = this.props.location.state.dispatch ? this.props.location.state.dispatch : "";
      var superFundCode = this.props.location.state.superFundCode;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["_82" /* Wangqi */])({ superFundCode: superFundCode }, function (val) {
        console.log(val), _this2.setState({ arrObjList: val });
      }));
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var arrObjList = this.state.arrObjList;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NHeader_js__["a" /* default */], { title: '\u5F80\u671F\u62A5\u544A', isPaddingBottom: 0 })
        ),
        arrObjList[0] != undefined ? arrObjList.map(function (v, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: i, style: { backgroundColor: "#ffffff", borderBottom: "0.02rem solid gray" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingBottom: "0.3rem", paddingTop: "0.3rem", fontSize: "0.28rem", paddingLeft: "0.3rem", paddingRight: "0.3rem" } },
              arrObjList[i].fundName ? arrObjList[i].fundName : ""
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlexDirection: "row", display: "flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.24rem", color: "#666666" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1 } },
                '\u76EE\u6807\u5E74\u5316\u6536\u76CA\u7387'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: "2rem", display: "flex", justifyContent: "center" } },
                '\u8FD0\u4F5C\u5E74\u5316',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(431), style: { width: '0.3rem', marginLeft: "5px", marginTop: "-2px", height: "0.3rem" }, onClick: function onClick() {
                    _this3.setState({ tipFlag: true, texts: ["运运作说明运作说明运作说明作说明"] });
                  } })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: "flex", justifyContent: "flex-end" } },
                '\u5B9E\u9645\u8FD0\u884C\u5929\u6570'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlexDirection: "row", display: "flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", fontSize: "0.24rem", paddingBottom: "0.2rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, color: arrObjList[i].profitRate != null ? arrObjList[i].profitRate >= 0 ? "#F8515C" : "rgba(54, 169, 99, 1)" : "#333333", fontWeight: "bold" } },
                arrObjList[i].profitRate != null ? (arrObjList[i].profitRate * 100).toFixed(2) + "%" : "--"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: "2rem", textAlign: "center", paddingRight: "0.3rem", color: arrObjList[i].operation ? "#000000" : arrObjList[i].annualizedGains != null ? arrObjList[i].annualizedGains >= 0 ? "#F8515C" : "rgba(54, 169, 99, 1)" : "#333333", fontWeight: "bold", display: "flex", justifyContent: "center" } },
                arrObjList[i].operation ? "运作中" : arrObjList[i].annualizedGains != null ? (arrObjList[i].annualizedGains * 100).toFixed(2) + '%' : "--"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, color: "#000000", fontWeight: "bold", display: "flex", justifyContent: "flex-end" } },
                arrObjList[i].operation ? "运作中" : arrObjList[i].operationDay != null ? arrObjList[i].operationDay + '天' : "--"
              )
            )
          );
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem", color: "gray", fontSize: "0.24rem" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: "0.2rem", paddingBottom: "0.2rem", paddingLeft: "0.2rem", border: "0.02rem solid #D6DAE4", color: "#D6DAE4", backgroundColor: "#F6F7FA", flex: 1, borderRadius: "0.1rem" } },
            '\u6682\u65E0\u5F80\u671F\u62A5\u544A\u3002'
          )
        ),
        this.state.tipFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AlerModle__["b" /* AlerModleCommonn */], {
          btnTxt1: '\u77E5\u9053\u4E86',
          contentArr: this.state.texts,
          title: '\u67E5\u7406\u89E3\u5BC6',
          handleClick1: function handleClick1() {
            _this3.setState({ tipFlag: false });
          }
        }) : null
      );
    }
  }]);

  return BaoGao;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (BaoGao);

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PositionList__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NHeader__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__changefunddetail_css__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__changefunddetail_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__changefunddetail_css__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ChangeFundDetail = function (_React$Component) {
  _inherits(ChangeFundDetail, _React$Component);

  function ChangeFundDetail(props) {
    _classCallCheck(this, ChangeFundDetail);

    var _this = _possibleConstructorReturn(this, (ChangeFundDetail.__proto__ || Object.getPrototypeOf(ChangeFundDetail)).call(this, props));

    _this.renderItem = function (item) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "CFD_item_container", key: item.fundCode },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "CFD_item_fundname" },
            item.fundName
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "CFD_item_fundcode" },
            item.fundCode
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "CFD_item_change" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "span",
            null,
            __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(item.beforeRate)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { margin: "0 .1rem", width: ".24rem" }, src: __webpack_require__(672) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "span",
            { className: "CFD_item_aftervalue" },
            __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(item.afterRate)
          )
        )
      );
    };

    _this.header = function (v) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "CFD_Pie_header", style: { background: __WEBPACK_IMPORTED_MODULE_3__util___default.a.pieEchartsFundListColorMap.get(v.styleTypeName) } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "span",
          { className: "CFD_Pie_header_title" },
          v.styleTypeName
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "CFD_Pie_header_value" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "span",
            null,
            __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(v.beforeTotalRate)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { margin: "0 .1rem", width: ".24rem" }, src: __webpack_require__(672) }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "span",
            null,
            __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(v.afterTotalRate)
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  _createClass(ChangeFundDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      document.title = "调仓记录";
      var successCallback = function successCallback(data) {
        if (data && data.code === "0000") {
          _this2.setState(data.content);
        } else {
          console.log("后台返回数据有误！" + data.message);
        }
      };
      var errorCallback = function errorCallback(err) {};
      var param = { superFundCode: this.props.location.state.superFundCode, version: this.props.location.state.version };
      var getData = function () {
        var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  __WEBPACK_IMPORTED_MODULE_3__util___default.a.get(__WEBPACK_IMPORTED_MODULE_3__util___default.a.url + "/api/v1/superfund/product/adjustment/geSuperFundAdjustmentDetail", param, successCallback, errorCallback);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function getData() {
          return _ref.apply(this, arguments);
        };
      }();
      getData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          _state$adjustmentItem = _state.adjustmentItemList,
          adjustmentItemList = _state$adjustmentItem === undefined ? [] : _state$adjustmentItem,
          effectDateStr = _state.effectDateStr,
          adjustReason = _state.adjustReason;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "CFD_container", style: { minHeight: window.winHeight } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NHeader__["a" /* default */], { title: "\u8C03\u4ED3\u8BB0\u5F55", isPaddingBottom: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "CFD_content" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "CFD_reason" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "CFD_data" },
              effectDateStr
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "CFD_reason_content" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "CFD_reson_title" },
                "\u8C03\u4ED3\u539F\u56E0"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "CFD_reason_body" },
                adjustReason
              )
            )
          ),
          adjustmentItemList.map(function (v) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PositionList__["a" /* default */], { key: v.styleType, background: __WEBPACK_IMPORTED_MODULE_3__util___default.a.pieEchartsFundListBgColorMap.get(v.styleTypeName), header: _this3.header(v), renderItem: _this3.renderItem, dataSource: v.itemAdjustHistory, topDistance: ".1rem", bottomDistance: ".1rem" });
          })
        )
      );
    }
  }]);

  return ChangeFundDetail;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ChangeFundDetail);

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PositionList__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NHeader__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__changefundlist_css__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__changefundlist_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__changefundlist_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ChangeFundList = function (_React$Component) {
  _inherits(ChangeFundList, _React$Component);

  function ChangeFundList(props) {
    _classCallCheck(this, ChangeFundList);

    var _this = _possibleConstructorReturn(this, (ChangeFundList.__proto__ || Object.getPrototypeOf(ChangeFundList)).call(this, props));

    _this.toDetail = function (superFundCode, version) {
      return __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/ChangeFundDetail",
        query: {
          superFundCode: superFundCode,
          version: version
        },
        state: {
          superFundCode: superFundCode,
          version: version
        }
      });
    };

    _this.header = function (key) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "CF_list_header" },
        key + "年"
      );
    };

    _this.renderItem = function (v) {
      var arr = v.adjustDateStr.split("-");
      var adjustReason = v.adjustReason.length > 100 ? v.adjustReason.slice(0, 100) + "..." : v.adjustReason;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: v.version, className: "CF_list_item" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "CF_item_data" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "CF_item_day" },
            arr[2]
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "CF_item_month" },
            arr[1] + "月"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "CF_item_line" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "CF_item_content", style: {/*  paddingBottom: i != length - 1 && ".6rem"  */} },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "CF_item_con" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "CF_item_header", onClick: function onClick() {
                  _this.toDetail(v.superFundCode, v.version);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                { className: "CF_item_title" },
                "\u8C03\u4ED3\u7406\u7531"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "CF_item_detail_btn" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  null,
                  "\u8BE6\u60C5"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(272) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              adjustReason
            )
          )
        )
      );
    };

    _this.state = {};
    return _this;
  }

  _createClass(ChangeFundList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.title = "调仓记录";
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_portfolioAction__["e" /* getChangeFundList */])({
        superFundCode: this.props.location.state.superFundCode
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_portfolioAction__["f" /* changeFundListDel */])());
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props$dataSource = this.props.dataSource,
          dataSource = _props$dataSource === undefined ? {} : _props$dataSource;

      console.log('data', dataSource);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "CF_list_container", style: { minHeight: window.winHeight } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NHeader__["a" /* default */], { title: "\u8C03\u4ED3\u8BB0\u5F55", isPaddingBottom: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "CF_list_content", style: dataSource && !Object.keys(dataSource).length ? { display: 'flex', alignItems: 'center', justifyContent: 'center' } : null },
          dataSource && !Object.keys(dataSource).length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { style: { width: '4.14rem' }, src: __webpack_require__(2164) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { fontSize: '.28rem', lineHeight: '.4rem', color: '#333', marginTop: '.3rem' } },
              "\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E"
            )
          ) : Object.keys(dataSource).map(function (key) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__PositionList__["a" /* default */], { key: key, header: _this2.header(key), renderItem: _this2.renderItem, dataSource: dataSource[key] });
          })
        )
      );
    }
  }]);

  return ChangeFundList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

function mapStateToProps(state, ownProps) {
  return {
    dataSource: state.changeFundList.processedData
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(ChangeFundList));

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HOC_StateCache_js__ = __webpack_require__(156);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';
var width = window.screen.width;

/*理财规划*/

var ChooseGh = function (_Component) {
  _inherits(ChooseGh, _Component);

  function ChooseGh(props) {
    _classCallCheck(this, ChooseGh);

    var _this = _possibleConstructorReturn(this, (ChooseGh.__proto__ || Object.getPrototypeOf(ChooseGh)).call(this, props));

    _this.state = {
      loadingFlag: true
    };
    return _this;
  }

  _createClass(ChooseGh, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'handleCallback',
    value: function handleCallback() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      document.title = '理财规划';
      document.body.scrollTo(0, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'pushDetail',
    value: function pushDetail(num) {
      var pathname = "recoQuestionDoing";
      if (num == 1) {
        var dispatch = this.props.dispatch;

        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/educationCalculator",
          state: {
            school: "大学"
          }
        });
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_56" /* clearJyOne */])("大学"));
        return;
      } else if (num == 2) {
        var _dispatch = this.props.dispatch;

        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/pensionCalculator"
        });
        _dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_89" /* clearYlOne */])());
        return;
      }
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
        pathname: pathname
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              '\u7406\u8D22\u89C4\u5212 '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '13px' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content', id: 'ChooseGhIndex', style: { background: "#FFF", display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'scroll' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'ChooseGh_top_bg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: 'rgba(0,0,0,0)', color: '#FFF', fontSize: 14, lineHeight: "22px" } },
              '\u5F53\u4E0B\u6709\u94B1\u53EB\u6709\u8D22\uFF0C\u672A\u6765\u4E00\u76F4\u6709\u94B1\uFF0C\u624D\u53EB\u5BCC\u3002\u7406\u8D22\u89C4\u5212\u7684\u610F\u4E49\u5C31\u5728\u4E8E\u8FD0\u7528\u4F60\u73B0\u5728\u65E2\u6709\u7684\u8D44\u6E90\u548C\u53EF\u9884\u671F\u7684\u8D44\u6E90\u8FDB\u884C\u957F\u671F\u7684\uFF0C\u89C4\u5212\u6027\u7684\uFF0C\u6301\u7EED\u6027\u7684\u5E03\u5C40\uFF0C\u5B9E\u73B0\u7EC8\u751F\u7684\u8D22\u52A1\u5E73\u8861'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20, paddingBottom: 15, paddingLeft: 15 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: '#4A4A4A', fontSize: 14 } },
              '\u8BF7\u9009\u62E9\u60A8\u7684\u7406\u8D22\u89C4\u5212\u76EE\u6807\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this2.pushDetail(1);
              }, className: 'ChooseGh_show_bannerbg', style: { width: width - 30, height: (width - 30) * (290 / 690), marginLeft: 15 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: 'rgba(104,104,159,0.5)', height: 65, paddingTop: 10, paddingLeft: 12, paddingRight: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 16, color: "#FFF", marginBottom: 4 } },
                '\u6559\u80B2\u7406\u8D22\u89C4\u5212'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 13, color: "#FFF" } },
                '\u6839\u636E\u60A8\u5BF9\u5B50\u5973\u6559\u80B2\u50A8\u5907\u548C\u76EE\u6807\uFF0C\u4E13\u5C5E\u5B9A\u5236\u6559\u80B2\u6295\u8D44\u65B9\u6848\u3002'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this2.pushDetail(2);
              }, className: 'ChooseGh_show_bannerbg ChooseGh_show_bannerbg2', style: { width: width - 30, height: (width - 30) * (290 / 690), marginLeft: 15 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: 'rgba(104,104,159,0.5)', height: 65, paddingTop: 10, paddingLeft: 12, paddingRight: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 16, color: "#FFF", marginBottom: 4 } },
                '\u517B\u8001\u7406\u8D22\u89C4\u5212'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 13, color: "#FFF" } },
                '\u6839\u636E\u60A8\u7684\u517B\u8001\u50A8\u5907\u548C\u5B9E\u9645\u9700\u6C42\uFF0C\u4E13\u5C5E\u5B9A\u5236\u517B\u8001\u6295\u8D44\u65B9\u6848\u3002'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                _this2.pushDetail(3);
              }, className: 'ChooseGh_show_bannerbg ChooseGh_show_bannerbg3', style: { width: width - 30, height: (width - 30) * (290 / 690), marginLeft: 15 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { backgroundColor: 'rgba(104,104,159,0.5)', height: 65, paddingTop: 10, paddingLeft: 12, paddingRight: 10 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 16, color: "#FFF", marginBottom: 4 } },
                '\u8D44\u4EA7\u589E\u503C'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 13, color: "#FFF" } },
                '\u6839\u636E\u60A8\u7684\u6295\u8D44\u98CE\u9669\u504F\u597D\u7279\u5F81\uFF0C\u63A8\u8350\u9002\u5408\u60A8\u7684\u57FA\u91D1\u7EC4\u5408\u3002'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
        )
      );
    }
  }]);

  return ChooseGh;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__HOC_StateCache_js__["a" /* default */])(ChooseGh, 'ChooseGhIndex')));

function getFx(fundtype) {
  var touzFx = "";
  if (fundtype == "股票型" || fundtype == "指数型") {
    touzFx = "高";
  } else if (fundtype == "混合型" || fundtype == "债券型") {
    touzFx = "中";
  } else if (fundtype == "货币型" || fundtype == "理财型") {
    touzFx = "低";
  }
  return touzFx;
}

/*根据对象参数按从小到大排序*/
var compare = function compare(prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  };
};

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DownUpList1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NHeaderjiaoyijilu__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_Transferrecord_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_Transferrecord_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_Transferrecord_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//调仓记录











var Detailsofwarehouseadjustment = function (_Component) {
  _inherits(Detailsofwarehouseadjustment, _Component);

  function Detailsofwarehouseadjustment(props) {
    _classCallCheck(this, Detailsofwarehouseadjustment);

    var _this2 = _possibleConstructorReturn(this, (Detailsofwarehouseadjustment.__proto__ || Object.getPrototypeOf(Detailsofwarehouseadjustment)).call(this, props));

    _this2.state = {
      loadingFlag: false,
      xinxi: [],
      xinxi1: [],
      timeType: "请选择业务类型",
      timeAll: false,
      businessType: ""
    };
    return _this2;
  }

  _createClass(Detailsofwarehouseadjustment, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var _this = this;
      var data1 = {
        tradeRequestId: this.props.location.state.tradeRequestId
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_77" /* ztcgjiaoyijiluxiangqing */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(res) {
      console.log(res);
      var data = res.filter(function (i) {
        return i.businessType.substring(1, 3) !== "29";
      });
      this.setState({
        xinxi: data,
        xinxi1: data
      });
    }
    // 去除时间的时分秒

  }, {
    key: 'timeFormat',
    value: function timeFormat(date) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
      return newDate[0];
    }
  }, {
    key: 'selectRight',
    value: function selectRight() {
      this.setState({
        timeAll: !this.state.timeAll
      });
    }
  }, {
    key: 'jyTypeCallback',
    value: function jyTypeCallback(period, businessType) {
      console.log(period, businessType);
      var flag = void 0;
      this.setState({
        loadingFlag: flag,
        timeAll: false,
        handleFlag: true,
        timeType: period
      });
      if (period === "选择业务类型") {
        this.setState({
          xinxi: this.state.xinxi1
        });
      } else {
        var guolvshuju = this.state.xinxi1.filter(function (i) {
          return i.businessType.substring(1, 3) === businessType;
        });
        this.setState({
          xinxi: guolvshuju
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          timeAll = _state.timeAll,
          xinxi = _state.xinxi,
          timeType = _state.timeType;
      var _props$location$state = this.props.location.state,
          commission = _props$location$state.commission,
          confirmTimeStr = _props$location$state.confirmTimeStr,
          businessTimeStr = _props$location$state.businessTimeStr;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_containertiaocang' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wraptiaocang' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u4EA4\u6613\u8BE6\u60C5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_sharetiaocang' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { marginRight: 5 }, onClick: function onClick() {
                      _this3.selectRight();
                    } },
                  timeType
                ),
                timeAll ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { height: 16, width: 16 }, src: __webpack_require__(2170) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { height: 16, width: 16 }, src: __webpack_require__(2171) })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'jiaoyixiangqingtiaocang' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingtoptiaocangxiangqing' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop1' },
              '\u8C03\u4ED3\u4FE1\u606F'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u8C03\u4ED3\u65F6\u95F4'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                businessTimeStr ? businessTimeStr : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u624B\u7EED\u8D39'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(commission) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u786E\u8BA4\u5B8C\u6210\u65F6\u95F4'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                this.timeFormat(confirmTimeStr)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingbottom' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop1' },
              '\u4EA4\u6613\u8FDB\u5EA6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1, display: "flex", flexDirection: "column" } },
              xinxi.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index, className: 'jiaouyixiangqingbottommingxitiaocang' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi1' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxitiaocang1l' },
                      item.businessType.substring(1, 3) === "36" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1lz', style: { borderColor: "#5BA3F6", color: "#5BA3F6" } },
                        '\u8F6C\u6362'
                      ) : null,
                      item.businessType.substring(1, 3) === "22" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1lz', style: { borderColor: "#875426", color: "#875426" } },
                        '\u7533\u8D2D'
                      ) : null,
                      item.businessType.substring(1, 3) === "24" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1lz', style: { borderColor: "#FF9653", color: "#FF9653" } },
                        '\u8D4E\u56DE'
                      ) : null,
                      item.businessType.substring(1, 3) === "36" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1r' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { flexDirection: "row", alignItems: "center", display: "flex" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaouyixiangqingbottommingxitiaocang1ryuan', style: { backgroundColor: "#D8D8D8" } }),
                          item.fundName
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxitiaocang1rtu' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'jiaouyixiangqingbottommingxitiaocang1rtu', src: __webpack_require__(1904) })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { alignItems: "center", flexDirection: "row", display: "flex" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaouyixiangqingbottommingxitiaocang1ryuan', style: { backgroundColor: "#B69271" } }),
                          item.targetFundName
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1l1' },
                        item.fundName
                      )
                    ),
                    item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1right' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'text',
                        { style: { color: "#F8515C" } },
                        item.confirmStateName
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1right' },
                      item.confirmState === "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'text',
                        { style: { color: "#999999" } },
                        item.confirmStateName
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi1right' },
                          item.confirmState === "9" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            { style: { color: "#B69271" } },
                            '\u7B49\u5F85\u786E\u8BA4'
                          ) : null
                        )
                      )
                    )
                  ),
                  item.businessType.substring(1, 3) === "22" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi2' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2top' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top1' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999" } },
                            '\u7533\u8D2D\u91D1\u989D'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.applicationAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationAmount) : ""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2top' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top1' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999" } },
                            '\u6210\u4EA4\u4EFD\u989D'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.confirmState === "1" ? item.confirmVolume === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmVolume) : "--"
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end", alignContent: "space-around" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2topxiamingzi' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999", textAlign: "left" } },
                          '\u6210\u4EA4\u51C0\u503C'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999", textAlign: "left" } },
                          '\u624B\u7EED\u8D39'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2topxia' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                        )
                      )
                    )
                  ) : null,
                  item.businessType.substring(1, 3) === "24" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi2' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2top' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top1' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999" } },
                            '\u8D4E\u56DE\u4EFD\u989D'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationVolume) : ""
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2top' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top1' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999" } },
                            '\u5230\u8D26\u91D1\u989D'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.confirmState === "1" ? item.confirmAmount == null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmAmount) + "元" : "--"
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end", alignContent: "space-around" } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2topxiamingzi' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999", textAlign: "left" } },
                          '\u6210\u4EA4\u51C0\u503C'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999", textAlign: "left" } },
                          '\u624B\u7EED\u8D39'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi2topxia' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#333333" } },
                          item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                        )
                      )
                    )
                  ) : null,
                  item.businessType.substring(1, 3) === "36" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    item.confirmState === "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u6362\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationVolume) : ""
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u5165\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmAmount) + "元" : "" : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end", alignContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2topxiamingzi' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999", textAlign: "left" } },
                            '\u6210\u4EA4\u51C0\u503C'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999", textAlign: "left" } },
                            '\u624B\u7EED\u8D39'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2topxia' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2zhuanhuan' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u6362\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationVolume) : ""
                          )
                        )
                      )
                    )
                  ) : null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi4tiaocang' },
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'text',
                      { style: { color: "#333333" } },
                      item.trustChannelName
                    )
                  )
                );
              })
            )
          )
        ),
        timeAll ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownUpList1, { titleItem: '\u4EA4\u6613', chulihanshu: this.jyTypeCallback.bind(this), listContent: [{ title: '选择业务类型', callback: '' }, { title: '转换', callback: '36' }, { title: '申购', callback: '22' }, { title: '赎回', callback: '24' }] }) : null
      );
    }
  }]);

  return Detailsofwarehouseadjustment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    shareToInfo: state.shareToInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Detailsofwarehouseadjustment));
var DownUpList1 = function (_Component2) {
  _inherits(DownUpList1, _Component2);

  function DownUpList1(props) {
    _classCallCheck(this, DownUpList1);

    var _this4 = _possibleConstructorReturn(this, (DownUpList1.__proto__ || Object.getPrototypeOf(DownUpList1)).call(this, props));

    _this4.state = {};
    return _this4;
  }

  _createClass(DownUpList1, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var listContent = this.props.listContent;
      var listArray = [];

      var _loop = function _loop(i) {
        listArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: i, className: 'contentContainer', onClick: function onClick() {
              return _this5.props.chulihanshu(listContent[i].title, listContent[i].callback);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { color: "#333333" } },
            listContent[i].title
          )
        ));
      };

      for (var i = 0; i < listContent.length; i++) {
        _loop(i);
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'containertiaocang' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'scrollView' },
          listArray
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1 }, onClick: this.props.cancelCallback })
      );
    }
  }]);

  return DownUpList1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var styles = {
  container: {
    flex: 1
  },
  scrollView: {
    flex: 1,
    width: "100%"
  },
  title: {
    color: '#5b6370',
    fontSize: 13
    // fontFamily: 'Microsoft YaHei'
  },
  contentContainer: {
    justifyContent: 'center',
    display: "-webkit-flex",
    alignItems: 'center',
    width: "100%",
    height: 52,
    backgroundColor: '#ffffff'
  }
};

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NHeaderjiaoyijilu__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_Transferrecord_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__css_Transferrecord_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__css_Transferrecord_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//现金分红 红利再投  //因为列表里的数据完全满足了分红的需求并且从详情里面取会特别麻烦所以数据是从列表带的










var Dividendreinvestedincash = function (_Component) {
  _inherits(Dividendreinvestedincash, _Component);

  function Dividendreinvestedincash(props) {
    _classCallCheck(this, Dividendreinvestedincash);

    var _this = _possibleConstructorReturn(this, (Dividendreinvestedincash.__proto__ || Object.getPrototypeOf(Dividendreinvestedincash)).call(this, props));

    _this.getNum = function (num1, num2) {
      if (num1 === null && num2 === null) {
        return null;
      } else if (num1 === null) {
        return num2 + '份';
      } else if (num2 === null) {
        return num1 + '元';
      } else if (num1 == num2) {
        return num1 + '元';
      } else {
        return null;
      }
    };

    _this.state = {
      loadingFlag: false,
      xinxi: []
    };
    return _this;
  }

  _createClass(Dividendreinvestedincash, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'timeFormat',

    // 去除时间的时分秒
    value: function timeFormat(date) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
      return newDate[0];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$location$state = this.props.location.state,
          dividendMethod = _props$location$state.dividendMethod,
          confirmVolume = _props$location$state.confirmVolume,
          confirmAmount = _props$location$state.confirmAmount,
          trustChannelName = _props$location$state.trustChannelName,
          fundName = _props$location$state.fundName,
          superFundName = _props$location$state.superFundName,
          confirmTimeStr = _props$location$state.confirmTimeStr;

      console.log(confirmVolume);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u4EA4\u6613\u8BE6\u60C5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'NHeader_share' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'jiaoyixiangqing' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingtopfenhong' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u5206\u7EA2\u4EFD\u989D'
              ),
              dividendMethod === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  confirmVolume ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(confirmVolume) + "份" : "--"
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  confirmAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(confirmAmount) + "元" : "--"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u5206\u7EA2\u4EA7\u54C1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                fundName ? fundName : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u5206\u7EA2\u65F6\u95F4'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                confirmTimeStr ? confirmTimeStr : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u5206\u7EA2\u65B9\u5F0F'
              ),
              dividendMethod === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'text',
                { style: { color: "#333333" } },
                '\u7EA2\u5229\u518D\u6295'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                dividendMethod === "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  '\u73B0\u91D1\u5206\u7EA2'
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  "--"
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u6240\u5C5E\u6295\u987E\u4EA7\u54C1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'text',
                { style: { color: "#333333" } },
                superFundName ? superFundName : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u652F\u4ED8\u6E20\u9053'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'text',
                { style: { color: "#333333" } },
                trustChannelName ? trustChannelName : "--"
              )
            )
          )
        )
      );
    }
  }]);

  return Dividendreinvestedincash;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    shareToInfo: state.shareToInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Dividendreinvestedincash));

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FeiL = function (_Component) {
  _inherits(FeiL, _Component);

  function FeiL() {
    _classCallCheck(this, FeiL);

    return _possibleConstructorReturn(this, (FeiL.__proto__ || Object.getPrototypeOf(FeiL)).apply(this, arguments));
  }

  _createClass(FeiL, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'headerblacks' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold" } },
              '\u8D39\u7387\u8BE6\u60C5'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "44px" } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { paddingTop: "44px", paddingLeft: "0.2rem", paddingRight: "0.2rem" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: "0.6rem" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "flex", alignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: "16px", height: "16px", borderRadius: "16px", display: "flex", justifyContent: "center", alignItems: "center", color: "#fff", background: "#CE9968" } },
                '1'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: "0.28rem", color: "#333333", marginLeft: "5px" } },
                '\u7533\u8D2D\u8D39\u4E0E\u8D4E\u56DE\u8D39'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "flex", alignItems: "center", marginTop: "5px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.7rem" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: "0.24rem", color: "#999999" } },
                '\u672C\u7EC4\u5408\u4E0D\u91CD\u590D\u6536\u53D6\u7533\u8D2D\u8D39\u7528\u3001\u8D4E\u56DE\u8D39\u7528\u3002\u6210\u5206\u57FA\u91D1\u7533\u8D2D\u8D39\u75280\u81F31\u6298\uFF0C\u6210\u5206\u57FA\u91D1\u8D4E\u56DE\u8D39\u7528\u6309\u7167\u57FA\u91D1\u62DB\u52DF\u8BF4\u660E\u4E66\u6536\u53D6\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "flex", alignItems: "center", marginTop: "0.3rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: "16px", height: "16px", borderRadius: "16px", display: "flex", justifyContent: "center", alignItems: "center", color: "#fff", background: "#CE9968" } },
                '2'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: "0.28rem", color: "#333333", marginLeft: "5px" } },
                '\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "flex", alignItems: "center", marginTop: "5px" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.7rem" } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: "0.24rem", color: "#999999" } },
                '\u672C\u7EC4\u5408\u4EE5\u5BA2\u6237\u8D26\u6237\u8D44\u4EA7\u51C0\u503C',
                this.props.location.state.manageFeeRate != null ? this.props.location.state.manageFeeRate : "",
                '\uFF08\u5E74\u5316\uFF09\u8BA1\u63D0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u3002\u6BCF\u65E5\u8BA1\u63D0\uFF0C\u6708\u5EA6\u7ED3\u7B97\u3002'
              )
            )
          )
        )
      );
    }
  }]);

  return FeiL;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FeiL);

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_Feiyongxiangqing_css__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_Feiyongxiangqing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_Feiyongxiangqing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var objArr;

var Feiyongxiangqing = function (_Component) {
  _inherits(Feiyongxiangqing, _Component);

  function Feiyongxiangqing(props) {
    _classCallCheck(this, Feiyongxiangqing);

    var _this2 = _possibleConstructorReturn(this, (Feiyongxiangqing.__proto__ || Object.getPrototypeOf(Feiyongxiangqing)).call(this, props));

    _this2.getSource = function () {
      var dispatch = _this2.props.dispatch;

      var _this = _this2;
      var data = {
        pageIndex: _this2.state.pageIndex,
        pageSize: _this2.state.pageSize,
        superFundCode: _this2.props.location.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_78" /* ztcgfuwufeimingxi */])(data, _this2.callbackData.bind(_this2), _this));
    };

    var ds = new __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
        return r1 !== r2;
      } });
    _this2.state = {
      loadingFlag: false,
      dataSource: ds.cloneWithRows([]),
      pageIndex: 1,
      pageSize: 30,
      nomore: false,
      totalDataArr: [],
      businessType: "",
      fundCode: ""
    };
    return _this2;
  }

  _createClass(Feiyongxiangqing, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      objArr = [];
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var _this = this;
      var data1 = {
        pageIndex: this.state.pageIndex,
        pageSize: this.state.pageSize,
        superFundCode: this.props.location.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_78" /* ztcgfuwufeimingxi */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      console.log(data);
      var totalDataArr = this.state.totalDataArr.concat(data.records);
      if (data.records.length !== 0) {
        if (data.records.length < this.state.pageSize) {
          this.setState({
            nomore: 3,
            dataSource: this.state.dataSource.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            pageIndex: this.state.pageIndex + 1,
            loadingFlag: false,
            handleFlag: false,
            timeAll: false
          });
        } else {
          this.setState({
            nomore: 0,
            pageIndex: this.state.pageIndex + 1,
            dataSource: this.state.dataSource.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            loadingFlag: false,
            handleFlag: false,
            timeAll: false
          });
        }
      } else {
        this.setState({
          nomore: 3,
          loadingFlag: false,
          timeAll: false
        });
      }
    }
  }, {
    key: 'timeFormat',
    value: function timeFormat(date) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
      return newDate[0];
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.state.nomore === 3) {
        if (this.state.totalDataArr.length === 0) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: 0, textAlign: 'center' } },
            '\u6CA1\u6709\u66F4\u591A\u6570\u636E\u4E86'
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 0, textAlign: 'center' } });
        }
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var suoyoufuwufei = this.props.location.state.suoyoufuwufei;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'body2' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fuwufei_bg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_wrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_content' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'NHeader_goback', onClick: this.goBack },
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'NHeader_title' },
                  '\u6295\u987E\u670D\u52A1\u8D39'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'NHeader_share' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'feiyongCard' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'feiyongCardTop' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'feiyongCardTop1' },
                '\u6240\u6709\u670D\u52A1\u8D39(\u5143)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'feiyongCardTop2' },
                __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.thousandCount(suoyoufuwufei)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'feiyongCard2' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'feiYongCard2top' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'feiYongCard2topLeft' },
                '\u670D\u52A1\u8D39\u660E\u7EC6'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["ListView"], {
              ref: function ref(el) {
                return _this3.lv = el;
              },
              dataSource: this.state.dataSource,
              renderFooter: function renderFooter() {
                return _this3.renderFooter();
              },
              renderRow: function renderRow(item, index) {
                objArr = [{ createDate: "" }].concat(_this3.state.totalDataArr);
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index, className: 'feiyongCardbottom' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'feiyongCardbottom1' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'feiyongCardbottomtop' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'feiyongCardbottomtop1' },
                        item.currentSuperFundAssets ? item.currentSuperFundAssets : "--"
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'feiyongCardbottomtop2' },
                        '\u5F53\u65E5\u603B\u8D44\u4EA7\uFF08',
                        item.feeDateStr ? _this3.timeFormat(item.feeDateStr) : "--",
                        '\uFF09'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'feiyongCardbottom2' },
                      __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.thousandCount4(item.dailyFee)
                    )
                  )
                );
              },
              onEndReached: this.getSource,
              onEndReachedThreshold: 0.1
            })
          )
        )
      );
    }
  }]);

  return Feiyongxiangqing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Feiyongxiangqing));

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_fuwufei_css__ = __webpack_require__(2138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__css_fuwufei_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__css_fuwufei_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Fuwuqimingxi = function (_Component) {
  _inherits(Fuwuqimingxi, _Component);

  function Fuwuqimingxi(props) {
    _classCallCheck(this, Fuwuqimingxi);

    var _this2 = _possibleConstructorReturn(this, (Fuwuqimingxi.__proto__ || Object.getPrototypeOf(Fuwuqimingxi)).call(this, props));

    _this2.getNum = function (num1, num2) {
      if (num1 === null && num2 === null) {
        return null;
      } else if (num1 === null) {
        return num2 + '份';
      } else if (num2 === null) {
        return num1 + '元';
      } else if (num1 == num2) {
        return num1 + '元';
      } else {
        return null;
      }
    };

    _this2.state = {
      loadingFlag: false,
      xinxi: []
    };
    return _this2;
  }

  _createClass(Fuwuqimingxi, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var _this = this;
      var data1 = {
        superFundCode: this.props.location.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["_79" /* ztcgfuwufei */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      console.log(data);
      this.setState({
        xinxi: data
      });
    }
  }, {
    key: 'fuwumingxi',
    value: function fuwumingxi(res) {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
        pathname: '/Feiyongxiangqing',
        state: {
          suoyoufuwufei: res,
          superFundCode: this.props.location.state.superFundCode
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var xinxi = this.state.xinxi;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { id: 'body1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u6295\u987E\u670D\u52A1\u8D39'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'NHeader_share' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'fuwuconter' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fuwuconterTop' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fuwuconterTopTitle' },
              '\u5F53\u524D\u670D\u52A1\u6807\u51C6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fuwuconterbottom' },
              '\u6295\u987E\u670D\u52A1\u8D39\u7B49\u4E8E\u6BCF\u65E5\u670D\u52A1\u8D39\u7684\u52A0\u603B\uFF0C\u6BCF\u65E5\u670D\u52A1\u8D39=\u5F53\u65E5\u60A8\u6301\u6709\u7684\u603B\u8D44\u4EA7*\u6295\u987E\u670D\u52A1\u8D39\u7387/\u5F53\u5E74\u5929\u6570\uFF08\u5982\u9047\u670D\u52A1\u8D39\u7387\u6253\u6298\u6216\u8005\u51CF\u514D\u7B49\u6D3B\u52A8\uFF0C\u5219\u6309\u6D3B\u52A8\u540E\u8D39\u7387\u8BA1\u7B97\uFF09'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fuwufeiCard' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fuwufeiCardTop1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop1Left' },
                '\u8D39\u7528\u8BE6\u60C5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop1Right', onClick: function onClick() {
                    return _this3.fuwumingxi(xinxi.allManageFee);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'fuwufeiCardTop1Righttu', src: __webpack_require__(2169) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fuwufeiCardTop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop2Left' },
                '\u6240\u6709\u670D\u52A1\u8D39'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop2Right' },
                xinxi.allManageFee == null ? "" : __WEBPACK_IMPORTED_MODULE_5__util_js___default.a.thousandCount(xinxi.allManageFee) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fuwufeiCardTop3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop3Left' },
                '\u5F85\u6536\u670D\u52A1\u8D39'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop3Right' },
                xinxi.pendingFee == null ? "" : __WEBPACK_IMPORTED_MODULE_5__util_js___default.a.thousandCount(xinxi.pendingFee) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fuwufeiCardTop4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop4Left' },
                '\u5DF2\u4ED8\u670D\u52A1\u8D39'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'fuwufeiCardTop4Right' },
                xinxi.deductFee == null ? "" : __WEBPACK_IMPORTED_MODULE_5__util_js___default.a.thousandCount(xinxi.deductFee) + "元"
              )
            )
          )
        )
      );
    }
  }]);

  return Fuwuqimingxi;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Fuwuqimingxi));

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__(13);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';


/*止盈往期表现*/

var HistoryPerformance = function (_Component) {
  _inherits(HistoryPerformance, _Component);

  function HistoryPerformance(props) {
    _classCallCheck(this, HistoryPerformance);

    var _this = _possibleConstructorReturn(this, (HistoryPerformance.__proto__ || Object.getPrototypeOf(HistoryPerformance)).call(this, props));

    _this.state = {
      loadingFlag: true
    };
    return _this;
  }

  _createClass(HistoryPerformance, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'handleCallback',
    value: function handleCallback() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var superFundCode = this.props.location.state && this.props.location.state.superFundCode;
      console.log(superFundCode);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header blue-bg' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              ' \u5F80\u671F\u8868\u73B0 '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '13px' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'Performance_bg' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'eq_zyztDetail_title', style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", marginTop: '-2.9rem' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u7EC4\u5408\u540D\u79F0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u8FBE\u6807\u5929\u6570'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'zyztDetail_content' },
            this.props.location.state.reportList ? this.props.location.state.reportList.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index + '_item', className: 'Performance_item' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  item.status
                )
              );
            }) : null
          )
        )
      );
    }
  }]);

  return HistoryPerformance;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HistoryPerformance);

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NHeader_js__ = __webpack_require__(157);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var JaoYi = function (_Component) {
    _inherits(JaoYi, _Component);

    function JaoYi(props) {
        _classCallCheck(this, JaoYi);

        var _this = _possibleConstructorReturn(this, (JaoYi.__proto__ || Object.getPrototypeOf(JaoYi)).call(this, props));

        _this.state = {
            data: null,
            zhaunru: true,
            zhuanchu: false,
            dataVals: null,
            active: 1
        };
        return _this;
    }

    _createClass(JaoYi, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var dispatchs = this.props.location.state ? this.props.location.state.dispatch : "";
            var fundCodes = this.props.location.state ? this.props.location.state.fundCode : "";
            dispatchs && dispatchs(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction__["_81" /* getJiaoYis */])(fundCodes, function (result) {
                _this2.setState({
                    dataVals: result
                });
            }));
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
        }
    }, {
        key: 'choseTab',
        value: function choseTab(i) {
            if (i == "1") {
                this.setState({
                    zhaunru: true,
                    zhuanchu: false
                });
            } else {
                this.setState({
                    zhaunru: false,
                    zhuanchu: true
                });
            }
            this.setState({
                active: i
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _ref,
                _ref2;

            var _state = this.state,
                dataVals = _state.dataVals,
                zhaunru = _state.zhaunru;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NHeader_js__["a" /* default */], { title: '\u4EA4\u6613\u89C4\u5219', isPaddingBottom: 0 })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { lassName: 'content paddB40' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: "1", overflow: "auto" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'headerActive' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { paddingTop: "5px" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { onClick: function onClick() {
                                            return _this3.choseTab(1);
                                        }, style: { fontSize: "20px", fontWeight: "bold", color: this.state.active == 1 ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)' } },
                                    '\u8F6C\u5165\u89C4\u5219'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { onClick: function onClick() {
                                            return _this3.choseTab(2);
                                        }, style: { fontSize: "20px", fontWeight: "bold", color: this.state.active == 2 ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)' } },
                                    '\u8F6C\u51FA\u89C4\u5219'
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { display: "flex", paddingTop: "5px" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { flex: 1, textAlign: "center" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.state.active == 1 ? 'active' : null })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { flex: 1, textAlign: "center" } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: this.state.active == 2 ? 'active' : null })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { fontSize: "0.32rem", paddingTop: "0.1rem", paddingBottom: "0.1rem", backgroundColor: "#ffffff", paddingRight: "0.2rem", paddingLeft: "0.2rem" } },
                            this.state.zhaunru ? "转入时间" : "转出时间"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", color: "gray", fontSize: "0.2rem" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { textAlign: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: "0.24rem", paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                                    this.state.zhaunru ? "转入申请" : "转出申请"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(164), style: { width: '0.2rem', height: "0.2rem" } })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { textAlign: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: "0.24rem", paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                                    '\u5F00\u59CB\u786E\u8BA4\u4EA4\u6613'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(164), style: { width: '0.2rem', height: "0.2rem" } })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { textAlign: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: "0.24rem", paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                                    this.state.zhaunru ? "查看收益" : "充值到货币"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(164), style: { width: '0.2rem', height: "0.2rem" } })
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { display: "flex", paddingLeft: "0.8rem", paddingRight: "0.8rem", backgroundColor: "#ffffff" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem", marginLeft: zhaunru ? 0 : "-0.12rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem", marginRight: zhaunru ? 0 : "0.12rem" } })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", fontSize: "0.24rem", color: "#818597" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                dataVals ? dataVals.superFundConfirmAndIncomeDate.tradeDateString : ""
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.substring(5, dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.length) : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.substring(5, dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.length) : "",
                                '(',
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyConfirmWeek : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.redeemConfirmWeek : "",
                                ')'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.substring(5, dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.length) : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.substring(5, dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.length) : "",
                                '(',
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyIncomeWeek : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.fundArrivalWeek : "",
                                ')'
                            )
                        ),
                        zhaunru ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.5rem", color: "gray", fontSize: "0.2rem" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { textAlign: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: "0.24rem", paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                                    this.state.zhaunru ? "转入申请" : "转出申请"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(164), style: { width: '0.2rem', height: "0.2rem" } })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { textAlign: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: "0.24rem", paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                                    '\u5F00\u59CB\u786E\u8BA4\u4EA4\u6613'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(164), style: { width: '0.2rem', height: "0.2rem" } })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { textAlign: "center" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { fontSize: "0.24rem", paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                                    this.state.zhaunru ? "查看收益" : "资金到银行卡"
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(164), style: { width: '0.2rem', height: "0.2rem" } })
                            )
                        ),
                        zhaunru ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { display: "flex", paddingLeft: "0.8rem", paddingRight: "0.8rem", backgroundColor: "#ffffff" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem", marginLeft: zhaunru ? 0 : "-0.24rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem", marginRight: zhaunru ? 0 : "0.24rem" } })
                        ),
                        zhaunru ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", fontSize: "0.24rem", color: "#818597" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                dataVals ? dataVals.superFundConfirmAndIncomeDate.tradeDateString : ""
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.substring(5, dataVals.superFundConfirmAndIncomeDate.buyConfirmDate.length) : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.substring(5, dataVals.superFundConfirmAndIncomeDate.redeemConfirmDate.length) : "",
                                '(',
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyConfirmWeek : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.redeemConfirmWeek : "",
                                ')'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                null,
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.substring(5, dataVals.superFundConfirmAndIncomeDate.buyIncomeDate.length) : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.substring(5, dataVals.superFundConfirmAndIncomeDate.fundArrivalDate.length) : "",
                                '(',
                                zhaunru ? dataVals ? dataVals.superFundConfirmAndIncomeDate.buyIncomeWeek : "" : dataVals ? dataVals.superFundConfirmAndIncomeDate.fundArrivalWeek : "",
                                ')'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem", color: "gray", fontSize: "0.24rem" } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { paddingTop: "0.2rem", paddingBottom: "0.2rem", paddingLeft: "0.2rem", border: "0.02rem solid #D6DAE4", color: "#D6DAE4", backgroundColor: "#F6F7FA", flex: 1, borderRadius: "0.1rem" } },
                                '\u4EE5\u4E0A\u65F6\u95F4\u70B9\u4EC5\u4F9B\u53C2\u8003\uFF0C\u5177\u4F53\u4EE5\u5B9E\u9645\u786E\u8BA4\uFF0C\u5230\u8D26\u65F6\u95F4\u4E3A\u51C6'
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: (_ref = { fontSize: "0.2rem", paddingTop: "0.1rem", paddingBottom: "0.1rem", backgroundColor: "#ffffff", paddingRight: "0.2rem", paddingLeft: "0.2rem" }, _defineProperty(_ref, 'fontSize', "0.32rem"), _defineProperty(_ref, 'marginTop', "0.3rem"), _ref) },
                            this.state.zhaunru ? "转入费用" : "转出费用"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { paddingTop: "0.1rem", paddingBottom: "0.1rem", fontSize: "0.28rem", backgroundColor: "#ffffff", paddingLeft: "0.2rem", paddingRight: "0.2rem", lineHeight: "0.4rem" } },
                            this.state.zhaunru ? "本策略不重复收取申购费用。成分基金申购费率为0至1折。" : "据投顾账户持仓组合基金规定的赎回费收取。组合内成分基金若持有期小于7天，赎回将收取不低于1.5%的赎回费。"
                        ),
                        this.state.zhaunru ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: (_ref2 = { fontSize: "0.2rem", paddingTop: "0.1rem", paddingBottom: "0.1rem", backgroundColor: "#ffffff", paddingRight: "0.2rem", paddingLeft: "0.2rem" }, _defineProperty(_ref2, 'fontSize', "0.32rem"), _defineProperty(_ref2, 'marginTop', "0.2rem"), _ref2) },
                                '\u6295\u987E\u670D\u52A1\u8D39\u7387'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { style: { display: "flex", paddingRight: "0.2rem", paddingLeft: "0.2rem", backgroundColor: "#ffffff", fontSize: "0.28rem", paddingBottom: "0.2rem", paddingTop: "0.2rem" } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { style: { flex: 1 } },
                                    '\u6295\u987E\u670D\u52A1\u8D39\u7387'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    dataVals ? dataVals.superFundManageRate.manageFeeRate : ""
                                )
                            )
                        ) : null
                    )
                )
            );
        }
    }]);

    return JaoYi;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (JaoYi);

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_riskInPayAction_js__ = __webpack_require__(196);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ua = navigator.userAgent.toLowerCase();

var MakePlanDetail = function (_Component) {
  _inherits(MakePlanDetail, _Component);

  function MakePlanDetail(props) {
    _classCallCheck(this, MakePlanDetail);

    var _this = _possibleConstructorReturn(this, (MakePlanDetail.__proto__ || Object.getPrototypeOf(MakePlanDetail)).call(this, props));

    _this.chooseDataFun = function (arr) {
      var _count = false;
      if (arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
            _count = true;
            break;
          }
        }
      }
      return _count;
    };

    _this.chooseDataSecFun = function (arr) {
      if (arr && arr.length === 0 || !arr) {
        return true;
      } else {
        var _count = true;
        if (arr && arr.length > 0) {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].superFundProductViewList && arr[i].superFundProductViewList.length > 0) {
              _count = false;
              break;
            }
          }
        }
        return _count;
      }
    };

    _this.getQuestionFun = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_83" /* getEfficientQuestionnaire */])({}, function (res) {
        console.log(res);
        _this.setState({
          questionnaireId: res.content.questionnaireId
        });
        if (res.content.questionList && res.content.questionList.length > 0) {
          var dataSource = [].concat(res.content.questionList);
          for (var i = 0; i < dataSource.length; i++) {
            if (dataSource[i].order == "1") {
              _this.setState({
                ageContent: dataSource[i].content
              });
            }
            if (dataSource[i].order == "2") {
              var _arr = [];
              for (var s = 0; s < dataSource[i].optionList.length; s++) {
                if (dataSource[i].optionList[s].order > 0) {
                  _arr[Number(dataSource[i].optionList[s].order) - 1] = {
                    flag: false,
                    title: dataSource[i].optionList[s].content.split("：")[0] + "：",
                    content: dataSource[i].optionList[s].content.split("：")[1],
                    order: dataSource[i].optionList[s].order
                  };
                }
              }
              _this.setState({
                typeListContent: dataSource[i].content,
                typeListArr: _arr
              }, function () {
                _this.initYear();
              });
            }
            // if(dataSource[i].order == "3") {
            //   const _arr = [];
            //   for(let s = 0; s < dataSource[i].optionList.length; s++) {
            //     if(dataSource[i].optionList[s].order > 0) {
            //       _arr[Number(dataSource[i].optionList[s].order) - 1] = {
            //         content: dataSource[i].optionList[s].content,
            //         order: dataSource[i].optionList[s].order
            //       }
            //     }
            //   }
            //   this.setState({
            //     radioContent: dataSource[i].content,
            //     radioAnswer: _arr
            //   });
            // }
          }
        }
      }));
    };

    _this.initYear = function () {
      if (_this.props.location && _this.props.location.state && _this.props.location.state.certNo) {
        var _fullYear = new Date().getFullYear();
        var _certNo = _this.props.location.state.certNo;
        var _ageVal = _fullYear - _certNo.toString().substr(6, 4);
        if (_ageVal > 0) {
          _this.setState({
            certAge: _ageVal,
            ageVal: _ageVal
          });
        }
        _this.changePlan(_ageVal);
      }
    };

    _this.goBackFun = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.blurAgeFun = function (e) {
      var _val = e.target.value;
      _this.changePlan(_val);
      if (_val) {
        if (_this.state.certAge != _val && _this.state.certAge !== "") {
          _this.setState({
            showText: true
          });
        } else {
          _this.setState({
            showText: false
          });
        }
      } else {
        _this.changeChoose([false, false, false, false]);
        _this.setState({
          showText: false
        });
      }
    };

    _this.changeAge = function (e) {
      var _val = e.target.value;
      if (_val !== "") {
        var reg = new RegExp(/^\d{1,3}$/).test(_val);
        if (!reg) {
          // this.changeChoose([false, false, false, false]);
          var toast = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入有效年龄', 2);
          return;
        } else {
          if (_val.toString().substr(0, 1) === "0" || _val.toString().substr(0, 1) === 0) {
            // this.changeChoose([false, false, false, false]);
            var _toast = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请输入有效年龄', 2);
            return;
          } else {
            _this.setState({
              ageVal: _val
            });
            // this.changePlan(_val);
          }
        }
      } else {
        // this.changeChoose([false, false, false, false]);
        _this.setState({
          ageVal: _val
        });
      }
      _this.blurAgeFun(e);
    };

    _this.selectFunByType = function (index) {
      var _arr = [].concat(_this.state.typeListArr);
      _arr[index].flag = _arr[index].flag ? false : true;
      _this.setState({
        typeListArr: _arr
      });
    };

    _this.showFundFun = function () {
      sessionStorage.setItem('loadSourceByZt', "true");
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
      });
    };

    _this.changePlan = function (age) {
      if (age === "" || age === undefined || age === null) {
        _this.changeChoose([false, false, false, false]);
        _this.setState({
          textByAge: ""
        });
      } else {
        var _age = age;
        _age = Number(_age);
        var _fullYear = new Date().getFullYear();
        var outYear = _fullYear - _age;
        switch (true) {
          case _age < 20:
            _this.changeChoose([false, false, false, false]);
            _this.setState({
              textByAge: ""
            });
            break;
          case outYear >= 1990:
            _this.changeChoose([true, true, true, true]);
            _this.setState({
              textByAge: "您当前正处在人生的快速上升期，此阶段可重点从财富积累视角出发，拉长您的资金投资期限，建议积极参与权益类投资品种。"
            });
            break;
          case outYear >= 1980 && outYear < 1990:
            _this.changeChoose([true, true, true, true]);
            _this.setState({
              textByAge: "您当前正处在人生的黄金期，此阶段可重点从家庭整体场景需求的视角出发，开始为子女储备教育金，为自己及家人储备养老金，建议积极参与权益类投资品种。"
            });
            break;
          case outYear >= 1970 && outYear < 1980:
            _this.changeChoose([true, true, true, true]);
            _this.setState({
              textByAge: "您当前正处在人生的稳定期，此阶段可重点从家庭整体场景需求的视角出发，开始为子女储备教育金，为自己及家人储备养老金，建议均衡配置权益类和稳健类投资品种。"
            });
            break;
          case outYear >= 1960 && outYear < 1970:
            _this.changeChoose([true, true, true, false]);
            _this.setState({
              textByAge: "您当前即将步入或已经进入退休期，此阶段可重点从退休后的资金需求视角出发，为自己及家人储备充备的养老金，建议逐渐降低权益类投资品种的比例。"
            });
            break;
          case outYear < 1960:
            _this.changeChoose([true, true, false, false]);
            _this.setState({
              textByAge: "您当前已经进入退休养老阶段，此阶段可重点从退休后的生活开支需求视角出发，力求自己的养老金保值增值，建议积极参与稳健类投资品种。"
            });
            break;
        }
      }
    };

    _this.changeChoose = function (data) {
      var _arr = [].concat(_this.state.typeListArr);
      for (var i = 0; i < _arr.length; i++) {
        _arr[i].flag = data[i];
      }
      _this.setState({
        typeListArr: _arr
      });
    };

    _this.sucAnswer = function () {
      __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].loading();
      _this.setState({
        allStrategyList: [],
        partMateStrategyList: []
      });
      if (!_this.state.ageVal) {
        var toast = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('年龄不能为空', 2);
        return;
      }
      var answerSec = "";
      for (var i = 0; i < _this.state.typeListArr.length; i++) {
        if (_this.state.typeListArr[i].flag) {
          answerSec = answerSec + _this.state.typeListArr[i].order;
        }
      }
      if (!answerSec) {
        var _toast2 = __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('请至少选择一项', 2);
        return;
      }
      // const addAnswerList = [{
      //   questionNo: "1",
      //   answer: (new Date().getFullYear() - this.state.ageVal).toString()
      // }, {
      //   questionNo: "2",
      //   answer: answerSec
      // }, {
      //   questionNo: "3",
      //   answer: this.state.radioFlag
      // }];
      var addAnswerList = [{
        questionNo: "1",
        answer: (new Date().getFullYear() - _this.state.ageVal).toString()
      }, {
        questionNo: "2",
        answer: answerSec
      }];
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_84" /* addUserAnswerByZt */])({
        questionnaireId: _this.state.questionnaireId,
        addAnswerList: addAnswerList
      }, function (res) {
        console.log(res);
        if (res && res.content === true) {
          _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction_js__["_69" /* getRcommendStrategy */])({}, function (suc) {
            console.log(suc);
            if (suc && suc.content) {
              __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
              _this.setState({
                sceneVoList: suc.content.sceneVoList
              }, function () {
                if (suc.content.mateAll === true) {
                  if (_this.chooseDataSecFun(suc.content.allStrategyList)) {
                    _this.setState({
                      nothingFlag: true
                    });
                  } else {
                    //匹配直接跳转
                    _this.showAllFundList(false, suc.content.allStrategyList ? suc.content.allStrategyList : [], "全部");
                  }
                } else {
                  //不匹配 一个也没有
                  if (_this.chooseDataSecFun(suc.content.allStrategyList)) {
                    _this.setState({
                      nothingFlag: true
                    });
                  } else {
                    _this.setState({
                      riskModal: true,
                      allStrategyList: suc.content.allStrategyList ? suc.content.allStrategyList : [],
                      partMateStrategyList: suc.content.partMateStrategyList ? suc.content.partMateStrategyList : []
                    });
                  }
                }
              });
            } else {
              __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
            }
          }));
        } else {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
        }
      }));
    };

    _this.showRiskMakeFun = function () {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_riskInPayAction_js__["c" /* traceSave */])({ action: 'SF_SPECIAL_TIP', message: '用户查看部分智投产品时间: ' + new Date().toLocaleString() }));
      if (_this.chooseDataSecFun(_this.state.partMateStrategyList)) {
        _this.setState({
          riskModal: false,
          riskMakeFlag: true
        });
      } else {
        _this.showAllFundList(true, _this.state.partMateStrategyList, "部分");
      }
    };

    _this.showAllFundList = function (flag, data, name) {
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_riskInPayAction_js__["c" /* traceSave */])({ action: 'SF_SPECIAL_TIP', message: '用户查看全部智投产品时间: ' + new Date().toLocaleString() }));
      if (flag === true) {
        _this.setState({
          riskModal: false
        });
      }
      if (_this.chooseDataFun(data)) {
        var tabListArr = [];
        for (var i = 0; i < _this.state.sceneVoList.length; i++) {
          var _count = 0;
          var _countSec = 0;
          for (var s = 0; s < data.length; s++) {
            if (data[s].superFundProductViewList && data[s].superFundProductViewList.length > 0) {
              _countSec = _countSec - 0 + 1;
              if (_this.state.sceneVoList[i].sceneId != data[s].sceneId) {
                _count = _count - 0 + 1;
              }
            }
          }
          if (_count == _countSec && _count > 0) {
            tabListArr.push(_this.state.sceneVoList[i].sceneName);
          }
        }
        console.log(tabListArr);
        __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
          pathname: '/MakePlanResult',
          state: {
            fundListArr: data,
            tabListArr: tabListArr,
            lookFlag: name,
            rootPath: "MakePlanDetail"
          }
        });
      }
    };

    _this.resetData = function () {
      _this.setState({
        ageVal: "",
        // radioFlag: "1",
        certAge: "",
        riskModal: false,
        riskMakeFlag: false,
        nothingFlag: false,
        allStrategyList: [],
        partMateStrategyList: [],
        textByAge: ""
      });
      var _arr = [].concat(_this.state.typeListArr);
      for (var i = 0; i < _arr.length; i++) {
        _arr[i].flag = false;
      }
      _this.setState({
        typeListArr: _arr
      }, function () {
        _this.initYear();
      });
    };

    _this.showModalXiaoai = function () {
      _this.setState({
        modalXai: true
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
    };

    _this.closeModalXai = function () {
      _this.setState({
        modalXai: false
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", _this.touchMove, false);
    };

    _this.state = {
      ageVal: "",
      typeListArr: [],
      // radioFlag: "1",
      certAge: "",
      riskModal: false, //风险提示
      riskMakeFlag: false, // 重新规划
      nothingFlag: false, // 重新规划
      // radioContent: "",
      // radioAnswer: [],
      ageContent: "",
      typeListContent: "",
      questionnaireId: "",
      allStrategyList: [],
      partMateStrategyList: [],
      textByAge: "",
      modalXai: false,
      showText: false,
      sceneVoList: []
    };
    return _this;
  }

  _createClass(MakePlanDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getQuestionFun();
    }
    //获取题目

    //初始化年份

    // chooseThis = (val) => {
    //   this.setState({
    //     radioFlag: val
    //   });
    // }

    //根据年龄改变选项

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: "-webkit-flex", WebkitFlex: 1, backgroundColor: "#fff", WebkitFlexDirection: "column", WebkitAlignItems: "center", paddingBottom: 50 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { backgroundImage: 'url(' + __webpack_require__(1970) + ')', backgroundSize: "cover", width: window.winWidth, height: window.winWidth / (1125 / 1113), paddingRight: 20, paddingLeft: 20 } },
          ua.indexOf("amcfmapp") > -1 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBackFun, src: __webpack_require__(1972), style: { width: 24, height: 24 } })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 24, color: "#fff", fontWeight: 500 } },
              '\u534E\u590F\u67E5\u7406\u667A\u6295'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 16, color: "#fff", fontWeight: 500 } },
                '\u61C2\u6295\u8D44\xB7\u66F4\u61C2\u4F60'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.showModalXiaoai, src: __webpack_require__(1974), style: { width: 18, height: 18, marginLeft: 5 } })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { backgroundColor: "#fff", borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", paddingTop: 20, paddingBottom: 20, paddingLeft: 15, paddingRight: 15, width: window.winWidth - 40, marginTop: ua.indexOf("amcfmapp") > -1 ? -309 : -235 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 16, color: "#333", fontWeight: 500 } },
              this.state.ageContent
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 10, display: "-webkit-flex", WebkitFlexDirection: "row", WebkitAlignItems: "center", width: window.winWidth - 70, position: "relative" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autoComplete: 'off', style: { paddingLeft: 10, width: window.winWidth - 70, height: 40, backgroundColor: "#FAFAFA", borderRadius: 4, color: "#666", fontSize: 18, paddingRight: 30 }, onChange: function onChange(e) {
                _this2.changeAge(e);
              }, onBlur: function onBlur() {}, type: 'text', value: this.state.ageVal, placeholder: '请输入年龄' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 18, color: "#333", position: "absolute", right: 10 } },
              '\u5C81'
            )
          ),
          this.state.showText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 13, color: "#F92C3D", fontWeight: 500 } },
              '\u60A8\u586B\u5199\u7684\u5E74\u9F84\u4E0E\u60A8\u5F00\u6237\u586B\u5199\u7684\u4FE1\u606F\u4E0D\u7B26'
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 25 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 16, color: "#333", fontWeight: 500 } },
              this.state.typeListContent
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 12, lineHeight: "17px", color: "#666" } },
              this.state.textByAge
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { fontSize: 12, lineHeight: "17px", color: "#F92C3D" } },
              this.state.textByAge === "" ? null : "预测您有如下需求，您也可自行调整。"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.state.typeListArr.map(function (data, index) {
              if (data.flag) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this2.selectFunByType(index);
                    }, key: index, style: { position: "relative", borderRadius: 2, marginTop: index === 0 ? 10 : 8, width: window.winWidth - 70, display: "-webkit-flex", WebkitFlexDirection: "column", paddingLeft: 10, paddingRight: 10, backgroundColor: "#FFEEF0", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", paddingTop: 7, paddingBottom: 7 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 12, color: "#F92C3D", fontWeight: 500, whiteSpace: "pre" } },
                    data.title
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 11, color: "#F92C3D", lineHeight: "17px", marginTop: 2 } },
                    data.content
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2176), style: { width: 8, height: 8, position: "absolute", right: 0, top: 0 } })
                );
              } else {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this2.selectFunByType(index);
                    }, key: index, style: { position: "relative", borderRadius: 2, marginTop: index === 0 ? 10 : 8, width: window.winWidth - 70, display: "-webkit-flex", WebkitFlexDirection: "column", paddingLeft: 10, paddingRight: 10, backgroundColor: "#F5F5F5", borderStyle: "solid", borderWidth: 1, borderColor: "#F5F5F5", paddingTop: 7, paddingBottom: 7 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 12, color: "#666", fontWeight: 500, whiteSpace: "pre" } },
                    data.title
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 11, color: "#666", lineHeight: "17px", marginTop: 2 } },
                    data.content
                  )
                );
              }
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: window.winWidth - 70, display: "-webkit-flex", WebkitAlignItems: "center", WebkitJustifyContent: "center", marginTop: 30 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.sucAnswer, style: { width: 122, height: 32, backgroundColor: "#F92C3D", borderRadius: 4, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#fff" } },
                '\u4E3A\u6211\u89C4\u5212'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: this.showFundFun, style: { boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", width: window.winWidth - 40, height: 50, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#fff", WebkitFlexDirection: "row", borderRadius: 4, marginTop: 20 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { fontSize: 14, color: "#2C3245" } },
            '\u6211\u6709\u660E\u786E\u6295\u8D44\u76EE\u6807\uFF0C\u5E0C\u671B\u76F4\u63A5\u6311\u9009\u7EC4\u5408'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(777), style: { width: 16, height: 16, marginLeft: 5 } })
        ),
        this.state.riskModal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u4E3A\u60A8\u89C4\u5212\u7684\u65B9\u6848\u4E2D\u90E8\u5206\u4EA7\u54C1\u7684\u98CE\u9669\u7B49\u7EA7\u4E0E\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E0D\u7B26\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u5168\u90E8\u67E5\u770B'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.showRiskMakeFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u90E8\u5206\u67E5\u770B'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    _this2.showAllFundList(true, _this2.state.allStrategyList, "全部");
                  }, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u5168\u90E8\u67E5\u770B'
                )
              )
            )
          )
        ) : null,
        this.state.riskMakeFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5C0A\u656C\u7684\u7528\u6237\uFF0C\u60A8\u9009\u62E9\u4E86\u90E8\u5206\u67E5\u770B\uFF0C\u5DF2\u4E3A\u60A8\u5C4F\u853D\u6389\u98CE\u9669\u4E0D\u5339\u914D\u7684\u7EC4\u5408\u7B56\u7565\uFF0C\u5C4F\u853D\u540E\uFF0C\u6682\u65E0\u5339\u914D\u60A8\u98CE\u9669\u9700\u6C42\u7684\u6295\u987E\u7EC4\u5408\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.resetData, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u91CD\u65B0\u89C4\u5212'
                )
              )
            )
          )
        ) : null,
        this.state.nothingFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u98CE\u9669\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u5C0A\u656C\u7684\u7528\u6237\uFF0C\u57FA\u4E8E\u60A8\u7684\u9700\u6C42\uFF0C\u6682\u672A\u80FD\u4E3A\u60A8\u5339\u914D\u51FA\u6295\u987E\u7EC4\u5408\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.resetData, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u91CD\u65B0\u89C4\u5212'
                )
              )
            )
          )
        ) : null,
        this.state.modalXai ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20, fontWeight: "500" } },
                "华夏查理智投依托于华夏财富多年的投顾服务经验，基于您在不同人生阶段的财富目标，通过智能化的算法模型为您匹配定制化财富管理方案，一站式满足您的资产保值、财富成长、品质养老、子女教育等场景需求。"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20, fontWeight: "500" } },
                "我们希望通过专业化、场景化的基金投顾服务，帮助您降低筛选基金的门槛，并通过全程暖心陪伴服务，帮助您坚定地长期持有，将优选基金的业绩转化为您的实际回报，让您在投资过程中更省心、更安心。"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.closeModalXai, style: { width: "100%", height: "40px", textAlign: "center", lineHeight: "40px", borderTopColor: "#ebeef0", borderTopWidth: "1px", borderTopStyle: "solid", marginTop: "15px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 17, color: '#666666' } },
                    '\u77E5\u9053\u4E86'
                  )
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return MakePlanDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(MakePlanDetail));

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getPay__ = __webpack_require__(20);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ua = navigator.userAgent.toLowerCase();

var MakePlanResult = function (_Component) {
  _inherits(MakePlanResult, _Component);

  function MakePlanResult(props) {
    var _this2 = this;

    _classCallCheck(this, MakePlanResult);

    var _this = _possibleConstructorReturn(this, (MakePlanResult.__proto__ || Object.getPrototypeOf(MakePlanResult)).call(this, props));

    _this.goBackFun = function () {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    };

    _this.showModal = function (title, data) {
      _this.setState({
        modalFundListArr: data,
        modalFundTitle: title
      }, function () {
        _this.setState({
          modalList: true
        });
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
    };

    _this.closeModal = function () {
      _this.setState({
        modalList: false
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", _this.touchMove, false);
    };

    _this.investNotDetil = function (data) {
      if (ua.indexOf("amcfmapp") > -1) {
        // window.location.href = "http://mtest.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode;//测试
        if (data.superFundCode == 'SF1022') {
          window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/touguDetailPage/index.html?fundCode=" + data.superFundCode; //生产
        } else {
          window.location.href = "https://m.chinaamc.com/huaXiaCaiFu/fullMarketTouguDetailPage/index.html?fundCode=" + data.superFundCode; //生产
        }
        return;
      }
      var pathName = "/SuperFundDetail";
      if (data.fundType === "1") {
        pathName = '/TargetProfitDetail';
      } else {
        pathName = '/SuperFundDetail';
      }

      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: pathName,
        state: { superFundName: data.fundName, superFundCode: data.superFundCode },
        query: { superFundName: data.fundName, superFundCode: data.superFundCode }
      });
    };

    _this.showModalXiaoai = function () {
      _this.setState({
        modalXai: true
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "hidden";
      obj.addEventListener("touchmove", _this.touchMove, false);
    };

    _this.closeModalXai = function () {
      _this.setState({
        modalXai: false
      });
      var obj = document.getElementsByTagName("html")[0];
      obj.style.overflowY = "auto";
      obj.removeEventListener("touchmove", _this.touchMove, false);
    };

    _this.goToMakePlan = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var flagDigital, _currentUserInfo, didQuestionnairs, currentUserInfo;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.props.location.state && _this.props.location.state.rootPath == "MakePlanDetail")) {
                _context.next = 3;
                break;
              }

              _this.goBackFun();
              return _context.abrupt('return');

            case 3:
              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading();
              _context.next = 6;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["d" /* getStorage */])('loginState');

            case 6:
              flagDigital = _context.sent;
              _context.next = 9;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["d" /* getStorage */])('currentUserInfo');

            case 9:
              _currentUserInfo = _context.sent;

              console.log(flagDigital, _currentUserInfo);

              if (!(flagDigital == '1')) {
                _context.next = 18;
                break;
              }

              //实名认证
              _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_investmentAction_js__["b" /* clearSmrzOne */])());
              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
              __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                pathname: '/CertificationUpload',
                state: {
                  route: window.history.length,
                  phoneNo: _currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
                  callback: ua.indexOf("amcfmapp") > -1 ? function () {
                    _this.goToMakePlan();
                  } : null
                }
              });
              return _context.abrupt('return');

            case 18:
              if (!(flagDigital == '3')) {
                _context.next = 24;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
              //同步开户
              __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                pathname: '/BindingMobile',
                state: { route: window.history.length, callback: function callback() {
                    _this.goToMakePlan();
                  } }
              });
              return _context.abrupt('return');

            case 24:
              if (!(flagDigital == '0')) {
                _context.next = 30;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
              __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                pathname: ua.indexOf("amcfmapp") > -1 ? '/LoginHxjj' : '/Login',
                state: { route: window.history.length, callback: ua.indexOf("amcfmapp") > -1 ? function () {
                    _this.goToMakePlan();
                  } : null }
              });
              return _context.abrupt('return');

            case 30:
              __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
              didQuestionnairs = false;
              _context.prev = 32;
              _context.next = 35;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__getPay__["o" /* judgeQuestionnaires */])();

            case 35:
              didQuestionnairs = _context.sent;
              _context.next = 41;
              break;

            case 38:
              _context.prev = 38;
              _context.t0 = _context['catch'](32);
              return _context.abrupt('return');

            case 41:
              if (didQuestionnairs) {
                _context.next = 44;
                break;
              }

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], window.history.length, function () {
                _this.goToMakePlan();
              });
              return _context.abrupt('return');

            case 44:
              _context.next = 46;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["d" /* getStorage */])('currentUserInfo');

            case 46:
              currentUserInfo = _context.sent;

              console.log(currentUserInfo);
              if (currentUserInfo && currentUserInfo.userMsg) {
                __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].replace({
                  pathname: '/MakePlanDetail',
                  state: {
                    certNo: currentUserInfo.userMsg.certType === "0" && currentUserInfo.userMsg.certNo ? currentUserInfo.userMsg.certNo : ""
                  }
                });
              }

            case 49:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[32, 38]]);
    }));

    _this.state = {
      modalList: false,
      modalFundListArr: [],
      modalFundTitle: "",
      modalXai: false
    };
    return _this;
  }

  _createClass(MakePlanResult, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var arrList = this.props.location.state && this.props.location.state.fundListArr ? this.props.location.state.fundListArr : [];
      var arrListSec = [1, 2, 3, 4, 5];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { display: "-webkit-flex", WebkitFlex: 1, backgroundColor: "#fff", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { backgroundImage: 'url(' + __webpack_require__(1970) + ')', backgroundSize: "cover", width: window.winWidth, height: window.winWidth / (1125 / 1113), paddingRight: 20, paddingLeft: 20 } },
          ua.indexOf("amcfmapp") > -1 ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 56 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBackFun, src: __webpack_require__(1972), style: { width: 24, height: 24 } })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 18, WebkitFlexDirection: "row", WebkitAlignItems: "center", WebkitJustifyContent: "space-between", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 24, color: "#fff", fontWeight: 500 } },
              '\u534E\u590F\u67E5\u7406\u667A\u6295'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { WebkitFlexDirection: "row", WebkitAlignItems: "center", display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 16, color: "#fff", fontWeight: 500 } },
                '\u61C2\u6295\u8D44\xB7\u66F4\u61C2\u4F60'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.showModalXiaoai, src: __webpack_require__(1974), style: { width: 18, height: 18, marginLeft: 5 } })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { marginTop: ua.indexOf("amcfmapp") > -1 ? -309 : -225, paddingBottom: 20, width: window.winWidth, display: "-webkit-flex", WebkitFlexDirection: "column", WebkitAlignItems: "center" } },
          this.props.location.state && this.props.location.state.tabListArr && this.props.location.state.tabListArr.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingBottom: 10, width: window.winWidth - 40 } },
            this.props.location.state.lookFlag == "部分" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 13, color: "#fff", fontWeight: 500, lineHeight: "17px" } },
              '\u57FA\u4E8E\u60A8\u7684\u9700\u6C42\u548C\u5BF9\u98CE\u9669\u63D0\u793A\u7684\u786E\u8BA4\uFF0C',
              this.props.location.state.tabListArr.join("、"),
              '\u6682\u672A\u5339\u914D\u51FA\u6295\u987E\u7EC4\u5408\u3002',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { onClick: this.goToMakePlan, style: { fontSize: 13, color: "#fff", fontWeight: 500, borderBottom: "solid" } },
                '\u91CD\u65B0\u89C4\u5212'
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 13, color: "#fff", fontWeight: 500, lineHeight: "17px" } },
              this.props.location.state.tabListArr.join("、"),
              '\u6682\u672A\u5339\u914D\u51FA\u6295\u987E\u7EC4\u5408\u3002'
            )
          ) : null,
          arrList.map(function (data, index) {
            if (data.superFundProductViewList && data.superFundProductViewList.length > 0) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ListView, { key: index, _showModal: function _showModal(fir, sec) {
                  _this3.showModal(fir, sec);
                }, _investNotDetil: function _investNotDetil(res) {
                  return _this3.investNotDetil(res);
                }, datas: data, indexs: index });
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingTop: 20, display: "-webkit-flex", backgroundColor: "#F8F8F8" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: this.goToMakePlan, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", width: 122, height: 32, borderRadius: 4 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 14, color: "#fff" } },
              '\u91CD\u65B0\u89C4\u5212'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, backgroundColor: "#F8F8F8", paddingTop: 20, paddingBottom: 57, paddingLeft: 20, paddingRight: 20 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { style: { fontSize: 12, color: "#999", lineHeight: "17px" } },
            ua.indexOf("amcfmapp") > -1 ? '成立以来年化涨跌幅' : '成立以来年化收益',
            '\u7B49\u5386\u53F2\u4E1A\u7EE9\u4EC5\u4F5C\u4E3A\u53C2\u8003\uFF0C\u4E0D\u9884\u793A\u7EC4\u5408\u672A\u6765\u8868\u73B0\u3002\u534E\u590F\u8D22\u5BCC\u4E0D\u627F\u8BFA\u7EC4\u5408\u6536\u76CA\uFF0C\u4E5F\u4E0D\u505A\u4FDD\u672C\u627F\u8BFA\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\uFF1B\u6295\u8D44\u8005\u81EA\u4E3B\u9009\u62E9\u6295\u987E\u7EC4\u5408\uFF0C\u627F\u62C5\u5E02\u573A\u6CE2\u52A8\u5E26\u6765\u7684\u635F\u5931\uFF1B\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002'
          )
        ),
        this.state.modalList ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: this.closeModal, style: { position: "fixed", width: window.winWidth, top: 0, left: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.6)" } }) : null,
        this.state.modalList ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { backgroundColor: "#fff", position: "fixed", bottom: 0, height: 558, borderTopLeftRadius: 8, borderTopRightRadius: 8, width: window.winWidth, overflowY: "auto", zIndex: 10 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.closeModal, src: __webpack_require__(392), style: { width: 14, height: 14, right: 20, top: 20, position: "absolute" } }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 18, color: "#333", fontWeight: 500, width: window.winWidth, textAlign: "center" } },
              this.state.modalFundTitle
            )
          ),
          this.state.modalFundListArr.map(function (data, index) {
            var colorSyl = "#F92C3D";
            if (data.fullOneYear) {
              if (__WEBPACK_IMPORTED_MODULE_5__util___default.a.returnEmpty(data.rate, "%") == "--%") {
                colorSyl = "#333";
              } else {
                if (data.rate < 0) {
                  colorSyl = "rgba(54, 169, 99, 1)";
                } else {
                  colorSyl = "#F92C3D";
                }
              }
            } else {
              colorSyl = "#333";
            }
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: index, onClick: function onClick() {
                  _this3.investNotDetil(data);
                }, style: { width: window.winWidth, paddingLeft: 20, paddingRight: 20, paddingTop: 20 } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#333" } },
                  data.fundName
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 18, color: colorSyl, fontWeight: 400, lineHeight: '20px' } },
                    data.fullOneYear ? __WEBPACK_IMPORTED_MODULE_5__util___default.a.returnEmpty(data.rate, "%") : "--%"
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 11, color: "#666", marginTop: 5 } },
                    ua.indexOf("amcfmapp") > -1 ? '成立以来年化涨跌幅' : data.rateTypeName
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 18, color: "#333", fontWeight: 400, lineHeight: '20px' } },
                    data.holdTime
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: 11, color: "#666", marginTop: 5 } },
                    data.hold
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { marginTop: 10, backgroundColor: "#F5F5F5", paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10, borderRadius: 2 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 11, color: "#666" } },
                  '\u7279\u70B9\uFF1A',
                  data.feature
                )
              ),
              index === _this3.state.modalFundListArr.length - 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { marginTop: 20 } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { marginTop: 20, backgroundColor: "#EFF0F4", height: 1, width: window.winWidth - 40 } })
            );
          })
        ) : null,
        this.state.modalXai ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { WebkitFlexDirection: "column", width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center", display: "-webkit-flex" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center", WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20, fontWeight: "500" } },
                "华夏查理智投依托于华夏财富多年的投顾服务经验，基于您在不同人生阶段的财富目标，通过智能化的算法模型为您匹配定制化财富管理方案，一站式满足您的资产保值、财富成长、品质养老、子女教育等场景需求。"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { fontSize: 16, lineHeight: "22px", color: "#474747", paddingLeft: 20, paddingRight: 20, fontWeight: "500" } },
                "我们希望通过专业化、场景化的基金投顾服务，帮助您降低筛选基金的门槛，并通过全程暖心陪伴服务，帮助您坚定地长期持有，将优选基金的业绩转化为您的实际回报，让您在投资过程中更省心、更安心。"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { onClick: this.closeModalXai, style: { width: "100%", height: "40px", textAlign: "center", lineHeight: "40px", borderTopColor: "#ebeef0", borderTopWidth: "1px", borderTopStyle: "solid", marginTop: "15px" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 17, color: '#666666' } },
                    '\u77E5\u9053\u4E86'
                  )
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return MakePlanResult;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ListView = function (_Component2) {
  _inherits(ListView, _Component2);

  function ListView(props) {
    _classCallCheck(this, ListView);

    var _this4 = _possibleConstructorReturn(this, (ListView.__proto__ || Object.getPrototypeOf(ListView)).call(this, props));

    _this4.showHideFun = function (title, data) {
      _this4.props._showModal(title, data);
    };

    _this4.returnImg = function (id) {
      for (var i = 0; i < _this4.imgList.length; i++) {
        if (id == _this4.imgList[i].id) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: _this4.imgList[i].img, style: { width: 64, height: 64, right: 0, top: 0, position: "absolute" } });
        }
      }
    };

    _this4.state = {};
    _this4.imgList = [{
      id: "zcbz",
      img: __webpack_require__(2160)
    }, {
      id: "cfcz",
      img: __webpack_require__(2161)
    }, {
      id: "pzyl",
      img: __webpack_require__(2167)
    }, {
      id: "znjy",
      img: __webpack_require__(2162)
    }];
    return _this4;
  }

  _createClass(ListView, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var colorSyl = "#F92C3D";
      if (this.props.datas.superFundProductViewList[0].fullOneYear) {
        if (__WEBPACK_IMPORTED_MODULE_5__util___default.a.returnEmpty(this.props.datas.superFundProductViewList[0].rate, "%") == "--%") {
          colorSyl = "#333";
        } else {
          if (this.props.datas.superFundProductViewList[0].rate < 0) {
            colorSyl = "rgba(54, 169, 99, 1)";
          } else {
            colorSyl = "#F92C3D";
          }
        }
      } else {
        colorSyl = "#333";
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { position: "relative", backgroundColor: "#fff", borderRadius: 4, boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)", paddingTop: 15, paddingBottom: this.props.datas.superFundProductViewList.length > 1 ? 10 : 15, paddingLeft: 15, paddingRight: 15, width: window.winWidth - 40, marginTop: this.props.indexs === 0 ? 0 : 10 } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              _this5.props._investNotDetil(_this5.props.datas.superFundProductViewList[0]);
            } },
          this.returnImg(this.props.datas.sceneId),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 16, color: "#2C3245", fontWeight: 500 } },
              this.props.datas.sceneName
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 14, color: "#333" } },
              this.props.datas.superFundProductViewList[0].fundName
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginTop: 15, display: "-webkit-flex", WebkitFlexDirection: "row" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: colorSyl, fontWeight: 400, lineHeight: '20px' } },
                this.props.datas.superFundProductViewList[0].fullOneYear ? __WEBPACK_IMPORTED_MODULE_5__util___default.a.returnEmpty(this.props.datas.superFundProductViewList[0].rate, "%") : "--%"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 11, color: "#666", marginTop: 5 } },
                ua.indexOf("amcfmapp") > -1 ? '成立以来年化涨跌幅' : this.props.datas.superFundProductViewList[0].rateTypeName
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "column" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 400, lineHeight: '20px' } },
                this.props.datas.superFundProductViewList[0].holdTime
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { style: { fontSize: 11, color: "#666", marginTop: 5 } },
                this.props.datas.superFundProductViewList[0].hold
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginTop: 10, backgroundColor: "#F5F5F5", paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10, borderRadius: 2 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { style: { fontSize: 11, color: "#666" } },
              '\u7279\u70B9\uFF1A',
              this.props.datas.superFundProductViewList[0].feature
            )
          )
        ),
        this.props.datas.superFundProductViewList.length > 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              _this5.showHideFun(_this5.props.datas.sceneName, _this5.props.datas.superFundProductViewList);
            }, style: { marginTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(392), style: { width: 14, height: 14 } })
        ) : null
      );
    }
  }]);

  return ListView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(MakePlanResult));

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__ = __webpack_require__(97);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ToastTime = 2;

var seasons = [{
  label: '全部产品',
  value: '2013',
  key: 0
}, {
  label: '锐意进取型',
  value: '2013',
  key: 1
}, {
  label: '稳健型',
  value: '2014',
  key: 2
}];

var ModifyTaxInfo = function (_Component) {
  _inherits(ModifyTaxInfo, _Component);

  function ModifyTaxInfo(props) {
    _classCallCheck(this, ModifyTaxInfo);

    var _this2 = _possibleConstructorReturn(this, (ModifyTaxInfo.__proto__ || Object.getPrototypeOf(ModifyTaxInfo)).call(this, props));

    _this2.state = {
      yesFlag: false,
      noFlag: true,
      onlyChinese: true,
      noOnlyChinese: false,

      allCountry: [],
      allCountryCode: "",
      allCountryZhCode: "",
      allCountryUsCode: "",
      allCountryUs: [],
      chineseName: "", /*姓名*/
      familyName: "", /*姓*/
      englishName: "", /*名*/
      countryUs: "", /*现居国英文*/
      countryZh: "", /*现居国中文*/
      countryCode: "",
      countryUsCode: "",
      provinceUs: "", /*现居省英文*/
      provinceZh: "", /*现居省中文*/
      cityUs: "", /*现居市英文*/
      cityZh: "", /*现居市中文*/
      birthCityUs: "", /*出生市英文*/
      birthCityZh: "", /*出生市中文*/
      birthCountryUs: "", /*出生国家英文*/
      birthCountryZh: "", /*出生国家中文*/
      birthCountryCode: "",
      birthCountryUsCode: "",
      addressUs: "", /*现居地址英文或拼音*/
      addressZh: "", /*现居地址中文*/
      birthAddressUs: "", /*出生地英文或拼音*/
      birthAddressZh: "", /*出生地址中文*/
      provinceCity: "", /*所在城市(选中国)*/
      provinceCode: "",
      cityCode: "",
      isShow: true,

      TaxCountryCode: "",
      onTaxNumber: "有", /*是否有纳税人识别号*/
      TaxNumber: "", /*纳税人识别号*/
      NoTaxNumber: "A", /*无纳税人识别号原因*/
      NoNumberReasion: "", /*具体原因*/

      arrInfo: [],
      i: 0,

      agreeIcon: true,
      enterType: _this2.props.location.query.enterType ? _this2.props.location.query.enterType : null
    };
    _this2.goCallback = false;
    return _this2;
  }

  _createClass(ModifyTaxInfo, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.goCallback) {
        this.props.location.state.callback ? this.props.location.state.callback() : null;
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var dispatch = this.props.dispatch;

      document.getElementsByTagName('title')[0].innerHTML = "税收居民身份";

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["x" /* provinceCity */])(null));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["y" /* getAllCountry */])(this.detailCallBack.bind(this), this));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["z" /* getProvinceCity */])(function (data) {
        _this3.setState({
          provinceCity: [data[0].provinceName, data[0].cityList[0].cityName],
          provinceCode: data[0].provinceCode,
          cityCode: data[0].cityList[0].cityCode
        });
      }, function () {
        _this3.setState({
          provinceCity: ["", ""]
        });
      }));
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'detailCallBack',
    value: function detailCallBack(data) {
      var newDataUS = [].concat(data);
      var newDataZh = [].concat(data);
      var usCode = [];
      var code = [];
      var usAll = [];
      var zhAll = [];
      newDataUS.sort(function (a, b) {
        return a.countryNameUs.localeCompare(b.countryNameUs, 'zh-Hans-CN', { sensitivity: 'accent' });
      });
      newDataZh.sort(function (a, b) {
        return a.countryNameZh.localeCompare(b.countryNameZh, 'zh-Hans-CN', { sensitivity: 'accent' });
      });
      for (var i = 0; i < newDataUS.length; i++) {
        usCode.push(newDataUS[i].countryCode);
        usAll.push(newDataUS[i].countryNameUs);
      }
      for (var _i = 0; _i < newDataZh.length; _i++) {
        code.push(newDataZh[_i].countryCode);
        zhAll.push(newDataZh[_i].countryNameZh);
      }
      this.setState({
        allCountryUs: newDataUS,
        allCountry: newDataZh,
        allCountryCode: code,
        allCountryZhCode: code,
        allCountryUsCode: usCode,
        countryUs: usAll[0],
        countryZh: zhAll[code.indexOf(newDataUS[0].countryCode)],
        countryUsCode: usCode[0],
        countryCode: usCode[0],
        birthCountryUs: usAll[0],
        birthCountryZh: zhAll[code.indexOf(newDataUS[0].countryCode)],
        birthCountryUsCode: usCode[0],
        birthCountryCode: usCode[0],
        TaxCountryCode: code[0]
      });
    }
  }, {
    key: 'addTaxCountry',
    value: function addTaxCountry() {
      var _this = this;
      var arr = [];
      arr = arr.concat(this.state.arrInfo);
      var vueKey = this.state.i;
      var ii = void 0;
      for (var i = 0; i < this.state.i; i++) {
        if (arr[i] == undefined) {
          var refOne = "taxName" + String(i);
          arr[i] = refOne;
          ii = 0;
          break;
        }
      }
      if (this.state.i < 19) {
        if (ii != 0) {
          var refTwo = "taxName" + String(vueKey);
          arr[vueKey] = refTwo;
          ii = 1;
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('最多只能有20个纳税国家', ToastTime);
        return;
      }
      this.setState({
        i: this.state.i + ii,
        arrInfo: arr
      });
    }
  }, {
    key: 'deleteTaxCountry',
    value: function deleteTaxCountry(vue) {
      var arrTemp = [];
      arrTemp = arrTemp.concat(this.state.arrInfo);
      arrTemp[vue] = undefined;
      this.setState({
        arrInfo: arrTemp
      });
    }
  }, {
    key: 'successCallBack',
    value: function successCallBack() {
      __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].push({
        pathname: '/TaxSuccess',
        state: {
          callback: this.props.location.state.callback, route: this.props.location.state.route, name: false
        }
      });
    }
  }, {
    key: 'sureBtn',
    value: function sureBtn() {
      var _this4 = this;

      var that = this;
      var dispatch = this.props.dispatch;
      var _props$location$state = this.props.location.state,
          passWord = _props$location$state.passWord,
          name = _props$location$state.name,
          authRequestNo = _props$location$state.authRequestNo,
          bankAccountName = _props$location$state.bankAccountName,
          bankAccountShowNo = _props$location$state.bankAccountShowNo,
          bankCode = _props$location$state.bankCode,
          businessType = _props$location$state.businessType,
          certNo = _props$location$state.certNo,
          certType = _props$location$state.certType,
          mobileNo = _props$location$state.mobileNo,
          paymentChannelId = _props$location$state.paymentChannelId,
          actualBeneficiary = _props$location$state.actualBeneficiary,
          actualController = _props$location$state.actualController,
          actualBeneficiaryCertType = _props$location$state.actualBeneficiaryCertType,
          actualBeneficiaryCertNo = _props$location$state.actualBeneficiaryCertNo,
          actualControllerCertType = _props$location$state.actualControllerCertType,
          actualControllerCertNo = _props$location$state.actualControllerCertNo,
          officialsOrRelatives = _props$location$state.officialsOrRelatives,
          address = _props$location$state.address,
          careerCode = _props$location$state.careerCode,
          cityCode = _props$location$state.cityCode,
          provinceCode = _props$location$state.provinceCode;

      var password = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.encrypt(passWord);
      var _state = this.state,
          agreeIcon = _state.agreeIcon,
          yesFlag = _state.yesFlag,
          noFlag = _state.noFlag,
          onlyChinese = _state.onlyChinese,
          noOnlyChinese = _state.noOnlyChinese,
          onTaxNumber = _state.onTaxNumber,
          TaxCountryCode = _state.TaxCountryCode,
          TaxNumber = _state.TaxNumber,
          NoTaxNumber = _state.NoTaxNumber,
          NoNumberReasion = _state.NoNumberReasion,
          chineseName = _state.chineseName,
          countryZh = _state.countryZh,
          countryUs = _state.countryUs,
          familyName = _state.familyName,
          englishName = _state.englishName,
          birthCountryZh = _state.birthCountryZh,
          birthCountryUs = _state.birthCountryUs,
          addressZh = _state.addressZh,
          addressUs = _state.addressUs,
          birthAddressZh = _state.birthAddressZh,
          birthAddressUs = _state.birthAddressUs,
          provinceUs = _state.provinceUs,
          provinceZh = _state.provinceZh,
          cityUs = _state.cityUs,
          cityZh = _state.cityZh,
          birthCityUs = _state.birthCityUs,
          birthCityZh = _state.birthCityZh,
          countryCode = _state.countryCode,
          countryUsCode = _state.countryUsCode,
          birthCountryCode = _state.birthCountryCode,
          birthCountryUsCode = _state.birthCountryUsCode,
          provinceCity = _state.provinceCity;

      var isAbroad = yesFlag ? true : false;
      var residentType = onlyChinese ? "0" : "2";
      var crsTaxCountry = [];
      var crsTaxIdentifier = [];
      var noIdentifierReason = [];
      var specificReason = [];
      if (!agreeIcon) {
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请勾选本人承诺', ToastTime);
        return;
      }
      var cNReg = /^[\u4e00-\u9fa5]+$/; //全中文
      var eNReg = /^[^\u4e00-\u9fa5]+$/; //全英文
      if (noOnlyChinese) {
        if (countryUs == "China") {
          if (chineseName == "" || familyName == "" || englishName == "" || countryZh == "" || countryUs == "" || cityUs == "" || provinceCity == "" || birthCountryUs == "" || birthCountryZh == "" || TaxCountryCode == "") {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请完整填写身份资料', ToastTime);
            return;
          } else {
            if (!cNReg.test(chineseName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓名不能包含英文", ToastTime);
              return;
            }
            if (!eNReg.test(familyName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓不能包含中文", ToastTime);
              return;
            }
            if (!eNReg.test(englishName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("名不能包含中文", ToastTime);
              return;
            }
            if (onTaxNumber === "有") {
              if (TaxNumber == "") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写纳税人识别号', ToastTime);
                return;
              }
            } else if (onTaxNumber === "无") {
              if (NoTaxNumber === "请选择") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请选择无纳税人识别号原因', ToastTime);
                return;
              } else if (NoTaxNumber === "B") {
                if (NoNumberReasion === "") {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写未取得纳税人识别号具体原因', ToastTime);
                  return;
                }
              }
            }
          }
        } else {
          if (chineseName == "" || familyName == "" || englishName == "" || countryZh == "" || countryUs == "" || cityUs == "" || birthCountryUs == "" || birthCountryZh == "" || TaxCountryCode == "") {
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请完整填写身份资料', ToastTime);
            return;
          } else {
            if (!cNReg.test(chineseName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓名不能包含英文", ToastTime);
              return;
            }
            if (!eNReg.test(familyName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("姓不能包含中文", ToastTime);
              return;
            }
            if (!eNReg.test(englishName)) {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("名不能包含中文", ToastTime);
              return;
            }
            if (onTaxNumber === "有") {
              if (TaxNumber == "") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写纳税人识别号', ToastTime);
                return;
              }
            } else if (onTaxNumber === "无") {
              if (NoTaxNumber === "请选择") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请选择无纳税人识别号原因', ToastTime);
                return;
              } else if (NoTaxNumber === "B") {
                if (NoNumberReasion === "") {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('请填写未取得纳税人识别号具体原因', ToastTime);
                  return;
                }
              }
            }
          }
        }
        if (NoTaxNumber === "请选择") {
          noIdentifierReason.push("");
        } else {
          noIdentifierReason = [NoTaxNumber];
        }
        crsTaxCountry = [TaxCountryCode];
        crsTaxIdentifier.push(TaxNumber);

        specificReason.push(NoNumberReasion);
        var disFlag = false;

        this.state.arrInfo.map(function (item, key) {
          if (item != undefined) {
            if (that.refs[item].state.TaxCountryCode == "") {
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("纳税居民国" + String(key + 2) + "不能为空", ToastTime);
              disFlag = true;
              return false;
            } else if (that.refs[item].state.onTaxNumber == "有") {
              if (that.refs[item].state.TaxNumber === "") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请填写纳税居民国" + String(key + 2) + "纳税人识别号", ToastTime);
                disFlag = true;
                return false;
              }
            } else if (that.refs[item].state.onTaxNumber === "无") {
              if (that.refs[item].state.NoTaxNumber === "请选择") {
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择纳税居民国" + String(key + 2) + "无纳税人识别号原因", ToastTime);
                disFlag = true;
                return false;
              } else if (that.refs[item].state.NoTaxNumber === "B") {
                if (that.refs[item].state.NoNumberReasion === "") {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请填写纳税居民国" + String(key + 2) + "未取得纳税人识别号原因", ToastTime);
                  disFlag = true;
                  return false;
                }
              }
            }
            if (that.refs[item].state.NoTaxNumber === "请选择") {
              noIdentifierReason.push("");
            } else {
              noIdentifierReason.push(that.refs[item].state.NoTaxNumber);
            }
            crsTaxCountry.push(that.refs[item].state.TaxCountryCode);
            crsTaxIdentifier.push(that.refs[item].state.TaxNumber);
            specificReason.push(that.refs[item].state.NoNumberReasion);
          }
        });
        if (disFlag) {
          return false;
        }
        crsTaxCountry = crsTaxCountry.join();
        crsTaxIdentifier = crsTaxIdentifier.join();
        noIdentifierReason = noIdentifierReason.join();
        specificReason = specificReason.join();

        var route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
        var callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;

        var allInObj = {
          isAbroad: isAbroad, residentType: residentType,
          chineseName: chineseName,
          familyName: familyName,
          englishName: englishName,
          countryZh: countryCode,
          countryUs: countryUsCode,
          provinceUs: provinceUs,
          provinceZh: countryUs == "China" ? this.state.provinceCode : provinceZh,
          cityUs: cityUs,
          cityZh: countryUs == "China" ? this.state.cityCode : cityZh,
          birthCityUs: birthCityUs,
          birthCityZh: birthCityZh,
          postCode: "",
          email: "",
          addressZh: addressZh,
          addressUs: addressUs,
          birthCountryZh: birthCountryCode,
          birthCountryUs: birthCountryUsCode,
          birthAddressZh: birthAddressZh,
          birthAddressUs: birthAddressUs,
          crsTaxCountry: crsTaxCountry,
          crsTaxIdentifier: crsTaxIdentifier,
          noIdentifierReason: noIdentifierReason,
          specificReason: specificReason
        };
        console.log(allInObj);
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["i" /* modifyTaxInfo */])(allInObj, function () {
          var route = _this4.props.location.state && _this4.props.location.state.route ? _this4.props.location.state.route : null;

          if (route) {
            _this4.goCallback = true;
            __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-2);
          }
        }, function (msg) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(msg, __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.ToastTime);
        }));
      } else {
        if (!yesFlag && !noFlag) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择是否有向向其他国家纳税的活动", ToastTime);
          return;
        } else if (!onlyChinese && !noOnlyChinese) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("请选择本人申明", ToastTime);
          return;
        }

        var obj = {
          isAbroad: isAbroad,
          residentType: residentType
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["i" /* modifyTaxInfo */])(obj, function () {
          var route = _this4.props.location.state && _this4.props.location.state.route ? _this4.props.location.state.route : null;

          if (route) {
            _this4.goCallback = true;
            __WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */].go(-2);
          }
        }, function (msg) {
          __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info(msg, ToastTime);
        }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var arrUs = [];
      var arrZh = [];
      var usAll = [];
      var zhAll = [];
      var arrProc = [];
      if (this.state.allCountry.length > 0 && this.state.allCountryUs.length > 0) {
        for (var i = 0; i < this.state.allCountry.length; i++) {
          arrUs.push({
            label: this.state.allCountryUs[i].countryNameUs,
            value: this.state.allCountryUs[i].countryCode
          });
          arrZh.push({
            label: this.state.allCountry[i].countryNameZh,
            value: this.state.allCountry[i].countryCode
          });
          usAll.push(this.state.allCountryUs[i].countryNameUs);
          zhAll.push(this.state.allCountry[i].countryNameZh);
        }
      }
      if (this.props.provinceCity != null) {
        for (var _i2 = 0; _i2 < this.props.provinceCity.length; _i2++) {
          var obj = {};
          var obj2 = [];
          obj.label = this.props.provinceCity[_i2].provinceName;
          obj.value = this.props.provinceCity[_i2].provinceCode;
          for (var k = 0; k < this.props.provinceCity[_i2].cityList.length; k++) {
            obj2.push({
              label: this.props.provinceCity[_i2].cityList[k].cityName,
              value: this.props.provinceCity[_i2].cityList[k].cityCode
            });
          }
          obj.children = obj2;
          arrProc.push(obj);
        }
      }

      var _state2 = this.state,
          yesFlag = _state2.yesFlag,
          noFlag = _state2.noFlag,
          onlyChinese = _state2.onlyChinese,
          noOnlyChinese = _state2.noOnlyChinese,
          onTaxNumber = _state2.onTaxNumber,
          NoTaxNumber = _state2.NoTaxNumber,
          chineseName = _state2.chineseName,
          countryZh = _state2.countryZh,
          countryUs = _state2.countryUs,
          familyName = _state2.familyName,
          englishName = _state2.englishName,
          birthCountryZh = _state2.birthCountryZh,
          birthCountryUs = _state2.birthCountryUs,
          addressZh = _state2.addressZh,
          addressUs = _state2.addressUs,
          birthAddressZh = _state2.birthAddressZh,
          birthAddressUs = _state2.birthAddressUs,
          provinceUs = _state2.provinceUs,
          provinceZh = _state2.provinceZh,
          cityUs = _state2.cityUs,
          cityZh = _state2.cityZh,
          birthCityUs = _state2.birthCityUs,
          birthCityZh = _state2.birthCityZh,
          countryCode = _state2.countryCode,
          countryUsCode = _state2.countryUsCode,
          birthCountryCode = _state2.birthCountryCode,
          birthCountryUsCode = _state2.birthCountryUsCode,
          TaxCountryCode = _state2.TaxCountryCode,
          provinceCity = _state2.provinceCity,
          agreeIcon = _state2.agreeIcon;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this5.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u7A0E\u6536\u5C45\u6C11\u8EAB\u4EFD'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content', style: { paddingBottom: "40px" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'TaxBgMain' },
            '\u6839\u636E\u300A\u975E\u5C45\u6C11\u91D1\u878D\u8D26\u6237\u6D89\u7A0E\u4FE1\u606F\u5C3D\u804C\u8C03\u67E5\u7BA1\u7406\u529E\u6CD5\u300B\u89C4\u5B9A\uFF0C\u8BF7\u60A8\u8865\u5145\u4EE5\u4E0B\u8D44\u6599\uFF0C\u9605\u8BFB\u5E76\u52FE\u9009\u627F\u8BFA\u5185\u5BB9:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'yesOrNoTax' },
            '\u662F\u5426\u6301\u6709\u5176\u4ED6\u56FD\u5BB6\u6216\u5730\u533A\u7684\u56FD\u7C4D\u6216\u6C38\u4E45\u5C45\u7559\u6743,\u6216\u5728\u8FC7\u53BB\u4E00\u5E74\u4E2D\u5728\u5176\u4ED6\u56FD\u5BB6\u5C45\u4F4F\u6216\u5DE5\u4F5C,\u6216\u4ECE\u4E8B\u5176\u4ED6\u6709\u4E49\u52A1\u5411\u522B\u56FD\u7F34\u7EB3\u7A0E\u6536\u7684\u6D3B\u52A8\uFF1F'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: yesFlag ? "chooseYes" : "chooseNO", onClick: function onClick() {
                _this5.setState({ yesFlag: true, noFlag: false, noOnlyChinese: true, onlyChinese: false });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u662F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: noFlag ? "chooseYes" : "chooseNO", onClick: function onClick() {
                _this5.setState({ noFlag: true, yesFlag: false, onlyChinese: true, noOnlyChinese: false });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5426'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
            '\u672C\u4EBA\u7533\u660E\u4E3A'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: onlyChinese ? "chooseYes" : "chooseNO", onClick: function onClick() {
                _this5.setState({ onlyChinese: true, noOnlyChinese: false, resultShow: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u4EC5\u4E3A\u4E2D\u56FD\u7A0E\u6536\u5C45\u6C11'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: noOnlyChinese ? "chooseYes" : "chooseNO", onClick: function onClick() {
                _this5.setState({ noOnlyChinese: true, onlyChinese: false, resultShow: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5373\u662F\u4E2D\u56FD\u7A0E\u6536\u5C45\u6C11\u53C8\u662F\u5176\u4ED6\u56FD\u5BB6\uFF08\u5730\u533A\uFF09\u7A0E\u6536\u5C45\u6C11'
            )
          ),
          noOnlyChinese ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'crsAdd' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u8865\u5145\u8EAB\u4EFD\u8D44\u6599'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u59D3\u540D\uFF08\u4E2D\u6587\uFF09'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D', value: chineseName, onChange: function onChange(e) {
                  _this5.setState({ chineseName: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u59D3 (\u82F1\u6587\u6216\u62FC\u97F3)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u59D3', value: familyName, onChange: function onChange(e) {
                  _this5.setState({ familyName: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u540D (\u82F1\u6587\u6216\u62FC\u97F3)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u540D', value: englishName, onChange: function onChange(e) {
                  _this5.setState({ englishName: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u73B0\u5C45\u5730\u5740 (\u82F1\u6587\u6216\u62FC\u97F3)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrUs, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [countryUsCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ countryUsCode: e[0], countryCode: e[0], countryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], countryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7701 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u7701', value: provinceUs, onChange: function onChange(e) {
                  _this5.setState({ provinceUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: cityUs, onChange: function onChange(e) {
                  _this5.setState({ cityUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: addressUs, onChange: function onChange(e) {
                  _this5.setState({ addressUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: countryUs == "China" ? "" : "ifChina", style: { height: '0.9rem', paddingLeft: '13px', paddingRight: '13px', lineHeight: '1rem', fontSize: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u73B0\u5C45\u5730\u5740 (\u4E2D\u6587)'
              ),
              countryUs == "China" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u6B64\u9879\u9009\u586B'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrZh, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [countryCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ countryCode: e[0], countryUsCode: e[0], countryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], countryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            countryUs == "China" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrProc, cols: 2, className: 'forss', title: '\u9009\u62E9\u57CE\u5E02', value: [this.state.provinceCode, this.state.cityCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ provinceCode: e[0], cityCode: e[1] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u6240\u5728\u57CE\u5E02'
                )
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u7701'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u7701', value: provinceZh, onChange: function onChange(e) {
                  _this5.setState({ provinceZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            countryUs == "China" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: cityZh, onChange: function onChange(e) {
                  _this5.setState({ cityZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              countryUs == "China" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: addressZh, onChange: function onChange(e) {
                  _this5.setState({ addressZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u51FA\u751F\u5730 (\u82F1\u6587\u6216\u62FC\u97F3)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrUs, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [birthCountryUsCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ birthCountryUsCode: e[0], birthCountryCode: e[0], birthCountryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], birthCountryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: birthCityUs, onChange: function onChange(e) {
                  _this5.setState({ birthCityUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: birthAddressUs, onChange: function onChange(e) {
                  _this5.setState({ birthAddressUs: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '0.9rem', paddingLeft: '13px', lineHeight: '1rem', fontSize: '13px' } },
              '\u51FA\u751F\u5730 (\u4E2D\u6587)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'PickerWrap' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                { data: arrZh, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [birthCountryCode], onPickerChange: function onPickerChange(e) {
                    return console.log('onPickerChange', e);
                  }, onOk: function onOk(e) {
                    return _this5.setState({ birthCountryCode: e[0], birthCountryUsCode: e[0], birthCountryUs: usAll[_this5.state.allCountryUsCode.indexOf(e[0])], birthCountryZh: zhAll[_this5.state.allCountryZhCode.indexOf(e[0])] });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                  { arrow: 'horizontal' },
                  '\u56FD\u5BB6'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u5E02 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5E02', value: birthCityZh, onChange: function onChange(e) {
                  _this5.setState({ birthCityZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'taxInputClass' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8BE6\u7EC6\u5730\u5740 (\u9009\u586B)'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                  _this5.setState({ isShow: false });
                }, onBlur: function onBlur() {
                  _this5.setState({ isShow: true });
                }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BE6\u7EC6\u5730\u5740', value: birthAddressZh, onChange: function onChange(e) {
                  _this5.setState({ birthAddressZh: e.target.value });
                }, style: { WebkitFlex: 1, textAlign: 'right' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { hegiht: "0.18rem" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'taxCountryTitle' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  '\u7EB3\u7A0E\u5C45\u6C11\u56FD1'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'PickerWrap' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                  { data: arrZh, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [TaxCountryCode], onPickerChange: function onPickerChange(e) {
                      return console.log('onPickerChange', e);
                    }, onOk: function onOk(e) {
                      return _this5.setState({ TaxCountryCode: e[0] });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                    { arrow: 'horizontal' },
                    '\u7A0E\u6536\u5C45\u6C11\u56FD(\u5730\u533A)'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'PickerWrap' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                  { data: HoverNoTaxNumber, cols: 1, className: 'forss', title: '\u8BF7\u9009\u62E9', value: [this.state.onTaxNumber], onPickerChange: function onPickerChange(e) {
                      return console.log('onPickerChange', e);
                    }, onOk: function onOk(e) {
                      return _this5.setState({ onTaxNumber: e[0] });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                    { arrow: 'horizontal' },
                    '\u662F\u5426\u6709\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
                  )
                )
              ),
              onTaxNumber === "有" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'taxInputClass' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                    _this5.setState({ isShow: false });
                  }, onBlur: function onBlur() {
                    _this5.setState({ isShow: true });
                  }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BC6\u522B\u53F7', value: this.state.TaxNumber, onChange: function onChange(e) {
                    _this5.setState({ TaxNumber: e.target.value });
                  }, style: { WebkitFlex: 1, textAlign: 'right' } })
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'PickerWrap' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
                    { data: NoTaxNumberArr, cols: 1, className: 'forss', title: '\u9009\u62E9\u539F\u56E0', value: [this.state.NoTaxNumber], onPickerChange: function onPickerChange(e) {
                        return console.log('onPickerChange', e);
                      }, onOk: function onOk(e) {
                        return _this5.setState({ NoTaxNumber: e[0] });
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                      { arrow: 'horizontal' },
                      '\u65E0\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7\u539F\u56E0'
                    )
                  )
                ),
                NoTaxNumber === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'taxInputClass' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    '\u5177\u4F53\u539F\u56E0'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onFocus: function onFocus() {
                      _this5.setState({ isShow: false });
                    }, onBlur: function onBlur() {
                      _this5.setState({ isShow: true });
                    }, autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5177\u4F53\u539F\u56E0', value: this.state.NoNumberReasion, onChange: function onChange(e) {
                      _this5.setState({ NoNumberReasion: e.target.value });
                    }, style: { WebkitFlex: 1, textAlign: 'right' } })
                ) : null
              )
            ),
            this.state.arrInfo.map(function (item, i) {
              var index = i;

              if (item != undefined) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TaxCountry, { key: "item" + i, allCountry: arrZh, ref: item, 'this': _this5, index: index });
              }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: "0 13px 0 0.26em", marginTop: '0.3rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this5.addTaxCountry();
                  }, style: { height: '0.8rem', display: "-webkit-flex", borderRadius: 40, border: "1px solid #ff9536", WebkitJustifyContent: 'center', WebkitAlignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#ff9536' } },
                  '+\u6DFB\u52A0\u5176\u4ED6\u7EB3\u7A0E\u5C45\u6C11\u56FD'
                )
              )
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'toSureAll' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: agreeIcon ? "yesSure" : "noSure" },
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { onClick: function onClick() {
                  _this5.setState({ agreeIcon: !_this5.state.agreeIcon });
                } }),
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'sureContent' },
              '"\u672C\u4EBA\u786E\u8BA4\u4E0A\u8FF0\u6240\u63D0\u4F9B\u7684\u4FE1\u606F\u771F\u5B9E\u3001\u51C6\u786E\u3001\u5B8C\u6574\u3001\u5408\u6CD5\u3001\u6709\u6548\uFF0C\u5982\u6709\u4F2A\u9020 \u3001\u6B3A\u8BC8\uFF0C\u63D0\u4F9B\u865A\u5047\u4FE1\u606F\u7B49\u884C\u4E3A\uFF0C\u672C\u4EBA\u81EA\u613F\u627F\u62C5\u6CD5\u5F8B\u8D23\u4EFB\u3002\u5F53\u6709\u5173\u8D44\u6599\u4FE1\u5FC3\u53D1\u751F\u53D8\u66F4\u65F6\uFF0C\u672C\u4EBA\u5C06\u5728 30\u65E5\u5185\u4E66\u9762\u901A\u77E5\u534E\u590F\u57FA\u91D1\u529E\u7406\u4FE1\u606F\u66F4\u6539\u624B\u7EED\uFF0C\u672C\u4EBA\u81EA\u613F\u627F\u62C5\u56E0\u672A\u5C65\u884C\u4E0A\u8FF0\u4E49\u52A1\u7167\u6210\u7684\u98CE\u9669\u548C\u635F\u5931\uFF0C\u534E\u590F\u57FA\u91D1\u5BF9\u672C\u4EBA\u906D\u53D7\u7684\u635F\u5931\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002"'
            )
          )
        ),
        this.state.isShow ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'FixedBottomHave', style: { WebkitJustifyContent: "center" }, onClick: function onClick() {
              return _this5.sureBtn();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F'
          )
        ) : null
      );
    }
  }]);

  return ModifyTaxInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var HoverNoTaxNumber = [{
  label: '有',
  value: '有',
  key: 0
}, {
  label: '无',
  value: '无',
  key: 1
}];

var NoTaxNumberArr = [{
  label: '居民国不发放识别号',
  value: 'A',
  key: 0
}, {
  label: '未取得纳税人识别号',
  value: 'B',
  key: 1
}];

var TaxCountry = function (_Component2) {
  _inherits(TaxCountry, _Component2);

  function TaxCountry(props) {
    _classCallCheck(this, TaxCountry);

    var _this6 = _possibleConstructorReturn(this, (TaxCountry.__proto__ || Object.getPrototypeOf(TaxCountry)).call(this, props));

    _this6.state = {
      TaxCountryCode: _this6.props.this.state.allCountryCode[0],
      onTaxNumber: "有", /*是否有纳税人识别号*/
      TaxNumber: "", /*纳税人识别号*/
      NoTaxNumber: "A", /*无纳税人识别号原因*/
      NoNumberReasion: "" /*具体原因*/
    };
    return _this6;
  }

  _createClass(TaxCountry, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _state3 = this.state,
          onTaxNumber = _state3.onTaxNumber,
          NoTaxNumber = _state3.NoTaxNumber;
      var allCountry = this.props.allCountry;

      var thisPro = this.props.this;
      var index = this.props.index + 2;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'taxCountryTitle' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            "纳税居民国" + index
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: function onClick() {
                thisPro.deleteTaxCountry(_this7.props.index);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              null,
              '\u5220\u9664'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerWrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
            { data: allCountry, cols: 1, className: 'forss', title: '\u9009\u62E9\u56FD\u5BB6', value: [this.state.TaxCountryCode], onPickerChange: function onPickerChange(e) {
                return console.log('onPickerChange', e);
              }, onOk: function onOk(e) {
                return _this7.setState({ TaxCountryCode: e[0] });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
              { arrow: 'horizontal' },
              '\u7A0E\u6536\u5C45\u6C11\u56FD(\u5730\u533A)'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'PickerWrap' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
            { data: HoverNoTaxNumber, cols: 1, className: 'forss', title: '\u8BF7\u9009\u62E9', value: [this.state.onTaxNumber], onPickerChange: function onPickerChange(e) {
                return console.log('onPickerChange', e);
              }, onOk: function onOk(e) {
                return _this7.setState({ onTaxNumber: e[0] });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
              { arrow: 'horizontal' },
              '\u662F\u5426\u6709\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
            )
          )
        ),
        onTaxNumber === "有" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'taxInputClass' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u8BC6\u522B\u53F7', value: this.state.TaxNumber, onChange: function onChange(e) {
              _this7.setState({ TaxNumber: e.target.value });
            }, style: { WebkitFlex: 1, textAlign: 'right' } })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'PickerWrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Picker"],
              { data: NoTaxNumberArr, cols: 1, className: 'forss', title: '\u9009\u62E9\u539F\u56E0', value: [this.state.NoTaxNumber], onPickerChange: function onPickerChange(e) {
                  return console.log('onPickerChange', e);
                }, onOk: function onOk(e) {
                  return _this7.setState({ NoTaxNumber: e[0] });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["List"].Item,
                { arrow: 'horizontal' },
                '\u65E0\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7\u539F\u56E0'
              )
            )
          ),
          NoTaxNumber === "B" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'taxInputClass' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              '\u5177\u4F53\u539F\u56E0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', placeholder: '\u8BF7\u8F93\u5165\u5177\u4F53\u539F\u56E0', value: this.state.NoNumberReasion, onChange: function onChange(e) {
                _this7.setState({ NoNumberReasion: e.target.value });
              }, style: { WebkitFlex: 1, textAlign: 'right' } })
          ) : null
        )
      );
    }
  }]);

  return TaxCountry;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    provinceCity: state.provinceCity
    // userHasInvested:state.userHasInvested,
    // inNeedUpdate:state.inNeedUpdate,
    // payLoading:state.riskInPay.payLoading,
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(ModifyTaxInfo));

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NHeader_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Performance_js__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__portfolioPerformance_css__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__portfolioPerformance_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__portfolioPerformance_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InfoTable_js__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LineEchartPerformanceTrends_js__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var PortfolioPerformance = function (_Component) {
  _inherits(PortfolioPerformance, _Component);

  function PortfolioPerformance(props) {
    _classCallCheck(this, PortfolioPerformance);

    var _this = _possibleConstructorReturn(this, (PortfolioPerformance.__proto__ || Object.getPrototypeOf(PortfolioPerformance)).call(this, props));

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.getInfo = function () {
      var infos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var formatter = function formatter(value) {
        if (value == 0) return "0.00";
        if (!value) return "--";
        var _value = value;

        var result = (Math.floor(Math.abs(value) * 100) / 100).toFixed(2);
        var flag = result != 0 ? _value < 0 ? "-" : "" : "";
        return "" + flag + result;
      };
      var day = '--';
      if (infos.navActualDate) {
        var date = new Date(infos.navActualDate);
        day = date.getMonth() + 1 + "." + date.getDate();
      }

      return {
        incomeRateList: [[[__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.dayGains), "\u65E5\u6DA8\u8DCC\u5E45 (" + day + ")"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.hisAnnualizedGains), "成立以来年化"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.gains), "成立以来涨跌幅"]], [[__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.monthGains), "近一月涨跌幅"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.month3Gains), "近三月涨跌幅"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.month6Gains), "近六月涨跌幅"]], [[__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.yearGains), "近一年涨跌幅"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.thisYearGains), "今年以来涨跌幅"]]],
        riskIndex: [[[__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.hisMaxRetreat), "组合最大回撤"], [__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.maxRetreat), "近一年最大回撤"]], [[__WEBPACK_IMPORTED_MODULE_3__util_js___default.a.toPercent(infos.hisAnnualizedVolatility), "年化波动率"], [formatter(infos.hisSharpeRate), "夏普比率"]]]
      };
    };

    _this.state = {};
    return _this;
  }

  _createClass(PortfolioPerformance, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.title = "组合表现";
      var _props = this.props,
          dispatch = _props.dispatch,
          location = _props.location;

      var params = {
        superFundCode: location.state.superFundCode,
        periodType: 1
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_portfolioAction__["a" /* getSuperFundProductIncome */])(params));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "container PPF_container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NHeader_js__["a" /* default */], { title: "\u7EC4\u5408\u8868\u73B0", isPaddingBottom: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "PPF_content" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Performance_js__["a" /* default */], { title: "\u4E1A\u7EE9\u8868\u73B0", background: true, style: { borderRadius: '.2rem .2rem 0 0', marginBottom: '.2rem' }, renderDOM: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__InfoTable_js__["a" /* default */], { cols: 3, dataSouse: this.getInfo(this.props).incomeRateList, valueStyle: { fontSize: '.32rem' } }) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Performance_js__["a" /* default */], { title: "\u4E1A\u7EE9\u8D70\u52BF", style: { marginBottom: '.2rem' }, renderDOM: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LineEchartPerformanceTrends_js__["a" /* default */], null) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Performance_js__["a" /* default */], {
            title: "\u98CE\u9669\u6307\u6807",
            renderDOM: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { style: { margin: "0 -.3rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__InfoTable_js__["a" /* default */], { cols: 2, dataSouse: this.getInfo(this.props).riskIndex, valueStyle: { fontSize: '.32rem' } })
            )
          })
        )
      );
    }
  }]);

  return PortfolioPerformance;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return Object.assign({}, state.superFundProductIncomes);
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* withRouter */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PortfolioPerformance)));

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NHeader__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PositionList__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__positiondetails_css__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__positiondetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__positiondetails_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PositionDetails = function (_React$Component) {
  _inherits(PositionDetails, _React$Component);

  function PositionDetails(props) {
    _classCallCheck(this, PositionDetails);

    var _this = _possibleConstructorReturn(this, (PositionDetails.__proto__ || Object.getPrototypeOf(PositionDetails)).call(this, props));

    _this.toPublicOffering = function (item) {
      if (item.camcOrNonCamcWhiteListFundFlag === "0") return __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("该产品暂不支持交易", __WEBPACK_IMPORTED_MODULE_3__util__["ToastTime"]);
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({ pathname: "/PublicOffering", query: { fundCode: item.fundCode }, state: { fundCode: item.fundCode } });
    };

    _this.renderItem = function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: item.fundCode, className: "PD_list_item", onClick: function onClick() {
            _this.toPublicOffering(item);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          item.fundName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          item.fundCode
        )
      );
    };

    _this.header = function (v) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "PD_Pie_header", style: { background: __WEBPACK_IMPORTED_MODULE_3__util___default.a.pieEchartsFundListColorMap.get(v.styleTypeName) } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "PD_Pie_title" },
          v.styleTypeName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "PD_pie_totlevalue" },
          __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(v.totalRate)
        )
      );
    };

    return _this;
  }

  _createClass(PositionDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.title = "持仓明细";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props$location$state = this.props.location.state,
          _props$location$state2 = _props$location$state.superFundItemFund4StyleTypeList,
          superFundItemFund4StyleTypeList = _props$location$state2 === undefined ? [] : _props$location$state2,
          updateTimeStr = _props$location$state.updateTimeStr;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "PD_container", style: { minHeight: window.winHeight, background: "#fff url(" + __webpack_require__(669) + ") no-repeat 0 0/100% auto" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NHeader__["a" /* default */], { title: "\u6301\u4ED3\u660E\u7EC6" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "PD_list" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "PD_list_header" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { className: "PD_list_title" },
              "\u7B56\u7565\u6301\u4ED3"
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              "\u66F4\u65B0\u65F6\u95F4\uFF1A",
              updateTimeStr
            )
          ),
          superFundItemFund4StyleTypeList.map(function (v, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PositionList__["a" /* default */], { key: i, background: __WEBPACK_IMPORTED_MODULE_3__util___default.a.pieEchartsFundListBgColorMap.get(v.styleTypeName), header: _this2.header(v), renderItem: _this2.renderItem, dataSource: v.subSuperFundItemList, topDistance: ".22rem", bottomDistance: ".22rem" });
          })
        )
      );
    }
  }]);

  return PositionDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (PositionDetails);

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NHeader__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PositionList__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__targetProfitHaveCast_css__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__targetProfitHaveCast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__targetProfitHaveCast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PositionDetails = function (_React$Component) {
  _inherits(PositionDetails, _React$Component);

  function PositionDetails(props) {
    _classCallCheck(this, PositionDetails);

    var _this = _possibleConstructorReturn(this, (PositionDetails.__proto__ || Object.getPrototypeOf(PositionDetails)).call(this, props));

    _this.toPublicOffering = function (item) {
      if (item.camcOrNonCamcWhiteListFundFlag === "0") return __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("该产品暂不支持交易", __WEBPACK_IMPORTED_MODULE_3__util__["ToastTime"]);
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].push({ pathname: "/PublicOffering", query: { fundCode: item.fundCode }, state: { fundCode: item.fundCode } });
    };

    _this.renderItem = function (item) {
      var currentNavDate = new Date(item.currentNavDateDesc);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { key: item.fundCode, className: "PDH_item", style: { padding: "0 .3rem" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { padding: ".3rem 0" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "style_flex_row_between style_sm_font style_font_weight", style: { marginBottom: ".3rem" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              null,
              item.fundName,
              "-",
              item.fundCode
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "span",
              { style: { color: "#B69271" } },
              "\u5360\u6BD4: ",
              __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(item.rate)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "style_flex_row_between style_sm_font" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_left_align" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "style_color_neutral", style: { marginBottom: ".06rem" } },
                "\u6301\u6709\u91D1\u989D"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "style_font_weight" },
                item.amount.toFixed(2)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_center_align" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "style_color_neutral", style: { marginBottom: ".06rem" } },
                "\u53EF\u7528\u4EFD\u989D"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "style_font_weight" },
                item.realBalance.toFixed(2)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_right_align" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "style_color_neutral", style: { marginBottom: ".06rem" } },
                currentNavDate.getMonth() + 1,
                ".",
                currentNavDate.getDate(),
                "\u51C0\u503C"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "style_font_weight" },
                item.currentNav.toFixed(4)
              )
            )
          )
        )
      );
    };

    _this.header = function (v) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "style_flex_row_between", style: { padding: ".1rem .3rem", background: __WEBPACK_IMPORTED_MODULE_3__util___default.a.pieEchartsFundListColorMap.get(v.styleTypeName) } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "style_md_white_font style_font_weight", style: { color: "#3C3C3C" } },
          v.styleTypeName
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          { className: "style_sm_font style_color_light" },
          "\u5171\u5360\u6BD4",
          __WEBPACK_IMPORTED_MODULE_3__util___default.a.toPercent(v.totalRate)
        )
      );
    };

    return _this;
  }

  _createClass(PositionDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.title = "持仓明细";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props$location$state = this.props.location.state.fundItems,
          fundItems = _props$location$state === undefined ? [] : _props$location$state;

      console.log("this.props.location", this.props.location);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "PD_container", style: { minHeight: window.winHeight, background: "#fff url(" + __webpack_require__(669) + ") no-repeat 0 0/100% auto" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__NHeader__["a" /* default */], { title: "\u6301\u4ED3\u660E\u7EC6" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "PD_list" },
          fundItems.map(function (v, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PositionList__["a" /* default */], { key: i, background: __WEBPACK_IMPORTED_MODULE_3__util___default.a.pieEchartsFundListBgColorMap.get(v.styleTypeName), header: _this2.header(v), renderItem: _this2.renderItem, dataSource: v.superFundItemShareList });
          })
        )
      );
    }
  }]);

  return PositionDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (PositionDetails);

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceReport_css__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceReport_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ServiceReport_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_ServiceReportAction__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NHeader_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ServiceReport = function (_Component) {
  _inherits(ServiceReport, _Component);

  function ServiceReport(props) {
    _classCallCheck(this, ServiceReport);

    return _possibleConstructorReturn(this, (ServiceReport.__proto__ || Object.getPrototypeOf(ServiceReport)).call(this, props));
  }

  _createClass(ServiceReport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var param = {
        superFundCode: this.props.location.state.superFundCode,
        pageNum: 1,
        pageSize: 10
      };
      this.props.location.state.hasQuarterly ? dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_ServiceReportAction__["c" /* getServiceReportListHasQuarterly */])(param)) : dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_ServiceReportAction__["d" /* getServiceReportList */])(param));
      document.title = '投顾服务报告';
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_ServiceReportAction__["e" /* serviceReporListDel */])());
    }
  }, {
    key: "getMore",
    value: function getMore() {
      var _props = this.props,
          dispatch = _props.dispatch,
          serviceReportList = _props.serviceReportList;

      if (serviceReportList.total === serviceReportList.data.length) return;
      var param = {
        superFundCode: this.props.location.state.superFundCode,
        pageNum: serviceReportList.pageNum + 1,
        pageSize: 10
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_ServiceReportAction__["d" /* getServiceReportList */])(param));
    }
  }, {
    key: "goBack",
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var serviceReportList = this.props.serviceReportList;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "container SR_wrap", style: { display: "flex", maxHeight: document.documentElement.clientHeight /*  window.screen.height */ } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NHeader_js__["a" /* default */], { title: "\u6295\u987E\u670D\u52A1\u62A5\u544A", isPaddingBottom: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_con_wrap" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "SR_content" },
            this.props.location.state.hasQuarterly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_data" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "p",
                null,
                "Hi\uFF0C\u5DF2\u4E3A\u60A8\u670D\u52A1",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "span",
                  { className: "SR_days" },
                  this.props.location.state.serveDays
                ),
                "\u5929"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              ScrollView,
              { moreEvent: this.getMore.bind(this) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "SR_list", style: {} },
                Object.entries(serviceReportList.processData).map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemList, { token: _this2.props.location.state.token, date: item[0], dataList: item[1], key: item[0] });
                })
              )
            )
          )
        )
      );
    }
  }]);

  return ServiceReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    serviceReportList: state.serviceReportReducer.serviceReportList
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ServiceReport));

var Item = function (_Component2) {
  _inherits(Item, _Component2);

  function Item() {
    var _ref;

    var _temp, _this3, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this3), _this3.toRecentNewsDetail = function (v) {
      console.log(v);
      if (v.monthReportToPortal && _this3.props.token) {
        var fundCode = v.monthReportToPortal.monthReportTemplate.fundCode;
        var year = v.monthReportToPortal.monthReportTemplate.year;
        var month = v.monthReportToPortal.monthReportTemplate.month;
        var token = _this3.props.token;
        var _url = year > 2020 ? "NewQuarterlyReport/index.html?device=h5&token=" : "QuarterlyReport/index.html?device=h5&token=";
        var _urlSec = _url + token + "&fundCode=" + fundCode + "&month=" + month + "&year=" + year;
        // window.open("http://10.16.160.74/monthReport/" + _urlSec); //测试
        window.open("https://app.amcfortune.com/wAppStatic/" + _urlSec); //生产
      } else {
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/ServiceReportDetail",
          state: { id: v.id },
          query: { id: v.id }
        });
      }
    }, _temp), _possibleConstructorReturn(_this3, _ret);
  }

  _createClass(Item, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var data = this.props.data;

      var type = ["投顾服务报告", "投顾服务报告", "投顾季报"];
      var intro = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "SR_item_intro" },
        data.overView
      )];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "SR_item_con", onClick: function onClick() {
            _this4.toRecentNewsDetail(data);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_item_tip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            type[data.type]
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            null,
            data.newsTime
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_item_title" },
          data.title
        ),
        intro[0]
      );
    }
  }]);

  return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ItemList = function (_Component3) {
  _inherits(ItemList, _Component3);

  function ItemList() {
    _classCallCheck(this, ItemList);

    return _possibleConstructorReturn(this, (ItemList.__proto__ || Object.getPrototypeOf(ItemList)).apply(this, arguments));
  }

  _createClass(ItemList, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          dataList = _props2.dataList,
          date = _props2.date;

      var lineHeight = this.props.dataList.length * 1.94 + this.props.dataList.length * 0.2 + "rem";
      var month = parseInt(date.slice(5, 7));
      var day = date.slice(8);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "RS_Item", style: { marginTop: "-.1rem" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Item_data" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "Item_data_day" },
            day
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "Item_data_m" },
            month,
            "\u6708"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "Item_line" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "Item_line_circle" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "Item_line_line", style: { height: lineHeight } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_item_list", style: { marginTop: "-.18rem" } },
          dataList.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item, { token: _this6.props.token, data: item, key: item.id });
          })
        )
      );
    }
  }]);

  return ItemList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ScrollView = function (_PureComponent) {
  _inherits(ScrollView, _PureComponent);

  function ScrollView() {
    _classCallCheck(this, ScrollView);

    return _possibleConstructorReturn(this, (ScrollView.__proto__ || Object.getPrototypeOf(ScrollView)).apply(this, arguments));
  }

  _createClass(ScrollView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this8 = this;

      var node = document.querySelector("#scroll");
      node.addEventListener("scroll", function () {
        var scrollBottom = node.scrollHeight - node.scrollTop - node.clientHeight;
        console.log(document.documentElement.scrollTop); //代表目前滚动条和最上方的距离多长
        console.log(document.documentElement.scrollHeight); //代表整个滚动条多长
        console.log(document.documentElement.clientHeight);
        console.log("-----", scrollBottom, node.scrollHeight, node.scrollTop, node.clientHeight);
        if (scrollBottom < 0.5) _this8.props.moreEvent();
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "scroll", style: { height: "auto", overflowY: "scroll" } },
        this.props.children
      );
    }
  }]);

  return ScrollView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServiceReport_css__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServiceReport_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ServiceReport_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_ServiceReportAction__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ServiceReportDetail = function (_PureComponent) {
  _inherits(ServiceReportDetail, _PureComponent);

  function ServiceReportDetail(props) {
    _classCallCheck(this, ServiceReportDetail);

    var _this = _possibleConstructorReturn(this, (ServiceReportDetail.__proto__ || Object.getPrototypeOf(ServiceReportDetail)).call(this, props));

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    };

    _this.typeComponents = {
      notice: function notice() {
        var serviceReporDetail = _this.props.serviceReporDetail;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_con_wrap", style: { maxHeight: document.documentElement.clientHeight /*  window.screen.height */ } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_header", style: { height: "1.82rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "SR_header_con", style: { paddingBottom: ".22rem" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "SR_goback_btn", onClick: _this.goBack },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(430) })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "SR_header_tit" },
                  "\u516C\u544A\u8BE6\u60C5"
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { flex: "auto", overflowY: "scroll" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_detail_tit" },
              serviceReporDetail.title
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_detail_date" },
              "\u534E\u590F\u8D22\u5BCC ",
              serviceReporDetail.newsTime && serviceReporDetail.newsTime.slice(5)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_detail_con" },
              serviceReporDetail.detail
            )
          )
        );
      },
      weekly: function weekly() {
        var imgUrl = "" + __WEBPACK_IMPORTED_MODULE_6__util___default.a.imgUrl + _this.props.serviceReporDetail.detail;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_con_wrap", style: { maxHeight: document.documentElement.clientHeight /*  window.screen.height */ } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_header", style: { height: "1.82rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "SR_header_con", style: { paddingBottom: ".22rem" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "SR_goback_btn", onClick: _this.goBack },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(430) })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "SR_header_tit" },
                  "\u5468\u62A5\u8BE6\u60C5"
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: imgUrl, style: { width: "100%" } })
        );
      },
      quarterly: function quarterly() {
        // return <div style={{ textAlign: "center", paddingTop: "2rem" }}>季报</div>;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "SR_con_wrap", style: { maxHeight: document.documentElement.clientHeight /*  window.screen.height */ } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__NavigatorMain__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "SR_header", style: { height: "1.82rem" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "div",
                { className: "SR_header_con", style: { paddingBottom: ".22rem" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "SR_goback_btn", onClick: _this.goBack },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(430) })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "div",
                  { className: "SR_header_tit" },
                  "\u5B63\u62A5\u8BE6\u60C5"
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            "\u5B63\u62A5"
          )
        );
      }
    };
    return _this;
  }

  _createClass(ServiceReportDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var typeDetail = ["notice", "weekly", "quarterly"];
      var titleType = {
        notice: "公告详情",
        weekly: "周报详情",
        quarterly: "季报详情"
      };
      document.title = titleType[typeDetail[this.props.location.state.detailType]];

      var dispatch = this.props.dispatch;

      var param = { id: this.props.location.state.id };
      param.id !== "null" && dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_ServiceReportAction__["a" /* getServiceReportDetail */])(param));
      param.id === "null" && dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_ServiceReportAction__["b" /* serviceReporDetailDel */])());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var dispatch = this.props.dispatch;

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_ServiceReportAction__["b" /* serviceReporDetailDel */])());
    }
  }, {
    key: "render",
    value: function render() {
      var typeDetail = ["notice", "weekly", "quarterly"];
      var serviceReporDetail = this.props.serviceReporDetail;

      document.title = serviceReporDetail && serviceReporDetail.type == 0 ? '公告详情' : serviceReporDetail && serviceReporDetail.type == 1 ? '周报详情' : serviceReporDetail && serviceReporDetail.type == 1 ? '季报详情' : '投顾服务报告';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "container", style: { maxHeight: document.documentElement.clientHeight, background: "#fff" } },
        serviceReporDetail && this.typeComponents[typeDetail[serviceReporDetail.type] || "quarterly"]()
      );
    }
  }]);

  return ServiceReportDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

function mapStateToProps(state, ownProps) {
  return {
    serviceReporDetail: state.serviceReportReducer.serviceReporDetail
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(ServiceReportDetail));

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NHeaderjiaoyijilu__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_Transferrecord_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_Transferrecord_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_Transferrecord_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//服务费收取明细











var Servicechargerecord = function (_Component) {
  _inherits(Servicechargerecord, _Component);

  function Servicechargerecord(props) {
    _classCallCheck(this, Servicechargerecord);

    var _this2 = _possibleConstructorReturn(this, (Servicechargerecord.__proto__ || Object.getPrototypeOf(Servicechargerecord)).call(this, props));

    _this2.getNum = function (num1, num2) {
      if (num1 === null && num2 === null) {
        return null;
      } else if (num1 === null) {
        return num2 + '份';
      } else if (num2 === null) {
        return num1 + '元';
      } else if (num1 == num2) {
        return num1 + '元';
      } else {
        return null;
      }
    };

    _this2.state = {
      loadingFlag: false,
      xinxi: []
    };
    return _this2;
  }

  _createClass(Servicechargerecord, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var _this = this;
      var data1 = {
        tradeRequestId: this.props.location.state.tradeRequestId
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_77" /* ztcgjiaoyijiluxiangqing */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      console.log(data);
      this.setState({
        xinxi: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var xinxi = this.state.xinxi;

      console.log(xinxi);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wrap' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u4EA4\u6613\u8BE6\u60C5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'NHeader_share' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'jiaoyixiangqing' },
          xinxi.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index, className: 'jiaouyixiangqingtopfuwufei' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaouyixiangqingtop2top' },
                  '\u670D\u52A1\u8D39\u91D1\u989D'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  item.confirmAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmAmount) + "元" : "--"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaouyixiangqingtop2top' },
                  '\u6536\u8D39\u4EA7\u54C1'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaouyixiangqingtop2bottom' },
                  item.fundName ? item.fundName : "--"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaouyixiangqingtop2top' },
                  '\u6536\u8D39\u65F6\u95F4'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  item.confirmDateStr || '--'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaouyixiangqingtop2top' },
                  '\u6240\u5C5E\u6295\u987E\u4EA7\u54C1'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  item.targetFundName || '--'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaouyixiangqingtop2top' },
                  '\u652F\u4ED8\u6E20\u9053'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'text',
                  { style: { color: "#333333" } },
                  item.trustChannelName || '--'
                )
              )
            );
          })
        )
      );
    }
  }]);

  return Servicechargerecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    shareToInfo: state.shareToInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Servicechargerecord));

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NHeader_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Position__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChangeFundListEntry_js__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BaseInformationGeneral__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SuperFundDetailTab__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__action_portfolioAction__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__guidePage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var SuperFundDetail = function (_Component) {
  _inherits(SuperFundDetail, _Component);

  function SuperFundDetail(props) {
    _classCallCheck(this, SuperFundDetail);

    var _this = _possibleConstructorReturn(this, (SuperFundDetail.__proto__ || Object.getPrototypeOf(SuperFundDetail)).call(this, props));

    _this.goDT = function () {
      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_16__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      var dispatch = _this.props.dispatch;
      var _this$state = _this.state,
          superFundCode = _this$state.superFundCode,
          superFundName = _this$state.superFundName;

      var params = {
        fundCode: superFundCode,
        fundName: superFundName,
        isShowModal: true, //首次购买弹窗标识
        productType: "Z",
        pageText: "新建定投计划",
        superTypeValue: "0"
      };
      var fun = function fun() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["r" /* getPayAllSuper */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["a" /* goLogin */])(fun, window.history.length, { isInvestmentAdvisory: _this.state.isInvestmentAdvisory, fundCode: superFundCode, fundName: superFundName, enterType: _this.props.location.query.enterType });
    };

    _this.state = {
      dataval: null,
      buyStatus: false,
      planBuyStatus: false,
      superFundCode: "",
      superFundName: "",
      superData: "",
      isInvestmentAdvisory: false
    };
    return _this;
  }

  _createClass(SuperFundDetail, [{
    key: "componentWillMount",
    value: function componentWillMount() {}
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.location.search.indexOf('appInvestmentAdvisory') !== -1) {
        this.setState({ isInvestmentAdvisory: true });
      }
      document.title = "策略详情";
      this.setState({
        superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
        superFundName: this.props.location.state ? this.props.location.state.superFundName : this.props.location.query.superFundName
      });
      var objVal = {
        superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
        stopProfit: false
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_investmentAction__["_85" /* verifyActivityBool */])(objVal, function (result) {
        _this2.setState({
          buyStatus: result.buyStatus,
          planBuyStatus: result.planBuyStatus
        });
        console.log(result);
      }));
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__action_portfolioAction__["i" /* getStrategiesDetails */])({
        superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode
      }, function (val) {
        _this2.setState({ superData: val });
      }));
      var params = {
        superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode,
        periodType: 1
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__action_portfolioAction__["a" /* getSuperFundProductIncome */])(params));
      document.body.scrollTo(0, 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_17__guidePage__["b" /* default */].leave();
    }
  }, {
    key: "goInvesting",
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isMiniProgram, route, dispatch, _state, superFundCode, superFundName, data, fun;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_16__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                __WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib__["Toast"].loading('', 0);
                route = window.history.length;
                dispatch = this.props.dispatch;
                _state = this.state, superFundCode = _state.superFundCode, superFundName = _state.superFundName;
                data = {
                  superFundCode: superFundCode
                };

                fun = function fun() {
                  var params = {
                    fundCode: superFundCode,
                    fundName: superFundName,
                    isShowModal: true, //首次购买弹窗标识
                    productType: "Z",
                    pageText: "申购",
                    superTypeValue: "0"
                  };
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["r" /* getPayAllSuper */])(route, params, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["a" /* goLogin */])(fun, window.history.length, { isInvestmentAdvisory: this.state.isInvestmentAdvisory, fundCode: superFundCode, fundName: superFundName, enterType: this.props.location.query.enterType });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function goInvesting() {
        return _ref.apply(this, arguments);
      }

      return goInvesting;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _ref6;

      var _state2 = this.state,
          buyStatus = _state2.buyStatus,
          planBuyStatus = _state2.planBuyStatus,
          superData = _state2.superData;
      var _props = this.props,
          dataval = _props.dataval,
          manageFeeRate = _props.manageFeeRate,
          minLimit = _props.minLimit;

      var tradeDateString = dataval ? dataval.tradeDateString : "";
      var buyConfirmDate = dataval ? dataval.buyConfirmDate.slice(5) + "(" + dataval.buyConfirmWeek + ")" : "";
      var buyIncomeDate = dataval ? dataval.buyIncomeDate.slice(5) + "(" + dataval.buyIncomeWeek + ")" : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "container" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__NHeader_js__["a" /* default */], { title: "\u7B56\u7565\u8BE6\u60C5", isPaddingBottom: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "content", id: "SuperFundDetailIndex", style: { paddingTop: "0px", display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'scroll' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__BaseInformationGeneral__["a" /* default */], { superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode, superFundName: this.props.location.state ? this.props.location.state.superFundName : this.props.location.query.superFundName }),
          this.props.hasOneYear && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SuperFundDetailTab__["a" /* default */], { superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Position__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ChangeFundListEntry_js__["a" /* default */], { superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { padding: "0 .1rem" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/JaoYi",
                    state: { dispatch: _this3.props.dispatch, fundCode: _this3.props.location.state ? _this3.props.location.state.superFundCode : _this3.props.location.query.superFundCode }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.3rem", paddingTop: "0.3rem", paddingBottom: "0.3rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u4EA4\u6613\u89C4\u5219"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" } },
                "\u66F4\u591A",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", color: "gray", fontSize: "0.2rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem" } },
                  "\u8F6C\u5165\u7533\u8BF7"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(164), style: { width: "0.2rem", height: "0.2rem" } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem" } },
                  "\u5F00\u59CB\u786E\u8BA4\u4EA4\u6613"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(164), style: { width: "0.2rem", height: "0.2rem" } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem" } },
                  "\u67E5\u770B\u6536\u76CA"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(164), style: { width: "0.2rem", height: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { display: "flex", paddingLeft: "0.75rem", paddingRight: "0.75rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", fontSize: "0.2rem", color: "#818597" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { flex: 1, textAlign: "left" } },
                tradeDateString
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { flex: 1, textAlign: "center" } },
                buyConfirmDate
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { flex: 1, textAlign: "right" } },
                buyIncomeDate
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem", color: "gray", fontSize: "0.2rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.2rem", paddingBottom: "0.2rem", paddingLeft: "0.2rem", border: "0.02rem solid #D6DAE4", color: "#D6DAE4", backgroundColor: "#F6F7FA", flex: 1, borderRadius: "0.1rem" } },
                "* \u5B9E\u9645\u786E\u8BA4\u91D1\u989D\u548C\u67E5\u770B\u76C8\u4E8F\u7684\u65F6\u95F4\u4EE5\u57FA\u91D1\u516C\u53F8\u4E3A\u51C6"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/FeiL",
                    state: {
                      manageFeeRate: manageFeeRate
                    }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.2rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u8D39\u7528\u8BF4\u660E"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem", paddingTop: "0.3rem" } },
                "\u66F4\u591A",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.28rem", lineHeight: "0.4rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem" } },
                "1\u3001\u6295\u987E\u670D\u52A1\u8D39\uFF1A\u672C\u7EC4\u5408\u4EE5\u5BA2\u6237\u8D26\u6237\u8D44\u4EA7\u51C0\u503C",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  { style: { color: "#BF9B79" } },
                  manageFeeRate || "--"
                ),
                "\uFF08\u5E74\u5316\uFF09\u8BA1\u63D0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u3002\u6BCF\u65E5\u8BA1\u63D0\uFF0C\u6708\u5EA6\u7ED3\u7B97\u3002"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", paddingBottom: "0.3rem" } },
                "2\u3001\u7533\u8D2D\u8D39\u4E0E\u8D4E\u56DE\u8D39\uFF1A\u672C\u7EC4\u5408",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  { style: { color: "#BF9B79" } },
                  "\u4E0D\u91CD\u590D\u6536\u53D6\u7533\u8D2D\u3001\u8D4E\u56DE\u8D39\u7528"
                ),
                "\u3002\u6210\u5206\u57FA\u91D1\u7533\u8D2D\u8D39\u75280\u81F31\u6298\uFF0C\u6210\u5206\u57FA\u91D1\u8D4E\u56DE\u8D39\u7528\u6309\u7167\u57FA\u91D1\u62DB\u52DF\u8BF4\u660E\u4E66\u6536\u53D6\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  var code = superData.superFundPolicy ? superData.superFundPolicy.policy ? superData.superFundPolicy.policy : "" : "";
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/WebView",
                    state: { name: superData.superFundPolicy ? superData.superFundPolicy.policyTitle ? superData.superFundPolicy.policyTitle : "" : "", code: code },
                    query: { code: code }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u7B56\u7565\u8BF4\u660E\u4E66"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" } },
                "\u67E5\u770B",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u5E38\u89C1\u95EE\u9898"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(769), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "Q1"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem" }, "fontSize", "0.28rem") },
                "\u4EC0\u4E48\u662F\u67E5\u7406\u667A\u6295\uFF1F"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(770), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "A1"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem" }, "fontSize", "0.28rem") },
                "\u67E5\u7406\u667A\u6295\u662F\u534E\u590F\u57FA\u91D1\u501F\u52A9\u5927\u6570\u636E\u624B\u6BB5\uFF0C\u5229\u7528\u4EBA\u5DE5\u667A\u80FD\u6280\u672F\uFF0C\u501F\u52A9\u7B97\u6CD5\u548C\u6A21\u578B\u4E3A\u6295\u8D44\u8005\u5236\u5B9A\u7684\u7406\u8D22\u65B9\u6848\u3002\u67E5\u7406\u667A\u6295\u529B\u6C42\u4E3A\u4E0D\u540C\u4EBA\u751F\u9636\u6BB5\u3001\u4E0D\u540C\u98CE\u9669\u6536\u76CA\u504F\u597D\u7684\u6295\u8D44\u8005\u63D0\u4F9B\u4E2A\u6027\u5316\u7684\u6295\u987E\u670D\u52A1\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(769), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "Q2"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem" }, "fontSize", "0.28rem") },
                "\u57FA\u91D1\u6295\u987E\u548C\u57FA\u91D1\u7EC4\u5408\u6709\u4EC0\u4E48\u533A\u522B\uFF1F"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff", paddingBottom: "0.2rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(770), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "A2"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem" }, "fontSize", "0.28rem") },
                "\u76F8\u5BF9\u4E8E\u7EC4\u5408\u6765\u8BF4\uFF0C\u57FA\u91D1\u6295\u987E\u662F\u4E13\u4E1A\u6295\u987E\u56E2\u961F\u6839\u636E\u7528\u6237\u98CE\u9669\u7B49\u7EA7\u548C\u6295\u8D44\u9700\u6C42\u5B9A\u5236\u5316\u9009\u57FA\uFF0C\u5E76\u63D0\u4F9B\u81EA\u52A8\u8C03\u4ED3\uFF0C\u966A\u4F34\u670D\u52A1\u7B49\u4E00\u7AD9\u5F0F\u8D44\u4EA7\u914D\u7F6E\u670D\u52A1\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { lineHeight: "0.4rem", color: "#5A5A62", fontSize: "0.2rem", marginBottom: "0.8rem", paddingLeft: "0.2rem", paddingRight: "0.2rem", paddingBottom: "0.7rem", marginTop: "0.2rem" } },
              "\u98CE\u9669\u63D0\u793A\uFF1A\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E\u3002\u672C\u516C\u53F8\u627F\u8BFA\u4EE5\u8BDA\u5B9E\u4FE1\u7528\u3001\u52E4\u52C9\u5C3D\u8D23\u7684\u539F\u5219\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u4E3A\u6295\u8D44\u8005\u8C03\u4ED3\uFF0C\u4F46\u4E0D\u4FDD\u8BC1\u6295\u987E\u8D26\u6237\u4E00\u5B9A\u76C8\u5229\uFF0C\u4E5F\u4E0D\u4FDD\u8BC1\u6700\u4F4E\u6536\u76CA\u3002\u7EC4\u5408\u5386\u53F2\u4E1A\u7EE9\u4E0D\u4EE3\u8868\u672A\u6765\u6536\u76CA\u3002\u672C\u516C\u53F8\u63D0\u9192\u6295\u8D44\u8005\u63A5\u53D7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u7ED3\u5408\u81EA\u8EAB\u7684\u6295\u8D44\u7ECF\u5386\u3001\u98CE\u9669\u627F\u53D7\u80FD\u529B\u3001\u8D44\u4EA7\u914D\u7F6E\u9700\u8981\u4F5C\u51FA\u6295\u8D44\u51B3\u7B56\uFF0C\u6295\u987E\u8D26\u6237\u7684\u6295\u8D44\u98CE\u9669\u7531\u6295\u8D44\u8005\u81EA\u884C\u627F\u62C5\u3002\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\uFF0C\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002\u6295\u8D44\u8005\u5E94\u81EA\u884C\u9605\u8BFB\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u7B49\u4EA7\u54C1\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u81EA\u884C\u505A\u51FA\u6295\u8D44\u9009\u62E9\u3002\u57FA\u91D1\u6295\u987E\u7EC4\u5408\u53CA\u57FA\u91D1\u6295\u8D44\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\u3002"
            )
          )
        ),
        buyStatus || planBuyStatus ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { style: (_ref6 = { paddingTop: "0.12rem", paddingBottom: "0.14rem", color: "#333", display: "flex", justifyContent: "center", backgroundColor: "gray", position: "fixed", bottom: "40px", width: "100%" }, _defineProperty(_ref6, "backgroundColor", "#F6F1E9"), _defineProperty(_ref6, "fontSize", ".24rem"), _defineProperty(_ref6, "zIndex", '9999999'), _ref6) },
          minLimit != null ? minLimit : "--",
          "\u5143\u8D77\uFF0C\u6295\u987E\u8D39\u7387\uFF1A",
          manageFeeRate != null ? manageFeeRate : "--"
        ) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "FixedBottomNot" },
          planBuyStatus ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { onClick: this.goDT },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#B69271", fontSize: "0.26rem" } },
              "\u5B9A\u6295"
            )
          ) : null,
          buyStatus ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { onClick: function onClick() {
                return _this3.goInvesting();
              }, style: { backgroundColor: "#BF9B79", color: "#ffffff", fontSize: "0.26rem" } },
            "\u8F6C\u5165"
          ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { onClick: function onClick() {}, style: { backgroundColor: "#C4C4C4", color: "#ffffff", fontSize: "0.26rem" } },
            "\u5DF2\u6682\u505C\u8F6C\u5165"
          )
        )
      );
    }
  }]);

  return SuperFundDetail;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails,
      _state$strategiesDeta2 = _state$strategiesDeta.problemList,
      problemList = _state$strategiesDeta2 === undefined ? {} : _state$strategiesDeta2,
      _state$strategiesDeta3 = _state$strategiesDeta.superFundBasicInfo,
      superFundBasicInfo = _state$strategiesDeta3 === undefined ? {} : _state$strategiesDeta3,
      _state$strategiesDeta4 = _state$strategiesDeta.superFundAdjustmentVersion,
      superFundAdjustmentVersion = _state$strategiesDeta4 === undefined ? {} : _state$strategiesDeta4,
      superFundConfirmAndIncomeDate = _state$strategiesDeta.superFundConfirmAndIncomeDate,
      _state$strategiesDeta5 = _state$strategiesDeta.superFundManageRate,
      superFundManageRate = _state$strategiesDeta5 === undefined ? {} : _state$strategiesDeta5,
      _state$strategiesDeta6 = _state$strategiesDeta.superFundTradeLimit,
      superFundTradeLimit = _state$strategiesDeta6 === undefined ? {} : _state$strategiesDeta6;

  return {
    SupperFundHome: state.SupperFundHome,
    fullOneYear: superFundBasicInfo.fullOneYear,
    effectDateStr: superFundAdjustmentVersion && superFundAdjustmentVersion.effectDateStr,
    dataval: superFundConfirmAndIncomeDate,
    manageFeeRate: superFundManageRate.manageFeeRate,
    minLimit: superFundTradeLimit.minLimit,
    hasOneYear: state.superFundProductIncomes.hasOneYear
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__HOC_StateCache_js__["a" /* default */])(SuperFundDetail, 'SuperFundDetailIndex')));

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NHeader__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__targetProfitHaveCast_css__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__targetProfitHaveCast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__targetProfitHaveCast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllIncomeHaveCastLineEcharts_js__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PerformanceTrendsHaveCastLineEcharts_js__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PieEcarts__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Modal_ModalDetail__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__guidePage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var SuperFundDetailHaveCast = function (_React$PureComponent) {
  _inherits(SuperFundDetailHaveCast, _React$PureComponent);

  function SuperFundDetailHaveCast(props) {
    _classCallCheck(this, SuperFundDetailHaveCast);

    var _this = _possibleConstructorReturn(this, (SuperFundDetailHaveCast.__proto__ || Object.getPrototypeOf(SuperFundDetailHaveCast)).call(this, props));

    _this.goHistoryProfit = function () {
      var SupperFundHome = _this.props.SupperFundHome;
      var data = SupperFundHome ? _this.props.SupperFundHome.singleSuperFundViews ? _this.props.SupperFundHome.singleSuperFundViews : [] : [];
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/HistoryProfit',
        state: {
          SuperList: data
        },
        query: {
          SuperList: ""
        }
      });
    };

    _this.goDT = function () {
      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      var strategiesDetails = _this.props.strategiesDetails;

      var superFundUserShare = strategiesDetails && strategiesDetails.superFundUserShare;
      var params = {
        fundCode: superFundUserShare && superFundUserShare.superFundCode,
        fundName: superFundUserShare && superFundUserShare.superFundName,
        productType: "Z",
        pageText: "新建定投计划",
        superTypeValue: "0",
        isShowModal: false //首次购买弹窗标识
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["r" /* getPayAllSuper */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
    };

    _this.toSuperFundDetail = function () {
      var data = _this.props.strategiesDetails || {};
      var shareQueryResponse = data.superFundUserShare || {};
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/SuperFundDetail",
        state: Object.assign({}, _this.props.location.state, { superFundName: shareQueryResponse.superFundName }),
        query: Object.assign({}, _this.props.location.state, { superFundName: shareQueryResponse.superFundName })
      });
    };

    _this.showWenHaoView = function (event, val) {
      event.stopPropagation();
      if (val == "当前资产") {
        _this.setState({
          tipFlag: true,
          tsText: ["资产分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品资产，预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品资产。遇特殊情况（分红、折算等）资产可能不准确，分红、折算确认后会自动修复。"]
        });
      } else if (val == "最新收益") {
        _this.setState({
          tipFlag: true,
          tsText: ["1. 日收益分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品收益；预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品收益。遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。", "2. 货基收益预计会在次日的15点至20点更新。", "3. 非华夏基金最新净值更新后，当前资产实时计增，日收益略有延迟。", "4. 如果组合中含有沪港通等T+2日更新净值的基金，则该基金的日收益不展示在日收益中。"]
        });
      } else if (val == "累计收益") {
        _this.setState({
          tipFlag: true,
          tsText: ["1. 累计收益分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品收益；预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品收益。遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。", "2. 货基收益预计会在次日的15点至20点更新。", "3. 非华夏基金最新净值更新后，当前资产实时计增，累计收益略有延迟。", "4. 如果组合中含有沪港通等T+2日更新净值的基金，则该基金的最新收益展示在累计收益中。"]
        });
      } else if (val == "组合年化收益") {
        _this.setState({
          tipFlag: true,
          tsText: ["1. 智投组合年化收益是根据该组合的历史表现（自2019年内部构建以来）进行年化处理计算，并不代表预期收益。", "2. 组合收益信息预计在交易日的次日5点至8点更新。"]
        });
      }
    };

    _this.toggerToPrtformanceTrends = function () {
      _this.setState({ tab: 1 });
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          location = _this$props.location,
          lineData = _this$props.lineData;

      if (lineData[1]) return;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__["b" /* getUserTransactionIncomeAndProductIncome */])({
        superFundCode: _this.props.location.state.superFundCode,
        periodType: 1
      }));
    };

    _this.getAll = function () {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/ServiceReport",
        state: { superFundCode: _this.props.location.state.superFundCode, hasQuarterly: true, serveDays: _this.props.serveDays, token: _this.state.token },
        query: { superFundCode: _this.props.location.state.superFundCode, hasQuarterly: true, serveDays: _this.props.serveDays, token: _this.state.token }
      });
    };

    _this.toDetail = function () {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/PositionDetailsHavaCast',
        state: { fundItems: _this.props.fundItems },
        query: { fundItems: _this.props.fundItems }
      });
    };

    _this.toRecentNewsDetail = function (v) {
      console.log(v);
      if (v.monthReportToPortal && _this.state.token) {
        var fundCode = v.monthReportToPortal.monthReportTemplate.fundCode;
        var year = v.monthReportToPortal.monthReportTemplate.year;
        var month = v.monthReportToPortal.monthReportTemplate.month;
        var token = _this.state.token;
        var _url = year > 2020 ? "NewQuarterlyReport/index.html?device=h5&token=" : "QuarterlyReport/index.html?device=h5&token=";
        var _urlSec = _url + token + "&fundCode=" + fundCode + "&month=" + month + "&year=" + year;
        // window.open("http://10.16.160.74/monthReport/" + _urlSec); //测试
        window.open("https://app.amcfortune.com/wAppStatic/" + _urlSec); //生产
      } else {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
          pathname: "/ServiceReportDetail",
          state: { id: v.id },
          query: { id: v.id }
        });
      }
    };

    _this.state = {
      fundIsOpen: "",
      incomeDay: "--",
      dayIncomeDate: "--",
      SharpRate: "",
      Volatility: "",
      resultShow: false,
      alertContent: "",
      updateFlag: true,
      hideFlag: false,
      tabName: "配置概况",
      yearIncomeRate: "",
      ThreeIncome: "",
      singingFlag: false,
      singingFlagNext: false,
      manageFeeRate: "",
      discountRate: "",
      tipFlag: false,
      tsText: [],
      tab: 0,
      dataval: "",
      token: ""
    };
    return _this;
  }

  _createClass(SuperFundDetailHaveCast, [{
    key: "componentDidMount",
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["f" /* getSupperFundHome */])({}, function () {}, this));
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["b" /* getTempInfo */])('shortToken');

              case 3:
                token = _context.sent;

                this.setState({
                  token: token
                });
                document.body.scrollTo(0, 0);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var objVal = {
        superFundCode: this.props.location.state.superFundCode,
        stopProfit: false
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["_75" /* verifyActivityBoolHaveCast */])(objVal, function (result) {
        _this2.setState({
          buyStatus: result.buyStatus, //追加
          convertStatus: result.convertStatus, //转换
          planBuyStatus: result.planBuyStatus, //定投
          redeemStatus: result.redeemStatus //赎回
        });
        console.log(result);
      }));
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智投已投详情", "进入"]);
      var dispatch = this.props.dispatch;

      console.log(this.props, "00000");
      var superFundCode = this.props.location.query.superFundCode ? this.props.location.query.superFundCode : "SF1003";
      var len = __WEBPACK_IMPORTED_MODULE_6__util___default.a.superFundCodeArr.indexOf(superFundCode);
      document.title = __WEBPACK_IMPORTED_MODULE_6__util___default.a.superFundNameArr[len] ? __WEBPACK_IMPORTED_MODULE_6__util___default.a.superFundNameArr[len] : '策略详情';
      var data1 = { superFundCode: superFundCode };
      //查询是否开放升级功能
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["_76" /* validateSuperFundUpdate */])(data1));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__["c" /* getStrategiesDetailsHaveCast */])({
        superFundCode: this.props.location.state.superFundCode
      }, function (val) {
        _this2.setState({ dataval: val });
      }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__["d" /* getHistoryIncomeList */])({
        superFundCode: this.props.location.state.superFundCode,
        periodType: 1
      }));
    }
  }, {
    key: "goInvesting",
    value: function goInvesting() {
      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      console.log('转入');
      __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].loading('', 0);
      window._czc.push(["_trackEvent", "华夏财富H5", "智投养老已投详情", "追加投资"]);
      var _props = this.props,
          history = _props.history,
          inNeedNotice = _props.inNeedNotice,
          inNeedUpdate = _props.inNeedUpdate,
          dispatch = _props.dispatch,
          strategiesDetails = _props.strategiesDetails;

      var route = window.history.length;
      var superFundUserShare = strategiesDetails && strategiesDetails.superFundUserShare;

      if (inNeedNotice == true) {} else if (inNeedUpdate == true) {} else {
        var params = {
          fundCode: superFundUserShare && superFundUserShare.superFundCode,
          fundName: superFundUserShare && superFundUserShare.superFundName,
          productType: "Z",
          pageText: "申购",
          superTypeValue: "0",
          isShowModal: false //首次购买弹窗标识
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["r" /* getPayAllSuper */])(route, params, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
      }
    }
  }, {
    key: "RedeemSuperFund",
    value: function RedeemSuperFund(data) {
      var _this3 = this;

      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      if (!data && !this.props.InvestStopDetil) {
        //待确定
        return false;
      }
      if (data.buyFlag != true) {
        var fun = function fun() {
          __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].loading();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["q" /* hasConvertingTrade */])({
            superFundCode: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundCode : ""
          }, function () {
            __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].hide();
          }, function () {
            __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].hide();
          }).then(function (suc) {
            if (suc === true) {
              __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].show('当前智投组合有转换在途交易，该操作暂停', __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
              return;
            }

            _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__action_productAction__["i" /* choseCurrentIndex */])(0));
            _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__action_productAction__["J" /* choseCurrencyIndex */])(0));
            __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
              pathname: "/RedeemSuperFund",
              state: {
                fundCode: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundCode : "",
                fundName: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundName : "",
                cardList: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundChannelList : "",
                totalAmount: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.totalAmount : ""
              }
            });
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].hide();
            return;
          });
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["a" /* goLogin */])(fun, window.history.length);
      } else {
        __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].info("华夏智投正在调仓、赎回、申购中，无法进行此操作", __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "养老智投已投详情", "离开"]);
      __WEBPACK_IMPORTED_MODULE_21__guidePage__["b" /* default */].leave();
    }
  }, {
    key: "pushUpdate",
    value: function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isMiniProgram, dispatch, singStatus, superFundCode, targetFundList, strategiesDetails, amount, fun;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                dispatch = this.props.dispatch;
                _context2.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["p" /* querySuperFundAccAgreementStatus */])();

              case 6:
                singStatus = _context2.sent;

                if (singStatus != null && singStatus.state == 1) {
                  superFundCode = this.props.location.query.superFundCode;
                  targetFundList = this.state.dataval ? this.state.dataval.superFundUserShare.superFundChannelList : "";
                  strategiesDetails = this.props.strategiesDetails || {};
                  amount = strategiesDetails && strategiesDetails.superFundUserShare.totalAmount;

                  fun = function fun() {
                    __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].loading();
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["q" /* hasConvertingTrade */])({
                      superFundCode: superFundCode
                    }, function () {
                      __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].hide();
                    }, function () {
                      __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].hide();
                    }).then(function (suc) {
                      if (suc === true) {
                        __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].show('当前智投组合有转换在途交易，该操作暂停', __WEBPACK_IMPORTED_MODULE_6__util___default.a.ToastTime);
                        return;
                      }

                      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                        pathname: "/TransferF",
                        state: {
                          type: 1, //调整组合,
                          targetFundList: targetFundList,
                          amount: amount,
                          superFundCode: superFundCode
                        },
                        query: {
                          targetFundList: targetFundList,
                          amount: amount,
                          superFundCode: superFundCode
                        }
                      });
                    }).catch(function (err) {
                      __WEBPACK_IMPORTED_MODULE_15_antd_mobile_lib__["Toast"].hide();
                      return;
                    });
                  };

                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__getPay__["a" /* goLogin */])(fun, window.history.length);
                } else {
                  /**未签约，弹签约窗 */
                  this.setState({
                    singingFlag: true,
                    updateFlag: false
                  });
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function pushUpdate() {
        return _ref2.apply(this, arguments);
      }

      return pushUpdate;
    }()

    /**同意签约 */

  }, {
    key: "handleArgee",
    value: function handleArgee() {
      var _this4 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_investmentAction__["_74" /* signSuperFundAccAgreement */])({ state: 1, operator: "user" }, function () {
        _this4.setState({
          singingFlag: false
        }, _this4.pushUpdate());
      }));
    }
    //暂不签约

  }, {
    key: "handleDisagree",
    value: function handleDisagree() {
      this.setState({
        singingFlag: false,
        singingFlagNext: true
      });
    }
    /**返回签约页 */

  }, {
    key: "callBackQy",
    value: function callBackQy() {
      this.setState({
        singingFlag: true,
        singingFlagNext: false
      });
    }
    /**不同意签约 */

  }, {
    key: "closeDisAgreeAlert",
    value: function closeDisAgreeAlert() {
      this.setState({
        singingFlagNext: false
      });
    }
  }, {
    key: "jiaoyimingxi",
    value: function jiaoyimingxi() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/Transactionrecordztgz",
        state: {
          superFundCode: this.props.location.state.superFundCode
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var superFundCode = this.props.location.query.superFundCode;
      var data = this.props.strategiesDetails || {};
      var shareQueryResponse = data.superFundUserShare || {};

      var Amount = __WEBPACK_IMPORTED_MODULE_6__util___default.a.fomatFloat(shareQueryResponse.totalAmount);
      var superFundAccAgreementState = this.props.superFundAccAgreementState;
      var _props2 = this.props,
          totalAmount = _props2.totalAmount,
          dayIncome = _props2.dayIncome,
          allIncome = _props2.allIncome,
          annualizedGains = _props2.annualizedGains,
          operationDay = _props2.operationDay,
          serveDays = _props2.serveDays,
          _props2$recentNewsLis = _props2.recentNewsList,
          recentNewsList = _props2$recentNewsLis === undefined ? [] : _props2$recentNewsLis,
          _props2$superFundNoti = _props2.superFundNotifications,
          superFundNotifications = _props2$superFundNoti === undefined ? [] : _props2$superFundNoti,
          _props2$fundItemsUpda = _props2.fundItemsUpdateDate,
          fundItemsUpdateDate = _props2$fundItemsUpda === undefined ? "--" : _props2$fundItemsUpda,
          _props2$legendData = _props2.legendData,
          legendData = _props2$legendData === undefined ? [] : _props2$legendData,
          _props2$seriesData = _props2.seriesData,
          seriesData = _props2$seriesData === undefined ? [] : _props2$seriesData;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "container" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__NHeader__["a" /* default */], {
            title: shareQueryResponse.superFundName,
            rightContent: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_md_white_font", onClick: this.toSuperFundDetail.bind(this) },
              "\u7B56\u7565\u8BE6\u60C5"
            ),
            isPaddingBottom: 0
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "content paddB40", id: "SuperFundDetailHaveCastIndex", style: { paddingTop: 0, display: 'flex', flex: 1, overflowY: 'scroll', flexDirection: 'column' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_md_white_font style_transparent_color target_content_bg" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_column_center target_total_amount" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "tartget_total_amount_tit" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  { style: { marginRight: ".1rem" } },
                  "\u603B\u8D44\u4EA7"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
                  onClick: function onClick(event) {
                    _this5.showWenHaoView(event, "当前资产");
                  },
                  style: { width: ".24rem" },
                  src: __webpack_require__(674)
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "total_amount_font" },
                Amount
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_row_center target_info" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_average style_center_align" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { marginBottom: ".06rem" } },
                  "\u6700\u65B0\u6536\u76CA (\u5143)"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_lbg_font style_font_weight" },
                  __WEBPACK_IMPORTED_MODULE_6__util___default.a.processingDecimal(dayIncome, 2, true)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_average style_center_align" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { marginBottom: ".06rem" } },
                  "\u7D2F\u8BA1\u6536\u76CA (\u5143)"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_lbg_font style_font_weight" },
                  __WEBPACK_IMPORTED_MODULE_6__util___default.a.processingDecimal(allIncome, 2, true)
                )
              )
            ),
            superFundNotifications && !!superFundNotifications.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_sm_font style_color_light  target_notification" },
              superFundNotifications.map(function (v, i) {
                if (v.transactionType == 0) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { key: "target_notification_item1" + i, className: "target_notification_item" },
                  "\u60A8\u6709",
                  v.transactionNum,
                  "\u7B14\u8F6C\u5165",
                  v.transactionNum > 1 ? '共计' : '',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "span",
                    { className: "style_color_dark" },
                    __WEBPACK_IMPORTED_MODULE_6__util___default.a.processingDecimal(v.amount, 2) || "--"
                  ),
                  "\u5143",
                  v.confirmStatus ? '确认中' : '待确认',
                  "\uFF0C\u9884\u8BA1",
                  new Date(v.date).getMonth() + 1 + "." + new Date(v.date).getDate(),
                  "\u53EF\u67E5\u770B\u6536\u76CA"
                );
                if (v.transactionType == 1) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { key: "target_notification_item2" + i, className: "target_notification_item" },
                  "\u60A8\u6709",
                  v.transactionNum,
                  "\u7B14\u8F6C\u51FA\u4EA4\u6613",
                  v.confirmStatus ? '，成分基金将陆续确认。' : '待确认，',
                  "\u9884\u8BA1",
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "span",
                    { className: "style_color_dark" },
                    new Date(v.date).getMonth() + 1 + "." + new Date(v.date).getDate()
                  ),
                  "\u8D44\u91D1\u5230\u8D26"
                );
                if (v.transactionType == 2) return v.notifications.map(function (value, i) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { key: "target_notification_item3" + i, className: "target_notification_item" },
                    "\u8C03\u4ED3\u8FDB\u884C\u4E2D\uFF0C\u5F53\u524D\u8D44\u4EA7\u4E3A\u9884\u4F30\u8D44\u4EA7\uFF0C\u8C03\u4ED3\u7ED3\u675F\u540E\u5C55\u793A\u5B9E\u9645\u8D44\u4EA7\u3002\u9884\u8BA1",
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "span",
                      { className: "style_color_dark" },
                      new Date(value.date).getMonth() + 1 + "." + new Date(value.date).getDate(),
                      "\u8C03\u4ED3\u7ED3\u675F"
                    )
                  );
                });
                if (v.transactionType == 3) return v.notifications.map(function (value, i) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { key: "target_notification_item4" + i, className: "target_notification_item" },
                    "\u9884\u8BA1",
                    v.fundName,
                    "\uFF08",
                    value.fundCode,
                    "\uFF09\u5728",
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "span",
                      { className: "style_color_dark" },
                      new Date(value.date).getMonth() + 1 + "-" + new Date(value.date).getDate()
                    ),
                    "\u6709\u5206\u7EA2\uFF0C\u5C4A\u65F6\u8D44\u4EA7\u548C\u6536\u76CA\u4E0D\u51C6\u786E\uFF0C\u5206\u7EA2\u6298\u7B97\u786E\u8BA4\u540E\u4F1A\u81EA\u52A8\u4FEE\u590D"
                  );
                });
              })
            ),
            recentNewsList && !!recentNewsList.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "tartget_news_list" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_row_center target_serve_day_wrap", onClick: this.getAll },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "tartget_serve_day" },
                  "Hi\uFF0C\u5DF2\u4E3A\u60A8\u670D\u52A1",
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "span",
                    { style: { color: "#B69271" } },
                    serveDays || "--"
                  ),
                  "\u5929"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(387) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_row_center target_info_list" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_flex_row_center", style: { marginRight: ".3rem", justifyContent: "flex-start" } },
                  recentNewsList.map(function (v, i) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { key: i, className: "tartget_news_item", onClick: function onClick() {
                          return _this5.toRecentNewsDetail(v);
                        } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "style_font_weight style_overflow_ellipsis", style: { marginBottom: ".1rem" } },
                        v.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "style_sm_font", style: { color: "#875426" } },
                        v.newsTime
                      )
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_row_center target_mingxi" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_flex_row_center", onClick: this.goHistoryProfit },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".64rem", marginRight: ".1rem" }, src: __webpack_require__(673) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_md_white_font style_color_dark" },
                "\u6536\u76CA\u660E\u7EC6"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_flex_row_center", onClick: function onClick() {
                  return _this5.jiaoyimingxi();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".64rem", marginRight: ".1rem" }, src: __webpack_require__(670) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_md_white_font style_color_dark" },
                "\u4EA4\u6613\u660E\u7EC6"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { padding: " .4rem", background: "#fff", marginBottom: ".2rem" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_md_white_font style_color_neutral line_echarts_btn", style: { marginBottom: ".3rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                {
                  onClick: function onClick() {
                    _this5.setState({ tab: 0 });
                  },
                  className: "style_flex_column_center " + (this.state.tab == 0 && "style_bg_font style_color_dark style_font_weight tab_underline")
                },
                "\u7D2F\u8BA1\u76C8\u4E8F"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { onClick: this.toggerToPrtformanceTrends.bind(this), className: "style_flex_column_center " + (this.state.tab == 1 && "style_bg_font style_color_dark style_font_weight tab_underline") },
                "\u4E1A\u7EE9\u8D70\u52BF"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              null,
              this.state.tab == 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AllIncomeHaveCastLineEcharts_js__["a" /* default */], null),
              this.state.tab == 1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PerformanceTrendsHaveCastLineEcharts_js__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "target_pie_echarts" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_row_between" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_bg_font style_color_dark style_font_weight" },
                "\u6211\u7684\u6301\u4ED3"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_md_white_font style_color_light" },
                "\u6301\u4ED3\u6570\u636E\u4EC5\u542B\u53EF\u7528\u4EFD\u989D\uFF0C\u4E0D\u542B\u51BB\u7ED3\u4EFD\u989D"
              )
            ),
            legendData.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PieEcarts__["a" /* default */], { height: "2.8rem", legendData: legendData, seriesData: seriesData }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".4rem", paddingBottom: ".4rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: "4.14rem", height: "2.52rem" }, src: __webpack_require__(775) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "text",
                { style: { fontSize: ".28rem", lineHeight: ".4rem" } },
                "\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E"
              )
            ),
            legendData.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_sm_font style_center_align target_detail", onClick: this.toDetail },
              "\u67E5\u770B\u8BE6\u7EC6\u6301\u4ED3",
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(273) })
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_row_center target_kefu" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "a",
              { href: "tel:4008175666", className: "style_sm_font style_flex_row_center", style: { flex: 1, justifyContent: 'space-between' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_flex_row_center " },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".48rem", marginRight: ".16rem" }, src: __webpack_require__(671) }),
                "\u667A\u80FD\u5BA2\u670D"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(387) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_sm_font style_color_light target_tip" },
            "\u98CE\u9669\u63D0\u793A",
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "span",
              null,
              "\uFF1A"
            ),
            "\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E\u3002\u672C\u516C\u53F8\u627F\u8BFA\u4EE5\u8BDA\u5B9E\u4FE1\u7528\u3001\u52E4\u52C9\u5C3D\u8D23\u7684\u539F\u5219\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u4E3A\u6295\u8D44\u8005\u8C03\u4ED3\uFF0C\u4F46\u4E0D\u4FDD\u8BC1\u6295\u987E\u8D26\u6237\u4E00\u5B9A\u76C8\u5229\uFF0C\u4E5F\u4E0D\u4FDD\u8BC1\u6700\u4F4E\u6536\u76CA\u3002\u7EC4\u5408\u5386\u53F2\u4E1A\u7EE9\u4E0D\u4EE3\u8868\u672A\u6765\u6536\u76CA\u3002\u672C\u516C\u53F8\u63D0\u9192\u6295\u8D44\u8005\u63A5\u53D7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u7ED3\u5408\u81EA\u8EAB\u7684\u6295\u8D44\u7ECF\u5386\u3001\u98CE\u9669\u627F\u53D7\u80FD\u529B\u3001\u8D44\u4EA7\u914D\u7F6E\u9700\u8981\u4F5C\u51FA\u6295\u8D44\u51B3\u7B56\uFF0C\u6295\u987E\u8D26\u6237\u7684\u6295\u8D44\u98CE\u9669\u7531\u6295\u8D44\u8005\u81EA\u884C\u627F\u62C5\u3002\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\uFF0C\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002\u6295\u8D44\u8005\u5E94\u81EA\u884C\u9605\u8BFB\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u7B49\u4EA7\u54C1\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u81EA\u884C\u505A\u51FA\u6295\u8D44\u9009\u62E9\u3002\u57FA\u91D1\u6295\u987E\u7EC4\u5408\u53CA\u57FA\u91D1\u6295\u8D44\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\u3002"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "FixedBottomHave style_bg_font style_flex_row_center style_center_align", style: { height: ".96rem", lineHeight: ".96rem", background: "#fff" } },
          this.state.convertStatus && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#B69271", background: "#fff", height: "100%", border: '1px solid #F3F3F3' }, onClick: function onClick() {
                return _this5.pushUpdate(shareQueryResponse);
              } },
            "\u8F6C\u6362"
          ),
          this.state.redeemStatus && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#B69271", background: "#fff", height: "100%", border: '1px solid #F3F3F3' }, onClick: function onClick() {
                return _this5.RedeemSuperFund(shareQueryResponse);
              } },
            "\u8F6C\u51FA"
          ),
          this.state.planBuyStatus && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#B69271", background: "#fff", height: "100%", border: '1px solid #F3F3F3' }, onClick: this.goDT },
            "\u5B9A\u6295"
          ),
          this.state.buyStatus && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#fff", background: "#BF9B79", height: "100%" }, onClick: function onClick() {
                return _this5.goInvesting(shareQueryResponse);
              } },
            "\u8F6C\u5165"
          )
        ),
        this.state.resultShow ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AlerModle__["e" /* default */], {
          content: this.state.alertContent,
          CloseAler: function CloseAler() {
            _this5.setState({ resultShow: false });
          }
        }) : null,
        this.state.singingFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AlerModle__["c" /* AlerModleQy */], { handleClick1: this.handleArgee.bind(this), handleClick2: this.handleDisagree.bind(this) }) : null,
        this.state.singingFlagNext ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AlerModle__["a" /* AlerModleCommon */], { btnTxt1: "\u8FD4\u56DE\u7B7E\u7EA6\u9875\u9762", btnTxt2: "\u77E5\u9053\u4E86\uFF0C\u6682\u4E0D\u7B7E\u7EA6", content: "根据监管要求，只能对签约的客户提供基金投顾服务。如未及时签约，华夏财富将无法再为您提供自动调仓等服务，您可选择继续持有当前份额或赎回。", title: "\u7B7E\u7EA6\u63D0\u9192", handleClick1: this.callBackQy.bind(this), handleClick2: this.closeDisAgreeAlert.bind(this) }) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Modal_ModalDetail__["a" /* default */], {
          flag: this.state.tipFlag,
          rightButtonTitle: "\u77E5\u9053\u4E86",
          content: this.state.tsText,
          onOK: function onOK() {
            _this5.setState({ tipFlag: false });
          }
        })
      );
    }
  }]);

  return SuperFundDetailHaveCast;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails,
      _state$strategiesDeta2 = _state$strategiesDeta.superFundUserShare,
      superFundUserShare = _state$strategiesDeta2 === undefined ? {} : _state$strategiesDeta2,
      _state$strategiesDeta3 = _state$strategiesDeta.recentNewsList,
      recentNewsList = _state$strategiesDeta3 === undefined ? [] : _state$strategiesDeta3,
      _state$strategiesDeta4 = _state$strategiesDeta.stopProfitOperationInfo,
      stopProfitOperationInfo = _state$strategiesDeta4 === undefined ? {} : _state$strategiesDeta4,
      _state$strategiesDeta5 = _state$strategiesDeta.superFundNotifications,
      superFundNotifications = _state$strategiesDeta5 === undefined ? [] : _state$strategiesDeta5;

  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    inNeedNotice: state.inNeedNotice,
    // InvestStopDetil: state.InvestStopDetil,
    superFundAccAgreementState: state.superFundAccAgreementState,

    strategiesDetails: state.strategiesDetails,
    totalAmount: superFundUserShare.totalAmount,
    dayIncome: superFundUserShare.dayIncome,
    allIncome: superFundUserShare.allIncome,
    annualizedGains: stopProfitOperationInfo.annualizedGains,
    recentNewsList: recentNewsList,
    superFundNotifications: superFundNotifications,
    serveDays: superFundUserShare.serveDays,
    operationDay: stopProfitOperationInfo.operationDay,
    legendData: superFundUserShare.legendData,
    seriesData: superFundUserShare.seriesData,
    fundItemsUpdateDate: superFundUserShare.fundItemsUpdateDate,
    lineData: state.lineData,
    fundItems: superFundUserShare.fundItems,
    SupperFundHome: state.SupperFundHome
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__HOC_StateCache_js__["a" /* default */])(SuperFundDetailHaveCast, 'SuperFundDetailHaveCastIndex')));

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(13);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';


/*费率介绍*/

var SuperRate = function (_Component) {
  _inherits(SuperRate, _Component);

  function SuperRate(props) {
    _classCallCheck(this, SuperRate);

    var _this = _possibleConstructorReturn(this, (SuperRate.__proto__ || Object.getPrototypeOf(SuperRate)).call(this, props));

    _this.state = {
      loadingFlag: true
    };
    return _this;
  }

  _createClass(SuperRate, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'handleCallback',
    value: function handleCallback() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isAllMonetary = this.props.location.state && this.props.location.state.isAllMonetary;
      var superFundCode = this.props.location.state && this.props.location.state.superFundCode;
      console.log(superFundCode);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } },
              ' \u8D39\u7387\u8BE6\u60C5 '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '13px' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: "#5b6370", fontSize: 16, lineHeight: "22px" } },
            '1\u3001\u7533\u8D2D\u8D39\u4E0E\u8D4E\u56DE\u8D39\uFF1A'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: "#5b6370", fontSize: 16, lineHeight: "22px" } },
            '\u672C\u7EC4\u5408\u4E0D\u91CD\u590D\u6536\u53D6\u7533\u8D2D\u8D39\u7528\u3001\u8D4E\u56DE\u8D39\u7528\u3002 \u6210\u5206\u57FA\u91D1\u7533\u8D2D\u8D39\u75280\u81F31\u6298\uFF0C\u6210\u5206\u57FA\u91D1\u8D4E\u56DE\u8D39\u7528\u6309\u7167\u57FA\u91D1\u62DB\u52DF\u8BF4\u660E\u4E66\u6536\u53D6\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: "#5b6370", fontSize: 16, lineHeight: "22px" } },
            '2\u3001\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\uFF1A'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { color: "#5b6370", fontSize: 16, lineHeight: "22px" } },
            '\u672C\u7EC4\u5408\u4EE5\u5BA2\u6237\u8D26\u6237\u8D44\u4EA7\u51C0\u503C' + (this.props.location.state && this.props.location.state.manageFeeRate ? this.props.location.state.manageFeeRate + '%' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common__["k" /* superFundCodeFee */])(superFundCode)) + '\uFF08\u5E74\u5316\uFF09\u8BA1\u63D0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u3002\u6BCF\u65E5\u8BA1\u63D0\uFF0C\u6708\u5EA6\u7ED3\u7B97\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingTop: "10px" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { style: { color: "#5b6370", fontSize: 16, lineHeight: "22px" } },
              '\u5177\u4F53\u4EE5\u7F51\u7AD9\u516C\u544A\u3001\u79FB\u52A8\u7AEF\u6295\u987E\u7EC4\u5408\u4EA7\u54C1\u9875\u9762\u6807\u8BC6\u4FE1\u606F\u4E3A\u51C6\u3002'
            )
          )
        )
      );
    }
  }]);

  return SuperRate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SuperRate);


function getFx(fundtype) {
  var touzFx = "";
  if (fundtype == "股票型" || fundtype == "指数型") {
    touzFx = "高";
  } else if (fundtype == "混合型" || fundtype == "债券型") {
    touzFx = "中";
  } else if (fundtype == "货币型" || fundtype == "理财型") {
    touzFx = "低";
  }
  return touzFx;
}

/*根据对象参数按从小到大排序*/
var compare = function compare(prop) {
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
      val1 = Number(val1);
      val2 = Number(val2);
    }
    if (val1 < val2) {
      return -1;
    } else if (val1 > val2) {
      return 1;
    } else {
      return 0;
    }
  };
};

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NHeader_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ChangeFundListEntry_js__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BaseInformationStop_js__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_portfolioAction__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StopPosition_js__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__guidePage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var TargetProfitDetail = function (_Component) {
  _inherits(TargetProfitDetail, _Component);

  function TargetProfitDetail(props) {
    _classCallCheck(this, TargetProfitDetail);

    var _this2 = _possibleConstructorReturn(this, (TargetProfitDetail.__proto__ || Object.getPrototypeOf(TargetProfitDetail)).call(this, props));

    _this2.SplitLine = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column", alignItems: "center" } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: ".06rem", height: ".06rem", border: ".02rem solid #BF9B79", borderRadius: "50%" } }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { height: ".82rem", borderLeft: ".02rem dotted #BF9B79" } })
    );

    _this2.state = {
      data: null,
      openDate: "",
      dataval: null,
      subStatus: "",
      endDate: "",
      superData: "",
      isInvestmentAdvisory: false
    };
    return _this2;
  }

  _createClass(TargetProfitDetail, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "止盈组合未投详情", "进入"]);
      var _props$location$query = this.props.location.query,
          superFundCode = _props$location$query.superFundCode,
          superFundName = _props$location$query.superFundName;

      var len = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundCodeArrByTarget.indexOf(superFundCode);

      document.title = "策略详情";
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "止盈组合未投投详情", "离开"]);
      __WEBPACK_IMPORTED_MODULE_17__guidePage__["b" /* default */].leave();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      if (this.props.location.search.indexOf('appInvestmentAdvisory') !== -1) {
        this.setState({ isInvestmentAdvisory: true });
      }
      if (this.props.location.query.inviteCode) {
        window.localStorage.setItem("inviteCode", this.props.location.query.inviteCode);
      }
      // getStorage("shortToken",function(data){console.log(data,"**shortTokenshortTokenshortToken***")})
      var dispatch = this.props.dispatch;


      var superFundCode = this.props.location.query.superFundCode ? this.props.location.query.superFundCode : "SF1003";
      var that = this;
      var data = {
        superFundCode: superFundCode
      };
      // dispatch(getSuperFoundDetail(superFundCode));
      var objVal = {
        superFundCode: superFundCode,
        stopProfit: true
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_investmentAction__["_85" /* verifyActivityBool */])(objVal, function (result) {
        console.log(result);
        _this3.setState({
          subStatus: result.subStatus,
          endDate: result.activitySuperFund ? result.activitySuperFund.endDateStr : "",
          openDate: result.activitySuperFund ? result.activitySuperFund.startDateStr : ""
        });
      }));

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction__["h" /* getStrategiesDetailsStop */])({
        superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode
      }, function (val) {
        _this3.setState({ superData: val });
      }));
      document.body.scrollTo(0, 0);
    }
  }, {
    key: "callBack",
    value: function callBack(data) {
      // document.getElementsByTagName('title')[0].innerHTML = data.productQueryResponse.superFundName
    }
  }, {
    key: "goBack",
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: "goInvesting",
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isMiniProgram, route, _props, dispatch, SuperFoundDetailXCL, superData, _this, data, fun;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_16__guidePage_index_js__["a" /* GuidePageType */].Trade);

                if (!isMiniProgram) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                route = window.history.length;
                _props = this.props, dispatch = _props.dispatch, SuperFoundDetailXCL = _props.SuperFoundDetailXCL;
                superData = this.state.superData;
                _this = this;
                data = {
                  superFundCode: _this.props.location.state ? _this.props.location.state.superFundCode : _this.props.location.query.superFundCode
                };

                fun = function fun() {
                  var params = {
                    fundCode: _this.props.location.state ? _this.props.location.state.superFundCode : _this.props.location.query.superFundCode,
                    fundName: _this.props.location.state ? _this.props.location.state.superFundName : _this.props.location.query.superFundName,
                    isShowModal: true, //首次购买弹窗标识
                    // prompt: SuperFoundDetailXCL[0].prompt,
                    policy: superData.superFundPolicy ? superData.superFundPolicy.policy ? superData.superFundPolicy.policy : "" : "",
                    policyTitle: superData.superFundPolicy ? superData.superFundPolicy.policyTitle ? superData.superFundPolicy.policyTitle : "" : "",
                    productType: "Z",
                    pageText: "无定投",
                    superTypeValue: "1"
                  };
                  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["r" /* getPayAllSuper */])(route, params, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
                };

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["a" /* goLogin */])(fun, window.history.length, { isInvestmentAdvisory: this.state.isInvestmentAdvisory, fundCode: _this.props.location.state ? _this.props.location.state.superFundCode : _this.props.location.query.superFundCode, fundName: _this.props.location.state ? _this.props.location.state.superFundName : _this.props.location.query.superFundName, enterType: this.props.location.query.enterType });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function goInvesting() {
        return _ref.apply(this, arguments);
      }

      return goInvesting;
    }()
  }, {
    key: "ok",
    value: function ok() {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/paymentSuperFund"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
          _ref6;

      var dispatch = this.props.dispatch;
      var _state = this.state,
          buyStatusDesc = _state.buyStatusDesc,
          subStatus = _state.subStatus,
          endDate = _state.endDate,
          openDate = _state.openDate,
          superData = _state.superData;
      var _props2 = this.props,
          dataval = _props2.dataval,
          manageFeeRate = _props2.manageFeeRate,
          minLimit = _props2.minLimit,
          _props2$stopProfitOpe = _props2.stopProfitOperationInfo,
          stopProfitOperationInfo = _props2$stopProfitOpe === undefined ? {} : _props2$stopProfitOpe;

      var superFundCode = this.props.location.query.superFundCode;

      var tradeDateString = dataval.tradeDateString ? dataval.tradeDateString : "";
      var buyConfirmDate = dataval.buyConfirmDate ? dataval.buyConfirmDate.slice(5) + "(" + dataval.buyConfirmWeek + ")" : "";
      var buyIncomeDate = dataval.buyIncomeDate ? dataval.buyIncomeDate.slice(5) + "(" + dataval.buyIncomeWeek + ")" : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "container" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NHeader_js__["a" /* default */], { title: "\u7B56\u7565\u8BE6\u60C5", isPaddingBottom: 0 })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "content paddB40", id: "TargetProfitDetailIndex", style: { padding: 0, display: 'flex', flex: 1, flexDirection: 'column', overflowY: 'scroll' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BaseInformationStop_js__["a" /* default */], { superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode, superFundName: this.props.location.state ? this.props.location.state.superFundName : this.props.location.query.superFundName }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__StopPosition_js__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ChangeFundListEntry_js__["a" /* default */], { superFundCode: this.props.location.state ? this.props.location.state.superFundCode : this.props.location.query.superFundCode }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { flex: "1", overflow: "auto", padding: "0 .1rem" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/BaoGao",
                    state: { superFundCode: superFundCode, dispatch: _this4.props.dispatch }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingBottom: "0.2rem", paddingTop: "0.2rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u5F80\u671F\u62A5\u544A"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u670D\u52A1\u6D41\u7A0B"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "zyztDetail_content", style: { margin: "0", height: "3.8rem", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: ".6rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { display: "flex" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { display: "flex" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    null,
                    this.SplitLine
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { style: { margin: "-.12rem .04rem 0" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { fontSize: ".22rem", lineHeight: ".32rem", color: "#999" } },
                      stopProfitOperationInfo.collectDateStr ? stopProfitOperationInfo.collectDateStr.substring(5) : ""
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { margin: ".2rem 0", textAlign: "center", width: "1.38rem", height: ".5rem", lineHeight: ".5rem", background: "rgba(91, 163, 246, 0.25)", borderRadius: ".24rem", fontSize: ".24rem", color: "#80B4EF" } },
                      "\u52DF\u96C6\u671F"
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { textAlign: "center", color: "#79A2E1", fontSize: ".24rem", lineHeight: ".34rem", fontWeight: 500 } },
                      "\u4EA7\u54C1\u52DF\u96C6"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { display: "flex" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    null,
                    this.SplitLine
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { style: { margin: "-.12rem .04rem 0" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { fontSize: ".22rem", lineHeight: ".32rem", color: "#999" } },
                      stopProfitOperationInfo.investDateStr ? stopProfitOperationInfo.investDateStr.substring(5) : ""
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { margin: ".2rem 0", textAlign: "center", width: "2.18rem", height: ".5rem", lineHeight: ".5rem", background: "rgba(255, 150, 83, 0.25)", borderRadius: ".24rem 0 0 .24rem", fontSize: ".24rem ", color: "#F09B3D" } },
                      "\u8FD0\u4F5C\u671F",
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "span",
                        { style: { color: "#9E9D9C" } },
                        "\uFF08\u4E0D\u6B62\u76C8\uFF09"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { textAlign: "center", color: "#E1AA63", fontSize: ".24rem", lineHeight: ".34rem", fontWeight: 500 } },
                      "\u4EA7\u54C1\u5F00\u59CB\u8FD0\u4F5C"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { display: "flex" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    null,
                    this.SplitLine
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { style: { margin: "-.12rem .04rem 0" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { fontSize: ".22rem", lineHeight: ".32rem", color: "#999", display: "flex", justifyContent: "space-between" } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "span",
                        null,
                        stopProfitOperationInfo.profitDateStr ? stopProfitOperationInfo.profitDateStr.substring(2) : ""
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "span",
                        null,
                        stopProfitOperationInfo.endDateStr ? stopProfitOperationInfo.endDateStr.substring(2) : ""
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { margin: ".2rem 0", textAlign: "center", width: "2.78rem", height: ".5rem", lineHeight: ".5rem", background: "#FFE3E3", borderRadius: "0  0.24rem 0.24rem 0", fontSize: ".24rem", color: "#F85B51" } },
                      "\u8FD0\u4F5C\u671F",
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "span",
                        { style: { color: "#9E9D9C" } },
                        "\uFF08\u8FBE\u6807\u5373\u6B62\u76C8\uFF09"
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { style: { textAlign: "center", color: "#F85B51", fontSize: ".24rem", lineHeight: ".34rem", fontWeight: 500 } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "p",
                        null,
                        "\u6536\u76CA\u8FBE\u5230\u5E74\u5316",
                        __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.toPercent(stopProfitOperationInfo.profitRate)
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "p",
                        null,
                        "\u89E6\u53D1\u6B62\u76C8"
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    null,
                    this.SplitLine
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { marginTop: ".3rem", paddingLeft: ".3rem", height: ".76rem", lineHeight: ".76rem", background: "#F6F7FA", border: "1PX solid #D6DAE4", borderRadius: ".2rem", fontSize: ".24rem", color: "#999" } },
                "* \u672C\u671F\u5C0F\u5E38\u4E50" + (stopProfitOperationInfo.collectEndDateStr ? new Date(stopProfitOperationInfo.collectEndDateStr).getMonth() + 1 + "\u6708" + new Date(stopProfitOperationInfo.collectEndDateStr).getDate() + "\u65E515\u70B9" : "--") + "\u7ED3\u675F\u52DF\u96C6\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/JaoYi",
                    state: { dispatch: dispatch, fundCode: _this4.props.location.state ? _this4.props.location.state.superFundCode : _this4.props.location.query.superFundCode }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem", paddingTop: "0.3rem", paddingBottom: "0.3rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u4EA4\u6613\u89C4\u5219"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" } },
                "\u66F4\u591A",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", color: "gray", fontSize: "0.24rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                  "\u8F6C\u5165\u7533\u8BF7"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(164), style: { width: "0.2rem", height: "0.2rem" } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                  "\u5F00\u59CB\u786E\u8BA4\u4EA4\u6613"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(164), style: { width: "0.2rem", height: "0.2rem" } })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { textAlign: "center" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { paddingBottom: "0.05rem", paddingTop: "0.05rem", paddingLeft: "0.1rem", paddingRight: "0.1rem", backgroundColor: "#BF9B79", color: "#ffffff", borderRadius: "0.04rem", marginBottom: "-3px" } },
                  "\u67E5\u770B\u6536\u76CA"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(164), style: { width: "0.2rem", height: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { display: "flex", paddingLeft: "0.8rem", paddingRight: "0.8rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { flex: "1", borderBottom: "0.02rem solid #D6DAE4", marginBottom: "0.03rem" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { style: { width: "0.1rem", borderRadius: "0.1rem", border: "0.02rem solid #BF9B79", height: "0.1rem" } })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", fontSize: "0.24rem", color: "#818597" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { flex: 1, textAlign: "left" } },
                tradeDateString
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { flex: 1, textAlign: "center" } },
                buyConfirmDate
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { flex: 1, textAlign: "right" } },
                buyIncomeDate
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem", color: "gray", fontSize: "0.24rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.2rem", paddingBottom: "0.2rem", paddingLeft: "0.2rem", border: "0.02rem solid #D6DAE4", color: "#D6DAE4", backgroundColor: "#F6F7FA", flex: 1, borderRadius: "0.1rem" } },
                "* \u5B9E\u9645\u786E\u8BA4\u91D1\u989D\u548C\u67E5\u770B\u76C8\u4E8F\u7684\u65F6\u95F4\u4EE5\u57FA\u91D1\u516C\u53F8\u4E3A\u51C6"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/FeiL",
                    state: {
                      manageFeeRate: manageFeeRate
                    }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u8D39\u7528\u8BF4\u660E"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem", paddingTop: "0.3rem" } },
                "\u66F4\u591A",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", fontSize: "0.28rem", lineHeight: "0.4rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem" } },
                "1\u3001\u6295\u987E\u670D\u52A1\u8D39\uFF1A\u672C\u7EC4\u5408\u4EE5\u5BA2\u6237\u8D26\u6237\u8D44\u4EA7\u51C0\u503C",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  { style: { color: "#BF9B79" } },
                  manageFeeRate || "--"
                ),
                "\uFF08\u5E74\u5316\uFF09\u8BA1\u63D0\u6295\u8D44\u987E\u95EE\u670D\u52A1\u8D39\u3002\u6BCF\u65E5\u8BA1\u63D0\uFF0C\u6708\u5EA6\u7ED3\u7B97\u3002"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", paddingBottom: "0.3rem" } },
                "2\u3001\u7533\u8D2D\u8D39\u4E0E\u8D4E\u56DE\u8D39\uFF1A\u672C\u7EC4\u5408",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  { style: { color: "#BF9B79" } },
                  "\u4E0D\u91CD\u590D\u6536\u53D6\u7533\u8D2D\u3001\u8D4E\u56DE\u8D39\u7528"
                ),
                "\u3002\u6210\u5206\u57FA\u91D1\u7533\u8D2D\u8D39\u75280\u81F31\u6298\uFF0C\u6210\u5206\u57FA\u91D1\u8D4E\u56DE\u8D39\u7528\u6309\u7167\u57FA\u91D1\u62DB\u52DF\u8BF4\u660E\u4E66\u6536\u53D6\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              {
                onClick: function onClick() {
                  var code = superData.superFundPolicy ? superData.superFundPolicy.policy ? superData.superFundPolicy.policy : "" : "";
                  __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                    pathname: "/WebView",
                    state: { name: superData.superFundPolicy ? superData.superFundPolicy.policyTitle ? superData.superFundPolicy.policyTitle : "" : "", code: code },
                    query: { code: code }
                  });
                },
                style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem", paddingTop: "0.2rem", paddingBottom: "0.2rem" }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u7B56\u7565\u8BF4\u660E\u4E66"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", color: "#999", fontSize: ".24rem" } },
                "\u67E5\u770B",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(395), style: { width: "0.2rem" } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { WebkitFlexDirection: "row", display: "-webkit-flex", WebkitJustifyContent: "space-between", WebkitAlignItems: "center", backgroundColor: "#ffffff", paddingLeft: "0.3rem", paddingRight: "0.3rem", marginTop: "0.2rem", fontSize: "0.3rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { paddingTop: "0.3rem", flex: "1", fontSize: ".32rem", fontWeight: 500, color: "#333" } },
                "\u5E38\u89C1\u95EE\u9898"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(769), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "Q1"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem" }, "fontSize", "0.28rem") },
                "\u4EC0\u4E48\u662F\u67E5\u7406\u667A\u6295\uFF1F"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(770), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "A1"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem" }, "fontSize", "0.28rem") },
                "\u67E5\u7406\u667A\u6295\u662F\u534E\u590F\u57FA\u91D1\u501F\u52A9\u5927\u6570\u636E\u624B\u6BB5\uFF0C\u5229\u7528\u4EBA\u5DE5\u667A\u80FD\u6280\u672F\uFF0C\u501F\u52A9\u7B97\u6CD5\u548C\u6A21\u578B\u4E3A\u6295\u8D44\u8005\u5236\u5B9A\u7684\u7406\u8D22\u65B9\u6848\u3002\u67E5\u7406\u667A\u6295\u529B\u6C42\u4E3A\u4E0D\u540C\u4EBA\u751F\u9636\u6BB5\u3001\u4E0D\u540C\u98CE\u9669\u6536\u76CA\u504F\u597D\u7684\u6295\u8D44\u8005\u63D0\u4F9B\u4E2A\u6027\u5316\u7684\u6295\u987E\u670D\u52A1\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.3rem", backgroundColor: "#ffffff" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(769), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "Q2"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem" }, "fontSize", "0.28rem") },
                "\u57FA\u91D1\u6295\u987E\u548C\u57FA\u91D1\u7EC4\u5408\u6709\u4EC0\u4E48\u533A\u522B\uFF1F"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { color: "#333", display: "flex", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.1rem", backgroundColor: "#ffffff", paddingBottom: "0.2rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: { width: "0.5rem", height: "0.5rem", position: "relative" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { alt: "", src: __webpack_require__(770), style: { width: "0.4rem", height: "0.4rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { position: "absolute", top: "0.05rem", left: "0.07rem", color: "#ffffff", fontSize: "0.2rem" } },
                  "A2"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { style: _defineProperty({ flex: 1, display: "flex", fontSize: "0.2rem", paddingTop: "0.04rem", lineHeight: "0.4rem" }, "fontSize", "0.28rem") },
                "\u76F8\u5BF9\u4E8E\u7EC4\u5408\u6765\u8BF4\uFF0C\u57FA\u91D1\u6295\u987E\u662F\u4E13\u4E1A\u6295\u987E\u56E2\u961F\u6839\u636E\u7528\u6237\u98CE\u9669\u7B49\u7EA7\u548C\u6295\u8D44\u9700\u6C42\u5B9A\u5236\u5316\u9009\u57FA\uFF0C\u5E76\u63D0\u4F9B\u81EA\u52A8\u8C03\u4ED3\uFF0C\u966A\u4F34\u670D\u52A1\u7B49\u4E00\u7AD9\u5F0F\u8D44\u4EA7\u914D\u7F6E\u670D\u52A1\u3002"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { lineHeight: "0.4rem", color: "#5A5A62", fontSize: "0.2rem", paddingLeft: "0.2rem", paddingRight: "0.2rem", paddingBottom: "2rem", marginTop: "0.2rem" } },
              "\u98CE\u9669\u63D0\u793A\uFF1A\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E\u3002\u672C\u516C\u53F8\u627F\u8BFA\u4EE5\u8BDA\u5B9E\u4FE1\u7528\u3001\u52E4\u52C9\u5C3D\u8D23\u7684\u539F\u5219\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u4E3A\u6295\u8D44\u8005\u8C03\u4ED3\uFF0C\u4F46\u4E0D\u4FDD\u8BC1\u6295\u987E\u8D26\u6237\u4E00\u5B9A\u76C8\u5229\uFF0C\u4E5F\u4E0D\u4FDD\u8BC1\u6700\u4F4E\u6536\u76CA\u3002\u7EC4\u5408\u5386\u53F2\u4E1A\u7EE9\u4E0D\u4EE3\u8868\u672A\u6765\u6536\u76CA\u3002\u672C\u516C\u53F8\u63D0\u9192\u6295\u8D44\u8005\u63A5\u53D7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u7ED3\u5408\u81EA\u8EAB\u7684\u6295\u8D44\u7ECF\u5386\u3001\u98CE\u9669\u627F\u53D7\u80FD\u529B\u3001\u8D44\u4EA7\u914D\u7F6E\u9700\u8981\u4F5C\u51FA\u6295\u8D44\u51B3\u7B56\uFF0C\u6295\u987E\u8D26\u6237\u7684\u6295\u8D44\u98CE\u9669\u7531\u6295\u8D44\u8005\u81EA\u884C\u627F\u62C5\u3002\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\uFF0C\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002\u6295\u8D44\u8005\u5E94\u81EA\u884C\u9605\u8BFB\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u7B49\u4EA7\u54C1\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u81EA\u884C\u505A\u51FA\u6295\u8D44\u9009\u62E9\u3002\u57FA\u91D1\u6295\u987E\u7EC4\u5408\u53CA\u57FA\u91D1\u6295\u8D44\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\u3002"
            )
          )
        ),
        subStatus == 0 || subStatus == 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { style: (_ref6 = { paddingTop: "0.12rem", paddingBottom: "0.14rem", color: "#333", display: "flex", justifyContent: "center", backgroundColor: "gray", position: "fixed", bottom: "1.4rem", width: "100%" }, _defineProperty(_ref6, "backgroundColor", "#F6F1E9"), _defineProperty(_ref6, "fontSize", "0.24rem"), _ref6) },
          minLimit != null ? minLimit : "--",
          "\u5143\u8D77\uFF0C\u6295\u987E\u8D39\u7387\uFF1A",
          manageFeeRate != null ? manageFeeRate : "--"
        ) : null,
        subStatus == 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "FixedBottomNot_zy" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#BF9B79", color: "#ffffff", fontSize: "0.32rem" } },
            openDate,
            "\u5F00\u653E\u8F6C\u5165"
          )
        ) : subStatus == 1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "FixedBottomNot_zy" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { onClick: function onClick() {
                return _this4.goInvesting();
              }, style: { backgroundColor: "#BF9B79", color: "#ffffff" } },
            "\u8F6C\u5165"
          )
        ) : subStatus == 2 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "FixedBottomNot_zy" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#C4C4C4" }, onClick: function onClick() {} },
            "\u672C\u671F\u5DF2\u552E\u7F44"
          )
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "FixedBottomNot_zy" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { backgroundColor: "#C4C4C4" }, onClick: function onClick() {} },
            "\u5DF2\u6682\u505C\u8F6C\u5165"
          )
        )
      );
    }
  }]);

  return TargetProfitDetail;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails,
      _state$strategiesDeta2 = _state$strategiesDeta.superFundManageRate,
      superFundManageRate = _state$strategiesDeta2 === undefined ? {} : _state$strategiesDeta2,
      _state$strategiesDeta3 = _state$strategiesDeta.superFundTradeLimit,
      superFundTradeLimit = _state$strategiesDeta3 === undefined ? {} : _state$strategiesDeta3,
      _state$strategiesDeta4 = _state$strategiesDeta.stopProfitOperationInfo,
      stopProfitOperationInfo = _state$strategiesDeta4 === undefined ? {} : _state$strategiesDeta4,
      superFundConfirmAndIncomeDate = _state$strategiesDeta.superFundConfirmAndIncomeDate;


  return {
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    SuperFoundDetailXCL: state.SuperFoundDetailXCL,
    // payLoading:state.riskInPay.payLoading,
    dataval: superFundConfirmAndIncomeDate || {},
    manageFeeRate: superFundManageRate && superFundManageRate.manageFeeRate,
    minLimit: superFundTradeLimit && superFundTradeLimit.minLimit,
    stopProfitOperationInfo: stopProfitOperationInfo || {}
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__HOC_StateCache_js__["a" /* default */])(TargetProfitDetail, 'TargetProfitDetailIndex')));

function add0(m) {
  return m < 10 ? "0" + m : m;
}
function formatTime(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  // let h = time.getHours();
  // let mm = time.getMinutes();
  // let s = time.getSeconds();
  return y + "." + add0(m) + "." + add0(d);
}

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AlerModle__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NHeader_js__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__targetProfitHaveCast_css__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__targetProfitHaveCast_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__targetProfitHaveCast_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PieEcarts__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AllIncomeHaveCastLineEcharts_js__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__PerformanceTrendsHaveCastLineEcharts_js__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Modal_ModalDetail__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__guidePage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HOC_StateCache_js__ = __webpack_require__(156);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var TargetProfitHaveCast = function (_Component) {
  _inherits(TargetProfitHaveCast, _Component);

  function TargetProfitHaveCast(props) {
    _classCallCheck(this, TargetProfitHaveCast);

    var _this = _possibleConstructorReturn(this, (TargetProfitHaveCast.__proto__ || Object.getPrototypeOf(TargetProfitHaveCast)).call(this, props));

    _this.goHistoryProfit = function () {
      var SupperFundHome = _this.props.SupperFundHome;
      var data = SupperFundHome ? _this.props.SupperFundHome.singleSuperFundViews ? _this.props.SupperFundHome.singleSuperFundViews : [] : [];
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/HistoryProfit',
        state: {
          SuperList: data
        },
        query: {
          SuperList: ""
        }
      });
    };

    _this.showWenHaoView = function (event, val) {
      event.stopPropagation();
      if (val == "当前资产") {
        _this.setState({
          tipFlag: true,
          tsText: ["资产分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品资产，预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品资产。遇特殊情况（分红、折算等）资产可能不准确，分红、折算确认后会自动修复。"]
        });
      } else if (val == "最新收益") {
        _this.setState({
          tipFlag: true,
          tsText: ["1. 日收益分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品收益；预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品收益。遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。", "2. 货基收益预计会在次日的15点至20点更新。", "3. 非华夏基金最新净值更新后，当前资产实时计增，日收益略有延迟。", "4. 如果组合中含有沪港通等T+2日更新净值的基金，则该基金的日收益不展示在日收益中。"]
        });
      } else if (val == "累计收益") {
        _this.setState({
          tipFlag: true,
          tsText: ["1. 累计收益分为两次更新，预计交易日20点至24点更新投顾组合中华夏基金公募产品收益；预计下一自然日0点至12点，更新投顾组合中非华夏基金公募产品收益。遇特殊情况（分红、折算等）收益可能不准确，分红、折算确认后会自动修复。", "2. 货基收益预计会在次日的15点至20点更新。", "3. 非华夏基金最新净值更新后，当前资产实时计增，累计收益略有延迟。", "4. 如果组合中含有沪港通等T+2日更新净值的基金，则该基金的最新收益展示在累计收益中。"]
        });
      }
    };

    _this.toTartgetProfitDetail = function () {
      var data = _this.props.strategiesDetails || {};
      var shareQueryResponse = data.superFundUserShare || {};
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/TargetProfitDetail",
        state: Object.assign({}, _this.props.location.state, { superFundName: shareQueryResponse.superFundName }),
        query: Object.assign({}, _this.props.location.state, { superFundName: shareQueryResponse.superFundName })
      });
    };

    _this.getColor = function (value) {
      if (value === "--") return "#333";
      if (value.replace("%", "") >= 0) return "#F8515C";
      return "#1DA96B";
    };

    _this.getAll = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/ServiceReport",
        state: { superFundCode: _this.props.location.state.superFundCode, hasQuarterly: true, serveDays: _this.props.serveDays, token: _this.state.token },
        query: { superFundCode: _this.props.location.state.superFundCode, hasQuarterly: true, serveDays: _this.props.serveDays, token: _this.state.token }
      });
    };

    _this.toRecentNewsDetail = function (v) {
      console.log(v);
      if (v.monthReportToPortal && _this.state.token) {
        var fundCode = v.monthReportToPortal.monthReportTemplate.fundCode;
        var year = v.monthReportToPortal.monthReportTemplate.year;
        var month = v.monthReportToPortal.monthReportTemplate.month;
        var token = _this.state.token;
        var _url = year > 2020 ? "NewQuarterlyReport/index.html?device=h5&token=" : "QuarterlyReport/index.html?device=h5&token=";
        var _urlSec = _url + token + "&fundCode=" + fundCode + "&month=" + month + "&year=" + year;
        // window.open("http://10.16.160.74/monthReport/" + _urlSec); //测试
        window.open("https://app.amcfortune.com/wAppStatic/" + _urlSec); //生产
      } else {
        __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
          pathname: "/ServiceReportDetail",
          state: { id: v.id },
          query: { id: v.id }
        });
      }
    };

    _this.toggerToPrtformanceTrends = function () {
      _this.setState({ tab: 1 });
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          location = _this$props.location,
          lineData = _this$props.lineData;

      if (lineData[1]) return;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__["b" /* getUserTransactionIncomeAndProductIncome */])({
        superFundCode: _this.props.location.state.superFundCode,
        periodType: 1
      }));
    };

    _this.toDetail = function () {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: '/PositionDetailsHavaCast',
        state: { fundItems: _this.props.fundItems },
        query: { fundItems: _this.props.fundItems }
      });
    };

    _this.state = {
      fundIsOpen: "",
      incomeDay: "--",
      dayIncomeDate: "--",
      SharpRate: "",
      Volatility: "",
      resultShow: false,
      alertContent: "",
      updateFlag: true,
      hideFlag: false,
      tabName: "配置概况",
      yearIncomeRate: "",
      ThreeIncome: "",
      singingFlag: false,
      singingFlagNext: false,
      manageFeeRate: "",
      discountRate: "",
      tipFlag: false,
      openState: "",
      endDate: "",
      tsText: [],
      tab: 0,
      dataval: "",
      token: ""
    };
    return _this;
  }

  _createClass(TargetProfitHaveCast, [{
    key: "componentDidMount",
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["f" /* getSupperFundHome */])({}, function () {}, this));
                _context.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["b" /* getTempInfo */])('shortToken');

              case 3:
                token = _context.sent;

                this.setState({
                  token: token
                });
                document.body.scrollTo(0, 0);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      window._czc.push(["_trackEvent", "华夏财富H5", "智投教育已投详情", "进入"]);
      var dispatch = this.props.dispatch;

      console.log(this.props.location);
      var superFundCode = this.props.location.query.superFundCode ? this.props.location.query.superFundCode : "SF1003";
      var len = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundCodeArrByTarget.indexOf(superFundCode);
      document.title = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundCodeArrByTargetName[len] ? __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.superFundCodeArrByTargetName[len] : '策略详情';
      var data1 = { superFundCode: superFundCode };
      // dispatch(getSuperFoundDetail(superFundCode));
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_76" /* validateSuperFundUpdate */])(data1));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_75" /* verifyActivityBoolHaveCast */])({ superFundCode: superFundCode, stopProfit: true }, function (result) {
        _this2.setState({
          openState: result.activitySuperFund.state,
          endDate: __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.dateMD(result.activitySuperFund.endDate)
        });
      }));

      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__["g" /* getStrategiesDetailsStopHaveCast */])({
        superFundCode: this.props.location.state.superFundCode
      }, function (val) {
        _this2.setState({ dataval: val }), console.log(val);
      }));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction_js__["d" /* getHistoryIncomeList */])({
        superFundCode: this.props.location.state.superFundCode,
        periodType: 1
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window._czc.push(["_trackEvent", "华夏财富H5", "智投教育已投详情", "离开"]);
      __WEBPACK_IMPORTED_MODULE_21__guidePage__["b" /* default */].leave();
      document.title = "";
    }
  }, {
    key: "callBack",
    value: function callBack(data) {}
  }, {
    key: "goInvesting",
    value: function goInvesting() {
      window._czc.push(["_trackEvent", "华夏财富H5", "智投教育已投详情", "追加投资"]);
      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      var _props = this.props,
          history = _props.history,
          inNeedNotice = _props.inNeedNotice,
          inNeedUpdate = _props.inNeedUpdate,
          dispatch = _props.dispatch,
          SuperFoundDetailXCL = _props.SuperFoundDetailXCL,
          strategiesDetails = _props.strategiesDetails;

      var route = window.history.length;
      var superFundUserShare = strategiesDetails && strategiesDetails.superFundUserShare;
      if (inNeedNotice == true) {} else if (inNeedUpdate == true) {} else {
        var params = {
          fundCode: superFundUserShare && superFundUserShare.superFundCode,
          fundName: superFundUserShare && superFundUserShare.superFundName,
          isShowModal: false, //首次购买弹窗标识
          // prompt: SuperFoundDetailXCL[0] && SuperFoundDetailXCL[0].prompt,
          // policy: SuperFoundDetailXCL[0] && SuperFoundDetailXCL[0].policy,
          // policyTitle: SuperFoundDetailXCL[0] && SuperFoundDetailXCL[0].policyTitle,
          productType: "Z",
          pageText: "无定投",
          superTypeValue: "1"
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["r" /* getPayAllSuper */])(route, params, __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */], "PaymentAllSuperFund");
      }
    }
  }, {
    key: "RedeemSuperFund",
    value: function RedeemSuperFund(data) {
      var _this3 = this;

      var isMiniProgram = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__common_js__["i" /* onMiniProgramDialog */])(__WEBPACK_IMPORTED_MODULE_20__guidePage_index_js__["a" /* GuidePageType */].Trade);
      if (isMiniProgram) return;
      if (!data && !this.props.InvestStopDetil) {
        return false;
      }
      if (data.buyFlag != true) {

        var fun = function fun() {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].loading();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["q" /* hasConvertingTrade */])({
            superFundCode: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundCode : ""
          }, function () {
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
          }, function () {
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
          }).then(function (suc) {
            if (suc === true) {
              __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].show('当前智投组合有转换在途交易，该操作暂停', __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.ToastTime);
              return;
            }
            _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_productAction__["i" /* choseCurrentIndex */])(0));
            _this3.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_productAction__["J" /* choseCurrencyIndex */])(0));

            __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
              pathname: "/RedeemSuperFund",
              state: {
                fundCode: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundCode : "",
                fundName: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundName : "",
                cardList: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.superFundChannelList : "",
                totalAmount: _this3.state.dataval ? _this3.state.dataval.superFundUserShare.totalAmount : ""
              }
            });
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
            return;
          });
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__getPay__["a" /* goLogin */])(fun, window.history.length);
      } else {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info("华夏智投正在调仓、赎回、申购中，无法进行此操作", __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.ToastTime);
      }
    }
  }, {
    key: "goBack",
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].goBack();
    }

    /**同意签约 */

  }, {
    key: "handleArgee",
    value: function handleArgee() {
      var _this4 = this;

      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__action_investmentAction__["_74" /* signSuperFundAccAgreement */])({ state: 1, operator: "user" }, function () {
        _this4.setState({
          singingFlag: false
        }, _this4.pushUpdate());
      }));
    }
    //暂不签约

  }, {
    key: "handleDisagree",
    value: function handleDisagree() {
      this.setState({
        singingFlag: false,
        singingFlagNext: true
      });
    }
    /**返回签约页 */

  }, {
    key: "callBackQy",
    value: function callBackQy() {
      this.setState({
        singingFlag: true,
        singingFlagNext: false
      });
    }
    /**不同意签约 */

  }, {
    key: "closeDisAgreeAlert",
    value: function closeDisAgreeAlert() {
      this.setState({
        singingFlagNext: false
      });
    }
  }, {
    key: "jiaoyimingxi",
    value: function jiaoyimingxi() {
      __WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* hashHistory */].push({
        pathname: "/Transactionrecordztgz",
        state: {
          superFundCode: this.props.location.state.superFundCode
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          buyFlag = _props2.buyFlag,
          adjustFlag = _props2.adjustFlag,
          totalAmount = _props2.totalAmount,
          dayIncome = _props2.dayIncome,
          allIncome = _props2.allIncome,
          annualizedGains = _props2.annualizedGains,
          operationDay = _props2.operationDay,
          collectingStatus = _props2.collectingStatus,
          serveDays = _props2.serveDays,
          _props2$recentNewsLis = _props2.recentNewsList,
          recentNewsList = _props2$recentNewsLis === undefined ? [] : _props2$recentNewsLis,
          _props2$superFundNoti = _props2.superFundNotifications,
          superFundNotifications = _props2$superFundNoti === undefined ? [] : _props2$superFundNoti,
          _props2$fundItemsUpda = _props2.fundItemsUpdateDate,
          fundItemsUpdateDate = _props2$fundItemsUpda === undefined ? "--" : _props2$fundItemsUpda,
          _props2$legendData = _props2.legendData,
          legendData = _props2$legendData === undefined ? [] : _props2$legendData,
          _props2$seriesData = _props2.seriesData,
          seriesData = _props2$seriesData === undefined ? [] : _props2$seriesData;


      var superFundCode = this.props.location.query.superFundCode;
      var ua = navigator.userAgent.toLowerCase();
      console.log(ua.match(/MicroMessenger/i) == "micromessenger");
      // let { tabName } = this.state;
      // let { dispatch, inNeedNotice, SuperFoundDetailXCL } = this.props;
      var data = this.props.strategiesDetails || {};
      //let flag_pie = data ? data.shareQueryResponse.fundItems : false;

      // document.getElementsByTagName('title')[0].innerHTML = data ? data.productQueryResponse.superFundName : "";
      var shareQueryResponse = data.superFundUserShare || {};
      //let performance = data ? Util.fomatFloat(data.productQueryResponse.performance * 100) : "";
      //let maxRetracement = data ? Util.fomatFloat(data.productQueryResponse.maxRetracement * 100) : "";

      var Amount = __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.parsePrice(shareQueryResponse.totalAmount);
      var collectingObj = {
        0: "募集中",
        1: "募集结束",
        2: __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.toPercent(annualizedGains)
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        { className: "container" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__NHeader_js__["a" /* default */], {
            title: shareQueryResponse.superFundName,
            rightContent: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_md_white_font", onClick: this.toTartgetProfitDetail.bind(this) },
              "\u7B56\u7565\u8BE6\u60C5"
            ),
            isPaddingBottom: 0
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "content paddB40", id: "TargetProfitHaveCastIndex", style: { paddingTop: 0, display: 'flex', flex: 1, overflowY: 'scroll', flexDirection: 'column' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_md_white_font style_transparent_color target_content_bg" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_column_center target_total_amount" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "tartget_total_amount_tit" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "span",
                  { style: { marginRight: ".1rem" } },
                  "\u603B\u8D44\u4EA7"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", {
                  onClick: function onClick(event) {
                    _this5.showWenHaoView(event, "当前资产");
                  },
                  style: { width: ".24rem" },
                  src: __webpack_require__(674)
                })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "total_amount_font" },
                Amount
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_row_center target_info" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_average style_center_align" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { marginBottom: ".06rem" } },
                  "\u6700\u65B0\u6536\u76CA (\u5143)"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_lbg_font style_font_weight" },
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.processingDecimal(dayIncome, 2, true)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_average style_center_align" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { marginBottom: ".06rem" } },
                  "\u7D2F\u8BA1\u6536\u76CA (\u5143)"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_lbg_font style_font_weight" },
                  __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.processingDecimal(allIncome, 2, true)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_average style_center_align style_flex_column_center" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_flex_column_center operationDay" },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { style: { color: "#FFE5B9" } },
                    collectingStatus !== undefined ? collectingStatus === 2 ? "\u5DF2\u8FD0\u4F5C" + operationDay + "\u5929" : "未开始运作" : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "span",
                      { style: { color: "#fff" } },
                      "--"
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { style: { marginBottom: ".06rem", marginTop: ".1rem" } },
                  "\u8FD0\u4F5C\u4EE5\u6765\u5E74\u5316"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_lbg_font style_font_weight" },
                  collectingStatus !== undefined ? collectingObj[collectingStatus] : "--"
                )
              )
            ),
            superFundNotifications && !!superFundNotifications.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_sm_font style_color_light  target_notification" },
              superFundNotifications.map(function (v, i) {
                if (v.transactionType == 0) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "target_notification_item" },
                  "\u60A8\u6709",
                  v.transactionNum,
                  "\u7B14\u8F6C\u5165",
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "span",
                    { className: "style_color_dark" },
                    __WEBPACK_IMPORTED_MODULE_4__util_js___default.a.processingDecimal(v.amount, 2) || "--"
                  ),
                  "\u5143",
                  v.confirmStatus ? '确认中' : '待确认',
                  "\uFF0C\u9884\u8BA1",
                  new Date(v.date).getMonth() + 1 + "." + new Date(v.date).getDate(),
                  "\u53EF\u67E5\u770B\u6536\u76CA"
                );
                if (v.transactionType == 1) return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "target_notification_item" },
                  "\u60A8\u6709",
                  v.transactionNum,
                  "\u7B14\u8F6C\u51FA\u4EA4\u6613",
                  v.confirmStatus ? '，成分基金将陆续确认。' : '待确认，',
                  "\u9884\u8BA1",
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "span",
                    { className: "style_color_dark" },
                    new Date(v.date).getMonth() + 1 + "." + new Date(v.date).getDate()
                  ),
                  "\u8D44\u91D1\u5230\u8D26"
                );
                if (v.transactionType == 2) return v.notifications.map(function (value, i) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "target_notification_item" },
                    "\u8C03\u4ED3\u8FDB\u884C\u4E2D\uFF0C\u5F53\u524D\u8D44\u4EA7\u4E3A\u9884\u4F30\u8D44\u4EA7\uFF0C\u8C03\u4ED3\u7ED3\u675F\u540E\u5C55\u793A\u5B9E\u9645\u8D44\u4EA7\u3002\u9884\u8BA1",
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "span",
                      { className: "style_color_dark" },
                      new Date(value.date).getMonth() + 1 + "." + new Date(value.date).getDate(),
                      "\u8C03\u4ED3\u7ED3\u675F"
                    )
                  );
                });
                if (v.transactionType == 3) return v.notifications.map(function (value, i) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "div",
                    { className: "target_notification_item" },
                    "\u9884\u8BA1",
                    v.fundName,
                    "\uFF08",
                    value.fundCode,
                    "\uFF09\u5728",
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "span",
                      { className: "style_color_dark" },
                      new Date(value.date).getMonth() + 1 + "-" + new Date(value.date).getDate()
                    ),
                    "\u6709\u5206\u7EA2\uFF0C\u5C4A\u65F6\u8D44\u4EA7\u548C\u6536\u76CA\u4E0D\u51C6\u786E\uFF0C\u5206\u7EA2\u6298\u7B97\u786E\u8BA4\u540E\u4F1A\u81EA\u52A8\u4FEE\u590D"
                  );
                });
              })
            ),
            recentNewsList && !!recentNewsList.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "tartget_news_list" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_row_center target_serve_day_wrap", onClick: this.getAll },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "tartget_serve_day" },
                  "Hi\uFF0C\u5DF2\u4E3A\u60A8\u670D\u52A1",
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    "span",
                    { style: { color: "#B69271" } },
                    serveDays || "--"
                  ),
                  "\u5929"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(387) })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "style_flex_row_center target_info_list" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  "div",
                  { className: "style_flex_row_center", style: { marginRight: ".3rem", justifyContent: "flex-start" } },
                  recentNewsList.map(function (v, i) {
                    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      "div",
                      { key: i, className: "tartget_news_item", onClick: function onClick() {
                          return _this5.toRecentNewsDetail(v);
                        } },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "style_font_weight style_overflow_ellipsis", style: { marginBottom: ".1rem" } },
                        v.title
                      ),
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        "div",
                        { className: "style_sm_font", style: { color: "#875426" } },
                        v.newsTime
                      )
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_row_center target_mingxi" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_flex_row_center", onClick: this.goHistoryProfit },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".64rem", marginRight: ".1rem" }, src: __webpack_require__(673) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_md_white_font style_color_dark" },
                "\u6536\u76CA\u660E\u7EC6"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_average style_flex_row_center", onClick: function onClick() {
                  return _this5.jiaoyimingxi();
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".64rem", marginRight: ".1rem" }, src: __webpack_require__(670) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_md_white_font style_color_dark" },
                "\u4EA4\u6613\u660E\u7EC6"
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { style: { padding: " .4rem", background: "#fff", marginBottom: ".2rem" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_md_white_font style_color_neutral line_echarts_btn", style: { marginBottom: ".3rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                {
                  onClick: function onClick() {
                    _this5.setState({ tab: 0 });
                  },
                  className: "style_flex_column_center " + (this.state.tab == 0 && "style_bg_font style_color_dark style_font_weight tab_underline")
                },
                "\u7D2F\u8BA1\u76C8\u4E8F"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { onClick: this.toggerToPrtformanceTrends.bind(this), className: "style_flex_column_center " + (this.state.tab == 1 && "style_bg_font style_color_dark style_font_weight tab_underline") },
                "\u4E1A\u7EE9\u8D70\u52BF"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              null,
              this.state.tab == 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__AllIncomeHaveCastLineEcharts_js__["a" /* default */], null),
              this.state.tab == 1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__PerformanceTrendsHaveCastLineEcharts_js__["a" /* default */], null)
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "target_pie_echarts" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_flex_row_between" },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_bg_font style_color_dark style_font_weight" },
                "\u6211\u7684\u6301\u4ED3"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_md_white_font style_color_light" },
                "\u6301\u4ED3\u6570\u636E\u4EC5\u542B\u53EF\u7528\u4EFD\u989D\uFF0C\u4E0D\u542B\u51BB\u7ED3\u4EFD\u989D"
              )
            ),
            legendData.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PieEcarts__["a" /* default */], { height: "2.8rem", legendData: legendData, seriesData: seriesData }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".4rem", paddingBottom: ".4rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: "4.14rem", height: "2.52rem" }, src: __webpack_require__(775) }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "text",
                { style: { fontSize: ".28rem", lineHeight: ".4rem" } },
                "\u8FD9\u91CC\u7A7A\u7A7A\u5982\u4E5F\uFF5E"
              )
            ),
            legendData.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "style_sm_font style_center_align target_detail", onClick: this.toDetail },
              "\u67E5\u770B\u8BE6\u7EC6\u6301\u4ED3",
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(273) })
            ) : null
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_sm_font style_flex_row_center target_kefu" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "a",
              { href: "tel:4008175666", className: "style_sm_font style_flex_row_center", style: { flex: 1, justifyContent: "space-between" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "span",
                { className: "style_flex_row_center " },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".48rem", marginRight: ".16rem" }, src: __webpack_require__(671) }),
                "\u667A\u80FD\u5BA2\u670D"
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img", { style: { width: ".2rem" }, src: __webpack_require__(387) })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_sm_font style_color_light target_tip" },
            "\u98CE\u9669\u63D0\u793A",
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "span",
              null,
              "\uFF1A"
            ),
            "\u5E02\u573A\u6709\u98CE\u9669\uFF0C\u6295\u8D44\u9700\u8C28\u614E\u3002\u672C\u516C\u53F8\u627F\u8BFA\u4EE5\u8BDA\u5B9E\u4FE1\u7528\u3001\u52E4\u52C9\u5C3D\u8D23\u7684\u539F\u5219\u63D0\u4F9B\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\uFF0C\u63D0\u4F9B\u6295\u8D44\u5EFA\u8BAE\u5E76\u4E3A\u6295\u8D44\u8005\u8C03\u4ED3\uFF0C\u4F46\u4E0D\u4FDD\u8BC1\u6295\u987E\u8D26\u6237\u4E00\u5B9A\u76C8\u5229\uFF0C\u4E5F\u4E0D\u4FDD\u8BC1\u6700\u4F4E\u6536\u76CA\u3002\u7EC4\u5408\u5386\u53F2\u4E1A\u7EE9\u4E0D\u4EE3\u8868\u672A\u6765\u6536\u76CA\u3002\u672C\u516C\u53F8\u63D0\u9192\u6295\u8D44\u8005\u63A5\u53D7\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u7ED3\u5408\u81EA\u8EAB\u7684\u6295\u8D44\u7ECF\u5386\u3001\u98CE\u9669\u627F\u53D7\u80FD\u529B\u3001\u8D44\u4EA7\u914D\u7F6E\u9700\u8981\u4F5C\u51FA\u6295\u8D44\u51B3\u7B56\uFF0C\u6295\u987E\u8D26\u6237\u7684\u6295\u8D44\u98CE\u9669\u7531\u6295\u8D44\u8005\u81EA\u884C\u627F\u62C5\u3002\u4E3A\u5176\u4ED6\u5BA2\u6237\u521B\u9020\u7684\u6536\u76CA\uFF0C\u5E76\u4E0D\u6784\u6210\u4E1A\u7EE9\u8868\u73B0\u7684\u4FDD\u8BC1\u3002\u57FA\u91D1\u6295\u8D44\u7EC4\u5408\u7B56\u7565\u7684\u98CE\u9669\u7279\u5F81\u4E0E\u5355\u53EA\u57FA\u91D1\u4EA7\u54C1\u7684\u98CE\u9669\u7279\u5F81\u5B58\u5728\u5DEE\u5F02\u3002\u6295\u8D44\u8005\u5E94\u81EA\u884C\u9605\u8BFB\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u57FA\u91D1\u6295\u8D44\u987E\u95EE\u670D\u52A1\u534F\u8BAE\u300B\u300A\u98CE\u9669\u63ED\u793A\u4E66\u300B\u300A\u7EC4\u5408\u7B56\u7565\u8BF4\u660E\u4E66\u300B\u7B49\u4EA7\u54C1\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u81EA\u884C\u505A\u51FA\u6295\u8D44\u9009\u62E9\u3002\u57FA\u91D1\u6295\u987E\u7EC4\u5408\u53CA\u57FA\u91D1\u6295\u8D44\u9075\u5FAA\u201C\u4E70\u8005\u81EA\u8D1F\u201D\u539F\u5219\uFF0C\u6295\u8D44\u8005\u5E94\u81EA\u884C\u627F\u62C5\u6295\u8D44\u98CE\u9669\u3002"
          )
        ),
        this.state.openState === "已开始" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "style_bg_font style_flex_row_center style_center_align FixedBottomHave", style: { height: ".96rem", lineHeight: ".96rem", background: "#fff" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#B69271", background: "#fff", height: "100%", border: '1px solid #F3F3F3' }, onClick: function onClick() {
                return _this5.RedeemSuperFund(shareQueryResponse);
              } },
            "\u8F6C\u51FA"
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#fff", background: "#BF9B79", height: "100%" }, onClick: function onClick() {
                return _this5.goInvesting(shareQueryResponse);
              } },
            "\u8F6C\u5165"
          )
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "style_bg_font style_flex_row_center style_center_align FixedBottomHave", style: { height: ".96rem", lineHeight: ".96rem", background: "#fff" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            { className: "style_flex_average", style: { color: "#B69271", background: "#fff", height: "100%", border: '1px solid #F3F3F3' }, onClick: function onClick() {
                return _this5.RedeemSuperFund(shareQueryResponse);
              } },
            "\u8F6C\u51FA"
          )
        ),
        this.state.resultShow ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AlerModle__["e" /* default */], {
          content: this.state.alertContent,
          CloseAler: function CloseAler() {
            _this5.setState({ resultShow: false });
          }
        }) : null,
        this.state.singingFlag ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AlerModle__["c" /* AlerModleQy */], { handleClick1: this.handleArgee.bind(this), handleClick2: this.handleDisagree.bind(this) }) : null,
        this.state.singingFlagNext ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AlerModle__["a" /* AlerModleCommon */], { btnTxt1: "\u8FD4\u56DE\u7B7E\u7EA6\u9875\u9762", btnTxt2: "\u77E5\u9053\u4E86\uFF0C\u6682\u4E0D\u7B7E\u7EA6", content: "根据监管要求，只能对签约的客户提供基金投顾服务。如未及时签约，华夏财富将无法再为您提供自动调仓等服务，您可选择继续持有当前份额或赎回。", title: "\u7B7E\u7EA6\u63D0\u9192", handleClick1: this.callBackQy.bind(this), handleClick2: this.closeDisAgreeAlert.bind(this) }) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Modal_ModalDetail__["a" /* default */], {
          flag: this.state.tipFlag,
          rightButtonTitle: "\u77E5\u9053\u4E86",
          content: this.state.tsText,
          onOK: function onOK() {
            _this5.setState({ tipFlag: false });
          }
        })
      );
    }
  }]);

  return TargetProfitHaveCast;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  var _state$strategiesDeta = state.strategiesDetails,
      _state$strategiesDeta2 = _state$strategiesDeta.superFundUserShare,
      superFundUserShare = _state$strategiesDeta2 === undefined ? {} : _state$strategiesDeta2,
      _state$strategiesDeta3 = _state$strategiesDeta.recentNewsList,
      recentNewsList = _state$strategiesDeta3 === undefined ? [] : _state$strategiesDeta3,
      _state$strategiesDeta4 = _state$strategiesDeta.stopProfitOperationInfo,
      stopProfitOperationInfo = _state$strategiesDeta4 === undefined ? {} : _state$strategiesDeta4,
      _state$strategiesDeta5 = _state$strategiesDeta.superFundNotifications,
      superFundNotifications = _state$strategiesDeta5 === undefined ? [] : _state$strategiesDeta5;

  stopProfitOperationInfo = stopProfitOperationInfo || {};
  return {
    strategiesDetails: state.strategiesDetails,
    userHasInvested: state.userHasInvested,
    inNeedUpdate: state.inNeedUpdate,
    inNeedNotice: state.inNeedNotice,
    // payLoading:state.riskInPay.payLoading,
    // InvestStopDetil: state.InvestStopDetil,
    validateSuperFundUpdateData: state.validateSuperFundUpdate,
    superFundAccAgreementState: state.superFundAccAgreementState,
    SuperFoundDetailXCL: state.SuperFoundDetailXCL,

    totalAmount: superFundUserShare.totalAmount,
    dayIncome: superFundUserShare.dayIncome,
    allIncome: superFundUserShare.allIncome,
    annualizedGains: stopProfitOperationInfo.annualizedGains,
    recentNewsList: recentNewsList,
    superFundNotifications: superFundNotifications,
    serveDays: superFundUserShare.serveDays,
    operationDay: stopProfitOperationInfo.operationDay,
    collectingStatus: stopProfitOperationInfo.collectingStatus,
    legendData: superFundUserShare.legendData,
    seriesData: superFundUserShare.seriesData,
    fundItemsUpdateDate: superFundUserShare.fundItemsUpdateDate,
    lineData: state.lineData,
    userAllIncomeHistory: state.userAllIncomeHistory,
    adjustFlag: superFundUserShare.adjustFlag,
    buyFlag: superFundUserShare.buyFlag,
    fundItems: superFundUserShare.fundItems,
    SupperFundHome: state.SupperFundHome
  };
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__HOC_StateCache_js__["a" /* default */])(TargetProfitHaveCast, 'TargetProfitHaveCastIndex')));

function add0(m) {
  return m < 10 ? "0" + m : m;
}
function formatTime(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  var time = new Date(shijianchuo);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  // let h = time.getHours();
  // let mm = time.getMinutes();
  // let s = time.getSeconds();
  return y + "." + add0(m) + "." + add0(d);
}

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DownUpList1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nheaderjiaoyijilu_css__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nheaderjiaoyijilu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__nheaderjiaoyijilu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_Transferrecord_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_Transferrecord_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_Transferrecord_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var objArr;

/*产品交易记录*/

var Transactionrecordztgz = function (_Component) {
  _inherits(Transactionrecordztgz, _Component);

  function Transactionrecordztgz(props) {
    _classCallCheck(this, Transactionrecordztgz);

    var _this2 = _possibleConstructorReturn(this, (Transactionrecordztgz.__proto__ || Object.getPrototypeOf(Transactionrecordztgz)).call(this, props));

    _this2.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
    };

    _this2.getSource = function () {
      var _this2$props = _this2.props,
          dispatch = _this2$props.dispatch,
          isRealName = _this2$props.isRealName;

      var _this = _this2;
      var data = {
        pageIndex: _this2.state.pageIndex,
        pageSize: _this2.state.pageSize,
        businessType: _this2.state.businessType,
        superFundCode: _this2.props.location.state.superFundCode

      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["_80" /* ztcgjiaoyijilu */])(data, _this2.callbackData.bind(_this2), _this));
    };

    var ds = new __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
        return r1 !== r2;
      } });

    _this2.state = {
      isLoading: true,
      dataSource: ds.cloneWithRows([]),
      height: navigator.userAgent.toLowerCase().indexOf("amcfmapp") > -1 ? window.winHeight : window.winHeight - 88,
      businessType: "",
      fundCode: "",
      pageIndex: 1,
      pageSize: 30,
      totalDataArr: [],
      transactionAll: false,
      timeAll: false,
      txt: "类型",
      transactionType: '全部类型',
      period: "全部时间",
      periodType: "",
      nomore: false
    };
    return _this2;
  }

  _createClass(Transactionrecordztgz, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      objArr = [];
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {}
  }, {
    key: 'callbackData',
    value: function callbackData(data) {
      console.log(data, "交易记录记录记录");
      var totalDataArr = this.state.totalDataArr.concat(data.records);
      if (data.records.length !== 0) {
        if (data.records.length < this.state.pageSize) {
          this.setState({
            nomore: 3,
            dataSource: this.state.dataSource.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            pageIndex: this.state.pageIndex + 1,
            loadingFlag: false,
            handleFlag: false,
            timeAll: false
          });
        } else {
          this.setState({
            nomore: 0,
            pageIndex: this.state.pageIndex + 1,
            dataSource: this.state.dataSource.cloneWithRows(totalDataArr),
            totalDataArr: totalDataArr,
            loadingFlag: false,
            handleFlag: false,
            timeAll: false
          });
        }
      } else {
        this.setState({
          nomore: 3,
          loadingFlag: false,
          timeAll: false
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      console.log(this.state.period, this.state.transactionType);
      var period = this.state.period;
      var transactionType = this.state.transactionType;
      sessionStorage.setItem('period', period);
      sessionStorage.setItem('transactionType', transactionType);
      var _this = this;
      var data1 = {
        pageIndex: this.state.pageIndex,
        pageSize: this.state.pageSize,
        superFundCode: this.props.location.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["_80" /* ztcgjiaoyijilu */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'timeTypeCallback',
    value: function timeTypeCallback(period, periodType) {
      var _this = this;
      var flag = void 0;
      if (this.state.totalDataArr.length !== 0) {
        flag = true;
      } else {
        flag = false;
      }
      var dispatch = this.props.dispatch;

      var ds = new __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });

      this.setState({
        loadingFlag: flag,
        period: period,
        periodType: periodType,
        pageIndex: 1,
        pageSize: 30,
        totalDataArr: [],
        handleFlag: true,
        timeAll: false,
        dataSource: ds.cloneWithRows([])
      });
      var data = {
        pageIndex: 1,
        pageSize: 30,
        periodType: periodType,
        businessType: this.state.businessType,
        superFundCode: this.props.location.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["_80" /* ztcgjiaoyijilu */])(data, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'jyTypeCallback',
    value: function jyTypeCallback(transactionType, businessType) {
      var _this = this;
      var flag = void 0;
      if (this.state.totalDataArr.length !== 0) {
        flag = true;
      } else {
        flag = false;
      }
      var dispatch = this.props.dispatch;

      var ds = new __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["ListView"].DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
          return r1 !== r2;
        } });

      this.setState({
        loadingFlag: flag,
        transactionAll: false,
        transactionType: transactionType,
        businessType: businessType,
        pageIndex: 1,
        pageSize: 30,
        totalDataArr: [],
        handleFlag: true,
        timeAll: false,
        dataSource: ds.cloneWithRows([])
      });
      var data = {
        pageIndex: 1,
        pageSize: 30,
        periodType: this.state.periodType,
        businessType: businessType,
        superFundCode: this.props.location.state.superFundCode
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction__["_80" /* ztcgjiaoyijilu */])(data, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.state.nomore === 3) {
        if (this.state.totalDataArr.length === 0) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: 0, textAlign: 'center' } },
            '\u6CA1\u6709\u66F4\u591A\u6570\u636E\u4E86'
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 0, textAlign: 'center' } });
        }
      } else {
        return null;
      }
    }
  }, {
    key: 'selectLeft',
    value: function selectLeft(txt) {
      this.setState({
        transactionAll: !this.state.transactionAll,
        timeAll: false,
        txt: txt
      });
    }
  }, {
    key: 'selectRight',
    value: function selectRight(txt) {
      this.setState({
        timeAll: !this.state.timeAll,
        transactionAll: false,
        txt: txt
      });
    }
  }, {
    key: 'detailPush',
    value: function detailPush(annualizedGains, dividendMethod, confirmVolume, confirmAmount, redeemRate, commission, trustChannelName, fundName, superFundName, confirmTimeStr, businessTimeStr, applicationAmount, tradeRequestId, businessType) {
      var data = {
        tradeRequestId: tradeRequestId,
        businessType: businessType
      };

      if (businessType === "T522" || businessType === "T822" || businessType === "T422") {
        //银行卡、零钱宝、活期通申购
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/Transferinrecord",
          state: {
            commission: commission,
            confirmTimeStr: confirmTimeStr,
            businessTimeStr: businessTimeStr,
            applicationAmount: applicationAmount,
            tradeRequestId: tradeRequestId
          }
        });
      } else if (businessType === "T024" || businessType === "TA24" || businessType === "TF24") {
        //赎回至银行卡、零钱宝、活期通
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/Transferrecord",
          state: {
            annualizedGains: annualizedGains,
            confirmAmount: confirmAmount,
            redeemRate: redeemRate,
            commission: commission,
            confirmTimeStr: confirmTimeStr,
            businessTimeStr: businessTimeStr,
            applicationAmount: applicationAmount,
            tradeRequestId: tradeRequestId,
            superFundCode: this.props.location.state.superFundCode
          }
        });
      } else if (businessType === "T031") {
        //分红   //因为列表里的数据完全满足了分红的需求并且从详情里面取会特别麻烦所以数据是从列表带的
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/Dividendreinvestedincash",
          state: {
            confirmVolume: confirmVolume,
            dividendMethod: dividendMethod,
            confirmAmount: confirmAmount,
            trustChannelName: trustChannelName,
            fundName: fundName,
            superFundName: superFundName,
            confirmTimeStr: confirmTimeStr,
            tradeRequestId: tradeRequestId
          }
        });
      } else if (businessType === "T999") {
        //调仓
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/Detailsofwarehouseadjustment",
          state: {
            commission: commission,
            businessTimeStr: businessTimeStr,
            confirmTimeStr: confirmTimeStr,
            tradeRequestId: tradeRequestId
          }
        });
      } else if (businessType === "T888") {
        //调仓
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/Detailsofwarehouseadjustment",
          state: {
            commission: commission,
            businessTimeStr: businessTimeStr,
            confirmTimeStr: confirmTimeStr,
            tradeRequestId: tradeRequestId
          }
        });
      } else if (businessType === "TC24") {
        //服务费
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/Servicechargerecord",
          state: {
            tradeRequestId: tradeRequestId
          }
        });
      } else {
        //其他
        __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
          pathname: "/TransactionDetail",
          state: {
            data: data,
            flag: "JL",
            canCancel: false,
            title: "交易详情",
            commission: commission
          }
        });
      }
    }
  }, {
    key: 'getNum',
    value: function getNum(num1, num2) {
      if (num1 === null && num2 === null) {
        return null;
      } else if (num1 === null) {
        return num2 + '元';
      } else if (num2 === null) {
        return num1 + '元';
      } else if (num1 == num2) {
        return num1 + '元';
      } else {
        return null;
      }
    }
  }, {
    key: 'fuwufei',
    value: function fuwufei() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
        pathname: '/Fuwufei',
        state: {
          superFundCode: this.props.location.state.superFundCode
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          txt = _state.txt,
          timeAll = _state.timeAll,
          transactionAll = _state.transactionAll;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_containerq' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wrapq' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u4EA4\u6613\u8BB0\u5F55'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_share' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this3.fuwufei();
                    } },
                  '\u670D\u52A1\u8D39'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaoyijilutoubuxz' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this3.selectLeft("类型");
                  }, className: 'jiaoyijilutoubuxzleixing' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaoyijilutoubuxzleixing1' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaoyijilutoubuxzleixing2' },
                    txt === "类型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'text',
                      { style: { color: '#fff', fontWeight: "bold" } },
                      this.state.transactionType
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'text',
                      { style: { color: '#fff' } },
                      this.state.transactionType
                    ),
                    txt === "类型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaoyijilutoubuxzleixing2kuai', style: { backgroundColor: "rgba(182, 146, 113, 1)" } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaoyijilutoubuxzleixing2kuai', style: { backgroundColor: "transparent" } })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaoyijilutoubuxzleixing3' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this3.selectRight("时间");
                  }, className: 'jiaoyijilutoubuxzleixing' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaoyijilutoubuxzleixing1' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaoyijilutoubuxzleixing2' },
                    txt === "时间" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'text',
                      { style: { color: '#fff', fontWeight: "bold" } },
                      this.state.period
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'text',
                      { style: { color: '#fff' } },
                      this.state.period
                    ),
                    txt === "时间" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaoyijilutoubuxzleixing2kuai', style: { backgroundColor: "rgba(182, 146, 113, 1)" } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaoyijilutoubuxzleixing2kuai', style: { backgroundColor: "transparent" } })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaoyijilutoubuxzleixing3' })
                )
              )
            )
          )
        ),
        this.state.totalDataArr.length === 0 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'ListViewWrap1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["ListView"], {
            ref: function ref(el) {
              return _this3.lv = el;
            },
            dataSource: this.state.dataSource,
            renderFooter: function renderFooter() {
              return _this3.renderFooter();
            },
            renderRow: function renderRow(item, index) {
              objArr = [{ createDate: "" }].concat(_this3.state.totalDataArr);
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this3.detailPush(item.annualizedGains, item.dividendMethod, item.confirmVolume, item.confirmAmount, item.redeemRate, item.commission, item.trustChannelName, item.fundName, item.superFundName, item.confirmTimeStr, item.businessTimeStr, item.applicationAmount, item.tradeRequestId, item.businessType);
                  }, className: 'jiaoyjiluliebiaozhanshi' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaoyjiluliebiaozhanshitu' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'jiaoyjiluliebiaozhanshitu1', src: __webpack_require__(2168) })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'jiaoyjiluliebiaozhanshiright' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaoyjiluliebiaozhanshiright1' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaoyjiluliebiaozhanshiright1top' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaoyjiluliebiaozhanshiright1topleft' },
                        item.businessType === "T999" || item.businessType === "T888" || item.businessType == 'T031' || item.businessType == 'TC24' || item.businessType == "T024" || item.businessType == "TA24" || item.businessType == "TF24" || item.businessType == "T522" || item.businessType == "T822" || item.businessType == "T422" || item.businessType == "TH22" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          item.businessType === "T999" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1topleftziti' },
                            item.businessTypeName.slice(4, 6),
                            '-',
                            item.trustChannelName
                          ) : null,
                          item.businessType === "T888" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1topleftziti' },
                            item.businessTypeName.slice(3, 5),
                            '-',
                            item.trustChannelName
                          ) : null,
                          item.businessType === "T031" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1topleftziti' },
                            item.businessTypeName,
                            '-',
                            item.trustChannelName
                          ) : null,
                          item.businessType === "TC24" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1topleftziti' },
                            '\u6536\u53D6\u670D\u52A1\u8D39-',
                            item.trustChannelName
                          ) : null,
                          item.businessType === "T522" || item.businessType === "T822" || item.businessType === "T422" || item.businessType === "TH22" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1topleftziti' },
                            '\u8F6C\u5165'
                          ) : null,
                          item.businessType === "T024" || item.businessType === "TA24" || item.businessType === "TF24" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1topleftziti' },
                            '\u8F6C\u51FA'
                          ) : null
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            null,
                            item.businessTypeName
                          )
                        ),
                        item.businessType === "T888" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaoyjiluliebiaozhanshiright1toplefttiaocangzaitiaocang' },
                          '\u518D\u5E73\u8861\u8C03\u4ED3'
                        ) : null
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaoyjiluliebiaozhanshiright1topright' },
                        item.businessType === "T031" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          item.dividendMethod === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            null,
                            item.confirmVolume === null ? "--" : item.confirmVolume + '份'
                          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            null,
                            item.confirmAmount === null ? "--" : item.confirmAmount + '元'
                          )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          item.redeemRate === null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            null,
                            _this3.getNum(item.applicationAmount, item.applicationVolume)
                          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            null,
                            item.redeemRate === null ? "--" : parseFloat((item.redeemRate * 100).toPrecision(12)) + "%"
                          )
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaoyjiluliebiaozhanshiright1bottom' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaoyjiluliebiaozhanshiright1bottomleft' },
                        item.businessType === "T031" || item.businessType === "TC24" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          null,
                          item.businessType === "T031" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaoyjiluliebiaozhanshiright1bottomleftziti' },
                            item.fundName,
                            '(',
                            item.superFundName,
                            ')'
                          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'text',
                            null,
                            item.superFundName
                          )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          null,
                          item.fundName
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaoyjiluliebiaozhanshiright1bottomright', style: { alignItems: "flex-end", display: "flex" } },
                        item.taConfirmStateName === "成功" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          null,
                          item.taConfirmStateName
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: '#B69271' } },
                          item.taConfirmStateName
                        )
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaoyjiluliebiaozhanshiright2' },
                    item.businessTimeStr
                  )
                )
              );
            },
            onEndReached: this.getSource,
            onEndReachedThreshold: 0.1
          })
        ),
        timeAll ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownUpList1, { titleItem: '\u65F6\u95F4', cancelCallback: function cancelCallback() {
            _this3.setState({ timeAll: false });
          }, chulihanshu: this.timeTypeCallback.bind(this), listContent: [{ title: '全部时间', callback: ('全部时间', "") }, { title: '今年以来', callback: ('今年以来', "thisYear") }, { title: '近一个月', callback: ('近一月', "m1") }, { title: '近三个月', callback: ('近三月', "m3") }, { title: '近六个月', callback: ('近六月', "m6") }, { title: '近一年', callback: ('近一年', "y1") }, { title: '近三年', callback: ('近三年', "y3") }] }) : null,
        transactionAll ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownUpList1, { titleItem: '\u4EA4\u6613', cancelCallback: function cancelCallback() {
            _this3.setState({ transactionAll: false });
          }, chulihanshu: this.jyTypeCallback.bind(this), listContent: [{ title: '全部类型', callback: ('全部类型', '') }, { title: '转入', callback: ('转入', 'T022') }, { title: '转出', callback: ('转出', 'T024') }, { title: '调仓', callback: ('调仓', 'T999') }, { title: '分红', callback: ('分红', 'T031') }, { title: '收取服务费', callback: ('收取服务费', 'TC24') }, { title: '其他', callback: ('其他', 'TB24') }] }) : null
      );
    }
  }]);

  return Transactionrecordztgz;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords: state.QueryTradeRecords
  };
}

var DownUpList1 = function (_Component2) {
  _inherits(DownUpList1, _Component2);

  function DownUpList1(props) {
    _classCallCheck(this, DownUpList1);

    var _this4 = _possibleConstructorReturn(this, (DownUpList1.__proto__ || Object.getPrototypeOf(DownUpList1)).call(this, props));

    _this4.state = {
      totalDataArr: [],
      timeAll: false,
      periodType: "",
      businessType: ""
    };
    return _this4;
  }

  _createClass(DownUpList1, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var listContent = this.props.listContent;
      var listArray = [];

      var _loop = function _loop(i) {
        listArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: i, className: 'contentContainer', onClick: function onClick() {
              return _this5.props.chulihanshu(listContent[i].title, listContent[i].callback);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { color: "#333333" } },
            listContent[i].title
          )
        ));
      };

      for (var i = 0; i < listContent.length; i++) {
        _loop(i);
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container1' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'scrollView' },
          listArray
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1 }, onClick: this.props.cancelCallback })
      );
    }
  }]);

  return DownUpList1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var styles = {
  container: {
    flex: 1,
    backgroundColor: '#fff'
  },
  footerBox: {
    height: 30,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: '#FFF',
    marginTop: -1
  }

};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Transactionrecordztgz));

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_Transferrecord_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_Transferrecord_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_Transferrecord_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__myAssets_payment_Password__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//转入记录









var Transferinrecord = function (_Component) {
  _inherits(Transferinrecord, _Component);

  function Transferinrecord(props) {
    _classCallCheck(this, Transferinrecord);

    var _this2 = _possibleConstructorReturn(this, (Transferinrecord.__proto__ || Object.getPrototypeOf(Transferinrecord)).call(this, props));

    _this2.backThisFun = function () {
      _this2.setState({
        pwdFlag: true
      });
    };

    _this2.onChangePwd = function (val) {
      _this2.setState({
        keyPasswordVal: val
      });
    };

    _this2.keyOk = function () {
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].loading();
      var data = {
        tradeRequestId: _this2.props.location.state.tradeRequestId,
        password: __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.encrypt(_this2.state.keyPasswordVal)
      };
      _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction__["t" /* superfundCancelFun */])(data, function (index, suc) {
        console.log(suc);
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
        if (index === 1) {
          _this2.setState({
            isCancel: false,
            pwdFlag: false
          });
          __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info("撤单成功", __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.ToastTime);
        }
      }, function () {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].hide();
      }));
    };

    _this2.state = {
      loadingFlag: false,
      xinxi: [],
      isCancel: false,
      pwdFlag: false,
      keyPasswordVal: ""
    };
    return _this2;
  }

  _createClass(Transferinrecord, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      console.log("1");
      var _this = this;
      var data1 = {
        tradeRequestId: this.props.location.state.tradeRequestId
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction__["_77" /* ztcgjiaoyijiluxiangqing */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data, sec) {
      console.log(data);
      this.setState({
        xinxi: data,
        isCancel: sec
      });
    }
    // 去除时间的时分秒

  }, {
    key: 'timeFormat',
    value: function timeFormat(date) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
      return newDate[0];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var xinxi = this.state.xinxi;

      console.log(xinxi);
      var _props$location$state = this.props.location.state,
          commission = _props$location$state.commission,
          confirmTimeStr = _props$location$state.confirmTimeStr,
          businessTimeStr = _props$location$state.businessTimeStr,
          applicationAmount = _props$location$state.applicationAmount;

      console.log(confirmTimeStr);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wrap', style: { zIndex: 9 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u4EA4\u6613\u8BE6\u60C5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: "20%", textAlign: "right" } },
                this.state.isCancel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: this.backThisFun },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 18, color: "#ffff", fontWeight: "500" } },
                    '\u64A4\u5355'
                  )
                ) : null
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'jiaoyixiangqing', style: { zIndex: 10 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingtopshengou' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop1' },
              '\u8F6C\u5165\u4FE1\u606F'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u8F6C\u5165\u91D1\u989D'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                applicationAmount == null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(applicationAmount) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u8F6C\u5165\u65F6\u95F4'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                businessTimeStr ? businessTimeStr : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u624B\u7EED\u8D39'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(commission) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u786E\u8BA4\u5B8C\u6210\u65F6\u95F4'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                this.timeFormat(confirmTimeStr)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingbottom' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop1' },
              '\u57FA\u91D1\u7533\u8D2D\u660E\u7EC6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1, display: "flex", flexDirection: "column" } },
              xinxi.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index },
                  item.businessType === "022" || item.businessType === "122" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1left', style: { flex: 1 } },
                        item.fundName,
                        '(',
                        item.fundCode,
                        ')'
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u7533\u8D2D\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationAmount ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.applicationAmount) + "元" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u6210\u4EA4\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmVolume === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.confirmVolume) : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "end" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u6210\u4EA4\u51C0\u503C'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u624B\u7EED\u8D39'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          _this3.timeFormat(item.confirmDateStr) || "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          _this3.timeFormat(item.confirmDateStr) || "--"
                        ) : null
                      )
                    ) : null
                  ) : null,
                  item.businessType === "036" || item.businessType === "136" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1left', style: { flex: 1 } },
                        item.fundName,
                        '(',
                        item.fundCode,
                        ')'
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u7533\u8D2D\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationAmount ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.applicationAmount) + "元" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u6210\u4EA4\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmVolume === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.confirmVolume) : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "end" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u6210\u4EA4\u51C0\u503C'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u624B\u7EED\u8D39'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } })
                  ) : null,
                  item.businessType === "036" || item.businessType === "136" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxizhuanhuan' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1r', style: { flex: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { flexDirection: "row", alignItems: "center", display: "flex" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaouyixiangqingbottommingxitiaocang1ryuan', style: { backgroundColor: "#D8D8D8" } }),
                          item.fundName,
                          '(',
                          item.fundCode,
                          ')'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxitiaocang1rtu' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'jiaouyixiangqingbottommingxitiaocang1rtu', src: __webpack_require__(1904) })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { alignItems: "center", flexDirection: "row", display: "flex" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaouyixiangqingbottommingxitiaocang1ryuan', style: { backgroundColor: "#B69271" } }),
                          item.targetFundName,
                          '(',
                          item.targetFundCode,
                          ')'
                        )
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u6362\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.applicationVolume) : ""
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u5165\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmAmount ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.confirmAmount) + "元" : "" : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end", alignContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2topxiamingzi' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999", textAlign: "left" } },
                            '\u6210\u4EA4\u51C0\u503C'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999", textAlign: "left" } },
                            '\u624B\u7EED\u8D39'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2topxia' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } })
                  ) : null,
                  item.businessType === "024" || item.businessType === "124" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1left' },
                        item.fundName,
                        '(',
                        item.fundCode,
                        ')'
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8D4E\u56DE\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.applicationVolume) : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u5230\u8D26\u91D1\u989D'
                            )
                          ),
                          item.confirmState === "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmAmount === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.confirmAmount) + "元"
                          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            '--'
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "end" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u6210\u4EA4\u51C0\u503C'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.confirmNav == null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount4(item.confirmNav) : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u624B\u7EED\u8D39'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_2__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } })
                  ) : null
                );
              })
            )
          )
        ),
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__myAssets_payment_Password__["a" /* default */], { _this: this, ztFlag: true, _type: 'ZT' }) : null
      );
    }
  }]);

  return Transferinrecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    shareToInfo: state.shareToInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Transferinrecord));

var styles = {
  container: {
    flex: 1
  },
  rsyzt: {
    height: 98,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
    // zIndex:3
  },
  mainrsyzt: {
    height: 64,
    backgroundColor: "#84C4F6",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
    // zIndex:3
  }
};

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_form__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_investmentAction__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_Transferrecord_css__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__css_Transferrecord_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__css_Transferrecord_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__myAssets_payment_Password__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//转出记录










var Transferrecord = function (_Component) {
  _inherits(Transferrecord, _Component);

  function Transferrecord(props) {
    _classCallCheck(this, Transferrecord);

    var _this2 = _possibleConstructorReturn(this, (Transferrecord.__proto__ || Object.getPrototypeOf(Transferrecord)).call(this, props));

    _this2.backThisFun = function () {
      _this2.setState({
        pwdFlag: true
      });
    };

    _this2.onChangePwd = function (val) {
      _this2.setState({
        keyPasswordVal: val
      });
    };

    _this2.keyOk = function () {
      __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].loading();
      var data = {
        tradeRequestId: _this2.props.location.state.tradeRequestId,
        password: __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.encrypt(_this2.state.keyPasswordVal)
      };
      _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["t" /* superfundCancelFun */])(data, function (index, suc) {
        console.log(suc);
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
        if (index === 1) {
          _this2.setState({
            isCancel: false,
            pwdFlag: false
          });
          __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].info("撤单成功", __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.ToastTime);
        }
      }, function () {
        __WEBPACK_IMPORTED_MODULE_8_antd_mobile_lib__["Toast"].hide();
      }));
    };

    _this2.state = {
      loadingFlag: false,
      xinxi: [],
      isCancel: false,
      pwdFlag: false,
      keyPasswordVal: ""
    };
    return _this2;
  }

  _createClass(Transferrecord, [{
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;

      var _this = this;
      var data1 = {
        tradeRequestId: this.props.location.state.tradeRequestId
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_investmentAction__["_77" /* ztcgjiaoyijiluxiangqing */])(data1, this.callbackData.bind(this), _this));
    }
  }, {
    key: 'callbackData',
    value: function callbackData(data, sec) {
      console.log(data);
      this.setState({
        xinxi: data,
        isCancel: sec
      });
    }
    // 去除时间的时分秒

  }, {
    key: 'timeFormat',
    value: function timeFormat(date) {
      var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
      return newDate[0];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          i = _state.i,
          xinxi = _state.xinxi;

      console.log(xinxi);
      var _props$location$state = this.props.location.state,
          superFundCode = _props$location$state.superFundCode,
          annualizedGains = _props$location$state.annualizedGains,
          confirmAmount = _props$location$state.confirmAmount,
          redeemRate = _props$location$state.redeemRate,
          commission = _props$location$state.commission,
          confirmTimeStr = _props$location$state.confirmTimeStr,
          businessTimeStr = _props$location$state.businessTimeStr,
          applicationAmount = _props$location$state.applicationAmount;

      console.log(superFundCode, annualizedGains, confirmAmount, redeemRate, commission, confirmTimeStr, businessTimeStr, applicationAmount);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'NHeader_container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'NHeader_wrap', style: { zIndex: 9 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'NHeader_content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_goback', onClick: this.goBack },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(152) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'NHeader_title' },
                '\u4EA4\u6613\u8BE6\u60C5'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: "20%", textAlign: "right" } },
                this.state.isCancel ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: this.backThisFun },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 18, color: "#ffff", fontWeight: "500" } },
                    '\u64A4\u5355'
                  )
                ) : null
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'jiaoyixiangqing', style: { zIndex: 10 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingtop' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop1' },
              '\u8F6C\u51FA\u4FE1\u606F'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u8F6C\u51FA\u6BD4\u4F8B'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                redeemRate == null ? "--" : parseFloat((redeemRate * 100).toPrecision(12)) + "%"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u8F6C\u51FA\u65F6\u95F4'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                businessTimeStr ? businessTimeStr : "--"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u5230\u8D26\u91D1\u989D'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                confirmAmount == null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(confirmAmount) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.superFundCodeArrByTarget.indexOf(superFundCode) !== -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u6B62\u76C8\u5B9E\u9645\u6536\u76CA\u7387'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                annualizedGains === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(annualizedGains) + "%"
              )
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u624B\u7EED\u8D39'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(commission) + "元"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2top' },
                '\u786E\u8BA4\u5B8C\u6210\u65F6\u95F4'
              ),
              confirmTimeStr == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                '--'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'jiaouyixiangqingtop2bottom' },
                this.timeFormat(confirmTimeStr)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'jiaouyixiangqingbottom' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'jiaouyixiangqingtop1' },
              '\u57FA\u91D1\u8D4E\u56DE\u660E\u7EC6'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1, display: "flex", flexDirection: "column" } },
              xinxi.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index },
                  item.businessType === "022" || item.businessType === "122" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1left', style: { flex: 1 } },
                        item.fundName,
                        '(',
                        item.fundCode,
                        ')'
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u7533\u8D2D\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationAmount) + "元" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u6210\u4EA4\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmVolume === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmVolume) : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "end" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u6210\u4EA4\u51C0\u503C'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u624B\u7EED\u8D39'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          _this3.timeFormat(item.confirmDateStr) || "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          _this3.timeFormat(item.confirmDateStr) || "--"
                        ) : null
                      )
                    ) : null
                  ) : null,
                  item.businessType === "036" || item.businessType === "136" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1left', style: { flex: 1 } },
                        item.fundName,
                        '(',
                        item.fundCode,
                        ')'
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u7533\u8D2D\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationAmount) + "元" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u6210\u4EA4\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmVolume === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmVolume) : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "end" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u6210\u4EA4\u51C0\u503C'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u624B\u7EED\u8D39'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } })
                  ) : null,
                  item.businessType === "036" || item.businessType === "136" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxitiaocang1r', style: { flex: 1 } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { flexDirection: "row", alignItems: "center", display: "flex" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaouyixiangqingbottommingxitiaocang1ryuan', style: { backgroundColor: "#D8D8D8" } }),
                          item.fundName,
                          '(',
                          item.fundCode,
                          ')'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxitiaocang1rtu' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'jiaouyixiangqingbottommingxitiaocang1rtu', src: __webpack_require__(1904) })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { alignItems: "center", flexDirection: "row", display: "flex" } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'jiaouyixiangqingbottommingxitiaocang1ryuan', style: { backgroundColor: "#B69271" } }),
                          item.targetFundName,
                          '(',
                          item.targetFundCode,
                          ')'
                        )
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u6362\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationVolume) : ""
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8F6C\u5165\u91D1\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmAmount ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmAmount) + "元" : "" : "--"
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "row", justifyContent: "flex-end", alignContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2topxiamingzi' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999", textAlign: "left" } },
                            '\u6210\u4EA4\u51C0\u503C'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#999999", textAlign: "left" } },
                            '\u624B\u7EED\u8D39'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2topxia' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.confirmNav ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--" : "--"
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } })
                  ) : null,
                  item.businessType === "024" || item.businessType === "124" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'jiaouyixiangqingbottommingxi' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi1' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1left' },
                        item.fundName,
                        '(',
                        item.fundCode,
                        ')'
                      ),
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#F8515C" } },
                          '\u786E\u8BA4\u5931\u8D25'
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'jiaouyixiangqingbottommingxi1right' },
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#999999" } },
                          '\u786E\u8BA4\u6210\u529F'
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { color: "#B69271" } },
                          item.confirmStateName
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi2' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u8D4E\u56DE\u4EFD\u989D'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.applicationVolume ? __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.applicationVolume) : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999" } },
                              '\u5230\u8D26\u91D1\u989D'
                            )
                          ),
                          item.confirmState === "1" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            item.confirmAmount === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.confirmAmount) + "元"
                          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333" } },
                            '--'
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "end" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u6210\u4EA4\u51C0\u503C'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.confirmNav == null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount4(item.confirmNav) : "--"
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'jiaouyixiangqingbottommingxi2top' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'jiaouyixiangqingbottommingxi2top1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { style: { color: "#999999", textAlign: "left" } },
                              '\u624B\u7EED\u8D39'
                            )
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { color: "#333333", textAlign: "left" } },
                            item.confirmState === "1" ? item.commision === null ? "--" : __WEBPACK_IMPORTED_MODULE_3__util_js___default.a.thousandCount(item.commision) + "元" : "--"
                          )
                        )
                      )
                    ),
                    item.confirmState === "0" || item.confirmState === "1" || item.confirmState === "2" || item.confirmState === "5" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'jiaouyixiangqingbottommingxi4' },
                      item.confirmState === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u5931\u8D25\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        )
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        item.confirmState === "1" || item.confirmState === "2" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'text',
                          { style: { color: "#999999", fontSize: 12 } },
                          '\u786E\u8BA4\u6210\u529F\u65F6\u95F4  ',
                          item.confirmDateStr ? _this3.timeFormat(item.confirmDateStr) : "--"
                        ) : null
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, flexDirection: "row" } })
                  ) : null
                );
              })
            )
          )
        ),
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__myAssets_payment_Password__["a" /* default */], { _this: this, ztFlag: true, _type: 'ZT' }) : null
      );
    }
  }]);

  return Transferrecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    shareToInfo: state.shareToInfo
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Transferrecord));

var styles = {
  container: {
    flex: 1
  },
  rsyzt: {
    height: 98,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
    // zIndex:3
  },
  mainrsyzt: {
    height: 64,
    backgroundColor: "#84C4F6",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
    // zIndex:3
  }
};

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GuidePageType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_guidePage_openAccount_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_guidePage_openAccount_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__imgs_guidePage_openAccount_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_guidePage_trade_png__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_guidePage_trade_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__imgs_guidePage_trade_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_icon_guidePage_png__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_icon_guidePage_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgs_icon_guidePage_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var GuidePageType = {
    OpenAccount: 'OPENACCOUNT', //开户
    Trade: "TRADE" //交易
};

var imgPage = function (_Component) {
    _inherits(imgPage, _Component);

    function imgPage(props) {
        _classCallCheck(this, imgPage);

        var _this = _possibleConstructorReturn(this, (imgPage.__proto__ || Object.getPrototypeOf(imgPage)).call(this, props));

        _this.onCloseView = function () {
            __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
        };

        _this.state = {};
        _this.guideType = _this.props.location.state.type;
        return _this;
    }

    _createClass(imgPage, [{
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'guide_page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'guide_page_top' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'guide_page_close', onClick: this.onCloseView },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'guide_page_image_icon', src: __WEBPACK_IMPORTED_MODULE_6__imgs_icon_guidePage_png___default.a })
                ),
                this.guideType === GuidePageType.OpenAccount ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'guide_page_image', src: __WEBPACK_IMPORTED_MODULE_4__imgs_guidePage_openAccount_png___default.a }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'guide_page_image', src: __WEBPACK_IMPORTED_MODULE_5__imgs_guidePage_trade_png___default.a })
            );
        }
    }]);

    return imgPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
    return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(imgPage));

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var iframeWeb = function (_Component) {
  _inherits(iframeWeb, _Component);

  function iframeWeb(props) {
    _classCallCheck(this, iframeWeb);

    var _this = _possibleConstructorReturn(this, (iframeWeb.__proto__ || Object.getPrototypeOf(iframeWeb)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(iframeWeb, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // setTimeout(function () { //延迟1s，为了确保iframe已经被加载完成，由于是动态创建的iframe，无法使用onload监听
      //    onLoad();
      // },1000);
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var url = this.props.location.query.url;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { WebkitFlex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn', onClick: function onClick() {
                  return _this2.goBack();
                } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 2, textAlign: 'center', fontSize: "0.3rem" } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { WebkitFlex: 1, textAlign: 'right', fontSize: "0.28rem", paddingRight: '13px' } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { ref: 'iframe', id: 'postMessage', src: url, frameborder: '0', width: '100%', height: window.screen.height - 44, style: { border: 0 } })
      );
    }
  }]);

  return iframeWeb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(iframeWeb));

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_js__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var intervalId = null;
var requestId = '';

var HxjjBindingMobile = function (_Component) {
  _inherits(HxjjBindingMobile, _Component);

  function HxjjBindingMobile(props) {
    var _this2 = this;

    _classCallCheck(this, HxjjBindingMobile);

    var _this = _possibleConstructorReturn(this, (HxjjBindingMobile.__proto__ || Object.getPrototypeOf(HxjjBindingMobile)).call(this, props));

    _this.handleVerify = function () {
      if (!_this.state.verifyCode || !_this.state.phoneNum) {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('请输入信息', 2);
        return;
      }
      if (!/^1[0123456789]\d{9}$/.test(_this.state.phoneNum)) {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      if (requestId === '' || !requestId) {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('请先申请手机验证码', 2);
        return;
      }
      var verifyParam = {
        requestId: requestId,
        mobileNo: _this.state.phoneNum,
        mobileCaptchaText: _this.state.verifyCode,
        token: _this.props.location.state.content.shortToken
      };
      _this.setState({
        flag: true
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__action_loginAction_js__["p" /* userBindingMobile */])(verifyParam, _this.props.location.state.content, function () {
        _this.verifySuccess();
      }, function (msg) {
        return _this.verifyError(msg);
      }));
    };

    _this.verifySuccess = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var currentUserInfo, userId_a, tradeAccountNo_a, paramsStr, paramsData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.goCallback = true;

              if (!(window.navigator.userAgent.indexOf("amcfmapp") > -1)) {
                _context.next = 5;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].go(-2);
              _context.next = 31;
              break;

            case 5:
              if (!_this.state.enterType) {
                _context.next = 30;
                break;
              }

              if (!(_this.state.enterType == 'SubscriptionDetail')) {
                _context.next = 10;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].go(-2);

              _context.next = 28;
              break;

            case 10:
              if (!(_this.state.enterType == 'Answer')) {
                _context.next = 15;
                break;
              }

              console.log("进入答题");
              __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].push({
                pathname: '/AnswerActivityDatillPage',
                state: {},
                query: { enterType: "Answer", activityId: _this.props.location.query.activityId }
              });
              _context.next = 28;
              break;

            case 15:
              if (!(_this.state.enterType == "activity")) {
                _context.next = 27;
                break;
              }

              _context.next = 18;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_js__["d" /* getStorage */])('currentUserInfo');

            case 18:
              currentUserInfo = _context.sent;
              userId_a = currentUserInfo.userId ? currentUserInfo.userId : "";
              tradeAccountNo_a = currentUserInfo.tradeAccountNo ? currentUserInfo.tradeAccountNo : "";
              paramsStr = "userId=" + userId_a + "&tradeAccountNo=" + tradeAccountNo_a;

              console.log(paramsStr);
              paramsData = window.encodeURIComponent(__WEBPACK_IMPORTED_MODULE_6__util_js___default.a.aesEncrypt(paramsStr));

              window.location.href = __WEBPACK_IMPORTED_MODULE_6__util_js___default.a.hdUrl + paramsData;
              _context.next = 28;
              break;

            case 27:
              __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].replace({
                pathname: '/?enterType="Investment'
              });

            case 28:
              _context.next = 31;
              break;

            case 30:
              __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].go(-3);

            case 31:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.verifyError = function (msg) {
      _this.setState({
        flag: false
      });
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(msg, 2);
    };

    _this.verifyRegisterPhoneSuc = function (phoneNum) {
      var params = { mobileNo: phoneNum };
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["r" /* realUserMobileCaptcha */])(params, function (requestid) {
        requestId = requestid;
      }));
    };

    _this.verifyRegisterPhoneErr = function (msg) {
      __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info(msg, 2);
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
      _this.setState({
        isRequestingVerifyCode: false
      });
    };

    _this.handleWaitingForVC = function () {
      if (!/^1[0123456789]\d{9}$/.test(_this.state.phoneNum)) {
        __WEBPACK_IMPORTED_MODULE_7_antd_mobile_lib__["Toast"].info('请输入正确的手机号码', 2);
        return;
      }
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__action_investmentAction_js__["d" /* verifyRegisterPhone */])({ mobileNo: _this.state.phoneNum }, function (phoneNum) {
        _this.verifyRegisterPhoneSuc(phoneNum);
      }, function (msg) {
        _this.verifyRegisterPhoneErr(msg);
      }));
      var countNum = 119;
      _this.setState({ isRequestingVerifyCode: true, countDown: countNum }, function () {
        intervalId = setInterval(function () {
          countNum--;
          if (countNum < 0) {
            cancelTimeOut();
            _this.setState({
              isRequestingVerifyCode: false
            });
          }
          _this.setState({
            countDown: countNum
          });
        }, 1000);
        var cancelTimeOut = function cancelTimeOut() {
          if (intervalId) clearInterval(intervalId);
          intervalId = null;
        };
      });
    };

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* hashHistory */].goBack();
    };

    _this.changePhoneNo = function (event) {
      _this.setState({
        phoneNum: event.target.value
      });
    };

    _this.changeVerifyCode = function (event) {
      _this.setState({
        verifyCode: event.target.value
      });
    };

    _this.clearPhoneNum = function () {
      _this.setState({
        phoneNum: ""
      });
    };

    _this.state = {
      verifyCode: '',
      phoneNum: '',
      isRequestingVerifyCode: false,
      countDown: 120,
      flag: false,
      enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null
    };
    _this.goCallback = false;
    return _this;
  }

  _createClass(HxjjBindingMobile, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      requestId = '';
      this.setState({
        flag: false
      });
      if (intervalId) {
        clearInterval(intervalId);
      };
      if (this.goCallback) {
        this.props.location.state.callback ? this.props.location.state.callback() : null;
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "绑定手机号";
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                '\u7ED1\u5B9A\u624B\u673A\u53F7'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: window.winWidth,
                height: "auto"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: {
                  color: '#5b6370',
                  marginTop: 25,
                  marginBottom: 12,
                  fontSize: 13,
                  marginLeft: 13,
                  marginRight: 13,
                  display: 'block',
                  lineHeight: "18px"
                } },
              '\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u4F60\u8FD8\u6CA1\u6709\u7ED1\u5B9A\u624B\u673A\u53F7\uFF01\u4E3A\u4E86\u786E\u4FDD\u60A8\u7684\u8D26\u6237\u5B89\u5168\uFF0C\u8BF7\u7ED1\u5B9A\u60A8\u7684\u624B\u673A\u53F7\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: window.winWidth,
                height: "auto"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  width: 'auto',
                  height: 45,
                  borderBottom: "1px solid  rgba(242,245,247,1)",
                  backgroundColor: '#ffffff',
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  display: "-webkit-flex",
                  position: "relative"
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: {
                    color: '#3a3e47',
                    paddingLeft: 13,
                    fontSize: 13,
                    width: 90
                  } },
                '\u624B\u673A\u53F7'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: {
                    display: "-webkit-flex",
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitFlex: 1
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, WebkitFlex: 1 }, placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.phoneNum, onChange: this.changePhoneNo }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.clearPhoneNum, src: __webpack_require__(47), style: { marginRight: -2, width: 44, height: 44 } })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                width: 'auto',
                height: 45,
                borderBottom: "1px solid  rgba(242,245,247,1)",
                backgroundColor: '#ffffff',
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                display: "-webkit-flex"
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: {
                  color: '#3a3e47',
                  paddingLeft: 13,
                  fontSize: 13,
                  width: 90
                } },
              '\u624B\u673A\u52A8\u6001\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: {
                  display: "-webkit-flex",
                  WebkitFlexDirection: 'row',
                  WebkitAlignItems: 'center',
                  WebkitFlex: 1
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { WebkitFlex: 1, paddingRight: 10 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { autocomplete: 'off', type: 'text', style: { color: "#3a3e47", fontSize: 13, width: "100%" }, placeholder: '\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801', value: this.state.verifyCode, onChange: this.changeVerifyCode })
              ),
              this.state.isRequestingVerifyCode ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: {
                    backgroundColor: '#d8dbdd',
                    height: 27,
                    borderRadius: 13,
                    paddingLeft: 10,
                    paddingRight: 10,
                    WebkitAlignItems: 'center',
                    WebkitJustifyContent: 'center',
                    display: "-webkit-flex",
                    marginRight: 10,
                    width: 110
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { style: { color: "#5b6370", fontSize: 13 } },
                  this.state.countDown,
                  '\u79D2\u540E\u91CD\u53D1'
                )
              ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { "white-space": "nowrap", width: 110, textAlign: "right", paddingRight: 13 } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  { onClick: this.handleWaitingForVC, style: {
                      color: '#fa063a',
                      fontSize: 13
                    } },
                  '\u83B7\u53D6\u9A8C\u8BC1\u7801'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: {
                marginTop: 15,
                marginLeft: 13,
                marginRight: 13,
                borderRadius: 20
              }, onClick: this.state.verifyCode && this.state.phoneNum ? this.handleVerify : null },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { backgroundColor: this.state.verifyCode && this.state.phoneNum ? '#fa063a' : '#afb0b2', WebkitAlignItems: 'center', WebkitJustifyContent: 'center', height: 40, borderRadius: 20, WebkitFlexDirection: 'row', display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { style: { color: '#ffffff', fontSize: 15 } },
                '\u7ED1\u5B9A'
              )
            )
          )
        )
      );
    }
  }]);

  return HxjjBindingMobile;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {};
};
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(HxjjBindingMobile));

/***/ }),
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_component_ProductInfo__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_ModalSelect__ = __webpack_require__(67);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var InvestmentFund = function (_Component) {
  _inherits(InvestmentFund, _Component);

  function InvestmentFund(props) {
    _classCallCheck(this, InvestmentFund);

    var _this = _possibleConstructorReturn(this, (InvestmentFund.__proto__ || Object.getPrototypeOf(InvestmentFund)).call(this, props));

    _this.keypress = function (e) {

      e.which == 13 && _this.handler();
    };

    _this.state = {
      serchVal: '',
      source1: [],
      serchFlag: false,
      serchSource: []
    };
    return _this;
  }

  _createClass(InvestmentFund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        source1: this.props.location.state.source1
      });
    }
  }, {
    key: 'selectFund',
    value: function selectFund(item) {
      var productType = void 0;
      if (item.fundTypeName == "超级基金型") {
        productType = 'Z';
      } else if (item.raiseMethod == '9') {
        productType = 'G';
      } else if (item.raiseMethod == '7') {
        productType = 'S';
      } else if (item.raiseMethod == '5') {
        productType = 'J';
      }
      if (item.fundTypeName == "超级基金型") {
        var params = {
          fundCode: item.fundCode,
          fundName: item.name,
          productType: "Z",
          pageText: "新建定投计划"
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, params, __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], 'PaymentAllSuperFund');
      } else {
        var _params = {
          fundName: item.name,
          fundCode: item.fundCode,
          businessType: 'T022',
          productType: productType,
          titleHeader: '新建定投计划',
          wanfenshouyi: item.wanfenshouyi,
          fundType: item.fundTypeName,
          currentNav: item.currentNav,
          currentNavDate: item.currentNavDate,
          item: item
        };
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPay__["j" /* getPayAll */])(window.history.length, _params, __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], 'FixedInvestment');
      }
    }
  }, {
    key: 'serchChange',
    value: function serchChange(e) {
      this.setState({
        serchVal: e.target.value
      });
    }
  }, {
    key: 'handler',
    value: function handler() {
      var _this2 = this;

      var data = [];
      this.state.source1.forEach(function (item, i) {
        if (item.name.indexOf(_this2.state.serchVal) > -1 || item.fundCode.indexOf(_this2.state.serchVal) > -1) {
          data.push(item);
        }
      });
      this.setState({
        serchSource: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          serchSource = _state.serchSource,
          serchFlag = _state.serchFlag;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container plan-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modal_ModalSelect__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { onKeyPress: this.keypress, onChange: this.serchChange.bind(this), value: this.state.serchVal, type: 'search', className: 'serchHeader-input' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'serchHeader-btn', onClick: function onClick() {
                  return __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
                } },
              '\u53D6\u6D88'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          serchSource.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: 'invest' + i },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__product_component_ProductInfo__["a" /* default */], { singlePoint: function singlePoint() {
                  return _this3.selectFund(item);
                },
                fundName: item.name,
                valName: '近一年收益',
                val: __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(item.yearsIncome[item.yearsIncome.length - 1] * 100, 2) + '%',
                valDate: __WEBPACK_IMPORTED_MODULE_3__util___default.a.returnDate(item.currentNavDate).substr(-5),
                rateName: '日涨跌幅',
                rate: '' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.fomatFloat(((item.yearsIncome[item.yearsIncome.length - 1] + 1) / (item.yearsIncome[item.yearsIncome.length - 1 - 1] + 1) - 1) * 100, 2)
              })
            );
          }),
          serchSource.length == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'plan-tip' },
            '\u6CA1\u6709\u7B26\u5408\u6761\u4EF6\u7684\u4EA7\u54C1'
          ) : null
        )
      );
    }
  }]);

  return InvestmentFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    inInvestmentFundList: state.InvestPlanReducer.inInvestmentFundList
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(InvestmentFund));

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BankCode_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myAssets_myCardAction__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_loginAction__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_myAssets_userInfoAction__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ReduxStore__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__css_Investment_css__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__css_Investment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__css_Investment_css__);


var _styles;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var CurrentDemand = function (_Component) {
  _inherits(CurrentDemand, _Component);

  function CurrentDemand(props) {
    var _this2 = this;

    _classCallCheck(this, CurrentDemand);

    var _this = _possibleConstructorReturn(this, (CurrentDemand.__proto__ || Object.getPrototypeOf(CurrentDemand)).call(this, props));

    _this.goDetail = function (data) {
      if (data.trustChannelDisplayName == "招商银行在线支付" && !data.enableCMBTrustChannel) {
        _this.setState({
          unUseBank: true
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
          pathname: "/HuoqitongDetail",
          state: {
            bankCode: data.bankCode,
            bankName: data.bankName,
            availableVolume: data.availableVolume,
            bankAccountShowNo: data.bankAccountShowNo,
            trustChannelDisplayName: data.trustChannelDisplayName,
            enableCMBTrustChannel: data.enableCMBTrustChannel,
            bankAccountShowNo2: data.bankAccountShowNo2 ? data.bankAccountShowNo2 : null,
            showOneKey: data.showOneKey
            // callback:()=> {  this.toGetCardList() }
          }
        });
      }
    };

    _this.closeMoadlLft = function () {
      _this.setState({
        tanCar: false
      });
    };

    _this.closeMoadls = function () {
      if (_this.state.Bools) {
        // if(this.state.dataVal.tradeAccountNo){
        //   this.setState({
        //     tanCar:false
        //   })
        // }else{
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_loginAction__["r" /* getTbuxyKh */])({}, function () {
          _this.setState({
            tanCar: false
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__getPay__["s" /* getOpenHqt */])(window.history.length, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], function () {
            _this.toGetCardList();_this.toGetUserInfoList();
          });
        }));
        // }
      } else {
        __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info("请先阅读并确认用户同步信息授权书", 2);
        return;
      }
    };

    _this.closeMoadl = function () {
      _this.setState({
        unUseBank: false
      });
    };

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    };

    _this.openHqt = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this$props, findHqtExist, verifiedUserInfo, dispatch, i, isRealHqt, didQuestionnairs;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, findHqtExist = _this$props.findHqtExist, verifiedUserInfo = _this$props.verifiedUserInfo, dispatch = _this$props.dispatch;

              console.log('findHqtExist', findHqtExist);
              i = localStorage.getItem("loginState");

              if (!(i && JSON.parse(i) == "2")) {
                _context.next = 43;
                break;
              }

              console.log("已经开户");
              isRealHqt = findHqtExist ? findHqtExist.tradeAccountNo : false;

              console.log(isRealHqt, "isRealHqtisRealHqtisRealHqt");

              if (!isRealHqt) {
                _context.next = 39;
                break;
              }

              if (!(findHqtExist.status == '2')) {
                _context.next = 13;
                break;
              }

              /*直销已销户状态按照直销未开户来处理*/
              _this.setState({ tanCar: true });
              // getOpenHqt(window.history.length,hashHistory,()=> { this.toGetCardList();  this.toGetUserInfoList(); })
              return _context.abrupt('return');

            case 13:
              if (!(findHqtExist.status != '0')) {
                _context.next = 18;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info("用户信息异常", __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
              return _context.abrupt('return');

            case 18:
              if (!(findHqtExist.name != verifiedUserInfo.content.name)) {
                _context.next = 21;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info("华夏基金和华夏财富信息不一致", __WEBPACK_IMPORTED_MODULE_4__util___default.a.ToastTime);
              return _context.abrupt('return');

            case 21:
              didQuestionnairs = false;
              _context.prev = 22;
              _context.next = 25;
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__getPay__["o" /* judgeQuestionnaires */])("S");

            case 25:
              didQuestionnairs = _context.sent;
              _context.next = 33;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context['catch'](22);

              __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].hide();
              __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info(_context.t0.message, 2);
              return _context.abrupt('return');

            case 33:
              if (didQuestionnairs) {
                _context.next = 36;
                break;
              }

              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], window.history.length, function () {
                _this.openHqt();
              });
              return _context.abrupt('return');

            case 36:

              __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
                pathname: '/HqtAddCard',
                state: {
                  router: window.history.length,
                  callback: function callback() {
                    _this.toGetCardList();
                  }
                }
              });
              _context.next = 41;
              break;

            case 39:
              _this.setState({ tanCar: true });
              console.log("getOpenHqtgetOpenHqtgetOpenHqt");
              // getOpenHqt(window.history.length,hashHistory,()=> { this.toGetCardList();  this.toGetUserInfoList(); })

            case 41:
              _context.next = 44;
              break;

            case 43:
              _this.setState({
                alertFlag: true
              });

            case 44:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[22, 28]]);
    }));

    _this.goRealName = function () {
      _this.setState({
        alertFlag: false
      });
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_myAssets_userInfoAction__["k" /* hqtExist */])(false));
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__getPay__["s" /* getOpenHqt */])(window.history.length, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], function () {
        _this.toGetCardList();
      });
    };

    _this.state = {
      cardListType: 0,
      bankCardArray: [],
      huoqitongArray: [],
      showComponent: false,
      unUseBank: false,
      alertFlag: false,
      Bools: false,
      tanCar: false,
      dataVal: ""
    };
    return _this;
  }

  _createClass(CurrentDemand, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_myCardAction__["b" /* hqtCardList */])([]));
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, i, _verifiedUserInfo;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = __WEBPACK_IMPORTED_MODULE_13__ReduxStore__["a" /* default */].getState().verifiedUserInfo.content;

                this.setState({ dataVal: data });
                i = localStorage.getItem("loginState");


                console.log(i, "iiiiii");
                if (i && JSON.parse(i) == "2") {
                  this.toGetUserInfoList();
                  this.toGetCardList();

                  _verifiedUserInfo = this.props.verifiedUserInfo; /*个人信息*/

                  console.log("个人信息", _verifiedUserInfo);
                  try {
                    this.userInfoCallBack(_verifiedUserInfo.content);
                  } catch (err) {
                    console.log(err, 'err');
                  }
                }

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'userInfoCallBack',
    value: function userInfoCallBack(data) {
      var inParamsData = {
        certNo: data.certNo,
        certType: data.certType,
        name: data.name
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_myAssets_userInfoAction__["a" /* findCamcHqtExist */])(inParamsData));
    }
  }, {
    key: 'toGetUserInfoList',
    value: function toGetUserInfoList() {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_loginAction__["b" /* getUserInfoList */])());
    }
  }, {
    key: 'toGetCardList',
    value: function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;

        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].loading();
                _context3.next = 3;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__common_js__["b" /* getTempInfo */])('shortToken');

              case 3:
                _context3.t0 = _context3.sent;
                params = {
                  token: _context3.t0
                };

                this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_myCardAction__["a" /* getCardList */])(params, function (content) {
                  return _this3.getCardListSuccess(content);
                }, function (msg) {
                  return _this3.getCardListError(msg);
                }));

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function toGetCardList() {
        return _ref3.apply(this, arguments);
      }

      return toGetCardList;
    }()
  }, {
    key: 'getCardListSuccess',
    value: function getCardListSuccess(content) {
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].hide();
      this.setState({ showComponent: true });
      //排序函数
      var newData = content.HqtCard;
      var allAbleVolume = 0;
      if (newData) {
        for (var i = 0; i < newData.length; i++) {
          allAbleVolume += newData[i].availableVolume;
        }
      }
      // this.setState({
      //   huoqitongArray: newData? newData : [],
      //   allAbleVolume
      // })
      this.setState({
        bankCardArray: content.bankCard ? content.bankCard : [],
        allAbleVolume: allAbleVolume
      });
    }
  }, {
    key: 'getCardListError',
    value: function getCardListError(msg) {
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].hide();
      __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib__["Toast"].info(msg, 2);
    }
  }, {
    key: 'navigatorToHuoqitongDetail',
    value: function navigatorToHuoqitongDetail(index) {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/HuoqitongDetail",
        state: {
          bankName: this.state.huoqitongArray[index].bankName,
          availableVolume: this.state.huoqitongArray[index].availableVolume,
          bankAccountShowNo: this.state.huoqitongArray[index].bankAccountShowNo,
          trustChannelDisplayName: this.state.huoqitongArray[index].trustChannelDisplayName
        }
      });
    }
  }, {
    key: 'RechargeHqt',
    value: function RechargeHqt() {
      var _props = this.props,
          dispatch = _props.dispatch,
          fundCode = _props.fundCode,
          hqtCardList = _props.hqtCardList;

      var data = {
        fundCode: '003003',
        businessType: 'T022',
        productType: 'G',
        bankAccountShowNo: hqtCardList[0].bankAccountShowNo
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__getPay__["j" /* getPayAll */])(window.history.length, data, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], 'RechargeHqt');
    }
  }, {
    key: 'navigatorToAddCard',
    value: function navigatorToAddCard() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: "/HqtAddCard",
        state: {
          router: window.history.length, hashHistory: __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */],
          callback: function callback() {
            _this4.toGetCardList();
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          dispatch = _props2.dispatch,
          findHqtExist = _props2.findHqtExist,
          hqtCardList = _props2.hqtCardList;
      var allAbleVolume = this.state.allAbleVolume;

      console.log(hqtCardList, "hqtCardListhqtCardListhqtCardListhqtCardList", findHqtExist);
      var bankCardArray = [];
      var huoqitongArray = [];

      if (this.state.huoqitongArray.length == 0) {
        huoqitongArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { key: -1, style: { display: "-webkit-flex", Webkitflex: 1, WebkitAlignItems: 'center', paddingTop: '50%', WebkitJustifyContent: 'center' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: { fontSize: 15 } },
            '\u6CA1\u6709\u53EF\u4F7F\u7528\u7684\u6D3B\u671F\u901A\u4EFD\u989D'
          )
        ));
      } else {
        var _loop = function _loop(i) {
          huoqitongArray.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { key: -i, style: _this5.state.huoqitongArray[i].trustChannelDisplayName == "招商银行在线支付" && !_this5.state.huoqitongArray[i].enableCMBTrustChannel ? styles.unHqtCardView : Object.assign(styles.HqtCardView, { width: window.winWidth }), onClick: function onClick() {
                _this5.goDetail(_this5.state.huoqitongArray[i]);
              }
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { display: "-webkit-flex" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: styles.HqtCardImgView },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 24.5, width: 24.5 }, src: __WEBPACK_IMPORTED_MODULE_6__BankCode_js__["b" /* bankCode */].ty[_this5.state.huoqitongArray[i].bankCode] })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex", Webkitflex: 1, WebkitFlexDirection: "column", WebkitAlignItems: "flex-start" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { marginBottom: 5 } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: 'rgb(0,0,0)', fontSize: 15, marginTop: 23.5 } },
                    _this5.state.huoqitongArray[i].bankName + '(*' + _this5.state.huoqitongArray[i].bankAccountShowNo.slice(-4) + ')'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  null,
                  _this5.state.huoqitongArray[i].trustChannelDisplayName == "招商银行在线支付" && !_this5.state.huoqitongArray[i].enableCMBTrustChannel ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: 'rgb(104,113,126)', fontSize: 12, paddingTop: 11 } },
                    '\u4E0D\u53EF\u7528'
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: 'rgb(104,113,126)', fontSize: 12, paddingTop: 11 } },
                    '\u53EF\u7528\u4F59\u989D: ',
                    __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(_this5.state.huoqitongArray[i].availableVolume),
                    '\u5143'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: styles.centerItems },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: styles.rightArrow, src: __webpack_require__(153) })
            )
          ));
        };

        for (var i = 0; i < this.state.huoqitongArray.length; i++) {
          _loop(i);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { backgroundColor: "#f2f5f7" }, className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'boxHeader' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              '\u6D3B\u671F\u901A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
        ),
        hqtCardList.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content', style: { paddingBottom: 40 } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { height: 124, backgroundColor: "#FFF", textAlign: 'center', marginBottom: 10, paddingTop: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: 15 } },
              '\u6D3B\u671F\u901A\u53EF\u7528\u4F59\u989D(\u5143)'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: 30, marginTop: 20 } },
              __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(allAbleVolume)
            )
          ),
          hqtCardList.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: -index, style: Object.assign(styles.HqtCardView, { width: window.winWidth }), onClick: function onClick() {
                  _this5.goDetail(item);
                }
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { display: "-webkit-flex" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: styles.HqtCardImgView },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { height: 24.5, width: 24.5 }, src: __WEBPACK_IMPORTED_MODULE_6__BankCode_js__["b" /* bankCode */].ty[item.bankCode] })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { display: "-webkit-flex", Webkitflex: 1, WebkitFlexDirection: "column", WebkitAlignItems: "flex-start" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { marginBottom: 5 } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: 'rgb(0,0,0)', fontSize: 15, marginTop: 23.5 } },
                      item.bankName + '(*' + item.bankAccountShowNo.slice(-4) + ')'
                    ),
                    item.enableCMBTrustChannel === false || item.enableCMBTrustChannel === "0" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: 'rgb(104,113,126)', fontSize: 12, padding: 2, marginLeft: 5, backgroundColor: "rgba(0,0,0,0.1)", justifyContent: "center" } },
                      '\u4E0D\u53EF\u7528'
                    ) : null
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: 'rgb(104,113,126)', fontSize: 12, paddingTop: 11 } },
                      '\u53EF\u7528\u4F59\u989D: ',
                      __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(item.availableVolume),
                      '\u5143'
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: styles.centerItems },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: styles.rightArrow, src: __webpack_require__(153) })
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, marginTop: "0.3rem", marginBottom: "0.4rem" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { color: '#FE492E', fontSize: 15, backgroundColor: '#FFF',
                  height: 40, borderRadius: 20, borderColor: "#e1e3e6", borderWidth: 1, textAlign: 'center', lineHeight: "40px"
                },
                onClick: function onClick() {
                  _this5.navigatorToAddCard();
                }
              },
              '+\u6DFB\u52A0\u94F6\u884C\u5361'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 8, paddingRight: 8, paddingBottom: 20 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { fontSize: 13, marginBottom: 5, color: "#5b6370" } },
              '\u6E29\u99A8\u63D0\u793A:'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: styles.txtStyle },
              ' 1\u3001\u6D3B\u671F\u901A\u662F\u6709\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\u7684\u7406\u8D22\u4EA7\u54C1\uFF0C\u60A8\u53EF\u4F7F\u7528\u6D3B\u671F\u901A\u4EFD\u989D\u7533\u8D2D\u534E\u590F\u8D22\u5BCC\u4EE3\u9500\u7684\u4EA7\u54C1,\u8BA4\u7533\u8D2D\u8D39\u7387\u6700\u4F4E\u53EF\u4EAB\u53D71\u6298\u4F18\u60E0;'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: styles.txtStyle },
              ' 2\u3001\u534E\u590F\u8D22\u5BCC\u4EC5\u53EF\u8FDB\u884C\u6D3B\u671F\u901A\u5145\u503C,\u5982\u9700\u529E\u7406\u6D3B\u671F\u901A\u8D4E\u56DE\u3001\u4EA4\u6613\u67E5\u8BE2\u7B49\u4E1A\u52A1,\u8BF7\u767B\u5F55\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6;'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: styles.txtStyle },
              ' 3\u3001\u5982\u9700\u53D8\u66F4\u6D3B\u671F\u901A\u5BF9\u5E94\u7684\u94F6\u884C\u5361,\u60A8\u9700\u8981\u5206\u522B\u767B\u9646\u534E\u590F\u57FA\u91D1\u5B98\u7F51\u548C\u534E\u590F\u8D22\u5BCC\u5B98\u7F51\u8FDB\u884C\u94F6\u884C\u5361\u53D8\u66F4,\u60A8\u4E5F\u53EF\u4EE5\u81F4\u7535\u5BA2\u670D\u70ED\u7EBF400-817-5666\u54A8\u8BE2\u529E\u7406\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { position: "fixed", bottom: 0, width: '100%', height: 40 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'currentDemandBot_btn' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'bottom_btn1', onClick: function onClick() {
                    __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({ pathname: "/home" });
                  } },
                '\u4E70\u57FA\u91D1'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'bottom_btn2', onClick: function onClick() {
                    _this5.RechargeHqt();
                  } },
                '\u5B58\u5165\u6D3B\u671F\u901A'
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'content', style: { background: "#FFF" } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: window.winWidth, height: window.winWidth * (650 / 750) }, src: __webpack_require__(739) }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 13, paddingRight: 12, paddingTop: '0.6rem' } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: styles.openHqtBtn, onClick: this.openHqt },
                '\u5F00\u901A\u6D3B\u671F\u901A'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { position: 'absolute', bottom: 15, left: 0 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { style: { width: window.winWidth, height: window.winWidth * (64 / 750) }, src: __webpack_require__(740) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modal_ModalList__["a" /* default */], { flag: this.state.unUseBank, btnRight: "确认", btnRightFun: this.closeMoadl, content: "该渠道份额不可用，需提交相关证明资料。如需办理，请联系您的理财顾问或拨打客服电话400-817-5666。", title: "银行渠道提示" }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modal_ModalList__["a" /* default */], { flag: this.state.alertFlag,
          btnLeft: "取消", btnLeftFun: function btnLeftFun() {
            _this5.setState({ alertFlag: false });
          },
          btnRight: "确认", btnRightFun: function btnRightFun() {
            _this5.goRealName();
          },
          content: "尊敬的客户，请先完成实名认证，方可开通华夏基金活期通。", title: "开通活期通提示"
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modal_ModalList__["a" /* default */], { onFun: function onFun(Bools) {
            _this5.setState({ Bools: Bools });
          }, flag: this.state.tanCar, btnLiftFun: this.closeMoadlLft, btnLift: "取消", btnRight: "确认", btnRightFun: this.closeMoadls, content: "为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》", title: "" })
      );
    }
  }]);

  return CurrentDemand;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var BankCard = function (_Component2) {
  _inherits(BankCard, _Component2);

  function BankCard(props) {
    _classCallCheck(this, BankCard);

    return _possibleConstructorReturn(this, (BankCard.__proto__ || Object.getPrototypeOf(BankCard)).call(this, props));
  }

  _createClass(BankCard, [{
    key: 'doSecureForBankCardNo',
    value: function doSecureForBankCardNo(bankCardNo) {
      var end = bankCardNo.substring(bankCardNo.length - 4, bankCardNo.length);
      return '**** **** **** ' + end;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          style: this.props.style,
          onClick: function onClick() {
            return __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
              pathname: "/CardDetail",
              state: {
                bankCardNo: _this7.props.bankCardNo,
                bankCode: _this7.props.bankCode,
                bankName: _this7.props.bankName,
                cardListType: _this7.props.cardListType,
                currentAccountId: _this7.props.currentAccountId,
                trustChannelId: _this7.props.trustChannelId
              }
            });
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: Object.assign({ backgroundImage: 'url(' + this.props.imageRequire + ')' }, styles.bankCardView, styles.bankCardImage, { width: window.winWidth - 26 }) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { style: styles.bankCardNo },
            this.doSecureForBankCardNo(this.props.bankCardNo)
          )
        )
      );
    }
  }]);

  return BankCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var styles = (_styles = {
  container: {
    display: "-webkit-flex",
    WebkitFlex: 1,
    WebkitAlignItems: 'stretch'
  },
  centerItems: {
    display: "-webkit-flex",
    WebkitFlexDirection: 'row',
    WebkitJustifyContent: 'center',
    WebkitAlignItems: 'center'
  },
  headerView: {
    display: "-webkit-flex",
    height: 44,
    backgroundColor: "rgb(38, 42, 48)",
    WebkitFlexDirection: "row",
    WebkitJustifyContent: "space-between",
    WebkitAlignItems: 'center'
  },
  headerLeftView: {
    marginTop: 0
  },
  headerMiddleView: {
    marginTop: 0,
    height: 44
  },
  headerRightView: {
    marginTop: 20
  },
  headerMiddleContent: {
    fontSize: 15,
    color: '#fff',
    backgroundColor: 'transparent'
  },
  headerRightContent: {
    height: 44,
    width: 44,
    backgroundColor: 'transparent'
  },
  headerTouchHighlightBtn: {
    marginLeft: 3.5,
    marginRight: 3.5,
    borderRadius: 13.5
  },
  inputContainer: {
    display: "-webkit-flex",
    width: 'auto',
    height: 45,
    borderBottomColor: 'rgba(242,245,247,1)',
    borderBottomWidth: 1,
    backgroundColor: '#ffffff',
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center'
  },
  flexViewContainer: {
    display: "-webkit-flex",
    WebkitFlex: 1,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center'
  }
}, _defineProperty(_styles, 'centerItems', {
  display: "-webkit-flex",
  WebkitFlexDirection: 'row',
  WebkitJustifyContent: 'center',
  WebkitAlignItems: 'center'
}), _defineProperty(_styles, 'headerItem', {
  display: "-webkit-flex",
  backgroundColor: '#FE492E',
  height: 27,
  width: 115,
  borderRadius: 13.5,
  WebkitFlexDirection: 'row',
  WebkitAlignItems: 'center',
  WebkitJustifyContent: 'center'
}), _defineProperty(_styles, 'headerItemInversed', {
  display: "-webkit-flex",
  backgroundColor: '#32393f',
  height: 27,
  width: 115,
  borderRadius: 13.5,
  WebkitFlexDirection: 'row',
  WebkitAlignItems: 'center',
  WebkitJustifyContent: 'center'
}), _defineProperty(_styles, 'rightArrow', {
  marginRight: -2,
  width: 44,
  height: 44
}), _defineProperty(_styles, 'bankCardScrollView', {
  overflow: "auto",
  paddingTop: 3
}), _defineProperty(_styles, 'bankCardHeight', {
  marginBottom: 10,
  marginLeft: 13,
  marginRight: 13
}), _defineProperty(_styles, 'bottomTouchHighlightBtn', {
  marginTop: 15,
  marginBottom: 15,
  marginLeft: 13,
  marginRight: 13,
  borderRadius: 20
}), _defineProperty(_styles, 'loginView', {
  display: "-webkit-flex",
  backgroundColor: '#FE492E',
  height: 40,
  borderRadius: 20,
  WebkitFlexDirection: 'row',
  WebkitAlignItems: 'center',
  WebkitJustifyContent: 'center'
}), _defineProperty(_styles, 'bankCardImage', {
  display: "-webkit-flex",
  WebkitAlignSelf: 'stretch',
  WebkitFlex: 1
}), _defineProperty(_styles, 'bankCardView', {
  display: "-webkit-flex",
  backgroundColor: 'rgba(0,0,0,0)',
  WebkitFlex: 1,
  WebkitAlignSelf: 'stretch',
  height: 85,
  backgroundSize: "contain",
  position: "relative"
}), _defineProperty(_styles, 'bankCardNo', {
  display: "-webkit-flex",
  fontSize: 22,
  lineHeight: "22px",
  color: '#ffffff',
  WebkitAlignSelf: 'flex-end',
  right: 13,
  bottom: 8,
  position: 'absolute'
}), _defineProperty(_styles, 'HqtCardView', {
  display: "-webkit-flex",
  width: 'auto',
  height: 86,
  borderBottomColor: 'rgba(242,245,247,1)',
  borderBottomWidth: 1,
  WebkitFlexDirection: "row",
  WebkitAlignItems: 'center',
  backgroundColor: '#fff',
  borderBottomStyle: "solid",
  WebkitJustifyContent: "space-between"
}), _defineProperty(_styles, 'unHqtCardView', {
  width: 'auto',
  height: 86,
  borderBottomColor: 'rgba(242,245,247,1)',
  borderBottomWidth: 1,
  WebkitFlexDirection: "row",
  WebkitAlignItems: 'center',
  backgroundColor: 'rgba(0,0,0,0.1)'
}), _defineProperty(_styles, 'HqtCardImgView', {
  marginLeft: 13,
  marginRight: 5,
  height: 44.5,
  width: 24.5
}), _defineProperty(_styles, 'openHqtBtn', {
  backgroundColor: "#FE492E", height: "0.8rem", alignItems: 'center', justifyContent: 'center',
  borderRadius: 20,
  color: "#FFF", lineHeight: "0.8rem", textAlign: 'center'
}), _defineProperty(_styles, 'txtStyle', {
  lineHeight: '16px', fontSize: 12, marginTop: 10,
  color: "#a1a7b2"
}), _styles);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    verifiedUserInfo: state.verifiedUserInfo,
    findHqtExist: state.findHqtExist,
    payLoading: state.payLoading,
    hqtCardList: state.hqtCardList
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CurrentDemand));

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BankCode_js__ = __webpack_require__(29);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var HqtAddCard = function (_Component) {
	_inherits(HqtAddCard, _Component);

	function HqtAddCard(props) {
		_classCallCheck(this, HqtAddCard);

		var _this = _possibleConstructorReturn(this, (HqtAddCard.__proto__ || Object.getPrototypeOf(HqtAddCard)).call(this, props));

		_this.goBack = function () {
			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
		};

		_this.showModal = function (no, tranlId) {
			var cardListCf = _this.state.cardListCf;

			if (cardListCf.length > 0) {
				for (var i = 0; i < cardListCf.length; i++) {
					if (cardListCf[i].bankCode == no) {
						_this.setState({
							cardNo: cardListCf[i].bankAccountShowNo,
							cardName: cardListCf[i].bankName,
							setModalShow: true,
							tranlId: tranlId,
							bankCodeNo: no
						});
						break;
					} else {
						if (i == cardListCf.length - 1) {
							_this.toNext("", tranlId, no);
							break;
						}
					}
				}
			} else {
				_this.toNext("", tranlId, no);
			}
		};

		_this.hiddenModal = function () {
			_this.setState({
				setModalShow: false
			});
		};

		_this.toNext = function (num, tranlId, bankCodeNo) {
			var _this$props$location$ = _this.props.location.state,
			    router = _this$props$location$.router,
			    callback = _this$props$location$.callback,
			    isShow = _this$props$location$.isShow,
			    fundCode = _this$props$location$.fundCode;
			var verifiedUserInfo = _this.props.verifiedUserInfo;
			var _verifiedUserInfo$con = verifiedUserInfo.content,
			    name = _verifiedUserInfo$con.name,
			    certType = _verifiedUserInfo$con.certType,
			    certNo = _verifiedUserInfo$con.certNo,
			    mobileNo = _verifiedUserInfo$con.mobileNo;

			_this.setState({
				setModalShow: false
			});
			console.log(callback, "HqtAddCard---callBack");
			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
				pathname: "/HqtBindCard",
				state: {
					bankAccountShowNo: num,
					paymentChannelId: tranlId,
					bankAccountName: name,
					certType: certType,
					certNo: certNo,
					router: router,
					bankCode: bankCodeNo,
					openHqt: true,
					mobileNo: mobileNo,
					callback: callback,
					isShow: isShow,
					fundCode: fundCode
				}
			});
		};

		_this.state = {
			setModalShow: false,
			cardList: [],
			cardListCf: [],
			flag: true,
			cardName: "",
			cardNo: "",
			tranlId: "",
			bankCodeNo: ""
		};
		return _this;
	}

	_createClass(HqtAddCard, [{
		key: 'componentDidMount',
		value: function componentDidMount() {}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			var _props = this.props,
			    dispatch = _props.dispatch,
			    openHqt = _props.openHqt,
			    findHqtExist = _props.findHqtExist;

			console.log(findHqtExist);
			var tradeAccountNo = findHqtExist.tradeAccountNo;

			var params = {};
			var errback = function errback() {
				_this2.setState({
					flag: false
				});
			};
			var callback = function callback(result) {
				_this2.setState({
					cardList: result,
					flag: false
				});
				var callbackSec = function callbackSec(result) {
					_this2.setState({
						cardListCf: result
					});
				};
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__["f" /* getCardListByCf */])(params, callbackSec, errback));
			};
			if (openHqt) {
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__["g" /* getCardByHqtOpen */])(params, callback, errback));
			} else {
				var paramsSec = {
					otsTradeAccountNo: tradeAccountNo
				};
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__["h" /* getCardByHqt */])(paramsSec, callback, errback));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var openHqt = true;
			var _state = this.state,
			    setModalShow = _state.setModalShow,
			    cardList = _state.cardList,
			    flag = _state.flag,
			    cardName = _state.cardName,
			    cardNo = _state.cardNo,
			    tranlId = _state.tranlId,
			    bankCodeNo = _state.bankCodeNo;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								null,
								openHqt ? "开通活期通" : "添加银行卡"
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'content' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { flex: 1 } },
						cardList.length > 0 && !flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									{ style: { fontSize: 13, color: "#5b6370" } },
									'\u8BF7\u9009\u62E9\u6240\u5C5E\u94F6\u884C'
								)
							),
							cardList.map(function (data, index) {
								return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									{ key: index, style: styles.container, onClick: function onClick() {
											_this3.showModal(data.bankCode, data.paymentChannelId);
										} },
									__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { height: 24.5, width: 24.5 }, src: __WEBPACK_IMPORTED_MODULE_9__BankCode_js__["b" /* bankCode */].ty[data.bankCode] }),
									__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
										'div',
										{ style: { flex: 1, paddingLeft: 10 } },
										data.paymentChannelName
									),
									__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: styles.rightArrow, src: __webpack_require__(153) })
								);
							}),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { marginTop: 15, paddingLeft: 13, paddingRight: 13, paddingBottom: 13 } },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									{ style: { height: 30, fontSize: 12 } },
									'\u6E29\u99A8\u63D0\u793A :'
								),
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'div',
									{ style: { color: 'rgba(130,138,138,1)', fontSize: 12, lineHeight: '12px' } },
									'\u540C\u4E00\u4E2A\u94F6\u884C\u4EC5\u652F\u6301\u4E00\u5F20\u94F6\u884C\u5361\u5F00\u901A\u6D3B\u671F\u901A\uFF0C\u5982\u9700\u6362\u5361\uFF0C\u8BF7\u5148\u89E3\u7ED1\u539F\u94F6\u884C\u5361\uFF0C\u518D\u91CD\u65B0\u7ED1\u5B9A\u65B0\u5361  '
								)
							)
						) : cardList.length <= 0 && !flag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20 } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: { fontSize: 15 } },
								'\u60A8\u6240\u6DFB\u52A0\u7684\u94F6\u884C\u5361\u5DF2\u6EE1, \u6682\u65F6\u65E0\u6CD5\u6DFB\u52A0'
							)
						) : null
					)
				),
				setModalShow ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__["c" /* AddCardHqtAlert */], {
					title: "温馨提示",
					content: "您已经在华夏财富绑定过尾号为*" + cardNo.slice(-4) + "的" + cardName + "卡，是否要开通该银行卡活期通？",
					CloseAler: function CloseAler() {
						_this3.setState({ setModalShow: false });
					},
					handleBtn1: function handleBtn1() {
						_this3.toNext(cardNo, tranlId, bankCodeNo);
					},
					handleBtn2: function handleBtn2() {
						_this3.toNext("", tranlId, bankCodeNo);
					},
					btnfirText: '\u786E\u5B9A',
					btnsecText: '\u5176\u4ED6\u94F6\u884C\u5361'
				}) : null
			);
		}
	}]);

	return HqtAddCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = {
	centerItems: {
		display: "-webkit-flex",
		WebkitFlexDirection: 'row',
		WebkitJustifyContent: 'center',
		WebkitAlignItems: 'center'
	},
	headerLeftView: {
		marginTop: 20,
		height: 44
	},
	headerMiddleView: {
		marginTop: 20,
		height: 44
	},
	headerRightView: {
		marginTop: 20,
		height: 44
	},
	headerLeftContent: {
		width: 44
	},
	headerMiddleContent: {
		fontSize: 13,
		color: '#fff',
		backgroundColor: 'transparent'
	},
	headerRightContent: {
		width: 44,
		fontSize: 13,
		color: '#fff',
		backgroundColor: 'transparent'
	},
	touchHighlightBtn: {
		marginTop: 14,
		marginLeft: 13,
		marginRight: 13,
		borderRadius: 20
	},
	loginView: {
		display: "-webkit-flex",
		backgroundColor: '#FE492E',
		height: 40,
		borderRadius: 20,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	},
	inversedLoginView: {
		display: "-webkit-flex",
		backgroundColor: '#ffffff',
		borderColor: '#fe492e',
		borderStyle: "solid",
		height: 40,
		borderWidth: 1,
		borderRadius: 20,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	},
	rightArrow: {
		marginRight: -2,
		width: 44,
		height: 44
	},
	container: {
		display: "-webkit-flex",
		height: 45,
		borderBottom: '1px solid rgb(235, 238, 240)',
		justifyContent: "space-between",
		alignItems: "center",
		flexDirection: "row",
		paddingLeft: 13,
		paddingRight: 5,
		backgroundColor: "#fff"
	}
};

function mapStateToProps(state, ownProps) {
	return {
		verifiedUserInfo: state.verifiedUserInfo,
		findHqtExist: state.findHqtExist
	};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HqtAddCard));

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BankCode_js__ = __webpack_require__(29);
var _styles;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var HqtBindCard = function (_Component) {
	_inherits(HqtBindCard, _Component);

	function HqtBindCard(props) {
		_classCallCheck(this, HqtBindCard);

		var _this = _possibleConstructorReturn(this, (HqtBindCard.__proto__ || Object.getPrototypeOf(HqtBindCard)).call(this, props));

		_this.goCertification = function () {
			var _this$state = _this.state,
			    phoneNumber = _this$state.phoneNumber,
			    cardNumber = _this$state.cardNumber;
			var _this$props$location$ = _this.props.location.state,
			    paymentChannelId = _this$props$location$.paymentChannelId,
			    bankAccountName = _this$props$location$.bankAccountName,
			    router = _this$props$location$.router,
			    certType = _this$props$location$.certType,
			    certNo = _this$props$location$.certNo,
			    bankCode = _this$props$location$.bankCode,
			    openHqt = _this$props$location$.openHqt,
			    callback = _this$props$location$.callback,
			    isShow = _this$props$location$.isShow,
			    fundCode = _this$props$location$.fundCode;

			var regPhone = /^1[0123456789]\d{9}$/;
			if (!regPhone.test(phoneNumber)) {
				__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].show("手机号有误，请重新输入", 2);
				return;
			}

			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
				pathname: "/HqtCheckCard",
				state: {
					paymentChannelId: paymentChannelId,
					bankAccountShowNo: cardNumber,
					mobileNo: phoneNumber,
					bankAccountName: bankAccountName,
					certType: certType,
					certNo: certNo,
					bankCode: bankCode,
					router: router,
					openHqt: openHqt,
					callback: callback,
					isShow: isShow,
					fundCode: fundCode
				}
			});
		};

		_this.changeCardNumber = function (value) {
			_this.setState({
				cardNumber: value
			});
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__["b" /* htqAddCardNum */])(value));
		};

		_this.changePhoneNumber = function (value) {
			_this.setState({
				phoneNumber: value
			});
		};

		_this.changeAgree = function () {
			_this.setState({
				agreeIcon: _this.state.agreeIcon ? false : true
			});
		};

		_this.goBack = function () {
			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
		};

		_this.state = {
			cardNumber: _this.props.location && _this.props.location.state.bankAccountShowNo ? _this.props.location.state.bankAccountShowNo : _this.props.htqAddCardNum,
			agreeIcon: false,
			phoneNumber: _this.props.location && _this.props.location.state.mobileNo ? _this.props.location.state.mobileNo : ""
		};
		return _this;
	}

	_createClass(HqtBindCard, [{
		key: 'handleJumpToProtocol',
		value: function handleJumpToProtocol(title) {
			var code = __WEBPACK_IMPORTED_MODULE_8__BankCode_js__["a" /* protocolCode */][title];
			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
				pathname: '/WebView',
				state: { name: title, code: code },
				query: { code: code }
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var openHqt = this.props.location.state && this.props.location.state.openHqt;
			var _state = this.state,
			    phoneNumber = _state.phoneNumber,
			    cardNumber = _state.cardNumber,
			    agreeIcon = _state.agreeIcon;
			var htqAddCardNum = this.props.htqAddCardNum;

			console.log;
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								null,
								openHqt ? "开通活期通" : "添加银行卡"
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'content' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: "13px", color: "#5b6370" } },
							'\u8BF7\u7ED1\u5B9A\u60A8\u672C\u4EBA\u7684\u94F6\u884C\u5361'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: styles.inputContainer },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: styles.centerItems },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								{ style: styles.leftText },
								'\u94F6\u884C\u5361'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: styles.flexViewContainer },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
								style: styles.rightTextInput,
								value: this.state.cardNumber,
								onChange: function onChange(event) {
									_this2.changeCardNumber(event.target.value);
								},
								type: 'text',
								placeholder: '\u8BF7\u8F93\u5165\u5361\u53F7'
							})
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: styles.inputContainer },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: styles.centerItems },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								{ style: styles.leftText },
								'\u624B\u673A\u53F7'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: styles.flexViewContainer },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
								type: 'text',
								style: styles.rightTextInput,
								value: phoneNumber,
								onChange: function onChange(event) {
									_this2.setState({ phoneNumber: event.target.value });
								},
								placeholder: '\u8BF7\u8F93\u5165\u94F6\u884C\u9884\u7559\u624B\u673A\u53F7'
							})
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { display: "-webkit-flex", WebkitFlexDirection: "row", /*WebkitAlignItems: "center",*/paddingRight: 13, paddingLeft: 13 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ onClick: this.changeAgree },
							agreeIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { height: 44, width: 44, marginRight: 5, marginLeft: -8 }, src: __webpack_require__(766) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { height: 44, width: 44, marginRight: 5, marginLeft: -8 }, src: __webpack_require__(51) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ onClick: this.changeAgree, style: { paddingTop: 10, marginLeft: -5 } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								{ style: { color: "#5b6370", fontSize: 12, lineHeight: "20px" } },
								'\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'span',
									{ style: { color: '#f8986a' }, onClick: function onClick() {
											_this2.handleJumpToProtocol('上海华夏财富投资管理有限公司快易付业务协议');
										} },
									'\u300A\u4E0A\u6D77\u534E\u590F\u8D22\u5BCC\u6295\u8D44\u7BA1\u7406\u6709\u9650\u516C\u53F8\u5FEB\u6613\u4ED8\u4E1A\u52A1\u534F\u8BAE\u300B'
								)
							)
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: styles.touchHighlightBtn, delayPressIn: 0, onClick: cardNumber && phoneNumber && agreeIcon ? function () {
								_this2.goCertification();
							} : null },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: Object.assign(styles.nextStepBtn, { backgroundColor: cardNumber && phoneNumber && agreeIcon ? '#FE492E' : '#afb0b2' }) },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								{ style: { color: '#ffffff', fontSize: 15 } },
								'\u4E0B\u4E00\u6B65'
							)
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { marginTop: 20, paddingLeft: 13, paddingRight: 13 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { height: 30, fontSize: 12 } },
							'\u6E29\u99A8\u63D0\u793A :'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { color: 'rgba(130,138,138,1)', fontSize: 12, lineHeight: "22px" } },
							'1\u3001\u6D3B\u671F\u901A\u662F\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\u7684\u7406\u8D22\u4EA7\u54C1\uFF0C\u534E\u590F\u8D22\u5BCC\u5C06\u4E3A\u60A8\u5728\u534E\u590F\u57FA\u91D1\u5F00\u7ACB\u76F4\u9500\u8D26\u6237\uFF0C\u5E76\u63D0\u4F9B\u6D3B\u671F\u901A\u5145\u503C\u4E1A\u52A1\uFF1B'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { color: 'rgba(130,138,138,1)', fontSize: 12, lineHeight: "22px" } },
							'2\u3001\u5982\u9700\u53D8\u66F4\u6D3B\u671F\u901A\u5BF9\u5E94\u7684\u94F6\u884C\u5361\uFF0C\u60A8\u9700\u5206\u522B\u767B\u5F55\u534E\u590F\u57FA\u91D1\u5B98\u7F51\u548C\u534E\u590F\u8D22\u5BCC\u5B98\u7F51\u8FDB\u884C\u94F6\u884C\u5361\u53D8\u66F4\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u81F4\u7535\u5BA2\u670D\u70ED\u7EBF400-817-5666\u54A8\u8BE2\u529E\u7406\u3002'
						)
					)
				)
			);
		}
	}]);

	return HqtBindCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = (_styles = {
	centerItems: {
		display: "-webkit-flex",
		WebkitFlexDirection: 'row',
		WebkitJustifyContent: 'center',
		WebkitAlignItems: 'center'
	},
	headerLeftView: {
		marginTop: 20,
		height: 44
	},
	headerMiddleView: {
		marginTop: 20,
		height: 44
	},
	headerRightView: {
		marginTop: 20,
		height: 44
	},
	headerLeftContent: {
		width: 44
	},
	headerMiddleContent: {
		fontSize: 13,
		color: '#fff',
		backgroundColor: 'transparent'
	},
	headerRightContent: {
		width: 44,
		fontSize: 13,
		color: '#fff',
		backgroundColor: 'transparent'
	},
	touchHighlightBtn: {
		marginTop: 14,
		marginLeft: 13,
		marginRight: 13,
		borderRadius: 20
	},
	loginView: {
		display: "-webkit-flex",
		backgroundColor: '#FE492E',
		height: 40,
		borderRadius: 20,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	},
	inversedLoginView: {
		display: "-webkit-flex",
		backgroundColor: '#ffffff',
		borderColor: '#fe492e',
		borderStyle: "solid",
		height: 40,
		borderWidth: 1,
		borderRadius: 20,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	},
	rightArrow: {
		marginRight: -2,
		width: 44,
		height: 44
	},
	container: {
		display: "-webkit-flex",
		height: 45,
		borderBottom: '1px solid rgb(235, 238, 240)',
		justifyContent: "space-between",
		alignItems: "center",
		flexDirection: "row",
		paddingLeft: 13,
		paddingRight: 5,
		backgroundColor: "#fff"
	},
	nextStepBtn: {
		display: "-webkit-flex",
		backgroundColor: '#FE492E',
		borderRadius: 20,
		height: 40,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	},
	inputContainer: {
		display: "-webkit-flex",
		width: 'auto',
		height: 45,
		borderBottomColor: 'rgba(242,245,247,1)',
		borderBottomWidth: 1,
		borderBottomStyle: "solid",
		backgroundColor: '#ffffff',
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center'
	}
}, _defineProperty(_styles, 'centerItems', {
	display: "-webkit-flex",
	WebkitFlexDirection: 'row',
	WebkitJustifyContent: 'center',
	WebkitAlignItems: 'center'
}), _defineProperty(_styles, 'leftText', {
	color: '#3a3e47',
	marginLeft: 13,
	fontSize: 13,
	width: 68
}), _defineProperty(_styles, 'flexViewContainer', {
	display: "-webkit-flex",
	WebkitFlex: 1,
	WebkitFlexDirection: 'row',
	WebkitAlignItems: 'center'
}), _styles);

function mapStateToProps(state, ownProps) {
	return {
		verifiedUserInfo: state.verifiedUserInfo,
		findHqtExist: state.findHqtExist,
		htqAddCardNum: state.htqAddCardNum
	};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HqtBindCard));

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myCardsAction__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction__ = __webpack_require__(97);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var HqtCheckCard = function (_Component) {
  _inherits(HqtCheckCard, _Component);

  function HqtCheckCard(props) {
    _classCallCheck(this, HqtCheckCard);

    var _this = _possibleConstructorReturn(this, (HqtCheckCard.__proto__ || Object.getPrototypeOf(HqtCheckCard)).call(this, props));

    _this.goCertification = function () {
      var _this$props$location$ = _this.props.location.state,
          router = _this$props$location$.router,
          bankAccountName = _this$props$location$.bankAccountName,
          mobileNo = _this$props$location$.mobileNo,
          paymentChannelId = _this$props$location$.paymentChannelId,
          bankAccountShowNo = _this$props$location$.bankAccountShowNo,
          bankCode = _this$props$location$.bankCode,
          certType = _this$props$location$.certType,
          certNo = _this$props$location$.certNo,
          openHqt = _this$props$location$.openHqt,
          callback = _this$props$location$.callback,
          isShow = _this$props$location$.isShow,
          fundCode = _this$props$location$.fundCode;
      var _this$props = _this.props,
          findHqtExist = _this$props.findHqtExist,
          dispatch = _this$props.dispatch;
      var _this$state = _this.state,
          requestNo = _this$state.requestNo,
          checkCard = _this$state.checkCard,
          checkFlag = _this$state.checkFlag;
      var tradeAccountNo = findHqtExist.tradeAccountNo;

      if (!checkFlag) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].show("请先获取验证码", 2);
        return false;
      }
      _this.setState({
        flag: true
      });
      var data = {
        authRequestNo: requestNo,
        captcha: checkCard
      };
      var errback = function errback() {
        _this.setState({
          flag: false
        });
      };
      var callbacks = function callbacks(result) {
        var dataSec = {
          bankAccountName: bankAccountName,
          bankAccountShowNo: bankAccountShowNo,
          bankCode: bankCode,
          authRequestSNo: requestNo,
          certType: certType,
          certNo: certNo,
          trustChannelId: paymentChannelId,
          mobileNo: mobileNo,
          otsTradeAccountNo: tradeAccountNo
        };
        var dataThr = {
          bankAccountShowNo: bankAccountShowNo,
          bankCode: bankCode,
          requestNo: requestNo,
          certificateType: certType,
          certificateNo: certNo,
          paymentChannelId: paymentChannelId,
          mobileNo: mobileNo,
          name: bankAccountName
        };
        console.log(dataSec);
        console.log(dataThr);
        var callbackSec = function callbackSec(result) {
          _this.setState({
            flag: false
          });

          __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
            pathname: "/HqtSuccess",
            state: {
              router: router,
              bankAccountShowNo: bankAccountShowNo,
              openHqt: openHqt,
              callback: callback,
              isShow: isShow,
              fundCode: fundCode
            }
          });
          _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction__["b" /* htqAddCardNum */])(""));
        };
        if (result) {
          // if(openHqt) {
          //   dispatch(addCardByHqtOpenFinish(dataThr, callbackSec, errback));
          // }else {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction__["c" /* addCardByHqtFinish */])(dataSec, callbackSec, errback));
          // }
        } else {
          _this.setState({
            flag: false
          });
        }
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction__["d" /* addCardByHqtOk */])(data, callbacks, errback));
    };

    _this.changeCheckCard = function (value) {
      _this.setState({
        checkCard: value
      });
    };

    _this.getCheckCard = function () {
      var count = 119;
      var thisO = _this;
      var _this$props$location$2 = _this.props.location.state,
          bankAccountName = _this$props$location$2.bankAccountName,
          certType = _this$props$location$2.certType,
          certNo = _this$props$location$2.certNo,
          mobileNo = _this$props$location$2.mobileNo,
          bankAccountShowNo = _this$props$location$2.bankAccountShowNo,
          paymentChannelId = _this$props$location$2.paymentChannelId;
      var dispatch = _this.props.dispatch;

      var businessType = "AddCard";

      thisO.setState({
        cardVal: count + "秒后重发",
        checkFlag: true,
        flag: true
      });
      __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].loading();
      _this.time = setInterval(function () {
        count--;
        thisO.setState({
          cardVal: count + "秒后重发",
          checkFlag: true
        });
        if (count == 0) {
          clearInterval(_this.time);
          thisO.setState({
            cardVal: "获取验证码",
            checkFlag: false
          });
        }
      }, 1000);
      var data = {
        name: bankAccountName,
        certNo: certNo,
        certType: certType,
        mobileNo: mobileNo,
        bankAccountShowNo: bankAccountShowNo,
        trustChannelId: paymentChannelId,
        businessType: businessType
      };
      console.log(data);
      var callback = function callback(result) {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        _this.setState({
          requestNo: result.requestNo,
          flag: false
        });
      };
      var errback = function errback() {
        __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib__["Toast"].hide();
        _this.setState({
          flag: false
        });
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction__["e" /* addCardByHqtPost */])(data, callback, errback));
    };

    _this.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    };

    _this.state = {
      checkCard: "",
      cardVal: "获取验证码",
      checkFlag: false,
      flag: false,
      requestNo: ""
    };
    _this.time = '';
    return _this;
  }

  _createClass(HqtCheckCard, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.time);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var openHqt = this.props.location.state && this.props.location.state.openHqt;
      var _state = this.state,
          checkCard = _state.checkCard,
          checkFlag = _state.checkFlag,
          cardVal = _state.cardVal,
          flag = _state.flag;
      var findHqtExist = this.props.findHqtExist;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'mainBox' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'boxHeader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                openHqt ? "开通活期通" : "添加银行卡"
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'boxContent' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { fontSize: 13, color: "#5b6370" } },
              '\u8BF7\u8F93\u5165\u60A8\u6536\u5230\u7684\u77ED\u4FE1\u9A8C\u8BC1\u7801'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.contentList },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: styles.listText },
              '\u9A8C\u8BC1\u7801'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              type: 'text',
              style: styles.textInput,
              value: checkCard,
              onChange: function onChange(event) {
                _this2.setState({ checkCard: event.target.value });
              },
              placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801'
            }),
            checkFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.checkCardBox2 },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: styles.checkCardText2 },
                cardVal
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: styles.checkCardBox, onClick: this.getCheckCard },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: styles.checkCardText },
                '\u83B7\u53D6\u9A8C\u8BC1\u7801'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.touchHighlightBtn, delayPressIn: 0, onClick: checkCard != "" ? function () {
              _this2.goCertification();
            } : null },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: Object.assign(styles.nextStepBtn, { backgroundColor: checkCard != "" ? '#FE492E' : '#afb0b2' }) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: '#ffffff', fontSize: 15 } },
              '\u4E0B\u4E00\u6B65'
            )
          )
        )
      );
    }
  }]);

  return HqtCheckCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HqtCheckCard));

var styles = {
  btnSuccess: {
    display: "-webkit-flex",
    marginTop: 15,
    height: 40,
    backgroundColor: "#FE492E",
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    marginLeft: 13,
    marginRight: 13,
    marginBottom: 15
  },
  contentList: {
    display: "-webkit-flex",
    height: 45,
    backgroundColor: "#fff",
    paddingLeft: 13,
    paddingRight: 13,
    WebkitAlignItems: "center",
    WebkitFlexDirection: "row",
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: 'rgb(235, 238, 240)'
  },
  contentList2: {
    display: "-webkit-flex",
    height: 45,
    backgroundColor: "#fff",
    paddingLeft: 13,
    paddingRight: 13,
    WebkitAlignItems: "center",
    WebkitFlexDirection: "row"
  },
  listText: {
    color: "#5b6370",
    fontSize: 13
  },
  textInput: {
    height: 40,
    width: 200,
    fontSize: 13,
    marginLeft: 10,
    marginTop: 3,
    color: "#3a3e47"
  },
  disableBtnSuccess: {
    display: "-webkit-flex",
    marginTop: 15,
    height: 40,
    backgroundColor: "#afb0b2",
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    marginLeft: 13,
    marginRight: 13,
    marginBottom: 15
  },
  checkCardBox: {
    display: "-webkit-flex",
    backgroundColor: "#FE492E",
    height: 30,
    width: 90,
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    position: "absolute",
    right: 13
  },
  checkCardText: {
    color: "#fff",
    fontSize: 13
  },
  checkCardBox2: {
    display: "-webkit-flex",
    backgroundColor: "#afb0b2",
    height: 30,
    width: 100,
    WebkitJustifyContent: "center",
    WebkitAlignItems: "center",
    borderRadius: 30,
    position: "absolute",
    right: 13
  },
  checkCardText2: {
    color: "#5b6370",
    fontSize: 13
  },
  nextStepBtn: {
    display: "-webkit-flex",
    backgroundColor: '#FE492E',
    borderRadius: 20,
    height: 40,
    WebkitFlexDirection: 'row',
    WebkitAlignItems: 'center',
    WebkitJustifyContent: 'center'
  },
  touchHighlightBtn: {
    marginTop: 14,
    marginLeft: 13,
    marginRight: 13,
    borderRadius: 20
  }
};

function mapStateToProps(state, ownProps) {
  return {
    checkNumber: state.checkNumber,
    findHqtExist: state.findHqtExist
  };
}

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_productAction__ = __webpack_require__(28);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var HqtSuccess = function (_Component) {
	_inherits(HqtSuccess, _Component);

	function HqtSuccess(props) {
		_classCallCheck(this, HqtSuccess);

		var _this = _possibleConstructorReturn(this, (HqtSuccess.__proto__ || Object.getPrototypeOf(HqtSuccess)).call(this, props));

		_this.state = {};
		_this.goCallback = false;
		return _this;
	}

	_createClass(HqtSuccess, [{
		key: 'funRight',
		value: function funRight() {
			var _this2 = this;

			var _props$location$state = this.props.location.state,
			    router = _props$location$state.router,
			    callback = _props$location$state.callback,
			    fundCode = _props$location$state.fundCode,
			    productType = _props$location$state.productType;
			// navigator.popToRoute(router)

			this.goCallback = true;
			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-4);
			setTimeout(function () {
				_this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__action_productAction__["I" /* getTradeInfo */])(fundCode, 'T522', productType, function (result, i, type) {
					Object.assign(result, { currentType: type }, { currentIndex: i });
					_this2.props.dispatch({
						type: "SUPER_FUND_PAY_INFO",
						text: result
					});
				}));
			});
		}
	}, {
		key: 'RechargeHqt',
		value: function RechargeHqt() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].go(-4);
			setTimeout(function () {
				var bankAccountShowNo = _this3.props.location.state.bankAccountShowNo;

				var data = {
					fundCode: '003003',
					businessType: 'T022',
					productType: 'G',
					bankAccountShowNo: bankAccountShowNo,
					refresh: true,
					_fundCode: _this3.props.location.state.fundCode
				};
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getPay__["j" /* getPayAll */])(window.history.length, data, __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */], 'RechargeHqt');
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.goCallback) {
				this.props.location.state.callback ? this.props.location.state.callback() : null;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var _props$location$state2 = this.props.location.state,
			    openHqt = _props$location$state2.openHqt,
			    isShow = _props$location$state2.isShow;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'header black' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ onClick: function onClick() {
									return __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							openHqt ? "开通活期通" : "添加银行卡"
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ onClick: function onClick() {
									_this4.funRight();
								}, style: { marginRight: 13 } },
							'\u5B8C\u6210'
						)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, backgroundColor: "#fff", paddingBottom: 20, paddingTop: 40 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingBottom: 10 } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
								src: __webpack_require__(432),
								style: { width: 62, height: 62 }
							})
						),
						openHqt ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { WebkitAlignItems: "center", marginBottom: 10, textAlign: "center" } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ style: { color: "#5b6370", fontSize: 13, marginBottom: 10 } },
								'\u534E\u590F\u57FA\u91D1\u76F4\u9500\u8D26\u6237\u5F00\u901A\u6210\u529F'
							),
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ style: { color: "#5b6370", fontSize: 13 } },
								'\u6D3B\u671F\u901A\u5F00\u901A\u6210\u529F'
							)
						) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { WebkitAlignItems: "center", marginBottom: 10, textAlign: "center" } },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'p',
								{ style: { color: "#5b6370", fontSize: 13 } },
								'\u6D3B\u671F\u901A\u5F00\u901A\u6210\u529F'
							)
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { marginTop: 30 } },
						isShow ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{
								style: styles.touchHighlightBtn,
								delayPressIn: 0,
								onClick: function onClick() {
									_this4.RechargeHqt();
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: styles.loginView },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'span',
									{ style: { color: '#fff', fontSize: 15 } },
									'\u7ACB\u5373\u5145\u503C'
								)
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: Object.assign(styles.touchHighlightBtn, { marginTop: 7 }), onClick: function onClick() {
									_this4.funRight();
								} },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'div',
								{ style: styles.inversedLoginView },
								__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
									'span',
									{ style: { color: '#FE492E', fontSize: 15 } },
									'\u8FD4\u56DE'
								)
							)
						)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'addCard-tipBox' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'p',
						{ style: { marginTop: 15 } },
						'\u6E29\u99A8\u63D0\u793A :'
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'p',
						null,
						'1\u3001\u6D3B\u671F\u901A\u662F\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\u7684\u7406\u8D22\u4EA7\u54C1\uFF0C\u534E\u590F\u8D22\u5BCC\u5C06\u4E3A\u60A8\u5728\u534E\u590F\u57FA\u91D1\u5F00\u7ACB\u76F4\u9500\u8D26\u6237\uFF0C\u5E76\u63D0\u4F9B\u6D3B\u671F\u901A\u5145\u503C\u4E1A\u52A1\uFF1B'
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'p',
						null,
						'2\u3001\u5982\u9700\u53D8\u66F4\u6D3B\u671F\u901A\u5BF9\u5E94\u7684\u94F6\u884C\u5361\uFF0C\u60A8\u9700\u5206\u522B\u767B\u5F55\u534E\u590F\u57FA\u91D1\u5B98\u7F51\u548C\u534E\u590F\u8D22\u5BCC\u5B98\u7F51\u8FDB\u884C\u94F6\u884C\u5361\u53D8\u66F4\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u81F4\u7535\u5BA2\u670D\u70ED\u7EBF400-817-5666\u54A8\u8BE2\u529E\u7406\u3002'
					)
				)
			);
		}
	}]);

	return HqtSuccess;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = {
	touchHighlightBtn: {
		marginTop: 14,
		marginLeft: 13,
		marginRight: 13,
		borderRadius: 20
	},
	loginView: {
		display: "-webkit-flex",
		backgroundColor: '#FE492E',
		height: 40,
		borderRadius: 20,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	},
	inversedLoginView: {
		display: "-webkit-flex",
		backgroundColor: '#ffffff',
		borderColor: '#fe492e',
		borderStyle: "solid",
		height: 40,
		borderWidth: 1,
		borderRadius: 20,
		WebkitFlexDirection: 'row',
		WebkitAlignItems: 'center',
		WebkitJustifyContent: 'center'
	}
};

function mapStateToProps(state, ownProps) {
	return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HqtSuccess));

/***/ }),
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_tree_filter__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_array_tree_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_array_tree_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__investPlan_InvestmentPlan_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__investPlan_InvestmentPlan_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__investPlan_InvestmentPlan_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pay_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Pay_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PayWarmTips__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_portfolioAction__ = __webpack_require__(91);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var CustomChildren = function CustomChildren(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      onClick: props.onClick,
      className: 'text-bar'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      props.children
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      props.extra,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'toBottom', style: { marginRight: '-13px' } })
    )
  );
};
var accountTip;
var account;

var FixedInvestmentSuperFund = function (_Component) {
  _inherits(FixedInvestmentSuperFund, _Component);

  function FixedInvestmentSuperFund(props) {
    _classCallCheck(this, FixedInvestmentSuperFund);

    var _this = _possibleConstructorReturn(this, (FixedInvestmentSuperFund.__proto__ || Object.getPrototypeOf(FixedInvestmentSuperFund)).call(this, props));

    _this.state = {
      pickerValue: [0, 1],
      agreeIndex: 0,
      pwdFlag: false,
      keyPasswordVal: '',
      amount: '',
      dayIncomeDate: '',
      ThreeIncome: '',
      dataSouse: [{
        label: '每月',
        value: 0,
        key: 0,
        children: [{ label: '1日', value: 1, key: 0 }, { label: '2日', value: 2, key: 1 }, { label: '3日', value: 3, key: 2 }, { label: '4日', value: 4, key: 3 }, { label: '5日', value: 5, key: 4 }, { label: '6日', value: 6, key: 5 }, { label: '7日', value: 7, key: 6 }, { label: '8日', value: 8, key: 7 }, { label: '9日', value: 9, key: 8 }, { label: '10日', value: 10, key: 9 }, { label: '11日', value: 11, key: 10 }, { label: '12日', value: 12, key: 11 }, { label: '13日', value: 13, key: 12 }, { label: '14日', value: 14, key: 13 }, { label: '15日', value: 15, key: 14 }, { label: '16日', value: 16, key: 15 }, { label: '17日', value: 17, key: 16 }, { label: '18日', value: 18, key: 17 }, { label: '19日', value: 19, key: 18 }, { label: '20日', value: 20, key: 19 }, { label: '21日', value: 21, key: 20 }, { label: '22日', value: 22, key: 21 }, { label: '23日', value: 23, key: 22 }, { label: '24日', value: 24, key: 23 }, { label: '25日', value: 25, key: 24 }, { label: '26日', value: 26, key: 25 }, { label: '27日', value: 27, key: 26 }, { label: '28日', value: 28, key: 27 }]
      }]
    };
    return _this;
  }

  _createClass(FixedInvestmentSuperFund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      document.title = "定投计划修改";
      var _props$location$state = this.props.location.state,
          fundCode = _props$location$state.fundCode,
          productType = _props$location$state.productType;

      var dataAmount = {
        tradeType: 'T022',
        fundCode: fundCode
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["_3" /* getTradeInfo2 */])(fundCode, 'T522', productType));
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_productAction__["_4" /* getLimitAmount */])(dataAmount, function (val) {
        _this2.setState({ amount: val });
      }));
      var inData = {
        superFundCode: fundCode,
        periodType: 0
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_portfolioAction__["a" /* getSuperFundProductIncome */])(inData, function (data) {
        var leng = data.incomeDateList.length - 1;
        var dataP = (data.incomeList[leng] + 1) / (data.incomeList[0] + 1);
        var nH = Math.pow(dataP, 240 / (leng + 1)) - 1;
        var yearIncomeRate = __WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(nH * 100); /*年化收益率*/
        _this2.setState({
          ThreeIncome: yearIncomeRate,
          dayIncomeDate: data.incomeDateList[leng].replace(/\//g, "-")
        });
      }, this));
      this.setState({
        pickerValue: [0, this.props.location.state.planItem.tradeDates[0]]
      });
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        keyPasswordVal: val
      });
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(text) {
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_publicAction__["d" /* myPaymentText */])(text));
    }
  }, {
    key: 'ProtocolPaper',
    value: function ProtocolPaper(name) {
      var code = __WEBPACK_IMPORTED_MODULE_8__BankCode__["a" /* protocolCode */][name];
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/WebView',
        state: { name: name, code: code },
        query: { code: code }
      });
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var agreeIndex = this.state.agreeIndex;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
      } else {
        this.setState({
          agreeIndex: 0
        });
      }
    }
  }, {
    key: 'next',
    value: function next() {
      var _props = this.props,
          payInfoData = _props.payInfoData,
          paymentText = _props.paymentText;
      var amount = this.state.amount;

      if (amount > paymentText) {
        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].info('投资金额不可低于' + amount + '元', __WEBPACK_IMPORTED_MODULE_5__util___default.a.ToastTime);
        return;
      }
      this.setState({
        pwdFlag: true
      });
    }
  }, {
    key: 'keyOk',
    value: function keyOk() {
      var _this3 = this;

      var _props2 = this.props,
          payInfoData = _props2.payInfoData,
          dispatch = _props2.dispatch;
      var _props$location$state2 = this.props.location.state,
          planItem = _props$location$state2.planItem,
          fundCode = _props$location$state2.fundCode,
          fundName = _props$location$state2.fundName;

      var pushResult = function pushResult(i, result) {
        if (i === 1) {
          __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Toast"].hide();
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '定投计划',
              content: '定投签约完成',
              dataSouse: [['申请编号', result.content.planId], ['产品名称', fundName], ['投资金额', _this3.props.paymentText + '元']],
              souseVal: ['返回智投首页']
            }
          });
        } else if (i === 3) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '定投计划',
              content: '定投签约失败',
              content2: result,
              dataSouse: [],
              souseVal: ['返回智投首页', '联系客服']
            }
          });
        }
      };
      if (planItem.type == '12') {
        console.log('修改活期通');
        var data = {
          password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(this.state.keyPasswordVal),
          tradeDates: this.state.pickerValue[1],
          tradeAmount: this.props.paymentText,
          planId: planItem.planId
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_myAssets_InvestPlanAction_js__["c" /* modifyPlan */])(data, pushResult));
      } else if (planItem.type == '0') {
        console.log('修改银行卡');
        var _data = {
          password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(this.state.keyPasswordVal),
          fundCode: planItem.fundCode,
          periodTradeType: 0,
          tradeDates: this.state.pickerValue[1],
          tradeAmount: this.props.paymentText,
          planId: planItem.planId
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_myAssets_InvestPlanAction_js__["d" /* modifyBuyPlan */])(_data, pushResult));
      } else if (planItem.type == '11' || planItem.type == '2') {
        console.log(this.props);
        var _data2 = {
          password: __WEBPACK_IMPORTED_MODULE_5__util___default.a.encrypt(this.state.keyPasswordVal),
          fundCode: planItem.convertOutFundCode,
          targetFundCode: planItem.fundCode,
          tradeDays: this.state.pickerValue[1],
          tradeAmount: this.props.paymentText,
          planId: planItem.planId,
          trustChannelId: this.props.location.state.trustChannelId
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__action_myAssets_InvestPlanAction_js__["m" /* moneyFundPlanModifyValidate */])(_data2, pushResult));
      }
    }
  }, {
    key: 'choseBank',
    value: function choseBank() {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: '/paymentBankList',
        state: {
          fundCode: this.props.location.state.fundCode
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      var payInfoData = this.props.payInfoData;
      var _props$location$state3 = this.props.location.state,
          titleHeader = _props$location$state3.titleHeader,
          fundName = _props$location$state3.fundName,
          fundCode = _props$location$state3.fundCode,
          planItem = _props$location$state3.planItem;

      if (planItem.type == '12') {
        for (var i = 0; i < payInfoData.content.shareList.length; i++) {
          if (planItem.bankAccountShowNo == payInfoData.content.shareList[i].bankAccountShowNo) {
            accountTip = '可用余额:' + __WEBPACK_IMPORTED_MODULE_5__util___default.a.parsePrice(payInfoData.content.shareList[i].availableVolume);
            account = payInfoData.content.shareList[i].availableVolume;
          }
        }
      } else if (planItem.type == '0') {
        for (var i = 0; i < payInfoData.content.currentAccountList.length; i++) {
          if (planItem.bankAccountShowNo == payInfoData.content.currentAccountList[i].bankAccountShowNo) {
            accountTip = payInfoData.content.currentAccountList[i].tradeMaxAmountTips.split("|")[1];
            account = payInfoData.content.currentAccountList[i].tradeMaxAmountTips.split("|")[0];
          }
        }
      } else if (planItem.type == '11' || planItem.type == '2') {
        payInfoData.content.currencyFund.forEach(function (x, i) {
          console.log(_this4.props.location.state);
          if (x.fundCode == planItem.convertOutFundCode && x.trustChannelId == _this4.props.location.state.trustChannelId) {
            accountTip = '\u53EF\u7528\u4F59\u989D:' + x.availableVolume;
            account = x.availableVolume;
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              titleHeader
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fixed-invest-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fixed-invest-header-top' },
              fundName + '(' + fundCode + ')'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fixed-invest-header-bottom' },
              '\u5E74\u5316\u6536\u76CA\uFF1A' + __WEBPACK_IMPORTED_MODULE_5__util___default.a.fomatFloat(this.state.ThreeIncome, 2) + '%(' + __WEBPACK_IMPORTED_MODULE_5__util___default.a.returnDate(this.state.dayIncomeDate) + ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'share' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'shareTitle' },
              '\u652F\u4ED8\u6E20\u9053'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fixed-invest-card-wrad', style: { marginBottom: 10 } },
            planItem.type == '11' || planItem.type == '2' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: 'currentAccountList', className: 'bankList' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(429), className: 'img', style: { width: 24, height: 31 } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListTip' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  planItem.convertOutFundName,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontSize: 12, color: '#5b6370' } },
                    '(' + __WEBPACK_IMPORTED_MODULE_5__util___default.a.formatStr(planItem.trustChannelName) + ')'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  accountTip
                )
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: 'currentAccountList', className: 'bankList' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8__BankCode__["b" /* bankCode */]['ty'][planItem.bankCode] ? __WEBPACK_IMPORTED_MODULE_8__BankCode__["b" /* bankCode */]['ty'][planItem.bankCode] : __webpack_require__(39), className: 'img' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListTip' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  planItem.trustChannelName ? planItem.trustChannelName.split('*')[0] + '(*' + planItem.trustChannelName.split('*')[1] + ')' : '--'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  accountTip
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'input' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u6BCF\u671F\u6295\u8D44\u91D1\u989D(\u5143)'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', value: this.props.paymentText, className: 'dt-memony', placeholder: '\u6700\u4F4E\u6295\u8D44\u91D1\u989D' + __WEBPACK_IMPORTED_MODULE_5__util___default.a.parsePrice(this.state.amount) + '\u5143', onChange: function onChange(e) {
                return _this4.onChangeText(e.target.value);
              }, type: 'text' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["Picker"],
            {
              title: '\u9009\u62E9\u5B9A\u6295\u5468\u671F',
              extra: this.state.pickerValue,
              cols: 2,
              data: this.state.dataSouse,
              value: this.state.pickerValue,
              onChange: function onChange(v) {
                console.log(v);_this4.setState({ pickerValue: v });
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              CustomChildren,
              null,
              '\u6263\u6B3E\u5468\u671F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dt-xy-box' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: img_arr[this.state.agreeIndex], className: 'imgBtn', onClick: function onClick() {
                return _this4.isAgreeClick();
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'red-t', onClick: function onClick() {
                    return _this4.ProtocolPaper('华夏查理智投定期定额申请协议');
                  } },
                '\u300A\u534E\u590F\u67E5\u7406\u667A\u6295\u5B9A\u671F\u5B9A\u989D\u7533\u8BF7\u534F\u8BAE\u300B'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PayWarmTips__["a" /* default */], { fundLimit: this.props.location.state.fundLimit, buyType: 'SF' }),
          __WEBPACK_IMPORTED_MODULE_5__util___default.a.regular1.test(this.props.paymentText) && this.state.agreeIndex !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this4.next();
              }, className: 'btn' },
            '\u4E0B\u4E00\u6B65'
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray' },
            '\u4E0B\u4E00\u6B65'
          )
        ),
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', top: 0, width: '100%', height: '100%', background: 'rgba(52,52,52,0.4)' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'fixed', bottom: 0, width: '100%', height: '70%', background: '#fff' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'relative', height: '45px', lineHeight: '45px', textAlign: 'center', borderBottom: '0.005rem solid rgb(224,227,279)', fontSize: '0.3rem' } },
              '\u4EA4\u6613\u5BC6\u7801',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), style: { position: 'absolute', left: 0, width: '0.88rem', height: '0.88rem' }, onClick: function onClick() {
                  _this4.setState({ pwdFlag: false });
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { position: 'absolute', top: 0, right: 0, width: '45px', fontSize: '13px' }, className: 'red-t', onClick: function onClick() {
                    _this4.keyOk();
                  } },
                ' \u786E\u8BA4'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '0.3rem 0.3rem 0rem 0.3rem', fontSize: '13px' } },
              this.props.location.state.fundRisk ? '温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。' : ''
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '45px', padding: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                  return _this4.onChangePwd(e.target.value);
                }, autofocus: 'autofocus', style: { height: '45px', width: '100%', fontSize: '0.3rem', border: '1px solid #afafaf', borderRadius: '0.1rem' }, type: 'password', placeholder: '' })
            )
          )
        ) : null
      );
    }
  }]);

  return FixedInvestmentSuperFund;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  return {
    payInfoData: state.payInfo,
    paymentText: state.paymentText
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(FixedInvestmentSuperFund));

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getPay__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var HqtCard = function (_Component) {
  _inherits(HqtCard, _Component);

  function HqtCard(props) {
    _classCallCheck(this, HqtCard);

    var _this = _possibleConstructorReturn(this, (HqtCard.__proto__ || Object.getPrototypeOf(HqtCard)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(HqtCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      console.log("this.props.location.fetch");
    }
  }, {
    key: 'choseBank',
    value: function choseBank() {
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
        pathname: '/HqtCardList',
        state: {
          type: this.props.type,
          actionType: this.props.actionType,
          // businessType:this.props.businessType,
          // text:this.props.text,
          // currentIndex:this.props.currentIndex,
          // currencyFundChange:this.props.currencyFundChange,
          // currentType:this.props.currentType,
          // payInfoData:this.props.payInfoData,
          callback: this.props.fetch
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          payInfoData = _props.payInfoData,
          currentType = _props.currentType,
          currentIndex = _props.currentIndex;

      console.log(window.funSplit("500000.0"), "****");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { marginBottom: 10 } },
        payInfoData.content.currentAccountList.length > 0 && payInfoData.currentIndex != -1 ? payInfoData.content.currentAccountList.map(function (item, i) {
          if (item.bankCode == _this2.props.hqtXz) {
            if (item.disable) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: 'currentAccountList' + i, onClick: function onClick() {
                    return _this2.choseBank();
                  }, className: 'bankList' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), className: 'img' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'bankListTip' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankName) + '(*' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')',
                    item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == null ? item.enableCMBTrustChannel === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { color: 'rgb(104,113,126)', fontSize: 12, padding: 2, backgroundColor: "rgba(0,0,0,0.1)", justifyContent: "center", marginLeft: "5px" } },
                      '\u4E0D\u53EF\u7528'
                    ) : null : null
                  ),
                  item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    '\u62DB\u884C\u5361\u6682\u4E0D\u53EF\u7528\uFF0C\u8BF7\u60A8\u53BB\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6App\u64CD\u4F5C\u6216\u54A8\u8BE2\u5BA2\u670D'
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    window.funSplit(item.tradeMaxAmountTips)[1],
                    ' '
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bankListRight' })
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.choseBank();
                  }, style: { fontSize: 15, height: '1.7rem', backgroundColor: '#fefefe', textAlign: 'center', lineHeight: '1.7rem' } },
                '\u65E0\u652F\u4ED8\u65B9\u5F0F'
              );
            }
          }
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              return _this2.choseBank();
            }, style: { fontSize: 15, height: '1.7rem', backgroundColor: '#fefefe', textAlign: 'center', lineHeight: '1.7rem' } },
          '\u65E0\u652F\u4ED8\u65B9\u5F0F'
        )
      );
    }
  }]);

  return HqtCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(state, ownProps);
  return {
    payInfoData: state[ownProps.type + 'PayInfo'],
    hqtXz: state.hqtXz
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(HqtCard));

/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modal_ModalSelectTip__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_investmentAction__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { changepayInfoData.CurrentIndex ,changepayInfoData.CurrentType} from '../../../action/productAction';









var PayCardList = function (_Component) {
  _inherits(PayCardList, _Component);

  function PayCardList(props) {
    _classCallCheck(this, PayCardList);

    var _this = _possibleConstructorReturn(this, (PayCardList.__proto__ || Object.getPrototypeOf(PayCardList)).call(this, props));

    _this.closeMoadl = function () {
      _this.setState({
        alertFlag: false
      });
    };

    _this.state = {
      unUseBank: false,
      unUseBankTip: '',
      alertFlag: false
    };
    return _this;
  }

  _createClass(PayCardList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "选择支付方式";
      if (this.props.location.state && this.props.location.state.callback) {
        this.props.location.state.callback();
      }
    }
  }, {
    key: 'choseBank',
    value: function choseBank(item, i) {
      console.log(item);
      if (item.bankAccountShowNo2) {
        this.setState({
          alertFlag: true,
          alertContent: '\u7531\u4E8E\u60A8\u5728\u534E\u590F\u57FA\u91D1\u7684' + item.bankName + '\uFF08*' + item.bankAccountShowNo.slice(-4) + '\uFF09\u4E0E\u534E\u590F\u8D22\u5BCC\u7684' + item.bankName + '\uFF08*' + item.bankAccountShowNo2.slice(-4) + '\uFF09\u4FE1\u606F\u4E0D\u4E00\u81F4\uFF0C\u8BE5\u6E20\u9053\u6D3B\u671F\u901A\u4EFD\u989D\u6682\u4E0D\u53EF\u7528\u3002\u5982\u9700\u94F6\u884C\u5361\u4FE1\u606F\u53D8\u66F4\uFF0C\u8BF7\u60A8\u5206\u522B\u5728\u534E\u590F\u57FA\u91D1\u5B98\u7F51\u548C\u534E\u590F\u8D22\u5BCC\u5B98\u7F51\u8FDB\u884C\u53D8\u66F4\u3002\u5982\u6709\u7591\u95EE\uFF0C\u8BF7\u54A8\u8BE2\u5BA2\u670D\u70ED\u7EBF400-817-5666\u3002'
        });
        return;
      } else if (item.trustChannelDisplayName == "招商银行在线支付") {
        if (item.ywt == false) {
          this.setState({
            alertFlag: true,
            alertContent: "您的银行卡未签约，请登录华夏基金官网【银行卡管理-代扣签约】进行签约升级或咨询投资顾问。客服电话：400-817-5666"
          });
          return;
        } else if (item.ywt == null) {
          if (item.enableCMBTrustChannel === false) {
            this.setState({
              alertFlag: true,
              alertContent: "为确保资金同卡进出的原则，请补充该招商银行卡信息，该渠道活期通份额方可在华夏财富使用。您可以直接登录华夏财富官网个人中心提交银行卡信息，或致电客服热线400-817-5666进行办理。"
            });
            return;
          }
        }
      }
      var _props = this.props,
          dispatch = _props.dispatch,
          payInfoData = _props.payInfoData;

      Object.assign(payInfoData, { currentType: 2 }, { currentIndex: i });
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_investmentAction__["L" /* hqtXz */])(item.bankCode));
      dispatch({
        type: this.props.location.state.actionType + "_PAY_INFO",
        text: payInfoData
      });
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'JumpAddCard',
    value: function JumpAddCard() {
      console.log('加卡');
      __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].push({
        pathname: '/HqtAddCard',
        state: {
          isShow: true,
          callback: this.props.location.state.callback
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          payInfoData = _props2.payInfoData,
          currentIndex = _props2.currentIndex,
          currentType = _props2.currentType;


      var icon = [__webpack_require__(125), __webpack_require__(151)];
      console.log(payInfoData, "payInfoDatapayInfoDatapayInfoData");
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_3_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bankTypeName' },
            '\u94F6\u884C\u5361\u652F\u4ED8'
          ),
          payInfoData.content.currentAccountList.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: 'current' + i, className: 'bankList', onClick: function onClick() {
                  return _this2.choseBank(item, i);
                }, style: item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == null ? item.enableCMBTrustChannel === "0" ? { backgroundColor: "rgba(0, 0, 0, 0.1)" } : {} : {} },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_5__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_5__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), className: 'img' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListTip' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_2__util___default.a.formatStr(item.bankName) + '(*' + __WEBPACK_IMPORTED_MODULE_2__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')',
                  item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == null ? item.enableCMBTrustChannel === "0" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: 'rgb(104,113,126)', fontSize: 12, padding: 2, backgroundColor: "rgba(0,0,0,0.1)", justifyContent: "center", marginLeft: "5px" } },
                    '\u4E0D\u53EF\u7528'
                  ) : null : null
                ),
                item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '\u62DB\u884C\u5361\u6682\u4E0D\u53EF\u7528\uFF0C\u8BF7\u60A8\u53BB\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6App\u64CD\u4F5C\u6216\u54A8\u8BE2\u5BA2\u670D'
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  window.funSplit(item.tradeMaxAmountTips)[1]
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'bankListRightOK' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: payInfoData.currentType === 2 && item.bankCode == _this2.props.hqtXz ? icon[1] : icon[0], className: 'img' })
              )
            );
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btnAddCard', onClick: function onClick() {
                _this2.JumpAddCard();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { color: '#000', fontSize: '15px' } },
              '+\u6DFB\u52A0\u94F6\u884C\u5361'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modal_ModalSelectTip__["a" /* default */], { onCancel: function onCancel() {
            _this2.setState({ unUseBank: false });
          }, onOK: function onOK() {
            _this2.setState({ unUseBank: false });
          }, flag: this.state.unUseBank, height: 240, title: '\u94F6\u884C\u6E20\u9053\u63D0\u793A', content: this.state.unUseConent }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__["a" /* default */], { flag: this.state.alertFlag, btnRight: "确认", btnRightFun: this.closeMoadl, content: this.state.alertContent, title: "温馨提示" })
      );
    }
  }]);

  return PayCardList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(ownProps.location.state.type + 'PayInfo');
  return {
    // payInfoData:state[ownProps.location.state.type+'PayInfo'],
    payInfoData: state.hqtPayInfo,
    hqtXz: state.hqtXz
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(PayCardList));

/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modal_ModalTip__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_myAssets_userInfoAction__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__action_loginAction__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__action_investmentAction__ = __webpack_require__(8);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { changepayInfoData.CurrentIndex ,changepayInfoData.CurrentType} from '../../../action/productAction';















var PayCardList = function (_Component) {
  _inherits(PayCardList, _Component);

  function PayCardList(props) {
    var _this2 = this;

    _classCallCheck(this, PayCardList);

    var _this = _possibleConstructorReturn(this, (PayCardList.__proto__ || Object.getPrototypeOf(PayCardList)).call(this, props));

    _this.getUserInfo = function () {
      console.log(_this.props.location.state);
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["g" /* myAddPhoneText */])(''));
      _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__action_publicAction__["h" /* myAddCardText */])(''));
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
        pathname: '/AddCard',
        state: { fundCode: _this.props.location.state.fundCode }
      });
    };

    _this.closeModal = function () {
      _this.setState({
        setModalShow: false
      });
    };

    _this.okAddHqt = function () {
      // let { dispatch,payInfoData } = this.props;
      var theListResult = _this.state.theListResult;
      var _this$props$location$ = _this.props.location.state,
          router = _this$props$location$.router,
          callback = _this$props$location$.callback,
          isShow = _this$props$location$.isShow,
          fundCode = _this$props$location$.fundCode;

      var verifiedUserInfo = __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].getState().verifiedUserInfo;
      var _verifiedUserInfo$con = verifiedUserInfo.content,
          name = _verifiedUserInfo$con.name,
          certType = _verifiedUserInfo$con.certType,
          certNo = _verifiedUserInfo$con.certNo,
          mobileNo = _verifiedUserInfo$con.mobileNo;

      var count = 0;
      _this.setState({
        setModalShow: false
      });
      if (payInfoData.content.shareList.length > 0) {
        for (var i = 0; i < payInfoData.content.shareList.length; i++) {
          if (payInfoData.content.shareList[i].bankAccountShowNo == theListResult.bankAccountShowNo && payInfoData.content.shareList[i].paymentChannel != "888") {
            count++;
            _this.choseCurrent(i);
            break;
          }
        }
        if (count > 0) {
          return;
        }
        console.log(name, certType, certNo, mobileNo, router, callback, isShow);
        __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
          pathname: "/HqtBindCard",
          state: {
            bankAccountShowNo: theListResult.bankAccountShowNo,
            paymentChannelId: theListResult.paymentChannel,
            bankAccountName: theListResult.bankName,
            certType: certType,
            certNo: certNo,
            router: router,
            bankCode: theListResult.bankCode,
            openHqt: true,
            mobileNo: mobileNo,
            callback: callback,
            isShow: isShow,
            fundCode: fundCode
          }
        });
      } else {
        var _arr = _this.state.theListResult;
        _arr.certType = certType;
        _arr.certNo = certNo;
        _arr.mobileNo = mobileNo;
        _arr.callback = callback;
        _arr.isShow = isShow;
        _arr.fundCode = fundCode;
        _arr.router = router;
        _this.openHqt(_arr);
      }
      var payInfoData = _this.props.payInfoData;

      if (payInfoData.content.shareList.length > 0) {
        _this.goHqtAddCard();
      } else {
        _this.openHqt({ fundCode: _this.props.location.state.fundCode });
      }
    };

    _this.openHqt = function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(arr) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.state.isOpenHqt) {
                  _this.goHqtAddCard();
                } else {
                  console.log('开通活期通');
                  _this.setState({
                    tanCar: true,
                    FundCode: arr.fundCode
                  });
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.closeMoadlLft = function () {
      _this.setState({
        tanCar: false
      });
    };

    _this.closeMoadls = function () {
      if (_this.state.Bools) {
        _this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__action_loginAction__["r" /* getTbuxyKh */])({}, function () {
          _this.setState({
            tanCar: false
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__getPay__["s" /* getOpenHqt */])(window.history.length, __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */], null, { fundCode: _this.state.FundCode });
          var data = __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].getState().verifiedUserInfo.content;
          console.log(data);
          var inParamsData = {
            certNo: data.certNo,
            certType: data.certType,
            name: data.name
          };
          __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_myAssets_userInfoAction__["a" /* findCamcHqtExist */])(inParamsData, function (result) {
            console.log(result);
            _this.setState({
              isOpenHqt: result.tradeAccountNo
            });
          }));
        }));
      } else {
        __WEBPACK_IMPORTED_MODULE_13_antd_mobile_lib__["Toast"].info("请先阅读并确认用户同步信息授权书", 2);
        return;
      }
    };

    _this.isSignOnekeyModalOk = function () {
      _this.setState({
        isSignOnekeyFlag: false
      });
    };

    _this.state = {
      fundLimit: '',
      isOk: false,
      unUseBank: false,
      showMore: false,
      showMore2: false,
      unUseConent: '',
      setModalShow: false,
      theListResult: null,
      isOpenHqt: null,
      Bools: false,
      tanCar: false,
      dataVal: "",
      FundCode: "",
      yhkLx: false,
      isSignOnekeyFlag: false //直销卡签约弹窗
    };
    return _this;
  }

  _createClass(PayCardList, [{
    key: 'callBack',
    value: function callBack() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "选择支付方式";
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({
        yhkLx: true
      });
      // console.log(this.props.location.state)
      // this.props.dispatch(myAddPhoneText(''));
      // this.props.dispatch(myAddCardText(''))
      // hashHistory.push({
      //     pathname:'/AddCard',
      //     state:{fundCode:this.props.location.state.fundCode,},

      // })
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      if (__WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].getState() && __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].getState().verifiedUserInfo && __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].getState().verifiedUserInfo.content) {
        var data = __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].getState().verifiedUserInfo.content;
        this.setState({ dataVal: data });
        console.log(data);
        var inParamsData = {
          certNo: data.certNo,
          certType: data.certType,
          name: data.name
        };
        __WEBPACK_IMPORTED_MODULE_11__ReduxStore_js__["a" /* default */].dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__action_myAssets_userInfoAction__["a" /* findCamcHqtExist */])(inParamsData, function (result) {
          console.log(result);
          _this3.setState({
            isOpenHqt: result.tradeAccountNo
          });
        }));
      }
    }
  }, {
    key: 'choseBank',
    value: function choseBank(result, i) {
      var _props = this.props,
          payInfoData = _props.payInfoData,
          dispatch = _props.dispatch;

      var item = payInfoData.content.yhkNewListList[i];
      if (!item.disable) {
        console.log(result);
        this.setState({
          setModalShow: true,
          theListResult: result
        });
        return;
      }
      //直销卡没签约弹窗
      if (!(item.signOnekey === true || item.signTripleAgreement === true)) {
        this.setState({
          isSignOnekeyFlag: true
        });
        return;
      }
      // dispatch(changepayInfoData.CurrentType(1))
      // dispatch(changepayInfoData.CurrentIndex(i))
      Object.assign(payInfoData, { currentType: 1 }, { currentIndex: i });
      dispatch({
        type: this.props.location.state.actionType + "_PAY_INFO",
        text: payInfoData
      });
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'choseCurrent',
    value: function choseCurrent(i) {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          payInfoData = _props2.payInfoData;

      var item = payInfoData.content.shareList[i];
      if (item.paymentChannel == "G000") {
        if (item.ywt == false) {
          this.setState({
            unUseBank: true,
            unUseConent: '您的银行卡未签约，请登录华夏基金官网【银行卡管理-代扣签约】进行签约升级或咨询投资顾问。客服电话：400-817-5666'
          });
          return;
        } else if (item.ywt == null) {
          if (!item.enableCMBTrustChannel) {
            this.setState({
              unUseBank: true,
              unUseConent: '为确保资金同卡进出的原则, 请补充该招商银行卡信息, 该渠道活期通份额方可在华夏财富使用。您可以直接登录华夏财富官网个人中心提交银行卡信息, 或致电客服热线400- 817 - 5666进行办理。'
            });
            return;
          }
        }
      } else if (item.bankAccountShowNo2) {
        this.setState({
          unUseBank: true,
          unUseConent: '\u60A8\u5728\u534E\u590F\u57FA\u91D1\u7684' + item.trustChannelName.slice(-4) + '(*' + item.bankAccountShowNo.slice(-4) + ')\u4E0E\u534E\u590F\u8D22\u5BCC\u7684' + item.trustChannelName.slice(-4) + '(*' + item.bankAccountShowNo2.slice(-4) + ')\u4FE1\u606F\u4E0D\u4E00\u81F4,\u8BE5\u6E20\u9053\u6D3B\u671F\u901A\u6682\u4E0D\u53EF\u7528\u3002\u5982\u9700\u94F6\u884C\u5361\u4FE1\u606F\u53D8\u66F4,\u8BF7\u60A8\u5206\u522B\u5728\u534E\u590F\u57FA\u91D1\u5B98\u7F51\u548C\u534E\u590F\u8D22\u5BCC\u5B98\u7F51\u8FDB\u884C\u53D8\u66F4\u3002\u5982\u6709\u7591\u95EE,\u8BF7\u54A8\u8BE2\u5BA2\u670D\u70ED\u7EBF400-817-5666\u3002'
        });
        return;
      }
      Object.assign(payInfoData, { currentType: 2 }, { currentIndex: i });
      dispatch({
        type: this.props.location.state.actionType + "_PAY_INFO",
        text: payInfoData
      });
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'choseHB',
    value: function choseHB(i) {
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          payInfoData = _props3.payInfoData;

      Object.assign(payInfoData, { currentType: 3 }, { currentIndex: i });
      dispatch({
        type: this.props.location.state.actionType + "_PAY_INFO",
        text: payInfoData
      });
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack();
    }
    //活期通加卡

  }, {
    key: 'goHqtAddCard',
    value: function goHqtAddCard() {
      console.log('加卡');
      __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].push({
        pathname: '/HqtAddCard',
        state: {
          fundCode: this.props.location.state.fundCode
        }
      });
    }
    //开通活期通

  }, {
    key: 'goHQT',
    value: function goHQT(parmas, val) {
      var _props4 = this.props,
          navigator = _props4.navigator,
          dispatch = _props4.dispatch,
          fundCode = _props4.fundCode;

      var data = {
        fundCode: '003003',
        businessType: 'T022',
        productType: 'G',
        type: 'superFund',
        bankAccountShowNo: parmas.bankAccountShowNo,
        currentIndex: val
      };
      this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__action_investmentAction__["L" /* hqtXz */])(parmas.bankCode));
      Object.assign(this.props.payInfoData, { currentType: 2 }, { currentIndex: val });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__getPay__["j" /* getPayAll */])(window.history.length, data, __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */], 'RechargeHqt');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var payInfoData = this.props.payInfoData;
      var active = this.props.active;

      console.log(payInfoData, "99999999999999");
      var icon = [__webpack_require__(2185), __webpack_require__(2186)];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { onClick: __WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* hashHistory */].goBack },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              '\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { background: "rgba(255, 255, 255, 1)" }, className: 'content' },
          this.state.yhkLx ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { background: "rgba(0, 0, 0, 0.3)", left: 0, top: 0, position: "fixed", width: "100%", height: "100%" } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { style: { height: "5.5rem", position: "fixed", bottom: 0, background: "rgba(255, 255, 255, 1)", width: "100%", padding: "0.4rem" } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { width: "100%", display: "flex" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { width: "0.36rem", height: "0.36rem" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, color: "rgba(51, 51, 51, 1)", fontSize: "0.36rem", fontWeight: "bold", textAlign: "center" } },
                  '\u9009\u62E9\u94F6\u884C\u5361\u7C7B\u578B'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: function onClick() {
                    _this4.setState({ yhkLx: false });
                  }, src: __webpack_require__(2179), style: { width: "0.36rem", height: "0.36rem" }, className: 'img' })
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { width: "100%", display: "flex", marginTop: "0.4rem" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      payInfoData.content.shareList.length > 0 ? _this4.goHqtAddCard() : _this4.openHqt({ fundCode: _this4.props.location.state.fundCode });
                    }, style: { background: "rgba(227, 212, 190, 1)", display: "flex", alignItems: "center", paddingBottom: "0.7rem", width: "3.2rem", height: "1.64rem", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", position: "relative", borderRadius: "0.08rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { flex: 1, fontSize: "0.32rem", color: "rgba(95, 80, 61, 1)", fontWeight: "bold" } },
                    '\u534E\u590F\u57FA\u91D1\u76F4\u9500\u94F6\u884C\u5361'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(2180), style: { width: "0.6rem", height: "0.36rem", marginRight: "0.1rem" } }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1971), style: { width: "0.2rem", height: "0.2rem" } }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(2175), style: { width: "0.88rem", height: "0.64rem", position: "absolute", right: 0, bottom: 0 } })
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { flex: 1 } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this4.getUserInfo();
                    }, style: { width: "3.2rem", height: "1.64rem", background: "rgba(222, 225, 236, 1)", display: "flex", alignItems: "center", paddingBottom: "0.7rem", paddingLeft: "0.3rem", paddingRight: "0.3rem", paddingTop: "0.2rem", position: "relative", borderRadius: "0.08rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { flex: 1, fontSize: "0.32rem", color: "rgba(61, 67, 87, 1)", fontWeight: "bold" } },
                    '\u534E\u590F\u8D22\u5BCC\u94F6\u884C\u5361'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(1971), style: { width: "0.2rem", height: "0.2rem" } }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(2183), style: { width: "0.88rem", height: "0.64rem", position: "absolute", right: 0, bottom: 0 } })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { fontSize: "0.24rem", color: "rgba(153, 153, 153, 1)", lineHeight: "0.34rem", marginTop: "0.4rem", marginBottom: "0.8rem" } },
                '1\u3001\u9009\u62E9\u6DFB\u52A0\u201C\u534E\u590F\u57FA\u91D1\u76F4\u9500\u94F6\u884C\u5361\u201D\uFF0C\u60A8\u5C06\u5728\u534E\u590F\u57FA\u91D1\u7684\u76F4\u9500\u7AEF\u901A\u9053\u7ED1\u5B9A\u94F6\u884C\u5361\uFF0C\u8BE5\u7C7B\u94F6\u884C\u5361\u7684\u652F\u4ED8\u989D\u5EA6\u8F83\u9AD8\uFF0C\u5EFA\u8BAE\u4F7F\u7528\u3002',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                '2\u3001\u9009\u62E9\u6DFB\u52A0\u201C\u534E\u590F\u8D22\u5BCC\u94F6\u884C\u5361\u201D\uFF0C\u60A8\u5C06\u5728\u534E\u590F\u8D22\u5BCC\u7AEF\u7684\u94F6\u8054\u901A\u901A\u9053\u7ED1\u5B9A\u94F6\u884C\u5361\uFF0C\u8BE5\u7C7B\u94F6\u884C\u5361\u7684\u652F\u4ED8\u989D\u5EA6\u8F83\u4F4E\u3002'
              )
            )
          ) : null,
          payInfoData.content.currencyFund.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: "0.4rem", paddingLeft: "20px", fontSize: "0.28rem", paddingBottom: "0.1rem" } },
            '\u96F6\u94B1\u5B9D\u652F\u4ED8'
          ) : null,
          payInfoData.content.currencyFund.map(function (item, i) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { key: 'shareList' + i, style: !_this4.state.showMore && i > 1 ? { display: 'none' } : null, className: payInfoData.currentType === 3 && payInfoData.currentIndex === i ? 'bankLists' : "bankListss", onClick: function onClick() {
                  return _this4.choseHB(i);
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(271), style: { width: 40, height: 40, alignSelf: "center" } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { style: { flex: 1, paddingLeft: "0.2rem" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { color: "rgba(51, 51, 51, 1)", fontSize: "0.28rem" } },
                  item.fundName
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", paddingBottom: "0.1rem", paddingTop: "0.1rem" } },
                  __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.trustChannelName) + ' (*' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ")"
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'p',
                  { style: { fontSize: "0.24rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: "rgba(102, 102, 102, 1)" } },
                    '\u53EF\u7528\u4F59\u989D \uFF1A'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { style: { color: "rgba(249, 44, 61, 1)" } },
                    __WEBPACK_IMPORTED_MODULE_3__util___default.a.parsePrice(item.availableVolume)
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'bankListRightOK' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: payInfoData.currentType === 3 && payInfoData.currentIndex === i ? icon[1] : icon[0], style: { width: "0.4rem", height: "0.4rem", alignSelf: "center" } })
              )
            );
          }),
          payInfoData.content.currencyFund.length > 2 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'bankTypeBtn', onClick: function onClick() {
                return _this4.setState({ showMore: !_this4.state.showMore });
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u66F4\u591A\u96F6\u94B1\u5B9D\u652F\u4ED8\u65B9\u5F0F'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(645), className: this.state.showMore ? 'transform180' : null })
          ) : payInfoData.content.currencyFund.length != 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 20 } }) : null,
          payInfoData.content.currencyFund.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: "10px", background: "rgba(248, 248, 248, 1)" } }) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'bankTypeNames', style: { paddingRight: "20px" } },
            '\u6D3B\u671F\u901A\u652F\u4ED8',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { flex: 1 } }),
            payInfoData.content.shareList.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: "red" }, onClick: function onClick() {
                  return _this4.goHqtAddCard();
                } },
              '+\u589E\u5F00\u6D3B\u671F\u901A'
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { style: { color: "red" }, onClick: function onClick() {
                  return _this4.openHqt({ fundCode: _this4.props.location.state.fundCode });
                } },
              '+\u5F00\u901A\u6D3B\u671F\u901A'
            )
          ),
          payInfoData.content.shareList.map(function (item, i) {
            if (item.paymentChannel == "G000" && !item.enableCMBTrustChannel || item.enableCMBTrustChannel === '0') {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'shareList' + i, style: !_this4.state.showMore2 && i > 1 ? { display: 'none' } : {}, className: payInfoData.currentType === 2 && payInfoData.currentIndex === i ? 'bankLists' : "bankListss", onClick: function onClick() {
                    return _this4.choseCurrent(i);
                  } },
                item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(39), style: { width: 40, height: 40, alignSelf: "center" } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), style: { width: 40, height: 40, alignSelf: "center" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, paddingLeft: "0.2rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { color: "rgba(51, 51, 51, 1)", fontSize: "0.28rem" } },
                    '\u6D3B\u671F\u901A'
                  ),
                  item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", paddingBottom: "0.1rem", paddingTop: "0.1rem" } },
                    '\u6D3B\u671F\u901A',
                    item.enableCMBTrustChannel === '0' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: 'rgb(104,113,126)', fontSize: 12, padding: 2, backgroundColor: "rgba(0,0,0,0.1)" } },
                      '\u4E0D\u53EF\u7528'
                    ) : null
                  ) : item.paymentChannel == "G000" && item.ywt == null ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", paddingBottom: "0.1rem", paddingTop: "0.1rem" } },
                    __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.trustChannelName).indexOf('-') > -1 ? item.trustChannelName.split('-')[1] : "--",
                    ' ',
                    '(*' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')',
                    item.paymentChannel == "G000" && !item.enableCMBTrustChannel || item.enableCMBTrustChannel === '0' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: 'rgb(104,113,126)', fontSize: 12, padding: 2, backgroundColor: "rgba(0,0,0,0.1)" } },
                      '\u4E0D\u53EF\u7528'
                    ) : null
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", paddingBottom: "0.1rem", paddingTop: "0.1rem" } },
                    __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.trustChannelName).indexOf('-') > -1 ? item.trustChannelName.split('-')[1] : "--",
                    ' ',
                    '(*' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                  ),
                  item.paymentChannel == "G000" && item.ywt == false ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: "0.24rem" } },
                    '\u62DB\u884C\u5361\u6682\u4E0D\u53EF\u7528\uFF0C\u8BF7\u60A8\u53BB\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6App\u64CD\u4F5C\u6216\u54A8\u8BE2\u5BA2\u670D'
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: "0.24rem" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: "rgba(102, 102, 102, 1)" } },
                      '\u53EF\u7528\u4F59\u989D \uFF1A'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: "rgba(249, 44, 61, 1)" } },
                      __WEBPACK_IMPORTED_MODULE_3__util___default.a.parsePrice(item.availableVolume)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { onClick: function onClick() {
                          return _this4.goHQT(payInfoData.content.shareList[i], i);
                        }, style: { color: "rgba(173, 127, 72, 1)", marginLeft: 10 } },
                      '\u5145\u503C'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'bankListRightOK' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: payInfoData.currentType === 2 && payInfoData.currentIndex === i ? icon[1] : icon[0], style: { width: "0.4rem", height: "0.4rem", alignSelf: "center" } })
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'shareList' + i, style: !_this4.state.showMore2 && i > 1 ? { display: 'none' } : {}, className: payInfoData.currentType === 2 && payInfoData.currentIndex === i ? 'bankLists' : "bankListss", onClick: function onClick() {
                    return _this4.choseCurrent(i);
                  } },
                item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(39), style: { width: 40, height: 40, alignSelf: "center" } }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), style: { width: 40, height: 40, alignSelf: "center" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, paddingLeft: "0.2rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { style: { color: "rgba(51, 51, 51, 1)", fontSize: "0.28rem" } },
                    '\u6D3B\u671F\u901A'
                  ),
                  item.paymentChannel == '888' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", paddingBottom: "0.1rem", paddingTop: "0.1rem" } },
                    '\u6D3B\u671F\u901A'
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", paddingBottom: "0.1rem", paddingTop: "0.1rem" } },
                    __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.trustChannelName).indexOf('-') > -1 ? item.trustChannelName.split('-')[1] : "--",
                    ' ',
                    '(*' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                  ),
                  item.paymentChannel == "G000" && item.ywt == false ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: "0.24rem" } },
                    '\u62DB\u884C\u5361\u6682\u4E0D\u53EF\u7528\uFF0C\u8BF7\u60A8\u53BB\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6App\u64CD\u4F5C\u6216\u54A8\u8BE2\u5BA2\u670D'
                  ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { fontSize: "0.24rem" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: "rgba(102, 102, 102, 1)" } },
                      '\u53EF\u7528\u4F59\u989D \uFF1A'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { style: { color: "rgba(249, 44, 61, 1)" } },
                      __WEBPACK_IMPORTED_MODULE_3__util___default.a.parsePrice(item.availableVolume)
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'span',
                      { onClick: function onClick() {
                          return _this4.goHQT(payInfoData.content.shareList[i], i);
                        }, style: { color: "rgba(173, 127, 72, 1)", marginLeft: 10 } },
                      '\u5145\u503C'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'bankListRightOK' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: payInfoData.currentType === 2 && payInfoData.currentIndex === i ? icon[1] : icon[0], style: { width: "0.4rem", height: "0.4rem", alignSelf: "center" } })
                )
              );
            }
          }),
          payInfoData.content.shareList.length > 2 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'bankTypeBtn', onClick: function onClick() {
                return _this4.setState({ showMore2: !_this4.state.showMore2 });
              } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              '\u66F4\u591A\u6D3B\u671F\u901A\u652F\u4ED8\u65B9\u5F0F'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(645), className: this.state.showMore2 ? 'transform180' : null })
          ) : payInfoData.content.shareList.length != 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: 20 } }) : null,
          payInfoData.content.yhkNewListList.length > -1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { height: "10px", background: "rgba(248, 248, 248, 1)" } }) : null,
          payInfoData.content.yhkNewListList.length > -1 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { paddingTop: "0.4rem", paddingLeft: "20px", fontSize: "0.28rem", paddingBottom: "0.1rem" } },
            '\u94F6\u884C\u5361\u652F\u4ED8'
          ) : null,
          payInfoData.content.yhkNewListList.map(function (item, i) {
            if (item.paymentChannel == '888') {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'current' + i, className: payInfoData.currentType === 1 && payInfoData.currentIndex === i ? 'yhbankLists' : "yhbankListss", style: !item.disable ? { backgroundColor: "rgba(0,0,0,0.1)" } : null, onClick: function onClick() {
                    return _this4.choseBank(item, i);
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(39), style: { width: 40, height: 40, alignSelf: "center" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, paddingLeft: "0.2rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(51, 51, 51, 1)", fontSize: "0.28rem" } },
                    '\u7406\u8D22\u4E2D\u5FC3'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem" } },
                    '\u7406\u8D22\u4E2D\u5FC3POS\u673A\u5237\u5361'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'bankListRightOK' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: payInfoData.currentType === 1 && payInfoData.currentIndex === i ? icon[1] : icon[0], style: { width: "0.4rem", height: "0.4rem", alignSelf: "center" } })
                )
              );
            } else {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { key: 'current' + i, className: payInfoData.currentType === 1 && payInfoData.currentIndex === i ? 'yhbankLists' : "yhbankListss", style: !item.disable ? { backgroundColor: "rgba(0,0,0,0.1)" } : null, onClick: function onClick() {
                    return _this4.choseBank(item, i);
                  } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] ? __WEBPACK_IMPORTED_MODULE_6__BankCode__["b" /* bankCode */]['ty'][item.bankCode] : __webpack_require__(39), style: { width: 40, height: 40, alignSelf: "center" } }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, paddingLeft: "0.2rem" } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(51, 51, 51, 1)", fontSize: "0.28rem" } },
                    (item.yhkBool ? "直销银行卡-" : "财富银行卡-") + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankName) + ' (*' + __WEBPACK_IMPORTED_MODULE_3__util___default.a.formatStr(item.bankAccountShowNo).substr(-4) + ')'
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { style: { color: "rgba(102, 102, 102, 1)", fontSize: "0.24rem", marginTop: "0.1rem" } },
                    item.yhkBool ? window.funSplit(item.tradeMaxAmountTips)[0] >= 999999999999 ? '单笔无限额，单日无限额' : item.paymentChannelId == 'G000' && item.bankCode == '007' ? '单笔限额20万，单日限额20万' : item.dayMonthLimit && window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额" + window.funSplit(item.tradeMaxAmountTips)[0] / 10000 + "万" + item.dayMonthLimit : window.funSplit(item.tradeMaxAmountTips)[0] ? "单笔限额" + window.funSplit(item.tradeMaxAmountTips)[0] / 10000 + "万" : '' : window.funSplit(item.tradeMaxAmountTips)[1]
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'bankListRightOK' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: payInfoData.currentType === 1 && payInfoData.currentIndex === i ? icon[1] : icon[0], style: { width: "0.4rem", height: "0.4rem", alignSelf: "center" } })
                )
              );
            }
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this4.next();
              }, className: 'yhbtn' },
            '+\u6DFB\u52A0\u94F6\u884C\u5361'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modal_ModalTip__["a" /* default */], { onCancel: function onCancel() {
            _this4.setState({ unUseBank: false });
          }, onOK: function onOK() {
            _this4.setState({ unUseBank: false });
          }, flag: this.state.unUseBank, height: 240, title: '\u94F6\u884C\u6E20\u9053\u63D0\u793A', content: this.state.unUseConent }),
        this.state.setModalShow ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__["c" /* AddCardHqtAlert */], {
          title: "温馨提示",
          content: "很抱歉，该银行卡暂不支持扣款，建议您使用活期通进行支付。",
          CloseAler: function CloseAler() {
            _this4.setState({ setModalShow: false });
          },
          handleBtn1: this.okAddHqt,
          handleBtn2: this.closeModal,
          btnfirText: '\u6D3B\u671F\u901A\u652F\u4ED8',
          btnsecText: '\u5176\u4ED6\u94F6\u884C\u5361\u652F\u4ED8'
        }) : null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__["a" /* default */], { onFun: function onFun(Bools) {
            _this4.setState({ Bools: Bools });
          }, flag: this.state.tanCar, btnLiftFun: this.closeMoadlLft, btnLift: "取消", btnRight: "确认", btnRightFun: this.closeMoadls, content: "为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》", title: "" }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal_ModalList__["a" /* default */], { flag: this.state.isSignOnekeyFlag, btnRight: "确认", btnRightFun: this.isSignOnekeyModalOk, content: "您选择的银行卡尚未进行签约升级，需升级后才可进行支付，详情请咨询客服400-817-5666", title: "温馨提示" })
      );
    }
  }]);

  return PayCardList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(ownProps.location.state.type + 'PayInfo');
  return {
    payInfoData: state[ownProps.location.state.type + 'PayInfo']
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(PayCardList));

/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_array_tree_filter__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_array_tree_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_array_tree_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BankCode__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myAssets_InvestPlanAction_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PayWarmTips__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pay_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pay_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Pay_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HqtCard__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__action_publicAction__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Modal_ModalList__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getPay__ = __webpack_require__(20);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import { Picker,List} from 'antd-mobile/lib';









// import { traceSave } from '../../../action/riskInPayAction';





var RechargeHqt = function (_Component) {
  _inherits(RechargeHqt, _Component);

  function RechargeHqt(props) {
    _classCallCheck(this, RechargeHqt);

    var _this2 = _possibleConstructorReturn(this, (RechargeHqt.__proto__ || Object.getPrototypeOf(RechargeHqt)).call(this, props));

    _this2.goRember = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
        pathname: "/BankCardList",
        state: {
          title: '重置交易密码'
        }
      });
    };

    _this2.goSetOk = function () {
      _this2.setState({
        setModalShow: false
      });
      window.sessionStorage.setItem('hqtTipShow', false);
    };

    _this2.closeMoadl = function () {
      _this2.setState({
        alertFlag: false
      });
    };

    _this2.goBack = function () {
      __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
      if (_this2.props.location.state.refresh) {
        setTimeout(function () {
          _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["I" /* getTradeInfo */])(_this2.props.location.state._fundCode, 'T522', _this2.props.location.state.productType, function (result, i, type) {
            Object.assign(result, { currentType: type }, { currentIndex: i });
            _this2.props.dispatch({
              type: "SUPER_FUND_PAY_INFO",
              text: result
            });
          }));
        });
      }
    };

    _this2.resetRiskFun = function () {
      _this2.setState({
        showRiskModal: false
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], window.history.length, function () {
        _this2.keyOk("1");
      });
      return;
    };

    _this2.sameDataFun = function () {
      _this2.setState({
        showRiskModal: false
      });
      _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["L" /* syncCwimRiskToCamcAndStopOutOfRiskBuyPlan */])({}, function () {
        _this2.keyOk("2");
      }));
      return;
    };

    _this2.riskShowFun = function () {
      _this2.setState({
        showRiskModal: true
      });
    };

    _this2.isSignOnekeyModalOk = function () {
      _this2.setState({
        isSignOnekeyFlag: false
      });
    };

    _this2.state = {
      text: '',
      btnFlag: false,
      pwdFlag: false,
      keyPasswordVal: '',
      agreeIndex: 0,
      setModalShow: false,
      rateAndFeeDate: { code: '', message: '', content: { fee: '--', feeBefore: '--', rate: '--', rate4: '--', rateBefore: '--' } },
      payInfoData: { code: '', message: '', content: { currencyFund: [], shareList: [], currentAccountList: [], currentNav: '', currentNavDate: '', fundCode: '', fundName: '', minAmount: '' } },
      showRiskModal: false,
      isSignOnekeyFlag: false //直销卡签约弹窗
    };
    return _this2;
  }

  _createClass(RechargeHqt, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.title = "存入活期通";
      if (window.sessionStorage.getItem("hqtTipShow") != "false") {
        this.setState({
          setModalShow: true
        });
      };
      this.fetch();
    }
  }, {
    key: 'onChangeText',
    value: function onChangeText(text) {
      var _props = this.props,
          dispatch = _props.dispatch,
          payInfoData = _props.payInfoData;
      var _props$location$state = this.props.location.state,
          fundCode = _props$location$state.fundCode,
          businessType = _props$location$state.businessType,
          productType = _props$location$state.productType;

      var flag = __WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(text);
      this.setState({ text: text });
      if (!flag) {
        return;
      }
      if (payInfoData.content.currentAccountList.length == 0) {
        return;
      }
      var item = payInfoData.content.currentAccountList[payInfoData.currentIndex];
      console.log(this.props.location, "this.porps.location");
      var data = {
        currentAccountId: item.paymentAccountId,
        businessType: businessType,
        fundCode: fundCode,
        applicationAmount: text,
        payBuyHqt: true
      };
      this.getMoneyChange(data);
    }
  }, {
    key: 'getMoneyChange',
    value: function getMoneyChange(data) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["V" /* getMoneyChange */])(data).then(function (e) {
        _this3.setState({
          rateAndFeeDate: e
        });
      }).catch(function (err) {});
    }
  }, {
    key: 'next',
    value: function next() {
      var _props2 = this.props,
          dispatch = _props2.dispatch,
          payInfoData = _props2.payInfoData;
      var _state = this.state,
          text = _state.text,
          agreeIndex = _state.agreeIndex,
          currentType = _state.currentType,
          currentIndex = _state.currentIndex;

      if (agreeIndex == 0) {
        var toast = __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].show('请同意特别提示内容', 2);
        return;
      }
      if (!__WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(this.state.text)) {
        var _toast = __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].show('请输入正确格式的金额', 2);
        return;
      }

      // let item=payInfoData.content.currentAccountList[payInfoData.currentIndex];
      // if (item.tradeMaxAmountTips.split('|')[0]-0<text) {
      //   Toast.info(  item.tradeMaxAmountTips.split('|')[1], 2 );
      //   return ;
      // } 
      var item = payInfoData.content.currentAccountList[payInfoData.currentIndex];

      console.log(currentIndex, "currentIndexcurrentIndexcurrentIndex");
      if (item.tradeMaxAmountTips.split('|')[0] - 0 < text) {
        var _toast2 = __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].show(item.tradeMaxAmountTips.split('|')[1], 2);
        return;
      }
      var cardSelect = payInfoData.content.currentAccountList[payInfoData.currentIndex];
      if (cardSelect.bankAccountShowNo2) {
        this.setState({
          alertFlag: true,
          alertContent: '\u7531\u4E8E\u60A8\u5728\u534E\u590F\u57FA\u91D1\u7684' + item.bankName + '\uFF08*' + item.bankAccountShowNo.slice(-4) + '\uFF09\u4E0E\u534E\u590F\u8D22\u5BCC\u7684' + item.bankName + '\uFF08*' + item.bankAccountShowNo2.slice(-4) + '\uFF09\u4FE1\u606F\u4E0D\u4E00\u81F4\uFF0C\u8BE5\u6E20\u9053\u6D3B\u671F\u901A\u4EFD\u989D\u6682\u4E0D\u53EF\u7528\u3002\u5982\u9700\u94F6\u884C\u5361\u4FE1\u606F\u53D8\u66F4\uFF0C\u8BF7\u60A8\u5206\u522B\u5728\u534E\u590F\u57FA\u91D1\u5B98\u7F51\u548C\u534E\u590F\u8D22\u5BCC\u5B98\u7F51\u8FDB\u884C\u53D8\u66F4\u3002\u5982\u6709\u7591\u95EE\uFF0C\u8BF7\u54A8\u8BE2\u5BA2\u670D\u70ED\u7EBF400-817-5666\u3002'
        });
        return;
      } else if (cardSelect.trustChannelDisplayName == "招商银行在线支付") {
        if (cardSelect.ywt == false) {
          this.setState({
            alertFlag: true,
            alertContent: "您的银行卡未签约，请登录华夏基金官网【银行卡管理-代扣签约】进行签约升级或咨询投资顾问。客服电话：400-817-5666"
          });
          return;
        } else if (cardSelect.ywt == null) {
          if (cardSelect.enableCMBTrustChannel === false) {
            this.setState({
              alertFlag: true,
              alertContent: "为确保资金同卡进出的原则，请补充该招商银行卡信息，该渠道活期通份额方可在华夏财富使用。您可以直接登录华夏财富官网个人中心提交银行卡信息，或致电客服热线400-817-5666进行办理。"
            });
            return;
          }
        }
      }
      console.log(payInfoData, "payInfoDatapayInfoDatapayInfoData", currentIndex);
      //直销卡没签约弹窗
      if (!(cardSelect.signOnekey === true || cardSelect.signTripleAgreement === true)) {
        this.setState({
          isSignOnekeyFlag: true
        });
        return;
      }
      this.openPwd();
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _props$location$state2 = this.props.location.state,
          fundCode = _props$location$state2.fundCode,
          businessType = _props$location$state2.businessType,
          productType = _props$location$state2.productType,
          bankAccountShowNo = _props$location$state2.bankAccountShowNo;
      var _props3 = this.props,
          dispatch = _props3.dispatch,
          payInfoData = _props3.payInfoData,
          hqtCardList = _props3.hqtCardList;

      if (payInfoData.currentType == 4) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["_1" /* getCamcBankCardList */])(fundCode, businessType, this.props.bankAccountShowNo, function (result, i, type) {
          var AccountList = result.content && result.content.currentAccountList;
          for (var _i = 0; _i < result.content.currentAccountList.length; _i++) {
            for (var j = 0; j < hqtCardList.length; j++) {
              if (hqtCardList[j].enableCMBTrustChannel === "0" && result.content.currentAccountList[_i].bankCode === hqtCardList[j].bankCode) {
                result.content.currentAccountList[_i].enableCMBTrustChannel = hqtCardList[j].enableCMBTrustChannel;
                result.content.currentAccountList[_i].bankAccountShowNo2 = hqtCardList[j].bankAccountShowNo2;
              } else {
                if (hqtCardList[j].trustChannelDisplayName === "招商银行在线支付" && result.content.currentAccountList[_i].bankCode === hqtCardList[j].bankCode) {
                  if (hqtCardList[j].ywt == true) {} else if (hqtCardList[j].ywt == false) {
                    result.content.currentAccountList[_i].enableCMBTrustChannel = hqtCardList[j].enableCMBTrustChannel;
                    result.content.currentAccountList[_i].trustChannelDisplayName = hqtCardList[j].trustChannelDisplayName;
                  } else {
                    if (hqtCardList[j].enableCMBTrustChannel === false) {
                      result.content.currentAccountList[_i].enableCMBTrustChannel = hqtCardList[j].enableCMBTrustChannel;
                      result.content.currentAccountList[_i].trustChannelDisplayName = hqtCardList[j].trustChannelDisplayName;
                    }
                  }
                }
              }
            }
          }
          dispatch({
            type: "HQT_PAY_INFO",
            text: result
          });
        }));
      }
    }
  }, {
    key: 'onChangePwd',
    value: function onChangePwd(val) {
      this.setState({
        keyPasswordVal: val
      });
    }
  }, {
    key: 'isAgreeClick',
    value: function isAgreeClick() {
      var agreeIndex = this.state.agreeIndex;

      if (agreeIndex === 0) {
        this.setState({
          agreeIndex: 1
        });
      } else {
        this.setState({
          agreeIndex: 0
        });
      }
    }
  }, {
    key: 'keyOk',
    value: function keyOk(res) {
      var _this4 = this;

      var _props4 = this.props,
          payInfoData = _props4.payInfoData,
          dispatch = _props4.dispatch;
      var _props$location$state3 = this.props.location.state,
          fundCode = _props$location$state3.fundCode,
          businessType = _props$location$state3.businessType,
          fundName = _props$location$state3.fundName;

      var _this = this;
      var _state2 = this.state,
          text = _state2.text,
          keyPasswordVal = _state2.keyPasswordVal;

      var pushResult = function pushResult(i, result) {
        __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].hide();
        if (i == 1) {
          // dispatch(traceSave(this.props.location.state.traceSaveObj));
          // dispatch(traceSave({action: 'SPECIAL_TIP', message:'已阅读充值活期通特别提示' }));
          // dispatch(traceSave({action: 'READ_TIPS', message: this.props.location.state.fundRisk?'充值高于自身风险基金：'+payInfoData.content.fundName:'充值'+payInfoData.content.fundName }))
          // dispatch(traceSave({action: 'BUY_WARN_AGAIN', message: this.props.location.state.fundRisk?'充值高于自身风险基金：'+payInfoData.content.fundName:'充值'+payInfoData.content.fundName }))
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/Success',
            state: {
              title: '充值结果',
              content: '申请已受理',
              dataSouse: [['申请编号', result.content], ['产品名称', '活期通'], ['投资金额', __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(text) + '元']],
              souseVal: ['返回我的智投']
            }
          });
        } else if (i == 3) {
          __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].push({
            pathname: '/ErrorResult',
            state: {
              title: '充值失败',
              content: '充值失败',
              content2: result,
              dataSouse: [],
              souseVal: ['返回华夏智投', '联系客服']
            }
          });
        }
      };
      var item = payInfoData.content.currentAccountList[payInfoData.currentIndex];
      var data = {
        amount: text - 0,
        businessType: businessType,
        fundCode: fundCode,
        clientIp: '127.0.0.1',
        password: __WEBPACK_IMPORTED_MODULE_4__util___default.a.encrypt(keyPasswordVal),
        paymentAccountId: item.paymentAccountId
      };

      var findHqtExist = this.props.findHqtExist;
      var params = {
        otsTradeAccountNo: findHqtExist.tradeAccountNo,
        raiseMethod: "9"
      };
      if (res == "1") {
        try {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
            if (_flag) {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["_2" /* validateHqtPay */])(data, pushResult));
            } else {
              _this4.riskShowFun();
            }
          }));
        } catch (err) {
          __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].hide();
        }
      } else if (res == "2") {
        try {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["_2" /* validateHqtPay */])(data, pushResult));
        } catch (err) {
          __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].hide();
        }
      } else {
        try {
          dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["N" /* hasOtsRiskRearing */])(params, function (c1, c2, z1) {
            console.log(c1, c2, z1, "是否同步问卷");
            if (z1) {
              dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["_2" /* validateHqtPay */])(data, pushResult));
            } else {
              if (c1 === c2) {
                console.log(c1, c2, z1, "c1 === c2同步问卷");
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
                  if (_flag) {
                    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["_2" /* validateHqtPay */])(data, pushResult));
                  } else {
                    _this4.riskShowFun();
                  }
                }));
              } else {
                console.log(c1, c2, z1, "c1 === c2同步问卷");
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__getPay__["n" /* goPubQuestionnaires */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */], window.history.length, function () {
                  dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["M" /* syncCwimToCamcNew */])({}, function (_flag) {
                    if (_flag) {
                      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__action_productAction__["_2" /* validateHqtPay */])(data, pushResult));
                    } else {
                      _this4.riskShowFun();
                    }
                  }));
                });
              }
            }
          }));
        } catch (err) {
          __WEBPACK_IMPORTED_MODULE_10_antd_mobile_lib__["Toast"].hide();
          console.log(err, '同步问卷失败');
        }
      }

      // dispatch(validateHqtPay(data,pushResult))
    }
  }, {
    key: 'currencyFundChange',
    value: function currencyFundChange(i, type) {
      console.log(i, type);
      this.setState({
        currentIndex: i,
        currentType: type
      });
      var payInfoData = this.props.payInfoData;

      var item = payInfoData.content.currentAccountList[i];
      var data = {
        currentAccountId: item.paymentAccountId,
        businessType: this.props.businessType,
        fundCode: payInfoData.content.fundCode,
        applicationAmount: this.state.text,
        payBuyHqt: true
      };
      this.getMoneyChange(data);
    }
  }, {
    key: 'openPwd',
    value: function openPwd() {
      this.setState({
        pwdFlag: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var img_arr = [__webpack_require__(51), __webpack_require__(55)];
      var _props$location$state4 = this.props.location.state,
          fundName = _props$location$state4.fundName,
          fundCode = _props$location$state4.fundCode,
          fundType = _props$location$state4.fundType,
          wanfenshouyi = _props$location$state4.wanfenshouyi,
          currentNavDate = _props$location$state4.currentNavDate,
          currentNav = _props$location$state4.currentNav,
          businessType = _props$location$state4.businessType,
          fundRisk = _props$location$state4.fundRisk;
      var payInfoData = this.props.payInfoData;

      Object.assign(payInfoData, { currentType: 2 }, { currentIndex: this.props.location.state.currentIndex ? this.props.location.state.currentIndex : 0 });
      console.log(payInfoData, "******payInfoDatapayInfoDatapayInfoData", this.props);
      var _state3 = this.state,
          rateAndFeeDate = _state3.rateAndFeeDate,
          currentType = _state3.currentType,
          currentIndex = _state3.currentIndex;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__NavigatorMain__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header black' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: this.goBack },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'headerLeftBtn' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              '\u5B58\u5165\u6D3B\u671F\u901A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'fixed-invest-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fixed-invest-header-top' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'fixed-invest-header-top-name' },
                "活期通(" + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(payInfoData.content.fundName) + ")"
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'fixed-invest-header-top-type' },
                businessType == 'T022' ? '申购' : businessType == 'T020' ? '认购' : ''
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'fixed-invest-header-bottom' },
              businessType != 'T022' ? '\u6700\u65B0\u51C0\u503C \uFF1A1.000\u5143' : '\u4E07\u4EFD\u6536\u76CA:' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.fomatFloat(__WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(payInfoData.content.currentNav), 4) + '\u5143(' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(payInfoData.content.currentNavDate) + ')'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'share' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'shareTitle' },
              '\u8BF7\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__HqtCard__["a" /* default */], { type: 'hqt', actionType: 'HQT', fetch: this.fetch.bind(this) }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'input' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u6295\u8D44\u91D1\u989D'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                return _this5.onChangeText(e.target.value);
              }, type: 'text', placeholder: '最低投资金额' + __WEBPACK_IMPORTED_MODULE_4__util___default.a.parsePrice(payInfoData.content.minAmount) + '元' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pay-agree' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: img_arr[this.state.agreeIndex], className: 'imgBtn', onClick: function onClick() {
                return _this5.isAgreeClick();
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u5DF2\u9605\u8BFB\u7279\u522B\u63D0\u793A\u5185\u5BB9'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pay-fee' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u8D39\u7387\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'red-t' },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate) == '0.00' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate) == '0.00%' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate) == '0%' ? '0%' : __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.rate)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '\u9884\u8BA1\u8D39\u7528\uFF1A'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'red-t' },
                __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee) == '0.00' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee) == '0.00%' || __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee) == '0%' ? '0元' : __WEBPACK_IMPORTED_MODULE_4__util___default.a.formatStr(rateAndFeeDate.content.fee)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_4__util___default.a.regular1.test(this.state.text) && this.state.agreeIndex == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: function onClick() {
                return _this5.next();
              }, className: 'btn' },
            '\u786E\u8BA4\u4E70\u5165'
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btn btn-gray' },
            '\u786E\u8BA4\u4E70\u5165'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { marginTop: 40 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PayWarmTips__["a" /* default */], { hqt: true, fundLimit: this.props.location.state.fundCode })
          )
        ),
        this.state.pwdFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', top: 0, width: '100%', height: '100%', background: 'rgba(52,52,52,0.4)' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { position: 'fixed', bottom: 0, width: '100%', height: '70%', background: '#fff' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { position: 'relative', height: '45px', lineHeight: '45px', textAlign: 'center', borderBottom: '0.005rem solid rgb(224,227,279)', fontSize: '0.3rem' } },
              '\u4EA4\u6613\u5BC6\u7801',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(95), style: { position: 'absolute', left: 0, width: '0.88rem', height: '0.88rem' }, onClick: function onClick() {
                  _this5.setState({ pwdFlag: false });
                } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { position: 'absolute', top: 0, right: 0, width: '45px', fontSize: '13px' }, className: 'red-t', onClick: function onClick() {
                    _this5.keyOk();
                  } },
                ' \u786E\u8BA4'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { padding: '0.3rem 0.3rem 0rem 0.3rem', fontSize: '13px' } },
              '\u6E29\u99A8\u63D0\u793A\uFF1A' + (fundRisk ? '温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。' : '请充分了解投资风险，并确定符合您的投资目标。')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { height: '45px', padding: '13px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off', onChange: function onChange(e) {
                  return _this5.onChangePwd(e.target.value);
                }, autofocus: 'autofocus', style: { height: '45px', width: '100%', fontSize: '0.3rem', border: '1px solid #afafaf', borderRadius: '0.1rem' }, type: 'password', placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 40, paddingRight: 10, textAlign: "right" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { onClick: this.goRember, style: { fontSize: 12, color: '#FE492E', textAlign: 'right' } },
                '\u5FD8\u8BB0\u5BC6\u7801\uFF1F'
              )
            )
          )
        ) : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Modal_ModalList__["a" /* default */], { contentSec: '\u5982\u9700\u529E\u7406\u6D3B\u671F\u901A\u8D4E\u56DE\u3001\u4EA4\u6613\u67E5\u8BE2\u7B49\u4E1A\u52A1\uFF0C\u8BF7\u767B\u5F55\u534E\u590F\u57FA\u91D1\u7BA1\u5BB6\u6216\u534E\u590F\u57FA\u91D1\u5B98\u7F51', flag: this.state.setModalShow, btnRight: "确认", btnRightFun: this.goSetOk, content: '\u5C0A\u656C\u7684\u5BA2\u6237\uFF0C\u6D3B\u671F\u901A\u662F\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\u7684\u7406\u8D22\u4EA7\u54C1\uFF0C\u901A\u8FC7\u534E\u590F\u57FA\u91D1\u53CA\u534E\u590F\u8D22\u5BCC\u5747\u53EF\u529E\u7406\u6D3B\u671F\u901A\u7533\u8D2D\u4E1A\u52A1\uFF0C\u6301\u6709\u7684\u6D3B\u671F\u901A\u4F59\u989D\u53EF\u4EE5\u7528\u4E8E\u7533\u8D2D\u534E\u590F\u8D22\u5BCC\u4EE3\u9500\u7684\u4EA7\u54C1\u3002', title: "特别提示" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Modal_ModalList__["a" /* default */], { flag: this.state.alertFlag, btnRight: "确认", btnRightFun: this.closeMoadl, content: this.state.alertContent, title: "温馨提示" }),
        this.state.showRiskModal ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 18, color: "#333", fontWeight: 500 } },
                '\u6E29\u99A8\u63D0\u793A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u6D3B\u671F\u901A\u3001\u95EA\u8D2D\u76F8\u5173\u670D\u52A1\u7531\u534E\u590F\u57FA\u91D1\u63D0\u4F9B\uFF0C\u6839\u636E\u534E\u590F\u57FA\u91D1\u7684\u8BC4\u5206\u6807\u51C6\uFF0C\u60A8\u7684\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E3A\uFF1AC1\u4FDD\u5B88\u578B\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 20, paddingRight: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { style: { fontSize: 14, color: "#333", lineHeight: "20px" } },
                '\u6839\u636E\u300A\u8BC1\u5238\u671F\u8D27\u6295\u8D44\u8005\u9002\u5F53\u6027\u7BA1\u7406\u529E\u6CD5\u300B\u7684\u89C4\u5B9A\uFF0C\u60A8\u9002\u5408\u4EA4\u6613\u98CE\u9669\u7B49\u7EA7\u4E3AR1\u7684\u4EA7\u54C1\u3002',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { fontSize: 15, color: "#333", lineHeight: "20px", fontWeight: "bold" } },
                  '\u60A8\u5982\u679C\u786E\u5B9A\u8BA4\u540C\u6B64\u98CE\u9669\u7B49\u7EA7\u8BC4\u5B9A\uFF0C\u4E3A\u4E86\u964D\u4F4E\u60A8\u7684\u98CE\u9669\uFF0C\u6211\u4EEC\u5C06\u7EC8\u6B62\u60A8\u5728\u534E\u590F\u57FA\u91D1\u5DF2\u7ECF\u7B7E\u7EA6\u7684R1\u4EA7\u54C1\u4EE5\u5916\u7684\u8BA1\u5212\u7C7B\u4EA4\u6613\uFF0C\u5305\u62EC\u5B9A\u6295\u3001\u667A\u80FD\u8BA4\u8D2D\u3001\u5B9A\u671F\u8F6C\u6362\u7B49\u3002'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.resetRiskFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#F92C3D" } },
                  '\u91CD\u65B0\u6D4B\u8BC4'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: this.sameDataFun, style: { display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  { style: { fontSize: 14, color: "#fff" } },
                  '\u786E\u8BA4'
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return RechargeHqt;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
  console.log(ownProps);
  return {
    pageFlag: state.pageFlag,
    keyPasswordVal: state.keyPasswordVal,
    hqtCardList: state.hqtCardList,
    payInfoData: state.hqtPayInfo,
    findHqtExist: state.findHqtExist
  };
}
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(RechargeHqt));

/***/ }),
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EchartsBox */
/* unused harmony export SelectOtherTransRecord */
/* unused harmony export SelectOtherzhishu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NavigatorMain__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_headerImg_png__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imgs_headerImg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__imgs_headerImg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_fundHeader_png__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imgs_fundHeader_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__imgs_fundHeader_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_yingxiao_png__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imgs_yingxiao_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__imgs_yingxiao_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_svg_svg__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zrender_lib_svg_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_zrender_lib_svg_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_echarts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_legend__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_line__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_tooltip__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_component_title__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__tip_FundAnalysisTips__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getPay__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__action_productAction__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__util__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var TabPane = __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Tabs"].TabPane;
var newToFixed = __WEBPACK_IMPORTED_MODULE_18__util___default.a.newToFixed;

var NewPublicOffering = function (_Component) {
  _inherits(NewPublicOffering, _Component);

  function NewPublicOffering(props) {
    _classCallCheck(this, NewPublicOffering);

    var _this2 = _possibleConstructorReturn(this, (NewPublicOffering.__proto__ || Object.getPrototypeOf(NewPublicOffering)).call(this, props));

    _this2.getVersionCallBack = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log(data);
    };

    _this2.getOperatingSystem = function () {
      var userAgent = navigator.userAgent.toLowerCase();

      var osName = '';
      var osVersion = '';

      if (userAgent.indexOf('win') !== -1) {
        osName = 'Windows';
        var match = /Windows NT ([\d.]+)/.exec(userAgent);
        if (match) {
          osVersion = match[1];
        }
      } else if (userAgent.indexOf('mac') !== -1) {
        osName = 'Mac OS';
        var _match = /Mac OS X ([\d_]+)/.exec(userAgent);
        if (_match) {
          osVersion = _match[1].replace(/_/g, '.');
        }
      } else if (userAgent.indexOf('x11') !== -1 || userAgent.indexOf('linux') !== -1) {
        osName = 'Linux';
      } else if (userAgent.indexOf('android') !== -1) {
        osName = 'Android';
        var _match2 = /Android ([\d.]+)/.exec(userAgent);
        if (_match2) {
          osVersion = _match2[1];
        }
      } else if (userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1 || userAgent.indexOf('ipod') !== -1) {
        osName = 'iOS';
        var _match3 = /(iPhone|iPod|iPad).*OS (\d+)/.exec(userAgent);
        if (_match3) {
          osVersion = _match3[2].replace(/_/g, '.');
        }
      } else {
        osName = 'Unknown';
      }

      return { osName: osName, osVersion: osVersion };
    };

    _this2.getDeviceType = function () {
      var userAgent = navigator.userAgent;

      if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "iphone";
      } else if (/Android/i.test(userAgent)) {
        return "android";
      } else {
        return "unknown"; // 或者你可以返回其他适当的默认值
      }
    };

    _this2.scrollFun = function (_this, e) {
      var hei = e.target.scrollTop;
      if (hei > 100) {
        _this.setState({ tebflag: true });
      } else {
        _this.setState({ tebflag: false });
      }
      if (hei >= 0 && hei < _this.arr[1]) _this.setState({ tabtext: _this.state.tabtextList[0] });
      if (hei >= _this.arr[1] && hei < _this.arr[2] - 1) _this.setState({ tabtext: _this.state.tabtextList[1] });
      if (hei >= _this.arr[2] - 1 && hei < _this.arr[3] - 1) _this.setState({ tabtext: _this.state.tabtextList[2] });
      if (hei >= _this.arr[3] - 1) _this.setState({ tabtext: _this.state.tabtextList[3] });
    };

    _this2.tabValFun = function (selectTab, num) {
      var val = _this2.state.selectTab; //时间区间
      _this2.setState({
        tabVal: selectTab,
        initialPage: num });
      var theFun = function theFun(_selectTab, val) {
        var fundcode = _this2.state.fundCode;
        if (_selectTab == '业绩走势') {
          if (val == '近1月') {
            _this2.setState({
              loadingFlag: true,
              OneMonthBasicffsa: true,
              type: "m1"
            });
            var params = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "m1" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(params, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { oneMonth: IndexData, oneMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                loadingFlag: false,
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { OneMonthmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          } else if (val == '近3月') {
            _this2.setState({
              loadingFlag: true,
              ThreeMonthBasicffsa: true,
              type: "m3"
            });
            var _params = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "m3" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { threeMonth: IndexData, threeMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                loadingFlag: false,
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThreeMonthmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          } else if (val == '近6月') {
            _this2.setState({
              loadingFlag: true,
              SixMonthBasicffsa: true,
              type: "m6"
            });
            var _params2 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "m6" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params2, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { sixMonth: IndexData, sixMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                loadingFlag: false,
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { SixMonthmaxDrawDownValue: data.maxDrawDownValue })

              });
            }));
          } else if (val == '近1年') {
            _this2.setState({
              loadingFlag: true,
              OneYearBasicffsa: true,
              type: "y1"
            });
            var _params3 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "y1" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params3, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { oneYear: IndexData, oneYearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                loadingFlag: false,
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { OneYearmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          } else if (val == '今年以来') {
            _this2.setState({
              loadingFlag: true,
              ThisyearBasicffsa: true,
              type: "thisyear"
            });
            var _params4 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "thisyear" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params4, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { thisyear: IndexData, thisyearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                loadingFlag: false,
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThisyearmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          } else if (val == '近3年') {
            _this2.setState({
              loadingFlag: true,
              ThreeYearBasicffsa: true,
              type: "y3"
            });
            var _params5 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "y3" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params5, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { ThreeYear: IndexData, ThreeYearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                loadingFlag: false,
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThreeYearmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          } else if (val == '近5年') {
            _this2.setState({
              loadingFlag: true,
              FiveYearBasicffsa: true,
              type: "y5"
            });
            var _params6 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "y5" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params6, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { fiveYear: IndexData, fiveYearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { FiveYearmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          } else if (val == '成立以来') {
            _this2.setState({
              loadingFlag: true,
              AllDataBasicffsa: true,
              type: "sincefound"
            });
            var _params7 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "sincefound" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params7, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_selectTab, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { allData: IndexData, allDatapublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { AllDatamaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          }
        } else {
          _this2.setState({ tabloadingFlag: true, loadingFlag: true });
          if (_this2.state.echartsData !== null) {
            _this2.changeEchartsData(_selectTab, _this2.state.echartsData, val);
            _this2.setState({ tabloadingFlag: false });
          } else {
            var getHdata = { type: 1, fundcode: _this2.state.fundCode };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_6" /* getPublicHistoryProfileRate */])(getHdata, function (data) {
              var AccumulatedNet = data.HistoryRate.reverse();
              _this2.setState({
                AccumulatedNet: AccumulatedNet.slice(0, 4)
              });
              _this2.changeEchartsData(_this2.state.tabVal, data, _this2.state.selectTab);
            }, _this2));
          }
        }
      };
      theFun(selectTab, val);
    };

    _this2.changeEchartsData = function (_val, data, val, maxDrawDownValue) {
      // console.log(_val, data, val,maxDrawDownValue)
      var _oneMonthDate = []; //一个月
      var _oneMonthNav = [];
      var _threeMonthDate = []; //三个月
      var _threeMonthNav = [];
      var _sixMonthDate = []; //六个月
      var _sixMonthNav = [];

      var _oneYearDate = []; //一年
      var _oneYearNav = [];

      var _thisyearDate = []; //今年以来
      var _thisyearNav = [];

      var _ThreeYearDate = []; //三年
      var _ThreeYearNav = [];

      var _fiveYearDate = []; //五年
      var _fiveYearNav = [];

      var _totalDate = []; //成立以来
      var _totalNav = [];
      var _oneArr = [];
      var _threeArr = [];
      var _sixArr = [];
      var _yearArr = [];
      var _ThreeArr = [];
      var _fiveArr = [];
      var _thisyearArr = [];
      var _totalArr = [];
      var _profitNav = [];
      var _profitData = [];
      var oneMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["d" /* getOneMonthBefor */])();
      var threeMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["e" /* get3MonthBefor */])();
      var sixMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["f" /* getSixMonthBefor */])();
      var oneYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["l" /* get1yearBefor */])();
      var thisyearYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["u" /* Fromthisyear */])();
      var ThreeYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["v" /* get3yearBefor */])();
      var fiveYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["w" /* get5yearBefor */])();

      var datas = [];
      var Datacontnet = data.HistoryRate;
      if (_val === '业绩走势') {
        _profitNav = [];
        _profitData = [];
        if (_this2.state.Notenoughforoneyear == 1) {
          for (var i = data.length - 1; i >= 0; i--) {
            _profitNav.push({ value: __WEBPACK_IMPORTED_MODULE_18__util___default.a.Keepwodecimalplaces(data[i].value), allIncome: data[i].allIncome, Lineval: data[i].Lineval, maxDrawDown: data[i].maxDrawDown, deadLine: data[i].deadLine });
            _profitData.push(data[i].deadLine);
          }
        } else {
          for (var _i = data.length - 1; _i >= 0; _i--) {
            _profitNav.push({ value: __WEBPACK_IMPORTED_MODULE_18__util___default.a.Keepwodecimalplaces(data[_i].value), allIncome: data[_i].allIncome, Lineval: data[_i].Lineval, maxDrawDown: null, deadLine: data[_i].deadLine });
            _profitData.push(data[_i].deadLine);
          }
        }
        _profitNav = _profitNav.reverse();
        _profitData = _profitData.reverse();
        var _dotnav = [];
        _profitNav.map(function (item, index) {
          _dotnav.push(item.value);
        });
        _this2.setState({
          profitNav: _profitNav,
          profitData: _profitData
        });
        datas = {
          _profitNav: _profitNav,
          _profitData: _profitData,
          _dotnav: _dotnav,
          _selectTab: val,
          _maxDrawDownValue: maxDrawDownValue
        };
        setTimeout(function () {
          _this2.echartsbox.showOption(datas);
        }, 0);
        setTimeout(function () {
          _this2.setState({
            loadingFlag: false
          });
        }, 100);
      } else {
        for (var _i2 = Datacontnet.length - 1; _i2 >= 0; _i2--) {
          _totalDate.push(Datacontnet[_i2].publish_date);
          if (_val == "单位净值") {
            _totalNav.push(Datacontnet[_i2].value_134);
          } else if (_val == "累计净值") {
            _totalNav.push(Datacontnet[_i2].value_134_2);
          } else if (_val == "万份收益") {
            _totalNav.push(Datacontnet[_i2].value_2_1);
          } else if (_val == "七日年化") {
            _totalNav.push(Datacontnet[_i2].value_2_2);
          }

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(fiveYear, Datacontnet[_i2].publish_date)) {
            _fiveYearDate.push(Datacontnet[_i2].publish_date);
            if (_val == "单位净值") {
              _fiveYearNav.push(Datacontnet[_i2].value_134);
            } else if (_val == "累计净值") {
              _fiveYearNav.push(Datacontnet[_i2].value_134_2);
            } else if (_val == "万份收益") {
              _fiveYearNav.push(Datacontnet[_i2].value_2_1);
            } else if (_val == "七日年化") {
              _fiveYearNav.push(Datacontnet[_i2].value_2_2);
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(ThreeYear, Datacontnet[_i2].publish_date)) {
              _ThreeYearDate.push(Datacontnet[_i2].publish_date);
              if (_val == "单位净值") {
                _ThreeYearNav.push(Datacontnet[_i2].value_134);
              } else if (_val == "累计净值") {
                _ThreeYearNav.push(Datacontnet[_i2].value_134_2);
              } else if (_val == "万份收益") {
                _ThreeYearNav.push(Datacontnet[_i2].value_2_1);
              } else if (_val == "七日年化") {
                _ThreeYearNav.push(Datacontnet[_i2].value_2_2);
              }
              if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(oneYear, Datacontnet[_i2].publish_date)) {
                _oneYearDate.push(Datacontnet[_i2].publish_date);
                if (_val == "单位净值") {
                  _oneYearNav.push(Datacontnet[_i2].value_134);
                } else if (_val == "累计净值") {
                  _oneYearNav.push(Datacontnet[_i2].value_134_2);
                } else if (_val == "万份收益") {
                  _oneYearNav.push(Datacontnet[_i2].value_2_1);
                } else if (_val == "七日年化") {
                  _oneYearNav.push(Datacontnet[_i2].value_2_2);
                }
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(thisyearYear, Datacontnet[_i2].publish_date)) {
                  _thisyearDate.push(Datacontnet[_i2].publish_date);
                  if (_val == "单位净值") {
                    _thisyearNav.push(Datacontnet[_i2].value_134);
                  } else if (_val == "累计净值") {
                    _thisyearNav.push(Datacontnet[_i2].value_134_2);
                  } else if (_val == "万份收益") {
                    _thisyearNav.push(Datacontnet[_i2].value_2_1);
                  } else if (_val == "七日年化") {
                    _thisyearNav.push(Datacontnet[_i2].value_2_2);
                  }
                  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(sixMonth, Datacontnet[_i2].publish_date)) {
                    _sixMonthDate.push(Datacontnet[_i2].publish_date);
                    if (_val == "单位净值") {
                      _sixMonthNav.push(Datacontnet[_i2].value_134);
                    } else if (_val == "累计净值") {
                      _sixMonthNav.push(Datacontnet[_i2].value_134_2);
                    } else if (_val == "万份收益") {
                      _sixMonthNav.push(Datacontnet[_i2].value_2_1);
                    } else if (_val == "七日年化") {
                      _sixMonthNav.push(Datacontnet[_i2].value_2_2);
                    }
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(threeMonth, Datacontnet[_i2].publish_date)) {
                      _threeMonthDate.push(Datacontnet[_i2].publish_date);
                      if (_val == "单位净值") {
                        _threeMonthNav.push(Datacontnet[_i2].value_134);
                      } else if (_val == "累计净值") {
                        _threeMonthNav.push(Datacontnet[_i2].value_134_2);
                      } else if (_val == "万份收益") {
                        _threeMonthNav.push(Datacontnet[_i2].value_2_1);
                      } else if (_val == "七日年化") {
                        _threeMonthNav.push(Datacontnet[_i2].value_2_2);
                      }
                      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["g" /* compareTime */])(oneMonth, Datacontnet[_i2].publish_date)) {
                        _oneMonthDate.push(Datacontnet[_i2].publish_date);
                        if (_val == "单位净值") {
                          _oneMonthNav.push(Datacontnet[_i2].value_134);
                        } else if (_val == "累计净值") {
                          _oneMonthNav.push(Datacontnet[_i2].value_134_2);
                        } else if (_val == "万份收益") {
                          _oneMonthNav.push(Datacontnet[_i2].value_2_1);
                        } else if (_val == "七日年化") {
                          _oneMonthNav.push(Datacontnet[_i2].value_2_2);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        for (var _i3 = 0; _i3 < _oneMonthDate.length; _i3++) {
          if (_oneMonthDate[_i3]) {
            _oneArr.push(_oneMonthDate[_i3]);
          }
        }
        for (var _i4 = 0; _i4 < _threeMonthDate.length; _i4++) {
          if (_threeMonthDate[_i4]) {
            _threeArr.push(_threeMonthDate[_i4]);
          }
        }
        for (var _i5 = 0; _i5 < _sixMonthDate.length; _i5++) {
          if (_sixMonthDate[_i5]) {
            _sixArr.push(_sixMonthDate[_i5]);
          }
        }
        for (var _i6 = 0; _i6 < _oneYearDate.length; _i6++) {
          if (_oneYearDate[_i6]) {
            _yearArr.push(_oneYearDate[_i6]);
          }
        }
        //今年以来
        for (var _i7 = 0; _i7 < _thisyearDate.length; _i7++) {
          if (_thisyearDate[_i7]) {
            _thisyearArr.push(_thisyearDate[_i7]);
          }
        }
        for (var _i8 = 0; _i8 < _ThreeYearDate.length; _i8++) {
          if (_ThreeYearDate[_i8]) {
            _ThreeArr.push(_ThreeYearDate[_i8]);
          }
        }
        for (var _i9 = 0; _i9 < _fiveYearDate.length; _i9++) {
          if (_fiveYearDate[_i9]) {
            _fiveArr.push(_fiveYearDate[_i9]);
          }
        }
        for (var _i10 = 0; _i10 < _totalDate.length; _i10++) {
          if (_totalDate[_i10]) {
            _totalArr.push(_totalDate[_i10]);
          }
        }
        _this2.setState({
          oneMonthDate: _oneArr,
          oneMonthNav: _oneMonthNav,

          threeMonthDate: _threeArr,
          threeMonthNav: _threeMonthNav,

          sixMonthDate: _sixArr,
          sixMonthNav: _sixMonthNav,

          oneYearDate: _yearArr,
          oneYearNav: _oneYearNav,

          thisyearDate: _thisyearArr,
          thisyearNav: _thisyearNav,

          ThreeYearDate: _ThreeArr, //三年
          ThreeYearNav: _ThreeYearNav,

          fiveYearDate: _fiveArr, //五年
          fiveYearNav: _fiveYearNav,

          totalDate: _totalArr,
          totalNav: _totalNav,

          echartsData: data
        });
        datas = {
          oneMonthDate: _oneArr,
          oneMonthNav: _oneMonthNav,

          threeMonthDate: _threeArr,
          threeMonthNav: _threeMonthNav,

          sixMonthDate: _sixArr,
          sixMonthNav: _sixMonthNav,

          oneYearDate: _yearArr,
          oneYearNav: _oneYearNav,

          thisyearDate: _thisyearArr,
          thisyearNav: _thisyearNav,

          ThreeYearDate: _ThreeArr, //三年
          ThreeYearNav: _ThreeYearNav,

          fiveYearDate: _fiveArr, //五年
          fiveYearNav: _fiveYearNav,

          totalDate: _totalArr,
          totalNav: _totalNav
        };
        setTimeout(function () {
          _this2.echartsbox.showOptionNav(datas, val);
        }, 0);
        setTimeout(function () {
          _this2.setState({
            loadingFlag: false
          });
        }, 50);
      }
    };

    _this2.selectTabFun = function (val) {
      _this2.setState({
        selectTab: val, initialPage: _this2.state.initialPage, selectOther: false
      });
      var fundcode = _this2.state.fundCode;
      if (_this2.state.tabVal == '业绩走势') {
        if (val == '近1月') {
          if (_this2.state.chartsDataArr.oneMonth.length > 0 && _this2.state.OneMonthBasicffsa) {
            _this2.setState({
              type: "m1",
              publicFundPerformanceflag: _this2.state.chartsDataArr.oneMonthpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.oneMonth, _this2.state.selectTab, _this2.state.maxDrawDownArr.OneMonthmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              OneMonthBasicffsa: true,
              type: "m1"
            });
            var params = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "m1" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(params, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { oneMonth: IndexData, oneMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { OneMonthmaxDrawDownValue: data.maxDrawDownValue }),
                loadingFlag: false
              });
            }));
          }
        } else if (val == '近3月') {
          if (_this2.state.chartsDataArr.threeMonth.length > 0 && _this2.state.ThreeMonthBasicffsa) {
            _this2.setState({
              type: "m3",
              publicFundPerformanceflag: _this2.state.chartsDataArr.threeMonthpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.threeMonth, _this2.state.selectTab, _this2.state.maxDrawDownArr.ThreeMonthmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              ThreeMonthBasicffsa: true,
              type: "m3"
            });
            var _params8 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "m3" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params8, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { threeMonth: IndexData, threeMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThreeMonthmaxDrawDownValue: data.maxDrawDownValue }),
                loadingFlag: false
              });
            }));
          }
        } else if (val == '近6月') {
          if (_this2.state.chartsDataArr.sixMonth.length > 0 && _this2.state.SixMonthBasicffsa) {
            _this2.setState({
              type: "m6",
              publicFundPerformanceflag: _this2.state.chartsDataArr.sixMonthpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.sixMonth, _this2.state.selectTab, _this2.state.maxDrawDownArr.SixMonthmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              SixMonthBasicffsa: true,
              type: "m6"
            });
            var _params9 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "m6" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params9, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { sixMonth: IndexData, sixMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { SixMonthmaxDrawDownValue: data.maxDrawDownValue }),
                loadingFlag: false
              });
            }));
          }
        } else if (val == '近1年') {
          if (_this2.state.chartsDataArr.oneYear.length > 0 && _this2.state.OneYearBasicffsa) {
            _this2.setState({
              type: "y1",
              publicFundPerformanceflag: _this2.state.chartsDataArr.oneYearpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.oneYear, _this2.state.selectTab, _this2.state.maxDrawDownArr.OneYearmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              OneYearBasicffsa: true,
              type: "y1"
            });
            var _params10 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "y1" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params10, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { oneYear: IndexData, oneYearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { OneYearmaxDrawDownValue: data.maxDrawDownValue }),
                loadingFlag: false
              });
            }));
          }
        } else if (val == '今年以来') {
          if (_this2.state.chartsDataArr.thisyear.length > 0 && _this2.state.ThisyearBasicffsa) {
            _this2.setState({
              type: "thisyear",
              publicFundPerformanceflag: _this2.state.chartsDataArr.thisyearpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.thisyear, _this2.state.selectTab, _this2.state.maxDrawDownArr.ThisyearmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              ThisyearBasicffsa: true,
              type: "thisyear"
            });
            var _params11 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "thisyear" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params11, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { thisyear: IndexData, thisyearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThisyearmaxDrawDownValue: data.maxDrawDownValue }),
                loadingFlag: false
              });
            }));
          }
        } else if (val == '近3年') {
          if (_this2.state.chartsDataArr.ThreeYear.length > 0 && _this2.state.ThreeYearBasicffsa) {
            _this2.setState({
              type: "y3",
              publicFundPerformanceflag: _this2.state.chartsDataArr.ThreeYearpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.ThreeYear, _this2.state.selectTab, _this2.state.maxDrawDownArr.ThreeYearmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              ThreeYearBasicffsa: true,
              type: "y3"
            });
            var _params12 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "y3" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params12, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { ThreeYear: IndexData, ThreeYearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThreeYearmaxDrawDownValue: data.maxDrawDownValue }),
                loadingFlag: false
              });
            }));
          }
        } else if (val == '近5年') {
          if (_this2.state.chartsDataArr.fiveYear.length > 0 && _this2.state.FiveYearBasicffsa) {
            _this2.setState({
              type: "y5",
              publicFundPerformanceflag: _this2.state.chartsDataArr.fiveYearpublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.fiveYear, _this2.state.selectTab, _this2.state.maxDrawDownArr.FiveYearmaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              FiveYearBasicffsa: true,
              type: "y5"
            });
            var _params13 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "y5" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params13, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { fiveYear: IndexData, fiveYearpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { FiveYearmaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          }
        } else if (val == '成立以来') {
          if (_this2.state.chartsDataArr.allData.length > 0 && _this2.state.AllDataBasicffsa) {
            _this2.setState({
              type: "sincefound",
              publicFundPerformanceflag: _this2.state.chartsDataArr.allDatapublicFundflag
            });
            _this2.changeEchartsData(_this2.state.tabVal, _this2.state.chartsDataArr.allData, _this2.state.selectTab, _this2.state.maxDrawDownArr.AllDatamaxDrawDownValue);
          } else {
            _this2.setState({
              loadingFlag: true,
              AllDataBasicffsa: true,
              type: "sincefound"
            });
            var _params14 = { fundCode: fundcode, symbolCode: _this2.state.symbolcode, type: "sincefound" };
            _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(_params14, function (data) {
              var IndexData = _this2.datacl(data);
              _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue), _this2.setState({
                chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { allData: IndexData, allDatapublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
                maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { AllDatamaxDrawDownValue: data.maxDrawDownValue })
              });
            }));
          }
        }
      } else {
        if (_this2.state.echartsData !== null) {
          var datas = {
            oneMonthDate: _this2.state.oneMonthDate,
            oneMonthNav: _this2.state.oneMonthNav,
            threeMonthDate: _this2.state.threeMonthDate,
            threeMonthNav: _this2.state.threeMonthNav,
            sixMonthDate: _this2.state.sixMonthDate,
            sixMonthNav: _this2.state.sixMonthNav,
            oneYearDate: _this2.state.oneYearDate,
            oneYearNav: _this2.state.oneYearNav,
            thisyearDate: _this2.state.thisyearDate,
            thisyearNav: _this2.state.thisyearNav,
            ThreeYearDate: _this2.state.ThreeYearDate, //三年
            ThreeYearNav: _this2.state.ThreeYearNav,
            fiveYearDate: _this2.state.fiveYearDate, //五年
            fiveYearNav: _this2.state.fiveYearNav,
            totalDate: _this2.state.totalDate,
            totalNav: _this2.state.totalNav
          };
          if (val == '近1月') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '近3月') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '近6月') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '近1年') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '今年以来') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '近3年') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '近5年') {
            _this2.echartsbox.showOptionNav(datas, val);
          } else if (val == '成立以来') {
            _this2.echartsbox.showOptionNav(datas, val);
          }
        }
      }
    };

    _this2.onRef = function (ref) {
      _this2.echartsbox = ref;
    };

    _this2.Coloroffluctuationrange = function (val) {
      val = Number(val);
      var valColor = "#999999";
      if (val == 0) {
        valColor = "#999999";
      } else if (val < 0) {
        valColor = "#1DA96B";
      } else if (val > 0) {
        valColor = "#FA063A";
      } else {
        valColor = "#999999";
      }
      return valColor;
    };

    _this2.FundAnalysis = function (val) {
      if (_this2.state.dataSource.yearsOfFund >= 5 && val == "近五年") {
        var dispatch = _this2.props.dispatch;

        var parameter = {
          fundCode: _this2.state.fundCode
        };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_7" /* getFundAnalysisIndicatorOfFiveYears */])(parameter, function (data) {
          _this2.setState({
            maxDownSideFiveYear: data.maxDownSideFiveYear,
            text: val
          });
        }));
      } else {
        _this2.setState({ text: val });
      }
    };

    _this2.investmentallocation = function (dataSource) {
      var investdata = [{}, {}, {}, {}];
      var data = [];
      if (dataSource != null) {
        var _data = dataSource.PublicDetilAsset;
        if (dataSource.riskLevelName == "低风险") {
          investdata[0].name = "股票" + " --";
          investdata[0].value = 0.00;
        }
        for (var i = 0; i < _data.length; i++) {
          if (_data[i].name === "其中：股票" || _data[i].name === "其中：普通股") {
            investdata[0].name = "股票";
            investdata[0].value = newToFixed(_data[i].rate);
          } else if (_data[i].name === "其中：债券") {
            investdata[1].name = "债券";
            investdata[1].value = newToFixed(_data[i].rate);
          } else if (_data[i].name === "银行存款和结算备付金合计") {
            investdata[2].name = "现金";
            investdata[2].value = newToFixed(_data[i].rate);
          } else if (_data[i].name === "其他各项资产") {
            investdata[3].name = "其他";
            investdata[3].value = newToFixed(_data[i].rate);
          }
        }
        if (!investdata[0].name) {
          investdata[0].name = "股票";
          investdata[0].value = 0;
        }
        if (!investdata[1].name) {
          investdata[1].name = "债券";
          investdata[1].value = 0;
        }
        if (!investdata[2].name) {
          investdata[2].name = "现金";
          investdata[2].value = 0;
        }
        if (!investdata[3].name) {
          investdata[3].name = "其他";
          investdata[3].value = 0;
        }
      }
      investdata.map(function (item) {
        if (item.value > 0) {
          data.push(item);
        }
      });
      data.sort(function (a, b) {
        //  b-a 就是后边的值减前边的值 降序 
        return b.value - a.value;
      });

      return data;
    };

    _this2.Proportionofheavypositions = function (data) {
      // PublicDetilStock 重仓股  PublicDetailFund 重仓基金 PublicDetilBond 重仓债   
      // compareToPrevious 较上期
      var text = "";
      if (data != null) {
        var PublicDetilBondsum = { sum: 0, tet: "" //重仓债
        };var PublicDetilStocksum = { sum: 0, tet: "" //重仓股
        };var PublicDetailFundsum = { sum: 0, tet: "" //重仓基金
        };var Bondsum = 0;
        var Stocksum = 0;
        var Fundsum = 0;
        data.PublicDetilBond.map(function (item) {
          Bondsum = Number(Bondsum - 0 + Number(item.rate)).toFixed(2);
          PublicDetilBondsum = { sum: Number(Bondsum), tex: "重仓债券" };
        });
        data.PublicDetilStock.map(function (item) {
          Stocksum = Number(Stocksum - 0 + Number(item.rate)).toFixed(2);
          PublicDetilStocksum = { sum: Number(Stocksum), tex: "重仓股票" };
        });
        data.PublicDetailFund.map(function (item) {
          Fundsum = Number(Fundsum - 0 + Number(item.rate)).toFixed(2);
          PublicDetailFundsum = { sum: Number(Fundsum), tex: "重仓基金" };
        });
        // console.log(PublicDetilBondsum,PublicDetilStocksum,PublicDetailFundsum)
        var dataaaaa = [PublicDetilStocksum, PublicDetailFundsum, PublicDetilBondsum];
        dataaaaa.sort(function (a, b) {
          //  b-a 就是后边的值减前边的值 降序 
          return b.sum - a.sum;
        });
        text = dataaaaa[0].tex;
      }
      return text;
    };

    _this2.dateformat = function (data) {
      if (data != null) {
        var year = data.slice(0, 4);
        var month = data.slice(4, 6);
        var day = data.slice(6, 9);
        return year + "-" + month + "-" + day;
      }
      return "--";
    };

    _this2.productTypeCallback = function (name, Code) {
      var dispatch = _this2.props.dispatch;

      var params = { fundCode: _this2.state.fundCode, symbolCode: Code, type: _this2.state.type };
      _this2.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(params, function (data) {
        var IndexData = _this2.datacl(data);
        _this2.changeEchartsData(_this2.state.tabVal, IndexData, _this2.state.selectTab, data.maxDrawDownValue);
        if (_this2.state.selectTab == "近一月") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { oneMonth: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { OneMonthmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "近三月") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { threeMonth: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThreeMonthmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "近六月") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { sixMonth: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { SixMonthmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "近一年") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { oneYear: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { OneYearmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "近三年") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { ThreeYear: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThreeYearmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "近五年") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { fiveYear: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { FiveYearmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "今年以来") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { thisyear: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { ThisyearmaxDrawDownValue: data.maxDrawDownValue })
          });
        } else if (_this2.state.selectTab == "成立以来") {
          _this2.setState({
            chartsDataArr: Object.assign({}, _this2.state.chartsDataArr, { allData: IndexData }),
            maxDrawDownArr: Object.assign({}, _this2.state.maxDrawDownArr, { AllDatamaxDrawDownValue: data.maxDrawDownValue })
          });
        }
      }));
      _this2.setState({
        Basictext: name,
        symbolcode: Code,
        Basicfalg: false,
        OneMonthBasicffsa: false,
        ThreeMonthBasicffsa: false,
        SixMonthBasicffsa: false,
        OneYearBasicffsa: false,
        ThisyearBasicffsa: false,
        ThreeYearBasicffsa: false,
        FiveYearBasicffsa: false,
        AllDataBasicffsa: false
      });
    };

    _this2.goToProductSummaryPage = function () {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/ProductSummary',
        state: {
          url: _this2.state.dataSource.cpzlgyUrl,
          navigator: __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */]
        }
      });
    };

    _this2.goToManager = function (fundCode, wdmanagerid, index) {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/NewManagerDetailSlidePage',
        state: {
          fundCode: fundCode,
          wdmanagerid: wdmanagerid,
          index: index
        }
      });
    };

    _this2.onLearnMore = function (url) {
      _this2.props.navigator.push({
        pathname: '/NoticeListPdf',
        state: {
          downloadUrl: url
        }
      });
    };

    _this2.OpenApp = function (e) {
      var fundCode = _this2.state.fundCode;

      var u = navigator.userAgent;
      var Config = {
        /*scheme:必须*/
        // scheme: 'hxfapp://index/?component=NewPublicOffering&fundcode='+this.state.fundCode,
        download_url_IOS: "https://itunes.apple.com/cn/app/%E5%8D%8E%E5%A4%8F%E6%9F%A5%E7%90%86%E6%99%BA%E6%8A%95-%E5%8D%8E%E5%A4%8F%E5%9F%BA%E9%87%91%E6%97%97%E4%B8%8B%E6%99%BA%E8%83%BD%E6%8A%95%E9%A1%BE%E5%B9%B3%E5%8F%B0/id1310292772?mt=8",
        download_url_Adr: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.huaxiafortune',
        timeout: 2000,
        jump_url: "https://app.amcfortune.com/open-wapp?param=",
        hidden: window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
      };
      var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // 微信内
      if (isWeixin) {
        _this2.setState({ showOverLay: true });
        return;
      }
      {
        //android端
        if (isAndroid) {
          //安卓app的scheme协议  
          //  window.location.href = Config.scheme;
          window.location.href = 'hxfapp://index/?param=' + JSON.stringify({ param1: fundCode, param2: 'GDetail' });
          // window.open = Config.scheme;
          setTimeout(function () {
            if (typeof Config.hidden === "undefined" || Config.hidden === false) {
              //应用宝下载地址 
              window.location.href = Config.download_url_Adr;
            }
          }, Config.timeout);
        }
        //ios端
        if (isIOS) {
          //ios的scheme协议
          //  window.location.href = Config.scheme;
          // window.open = Config.scheme;

          //  setTimeout(function(){
          //      if(typeof Config.hidden ==="undefined" || Config.hidden ===false){
          //          //App store下载地址
          //         //  window.location.href =Config.download_url_IOS
          //         window.location.replace(Config.download_url_IOS)
          //       }
          //  }, Config.timeout);
          window.location.href = Config.jump_url + JSON.stringify({ param1: fundCode, param2: "GDetail" });
        }
      }
    };

    _this2.state = {
      key: '1',
      loadingFlag: true,
      initialPage: 0,
      is_optional: '0',
      tipIntroduce: false,
      dataSource: null,
      AddZxFlag: "",
      isTaxDeferredProduct: "0", //“1”个税产品“0”非个税产品
      AccumulatedNet: [],
      selectOther: false,
      tabtext: "",
      tabtextList: [],
      arr: [],
      text: "近一年",
      investflag: false,
      sum: 0,
      invest: null,
      tebflag: false,
      beginDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["d" /* getOneMonthBefor */])(),
      endDate: "",

      buyDateList: [], //净值打点
      redeemDateList: [],

      newbuyDateList: [], //新版折线图收益走势 买入点
      newredeemDateList: [], //卖出
      dividendDateList: [], //分红

      profitNav: null,
      profitData: null,
      allIncome: null,
      Lineval: null,
      newDatas: null,
      newNevs: null,
      newNev: null,
      newData: null,
      tabVal: null,
      selectTab: '近1年',
      syArr: {
        zxjz: "--",
        rzdf: "--",
        wfsy: "--",
        qrnh: "--"
      },
      lineOption1: null,
      threeMonthDate: [],
      threeMonthNav: [],
      totalNav: [],
      totalDate: [],
      thisyearDate: [], //今年以来
      thisyearNav: [],
      ThreeYearDate: [], //三年
      ThreeYearNav: [],
      fiveYearDate: [], //五年
      fiveYearNav: [],
      oneYearDate: [],
      oneYearNav: [],
      oneMonthDate: [],
      oneMonthNav: [],
      sixMonthDate: [],
      sixMonthNav: [],
      echartsData: null,
      chartsDataArr: { //折线图
        oneMonth: [],
        oneMonthpublicFundflag: false,
        threeMonth: [],
        threeMonthpublicFundflag: false,
        sixMonth: [],
        sixMonthpublicFundflag: false,
        oneYear: [],
        oneYearpublicFundflag: false,
        thisyear: [],
        thisyearpublicFundflag: false,
        ThreeYear: [],
        ThreeYearpublicFundflag: false,
        fiveYear: [],
        fiveYearpublicFundflag: false,
        allData: [],
        allDatapublicFundflag: false
      },

      Basictext: "沪深300", //指数基本信息
      symbolcode: "000300",
      Basicfalg: false,
      DataArr: [], //指数和折线图对比数据源
      icatorFlag: false, //是否展示基金指数
      dataInfo: null,
      Netperformance: null,
      buyTradeRule: null,
      PublicDetilBaseInfo: null,
      PublicDetilManager: null,
      latestDividend: null,
      latestPublicFundAnnouncement: null,
      acRelationFundCode: null,
      fundCode: '',
      chenck: false,
      chencked: false,
      dividDateList: [], //分红
      relationFundName: null,
      publicFundPerformanceflag: false, //是否只有本基金
      jumpToAPP: false,
      download_scheme: '',
      type: "m1",
      publicFundPerformanceResponseList: null,
      publicFundBenchmarkPerformanceResponseList: null,
      indexPerformanceResponseList: null,
      maxDrawDownArr: { //折线图最大回撤
        OneMonthmaxDrawDownValue: null,
        ThreeMonthmaxDrawDownValue: null,
        SixMonthmaxDrawDownValue: null,
        OneYearmaxDrawDownValue: null,
        ThisyearmaxDrawDownValue: null,
        ThreeYearmaxDrawDownValue: null,
        FiveYearmaxDrawDownValue: null,
        AllDatamaxDrawDownValue: null
      },
      OneMonthBasicffsa: true,
      ThreeMonthBasicffsa: true,
      SixMonthBasicffsa: true,
      OneYearBasicffsa: true,
      ThisyearBasicffsa: true,
      ThreeYearBasicffsa: true,
      FiveYearBasicffsa: true,
      AllDataBasicffsa: true,
      Basicdata: [{ symbolCode: '000905', symbolName: '中证500', exchangeName: 'XSHG' }, { symbolCode: '399005', symbolName: '中小板', exchangeName: 'XSHE' }, { symbolCode: '399006', symbolName: '创业板', exchangeName: 'XSHE' }, { symbolCode: '000300', symbolName: '沪深300', exchangeName: 'XSHG' }, { symbolCode: '000016', symbolName: '上证50', exchangeName: 'XSHG' }, { symbolCode: '399001', symbolName: '深证指数', exchangeName: 'XSHE' }, { symbolCode: '000001', symbolName: '上证指数', exchangeName: 'XSHG' }],
      discountRateHundredPercent: '',
      maxBuyRateHundredPercent: '',
      maxDrawDownValue: null,
      chengli: null,
      Notenoughforoneyear: 1
    };
    _this2.scrollView = null;
    _this2.androidUrl = '';
    _this2.arr = [];
    return _this2;
  }
  //获取操作系统的名称和版本

  //获取设备类型


  _createClass(NewPublicOffering, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var dispatch = this.props.dispatch;


      var fundcode = this.props.location.query.fundcode ? this.props.location.query.fundcode : '000948';
      __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading('', 0);
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_8" /* newgetPublicProductDetil */])(fundcode, this.handleCallback.bind(this), this));

      var userAgent = navigator.userAgent;
      console.log(userAgent);
      var versionIndex = userAgent.indexOf('Version/');
      var appVersion = '';
      if (versionIndex !== -1) {
        appVersion = userAgent.substr(versionIndex + 8).split(' ')[0];
      }
      console.log('***********appVersion*****************', appVersion);

      var osInfo = this.getOperatingSystem();
      var osver = osInfo.osName + ' ' + osInfo.osVersion;
      console.log('Operating System:', osver);
      var deviceType = this.getDeviceType();

      var params = {
        appver: appVersion,
        ostype: deviceType,
        appname: "HXCF_APP",
        osver: osver
      };
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_9" /* getVersionInfo */])(params, function (data) {
        console.log(data);
        _this3.androidUrl = data.data.url;
        console.log(_this3.androidUrl);
      }, function (err) {
        console.log(err, "**********************");
      }));
    }
  }, {
    key: 'dateData',
    value: function dateData(property, bol) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (bol) {
          // 升序
          return Date.parse(value1) - Date.parse(value2);
        } else {
          // 降序
          return Date.parse(value2) - Date.parse(value1);
        }
      };
    }
  }, {
    key: 'datacl',
    value: function datacl(data) {
      this.setState({
        publicFundPerformanceflag: false
      });
      var Data = [];
      if (data.publicFundPerformanceResponseList !== null || data.publicFundPerformanceResponseList.length > 0) {
        var mergedArray = data.publicFundPerformanceResponseList.concat(data.publicFundBenchmarkPerformanceResponseList, data.indexPerformanceResponseList);
        var mergedObject = {};
        mergedArray.forEach(function (item) {
          var date = item.trendDate;
          if (!mergedObject[date]) {
            mergedObject[date] = {
              value: null,
              allIncome: null,
              Lineval: null,
              maxDrawDown: null,
              deadLine: item.trendDate
            };
          }
          mergedObject[date].value = null;
          mergedObject[date].allIncome = null;
          mergedObject[date].Lineval = null;
        });
        var resultArray = Object.values(mergedObject).sort(this.dateData("deadLine", true));
        var publicFundPerformanceResponseList = data.publicFundPerformanceResponseList;
        var publicFundBenchmarkPerformanceResponseList = data.publicFundBenchmarkPerformanceResponseList;
        var indexPerformanceResponseList = data.indexPerformanceResponseList;

        var arr1 = new Map();
        for (var i = publicFundPerformanceResponseList.length - 1; i >= 0; i--) {
          arr1.set(publicFundPerformanceResponseList[i].trendDate, publicFundPerformanceResponseList[i]);
        }
        var arr2 = new Map();
        for (var _i11 = publicFundBenchmarkPerformanceResponseList.length - 1; _i11 >= 0; _i11--) {
          arr2.set(publicFundBenchmarkPerformanceResponseList[_i11].trendDate, publicFundBenchmarkPerformanceResponseList[_i11]);
        }
        var arr3 = new Map();
        for (var _i12 = indexPerformanceResponseList.length - 1; _i12 >= 0; _i12--) {
          arr3.set(indexPerformanceResponseList[_i12].trendDate, indexPerformanceResponseList[_i12]);
        }
        var hebing = [];
        var hebing1 = [];
        var hebing2 = [];
        resultArray.forEach(function (value, index) {
          var data = value.deadLine;
          if (arr1.has(data)) {
            var object = arr1.get(data);
            var object1 = value;
            object1.value = object.sumTrend;
            object1.valueTrend = object.trend;
            hebing.push(object1);
          } else {
            var _object = value;
            _object.value = null;
            _object.valueTrend = null;
            hebing.push(_object);
          }
        });
        hebing.forEach(function (value, index) {
          var data = value.deadLine;
          if (arr2.has(data)) {
            var object = arr2.get(data);
            var object1 = value;
            object1.allIncome = object.sumTrend;
            object1.allIncomeTrend = object.trend;
            hebing1.push(object1);
          } else {
            var _object2 = value;
            _object2.allIncome = null;
            _object2.allIncomeTrend = null;
            hebing1.push(_object2);
          }
        });
        hebing1.forEach(function (value, index) {
          var data = value.deadLine;
          if (arr3.has(data)) {
            var object = arr3.get(data);
            var object1 = value;
            object1.Lineval = object.sumTrend;
            object1.LinevalTrend = object.trend;
            hebing2.push(object1);
          } else {
            var _object3 = value;
            _object3.Lineval = null;
            _object3.LinevalTrend = null;
            hebing2.push(_object3);
          }
        });
        if (this.state.Notenoughforoneyear !== -1) {
          var allStartDate = data.maxDrawDownStart ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["m" /* getDateS */])(data.maxDrawDownStart) : null;
          var allEndDate = data.maxDrawDownEnd ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["m" /* getDateS */])(data.maxDrawDownEnd) : null;
          if (allStartDate && allEndDate) {
            for (var _i13 = 0; _i13 < hebing2.length; _i13++) {
              var deadLine = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["m" /* getDateS */])(hebing2[_i13].deadLine);
              if (deadLine.getTime() < allStartDate.getTime() || deadLine.getTime() > allEndDate.getTime()) {
                Data.push({ value: hebing2[_i13].value, valueTrend: hebing2[_i13].valueTrend, allIncome: hebing2[_i13].allIncome, allIncomeTrend: hebing2[_i13].allIncomeTrend, Lineval: hebing2[_i13].Lineval, LinevalTrend: hebing2[_i13].LinevalTrend, maxDrawDown: null, deadLine: hebing2[_i13].deadLine });
              } else {
                Data.push({ value: hebing2[_i13].value, valueTrend: hebing2[_i13].valueTrend, allIncome: hebing2[_i13].allIncome, allIncomeTrend: hebing2[_i13].allIncomeTrend, Lineval: hebing2[_i13].Lineval, LinevalTrend: hebing2[_i13].LinevalTrend, maxDrawDown: hebing2[_i13].value, deadLine: hebing2[_i13].deadLine });
              }
            }
          } else {
            for (var _i14 = 0; _i14 < hebing2.length; _i14++) {
              Data.push({ value: hebing2[_i14].value, valueTrend: hebing2[_i14].valueTrend, allIncome: hebing2[_i14].allIncome, allIncomeTrend: hebing2[_i14].allIncomeTrend, Lineval: hebing2[_i14].Lineval, LinevalTrend: hebing2[_i14].LinevalTrend, maxDrawDown: null, deadLine: hebing2[_i14].deadLine });
            }
          }
          if (data.publicFundBenchmarkPerformanceResponseList.length == 0) {
            this.setState({
              publicFundPerformanceflag: true
            });
          }
        } else {
          Data = hebing2;
          if (data.publicFundBenchmarkPerformanceResponseList.length == 0) {
            this.setState({
              publicFundPerformanceflag: true
            });
          }
        }
      }
      // console.log(Data)
      return Data;
    }
  }, {
    key: 'handleCallback',
    value: function handleCallback(data) {
      var _this4 = this;

      var tabtextarr = [];
      if (data.PublicDetilInfo[0] && data.PublicDetilInfo[0].fundType === '货币型') {
        tabtextarr = ['行情', '业绩', '规则', '档案'];
      } else {
        tabtextarr = ['净值', '业绩', '规则', '档案'];
      }
      this.setState({
        dataSource: data,
        fundcode: data.PublicDetilInfo[0].fundcode,
        is_optional: data.is_optional,
        isTaxDeferredProduct: data.isTaxDeferredProduct, //获取养老个税产品标识
        icatorFlag: data.fundAnalysisIndicatorFlag === true && data.PublicDetilInfo[0].fundtype != "货币型" ? true : false,
        dataInfo: data.PublicDetilInfo[0], //基本信息
        Netperformance: data.PublicDetilProfit[0], //净值业绩
        buyTradeRule: data.buyTradeRule, //交易规则
        PublicDetilBaseInfo: data.PublicDetilBaseInfo[0], //基金档案
        PublicDetilManager: data.PublicDetilManager, //基金经理
        latestDividend: data.latestDividend, //分红记录
        latestPublicFundAnnouncement: data.latestPublicFundAnnouncement, //基金公告
        acRelationFundCode: data.acRelationFundCode, //a c类产品
        relationFundName: data.relationFundName, //a c类产品名
        fundCode: data.PublicDetilInfo[0].fundcode,
        tabtextList: tabtextarr,
        discountRateHundredPercent: data.discountRateHundredPercent,
        maxBuyRateHundredPercent: data.maxBuyRateHundredPercent,
        Notenoughforoneyear: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["x" /* dateDeath */])(data.PublicDetilBaseInfo[0].fundstartdate).indexOf("年"), //基金成立满不满足一年
        chengli: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__getPay__["x" /* dateDeath */])(data.PublicDetilBaseInfo[0].fundstartdate), //基金成立多少天
        invest: data.publicDetailAssetVoList
      }, function () {
        _this4.scrollView = document.getElementById('scrollView');
        _this4.scrollView.addEventListener('scroll', function (e) {
          return _this4.scrollFun(_this4, e);
        }, false);
        var echartsRef = document.getElementById('echartsbox').offsetTop;
        var ruleRef = document.getElementById('rule').offsetTop;
        var filesRef = document.getElementById('files').offsetTop;
        _this4.arr = [0, echartsRef - 45, ruleRef - 45, filesRef - 45];
      });
      var dispatch = this.props.dispatch;
      var fundcode = this.state.fundcode;
      //打点数据

      this.echinterface(data);

      if (data.PublicDetilInfo[0].fundtype !== '货币型') {
        //净值
        var getHdata = { type: 1, fundcode: fundcode };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_6" /* getPublicHistoryProfileRate */])(getHdata, function (data) {
          // console.log(data,"净值")
          var AccumulatedNet = data.HistoryRate.reverse();
          _this4.setState({
            AccumulatedNet: AccumulatedNet.slice(0, 4)
          });
        }, this));
        var params = { fundCode: fundcode, symbolCode: this.state.symbolcode, type: "m1" };
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_5" /* Newpublicinterface */])(params, function (data) {
          console.log(data, '折线图data');
          // buyDateList[yy--mm-mm,] 买入打点 
          // dividendDateList 分红日期打点
          // redeemDateList 卖出打点
          // publicFundBenchmarkPerformanceResponseList 业绩基准
          // publicFundPerformanceResponseList 本基金
          var IndexData = _this4.datacl(data);
          _this4.setState({
            publicFundPerformanceResponseList: data.publicFundPerformanceResponseList,
            publicFundBenchmarkPerformanceResponseList: data.publicFundBenchmarkPerformanceResponseList,
            indexPerformanceResponseList: data.indexPerformanceResponseList,
            chartsDataArr: Object.assign({}, _this4.state.chartsDataArr, { oneMonth: IndexData, oneMonthpublicFundflag: data.publicFundBenchmarkPerformanceResponseList.length > 0 ? false : true }),
            maxDrawDownArr: Object.assign({}, _this4.state.maxDrawDownArr, { OneMonthmaxDrawDownValue: data.maxDrawDownValue })
          });
          _this4.changeEchartsData(_this4.state.tabVal, IndexData, _this4.state.selectTab, data.maxDrawDownValue);
        }));

        this.setState({
          tabVal: "七日年化",
          initialPage: 0
        });
        this.tabValFun('业绩走势', 0);
      } else {
        this.tabValFun('七日年化', 0);
      }
      var datasum = this.investmentallocation(data);
      var sum = 0;
      datasum.map(function (item, index) {
        sum = Number(Number(item.value) + (sum - 0)).toFixed(2);
      });

      this.setState({
        sum: sum
      });
    }
    //打点数据接口

  }, {
    key: 'echinterface',
    value: function echinterface(data) {
      var _this5 = this;

      var dispatch = this.props.dispatch;
      var fundcode = this.state.fundcode;

      var Dotparams = { fundCode: fundcode };
      data.PublicDetilInfo[0].fundtype == '货币型' ? null : dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_10" /* Newpublicinterfacedadian */])(Dotparams, function (data) {
        _this5.setState({ dividDateList: data.dividendDateList }), console.log(data, '未登录打点数据');
      }), this);
    }
    //折线图数值


    //折线图点击事件

  }, {
    key: 'handleLocation',
    value: function handleLocation(id) {
      this.scrollView.scrollTo({ top: this.arr[id], behavior: 'smooth' });
    }
  }, {
    key: 'ResetDetail',
    value: function ResetDetail() {
      var dispatch = this.props.dispatch;

      var funcodeVue = this.state.dataSource.PublicDetilInfo[0].fundcode;
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__action_productAction__["_8" /* newgetPublicProductDetil */])(funcodeVue, function () {}, this));
    }
    //涨跌幅颜色

    //基金分析指标按钮

    // 投资分布占比

    //重仓占比对比

    //指数切换

  }, {
    key: 'callService',
    value: function callService() {}
    // OnlineService(this)

    //基金经理时间判断

  }, {
    key: 'sofar',
    value: function sofar(mvenddate1) {
      var mvenddate = new Date(mvenddate1).getTime();
      var mvend = new Date().getTime();
      if (mvenddate === mvend || null) {
        return "至今";
      } else {
        return mvenddate1;
      }
    }
  }, {
    key: 'goOfferingTranInfo',
    value: function goOfferingTranInfo() {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/PublicOfferingTranInfo',
        state: {
          fundCode: this.state.fundCode,
          isTaxDeferredProduct: this.state.isTaxDeferredProduct
        }
      });
    }
  }, {
    key: 'goFundGk',
    value: function goFundGk(val) {
      var isScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      console.log(this.state.dataSource);
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/newFundGk',
        state: {
          invest: this.state.invest,
          fundcode: this.state.fundCode,
          dataSource: this.state.dataSource,
          // initialPage:val === "行业" ? 1:val === "公告" ?  2:val === "分红记录" ? 3:0,
          initialPage: val,
          isScroll: isScroll
          // dispatch:this.props.dispatch
        }
      });
    }
  }, {
    key: 'gcClassC',
    value: function gcClassC(code, statecode) {
      var scode = this.props.statecode || "";
      if (code === scode) {
        this.props.navigator.pop();
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__common__["l" /* ClassfundFun */])(code, statecode, __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */]);
      }
    }
  }, {
    key: 'goBack',
    value: function goBack() {
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].goBack();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(key) {
      this.setState({ key: key });
    }
  }, {
    key: 'timeTxt',
    value: function timeTxt(currentDayIsWorkDay, currentTimeIsWorkTime) {
      // console.log(currentDayIsWorkDay,currentTimeIsWorkTime,'123123123')
      if (currentDayIsWorkDay && currentTimeIsWorkTime) return '今日15点前';
      if (currentDayIsWorkDay && !currentTimeIsWorkTime) return '今日15点后';
      if (!currentDayIsWorkDay) return '今日';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state = this.state,
          latestDividend = _state.latestDividend,
          is_optional = _state.is_optional,
          dataSource = _state.dataSource,
          text = _state.text,
          AccumulatedNet = _state.AccumulatedNet,
          Basicdata = _state.Basicdata,
          invest = _state.invest,
          acRelationFundCode = _state.acRelationFundCode,
          latestPublicFundAnnouncement = _state.latestPublicFundAnnouncement,
          relationFundName = _state.relationFundName,
          dataInfo = _state.dataInfo,
          Netperformance = _state.Netperformance,
          buyTradeRule = _state.buyTradeRule,
          PublicDetilBaseInfo = _state.PublicDetilBaseInfo,
          PublicDetilManager = _state.PublicDetilManager;
      // let Latestcopies=PublicDetilBaseInfo ? PublicDetilBaseInfo.lasttotal:null//份数 13是后面的日期加份的长度
      // let fen=Latestcopies=== null ? 0:Latestcopies.slice(0,Latestcopies.length - 13)
      // let Latestscale = dataInfo === null ? null:Util.priceParse(fen) * Number(dataInfo.fundvalue) //最新规模

      var chengli = this.state.chengli || ""; //基金成立多少天
      var Latestcopies = PublicDetilBaseInfo ? PublicDetilBaseInfo.lasttotal : null; //份数 13是后面的日期加份的长度
      var fen = Latestcopies === null ? 0 : Latestcopies.slice(0, Latestcopies.length - 13);
      var investdata = invest ? invest : null; //投资分布
      var Proport = this.Proportionofheavypositions(dataSource); //重仓占比
      var Proportdata = dataSource ? Proport === "重仓债券" ? dataSource.PublicDetilBond : Proport === "重仓股票" ? dataSource.PublicDetilStock : Proport === "重仓基金" ? dataSource.PublicDetailFund : null : null;
      var acRelationname = ""; //a c类产品名
      var funname = "";
      if (dataInfo === null) {
        acRelationname = "";
      } else {
        if (dataInfo.fundtype === "货币型") {
          if (dataSource === null) {
            acRelationname = "";
          } else if (dataSource.fundShareClass === "A") {
            funname = dataInfo === null ? "" : dataInfo.fundname.slice(0, dataInfo.fundname.length - 1);
            acRelationname = funname + "B";
          } else if (dataSource.fundShareClass === "B") {
            funname = dataInfo === null ? "" : dataInfo.fundname.slice(0, dataInfo.fundname.length - 1);
            acRelationname = funname + "A";
          }
        } else {
          if (dataSource === null) {
            acRelationname = "";
          } else if (dataSource.fundShareClass === "A") {
            funname = dataInfo === null ? "" : dataInfo.fundname.slice(0, dataInfo.fundname.length - 1);
            acRelationname = funname + "C";
          } else if (dataSource.fundShareClass === "C") {
            funname = dataInfo === null ? "" : dataInfo.fundname.slice(0, dataInfo.fundname.length - 1);
            acRelationname = funname + "A";
          }
        }
      }
      var _fxColor = "#FF8026";
      var biaotiyanse = {
        "股票": {
          imgurl: __webpack_require__(2189),
          fontColor: '#7361F4'
        },
        "债券": {
          imgurl: __webpack_require__(2182),
          fontColor: '#FF8026'
        },
        "现金": {
          imgurl: __webpack_require__(2187),
          fontColor: '#F92C3D'
        },
        "其他": {
          imgurl: __webpack_require__(2174),
          fontColor: '#407BE7'
        },
        '基金': {
          imgurl: __webpack_require__(2172),
          fontColor: '#37ABEE'
        }
      };
      var tabList = [];
      if (dataInfo != null) {
        if (dataInfo.fundtype === "货币型") {
          tabList = ["七日年化", "万份收益"];
        } else {
          tabList = ["业绩走势", "单位净值", "累计净值"];
        }
      }
      var historyList = ["历史业绩", "历史净值"];
      if (dataInfo === null) {
        historyList = ["历史业绩", "历史净值"];
      } else if (dataInfo.fundtype === "货币型") {
        historyList = ["历史业绩", "历史收益"];
      } else {
        historyList = ["历史业绩", "历史净值"];
      }
      var fundAnalysisIndicatorFlag = dataSource ? dataSource.fundAnalysisIndicatorFlag : null;
      var _this = this;
      var productTypeListContent = [];
      Basicdata ? Basicdata.map(function (itme, i) {
        productTypeListContent.push({ title: itme.symbolName, code: itme.symbolCode, callback: function callback() {
            _this.productTypeCallback(itme.symbolName, itme.symbolCode);
          } });
      }) : null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'container', style: { background: '#fff', display: 'flex', flexDirection: 'column' } },
        this.state.showOverLay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: function onClick() {
              return _this6.setState({ showOverLay: false });
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { position: 'relative' } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: ' rgba(0, 0, 0, 0.5)', /* 半透明黑色 */
                zIndex: 99999999 /* 保证遮罩层在其他内容之上 */
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2155), width: '100%', height: 'auto' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'header', id: 'header', style: { position: 'relative', backgroundColor: '#fff', background: 'url(' + __WEBPACK_IMPORTED_MODULE_4__imgs_headerImg_png___default.a + ') repeat-x', backgroundSize: 'cover' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', width: 150 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
              dataInfo ? dataInfo.fundname : "--"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { id: 'scrollView', style: { flex: 1, overflow: 'auto' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '100%', position: 'relative' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { heighe: 160, background: 'url(' + __webpack_require__(1973) + ') repeat-x', backgroundSize: 'cover', backgroundPosition: ' 0 -136px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { boxShadow: '0 1px 1px rgba(0, 0, 0, 0.10)', marginBottom: 5, background: '#fff', borderRadius: 10, marginLeft: 20, marginRight: 20, paddingBottom: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { paddingTop: 17, paddingLeft: 15, marginBottom: 23, background: 'url(' + __WEBPACK_IMPORTED_MODULE_5__imgs_fundHeader_png___default.a + ') no-repeat 0 0/100% auto' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: '#333', fontWeight: 500, lineHeight: '22px', fontSize: 18, marginBottom: 10 } },
                    dataInfo ? dataInfo.fundname ? dataInfo.fundname : "--" : "--"
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 16, lineHeight: '16px', color: '#999', marginRight: 10 } },
                      dataInfo ? dataInfo.fundcode ? dataInfo.fundcode : "--" : "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 12, color: '#999999', border: '1px solid #999999', padding: 1, marginRight: 10 } },
                      dataInfo ? dataInfo.fundtype ? dataInfo.fundtype : "--" : "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 12, color: '#FF8026', border: '1px solid #FF8026', padding: 1 } },
                      dataSource ? dataSource.riskLevelName ? dataSource.riskLevelName : "--" : "--",
                      dataSource ? dataSource.riskLevel ? "R" + dataSource.riskLevel : "--" : "--"
                    )
                  )
                ),
                dataInfo && dataInfo.fundtype === "货币型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', paddingLeft: 15, paddingRight: 15, justifyContent: 'space-between' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { flex: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 24, marginBottom: 5, color: dataInfo ? this.Coloroffluctuationrange(dataInfo.qirinianhua) : "#999999", fontFamily: 'DINAlternate-Bold' } },
                      dataInfo.qirinianhua ? dataInfo.qirinianhua > 0 ? "+" + __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(dataInfo.qirinianhua) + "%" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(dataInfo.qirinianhua) + "%" : "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12999) },
                      '\u4E03\u65E5\u5E74\u5316(',
                      dataInfo.publish_date ? dataInfo.publish_date.slice(5, 10) : "--",
                      ')'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { flex: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 24, textAlign: 'center', marginBottom: 5, color: "#333", fontFamily: 'DINAlternate-Bold' } },
                      dataInfo.wanfenshouyi ? dataInfo.wanfenshouyi : "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12999, { textAlign: 'center' }) },
                      '\u4E07\u4EFD\u6536\u76CA(\u5143)'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { flex: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 24, textAlign: 'center', marginBottom: 5, color: dataInfo ? this.Coloroffluctuationrange(Netperformance.yearnavchgrate) : "#999999", fontFamily: 'DINAlternate-Bold' } },
                      Netperformance ? __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.yearnavchgrate) : "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12999, { textAlign: 'center' }) },
                      '\u4ECA\u5E74\u4EE5\u6765\u6536\u76CA\u7387'
                    )
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', paddingLeft: 15, paddingRight: 15, justifyContent: 'space-between' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { flex: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 24, marginBottom: 5, color: AccumulatedNet.length > 0 ? this.Coloroffluctuationrange(AccumulatedNet[0].value_zdf) : "#999999", fontFamily: 'DINAlternate-Bold' } },
                      AccumulatedNet.length > 0 ? __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(AccumulatedNet[0].value_zdf) : "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12999) },
                      '\u65E5\u6DA8\u8DCC\u5E45(',
                      dataInfo && dataInfo.publish_date.slice(5, 10) || "--",
                      ')'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { flex: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 24, textAlign: 'center', marginBottom: 5, color: '#333', fontFamily: 'DINAlternate-Bold' } },
                      dataInfo && dataInfo.fundvalue || "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12999, { textAlign: 'center' }) },
                      '\u5355\u4F4D\u51C0\u503C'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { flex: 1 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 24, textAlign: 'center', marginBottom: 5, color: '#333', fontFamily: 'DINAlternate-Bold' } },
                      dataInfo && dataInfo.leijijingzhi || "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12999, { textAlign: 'center' }) },
                      '\u7D2F\u8BA1\u51C0\u503C'
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { background: '#fff', paddingBottom: 10 } },
              dataSource ? dataSource.marketingConfig ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this6.OpenApp();
                  }, style: { marginTop: 10, marginLeft: 20, marginRight: 20, display: 'flex', alignItems: 'center', height: 34, background: 'url(' + __WEBPACK_IMPORTED_MODULE_6__imgs_yingxiao_png___default.a + ') no-repeat', backgroundSize: 'cover' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 12, color: '#ED364F', marginRight: 5, marginLeft: 15, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } },
                  dataSource.marketingConfig.marketingClaims
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2156), style: { height: 10, width: 18 }, alt: '' })
              ) : null : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { id: 'echartsbox', style: { display: 'flex', paddingTop: 20, paddingLeft: 20, paddingRight: 20, marginBottom: 10 } },
                tabList.map(function (item, index) {
                  var fontColorName = index + 1 + '' === _this6.state.key ? "b1" : "b2";
                  var lineColor = index + 1 + '' === _this6.state.key ? "activeLine" : "notActiveLine";
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: index + 1 + '', onClick: function onClick() {
                        _this6.handleClick(index + 1 + '');_this6.tabValFun(item, index);
                      }, style: { display: 'flex', lineHeight: '16px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginRight: 25 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles[fontColorName], { marginBottom: 8 }) },
                      item
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: Object.assign({}, styles[lineColor], { height: 3, width: 28, borderRadius: 2 }) })
                  );
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EchartsBox, {
                _thisObj: this,
                _selectTab: this.state.selectTab,
                _tabVal: this.state.tabVal,

                _profitNav: this.state.profitNav,
                _profitData: this.state.profitData,

                onRef: this.onRef,
                newDatas: this.state.newDatas,
                newNevs: this.state.newNevs,
                newNev: this.state.newNev,
                newData: this.state.newData,
                allIncome: this.state.allIncome,
                Lineval: this.state.Lineval,
                Basicfalg: this.state.Basicfalg,
                Basicback: function Basicback() {
                  return _this6.setState({ Basicfalg: !_this6.state.Basicfalg });
                },
                Basictext: this.state.Basictext
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginLeft: 20, marginRight: 20, backgroundColor: "#fff", height: 30, borderRadius: 6, border: "1px solid #DFDFDF", display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this6.selectTabFun("近1月");
                    }, style: { flex: 1, height: 30, display: 'flex', justifyContent: "center", alignItems: "center", borderRight: '1px solid #DFDFDF' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: this.state.selectTab == "近1月" ? "#B69271" : "#3C3C3C", fontSize: 12 } },
                    '\u8FD11\u6708'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this6.selectTabFun("近3月");
                    }, style: { flex: 1, height: 30, display: 'flex', justifyContent: "center", alignItems: "center", borderRight: '1px solid #DFDFDF' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: this.state.selectTab == "近3月" ? "#B69271" : "#3C3C3C", fontSize: 12 } },
                    '\u8FD13\u6708'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this6.selectTabFun("近6月");
                    }, style: { flex: 1, height: 30, display: 'flex', justifyContent: "center", alignItems: "center", borderRight: '1px solid #DFDFDF' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: this.state.selectTab == "近6月" ? "#B69271" : "#3C3C3C", fontSize: 12 } },
                    '\u8FD16\u6708'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this6.selectTabFun("近1年");
                    }, style: { flex: 1, height: 30, display: 'flex', justifyContent: "center", alignItems: "center", borderRight: '1px solid #DFDFDF' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: this.state.selectTab == "近1年" ? "#B69271" : "#3C3C3C", fontSize: 12 } },
                    '\u8FD11\u5E74'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { onClick: function onClick() {
                      _this6.setState({ selectOther: true });
                    }, style: { flex: 1, height: 30, display: 'flex', justifyContent: "center", alignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: this.state.selectTab == "更多" ? "#B69271" : "#3C3C3C", fontSize: 12 } },
                    '\u66F4\u591A'
                  ),
                  this.state.selectOther === false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 8, height: 8 }, src: __webpack_require__(2165) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 8, height: 8 }, src: __webpack_require__(2166) })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: '#F5F6F7' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { id: 'history', style: { paddingTop: 15, paddingLeft: 20, paddingRight: 20, background: '#fff' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HistoryList, { AccumulatedNet: AccumulatedNet, historyList: historyList, Netperformance: Netperformance, dataSource: dataSource, dataInfo: dataInfo })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: '#F5F6F7' } }),
            fundAnalysisIndicatorFlag === true && dataInfo.fundtype != "货币型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: Object.assign({}, styles.box) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', marginBottom: 20 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: Object.assign({}, styles.font16333, { marginRight: 5 }) },
                  '\u57FA\u91D1\u5206\u6790\u6307\u6807'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { background: '#F0F0F0', display: 'flex', padding: 4, borderRadius: 11 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      style: { paddingLeft: 4, paddingRight: 4, color: text === "近一年" ? '#fff' : '#999', background: text === "近一年" ? "#F92C3D" : 'transparent', fontSize: 12, textAlign: 'center', lineHeight: '17px', borderRadius: 8 },
                      onClick: function onClick() {
                        return _this6.FundAnalysis("近一年");
                      }
                    },
                    '\u8FD1\u4E00\u5E74'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      style: { paddingLeft: 4, paddingRight: 4, color: text === "近三年" ? '#fff' : '#999', background: text === "近三年" ? "#F92C3D" : 'transparent', fontSize: 12, textAlign: 'center', lineHeight: '17px', borderRadius: 8, marginLeft: 4 },
                      onClick: function onClick() {
                        return _this6.FundAnalysis("近三年");
                      }
                    },
                    '\u8FD1\u4E09\u5E74'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      style: { paddingLeft: 4, paddingRight: 4, color: text === "近五年" ? '#fff' : '#999', background: text === "近五年" ? "#F92C3D" : 'transparent', fontSize: 12, textAlign: 'center', lineHeight: '17px', borderRadius: 8, marginLeft: 4 },
                      onClick: function onClick() {
                        return _this6.FundAnalysis("近五年");
                      }
                    },
                    '\u8FD1\u4E94\u5E74'
                  )
                )
              ),
              Netperformance ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                text === "近一年" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: '#333333', fontSize: 16 } },
                      Netperformance.volatilityYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.volatilityYear)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex', alignItems: 'center' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: Object.assign({}, styles.font12999) },
                        '\u6CE2\u52A8\u7387'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                          _this6.setState({ tipIntroduce: true });
                        }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: '#333333', fontSize: 16 } },
                      Netperformance.sharpRatioYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.sharpRatioYear)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex', alignItems: 'center' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: Object.assign({}, styles.font12999) },
                        '\u590F\u666E\u6BD4\u7387'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                          _this6.setState({ tipIntroduce: true });
                        }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { color: '#333333', fontSize: 16 } },
                      Netperformance.maxDownSideYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.maxDownSideYear)
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex', alignItems: 'center' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: Object.assign({}, styles.font12999) },
                        '\u6700\u5927\u56DE\u64A4'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                          _this6.setState({ tipIntroduce: true });
                        }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                    )
                  )
                ) : null,
                text === '近三年' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  dataSource.yearsOfFund >= 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        Netperformance.volatilityThreeYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.volatilityThreeYear)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font12999) },
                          '\u6CE2\u52A8\u7387'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                            _this6.setState({ tipIntroduce: true });
                          }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        Netperformance.sharpRatioThreeYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.sharpRatioThreeYear)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font12999) },
                          '\u590F\u666E\u6BD4\u7387'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                            _this6.setState({ tipIntroduce: true });
                          }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        Netperformance.maxDownSideThreeYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.maxDownSideThreeYear)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font12999) },
                          '\u6700\u5927\u56DE\u64A4'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                            _this6.setState({ tipIntroduce: true });
                          }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                      )
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: 62, color: '#999', fontSize: 12 } },
                    '\u6210\u7ACB\u65F6\u95F4\u4E0D\u8DB3\uFF0C\u6682\u65E0\u6570\u636E\uFF1B'
                  )
                ) : null,
                text === '近五年' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  dataSource.yearsOfFund >= 5 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-around' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        Netperformance.volatilityThreeYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.volatilityThreeYear)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font12999) },
                          '\u6CE2\u52A8\u7387'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                            _this6.setState({ tipIntroduce: true });
                          }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        Netperformance.sharpRatioThreeYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.sharpRatioThreeYear)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font12999) },
                          '\u590F\u666E\u6BD4\u7387'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                            _this6.setState({ tipIntroduce: true });
                          }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { background: '#FBFBFB', height: 62, width: 110, display: 'flex', justifyContent: 'center', alignItems: "center", flexDirection: 'column' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: '#333333', fontSize: 16 } },
                        Netperformance.maxDownSideThreeYear == 0 ? "--" : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloat(Netperformance.maxDownSideThreeYear)
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font12999) },
                          '\u6700\u5927\u56DE\u64A4'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                            _this6.setState({ tipIntroduce: true });
                          }, src: __webpack_require__(197), style: { height: 16, width: 16 }, alt: '' })
                      )
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-around', height: 62, color: '#999', fontSize: 12 } },
                    '\u6210\u7ACB\u65F6\u95F4\u4E0D\u8DB3\uFF0C\u6682\u65E0\u6570\u636E\uFF1B'
                  )
                ) : null
              ) : null
            ) : null,
            Netperformance ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: '#F5F6F7' } }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { id: 'rule', style: Object.assign({}, styles.box) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', marginBottom: 20 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: Object.assign({}, styles.font16333) },
                  '\u4EA4\u6613\u4FE1\u606F'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingBottom: 15, paddingLeft: 10, display: 'flex', justifyContent: 'space-between' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, display: 'flex', flexDirection: 'column' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.font12666 },
                    '\u4E70\u5165'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.redRound }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, backgroundColor: '#FFE5E7', flex: 1 } })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.font12999 },
                    buyTradeRule && this.timeTxt(buyTradeRule.currentDayIsWorkDay, buyTradeRule.currentTimeIsWorkTime) || ""
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { textAlign: 'center', flex: 2 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.font12666 },
                    '\u786E\u8BA4\u4EFD\u989D'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, backgroundColor: '#FFE5E7', flex: 1 } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.redRound }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, backgroundColor: '#FFE5E7', flex: 1 } })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.font12999 },
                    buyTradeRule && buyTradeRule.confirmDate.slice(-5) + '(' + (buyTradeRule.confirmDateWeekDay || '--') + ')' || "--"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 2, textAlign: 'right' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.font12666 },
                    '\u67E5\u770B\u76C8\u4E8F'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { marginTop: 4, marginBottom: 4, display: 'flex', alignItems: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, backgroundColor: '#FFE5E7', flex: 1 } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: styles.redRound })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: styles.font12999 },
                    buyTradeRule && buyTradeRule.incomeOrAssetReturnDate.slice(-5) + '\u51C0\u503C\u66F4\u65B0\u540E' || "--"
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: '#F5F6F7' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { id: 'files', style: Object.assign({}, styles.box) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', marginBottom: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: Object.assign({}, styles.font16333) },
                  '\u57FA\u91D1\u6863\u6848'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 14, color: '#999', marginBottom: 15 } },
                '\u57FA\u91D1\u516C\u53F8\uFF1A',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#333' } },
                  PublicDetilBaseInfo && PublicDetilBaseInfo.fundManager || "--"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', marginBottom: 15, justifyContent: 'space-between' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 14, color: '#999' } },
                  '\u6700\u65B0\u89C4\u6A21\uFF1A',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: '#333' } },
                    PublicDetilBaseInfo && PublicDetilBaseInfo.finalFundAssetNavStr || "--"
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 14, color: '#999', paddingRight: 10 } },
                  '\u6210\u7ACB\u65E5\u671F\uFF1A',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { color: '#333' } },
                    PublicDetilBaseInfo && PublicDetilBaseInfo.fundstartdate || "--"
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, marginBottom: 10, background: '#EFF0F4' } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', marginBottom: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: Object.assign({}, styles.font14666) },
                  '\u57FA\u91D1\u7ECF\u7406'
                )
              ),
              PublicDetilManager && PublicDetilManager.map(function (item, index) {
                return (
                  // <div key={index+''} onClick={()=>{ this.goToManager(dataInfo.fundcode,item.wdmanagerid,index) } } style={{...styles.box,marginBottom:15,background:`url(${require("../../../imgs/jijinjinglibeijing.png")}) repeat-x`,backgroundSize:'cover'}}>
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: index + '', style: Object.assign({}, styles.box, { marginBottom: 15, background: 'url(' + __webpack_require__(2173) + ') repeat-x', backgroundSize: 'cover' }) },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { marginBottom: 12, display: 'flex', alignItems: 'flex-end' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 16, color: '#985119', marginRight: 5, fontWeight: 500 } },
                        item.name || "--"
                      ),
                      item.periodOfOperationStr ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { style: { fontSize: 12, color: '#A1612C', marginRight: 5 } },
                        '\u4ECE\u4E1A',
                        item.periodOfOperationStr || "--"
                      ) : null
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex', justifyContent: 'space-between' } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', flexDirection: 'column' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { marginBottom: 4 } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: Object.assign({}, styles.font14119, { marginRight: 10, fontWeight: 500 }) },
                            item.startdate || "--",
                            ' - \u81F3\u4ECA'
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { fontSize: 12, color: '#985119', marginRight: 10 } },
                            item.daysStr
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { fontSize: 12, color: '#DBBEA6' } },
                          '\u672C\u57FA\u91D1\u4EFB\u671F'
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: Object.assign({}, styles.font14119, { marginBottom: 4, fontWeight: 500, fontFamily: 'DINAlternate-Bold' }) },
                          item.managerincome ? item.managerincome > 0 ? "+" + item.managerincome + "%" : item.managerincome + "%" : "--"
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { fontSize: 12, color: '#DBBEA6' } },
                          '\u4EFB\u671F\u5185\u56DE\u62A5'
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2157), style: { height: 20, marginTop: 10 }, alt: '' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font12119, { overflow: 'hidden', lineHeight: '17px', textOverflow: 'ellipsis', display: '-webkit-box', wordBreak: ' break-all', WebkitBoxOrient: 'vertical', WebkitLineClamp: 2 }) },
                      item.resume || "--"
                    )
                  )
                );
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, marginBottom: 10, background: '#EFF0F4' } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: Object.assign({}, styles.font14666) },
                  '\u6295\u8D44\u5206\u5E03'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: Object.assign({}, styles.font12999, { fontFamily: 'DINAlternate-Bold' }) },
                  dataSource && dataSource.PublicDetilAsset[0] && dataSource.PublicDetilAsset[0].reportenddate || "--"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', marginBottom: 10 } },
                investdata && investdata.map(function (item, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: index + '', style: { flex: 1, height: 63, paddingTop: 13, paddingLeft: 6, paddingBottom: 13, marginRight: 5, background: 'url(' + biaotiyanse[item.name].imgurl + ') repeat-x', backgroundSize: 'cover' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 16, color: biaotiyanse[item.name].fontColor, textAlign: 'left', marginBottom: 4, fontFamily: 'DINAlternate-Bold' } },
                      item.ratePercent || "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 12, color: '#00000063', textAlign: 'left' } },
                      item.name || "--"
                    )
                  );
                })
              ),
              this.state.sum > 100 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 10 }) },
                '\u4E3A\u4EC0\u4E48\u6BD4\u4F8B\u8D85\u8FC7100%',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: function onClick() {
                    _this6.setState({ investflag: true });
                  }, src: __webpack_require__(197), style: { height: 12, width: 12 }, alt: '' })
              ) : null,
              Proportdata ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingLeft: 15, paddingTop: 15, paddingRight: 8, borderRadius: 5, paddingBottom: 2, background: 'url(' + __webpack_require__(2188) + ') repeat-x', backgroundSize: 'cover' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 14, color: '#333', marginBottom: 15 } },
                  Proport || "--"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', justifyContent: 'space-between' } },
                  Proport === "重仓股票" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: Object.assign({}, styles.font12999, { marginBottom: 10, flex: 1 }) },
                    '\u80A1\u7968\u540D\u79F0'
                  ) : null,
                  Proport === "重仓基金" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: Object.assign({}, styles.font12999, { marginBottom: 10, flex: 1 }) },
                    '\u57FA\u91D1\u540D\u79F0'
                  ) : null,
                  Proport === "重仓债券" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: Object.assign({}, styles.font12999, { marginBottom: 10, flex: 1 }) },
                    '\u503A\u5377\u540D\u79F0'
                  ) : null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: Object.assign({}, styles.font12999, { marginLeft: 12, marginRight: 12, textAlign: 'center', width: 50 }) },
                    '\u6301\u4ED3\u5360\u6BD4'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: Object.assign({}, styles.font12999, { marginLeft: 12, marginRight: 12, textAlign: 'right', width: 50 }) },
                    '\u8F83\u4E0A\u671F'
                  )
                ),
                Proportdata.map(function (item, index) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: index + '', style: { display: 'flex', justifyContent: 'space-between', marginBottom: 10 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: Object.assign({}, styles.font14666, { flex: 1, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }) },
                      item.holdFundName ? item.holdFundName : item.name || "--"
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { fontSize: 14, color: '#666', marginLeft: 12, marginRight: 12, textAlign: 'center', width: 50, fontFamily: 'DINAlternate-Bold' } },
                      item.rate + "%" || "--"
                    ),
                    item.comparedToPrevious === null || item.comparedToPrevious ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex', alignItems: "center", justifyContent: "flex-end", marginLeft: 12, marginRight: 12, width: 50 } },
                      item.comparedToPrevious === "新增" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#666", fontWeight: "500", fontSize: 12 } },
                        '\u65B0\u589E'
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                        item.comparedToPrevious === null || item.comparedToPrevious === "--" || item.comparedToPrevious === "0.00" ? null : item.comparedToPrevious > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(1975) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(1976) }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { fontSize: 14, color: '#666', textAlign: 'center', fontFamily: 'DINAlternate-Bold' } },
                          item.comparedToPrevious === "--" ? item.comparedToPrevious : item.comparedToPrevious !== null ? __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(item.comparedToPrevious) : "--"
                        )
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { style: { display: 'flex', alignItems: "center", justifyContent: "center", marginLeft: 12, marginRight: 12, width: 50 } },
                      item.compareToPrevious === "新增" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { color: "#666", fontWeight: "500", fontSize: 12 } },
                        '\u65B0\u589E'
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                        item.compareToPrevious === null || item.compareToPrevious === "--" || item.compareToPrevious === "0.00" ? null : item.compareToPrevious > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(1975) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', src: __webpack_require__(1976) }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { style: { fontSize: 14, color: '#666', textAlign: 'center', fontFamily: 'DINAlternate-Bold' } },
                          item.compareToPrevious === "--" ? item.compareToPrevious : item.compareToPrevious !== null ? __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(item.compareToPrevious) : "--"
                        )
                      )
                    )
                  );
                })
              ) : null
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: '#F5F6F7' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 20, paddingRight: 20, background: '#fff' } },
              latestPublicFundAnnouncement ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this6.OpenApp();
                  }, style: { display: 'flex', height: 52, justifyContent: 'space-between', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: styles.font16333 },
                  '\u57FA\u91D1\u516C\u544A'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', alignItems: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: '#999' } },
                    latestPublicFundAnnouncement.publishDate === null ? "暂无公告记录" : latestPublicFundAnnouncement.publishDate + "更新"
                  ),
                  latestPublicFundAnnouncement.publishDate === null ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(702), style: { height: 10, width: 10 }, alt: '' })
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, background: '#EFF0F4' } }),
              dataInfo ? dataInfo.fundtype === "货币型" ? null :
              // <div onClick = {latestDividend ? latestDividend  ? ()=>{this.goFundGk("分红记录")}:()=>{}:()=>{}} style={{display:'flex',height:52,justifyContent:'space-between',alignItems:'center'}}>
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this6.OpenApp();
                  }, style: { display: 'flex', height: 52, alignItems: 'center', justifyContent: 'space-between' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: styles.font16333 },
                  '\u5206\u7EA2\u8BB0\u5F55'
                ),
                latestDividend ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 14, color: '#999' } },
                  '\u6BCF\u4EFD\u5206\u7EA2',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { style: { fontFamily: 'DINAlternate-Bold' } },
                    __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(latestDividend.dividendPerShare) || "--",
                    '\uFF08',
                    latestDividend ? this.dateformat(latestDividend.equityRegistrationDate) : "--",
                    '\uFF09'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(702), style: { height: 10, width: 10 }, alt: '' })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', alignItems: "center" } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 14, color: '#999' } },
                    '\u6682\u65E0\u5206\u7EA2\u8BB0\u5F55'
                  )
                )
              ) : null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 1, background: '#EFF0F4' } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this6.OpenApp();
                  }, style: { display: 'flex', height: 52, justifyContent: 'space-between', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: styles.font16333 },
                  '\u4EA7\u54C1\u8D44\u6599\u6982\u8981'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 14, color: '#999' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(702), style: { height: 10, width: 10 }, alt: '' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 10, background: '#F5F6F7' } }),
            dataInfo ? dataInfo.fundtype === "货币型" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              acRelationFundCode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this6.OpenApp();
                  }, style: { fontSize: 14, color: '#F92C3D', background: '#fff', height: 44, display: 'flex', justifyContent: 'center', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { color: '#F92C3D' }, target: '_blank' },
                  '\u67E5\u770B',
                  relationFundName
                )
              ) : null
            ) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  return _this6.OpenApp();
                }, style: { padding: 20, backgroundColor: 'rgb(245, 246, 247)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { borderRadius: 10, marginBottom: 20, background: '#fff', height: 44, paddingLeft: 15, paddingRight: 15, display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { display: 'flex', alignItems: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2163), style: { height: 20, width: 20, marginRight: 10 }, alt: '' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { fontSize: 12, color: '#666' } },
                    '\u5BF9\u4EA7\u54C1\u6709\u7591\u95EE\uFF0C',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { style: { color: '#F92C3D' } },
                      '\u54A8\u8BE2\u5728\u7EBF\u5BA2\u670D'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(702), style: { height: 10, width: 10 }, alt: '' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: '100%', textAlign: 'center', fontSize: 12, color: '#999', marginBottom: 5 } },
                '- \u6C11\u751F\u94F6\u884C\u5168\u7A0B\u4FDD\u8BC1\u8D44\u91D1\u4EA4\u6613\u5B89\u5168 -'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginBottom: 23, fontSize: 12, color: '#999', width: '100%', textAlign: 'center' } },
                '\u6570\u636E\u6765\u6E90\uFF1AWind\u3001\u94F6\u6CB3\u8BC1\u5238\u3001\u57FA\u91D1\u7BA1\u7406\u4EBA'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: '100%', textAlign: 'center', fontSize: 12, color: '#999', lineHeight: '17px' } },
                '\u57FA\u91D1\u7684\u8FC7\u5F80\u4E1A\u7EE9\u4E0D\u9884\u793A\u5176\u672A\u6765\u8868\u73B0\uFF0C\u76F8\u5173\u6570\u636E\u4EC5\u4F9B\u53C2\u8003\uFF0C\u4E0D\u6784\u6210\u6295\u8D44\u5EFA\u8BAE\u3002\u6295\u8D44\u4EBA\u8BF7\u8BE6\u9605\u57FA\u91D1\u5408\u540C\u548C\u57FA\u91D1\u62DB\u52DF\u8BF4\u660E\u4E66\uFF0C\u5E76\u81EA\u884C\u627F\u62C5\u6295\u8D44\u57FA\u91D1\u7684\u98CE\u9669\u3002'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: this.OpenApp, style: { background: '#fff', width: '100%' } },
          dataInfo ? dataInfo.fundtype === "货币型" ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { height: 32, borderBottom: '1px solid #EFF0F4', boxShadow: '0px -1px 0px 1px #EFF0F4', display: 'flex', fontSize: 12, alignItems: 'center', justifyContent: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginRight: 10, color: '#666' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '\u8D2D\u4E70\u8D39\u7387 \xA0'
              ),
              dataSource && dataSource.maxBuyRate && dataSource.maxBuyRate.conditionRate === "0.00%" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '0.00%'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { style: { textDecorationLine: "line-through" } },
                  dataSource ? dataSource.maxBuyRate ? dataSource.maxBuyRate.conditionRate : "" : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  dataSource ? dataSource.discountFeeRate ? dataSource.discountFeeRate + "  起" : "--" : ''
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(702), style: { height: 10, width: 10 }, alt: '' })
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', alignItems: 'center', paddingRight: 20, paddingBottom: 5, paddingTop: 10, paddingLeft: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: 10 } },
              is_optional === '0' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2159), style: { height: 20 }, alt: '' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(2178), style: { height: 20 }, alt: '' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 18, WebkitTransform: 'scale(0.5)' } },
                is_optional === '0' ? '加自选' : '取消自选'
              )
            ),
            this.state.dataSource ? this.state.dataSource.fundCanDT ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', fontSize: 16, flex: 1 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 44, flex: 1, background: '#FEE9EB', color: '#F92C3D', borderTopLeftRadius: 22, borderBottomLeftRadius: 22 } },
                '\u5B9A\u6295'
              ),
              this.state.dataSource ? this.state.dataSource.businessType === "T022" || this.state.dataSource.businessType === "T020" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 44, flex: 1, background: '#F92C3D', color: '#fff', borderTopRightRadius: 22, borderBottomRightRadius: 22 } },
                '\u7533\u8D2D'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 44, flex: 1, background: '#afb0b2', color: '#fff', borderTopRightRadius: 22, borderBottomRightRadius: 22 } },
                '\u7533\u8D2D'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: 44, flex: 1, background: '#afb0b2', color: '#fff', borderTopRightRadius: 22, borderBottomRightRadius: 22 } },
                '\u7533\u8D2D'
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1, height: 44, display: 'flex', alignItems: 'center', borderRadius: 22, marginLeft: 10, fontSize: 16 } },
              this.state.dataSource ? this.state.dataSource.businessType === "T022" || this.state.dataSource.businessType === "T020" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { display: 'flex', flex: 1, height: 44, backgroundColor: '#F92C3D', borderRadius: 22, alignItems: 'center', justifyContent: 'center', color: '#fff' } },
                '\u7533\u8D2D'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 22, height: 44, background: '#afb0b2', color: '#fff' } },
                '\u7533\u8D2D'
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 22, height: 44, background: '#afb0b2', color: '#fff' } },
                '\u7533\u8D2D'
              )
            ) : null
          )
        ),
        !this.state.dataInfo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#fff', position: 'absolute', width: '100%', height: '100%', zIndex: 9999 } }) : null,
        this.state.tipIntroduce ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__tip_FundAnalysisTips__["a" /* default */], { onOK: function onOK() {
            return _this6.setState({ tipIntroduce: false });
          } }) : null,
        this.state.investflag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: styles.container2 },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: styles.modalView },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 25, paddingRight: 25, paddingTop: 24 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { fontSize: 14, lineHeight: '20px', color: "#333333", fontWeight: "500", textAlign: 'center' } })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 25, paddingRight: 25, paddingTop: 12 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 14, lineHeight: '20px', color: "#333333" } },
                '\u5982\u679C\u51FA\u73B0\u5404\u8D44\u4EA7\u603B\u548C\u5360\u51C0\u503C\u6BD4\u4F8B\u8D85\u8FC7100%\u7684\u73B0\u8C61\uFF0C\u4E00\u822C\u662F\u7531\u4E8E\u57FA\u91D1\u5728\u8FD0\u4F5C\u8FC7\u7A0B\u4E2D\u5B58\u5728\u8D1F\u503A\uFF0C\u5982\u5B58\u5728\u5E94\u4ED8\u8D26\u6B3E\u6216\u503A\u5238\u8D28\u62BC\u6760\u6746\u4EA4\u6613\u7B49\u60C5\u51B5\u3002'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { onClick: function onClick() {
                  _this6.setState({ investflag: false });
                }, style: Object.assign({}, styles.footHeight, { width: 273, height: 43, borderTop: '1px solid #EBEBEB', marginTop: 20 }) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 14, color: '#333', lineHeight: '20px', fontWeight: "500" } },
                '\u77E5\u9053\u4E86'
              )
            )
          )
        ) : null,
        this.state.selectOther ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOtherTransRecord, { title: '\u53D6\u6D88',
          listContent: [{ title: '近3年', callback: function callback() {
              _this6.selectTabFun("近3年");
            } }, { title: '近5年', callback: function callback() {
              _this6.selectTabFun("近5年");
            } }, { title: '今年以来', callback: function callback() {
              _this6.selectTabFun("今年以来");
            } }, { title: '成立以来' + "(" + chengli + ")", callback: function callback() {
              _this6.selectTabFun('成立以来');
            } }],
          cancelCallback: function cancelCallback() {
            _this6.setState({ selectOther: false });
          },
          symbolvalue: this.state.selectTab,
          chengli: chengli
        }) : null,
        this.state.Basicfalg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectOtherzhishu, { title: '\u53D6\u6D88',
          listContent: productTypeListContent,
          cancelCallback: function cancelCallback() {
            _this6.setState({ Basicfalg: false });
          },
          symbolcode: this.state.symbolcode
        }) : null,
        this.state.tebflag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { zIndex: 1, width: '100%', height: 45, display: "flex", alignItems: "center", position: "absolute", top: 50, background: 'url(' + __webpack_require__(2177) + ') repeat-x', backgroundSize: 'cover' } },
          this.state.tabtextList.map(function (item, index) {
            var opacity = void 0;
            if (item === _this6.state.tabtext) {
              opacity = 1;
            } else {
              opacity = 0;
            }
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: index + '', onClick: function onClick() {
                  return _this6.handleLocation(index);
                }, style: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: "center", justifyContent: "center" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { color: "#FFFFFF", fontSize: 14, marginBottom: 5 } },
                item
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 28, height: 3, backgroundColor: "#fff", opacity: opacity } })
            );
          })
        ) : null
      );
    }
  }]);

  return NewPublicOffering;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var HistoryList = function (_Component2) {
  _inherits(HistoryList, _Component2);

  function HistoryList(props) {
    _classCallCheck(this, HistoryList);

    var _this7 = _possibleConstructorReturn(this, (HistoryList.__proto__ || Object.getPrototypeOf(HistoryList)).call(this, props));

    _this7.goToDetailedPages = function (data, historyType) {
      // console.log( '是否展示',data.homogeneousAverageFlag);
      __WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* hashHistory */].push({
        pathname: '/HistoryAchievement',
        state: {
          fundCode: data.fundcode, //'003003',//002460货币  002460非货币  data.fundcode
          dispatch: _this7.props.dispatch,
          fundType: data.fundtype, //'货币型',//0 货币  1 非货币 data.fundtype
          fundTypeTitle: data.fundname, //data.fundname
          historyType: historyType,
          homogeneousAverageFlag: _this7.props.dataSource.homogeneousAverageFlag
        }
      });
    };

    _this7.Coloroffluctuationrange = function (val) {
      val = Number(val);
      var valColor = "#999999";
      if (val == 0) {
        valColor = "#999999";
      } else if (val < 0) {
        valColor = "#1DA96B";
      } else if (val > 0) {
        valColor = "#FA063A";
      } else {
        valColor = "#999999";
      }
      return valColor;
    };

    _this7.state = {
      key: '1'
    };
    return _this7;
  }

  _createClass(HistoryList, [{
    key: 'handleClick',
    value: function handleClick(key) {
      this.setState({ key: key });
    }

    //涨跌幅颜色

  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props = this.props,
          historyList = _props.historyList,
          Netperformance = _props.Netperformance,
          dataSource = _props.dataSource,
          dataInfo = _props.dataInfo,
          AccumulatedNet = _props.AccumulatedNet;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Tabs"],
        {
          defaultActiveKey: '1',
          swipeable: false,
          type: 'card',
          animated: true,
          activeKey: this.state.key,
          renderTabBar: function renderTabBar() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', marginBottom: 15 } },
              historyList.map(function (item, index) {
                var fontColorName = index + 1 + '' === _this8.state.key ? "b1" : "b2";
                var lineColor = index + 1 + '' === _this8.state.key ? "activeLine" : "notActiveLine";
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { key: index + 1 + '', onClick: function onClick() {
                      return _this8.handleClick(index + 1 + '');
                    }, style: { display: 'flex', lineHeight: '16px', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginRight: 25 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: Object.assign({}, styles[fontColorName], { marginBottom: 8 }) },
                    item
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: Object.assign({}, styles[lineColor], { height: 3, width: 28, borderRadius: 2 }) })
                );
              })
            );
          }
        },
        Netperformance ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TabPane,
          { tab: '', key: '1' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-around', width: '100%', flex: 1, marginBottom: 20 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { height: 16, flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u65F6\u95F4\u533A\u95F4'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, color: '#666', flex: 1, textAlign: 'center' } },
                '\u4ECA\u5E74\u4EE5\u6765'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, color: '#666', flex: 1, textAlign: 'center' } },
                '\u8FD1\u4E00\u6708'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, color: '#666', flex: 1, textAlign: 'center' } },
                '\u8FD1\u4E00\u5E74'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, color: '#666', flex: 1, textAlign: 'center' } },
                '\u8FD1\u4E09\u5E74'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { height: 16, flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u6DA8\u8DCC\u5E45'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, fontFamily: 'DINAlternate-Bold', flex: 1, textAlign: 'center', color: Netperformance.yearnavchgrate ? this.Coloroffluctuationrange(Netperformance.yearnavchgrate) : "#999999" } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.yearnavchgrate)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, fontFamily: 'DINAlternate-Bold', color: Netperformance.m1 ? this.Coloroffluctuationrange(Netperformance.m1) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.m1)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, fontFamily: 'DINAlternate-Bold', color: Netperformance.y1 ? this.Coloroffluctuationrange(Netperformance.y1) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.y1)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, fontFamily: 'DINAlternate-Bold', color: Netperformance.y3 ? this.Coloroffluctuationrange(Netperformance.y3) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.y3)
              )
            ),
            dataSource ? dataSource.homogeneousAverageFlag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { height: 16, flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u540C\u7C7B\u5E73\u5747'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, fontFamily: 'DINAlternate-Bold', color: Netperformance.sfReturnThisYear ? this.Coloroffluctuationrange(Netperformance.sfReturnThisYear) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.sfReturnThisYear)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, fontFamily: 'DINAlternate-Bold', color: Netperformance.sfReturnRecentMonth ? this.Coloroffluctuationrange(Netperformance.sfReturnRecentMonth) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.sfReturnRecentMonth)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, marginBottom: 20, fontFamily: 'DINAlternate-Bold', color: Netperformance.sfReturnRecentYear ? this.Coloroffluctuationrange(Netperformance.sfReturnRecentYear) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.sfReturnRecentYear)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { height: 16, fontSize: 14, fontFamily: 'DINAlternate-Bold', color: Netperformance.sfReturnRecentThreeYear ? this.Coloroffluctuationrange(Netperformance.sfReturnRecentThreeYear) : "#999999", flex: 1, textAlign: 'center' } },
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(Netperformance.sfReturnRecentThreeYear)
              )
            ) : null : null
          )
        ) : null,
        dataInfo ? dataInfo.fundtype === "货币型" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TabPane,
          { tab: '', key: '2' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '100%', flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { dispaly: 'flex', height: 16, alignItems: "center", marginBottom: 15, display: 'flex' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center' }) },
                '\u65E5\u671F'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center' }) },
                '\u4E03\u65E5\u5E74\u5316'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center' }) },
                '\u4E07\u4EFD\u6536\u76CA'
              )
            ),
            AccumulatedNet ? AccumulatedNet.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index, style: { display: 'flex', height: 16, alignItems: "center", marginBottom: 20 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: "#666666", fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  item.publish_date || "--"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: _this8.Coloroffluctuationrange(item.value_2_2), fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(item.value_2_2) + "%" || "--"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: "#666", fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(item.value_2_1) || "--"
                )
              );
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', height: 16, textAlign: "center", marginBottom: 20 } },
              '\u6682\u65E0\u6570\u636E'
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          TabPane,
          { tab: '', key: '2' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { width: '100%', flex: 1 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', height: 16, alignContent: "center", marginBottom: 15 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u65E5\u671F'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u5355\u4F4D\u51C0\u503C'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u7D2F\u8BA1\u51C0\u503C'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: Object.assign({}, styles.font12999, { flex: 1, textAlign: 'center', marginBottom: 15 }) },
                '\u65E5\u6DA8\u8DCC\u5E45'
              )
            ),
            AccumulatedNet ? AccumulatedNet.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index, style: { display: 'flex', height: 16, alignContent: "center", marginBottom: 20 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: "#666666", fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  item.publish_date || "--"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: "#666666", fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  item.value_134 || "--"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: "#666666", fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  item.value_134_2 || "--"
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { flex: 1, textAlign: 'center', color: _this8.Coloroffluctuationrange(item.value_zdf), fontSize: 14, fontFamily: 'DINAlternate-Bold' } },
                  __WEBPACK_IMPORTED_MODULE_18__util___default.a.keepfomatFloat(item.value_zdf)
                )
              );
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { display: 'flex', height: 16, textAlign: "center", marginBottom: 20 } },
              '\u6682\u65E0\u6570\u636E'
            )
          )
        ) : null
      );
    }
  }]);

  return HistoryList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var EchartsBox = function (_Component3) {
  _inherits(EchartsBox, _Component3);

  function EchartsBox(props) {
    _classCallCheck(this, EchartsBox);

    var _this9 = _possibleConstructorReturn(this, (EchartsBox.__proto__ || Object.getPrototypeOf(EchartsBox)).call(this, props));

    _this9.componentDidMount = function () {
      _this9.props.onRef(_this9);
      if (document.querySelector('#PublicLine')) {
        if (window.isLess47) {
          _this9.myChart = __WEBPACK_IMPORTED_MODULE_9_echarts_lib_echarts___default.a.init(document.querySelector('#PublicLine'));
        } else {
          _this9.myChart = __WEBPACK_IMPORTED_MODULE_9_echarts_lib_echarts___default.a.init(document.querySelector('#PublicLine'), null, { renderer: "svg" });
        }
        _this9.myChart.clear();
        _this9.myChart.resize();
      }
    };

    _this9.showOption = function (val) {
      var _seriesArr$push, _seriesArr$push2, _seriesArr$push3, _seriesArr$push4;

      var _profitNav = val._profitNav,
          _profitData = val._profitData,
          _dotnav = val._dotnav,
          _maxDrawDownValue = val._maxDrawDownValue;

      console.log(_profitNav);
      var buyAndSaleDateArr = [];
      var _tabVal = _this9.props._tabVal;

      var newbuyDateList = _this9.props._thisObj.state.buyDateList ? _this9.props._thisObj.state.buyDateList : [];
      var newredeemDateList = _this9.props._thisObj.state.redeemDateList ? _this9.props._thisObj.state.redeemDateList : [];
      var dividendDateList = _this9.props._thisObj.state.dividDateList ? _this9.props._thisObj.state.dividDateList : [];
      var newbuynameArr = [];
      var redeemnameArr = [];
      var dividendnameArr = [];

      var seriesArr = [];
      var _valueAll = [];
      var _LineAll = [];
      var _maxDrawDownAll = [];
      var newNev = _profitNav.length > 0 && __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(_profitNav[_profitNav.length - 1].value) && _profitNav[_profitNav.length - 1].value !== '--' ? _profitNav[_profitNav.length - 1].value : '--';
      var newData = _profitData.length > 0 && __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(_profitData[_profitData.length - 1]) && _profitData[_profitData.length - 1] !== '--' ? _profitData[_profitData.length - 1] : '--';
      var _value = val._profitNav;
      var _name = val._profitData;
      var sum = val._profitData.length;
      var _name1 = [_name[0], _name[sum - 1]];
      var dotvalue = _dotnav;
      _this9.setState({ showdataArr: val });
      for (var i = 0; i < _profitNav.length; i++) {
        _valueAll.push({
          value: _profitNav[i].allIncome,
          deadLine: _profitNav[i].deadLine
        });
      }
      for (var _i15 = 0; _i15 < _profitNav.length; _i15++) {
        _LineAll.push({
          value: _profitNav[_i15].Lineval,
          deadLine: _profitNav[_i15].deadLine
        });
      }
      for (var _i16 = 0; _i16 < _profitNav.length; _i16++) {
        _maxDrawDownAll.push({
          value: _profitNav[_i16].maxDrawDown,
          deadLine: _profitNav[_i16].deadLine
        });
      }
      //转入打点
      for (var _i17 = 0; _i17 < newbuyDateList.length; _i17++) {
        var indexname = _name.indexOf(newbuyDateList[_i17]);
        if (indexname !== -1) {
          var salenameVal = dotvalue[indexname];
          newbuynameArr.push([indexname, salenameVal]);
        }
      }
      for (var _i18 = 0; _i18 < newbuynameArr.length; _i18++) {
        buyAndSaleDateArr.push({
          coord: newbuynameArr[_i18],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#407BE7',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        });
        if (_i18 == newbuynameArr.length - 1) {
          buyAndSaleDateArr.push({
            coord: newbuynameArr[_i18],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAstJREFUSEvFlttLVFEUh79zzjijc/GKl6BQCimtTIsyzEgtMLMkxKSHJHwoIoqCoP6CHgoKo3ryIUiIIBRTNAoM85JSSCmGhYVU+qCW13Fm1Jlz4owedcYZbQpxP6699vrWb6+1L4KiKHrgNlACRLK2YwSoAK4LiqKUfex1XKl4OcnElLym2FCTSEmuhdTE4Hsq+Pe1B8ORaw3VFKnwO5eiR1Swcu7W4Joq9Q5efiMWn+Ck+CBMIaLfZIZGXfwYdHrMH003YnPINHU6VhXhF5yaaMBiXAQLgCCArEBCnI5f4y5etNs8AKIAFwvD3PZvA7Mrwv2C1VXpyQaSEwzUtlqJCpNISjBQ3WSlNN9C3VsbqmrvERUqcuFkGDcfj/4bWFU1aZfRiQKZKcF0980sgCUJXMuZbtDOzXrO5oVSXjPOl5/+VftVvCFK4niGiZFJmcpGKylb9GyK0VHX5rm93rJKj1lo7nKQu8/Iw6pxv6p9gtVaGoLUqkJshMTgqIvs3SFY7TLve6YXgs06FVxLjn1cpMSpbDP3K8c5XxBKfbuN/iHPBtQW+wTHREicPmzxyHZbvJ7P32c8bA0dNj71zdnUZC8XhVPVaKV/2OlO+EyuhbtPx1B86F6xuTT/rLQQ97bXt03R3GVn1oeIoiwzsy6F581TC5j8DBNBElQvsa2oWJvcGK0jb78RpwxPXk2wZ2swB3eF8K7HwZsPdvfRkkQozjETbBB5VDexTJu65QPDzmW94VOxGuxqcThTdpmGDju9/Yvdqc4d2Wtke4KesmdjpCUaUEvjfaa1DEQRCg+Z6fw6Te+SLve71WrNFF/FmY+oBpT/4z3RwOv2SKzbsxjwR6CmxUpt61wHnzhgoiDTvOrDMO+w+BH42xWan6Io0cDrmhbrDtVWkGnuBnIEQRgOJNbcFRXg0ODzywKGui+dAJkL7vNwAlWqBfgDpUlb6dF6Xa8AAAAASUVORK5CYII='
          });
        }
      }
      //转出打点
      for (var _i19 = 0; _i19 < newredeemDateList.length; _i19++) {
        var _indexname = _name.indexOf(newredeemDateList[_i19]);
        if (_indexname !== -1) {
          var _salenameVal = dotvalue[_indexname];
          redeemnameArr.push([_indexname, _salenameVal]);
        }
      }
      for (var _i20 = 0; _i20 < redeemnameArr.length; _i20++) {
        buyAndSaleDateArr.push({
          coord: redeemnameArr[_i20],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#FF8026',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        });
        if (_i20 == redeemnameArr.length - 1) {
          buyAndSaleDateArr.push({
            coord: redeemnameArr[_i20],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAn5JREFUSEvFll1Ik1EYgJ/PWaSF0VIqCtKMtBgURX8uSdcKoYIK8i4KMaNQlLIuihBvI2qiNxlEUaAsW13sqvInQrFpKSFkUaKgV/4UNW3+zC9OZ+tM2QdbOHzhwHnP+573+d4fOJ+m6/pS4BZwBjATWxkDHgPXNF3XHfS+LsVdAeMjscUuT4ZjlZBprxLgUW5bzTGHBlMS8PLWMQHWqcyIbabzo1d8JjxYi4MVKcr9tAOelindOwK6X+pLEuSaEO0Dip5D7Um5TzTD9G+5QsUQnLAS7OXKdYsNvjQpvfGuAm2ywsbd0OyQ9gsv4N4Juc8tg4EO6GuNEJxhA5MY9oDklkJzldJ9P6GvTeoLCrYchcRV4J+WK84ESWvhxxAsS4LUPVB/SYG3HoF3j6SeXwPOYrnfexY+vYwiY80E67ZBVgGM9kNHHeRdh4Yy2JkPs37ofiaDp2yGfedUNTIPQ+8rpbc/hOGvEZZ6ww7Ivii/drAbpsbBfhVcV2B1GniHYdIrg6Vnw7e3KnBoj8PZxVnY4RITnX5AltdyHHrckJwG67dDV4MC9HtgxgfnXXD/lDF4vt0QHBcP+wtUIFM8WAvB8wR8gSyFtbMOJn8tIDiIFH1Ot0JWIQx2yV5OfIcPThj6qD6syAVtD5R+6DI03lG6mJPakIoYZiwMeTdgTSYMeKCzXvZUiDlV9t4/Be6b8kyA3zvnDk+otis/CrAo9+yMcbBQu5gFMeVGEs4eGK5FeyQW7VmM/kegpRre1MjiHiyGnBLjUs+1qB+BSG8E/XRdF89WEy3Vlr9nOSU9gE3TtMAERhZRi8xtrtc/uDyOGiou/RdYXAzAiTbTYAp/APioK+lF/NQbAAAAAElFTkSuQmCC'
          });
        }
      }
      //分红打点
      for (var _i21 = 0; _i21 < dividendDateList.length; _i21++) {
        var _indexname2 = _name.indexOf(dividendDateList[_i21]);
        if (_indexname2 !== -1) {
          var _salenameVal2 = dotvalue[_indexname2];
          dividendnameArr.push([_indexname2, _salenameVal2]);
        }
      }
      for (var _i22 = 0; _i22 < dividendnameArr.length; _i22++) {
        buyAndSaleDateArr.push({
          coord: dividendnameArr[_i22],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#F8515C',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        });
        if (_i22 == 0) {
          buyAndSaleDateArr.push({
            coord: dividendnameArr[_i22],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAtlJREFUSEvFlllIVFEYx3/n3qsTLU6NTEI9mNpiJggVRWDZ8hYINQWWYNlmgS30UNlDJL7Y8lBJREUlJVFCTSBEtAcFWZpRGEkbqS0P7WTQ4D33xL3jzFRj5kyY5+nes3y/8/+Wc45QSiUCu4AiwEPfto9ADbBZKKX2yrv3NpgHq+Hzl77FDnVjrFmGPmXSPhv8IbB8rafPoSFJQ924ju3/aINVwGd7+f81l7+GHsEiLRWGe1F3GtGmT0N9+oxqfhy1Q71wIfJWPbx5i8hIjxpXrW3wPRDu7xms6xjlZZiHquHVG0jxYqwtwdxeCZYVMT5oIAnbNtG5tQIGDEBfkO+M6TNzkTduOd/ywhX4YOdVsPUI1kuKUe2vsS5cDi/Q5s1FuN3I46fCffqSRVgtTxxFItmDdf2mM5aws5zOLeXdxq97sL3rVUvg3XvkaX+0W1cUgaEjq08iRo7AWFeCPH8JbfYMzB174GtHfGCRlQnD3GjpoxCDB0eBrecvQCnU0+cgLcSE8WhZ47AetWBdvBqeH7vi0NIUL8KO88ZSzP2HobMTvMnoebmYVYciG7Jjv6IIs3IP6DqYZnyKf5GY7MEoXYlZYR9sYGe5NicPeeREcJo7iYTyLajWdnC7sS5dw7rd8O9gY8Nq5M16VNODIHhiDlp6KvJMXRCcNARt6mTUsxeol21OCEItPlcbOvrSxQiXC/PA0UgGFxdiPXqMarjfVRcuxOg0xNjRaNlZSLsC7NIDjM3rMXdVOd+qowM6voXt/LGcjLKNjgp5tg6Rk43hywdXIioQwKzYHY6jmJSDlpWJanmK9bAZMSYDfdb0qISU9Y2ohqa/g50kkTJiQBNge/EnV3ZboL3sDCnut0ui367FmB8CZq0fWXvOcaxeMB+jwNdLJxN5CPR2RWieUsoLXDNr/dlO9hb4moHZQoh3sdgSsUz+Hd71HzPUORPiATu1GVROrEpDvB9IQHHpfaA4tAAAAABJRU5ErkJggg=='
          });
        }
      }
      console.log(_maxDrawDownAll);

      seriesArr.push((_seriesArr$push = {
        name: _tabVal,
        type: 'line',
        smooth: false,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: [5, 5],
        hoverAnimation: false,
        data: _value
      }, _defineProperty(_seriesArr$push, 'symbolSize', 8), _defineProperty(_seriesArr$push, 'markPoint', {
        data: buyAndSaleDateArr,
        silent: true,
        label: {
          normal: {
            show: false
          }
        }
      }), _defineProperty(_seriesArr$push, 'itemStyle', {
        normal: {
          color: "#BF9B79",
          borderColor: '#FFF',
          lineStyle: {
            width: 2,
            color: "#B69271"
          },
          areaStyle: {
            opacity: 0.1,
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: '#B69271'
              }, {
                offset: 1, color: '#FBFCFD'
              }],
              globalCoord: false
            }
          }
        }
      }), _defineProperty(_seriesArr$push, 'connectNulls', true), _seriesArr$push));

      seriesArr.push((_seriesArr$push2 = {
        name: _tabVal,
        type: 'line',
        smooth: false,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: [5, 5],
        hoverAnimation: false,
        data: _valueAll
      }, _defineProperty(_seriesArr$push2, 'symbolSize', 8), _defineProperty(_seriesArr$push2, 'itemStyle', {
        normal: {
          color: "#BDC8D4",
          borderColor: '#FFF'
        }
      }), _defineProperty(_seriesArr$push2, 'connectNulls', true), _seriesArr$push2));
      seriesArr.push((_seriesArr$push3 = {
        name: _tabVal,
        type: 'line',
        smooth: false,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: [5, 5],
        hoverAnimation: false,
        data: _LineAll
      }, _defineProperty(_seriesArr$push3, 'symbolSize', 8), _defineProperty(_seriesArr$push3, 'itemStyle', {
        normal: {
          color: "#8EC7FF",
          borderColor: '#FFF'
        }
      }), _defineProperty(_seriesArr$push3, 'connectNulls', true), _seriesArr$push3));
      seriesArr.push((_seriesArr$push4 = {
        name: _tabVal,
        type: 'line',
        smooth: false,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: [5, 5],
        hoverAnimation: false,
        data: _maxDrawDownAll
      }, _defineProperty(_seriesArr$push4, 'symbolSize', 8), _defineProperty(_seriesArr$push4, 'itemStyle', {
        normal: {
          color: "#01D083",
          borderColor: '#FFF'
        }
      }), _defineProperty(_seriesArr$push4, 'connectNulls', true), _seriesArr$push4));
      if (_this9.myChart) {
        _this9.myChart.clear();
        _this9.myChart.resize();
        _this9.myChart.setOption(_this9.options(seriesArr, _name, _value, _this9.props._thisObj.state.tabVal, _this9));
      }
      _this9.setState({
        _value: _value
      });
      _this9.props._thisObj.setState({
        newNev: newNev,
        newData: newData,
        allIncome: _profitNav.length > 0 && __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(_profitNav[_profitNav.length - 1].allIncome) && _profitNav[_profitNav.length - 1].allIncome !== '--' ? (_profitNav[_profitNav.length - 1].allIncome - 0).toFixed(2) : '--',
        Lineval: _profitNav.length > 0 && __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(_profitNav[_profitNav.length - 1].Lineval) && _profitNav[_profitNav.length - 1].Lineval !== '--' ? (_profitNav[_profitNav.length - 1].Lineval - 0).toFixed(2) : '--',
        lineOption1: _this9.options(seriesArr, _name, _value, _this9.props._thisObj.state.tabVal),
        chenck: false,
        maxDrawDownValue: _maxDrawDownValue
      });
    };

    _this9.showOptionNav = function (datas, val) {
      var _seriesArr$push5;

      var oneMonthNav = datas.oneMonthNav,
          oneMonthDate = datas.oneMonthDate,
          threeMonthNav = datas.threeMonthNav,
          threeMonthDate = datas.threeMonthDate,
          sixMonthNav = datas.sixMonthNav,
          sixMonthDate = datas.sixMonthDate,
          oneYearNav = datas.oneYearNav,
          oneYearDate = datas.oneYearDate,
          thisyearNav = datas.thisyearNav,
          thisyearDate = datas.thisyearDate,
          ThreeYearDate = datas.ThreeYearDate,
          ThreeYearNav = datas.ThreeYearNav,
          fiveYearDate = datas.fiveYearDate,
          fiveYearNav = datas.fiveYearNav,
          totalNav = datas.totalNav,
          totalDate = datas.totalDate;

      var _value = [];
      var _name = [];
      var buynameArr = [];
      var salenameArr = [];
      var dividnameArr = [];

      var buyDateList = _this9.props._thisObj.state.buyDateList ? _this9.props._thisObj.state.buyDateList : [];
      var redeemDateList = _this9.props._thisObj.state.redeemDateList ? _this9.props._thisObj.state.redeemDateList : [];
      var dividDateList = _this9.props._thisObj.state.dividDateList ? _this9.props._thisObj.state.dividDateList : [];

      var buyAndSaleDateArr = [];
      var _tabVal = _this9.props._tabVal;
      var seriesArr = [];

      var newNev = totalNav.length > 0 ? totalNav[totalNav.length - 1] : '--';
      var newData = totalDate.length > 0 ? totalDate[totalDate.length - 1] : '--';
      _this9.props._thisObj.setState({ newNevs: newNev, newDatas: newData });
      if (val == "近1月") {
        _value = oneMonthNav;
        _name = oneMonthDate;
      } else if (val == "近3月") {
        _value = threeMonthNav;
        _name = threeMonthDate;
      } else if (val == "近6月") {
        _value = sixMonthNav;
        _name = sixMonthDate;
      } else if (val == "近1年") {
        _value = oneYearNav;
        _name = oneYearDate;
      } else if (val == "今年以来") {
        _value = thisyearNav;
        _name = thisyearDate;
      } else if (val == "近3年") {
        _value = ThreeYearNav;
        _name = ThreeYearDate;
      } else if (val == "近5年") {
        _value = fiveYearNav;
        _name = fiveYearDate;
      } else if (val == "成立以来") {
        _value = totalNav;
        _name = totalDate;
      }
      _this9.setState({
        _value: _value
      });
      for (var i = 0; i < buyDateList.length; i++) {
        var indexBuyname = _name.indexOf(buyDateList[i]);
        if (indexBuyname !== -1) {
          var buynameVal = _value[indexBuyname];
          buynameArr.push([indexBuyname, buynameVal]);
        }
      }
      for (var _i23 = 0; _i23 < buynameArr.length; _i23++) {
        buyAndSaleDateArr.push({
          coord: buynameArr[_i23],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#407BE7',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        });
        if (_i23 == 0) {
          buyAndSaleDateArr.push({
            coord: buynameArr[_i23],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAstJREFUSEvFlttLVFEUh79zzjijc/GKl6BQCimtTIsyzEgtMLMkxKSHJHwoIoqCoP6CHgoKo3ryIUiIIBRTNAoM85JSSCmGhYVU+qCW13Fm1Jlz4owedcYZbQpxP6699vrWb6+1L4KiKHrgNlACRLK2YwSoAK4LiqKUfex1XKl4OcnElLym2FCTSEmuhdTE4Hsq+Pe1B8ORaw3VFKnwO5eiR1Swcu7W4Joq9Q5efiMWn+Ck+CBMIaLfZIZGXfwYdHrMH003YnPINHU6VhXhF5yaaMBiXAQLgCCArEBCnI5f4y5etNs8AKIAFwvD3PZvA7Mrwv2C1VXpyQaSEwzUtlqJCpNISjBQ3WSlNN9C3VsbqmrvERUqcuFkGDcfj/4bWFU1aZfRiQKZKcF0980sgCUJXMuZbtDOzXrO5oVSXjPOl5/+VftVvCFK4niGiZFJmcpGKylb9GyK0VHX5rm93rJKj1lo7nKQu8/Iw6pxv6p9gtVaGoLUqkJshMTgqIvs3SFY7TLve6YXgs06FVxLjn1cpMSpbDP3K8c5XxBKfbuN/iHPBtQW+wTHREicPmzxyHZbvJ7P32c8bA0dNj71zdnUZC8XhVPVaKV/2OlO+EyuhbtPx1B86F6xuTT/rLQQ97bXt03R3GVn1oeIoiwzsy6F581TC5j8DBNBElQvsa2oWJvcGK0jb78RpwxPXk2wZ2swB3eF8K7HwZsPdvfRkkQozjETbBB5VDexTJu65QPDzmW94VOxGuxqcThTdpmGDju9/Yvdqc4d2Wtke4KesmdjpCUaUEvjfaa1DEQRCg+Z6fw6Te+SLve71WrNFF/FmY+oBpT/4z3RwOv2SKzbsxjwR6CmxUpt61wHnzhgoiDTvOrDMO+w+BH42xWan6Io0cDrmhbrDtVWkGnuBnIEQRgOJNbcFRXg0ODzywKGui+dAJkL7vNwAlWqBfgDpUlb6dF6Xa8AAAAASUVORK5CYII='
          });
        }
      }
      for (var _i24 = 0; _i24 < redeemDateList.length; _i24++) {
        var indexname = _name.indexOf(redeemDateList[_i24]);
        if (indexname !== -1) {
          var salenameVal = _value[indexname];
          salenameArr.push([indexname, salenameVal]);
        }
      }
      for (var _i25 = 0; _i25 < salenameArr.length; _i25++) {
        buyAndSaleDateArr.push({
          coord: salenameArr[_i25],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#FF8026',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        });
        if (_i25 == 0) {
          buyAndSaleDateArr.push({
            coord: salenameArr[_i25],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAn5JREFUSEvFll1Ik1EYgJ/PWaSF0VIqCtKMtBgURX8uSdcKoYIK8i4KMaNQlLIuihBvI2qiNxlEUaAsW13sqvInQrFpKSFkUaKgV/4UNW3+zC9OZ+tM2QdbOHzhwHnP+573+d4fOJ+m6/pS4BZwBjATWxkDHgPXNF3XHfS+LsVdAeMjscUuT4ZjlZBprxLgUW5bzTGHBlMS8PLWMQHWqcyIbabzo1d8JjxYi4MVKcr9tAOelindOwK6X+pLEuSaEO0Dip5D7Um5TzTD9G+5QsUQnLAS7OXKdYsNvjQpvfGuAm2ywsbd0OyQ9gsv4N4Juc8tg4EO6GuNEJxhA5MY9oDklkJzldJ9P6GvTeoLCrYchcRV4J+WK84ESWvhxxAsS4LUPVB/SYG3HoF3j6SeXwPOYrnfexY+vYwiY80E67ZBVgGM9kNHHeRdh4Yy2JkPs37ofiaDp2yGfedUNTIPQ+8rpbc/hOGvEZZ6ww7Ivii/drAbpsbBfhVcV2B1GniHYdIrg6Vnw7e3KnBoj8PZxVnY4RITnX5AltdyHHrckJwG67dDV4MC9HtgxgfnXXD/lDF4vt0QHBcP+wtUIFM8WAvB8wR8gSyFtbMOJn8tIDiIFH1Ot0JWIQx2yV5OfIcPThj6qD6syAVtD5R+6DI03lG6mJPakIoYZiwMeTdgTSYMeKCzXvZUiDlV9t4/Be6b8kyA3zvnDk+otis/CrAo9+yMcbBQu5gFMeVGEs4eGK5FeyQW7VmM/kegpRre1MjiHiyGnBLjUs+1qB+BSG8E/XRdF89WEy3Vlr9nOSU9gE3TtMAERhZRi8xtrtc/uDyOGiou/RdYXAzAiTbTYAp/APioK+lF/NQbAAAAAElFTkSuQmCC'
          });
        }
      }
      //分红打点
      for (var _i26 = 0; _i26 < dividDateList.length; _i26++) {
        var _indexname3 = _name.indexOf(dividDateList[_i26]);
        if (_indexname3 !== -1) {
          var _salenameVal3 = _value[_indexname3];
          dividnameArr.push([_indexname3, _salenameVal3]);
        }
      }
      for (var _i27 = 0; _i27 < dividnameArr.length; _i27++) {
        buyAndSaleDateArr.push({
          coord: dividnameArr[_i27],
          symbolSize: 6,
          symbol: 'circle',
          itemStyle: {
            normal: {
              color: '#F8515C',
              borderWidth: 1,
              borderColor: '#FFFFFF'
            }
          }
        });
        if (_i27 == 0) {
          buyAndSaleDateArr.push({
            coord: dividnameArr[_i27],
            symbolSize: 25,
            symbolOffset: [0, -15],
            symbolKeepAspect: true,
            symbol: 'image://data:data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAVCAYAAABR915hAAAAAXNSR0IArs4c6QAAAtlJREFUSEvFlllIVFEYx3/n3qsTLU6NTEI9mNpiJggVRWDZ8hYINQWWYNlmgS30UNlDJL7Y8lBJREUlJVFCTSBEtAcFWZpRGEkbqS0P7WTQ4D33xL3jzFRj5kyY5+nes3y/8/+Wc45QSiUCu4AiwEPfto9ADbBZKKX2yrv3NpgHq+Hzl77FDnVjrFmGPmXSPhv8IbB8rafPoSFJQ924ju3/aINVwGd7+f81l7+GHsEiLRWGe1F3GtGmT0N9+oxqfhy1Q71wIfJWPbx5i8hIjxpXrW3wPRDu7xms6xjlZZiHquHVG0jxYqwtwdxeCZYVMT5oIAnbNtG5tQIGDEBfkO+M6TNzkTduOd/ywhX4YOdVsPUI1kuKUe2vsS5cDi/Q5s1FuN3I46fCffqSRVgtTxxFItmDdf2mM5aws5zOLeXdxq97sL3rVUvg3XvkaX+0W1cUgaEjq08iRo7AWFeCPH8JbfYMzB174GtHfGCRlQnD3GjpoxCDB0eBrecvQCnU0+cgLcSE8WhZ47AetWBdvBqeH7vi0NIUL8KO88ZSzP2HobMTvMnoebmYVYciG7Jjv6IIs3IP6DqYZnyKf5GY7MEoXYlZYR9sYGe5NicPeeREcJo7iYTyLajWdnC7sS5dw7rd8O9gY8Nq5M16VNODIHhiDlp6KvJMXRCcNARt6mTUsxeol21OCEItPlcbOvrSxQiXC/PA0UgGFxdiPXqMarjfVRcuxOg0xNjRaNlZSLsC7NIDjM3rMXdVOd+qowM6voXt/LGcjLKNjgp5tg6Rk43hywdXIioQwKzYHY6jmJSDlpWJanmK9bAZMSYDfdb0qISU9Y2ohqa/g50kkTJiQBNge/EnV3ZboL3sDCnut0ui367FmB8CZq0fWXvOcaxeMB+jwNdLJxN5CPR2RWieUsoLXDNr/dlO9hb4moHZQoh3sdgSsUz+Hd71HzPUORPiATu1GVROrEpDvB9IQHHpfaA4tAAAAABJRU5ErkJggg=='
          });
        }
      }
      seriesArr.push((_seriesArr$push5 = {
        name: _tabVal,
        type: 'line',
        smooth: false,
        symbol: 'circle',
        showSymbol: false,
        symbolSize: [5, 5],
        hoverAnimation: false,
        data: _value
      }, _defineProperty(_seriesArr$push5, 'symbolSize', 8), _defineProperty(_seriesArr$push5, 'markPoint', {
        data: buyAndSaleDateArr,
        silent: true,
        label: {
          normal: {
            show: false
          }
        }
      }), _defineProperty(_seriesArr$push5, 'itemStyle', {
        normal: {
          color: "#BF9B79",
          borderColor: '#FFF',
          lineStyle: {
            width: 2,
            color: "#B69271"
          },
          areaStyle: {
            opacity: 0.1,
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: '#B69271'
              }, {
                offset: 1, color: '#FBFCFD'
              }],
              globalCoord: false
            }
          }
        }
      }), _seriesArr$push5));
      if (_this9.myChart) {
        _this9.myChart.clear();
        _this9.myChart.resize();
        _this9.myChart.setOption(_this9.options(seriesArr, _name, _value, _this9.props._thisObj.state.tabVal, _this9));
      }
      _this9.props._thisObj.setState({
        lineOption: _this9.options(seriesArr, _name, _value, _this9.props._thisObj.state.tabVal),
        chencked: false
      });
    };

    _this9.options = function (seriesArr, _name, _value, _tabVal, _this) {
      if (_tabVal == "业绩走势" || _tabVal == "七日年化") {
        var optionA = {
          calculable: true,
          series: seriesArr,
          grid: {
            y: '10%',
            left: 70,
            bottom: 50,
            top: 60 //75
          },
          tooltip: {
            show: true,
            position: [15, 0],
            trigger: 'axis',
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#F92C3D',
                width: 1,
                type: 'dashed'
              },
              label: {
                margin: 20,
                show: true,
                backgroundColor: '#F92C3D'
              }
            },
            backgroundColor: "rgba(246, 247, 250, 1)",
            extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0.3)',
            textStyle: { fontSize: 12 },
            formatter: function formatter(params) {
              if (_this.props._tabVal == '业绩走势') {
                _this.setState({
                  newNev: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].data.value) === false ? _this.state.newNev : params[0].data.value, //本基金
                  newData: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].deadLine) === false ? _this.state.newData : params[0].deadLine, //日期
                  allIncome: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].data.allIncome) === false ? _this.state.allIncome : params[0].data.allIncome, //业绩基准
                  Lineval: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].data.Lineval) === false ? _this.state.Lineval : params[0].data.Lineval //指数
                });
                _this.props._thisObj.setState({
                  chenck: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].data.value) === false ? false : true,
                  chencked: false
                });
              } else {
                _this.setState({
                  newNevs: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].value) === false ? _this.state.newNev : params[0].value, //净值
                  newDatas: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].name) === false ? _this.state.newData : params[0].name //日期
                });
                _this.props._thisObj.setState({
                  chenck: false,
                  chencked: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].data) === false ? false : true
                });
              }
            }
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            color: "#878787",
            fontSize: 9,
            fontWeight: 600,
            data: _name,
            axisTick: {
              lineStyle: {
                width: 0
              }
            },
            axisLabel: {
              color: "#878787",
              showMinLabel: true,
              showMaxLabel: true,
              interval: Math.ceil(_name.length / 2) - 1,
              align: "center",
              margin: 20,
              formatter: function formatter(value, index) {
                if (index === 0) {
                  return '        ' + value;
                }
                if (index === _name.length - 1) {
                  return value + '         ';
                }
                return value;
              }
            },
            axisLine: {
              show: true,
              onZero: false,
              lineStyle: {
                width: 1,
                color: "rgb(160,167,176,0.7)"
              }
            }
          }],
          yAxis: [{
            type: 'value',
            scale: true,
            splitNumber: 3,
            axisLine: {
              lineStyle: {
                width: 0,
                color: "#878787"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 0.5,
                color: "#DFDFDF",
                type: "dashed"
              }
            },
            axisTick: {
              lineStyle: {
                width: 0,
                color: "#9BC4D8"
              }
            },
            axisLabel: {
              formatter: function formatter(value, index) {
                return value.toFixed(2) + "%";
              },
              textStyle: {
                fontSize: 12
              }
            }
          }]
        };
        return optionA;
      } else {
        var _optionA = {
          calculable: true,
          series: seriesArr,
          grid: {
            y: '10%',
            left: 70,
            bottom: 50,
            top: 60 //75
          },
          tooltip: {
            show: true,
            position: [15, 0],
            trigger: 'axis',
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#F92C3D',
                width: 1,
                type: 'dashed'
              },
              label: {
                margin: 20,
                show: true,
                backgroundColor: '#F92C3D'
              }
            },
            backgroundColor: "rgba(246, 247, 250, 1)",
            extraCssText: 'box-shadow: 0 0 0 rgba(0, 0, 0, 0.3)',
            textStyle: { fontSize: 12 },
            formatter: function formatter(params) {
              _this.setState({
                newNevs: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].value) === false ? _this.state.newNev : params[0].value, //净值
                newDatas: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].name) === false ? _this.state.newData : params[0].name //日期

              });
              _this.props._thisObj.setState({
                chenck: false,
                chencked: __WEBPACK_IMPORTED_MODULE_18__util___default.a.returnEmptyAlone(params[0].data) === false ? false : true
              });
            }
          },
          xAxis: [{
            silent: false,
            type: 'category',
            boundaryGap: false,
            color: "#878787",
            fontSize: 9,
            fontWeight: 600,
            data: _name,
            axisTick: {
              lineStyle: {
                width: 0
              }
            },
            axisLabel: {
              color: "#878787",
              showMinLabel: true,
              showMaxLabel: true,
              interval: Math.ceil(_name.length / 2) - 1,
              align: "center",
              margin: 20,
              formatter: function formatter(value, index) {
                if (index === 0) {
                  return '        ' + value;
                }
                if (index === _name.length - 1) {
                  return value + '         ';
                }
                return value;
              }
            },
            axisLine: {
              lineStyle: {
                width: 0.5,
                color: "rgb(160,167,176)"
              }
            }
          }],
          yAxis: [{
            type: 'value',
            scale: true,
            splitNumber: 3,
            axisLine: {
              lineStyle: {
                width: 0,
                color: "#878787"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 0.5,
                color: "#DFDFDF",
                type: "dashed"
              }
            },
            axisTick: {
              lineStyle: {
                width: 0,
                color: "#9BC4D8"
              }
            },
            axisLabel: {
              formatter: function formatter(value, index) {
                return value.toFixed(4);
              },
              textStyle: {
                fontSize: 12
              }
            }
          }]
        };
        return _optionA;
      }
    };

    _this9.yingkui = function () {
      if (_this9.props._thisObj.state.tabVal == '业绩走势' && _this9.props._thisObj.state.chenck !== true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { zIndex: 1, height: 25, position: "absolute", top: 0, width: '100%', padding: 10, paddingLeft: 5, paddingRight: 5 } },
          _this9.props._thisObj.state.publicFundPerformanceflag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: 7, display: 'flex', width: '100%', alignItems: 'center', paddingLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: 160, display: 'flex', justifyContent: "flex-start", alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#BF9B79", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u672C\u57FA\u91D1 :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: _this9.props.newNev < 0 ? '#139F6B' : _this9.props.newNev > 0 ? '#F92C3D' : '#666666' } },
                  _this9.props.newNev != "--" ? _this9.props.newNev > 0.00 ? '+' + __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.newNev) : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.newNev) : '--'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this9.props.Basicback();
                  }, style: { width: 125, display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#8EC7FF", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  _this9.props.Basictext,
                  ' :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, width: 50, color: _this9.props.Lineval < 0 ? '#139F6B' : _this9.props.Lineval > 0 ? '#F92C3D' : '#666666' } },
                  _this9.props.Lineval != "--" ? _this9.props.Lineval > 0.00 ? '+' + __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.Lineval) : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.Lineval) : '--'
                ),
                _this9.props.Basicfalg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(776) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(774) })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 20, flex: 1, display: 'flex', alignItems: 'center', justifyContent: "flex-start" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#01D083", borderRadius: 3 } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                '\u6700\u5927\u56DE\u64A4 : \xA0'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 10, color: '#3C3C3C', fontWeight: "500" } },
                '-',
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props._thisObj.state.maxDrawDownValue)
              )
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: 7, display: 'flex', width: '100%', justifyContent: "space-around", alignItems: 'center', paddingLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', justifyContent: "flex-start", alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#BF9B79", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u672C\u57FA\u91D1 :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: _this9.props.newNev < 0 ? '#139F6B' : _this9.props.newNev > 0 ? '#F92C3D' : '#666666' } },
                  _this9.props.newNev != "--" ? _this9.props.newNev > 0.00 ? '+' + __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.newNev) : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.newNev) : '--'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: "flex-start" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#BDC8D4", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u4E1A\u7EE9\u57FA\u51C6 : \xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: _this9.props.allIncome < 0 ? '#139F6B' : _this9.props.allIncome > 0 ? '#F92C3D' : '#666666' } },
                  _this9.props.allIncome != "--" ? _this9.props.allIncome > 0.00 ? '+' + __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.allIncome) : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.allIncome) : '--'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 20, display: 'flex', width: '100%', justifyContent: "space-around", alignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this9.props.Basicback();
                  }, style: { flex: 1, display: 'flex', justifyContent: "flex-start", alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#8EC7FF", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  _this9.props.Basictext,
                  ' :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, width: 50, color: _this9.props.Lineval < 0 ? '#139F6B' : _this9.props.Lineval > 0 ? '#F92C3D' : '#666666' } },
                  _this9.props.Lineval != "--" ? _this9.props.Lineval > 0.00 ? '+' + __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.Lineval) : __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props.Lineval) : '--'
                ),
                _this9.props.Basicfalg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(776) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(774) })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: "flex-start" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#01D083", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u6700\u5927\u56DE\u64A4 : \xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', fontWeight: "500" } },
                  '-',
                  __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props._thisObj.state.maxDrawDownValue)
                )
              )
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { zIndex: 1, height: 25, position: "absolute", top: 0, width: '100%', padding: 10, paddingLeft: 5, paddingRight: 5 } },
          _this9.props._thisObj.state.publicFundPerformanceflag ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: 7, display: 'flex', width: '100%', alignItems: 'center', paddingLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { width: 160, display: 'flex', justifyContent: "flex-start", alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#BF9B79", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u672C\u57FA\u91D1 :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: _this9.state.newNev < 0 ? '#139F6B' : _this9.state.newNev > 0 ? '#F92C3D' : '#666666' } },
                  _this9.state.newNev != '--' ? _this9.state.newNev > 0.00 ? '+' + _this9.state.newNev + "%" : _this9.state.newNev + "%" : '--'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this9.props.Basicback();
                  }, style: { width: 125, display: 'flex', alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#8EC7FF", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  _this9.props.Basictext,
                  ' :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, width: 50, color: _this9.state.Lineval < 0 ? '#139F6B' : _this9.state.Lineval > 0 ? '#F92C3D' : '#666666' } },
                  _this9.state.Lineval != '--' ? _this9.state.Lineval > 0.00 ? '+' + _this9.state.Lineval + "%" : _this9.state.Lineval + "%" : '--'
                ),
                _this9.props.Basicfalg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(776) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(774) })
              )
            ),
            _this9.props._thisObj.state.Notenoughforoneyear !== -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 20, flex: 1, display: 'flex', alignItems: 'center', justifyContent: "flex-start" } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#01D083", borderRadius: 3 } }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                '\u6700\u5927\u56DE\u64A4 : \xA0'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { fontSize: 10, color: '#3C3C3C', fontWeight: "500" } },
                '-',
                __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props._thisObj.state.maxDrawDownValue)
              )
            ) : null
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: 7, display: 'flex', width: '100%', justifyContent: "space-around", alignItems: 'center', paddingLeft: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', justifyContent: "flex-start", alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#BF9B79", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u672C\u57FA\u91D1 :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: _this9.state.newNev < 0 ? '#139F6B' : _this9.state.newNev > 0 ? '#F92C3D' : '#666666' } },
                  _this9.state.newNev != '--' ? _this9.state.newNev > 0.00 ? '+' + _this9.state.newNev + "%" : _this9.state.newNev + "%" : '--'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: "flex-start" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#BDC8D4", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u4E1A\u7EE9\u57FA\u51C6 : \xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: _this9.state.allIncome < 0 ? '#139F6B' : _this9.state.allIncome > 0 ? '#F92C3D' : '#666666' } },
                  _this9.state.allIncome != '--' ? _this9.state.allIncome > 0.00 ? '+' + _this9.state.allIncome + "%" : _this9.state.allIncome + "%" : '--'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { paddingLeft: 20, display: 'flex', width: '100%', justifyContent: "space-around", alignItems: 'center' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { onClick: function onClick() {
                    return _this9.props.Basicback();
                  }, style: { flex: 1, display: 'flex', justifyContent: "flex-start", alignItems: 'center' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#8EC7FF", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  _this9.props.Basictext,
                  ' :\xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, width: 50, color: _this9.state.Lineval < 0 ? '#139F6B' : _this9.state.Lineval > 0 ? '#F92C3D' : '#666666' } },
                  _this9.state.Lineval != '--' ? _this9.state.Lineval > 0.00 ? '+' + _this9.state.Lineval + "%" : _this9.state.Lineval + "%" : '--'
                ),
                _this9.props.Basicfalg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(776) }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 12, height: 12 }, src: __webpack_require__(774) })
              ),
              _this9.props._thisObj.state.Notenoughforoneyear !== -1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { paddingLeft: 20, flex: 1, display: 'flex', alignItems: 'center', justifyContent: "flex-start" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 6, height: 6, backgroundColor: "#01D083", borderRadius: 3 } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', marginLeft: 1 } },
                  '\u6700\u5927\u56DE\u64A4 : \xA0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { style: { fontSize: 10, color: '#3C3C3C', fontWeight: "500" } },
                  '-',
                  __WEBPACK_IMPORTED_MODULE_18__util___default.a.fomatFloatpercentage(_this9.props._thisObj.state.maxDrawDownValue)
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
            )
          )
        );
      }
    };

    _this9.othertips = function () {
      if (_this9.props._thisObj.state.tabVal !== '业绩走势' && _this9.props._thisObj.state.chencked !== true) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { zIndex: 1, paddingLeft: 22, paddingRight: 22, paddingTop: 10, paddingBottom: 10, display: 'flex', justifyContent: 'space-between', height: 25, position: "absolute", top: 5, left: 0, width: '100%', alignItems: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', width: 160, justifyContent: 'flex-start', alignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#3C3C3C' } },
              ' \u65E5\u671F : ',
              _this9.props.newDatas != '--' ? _this9.props.newDatas : '--'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', width: 125, justifyContent: 'flex-start', alignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#3C3C3C', marginLeft: 3 } },
              _this9.props._tabVal == '业绩走势' ? '本基金' : _this9.props._tabVal + ' : '
            ),
            _this9.props._tabVal == '七日年化' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: _this9.props.newNevs < 0 ? '#139F6B' : _this9.props.newNevs > 0 ? '#F92C3D' : '#666666' } },
              _this9.props.newNevs > 0 ? _this9.props.newNevs + "%" : _this9.props.newNevs
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#666666' } },
              __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(_this9.props.newNevs) || '--'
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { zIndex: 1, paddingLeft: 22, paddingRight: 22, paddingTop: 10, paddingBottom: 10, display: 'flex', justifyContent: 'space-between', height: 25, position: "absolute", top: 5, left: 0, width: '100%', alignItems: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', width: 160, justifyContent: 'flex-start', alignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#3C3C3C' } },
              ' \u65E5\u671F : ',
              _this9.state.newDatas != '--' ? _this9.state.newDatas : '--'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', width: 125, justifyContent: 'flex-start', alignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#3C3C3C', marginLeft: 3 } },
              _this9.props._tabVal == '业绩走势' ? '本基金' : _this9.props._tabVal + ' : '
            ),
            _this9.props._tabVal == '七日年化' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: _this9.state.newNevs < 0 ? '#139F6B' : _this9.state.newNevs > 0 ? '#F92C3D' : '#666666' } },
              _this9.state.newNevs != '--' ? _this9.state.newNevs + '%' : '--'
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#666666' } },
              __WEBPACK_IMPORTED_MODULE_18__util___default.a.Retainfourdecimalplaces(_this9.state.newNevs) || '--'
            )
          )
        );
      }
    };

    _this9.state = {
      lodingflag: false,
      newNev: null,
      newData: null,
      newNevs: null,
      newDatas: null,
      checkykDate: null,
      checkykVal: null,
      newNav: null,
      incomeList: null,
      allIncome: null,
      Lineval: null,
      chenck: false,
      chencked: false,
      showdataArr: null,
      _value: []
    };
    _this9.myChart = null;
    return _this9;
  }
  //业绩走势

  //单位净值 累计净值

  //业绩走势亏展示

  //单位和累计净值展示


  _createClass(EchartsBox, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { display: 'flex', justifyContent: "center", alignItems: "center", flex: 1, position: 'relative' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { display: 'flex', justifyContent: "center", alignItems: "center", flex: 1 } },
          this.props._tabVal == '业绩走势' ? this.props._thisObj.state.lineOption1 ? this.yingkui() : null : this.props._thisObj.state.lineOption ? this.othertips() : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'PublicLine', style: { width: '100%', height: 300, overflow: "hidden" } }),
          this.state._value.length > 0 ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '100%', height: 220, background: '#fff', position: 'absolute', top: 55 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: '', style: { marginBottom: 10 }, src: __webpack_require__(2184) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { fontSize: 12, color: '#666' } },
              '\u6682\u65E0\u6570\u636E'
            )
          )
        )
      );
    }
  }]);

  return EchartsBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SelectOtherTransRecord = function (_Component4) {
  _inherits(SelectOtherTransRecord, _Component4);

  function SelectOtherTransRecord(props) {
    _classCallCheck(this, SelectOtherTransRecord);

    var _this10 = _possibleConstructorReturn(this, (SelectOtherTransRecord.__proto__ || Object.getPrototypeOf(SelectOtherTransRecord)).call(this, props));

    _this10.state = {};
    return _this10;
  }

  _createClass(SelectOtherTransRecord, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Keyboard.dismiss();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var chenli = this.props.chengli;
      var currentvalue = this.props.symbolvalue === "成立以来" ? this.props.symbolvalue + "(" + chenli + ")" : this.props.symbolvalue;
      var listContent = this.props.listContent;
      var title = this.props.title;
      var listArray = [];

      var _loop = function _loop(i) {
        listArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: i + '', onClick: function onClick() {
              return listContent[i].callback();
            }, style: { borderBottom: '1px solid #EFF0F4', paddingTop: 20, paddingBottom: 20, marginLeft: 20, marginRight: 20, display: 'flex', alignItems: "center", justifyContent: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: 14, lineHeight: '20px', color: currentvalue === listContent[i].title ? "#F92C3D" : '#333', fontWeight: '500' } },
            listContent[i].title
          )
        ));
      };

      for (var i = 0; i < listContent.length; i++) {
        _loop(i);
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container1 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { flex: 1 }, onClick: this.props.cancelCallback },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1 } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: Object.assign({}, styles.actionContainer, { height: 300, backgroundColor: '#fff', bottom: 0 }) },
          listArray,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, height: 10, backgroundColor: "#F5F6F7" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: this.props.cancelCallback, style: { height: 50, display: 'flex', paddingLeft: 20, paddingRight: 20, paddingTop: 15 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: '#666', fontSize: 14, lineHeight: '20px', flex: 1, textAlign: 'center' } },
              title
            )
          )
        )
      );
    }
  }]);

  return SelectOtherTransRecord;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var SelectOtherzhishu = function (_Component5) {
  _inherits(SelectOtherzhishu, _Component5);

  function SelectOtherzhishu(props) {
    _classCallCheck(this, SelectOtherzhishu);

    var _this11 = _possibleConstructorReturn(this, (SelectOtherzhishu.__proto__ || Object.getPrototypeOf(SelectOtherzhishu)).call(this, props));

    _this11.state = {};
    return _this11;
  }

  _createClass(SelectOtherzhishu, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Keyboard.dismiss();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var currentcode = this.props.symbolcode;
      var listContent = this.props.listContent;
      var title = this.props.title;
      var listArray = [];

      var _loop2 = function _loop2(i) {
        listArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: i + '', onClick: function onClick() {
              return listContent[i].callback();
            }, style: { borderBottom: '1px solid #EFF0F4', paddingTop: 20, paddingBottom: 20, marginLeft: 20, marginRight: 20, display: 'flex', alignItems: "center", justifyContent: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { fontSize: 14, lineHeight: '20px', color: currentcode === listContent[i].code ? "#F92C3D" : '#333', fontWeight: '500' } },
            listContent[i].title
          )
        ));
      };

      for (var i = 0; i < listContent.length; i++) {
        _loop2(i);
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: styles.container1 },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { flex: 1 }, onClick: this.props.cancelCallback },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1 } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: Object.assign({}, styles.actionContainer, { backgroundColor: "#ffff", height: 490 }) },
          listArray,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { flex: 1, height: 10, backgroundColor: "#F5F6F7" } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { onClick: this.props.cancelCallback, style: { height: 50, display: 'flex', paddingLeft: 20, paddingRight: 20, alignItems: 'center' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { color: '#666', fontSize: 14, lineHeight: '20px', flex: 1, textAlign: 'center' } },
              title
            )
          )
        )
      );
    }
  }]);

  return SelectOtherzhishu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var styles = {
  actionContainer: {
    position: 'absolute',
    bottom: 0,
    width: '100%'
  },
  container1: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 99998
  },
  box: {
    paddingTop: 15,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 15,
    background: '#fff'
  },
  b1: {
    fontSize: 16,
    fontWeight: 500,
    color: '#333'
  },
  b2: {
    fontSize: 14,
    color: '#333'
  },
  activeLine: {
    background: '#F92C3D'
  },
  notActiveLine: {
    background: '#fff'
  },
  font12999: {
    fontSize: 12,
    color: '#999'
  },
  font14119: {
    fontSize: 14,
    color: '#985119'
  },
  font12119: {
    fontSize: 12,
    color: '#985119'
  },
  font12666: {
    fontSize: 12,
    color: '#666'
  },
  font14666: {
    fontSize: 14,
    color: '#666'
  },
  font16333: {
    fontSize: 16,
    color: '#333',
    fontWeight: 500
  },
  redRound: {
    height: 16,
    width: 16,
    borderRadius: 16,
    backgroundColor: '#F92C3D',
    border: '4px solid #FFE5E7'
  },
  footHeight: {
    alignSelf: 'stretch',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    width: 273,
    justifyContent: 'center',
    borderColor: '#ebeef0',
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15
  },
  modalView: {
    backgroundColor: '#ffffff',
    borderRadius: 15,
    width: 273
  },
  container2: {
    position: 'absolute',
    width: '100%',
    top: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 999,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  }
};
function mapStateToProps(state, ownProps) {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(NewPublicOffering));

/***/ }),
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FundAnalysisTips = function (_Component) {
	_inherits(FundAnalysisTips, _Component);

	function FundAnalysisTips() {
		_classCallCheck(this, FundAnalysisTips);

		return _possibleConstructorReturn(this, (FundAnalysisTips.__proto__ || Object.getPrototypeOf(FundAnalysisTips)).apply(this, arguments));
	}

	_createClass(FundAnalysisTips, [{
		key: 'handleOk',
		value: function handleOk() {
			this.props.onOK();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ style: styles.container },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ style: styles.modalView },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 25, paddingRight: 25, paddingTop: 25 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: 14, lineHeight: '20px', color: "#333333" } },
							'\u6CE2\u52A8\u7387\uFF1A\u8861\u91CF\u57FA\u91D1\u7684\u6536\u76CA\u7387\u53D8\u5316\u7A0B\u5EA6\u7684\u6307\u6807\uFF0C\u6570\u503C\u8D8A\u5C0F\u8868\u793A\u8BE5\u57FA\u91D1\u7684\u6297\u98CE\u9669\u6CE2\u52A8\u80FD\u529B\u8D8A\u5F3A\uFF0C\u53CD\u4E4B\u5219\u8D8A\u5F31\u3002'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: 14, lineHeight: '20px', color: "#333333" } },
							'\u590F\u666E\u6BD4\u7387\uFF1A\u8BA1\u7B97\u57FA\u91D1\u6BCF\u627F\u53D7\u4E00\u5355\u4F4D\u98CE\u9669\uFF0C\u53EF\u83B7\u5F97\u7684\u8D85\u989D\u6536\u76CA\uFF0C\u6570\u503C\u4E3A\u6B63\u65F6\u8D8A\u5927\u8D8A\u597D\uFF0C\u8868\u793A\u57FA\u91D1\u7684\u6027\u4EF7\u6BD4\u8D8A\u9AD8\u3002'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: 14, lineHeight: '20px', color: "#333333" } },
							'\u6700\u5927\u56DE\u64A4\uFF1A\u8868\u793A\u5728\u4E00\u5B9A\u533A\u95F4\u5185\uFF0C\u57FA\u91D1\u51C0\u503C\u4ECE\u6700\u9AD8\u70B9\u5230\u6700\u4F4E\u70B9\u7684\u4E0B\u964D\u5E45\u5EA6\uFF0C\u4F53\u73B0\u8BE5\u57FA\u91D1\u5728\u6B64\u533A\u95F4\u5185\u7684\u6700\u5927\u4E8F\u635F\u3002\u6570\u503C\u8D8A\u5927\u8868\u793A\u8BE5\u57FA\u91D1\u7684\u98CE\u9669\u63A7\u5236\u80FD\u529B\u8D8A\u5F3A'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ onClick: function onClick() {
								_this2.handleOk();
							}, style: Object.assign({}, styles.footHeight, { width: 273, height: 43, borderTop: '1px solid #EBEBEB', marginTop: 20 }) },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: 14, color: '#333', lineHeight: '20px', fontWeight: "500" } },
							'\u77E5\u9053\u4E86'
						)
					)
				)
			);
		}
	}]);

	return FundAnalysisTips;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FundAnalysisTips);

var styles = {
	container: {
		position: 'absolute',
		width: '100%',
		top: 0,
		bottom: 0,
		backgroundColor: 'rgba(0,0,0,0.5)',
		zIndex: 999,
		justifyContent: 'center',
		alignItems: 'center',
		display: 'flex'
	},
	modalView: {
		backgroundColor: '#ffffff',
		borderRadius: 15,
		width: 273
	},
	titleText: {
		fontSize: 16,
		color: '#474747',
		marginTop: 28
	},
	contentText: {
		color: '#474747',
		fontSize: 12,
		lineHeight: '18px',
		marginTop: 20,
		marginLeft: 20,
		marginRight: 20,
		marginBottom: 5
	},
	footHeight: {
		display: 'flex',
		alignSelf: 'stretch',
		flex: 1,
		alignItems: 'center',
		width: 273,
		justifyContent: 'center',
		borderColor: '#ebeef0',
		borderBottomLeftRadius: 15,
		borderBottomRightRadius: 15
	},
	footView: {
		alignSelf: 'stretch',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 30,
		backgroundColor: "#FA063A",
		width: 210,
		display: 'flex'
	},
	footText: {
		color: '#f8986a',
		fontSize: 15
	}
};

/***/ }),
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_CertificationCard_css__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__css_CertificationCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__css_CertificationCard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__ = __webpack_require__(97);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










/*老用户添加反洗钱信息*/

var AddCertificationCard = function (_Component) {
	_inherits(AddCertificationCard, _Component);

	function AddCertificationCard() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, AddCertificationCard);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddCertificationCard.__proto__ || Object.getPrototypeOf(AddCertificationCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			cardPerson: _this.props.smrzCardPerson,
			personNumber: _this.props.smrzPersonNumber,
			address: _this.props.smrzAddress,
			job: _this.props.smrzJob,
			city: _this.props.smrzCity,
			beneficiaries: _this.props.smrzBeneficiaries,
			beneficiariesName: _this.props.smrzBeneficiariesName,
			beneficiariesType: _this.props.smrzBeneficiariesType,
			beneficiariesNo: _this.props.smrzBeneficiariesNo,
			beneficontro: _this.props.smrzBeneficontro,
			beneficontroName: _this.props.smrzBeneficontroName,
			beneficontroType: _this.props.smrzBeneficontroType,
			beneficontroNo: _this.props.smrzBeneficontroNo,
			isImportant: _this.props.smrzGjzz,
			phoneNo: _this.props.userMobileNo,
			enterType: _this.props.location.query.enterType ? _this.props.location.query.enterType : null,
			careerCode: _this.props.smrzCareerCode
		}, _this.changeJob = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					job: value,
					careerCode: value[0]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_1" /* smrzCareerCode */])(value[0]));
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_2" /* smrzJob */])(value));
			} else {
				var _dispatch = _this.props.dispatch;

				_this.setState({
					job: [_this.props.userJob[0].careerId],
					careerCode: _this.props.userJob[0].careerId
				});
				_dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_1" /* smrzCareerCode */])(_this.props.userJob[0].careerId));
				_dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_2" /* smrzJob */])([_this.props.userJob[0].careerId]));
			}
		}, _this.changeCity = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				city: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_10" /* smrzCity */])(value));
		}, _this.changeBeneficiaries = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficiaries: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_13" /* smrzBeneficiaries */])(value));
		}, _this.changeBeneficontro = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficontro: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_14" /* smrzBeneficontro */])(value));
		}, _this.changeBeneficiariesType = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					beneficiariesType: value
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_15" /* smrzBeneficiariesType */])(value));
			} else {
				var _dispatch2 = _this.props.dispatch;

				_this.setState({
					beneficiariesType: ["身份证"]
				});
				_dispatch2(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_15" /* smrzBeneficiariesType */])(["身份证"]));
			}
		}, _this.changeBeneficontroType = function (value) {
			if (value[0]) {
				var dispatch = _this.props.dispatch;

				_this.setState({
					beneficontroType: value
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_16" /* smrzBeneficontroType */])(value));
			} else {
				var _dispatch3 = _this.props.dispatch;

				_this.setState({
					beneficontroType: ["身份证"]
				});
				_dispatch3(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_16" /* smrzBeneficontroType */])(["身份证"]));
			}
		}, _this.changeIsImportant = function (value) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				isImportant: value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_24" /* smrzGjzz */])(value));
		}, _this.goCertification = function () {
			var dispatch = _this.props.dispatch;
			var _this$state = _this.state,
			    phoneNo = _this$state.phoneNo,
			    personNumber = _this$state.personNumber,
			    beneficiariesName = _this$state.beneficiariesName,
			    beneficiaries = _this$state.beneficiaries,
			    beneficontroName = _this$state.beneficontroName,
			    beneficontro = _this$state.beneficontro,
			    beneficiariesType = _this$state.beneficiariesType,
			    beneficontroType = _this$state.beneficontroType,
			    beneficiariesNo = _this$state.beneficiariesNo,
			    beneficontroNo = _this$state.beneficontroNo,
			    isImportant = _this$state.isImportant,
			    address = _this$state.address,
			    job = _this$state.job,
			    city = _this$state.city,
			    careerCode = _this$state.careerCode;

			var regName = /^([\u4e00-\u9fa5]){2,7}$/;
			var regNo = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
			var regAddress = /[\u4e00-\u9fa5]+/i;
			// if(!regName.test(cardPerson)) {
			// 	Toast.info( "请输入正确格式的持卡人", 2);
			// 	return ;
			// }
			// if(!regNo.test(personNumber)) {
			// 	Toast.info( "请输入正确格式的身份证号", 2);
			// 	return ;
			// }
			// if(cLength(address) < 4) {
			// 	Toast.info( "详细地址不能少于4个汉字", 2);
			// 	return ;
			// }
			console.log(careerCode, "careerCodecareerCode请选择职业请选择职业", !careerCode);
			if (careerCode[0] == "") {
				__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请选择职业", 2);
				return;
			}
			if (beneficontro == "他人") {
				if (!regName.test(beneficontroName)) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入正确格式的控制人姓名", 2);
					return;
				}
				if (!beneficontroType) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请选择控制人证件类型", 2);
					return;
				}
				if (!beneficontroNo) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入控制人证件号", 2);
					return;
				}
				if (beneficontroType == '身份证' && !regNo.test(beneficontroNo)) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的控制人身份证号', 2);
					return;
				}
			}
			if (beneficiaries == "他人") {
				if (!regName.test(beneficiariesName)) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入正确格式的受益人姓名", 2);
					return;
				}
				if (!beneficiariesType) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请选择受益人证件类型", 2);
					return;
				}
				if (!beneficiariesNo) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info("请输入受益人证件号", 2);
					return;
				}
				if (beneficiariesType == '身份证' && !regNo.test(beneficiariesNo)) {
					__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].info('请输入正确格式的受益人身份证号', 2);
					return;
				}
			}
			// let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
			//   	let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
			var theNo = {
				"身份证": "0",
				"护照": "1",
				"户口本": "5",
				"警官证": "a",
				"文职证": "b",
				"港澳居民来往内地通行证(原回乡证)": "4",
				"台胞证": "A"
				// hashHistory.push({
				// 	pathname: "/certificationCardAgain",
				// 	state: {
				// 		name: cardPerson,
				// 		certNo: personNumber.toUpperCase(),
				// 		certType: 0,
				// 		address: address,
				// 		careerCode: careerCode,
				// 		cityCode: city[1],
				// 		provinceCode: city[0],
				// 		actualBeneficiary: beneficiaries == "本人" ? cardPerson : beneficiariesName,
				// 		actualController: beneficontro == "本人" ? cardPerson : beneficontroName,
				// 		actualBeneficiaryCertType: beneficiariesType ? theNo[beneficiariesType] : beneficiariesType,
				// 		actualBeneficiaryCertNo: beneficiariesNo,
				// 		actualControllerCertType: beneficontroType ? theNo[beneficontroType] : beneficontroType,
				// 		actualControllerCertNo: beneficontroNo,
				// 		officialsOrRelatives: isImportant == "是" ? true : false, 
				// 		phoneNo: phoneNo,
				// 		callback: callback,
				// 		route: route,
				// 		enterType:this.state.enterType
				// 	},
				// 	query: {enterType:this.state.enterType}
				// })
			};dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_0" /* smrzCardNumber */])(""));
			var userInfo = _this.props.userInfo && _this.props.userInfo.content;

			var cardPerson = userInfo.name;
			var certNo = userInfo.certNo;
			var certType = userInfo.certType;

			var params = {
				name: cardPerson,
				profession: careerCode, /*职业代码*/
				actualBeneficiary: beneficiaries == "本人" ? cardPerson : beneficiariesName,
				actualController: beneficontro == "本人" ? cardPerson : beneficontroName,

				// actualBeneficiaryCertType: beneficiaries == "本人" ? certType : ( beneficiariesType ? theNo[beneficiariesType] : beneficiariesType ),
				// actualBeneficiaryCertNo: beneficiaries == "本人" ? certNo : beneficiariesNo,
				// actualControllerCertType: beneficontro == "本人" ? certType : beneficontroType ? theNo[beneficontroType] : beneficontroType,
				// actualControllerCertNo: beneficontro == "本人" ? certNo : beneficontroNo,
				// isOfficialsOrRelatives: isImportant == "是" ? true : false, 

				actualBeneficiaryCertType: beneficiariesType ? theNo[beneficiariesType] : "0",
				actualBeneficiaryCertNo: beneficiaries == "本人" ? certNo : beneficiariesNo,
				actualControllerCertType: beneficontroType ? theNo[beneficontroType] : "0",
				actualControllerCertNo: beneficontro == "本人" ? certNo : beneficontroNo,
				isOfficialsOrRelatives: isImportant == "是" ? true : false,
				sex: "",
				email: "",
				contactAddress: ""

			};
			console.log(params, "paramspara8888msparams");
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__action_myAssets_userInfoAction__["j" /* modifyUserAccount */])(params, _this.callback));
		}, _this.callback = function (res) {
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			if (route) {
				__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].go(-1);
			}
		}, _this.changeCardPerson = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				cardPerson: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_26" /* smrzCardPerson */])(event.target.value));
		}, _this.changeBeneficiariesName = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficiariesName: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_27" /* smrzBeneficiariesName */])(event.target.value));
		}, _this.changeBeneficontroName = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficontroName: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_28" /* smrzBeneficontroName */])(event.target.value));
		}, _this.changeBeneficiariesNo = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficiariesNo: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_29" /* smrzBeneficiariesNo */])(event.target.value));
		}, _this.changeBeneficontroNo = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				beneficontroNo: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_30" /* smrzBeneficontroNo */])(event.target.value));
		}, _this.changePersonNumber = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				personNumber: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_33" /* smrzPersonNumber */])(event.target.value));
		}, _this.changeAddress = function (event) {
			var dispatch = _this.props.dispatch;

			_this.setState({
				address: event.target.value
			});
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_34" /* smrzAddress */])(event.target.value));
		}, _this.goBack = function () {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
			__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* hashHistory */].goBack();
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(AddCertificationCard, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
			document.getElementsByTagName('title')[0].innerHTML = "实名认证";
			var dispatch = this.props.dispatch;

			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_44" /* userJob */])(null));
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["x" /* provinceCity */])(null));
			__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Toast"].loading("正在加载");
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["z" /* getProvinceCity */])(function (data) {
				_this2.setState({
					city: [data[0].provinceCode, data[0].cityList[0].cityCode]
				});
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_10" /* smrzCity */])([data[0].provinceCode, data[0].cityList[0].cityCode]));
			}, function () {}));
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__action_investmentAction_js__["_45" /* getUserJob */])());

			console.log(this.props.userInfo, "userInfouserInfouserInfouserInfo****");
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
		}
	}, {
		key: 'render',
		value: function render() {
			var _state = this.state,
			    cardPerson = _state.cardPerson,
			    personNumber = _state.personNumber,
			    city = _state.city,
			    address = _state.address,
			    job = _state.job,
			    downUpListShow = _state.downUpListShow,
			    beneficiariesName = _state.beneficiariesName,
			    beneficiaries = _state.beneficiaries,
			    beneficontroName = _state.beneficontroName,
			    beneficontro = _state.beneficontro,
			    beneficiariesType = _state.beneficiariesType,
			    beneficontroType = _state.beneficontroType,
			    beneficiariesNo = _state.beneficiariesNo,
			    beneficontroNo = _state.beneficontroNo,
			    isImportant = _state.isImportant,
			    downListFlag = _state.downListFlag;

			var btnArr = [];
			var jobArr = [];
			var cityArr = [];
			var _props = this.props,
			    provinceCity = _props.provinceCity,
			    userJob = _props.userJob;

			if (userJob != null) {
				for (var i = 0; i < userJob.length; i++) {
					jobArr.push({ label: userJob[i].careerName, value: userJob[i].careerId });
				}
			}
			if (provinceCity != null) {
				for (var _i = 0; _i < provinceCity.length; _i++) {
					var obj = {};
					var obj2 = [];
					obj.label = provinceCity[_i].provinceName;
					obj.value = provinceCity[_i].provinceCode;
					for (var k = 0; k < provinceCity[_i].cityList.length; k++) {
						obj2.push({
							label: provinceCity[_i].cityList[k].cityName,
							value: provinceCity[_i].cityList[k].cityCode
						});
					}
					obj.children = obj2;
					cityArr.push(obj);
				}
			}
			var beneficiariesArr = [{ value: "本人", label: "本人" }, { value: "他人", label: "他人" }];
			var beneficontroArr = [{ value: "本人", label: "本人" }, { value: "他人", label: "他人" }];
			var beneficiariesTypeArr = [{ value: "身份证", label: "身份证" }, { value: "护照", label: "护照" }, { value: "户口本", label: "户口本" }, { value: "警官证", label: "警官证" }, { value: "文职证", label: "文职证" }, { value: "港澳居民来往内地通行证(原回乡证)", label: "港澳居民来往内地通行证(原回乡证)" }, { value: "台胞证", label: "台胞证" }];
			var beneficontroTypeArr = [{ value: "身份证", label: "身份证" }, { value: "护照", label: "护照" }, { value: "户口本", label: "户口本" }, { value: "警官证", label: "警官证" }, { value: "文职证", label: "文职证" }, { value: "港澳居民来往内地通行证(原回乡证)", label: "港澳居民来往内地通行证(原回乡证)" }, { value: "台胞证", label: "台胞证" }];
			var gjzzArr = [{ value: "是", label: "是" }, { value: "否", label: "否" }];
			if (job && beneficontro == "本人" && beneficiaries == "本人" && isImportant) {
				btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{
						className: 'smrz-first-okbtn',
						key: 0,
						onClick: this.goCertification
					},
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						null,
						'\u4E0B\u4E00\u6B65'
					)
				));
			} else if (job && beneficontro == "他人" && beneficiaries == "本人" && isImportant) {
				if (beneficontroName && beneficontroType && beneficontroNo) {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-unokbtn',
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				}
			} else if (job && beneficiaries == "他人" && beneficontro == "本人" && isImportant) {
				if (beneficiariesName && beneficiariesType && beneficiariesNo) {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-unokbtn',
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				}
			} else if (job && beneficiaries == "他人" && beneficontro == "他人" && isImportant) {
				if (beneficiariesName && beneficontroName && beneficiariesType && beneficontroType && beneficiariesNo && beneficontroNo) {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-okbtn',
							key: 0,
							onClick: this.goCertification
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				} else {
					btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{
							className: 'smrz-first-unokbtn',
							key: 0
						},
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							'\u4E0B\u4E00\u6B65'
						)
					));
				}
			} else {
				btnArr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{
						className: 'smrz-first-unokbtn',
						key: 0
					},
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						null,
						'\u4E0B\u4E00\u6B65'
					)
				));
			}
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_4__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10 } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'div',
							{ style: { fontSize: "13px", color: "#5b6370" } },
							'\u6839\u636E\u8BC1\u76D1\u4F1A\u9500\u552E\u9002\u5F53\u6027\u8981\u6C42\uFF0C\u8BF7\u5982\u5B9E\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u4E8E\u4E3A\u60A8\u63D0\u4F9B\u66F4\u597D\u7684\u5B89\u5168\u4FDD\u969C'
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: job[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: job, title: '\u804C\u4E1A\u5217\u8868', data: jobArr, extra: '\u8BF7\u9009\u62E9\u804C\u4E1A', onChange: this.changeJob, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u804C\u4E1A'
							)
						)
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficontro, title: '\u8D26\u6237\u5B9E\u9645\u63A7\u5236\u4EBA', data: beneficontroArr, onChange: this.changeBeneficontro, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8D26\u6237\u5B9E\u9645\u63A7\u5236\u4EBA'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u59D3\u540D'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficontroName,
							onChange: this.changeBeneficontroName,
							placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D'
						})
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: beneficontroType[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficontroType, title: '\u8BC1\u4EF6\u7C7B\u578B', extra: '\u8BF7\u9009\u62E9\u8BC1\u4EF6\u7C7B\u578B', data: beneficontroTypeArr, onChange: this.changeBeneficontroType, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8BC1\u4EF6\u7C7B\u578B'
							)
						)
					),
					beneficontro == "本人" || !beneficontro ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BC1\u4EF6\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficontroNo,
							onChange: this.changeBeneficontroNo,
							placeholder: '\u8BF7\u8F93\u5165\u8BC1\u4EF6\u53F7'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox', style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficiaries, title: '\u8D26\u6237\u5B9E\u9645\u63A7\u5236\u4EBA', data: beneficiariesArr, onChange: this.changeBeneficiaries, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8D26\u6237\u5B9E\u9645\u53D7\u76CA\u4EBA'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u59D3\u540D'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficiariesName,
							onChange: this.changeBeneficiariesName,
							placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D'
						})
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: beneficiariesType[0] ? "pickerBox" : "pickerBox pickerBox6", style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: beneficiariesType, title: '\u8BC1\u4EF6\u7C7B\u578B', extra: '\u8BF7\u9009\u62E9\u8BC1\u4EF6\u7C7B\u578B', data: beneficiariesTypeArr, onChange: this.changeBeneficiariesType, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u8BC1\u4EF6\u7C7B\u578B'
							)
						)
					),
					beneficiaries == "本人" || !beneficiaries ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ style: {
								display: "-webkit-flex",
								height: 45,
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							'span',
							{ style: {
									color: "#5b6370",
									fontSize: "13px",
									width: "40%",
									display: "block"
								} },
							'\u8BC1\u4EF6\u53F7'
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autocomplete: 'off',
							style: {
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							},
							value: beneficiariesNo,
							onChange: this.changeBeneficiariesNo,
							placeholder: '\u8BF7\u8F93\u5165\u8BC1\u4EF6\u53F7'
						})
					),
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						'div',
						{ className: 'pickerBox pickerBoxTs', style: {
								display: "-webkit-flex",
								height: "auto",
								backgroundColor: "#fff",
								paddingLeft: 13,
								paddingRight: 13,
								WebkitAlignItems: "center",
								WebkitFlexDirection: "row",
								borderBottom: "1px solid rgb(235, 238, 240)"
							} },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["Picker"],
							{ value: isImportant, title: '\u8BF7\u9009\u62E9\u662F\u6216\u5426', data: gjzzArr, onChange: this.changeIsImportant, cols: 1, className: 'forss' },
							__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
								__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib__["List"].Item,
								{ arrow: 'horizontal' },
								'\u5B9E\u9645\u53D7\u76CA\u4EBA\u4E3A\u653F\u8981\u3001\u56FD\u9645\u7EC4\u7EC7\u9AD8\u7EA7\u7BA1\u7406\u4EBA\u5458\u6216\u5176\u4EB2\u5C5E\u3001\u5173\u7CFB\u5BC6\u5207\u7684\u4EBA'
							)
						)
					),
					btnArr
				)
			);
		}
	}]);

	return AddCertificationCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state, ownProps) {
	return {
		userJob: state.userJob,
		provinceCity: state.provinceCity,
		smrzCardPerson: state.smrzCardPerson,
		smrzPersonNumber: state.smrzPersonNumber,
		smrzAddress: state.smrzAddress,
		smrzJob: state.smrzJob,
		smrzCareerCode: state.smrzCareerCode,
		smrzCity: state.smrzCity,
		smrzBeneficiaries: state.smrzBeneficiaries,
		smrzBeneficiariesName: state.smrzBeneficiariesName,
		smrzBeneficiariesType: state.smrzBeneficiariesType,
		smrzBeneficiariesNo: state.smrzBeneficiariesNo,
		smrzBeneficontro: state.smrzBeneficontro,
		smrzBeneficontroName: state.smrzBeneficontroName,
		smrzBeneficontroType: state.smrzBeneficontroType,
		smrzBeneficontroNo: state.smrzBeneficontroNo,
		smrzGjzz: state.smrzGjzz,
		userMobileNo: state.userMobileNo,
		userInfo: state.verifiedUserInfo
	};
}

function cLength(str) {
	var reg = /[^\u4E00-\u9FA5\uf900-\ufa2d]/g;
	//匹配非中文的正则表达式
	var temp = str.replace(reg, '');
	return temp.length;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(AddCertificationCard));

/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CertificationCard_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain_js__ = __webpack_require__(4);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var CertiUpload = function (_PureComponent) {
	_inherits(CertiUpload, _PureComponent);

	function CertiUpload() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CertiUpload);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertiUpload.__proto__ || Object.getPrototypeOf(CertiUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			isRealName: false,
			filesList: [{ url: "" }, { url: "" }],
			kzrId: _this.props.location.state.accountRole.kzrId,
			syrId: _this.props.location.state.accountRole.syrId
		}, _this.getConversationIDFun = function () {
			var accountRole = _this.props.location.state.accountRole;
			var ksId = accountRole == 1 ? _this.state.kzrId : _this.state.syrId;
			console.log(ksId);
			_this.goCert(ksId);
		}, _this.savePic = function (files, requestId, token, zzhId, kzrId, syrId, ksId, allParams) {
			var dispatch = _this.props.dispatch;

			var formData = new FormData();
			for (var i = 0; i < files.length; i++) {
				formData.append("multipartFiles", files[i].file);
			}
			formData.append("clientType", __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type());
			formData.append("token", token);
			formData.append("requestId", requestId);
			formData.append("conversationId", ksId);
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["l" /* uploadCertificatePic */])(formData, function (result) {}, function () {}, true, "0"));
			// this.saveUserAccountFun(token, allParams, kzrId, syrId);
		}, _this.goBack = function () {
			__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
		}, _this.resetFun = function () {
			_this.setState({
				filesList: [{ url: "" }, { url: "" }]
			});
		}, _this.goCert = function (ksId) {
			var dispatch = _this.props.dispatch;

			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var backFun = _this.props.location.state && _this.props.location.state.backFun ? _this.props.location.state.backFun : null;
			var phoneNo = _this.props.location.state && _this.props.location.state.phoneNo ? _this.props.location.state.phoneNo : null;
			var filesList = _this.state.filesList;

			var formData = new FormData();
			__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading("正在加载");
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["b" /* getTempInfo */])('shortToken').then(function (token) {
				for (var i = 0; i < filesList.length; i++) {
					formData.append("multipartFiles", filesList[i].file);
				}
				formData.append("clientType", __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type());
				formData.append("token", token);
				formData.append("conversationId", ksId);
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["l" /* uploadCertificatePic */])(formData, function (result) {
					__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
					var objsk = {
						personNo: result.content.certificateNo,
						realName: result.content.certificateName,
						route: route ? route : null,
						callback: callback ? callback : null,
						phoneNo: phoneNo ? phoneNo : null,
						backFun: backFun ? backFun : null,
						Boll: true
					};
					var onFun = _this.props.location.state.onFun;
					onFun(objsk);
					__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
				}, function () {
					__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
				}, false, "0"));
			}).catch(function (err) {
				__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
			});
		}, _this.onChangeImg = function (files, index) {
			var newArr = [].concat(_this.state.filesList);
			newArr[index] = files[0];
			_this.setState({
				filesList: newArr
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CertiUpload, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {}
	}, {
		key: 'componentDidMount',
		value: function () {
			var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var isRealName;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["d" /* getStorage */])('loginState');

							case 2:
								isRealName = _context.sent;

								console.log(isRealName, this.props.location.state);
								if (isRealName == "2") {
									this.setState({
										isRealName: true
									});
								}

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function componentDidMount() {
				return _ref2.apply(this, arguments);
			}

			return componentDidMount;
		}()
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    isRealName = _state.isRealName,
			    filesList = _state.filesList;

			return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_9__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, height: 76, backgroundColor: "#fff", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { fontSize: 13, color: "#535760", lineHeight: "20px" } },
							'\u8BF7\u4E0A\u4F20\u672C\u4EBA\u8EAB\u4EFD\u8BC1\u7167\u7247\uFF0C\u62CD\u7167\u65F6\u8BF7\u786E\u4FDD\u8EAB\u4EFD\u8BC1\u8FB9\u6846\u5B8C\u6574\u3001\u56FE\u50CF\u6E05\u6670\u3001\u5149\u7EBF\u5747\u5300\uFF1A'
						)
					),
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingTop: 30, paddingBottom: 30, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { fontSize: 18, color: "#33363F" } },
							'\u8BF7\u62CD\u6444/\u4E0A\u4F20\u60A8\u7684\u4E8C\u4EE3\u8EAB\u4EFD\u8BC1'
						)
					),
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13 } },
						filesList.map(function (data, index) {
							return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'div',
								{ id: 'uploadCert', key: index, style: { backgroundColor: "#fff", height: 204, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: "100%", marginTop: index == "0" ? 0 : 10 } },
								data.url ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'div',
									{ style: { position: "relative", width: 270, height: 150 } },
									__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
										src: data.url,
										style: { width: "100%", height: "100%" }
									}),
									__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ImagePicker"], {
										style: { opacity: 0, position: "absolute", left: 90, top: 15, width: "100%", height: "100%" },
										files: [],
										length: 1,
										selectable: true,
										disableDelete: true,
										onChange: function onChange(files) {
											_this2.onChangeImg(files, index);
										},
										multiple: false
									})
								) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'div',
									{ style: { borderColor: "#000", borderStyle: "dotted", borderRadius: 0.5, borderWidth: 1, width: 270, height: 150 } },
									__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
										'div',
										{ style: { position: "relative", width: 262, height: 144, display: "-webkit-flex", backgroundImage: index == "0" ? 'url(' + __webpack_require__(644) + ')' : 'url(' + __webpack_require__(643) + ')' } },
										__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
											'div',
											{ style: { WebkitFlexDirection: "column", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1 } },
											__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
												'div',
												{ style: { width: 60, height: 60, display: "-webkit-flex", borderRadius: 60, backgroundColor: "#3691FF", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
												__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(647), style: { width: 35, height: 30 } })
											),
											__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
												'div',
												{ style: { color: "#535760", fontSize: 15, marginTop: 10 } },
												index == "0" ? "点击拍摄/上传人像面" : "点击拍摄/上传国徽面"
											)
										),
										__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ImagePicker"], {
											style: { opacity: 0, position: "absolute", left: 90, top: 15, width: "100%", height: "100%" },
											files: [],
											length: 1,
											selectable: true,
											disableDelete: true,
											onChange: function onChange(files) {
												_this2.onChangeImg(files, index);
											},
											multiple: false
										})
									)
								)
							);
						})
					),
					filesList[0].url == "" || filesList[1].url == "" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: styles.disableBtnSuccess,
							onClick: function onClick() {}
						},
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u63D0\u4EA4\u8EAB\u4EFD\u8BC1\u7167\u7247'
						)
					) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: styles.btnSuccess,
							onClick: this.getConversationIDFun
						},
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u63D0\u4EA4\u8EAB\u4EFD\u8BC1\u7167\u7247'
						)
					)
				)
			);
		}
	}]);

	return CertiUpload;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(CertiUpload));

var styles = {
	disableBtnSuccess: {
		marginTop: 30,
		height: 40,
		backgroundColor: "#afb0b2",
		WebkitJustifyContent: "center",
		WebkitAlignItems: "center",
		marginLeft: 13,
		marginRight: 13,
		marginBottom: 74,
		borderRadius: 30,
		display: "-webkit-flex"
	},
	btnSuccess: {
		marginTop: 30,
		height: 40,
		backgroundColor: "#FA063A",
		WebkitJustifyContent: "center",
		display: "-webkit-flex",
		WebkitAlignItems: "center",
		marginLeft: 13,
		marginRight: 13,
		marginBottom: 74,
		borderRadius: 30
	}
};

function mapStateToProps(state, ownProps) {
	return {};
}

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CertificationCard_js__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_investmentAction__ = __webpack_require__(8);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CertificationUpload = function (_PureComponent) {
	_inherits(CertificationUpload, _PureComponent);

	function CertificationUpload() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, CertificationUpload);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CertificationUpload.__proto__ || Object.getPrototypeOf(CertificationUpload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			isRealName: false,
			filesList: [{ url: "" }, { url: "" }]
		}, _this.getConversationIDFun = function () {
			_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["m" /* getConversationIds */])({}, function (res) {
				console.log(res);
				if (_this.state.isRealName) {
					_this.goCertSec(res.content.zzh);
				} else {
					_this.goCert(res.content.zzh, res.content.kzr, res.content.syr);
				}
			}, function () {}));
		}, _this.saveUserAccountFun = function (token, allParams, kzrId, syrId) {
			var isTrueKzr = allParams.certNo != allParams.actualControllerCertNo ? true : false;
			var isTrueSyr = allParams.certNo != allParams.actualBeneficiaryCertNo ? true : false;
			if (isTrueKzr || isTrueSyr) {
				// let _actualControllerValidTerm = allParams.actualControllerValidTerm=="长期有效"?"":allParams.actualControllerValidTerm+" 00:00:00";
				// let _actualBeneficiaryValidTerm = allParams.actualBeneficiaryValidTerm=="长期有效"?"":allParams.actualBeneficiaryValidTerm+" 00:00:00";
				_this.props.dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["n" /* saveUserAccount */])({
					actualController: isTrueKzr ? allParams.actualController : "",
					actualControllerCertNo: isTrueKzr ? allParams.actualControllerCertNo : "",
					actualControllerCertType: isTrueKzr ? allParams.actualControllerCertType : "",
					actualControllerValidTerm: isTrueKzr ? allParams.actualControllerValidTerm : "",
					actualControllerValidEver: isTrueKzr ? allParams.actualControllerValidEver : "",
					controllerConversationId: isTrueKzr ? kzrId : "",
					actualBeneficiary: isTrueSyr ? allParams.actualBeneficiary : "",
					actualBeneficiaryCertNo: isTrueSyr ? allParams.actualBeneficiaryCertNo : "",
					actualBeneficiaryCertType: isTrueSyr ? allParams.actualBeneficiaryCertType : "",
					actualBeneficiaryValidTerm: isTrueSyr ? allParams.actualBeneficiaryValidTerm : "",
					actualBeneficiaryValidEver: isTrueSyr ? allParams.actualBeneficiaryValidEver : "",
					beneficiaryConversationId: isTrueSyr ? syrId : "",
					token: token
				}));
			}
		}, _this.savePic = function (files, requestId, token, zzhId, kzrId, syrId, allParams) {
			var dispatch = _this.props.dispatch;

			var formData = new FormData();
			for (var i = 0; i < files.length; i++) {
				formData.append("multipartFiles", files[i].file);
			}
			formData.append("clientType", __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type());
			formData.append("token", token);
			formData.append("requestId", requestId);
			formData.append("conversationId", zzhId);
			formData.append("fillAccountNo", true);
			dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["l" /* uploadCertificatePic */])(formData, function (result) {}, function () {}, true, "0"));
			_this.saveUserAccountFun(token, allParams, kzrId, syrId);
		}, _this.goBack = function () {
			__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].goBack();
		}, _this.resetFun = function () {
			_this.setState({
				filesList: [{ url: "" }, { url: "" }]
			});
		}, _this.goCert = function (zzhId, kzrId, syrId) {
			var dispatch = _this.props.dispatch;

			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			var route = _this.props.location.state && _this.props.location.state.route ? _this.props.location.state.route : null;
			var backFun = _this.props.location.state && _this.props.location.state.backFun ? _this.props.location.state.backFun : null;
			var phoneNo = _this.props.location.state && _this.props.location.state.phoneNo ? _this.props.location.state.phoneNo : null;
			var filesList = _this.state.filesList;

			var formData = new FormData();
			__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading("正在加载");
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["b" /* getTempInfo */])('shortToken').then(function (token) {
				for (var i = 0; i < filesList.length; i++) {
					formData.append("multipartFiles", filesList[i].file);
				}
				formData.append("clientType", __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type());
				formData.append("token", token);
				formData.append("conversationId", zzhId);
				formData.append("mobileNo", _this.props.location.state.phoneNo);
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["l" /* uploadCertificatePic */])(formData, function (result) {
					console.log(result);
					__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
					var objzzh = {
						certValidTerm: result.content.certificateValidEver ? "长期有效" : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["returnDate"])(result.content.certificateValidTerm),
						certValidEver: result.content.certificateValidEver ? "1" : "0"
					};
					dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__action_investmentAction__["_17" /* zzhZjyxq */])(objzzh));
					var reg = /^[1-9]\d{3}.(0[1-9]|1[0-2]).(0[1-9]|[1-2][0-9]|3[0-1])$/;
					if (!reg.test(result.content.validity.split("-")[0])) {
						__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("身份信息识别失败，请重新上传本人证件照片，拍照时请确保证件边框完成、图像清晰、光线均匀。", 2);
						_this.resetFun();
					} else {
						if (result.content.validity.split("-")[1] == "长期" || reg.test(result.content.validity.split("-")[1])) {
							__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].push({
								pathname: '/CertificationCard',
								state: {
									personNo: result.content.certificateNo,
									realName: result.content.certificateName,
									conversationId: zzhId,
									kzrId: kzrId,
									syrId: syrId,
									certificateValidEver: result.content.certificateValidEver,
									certificateValidTerm: result.content.certificateValidTerm,
									validity: result.content.validity,
									mobileNo: _this.props.location.state.phoneNo,
									resetFun: function resetFun() {
										_this.resetFun();
									},
									route: route ? route : null,
									callback: callback ? callback : null,
									phoneNo: phoneNo ? phoneNo : null,
									backFun: backFun ? backFun : null,
									savePicFun: function savePicFun(token, allParams) {
										_this.savePic(filesList, result.content.requestId, token, zzhId, kzrId, syrId, allParams);
									},
									BoolVule: true
								},
								query: { enterType: _this.state.enterType,
									activityId: _this.props.location.query.activityId
								}
							});
						} else {
							__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info("身份信息识别失败，请重新上传本人证件照片，拍照时请确保证件边框完成、图像清晰、光线均匀。", 2);
							_this.resetFun();
						}
					}
				}, function () {
					__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
				}, false, "0"));
			}).catch(function (err) {
				__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
			});
		}, _this.goCertSec = function (zzhId) {
			var dispatch = _this.props.dispatch;

			var callback = _this.props.location.state && _this.props.location.state.callback ? _this.props.location.state.callback : null;
			var filesList = _this.state.filesList;

			var formData = new FormData();
			__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].loading("正在加载");
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["b" /* getTempInfo */])('shortToken').then(function (token) {
				for (var i = 0; i < filesList.length; i++) {
					formData.append("multipartFiles", filesList[i].file);
				}
				formData.append("clientType", __WEBPACK_IMPORTED_MODULE_7__util___default.a.return_Clinet_Type());
				formData.append("token", token);
				formData.append("conversationId", zzhId);
				dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["l" /* uploadCertificatePic */])(formData, function (result) {
					formData.append("requestId", result.content.requestId);
					formData.append("conversationId", zzhId);
					dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__action_myAssets_userInfoAction_js__["l" /* uploadCertificatePic */])(formData, function (_result) {
						__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
						__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].info('身份证上传成功', 2000, function () {
							_this.goBack();
							if (callback) {
								setTimeout(function () {
									callback();
								});
							}
						});
					}, function () {
						__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
					}, true, "0"));
				}, function () {
					__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
				}, false, "0"));
			}).catch(function (err) {
				__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].hide();
			});
		}, _this.onChangeImg = function (files, index) {
			__WEBPACK_IMPORTED_MODULE_7__util___default.a.compressPicture(files).then(function (res) {
				var newArr = [].concat(_this.state.filesList);
				newArr[index] = res;
				_this.setState({
					filesList: newArr
				});
			}).catch(function () {
				__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["Toast"].fail('请正确上传本人有效证件', __WEBPACK_IMPORTED_MODULE_7__util___default.a.ToastTime);
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(CertificationUpload, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {}
	}, {
		key: 'componentDidMount',
		value: function () {
			var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var isRealName;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_js__["d" /* getStorage */])('loginState');

							case 2:
								isRealName = _context.sent;

								console.log(isRealName, this.props.location.state);
								if (isRealName == "2") {
									this.setState({
										isRealName: true
									});
								}

							case 5:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function componentDidMount() {
				return _ref2.apply(this, arguments);
			}

			return componentDidMount;
		}()
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _state = this.state,
			    isRealName = _state.isRealName,
			    filesList = _state.filesList;

			console.log(filesList, "8383838383", isRealName);
			return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
				'div',
				{ className: 'mainBox' },
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					__WEBPACK_IMPORTED_MODULE_9__NavigatorMain_js__["a" /* default */],
					null,
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ className: 'boxHeader' },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							null,
							__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'span',
								null,
								'\u5B9E\u540D\u8BA4\u8BC1'
							)
						),
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null)
					)
				),
				__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
					'div',
					{ className: 'boxContent' },
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13, height: 76, backgroundColor: "#fff", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { fontSize: 13, color: "#535760", lineHeight: "20px" } },
							'\u8BF7\u4E0A\u4F20\u672C\u4EBA\u8EAB\u4EFD\u8BC1\u7167\u7247\uFF0C\u62CD\u7167\u65F6\u8BF7\u786E\u4FDD\u8EAB\u4EFD\u8BC1\u8FB9\u6846\u5B8C\u6574\u3001\u56FE\u50CF\u6E05\u6670\u3001\u5149\u7EBF\u5747\u5300\uFF1A'
						)
					),
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingTop: 30, paddingBottom: 30, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { fontSize: 18, color: "#33363F" } },
							'\u8BF7\u62CD\u6444/\u4E0A\u4F20\u60A8\u7684\u4E8C\u4EE3\u8EAB\u4EFD\u8BC1'
						)
					),
					__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: { paddingLeft: 13, paddingRight: 13 } },
						filesList.map(function (data, index) {
							return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
								'div',
								{ id: 'uploadCert', key: index, style: { backgroundColor: "#fff", height: 204, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", width: "100%", marginTop: index == "0" ? 0 : 10 } },
								data.url ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'div',
									{ style: { position: "relative", width: 270, height: 150 } },
									__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
										src: data.url,
										style: { width: "100%", height: "100%" }
									}),
									__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ImagePicker"], {
										style: { opacity: 0, position: "absolute", left: 90, top: 15, width: "100%", height: "100%" },
										files: [],
										length: 1,
										selectable: true,
										disableDelete: true,
										onChange: function onChange(files) {
											_this2.onChangeImg(files, index);
										},
										multiple: false
									})
								) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
									'div',
									{ style: { borderColor: "#000", borderStyle: "dotted", borderRadius: 0.5, borderWidth: 1, width: 270, height: 150 } },
									__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
										'div',
										{ style: { position: "relative", width: 262, height: 144, display: "-webkit-flex", backgroundImage: index == "0" ? 'url(' + __webpack_require__(644) + ')' : 'url(' + __webpack_require__(643) + ')' } },
										__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
											'div',
											{ style: { WebkitFlexDirection: "column", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1 } },
											__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
												'div',
												{ style: { width: 60, height: 60, display: "-webkit-flex", borderRadius: 60, backgroundColor: "#3691FF", WebkitJustifyContent: "center", WebkitAlignItems: "center" } },
												__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(647), style: { width: 35, height: 30 } })
											),
											__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
												'div',
												{ style: { color: "#535760", fontSize: 15, marginTop: 10 } },
												index == "0" ? "点击拍摄/上传人像面" : "点击拍摄/上传国徽面"
											)
										),
										__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib__["ImagePicker"], {
											style: { opacity: 0, position: "absolute", left: 90, top: 15, width: "100%", height: "100%" },
											files: [],
											length: 1,
											selectable: true,
											disableDelete: true,
											onChange: function onChange(files) {
												_this2.onChangeImg(files, index);
											},
											multiple: false
										})
									)
								)
							);
						})
					),
					filesList[0].url == "" || filesList[1].url == "" ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: styles.disableBtnSuccess,
							onClick: function onClick() {}
						},
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u63D0\u4EA4\u8EAB\u4EFD\u8BC1\u7167\u7247'
						)
					) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
						'div',
						{ style: styles.btnSuccess,
							onClick: this.getConversationIDFun
						},
						__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
							'div',
							{ style: { color: "#fff", fontSize: 15 } },
							'\u63D0\u4EA4\u8EAB\u4EFD\u8BC1\u7167\u7247'
						)
					)
				)
			);
		}
	}]);

	return CertificationUpload;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps)(CertificationUpload));

var styles = {
	disableBtnSuccess: {
		marginTop: 30,
		height: 40,
		backgroundColor: "#afb0b2",
		WebkitJustifyContent: "center",
		WebkitAlignItems: "center",
		marginLeft: 13,
		marginRight: 13,
		marginBottom: 74,
		borderRadius: 30,
		display: "-webkit-flex"
	},
	btnSuccess: {
		marginTop: 30,
		height: 40,
		backgroundColor: "#FA063A",
		WebkitJustifyContent: "center",
		display: "-webkit-flex",
		WebkitAlignItems: "center",
		marginLeft: 13,
		marginRight: 13,
		marginBottom: 74,
		borderRadius: 30
	}
};

function mapStateToProps(state, ownProps) {
	return {};
}

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var nowTimeStamp = Date.now();
var dataval = __WEBPACK_IMPORTED_MODULE_4_moment___default()(nowTimeStamp);

var ChangTime = function (_Component) {
    _inherits(ChangTime, _Component);

    function ChangTime() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ChangTime);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChangTime.__proto__ || Object.getPrototypeOf(ChangTime)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            date: dataval,
            agreeIndex: 0,
            dateValueTime: dataval.format('YYYY-MM-DD')
        }, _this.goBack = function () {
            window._czc.push(["_trackEvent", "华夏财富H5", "设置证件有效期", "回退"]);
            __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
        }, _this.getShowDate = function (value) {
            var dateValue = value.format('YYYY-MM-DD');
            _this.setState({
                dateValueTime: dateValue
            });
            return dateValue;
        }, _this.goBacks = function () {
            if (_this.state.agreeIndex == "1") {
                _this.setState({
                    agreeIndex: 0
                });
            } else {
                _this.setState({
                    agreeIndex: 1
                });
            }
        }, _this.zjyxq = function () {
            var onFun = _this.props.location.state.onFun;
            var valu = _this.props.location.state.valu;
            var objzzh = {
                certValidTerm: _this.state.agreeIndex == "1" ? "长期有效" : _this.state.dateValueTime,
                certValidEver: _this.state.agreeIndex == "1" ? "1" : "0"
            };
            var objkzr = {
                actualControllerValidTerm: _this.state.agreeIndex == "1" ? "长期有效" : _this.state.dateValueTime,
                actualControllerValidEver: _this.state.agreeIndex == "1" ? "1" : "0",
                str: "控制人证件有效期"
            };
            var objkzrs = {
                actualControllerBirthday: _this.state.dateValueTime,
                str: "控制人出生日期"
            };
            var objsyr = {
                actualBeneficiaryValidTerm: _this.state.agreeIndex == "1" ? "长期有效" : _this.state.dateValueTime,
                actualBeneficiaryValidEver: _this.state.agreeIndex == "1" ? "1" : "0",
                str: "受益人证件有效期"
            };
            var objsyrs = {
                actualBeneficiaryBirthday: _this.state.dateValueTime,
                str: "受益人出生日期"
            };
            if (valu == "控制人证件有效期") {
                onFun(objkzr);
            } else if (valu == "受益人证件有效期") {
                onFun(objsyr);
            } else if (valu == "控制人出生日期") {
                onFun(objkzrs);
            } else if (valu == "受益人出生日期") {
                onFun(objsyrs);
            } else if (valu == "主账户证件有效期") {
                onFun(objzzh);
            }
            __WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* hashHistory */].goBack();
        }, _this.onChanges = function (datas) {
            console.log(datas);
            var dateValue = datas.format('YYYY-MM-DD');
            _this.setState({
                date: datas,
                dateValueTime: dateValue
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ChangTime, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            console.log(this.state.date);
            var img_arr = [__webpack_require__(389), __webpack_require__(390)];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_1__NavigatorMain_js__["a" /* default */],
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'boxHeader' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.goBack, src: __webpack_require__(21) })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                null,
                                '\u8BBE\u7F6E',
                                this.props.location.state.valu
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'boxContent' },
                    this.props.location.state.valu == "控制人证件有效期" || this.props.location.state.valu == "受益人证件有效期" || this.props.location.state.valu == "主账户证件有效期" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "flex", paddingLeft: "0.2rem", alignItems: "center", background: "#fff", borderBottom: "1px solid gray", paddingRight: "0.2rem" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { style: { flex: 1 } },
                            '\u662F\u5426\u957F\u671F\u6709\u6548'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            ' ',
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: "0.6rem", height: "0.6rem" }, onClick: this.goBacks, src: img_arr[this.state.agreeIndex] })
                        )
                    ) : null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["DatePicker"],
                        {
                            mode: 'date',
                            title: '\u9009\u62E9\u65F6\u95F4'
                            // extra="Optional"
                            , minDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date(1900, 1, 1, 23, 59, 59)),
                            maxDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date(2222, 1, 1, 23, 59, 59)),
                            value: this.state.date,
                            format: function format(value) {
                                return value.format('YYYY-MM-DD');
                            },
                            onChange: function onChange(data) {
                                _this2.onChanges(data);
                            }
                        },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib__["List"].Item,
                            { arrow: 'horizontal' },
                            '\u8BF7\u9009\u62E9\u65E5\u671F'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { style: { display: "flex", justifyContent: "center", paddingTop: "0.2rem" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { onClick: this.zjyxq, style: { width: "3rem", height: "0.6rem", background: "red", borderRadius: "10px", border: "0", color: "#000", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "20px" } },
                            '\u63D0\u4EA4'
                        )
                    )
                )
            );
        }
    }]);

    return ChangTime;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ChangTime);

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2144 */,
/* 2145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OpenBrowser.d15b88b6.jpg";

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bianzu4.d6e18d13.png";

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bianzu6.c8a41d7a.png";

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fundHeader.7b1243ff.png";

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_add_self.5a788b40.png";

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_baozhi_grey.89eef90b.png";

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_chengzheng_gray.730e1e0a.png";

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jiaoyu.ca63b597.png";

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_kefu.2ab15707.png";

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_no_data.61421c20.png";

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_xiala.767dd2d8.png";

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_xlqhx.19c0502b.png";

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_yanglao.a72f8f76.png";

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icondfenhong.5a7d6a81.png";

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconhxcf_icon_youjiantou_10_gray.52e297bd.png";

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconshangla.ac3377b4.png";

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconxiala.0253c293.png";

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jijin.dda92bf6.png";

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jijinjinglibeijing.196d3f2e.png";

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lanqita.e12e7f32.png";

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sgyhk.53f7e02e.png";

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/st_icon.9457a606.png";

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/subscribe_bg.3dee3c0c.png";

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/subscribe_icon_del_self.459ca4a2.png";

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tjyhk_qx.46d0fd0e.png";

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xayhk_lx.b4303b2e.png";

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yingxiao.9daaea67.png";

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yinhang.5473a3f7.png";

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ylyhk.79efa8a7.png";

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zcdt_nonedata.354cbdb3.png";

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zflb_moren.af9af8bf.png";

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zflb_yxz.1aa5ad80.png";

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhaiquan.8ce8d17a.png";

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhongcang.95c070ec.png";

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ziqita.5e439c77.png";

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _redux = __webpack_require__(2204);

var _reducers = _interopRequireDefault(__webpack_require__(2000));

var playerActions = _interopRequireWildcard(__webpack_require__(778));

var videoActions = _interopRequireWildcard(__webpack_require__(1905));

var Manager =
/*#__PURE__*/
function () {
  function Manager(store) {
    (0, _classCallCheck2["default"])(this, Manager);
    this.store = store || (0, _redux.createStore)(_reducers["default"]);
    this.video = null;
    this.rootElement = null;
  }

  (0, _createClass2["default"])(Manager, [{
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;
      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);

      function bindActionCreator(actionCreator) {
        return function bindAction() {
          // eslint-disable-next-line prefer-rest-params
          var action = actionCreator.apply(manager, arguments);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      return Object.keys(actions).filter(function (key) {
        return typeof actions[key] === 'function';
      }).reduce(function (boundActions, key) {
        boundActions[key] = bindActionCreator(actions[key]);
        return boundActions;
      }, {});
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    } // subscribe state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, getState) {
      if (!getState) {
        getState = this.getState.bind(this);
      }

      var prevState = getState();

      var handleChange = function handleChange() {
        var state = getState();

        if (state === prevState) {
          return;
        }

        var prevStateCopy = prevState;
        prevState = state;
        listener(state, prevStateCopy);
      };

      return this.store.subscribe(handleChange);
    } // subscribe to operation state change

  }, {
    key: "subscribeToOperationStateChange",
    value: function subscribeToOperationStateChange(listener) {
      var _this = this;

      return this.subscribeToStateChange(listener, function () {
        return _this.getState().operation;
      });
    } // subscribe to player state change

  }, {
    key: "subscribeToPlayerStateChange",
    value: function subscribeToPlayerStateChange(listener) {
      var _this2 = this;

      return this.subscribeToStateChange(listener, function () {
        return _this2.getState().player;
      });
    }
  }]);
  return Manager;
}();

exports["default"] = Manager;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(781));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(782));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _Manager = _interopRequireDefault(__webpack_require__(2190));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(1978));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(1980));

var _PosterImage = _interopRequireDefault(__webpack_require__(1981));

var _Video = _interopRequireDefault(__webpack_require__(1983));

var _Bezel = _interopRequireDefault(__webpack_require__(1977));

var _Shortcut = _interopRequireDefault(__webpack_require__(1982));

var _ControlBar = _interopRequireDefault(__webpack_require__(1984));

var browser = _interopRequireWildcard(__webpack_require__(2203));

var _dom = __webpack_require__(779);

var _utils = __webpack_require__(198);

var _fullscreen = _interopRequireDefault(__webpack_require__(2001));

var propTypes = {
  children: _propTypes["default"].any,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  fluid: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  aspectRatio: _propTypes["default"].string,
  className: _propTypes["default"].string,
  videoId: _propTypes["default"].string,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  store: _propTypes["default"].object
};
var defaultProps = {
  fluid: true,
  muted: false,
  playsInline: false,
  preload: 'auto',
  aspectRatio: 'auto'
};

var Player =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Player, _Component);

  function Player(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Player);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
    _this.controlsHideTimer = null;
    _this.video = null; // the Video component

    _this.manager = new _Manager["default"](props.store);
    _this.actions = _this.manager.getActions();

    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));

    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);

      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener
      window.removeEventListener('resize', this.handleResize);

      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);

      if (this.controlsHideTimer) {
        window.clearTimeout(this.controlsHideTimer);
      }
    }
  }, {
    key: "getDefaultChildren",
    value: function getDefaultChildren(originalChildren) {
      var _this2 = this;

      return [_react["default"].createElement(_Video["default"], {
        ref: function ref(c) {
          _this2.video = c;
          _this2.manager.video = _this2.video;
        },
        key: "video",
        order: 0.0
      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
        key: "poster-image",
        order: 1.0
      }), _react["default"].createElement(_LoadingSpinner["default"], {
        key: "loading-spinner",
        order: 2.0
      }), _react["default"].createElement(_Bezel["default"], {
        key: "bezel",
        order: 3.0
      }), _react["default"].createElement(_BigPlayButton["default"], {
        key: "big-play-button",
        order: 4.0
      }), _react["default"].createElement(_ControlBar["default"], {
        key: "control-bar",
        order: 5.0
      }), _react["default"].createElement(_Shortcut["default"], {
        key: "shortcut",
        order: 99.0
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren(props) {
      var _ = props.className,
          originalChildren = props.children,
          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);

      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
        return !(0, _utils.isVideoChild)(e);
      });

      var defaultChildren = this.getDefaultChildren(originalChildren);
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
    }
  }, {
    key: "setWidthOrHeight",
    value: function setWidthOrHeight(style, name, value) {
      var styleVal;

      if (typeof value === 'string') {
        if (value === 'auto') {
          styleVal = 'auto';
        } else if (value.match(/\d+%/)) {
          styleVal = value;
        }
      } else if (typeof value === 'number') {
        styleVal = "".concat(value, "px");
      }

      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          fluid = _this$props.fluid,
          propsAspectRatio = _this$props.aspectRatio,
          propsHeight = _this$props.height,
          propsWidth = _this$props.width;

      var _this$manager$getStat = this.manager.getState(),
          player = _this$manager$getStat.player;

      var style = {};
      var width;
      var height;
      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.

      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
        // Use any aspectRatio that's been specifically set
        aspectRatio = propsAspectRatio;
      } else if (player.videoWidth) {
        // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
      } else {
        // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
      } // Get the ratio as a decimal we can use to calculate dimensions


      var ratioParts = aspectRatio.split(':');
      var ratioMultiplier = ratioParts[1] / ratioParts[0];

      if (propsWidth !== undefined) {
        // Use any width that's been specifically set
        width = propsWidth;
      } else if (propsHeight !== undefined) {
        // Or calulate the width from the aspect ratio if a height has been set
        width = propsHeight / ratioMultiplier;
      } else {
        // Or use the video's metadata, or use the video el's default of 300
        width = player.videoWidth || 400;
      }

      if (propsHeight !== undefined) {
        // Use any height that's been specifically set
        height = propsHeight;
      } else {
        // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
      }

      if (fluid) {
        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
      } else {
        // If Width contains "auto", set "auto" in style
        this.setWidthOrHeight(style, 'width', width);
        this.setWidthOrHeight(style, 'height', height);
      }

      return style;
    } // get redux state
    // { player, operation }

  }, {
    key: "getState",
    value: function getState() {
      return this.manager.getState();
    } // get playback rate

  }, {
    key: "play",
    // play the video
    value: function play() {
      this.video.play();
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      this.video.seek(time);
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.video.forward(seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.video.replay(seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      this.video.toggleFullscreen();
    } // subscribe to player state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      return this.manager.subscribeToPlayerStateChange(listener);
    } // player resize

  }, {
    key: "handleResize",
    value: function handleResize() {}
  }, {
    key: "handleFullScreenChange",
    value: function handleFullScreenChange(event) {
      if (event.target === this.manager.rootElement) {
        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      this.startControlsTimer();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.startControlsTimer();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown() {
      this.startControlsTimer();
    }
  }, {
    key: "startControlsTimer",
    value: function startControlsTimer() {
      var _this3 = this;

      var controlBarActiveTime = 3000;

      _react["default"].Children.forEach(this.props.children, function (element) {
        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
          return;
        }

        var autoHideTime = element.props.autoHideTime;

        if (typeof autoHideTime === 'number') {
          controlBarActiveTime = autoHideTime;
        }
      });

      this.actions.userActivate(true);
      clearTimeout(this.controlsHideTimer);
      this.controlsHideTimer = setTimeout(function () {
        _this3.actions.userActivate(false);
      }, controlBarActiveTime);
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      if (state.isFullscreen !== prevState.isFullscreen) {
        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276

        (0, _dom.focusNode)(this.manager.rootElement);
      }

      this.forceUpdate(); // re-render
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.actions.activate(true);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.actions.activate(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var fluid = this.props.fluid;

      var _this$manager$getStat2 = this.manager.getState(),
          player = _this$manager$getStat2.player;

      var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;
      var props = (0, _objectSpread2["default"])({}, this.props, {
        player: player,
        actions: this.actions,
        manager: this.manager,
        store: this.manager.store,
        video: this.video ? this.video.video : null
      });
      var children = this.getChildren(props);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-controls-enabled': true,
          'video-react-has-started': hasStarted,
          'video-react-paused': paused,
          'video-react-playing': !paused,
          'video-react-waiting': waiting,
          'video-react-seeking': seeking,
          'video-react-fluid': fluid,
          'video-react-fullscreen': isFullscreen,
          'video-react-user-inactive': !userActivity,
          'video-react-user-active': userActivity,
          'video-react-workinghover': !browser.IS_IOS
        }, 'video-react', this.props.className),
        style: this.getStyle(),
        ref: function ref(c) {
          _this4.manager.rootElement = c;
        },
        role: "region",
        onTouchStart: this.handleMouseDown,
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleMouseMove,
        onMouseMove: this.handleMouseMove,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: "-1"
      }, children);
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Player;
}(_react.Component);

exports["default"] = Player;
Player.contextTypes = {
  store: _propTypes["default"].object
};
Player.propTypes = propTypes;
Player.defaultProps = defaultProps;
Player.displayName = 'Player';

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _MenuButton = _interopRequireDefault(__webpack_require__(1908));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  offMenuText: _propTypes["default"].string,
  showOffMenu: _propTypes["default"].bool,
  kinds: _propTypes["default"].array
};
var defaultProps = {
  offMenuText: 'Off',
  showOffMenu: true,
  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.

};

var ClosedCaptionButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClosedCaptionButton, _Component);

  function ClosedCaptionButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = _this.getTextTrackItems();
    return _this;
  }

  (0, _createClass2["default"])(ClosedCaptionButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateState();
    }
  }, {
    key: "getTextTrackItems",
    value: function getTextTrackItems() {
      var _this$props = this.props,
          kinds = _this$props.kinds,
          player = _this$props.player,
          offMenuText = _this$props.offMenuText,
          showOffMenu = _this$props.showOffMenu;
      var textTracks = player.textTracks,
          activeTextTrack = player.activeTextTrack;
      var textTrackItems = {
        items: [],
        selectedIndex: 0
      };
      var tracks = Array.from(textTracks || []);

      if (tracks.length === 0) {
        return textTrackItems;
      }

      if (showOffMenu) {
        textTrackItems.items.push({
          label: offMenuText || 'Off',
          value: null
        });
      }

      tracks.forEach(function (textTrack) {
        // ignore invalid text track kind
        if (kinds.length && !kinds.includes(textTrack.kind)) {
          return;
        }

        textTrackItems.items.push({
          label: textTrack.label,
          value: textTrack.language
        });
      });
      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
        return activeTextTrack && activeTextTrack.language === item.value;
      });

      if (textTrackItems.selectedIndex === -1) {
        textTrackItems.selectedIndex = 0;
      }

      return textTrackItems;
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var textTrackItems = this.getTextTrackItems();

      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
        this.setState(textTrackItems);
      }
    }
  }, {
    key: "textTrackItemsAreEqual",
    value: function textTrackItemsAreEqual(items1, items2) {
      if (items1.length !== items2.length) {
        return false;
      }

      for (var i = 0; i < items1.length; i++) {
        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          showOffMenu = _this$props2.showOffMenu;
      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
      // so all subtitles will be turned off

      Array.from(textTracks).forEach(function (textTrack, i) {
        // if it shows the `Off` menu, the first item is `Off`
        if (index === (showOffMenu ? i + 1 : i)) {
          textTrack.mode = 'showing';
          actions.activateTextTrack(textTrack);
        } else {
          textTrack.mode = 'hidden';
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          items = _this$state.items,
          selectedIndex = _this$state.selectedIndex;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Closed Caption"));
    }
  }]);
  return ClosedCaptionButton;
}(_react.Component);

ClosedCaptionButton.propTypes = propTypes;
ClosedCaptionButton.defaultProps = defaultProps;
ClosedCaptionButton.displayName = 'ClosedCaptionButton';
var _default = ClosedCaptionButton;
exports["default"] = _default;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(1907));

var _utils = __webpack_require__(198);

var PlaybackRate =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRate, _Component);

  function PlaybackRate(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRate);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRate, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
    }
  }]);
  return PlaybackRate;
}(_react.Component);

exports["default"] = PlaybackRate;
PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  children: _propTypes["default"].any
};

var Menu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Menu, _Component);

  function Menu(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "video-react-menu video-react-lock-showing",
        role: "presentation",
        onClick: this.handleClick
      }, _react["default"].createElement("ul", {
        className: "video-react-menu-content"
      }, this.props.children));
    }
  }]);
  return Menu;
}(_react.Component);

exports["default"] = Menu;
Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  activateIndex: _propTypes["default"].number,
  onSelectItem: _propTypes["default"].func
};

var MenuItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuItem, _Component);

  function MenuItem(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          index = _this$props.index,
          onSelectItem = _this$props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          index = _this$props2.index,
          activateIndex = _this$props2.activateIndex;
      return _react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          'video-react-menu-item': true,
          'video-react-selected': index === activateIndex
        }),
        role: "menuitem",
        onClick: this.handleClick
      }, item.label, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }));
    }
  }]);
  return MenuItem;
}(_react.Component);

exports["default"] = MenuItem;
MenuItem.propTypes = propTypes;
MenuItem.displayName = 'MenuItem';

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  player: _propTypes["default"].object,
  children: _propTypes["default"].any
};

var Popup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Popup, _Component);

  function Popup(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Popup, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("div", {
        className: "video-react-menu",
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: "video-react-menu-content"
      }, children));
    }
  }]);
  return Popup;
}(_react.Component);

exports["default"] = Popup;
Popup.propTypes = propTypes;
Popup.displayName = 'Popup';

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PopupButton;

var _extends2 = _interopRequireDefault(__webpack_require__(433));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(1979));

var _Popup = _interopRequireDefault(__webpack_require__(2196));

var propTypes = {
  inline: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;
  var ps = (0, _objectSpread2["default"])({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, {
      'video-react-menu-button-inline': !!inline,
      'video-react-menu-button-popup': !inline
    }, 'video-react-control video-react-button video-react-menu-button')
  }, ps), _react["default"].createElement(_Popup["default"], props));
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;
PopupButton.displayName = 'PopupButton';

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(433));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(65));

var _createClass2 = _interopRequireDefault(__webpack_require__(66));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(80));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(78));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(77));

var _inherits2 = _interopRequireDefault(__webpack_require__(79));

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var _Slider = _interopRequireDefault(__webpack_require__(1906));

var _VolumeLevel = _interopRequireDefault(__webpack_require__(2199));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};

var VolumeBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeBar, _Component);

  function VolumeBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
    _this.state = {
      percentage: '0%'
    };
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "getPercent",
    value: function getPercent() {
      var player = this.props.player;

      if (player.muted) {
        return 0;
      }

      return player.volume;
    }
  }, {
    key: "checkMuted",
    value: function checkMuted() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (player.muted) {
        actions.mute(false);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      this.checkMuted();
      var distance = this.slider.calculateDistance(event);
      actions.changeVolume(distance);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      this.checkMuted();
      actions.changeVolume(player.volume + 0.1);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions;
      this.checkMuted();
      actions.changeVolume(player.volume - 0.1);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handlePercentageChange",
    value: function handlePercentageChange(percentage) {
      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          player = _this$props4.player,
          className = _this$props4.className;
      var volume = (player.volume * 100).toFixed(2);
      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
        ref: function ref(c) {
          _this2.slider = c;
        },
        label: "volume level",
        valuenow: volume,
        valuetext: "".concat(volume, "%"),
        onMouseMove: this.handleMouseMove,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        sliderActive: this.handleFocus,
        sliderInactive: this.handleBlur,
        getPercent: this.getPercent,
        onPercentageChange: this.handlePercentageChange,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, this.props, {
        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
    }
  }]);
  return VolumeBar;
}(_react.Component);

VolumeBar.propTypes = propTypes;
VolumeBar.displayName = 'VolumeBar';
var _default = VolumeBar;
exports["default"] = _default;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(7));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(18));

var propTypes = {
  percentage: _propTypes["default"].string,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  percentage: '100%',
  vertical: false
};

function VolumeLevel(_ref) {
  var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;
  var style = {};

  if (vertical) {
    style.height = percentage;
  } else {
    style.width = percentage;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
    style: style
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }));
}

VolumeLevel.propTypes = propTypes;
VolumeLevel.defaultProps = defaultProps;
VolumeLevel.displayName = 'VolumeLevel';
var _default = VolumeLevel;
exports["default"] = _default;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(68);

var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video["default"];
  }
});
Object.defineProperty(exports, "BigPlayButton", {
  enumerable: true,
  get: function get() {
    return _BigPlayButton["default"];
  }
});
Object.defineProperty(exports, "LoadingSpinner", {
  enumerable: true,
  get: function get() {
    return _LoadingSpinner["default"];
  }
});
Object.defineProperty(exports, "PosterImage", {
  enumerable: true,
  get: function get() {
    return _PosterImage["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "Bezel", {
  enumerable: true,
  get: function get() {
    return _Bezel["default"];
  }
});
Object.defineProperty(exports, "Shortcut", {
  enumerable: true,
  get: function get() {
    return _Shortcut["default"];
  }
});
Object.defineProperty(exports, "ControlBar", {
  enumerable: true,
  get: function get() {
    return _ControlBar["default"];
  }
});
Object.defineProperty(exports, "PlayToggle", {
  enumerable: true,
  get: function get() {
    return _PlayToggle["default"];
  }
});
Object.defineProperty(exports, "ForwardControl", {
  enumerable: true,
  get: function get() {
    return _ForwardControl["default"];
  }
});
Object.defineProperty(exports, "ReplayControl", {
  enumerable: true,
  get: function get() {
    return _ReplayControl["default"];
  }
});
Object.defineProperty(exports, "FullscreenToggle", {
  enumerable: true,
  get: function get() {
    return _FullscreenToggle["default"];
  }
});
Object.defineProperty(exports, "ProgressControl", {
  enumerable: true,
  get: function get() {
    return _ProgressControl["default"];
  }
});
Object.defineProperty(exports, "SeekBar", {
  enumerable: true,
  get: function get() {
    return _SeekBar["default"];
  }
});
Object.defineProperty(exports, "PlayProgressBar", {
  enumerable: true,
  get: function get() {
    return _PlayProgressBar["default"];
  }
});
Object.defineProperty(exports, "LoadProgressBar", {
  enumerable: true,
  get: function get() {
    return _LoadProgressBar["default"];
  }
});
Object.defineProperty(exports, "MouseTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _MouseTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "VolumeMenuButton", {
  enumerable: true,
  get: function get() {
    return _VolumeMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRateMenuButton", {
  enumerable: true,
  get: function get() {
    return _PlaybackRateMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRate", {
  enumerable: true,
  get: function get() {
    return _PlaybackRate["default"];
  }
});
Object.defineProperty(exports, "ClosedCaptionButton", {
  enumerable: true,
  get: function get() {
    return _ClosedCaptionButton["default"];
  }
});
Object.defineProperty(exports, "RemainingTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _RemainingTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "CurrentTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _CurrentTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "DurationDisplay", {
  enumerable: true,
  get: function get() {
    return _DurationDisplay["default"];
  }
});
Object.defineProperty(exports, "TimeDivider", {
  enumerable: true,
  get: function get() {
    return _TimeDivider["default"];
  }
});
Object.defineProperty(exports, "MenuButton", {
  enumerable: true,
  get: function get() {
    return _MenuButton["default"];
  }
});
Object.defineProperty(exports, "playerReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.playerReducer;
  }
});
Object.defineProperty(exports, "operationReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.operationReducer;
  }
});
exports.videoActions = exports.playerActions = void 0;

var _Player = _interopRequireDefault(__webpack_require__(2191));

var _Video = _interopRequireDefault(__webpack_require__(1983));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(1978));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(1980));

var _PosterImage = _interopRequireDefault(__webpack_require__(1981));

var _Slider = _interopRequireDefault(__webpack_require__(1906));

var _Bezel = _interopRequireDefault(__webpack_require__(1977));

var _Shortcut = _interopRequireDefault(__webpack_require__(1982));

var _ControlBar = _interopRequireDefault(__webpack_require__(1984));

var _PlayToggle = _interopRequireDefault(__webpack_require__(1991));

var _ForwardControl = _interopRequireDefault(__webpack_require__(1985));

var _ReplayControl = _interopRequireDefault(__webpack_require__(1993));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(1987));

var _ProgressControl = _interopRequireDefault(__webpack_require__(1992));

var _SeekBar = _interopRequireDefault(__webpack_require__(1994));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(1990));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(1988));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(1989));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(1995));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(1907));

var _PlaybackRate = _interopRequireDefault(__webpack_require__(2193));

var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(2192));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(1998));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(1996));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(1997));

var _TimeDivider = _interopRequireDefault(__webpack_require__(1999));

var _MenuButton = _interopRequireDefault(__webpack_require__(1908));

var playerActions = _interopRequireWildcard(__webpack_require__(778));

exports.playerActions = playerActions;

var videoActions = _interopRequireWildcard(__webpack_require__(1905));

exports.videoActions = videoActions;

var _reducers = __webpack_require__(2000);

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = operation;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _player = __webpack_require__(778);

var initialState = {
  count: 0,
  operation: {
    action: '',
    source: ''
  }
};

function operation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.OPERATE:
      return (0, _objectSpread2["default"])({}, state, {
        count: state.count + 1,
        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
      });

    default:
      return state;
  }
}

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = player;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(265));

var _video = __webpack_require__(1905);

var _player = __webpack_require__(778);

var initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false,
  activeTextTrack: null
};

function player() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.USER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        userActivity: action.activity
      });

    case _player.PLAYER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        isActive: action.activity
      });

    case _player.FULLSCREEN_CHANGE:
      return (0, _objectSpread2["default"])({}, state, {
        isFullscreen: !!action.isFullscreen
      });

    case _video.SEEKING_TIME:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: action.time
      });

    case _video.END_SEEKING:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: 0
      });

    case _video.LOAD_START:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        hasStarted: false,
        ended: false
      });

    case _video.CAN_PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.WAITING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: true
      });

    case _video.CAN_PLAY_THROUGH:
    case _video.PLAYING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        hasStarted: true
      });

    case _video.PAUSE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        paused: true
      });

    case _video.END:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: true
      });

    case _video.SEEKING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: true
      });

    case _video.SEEKED:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: false
      });

    case _video.ERROR:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        error: 'UNKNOWN ERROR',
        ended: true
      });

    case _video.DURATION_CHANGE:
    case _video.TIME_UPDATE:
    case _video.VOLUME_CHANGE:
    case _video.PROGRESS_CHANGE:
    case _video.RATE_CHANGE:
    case _video.SUSPEND:
    case _video.ABORT:
    case _video.EMPTIED:
    case _video.STALLED:
    case _video.LOADED_META_DATA:
    case _video.LOADED_DATA:
    case _video.RESIZE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps);

    case _video.ACTIVATE_TEXT_TRACK:
      return (0, _objectSpread2["default"])({}, state, {
        activeTextTrack: action.textTrack
      });

    default:
      return state;
  }
}

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */

var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/

exports.IS_IPAD = IS_IPAD;
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
exports.IS_IPHONE = IS_IPHONE;
var IS_IPOD = /iPod/i.test(USER_AGENT);
exports.IS_IPOD = IS_IPOD;
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
exports.IS_IOS = IS_IOS;

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legacy_createStore", function() { return legacy_createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(2006);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),
/* 2205 */,
/* 2206 */,
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(719);
module.exports = __webpack_require__(2003);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.339091db.js